webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(5);
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(16);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(18);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	__webpack_require__(20);
	
	__webpack_require__(21);
	
	__webpack_require__(22);
	
	var _angularDialogService = __webpack_require__(23);
	
	var _angularDialogService2 = _interopRequireDefault(_angularDialogService);
	
	var _angularUiRouter = __webpack_require__(28);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(29);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _angularValidationMatch = __webpack_require__(31);
	
	var _angularValidationMatch2 = _interopRequireDefault(_angularValidationMatch);
	
	var _ngFileUpload = __webpack_require__(33);
	
	var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);
	
	__webpack_require__(35);
	
	__webpack_require__(36);
	
	__webpack_require__(39);
	
	__webpack_require__(41);
	
	__webpack_require__(163);
	
	var _app = __webpack_require__(164);
	
	var _auth = __webpack_require__(165);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(174);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _navbar = __webpack_require__(188);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(190);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _mongooseError = __webpack_require__(192);
	
	var _mongooseError2 = _interopRequireDefault(_mongooseError);
	
	var _main = __webpack_require__(193);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _app2 = __webpack_require__(166);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(168);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _socket = __webpack_require__(196);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _storage = __webpack_require__(252);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _home = __webpack_require__(253);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _newlineToHtml = __webpack_require__(256);
	
	var _newlineToHtml2 = _interopRequireDefault(_newlineToHtml);
	
	var _angularDatatables = __webpack_require__(257);
	
	var _angularDatatables2 = _interopRequireDefault(_angularDatatables);
	
	__webpack_require__(268);
	
	__webpack_require__(270);
	
	__webpack_require__(272);
	
	__webpack_require__(273);
	
	__webpack_require__(275);
	
	__webpack_require__(275);
	
	__webpack_require__(276);
	
	__webpack_require__(277);
	
	__webpack_require__(278);
	
	__webpack_require__(279);
	
	__webpack_require__(280);
	
	__webpack_require__(282);
	
	__webpack_require__(289);
	
	__webpack_require__(290);
	
	__webpack_require__(291);
	
	__webpack_require__(302);
	
	__webpack_require__(303);
	
	__webpack_require__(305);
	
	var _angularBootstrapDatetimepicker = __webpack_require__(306);
	
	var _angularBootstrapDatetimepicker2 = _interopRequireDefault(_angularBootstrapDatetimepicker);
	
	__webpack_require__(311);
	
	var _settings = __webpack_require__(313);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _settingsList = __webpack_require__(314);
	
	var _settingsList2 = _interopRequireDefault(_settingsList);
	
	var _settingsEdit = __webpack_require__(317);
	
	var _settingsEdit2 = _interopRequireDefault(_settingsEdit);
	
	var _dynamicPage = __webpack_require__(320);
	
	var _dynamicPage2 = _interopRequireDefault(_dynamicPage);
	
	var _dynamicPage3 = __webpack_require__(323);
	
	var _dynamicPage4 = _interopRequireDefault(_dynamicPage3);
	
	var _jsonView = __webpack_require__(324);
	
	var _jsonView2 = _interopRequireDefault(_jsonView);
	
	var _jsonView3 = __webpack_require__(325);
	
	var _jsonView4 = _interopRequireDefault(_jsonView3);
	
	var _datatableLoadingPlaceholder = __webpack_require__(326);
	
	var _datatableLoadingPlaceholder2 = _interopRequireDefault(_datatableLoadingPlaceholder);
	
	var _startFrom = __webpack_require__(328);
	
	var _startFrom2 = _interopRequireDefault(_startFrom);
	
	var _feedbackFormular = __webpack_require__(329);
	
	var _feedbackFormular2 = _interopRequireDefault(_feedbackFormular);
	
	var _searchResult = __webpack_require__(331);
	
	var _searchResult2 = _interopRequireDefault(_searchResult);
	
	__webpack_require__(334);
	
	__webpack_require__(335);
	
	__webpack_require__(337);
	
	__webpack_require__(338);
	
	__webpack_require__(339);
	
	__webpack_require__(341);
	
	var _history = __webpack_require__(343);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _profile = __webpack_require__(344);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _profilePictureUpload = __webpack_require__(347);
	
	var _profilePictureUpload2 = _interopRequireDefault(_profilePictureUpload);
	
	__webpack_require__(350);
	
	__webpack_require__(398);
	
	__webpack_require__(437);
	
	var _community = __webpack_require__(438);
	
	var _community2 = _interopRequireDefault(_community);
	
	var _property = __webpack_require__(439);
	
	var _property2 = _interopRequireDefault(_property);
	
	var _contacts = __webpack_require__(440);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	var _violationsCodeList = __webpack_require__(441);
	
	var _violationsCodeList2 = _interopRequireDefault(_violationsCodeList);
	
	var _violationsCodeEdit = __webpack_require__(444);
	
	var _violationsCodeEdit2 = _interopRequireDefault(_violationsCodeEdit);
	
	var _violationCodes = __webpack_require__(447);
	
	var _violationCodes2 = _interopRequireDefault(_violationCodes);
	
	var _violationsTicketList = __webpack_require__(448);
	
	var _violationsTicketList2 = _interopRequireDefault(_violationsTicketList);
	
	var _violationsTicketEdit = __webpack_require__(451);
	
	var _violationsTicketEdit2 = _interopRequireDefault(_violationsTicketEdit);
	
	var _violationsTicketShow = __webpack_require__(454);
	
	var _violationsTicketShow2 = _interopRequireDefault(_violationsTicketShow);
	
	var _violationTickets = __webpack_require__(457);
	
	var _violationTickets2 = _interopRequireDefault(_violationTickets);
	
	var _communityList = __webpack_require__(458);
	
	var _communityList2 = _interopRequireDefault(_communityList);
	
	var _communityEdit = __webpack_require__(461);
	
	var _communityEdit2 = _interopRequireDefault(_communityEdit);
	
	var _communityShow = __webpack_require__(464);
	
	var _communityShow2 = _interopRequireDefault(_communityShow);
	
	var _contactList = __webpack_require__(467);
	
	var _contactList2 = _interopRequireDefault(_contactList);
	
	var _contactEdit = __webpack_require__(470);
	
	var _contactEdit2 = _interopRequireDefault(_contactEdit);
	
	var _contactShow = __webpack_require__(473);
	
	var _contactShow2 = _interopRequireDefault(_contactShow);
	
	var _propertyList = __webpack_require__(476);
	
	var _propertyList2 = _interopRequireDefault(_propertyList);
	
	var _propertyEdit = __webpack_require__(479);
	
	var _propertyEdit2 = _interopRequireDefault(_propertyEdit);
	
	var _propertyShow = __webpack_require__(482);
	
	var _propertyShow2 = _interopRequireDefault(_propertyShow);
	
	var _vendorList = __webpack_require__(485);
	
	var _vendorList2 = _interopRequireDefault(_vendorList);
	
	var _vendorEdit = __webpack_require__(488);
	
	var _vendorEdit2 = _interopRequireDefault(_vendorEdit);
	
	var _vendorShow = __webpack_require__(491);
	
	var _vendorShow2 = _interopRequireDefault(_vendorShow);
	
	var _vendors = __webpack_require__(494);
	
	var _vendors2 = _interopRequireDefault(_vendors);
	
	var _workordersCodeList = __webpack_require__(495);
	
	var _workordersCodeList2 = _interopRequireDefault(_workordersCodeList);
	
	var _workordersCodeEdit = __webpack_require__(498);
	
	var _workordersCodeEdit2 = _interopRequireDefault(_workordersCodeEdit);
	
	var _workorderTicketList = __webpack_require__(501);
	
	var _workorderTicketList2 = _interopRequireDefault(_workorderTicketList);
	
	var _workorderTicketEdit = __webpack_require__(504);
	
	var _workorderTicketEdit2 = _interopRequireDefault(_workorderTicketEdit);
	
	var _workorderTicketShow = __webpack_require__(507);
	
	var _workorderTicketShow2 = _interopRequireDefault(_workorderTicketShow);
	
	var _workorderCodes = __webpack_require__(510);
	
	var _workorderCodes2 = _interopRequireDefault(_workorderCodes);
	
	var _workorderTickets = __webpack_require__(511);
	
	var _workorderTickets2 = _interopRequireDefault(_workorderTickets);
	
	var _servicerequestTicketList = __webpack_require__(512);
	
	var _servicerequestTicketList2 = _interopRequireDefault(_servicerequestTicketList);
	
	var _servicerequestTicketEdit = __webpack_require__(515);
	
	var _servicerequestTicketEdit2 = _interopRequireDefault(_servicerequestTicketEdit);
	
	var _servicerequestTicketShow = __webpack_require__(518);
	
	var _servicerequestTicketShow2 = _interopRequireDefault(_servicerequestTicketShow);
	
	var _servicerequestTickets = __webpack_require__(521);
	
	var _servicerequestTickets2 = _interopRequireDefault(_servicerequestTickets);
	
	var _clientEdit = __webpack_require__(522);
	
	var _clientEdit2 = _interopRequireDefault(_clientEdit);
	
	var _templates = __webpack_require__(525);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _templateList = __webpack_require__(526);
	
	var _templateList2 = _interopRequireDefault(_templateList);
	
	var _templateEdit = __webpack_require__(529);
	
	var _templateEdit2 = _interopRequireDefault(_templateEdit);
	
	var _templateUpload = __webpack_require__(532);
	
	var _templateUpload2 = _interopRequireDefault(_templateUpload);
	
	__webpack_require__(535);
	
	__webpack_require__(537);
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	__webpack_require__(543);
	
	__webpack_require__(544);
	
	__webpack_require__(547);
	
	__webpack_require__(548);
	
	__webpack_require__(549);
	
	__webpack_require__(550);
	
	__webpack_require__(552);
	
	__webpack_require__(553);
	
	__webpack_require__(554);
	
	__webpack_require__(555);
	
	var _acctst = __webpack_require__(556);
	
	var _acctst2 = _interopRequireDefault(_acctst);
	
	var _accounting = __webpack_require__(559);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	var _journalEntries = __webpack_require__(560);
	
	var _journalEntries2 = _interopRequireDefault(_journalEntries);
	
	var _chartOfAccounts = __webpack_require__(563);
	
	var _chartOfAccounts2 = _interopRequireDefault(_chartOfAccounts);
	
	var _balanceSheet = __webpack_require__(566);
	
	var _balanceSheet2 = _interopRequireDefault(_balanceSheet);
	
	var _addJournalEntry = __webpack_require__(569);
	
	var _addJournalEntry2 = _interopRequireDefault(_addJournalEntry);
	
	var _accountTree = __webpack_require__(572);
	
	var _accountTree2 = _interopRequireDefault(_accountTree);
	
	var _accountLookup = __webpack_require__(574);
	
	var _accountLookup2 = _interopRequireDefault(_accountLookup);
	
	var _propertyLookup = __webpack_require__(576);
	
	var _propertyLookup2 = _interopRequireDefault(_propertyLookup);
	
	var _vendorLookup = __webpack_require__(578);
	
	var _vendorLookup2 = _interopRequireDefault(_vendorLookup);
	
	var _userLookup = __webpack_require__(580);
	
	var _userLookup2 = _interopRequireDefault(_userLookup);
	
	var _communityLookup = __webpack_require__(582);
	
	var _communityLookup2 = _interopRequireDefault(_communityLookup);
	
	var _templateLookup = __webpack_require__(584);
	
	var _templateLookup2 = _interopRequireDefault(_templateLookup);
	
	var _contactLookup = __webpack_require__(586);
	
	var _contactLookup2 = _interopRequireDefault(_contactLookup);
	
	__webpack_require__(588);
	
	__webpack_require__(589);
	
	__webpack_require__(590);
	
	__webpack_require__(599);
	
	__webpack_require__(601);
	
	var _viewSelection = __webpack_require__(603);
	
	var _viewSelection2 = _interopRequireDefault(_viewSelection);
	
	var _tasks = __webpack_require__(604);
	
	var _tasks2 = _interopRequireDefault(_tasks);
	
	var _taskEdit = __webpack_require__(605);
	
	var _taskEdit2 = _interopRequireDefault(_taskEdit);
	
	var _taskShow = __webpack_require__(607);
	
	var _taskShow2 = _interopRequireDefault(_taskShow);
	
	var _ntaSection = __webpack_require__(609);
	
	var _ntaSection2 = _interopRequireDefault(_ntaSection);
	
	var _addressEdit = __webpack_require__(611);
	
	var _addressEdit2 = _interopRequireDefault(_addressEdit);
	
	var _headerDropdownMenu = __webpack_require__(613);
	
	var _headerDropdownMenu2 = _interopRequireDefault(_headerDropdownMenu);
	
	var _inlineDropdownMenu = __webpack_require__(615);
	
	var _inlineDropdownMenu2 = _interopRequireDefault(_inlineDropdownMenu);
	
	var _userCard = __webpack_require__(617);
	
	var _userCard2 = _interopRequireDefault(_userCard);
	
	var _calendar = __webpack_require__(619);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _assetUpload = __webpack_require__(629);
	
	var _assetUpload2 = _interopRequireDefault(_assetUpload);
	
	var _attachmentList = __webpack_require__(631);
	
	var _attachmentList2 = _interopRequireDefault(_attachmentList);
	
	var _editPropertyContacts = __webpack_require__(633);
	
	var _editPropertyContacts2 = _interopRequireDefault(_editPropertyContacts);
	
	var _addPropertyContact = __webpack_require__(635);
	
	var _addPropertyContact2 = _interopRequireDefault(_addPropertyContact);
	
	var _usPhone = __webpack_require__(637);
	
	var _usPhone2 = _interopRequireDefault(_usPhone);
	
	var _workorderShow = __webpack_require__(638);
	
	var _workorderShow2 = _interopRequireDefault(_workorderShow);
	
	var _violationShow = __webpack_require__(640);
	
	var _violationShow2 = _interopRequireDefault(_violationShow);
	
	var _stateChangeForm = __webpack_require__(642);
	
	var _stateChangeForm2 = _interopRequireDefault(_stateChangeForm);
	
	var _roleEdit = __webpack_require__(644);
	
	var _roleEdit2 = _interopRequireDefault(_roleEdit);
	
	var _permissionEdit = __webpack_require__(647);
	
	var _permissionEdit2 = _interopRequireDefault(_permissionEdit);
	
	__webpack_require__(649);
	
	__webpack_require__(650);
	
	var _projectList = __webpack_require__(652);
	
	var _projectList2 = _interopRequireDefault(_projectList);
	
	var _projectEdit = __webpack_require__(655);
	
	var _projectEdit2 = _interopRequireDefault(_projectEdit);
	
	var _projectBoard = __webpack_require__(658);
	
	var _projectBoard2 = _interopRequireDefault(_projectBoard);
	
	var _projectItemEdit = __webpack_require__(661);
	
	var _projectItemEdit2 = _interopRequireDefault(_projectItemEdit);
	
	var _project = __webpack_require__(663);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _projectItem = __webpack_require__(664);
	
	var _projectItem2 = _interopRequireDefault(_projectItem);
	
	__webpack_require__(665);
	
	var _recentVisits = __webpack_require__(666);
	
	var _recentVisits2 = _interopRequireDefault(_recentVisits);
	
	var _pinnedItems = __webpack_require__(667);
	
	var _pinnedItems2 = _interopRequireDefault(_pinnedItems);
	
	__webpack_require__(668);
	
	__webpack_require__(669);
	
	__webpack_require__(671);
	
	__webpack_require__(672);
	
	var _dashboard = __webpack_require__(674);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _rolesConfig = __webpack_require__(677);
	
	var _rolesConfig2 = _interopRequireDefault(_rolesConfig);
	
	var _angularPermission = __webpack_require__(678);
	
	var _serviceRequestToWorkorderForm = __webpack_require__(682);
	
	var _serviceRequestToWorkorderForm2 = _interopRequireDefault(_serviceRequestToWorkorderForm);
	
	var _targetDateChangeForm = __webpack_require__(684);
	
	var _targetDateChangeForm2 = _interopRequireDefault(_targetDateChangeForm);
	
	var _issuedToChangeForm = __webpack_require__(686);
	
	var _issuedToChangeForm2 = _interopRequireDefault(_issuedToChangeForm);
	
	var _reports = __webpack_require__(688);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _customList = __webpack_require__(691);
	
	var _customList2 = _interopRequireDefault(_customList);
	
	var _customEdit = __webpack_require__(695);
	
	var _customEdit2 = _interopRequireDefault(_customEdit);
	
	var _customShow = __webpack_require__(698);
	
	var _customShow2 = _interopRequireDefault(_customShow);
	
	var _customEntity = __webpack_require__(701);
	
	var _customEntity2 = _interopRequireDefault(_customEntity);
	
	__webpack_require__(702);
	
	__webpack_require__(703);
	
	__webpack_require__(705);
	
	var _bindDynamicPage = __webpack_require__(707);
	
	var _bindDynamicPage2 = _interopRequireDefault(_bindDynamicPage);
	
	__webpack_require__(708);
	
	__webpack_require__(709);
	
	__webpack_require__(711);
	
	var _webaccessList = __webpack_require__(713);
	
	var _webaccessList2 = _interopRequireDefault(_webaccessList);
	
	var _webaccessEdit = __webpack_require__(716);
	
	var _webaccessEdit2 = _interopRequireDefault(_webaccessEdit);
	
	var _webaccessShow = __webpack_require__(719);
	
	var _webaccessShow2 = _interopRequireDefault(_webaccessShow);
	
	var _webaccess = __webpack_require__(722);
	
	var _webaccess2 = _interopRequireDefault(_webaccess);
	
	var _webaccessResetPassword = __webpack_require__(723);
	
	var _webaccessResetPassword2 = _interopRequireDefault(_webaccessResetPassword);
	
	var _webaccessPicker = __webpack_require__(725);
	
	var _webaccessPicker2 = _interopRequireDefault(_webaccessPicker);
	
	var _ldapDb = __webpack_require__(727);
	
	var _ldapDb2 = _interopRequireDefault(_ldapDb);
	
	var _quickbooksImport = __webpack_require__(730);
	
	var _quickbooksImport2 = _interopRequireDefault(_quickbooksImport);
	
	var _quickbooksList = __webpack_require__(733);
	
	var _quickbooksList2 = _interopRequireDefault(_quickbooksList);
	
	var _quickbooksOverview = __webpack_require__(736);
	
	var _quickbooksOverview2 = _interopRequireDefault(_quickbooksOverview);
	
	var _quickbooksImport3 = __webpack_require__(739);
	
	var _quickbooksImport4 = _interopRequireDefault(_quickbooksImport3);
	
	var _sendAttachmentEmail = __webpack_require__(740);
	
	var _sendAttachmentEmail2 = _interopRequireDefault(_sendAttachmentEmail);
	
	var _htmlIframe = __webpack_require__(744);
	
	var _htmlIframe2 = _interopRequireDefault(_htmlIframe);
	
	var _iframePreview = __webpack_require__(745);
	
	var _iframePreview2 = _interopRequireDefault(_iframePreview);
	
	var _stripe = __webpack_require__(747);
	
	var _stripe2 = _interopRequireDefault(_stripe);
	
	var _connectedAccountDetails = __webpack_require__(748);
	
	var _connectedAccountDetails2 = _interopRequireDefault(_connectedAccountDetails);
	
	var _connectedAccountCharges = __webpack_require__(750);
	
	var _connectedAccountCharges2 = _interopRequireDefault(_connectedAccountCharges);
	
	var _userList = __webpack_require__(752);
	
	var _userList2 = _interopRequireDefault(_userList);
	
	var _schemaFormModal = __webpack_require__(756);
	
	var _schemaFormModal2 = _interopRequireDefault(_schemaFormModal);
	
	var _inplaceEditHover = __webpack_require__(758);
	
	var _inplaceEditHover2 = _interopRequireDefault(_inplaceEditHover);
	
	__webpack_require__(759);
	
	__webpack_require__(761);
	
	__webpack_require__(762);
	
	__webpack_require__(763);
	
	__webpack_require__(764);
	
	var _dbAdmin = __webpack_require__(765);
	
	var _dbAdmin2 = _interopRequireDefault(_dbAdmin);
	
	var _dbAdminList = __webpack_require__(766);
	
	var _dbAdminList2 = _interopRequireDefault(_dbAdminList);
	
	var _dbAdminEdit = __webpack_require__(769);
	
	var _dbAdminEdit2 = _interopRequireDefault(_dbAdminEdit);
	
	var _reportFilterModal = __webpack_require__(772);
	
	var _reportFilterModal2 = _interopRequireDefault(_reportFilterModal);
	
	var _singleAddressLabelModal = __webpack_require__(774);
	
	var _singleAddressLabelModal2 = _interopRequireDefault(_singleAddressLabelModal);
	
	var _customView = __webpack_require__(776);
	
	var _customView2 = _interopRequireDefault(_customView);
	
	var _customView3 = __webpack_require__(781);
	
	var _customView4 = _interopRequireDefault(_customView3);
	
	var _datatablesState = __webpack_require__(782);
	
	var _datatablesState2 = _interopRequireDefault(_datatablesState);
	
	var _combinedDateTimePicker = __webpack_require__(783);
	
	var _combinedDateTimePicker2 = _interopRequireDefault(_combinedDateTimePicker);
	
	var _letterAddressSelectModal = __webpack_require__(785);
	
	var _letterAddressSelectModal2 = _interopRequireDefault(_letterAddressSelectModal);
	
	var _letterAddressDownloadModal = __webpack_require__(787);
	
	var _letterAddressDownloadModal2 = _interopRequireDefault(_letterAddressDownloadModal);
	
	var _voterGroupList = __webpack_require__(789);
	
	var _voterGroupList2 = _interopRequireDefault(_voterGroupList);
	
	var _voterGroupEdit = __webpack_require__(792);
	
	var _voterGroupEdit2 = _interopRequireDefault(_voterGroupEdit);
	
	var _voterGroupShow = __webpack_require__(795);
	
	var _voterGroupShow2 = _interopRequireDefault(_voterGroupShow);
	
	var _voterGroups = __webpack_require__(798);
	
	var _voterGroups2 = _interopRequireDefault(_voterGroups);
	
	var _customEntityLookup = __webpack_require__(799);
	
	var _customEntityLookup2 = _interopRequireDefault(_customEntityLookup);
	
	var _paymentsOverview = __webpack_require__(801);
	
	var _paymentsOverview2 = _interopRequireDefault(_paymentsOverview);
	
	var _photoCard = __webpack_require__(804);
	
	var _photoCard2 = _interopRequireDefault(_photoCard);
	
	var _customEntityEdit = __webpack_require__(806);
	
	var _customEntityEdit2 = _interopRequireDefault(_customEntityEdit);
	
	var _eForm = __webpack_require__(809);
	
	var _eForm2 = _interopRequireDefault(_eForm);
	
	var _signatureModal = __webpack_require__(833);
	
	var _signatureModal2 = _interopRequireDefault(_signatureModal);
	
	__webpack_require__(835);
	
	var _eformResultModal = __webpack_require__(836);
	
	var _eformResultModal2 = _interopRequireDefault(_eformResultModal);
	
	var _mailComposer = __webpack_require__(838);
	
	var _mailComposer2 = _interopRequireDefault(_mailComposer);
	
	var _mailList = __webpack_require__(841);
	
	var _mailList2 = _interopRequireDefault(_mailList);
	
	var _mailComposerPreview = __webpack_require__(844);
	
	var _mailComposerPreview2 = _interopRequireDefault(_mailComposerPreview);
	
	var _mailComposerFilterSend = __webpack_require__(846);
	
	var _mailComposerFilterSend2 = _interopRequireDefault(_mailComposerFilterSend);
	
	var _mails = __webpack_require__(848);
	
	var _mails2 = _interopRequireDefault(_mails);
	
	var _datatableView = __webpack_require__(849);
	
	var _datatableView2 = _interopRequireDefault(_datatableView);
	
	var _textList = __webpack_require__(851);
	
	var _textList2 = _interopRequireDefault(_textList);
	
	var _textMessageEdit = __webpack_require__(854);
	
	var _textMessageEdit2 = _interopRequireDefault(_textMessageEdit);
	
	var _textMessages = __webpack_require__(856);
	
	var _textMessages2 = _interopRequireDefault(_textMessages);
	
	var _textMessageFilterSend = __webpack_require__(857);
	
	var _textMessageFilterSend2 = _interopRequireDefault(_textMessageFilterSend);
	
	var _phoneNumberEditModal = __webpack_require__(859);
	
	var _phoneNumberEditModal2 = _interopRequireDefault(_phoneNumberEditModal);
	
	var _emailSectionEdit = __webpack_require__(861);
	
	var _emailSectionEdit2 = _interopRequireDefault(_emailSectionEdit);
	
	var _phoneSectionEdit = __webpack_require__(863);
	
	var _phoneSectionEdit2 = _interopRequireDefault(_phoneSectionEdit);
	
	var _addressSectionEdit = __webpack_require__(865);
	
	var _addressSectionEdit2 = _interopRequireDefault(_addressSectionEdit);
	
	var _attachmentPicker = __webpack_require__(867);
	
	var _attachmentPicker2 = _interopRequireDefault(_attachmentPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $stateProviderRef = null;
	
	_angular2.default.module('conduu', [_angularCookies2.default, _angularResource2.default, 'btford.socket-io', _angularUiRouter2.default, _angularPermission.permission, _angularPermission.uiPermission, 'xeditable', 'checklist-model', _angularUiBootstrap2.default, _auth2.default, _account2.default, _navbar2.default, _footer2.default, _main2.default, _app3.default, _socket2.default, _util2.default, _angularValidationMatch2.default, _mongooseError2.default, _angularDialogService2.default, _ngFileUpload2.default, _angularDatatables2.default, _newlineToHtml2.default, _storage2.default, 'textAngular', 'angularMoment', _home2.default, _settings2.default, _settingsList2.default, _settingsEdit2.default, 'ui.codemirror', _jsonView4.default, _jsonView2.default, _feedbackFormular2.default, _startFrom2.default, 'angular-timeline', _history2.default, 'chart.js', _searchResult2.default, 'cgPrompt', _profile2.default, _profilePictureUpload2.default, _violationsCodeList2.default, _violationsCodeEdit2.default, _violationCodes2.default, _violationsTicketList2.default, _violationsTicketEdit2.default, _violationsTicketShow2.default, _violationTickets2.default, _community2.default, _property2.default, _contacts2.default, 'schemaForm', 'mgcrea.ngStrap', _communityList2.default, _communityEdit2.default, _contactList2.default, _contactEdit2.default, _contactShow2.default, _propertyList2.default, _propertyEdit2.default, _vendorList2.default, _vendorEdit2.default, _vendors2.default, _workordersCodeList2.default, _workordersCodeEdit2.default, _workorderCodes2.default, _workorderTicketList2.default, _workorderTicketEdit2.default, _workorderTickets2.default, _angularBootstrapDatetimepicker2.default, _clientEdit2.default, _acctst2.default, _accounting2.default, _journalEntries2.default, _chartOfAccounts2.default, _balanceSheet2.default, _addJournalEntry2.default, _accountLookup2.default, _propertyLookup2.default, 'treeControl', _accountTree2.default, _vendorLookup2.default, 'ui.mask', _viewSelection2.default, _userLookup2.default, _communityLookup2.default, _templates2.default, _templateList2.default, _templateEdit2.default, _templateLookup2.default, _tasks2.default, _taskEdit2.default, 'cgPrompt', _propertyShow2.default, _ntaSection2.default, _communityShow2.default, _vendorShow2.default, _workorderTicketShow2.default, _taskShow2.default, _calendar2.default, 'ui.calendar', _addressEdit2.default, _headerDropdownMenu2.default, _userCard2.default, _contactLookup2.default, _assetUpload2.default, _attachmentList2.default, _servicerequestTicketList2.default, _servicerequestTicketEdit2.default, _servicerequestTicketShow2.default, _servicerequestTickets2.default, _editPropertyContacts2.default, _addPropertyContact2.default, _usPhone2.default, _workorderShow2.default, _violationShow2.default, _stateChangeForm2.default, _roleEdit2.default, _permissionEdit2.default, 'as.sortable', _inlineDropdownMenu2.default, _projectList2.default, _projectEdit2.default, _projectBoard2.default, _project2.default, _projectItem2.default, _projectItemEdit2.default, 'ngStorage', _recentVisits2.default, _pinnedItems2.default, 'ui.toggle', 'ui.dashboard', _dashboard2.default, _rolesConfig2.default, _serviceRequestToWorkorderForm2.default, _targetDateChangeForm2.default, _issuedToChangeForm2.default, _reports2.default, 'ngIdle', 'stBlurredDialog', _customList2.default, _customEdit2.default, _customEntity2.default, _customShow2.default, _bindDynamicPage2.default, 'ngTagsInput', _webaccess2.default, _webaccessList2.default, _webaccessEdit2.default, _webaccessShow2.default, _ldapDb2.default, _webaccessResetPassword2.default, _datatableLoadingPlaceholder2.default, _quickbooksImport2.default, _quickbooksImport4.default, _quickbooksList2.default, _sendAttachmentEmail2.default, _webaccessPicker2.default, _htmlIframe2.default, _iframePreview2.default, _stripe2.default, _connectedAccountDetails2.default, _connectedAccountCharges2.default, _userList2.default, _schemaFormModal2.default, _inplaceEditHover2.default, 'angulartics', 'angulartics.piwik', 'fxpicklist', 'schemaForm-currency', 'schemaForm-picklist', 'pascalprecht.translate', 'dialogs.default-translations', _quickbooksOverview2.default, _dbAdmin2.default, _dbAdminList2.default, _dbAdminEdit2.default, _reportFilterModal2.default, _singleAddressLabelModal2.default, _customView4.default, _customView2.default, _datatablesState2.default, _templateUpload2.default, 'schemaForm-dtpicker', _letterAddressSelectModal2.default, _letterAddressDownloadModal2.default, _voterGroupList2.default, _voterGroupEdit2.default, _voterGroupShow2.default, _voterGroups2.default, _customEntityLookup2.default, 'schemaForm-percent', _paymentsOverview2.default, _photoCard2.default, _customEntityEdit2.default, _eForm2.default, _signatureModal2.default, "signature", _eformResultModal2.default, _mailComposer2.default, _mailList2.default, _mailComposerPreview2.default, _mails2.default, _mailComposerFilterSend2.default, _datatableView2.default, _textList2.default, _textMessageEdit2.default, _textMessages2.default, _textMessageFilterSend2.default, _phoneNumberEditModal2.default, _emailSectionEdit2.default, _phoneSectionEdit2.default, _addressSectionEdit2.default, _attachmentPicker2.default]).config(_app.routeConfig).config(_app.schemaFormCustomFields).config(_app.schemaFormSingleFileUpload).config(_app.decorateTextAngular).config(['$provide', function ($provide) {
	  'ngInject';
	
	  $provide.decorator('uibAccordionDirective', ['$delegate', function ($delegate) {
	    var directive = $delegate[0];
	    directive.replace = true;
	    return $delegate;
	  }]);
	}]).config(['$compileProvider', function ($compileProvider) {
	  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|conduu):/);
	}]).config(['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProviderRef = $stateProvider;
	}]).config(['ChartJsProvider', function (ChartJsProvider) {
	  'ngInject';
	
	  ChartJsProvider.setOptions("global", { colors: ['#97BBCD', '#B452CD', '#F7464A', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360'] });
	}]).config(['KeepaliveProvider', 'IdleProvider', function (KeepaliveProvider, IdleProvider) {
	  'ngInject';
	
	  IdleProvider.idle(60 * 10);
	  IdleProvider.timeout(30);
	  KeepaliveProvider.interval(10);
	}]).run(_app.addCustomFieldsCache).run(_app.addSingleFileUploadCache).run(['$rootScope', 'Idle', 'stBlurredDialog', '$localStorage', 'Auth', function ($rootScope, Idle, stBlurredDialog, $localStorage, Auth) {
	  'ngInject';
	
	  $rootScope.events = [];
	
	  $rootScope.$on('IdleStart', function () {
	    console.log('%%%%%%%% IdleStart');
	  });
	
	  $rootScope.$on('IdleWarn', function (e, countdown) {
	    console.log('%%%%%%%% IdleWarn ' + countdown);
	  });
	
	  $rootScope.$on('IdleTimeout', function () {
	
	    $localStorage.screenIsLocked = true;
	    stBlurredDialog.open();
	
	    console.log('%%%%%%%% IdleTimeout');
	  });
	
	  $rootScope.$on('IdleEnd', function () {
	    console.log('%%%%%%%% IdleEnd');
	  });
	
	  $rootScope.$on('Keepalive', function () {
	    console.log('%%%%%%%% Keepalive');
	    stBlurredDialog.close();
	  });
	
	  Auth.isLoggedIn(function (loggedIn) {
	
	    if (!loggedIn) {
	      $localStorage.screenIsLocked = false;
	    }
	
	    if ($localStorage.screenIsLocked) {
	      stBlurredDialog.open();
	    }
	  });
	}]).run(['$rootScope', '$location', 'Auth', 'editableOptions', 'SettingsService', '$window', function ($rootScope, $location, Auth, editableOptions, SettingsService, $window) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    Auth.isLoggedIn(function (loggedIn) {
	      if (next.authenticate && !loggedIn) {
	        $location.path('/');
	      }
	    });
	  });
	
	  editableOptions.theme = 'bs3';
	  SettingsService.getByName({ name: 'config.platform' }, function (settings) {
	    var analyticsId = settings.data.piwikSiteId;
	    if ($window._paq && analyticsId) {
	      $window._paq.push(['setSiteId', analyticsId]);
	    }
	  });
	}]).run(function (PermPermissionStore) {}).controller('DialogCtrl', ['$scope', 'stBlurredDialog', function ($scope, stBlurredDialog) {
	  'ngInject';
	
	  $scope.dialogData = stBlurredDialog.getDialogData();
	}]);
	
	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, ['conduu']);
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! DataTables 1.10.16
	 * ©2008-2017 SpryMedia Ltd - datatables.net/license
	 */
	
	/**
	 * @summary     DataTables
	 * @description Paginate, search and order HTML tables
	 * @version     1.10.16
	 * @file        jquery.dataTables.js
	 * @author      SpryMedia Ltd
	 * @contact     www.datatables.net
	 * @copyright   Copyright 2008-2017 SpryMedia Ltd.
	 *
	 * This source file is free software, available under the following license:
	 *   MIT license - http://datatables.net/license
	 *
	 * This source file is distributed in the hope that it will be useful, but
	 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
	 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
	 *
	 * For details please refer to: http://www.datatables.net
	 */
	
	/*jslint evil: true, undef: true, browser: true */
	/*globals $,require,jQuery,define,_selector_run,_selector_opts,_selector_first,_selector_row_indexes,_ext,_Api,_api_register,_api_registerPlural,_re_new_lines,_re_html,_re_formatted_numeric,_re_escape_regex,_empty,_intVal,_numToDecimal,_isNumber,_isHtml,_htmlNumeric,_pluck,_pluck_order,_range,_stripHtml,_unique,_fnBuildAjax,_fnAjaxUpdate,_fnAjaxParameters,_fnAjaxUpdateDraw,_fnAjaxDataSrc,_fnAddColumn,_fnColumnOptions,_fnAdjustColumnSizing,_fnVisibleToColumnIndex,_fnColumnIndexToVisible,_fnVisbleColumns,_fnGetColumns,_fnColumnTypes,_fnApplyColumnDefs,_fnHungarianMap,_fnCamelToHungarian,_fnLanguageCompat,_fnBrowserDetect,_fnAddData,_fnAddTr,_fnNodeToDataIndex,_fnNodeToColumnIndex,_fnGetCellData,_fnSetCellData,_fnSplitObjNotation,_fnGetObjectDataFn,_fnSetObjectDataFn,_fnGetDataMaster,_fnClearTable,_fnDeleteIndex,_fnInvalidate,_fnGetRowElements,_fnCreateTr,_fnBuildHead,_fnDrawHead,_fnDraw,_fnReDraw,_fnAddOptionsHtml,_fnDetectHeader,_fnGetUniqueThs,_fnFeatureHtmlFilter,_fnFilterComplete,_fnFilterCustom,_fnFilterColumn,_fnFilter,_fnFilterCreateSearch,_fnEscapeRegex,_fnFilterData,_fnFeatureHtmlInfo,_fnUpdateInfo,_fnInfoMacros,_fnInitialise,_fnInitComplete,_fnLengthChange,_fnFeatureHtmlLength,_fnFeatureHtmlPaginate,_fnPageChange,_fnFeatureHtmlProcessing,_fnProcessingDisplay,_fnFeatureHtmlTable,_fnScrollDraw,_fnApplyToChildren,_fnCalculateColumnWidths,_fnThrottle,_fnConvertToWidth,_fnGetWidestNode,_fnGetMaxLenString,_fnStringToCss,_fnSortFlatten,_fnSort,_fnSortAria,_fnSortListener,_fnSortAttachListener,_fnSortingClasses,_fnSortData,_fnSaveState,_fnLoadState,_fnSettingsFromNode,_fnLog,_fnMap,_fnBindAction,_fnCallbackReg,_fnCallbackFire,_fnLengthOverflow,_fnRenderer,_fnDataSource,_fnRowAttributes*/
	
	(function( factory ) {
		"use strict";
	
		if ( true ) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
				return factory( $, window, document );
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if ( typeof exports === 'object' ) {
			// CommonJS
			module.exports = function (root, $) {
				if ( ! root ) {
					// CommonJS environments without a window global must pass a
					// root. This will give an error otherwise
					root = window;
				}
	
				if ( ! $ ) {
					$ = typeof window !== 'undefined' ? // jQuery's factory checks for a global window
						require('jquery') :
						require('jquery')( root );
				}
	
				return factory( $, root, root.document );
			};
		}
		else {
			// Browser
			factory( jQuery, window, document );
		}
	}
	(function( $, window, document, undefined ) {
		"use strict";
	
		/**
		 * DataTables is a plug-in for the jQuery Javascript library. It is a highly
		 * flexible tool, based upon the foundations of progressive enhancement,
		 * which will add advanced interaction controls to any HTML table. For a
		 * full list of features please refer to
		 * [DataTables.net](href="http://datatables.net).
		 *
		 * Note that the `DataTable` object is not a global variable but is aliased
		 * to `jQuery.fn.DataTable` and `jQuery.fn.dataTable` through which it may
		 * be  accessed.
		 *
		 *  @class
		 *  @param {object} [init={}] Configuration object for DataTables. Options
		 *    are defined by {@link DataTable.defaults}
		 *  @requires jQuery 1.7+
		 *
		 *  @example
		 *    // Basic initialisation
		 *    $(document).ready( function {
		 *      $('#example').dataTable();
		 *    } );
		 *
		 *  @example
		 *    // Initialisation with configuration options - in this case, disable
		 *    // pagination and sorting.
		 *    $(document).ready( function {
		 *      $('#example').dataTable( {
		 *        "paginate": false,
		 *        "sort": false
		 *      } );
		 *    } );
		 */
		var DataTable = function ( options )
		{
			/**
			 * Perform a jQuery selector action on the table's TR elements (from the tbody) and
			 * return the resulting jQuery object.
			 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
			 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
			 *  @param {string} [oOpts.filter=none] Select TR elements that meet the current filter
			 *    criterion ("applied") or all TR elements (i.e. no filter).
			 *  @param {string} [oOpts.order=current] Order of the TR elements in the processed array.
			 *    Can be either 'current', whereby the current sorting of the table is used, or
			 *    'original' whereby the original order the data was read into the table is used.
			 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
			 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
			 *    'current' and filter is 'applied', regardless of what they might be given as.
			 *  @returns {object} jQuery object, filtered by the given selector.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Highlight every second row
			 *      oTable.$('tr:odd').css('backgroundColor', 'blue');
			 *    } );
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Filter to rows with 'Webkit' in them, add a background colour and then
			 *      // remove the filter, thus highlighting the 'Webkit' rows only.
			 *      oTable.fnFilter('Webkit');
			 *      oTable.$('tr', {"search": "applied"}).css('backgroundColor', 'blue');
			 *      oTable.fnFilter('');
			 *    } );
			 */
			this.$ = function ( sSelector, oOpts )
			{
				return this.api(true).$( sSelector, oOpts );
			};
			
			
			/**
			 * Almost identical to $ in operation, but in this case returns the data for the matched
			 * rows - as such, the jQuery selector used should match TR row nodes or TD/TH cell nodes
			 * rather than any descendants, so the data can be obtained for the row/cell. If matching
			 * rows are found, the data returned is the original data array/object that was used to
			 * create the row (or a generated array if from a DOM source).
			 *
			 * This method is often useful in-combination with $ where both functions are given the
			 * same parameters and the array indexes will match identically.
			 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
			 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
			 *  @param {string} [oOpts.filter=none] Select elements that meet the current filter
			 *    criterion ("applied") or all elements (i.e. no filter).
			 *  @param {string} [oOpts.order=current] Order of the data in the processed array.
			 *    Can be either 'current', whereby the current sorting of the table is used, or
			 *    'original' whereby the original order the data was read into the table is used.
			 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
			 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
			 *    'current' and filter is 'applied', regardless of what they might be given as.
			 *  @returns {array} Data for the matched elements. If any elements, as a result of the
			 *    selector, were not TR, TD or TH elements in the DataTable, they will have a null
			 *    entry in the array.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Get the data from the first row in the table
			 *      var data = oTable._('tr:first');
			 *
			 *      // Do something useful with the data
			 *      alert( "First cell is: "+data[0] );
			 *    } );
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Filter to 'Webkit' and get all data for
			 *      oTable.fnFilter('Webkit');
			 *      var data = oTable._('tr', {"search": "applied"});
			 *
			 *      // Do something with the data
			 *      alert( data.length+" rows matched the search" );
			 *    } );
			 */
			this._ = function ( sSelector, oOpts )
			{
				return this.api(true).rows( sSelector, oOpts ).data();
			};
			
			
			/**
			 * Create a DataTables Api instance, with the currently selected tables for
			 * the Api's context.
			 * @param {boolean} [traditional=false] Set the API instance's context to be
			 *   only the table referred to by the `DataTable.ext.iApiIndex` option, as was
			 *   used in the API presented by DataTables 1.9- (i.e. the traditional mode),
			 *   or if all tables captured in the jQuery object should be used.
			 * @return {DataTables.Api}
			 */
			this.api = function ( traditional )
			{
				return traditional ?
					new _Api(
						_fnSettingsFromNode( this[ _ext.iApiIndex ] )
					) :
					new _Api( this );
			};
			
			
			/**
			 * Add a single new row or multiple rows of data to the table. Please note
			 * that this is suitable for client-side processing only - if you are using
			 * server-side processing (i.e. "bServerSide": true), then to add data, you
			 * must add it to the data source, i.e. the server-side, through an Ajax call.
			 *  @param {array|object} data The data to be added to the table. This can be:
			 *    <ul>
			 *      <li>1D array of data - add a single row with the data provided</li>
			 *      <li>2D array of arrays - add multiple rows in a single call</li>
			 *      <li>object - data object when using <i>mData</i></li>
			 *      <li>array of objects - multiple data objects when using <i>mData</i></li>
			 *    </ul>
			 *  @param {bool} [redraw=true] redraw the table or not
			 *  @returns {array} An array of integers, representing the list of indexes in
			 *    <i>aoData</i> ({@link DataTable.models.oSettings}) that have been added to
			 *    the table.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    // Global var for counter
			 *    var giCount = 2;
			 *
			 *    $(document).ready(function() {
			 *      $('#example').dataTable();
			 *    } );
			 *
			 *    function fnClickAddRow() {
			 *      $('#example').dataTable().fnAddData( [
			 *        giCount+".1",
			 *        giCount+".2",
			 *        giCount+".3",
			 *        giCount+".4" ]
			 *      );
			 *
			 *      giCount++;
			 *    }
			 */
			this.fnAddData = function( data, redraw )
			{
				var api = this.api( true );
			
				/* Check if we want to add multiple rows or not */
				var rows = $.isArray(data) && ( $.isArray(data[0]) || $.isPlainObject(data[0]) ) ?
					api.rows.add( data ) :
					api.row.add( data );
			
				if ( redraw === undefined || redraw ) {
					api.draw();
				}
			
				return rows.flatten().toArray();
			};
			
			
			/**
			 * This function will make DataTables recalculate the column sizes, based on the data
			 * contained in the table and the sizes applied to the columns (in the DOM, CSS or
			 * through the sWidth parameter). This can be useful when the width of the table's
			 * parent element changes (for example a window resize).
			 *  @param {boolean} [bRedraw=true] Redraw the table or not, you will typically want to
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable( {
			 *        "sScrollY": "200px",
			 *        "bPaginate": false
			 *      } );
			 *
			 *      $(window).on('resize', function () {
			 *        oTable.fnAdjustColumnSizing();
			 *      } );
			 *    } );
			 */
			this.fnAdjustColumnSizing = function ( bRedraw )
			{
				var api = this.api( true ).columns.adjust();
				var settings = api.settings()[0];
				var scroll = settings.oScroll;
			
				if ( bRedraw === undefined || bRedraw ) {
					api.draw( false );
				}
				else if ( scroll.sX !== "" || scroll.sY !== "" ) {
					/* If not redrawing, but scrolling, we want to apply the new column sizes anyway */
					_fnScrollDraw( settings );
				}
			};
			
			
			/**
			 * Quickly and simply clear a table
			 *  @param {bool} [bRedraw=true] redraw the table or not
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Immediately 'nuke' the current rows (perhaps waiting for an Ajax callback...)
			 *      oTable.fnClearTable();
			 *    } );
			 */
			this.fnClearTable = function( bRedraw )
			{
				var api = this.api( true ).clear();
			
				if ( bRedraw === undefined || bRedraw ) {
					api.draw();
				}
			};
			
			
			/**
			 * The exact opposite of 'opening' a row, this function will close any rows which
			 * are currently 'open'.
			 *  @param {node} nTr the table row to 'close'
			 *  @returns {int} 0 on success, or 1 if failed (can't find the row)
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable;
			 *
			 *      // 'open' an information row when a row is clicked on
			 *      $('#example tbody tr').click( function () {
			 *        if ( oTable.fnIsOpen(this) ) {
			 *          oTable.fnClose( this );
			 *        } else {
			 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
			 *        }
			 *      } );
			 *
			 *      oTable = $('#example').dataTable();
			 *    } );
			 */
			this.fnClose = function( nTr )
			{
				this.api( true ).row( nTr ).child.hide();
			};
			
			
			/**
			 * Remove a row for the table
			 *  @param {mixed} target The index of the row from aoData to be deleted, or
			 *    the TR element you want to delete
			 *  @param {function|null} [callBack] Callback function
			 *  @param {bool} [redraw=true] Redraw the table or not
			 *  @returns {array} The row that was deleted
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Immediately remove the first row
			 *      oTable.fnDeleteRow( 0 );
			 *    } );
			 */
			this.fnDeleteRow = function( target, callback, redraw )
			{
				var api = this.api( true );
				var rows = api.rows( target );
				var settings = rows.settings()[0];
				var data = settings.aoData[ rows[0][0] ];
			
				rows.remove();
			
				if ( callback ) {
					callback.call( this, settings, data );
				}
			
				if ( redraw === undefined || redraw ) {
					api.draw();
				}
			
				return data;
			};
			
			
			/**
			 * Restore the table to it's original state in the DOM by removing all of DataTables
			 * enhancements, alterations to the DOM structure of the table and event listeners.
			 *  @param {boolean} [remove=false] Completely remove the table from the DOM
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      // This example is fairly pointless in reality, but shows how fnDestroy can be used
			 *      var oTable = $('#example').dataTable();
			 *      oTable.fnDestroy();
			 *    } );
			 */
			this.fnDestroy = function ( remove )
			{
				this.api( true ).destroy( remove );
			};
			
			
			/**
			 * Redraw the table
			 *  @param {bool} [complete=true] Re-filter and resort (if enabled) the table before the draw.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Re-draw the table - you wouldn't want to do it here, but it's an example :-)
			 *      oTable.fnDraw();
			 *    } );
			 */
			this.fnDraw = function( complete )
			{
				// Note that this isn't an exact match to the old call to _fnDraw - it takes
				// into account the new data, but can hold position.
				this.api( true ).draw( complete );
			};
			
			
			/**
			 * Filter the input based on data
			 *  @param {string} sInput String to filter the table on
			 *  @param {int|null} [iColumn] Column to limit filtering to
			 *  @param {bool} [bRegex=false] Treat as regular expression or not
			 *  @param {bool} [bSmart=true] Perform smart filtering or not
			 *  @param {bool} [bShowGlobal=true] Show the input global filter in it's input box(es)
			 *  @param {bool} [bCaseInsensitive=true] Do case-insensitive matching (true) or not (false)
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Sometime later - filter...
			 *      oTable.fnFilter( 'test string' );
			 *    } );
			 */
			this.fnFilter = function( sInput, iColumn, bRegex, bSmart, bShowGlobal, bCaseInsensitive )
			{
				var api = this.api( true );
			
				if ( iColumn === null || iColumn === undefined ) {
					api.search( sInput, bRegex, bSmart, bCaseInsensitive );
				}
				else {
					api.column( iColumn ).search( sInput, bRegex, bSmart, bCaseInsensitive );
				}
			
				api.draw();
			};
			
			
			/**
			 * Get the data for the whole table, an individual row or an individual cell based on the
			 * provided parameters.
			 *  @param {int|node} [src] A TR row node, TD/TH cell node or an integer. If given as
			 *    a TR node then the data source for the whole row will be returned. If given as a
			 *    TD/TH cell node then iCol will be automatically calculated and the data for the
			 *    cell returned. If given as an integer, then this is treated as the aoData internal
			 *    data index for the row (see fnGetPosition) and the data for that row used.
			 *  @param {int} [col] Optional column index that you want the data of.
			 *  @returns {array|object|string} If mRow is undefined, then the data for all rows is
			 *    returned. If mRow is defined, just data for that row, and is iCol is
			 *    defined, only data for the designated cell is returned.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    // Row data
			 *    $(document).ready(function() {
			 *      oTable = $('#example').dataTable();
			 *
			 *      oTable.$('tr').click( function () {
			 *        var data = oTable.fnGetData( this );
			 *        // ... do something with the array / object of data for the row
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Individual cell data
			 *    $(document).ready(function() {
			 *      oTable = $('#example').dataTable();
			 *
			 *      oTable.$('td').click( function () {
			 *        var sData = oTable.fnGetData( this );
			 *        alert( 'The cell clicked on had the value of '+sData );
			 *      } );
			 *    } );
			 */
			this.fnGetData = function( src, col )
			{
				var api = this.api( true );
			
				if ( src !== undefined ) {
					var type = src.nodeName ? src.nodeName.toLowerCase() : '';
			
					return col !== undefined || type == 'td' || type == 'th' ?
						api.cell( src, col ).data() :
						api.row( src ).data() || null;
				}
			
				return api.data().toArray();
			};
			
			
			/**
			 * Get an array of the TR nodes that are used in the table's body. Note that you will
			 * typically want to use the '$' API method in preference to this as it is more
			 * flexible.
			 *  @param {int} [iRow] Optional row index for the TR element you want
			 *  @returns {array|node} If iRow is undefined, returns an array of all TR elements
			 *    in the table's body, or iRow is defined, just the TR element requested.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Get the nodes from the table
			 *      var nNodes = oTable.fnGetNodes( );
			 *    } );
			 */
			this.fnGetNodes = function( iRow )
			{
				var api = this.api( true );
			
				return iRow !== undefined ?
					api.row( iRow ).node() :
					api.rows().nodes().flatten().toArray();
			};
			
			
			/**
			 * Get the array indexes of a particular cell from it's DOM element
			 * and column index including hidden columns
			 *  @param {node} node this can either be a TR, TD or TH in the table's body
			 *  @returns {int} If nNode is given as a TR, then a single index is returned, or
			 *    if given as a cell, an array of [row index, column index (visible),
			 *    column index (all)] is given.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      $('#example tbody td').click( function () {
			 *        // Get the position of the current data from the node
			 *        var aPos = oTable.fnGetPosition( this );
			 *
			 *        // Get the data array for this row
			 *        var aData = oTable.fnGetData( aPos[0] );
			 *
			 *        // Update the data array and return the value
			 *        aData[ aPos[1] ] = 'clicked';
			 *        this.innerHTML = 'clicked';
			 *      } );
			 *
			 *      // Init DataTables
			 *      oTable = $('#example').dataTable();
			 *    } );
			 */
			this.fnGetPosition = function( node )
			{
				var api = this.api( true );
				var nodeName = node.nodeName.toUpperCase();
			
				if ( nodeName == 'TR' ) {
					return api.row( node ).index();
				}
				else if ( nodeName == 'TD' || nodeName == 'TH' ) {
					var cell = api.cell( node ).index();
			
					return [
						cell.row,
						cell.columnVisible,
						cell.column
					];
				}
				return null;
			};
			
			
			/**
			 * Check to see if a row is 'open' or not.
			 *  @param {node} nTr the table row to check
			 *  @returns {boolean} true if the row is currently open, false otherwise
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable;
			 *
			 *      // 'open' an information row when a row is clicked on
			 *      $('#example tbody tr').click( function () {
			 *        if ( oTable.fnIsOpen(this) ) {
			 *          oTable.fnClose( this );
			 *        } else {
			 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
			 *        }
			 *      } );
			 *
			 *      oTable = $('#example').dataTable();
			 *    } );
			 */
			this.fnIsOpen = function( nTr )
			{
				return this.api( true ).row( nTr ).child.isShown();
			};
			
			
			/**
			 * This function will place a new row directly after a row which is currently
			 * on display on the page, with the HTML contents that is passed into the
			 * function. This can be used, for example, to ask for confirmation that a
			 * particular record should be deleted.
			 *  @param {node} nTr The table row to 'open'
			 *  @param {string|node|jQuery} mHtml The HTML to put into the row
			 *  @param {string} sClass Class to give the new TD cell
			 *  @returns {node} The row opened. Note that if the table row passed in as the
			 *    first parameter, is not found in the table, this method will silently
			 *    return.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable;
			 *
			 *      // 'open' an information row when a row is clicked on
			 *      $('#example tbody tr').click( function () {
			 *        if ( oTable.fnIsOpen(this) ) {
			 *          oTable.fnClose( this );
			 *        } else {
			 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
			 *        }
			 *      } );
			 *
			 *      oTable = $('#example').dataTable();
			 *    } );
			 */
			this.fnOpen = function( nTr, mHtml, sClass )
			{
				return this.api( true )
					.row( nTr )
					.child( mHtml, sClass )
					.show()
					.child()[0];
			};
			
			
			/**
			 * Change the pagination - provides the internal logic for pagination in a simple API
			 * function. With this function you can have a DataTables table go to the next,
			 * previous, first or last pages.
			 *  @param {string|int} mAction Paging action to take: "first", "previous", "next" or "last"
			 *    or page number to jump to (integer), note that page 0 is the first page.
			 *  @param {bool} [bRedraw=true] Redraw the table or not
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *      oTable.fnPageChange( 'next' );
			 *    } );
			 */
			this.fnPageChange = function ( mAction, bRedraw )
			{
				var api = this.api( true ).page( mAction );
			
				if ( bRedraw === undefined || bRedraw ) {
					api.draw(false);
				}
			};
			
			
			/**
			 * Show a particular column
			 *  @param {int} iCol The column whose display should be changed
			 *  @param {bool} bShow Show (true) or hide (false) the column
			 *  @param {bool} [bRedraw=true] Redraw the table or not
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Hide the second column after initialisation
			 *      oTable.fnSetColumnVis( 1, false );
			 *    } );
			 */
			this.fnSetColumnVis = function ( iCol, bShow, bRedraw )
			{
				var api = this.api( true ).column( iCol ).visible( bShow );
			
				if ( bRedraw === undefined || bRedraw ) {
					api.columns.adjust().draw();
				}
			};
			
			
			/**
			 * Get the settings for a particular table for external manipulation
			 *  @returns {object} DataTables settings object. See
			 *    {@link DataTable.models.oSettings}
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *      var oSettings = oTable.fnSettings();
			 *
			 *      // Show an example parameter from the settings
			 *      alert( oSettings._iDisplayStart );
			 *    } );
			 */
			this.fnSettings = function()
			{
				return _fnSettingsFromNode( this[_ext.iApiIndex] );
			};
			
			
			/**
			 * Sort the table by a particular column
			 *  @param {int} iCol the data index to sort on. Note that this will not match the
			 *    'display index' if you have hidden data entries
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Sort immediately with columns 0 and 1
			 *      oTable.fnSort( [ [0,'asc'], [1,'asc'] ] );
			 *    } );
			 */
			this.fnSort = function( aaSort )
			{
				this.api( true ).order( aaSort ).draw();
			};
			
			
			/**
			 * Attach a sort listener to an element for a given column
			 *  @param {node} nNode the element to attach the sort listener to
			 *  @param {int} iColumn the column that a click on this node will sort on
			 *  @param {function} [fnCallback] callback function when sort is run
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Sort on column 1, when 'sorter' is clicked on
			 *      oTable.fnSortListener( document.getElementById('sorter'), 1 );
			 *    } );
			 */
			this.fnSortListener = function( nNode, iColumn, fnCallback )
			{
				this.api( true ).order.listener( nNode, iColumn, fnCallback );
			};
			
			
			/**
			 * Update a table cell or row - this method will accept either a single value to
			 * update the cell with, an array of values with one element for each column or
			 * an object in the same format as the original data source. The function is
			 * self-referencing in order to make the multi column updates easier.
			 *  @param {object|array|string} mData Data to update the cell/row with
			 *  @param {node|int} mRow TR element you want to update or the aoData index
			 *  @param {int} [iColumn] The column to update, give as null or undefined to
			 *    update a whole row.
			 *  @param {bool} [bRedraw=true] Redraw the table or not
			 *  @param {bool} [bAction=true] Perform pre-draw actions or not
			 *  @returns {int} 0 on success, 1 on error
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *      oTable.fnUpdate( 'Example update', 0, 0 ); // Single cell
			 *      oTable.fnUpdate( ['a', 'b', 'c', 'd', 'e'], $('tbody tr')[0] ); // Row
			 *    } );
			 */
			this.fnUpdate = function( mData, mRow, iColumn, bRedraw, bAction )
			{
				var api = this.api( true );
			
				if ( iColumn === undefined || iColumn === null ) {
					api.row( mRow ).data( mData );
				}
				else {
					api.cell( mRow, iColumn ).data( mData );
				}
			
				if ( bAction === undefined || bAction ) {
					api.columns.adjust();
				}
			
				if ( bRedraw === undefined || bRedraw ) {
					api.draw();
				}
				return 0;
			};
			
			
			/**
			 * Provide a common method for plug-ins to check the version of DataTables being used, in order
			 * to ensure compatibility.
			 *  @param {string} sVersion Version string to check for, in the format "X.Y.Z". Note that the
			 *    formats "X" and "X.Y" are also acceptable.
			 *  @returns {boolean} true if this version of DataTables is greater or equal to the required
			 *    version, or false if this version of DataTales is not suitable
			 *  @method
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *      alert( oTable.fnVersionCheck( '1.9.0' ) );
			 *    } );
			 */
			this.fnVersionCheck = _ext.fnVersionCheck;
			
	
			var _that = this;
			var emptyInit = options === undefined;
			var len = this.length;
	
			if ( emptyInit ) {
				options = {};
			}
	
			this.oApi = this.internal = _ext.internal;
	
			// Extend with old style plug-in API methods
			for ( var fn in DataTable.ext.internal ) {
				if ( fn ) {
					this[fn] = _fnExternApiFunc(fn);
				}
			}
	
			this.each(function() {
				// For each initialisation we want to give it a clean initialisation
				// object that can be bashed around
				var o = {};
				var oInit = len > 1 ? // optimisation for single table case
					_fnExtend( o, options, true ) :
					options;
	
				/*global oInit,_that,emptyInit*/
				var i=0, iLen, j, jLen, k, kLen;
				var sId = this.getAttribute( 'id' );
				var bInitHandedOff = false;
				var defaults = DataTable.defaults;
				var $this = $(this);
				
				
				/* Sanity check */
				if ( this.nodeName.toLowerCase() != 'table' )
				{
					_fnLog( null, 0, 'Non-table node initialisation ('+this.nodeName+')', 2 );
					return;
				}
				
				/* Backwards compatibility for the defaults */
				_fnCompatOpts( defaults );
				_fnCompatCols( defaults.column );
				
				/* Convert the camel-case defaults to Hungarian */
				_fnCamelToHungarian( defaults, defaults, true );
				_fnCamelToHungarian( defaults.column, defaults.column, true );
				
				/* Setting up the initialisation object */
				_fnCamelToHungarian( defaults, $.extend( oInit, $this.data() ) );
				
				
				
				/* Check to see if we are re-initialising a table */
				var allSettings = DataTable.settings;
				for ( i=0, iLen=allSettings.length ; i<iLen ; i++ )
				{
					var s = allSettings[i];
				
					/* Base check on table node */
					if ( s.nTable == this || s.nTHead.parentNode == this || (s.nTFoot && s.nTFoot.parentNode == this) )
					{
						var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
						var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
				
						if ( emptyInit || bRetrieve )
						{
							return s.oInstance;
						}
						else if ( bDestroy )
						{
							s.oInstance.fnDestroy();
							break;
						}
						else
						{
							_fnLog( s, 0, 'Cannot reinitialise DataTable', 3 );
							return;
						}
					}
				
					/* If the element we are initialising has the same ID as a table which was previously
					 * initialised, but the table nodes don't match (from before) then we destroy the old
					 * instance by simply deleting it. This is under the assumption that the table has been
					 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
					 */
					if ( s.sTableId == this.id )
					{
						allSettings.splice( i, 1 );
						break;
					}
				}
				
				/* Ensure the table has an ID - required for accessibility */
				if ( sId === null || sId === "" )
				{
					sId = "DataTables_Table_"+(DataTable.ext._unique++);
					this.id = sId;
				}
				
				/* Create the settings object for this table and set some of the default parameters */
				var oSettings = $.extend( true, {}, DataTable.models.oSettings, {
					"sDestroyWidth": $this[0].style.width,
					"sInstance":     sId,
					"sTableId":      sId
				} );
				oSettings.nTable = this;
				oSettings.oApi   = _that.internal;
				oSettings.oInit  = oInit;
				
				allSettings.push( oSettings );
				
				// Need to add the instance after the instance after the settings object has been added
				// to the settings array, so we can self reference the table instance if more than one
				oSettings.oInstance = (_that.length===1) ? _that : $this.dataTable();
				
				// Backwards compatibility, before we apply all the defaults
				_fnCompatOpts( oInit );
				
				if ( oInit.oLanguage )
				{
					_fnLanguageCompat( oInit.oLanguage );
				}
				
				// If the length menu is given, but the init display length is not, use the length menu
				if ( oInit.aLengthMenu && ! oInit.iDisplayLength )
				{
					oInit.iDisplayLength = $.isArray( oInit.aLengthMenu[0] ) ?
						oInit.aLengthMenu[0][0] : oInit.aLengthMenu[0];
				}
				
				// Apply the defaults and init options to make a single init object will all
				// options defined from defaults and instance options.
				oInit = _fnExtend( $.extend( true, {}, defaults ), oInit );
				
				
				// Map the initialisation options onto the settings object
				_fnMap( oSettings.oFeatures, oInit, [
					"bPaginate",
					"bLengthChange",
					"bFilter",
					"bSort",
					"bSortMulti",
					"bInfo",
					"bProcessing",
					"bAutoWidth",
					"bSortClasses",
					"bServerSide",
					"bDeferRender"
				] );
				_fnMap( oSettings, oInit, [
					"asStripeClasses",
					"ajax",
					"fnServerData",
					"fnFormatNumber",
					"sServerMethod",
					"aaSorting",
					"aaSortingFixed",
					"aLengthMenu",
					"sPaginationType",
					"sAjaxSource",
					"sAjaxDataProp",
					"iStateDuration",
					"sDom",
					"bSortCellsTop",
					"iTabIndex",
					"fnStateLoadCallback",
					"fnStateSaveCallback",
					"renderer",
					"searchDelay",
					"rowId",
					[ "iCookieDuration", "iStateDuration" ], // backwards compat
					[ "oSearch", "oPreviousSearch" ],
					[ "aoSearchCols", "aoPreSearchCols" ],
					[ "iDisplayLength", "_iDisplayLength" ]
				] );
				_fnMap( oSettings.oScroll, oInit, [
					[ "sScrollX", "sX" ],
					[ "sScrollXInner", "sXInner" ],
					[ "sScrollY", "sY" ],
					[ "bScrollCollapse", "bCollapse" ]
				] );
				_fnMap( oSettings.oLanguage, oInit, "fnInfoCallback" );
				
				/* Callback functions which are array driven */
				_fnCallbackReg( oSettings, 'aoDrawCallback',       oInit.fnDrawCallback,      'user' );
				_fnCallbackReg( oSettings, 'aoServerParams',       oInit.fnServerParams,      'user' );
				_fnCallbackReg( oSettings, 'aoStateSaveParams',    oInit.fnStateSaveParams,   'user' );
				_fnCallbackReg( oSettings, 'aoStateLoadParams',    oInit.fnStateLoadParams,   'user' );
				_fnCallbackReg( oSettings, 'aoStateLoaded',        oInit.fnStateLoaded,       'user' );
				_fnCallbackReg( oSettings, 'aoRowCallback',        oInit.fnRowCallback,       'user' );
				_fnCallbackReg( oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow,        'user' );
				_fnCallbackReg( oSettings, 'aoHeaderCallback',     oInit.fnHeaderCallback,    'user' );
				_fnCallbackReg( oSettings, 'aoFooterCallback',     oInit.fnFooterCallback,    'user' );
				_fnCallbackReg( oSettings, 'aoInitComplete',       oInit.fnInitComplete,      'user' );
				_fnCallbackReg( oSettings, 'aoPreDrawCallback',    oInit.fnPreDrawCallback,   'user' );
				
				oSettings.rowIdFn = _fnGetObjectDataFn( oInit.rowId );
				
				/* Browser support detection */
				_fnBrowserDetect( oSettings );
				
				var oClasses = oSettings.oClasses;
				
				$.extend( oClasses, DataTable.ext.classes, oInit.oClasses );
				$this.addClass( oClasses.sTable );
				
				
				if ( oSettings.iInitDisplayStart === undefined )
				{
					/* Display start point, taking into account the save saving */
					oSettings.iInitDisplayStart = oInit.iDisplayStart;
					oSettings._iDisplayStart = oInit.iDisplayStart;
				}
				
				if ( oInit.iDeferLoading !== null )
				{
					oSettings.bDeferLoading = true;
					var tmp = $.isArray( oInit.iDeferLoading );
					oSettings._iRecordsDisplay = tmp ? oInit.iDeferLoading[0] : oInit.iDeferLoading;
					oSettings._iRecordsTotal = tmp ? oInit.iDeferLoading[1] : oInit.iDeferLoading;
				}
				
				/* Language definitions */
				var oLanguage = oSettings.oLanguage;
				$.extend( true, oLanguage, oInit.oLanguage );
				
				if ( oLanguage.sUrl )
				{
					/* Get the language definitions from a file - because this Ajax call makes the language
					 * get async to the remainder of this function we use bInitHandedOff to indicate that
					 * _fnInitialise will be fired by the returned Ajax handler, rather than the constructor
					 */
					$.ajax( {
						dataType: 'json',
						url: oLanguage.sUrl,
						success: function ( json ) {
							_fnLanguageCompat( json );
							_fnCamelToHungarian( defaults.oLanguage, json );
							$.extend( true, oLanguage, json );
							_fnInitialise( oSettings );
						},
						error: function () {
							// Error occurred loading language file, continue on as best we can
							_fnInitialise( oSettings );
						}
					} );
					bInitHandedOff = true;
				}
				
				/*
				 * Stripes
				 */
				if ( oInit.asStripeClasses === null )
				{
					oSettings.asStripeClasses =[
						oClasses.sStripeOdd,
						oClasses.sStripeEven
					];
				}
				
				/* Remove row stripe classes if they are already on the table row */
				var stripeClasses = oSettings.asStripeClasses;
				var rowOne = $this.children('tbody').find('tr').eq(0);
				if ( $.inArray( true, $.map( stripeClasses, function(el, i) {
					return rowOne.hasClass(el);
				} ) ) !== -1 ) {
					$('tbody tr', this).removeClass( stripeClasses.join(' ') );
					oSettings.asDestroyStripes = stripeClasses.slice();
				}
				
				/*
				 * Columns
				 * See if we should load columns automatically or use defined ones
				 */
				var anThs = [];
				var aoColumnsInit;
				var nThead = this.getElementsByTagName('thead');
				if ( nThead.length !== 0 )
				{
					_fnDetectHeader( oSettings.aoHeader, nThead[0] );
					anThs = _fnGetUniqueThs( oSettings );
				}
				
				/* If not given a column array, generate one with nulls */
				if ( oInit.aoColumns === null )
				{
					aoColumnsInit = [];
					for ( i=0, iLen=anThs.length ; i<iLen ; i++ )
					{
						aoColumnsInit.push( null );
					}
				}
				else
				{
					aoColumnsInit = oInit.aoColumns;
				}
				
				/* Add the columns */
				for ( i=0, iLen=aoColumnsInit.length ; i<iLen ; i++ )
				{
					_fnAddColumn( oSettings, anThs ? anThs[i] : null );
				}
				
				/* Apply the column definitions */
				_fnApplyColumnDefs( oSettings, oInit.aoColumnDefs, aoColumnsInit, function (iCol, oDef) {
					_fnColumnOptions( oSettings, iCol, oDef );
				} );
				
				/* HTML5 attribute detection - build an mData object automatically if the
				 * attributes are found
				 */
				if ( rowOne.length ) {
					var a = function ( cell, name ) {
						return cell.getAttribute( 'data-'+name ) !== null ? name : null;
					};
				
					$( rowOne[0] ).children('th, td').each( function (i, cell) {
						var col = oSettings.aoColumns[i];
				
						if ( col.mData === i ) {
							var sort = a( cell, 'sort' ) || a( cell, 'order' );
							var filter = a( cell, 'filter' ) || a( cell, 'search' );
				
							if ( sort !== null || filter !== null ) {
								col.mData = {
									_:      i+'.display',
									sort:   sort !== null   ? i+'.@data-'+sort   : undefined,
									type:   sort !== null   ? i+'.@data-'+sort   : undefined,
									filter: filter !== null ? i+'.@data-'+filter : undefined
								};
				
								_fnColumnOptions( oSettings, i );
							}
						}
					} );
				}
				
				var features = oSettings.oFeatures;
				var loadedInit = function () {
					/*
					 * Sorting
					 * @todo For modularisation (1.11) this needs to do into a sort start up handler
					 */
				
					// If aaSorting is not defined, then we use the first indicator in asSorting
					// in case that has been altered, so the default sort reflects that option
					if ( oInit.aaSorting === undefined ) {
						var sorting = oSettings.aaSorting;
						for ( i=0, iLen=sorting.length ; i<iLen ; i++ ) {
							sorting[i][1] = oSettings.aoColumns[ i ].asSorting[0];
						}
					}
				
					/* Do a first pass on the sorting classes (allows any size changes to be taken into
					 * account, and also will apply sorting disabled classes if disabled
					 */
					_fnSortingClasses( oSettings );
				
					if ( features.bSort ) {
						_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
							if ( oSettings.bSorted ) {
								var aSort = _fnSortFlatten( oSettings );
								var sortedColumns = {};
				
								$.each( aSort, function (i, val) {
									sortedColumns[ val.src ] = val.dir;
								} );
				
								_fnCallbackFire( oSettings, null, 'order', [oSettings, aSort, sortedColumns] );
								_fnSortAria( oSettings );
							}
						} );
					}
				
					_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
						if ( oSettings.bSorted || _fnDataSource( oSettings ) === 'ssp' || features.bDeferRender ) {
							_fnSortingClasses( oSettings );
						}
					}, 'sc' );
				
				
					/*
					 * Final init
					 * Cache the header, body and footer as required, creating them if needed
					 */
				
					// Work around for Webkit bug 83867 - store the caption-side before removing from doc
					var captions = $this.children('caption').each( function () {
						this._captionSide = $(this).css('caption-side');
					} );
				
					var thead = $this.children('thead');
					if ( thead.length === 0 ) {
						thead = $('<thead/>').appendTo($this);
					}
					oSettings.nTHead = thead[0];
				
					var tbody = $this.children('tbody');
					if ( tbody.length === 0 ) {
						tbody = $('<tbody/>').appendTo($this);
					}
					oSettings.nTBody = tbody[0];
				
					var tfoot = $this.children('tfoot');
					if ( tfoot.length === 0 && captions.length > 0 && (oSettings.oScroll.sX !== "" || oSettings.oScroll.sY !== "") ) {
						// If we are a scrolling table, and no footer has been given, then we need to create
						// a tfoot element for the caption element to be appended to
						tfoot = $('<tfoot/>').appendTo($this);
					}
				
					if ( tfoot.length === 0 || tfoot.children().length === 0 ) {
						$this.addClass( oClasses.sNoFooter );
					}
					else if ( tfoot.length > 0 ) {
						oSettings.nTFoot = tfoot[0];
						_fnDetectHeader( oSettings.aoFooter, oSettings.nTFoot );
					}
				
					/* Check if there is data passing into the constructor */
					if ( oInit.aaData ) {
						for ( i=0 ; i<oInit.aaData.length ; i++ ) {
							_fnAddData( oSettings, oInit.aaData[ i ] );
						}
					}
					else if ( oSettings.bDeferLoading || _fnDataSource( oSettings ) == 'dom' ) {
						/* Grab the data from the page - only do this when deferred loading or no Ajax
						 * source since there is no point in reading the DOM data if we are then going
						 * to replace it with Ajax data
						 */
						_fnAddTr( oSettings, $(oSettings.nTBody).children('tr') );
					}
				
					/* Copy the data index array */
					oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
				
					/* Initialisation complete - table can be drawn */
					oSettings.bInitialised = true;
				
					/* Check if we need to initialise the table (it might not have been handed off to the
					 * language processor)
					 */
					if ( bInitHandedOff === false ) {
						_fnInitialise( oSettings );
					}
				};
				
				/* Must be done after everything which can be overridden by the state saving! */
				if ( oInit.bStateSave )
				{
					features.bStateSave = true;
					_fnCallbackReg( oSettings, 'aoDrawCallback', _fnSaveState, 'state_save' );
					_fnLoadState( oSettings, oInit, loadedInit );
				}
				else {
					loadedInit();
				}
				
			} );
			_that = null;
			return this;
		};
	
		
		/*
		 * It is useful to have variables which are scoped locally so only the
		 * DataTables functions can access them and they don't leak into global space.
		 * At the same time these functions are often useful over multiple files in the
		 * core and API, so we list, or at least document, all variables which are used
		 * by DataTables as private variables here. This also ensures that there is no
		 * clashing of variable names and that they can easily referenced for reuse.
		 */
		
		
		// Defined else where
		//  _selector_run
		//  _selector_opts
		//  _selector_first
		//  _selector_row_indexes
		
		var _ext; // DataTable.ext
		var _Api; // DataTable.Api
		var _api_register; // DataTable.Api.register
		var _api_registerPlural; // DataTable.Api.registerPlural
		
		var _re_dic = {};
		var _re_new_lines = /[\r\n]/g;
		var _re_html = /<.*?>/g;
		
		// This is not strict ISO8601 - Date.parse() is quite lax, although
		// implementations differ between browsers.
		var _re_date = /^\d{2,4}[\.\/\-]\d{1,2}[\.\/\-]\d{1,2}([T ]{1}\d{1,2}[:\.]\d{2}([\.:]\d{2})?)?$/;
		
		// Escape regular expression special characters
		var _re_escape_regex = new RegExp( '(\\' + [ '/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\', '$', '^', '-' ].join('|\\') + ')', 'g' );
		
		// http://en.wikipedia.org/wiki/Foreign_exchange_market
		// - \u20BD - Russian ruble.
		// - \u20a9 - South Korean Won
		// - \u20BA - Turkish Lira
		// - \u20B9 - Indian Rupee
		// - R - Brazil (R$) and South Africa
		// - fr - Swiss Franc
		// - kr - Swedish krona, Norwegian krone and Danish krone
		// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
		//   standards as thousands separators.
		var _re_formatted_numeric = /[',$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfk]/gi;
		
		
		var _empty = function ( d ) {
			return !d || d === true || d === '-' ? true : false;
		};
		
		
		var _intVal = function ( s ) {
			var integer = parseInt( s, 10 );
			return !isNaN(integer) && isFinite(s) ? integer : null;
		};
		
		// Convert from a formatted number with characters other than `.` as the
		// decimal place, to a Javascript number
		var _numToDecimal = function ( num, decimalPoint ) {
			// Cache created regular expressions for speed as this function is called often
			if ( ! _re_dic[ decimalPoint ] ) {
				_re_dic[ decimalPoint ] = new RegExp( _fnEscapeRegex( decimalPoint ), 'g' );
			}
			return typeof num === 'string' && decimalPoint !== '.' ?
				num.replace( /\./g, '' ).replace( _re_dic[ decimalPoint ], '.' ) :
				num;
		};
		
		
		var _isNumber = function ( d, decimalPoint, formatted ) {
			var strType = typeof d === 'string';
		
			// If empty return immediately so there must be a number if it is a
			// formatted string (this stops the string "k", or "kr", etc being detected
			// as a formatted number for currency
			if ( _empty( d ) ) {
				return true;
			}
		
			if ( decimalPoint && strType ) {
				d = _numToDecimal( d, decimalPoint );
			}
		
			if ( formatted && strType ) {
				d = d.replace( _re_formatted_numeric, '' );
			}
		
			return !isNaN( parseFloat(d) ) && isFinite( d );
		};
		
		
		// A string without HTML in it can be considered to be HTML still
		var _isHtml = function ( d ) {
			return _empty( d ) || typeof d === 'string';
		};
		
		
		var _htmlNumeric = function ( d, decimalPoint, formatted ) {
			if ( _empty( d ) ) {
				return true;
			}
		
			var html = _isHtml( d );
			return ! html ?
				null :
				_isNumber( _stripHtml( d ), decimalPoint, formatted ) ?
					true :
					null;
		};
		
		
		var _pluck = function ( a, prop, prop2 ) {
			var out = [];
			var i=0, ien=a.length;
		
			// Could have the test in the loop for slightly smaller code, but speed
			// is essential here
			if ( prop2 !== undefined ) {
				for ( ; i<ien ; i++ ) {
					if ( a[i] && a[i][ prop ] ) {
						out.push( a[i][ prop ][ prop2 ] );
					}
				}
			}
			else {
				for ( ; i<ien ; i++ ) {
					if ( a[i] ) {
						out.push( a[i][ prop ] );
					}
				}
			}
		
			return out;
		};
		
		
		// Basically the same as _pluck, but rather than looping over `a` we use `order`
		// as the indexes to pick from `a`
		var _pluck_order = function ( a, order, prop, prop2 )
		{
			var out = [];
			var i=0, ien=order.length;
		
			// Could have the test in the loop for slightly smaller code, but speed
			// is essential here
			if ( prop2 !== undefined ) {
				for ( ; i<ien ; i++ ) {
					if ( a[ order[i] ][ prop ] ) {
						out.push( a[ order[i] ][ prop ][ prop2 ] );
					}
				}
			}
			else {
				for ( ; i<ien ; i++ ) {
					out.push( a[ order[i] ][ prop ] );
				}
			}
		
			return out;
		};
		
		
		var _range = function ( len, start )
		{
			var out = [];
			var end;
		
			if ( start === undefined ) {
				start = 0;
				end = len;
			}
			else {
				end = start;
				start = len;
			}
		
			for ( var i=start ; i<end ; i++ ) {
				out.push( i );
			}
		
			return out;
		};
		
		
		var _removeEmpty = function ( a )
		{
			var out = [];
		
			for ( var i=0, ien=a.length ; i<ien ; i++ ) {
				if ( a[i] ) { // careful - will remove all falsy values!
					out.push( a[i] );
				}
			}
		
			return out;
		};
		
		
		var _stripHtml = function ( d ) {
			return d.replace( _re_html, '' );
		};
		
		
		/**
		 * Determine if all values in the array are unique. This means we can short
		 * cut the _unique method at the cost of a single loop. A sorted array is used
		 * to easily check the values.
		 *
		 * @param  {array} src Source array
		 * @return {boolean} true if all unique, false otherwise
		 * @ignore
		 */
		var _areAllUnique = function ( src ) {
			if ( src.length < 2 ) {
				return true;
			}
		
			var sorted = src.slice().sort();
			var last = sorted[0];
		
			for ( var i=1, ien=sorted.length ; i<ien ; i++ ) {
				if ( sorted[i] === last ) {
					return false;
				}
		
				last = sorted[i];
			}
		
			return true;
		};
		
		
		/**
		 * Find the unique elements in a source array.
		 *
		 * @param  {array} src Source array
		 * @return {array} Array of unique items
		 * @ignore
		 */
		var _unique = function ( src )
		{
			if ( _areAllUnique( src ) ) {
				return src.slice();
			}
		
			// A faster unique method is to use object keys to identify used values,
			// but this doesn't work with arrays or objects, which we must also
			// consider. See jsperf.com/compare-array-unique-versions/4 for more
			// information.
			var
				out = [],
				val,
				i, ien=src.length,
				j, k=0;
		
			again: for ( i=0 ; i<ien ; i++ ) {
				val = src[i];
		
				for ( j=0 ; j<k ; j++ ) {
					if ( out[j] === val ) {
						continue again;
					}
				}
		
				out.push( val );
				k++;
			}
		
			return out;
		};
		
		
		/**
		 * DataTables utility methods
		 * 
		 * This namespace provides helper methods that DataTables uses internally to
		 * create a DataTable, but which are not exclusively used only for DataTables.
		 * These methods can be used by extension authors to save the duplication of
		 * code.
		 *
		 *  @namespace
		 */
		DataTable.util = {
			/**
			 * Throttle the calls to a function. Arguments and context are maintained
			 * for the throttled function.
			 *
			 * @param {function} fn Function to be called
			 * @param {integer} freq Call frequency in mS
			 * @return {function} Wrapped function
			 */
			throttle: function ( fn, freq ) {
				var
					frequency = freq !== undefined ? freq : 200,
					last,
					timer;
		
				return function () {
					var
						that = this,
						now  = +new Date(),
						args = arguments;
		
					if ( last && now < last + frequency ) {
						clearTimeout( timer );
		
						timer = setTimeout( function () {
							last = undefined;
							fn.apply( that, args );
						}, frequency );
					}
					else {
						last = now;
						fn.apply( that, args );
					}
				};
			},
		
		
			/**
			 * Escape a string such that it can be used in a regular expression
			 *
			 *  @param {string} val string to escape
			 *  @returns {string} escaped string
			 */
			escapeRegex: function ( val ) {
				return val.replace( _re_escape_regex, '\\$1' );
			}
		};
		
		
		
		/**
		 * Create a mapping object that allows camel case parameters to be looked up
		 * for their Hungarian counterparts. The mapping is stored in a private
		 * parameter called `_hungarianMap` which can be accessed on the source object.
		 *  @param {object} o
		 *  @memberof DataTable#oApi
		 */
		function _fnHungarianMap ( o )
		{
			var
				hungarian = 'a aa ai ao as b fn i m o s ',
				match,
				newKey,
				map = {};
		
			$.each( o, function (key, val) {
				match = key.match(/^([^A-Z]+?)([A-Z])/);
		
				if ( match && hungarian.indexOf(match[1]+' ') !== -1 )
				{
					newKey = key.replace( match[0], match[2].toLowerCase() );
					map[ newKey ] = key;
		
					if ( match[1] === 'o' )
					{
						_fnHungarianMap( o[key] );
					}
				}
			} );
		
			o._hungarianMap = map;
		}
		
		
		/**
		 * Convert from camel case parameters to Hungarian, based on a Hungarian map
		 * created by _fnHungarianMap.
		 *  @param {object} src The model object which holds all parameters that can be
		 *    mapped.
		 *  @param {object} user The object to convert from camel case to Hungarian.
		 *  @param {boolean} force When set to `true`, properties which already have a
		 *    Hungarian value in the `user` object will be overwritten. Otherwise they
		 *    won't be.
		 *  @memberof DataTable#oApi
		 */
		function _fnCamelToHungarian ( src, user, force )
		{
			if ( ! src._hungarianMap ) {
				_fnHungarianMap( src );
			}
		
			var hungarianKey;
		
			$.each( user, function (key, val) {
				hungarianKey = src._hungarianMap[ key ];
		
				if ( hungarianKey !== undefined && (force || user[hungarianKey] === undefined) )
				{
					// For objects, we need to buzz down into the object to copy parameters
					if ( hungarianKey.charAt(0) === 'o' )
					{
						// Copy the camelCase options over to the hungarian
						if ( ! user[ hungarianKey ] ) {
							user[ hungarianKey ] = {};
						}
						$.extend( true, user[hungarianKey], user[key] );
		
						_fnCamelToHungarian( src[hungarianKey], user[hungarianKey], force );
					}
					else {
						user[hungarianKey] = user[ key ];
					}
				}
			} );
		}
		
		
		/**
		 * Language compatibility - when certain options are given, and others aren't, we
		 * need to duplicate the values over, in order to provide backwards compatibility
		 * with older language files.
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnLanguageCompat( lang )
		{
			var defaults = DataTable.defaults.oLanguage;
			var zeroRecords = lang.sZeroRecords;
		
			/* Backwards compatibility - if there is no sEmptyTable given, then use the same as
			 * sZeroRecords - assuming that is given.
			 */
			if ( ! lang.sEmptyTable && zeroRecords &&
				defaults.sEmptyTable === "No data available in table" )
			{
				_fnMap( lang, lang, 'sZeroRecords', 'sEmptyTable' );
			}
		
			/* Likewise with loading records */
			if ( ! lang.sLoadingRecords && zeroRecords &&
				defaults.sLoadingRecords === "Loading..." )
			{
				_fnMap( lang, lang, 'sZeroRecords', 'sLoadingRecords' );
			}
		
			// Old parameter name of the thousands separator mapped onto the new
			if ( lang.sInfoThousands ) {
				lang.sThousands = lang.sInfoThousands;
			}
		
			var decimal = lang.sDecimal;
			if ( decimal ) {
				_addNumericSort( decimal );
			}
		}
		
		
		/**
		 * Map one parameter onto another
		 *  @param {object} o Object to map
		 *  @param {*} knew The new parameter name
		 *  @param {*} old The old parameter name
		 */
		var _fnCompatMap = function ( o, knew, old ) {
			if ( o[ knew ] !== undefined ) {
				o[ old ] = o[ knew ];
			}
		};
		
		
		/**
		 * Provide backwards compatibility for the main DT options. Note that the new
		 * options are mapped onto the old parameters, so this is an external interface
		 * change only.
		 *  @param {object} init Object to map
		 */
		function _fnCompatOpts ( init )
		{
			_fnCompatMap( init, 'ordering',      'bSort' );
			_fnCompatMap( init, 'orderMulti',    'bSortMulti' );
			_fnCompatMap( init, 'orderClasses',  'bSortClasses' );
			_fnCompatMap( init, 'orderCellsTop', 'bSortCellsTop' );
			_fnCompatMap( init, 'order',         'aaSorting' );
			_fnCompatMap( init, 'orderFixed',    'aaSortingFixed' );
			_fnCompatMap( init, 'paging',        'bPaginate' );
			_fnCompatMap( init, 'pagingType',    'sPaginationType' );
			_fnCompatMap( init, 'pageLength',    'iDisplayLength' );
			_fnCompatMap( init, 'searching',     'bFilter' );
		
			// Boolean initialisation of x-scrolling
			if ( typeof init.sScrollX === 'boolean' ) {
				init.sScrollX = init.sScrollX ? '100%' : '';
			}
			if ( typeof init.scrollX === 'boolean' ) {
				init.scrollX = init.scrollX ? '100%' : '';
			}
		
			// Column search objects are in an array, so it needs to be converted
			// element by element
			var searchCols = init.aoSearchCols;
		
			if ( searchCols ) {
				for ( var i=0, ien=searchCols.length ; i<ien ; i++ ) {
					if ( searchCols[i] ) {
						_fnCamelToHungarian( DataTable.models.oSearch, searchCols[i] );
					}
				}
			}
		}
		
		
		/**
		 * Provide backwards compatibility for column options. Note that the new options
		 * are mapped onto the old parameters, so this is an external interface change
		 * only.
		 *  @param {object} init Object to map
		 */
		function _fnCompatCols ( init )
		{
			_fnCompatMap( init, 'orderable',     'bSortable' );
			_fnCompatMap( init, 'orderData',     'aDataSort' );
			_fnCompatMap( init, 'orderSequence', 'asSorting' );
			_fnCompatMap( init, 'orderDataType', 'sortDataType' );
		
			// orderData can be given as an integer
			var dataSort = init.aDataSort;
			if ( typeof dataSort === 'number' && ! $.isArray( dataSort ) ) {
				init.aDataSort = [ dataSort ];
			}
		}
		
		
		/**
		 * Browser feature detection for capabilities, quirks
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnBrowserDetect( settings )
		{
			// We don't need to do this every time DataTables is constructed, the values
			// calculated are specific to the browser and OS configuration which we
			// don't expect to change between initialisations
			if ( ! DataTable.__browser ) {
				var browser = {};
				DataTable.__browser = browser;
		
				// Scrolling feature / quirks detection
				var n = $('<div/>')
					.css( {
						position: 'fixed',
						top: 0,
						left: $(window).scrollLeft()*-1, // allow for scrolling
						height: 1,
						width: 1,
						overflow: 'hidden'
					} )
					.append(
						$('<div/>')
							.css( {
								position: 'absolute',
								top: 1,
								left: 1,
								width: 100,
								overflow: 'scroll'
							} )
							.append(
								$('<div/>')
									.css( {
										width: '100%',
										height: 10
									} )
							)
					)
					.appendTo( 'body' );
		
				var outer = n.children();
				var inner = outer.children();
		
				// Numbers below, in order, are:
				// inner.offsetWidth, inner.clientWidth, outer.offsetWidth, outer.clientWidth
				//
				// IE6 XP:                           100 100 100  83
				// IE7 Vista:                        100 100 100  83
				// IE 8+ Windows:                     83  83 100  83
				// Evergreen Windows:                 83  83 100  83
				// Evergreen Mac with scrollbars:     85  85 100  85
				// Evergreen Mac without scrollbars: 100 100 100 100
		
				// Get scrollbar width
				browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;
		
				// IE6/7 will oversize a width 100% element inside a scrolling element, to
				// include the width of the scrollbar, while other browsers ensure the inner
				// element is contained without forcing scrolling
				browser.bScrollOversize = inner[0].offsetWidth === 100 && outer[0].clientWidth !== 100;
		
				// In rtl text layout, some browsers (most, but not all) will place the
				// scrollbar on the left, rather than the right.
				browser.bScrollbarLeft = Math.round( inner.offset().left ) !== 1;
		
				// IE8- don't provide height and width for getBoundingClientRect
				browser.bBounding = n[0].getBoundingClientRect().width ? true : false;
		
				n.remove();
			}
		
			$.extend( settings.oBrowser, DataTable.__browser );
			settings.oScroll.iBarWidth = DataTable.__browser.barWidth;
		}
		
		
		/**
		 * Array.prototype reduce[Right] method, used for browsers which don't support
		 * JS 1.6. Done this way to reduce code size, since we iterate either way
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnReduce ( that, fn, init, start, end, inc )
		{
			var
				i = start,
				value,
				isSet = false;
		
			if ( init !== undefined ) {
				value = init;
				isSet = true;
			}
		
			while ( i !== end ) {
				if ( ! that.hasOwnProperty(i) ) {
					continue;
				}
		
				value = isSet ?
					fn( value, that[i], i, that ) :
					that[i];
		
				isSet = true;
				i += inc;
			}
		
			return value;
		}
		
		/**
		 * Add a column to the list used for the table with default values
		 *  @param {object} oSettings dataTables settings object
		 *  @param {node} nTh The th element for this column
		 *  @memberof DataTable#oApi
		 */
		function _fnAddColumn( oSettings, nTh )
		{
			// Add column to aoColumns array
			var oDefaults = DataTable.defaults.column;
			var iCol = oSettings.aoColumns.length;
			var oCol = $.extend( {}, DataTable.models.oColumn, oDefaults, {
				"nTh": nTh ? nTh : document.createElement('th'),
				"sTitle":    oDefaults.sTitle    ? oDefaults.sTitle    : nTh ? nTh.innerHTML : '',
				"aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [iCol],
				"mData": oDefaults.mData ? oDefaults.mData : iCol,
				idx: iCol
			} );
			oSettings.aoColumns.push( oCol );
		
			// Add search object for column specific search. Note that the `searchCols[ iCol ]`
			// passed into extend can be undefined. This allows the user to give a default
			// with only some of the parameters defined, and also not give a default
			var searchCols = oSettings.aoPreSearchCols;
			searchCols[ iCol ] = $.extend( {}, DataTable.models.oSearch, searchCols[ iCol ] );
		
			// Use the default column options function to initialise classes etc
			_fnColumnOptions( oSettings, iCol, $(nTh).data() );
		}
		
		
		/**
		 * Apply options for a column
		 *  @param {object} oSettings dataTables settings object
		 *  @param {int} iCol column index to consider
		 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
		 *  @memberof DataTable#oApi
		 */
		function _fnColumnOptions( oSettings, iCol, oOptions )
		{
			var oCol = oSettings.aoColumns[ iCol ];
			var oClasses = oSettings.oClasses;
			var th = $(oCol.nTh);
		
			// Try to get width information from the DOM. We can't get it from CSS
			// as we'd need to parse the CSS stylesheet. `width` option can override
			if ( ! oCol.sWidthOrig ) {
				// Width attribute
				oCol.sWidthOrig = th.attr('width') || null;
		
				// Style attribute
				var t = (th.attr('style') || '').match(/width:\s*(\d+[pxem%]+)/);
				if ( t ) {
					oCol.sWidthOrig = t[1];
				}
			}
		
			/* User specified column options */
			if ( oOptions !== undefined && oOptions !== null )
			{
				// Backwards compatibility
				_fnCompatCols( oOptions );
		
				// Map camel case parameters to their Hungarian counterparts
				_fnCamelToHungarian( DataTable.defaults.column, oOptions );
		
				/* Backwards compatibility for mDataProp */
				if ( oOptions.mDataProp !== undefined && !oOptions.mData )
				{
					oOptions.mData = oOptions.mDataProp;
				}
		
				if ( oOptions.sType )
				{
					oCol._sManualType = oOptions.sType;
				}
		
				// `class` is a reserved word in Javascript, so we need to provide
				// the ability to use a valid name for the camel case input
				if ( oOptions.className && ! oOptions.sClass )
				{
					oOptions.sClass = oOptions.className;
				}
				if ( oOptions.sClass ) {
					th.addClass( oOptions.sClass );
				}
		
				$.extend( oCol, oOptions );
				_fnMap( oCol, oOptions, "sWidth", "sWidthOrig" );
		
				/* iDataSort to be applied (backwards compatibility), but aDataSort will take
				 * priority if defined
				 */
				if ( oOptions.iDataSort !== undefined )
				{
					oCol.aDataSort = [ oOptions.iDataSort ];
				}
				_fnMap( oCol, oOptions, "aDataSort" );
			}
		
			/* Cache the data get and set functions for speed */
			var mDataSrc = oCol.mData;
			var mData = _fnGetObjectDataFn( mDataSrc );
			var mRender = oCol.mRender ? _fnGetObjectDataFn( oCol.mRender ) : null;
		
			var attrTest = function( src ) {
				return typeof src === 'string' && src.indexOf('@') !== -1;
			};
			oCol._bAttrSrc = $.isPlainObject( mDataSrc ) && (
				attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter)
			);
			oCol._setter = null;
		
			oCol.fnGetData = function (rowData, type, meta) {
				var innerData = mData( rowData, type, undefined, meta );
		
				return mRender && type ?
					mRender( innerData, type, rowData, meta ) :
					innerData;
			};
			oCol.fnSetData = function ( rowData, val, meta ) {
				return _fnSetObjectDataFn( mDataSrc )( rowData, val, meta );
			};
		
			// Indicate if DataTables should read DOM data as an object or array
			// Used in _fnGetRowElements
			if ( typeof mDataSrc !== 'number' ) {
				oSettings._rowReadObject = true;
			}
		
			/* Feature sorting overrides column specific when off */
			if ( !oSettings.oFeatures.bSort )
			{
				oCol.bSortable = false;
				th.addClass( oClasses.sSortableNone ); // Have to add class here as order event isn't called
			}
		
			/* Check that the class assignment is correct for sorting */
			var bAsc = $.inArray('asc', oCol.asSorting) !== -1;
			var bDesc = $.inArray('desc', oCol.asSorting) !== -1;
			if ( !oCol.bSortable || (!bAsc && !bDesc) )
			{
				oCol.sSortingClass = oClasses.sSortableNone;
				oCol.sSortingClassJUI = "";
			}
			else if ( bAsc && !bDesc )
			{
				oCol.sSortingClass = oClasses.sSortableAsc;
				oCol.sSortingClassJUI = oClasses.sSortJUIAscAllowed;
			}
			else if ( !bAsc && bDesc )
			{
				oCol.sSortingClass = oClasses.sSortableDesc;
				oCol.sSortingClassJUI = oClasses.sSortJUIDescAllowed;
			}
			else
			{
				oCol.sSortingClass = oClasses.sSortable;
				oCol.sSortingClassJUI = oClasses.sSortJUI;
			}
		}
		
		
		/**
		 * Adjust the table column widths for new data. Note: you would probably want to
		 * do a redraw after calling this function!
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnAdjustColumnSizing ( settings )
		{
			/* Not interested in doing column width calculation if auto-width is disabled */
			if ( settings.oFeatures.bAutoWidth !== false )
			{
				var columns = settings.aoColumns;
		
				_fnCalculateColumnWidths( settings );
				for ( var i=0 , iLen=columns.length ; i<iLen ; i++ )
				{
					columns[i].nTh.style.width = columns[i].sWidth;
				}
			}
		
			var scroll = settings.oScroll;
			if ( scroll.sY !== '' || scroll.sX !== '')
			{
				_fnScrollDraw( settings );
			}
		
			_fnCallbackFire( settings, null, 'column-sizing', [settings] );
		}
		
		
		/**
		 * Covert the index of a visible column to the index in the data array (take account
		 * of hidden columns)
		 *  @param {object} oSettings dataTables settings object
		 *  @param {int} iMatch Visible column index to lookup
		 *  @returns {int} i the data index
		 *  @memberof DataTable#oApi
		 */
		function _fnVisibleToColumnIndex( oSettings, iMatch )
		{
			var aiVis = _fnGetColumns( oSettings, 'bVisible' );
		
			return typeof aiVis[iMatch] === 'number' ?
				aiVis[iMatch] :
				null;
		}
		
		
		/**
		 * Covert the index of an index in the data array and convert it to the visible
		 *   column index (take account of hidden columns)
		 *  @param {int} iMatch Column index to lookup
		 *  @param {object} oSettings dataTables settings object
		 *  @returns {int} i the data index
		 *  @memberof DataTable#oApi
		 */
		function _fnColumnIndexToVisible( oSettings, iMatch )
		{
			var aiVis = _fnGetColumns( oSettings, 'bVisible' );
			var iPos = $.inArray( iMatch, aiVis );
		
			return iPos !== -1 ? iPos : null;
		}
		
		
		/**
		 * Get the number of visible columns
		 *  @param {object} oSettings dataTables settings object
		 *  @returns {int} i the number of visible columns
		 *  @memberof DataTable#oApi
		 */
		function _fnVisbleColumns( oSettings )
		{
			var vis = 0;
		
			// No reduce in IE8, use a loop for now
			$.each( oSettings.aoColumns, function ( i, col ) {
				if ( col.bVisible && $(col.nTh).css('display') !== 'none' ) {
					vis++;
				}
			} );
		
			return vis;
		}
		
		
		/**
		 * Get an array of column indexes that match a given property
		 *  @param {object} oSettings dataTables settings object
		 *  @param {string} sParam Parameter in aoColumns to look for - typically
		 *    bVisible or bSearchable
		 *  @returns {array} Array of indexes with matched properties
		 *  @memberof DataTable#oApi
		 */
		function _fnGetColumns( oSettings, sParam )
		{
			var a = [];
		
			$.map( oSettings.aoColumns, function(val, i) {
				if ( val[sParam] ) {
					a.push( i );
				}
			} );
		
			return a;
		}
		
		
		/**
		 * Calculate the 'type' of a column
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnColumnTypes ( settings )
		{
			var columns = settings.aoColumns;
			var data = settings.aoData;
			var types = DataTable.ext.type.detect;
			var i, ien, j, jen, k, ken;
			var col, cell, detectedType, cache;
		
			// For each column, spin over the 
			for ( i=0, ien=columns.length ; i<ien ; i++ ) {
				col = columns[i];
				cache = [];
		
				if ( ! col.sType && col._sManualType ) {
					col.sType = col._sManualType;
				}
				else if ( ! col.sType ) {
					for ( j=0, jen=types.length ; j<jen ; j++ ) {
						for ( k=0, ken=data.length ; k<ken ; k++ ) {
							// Use a cache array so we only need to get the type data
							// from the formatter once (when using multiple detectors)
							if ( cache[k] === undefined ) {
								cache[k] = _fnGetCellData( settings, k, i, 'type' );
							}
		
							detectedType = types[j]( cache[k], settings );
		
							// If null, then this type can't apply to this column, so
							// rather than testing all cells, break out. There is an
							// exception for the last type which is `html`. We need to
							// scan all rows since it is possible to mix string and HTML
							// types
							if ( ! detectedType && j !== types.length-1 ) {
								break;
							}
		
							// Only a single match is needed for html type since it is
							// bottom of the pile and very similar to string
							if ( detectedType === 'html' ) {
								break;
							}
						}
		
						// Type is valid for all data points in the column - use this
						// type
						if ( detectedType ) {
							col.sType = detectedType;
							break;
						}
					}
		
					// Fall back - if no type was detected, always use string
					if ( ! col.sType ) {
						col.sType = 'string';
					}
				}
			}
		}
		
		
		/**
		 * Take the column definitions and static columns arrays and calculate how
		 * they relate to column indexes. The callback function will then apply the
		 * definition found for a column to a suitable configuration object.
		 *  @param {object} oSettings dataTables settings object
		 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
		 *  @param {array} aoCols The aoColumns array that defines columns individually
		 *  @param {function} fn Callback function - takes two parameters, the calculated
		 *    column index and the definition for that column.
		 *  @memberof DataTable#oApi
		 */
		function _fnApplyColumnDefs( oSettings, aoColDefs, aoCols, fn )
		{
			var i, iLen, j, jLen, k, kLen, def;
			var columns = oSettings.aoColumns;
		
			// Column definitions with aTargets
			if ( aoColDefs )
			{
				/* Loop over the definitions array - loop in reverse so first instance has priority */
				for ( i=aoColDefs.length-1 ; i>=0 ; i-- )
				{
					def = aoColDefs[i];
		
					/* Each definition can target multiple columns, as it is an array */
					var aTargets = def.targets !== undefined ?
						def.targets :
						def.aTargets;
		
					if ( ! $.isArray( aTargets ) )
					{
						aTargets = [ aTargets ];
					}
		
					for ( j=0, jLen=aTargets.length ; j<jLen ; j++ )
					{
						if ( typeof aTargets[j] === 'number' && aTargets[j] >= 0 )
						{
							/* Add columns that we don't yet know about */
							while( columns.length <= aTargets[j] )
							{
								_fnAddColumn( oSettings );
							}
		
							/* Integer, basic index */
							fn( aTargets[j], def );
						}
						else if ( typeof aTargets[j] === 'number' && aTargets[j] < 0 )
						{
							/* Negative integer, right to left column counting */
							fn( columns.length+aTargets[j], def );
						}
						else if ( typeof aTargets[j] === 'string' )
						{
							/* Class name matching on TH element */
							for ( k=0, kLen=columns.length ; k<kLen ; k++ )
							{
								if ( aTargets[j] == "_all" ||
								     $(columns[k].nTh).hasClass( aTargets[j] ) )
								{
									fn( k, def );
								}
							}
						}
					}
				}
			}
		
			// Statically defined columns array
			if ( aoCols )
			{
				for ( i=0, iLen=aoCols.length ; i<iLen ; i++ )
				{
					fn( i, aoCols[i] );
				}
			}
		}
		
		/**
		 * Add a data array to the table, creating DOM node etc. This is the parallel to
		 * _fnGatherData, but for adding rows from a Javascript source, rather than a
		 * DOM source.
		 *  @param {object} oSettings dataTables settings object
		 *  @param {array} aData data array to be added
		 *  @param {node} [nTr] TR element to add to the table - optional. If not given,
		 *    DataTables will create a row automatically
		 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
		 *    if nTr is.
		 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
		 *  @memberof DataTable#oApi
		 */
		function _fnAddData ( oSettings, aDataIn, nTr, anTds )
		{
			/* Create the object for storing information about this new row */
			var iRow = oSettings.aoData.length;
			var oData = $.extend( true, {}, DataTable.models.oRow, {
				src: nTr ? 'dom' : 'data',
				idx: iRow
			} );
		
			oData._aData = aDataIn;
			oSettings.aoData.push( oData );
		
			/* Create the cells */
			var nTd, sThisType;
			var columns = oSettings.aoColumns;
		
			// Invalidate the column types as the new data needs to be revalidated
			for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
			{
				columns[i].sType = null;
			}
		
			/* Add to the display array */
			oSettings.aiDisplayMaster.push( iRow );
		
			var id = oSettings.rowIdFn( aDataIn );
			if ( id !== undefined ) {
				oSettings.aIds[ id ] = oData;
			}
		
			/* Create the DOM information, or register it if already present */
			if ( nTr || ! oSettings.oFeatures.bDeferRender )
			{
				_fnCreateTr( oSettings, iRow, nTr, anTds );
			}
		
			return iRow;
		}
		
		
		/**
		 * Add one or more TR elements to the table. Generally we'd expect to
		 * use this for reading data from a DOM sourced table, but it could be
		 * used for an TR element. Note that if a TR is given, it is used (i.e.
		 * it is not cloned).
		 *  @param {object} settings dataTables settings object
		 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
		 *  @returns {array} Array of indexes for the added rows
		 *  @memberof DataTable#oApi
		 */
		function _fnAddTr( settings, trs )
		{
			var row;
		
			// Allow an individual node to be passed in
			if ( ! (trs instanceof $) ) {
				trs = $(trs);
			}
		
			return trs.map( function (i, el) {
				row = _fnGetRowElements( settings, el );
				return _fnAddData( settings, row.data, el, row.cells );
			} );
		}
		
		
		/**
		 * Take a TR element and convert it to an index in aoData
		 *  @param {object} oSettings dataTables settings object
		 *  @param {node} n the TR element to find
		 *  @returns {int} index if the node is found, null if not
		 *  @memberof DataTable#oApi
		 */
		function _fnNodeToDataIndex( oSettings, n )
		{
			return (n._DT_RowIndex!==undefined) ? n._DT_RowIndex : null;
		}
		
		
		/**
		 * Take a TD element and convert it into a column data index (not the visible index)
		 *  @param {object} oSettings dataTables settings object
		 *  @param {int} iRow The row number the TD/TH can be found in
		 *  @param {node} n The TD/TH element to find
		 *  @returns {int} index if the node is found, -1 if not
		 *  @memberof DataTable#oApi
		 */
		function _fnNodeToColumnIndex( oSettings, iRow, n )
		{
			return $.inArray( n, oSettings.aoData[ iRow ].anCells );
		}
		
		
		/**
		 * Get the data for a given cell from the internal cache, taking into account data mapping
		 *  @param {object} settings dataTables settings object
		 *  @param {int} rowIdx aoData row id
		 *  @param {int} colIdx Column index
		 *  @param {string} type data get type ('display', 'type' 'filter' 'sort')
		 *  @returns {*} Cell data
		 *  @memberof DataTable#oApi
		 */
		function _fnGetCellData( settings, rowIdx, colIdx, type )
		{
			var draw           = settings.iDraw;
			var col            = settings.aoColumns[colIdx];
			var rowData        = settings.aoData[rowIdx]._aData;
			var defaultContent = col.sDefaultContent;
			var cellData       = col.fnGetData( rowData, type, {
				settings: settings,
				row:      rowIdx,
				col:      colIdx
			} );
		
			if ( cellData === undefined ) {
				if ( settings.iDrawError != draw && defaultContent === null ) {
					_fnLog( settings, 0, "Requested unknown parameter "+
						(typeof col.mData=='function' ? '{function}' : "'"+col.mData+"'")+
						" for row "+rowIdx+", column "+colIdx, 4 );
					settings.iDrawError = draw;
				}
				return defaultContent;
			}
		
			// When the data source is null and a specific data type is requested (i.e.
			// not the original data), we can use default column data
			if ( (cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined ) {
				cellData = defaultContent;
			}
			else if ( typeof cellData === 'function' ) {
				// If the data source is a function, then we run it and use the return,
				// executing in the scope of the data object (for instances)
				return cellData.call( rowData );
			}
		
			if ( cellData === null && type == 'display' ) {
				return '';
			}
			return cellData;
		}
		
		
		/**
		 * Set the value for a specific cell, into the internal data cache
		 *  @param {object} settings dataTables settings object
		 *  @param {int} rowIdx aoData row id
		 *  @param {int} colIdx Column index
		 *  @param {*} val Value to set
		 *  @memberof DataTable#oApi
		 */
		function _fnSetCellData( settings, rowIdx, colIdx, val )
		{
			var col     = settings.aoColumns[colIdx];
			var rowData = settings.aoData[rowIdx]._aData;
		
			col.fnSetData( rowData, val, {
				settings: settings,
				row:      rowIdx,
				col:      colIdx
			}  );
		}
		
		
		// Private variable that is used to match action syntax in the data property object
		var __reArray = /\[.*?\]$/;
		var __reFn = /\(\)$/;
		
		/**
		 * Split string on periods, taking into account escaped periods
		 * @param  {string} str String to split
		 * @return {array} Split string
		 */
		function _fnSplitObjNotation( str )
		{
			return $.map( str.match(/(\\.|[^\.])+/g) || [''], function ( s ) {
				return s.replace(/\\\./g, '.');
			} );
		}
		
		
		/**
		 * Return a function that can be used to get data from a source object, taking
		 * into account the ability to use nested objects as a source
		 *  @param {string|int|function} mSource The data source for the object
		 *  @returns {function} Data get function
		 *  @memberof DataTable#oApi
		 */
		function _fnGetObjectDataFn( mSource )
		{
			if ( $.isPlainObject( mSource ) )
			{
				/* Build an object of get functions, and wrap them in a single call */
				var o = {};
				$.each( mSource, function (key, val) {
					if ( val ) {
						o[key] = _fnGetObjectDataFn( val );
					}
				} );
		
				return function (data, type, row, meta) {
					var t = o[type] || o._;
					return t !== undefined ?
						t(data, type, row, meta) :
						data;
				};
			}
			else if ( mSource === null )
			{
				/* Give an empty string for rendering / sorting etc */
				return function (data) { // type, row and meta also passed, but not used
					return data;
				};
			}
			else if ( typeof mSource === 'function' )
			{
				return function (data, type, row, meta) {
					return mSource( data, type, row, meta );
				};
			}
			else if ( typeof mSource === 'string' && (mSource.indexOf('.') !== -1 ||
				      mSource.indexOf('[') !== -1 || mSource.indexOf('(') !== -1) )
			{
				/* If there is a . in the source string then the data source is in a
				 * nested object so we loop over the data for each level to get the next
				 * level down. On each loop we test for undefined, and if found immediately
				 * return. This allows entire objects to be missing and sDefaultContent to
				 * be used if defined, rather than throwing an error
				 */
				var fetchData = function (data, type, src) {
					var arrayNotation, funcNotation, out, innerSrc;
		
					if ( src !== "" )
					{
						var a = _fnSplitObjNotation( src );
		
						for ( var i=0, iLen=a.length ; i<iLen ; i++ )
						{
							// Check if we are dealing with special notation
							arrayNotation = a[i].match(__reArray);
							funcNotation = a[i].match(__reFn);
		
							if ( arrayNotation )
							{
								// Array notation
								a[i] = a[i].replace(__reArray, '');
		
								// Condition allows simply [] to be passed in
								if ( a[i] !== "" ) {
									data = data[ a[i] ];
								}
								out = [];
		
								// Get the remainder of the nested object to get
								a.splice( 0, i+1 );
								innerSrc = a.join('.');
		
								// Traverse each entry in the array getting the properties requested
								if ( $.isArray( data ) ) {
									for ( var j=0, jLen=data.length ; j<jLen ; j++ ) {
										out.push( fetchData( data[j], type, innerSrc ) );
									}
								}
		
								// If a string is given in between the array notation indicators, that
								// is used to join the strings together, otherwise an array is returned
								var join = arrayNotation[0].substring(1, arrayNotation[0].length-1);
								data = (join==="") ? out : out.join(join);
		
								// The inner call to fetchData has already traversed through the remainder
								// of the source requested, so we exit from the loop
								break;
							}
							else if ( funcNotation )
							{
								// Function call
								a[i] = a[i].replace(__reFn, '');
								data = data[ a[i] ]();
								continue;
							}
		
							if ( data === null || data[ a[i] ] === undefined )
							{
								return undefined;
							}
							data = data[ a[i] ];
						}
					}
		
					return data;
				};
		
				return function (data, type) { // row and meta also passed, but not used
					return fetchData( data, type, mSource );
				};
			}
			else
			{
				/* Array or flat object mapping */
				return function (data, type) { // row and meta also passed, but not used
					return data[mSource];
				};
			}
		}
		
		
		/**
		 * Return a function that can be used to set data from a source object, taking
		 * into account the ability to use nested objects as a source
		 *  @param {string|int|function} mSource The data source for the object
		 *  @returns {function} Data set function
		 *  @memberof DataTable#oApi
		 */
		function _fnSetObjectDataFn( mSource )
		{
			if ( $.isPlainObject( mSource ) )
			{
				/* Unlike get, only the underscore (global) option is used for for
				 * setting data since we don't know the type here. This is why an object
				 * option is not documented for `mData` (which is read/write), but it is
				 * for `mRender` which is read only.
				 */
				return _fnSetObjectDataFn( mSource._ );
			}
			else if ( mSource === null )
			{
				/* Nothing to do when the data source is null */
				return function () {};
			}
			else if ( typeof mSource === 'function' )
			{
				return function (data, val, meta) {
					mSource( data, 'set', val, meta );
				};
			}
			else if ( typeof mSource === 'string' && (mSource.indexOf('.') !== -1 ||
				      mSource.indexOf('[') !== -1 || mSource.indexOf('(') !== -1) )
			{
				/* Like the get, we need to get data from a nested object */
				var setData = function (data, val, src) {
					var a = _fnSplitObjNotation( src ), b;
					var aLast = a[a.length-1];
					var arrayNotation, funcNotation, o, innerSrc;
		
					for ( var i=0, iLen=a.length-1 ; i<iLen ; i++ )
					{
						// Check if we are dealing with an array notation request
						arrayNotation = a[i].match(__reArray);
						funcNotation = a[i].match(__reFn);
		
						if ( arrayNotation )
						{
							a[i] = a[i].replace(__reArray, '');
							data[ a[i] ] = [];
		
							// Get the remainder of the nested object to set so we can recurse
							b = a.slice();
							b.splice( 0, i+1 );
							innerSrc = b.join('.');
		
							// Traverse each entry in the array setting the properties requested
							if ( $.isArray( val ) )
							{
								for ( var j=0, jLen=val.length ; j<jLen ; j++ )
								{
									o = {};
									setData( o, val[j], innerSrc );
									data[ a[i] ].push( o );
								}
							}
							else
							{
								// We've been asked to save data to an array, but it
								// isn't array data to be saved. Best that can be done
								// is to just save the value.
								data[ a[i] ] = val;
							}
		
							// The inner call to setData has already traversed through the remainder
							// of the source and has set the data, thus we can exit here
							return;
						}
						else if ( funcNotation )
						{
							// Function call
							a[i] = a[i].replace(__reFn, '');
							data = data[ a[i] ]( val );
						}
		
						// If the nested object doesn't currently exist - since we are
						// trying to set the value - create it
						if ( data[ a[i] ] === null || data[ a[i] ] === undefined )
						{
							data[ a[i] ] = {};
						}
						data = data[ a[i] ];
					}
		
					// Last item in the input - i.e, the actual set
					if ( aLast.match(__reFn ) )
					{
						// Function call
						data = data[ aLast.replace(__reFn, '') ]( val );
					}
					else
					{
						// If array notation is used, we just want to strip it and use the property name
						// and assign the value. If it isn't used, then we get the result we want anyway
						data[ aLast.replace(__reArray, '') ] = val;
					}
				};
		
				return function (data, val) { // meta is also passed in, but not used
					return setData( data, val, mSource );
				};
			}
			else
			{
				/* Array or flat object mapping */
				return function (data, val) { // meta is also passed in, but not used
					data[mSource] = val;
				};
			}
		}
		
		
		/**
		 * Return an array with the full table data
		 *  @param {object} oSettings dataTables settings object
		 *  @returns array {array} aData Master data array
		 *  @memberof DataTable#oApi
		 */
		function _fnGetDataMaster ( settings )
		{
			return _pluck( settings.aoData, '_aData' );
		}
		
		
		/**
		 * Nuke the table
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnClearTable( settings )
		{
			settings.aoData.length = 0;
			settings.aiDisplayMaster.length = 0;
			settings.aiDisplay.length = 0;
			settings.aIds = {};
		}
		
		
		 /**
		 * Take an array of integers (index array) and remove a target integer (value - not
		 * the key!)
		 *  @param {array} a Index array to target
		 *  @param {int} iTarget value to find
		 *  @memberof DataTable#oApi
		 */
		function _fnDeleteIndex( a, iTarget, splice )
		{
			var iTargetIndex = -1;
		
			for ( var i=0, iLen=a.length ; i<iLen ; i++ )
			{
				if ( a[i] == iTarget )
				{
					iTargetIndex = i;
				}
				else if ( a[i] > iTarget )
				{
					a[i]--;
				}
			}
		
			if ( iTargetIndex != -1 && splice === undefined )
			{
				a.splice( iTargetIndex, 1 );
			}
		}
		
		
		/**
		 * Mark cached data as invalid such that a re-read of the data will occur when
		 * the cached data is next requested. Also update from the data source object.
		 *
		 * @param {object} settings DataTables settings object
		 * @param {int}    rowIdx   Row index to invalidate
		 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
		 *     or 'data'
		 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
		 *     row will be invalidated
		 * @memberof DataTable#oApi
		 *
		 * @todo For the modularisation of v1.11 this will need to become a callback, so
		 *   the sort and filter methods can subscribe to it. That will required
		 *   initialisation options for sorting, which is why it is not already baked in
		 */
		function _fnInvalidate( settings, rowIdx, src, colIdx )
		{
			var row = settings.aoData[ rowIdx ];
			var i, ien;
			var cellWrite = function ( cell, col ) {
				// This is very frustrating, but in IE if you just write directly
				// to innerHTML, and elements that are overwritten are GC'ed,
				// even if there is a reference to them elsewhere
				while ( cell.childNodes.length ) {
					cell.removeChild( cell.firstChild );
				}
		
				cell.innerHTML = _fnGetCellData( settings, rowIdx, col, 'display' );
			};
		
			// Are we reading last data from DOM or the data object?
			if ( src === 'dom' || ((! src || src === 'auto') && row.src === 'dom') ) {
				// Read the data from the DOM
				row._aData = _fnGetRowElements(
						settings, row, colIdx, colIdx === undefined ? undefined : row._aData
					)
					.data;
			}
			else {
				// Reading from data object, update the DOM
				var cells = row.anCells;
		
				if ( cells ) {
					if ( colIdx !== undefined ) {
						cellWrite( cells[colIdx], colIdx );
					}
					else {
						for ( i=0, ien=cells.length ; i<ien ; i++ ) {
							cellWrite( cells[i], i );
						}
					}
				}
			}
		
			// For both row and cell invalidation, the cached data for sorting and
			// filtering is nulled out
			row._aSortData = null;
			row._aFilterData = null;
		
			// Invalidate the type for a specific column (if given) or all columns since
			// the data might have changed
			var cols = settings.aoColumns;
			if ( colIdx !== undefined ) {
				cols[ colIdx ].sType = null;
			}
			else {
				for ( i=0, ien=cols.length ; i<ien ; i++ ) {
					cols[i].sType = null;
				}
		
				// Update DataTables special `DT_*` attributes for the row
				_fnRowAttributes( settings, row );
			}
		}
		
		
		/**
		 * Build a data source object from an HTML row, reading the contents of the
		 * cells that are in the row.
		 *
		 * @param {object} settings DataTables settings object
		 * @param {node|object} TR element from which to read data or existing row
		 *   object from which to re-read the data from the cells
		 * @param {int} [colIdx] Optional column index
		 * @param {array|object} [d] Data source object. If `colIdx` is given then this
		 *   parameter should also be given and will be used to write the data into.
		 *   Only the column in question will be written
		 * @returns {object} Object with two parameters: `data` the data read, in
		 *   document order, and `cells` and array of nodes (they can be useful to the
		 *   caller, so rather than needing a second traversal to get them, just return
		 *   them from here).
		 * @memberof DataTable#oApi
		 */
		function _fnGetRowElements( settings, row, colIdx, d )
		{
			var
				tds = [],
				td = row.firstChild,
				name, col, o, i=0, contents,
				columns = settings.aoColumns,
				objectRead = settings._rowReadObject;
		
			// Allow the data object to be passed in, or construct
			d = d !== undefined ?
				d :
				objectRead ?
					{} :
					[];
		
			var attr = function ( str, td  ) {
				if ( typeof str === 'string' ) {
					var idx = str.indexOf('@');
		
					if ( idx !== -1 ) {
						var attr = str.substring( idx+1 );
						var setter = _fnSetObjectDataFn( str );
						setter( d, td.getAttribute( attr ) );
					}
				}
			};
		
			// Read data from a cell and store into the data object
			var cellProcess = function ( cell ) {
				if ( colIdx === undefined || colIdx === i ) {
					col = columns[i];
					contents = $.trim(cell.innerHTML);
		
					if ( col && col._bAttrSrc ) {
						var setter = _fnSetObjectDataFn( col.mData._ );
						setter( d, contents );
		
						attr( col.mData.sort, cell );
						attr( col.mData.type, cell );
						attr( col.mData.filter, cell );
					}
					else {
						// Depending on the `data` option for the columns the data can
						// be read to either an object or an array.
						if ( objectRead ) {
							if ( ! col._setter ) {
								// Cache the setter function
								col._setter = _fnSetObjectDataFn( col.mData );
							}
							col._setter( d, contents );
						}
						else {
							d[i] = contents;
						}
					}
				}
		
				i++;
			};
		
			if ( td ) {
				// `tr` element was passed in
				while ( td ) {
					name = td.nodeName.toUpperCase();
		
					if ( name == "TD" || name == "TH" ) {
						cellProcess( td );
						tds.push( td );
					}
		
					td = td.nextSibling;
				}
			}
			else {
				// Existing row object passed in
				tds = row.anCells;
		
				for ( var j=0, jen=tds.length ; j<jen ; j++ ) {
					cellProcess( tds[j] );
				}
			}
		
			// Read the ID from the DOM if present
			var rowNode = row.firstChild ? row : row.nTr;
		
			if ( rowNode ) {
				var id = rowNode.getAttribute( 'id' );
		
				if ( id ) {
					_fnSetObjectDataFn( settings.rowId )( d, id );
				}
			}
		
			return {
				data: d,
				cells: tds
			};
		}
		/**
		 * Create a new TR element (and it's TD children) for a row
		 *  @param {object} oSettings dataTables settings object
		 *  @param {int} iRow Row to consider
		 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
		 *    DataTables will create a row automatically
		 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
		 *    if nTr is.
		 *  @memberof DataTable#oApi
		 */
		function _fnCreateTr ( oSettings, iRow, nTrIn, anTds )
		{
			var
				row = oSettings.aoData[iRow],
				rowData = row._aData,
				cells = [],
				nTr, nTd, oCol,
				i, iLen;
		
			if ( row.nTr === null )
			{
				nTr = nTrIn || document.createElement('tr');
		
				row.nTr = nTr;
				row.anCells = cells;
		
				/* Use a private property on the node to allow reserve mapping from the node
				 * to the aoData array for fast look up
				 */
				nTr._DT_RowIndex = iRow;
		
				/* Special parameters can be given by the data source to be used on the row */
				_fnRowAttributes( oSettings, row );
		
				/* Process each column */
				for ( i=0, iLen=oSettings.aoColumns.length ; i<iLen ; i++ )
				{
					oCol = oSettings.aoColumns[i];
		
					nTd = nTrIn ? anTds[i] : document.createElement( oCol.sCellType );
					nTd._DT_CellIndex = {
						row: iRow,
						column: i
					};
					
					cells.push( nTd );
		
					// Need to create the HTML if new, or if a rendering function is defined
					if ( (!nTrIn || oCol.mRender || oCol.mData !== i) &&
						 (!$.isPlainObject(oCol.mData) || oCol.mData._ !== i+'.display')
					) {
						nTd.innerHTML = _fnGetCellData( oSettings, iRow, i, 'display' );
					}
		
					/* Add user defined class */
					if ( oCol.sClass )
					{
						nTd.className += ' '+oCol.sClass;
					}
		
					// Visibility - add or remove as required
					if ( oCol.bVisible && ! nTrIn )
					{
						nTr.appendChild( nTd );
					}
					else if ( ! oCol.bVisible && nTrIn )
					{
						nTd.parentNode.removeChild( nTd );
					}
		
					if ( oCol.fnCreatedCell )
					{
						oCol.fnCreatedCell.call( oSettings.oInstance,
							nTd, _fnGetCellData( oSettings, iRow, i ), rowData, iRow, i
						);
					}
				}
		
				_fnCallbackFire( oSettings, 'aoRowCreatedCallback', null, [nTr, rowData, iRow] );
			}
		
			// Remove once webkit bug 131819 and Chromium bug 365619 have been resolved
			// and deployed
			row.nTr.setAttribute( 'role', 'row' );
		}
		
		
		/**
		 * Add attributes to a row based on the special `DT_*` parameters in a data
		 * source object.
		 *  @param {object} settings DataTables settings object
		 *  @param {object} DataTables row object for the row to be modified
		 *  @memberof DataTable#oApi
		 */
		function _fnRowAttributes( settings, row )
		{
			var tr = row.nTr;
			var data = row._aData;
		
			if ( tr ) {
				var id = settings.rowIdFn( data );
		
				if ( id ) {
					tr.id = id;
				}
		
				if ( data.DT_RowClass ) {
					// Remove any classes added by DT_RowClass before
					var a = data.DT_RowClass.split(' ');
					row.__rowc = row.__rowc ?
						_unique( row.__rowc.concat( a ) ) :
						a;
		
					$(tr)
						.removeClass( row.__rowc.join(' ') )
						.addClass( data.DT_RowClass );
				}
		
				if ( data.DT_RowAttr ) {
					$(tr).attr( data.DT_RowAttr );
				}
		
				if ( data.DT_RowData ) {
					$(tr).data( data.DT_RowData );
				}
			}
		}
		
		
		/**
		 * Create the HTML header for the table
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnBuildHead( oSettings )
		{
			var i, ien, cell, row, column;
			var thead = oSettings.nTHead;
			var tfoot = oSettings.nTFoot;
			var createHeader = $('th, td', thead).length === 0;
			var classes = oSettings.oClasses;
			var columns = oSettings.aoColumns;
		
			if ( createHeader ) {
				row = $('<tr/>').appendTo( thead );
			}
		
			for ( i=0, ien=columns.length ; i<ien ; i++ ) {
				column = columns[i];
				cell = $( column.nTh ).addClass( column.sClass );
		
				if ( createHeader ) {
					cell.appendTo( row );
				}
		
				// 1.11 move into sorting
				if ( oSettings.oFeatures.bSort ) {
					cell.addClass( column.sSortingClass );
		
					if ( column.bSortable !== false ) {
						cell
							.attr( 'tabindex', oSettings.iTabIndex )
							.attr( 'aria-controls', oSettings.sTableId );
		
						_fnSortAttachListener( oSettings, column.nTh, i );
					}
				}
		
				if ( column.sTitle != cell[0].innerHTML ) {
					cell.html( column.sTitle );
				}
		
				_fnRenderer( oSettings, 'header' )(
					oSettings, cell, column, classes
				);
			}
		
			if ( createHeader ) {
				_fnDetectHeader( oSettings.aoHeader, thead );
			}
			
			/* ARIA role for the rows */
		 	$(thead).find('>tr').attr('role', 'row');
		
			/* Deal with the footer - add classes if required */
			$(thead).find('>tr>th, >tr>td').addClass( classes.sHeaderTH );
			$(tfoot).find('>tr>th, >tr>td').addClass( classes.sFooterTH );
		
			// Cache the footer cells. Note that we only take the cells from the first
			// row in the footer. If there is more than one row the user wants to
			// interact with, they need to use the table().foot() method. Note also this
			// allows cells to be used for multiple columns using colspan
			if ( tfoot !== null ) {
				var cells = oSettings.aoFooter[0];
		
				for ( i=0, ien=cells.length ; i<ien ; i++ ) {
					column = columns[i];
					column.nTf = cells[i].cell;
		
					if ( column.sClass ) {
						$(column.nTf).addClass( column.sClass );
					}
				}
			}
		}
		
		
		/**
		 * Draw the header (or footer) element based on the column visibility states. The
		 * methodology here is to use the layout array from _fnDetectHeader, modified for
		 * the instantaneous column visibility, to construct the new layout. The grid is
		 * traversed over cell at a time in a rows x columns grid fashion, although each
		 * cell insert can cover multiple elements in the grid - which is tracks using the
		 * aApplied array. Cell inserts in the grid will only occur where there isn't
		 * already a cell in that position.
		 *  @param {object} oSettings dataTables settings object
		 *  @param array {objects} aoSource Layout array from _fnDetectHeader
		 *  @param {boolean} [bIncludeHidden=false] If true then include the hidden columns in the calc,
		 *  @memberof DataTable#oApi
		 */
		function _fnDrawHead( oSettings, aoSource, bIncludeHidden )
		{
			var i, iLen, j, jLen, k, kLen, n, nLocalTr;
			var aoLocal = [];
			var aApplied = [];
			var iColumns = oSettings.aoColumns.length;
			var iRowspan, iColspan;
		
			if ( ! aoSource )
			{
				return;
			}
		
			if (  bIncludeHidden === undefined )
			{
				bIncludeHidden = false;
			}
		
			/* Make a copy of the master layout array, but without the visible columns in it */
			for ( i=0, iLen=aoSource.length ; i<iLen ; i++ )
			{
				aoLocal[i] = aoSource[i].slice();
				aoLocal[i].nTr = aoSource[i].nTr;
		
				/* Remove any columns which are currently hidden */
				for ( j=iColumns-1 ; j>=0 ; j-- )
				{
					if ( !oSettings.aoColumns[j].bVisible && !bIncludeHidden )
					{
						aoLocal[i].splice( j, 1 );
					}
				}
		
				/* Prep the applied array - it needs an element for each row */
				aApplied.push( [] );
			}
		
			for ( i=0, iLen=aoLocal.length ; i<iLen ; i++ )
			{
				nLocalTr = aoLocal[i].nTr;
		
				/* All cells are going to be replaced, so empty out the row */
				if ( nLocalTr )
				{
					while( (n = nLocalTr.firstChild) )
					{
						nLocalTr.removeChild( n );
					}
				}
		
				for ( j=0, jLen=aoLocal[i].length ; j<jLen ; j++ )
				{
					iRowspan = 1;
					iColspan = 1;
		
					/* Check to see if there is already a cell (row/colspan) covering our target
					 * insert point. If there is, then there is nothing to do.
					 */
					if ( aApplied[i][j] === undefined )
					{
						nLocalTr.appendChild( aoLocal[i][j].cell );
						aApplied[i][j] = 1;
		
						/* Expand the cell to cover as many rows as needed */
						while ( aoLocal[i+iRowspan] !== undefined &&
						        aoLocal[i][j].cell == aoLocal[i+iRowspan][j].cell )
						{
							aApplied[i+iRowspan][j] = 1;
							iRowspan++;
						}
		
						/* Expand the cell to cover as many columns as needed */
						while ( aoLocal[i][j+iColspan] !== undefined &&
						        aoLocal[i][j].cell == aoLocal[i][j+iColspan].cell )
						{
							/* Must update the applied array over the rows for the columns */
							for ( k=0 ; k<iRowspan ; k++ )
							{
								aApplied[i+k][j+iColspan] = 1;
							}
							iColspan++;
						}
		
						/* Do the actual expansion in the DOM */
						$(aoLocal[i][j].cell)
							.attr('rowspan', iRowspan)
							.attr('colspan', iColspan);
					}
				}
			}
		}
		
		
		/**
		 * Insert the required TR nodes into the table for display
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnDraw( oSettings )
		{
			/* Provide a pre-callback function which can be used to cancel the draw is false is returned */
			var aPreDraw = _fnCallbackFire( oSettings, 'aoPreDrawCallback', 'preDraw', [oSettings] );
			if ( $.inArray( false, aPreDraw ) !== -1 )
			{
				_fnProcessingDisplay( oSettings, false );
				return;
			}
		
			var i, iLen, n;
			var anRows = [];
			var iRowCount = 0;
			var asStripeClasses = oSettings.asStripeClasses;
			var iStripes = asStripeClasses.length;
			var iOpenRows = oSettings.aoOpenRows.length;
			var oLang = oSettings.oLanguage;
			var iInitDisplayStart = oSettings.iInitDisplayStart;
			var bServerSide = _fnDataSource( oSettings ) == 'ssp';
			var aiDisplay = oSettings.aiDisplay;
		
			oSettings.bDrawing = true;
		
			/* Check and see if we have an initial draw position from state saving */
			if ( iInitDisplayStart !== undefined && iInitDisplayStart !== -1 )
			{
				oSettings._iDisplayStart = bServerSide ?
					iInitDisplayStart :
					iInitDisplayStart >= oSettings.fnRecordsDisplay() ?
						0 :
						iInitDisplayStart;
		
				oSettings.iInitDisplayStart = -1;
			}
		
			var iDisplayStart = oSettings._iDisplayStart;
			var iDisplayEnd = oSettings.fnDisplayEnd();
		
			/* Server-side processing draw intercept */
			if ( oSettings.bDeferLoading )
			{
				oSettings.bDeferLoading = false;
				oSettings.iDraw++;
				_fnProcessingDisplay( oSettings, false );
			}
			else if ( !bServerSide )
			{
				oSettings.iDraw++;
			}
			else if ( !oSettings.bDestroying && !_fnAjaxUpdate( oSettings ) )
			{
				return;
			}
		
			if ( aiDisplay.length !== 0 )
			{
				var iStart = bServerSide ? 0 : iDisplayStart;
				var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;
		
				for ( var j=iStart ; j<iEnd ; j++ )
				{
					var iDataIndex = aiDisplay[j];
					var aoData = oSettings.aoData[ iDataIndex ];
					if ( aoData.nTr === null )
					{
						_fnCreateTr( oSettings, iDataIndex );
					}
		
					var nRow = aoData.nTr;
		
					/* Remove the old striping classes and then add the new one */
					if ( iStripes !== 0 )
					{
						var sStripe = asStripeClasses[ iRowCount % iStripes ];
						if ( aoData._sRowStripe != sStripe )
						{
							$(nRow).removeClass( aoData._sRowStripe ).addClass( sStripe );
							aoData._sRowStripe = sStripe;
						}
					}
		
					// Row callback functions - might want to manipulate the row
					// iRowCount and j are not currently documented. Are they at all
					// useful?
					_fnCallbackFire( oSettings, 'aoRowCallback', null,
						[nRow, aoData._aData, iRowCount, j] );
		
					anRows.push( nRow );
					iRowCount++;
				}
			}
			else
			{
				/* Table is empty - create a row with an empty message in it */
				var sZero = oLang.sZeroRecords;
				if ( oSettings.iDraw == 1 &&  _fnDataSource( oSettings ) == 'ajax' )
				{
					sZero = oLang.sLoadingRecords;
				}
				else if ( oLang.sEmptyTable && oSettings.fnRecordsTotal() === 0 )
				{
					sZero = oLang.sEmptyTable;
				}
		
				anRows[ 0 ] = $( '<tr/>', { 'class': iStripes ? asStripeClasses[0] : '' } )
					.append( $('<td />', {
						'valign':  'top',
						'colSpan': _fnVisbleColumns( oSettings ),
						'class':   oSettings.oClasses.sRowEmpty
					} ).html( sZero ) )[0];
			}
		
			/* Header and footer callbacks */
			_fnCallbackFire( oSettings, 'aoHeaderCallback', 'header', [ $(oSettings.nTHead).children('tr')[0],
				_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );
		
			_fnCallbackFire( oSettings, 'aoFooterCallback', 'footer', [ $(oSettings.nTFoot).children('tr')[0],
				_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );
		
			var body = $(oSettings.nTBody);
		
			body.children().detach();
			body.append( $(anRows) );
		
			/* Call all required callback functions for the end of a draw */
			_fnCallbackFire( oSettings, 'aoDrawCallback', 'draw', [oSettings] );
		
			/* Draw is complete, sorting and filtering must be as well */
			oSettings.bSorted = false;
			oSettings.bFiltered = false;
			oSettings.bDrawing = false;
		}
		
		
		/**
		 * Redraw the table - taking account of the various features which are enabled
		 *  @param {object} oSettings dataTables settings object
		 *  @param {boolean} [holdPosition] Keep the current paging position. By default
		 *    the paging is reset to the first page
		 *  @memberof DataTable#oApi
		 */
		function _fnReDraw( settings, holdPosition )
		{
			var
				features = settings.oFeatures,
				sort     = features.bSort,
				filter   = features.bFilter;
		
			if ( sort ) {
				_fnSort( settings );
			}
		
			if ( filter ) {
				_fnFilterComplete( settings, settings.oPreviousSearch );
			}
			else {
				// No filtering, so we want to just use the display master
				settings.aiDisplay = settings.aiDisplayMaster.slice();
			}
		
			if ( holdPosition !== true ) {
				settings._iDisplayStart = 0;
			}
		
			// Let any modules know about the draw hold position state (used by
			// scrolling internally)
			settings._drawHold = holdPosition;
		
			_fnDraw( settings );
		
			settings._drawHold = false;
		}
		
		
		/**
		 * Add the options to the page HTML for the table
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnAddOptionsHtml ( oSettings )
		{
			var classes = oSettings.oClasses;
			var table = $(oSettings.nTable);
			var holding = $('<div/>').insertBefore( table ); // Holding element for speed
			var features = oSettings.oFeatures;
		
			// All DataTables are wrapped in a div
			var insert = $('<div/>', {
				id:      oSettings.sTableId+'_wrapper',
				'class': classes.sWrapper + (oSettings.nTFoot ? '' : ' '+classes.sNoFooter)
			} );
		
			oSettings.nHolding = holding[0];
			oSettings.nTableWrapper = insert[0];
			oSettings.nTableReinsertBefore = oSettings.nTable.nextSibling;
		
			/* Loop over the user set positioning and place the elements as needed */
			var aDom = oSettings.sDom.split('');
			var featureNode, cOption, nNewNode, cNext, sAttr, j;
			for ( var i=0 ; i<aDom.length ; i++ )
			{
				featureNode = null;
				cOption = aDom[i];
		
				if ( cOption == '<' )
				{
					/* New container div */
					nNewNode = $('<div/>')[0];
		
					/* Check to see if we should append an id and/or a class name to the container */
					cNext = aDom[i+1];
					if ( cNext == "'" || cNext == '"' )
					{
						sAttr = "";
						j = 2;
						while ( aDom[i+j] != cNext )
						{
							sAttr += aDom[i+j];
							j++;
						}
		
						/* Replace jQuery UI constants @todo depreciated */
						if ( sAttr == "H" )
						{
							sAttr = classes.sJUIHeader;
						}
						else if ( sAttr == "F" )
						{
							sAttr = classes.sJUIFooter;
						}
		
						/* The attribute can be in the format of "#id.class", "#id" or "class" This logic
						 * breaks the string into parts and applies them as needed
						 */
						if ( sAttr.indexOf('.') != -1 )
						{
							var aSplit = sAttr.split('.');
							nNewNode.id = aSplit[0].substr(1, aSplit[0].length-1);
							nNewNode.className = aSplit[1];
						}
						else if ( sAttr.charAt(0) == "#" )
						{
							nNewNode.id = sAttr.substr(1, sAttr.length-1);
						}
						else
						{
							nNewNode.className = sAttr;
						}
		
						i += j; /* Move along the position array */
					}
		
					insert.append( nNewNode );
					insert = $(nNewNode);
				}
				else if ( cOption == '>' )
				{
					/* End container div */
					insert = insert.parent();
				}
				// @todo Move options into their own plugins?
				else if ( cOption == 'l' && features.bPaginate && features.bLengthChange )
				{
					/* Length */
					featureNode = _fnFeatureHtmlLength( oSettings );
				}
				else if ( cOption == 'f' && features.bFilter )
				{
					/* Filter */
					featureNode = _fnFeatureHtmlFilter( oSettings );
				}
				else if ( cOption == 'r' && features.bProcessing )
				{
					/* pRocessing */
					featureNode = _fnFeatureHtmlProcessing( oSettings );
				}
				else if ( cOption == 't' )
				{
					/* Table */
					featureNode = _fnFeatureHtmlTable( oSettings );
				}
				else if ( cOption ==  'i' && features.bInfo )
				{
					/* Info */
					featureNode = _fnFeatureHtmlInfo( oSettings );
				}
				else if ( cOption == 'p' && features.bPaginate )
				{
					/* Pagination */
					featureNode = _fnFeatureHtmlPaginate( oSettings );
				}
				else if ( DataTable.ext.feature.length !== 0 )
				{
					/* Plug-in features */
					var aoFeatures = DataTable.ext.feature;
					for ( var k=0, kLen=aoFeatures.length ; k<kLen ; k++ )
					{
						if ( cOption == aoFeatures[k].cFeature )
						{
							featureNode = aoFeatures[k].fnInit( oSettings );
							break;
						}
					}
				}
		
				/* Add to the 2D features array */
				if ( featureNode )
				{
					var aanFeatures = oSettings.aanFeatures;
		
					if ( ! aanFeatures[cOption] )
					{
						aanFeatures[cOption] = [];
					}
		
					aanFeatures[cOption].push( featureNode );
					insert.append( featureNode );
				}
			}
		
			/* Built our DOM structure - replace the holding div with what we want */
			holding.replaceWith( insert );
			oSettings.nHolding = null;
		}
		
		
		/**
		 * Use the DOM source to create up an array of header cells. The idea here is to
		 * create a layout grid (array) of rows x columns, which contains a reference
		 * to the cell that that point in the grid (regardless of col/rowspan), such that
		 * any column / row could be removed and the new grid constructed
		 *  @param array {object} aLayout Array to store the calculated layout in
		 *  @param {node} nThead The header/footer element for the table
		 *  @memberof DataTable#oApi
		 */
		function _fnDetectHeader ( aLayout, nThead )
		{
			var nTrs = $(nThead).children('tr');
			var nTr, nCell;
			var i, k, l, iLen, jLen, iColShifted, iColumn, iColspan, iRowspan;
			var bUnique;
			var fnShiftCol = function ( a, i, j ) {
				var k = a[i];
		                while ( k[j] ) {
					j++;
				}
				return j;
			};
		
			aLayout.splice( 0, aLayout.length );
		
			/* We know how many rows there are in the layout - so prep it */
			for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
			{
				aLayout.push( [] );
			}
		
			/* Calculate a layout array */
			for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
			{
				nTr = nTrs[i];
				iColumn = 0;
		
				/* For every cell in the row... */
				nCell = nTr.firstChild;
				while ( nCell ) {
					if ( nCell.nodeName.toUpperCase() == "TD" ||
					     nCell.nodeName.toUpperCase() == "TH" )
					{
						/* Get the col and rowspan attributes from the DOM and sanitise them */
						iColspan = nCell.getAttribute('colspan') * 1;
						iRowspan = nCell.getAttribute('rowspan') * 1;
						iColspan = (!iColspan || iColspan===0 || iColspan===1) ? 1 : iColspan;
						iRowspan = (!iRowspan || iRowspan===0 || iRowspan===1) ? 1 : iRowspan;
		
						/* There might be colspan cells already in this row, so shift our target
						 * accordingly
						 */
						iColShifted = fnShiftCol( aLayout, i, iColumn );
		
						/* Cache calculation for unique columns */
						bUnique = iColspan === 1 ? true : false;
		
						/* If there is col / rowspan, copy the information into the layout grid */
						for ( l=0 ; l<iColspan ; l++ )
						{
							for ( k=0 ; k<iRowspan ; k++ )
							{
								aLayout[i+k][iColShifted+l] = {
									"cell": nCell,
									"unique": bUnique
								};
								aLayout[i+k].nTr = nTr;
							}
						}
					}
					nCell = nCell.nextSibling;
				}
			}
		}
		
		
		/**
		 * Get an array of unique th elements, one for each column
		 *  @param {object} oSettings dataTables settings object
		 *  @param {node} nHeader automatically detect the layout from this node - optional
		 *  @param {array} aLayout thead/tfoot layout from _fnDetectHeader - optional
		 *  @returns array {node} aReturn list of unique th's
		 *  @memberof DataTable#oApi
		 */
		function _fnGetUniqueThs ( oSettings, nHeader, aLayout )
		{
			var aReturn = [];
			if ( !aLayout )
			{
				aLayout = oSettings.aoHeader;
				if ( nHeader )
				{
					aLayout = [];
					_fnDetectHeader( aLayout, nHeader );
				}
			}
		
			for ( var i=0, iLen=aLayout.length ; i<iLen ; i++ )
			{
				for ( var j=0, jLen=aLayout[i].length ; j<jLen ; j++ )
				{
					if ( aLayout[i][j].unique &&
						 (!aReturn[j] || !oSettings.bSortCellsTop) )
					{
						aReturn[j] = aLayout[i][j].cell;
					}
				}
			}
		
			return aReturn;
		}
		
		/**
		 * Create an Ajax call based on the table's settings, taking into account that
		 * parameters can have multiple forms, and backwards compatibility.
		 *
		 * @param {object} oSettings dataTables settings object
		 * @param {array} data Data to send to the server, required by
		 *     DataTables - may be augmented by developer callbacks
		 * @param {function} fn Callback function to run when data is obtained
		 */
		function _fnBuildAjax( oSettings, data, fn )
		{
			// Compatibility with 1.9-, allow fnServerData and event to manipulate
			_fnCallbackFire( oSettings, 'aoServerParams', 'serverParams', [data] );
		
			// Convert to object based for 1.10+ if using the old array scheme which can
			// come from server-side processing or serverParams
			if ( data && $.isArray(data) ) {
				var tmp = {};
				var rbracket = /(.*?)\[\]$/;
		
				$.each( data, function (key, val) {
					var match = val.name.match(rbracket);
		
					if ( match ) {
						// Support for arrays
						var name = match[0];
		
						if ( ! tmp[ name ] ) {
							tmp[ name ] = [];
						}
						tmp[ name ].push( val.value );
					}
					else {
						tmp[val.name] = val.value;
					}
				} );
				data = tmp;
			}
		
			var ajaxData;
			var ajax = oSettings.ajax;
			var instance = oSettings.oInstance;
			var callback = function ( json ) {
				_fnCallbackFire( oSettings, null, 'xhr', [oSettings, json, oSettings.jqXHR] );
				fn( json );
			};
		
			if ( $.isPlainObject( ajax ) && ajax.data )
			{
				ajaxData = ajax.data;
		
				var newData = $.isFunction( ajaxData ) ?
					ajaxData( data, oSettings ) :  // fn can manipulate data or return
					ajaxData;                      // an object object or array to merge
		
				// If the function returned something, use that alone
				data = $.isFunction( ajaxData ) && newData ?
					newData :
					$.extend( true, data, newData );
		
				// Remove the data property as we've resolved it already and don't want
				// jQuery to do it again (it is restored at the end of the function)
				delete ajax.data;
			}
		
			var baseAjax = {
				"data": data,
				"success": function (json) {
					var error = json.error || json.sError;
					if ( error ) {
						_fnLog( oSettings, 0, error );
					}
		
					oSettings.json = json;
					callback( json );
				},
				"dataType": "json",
				"cache": false,
				"type": oSettings.sServerMethod,
				"error": function (xhr, error, thrown) {
					var ret = _fnCallbackFire( oSettings, null, 'xhr', [oSettings, null, oSettings.jqXHR] );
		
					if ( $.inArray( true, ret ) === -1 ) {
						if ( error == "parsererror" ) {
							_fnLog( oSettings, 0, 'Invalid JSON response', 1 );
						}
						else if ( xhr.readyState === 4 ) {
							_fnLog( oSettings, 0, 'Ajax error', 7 );
						}
					}
		
					_fnProcessingDisplay( oSettings, false );
				}
			};
		
			// Store the data submitted for the API
			oSettings.oAjaxData = data;
		
			// Allow plug-ins and external processes to modify the data
			_fnCallbackFire( oSettings, null, 'preXhr', [oSettings, data] );
		
			if ( oSettings.fnServerData )
			{
				// DataTables 1.9- compatibility
				oSettings.fnServerData.call( instance,
					oSettings.sAjaxSource,
					$.map( data, function (val, key) { // Need to convert back to 1.9 trad format
						return { name: key, value: val };
					} ),
					callback,
					oSettings
				);
			}
			else if ( oSettings.sAjaxSource || typeof ajax === 'string' )
			{
				// DataTables 1.9- compatibility
				oSettings.jqXHR = $.ajax( $.extend( baseAjax, {
					url: ajax || oSettings.sAjaxSource
				} ) );
			}
			else if ( $.isFunction( ajax ) )
			{
				// Is a function - let the caller define what needs to be done
				oSettings.jqXHR = ajax.call( instance, data, callback, oSettings );
			}
			else
			{
				// Object to extend the base settings
				oSettings.jqXHR = $.ajax( $.extend( baseAjax, ajax ) );
		
				// Restore for next time around
				ajax.data = ajaxData;
			}
		}
		
		
		/**
		 * Update the table using an Ajax call
		 *  @param {object} settings dataTables settings object
		 *  @returns {boolean} Block the table drawing or not
		 *  @memberof DataTable#oApi
		 */
		function _fnAjaxUpdate( settings )
		{
			if ( settings.bAjaxDataGet ) {
				settings.iDraw++;
				_fnProcessingDisplay( settings, true );
		
				_fnBuildAjax(
					settings,
					_fnAjaxParameters( settings ),
					function(json) {
						_fnAjaxUpdateDraw( settings, json );
					}
				);
		
				return false;
			}
			return true;
		}
		
		
		/**
		 * Build up the parameters in an object needed for a server-side processing
		 * request. Note that this is basically done twice, is different ways - a modern
		 * method which is used by default in DataTables 1.10 which uses objects and
		 * arrays, or the 1.9- method with is name / value pairs. 1.9 method is used if
		 * the sAjaxSource option is used in the initialisation, or the legacyAjax
		 * option is set.
		 *  @param {object} oSettings dataTables settings object
		 *  @returns {bool} block the table drawing or not
		 *  @memberof DataTable#oApi
		 */
		function _fnAjaxParameters( settings )
		{
			var
				columns = settings.aoColumns,
				columnCount = columns.length,
				features = settings.oFeatures,
				preSearch = settings.oPreviousSearch,
				preColSearch = settings.aoPreSearchCols,
				i, data = [], dataProp, column, columnSearch,
				sort = _fnSortFlatten( settings ),
				displayStart = settings._iDisplayStart,
				displayLength = features.bPaginate !== false ?
					settings._iDisplayLength :
					-1;
		
			var param = function ( name, value ) {
				data.push( { 'name': name, 'value': value } );
			};
		
			// DataTables 1.9- compatible method
			param( 'sEcho',          settings.iDraw );
			param( 'iColumns',       columnCount );
			param( 'sColumns',       _pluck( columns, 'sName' ).join(',') );
			param( 'iDisplayStart',  displayStart );
			param( 'iDisplayLength', displayLength );
		
			// DataTables 1.10+ method
			var d = {
				draw:    settings.iDraw,
				columns: [],
				order:   [],
				start:   displayStart,
				length:  displayLength,
				search:  {
					value: preSearch.sSearch,
					regex: preSearch.bRegex
				}
			};
		
			for ( i=0 ; i<columnCount ; i++ ) {
				column = columns[i];
				columnSearch = preColSearch[i];
				dataProp = typeof column.mData=="function" ? 'function' : column.mData ;
		
				d.columns.push( {
					data:       dataProp,
					name:       column.sName,
					searchable: column.bSearchable,
					orderable:  column.bSortable,
					search:     {
						value: columnSearch.sSearch,
						regex: columnSearch.bRegex
					}
				} );
		
				param( "mDataProp_"+i, dataProp );
		
				if ( features.bFilter ) {
					param( 'sSearch_'+i,     columnSearch.sSearch );
					param( 'bRegex_'+i,      columnSearch.bRegex );
					param( 'bSearchable_'+i, column.bSearchable );
				}
		
				if ( features.bSort ) {
					param( 'bSortable_'+i, column.bSortable );
				}
			}
		
			if ( features.bFilter ) {
				param( 'sSearch', preSearch.sSearch );
				param( 'bRegex', preSearch.bRegex );
			}
		
			if ( features.bSort ) {
				$.each( sort, function ( i, val ) {
					d.order.push( { column: val.col, dir: val.dir } );
		
					param( 'iSortCol_'+i, val.col );
					param( 'sSortDir_'+i, val.dir );
				} );
		
				param( 'iSortingCols', sort.length );
			}
		
			// If the legacy.ajax parameter is null, then we automatically decide which
			// form to use, based on sAjaxSource
			var legacy = DataTable.ext.legacy.ajax;
			if ( legacy === null ) {
				return settings.sAjaxSource ? data : d;
			}
		
			// Otherwise, if legacy has been specified then we use that to decide on the
			// form
			return legacy ? data : d;
		}
		
		
		/**
		 * Data the data from the server (nuking the old) and redraw the table
		 *  @param {object} oSettings dataTables settings object
		 *  @param {object} json json data return from the server.
		 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
		 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
		 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
		 *  @param {array} json.aaData The data to display on this page
		 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
		 *  @memberof DataTable#oApi
		 */
		function _fnAjaxUpdateDraw ( settings, json )
		{
			// v1.10 uses camelCase variables, while 1.9 uses Hungarian notation.
			// Support both
			var compat = function ( old, modern ) {
				return json[old] !== undefined ? json[old] : json[modern];
			};
		
			var data = _fnAjaxDataSrc( settings, json );
			var draw            = compat( 'sEcho',                'draw' );
			var recordsTotal    = compat( 'iTotalRecords',        'recordsTotal' );
			var recordsFiltered = compat( 'iTotalDisplayRecords', 'recordsFiltered' );
		
			if ( draw ) {
				// Protect against out of sequence returns
				if ( draw*1 < settings.iDraw ) {
					return;
				}
				settings.iDraw = draw * 1;
			}
		
			_fnClearTable( settings );
			settings._iRecordsTotal   = parseInt(recordsTotal, 10);
			settings._iRecordsDisplay = parseInt(recordsFiltered, 10);
		
			for ( var i=0, ien=data.length ; i<ien ; i++ ) {
				_fnAddData( settings, data[i] );
			}
			settings.aiDisplay = settings.aiDisplayMaster.slice();
		
			settings.bAjaxDataGet = false;
			_fnDraw( settings );
		
			if ( ! settings._bInitComplete ) {
				_fnInitComplete( settings, json );
			}
		
			settings.bAjaxDataGet = true;
			_fnProcessingDisplay( settings, false );
		}
		
		
		/**
		 * Get the data from the JSON data source to use for drawing a table. Using
		 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
		 * source object, or from a processing function.
		 *  @param {object} oSettings dataTables settings object
		 *  @param  {object} json Data source object / array from the server
		 *  @return {array} Array of data to use
		 */
		function _fnAjaxDataSrc ( oSettings, json )
		{
			var dataSrc = $.isPlainObject( oSettings.ajax ) && oSettings.ajax.dataSrc !== undefined ?
				oSettings.ajax.dataSrc :
				oSettings.sAjaxDataProp; // Compatibility with 1.9-.
		
			// Compatibility with 1.9-. In order to read from aaData, check if the
			// default has been changed, if not, check for aaData
			if ( dataSrc === 'data' ) {
				return json.aaData || json[dataSrc];
			}
		
			return dataSrc !== "" ?
				_fnGetObjectDataFn( dataSrc )( json ) :
				json;
		}
		
		/**
		 * Generate the node required for filtering text
		 *  @returns {node} Filter control element
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnFeatureHtmlFilter ( settings )
		{
			var classes = settings.oClasses;
			var tableId = settings.sTableId;
			var language = settings.oLanguage;
			var previousSearch = settings.oPreviousSearch;
			var features = settings.aanFeatures;
			var input = '<input type="search" class="'+classes.sFilterInput+'"/>';
		
			var str = language.sSearch;
			str = str.match(/_INPUT_/) ?
				str.replace('_INPUT_', input) :
				str+input;
		
			var filter = $('<div/>', {
					'id': ! features.f ? tableId+'_filter' : null,
					'class': classes.sFilter
				} )
				.append( $('<label/>' ).append( str ) );
		
			var searchFn = function() {
				/* Update all other filter input elements for the new display */
				var n = features.f;
				var val = !this.value ? "" : this.value; // mental IE8 fix :-(
		
				/* Now do the filter */
				if ( val != previousSearch.sSearch ) {
					_fnFilterComplete( settings, {
						"sSearch": val,
						"bRegex": previousSearch.bRegex,
						"bSmart": previousSearch.bSmart ,
						"bCaseInsensitive": previousSearch.bCaseInsensitive
					} );
		
					// Need to redraw, without resorting
					settings._iDisplayStart = 0;
					_fnDraw( settings );
				}
			};
		
			var searchDelay = settings.searchDelay !== null ?
				settings.searchDelay :
				_fnDataSource( settings ) === 'ssp' ?
					400 :
					0;
		
			var jqFilter = $('input', filter)
				.val( previousSearch.sSearch )
				.attr( 'placeholder', language.sSearchPlaceholder )
				.on(
					'keyup.DT search.DT input.DT paste.DT cut.DT',
					searchDelay ?
						_fnThrottle( searchFn, searchDelay ) :
						searchFn
				)
				.on( 'keypress.DT', function(e) {
					/* Prevent form submission */
					if ( e.keyCode == 13 ) {
						return false;
					}
				} )
				.attr('aria-controls', tableId);
		
			// Update the input elements whenever the table is filtered
			$(settings.nTable).on( 'search.dt.DT', function ( ev, s ) {
				if ( settings === s ) {
					// IE9 throws an 'unknown error' if document.activeElement is used
					// inside an iframe or frame...
					try {
						if ( jqFilter[0] !== document.activeElement ) {
							jqFilter.val( previousSearch.sSearch );
						}
					}
					catch ( e ) {}
				}
			} );
		
			return filter[0];
		}
		
		
		/**
		 * Filter the table using both the global filter and column based filtering
		 *  @param {object} oSettings dataTables settings object
		 *  @param {object} oSearch search information
		 *  @param {int} [iForce] force a research of the master array (1) or not (undefined or 0)
		 *  @memberof DataTable#oApi
		 */
		function _fnFilterComplete ( oSettings, oInput, iForce )
		{
			var oPrevSearch = oSettings.oPreviousSearch;
			var aoPrevSearch = oSettings.aoPreSearchCols;
			var fnSaveFilter = function ( oFilter ) {
				/* Save the filtering values */
				oPrevSearch.sSearch = oFilter.sSearch;
				oPrevSearch.bRegex = oFilter.bRegex;
				oPrevSearch.bSmart = oFilter.bSmart;
				oPrevSearch.bCaseInsensitive = oFilter.bCaseInsensitive;
			};
			var fnRegex = function ( o ) {
				// Backwards compatibility with the bEscapeRegex option
				return o.bEscapeRegex !== undefined ? !o.bEscapeRegex : o.bRegex;
			};
		
			// Resolve any column types that are unknown due to addition or invalidation
			// @todo As per sort - can this be moved into an event handler?
			_fnColumnTypes( oSettings );
		
			/* In server-side processing all filtering is done by the server, so no point hanging around here */
			if ( _fnDataSource( oSettings ) != 'ssp' )
			{
				/* Global filter */
				_fnFilter( oSettings, oInput.sSearch, iForce, fnRegex(oInput), oInput.bSmart, oInput.bCaseInsensitive );
				fnSaveFilter( oInput );
		
				/* Now do the individual column filter */
				for ( var i=0 ; i<aoPrevSearch.length ; i++ )
				{
					_fnFilterColumn( oSettings, aoPrevSearch[i].sSearch, i, fnRegex(aoPrevSearch[i]),
						aoPrevSearch[i].bSmart, aoPrevSearch[i].bCaseInsensitive );
				}
		
				/* Custom filtering */
				_fnFilterCustom( oSettings );
			}
			else
			{
				fnSaveFilter( oInput );
			}
		
			/* Tell the draw function we have been filtering */
			oSettings.bFiltered = true;
			_fnCallbackFire( oSettings, null, 'search', [oSettings] );
		}
		
		
		/**
		 * Apply custom filtering functions
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnFilterCustom( settings )
		{
			var filters = DataTable.ext.search;
			var displayRows = settings.aiDisplay;
			var row, rowIdx;
		
			for ( var i=0, ien=filters.length ; i<ien ; i++ ) {
				var rows = [];
		
				// Loop over each row and see if it should be included
				for ( var j=0, jen=displayRows.length ; j<jen ; j++ ) {
					rowIdx = displayRows[ j ];
					row = settings.aoData[ rowIdx ];
		
					if ( filters[i]( settings, row._aFilterData, rowIdx, row._aData, j ) ) {
						rows.push( rowIdx );
					}
				}
		
				// So the array reference doesn't break set the results into the
				// existing array
				displayRows.length = 0;
				$.merge( displayRows, rows );
			}
		}
		
		
		/**
		 * Filter the table on a per-column basis
		 *  @param {object} oSettings dataTables settings object
		 *  @param {string} sInput string to filter on
		 *  @param {int} iColumn column to filter
		 *  @param {bool} bRegex treat search string as a regular expression or not
		 *  @param {bool} bSmart use smart filtering or not
		 *  @param {bool} bCaseInsensitive Do case insenstive matching or not
		 *  @memberof DataTable#oApi
		 */
		function _fnFilterColumn ( settings, searchStr, colIdx, regex, smart, caseInsensitive )
		{
			if ( searchStr === '' ) {
				return;
			}
		
			var data;
			var out = [];
			var display = settings.aiDisplay;
			var rpSearch = _fnFilterCreateSearch( searchStr, regex, smart, caseInsensitive );
		
			for ( var i=0 ; i<display.length ; i++ ) {
				data = settings.aoData[ display[i] ]._aFilterData[ colIdx ];
		
				if ( rpSearch.test( data ) ) {
					out.push( display[i] );
				}
			}
		
			settings.aiDisplay = out;
		}
		
		
		/**
		 * Filter the data table based on user input and draw the table
		 *  @param {object} settings dataTables settings object
		 *  @param {string} input string to filter on
		 *  @param {int} force optional - force a research of the master array (1) or not (undefined or 0)
		 *  @param {bool} regex treat as a regular expression or not
		 *  @param {bool} smart perform smart filtering or not
		 *  @param {bool} caseInsensitive Do case insenstive matching or not
		 *  @memberof DataTable#oApi
		 */
		function _fnFilter( settings, input, force, regex, smart, caseInsensitive )
		{
			var rpSearch = _fnFilterCreateSearch( input, regex, smart, caseInsensitive );
			var prevSearch = settings.oPreviousSearch.sSearch;
			var displayMaster = settings.aiDisplayMaster;
			var display, invalidated, i;
			var filtered = [];
		
			// Need to take account of custom filtering functions - always filter
			if ( DataTable.ext.search.length !== 0 ) {
				force = true;
			}
		
			// Check if any of the rows were invalidated
			invalidated = _fnFilterData( settings );
		
			// If the input is blank - we just want the full data set
			if ( input.length <= 0 ) {
				settings.aiDisplay = displayMaster.slice();
			}
			else {
				// New search - start from the master array
				if ( invalidated ||
					 force ||
					 prevSearch.length > input.length ||
					 input.indexOf(prevSearch) !== 0 ||
					 settings.bSorted // On resort, the display master needs to be
					                  // re-filtered since indexes will have changed
				) {
					settings.aiDisplay = displayMaster.slice();
				}
		
				// Search the display array
				display = settings.aiDisplay;
		
				for ( i=0 ; i<display.length ; i++ ) {
					if ( rpSearch.test( settings.aoData[ display[i] ]._sFilterRow ) ) {
						filtered.push( display[i] );
					}
				}
		
				settings.aiDisplay = filtered;
			}
		}
		
		
		/**
		 * Build a regular expression object suitable for searching a table
		 *  @param {string} sSearch string to search for
		 *  @param {bool} bRegex treat as a regular expression or not
		 *  @param {bool} bSmart perform smart filtering or not
		 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
		 *  @returns {RegExp} constructed object
		 *  @memberof DataTable#oApi
		 */
		function _fnFilterCreateSearch( search, regex, smart, caseInsensitive )
		{
			search = regex ?
				search :
				_fnEscapeRegex( search );
			
			if ( smart ) {
				/* For smart filtering we want to allow the search to work regardless of
				 * word order. We also want double quoted text to be preserved, so word
				 * order is important - a la google. So this is what we want to
				 * generate:
				 * 
				 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
				 */
				var a = $.map( search.match( /"[^"]+"|[^ ]+/g ) || [''], function ( word ) {
					if ( word.charAt(0) === '"' ) {
						var m = word.match( /^"(.*)"$/ );
						word = m ? m[1] : word;
					}
		
					return word.replace('"', '');
				} );
		
				search = '^(?=.*?'+a.join( ')(?=.*?' )+').*$';
			}
		
			return new RegExp( search, caseInsensitive ? 'i' : '' );
		}
		
		
		/**
		 * Escape a string such that it can be used in a regular expression
		 *  @param {string} sVal string to escape
		 *  @returns {string} escaped string
		 *  @memberof DataTable#oApi
		 */
		var _fnEscapeRegex = DataTable.util.escapeRegex;
		
		var __filter_div = $('<div>')[0];
		var __filter_div_textContent = __filter_div.textContent !== undefined;
		
		// Update the filtering data for each row if needed (by invalidation or first run)
		function _fnFilterData ( settings )
		{
			var columns = settings.aoColumns;
			var column;
			var i, j, ien, jen, filterData, cellData, row;
			var fomatters = DataTable.ext.type.search;
			var wasInvalidated = false;
		
			for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
				row = settings.aoData[i];
		
				if ( ! row._aFilterData ) {
					filterData = [];
		
					for ( j=0, jen=columns.length ; j<jen ; j++ ) {
						column = columns[j];
		
						if ( column.bSearchable ) {
							cellData = _fnGetCellData( settings, i, j, 'filter' );
		
							if ( fomatters[ column.sType ] ) {
								cellData = fomatters[ column.sType ]( cellData );
							}
		
							// Search in DataTables 1.10 is string based. In 1.11 this
							// should be altered to also allow strict type checking.
							if ( cellData === null ) {
								cellData = '';
							}
		
							if ( typeof cellData !== 'string' && cellData.toString ) {
								cellData = cellData.toString();
							}
						}
						else {
							cellData = '';
						}
		
						// If it looks like there is an HTML entity in the string,
						// attempt to decode it so sorting works as expected. Note that
						// we could use a single line of jQuery to do this, but the DOM
						// method used here is much faster http://jsperf.com/html-decode
						if ( cellData.indexOf && cellData.indexOf('&') !== -1 ) {
							__filter_div.innerHTML = cellData;
							cellData = __filter_div_textContent ?
								__filter_div.textContent :
								__filter_div.innerText;
						}
		
						if ( cellData.replace ) {
							cellData = cellData.replace(/[\r\n]/g, '');
						}
		
						filterData.push( cellData );
					}
		
					row._aFilterData = filterData;
					row._sFilterRow = filterData.join('  ');
					wasInvalidated = true;
				}
			}
		
			return wasInvalidated;
		}
		
		
		/**
		 * Convert from the internal Hungarian notation to camelCase for external
		 * interaction
		 *  @param {object} obj Object to convert
		 *  @returns {object} Inverted object
		 *  @memberof DataTable#oApi
		 */
		function _fnSearchToCamel ( obj )
		{
			return {
				search:          obj.sSearch,
				smart:           obj.bSmart,
				regex:           obj.bRegex,
				caseInsensitive: obj.bCaseInsensitive
			};
		}
		
		
		
		/**
		 * Convert from camelCase notation to the internal Hungarian. We could use the
		 * Hungarian convert function here, but this is cleaner
		 *  @param {object} obj Object to convert
		 *  @returns {object} Inverted object
		 *  @memberof DataTable#oApi
		 */
		function _fnSearchToHung ( obj )
		{
			return {
				sSearch:          obj.search,
				bSmart:           obj.smart,
				bRegex:           obj.regex,
				bCaseInsensitive: obj.caseInsensitive
			};
		}
		
		/**
		 * Generate the node required for the info display
		 *  @param {object} oSettings dataTables settings object
		 *  @returns {node} Information element
		 *  @memberof DataTable#oApi
		 */
		function _fnFeatureHtmlInfo ( settings )
		{
			var
				tid = settings.sTableId,
				nodes = settings.aanFeatures.i,
				n = $('<div/>', {
					'class': settings.oClasses.sInfo,
					'id': ! nodes ? tid+'_info' : null
				} );
		
			if ( ! nodes ) {
				// Update display on each draw
				settings.aoDrawCallback.push( {
					"fn": _fnUpdateInfo,
					"sName": "information"
				} );
		
				n
					.attr( 'role', 'status' )
					.attr( 'aria-live', 'polite' );
		
				// Table is described by our info div
				$(settings.nTable).attr( 'aria-describedby', tid+'_info' );
			}
		
			return n[0];
		}
		
		
		/**
		 * Update the information elements in the display
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnUpdateInfo ( settings )
		{
			/* Show information about the table */
			var nodes = settings.aanFeatures.i;
			if ( nodes.length === 0 ) {
				return;
			}
		
			var
				lang  = settings.oLanguage,
				start = settings._iDisplayStart+1,
				end   = settings.fnDisplayEnd(),
				max   = settings.fnRecordsTotal(),
				total = settings.fnRecordsDisplay(),
				out   = total ?
					lang.sInfo :
					lang.sInfoEmpty;
		
			if ( total !== max ) {
				/* Record set after filtering */
				out += ' ' + lang.sInfoFiltered;
			}
		
			// Convert the macros
			out += lang.sInfoPostFix;
			out = _fnInfoMacros( settings, out );
		
			var callback = lang.fnInfoCallback;
			if ( callback !== null ) {
				out = callback.call( settings.oInstance,
					settings, start, end, max, total, out
				);
			}
		
			$(nodes).html( out );
		}
		
		
		function _fnInfoMacros ( settings, str )
		{
			// When infinite scrolling, we are always starting at 1. _iDisplayStart is used only
			// internally
			var
				formatter  = settings.fnFormatNumber,
				start      = settings._iDisplayStart+1,
				len        = settings._iDisplayLength,
				vis        = settings.fnRecordsDisplay(),
				all        = len === -1;
		
			return str.
				replace(/_START_/g, formatter.call( settings, start ) ).
				replace(/_END_/g,   formatter.call( settings, settings.fnDisplayEnd() ) ).
				replace(/_MAX_/g,   formatter.call( settings, settings.fnRecordsTotal() ) ).
				replace(/_TOTAL_/g, formatter.call( settings, vis ) ).
				replace(/_PAGE_/g,  formatter.call( settings, all ? 1 : Math.ceil( start / len ) ) ).
				replace(/_PAGES_/g, formatter.call( settings, all ? 1 : Math.ceil( vis / len ) ) );
		}
		
		
		
		/**
		 * Draw the table for the first time, adding all required features
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnInitialise ( settings )
		{
			var i, iLen, iAjaxStart=settings.iInitDisplayStart;
			var columns = settings.aoColumns, column;
			var features = settings.oFeatures;
			var deferLoading = settings.bDeferLoading; // value modified by the draw
		
			/* Ensure that the table data is fully initialised */
			if ( ! settings.bInitialised ) {
				setTimeout( function(){ _fnInitialise( settings ); }, 200 );
				return;
			}
		
			/* Show the display HTML options */
			_fnAddOptionsHtml( settings );
		
			/* Build and draw the header / footer for the table */
			_fnBuildHead( settings );
			_fnDrawHead( settings, settings.aoHeader );
			_fnDrawHead( settings, settings.aoFooter );
		
			/* Okay to show that something is going on now */
			_fnProcessingDisplay( settings, true );
		
			/* Calculate sizes for columns */
			if ( features.bAutoWidth ) {
				_fnCalculateColumnWidths( settings );
			}
		
			for ( i=0, iLen=columns.length ; i<iLen ; i++ ) {
				column = columns[i];
		
				if ( column.sWidth ) {
					column.nTh.style.width = _fnStringToCss( column.sWidth );
				}
			}
		
			_fnCallbackFire( settings, null, 'preInit', [settings] );
		
			// If there is default sorting required - let's do it. The sort function
			// will do the drawing for us. Otherwise we draw the table regardless of the
			// Ajax source - this allows the table to look initialised for Ajax sourcing
			// data (show 'loading' message possibly)
			_fnReDraw( settings );
		
			// Server-side processing init complete is done by _fnAjaxUpdateDraw
			var dataSrc = _fnDataSource( settings );
			if ( dataSrc != 'ssp' || deferLoading ) {
				// if there is an ajax source load the data
				if ( dataSrc == 'ajax' ) {
					_fnBuildAjax( settings, [], function(json) {
						var aData = _fnAjaxDataSrc( settings, json );
		
						// Got the data - add it to the table
						for ( i=0 ; i<aData.length ; i++ ) {
							_fnAddData( settings, aData[i] );
						}
		
						// Reset the init display for cookie saving. We've already done
						// a filter, and therefore cleared it before. So we need to make
						// it appear 'fresh'
						settings.iInitDisplayStart = iAjaxStart;
		
						_fnReDraw( settings );
		
						_fnProcessingDisplay( settings, false );
						_fnInitComplete( settings, json );
					}, settings );
				}
				else {
					_fnProcessingDisplay( settings, false );
					_fnInitComplete( settings );
				}
			}
		}
		
		
		/**
		 * Draw the table for the first time, adding all required features
		 *  @param {object} oSettings dataTables settings object
		 *  @param {object} [json] JSON from the server that completed the table, if using Ajax source
		 *    with client-side processing (optional)
		 *  @memberof DataTable#oApi
		 */
		function _fnInitComplete ( settings, json )
		{
			settings._bInitComplete = true;
		
			// When data was added after the initialisation (data or Ajax) we need to
			// calculate the column sizing
			if ( json || settings.oInit.aaData ) {
				_fnAdjustColumnSizing( settings );
			}
		
			_fnCallbackFire( settings, null, 'plugin-init', [settings, json] );
			_fnCallbackFire( settings, 'aoInitComplete', 'init', [settings, json] );
		}
		
		
		function _fnLengthChange ( settings, val )
		{
			var len = parseInt( val, 10 );
			settings._iDisplayLength = len;
		
			_fnLengthOverflow( settings );
		
			// Fire length change event
			_fnCallbackFire( settings, null, 'length', [settings, len] );
		}
		
		
		/**
		 * Generate the node required for user display length changing
		 *  @param {object} settings dataTables settings object
		 *  @returns {node} Display length feature node
		 *  @memberof DataTable#oApi
		 */
		function _fnFeatureHtmlLength ( settings )
		{
			var
				classes  = settings.oClasses,
				tableId  = settings.sTableId,
				menu     = settings.aLengthMenu,
				d2       = $.isArray( menu[0] ),
				lengths  = d2 ? menu[0] : menu,
				language = d2 ? menu[1] : menu;
		
			var select = $('<select/>', {
				'name':          tableId+'_length',
				'aria-controls': tableId,
				'class':         classes.sLengthSelect
			} );
		
			for ( var i=0, ien=lengths.length ; i<ien ; i++ ) {
				select[0][ i ] = new Option(
					typeof language[i] === 'number' ?
						settings.fnFormatNumber( language[i] ) :
						language[i],
					lengths[i]
				);
			}
		
			var div = $('<div><label/></div>').addClass( classes.sLength );
			if ( ! settings.aanFeatures.l ) {
				div[0].id = tableId+'_length';
			}
		
			div.children().append(
				settings.oLanguage.sLengthMenu.replace( '_MENU_', select[0].outerHTML )
			);
		
			// Can't use `select` variable as user might provide their own and the
			// reference is broken by the use of outerHTML
			$('select', div)
				.val( settings._iDisplayLength )
				.on( 'change.DT', function(e) {
					_fnLengthChange( settings, $(this).val() );
					_fnDraw( settings );
				} );
		
			// Update node value whenever anything changes the table's length
			$(settings.nTable).on( 'length.dt.DT', function (e, s, len) {
				if ( settings === s ) {
					$('select', div).val( len );
				}
			} );
		
			return div[0];
		}
		
		
		
		/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
		 * Note that most of the paging logic is done in
		 * DataTable.ext.pager
		 */
		
		/**
		 * Generate the node required for default pagination
		 *  @param {object} oSettings dataTables settings object
		 *  @returns {node} Pagination feature node
		 *  @memberof DataTable#oApi
		 */
		function _fnFeatureHtmlPaginate ( settings )
		{
			var
				type   = settings.sPaginationType,
				plugin = DataTable.ext.pager[ type ],
				modern = typeof plugin === 'function',
				redraw = function( settings ) {
					_fnDraw( settings );
				},
				node = $('<div/>').addClass( settings.oClasses.sPaging + type )[0],
				features = settings.aanFeatures;
		
			if ( ! modern ) {
				plugin.fnInit( settings, node, redraw );
			}
		
			/* Add a draw callback for the pagination on first instance, to update the paging display */
			if ( ! features.p )
			{
				node.id = settings.sTableId+'_paginate';
		
				settings.aoDrawCallback.push( {
					"fn": function( settings ) {
						if ( modern ) {
							var
								start      = settings._iDisplayStart,
								len        = settings._iDisplayLength,
								visRecords = settings.fnRecordsDisplay(),
								all        = len === -1,
								page = all ? 0 : Math.ceil( start / len ),
								pages = all ? 1 : Math.ceil( visRecords / len ),
								buttons = plugin(page, pages),
								i, ien;
		
							for ( i=0, ien=features.p.length ; i<ien ; i++ ) {
								_fnRenderer( settings, 'pageButton' )(
									settings, features.p[i], i, buttons, page, pages
								);
							}
						}
						else {
							plugin.fnUpdate( settings, redraw );
						}
					},
					"sName": "pagination"
				} );
			}
		
			return node;
		}
		
		
		/**
		 * Alter the display settings to change the page
		 *  @param {object} settings DataTables settings object
		 *  @param {string|int} action Paging action to take: "first", "previous",
		 *    "next" or "last" or page number to jump to (integer)
		 *  @param [bool] redraw Automatically draw the update or not
		 *  @returns {bool} true page has changed, false - no change
		 *  @memberof DataTable#oApi
		 */
		function _fnPageChange ( settings, action, redraw )
		{
			var
				start     = settings._iDisplayStart,
				len       = settings._iDisplayLength,
				records   = settings.fnRecordsDisplay();
		
			if ( records === 0 || len === -1 )
			{
				start = 0;
			}
			else if ( typeof action === "number" )
			{
				start = action * len;
		
				if ( start > records )
				{
					start = 0;
				}
			}
			else if ( action == "first" )
			{
				start = 0;
			}
			else if ( action == "previous" )
			{
				start = len >= 0 ?
					start - len :
					0;
		
				if ( start < 0 )
				{
				  start = 0;
				}
			}
			else if ( action == "next" )
			{
				if ( start + len < records )
				{
					start += len;
				}
			}
			else if ( action == "last" )
			{
				start = Math.floor( (records-1) / len) * len;
			}
			else
			{
				_fnLog( settings, 0, "Unknown paging action: "+action, 5 );
			}
		
			var changed = settings._iDisplayStart !== start;
			settings._iDisplayStart = start;
		
			if ( changed ) {
				_fnCallbackFire( settings, null, 'page', [settings] );
		
				if ( redraw ) {
					_fnDraw( settings );
				}
			}
		
			return changed;
		}
		
		
		
		/**
		 * Generate the node required for the processing node
		 *  @param {object} settings dataTables settings object
		 *  @returns {node} Processing element
		 *  @memberof DataTable#oApi
		 */
		function _fnFeatureHtmlProcessing ( settings )
		{
			return $('<div/>', {
					'id': ! settings.aanFeatures.r ? settings.sTableId+'_processing' : null,
					'class': settings.oClasses.sProcessing
				} )
				.html( settings.oLanguage.sProcessing )
				.insertBefore( settings.nTable )[0];
		}
		
		
		/**
		 * Display or hide the processing indicator
		 *  @param {object} settings dataTables settings object
		 *  @param {bool} show Show the processing indicator (true) or not (false)
		 *  @memberof DataTable#oApi
		 */
		function _fnProcessingDisplay ( settings, show )
		{
			if ( settings.oFeatures.bProcessing ) {
				$(settings.aanFeatures.r).css( 'display', show ? 'block' : 'none' );
			}
		
			_fnCallbackFire( settings, null, 'processing', [settings, show] );
		}
		
		/**
		 * Add any control elements for the table - specifically scrolling
		 *  @param {object} settings dataTables settings object
		 *  @returns {node} Node to add to the DOM
		 *  @memberof DataTable#oApi
		 */
		function _fnFeatureHtmlTable ( settings )
		{
			var table = $(settings.nTable);
		
			// Add the ARIA grid role to the table
			table.attr( 'role', 'grid' );
		
			// Scrolling from here on in
			var scroll = settings.oScroll;
		
			if ( scroll.sX === '' && scroll.sY === '' ) {
				return settings.nTable;
			}
		
			var scrollX = scroll.sX;
			var scrollY = scroll.sY;
			var classes = settings.oClasses;
			var caption = table.children('caption');
			var captionSide = caption.length ? caption[0]._captionSide : null;
			var headerClone = $( table[0].cloneNode(false) );
			var footerClone = $( table[0].cloneNode(false) );
			var footer = table.children('tfoot');
			var _div = '<div/>';
			var size = function ( s ) {
				return !s ? null : _fnStringToCss( s );
			};
		
			if ( ! footer.length ) {
				footer = null;
			}
		
			/*
			 * The HTML structure that we want to generate in this function is:
			 *  div - scroller
			 *    div - scroll head
			 *      div - scroll head inner
			 *        table - scroll head table
			 *          thead - thead
			 *    div - scroll body
			 *      table - table (master table)
			 *        thead - thead clone for sizing
			 *        tbody - tbody
			 *    div - scroll foot
			 *      div - scroll foot inner
			 *        table - scroll foot table
			 *          tfoot - tfoot
			 */
			var scroller = $( _div, { 'class': classes.sScrollWrapper } )
				.append(
					$(_div, { 'class': classes.sScrollHead } )
						.css( {
							overflow: 'hidden',
							position: 'relative',
							border: 0,
							width: scrollX ? size(scrollX) : '100%'
						} )
						.append(
							$(_div, { 'class': classes.sScrollHeadInner } )
								.css( {
									'box-sizing': 'content-box',
									width: scroll.sXInner || '100%'
								} )
								.append(
									headerClone
										.removeAttr('id')
										.css( 'margin-left', 0 )
										.append( captionSide === 'top' ? caption : null )
										.append(
											table.children('thead')
										)
								)
						)
				)
				.append(
					$(_div, { 'class': classes.sScrollBody } )
						.css( {
							position: 'relative',
							overflow: 'auto',
							width: size( scrollX )
						} )
						.append( table )
				);
		
			if ( footer ) {
				scroller.append(
					$(_div, { 'class': classes.sScrollFoot } )
						.css( {
							overflow: 'hidden',
							border: 0,
							width: scrollX ? size(scrollX) : '100%'
						} )
						.append(
							$(_div, { 'class': classes.sScrollFootInner } )
								.append(
									footerClone
										.removeAttr('id')
										.css( 'margin-left', 0 )
										.append( captionSide === 'bottom' ? caption : null )
										.append(
											table.children('tfoot')
										)
								)
						)
				);
			}
		
			var children = scroller.children();
			var scrollHead = children[0];
			var scrollBody = children[1];
			var scrollFoot = footer ? children[2] : null;
		
			// When the body is scrolled, then we also want to scroll the headers
			if ( scrollX ) {
				$(scrollBody).on( 'scroll.DT', function (e) {
					var scrollLeft = this.scrollLeft;
		
					scrollHead.scrollLeft = scrollLeft;
		
					if ( footer ) {
						scrollFoot.scrollLeft = scrollLeft;
					}
				} );
			}
		
			$(scrollBody).css(
				scrollY && scroll.bCollapse ? 'max-height' : 'height', 
				scrollY
			);
		
			settings.nScrollHead = scrollHead;
			settings.nScrollBody = scrollBody;
			settings.nScrollFoot = scrollFoot;
		
			// On redraw - align columns
			settings.aoDrawCallback.push( {
				"fn": _fnScrollDraw,
				"sName": "scrolling"
			} );
		
			return scroller[0];
		}
		
		
		
		/**
		 * Update the header, footer and body tables for resizing - i.e. column
		 * alignment.
		 *
		 * Welcome to the most horrible function DataTables. The process that this
		 * function follows is basically:
		 *   1. Re-create the table inside the scrolling div
		 *   2. Take live measurements from the DOM
		 *   3. Apply the measurements to align the columns
		 *   4. Clean up
		 *
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnScrollDraw ( settings )
		{
			// Given that this is such a monster function, a lot of variables are use
			// to try and keep the minimised size as small as possible
			var
				scroll         = settings.oScroll,
				scrollX        = scroll.sX,
				scrollXInner   = scroll.sXInner,
				scrollY        = scroll.sY,
				barWidth       = scroll.iBarWidth,
				divHeader      = $(settings.nScrollHead),
				divHeaderStyle = divHeader[0].style,
				divHeaderInner = divHeader.children('div'),
				divHeaderInnerStyle = divHeaderInner[0].style,
				divHeaderTable = divHeaderInner.children('table'),
				divBodyEl      = settings.nScrollBody,
				divBody        = $(divBodyEl),
				divBodyStyle   = divBodyEl.style,
				divFooter      = $(settings.nScrollFoot),
				divFooterInner = divFooter.children('div'),
				divFooterTable = divFooterInner.children('table'),
				header         = $(settings.nTHead),
				table          = $(settings.nTable),
				tableEl        = table[0],
				tableStyle     = tableEl.style,
				footer         = settings.nTFoot ? $(settings.nTFoot) : null,
				browser        = settings.oBrowser,
				ie67           = browser.bScrollOversize,
				dtHeaderCells  = _pluck( settings.aoColumns, 'nTh' ),
				headerTrgEls, footerTrgEls,
				headerSrcEls, footerSrcEls,
				headerCopy, footerCopy,
				headerWidths=[], footerWidths=[],
				headerContent=[], footerContent=[],
				idx, correction, sanityWidth,
				zeroOut = function(nSizer) {
					var style = nSizer.style;
					style.paddingTop = "0";
					style.paddingBottom = "0";
					style.borderTopWidth = "0";
					style.borderBottomWidth = "0";
					style.height = 0;
				};
		
			// If the scrollbar visibility has changed from the last draw, we need to
			// adjust the column sizes as the table width will have changed to account
			// for the scrollbar
			var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
			
			if ( settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined ) {
				settings.scrollBarVis = scrollBarVis;
				_fnAdjustColumnSizing( settings );
				return; // adjust column sizing will call this function again
			}
			else {
				settings.scrollBarVis = scrollBarVis;
			}
		
			/*
			 * 1. Re-create the table inside the scrolling div
			 */
		
			// Remove the old minimised thead and tfoot elements in the inner table
			table.children('thead, tfoot').remove();
		
			if ( footer ) {
				footerCopy = footer.clone().prependTo( table );
				footerTrgEls = footer.find('tr'); // the original tfoot is in its own table and must be sized
				footerSrcEls = footerCopy.find('tr');
			}
		
			// Clone the current header and footer elements and then place it into the inner table
			headerCopy = header.clone().prependTo( table );
			headerTrgEls = header.find('tr'); // original header is in its own table
			headerSrcEls = headerCopy.find('tr');
			headerCopy.find('th, td').removeAttr('tabindex');
		
		
			/*
			 * 2. Take live measurements from the DOM - do not alter the DOM itself!
			 */
		
			// Remove old sizing and apply the calculated column widths
			// Get the unique column headers in the newly created (cloned) header. We want to apply the
			// calculated sizes to this header
			if ( ! scrollX )
			{
				divBodyStyle.width = '100%';
				divHeader[0].style.width = '100%';
			}
		
			$.each( _fnGetUniqueThs( settings, headerCopy ), function ( i, el ) {
				idx = _fnVisibleToColumnIndex( settings, i );
				el.style.width = settings.aoColumns[idx].sWidth;
			} );
		
			if ( footer ) {
				_fnApplyToChildren( function(n) {
					n.style.width = "";
				}, footerSrcEls );
			}
		
			// Size the table as a whole
			sanityWidth = table.outerWidth();
			if ( scrollX === "" ) {
				// No x scrolling
				tableStyle.width = "100%";
		
				// IE7 will make the width of the table when 100% include the scrollbar
				// - which is shouldn't. When there is a scrollbar we need to take this
				// into account.
				if ( ie67 && (table.find('tbody').height() > divBodyEl.offsetHeight ||
					divBody.css('overflow-y') == "scroll")
				) {
					tableStyle.width = _fnStringToCss( table.outerWidth() - barWidth);
				}
		
				// Recalculate the sanity width
				sanityWidth = table.outerWidth();
			}
			else if ( scrollXInner !== "" ) {
				// legacy x scroll inner has been given - use it
				tableStyle.width = _fnStringToCss(scrollXInner);
		
				// Recalculate the sanity width
				sanityWidth = table.outerWidth();
			}
		
			// Hidden header should have zero height, so remove padding and borders. Then
			// set the width based on the real headers
		
			// Apply all styles in one pass
			_fnApplyToChildren( zeroOut, headerSrcEls );
		
			// Read all widths in next pass
			_fnApplyToChildren( function(nSizer) {
				headerContent.push( nSizer.innerHTML );
				headerWidths.push( _fnStringToCss( $(nSizer).css('width') ) );
			}, headerSrcEls );
		
			// Apply all widths in final pass
			_fnApplyToChildren( function(nToSize, i) {
				// Only apply widths to the DataTables detected header cells - this
				// prevents complex headers from having contradictory sizes applied
				if ( $.inArray( nToSize, dtHeaderCells ) !== -1 ) {
					nToSize.style.width = headerWidths[i];
				}
			}, headerTrgEls );
		
			$(headerSrcEls).height(0);
		
			/* Same again with the footer if we have one */
			if ( footer )
			{
				_fnApplyToChildren( zeroOut, footerSrcEls );
		
				_fnApplyToChildren( function(nSizer) {
					footerContent.push( nSizer.innerHTML );
					footerWidths.push( _fnStringToCss( $(nSizer).css('width') ) );
				}, footerSrcEls );
		
				_fnApplyToChildren( function(nToSize, i) {
					nToSize.style.width = footerWidths[i];
				}, footerTrgEls );
		
				$(footerSrcEls).height(0);
			}
		
		
			/*
			 * 3. Apply the measurements
			 */
		
			// "Hide" the header and footer that we used for the sizing. We need to keep
			// the content of the cell so that the width applied to the header and body
			// both match, but we want to hide it completely. We want to also fix their
			// width to what they currently are
			_fnApplyToChildren( function(nSizer, i) {
				nSizer.innerHTML = '<div class="dataTables_sizing" style="height:0;overflow:hidden;">'+headerContent[i]+'</div>';
				nSizer.style.width = headerWidths[i];
			}, headerSrcEls );
		
			if ( footer )
			{
				_fnApplyToChildren( function(nSizer, i) {
					nSizer.innerHTML = '<div class="dataTables_sizing" style="height:0;overflow:hidden;">'+footerContent[i]+'</div>';
					nSizer.style.width = footerWidths[i];
				}, footerSrcEls );
			}
		
			// Sanity check that the table is of a sensible width. If not then we are going to get
			// misalignment - try to prevent this by not allowing the table to shrink below its min width
			if ( table.outerWidth() < sanityWidth )
			{
				// The min width depends upon if we have a vertical scrollbar visible or not */
				correction = ((divBodyEl.scrollHeight > divBodyEl.offsetHeight ||
					divBody.css('overflow-y') == "scroll")) ?
						sanityWidth+barWidth :
						sanityWidth;
		
				// IE6/7 are a law unto themselves...
				if ( ie67 && (divBodyEl.scrollHeight >
					divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll")
				) {
					tableStyle.width = _fnStringToCss( correction-barWidth );
				}
		
				// And give the user a warning that we've stopped the table getting too small
				if ( scrollX === "" || scrollXInner !== "" ) {
					_fnLog( settings, 1, 'Possible column misalignment', 6 );
				}
			}
			else
			{
				correction = '100%';
			}
		
			// Apply to the container elements
			divBodyStyle.width = _fnStringToCss( correction );
			divHeaderStyle.width = _fnStringToCss( correction );
		
			if ( footer ) {
				settings.nScrollFoot.style.width = _fnStringToCss( correction );
			}
		
		
			/*
			 * 4. Clean up
			 */
			if ( ! scrollY ) {
				/* IE7< puts a vertical scrollbar in place (when it shouldn't be) due to subtracting
				 * the scrollbar height from the visible display, rather than adding it on. We need to
				 * set the height in order to sort this. Don't want to do it in any other browsers.
				 */
				if ( ie67 ) {
					divBodyStyle.height = _fnStringToCss( tableEl.offsetHeight+barWidth );
				}
			}
		
			/* Finally set the width's of the header and footer tables */
			var iOuterWidth = table.outerWidth();
			divHeaderTable[0].style.width = _fnStringToCss( iOuterWidth );
			divHeaderInnerStyle.width = _fnStringToCss( iOuterWidth );
		
			// Figure out if there are scrollbar present - if so then we need a the header and footer to
			// provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
			var bScrolling = table.height() > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
			var padding = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right' );
			divHeaderInnerStyle[ padding ] = bScrolling ? barWidth+"px" : "0px";
		
			if ( footer ) {
				divFooterTable[0].style.width = _fnStringToCss( iOuterWidth );
				divFooterInner[0].style.width = _fnStringToCss( iOuterWidth );
				divFooterInner[0].style[padding] = bScrolling ? barWidth+"px" : "0px";
			}
		
			// Correct DOM ordering for colgroup - comes before the thead
			table.children('colgroup').insertBefore( table.children('thead') );
		
			/* Adjust the position of the header in case we loose the y-scrollbar */
			divBody.scroll();
		
			// If sorting or filtering has occurred, jump the scrolling back to the top
			// only if we aren't holding the position
			if ( (settings.bSorted || settings.bFiltered) && ! settings._drawHold ) {
				divBodyEl.scrollTop = 0;
			}
		}
		
		
		
		/**
		 * Apply a given function to the display child nodes of an element array (typically
		 * TD children of TR rows
		 *  @param {function} fn Method to apply to the objects
		 *  @param array {nodes} an1 List of elements to look through for display children
		 *  @param array {nodes} an2 Another list (identical structure to the first) - optional
		 *  @memberof DataTable#oApi
		 */
		function _fnApplyToChildren( fn, an1, an2 )
		{
			var index=0, i=0, iLen=an1.length;
			var nNode1, nNode2;
		
			while ( i < iLen ) {
				nNode1 = an1[i].firstChild;
				nNode2 = an2 ? an2[i].firstChild : null;
		
				while ( nNode1 ) {
					if ( nNode1.nodeType === 1 ) {
						if ( an2 ) {
							fn( nNode1, nNode2, index );
						}
						else {
							fn( nNode1, index );
						}
		
						index++;
					}
		
					nNode1 = nNode1.nextSibling;
					nNode2 = an2 ? nNode2.nextSibling : null;
				}
		
				i++;
			}
		}
		
		
		
		var __re_html_remove = /<.*?>/g;
		
		
		/**
		 * Calculate the width of columns for the table
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnCalculateColumnWidths ( oSettings )
		{
			var
				table = oSettings.nTable,
				columns = oSettings.aoColumns,
				scroll = oSettings.oScroll,
				scrollY = scroll.sY,
				scrollX = scroll.sX,
				scrollXInner = scroll.sXInner,
				columnCount = columns.length,
				visibleColumns = _fnGetColumns( oSettings, 'bVisible' ),
				headerCells = $('th', oSettings.nTHead),
				tableWidthAttr = table.getAttribute('width'), // from DOM element
				tableContainer = table.parentNode,
				userInputs = false,
				i, column, columnIdx, width, outerWidth,
				browser = oSettings.oBrowser,
				ie67 = browser.bScrollOversize;
		
			var styleWidth = table.style.width;
			if ( styleWidth && styleWidth.indexOf('%') !== -1 ) {
				tableWidthAttr = styleWidth;
			}
		
			/* Convert any user input sizes into pixel sizes */
			for ( i=0 ; i<visibleColumns.length ; i++ ) {
				column = columns[ visibleColumns[i] ];
		
				if ( column.sWidth !== null ) {
					column.sWidth = _fnConvertToWidth( column.sWidthOrig, tableContainer );
		
					userInputs = true;
				}
			}
		
			/* If the number of columns in the DOM equals the number that we have to
			 * process in DataTables, then we can use the offsets that are created by
			 * the web- browser. No custom sizes can be set in order for this to happen,
			 * nor scrolling used
			 */
			if ( ie67 || ! userInputs && ! scrollX && ! scrollY &&
			     columnCount == _fnVisbleColumns( oSettings ) &&
			     columnCount == headerCells.length
			) {
				for ( i=0 ; i<columnCount ; i++ ) {
					var colIdx = _fnVisibleToColumnIndex( oSettings, i );
		
					if ( colIdx !== null ) {
						columns[ colIdx ].sWidth = _fnStringToCss( headerCells.eq(i).width() );
					}
				}
			}
			else
			{
				// Otherwise construct a single row, worst case, table with the widest
				// node in the data, assign any user defined widths, then insert it into
				// the DOM and allow the browser to do all the hard work of calculating
				// table widths
				var tmpTable = $(table).clone() // don't use cloneNode - IE8 will remove events on the main table
					.css( 'visibility', 'hidden' )
					.removeAttr( 'id' );
		
				// Clean up the table body
				tmpTable.find('tbody tr').remove();
				var tr = $('<tr/>').appendTo( tmpTable.find('tbody') );
		
				// Clone the table header and footer - we can't use the header / footer
				// from the cloned table, since if scrolling is active, the table's
				// real header and footer are contained in different table tags
				tmpTable.find('thead, tfoot').remove();
				tmpTable
					.append( $(oSettings.nTHead).clone() )
					.append( $(oSettings.nTFoot).clone() );
		
				// Remove any assigned widths from the footer (from scrolling)
				tmpTable.find('tfoot th, tfoot td').css('width', '');
		
				// Apply custom sizing to the cloned header
				headerCells = _fnGetUniqueThs( oSettings, tmpTable.find('thead')[0] );
		
				for ( i=0 ; i<visibleColumns.length ; i++ ) {
					column = columns[ visibleColumns[i] ];
		
					headerCells[i].style.width = column.sWidthOrig !== null && column.sWidthOrig !== '' ?
						_fnStringToCss( column.sWidthOrig ) :
						'';
		
					// For scrollX we need to force the column width otherwise the
					// browser will collapse it. If this width is smaller than the
					// width the column requires, then it will have no effect
					if ( column.sWidthOrig && scrollX ) {
						$( headerCells[i] ).append( $('<div/>').css( {
							width: column.sWidthOrig,
							margin: 0,
							padding: 0,
							border: 0,
							height: 1
						} ) );
					}
				}
		
				// Find the widest cell for each column and put it into the table
				if ( oSettings.aoData.length ) {
					for ( i=0 ; i<visibleColumns.length ; i++ ) {
						columnIdx = visibleColumns[i];
						column = columns[ columnIdx ];
		
						$( _fnGetWidestNode( oSettings, columnIdx ) )
							.clone( false )
							.append( column.sContentPadding )
							.appendTo( tr );
					}
				}
		
				// Tidy the temporary table - remove name attributes so there aren't
				// duplicated in the dom (radio elements for example)
				$('[name]', tmpTable).removeAttr('name');
		
				// Table has been built, attach to the document so we can work with it.
				// A holding element is used, positioned at the top of the container
				// with minimal height, so it has no effect on if the container scrolls
				// or not. Otherwise it might trigger scrolling when it actually isn't
				// needed
				var holder = $('<div/>').css( scrollX || scrollY ?
						{
							position: 'absolute',
							top: 0,
							left: 0,
							height: 1,
							right: 0,
							overflow: 'hidden'
						} :
						{}
					)
					.append( tmpTable )
					.appendTo( tableContainer );
		
				// When scrolling (X or Y) we want to set the width of the table as 
				// appropriate. However, when not scrolling leave the table width as it
				// is. This results in slightly different, but I think correct behaviour
				if ( scrollX && scrollXInner ) {
					tmpTable.width( scrollXInner );
				}
				else if ( scrollX ) {
					tmpTable.css( 'width', 'auto' );
					tmpTable.removeAttr('width');
		
					// If there is no width attribute or style, then allow the table to
					// collapse
					if ( tmpTable.width() < tableContainer.clientWidth && tableWidthAttr ) {
						tmpTable.width( tableContainer.clientWidth );
					}
				}
				else if ( scrollY ) {
					tmpTable.width( tableContainer.clientWidth );
				}
				else if ( tableWidthAttr ) {
					tmpTable.width( tableWidthAttr );
				}
		
				// Get the width of each column in the constructed table - we need to
				// know the inner width (so it can be assigned to the other table's
				// cells) and the outer width so we can calculate the full width of the
				// table. This is safe since DataTables requires a unique cell for each
				// column, but if ever a header can span multiple columns, this will
				// need to be modified.
				var total = 0;
				for ( i=0 ; i<visibleColumns.length ; i++ ) {
					var cell = $(headerCells[i]);
					var border = cell.outerWidth() - cell.width();
		
					// Use getBounding... where possible (not IE8-) because it can give
					// sub-pixel accuracy, which we then want to round up!
					var bounding = browser.bBounding ?
						Math.ceil( headerCells[i].getBoundingClientRect().width ) :
						cell.outerWidth();
		
					// Total is tracked to remove any sub-pixel errors as the outerWidth
					// of the table might not equal the total given here (IE!).
					total += bounding;
		
					// Width for each column to use
					columns[ visibleColumns[i] ].sWidth = _fnStringToCss( bounding - border );
				}
		
				table.style.width = _fnStringToCss( total );
		
				// Finished with the table - ditch it
				holder.remove();
			}
		
			// If there is a width attr, we want to attach an event listener which
			// allows the table sizing to automatically adjust when the window is
			// resized. Use the width attr rather than CSS, since we can't know if the
			// CSS is a relative value or absolute - DOM read is always px.
			if ( tableWidthAttr ) {
				table.style.width = _fnStringToCss( tableWidthAttr );
			}
		
			if ( (tableWidthAttr || scrollX) && ! oSettings._reszEvt ) {
				var bindResize = function () {
					$(window).on('resize.DT-'+oSettings.sInstance, _fnThrottle( function () {
						_fnAdjustColumnSizing( oSettings );
					} ) );
				};
		
				// IE6/7 will crash if we bind a resize event handler on page load.
				// To be removed in 1.11 which drops IE6/7 support
				if ( ie67 ) {
					setTimeout( bindResize, 1000 );
				}
				else {
					bindResize();
				}
		
				oSettings._reszEvt = true;
			}
		}
		
		
		/**
		 * Throttle the calls to a function. Arguments and context are maintained for
		 * the throttled function
		 *  @param {function} fn Function to be called
		 *  @param {int} [freq=200] call frequency in mS
		 *  @returns {function} wrapped function
		 *  @memberof DataTable#oApi
		 */
		var _fnThrottle = DataTable.util.throttle;
		
		
		/**
		 * Convert a CSS unit width to pixels (e.g. 2em)
		 *  @param {string} width width to be converted
		 *  @param {node} parent parent to get the with for (required for relative widths) - optional
		 *  @returns {int} width in pixels
		 *  @memberof DataTable#oApi
		 */
		function _fnConvertToWidth ( width, parent )
		{
			if ( ! width ) {
				return 0;
			}
		
			var n = $('<div/>')
				.css( 'width', _fnStringToCss( width ) )
				.appendTo( parent || document.body );
		
			var val = n[0].offsetWidth;
			n.remove();
		
			return val;
		}
		
		
		/**
		 * Get the widest node
		 *  @param {object} settings dataTables settings object
		 *  @param {int} colIdx column of interest
		 *  @returns {node} widest table node
		 *  @memberof DataTable#oApi
		 */
		function _fnGetWidestNode( settings, colIdx )
		{
			var idx = _fnGetMaxLenString( settings, colIdx );
			if ( idx < 0 ) {
				return null;
			}
		
			var data = settings.aoData[ idx ];
			return ! data.nTr ? // Might not have been created when deferred rendering
				$('<td/>').html( _fnGetCellData( settings, idx, colIdx, 'display' ) )[0] :
				data.anCells[ colIdx ];
		}
		
		
		/**
		 * Get the maximum strlen for each data column
		 *  @param {object} settings dataTables settings object
		 *  @param {int} colIdx column of interest
		 *  @returns {string} max string length for each column
		 *  @memberof DataTable#oApi
		 */
		function _fnGetMaxLenString( settings, colIdx )
		{
			var s, max=-1, maxIdx = -1;
		
			for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
				s = _fnGetCellData( settings, i, colIdx, 'display' )+'';
				s = s.replace( __re_html_remove, '' );
				s = s.replace( /&nbsp;/g, ' ' );
		
				if ( s.length > max ) {
					max = s.length;
					maxIdx = i;
				}
			}
		
			return maxIdx;
		}
		
		
		/**
		 * Append a CSS unit (only if required) to a string
		 *  @param {string} value to css-ify
		 *  @returns {string} value with css unit
		 *  @memberof DataTable#oApi
		 */
		function _fnStringToCss( s )
		{
			if ( s === null ) {
				return '0px';
			}
		
			if ( typeof s == 'number' ) {
				return s < 0 ?
					'0px' :
					s+'px';
			}
		
			// Check it has a unit character already
			return s.match(/\d$/) ?
				s+'px' :
				s;
		}
		
		
		
		function _fnSortFlatten ( settings )
		{
			var
				i, iLen, k, kLen,
				aSort = [],
				aiOrig = [],
				aoColumns = settings.aoColumns,
				aDataSort, iCol, sType, srcCol,
				fixed = settings.aaSortingFixed,
				fixedObj = $.isPlainObject( fixed ),
				nestedSort = [],
				add = function ( a ) {
					if ( a.length && ! $.isArray( a[0] ) ) {
						// 1D array
						nestedSort.push( a );
					}
					else {
						// 2D array
						$.merge( nestedSort, a );
					}
				};
		
			// Build the sort array, with pre-fix and post-fix options if they have been
			// specified
			if ( $.isArray( fixed ) ) {
				add( fixed );
			}
		
			if ( fixedObj && fixed.pre ) {
				add( fixed.pre );
			}
		
			add( settings.aaSorting );
		
			if (fixedObj && fixed.post ) {
				add( fixed.post );
			}
		
			for ( i=0 ; i<nestedSort.length ; i++ )
			{
				srcCol = nestedSort[i][0];
				aDataSort = aoColumns[ srcCol ].aDataSort;
		
				for ( k=0, kLen=aDataSort.length ; k<kLen ; k++ )
				{
					iCol = aDataSort[k];
					sType = aoColumns[ iCol ].sType || 'string';
		
					if ( nestedSort[i]._idx === undefined ) {
						nestedSort[i]._idx = $.inArray( nestedSort[i][1], aoColumns[iCol].asSorting );
					}
		
					aSort.push( {
						src:       srcCol,
						col:       iCol,
						dir:       nestedSort[i][1],
						index:     nestedSort[i]._idx,
						type:      sType,
						formatter: DataTable.ext.type.order[ sType+"-pre" ]
					} );
				}
			}
		
			return aSort;
		}
		
		/**
		 * Change the order of the table
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 *  @todo This really needs split up!
		 */
		function _fnSort ( oSettings )
		{
			var
				i, ien, iLen, j, jLen, k, kLen,
				sDataType, nTh,
				aiOrig = [],
				oExtSort = DataTable.ext.type.order,
				aoData = oSettings.aoData,
				aoColumns = oSettings.aoColumns,
				aDataSort, data, iCol, sType, oSort,
				formatters = 0,
				sortCol,
				displayMaster = oSettings.aiDisplayMaster,
				aSort;
		
			// Resolve any column types that are unknown due to addition or invalidation
			// @todo Can this be moved into a 'data-ready' handler which is called when
			//   data is going to be used in the table?
			_fnColumnTypes( oSettings );
		
			aSort = _fnSortFlatten( oSettings );
		
			for ( i=0, ien=aSort.length ; i<ien ; i++ ) {
				sortCol = aSort[i];
		
				// Track if we can use the fast sort algorithm
				if ( sortCol.formatter ) {
					formatters++;
				}
		
				// Load the data needed for the sort, for each cell
				_fnSortData( oSettings, sortCol.col );
			}
		
			/* No sorting required if server-side or no sorting array */
			if ( _fnDataSource( oSettings ) != 'ssp' && aSort.length !== 0 )
			{
				// Create a value - key array of the current row positions such that we can use their
				// current position during the sort, if values match, in order to perform stable sorting
				for ( i=0, iLen=displayMaster.length ; i<iLen ; i++ ) {
					aiOrig[ displayMaster[i] ] = i;
				}
		
				/* Do the sort - here we want multi-column sorting based on a given data source (column)
				 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
				 * follow on it's own, but this is what we want (example two column sorting):
				 *  fnLocalSorting = function(a,b){
				 *    var iTest;
				 *    iTest = oSort['string-asc']('data11', 'data12');
				 *      if (iTest !== 0)
				 *        return iTest;
				 *    iTest = oSort['numeric-desc']('data21', 'data22');
				 *    if (iTest !== 0)
				 *      return iTest;
				 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
				 *  }
				 * Basically we have a test for each sorting column, if the data in that column is equal,
				 * test the next column. If all columns match, then we use a numeric sort on the row
				 * positions in the original data array to provide a stable sort.
				 *
				 * Note - I know it seems excessive to have two sorting methods, but the first is around
				 * 15% faster, so the second is only maintained for backwards compatibility with sorting
				 * methods which do not have a pre-sort formatting function.
				 */
				if ( formatters === aSort.length ) {
					// All sort types have formatting functions
					displayMaster.sort( function ( a, b ) {
						var
							x, y, k, test, sort,
							len=aSort.length,
							dataA = aoData[a]._aSortData,
							dataB = aoData[b]._aSortData;
		
						for ( k=0 ; k<len ; k++ ) {
							sort = aSort[k];
		
							x = dataA[ sort.col ];
							y = dataB[ sort.col ];
		
							test = x<y ? -1 : x>y ? 1 : 0;
							if ( test !== 0 ) {
								return sort.dir === 'asc' ? test : -test;
							}
						}
		
						x = aiOrig[a];
						y = aiOrig[b];
						return x<y ? -1 : x>y ? 1 : 0;
					} );
				}
				else {
					// Depreciated - remove in 1.11 (providing a plug-in option)
					// Not all sort types have formatting methods, so we have to call their sorting
					// methods.
					displayMaster.sort( function ( a, b ) {
						var
							x, y, k, l, test, sort, fn,
							len=aSort.length,
							dataA = aoData[a]._aSortData,
							dataB = aoData[b]._aSortData;
		
						for ( k=0 ; k<len ; k++ ) {
							sort = aSort[k];
		
							x = dataA[ sort.col ];
							y = dataB[ sort.col ];
		
							fn = oExtSort[ sort.type+"-"+sort.dir ] || oExtSort[ "string-"+sort.dir ];
							test = fn( x, y );
							if ( test !== 0 ) {
								return test;
							}
						}
		
						x = aiOrig[a];
						y = aiOrig[b];
						return x<y ? -1 : x>y ? 1 : 0;
					} );
				}
			}
		
			/* Tell the draw function that we have sorted the data */
			oSettings.bSorted = true;
		}
		
		
		function _fnSortAria ( settings )
		{
			var label;
			var nextSort;
			var columns = settings.aoColumns;
			var aSort = _fnSortFlatten( settings );
			var oAria = settings.oLanguage.oAria;
		
			// ARIA attributes - need to loop all columns, to update all (removing old
			// attributes as needed)
			for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
			{
				var col = columns[i];
				var asSorting = col.asSorting;
				var sTitle = col.sTitle.replace( /<.*?>/g, "" );
				var th = col.nTh;
		
				// IE7 is throwing an error when setting these properties with jQuery's
				// attr() and removeAttr() methods...
				th.removeAttribute('aria-sort');
		
				/* In ARIA only the first sorting column can be marked as sorting - no multi-sort option */
				if ( col.bSortable ) {
					if ( aSort.length > 0 && aSort[0].col == i ) {
						th.setAttribute('aria-sort', aSort[0].dir=="asc" ? "ascending" : "descending" );
						nextSort = asSorting[ aSort[0].index+1 ] || asSorting[0];
					}
					else {
						nextSort = asSorting[0];
					}
		
					label = sTitle + ( nextSort === "asc" ?
						oAria.sSortAscending :
						oAria.sSortDescending
					);
				}
				else {
					label = sTitle;
				}
		
				th.setAttribute('aria-label', label);
			}
		}
		
		
		/**
		 * Function to run on user sort request
		 *  @param {object} settings dataTables settings object
		 *  @param {node} attachTo node to attach the handler to
		 *  @param {int} colIdx column sorting index
		 *  @param {boolean} [append=false] Append the requested sort to the existing
		 *    sort if true (i.e. multi-column sort)
		 *  @param {function} [callback] callback function
		 *  @memberof DataTable#oApi
		 */
		function _fnSortListener ( settings, colIdx, append, callback )
		{
			var col = settings.aoColumns[ colIdx ];
			var sorting = settings.aaSorting;
			var asSorting = col.asSorting;
			var nextSortIdx;
			var next = function ( a, overflow ) {
				var idx = a._idx;
				if ( idx === undefined ) {
					idx = $.inArray( a[1], asSorting );
				}
		
				return idx+1 < asSorting.length ?
					idx+1 :
					overflow ?
						null :
						0;
			};
		
			// Convert to 2D array if needed
			if ( typeof sorting[0] === 'number' ) {
				sorting = settings.aaSorting = [ sorting ];
			}
		
			// If appending the sort then we are multi-column sorting
			if ( append && settings.oFeatures.bSortMulti ) {
				// Are we already doing some kind of sort on this column?
				var sortIdx = $.inArray( colIdx, _pluck(sorting, '0') );
		
				if ( sortIdx !== -1 ) {
					// Yes, modify the sort
					nextSortIdx = next( sorting[sortIdx], true );
		
					if ( nextSortIdx === null && sorting.length === 1 ) {
						nextSortIdx = 0; // can't remove sorting completely
					}
		
					if ( nextSortIdx === null ) {
						sorting.splice( sortIdx, 1 );
					}
					else {
						sorting[sortIdx][1] = asSorting[ nextSortIdx ];
						sorting[sortIdx]._idx = nextSortIdx;
					}
				}
				else {
					// No sort on this column yet
					sorting.push( [ colIdx, asSorting[0], 0 ] );
					sorting[sorting.length-1]._idx = 0;
				}
			}
			else if ( sorting.length && sorting[0][0] == colIdx ) {
				// Single column - already sorting on this column, modify the sort
				nextSortIdx = next( sorting[0] );
		
				sorting.length = 1;
				sorting[0][1] = asSorting[ nextSortIdx ];
				sorting[0]._idx = nextSortIdx;
			}
			else {
				// Single column - sort only on this column
				sorting.length = 0;
				sorting.push( [ colIdx, asSorting[0] ] );
				sorting[0]._idx = 0;
			}
		
			// Run the sort by calling a full redraw
			_fnReDraw( settings );
		
			// callback used for async user interaction
			if ( typeof callback == 'function' ) {
				callback( settings );
			}
		}
		
		
		/**
		 * Attach a sort handler (click) to a node
		 *  @param {object} settings dataTables settings object
		 *  @param {node} attachTo node to attach the handler to
		 *  @param {int} colIdx column sorting index
		 *  @param {function} [callback] callback function
		 *  @memberof DataTable#oApi
		 */
		function _fnSortAttachListener ( settings, attachTo, colIdx, callback )
		{
			var col = settings.aoColumns[ colIdx ];
		
			_fnBindAction( attachTo, {}, function (e) {
				/* If the column is not sortable - don't to anything */
				if ( col.bSortable === false ) {
					return;
				}
		
				// If processing is enabled use a timeout to allow the processing
				// display to be shown - otherwise to it synchronously
				if ( settings.oFeatures.bProcessing ) {
					_fnProcessingDisplay( settings, true );
		
					setTimeout( function() {
						_fnSortListener( settings, colIdx, e.shiftKey, callback );
		
						// In server-side processing, the draw callback will remove the
						// processing display
						if ( _fnDataSource( settings ) !== 'ssp' ) {
							_fnProcessingDisplay( settings, false );
						}
					}, 0 );
				}
				else {
					_fnSortListener( settings, colIdx, e.shiftKey, callback );
				}
			} );
		}
		
		
		/**
		 * Set the sorting classes on table's body, Note: it is safe to call this function
		 * when bSort and bSortClasses are false
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnSortingClasses( settings )
		{
			var oldSort = settings.aLastSort;
			var sortClass = settings.oClasses.sSortColumn;
			var sort = _fnSortFlatten( settings );
			var features = settings.oFeatures;
			var i, ien, colIdx;
		
			if ( features.bSort && features.bSortClasses ) {
				// Remove old sorting classes
				for ( i=0, ien=oldSort.length ; i<ien ; i++ ) {
					colIdx = oldSort[i].src;
		
					// Remove column sorting
					$( _pluck( settings.aoData, 'anCells', colIdx ) )
						.removeClass( sortClass + (i<2 ? i+1 : 3) );
				}
		
				// Add new column sorting
				for ( i=0, ien=sort.length ; i<ien ; i++ ) {
					colIdx = sort[i].src;
		
					$( _pluck( settings.aoData, 'anCells', colIdx ) )
						.addClass( sortClass + (i<2 ? i+1 : 3) );
				}
			}
		
			settings.aLastSort = sort;
		}
		
		
		// Get the data to sort a column, be it from cache, fresh (populating the
		// cache), or from a sort formatter
		function _fnSortData( settings, idx )
		{
			// Custom sorting function - provided by the sort data type
			var column = settings.aoColumns[ idx ];
			var customSort = DataTable.ext.order[ column.sSortDataType ];
			var customData;
		
			if ( customSort ) {
				customData = customSort.call( settings.oInstance, settings, idx,
					_fnColumnIndexToVisible( settings, idx )
				);
			}
		
			// Use / populate cache
			var row, cellData;
			var formatter = DataTable.ext.type.order[ column.sType+"-pre" ];
		
			for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
				row = settings.aoData[i];
		
				if ( ! row._aSortData ) {
					row._aSortData = [];
				}
		
				if ( ! row._aSortData[idx] || customSort ) {
					cellData = customSort ?
						customData[i] : // If there was a custom sort function, use data from there
						_fnGetCellData( settings, i, idx, 'sort' );
		
					row._aSortData[ idx ] = formatter ?
						formatter( cellData ) :
						cellData;
				}
			}
		}
		
		
		
		/**
		 * Save the state of a table
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnSaveState ( settings )
		{
			if ( !settings.oFeatures.bStateSave || settings.bDestroying )
			{
				return;
			}
		
			/* Store the interesting variables */
			var state = {
				time:    +new Date(),
				start:   settings._iDisplayStart,
				length:  settings._iDisplayLength,
				order:   $.extend( true, [], settings.aaSorting ),
				search:  _fnSearchToCamel( settings.oPreviousSearch ),
				columns: $.map( settings.aoColumns, function ( col, i ) {
					return {
						visible: col.bVisible,
						search: _fnSearchToCamel( settings.aoPreSearchCols[i] )
					};
				} )
			};
		
			_fnCallbackFire( settings, "aoStateSaveParams", 'stateSaveParams', [settings, state] );
		
			settings.oSavedState = state;
			settings.fnStateSaveCallback.call( settings.oInstance, settings, state );
		}
		
		
		/**
		 * Attempt to load a saved table state
		 *  @param {object} oSettings dataTables settings object
		 *  @param {object} oInit DataTables init object so we can override settings
		 *  @param {function} callback Callback to execute when the state has been loaded
		 *  @memberof DataTable#oApi
		 */
		function _fnLoadState ( settings, oInit, callback )
		{
			var i, ien;
			var columns = settings.aoColumns;
			var loaded = function ( s ) {
				if ( ! s || ! s.time ) {
					callback();
					return;
				}
		
				// Allow custom and plug-in manipulation functions to alter the saved data set and
				// cancelling of loading by returning false
				var abStateLoad = _fnCallbackFire( settings, 'aoStateLoadParams', 'stateLoadParams', [settings, s] );
				if ( $.inArray( false, abStateLoad ) !== -1 ) {
					callback();
					return;
				}
		
				// Reject old data
				var duration = settings.iStateDuration;
				if ( duration > 0 && s.time < +new Date() - (duration*1000) ) {
					callback();
					return;
				}
		
				// Number of columns have changed - all bets are off, no restore of settings
				if ( s.columns && columns.length !== s.columns.length ) {
					callback();
					return;
				}
		
				// Store the saved state so it might be accessed at any time
				settings.oLoadedState = $.extend( true, {}, s );
		
				// Restore key features - todo - for 1.11 this needs to be done by
				// subscribed events
				if ( s.start !== undefined ) {
					settings._iDisplayStart    = s.start;
					settings.iInitDisplayStart = s.start;
				}
				if ( s.length !== undefined ) {
					settings._iDisplayLength   = s.length;
				}
		
				// Order
				if ( s.order !== undefined ) {
					settings.aaSorting = [];
					$.each( s.order, function ( i, col ) {
						settings.aaSorting.push( col[0] >= columns.length ?
							[ 0, col[1] ] :
							col
						);
					} );
				}
		
				// Search
				if ( s.search !== undefined ) {
					$.extend( settings.oPreviousSearch, _fnSearchToHung( s.search ) );
				}
		
				// Columns
				//
				if ( s.columns ) {
					for ( i=0, ien=s.columns.length ; i<ien ; i++ ) {
						var col = s.columns[i];
		
						// Visibility
						if ( col.visible !== undefined ) {
							columns[i].bVisible = col.visible;
						}
		
						// Search
						if ( col.search !== undefined ) {
							$.extend( settings.aoPreSearchCols[i], _fnSearchToHung( col.search ) );
						}
					}
				}
		
				_fnCallbackFire( settings, 'aoStateLoaded', 'stateLoaded', [settings, s] );
				callback();
			}
		
			if ( ! settings.oFeatures.bStateSave ) {
				callback();
				return;
			}
		
			var state = settings.fnStateLoadCallback.call( settings.oInstance, settings, loaded );
		
			if ( state !== undefined ) {
				loaded( state );
			}
			// otherwise, wait for the loaded callback to be executed
		}
		
		
		/**
		 * Return the settings object for a particular table
		 *  @param {node} table table we are using as a dataTable
		 *  @returns {object} Settings object - or null if not found
		 *  @memberof DataTable#oApi
		 */
		function _fnSettingsFromNode ( table )
		{
			var settings = DataTable.settings;
			var idx = $.inArray( table, _pluck( settings, 'nTable' ) );
		
			return idx !== -1 ?
				settings[ idx ] :
				null;
		}
		
		
		/**
		 * Log an error message
		 *  @param {object} settings dataTables settings object
		 *  @param {int} level log error messages, or display them to the user
		 *  @param {string} msg error message
		 *  @param {int} tn Technical note id to get more information about the error.
		 *  @memberof DataTable#oApi
		 */
		function _fnLog( settings, level, msg, tn )
		{
			msg = 'DataTables warning: '+
				(settings ? 'table id='+settings.sTableId+' - ' : '')+msg;
		
			if ( tn ) {
				msg += '. For more information about this error, please see '+
				'http://datatables.net/tn/'+tn;
			}
		
			if ( ! level  ) {
				// Backwards compatibility pre 1.10
				var ext = DataTable.ext;
				var type = ext.sErrMode || ext.errMode;
		
				if ( settings ) {
					_fnCallbackFire( settings, null, 'error', [ settings, tn, msg ] );
				}
		
				if ( type == 'alert' ) {
					alert( msg );
				}
				else if ( type == 'throw' ) {
					throw new Error(msg);
				}
				else if ( typeof type == 'function' ) {
					type( settings, tn, msg );
				}
			}
			else if ( window.console && console.log ) {
				console.log( msg );
			}
		}
		
		
		/**
		 * See if a property is defined on one object, if so assign it to the other object
		 *  @param {object} ret target object
		 *  @param {object} src source object
		 *  @param {string} name property
		 *  @param {string} [mappedName] name to map too - optional, name used if not given
		 *  @memberof DataTable#oApi
		 */
		function _fnMap( ret, src, name, mappedName )
		{
			if ( $.isArray( name ) ) {
				$.each( name, function (i, val) {
					if ( $.isArray( val ) ) {
						_fnMap( ret, src, val[0], val[1] );
					}
					else {
						_fnMap( ret, src, val );
					}
				} );
		
				return;
			}
		
			if ( mappedName === undefined ) {
				mappedName = name;
			}
		
			if ( src[name] !== undefined ) {
				ret[mappedName] = src[name];
			}
		}
		
		
		/**
		 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
		 * shallow copy arrays. The reason we need to do this, is that we don't want to
		 * deep copy array init values (such as aaSorting) since the dev wouldn't be
		 * able to override them, but we do want to deep copy arrays.
		 *  @param {object} out Object to extend
		 *  @param {object} extender Object from which the properties will be applied to
		 *      out
		 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
		 *      independent copy with the exception of the `data` or `aaData` parameters
		 *      if they are present. This is so you can pass in a collection to
		 *      DataTables and have that used as your data source without breaking the
		 *      references
		 *  @returns {object} out Reference, just for convenience - out === the return.
		 *  @memberof DataTable#oApi
		 *  @todo This doesn't take account of arrays inside the deep copied objects.
		 */
		function _fnExtend( out, extender, breakRefs )
		{
			var val;
		
			for ( var prop in extender ) {
				if ( extender.hasOwnProperty(prop) ) {
					val = extender[prop];
		
					if ( $.isPlainObject( val ) ) {
						if ( ! $.isPlainObject( out[prop] ) ) {
							out[prop] = {};
						}
						$.extend( true, out[prop], val );
					}
					else if ( breakRefs && prop !== 'data' && prop !== 'aaData' && $.isArray(val) ) {
						out[prop] = val.slice();
					}
					else {
						out[prop] = val;
					}
				}
			}
		
			return out;
		}
		
		
		/**
		 * Bind an event handers to allow a click or return key to activate the callback.
		 * This is good for accessibility since a return on the keyboard will have the
		 * same effect as a click, if the element has focus.
		 *  @param {element} n Element to bind the action to
		 *  @param {object} oData Data object to pass to the triggered function
		 *  @param {function} fn Callback function for when the event is triggered
		 *  @memberof DataTable#oApi
		 */
		function _fnBindAction( n, oData, fn )
		{
			$(n)
				.on( 'click.DT', oData, function (e) {
						n.blur(); // Remove focus outline for mouse users
						fn(e);
					} )
				.on( 'keypress.DT', oData, function (e){
						if ( e.which === 13 ) {
							e.preventDefault();
							fn(e);
						}
					} )
				.on( 'selectstart.DT', function () {
						/* Take the brutal approach to cancelling text selection */
						return false;
					} );
		}
		
		
		/**
		 * Register a callback function. Easily allows a callback function to be added to
		 * an array store of callback functions that can then all be called together.
		 *  @param {object} oSettings dataTables settings object
		 *  @param {string} sStore Name of the array storage for the callbacks in oSettings
		 *  @param {function} fn Function to be called back
		 *  @param {string} sName Identifying name for the callback (i.e. a label)
		 *  @memberof DataTable#oApi
		 */
		function _fnCallbackReg( oSettings, sStore, fn, sName )
		{
			if ( fn )
			{
				oSettings[sStore].push( {
					"fn": fn,
					"sName": sName
				} );
			}
		}
		
		
		/**
		 * Fire callback functions and trigger events. Note that the loop over the
		 * callback array store is done backwards! Further note that you do not want to
		 * fire off triggers in time sensitive applications (for example cell creation)
		 * as its slow.
		 *  @param {object} settings dataTables settings object
		 *  @param {string} callbackArr Name of the array storage for the callbacks in
		 *      oSettings
		 *  @param {string} eventName Name of the jQuery custom event to trigger. If
		 *      null no trigger is fired
		 *  @param {array} args Array of arguments to pass to the callback function /
		 *      trigger
		 *  @memberof DataTable#oApi
		 */
		function _fnCallbackFire( settings, callbackArr, eventName, args )
		{
			var ret = [];
		
			if ( callbackArr ) {
				ret = $.map( settings[callbackArr].slice().reverse(), function (val, i) {
					return val.fn.apply( settings.oInstance, args );
				} );
			}
		
			if ( eventName !== null ) {
				var e = $.Event( eventName+'.dt' );
		
				$(settings.nTable).trigger( e, args );
		
				ret.push( e.result );
			}
		
			return ret;
		}
		
		
		function _fnLengthOverflow ( settings )
		{
			var
				start = settings._iDisplayStart,
				end = settings.fnDisplayEnd(),
				len = settings._iDisplayLength;
		
			/* If we have space to show extra rows (backing up from the end point - then do so */
			if ( start >= end )
			{
				start = end - len;
			}
		
			// Keep the start record on the current page
			start -= (start % len);
		
			if ( len === -1 || start < 0 )
			{
				start = 0;
			}
		
			settings._iDisplayStart = start;
		}
		
		
		function _fnRenderer( settings, type )
		{
			var renderer = settings.renderer;
			var host = DataTable.ext.renderer[type];
		
			if ( $.isPlainObject( renderer ) && renderer[type] ) {
				// Specific renderer for this type. If available use it, otherwise use
				// the default.
				return host[renderer[type]] || host._;
			}
			else if ( typeof renderer === 'string' ) {
				// Common renderer - if there is one available for this type use it,
				// otherwise use the default
				return host[renderer] || host._;
			}
		
			// Use the default
			return host._;
		}
		
		
		/**
		 * Detect the data source being used for the table. Used to simplify the code
		 * a little (ajax) and to make it compress a little smaller.
		 *
		 *  @param {object} settings dataTables settings object
		 *  @returns {string} Data source
		 *  @memberof DataTable#oApi
		 */
		function _fnDataSource ( settings )
		{
			if ( settings.oFeatures.bServerSide ) {
				return 'ssp';
			}
			else if ( settings.ajax || settings.sAjaxSource ) {
				return 'ajax';
			}
			return 'dom';
		}
		
	
		
		
		/**
		 * Computed structure of the DataTables API, defined by the options passed to
		 * `DataTable.Api.register()` when building the API.
		 *
		 * The structure is built in order to speed creation and extension of the Api
		 * objects since the extensions are effectively pre-parsed.
		 *
		 * The array is an array of objects with the following structure, where this
		 * base array represents the Api prototype base:
		 *
		 *     [
		 *       {
		 *         name:      'data'                -- string   - Property name
		 *         val:       function () {},       -- function - Api method (or undefined if just an object
		 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
		 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
		 *       },
		 *       {
		 *         name:     'row'
		 *         val:       {},
		 *         methodExt: [ ... ],
		 *         propExt:   [
		 *           {
		 *             name:      'data'
		 *             val:       function () {},
		 *             methodExt: [ ... ],
		 *             propExt:   [ ... ]
		 *           },
		 *           ...
		 *         ]
		 *       }
		 *     ]
		 *
		 * @type {Array}
		 * @ignore
		 */
		var __apiStruct = [];
		
		
		/**
		 * `Array.prototype` reference.
		 *
		 * @type object
		 * @ignore
		 */
		var __arrayProto = Array.prototype;
		
		
		/**
		 * Abstraction for `context` parameter of the `Api` constructor to allow it to
		 * take several different forms for ease of use.
		 *
		 * Each of the input parameter types will be converted to a DataTables settings
		 * object where possible.
		 *
		 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
		 *   of:
		 *
		 *   * `string` - jQuery selector. Any DataTables' matching the given selector
		 *     with be found and used.
		 *   * `node` - `TABLE` node which has already been formed into a DataTable.
		 *   * `jQuery` - A jQuery object of `TABLE` nodes.
		 *   * `object` - DataTables settings object
		 *   * `DataTables.Api` - API instance
		 * @return {array|null} Matching DataTables settings objects. `null` or
		 *   `undefined` is returned if no matching DataTable is found.
		 * @ignore
		 */
		var _toSettings = function ( mixed )
		{
			var idx, jq;
			var settings = DataTable.settings;
			var tables = $.map( settings, function (el, i) {
				return el.nTable;
			} );
		
			if ( ! mixed ) {
				return [];
			}
			else if ( mixed.nTable && mixed.oApi ) {
				// DataTables settings object
				return [ mixed ];
			}
			else if ( mixed.nodeName && mixed.nodeName.toLowerCase() === 'table' ) {
				// Table node
				idx = $.inArray( mixed, tables );
				return idx !== -1 ? [ settings[idx] ] : null;
			}
			else if ( mixed && typeof mixed.settings === 'function' ) {
				return mixed.settings().toArray();
			}
			else if ( typeof mixed === 'string' ) {
				// jQuery selector
				jq = $(mixed);
			}
			else if ( mixed instanceof $ ) {
				// jQuery object (also DataTables instance)
				jq = mixed;
			}
		
			if ( jq ) {
				return jq.map( function(i) {
					idx = $.inArray( this, tables );
					return idx !== -1 ? settings[idx] : null;
				} ).toArray();
			}
		};
		
		
		/**
		 * DataTables API class - used to control and interface with  one or more
		 * DataTables enhanced tables.
		 *
		 * The API class is heavily based on jQuery, presenting a chainable interface
		 * that you can use to interact with tables. Each instance of the API class has
		 * a "context" - i.e. the tables that it will operate on. This could be a single
		 * table, all tables on a page or a sub-set thereof.
		 *
		 * Additionally the API is designed to allow you to easily work with the data in
		 * the tables, retrieving and manipulating it as required. This is done by
		 * presenting the API class as an array like interface. The contents of the
		 * array depend upon the actions requested by each method (for example
		 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
		 * return an array of objects or arrays depending upon your table's
		 * configuration). The API object has a number of array like methods (`push`,
		 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
		 * `unique` etc) to assist your working with the data held in a table.
		 *
		 * Most methods (those which return an Api instance) are chainable, which means
		 * the return from a method call also has all of the methods available that the
		 * top level object had. For example, these two calls are equivalent:
		 *
		 *     // Not chained
		 *     api.row.add( {...} );
		 *     api.draw();
		 *
		 *     // Chained
		 *     api.row.add( {...} ).draw();
		 *
		 * @class DataTable.Api
		 * @param {array|object|string|jQuery} context DataTable identifier. This is
		 *   used to define which DataTables enhanced tables this API will operate on.
		 *   Can be one of:
		 *
		 *   * `string` - jQuery selector. Any DataTables' matching the given selector
		 *     with be found and used.
		 *   * `node` - `TABLE` node which has already been formed into a DataTable.
		 *   * `jQuery` - A jQuery object of `TABLE` nodes.
		 *   * `object` - DataTables settings object
		 * @param {array} [data] Data to initialise the Api instance with.
		 *
		 * @example
		 *   // Direct initialisation during DataTables construction
		 *   var api = $('#example').DataTable();
		 *
		 * @example
		 *   // Initialisation using a DataTables jQuery object
		 *   var api = $('#example').dataTable().api();
		 *
		 * @example
		 *   // Initialisation as a constructor
		 *   var api = new $.fn.DataTable.Api( 'table.dataTable' );
		 */
		_Api = function ( context, data )
		{
			if ( ! (this instanceof _Api) ) {
				return new _Api( context, data );
			}
		
			var settings = [];
			var ctxSettings = function ( o ) {
				var a = _toSettings( o );
				if ( a ) {
					settings = settings.concat( a );
				}
			};
		
			if ( $.isArray( context ) ) {
				for ( var i=0, ien=context.length ; i<ien ; i++ ) {
					ctxSettings( context[i] );
				}
			}
			else {
				ctxSettings( context );
			}
		
			// Remove duplicates
			this.context = _unique( settings );
		
			// Initial data
			if ( data ) {
				$.merge( this, data );
			}
		
			// selector
			this.selector = {
				rows: null,
				cols: null,
				opts: null
			};
		
			_Api.extend( this, this, __apiStruct );
		};
		
		DataTable.Api = _Api;
		
		// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
		// isPlainObject.
		$.extend( _Api.prototype, {
			any: function ()
			{
				return this.count() !== 0;
			},
		
		
			concat:  __arrayProto.concat,
		
		
			context: [], // array of table settings objects
		
		
			count: function ()
			{
				return this.flatten().length;
			},
		
		
			each: function ( fn )
			{
				for ( var i=0, ien=this.length ; i<ien; i++ ) {
					fn.call( this, this[i], i, this );
				}
		
				return this;
			},
		
		
			eq: function ( idx )
			{
				var ctx = this.context;
		
				return ctx.length > idx ?
					new _Api( ctx[idx], this[idx] ) :
					null;
			},
		
		
			filter: function ( fn )
			{
				var a = [];
		
				if ( __arrayProto.filter ) {
					a = __arrayProto.filter.call( this, fn, this );
				}
				else {
					// Compatibility for browsers without EMCA-252-5 (JS 1.6)
					for ( var i=0, ien=this.length ; i<ien ; i++ ) {
						if ( fn.call( this, this[i], i, this ) ) {
							a.push( this[i] );
						}
					}
				}
		
				return new _Api( this.context, a );
			},
		
		
			flatten: function ()
			{
				var a = [];
				return new _Api( this.context, a.concat.apply( a, this.toArray() ) );
			},
		
		
			join:    __arrayProto.join,
		
		
			indexOf: __arrayProto.indexOf || function (obj, start)
			{
				for ( var i=(start || 0), ien=this.length ; i<ien ; i++ ) {
					if ( this[i] === obj ) {
						return i;
					}
				}
				return -1;
			},
		
			iterator: function ( flatten, type, fn, alwaysNew ) {
				var
					a = [], ret,
					i, ien, j, jen,
					context = this.context,
					rows, items, item,
					selector = this.selector;
		
				// Argument shifting
				if ( typeof flatten === 'string' ) {
					alwaysNew = fn;
					fn = type;
					type = flatten;
					flatten = false;
				}
		
				for ( i=0, ien=context.length ; i<ien ; i++ ) {
					var apiInst = new _Api( context[i] );
		
					if ( type === 'table' ) {
						ret = fn.call( apiInst, context[i], i );
		
						if ( ret !== undefined ) {
							a.push( ret );
						}
					}
					else if ( type === 'columns' || type === 'rows' ) {
						// this has same length as context - one entry for each table
						ret = fn.call( apiInst, context[i], this[i], i );
		
						if ( ret !== undefined ) {
							a.push( ret );
						}
					}
					else if ( type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell' ) {
						// columns and rows share the same structure.
						// 'this' is an array of column indexes for each context
						items = this[i];
		
						if ( type === 'column-rows' ) {
							rows = _selector_row_indexes( context[i], selector.opts );
						}
		
						for ( j=0, jen=items.length ; j<jen ; j++ ) {
							item = items[j];
		
							if ( type === 'cell' ) {
								ret = fn.call( apiInst, context[i], item.row, item.column, i, j );
							}
							else {
								ret = fn.call( apiInst, context[i], item, i, j, rows );
							}
		
							if ( ret !== undefined ) {
								a.push( ret );
							}
						}
					}
				}
		
				if ( a.length || alwaysNew ) {
					var api = new _Api( context, flatten ? a.concat.apply( [], a ) : a );
					var apiSelector = api.selector;
					apiSelector.rows = selector.rows;
					apiSelector.cols = selector.cols;
					apiSelector.opts = selector.opts;
					return api;
				}
				return this;
			},
		
		
			lastIndexOf: __arrayProto.lastIndexOf || function (obj, start)
			{
				// Bit cheeky...
				return this.indexOf.apply( this.toArray.reverse(), arguments );
			},
		
		
			length:  0,
		
		
			map: function ( fn )
			{
				var a = [];
		
				if ( __arrayProto.map ) {
					a = __arrayProto.map.call( this, fn, this );
				}
				else {
					// Compatibility for browsers without EMCA-252-5 (JS 1.6)
					for ( var i=0, ien=this.length ; i<ien ; i++ ) {
						a.push( fn.call( this, this[i], i ) );
					}
				}
		
				return new _Api( this.context, a );
			},
		
		
			pluck: function ( prop )
			{
				return this.map( function ( el ) {
					return el[ prop ];
				} );
			},
		
			pop:     __arrayProto.pop,
		
		
			push:    __arrayProto.push,
		
		
			// Does not return an API instance
			reduce: __arrayProto.reduce || function ( fn, init )
			{
				return _fnReduce( this, fn, init, 0, this.length, 1 );
			},
		
		
			reduceRight: __arrayProto.reduceRight || function ( fn, init )
			{
				return _fnReduce( this, fn, init, this.length-1, -1, -1 );
			},
		
		
			reverse: __arrayProto.reverse,
		
		
			// Object with rows, columns and opts
			selector: null,
		
		
			shift:   __arrayProto.shift,
		
		
			slice: function () {
				return new _Api( this.context, this );
			},
		
		
			sort:    __arrayProto.sort, // ? name - order?
		
		
			splice:  __arrayProto.splice,
		
		
			toArray: function ()
			{
				return __arrayProto.slice.call( this );
			},
		
		
			to$: function ()
			{
				return $( this );
			},
		
		
			toJQuery: function ()
			{
				return $( this );
			},
		
		
			unique: function ()
			{
				return new _Api( this.context, _unique(this) );
			},
		
		
			unshift: __arrayProto.unshift
		} );
		
		
		_Api.extend = function ( scope, obj, ext )
		{
			// Only extend API instances and static properties of the API
			if ( ! ext.length || ! obj || ( ! (obj instanceof _Api) && ! obj.__dt_wrapper ) ) {
				return;
			}
		
			var
				i, ien,
				j, jen,
				struct, inner,
				methodScoping = function ( scope, fn, struc ) {
					return function () {
						var ret = fn.apply( scope, arguments );
		
						// Method extension
						_Api.extend( ret, ret, struc.methodExt );
						return ret;
					};
				};
		
			for ( i=0, ien=ext.length ; i<ien ; i++ ) {
				struct = ext[i];
		
				// Value
				obj[ struct.name ] = typeof struct.val === 'function' ?
					methodScoping( scope, struct.val, struct ) :
					$.isPlainObject( struct.val ) ?
						{} :
						struct.val;
		
				obj[ struct.name ].__dt_wrapper = true;
		
				// Property extension
				_Api.extend( scope, obj[ struct.name ], struct.propExt );
			}
		};
		
		
		// @todo - Is there need for an augment function?
		// _Api.augment = function ( inst, name )
		// {
		// 	// Find src object in the structure from the name
		// 	var parts = name.split('.');
		
		// 	_Api.extend( inst, obj );
		// };
		
		
		//     [
		//       {
		//         name:      'data'                -- string   - Property name
		//         val:       function () {},       -- function - Api method (or undefined if just an object
		//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
		//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
		//       },
		//       {
		//         name:     'row'
		//         val:       {},
		//         methodExt: [ ... ],
		//         propExt:   [
		//           {
		//             name:      'data'
		//             val:       function () {},
		//             methodExt: [ ... ],
		//             propExt:   [ ... ]
		//           },
		//           ...
		//         ]
		//       }
		//     ]
		
		_Api.register = _api_register = function ( name, val )
		{
			if ( $.isArray( name ) ) {
				for ( var j=0, jen=name.length ; j<jen ; j++ ) {
					_Api.register( name[j], val );
				}
				return;
			}
		
			var
				i, ien,
				heir = name.split('.'),
				struct = __apiStruct,
				key, method;
		
			var find = function ( src, name ) {
				for ( var i=0, ien=src.length ; i<ien ; i++ ) {
					if ( src[i].name === name ) {
						return src[i];
					}
				}
				return null;
			};
		
			for ( i=0, ien=heir.length ; i<ien ; i++ ) {
				method = heir[i].indexOf('()') !== -1;
				key = method ?
					heir[i].replace('()', '') :
					heir[i];
		
				var src = find( struct, key );
				if ( ! src ) {
					src = {
						name:      key,
						val:       {},
						methodExt: [],
						propExt:   []
					};
					struct.push( src );
				}
		
				if ( i === ien-1 ) {
					src.val = val;
				}
				else {
					struct = method ?
						src.methodExt :
						src.propExt;
				}
			}
		};
		
		
		_Api.registerPlural = _api_registerPlural = function ( pluralName, singularName, val ) {
			_Api.register( pluralName, val );
		
			_Api.register( singularName, function () {
				var ret = val.apply( this, arguments );
		
				if ( ret === this ) {
					// Returned item is the API instance that was passed in, return it
					return this;
				}
				else if ( ret instanceof _Api ) {
					// New API instance returned, want the value from the first item
					// in the returned array for the singular result.
					return ret.length ?
						$.isArray( ret[0] ) ?
							new _Api( ret.context, ret[0] ) : // Array results are 'enhanced'
							ret[0] :
						undefined;
				}
		
				// Non-API return - just fire it back
				return ret;
			} );
		};
		
		
		/**
		 * Selector for HTML tables. Apply the given selector to the give array of
		 * DataTables settings objects.
		 *
		 * @param {string|integer} [selector] jQuery selector string or integer
		 * @param  {array} Array of DataTables settings objects to be filtered
		 * @return {array}
		 * @ignore
		 */
		var __table_selector = function ( selector, a )
		{
			// Integer is used to pick out a table by index
			if ( typeof selector === 'number' ) {
				return [ a[ selector ] ];
			}
		
			// Perform a jQuery selector on the table nodes
			var nodes = $.map( a, function (el, i) {
				return el.nTable;
			} );
		
			return $(nodes)
				.filter( selector )
				.map( function (i) {
					// Need to translate back from the table node to the settings
					var idx = $.inArray( this, nodes );
					return a[ idx ];
				} )
				.toArray();
		};
		
		
		
		/**
		 * Context selector for the API's context (i.e. the tables the API instance
		 * refers to.
		 *
		 * @name    DataTable.Api#tables
		 * @param {string|integer} [selector] Selector to pick which tables the iterator
		 *   should operate on. If not given, all tables in the current context are
		 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
		 *   select multiple tables or as an integer to select a single table.
		 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
		 */
		_api_register( 'tables()', function ( selector ) {
			// A new instance is created if there was a selector specified
			return selector ?
				new _Api( __table_selector( selector, this.context ) ) :
				this;
		} );
		
		
		_api_register( 'table()', function ( selector ) {
			var tables = this.tables( selector );
			var ctx = tables.context;
		
			// Truncate to the first matched table
			return ctx.length ?
				new _Api( ctx[0] ) :
				tables;
		} );
		
		
		_api_registerPlural( 'tables().nodes()', 'table().node()' , function () {
			return this.iterator( 'table', function ( ctx ) {
				return ctx.nTable;
			}, 1 );
		} );
		
		
		_api_registerPlural( 'tables().body()', 'table().body()' , function () {
			return this.iterator( 'table', function ( ctx ) {
				return ctx.nTBody;
			}, 1 );
		} );
		
		
		_api_registerPlural( 'tables().header()', 'table().header()' , function () {
			return this.iterator( 'table', function ( ctx ) {
				return ctx.nTHead;
			}, 1 );
		} );
		
		
		_api_registerPlural( 'tables().footer()', 'table().footer()' , function () {
			return this.iterator( 'table', function ( ctx ) {
				return ctx.nTFoot;
			}, 1 );
		} );
		
		
		_api_registerPlural( 'tables().containers()', 'table().container()' , function () {
			return this.iterator( 'table', function ( ctx ) {
				return ctx.nTableWrapper;
			}, 1 );
		} );
		
		
		
		/**
		 * Redraw the tables in the current context.
		 */
		_api_register( 'draw()', function ( paging ) {
			return this.iterator( 'table', function ( settings ) {
				if ( paging === 'page' ) {
					_fnDraw( settings );
				}
				else {
					if ( typeof paging === 'string' ) {
						paging = paging === 'full-hold' ?
							false :
							true;
					}
		
					_fnReDraw( settings, paging===false );
				}
			} );
		} );
		
		
		
		/**
		 * Get the current page index.
		 *
		 * @return {integer} Current page index (zero based)
		 *//**
		 * Set the current page.
		 *
		 * Note that if you attempt to show a page which does not exist, DataTables will
		 * not throw an error, but rather reset the paging.
		 *
		 * @param {integer|string} action The paging action to take. This can be one of:
		 *  * `integer` - The page index to jump to
		 *  * `string` - An action to take:
		 *    * `first` - Jump to first page.
		 *    * `next` - Jump to the next page
		 *    * `previous` - Jump to previous page
		 *    * `last` - Jump to the last page.
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'page()', function ( action ) {
			if ( action === undefined ) {
				return this.page.info().page; // not an expensive call
			}
		
			// else, have an action to take on all tables
			return this.iterator( 'table', function ( settings ) {
				_fnPageChange( settings, action );
			} );
		} );
		
		
		/**
		 * Paging information for the first table in the current context.
		 *
		 * If you require paging information for another table, use the `table()` method
		 * with a suitable selector.
		 *
		 * @return {object} Object with the following properties set:
		 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
		 *  * `pages` - Total number of pages
		 *  * `start` - Display index for the first record shown on the current page
		 *  * `end` - Display index for the last record shown on the current page
		 *  * `length` - Display length (number of records). Note that generally `start
		 *    + length = end`, but this is not always true, for example if there are
		 *    only 2 records to show on the final page, with a length of 10.
		 *  * `recordsTotal` - Full data set length
		 *  * `recordsDisplay` - Data set length once the current filtering criterion
		 *    are applied.
		 */
		_api_register( 'page.info()', function ( action ) {
			if ( this.context.length === 0 ) {
				return undefined;
			}
		
			var
				settings   = this.context[0],
				start      = settings._iDisplayStart,
				len        = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1,
				visRecords = settings.fnRecordsDisplay(),
				all        = len === -1;
		
			return {
				"page":           all ? 0 : Math.floor( start / len ),
				"pages":          all ? 1 : Math.ceil( visRecords / len ),
				"start":          start,
				"end":            settings.fnDisplayEnd(),
				"length":         len,
				"recordsTotal":   settings.fnRecordsTotal(),
				"recordsDisplay": visRecords,
				"serverSide":     _fnDataSource( settings ) === 'ssp'
			};
		} );
		
		
		/**
		 * Get the current page length.
		 *
		 * @return {integer} Current page length. Note `-1` indicates that all records
		 *   are to be shown.
		 *//**
		 * Set the current page length.
		 *
		 * @param {integer} Page length to set. Use `-1` to show all records.
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'page.len()', function ( len ) {
			// Note that we can't call this function 'length()' because `length`
			// is a Javascript property of functions which defines how many arguments
			// the function expects.
			if ( len === undefined ) {
				return this.context.length !== 0 ?
					this.context[0]._iDisplayLength :
					undefined;
			}
		
			// else, set the page length
			return this.iterator( 'table', function ( settings ) {
				_fnLengthChange( settings, len );
			} );
		} );
		
		
		
		var __reload = function ( settings, holdPosition, callback ) {
			// Use the draw event to trigger a callback
			if ( callback ) {
				var api = new _Api( settings );
		
				api.one( 'draw', function () {
					callback( api.ajax.json() );
				} );
			}
		
			if ( _fnDataSource( settings ) == 'ssp' ) {
				_fnReDraw( settings, holdPosition );
			}
			else {
				_fnProcessingDisplay( settings, true );
		
				// Cancel an existing request
				var xhr = settings.jqXHR;
				if ( xhr && xhr.readyState !== 4 ) {
					xhr.abort();
				}
		
				// Trigger xhr
				_fnBuildAjax( settings, [], function( json ) {
					_fnClearTable( settings );
		
					var data = _fnAjaxDataSrc( settings, json );
					for ( var i=0, ien=data.length ; i<ien ; i++ ) {
						_fnAddData( settings, data[i] );
					}
		
					_fnReDraw( settings, holdPosition );
					_fnProcessingDisplay( settings, false );
				} );
			}
		};
		
		
		/**
		 * Get the JSON response from the last Ajax request that DataTables made to the
		 * server. Note that this returns the JSON from the first table in the current
		 * context.
		 *
		 * @return {object} JSON received from the server.
		 */
		_api_register( 'ajax.json()', function () {
			var ctx = this.context;
		
			if ( ctx.length > 0 ) {
				return ctx[0].json;
			}
		
			// else return undefined;
		} );
		
		
		/**
		 * Get the data submitted in the last Ajax request
		 */
		_api_register( 'ajax.params()', function () {
			var ctx = this.context;
		
			if ( ctx.length > 0 ) {
				return ctx[0].oAjaxData;
			}
		
			// else return undefined;
		} );
		
		
		/**
		 * Reload tables from the Ajax data source. Note that this function will
		 * automatically re-draw the table when the remote data has been loaded.
		 *
		 * @param {boolean} [reset=true] Reset (default) or hold the current paging
		 *   position. A full re-sort and re-filter is performed when this method is
		 *   called, which is why the pagination reset is the default action.
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'ajax.reload()', function ( callback, resetPaging ) {
			return this.iterator( 'table', function (settings) {
				__reload( settings, resetPaging===false, callback );
			} );
		} );
		
		
		/**
		 * Get the current Ajax URL. Note that this returns the URL from the first
		 * table in the current context.
		 *
		 * @return {string} Current Ajax source URL
		 *//**
		 * Set the Ajax URL. Note that this will set the URL for all tables in the
		 * current context.
		 *
		 * @param {string} url URL to set.
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'ajax.url()', function ( url ) {
			var ctx = this.context;
		
			if ( url === undefined ) {
				// get
				if ( ctx.length === 0 ) {
					return undefined;
				}
				ctx = ctx[0];
		
				return ctx.ajax ?
					$.isPlainObject( ctx.ajax ) ?
						ctx.ajax.url :
						ctx.ajax :
					ctx.sAjaxSource;
			}
		
			// set
			return this.iterator( 'table', function ( settings ) {
				if ( $.isPlainObject( settings.ajax ) ) {
					settings.ajax.url = url;
				}
				else {
					settings.ajax = url;
				}
				// No need to consider sAjaxSource here since DataTables gives priority
				// to `ajax` over `sAjaxSource`. So setting `ajax` here, renders any
				// value of `sAjaxSource` redundant.
			} );
		} );
		
		
		/**
		 * Load data from the newly set Ajax URL. Note that this method is only
		 * available when `ajax.url()` is used to set a URL. Additionally, this method
		 * has the same effect as calling `ajax.reload()` but is provided for
		 * convenience when setting a new URL. Like `ajax.reload()` it will
		 * automatically redraw the table once the remote data has been loaded.
		 *
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'ajax.url().load()', function ( callback, resetPaging ) {
			// Same as a reload, but makes sense to present it for easy access after a
			// url change
			return this.iterator( 'table', function ( ctx ) {
				__reload( ctx, resetPaging===false, callback );
			} );
		} );
		
		
		
		
		var _selector_run = function ( type, selector, selectFn, settings, opts )
		{
			var
				out = [], res,
				a, i, ien, j, jen,
				selectorType = typeof selector;
		
			// Can't just check for isArray here, as an API or jQuery instance might be
			// given with their array like look
			if ( ! selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined ) {
				selector = [ selector ];
			}
		
			for ( i=0, ien=selector.length ; i<ien ; i++ ) {
				// Only split on simple strings - complex expressions will be jQuery selectors
				a = selector[i] && selector[i].split && ! selector[i].match(/[\[\(:]/) ?
					selector[i].split(',') :
					[ selector[i] ];
		
				for ( j=0, jen=a.length ; j<jen ; j++ ) {
					res = selectFn( typeof a[j] === 'string' ? $.trim(a[j]) : a[j] );
		
					if ( res && res.length ) {
						out = out.concat( res );
					}
				}
			}
		
			// selector extensions
			var ext = _ext.selector[ type ];
			if ( ext.length ) {
				for ( i=0, ien=ext.length ; i<ien ; i++ ) {
					out = ext[i]( settings, opts, out );
				}
			}
		
			return _unique( out );
		};
		
		
		var _selector_opts = function ( opts )
		{
			if ( ! opts ) {
				opts = {};
			}
		
			// Backwards compatibility for 1.9- which used the terminology filter rather
			// than search
			if ( opts.filter && opts.search === undefined ) {
				opts.search = opts.filter;
			}
		
			return $.extend( {
				search: 'none',
				order: 'current',
				page: 'all'
			}, opts );
		};
		
		
		var _selector_first = function ( inst )
		{
			// Reduce the API instance to the first item found
			for ( var i=0, ien=inst.length ; i<ien ; i++ ) {
				if ( inst[i].length > 0 ) {
					// Assign the first element to the first item in the instance
					// and truncate the instance and context
					inst[0] = inst[i];
					inst[0].length = 1;
					inst.length = 1;
					inst.context = [ inst.context[i] ];
		
					return inst;
				}
			}
		
			// Not found - return an empty instance
			inst.length = 0;
			return inst;
		};
		
		
		var _selector_row_indexes = function ( settings, opts )
		{
			var
				i, ien, tmp, a=[],
				displayFiltered = settings.aiDisplay,
				displayMaster = settings.aiDisplayMaster;
		
			var
				search = opts.search,  // none, applied, removed
				order  = opts.order,   // applied, current, index (original - compatibility with 1.9)
				page   = opts.page;    // all, current
		
			if ( _fnDataSource( settings ) == 'ssp' ) {
				// In server-side processing mode, most options are irrelevant since
				// rows not shown don't exist and the index order is the applied order
				// Removed is a special case - for consistency just return an empty
				// array
				return search === 'removed' ?
					[] :
					_range( 0, displayMaster.length );
			}
			else if ( page == 'current' ) {
				// Current page implies that order=current and fitler=applied, since it is
				// fairly senseless otherwise, regardless of what order and search actually
				// are
				for ( i=settings._iDisplayStart, ien=settings.fnDisplayEnd() ; i<ien ; i++ ) {
					a.push( displayFiltered[i] );
				}
			}
			else if ( order == 'current' || order == 'applied' ) {
				a = search == 'none' ?
					displayMaster.slice() :                      // no search
					search == 'applied' ?
						displayFiltered.slice() :                // applied search
						$.map( displayMaster, function (el, i) { // removed search
							return $.inArray( el, displayFiltered ) === -1 ? el : null;
						} );
			}
			else if ( order == 'index' || order == 'original' ) {
				for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
					if ( search == 'none' ) {
						a.push( i );
					}
					else { // applied | removed
						tmp = $.inArray( i, displayFiltered );
		
						if ((tmp === -1 && search == 'removed') ||
							(tmp >= 0   && search == 'applied') )
						{
							a.push( i );
						}
					}
				}
			}
		
			return a;
		};
		
		
		/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
		 * Rows
		 *
		 * {}          - no selector - use all available rows
		 * {integer}   - row aoData index
		 * {node}      - TR node
		 * {string}    - jQuery selector to apply to the TR elements
		 * {array}     - jQuery array of nodes, or simply an array of TR nodes
		 *
		 */
		
		
		var __row_selector = function ( settings, selector, opts )
		{
			var rows;
			var run = function ( sel ) {
				var selInt = _intVal( sel );
				var i, ien;
		
				// Short cut - selector is a number and no options provided (default is
				// all records, so no need to check if the index is in there, since it
				// must be - dev error if the index doesn't exist).
				if ( selInt !== null && ! opts ) {
					return [ selInt ];
				}
		
				if ( ! rows ) {
					rows = _selector_row_indexes( settings, opts );
				}
		
				if ( selInt !== null && $.inArray( selInt, rows ) !== -1 ) {
					// Selector - integer
					return [ selInt ];
				}
				else if ( sel === null || sel === undefined || sel === '' ) {
					// Selector - none
					return rows;
				}
		
				// Selector - function
				if ( typeof sel === 'function' ) {
					return $.map( rows, function (idx) {
						var row = settings.aoData[ idx ];
						return sel( idx, row._aData, row.nTr ) ? idx : null;
					} );
				}
		
				// Get nodes in the order from the `rows` array with null values removed
				var nodes = _removeEmpty(
					_pluck_order( settings.aoData, rows, 'nTr' )
				);
		
				// Selector - node
				if ( sel.nodeName ) {
					if ( sel._DT_RowIndex !== undefined ) {
						return [ sel._DT_RowIndex ]; // Property added by DT for fast lookup
					}
					else if ( sel._DT_CellIndex ) {
						return [ sel._DT_CellIndex.row ];
					}
					else {
						var host = $(sel).closest('*[data-dt-row]');
						return host.length ?
							[ host.data('dt-row') ] :
							[];
					}
				}
		
				// ID selector. Want to always be able to select rows by id, regardless
				// of if the tr element has been created or not, so can't rely upon
				// jQuery here - hence a custom implementation. This does not match
				// Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
				// but to select it using a CSS selector engine (like Sizzle or
				// querySelect) it would need to need to be escaped for some characters.
				// DataTables simplifies this for row selectors since you can select
				// only a row. A # indicates an id any anything that follows is the id -
				// unescaped.
				if ( typeof sel === 'string' && sel.charAt(0) === '#' ) {
					// get row index from id
					var rowObj = settings.aIds[ sel.replace( /^#/, '' ) ];
					if ( rowObj !== undefined ) {
						return [ rowObj.idx ];
					}
		
					// need to fall through to jQuery in case there is DOM id that
					// matches
				}
		
				// Selector - jQuery selector string, array of nodes or jQuery object/
				// As jQuery's .filter() allows jQuery objects to be passed in filter,
				// it also allows arrays, so this will cope with all three options
				return $(nodes)
					.filter( sel )
					.map( function () {
						return this._DT_RowIndex;
					} )
					.toArray();
			};
		
			return _selector_run( 'row', selector, run, settings, opts );
		};
		
		
		_api_register( 'rows()', function ( selector, opts ) {
			// argument shifting
			if ( selector === undefined ) {
				selector = '';
			}
			else if ( $.isPlainObject( selector ) ) {
				opts = selector;
				selector = '';
			}
		
			opts = _selector_opts( opts );
		
			var inst = this.iterator( 'table', function ( settings ) {
				return __row_selector( settings, selector, opts );
			}, 1 );
		
			// Want argument shifting here and in __row_selector?
			inst.selector.rows = selector;
			inst.selector.opts = opts;
		
			return inst;
		} );
		
		_api_register( 'rows().nodes()', function () {
			return this.iterator( 'row', function ( settings, row ) {
				return settings.aoData[ row ].nTr || undefined;
			}, 1 );
		} );
		
		_api_register( 'rows().data()', function () {
			return this.iterator( true, 'rows', function ( settings, rows ) {
				return _pluck_order( settings.aoData, rows, '_aData' );
			}, 1 );
		} );
		
		_api_registerPlural( 'rows().cache()', 'row().cache()', function ( type ) {
			return this.iterator( 'row', function ( settings, row ) {
				var r = settings.aoData[ row ];
				return type === 'search' ? r._aFilterData : r._aSortData;
			}, 1 );
		} );
		
		_api_registerPlural( 'rows().invalidate()', 'row().invalidate()', function ( src ) {
			return this.iterator( 'row', function ( settings, row ) {
				_fnInvalidate( settings, row, src );
			} );
		} );
		
		_api_registerPlural( 'rows().indexes()', 'row().index()', function () {
			return this.iterator( 'row', function ( settings, row ) {
				return row;
			}, 1 );
		} );
		
		_api_registerPlural( 'rows().ids()', 'row().id()', function ( hash ) {
			var a = [];
			var context = this.context;
		
			// `iterator` will drop undefined values, but in this case we want them
			for ( var i=0, ien=context.length ; i<ien ; i++ ) {
				for ( var j=0, jen=this[i].length ; j<jen ; j++ ) {
					var id = context[i].rowIdFn( context[i].aoData[ this[i][j] ]._aData );
					a.push( (hash === true ? '#' : '' )+ id );
				}
			}
		
			return new _Api( context, a );
		} );
		
		_api_registerPlural( 'rows().remove()', 'row().remove()', function () {
			var that = this;
		
			this.iterator( 'row', function ( settings, row, thatIdx ) {
				var data = settings.aoData;
				var rowData = data[ row ];
				var i, ien, j, jen;
				var loopRow, loopCells;
		
				data.splice( row, 1 );
		
				// Update the cached indexes
				for ( i=0, ien=data.length ; i<ien ; i++ ) {
					loopRow = data[i];
					loopCells = loopRow.anCells;
		
					// Rows
					if ( loopRow.nTr !== null ) {
						loopRow.nTr._DT_RowIndex = i;
					}
		
					// Cells
					if ( loopCells !== null ) {
						for ( j=0, jen=loopCells.length ; j<jen ; j++ ) {
							loopCells[j]._DT_CellIndex.row = i;
						}
					}
				}
		
				// Delete from the display arrays
				_fnDeleteIndex( settings.aiDisplayMaster, row );
				_fnDeleteIndex( settings.aiDisplay, row );
				_fnDeleteIndex( that[ thatIdx ], row, false ); // maintain local indexes
		
				// For server-side processing tables - subtract the deleted row from the count
				if ( settings._iRecordsDisplay > 0 ) {
					settings._iRecordsDisplay--;
				}
		
				// Check for an 'overflow' they case for displaying the table
				_fnLengthOverflow( settings );
		
				// Remove the row's ID reference if there is one
				var id = settings.rowIdFn( rowData._aData );
				if ( id !== undefined ) {
					delete settings.aIds[ id ];
				}
			} );
		
			this.iterator( 'table', function ( settings ) {
				for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
					settings.aoData[i].idx = i;
				}
			} );
		
			return this;
		} );
		
		
		_api_register( 'rows.add()', function ( rows ) {
			var newRows = this.iterator( 'table', function ( settings ) {
					var row, i, ien;
					var out = [];
		
					for ( i=0, ien=rows.length ; i<ien ; i++ ) {
						row = rows[i];
		
						if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
							out.push( _fnAddTr( settings, row )[0] );
						}
						else {
							out.push( _fnAddData( settings, row ) );
						}
					}
		
					return out;
				}, 1 );
		
			// Return an Api.rows() extended instance, so rows().nodes() etc can be used
			var modRows = this.rows( -1 );
			modRows.pop();
			$.merge( modRows, newRows );
		
			return modRows;
		} );
		
		
		
		
		
		/**
		 *
		 */
		_api_register( 'row()', function ( selector, opts ) {
			return _selector_first( this.rows( selector, opts ) );
		} );
		
		
		_api_register( 'row().data()', function ( data ) {
			var ctx = this.context;
		
			if ( data === undefined ) {
				// Get
				return ctx.length && this.length ?
					ctx[0].aoData[ this[0] ]._aData :
					undefined;
			}
		
			// Set
			ctx[0].aoData[ this[0] ]._aData = data;
		
			// Automatically invalidate
			_fnInvalidate( ctx[0], this[0], 'data' );
		
			return this;
		} );
		
		
		_api_register( 'row().node()', function () {
			var ctx = this.context;
		
			return ctx.length && this.length ?
				ctx[0].aoData[ this[0] ].nTr || null :
				null;
		} );
		
		
		_api_register( 'row.add()', function ( row ) {
			// Allow a jQuery object to be passed in - only a single row is added from
			// it though - the first element in the set
			if ( row instanceof $ && row.length ) {
				row = row[0];
			}
		
			var rows = this.iterator( 'table', function ( settings ) {
				if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
					return _fnAddTr( settings, row )[0];
				}
				return _fnAddData( settings, row );
			} );
		
			// Return an Api.rows() extended instance, with the newly added row selected
			return this.row( rows[0] );
		} );
		
		
		
		var __details_add = function ( ctx, row, data, klass )
		{
			// Convert to array of TR elements
			var rows = [];
			var addRow = function ( r, k ) {
				// Recursion to allow for arrays of jQuery objects
				if ( $.isArray( r ) || r instanceof $ ) {
					for ( var i=0, ien=r.length ; i<ien ; i++ ) {
						addRow( r[i], k );
					}
					return;
				}
		
				// If we get a TR element, then just add it directly - up to the dev
				// to add the correct number of columns etc
				if ( r.nodeName && r.nodeName.toLowerCase() === 'tr' ) {
					rows.push( r );
				}
				else {
					// Otherwise create a row with a wrapper
					var created = $('<tr><td/></tr>').addClass( k );
					$('td', created)
						.addClass( k )
						.html( r )
						[0].colSpan = _fnVisbleColumns( ctx );
		
					rows.push( created[0] );
				}
			};
		
			addRow( data, klass );
		
			if ( row._details ) {
				row._details.detach();
			}
		
			row._details = $(rows);
		
			// If the children were already shown, that state should be retained
			if ( row._detailsShow ) {
				row._details.insertAfter( row.nTr );
			}
		};
		
		
		var __details_remove = function ( api, idx )
		{
			var ctx = api.context;
		
			if ( ctx.length ) {
				var row = ctx[0].aoData[ idx !== undefined ? idx : api[0] ];
		
				if ( row && row._details ) {
					row._details.remove();
		
					row._detailsShow = undefined;
					row._details = undefined;
				}
			}
		};
		
		
		var __details_display = function ( api, show ) {
			var ctx = api.context;
		
			if ( ctx.length && api.length ) {
				var row = ctx[0].aoData[ api[0] ];
		
				if ( row._details ) {
					row._detailsShow = show;
		
					if ( show ) {
						row._details.insertAfter( row.nTr );
					}
					else {
						row._details.detach();
					}
		
					__details_events( ctx[0] );
				}
			}
		};
		
		
		var __details_events = function ( settings )
		{
			var api = new _Api( settings );
			var namespace = '.dt.DT_details';
			var drawEvent = 'draw'+namespace;
			var colvisEvent = 'column-visibility'+namespace;
			var destroyEvent = 'destroy'+namespace;
			var data = settings.aoData;
		
			api.off( drawEvent +' '+ colvisEvent +' '+ destroyEvent );
		
			if ( _pluck( data, '_details' ).length > 0 ) {
				// On each draw, insert the required elements into the document
				api.on( drawEvent, function ( e, ctx ) {
					if ( settings !== ctx ) {
						return;
					}
		
					api.rows( {page:'current'} ).eq(0).each( function (idx) {
						// Internal data grab
						var row = data[ idx ];
		
						if ( row._detailsShow ) {
							row._details.insertAfter( row.nTr );
						}
					} );
				} );
		
				// Column visibility change - update the colspan
				api.on( colvisEvent, function ( e, ctx, idx, vis ) {
					if ( settings !== ctx ) {
						return;
					}
		
					// Update the colspan for the details rows (note, only if it already has
					// a colspan)
					var row, visible = _fnVisbleColumns( ctx );
		
					for ( var i=0, ien=data.length ; i<ien ; i++ ) {
						row = data[i];
		
						if ( row._details ) {
							row._details.children('td[colspan]').attr('colspan', visible );
						}
					}
				} );
		
				// Table destroyed - nuke any child rows
				api.on( destroyEvent, function ( e, ctx ) {
					if ( settings !== ctx ) {
						return;
					}
		
					for ( var i=0, ien=data.length ; i<ien ; i++ ) {
						if ( data[i]._details ) {
							__details_remove( api, i );
						}
					}
				} );
			}
		};
		
		// Strings for the method names to help minification
		var _emp = '';
		var _child_obj = _emp+'row().child';
		var _child_mth = _child_obj+'()';
		
		// data can be:
		//  tr
		//  string
		//  jQuery or array of any of the above
		_api_register( _child_mth, function ( data, klass ) {
			var ctx = this.context;
		
			if ( data === undefined ) {
				// get
				return ctx.length && this.length ?
					ctx[0].aoData[ this[0] ]._details :
					undefined;
			}
			else if ( data === true ) {
				// show
				this.child.show();
			}
			else if ( data === false ) {
				// remove
				__details_remove( this );
			}
			else if ( ctx.length && this.length ) {
				// set
				__details_add( ctx[0], ctx[0].aoData[ this[0] ], data, klass );
			}
		
			return this;
		} );
		
		
		_api_register( [
			_child_obj+'.show()',
			_child_mth+'.show()' // only when `child()` was called with parameters (without
		], function ( show ) {   // it returns an object and this method is not executed)
			__details_display( this, true );
			return this;
		} );
		
		
		_api_register( [
			_child_obj+'.hide()',
			_child_mth+'.hide()' // only when `child()` was called with parameters (without
		], function () {         // it returns an object and this method is not executed)
			__details_display( this, false );
			return this;
		} );
		
		
		_api_register( [
			_child_obj+'.remove()',
			_child_mth+'.remove()' // only when `child()` was called with parameters (without
		], function () {           // it returns an object and this method is not executed)
			__details_remove( this );
			return this;
		} );
		
		
		_api_register( _child_obj+'.isShown()', function () {
			var ctx = this.context;
		
			if ( ctx.length && this.length ) {
				// _detailsShown as false or undefined will fall through to return false
				return ctx[0].aoData[ this[0] ]._detailsShow || false;
			}
			return false;
		} );
		
		
		
		/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
		 * Columns
		 *
		 * {integer}           - column index (>=0 count from left, <0 count from right)
		 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
		 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
		 * "{string}:name"     - column name
		 * "{string}"          - jQuery selector on column header nodes
		 *
		 */
		
		// can be an array of these items, comma separated list, or an array of comma
		// separated lists
		
		var __re_column_selector = /^([^:]+):(name|visIdx|visible)$/;
		
		
		// r1 and r2 are redundant - but it means that the parameters match for the
		// iterator callback in columns().data()
		var __columnData = function ( settings, column, r1, r2, rows ) {
			var a = [];
			for ( var row=0, ien=rows.length ; row<ien ; row++ ) {
				a.push( _fnGetCellData( settings, rows[row], column ) );
			}
			return a;
		};
		
		
		var __column_selector = function ( settings, selector, opts )
		{
			var
				columns = settings.aoColumns,
				names = _pluck( columns, 'sName' ),
				nodes = _pluck( columns, 'nTh' );
		
			var run = function ( s ) {
				var selInt = _intVal( s );
		
				// Selector - all
				if ( s === '' ) {
					return _range( columns.length );
				}
		
				// Selector - index
				if ( selInt !== null ) {
					return [ selInt >= 0 ?
						selInt : // Count from left
						columns.length + selInt // Count from right (+ because its a negative value)
					];
				}
		
				// Selector = function
				if ( typeof s === 'function' ) {
					var rows = _selector_row_indexes( settings, opts );
		
					return $.map( columns, function (col, idx) {
						return s(
								idx,
								__columnData( settings, idx, 0, 0, rows ),
								nodes[ idx ]
							) ? idx : null;
					} );
				}
		
				// jQuery or string selector
				var match = typeof s === 'string' ?
					s.match( __re_column_selector ) :
					'';
		
				if ( match ) {
					switch( match[2] ) {
						case 'visIdx':
						case 'visible':
							var idx = parseInt( match[1], 10 );
							// Visible index given, convert to column index
							if ( idx < 0 ) {
								// Counting from the right
								var visColumns = $.map( columns, function (col,i) {
									return col.bVisible ? i : null;
								} );
								return [ visColumns[ visColumns.length + idx ] ];
							}
							// Counting from the left
							return [ _fnVisibleToColumnIndex( settings, idx ) ];
		
						case 'name':
							// match by name. `names` is column index complete and in order
							return $.map( names, function (name, i) {
								return name === match[1] ? i : null;
							} );
		
						default:
							return [];
					}
				}
		
				// Cell in the table body
				if ( s.nodeName && s._DT_CellIndex ) {
					return [ s._DT_CellIndex.column ];
				}
		
				// jQuery selector on the TH elements for the columns
				var jqResult = $( nodes )
					.filter( s )
					.map( function () {
						return $.inArray( this, nodes ); // `nodes` is column index complete and in order
					} )
					.toArray();
		
				if ( jqResult.length || ! s.nodeName ) {
					return jqResult;
				}
		
				// Otherwise a node which might have a `dt-column` data attribute, or be
				// a child or such an element
				var host = $(s).closest('*[data-dt-column]');
				return host.length ?
					[ host.data('dt-column') ] :
					[];
			};
		
			return _selector_run( 'column', selector, run, settings, opts );
		};
		
		
		var __setColumnVis = function ( settings, column, vis ) {
			var
				cols = settings.aoColumns,
				col  = cols[ column ],
				data = settings.aoData,
				row, cells, i, ien, tr;
		
			// Get
			if ( vis === undefined ) {
				return col.bVisible;
			}
		
			// Set
			// No change
			if ( col.bVisible === vis ) {
				return;
			}
		
			if ( vis ) {
				// Insert column
				// Need to decide if we should use appendChild or insertBefore
				var insertBefore = $.inArray( true, _pluck(cols, 'bVisible'), column+1 );
		
				for ( i=0, ien=data.length ; i<ien ; i++ ) {
					tr = data[i].nTr;
					cells = data[i].anCells;
		
					if ( tr ) {
						// insertBefore can act like appendChild if 2nd arg is null
						tr.insertBefore( cells[ column ], cells[ insertBefore ] || null );
					}
				}
			}
			else {
				// Remove column
				$( _pluck( settings.aoData, 'anCells', column ) ).detach();
			}
		
			// Common actions
			col.bVisible = vis;
			_fnDrawHead( settings, settings.aoHeader );
			_fnDrawHead( settings, settings.aoFooter );
		
			_fnSaveState( settings );
		};
		
		
		_api_register( 'columns()', function ( selector, opts ) {
			// argument shifting
			if ( selector === undefined ) {
				selector = '';
			}
			else if ( $.isPlainObject( selector ) ) {
				opts = selector;
				selector = '';
			}
		
			opts = _selector_opts( opts );
		
			var inst = this.iterator( 'table', function ( settings ) {
				return __column_selector( settings, selector, opts );
			}, 1 );
		
			// Want argument shifting here and in _row_selector?
			inst.selector.cols = selector;
			inst.selector.opts = opts;
		
			return inst;
		} );
		
		_api_registerPlural( 'columns().header()', 'column().header()', function ( selector, opts ) {
			return this.iterator( 'column', function ( settings, column ) {
				return settings.aoColumns[column].nTh;
			}, 1 );
		} );
		
		_api_registerPlural( 'columns().footer()', 'column().footer()', function ( selector, opts ) {
			return this.iterator( 'column', function ( settings, column ) {
				return settings.aoColumns[column].nTf;
			}, 1 );
		} );
		
		_api_registerPlural( 'columns().data()', 'column().data()', function () {
			return this.iterator( 'column-rows', __columnData, 1 );
		} );
		
		_api_registerPlural( 'columns().dataSrc()', 'column().dataSrc()', function () {
			return this.iterator( 'column', function ( settings, column ) {
				return settings.aoColumns[column].mData;
			}, 1 );
		} );
		
		_api_registerPlural( 'columns().cache()', 'column().cache()', function ( type ) {
			return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
				return _pluck_order( settings.aoData, rows,
					type === 'search' ? '_aFilterData' : '_aSortData', column
				);
			}, 1 );
		} );
		
		_api_registerPlural( 'columns().nodes()', 'column().nodes()', function () {
			return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
				return _pluck_order( settings.aoData, rows, 'anCells', column ) ;
			}, 1 );
		} );
		
		_api_registerPlural( 'columns().visible()', 'column().visible()', function ( vis, calc ) {
			var ret = this.iterator( 'column', function ( settings, column ) {
				if ( vis === undefined ) {
					return settings.aoColumns[ column ].bVisible;
				} // else
				__setColumnVis( settings, column, vis );
			} );
		
			// Group the column visibility changes
			if ( vis !== undefined ) {
				// Second loop once the first is done for events
				this.iterator( 'column', function ( settings, column ) {
					_fnCallbackFire( settings, null, 'column-visibility', [settings, column, vis, calc] );
				} );
		
				if ( calc === undefined || calc ) {
					this.columns.adjust();
				}
			}
		
			return ret;
		} );
		
		_api_registerPlural( 'columns().indexes()', 'column().index()', function ( type ) {
			return this.iterator( 'column', function ( settings, column ) {
				return type === 'visible' ?
					_fnColumnIndexToVisible( settings, column ) :
					column;
			}, 1 );
		} );
		
		_api_register( 'columns.adjust()', function () {
			return this.iterator( 'table', function ( settings ) {
				_fnAdjustColumnSizing( settings );
			}, 1 );
		} );
		
		_api_register( 'column.index()', function ( type, idx ) {
			if ( this.context.length !== 0 ) {
				var ctx = this.context[0];
		
				if ( type === 'fromVisible' || type === 'toData' ) {
					return _fnVisibleToColumnIndex( ctx, idx );
				}
				else if ( type === 'fromData' || type === 'toVisible' ) {
					return _fnColumnIndexToVisible( ctx, idx );
				}
			}
		} );
		
		_api_register( 'column()', function ( selector, opts ) {
			return _selector_first( this.columns( selector, opts ) );
		} );
		
		
		
		var __cell_selector = function ( settings, selector, opts )
		{
			var data = settings.aoData;
			var rows = _selector_row_indexes( settings, opts );
			var cells = _removeEmpty( _pluck_order( data, rows, 'anCells' ) );
			var allCells = $( [].concat.apply([], cells) );
			var row;
			var columns = settings.aoColumns.length;
			var a, i, ien, j, o, host;
		
			var run = function ( s ) {
				var fnSelector = typeof s === 'function';
		
				if ( s === null || s === undefined || fnSelector ) {
					// All cells and function selectors
					a = [];
		
					for ( i=0, ien=rows.length ; i<ien ; i++ ) {
						row = rows[i];
		
						for ( j=0 ; j<columns ; j++ ) {
							o = {
								row: row,
								column: j
							};
		
							if ( fnSelector ) {
								// Selector - function
								host = data[ row ];
		
								if ( s( o, _fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null ) ) {
									a.push( o );
								}
							}
							else {
								// Selector - all
								a.push( o );
							}
						}
					}
		
					return a;
				}
				
				// Selector - index
				if ( $.isPlainObject( s ) ) {
					return [s];
				}
		
				// Selector - jQuery filtered cells
				var jqResult = allCells
					.filter( s )
					.map( function (i, el) {
						return { // use a new object, in case someone changes the values
							row:    el._DT_CellIndex.row,
							column: el._DT_CellIndex.column
		 				};
					} )
					.toArray();
		
				if ( jqResult.length || ! s.nodeName ) {
					return jqResult;
				}
		
				// Otherwise the selector is a node, and there is one last option - the
				// element might be a child of an element which has dt-row and dt-column
				// data attributes
				host = $(s).closest('*[data-dt-row]');
				return host.length ?
					[ {
						row: host.data('dt-row'),
						column: host.data('dt-column')
					} ] :
					[];
			};
		
			return _selector_run( 'cell', selector, run, settings, opts );
		};
		
		
		
		
		_api_register( 'cells()', function ( rowSelector, columnSelector, opts ) {
			// Argument shifting
			if ( $.isPlainObject( rowSelector ) ) {
				// Indexes
				if ( rowSelector.row === undefined ) {
					// Selector options in first parameter
					opts = rowSelector;
					rowSelector = null;
				}
				else {
					// Cell index objects in first parameter
					opts = columnSelector;
					columnSelector = null;
				}
			}
			if ( $.isPlainObject( columnSelector ) ) {
				opts = columnSelector;
				columnSelector = null;
			}
		
			// Cell selector
			if ( columnSelector === null || columnSelector === undefined ) {
				return this.iterator( 'table', function ( settings ) {
					return __cell_selector( settings, rowSelector, _selector_opts( opts ) );
				} );
			}
		
			// Row + column selector
			var columns = this.columns( columnSelector, opts );
			var rows = this.rows( rowSelector, opts );
			var a, i, ien, j, jen;
		
			var cells = this.iterator( 'table', function ( settings, idx ) {
				a = [];
		
				for ( i=0, ien=rows[idx].length ; i<ien ; i++ ) {
					for ( j=0, jen=columns[idx].length ; j<jen ; j++ ) {
						a.push( {
							row:    rows[idx][i],
							column: columns[idx][j]
						} );
					}
				}
		
				return a;
			}, 1 );
		
			$.extend( cells.selector, {
				cols: columnSelector,
				rows: rowSelector,
				opts: opts
			} );
		
			return cells;
		} );
		
		
		_api_registerPlural( 'cells().nodes()', 'cell().node()', function () {
			return this.iterator( 'cell', function ( settings, row, column ) {
				var data = settings.aoData[ row ];
		
				return data && data.anCells ?
					data.anCells[ column ] :
					undefined;
			}, 1 );
		} );
		
		
		_api_register( 'cells().data()', function () {
			return this.iterator( 'cell', function ( settings, row, column ) {
				return _fnGetCellData( settings, row, column );
			}, 1 );
		} );
		
		
		_api_registerPlural( 'cells().cache()', 'cell().cache()', function ( type ) {
			type = type === 'search' ? '_aFilterData' : '_aSortData';
		
			return this.iterator( 'cell', function ( settings, row, column ) {
				return settings.aoData[ row ][ type ][ column ];
			}, 1 );
		} );
		
		
		_api_registerPlural( 'cells().render()', 'cell().render()', function ( type ) {
			return this.iterator( 'cell', function ( settings, row, column ) {
				return _fnGetCellData( settings, row, column, type );
			}, 1 );
		} );
		
		
		_api_registerPlural( 'cells().indexes()', 'cell().index()', function () {
			return this.iterator( 'cell', function ( settings, row, column ) {
				return {
					row: row,
					column: column,
					columnVisible: _fnColumnIndexToVisible( settings, column )
				};
			}, 1 );
		} );
		
		
		_api_registerPlural( 'cells().invalidate()', 'cell().invalidate()', function ( src ) {
			return this.iterator( 'cell', function ( settings, row, column ) {
				_fnInvalidate( settings, row, src, column );
			} );
		} );
		
		
		
		_api_register( 'cell()', function ( rowSelector, columnSelector, opts ) {
			return _selector_first( this.cells( rowSelector, columnSelector, opts ) );
		} );
		
		
		_api_register( 'cell().data()', function ( data ) {
			var ctx = this.context;
			var cell = this[0];
		
			if ( data === undefined ) {
				// Get
				return ctx.length && cell.length ?
					_fnGetCellData( ctx[0], cell[0].row, cell[0].column ) :
					undefined;
			}
		
			// Set
			_fnSetCellData( ctx[0], cell[0].row, cell[0].column, data );
			_fnInvalidate( ctx[0], cell[0].row, 'data', cell[0].column );
		
			return this;
		} );
		
		
		
		/**
		 * Get current ordering (sorting) that has been applied to the table.
		 *
		 * @returns {array} 2D array containing the sorting information for the first
		 *   table in the current context. Each element in the parent array represents
		 *   a column being sorted upon (i.e. multi-sorting with two columns would have
		 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
		 *   the column index that the sorting condition applies to, the second is the
		 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
		 *   index of the sorting order from the `column.sorting` initialisation array.
		 *//**
		 * Set the ordering for the table.
		 *
		 * @param {integer} order Column index to sort upon.
		 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
		 * @returns {DataTables.Api} this
		 *//**
		 * Set the ordering for the table.
		 *
		 * @param {array} order 1D array of sorting information to be applied.
		 * @param {array} [...] Optional additional sorting conditions
		 * @returns {DataTables.Api} this
		 *//**
		 * Set the ordering for the table.
		 *
		 * @param {array} order 2D array of sorting information to be applied.
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'order()', function ( order, dir ) {
			var ctx = this.context;
		
			if ( order === undefined ) {
				// get
				return ctx.length !== 0 ?
					ctx[0].aaSorting :
					undefined;
			}
		
			// set
			if ( typeof order === 'number' ) {
				// Simple column / direction passed in
				order = [ [ order, dir ] ];
			}
			else if ( order.length && ! $.isArray( order[0] ) ) {
				// Arguments passed in (list of 1D arrays)
				order = Array.prototype.slice.call( arguments );
			}
			// otherwise a 2D array was passed in
		
			return this.iterator( 'table', function ( settings ) {
				settings.aaSorting = order.slice();
			} );
		} );
		
		
		/**
		 * Attach a sort listener to an element for a given column
		 *
		 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
		 *   listener to. This can take the form of a single DOM node, a jQuery
		 *   collection of nodes or a jQuery selector which will identify the node(s).
		 * @param {integer} column the column that a click on this node will sort on
		 * @param {function} [callback] callback function when sort is run
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'order.listener()', function ( node, column, callback ) {
			return this.iterator( 'table', function ( settings ) {
				_fnSortAttachListener( settings, node, column, callback );
			} );
		} );
		
		
		_api_register( 'order.fixed()', function ( set ) {
			if ( ! set ) {
				var ctx = this.context;
				var fixed = ctx.length ?
					ctx[0].aaSortingFixed :
					undefined;
		
				return $.isArray( fixed ) ?
					{ pre: fixed } :
					fixed;
			}
		
			return this.iterator( 'table', function ( settings ) {
				settings.aaSortingFixed = $.extend( true, {}, set );
			} );
		} );
		
		
		// Order by the selected column(s)
		_api_register( [
			'columns().order()',
			'column().order()'
		], function ( dir ) {
			var that = this;
		
			return this.iterator( 'table', function ( settings, i ) {
				var sort = [];
		
				$.each( that[i], function (j, col) {
					sort.push( [ col, dir ] );
				} );
		
				settings.aaSorting = sort;
			} );
		} );
		
		
		
		_api_register( 'search()', function ( input, regex, smart, caseInsen ) {
			var ctx = this.context;
		
			if ( input === undefined ) {
				// get
				return ctx.length !== 0 ?
					ctx[0].oPreviousSearch.sSearch :
					undefined;
			}
		
			// set
			return this.iterator( 'table', function ( settings ) {
				if ( ! settings.oFeatures.bFilter ) {
					return;
				}
		
				_fnFilterComplete( settings, $.extend( {}, settings.oPreviousSearch, {
					"sSearch": input+"",
					"bRegex":  regex === null ? false : regex,
					"bSmart":  smart === null ? true  : smart,
					"bCaseInsensitive": caseInsen === null ? true : caseInsen
				} ), 1 );
			} );
		} );
		
		
		_api_registerPlural(
			'columns().search()',
			'column().search()',
			function ( input, regex, smart, caseInsen ) {
				return this.iterator( 'column', function ( settings, column ) {
					var preSearch = settings.aoPreSearchCols;
		
					if ( input === undefined ) {
						// get
						return preSearch[ column ].sSearch;
					}
		
					// set
					if ( ! settings.oFeatures.bFilter ) {
						return;
					}
		
					$.extend( preSearch[ column ], {
						"sSearch": input+"",
						"bRegex":  regex === null ? false : regex,
						"bSmart":  smart === null ? true  : smart,
						"bCaseInsensitive": caseInsen === null ? true : caseInsen
					} );
		
					_fnFilterComplete( settings, settings.oPreviousSearch, 1 );
				} );
			}
		);
		
		/*
		 * State API methods
		 */
		
		_api_register( 'state()', function () {
			return this.context.length ?
				this.context[0].oSavedState :
				null;
		} );
		
		
		_api_register( 'state.clear()', function () {
			return this.iterator( 'table', function ( settings ) {
				// Save an empty object
				settings.fnStateSaveCallback.call( settings.oInstance, settings, {} );
			} );
		} );
		
		
		_api_register( 'state.loaded()', function () {
			return this.context.length ?
				this.context[0].oLoadedState :
				null;
		} );
		
		
		_api_register( 'state.save()', function () {
			return this.iterator( 'table', function ( settings ) {
				_fnSaveState( settings );
			} );
		} );
		
		
		
		/**
		 * Provide a common method for plug-ins to check the version of DataTables being
		 * used, in order to ensure compatibility.
		 *
		 *  @param {string} version Version string to check for, in the format "X.Y.Z".
		 *    Note that the formats "X" and "X.Y" are also acceptable.
		 *  @returns {boolean} true if this version of DataTables is greater or equal to
		 *    the required version, or false if this version of DataTales is not
		 *    suitable
		 *  @static
		 *  @dtopt API-Static
		 *
		 *  @example
		 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
		 */
		DataTable.versionCheck = DataTable.fnVersionCheck = function( version )
		{
			var aThis = DataTable.version.split('.');
			var aThat = version.split('.');
			var iThis, iThat;
		
			for ( var i=0, iLen=aThat.length ; i<iLen ; i++ ) {
				iThis = parseInt( aThis[i], 10 ) || 0;
				iThat = parseInt( aThat[i], 10 ) || 0;
		
				// Parts are the same, keep comparing
				if (iThis === iThat) {
					continue;
				}
		
				// Parts are different, return immediately
				return iThis > iThat;
			}
		
			return true;
		};
		
		
		/**
		 * Check if a `<table>` node is a DataTable table already or not.
		 *
		 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
		 *      selector for the table to test. Note that if more than more than one
		 *      table is passed on, only the first will be checked
		 *  @returns {boolean} true the table given is a DataTable, or false otherwise
		 *  @static
		 *  @dtopt API-Static
		 *
		 *  @example
		 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
		 *      $('#example').dataTable();
		 *    }
		 */
		DataTable.isDataTable = DataTable.fnIsDataTable = function ( table )
		{
			var t = $(table).get(0);
			var is = false;
		
			if ( table instanceof DataTable.Api ) {
				return true;
			}
		
			$.each( DataTable.settings, function (i, o) {
				var head = o.nScrollHead ? $('table', o.nScrollHead)[0] : null;
				var foot = o.nScrollFoot ? $('table', o.nScrollFoot)[0] : null;
		
				if ( o.nTable === t || head === t || foot === t ) {
					is = true;
				}
			} );
		
			return is;
		};
		
		
		/**
		 * Get all DataTable tables that have been initialised - optionally you can
		 * select to get only currently visible tables.
		 *
		 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
		 *    or visible tables only.
		 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
		 *    DataTables
		 *  @static
		 *  @dtopt API-Static
		 *
		 *  @example
		 *    $.each( $.fn.dataTable.tables(true), function () {
		 *      $(table).DataTable().columns.adjust();
		 *    } );
		 */
		DataTable.tables = DataTable.fnTables = function ( visible )
		{
			var api = false;
		
			if ( $.isPlainObject( visible ) ) {
				api = visible.api;
				visible = visible.visible;
			}
		
			var a = $.map( DataTable.settings, function (o) {
				if ( !visible || (visible && $(o.nTable).is(':visible')) ) {
					return o.nTable;
				}
			} );
		
			return api ?
				new _Api( a ) :
				a;
		};
		
		
		/**
		 * Convert from camel case parameters to Hungarian notation. This is made public
		 * for the extensions to provide the same ability as DataTables core to accept
		 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
		 * parameters.
		 *
		 *  @param {object} src The model object which holds all parameters that can be
		 *    mapped.
		 *  @param {object} user The object to convert from camel case to Hungarian.
		 *  @param {boolean} force When set to `true`, properties which already have a
		 *    Hungarian value in the `user` object will be overwritten. Otherwise they
		 *    won't be.
		 */
		DataTable.camelToHungarian = _fnCamelToHungarian;
		
		
		
		/**
		 *
		 */
		_api_register( '$()', function ( selector, opts ) {
			var
				rows   = this.rows( opts ).nodes(), // Get all rows
				jqRows = $(rows);
		
			return $( [].concat(
				jqRows.filter( selector ).toArray(),
				jqRows.find( selector ).toArray()
			) );
		} );
		
		
		// jQuery functions to operate on the tables
		$.each( [ 'on', 'one', 'off' ], function (i, key) {
			_api_register( key+'()', function ( /* event, handler */ ) {
				var args = Array.prototype.slice.call(arguments);
		
				// Add the `dt` namespace automatically if it isn't already present
				args[0] = $.map( args[0].split( /\s/ ), function ( e ) {
					return ! e.match(/\.dt\b/) ?
						e+'.dt' :
						e;
					} ).join( ' ' );
		
				var inst = $( this.tables().nodes() );
				inst[key].apply( inst, args );
				return this;
			} );
		} );
		
		
		_api_register( 'clear()', function () {
			return this.iterator( 'table', function ( settings ) {
				_fnClearTable( settings );
			} );
		} );
		
		
		_api_register( 'settings()', function () {
			return new _Api( this.context, this.context );
		} );
		
		
		_api_register( 'init()', function () {
			var ctx = this.context;
			return ctx.length ? ctx[0].oInit : null;
		} );
		
		
		_api_register( 'data()', function () {
			return this.iterator( 'table', function ( settings ) {
				return _pluck( settings.aoData, '_aData' );
			} ).flatten();
		} );
		
		
		_api_register( 'destroy()', function ( remove ) {
			remove = remove || false;
		
			return this.iterator( 'table', function ( settings ) {
				var orig      = settings.nTableWrapper.parentNode;
				var classes   = settings.oClasses;
				var table     = settings.nTable;
				var tbody     = settings.nTBody;
				var thead     = settings.nTHead;
				var tfoot     = settings.nTFoot;
				var jqTable   = $(table);
				var jqTbody   = $(tbody);
				var jqWrapper = $(settings.nTableWrapper);
				var rows      = $.map( settings.aoData, function (r) { return r.nTr; } );
				var i, ien;
		
				// Flag to note that the table is currently being destroyed - no action
				// should be taken
				settings.bDestroying = true;
		
				// Fire off the destroy callbacks for plug-ins etc
				_fnCallbackFire( settings, "aoDestroyCallback", "destroy", [settings] );
		
				// If not being removed from the document, make all columns visible
				if ( ! remove ) {
					new _Api( settings ).columns().visible( true );
				}
		
				// Blitz all `DT` namespaced events (these are internal events, the
				// lowercase, `dt` events are user subscribed and they are responsible
				// for removing them
				jqWrapper.off('.DT').find(':not(tbody *)').off('.DT');
				$(window).off('.DT-'+settings.sInstance);
		
				// When scrolling we had to break the table up - restore it
				if ( table != thead.parentNode ) {
					jqTable.children('thead').detach();
					jqTable.append( thead );
				}
		
				if ( tfoot && table != tfoot.parentNode ) {
					jqTable.children('tfoot').detach();
					jqTable.append( tfoot );
				}
		
				settings.aaSorting = [];
				settings.aaSortingFixed = [];
				_fnSortingClasses( settings );
		
				$( rows ).removeClass( settings.asStripeClasses.join(' ') );
		
				$('th, td', thead).removeClass( classes.sSortable+' '+
					classes.sSortableAsc+' '+classes.sSortableDesc+' '+classes.sSortableNone
				);
		
				// Add the TR elements back into the table in their original order
				jqTbody.children().detach();
				jqTbody.append( rows );
		
				// Remove the DataTables generated nodes, events and classes
				var removedMethod = remove ? 'remove' : 'detach';
				jqTable[ removedMethod ]();
				jqWrapper[ removedMethod ]();
		
				// If we need to reattach the table to the document
				if ( ! remove && orig ) {
					// insertBefore acts like appendChild if !arg[1]
					orig.insertBefore( table, settings.nTableReinsertBefore );
		
					// Restore the width of the original table - was read from the style property,
					// so we can restore directly to that
					jqTable
						.css( 'width', settings.sDestroyWidth )
						.removeClass( classes.sTable );
		
					// If the were originally stripe classes - then we add them back here.
					// Note this is not fool proof (for example if not all rows had stripe
					// classes - but it's a good effort without getting carried away
					ien = settings.asDestroyStripes.length;
		
					if ( ien ) {
						jqTbody.children().each( function (i) {
							$(this).addClass( settings.asDestroyStripes[i % ien] );
						} );
					}
				}
		
				/* Remove the settings object from the settings array */
				var idx = $.inArray( settings, DataTable.settings );
				if ( idx !== -1 ) {
					DataTable.settings.splice( idx, 1 );
				}
			} );
		} );
		
		
		// Add the `every()` method for rows, columns and cells in a compact form
		$.each( [ 'column', 'row', 'cell' ], function ( i, type ) {
			_api_register( type+'s().every()', function ( fn ) {
				var opts = this.selector.opts;
				var api = this;
		
				return this.iterator( type, function ( settings, arg1, arg2, arg3, arg4 ) {
					// Rows and columns:
					//  arg1 - index
					//  arg2 - table counter
					//  arg3 - loop counter
					//  arg4 - undefined
					// Cells:
					//  arg1 - row index
					//  arg2 - column index
					//  arg3 - table counter
					//  arg4 - loop counter
					fn.call(
						api[ type ](
							arg1,
							type==='cell' ? arg2 : opts,
							type==='cell' ? opts : undefined
						),
						arg1, arg2, arg3, arg4
					);
				} );
			} );
		} );
		
		
		// i18n method for extensions to be able to use the language object from the
		// DataTable
		_api_register( 'i18n()', function ( token, def, plural ) {
			var ctx = this.context[0];
			var resolved = _fnGetObjectDataFn( token )( ctx.oLanguage );
		
			if ( resolved === undefined ) {
				resolved = def;
			}
		
			if ( plural !== undefined && $.isPlainObject( resolved ) ) {
				resolved = resolved[ plural ] !== undefined ?
					resolved[ plural ] :
					resolved._;
			}
		
			return resolved.replace( '%d', plural ); // nb: plural might be undefined,
		} );
		/**
		 * Version string for plug-ins to check compatibility. Allowed format is
		 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
		 * only for non-release builds. See http://semver.org/ for more information.
		 *  @member
		 *  @type string
		 *  @default Version number
		 */
		DataTable.version = "1.10.16";
	
		/**
		 * Private data store, containing all of the settings objects that are
		 * created for the tables on a given page.
		 *
		 * Note that the `DataTable.settings` object is aliased to
		 * `jQuery.fn.dataTableExt` through which it may be accessed and
		 * manipulated, or `jQuery.fn.dataTable.settings`.
		 *  @member
		 *  @type array
		 *  @default []
		 *  @private
		 */
		DataTable.settings = [];
	
		/**
		 * Object models container, for the various models that DataTables has
		 * available to it. These models define the objects that are used to hold
		 * the active state and configuration of the table.
		 *  @namespace
		 */
		DataTable.models = {};
		
		
		
		/**
		 * Template object for the way in which DataTables holds information about
		 * search information for the global filter and individual column filters.
		 *  @namespace
		 */
		DataTable.models.oSearch = {
			/**
			 * Flag to indicate if the filtering should be case insensitive or not
			 *  @type boolean
			 *  @default true
			 */
			"bCaseInsensitive": true,
		
			/**
			 * Applied search term
			 *  @type string
			 *  @default <i>Empty string</i>
			 */
			"sSearch": "",
		
			/**
			 * Flag to indicate if the search term should be interpreted as a
			 * regular expression (true) or not (false) and therefore and special
			 * regex characters escaped.
			 *  @type boolean
			 *  @default false
			 */
			"bRegex": false,
		
			/**
			 * Flag to indicate if DataTables is to use its smart filtering or not.
			 *  @type boolean
			 *  @default true
			 */
			"bSmart": true
		};
		
		
		
		
		/**
		 * Template object for the way in which DataTables holds information about
		 * each individual row. This is the object format used for the settings
		 * aoData array.
		 *  @namespace
		 */
		DataTable.models.oRow = {
			/**
			 * TR element for the row
			 *  @type node
			 *  @default null
			 */
			"nTr": null,
		
			/**
			 * Array of TD elements for each row. This is null until the row has been
			 * created.
			 *  @type array nodes
			 *  @default []
			 */
			"anCells": null,
		
			/**
			 * Data object from the original data source for the row. This is either
			 * an array if using the traditional form of DataTables, or an object if
			 * using mData options. The exact type will depend on the passed in
			 * data from the data source, or will be an array if using DOM a data
			 * source.
			 *  @type array|object
			 *  @default []
			 */
			"_aData": [],
		
			/**
			 * Sorting data cache - this array is ostensibly the same length as the
			 * number of columns (although each index is generated only as it is
			 * needed), and holds the data that is used for sorting each column in the
			 * row. We do this cache generation at the start of the sort in order that
			 * the formatting of the sort data need be done only once for each cell
			 * per sort. This array should not be read from or written to by anything
			 * other than the master sorting methods.
			 *  @type array
			 *  @default null
			 *  @private
			 */
			"_aSortData": null,
		
			/**
			 * Per cell filtering data cache. As per the sort data cache, used to
			 * increase the performance of the filtering in DataTables
			 *  @type array
			 *  @default null
			 *  @private
			 */
			"_aFilterData": null,
		
			/**
			 * Filtering data cache. This is the same as the cell filtering cache, but
			 * in this case a string rather than an array. This is easily computed with
			 * a join on `_aFilterData`, but is provided as a cache so the join isn't
			 * needed on every search (memory traded for performance)
			 *  @type array
			 *  @default null
			 *  @private
			 */
			"_sFilterRow": null,
		
			/**
			 * Cache of the class name that DataTables has applied to the row, so we
			 * can quickly look at this variable rather than needing to do a DOM check
			 * on className for the nTr property.
			 *  @type string
			 *  @default <i>Empty string</i>
			 *  @private
			 */
			"_sRowStripe": "",
		
			/**
			 * Denote if the original data source was from the DOM, or the data source
			 * object. This is used for invalidating data, so DataTables can
			 * automatically read data from the original source, unless uninstructed
			 * otherwise.
			 *  @type string
			 *  @default null
			 *  @private
			 */
			"src": null,
		
			/**
			 * Index in the aoData array. This saves an indexOf lookup when we have the
			 * object, but want to know the index
			 *  @type integer
			 *  @default -1
			 *  @private
			 */
			"idx": -1
		};
		
		
		/**
		 * Template object for the column information object in DataTables. This object
		 * is held in the settings aoColumns array and contains all the information that
		 * DataTables needs about each individual column.
		 *
		 * Note that this object is related to {@link DataTable.defaults.column}
		 * but this one is the internal data store for DataTables's cache of columns.
		 * It should NOT be manipulated outside of DataTables. Any configuration should
		 * be done through the initialisation options.
		 *  @namespace
		 */
		DataTable.models.oColumn = {
			/**
			 * Column index. This could be worked out on-the-fly with $.inArray, but it
			 * is faster to just hold it as a variable
			 *  @type integer
			 *  @default null
			 */
			"idx": null,
		
			/**
			 * A list of the columns that sorting should occur on when this column
			 * is sorted. That this property is an array allows multi-column sorting
			 * to be defined for a column (for example first name / last name columns
			 * would benefit from this). The values are integers pointing to the
			 * columns to be sorted on (typically it will be a single integer pointing
			 * at itself, but that doesn't need to be the case).
			 *  @type array
			 */
			"aDataSort": null,
		
			/**
			 * Define the sorting directions that are applied to the column, in sequence
			 * as the column is repeatedly sorted upon - i.e. the first value is used
			 * as the sorting direction when the column if first sorted (clicked on).
			 * Sort it again (click again) and it will move on to the next index.
			 * Repeat until loop.
			 *  @type array
			 */
			"asSorting": null,
		
			/**
			 * Flag to indicate if the column is searchable, and thus should be included
			 * in the filtering or not.
			 *  @type boolean
			 */
			"bSearchable": null,
		
			/**
			 * Flag to indicate if the column is sortable or not.
			 *  @type boolean
			 */
			"bSortable": null,
		
			/**
			 * Flag to indicate if the column is currently visible in the table or not
			 *  @type boolean
			 */
			"bVisible": null,
		
			/**
			 * Store for manual type assignment using the `column.type` option. This
			 * is held in store so we can manipulate the column's `sType` property.
			 *  @type string
			 *  @default null
			 *  @private
			 */
			"_sManualType": null,
		
			/**
			 * Flag to indicate if HTML5 data attributes should be used as the data
			 * source for filtering or sorting. True is either are.
			 *  @type boolean
			 *  @default false
			 *  @private
			 */
			"_bAttrSrc": false,
		
			/**
			 * Developer definable function that is called whenever a cell is created (Ajax source,
			 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
			 * allowing you to modify the DOM element (add background colour for example) when the
			 * element is available.
			 *  @type function
			 *  @param {element} nTd The TD node that has been created
			 *  @param {*} sData The Data for the cell
			 *  @param {array|object} oData The data for the whole row
			 *  @param {int} iRow The row index for the aoData data store
			 *  @default null
			 */
			"fnCreatedCell": null,
		
			/**
			 * Function to get data from a cell in a column. You should <b>never</b>
			 * access data directly through _aData internally in DataTables - always use
			 * the method attached to this property. It allows mData to function as
			 * required. This function is automatically assigned by the column
			 * initialisation method
			 *  @type function
			 *  @param {array|object} oData The data array/object for the array
			 *    (i.e. aoData[]._aData)
			 *  @param {string} sSpecific The specific data type you want to get -
			 *    'display', 'type' 'filter' 'sort'
			 *  @returns {*} The data for the cell from the given row's data
			 *  @default null
			 */
			"fnGetData": null,
		
			/**
			 * Function to set data for a cell in the column. You should <b>never</b>
			 * set the data directly to _aData internally in DataTables - always use
			 * this method. It allows mData to function as required. This function
			 * is automatically assigned by the column initialisation method
			 *  @type function
			 *  @param {array|object} oData The data array/object for the array
			 *    (i.e. aoData[]._aData)
			 *  @param {*} sValue Value to set
			 *  @default null
			 */
			"fnSetData": null,
		
			/**
			 * Property to read the value for the cells in the column from the data
			 * source array / object. If null, then the default content is used, if a
			 * function is given then the return from the function is used.
			 *  @type function|int|string|null
			 *  @default null
			 */
			"mData": null,
		
			/**
			 * Partner property to mData which is used (only when defined) to get
			 * the data - i.e. it is basically the same as mData, but without the
			 * 'set' option, and also the data fed to it is the result from mData.
			 * This is the rendering method to match the data method of mData.
			 *  @type function|int|string|null
			 *  @default null
			 */
			"mRender": null,
		
			/**
			 * Unique header TH/TD element for this column - this is what the sorting
			 * listener is attached to (if sorting is enabled.)
			 *  @type node
			 *  @default null
			 */
			"nTh": null,
		
			/**
			 * Unique footer TH/TD element for this column (if there is one). Not used
			 * in DataTables as such, but can be used for plug-ins to reference the
			 * footer for each column.
			 *  @type node
			 *  @default null
			 */
			"nTf": null,
		
			/**
			 * The class to apply to all TD elements in the table's TBODY for the column
			 *  @type string
			 *  @default null
			 */
			"sClass": null,
		
			/**
			 * When DataTables calculates the column widths to assign to each column,
			 * it finds the longest string in each column and then constructs a
			 * temporary table and reads the widths from that. The problem with this
			 * is that "mmm" is much wider then "iiii", but the latter is a longer
			 * string - thus the calculation can go wrong (doing it properly and putting
			 * it into an DOM object and measuring that is horribly(!) slow). Thus as
			 * a "work around" we provide this option. It will append its value to the
			 * text that is found to be the longest string for the column - i.e. padding.
			 *  @type string
			 */
			"sContentPadding": null,
		
			/**
			 * Allows a default value to be given for a column's data, and will be used
			 * whenever a null data source is encountered (this can be because mData
			 * is set to null, or because the data source itself is null).
			 *  @type string
			 *  @default null
			 */
			"sDefaultContent": null,
		
			/**
			 * Name for the column, allowing reference to the column by name as well as
			 * by index (needs a lookup to work by name).
			 *  @type string
			 */
			"sName": null,
		
			/**
			 * Custom sorting data type - defines which of the available plug-ins in
			 * afnSortData the custom sorting will use - if any is defined.
			 *  @type string
			 *  @default std
			 */
			"sSortDataType": 'std',
		
			/**
			 * Class to be applied to the header element when sorting on this column
			 *  @type string
			 *  @default null
			 */
			"sSortingClass": null,
		
			/**
			 * Class to be applied to the header element when sorting on this column -
			 * when jQuery UI theming is used.
			 *  @type string
			 *  @default null
			 */
			"sSortingClassJUI": null,
		
			/**
			 * Title of the column - what is seen in the TH element (nTh).
			 *  @type string
			 */
			"sTitle": null,
		
			/**
			 * Column sorting and filtering type
			 *  @type string
			 *  @default null
			 */
			"sType": null,
		
			/**
			 * Width of the column
			 *  @type string
			 *  @default null
			 */
			"sWidth": null,
		
			/**
			 * Width of the column when it was first "encountered"
			 *  @type string
			 *  @default null
			 */
			"sWidthOrig": null
		};
		
		
		/*
		 * Developer note: The properties of the object below are given in Hungarian
		 * notation, that was used as the interface for DataTables prior to v1.10, however
		 * from v1.10 onwards the primary interface is camel case. In order to avoid
		 * breaking backwards compatibility utterly with this change, the Hungarian
		 * version is still, internally the primary interface, but is is not documented
		 * - hence the @name tags in each doc comment. This allows a Javascript function
		 * to create a map from Hungarian notation to camel case (going the other direction
		 * would require each property to be listed, which would at around 3K to the size
		 * of DataTables, while this method is about a 0.5K hit.
		 *
		 * Ultimately this does pave the way for Hungarian notation to be dropped
		 * completely, but that is a massive amount of work and will break current
		 * installs (therefore is on-hold until v2).
		 */
		
		/**
		 * Initialisation options that can be given to DataTables at initialisation
		 * time.
		 *  @namespace
		 */
		DataTable.defaults = {
			/**
			 * An array of data to use for the table, passed in at initialisation which
			 * will be used in preference to any data which is already in the DOM. This is
			 * particularly useful for constructing tables purely in Javascript, for
			 * example with a custom Ajax call.
			 *  @type array
			 *  @default null
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.data
			 *
			 *  @example
			 *    // Using a 2D array data source
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "data": [
			 *          ['Trident', 'Internet Explorer 4.0', 'Win 95+', 4, 'X'],
			 *          ['Trident', 'Internet Explorer 5.0', 'Win 95+', 5, 'C'],
			 *        ],
			 *        "columns": [
			 *          { "title": "Engine" },
			 *          { "title": "Browser" },
			 *          { "title": "Platform" },
			 *          { "title": "Version" },
			 *          { "title": "Grade" }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using an array of objects as a data source (`data`)
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "data": [
			 *          {
			 *            "engine":   "Trident",
			 *            "browser":  "Internet Explorer 4.0",
			 *            "platform": "Win 95+",
			 *            "version":  4,
			 *            "grade":    "X"
			 *          },
			 *          {
			 *            "engine":   "Trident",
			 *            "browser":  "Internet Explorer 5.0",
			 *            "platform": "Win 95+",
			 *            "version":  5,
			 *            "grade":    "C"
			 *          }
			 *        ],
			 *        "columns": [
			 *          { "title": "Engine",   "data": "engine" },
			 *          { "title": "Browser",  "data": "browser" },
			 *          { "title": "Platform", "data": "platform" },
			 *          { "title": "Version",  "data": "version" },
			 *          { "title": "Grade",    "data": "grade" }
			 *        ]
			 *      } );
			 *    } );
			 */
			"aaData": null,
		
		
			/**
			 * If ordering is enabled, then DataTables will perform a first pass sort on
			 * initialisation. You can define which column(s) the sort is performed
			 * upon, and the sorting direction, with this variable. The `sorting` array
			 * should contain an array for each column to be sorted initially containing
			 * the column's index and a direction string ('asc' or 'desc').
			 *  @type array
			 *  @default [[0,'asc']]
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.order
			 *
			 *  @example
			 *    // Sort by 3rd column first, and then 4th column
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "order": [[2,'asc'], [3,'desc']]
			 *      } );
			 *    } );
			 *
			 *    // No initial sorting
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "order": []
			 *      } );
			 *    } );
			 */
			"aaSorting": [[0,'asc']],
		
		
			/**
			 * This parameter is basically identical to the `sorting` parameter, but
			 * cannot be overridden by user interaction with the table. What this means
			 * is that you could have a column (visible or hidden) which the sorting
			 * will always be forced on first - any sorting after that (from the user)
			 * will then be performed as required. This can be useful for grouping rows
			 * together.
			 *  @type array
			 *  @default null
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.orderFixed
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "orderFixed": [[0,'asc']]
			 *      } );
			 *    } )
			 */
			"aaSortingFixed": [],
		
		
			/**
			 * DataTables can be instructed to load data to display in the table from a
			 * Ajax source. This option defines how that Ajax call is made and where to.
			 *
			 * The `ajax` property has three different modes of operation, depending on
			 * how it is defined. These are:
			 *
			 * * `string` - Set the URL from where the data should be loaded from.
			 * * `object` - Define properties for `jQuery.ajax`.
			 * * `function` - Custom data get function
			 *
			 * `string`
			 * --------
			 *
			 * As a string, the `ajax` property simply defines the URL from which
			 * DataTables will load data.
			 *
			 * `object`
			 * --------
			 *
			 * As an object, the parameters in the object are passed to
			 * [jQuery.ajax](http://api.jquery.com/jQuery.ajax/) allowing fine control
			 * of the Ajax request. DataTables has a number of default parameters which
			 * you can override using this option. Please refer to the jQuery
			 * documentation for a full description of the options available, although
			 * the following parameters provide additional options in DataTables or
			 * require special consideration:
			 *
			 * * `data` - As with jQuery, `data` can be provided as an object, but it
			 *   can also be used as a function to manipulate the data DataTables sends
			 *   to the server. The function takes a single parameter, an object of
			 *   parameters with the values that DataTables has readied for sending. An
			 *   object may be returned which will be merged into the DataTables
			 *   defaults, or you can add the items to the object that was passed in and
			 *   not return anything from the function. This supersedes `fnServerParams`
			 *   from DataTables 1.9-.
			 *
			 * * `dataSrc` - By default DataTables will look for the property `data` (or
			 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
			 *   from an Ajax source or for server-side processing - this parameter
			 *   allows that property to be changed. You can use Javascript dotted
			 *   object notation to get a data source for multiple levels of nesting, or
			 *   it my be used as a function. As a function it takes a single parameter,
			 *   the JSON returned from the server, which can be manipulated as
			 *   required, with the returned value being that used by DataTables as the
			 *   data source for the table. This supersedes `sAjaxDataProp` from
			 *   DataTables 1.9-.
			 *
			 * * `success` - Should not be overridden it is used internally in
			 *   DataTables. To manipulate / transform the data returned by the server
			 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
			 *
			 * `function`
			 * ----------
			 *
			 * As a function, making the Ajax call is left up to yourself allowing
			 * complete control of the Ajax request. Indeed, if desired, a method other
			 * than Ajax could be used to obtain the required data, such as Web storage
			 * or an AIR database.
			 *
			 * The function is given four parameters and no return is required. The
			 * parameters are:
			 *
			 * 1. _object_ - Data to send to the server
			 * 2. _function_ - Callback function that must be executed when the required
			 *    data has been obtained. That data should be passed into the callback
			 *    as the only parameter
			 * 3. _object_ - DataTables settings object for the table
			 *
			 * Note that this supersedes `fnServerData` from DataTables 1.9-.
			 *
			 *  @type string|object|function
			 *  @default null
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.ajax
			 *  @since 1.10.0
			 *
			 * @example
			 *   // Get JSON data from a file via Ajax.
			 *   // Note DataTables expects data in the form `{ data: [ ...data... ] }` by default).
			 *   $('#example').dataTable( {
			 *     "ajax": "data.json"
			 *   } );
			 *
			 * @example
			 *   // Get JSON data from a file via Ajax, using `dataSrc` to change
			 *   // `data` to `tableData` (i.e. `{ tableData: [ ...data... ] }`)
			 *   $('#example').dataTable( {
			 *     "ajax": {
			 *       "url": "data.json",
			 *       "dataSrc": "tableData"
			 *     }
			 *   } );
			 *
			 * @example
			 *   // Get JSON data from a file via Ajax, using `dataSrc` to read data
			 *   // from a plain array rather than an array in an object
			 *   $('#example').dataTable( {
			 *     "ajax": {
			 *       "url": "data.json",
			 *       "dataSrc": ""
			 *     }
			 *   } );
			 *
			 * @example
			 *   // Manipulate the data returned from the server - add a link to data
			 *   // (note this can, should, be done using `render` for the column - this
			 *   // is just a simple example of how the data can be manipulated).
			 *   $('#example').dataTable( {
			 *     "ajax": {
			 *       "url": "data.json",
			 *       "dataSrc": function ( json ) {
			 *         for ( var i=0, ien=json.length ; i<ien ; i++ ) {
			 *           json[i][0] = '<a href="/message/'+json[i][0]+'>View message</a>';
			 *         }
			 *         return json;
			 *       }
			 *     }
			 *   } );
			 *
			 * @example
			 *   // Add data to the request
			 *   $('#example').dataTable( {
			 *     "ajax": {
			 *       "url": "data.json",
			 *       "data": function ( d ) {
			 *         return {
			 *           "extra_search": $('#extra').val()
			 *         };
			 *       }
			 *     }
			 *   } );
			 *
			 * @example
			 *   // Send request as POST
			 *   $('#example').dataTable( {
			 *     "ajax": {
			 *       "url": "data.json",
			 *       "type": "POST"
			 *     }
			 *   } );
			 *
			 * @example
			 *   // Get the data from localStorage (could interface with a form for
			 *   // adding, editing and removing rows).
			 *   $('#example').dataTable( {
			 *     "ajax": function (data, callback, settings) {
			 *       callback(
			 *         JSON.parse( localStorage.getItem('dataTablesData') )
			 *       );
			 *     }
			 *   } );
			 */
			"ajax": null,
		
		
			/**
			 * This parameter allows you to readily specify the entries in the length drop
			 * down menu that DataTables shows when pagination is enabled. It can be
			 * either a 1D array of options which will be used for both the displayed
			 * option and the value, or a 2D array which will use the array in the first
			 * position as the value, and the array in the second position as the
			 * displayed options (useful for language strings such as 'All').
			 *
			 * Note that the `pageLength` property will be automatically set to the
			 * first value given in this array, unless `pageLength` is also provided.
			 *  @type array
			 *  @default [ 10, 25, 50, 100 ]
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.lengthMenu
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
			 *      } );
			 *    } );
			 */
			"aLengthMenu": [ 10, 25, 50, 100 ],
		
		
			/**
			 * The `columns` option in the initialisation parameter allows you to define
			 * details about the way individual columns behave. For a full list of
			 * column options that can be set, please see
			 * {@link DataTable.defaults.column}. Note that if you use `columns` to
			 * define your columns, you must have an entry in the array for every single
			 * column that you have in your table (these can be null if you don't which
			 * to specify any options).
			 *  @member
			 *
			 *  @name DataTable.defaults.column
			 */
			"aoColumns": null,
		
			/**
			 * Very similar to `columns`, `columnDefs` allows you to target a specific
			 * column, multiple columns, or all columns, using the `targets` property of
			 * each object in the array. This allows great flexibility when creating
			 * tables, as the `columnDefs` arrays can be of any length, targeting the
			 * columns you specifically want. `columnDefs` may use any of the column
			 * options available: {@link DataTable.defaults.column}, but it _must_
			 * have `targets` defined in each object in the array. Values in the `targets`
			 * array may be:
			 *   <ul>
			 *     <li>a string - class name will be matched on the TH for the column</li>
			 *     <li>0 or a positive integer - column index counting from the left</li>
			 *     <li>a negative integer - column index counting from the right</li>
			 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
			 *   </ul>
			 *  @member
			 *
			 *  @name DataTable.defaults.columnDefs
			 */
			"aoColumnDefs": null,
		
		
			/**
			 * Basically the same as `search`, this parameter defines the individual column
			 * filtering state at initialisation time. The array must be of the same size
			 * as the number of columns, and each element be an object with the parameters
			 * `search` and `escapeRegex` (the latter is optional). 'null' is also
			 * accepted and the default will be used.
			 *  @type array
			 *  @default []
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.searchCols
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "searchCols": [
			 *          null,
			 *          { "search": "My filter" },
			 *          null,
			 *          { "search": "^[0-9]", "escapeRegex": false }
			 *        ]
			 *      } );
			 *    } )
			 */
			"aoSearchCols": [],
		
		
			/**
			 * An array of CSS classes that should be applied to displayed rows. This
			 * array may be of any length, and DataTables will apply each class
			 * sequentially, looping when required.
			 *  @type array
			 *  @default null <i>Will take the values determined by the `oClasses.stripe*`
			 *    options</i>
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.stripeClasses
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stripeClasses": [ 'strip1', 'strip2', 'strip3' ]
			 *      } );
			 *    } )
			 */
			"asStripeClasses": null,
		
		
			/**
			 * Enable or disable automatic column width calculation. This can be disabled
			 * as an optimisation (it takes some time to calculate the widths) if the
			 * tables widths are passed in using `columns`.
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.autoWidth
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "autoWidth": false
			 *      } );
			 *    } );
			 */
			"bAutoWidth": true,
		
		
			/**
			 * Deferred rendering can provide DataTables with a huge speed boost when you
			 * are using an Ajax or JS data source for the table. This option, when set to
			 * true, will cause DataTables to defer the creation of the table elements for
			 * each row until they are needed for a draw - saving a significant amount of
			 * time.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.deferRender
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "ajax": "sources/arrays.txt",
			 *        "deferRender": true
			 *      } );
			 *    } );
			 */
			"bDeferRender": false,
		
		
			/**
			 * Replace a DataTable which matches the given selector and replace it with
			 * one which has the properties of the new initialisation object passed. If no
			 * table matches the selector, then the new DataTable will be constructed as
			 * per normal.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.destroy
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "srollY": "200px",
			 *        "paginate": false
			 *      } );
			 *
			 *      // Some time later....
			 *      $('#example').dataTable( {
			 *        "filter": false,
			 *        "destroy": true
			 *      } );
			 *    } );
			 */
			"bDestroy": false,
		
		
			/**
			 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
			 * that it allows the end user to input multiple words (space separated) and
			 * will match a row containing those words, even if not in the order that was
			 * specified (this allow matching across multiple columns). Note that if you
			 * wish to use filtering in DataTables this must remain 'true' - to remove the
			 * default filtering input box and retain filtering abilities, please use
			 * {@link DataTable.defaults.dom}.
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.searching
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "searching": false
			 *      } );
			 *    } );
			 */
			"bFilter": true,
		
		
			/**
			 * Enable or disable the table information display. This shows information
			 * about the data that is currently visible on the page, including information
			 * about filtered data if that action is being performed.
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.info
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "info": false
			 *      } );
			 *    } );
			 */
			"bInfo": true,
		
		
			/**
			 * Allows the end user to select the size of a formatted page from a select
			 * menu (sizes are 10, 25, 50 and 100). Requires pagination (`paginate`).
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.lengthChange
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "lengthChange": false
			 *      } );
			 *    } );
			 */
			"bLengthChange": true,
		
		
			/**
			 * Enable or disable pagination.
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.paging
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "paging": false
			 *      } );
			 *    } );
			 */
			"bPaginate": true,
		
		
			/**
			 * Enable or disable the display of a 'processing' indicator when the table is
			 * being processed (e.g. a sort). This is particularly useful for tables with
			 * large amounts of data where it can take a noticeable amount of time to sort
			 * the entries.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.processing
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "processing": true
			 *      } );
			 *    } );
			 */
			"bProcessing": false,
		
		
			/**
			 * Retrieve the DataTables object for the given selector. Note that if the
			 * table has already been initialised, this parameter will cause DataTables
			 * to simply return the object that has already been set up - it will not take
			 * account of any changes you might have made to the initialisation object
			 * passed to DataTables (setting this parameter to true is an acknowledgement
			 * that you understand this). `destroy` can be used to reinitialise a table if
			 * you need.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.retrieve
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      initTable();
			 *      tableActions();
			 *    } );
			 *
			 *    function initTable ()
			 *    {
			 *      return $('#example').dataTable( {
			 *        "scrollY": "200px",
			 *        "paginate": false,
			 *        "retrieve": true
			 *      } );
			 *    }
			 *
			 *    function tableActions ()
			 *    {
			 *      var table = initTable();
			 *      // perform API operations with oTable
			 *    }
			 */
			"bRetrieve": false,
		
		
			/**
			 * When vertical (y) scrolling is enabled, DataTables will force the height of
			 * the table's viewport to the given height at all times (useful for layout).
			 * However, this can look odd when filtering data down to a small data set,
			 * and the footer is left "floating" further down. This parameter (when
			 * enabled) will cause DataTables to collapse the table's viewport down when
			 * the result set will fit within the given Y height.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.scrollCollapse
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "scrollY": "200",
			 *        "scrollCollapse": true
			 *      } );
			 *    } );
			 */
			"bScrollCollapse": false,
		
		
			/**
			 * Configure DataTables to use server-side processing. Note that the
			 * `ajax` parameter must also be given in order to give DataTables a
			 * source to obtain the required data for each draw.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Features
			 *  @dtopt Server-side
			 *  @name DataTable.defaults.serverSide
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "serverSide": true,
			 *        "ajax": "xhr.php"
			 *      } );
			 *    } );
			 */
			"bServerSide": false,
		
		
			/**
			 * Enable or disable sorting of columns. Sorting of individual columns can be
			 * disabled by the `sortable` option for each column.
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.ordering
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "ordering": false
			 *      } );
			 *    } );
			 */
			"bSort": true,
		
		
			/**
			 * Enable or display DataTables' ability to sort multiple columns at the
			 * same time (activated by shift-click by the user).
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.orderMulti
			 *
			 *  @example
			 *    // Disable multiple column sorting ability
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "orderMulti": false
			 *      } );
			 *    } );
			 */
			"bSortMulti": true,
		
		
			/**
			 * Allows control over whether DataTables should use the top (true) unique
			 * cell that is found for a single column, or the bottom (false - default).
			 * This is useful when using complex headers.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.orderCellsTop
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "orderCellsTop": true
			 *      } );
			 *    } );
			 */
			"bSortCellsTop": false,
		
		
			/**
			 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
			 * `sorting\_3` to the columns which are currently being sorted on. This is
			 * presented as a feature switch as it can increase processing time (while
			 * classes are removed and added) so for large data sets you might want to
			 * turn this off.
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.orderClasses
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "orderClasses": false
			 *      } );
			 *    } );
			 */
			"bSortClasses": true,
		
		
			/**
			 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
			 * used to save table display information such as pagination information,
			 * display length, filtering and sorting. As such when the end user reloads
			 * the page the display display will match what thy had previously set up.
			 *
			 * Due to the use of `localStorage` the default state saving is not supported
			 * in IE6 or 7. If state saving is required in those browsers, use
			 * `stateSaveCallback` to provide a storage solution such as cookies.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.stateSave
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "stateSave": true
			 *      } );
			 *    } );
			 */
			"bStateSave": false,
		
		
			/**
			 * This function is called when a TR element is created (and all TD child
			 * elements have been inserted), or registered if using a DOM source, allowing
			 * manipulation of the TR element (adding classes etc).
			 *  @type function
			 *  @param {node} row "TR" element for the current row
			 *  @param {array} data Raw data array for this row
			 *  @param {int} dataIndex The index of this row in the internal aoData array
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.createdRow
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "createdRow": function( row, data, dataIndex ) {
			 *          // Bold the grade for all 'A' grade browsers
			 *          if ( data[4] == "A" )
			 *          {
			 *            $('td:eq(4)', row).html( '<b>A</b>' );
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"fnCreatedRow": null,
		
		
			/**
			 * This function is called on every 'draw' event, and allows you to
			 * dynamically modify any aspect you want about the created DOM.
			 *  @type function
			 *  @param {object} settings DataTables settings object
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.drawCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "drawCallback": function( settings ) {
			 *          alert( 'DataTables has redrawn the table' );
			 *        }
			 *      } );
			 *    } );
			 */
			"fnDrawCallback": null,
		
		
			/**
			 * Identical to fnHeaderCallback() but for the table footer this function
			 * allows you to modify the table footer on every 'draw' event.
			 *  @type function
			 *  @param {node} foot "TR" element for the footer
			 *  @param {array} data Full table data (as derived from the original HTML)
			 *  @param {int} start Index for the current display starting point in the
			 *    display array
			 *  @param {int} end Index for the current display ending point in the
			 *    display array
			 *  @param {array int} display Index array to translate the visual position
			 *    to the full data array
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.footerCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "footerCallback": function( tfoot, data, start, end, display ) {
			 *          tfoot.getElementsByTagName('th')[0].innerHTML = "Starting index is "+start;
			 *        }
			 *      } );
			 *    } )
			 */
			"fnFooterCallback": null,
		
		
			/**
			 * When rendering large numbers in the information element for the table
			 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
			 * to have a comma separator for the 'thousands' units (e.g. 1 million is
			 * rendered as "1,000,000") to help readability for the end user. This
			 * function will override the default method DataTables uses.
			 *  @type function
			 *  @member
			 *  @param {int} toFormat number to be formatted
			 *  @returns {string} formatted string for DataTables to show the number
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.formatNumber
			 *
			 *  @example
			 *    // Format a number using a single quote for the separator (note that
			 *    // this can also be done with the language.thousands option)
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "formatNumber": function ( toFormat ) {
			 *          return toFormat.toString().replace(
			 *            /\B(?=(\d{3})+(?!\d))/g, "'"
			 *          );
			 *        };
			 *      } );
			 *    } );
			 */
			"fnFormatNumber": function ( toFormat ) {
				return toFormat.toString().replace(
					/\B(?=(\d{3})+(?!\d))/g,
					this.oLanguage.sThousands
				);
			},
		
		
			/**
			 * This function is called on every 'draw' event, and allows you to
			 * dynamically modify the header row. This can be used to calculate and
			 * display useful information about the table.
			 *  @type function
			 *  @param {node} head "TR" element for the header
			 *  @param {array} data Full table data (as derived from the original HTML)
			 *  @param {int} start Index for the current display starting point in the
			 *    display array
			 *  @param {int} end Index for the current display ending point in the
			 *    display array
			 *  @param {array int} display Index array to translate the visual position
			 *    to the full data array
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.headerCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "fheaderCallback": function( head, data, start, end, display ) {
			 *          head.getElementsByTagName('th')[0].innerHTML = "Displaying "+(end-start)+" records";
			 *        }
			 *      } );
			 *    } )
			 */
			"fnHeaderCallback": null,
		
		
			/**
			 * The information element can be used to convey information about the current
			 * state of the table. Although the internationalisation options presented by
			 * DataTables are quite capable of dealing with most customisations, there may
			 * be times where you wish to customise the string further. This callback
			 * allows you to do exactly that.
			 *  @type function
			 *  @param {object} oSettings DataTables settings object
			 *  @param {int} start Starting position in data for the draw
			 *  @param {int} end End position in data for the draw
			 *  @param {int} max Total number of rows in the table (regardless of
			 *    filtering)
			 *  @param {int} total Total number of rows in the data set, after filtering
			 *  @param {string} pre The string that DataTables has formatted using it's
			 *    own rules
			 *  @returns {string} The string to be displayed in the information element.
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.infoCallback
			 *
			 *  @example
			 *    $('#example').dataTable( {
			 *      "infoCallback": function( settings, start, end, max, total, pre ) {
			 *        return start +" to "+ end;
			 *      }
			 *    } );
			 */
			"fnInfoCallback": null,
		
		
			/**
			 * Called when the table has been initialised. Normally DataTables will
			 * initialise sequentially and there will be no need for this function,
			 * however, this does not hold true when using external language information
			 * since that is obtained using an async XHR call.
			 *  @type function
			 *  @param {object} settings DataTables settings object
			 *  @param {object} json The JSON object request from the server - only
			 *    present if client-side Ajax sourced data is used
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.initComplete
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "initComplete": function(settings, json) {
			 *          alert( 'DataTables has finished its initialisation.' );
			 *        }
			 *      } );
			 *    } )
			 */
			"fnInitComplete": null,
		
		
			/**
			 * Called at the very start of each table draw and can be used to cancel the
			 * draw by returning false, any other return (including undefined) results in
			 * the full draw occurring).
			 *  @type function
			 *  @param {object} settings DataTables settings object
			 *  @returns {boolean} False will cancel the draw, anything else (including no
			 *    return) will allow it to complete.
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.preDrawCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "preDrawCallback": function( settings ) {
			 *          if ( $('#test').val() == 1 ) {
			 *            return false;
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"fnPreDrawCallback": null,
		
		
			/**
			 * This function allows you to 'post process' each row after it have been
			 * generated for each table draw, but before it is rendered on screen. This
			 * function might be used for setting the row class name etc.
			 *  @type function
			 *  @param {node} row "TR" element for the current row
			 *  @param {array} data Raw data array for this row
			 *  @param {int} displayIndex The display index for the current table draw
			 *  @param {int} displayIndexFull The index of the data in the full list of
			 *    rows (after filtering)
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.rowCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "rowCallback": function( row, data, displayIndex, displayIndexFull ) {
			 *          // Bold the grade for all 'A' grade browsers
			 *          if ( data[4] == "A" ) {
			 *            $('td:eq(4)', row).html( '<b>A</b>' );
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"fnRowCallback": null,
		
		
			/**
			 * __Deprecated__ The functionality provided by this parameter has now been
			 * superseded by that provided through `ajax`, which should be used instead.
			 *
			 * This parameter allows you to override the default function which obtains
			 * the data from the server so something more suitable for your application.
			 * For example you could use POST data, or pull information from a Gears or
			 * AIR database.
			 *  @type function
			 *  @member
			 *  @param {string} source HTTP source to obtain the data from (`ajax`)
			 *  @param {array} data A key/value pair object containing the data to send
			 *    to the server
			 *  @param {function} callback to be called on completion of the data get
			 *    process that will draw the data on the page.
			 *  @param {object} settings DataTables settings object
			 *
			 *  @dtopt Callbacks
			 *  @dtopt Server-side
			 *  @name DataTable.defaults.serverData
			 *
			 *  @deprecated 1.10. Please use `ajax` for this functionality now.
			 */
			"fnServerData": null,
		
		
			/**
			 * __Deprecated__ The functionality provided by this parameter has now been
			 * superseded by that provided through `ajax`, which should be used instead.
			 *
			 *  It is often useful to send extra data to the server when making an Ajax
			 * request - for example custom filtering information, and this callback
			 * function makes it trivial to send extra information to the server. The
			 * passed in parameter is the data set that has been constructed by
			 * DataTables, and you can add to this or modify it as you require.
			 *  @type function
			 *  @param {array} data Data array (array of objects which are name/value
			 *    pairs) that has been constructed by DataTables and will be sent to the
			 *    server. In the case of Ajax sourced data with server-side processing
			 *    this will be an empty array, for server-side processing there will be a
			 *    significant number of parameters!
			 *  @returns {undefined} Ensure that you modify the data array passed in,
			 *    as this is passed by reference.
			 *
			 *  @dtopt Callbacks
			 *  @dtopt Server-side
			 *  @name DataTable.defaults.serverParams
			 *
			 *  @deprecated 1.10. Please use `ajax` for this functionality now.
			 */
			"fnServerParams": null,
		
		
			/**
			 * Load the table state. With this function you can define from where, and how, the
			 * state of a table is loaded. By default DataTables will load from `localStorage`
			 * but you might wish to use a server-side database or cookies.
			 *  @type function
			 *  @member
			 *  @param {object} settings DataTables settings object
			 *  @param {object} callback Callback that can be executed when done. It
			 *    should be passed the loaded state object.
			 *  @return {object} The DataTables state object to be loaded
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.stateLoadCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateSave": true,
			 *        "stateLoadCallback": function (settings, callback) {
			 *          $.ajax( {
			 *            "url": "/state_load",
			 *            "dataType": "json",
			 *            "success": function (json) {
			 *              callback( json );
			 *            }
			 *          } );
			 *        }
			 *      } );
			 *    } );
			 */
			"fnStateLoadCallback": function ( settings ) {
				try {
					return JSON.parse(
						(settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem(
							'DataTables_'+settings.sInstance+'_'+location.pathname
						)
					);
				} catch (e) {}
			},
		
		
			/**
			 * Callback which allows modification of the saved state prior to loading that state.
			 * This callback is called when the table is loading state from the stored data, but
			 * prior to the settings object being modified by the saved state. Note that for
			 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
			 * a plug-in.
			 *  @type function
			 *  @param {object} settings DataTables settings object
			 *  @param {object} data The state object that is to be loaded
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.stateLoadParams
			 *
			 *  @example
			 *    // Remove a saved filter, so filtering is never loaded
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateSave": true,
			 *        "stateLoadParams": function (settings, data) {
			 *          data.oSearch.sSearch = "";
			 *        }
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Disallow state loading by returning false
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateSave": true,
			 *        "stateLoadParams": function (settings, data) {
			 *          return false;
			 *        }
			 *      } );
			 *    } );
			 */
			"fnStateLoadParams": null,
		
		
			/**
			 * Callback that is called when the state has been loaded from the state saving method
			 * and the DataTables settings object has been modified as a result of the loaded state.
			 *  @type function
			 *  @param {object} settings DataTables settings object
			 *  @param {object} data The state object that was loaded
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.stateLoaded
			 *
			 *  @example
			 *    // Show an alert with the filtering value that was saved
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateSave": true,
			 *        "stateLoaded": function (settings, data) {
			 *          alert( 'Saved filter was: '+data.oSearch.sSearch );
			 *        }
			 *      } );
			 *    } );
			 */
			"fnStateLoaded": null,
		
		
			/**
			 * Save the table state. This function allows you to define where and how the state
			 * information for the table is stored By default DataTables will use `localStorage`
			 * but you might wish to use a server-side database or cookies.
			 *  @type function
			 *  @member
			 *  @param {object} settings DataTables settings object
			 *  @param {object} data The state object to be saved
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.stateSaveCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateSave": true,
			 *        "stateSaveCallback": function (settings, data) {
			 *          // Send an Ajax request to the server with the state object
			 *          $.ajax( {
			 *            "url": "/state_save",
			 *            "data": data,
			 *            "dataType": "json",
			 *            "method": "POST"
			 *            "success": function () {}
			 *          } );
			 *        }
			 *      } );
			 *    } );
			 */
			"fnStateSaveCallback": function ( settings, data ) {
				try {
					(settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem(
						'DataTables_'+settings.sInstance+'_'+location.pathname,
						JSON.stringify( data )
					);
				} catch (e) {}
			},
		
		
			/**
			 * Callback which allows modification of the state to be saved. Called when the table
			 * has changed state a new state save is required. This method allows modification of
			 * the state saving object prior to actually doing the save, including addition or
			 * other state properties or modification. Note that for plug-in authors, you should
			 * use the `stateSaveParams` event to save parameters for a plug-in.
			 *  @type function
			 *  @param {object} settings DataTables settings object
			 *  @param {object} data The state object to be saved
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.stateSaveParams
			 *
			 *  @example
			 *    // Remove a saved filter, so filtering is never saved
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateSave": true,
			 *        "stateSaveParams": function (settings, data) {
			 *          data.oSearch.sSearch = "";
			 *        }
			 *      } );
			 *    } );
			 */
			"fnStateSaveParams": null,
		
		
			/**
			 * Duration for which the saved state information is considered valid. After this period
			 * has elapsed the state will be returned to the default.
			 * Value is given in seconds.
			 *  @type int
			 *  @default 7200 <i>(2 hours)</i>
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.stateDuration
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateDuration": 60*60*24; // 1 day
			 *      } );
			 *    } )
			 */
			"iStateDuration": 7200,
		
		
			/**
			 * When enabled DataTables will not make a request to the server for the first
			 * page draw - rather it will use the data already on the page (no sorting etc
			 * will be applied to it), thus saving on an XHR at load time. `deferLoading`
			 * is used to indicate that deferred loading is required, but it is also used
			 * to tell DataTables how many records there are in the full table (allowing
			 * the information element and pagination to be displayed correctly). In the case
			 * where a filtering is applied to the table on initial load, this can be
			 * indicated by giving the parameter as an array, where the first element is
			 * the number of records available after filtering and the second element is the
			 * number of records without filtering (allowing the table information element
			 * to be shown correctly).
			 *  @type int | array
			 *  @default null
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.deferLoading
			 *
			 *  @example
			 *    // 57 records available in the table, no filtering applied
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "serverSide": true,
			 *        "ajax": "scripts/server_processing.php",
			 *        "deferLoading": 57
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // 57 records after filtering, 100 without filtering (an initial filter applied)
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "serverSide": true,
			 *        "ajax": "scripts/server_processing.php",
			 *        "deferLoading": [ 57, 100 ],
			 *        "search": {
			 *          "search": "my_filter"
			 *        }
			 *      } );
			 *    } );
			 */
			"iDeferLoading": null,
		
		
			/**
			 * Number of rows to display on a single page when using pagination. If
			 * feature enabled (`lengthChange`) then the end user will be able to override
			 * this to a custom setting using a pop-up menu.
			 *  @type int
			 *  @default 10
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.pageLength
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "pageLength": 50
			 *      } );
			 *    } )
			 */
			"iDisplayLength": 10,
		
		
			/**
			 * Define the starting point for data display when using DataTables with
			 * pagination. Note that this parameter is the number of records, rather than
			 * the page number, so if you have 10 records per page and want to start on
			 * the third page, it should be "20".
			 *  @type int
			 *  @default 0
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.displayStart
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "displayStart": 20
			 *      } );
			 *    } )
			 */
			"iDisplayStart": 0,
		
		
			/**
			 * By default DataTables allows keyboard navigation of the table (sorting, paging,
			 * and filtering) by adding a `tabindex` attribute to the required elements. This
			 * allows you to tab through the controls and press the enter key to activate them.
			 * The tabindex is default 0, meaning that the tab follows the flow of the document.
			 * You can overrule this using this parameter if you wish. Use a value of -1 to
			 * disable built-in keyboard navigation.
			 *  @type int
			 *  @default 0
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.tabIndex
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "tabIndex": 1
			 *      } );
			 *    } );
			 */
			"iTabIndex": 0,
		
		
			/**
			 * Classes that DataTables assigns to the various components and features
			 * that it adds to the HTML table. This allows classes to be configured
			 * during initialisation in addition to through the static
			 * {@link DataTable.ext.oStdClasses} object).
			 *  @namespace
			 *  @name DataTable.defaults.classes
			 */
			"oClasses": {},
		
		
			/**
			 * All strings that DataTables uses in the user interface that it creates
			 * are defined in this object, allowing you to modified them individually or
			 * completely replace them all as required.
			 *  @namespace
			 *  @name DataTable.defaults.language
			 */
			"oLanguage": {
				/**
				 * Strings that are used for WAI-ARIA labels and controls only (these are not
				 * actually visible on the page, but will be read by screenreaders, and thus
				 * must be internationalised as well).
				 *  @namespace
				 *  @name DataTable.defaults.language.aria
				 */
				"oAria": {
					/**
					 * ARIA label that is added to the table headers when the column may be
					 * sorted ascending by activing the column (click or return when focused).
					 * Note that the column header is prefixed to this string.
					 *  @type string
					 *  @default : activate to sort column ascending
					 *
					 *  @dtopt Language
					 *  @name DataTable.defaults.language.aria.sortAscending
					 *
					 *  @example
					 *    $(document).ready( function() {
					 *      $('#example').dataTable( {
					 *        "language": {
					 *          "aria": {
					 *            "sortAscending": " - click/return to sort ascending"
					 *          }
					 *        }
					 *      } );
					 *    } );
					 */
					"sSortAscending": ": activate to sort column ascending",
		
					/**
					 * ARIA label that is added to the table headers when the column may be
					 * sorted descending by activing the column (click or return when focused).
					 * Note that the column header is prefixed to this string.
					 *  @type string
					 *  @default : activate to sort column ascending
					 *
					 *  @dtopt Language
					 *  @name DataTable.defaults.language.aria.sortDescending
					 *
					 *  @example
					 *    $(document).ready( function() {
					 *      $('#example').dataTable( {
					 *        "language": {
					 *          "aria": {
					 *            "sortDescending": " - click/return to sort descending"
					 *          }
					 *        }
					 *      } );
					 *    } );
					 */
					"sSortDescending": ": activate to sort column descending"
				},
		
				/**
				 * Pagination string used by DataTables for the built-in pagination
				 * control types.
				 *  @namespace
				 *  @name DataTable.defaults.language.paginate
				 */
				"oPaginate": {
					/**
					 * Text to use when using the 'full_numbers' type of pagination for the
					 * button to take the user to the first page.
					 *  @type string
					 *  @default First
					 *
					 *  @dtopt Language
					 *  @name DataTable.defaults.language.paginate.first
					 *
					 *  @example
					 *    $(document).ready( function() {
					 *      $('#example').dataTable( {
					 *        "language": {
					 *          "paginate": {
					 *            "first": "First page"
					 *          }
					 *        }
					 *      } );
					 *    } );
					 */
					"sFirst": "First",
		
		
					/**
					 * Text to use when using the 'full_numbers' type of pagination for the
					 * button to take the user to the last page.
					 *  @type string
					 *  @default Last
					 *
					 *  @dtopt Language
					 *  @name DataTable.defaults.language.paginate.last
					 *
					 *  @example
					 *    $(document).ready( function() {
					 *      $('#example').dataTable( {
					 *        "language": {
					 *          "paginate": {
					 *            "last": "Last page"
					 *          }
					 *        }
					 *      } );
					 *    } );
					 */
					"sLast": "Last",
		
		
					/**
					 * Text to use for the 'next' pagination button (to take the user to the
					 * next page).
					 *  @type string
					 *  @default Next
					 *
					 *  @dtopt Language
					 *  @name DataTable.defaults.language.paginate.next
					 *
					 *  @example
					 *    $(document).ready( function() {
					 *      $('#example').dataTable( {
					 *        "language": {
					 *          "paginate": {
					 *            "next": "Next page"
					 *          }
					 *        }
					 *      } );
					 *    } );
					 */
					"sNext": "Next",
		
		
					/**
					 * Text to use for the 'previous' pagination button (to take the user to
					 * the previous page).
					 *  @type string
					 *  @default Previous
					 *
					 *  @dtopt Language
					 *  @name DataTable.defaults.language.paginate.previous
					 *
					 *  @example
					 *    $(document).ready( function() {
					 *      $('#example').dataTable( {
					 *        "language": {
					 *          "paginate": {
					 *            "previous": "Previous page"
					 *          }
					 *        }
					 *      } );
					 *    } );
					 */
					"sPrevious": "Previous"
				},
		
				/**
				 * This string is shown in preference to `zeroRecords` when the table is
				 * empty of data (regardless of filtering). Note that this is an optional
				 * parameter - if it is not given, the value of `zeroRecords` will be used
				 * instead (either the default or given value).
				 *  @type string
				 *  @default No data available in table
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.emptyTable
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "emptyTable": "No data available in table"
				 *        }
				 *      } );
				 *    } );
				 */
				"sEmptyTable": "No data available in table",
		
		
				/**
				 * This string gives information to the end user about the information
				 * that is current on display on the page. The following tokens can be
				 * used in the string and will be dynamically replaced as the table
				 * display updates. This tokens can be placed anywhere in the string, or
				 * removed as needed by the language requires:
				 *
				 * * `\_START\_` - Display index of the first record on the current page
				 * * `\_END\_` - Display index of the last record on the current page
				 * * `\_TOTAL\_` - Number of records in the table after filtering
				 * * `\_MAX\_` - Number of records in the table without filtering
				 * * `\_PAGE\_` - Current page number
				 * * `\_PAGES\_` - Total number of pages of data in the table
				 *
				 *  @type string
				 *  @default Showing _START_ to _END_ of _TOTAL_ entries
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.info
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "info": "Showing page _PAGE_ of _PAGES_"
				 *        }
				 *      } );
				 *    } );
				 */
				"sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",
		
		
				/**
				 * Display information string for when the table is empty. Typically the
				 * format of this string should match `info`.
				 *  @type string
				 *  @default Showing 0 to 0 of 0 entries
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.infoEmpty
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "infoEmpty": "No entries to show"
				 *        }
				 *      } );
				 *    } );
				 */
				"sInfoEmpty": "Showing 0 to 0 of 0 entries",
		
		
				/**
				 * When a user filters the information in a table, this string is appended
				 * to the information (`info`) to give an idea of how strong the filtering
				 * is. The variable _MAX_ is dynamically updated.
				 *  @type string
				 *  @default (filtered from _MAX_ total entries)
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.infoFiltered
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "infoFiltered": " - filtering from _MAX_ records"
				 *        }
				 *      } );
				 *    } );
				 */
				"sInfoFiltered": "(filtered from _MAX_ total entries)",
		
		
				/**
				 * If can be useful to append extra information to the info string at times,
				 * and this variable does exactly that. This information will be appended to
				 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
				 * being used) at all times.
				 *  @type string
				 *  @default <i>Empty string</i>
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.infoPostFix
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "infoPostFix": "All records shown are derived from real information."
				 *        }
				 *      } );
				 *    } );
				 */
				"sInfoPostFix": "",
		
		
				/**
				 * This decimal place operator is a little different from the other
				 * language options since DataTables doesn't output floating point
				 * numbers, so it won't ever use this for display of a number. Rather,
				 * what this parameter does is modify the sort methods of the table so
				 * that numbers which are in a format which has a character other than
				 * a period (`.`) as a decimal place will be sorted numerically.
				 *
				 * Note that numbers with different decimal places cannot be shown in
				 * the same table and still be sortable, the table must be consistent.
				 * However, multiple different tables on the page can use different
				 * decimal place characters.
				 *  @type string
				 *  @default 
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.decimal
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "decimal": ","
				 *          "thousands": "."
				 *        }
				 *      } );
				 *    } );
				 */
				"sDecimal": "",
		
		
				/**
				 * DataTables has a build in number formatter (`formatNumber`) which is
				 * used to format large numbers that are used in the table information.
				 * By default a comma is used, but this can be trivially changed to any
				 * character you wish with this parameter.
				 *  @type string
				 *  @default ,
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.thousands
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "thousands": "'"
				 *        }
				 *      } );
				 *    } );
				 */
				"sThousands": ",",
		
		
				/**
				 * Detail the action that will be taken when the drop down menu for the
				 * pagination length option is changed. The '_MENU_' variable is replaced
				 * with a default select list of 10, 25, 50 and 100, and can be replaced
				 * with a custom select box if required.
				 *  @type string
				 *  @default Show _MENU_ entries
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.lengthMenu
				 *
				 *  @example
				 *    // Language change only
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "lengthMenu": "Display _MENU_ records"
				 *        }
				 *      } );
				 *    } );
				 *
				 *  @example
				 *    // Language and options change
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "lengthMenu": 'Display <select>'+
				 *            '<option value="10">10</option>'+
				 *            '<option value="20">20</option>'+
				 *            '<option value="30">30</option>'+
				 *            '<option value="40">40</option>'+
				 *            '<option value="50">50</option>'+
				 *            '<option value="-1">All</option>'+
				 *            '</select> records'
				 *        }
				 *      } );
				 *    } );
				 */
				"sLengthMenu": "Show _MENU_ entries",
		
		
				/**
				 * When using Ajax sourced data and during the first draw when DataTables is
				 * gathering the data, this message is shown in an empty row in the table to
				 * indicate to the end user the the data is being loaded. Note that this
				 * parameter is not used when loading data by server-side processing, just
				 * Ajax sourced data with client-side processing.
				 *  @type string
				 *  @default Loading...
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.loadingRecords
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "loadingRecords": "Please wait - loading..."
				 *        }
				 *      } );
				 *    } );
				 */
				"sLoadingRecords": "Loading...",
		
		
				/**
				 * Text which is displayed when the table is processing a user action
				 * (usually a sort command or similar).
				 *  @type string
				 *  @default Processing...
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.processing
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "processing": "DataTables is currently busy"
				 *        }
				 *      } );
				 *    } );
				 */
				"sProcessing": "Processing...",
		
		
				/**
				 * Details the actions that will be taken when the user types into the
				 * filtering input text box. The variable "_INPUT_", if used in the string,
				 * is replaced with the HTML text box for the filtering input allowing
				 * control over where it appears in the string. If "_INPUT_" is not given
				 * then the input box is appended to the string automatically.
				 *  @type string
				 *  @default Search:
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.search
				 *
				 *  @example
				 *    // Input text box will be appended at the end automatically
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "search": "Filter records:"
				 *        }
				 *      } );
				 *    } );
				 *
				 *  @example
				 *    // Specify where the filter should appear
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "search": "Apply filter _INPUT_ to table"
				 *        }
				 *      } );
				 *    } );
				 */
				"sSearch": "Search:",
		
		
				/**
				 * Assign a `placeholder` attribute to the search `input` element
				 *  @type string
				 *  @default 
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.searchPlaceholder
				 */
				"sSearchPlaceholder": "",
		
		
				/**
				 * All of the language information can be stored in a file on the
				 * server-side, which DataTables will look up if this parameter is passed.
				 * It must store the URL of the language file, which is in a JSON format,
				 * and the object has the same properties as the oLanguage object in the
				 * initialiser object (i.e. the above parameters). Please refer to one of
				 * the example language files to see how this works in action.
				 *  @type string
				 *  @default <i>Empty string - i.e. disabled</i>
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.url
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "url": "http://www.sprymedia.co.uk/dataTables/lang.txt"
				 *        }
				 *      } );
				 *    } );
				 */
				"sUrl": "",
		
		
				/**
				 * Text shown inside the table records when the is no information to be
				 * displayed after filtering. `emptyTable` is shown when there is simply no
				 * information in the table at all (regardless of filtering).
				 *  @type string
				 *  @default No matching records found
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.zeroRecords
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "zeroRecords": "No records to display"
				 *        }
				 *      } );
				 *    } );
				 */
				"sZeroRecords": "No matching records found"
			},
		
		
			/**
			 * This parameter allows you to have define the global filtering state at
			 * initialisation time. As an object the `search` parameter must be
			 * defined, but all other parameters are optional. When `regex` is true,
			 * the search string will be treated as a regular expression, when false
			 * (default) it will be treated as a straight string. When `smart`
			 * DataTables will use it's smart filtering methods (to word match at
			 * any point in the data), when false this will not be done.
			 *  @namespace
			 *  @extends DataTable.models.oSearch
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.search
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "search": {"search": "Initial search"}
			 *      } );
			 *    } )
			 */
			"oSearch": $.extend( {}, DataTable.models.oSearch ),
		
		
			/**
			 * __Deprecated__ The functionality provided by this parameter has now been
			 * superseded by that provided through `ajax`, which should be used instead.
			 *
			 * By default DataTables will look for the property `data` (or `aaData` for
			 * compatibility with DataTables 1.9-) when obtaining data from an Ajax
			 * source or for server-side processing - this parameter allows that
			 * property to be changed. You can use Javascript dotted object notation to
			 * get a data source for multiple levels of nesting.
			 *  @type string
			 *  @default data
			 *
			 *  @dtopt Options
			 *  @dtopt Server-side
			 *  @name DataTable.defaults.ajaxDataProp
			 *
			 *  @deprecated 1.10. Please use `ajax` for this functionality now.
			 */
			"sAjaxDataProp": "data",
		
		
			/**
			 * __Deprecated__ The functionality provided by this parameter has now been
			 * superseded by that provided through `ajax`, which should be used instead.
			 *
			 * You can instruct DataTables to load data from an external
			 * source using this parameter (use aData if you want to pass data in you
			 * already have). Simply provide a url a JSON object can be obtained from.
			 *  @type string
			 *  @default null
			 *
			 *  @dtopt Options
			 *  @dtopt Server-side
			 *  @name DataTable.defaults.ajaxSource
			 *
			 *  @deprecated 1.10. Please use `ajax` for this functionality now.
			 */
			"sAjaxSource": null,
		
		
			/**
			 * This initialisation variable allows you to specify exactly where in the
			 * DOM you want DataTables to inject the various controls it adds to the page
			 * (for example you might want the pagination controls at the top of the
			 * table). DIV elements (with or without a custom class) can also be added to
			 * aid styling. The follow syntax is used:
			 *   <ul>
			 *     <li>The following options are allowed:
			 *       <ul>
			 *         <li>'l' - Length changing</li>
			 *         <li>'f' - Filtering input</li>
			 *         <li>'t' - The table!</li>
			 *         <li>'i' - Information</li>
			 *         <li>'p' - Pagination</li>
			 *         <li>'r' - pRocessing</li>
			 *       </ul>
			 *     </li>
			 *     <li>The following constants are allowed:
			 *       <ul>
			 *         <li>'H' - jQueryUI theme "header" classes ('fg-toolbar ui-widget-header ui-corner-tl ui-corner-tr ui-helper-clearfix')</li>
			 *         <li>'F' - jQueryUI theme "footer" classes ('fg-toolbar ui-widget-header ui-corner-bl ui-corner-br ui-helper-clearfix')</li>
			 *       </ul>
			 *     </li>
			 *     <li>The following syntax is expected:
			 *       <ul>
			 *         <li>'&lt;' and '&gt;' - div elements</li>
			 *         <li>'&lt;"class" and '&gt;' - div with a class</li>
			 *         <li>'&lt;"#id" and '&gt;' - div with an ID</li>
			 *       </ul>
			 *     </li>
			 *     <li>Examples:
			 *       <ul>
			 *         <li>'&lt;"wrapper"flipt&gt;'</li>
			 *         <li>'&lt;lf&lt;t&gt;ip&gt;'</li>
			 *       </ul>
			 *     </li>
			 *   </ul>
			 *  @type string
			 *  @default lfrtip <i>(when `jQueryUI` is false)</i> <b>or</b>
			 *    <"H"lfr>t<"F"ip> <i>(when `jQueryUI` is true)</i>
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.dom
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "dom": '&lt;"top"i&gt;rt&lt;"bottom"flp&gt;&lt;"clear"&gt;'
			 *      } );
			 *    } );
			 */
			"sDom": "lfrtip",
		
		
			/**
			 * Search delay option. This will throttle full table searches that use the
			 * DataTables provided search input element (it does not effect calls to
			 * `dt-api search()`, providing a delay before the search is made.
			 *  @type integer
			 *  @default 0
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.searchDelay
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "searchDelay": 200
			 *      } );
			 *    } )
			 */
			"searchDelay": null,
		
		
			/**
			 * DataTables features six different built-in options for the buttons to
			 * display for pagination control:
			 *
			 * * `numbers` - Page number buttons only
			 * * `simple` - 'Previous' and 'Next' buttons only
			 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
			 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
			 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
			 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
			 *  
			 * Further methods can be added using {@link DataTable.ext.oPagination}.
			 *  @type string
			 *  @default simple_numbers
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.pagingType
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "pagingType": "full_numbers"
			 *      } );
			 *    } )
			 */
			"sPaginationType": "simple_numbers",
		
		
			/**
			 * Enable horizontal scrolling. When a table is too wide to fit into a
			 * certain layout, or you have a large number of columns in the table, you
			 * can enable x-scrolling to show the table in a viewport, which can be
			 * scrolled. This property can be `true` which will allow the table to
			 * scroll horizontally when needed, or any CSS unit, or a number (in which
			 * case it will be treated as a pixel measurement). Setting as simply `true`
			 * is recommended.
			 *  @type boolean|string
			 *  @default <i>blank string - i.e. disabled</i>
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.scrollX
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "scrollX": true,
			 *        "scrollCollapse": true
			 *      } );
			 *    } );
			 */
			"sScrollX": "",
		
		
			/**
			 * This property can be used to force a DataTable to use more width than it
			 * might otherwise do when x-scrolling is enabled. For example if you have a
			 * table which requires to be well spaced, this parameter is useful for
			 * "over-sizing" the table, and thus forcing scrolling. This property can by
			 * any CSS unit, or a number (in which case it will be treated as a pixel
			 * measurement).
			 *  @type string
			 *  @default <i>blank string - i.e. disabled</i>
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.scrollXInner
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "scrollX": "100%",
			 *        "scrollXInner": "110%"
			 *      } );
			 *    } );
			 */
			"sScrollXInner": "",
		
		
			/**
			 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
			 * to the given height, and enable scrolling for any data which overflows the
			 * current viewport. This can be used as an alternative to paging to display
			 * a lot of data in a small area (although paging and scrolling can both be
			 * enabled at the same time). This property can be any CSS unit, or a number
			 * (in which case it will be treated as a pixel measurement).
			 *  @type string
			 *  @default <i>blank string - i.e. disabled</i>
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.scrollY
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "scrollY": "200px",
			 *        "paginate": false
			 *      } );
			 *    } );
			 */
			"sScrollY": "",
		
		
			/**
			 * __Deprecated__ The functionality provided by this parameter has now been
			 * superseded by that provided through `ajax`, which should be used instead.
			 *
			 * Set the HTTP method that is used to make the Ajax call for server-side
			 * processing or Ajax sourced data.
			 *  @type string
			 *  @default GET
			 *
			 *  @dtopt Options
			 *  @dtopt Server-side
			 *  @name DataTable.defaults.serverMethod
			 *
			 *  @deprecated 1.10. Please use `ajax` for this functionality now.
			 */
			"sServerMethod": "GET",
		
		
			/**
			 * DataTables makes use of renderers when displaying HTML elements for
			 * a table. These renderers can be added or modified by plug-ins to
			 * generate suitable mark-up for a site. For example the Bootstrap
			 * integration plug-in for DataTables uses a paging button renderer to
			 * display pagination buttons in the mark-up required by Bootstrap.
			 *
			 * For further information about the renderers available see
			 * DataTable.ext.renderer
			 *  @type string|object
			 *  @default null
			 *
			 *  @name DataTable.defaults.renderer
			 *
			 */
			"renderer": null,
		
		
			/**
			 * Set the data property name that DataTables should use to get a row's id
			 * to set as the `id` property in the node.
			 *  @type string
			 *  @default DT_RowId
			 *
			 *  @name DataTable.defaults.rowId
			 */
			"rowId": "DT_RowId"
		};
		
		_fnHungarianMap( DataTable.defaults );
		
		
		
		/*
		 * Developer note - See note in model.defaults.js about the use of Hungarian
		 * notation and camel case.
		 */
		
		/**
		 * Column options that can be given to DataTables at initialisation time.
		 *  @namespace
		 */
		DataTable.defaults.column = {
			/**
			 * Define which column(s) an order will occur on for this column. This
			 * allows a column's ordering to take multiple columns into account when
			 * doing a sort or use the data from a different column. For example first
			 * name / last name columns make sense to do a multi-column sort over the
			 * two columns.
			 *  @type array|int
			 *  @default null <i>Takes the value of the column index automatically</i>
			 *
			 *  @name DataTable.defaults.column.orderData
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "orderData": [ 0, 1 ], "targets": [ 0 ] },
			 *          { "orderData": [ 1, 0 ], "targets": [ 1 ] },
			 *          { "orderData": 2, "targets": [ 2 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "orderData": [ 0, 1 ] },
			 *          { "orderData": [ 1, 0 ] },
			 *          { "orderData": 2 },
			 *          null,
			 *          null
			 *        ]
			 *      } );
			 *    } );
			 */
			"aDataSort": null,
			"iDataSort": -1,
		
		
			/**
			 * You can control the default ordering direction, and even alter the
			 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
			 * using this parameter.
			 *  @type array
			 *  @default [ 'asc', 'desc' ]
			 *
			 *  @name DataTable.defaults.column.orderSequence
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "orderSequence": [ "asc" ], "targets": [ 1 ] },
			 *          { "orderSequence": [ "desc", "asc", "asc" ], "targets": [ 2 ] },
			 *          { "orderSequence": [ "desc" ], "targets": [ 3 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          null,
			 *          { "orderSequence": [ "asc" ] },
			 *          { "orderSequence": [ "desc", "asc", "asc" ] },
			 *          { "orderSequence": [ "desc" ] },
			 *          null
			 *        ]
			 *      } );
			 *    } );
			 */
			"asSorting": [ 'asc', 'desc' ],
		
		
			/**
			 * Enable or disable filtering on the data in this column.
			 *  @type boolean
			 *  @default true
			 *
			 *  @name DataTable.defaults.column.searchable
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "searchable": false, "targets": [ 0 ] }
			 *        ] } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "searchable": false },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ] } );
			 *    } );
			 */
			"bSearchable": true,
		
		
			/**
			 * Enable or disable ordering on this column.
			 *  @type boolean
			 *  @default true
			 *
			 *  @name DataTable.defaults.column.orderable
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "orderable": false, "targets": [ 0 ] }
			 *        ] } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "orderable": false },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ] } );
			 *    } );
			 */
			"bSortable": true,
		
		
			/**
			 * Enable or disable the display of this column.
			 *  @type boolean
			 *  @default true
			 *
			 *  @name DataTable.defaults.column.visible
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "visible": false, "targets": [ 0 ] }
			 *        ] } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "visible": false },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ] } );
			 *    } );
			 */
			"bVisible": true,
		
		
			/**
			 * Developer definable function that is called whenever a cell is created (Ajax source,
			 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
			 * allowing you to modify the DOM element (add background colour for example) when the
			 * element is available.
			 *  @type function
			 *  @param {element} td The TD node that has been created
			 *  @param {*} cellData The Data for the cell
			 *  @param {array|object} rowData The data for the whole row
			 *  @param {int} row The row index for the aoData data store
			 *  @param {int} col The column index for aoColumns
			 *
			 *  @name DataTable.defaults.column.createdCell
			 *  @dtopt Columns
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [3],
			 *          "createdCell": function (td, cellData, rowData, row, col) {
			 *            if ( cellData == "1.7" ) {
			 *              $(td).css('color', 'blue')
			 *            }
			 *          }
			 *        } ]
			 *      });
			 *    } );
			 */
			"fnCreatedCell": null,
		
		
			/**
			 * This parameter has been replaced by `data` in DataTables to ensure naming
			 * consistency. `dataProp` can still be used, as there is backwards
			 * compatibility in DataTables for this option, but it is strongly
			 * recommended that you use `data` in preference to `dataProp`.
			 *  @name DataTable.defaults.column.dataProp
			 */
		
		
			/**
			 * This property can be used to read data from any data source property,
			 * including deeply nested objects / properties. `data` can be given in a
			 * number of different ways which effect its behaviour:
			 *
			 * * `integer` - treated as an array index for the data source. This is the
			 *   default that DataTables uses (incrementally increased for each column).
			 * * `string` - read an object property from the data source. There are
			 *   three 'special' options that can be used in the string to alter how
			 *   DataTables reads the data from the source object:
			 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
			 *      Javascript to read from nested objects, so to can the options
			 *      specified in `data`. For example: `browser.version` or
			 *      `browser.name`. If your object parameter name contains a period, use
			 *      `\\` to escape it - i.e. `first\\.name`.
			 *    * `[]` - Array notation. DataTables can automatically combine data
			 *      from and array source, joining the data with the characters provided
			 *      between the two brackets. For example: `name[, ]` would provide a
			 *      comma-space separated list from the source array. If no characters
			 *      are provided between the brackets, the original array source is
			 *      returned.
			 *    * `()` - Function notation. Adding `()` to the end of a parameter will
			 *      execute a function of the name given. For example: `browser()` for a
			 *      simple function on the data source, `browser.version()` for a
			 *      function in a nested property or even `browser().version` to get an
			 *      object property if the function called returns an object. Note that
			 *      function notation is recommended for use in `render` rather than
			 *      `data` as it is much simpler to use as a renderer.
			 * * `null` - use the original data source for the row rather than plucking
			 *   data directly from it. This action has effects on two other
			 *   initialisation options:
			 *    * `defaultContent` - When null is given as the `data` option and
			 *      `defaultContent` is specified for the column, the value defined by
			 *      `defaultContent` will be used for the cell.
			 *    * `render` - When null is used for the `data` option and the `render`
			 *      option is specified for the column, the whole data source for the
			 *      row is used for the renderer.
			 * * `function` - the function given will be executed whenever DataTables
			 *   needs to set or get the data for a cell in the column. The function
			 *   takes three parameters:
			 *    * Parameters:
			 *      * `{array|object}` The data source for the row
			 *      * `{string}` The type call data requested - this will be 'set' when
			 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
			 *        when gathering data. Note that when `undefined` is given for the
			 *        type DataTables expects to get the raw data for the object back<
			 *      * `{*}` Data to set when the second parameter is 'set'.
			 *    * Return:
			 *      * The return value from the function is not required when 'set' is
			 *        the type of call, but otherwise the return is what will be used
			 *        for the data requested.
			 *
			 * Note that `data` is a getter and setter option. If you just require
			 * formatting of data for output, you will likely want to use `render` which
			 * is simply a getter and thus simpler to use.
			 *
			 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
			 * name change reflects the flexibility of this property and is consistent
			 * with the naming of mRender. If 'mDataProp' is given, then it will still
			 * be used by DataTables, as it automatically maps the old name to the new
			 * if required.
			 *
			 *  @type string|int|function|null
			 *  @default null <i>Use automatically calculated column index</i>
			 *
			 *  @name DataTable.defaults.column.data
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Read table data from objects
			 *    // JSON structure for each row:
			 *    //   {
			 *    //      "engine": {value},
			 *    //      "browser": {value},
			 *    //      "platform": {value},
			 *    //      "version": {value},
			 *    //      "grade": {value}
			 *    //   }
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "ajaxSource": "sources/objects.txt",
			 *        "columns": [
			 *          { "data": "engine" },
			 *          { "data": "browser" },
			 *          { "data": "platform" },
			 *          { "data": "version" },
			 *          { "data": "grade" }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Read information from deeply nested objects
			 *    // JSON structure for each row:
			 *    //   {
			 *    //      "engine": {value},
			 *    //      "browser": {value},
			 *    //      "platform": {
			 *    //         "inner": {value}
			 *    //      },
			 *    //      "details": [
			 *    //         {value}, {value}
			 *    //      ]
			 *    //   }
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "ajaxSource": "sources/deep.txt",
			 *        "columns": [
			 *          { "data": "engine" },
			 *          { "data": "browser" },
			 *          { "data": "platform.inner" },
			 *          { "data": "platform.details.0" },
			 *          { "data": "platform.details.1" }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `data` as a function to provide different information for
			 *    // sorting, filtering and display. In this case, currency (price)
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "data": function ( source, type, val ) {
			 *            if (type === 'set') {
			 *              source.price = val;
			 *              // Store the computed dislay and filter values for efficiency
			 *              source.price_display = val=="" ? "" : "$"+numberFormat(val);
			 *              source.price_filter  = val=="" ? "" : "$"+numberFormat(val)+" "+val;
			 *              return;
			 *            }
			 *            else if (type === 'display') {
			 *              return source.price_display;
			 *            }
			 *            else if (type === 'filter') {
			 *              return source.price_filter;
			 *            }
			 *            // 'sort', 'type' and undefined all just use the integer
			 *            return source.price;
			 *          }
			 *        } ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using default content
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "data": null,
			 *          "defaultContent": "Click to edit"
			 *        } ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using array notation - outputting a list from an array
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "data": "name[, ]"
			 *        } ]
			 *      } );
			 *    } );
			 *
			 */
			"mData": null,
		
		
			/**
			 * This property is the rendering partner to `data` and it is suggested that
			 * when you want to manipulate data for display (including filtering,
			 * sorting etc) without altering the underlying data for the table, use this
			 * property. `render` can be considered to be the the read only companion to
			 * `data` which is read / write (then as such more complex). Like `data`
			 * this option can be given in a number of different ways to effect its
			 * behaviour:
			 *
			 * * `integer` - treated as an array index for the data source. This is the
			 *   default that DataTables uses (incrementally increased for each column).
			 * * `string` - read an object property from the data source. There are
			 *   three 'special' options that can be used in the string to alter how
			 *   DataTables reads the data from the source object:
			 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
			 *      Javascript to read from nested objects, so to can the options
			 *      specified in `data`. For example: `browser.version` or
			 *      `browser.name`. If your object parameter name contains a period, use
			 *      `\\` to escape it - i.e. `first\\.name`.
			 *    * `[]` - Array notation. DataTables can automatically combine data
			 *      from and array source, joining the data with the characters provided
			 *      between the two brackets. For example: `name[, ]` would provide a
			 *      comma-space separated list from the source array. If no characters
			 *      are provided between the brackets, the original array source is
			 *      returned.
			 *    * `()` - Function notation. Adding `()` to the end of a parameter will
			 *      execute a function of the name given. For example: `browser()` for a
			 *      simple function on the data source, `browser.version()` for a
			 *      function in a nested property or even `browser().version` to get an
			 *      object property if the function called returns an object.
			 * * `object` - use different data for the different data types requested by
			 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
			 *   of the object is the data type the property refers to and the value can
			 *   defined using an integer, string or function using the same rules as
			 *   `render` normally does. Note that an `_` option _must_ be specified.
			 *   This is the default value to use if you haven't specified a value for
			 *   the data type requested by DataTables.
			 * * `function` - the function given will be executed whenever DataTables
			 *   needs to set or get the data for a cell in the column. The function
			 *   takes three parameters:
			 *    * Parameters:
			 *      * {array|object} The data source for the row (based on `data`)
			 *      * {string} The type call data requested - this will be 'filter',
			 *        'display', 'type' or 'sort'.
			 *      * {array|object} The full data source for the row (not based on
			 *        `data`)
			 *    * Return:
			 *      * The return value from the function is what will be used for the
			 *        data requested.
			 *
			 *  @type string|int|function|object|null
			 *  @default null Use the data source value.
			 *
			 *  @name DataTable.defaults.column.render
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Create a comma separated list from an array of objects
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "ajaxSource": "sources/deep.txt",
			 *        "columns": [
			 *          { "data": "engine" },
			 *          { "data": "browser" },
			 *          {
			 *            "data": "platform",
			 *            "render": "[, ].name"
			 *          }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Execute a function to obtain data
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "data": null, // Use the full data source object for the renderer's source
			 *          "render": "browserName()"
			 *        } ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // As an object, extracting different data for the different types
			 *    // This would be used with a data source such as:
			 *    //   { "phone": 5552368, "phone_filter": "5552368 555-2368", "phone_display": "555-2368" }
			 *    // Here the `phone` integer is used for sorting and type detection, while `phone_filter`
			 *    // (which has both forms) is used for filtering for if a user inputs either format, while
			 *    // the formatted phone number is the one that is shown in the table.
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "data": null, // Use the full data source object for the renderer's source
			 *          "render": {
			 *            "_": "phone",
			 *            "filter": "phone_filter",
			 *            "display": "phone_display"
			 *          }
			 *        } ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Use as a function to create a link from the data source
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "data": "download_link",
			 *          "render": function ( data, type, full ) {
			 *            return '<a href="'+data+'">Download</a>';
			 *          }
			 *        } ]
			 *      } );
			 *    } );
			 */
			"mRender": null,
		
		
			/**
			 * Change the cell type created for the column - either TD cells or TH cells. This
			 * can be useful as TH cells have semantic meaning in the table body, allowing them
			 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
			 *  @type string
			 *  @default td
			 *
			 *  @name DataTable.defaults.column.cellType
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Make the first column use TH cells
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "cellType": "th"
			 *        } ]
			 *      } );
			 *    } );
			 */
			"sCellType": "td",
		
		
			/**
			 * Class to give to each cell in this column.
			 *  @type string
			 *  @default <i>Empty string</i>
			 *
			 *  @name DataTable.defaults.column.class
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "class": "my_class", "targets": [ 0 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "class": "my_class" },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ]
			 *      } );
			 *    } );
			 */
			"sClass": "",
		
			/**
			 * When DataTables calculates the column widths to assign to each column,
			 * it finds the longest string in each column and then constructs a
			 * temporary table and reads the widths from that. The problem with this
			 * is that "mmm" is much wider then "iiii", but the latter is a longer
			 * string - thus the calculation can go wrong (doing it properly and putting
			 * it into an DOM object and measuring that is horribly(!) slow). Thus as
			 * a "work around" we provide this option. It will append its value to the
			 * text that is found to be the longest string for the column - i.e. padding.
			 * Generally you shouldn't need this!
			 *  @type string
			 *  @default <i>Empty string<i>
			 *
			 *  @name DataTable.defaults.column.contentPadding
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          null,
			 *          null,
			 *          null,
			 *          {
			 *            "contentPadding": "mmm"
			 *          }
			 *        ]
			 *      } );
			 *    } );
			 */
			"sContentPadding": "",
		
		
			/**
			 * Allows a default value to be given for a column's data, and will be used
			 * whenever a null data source is encountered (this can be because `data`
			 * is set to null, or because the data source itself is null).
			 *  @type string
			 *  @default null
			 *
			 *  @name DataTable.defaults.column.defaultContent
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          {
			 *            "data": null,
			 *            "defaultContent": "Edit",
			 *            "targets": [ -1 ]
			 *          }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          null,
			 *          null,
			 *          null,
			 *          {
			 *            "data": null,
			 *            "defaultContent": "Edit"
			 *          }
			 *        ]
			 *      } );
			 *    } );
			 */
			"sDefaultContent": null,
		
		
			/**
			 * This parameter is only used in DataTables' server-side processing. It can
			 * be exceptionally useful to know what columns are being displayed on the
			 * client side, and to map these to database fields. When defined, the names
			 * also allow DataTables to reorder information from the server if it comes
			 * back in an unexpected order (i.e. if you switch your columns around on the
			 * client-side, your server-side code does not also need updating).
			 *  @type string
			 *  @default <i>Empty string</i>
			 *
			 *  @name DataTable.defaults.column.name
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "name": "engine", "targets": [ 0 ] },
			 *          { "name": "browser", "targets": [ 1 ] },
			 *          { "name": "platform", "targets": [ 2 ] },
			 *          { "name": "version", "targets": [ 3 ] },
			 *          { "name": "grade", "targets": [ 4 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "name": "engine" },
			 *          { "name": "browser" },
			 *          { "name": "platform" },
			 *          { "name": "version" },
			 *          { "name": "grade" }
			 *        ]
			 *      } );
			 *    } );
			 */
			"sName": "",
		
		
			/**
			 * Defines a data source type for the ordering which can be used to read
			 * real-time information from the table (updating the internally cached
			 * version) prior to ordering. This allows ordering to occur on user
			 * editable elements such as form inputs.
			 *  @type string
			 *  @default std
			 *
			 *  @name DataTable.defaults.column.orderDataType
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "orderDataType": "dom-text", "targets": [ 2, 3 ] },
			 *          { "type": "numeric", "targets": [ 3 ] },
			 *          { "orderDataType": "dom-select", "targets": [ 4 ] },
			 *          { "orderDataType": "dom-checkbox", "targets": [ 5 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          null,
			 *          null,
			 *          { "orderDataType": "dom-text" },
			 *          { "orderDataType": "dom-text", "type": "numeric" },
			 *          { "orderDataType": "dom-select" },
			 *          { "orderDataType": "dom-checkbox" }
			 *        ]
			 *      } );
			 *    } );
			 */
			"sSortDataType": "std",
		
		
			/**
			 * The title of this column.
			 *  @type string
			 *  @default null <i>Derived from the 'TH' value for this column in the
			 *    original HTML table.</i>
			 *
			 *  @name DataTable.defaults.column.title
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "title": "My column title", "targets": [ 0 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "title": "My column title" },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ]
			 *      } );
			 *    } );
			 */
			"sTitle": null,
		
		
			/**
			 * The type allows you to specify how the data for this column will be
			 * ordered. Four types (string, numeric, date and html (which will strip
			 * HTML tags before ordering)) are currently available. Note that only date
			 * formats understood by Javascript's Date() object will be accepted as type
			 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
			 * 'numeric', 'date' or 'html' (by default). Further types can be adding
			 * through plug-ins.
			 *  @type string
			 *  @default null <i>Auto-detected from raw data</i>
			 *
			 *  @name DataTable.defaults.column.type
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "type": "html", "targets": [ 0 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "type": "html" },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ]
			 *      } );
			 *    } );
			 */
			"sType": null,
		
		
			/**
			 * Defining the width of the column, this parameter may take any CSS value
			 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
			 * been given a specific width through this interface ensuring that the table
			 * remains readable.
			 *  @type string
			 *  @default null <i>Automatic</i>
			 *
			 *  @name DataTable.defaults.column.width
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "width": "20%", "targets": [ 0 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "width": "20%" },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ]
			 *      } );
			 *    } );
			 */
			"sWidth": null
		};
		
		_fnHungarianMap( DataTable.defaults.column );
		
		
		
		/**
		 * DataTables settings object - this holds all the information needed for a
		 * given table, including configuration, data and current application of the
		 * table options. DataTables does not have a single instance for each DataTable
		 * with the settings attached to that instance, but rather instances of the
		 * DataTable "class" are created on-the-fly as needed (typically by a
		 * $().dataTable() call) and the settings object is then applied to that
		 * instance.
		 *
		 * Note that this object is related to {@link DataTable.defaults} but this
		 * one is the internal data store for DataTables's cache of columns. It should
		 * NOT be manipulated outside of DataTables. Any configuration should be done
		 * through the initialisation options.
		 *  @namespace
		 *  @todo Really should attach the settings object to individual instances so we
		 *    don't need to create new instances on each $().dataTable() call (if the
		 *    table already exists). It would also save passing oSettings around and
		 *    into every single function. However, this is a very significant
		 *    architecture change for DataTables and will almost certainly break
		 *    backwards compatibility with older installations. This is something that
		 *    will be done in 2.0.
		 */
		DataTable.models.oSettings = {
			/**
			 * Primary features of DataTables and their enablement state.
			 *  @namespace
			 */
			"oFeatures": {
		
				/**
				 * Flag to say if DataTables should automatically try to calculate the
				 * optimum table and columns widths (true) or not (false).
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bAutoWidth": null,
		
				/**
				 * Delay the creation of TR and TD elements until they are actually
				 * needed by a driven page draw. This can give a significant speed
				 * increase for Ajax source and Javascript source data, but makes no
				 * difference at all fro DOM and server-side processing tables.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bDeferRender": null,
		
				/**
				 * Enable filtering on the table or not. Note that if this is disabled
				 * then there is no filtering at all on the table, including fnFilter.
				 * To just remove the filtering input use sDom and remove the 'f' option.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bFilter": null,
		
				/**
				 * Table information element (the 'Showing x of y records' div) enable
				 * flag.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bInfo": null,
		
				/**
				 * Present a user control allowing the end user to change the page size
				 * when pagination is enabled.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bLengthChange": null,
		
				/**
				 * Pagination enabled or not. Note that if this is disabled then length
				 * changing must also be disabled.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bPaginate": null,
		
				/**
				 * Processing indicator enable flag whenever DataTables is enacting a
				 * user request - typically an Ajax request for server-side processing.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bProcessing": null,
		
				/**
				 * Server-side processing enabled flag - when enabled DataTables will
				 * get all data from the server for every draw - there is no filtering,
				 * sorting or paging done on the client-side.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bServerSide": null,
		
				/**
				 * Sorting enablement flag.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bSort": null,
		
				/**
				 * Multi-column sorting
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bSortMulti": null,
		
				/**
				 * Apply a class to the columns which are being sorted to provide a
				 * visual highlight or not. This can slow things down when enabled since
				 * there is a lot of DOM interaction.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bSortClasses": null,
		
				/**
				 * State saving enablement flag.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bStateSave": null
			},
		
		
			/**
			 * Scrolling settings for a table.
			 *  @namespace
			 */
			"oScroll": {
				/**
				 * When the table is shorter in height than sScrollY, collapse the
				 * table container down to the height of the table (when true).
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bCollapse": null,
		
				/**
				 * Width of the scrollbar for the web-browser's platform. Calculated
				 * during table initialisation.
				 *  @type int
				 *  @default 0
				 */
				"iBarWidth": 0,
		
				/**
				 * Viewport width for horizontal scrolling. Horizontal scrolling is
				 * disabled if an empty string.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type string
				 */
				"sX": null,
		
				/**
				 * Width to expand the table to when using x-scrolling. Typically you
				 * should not need to use this.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type string
				 *  @deprecated
				 */
				"sXInner": null,
		
				/**
				 * Viewport height for vertical scrolling. Vertical scrolling is disabled
				 * if an empty string.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type string
				 */
				"sY": null
			},
		
			/**
			 * Language information for the table.
			 *  @namespace
			 *  @extends DataTable.defaults.oLanguage
			 */
			"oLanguage": {
				/**
				 * Information callback function. See
				 * {@link DataTable.defaults.fnInfoCallback}
				 *  @type function
				 *  @default null
				 */
				"fnInfoCallback": null
			},
		
			/**
			 * Browser support parameters
			 *  @namespace
			 */
			"oBrowser": {
				/**
				 * Indicate if the browser incorrectly calculates width:100% inside a
				 * scrolling element (IE6/7)
				 *  @type boolean
				 *  @default false
				 */
				"bScrollOversize": false,
		
				/**
				 * Determine if the vertical scrollbar is on the right or left of the
				 * scrolling container - needed for rtl language layout, although not
				 * all browsers move the scrollbar (Safari).
				 *  @type boolean
				 *  @default false
				 */
				"bScrollbarLeft": false,
		
				/**
				 * Flag for if `getBoundingClientRect` is fully supported or not
				 *  @type boolean
				 *  @default false
				 */
				"bBounding": false,
		
				/**
				 * Browser scrollbar width
				 *  @type integer
				 *  @default 0
				 */
				"barWidth": 0
			},
		
		
			"ajax": null,
		
		
			/**
			 * Array referencing the nodes which are used for the features. The
			 * parameters of this object match what is allowed by sDom - i.e.
			 *   <ul>
			 *     <li>'l' - Length changing</li>
			 *     <li>'f' - Filtering input</li>
			 *     <li>'t' - The table!</li>
			 *     <li>'i' - Information</li>
			 *     <li>'p' - Pagination</li>
			 *     <li>'r' - pRocessing</li>
			 *   </ul>
			 *  @type array
			 *  @default []
			 */
			"aanFeatures": [],
		
			/**
			 * Store data information - see {@link DataTable.models.oRow} for detailed
			 * information.
			 *  @type array
			 *  @default []
			 */
			"aoData": [],
		
			/**
			 * Array of indexes which are in the current display (after filtering etc)
			 *  @type array
			 *  @default []
			 */
			"aiDisplay": [],
		
			/**
			 * Array of indexes for display - no filtering
			 *  @type array
			 *  @default []
			 */
			"aiDisplayMaster": [],
		
			/**
			 * Map of row ids to data indexes
			 *  @type object
			 *  @default {}
			 */
			"aIds": {},
		
			/**
			 * Store information about each column that is in use
			 *  @type array
			 *  @default []
			 */
			"aoColumns": [],
		
			/**
			 * Store information about the table's header
			 *  @type array
			 *  @default []
			 */
			"aoHeader": [],
		
			/**
			 * Store information about the table's footer
			 *  @type array
			 *  @default []
			 */
			"aoFooter": [],
		
			/**
			 * Store the applied global search information in case we want to force a
			 * research or compare the old search to a new one.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @namespace
			 *  @extends DataTable.models.oSearch
			 */
			"oPreviousSearch": {},
		
			/**
			 * Store the applied search for each column - see
			 * {@link DataTable.models.oSearch} for the format that is used for the
			 * filtering information for each column.
			 *  @type array
			 *  @default []
			 */
			"aoPreSearchCols": [],
		
			/**
			 * Sorting that is applied to the table. Note that the inner arrays are
			 * used in the following manner:
			 * <ul>
			 *   <li>Index 0 - column number</li>
			 *   <li>Index 1 - current sorting direction</li>
			 * </ul>
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type array
			 *  @todo These inner arrays should really be objects
			 */
			"aaSorting": null,
		
			/**
			 * Sorting that is always applied to the table (i.e. prefixed in front of
			 * aaSorting).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type array
			 *  @default []
			 */
			"aaSortingFixed": [],
		
			/**
			 * Classes to use for the striping of a table.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type array
			 *  @default []
			 */
			"asStripeClasses": null,
		
			/**
			 * If restoring a table - we should restore its striping classes as well
			 *  @type array
			 *  @default []
			 */
			"asDestroyStripes": [],
		
			/**
			 * If restoring a table - we should restore its width
			 *  @type int
			 *  @default 0
			 */
			"sDestroyWidth": 0,
		
			/**
			 * Callback functions array for every time a row is inserted (i.e. on a draw).
			 *  @type array
			 *  @default []
			 */
			"aoRowCallback": [],
		
			/**
			 * Callback functions for the header on each draw.
			 *  @type array
			 *  @default []
			 */
			"aoHeaderCallback": [],
		
			/**
			 * Callback function for the footer on each draw.
			 *  @type array
			 *  @default []
			 */
			"aoFooterCallback": [],
		
			/**
			 * Array of callback functions for draw callback functions
			 *  @type array
			 *  @default []
			 */
			"aoDrawCallback": [],
		
			/**
			 * Array of callback functions for row created function
			 *  @type array
			 *  @default []
			 */
			"aoRowCreatedCallback": [],
		
			/**
			 * Callback functions for just before the table is redrawn. A return of
			 * false will be used to cancel the draw.
			 *  @type array
			 *  @default []
			 */
			"aoPreDrawCallback": [],
		
			/**
			 * Callback functions for when the table has been initialised.
			 *  @type array
			 *  @default []
			 */
			"aoInitComplete": [],
		
		
			/**
			 * Callbacks for modifying the settings to be stored for state saving, prior to
			 * saving state.
			 *  @type array
			 *  @default []
			 */
			"aoStateSaveParams": [],
		
			/**
			 * Callbacks for modifying the settings that have been stored for state saving
			 * prior to using the stored values to restore the state.
			 *  @type array
			 *  @default []
			 */
			"aoStateLoadParams": [],
		
			/**
			 * Callbacks for operating on the settings object once the saved state has been
			 * loaded
			 *  @type array
			 *  @default []
			 */
			"aoStateLoaded": [],
		
			/**
			 * Cache the table ID for quick access
			 *  @type string
			 *  @default <i>Empty string</i>
			 */
			"sTableId": "",
		
			/**
			 * The TABLE node for the main table
			 *  @type node
			 *  @default null
			 */
			"nTable": null,
		
			/**
			 * Permanent ref to the thead element
			 *  @type node
			 *  @default null
			 */
			"nTHead": null,
		
			/**
			 * Permanent ref to the tfoot element - if it exists
			 *  @type node
			 *  @default null
			 */
			"nTFoot": null,
		
			/**
			 * Permanent ref to the tbody element
			 *  @type node
			 *  @default null
			 */
			"nTBody": null,
		
			/**
			 * Cache the wrapper node (contains all DataTables controlled elements)
			 *  @type node
			 *  @default null
			 */
			"nTableWrapper": null,
		
			/**
			 * Indicate if when using server-side processing the loading of data
			 * should be deferred until the second draw.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 *  @default false
			 */
			"bDeferLoading": false,
		
			/**
			 * Indicate if all required information has been read in
			 *  @type boolean
			 *  @default false
			 */
			"bInitialised": false,
		
			/**
			 * Information about open rows. Each object in the array has the parameters
			 * 'nTr' and 'nParent'
			 *  @type array
			 *  @default []
			 */
			"aoOpenRows": [],
		
			/**
			 * Dictate the positioning of DataTables' control elements - see
			 * {@link DataTable.model.oInit.sDom}.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 *  @default null
			 */
			"sDom": null,
		
			/**
			 * Search delay (in mS)
			 *  @type integer
			 *  @default null
			 */
			"searchDelay": null,
		
			/**
			 * Which type of pagination should be used.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 *  @default two_button
			 */
			"sPaginationType": "two_button",
		
			/**
			 * The state duration (for `stateSave`) in seconds.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type int
			 *  @default 0
			 */
			"iStateDuration": 0,
		
			/**
			 * Array of callback functions for state saving. Each array element is an
			 * object with the following parameters:
			 *   <ul>
			 *     <li>function:fn - function to call. Takes two parameters, oSettings
			 *       and the JSON string to save that has been thus far created. Returns
			 *       a JSON string to be inserted into a json object
			 *       (i.e. '"param": [ 0, 1, 2]')</li>
			 *     <li>string:sName - name of callback</li>
			 *   </ul>
			 *  @type array
			 *  @default []
			 */
			"aoStateSave": [],
		
			/**
			 * Array of callback functions for state loading. Each array element is an
			 * object with the following parameters:
			 *   <ul>
			 *     <li>function:fn - function to call. Takes two parameters, oSettings
			 *       and the object stored. May return false to cancel state loading</li>
			 *     <li>string:sName - name of callback</li>
			 *   </ul>
			 *  @type array
			 *  @default []
			 */
			"aoStateLoad": [],
		
			/**
			 * State that was saved. Useful for back reference
			 *  @type object
			 *  @default null
			 */
			"oSavedState": null,
		
			/**
			 * State that was loaded. Useful for back reference
			 *  @type object
			 *  @default null
			 */
			"oLoadedState": null,
		
			/**
			 * Source url for AJAX data for the table.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 *  @default null
			 */
			"sAjaxSource": null,
		
			/**
			 * Property from a given object from which to read the table data from. This
			 * can be an empty string (when not server-side processing), in which case
			 * it is  assumed an an array is given directly.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */
			"sAjaxDataProp": null,
		
			/**
			 * Note if draw should be blocked while getting data
			 *  @type boolean
			 *  @default true
			 */
			"bAjaxDataGet": true,
		
			/**
			 * The last jQuery XHR object that was used for server-side data gathering.
			 * This can be used for working with the XHR information in one of the
			 * callbacks
			 *  @type object
			 *  @default null
			 */
			"jqXHR": null,
		
			/**
			 * JSON returned from the server in the last Ajax request
			 *  @type object
			 *  @default undefined
			 */
			"json": undefined,
		
			/**
			 * Data submitted as part of the last Ajax request
			 *  @type object
			 *  @default undefined
			 */
			"oAjaxData": undefined,
		
			/**
			 * Function to get the server-side data.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type function
			 */
			"fnServerData": null,
		
			/**
			 * Functions which are called prior to sending an Ajax request so extra
			 * parameters can easily be sent to the server
			 *  @type array
			 *  @default []
			 */
			"aoServerParams": [],
		
			/**
			 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
			 * required).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */
			"sServerMethod": null,
		
			/**
			 * Format numbers for display.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type function
			 */
			"fnFormatNumber": null,
		
			/**
			 * List of options that can be used for the user selectable length menu.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type array
			 *  @default []
			 */
			"aLengthMenu": null,
		
			/**
			 * Counter for the draws that the table does. Also used as a tracker for
			 * server-side processing
			 *  @type int
			 *  @default 0
			 */
			"iDraw": 0,
		
			/**
			 * Indicate if a redraw is being done - useful for Ajax
			 *  @type boolean
			 *  @default false
			 */
			"bDrawing": false,
		
			/**
			 * Draw index (iDraw) of the last error when parsing the returned data
			 *  @type int
			 *  @default -1
			 */
			"iDrawError": -1,
		
			/**
			 * Paging display length
			 *  @type int
			 *  @default 10
			 */
			"_iDisplayLength": 10,
		
			/**
			 * Paging start point - aiDisplay index
			 *  @type int
			 *  @default 0
			 */
			"_iDisplayStart": 0,
		
			/**
			 * Server-side processing - number of records in the result set
			 * (i.e. before filtering), Use fnRecordsTotal rather than
			 * this property to get the value of the number of records, regardless of
			 * the server-side processing setting.
			 *  @type int
			 *  @default 0
			 *  @private
			 */
			"_iRecordsTotal": 0,
		
			/**
			 * Server-side processing - number of records in the current display set
			 * (i.e. after filtering). Use fnRecordsDisplay rather than
			 * this property to get the value of the number of records, regardless of
			 * the server-side processing setting.
			 *  @type boolean
			 *  @default 0
			 *  @private
			 */
			"_iRecordsDisplay": 0,
		
			/**
			 * The classes to use for the table
			 *  @type object
			 *  @default {}
			 */
			"oClasses": {},
		
			/**
			 * Flag attached to the settings object so you can check in the draw
			 * callback if filtering has been done in the draw. Deprecated in favour of
			 * events.
			 *  @type boolean
			 *  @default false
			 *  @deprecated
			 */
			"bFiltered": false,
		
			/**
			 * Flag attached to the settings object so you can check in the draw
			 * callback if sorting has been done in the draw. Deprecated in favour of
			 * events.
			 *  @type boolean
			 *  @default false
			 *  @deprecated
			 */
			"bSorted": false,
		
			/**
			 * Indicate that if multiple rows are in the header and there is more than
			 * one unique cell per column, if the top one (true) or bottom one (false)
			 * should be used for sorting / title by DataTables.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bSortCellsTop": null,
		
			/**
			 * Initialisation object that is used for the table
			 *  @type object
			 *  @default null
			 */
			"oInit": null,
		
			/**
			 * Destroy callback functions - for plug-ins to attach themselves to the
			 * destroy so they can clean up markup and events.
			 *  @type array
			 *  @default []
			 */
			"aoDestroyCallback": [],
		
		
			/**
			 * Get the number of records in the current record set, before filtering
			 *  @type function
			 */
			"fnRecordsTotal": function ()
			{
				return _fnDataSource( this ) == 'ssp' ?
					this._iRecordsTotal * 1 :
					this.aiDisplayMaster.length;
			},
		
			/**
			 * Get the number of records in the current record set, after filtering
			 *  @type function
			 */
			"fnRecordsDisplay": function ()
			{
				return _fnDataSource( this ) == 'ssp' ?
					this._iRecordsDisplay * 1 :
					this.aiDisplay.length;
			},
		
			/**
			 * Get the display end point - aiDisplay index
			 *  @type function
			 */
			"fnDisplayEnd": function ()
			{
				var
					len      = this._iDisplayLength,
					start    = this._iDisplayStart,
					calc     = start + len,
					records  = this.aiDisplay.length,
					features = this.oFeatures,
					paginate = features.bPaginate;
		
				if ( features.bServerSide ) {
					return paginate === false || len === -1 ?
						start + records :
						Math.min( start+len, this._iRecordsDisplay );
				}
				else {
					return ! paginate || calc>records || len===-1 ?
						records :
						calc;
				}
			},
		
			/**
			 * The DataTables object for this table
			 *  @type object
			 *  @default null
			 */
			"oInstance": null,
		
			/**
			 * Unique identifier for each instance of the DataTables object. If there
			 * is an ID on the table node, then it takes that value, otherwise an
			 * incrementing internal counter is used.
			 *  @type string
			 *  @default null
			 */
			"sInstance": null,
		
			/**
			 * tabindex attribute value that is added to DataTables control elements, allowing
			 * keyboard navigation of the table and its controls.
			 */
			"iTabIndex": 0,
		
			/**
			 * DIV container for the footer scrolling table if scrolling
			 */
			"nScrollHead": null,
		
			/**
			 * DIV container for the footer scrolling table if scrolling
			 */
			"nScrollFoot": null,
		
			/**
			 * Last applied sort
			 *  @type array
			 *  @default []
			 */
			"aLastSort": [],
		
			/**
			 * Stored plug-in instances
			 *  @type object
			 *  @default {}
			 */
			"oPlugins": {},
		
			/**
			 * Function used to get a row's id from the row's data
			 *  @type function
			 *  @default null
			 */
			"rowIdFn": null,
		
			/**
			 * Data location where to store a row's id
			 *  @type string
			 *  @default null
			 */
			"rowId": null
		};
	
		/**
		 * Extension object for DataTables that is used to provide all extension
		 * options.
		 *
		 * Note that the `DataTable.ext` object is available through
		 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
		 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
		 *  @namespace
		 *  @extends DataTable.models.ext
		 */
		
		
		/**
		 * DataTables extensions
		 * 
		 * This namespace acts as a collection area for plug-ins that can be used to
		 * extend DataTables capabilities. Indeed many of the build in methods
		 * use this method to provide their own capabilities (sorting methods for
		 * example).
		 *
		 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
		 * reasons
		 *
		 *  @namespace
		 */
		DataTable.ext = _ext = {
			/**
			 * Buttons. For use with the Buttons extension for DataTables. This is
			 * defined here so other extensions can define buttons regardless of load
			 * order. It is _not_ used by DataTables core.
			 *
			 *  @type object
			 *  @default {}
			 */
			buttons: {},
		
		
			/**
			 * Element class names
			 *
			 *  @type object
			 *  @default {}
			 */
			classes: {},
		
		
			/**
			 * DataTables build type (expanded by the download builder)
			 *
			 *  @type string
			 */
			builder: "-source-",
		
		
			/**
			 * Error reporting.
			 * 
			 * How should DataTables report an error. Can take the value 'alert',
			 * 'throw', 'none' or a function.
			 *
			 *  @type string|function
			 *  @default alert
			 */
			errMode: "alert",
		
		
			/**
			 * Feature plug-ins.
			 * 
			 * This is an array of objects which describe the feature plug-ins that are
			 * available to DataTables. These feature plug-ins are then available for
			 * use through the `dom` initialisation option.
			 * 
			 * Each feature plug-in is described by an object which must have the
			 * following properties:
			 * 
			 * * `fnInit` - function that is used to initialise the plug-in,
			 * * `cFeature` - a character so the feature can be enabled by the `dom`
			 *   instillation option. This is case sensitive.
			 *
			 * The `fnInit` function has the following input parameters:
			 *
			 * 1. `{object}` DataTables settings object: see
			 *    {@link DataTable.models.oSettings}
			 *
			 * And the following return is expected:
			 * 
			 * * {node|null} The element which contains your feature. Note that the
			 *   return may also be void if your plug-in does not require to inject any
			 *   DOM elements into DataTables control (`dom`) - for example this might
			 *   be useful when developing a plug-in which allows table control via
			 *   keyboard entry
			 *
			 *  @type array
			 *
			 *  @example
			 *    $.fn.dataTable.ext.features.push( {
			 *      "fnInit": function( oSettings ) {
			 *        return new TableTools( { "oDTSettings": oSettings } );
			 *      },
			 *      "cFeature": "T"
			 *    } );
			 */
			feature: [],
		
		
			/**
			 * Row searching.
			 * 
			 * This method of searching is complimentary to the default type based
			 * searching, and a lot more comprehensive as it allows you complete control
			 * over the searching logic. Each element in this array is a function
			 * (parameters described below) that is called for every row in the table,
			 * and your logic decides if it should be included in the searching data set
			 * or not.
			 *
			 * Searching functions have the following input parameters:
			 *
			 * 1. `{object}` DataTables settings object: see
			 *    {@link DataTable.models.oSettings}
			 * 2. `{array|object}` Data for the row to be processed (same as the
			 *    original format that was passed in as the data source, or an array
			 *    from a DOM data source
			 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
			 *    can be useful to retrieve the `TR` element if you need DOM interaction.
			 *
			 * And the following return is expected:
			 *
			 * * {boolean} Include the row in the searched result set (true) or not
			 *   (false)
			 *
			 * Note that as with the main search ability in DataTables, technically this
			 * is "filtering", since it is subtractive. However, for consistency in
			 * naming we call it searching here.
			 *
			 *  @type array
			 *  @default []
			 *
			 *  @example
			 *    // The following example shows custom search being applied to the
			 *    // fourth column (i.e. the data[3] index) based on two input values
			 *    // from the end-user, matching the data in a certain range.
			 *    $.fn.dataTable.ext.search.push(
			 *      function( settings, data, dataIndex ) {
			 *        var min = document.getElementById('min').value * 1;
			 *        var max = document.getElementById('max').value * 1;
			 *        var version = data[3] == "-" ? 0 : data[3]*1;
			 *
			 *        if ( min == "" && max == "" ) {
			 *          return true;
			 *        }
			 *        else if ( min == "" && version < max ) {
			 *          return true;
			 *        }
			 *        else if ( min < version && "" == max ) {
			 *          return true;
			 *        }
			 *        else if ( min < version && version < max ) {
			 *          return true;
			 *        }
			 *        return false;
			 *      }
			 *    );
			 */
			search: [],
		
		
			/**
			 * Selector extensions
			 *
			 * The `selector` option can be used to extend the options available for the
			 * selector modifier options (`selector-modifier` object data type) that
			 * each of the three built in selector types offer (row, column and cell +
			 * their plural counterparts). For example the Select extension uses this
			 * mechanism to provide an option to select only rows, columns and cells
			 * that have been marked as selected by the end user (`{selected: true}`),
			 * which can be used in conjunction with the existing built in selector
			 * options.
			 *
			 * Each property is an array to which functions can be pushed. The functions
			 * take three attributes:
			 *
			 * * Settings object for the host table
			 * * Options object (`selector-modifier` object type)
			 * * Array of selected item indexes
			 *
			 * The return is an array of the resulting item indexes after the custom
			 * selector has been applied.
			 *
			 *  @type object
			 */
			selector: {
				cell: [],
				column: [],
				row: []
			},
		
		
			/**
			 * Internal functions, exposed for used in plug-ins.
			 * 
			 * Please note that you should not need to use the internal methods for
			 * anything other than a plug-in (and even then, try to avoid if possible).
			 * The internal function may change between releases.
			 *
			 *  @type object
			 *  @default {}
			 */
			internal: {},
		
		
			/**
			 * Legacy configuration options. Enable and disable legacy options that
			 * are available in DataTables.
			 *
			 *  @type object
			 */
			legacy: {
				/**
				 * Enable / disable DataTables 1.9 compatible server-side processing
				 * requests
				 *
				 *  @type boolean
				 *  @default null
				 */
				ajax: null
			},
		
		
			/**
			 * Pagination plug-in methods.
			 * 
			 * Each entry in this object is a function and defines which buttons should
			 * be shown by the pagination rendering method that is used for the table:
			 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
			 * buttons are displayed in the document, while the functions here tell it
			 * what buttons to display. This is done by returning an array of button
			 * descriptions (what each button will do).
			 *
			 * Pagination types (the four built in options and any additional plug-in
			 * options defined here) can be used through the `paginationType`
			 * initialisation parameter.
			 *
			 * The functions defined take two parameters:
			 *
			 * 1. `{int} page` The current page index
			 * 2. `{int} pages` The number of pages in the table
			 *
			 * Each function is expected to return an array where each element of the
			 * array can be one of:
			 *
			 * * `first` - Jump to first page when activated
			 * * `last` - Jump to last page when activated
			 * * `previous` - Show previous page when activated
			 * * `next` - Show next page when activated
			 * * `{int}` - Show page of the index given
			 * * `{array}` - A nested array containing the above elements to add a
			 *   containing 'DIV' element (might be useful for styling).
			 *
			 * Note that DataTables v1.9- used this object slightly differently whereby
			 * an object with two functions would be defined for each plug-in. That
			 * ability is still supported by DataTables 1.10+ to provide backwards
			 * compatibility, but this option of use is now decremented and no longer
			 * documented in DataTables 1.10+.
			 *
			 *  @type object
			 *  @default {}
			 *
			 *  @example
			 *    // Show previous, next and current page buttons only
			 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
			 *      return [ 'previous', page, 'next' ];
			 *    };
			 */
			pager: {},
		
		
			renderer: {
				pageButton: {},
				header: {}
			},
		
		
			/**
			 * Ordering plug-ins - custom data source
			 * 
			 * The extension options for ordering of data available here is complimentary
			 * to the default type based ordering that DataTables typically uses. It
			 * allows much greater control over the the data that is being used to
			 * order a column, but is necessarily therefore more complex.
			 * 
			 * This type of ordering is useful if you want to do ordering based on data
			 * live from the DOM (for example the contents of an 'input' element) rather
			 * than just the static string that DataTables knows of.
			 * 
			 * The way these plug-ins work is that you create an array of the values you
			 * wish to be ordering for the column in question and then return that
			 * array. The data in the array much be in the index order of the rows in
			 * the table (not the currently ordering order!). Which order data gathering
			 * function is run here depends on the `dt-init columns.orderDataType`
			 * parameter that is used for the column (if any).
			 *
			 * The functions defined take two parameters:
			 *
			 * 1. `{object}` DataTables settings object: see
			 *    {@link DataTable.models.oSettings}
			 * 2. `{int}` Target column index
			 *
			 * Each function is expected to return an array:
			 *
			 * * `{array}` Data for the column to be ordering upon
			 *
			 *  @type array
			 *
			 *  @example
			 *    // Ordering using `input` node values
			 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
			 *    {
			 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
			 *        return $('input', td).val();
			 *      } );
			 *    }
			 */
			order: {},
		
		
			/**
			 * Type based plug-ins.
			 *
			 * Each column in DataTables has a type assigned to it, either by automatic
			 * detection or by direct assignment using the `type` option for the column.
			 * The type of a column will effect how it is ordering and search (plug-ins
			 * can also make use of the column type if required).
			 *
			 * @namespace
			 */
			type: {
				/**
				 * Type detection functions.
				 *
				 * The functions defined in this object are used to automatically detect
				 * a column's type, making initialisation of DataTables super easy, even
				 * when complex data is in the table.
				 *
				 * The functions defined take two parameters:
				 *
			     *  1. `{*}` Data from the column cell to be analysed
			     *  2. `{settings}` DataTables settings object. This can be used to
			     *     perform context specific type detection - for example detection
			     *     based on language settings such as using a comma for a decimal
			     *     place. Generally speaking the options from the settings will not
			     *     be required
				 *
				 * Each function is expected to return:
				 *
				 * * `{string|null}` Data type detected, or null if unknown (and thus
				 *   pass it on to the other type detection functions.
				 *
				 *  @type array
				 *
				 *  @example
				 *    // Currency type detection plug-in:
				 *    $.fn.dataTable.ext.type.detect.push(
				 *      function ( data, settings ) {
				 *        // Check the numeric part
				 *        if ( ! $.isNumeric( data.substring(1) ) ) {
				 *          return null;
				 *        }
				 *
				 *        // Check prefixed by currency
				 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
				 *          return 'currency';
				 *        }
				 *        return null;
				 *      }
				 *    );
				 */
				detect: [],
		
		
				/**
				 * Type based search formatting.
				 *
				 * The type based searching functions can be used to pre-format the
				 * data to be search on. For example, it can be used to strip HTML
				 * tags or to de-format telephone numbers for numeric only searching.
				 *
				 * Note that is a search is not defined for a column of a given type,
				 * no search formatting will be performed.
				 * 
				 * Pre-processing of searching data plug-ins - When you assign the sType
				 * for a column (or have it automatically detected for you by DataTables
				 * or a type detection plug-in), you will typically be using this for
				 * custom sorting, but it can also be used to provide custom searching
				 * by allowing you to pre-processing the data and returning the data in
				 * the format that should be searched upon. This is done by adding
				 * functions this object with a parameter name which matches the sType
				 * for that target column. This is the corollary of <i>afnSortData</i>
				 * for searching data.
				 *
				 * The functions defined take a single parameter:
				 *
			     *  1. `{*}` Data from the column cell to be prepared for searching
				 *
				 * Each function is expected to return:
				 *
				 * * `{string|null}` Formatted string that will be used for the searching.
				 *
				 *  @type object
				 *  @default {}
				 *
				 *  @example
				 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
				 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
				 *    }
				 */
				search: {},
		
		
				/**
				 * Type based ordering.
				 *
				 * The column type tells DataTables what ordering to apply to the table
				 * when a column is sorted upon. The order for each type that is defined,
				 * is defined by the functions available in this object.
				 *
				 * Each ordering option can be described by three properties added to
				 * this object:
				 *
				 * * `{type}-pre` - Pre-formatting function
				 * * `{type}-asc` - Ascending order function
				 * * `{type}-desc` - Descending order function
				 *
				 * All three can be used together, only `{type}-pre` or only
				 * `{type}-asc` and `{type}-desc` together. It is generally recommended
				 * that only `{type}-pre` is used, as this provides the optimal
				 * implementation in terms of speed, although the others are provided
				 * for compatibility with existing Javascript sort functions.
				 *
				 * `{type}-pre`: Functions defined take a single parameter:
				 *
			     *  1. `{*}` Data from the column cell to be prepared for ordering
				 *
				 * And return:
				 *
				 * * `{*}` Data to be sorted upon
				 *
				 * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
				 * functions, taking two parameters:
				 *
			     *  1. `{*}` Data to compare to the second parameter
			     *  2. `{*}` Data to compare to the first parameter
				 *
				 * And returning:
				 *
				 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
				 *   than the second parameter, ===0 if the two parameters are equal and
				 *   >0 if the first parameter should be sorted height than the second
				 *   parameter.
				 * 
				 *  @type object
				 *  @default {}
				 *
				 *  @example
				 *    // Numeric ordering of formatted numbers with a pre-formatter
				 *    $.extend( $.fn.dataTable.ext.type.order, {
				 *      "string-pre": function(x) {
				 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
				 *        return parseFloat( a );
				 *      }
				 *    } );
				 *
				 *  @example
				 *    // Case-sensitive string ordering, with no pre-formatting method
				 *    $.extend( $.fn.dataTable.ext.order, {
				 *      "string-case-asc": function(x,y) {
				 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
				 *      },
				 *      "string-case-desc": function(x,y) {
				 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
				 *      }
				 *    } );
				 */
				order: {}
			},
		
			/**
			 * Unique DataTables instance counter
			 *
			 * @type int
			 * @private
			 */
			_unique: 0,
		
		
			//
			// Depreciated
			// The following properties are retained for backwards compatiblity only.
			// The should not be used in new projects and will be removed in a future
			// version
			//
		
			/**
			 * Version check function.
			 *  @type function
			 *  @depreciated Since 1.10
			 */
			fnVersionCheck: DataTable.fnVersionCheck,
		
		
			/**
			 * Index for what 'this' index API functions should use
			 *  @type int
			 *  @deprecated Since v1.10
			 */
			iApiIndex: 0,
		
		
			/**
			 * jQuery UI class container
			 *  @type object
			 *  @deprecated Since v1.10
			 */
			oJUIClasses: {},
		
		
			/**
			 * Software version
			 *  @type string
			 *  @deprecated Since v1.10
			 */
			sVersion: DataTable.version
		};
		
		
		//
		// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
		//
		$.extend( _ext, {
			afnFiltering: _ext.search,
			aTypes:       _ext.type.detect,
			ofnSearch:    _ext.type.search,
			oSort:        _ext.type.order,
			afnSortData:  _ext.order,
			aoFeatures:   _ext.feature,
			oApi:         _ext.internal,
			oStdClasses:  _ext.classes,
			oPagination:  _ext.pager
		} );
		
		
		$.extend( DataTable.ext.classes, {
			"sTable": "dataTable",
			"sNoFooter": "no-footer",
		
			/* Paging buttons */
			"sPageButton": "paginate_button",
			"sPageButtonActive": "current",
			"sPageButtonDisabled": "disabled",
		
			/* Striping classes */
			"sStripeOdd": "odd",
			"sStripeEven": "even",
		
			/* Empty row */
			"sRowEmpty": "dataTables_empty",
		
			/* Features */
			"sWrapper": "dataTables_wrapper",
			"sFilter": "dataTables_filter",
			"sInfo": "dataTables_info",
			"sPaging": "dataTables_paginate paging_", /* Note that the type is postfixed */
			"sLength": "dataTables_length",
			"sProcessing": "dataTables_processing",
		
			/* Sorting */
			"sSortAsc": "sorting_asc",
			"sSortDesc": "sorting_desc",
			"sSortable": "sorting", /* Sortable in both directions */
			"sSortableAsc": "sorting_asc_disabled",
			"sSortableDesc": "sorting_desc_disabled",
			"sSortableNone": "sorting_disabled",
			"sSortColumn": "sorting_", /* Note that an int is postfixed for the sorting order */
		
			/* Filtering */
			"sFilterInput": "",
		
			/* Page length */
			"sLengthSelect": "",
		
			/* Scrolling */
			"sScrollWrapper": "dataTables_scroll",
			"sScrollHead": "dataTables_scrollHead",
			"sScrollHeadInner": "dataTables_scrollHeadInner",
			"sScrollBody": "dataTables_scrollBody",
			"sScrollFoot": "dataTables_scrollFoot",
			"sScrollFootInner": "dataTables_scrollFootInner",
		
			/* Misc */
			"sHeaderTH": "",
			"sFooterTH": "",
		
			// Deprecated
			"sSortJUIAsc": "",
			"sSortJUIDesc": "",
			"sSortJUI": "",
			"sSortJUIAscAllowed": "",
			"sSortJUIDescAllowed": "",
			"sSortJUIWrapper": "",
			"sSortIcon": "",
			"sJUIHeader": "",
			"sJUIFooter": ""
		} );
		
		
		var extPagination = DataTable.ext.pager;
		
		function _numbers ( page, pages ) {
			var
				numbers = [],
				buttons = extPagination.numbers_length,
				half = Math.floor( buttons / 2 ),
				i = 1;
		
			if ( pages <= buttons ) {
				numbers = _range( 0, pages );
			}
			else if ( page <= half ) {
				numbers = _range( 0, buttons-2 );
				numbers.push( 'ellipsis' );
				numbers.push( pages-1 );
			}
			else if ( page >= pages - 1 - half ) {
				numbers = _range( pages-(buttons-2), pages );
				numbers.splice( 0, 0, 'ellipsis' ); // no unshift in ie6
				numbers.splice( 0, 0, 0 );
			}
			else {
				numbers = _range( page-half+2, page+half-1 );
				numbers.push( 'ellipsis' );
				numbers.push( pages-1 );
				numbers.splice( 0, 0, 'ellipsis' );
				numbers.splice( 0, 0, 0 );
			}
		
			numbers.DT_el = 'span';
			return numbers;
		}
		
		
		$.extend( extPagination, {
			simple: function ( page, pages ) {
				return [ 'previous', 'next' ];
			},
		
			full: function ( page, pages ) {
				return [  'first', 'previous', 'next', 'last' ];
			},
		
			numbers: function ( page, pages ) {
				return [ _numbers(page, pages) ];
			},
		
			simple_numbers: function ( page, pages ) {
				return [ 'previous', _numbers(page, pages), 'next' ];
			},
		
			full_numbers: function ( page, pages ) {
				return [ 'first', 'previous', _numbers(page, pages), 'next', 'last' ];
			},
			
			first_last_numbers: function (page, pages) {
		 		return ['first', _numbers(page, pages), 'last'];
		 	},
		
			// For testing and plug-ins to use
			_numbers: _numbers,
		
			// Number of number buttons (including ellipsis) to show. _Must be odd!_
			numbers_length: 7
		} );
		
		
		$.extend( true, DataTable.ext.renderer, {
			pageButton: {
				_: function ( settings, host, idx, buttons, page, pages ) {
					var classes = settings.oClasses;
					var lang = settings.oLanguage.oPaginate;
					var aria = settings.oLanguage.oAria.paginate || {};
					var btnDisplay, btnClass, counter=0;
		
					var attach = function( container, buttons ) {
						var i, ien, node, button;
						var clickHandler = function ( e ) {
							_fnPageChange( settings, e.data.action, true );
						};
		
						for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
							button = buttons[i];
		
							if ( $.isArray( button ) ) {
								var inner = $( '<'+(button.DT_el || 'div')+'/>' )
									.appendTo( container );
								attach( inner, button );
							}
							else {
								btnDisplay = null;
								btnClass = '';
		
								switch ( button ) {
									case 'ellipsis':
										container.append('<span class="ellipsis">&#x2026;</span>');
										break;
		
									case 'first':
										btnDisplay = lang.sFirst;
										btnClass = button + (page > 0 ?
											'' : ' '+classes.sPageButtonDisabled);
										break;
		
									case 'previous':
										btnDisplay = lang.sPrevious;
										btnClass = button + (page > 0 ?
											'' : ' '+classes.sPageButtonDisabled);
										break;
		
									case 'next':
										btnDisplay = lang.sNext;
										btnClass = button + (page < pages-1 ?
											'' : ' '+classes.sPageButtonDisabled);
										break;
		
									case 'last':
										btnDisplay = lang.sLast;
										btnClass = button + (page < pages-1 ?
											'' : ' '+classes.sPageButtonDisabled);
										break;
		
									default:
										btnDisplay = button + 1;
										btnClass = page === button ?
											classes.sPageButtonActive : '';
										break;
								}
		
								if ( btnDisplay !== null ) {
									node = $('<a>', {
											'class': classes.sPageButton+' '+btnClass,
											'aria-controls': settings.sTableId,
											'aria-label': aria[ button ],
											'data-dt-idx': counter,
											'tabindex': settings.iTabIndex,
											'id': idx === 0 && typeof button === 'string' ?
												settings.sTableId +'_'+ button :
												null
										} )
										.html( btnDisplay )
										.appendTo( container );
		
									_fnBindAction(
										node, {action: button}, clickHandler
									);
		
									counter++;
								}
							}
						}
					};
		
					// IE9 throws an 'unknown error' if document.activeElement is used
					// inside an iframe or frame. Try / catch the error. Not good for
					// accessibility, but neither are frames.
					var activeEl;
		
					try {
						// Because this approach is destroying and recreating the paging
						// elements, focus is lost on the select button which is bad for
						// accessibility. So we want to restore focus once the draw has
						// completed
						activeEl = $(host).find(document.activeElement).data('dt-idx');
					}
					catch (e) {}
		
					attach( $(host).empty(), buttons );
		
					if ( activeEl !== undefined ) {
						$(host).find( '[data-dt-idx='+activeEl+']' ).focus();
					}
				}
			}
		} );
		
		
		
		// Built in type detection. See model.ext.aTypes for information about
		// what is required from this methods.
		$.extend( DataTable.ext.type.detect, [
			// Plain numbers - first since V8 detects some plain numbers as dates
			// e.g. Date.parse('55') (but not all, e.g. Date.parse('22')...).
			function ( d, settings )
			{
				var decimal = settings.oLanguage.sDecimal;
				return _isNumber( d, decimal ) ? 'num'+decimal : null;
			},
		
			// Dates (only those recognised by the browser's Date.parse)
			function ( d, settings )
			{
				// V8 tries _very_ hard to make a string passed into `Date.parse()`
				// valid, so we need to use a regex to restrict date formats. Use a
				// plug-in for anything other than ISO8601 style strings
				if ( d && !(d instanceof Date) && ! _re_date.test(d) ) {
					return null;
				}
				var parsed = Date.parse(d);
				return (parsed !== null && !isNaN(parsed)) || _empty(d) ? 'date' : null;
			},
		
			// Formatted numbers
			function ( d, settings )
			{
				var decimal = settings.oLanguage.sDecimal;
				return _isNumber( d, decimal, true ) ? 'num-fmt'+decimal : null;
			},
		
			// HTML numeric
			function ( d, settings )
			{
				var decimal = settings.oLanguage.sDecimal;
				return _htmlNumeric( d, decimal ) ? 'html-num'+decimal : null;
			},
		
			// HTML numeric, formatted
			function ( d, settings )
			{
				var decimal = settings.oLanguage.sDecimal;
				return _htmlNumeric( d, decimal, true ) ? 'html-num-fmt'+decimal : null;
			},
		
			// HTML (this is strict checking - there must be html)
			function ( d, settings )
			{
				return _empty( d ) || (typeof d === 'string' && d.indexOf('<') !== -1) ?
					'html' : null;
			}
		] );
		
		
		
		// Filter formatting functions. See model.ext.ofnSearch for information about
		// what is required from these methods.
		// 
		// Note that additional search methods are added for the html numbers and
		// html formatted numbers by `_addNumericSort()` when we know what the decimal
		// place is
		
		
		$.extend( DataTable.ext.type.search, {
			html: function ( data ) {
				return _empty(data) ?
					data :
					typeof data === 'string' ?
						data
							.replace( _re_new_lines, " " )
							.replace( _re_html, "" ) :
						'';
			},
		
			string: function ( data ) {
				return _empty(data) ?
					data :
					typeof data === 'string' ?
						data.replace( _re_new_lines, " " ) :
						data;
			}
		} );
		
		
		
		var __numericReplace = function ( d, decimalPlace, re1, re2 ) {
			if ( d !== 0 && (!d || d === '-') ) {
				return -Infinity;
			}
		
			// If a decimal place other than `.` is used, it needs to be given to the
			// function so we can detect it and replace with a `.` which is the only
			// decimal place Javascript recognises - it is not locale aware.
			if ( decimalPlace ) {
				d = _numToDecimal( d, decimalPlace );
			}
		
			if ( d.replace ) {
				if ( re1 ) {
					d = d.replace( re1, '' );
				}
		
				if ( re2 ) {
					d = d.replace( re2, '' );
				}
			}
		
			return d * 1;
		};
		
		
		// Add the numeric 'deformatting' functions for sorting and search. This is done
		// in a function to provide an easy ability for the language options to add
		// additional methods if a non-period decimal place is used.
		function _addNumericSort ( decimalPlace ) {
			$.each(
				{
					// Plain numbers
					"num": function ( d ) {
						return __numericReplace( d, decimalPlace );
					},
		
					// Formatted numbers
					"num-fmt": function ( d ) {
						return __numericReplace( d, decimalPlace, _re_formatted_numeric );
					},
		
					// HTML numeric
					"html-num": function ( d ) {
						return __numericReplace( d, decimalPlace, _re_html );
					},
		
					// HTML numeric, formatted
					"html-num-fmt": function ( d ) {
						return __numericReplace( d, decimalPlace, _re_html, _re_formatted_numeric );
					}
				},
				function ( key, fn ) {
					// Add the ordering method
					_ext.type.order[ key+decimalPlace+'-pre' ] = fn;
		
					// For HTML types add a search formatter that will strip the HTML
					if ( key.match(/^html\-/) ) {
						_ext.type.search[ key+decimalPlace ] = _ext.type.search.html;
					}
				}
			);
		}
		
		
		// Default sort methods
		$.extend( _ext.type.order, {
			// Dates
			"date-pre": function ( d ) {
				return Date.parse( d ) || -Infinity;
			},
		
			// html
			"html-pre": function ( a ) {
				return _empty(a) ?
					'' :
					a.replace ?
						a.replace( /<.*?>/g, "" ).toLowerCase() :
						a+'';
			},
		
			// string
			"string-pre": function ( a ) {
				// This is a little complex, but faster than always calling toString,
				// http://jsperf.com/tostring-v-check
				return _empty(a) ?
					'' :
					typeof a === 'string' ?
						a.toLowerCase() :
						! a.toString ?
							'' :
							a.toString();
			},
		
			// string-asc and -desc are retained only for compatibility with the old
			// sort methods
			"string-asc": function ( x, y ) {
				return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			},
		
			"string-desc": function ( x, y ) {
				return ((x < y) ? 1 : ((x > y) ? -1 : 0));
			}
		} );
		
		
		// Numeric sorting types - order doesn't matter here
		_addNumericSort( '' );
		
		
		$.extend( true, DataTable.ext.renderer, {
			header: {
				_: function ( settings, cell, column, classes ) {
					// No additional mark-up required
					// Attach a sort listener to update on sort - note that using the
					// `DT` namespace will allow the event to be removed automatically
					// on destroy, while the `dt` namespaced event is the one we are
					// listening for
					$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
						if ( settings !== ctx ) { // need to check this this is the host
							return;               // table, not a nested one
						}
		
						var colIdx = column.idx;
		
						cell
							.removeClass(
								column.sSortingClass +' '+
								classes.sSortAsc +' '+
								classes.sSortDesc
							)
							.addClass( columns[ colIdx ] == 'asc' ?
								classes.sSortAsc : columns[ colIdx ] == 'desc' ?
									classes.sSortDesc :
									column.sSortingClass
							);
					} );
				},
		
				jqueryui: function ( settings, cell, column, classes ) {
					$('<div/>')
						.addClass( classes.sSortJUIWrapper )
						.append( cell.contents() )
						.append( $('<span/>')
							.addClass( classes.sSortIcon+' '+column.sSortingClassJUI )
						)
						.appendTo( cell );
		
					// Attach a sort listener to update on sort
					$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
						if ( settings !== ctx ) {
							return;
						}
		
						var colIdx = column.idx;
		
						cell
							.removeClass( classes.sSortAsc +" "+classes.sSortDesc )
							.addClass( columns[ colIdx ] == 'asc' ?
								classes.sSortAsc : columns[ colIdx ] == 'desc' ?
									classes.sSortDesc :
									column.sSortingClass
							);
		
						cell
							.find( 'span.'+classes.sSortIcon )
							.removeClass(
								classes.sSortJUIAsc +" "+
								classes.sSortJUIDesc +" "+
								classes.sSortJUI +" "+
								classes.sSortJUIAscAllowed +" "+
								classes.sSortJUIDescAllowed
							)
							.addClass( columns[ colIdx ] == 'asc' ?
								classes.sSortJUIAsc : columns[ colIdx ] == 'desc' ?
									classes.sSortJUIDesc :
									column.sSortingClassJUI
							);
					} );
				}
			}
		} );
		
		/*
		 * Public helper functions. These aren't used internally by DataTables, or
		 * called by any of the options passed into DataTables, but they can be used
		 * externally by developers working with DataTables. They are helper functions
		 * to make working with DataTables a little bit easier.
		 */
		
		var __htmlEscapeEntities = function ( d ) {
			return typeof d === 'string' ?
				d.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') :
				d;
		};
		
		/**
		 * Helpers for `columns.render`.
		 *
		 * The options defined here can be used with the `columns.render` initialisation
		 * option to provide a display renderer. The following functions are defined:
		 *
		 * * `number` - Will format numeric data (defined by `columns.data`) for
		 *   display, retaining the original unformatted data for sorting and filtering.
		 *   It takes 5 parameters:
		 *   * `string` - Thousands grouping separator
		 *   * `string` - Decimal point indicator
		 *   * `integer` - Number of decimal points to show
		 *   * `string` (optional) - Prefix.
		 *   * `string` (optional) - Postfix (/suffix).
		 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
		 *   parameters.
		 *
		 * @example
		 *   // Column definition using the number renderer
		 *   {
		 *     data: "salary",
		 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
		 *   }
		 *
		 * @namespace
		 */
		DataTable.render = {
			number: function ( thousands, decimal, precision, prefix, postfix ) {
				return {
					display: function ( d ) {
						if ( typeof d !== 'number' && typeof d !== 'string' ) {
							return d;
						}
		
						var negative = d < 0 ? '-' : '';
						var flo = parseFloat( d );
		
						// If NaN then there isn't much formatting that we can do - just
						// return immediately, escaping any HTML (this was supposed to
						// be a number after all)
						if ( isNaN( flo ) ) {
							return __htmlEscapeEntities( d );
						}
		
						flo = flo.toFixed( precision );
						d = Math.abs( flo );
		
						var intPart = parseInt( d, 10 );
						var floatPart = precision ?
							decimal+(d - intPart).toFixed( precision ).substring( 2 ):
							'';
		
						return negative + (prefix||'') +
							intPart.toString().replace(
								/\B(?=(\d{3})+(?!\d))/g, thousands
							) +
							floatPart +
							(postfix||'');
					}
				};
			},
		
			text: function () {
				return {
					display: __htmlEscapeEntities
				};
			}
		};
		
		
		/*
		 * This is really a good bit rubbish this method of exposing the internal methods
		 * publicly... - To be fixed in 2.0 using methods on the prototype
		 */
		
		
		/**
		 * Create a wrapper function for exporting an internal functions to an external API.
		 *  @param {string} fn API function name
		 *  @returns {function} wrapped function
		 *  @memberof DataTable#internal
		 */
		function _fnExternApiFunc (fn)
		{
			return function() {
				var args = [_fnSettingsFromNode( this[DataTable.ext.iApiIndex] )].concat(
					Array.prototype.slice.call(arguments)
				);
				return DataTable.ext.internal[fn].apply( this, args );
			};
		}
		
		
		/**
		 * Reference to internal functions for use by plug-in developers. Note that
		 * these methods are references to internal functions and are considered to be
		 * private. If you use these methods, be aware that they are liable to change
		 * between versions.
		 *  @namespace
		 */
		$.extend( DataTable.ext.internal, {
			_fnExternApiFunc: _fnExternApiFunc,
			_fnBuildAjax: _fnBuildAjax,
			_fnAjaxUpdate: _fnAjaxUpdate,
			_fnAjaxParameters: _fnAjaxParameters,
			_fnAjaxUpdateDraw: _fnAjaxUpdateDraw,
			_fnAjaxDataSrc: _fnAjaxDataSrc,
			_fnAddColumn: _fnAddColumn,
			_fnColumnOptions: _fnColumnOptions,
			_fnAdjustColumnSizing: _fnAdjustColumnSizing,
			_fnVisibleToColumnIndex: _fnVisibleToColumnIndex,
			_fnColumnIndexToVisible: _fnColumnIndexToVisible,
			_fnVisbleColumns: _fnVisbleColumns,
			_fnGetColumns: _fnGetColumns,
			_fnColumnTypes: _fnColumnTypes,
			_fnApplyColumnDefs: _fnApplyColumnDefs,
			_fnHungarianMap: _fnHungarianMap,
			_fnCamelToHungarian: _fnCamelToHungarian,
			_fnLanguageCompat: _fnLanguageCompat,
			_fnBrowserDetect: _fnBrowserDetect,
			_fnAddData: _fnAddData,
			_fnAddTr: _fnAddTr,
			_fnNodeToDataIndex: _fnNodeToDataIndex,
			_fnNodeToColumnIndex: _fnNodeToColumnIndex,
			_fnGetCellData: _fnGetCellData,
			_fnSetCellData: _fnSetCellData,
			_fnSplitObjNotation: _fnSplitObjNotation,
			_fnGetObjectDataFn: _fnGetObjectDataFn,
			_fnSetObjectDataFn: _fnSetObjectDataFn,
			_fnGetDataMaster: _fnGetDataMaster,
			_fnClearTable: _fnClearTable,
			_fnDeleteIndex: _fnDeleteIndex,
			_fnInvalidate: _fnInvalidate,
			_fnGetRowElements: _fnGetRowElements,
			_fnCreateTr: _fnCreateTr,
			_fnBuildHead: _fnBuildHead,
			_fnDrawHead: _fnDrawHead,
			_fnDraw: _fnDraw,
			_fnReDraw: _fnReDraw,
			_fnAddOptionsHtml: _fnAddOptionsHtml,
			_fnDetectHeader: _fnDetectHeader,
			_fnGetUniqueThs: _fnGetUniqueThs,
			_fnFeatureHtmlFilter: _fnFeatureHtmlFilter,
			_fnFilterComplete: _fnFilterComplete,
			_fnFilterCustom: _fnFilterCustom,
			_fnFilterColumn: _fnFilterColumn,
			_fnFilter: _fnFilter,
			_fnFilterCreateSearch: _fnFilterCreateSearch,
			_fnEscapeRegex: _fnEscapeRegex,
			_fnFilterData: _fnFilterData,
			_fnFeatureHtmlInfo: _fnFeatureHtmlInfo,
			_fnUpdateInfo: _fnUpdateInfo,
			_fnInfoMacros: _fnInfoMacros,
			_fnInitialise: _fnInitialise,
			_fnInitComplete: _fnInitComplete,
			_fnLengthChange: _fnLengthChange,
			_fnFeatureHtmlLength: _fnFeatureHtmlLength,
			_fnFeatureHtmlPaginate: _fnFeatureHtmlPaginate,
			_fnPageChange: _fnPageChange,
			_fnFeatureHtmlProcessing: _fnFeatureHtmlProcessing,
			_fnProcessingDisplay: _fnProcessingDisplay,
			_fnFeatureHtmlTable: _fnFeatureHtmlTable,
			_fnScrollDraw: _fnScrollDraw,
			_fnApplyToChildren: _fnApplyToChildren,
			_fnCalculateColumnWidths: _fnCalculateColumnWidths,
			_fnThrottle: _fnThrottle,
			_fnConvertToWidth: _fnConvertToWidth,
			_fnGetWidestNode: _fnGetWidestNode,
			_fnGetMaxLenString: _fnGetMaxLenString,
			_fnStringToCss: _fnStringToCss,
			_fnSortFlatten: _fnSortFlatten,
			_fnSort: _fnSort,
			_fnSortAria: _fnSortAria,
			_fnSortListener: _fnSortListener,
			_fnSortAttachListener: _fnSortAttachListener,
			_fnSortingClasses: _fnSortingClasses,
			_fnSortData: _fnSortData,
			_fnSaveState: _fnSaveState,
			_fnLoadState: _fnLoadState,
			_fnSettingsFromNode: _fnSettingsFromNode,
			_fnLog: _fnLog,
			_fnMap: _fnMap,
			_fnBindAction: _fnBindAction,
			_fnCallbackReg: _fnCallbackReg,
			_fnCallbackFire: _fnCallbackFire,
			_fnLengthOverflow: _fnLengthOverflow,
			_fnRenderer: _fnRenderer,
			_fnDataSource: _fnDataSource,
			_fnRowAttributes: _fnRowAttributes,
			_fnCalculateEnd: function () {} // Used by a lot of plug-ins, but redundant
			                                // in 1.10, so this dead-end function is
			                                // added to prevent errors
		} );
		
	
		// jQuery access
		$.fn.dataTable = DataTable;
	
		// Provide access to the host jQuery object (circular reference)
		DataTable.$ = $;
	
		// Legacy aliases
		$.fn.dataTableSettings = DataTable.settings;
		$.fn.dataTableExt = DataTable.ext;
	
		// With a capital `D` we return a DataTables API instance rather than a
		// jQuery object
		$.fn.DataTable = function ( opts ) {
			return $(this).dataTable( opts ).api();
		};
	
		// All properties that are available to $.fn.dataTable should also be
		// available on $.fn.DataTable
		$.each( DataTable, function ( prop, val ) {
			$.fn.DataTable[ prop ] = val;
		} );
	
	
		// Information about events fired by DataTables - for documentation.
		/**
		 * Draw event, fired whenever the table is redrawn on the page, at the same
		 * point as fnDrawCallback. This may be useful for binding events or
		 * performing calculations when the table is altered at all.
		 *  @name DataTable#draw.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 */
	
		/**
		 * Search event, fired when the searching applied to the table (using the
		 * built-in global search, or column filters) is altered.
		 *  @name DataTable#search.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 */
	
		/**
		 * Page change event, fired when the paging of the table is altered.
		 *  @name DataTable#page.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 */
	
		/**
		 * Order event, fired when the ordering applied to the table is altered.
		 *  @name DataTable#order.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 */
	
		/**
		 * DataTables initialisation complete event, fired when the table is fully
		 * drawn, including Ajax data loaded, if Ajax data is required.
		 *  @name DataTable#init.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} oSettings DataTables settings object
		 *  @param {object} json The JSON object request from the server - only
		 *    present if client-side Ajax sourced data is used</li></ol>
		 */
	
		/**
		 * State save event, fired when the table has changed state a new state save
		 * is required. This event allows modification of the state saving object
		 * prior to actually doing the save, including addition or other state
		 * properties (for plug-ins) or modification of a DataTables core property.
		 *  @name DataTable#stateSaveParams.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} oSettings DataTables settings object
		 *  @param {object} json The state information to be saved
		 */
	
		/**
		 * State load event, fired when the table is loading state from the stored
		 * data, but prior to the settings object being modified by the saved state
		 * - allowing modification of the saved state is required or loading of
		 * state for a plug-in.
		 *  @name DataTable#stateLoadParams.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} oSettings DataTables settings object
		 *  @param {object} json The saved state information
		 */
	
		/**
		 * State loaded event, fired when state has been loaded from stored data and
		 * the settings object has been modified by the loaded data.
		 *  @name DataTable#stateLoaded.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} oSettings DataTables settings object
		 *  @param {object} json The saved state information
		 */
	
		/**
		 * Processing event, fired when DataTables is doing some kind of processing
		 * (be it, order, searcg or anything else). It can be used to indicate to
		 * the end user that there is something happening, or that something has
		 * finished.
		 *  @name DataTable#processing.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} oSettings DataTables settings object
		 *  @param {boolean} bShow Flag for if DataTables is doing processing or not
		 */
	
		/**
		 * Ajax (XHR) event, fired whenever an Ajax request is completed from a
		 * request to made to the server for new data. This event is called before
		 * DataTables processed the returned data, so it can also be used to pre-
		 * process the data returned from the server, if needed.
		 *
		 * Note that this trigger is called in `fnServerData`, if you override
		 * `fnServerData` and which to use this event, you need to trigger it in you
		 * success function.
		 *  @name DataTable#xhr.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 *  @param {object} json JSON returned from the server
		 *
		 *  @example
		 *     // Use a custom property returned from the server in another DOM element
		 *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
		 *       $('#status').html( json.status );
		 *     } );
		 *
		 *  @example
		 *     // Pre-process the data returned from the server
		 *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
		 *       for ( var i=0, ien=json.aaData.length ; i<ien ; i++ ) {
		 *         json.aaData[i].sum = json.aaData[i].one + json.aaData[i].two;
		 *       }
		 *       // Note no return - manipulate the data directly in the JSON object.
		 *     } );
		 */
	
		/**
		 * Destroy event, fired when the DataTable is destroyed by calling fnDestroy
		 * or passing the bDestroy:true parameter in the initialisation object. This
		 * can be used to remove bound events, added DOM nodes, etc.
		 *  @name DataTable#destroy.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 */
	
		/**
		 * Page length change event, fired when number of records to show on each
		 * page (the length) is changed.
		 *  @name DataTable#length.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 *  @param {integer} len New length
		 */
	
		/**
		 * Column sizing has changed.
		 *  @name DataTable#column-sizing.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 */
	
		/**
		 * Column visibility has changed.
		 *  @name DataTable#column-visibility.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 *  @param {int} column Column index
		 *  @param {bool} vis `false` if column now hidden, or `true` if visible
		 */
	
		return $.fn.dataTable;
	}));


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

	/*!
	angular-xeditable - 0.6.0
	Edit-in-place for angular.js
	Build date: 2016-12-27
	*/
	/**
	 * Angular-xeditable module
	 *
	 */
	angular.module('xeditable', [])
	
	
	/**
	 * Default options.
	 *
	 * @namespace editable-options
	 */
	//todo: maybe better have editableDefaults, not options...
	.value('editableOptions', {
	  /**
	   * Theme. Possible values `bs3`, `bs2`, `default`.
	   * Default is `default`
	   *
	   * @var {string} theme
	   * @memberOf editable-options
	   */
	  theme: 'default',
	  /**
	   * icon_set. Possible values `font-awesome`, `default`.
	   * Default is `default`
	   *
	   * @var {string} icon set
	   * @memberOf editable-options
	   */
	  icon_set: 'default',
	  /**
	   * Whether to show buttons for single editable element.
	   * Possible values `right`, `no`.
	   * Default is `right`
	   *
	   * @var {string} buttons
	   * @memberOf editable-options
	   */
	  buttons: 'right',
	  /**
	   * Default value for `blur` attribute of single editable element.
	   * Can be `cancel|submit|ignore`.
	   * Default is `cancel`
	   *
	   * @var {string} blurElem
	   * @memberOf editable-options
	   */
	  blurElem: 'cancel',
	  /**
	   * Default value for `blur` attribute of editable form.
	   * Can be `cancel|submit|ignore`.
	   * Default is `ignore`.
	   *
	   * @var {string} blurForm
	   * @memberOf editable-options
	   */
	  blurForm: 'ignore',
	  /**
	   * How input elements get activated. Possible values: `focus|select|none`.
	   * Default is `focus`
	   *
	   * @var {string} activate
	   * @memberOf editable-options
	   */
	  activate: 'focus',
	  /**
	   * Whether to disable x-editable. Can be overloaded on each element.
	   * Default is `false`
	   *
	   * @var {boolean} isDisabled
	   * @memberOf editable-options
	   */
	   isDisabled: false,
	
	  /**
	   * Event, on which the edit mode gets activated.
	   * Can be any event.
	   * Default is `click`
	   *
	   * @var {string} activationEvent
	   * @memberOf editable-options
	   */
	  activationEvent: 'click',
	
	  /**
	   * The default title of the submit button.
	   * Default is `Submit`
	   *
	   * @var {string} submitButtonTitle
	   * @memberOf editable-options
	   */
	  submitButtonTitle: 'Submit',
	
	  /**
	   * The default aria label of the submit button.
	   * Default is `Submit`
	   *
	   * @var {string} submitButtonAriaLabel
	   * @memberOf editable-options
	   */
	  submitButtonAriaLabel: 'Submit',
	
	  /**
	   * The default title of the cancel button.
	   * Default is `Cancel`
	   *
	   * @var {string} cancelButtonTitle
	   * @memberOf editable-options
	   */
	  cancelButtonTitle: 'Cancel',
	
	  /**
	   * The default aria label of the cancel button.
	   * Default is `Cancel`
	   *
	   * @var {string} cancelButtonAriaLabel
	   * @memberOf editable-options
	   */
	  cancelButtonAriaLabel: 'Cancel',
	
	  /**
	   * The default title of the clear button.
	   * Default is `Clear`
	   *
	   * @var {string} clearButtonTitle
	   * @memberOf editable-options
	   */
	  clearButtonTitle: 'Clear',
	
	  /**
	   * The default aria label of the clear button.
	   * Default is `Clear`
	   *
	   * @var {string} clearButtonAriaLabel
	   * @memberOf editable-options
	   */
	  clearButtonAriaLabel: 'Clear',
	
	  /**
	   * Whether to display the clear button.
	   * Default is `false`
	   *
	   * @var {boolean} displayClearButton
	   * @memberOf editable-options
	   */
	  displayClearButton: false
	});
	
	/*
	 Angular-ui bootstrap datepicker
	 http://angular-ui.github.io/bootstrap/#/datepicker
	 */
	angular.module('xeditable').directive('editableBsdate', ['editableDirectiveFactory', '$injector', '$parse',
	    function(editableDirectiveFactory, $injector, $parse) {
	
	        // Constants from Angular-ui bootstrap datepicker
	        uibDatepickerConfig = $injector.get('uibDatepickerConfig');
	        uibDatepickerPopupConfig = $injector.get('uibDatepickerPopupConfig');
	
	        var popupAttrNames = [
	            ['eIsOpen', 'is-open'],
	            ['eDateDisabled', 'date-disabled'],
	            ['eDatepickerPopup', 'uib-datepicker-popup'],
	            ['eShowButtonBar', 'show-button-bar'],
	            ['eCurrentText', 'current-text'],
	            ['eClearText', 'clear-text'],
	            ['eCloseText', 'close-text'],
	            ['eCloseOnDateSelection', 'close-on-date-selection'],
	            ['eDatePickerAppendToBody', 'datepicker-append-to-body'],
	            ['eOnOpenFocus', 'on-open-focus'],
	            ['eName', 'name'],
	            ['eDateDisabled', 'date-disabled']
	        ];
	
	        var dateOptionsNames = [
	            ['eFormatDay', 'formatDay'],
	            ['eFormatMonth', 'formatMonth'],
	            ['eFormatYear', 'formatYear'],
	            ['eFormatDayHeader', 'formatDayHeader'],
	            ['eFormatDayTitle', 'formatDayTitle'],
	            ['eFormatMonthTitle', 'formatMonthTitle'],
	            ['eMaxMode', 'maxMode'],
	            ['eMinMode', 'minMode'],
	            ['eDatepickerMode', 'datepickerMode']
	        ];
	
	        return editableDirectiveFactory({
	            directiveName: 'editableBsdate',
	            inputTpl: '<div></div>',
	            render: function() {
	                /** This basically renders a datepicker as in the example shown in
	                 **  http://angular-ui.github.io/bootstrap/#/datepicker
	                 **  The attributes are all the same as in the bootstrap-ui datepicker with e- as prefix
	                 **/
	                this.parent.render.call(this);
	
	                var attrs = this.attrs;
	                var scope = this.scope;
	
	                var inputDatePicker = angular.element('<input type="text" class="form-control" ng-model="$parent.$data"/>');
	
	                inputDatePicker.attr('uib-datepicker-popup', attrs.eDatepickerPopupXEditable || uibDatepickerPopupConfig.datepickerPopup );
	                inputDatePicker.attr('year-range', attrs.eYearRange || 20);
	                inputDatePicker.attr('ng-readonly', attrs.eReadonly || false);
	
	                for (var i = popupAttrNames.length - 1; i >= 0; i--) {
	                    var popupAttr = attrs[popupAttrNames[i][0]];
	                    if (typeof popupAttr !== 'undefined') {
	                        inputDatePicker.attr(popupAttrNames[i][1], popupAttr);
	                    }
	                }
	
	                if (attrs.eNgChange) {
	                    inputDatePicker.attr('ng-change', attrs.eNgChange);
	                    this.inputEl.removeAttr('ng-change');
	                }
	
	                if (attrs.eStyle) {
	                    inputDatePicker.attr('style', attrs.eStyle);
	                    this.inputEl.removeAttr('style');
	                }
	
	                var dateOptions = {
	                    maxDate: scope.$eval(attrs.eMaxDate) || uibDatepickerConfig.maxDate,
	                    minDate: scope.$eval(attrs.eMinDate) || uibDatepickerConfig.minDate,
	                    showWeeks: attrs.eShowWeeks ? attrs.eShowWeeks.toLowerCase() === 'true' : uibDatepickerConfig.showWeeks,
	                    startingDay: attrs.eStartingDay || 0,
	                    initDate: scope.$eval(attrs.eInitDate) || new Date()
	                };
	
	                if (attrs.eDatepickerOptions) {
	                    var eDatepickerOptions = $parse(attrs.eDatepickerOptions)(scope);
	                    angular.extend(dateOptions, eDatepickerOptions);
	                }
	
	                for (var z = dateOptionsNames.length - 1; z >= 0; z--) {
	                    var doAttr = attrs[dateOptionsNames[z][0]];
	                    if (typeof doAttr !== 'undefined') {
	                        dateOptions[dateOptionsNames[z][1]] = doAttr;
	                    }
	                }
	
	                scope.dateOptions = dateOptions;
	
	                var showCalendarButton = angular.isDefined(attrs.eShowCalendarButton) ? attrs.eShowCalendarButton : "true";
	
	                //See if calendar button should be displayed
	                if (showCalendarButton === "true") {
	                    var buttonDatePicker = angular.element('<button type="button" class="btn btn-default"><i class="glyphicon glyphicon-calendar"></i></button>');
	                    var buttonWrapper = angular.element('<span class="input-group-btn"></span>');
	
	                    buttonDatePicker.attr('ng-click', attrs.eNgClick);
	
	                    buttonWrapper.append(buttonDatePicker);
	
	                    this.inputEl.append(buttonWrapper);
	                } else {
	                    //If no calendar button, display calendar popup on click of input field
	                    inputDatePicker.attr('ng-click', attrs.eNgClick);
	                }
	
	                inputDatePicker.attr('datepicker-options', "dateOptions");
	
	                this.inputEl.prepend(inputDatePicker);
	
	                this.inputEl.removeAttr('class');
	                this.inputEl.removeAttr('ng-click');
	                this.inputEl.removeAttr('is-open');
	                this.inputEl.removeAttr('init-date');
	                this.inputEl.removeAttr('datepicker-popup');
	                this.inputEl.removeAttr('required');
	                this.inputEl.removeAttr('ng-model');
	                this.inputEl.removeAttr('date-picker-append-to-body');
	                this.inputEl.removeAttr('name');
	                this.inputEl.attr('class','input-group');
	            }
	    });
	}]);
	/*
	Angular-ui bootstrap editable timepicker
	http://angular-ui.github.io/bootstrap/#/timepicker
	*/
	angular.module('xeditable').directive('editableBstime', ['editableDirectiveFactory',
	  function(editableDirectiveFactory) {
	    return editableDirectiveFactory({
	      directiveName: 'editableBstime',
	      inputTpl: '<uib-timepicker></uib-timepicker>',
	      render: function() {
	        this.parent.render.call(this);
	
	        // timepicker can't update model when ng-model set directly to it
	        // see: https://github.com/angular-ui/bootstrap/issues/1141
	        // so we wrap it into DIV
	        var div = angular.element('<div class="well well-small" style="display:inline-block;"></div>');
	
	        // move ng-model to wrapping div
	        div.attr('ng-model', this.inputEl.attr('ng-model'));
	        this.inputEl.removeAttr('ng-model');
	
	        // move ng-change to wrapping div
	        if(this.attrs.eNgChange) {
	          div.attr('ng-change', this.inputEl.attr('ng-change'));
	          this.inputEl.removeAttr('ng-change');
	        }
	
	        // wrap
	        this.inputEl.wrap(div);
	      }
	    });
	}]);
	//checkbox
	angular.module('xeditable').directive('editableCheckbox', ['editableDirectiveFactory',
	  function(editableDirectiveFactory) {
	    return editableDirectiveFactory({
	      directiveName: 'editableCheckbox',
	      inputTpl: '<input type="checkbox">',
	      render: function() {
	        this.parent.render.call(this);
	        if(this.attrs.eTitle) {
	          this.inputEl.wrap('<label></label>');
	          this.inputEl.parent().append('<span>' + this.attrs.eTitle + '</span>');
	        }
	      },
	      autosubmit: function() {
	        var self = this;
	        self.inputEl.bind('change', function() {
	          setTimeout(function() {
	            self.scope.$apply(function() {
	              self.scope.$form.$submit();
	            });
	          }, 500);
	        });
	      }
	    });
	}]);
	
	// checklist
	angular.module('xeditable').directive('editableChecklist', [
	  'editableDirectiveFactory',
	  'editableNgOptionsParser',
	  function(editableDirectiveFactory, editableNgOptionsParser) {
	    return editableDirectiveFactory({
	      directiveName: 'editableChecklist',
	      inputTpl: '<span></span>',
	      useCopy: true,
	      render: function() {
	        this.parent.render.call(this);
	        var parsed = editableNgOptionsParser(this.attrs.eNgOptions);
	        var ngChangeHtml = '';
	        var ngChecklistComparatorHtml = '';
	
	        if (this.attrs.eNgChange) {
	          ngChangeHtml = ' ng-change="' +  this.attrs.eNgChange + '"';
	        }
	
	        if (this.attrs.eChecklistComparator) {
	          ngChecklistComparatorHtml = ' checklist-comparator="' +  this.attrs.eChecklistComparator + '"';
	        }
	
	        var html = '<label ng-repeat="'+parsed.ngRepeat+'">'+
	          '<input type="checkbox" checklist-model="$parent.$parent.$data" checklist-value="'+parsed.locals.valueFn+'"' +
	            ngChangeHtml + ngChecklistComparatorHtml + '>'+
	          '<span ng-bind="'+parsed.locals.displayFn+'"></span></label>';
	
	        this.inputEl.removeAttr('ng-model');
	        this.inputEl.removeAttr('ng-options');
	        this.inputEl.removeAttr('ng-change');
	        this.inputEl.removeAttr('checklist-comparator');
	        this.inputEl.html(html);
	      }
	    });
	}]);
	
	angular.module('xeditable').directive('editableCombodate', ['editableDirectiveFactory', 'editableCombodate',
	  function(editableDirectiveFactory, editableCombodate) {
	    return editableDirectiveFactory({
	      directiveName: 'editableCombodate',
	      inputTpl: '<input type="text">',
	      render: function() {
	        this.parent.render.call(this);
	
	        var options = {
	          value: new Date(this.scope.$data)
	        };
	        var self = this;
	        angular.forEach(["format", "template", "minYear", "maxYear", "yearDescending", "minuteStep", "secondStep", "firstItem", "errorClass", "customClass", "roundTime", "smartDays"], function(name) {
	
	          var attrName = "e" + name.charAt(0).toUpperCase() + name.slice(1);
	
	          if (attrName in self.attrs) {
	            if (name == "minYear" || name == "maxYear" || name == "minuteStep" || name == "secondStep") {
	              options[name] = parseInt(self.attrs[attrName], 10);
	            } else {
	              options[name] = self.attrs[attrName];
	            }
	          }
	        });
	
	        var combodate = editableCombodate.getInstance(this.inputEl, options);
	        combodate.$widget.find('select').bind('change', function(e) {
	          self.scope.$data = (new Date(combodate.getValue())).toISOString();
	        });
	      }
	    });
	  }
	]);
	
	/*
	Input types: text|password|email|tel|number|url|search|color|date|datetime|datetime-local|time|month|week|file
	*/
	
	(function() {
	
	  var camelCase = function(dashDelimitedString) {
	    return dashDelimitedString.toLowerCase().replace(/-(.)/g, function(match, word) {
	      return word.toUpperCase();
	    });
	  };
	
	  var types = 'text|password|email|tel|number|url|search|color|date|datetime|datetime-local|time|month|week|file'.split('|');
	
	  //todo: datalist
	
	  // generate directives
	  angular.forEach(types, function(type) {
	    var directiveName = camelCase('editable' + '-' + type);
	    angular.module('xeditable').directive(directiveName, ['editableDirectiveFactory',
	      function(editableDirectiveFactory) {
	        return editableDirectiveFactory({
	          directiveName: directiveName,
	          inputTpl: '<input type="'+type+'">',
	          render: function() {
	            this.parent.render.call(this);
	
	            //Add bootstrap simple input groups
	            if (this.attrs.eInputgroupleft || this.attrs.eInputgroupright) {
	              this.inputEl.wrap('<div class="input-group"></div>');
	
	              if (this.attrs.eInputgroupleft) {
	                var inputGroupLeft = angular.element('<span class="input-group-addon">' + this.attrs.eInputgroupleft + '</span>');
	                this.inputEl.parent().prepend(inputGroupLeft);
	              }
	
	              if (this.attrs.eInputgroupright) {
	                var inputGroupRight = angular.element('<span class="input-group-addon">' + this.attrs.eInputgroupright + '</span>');
	                this.inputEl.parent().append(inputGroupRight);
	              }
	            }
	
	            // Add label to the input
	            if (this.attrs.eLabel) {
	              var label = angular.element('<label>' + this.attrs.eLabel + '</label>');
	              if (this.attrs.eInputgroupleft || this.attrs.eInputgroupright) {
	                this.inputEl.parent().parent().prepend(label);
	              } else {
	                this.inputEl.parent().prepend(label);
	              }
	            }
	
	            // Add classes to the form
	            if (this.attrs.eFormclass) {
	              this.editorEl.addClass(this.attrs.eFormclass);
	            }
	          },
	          autosubmit: function() {
	            var self = this;
	            self.inputEl.bind('keydown', function(e) {
	                //submit on tab
	                if (e.keyCode === 9) {
	                    self.scope.$apply(function() {
	                        self.scope.$form.$submit();
	                    });
	                }
	            });
	          }
	        });
	    }]);
	  });
	
	  //`range` is bit specific
	  angular.module('xeditable').directive('editableRange', ['editableDirectiveFactory', '$interpolate',
	    function(editableDirectiveFactory, $interpolate) {
	      return editableDirectiveFactory({
	        directiveName: 'editableRange',
	        inputTpl: '<input type="range" id="range" name="range">',
	        render: function() {
	          this.parent.render.call(this);
	          this.inputEl.after('<output>' + $interpolate.startSymbol() + '$data' + $interpolate.endSymbol()  + '</output>');
	        }
	      });
	  }]);
	
	}());
	
	
	/*
	 Tags input directive for AngularJS
	 https://github.com/mbenford/ngTagsInput
	 */
	angular.module('xeditable').directive('editableTagsInput', ['editableDirectiveFactory', 'editableUtils',
	  function(editableDirectiveFactory, editableUtils) {
	    var dir = editableDirectiveFactory({
	        directiveName: 'editableTagsInput',
	        inputTpl: '<tags-input></tags-input>',
	        render: function () {
	            this.parent.render.call(this);
	            this.inputEl.append(editableUtils.rename('auto-complete', this.attrs.$autoCompleteElement));
	            this.inputEl.removeAttr('ng-model');
	            this.inputEl.attr('ng-model', '$parent.$data');
	        }
	    });
	
	    var linkOrg = dir.link;
	
	    dir.link = function (scope, el, attrs, ctrl) {
	        var autoCompleteEl = el.find('editable-tags-input-auto-complete');
	
	        attrs.$autoCompleteElement = autoCompleteEl.clone();
	
	        autoCompleteEl.remove();
	
	        return linkOrg(scope, el, attrs, ctrl);
	    };
	
	    return dir;
	}]);
	// radiolist
	angular.module('xeditable').directive('editableRadiolist', [
	  'editableDirectiveFactory',
	  'editableNgOptionsParser',
	  '$interpolate',
	  function(editableDirectiveFactory, editableNgOptionsParser, $interpolate) {
	    return editableDirectiveFactory({
	      directiveName: 'editableRadiolist',
	      inputTpl: '<span></span>',
	      render: function() {
	        this.parent.render.call(this);
	        var parsed = editableNgOptionsParser(this.attrs.eNgOptions);
	        var ngChangeHtml = '';
	
	        if (this.attrs.eNgChange) {
	          ngChangeHtml = 'ng-change="' +  this.attrs.eNgChange + '"';
	        }
	
	        var html = '<label data-ng-repeat="'+parsed.ngRepeat+'">'+
	          '<input type="radio" data-ng-disabled="::' +
	            this.attrs.eNgDisabled +
	            '" data-ng-model="$parent.$parent.$data" data-ng-value="' + $interpolate.startSymbol() +
	            '::' + parsed.locals.valueFn + $interpolate.endSymbol() +'"' +
	            ngChangeHtml + '>'+
	          '<span data-ng-bind="::'+parsed.locals.displayFn+'"></span></label>';
	
	        this.inputEl.removeAttr('ng-model');
	        this.inputEl.removeAttr('ng-options');
	        this.inputEl.removeAttr('ng-change');
	        this.inputEl.html(html);
	      },
	      autosubmit: function() {
	        var self = this;
	        self.inputEl.bind('change', function() {
	          setTimeout(function() {
	            self.scope.$apply(function() {
	              self.scope.$form.$submit();
	            });
	          }, 500);
	        });
	      }
	    });
	}]);
	
	//select
	angular.module('xeditable').directive('editableSelect', ['editableDirectiveFactory',
	  function(editableDirectiveFactory) {
	    return editableDirectiveFactory({
	      directiveName: 'editableSelect',
	      inputTpl: '<select></select>',
	      render: function() {
	        this.parent.render.call(this);
	
	        if (this.attrs.ePlaceholder) {
	          var placeholder = angular.element('<option value="">' + this.attrs.ePlaceholder + '</option>');
	          this.inputEl.append(placeholder);
	        }
	      },
	      autosubmit: function() {
	        var self = this;
	        self.inputEl.bind('change', function() {
	          self.scope.$apply(function() {
	            self.scope.$form.$submit();
	          });
	        });
	      }
	    });
	}]);
	//textarea
	angular.module('xeditable').directive('editableTextarea', ['editableDirectiveFactory',
	  function(editableDirectiveFactory) {
	    return editableDirectiveFactory({
	      directiveName: 'editableTextarea',
	      inputTpl: '<textarea></textarea>',
	      addListeners: function() {
	        var self = this;
	        self.parent.addListeners.call(self);
	        // submit textarea by ctrl+enter even with buttons
	        if (self.single && self.buttons !== 'no') {
	          self.autosubmit();
	        }
	      },
	      autosubmit: function() {
	        var self = this;
	        self.inputEl.bind('keydown', function(e) {
	          if (self.attrs.submitOnEnter) {
	            if (e.keyCode === 13 && !e.shiftKey) {
	              self.scope.$apply(function() {
	                self.scope.$form.$submit();
	              });
	            }
	          } else if ((e.ctrlKey || e.metaKey) && (e.keyCode === 13)) {
	            self.scope.$apply(function() {
	              self.scope.$form.$submit();
	            });
	          }
	        });
	      }
	    });
	}]);
	
	/*
	 jQuery UI Datepicker for AngularJS
	 https://github.com/angular-ui/ui-date
	 */
	angular.module('xeditable').directive('editableUidate', ['editableDirectiveFactory',
	    function(editableDirectiveFactory) {
	        return editableDirectiveFactory({
	            directiveName: 'editableUidate',
	            inputTpl: '<input class="form-control" />',
	            render: function() {
	                this.parent.render.call(this);
	                this.inputEl.attr('ui-date', this.attrs.eUiDate);
	                this.inputEl.attr('placeholder', this.attrs.ePlaceholder);
	            }
	        });
	}]);
	
	/*
	 AngularJS-native version of Select2 and Selectize
	 https://github.com/angular-ui/ui-select
	 */
	angular.module('xeditable').directive('editableUiSelect',['editableDirectiveFactory', 'editableUtils',
	    function(editableDirectiveFactory, editableUtils) {
	        var dir = editableDirectiveFactory({
	            directiveName: 'editableUiSelect',
	            inputTpl: '<ui-select></ui-select>',
	            render: function () {
	                this.parent.render.call(this);
	                this.inputEl.append(editableUtils.rename('ui-select-match', this.attrs.$matchElement));
	                this.inputEl.append(editableUtils.rename('ui-select-choices', this.attrs.$choicesElement));
	                this.inputEl.removeAttr('ng-model');
	                this.inputEl.attr('ng-model', '$parent.$parent.$data');
	            }
	        });
	
	        var linkOrg = dir.link;
	
	        dir.link = function (scope, el, attrs, ctrl) {
	            var matchEl = el.find('editable-ui-select-match');
	            var choicesEl = el.find('editable-ui-select-choices');
	
	            attrs.$matchElement = matchEl.clone();
	            attrs.$choicesElement = choicesEl.clone();
	
	            matchEl.remove();
	            choicesEl.remove();
	
	            return linkOrg(scope, el, attrs, ctrl);
	        };
	
	        return dir;
	    }]);
	/**
	 * EditableController class.
	 * Attached to element with `editable-xxx` directive.
	 *
	 * @namespace editable-element
	 */
	/*
	TODO: this file should be refactored to work more clear without closures!
	*/
	angular.module('xeditable').factory('editableController',
	  ['$q', 'editableUtils',
	  function($q, editableUtils) {
	
	  //EditableController function
	  EditableController.$inject = ['$scope', '$attrs', '$element', '$parse', 'editableThemes', 'editableIcons', 'editableOptions', '$rootScope', '$compile', '$q'];
	  function EditableController($scope, $attrs, $element, $parse, editableThemes, editableIcons, editableOptions, $rootScope, $compile, $q) {
	    var valueGetter;
	
	    //if control is disabled - it does not participate in waiting process
	    var inWaiting;
	
	    var self = this;
	
	    self.scope = $scope;
	    self.elem = $element;
	    self.attrs = $attrs;
	    self.inputEl = null;
	    self.editorEl = null;
	    self.single = true;
	    self.error = '';
	    self.theme =  editableThemes[$attrs.editableTheme] || editableThemes[editableOptions.theme] || editableThemes['default'];
	    self.parent = {};
	
	    //will be undefined if icon_set is default and theme is default
	    var theme_name = $attrs.editableTheme || editableOptions.theme || 'default';
	    // The theme_name will not be correct if the theme set in options is unavailable
	    // However, in that case an undefined icon_set is not that bad...
	    var icon_set_option = $attrs.editableIconSet || editableOptions.icon_set;
	    self.icon_set = icon_set_option === 'default' ? editableIcons.default[theme_name] : editableIcons.external[icon_set_option];
	
	    //to be overwritten by directive
	    self.inputTpl = '';
	    self.directiveName = '';
	
	    // with majority of controls copy is not needed, but..
	    // copy MUST NOT be used for `select-multiple` with objects as items
	    // copy MUST be used for `checklist`
	    self.useCopy = false;
	
	    //runtime (defaults)
	    self.single = null;
	
	    /**
	     * Attributes defined with `e-*` prefix automatically transferred from original element to
	     * control.
	     * For example, if you set `<span editable-text="user.name" e-style="width: 100px"`>
	     * then input will appear as `<input style="width: 100px">`.
	     * See [demo](#text-customize).
	     *
	     * @var {any|attribute} e-*
	     * @memberOf editable-element
	     */
	
	    /**
	     * Whether to show ok/cancel buttons. Values: `right|no`.
	     * If set to `no` control automatically submitted when value changed.
	     * If control is part of form buttons will never be shown.
	     *
	     * @var {string|attribute} buttons
	     * @memberOf editable-element
	     */
	    self.buttons = 'right';
	    /**
	     * Action when control losses focus. Values: `cancel|submit|ignore`.
	     * Has sense only for single editable element.
	     * Otherwise, if control is part of form - you should set `blur` of form, not of individual element.
	     *
	     * @var {string|attribute} blur
	     * @memberOf editable-element
	     */
	    // no real `blur` property as it is transferred to editable form
	
	    //init
	    self.init = function(single) {
	      self.single = single;
	
	      self.name = $attrs.eName || $attrs[self.directiveName];
	      /*
	      if(!$attrs[directiveName] && !$attrs.eNgModel && ($attrs.eValue === undefined)) {
	        throw 'You should provide value for `'+directiveName+'` or `e-value` in editable element!';
	      }
	      */
	      if($attrs[self.directiveName]) {
	        valueGetter = $parse($attrs[self.directiveName]);
	      } else {
	        throw 'You should provide value for `'+self.directiveName+'` in editable element!';
	      }
	
	      // settings for single and non-single
	      if (!self.single) {
	        // hide buttons for non-single
	        self.buttons = 'no';
	      } else {
	        self.buttons = self.attrs.buttons || editableOptions.buttons;
	      }
	
	      //if name defined --> watch changes and update $data in form
	      if($attrs.eName) {
	        self.scope.$watch('$data', function(newVal){
	          self.scope.$form.$data[$attrs.eName] = newVal;
	        });
	      }
	
	      /**
	       * Called when control is shown.
	       * See [demo](#select-remote).
	       *
	       * @var {method|attribute} onshow
	       * @memberOf editable-element
	       */
	      if($attrs.onshow) {
	        self.onshow = function() {
	          return self.catchError($parse($attrs.onshow)($scope));
	        };
	      }
	
	      /**
	       * Called when control is hidden after both save or cancel.
	       *
	       * @var {method|attribute} onhide
	       * @memberOf editable-element
	       */
	      if($attrs.onhide) {
	        self.onhide = function() {
	          return $parse($attrs.onhide)($scope);
	        };
	      }
	
	      /**
	       * Called when control is cancelled.
	       *
	       * @var {method|attribute} oncancel
	       * @memberOf editable-element
	       */
	      if($attrs.oncancel) {
	        self.oncancel = function() {
	          return $parse($attrs.oncancel)($scope);
	        };
	      }
	
	      /**
	       * Called during submit before value is saved to model.
	       * See [demo](#onbeforesave).
	       *
	       * @var {method|attribute} onbeforesave
	       * @memberOf editable-element
	       */
	      if ($attrs.onbeforesave) {
	        self.onbeforesave = function() {
	          return self.catchError($parse($attrs.onbeforesave)($scope));
	        };
	      }
	
	      /**
	       * Called during submit after value is saved to model.
	       * See [demo](#onaftersave).
	       *
	       * @var {method|attribute} onaftersave
	       * @memberOf editable-element
	       */
	      if ($attrs.onaftersave) {
	        self.onaftersave = function() {
	          return self.catchError($parse($attrs.onaftersave)($scope));
	        };
	      }
	
	      // watch change of model to update editable element
	      // now only add/remove `editable-empty` class.
	      // Initially this method called with newVal = undefined, oldVal = undefined
	      // so no need initially call handleEmpty() explicitly
	      $scope.$parent.$watch($attrs[self.directiveName], function(newVal, oldVal) {
	        self.setLocalValue();
	        self.handleEmpty();
	      });
	    };
	
	    self.render = function() {
	      var theme = self.theme;
	
	      //build input
	      self.inputEl = angular.element(self.inputTpl);
	
	      //build controls
	      self.controlsEl = angular.element(theme.controlsTpl);
	      self.controlsEl.append(self.inputEl);
	
	      //build buttons
	      if(self.buttons !== 'no') {
	        self.buttonsEl = angular.element(theme.buttonsTpl);
	        self.submitEl = angular.element(theme.submitTpl);
	        self.resetEl = angular.element(theme.resetTpl);
	        self.cancelEl = angular.element(theme.cancelTpl);
	        self.submitEl.attr('title', editableOptions.submitButtonTitle);
	        self.submitEl.attr('aria-label', editableOptions.submitButtonAriaLabel);
	        self.cancelEl.attr('title', editableOptions.cancelButtonTitle);
	        self.cancelEl.attr('aria-label', editableOptions.cancelButtonAriaLabel);
	        self.resetEl.attr('title', editableOptions.clearButtonTitle);
	        self.resetEl.attr('aria-label', editableOptions.clearButtonAriaLabel);
	
	        if (self.icon_set) {
	          self.submitEl.find('span').addClass(self.icon_set.ok);
	          self.cancelEl.find('span').addClass(self.icon_set.cancel);
	          self.resetEl.find('span').addClass(self.icon_set.clear);
	        }
	
	        self.buttonsEl.append(self.submitEl).append(self.cancelEl);
	
	        if (editableOptions.displayClearButton) {
	          self.buttonsEl.append(self.resetEl);
	        }
	
	        self.controlsEl.append(self.buttonsEl);
	
	        self.inputEl.addClass('editable-has-buttons');
	      }
	
	      //build error
	      self.errorEl = angular.element(theme.errorTpl);
	      self.controlsEl.append(self.errorEl);
	
	      //build editor
	      self.editorEl = angular.element(self.single ? theme.formTpl : theme.noformTpl);
	      self.editorEl.append(self.controlsEl);
	
	      // transfer `e-*|data-e-*|x-e-*` attributes
	      for (var k in $attrs.$attr) {
	        if(k.length <= 1) {
	          continue;
	        }
	        var transferAttr = false;
	        var nextLetter = k.substring(1, 2);
	
	        // if starts with `e` + uppercase letter
	        if (k.substring(0, 1) === 'e' && nextLetter === nextLetter.toUpperCase()) {
	          transferAttr = k.substring(1); // cut `e`
	        } else {
	          continue;
	        }
	
	        // exclude `form` and `ng-submit`,
	        if (transferAttr === 'Form' || transferAttr === 'NgSubmit') {
	          continue;
	        }
	
	        var firstLetter = transferAttr.substring(0, 1);
	        var secondLetter = transferAttr.substring(1, 2);
	
	        // convert back to lowercase style
	        if (secondLetter === secondLetter.toUpperCase() &&
	            firstLetter === firstLetter.toUpperCase()) {
	          transferAttr = firstLetter.toLowerCase() + '-' + editableUtils.camelToDash(transferAttr.substring(1));
	        } else {
	          transferAttr = firstLetter.toLowerCase() + editableUtils.camelToDash(transferAttr.substring(1));
	        }
	
	        // workaround for attributes without value (e.g. `multiple = "multiple"`)
	        // except for 'e-value'
	        var attrValue = (transferAttr !== 'value' && $attrs[k] === '') ? transferAttr : $attrs[k];
	
	        // set attributes to input
	        self.inputEl.attr(transferAttr, attrValue);
	      }
	
	      self.inputEl.addClass('editable-input');
	      self.inputEl.attr('ng-model', '$parent.$data');
	
	      // add directiveName class to editor, e.g. `editable-text`
	      self.editorEl.addClass(editableUtils.camelToDash(self.directiveName));
	
	      if (self.single) {
	        self.editorEl.attr('editable-form', '$form');
	        // transfer `blur` to form
	        self.editorEl.attr('blur', self.attrs.blur || (self.buttons === 'no' ? 'cancel' : editableOptions.blurElem));
	      }
	
	      //apply `postrender` method of theme
	      if (angular.isFunction(theme.postrender)) {
	        theme.postrender.call(self);
	      }
	
	    };
	
	    // with majority of controls copy is not needed, but..
	    // copy MUST NOT be used for `select-multiple` with objects as items
	    // copy MUST be used for `checklist`
	    self.setLocalValue = function() {
	      self.scope.$data = self.useCopy ?
	        angular.copy(valueGetter($scope.$parent)) :
	        valueGetter($scope.$parent);
	    };
	
	    // reference of the scope to use for $compile
	    var newScope = null;
	    //show
	    self.show = function() {
	      // set value of scope.$data
	      self.setLocalValue();
	
	      /*
	      Originally render() was inside init() method, but some directives polluting editorEl,
	      so it is broken on second openning.
	      Cloning is not a solution as jqLite can not clone with event handler's.
	      */
	      self.render();
	
	      // insert into DOM
	      $element.after(self.editorEl);
	
	      // compile (needed to attach ng-* events from markup)
	      newScope = $scope.$new();
	      $compile(self.editorEl)(newScope);
	
	      // attach listeners (`escape`, autosubmit, etc)
	      self.addListeners();
	
	      // hide element
	      $element.addClass('editable-hide');
	
	      // onshow
	      return self.onshow();
	    };
	
	    //hide
	    self.hide = function() {
	
	      // destroy the scope to prevent memory leak
	      newScope.$destroy();
	
	      self.controlsEl.remove();
	      self.editorEl.remove();
	      $element.removeClass('editable-hide');
	
	      // onhide
	      return self.onhide();
	    };
	
	    // cancel
	    self.cancel = function() {
	      // oncancel
	      self.oncancel();
	      // don't call hide() here as it called in form's code
	    };
	
	    /*
	    Called after show to attach listeners
	    */
	    self.addListeners = function() {
	      // bind keyup for `escape`
	      self.inputEl.bind('keyup', function(e) {
	          if(!self.single) {
	            return;
	          }
	
	          // todo: move this to editable-form!
	          switch(e.keyCode) {
	            // hide on `escape` press
	            case 27:
	              self.scope.$apply(function() {
	                self.scope.$form.$cancel();
	              });
	            break;
	          }
	      });
	
	      // autosubmit when `no buttons`
	      if (self.single && self.buttons === 'no') {
	        self.autosubmit();
	      }
	
	      // click - mark element as clicked to exclude in document click handler
	      self.editorEl.bind('click', function(e) {
	        // ignore right/middle button click
	        if (e.which && e.which !== 1) {
	          return;
	        }
	
	        if (self.scope.$form.$visible) {
	          self.scope.$form._clicked = true;
	        }
	      });
	    };
	
	    // setWaiting
	    self.setWaiting = function(value) {
	      if (value) {
	        // participate in waiting only if not disabled
	        inWaiting = !self.inputEl.attr('disabled') &&
	                    !self.inputEl.attr('ng-disabled') &&
	                    !self.inputEl.attr('ng-enabled');
	        if (inWaiting) {
	          self.inputEl.attr('disabled', 'disabled');
	          if(self.buttonsEl) {
	            self.buttonsEl.find('button').attr('disabled', 'disabled');
	          }
	        }
	      } else {
	        if (inWaiting) {
	          self.inputEl.removeAttr('disabled');
	          if (self.buttonsEl) {
	            self.buttonsEl.find('button').removeAttr('disabled');
	          }
	        }
	      }
	    };
	
	    self.activate = function(start, end) {
	      setTimeout(function() {
	        var el = self.inputEl[0];
	
	        if (editableOptions.activate === 'focus' && el.focus) {
	          if (start !== undefined && start !== "" && el.setSelectionRange) {
	            end = end || start;
	            el.onfocus = function() {
	              setTimeout(function() {
	                try {
	                  this.setSelectionRange(start,end);
	                } catch(e) {
	                  //do nothing, this input doesn't support setSelectionRange
	                }
	              }.bind(this));
	            };
	          }
	
	          if (self.directiveName == 'editableRadiolist' || self.directiveName == 'editableChecklist' ||
	              self.directiveName == 'editableBsdate' || self.directiveName == 'editableTagsInput') {
	            //Set focus to first pristine element in the list
	            el.querySelector('.ng-pristine').focus();
	          } else {
	            el.focus();
	          }
	        } else if (editableOptions.activate === 'select') {
	          if (el.select){
	            el.select();
	          } else if (el.focus) {
	            el.focus();
	          }
	        }
	      }, 0);
	    };
	
	    self.setError = function(msg) {
	      if(!angular.isObject(msg)) {
	        $scope.$error = msg;
	        self.error = msg;
	      }
	    };
	
	    /*
	    Checks that result is string or promise returned string and shows it as error message
	    Applied to onshow, onbeforesave, onaftersave
	    */
	    self.catchError = function(result, noPromise) {
	      if (angular.isObject(result) && noPromise !== true) {
	        $q.when(result).then(
	          //success and fail handlers are equal
	          angular.bind(this, function(r) {
	            this.catchError(r, true);
	          }),
	          angular.bind(this, function(r) {
	            this.catchError(r, true);
	          })
	        );
	      //check $http error
	      } else if (noPromise && angular.isObject(result) && result.status &&
	        (result.status !== 200) && result.data && angular.isString(result.data)) {
	        this.setError(result.data);
	        //set result to string: to let form know that there was error
	        result = result.data;
	      } else if (angular.isString(result)) {
	        this.setError(result);
	      }
	      return result;
	    };
	
	    self.save = function() {
	      valueGetter.assign($scope.$parent,
	          self.useCopy ? angular.copy(self.scope.$data) : self.scope.$data);
	
	      // no need to call handleEmpty here as we are watching change of model value
	      // self.handleEmpty();
	    };
	
	    /*
	    attach/detach `editable-empty` class to element
	    */
	    self.handleEmpty = function() {
	      var val = valueGetter($scope.$parent);
	      var isEmpty = val === null || val === undefined || val === "" || (angular.isArray(val) && val.length === 0);
	      $element.toggleClass('editable-empty', isEmpty);
	    };
	
	    /*
	    Called when `buttons = "no"` to submit automatically
	    */
	    self.autosubmit = angular.noop;
	
	    self.onshow = angular.noop;
	    self.onhide = angular.noop;
	    self.oncancel = angular.noop;
	    self.onbeforesave = angular.noop;
	    self.onaftersave = angular.noop;
	  }
	
	  return EditableController;
	}]);
	
	/*
	editableFactory is used to generate editable directives (see `/directives` folder)
	Inside it does several things:
	- detect form for editable element. Form may be one of three types:
	  1. autogenerated form (for single editable elements)
	  2. wrapper form (element wrapped by <form> tag)
	  3. linked form (element has `e-form` attribute pointing to existing form)
	
	- attach editableController to element
	
	Depends on: editableController, editableFormFactory
	*/
	angular.module('xeditable').factory('editableDirectiveFactory',
	['$parse', '$compile', 'editableThemes', '$rootScope', '$document', 'editableController', 'editableFormController', 'editableOptions',
	function($parse, $compile, editableThemes, $rootScope, $document, editableController, editableFormController, editableOptions) {
	
	  //directive object
	  return function(overwrites) {
	    return {
	      restrict: 'A',
	      scope: true,
	      require: [overwrites.directiveName, '?^form'],
	      controller: editableController,
	      link: function(scope, elem, attrs, ctrl) {
	        // editable controller
	        var eCtrl = ctrl[0];
	
	        // form controller
	        var eFormCtrl;
	
	        // this variable indicates is element is bound to some existing form,
	        // or it's single element who's form will be generated automatically
	        // By default consider single element without any linked form.ß
	        var hasForm = false;
	
	        // element wrapped by form
	        if (ctrl[1]) {
	          eFormCtrl = ctrl[1];
	          hasForm = attrs.eSingle === undefined;
	        } else if (attrs.eForm) { // element not wrapped by <form>, but we have `e-form` attr
	          var getter = $parse(attrs.eForm)(scope);
	          if (getter) { // form exists in scope (above), e.g. editable column
	            eFormCtrl = getter;
	            hasForm = true;
	          } else if (elem && typeof elem.parents === "function" && elem.parents().last().find('form[name='+attrs.eForm+']').length) { // form exists below or not exist at all: check document.forms
	            // form is below and not processed yet
	            eFormCtrl = null;
	            hasForm = true;
	          } else {
	            // form exists below or not exist at all: check document.forms
	            for (var i=0; i<$document[0].forms.length;i++) {
	              if ($document[0].forms[i].name === attrs.eForm) {
	                // form is below and not processed yet
	                eFormCtrl = null;
	                hasForm = true;
	                break;
	              }
	            }
	          }
	        }
	
	        /*
	        if(hasForm && !attrs.eName) {
	          throw 'You should provide `e-name` for editable element inside form!';
	        }
	        */
	
	        //check for `editable-form` attr in form
	        /*
	        if(eFormCtrl && ) {
	          throw 'You should provide `e-name` for editable element inside form!';
	        }
	        */
	
	        // store original props to `parent` before merge
	        angular.forEach(overwrites, function(v, k) {
	          if(eCtrl[k] !== undefined) {
	            eCtrl.parent[k] = eCtrl[k];
	          }
	        });
	
	        // merge overwrites to base editable controller
	        angular.extend(eCtrl, overwrites);
	
	        // x-editable can be disabled using editableOption or edit-disabled attribute
	        var is_disabled = function() {
	          return angular.isDefined(attrs.editDisabled) ?
	            scope.$eval(attrs.editDisabled) :
	            editableOptions.isDisabled;
	        };
	
	        // init editable ctrl
	        eCtrl.init(!hasForm);
	
	        // publich editable controller as `$editable` to be referenced in html
	        scope.$editable = eCtrl;
	
	        // add `editable` class to element
	        elem.addClass('editable');
	
	        // hasForm
	        if(hasForm) {
	          if(eFormCtrl) {
	            scope.$form = eFormCtrl;
	            if(!scope.$form.$addEditable) {
	              throw 'Form with editable elements should have `editable-form` attribute.';
	            }
	            scope.$form.$addEditable(eCtrl);
	          } else {
	            // future form (below): add editable controller to buffer and add to form later
	            $rootScope.$$editableBuffer = $rootScope.$$editableBuffer || {};
	            $rootScope.$$editableBuffer[attrs.eForm] = $rootScope.$$editableBuffer[attrs.eForm] || [];
	            $rootScope.$$editableBuffer[attrs.eForm].push(eCtrl);
	            scope.$form = null; //will be re-assigned later
	          }
	        // !hasForm
	        } else {
	          // create editableform controller
	          scope.$form = editableFormController();
	          // add self to editable controller
	          scope.$form.$addEditable(eCtrl);
	
	          // if `e-form` provided, publish local $form in scope
	          if(attrs.eForm) {
	            ($parse(attrs.eForm).assign || angular.noop)(scope.$parent, scope.$form);
	          }
	
	          // bind click - if no external form defined
	          if(!attrs.eForm || attrs.eClickable) {
	            elem.addClass('editable-click');
	            elem.bind(editableOptions.activationEvent, function(e) {
	              e.preventDefault();
	              e.editable = eCtrl;
	              if(!is_disabled()) {
	                scope.$apply(function(){
	                  scope.$form.$show();
	                });
	              }
	            });
	          }
	        }
	
	      }
	    };
	  };
	}]);
	
	/*
	Returns editableForm controller
	*/
	angular.module('xeditable').factory('editableFormController',
	  ['$parse', '$document', '$rootScope', 'editablePromiseCollection', 'editableUtils',
	  function($parse, $document, $rootScope, editablePromiseCollection, editableUtils) {
	
	  // array of opened editable forms
	  var shown = [];
	
	  //Check if the child element correspond or is a descendant of the parent element
	  var isSelfOrDescendant = function (parent, child) {
	    if (child == parent) {
	      return true;
	    }
	
	    var node = child.parentNode;
	    while (node !== null) {
	      if (node == parent) {
	        return true;
	      }
	      node = node.parentNode;
	    }
	    return false;
	  };
	
	  //Check if it is a real blur : if the click event appear on a shown editable elem, this is not a blur.
	  var isBlur = function(shown, event) {
	    var isBlur = true;
	
	    var editables = shown.$editables;
	    angular.forEach(editables, function(v){
	      var element = v.editorEl[0];
	      if (isSelfOrDescendant(element, event.target))
	        isBlur = false;
	
	    });
	    return isBlur;
	  };
	
	  // bind click to body: cancel|submit|ignore forms
	  $document.bind('click', function(e) {
	    // ignore right/middle button click
	    if (e.which && e.which !== 1) {
	      return;
	    }
	
	    var toCancel = [];
	    var toSubmit = [];
	    for (var i=0; i<shown.length; i++) {
	
	      // exclude clicked
	      if (shown[i]._clicked) {
	        shown[i]._clicked = false;
	        continue;
	      }
	
	      // exclude waiting
	      if (shown[i].$waiting) {
	        continue;
	      }
	
	      if (shown[i]._blur === 'cancel' && isBlur(shown[i], e)) {
	        toCancel.push(shown[i]);
	      }
	
	      if (shown[i]._blur === 'submit' && isBlur(shown[i], e)) {
	        toSubmit.push(shown[i]);
	      }
	    }
	
	    if (toCancel.length || toSubmit.length) {
	      $rootScope.$apply(function() {
	        angular.forEach(toCancel, function(v){ v.$cancel(); });
	        angular.forEach(toSubmit, function(v){ v.$submit(); });
	      });
	    }
	  });
	
	  $rootScope.$on('closeEdit', function() {
	    for(var i=0; i < shown.length; i++) {
	      shown[i].$hide();
	    }
	  });
	
	  var base = {
	    $addEditable: function(editable) {
	      //console.log('add editable', editable.elem, editable.elem.bind);
	      this.$editables.push(editable);
	
	      //'on' is not supported in angular 1.0.8
	      editable.elem.bind('$destroy', angular.bind(this, this.$removeEditable, editable));
	
	      //bind editable's local $form to self (if not bound yet, below form)
	      if (!editable.scope.$form) {
	        editable.scope.$form = this;
	      }
	
	      //if form already shown - call show() of new editable
	      if (this.$visible) {
	        editable.catchError(editable.show());
	      }
	      editable.catchError(editable.setWaiting(this.$waiting));
	    },
	
	    $removeEditable: function(editable) {
	      //arrayRemove
	      for(var i=0; i < this.$editables.length; i++) {
	        if(this.$editables[i] === editable) {
	          this.$editables.splice(i, 1);
	          return;
	        }
	      }
	    },
	
	    /**
	     * Shows form with editable controls.
	     *
	     * @method $show()
	     * @memberOf editable-form
	     */
	    $show: function() {
	      if (this.$visible) {
	        return;
	      }
	
	      this.$visible = true;
	
	      var pc = editablePromiseCollection();
	
	      //own show
	      pc.when(this.$onshow());
	
	      //clear errors
	      this.$setError(null, '');
	
	      //children show
	      angular.forEach(this.$editables, function(editable) {
	        pc.when(editable.show());
	      });
	
	      //wait promises and activate
	      pc.then({
	        onWait: angular.bind(this, this.$setWaiting),
	        onTrue: angular.bind(this, this.$activate),
	        onFalse: angular.bind(this, this.$activate),
	        onString: angular.bind(this, this.$activate)
	      });
	
	      // add to internal list of shown forms
	      // setTimeout needed to prevent closing right after opening (e.g. when trigger by button)
	      setTimeout(angular.bind(this, function() {
	        // clear `clicked` to get ready for clicks on visible form
	        this._clicked = false;
	        if(editableUtils.indexOf(shown, this) === -1) {
	          shown.push(this);
	        }
	      }), 0);
	    },
	
	    /**
	     * Sets focus on form field specified by `name`.<br/>
	     * When trying to set the focus on a form field of a new row in the editable table, the `$activate` call needs to be wrapped in a `$timeout` call so that the form is rendered before the `$activate` function is called.
	     *
	     * @method $activate(name)
	     * @param {string} name name of field
	     * @memberOf editable-form
	     */
	    $activate: function(name) {
	      var i,
	          selectionStart,
	          selectionEnd;
	      if (this.$editables.length) {
	        //activate by name
	        if (angular.isString(name)) {
	          for(i=0; i<this.$editables.length; i++) {
	            if (this.$editables[i].name === name) {
	              this.$editables[i].activate();
	              return;
	            }
	          }
	        }
	
	        //try activate error field
	        for(i=0; i<this.$editables.length; i++) {
	          if (this.$editables[i].error) {
	            this.$editables[i].activate();
	            return;
	          }
	        }
	
	        //by default activate first field
	        selectionStart = this.$editables[0].elem[0].selectionStart ?
	            this.$editables[0].elem[0].selectionStart :
	              this.$editables[0].elem[0].text ? this.$editables[0].elem[0].text.length : 0;
	        selectionEnd = this.$editables[0].elem[0].selectionEnd ?
	            this.$editables[0].elem[0].selectionEnd :
	              this.$editables[0].elem[0].text ? this.$editables[0].elem[0].text.length : 0;
	        this.$editables[0].activate(selectionStart, selectionEnd);
	      }
	    },
	
	    /**
	     * Hides form with editable controls without saving.
	     *
	     * @method $hide()
	     * @memberOf editable-form
	     */
	    $hide: function() {
	      if (!this.$visible) {
	        return;
	      }
	      this.$visible = false;
	      // self hide
	      this.$onhide();
	      // children's hide
	      angular.forEach(this.$editables, function(editable) {
	        editable.hide();
	      });
	
	      // remove from internal list of shown forms
	      editableUtils.arrayRemove(shown, this);
	    },
	
	    /**
	     * Triggers `oncancel` event and calls `$hide()`.
	     *
	     * @method $cancel()
	     * @memberOf editable-form
	     */
	    $cancel: function() {
	      if (!this.$visible) {
	        return;
	      }
	      // self cancel
	      this.$oncancel();
	      // children's cancel
	      angular.forEach(this.$editables, function(editable) {
	        editable.cancel();
	      });
	      // self hide
	      this.$hide();
	    },
	
	    $setWaiting: function(value) {
	      this.$waiting = !!value;
	      // we can't just set $waiting variable and use it via ng-disabled in children
	      // because in editable-row form is not accessible
	      angular.forEach(this.$editables, function(editable) {
	        editable.setWaiting(!!value);
	      });
	    },
	
	    /**
	     * Shows error message for particular field.
	     *
	     * @method $setError(name, msg)
	     * @param {string} name name of field
	     * @param {string} msg error message
	     * @memberOf editable-form
	     */
	    $setError: function(name, msg) {
	      angular.forEach(this.$editables, function(editable) {
	        if(!name || editable.name === name) {
	          editable.setError(msg);
	        }
	      });
	    },
	
	    $submit: function() {
	      if (this.$waiting) {
	        return;
	      }
	
	      //clear errors
	      this.$setError(null, '');
	
	      //children onbeforesave
	      var pc = editablePromiseCollection();
	      angular.forEach(this.$editables, function(editable) {
	        pc.when(editable.onbeforesave());
	      });
	
	      /*
	      onbeforesave result:
	      - true/undefined: save data and close form
	      - false: close form without saving
	      - string: keep form open and show error
	      */
	      pc.then({
	        onWait: angular.bind(this, this.$setWaiting),
	        onTrue: angular.bind(this, checkSelf, true),
	        onFalse: angular.bind(this, checkSelf, false),
	        onString: angular.bind(this, this.$activate)
	      });
	
	      //save
	      function checkSelf(childrenTrue){
	        var pc = editablePromiseCollection();
	        pc.when(this.$onbeforesave());
	        pc.then({
	          onWait: angular.bind(this, this.$setWaiting),
	          onTrue: childrenTrue ? angular.bind(this, this.$save) : angular.bind(this, this.$hide),
	          onFalse: angular.bind(this, this.$hide),
	          onString: angular.bind(this, this.$activate)
	        });
	      }
	    },
	
	    $save: function() {
	      // write model for each editable
	      angular.forEach(this.$editables, function(editable) {
	        editable.save();
	      });
	
	      //call onaftersave of self and children
	      var pc = editablePromiseCollection();
	      pc.when(this.$onaftersave());
	      angular.forEach(this.$editables, function(editable) {
	        pc.when(editable.onaftersave());
	      });
	
	      /*
	      onaftersave result:
	      - true/undefined/false: just close form
	      - string: keep form open and show error
	      */
	      pc.then({
	        onWait: angular.bind(this, this.$setWaiting),
	        onTrue: angular.bind(this, this.$hide),
	        onFalse: angular.bind(this, this.$hide),
	        onString: angular.bind(this, this.$activate)
	      });
	    },
	
	    $onshow: angular.noop,
	    $oncancel: angular.noop,
	    $onhide: angular.noop,
	    $onbeforesave: angular.noop,
	    $onaftersave: angular.noop
	  };
	
	  return function() {
	    return angular.extend({
	      $editables: [],
	      /**
	       * Form visibility flag.
	       *
	       * @var {bool} $visible
	       * @memberOf editable-form
	       */
	      $visible: false,
	      /**
	       * Form waiting flag. It becomes `true` when form is loading or saving data.
	       *
	       * @var {bool} $waiting
	       * @memberOf editable-form
	       */
	      $waiting: false,
	      $data: {},
	      _clicked: false,
	      _blur: null
	    }, base);
	  };
	}]);
	
	/**
	 * EditableForm directive. Should be defined in <form> containing editable controls.
	 * It add some usefull methods to form variable exposed to scope by `name="myform"` attribute.
	 *
	 * @namespace editable-form
	 */
	angular.module('xeditable').directive('editableForm',
	  ['$rootScope', '$parse', 'editableFormController', 'editableOptions',
	  function($rootScope, $parse, editableFormController, editableOptions) {
	    return {
	      restrict: 'A',
	      require: ['form'],
	      //require: ['form', 'editableForm'],
	      //controller: EditableFormController,
	      compile: function() {
	        return {
	          pre: function(scope, elem, attrs, ctrl) {
	            var form = ctrl[0];
	            var eForm;
	
	            //if `editableForm` has value - publish smartly under this value
	            //this is required only for single editor form that is created and removed
	            if(attrs.editableForm) {
	              if(scope[attrs.editableForm] && scope[attrs.editableForm].$show) {
	                eForm = scope[attrs.editableForm];
	                angular.extend(form, eForm);
	              } else {
	                eForm = editableFormController();
	                scope[attrs.editableForm] = eForm;
	                angular.extend(eForm, form);
	              }
	            } else { //just merge to form and publish if form has name
	              eForm = editableFormController();
	              angular.extend(form, eForm);
	            }
	
	            //read editables from buffer (that appeared before FORM tag)
	            var buf = $rootScope.$$editableBuffer;
	            var name = form.$name;
	            if(name && buf && buf[name]) {
	              angular.forEach(buf[name], function(editable) {
	                eForm.$addEditable(editable);
	              });
	              delete buf[name];
	            }
	          },
	          post: function(scope, elem, attrs, ctrl) {
	            var eForm;
	
	            if(attrs.editableForm && scope[attrs.editableForm] && scope[attrs.editableForm].$show) {
	              eForm = scope[attrs.editableForm];
	            } else {
	              eForm = ctrl[0];
	            }
	
	            /**
	             * Called when form is shown.
	             *
	             * @var {method|attribute} onshow
	             * @memberOf editable-form
	             */
	            if(attrs.onshow) {
	              eForm.$onshow = angular.bind(eForm, $parse(attrs.onshow), scope);
	            }
	
	            /**
	             * Called when form hides after both save or cancel.
	             *
	             * @var {method|attribute} onhide
	             * @memberOf editable-form
	             */
	            if(attrs.onhide) {
	              eForm.$onhide = angular.bind(eForm, $parse(attrs.onhide), scope);
	            }
	
	            /**
	             * Called when form is cancelled.
	             *
	             * @var {method|attribute} oncancel
	             * @memberOf editable-form
	             */
	            if(attrs.oncancel) {
	              eForm.$oncancel = angular.bind(eForm, $parse(attrs.oncancel), scope);
	            }
	
	            /**
	             * Whether form initially rendered in shown state.
	             *
	             * @var {bool|attribute} shown
	             * @memberOf editable-form
	             */
	            if(attrs.shown && $parse(attrs.shown)(scope)) {
	              eForm.$show();
	            }
	
	            /**
	             * Action when form losses focus. Values: `cancel|submit|ignore`.
	             * Default is `ignore`.
	             *
	             * @var {string|attribute} blur
	             * @memberOf editable-form
	             */
	            eForm._blur = attrs.blur || editableOptions.blurForm;
	
	            // onbeforesave, onaftersave
	            if(!attrs.ngSubmit && !attrs.submit) {
	              /**
	               * Called after all children `onbeforesave` callbacks but before saving form values
	               * to model.
	               * If at least one children callback returns `non-string` - it will not not be called.
	               * See [editable-form demo](#editable-form) for details.
	               *
	               * @var {method|attribute} onbeforesave
	               * @memberOf editable-form
	               *
	               */
	              if(attrs.onbeforesave) {
	                eForm.$onbeforesave = function() {
	                  return $parse(attrs.onbeforesave)(scope, {$data: eForm.$data});
	                };
	              }
	
	              /**
	               * Called when form values are saved to model.
	               * See [editable-form demo](#editable-form) for details.
	               *
	               * @var {method|attribute} onaftersave
	               * @memberOf editable-form
	               *
	               */
	              if(attrs.onaftersave) {
	                eForm.$onaftersave = function() {
	                  return $parse(attrs.onaftersave)(scope, {$data: eForm.$data});
	                };
	              }
	
	              elem.bind('submit', function(event) {
	                event.preventDefault();
	                scope.$apply(function() {
	                  eForm.$submit();
	                });
	              });
	            }
	
	
	            // click - mark form as clicked to exclude in document click handler
	            elem.bind('click', function(e) {
	              // ignore right/middle button click
	              if (e.which && e.which !== 1) {
	                return;
	              }
	
	              if (eForm.$visible) {
	                eForm._clicked = true;
	              }
	            });
	
	          }
	        };
	      }
	    };
	}]);
	/**
	 * editablePromiseCollection
	 *
	 * Collect results of function calls. Shows waiting if there are promises.
	 * Finally, applies callbacks if:
	 * - onTrue(): all results are true and all promises resolved to true
	 * - onFalse(): at least one result is false or promise resolved to false
	 * - onString(): at least one result is string or promise rejected or promise resolved to string
	 */
	
	angular.module('xeditable').factory('editablePromiseCollection', ['$q', function($q) {
	
	  function promiseCollection() {
	    return {
	      promises: [],
	      hasFalse: false,
	      hasString: false,
	      when: function(result, noPromise) {
	        if (result === false) {
	          this.hasFalse = true;
	        } else if (!noPromise && angular.isObject(result)) {
	          this.promises.push($q.when(result));
	        } else if (angular.isString(result)){
	          this.hasString = true;
	        } else { //result === true || result === undefined || result === null
	          return;
	        }
	      },
	      //callbacks: onTrue, onFalse, onString
	      then: function(callbacks) {
	        callbacks = callbacks || {};
	        var onTrue = callbacks.onTrue || angular.noop;
	        var onFalse = callbacks.onFalse || angular.noop;
	        var onString = callbacks.onString || angular.noop;
	        var onWait = callbacks.onWait || angular.noop;
	
	        var self = this;
	
	        if (this.promises.length) {
	          onWait(true);
	          $q.all(this.promises).then(
	            //all resolved
	            function(results) {
	              onWait(false);
	              //check all results via same `when` method (without checking promises)
	              angular.forEach(results, function(result) {
	                self.when(result, true);
	              });
	              applyCallback();
	            },
	            //some rejected
	            function(error) {
	              onWait(false);
	              onString();
	            }
	            );
	        } else {
	          applyCallback();
	        }
	
	        function applyCallback() {
	          if (!self.hasString && !self.hasFalse) {
	            onTrue();
	          } else if (!self.hasString && self.hasFalse) {
	            onFalse();
	          } else {
	            onString();
	          }
	        }
	
	      }
	    };
	  }
	
	  return promiseCollection;
	
	}]);
	
	/**
	 * editableUtils
	 */
	 angular.module('xeditable').factory('editableUtils', [function() {
	  return {
	    indexOf: function (array, obj) {
	      if (array.indexOf) return array.indexOf(obj);
	
	      for ( var i = 0; i < array.length; i++) {
	        if (obj === array[i]) return i;
	      }
	      return -1;
	    },
	
	    arrayRemove: function (array, value) {
	      var index = this.indexOf(array, value);
	      if (index >= 0) {
	        array.splice(index, 1);
	      }
	      return value;
	    },
	
	    // copy from https://github.com/angular/angular.js/blob/master/src/Angular.js
	    camelToDash: function(str) {
	      var SNAKE_CASE_REGEXP = /[A-Z]/g;
	      return str.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	        return (pos ? '-' : '') + letter.toLowerCase();
	      });
	    },
	
	    dashToCamel: function(str) {
	      var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	      var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	      return str.
	      replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	        return offset ? letter.toUpperCase() : letter;
	      }).
	      replace(MOZ_HACK_REGEXP, 'Moz$1');
	    },
	
	    rename: function (tag, el) {
	      if (el[0] && el[0].attributes) {
	        var newEl = angular.element('<' + tag + '/>');
	        newEl.html(el.html());
	        var attrs = el[0].attributes;
	        for (var i = 0; i < attrs.length; ++i) {
	            newEl.attr(attrs.item(i).nodeName, attrs.item(i).value);
	        }
	        return newEl;
	      }
	    }
	  };
	}]);
	
	/**
	 * editableNgOptionsParser
	 *
	 * see: https://github.com/angular/angular.js/blob/master/src/ng/directive/select.js#L131
	 */
	 angular.module('xeditable').factory('editableNgOptionsParser', [function() {
	  //0000111110000000000022220000000000000000000000333300000000000000444444444444444000000000555555555555555000000066666666666666600000000000000007777000000000000000000088888
	  var NG_OPTIONS_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/;
	
	  function parser(optionsExp) {
	    var match;
	
	    if (! (match = optionsExp.match(NG_OPTIONS_REGEXP))) {
	      throw 'ng-options parse error';
	    }
	
	    var
	    displayFn = match[2] || match[1],
	    valueName = match[4] || match[6],
	    keyName = match[5],
	    groupByFn = match[3] || '',
	    valueFn = match[2] ? match[1] : valueName,
	    valuesFn = match[7],
	    track = match[8],
	    trackFn = track ? match[8] : null;
	
	    var ngRepeat;
	    if (keyName === undefined) { // array
	      ngRepeat = valueName + ' in ' + valuesFn;
	      if (track !== undefined) {
	        ngRepeat += ' track by '+trackFn;
	      }
	    } else { // object
	      ngRepeat = '('+keyName+', '+valueName+') in '+valuesFn;
	    }
	
	    // group not supported yet
	    return {
	      ngRepeat: ngRepeat,
	      locals: {
	        valueName: valueName,
	        keyName: keyName,
	        valueFn: valueFn,
	        displayFn: displayFn
	      }
	    };
	  }
	
	  return parser;
	}]);
	
	/**
	 * editableCombodate
	 *
	 * angular version of https://github.com/vitalets/combodate
	 */
	angular.module('xeditable').factory('editableCombodate', [function() {
	  function Combodate(element, options) {
	    this.$element = angular.element(element);
	
	    if(this.$element[0].nodeName != 'INPUT') {
	      throw 'Combodate should be applied to INPUT element';
	    }
	
	    var currentYear = new Date().getFullYear();
	    this.defaults = {
	      //in this format value stored in original input
	      format: 'YYYY-MM-DD HH:mm',
	      //in this format items in dropdowns are displayed
	      template: 'D / MMM / YYYY   H : mm',
	      //initial value, can be `new Date()`
	      value: null,
	      minYear: 1970,
	      maxYear: currentYear,
	      yearDescending: true,
	      minuteStep: 5,
	      secondStep: 1,
	      firstItem: 'empty', //'name', 'empty', 'none'
	      errorClass: null,
	      customClass: '',
	      roundTime: true, // whether to round minutes and seconds if step > 1
	      smartDays: true // whether days in combo depend on selected month: 31, 30, 28
	    };
	
	    this.options = angular.extend({}, this.defaults, options);
	    this.init();
	  }
	
	  Combodate.prototype = {
	    constructor: Combodate,
	    init: function () {
	      this.map = {
	        //key   regexp    moment.method
	        day:    ['D',    'date'],
	        month:  ['M',    'month'],
	        year:   ['Y',    'year'],
	        hour:   ['[Hh]', 'hours'],
	        minute: ['m',    'minutes'],
	        second: ['s',    'seconds'],
	        ampm:   ['[Aa]', '']
	      };
	
	      this.$widget = angular.element('<span class="combodate"></span>').html(this.getTemplate());
	
	      this.initCombos();
	
	      if (this.options.smartDays) {
	        var combo = this;
	        this.$widget.find('select').bind('change', function(e) {
	          // update days count if month or year changes
	          if (angular.element(e.target).hasClass('month') || angular.element(e.target).hasClass('year')) {
	            combo.fillCombo('day');
	          }
	        });
	      }
	
	      this.$widget.find('select').css('width', 'auto');
	
	      // hide original input and insert widget
	      this.$element.css('display', 'none').after(this.$widget);
	
	      // set initial value
	      this.setValue(this.$element.val() || this.options.value);
	    },
	
	    /*
	     Replace tokens in template with <select> elements
	     */
	     getTemplate: function() {
	      var tpl = this.options.template;
	      var customClass = this.options.customClass;
	
	      //first pass
	      angular.forEach(this.map, function(v, k) {
	        v = v[0];
	        var r = new RegExp(v+'+');
	        var token = v.length > 1 ? v.substring(1, 2) : v;
	
	        tpl = tpl.replace(r, '{'+token+'}');
	      });
	
	      //replace spaces with &nbsp;
	      tpl = tpl.replace(/ /g, '&nbsp;');
	
	      //second pass
	      angular.forEach(this.map, function(v, k) {
	        v = v[0];
	        var token = v.length > 1 ? v.substring(1, 2) : v;
	
	        tpl = tpl.replace('{'+token+'}', '<select class="'+k+' '+customClass+'"></select>');
	      });
	
	      return tpl;
	    },
	
	    /*
	     Initialize combos that presents in template
	     */
	     initCombos: function() {
	      for (var k in this.map) {
	        var c = this.$widget[0].querySelectorAll('.'+k);
	        // set properties like this.$day, this.$month etc.
	        this['$'+k] = c.length ? angular.element(c) : null;
	        // fill with items
	        this.fillCombo(k);
	      }
	    },
	
	    /*
	     Fill combo with items
	     */
	     fillCombo: function(k) {
	      var $combo = this['$'+k];
	      if (!$combo) {
	        return;
	      }
	
	      // define method name to fill items, e.g `fillDays`
	      var f = 'fill' + k.charAt(0).toUpperCase() + k.slice(1);
	      var items = this[f]();
	      var value = $combo.val();
	
	      $combo.html('');
	      for(var i=0; i<items.length; i++) {
	        $combo.append('<option value="'+items[i][0]+'">'+items[i][1]+'</option>');
	      }
	
	      $combo.val(value);
	    },
	
	    /*
	     Initialize items of combos. Handles `firstItem` option
	     */
	     fillCommon: function(key) {
	      var values = [], relTime;
	
	      if(this.options.firstItem === 'name') {
	        //need both to support moment ver < 2 and  >= 2
	        relTime = moment.relativeTime || moment.langData()._relativeTime;
	        var header = typeof relTime[key] === 'function' ? relTime[key](1, true, key, false) : relTime[key];
	        //take last entry (see momentjs lang files structure)
	        header = header.split(' ').reverse()[0];
	        values.push(['', header]);
	      } else if(this.options.firstItem === 'empty') {
	        values.push(['', '']);
	      }
	      return values;
	    },
	
	
	    /*
	    fill day
	    */
	    fillDay: function() {
	      var items = this.fillCommon('d'), name, i,
	      twoDigit = this.options.template.indexOf('DD') !== -1,
	      daysCount = 31;
	
	      // detect days count (depends on month and year)
	      // originally https://github.com/vitalets/combodate/pull/7
	      if (this.options.smartDays && this.$month && this.$year) {
	        var month = parseInt(this.$month.val(), 10);
	        var year = parseInt(this.$year.val(), 10);
	
	        if (!isNaN(month) && !isNaN(year)) {
	          daysCount = moment([year, month]).daysInMonth();
	        }
	      }
	
	      for (i = 1; i <= daysCount; i++) {
	        name = twoDigit ? this.leadZero(i) : i;
	        items.push([i, name]);
	      }
	      return items;
	    },
	
	    /*
	    fill month
	    */
	    fillMonth: function() {
	      var items = this.fillCommon('M'), name, i,
	      longNames = this.options.template.indexOf('MMMM') !== -1,
	      shortNames = this.options.template.indexOf('MMM') !== -1,
	      twoDigit = this.options.template.indexOf('MM') !== -1;
	
	      for(i=0; i<=11; i++) {
	        if(longNames) {
	          //see https://github.com/timrwood/momentjs.com/pull/36
	          name = moment().date(1).month(i).format('MMMM');
	        } else if(shortNames) {
	          name = moment().date(1).month(i).format('MMM');
	        } else if(twoDigit) {
	          name = this.leadZero(i+1);
	        } else {
	          name = i+1;
	        }
	        items.push([i, name]);
	      }
	      return items;
	    },
	
	    /*
	    fill year
	    */
	    fillYear: function() {
	      var items = [], name, i,
	      longNames = this.options.template.indexOf('YYYY') !== -1;
	
	      for(i=this.options.maxYear; i>=this.options.minYear; i--) {
	        name = longNames ? i : (i+'').substring(2);
	        items[this.options.yearDescending ? 'push' : 'unshift']([i, name]);
	      }
	
	      items = this.fillCommon('y').concat(items);
	
	      return items;
	    },
	
	    /*
	    fill hour
	    */
	    fillHour: function() {
	      var items = this.fillCommon('h'), name, i,
	      h12 = this.options.template.indexOf('h') !== -1,
	      h24 = this.options.template.indexOf('H') !== -1,
	      twoDigit = this.options.template.toLowerCase().indexOf('hh') !== -1,
	      min = h12 ? 1 : 0,
	      max = h12 ? 12 : 23;
	
	      for(i=min; i<=max; i++) {
	        name = twoDigit ? this.leadZero(i) : i;
	        items.push([i, name]);
	      }
	      return items;
	    },
	
	    /*
	    fill minute
	    */
	    fillMinute: function() {
	      var items = this.fillCommon('m'), name, i,
	      twoDigit = this.options.template.indexOf('mm') !== -1;
	
	      for(i=0; i<=59; i+= this.options.minuteStep) {
	        name = twoDigit ? this.leadZero(i) : i;
	        items.push([i, name]);
	      }
	      return items;
	    },
	
	    /*
	    fill second
	    */
	    fillSecond: function() {
	      var items = this.fillCommon('s'), name, i,
	      twoDigit = this.options.template.indexOf('ss') !== -1;
	
	      for(i=0; i<=59; i+= this.options.secondStep) {
	        name = twoDigit ? this.leadZero(i) : i;
	        items.push([i, name]);
	      }
	      return items;
	    },
	
	    /*
	    fill ampm
	    */
	    fillAmpm: function() {
	      var ampmL = this.options.template.indexOf('a') !== -1,
	      ampmU = this.options.template.indexOf('A') !== -1,
	      items = [
	      ['am', ampmL ? 'am' : 'AM'],
	      ['pm', ampmL ? 'pm' : 'PM']
	      ];
	      return items;
	    },
	
	    /*
	     Returns current date value from combos.
	     If format not specified - `options.format` used.
	     If format = `null` - Moment object returned.
	     */
	     getValue: function(format) {
	      var dt, values = {},
	      that = this,
	      notSelected = false;
	
	      //getting selected values
	      angular.forEach(this.map, function(v, k) {
	        if(k === 'ampm') {
	          return;
	        }
	        var def = k === 'day' ? 1 : 0;
	
	        values[k] = that['$'+k] ? parseInt(that['$'+k].val(), 10) : def;
	
	        if(isNaN(values[k])) {
	         notSelected = true;
	         return false;
	       }
	     });
	
	      //if at least one visible combo not selected - return empty string
	      if(notSelected) {
	       return '';
	     }
	
	      //convert hours 12h --> 24h
	      if(this.$ampm) {
	        //12:00 pm --> 12:00 (24-h format, midday), 12:00 am --> 00:00 (24-h format, midnight, start of day)
	        if(values.hour === 12) {
	          values.hour = this.$ampm.val() === 'am' ? 0 : 12;
	        } else {
	          values.hour = this.$ampm.val() === 'am' ? values.hour : values.hour+12;
	        }
	      }
	
	      dt = moment([values.year, values.month, values.day, values.hour, values.minute, values.second]);
	
	      //highlight invalid date
	      this.highlight(dt);
	
	      format = format === undefined ? this.options.format : format;
	      if(format === null) {
	       return dt.isValid() ? dt : null;
	     } else {
	       return dt.isValid() ? dt.format(format) : '';
	     }
	   },
	
	   setValue: function(value) {
	    if(!value) {
	      return;
	    }
	
	      // parse in strict mode (third param `true`)
	      var dt = typeof value === 'string' ? moment(value, this.options.format, true) : moment(value),
	      that = this,
	      values = {};
	
	      //function to find nearest value in select options
	      function getNearest($select, value) {
	        var delta = {};
	        angular.forEach($select.children('option'), function(opt, i){
	          var optValue = angular.element(opt).attr('value');
	
	          if(optValue === '') return;
	          var distance = Math.abs(optValue - value);
	          if(typeof delta.distance === 'undefined' || distance < delta.distance) {
	            delta = {value: optValue, distance: distance};
	          }
	        });
	        return delta.value;
	      }
	
	      if(dt.isValid()) {
	        //read values from date object
	        angular.forEach(this.map, function(v, k) {
	          if(k === 'ampm') {
	            return;
	          }
	          values[k] = dt[v[1]]();
	        });
	
	        if(this.$ampm) {
	          //12:00 pm --> 12:00 (24-h format, midday), 12:00 am --> 00:00 (24-h format, midnight, start of day)
	          if(values.hour >= 12) {
	            values.ampm = 'pm';
	            if(values.hour > 12) {
	              values.hour -= 12;
	            }
	          } else {
	            values.ampm = 'am';
	            if(values.hour === 0) {
	              values.hour = 12;
	            }
	          }
	        }
	
	        angular.forEach(values, function(v, k) {
	          //call val() for each existing combo, e.g. this.$hour.val()
	          if(that['$'+k]) {
	
	            if(k === 'minute' && that.options.minuteStep > 1 && that.options.roundTime) {
	             v = getNearest(that['$'+k], v);
	           }
	
	           if(k === 'second' && that.options.secondStep > 1 && that.options.roundTime) {
	             v = getNearest(that['$'+k], v);
	           }
	
	           that['$'+k].val(v);
	         }
	       });
	
	        // update days count
	        if (this.options.smartDays) {
	          this.fillCombo('day');
	        }
	
	        this.$element.val(dt.format(this.options.format)).triggerHandler('change');
	      }
	    },
	
	    /*
	     highlight combos if date is invalid
	     */
	     highlight: function(dt) {
	      if(!dt.isValid()) {
	        if(this.options.errorClass) {
	          this.$widget.addClass(this.options.errorClass);
	        } else {
	          //store original border color
	          if(!this.borderColor) {
	            this.borderColor = this.$widget.find('select').css('border-color');
	          }
	          this.$widget.find('select').css('border-color', 'red');
	        }
	      } else {
	        if(this.options.errorClass) {
	          this.$widget.removeClass(this.options.errorClass);
	        } else {
	          this.$widget.find('select').css('border-color', this.borderColor);
	        }
	      }
	    },
	
	    leadZero: function(v) {
	      return v <= 9 ? '0' + v : v;
	    },
	
	    destroy: function() {
	      this.$widget.remove();
	      this.$element.removeData('combodate').show();
	    }
	
	  };
	
	  return {
	    getInstance: function(element, options) {
	      return new Combodate(element, options);
	    }
	  };
	}]);
	
	/*
	Editable icons:
	- default
	- font-awesome
	
	*/
	angular.module('xeditable').factory('editableIcons', function() {
	
	  var icons = {
	    //Icon-set to use, defaults to bootstrap icons
	    default: {
	      'bs2': {
	        ok: 'icon-ok icon-white',
	        cancel: 'icon-remove',
	        clear: 'icon-trash'
	      },
	      'bs3': {
	        ok: 'glyphicon glyphicon-ok',
	        cancel: 'glyphicon glyphicon-remove',
	        clear: 'glyphicon glyphicon-trash'
	      }
	    },
	    external: {
	      'font-awesome': {
	        ok: 'fa fa-check',
	        cancel: 'fa fa-times',
	        clear: 'fa fa-trash'
	      }
	    }
	  };
	
	  return icons;
	});
	
	/* jshint -W086 */
	/*
	Editable themes:
	- default
	- bootstrap 2
	- bootstrap 3
	- semantic-ui
	
	Note: in postrender() `this` is instance of editableController
	*/
	angular.module('xeditable').factory('editableThemes', function() {
	  var themes = {
	    //default
	    'default': {
	      formTpl:      '<form class="editable-wrap"></form>',
	      noformTpl:    '<span class="editable-wrap"></span>',
	      controlsTpl:  '<span class="editable-controls"></span>',
	      inputTpl:     '',
	      errorTpl:     '<div class="editable-error" data-ng-if="$error" data-ng-bind="$error"></div>',
	      buttonsTpl:   '<span class="editable-buttons"></span>',
	      submitTpl:    '<button type="submit">save</button>',
	      cancelTpl:    '<button type="button" ng-click="$form.$cancel()">cancel</button>',
	      resetTpl:    '<button type="reset">clear</button>'
	    },
	
	    //bs2
	    'bs2': {
	      formTpl:     '<form class="form-inline editable-wrap" role="form"></form>',
	      noformTpl:   '<span class="editable-wrap"></span>',
	      controlsTpl: '<div class="editable-controls controls control-group" ng-class="{\'error\': $error}"></div>',
	      inputTpl:    '',
	      errorTpl:    '<div class="editable-error help-block" data-ng-if="$error" data-ng-bind="$error"></div>',
	      buttonsTpl:  '<span class="editable-buttons"></span>',
	      submitTpl:   '<button type="submit" class="btn btn-primary"><span></span></button>',
	      cancelTpl:   '<button type="button" class="btn" ng-click="$form.$cancel()">'+
	                      '<span></span>'+
	                   '</button>',
	      resetTpl:    '<button type="reset" class="btn btn-danger">clear</button>'
	
	    },
	
	    //bs3
	    'bs3': {
	      formTpl:     '<form class="form-inline editable-wrap" role="form"></form>',
	      noformTpl:   '<span class="editable-wrap"></span>',
	      controlsTpl: '<div class="editable-controls form-group" ng-class="{\'has-error\': $error}"></div>',
	      inputTpl:    '',
	      errorTpl:    '<div class="editable-error help-block" data-ng-if="$error" data-ng-bind="$error"></div>',
	      buttonsTpl:  '<span class="editable-buttons"></span>',
	      submitTpl:   '<button type="submit" class="btn btn-primary"><span></span></button>',
	      cancelTpl:   '<button type="button" class="btn btn-default" ng-click="$form.$cancel()">'+
	                     '<span></span>'+
	                   '</button>',
	      resetTpl:    '<button type="reset" class="btn btn-danger">clear</button>',
	
	      //bs3 specific prop to change buttons class: btn-sm, btn-lg
	      buttonsClass: '',
	      //bs3 specific prop to change standard inputs class: input-sm, input-lg
	      inputClass: '',
	      postrender: function() {
	        //apply `form-control` class to std inputs
	        switch(this.directiveName) {
	          case 'editableText':
	          case 'editableSelect':
	          case 'editableTextarea':
	          case 'editableEmail':
	          case 'editableTel':
	          case 'editableNumber':
	          case 'editableUrl':
	          case 'editableSearch':
	          case 'editableDate':
	          case 'editableDatetime':
	          case 'editableBsdate':
	          case 'editableTime':
	          case 'editableMonth':
	          case 'editableWeek':
	          case 'editablePassword':
	          case 'editableDatetimeLocal':
	            this.inputEl.addClass('form-control');
	            if(this.theme.inputClass) {
	              // don`t apply `input-sm` and `input-lg` to select multiple
	              // should be fixed in bs itself!
	              if(this.inputEl.attr('multiple') &&
	                (this.theme.inputClass === 'input-sm' || this.theme.inputClass === 'input-lg')) {
	                  break;
	              }
	              this.inputEl.addClass(this.theme.inputClass);
	            }
	          break;
	          case 'editableCheckbox':
	              this.editorEl.addClass('checkbox');
	        }
	
	        //apply buttonsClass (bs3 specific!)
	        if(this.buttonsEl && this.theme.buttonsClass) {
	          this.buttonsEl.find('button').addClass(this.theme.buttonsClass);
	        }
	      }
	    },
	
	    //semantic-ui
	    'semantic': {
	      formTpl:     '<form class="editable-wrap ui form" ng-class="{\'error\': $error}" role="form"></form>',
	      noformTpl:   '<span class="editable-wrap"></span>',
	      controlsTpl: '<div class="editable-controls ui fluid input" ng-class="{\'error\': $error}"></div>',
	      inputTpl:    '',
	      errorTpl:    '<div class="editable-error ui error message" data-ng-if="$error" data-ng-bind="$error"></div>',
	      buttonsTpl:  '<span class="mini ui buttons"></span>',
	      submitTpl:   '<button type="submit" class="ui primary button"><i class="ui check icon"></i></button>',
	      cancelTpl:   '<button type="button" class="ui button" ng-click="$form.$cancel()">'+
	                      '<i class="ui cancel icon"></i>'+
	                   '</button>',
	      resetTpl:    '<button type="reset" class="ui button">clear</button>'
	    }
	  };
	
	  return themes;
	});


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	/**
	 * Checklist-model
	 * AngularJS directive for list of checkboxes
	 * https://github.com/vitalets/checklist-model
	 * License: MIT http://opensource.org/licenses/MIT
	 */
	
	 /* commonjs package manager support (eg componentjs) */
	 if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	   module.exports = 'checklist-model';
	 }
	
	angular.module('checklist-model', [])
	.directive('checklistModel', ['$parse', '$compile', function($parse, $compile) {
	  // contains
	  function contains(arr, item, comparator) {
	    if (angular.isArray(arr)) {
	      for (var i = arr.length; i--;) {
	        if (comparator(arr[i], item)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  // add
	  function add(arr, item, comparator) {
	    arr = angular.isArray(arr) ? arr : [];
	      if(!contains(arr, item, comparator)) {
	          arr.push(item);
	      }
	    return arr;
	  }
	
	  // remove
	  function remove(arr, item, comparator) {
	    if (angular.isArray(arr)) {
	      for (var i = arr.length; i--;) {
	        if (comparator(arr[i], item)) {
	          arr.splice(i, 1);
	          break;
	        }
	      }
	    }
	    return arr;
	  }
	
	  // http://stackoverflow.com/a/19228302/1458162
	  function postLinkFn(scope, elem, attrs) {
	     // exclude recursion, but still keep the model
	    var checklistModel = attrs.checklistModel;
	    attrs.$set("checklistModel", null);
	    // compile with `ng-model` pointing to `checked`
	    $compile(elem)(scope);
	    attrs.$set("checklistModel", checklistModel);
	
	    // getter for original model
	    var checklistModelGetter = $parse(checklistModel);
	    var checklistChange = $parse(attrs.checklistChange);
	    var checklistBeforeChange = $parse(attrs.checklistBeforeChange);
	    var ngModelGetter = $parse(attrs.ngModel);
	
	
	
	    var comparator = function (a, b) {
	      if(!isNaN(a) && !isNaN(b)) {
	        return String(a) === String(b);
	      } else {
	        return angular.equals(a,b);
	      }
	    };
	
	    if (attrs.hasOwnProperty('checklistComparator')){
	      if (attrs.checklistComparator[0] == '.') {
	        var comparatorExpression = attrs.checklistComparator.substring(1);
	        comparator = function (a, b) {
	          return a[comparatorExpression] === b[comparatorExpression];
	        };
	
	      } else {
	        comparator = $parse(attrs.checklistComparator)(scope.$parent);
	      }
	    }
	
	    // watch UI checked change
	    var unbindModel = scope.$watch(attrs.ngModel, function(newValue, oldValue) {
	      if (newValue === oldValue) {
	        return;
	      }
	
	      if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
	        ngModelGetter.assign(scope, contains(checklistModelGetter(scope.$parent), getChecklistValue(), comparator));
	        return;
	      }
	
	      setValueInChecklistModel(getChecklistValue(), newValue);
	
	      if (checklistChange) {
	        checklistChange(scope);
	      }
	    });
	
	    // watches for value change of checklistValue
	    var unbindCheckListValue = scope.$watch(getChecklistValue, function(newValue, oldValue) {
	      if( newValue != oldValue && angular.isDefined(oldValue) && scope[attrs.ngModel] === true ) {
	        var current = checklistModelGetter(scope.$parent);
	        checklistModelGetter.assign(scope.$parent, remove(current, oldValue, comparator));
	        checklistModelGetter.assign(scope.$parent, add(current, newValue, comparator));
	      }
	    }, true);
	
	    var unbindDestroy = scope.$on('$destroy', destroy);
	
	    function destroy() {
	      unbindModel();
	      unbindCheckListValue();
	      unbindDestroy();
	    }
	
	    function getChecklistValue() {
	      return attrs.checklistValue ? $parse(attrs.checklistValue)(scope.$parent) : attrs.value;
	    }
	
	    function setValueInChecklistModel(value, checked) {
	      var current = checklistModelGetter(scope.$parent);
	      if (angular.isFunction(checklistModelGetter.assign)) {
	        if (checked === true) {
	          checklistModelGetter.assign(scope.$parent, add(current, value, comparator));
	        } else {
	          checklistModelGetter.assign(scope.$parent, remove(current, value, comparator));
	        }
	      }
	
	    }
	
	    // declare one function to be used for both $watch functions
	    function setChecked(newArr, oldArr) {
	      if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
	        setValueInChecklistModel(getChecklistValue(), ngModelGetter(scope));
	        return;
	      }
	      ngModelGetter.assign(scope, contains(newArr, getChecklistValue(), comparator));
	    }
	
	    // watch original model change
	    // use the faster $watchCollection method if it's available
	    if (angular.isFunction(scope.$parent.$watchCollection)) {
	        scope.$parent.$watchCollection(checklistModel, setChecked);
	    } else {
	        scope.$parent.$watch(checklistModel, setChecked, true);
	    }
	  }
	
	  return {
	    restrict: 'A',
	    priority: 1000,
	    terminal: true,
	    scope: true,
	    compile: function(tElement, tAttrs) {
	
	      if (!tAttrs.checklistValue && !tAttrs.value) {
	        throw 'You should provide `value` or `checklist-value`.';
	      }
	
	      // by default ngModel is 'checked', so we set it if not specified
	      if (!tAttrs.ngModel) {
	        // local scope var storing individual checkbox model
	        tAttrs.$set("ngModel", "checked");
	      }
	
	      return postLinkFn;
	    }
	  };
	}]);


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(24);
	__webpack_require__(25);
	__webpack_require__(26);
	module.exports = 'dialogs.main';


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	/**
	 * angular-dialog-service - A service to handle common dialog types in a web application.  Built on top of Angular-Bootstrap's modal
	 * @version v5.3.0
	 * @author Michael Conroy, michael.e.conroy@gmail.com
	 * @license MIT, http://www.opensource.org/licenses/MIT
	 */
	(function(){
	"use strict";
	//== Translate Substitute Module =============================================//
	
	/**
	 * For those not using Angular-Translate (pascalprecht.translate), this will sub
	 * in for it so we don't have to include Angular-Translate if we don't want to.
	 */
	
	var translateSubMod = angular.module('translate.sub',[]);
	
		/**
		 * $translate Service
		 * Sets up a $translateProvider service to use in your module's config
		 * function.  $translate.Provider syntax is the same as Angular-Translate,
		 * use $translate.Provider.translations(lang,obj) to change the defaults
		 * for modal button, header and message text.
		 */
		translateSubMod.provider('$translate',[function(){
			var _translations = []; // object of key/value translation pairs
			var _current = 'en-US'; // default language
	
			/**
			 * Translations
			 * Set the internal object of translation key/value pairs.
			 */
			this.translations = function(lang,obj){
				if(angular.isDefined(lang) && angular.isDefined(obj)){
					_translations[lang] = angular.copy(obj);
					_current = lang;
				}
			}; // end translations
	
			this.$get = [function(){
				return {
					/**
					 * Instant
					 * Retrieve the translation for the given key, if key not found
					 * return an empty string.
					 * Example: $translate.instant('DIALOGS_OK');
					 */
					instant : function(what){
						if(angular.isDefined(what) && angular.isDefined(_translations[_current][what]))
							return _translations[_current][what];
						else
							return '';
					} // end instant
				}; // end return 
			}]; // end $get
	
		}]); // end $translate
	
		/**
		 * Translate Filter
		 * For use in an Angular template.  
		 * Example: {{"DIALOGS_CLOSE" | translate}}
		 */
		translateSubMod.filter('translate',['$translate',function($translate){
			return function(what){
				return $translate.instant(what);
			};
		}]); // end translate / translate.sub
	//== Controllers =============================================================//
	
	var ctrlrs; // will be dialogs.controllers module
	
	// determine if Angular-Translate is available, if not use the substitute
	try{
		angular.module('pascalprecht.translate'); // throws error if module not loaded
		// console.log('Dialogs (Angular-Translate): OK');
		
		// dialogs.controllers: module declaration
		ctrlrs = angular.module('dialogs.controllers',['ui.bootstrap.modal','pascalprecht.translate']);
	}catch(err){
		// console.log('Dialogs: (Angular-Translate): ' + err.message);
		// console.log('Dialogs: Attempting to use translate.sub module.');
	
		// dialogs.controllers: module declaration
		ctrlrs = angular.module('dialogs.controllers',['ui.bootstrap.modal','translate.sub']);
	} // end try/catch
	
	// angular.module('dialogs.controllers',['ui.bootstrap.modal','pascalprecht.translate'])
	
	/**
	 * Error Dialog Controller 
	 */
	ctrlrs.controller('errorDialogCtrl',['$scope','$uibModalInstance','$translate','data',function($scope,$uibModalInstance,$translate,data){
		//-- Variables -----//
	
		$scope.header = (angular.isDefined(data.header)) ? data.header : $translate.instant('DIALOGS_ERROR');
		$scope.msg = (angular.isDefined(data.msg)) ? data.msg : $translate.instant('DIALOGS_ERROR_MSG');
		$scope.icon = (angular.isDefined(data.fa) && angular.equals(data.fa,true)) ? 'fa fa-warning' : 'glyphicon glyphicon-warning-sign';
	
		//-- Methods -----//
		
		$scope.close = function(){
			$uibModalInstance.close();
			$scope.$destroy();
		}; // end close
	}]); // end ErrorDialogCtrl
		
	/**
	 * Wait Dialog Controller 
	 */
	ctrlrs.controller('waitDialogCtrl',['$scope','$uibModalInstance','$translate','$timeout','data',function($scope,$uibModalInstance,$translate,$timeout,data){
		//-- Variables -----//
	
		$scope.header = (angular.isDefined(data.header)) ? data.header : $translate.instant('DIALOGS_PLEASE_WAIT_ELIPS');
		$scope.msg = (angular.isDefined(data.msg)) ? data.msg : $translate.instant('DIALOGS_PLEASE_WAIT_MSG');
		$scope.progress = (angular.isDefined(data.progress)) ? data.progress : 100;
		$scope.icon = (angular.isDefined(data.fa) && angular.equals(data.fa,true)) ? 'fa fa-clock-o' : 'glyphicon glyphicon-time';
	
		//-- Listeners -----//
		
		// Note: used $timeout instead of $scope.$apply() because I was getting a $$nextSibling error
		
		// close wait dialog
		$scope.$on('dialogs.wait.complete',function(){
			$timeout(function(){ $uibModalInstance.close(); $scope.$destroy(); });
		}); // end on(dialogs.wait.complete)
		
		// update the dialog's message
		$scope.$on('dialogs.wait.message',function(evt,args){
			$scope.msg = (angular.isDefined(args.msg)) ? args.msg : $scope.msg;
		}); // end on(dialogs.wait.message)
		
		// update the dialog's progress (bar) and/or message
		$scope.$on('dialogs.wait.progress',function(evt,args){
			$scope.msg = (angular.isDefined(args.msg)) ? args.msg : $scope.msg;
			$scope.progress = (angular.isDefined(args.progress)) ? args.progress : $scope.progress;
		}); // end on(dialogs.wait.progress)
		
		//-- Methods -----//
	
		$scope.getProgress = function(){
			return {'width': $scope.progress + '%'};
		}; // end getProgress
		
	}]); // end WaitDialogCtrl
	
	/**
	 * Notify Dialog Controller 
	 */
	ctrlrs.controller('notifyDialogCtrl',['$scope','$uibModalInstance','$translate','data',function($scope,$uibModalInstance,$translate,data){
		//-- Variables -----//
	
		$scope.header = (angular.isDefined(data.header)) ? data.header : $translate.instant('DIALOGS_NOTIFICATION');
		$scope.msg = (angular.isDefined(data.msg)) ? data.msg : $translate.instant('DIALOGS_NOTIFICATION_MSG');
		$scope.icon = (angular.isDefined(data.fa) && angular.equals(data.fa,true)) ? 'fa fa-info' : 'glyphicon glyphicon-info-sign';
	
		//-- Methods -----//
		
		$scope.close = function(){
			$uibModalInstance.close();
			$scope.$destroy();
		}; // end close
	}]); // end WaitDialogCtrl
	
	/**
	 * Confirm Dialog Controller 
	 */
	ctrlrs.controller('confirmDialogCtrl',['$scope','$uibModalInstance','$translate','data',function($scope,$uibModalInstance,$translate,data){
		//-- Variables -----//
	
		$scope.header = (angular.isDefined(data.header)) ? data.header : $translate.instant('DIALOGS_CONFIRMATION');
		$scope.msg = (angular.isDefined(data.msg)) ? data.msg : $translate.instant('DIALOGS_CONFIRMATION_MSG');
		$scope.icon = (angular.isDefined(data.fa) && angular.equals(data.fa,true)) ? 'fa fa-check' : 'glyphicon glyphicon-check';
	
		//-- Methods -----//
		
		$scope.no = function(){
			$uibModalInstance.dismiss('no');
		}; // end close
		
		$scope.yes = function(){
			$uibModalInstance.close('yes');
		}; // end yes
	}]); // end ConfirmDialogCtrl / dialogs.controllers
	//== Services ================================================================//
	
	angular.module('dialogs.services',['ui.bootstrap.modal','dialogs.controllers'])
	
		.provider('dialogs',[function(){
			var _b = true; // backdrop
			var _k = true; // keyboard
			var _w = 'dialogs-default'; // windowClass
			var _bdc = 'dialogs-backdrop-default'; // backdropClass
			var _copy = true; // controls use of angular.copy
			var _wTmpl = null; // window template
			var _wSize = 'lg'; // large modal window default
			var _animation = false; // true/false to use animation
	
			var _fa = false; // fontawesome flag
	
			var _setOpts = function(opts){
				var _opts = {};
				opts = opts || {};
				_opts.kb = (angular.isDefined(opts.keyboard)) ? !!opts.keyboard : _k; // values: true,false
				_opts.bd = (angular.isDefined(opts.backdrop)) ? opts.backdrop : _b; // values: 'static',true,false
				_opts.bdc = (angular.isDefined(opts.backdropClass)) ? opts.backdropClass : _bdc; // additional CSS class(es) to be added to the modal backdrop
				_opts.ws = (angular.isDefined(opts.size) && ((opts.size === 'sm') || (opts.size === 'lg') || (opts.size === 'md'))) ? opts.size : _wSize; // values: 'sm', 'lg', 'md'
				_opts.wc = (angular.isDefined(opts.windowClass)) ? opts.windowClass : _w; // additional CSS class(es) to be added to a modal window
				_opts.anim = (angular.isDefined(opts.animation)) ? !!opts.animation : _animation; // values: true,false
				return _opts;
			}; // end _setOpts
	
			/**
			 * Use Backdrop
			 *
			 * Sets the use of the modal backdrop.  Either to have one or not and
			 * whether or not it responds to mouse clicks ('static' sets the
			 * backdrop to true and does not respond to mouse clicks).
			 *
			 * @param	val 	mixed	(true, false, 'static')
			 */
			this.useBackdrop = function(val){ // possible values : true, false, 'static'
				if(angular.isDefined(val))
					_b = val;
			}; // end useStaticBackdrop
	
			/**
			 * Use ESC Close
			 *
			 * Sets the use of the ESC (escape) key to close modal windows.
			 *
			 * @param	val 	boolean
			 */
			this.useEscClose = function(val){ // possible values : true, false
				if(angular.isDefined(val))
					_k = (!angular.equals(val,0) && !angular.equals(val,'false') && !angular.equals(val,'no') && !angular.equals(val,null) && !angular.equals(val,false)) ? true : false;
			}; // end useESCClose
	
			/**
			 * Use Class
			 *
			 * Sets the additional CSS window class of the modal window template.
			 *
			 * @param	val 	string
			 */
			this.useClass = function(val){
				if(angular.isDefined(val))
					_w = val;
			}; // end useClass
	
			/**
			 * Use Copy
			 *
			 * Determines the use of angular.copy when sending data to the modal controller.
			 *
			 * @param	val 	boolean
			 */
			this.useCopy = function(val){
				if(angular.isDefined(val))
					_copy = (!angular.equals(val,0) && !angular.equals(val,'false') && !angular.equals(val,'no') && !angular.equals(val,null) && !angular.equals(val,false)) ? true : false;
			}; // end useCopy
	
			/**
			 * Set Window Template
			 *
			 * Sets a path to a template to use overriding modal's window template.
			 *
			 * @param	val 	string
			 */
			this.setWindowTmpl = function(val){
				if(angular.isDefined(val))
					_wTmpl = val;
			}; // end setWindowTmpl
	
			/**
			 * Set Size
			 *
			 * Sets the modal size to use (sm,lg,md)
			 *
			 * @param	val 	string (sm,lg,md)
			 */
			this.setSize = function(val){
				if(angular.isDefined(val))
					_wSize = (angular.equals(val,'sm') || angular.equals(val,'lg') || angular.equals(val,'md')) ? val : _wSize;
			}; // end setSize
	
			/**
			 * Use Animations
			 *
			 * Sets the use of animations to true
			 */
			 this.useAnimation = function(){
			 	_animation = true;
			 }; // end useAnimation
	
			/**
			 * Use Font-Awesome.
			 *
			 * Sets Font-Awesome flag to true and substitutes font-awesome icons for
			 * Bootstrap's glyphicons.
			 */
			this.useFontAwesome = function(){
				_fa = true;
			}; // end useFontAwesome
	
	
			this.$get = ['$uibModal',function ($uibModal){
	
				return {
					/**
					 * Error Dialog
					 *
					 * @param	header 	string
					 * @param	msg 	string
					 * @param	opts	object
					 */
					error : function(header,msg,opts){
						opts = _setOpts(opts);
	
						return $uibModal.open({
							templateUrl : '/dialogs/error.html',
							controller : 'errorDialogCtrl',
							backdrop: opts.bd,
							backdropClass: opts.bdc,
							keyboard: opts.kb,
							windowClass: opts.wc,
							size: opts.ws,
							animation: opts.anim,
							resolve : {
								data : function(){
									return {
										header : angular.copy(header),
										msg : angular.copy(msg),
										fa : _fa
									};
								}
							}
						}); // end modal.open
					}, // end error
	
					/**
					 * Wait Dialog
					 *
					 * @param	header 		string
					 * @param	msg 		string
					 * @param	progress 	int
					 * @param	opts	object
					 */
					wait : function(header,msg,progress,opts){
						opts = _setOpts(opts);
	
						return $uibModal.open({
							templateUrl : '/dialogs/wait.html',
							controller : 'waitDialogCtrl',
							backdrop: opts.bd,
							backdropClass: opts.bdc,
							keyboard: opts.kb,
							windowClass: opts.wc,
							size: opts.ws,
							animation: opts.anim,
							resolve : {
								data : function(){
									return {
										header : angular.copy(header),
										msg : angular.copy(msg),
										progress : angular.copy(progress),
										fa : _fa
									};
								}
							}
						}); // end modal.open
					}, // end wait
	
					/**
					 * Notify Dialog
					 *
					 * @param	header 		string
					 * @param	msg 		string
					 * @param	opts	object
					 */
					notify : function(header,msg,opts){
						opts = _setOpts(opts);
	
						return $uibModal.open({
							templateUrl : '/dialogs/notify.html',
							controller : 'notifyDialogCtrl',
							backdrop: opts.bd,
							backdropClass: opts.bdc,
							keyboard: opts.kb,
							windowClass: opts.wc,
							size: opts.ws,
							animation: opts.anim,
							resolve : {
								data : function(){
									return {
										header : angular.copy(header),
										msg : angular.copy(msg),
										fa : _fa
									};
								}
							}
						}); // end modal.open
					}, // end notify
	
					/**
					 * Confirm Dialog
					 *
					 * @param	header 	string
					 * @param	msg 	string
					 * @param	opts	object
					 */
					confirm : function(header,msg,opts){
						opts = _setOpts(opts);
	
						return $uibModal.open({
							templateUrl : '/dialogs/confirm.html',
							controller : 'confirmDialogCtrl',
							backdrop: opts.bd,
							backdropClass: opts.bdc,
							keyboard: opts.kb,
							windowClass: opts.wc,
							size: opts.ws,
							animation: opts.anim,
							resolve : {
								data : function(){
									return {
										header : angular.copy(header),
										msg : angular.copy(msg),
										fa : _fa
									};
								}
							}
						}); // end modal.open
					}, // end confirm
	
					/**
					 * Create Custom Dialog
					 *
					 * @param	url 	string
					 * @param	ctrlr 	string
					 * @param	data 	object
					 * @param	opts	object
					 */
					create : function(url,ctrlr,data,opts,ctrlAs){
						var copy = (opts && angular.isDefined(opts.copy)) ? opts.copy : _copy;
						opts = _setOpts(opts);
	
						return $uibModal.open({
							templateUrl : url,
							controller : ctrlr,
							controllerAs : ctrlAs,
							keyboard : opts.kb,
							backdrop : opts.bd,
							backdropClass: opts.bdc,
							windowClass: opts.wc,
							size: opts.ws,
							animation: opts.anim,
							resolve : {
								data : function() {
									if(copy)
										return angular.copy(data);
									else
										return data;
								}
							}
						}); // end modal.open
					} // end create
	
				}; // end return
	
			}]; // end $get
		}]); // end provider dialogs
	//== Dialogs.Main Module =====================================================//
	
	/**
	 * Include this module 'dialogs.main' in your module's dependency list where you
	 * intend to use it.  Then inject the 'dialogs' service in your controllers that
	 * need it.
	 */
	
	angular.module('dialogs.main',['dialogs.services','ngSanitize']) // requires angular-sanitize.min.js (ngSanitize) //code.angularjs.org/1.2.1/angular-sanitize.min.js
			
		.config(['$translateProvider','dialogsProvider',function($translateProvider,dialogsProvider){
			/** 
			 * if Angular-Translate is not loaded, use the translate substitute
			 * module and create default translations to use as default modal texts
			 */
			try{
				angular.module('pascalprecht.translate');
			}catch(err){
				// console.log('Dialogs: Creating default translations for use without Angular-Translate.');
	
				// This will set default modal buttons, header and message text
				$translateProvider.translations('en-US',{
		            DIALOGS_ERROR: "Error",
		            DIALOGS_ERROR_MSG: "An unknown error has occurred.",
		            DIALOGS_CLOSE: "Close",
		            DIALOGS_PLEASE_WAIT: "Please Wait",
		            DIALOGS_PLEASE_WAIT_ELIPS: "Please Wait...",
		            DIALOGS_PLEASE_WAIT_MSG: "Waiting on operation to complete.",
		            DIALOGS_PERCENT_COMPLETE: "% Complete",
		            DIALOGS_NOTIFICATION: "Notification",
		            DIALOGS_NOTIFICATION_MSG: "Unknown application notification.",
		            DIALOGS_CONFIRMATION: "Confirmation",
		            DIALOGS_CONFIRMATION_MSG: "Confirmation required.",
		            DIALOGS_OK: "OK",
		            DIALOGS_YES: "Yes",
		            DIALOGS_NO: "No"
	        	});
			} // end try/catch
	
			/**
			 * Attempt to ascertain if page is using Font Awesome instead of the
			 * regular Bootstrap Icons.  If you are changing the stylesheet name or
			 * not including it from a CDN or have included Font-Awesome as a 
			 * concatentation of CSS sheets together, then you will have to manually
			 * set Font-Awesome usage in your Angular Module's config by including
			 * the $dialogsProvider and calling the method $dialogsProvider.useFontAwesome().
			 */
			 try{
			 	var _sheets = document.styleSheets;
	
			 	sheetLoop:
			 	for(var i = (_sheets.length - 1);i >= 0;i--){
			 		var _matches = null;
			 		var _rules = null;
	
			 		if(!_sheets[i].disabled){
				 		// check href of style sheet first
				 		if(_sheets[i].href !== null)
				 			_matches = _sheets[i].href.match(/font\-*awesome/i);
	
				 		if(angular.isArray(_matches)){
				 			dialogsProvider.useFontAwesome();
				 			break; // done, leave the style sheet for loop
				 		}else{
				 			// try to find css rule .fa, in case style sheet has been concatenated
				 			_rules = _sheets[i].cssRules;
				 			for(var x = (_rules.length - 1);x >= 0;x--){
				 				if(typeof(_rules[x].selectorText) === 'string' && _rules[x].selectorText.toLowerCase() === '.fa'){
				 					dialogsProvider.useFontAwesome();
				 					break sheetLoop; // done, exit both for loops
				 				}
				 			}
				 		}
				 	} // end if(disabled)
			 	} // end for
			 }catch(err){
			 	// console.log('Error Message: ' + err);
			 }
		}]) // end config
	
		// Add default templates via $templateCache
		.run(['$templateCache','$interpolate',function($templateCache,$interpolate){
	    
	    	// get interpolation symbol (possible that someone may have changed it in their application instead of using '{{}}')
	    	var startSym = $interpolate.startSymbol();
	    	var endSym = $interpolate.endSymbol();
	    
	    	$templateCache.put('/dialogs/error.html','<div class="modal-header dialog-header-error"><button type="button" class="close" ng-click="close()">&times;</button><h4 class="modal-title text-danger"><span class="'+startSym+'icon'+endSym+'"></span> <span ng-bind-html="header"></span></h4></div><div class="modal-body text-danger" ng-bind-html="msg"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="close()">'+startSym+'"DIALOGS_CLOSE" | translate'+endSym+'</button></div>');
	    	$templateCache.put('/dialogs/wait.html','<div class="modal-header dialog-header-wait"><h4 class="modal-title"><span class="'+startSym+'icon'+endSym+'"></span> '+startSym+'header'+endSym+'</h4></div><div class="modal-body"><p ng-bind-html="msg"></p><div class="progress progress-striped active"><div class="progress-bar progress-bar-info" ng-style="getProgress()"></div><span class="sr-only">'+startSym+'progress'+endSym+''+startSym+'"DIALOGS_PERCENT_COMPLETE" | translate'+endSym+'</span></div></div>');
	    	$templateCache.put('/dialogs/notify.html','<div class="modal-header dialog-header-notify"><button type="button" class="close" ng-click="close()" class="pull-right">&times;</button><h4 class="modal-title text-info"><span class="'+startSym+'icon'+endSym+'"></span> '+startSym+'header'+endSym+'</h4></div><div class="modal-body text-info" ng-bind-html="msg"></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="close()">'+startSym+'"DIALOGS_OK" | translate'+endSym+'</button></div>');
	    	$templateCache.put('/dialogs/confirm.html','<div class="modal-header dialog-header-confirm"><button type="button" class="close" ng-click="no()">&times;</button><h4 class="modal-title"><span class="'+startSym+'icon'+endSym+'"></span> '+startSym+'header'+endSym+'</h4></div><div class="modal-body" ng-bind-html="msg"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="yes()">'+startSym+'"DIALOGS_YES" | translate'+endSym+'</button><button type="button" class="btn btn-primary" ng-click="no()">'+startSym+'"DIALOGS_NO" | translate'+endSym+'</button></div>');
		}]); // end run / dialogs.main
	
	})();

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	/**
	 * angular-dialog-service - A service to handle common dialog types in a web application.  Built on top of Angular-Bootstrap's modal
	 * @version v5.3.0
	 * @author Michael Conroy, michael.e.conroy@gmail.com
	 * @license MIT, http://www.opensource.org/licenses/MIT
	 */
	/**
	 * Dialog Default Translations.
	 *
	 * Include this module if you're not already using angular-translate in your application, and
	 * add it to your application module's dependency list in order to get default header and
	 * dialog messages to appear.
	 *
	 * Ex: var myApp = angular.module('myApplication',['dialogs.main','dialogs.default-translations']);
	 *
	 * It was necessary to separate this out for those already using angular-translate because this would
	 * automatically reset their translation list for 'en-US'
	 *
	 * For those already using angular-translate, just copy the list of DIALOG_[..] translations to your
	 * translation list where you set 'en-US' using the $translateProvider.
	 */
	
	//== Translations =============================================================//
	
	 angular.module('dialogs.default-translations',['pascalprecht.translate'])
	 /**
	     * Default translations in English.
	     *
	     * Use angular-translate's $translateProvider to provide translations in an
	     * alternate language.
	     *
	     * $translateProvider.translations('[lang]',{[translations]});
	     * To use alternate translations set the preferred language to your desired
	     * language.
	     * $translateProvider.preferredLanguage('[lang]');
	     */
	    .config(['$translateProvider',function($translateProvider){
	        $translateProvider.translations('de-DE',{
	            DIALOGS_ERROR: "Error",
	            DIALOGS_ERROR_MSG: "Ein unbekannter Fehler ist aufgetreten.",
	            DIALOGS_CLOSE: "Schließen",
	            DIALOGS_PLEASE_WAIT: "Bitte warten",
	            DIALOGS_PLEASE_WAIT_ELIPS: "Bitte warten...",
	            DIALOGS_PLEASE_WAIT_MSG: "Warte auf Fertigstellung der Operation.",
	            DIALOGS_PERCENT_COMPLETE: "% fertig",
	            DIALOGS_NOTIFICATION: "Benachrichtigung",
	            DIALOGS_NOTIFICATION_MSG: "Unbekannte Anwendungsbenachrichtigung.",
	            DIALOGS_CONFIRMATION: "Bestätigung",
	            DIALOGS_CONFIRMATION_MSG: "Bestätigung erforderlich.",
	            DIALOGS_OK: "OK",
	            DIALOGS_YES: "Ja",
	            DIALOGS_NO: "Nein"
	        });
	        
	        $translateProvider.translations('en-US',{
	            DIALOGS_ERROR: "Error",
	            DIALOGS_ERROR_MSG: "An unknown error has occurred.",
	            DIALOGS_CLOSE: "Close",
	            DIALOGS_PLEASE_WAIT: "Please Wait",
	            DIALOGS_PLEASE_WAIT_ELIPS: "Please Wait...",
	            DIALOGS_PLEASE_WAIT_MSG: "Waiting on operation to complete.",
	            DIALOGS_PERCENT_COMPLETE: "% Complete",
	            DIALOGS_NOTIFICATION: "Notification",
	            DIALOGS_NOTIFICATION_MSG: "Unknown application notification.",
	            DIALOGS_CONFIRMATION: "Confirmation",
	            DIALOGS_CONFIRMATION_MSG: "Confirmation required.",
	            DIALOGS_OK: "OK",
	            DIALOGS_YES: "Yes",
	            DIALOGS_NO: "No"
	        });
	        
	        $translateProvider.translations('es-ES',{
	            DIALOGS_ERROR: "Error",
	            DIALOGS_ERROR_MSG: "Se ha producido un error.",
	            DIALOGS_CLOSE: "Cerrar",
	            DIALOGS_PLEASE_WAIT: "Espere por favor",
	            DIALOGS_PLEASE_WAIT_ELIPS: "Espere por favor...",
	            DIALOGS_PLEASE_WAIT_MSG: "Completando operación.",
	            DIALOGS_PERCENT_COMPLETE: "% Completado",
	            DIALOGS_NOTIFICATION: "Notificación",
	            DIALOGS_NOTIFICATION_MSG: "Notificación de una aplicación desconocida.",
	            DIALOGS_CONFIRMATION: "Confirmación",
	            DIALOGS_CONFIRMATION_MSG: "Se requiere confirmacion.",
	            DIALOGS_OK: "Aceptar",
	            DIALOGS_YES: "Sí",
	            DIALOGS_NO: "No"
	        });
	        
	        $translateProvider.translations("fr-FR", {
	            DIALOGS_ERROR: "Erreur",
	            DIALOGS_ERROR_MSG: "Une erreur inconnue s'est produite.",
	            DIALOGS_CLOSE: "Fermer",
	            DIALOGS_PLEASE_WAIT: "Patientez svp",
	            DIALOGS_PLEASE_WAIT_ELIPS: "Patienter svp...",
	            DIALOGS_PLEASE_WAIT_MSG: "En attente de la fin de l'opération.",
	            DIALOGS_PERCENT_COMPLETE: "% Terminer",
	            DIALOGS_NOTIFICATION: "Notification",
	            DIALOGS_NOTIFICATION_MSG: "Notification de l'application inconnue",
	            DIALOGS_CONFIRMATION: "Confirmer",
	            DIALOGS_CONFIRMATION_MSG: "Merci de confirmer",
	            DIALOGS_OK: "OK",
	            DIALOGS_YES: "Oui",
	            DIALOGS_NO: "Non"
	        });
	        
	        $translateProvider.translations('pt-BR',{
	            DIALOGS_ERROR: "Erro",
	            DIALOGS_ERROR_MSG: "Ocorreu um erro inesperado.",
	            DIALOGS_CLOSE: "Fechar",
	            DIALOGS_PLEASE_WAIT: "Por favor aguarde",
	            DIALOGS_PLEASE_WAIT_ELIPS: "Por favor aguarde...",
	            DIALOGS_PLEASE_WAIT_MSG: "Aguardando que a operação termine.",
	            DIALOGS_PERCENT_COMPLETE: "% Completados",
	            DIALOGS_NOTIFICATION: "Notificação",
	            DIALOGS_NOTIFICATION_MSG: "Notificação de aplicação desconhecida.",
	            DIALOGS_CONFIRMATION: "Confirmação",
	            DIALOGS_CONFIRMATION_MSG: "Confirmação requerida.",
	            DIALOGS_OK: "OK",
	            DIALOGS_YES: "Sim",
	            DIALOGS_NO: "Não"
	        });
	
	        $translateProvider.translations('zh-CN',{
	            DIALOGS_ERROR: "错误",
	            DIALOGS_ERROR_MSG: "出现未知错误。",
	            DIALOGS_CLOSE: "关闭",
	            DIALOGS_PLEASE_WAIT: "请稍候",
	            DIALOGS_PLEASE_WAIT_ELIPS: "请稍候...",
	            DIALOGS_PLEASE_WAIT_MSG: "请等待操作完成。",
	            DIALOGS_PERCENT_COMPLETE: "% 已完成",
	            DIALOGS_NOTIFICATION: "通知",
	            DIALOGS_NOTIFICATION_MSG: "未知应用程序的通知。",
	            DIALOGS_CONFIRMATION: "确认",
	            DIALOGS_CONFIRMATION_MSG: "确认要求。",
	            DIALOGS_OK: "确定",
	            DIALOGS_YES: "确认",
	            DIALOGS_NO: "取消"
	        });
	
	        $translateProvider.preferredLanguage('en-US');
	    }]); // end config


/***/ }),
/* 26 */
5,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(32);
	module.exports = 'validation.match';


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	/*!
	 * angular-validation-match
	 * Checks if one input matches another
	 * @version v1.9.0
	 * @link https://github.com/TheSharpieOne/angular-validation-match
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(window, angular, undefined){'use strict';
	
	match.$inject = ["$parse"];
	angular.module('validation.match', []);
	
	angular.module('validation.match').directive('match', match);
	
	function match ($parse) {
	    return {
	        require: '?ngModel',
	        restrict: 'A',
	        link: function(scope, elem, attrs, ctrl) {
	            if(!ctrl || !attrs.match) {
	                return;
	            }
	
	            var matchGetter = $parse(attrs.match);
	            var caselessGetter = $parse(attrs.matchCaseless);
	            var noMatchGetter = $parse(attrs.notMatch);
	            var matchIgnoreEmptyGetter = $parse(attrs.matchIgnoreEmpty);
	
	            scope.$watch(getMatchValue, function(){
	                ctrl.$$parseAndValidate();
	            });
	
	            ctrl.$validators.match = function(modelValue, viewValue){
	              var matcher = modelValue || viewValue;
	              var match = getMatchValue();
	              var notMatch = noMatchGetter(scope);
	              var value;
	
	              if (matchIgnoreEmptyGetter(scope) && !viewValue) {
	                return true;
	              }
	
	              if(caselessGetter(scope)){
	                value = angular.lowercase(matcher) === angular.lowercase(match);
	              }else{
	                value = matcher === match;
	              }
	              /*jslint bitwise: true */
	              value ^= notMatch;
	              /*jslint bitwise: false */
	              return !!value;
	            };
	
	            function getMatchValue(){
	                var match = matchGetter(scope);
	                if(angular.isObject(match) && match.hasOwnProperty('$viewValue')){
	                    match = match.$viewValue;
	                }
	                return match;
	            }
	        }
	    };
	}
	})(window, window.angular);


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(34);
	module.exports = 'ngFileUpload';

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	/**!
	 * AngularJS file upload directives and services. Supports: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * FileAPI Flash shim for old browsers not supporting FormData
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */
	
	(function () {
	  /** @namespace FileAPI.noContentTimeout */
	
	  function patchXHR(fnName, newFn) {
	    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
	  }
	
	  function redefineProp(xhr, prop, fn) {
	    try {
	      Object.defineProperty(xhr, prop, {get: fn});
	    } catch (e) {/*ignore*/
	    }
	  }
	
	  if (!window.FileAPI) {
	    window.FileAPI = {};
	  }
	
	  if (!window.XMLHttpRequest) {
	    throw 'AJAX is not supported. XMLHttpRequest is not defined.';
	  }
	
	  FileAPI.shouldLoad = !window.FormData || FileAPI.forceLoad;
	  if (FileAPI.shouldLoad) {
	    var initializeUploadListener = function (xhr) {
	      if (!xhr.__listeners) {
	        if (!xhr.upload) xhr.upload = {};
	        xhr.__listeners = [];
	        var origAddEventListener = xhr.upload.addEventListener;
	        xhr.upload.addEventListener = function (t, fn) {
	          xhr.__listeners[t] = fn;
	          if (origAddEventListener) origAddEventListener.apply(this, arguments);
	        };
	      }
	    };
	
	    patchXHR('open', function (orig) {
	      return function (m, url, b) {
	        initializeUploadListener(this);
	        this.__url = url;
	        try {
	          orig.apply(this, [m, url, b]);
	        } catch (e) {
	          if (e.message.indexOf('Access is denied') > -1) {
	            this.__origError = e;
	            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
	          }
	        }
	      };
	    });
	
	    patchXHR('getResponseHeader', function (orig) {
	      return function (h) {
	        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : (orig == null ? null : orig.apply(this, [h]));
	      };
	    });
	
	    patchXHR('getAllResponseHeaders', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('abort', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('setRequestHeader', function (orig) {
	      return function (header, value) {
	        if (header === '__setXHR_') {
	          initializeUploadListener(this);
	          var val = value(this);
	          // fix for angular < 1.2.0
	          if (val instanceof Function) {
	            val(this);
	          }
	        } else {
	          this.__requestHeaders = this.__requestHeaders || {};
	          this.__requestHeaders[header] = value;
	          orig.apply(this, arguments);
	        }
	      };
	    });
	
	    patchXHR('send', function (orig) {
	      return function () {
	        var xhr = this;
	        if (arguments[0] && arguments[0].__isFileAPIShim) {
	          var formData = arguments[0];
	          var config = {
	            url: xhr.__url,
	            jsonp: false, //removes the callback form param
	            cache: true, //removes the ?fileapiXXX in the url
	            complete: function (err, fileApiXHR) {
	              if (err && angular.isString(err) && err.indexOf('#2174') !== -1) {
	                // this error seems to be fine the file is being uploaded properly.
	                err = null;
	              }
	              xhr.__completed = true;
	              if (!err && xhr.__listeners.load)
	                xhr.__listeners.load({
	                  type: 'load',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (!err && xhr.__listeners.loadend)
	                xhr.__listeners.loadend({
	                  type: 'loadend',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (err === 'abort' && xhr.__listeners.abort)
	                xhr.__listeners.abort({
	                  type: 'abort',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
	                return (fileApiXHR.status === 0 && err && err !== 'abort') ? 500 : fileApiXHR.status;
	              });
	              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
	                return fileApiXHR.statusText;
	              });
	              redefineProp(xhr, 'readyState', function () {
	                return 4;
	              });
	              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
	                return fileApiXHR.response;
	              });
	              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
	              redefineProp(xhr, 'responseText', function () {
	                return resp;
	              });
	              redefineProp(xhr, 'response', function () {
	                return resp;
	              });
	              if (err) redefineProp(xhr, 'err', function () {
	                return err;
	              });
	              xhr.__fileApiXHR = fileApiXHR;
	              if (xhr.onreadystatechange) xhr.onreadystatechange();
	              if (xhr.onload) xhr.onload();
	            },
	            progress: function (e) {
	              e.target = xhr;
	              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
	              xhr.__total = e.total;
	              xhr.__loaded = e.loaded;
	              if (e.total === e.loaded) {
	                // fix flash issue that doesn't call complete if there is no response text from the server
	                var _this = this;
	                setTimeout(function () {
	                  if (!xhr.__completed) {
	                    xhr.getAllResponseHeaders = function () {
	                    };
	                    _this.complete(null, {status: 204, statusText: 'No Content'});
	                  }
	                }, FileAPI.noContentTimeout || 10000);
	              }
	            },
	            headers: xhr.__requestHeaders
	          };
	          config.data = {};
	          config.files = {};
	          for (var i = 0; i < formData.data.length; i++) {
	            var item = formData.data[i];
	            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
	              config.files[item.key] = item.val;
	            } else {
	              config.data[item.key] = item.val;
	            }
	          }
	
	          setTimeout(function () {
	            if (!FileAPI.hasFlash) {
	              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	            }
	            xhr.__fileApiXHR = FileAPI.upload(config);
	          }, 1);
	        } else {
	          if (this.__origError) {
	            throw this.__origError;
	          }
	          orig.apply(xhr, arguments);
	        }
	      };
	    });
	    window.XMLHttpRequest.__isFileAPIShim = true;
	    window.FormData = FormData = function () {
	      return {
	        append: function (key, val, name) {
	          if (val.__isFileAPIBlobShim) {
	            val = val.data[0];
	          }
	          this.data.push({
	            key: key,
	            val: val,
	            name: name
	          });
	        },
	        data: [],
	        __isFileAPIShim: true
	      };
	    };
	
	    window.Blob = Blob = function (b) {
	      return {
	        data: b,
	        __isFileAPIBlobShim: true
	      };
	    };
	  }
	
	})();
	
	(function () {
	  /** @namespace FileAPI.forceLoad */
	  /** @namespace window.FileAPI.jsUrl */
	  /** @namespace window.FileAPI.jsPath */
	
	  function isInputTypeFile(elem) {
	    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
	  }
	
	  function hasFlash() {
	    try {
	      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	      if (fo) return true;
	    } catch (e) {
	      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
	    }
	    return false;
	  }
	
	  function getOffset(obj) {
	    var left = 0, top = 0;
	
	    if (window.jQuery) {
	      return jQuery(obj).offset();
	    }
	
	    if (obj.offsetParent) {
	      do {
	        left += (obj.offsetLeft - obj.scrollLeft);
	        top += (obj.offsetTop - obj.scrollTop);
	        obj = obj.offsetParent;
	      } while (obj);
	    }
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  if (FileAPI.shouldLoad) {
	    FileAPI.hasFlash = hasFlash();
	
	    //load FileAPI
	    if (FileAPI.forceLoad) {
	      FileAPI.html5 = false;
	    }
	
	    if (!FileAPI.upload) {
	      var jsUrl, basePath, script = document.createElement('script'), allScripts = document.getElementsByTagName('script'), i, index, src;
	      if (window.FileAPI.jsUrl) {
	        jsUrl = window.FileAPI.jsUrl;
	      } else if (window.FileAPI.jsPath) {
	        basePath = window.FileAPI.jsPath;
	      } else {
	        for (i = 0; i < allScripts.length; i++) {
	          src = allScripts[i].src;
	          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
	          if (index > -1) {
	            basePath = src.substring(0, index + 1);
	            break;
	          }
	        }
	      }
	
	      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
	      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
	      document.getElementsByTagName('head')[0].appendChild(script);
	    }
	
	    FileAPI.ngfFixIE = function (elem, fileElem, changeFn) {
	      if (!hasFlash()) {
	        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	      }
	      var fixInputStyle = function () {
	        var label = fileElem.parent();
	        if (elem.attr('disabled')) {
	          if (label) label.removeClass('js-fileapi-wrapper');
	        } else {
	          if (!fileElem.attr('__ngf_flash_')) {
	            fileElem.unbind('change');
	            fileElem.unbind('click');
	            fileElem.bind('change', function (evt) {
	              fileApiChangeFn.apply(this, [evt]);
	              changeFn.apply(this, [evt]);
	            });
	            fileElem.attr('__ngf_flash_', 'true');
	          }
	          label.addClass('js-fileapi-wrapper');
	          if (!isInputTypeFile(elem)) {
	            label.css('position', 'absolute')
	              .css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px')
	              .css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('filter', 'alpha(opacity=0)').css('display', elem.css('display'))
	              .css('overflow', 'hidden').css('z-index', '900000')
	              .css('visibility', 'visible');
	            fileElem.css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('position', 'absolute').css('top', '0px').css('left', '0px');
	          }
	        }
	      };
	
	      elem.bind('mouseenter', fixInputStyle);
	
	      var fileApiChangeFn = function (evt) {
	        var files = FileAPI.getFiles(evt);
	        //just a double check for #233
	        for (var i = 0; i < files.length; i++) {
	          if (files[i].size === undefined) files[i].size = 0;
	          if (files[i].name === undefined) files[i].name = 'file';
	          if (files[i].type === undefined) files[i].type = 'undefined';
	        }
	        if (!evt.target) {
	          evt.target = {};
	        }
	        evt.target.files = files;
	        // if evt.target.files is not writable use helper field
	        if (evt.target.files !== files) {
	          evt.__files_ = files;
	        }
	        (evt.__files_ || evt.target.files).item = function (i) {
	          return (evt.__files_ || evt.target.files)[i] || null;
	        };
	      };
	    };
	
	    FileAPI.disableFileInput = function (elem, disable) {
	      if (disable) {
	        elem.removeClass('js-fileapi-wrapper');
	      } else {
	        elem.addClass('js-fileapi-wrapper');
	      }
	    };
	  }
	})();
	
	if (!window.FileReader) {
	  window.FileReader = function () {
	    var _this = this, loadStarted = false;
	    this.listeners = {};
	    this.addEventListener = function (type, fn) {
	      _this.listeners[type] = _this.listeners[type] || [];
	      _this.listeners[type].push(fn);
	    };
	    this.removeEventListener = function (type, fn) {
	      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
	    };
	    this.dispatchEvent = function (evt) {
	      var list = _this.listeners[evt.type];
	      if (list) {
	        for (var i = 0; i < list.length; i++) {
	          list[i].call(_this, evt);
	        }
	      }
	    };
	    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;
	
	    var constructEvent = function (type, evt) {
	      var e = {type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error};
	      if (evt.result != null) e.target.result = evt.result;
	      return e;
	    };
	    var listener = function (evt) {
	      if (!loadStarted) {
	        loadStarted = true;
	        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
	      }
	      var e;
	      if (evt.type === 'load') {
	        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
	        e = constructEvent('load', evt);
	        if (_this.onload) _this.onload(e);
	        _this.dispatchEvent(e);
	      } else if (evt.type === 'progress') {
	        e = constructEvent('progress', evt);
	        if (_this.onprogress) _this.onprogress(e);
	        _this.dispatchEvent(e);
	      } else {
	        e = constructEvent('error', evt);
	        if (_this.onerror) _this.onerror(e);
	        _this.dispatchEvent(e);
	      }
	    };
	    this.readAsDataURL = function (file) {
	      FileAPI.readAsDataURL(file, listener);
	    };
	    this.readAsText = function (file) {
	      FileAPI.readAsText(file, listener);
	    };
	  };
	}
	
	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */
	
	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  })(window.XMLHttpRequest.prototype.setRequestHeader);
	}
	
	var ngFileUpload = angular.module('ngFileUpload', []);
	
	ngFileUpload.version = '12.2.13';
	
	ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  var upload = this;
	  upload.promisesCount = 0;
	
	  this.isResumeSupported = function () {
	    return window.Blob && window.Blob.prototype.slice;
	  };
	
	  var resumeSupported = this.isResumeSupported();
	
	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};
	
	    var deferred = config._deferred = config._deferred || $q.defer();
	    var promise = deferred.promise;
	
	    function notifyProgress(e) {
	      if (deferred.notify) {
	        deferred.notify(e);
	      }
	      if (promise.progressFunc) {
	        $timeout(function () {
	          promise.progressFunc(e);
	        });
	      }
	    }
	
	    function getNotifyEvent(n) {
	      if (config._start != null && resumeSupported) {
	        return {
	          loaded: n.loaded + config._start,
	          total: (config._file && config._file.size) || n.total,
	          type: n.type, config: config,
	          lengthComputable: true, target: n.target
	        };
	      } else {
	        return n;
	      }
	    }
	
	    if (!config.disableProgress) {
	      config.headers.__setXHR_ = function () {
	        return function (xhr) {
	          if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
	          config.__XHR = xhr;
	          if (config.xhrFn) config.xhrFn(xhr);
	          xhr.upload.addEventListener('progress', function (e) {
	            e.config = config;
	            notifyProgress(getNotifyEvent(e));
	          }, false);
	          //fix for firefox not firing upload progress end, also IE8-9
	          xhr.upload.addEventListener('load', function (e) {
	            if (e.lengthComputable) {
	              e.config = config;
	              notifyProgress(getNotifyEvent(e));
	            }
	          }, false);
	        };
	      };
	    }
	
	    function uploadWithAngular() {
	      $http(config).then(function (r) {
	          if (resumeSupported && config._chunkSize && !config._finished && config._file) {
	            var fileSize = config._file && config._file.size || 0;
	            notifyProgress({
	                loaded: Math.min(config._end, fileSize),
	                total: fileSize,
	                config: config,
	                type: 'progress'
	              }
	            );
	            upload.upload(config, true);
	          } else {
	            if (config._finished) delete config._finished;
	            deferred.resolve(r);
	          }
	        }, function (e) {
	          deferred.reject(e);
	        }, function (n) {
	          deferred.notify(n);
	        }
	      );
	    }
	
	    if (!resumeSupported) {
	      uploadWithAngular();
	    } else if (config._chunkSize && config._end && !config._finished) {
	      config._start = config._end;
	      config._end += config._chunkSize;
	      uploadWithAngular();
	    } else if (config.resumeSizeUrl) {
	      $http.get(config.resumeSizeUrl).then(function (resp) {
	        if (config.resumeSizeResponseReader) {
	          config._start = config.resumeSizeResponseReader(resp.data);
	        } else {
	          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
	        }
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else if (config.resumeSize) {
	      config.resumeSize().then(function (size) {
	        config._start = size;
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else {
	      if (config._chunkSize) {
	        config._start = 0;
	        config._end = config._start + config._chunkSize;
	      }
	      uploadWithAngular();
	    }
	
	
	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (n) {
	        fn(n);
	      });
	      return promise;
	    };
	    promise.abort = promise.pause = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = (function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      })(config.xhrFn);
	      return promise;
	    };
	
	    upload.promisesCount++;
	    if (promise['finally'] && promise['finally'] instanceof Function) {
	      promise['finally'](function () {
	        upload.promisesCount--;
	      });
	    }
	    return promise;
	  }
	
	  this.isUploadInProgress = function () {
	    return upload.promisesCount > 0;
	  };
	
	  this.rename = function (file, name) {
	    file.ngfName = name;
	    return file;
	  };
	
	  this.jsonBlob = function (val) {
	    if (val != null && !angular.isString(val)) {
	      val = JSON.stringify(val);
	    }
	    var blob = new window.Blob([val], {type: 'application/json'});
	    blob._ngfBlob = true;
	    return blob;
	  };
	
	  this.json = function (val) {
	    return angular.toJson(val);
	  };
	
	  function copy(obj) {
	    var clone = {};
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        clone[key] = obj[key];
	      }
	    }
	    return clone;
	  }
	
	  this.isFile = function (file) {
	    return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
	  };
	
	  this.upload = function (config, internal) {
	    function toResumeFile(file, formData) {
	      if (file._ngfBlob) return file;
	      config._file = config._file || file;
	      if (config._start != null && resumeSupported) {
	        if (config._end && config._end >= file.size) {
	          config._finished = true;
	          config._end = file.size;
	        }
	        var slice = file.slice(config._start, config._end || file.size);
	        slice.name = file.name;
	        slice.ngfName = file.ngfName;
	        if (config._chunkSize) {
	          formData.append('_chunkSize', config._chunkSize);
	          formData.append('_currentChunkSize', config._end - config._start);
	          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
	          formData.append('_totalSize', config._file.size);
	        }
	        return slice;
	      }
	      return file;
	    }
	
	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (upload.isFile(val)) {
	          var file = toResumeFile(val, formData);
	          var split = key.split(',');
	          if (split[1]) {
	            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
	            key = split[0];
	          }
	          config._fileKey = config._fileKey || key;
	          formData.append(key, file, file.ngfName || file.name);
	        } else {
	          if (angular.isObject(val)) {
	            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;
	
	            val.$$ngfCircularDetection = true;
	            try {
	              for (var k in val) {
	                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
	                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
	                  if (val.length && parseInt(k) > -1) {
	                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
	                  }
	                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
	                }
	              }
	            } finally {
	              delete val.$$ngfCircularDetection;
	            }
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }
	
	    function digestConfig() {
	      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	      config.headers = config.headers || {};
	      config.headers['Content-Type'] = undefined;
	      config.transformRequest = config.transformRequest ?
	        (angular.isArray(config.transformRequest) ?
	          config.transformRequest : [config.transformRequest]) : [];
	      config.transformRequest.push(function (data) {
	        var formData = new window.FormData(), key;
	        data = data || config.fields || {};
	        if (config.file) {
	          data.file = config.file;
	        }
	        for (key in data) {
	          if (data.hasOwnProperty(key)) {
	            var val = data[key];
	            if (config.formDataAppender) {
	              config.formDataAppender(formData, key, val);
	            } else {
	              addFieldToFormData(formData, val, key);
	            }
	          }
	        }
	
	        return formData;
	      });
	    }
	
	    if (!internal) config = copy(config);
	    if (!config._isDigested) {
	      config._isDigested = true;
	      digestConfig();
	    }
	
	    return sendHttp(config);
	  };
	
	  this.http = function (config) {
	    config = copy(config);
	    config.transformRequest = config.transformRequest || function (data) {
	        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
	          return data;
	        }
	        return $http.defaults.transformRequest[0].apply(this, arguments);
	      };
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    return sendHttp(config);
	  };
	
	  this.translateScalars = function (str) {
	    if (angular.isString(str)) {
	      if (str.search(/kb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1024);
	      } else if (str.search(/mb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1048576);
	      } else if (str.search(/gb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1073741824);
	      } else if (str.search(/b/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/s/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/m/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 60);
	      } else if (str.search(/h/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 3600);
	      }
	    }
	    return str;
	  };
	
	  this.urlToBlob = function(url) {
	    var defer = $q.defer();
	    $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
	      var arrayBufferView = new Uint8Array(resp.data);
	      var type = resp.headers('content-type') || 'image/WebP';
	      var blob = new window.Blob([arrayBufferView], {type: type});
	      var matches = url.match(/.*\/(.+?)(\?.*)?$/);
	      if (matches.length > 1) {
	        blob.name = matches[1];
	      }
	      defer.resolve(blob);
	    }, function (e) {
	      defer.reject(e);
	    });
	    return defer.promise;
	  };
	
	  this.setDefaults = function (defaults) {
	    this.defaults = defaults || {};
	  };
	
	  this.defaults = {};
	  this.version = ngFileUpload.version;
	}
	
	]);
	
	ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
	  var upload = UploadExif;
	  upload.getAttrWithDefaults = function (attr, name) {
	    if (attr[name] != null) return attr[name];
	    var def = upload.defaults[name];
	    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
	  };
	
	  upload.attrGetter = function (name, attr, scope, params) {
	    var attrVal = this.getAttrWithDefaults(attr, name);
	    if (scope) {
	      try {
	        if (params) {
	          return $parse(attrVal)(scope, params);
	        } else {
	          return $parse(attrVal)(scope);
	        }
	      } catch (e) {
	        // hangle string value without single qoute
	        if (name.search(/min|max|pattern/i)) {
	          return attrVal;
	        } else {
	          throw e;
	        }
	      }
	    } else {
	      return attrVal;
	    }
	  };
	
	  upload.shouldUpdateOn = function (type, attr, scope) {
	    var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
	    if (modelOptions && modelOptions.updateOn) {
	      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
	    }
	    return true;
	  };
	
	  upload.emptyPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.resolve.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.rejectPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.reject.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.happyPromise = function (promise, data) {
	    var d = $q.defer();
	    promise.then(function (result) {
	      d.resolve(result);
	    }, function (error) {
	      $timeout(function () {
	        throw error;
	      });
	      d.resolve(data);
	    });
	    return d.promise;
	  };
	
	  function applyExifRotations(files, attr, scope) {
	    var promises = [upload.emptyPromise()];
	    angular.forEach(files, function (f, i) {
	      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
	        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
	          files.splice(i, 1, fixedFile);
	        }));
	      }
	    });
	    return $q.all(promises);
	  }
	
	  function resizeFile(files, attr, scope, ngModel) {
	    var resizeVal = upload.attrGetter('ngfResize', attr, scope);
	    if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
	    if (resizeVal instanceof Function) {
	      var defer = $q.defer();
	      return resizeVal(files).then(function (p) {
	        resizeWithParams(p, files, attr, scope, ngModel).then(function (r) {
	          defer.resolve(r);
	        }, function (e) {
	          defer.reject(e);
	        });
	      }, function (e) {
	        defer.reject(e);
	      });
	    } else {
	      return resizeWithParams(resizeVal, files, attr, scope, ngModel);
	    }
	  }
	
	  function resizeWithParams(params, files, attr, scope, ngModel) {
	    var promises = [upload.emptyPromise()];
	
	    function handleFile(f, i) {
	      if (f.type.indexOf('image') === 0) {
	        if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
	        params.resizeIf = function (width, height) {
	          return upload.attrGetter('ngfResizeIf', attr, scope,
	            {$width: width, $height: height, $file: f});
	        };
	        var promise = upload.resize(f, params);
	        promises.push(promise);
	        promise.then(function (resizedFile) {
	          files.splice(i, 1, resizedFile);
	        }, function (e) {
	          f.$error = 'resize';
	          (f.$errorMessages = (f.$errorMessages || {})).resize = true;
	          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
	          ngModel.$ngfValidations.push({name: 'resize', valid: false});
	          upload.applyModelValidation(ngModel, files);
	        });
	      }
	    }
	
	    for (var i = 0; i < files.length; i++) {
	      handleFile(files[i], i);
	    }
	    return $q.all(promises);
	  }
	
	  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
	    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
	      attr.$$ngfPrevValidFiles = files;
	      attr.$$ngfPrevInvalidFiles = invalidFiles;
	      var file = files && files.length ? files[0] : null;
	      var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;
	
	      if (ngModel) {
	        upload.applyModelValidation(ngModel, files);
	        ngModel.$setViewValue(isSingleModel ? file : files);
	      }
	
	      if (fileChange) {
	        $parse(fileChange)(scope, {
	          $files: files,
	          $file: file,
	          $newFiles: newFiles,
	          $duplicateFiles: dupFiles,
	          $invalidFiles: invalidFiles,
	          $invalidFile: invalidFile,
	          $event: evt
	        });
	      }
	
	      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
	      if (invalidModel) {
	        $timeout(function () {
	          $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
	        });
	      }
	      $timeout(function () {
	        // scope apply changes
	      });
	    }
	
	    var allNewFiles, dupFiles = [], prevValidFiles, prevInvalidFiles,
	      invalids = [], valids = [];
	
	    function removeDuplicates() {
	      function equals(f1, f2) {
	        return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) &&
	          f1.type === f2.type;
	      }
	
	      function isInPrevFiles(f) {
	        var j;
	        for (j = 0; j < prevValidFiles.length; j++) {
	          if (equals(f, prevValidFiles[j])) {
	            return true;
	          }
	        }
	        for (j = 0; j < prevInvalidFiles.length; j++) {
	          if (equals(f, prevInvalidFiles[j])) {
	            return true;
	          }
	        }
	        return false;
	      }
	
	      if (files) {
	        allNewFiles = [];
	        dupFiles = [];
	        for (var i = 0; i < files.length; i++) {
	          if (isInPrevFiles(files[i])) {
	            dupFiles.push(files[i]);
	          } else {
	            allNewFiles.push(files[i]);
	          }
	        }
	      }
	    }
	
	    function toArray(v) {
	      return angular.isArray(v) ? v : [v];
	    }
	
	    function resizeAndUpdate() {
	      function updateModel() {
	        $timeout(function () {
	          update(keep ? prevValidFiles.concat(valids) : valids,
	            keep ? prevInvalidFiles.concat(invalids) : invalids,
	            files, dupFiles, isSingleModel);
	        }, options && options.debounce ? options.debounce.change || options.debounce : 0);
	      }
	
	      var resizingFiles = validateAfterResize ? allNewFiles : valids;
	      resizeFile(resizingFiles, attr, scope, ngModel).then(function () {
	        if (validateAfterResize) {
	          upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	            .then(function (validationResult) {
	              valids = validationResult.validsFiles;
	              invalids = validationResult.invalidsFiles;
	              updateModel();
	            });
	        } else {
	          updateModel();
	        }
	      }, function () {
	        for (var i = 0; i < resizingFiles.length; i++) {
	          var f = resizingFiles[i];
	          if (f.$error === 'resize') {
	            var index = valids.indexOf(f);
	            if (index > -1) {
	              valids.splice(index, 1);
	              invalids.push(f);
	            }
	            updateModel();
	          }
	        }
	      });
	    }
	
	    prevValidFiles = attr.$$ngfPrevValidFiles || [];
	    prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
	    if (ngModel && ngModel.$modelValue) {
	      prevValidFiles = toArray(ngModel.$modelValue);
	    }
	
	    var keep = upload.attrGetter('ngfKeep', attr, scope);
	    allNewFiles = (files || []).slice(0);
	    if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
	      removeDuplicates(attr, scope);
	    }
	
	    var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);
	
	    if (keep && !allNewFiles.length) return;
	
	    upload.attrGetter('ngfBeforeModelChange', attr, scope, {
	      $files: files,
	      $file: files && files.length ? files[0] : null,
	      $newFiles: allNewFiles,
	      $duplicateFiles: dupFiles,
	      $event: evt
	    });
	
	    var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);
	
	    var options = upload.attrGetter('ngfModelOptions', attr, scope);
	    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	      .then(function (validationResult) {
	      if (noDelay) {
	        update(allNewFiles, [], files, dupFiles, isSingleModel);
	      } else {
	        if ((!options || !options.allowInvalid) && !validateAfterResize) {
	          valids = validationResult.validFiles;
	          invalids = validationResult.invalidFiles;
	        } else {
	          valids = allNewFiles;
	        }
	        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
	          applyExifRotations(valids, attr, scope).then(function () {
	            resizeAndUpdate();
	          });
	        } else {
	          resizeAndUpdate();
	        }
	      }
	    });
	  };
	
	  return upload;
	}]);
	
	ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
	  var generatedElems = [];
	
	  function isDelayedClickSupported(ua) {
	    // fix for android native browser < 4.4 and safari windows
	    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	    if (m && m.length > 2) {
	      var v = Upload.defaults.androidFixMinorVersion || 4;
	      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
	    }
	
	    // safari on windows
	    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
	  }
	
	  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
	    /** @namespace attr.ngfSelect */
	    /** @namespace attr.ngfChange */
	    /** @namespace attr.ngModel */
	    /** @namespace attr.ngfModelOptions */
	    /** @namespace attr.ngfMultiple */
	    /** @namespace attr.ngfCapture */
	    /** @namespace attr.ngfValidate */
	    /** @namespace attr.ngfKeep */
	    var attrGetter = function (name, scope) {
	      return upload.attrGetter(name, attr, scope);
	    };
	
	    function isInputTypeFile() {
	      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	    }
	
	    function fileChangeAttr() {
	      return attrGetter('ngfChange') || attrGetter('ngfSelect');
	    }
	
	    function changeFn(evt) {
	      if (upload.shouldUpdateOn('change', attr, scope)) {
	        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
	        /* Handle duplicate call in  IE11 */
	        if (!fileList) return;
	        for (var i = 0; i < fileList.length; i++) {
	          files.push(fileList[i]);
	        }
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
	          files.length ? files : null, evt);
	      }
	    }
	
	    upload.registerModelChangeValidator(ngModel, attr, scope);
	
	    var unwatches = [];
	    if (attrGetter('ngfMultiple')) {
	      unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
	        fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
	      }));
	    }
	    if (attrGetter('ngfCapture')) {
	      unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
	        fileElem.attr('capture', attrGetter('ngfCapture', scope));
	      }));
	    }
	    if (attrGetter('ngfAccept')) {
	      unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
	        fileElem.attr('accept', attrGetter('ngfAccept', scope));
	      }));
	    }
	    unwatches.push(attr.$observe('accept', function () {
	      fileElem.attr('accept', attrGetter('accept'));
	    }));
	    function bindAttrToFileInput(fileElem, label) {
	      function updateId(val) {
	        fileElem.attr('id', 'ngf-' + val);
	        label.attr('id', 'ngf-label-' + val);
	      }
	
	      for (var i = 0; i < elem[0].attributes.length; i++) {
	        var attribute = elem[0].attributes[i];
	        if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
	          if (attribute.name === 'id') {
	            updateId(attribute.value);
	            unwatches.push(attr.$observe('id', updateId));
	          } else {
	            fileElem.attr(attribute.name, (!attribute.value && (attribute.name === 'required' ||
	            attribute.name === 'multiple')) ? attribute.name : attribute.value);
	          }
	        }
	      }
	    }
	
	    function createFileInput() {
	      if (isInputTypeFile()) {
	        return elem;
	      }
	
	      var fileElem = angular.element('<input type="file">');
	
	      var label = angular.element('<label>upload</label>');
	      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
	        .css('width', '0px').css('height', '0px').css('border', 'none')
	        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	      bindAttrToFileInput(fileElem, label);
	
	      generatedElems.push({el: elem, ref: label});
	
	      document.body.appendChild(label.append(fileElem)[0]);
	
	      return fileElem;
	    }
	
	    function clickHandler(evt) {
	      if (elem.attr('disabled')) return false;
	      if (attrGetter('ngfSelectDisabled', scope)) return;
	
	      var r = detectSwipe(evt);
	      // prevent the click if it is a swipe
	      if (r != null) return r;
	
	      resetModel(evt);
	
	      // fix for md when the element is removed from the DOM and added back #460
	      try {
	        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
	          generatedElems.push({el: elem, ref: fileElem.parent()});
	          document.body.appendChild(fileElem.parent()[0]);
	          fileElem.bind('change', changeFn);
	        }
	      } catch (e) {/*ignore*/
	      }
	
	      if (isDelayedClickSupported(navigator.userAgent)) {
	        setTimeout(function () {
	          fileElem[0].click();
	        }, 0);
	      } else {
	        fileElem[0].click();
	      }
	
	      return false;
	    }
	
	
	    var initialTouchStartY = 0;
	    var initialTouchStartX = 0;
	
	    function detectSwipe(evt) {
	      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
	      if (touches) {
	        if (evt.type === 'touchstart') {
	          initialTouchStartX = touches[0].clientX;
	          initialTouchStartY = touches[0].clientY;
	          return true; // don't block event default
	        } else {
	          // prevent scroll from triggering event
	          if (evt.type === 'touchend') {
	            var currentX = touches[0].clientX;
	            var currentY = touches[0].clientY;
	            if ((Math.abs(currentX - initialTouchStartX) > 20) ||
	              (Math.abs(currentY - initialTouchStartY) > 20)) {
	              evt.stopPropagation();
	              evt.preventDefault();
	              return false;
	            }
	          }
	          return true;
	        }
	      }
	    }
	
	    var fileElem = elem;
	
	    function resetModel(evt) {
	      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
	        fileElem.val(null);
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
	      }
	    }
	
	    if (!isInputTypeFile()) {
	      fileElem = createFileInput();
	    }
	    fileElem.bind('change', changeFn);
	
	    if (!isInputTypeFile()) {
	      elem.bind('click touchstart touchend', clickHandler);
	    } else {
	      elem.bind('click', resetModel);
	    }
	
	    function ie10SameFileSelectFix(evt) {
	      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
	        if (!fileElem[0].parentNode) {
	          fileElem = null;
	          return;
	        }
	        evt.preventDefault();
	        evt.stopPropagation();
	        fileElem.unbind('click');
	        var clone = fileElem.clone();
	        fileElem.replaceWith(clone);
	        fileElem = clone;
	        fileElem.attr('__ngf_ie10_Fix_', 'true');
	        fileElem.bind('change', changeFn);
	        fileElem.bind('click', ie10SameFileSelectFix);
	        fileElem[0].click();
	        return false;
	      } else {
	        fileElem.removeAttr('__ngf_ie10_Fix_');
	      }
	    }
	
	    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
	      fileElem.bind('click', ie10SameFileSelectFix);
	    }
	
	    if (ngModel) ngModel.$formatters.push(function (val) {
	      if (val == null || val.length === 0) {
	        if (fileElem.val()) {
	          fileElem.val(null);
	        }
	      }
	      return val;
	    });
	
	    scope.$on('$destroy', function () {
	      if (!isInputTypeFile()) fileElem.parent().remove();
	      angular.forEach(unwatches, function (unwatch) {
	        unwatch();
	      });
	    });
	
	    $timeout(function () {
	      for (var i = 0; i < generatedElems.length; i++) {
	        var g = generatedElems[i];
	        if (!document.body.contains(g.el[0])) {
	          generatedElems.splice(i, 1);
	          g.ref.remove();
	        }
	      }
	    });
	
	    if (window.FileAPI && window.FileAPI.ngfFixIE) {
	      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
	    }
	  }
	
	  return {
	    restrict: 'AEC',
	    require: '?ngModel',
	    link: function (scope, elem, attr, ngModel) {
	      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
	    }
	  };
	}]);
	
	(function () {
	
	  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
	    var upload = UploadBase;
	    upload.base64DataUrl = function (file) {
	      if (angular.isArray(file)) {
	        var d = $q.defer(), count = 0;
	        angular.forEach(file, function (f) {
	          upload.dataUrl(f, true)['finally'](function () {
	            count++;
	            if (count === file.length) {
	              var urls = [];
	              angular.forEach(file, function (ff) {
	                urls.push(ff.$ngfDataUrl);
	              });
	              d.resolve(urls, file);
	            }
	          });
	        });
	        return d.promise;
	      } else {
	        return upload.dataUrl(file, true);
	      }
	    };
	    upload.dataUrl = function (file, disallowObjectUrl) {
	      if (!file) return upload.emptyPromise(file, file);
	      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
	        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
	      }
	      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
	      if (p) return p;
	
	      var deferred = $q.defer();
	      $timeout(function () {
	        if (window.FileReader && file &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	          //prefer URL.createObjectURL for handling refrences to files of all sizes
	          //since it doesn´t build a large string in memory
	          var URL = window.URL || window.webkitURL;
	          if (URL && URL.createObjectURL && !disallowObjectUrl) {
	            var url;
	            try {
	              url = URL.createObjectURL(file);
	            } catch (e) {
	              $timeout(function () {
	                file.$ngfBlobUrl = '';
	                deferred.reject();
	              });
	              return;
	            }
	            $timeout(function () {
	              file.$ngfBlobUrl = url;
	              if (url) {
	                deferred.resolve(url, file);
	                upload.blobUrls = upload.blobUrls || [];
	                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
	                upload.blobUrls.push({url: url, size: file.size});
	                upload.blobUrlsTotalSize += file.size || 0;
	                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
	                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
	                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
	                  var obj = upload.blobUrls.splice(0, 1)[0];
	                  URL.revokeObjectURL(obj.url);
	                  upload.blobUrlsTotalSize -= obj.size;
	                }
	              }
	            });
	          } else {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	              $timeout(function () {
	                file.$ngfDataUrl = e.target.result;
	                deferred.resolve(e.target.result, file);
	                $timeout(function () {
	                  delete file.$ngfDataUrl;
	                }, 1000);
	              });
	            };
	            fileReader.onerror = function () {
	              $timeout(function () {
	                file.$ngfDataUrl = '';
	                deferred.reject();
	              });
	            };
	            fileReader.readAsDataURL(file);
	          }
	        } else {
	          $timeout(function () {
	            file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
	            deferred.reject();
	          });
	        }
	      });
	
	      if (disallowObjectUrl) {
	        p = file.$$ngfDataUrlPromise = deferred.promise;
	      } else {
	        p = file.$$ngfBlobUrlPromise = deferred.promise;
	      }
	      p['finally'](function () {
	        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
	      });
	      return p;
	    };
	    return upload;
	  }]);
	
	  function getTagType(el) {
	    if (el.tagName.toLowerCase() === 'img') return 'image';
	    if (el.tagName.toLowerCase() === 'audio') return 'audio';
	    if (el.tagName.toLowerCase() === 'video') return 'video';
	    return /./;
	  }
	
	  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
	    function constructDataUrl(file) {
	      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
	      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
	        $timeout(function () {
	          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
	          if (isBackground) {
	            elem.css('background-image', 'url(\'' + (src || '') + '\')');
	          } else {
	            elem.attr('src', src);
	          }
	          if (src) {
	            elem.removeClass('ng-hide');
	          } else {
	            elem.addClass('ng-hide');
	          }
	        });
	      });
	    }
	
	    $timeout(function () {
	      var unwatch = scope.$watch(attr[directiveName], function (file) {
	        var size = resizeParams;
	        if (directiveName === 'ngfThumbnail') {
	          if (!size) {
	            size = {
	              width: elem[0].naturalWidth || elem[0].clientWidth,
	              height: elem[0].naturalHeight || elem[0].clientHeight
	            };
	          }
	          if (size.width === 0 && window.getComputedStyle) {
	            var style = getComputedStyle(elem[0]);
	            if (style.width && style.width.indexOf('px') > -1 && style.height && style.height.indexOf('px') > -1) {
	              size = {
	                width: parseInt(style.width.slice(0, -2)),
	                height: parseInt(style.height.slice(0, -2))
	              };
	            }
	          }
	        }
	
	        if (angular.isString(file)) {
	          elem.removeClass('ng-hide');
	          if (isBackground) {
	            return elem.css('background-image', 'url(\'' + file + '\')');
	          } else {
	            return elem.attr('src', file);
	          }
	        }
	        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
	          (!isBackground || file.type.indexOf('image') === 0)) {
	          if (size && Upload.isResizeSupported()) {
	            size.resizeIf = function (width, height) {
	              return Upload.attrGetter('ngfResizeIf', attr, scope,
	                {$width: width, $height: height, $file: file});
	            };
	            Upload.resize(file, size).then(
	              function (f) {
	                constructDataUrl(f);
	              }, function (e) {
	                throw e;
	              }
	            );
	          } else {
	            constructDataUrl(file);
	          }
	        } else {
	          elem.addClass('ng-hide');
	        }
	      });
	
	      scope.$on('$destroy', function () {
	        unwatch();
	      });
	    });
	  }
	
	
	  /** @namespace attr.ngfSrc */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
	          Upload.attrGetter('ngfResize', attr, scope), false);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfBackground */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
	          Upload.attrGetter('ngfResize', attr, scope), true);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfThumbnail */
	  /** @namespace attr.ngfAsBackground */
	  /** @namespace attr.ngfSize */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        var size = Upload.attrGetter('ngfSize', attr, scope);
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
	          Upload.attrGetter('ngfAsBackground', attr, scope));
	      }
	    };
	  }]);
	
	  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
	    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	  }]);
	
	  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
	    return function (file, disallowObjectUrl, trustedUrl) {
	      if (angular.isString(file)) {
	        return $sce.trustAsResourceUrl(file);
	      }
	      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
	      if (file && !src) {
	        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
	          file.$ngfDataUrlFilterInProgress = true;
	          UploadDataUrl.dataUrl(file, disallowObjectUrl);
	        }
	        return '';
	      }
	      if (file) delete file.$ngfDataUrlFilterInProgress;
	      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
	    };
	  }]);
	
	})();
	
	ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
	  var upload = UploadDataUrl;
	
	  function globStringToRegex(str) {
	    var regexp = '', excludes = [];
	    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	      regexp = str.substring(1, str.length - 1);
	    } else {
	      var split = str.split(',');
	      if (split.length > 1) {
	        for (var i = 0; i < split.length; i++) {
	          var r = globStringToRegex(split[i]);
	          if (r.regexp) {
	            regexp += '(' + r.regexp + ')';
	            if (i < split.length - 1) {
	              regexp += '|';
	            }
	          } else {
	            excludes = excludes.concat(r.excludes);
	          }
	        }
	      } else {
	        if (str.indexOf('!') === 0) {
	          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
	        } else {
	          if (str.indexOf('.') === 0) {
	            str = '*' + str;
	          }
	          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
	          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	        }
	      }
	    }
	    return {regexp: regexp, excludes: excludes};
	  }
	
	  upload.validatePattern = function (file, val) {
	    if (!val) {
	      return true;
	    }
	    var pattern = globStringToRegex(val), valid = true;
	    if (pattern.regexp && pattern.regexp.length) {
	      var regexp = new RegExp(pattern.regexp, 'i');
	      valid = (file.type != null && regexp.test(file.type)) ||
	        (file.name != null && regexp.test(file.name));
	    }
	    var len = pattern.excludes.length;
	    while (len--) {
	      var exclude = new RegExp(pattern.excludes[len], 'i');
	      valid = valid && (file.type == null || exclude.test(file.type)) &&
	        (file.name == null || exclude.test(file.name));
	    }
	    return valid;
	  };
	
	  upload.ratioToFloat = function (val) {
	    var r = val.toString(), xIndex = r.search(/[x:]/i);
	    if (xIndex > -1) {
	      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
	    } else {
	      r = parseFloat(r);
	    }
	    return r;
	  };
	
	  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
	    if (ngModel) {
	      ngModel.$formatters.push(function (files) {
	        if (ngModel.$dirty) {
	          var filesArray = files;
	          if (files && !angular.isArray(files)) {
	            filesArray = [files];
	          }
	          upload.validate(filesArray, 0, ngModel, attr, scope).then(function () {
	            upload.applyModelValidation(ngModel, filesArray);
	          });
	        }
	        return files;
	      });
	    }
	  };
	
	  function markModelAsDirty(ngModel, files) {
	    if (files != null && !ngModel.$dirty) {
	      if (ngModel.$setDirty) {
	        ngModel.$setDirty();
	      } else {
	        ngModel.$dirty = true;
	      }
	    }
	  }
	
	  upload.applyModelValidation = function (ngModel, files) {
	    markModelAsDirty(ngModel, files);
	    angular.forEach(ngModel.$ngfValidations, function (validation) {
	      ngModel.$setValidity(validation.name, validation.valid);
	    });
	  };
	
	  upload.getValidationAttr = function (attr, scope, name, validationName, file) {
	    var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	    var val = upload.attrGetter(dName, attr, scope, {$file: file});
	    if (val == null) {
	      val = upload.attrGetter('ngfValidate', attr, scope, {$file: file});
	      if (val) {
	        var split = (validationName || name).split('.');
	        val = val[split[0]];
	        if (split.length > 1) {
	          val = val && val[split[1]];
	        }
	      }
	    }
	    return val;
	  };
	
	  upload.validate = function (files, prevLength, ngModel, attr, scope) {
	    ngModel = ngModel || {};
	    ngModel.$ngfValidations = ngModel.$ngfValidations || [];
	
	    angular.forEach(ngModel.$ngfValidations, function (v) {
	      v.valid = true;
	    });
	
	    var attrGetter = function (name, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
	    var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);
	
	    if (files == null || files.length === 0) {
	      return upload.emptyPromise({'validFiles': files, 'invalidFiles': []});
	    }
	
	    files = files.length === undefined ? [files] : files.slice(0);
	    var invalidFiles = [];
	
	    function validateSync(name, validationName, fn) {
	      if (files) {
	        var i = files.length, valid = null;
	        while (i--) {
	          var file = files[i];
	          if (file) {
	            var val = upload.getValidationAttr(attr, scope, name, validationName, file);
	            if (val != null) {
	              if (!fn(file, val, i)) {
	                if (ignoredErrors.indexOf(name) === -1) {
	                  file.$error = name;
	                  (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	                  file.$errorParam = val;
	                  if (invalidFiles.indexOf(file) === -1) {
	                    invalidFiles.push(file);
	                  }
	                  if (!runAllValidation) {
	                    files.splice(i, 1);
	                  }
	                  valid = false;
	                } else {
	                  files.splice(i, 1);
	                }
	              }
	            }
	          }
	        }
	        if (valid !== null) {
	          ngModel.$ngfValidations.push({name: name, valid: valid});
	        }
	      }
	    }
	
	    validateSync('pattern', null, upload.validatePattern);
	    validateSync('minSize', 'size.min', function (file, val) {
	      return file.size + 0.1 >= upload.translateScalars(val);
	    });
	    validateSync('maxSize', 'size.max', function (file, val) {
	      return file.size - 0.1 <= upload.translateScalars(val);
	    });
	    var totalSize = 0;
	    validateSync('maxTotalSize', null, function (file, val) {
	      totalSize += file.size;
	      if (totalSize > upload.translateScalars(val)) {
	        files.splice(0, files.length);
	        return false;
	      }
	      return true;
	    });
	
	    validateSync('validateFn', null, function (file, r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!files.length) {
	      return upload.emptyPromise({'validFiles': [], 'invalidFiles': invalidFiles});
	    }
	
	    function validateAsync(name, validationName, type, asyncFn, fn) {
	      function resolveResult(defer, file, val) {
	        function resolveInternal(fn) {
	          if (fn()) {
	            if (ignoredErrors.indexOf(name) === -1) {
	              file.$error = name;
	              (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	              file.$errorParam = val;
	              if (invalidFiles.indexOf(file) === -1) {
	                invalidFiles.push(file);
	              }
	              if (!runAllValidation) {
	                var i = files.indexOf(file);
	                if (i > -1) files.splice(i, 1);
	              }
	              defer.resolve(false);
	            } else {
	              var j = files.indexOf(file);
	              if (j > -1) files.splice(j, 1);
	              defer.resolve(true);
	            }
	          } else {
	            defer.resolve(true);
	          }
	        }
	
	        if (val != null) {
	          asyncFn(file, val).then(function (d) {
	            resolveInternal(function () {
	              return !fn(d, val);
	            });
	          }, function () {
	            resolveInternal(function () {
	              return attrGetter('ngfValidateForce', {$file: file});
	            });
	          });
	        } else {
	          defer.resolve(true);
	        }
	      }
	
	      var promises = [upload.emptyPromise(true)];
	      if (files) {
	        files = files.length === undefined ? [files] : files;
	        angular.forEach(files, function (file) {
	          var defer = $q.defer();
	          promises.push(defer.promise);
	          if (type && (file.type == null || file.type.search(type) !== 0)) {
	            defer.resolve(true);
	            return;
	          }
	          if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
	            upload.imageDimensions(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDimensions', {$file: file, $width: d.width, $height: d.height}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
	            upload.mediaDuration(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDuration', {$file: file, $duration: d}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else {
	            resolveResult(defer, file,
	              upload.getValidationAttr(attr, scope, name, validationName, file));
	          }
	        });
	      }
	      var deffer = $q.defer();
	      $q.all(promises).then(function (values) {
	        var isValid = true;
	        for (var i = 0; i < values.length; i++) {
	          if (!values[i]) {
	            isValid = false;
	            break;
	          }
	        }
	        ngModel.$ngfValidations.push({name: name, valid: isValid});
	        deffer.resolve(isValid);
	      });
	      return deffer.promise;
	    }
	
	    var deffer = $q.defer();
	    var promises = [];
	
	    promises.push(validateAsync('maxHeight', 'height.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height <= val;
	      }));
	    promises.push(validateAsync('minHeight', 'height.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height >= val;
	      }));
	    promises.push(validateAsync('maxWidth', 'width.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width <= val;
	      }));
	    promises.push(validateAsync('minWidth', 'width.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width >= val;
	      }));
	    promises.push(validateAsync('dimensions', null, /image/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	    promises.push(validateAsync('ratio', null, /image/,
	      this.imageDimensions, function (d, val) {
	        var split = val.toString().split(','), valid = false;
	        for (var i = 0; i < split.length; i++) {
	          if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.01) {
	            valid = true;
	          }
	        }
	        return valid;
	      }));
	    promises.push(validateAsync('maxRatio', 'ratio.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
	      }));
	    promises.push(validateAsync('minRatio', 'ratio.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
	      }));
	    promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d <= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('minDuration', 'duration.min', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d >= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('duration', null, /audio|video/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	
	    promises.push(validateAsync('validateAsyncFn', null, null,
	      function (file, val) {
	        return val;
	      }, function (r) {
	        return r === true || r === null || r === '';
	      }));
	
	    $q.all(promises).then(function () {
	
	      if (runAllValidation) {
	        for (var i = 0; i < files.length; i++) {
	          var file = files[i];
	          if (file.$error) {
	            files.splice(i--, 1);
	          }
	        }
	      }
	
	      runAllValidation = false;
	      validateSync('maxFiles', null, function (file, val, i) {
	        return prevLength + i < val;
	      });
	
	      deffer.resolve({'validFiles': files, 'invalidFiles': invalidFiles});
	    });
	    return deffer.promise;
	  };
	
	  upload.imageDimensions = function (file) {
	    if (file.$ngfWidth && file.$ngfHeight) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
	      });
	      return d.promise;
	    }
	    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('image') !== 0) {
	        deferred.reject('not image');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var img = angular.element('<img>').attr('src', dataUrl)
	          .css('visibility', 'hidden').css('position', 'fixed')
	          .css('max-width', 'none !important').css('max-height', 'none !important');
	
	        function success() {
	          var width = img[0].naturalWidth || img[0].clientWidth;
	          var height = img[0].naturalHeight || img[0].clientHeight;
	          img.remove();
	          file.$ngfWidth = width;
	          file.$ngfHeight = height;
	          deferred.resolve({width: width, height: height});
	        }
	
	        function error() {
	          img.remove();
	          deferred.reject('load error');
	        }
	
	        img.on('load', success);
	        img.on('error', error);
	
	        var secondsCounter = 0;
	        function checkLoadErrorInCaseOfNoCallback() {
	          $timeout(function () {
	            if (img[0].parentNode) {
	              if (img[0].clientWidth) {
	                success();
	              } else if (secondsCounter++ > 10) {
	                error();
	              } else {
	                checkLoadErrorInCaseOfNoCallback();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadErrorInCaseOfNoCallback();
	
	        angular.element(document.getElementsByTagName('body')[0]).append(img);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDimensionPromise = deferred.promise;
	    file.$ngfDimensionPromise['finally'](function () {
	      delete file.$ngfDimensionPromise;
	    });
	    return file.$ngfDimensionPromise;
	  };
	
	  upload.mediaDuration = function (file) {
	    if (file.$ngfDuration) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve(file.$ngfDuration);
	      });
	      return d.promise;
	    }
	    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
	        deferred.reject('not media');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
	          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');
	
	        function success() {
	          var duration = el[0].duration;
	          file.$ngfDuration = duration;
	          el.remove();
	          deferred.resolve(duration);
	        }
	
	        function error() {
	          el.remove();
	          deferred.reject('load error');
	        }
	
	        el.on('loadedmetadata', success);
	        el.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (el[0].parentNode) {
	              if (el[0].duration) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.body).append(el);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDurationPromise = deferred.promise;
	    file.$ngfDurationPromise['finally'](function () {
	      delete file.$ngfDurationPromise;
	    });
	    return file.$ngfDurationPromise;
	  };
	  return upload;
	}
	]);
	
	ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
	  var upload = UploadValidate;
	
	  /**
	   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
	   * images to fit into a certain area.
	   * Source:  http://stackoverflow.com/a/14731922
	   *
	   * @param {Number} srcWidth Source area width
	   * @param {Number} srcHeight Source area height
	   * @param {Number} maxWidth Nestable area maximum available width
	   * @param {Number} maxHeight Nestable area maximum available height
	   * @return {Object} { width, height }
	   */
	  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
	    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
	      Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	    return {
	      width: srcWidth * ratio, height: srcHeight * ratio,
	      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
	    };
	  };
	
	  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
	  var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
	    var deferred = $q.defer();
	    var canvasElement = document.createElement('canvas');
	    var imageElement = document.createElement('img');
	    imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
	    document.body.appendChild(imageElement);
	
	    imageElement.onload = function () {
	      var imgWidth = imageElement.width, imgHeight = imageElement.height;
	      imageElement.parentNode.removeChild(imageElement);
	      if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
	        deferred.reject('resizeIf');
	        return;
	      }
	      try {
	        if (ratio) {
	          var ratioFloat = upload.ratioToFloat(ratio);
	          var imgRatio = imgWidth / imgHeight;
	          if (imgRatio < ratioFloat) {
	            width = imgWidth;
	            height = width / ratioFloat;
	          } else {
	            height = imgHeight;
	            width = height * ratioFloat;
	          }
	        }
	        if (!width) {
	          width = imgWidth;
	        }
	        if (!height) {
	          height = imgHeight;
	        }
	        var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
	        canvasElement.width = Math.min(dimensions.width, width);
	        canvasElement.height = Math.min(dimensions.height, height);
	        var context = canvasElement.getContext('2d');
	        context.drawImage(imageElement,
	          Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
	          dimensions.width, dimensions.height);
	        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
	      } catch (e) {
	        deferred.reject(e);
	      }
	    };
	    imageElement.onerror = function () {
	      imageElement.parentNode.removeChild(imageElement);
	      deferred.reject();
	    };
	    imageElement.src = imagen;
	    return deferred.promise;
	  };
	
	  upload.dataUrltoBlob = function (dataurl, name, origSize) {
	    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
	      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
	    while (n--) {
	      u8arr[n] = bstr.charCodeAt(n);
	    }
	    var blob = new window.Blob([u8arr], {type: mime});
	    blob.name = name;
	    blob.$ngfOrigSize = origSize;
	    return blob;
	  };
	
	  upload.isResizeSupported = function () {
	    var elem = document.createElement('canvas');
	    return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
	  };
	
	  if (upload.isResizeSupported()) {
	    // add name getter to the blob constructor prototype
	    Object.defineProperty(window.Blob.prototype, 'name', {
	      get: function () {
	        return this.$ngfName;
	      },
	      set: function (v) {
	        this.$ngfName = v;
	      },
	      configurable: true
	    });
	  }
	
	  upload.resize = function (file, options) {
	    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);
	
	    var deferred = $q.defer();
	    upload.dataUrl(file, true).then(function (url) {
	      resize(url, options.width, options.height, options.quality, options.type || file.type,
	        options.ratio, options.centerCrop, options.resizeIf)
	        .then(function (dataUrl) {
	          if (file.type === 'image/jpeg' && options.restoreExif !== false) {
	            try {
	              dataUrl = upload.restoreExif(url, dataUrl);
	            } catch (e) {
	              setTimeout(function () {throw e;}, 1);
	            }
	          }
	          try {
	            var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
	            deferred.resolve(blob);
	          } catch (e) {
	            deferred.reject(e);
	          }
	        }, function (r) {
	          if (r === 'resizeIf') {
	            deferred.resolve(file);
	          }
	          deferred.reject(r);
	        });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  return upload;
	}]);
	
	(function () {
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q',
	    function ($parse, $timeout, $window, Upload, $http, $q) {
	      return {
	        restrict: 'AEC',
	        require: '?ngModel',
	        link: function (scope, elem, attr, ngModel) {
	          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
	        }
	      };
	    }]);
	
	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });
	
	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
	        $timeout(function () {
	          model(scope);
	          if (model.assign) {
	            model.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);
	
	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
	    var available = dropAvailable();
	
	    var attrGetter = function (name, scope, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (attrGetter('dropAvailable')) {
	      $timeout(function () {
	        if (scope[attrGetter('dropAvailable')]) {
	          scope[attrGetter('dropAvailable')].value = available;
	        } else {
	          scope[attrGetter('dropAvailable')] = available;
	        }
	      });
	    }
	    if (!available) {
	      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }
	
	    function isDisabled() {
	      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
	    }
	
	    if (attrGetter('ngfSelect') == null) {
	      upload.registerModelChangeValidator(ngModel, attr, scope);
	    }
	
	    var leaveTimeout = null;
	    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
	    var dragOverDelay = 1;
	    var actualDragOverClass;
	
	    elem[0].addEventListener('dragover', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!actualDragOverClass) {
	        actualDragOverClass = 'C';
	        calculateDragOverClass(scope, attr, evt, function (clazz) {
	          actualDragOverClass = clazz;
	          elem.addClass(actualDragOverClass);
	          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
	        });
	      }
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      leaveTimeout = $timeout(function () {
	        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
	      }, dragOverDelay || 100);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      extractFilesAndUpdateModel(evt.dataTransfer, evt, 'dropUrl');
	    }, false);
	    elem[0].addEventListener('paste', function (evt) {
	      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	        attrGetter('ngfEnableFirefoxPaste', scope)) {
	        evt.preventDefault();
	      }
	      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
	      extractFilesAndUpdateModel(evt.clipboardData || evt.originalEvent.clipboardData, evt, 'pasteUrl');
	    }, false);
	
	    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	      attrGetter('ngfEnableFirefoxPaste', scope)) {
	      elem.attr('contenteditable', true);
	      elem.on('keypress', function (e) {
	        if (!e.metaKey && !e.ctrlKey) {
	          e.preventDefault();
	        }
	      });
	    }
	
	    function extractFilesAndUpdateModel(source, evt, updateOnType) {
	      if (!source) return;
	      // html needs to be calculated on the same process otherwise the data will be wiped
	      // after promise resolve or setTimeout.
	      var html;
	      try {
	        html = source && source.getData && source.getData('text/html');
	      } catch (e) {/* Fix IE11 that throw error calling getData */
	      }
	      extractFiles(source.items, source.files, attrGetter('ngfAllowDir', scope) !== false,
	        attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
	        if (files.length) {
	          updateModel(files, evt);
	        } else {
	          extractFilesFromHtml(updateOnType, html).then(function (files) {
	            updateModel(files, evt);
	          });
	        }
	      });
	    }
	
	    function updateModel(files, evt) {
	      upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	    }
	
	    function extractFilesFromHtml(updateOn, html) {
	      if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
	      var urls = [];
	      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
	        urls.push(src);
	      });
	      var promises = [], files = [];
	      if (urls.length) {
	        angular.forEach(urls, function (url) {
	          promises.push(upload.urlToBlob(url).then(function (blob) {
	            files.push(blob);
	          }));
	        });
	        var defer = $q.defer();
	        $q.all(promises).then(function () {
	          defer.resolve(files);
	        }, function (e) {
	          defer.reject(e);
	        });
	        return defer.promise;
	      }
	      return upload.emptyPromise();
	    }
	
	    function calculateDragOverClass(scope, attr, evt, callback) {
	      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
	      if (angular.isString(obj)) {
	        dClass = obj;
	      } else if (obj) {
	        if (obj.delay) dragOverDelay = obj.delay;
	        if (obj.accept || obj.reject) {
	          var items = evt.dataTransfer.items;
	          if (items == null || !items.length) {
	            dClass = obj.accept;
	          } else {
	            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
	            var len = items.length;
	            while (len--) {
	              if (!upload.validatePattern(items[len], pattern)) {
	                dClass = obj.reject;
	                break;
	              } else {
	                dClass = obj.accept;
	              }
	            }
	          }
	        }
	      }
	      callback(dClass);
	    }
	
	    function extractFiles(items, fileList, allowDir, multiple) {
	      var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
	      if (maxFiles == null) {
	        maxFiles = Number.MAX_VALUE;
	      }
	      var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
	      if (maxTotalSize == null) {
	        maxTotalSize = Number.MAX_VALUE;
	      }
	      var includeDir = attrGetter('ngfIncludeDir', scope);
	      var files = [], totalSize = 0;
	
	      function traverseFileTree(entry, path) {
	        var defer = $q.defer();
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var promises = [upload.emptyPromise()];
	            if (includeDir) {
	              var file = {type: 'directory'};
	              file.name = file.path = (path || '') + entry.name;
	              files.push(file);
	            }
	            var dirReader = entry.createReader();
	            var entries = [];
	            var readEntries = function () {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    angular.forEach(entries.slice(0), function (e) {
	                      if (files.length <= maxFiles && totalSize <= maxTotalSize) {
	                        promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
	                      }
	                    });
	                    $q.all(promises).then(function () {
	                      defer.resolve();
	                    }, function (e) {
	                      defer.reject(e);
	                    });
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  defer.reject(e);
	                }
	              }, function (e) {
	                defer.reject(e);
	              });
	            };
	            readEntries();
	          } else {
	            entry.file(function (file) {
	              try {
	                file.path = (path ? path : '') + file.name;
	                if (includeDir) {
	                  file = upload.rename(file, file.path);
	                }
	                files.push(file);
	                totalSize += file.size;
	                defer.resolve();
	              } catch (e) {
	                defer.reject(e);
	              }
	            }, function (e) {
	              defer.reject(e);
	            });
	          }
	        }
	        return defer.promise;
	      }
	
	      var promises = [upload.emptyPromise()];
	
	      if (items && items.length > 0 && $window.location.protocol !== 'file:') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              promises.push(traverseFileTree(entry));
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) {
	              files.push(f);
	              totalSize += f.size;
	            }
	          }
	          if (files.length > maxFiles || totalSize > maxTotalSize ||
	            (!multiple && files.length > 0)) break;
	        }
	      } else {
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            var file = fileList.item(j);
	            if (file.type || file.size > 0) {
	              files.push(file);
	              totalSize += file.size;
	            }
	            if (files.length > maxFiles || totalSize > maxTotalSize ||
	              (!multiple && files.length > 0)) break;
	          }
	        }
	      }
	
	      var defer = $q.defer();
	      $q.all(promises).then(function () {
	        if (!multiple && !includeDir && files.length) {
	          var i = 0;
	          while (files[i] && files[i].type === 'directory') i++;
	          defer.resolve([files[i]]);
	        } else {
	          defer.resolve(files);
	        }
	      }, function (e) {
	        defer.reject(e);
	      });
	
	      return defer.promise;
	    }
	  }
	
	  function dropAvailable() {
	    var div = document.createElement('div');
	    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
	  }
	
	})();
	
	// customized version of https://github.com/exif-js/exif-js
	ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
	  var upload = UploadResize;
	
	  upload.isExifSupported = function () {
	    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
	  };
	
	  function applyTransform(ctx, orientation, width, height) {
	    switch (orientation) {
	      case 2:
	        return ctx.transform(-1, 0, 0, 1, width, 0);
	      case 3:
	        return ctx.transform(-1, 0, 0, -1, width, height);
	      case 4:
	        return ctx.transform(1, 0, 0, -1, 0, height);
	      case 5:
	        return ctx.transform(0, 1, 1, 0, 0, 0);
	      case 6:
	        return ctx.transform(0, 1, -1, 0, height, 0);
	      case 7:
	        return ctx.transform(0, -1, -1, 0, height, width);
	      case 8:
	        return ctx.transform(0, -1, 1, 0, 0, width);
	    }
	  }
	
	  upload.readOrientation = function (file) {
	    var defer = $q.defer();
	    var reader = new FileReader();
	    var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
	    reader.readAsArrayBuffer(slicedFile);
	    reader.onerror = function (e) {
	      return defer.reject(e);
	    };
	    reader.onload = function (e) {
	      var result = {orientation: 1};
	      var view = new DataView(this.result);
	      if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);
	
	      var length = view.byteLength,
	        offset = 2;
	      while (offset < length) {
	        var marker = view.getUint16(offset, false);
	        offset += 2;
	        if (marker === 0xFFE1) {
	          if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);
	
	          var little = view.getUint16(offset += 6, false) === 0x4949;
	          offset += view.getUint32(offset + 4, little);
	          var tags = view.getUint16(offset, little);
	          offset += 2;
	          for (var i = 0; i < tags; i++)
	            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
	              var orientation = view.getUint16(offset + (i * 12) + 8, little);
	              if (orientation >= 2 && orientation <= 8) {
	                view.setUint16(offset + (i * 12) + 8, 1, little);
	                result.fixedArrayBuffer = e.target.result;
	              }
	              result.orientation = orientation;
	              return defer.resolve(result);
	            }
	        } else if ((marker & 0xFF00) !== 0xFF00) break;
	        else offset += view.getUint16(offset, false);
	      }
	      return defer.resolve(result);
	    };
	    return defer.promise;
	  };
	
	  function arrayBufferToBase64(buffer) {
	    var binary = '';
	    var bytes = new Uint8Array(buffer);
	    var len = bytes.byteLength;
	    for (var i = 0; i < len; i++) {
	      binary += String.fromCharCode(bytes[i]);
	    }
	    return window.btoa(binary);
	  }
	
	  upload.applyExifRotation = function (file) {
	    if (file.type.indexOf('image/jpeg') !== 0) {
	      return upload.emptyPromise(file);
	    }
	
	    var deferred = $q.defer();
	    upload.readOrientation(file).then(function (result) {
	      if (result.orientation < 2 || result.orientation > 8) {
	        return deferred.resolve(file);
	      }
	      upload.dataUrl(file, true).then(function (url) {
	        var canvas = document.createElement('canvas');
	        var img = document.createElement('img');
	
	        img.onload = function () {
	          try {
	            canvas.width = result.orientation > 4 ? img.height : img.width;
	            canvas.height = result.orientation > 4 ? img.width : img.height;
	            var ctx = canvas.getContext('2d');
	            applyTransform(ctx, result.orientation, img.width, img.height);
	            ctx.drawImage(img, 0, 0);
	            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
	            dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
	            var blob = upload.dataUrltoBlob(dataUrl, file.name);
	            deferred.resolve(blob);
	          } catch (e) {
	            return deferred.reject(e);
	          }
	        };
	        img.onerror = function () {
	          deferred.reject();
	        };
	        img.src = url;
	      }, function (e) {
	        deferred.reject(e);
	      });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  upload.restoreExif = function (orig, resized) {
	    var ExifRestorer = {};
	
	    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
	      'QRSTUVWXYZabcdef' +
	      'ghijklmnopqrstuv' +
	      'wxyz0123456789+/' +
	      '=';
	
	    ExifRestorer.encode64 = function (input) {
	      var output = '',
	        chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0;
	
	      do {
	        chr1 = input[i++];
	        chr2 = input[i++];
	        chr3 = input[i++];
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	
	        output = output +
	          this.KEY_STR.charAt(enc1) +
	          this.KEY_STR.charAt(enc2) +
	          this.KEY_STR.charAt(enc3) +
	          this.KEY_STR.charAt(enc4);
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	      } while (i < input.length);
	
	      return output;
	    };
	
	    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
	      if (origFileBase64.match('data:image/jpeg;base64,')) {
	        origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
	      }
	
	      var rawImage = this.decode64(origFileBase64);
	      var segments = this.slice2Segments(rawImage);
	
	      var image = this.exifManipulation(resizedFileBase64, segments);
	
	      return 'data:image/jpeg;base64,' + this.encode64(image);
	    };
	
	
	    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
	      var exifArray = this.getExifArray(segments),
	        newImageArray = this.insertExif(resizedFileBase64, exifArray);
	      return new Uint8Array(newImageArray);
	    };
	
	
	    ExifRestorer.getExifArray = function (segments) {
	      var seg;
	      for (var x = 0; x < segments.length; x++) {
	        seg = segments[x];
	        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
	        {
	          return seg;
	        }
	      }
	      return [];
	    };
	
	
	    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
	      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
	        buf = this.decode64(imageData),
	        separatePoint = buf.indexOf(255, 3),
	        mae = buf.slice(0, separatePoint),
	        ato = buf.slice(separatePoint),
	        array = mae;
	
	      array = array.concat(exifArray);
	      array = array.concat(ato);
	      return array;
	    };
	
	
	    ExifRestorer.slice2Segments = function (rawImageArray) {
	      var head = 0,
	        segments = [];
	
	      while (1) {
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
	          break;
	        }
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
	          head += 2;
	        }
	        else {
	          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
	            endPoint = head + length + 2,
	            seg = rawImageArray.slice(head, endPoint);
	          segments.push(seg);
	          head = endPoint;
	        }
	        if (head > rawImageArray.length) {
	          break;
	        }
	      }
	
	      return segments;
	    };
	
	
	    ExifRestorer.decode64 = function (input) {
	      var chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0,
	        buf = [];
	
	      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
	      var base64test = /[^A-Za-z0-9\+\/\=]/g;
	      if (base64test.exec(input)) {
	        console.log('There were invalid base64 characters in the input text.\n' +
	          'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' +
	          'Expect errors in decoding.');
	      }
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	
	      do {
	        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc4 = this.KEY_STR.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        buf.push(chr1);
	
	        if (enc3 !== 64) {
	          buf.push(chr2);
	        }
	        if (enc4 !== 64) {
	          buf.push(chr3);
	        }
	
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	
	      } while (i < input.length);
	
	      return buf;
	    };
	
	    return ExifRestorer.restore(orig, resized);  //<= EXIF
	  };
	
	  return upload;
	}]);
	


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.3.10
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	!function(a,b,c){"use strict";/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	/*
	 * HTML Parser By Misko Hevery (misko@hevery.com)
	 * based on:  HTML Parser By John Resig (ejohn.org)
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 *
	 * // Use like so:
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 */
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string, however, since our parser is more strict than a typical browser
	 *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
	 *   browser, won't make it through the sanitizer. The input may also contain SVG markup.
	 *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
	 *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	function d(){this.$get=["$$sanitizeUri",function(a){return function(b){"undefined"!=typeof arguments[1]&&(arguments[1].version="taSanitize");var c=[];return g(b,l(c,function(b,c){return!/^unsafe/.test(a(b,c))})),c.join("")}}]}function e(a){var c=[],d=l(c,b.noop);return d.chars(a),c.join("")}function f(a){var b,c={},d=a.split(",");for(b=0;b<d.length;b++)c[d[b]]=!0;return c}/**
	 * @example
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 * @param {string} html string
	 * @param {object} handler
	 */
	function g(a,c){function d(a,d,f,g){if(d=b.lowercase(d),D[d])for(;k.last()&&E[k.last()];)e("",k.last());C[d]&&k.last()==d&&e("",d),g=z[d]||!!g,g||k.push(d);var i={};f.replace(p,function(a,b,c,d,e){var f=c||d||e||"";i[b]=h(f)}),c.start&&c.start(d,i,g)}function e(a,d){var e,f=0;if(d=b.lowercase(d))
	// Find the closest opened tag of the same type
	for(f=k.length-1;f>=0&&k[f]!=d;f--);if(f>=0){
	// Close all the open elements, up the stack
	for(e=k.length-1;e>=f;e--)c.end&&c.end(k[e]);
	// Remove the open elements from the stack
	k.length=f}}"string"!=typeof a&&(a=null===a||"undefined"==typeof a?"":""+a);var f,g,i,j,k=[],l=a;for(k.last=function(){return k[k.length-1]};a;){
	// Make sure we're not in a script or style element
	if(j="",g=!0,k.last()&&G[k.last()])a=a.replace(new RegExp("([^]*)<\\s*\\/\\s*"+k.last()+"[^>]*>","i"),function(a,b){return b=b.replace(s,"$1").replace(v,"$1"),c.chars&&c.chars(h(b)),""}),e("",k.last());else{
	// White space
	if(y.test(a)){if(i=a.match(y)){i[0];c.whitespace&&c.whitespace(i[0]),a=a.replace(i[0],""),g=!1}}else t.test(a)?(i=a.match(t),i&&(c.comment&&c.comment(i[1]),a=a.replace(i[0],""),g=!1)):u.test(a)?(i=a.match(u),i&&(a=a.replace(i[0],""),g=!1)):r.test(a)?(i=a.match(o),i&&(a=a.substring(i[0].length),i[0].replace(o,e),g=!1)):q.test(a)&&(i=a.match(n),i?(
	// We only have a valid start-tag if there is a '>'.
	i[4]&&(a=a.substring(i[0].length),i[0].replace(n,d)),g=!1):(
	// no ending tag found --- this piece should be encoded as an entity.
	j+="<",a=a.substring(1)));g&&(f=a.indexOf("<"),j+=f<0?a:a.substring(0,f),a=f<0?"":a.substring(f),c.chars&&c.chars(h(j)))}if(a==l)throw m("badparse","The sanitizer was unable to parse the following block of html: {0}",a);l=a}
	// Clean up any remaining tags
	e()}/**
	 * decodes all entities into regular string
	 * @param value
	 * @returns {string} A string with decoded entities.
	 */
	function h(a){if(!a)return"";
	// Note: IE8 does not preserve spaces at the start/end of innerHTML
	// so we must capture them and reattach them afterward
	var b=N.exec(a),c=b[1],d=b[3],e=b[2];
	// innerText depends on styling as it doesn't display hidden elements.
	// Therefore, it's better to use textContent not to cause unnecessary
	// reflows. However, IE<9 don't support textContent so the innerText
	// fallback is necessary.
	return e&&(M.innerHTML=e.replace(/</g,"&lt;"),e="textContent"in M?M.textContent:M.innerText),c+e+d}/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param value
	 * @returns {string} escaped text
	 */
	function i(a){return a.replace(/&/g,"&amp;").replace(w,function(a){var b=a.charCodeAt(0),c=a.charCodeAt(1);return"&#"+(1024*(b-55296)+(c-56320)+65536)+";"}).replace(x,function(a){
	// unsafe chars are: \u0000-\u001f \u007f-\u009f \u00ad \u0600-\u0604 \u070f \u17b4 \u17b5 \u200c-\u200f \u2028-\u202f \u2060-\u206f \ufeff \ufff0-\uffff from jslint.com/lint.html
	// decimal values are: 0-31, 127-159, 173, 1536-1540, 1807, 6068, 6069, 8204-8207, 8232-8239, 8288-8303, 65279, 65520-65535
	var b=a.charCodeAt(0);
	// if unsafe character encode
	// if unsafe character encode
	return b<=159||173==b||b>=1536&&b<=1540||1807==b||6068==b||6069==b||b>=8204&&b<=8207||b>=8232&&b<=8239||b>=8288&&b<=8303||65279==b||b>=65520&&b<=65535?"&#"+b+";":a}).replace(/</g,"&lt;").replace(/>/g,"&gt;")}
	// Custom logic for accepting certain style options only - textAngular
	// Currently allows only the color, background-color, text-align, float, width and height attributes
	// all other attributes should be easily done through classes.
	function j(a){var c="",d=a.split(";");return b.forEach(d,function(a){var d=a.split(":");if(2==d.length){var e=O(b.lowercase(d[0])),a=O(b.lowercase(d[1]));(("color"===e||"background-color"===e)&&(a.match(/^rgb\([0-9%,\. ]*\)$/i)||a.match(/^rgba\([0-9%,\. ]*\)$/i)||a.match(/^hsl\([0-9%,\. ]*\)$/i)||a.match(/^hsla\([0-9%,\. ]*\)$/i)||a.match(/^#[0-9a-f]{3,6}$/i)||a.match(/^[a-z]*$/i))||"text-align"===e&&("left"===a||"right"===a||"center"===a||"justify"===a)||"text-decoration"===e&&("underline"===a||"line-through"===a)||"font-weight"===e&&"bold"===a||"font-style"===e&&"italic"===a||"float"===e&&("left"===a||"right"===a||"none"===a)||"vertical-align"===e&&("baseline"===a||"sub"===a||"super"===a||"test-top"===a||"text-bottom"===a||"middle"===a||"top"===a||"bottom"===a||a.match(/[0-9]*(px|em)/)||a.match(/[0-9]+?%/))||"font-size"===e&&("xx-small"===a||"x-small"===a||"small"===a||"medium"===a||"large"===a||"x-large"===a||"xx-large"===a||"larger"===a||"smaller"===a||a.match(/[0-9]*\.?[0-9]*(px|em|rem|mm|q|cm|in|pt|pc|%)/))||("width"===e||"height"===e)&&a.match(/[0-9\.]*(px|em|rem|%)/)||// Reference #520
	"direction"===e&&a.match(/^ltr|rtl|initial|inherit$/))&&(c+=e+": "+a+";")}}),c}
	// this function is used to manually allow specific attributes on specific tags with certain prerequisites
	function k(a,b,c,d){
	// catch the div placeholder for the iframe replacement
	return!("img"!==a||!b["ta-insert-video"]||"ta-insert-video"!==c&&"allowfullscreen"!==c&&"frameborder"!==c&&("contenteditable"!==c||"false"!==d))}/**
	 * create an HTML/XML writer which writes to buffer
	 * @param {Array} buf use buf.jain('') to get out sanitized html string
	 * @returns {object} in the form of {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * }
	 */
	function l(a,c){var d=!1,e=b.bind(a,a.push);return{start:function(a,f,g){a=b.lowercase(a),!d&&G[a]&&(d=a),d||H[a]!==!0||(e("<"),e(a),b.forEach(f,function(d,g){var h=b.lowercase(g),l="img"===a&&"src"===h||"background"===h;("style"===h&&""!==(d=j(d))||k(a,f,h,d)||L[h]===!0&&(I[h]!==!0||c(d,l)))&&(e(" "),e(g),e('="'),e(i(d)),e('"'))}),e(g?"/>":">"))},comment:function(a){e(a)},whitespace:function(a){e(i(a))},end:function(a){a=b.lowercase(a),d||H[a]!==!0||(e("</"),e(a),e(">")),a==d&&(d=!1)},chars:function(a){d||e(i(a))}}}var m=b.$$minErr("$sanitize"),n=/^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,o=/^<\/\s*([\w:-]+)[^>]*>/,p=/([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,q=/^</,r=/^<\//,s=/<!--(.*?)-->/g,t=/(^<!--.*?-->)/,u=/<!DOCTYPE([^>]*?)>/i,v=/<!\[CDATA\[(.*?)]]>/g,w=/[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	// Match everything outside of normal chars and " (quote character)
	x=/([^\#-~| |!])/g,y=/^(\s+)/,z=f("area,br,col,hr,img,wbr,input"),A=f("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),B=f("rp,rt"),C=b.extend({},B,A),D=b.extend({},A,f("address,article,aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul")),E=b.extend({},B,f("a,abbr,acronym,b,bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,samp,small,span,strike,strong,sub,sup,time,tt,u,var")),F=f("animate,animateColor,animateMotion,animateTransform,circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,set,stop,svg,switch,text,title,tspan,use"),G=f("script,style"),H=b.extend({},z,D,E,C,F),I=f("background,cite,href,longdesc,src,usemap,xlink:href"),J=f("abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,id,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,scope,scrolling,shape,size,span,start,summary,target,title,type,valign,value,vspace,width"),K=f("accent-height,accumulate,additive,alphabetic,arabic-form,ascent,attributeName,attributeType,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan"),L=b.extend({},I,K,J),M=document.createElement("pre"),N=/^(\s*)([\s\S]*?)(\s*)$/,O=function(){
	// native trim is way faster: http://jsperf.com/angular-trim-test
	// but IE doesn't have it... :-(
	// TODO: we should move this into IE/ES5 polyfill
	// native trim is way faster: http://jsperf.com/angular-trim-test
	// but IE doesn't have it... :-(
	// TODO: we should move this into IE/ES5 polyfill
	return String.prototype.trim?function(a){return b.isString(a)?a.trim():a}:function(a){return b.isString(a)?a.replace(/^\s\s*/,"").replace(/\s\s*$/,""):a}}();
	// define ngSanitize module and register $sanitize service
	b.module("ngSanitize",[]).provider("$sanitize",d),/* global sanitizeText: false */
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
	 * @returns {string} Html-linkified text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <script>
	         angular.module('linkyExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.snippet =
	               'Pretty text with some links:\n'+
	               'http://angularjs.org/,\n'+
	               'mailto:us@somewhere.org,\n'+
	               'another@somewhere.org,\n'+
	               'and one more: ftp://127.0.0.1/.';
	             $scope.snippetWithTarget = 'http://angularjs.org/';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Filter</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	     </file>
	   </example>
	 */
	b.module("ngSanitize").filter("linky",["$sanitize",function(a){var c=/((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"”’]/,d=/^mailto:/;return function(f,g){function h(a){a&&n.push(e(a))}function i(a,c){n.push("<a "),b.isDefined(g)&&n.push('target="',g,'" '),n.push('href="',a.replace(/"/g,"&quot;"),'">'),h(c),n.push("</a>")}if(!f)return f;for(var j,k,l,m=f,n=[];j=m.match(c);)
	// We can not end in these as they are sometimes found at the end of the sentence
	k=j[0],
	// if we did not match ftp/http/www/mailto then assume mailto
	j[2]||j[4]||(k=(j[3]?"http://":"mailto:")+k),l=j.index,h(m.substr(0,l)),i(k,j[0].replace(d,"")),m=m.substring(l+j[0].length);return h(m),a(n.join(""))}}])}(window,window.angular);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(a,b){ true?
	// AMD. Register as an anonymous module unless amdModuleId is set
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(37),__webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = function(c,d){return a["textAngular.name"]=b(c,d)}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?
	// Node. Does not work with strict CommonJS, but
	// only CommonJS-like environments that support module.exports,
	// like Node.
	module.exports=b(require("rangy"),require("rangy/lib/rangy-selectionsaverestore")):a.textAngular=b(rangy)}(this,function(a){
	// tests against the current jqLite/jquery implementation if this can be an element
	function b(a){try{return 0!==angular.element(a).length}catch(a){return!1}}/*
	    A tool definition is an object with the following key/value parameters:
	        action: [function(deferred, restoreSelection)]
	                a function that is executed on clicking on the button - this will allways be executed using ng-click and will
	                overwrite any ng-click value in the display attribute.
	                The function is passed a deferred object ($q.defer()), if this is wanted to be used `return false;` from the action and
	                manually call `deferred.resolve();` elsewhere to notify the editor that the action has finished.
	                restoreSelection is only defined if the rangy library is included and it can be called as `restoreSelection()` to restore the users
	                selection in the WYSIWYG editor.
	        display: [string]?
	                Optional, an HTML element to be displayed as the button. The `scope` of the button is the tool definition object with some additional functions
	                If set this will cause buttontext and iconclass to be ignored
	        class: [string]?
	                Optional, if set will override the taOptions.classes.toolbarButton class.
	        buttontext: [string]?
	                if this is defined it will replace the contents of the element contained in the `display` element
	        iconclass: [string]?
	                if this is defined an icon (<i>) will be appended to the `display` element with this string as it's class
	        tooltiptext: [string]?
	                Optional, a plain text description of the action, used for the title attribute of the action button in the toolbar by default.
	        activestate: [function(commonElement)]?
	                this function is called on every caret movement, if it returns true then the class taOptions.classes.toolbarButtonActive
	                will be applied to the `display` element, else the class will be removed
	        disabled: [function()]?
	                if this function returns true then the tool will have the class taOptions.classes.disabled applied to it, else it will be removed
	    Other functions available on the scope are:
	        name: [string]
	                the name of the tool, this is the first parameter passed into taRegisterTool
	        isDisabled: [function()]
	                returns true if the tool is disabled, false if it isn't
	        displayActiveToolClass: [function(boolean)]
	                returns true if the tool is 'active' in the currently focussed toolbar
	        onElementSelect: [Object]
	                This object contains the following key/value pairs and is used to trigger the ta-element-select event
	                element: [String]
	                    an element name, will only trigger the onElementSelect action if the tagName of the element matches this string
	                filter: [function(element)]?
	                    an optional filter that returns a boolean, if true it will trigger the onElementSelect.
	                action: [function(event, element, editorScope)]
	                    the action that should be executed if the onElementSelect function runs
	*/
	// name and toolDefinition to add into the tools available to be added on the toolbar
	function c(a,c){if(!a||""===a||e.hasOwnProperty(a))throw"textAngular Error: A unique name is required for a Tool Definition";if(c.display&&(""===c.display||!b(c.display))||!c.display&&!c.buttontext&&!c.iconclass)throw'textAngular Error: Tool Definition for "'+a+'" does not have a valid display/iconclass/buttontext value';e[a]=c}
	// usage is:
	// var t0 = performance.now();
	// doSomething();
	// var t1 = performance.now();
	// console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to do something!');
	//
	// turn html into pure text that shows visiblity
	function d(a){var b=document.createElement("DIV");b.innerHTML=a;var c=b.textContent||b.innerText||"";// zero width space
	return c.replace("​",""),c=c.trim()}
	// setup the global contstant functions for setting up the toolbar
	// all tool definitions
	var e={};angular.module("textAngularSetup",[]).constant("taRegisterTool",c).value("taTools",e).value("taOptions",{
	//////////////////////////////////////////////////////////////////////////////////////
	// forceTextAngularSanitize
	// set false to allow the textAngular-sanitize provider to be replaced
	// with angular-sanitize or a custom provider.
	forceTextAngularSanitize:!0,
	///////////////////////////////////////////////////////////////////////////////////////
	// keyMappings
	// allow customizable keyMappings for specialized key boards or languages
	//
	// keyMappings provides key mappings that are attached to a given commandKeyCode.
	// To modify a specific keyboard binding, simply provide function which returns true
	// for the event you wish to map to.
	// Or to disable a specific keyboard binding, provide a function which returns false.
	// Note: 'RedoKey' and 'UndoKey' are internally bound to the redo and undo functionality.
	// At present, the following commandKeyCodes are in use:
	// 98, 'TabKey', 'ShiftTabKey', 105, 117, 'UndoKey', 'RedoKey'
	//
	// To map to an new commandKeyCode, add a new key mapping such as:
	// {commandKeyCode: 'CustomKey', testForKey: function (event) {
	//  if (event.keyCode=57 && event.ctrlKey && !event.shiftKey && !event.altKey) return true;
	// } }
	// to the keyMappings. This example maps ctrl+9 to 'CustomKey'
	// Then where taRegisterTool(...) is called, add a commandKeyCode: 'CustomKey' and your
	// tool will be bound to ctrl+9.
	//
	// To disble one of the already bound commandKeyCodes such as 'RedoKey' or 'UndoKey' add:
	// {commandKeyCode: 'RedoKey', testForKey: function (event) { return false; } },
	// {commandKeyCode: 'UndoKey', testForKey: function (event) { return false; } },
	// to disable them.
	//
	keyMappings:[],toolbar:[["h1","h2","h3","h4","h5","h6","p","pre","quote"],["bold","italics","underline","strikeThrough","ul","ol","redo","undo","clear"],["justifyLeft","justifyCenter","justifyRight","justifyFull","indent","outdent"],["html","insertImage","insertLink","insertVideo","wordcount","charcount"]],classes:{focussed:"focussed",toolbar:"btn-toolbar",toolbarGroup:"btn-group",toolbarButton:"btn btn-default",toolbarButtonActive:"active",disabled:"disabled",textEditor:"form-control",htmlEditor:"form-control"},defaultTagAttributes:{a:{target:""}},setup:{
	// wysiwyg mode
	textEditorSetup:function(a){},
	// raw html
	htmlEditorSetup:function(a){}},defaultFileDropHandler:/* istanbul ignore next: untestable image processing */
	function(a,b){var c=new FileReader;return"image"===a.type.substring(0,5)&&(c.onload=function(){""!==c.result&&b("insertImage",c.result,!0)},c.readAsDataURL(a),!0)}}).value("taSelectableElements",["a","img"]).value("taCustomRenderers",[{
	// Parse back out: '<div class="ta-insert-video" ta-insert-video src="' + urlLink + '" allowfullscreen="true" width="300" frameborder="0" height="250"></div>'
	// To correct video element. For now only support youtube
	selector:"img",customAttribute:"ta-insert-video",renderLogic:function(a){var b=angular.element("<iframe></iframe>"),c=a.prop("attributes");
	// loop through element attributes and apply them on iframe
	angular.forEach(c,function(a){b.attr(a.name,a.value)}),b.attr("src",b.attr("ta-insert-video")),a.replaceWith(b)}}]).value("taTranslations",{
	// moved to sub-elements
	//toggleHTML: "Toggle HTML",
	//insertImage: "Please enter a image URL to insert",
	//insertLink: "Please enter a URL to insert",
	//insertVideo: "Please enter a youtube URL to embed",
	html:{tooltip:"Toggle html / Rich Text"},
	// tooltip for heading - might be worth splitting
	heading:{tooltip:"Heading "},p:{tooltip:"Paragraph"},pre:{tooltip:"Preformatted text"},ul:{tooltip:"Unordered List"},ol:{tooltip:"Ordered List"},quote:{tooltip:"Quote/unquote selection or paragraph"},undo:{tooltip:"Undo"},redo:{tooltip:"Redo"},bold:{tooltip:"Bold"},italic:{tooltip:"Italic"},underline:{tooltip:"Underline"},strikeThrough:{tooltip:"Strikethrough"},justifyLeft:{tooltip:"Align text left"},justifyRight:{tooltip:"Align text right"},justifyFull:{tooltip:"Justify text"},justifyCenter:{tooltip:"Center"},indent:{tooltip:"Increase indent"},outdent:{tooltip:"Decrease indent"},clear:{tooltip:"Clear formatting"},insertImage:{dialogPrompt:"Please enter an image URL to insert",tooltip:"Insert image",hotkey:"the - possibly language dependent hotkey ... for some future implementation"},insertVideo:{tooltip:"Insert video",dialogPrompt:"Please enter a youtube URL to embed"},insertLink:{tooltip:"Insert / edit link",dialogPrompt:"Please enter a URL to insert"},editLink:{reLinkButton:{tooltip:"Relink"},unLinkButton:{tooltip:"Unlink"},targetToggle:{buttontext:"Open in New Window"}},wordcount:{tooltip:"Display words Count"},charcount:{tooltip:"Display characters Count"}}).factory("taToolFunctions",["$window","taTranslations",function(a,b){return{imgOnSelectAction:function(a,b,c){
	// setup the editor toolbar
	// Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic/display
	var d=function(){c.updateTaBindtaTextElement(),c.hidePopover()};a.preventDefault(),c.displayElements.popover.css("width","375px");var e=c.displayElements.popoverContainer;e.empty();var f=angular.element('<div class="btn-group" style="padding-right: 6px;">'),g=angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">100% </button>');g.on("click",function(a){a.preventDefault(),b.css({width:"100%",height:""}),d()});var h=angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">50% </button>');h.on("click",function(a){a.preventDefault(),b.css({width:"50%",height:""}),d()});var i=angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">25% </button>');i.on("click",function(a){a.preventDefault(),b.css({width:"25%",height:""}),d()});var j=angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">Reset</button>');j.on("click",function(a){a.preventDefault(),b.css({width:"",height:""}),d()}),f.append(g),f.append(h),f.append(i),f.append(j),e.append(f),f=angular.element('<div class="btn-group" style="padding-right: 6px;">');var k=angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-left"></i></button>');k.on("click",function(a){a.preventDefault(),
	// webkit
	b.css("float","left"),
	// firefox
	b.css("cssFloat","left"),
	// IE < 8
	b.css("styleFloat","left"),d()});var l=angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-right"></i></button>');l.on("click",function(a){a.preventDefault(),
	// webkit
	b.css("float","right"),
	// firefox
	b.css("cssFloat","right"),
	// IE < 8
	b.css("styleFloat","right"),d()});var m=angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-justify"></i></button>');m.on("click",function(a){a.preventDefault(),
	// webkit
	b.css("float",""),
	// firefox
	b.css("cssFloat",""),
	// IE < 8
	b.css("styleFloat",""),d()}),f.append(k),f.append(m),f.append(l),e.append(f),f=angular.element('<div class="btn-group">');var n=angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-trash-o"></i></button>');n.on("click",function(a){a.preventDefault(),b.remove(),d()}),f.append(n),e.append(f),c.showPopover(b),c.showResizeOverlay(b)},aOnSelectAction:function(c,d,e){
	// setup the editor toolbar
	// Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic
	c.preventDefault(),e.displayElements.popover.css("width","436px");var f=e.displayElements.popoverContainer;f.empty(),f.css("line-height","28px");var g=angular.element('<a href="'+d.attr("href")+'" target="_blank">'+d.attr("href")+"</a>");g.css({display:"inline-block","max-width":"200px",overflow:"hidden","text-overflow":"ellipsis","white-space":"nowrap","vertical-align":"middle"}),f.append(g);var h=angular.element('<div class="btn-group pull-right">'),i=angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="'+b.editLink.reLinkButton.tooltip+'"><i class="fa fa-edit icon-edit"></i></button>');i.on("click",function(c){c.preventDefault();var f=a.prompt(b.insertLink.dialogPrompt,d.attr("href"));f&&""!==f&&"http://"!==f&&(d.attr("href",f),e.updateTaBindtaTextElement()),e.hidePopover()}),h.append(i);var j=angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="'+b.editLink.unLinkButton.tooltip+'"><i class="fa fa-unlink icon-unlink"></i></button>');
	// directly before this click event is fired a digest is fired off whereby the reference to $element is orphaned off
	j.on("click",function(a){a.preventDefault(),d.replaceWith(d.contents()),e.updateTaBindtaTextElement(),e.hidePopover()}),h.append(j);var k=angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on">'+b.editLink.targetToggle.buttontext+"</button>");"_blank"===d.attr("target")&&k.addClass("active"),k.on("click",function(a){a.preventDefault(),d.attr("target","_blank"===d.attr("target")?"":"_blank"),k.toggleClass("active"),e.updateTaBindtaTextElement()}),h.append(k),f.append(h),e.showPopover(d)},extractYoutubeVideoId:function(a){var b=/(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i,c=a.match(b);return c&&c[1]||null}}}]).run(["taRegisterTool","$window","taTranslations","taSelection","taToolFunctions","$sanitize","taOptions","$log",function(a,b,c,d,e,f,g,h){
	// test for the version of $sanitize that is in use
	// You can disable this check by setting taOptions.textAngularSanitize == false
	var i={};/* istanbul ignore next, throws error */
	if(f("",i),g.forceTextAngularSanitize===!0&&"taSanitize"!==i.version)throw angular.$$minErr("textAngular")("textAngularSetup","The textAngular-sanitize provider has been replaced by another -- have you included angular-sanitize by mistake?");a("html",{iconclass:"fa fa-code",tooltiptext:c.html.tooltip,action:function(){this.$editor().switchView()},activeState:function(){return this.$editor().showHtml}});
	// add the Header tools
	// convenience functions so that the loop works correctly
	var j=function(a){return function(){return this.$editor().queryFormatBlockState(a)}},k=function(){return this.$editor().wrapSelection("formatBlock","<"+this.name.toUpperCase()+">")};angular.forEach(["h1","h2","h3","h4","h5","h6"],function(b){a(b.toLowerCase(),{buttontext:b.toUpperCase(),tooltiptext:c.heading.tooltip+b.charAt(1),action:k,activeState:j(b.toLowerCase())})}),a("p",{buttontext:"P",tooltiptext:c.p.tooltip,action:function(){return this.$editor().wrapSelection("formatBlock","<P>")},activeState:function(){return this.$editor().queryFormatBlockState("p")}}),
	// key: pre -> taTranslations[key].tooltip, taTranslations[key].buttontext
	a("pre",{buttontext:"pre",tooltiptext:c.pre.tooltip,action:function(){return this.$editor().wrapSelection("formatBlock","<PRE>")},activeState:function(){return this.$editor().queryFormatBlockState("pre")}}),a("ul",{iconclass:"fa fa-list-ul",tooltiptext:c.ul.tooltip,action:function(){return this.$editor().wrapSelection("insertUnorderedList",null)},activeState:function(){return this.$editor().queryCommandState("insertUnorderedList")}}),a("ol",{iconclass:"fa fa-list-ol",tooltiptext:c.ol.tooltip,action:function(){return this.$editor().wrapSelection("insertOrderedList",null)},activeState:function(){return this.$editor().queryCommandState("insertOrderedList")}}),a("quote",{iconclass:"fa fa-quote-right",tooltiptext:c.quote.tooltip,action:function(){return this.$editor().wrapSelection("formatBlock","<BLOCKQUOTE>")},activeState:function(){return this.$editor().queryFormatBlockState("blockquote")}}),a("undo",{iconclass:"fa fa-undo",tooltiptext:c.undo.tooltip,action:function(){return this.$editor().wrapSelection("undo",null)}}),a("redo",{iconclass:"fa fa-repeat",tooltiptext:c.redo.tooltip,action:function(){return this.$editor().wrapSelection("redo",null)}}),a("bold",{iconclass:"fa fa-bold",tooltiptext:c.bold.tooltip,action:function(){return this.$editor().wrapSelection("bold",null)},activeState:function(){return this.$editor().queryCommandState("bold")},commandKeyCode:98}),a("justifyLeft",{iconclass:"fa fa-align-left",tooltiptext:c.justifyLeft.tooltip,action:function(){return this.$editor().wrapSelection("justifyLeft",null)},activeState:function(a){/* istanbul ignore next: */
	if(a&&"#document"===a.nodeName)return!1;var b=!1;if(a)
	// commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	// so we do try catch here...
	try{b="left"===a.css("text-align")||"left"===a.attr("align")||"right"!==a.css("text-align")&&"center"!==a.css("text-align")&&"justify"!==a.css("text-align")&&!this.$editor().queryCommandState("justifyRight")&&!this.$editor().queryCommandState("justifyCenter")&&!this.$editor().queryCommandState("justifyFull")}catch(a){/* istanbul ignore next: error handler */
	//console.log(e);
	b=!1}return b=b||this.$editor().queryCommandState("justifyLeft")}}),a("justifyRight",{iconclass:"fa fa-align-right",tooltiptext:c.justifyRight.tooltip,action:function(){return this.$editor().wrapSelection("justifyRight",null)},activeState:function(a){/* istanbul ignore next: */
	if(a&&"#document"===a.nodeName)return!1;var b=!1;if(a)
	// commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	// so we do try catch here...
	try{b="right"===a.css("text-align")}catch(a){/* istanbul ignore next: error handler */
	//console.log(e);
	b=!1}return b=b||this.$editor().queryCommandState("justifyRight")}}),a("justifyFull",{iconclass:"fa fa-align-justify",tooltiptext:c.justifyFull.tooltip,action:function(){return this.$editor().wrapSelection("justifyFull",null)},activeState:function(a){var b=!1;if(a)
	// commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	// so we do try catch here...
	try{b="justify"===a.css("text-align")}catch(a){/* istanbul ignore next: error handler */
	//console.log(e);
	b=!1}return b=b||this.$editor().queryCommandState("justifyFull")}}),a("justifyCenter",{iconclass:"fa fa-align-center",tooltiptext:c.justifyCenter.tooltip,action:function(){return this.$editor().wrapSelection("justifyCenter",null)},activeState:function(a){/* istanbul ignore next: */
	if(a&&"#document"===a.nodeName)return!1;var b=!1;if(a)
	// commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	// so we do try catch here...
	try{b="center"===a.css("text-align")}catch(a){/* istanbul ignore next: error handler */
	//console.log(e);
	b=!1}return b=b||this.$editor().queryCommandState("justifyCenter")}}),a("indent",{iconclass:"fa fa-indent",tooltiptext:c.indent.tooltip,action:function(){return this.$editor().wrapSelection("indent",null)},activeState:function(){return this.$editor().queryFormatBlockState("blockquote")},commandKeyCode:"TabKey"}),a("outdent",{iconclass:"fa fa-outdent",tooltiptext:c.outdent.tooltip,action:function(){return this.$editor().wrapSelection("outdent",null)},activeState:function(){return!1},commandKeyCode:"ShiftTabKey"}),a("italics",{iconclass:"fa fa-italic",tooltiptext:c.italic.tooltip,action:function(){return this.$editor().wrapSelection("italic",null)},activeState:function(){return this.$editor().queryCommandState("italic")},commandKeyCode:105}),a("underline",{iconclass:"fa fa-underline",tooltiptext:c.underline.tooltip,action:function(){return this.$editor().wrapSelection("underline",null)},activeState:function(){return this.$editor().queryCommandState("underline")},commandKeyCode:117}),a("strikeThrough",{iconclass:"fa fa-strikethrough",tooltiptext:c.strikeThrough.tooltip,action:function(){return this.$editor().wrapSelection("strikeThrough",null)},activeState:function(){return document.queryCommandState("strikeThrough")}}),a("clear",{iconclass:"fa fa-ban",tooltiptext:c.clear.tooltip,action:function(a,b){var c;this.$editor().wrapSelection("removeFormat",null);var e=angular.element(d.getSelectionElement());c=d.getAllSelectedElements();
	//$log.log('selectedElements:', selectedElements);
	// remove lists
	var f=function(a,b){a=angular.element(a);var c=b;return b||(c=a),angular.forEach(a.children(),function(a){if("ul"===a.tagName.toLowerCase()||"ol"===a.tagName.toLowerCase())c=f(a,c);else{var b=angular.element("<p></p>");b.html(angular.element(a).html()),c.after(b),c=b}}),a.remove(),c};angular.forEach(c,function(a){"ul"!==a.nodeName.toLowerCase()&&"ol"!==a.nodeName.toLowerCase()||
	//console.log('removeListElements', element);
	f(a)}),angular.forEach(e.find("ul"),f),angular.forEach(e.find("ol"),f);
	// clear out all class attributes. These do not seem to be cleared via removeFormat
	var g=this.$editor(),h=function(a){a=angular.element(a),/* istanbul ignore next: this is not triggered in tests any longer since we now never select the whole displayELement */
	a[0]!==g.displayElements.text[0]&&a.removeAttr("class"),angular.forEach(a.children(),h)};angular.forEach(e,h),
	// check if in list. If not in list then use formatBlock option
	e[0]&&"li"!==e[0].tagName.toLowerCase()&&"ol"!==e[0].tagName.toLowerCase()&&"ul"!==e[0].tagName.toLowerCase()&&"true"!==e[0].getAttribute("contenteditable")&&this.$editor().wrapSelection("formatBlock","default"),b()}});/* jshint -W099 */
	/****************************
	     //  we don't use this code - since the previous way CLEAR is expected to work does not clear partially selected <li>
	
	     var removeListElement = function(listE){
	                console.log(listE);
	                var _list = listE.parentNode.childNodes;
	                console.log('_list', _list);
	                var _preLis = [], _postLis = [], _found = false;
	                for (i = 0; i < _list.length; i++) {
	                    if (_list[i] === listE) {
	                        _found = true;
	                    } else if (!_found) _preLis.push(_list[i]);
	                    else _postLis.push(_list[i]);
	                }
	                var _parent = angular.element(listE.parentNode);
	                var newElem = angular.element('<p></p>');
	                newElem.html(angular.element(listE).html());
	                if (_preLis.length === 0 || _postLis.length === 0) {
	                    if (_postLis.length === 0) _parent.after(newElem);
	                    else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);
	
	                    if (_preLis.length === 0 && _postLis.length === 0) _parent.remove();
	                    else angular.element(listE).remove();
	                } else {
	                    var _firstList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
	                    var _secondList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
	                    for (i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
	                    for (i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
	                    _parent.after(_secondList);
	                    _parent.after(newElem);
	                    _parent.after(_firstList);
	                    _parent.remove();
	                }
	                taSelection.setSelectionToElementEnd(newElem[0]);
	            };
	
	     elementsSeen = [];
	     if (selectedElements.length !==0) console.log(selectedElements);
	     angular.forEach(selectedElements, function (element) {
	                if (elementsSeen.indexOf(element) !== -1 || elementsSeen.indexOf(element.parentElement) !== -1) {
	                    return;
	                }
	                elementsSeen.push(element);
	                if (element.nodeName.toLowerCase() === 'li') {
	                    console.log('removeListElement', element);
	                    removeListElement(element);
	                }
	                else if (element.parentElement && element.parentElement.nodeName.toLowerCase() === 'li') {
	                    console.log('removeListElement', element.parentElement);
	                    elementsSeen.push(element.parentElement);
	                    removeListElement(element.parentElement);
	                }
	            });
	     **********************/
	/**********************
	     if(possibleNodes[0].tagName.toLowerCase() === 'li'){
	                var _list = possibleNodes[0].parentNode.childNodes;
	                var _preLis = [], _postLis = [], _found = false;
	                for(i = 0; i < _list.length; i++){
	                    if(_list[i] === possibleNodes[0]){
	                        _found = true;
	                    }else if(!_found) _preLis.push(_list[i]);
	                    else _postLis.push(_list[i]);
	                }
	                var _parent = angular.element(possibleNodes[0].parentNode);
	                var newElem = angular.element('<p></p>');
	                newElem.html(angular.element(possibleNodes[0]).html());
	                if(_preLis.length === 0 || _postLis.length === 0){
	                    if(_postLis.length === 0) _parent.after(newElem);
	                    else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);
	
	                    if(_preLis.length === 0 && _postLis.length === 0) _parent.remove();
	                    else angular.element(possibleNodes[0]).remove();
	                }else{
	                    var _firstList = angular.element('<'+_parent[0].tagName+'></'+_parent[0].tagName+'>');
	                    var _secondList = angular.element('<'+_parent[0].tagName+'></'+_parent[0].tagName+'>');
	                    for(i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
	                    for(i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
	                    _parent.after(_secondList);
	                    _parent.after(newElem);
	                    _parent.after(_firstList);
	                    _parent.remove();
	                }
	                taSelection.setSelectionToElementEnd(newElem[0]);
	            }
	     *******************/
	/* istanbul ignore next: if it's javascript don't worry - though probably should show some kind of error message */
	var l=function(a){return a.toLowerCase().indexOf("javascript")!==-1};a("insertImage",{iconclass:"fa fa-picture-o",tooltiptext:c.insertImage.tooltip,action:function(){var a;if(a=b.prompt(c.insertImage.dialogPrompt,"http://"),a&&""!==a&&"http://"!==a&&!l(a)){d.getSelectionElement().tagName&&"a"===d.getSelectionElement().tagName.toLowerCase()&&
	// due to differences in implementation between FireFox and Chrome, we must move the
	// insertion point past the <a> element, otherwise FireFox inserts inside the <a>
	// With this change, both FireFox and Chrome behave the same way!
	d.setSelectionAfterElement(d.getSelectionElement());
	// In the past we used the simple statement:
	//return this.$editor().wrapSelection('insertImage', imageLink, true);
	//
	// However on Firefox only, when the content is empty this is a problem
	// See Issue #1201
	// Investigation reveals that Firefox only inserts a <p> only!!!!
	// So now we use insertHTML here and all is fine.
	// NOTE: this is what 'insertImage' is supposed to do anyway!
	var e='<img src="'+a+'">';return this.$editor().wrapSelection("insertHTML",e,!0)}},onElementSelect:{element:"img",action:e.imgOnSelectAction}}),a("insertVideo",{iconclass:"fa fa-youtube-play",tooltiptext:c.insertVideo.tooltip,action:function(){var a;
	// block javascript here
	/* istanbul ignore else: if it's javascript don't worry - though probably should show some kind of error message */
	if(a=b.prompt(c.insertVideo.dialogPrompt,"https://"),!l(a)&&a&&""!==a&&"https://"!==a&&(videoId=e.extractYoutubeVideoId(a),videoId)){
	// create the embed link
	var f="https://www.youtube.com/embed/"+videoId,g='<img class="ta-insert-video" src="https://img.youtube.com/vi/'+videoId+'/hqdefault.jpg" ta-insert-video="'+f+'" contenteditable="false" allowfullscreen="true" frameborder="0" />';
	// insert
	/* istanbul ignore next: don't know how to test this... since it needs a dialogPrompt */
	// due to differences in implementation between FireFox and Chrome, we must move the
	// insertion point past the <a> element, otherwise FireFox inserts inside the <a>
	// With this change, both FireFox and Chrome behave the same way!
	return d.getSelectionElement().tagName&&"a"===d.getSelectionElement().tagName.toLowerCase()&&d.setSelectionAfterElement(d.getSelectionElement()),this.$editor().wrapSelection("insertHTML",g,!0)}},onElementSelect:{element:"img",onlyWithAttrs:["ta-insert-video"],action:e.imgOnSelectAction}}),a("insertLink",{tooltiptext:c.insertLink.tooltip,iconclass:"fa fa-link",action:function(){var a;if(
	// if this link has already been set, we need to just edit the existing link
	/* istanbul ignore if: we do not test this */
	a=d.getSelectionElement().tagName&&"a"===d.getSelectionElement().tagName.toLowerCase()?b.prompt(c.insertLink.dialogPrompt,d.getSelectionElement().href):b.prompt(c.insertLink.dialogPrompt,"http://"),a&&""!==a&&"http://"!==a&&!l(a))return this.$editor().wrapSelection("createLink",a,!0)},activeState:function(a){return!!a&&"A"===a[0].tagName},onElementSelect:{element:"a",action:e.aOnSelectAction}}),a("wordcount",{display:'<div id="toolbarWC" style="display:block; min-width:100px;">Words: <span ng-bind="wordcount"></span></div>',disabled:!0,wordcount:0,activeState:function(){// this fires on keyup
	var a=this.$editor().displayElements.text,b=a[0].innerHTML||"",c=0;/* istanbul ignore if: will default to '' when undefined */
	//Set current scope
	//Set editor scope
	return""!==b.replace(/\s*<[^>]*?>\s*/g,"")&&""!==b.trim()&&(c=b.replace(/<\/?(b|i|em|strong|span|u|strikethrough|a|img|small|sub|sup|label)( [^>*?])?>/gi,"").replace(/(<[^>]*?>\s*<[^>]*?>)/gi," ").replace(/(<[^>]*?>)/gi,"").replace(/\s+/gi," ").match(/\S+/g).length),this.wordcount=c,this.$editor().wordcount=c,!1}}),a("charcount",{display:'<div id="toolbarCC" style="display:block; min-width:120px;">Characters: <span ng-bind="charcount"></span></div>',disabled:!0,charcount:0,activeState:function(){// this fires on keyup
	var a=this.$editor().displayElements.text,b=a[0].innerText||a[0].textContent,c=b.replace(/(\r\n|\n|\r)/gm,"").replace(/^\s+/g," ").replace(/\s+$/g," ").length;
	//Set current scope
	//Set editor scope
	return this.charcount=c,this.$editor().charcount=c,!1}})}]);// NOTE: textAngularVersion must match the Gruntfile.js 'setVersion' task.... and have format v/d+./d+./d+
	var f="v1.5.16",g={ie:function(){for(var a,b=3,c=document.createElement("div"),d=c.getElementsByTagName("i");c.innerHTML="<!--[if gt IE "+ ++b+"]><i></i><![endif]-->",d[0];);return b>4?b:a}(),webkit:/AppleWebKit\/([\d.]+)/i.test(navigator.userAgent),isFirefox:navigator.userAgent.toLowerCase().indexOf("firefox")>-1},h=h||{};/* istanbul ignore next: untestable browser check */
	h.now=function(){return h.now||h.mozNow||h.msNow||h.oNow||h.webkitNow||function(){return(new Date).getTime()}}();
	// Global to textAngular REGEXP vars for block and list elements.
	var i=/^(address|article|aside|audio|blockquote|canvas|center|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video)$/i,j=/^(ul|li|ol)$/i,k=/^(#text|span|address|article|aside|audio|blockquote|canvas|center|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video|li)$/i;
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Compatibility
	/* istanbul ignore next: trim shim for older browsers */
	String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")});/*
		Custom stylesheet for the placeholders rules.
		Credit to: http://davidwalsh.name/add-rules-stylesheets
	*/
	var l,m,n,o,p,q;/* istanbul ignore else: IE <8 test*/
	if(g.ie>8||void 0===g.ie){/* istanbul ignore next: preference for stylesheet loaded externally */
	for(var r=document.styleSheets,s=0;s<r.length;s++)if((0===r[s].media.length||r[s].media.mediaText.match(/(all|screen)/gi))&&r[s].href&&r[s].href.match(/textangular\.(min\.|)css/gi)){l=r[s];break}/* istanbul ignore next: preference for stylesheet loaded externally */
	l||(
	// this sheet is used for the placeholders later on.
	l=function(){
	// Create the <style> tag
	var a=document.createElement("style");/* istanbul ignore else : WebKit hack :( */
	// Add the <style> element to the page, add as first so the styles can be overridden by custom stylesheets
	return g.webkit&&a.appendChild(document.createTextNode("")),document.getElementsByTagName("head")[0].appendChild(a),a.sheet}()),
	// use as: addCSSRule("header", "float: left");
	m=function(a,b){return o(l,a,b)},o=function(a,b,c){var d,e;
	// return the inserted stylesheet rule
	// This order is important as IE 11 has both cssRules and rules but they have different lengths - cssRules is correct, rules gives an error in IE 11
	/* istanbul ignore next: browser catches */
	/* istanbul ignore else: untestable IE option */
	/* istanbul ignore next: browser catches */
	return a.cssRules?d=Math.max(a.cssRules.length-1,0):a.rules&&(d=Math.max(a.rules.length-1,0)),a.insertRule?a.insertRule(b+"{"+c+"}",d):a.addRule(b,c,d),l.rules?e=l.rules[d]:l.cssRules&&(e=l.cssRules[d]),e},q=function(a,b){var c,d;for(c=0;c<b.length;c++)/* istanbul ignore else: check for correct rule */
	if(b[c].cssText===a.cssText){d=c;break}return d},n=function(a){p(l,a)},/* istanbul ignore next: tests are browser specific */
	p=function(a,b){var c=a.cssRules||a.rules;if(c&&0!==c.length){var d=q(b,c);a.removeRule?a.removeRule(d):a.deleteRule(d)}}}angular.module("textAngular.factories",[]).factory("taBrowserTag",[function(){return function(a){/* istanbul ignore next: ie specific test */
	/* istanbul ignore next: ie specific test */
	return a?""===a?void 0===g.ie?"div":g.ie<=8?"P":"p":g.ie<=8?a.toUpperCase():a:g.ie<=8?"P":"p"}}]).factory("taApplyCustomRenderers",["taCustomRenderers","taDOM",function(a,b){return function(c){var d=angular.element("<div></div>");return d[0].innerHTML=c,angular.forEach(a,function(a){var c=[];
	// get elements based on what is defined. If both defined do secondary filter in the forEach after using selector string
	a.selector&&""!==a.selector?c=d.find(a.selector):a.customAttribute&&""!==a.customAttribute&&(c=b.getByAttribute(d,a.customAttribute)),
	// process elements if any found
	angular.forEach(c,function(b){b=angular.element(b),a.selector&&""!==a.selector&&a.customAttribute&&""!==a.customAttribute?void 0!==b.attr(a.customAttribute)&&a.renderLogic(b):a.renderLogic(b)})}),d[0].innerHTML}}]).factory("taFixChrome",function(){
	// get whaterever rubbish is inserted in chrome
	// should be passed an html string, returns an html string
	var a=function(a,b){if(!a||!angular.isString(a)||a.length<=0)return a;
	// remove all the Apple-converted-space spans and replace with the content of the span
	//console.log('before:', html);
	/* istanbul ignore next: apple-contereted-space span match */
	for(
	// grab all elements with a style attibute
	// a betterSpanMatch matches only a style=... with matching quotes
	// this captures the whole:
	// 'style="background-color: rgb(255, 255, 255);"'
	var c,d,e,f=/style\s?=\s?(["'])(?:(?=(\\?))\2.)*?\1/gi,g=/<span class="Apple-converted-space">([^<]+)<\/span>/gi,h="",i=0;c=g.exec(a);)e=c[1],e=e.replace(/&nbsp;/gi," "),h+=a.substring(i,c.index)+e,i=c.index+c[0].length;
	/////////////////////////////////////////////////////////////
	//
	// Allow control of this modification
	// taKeepStyles: False - removes these modification
	//
	// taFixChrome removes the following styles:
	//    font-family: inherit;
	//    line-height: <number>
	//    color: inherit;
	//    color: rgb( <rgb-component>#{3} )
	//    background-color: rgb( <rgb-component>#{3} )
	//
	/////////////////////////////////////////////////////////////
	if(/* istanbul ignore next: apple-contereted-space span has matched */
	i&&(
	// modified....
	h+=a.substring(i),a=h,h="",i=0),!b){for(;c=f.exec(a);)h+=a.substring(i,c.index-1),d=c[0],
	// test for chrome inserted junk
	c=/font-family: inherit;|line-height: 1.[0-9]{3,12};|color: inherit; line-height: 1.1;|color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);|background-color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);/gi.exec(d),c?(d=d.replace(/( |)font-family: inherit;|( |)line-height: 1.[0-9]{3,12};|( |)color: inherit;|( |)color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);|( |)background-color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);/gi,""),
	//console.log(styleVal, styleVal.length);
	d.length>8&&(h+=" "+d)):h+=" "+d,i=f.lastIndex;h+=a.substring(i)}
	//console.log('final:', finalHtml);
	// only replace when something has changed, else we get focus problems on inserting lists
	if(i>0){
	// replace all empty strings
	var j=h.replace(/<span\s?>(.*?)<\/span>(<br(\/|)>|)/gi,"$1");return j}return a};return a}).factory("taSanitize",["$sanitize",function(a){function b(a,b){for(var c,d=0,e=0,f=/<[^>]*>/gi;c=f.exec(a);)if(e=c.index,"/"===c[0].substr(1,1)){if(0===d)break;d--}else d++;
	// get the start tags reversed - this is safe as we construct the strings with no content except the tags
	return b+a.substring(0,e)+angular.element(b)[0].outerHTML.substring(b.length)+a.substring(e)}function c(a){if(!a||!angular.isString(a)||a.length<=0)return a;for(var d,f,g,h,i,k,l=/<([^>\/]+?)style=("([^"]+)"|'([^']+)')([^>]*)>/gi,m="",n="",o=0;f=l.exec(a);){
	// one of the quoted values ' or "
	/* istanbul ignore next: quotations match */
	h=f[3]||f[4];var p=new RegExp(j,"i");
	// test for style values to change
	if(angular.isString(h)&&p.test(h)){
	// remove build tag list
	i="";
	// find relevand tags and build a string of them
	for(
	// init regex here for exec
	var q=new RegExp(j,"ig");g=q.exec(h);)for(d=0;d<e.length;d++)g[2*d+2]&&(i+="<"+e[d].tag+">");
	// recursively find more legacy styles in html before this tag and after the previous match (if any)
	k=c(a.substring(o,f.index)),
	// build up html
	n+=m.length>0?b(k,m):k,
	// grab the style val without the transformed values
	h=h.replace(new RegExp(j,"ig"),""),
	// build the html tag
	n+="<"+f[1].trim(),h.length>0&&(n+=' style="'+h+'"'),n+=f[5]+">",
	// update the start index to after this tag
	o=f.index+f[0].length,m=i}}return n+=m.length>0?b(a.substring(o),m):a.substring(o)}function d(a){if(!a||!angular.isString(a)||a.length<=0)return a;
	// match all attr tags
	for(
	// replace all align='...' tags with text-align attributes
	var b,c=/<([^>\/]+?)align=("([^"]+)"|'([^']+)')([^>]*)>/gi,d="",e=0;b=c.exec(a);){
	// add all html before this tag
	d+=a.substring(e,b.index),
	// record last index after this tag
	e=b.index+b[0].length;
	// construct tag without the align attribute
	var f="<"+b[1]+b[5];
	// add the style attribute
	/style=("([^"]+)"|'([^']+)')/gi.test(f)?/* istanbul ignore next: quotations match */
	f=f.replace(/style=("([^"]+)"|'([^']+)')/i,'style="$2$3 text-align:'+(b[3]||b[4])+';"'):/* istanbul ignore next: quotations match */
	f+=' style="text-align:'+(b[3]||b[4])+';"',f+=">",
	// add to html
	d+=f}
	// return with remaining html
	return d+a.substring(e)}for(var e=[{property:"font-weight",values:["bold"],tag:"b"},{property:"font-style",values:["italic"],tag:"i"}],f=[],g=0;g<e.length;g++){for(var h="("+e[g].property+":\\s*(",i=0;i<e[g].values.length;i++)/* istanbul ignore next: not needed to be tested yet */
	i>0&&(h+="|"),h+=e[g].values[i];h+=");)",f.push(h)}var j="("+f.join("|")+")",k=new RegExp(/<span id="selectionBoundary_\d+_\d+" class="rangySelectionBoundary">[^<>]+?<\/span>/gi),l=new RegExp(/<span class="rangySelectionBoundary" id="selectionBoundary_\d+_\d+">[^<>]+?<\/span>/gi),m=new RegExp(/<span id="selectionBoundary_\d+_\d+" class="rangySelectionBoundary">[^<>]+?<\/span>/gi);return function(b,e,f){
	// unsafe html should NEVER built into a DOM object via angular.element. This allows XSS to be inserted and run.
	if(!f)try{b=c(b)}catch(a){}
	// we had an issue in the past, where we dumped a whole bunch of <span>'s into the content...
	// so we remove them here
	// IN A FUTURE release this can be removed after all have updated through release 1.5.9
	if(
	// unsafe and oldsafe should be valid HTML strings
	// any exceptions (lets say, color for example) should be made here but with great care
	// setup unsafe element for modification
	b=d(b))try{b=b.replace(k,""),b=b.replace(l,""),b=b.replace(k,""),b=b.replace(m,"")}catch(a){}var g;try{g=a(b),
	// do this afterwards, then the $sanitizer should still throw for bad markup
	f&&(g=b)}catch(a){g=e||""}
	// Do processing for <pre> tags, removing tabs and return carriages outside of them
	var h,i=g.match(/(<pre[^>]*>.*?<\/pre[^>]*>)/gi),j=g.replace(/(&#(9|10);)*/gi,""),n=/<pre[^>]*>.*?<\/pre[^>]*>/gi,o=0,p=0;for(g="";null!==(h=n.exec(j))&&o<i.length;)g+=j.substring(p,h.index)+i[o],p=h.index+h[0].length,o++;return g+j.substring(p)}}]).factory("taToolExecuteAction",["$q","$log",function(a,b){
	// this must be called on a toolScope or instance
	return function(c){void 0!==c&&(this.$editor=function(){return c});var d,e=a.defer(),f=e.promise,g=this.$editor();try{d=this.action(e,g.startAction()),
	// We set the .finally callback here to make sure it doesn't get executed before any other .then callback.
	f.finally(function(){g.endAction.call(g)})}catch(a){b.error(a)}(d||void 0===d)&&
	// if true or undefined is returned then the action has finished. Otherwise the deferred action will be resolved manually.
	e.resolve()}}]),angular.module("textAngular.DOM",["textAngular.factories"]).factory("taExecCommand",["taSelection","taBrowserTag","$document",function(b,c,d){var e=function(a,c){var d,e,f=a.find("li");for(e=f.length-1;e>=0;e--)d=angular.element("<"+c+">"+f[e].innerHTML+"</"+c+">"),a.after(d);a.remove(),b.setSelectionToElementEnd(d[0])},f=function(a,d,e,f,g){var h,i,j,k,l,m=a.find("li");for(i=0;i<m.length;i++)if(m[i].outerHTML===d[0].outerHTML){
	// found it...
	l=i,i>0&&(j=m[i-1]),i+1<m.length&&(k=m[i+1]);break}
	//console.log('listElementToSelfTag', list, listElement, selfTag, bDefault, priorElement, nextElement);
	// un-list the listElement
	var n="";
	//console.log('$target', $target[0]);
	if(f?n+="<"+g+">"+d[0].innerHTML+"</"+g+">":(n+="<"+c(e)+">",n+="<li>"+d[0].innerHTML+"</li>",n+="</"+c(e)+">"),h=angular.element(n),!j)
	// this is the first the list, so we just remove it...
	return d.remove(),a.after(angular.element(a[0].outerHTML)),a.after(h),a.remove(),void b.setSelectionToElementEnd(h[0]);if(k){var o=(a.parent(),""),p=a[0].nodeName.toLowerCase();for(o+="<"+p+">",i=0;i<l;i++)o+="<li>"+m[i].innerHTML+"</li>";o+="</"+p+">";var q="";for(q+="<"+p+">",i=l+1;i<m.length;i++)q+="<li>"+m[i].innerHTML+"</li>";q+="</"+p+">",
	//console.log(html1, $target[0], html2);
	a.after(angular.element(q)),a.after(h),a.after(angular.element(o)),a.remove(),
	//console.log('parent ******XXX*****', p[0]);
	b.setSelectionToElementEnd(h[0])}else
	// this is the last in the list, so we just remove it..
	d.remove(),a.after(h),b.setSelectionToElementEnd(h[0])},g=function(a,d,e,f,g){var h,i,j,k,l,m=a.find("li"),n=[];for(i=0;i<m.length;i++)for(j=0;j<d.length;j++)m[i].isEqualNode(d[j])&&(
	// found it...
	n[j]=i);n[0]>0&&(k=m[n[0]-1]),n[d.length-1]+1<m.length&&(l=m[n[d.length-1]+1]);
	//console.log('listElementsToSelfTag', list, listElements, selfTag, bDefault, !priorElement, !afterElement, foundIndexes[listElements.length-1], children.length);
	// un-list the listElements
	var o="";if(f)for(j=0;j<d.length;j++)o+="<"+g+">"+d[j].innerHTML+"</"+g+">",d[j].remove();else{for(o+="<"+c(e)+">",j=0;j<d.length;j++)o+=d[j].outerHTML,d[j].remove();o+="</"+c(e)+">"}if(h=angular.element(o),!k)
	// this is the first the list, so we just remove it...
	return a.after(angular.element(a[0].outerHTML)),a.after(h),a.remove(),void b.setSelectionToElementEnd(h[0]);if(!l)
	// this is the last in the list, so we just remove it..
	return a.after(h),void b.setSelectionToElementEnd(h[0]);
	// okay it was some where in the middle... so we need to break apart the list...
	var p="",q=a[0].nodeName.toLowerCase();for(p+="<"+q+">",i=0;i<n[0];i++)p+="<li>"+m[i].innerHTML+"</li>";p+="</"+q+">";var r="";for(r+="<"+q+">",i=n[d.length-1]+1;i<m.length;i++)r+="<li>"+m[i].innerHTML+"</li>";r+="</"+q+">",a.after(angular.element(r)),a.after(h),a.after(angular.element(p)),a.remove(),
	//console.log('parent ******YYY*****', list.parent()[0]);
	b.setSelectionToElementEnd(h[0])},h=function(a){/(<br(|\/)>)$/i.test(a.innerHTML.trim())?b.setSelectionBeforeElement(angular.element(a).find("br")[0]):b.setSelectionToElementEnd(a)},k=function(a,b){var c=angular.element("<"+b+">"+a[0].innerHTML+"</"+b+">");a.after(c),a.remove(),h(c.find("li")[0])},l=function(a,b,d){for(var e="",f=0;f<a.length;f++)e+="<"+c("li")+">"+a[f].innerHTML+"</"+c("li")+">";var g=angular.element("<"+d+">"+e+"</"+d+">");b.after(g),b.remove(),h(g.find("li")[0])},m=function(a,b){for(var c=0;c<a.childNodes.length;c++){var d=a.childNodes[c];/* istanbul ignore next - more complex testing*/
	d.tagName&&d.tagName.match(i)&&m(d,b)}/* istanbul ignore next - very rare condition that we do not test*/
	if(null===a.parentNode)
	// nothing left to do..
	return a;/* istanbul ignore next - not sure have to test this */
	if("<br>"===b)return a;var e=angular.element(b);return e[0].innerHTML=a.innerHTML,a.parentNode.insertBefore(e[0],a),a.parentNode.removeChild(a),e};return function(h,n){
	// NOTE: here we are dealing with the html directly from the browser and not the html the user sees.
	// IF you want to modify the html the user sees, do it when the user does a switchView
	return h=c(h),function(o,p,q,r){var s,t,u,v,w,x,y,z,A=angular.element("<"+h+">");try{b.getSelection&&(z=b.getSelection()),y=b.getSelectionElement();
	// special checks and fixes when we are selecting the whole container
	var B,C;/* istanbul ignore next */
	void 0!==y.tagName&&("div"===y.tagName.toLowerCase()&&/taTextElement.+/.test(y.id)&&z&&z.start&&1===z.start.offset&&1===z.end.offset?(
	// opps we are actually selecting the whole container!
	//console.log('selecting whole container!');
	B=y.innerHTML,/<br>/i.test(B)&&(
	// Firefox adds <br>'s and so we remove the <br>
	B=B.replace(/<br>/i,"&#8203;")),/<br\/>/i.test(B)&&(
	// Firefox adds <br/>'s and so we remove the <br/>
	B=B.replace(/<br\/>/i,"&#8203;")),
	// remove stacked up <span>'s
	/<span>(<span>)+/i.test(B)&&(B=__.replace(/<span>(<span>)+/i,"<span>")),
	// remove stacked up </span>'s
	/<\/span>(<\/span>)+/i.test(B)&&(B=__.replace(/<\/span>(<\/span>)+/i,"</span>")),/<span><\/span>/i.test(B)&&(
	// if we end up with a <span></span> here we remove it...
	B=B.replace(/<span><\/span>/i,"")),
	//console.log('inner whole container', selectedElement.childNodes);
	C="<div>"+B+"</div>",y.innerHTML=C,b.setSelectionToElementEnd(y.childNodes[0]),y=b.getSelectionElement()):"span"===y.tagName.toLowerCase()&&z&&z.start&&1===z.start.offset&&1===z.end.offset?(
	// just a span -- this is a problem...
	//console.log('selecting span!');
	B=y.innerHTML,/<br>/i.test(B)&&(
	// Firefox adds <br>'s and so we remove the <br>
	B=B.replace(/<br>/i,"&#8203;")),/<br\/>/i.test(B)&&(
	// Firefox adds <br/>'s and so we remove the <br/>
	B=B.replace(/<br\/>/i,"&#8203;")),
	// remove stacked up <span>'s
	/<span>(<span>)+/i.test(B)&&(B=__.replace(/<span>(<span>)+/i,"<span>")),
	// remove stacked up </span>'s
	/<\/span>(<\/span>)+/i.test(B)&&(B=__.replace(/<\/span>(<\/span>)+/i,"</span>")),/<span><\/span>/i.test(B)&&(
	// if we end up with a <span></span> here we remove it...
	B=B.replace(/<span><\/span>/i,"")),
	//console.log('inner span', selectedElement.childNodes);
	// we wrap this in a <div> because otherwise the browser get confused when we attempt to select the whole node
	// and the focus is not set correctly no matter what we do
	C="<div>"+B+"</div>",y.innerHTML=C,b.setSelectionToElementEnd(y.childNodes[0]),y=b.getSelectionElement()):"p"===y.tagName.toLowerCase()&&z&&z.start&&1===z.start.offset&&1===z.end.offset?(
	//console.log('p special');
	// we need to remove the </br> that firefox adds!
	B=y.innerHTML,/<br>/i.test(B)&&(
	// Firefox adds <br>'s and so we remove the <br>
	B=B.replace(/<br>/i,"&#8203;"),// no space-space
	y.innerHTML=B)):"li"===y.tagName.toLowerCase()&&z&&z.start&&z.start.offset===z.end.offset&&(
	// we need to remove the </br> that firefox adds!
	B=y.innerHTML,/<br>/i.test(B)&&(
	// Firefox adds <br>'s and so we remove the <br>
	B=B.replace(/<br>/i,""),// nothing
	y.innerHTML=B)))}catch(a){}
	//console.log('************** selectedElement:', selectedElement);
	/* istanbul ignore if: */
	if(y){var D=angular.element(y),E=y&&y.tagName&&y.tagName.toLowerCase()||/* istanbul ignore next: */
	"";if("insertorderedlist"===o.toLowerCase()||"insertunorderedlist"===o.toLowerCase()){var F=c("insertorderedlist"===o.toLowerCase()?"ol":"ul"),G=b.getOnlySelectedElements();
	//console.log('PPPPPPPPPPPPP', tagName, selfTag, selectedElements, tagName.match(BLOCKELEMENTS), $selected.hasClass('ta-bind'), $selected.parent()[0].tagName);
	if(G.length>1&&("ol"===E||"ul"===E))return g(D,G,F,F===E,h);if(E===F)
	// if all selected then we should remove the list
	// grab all li elements and convert to taDefaultWrap tags
	//console.log('tagName===selfTag');
	// if all selected then we should remove the list
	// grab all li elements and convert to taDefaultWrap tags
	//console.log('tagName===selfTag');
	return D[0].childNodes.length!==G.length&&1===G.length?(D=angular.element(G[0]),f(D.parent(),D,F,!0,h)):e(D,h);if("li"===E&&D.parent()[0].tagName.toLowerCase()===F&&1===D.parent().children().length)
	// catch for the previous statement if only one li exists
	return e(D.parent(),h);if("li"===E&&D.parent()[0].tagName.toLowerCase()!==F&&1===D.parent().children().length)
	// catch for the previous statement if only one li exists
	return k(D.parent(),F);if(E.match(i)&&!D.hasClass("ta-bind")){
	// if it's one of those block elements we have to change the contents
	// if it's a ol/ul we are changing from one to the other
	if(G.length&&D[0].childNodes.length!==G.length&&1===G.length)
	//console.log('&&&&&&&&&&&&&&& --------- &&&&&&&&&&&&&&&&', selectedElements[0], $selected[0].childNodes);
	return D=angular.element(G[0]),f(D.parent(),D,F,F===E,h);if("ol"===E||"ul"===E)
	// now if this is a set of selected elements... behave diferently
	return k(D,F);var H=!1;return angular.forEach(D.children(),function(a){a.tagName.match(i)&&(H=!0)}),H?l(D.children(),D,F):l([angular.element("<div>"+y.innerHTML+"</div>")[0]],D,F)}if(E.match(i)){
	//console.log('_nodes', _nodes, tagName);
	if(
	// if we get here then the contents of the ta-bind are selected
	v=b.getOnlySelectedElements(),0===v.length)
	// here is if there is only text in ta-bind ie <div ta-bind>test content</div>
	t=angular.element("<"+F+"><li>"+y.innerHTML+"</li></"+F+">"),D.html(""),D.append(t);else{if(1===v.length&&("ol"===v[0].tagName.toLowerCase()||"ul"===v[0].tagName.toLowerCase()))return v[0].tagName.toLowerCase()===F?e(angular.element(v[0]),h):k(angular.element(v[0]),F);u="";var I=[];for(s=0;s<v.length;s++)/* istanbul ignore else: catch for real-world can't make it occur in testing */
	if(3!==v[s].nodeType){var J=angular.element(v[s]);/* istanbul ignore if: browser check only, phantomjs doesn't return children nodes but chrome at least does */
	if("li"===v[s].tagName.toLowerCase())continue;u+="ol"===v[s].tagName.toLowerCase()||"ul"===v[s].tagName.toLowerCase()?J[0].innerHTML:"span"!==v[s].tagName.toLowerCase()||"ol"!==v[s].childNodes[0].tagName.toLowerCase()&&"ul"!==v[s].childNodes[0].tagName.toLowerCase()?"<"+c("li")+">"+J[0].innerHTML+"</"+c("li")+">":J[0].childNodes[0].innerHTML,I.unshift(J)}
	//console.log('$nodes', $nodes);
	t=angular.element("<"+F+">"+u+"</"+F+">"),I.pop().replaceWith(t),angular.forEach(I,function(a){a.remove()})}return void b.setSelectionToElementEnd(t[0])}}else{if("formatblock"===o.toLowerCase()){
	// find the first blockElement
	for(x=q.toLowerCase().replace(/[<>]/gi,""),"default"===x.trim()&&(x=h,q="<"+h+">"),t="li"===E?D.parent():D;!t[0].tagName||!t[0].tagName.match(i)&&!t.parent().attr("contenteditable");)t=t.parent(),/* istanbul ignore next */
	E=(t[0].tagName||"").toLowerCase();if(E===x){
	// $target is wrap element
	v=t.children();var K=!1;for(s=0;s<v.length;s++)K=K||v[s].tagName.match(i);K?(t.after(v),w=t.next(),t.remove(),t=w):(A.append(t[0].childNodes),t.after(A),t.remove(),t=A)}else if(t.parent()[0].tagName.toLowerCase()!==x||t.parent().hasClass("ta-bind"))if(E.match(j))
	// wrapping a list element
	t.wrap(q);else{
	// find the parent block element if any of the nodes are inline or text
	for(
	// default wrap behaviour
	v=b.getOnlySelectedElements(),0===v.length&&(
	// no nodes at all....
	v=[t[0]]),s=0;s<v.length;s++)if(3===v[s].nodeType||!v[s].tagName.match(i))for(;3===v[s].nodeType||!v[s].tagName||!v[s].tagName.match(i);)v[s]=v[s].parentNode;if(
	// remove any duplicates from the array of _nodes!
	v=v.filter(function(a,b,c){return c.indexOf(a)===b}),
	// remove all whole taTextElement if it is here... unless it is the only element!
	v.length>1&&(v=v.filter(function(a,b,c){return!("div"===a.nodeName.toLowerCase()&&/^taTextElement/.test(a.id))})),angular.element(v[0]).hasClass("ta-bind"))t=angular.element(q),t[0].innerHTML=v[0].innerHTML,v[0].innerHTML=t[0].outerHTML;else if("blockquote"===x){for(
	// blockquotes wrap other block elements
	u="",s=0;s<v.length;s++)u+=v[s].outerHTML;for(t=angular.element(q),t[0].innerHTML=u,v[0].parentNode.insertBefore(t[0],v[0]),s=v.length-1;s>=0;s--)/* istanbul ignore else:  */
	v[s].parentNode&&v[s].parentNode.removeChild(v[s])}else/* istanbul ignore next: not tested since identical to blockquote */
	if("pre"===x&&b.getStateShiftKey()){for(
	//console.log('shift pre', _nodes);
	// pre wrap other block elements
	u="",s=0;s<v.length;s++)u+=v[s].outerHTML;for(t=angular.element(q),t[0].innerHTML=u,v[0].parentNode.insertBefore(t[0],v[0]),s=v.length-1;s>=0;s--)/* istanbul ignore else:  */
	v[s].parentNode&&v[s].parentNode.removeChild(v[s])}else
	//console.log(optionsTagName, _nodes);
	// regular block elements replace other block elements
	for(s=0;s<v.length;s++){var L=m(v[s],q);v[s]===t[0]&&(t=angular.element(L))}}else{
	//unwrap logic for parent
	var M=t.parent(),N=M.contents();for(s=0;s<N.length;s++)/* istanbul ignore next: can't test - some wierd thing with how phantomjs works */
	M.parent().hasClass("ta-bind")&&3===N[s].nodeType&&(A=angular.element("<"+h+">"),A[0].innerHTML=N[s].outerHTML,N[s]=A[0]),M.parent()[0].insertBefore(N[s],M[0]);M.remove()}
	// looses focus when we have the whole container selected and no text!
	// refocus on the shown display element, this fixes a bug when using firefox
	return b.setSelectionToElementEnd(t[0]),void t[0].focus()}if("createlink"===o.toLowerCase()){/* istanbul ignore next: firefox specific fix */
	if("a"===E)
	// already a link!!! we are just replacing it...
	return void(b.getSelectionElement().href=q);var O='<a href="'+q+'" target="'+(r.a.target?r.a.target:"")+'">',P="</a>",Q=b.getSelection();if(Q.collapsed)
	//console.log('collapsed');
	// insert text at selection, then select then just let normal exec-command run
	b.insertHtml(O+q+P,n);else if(a.getSelection().getRangeAt(0).canSurroundContents()){var R=angular.element(O+P)[0];a.getSelection().getRangeAt(0).surroundContents(R)}return}if("inserthtml"===o.toLowerCase())
	//console.log('inserthtml');
	return void b.insertHtml(q,n)}try{d[0].execCommand(o,p,q)}catch(a){}}}}}]).service("taSelection",["$document","taDOM","$log",/* istanbul ignore next: all browser specifics and PhantomJS dosen't seem to support half of it */
	function(b,c,d){
	// need to dereference the document else the calls don't work correctly
	var e,f=b[0],g=function(a,b){/* check if selection is a BR element at the beginning of a container. If so, get
	        * the parentNode instead.
	        * offset should be zero in this case. Otherwise, return the original
	        * element.
	        */
	/* check if selection is a BR element at the beginning of a container. If so, get
	        * the parentNode instead.
	        * offset should be zero in this case. Otherwise, return the original
	        * element.
	        */
	return a.tagName&&a.tagName.match(/^br$/i)&&0===b&&!a.previousSibling?{element:a.parentNode,offset:0}:{element:a,offset:b}},h={getSelection:function(){var b;try{
	// catch any errors from rangy and ignore the issue
	b=a.getSelection().getRangeAt(0)}catch(a){
	//console.info(e);
	return}var c=b.commonAncestorContainer,d={start:g(b.startContainer,b.startOffset),end:g(b.endContainer,b.endOffset),collapsed:b.collapsed};
	//console.log('***selection container:', selection.container.nodeName, selection.start.offset, selection.container);
	// This has problems under Firefox.
	// On Firefox with
	// <p>Try me !</p>
	// <ul>
	// <li>line 1</li>
	// <li>line 2</li>
	// </ul>
	// <p>line 3</p>
	// <ul>
	// <li>line 4</li>
	// <li>line 5</li>
	// </ul>
	// <p>Hello textAngular</p>
	// WITH the cursor after the 3 on line 3, it gets the commonAncestorContainer as:
	// <TextNode textContent='line 3'>
	// AND Chrome gets the commonAncestorContainer as:
	// <p>line 3</p>
	//
	// Check if the container is a text node and return its parent if so
	// unless this is the whole taTextElement.  If so we return the textNode
	//console.log('*********taTextElement************');
	//console.log('commonAncestorContainer:', container);
	return 3===c.nodeType&&("div"===c.parentNode.nodeName.toLowerCase()&&/^taTextElement/.test(c.parentNode.id)||(c=c.parentNode)),"div"===c.nodeName.toLowerCase()&&/^taTextElement/.test(c.id)?(d.start.element=c.childNodes[d.start.offset],d.end.element=c.childNodes[d.end.offset],d.container=c):c.parentNode===d.start.element||c.parentNode===d.end.element?d.container=c.parentNode:d.container=c,d},
	// if we use the LEFT_ARROW and we are at the special place <span>&#65279;</span> we move the cursor over by one...
	// Chrome and Firefox behave differently so so fix this for Firefox here.  No adjustment needed for Chrome.
	updateLeftArrowKey:function(b){var c=a.getSelection().getRangeAt(0);if(c&&c.collapsed){var d=h.getFlattenedDom(c);if(!d.findIndex)return;var e,f,g=c.startContainer,i=d.findIndex(function(a,b){if(a.node===g)return!0;var c=a.parents.indexOf(g);return c!==-1});
	//console.log('updateLeftArrowKey', range.startOffset, range.startContainer.textContent);
	// this first section handles the case for Chrome browser
	// if the first character of the nextNode is a \ufeff we know that we are just before the special span...
	// and so we most left by one character
	if(
	//console.log('indexStartContainer', indexStartContainer, _nodes.length, 'startContainer:', _node, _node === _nodes[indexStartContainer].node);
	d.forEach(function(a,b){
	//console.log(i, n.node);
	a.parents.forEach(function(a,b){})}),i+1<d.length&&(
	// we need the node just after this startContainer
	// so we can check and see it this is a special place
	f=d[i+1].node),f&&f.textContent&&(e=/^\ufeff([^\ufeff]*)$/.exec(f.textContent)))
	// we are before the special node with begins with a \ufeff character
	//console.log('LEFT ...found it...', 'startOffset:', range.startOffset, m[0].length, m[1].length);
	// no need to change anything in this case
	return;var j;if(i>0&&(
	// we need the node just after this startContainer
	// so we can check and see it this is a special place
	j=d[i-1].node),0===c.startOffset&&j&&(
	//console.log(nextNodeToLeft, range.startOffset, nextNodeToLeft.textContent);
	e=/^\ufeff([^\ufeff]*)$/.exec(j.textContent)))
	//console.log('LEFT &&&&&&&&&&&&&&&&&&&...found it...&&&&&&&&&&&', nextNodeToLeft, m[0].length, m[1].length);
	// move over to the left my one -- Firefox triggers this case
	return void h.setSelectionToElementEnd(j)}},
	// if we use the RIGHT_ARROW and we are at the special place <span>&#65279;</span> we move the cursor over by one...
	updateRightArrowKey:function(a){},getFlattenedDom:function(a){function b(a){if(a.node.childNodes.length){var c=Array.prototype.slice.call(a.node.childNodes);// converts NodeList to Array
	c.forEach(function(c){var d=a.parents.slice();d.slice(-1)[0]!==a.node&&d.push(a.node),b({parents:d,node:c})})}else d.push({parents:a.parents,node:a.node})}var c=a.commonAncestorContainer.parentNode;if(!c)return a.commonAncestorContainer.childNodes;var d=Array.prototype.slice.call(c.childNodes),e=d.indexOf(a.startContainer);
	// make sure that we have a big enough set of nodes
	// now walk the parent
	return e+1<d.length&&e>0||c.parentNode&&(c=c.parentNode),d=[],b({parents:[c],node:c}),d},getOnlySelectedElements:function(){var b=a.getSelection().getRangeAt(0),c=b.commonAncestorContainer;
	// get the nodes in the range that are ELEMENT_NODE and are children of the container
	// in this range...
	// Node.TEXT_NODE === 3
	// Node.ELEMENT_NODE === 1
	// Node.COMMENT_NODE === 8
	// Check if the container is a text node and return its parent if so
	return c=3===c.nodeType?c.parentNode:c,b.getNodes([1],function(a){return a.parentNode===c})},
	// this includes the container element if all children are selected
	getAllSelectedElements:function(){var b=a.getSelection().getRangeAt(0),c=b.commonAncestorContainer;
	// Node.TEXT_NODE === 3
	// Node.ELEMENT_NODE === 1
	// Node.COMMENT_NODE === 8
	// Check if the container is a text node and return its parent if so
	c=3===c.nodeType?c.parentNode:c;
	// get the nodes in the range that are ELEMENT_NODE and are children of the container
	// in this range...
	var d=b.getNodes([1],function(a){return a.parentNode===c}),e=c.innerHTML;
	//console.log(innerHtml);
	//console.log(range.toHtml());
	//console.log(innerHtml === range.toHtml());
	if(
	// remove the junk that rangy has put down
	e=e.replace(/<span id=.selectionBoundary[^>]+>\ufeff?<\/span>/gi,""),e===b.toHtml()&&("div"!==c.nodeName.toLowerCase()||!/^taTextElement/.test(c.id))){for(var f=[],g=d.length;g--;f.unshift(d[g]));d=f,d.push(c)}return d},
	// Some basic selection functions
	getSelectionElement:function(){var a=h.getSelection();return a?h.getSelection().container:void 0},setSelection:function(b,c,d,e){var f=a.createRange();f.setStart(b,d),f.setEnd(c,e),a.getSelection().setSingleRange(f)},setSelectionBeforeElement:function(b){var c=a.createRange();c.selectNode(b),c.collapse(!0),a.getSelection().setSingleRange(c)},setSelectionAfterElement:function(b){var c=a.createRange();c.selectNode(b),c.collapse(!1),a.getSelection().setSingleRange(c)},setSelectionToElementStart:function(b){var c=a.createRange();c.selectNodeContents(b),c.collapse(!0),a.getSelection().setSingleRange(c)},setSelectionToElementEnd:function(b){var c=a.createRange();c.selectNodeContents(b),c.collapse(!1),b.childNodes&&b.childNodes[b.childNodes.length-1]&&"br"===b.childNodes[b.childNodes.length-1].nodeName&&(c.startOffset=c.endOffset=c.startOffset-1),a.getSelection().setSingleRange(c)},setStateShiftKey:function(a){e=a},getStateShiftKey:function(){return e},
	// from http://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div
	// topNode is the contenteditable normally, all manipulation MUST be inside this.
	insertHtml:function(b,d){var e,g,j,l,m,n,o,p=angular.element("<div>"+b+"</div>"),q=a.getSelection().getRangeAt(0),r=f.createDocumentFragment(),s=p[0].childNodes,t=!0;if(s.length>0){for(
	// NOTE!! We need to do the following:
	// check for blockelements - if they exist then we have to split the current element in half (and all others up to the closest block element) and insert all children in-between.
	// If there are no block elements, or there is a mixture we need to create textNodes for the non wrapped text (we don't want them spans messing up the picture).
	l=[],j=0;j<s.length;j++){var u=s[j];"p"===u.nodeName.toLowerCase()&&""===u.innerHTML.trim()||(/****************
	                     *  allow any text to be inserted...
	                    if((   _cnode.nodeType === 3 &&
	                           _cnode.nodeValue === '\ufeff'[0] &&
	                           _cnode.nodeValue.trim() === '') // empty no-space space element
	                        ) {
	                        // no change to isInline
	                        nodes.push(_cnode);
	                        continue;
	                    }
	                    if(_cnode.nodeType === 3 &&
	                         _cnode.nodeValue.trim() === '') { // empty text node
	                        continue;
	                    }
	                    *****************/
	t=t&&!i.test(u.nodeName),l.push(u))}for(var v=0;v<l.length;v++)n=r.appendChild(l[v]);!t&&q.collapsed&&/^(|<br(|\/)>)$/i.test(q.startContainer.innerHTML)&&q.selectNode(q.startContainer)}else t=!0,
	// paste text of some sort
	n=r=f.createTextNode(b);
	// Other Edge case - selected data spans multiple blocks.
	if(t)q.deleteContents();else// not inline insert
	if(q.collapsed&&q.startContainer!==d)if(q.startContainer.innerHTML&&q.startContainer.innerHTML.match(/^<[^>]*>$/i))
	// this log is to catch when innerHTML is something like `<img ...>`
	e=q.startContainer,1===q.startOffset?(
	// before single tag
	q.setStartAfter(e),q.setEndAfter(e)):(
	// after single tag
	q.setStartBefore(e),q.setEndBefore(e));else{
	// split element into 2 and insert block element in middle
	if(3===q.startContainer.nodeType&&q.startContainer.parentNode!==d)
	// Escape out of the inline tags like b
	for(// if text node
	e=q.startContainer.parentNode,g=e.cloneNode(),
	// split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
	c.splitNodes(e.childNodes,e,g,q.startContainer,q.startOffset);!k.test(e.nodeName);){angular.element(e).after(g),e=e.parentNode;var w=g;g=e.cloneNode(),
	// split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
	c.splitNodes(e.childNodes,e,g,w)}else e=q.startContainer,g=e.cloneNode(),c.splitNodes(e.childNodes,e,g,void 0,void 0,q.startOffset);if(angular.element(e).after(g),
	// put cursor to end of inserted content
	//console.log('setStartAfter', parent);
	q.setStartAfter(e),q.setEndAfter(e),/^(|<br(|\/)>)$/i.test(e.innerHTML.trim())&&(q.setStartBefore(e),q.setEndBefore(e),angular.element(e).remove()),/^(|<br(|\/)>)$/i.test(g.innerHTML.trim())&&angular.element(g).remove(),"li"===e.nodeName.toLowerCase()){for(o=f.createDocumentFragment(),m=0;m<r.childNodes.length;m++)p=angular.element("<li>"),c.transferChildNodes(r.childNodes[m],p[0]),c.transferNodeAttributes(r.childNodes[m],p[0]),o.appendChild(p[0]);r=o,n&&(n=r.childNodes[r.childNodes.length-1],n=n.childNodes[n.childNodes.length-1])}}else q.deleteContents();q.insertNode(r),n&&h.setSelectionToElementEnd(n)}};return h}]).service("taDOM",function(){var a={
	// recursive function that returns an array of angular.elements that have the passed attribute set on them
	getByAttribute:function(b,c){var d=[],e=b.children();return e.length&&angular.forEach(e,function(b){d=d.concat(a.getByAttribute(angular.element(b),c))}),void 0!==b.attr(c)&&d.push(b),d},transferChildNodes:function(a,b){for(
	// clear out target
	b.innerHTML="";a.childNodes.length>0;)b.appendChild(a.childNodes[0]);return b},splitNodes:function(b,c,d,e,f,g){if(!e&&isNaN(g))throw new Error("taDOM.splitNodes requires a splitNode or splitIndex");for(var h=document.createDocumentFragment(),i=document.createDocumentFragment(),j=0;b.length>0&&(isNaN(g)||g!==j)&&b[0]!==e;)h.appendChild(b[0]),// this removes from the nodes array (if proper childNodes object.
	j++;for(!isNaN(f)&&f>=0&&b[0]&&(h.appendChild(document.createTextNode(b[0].nodeValue.substring(0,f))),b[0].nodeValue=b[0].nodeValue.substring(f));b.length>0;)i.appendChild(b[0]);a.transferChildNodes(h,c),a.transferChildNodes(i,d)},transferNodeAttributes:function(a,b){for(var c=0;c<a.attributes.length;c++)b.setAttribute(a.attributes[c].name,a.attributes[c].value);return b}};return a}),angular.module("textAngular.validators",[]).directive("taMaxText",function(){return{restrict:"A",require:"ngModel",link:function(a,b,c,d){var e=parseInt(a.$eval(c.taMaxText));if(isNaN(e))throw"Max text must be an integer";c.$observe("taMaxText",function(a){if(e=parseInt(a),isNaN(e))throw"Max text must be an integer";d.$dirty&&d.$validate()}),d.$validators.taMaxText=function(a){var b=angular.element("<div/>");return b.html(a),b.text().length<=e}}}}).directive("taMinText",function(){return{restrict:"A",require:"ngModel",link:function(a,b,c,d){var e=parseInt(a.$eval(c.taMinText));if(isNaN(e))throw"Min text must be an integer";c.$observe("taMinText",function(a){if(e=parseInt(a),isNaN(e))throw"Min text must be an integer";d.$dirty&&d.$validate()}),d.$validators.taMinText=function(a){var b=angular.element("<div/>");return b.html(a),!b.text().length||b.text().length>=e}}}}),angular.module("textAngular.taBind",["textAngular.factories","textAngular.DOM"]).service("_taBlankTest",[function(){return function(a){
	// we radically restructure this code.
	// what was here before was incredibly fragile.
	// What we do now is to check that the html is non-blank visually
	// which we check by looking at html->text
	if(!a)return!0;
	// find first non-tag match - ie start of string or after tag that is not whitespace
	// var t0 = performance.now();
	// Takes a small fraction of a mSec to do this...
	var b=d(a);
	// var t1 = performance.now();
	// console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to generate:');
	// var t1 = performance.now();
	// console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to generate:');
	return""===b&&!/<img[^>]+>/.test(a)}}]).directive("taButton",[function(){return{link:function(a,b,c){b.attr("unselectable","on"),b.on("mousedown",function(a,b){/* istanbul ignore else: this is for catching the jqLite testing*/
	// this prevents focusout from firing on the editor when clicking toolbar buttons
	return b&&angular.extend(a,b),a.preventDefault(),!1})}}}]).directive("taBind",["taSanitize","$timeout","$document","taFixChrome","taBrowserTag","taSelection","taSelectableElements","taApplyCustomRenderers","taOptions","_taBlankTest","$parse","taDOM","textAngularManager",function(b,c,d,e,f,h,j,l,o,p,q,r,s){
	// Uses for this are textarea or input with ng-model and ta-bind='text'
	// OR any non-form element with contenteditable="contenteditable" ta-bind="html|text" ng-model
	return{priority:2,// So we override validators correctly
	require:["ngModel","?ngModelOptions"],link:function(f,r,u,v){function w(a){var b;return V.forEach(function(c){if(c.keyCode===a.keyCode){var d=(a.metaKey?N:0)+(a.ctrlKey?M:0)+(a.shiftKey?P:0)+(a.altKey?O:0);if(c.forbiddenModifiers&d)return;c.mustHaveModifiers.every(function(a){return d&a})&&(b=c.specialKey)}}),b}var x,y,z,A,B=v[0],C=v[1]||{},D=void 0!==r.attr("contenteditable")&&r.attr("contenteditable"),E=D||"textarea"===r[0].tagName.toLowerCase()||"input"===r[0].tagName.toLowerCase(),F=!1,G=!1,H=!1,I=u.taUnsafeSanitizer||o.disableSanitizer,J=u.taKeepStyles||o.keepStyles,K=/^(9|19|20|27|33|34|35|36|37|38|39|40|45|112|113|114|115|116|117|118|119|120|121|122|123|144|145)$/i,L=/^(8|13|32|46|59|61|107|109|173|186|187|188|189|190|191|192|219|220|221|222)$/i,M=1,N=2,O=4,P=8,Q=13,R=16,S=9,T=37,U=39,V=[
	//		ctrl/command + z
	{specialKey:"UndoKey",forbiddenModifiers:O+P,mustHaveModifiers:[N+M],keyCode:90},
	//		ctrl/command + shift + z
	{specialKey:"RedoKey",forbiddenModifiers:O,mustHaveModifiers:[N+M,P],keyCode:90},
	//		ctrl/command + y
	{specialKey:"RedoKey",forbiddenModifiers:O+P,mustHaveModifiers:[N+M],keyCode:89},
	//		TabKey
	{specialKey:"TabKey",forbiddenModifiers:N+P+O+M,mustHaveModifiers:[],keyCode:S},
	//		shift + TabKey
	{specialKey:"ShiftTabKey",forbiddenModifiers:N+O+M,mustHaveModifiers:[P],keyCode:S}];
	// set the default to be a paragraph value
	void 0===u.taDefaultWrap&&(u.taDefaultWrap="p"),/* istanbul ignore next: ie specific test */
	""===u.taDefaultWrap?(z="",A=void 0===g.ie?"<div><br></div>":g.ie>=11?"<p><br></p>":g.ie<=8?"<P>&nbsp;</P>":"<p>&nbsp;</p>"):(z=void 0===g.ie||g.ie>=11?"br"===u.taDefaultWrap.toLowerCase()?"<BR><BR>":"<"+u.taDefaultWrap+"><br></"+u.taDefaultWrap+">":g.ie<=8?"<"+u.taDefaultWrap.toUpperCase()+"></"+u.taDefaultWrap.toUpperCase()+">":"<"+u.taDefaultWrap+"></"+u.taDefaultWrap+">",A=void 0===g.ie||g.ie>=11?"br"===u.taDefaultWrap.toLowerCase()?"<br><br>":"<"+u.taDefaultWrap+"><br></"+u.taDefaultWrap+">":g.ie<=8?"<"+u.taDefaultWrap.toUpperCase()+">&nbsp;</"+u.taDefaultWrap.toUpperCase()+">":"<"+u.taDefaultWrap+">&nbsp;</"+u.taDefaultWrap+">"),/* istanbul ignore else */
	C.$options||(C.$options={});// ng-model-options support
	var W=function(a){if(p(a))return a;var b=angular.element("<div>"+a+"</div>");
	//console.log('domTest.children().length():', domTest.children().length);
	//console.log('_ensureContentWrapped', domTest.children());
	//console.log(value, attrs.taDefaultWrap);
	if(0===b.children().length)
	// if we have a <br> and the attrs.taDefaultWrap is a <p> we need to remove the <br>
	//value = value.replace(/<br>/i, '');
	a="<"+u.taDefaultWrap+">"+a+"</"+u.taDefaultWrap+">";else{var c,d=b[0].childNodes,e=!1;for(c=0;c<d.length&&!(e=d[c].nodeName.toLowerCase().match(i));c++);if(e)for(a="",c=0;c<d.length;c++){var f=d[c],g=f.nodeName.toLowerCase();
	//console.log('node#:', i, 'name:', nodeName);
	if("#comment"===g)a+="<!--"+f.nodeValue+"-->";else if("#text"===g){
	// determine if this is all whitespace, if so, we will leave it as it is.
	// otherwise, we will wrap it as it is
	var h=f.textContent;
	// not pure white space so wrap in <p>...</p> or whatever attrs.taDefaultWrap is set to.
	a+=h.trim()?"<"+u.taDefaultWrap+">"+h+"</"+u.taDefaultWrap+">":h}else if(g.match(i))a+=f.outerHTML;else{/* istanbul ignore  next: Doesn't seem to trigger on tests */
	var j=f.outerHTML||f.nodeValue;/* istanbul ignore else: Doesn't seem to trigger on tests, is tested though */
	a+=""!==j.trim()?"<"+u.taDefaultWrap+">"+j+"</"+u.taDefaultWrap+">":j}}else a="<"+u.taDefaultWrap+">"+a+"</"+u.taDefaultWrap+">"}
	//console.log(value);
	return a};u.taPaste&&(y=q(u.taPaste)),r.addClass("ta-bind");var X;f["$undoManager"+(u.id||"")]=B.$undoManager={_stack:[],_index:0,_max:1e3,push:function(a){return"undefined"==typeof a||null===a||"undefined"!=typeof this.current()&&null!==this.current()&&a===this.current()?a:(this._index<this._stack.length-1&&(this._stack=this._stack.slice(0,this._index+1)),this._stack.push(a),X&&c.cancel(X),this._stack.length>this._max&&this._stack.shift(),this._index=this._stack.length-1,a)},undo:function(){return this.setToIndex(this._index-1)},redo:function(){return this.setToIndex(this._index+1)},setToIndex:function(a){if(!(a<0||a>this._stack.length-1))return this._index=a,this.current()},current:function(){return this._stack[this._index]}};
	// in here we are undoing the converts used elsewhere to prevent the < > and & being displayed when they shouldn't in the code.
	var Y,Z=function(){if(D)return r[0].innerHTML;if(E)return r.val();throw"textAngular Error: attempting to update non-editable taBind"},$=function(a){
	// emit the element-select event, pass the element
	return f.$emit("ta-element-select",this),a.preventDefault(),!1},_=f["reApplyOnSelectorHandlers"+(u.id||"")]=function(){/* istanbul ignore else */
	F||angular.forEach(j,function(a){
	// check we don't apply the handler twice
	r.find(a).off("click",$).on("click",$)})},aa=function(a,b,c){H=c||!1,"undefined"!=typeof b&&null!==b||(b=D),// if not contentEditable then the native undo/redo is fine
	"undefined"!=typeof a&&null!==a||(a=Z()),p(a)?(
	// this avoids us from tripping the ng-pristine flag if we click in and out with out typing
	""!==B.$viewValue&&B.$setViewValue(""),b&&""!==B.$undoManager.current()&&B.$undoManager.push("")):(_(),B.$viewValue!==a&&(B.$setViewValue(a),b&&B.$undoManager.push(a))),B.$render()},ba=function(a){r[0].innerHTML=a},ca=f["$undoTaBind"+(u.id||"")]=function(){/* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
	if(!F&&D){var a=B.$undoManager.undo();"undefined"!=typeof a&&null!==a&&(ba(a),aa(a,!1),Y&&c.cancel(Y),Y=c(function(){r[0].focus(),h.setSelectionToElementEnd(r[0])},1))}},da=f["$redoTaBind"+(u.id||"")]=function(){/* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
	if(!F&&D){var a=B.$undoManager.redo();"undefined"!=typeof a&&null!==a&&(ba(a),aa(a,!1),/* istanbul ignore next */
	Y&&c.cancel(Y),Y=c(function(){r[0].focus(),h.setSelectionToElementEnd(r[0])},1))}};
	//used for updating when inserting wrapped elements
	f["updateTaBind"+(u.id||"")]=function(){F||aa(void 0,void 0,!0)};
	// catch DOM XSS via taSanitize
	// Sanitizing both ways is identical
	var ea=function(a){return B.$oldViewValue=b(e(a,J),B.$oldViewValue,I)};
	//this code is used to update the models when data is entered/deleted
	if(
	// trigger the validation calls
	r.attr("required")&&(B.$validators.required=function(a,b){return!p(a||b)}),
	// parsers trigger from the above keyup function or any other time that the viewValue is updated and parses it for storage in the ngModel
	B.$parsers.push(ea),B.$parsers.unshift(W),
	// because textAngular is bi-directional (which is awesome) we need to also sanitize values going in from the server
	B.$formatters.push(ea),B.$formatters.unshift(W),B.$formatters.unshift(function(a){return B.$undoManager.push(a||"")}),E)if(f.events={},D){
	// all the code specific to contenteditable divs
	var fa=!1,ga=function(a){var d=void 0!==a&&a.match(/content=["']*OneNote.File/i);/* istanbul ignore else: don't care if nothing pasted */
	//console.log(text);
	if(a&&a.trim().length){
	// test paste from word/microsoft product
	if(a.match(/class=["']*Mso(Normal|List)/i)||a.match(/content=["']*Word.Document/i)||a.match(/content=["']*OneNote.File/i)){var e=a.match(/<!--StartFragment-->([\s\S]*?)<!--EndFragment-->/i);e=e?e[1]:a,e=e.replace(/<o:p>[\s\S]*?<\/o:p>/gi,"").replace(/class=(["']|)MsoNormal(["']|)/gi,"");var g=angular.element("<div>"+e+"</div>"),i=angular.element("<div></div>"),j={element:null,lastIndent:[],lastLi:null,isUl:!1};j.lastIndent.peek=function(){var a=this.length;if(a>0)return this[a-1]};for(var k=function(a){j.isUl=a,j.element=angular.element(a?"<ul>":"<ol>"),j.lastIndent=[],j.lastIndent.peek=function(){var a=this.length;if(a>0)return this[a-1]},j.lastLevelMatch=null},l=0;l<=g[0].childNodes.length;l++)if(g[0].childNodes[l]&&"#text"!==g[0].childNodes[l].nodeName){var m=g[0].childNodes[l].tagName.toLowerCase();if("p"===m||"ul"===m||"h1"===m||"h2"===m||"h3"===m||"h4"===m||"h5"===m||"h6"===m||"table"===m){var n=angular.element(g[0].childNodes[l]),o=(n.attr("class")||"").match(/MsoList(Bullet|Number|Paragraph)(CxSp(First|Middle|Last)|)/i);if(o){if(n[0].childNodes.length<2||n[0].childNodes[1].childNodes.length<1)continue;var p="bullet"===o[1].toLowerCase()||"number"!==o[1].toLowerCase()&&!(/^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(n[0].childNodes[1].innerHTML)||/^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(n[0].childNodes[1].childNodes[0].innerHTML)),q=(n.attr("style")||"").match(/margin-left:([\-\.0-9]*)/i),s=parseFloat(q?q[1]:0),t=(n.attr("style")||"").match(/mso-list:l([0-9]+) level([0-9]+) lfo[0-9+]($|;)/i);if(
	// prefers the mso-list syntax
	t&&t[2]&&(s=parseInt(t[2])),t&&(!j.lastLevelMatch||t[1]!==j.lastLevelMatch[1])||!o[3]||"first"===o[3].toLowerCase()||null===j.lastIndent.peek()||j.isUl!==p&&j.lastIndent.peek()===s)k(p),i.append(j.element);else if(null!=j.lastIndent.peek()&&j.lastIndent.peek()<s)j.element=angular.element(p?"<ul>":"<ol>"),j.lastLi.append(j.element);else if(null!=j.lastIndent.peek()&&j.lastIndent.peek()>s){for(;null!=j.lastIndent.peek()&&j.lastIndent.peek()>s;)if("li"!==j.element.parent()[0].tagName.toLowerCase()){if(!/[uo]l/i.test(j.element.parent()[0].tagName.toLowerCase()))// else it's it should be a sibling
	break;j.element=j.element.parent(),j.lastIndent.pop()}else j.element=j.element.parent();j.isUl="ul"===j.element[0].tagName.toLowerCase(),p!==j.isUl&&(k(p),i.append(j.element))}j.lastLevelMatch=t,s!==j.lastIndent.peek()&&j.lastIndent.push(s),j.lastLi=angular.element("<li>"),j.element.append(j.lastLi),j.lastLi.html(n.html().replace(/<!(--|)\[if !supportLists\](--|)>[\s\S]*?<!(--|)\[endif\](--|)>/gi,"")),n.remove()}else k(!1),i.append(n)}}var u=function(a){a=angular.element(a);for(var b=a[0].childNodes.length-1;b>=0;b--)a.after(a[0].childNodes[b]);a.remove()};angular.forEach(i.find("span"),function(a){a.removeAttribute("lang"),a.attributes.length<=0&&u(a)}),angular.forEach(i.find("font"),u),a=i.html(),d&&(a=i.html()||g.html()),
	// LF characters instead of spaces in some spots and they are replaced by '/n', so we need to just swap them to spaces
	a=a.replace(/\n/g," ")}else{if(
	// remove unnecessary chrome insert
	a=a.replace(/<(|\/)meta[^>]*?>/gi,""),a.match(/<[^>]*?(ta-bind)[^>]*?>/)){
	// entire text-angular or ta-bind has been pasted, REMOVE AT ONCE!!
	if(a.match(/<[^>]*?(text-angular)[^>]*?>/)){var v=angular.element("<div>"+a+"</div>");v.find("textarea").remove();for(var w=0;w<binds.length;w++){for(var x=binds[w][0].parentNode.parentNode,z=0;z<binds[w][0].childNodes.length;z++)x.parentNode.insertBefore(binds[w][0].childNodes[z],x);x.parentNode.removeChild(x)}a=v.html().replace('<br class="Apple-interchange-newline">',"")}}else a.match(/^<span/)&&(
	// in case of pasting only a span - chrome paste, remove them. THis is just some wierd formatting
	// if we remove the '<span class="Apple-converted-space"> </span>' here we destroy the spacing
	// on paste from even ourselves!
	a.match(/<span class=(\"Apple-converted-space\"|\'Apple-converted-space\')>.<\/span>/gi)||(a=a.replace(/<(|\/)span[^>]*?>/gi,"")));
	// Webkit on Apple tags
	a=a.replace(/<br class="Apple-interchange-newline"[^>]*?>/gi,"").replace(/<span class="Apple-converted-space">( |&nbsp;)<\/span>/gi,"&nbsp;")}/<li(\s.*)?>/i.test(a)&&/(<ul(\s.*)?>|<ol(\s.*)?>).*<li(\s.*)?>/i.test(a)===!1&&(
	// insert missing parent of li element
	a=a.replace(/<li(\s.*)?>.*<\/li(\s.*)?>/i,"<ul>$&</ul>")),
	// parse whitespace from plaintext input, starting with preceding spaces that get stripped on paste
	a=a.replace(/^[ |\u00A0]+/gm,function(a){for(var b="",c=0;c<a.length;c++)b+="&nbsp;";return b}).replace(/\n|\r\n|\r/g,"<br />").replace(/\t/g,"&nbsp;&nbsp;&nbsp;&nbsp;"),y&&(a=y(f,{$html:a})||a),
	// turn span vertical-align:super into <sup></sup>
	a=a.replace(/<span style=("|')([^<]*?)vertical-align\s*:\s*super;?([^>]*?)("|')>([^<]+?)<\/span>/g,"<sup style='$2$3'>$5</sup>"),a=b(a,"",I),
	//console.log('DONE\n', text);
	h.insertHtml(a,r[0]),c(function(){B.$setViewValue(Z()),fa=!1,r.removeClass("processing-paste")},0)}else fa=!1,r.removeClass("processing-paste")};r.on("paste",f.events.paste=function(b,e){if(/* istanbul ignore else: this is for catching the jqLite testing*/
	e&&angular.extend(b,e),F||fa)return b.stopPropagation(),b.preventDefault(),!1;
	// Code adapted from http://stackoverflow.com/questions/2176861/javascript-get-clipboard-data-on-paste-event-cross-browser/6804718#6804718
	fa=!0,r.addClass("processing-paste");var f,g=(b.originalEvent||b).clipboardData;/* istanbul ignore next: Handle legacy IE paste */
	if(!g&&window.clipboardData&&window.clipboardData.getData)return f=window.clipboardData.getData("Text"),ga(f),b.stopPropagation(),b.preventDefault(),!1;if(g&&g.getData&&g.types.length>0){for(var h="",i=0;i<g.types.length;i++)h+=" "+g.types[i];/* istanbul ignore next: browser tests */
	return/text\/html/i.test(h)?f=g.getData("text/html"):/text\/plain/i.test(h)&&(f=g.getData("text/plain")),ga(f),b.stopPropagation(),b.preventDefault(),!1}// Everything else - empty editdiv and allow browser to paste content into it, then cleanup
	var j=a.saveSelection(),k=angular.element('<div class="ta-hidden-input" contenteditable="true"></div>');d.find("body").append(k),k[0].focus(),c(function(){
	// restore selection
	a.restoreSelection(j),ga(k[0].innerHTML),r[0].focus(),k.remove()},0)}),r.on("cut",f.events.cut=function(a){
	// timeout to next is needed as otherwise the paste/cut event has not finished actually changing the display
	F?a.preventDefault():c(function(){B.$setViewValue(Z())},0)}),r.on("keydown",f.events.keydown=function(a,b){/* istanbul ignore else: this is for catching the jqLite testing*/
	b&&angular.extend(a,b),a.keyCode===R?h.setStateShiftKey(!0):h.setStateShiftKey(!1),a.specialKey=w(a);var c;/* istanbul ignore else: readonly check */
	if(/* istanbul ignore next: difficult to test */
	o.keyMappings.forEach(function(b){a.specialKey===b.commandKeyCode&&(
	// taOptions has remapped this binding... so
	// we disable our own
	a.specialKey=void 0),b.testForKey(a)&&(c=b.commandKeyCode),"UndoKey"!==b.commandKeyCode&&"RedoKey"!==b.commandKeyCode||b.enablePropagation||a.preventDefault()}),/* istanbul ignore next: difficult to test */
	"undefined"!=typeof c&&(a.specialKey=c),/* istanbul ignore next: difficult to test as can't seem to select */
	"undefined"==typeof a.specialKey||"UndoKey"===a.specialKey&&"RedoKey"===a.specialKey||(a.preventDefault(),s.sendKeyCommand(f,a)),!(F||("UndoKey"===a.specialKey&&(ca(),a.preventDefault()),"RedoKey"===a.specialKey&&(da(),a.preventDefault()),a.keyCode!==Q||a.shiftKey||a.ctrlKey||a.metaKey||a.altKey))){var d,e=function(a,b){for(var c=0;c<a.length;c++)if(a[c]===b)return!0;return!1},g=h.getSelectionElement();
	// shifted to nodeName here from tagName since it is more widely supported see: http://stackoverflow.com/questions/4878484/difference-between-tagname-and-nodename
	if(!g.nodeName.match(k))return;var i=angular.element(z),j=["blockquote","ul","ol"];if(e(j,g.parentNode.tagName.toLowerCase())){if(/^<br(|\/)>$/i.test(g.innerHTML.trim())&&!g.nextSibling){
	// if last element is blank, pull element outside.
	d=angular.element(g);var l=d.parent();l.after(i),d.remove(),0===l.children().length&&l.remove(),h.setSelectionToElementStart(i[0]),a.preventDefault()}/^<[^>]+><br(|\/)><\/[^>]+>$/i.test(g.innerHTML.trim())&&(d=angular.element(g),d.after(i),d.remove(),h.setSelectionToElementStart(i[0]),a.preventDefault())}}});var ha;r.on("keyup",f.events.keyup=function(a,b){// clear the ShiftKey state
	/* istanbul ignore next: FF specific bug fix */
	if(/* istanbul ignore else: this is for catching the jqLite testing*/
	b&&angular.extend(a,b),h.setStateShiftKey(!1),a.keyCode===S){var d=h.getSelection();return void(d.start.element===r[0]&&r.children().length&&h.setSelectionToElementStart(r.children()[0]))}if(
	// we do this here during the 'keyup' so that the browser has already moved the slection by one character...
	a.keyCode!==T||a.shiftKey||h.updateLeftArrowKey(r),
	// we do this here during the 'keyup' so that the browser has already moved the slection by one character...
	a.keyCode!==U||a.shiftKey||h.updateRightArrowKey(r),X&&c.cancel(X),!F&&!K.test(a.keyCode))/* istanbul ignore next: Ignore any _ENTER_KEYCODE that has ctrlKey, metaKey or alKey */
	if(a.keyCode===Q&&(a.ctrlKey||a.metaKey||a.altKey));else{
	// if enter - insert new taDefaultWrap, if shift+enter insert <br/>
	if(""!==z&&"<BR><BR>"!==z&&a.keyCode===Q&&!a.ctrlKey&&!a.metaKey&&!a.altKey){for(var e=h.getSelectionElement();!e.nodeName.match(k)&&e!==r[0];)e=e.parentNode;if(a.shiftKey){
	// shift + Enter
	var f=e.tagName.toLowerCase();
	//console.log('Shift+Enter', selection.tagName, attrs.taDefaultWrap, selection.innerHTML.trim());
	// For an LI: We see: LI p ....<br><br>
	// For a P: We see: P p ....<br><br>
	// on Safari, the browser ignores the Shift+Enter and acts just as an Enter Key
	// For an LI: We see: LI p <br>
	// For a P: We see: P p <br>
	if((f===u.taDefaultWrap||"li"===f||"pre"===f||"div"===f)&&!/.+<br><br>/.test(e.innerHTML.trim())){var g=e.previousSibling;
	//console.log('wrong....', ps);
	// we need to remove this selection and fix the previousSibling up...
	g&&(g.innerHTML=g.innerHTML+"<br><br>",angular.element(e).remove(),h.setSelectionToElementEnd(g))}}else
	// new paragraph, br should be caught correctly
	// shifted to nodeName here from tagName since it is more widely supported see: http://stackoverflow.com/questions/4878484/difference-between-tagname-and-nodename
	//console.log('Enter', selection.nodeName, attrs.taDefaultWrap, selection.innerHTML.trim());
	if(e.tagName.toLowerCase()!==u.taDefaultWrap&&"li"!==e.nodeName.toLowerCase()&&(""===e.innerHTML.trim()||"<br>"===e.innerHTML.trim())){
	// Chrome starts with a <div><br></div> after an EnterKey
	// so we replace this with the _defaultVal
	var i=angular.element(z);angular.element(e).replaceWith(i),h.setSelectionToElementStart(i[0])}}var j=Z();""===z||""!==j.trim()&&"<br>"!==j.trim()?"<"!==j.substring(0,1)&&""!==u.taDefaultWrap:(ba(z),h.setSelectionToElementStart(r.children()[0]));var l=x!==a.keyCode&&L.test(a.keyCode);ha&&c.cancel(ha),ha=c(function(){aa(j,l,!0)},C.$options.debounce||400),l||(X=c(function(){B.$undoManager.push(j)},250)),x=a.keyCode}});
	// when there is a change from a spelling correction in the browser, the only
	// change that is seen is a 'input' and the $watch('html') sees nothing... So
	// we added this element.on('input') to catch this change and call the _setViewValue()
	// so the ngModel is updated and all works as it should.
	var ia;
	// Placeholders not supported on ie 8 and below
	if(r.on("input",function(){Z()!==B.$viewValue&&(
	// we wait a time now to allow the natural $watch('html') to handle this change
	// and then after a 1 second delay, if there is still a difference we will do the
	// _setViewValue() call.
	/* istanbul ignore if: can't test */
	ia&&c.cancel(ia),/* istanbul ignore next: cant' test? */
	ia=c(function(){var b=a.saveSelection(),c=Z();c!==B.$viewValue&&
	//console.log('_setViewValue');
	//console.log('old:', ngModel.$viewValue);
	//console.log('new:', _val);
	aa(c,!0),
	// if the savedSelection marker is gone at this point, we cannot restore the selection!!!
	//console.log('rangy.restoreSelection', ngModel.$viewValue.length, _savedSelection);
	0!==B.$viewValue.length&&a.restoreSelection(b)},1e3))}),r.on("blur",f.events.blur=function(){G=!1,/* istanbul ignore else: if readonly don't update model */
	F?(H=!0,// don't redo the whole thing, just check the placeholder logic
	B.$render()):aa(void 0,void 0,!0)}),u.placeholder&&(g.ie>8||void 0===g.ie)){var ja;if(!u.id)throw"textAngular Error: An unique ID is required for placeholders to work";ja=m("#"+u.id+".placeholder-text:before",'content: "'+u.placeholder+'"'),f.$on("$destroy",function(){n(ja)})}r.on("focus",f.events.focus=function(){G=!0,r.removeClass("placeholder-text"),_()}),r.on("mouseup",f.events.mouseup=function(){var a=h.getSelection();a&&a.start.element===r[0]&&r.children().length&&h.setSelectionToElementStart(r.children()[0])}),
	// prevent propagation on mousedown in editor, see #206
	r.on("mousedown",f.events.mousedown=function(a,b){/* istanbul ignore else: this is for catching the jqLite testing*/
	b&&angular.extend(a,b),a.stopPropagation()})}else{
	// if a textarea or input just add in change and blur handlers, everything else is done by angulars input directive
	r.on("change blur",f.events.change=f.events.blur=function(){F||B.$setViewValue(Z())}),r.on("keydown",f.events.keydown=function(a,b){
	// Reference to http://stackoverflow.com/questions/6140632/how-to-handle-tab-in-textarea
	/* istanbul ignore else: otherwise normal functionality */
	if(/* istanbul ignore else: this is for catching the jqLite testing*/
	b&&angular.extend(a,b),a.keyCode===S){// tab was pressed
	// get caret position/selection
	var c=this.selectionStart,d=this.selectionEnd,e=r.val();if(a.shiftKey){
	// find \t
	var f=e.lastIndexOf("\n",c),g=e.lastIndexOf("\t",c);g!==-1&&g>=f&&(
	// set textarea value to: text before caret + tab + text after caret
	r.val(e.substring(0,g)+e.substring(g+1)),
	// put caret at right position again (add one for the tab)
	this.selectionStart=this.selectionEnd=c-1)}else
	// set textarea value to: text before caret + tab + text after caret
	r.val(e.substring(0,c)+"\t"+e.substring(d)),
	// put caret at right position again (add one for the tab)
	this.selectionStart=this.selectionEnd=c+1;
	// prevent the focus lose
	a.preventDefault()}});var ka=function(a,b){for(var c="",d=0;d<b;d++)c+=a;return c},la=function(a,b,c){for(var d=0;d<a.length;d++)b.call(c,d,a[d])},ma=function(a,b){var c="",d=a.childNodes;
	// tab out and add the <ul> or <ol> html piece
	// now add on the </ol> or </ul> piece
	return b++,c+=ka("\t",b-1)+a.outerHTML.substring(0,4),la(d,function(a,d){/* istanbul ignore next: browser catch */
	var e=d.nodeName.toLowerCase();/* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
	return"#comment"===e?void(c+="<!--"+d.nodeValue+"-->"):"#text"===e?void(c+=d.textContent):void(d.outerHTML&&(c+="ul"===e||"ol"===e?"\n"+ma(d,b):"\n"+ka("\t",b)+d.outerHTML))}),c+="\n"+ka("\t",b-1)+a.outerHTML.substring(a.outerHTML.lastIndexOf("<"))};
	// handle formating of something like:
	// <ol><!--First comment-->
	//  <li>Test Line 1<!--comment test list 1--></li>
	//    <ul><!--comment ul-->
	//      <li>Nested Line 1</li>
	//        <!--comment between nested lines--><li>Nested Line 2</li>
	//    </ul>
	//  <li>Test Line 3</li>
	// </ol>
	B.$formatters.unshift(function(a){
	// tabulate the HTML so it looks nicer
	//
	// first get a list of the nodes...
	// we do this by using the element parser...
	//
	// doing this -- which is simpiler -- breaks our tests...
	//var _nodes=angular.element(htmlValue);
	var b=angular.element("<div>"+a+"</div>")[0].childNodes;
	// do the reformatting of the layout...
	return b.length>0&&(a="",la(b,function(b,c){var d=c.nodeName.toLowerCase();/* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
	// we aready have some content, so drop to a new line
	// okay a set of list stuff we want to reformat in a nested way
	return"#comment"===d?void(a+="<!--"+c.nodeValue+"-->"):"#text"===d?void(a+=c.textContent):void(c.outerHTML&&(a.length>0&&(a+="\n"),a+="ul"===d||"ol"===d?""+ma(c,0):""+c.outerHTML))})),a})}var na,oa=function(a,b){
	// emit the drop event, pass the element, preventing should be done elsewhere
	if(/* istanbul ignore else: this is for catching the jqLite testing*/
	b&&angular.extend(a,b),!t&&!F){t=!0;var d;d=a.originalEvent?a.originalEvent.dataTransfer:a.dataTransfer,f.$emit("ta-drop-event",this,a,d),c(function(){t=!1,aa(void 0,void 0,!0)},100)}},pa=!1;
	// changes to the model variable from outside the html/text inputs
	B.$render=function(){/* istanbul ignore if: Catches rogue renders, hard to replicate in tests */
	if(!pa){pa=!0;
	// catch model being null or undefined
	var a=B.$viewValue||"";
	// if the editor isn't focused it needs to be updated, otherwise it's receiving user input
	H||(/* istanbul ignore else: in other cases we don't care */
	D&&G&&(
	// update while focussed
	r.removeClass("placeholder-text"),/* istanbul ignore next: don't know how to test this */
	na&&c.cancel(na),na=c(function(){/* istanbul ignore if: Can't be bothered testing this... */
	G||(r[0].focus(),h.setSelectionToElementEnd(r.children()[r.children().length-1])),na=void 0},1)),D?(
	// blank
	ba(
	// WYSIWYG Mode
	u.placeholder?""===a?z:a:""===a?z:a),
	// if in WYSIWYG and readOnly we kill the use of links by clicking
	F?r.off("drop",oa):(_(),r.on("drop",oa))):"textarea"!==r[0].tagName.toLowerCase()&&"input"!==r[0].tagName.toLowerCase()?
	// make sure the end user can SEE the html code as a display. This is a read-only display element
	ba(l(a)):
	// only for input and textarea inputs
	r.val(a)),D&&u.placeholder&&(""===a?G?r.removeClass("placeholder-text"):r.addClass("placeholder-text"):r.removeClass("placeholder-text")),pa=H=!1}},u.taReadonly&&(
	//set initial value
	F=f.$eval(u.taReadonly),F?(r.addClass("ta-readonly"),
	// we changed to readOnly mode (taReadonly='true')
	"textarea"!==r[0].tagName.toLowerCase()&&"input"!==r[0].tagName.toLowerCase()||r.attr("disabled","disabled"),void 0!==r.attr("contenteditable")&&r.attr("contenteditable")&&r.removeAttr("contenteditable")):(r.removeClass("ta-readonly"),
	// we changed to NOT readOnly mode (taReadonly='false')
	"textarea"===r[0].tagName.toLowerCase()||"input"===r[0].tagName.toLowerCase()?r.removeAttr("disabled"):D&&r.attr("contenteditable","true")),
	// taReadonly only has an effect if the taBind element is an input or textarea or has contenteditable='true' on it.
	// Otherwise it is readonly by default
	f.$watch(u.taReadonly,function(a,b){b!==a&&(a?(r.addClass("ta-readonly"),
	// we changed to readOnly mode (taReadonly='true')
	"textarea"!==r[0].tagName.toLowerCase()&&"input"!==r[0].tagName.toLowerCase()||r.attr("disabled","disabled"),void 0!==r.attr("contenteditable")&&r.attr("contenteditable")&&r.removeAttr("contenteditable"),
	// turn ON selector click handlers
	angular.forEach(j,function(a){r.find(a).on("click",$)}),r.off("drop",oa)):(r.removeClass("ta-readonly"),
	// we changed to NOT readOnly mode (taReadonly='false')
	"textarea"===r[0].tagName.toLowerCase()||"input"===r[0].tagName.toLowerCase()?r.removeAttr("disabled"):D&&r.attr("contenteditable","true"),
	// remove the selector click handlers
	angular.forEach(j,function(a){r.find(a).off("click",$)}),r.on("drop",oa)),F=a)})),
	// Initialise the selectableElements
	// if in WYSIWYG and readOnly we kill the use of links by clicking
	D&&!F&&(angular.forEach(j,function(a){r.find(a).on("click",$)}),r.on("drop",oa))}}}]);
	// this global var is used to prevent multiple fires of the drop event. Needs to be global to the textAngular file.
	var t=!1,u=angular.module("textAngular",["ngSanitize","textAngularSetup","textAngular.factories","textAngular.DOM","textAngular.validators","textAngular.taBind"]);//This makes ngSanitize required
	return u.config([function(){
	// clear taTools variable. Just catches testing and any other time that this config may run multiple times...
	angular.forEach(e,function(a,b){delete e[b]})}]),u.directive("textAngular",["$compile","$timeout","taOptions","taSelection","taExecCommand","textAngularManager","$document","$animate","$log","$q","$parse",function(b,c,d,e,f,g,h,i,j,k,l){return{require:"?ngModel",scope:{},restrict:"EA",priority:2,// So we override validators correctly
	link:function(m,n,o,p){
	// all these vars should not be accessable outside this directive
	var q,r,s,t,u,v,w,x,y,z,A,B,C=o.serial?o.serial:Math.floor(1e16*Math.random());m._name=o.name?o.name:"textAngularEditor"+C;var D=function(a,b,d){c(function(){a.one(b,d)},100)};if(y=f(o.taDefaultWrap),
	// get the settings from the defaults and add our specific functions that need to be on the scope
	angular.extend(m,angular.copy(d),{
	// wraps the selection in the provided tag / execCommand function. Should only be called in WYSIWYG mode.
	wrapSelection:function(a,b,c){
	// we restore the saved selection that was saved when focus was lost
	/* NOT FUNCTIONAL YET */
	/* textAngularManager.restoreFocusSelection(scope._name, scope); */
	"undo"===a.toLowerCase()?m["$undoTaBindtaTextElement"+C]():"redo"===a.toLowerCase()?m["$redoTaBindtaTextElement"+C]():(
	// catch errors like FF erroring when you try to force an undo with nothing done
	y(a,!1,b,m.defaultTagAttributes),c&&
	// re-apply the selectable tool events
	m["reApplyOnSelectorHandlerstaTextElement"+C](),
	// refocus on the shown display element, this fixes a display bug when using :focus styles to outline the box.
	// You still have focus on the text/html input it just doesn't show up
	m.displayElements.text[0].focus())},showHtml:m.$eval(o.taShowHtml)||!1}),
	// setup the options from the optional attributes
	o.taFocussedClass&&(m.classes.focussed=o.taFocussedClass),o.taTextEditorClass&&(m.classes.textEditor=o.taTextEditorClass),o.taHtmlEditorClass&&(m.classes.htmlEditor=o.taHtmlEditorClass),o.taDefaultTagAttributes)try{
	//	TODO: This should use angular.merge to enhance functionality once angular 1.4 is required
	angular.extend(m.defaultTagAttributes,angular.fromJson(o.taDefaultTagAttributes))}catch(a){j.error(a)}
	// optional setup functions
	o.taTextEditorSetup&&(m.setup.textEditorSetup=m.$parent.$eval(o.taTextEditorSetup)),o.taHtmlEditorSetup&&(m.setup.htmlEditorSetup=m.$parent.$eval(o.taHtmlEditorSetup)),
	// optional fileDropHandler function
	o.taFileDrop?m.fileDropHandler=m.$parent.$eval(o.taFileDrop):m.fileDropHandler=m.defaultFileDropHandler,w=n[0].innerHTML,
	// clear the original content
	n[0].innerHTML="",
	// Setup the HTML elements as variable references for use later
	m.displayElements={
	// we still need the hidden input even with a textarea as the textarea may have invalid/old input in it,
	// wheras the input will ALLWAYS have the correct value.
	forminput:angular.element("<input type='hidden' tabindex='-1' style='display: none;'>"),html:angular.element("<textarea></textarea>"),text:angular.element("<div></div>"),
	// other toolbased elements
	scrollWindow:angular.element("<div class='ta-scroll-window'></div>"),popover:angular.element('<div class="popover fade bottom" style="max-width: none; width: 305px;"></div>'),popoverArrow:angular.element('<div class="arrow"></div>'),popoverContainer:angular.element('<div class="popover-content"></div>'),resize:{overlay:angular.element('<div class="ta-resizer-handle-overlay"></div>'),background:angular.element('<div class="ta-resizer-handle-background"></div>'),anchors:[angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tl"></div>'),angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tr"></div>'),angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-bl"></div>'),angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-br"></div>')],info:angular.element('<div class="ta-resizer-handle-info"></div>')}},
	// Setup the popover
	m.displayElements.popover.append(m.displayElements.popoverArrow),m.displayElements.popover.append(m.displayElements.popoverContainer),m.displayElements.scrollWindow.append(m.displayElements.popover),m.displayElements.popover.on("mousedown",function(a,b){/* istanbul ignore else: this is for catching the jqLite testing*/
	// this prevents focusout from firing on the editor when clicking anything in the popover
	return b&&angular.extend(a,b),a.preventDefault(),!1}),/* istanbul ignore next: popover resize and scroll events handled */
	m.handlePopoverEvents=function(){"block"===m.displayElements.popover.css("display")&&(B&&c.cancel(B),B=c(function(){
	//console.log('resize', scope.displayElements.popover.css('display'));
	m.reflowPopover(m.resizeElement),m.reflowResizeOverlay(m.resizeElement)},100))},/* istanbul ignore next: browser resize check */
	angular.element(window).on("resize",m.handlePopoverEvents),/* istanbul ignore next: browser scroll check */
	angular.element(window).on("scroll",m.handlePopoverEvents);
	// we want to know if a given node has a scrollbar!
	// credit to lotif on http://stackoverflow.com/questions/4880381/check-whether-html-element-has-scrollbars
	var E=function(a){var b,c={vertical:!1,horizontal:!1};try{if(b=window.getComputedStyle(a),null===b)return c}catch(a){/* istanbul ignore next: error handler */
	return c}var d=b["overflow-y"],e=b["overflow-x"];return{vertical:("scroll"===d||"auto"===d)&&/* istanbul ignore next: not tested */
	a.scrollHeight>a.clientHeight,horizontal:("scroll"===e||"auto"===e)&&/* istanbul ignore next: not tested */
	a.scrollWidth>a.clientWidth}};
	// getScrollTop
	//
	// we structure this so that it can climb the parents of the _el and when it finds
	// one with scrollbars, it adds an EventListener, so that no matter how the
	// DOM is structured in the user APP, if there is a scrollbar not as part of the
	// ta-scroll-window, we will still capture the 'scroll' events...
	// and handle the scroll event properly and do the resize, etc.
	//
	m.getScrollTop=function(a,b){var c=a.scrollTop;/* istanbul ignore next: triggered only if has scrollbar and scrolled */
	/* istanbul ignore next: triggered only if has scrollbar */
	// remove element eventListener
	/* istanbul ignore next: triggered only if has scrollbar and scrolled */
	/* istanbul ignore else: catches only if no scroll */
	return"undefined"==typeof c&&(c=0),b&&E(a).vertical&&(a.removeEventListener("scroll",m._scrollListener,!1),a.addEventListener("scroll",m._scrollListener,!1)),0!==c?{node:a.nodeName,top:c}:a.parentNode?m.getScrollTop(a.parentNode,b):{node:"<none>",top:0}},
	// define the popover show and hide functions
	m.showPopover=function(a){m.getScrollTop(m.displayElements.scrollWindow[0],!0),m.displayElements.popover.css("display","block"),
	// we must use a $timeout here, or the css change to the
	// displayElements.resize.overlay will not take!!!
	// WHY???
	c(function(){m.displayElements.resize.overlay.css("display","block")}),m.resizeElement=a,m.reflowPopover(a),i.addClass(m.displayElements.popover,"in"),D(h.find("body"),"click keyup",function(){m.hidePopover()})},/* istanbul ignore next: browser scroll event handler */
	m._scrollListener=function(a,b){m.handlePopoverEvents()},m.reflowPopover=function(a){var b=m.getScrollTop(m.displayElements.scrollWindow[0],!1),c=a[0].offsetTop-b.top;
	//var spaceBelowImage = scope.displayElements.text[0].offsetHeight - _el[0].offsetHeight - spaceAboveImage;
	//console.log(spaceAboveImage, spaceBelowImage);
	/* istanbul ignore if: catches only if near bottom of editor */
	c<51?(m.displayElements.popover.css("top",a[0].offsetTop+a[0].offsetHeight+m.displayElements.scrollWindow[0].scrollTop+"px"),m.displayElements.popover.removeClass("top").addClass("bottom")):(m.displayElements.popover.css("top",a[0].offsetTop-54+m.displayElements.scrollWindow[0].scrollTop+"px"),m.displayElements.popover.removeClass("bottom").addClass("top"));var d=m.displayElements.text[0].offsetWidth-m.displayElements.popover[0].offsetWidth,e=a[0].offsetLeft+a[0].offsetWidth/2-m.displayElements.popover[0].offsetWidth/2,f=Math.max(0,Math.min(d,e)),g=Math.min(e,Math.max(0,e-d))-11;f+=window.scrollX,g-=window.scrollX,m.displayElements.popover.css("left",f+"px"),m.displayElements.popoverArrow.css("margin-left",g+"px")},m.hidePopover=function(){m.displayElements.popover.css("display","none"),m.displayElements.popoverContainer.attr("style",""),m.displayElements.popoverContainer.attr("class","popover-content"),m.displayElements.popover.removeClass("in"),m.displayElements.resize.overlay.css("display","none")},
	// setup the resize overlay
	m.displayElements.resize.overlay.append(m.displayElements.resize.background),angular.forEach(m.displayElements.resize.anchors,function(a){m.displayElements.resize.overlay.append(a)}),m.displayElements.resize.overlay.append(m.displayElements.resize.info),m.displayElements.scrollWindow.append(m.displayElements.resize.overlay),
	// A click event on the resize.background will now shift the focus to the editor
	/* istanbul ignore next: click on the resize.background to focus back to editor */
	m.displayElements.resize.background.on("click",function(a){m.displayElements.text[0].focus()}),
	// define the show and hide events
	m.reflowResizeOverlay=function(a){a=angular.element(a)[0],m.displayElements.resize.overlay.css({display:"block",left:a.offsetLeft-5+"px",top:a.offsetTop-5+"px",width:a.offsetWidth+10+"px",height:a.offsetHeight+10+"px"}),m.displayElements.resize.info.text(a.offsetWidth+" x "+a.offsetHeight)},/* istanbul ignore next: pretty sure phantomjs won't test this */
	m.showResizeOverlay=function(a){var b=h.find("body");z=function(c){var d={width:parseInt(a.attr("width")),height:parseInt(a.attr("height")),x:c.clientX,y:c.clientY};(void 0===d.width||isNaN(d.width))&&(d.width=a[0].offsetWidth),(void 0===d.height||isNaN(d.height))&&(d.height=a[0].offsetHeight),m.hidePopover();var e=d.height/d.width,f=function(b){function c(a){return Math.round(Math.max(0,a))}
	// calculate new size
	var f={x:Math.max(0,d.width+(b.clientX-d.x)),y:Math.max(0,d.height+(b.clientY-d.y))},g=void 0!==o.taResizeForceAspectRatio,h=o.taResizeMaintainAspectRatio,i=g||h&&!b.shiftKey;if(i){var j=f.y/f.x;f.x=e>j?f.x:f.y/e,f.y=e>j?f.x*e:f.y}var k=angular.element(a);k.css("height",c(f.y)+"px"),k.css("width",c(f.x)+"px"),
	// reflow the popover tooltip
	m.reflowResizeOverlay(a)};b.on("mousemove",f),D(b,"mouseup",function(a){a.preventDefault(),a.stopPropagation(),b.off("mousemove",f),
	// at this point, we need to force the model to update! since the css has changed!
	// this fixes bug: #862 - we now hide the popover -- as this seems more consitent.
	// there are still issues under firefox, the window does not repaint. -- not sure
	// how best to resolve this, but clicking anywhere works.
	m.$apply(function(){m.hidePopover(),m.updateTaBindtaTextElement()},100)}),c.stopPropagation(),c.preventDefault()},m.displayElements.resize.anchors[3].off("mousedown"),m.displayElements.resize.anchors[3].on("mousedown",z),m.reflowResizeOverlay(a),D(b,"click",function(){m.hideResizeOverlay()})},/* istanbul ignore next: pretty sure phantomjs won't test this */
	m.hideResizeOverlay=function(){m.displayElements.resize.anchors[3].off("mousedown",z),m.displayElements.resize.overlay.css("display","none")},
	// allow for insertion of custom directives on the textarea and div
	m.setup.htmlEditorSetup(m.displayElements.html),m.setup.textEditorSetup(m.displayElements.text),m.displayElements.html.attr({id:"taHtmlElement"+C,"ng-show":"showHtml","ta-bind":"ta-bind","ng-model":"html","ng-model-options":n.attr("ng-model-options")}),m.displayElements.text.attr({id:"taTextElement"+C,contentEditable:"true","ta-bind":"ta-bind","ng-model":"html","ng-model-options":n.attr("ng-model-options")}),m.displayElements.scrollWindow.attr({"ng-hide":"showHtml"}),o.taDefaultWrap&&
	// taDefaultWrap is only applied to the text and not the html view
	m.displayElements.text.attr("ta-default-wrap",o.taDefaultWrap),o.taUnsafeSanitizer&&(m.displayElements.text.attr("ta-unsafe-sanitizer",o.taUnsafeSanitizer),m.displayElements.html.attr("ta-unsafe-sanitizer",o.taUnsafeSanitizer)),o.taKeepStyles&&(m.displayElements.text.attr("ta-keep-styles",o.taKeepStyles),m.displayElements.html.attr("ta-keep-styles",o.taKeepStyles)),
	// add the main elements to the origional element
	m.displayElements.scrollWindow.append(m.displayElements.text),n.append(m.displayElements.scrollWindow),n.append(m.displayElements.html),m.displayElements.forminput.attr("name",m._name),n.append(m.displayElements.forminput),o.tabindex&&(n.removeAttr("tabindex"),m.displayElements.text.attr("tabindex",o.tabindex),m.displayElements.html.attr("tabindex",o.tabindex)),o.placeholder&&(m.displayElements.text.attr("placeholder",o.placeholder),m.displayElements.html.attr("placeholder",o.placeholder)),o.taDisabled&&(m.displayElements.text.attr("ta-readonly","disabled"),m.displayElements.html.attr("ta-readonly","disabled"),m.disabled=m.$parent.$eval(o.taDisabled),m.$parent.$watch(o.taDisabled,function(a){m.disabled=a,m.disabled?n.addClass(m.classes.disabled):n.removeClass(m.classes.disabled)})),o.taPaste&&(m._pasteHandler=function(a){return l(o.taPaste)(m.$parent,{$html:a})},m.displayElements.text.attr("ta-paste","_pasteHandler($html)")),
	// compile the scope with the text and html elements only - if we do this with the main element it causes a compile loop
	b(m.displayElements.scrollWindow)(m),b(m.displayElements.html)(m),m.updateTaBindtaTextElement=m["updateTaBindtaTextElement"+C],m.updateTaBindtaHtmlElement=m["updateTaBindtaHtmlElement"+C],
	// add the classes manually last
	n.addClass("ta-root"),m.displayElements.scrollWindow.addClass("ta-text ta-editor "+m.classes.textEditor),m.displayElements.html.addClass("ta-html ta-editor "+m.classes.htmlEditor);var F=function(a,b){/* istanbul ignore next: this is only here because of a bug in rangy where rangy.saveSelection() has cleared the state */
	b!==h[0].queryCommandState(a)&&h[0].execCommand(a,!1,null)};
	// used in the toolbar actions
	m._actionRunning=!1;var G=!1;
	// changes to the model variable from outside the html/text inputs
	// if no ngModel, then the only input is from inside text-angular
	if(m.startAction=function(){var b=!1,c=!1,d=!1,e=!1;
	//console.log('B', $document[0].queryCommandState('bold'), 'I', $document[0].queryCommandState('italic'), '_', $document[0].queryCommandState('underline'), 'S', $document[0].queryCommandState('strikeThrough') );
	//console.log('B', _beforeStateBold, 'I', _beforeStateItalic, '_', _beforeStateUnderline, 'S', _beforeStateStrikethough);
	// if rangy library is loaded return a function to reload the current selection
	// rangy.saveSelection() clear the state of bold, italic, underline, strikethrough
	// so we reset them here....!!!
	// this fixes bugs #423, #1129, #1105, #693 which are actually rangy bugs!
	return m._actionRunning=!0,b=h[0].queryCommandState("bold"),c=h[0].queryCommandState("italic"),d=h[0].queryCommandState("underline"),e=h[0].queryCommandState("strikeThrough"),G=a.saveSelection(),F("bold",b),F("italic",c),F("underline",d),F("strikeThrough",e),function(){G&&a.restoreSelection(G)}},m.endAction=function(){m._actionRunning=!1,G&&(m.showHtml?m.displayElements.html[0].focus():m.displayElements.text[0].focus(),
	// rangy.restoreSelection(_savedSelection);
	a.removeMarkers(G)),G=!1,m.updateSelectedStyles(),
	// only update if in text or WYSIWYG mode
	m.showHtml||m["updateTaBindtaTextElement"+C]()},
	// note that focusout > focusin is called everytime we click a button - except bad support: http://www.quirksmode.org/dom/events/blurfocus.html
	// cascades to displayElements.text and displayElements.html automatically.
	u=function(a){m.focussed=!0,n.addClass(m.classes.focussed),/*******  NOT FUNCTIONAL YET
	                    if (e.target.id === 'taTextElement' + _serial) {
	                        console.log('_focusin taTextElement');
	                        // we only do this if NOT focussed
	                        textAngularManager.restoreFocusSelection(scope._name);
	                    }
	*******/
	x.focus(),n.triggerHandler("focus"),
	// we call editorScope.updateSelectedStyles() here because we want the toolbar to be focussed
	// as soon as we have focus.  Otherwise this only happens on mousedown or keydown etc...
	/* istanbul ignore else: don't run if already running */
	m.updateSelectedStyles&&!m._bUpdateSelectedStyles&&
	// we don't set editorScope._bUpdateSelectedStyles here, because we do not want the
	// updateSelectedStyles() to run twice which it will do after 200 msec if we have
	// set editorScope._bUpdateSelectedStyles
	//
	// WOW, normally I would do a scope.$apply here, but this causes ERRORs when doing tests!
	c(function(){m.updateSelectedStyles()},0)},m.displayElements.html.on("focus",u),m.displayElements.text.on("focus",u),v=function(a){/****************** NOT FUNCTIONAL YET
	                    try {
	                        var _s = rangy.getSelection();
	                        if (_s) {
	                            // we save the selection when we loose focus so that if do a wrapSelection, the
	                            // apropriate selection in the editor is restored before action.
	                            var _savedFocusRange = rangy.saveRange(_s.getRangeAt(0));
	                            textAngularManager.saveFocusSelection(scope._name, _savedFocusRange);
	                        }
	                    } catch(error) { }
	                    *****************/
	// if we are NOT runnig an action and have NOT focussed again on the text etc then fire the blur events
	// to prevent multiple apply error defer to next seems to work.
	return m._actionRunning||h[0].activeElement===m.displayElements.html[0]||h[0].activeElement===m.displayElements.text[0]||(n.removeClass(m.classes.focussed),x.unfocus(),c(function(){m._bUpdateSelectedStyles=!1,n.triggerHandler("blur"),m.focussed=!1},0)),a.preventDefault(),!1},m.displayElements.html.on("blur",v),m.displayElements.text.on("blur",v),m.displayElements.text.on("paste",function(a){n.triggerHandler("paste",a)}),
	// Setup the default toolbar tools, this way allows the user to add new tools like plugins.
	// This is on the editor for future proofing if we find a better way to do this.
	m.queryFormatBlockState=function(a){
	// $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
	return!m.showHtml&&a.toLowerCase()===h[0].queryCommandValue("formatBlock").toLowerCase()},m.queryCommandState=function(a){
	// $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
	return m.showHtml?"":h[0].queryCommandState(a)},m.switchView=function(){m.showHtml=!m.showHtml,i.enabled(!1,m.displayElements.html),i.enabled(!1,m.displayElements.text),
	//Show the HTML view
	/* istanbul ignore next: ngModel exists check */
	/* THIS is not the correct thing to do, here....
	   The ngModel is correct, but it is not formatted as the user as done it...
	                    var _model;
	                    if (ngModel) {
	                        _model = ngModel.$viewValue;
	                    } else {
	                        _model = scope.html;
	                    }
	                    var _html = scope.displayElements.html[0].value;
	                    if (getDomFromHtml(_html).childElementCount !== getDomFromHtml(_model).childElementCount) {
	                        // the model and the html do not agree
	                        // they can get out of sync and when they do, we correct that here...
	                        scope.displayElements.html.val(_model);
	                    }
	*/
	m.showHtml?
	//defer until the element is visible
	c(function(){
	// [0] dereferences the DOM object from the angular.element
	return i.enabled(!0,m.displayElements.html),i.enabled(!0,m.displayElements.text),m.displayElements.html[0].focus()},100):
	//Show the WYSIWYG view
	//defer until the element is visible
	c(function(){
	// [0] dereferences the DOM object from the angular.element
	return i.enabled(!0,m.displayElements.html),i.enabled(!0,m.displayElements.text),m.displayElements.text[0].focus()},100)},o.ngModel){var H=!0;p.$render=function(){if(H){
	// we need this firstRun to set the originalContents otherwise it gets overrided by the setting of ngModel to undefined from NaN
	H=!1;
	// if view value is null or undefined initially and there was original content, set to the original content
	var a=m.$parent.$eval(o.ngModel);void 0!==a&&null!==a||!w||""===w||
	// on passing through to taBind it will be sanitised
	p.$setViewValue(w)}m.displayElements.forminput.val(p.$viewValue),
	// if the editors aren't focused they need to be updated, otherwise they are doing the updating
	m.html=p.$viewValue||""},
	// trigger the validation calls
	n.attr("required")&&(p.$validators.required=function(a,b){var c=a||b;return!(!c||""===c.trim())})}else
	// if no ngModel then update from the contents of the origional html.
	m.displayElements.forminput.val(w),m.html=w;if(
	// changes from taBind back up to here
	m.$watch("html",function(a,b){a!==b&&(o.ngModel&&p.$viewValue!==a&&p.$setViewValue(a),m.displayElements.forminput.val(a))}),o.taTargetToolbars)x=g.registerEditor(m._name,m,o.taTargetToolbars.split(","));else{var I=angular.element('<div text-angular-toolbar name="textAngularToolbar'+C+'">');
	// passthrough init of toolbar options
	o.taToolbar&&I.attr("ta-toolbar",o.taToolbar),o.taToolbarClass&&I.attr("ta-toolbar-class",o.taToolbarClass),o.taToolbarGroupClass&&I.attr("ta-toolbar-group-class",o.taToolbarGroupClass),o.taToolbarButtonClass&&I.attr("ta-toolbar-button-class",o.taToolbarButtonClass),o.taToolbarActiveButtonClass&&I.attr("ta-toolbar-active-button-class",o.taToolbarActiveButtonClass),o.taFocussedClass&&I.attr("ta-focussed-class",o.taFocussedClass),n.prepend(I),b(I)(m.$parent),x=g.registerEditor(m._name,m,["textAngularToolbar"+C])}m.$on("$destroy",function(){g.unregisterEditor(m._name),angular.element(window).off("blur"),angular.element(window).off("resize",m.handlePopoverEvents),angular.element(window).off("scroll",m.handlePopoverEvents)}),
	// catch element select event and pass to toolbar tools
	m.$on("ta-element-select",function(a,b){x.triggerElementSelect(a,b)&&m["reApplyOnSelectorHandlerstaTextElement"+C]()}),/******************* no working fully
	                var distanceFromPoint = function (px, py, x, y) {
	                    return Math.sqrt((px-x)*(px-x)+(py-y)*(py-y));
	                };
	                // because each object is a rectangle and we have a single point,
	                // we need to give priority if the point is inside the rectangle
	                var getPositionDistance = function(el, x, y) {
	                    var range = document.createRange();
	                    range.selectNode(el);
	                    var rect = range.getBoundingClientRect();
	                    console.log(el, rect);
	                    range.detach();
	                    var bcr = rect;
	                    // top left
	                    var d1 = distanceFromPoint(bcr.left, bcr.top, x, y);
	                    // bottom left
	                    var d2 = distanceFromPoint(bcr.left, bcr.bottom, x, y);
	                    // top right
	                    var d3 = distanceFromPoint(bcr.right, bcr.top, x, y);
	                    // bottom right
	                    var d4 = distanceFromPoint(bcr.right, bcr.bottom, x, y);
	                    return Math.min(d1, d2, d3, d4);
	                };
	                var findClosest = function(el, minElement, maxDistance, x, y) {
	                    var _d=0;
	                    for (var i = 0; i < el.childNodes.length; i++) {
	                        var _n = el.childNodes[i];
	                        if (!_n.childNodes.length) {
	                            _d = getPositionDistance(_n, x, y);
	                            //console.log(_n, _n.childNodes, _d);
	                            if (_d < maxDistance) {
	                                maxDistance = _d;
	                                minElement = _n;
	                            }
	                        }
	                        var res = findClosest(_n, minElement, maxDistance, x, y);
	                        if (res.max < maxDistance) {
	                            maxDistance = res.max;
	                            minElement = res.min;
	                        }
	                    }
	                    return { max: maxDistance, min: minElement };
	                };
	                var getClosestElement = function (el, x, y) {
	                    return findClosest(el, null, 12341234124, x, y);
	                };
	****************/
	m.$on("ta-drop-event",function(a,b,d,f){f&&f.files&&f.files.length>0?(m.displayElements.text[0].focus(),
	// we must set the location of the drop!
	//console.log(dropEvent.clientX, dropEvent.clientY, dropEvent.target);
	e.setSelectionToElementEnd(d.target),angular.forEach(f.files,function(a){
	// taking advantage of boolean execution, if the fileDropHandler returns true, nothing else after it is executed
	// If it is false then execute the defaultFileDropHandler if the fileDropHandler is NOT the default one
	// Once one of these has been executed wrap the result as a promise, if undefined or variable update the taBind, else we should wait for the promise
	try{k.when(m.fileDropHandler(a,m.wrapSelection)||m.fileDropHandler!==m.defaultFileDropHandler&&k.when(m.defaultFileDropHandler(a,m.wrapSelection))).then(function(){m["updateTaBindtaTextElement"+C]()})}catch(a){j.error(a)}}),d.preventDefault(),d.stopPropagation()):c(function(){m["updateTaBindtaTextElement"+C]()},0)}),
	// the following is for applying the active states to the tools that support it
	m._bUpdateSelectedStyles=!1,/* istanbul ignore next: browser window/tab leave check */
	angular.element(window).on("blur",function(){m._bUpdateSelectedStyles=!1,m.focussed=!1}),
	// loop through all the tools polling their activeState function if it exists
	m.updateSelectedStyles=function(){var a;/* istanbul ignore next: This check is to ensure multiple timeouts don't exist */
	A&&c.cancel(A),
	// test if the common element ISN'T the root ta-text node
	void 0!==(a=e.getSelectionElement())&&a.parentNode!==m.displayElements.text[0]?x.updateSelectedStyles(angular.element(a)):x.updateSelectedStyles(),
	// used to update the active state when a key is held down, ie the left arrow
	/* istanbul ignore else: browser only check */
	m._bUpdateSelectedStyles&&(A=c(m.updateSelectedStyles,200))},
	// start updating on keydown
	q=function(){/* istanbul ignore next: ie catch */
	/* istanbul ignore next: ie catch */
	/* istanbul ignore else: don't run if already running */
	return m.focussed?void(m._bUpdateSelectedStyles||(m._bUpdateSelectedStyles=!0,m.$apply(function(){m.updateSelectedStyles()}))):void(m._bUpdateSelectedStyles=!1)},m.displayElements.html.on("keydown",q),m.displayElements.text.on("keydown",q),
	// stop updating on key up and update the display/model
	r=function(){m._bUpdateSelectedStyles=!1},m.displayElements.html.on("keyup",r),m.displayElements.text.on("keyup",r),
	// stop updating on key up and update the display/model
	s=function(a,b){
	// bug fix for Firefox.  If we are selecting a <a> already, any characters will
	// be added within the <a> which is bad!
	/* istanbul ignore next: don't see how to test this... */
	if(e.getSelection){var c=e.getSelection();
	// in a weird case (can't reproduce) taSelection.getSelectionElement() can be undefined!!
	// this comes from range.commonAncestorContainer;
	// so I check for this here which fixes the error case
	e.getSelectionElement()&&"a"===e.getSelectionElement().nodeName.toLowerCase()&&(
	// check and see if we are at the edge of the <a>
	3===c.start.element.nodeType&&c.start.element.textContent.length===c.end.offset&&
	// we are at the end of the <a>!!!
	// so move the selection to after the <a>!!
	e.setSelectionAfterElement(e.getSelectionElement()),3===c.start.element.nodeType&&0===c.start.offset&&
	// we are at the start of the <a>!!!
	// so move the selection before the <a>!!
	e.setSelectionBeforeElement(e.getSelectionElement()))}/* istanbul ignore else: this is for catching the jqLite testing*/
	b&&angular.extend(a,b),m.$apply(function(){if(x.sendKeyCommand(a))/* istanbul ignore else: don't run if already running */
	return m._bUpdateSelectedStyles||m.updateSelectedStyles(),a.preventDefault(),!1})},m.displayElements.html.on("keypress",s),m.displayElements.text.on("keypress",s),
	// update the toolbar active states when we click somewhere in the text/html boxed
	t=function(){
	// ensure only one execution of updateSelectedStyles()
	m._bUpdateSelectedStyles=!1,
	// for some reason, unless we do a $timeout here, after a _mouseup when the line is
	// highlighted, and instead use a scope.$apply(function(){ scope.updateSelectedStyles(); });
	// doesn't work properly, so we replaced this with:
	/* istanbul ignore next: not tested  */
	c(function(){m.updateSelectedStyles()},0)},m.displayElements.html.on("mouseup",t),m.displayElements.text.on("mouseup",t)}}}]),u.service("textAngularManager",["taToolExecuteAction","taTools","taRegisterTool","$interval","$rootScope","$log",function(a,b,c,d,e,g){
	// this service is used to manage all textAngular editors and toolbars.
	// All publicly published functions that modify/need to access the toolbar or editor scopes should be in here
	// these contain references to all the editors and toolbars that have been initialised in this app
	var h,i={},j={},k=0,l=function(a){angular.forEach(j,function(b){b.editorFunctions.updateSelectedStyles(a)})},m=50,n=function(){k=Date.now(),/* istanbul ignore next: setup a one time updateStyles() */
	h=d(function(){l(),h=void 0},m,1)};/* istanbul ignore next: make sure clean up on destroy */
	e.$on("destroy",function(){h&&(d.cancel(h),h=void 0)});var o=function(){Math.abs(Date.now()-k)>m&&
	// we have already triggered the updateStyles a long time back... so setup it again...
	n()};
	// when we focus into a toolbar, we need to set the TOOLBAR's $parent to be the toolbars it's linked to.
	// We also need to set the tools to be updated to be the toolbars...
	return{
	// register an editor and the toolbars that it is affected by
	registerEditor:function(c,d,e){
	// NOTE: name === editorScope._name
	// targetToolbars is an [] of 'toolbar name's
	// targetToolbars are optional, we don't require a toolbar to function
	if(!c||""===c)throw"textAngular Error: An editor requires a name";if(!d)throw"textAngular Error: An editor requires a scope";if(j[c])throw'textAngular Error: An Editor with name "'+c+'" already exists';return j[c]={scope:d,toolbars:e,
	// toolbarScopes used by this editor
	toolbarScopes:[],_registerToolbarScope:function(a){
	// add to the list late
	this.toolbars.indexOf(a.name)>=0&&
	// if this toolbarScope is being used by this editor we add it as one of the scopes
	this.toolbarScopes.push(a)},
	// this is a suite of functions the editor should use to update all it's linked toolbars
	editorFunctions:{disable:function(){
	// disable all linked toolbars
	angular.forEach(j[c].toolbarScopes,function(a){a.disabled=!0})},enable:function(){
	// enable all linked toolbars
	angular.forEach(j[c].toolbarScopes,function(a){a.disabled=!1})},focus:function(){
	// this should be called when the editor is focussed
	angular.forEach(j[c].toolbarScopes,function(a){a._parent=d,a.disabled=!1,a.focussed=!0}),d.focussed=!0},unfocus:function(){
	// this should be called when the editor becomes unfocussed
	angular.forEach(j[c].toolbarScopes,function(a){a.disabled=!0,a.focussed=!1}),d.focussed=!1},updateSelectedStyles:function(a){
	// update the active state of all buttons on liked toolbars
	angular.forEach(j[c].toolbarScopes,function(b){angular.forEach(b.tools,function(c){c.activeState&&(b._parent=d,
	// selectedElement may be undefined if nothing selected
	c.active=c.activeState(a))})})},sendKeyCommand:function(e){
	// we return true if we applied an action, false otherwise
	var f=!1;return(e.ctrlKey||e.metaKey||e.specialKey)&&angular.forEach(b,function(b,g){if(b.commandKeyCode&&(b.commandKeyCode===e.which||b.commandKeyCode===e.specialKey))for(var h=0;h<j[c].toolbarScopes.length;h++)if(void 0!==j[c].toolbarScopes[h].tools[g]){a.call(j[c].toolbarScopes[h].tools[g],d),f=!0;break}}),f},triggerElementSelect:function(a,e){
	// search through the taTools to see if a match for the tag is made.
	// if there is, see if the tool is on a registered toolbar and not disabled.
	// NOTE: This can trigger on MULTIPLE tools simultaneously.
	var f=function(a,b){for(var c=!0,d=0;d<b.length;d++)c=c&&a.attr(b[d]);return c},g=[],h={},i=!1;e=angular.element(e);
	// get all valid tools by element name, keep track if one matches the
	var k=!1;
	// Run the actions on the first visible filtered tool only
	if(angular.forEach(b,function(a,b){a.onElementSelect&&a.onElementSelect.element&&a.onElementSelect.element.toLowerCase()===e[0].tagName.toLowerCase()&&(!a.onElementSelect.filter||a.onElementSelect.filter(e))&&(
	// this should only end up true if the element matches the only attributes
	k=k||angular.isArray(a.onElementSelect.onlyWithAttrs)&&f(e,a.onElementSelect.onlyWithAttrs),a.onElementSelect.onlyWithAttrs&&!f(e,a.onElementSelect.onlyWithAttrs)||(h[b]=a))}),
	// if we matched attributes to filter on, then filter, else continue
	k?(angular.forEach(h,function(a,b){a.onElementSelect.onlyWithAttrs&&f(e,a.onElementSelect.onlyWithAttrs)&&g.push({name:b,tool:a})}),
	// sort most specific (most attrs to find) first
	g.sort(function(a,b){return b.tool.onElementSelect.onlyWithAttrs.length-a.tool.onElementSelect.onlyWithAttrs.length})):angular.forEach(h,function(a,b){g.push({name:b,tool:a})}),g.length>0)for(var l=0;l<g.length;l++){for(var m=g[l].tool,n=g[l].name,o=0;o<j[c].toolbarScopes.length;o++)if(void 0!==j[c].toolbarScopes[o].tools[n]){m.onElementSelect.action.call(j[c].toolbarScopes[o].tools[n],a,e,d),i=!0;break}if(i)break}return i}}},angular.forEach(e,function(a){i[a]&&j[c].toolbarScopes.push(i[a])}),o(),j[c].editorFunctions},
	// retrieve editor by name, largely used by testing suites only
	retrieveEditor:function(a){return j[a]},unregisterEditor:function(a){delete j[a],o()},
	// registers a toolbar such that it can be linked to editors
	registerToolbar:function(a){if(!a)throw"textAngular Error: A toolbar requires a scope";if(!a.name||""===a.name)throw"textAngular Error: A toolbar requires a name";if(i[a.name])throw'textAngular Error: A toolbar with name "'+a.name+'" already exists';i[a.name]=a,
	// walk all the editors and connect this toolbarScope to the editors.... if we need to.  This way, it does
	// not matter if we register the editors after the toolbars or not
	// Note the editor will ignore this toolbarScope if it is not connected to it...
	angular.forEach(j,function(b){b._registerToolbarScope(a)}),o()},
	// retrieve toolbar by name, largely used by testing suites only
	retrieveToolbar:function(a){return i[a]},
	// retrieve toolbars by editor name, largely used by testing suites only
	retrieveToolbarsViaEditor:function(a){var b=[],c=this;return angular.forEach(this.retrieveEditor(a).toolbars,function(a){b.push(c.retrieveToolbar(a))}),b},unregisterToolbar:function(a){delete i[a],o()},
	// functions for updating the toolbar buttons display
	updateToolsDisplay:function(a){
	// pass a partial struct of the taTools, this allows us to update the tools on the fly, will not change the defaults.
	var b=this;angular.forEach(a,function(a,c){b.updateToolDisplay(c,a)})},
	// this function resets all toolbars to their default tool definitions
	resetToolsDisplay:function(){var a=this;angular.forEach(b,function(b,c){a.resetToolDisplay(c)}),o()},
	// update a tool on all toolbars
	updateToolDisplay:function(a,b){var c=this;angular.forEach(i,function(d,e){c.updateToolbarToolDisplay(e,a,b)}),o()},
	// resets a tool to the default/starting state on all toolbars
	resetToolDisplay:function(a){var b=this;angular.forEach(i,function(c,d){b.resetToolbarToolDisplay(d,a)}),o()},
	// update a tool on a specific toolbar
	updateToolbarToolDisplay:function(a,b,c){if(!i[a])throw'textAngular Error: No Toolbar with name "'+a+'" exists';i[a].updateToolDisplay(b,c)},
	// reset a tool on a specific toolbar to it's default starting value
	resetToolbarToolDisplay:function(a,c){if(!i[a])throw'textAngular Error: No Toolbar with name "'+a+'" exists';i[a].updateToolDisplay(c,b[c],!0)},
	// removes a tool from all toolbars and it's definition
	removeTool:function(a){delete b[a],angular.forEach(i,function(b){delete b.tools[a];for(var c=0;c<b.toolbar.length;c++){for(var d,e=0;e<b.toolbar[c].length;e++){if(b.toolbar[c][e]===a){d={group:c,index:e};break}if(void 0!==d)break}void 0!==d&&(b.toolbar[d.group].slice(d.index,1),b._$element.children().eq(d.group).children().eq(d.index).remove())}}),o()},
	// toolkey, toolDefinition are required. If group is not specified will pick the last group, if index isnt defined will append to group
	addTool:function(a,b,d,e){c(a,b),angular.forEach(i,function(c){c.addTool(a,b,d,e)}),o()},
	// adds a Tool but only to one toolbar not all
	addToolToToolbar:function(a,b,d,e,f){c(a,b),i[d].addTool(a,b,e,f),o()},
	// this is used when externally the html of an editor has been changed and textAngular needs to be notified to update the model.
	// this will call a $digest if not already happening
	refreshEditor:function(a){if(!j[a])throw'textAngular Error: No Editor with name "'+a+'" exists';j[a].scope.updateTaBindtaTextElement(),/* istanbul ignore else: phase catch */
	j[a].scope.$$phase||j[a].scope.$digest(),o()},
	// this is used by taBind to send a key command in response to a special key event
	sendKeyCommand:function(a,b){var c=j[a._name];/* istanbul ignore else: if nothing to do, do nothing */
	if(c&&c.editorFunctions.sendKeyCommand(b))/* istanbul ignore else: don't run if already running */
	return a._bUpdateSelectedStyles||a.updateSelectedStyles(),b.preventDefault(),!1},
	//
	// When a toolbar and tools are created, it isn't until there is a key event or mouse event
	// that the updateSelectedStyles() is called behind the scenes.
	// This function forces an update through the existing editors to help the application make sure
	// the inital state is correct.
	//
	updateStyles:l,
	// return the current version of textAngular in use to the user
	getVersion:function(){return f},
	// for testing
	getToolbarScopes:function(){var a=[];return angular.forEach(j,function(b){a=a.concat(b.toolbarScopes)}),a}}}]),u.directive("textAngularToolbar",["$compile","textAngularManager","taOptions","taTools","taToolExecuteAction","$window",function(a,b,c,d,e,f){return{scope:{name:"@"},restrict:"EA",link:function(g,h,i){if(!g.name||""===g.name)throw"textAngular Error: A toolbar requires a name";angular.extend(g,angular.copy(c)),i.taToolbar&&(g.toolbar=g.$parent.$eval(i.taToolbar)),i.taToolbarClass&&(g.classes.toolbar=i.taToolbarClass),i.taToolbarGroupClass&&(g.classes.toolbarGroup=i.taToolbarGroupClass),i.taToolbarButtonClass&&(g.classes.toolbarButton=i.taToolbarButtonClass),i.taToolbarActiveButtonClass&&(g.classes.toolbarButtonActive=i.taToolbarActiveButtonClass),i.taFocussedClass&&(g.classes.focussed=i.taFocussedClass),g.disabled=!0,g.focussed=!1,g._$element=h,h[0].innerHTML="",h.addClass("ta-toolbar "+g.classes.toolbar),g.$watch("focussed",function(){g.focussed?h.addClass(g.classes.focussed):h.removeClass(g.classes.focussed)});var j=function(b,c){var d;if(d=b&&b.display?angular.element(b.display):angular.element("<button type='button'>"),b&&b.class?d.addClass(b.class):d.addClass(g.classes.toolbarButton),d.attr("name",c.name),
	// important to not take focus from the main text/html entry
	d.attr("ta-button","ta-button"),d.attr("ng-disabled","isDisabled()"),d.attr("tabindex","-1"),d.attr("ng-click","executeAction()"),d.attr("ng-class","displayActiveToolClass(active)"),b&&b.tooltiptext&&d.attr("title",b.tooltiptext),b&&!b.display&&!c._display&&(
	// first clear out the current contents if any
	d[0].innerHTML="",
	// add the buttonText
	b.buttontext&&(d[0].innerHTML=b.buttontext),b.iconclass)){var e=angular.element("<i>"),f=d[0].innerHTML;e.addClass(b.iconclass),d[0].innerHTML="",d.append(e),f&&""!==f&&d.append("&nbsp;"+f)}return c._lastToolDefinition=angular.copy(b),a(d)(c)};
	// Keep a reference for updating the active states later
	g.tools={},
	// create the tools in the toolbar
	// default functions and values to prevent errors in testing and on init
	g._parent={disabled:!0,showHtml:!1,queryFormatBlockState:function(){return!1},queryCommandState:function(){return!1}};var k={$window:f,$editor:function(){
	// dynamically gets the editor as it is set
	return g._parent},isDisabled:function(){
	// view selection button is always enabled since it doesn not depend on a selction!
	// view selection button is always enabled since it doesn not depend on a selction!
	// this bracket is important as without it it just returns the first bracket and ignores the rest
	// when the button's disabled function/value evaluates to true
	// all buttons except the HTML Switch button should be disabled in the showHtml (RAW html) mode
	// if the toolbar is disabled
	// if the current editor is disabled
	return("html"!==this.name||!g._parent.startAction)&&("function"!=typeof this.$eval("disabled")&&this.$eval("disabled")||this.$eval("disabled()")||"html"!==this.name&&this.$editor().showHtml||this.$parent.disabled||this.$editor().disabled)},displayActiveToolClass:function(a){return a?g.classes.toolbarButtonActive:""},executeAction:e};angular.forEach(g.toolbar,function(a){
	// setup the toolbar group
	var b=angular.element("<div>");b.addClass(g.classes.toolbarGroup),angular.forEach(a,function(a){
	// init and add the tools to the group
	// a tool name (key name from taTools struct)
	//creates a child scope of the main angularText scope and then extends the childScope with the functions of this particular tool
	// reference to the scope and element kept
	g.tools[a]=angular.extend(g.$new(!0),d[a],k,{name:a}),g.tools[a].$element=j(d[a],g.tools[a]),
	// append the tool compiled with the childScope to the group element
	b.append(g.tools[a].$element)}),
	// append the group to the toolbar
	h.append(b)}),
	// update a tool
	// if a value is set to null, remove from the display
	// when forceNew is set to true it will ignore all previous settings, used to reset to taTools definition
	// to reset to defaults pass in taTools[key] as _newTool and forceNew as true, ie `updateToolDisplay(key, taTools[key], true);`
	g.updateToolDisplay=function(a,b,c){var d=g.tools[a];if(d){if(
	// get the last toolDefinition, then override with the new definition
	d._lastToolDefinition&&!c&&(b=angular.extend({},d._lastToolDefinition,b)),null===b.buttontext&&null===b.iconclass&&null===b.display)throw'textAngular Error: Tool Definition for updating "'+a+'" does not have a valid display/iconclass/buttontext value';
	// if tool is defined on this toolbar, update/redo the tool
	null===b.buttontext&&delete b.buttontext,null===b.iconclass&&delete b.iconclass,null===b.display&&delete b.display;var e=j(b,d);d.$element.replaceWith(e),d.$element=e}},
	// we assume here that all values passed are valid and correct
	g.addTool=function(a,b,c,e){g.tools[a]=angular.extend(g.$new(!0),d[a],k,{name:a}),g.tools[a].$element=j(d[a],g.tools[a]);var f;void 0===c&&(c=g.toolbar.length-1),f=angular.element(h.children()[c]),void 0===e?(f.append(g.tools[a].$element),g.toolbar[c][g.toolbar[c].length-1]=a):(f.children().eq(e).after(g.tools[a].$element),g.toolbar[c][e]=a)},b.registerToolbar(g),g.$on("$destroy",function(){b.unregisterToolbar(g.name)})}}}]),u.directive("textAngularVersion",["textAngularManager",function(a){var b=a.getVersion();return{restrict:"EA",link:function(a,c,d){c.html(b)}}}]),u.name});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Copyright 2015, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.0
	 * Build date: 10 May 2015
	 */
	
	(function(factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && typeof exports == "object") {
	        // Node/CommonJS style
	        module.exports = factory();
	    } else {
	        // No AMD or CommonJS support so we place Rangy in (probably) the global variable
	        root.rangy = factory();
	    }
	})(function() {
	
	    var OBJECT = "object", FUNCTION = "function", UNDEFINED = "undefined";
	
	    // Minimal set of properties required for DOM Level 2 Range compliance. Comparison constants such as START_TO_START
	    // are omitted because ranges in KHTML do not have them but otherwise work perfectly well. See issue 113.
	    var domRangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
	        "commonAncestorContainer"];
	
	    // Minimal set of methods required for DOM Level 2 Range compliance
	    var domRangeMethods = ["setStart", "setStartBefore", "setStartAfter", "setEnd", "setEndBefore",
	        "setEndAfter", "collapse", "selectNode", "selectNodeContents", "compareBoundaryPoints", "deleteContents",
	        "extractContents", "cloneContents", "insertNode", "surroundContents", "cloneRange", "toString", "detach"];
	
	    var textRangeProperties = ["boundingHeight", "boundingLeft", "boundingTop", "boundingWidth", "htmlText", "text"];
	
	    // Subset of TextRange's full set of methods that we're interested in
	    var textRangeMethods = ["collapse", "compareEndPoints", "duplicate", "moveToElementText", "parentElement", "select",
	        "setEndPoint", "getBoundingClientRect"];
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Trio of functions taken from Peter Michaux's article:
	    // http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting
	    function isHostMethod(o, p) {
	        var t = typeof o[p];
	        return t == FUNCTION || (!!(t == OBJECT && o[p])) || t == "unknown";
	    }
	
	    function isHostObject(o, p) {
	        return !!(typeof o[p] == OBJECT && o[p]);
	    }
	
	    function isHostProperty(o, p) {
	        return typeof o[p] != UNDEFINED;
	    }
	
	    // Creates a convenience function to save verbose repeated calls to tests functions
	    function createMultiplePropertyTest(testFunc) {
	        return function(o, props) {
	            var i = props.length;
	            while (i--) {
	                if (!testFunc(o, props[i])) {
	                    return false;
	                }
	            }
	            return true;
	        };
	    }
	
	    // Next trio of functions are a convenience to save verbose repeated calls to previous two functions
	    var areHostMethods = createMultiplePropertyTest(isHostMethod);
	    var areHostObjects = createMultiplePropertyTest(isHostObject);
	    var areHostProperties = createMultiplePropertyTest(isHostProperty);
	
	    function isTextRange(range) {
	        return range && areHostMethods(range, textRangeMethods) && areHostProperties(range, textRangeProperties);
	    }
	
	    function getBody(doc) {
	        return isHostObject(doc, "body") ? doc.body : doc.getElementsByTagName("body")[0];
	    }
	
	    var forEach = [].forEach ?
	        function(arr, func) {
	            arr.forEach(func);
	        } :
	        function(arr, func) {
	            for (var i = 0, len = arr.length; i < len; ++i) {
	                func(arr[i], i);
	            }
	        };
	
	    var modules = {};
	
	    var isBrowser = (typeof window != UNDEFINED && typeof document != UNDEFINED);
	
	    var util = {
	        isHostMethod: isHostMethod,
	        isHostObject: isHostObject,
	        isHostProperty: isHostProperty,
	        areHostMethods: areHostMethods,
	        areHostObjects: areHostObjects,
	        areHostProperties: areHostProperties,
	        isTextRange: isTextRange,
	        getBody: getBody,
	        forEach: forEach
	    };
	
	    var api = {
	        version: "1.3.0",
	        initialized: false,
	        isBrowser: isBrowser,
	        supported: true,
	        util: util,
	        features: {},
	        modules: modules,
	        config: {
	            alertOnFail: false,
	            alertOnWarn: false,
	            preferTextRange: false,
	            autoInitialize: (typeof rangyAutoInitialize == UNDEFINED) ? true : rangyAutoInitialize
	        }
	    };
	
	    function consoleLog(msg) {
	        if (typeof console != UNDEFINED && isHostMethod(console, "log")) {
	            console.log(msg);
	        }
	    }
	
	    function alertOrLog(msg, shouldAlert) {
	        if (isBrowser && shouldAlert) {
	            alert(msg);
	        } else  {
	            consoleLog(msg);
	        }
	    }
	
	    function fail(reason) {
	        api.initialized = true;
	        api.supported = false;
	        alertOrLog("Rangy is not supported in this environment. Reason: " + reason, api.config.alertOnFail);
	    }
	
	    api.fail = fail;
	
	    function warn(msg) {
	        alertOrLog("Rangy warning: " + msg, api.config.alertOnWarn);
	    }
	
	    api.warn = warn;
	
	    // Add utility extend() method
	    var extend;
	    if ({}.hasOwnProperty) {
	        util.extend = extend = function(obj, props, deep) {
	            var o, p;
	            for (var i in props) {
	                if (props.hasOwnProperty(i)) {
	                    o = obj[i];
	                    p = props[i];
	                    if (deep && o !== null && typeof o == "object" && p !== null && typeof p == "object") {
	                        extend(o, p, true);
	                    }
	                    obj[i] = p;
	                }
	            }
	            // Special case for toString, which does not show up in for...in loops in IE <= 8
	            if (props.hasOwnProperty("toString")) {
	                obj.toString = props.toString;
	            }
	            return obj;
	        };
	
	        util.createOptions = function(optionsParam, defaults) {
	            var options = {};
	            extend(options, defaults);
	            if (optionsParam) {
	                extend(options, optionsParam);
	            }
	            return options;
	        };
	    } else {
	        fail("hasOwnProperty not supported");
	    }
	
	    // Test whether we're in a browser and bail out if not
	    if (!isBrowser) {
	        fail("Rangy can only run in a browser");
	    }
	
	    // Test whether Array.prototype.slice can be relied on for NodeLists and use an alternative toArray() if not
	    (function() {
	        var toArray;
	
	        if (isBrowser) {
	            var el = document.createElement("div");
	            el.appendChild(document.createElement("span"));
	            var slice = [].slice;
	            try {
	                if (slice.call(el.childNodes, 0)[0].nodeType == 1) {
	                    toArray = function(arrayLike) {
	                        return slice.call(arrayLike, 0);
	                    };
	                }
	            } catch (e) {}
	        }
	
	        if (!toArray) {
	            toArray = function(arrayLike) {
	                var arr = [];
	                for (var i = 0, len = arrayLike.length; i < len; ++i) {
	                    arr[i] = arrayLike[i];
	                }
	                return arr;
	            };
	        }
	
	        util.toArray = toArray;
	    })();
	
	    // Very simple event handler wrapper function that doesn't attempt to solve issues such as "this" handling or
	    // normalization of event properties
	    var addListener;
	    if (isBrowser) {
	        if (isHostMethod(document, "addEventListener")) {
	            addListener = function(obj, eventType, listener) {
	                obj.addEventListener(eventType, listener, false);
	            };
	        } else if (isHostMethod(document, "attachEvent")) {
	            addListener = function(obj, eventType, listener) {
	                obj.attachEvent("on" + eventType, listener);
	            };
	        } else {
	            fail("Document does not have required addEventListener or attachEvent method");
	        }
	
	        util.addListener = addListener;
	    }
	
	    var initListeners = [];
	
	    function getErrorDesc(ex) {
	        return ex.message || ex.description || String(ex);
	    }
	
	    // Initialization
	    function init() {
	        if (!isBrowser || api.initialized) {
	            return;
	        }
	        var testRange;
	        var implementsDomRange = false, implementsTextRange = false;
	
	        // First, perform basic feature tests
	
	        if (isHostMethod(document, "createRange")) {
	            testRange = document.createRange();
	            if (areHostMethods(testRange, domRangeMethods) && areHostProperties(testRange, domRangeProperties)) {
	                implementsDomRange = true;
	            }
	        }
	
	        var body = getBody(document);
	        if (!body || body.nodeName.toLowerCase() != "body") {
	            fail("No body element found");
	            return;
	        }
	
	        if (body && isHostMethod(body, "createTextRange")) {
	            testRange = body.createTextRange();
	            if (isTextRange(testRange)) {
	                implementsTextRange = true;
	            }
	        }
	
	        if (!implementsDomRange && !implementsTextRange) {
	            fail("Neither Range nor TextRange are available");
	            return;
	        }
	
	        api.initialized = true;
	        api.features = {
	            implementsDomRange: implementsDomRange,
	            implementsTextRange: implementsTextRange
	        };
	
	        // Initialize modules
	        var module, errorMessage;
	        for (var moduleName in modules) {
	            if ( (module = modules[moduleName]) instanceof Module ) {
	                module.init(module, api);
	            }
	        }
	
	        // Call init listeners
	        for (var i = 0, len = initListeners.length; i < len; ++i) {
	            try {
	                initListeners[i](api);
	            } catch (ex) {
	                errorMessage = "Rangy init listener threw an exception. Continuing. Detail: " + getErrorDesc(ex);
	                consoleLog(errorMessage);
	            }
	        }
	    }
	
	    function deprecationNotice(deprecated, replacement, module) {
	        if (module) {
	            deprecated += " in module " + module.name;
	        }
	        api.warn("DEPRECATED: " + deprecated + " is deprecated. Please use " +
	        replacement + " instead.");
	    }
	
	    function createAliasForDeprecatedMethod(owner, deprecated, replacement, module) {
	        owner[deprecated] = function() {
	            deprecationNotice(deprecated, replacement, module);
	            return owner[replacement].apply(owner, util.toArray(arguments));
	        };
	    }
	
	    util.deprecationNotice = deprecationNotice;
	    util.createAliasForDeprecatedMethod = createAliasForDeprecatedMethod;
	
	    // Allow external scripts to initialize this library in case it's loaded after the document has loaded
	    api.init = init;
	
	    // Execute listener immediately if already initialized
	    api.addInitListener = function(listener) {
	        if (api.initialized) {
	            listener(api);
	        } else {
	            initListeners.push(listener);
	        }
	    };
	
	    var shimListeners = [];
	
	    api.addShimListener = function(listener) {
	        shimListeners.push(listener);
	    };
	
	    function shim(win) {
	        win = win || window;
	        init();
	
	        // Notify listeners
	        for (var i = 0, len = shimListeners.length; i < len; ++i) {
	            shimListeners[i](win);
	        }
	    }
	
	    if (isBrowser) {
	        api.shim = api.createMissingNativeApi = shim;
	        createAliasForDeprecatedMethod(api, "createMissingNativeApi", "shim");
	    }
	
	    function Module(name, dependencies, initializer) {
	        this.name = name;
	        this.dependencies = dependencies;
	        this.initialized = false;
	        this.supported = false;
	        this.initializer = initializer;
	    }
	
	    Module.prototype = {
	        init: function() {
	            var requiredModuleNames = this.dependencies || [];
	            for (var i = 0, len = requiredModuleNames.length, requiredModule, moduleName; i < len; ++i) {
	                moduleName = requiredModuleNames[i];
	
	                requiredModule = modules[moduleName];
	                if (!requiredModule || !(requiredModule instanceof Module)) {
	                    throw new Error("required module '" + moduleName + "' not found");
	                }
	
	                requiredModule.init();
	
	                if (!requiredModule.supported) {
	                    throw new Error("required module '" + moduleName + "' not supported");
	                }
	            }
	
	            // Now run initializer
	            this.initializer(this);
	        },
	
	        fail: function(reason) {
	            this.initialized = true;
	            this.supported = false;
	            throw new Error(reason);
	        },
	
	        warn: function(msg) {
	            api.warn("Module " + this.name + ": " + msg);
	        },
	
	        deprecationNotice: function(deprecated, replacement) {
	            api.warn("DEPRECATED: " + deprecated + " in module " + this.name + " is deprecated. Please use " +
	                replacement + " instead");
	        },
	
	        createError: function(msg) {
	            return new Error("Error in Rangy " + this.name + " module: " + msg);
	        }
	    };
	
	    function createModule(name, dependencies, initFunc) {
	        var newModule = new Module(name, dependencies, function(module) {
	            if (!module.initialized) {
	                module.initialized = true;
	                try {
	                    initFunc(api, module);
	                    module.supported = true;
	                } catch (ex) {
	                    var errorMessage = "Module '" + name + "' failed to load: " + getErrorDesc(ex);
	                    consoleLog(errorMessage);
	                    if (ex.stack) {
	                        consoleLog(ex.stack);
	                    }
	                }
	            }
	        });
	        modules[name] = newModule;
	        return newModule;
	    }
	
	    api.createModule = function(name) {
	        // Allow 2 or 3 arguments (second argument is an optional array of dependencies)
	        var initFunc, dependencies;
	        if (arguments.length == 2) {
	            initFunc = arguments[1];
	            dependencies = [];
	        } else {
	            initFunc = arguments[2];
	            dependencies = arguments[1];
	        }
	
	        var module = createModule(name, dependencies, initFunc);
	
	        // Initialize the module immediately if the core is already initialized
	        if (api.initialized && api.supported) {
	            module.init();
	        }
	    };
	
	    api.createCoreModule = function(name, dependencies, initFunc) {
	        createModule(name, dependencies, initFunc);
	    };
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Ensure rangy.rangePrototype and rangy.selectionPrototype are available immediately
	
	    function RangePrototype() {}
	    api.RangePrototype = RangePrototype;
	    api.rangePrototype = new RangePrototype();
	
	    function SelectionPrototype() {}
	    api.selectionPrototype = new SelectionPrototype();
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // DOM utility methods used by Rangy
	    api.createCoreModule("DomUtil", [], function(api, module) {
	        var UNDEF = "undefined";
	        var util = api.util;
	        var getBody = util.getBody;
	
	        // Perform feature tests
	        if (!util.areHostMethods(document, ["createDocumentFragment", "createElement", "createTextNode"])) {
	            module.fail("document missing a Node creation method");
	        }
	
	        if (!util.isHostMethod(document, "getElementsByTagName")) {
	            module.fail("document missing getElementsByTagName method");
	        }
	
	        var el = document.createElement("div");
	        if (!util.areHostMethods(el, ["insertBefore", "appendChild", "cloneNode"] ||
	                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]))) {
	            module.fail("Incomplete Element implementation");
	        }
	
	        // innerHTML is required for Range's createContextualFragment method
	        if (!util.isHostProperty(el, "innerHTML")) {
	            module.fail("Element is missing innerHTML property");
	        }
	
	        var textNode = document.createTextNode("test");
	        if (!util.areHostMethods(textNode, ["splitText", "deleteData", "insertData", "appendData", "cloneNode"] ||
	                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]) ||
	                !util.areHostProperties(textNode, ["data"]))) {
	            module.fail("Incomplete Text Node implementation");
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been
	        // able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that
	        // contains just the document as a single element and the value searched for is the document.
	        var arrayContains = /*Array.prototype.indexOf ?
	            function(arr, val) {
	                return arr.indexOf(val) > -1;
	            }:*/
	
	            function(arr, val) {
	                var i = arr.length;
	                while (i--) {
	                    if (arr[i] === val) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	
	        // Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI
	        function isHtmlNamespace(node) {
	            var ns;
	            return typeof node.namespaceURI == UNDEF || ((ns = node.namespaceURI) === null || ns == "http://www.w3.org/1999/xhtml");
	        }
	
	        function parentElement(node) {
	            var parent = node.parentNode;
	            return (parent.nodeType == 1) ? parent : null;
	        }
	
	        function getNodeIndex(node) {
	            var i = 0;
	            while( (node = node.previousSibling) ) {
	                ++i;
	            }
	            return i;
	        }
	
	        function getNodeLength(node) {
	            switch (node.nodeType) {
	                case 7:
	                case 10:
	                    return 0;
	                case 3:
	                case 8:
	                    return node.length;
	                default:
	                    return node.childNodes.length;
	            }
	        }
	
	        function getCommonAncestor(node1, node2) {
	            var ancestors = [], n;
	            for (n = node1; n; n = n.parentNode) {
	                ancestors.push(n);
	            }
	
	            for (n = node2; n; n = n.parentNode) {
	                if (arrayContains(ancestors, n)) {
	                    return n;
	                }
	            }
	
	            return null;
	        }
	
	        function isAncestorOf(ancestor, descendant, selfIsAncestor) {
	            var n = selfIsAncestor ? descendant : descendant.parentNode;
	            while (n) {
	                if (n === ancestor) {
	                    return true;
	                } else {
	                    n = n.parentNode;
	                }
	            }
	            return false;
	        }
	
	        function isOrIsAncestorOf(ancestor, descendant) {
	            return isAncestorOf(ancestor, descendant, true);
	        }
	
	        function getClosestAncestorIn(node, ancestor, selfIsAncestor) {
	            var p, n = selfIsAncestor ? node : node.parentNode;
	            while (n) {
	                p = n.parentNode;
	                if (p === ancestor) {
	                    return n;
	                }
	                n = p;
	            }
	            return null;
	        }
	
	        function isCharacterDataNode(node) {
	            var t = node.nodeType;
	            return t == 3 || t == 4 || t == 8 ; // Text, CDataSection or Comment
	        }
	
	        function isTextOrCommentNode(node) {
	            if (!node) {
	                return false;
	            }
	            var t = node.nodeType;
	            return t == 3 || t == 8 ; // Text or Comment
	        }
	
	        function insertAfter(node, precedingNode) {
	            var nextNode = precedingNode.nextSibling, parent = precedingNode.parentNode;
	            if (nextNode) {
	                parent.insertBefore(node, nextNode);
	            } else {
	                parent.appendChild(node);
	            }
	            return node;
	        }
	
	        // Note that we cannot use splitText() because it is bugridden in IE 9.
	        function splitDataNode(node, index, positionsToPreserve) {
	            var newNode = node.cloneNode(false);
	            newNode.deleteData(0, index);
	            node.deleteData(index, node.length - index);
	            insertAfter(newNode, node);
	
	            // Preserve positions
	            if (positionsToPreserve) {
	                for (var i = 0, position; position = positionsToPreserve[i++]; ) {
	                    // Handle case where position was inside the portion of node after the split point
	                    if (position.node == node && position.offset > index) {
	                        position.node = newNode;
	                        position.offset -= index;
	                    }
	                    // Handle the case where the position is a node offset within node's parent
	                    else if (position.node == node.parentNode && position.offset > getNodeIndex(node)) {
	                        ++position.offset;
	                    }
	                }
	            }
	            return newNode;
	        }
	
	        function getDocument(node) {
	            if (node.nodeType == 9) {
	                return node;
	            } else if (typeof node.ownerDocument != UNDEF) {
	                return node.ownerDocument;
	            } else if (typeof node.document != UNDEF) {
	                return node.document;
	            } else if (node.parentNode) {
	                return getDocument(node.parentNode);
	            } else {
	                throw module.createError("getDocument: no document found for node");
	            }
	        }
	
	        function getWindow(node) {
	            var doc = getDocument(node);
	            if (typeof doc.defaultView != UNDEF) {
	                return doc.defaultView;
	            } else if (typeof doc.parentWindow != UNDEF) {
	                return doc.parentWindow;
	            } else {
	                throw module.createError("Cannot get a window object for node");
	            }
	        }
	
	        function getIframeDocument(iframeEl) {
	            if (typeof iframeEl.contentDocument != UNDEF) {
	                return iframeEl.contentDocument;
	            } else if (typeof iframeEl.contentWindow != UNDEF) {
	                return iframeEl.contentWindow.document;
	            } else {
	                throw module.createError("getIframeDocument: No Document object found for iframe element");
	            }
	        }
	
	        function getIframeWindow(iframeEl) {
	            if (typeof iframeEl.contentWindow != UNDEF) {
	                return iframeEl.contentWindow;
	            } else if (typeof iframeEl.contentDocument != UNDEF) {
	                return iframeEl.contentDocument.defaultView;
	            } else {
	                throw module.createError("getIframeWindow: No Window object found for iframe element");
	            }
	        }
	
	        // This looks bad. Is it worth it?
	        function isWindow(obj) {
	            return obj && util.isHostMethod(obj, "setTimeout") && util.isHostObject(obj, "document");
	        }
	
	        function getContentDocument(obj, module, methodName) {
	            var doc;
	
	            if (!obj) {
	                doc = document;
	            }
	
	            // Test if a DOM node has been passed and obtain a document object for it if so
	            else if (util.isHostProperty(obj, "nodeType")) {
	                doc = (obj.nodeType == 1 && obj.tagName.toLowerCase() == "iframe") ?
	                    getIframeDocument(obj) : getDocument(obj);
	            }
	
	            // Test if the doc parameter appears to be a Window object
	            else if (isWindow(obj)) {
	                doc = obj.document;
	            }
	
	            if (!doc) {
	                throw module.createError(methodName + "(): Parameter must be a Window object or DOM node");
	            }
	
	            return doc;
	        }
	
	        function getRootContainer(node) {
	            var parent;
	            while ( (parent = node.parentNode) ) {
	                node = parent;
	            }
	            return node;
	        }
	
	        function comparePoints(nodeA, offsetA, nodeB, offsetB) {
	            // See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing
	            var nodeC, root, childA, childB, n;
	            if (nodeA == nodeB) {
	                // Case 1: nodes are the same
	                return offsetA === offsetB ? 0 : (offsetA < offsetB) ? -1 : 1;
	            } else if ( (nodeC = getClosestAncestorIn(nodeB, nodeA, true)) ) {
	                // Case 2: node C (container B or an ancestor) is a child node of A
	                return offsetA <= getNodeIndex(nodeC) ? -1 : 1;
	            } else if ( (nodeC = getClosestAncestorIn(nodeA, nodeB, true)) ) {
	                // Case 3: node C (container A or an ancestor) is a child node of B
	                return getNodeIndex(nodeC) < offsetB  ? -1 : 1;
	            } else {
	                root = getCommonAncestor(nodeA, nodeB);
	                if (!root) {
	                    throw new Error("comparePoints error: nodes have no common ancestor");
	                }
	
	                // Case 4: containers are siblings or descendants of siblings
	                childA = (nodeA === root) ? root : getClosestAncestorIn(nodeA, root, true);
	                childB = (nodeB === root) ? root : getClosestAncestorIn(nodeB, root, true);
	
	                if (childA === childB) {
	                    // This shouldn't be possible
	                    throw module.createError("comparePoints got to case 4 and childA and childB are the same!");
	                } else {
	                    n = root.firstChild;
	                    while (n) {
	                        if (n === childA) {
	                            return -1;
	                        } else if (n === childB) {
	                            return 1;
	                        }
	                        n = n.nextSibling;
	                    }
	                }
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test for IE's crash (IE 6/7) or exception (IE >= 8) when a reference to garbage-collected text node is queried
	        var crashyTextNodes = false;
	
	        function isBrokenNode(node) {
	            var n;
	            try {
	                n = node.parentNode;
	                return false;
	            } catch (e) {
	                return true;
	            }
	        }
	
	        (function() {
	            var el = document.createElement("b");
	            el.innerHTML = "1";
	            var textNode = el.firstChild;
	            el.innerHTML = "<br />";
	            crashyTextNodes = isBrokenNode(textNode);
	
	            api.features.crashyTextNodes = crashyTextNodes;
	        })();
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        function inspectNode(node) {
	            if (!node) {
	                return "[No node]";
	            }
	            if (crashyTextNodes && isBrokenNode(node)) {
	                return "[Broken node]";
	            }
	            if (isCharacterDataNode(node)) {
	                return '"' + node.data + '"';
	            }
	            if (node.nodeType == 1) {
	                var idAttr = node.id ? ' id="' + node.id + '"' : "";
	                return "<" + node.nodeName + idAttr + ">[index:" + getNodeIndex(node) + ",length:" + node.childNodes.length + "][" + (node.innerHTML || "[innerHTML not supported]").slice(0, 25) + "]";
	            }
	            return node.nodeName;
	        }
	
	        function fragmentFromNodeChildren(node) {
	            var fragment = getDocument(node).createDocumentFragment(), child;
	            while ( (child = node.firstChild) ) {
	                fragment.appendChild(child);
	            }
	            return fragment;
	        }
	
	        var getComputedStyleProperty;
	        if (typeof window.getComputedStyle != UNDEF) {
	            getComputedStyleProperty = function(el, propName) {
	                return getWindow(el).getComputedStyle(el, null)[propName];
	            };
	        } else if (typeof document.documentElement.currentStyle != UNDEF) {
	            getComputedStyleProperty = function(el, propName) {
	                return el.currentStyle ? el.currentStyle[propName] : "";
	            };
	        } else {
	            module.fail("No means of obtaining computed style properties found");
	        }
	
	        function createTestElement(doc, html, contentEditable) {
	            var body = getBody(doc);
	            var el = doc.createElement("div");
	            el.contentEditable = "" + !!contentEditable;
	            if (html) {
	                el.innerHTML = html;
	            }
	
	            // Insert the test element at the start of the body to prevent scrolling to the bottom in iOS (issue #292)
	            var bodyFirstChild = body.firstChild;
	            if (bodyFirstChild) {
	                body.insertBefore(el, bodyFirstChild);
	            } else {
	                body.appendChild(el);
	            }
	
	            return el;
	        }
	
	        function removeNode(node) {
	            return node.parentNode.removeChild(node);
	        }
	
	        function NodeIterator(root) {
	            this.root = root;
	            this._next = root;
	        }
	
	        NodeIterator.prototype = {
	            _current: null,
	
	            hasNext: function() {
	                return !!this._next;
	            },
	
	            next: function() {
	                var n = this._current = this._next;
	                var child, next;
	                if (this._current) {
	                    child = n.firstChild;
	                    if (child) {
	                        this._next = child;
	                    } else {
	                        next = null;
	                        while ((n !== this.root) && !(next = n.nextSibling)) {
	                            n = n.parentNode;
	                        }
	                        this._next = next;
	                    }
	                }
	                return this._current;
	            },
	
	            detach: function() {
	                this._current = this._next = this.root = null;
	            }
	        };
	
	        function createIterator(root) {
	            return new NodeIterator(root);
	        }
	
	        function DomPosition(node, offset) {
	            this.node = node;
	            this.offset = offset;
	        }
	
	        DomPosition.prototype = {
	            equals: function(pos) {
	                return !!pos && this.node === pos.node && this.offset == pos.offset;
	            },
	
	            inspect: function() {
	                return "[DomPosition(" + inspectNode(this.node) + ":" + this.offset + ")]";
	            },
	
	            toString: function() {
	                return this.inspect();
	            }
	        };
	
	        function DOMException(codeName) {
	            this.code = this[codeName];
	            this.codeName = codeName;
	            this.message = "DOMException: " + this.codeName;
	        }
	
	        DOMException.prototype = {
	            INDEX_SIZE_ERR: 1,
	            HIERARCHY_REQUEST_ERR: 3,
	            WRONG_DOCUMENT_ERR: 4,
	            NO_MODIFICATION_ALLOWED_ERR: 7,
	            NOT_FOUND_ERR: 8,
	            NOT_SUPPORTED_ERR: 9,
	            INVALID_STATE_ERR: 11,
	            INVALID_NODE_TYPE_ERR: 24
	        };
	
	        DOMException.prototype.toString = function() {
	            return this.message;
	        };
	
	        api.dom = {
	            arrayContains: arrayContains,
	            isHtmlNamespace: isHtmlNamespace,
	            parentElement: parentElement,
	            getNodeIndex: getNodeIndex,
	            getNodeLength: getNodeLength,
	            getCommonAncestor: getCommonAncestor,
	            isAncestorOf: isAncestorOf,
	            isOrIsAncestorOf: isOrIsAncestorOf,
	            getClosestAncestorIn: getClosestAncestorIn,
	            isCharacterDataNode: isCharacterDataNode,
	            isTextOrCommentNode: isTextOrCommentNode,
	            insertAfter: insertAfter,
	            splitDataNode: splitDataNode,
	            getDocument: getDocument,
	            getWindow: getWindow,
	            getIframeWindow: getIframeWindow,
	            getIframeDocument: getIframeDocument,
	            getBody: getBody,
	            isWindow: isWindow,
	            getContentDocument: getContentDocument,
	            getRootContainer: getRootContainer,
	            comparePoints: comparePoints,
	            isBrokenNode: isBrokenNode,
	            inspectNode: inspectNode,
	            getComputedStyleProperty: getComputedStyleProperty,
	            createTestElement: createTestElement,
	            removeNode: removeNode,
	            fragmentFromNodeChildren: fragmentFromNodeChildren,
	            createIterator: createIterator,
	            DomPosition: DomPosition
	        };
	
	        api.DOMException = DOMException;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Pure JavaScript implementation of DOM Range
	    api.createCoreModule("DomRange", ["DomUtil"], function(api, module) {
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DOMException = api.DOMException;
	
	        var isCharacterDataNode = dom.isCharacterDataNode;
	        var getNodeIndex = dom.getNodeIndex;
	        var isOrIsAncestorOf = dom.isOrIsAncestorOf;
	        var getDocument = dom.getDocument;
	        var comparePoints = dom.comparePoints;
	        var splitDataNode = dom.splitDataNode;
	        var getClosestAncestorIn = dom.getClosestAncestorIn;
	        var getNodeLength = dom.getNodeLength;
	        var arrayContains = dom.arrayContains;
	        var getRootContainer = dom.getRootContainer;
	        var crashyTextNodes = api.features.crashyTextNodes;
	
	        var removeNode = dom.removeNode;
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Utility functions
	
	        function isNonTextPartiallySelected(node, range) {
	            return (node.nodeType != 3) &&
	                   (isOrIsAncestorOf(node, range.startContainer) || isOrIsAncestorOf(node, range.endContainer));
	        }
	
	        function getRangeDocument(range) {
	            return range.document || getDocument(range.startContainer);
	        }
	
	        function getRangeRoot(range) {
	            return getRootContainer(range.startContainer);
	        }
	
	        function getBoundaryBeforeNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node));
	        }
	
	        function getBoundaryAfterNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node) + 1);
	        }
	
	        function insertNodeAtPosition(node, n, o) {
	            var firstNodeInserted = node.nodeType == 11 ? node.firstChild : node;
	            if (isCharacterDataNode(n)) {
	                if (o == n.length) {
	                    dom.insertAfter(node, n);
	                } else {
	                    n.parentNode.insertBefore(node, o == 0 ? n : splitDataNode(n, o));
	                }
	            } else if (o >= n.childNodes.length) {
	                n.appendChild(node);
	            } else {
	                n.insertBefore(node, n.childNodes[o]);
	            }
	            return firstNodeInserted;
	        }
	
	        function rangesIntersect(rangeA, rangeB, touchingIsIntersecting) {
	            assertRangeValid(rangeA);
	            assertRangeValid(rangeB);
	
	            if (getRangeDocument(rangeB) != getRangeDocument(rangeA)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	
	            var startComparison = comparePoints(rangeA.startContainer, rangeA.startOffset, rangeB.endContainer, rangeB.endOffset),
	                endComparison = comparePoints(rangeA.endContainer, rangeA.endOffset, rangeB.startContainer, rangeB.startOffset);
	
	            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	        }
	
	        function cloneSubtree(iterator) {
	            var partiallySelected;
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
	                partiallySelected = iterator.isPartiallySelectedSubtree();
	                node = node.cloneNode(!partiallySelected);
	                if (partiallySelected) {
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(cloneSubtree(subIterator));
	                    subIterator.detach();
	                }
	
	                if (node.nodeType == 10) { // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function iterateSubtree(rangeIterator, func, iteratorState) {
	            var it, n;
	            iteratorState = iteratorState || { stop: false };
	            for (var node, subRangeIterator; node = rangeIterator.next(); ) {
	                if (rangeIterator.isPartiallySelectedSubtree()) {
	                    if (func(node) === false) {
	                        iteratorState.stop = true;
	                        return;
	                    } else {
	                        // The node is partially selected by the Range, so we can use a new RangeIterator on the portion of
	                        // the node selected by the Range.
	                        subRangeIterator = rangeIterator.getSubtreeIterator();
	                        iterateSubtree(subRangeIterator, func, iteratorState);
	                        subRangeIterator.detach();
	                        if (iteratorState.stop) {
	                            return;
	                        }
	                    }
	                } else {
	                    // The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its
	                    // descendants
	                    it = dom.createIterator(node);
	                    while ( (n = it.next()) ) {
	                        if (func(n) === false) {
	                            iteratorState.stop = true;
	                            return;
	                        }
	                    }
	                }
	            }
	        }
	
	        function deleteSubtree(iterator) {
	            var subIterator;
	            while (iterator.next()) {
	                if (iterator.isPartiallySelectedSubtree()) {
	                    subIterator = iterator.getSubtreeIterator();
	                    deleteSubtree(subIterator);
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	            }
	        }
	
	        function extractSubtree(iterator) {
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
	
	                if (iterator.isPartiallySelectedSubtree()) {
	                    node = node.cloneNode(false);
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(extractSubtree(subIterator));
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	                if (node.nodeType == 10) { // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function getNodesInRange(range, nodeTypes, filter) {
	            var filterNodeTypes = !!(nodeTypes && nodeTypes.length), regex;
	            var filterExists = !!filter;
	            if (filterNodeTypes) {
	                regex = new RegExp("^(" + nodeTypes.join("|") + ")$");
	            }
	
	            var nodes = [];
	            iterateSubtree(new RangeIterator(range, false), function(node) {
	                if (filterNodeTypes && !regex.test(node.nodeType)) {
	                    return;
	                }
	                if (filterExists && !filter(node)) {
	                    return;
	                }
	                // Don't include a boundary container if it is a character data node and the range does not contain any
	                // of its character data. See issue 190.
	                var sc = range.startContainer;
	                if (node == sc && isCharacterDataNode(sc) && range.startOffset == sc.length) {
	                    return;
	                }
	
	                var ec = range.endContainer;
	                if (node == ec && isCharacterDataNode(ec) && range.endOffset == 0) {
	                    return;
	                }
	
	                nodes.push(node);
	            });
	            return nodes;
	        }
	
	        function inspect(range) {
	            var name = (typeof range.getName == "undefined") ? "Range" : range.getName();
	            return "[" + name + "(" + dom.inspectNode(range.startContainer) + ":" + range.startOffset + ", " +
	                    dom.inspectNode(range.endContainer) + ":" + range.endOffset + ")]";
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)
	
	        function RangeIterator(range, clonePartiallySelectedTextNodes) {
	            this.range = range;
	            this.clonePartiallySelectedTextNodes = clonePartiallySelectedTextNodes;
	
	
	            if (!range.collapsed) {
	                this.sc = range.startContainer;
	                this.so = range.startOffset;
	                this.ec = range.endContainer;
	                this.eo = range.endOffset;
	                var root = range.commonAncestorContainer;
	
	                if (this.sc === this.ec && isCharacterDataNode(this.sc)) {
	                    this.isSingleCharacterDataNode = true;
	                    this._first = this._last = this._next = this.sc;
	                } else {
	                    this._first = this._next = (this.sc === root && !isCharacterDataNode(this.sc)) ?
	                        this.sc.childNodes[this.so] : getClosestAncestorIn(this.sc, root, true);
	                    this._last = (this.ec === root && !isCharacterDataNode(this.ec)) ?
	                        this.ec.childNodes[this.eo - 1] : getClosestAncestorIn(this.ec, root, true);
	                }
	            }
	        }
	
	        RangeIterator.prototype = {
	            _current: null,
	            _next: null,
	            _first: null,
	            _last: null,
	            isSingleCharacterDataNode: false,
	
	            reset: function() {
	                this._current = null;
	                this._next = this._first;
	            },
	
	            hasNext: function() {
	                return !!this._next;
	            },
	
	            next: function() {
	                // Move to next node
	                var current = this._current = this._next;
	                if (current) {
	                    this._next = (current !== this._last) ? current.nextSibling : null;
	
	                    // Check for partially selected text nodes
	                    if (isCharacterDataNode(current) && this.clonePartiallySelectedTextNodes) {
	                        if (current === this.ec) {
	                            (current = current.cloneNode(true)).deleteData(this.eo, current.length - this.eo);
	                        }
	                        if (this._current === this.sc) {
	                            (current = current.cloneNode(true)).deleteData(0, this.so);
	                        }
	                    }
	                }
	
	                return current;
	            },
	
	            remove: function() {
	                var current = this._current, start, end;
	
	                if (isCharacterDataNode(current) && (current === this.sc || current === this.ec)) {
	                    start = (current === this.sc) ? this.so : 0;
	                    end = (current === this.ec) ? this.eo : current.length;
	                    if (start != end) {
	                        current.deleteData(start, end - start);
	                    }
	                } else {
	                    if (current.parentNode) {
	                        removeNode(current);
	                    } else {
	                    }
	                }
	            },
	
	            // Checks if the current node is partially selected
	            isPartiallySelectedSubtree: function() {
	                var current = this._current;
	                return isNonTextPartiallySelected(current, this.range);
	            },
	
	            getSubtreeIterator: function() {
	                var subRange;
	                if (this.isSingleCharacterDataNode) {
	                    subRange = this.range.cloneRange();
	                    subRange.collapse(false);
	                } else {
	                    subRange = new Range(getRangeDocument(this.range));
	                    var current = this._current;
	                    var startContainer = current, startOffset = 0, endContainer = current, endOffset = getNodeLength(current);
	
	                    if (isOrIsAncestorOf(current, this.sc)) {
	                        startContainer = this.sc;
	                        startOffset = this.so;
	                    }
	                    if (isOrIsAncestorOf(current, this.ec)) {
	                        endContainer = this.ec;
	                        endOffset = this.eo;
	                    }
	
	                    updateBoundaries(subRange, startContainer, startOffset, endContainer, endOffset);
	                }
	                return new RangeIterator(subRange, this.clonePartiallySelectedTextNodes);
	            },
	
	            detach: function() {
	                this.range = this._current = this._next = this._first = this._last = this.sc = this.so = this.ec = this.eo = null;
	            }
	        };
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var beforeAfterNodeTypes = [1, 3, 4, 5, 7, 8, 10];
	        var rootContainerNodeTypes = [2, 9, 11];
	        var readonlyNodeTypes = [5, 6, 10, 12];
	        var insertableNodeTypes = [1, 3, 4, 5, 7, 8, 10, 11];
	        var surroundNodeTypes = [1, 3, 4, 5, 7, 8];
	
	        function createAncestorFinder(nodeTypes) {
	            return function(node, selfIsAncestor) {
	                var t, n = selfIsAncestor ? node : node.parentNode;
	                while (n) {
	                    t = n.nodeType;
	                    if (arrayContains(nodeTypes, t)) {
	                        return n;
	                    }
	                    n = n.parentNode;
	                }
	                return null;
	            };
	        }
	
	        var getDocumentOrFragmentContainer = createAncestorFinder( [9, 11] );
	        var getReadonlyAncestor = createAncestorFinder(readonlyNodeTypes);
	        var getDocTypeNotationEntityAncestor = createAncestorFinder( [6, 10, 12] );
	
	        function assertNoDocTypeNotationEntityAncestor(node, allowSelf) {
	            if (getDocTypeNotationEntityAncestor(node, allowSelf)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidNodeType(node, invalidTypes) {
	            if (!arrayContains(invalidTypes, node.nodeType)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidOffset(node, offset) {
	            if (offset < 0 || offset > (isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            }
	        }
	
	        function assertSameDocumentOrFragment(node1, node2) {
	            if (getDocumentOrFragmentContainer(node1, true) !== getDocumentOrFragmentContainer(node2, true)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        function assertNodeNotReadOnly(node) {
	            if (getReadonlyAncestor(node, true)) {
	                throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");
	            }
	        }
	
	        function assertNode(node, codeName) {
	            if (!node) {
	                throw new DOMException(codeName);
	            }
	        }
	
	        function isValidOffset(node, offset) {
	            return offset <= (isCharacterDataNode(node) ? node.length : node.childNodes.length);
	        }
	
	        function isRangeValid(range) {
	            return (!!range.startContainer && !!range.endContainer &&
	                    !(crashyTextNodes && (dom.isBrokenNode(range.startContainer) || dom.isBrokenNode(range.endContainer))) &&
	                    getRootContainer(range.startContainer) == getRootContainer(range.endContainer) &&
	                    isValidOffset(range.startContainer, range.startOffset) &&
	                    isValidOffset(range.endContainer, range.endOffset));
	        }
	
	        function assertRangeValid(range) {
	            if (!isRangeValid(range)) {
	                throw new Error("Range error: Range is not valid. This usually happens after DOM mutation. Range: (" + range.inspect() + ")");
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test the browser's innerHTML support to decide how to implement createContextualFragment
	        var styleEl = document.createElement("style");
	        var htmlParsingConforms = false;
	        try {
	            styleEl.innerHTML = "<b>x</b>";
	            htmlParsingConforms = (styleEl.firstChild.nodeType == 3); // Opera incorrectly creates an element node
	        } catch (e) {
	            // IE 6 and 7 throw
	        }
	
	        api.features.htmlParsingConforms = htmlParsingConforms;
	
	        var createContextualFragment = htmlParsingConforms ?
	
	            // Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See
	            // discussion and base code for this implementation at issue 67.
	            // Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface
	            // Thanks to Aleks Williams.
	            function(fragmentStr) {
	                // "Let node the context object's start's node."
	                var node = this.startContainer;
	                var doc = getDocument(node);
	
	                // "If the context object's start's node is null, raise an INVALID_STATE_ERR
	                // exception and abort these steps."
	                if (!node) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // "Let element be as follows, depending on node's interface:"
	                // Document, Document Fragment: null
	                var el = null;
	
	                // "Element: node"
	                if (node.nodeType == 1) {
	                    el = node;
	
	                // "Text, Comment: node's parentElement"
	                } else if (isCharacterDataNode(node)) {
	                    el = dom.parentElement(node);
	                }
	
	                // "If either element is null or element's ownerDocument is an HTML document
	                // and element's local name is "html" and element's namespace is the HTML
	                // namespace"
	                if (el === null || (
	                    el.nodeName == "HTML" &&
	                    dom.isHtmlNamespace(getDocument(el).documentElement) &&
	                    dom.isHtmlNamespace(el)
	                )) {
	
	                // "let element be a new Element with "body" as its local name and the HTML
	                // namespace as its namespace.""
	                    el = doc.createElement("body");
	                } else {
	                    el = el.cloneNode(false);
	                }
	
	                // "If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm."
	                // "If the node's document is an XML document: Invoke the XML fragment parsing algorithm."
	                // "In either case, the algorithm must be invoked with fragment as the input
	                // and element as the context element."
	                el.innerHTML = fragmentStr;
	
	                // "If this raises an exception, then abort these steps. Otherwise, let new
	                // children be the nodes returned."
	
	                // "Let fragment be a new DocumentFragment."
	                // "Append all new children to fragment."
	                // "Return fragment."
	                return dom.fragmentFromNodeChildren(el);
	            } :
	
	            // In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that
	            // previous versions of Rangy used (with the exception of using a body element rather than a div)
	            function(fragmentStr) {
	                var doc = getRangeDocument(this);
	                var el = doc.createElement("body");
	                el.innerHTML = fragmentStr;
	
	                return dom.fragmentFromNodeChildren(el);
	            };
	
	        function splitRangeBoundaries(range, positionsToPreserve) {
	            assertRangeValid(range);
	
	            var sc = range.startContainer, so = range.startOffset, ec = range.endContainer, eo = range.endOffset;
	            var startEndSame = (sc === ec);
	
	            if (isCharacterDataNode(ec) && eo > 0 && eo < ec.length) {
	                splitDataNode(ec, eo, positionsToPreserve);
	            }
	
	            if (isCharacterDataNode(sc) && so > 0 && so < sc.length) {
	                sc = splitDataNode(sc, so, positionsToPreserve);
	                if (startEndSame) {
	                    eo -= so;
	                    ec = sc;
	                } else if (ec == sc.parentNode && eo >= getNodeIndex(sc)) {
	                    eo++;
	                }
	                so = 0;
	            }
	            range.setStartAndEnd(sc, so, ec, eo);
	        }
	
	        function rangeToHtml(range) {
	            assertRangeValid(range);
	            var container = range.commonAncestorContainer.parentNode.cloneNode(false);
	            container.appendChild( range.cloneContents() );
	            return container.innerHTML;
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var rangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
	            "commonAncestorContainer"];
	
	        var s2s = 0, s2e = 1, e2e = 2, e2s = 3;
	        var n_b = 0, n_a = 1, n_b_a = 2, n_i = 3;
	
	        util.extend(api.rangePrototype, {
	            compareBoundaryPoints: function(how, range) {
	                assertRangeValid(this);
	                assertSameDocumentOrFragment(this.startContainer, range.startContainer);
	
	                var nodeA, offsetA, nodeB, offsetB;
	                var prefixA = (how == e2s || how == s2s) ? "start" : "end";
	                var prefixB = (how == s2e || how == s2s) ? "start" : "end";
	                nodeA = this[prefixA + "Container"];
	                offsetA = this[prefixA + "Offset"];
	                nodeB = range[prefixB + "Container"];
	                offsetB = range[prefixB + "Offset"];
	                return comparePoints(nodeA, offsetA, nodeB, offsetB);
	            },
	
	            insertNode: function(node) {
	                assertRangeValid(this);
	                assertValidNodeType(node, insertableNodeTypes);
	                assertNodeNotReadOnly(this.startContainer);
	
	                if (isOrIsAncestorOf(node, this.startContainer)) {
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	
	                // No check for whether the container of the start of the Range is of a type that does not allow
	                // children of the type of node: the browser's DOM implementation should do this for us when we attempt
	                // to add the node
	
	                var firstNodeInserted = insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                this.setStartBefore(firstNodeInserted);
	            },
	
	            cloneContents: function() {
	                assertRangeValid(this);
	
	                var clone, frag;
	                if (this.collapsed) {
	                    return getRangeDocument(this).createDocumentFragment();
	                } else {
	                    if (this.startContainer === this.endContainer && isCharacterDataNode(this.startContainer)) {
	                        clone = this.startContainer.cloneNode(true);
	                        clone.data = clone.data.slice(this.startOffset, this.endOffset);
	                        frag = getRangeDocument(this).createDocumentFragment();
	                        frag.appendChild(clone);
	                        return frag;
	                    } else {
	                        var iterator = new RangeIterator(this, true);
	                        clone = cloneSubtree(iterator);
	                        iterator.detach();
	                    }
	                    return clone;
	                }
	            },
	
	            canSurroundContents: function() {
	                assertRangeValid(this);
	                assertNodeNotReadOnly(this.startContainer);
	                assertNodeNotReadOnly(this.endContainer);
	
	                // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                // no non-text nodes.
	                var iterator = new RangeIterator(this, true);
	                var boundariesInvalid = (iterator._first && (isNonTextPartiallySelected(iterator._first, this)) ||
	                        (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
	                iterator.detach();
	                return !boundariesInvalid;
	            },
	
	            surroundContents: function(node) {
	                assertValidNodeType(node, surroundNodeTypes);
	
	                if (!this.canSurroundContents()) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // Extract the contents
	                var content = this.extractContents();
	
	                // Clear the children of the node
	                if (node.hasChildNodes()) {
	                    while (node.lastChild) {
	                        node.removeChild(node.lastChild);
	                    }
	                }
	
	                // Insert the new node and add the extracted contents
	                insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                node.appendChild(content);
	
	                this.selectNode(node);
	            },
	
	            cloneRange: function() {
	                assertRangeValid(this);
	                var range = new Range(getRangeDocument(this));
	                var i = rangeProperties.length, prop;
	                while (i--) {
	                    prop = rangeProperties[i];
	                    range[prop] = this[prop];
	                }
	                return range;
	            },
	
	            toString: function() {
	                assertRangeValid(this);
	                var sc = this.startContainer;
	                if (sc === this.endContainer && isCharacterDataNode(sc)) {
	                    return (sc.nodeType == 3 || sc.nodeType == 4) ? sc.data.slice(this.startOffset, this.endOffset) : "";
	                } else {
	                    var textParts = [], iterator = new RangeIterator(this, true);
	                    iterateSubtree(iterator, function(node) {
	                        // Accept only text or CDATA nodes, not comments
	                        if (node.nodeType == 3 || node.nodeType == 4) {
	                            textParts.push(node.data);
	                        }
	                    });
	                    iterator.detach();
	                    return textParts.join("");
	                }
	            },
	
	            // The methods below are all non-standard. The following batch were introduced by Mozilla but have since
	            // been removed from Mozilla.
	
	            compareNode: function(node) {
	                assertRangeValid(this);
	
	                var parent = node.parentNode;
	                var nodeIndex = getNodeIndex(node);
	
	                if (!parent) {
	                    throw new DOMException("NOT_FOUND_ERR");
	                }
	
	                var startComparison = this.comparePoint(parent, nodeIndex),
	                    endComparison = this.comparePoint(parent, nodeIndex + 1);
	
	                if (startComparison < 0) { // Node starts before
	                    return (endComparison > 0) ? n_b_a : n_b;
	                } else {
	                    return (endComparison > 0) ? n_a : n_i;
	                }
	            },
	
	            comparePoint: function(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                if (comparePoints(node, offset, this.startContainer, this.startOffset) < 0) {
	                    return -1;
	                } else if (comparePoints(node, offset, this.endContainer, this.endOffset) > 0) {
	                    return 1;
	                }
	                return 0;
	            },
	
	            createContextualFragment: createContextualFragment,
	
	            toHtml: function() {
	                return rangeToHtml(this);
	            },
	
	            // touchingIsIntersecting determines whether this method considers a node that borders a range intersects
	            // with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)
	            intersectsNode: function(node, touchingIsIntersecting) {
	                assertRangeValid(this);
	                if (getRootContainer(node) != getRangeRoot(this)) {
	                    return false;
	                }
	
	                var parent = node.parentNode, offset = getNodeIndex(node);
	                if (!parent) {
	                    return true;
	                }
	
	                var startComparison = comparePoints(parent, offset, this.endContainer, this.endOffset),
	                    endComparison = comparePoints(parent, offset + 1, this.startContainer, this.startOffset);
	
	                return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	            },
	
	            isPointInRange: function(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                return (comparePoints(node, offset, this.startContainer, this.startOffset) >= 0) &&
	                       (comparePoints(node, offset, this.endContainer, this.endOffset) <= 0);
	            },
	
	            // The methods below are non-standard and invented by me.
	
	            // Sharing a boundary start-to-end or end-to-start does not count as intersection.
	            intersectsRange: function(range) {
	                return rangesIntersect(this, range, false);
	            },
	
	            // Sharing a boundary start-to-end or end-to-start does count as intersection.
	            intersectsOrTouchesRange: function(range) {
	                return rangesIntersect(this, range, true);
	            },
	
	            intersection: function(range) {
	                if (this.intersectsRange(range)) {
	                    var startComparison = comparePoints(this.startContainer, this.startOffset, range.startContainer, range.startOffset),
	                        endComparison = comparePoints(this.endContainer, this.endOffset, range.endContainer, range.endOffset);
	
	                    var intersectionRange = this.cloneRange();
	                    if (startComparison == -1) {
	                        intersectionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (endComparison == 1) {
	                        intersectionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return intersectionRange;
	                }
	                return null;
	            },
	
	            union: function(range) {
	                if (this.intersectsOrTouchesRange(range)) {
	                    var unionRange = this.cloneRange();
	                    if (comparePoints(range.startContainer, range.startOffset, this.startContainer, this.startOffset) == -1) {
	                        unionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (comparePoints(range.endContainer, range.endOffset, this.endContainer, this.endOffset) == 1) {
	                        unionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return unionRange;
	                } else {
	                    throw new DOMException("Ranges do not intersect");
	                }
	            },
	
	            containsNode: function(node, allowPartial) {
	                if (allowPartial) {
	                    return this.intersectsNode(node, false);
	                } else {
	                    return this.compareNode(node) == n_i;
	                }
	            },
	
	            containsNodeContents: function(node) {
	                return this.comparePoint(node, 0) >= 0 && this.comparePoint(node, getNodeLength(node)) <= 0;
	            },
	
	            containsRange: function(range) {
	                var intersection = this.intersection(range);
	                return intersection !== null && range.equals(intersection);
	            },
	
	            containsNodeText: function(node) {
	                var nodeRange = this.cloneRange();
	                nodeRange.selectNode(node);
	                var textNodes = nodeRange.getNodes([3]);
	                if (textNodes.length > 0) {
	                    nodeRange.setStart(textNodes[0], 0);
	                    var lastTextNode = textNodes.pop();
	                    nodeRange.setEnd(lastTextNode, lastTextNode.length);
	                    return this.containsRange(nodeRange);
	                } else {
	                    return this.containsNodeContents(node);
	                }
	            },
	
	            getNodes: function(nodeTypes, filter) {
	                assertRangeValid(this);
	                return getNodesInRange(this, nodeTypes, filter);
	            },
	
	            getDocument: function() {
	                return getRangeDocument(this);
	            },
	
	            collapseBefore: function(node) {
	                this.setEndBefore(node);
	                this.collapse(false);
	            },
	
	            collapseAfter: function(node) {
	                this.setStartAfter(node);
	                this.collapse(true);
	            },
	
	            getBookmark: function(containerNode) {
	                var doc = getRangeDocument(this);
	                var preSelectionRange = api.createRange(doc);
	                containerNode = containerNode || dom.getBody(doc);
	                preSelectionRange.selectNodeContents(containerNode);
	                var range = this.intersection(preSelectionRange);
	                var start = 0, end = 0;
	                if (range) {
	                    preSelectionRange.setEnd(range.startContainer, range.startOffset);
	                    start = preSelectionRange.toString().length;
	                    end = start + range.toString().length;
	                }
	
	                return {
	                    start: start,
	                    end: end,
	                    containerNode: containerNode
	                };
	            },
	
	            moveToBookmark: function(bookmark) {
	                var containerNode = bookmark.containerNode;
	                var charIndex = 0;
	                this.setStart(containerNode, 0);
	                this.collapse(true);
	                var nodeStack = [containerNode], node, foundStart = false, stop = false;
	                var nextCharIndex, i, childNodes;
	
	                while (!stop && (node = nodeStack.pop())) {
	                    if (node.nodeType == 3) {
	                        nextCharIndex = charIndex + node.length;
	                        if (!foundStart && bookmark.start >= charIndex && bookmark.start <= nextCharIndex) {
	                            this.setStart(node, bookmark.start - charIndex);
	                            foundStart = true;
	                        }
	                        if (foundStart && bookmark.end >= charIndex && bookmark.end <= nextCharIndex) {
	                            this.setEnd(node, bookmark.end - charIndex);
	                            stop = true;
	                        }
	                        charIndex = nextCharIndex;
	                    } else {
	                        childNodes = node.childNodes;
	                        i = childNodes.length;
	                        while (i--) {
	                            nodeStack.push(childNodes[i]);
	                        }
	                    }
	                }
	            },
	
	            getName: function() {
	                return "DomRange";
	            },
	
	            equals: function(range) {
	                return Range.rangesEqual(this, range);
	            },
	
	            isValid: function() {
	                return isRangeValid(this);
	            },
	
	            inspect: function() {
	                return inspect(this);
	            },
	
	            detach: function() {
	                // In DOM4, detach() is now a no-op.
	            }
	        });
	
	        function copyComparisonConstantsToObject(obj) {
	            obj.START_TO_START = s2s;
	            obj.START_TO_END = s2e;
	            obj.END_TO_END = e2e;
	            obj.END_TO_START = e2s;
	
	            obj.NODE_BEFORE = n_b;
	            obj.NODE_AFTER = n_a;
	            obj.NODE_BEFORE_AND_AFTER = n_b_a;
	            obj.NODE_INSIDE = n_i;
	        }
	
	        function copyComparisonConstants(constructor) {
	            copyComparisonConstantsToObject(constructor);
	            copyComparisonConstantsToObject(constructor.prototype);
	        }
	
	        function createRangeContentRemover(remover, boundaryUpdater) {
	            return function() {
	                assertRangeValid(this);
	
	                var sc = this.startContainer, so = this.startOffset, root = this.commonAncestorContainer;
	
	                var iterator = new RangeIterator(this, true);
	
	                // Work out where to position the range after content removal
	                var node, boundary;
	                if (sc !== root) {
	                    node = getClosestAncestorIn(sc, root, true);
	                    boundary = getBoundaryAfterNode(node);
	                    sc = boundary.node;
	                    so = boundary.offset;
	                }
	
	                // Check none of the range is read-only
	                iterateSubtree(iterator, assertNodeNotReadOnly);
	
	                iterator.reset();
	
	                // Remove the content
	                var returnValue = remover(iterator);
	                iterator.detach();
	
	                // Move to the new position
	                boundaryUpdater(this, sc, so, sc, so);
	
	                return returnValue;
	            };
	        }
	
	        function createPrototypeRange(constructor, boundaryUpdater) {
	            function createBeforeAfterNodeSetter(isBefore, isStart) {
	                return function(node) {
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	                    assertValidNodeType(getRootContainer(node), rootContainerNodeTypes);
	
	                    var boundary = (isBefore ? getBoundaryBeforeNode : getBoundaryAfterNode)(node);
	                    (isStart ? setRangeStart : setRangeEnd)(this, boundary.node, boundary.offset);
	                };
	            }
	
	            function setRangeStart(range, node, offset) {
	                var ec = range.endContainer, eo = range.endOffset;
	                if (node !== range.startContainer || offset !== range.startOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(ec) || comparePoints(node, offset, ec, eo) == 1) {
	                        ec = node;
	                        eo = offset;
	                    }
	                    boundaryUpdater(range, node, offset, ec, eo);
	                }
	            }
	
	            function setRangeEnd(range, node, offset) {
	                var sc = range.startContainer, so = range.startOffset;
	                if (node !== range.endContainer || offset !== range.endOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(sc) || comparePoints(node, offset, sc, so) == -1) {
	                        sc = node;
	                        so = offset;
	                    }
	                    boundaryUpdater(range, sc, so, node, offset);
	                }
	            }
	
	            // Set up inheritance
	            var F = function() {};
	            F.prototype = api.rangePrototype;
	            constructor.prototype = new F();
	
	            util.extend(constructor.prototype, {
	                setStart: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeStart(this, node, offset);
	                },
	
	                setEnd: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeEnd(this, node, offset);
	                },
	
	                /**
	                 * Convenience method to set a range's start and end boundaries. Overloaded as follows:
	                 * - Two parameters (node, offset) creates a collapsed range at that position
	                 * - Three parameters (node, startOffset, endOffset) creates a range contained with node starting at
	                 *   startOffset and ending at endOffset
	                 * - Four parameters (startNode, startOffset, endNode, endOffset) creates a range starting at startOffset in
	                 *   startNode and ending at endOffset in endNode
	                 */
	                setStartAndEnd: function() {
	                    var args = arguments;
	                    var sc = args[0], so = args[1], ec = sc, eo = so;
	
	                    switch (args.length) {
	                        case 3:
	                            eo = args[2];
	                            break;
	                        case 4:
	                            ec = args[2];
	                            eo = args[3];
	                            break;
	                    }
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                setBoundary: function(node, offset, isStart) {
	                    this["set" + (isStart ? "Start" : "End")](node, offset);
	                },
	
	                setStartBefore: createBeforeAfterNodeSetter(true, true),
	                setStartAfter: createBeforeAfterNodeSetter(false, true),
	                setEndBefore: createBeforeAfterNodeSetter(true, false),
	                setEndAfter: createBeforeAfterNodeSetter(false, false),
	
	                collapse: function(isStart) {
	                    assertRangeValid(this);
	                    if (isStart) {
	                        boundaryUpdater(this, this.startContainer, this.startOffset, this.startContainer, this.startOffset);
	                    } else {
	                        boundaryUpdater(this, this.endContainer, this.endOffset, this.endContainer, this.endOffset);
	                    }
	                },
	
	                selectNodeContents: function(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	
	                    boundaryUpdater(this, node, 0, node, getNodeLength(node));
	                },
	
	                selectNode: function(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, false);
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	
	                    var start = getBoundaryBeforeNode(node), end = getBoundaryAfterNode(node);
	                    boundaryUpdater(this, start.node, start.offset, end.node, end.offset);
	                },
	
	                extractContents: createRangeContentRemover(extractSubtree, boundaryUpdater),
	
	                deleteContents: createRangeContentRemover(deleteSubtree, boundaryUpdater),
	
	                canSurroundContents: function() {
	                    assertRangeValid(this);
	                    assertNodeNotReadOnly(this.startContainer);
	                    assertNodeNotReadOnly(this.endContainer);
	
	                    // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                    // no non-text nodes.
	                    var iterator = new RangeIterator(this, true);
	                    var boundariesInvalid = (iterator._first && isNonTextPartiallySelected(iterator._first, this) ||
	                            (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
	                    iterator.detach();
	                    return !boundariesInvalid;
	                },
	
	                splitBoundaries: function() {
	                    splitRangeBoundaries(this);
	                },
	
	                splitBoundariesPreservingPositions: function(positionsToPreserve) {
	                    splitRangeBoundaries(this, positionsToPreserve);
	                },
	
	                normalizeBoundaries: function() {
	                    assertRangeValid(this);
	
	                    var sc = this.startContainer, so = this.startOffset, ec = this.endContainer, eo = this.endOffset;
	
	                    var mergeForward = function(node) {
	                        var sibling = node.nextSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            ec = node;
	                            eo = node.length;
	                            node.appendData(sibling.data);
	                            removeNode(sibling);
	                        }
	                    };
	
	                    var mergeBackward = function(node) {
	                        var sibling = node.previousSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            sc = node;
	                            var nodeLength = node.length;
	                            so = sibling.length;
	                            node.insertData(0, sibling.data);
	                            removeNode(sibling);
	                            if (sc == ec) {
	                                eo += so;
	                                ec = sc;
	                            } else if (ec == node.parentNode) {
	                                var nodeIndex = getNodeIndex(node);
	                                if (eo == nodeIndex) {
	                                    ec = node;
	                                    eo = nodeLength;
	                                } else if (eo > nodeIndex) {
	                                    eo--;
	                                }
	                            }
	                        }
	                    };
	
	                    var normalizeStart = true;
	                    var sibling;
	
	                    if (isCharacterDataNode(ec)) {
	                        if (eo == ec.length) {
	                            mergeForward(ec);
	                        } else if (eo == 0) {
	                            sibling = ec.previousSibling;
	                            if (sibling && sibling.nodeType == ec.nodeType) {
	                                eo = sibling.length;
	                                if (sc == ec) {
	                                    normalizeStart = false;
	                                }
	                                sibling.appendData(ec.data);
	                                removeNode(ec);
	                                ec = sibling;
	                            }
	                        }
	                    } else {
	                        if (eo > 0) {
	                            var endNode = ec.childNodes[eo - 1];
	                            if (endNode && isCharacterDataNode(endNode)) {
	                                mergeForward(endNode);
	                            }
	                        }
	                        normalizeStart = !this.collapsed;
	                    }
	
	                    if (normalizeStart) {
	                        if (isCharacterDataNode(sc)) {
	                            if (so == 0) {
	                                mergeBackward(sc);
	                            } else if (so == sc.length) {
	                                sibling = sc.nextSibling;
	                                if (sibling && sibling.nodeType == sc.nodeType) {
	                                    if (ec == sibling) {
	                                        ec = sc;
	                                        eo += sc.length;
	                                    }
	                                    sc.appendData(sibling.data);
	                                    removeNode(sibling);
	                                }
	                            }
	                        } else {
	                            if (so < sc.childNodes.length) {
	                                var startNode = sc.childNodes[so];
	                                if (startNode && isCharacterDataNode(startNode)) {
	                                    mergeBackward(startNode);
	                                }
	                            }
	                        }
	                    } else {
	                        sc = ec;
	                        so = eo;
	                    }
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                collapseToPoint: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	                    this.setStartAndEnd(node, offset);
	                }
	            });
	
	            copyComparisonConstants(constructor);
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Updates commonAncestorContainer and collapsed after boundary change
	        function updateCollapsedAndCommonAncestor(range) {
	            range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
	            range.commonAncestorContainer = range.collapsed ?
	                range.startContainer : dom.getCommonAncestor(range.startContainer, range.endContainer);
	        }
	
	        function updateBoundaries(range, startContainer, startOffset, endContainer, endOffset) {
	            range.startContainer = startContainer;
	            range.startOffset = startOffset;
	            range.endContainer = endContainer;
	            range.endOffset = endOffset;
	            range.document = dom.getDocument(startContainer);
	
	            updateCollapsedAndCommonAncestor(range);
	        }
	
	        function Range(doc) {
	            this.startContainer = doc;
	            this.startOffset = 0;
	            this.endContainer = doc;
	            this.endOffset = 0;
	            this.document = doc;
	            updateCollapsedAndCommonAncestor(this);
	        }
	
	        createPrototypeRange(Range, updateBoundaries);
	
	        util.extend(Range, {
	            rangeProperties: rangeProperties,
	            RangeIterator: RangeIterator,
	            copyComparisonConstants: copyComparisonConstants,
	            createPrototypeRange: createPrototypeRange,
	            inspect: inspect,
	            toHtml: rangeToHtml,
	            getRangeDocument: getRangeDocument,
	            rangesEqual: function(r1, r2) {
	                return r1.startContainer === r2.startContainer &&
	                    r1.startOffset === r2.startOffset &&
	                    r1.endContainer === r2.endContainer &&
	                    r1.endOffset === r2.endOffset;
	            }
	        });
	
	        api.DomRange = Range;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wrappers for the browser's native DOM Range and/or TextRange implementation
	    api.createCoreModule("WrappedRange", ["DomRange"], function(api, module) {
	        var WrappedRange, WrappedTextRange;
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DomRange = api.DomRange;
	        var getBody = dom.getBody;
	        var getContentDocument = dom.getContentDocument;
	        var isCharacterDataNode = dom.isCharacterDataNode;
	
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        if (api.features.implementsDomRange) {
	            // This is a wrapper around the browser's native DOM Range. It has two aims:
	            // - Provide workarounds for specific browser bugs
	            // - provide convenient extensions, which are inherited from Rangy's DomRange
	
	            (function() {
	                var rangeProto;
	                var rangeProperties = DomRange.rangeProperties;
	
	                function updateRangeProperties(range) {
	                    var i = rangeProperties.length, prop;
	                    while (i--) {
	                        prop = rangeProperties[i];
	                        range[prop] = range.nativeRange[prop];
	                    }
	                    // Fix for broken collapsed property in IE 9.
	                    range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
	                }
	
	                function updateNativeRange(range, startContainer, startOffset, endContainer, endOffset) {
	                    var startMoved = (range.startContainer !== startContainer || range.startOffset != startOffset);
	                    var endMoved = (range.endContainer !== endContainer || range.endOffset != endOffset);
	                    var nativeRangeDifferent = !range.equals(range.nativeRange);
	
	                    // Always set both boundaries for the benefit of IE9 (see issue 35)
	                    if (startMoved || endMoved || nativeRangeDifferent) {
	                        range.setEnd(endContainer, endOffset);
	                        range.setStart(startContainer, startOffset);
	                    }
	                }
	
	                var createBeforeAfterNodeSetter;
	
	                WrappedRange = function(range) {
	                    if (!range) {
	                        throw module.createError("WrappedRange: Range must be specified");
	                    }
	                    this.nativeRange = range;
	                    updateRangeProperties(this);
	                };
	
	                DomRange.createPrototypeRange(WrappedRange, updateNativeRange);
	
	                rangeProto = WrappedRange.prototype;
	
	                rangeProto.selectNode = function(node) {
	                    this.nativeRange.selectNode(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneContents = function() {
	                    return this.nativeRange.cloneContents();
	                };
	
	                // Due to a long-standing Firefox bug that I have not been able to find a reliable way to detect,
	                // insertNode() is never delegated to the native range.
	
	                rangeProto.surroundContents = function(node) {
	                    this.nativeRange.surroundContents(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.collapse = function(isStart) {
	                    this.nativeRange.collapse(isStart);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneRange = function() {
	                    return new WrappedRange(this.nativeRange.cloneRange());
	                };
	
	                rangeProto.refresh = function() {
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.toString = function() {
	                    return this.nativeRange.toString();
	                };
	
	                // Create test range and node for feature detection
	
	                var testTextNode = document.createTextNode("test");
	                getBody(document).appendChild(testTextNode);
	                var range = document.createRange();
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and
	                // correct for it
	
	                range.setStart(testTextNode, 0);
	                range.setEnd(testTextNode, 0);
	
	                try {
	                    range.setStart(testTextNode, 1);
	
	                    rangeProto.setStart = function(node, offset) {
	                        this.nativeRange.setStart(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function(node, offset) {
	                        this.nativeRange.setEnd(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function(name) {
	                        return function(node) {
	                            this.nativeRange[name](node);
	                            updateRangeProperties(this);
	                        };
	                    };
	
	                } catch(ex) {
	
	                    rangeProto.setStart = function(node, offset) {
	                        try {
	                            this.nativeRange.setStart(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setEnd(node, offset);
	                            this.nativeRange.setStart(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function(node, offset) {
	                        try {
	                            this.nativeRange.setEnd(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setStart(node, offset);
	                            this.nativeRange.setEnd(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function(name, oppositeName) {
	                        return function(node) {
	                            try {
	                                this.nativeRange[name](node);
	                            } catch (ex) {
	                                this.nativeRange[oppositeName](node);
	                                this.nativeRange[name](node);
	                            }
	                            updateRangeProperties(this);
	                        };
	                    };
	                }
	
	                rangeProto.setStartBefore = createBeforeAfterNodeSetter("setStartBefore", "setEndBefore");
	                rangeProto.setStartAfter = createBeforeAfterNodeSetter("setStartAfter", "setEndAfter");
	                rangeProto.setEndBefore = createBeforeAfterNodeSetter("setEndBefore", "setStartBefore");
	                rangeProto.setEndAfter = createBeforeAfterNodeSetter("setEndAfter", "setStartAfter");
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Always use DOM4-compliant selectNodeContents implementation: it's simpler and less code than testing
	                // whether the native implementation can be trusted
	                rangeProto.selectNodeContents = function(node) {
	                    this.setStartAndEnd(node, 0, dom.getNodeLength(node));
	                };
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for and correct WebKit bug that has the behaviour of compareBoundaryPoints round the wrong way for
	                // constants START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738
	
	                range.selectNodeContents(testTextNode);
	                range.setEnd(testTextNode, 3);
	
	                var range2 = document.createRange();
	                range2.selectNodeContents(testTextNode);
	                range2.setEnd(testTextNode, 4);
	                range2.setStart(testTextNode, 2);
	
	                if (range.compareBoundaryPoints(range.START_TO_END, range2) == -1 &&
	                        range.compareBoundaryPoints(range.END_TO_START, range2) == 1) {
	                    // This is the wrong way round, so correct for it
	
	                    rangeProto.compareBoundaryPoints = function(type, range) {
	                        range = range.nativeRange || range;
	                        if (type == range.START_TO_END) {
	                            type = range.END_TO_START;
	                        } else if (type == range.END_TO_START) {
	                            type = range.START_TO_END;
	                        }
	                        return this.nativeRange.compareBoundaryPoints(type, range);
	                    };
	                } else {
	                    rangeProto.compareBoundaryPoints = function(type, range) {
	                        return this.nativeRange.compareBoundaryPoints(type, range.nativeRange || range);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for IE deleteContents() and extractContents() bug and correct it. See issue 107.
	
	                var el = document.createElement("div");
	                el.innerHTML = "123";
	                var textNode = el.firstChild;
	                var body = getBody(document);
	                body.appendChild(el);
	
	                range.setStart(textNode, 1);
	                range.setEnd(textNode, 2);
	                range.deleteContents();
	
	                if (textNode.data == "13") {
	                    // Behaviour is correct per DOM4 Range so wrap the browser's implementation of deleteContents() and
	                    // extractContents()
	                    rangeProto.deleteContents = function() {
	                        this.nativeRange.deleteContents();
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.extractContents = function() {
	                        var frag = this.nativeRange.extractContents();
	                        updateRangeProperties(this);
	                        return frag;
	                    };
	                } else {
	                }
	
	                body.removeChild(el);
	                body = null;
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for existence of createContextualFragment and delegate to it if it exists
	                if (util.isHostMethod(range, "createContextualFragment")) {
	                    rangeProto.createContextualFragment = function(fragmentStr) {
	                        return this.nativeRange.createContextualFragment(fragmentStr);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Clean up
	                getBody(document).removeChild(testTextNode);
	
	                rangeProto.getName = function() {
	                    return "WrappedRange";
	                };
	
	                api.WrappedRange = WrappedRange;
	
	                api.createNativeRange = function(doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return doc.createRange();
	                };
	            })();
	        }
	
	        if (api.features.implementsTextRange) {
	            /*
	            This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()
	            method. For example, in the following (where pipes denote the selection boundaries):
	
	            <ul id="ul"><li id="a">| a </li><li id="b"> b |</li></ul>
	
	            var range = document.selection.createRange();
	            alert(range.parentElement().id); // Should alert "ul" but alerts "b"
	
	            This method returns the common ancestor node of the following:
	            - the parentElement() of the textRange
	            - the parentElement() of the textRange after calling collapse(true)
	            - the parentElement() of the textRange after calling collapse(false)
	            */
	            var getTextRangeContainerElement = function(textRange) {
	                var parentEl = textRange.parentElement();
	                var range = textRange.duplicate();
	                range.collapse(true);
	                var startEl = range.parentElement();
	                range = textRange.duplicate();
	                range.collapse(false);
	                var endEl = range.parentElement();
	                var startEndContainer = (startEl == endEl) ? startEl : dom.getCommonAncestor(startEl, endEl);
	
	                return startEndContainer == parentEl ? startEndContainer : dom.getCommonAncestor(parentEl, startEndContainer);
	            };
	
	            var textRangeIsCollapsed = function(textRange) {
	                return textRange.compareEndPoints("StartToEnd", textRange) == 0;
	            };
	
	            // Gets the boundary of a TextRange expressed as a node and an offset within that node. This function started
	            // out as an improved version of code found in Tim Cameron Ryan's IERange (http://code.google.com/p/ierange/)
	            // but has grown, fixing problems with line breaks in preformatted text, adding workaround for IE TextRange
	            // bugs, handling for inputs and images, plus optimizations.
	            var getTextRangeBoundaryPosition = function(textRange, wholeRangeContainerElement, isStart, isCollapsed, startInfo) {
	                var workingRange = textRange.duplicate();
	                workingRange.collapse(isStart);
	                var containerElement = workingRange.parentElement();
	
	                // Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so
	                // check for that
	                if (!dom.isOrIsAncestorOf(wholeRangeContainerElement, containerElement)) {
	                    containerElement = wholeRangeContainerElement;
	                }
	
	
	                // Deal with nodes that cannot "contain rich HTML markup". In practice, this means form inputs, images and
	                // similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx
	                if (!containerElement.canHaveHTML) {
	                    var pos = new DomPosition(containerElement.parentNode, dom.getNodeIndex(containerElement));
	                    return {
	                        boundaryPosition: pos,
	                        nodeInfo: {
	                            nodeIndex: pos.offset,
	                            containerElement: pos.node
	                        }
	                    };
	                }
	
	                var workingNode = dom.getDocument(containerElement).createElement("span");
	
	                // Workaround for HTML5 Shiv's insane violation of document.createElement(). See Rangy issue 104 and HTML5
	                // Shiv issue 64: https://github.com/aFarkas/html5shiv/issues/64
	                if (workingNode.parentNode) {
	                    dom.removeNode(workingNode);
	                }
	
	                var comparison, workingComparisonType = isStart ? "StartToStart" : "StartToEnd";
	                var previousNode, nextNode, boundaryPosition, boundaryNode;
	                var start = (startInfo && startInfo.containerElement == containerElement) ? startInfo.nodeIndex : 0;
	                var childNodeCount = containerElement.childNodes.length;
	                var end = childNodeCount;
	
	                // Check end first. Code within the loop assumes that the endth child node of the container is definitely
	                // after the range boundary.
	                var nodeIndex = end;
	
	                while (true) {
	                    if (nodeIndex == childNodeCount) {
	                        containerElement.appendChild(workingNode);
	                    } else {
	                        containerElement.insertBefore(workingNode, containerElement.childNodes[nodeIndex]);
	                    }
	                    workingRange.moveToElementText(workingNode);
	                    comparison = workingRange.compareEndPoints(workingComparisonType, textRange);
	                    if (comparison == 0 || start == end) {
	                        break;
	                    } else if (comparison == -1) {
	                        if (end == start + 1) {
	                            // We know the endth child node is after the range boundary, so we must be done.
	                            break;
	                        } else {
	                            start = nodeIndex;
	                        }
	                    } else {
	                        end = (end == start + 1) ? start : nodeIndex;
	                    }
	                    nodeIndex = Math.floor((start + end) / 2);
	                    containerElement.removeChild(workingNode);
	                }
	
	
	                // We've now reached or gone past the boundary of the text range we're interested in
	                // so have identified the node we want
	                boundaryNode = workingNode.nextSibling;
	
	                if (comparison == -1 && boundaryNode && isCharacterDataNode(boundaryNode)) {
	                    // This is a character data node (text, comment, cdata). The working range is collapsed at the start of
	                    // the node containing the text range's boundary, so we move the end of the working range to the
	                    // boundary point and measure the length of its text to get the boundary's offset within the node.
	                    workingRange.setEndPoint(isStart ? "EndToStart" : "EndToEnd", textRange);
	
	                    var offset;
	
	                    if (/[\r\n]/.test(boundaryNode.data)) {
	                        /*
	                        For the particular case of a boundary within a text node containing rendered line breaks (within a
	                        <pre> element, for example), we need a slightly complicated approach to get the boundary's offset in
	                        IE. The facts:
	
	                        - Each line break is represented as \r in the text node's data/nodeValue properties
	                        - Each line break is represented as \r\n in the TextRange's 'text' property
	                        - The 'text' property of the TextRange does not contain trailing line breaks
	
	                        To get round the problem presented by the final fact above, we can use the fact that TextRange's
	                        moveStart() and moveEnd() methods return the actual number of characters moved, which is not
	                        necessarily the same as the number of characters it was instructed to move. The simplest approach is
	                        to use this to store the characters moved when moving both the start and end of the range to the
	                        start of the document body and subtracting the start offset from the end offset (the
	                        "move-negative-gazillion" method). However, this is extremely slow when the document is large and
	                        the range is near the end of it. Clearly doing the mirror image (i.e. moving the range boundaries to
	                        the end of the document) has the same problem.
	
	                        Another approach that works is to use moveStart() to move the start boundary of the range up to the
	                        end boundary one character at a time and incrementing a counter with the value returned by the
	                        moveStart() call. However, the check for whether the start boundary has reached the end boundary is
	                        expensive, so this method is slow (although unlike "move-negative-gazillion" is largely unaffected
	                        by the location of the range within the document).
	
	                        The approach used below is a hybrid of the two methods above. It uses the fact that a string
	                        containing the TextRange's 'text' property with each \r\n converted to a single \r character cannot
	                        be longer than the text of the TextRange, so the start of the range is moved that length initially
	                        and then a character at a time to make up for any trailing line breaks not contained in the 'text'
	                        property. This has good performance in most situations compared to the previous two methods.
	                        */
	                        var tempRange = workingRange.duplicate();
	                        var rangeLength = tempRange.text.replace(/\r\n/g, "\r").length;
	
	                        offset = tempRange.moveStart("character", rangeLength);
	                        while ( (comparison = tempRange.compareEndPoints("StartToEnd", tempRange)) == -1) {
	                            offset++;
	                            tempRange.moveStart("character", 1);
	                        }
	                    } else {
	                        offset = workingRange.text.length;
	                    }
	                    boundaryPosition = new DomPosition(boundaryNode, offset);
	                } else {
	
	                    // If the boundary immediately follows a character data node and this is the end boundary, we should favour
	                    // a position within that, and likewise for a start boundary preceding a character data node
	                    previousNode = (isCollapsed || !isStart) && workingNode.previousSibling;
	                    nextNode = (isCollapsed || isStart) && workingNode.nextSibling;
	                    if (nextNode && isCharacterDataNode(nextNode)) {
	                        boundaryPosition = new DomPosition(nextNode, 0);
	                    } else if (previousNode && isCharacterDataNode(previousNode)) {
	                        boundaryPosition = new DomPosition(previousNode, previousNode.data.length);
	                    } else {
	                        boundaryPosition = new DomPosition(containerElement, dom.getNodeIndex(workingNode));
	                    }
	                }
	
	                // Clean up
	                dom.removeNode(workingNode);
	
	                return {
	                    boundaryPosition: boundaryPosition,
	                    nodeInfo: {
	                        nodeIndex: nodeIndex,
	                        containerElement: containerElement
	                    }
	                };
	            };
	
	            // Returns a TextRange representing the boundary of a TextRange expressed as a node and an offset within that
	            // node. This function started out as an optimized version of code found in Tim Cameron Ryan's IERange
	            // (http://code.google.com/p/ierange/)
	            var createBoundaryTextRange = function(boundaryPosition, isStart) {
	                var boundaryNode, boundaryParent, boundaryOffset = boundaryPosition.offset;
	                var doc = dom.getDocument(boundaryPosition.node);
	                var workingNode, childNodes, workingRange = getBody(doc).createTextRange();
	                var nodeIsDataNode = isCharacterDataNode(boundaryPosition.node);
	
	                if (nodeIsDataNode) {
	                    boundaryNode = boundaryPosition.node;
	                    boundaryParent = boundaryNode.parentNode;
	                } else {
	                    childNodes = boundaryPosition.node.childNodes;
	                    boundaryNode = (boundaryOffset < childNodes.length) ? childNodes[boundaryOffset] : null;
	                    boundaryParent = boundaryPosition.node;
	                }
	
	                // Position the range immediately before the node containing the boundary
	                workingNode = doc.createElement("span");
	
	                // Making the working element non-empty element persuades IE to consider the TextRange boundary to be within
	                // the element rather than immediately before or after it
	                workingNode.innerHTML = "&#feff;";
	
	                // insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report
	                // for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12
	                if (boundaryNode) {
	                    boundaryParent.insertBefore(workingNode, boundaryNode);
	                } else {
	                    boundaryParent.appendChild(workingNode);
	                }
	
	                workingRange.moveToElementText(workingNode);
	                workingRange.collapse(!isStart);
	
	                // Clean up
	                boundaryParent.removeChild(workingNode);
	
	                // Move the working range to the text offset, if required
	                if (nodeIsDataNode) {
	                    workingRange[isStart ? "moveStart" : "moveEnd"]("character", boundaryOffset);
	                }
	
	                return workingRange;
	            };
	
	            /*------------------------------------------------------------------------------------------------------------*/
	
	            // This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a
	            // prototype
	
	            WrappedTextRange = function(textRange) {
	                this.textRange = textRange;
	                this.refresh();
	            };
	
	            WrappedTextRange.prototype = new DomRange(document);
	
	            WrappedTextRange.prototype.refresh = function() {
	                var start, end, startBoundary;
	
	                // TextRange's parentElement() method cannot be trusted. getTextRangeContainerElement() works around that.
	                var rangeContainerElement = getTextRangeContainerElement(this.textRange);
	
	                if (textRangeIsCollapsed(this.textRange)) {
	                    end = start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true,
	                        true).boundaryPosition;
	                } else {
	                    startBoundary = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, false);
	                    start = startBoundary.boundaryPosition;
	
	                    // An optimization used here is that if the start and end boundaries have the same parent element, the
	                    // search scope for the end boundary can be limited to exclude the portion of the element that precedes
	                    // the start boundary
	                    end = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, false, false,
	                        startBoundary.nodeInfo).boundaryPosition;
	                }
	
	                this.setStart(start.node, start.offset);
	                this.setEnd(end.node, end.offset);
	            };
	
	            WrappedTextRange.prototype.getName = function() {
	                return "WrappedTextRange";
	            };
	
	            DomRange.copyComparisonConstants(WrappedTextRange);
	
	            var rangeToTextRange = function(range) {
	                if (range.collapsed) {
	                    return createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                } else {
	                    var startRange = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                    var endRange = createBoundaryTextRange(new DomPosition(range.endContainer, range.endOffset), false);
	                    var textRange = getBody( DomRange.getRangeDocument(range) ).createTextRange();
	                    textRange.setEndPoint("StartToStart", startRange);
	                    textRange.setEndPoint("EndToEnd", endRange);
	                    return textRange;
	                }
	            };
	
	            WrappedTextRange.rangeToTextRange = rangeToTextRange;
	
	            WrappedTextRange.prototype.toTextRange = function() {
	                return rangeToTextRange(this);
	            };
	
	            api.WrappedTextRange = WrappedTextRange;
	
	            // IE 9 and above have both implementations and Rangy makes both available. The next few lines sets which
	            // implementation to use by default.
	            if (!api.features.implementsDomRange || api.config.preferTextRange) {
	                // Add WrappedTextRange as the Range property of the global object to allow expression like Range.END_TO_END to work
	                var globalObj = (function(f) { return f("return this;")(); })(Function);
	                if (typeof globalObj.Range == "undefined") {
	                    globalObj.Range = WrappedTextRange;
	                }
	
	                api.createNativeRange = function(doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return getBody(doc).createTextRange();
	                };
	
	                api.WrappedRange = WrappedTextRange;
	            }
	        }
	
	        api.createRange = function(doc) {
	            doc = getContentDocument(doc, module, "createRange");
	            return new api.WrappedRange(api.createNativeRange(doc));
	        };
	
	        api.createRangyRange = function(doc) {
	            doc = getContentDocument(doc, module, "createRangyRange");
	            return new DomRange(doc);
	        };
	
	        util.createAliasForDeprecatedMethod(api, "createIframeRange", "createRange");
	        util.createAliasForDeprecatedMethod(api, "createIframeRangyRange", "createRangyRange");
	
	        api.addShimListener(function(win) {
	            var doc = win.document;
	            if (typeof doc.createRange == "undefined") {
	                doc.createRange = function() {
	                    return api.createRange(doc);
	                };
	            }
	            doc = win = null;
	        });
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // This module creates a selection object wrapper that conforms as closely as possible to the Selection specification
	    // in the HTML Editing spec (http://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#selections)
	    api.createCoreModule("WrappedSelection", ["DomRange", "WrappedRange"], function(api, module) {
	        api.config.checkSelectionRanges = true;
	
	        var BOOLEAN = "boolean";
	        var NUMBER = "number";
	        var dom = api.dom;
	        var util = api.util;
	        var isHostMethod = util.isHostMethod;
	        var DomRange = api.DomRange;
	        var WrappedRange = api.WrappedRange;
	        var DOMException = api.DOMException;
	        var DomPosition = dom.DomPosition;
	        var getNativeSelection;
	        var selectionIsCollapsed;
	        var features = api.features;
	        var CONTROL = "Control";
	        var getDocument = dom.getDocument;
	        var getBody = dom.getBody;
	        var rangesEqual = DomRange.rangesEqual;
	
	
	        // Utility function to support direction parameters in the API that may be a string ("backward", "backwards",
	        // "forward" or "forwards") or a Boolean (true for backwards).
	        function isDirectionBackward(dir) {
	            return (typeof dir == "string") ? /^backward(s)?$/i.test(dir) : !!dir;
	        }
	
	        function getWindow(win, methodName) {
	            if (!win) {
	                return window;
	            } else if (dom.isWindow(win)) {
	                return win;
	            } else if (win instanceof WrappedSelection) {
	                return win.win;
	            } else {
	                var doc = dom.getContentDocument(win, module, methodName);
	                return dom.getWindow(doc);
	            }
	        }
	
	        function getWinSelection(winParam) {
	            return getWindow(winParam, "getWinSelection").getSelection();
	        }
	
	        function getDocSelection(winParam) {
	            return getWindow(winParam, "getDocSelection").document.selection;
	        }
	
	        function winSelectionIsBackward(sel) {
	            var backward = false;
	            if (sel.anchorNode) {
	                backward = (dom.comparePoints(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset) == 1);
	            }
	            return backward;
	        }
	
	        // Test for the Range/TextRange and Selection features required
	        // Test for ability to retrieve selection
	        var implementsWinGetSelection = isHostMethod(window, "getSelection"),
	            implementsDocSelection = util.isHostObject(document, "selection");
	
	        features.implementsWinGetSelection = implementsWinGetSelection;
	        features.implementsDocSelection = implementsDocSelection;
	
	        var useDocumentSelection = implementsDocSelection && (!implementsWinGetSelection || api.config.preferTextRange);
	
	        if (useDocumentSelection) {
	            getNativeSelection = getDocSelection;
	            api.isSelectionValid = function(winParam) {
	                var doc = getWindow(winParam, "isSelectionValid").document, nativeSel = doc.selection;
	
	                // Check whether the selection TextRange is actually contained within the correct document
	                return (nativeSel.type != "None" || getDocument(nativeSel.createRange().parentElement()) == doc);
	            };
	        } else if (implementsWinGetSelection) {
	            getNativeSelection = getWinSelection;
	            api.isSelectionValid = function() {
	                return true;
	            };
	        } else {
	            module.fail("Neither document.selection or window.getSelection() detected.");
	            return false;
	        }
	
	        api.getNativeSelection = getNativeSelection;
	
	        var testSelection = getNativeSelection();
	
	        // In Firefox, the selection is null in an iframe with display: none. See issue #138.
	        if (!testSelection) {
	            module.fail("Native selection was null (possibly issue 138?)");
	            return false;
	        }
	
	        var testRange = api.createNativeRange(document);
	        var body = getBody(document);
	
	        // Obtaining a range from a selection
	        var selectionHasAnchorAndFocus = util.areHostProperties(testSelection,
	            ["anchorNode", "focusNode", "anchorOffset", "focusOffset"]);
	
	        features.selectionHasAnchorAndFocus = selectionHasAnchorAndFocus;
	
	        // Test for existence of native selection extend() method
	        var selectionHasExtend = isHostMethod(testSelection, "extend");
	        features.selectionHasExtend = selectionHasExtend;
	
	        // Test if rangeCount exists
	        var selectionHasRangeCount = (typeof testSelection.rangeCount == NUMBER);
	        features.selectionHasRangeCount = selectionHasRangeCount;
	
	        var selectionSupportsMultipleRanges = false;
	        var collapsedNonEditableSelectionsSupported = true;
	
	        var addRangeBackwardToNative = selectionHasExtend ?
	            function(nativeSelection, range) {
	                var doc = DomRange.getRangeDocument(range);
	                var endRange = api.createRange(doc);
	                endRange.collapseToPoint(range.endContainer, range.endOffset);
	                nativeSelection.addRange(getNativeRange(endRange));
	                nativeSelection.extend(range.startContainer, range.startOffset);
	            } : null;
	
	        if (util.areHostMethods(testSelection, ["addRange", "getRangeAt", "removeAllRanges"]) &&
	                typeof testSelection.rangeCount == NUMBER && features.implementsDomRange) {
	
	            (function() {
	                // Previously an iframe was used but this caused problems in some circumstances in IE, so tests are
	                // performed on the current document's selection. See issue 109.
	
	                // Note also that if a selection previously existed, it is wiped and later restored by these tests. This
	                // will result in the selection direction begin reversed if the original selection was backwards and the
	                // browser does not support setting backwards selections (Internet Explorer, I'm looking at you).
	                var sel = window.getSelection();
	                if (sel) {
	                    // Store the current selection
	                    var originalSelectionRangeCount = sel.rangeCount;
	                    var selectionHasMultipleRanges = (originalSelectionRangeCount > 1);
	                    var originalSelectionRanges = [];
	                    var originalSelectionBackward = winSelectionIsBackward(sel);
	                    for (var i = 0; i < originalSelectionRangeCount; ++i) {
	                        originalSelectionRanges[i] = sel.getRangeAt(i);
	                    }
	
	                    // Create some test elements
	                    var testEl = dom.createTestElement(document, "", false);
	                    var textNode = testEl.appendChild( document.createTextNode("\u00a0\u00a0\u00a0") );
	
	                    // Test whether the native selection will allow a collapsed selection within a non-editable element
	                    var r1 = document.createRange();
	
	                    r1.setStart(textNode, 1);
	                    r1.collapse(true);
	                    sel.removeAllRanges();
	                    sel.addRange(r1);
	                    collapsedNonEditableSelectionsSupported = (sel.rangeCount == 1);
	                    sel.removeAllRanges();
	
	                    // Test whether the native selection is capable of supporting multiple ranges.
	                    if (!selectionHasMultipleRanges) {
	                        // Doing the original feature test here in Chrome 36 (and presumably later versions) prints a
	                        // console error of "Discontiguous selection is not supported." that cannot be suppressed. There's
	                        // nothing we can do about this while retaining the feature test so we have to resort to a browser
	                        // sniff. I'm not happy about it. See
	                        // https://code.google.com/p/chromium/issues/detail?id=399791
	                        var chromeMatch = window.navigator.appVersion.match(/Chrome\/(.*?) /);
	                        if (chromeMatch && parseInt(chromeMatch[1]) >= 36) {
	                            selectionSupportsMultipleRanges = false;
	                        } else {
	                            var r2 = r1.cloneRange();
	                            r1.setStart(textNode, 0);
	                            r2.setEnd(textNode, 3);
	                            r2.setStart(textNode, 2);
	                            sel.addRange(r1);
	                            sel.addRange(r2);
	                            selectionSupportsMultipleRanges = (sel.rangeCount == 2);
	                        }
	                    }
	
	                    // Clean up
	                    dom.removeNode(testEl);
	                    sel.removeAllRanges();
	
	                    for (i = 0; i < originalSelectionRangeCount; ++i) {
	                        if (i == 0 && originalSelectionBackward) {
	                            if (addRangeBackwardToNative) {
	                                addRangeBackwardToNative(sel, originalSelectionRanges[i]);
	                            } else {
	                                api.warn("Rangy initialization: original selection was backwards but selection has been restored forwards because the browser does not support Selection.extend");
	                                sel.addRange(originalSelectionRanges[i]);
	                            }
	                        } else {
	                            sel.addRange(originalSelectionRanges[i]);
	                        }
	                    }
	                }
	            })();
	        }
	
	        features.selectionSupportsMultipleRanges = selectionSupportsMultipleRanges;
	        features.collapsedNonEditableSelectionsSupported = collapsedNonEditableSelectionsSupported;
	
	        // ControlRanges
	        var implementsControlRange = false, testControlRange;
	
	        if (body && isHostMethod(body, "createControlRange")) {
	            testControlRange = body.createControlRange();
	            if (util.areHostProperties(testControlRange, ["item", "add"])) {
	                implementsControlRange = true;
	            }
	        }
	        features.implementsControlRange = implementsControlRange;
	
	        // Selection collapsedness
	        if (selectionHasAnchorAndFocus) {
	            selectionIsCollapsed = function(sel) {
	                return sel.anchorNode === sel.focusNode && sel.anchorOffset === sel.focusOffset;
	            };
	        } else {
	            selectionIsCollapsed = function(sel) {
	                return sel.rangeCount ? sel.getRangeAt(sel.rangeCount - 1).collapsed : false;
	            };
	        }
	
	        function updateAnchorAndFocusFromRange(sel, range, backward) {
	            var anchorPrefix = backward ? "end" : "start", focusPrefix = backward ? "start" : "end";
	            sel.anchorNode = range[anchorPrefix + "Container"];
	            sel.anchorOffset = range[anchorPrefix + "Offset"];
	            sel.focusNode = range[focusPrefix + "Container"];
	            sel.focusOffset = range[focusPrefix + "Offset"];
	        }
	
	        function updateAnchorAndFocusFromNativeSelection(sel) {
	            var nativeSel = sel.nativeSelection;
	            sel.anchorNode = nativeSel.anchorNode;
	            sel.anchorOffset = nativeSel.anchorOffset;
	            sel.focusNode = nativeSel.focusNode;
	            sel.focusOffset = nativeSel.focusOffset;
	        }
	
	        function updateEmptySelection(sel) {
	            sel.anchorNode = sel.focusNode = null;
	            sel.anchorOffset = sel.focusOffset = 0;
	            sel.rangeCount = 0;
	            sel.isCollapsed = true;
	            sel._ranges.length = 0;
	        }
	
	        function getNativeRange(range) {
	            var nativeRange;
	            if (range instanceof DomRange) {
	                nativeRange = api.createNativeRange(range.getDocument());
	                nativeRange.setEnd(range.endContainer, range.endOffset);
	                nativeRange.setStart(range.startContainer, range.startOffset);
	            } else if (range instanceof WrappedRange) {
	                nativeRange = range.nativeRange;
	            } else if (features.implementsDomRange && (range instanceof dom.getWindow(range.startContainer).Range)) {
	                nativeRange = range;
	            }
	            return nativeRange;
	        }
	
	        function rangeContainsSingleElement(rangeNodes) {
	            if (!rangeNodes.length || rangeNodes[0].nodeType != 1) {
	                return false;
	            }
	            for (var i = 1, len = rangeNodes.length; i < len; ++i) {
	                if (!dom.isAncestorOf(rangeNodes[0], rangeNodes[i])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	
	        function getSingleElementFromRange(range) {
	            var nodes = range.getNodes();
	            if (!rangeContainsSingleElement(nodes)) {
	                throw module.createError("getSingleElementFromRange: range " + range.inspect() + " did not consist of a single element");
	            }
	            return nodes[0];
	        }
	
	        // Simple, quick test which only needs to distinguish between a TextRange and a ControlRange
	        function isTextRange(range) {
	            return !!range && typeof range.text != "undefined";
	        }
	
	        function updateFromTextRange(sel, range) {
	            // Create a Range from the selected TextRange
	            var wrappedRange = new WrappedRange(range);
	            sel._ranges = [wrappedRange];
	
	            updateAnchorAndFocusFromRange(sel, wrappedRange, false);
	            sel.rangeCount = 1;
	            sel.isCollapsed = wrappedRange.collapsed;
	        }
	
	        function updateControlSelection(sel) {
	            // Update the wrapped selection based on what's now in the native selection
	            sel._ranges.length = 0;
	            if (sel.docSelection.type == "None") {
	                updateEmptySelection(sel);
	            } else {
	                var controlRange = sel.docSelection.createRange();
	                if (isTextRange(controlRange)) {
	                    // This case (where the selection type is "Control" and calling createRange() on the selection returns
	                    // a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected
	                    // ControlRange have been removed from the ControlRange and removed from the document.
	                    updateFromTextRange(sel, controlRange);
	                } else {
	                    sel.rangeCount = controlRange.length;
	                    var range, doc = getDocument(controlRange.item(0));
	                    for (var i = 0; i < sel.rangeCount; ++i) {
	                        range = api.createRange(doc);
	                        range.selectNode(controlRange.item(i));
	                        sel._ranges.push(range);
	                    }
	                    sel.isCollapsed = sel.rangeCount == 1 && sel._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], false);
	                }
	            }
	        }
	
	        function addRangeToControlSelection(sel, range) {
	            var controlRange = sel.docSelection.createRange();
	            var rangeElement = getSingleElementFromRange(range);
	
	            // Create a new ControlRange containing all the elements in the selected ControlRange plus the element
	            // contained by the supplied range
	            var doc = getDocument(controlRange.item(0));
	            var newControlRange = getBody(doc).createControlRange();
	            for (var i = 0, len = controlRange.length; i < len; ++i) {
	                newControlRange.add(controlRange.item(i));
	            }
	            try {
	                newControlRange.add(rangeElement);
	            } catch (ex) {
	                throw module.createError("addRange(): Element within the specified Range could not be added to control selection (does it have layout?)");
	            }
	            newControlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        var getSelectionRangeAt;
	
	        if (isHostMethod(testSelection, "getRangeAt")) {
	            // try/catch is present because getRangeAt() must have thrown an error in some browser and some situation.
	            // Unfortunately, I didn't write a comment about the specifics and am now scared to take it out. Let that be a
	            // lesson to us all, especially me.
	            getSelectionRangeAt = function(sel, index) {
	                try {
	                    return sel.getRangeAt(index);
	                } catch (ex) {
	                    return null;
	                }
	            };
	        } else if (selectionHasAnchorAndFocus) {
	            getSelectionRangeAt = function(sel) {
	                var doc = getDocument(sel.anchorNode);
	                var range = api.createRange(doc);
	                range.setStartAndEnd(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset);
	
	                // Handle the case when the selection was selected backwards (from the end to the start in the
	                // document)
	                if (range.collapsed !== this.isCollapsed) {
	                    range.setStartAndEnd(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset);
	                }
	
	                return range;
	            };
	        }
	
	        function WrappedSelection(selection, docSelection, win) {
	            this.nativeSelection = selection;
	            this.docSelection = docSelection;
	            this._ranges = [];
	            this.win = win;
	            this.refresh();
	        }
	
	        WrappedSelection.prototype = api.selectionPrototype;
	
	        function deleteProperties(sel) {
	            sel.win = sel.anchorNode = sel.focusNode = sel._ranges = null;
	            sel.rangeCount = sel.anchorOffset = sel.focusOffset = 0;
	            sel.detached = true;
	        }
	
	        var cachedRangySelections = [];
	
	        function actOnCachedSelection(win, action) {
	            var i = cachedRangySelections.length, cached, sel;
	            while (i--) {
	                cached = cachedRangySelections[i];
	                sel = cached.selection;
	                if (action == "deleteAll") {
	                    deleteProperties(sel);
	                } else if (cached.win == win) {
	                    if (action == "delete") {
	                        cachedRangySelections.splice(i, 1);
	                        return true;
	                    } else {
	                        return sel;
	                    }
	                }
	            }
	            if (action == "deleteAll") {
	                cachedRangySelections.length = 0;
	            }
	            return null;
	        }
	
	        var getSelection = function(win) {
	            // Check if the parameter is a Rangy Selection object
	            if (win && win instanceof WrappedSelection) {
	                win.refresh();
	                return win;
	            }
	
	            win = getWindow(win, "getNativeSelection");
	
	            var sel = actOnCachedSelection(win);
	            var nativeSel = getNativeSelection(win), docSel = implementsDocSelection ? getDocSelection(win) : null;
	            if (sel) {
	                sel.nativeSelection = nativeSel;
	                sel.docSelection = docSel;
	                sel.refresh();
	            } else {
	                sel = new WrappedSelection(nativeSel, docSel, win);
	                cachedRangySelections.push( { win: win, selection: sel } );
	            }
	            return sel;
	        };
	
	        api.getSelection = getSelection;
	
	        util.createAliasForDeprecatedMethod(api, "getIframeSelection", "getSelection");
	
	        var selProto = WrappedSelection.prototype;
	
	        function createControlSelection(sel, ranges) {
	            // Ensure that the selection becomes of type "Control"
	            var doc = getDocument(ranges[0].startContainer);
	            var controlRange = getBody(doc).createControlRange();
	            for (var i = 0, el, len = ranges.length; i < len; ++i) {
	                el = getSingleElementFromRange(ranges[i]);
	                try {
	                    controlRange.add(el);
	                } catch (ex) {
	                    throw module.createError("setRanges(): Element within one of the specified Ranges could not be added to control selection (does it have layout?)");
	                }
	            }
	            controlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        // Selecting a range
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && util.areHostMethods(testSelection, ["removeAllRanges", "addRange"])) {
	            selProto.removeAllRanges = function() {
	                this.nativeSelection.removeAllRanges();
	                updateEmptySelection(this);
	            };
	
	            var addRangeBackward = function(sel, range) {
	                addRangeBackwardToNative(sel.nativeSelection, range);
	                sel.refresh();
	            };
	
	            if (selectionHasRangeCount) {
	                selProto.addRange = function(range, direction) {
	                    if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                        addRangeToControlSelection(this, range);
	                    } else {
	                        if (isDirectionBackward(direction) && selectionHasExtend) {
	                            addRangeBackward(this, range);
	                        } else {
	                            var previousRangeCount;
	                            if (selectionSupportsMultipleRanges) {
	                                previousRangeCount = this.rangeCount;
	                            } else {
	                                this.removeAllRanges();
	                                previousRangeCount = 0;
	                            }
	                            // Clone the native range so that changing the selected range does not affect the selection.
	                            // This is contrary to the spec but is the only way to achieve consistency between browsers. See
	                            // issue 80.
	                            var clonedNativeRange = getNativeRange(range).cloneRange();
	                            try {
	                                this.nativeSelection.addRange(clonedNativeRange);
	                            } catch (ex) {
	                            }
	
	                            // Check whether adding the range was successful
	                            this.rangeCount = this.nativeSelection.rangeCount;
	
	                            if (this.rangeCount == previousRangeCount + 1) {
	                                // The range was added successfully
	
	                                // Check whether the range that we added to the selection is reflected in the last range extracted from
	                                // the selection
	                                if (api.config.checkSelectionRanges) {
	                                    var nativeRange = getSelectionRangeAt(this.nativeSelection, this.rangeCount - 1);
	                                    if (nativeRange && !rangesEqual(nativeRange, range)) {
	                                        // Happens in WebKit with, for example, a selection placed at the start of a text node
	                                        range = new WrappedRange(nativeRange);
	                                    }
	                                }
	                                this._ranges[this.rangeCount - 1] = range;
	                                updateAnchorAndFocusFromRange(this, range, selectionIsBackward(this.nativeSelection));
	                                this.isCollapsed = selectionIsCollapsed(this);
	                            } else {
	                                // The range was not added successfully. The simplest thing is to refresh
	                                this.refresh();
	                            }
	                        }
	                    }
	                };
	            } else {
	                selProto.addRange = function(range, direction) {
	                    if (isDirectionBackward(direction) && selectionHasExtend) {
	                        addRangeBackward(this, range);
	                    } else {
	                        this.nativeSelection.addRange(getNativeRange(range));
	                        this.refresh();
	                    }
	                };
	            }
	
	            selProto.setRanges = function(ranges) {
	                if (implementsControlRange && implementsDocSelection && ranges.length > 1) {
	                    createControlSelection(this, ranges);
	                } else {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        this.addRange(ranges[i]);
	                    }
	                }
	            };
	        } else if (isHostMethod(testSelection, "empty") && isHostMethod(testRange, "select") &&
	                   implementsControlRange && useDocumentSelection) {
	
	            selProto.removeAllRanges = function() {
	                // Added try/catch as fix for issue #21
	                try {
	                    this.docSelection.empty();
	
	                    // Check for empty() not working (issue #24)
	                    if (this.docSelection.type != "None") {
	                        // Work around failure to empty a control selection by instead selecting a TextRange and then
	                        // calling empty()
	                        var doc;
	                        if (this.anchorNode) {
	                            doc = getDocument(this.anchorNode);
	                        } else if (this.docSelection.type == CONTROL) {
	                            var controlRange = this.docSelection.createRange();
	                            if (controlRange.length) {
	                                doc = getDocument( controlRange.item(0) );
	                            }
	                        }
	                        if (doc) {
	                            var textRange = getBody(doc).createTextRange();
	                            textRange.select();
	                            this.docSelection.empty();
	                        }
	                    }
	                } catch(ex) {}
	                updateEmptySelection(this);
	            };
	
	            selProto.addRange = function(range) {
	                if (this.docSelection.type == CONTROL) {
	                    addRangeToControlSelection(this, range);
	                } else {
	                    api.WrappedTextRange.rangeToTextRange(range).select();
	                    this._ranges[0] = range;
	                    this.rangeCount = 1;
	                    this.isCollapsed = this._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(this, range, false);
	                }
	            };
	
	            selProto.setRanges = function(ranges) {
	                this.removeAllRanges();
	                var rangeCount = ranges.length;
	                if (rangeCount > 1) {
	                    createControlSelection(this, ranges);
	                } else if (rangeCount) {
	                    this.addRange(ranges[0]);
	                }
	            };
	        } else {
	            module.fail("No means of selecting a Range or TextRange was found");
	            return false;
	        }
	
	        selProto.getRangeAt = function(index) {
	            if (index < 0 || index >= this.rangeCount) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            } else {
	                // Clone the range to preserve selection-range independence. See issue 80.
	                return this._ranges[index].cloneRange();
	            }
	        };
	
	        var refreshSelection;
	
	        if (useDocumentSelection) {
	            refreshSelection = function(sel) {
	                var range;
	                if (api.isSelectionValid(sel.win)) {
	                    range = sel.docSelection.createRange();
	                } else {
	                    range = getBody(sel.win.document).createTextRange();
	                    range.collapse(true);
	                }
	
	                if (sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else if (isTextRange(range)) {
	                    updateFromTextRange(sel, range);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else if (isHostMethod(testSelection, "getRangeAt") && typeof testSelection.rangeCount == NUMBER) {
	            refreshSelection = function(sel) {
	                if (implementsControlRange && implementsDocSelection && sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else {
	                    sel._ranges.length = sel.rangeCount = sel.nativeSelection.rangeCount;
	                    if (sel.rangeCount) {
	                        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                            sel._ranges[i] = new api.WrappedRange(sel.nativeSelection.getRangeAt(i));
	                        }
	                        updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], selectionIsBackward(sel.nativeSelection));
	                        sel.isCollapsed = selectionIsCollapsed(sel);
	                    } else {
	                        updateEmptySelection(sel);
	                    }
	                }
	            };
	        } else if (selectionHasAnchorAndFocus && typeof testSelection.isCollapsed == BOOLEAN && typeof testRange.collapsed == BOOLEAN && features.implementsDomRange) {
	            refreshSelection = function(sel) {
	                var range, nativeSel = sel.nativeSelection;
	                if (nativeSel.anchorNode) {
	                    range = getSelectionRangeAt(nativeSel, 0);
	                    sel._ranges = [range];
	                    sel.rangeCount = 1;
	                    updateAnchorAndFocusFromNativeSelection(sel);
	                    sel.isCollapsed = selectionIsCollapsed(sel);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else {
	            module.fail("No means of obtaining a Range or TextRange from the user's selection was found");
	            return false;
	        }
	
	        selProto.refresh = function(checkForChanges) {
	            var oldRanges = checkForChanges ? this._ranges.slice(0) : null;
	            var oldAnchorNode = this.anchorNode, oldAnchorOffset = this.anchorOffset;
	
	            refreshSelection(this);
	            if (checkForChanges) {
	                // Check the range count first
	                var i = oldRanges.length;
	                if (i != this._ranges.length) {
	                    return true;
	                }
	
	                // Now check the direction. Checking the anchor position is the same is enough since we're checking all the
	                // ranges after this
	                if (this.anchorNode != oldAnchorNode || this.anchorOffset != oldAnchorOffset) {
	                    return true;
	                }
	
	                // Finally, compare each range in turn
	                while (i--) {
	                    if (!rangesEqual(oldRanges[i], this._ranges[i])) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        };
	
	        // Removal of a single range
	        var removeRangeManually = function(sel, range) {
	            var ranges = sel.getAllRanges();
	            sel.removeAllRanges();
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                if (!rangesEqual(range, ranges[i])) {
	                    sel.addRange(ranges[i]);
	                }
	            }
	            if (!sel.rangeCount) {
	                updateEmptySelection(sel);
	            }
	        };
	
	        if (implementsControlRange && implementsDocSelection) {
	            selProto.removeRange = function(range) {
	                if (this.docSelection.type == CONTROL) {
	                    var controlRange = this.docSelection.createRange();
	                    var rangeElement = getSingleElementFromRange(range);
	
	                    // Create a new ControlRange containing all the elements in the selected ControlRange minus the
	                    // element contained by the supplied range
	                    var doc = getDocument(controlRange.item(0));
	                    var newControlRange = getBody(doc).createControlRange();
	                    var el, removed = false;
	                    for (var i = 0, len = controlRange.length; i < len; ++i) {
	                        el = controlRange.item(i);
	                        if (el !== rangeElement || removed) {
	                            newControlRange.add(controlRange.item(i));
	                        } else {
	                            removed = true;
	                        }
	                    }
	                    newControlRange.select();
	
	                    // Update the wrapped selection based on what's now in the native selection
	                    updateControlSelection(this);
	                } else {
	                    removeRangeManually(this, range);
	                }
	            };
	        } else {
	            selProto.removeRange = function(range) {
	                removeRangeManually(this, range);
	            };
	        }
	
	        // Detecting if a selection is backward
	        var selectionIsBackward;
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && features.implementsDomRange) {
	            selectionIsBackward = winSelectionIsBackward;
	
	            selProto.isBackward = function() {
	                return selectionIsBackward(this);
	            };
	        } else {
	            selectionIsBackward = selProto.isBackward = function() {
	                return false;
	            };
	        }
	
	        // Create an alias for backwards compatibility. From 1.3, everything is "backward" rather than "backwards"
	        selProto.isBackwards = selProto.isBackward;
	
	        // Selection stringifier
	        // This is conformant to the old HTML5 selections draft spec but differs from WebKit and Mozilla's implementation.
	        // The current spec does not yet define this method.
	        selProto.toString = function() {
	            var rangeTexts = [];
	            for (var i = 0, len = this.rangeCount; i < len; ++i) {
	                rangeTexts[i] = "" + this._ranges[i];
	            }
	            return rangeTexts.join("");
	        };
	
	        function assertNodeInSameDocument(sel, node) {
	            if (sel.win.document != getDocument(node)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        // No current browser conforms fully to the spec for this method, so Rangy's own method is always used
	        selProto.collapse = function(node, offset) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.collapseToPoint(node, offset);
	            this.setSingleRange(range);
	            this.isCollapsed = true;
	        };
	
	        selProto.collapseToStart = function() {
	            if (this.rangeCount) {
	                var range = this._ranges[0];
	                this.collapse(range.startContainer, range.startOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        selProto.collapseToEnd = function() {
	            if (this.rangeCount) {
	                var range = this._ranges[this.rangeCount - 1];
	                this.collapse(range.endContainer, range.endOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        // The spec is very specific on how selectAllChildren should be implemented and not all browsers implement it as
	        // specified so the native implementation is never used by Rangy.
	        selProto.selectAllChildren = function(node) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.selectNodeContents(node);
	            this.setSingleRange(range);
	        };
	
	        selProto.deleteFromDocument = function() {
	            // Sepcial behaviour required for IE's control selections
	            if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                var controlRange = this.docSelection.createRange();
	                var element;
	                while (controlRange.length) {
	                    element = controlRange.item(0);
	                    controlRange.remove(element);
	                    dom.removeNode(element);
	                }
	                this.refresh();
	            } else if (this.rangeCount) {
	                var ranges = this.getAllRanges();
	                if (ranges.length) {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        ranges[i].deleteContents();
	                    }
	                    // The spec says nothing about what the selection should contain after calling deleteContents on each
	                    // range. Firefox moves the selection to where the final selected range was, so we emulate that
	                    this.addRange(ranges[len - 1]);
	                }
	            }
	        };
	
	        // The following are non-standard extensions
	        selProto.eachRange = function(func, returnValue) {
	            for (var i = 0, len = this._ranges.length; i < len; ++i) {
	                if ( func( this.getRangeAt(i) ) ) {
	                    return returnValue;
	                }
	            }
	        };
	
	        selProto.getAllRanges = function() {
	            var ranges = [];
	            this.eachRange(function(range) {
	                ranges.push(range);
	            });
	            return ranges;
	        };
	
	        selProto.setSingleRange = function(range, direction) {
	            this.removeAllRanges();
	            this.addRange(range, direction);
	        };
	
	        selProto.callMethodOnEachRange = function(methodName, params) {
	            var results = [];
	            this.eachRange( function(range) {
	                results.push( range[methodName].apply(range, params || []) );
	            } );
	            return results;
	        };
	
	        function createStartOrEndSetter(isStart) {
	            return function(node, offset) {
	                var range;
	                if (this.rangeCount) {
	                    range = this.getRangeAt(0);
	                    range["set" + (isStart ? "Start" : "End")](node, offset);
	                } else {
	                    range = api.createRange(this.win.document);
	                    range.setStartAndEnd(node, offset);
	                }
	                this.setSingleRange(range, this.isBackward());
	            };
	        }
	
	        selProto.setStart = createStartOrEndSetter(true);
	        selProto.setEnd = createStartOrEndSetter(false);
	
	        // Add select() method to Range prototype. Any existing selection will be removed.
	        api.rangePrototype.select = function(direction) {
	            getSelection( this.getDocument() ).setSingleRange(this, direction);
	        };
	
	        selProto.changeEachRange = function(func) {
	            var ranges = [];
	            var backward = this.isBackward();
	
	            this.eachRange(function(range) {
	                func(range);
	                ranges.push(range);
	            });
	
	            this.removeAllRanges();
	            if (backward && ranges.length == 1) {
	                this.addRange(ranges[0], "backward");
	            } else {
	                this.setRanges(ranges);
	            }
	        };
	
	        selProto.containsNode = function(node, allowPartial) {
	            return this.eachRange( function(range) {
	                return range.containsNode(node, allowPartial);
	            }, true ) || false;
	        };
	
	        selProto.getBookmark = function(containerNode) {
	            return {
	                backward: this.isBackward(),
	                rangeBookmarks: this.callMethodOnEachRange("getBookmark", [containerNode])
	            };
	        };
	
	        selProto.moveToBookmark = function(bookmark) {
	            var selRanges = [];
	            for (var i = 0, rangeBookmark, range; rangeBookmark = bookmark.rangeBookmarks[i++]; ) {
	                range = api.createRange(this.win);
	                range.moveToBookmark(rangeBookmark);
	                selRanges.push(range);
	            }
	            if (bookmark.backward) {
	                this.setSingleRange(selRanges[0], "backward");
	            } else {
	                this.setRanges(selRanges);
	            }
	        };
	
	        selProto.saveRanges = function() {
	            return {
	                backward: this.isBackward(),
	                ranges: this.callMethodOnEachRange("cloneRange")
	            };
	        };
	
	        selProto.restoreRanges = function(selRanges) {
	            this.removeAllRanges();
	            for (var i = 0, range; range = selRanges.ranges[i]; ++i) {
	                this.addRange(range, (selRanges.backward && i == 0));
	            }
	        };
	
	        selProto.toHtml = function() {
	            var rangeHtmls = [];
	            this.eachRange(function(range) {
	                rangeHtmls.push( DomRange.toHtml(range) );
	            });
	            return rangeHtmls.join("");
	        };
	
	        if (features.implementsTextRange) {
	            selProto.getNativeTextRange = function() {
	                var sel, textRange;
	                if ( (sel = this.docSelection) ) {
	                    var range = sel.createRange();
	                    if (isTextRange(range)) {
	                        return range;
	                    } else {
	                        throw module.createError("getNativeTextRange: selection is a control selection");
	                    }
	                } else if (this.rangeCount > 0) {
	                    return api.WrappedTextRange.rangeToTextRange( this.getRangeAt(0) );
	                } else {
	                    throw module.createError("getNativeTextRange: selection contains no range");
	                }
	            };
	        }
	
	        function inspect(sel) {
	            var rangeInspects = [];
	            var anchor = new DomPosition(sel.anchorNode, sel.anchorOffset);
	            var focus = new DomPosition(sel.focusNode, sel.focusOffset);
	            var name = (typeof sel.getName == "function") ? sel.getName() : "Selection";
	
	            if (typeof sel.rangeCount != "undefined") {
	                for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                    rangeInspects[i] = DomRange.inspect(sel.getRangeAt(i));
	                }
	            }
	            return "[" + name + "(Ranges: " + rangeInspects.join(", ") +
	                    ")(anchor: " + anchor.inspect() + ", focus: " + focus.inspect() + "]";
	        }
	
	        selProto.getName = function() {
	            return "WrappedSelection";
	        };
	
	        selProto.inspect = function() {
	            return inspect(this);
	        };
	
	        selProto.detach = function() {
	            actOnCachedSelection(this.win, "delete");
	            deleteProperties(this);
	        };
	
	        WrappedSelection.detachAll = function() {
	            actOnCachedSelection(null, "deleteAll");
	        };
	
	        WrappedSelection.inspect = inspect;
	        WrappedSelection.isDirectionBackward = isDirectionBackward;
	
	        api.Selection = WrappedSelection;
	
	        api.selectionPrototype = selProto;
	
	        api.addShimListener(function(win) {
	            if (typeof win.getSelection == "undefined") {
	                win.getSelection = function() {
	                    return getSelection(win);
	                };
	            }
	            win = null;
	        });
	    });
	    
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wait for document to load before initializing
	    var docReady = false;
	
	    var loadHandler = function(e) {
	        if (!docReady) {
	            docReady = true;
	            if (!api.initialized && api.config.autoInitialize) {
	                init();
	            }
	        }
	    };
	
	    if (isBrowser) {
	        // Test whether the document has already been loaded and initialize immediately if so
	        if (document.readyState == "complete") {
	            loadHandler();
	        } else {
	            if (isHostMethod(document, "addEventListener")) {
	                document.addEventListener("DOMContentLoaded", loadHandler, false);
	            }
	
	            // Add a fallback in case the DOMContentLoaded event isn't supported
	            addListener(window, "load", loadHandler);
	        }
	    }
	
	    return api;
	}, this);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Selection save and restore module for Rangy.
	 * Saves and restores user selections using marker invisible elements in the DOM.
	 *
	 * Part of Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Depends on Rangy core.
	 *
	 * Copyright 2015, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.0
	 * Build date: 10 May 2015
	 */
	(function(factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module with a dependency on Rangy.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(37)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && typeof exports == "object") {
	        // Node/CommonJS style
	        module.exports = factory( require("rangy") );
	    } else {
	        // No AMD or CommonJS support so we use the rangy property of root (probably the global variable)
	        factory(root.rangy);
	    }
	})(function(rangy) {
	    rangy.createModule("SaveRestore", ["WrappedRange"], function(api, module) {
	        var dom = api.dom;
	        var removeNode = dom.removeNode;
	        var isDirectionBackward = api.Selection.isDirectionBackward;
	        var markerTextChar = "\ufeff";
	
	        function gEBI(id, doc) {
	            return (doc || document).getElementById(id);
	        }
	
	        function insertRangeBoundaryMarker(range, atStart) {
	            var markerId = "selectionBoundary_" + (+new Date()) + "_" + ("" + Math.random()).slice(2);
	            var markerEl;
	            var doc = dom.getDocument(range.startContainer);
	
	            // Clone the Range and collapse to the appropriate boundary point
	            var boundaryRange = range.cloneRange();
	            boundaryRange.collapse(atStart);
	
	            // Create the marker element containing a single invisible character using DOM methods and insert it
	            markerEl = doc.createElement("span");
	            markerEl.id = markerId;
	            markerEl.style.lineHeight = "0";
	            markerEl.style.display = "none";
	            markerEl.className = "rangySelectionBoundary";
	            markerEl.appendChild(doc.createTextNode(markerTextChar));
	
	            boundaryRange.insertNode(markerEl);
	            return markerEl;
	        }
	
	        function setRangeBoundary(doc, range, markerId, atStart) {
	            var markerEl = gEBI(markerId, doc);
	            if (markerEl) {
	                range[atStart ? "setStartBefore" : "setEndBefore"](markerEl);
	                removeNode(markerEl);
	            } else {
	                module.warn("Marker element has been removed. Cannot restore selection.");
	            }
	        }
	
	        function compareRanges(r1, r2) {
	            return r2.compareBoundaryPoints(r1.START_TO_START, r1);
	        }
	
	        function saveRange(range, direction) {
	            var startEl, endEl, doc = api.DomRange.getRangeDocument(range), text = range.toString();
	            var backward = isDirectionBackward(direction);
	
	            if (range.collapsed) {
	                endEl = insertRangeBoundaryMarker(range, false);
	                return {
	                    document: doc,
	                    markerId: endEl.id,
	                    collapsed: true
	                };
	            } else {
	                endEl = insertRangeBoundaryMarker(range, false);
	                startEl = insertRangeBoundaryMarker(range, true);
	
	                return {
	                    document: doc,
	                    startMarkerId: startEl.id,
	                    endMarkerId: endEl.id,
	                    collapsed: false,
	                    backward: backward,
	                    toString: function() {
	                        return "original text: '" + text + "', new text: '" + range.toString() + "'";
	                    }
	                };
	            }
	        }
	
	        function restoreRange(rangeInfo, normalize) {
	            var doc = rangeInfo.document;
	            if (typeof normalize == "undefined") {
	                normalize = true;
	            }
	            var range = api.createRange(doc);
	            if (rangeInfo.collapsed) {
	                var markerEl = gEBI(rangeInfo.markerId, doc);
	                if (markerEl) {
	                    markerEl.style.display = "inline";
	                    var previousNode = markerEl.previousSibling;
	
	                    // Workaround for issue 17
	                    if (previousNode && previousNode.nodeType == 3) {
	                        removeNode(markerEl);
	                        range.collapseToPoint(previousNode, previousNode.length);
	                    } else {
	                        range.collapseBefore(markerEl);
	                        removeNode(markerEl);
	                    }
	                } else {
	                    module.warn("Marker element has been removed. Cannot restore selection.");
	                }
	            } else {
	                setRangeBoundary(doc, range, rangeInfo.startMarkerId, true);
	                setRangeBoundary(doc, range, rangeInfo.endMarkerId, false);
	            }
	
	            if (normalize) {
	                range.normalizeBoundaries();
	            }
	
	            return range;
	        }
	
	        function saveRanges(ranges, direction) {
	            var rangeInfos = [], range, doc;
	            var backward = isDirectionBackward(direction);
	
	            // Order the ranges by position within the DOM, latest first, cloning the array to leave the original untouched
	            ranges = ranges.slice(0);
	            ranges.sort(compareRanges);
	
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                rangeInfos[i] = saveRange(ranges[i], backward);
	            }
	
	            // Now that all the markers are in place and DOM manipulation over, adjust each range's boundaries to lie
	            // between its markers
	            for (i = len - 1; i >= 0; --i) {
	                range = ranges[i];
	                doc = api.DomRange.getRangeDocument(range);
	                if (range.collapsed) {
	                    range.collapseAfter(gEBI(rangeInfos[i].markerId, doc));
	                } else {
	                    range.setEndBefore(gEBI(rangeInfos[i].endMarkerId, doc));
	                    range.setStartAfter(gEBI(rangeInfos[i].startMarkerId, doc));
	                }
	            }
	
	            return rangeInfos;
	        }
	
	        function saveSelection(win) {
	            if (!api.isSelectionValid(win)) {
	                module.warn("Cannot save selection. This usually happens when the selection is collapsed and the selection document has lost focus.");
	                return null;
	            }
	            var sel = api.getSelection(win);
	            var ranges = sel.getAllRanges();
	            var backward = (ranges.length == 1 && sel.isBackward());
	
	            var rangeInfos = saveRanges(ranges, backward);
	
	            // Ensure current selection is unaffected
	            if (backward) {
	                sel.setSingleRange(ranges[0], backward);
	            } else {
	                sel.setRanges(ranges);
	            }
	
	            return {
	                win: win,
	                rangeInfos: rangeInfos,
	                restored: false
	            };
	        }
	
	        function restoreRanges(rangeInfos) {
	            var ranges = [];
	
	            // Ranges are in reverse order of appearance in the DOM. We want to restore earliest first to avoid
	            // normalization affecting previously restored ranges.
	            var rangeCount = rangeInfos.length;
	
	            for (var i = rangeCount - 1; i >= 0; i--) {
	                ranges[i] = restoreRange(rangeInfos[i], true);
	            }
	
	            return ranges;
	        }
	
	        function restoreSelection(savedSelection, preserveDirection) {
	            if (!savedSelection.restored) {
	                var rangeInfos = savedSelection.rangeInfos;
	                var sel = api.getSelection(savedSelection.win);
	                var ranges = restoreRanges(rangeInfos), rangeCount = rangeInfos.length;
	
	                if (rangeCount == 1 && preserveDirection && api.features.selectionHasExtend && rangeInfos[0].backward) {
	                    sel.removeAllRanges();
	                    sel.addRange(ranges[0], true);
	                } else {
	                    sel.setRanges(ranges);
	                }
	
	                savedSelection.restored = true;
	            }
	        }
	
	        function removeMarkerElement(doc, markerId) {
	            var markerEl = gEBI(markerId, doc);
	            if (markerEl) {
	                removeNode(markerEl);
	            }
	        }
	
	        function removeMarkers(savedSelection) {
	            var rangeInfos = savedSelection.rangeInfos;
	            for (var i = 0, len = rangeInfos.length, rangeInfo; i < len; ++i) {
	                rangeInfo = rangeInfos[i];
	                if (rangeInfo.collapsed) {
	                    removeMarkerElement(savedSelection.doc, rangeInfo.markerId);
	                } else {
	                    removeMarkerElement(savedSelection.doc, rangeInfo.startMarkerId);
	                    removeMarkerElement(savedSelection.doc, rangeInfo.endMarkerId);
	                }
	            }
	        }
	
	        api.util.extend(api, {
	            saveRange: saveRange,
	            restoreRange: restoreRange,
	            saveRanges: saveRanges,
	            restoreRanges: restoreRanges,
	            saveSelection: saveSelection,
	            restoreSelection: restoreSelection,
	            removeMarkerElement: removeMarkerElement,
	            removeMarkers: removeMarkers
	        });
	    });
	    
	    return rangy;
	}, this);

/***/ }),
/* 39 */
5,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["moment"] = __webpack_require__(42);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(43);
	moment.tz.load(__webpack_require__(162));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.13
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(44)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else if (typeof module === 'object' && module.exports) {
			module.exports = factory(require('moment')); // Node
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.13",
			zones = {},
			links = {},
			names = {},
			guesses = {},
			cachedGuess,
	
			momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			return b.zone.population - a.zone.population;
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName){
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				if (split[5]) {
					addToGuesses(normalized, split[2].split(' '));
				}
			}
		}
	
		function getZone (name, caller) {
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			return !!(m._a && (m._tzm === undefined));
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.offset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					mom.utcOffset(-offset, keepTime);
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name) {
			if (name) {
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName = abbrWrap(fn.zoneName);
		fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
		fn.utc      = resetZoneWrap(fn.utc);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(46)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 47,
		"./af.js": 47,
		"./ar": 48,
		"./ar-dz": 49,
		"./ar-dz.js": 49,
		"./ar-kw": 50,
		"./ar-kw.js": 50,
		"./ar-ly": 51,
		"./ar-ly.js": 51,
		"./ar-ma": 52,
		"./ar-ma.js": 52,
		"./ar-sa": 53,
		"./ar-sa.js": 53,
		"./ar-tn": 54,
		"./ar-tn.js": 54,
		"./ar.js": 48,
		"./az": 55,
		"./az.js": 55,
		"./be": 56,
		"./be.js": 56,
		"./bg": 57,
		"./bg.js": 57,
		"./bn": 58,
		"./bn.js": 58,
		"./bo": 59,
		"./bo.js": 59,
		"./br": 60,
		"./br.js": 60,
		"./bs": 61,
		"./bs.js": 61,
		"./ca": 62,
		"./ca.js": 62,
		"./cs": 63,
		"./cs.js": 63,
		"./cv": 64,
		"./cv.js": 64,
		"./cy": 65,
		"./cy.js": 65,
		"./da": 66,
		"./da.js": 66,
		"./de": 67,
		"./de-at": 68,
		"./de-at.js": 68,
		"./de-ch": 69,
		"./de-ch.js": 69,
		"./de.js": 67,
		"./dv": 70,
		"./dv.js": 70,
		"./el": 71,
		"./el.js": 71,
		"./en-au": 72,
		"./en-au.js": 72,
		"./en-ca": 73,
		"./en-ca.js": 73,
		"./en-gb": 74,
		"./en-gb.js": 74,
		"./en-ie": 75,
		"./en-ie.js": 75,
		"./en-nz": 76,
		"./en-nz.js": 76,
		"./eo": 77,
		"./eo.js": 77,
		"./es": 78,
		"./es-do": 79,
		"./es-do.js": 79,
		"./es.js": 78,
		"./et": 80,
		"./et.js": 80,
		"./eu": 81,
		"./eu.js": 81,
		"./fa": 82,
		"./fa.js": 82,
		"./fi": 83,
		"./fi.js": 83,
		"./fo": 84,
		"./fo.js": 84,
		"./fr": 85,
		"./fr-ca": 86,
		"./fr-ca.js": 86,
		"./fr-ch": 87,
		"./fr-ch.js": 87,
		"./fr.js": 85,
		"./fy": 88,
		"./fy.js": 88,
		"./gd": 89,
		"./gd.js": 89,
		"./gl": 90,
		"./gl.js": 90,
		"./gom-latn": 91,
		"./gom-latn.js": 91,
		"./he": 92,
		"./he.js": 92,
		"./hi": 93,
		"./hi.js": 93,
		"./hr": 94,
		"./hr.js": 94,
		"./hu": 95,
		"./hu.js": 95,
		"./hy-am": 96,
		"./hy-am.js": 96,
		"./id": 97,
		"./id.js": 97,
		"./is": 98,
		"./is.js": 98,
		"./it": 99,
		"./it.js": 99,
		"./ja": 100,
		"./ja.js": 100,
		"./jv": 101,
		"./jv.js": 101,
		"./ka": 102,
		"./ka.js": 102,
		"./kk": 103,
		"./kk.js": 103,
		"./km": 104,
		"./km.js": 104,
		"./kn": 105,
		"./kn.js": 105,
		"./ko": 106,
		"./ko.js": 106,
		"./ky": 107,
		"./ky.js": 107,
		"./lb": 108,
		"./lb.js": 108,
		"./lo": 109,
		"./lo.js": 109,
		"./lt": 110,
		"./lt.js": 110,
		"./lv": 111,
		"./lv.js": 111,
		"./me": 112,
		"./me.js": 112,
		"./mi": 113,
		"./mi.js": 113,
		"./mk": 114,
		"./mk.js": 114,
		"./ml": 115,
		"./ml.js": 115,
		"./mr": 116,
		"./mr.js": 116,
		"./ms": 117,
		"./ms-my": 118,
		"./ms-my.js": 118,
		"./ms.js": 117,
		"./my": 119,
		"./my.js": 119,
		"./nb": 120,
		"./nb.js": 120,
		"./ne": 121,
		"./ne.js": 121,
		"./nl": 122,
		"./nl-be": 123,
		"./nl-be.js": 123,
		"./nl.js": 122,
		"./nn": 124,
		"./nn.js": 124,
		"./pa-in": 125,
		"./pa-in.js": 125,
		"./pl": 126,
		"./pl.js": 126,
		"./pt": 127,
		"./pt-br": 128,
		"./pt-br.js": 128,
		"./pt.js": 127,
		"./ro": 129,
		"./ro.js": 129,
		"./ru": 130,
		"./ru.js": 130,
		"./sd": 131,
		"./sd.js": 131,
		"./se": 132,
		"./se.js": 132,
		"./si": 133,
		"./si.js": 133,
		"./sk": 134,
		"./sk.js": 134,
		"./sl": 135,
		"./sl.js": 135,
		"./sq": 136,
		"./sq.js": 136,
		"./sr": 137,
		"./sr-cyrl": 138,
		"./sr-cyrl.js": 138,
		"./sr.js": 137,
		"./ss": 139,
		"./ss.js": 139,
		"./sv": 140,
		"./sv.js": 140,
		"./sw": 141,
		"./sw.js": 141,
		"./ta": 142,
		"./ta.js": 142,
		"./te": 143,
		"./te.js": 143,
		"./tet": 144,
		"./tet.js": 144,
		"./th": 145,
		"./th.js": 145,
		"./tl-ph": 146,
		"./tl-ph.js": 146,
		"./tlh": 147,
		"./tlh.js": 147,
		"./tr": 148,
		"./tr.js": 148,
		"./tzl": 149,
		"./tzl.js": 149,
		"./tzm": 150,
		"./tzm-latn": 151,
		"./tzm-latn.js": 151,
		"./tzm.js": 150,
		"./uk": 152,
		"./uk.js": 152,
		"./ur": 153,
		"./ur.js": 153,
		"./uz": 154,
		"./uz-latn": 155,
		"./uz-latn.js": 155,
		"./uz.js": 154,
		"./vi": 156,
		"./vi.js": 156,
		"./x-pseudo": 157,
		"./x-pseudo.js": 157,
		"./yo": 158,
		"./yo.js": 158,
		"./zh-cn": 159,
		"./zh-cn.js": 159,
		"./zh-hk": 160,
		"./zh-hk.js": 160,
		"./zh-tw": 161,
		"./zh-tw.js": 161
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 46;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(44)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	module.exports = {"version":"2017b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|HMT +0630 IST|-5R.k -6u -5u|01212|-18LFR.k 1unn.k HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.E -6u -90|0121|-21Jio.E SmnS.E 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Khartoum|Africa/Juba","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/East-Saskatchewan","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* angular-moment.js / v1.0.1 / (c) 2013, 2014, 2015, 2016 Uri Shaked / MIT Licence */
	
	'format amd';
	/* global define */
	
	(function () {
		'use strict';
	
		function isUndefinedOrNull(val) {
			return angular.isUndefined(val) || val === null;
		}
	
		function requireMoment() {
			try {
				return __webpack_require__(44); // Using nw.js or browserify?
			} catch (e) {
				throw new Error('Please install moment via npm. Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
			}
		}
	
		function angularMoment(angular, moment) {
	
			if(typeof moment === 'undefined') {
				if(true) {
					moment = requireMoment();
				}else{
					throw new Error('Moment cannot be found by angular-moment! Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
				}
			}
	
			/**
			 * @ngdoc overview
			 * @name angularMoment
			 *
			 * @description
			 * angularMoment module provides moment.js functionality for angular.js apps.
			 */
			angular.module('angularMoment', [])
	
			/**
			 * @ngdoc object
			 * @name angularMoment.config:angularMomentConfig
			 *
			 * @description
			 * Common configuration of the angularMoment module
			 */
				.constant('angularMomentConfig', {
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#preprocess
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {function} A preprocessor function that will be applied on all incoming dates
					 *
					 * @description
					 * Defines a preprocessor function to apply on all input dates (e.g. the input of `am-time-ago`,
					 * `amCalendar`, etc.). The function must return a `moment` object.
					 *
					 * @example
					 *   // Causes angular-moment to always treat the input values as unix timestamps
					 *   angularMomentConfig.preprocess = function(value) {
					 * 	   return moment.unix(value);
					 *   }
					 */
					preprocess: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#timezone
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The default timezone
					 *
					 * @description
					 * The default timezone (e.g. 'Europe/London'). Empty string by default (does not apply
					 * any timezone shift).
					 *
					 * NOTE: This option requires moment-timezone >= 0.3.0.
					 */
					timezone: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#format
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The pre-conversion format of the date
					 *
					 * @description
					 * Specify the format of the input date. Essentially it's a
					 * default and saves you from specifying a format in every
					 * element. Overridden by element attr. Null by default.
					 */
					format: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#statefulFilters
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {boolean} Whether angular-moment filters should be stateless (or not)
					 *
					 * @description
					 * Specifies whether the filters included with angular-moment are stateful.
					 * Stateful filters will automatically re-evaluate whenever you change the timezone
					 * or locale settings, but may negatively impact performance. true by default.
					 */
					statefulFilters: true
				})
	
			/**
			 * @ngdoc object
			 * @name angularMoment.object:moment
			 *
			 * @description
			 * moment global (as provided by the moment.js library)
			 */
				.constant('moment', moment)
	
			/**
			 * @ngdoc object
			 * @name angularMoment.config:amTimeAgoConfig
			 * @module angularMoment
			 *
			 * @description
			 * configuration specific to the amTimeAgo directive
			 */
				.constant('amTimeAgoConfig', {
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#withoutSuffix
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {boolean} Whether to include a suffix in am-time-ago directive
					 *
					 * @description
					 * Defaults to false.
					 */
					withoutSuffix: false,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#serverTime
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {number} Server time in milliseconds since the epoch
					 *
					 * @description
					 * If set, time ago will be calculated relative to the given value.
					 * If null, local time will be used. Defaults to null.
					 */
					serverTime: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#titleFormat
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {string} The format of the date to be displayed in the title of the element. If null,
					 *        the directive set the title of the element.
					 *
					 * @description
					 * The format of the date used for the title of the element. null by default.
					 */
					titleFormat: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#fullDateThreshold
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {number} The minimum number of days for showing a full date instead of relative time
					 *
					 * @description
					 * The threshold for displaying a full date. The default is null, which means the date will always
					 * be relative, and full date will never be displayed.
					 */
					fullDateThreshold: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#fullDateFormat
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {string} The format to use when displaying a full date.
					 *
					 * @description
					 * Specify the format of the date when displayed as full date. null by default.
					 */
					fullDateFormat: null,
	
					fullDateThresholdUnit: 'day'
				})
	
			/**
			 * @ngdoc directive
			 * @name angularMoment.directive:amTimeAgo
			 * @module angularMoment
			 *
			 * @restrict A
			 */
				.directive('amTimeAgo', ['$window', 'moment', 'amMoment', 'amTimeAgoConfig', function ($window, moment, amMoment, amTimeAgoConfig) {
	
					return function (scope, element, attr) {
						var activeTimeout = null;
						var currentValue;
						var withoutSuffix = amTimeAgoConfig.withoutSuffix;
						var titleFormat = amTimeAgoConfig.titleFormat;
						var fullDateThreshold = amTimeAgoConfig.fullDateThreshold;
						var fullDateFormat = amTimeAgoConfig.fullDateFormat;
						var fullDateThresholdUnit = amTimeAgoConfig.fullDateThresholdUnit;
	
						var localDate = new Date().getTime();
						var modelName = attr.amTimeAgo;
						var currentFrom;
						var isTimeElement = ('TIME' === element[0].nodeName.toUpperCase());
						var setTitleTime = !element.attr('title');
	
						function getNow() {
							var now;
							if (currentFrom) {
								now = currentFrom;
							} else if (amTimeAgoConfig.serverTime) {
								var localNow = new Date().getTime();
								var nowMillis = localNow - localDate + amTimeAgoConfig.serverTime;
								now = moment(nowMillis);
							}
							else {
								now = moment();
							}
							return now;
						}
	
						function cancelTimer() {
							if (activeTimeout) {
								$window.clearTimeout(activeTimeout);
								activeTimeout = null;
							}
						}
	
						function updateTime(momentInstance) {
							var timeAgo = getNow().diff(momentInstance, fullDateThresholdUnit);
							var showFullDate = fullDateThreshold && timeAgo >= fullDateThreshold;
	
							if (showFullDate) {
								element.text(momentInstance.format(fullDateFormat));
							} else {
								element.text(momentInstance.from(getNow(), withoutSuffix));
							}
	
							if (titleFormat && setTitleTime) {
								element.attr('title', momentInstance.format(titleFormat));
							}
	
							if (!showFullDate) {
								var howOld = Math.abs(getNow().diff(momentInstance, 'minute'));
								var secondsUntilUpdate = 3600;
								if (howOld < 1) {
									secondsUntilUpdate = 1;
								} else if (howOld < 60) {
									secondsUntilUpdate = 30;
								} else if (howOld < 180) {
									secondsUntilUpdate = 300;
								}
	
								activeTimeout = $window.setTimeout(function () {
									updateTime(momentInstance);
								}, secondsUntilUpdate * 1000);
							}
						}
	
						function updateDateTimeAttr(value) {
							if (isTimeElement) {
								element.attr('datetime', value);
							}
						}
	
						function updateMoment() {
							cancelTimer();
							if (currentValue) {
								var momentValue = amMoment.preprocessDate(currentValue);
								updateTime(momentValue);
								updateDateTimeAttr(momentValue.toISOString());
							}
						}
	
						scope.$watch(modelName, function (value) {
							if (isUndefinedOrNull(value) || (value === '')) {
								cancelTimer();
								if (currentValue) {
									element.text('');
									updateDateTimeAttr('');
									currentValue = null;
								}
								return;
							}
	
							currentValue = value;
							updateMoment();
						});
	
						if (angular.isDefined(attr.amFrom)) {
							scope.$watch(attr.amFrom, function (value) {
								if (isUndefinedOrNull(value) || (value === '')) {
									currentFrom = null;
								} else {
									currentFrom = moment(value);
								}
								updateMoment();
							});
						}
	
						if (angular.isDefined(attr.amWithoutSuffix)) {
							scope.$watch(attr.amWithoutSuffix, function (value) {
								if (typeof value === 'boolean') {
									withoutSuffix = value;
									updateMoment();
								} else {
									withoutSuffix = amTimeAgoConfig.withoutSuffix;
								}
							});
						}
	
						attr.$observe('amFullDateThreshold', function (newValue) {
							fullDateThreshold = newValue;
							updateMoment();
						});
	
						attr.$observe('amFullDateFormat', function (newValue) {
							fullDateFormat = newValue;
							updateMoment();
						});
	
						attr.$observe('amFullDateThresholdUnit', function (newValue) {
							fullDateThresholdUnit = newValue;
							updateMoment();
						});
	
						scope.$on('$destroy', function () {
							cancelTimer();
						});
	
						scope.$on('amMoment:localeChanged', function () {
							updateMoment();
						});
					};
				}])
	
			/**
			 * @ngdoc service
			 * @name angularMoment.service.amMoment
			 * @module angularMoment
			 */
				.service('amMoment', ['moment', '$rootScope', '$log', 'angularMomentConfig', function (moment, $rootScope, $log, angularMomentConfig) {
					var defaultTimezone = null;
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#changeLocale
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Changes the locale for moment.js and updates all the am-time-ago directive instances
					 * with the new locale. Also broadcasts an `amMoment:localeChanged` event on $rootScope.
					 *
					 * @param {string} locale Locale code (e.g. en, es, ru, pt-br, etc.)
					 * @param {object} customization object of locale strings to override
					 */
					this.changeLocale = function (locale, customization) {
						var result = moment.locale(locale, customization);
						if (angular.isDefined(locale)) {
							$rootScope.$broadcast('amMoment:localeChanged');
	
						}
						return result;
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#changeTimezone
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Changes the default timezone for amCalendar, amDateFormat and amTimeAgo. Also broadcasts an
					 * `amMoment:timezoneChanged` event on $rootScope.
					 *
					 * Note: this method works only if moment-timezone > 0.3.0 is loaded
					 *
					 * @param {string} timezone Timezone name (e.g. UTC)
					 */
					this.changeTimezone = function (timezone) {
						if (moment.tz && moment.tz.setDefault) {
							moment.tz.setDefault(timezone);
							$rootScope.$broadcast('amMoment:timezoneChanged');
						} else {
							$log.warn('angular-moment: changeTimezone() works only with moment-timezone.js v0.3.0 or greater.');
						}
						angularMomentConfig.timezone = timezone;
						defaultTimezone = timezone;
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#preprocessDate
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Preprocess a given value and convert it into a Moment instance appropriate for use in the
					 * am-time-ago directive and the filters. The behavior of this function can be overriden by
					 * setting `angularMomentConfig.preprocess`.
					 *
					 * @param {*} value The value to be preprocessed
					 * @return {Moment} A `moment` object
					 */
					this.preprocessDate = function (value) {
						// Configure the default timezone if needed
						if (defaultTimezone !== angularMomentConfig.timezone) {
							this.changeTimezone(angularMomentConfig.timezone);
						}
	
						if (angularMomentConfig.preprocess) {
							return angularMomentConfig.preprocess(value);
						}
	
						if (!isNaN(parseFloat(value)) && isFinite(value)) {
							// Milliseconds since the epoch
							return moment(parseInt(value, 10));
						}
	
						// else just returns the value as-is.
						return moment(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amParse
			 * @module angularMoment
			 */
				.filter('amParse', ['moment', function (moment) {
					return function (value, format) {
						return moment(value, format);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amFromUnix
			 * @module angularMoment
			 */
				.filter('amFromUnix', ['moment', function (moment) {
					return function (value) {
						return moment.unix(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amUtc
			 * @module angularMoment
			 */
				.filter('amUtc', ['moment', function (moment) {
					return function (value) {
						return moment.utc(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amUtcOffset
			 * @module angularMoment
			 *
			 * @description
			 * Adds a UTC offset to the given timezone object. The offset can be a number of minutes, or a string such as
			 * '+0300', '-0300' or 'Z'.
			 */
				.filter('amUtcOffset', ['amMoment', function (amMoment) {
					function amUtcOffset(value, offset) {
						return amMoment.preprocessDate(value).utcOffset(offset);
					}
	
					return amUtcOffset;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amLocal
			 * @module angularMoment
			 */
				.filter('amLocal', ['moment', function (moment) {
					return function (value) {
						return moment.isMoment(value) ? value.local() : null;
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amTimezone
			 * @module angularMoment
			 *
			 * @description
			 * Apply a timezone onto a given moment object, e.g. 'America/Phoenix').
			 *
			 * You need to include moment-timezone.js for timezone support.
			 */
				.filter('amTimezone', ['amMoment', 'angularMomentConfig', '$log', function (amMoment, angularMomentConfig, $log) {
					function amTimezone(value, timezone) {
						var aMoment = amMoment.preprocessDate(value);
	
						if (!timezone) {
							return aMoment;
						}
	
						if (aMoment.tz) {
							return aMoment.tz(timezone);
						} else {
							$log.warn('angular-moment: named timezone specified but moment.tz() is undefined. Did you forget to include moment-timezone.js ?');
							return aMoment;
						}
					}
	
					return amTimezone;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amCalendar
			 * @module angularMoment
			 */
				.filter('amCalendar', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amCalendarFilter(value, referenceTime, formats) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						return date.isValid() ? date.calendar(referenceTime, formats) : '';
					}
	
					// Since AngularJS 1.3, filters have to explicitly define being stateful
					// (this is no longer the default).
					amCalendarFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amCalendarFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDifference
			 * @module angularMoment
			 */
				.filter('amDifference', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amDifferenceFilter(value, otherValue, unit, usePrecision) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						var date2 = !isUndefinedOrNull(otherValue) ? amMoment.preprocessDate(otherValue) : moment();
	
						if (!date.isValid() || !date2.isValid()) {
							return '';
						}
	
						return date.diff(date2, unit, usePrecision);
					}
	
					amDifferenceFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDifferenceFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDateFormat
			 * @module angularMoment
			 * @function
			 */
				.filter('amDateFormat', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amDateFormatFilter(value, format) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						if (!date.isValid()) {
							return '';
						}
	
						return date.format(format);
					}
	
					amDateFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDateFormatFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDurationFormat
			 * @module angularMoment
			 * @function
			 */
				.filter('amDurationFormat', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amDurationFormatFilter(value, format, suffix) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment.duration(value, format).humanize(suffix);
					}
	
					amDurationFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDurationFormatFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amTimeAgo
			 * @module angularMoment
			 * @function
			 */
				.filter('amTimeAgo', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amTimeAgoFilter(value, suffix, from) {
						var date, dateFrom;
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						value = amMoment.preprocessDate(value);
						date = moment(value);
						if (!date.isValid()) {
							return '';
						}
	
						dateFrom = moment(from);
						if (!isUndefinedOrNull(from) && dateFrom.isValid()) {
							return date.from(dateFrom, suffix);
						}
	
						return date.fromNow(suffix);
					}
	
					amTimeAgoFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amTimeAgoFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amSubtract
			 * @module angularMoment
			 * @function
			 */
				.filter('amSubtract', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amSubtractFilter(value, amount, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).subtract(parseInt(amount, 10), type);
					}
	
					amSubtractFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amSubtractFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amAdd
			 * @module angularMoment
			 * @function
			 */
				.filter('amAdd', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amAddFilter(value, amount, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).add(parseInt(amount, 10), type);
					}
	
					amAddFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amAddFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amStartOf
			 * @module angularMoment
			 * @function
			 */
				.filter('amStartOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amStartOfFilter(value, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).startOf(type);
					}
	
					amStartOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amStartOfFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amEndOf
			 * @module angularMoment
			 * @function
			 */
				.filter('amEndOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amEndOfFilter(value, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).endOf(type);
					}
	
					amEndOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amEndOfFilter;
	 			}]);
	
			return 'angularMoment';
		}
	
		var isElectron = window && window.process && window.process.type;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14), __webpack_require__(44)], __WEBPACK_AMD_DEFINE_FACTORY__ = (angularMoment), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module && module.exports && (typeof require === 'function') && !isElectron) {
			module.exports = angularMoment(require('angular'), require('moment'));
		} else {
			angularMoment(angular, (typeof global !== 'undefined' ? global : window).moment);
		}
	})();


/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider'];
	decorateTextAngular.$inject = ['$provide'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	exports.decorateTextAngular = decorateTextAngular;
	exports.addCustomFieldsCache = addCustomFieldsCache;
	exports.schemaFormCustomFields = schemaFormCustomFields;
	exports.addSingleFileUploadCache = addSingleFileUploadCache;
	exports.schemaFormSingleFileUpload = schemaFormSingleFileUpload;
	function routeConfig($urlRouterProvider, $locationProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise(function ($injector) {
	    var $state = $injector.get("$state");
	    $state.go('/');
	  });
	
	  $locationProvider.html5Mode(true);
	}
	
	function decorateTextAngular($provide) {
	  'ngInject';
	
	  $provide.decorator('taOptions', ['taRegisterTool', '$delegate', '$uibModal', function (taRegisterTool, taOptions, $uibModal) {
	
	    taRegisterTool('backgroundColor', {
	      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px;'>" + "<button title='Background Color' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><span style='color:black; background-color:yellow'>ABC</span><i class='fa fa-caret-down'></i></button>" + "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='width: 100%' type='button' ng-click='action($event, o.css)'><div style='border:1px solid black; float:left; width:20px; background-color: {{o.css}}; '>&nbsp;</div>&nbsp;&nbsp;<i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</a></li></ul></span>",
	      action: function action(event, color) {
	        if (!!event.stopPropagation) {
	          event.stopPropagation();
	
	          $("body").trigger("click");
	        }
	        return this.$editor().wrapSelection('backColor', color);
	      },
	      options: [{ name: 'Aqua', css: "aqua" }, { name: 'Black', css: "black" }, { name: 'Blue', css: "blue" }, { name: 'Fuchsia', css: "fuchsia" }, { name: 'Gray', css: "gray" }, { name: 'Green', css: "green" }, { name: 'Lime', css: "lime" }, { name: 'Maroon', css: "maroon" }, { name: 'Navy', css: "navy" }, { name: 'Olive', css: "olive" }, { name: 'Purple', css: "purple" }, { name: 'Red', css: "red" }, { name: 'Silver', css: "silver" }, { name: 'Teal', css: "teal" }, { name: 'White', css: "white" }, { name: 'Yellow', css: "yellow" }]
	    });
	
	    taRegisterTool('fontColor', {
	      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px;'>" + "<button title='Text Color' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><span style='color:red'>A</span><span style='color:green'>B</span><span style='color:blue'>C</span><i class='fa fa-caret-down'></i></button>" + "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='width: 100%' type='button' ng-click='action($event, o.css)'><div style='border:1px solid black; float:left; width:20px; background-color: {{o.css}}; '>&nbsp;</div>&nbsp;&nbsp;<i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</a></li></ul></span>",
	      action: function action(event, color) {
	        if (!!event.stopPropagation) {
	          event.stopPropagation();
	
	          $("body").trigger("click");
	        }
	        return this.$editor().wrapSelection('foreColor', color);
	      },
	      options: [{ name: 'Aqua', css: "aqua" }, { name: 'Black', css: "black" }, { name: 'Blue', css: "blue" }, { name: 'Fuchsia', css: "fuchsia" }, { name: 'Gray', css: "gray" }, { name: 'Green', css: "green" }, { name: 'Lime', css: "lime" }, { name: 'Maroon', css: "maroon" }, { name: 'Navy', css: "navy" }, { name: 'Olive', css: "olive" }, { name: 'Purple', css: "purple" }, { name: 'Red', css: "red" }, { name: 'Silver', css: "silver" }, { name: 'Teal', css: "teal" }, { name: 'White', css: "white" }, { name: 'Yellow', css: "yellow" }]
	    });
	
	    taRegisterTool('fontName', {
	      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px;'>" + "<button title='Font Face' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><i class='fa fa-font'></i><i class='fa fa-caret-down'></i></button>" + "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='font-family: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.css)'><i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</a></li></ul></span>",
	      action: function action(event, font) {
	        if (!!event.stopPropagation) {
	          event.stopPropagation();
	
	          $("body").trigger("click");
	        }
	        return this.$editor().wrapSelection('fontName', font);
	      },
	      options: [{ name: 'Sans-Serif', css: 'Arial, Helvetica, sans-serif' }, { name: 'Serif', css: "'times new roman', serif" }, { name: 'Wide', css: "'arial black', sans-serif" }, { name: 'Narrow', css: "'arial narrow', sans-serif" }, { name: 'Comic Sans MS', css: "'comic sans ms', sans-serif" }, { name: 'Courier New', css: "'courier new', monospace" }, { name: 'Garamond', css: 'garamond, serif' }, { name: 'Georgia', css: 'georgia, serif' }, { name: 'Tahoma', css: 'tahoma, sans-serif' }, { name: 'Trebuchet MS', css: "'trebuchet ms', sans-serif" }, { name: "Helvetica", css: "'Helvetica Neue', Helvetica, Arial, sans-serif" }, { name: 'Verdana', css: 'verdana, sans-serif' }, { name: 'Proxima Nova', css: 'proxima_nova_rgregular' }]
	    });
	
	    taRegisterTool('fontSize', {
	      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px'>" + "<button title='Font Size' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><i class='fa fa-text-height'></i><i class='fa fa-caret-down'></i></button>" + "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='font-size: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.value)'><i ng-if='o.active' class='fa fa-check'></i> {{o.name}}</a></li></ul>" + "</span>",
	      action: function action(event, size) {
	        if (!!event.stopPropagation) {
	          event.stopPropagation();
	
	          $("body").trigger("click");
	        }
	        return this.$editor().wrapSelection('fontSize', parseInt(size));
	      },
	      options: [{ name: 'XX Small', css: 'xx-small', value: 1 }, { name: 'X Small', css: 'x-small', value: 2 }, { name: 'Small', css: 'small', value: 3 }, { name: 'Medium', css: 'medium', value: 4 }, { name: 'Large', css: 'large', value: 5 }, { name: 'X Large', css: 'x-large', value: 6 }, { name: 'XX Large', css: 'xx-large', value: 7 }]
	    });
	
	    taRegisterTool('codeMirror', {
	      iconclass: "fa fa-code",
	      disabled: function disabled() {
	        return false;
	      },
	      action: function action() {
	        var _this = this;
	
	        var modalInstance = $uibModal.open({
	          animation: true,
	          component: 'codemirrorHtmlForm',
	          backdrop: "static",
	          windowClass: 'html-modal',
	          resolve: {
	            config: function config() {
	              return {
	                data: _this.$editor().html
	              };
	            }
	          },
	          size: 'lg'
	        });
	
	        modalInstance.result.then(function (html) {
	          _this.$editor().html = html;
	        }, function () {});
	      }
	    });
	
	    return taOptions;
	  }]);
	}
	
	function addCustomFieldsCache($templateCache) {
	  $templateCache.put("components/schema-form-custom-fields/entity-lookup.html", '<div class="{{form.fieldHtmlClass}}"> <!-- Surrounding DIV for sfField builder to add a sfField directive to. -->\n    <label>{{form.title}}</label>\n\n    <div class="input-group">\n        <select class="form-control" ng-options="o.value as o.name group by o.group for o in form.schema.entityLookupData | orderBy:[\'group\',\'name\']"\n        sf-field-model schema-validate="form"></select>\n        <span class="input-group-btn">\n              <a class="btn btn-default" ng-click="form.schema.fnLookup(form.key[0])" type="button"><i class="fa fa-fw fa-search"></i></a>\n              <a class="btn btn-danger" ng-disabled="!model[form.key[0]]" href="#" ng-click="model[form.key[0]] = undefined"><i class="fa fa-fw fa-times"></i></a>\n            </span>\n    </div>\n\n    <div sf-message="form.description"></div>\n</div>');
	}
	
	function schemaFormCustomFields(schemaFormDecoratorsProvider, sfBuilderProvider) {
	  schemaFormDecoratorsProvider.defineAddOn('bootstrapDecorator', 'entitylookup', 'components/schema-form-custom-fields/entity-lookup.html', sfBuilderProvider.stdBuilders);
	}
	
	function addSingleFileUploadCache($templateCache) {
	  $templateCache.put("components/schema-form-single-file-upload/single-file-upload.html", '<div class="{{form.fieldHtmlClass}}"> <!-- Surrounding DIV for sfField builder to add a sfField directive to. -->\n    <label>{{form.title}}</label>\n\n      <div ng-if="model[form.key[0]]">\n        <div class="well well-sm">\n            <a ng-href="/api/storage/{{model[form.key[0]]}}" target="_blank"><i class="fa fa-fw fa-download"></i> Download</a>\n            <a class="btn btn-sm btn-danger pull-right" style="position: relative; top: -5px;"\n                ng-click="model[form.key[0]] = undefined"><i class="fa fa-fw fa-trash"></i></a>\n        </div>\n      </div>\n\n      <div ng-if="!model[form.key[0]]">\n        <a class="btn btn-sm btn-primary" ng-click="form.schema.fnOpenAssetUploadModal(form.key[0])"><i class="fa fa-fw fa-upload"></i> Upload</a>\n      </div>\n\n    <div sf-message="form.description"></div>\n</div>');
	}
	
	function schemaFormSingleFileUpload(schemaFormDecoratorsProvider, sfBuilderProvider) {
	  schemaFormDecoratorsProvider.defineAddOn('bootstrapDecorator', 'single-file-upload', 'components/schema-form-single-file-upload/single-file-upload.html', sfBuilderProvider.stdBuilders);
	}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	addInterceptor.$inject = ['$httpProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(166);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _util = __webpack_require__(168);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _angularCookies = __webpack_require__(16);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _interceptor = __webpack_require__(170);
	
	var _router = __webpack_require__(171);
	
	var _auth = __webpack_require__(172);
	
	var _user = __webpack_require__(173);
	
	var _angularUiRouter = __webpack_require__(28);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addInterceptor($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('authInterceptor');
	}
	
	exports.default = _angular2.default.module('conduu.auth', [_app2.default, _util2.default, _angularCookies2.default, _angularUiRouter2.default]).factory('authInterceptor', _interceptor.authInterceptor).run(_router.routerDecorator).factory('Auth', _auth.AuthService).factory('User', _user.UserResource).config(['$httpProvider', addInterceptor]).name;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('conduuHQ.constants', []).constant('appConfig', __webpack_require__(167)).name;

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	'use strict';
	
	exports = module.exports = {
	
	};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('conduu.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    },
	    dataTableExportBreakToNewlineRenderer: function dataTableExportBreakToNewlineRenderer(data, type, row) {
	      if (type === 'export') {
	        return data.replaceAll('<br>', '\r').replaceAll('<br/>', '\r').replaceAll('<br />', '\r');
	      }
	      return data;
	    }
	  };
	
	  return Util;
	}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	'use strict';
	
	authInterceptor.$inject = ['$rootScope', '$q', '$cookies', '$injector', 'Util'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authInterceptor = authInterceptor;
	function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
	  'ngInject';
	
	  var state;
	  return {
	    request: function request(config) {
	      config.headers = config.headers || {};
	      if ($cookies.get('token') && Util.isSameOrigin(config.url)) {
	        config.headers.Authorization = 'Bearer ' + $cookies.get('token');
	      }
	      return config;
	    },
	    responseError: function responseError(response) {
	      if (response.status === 401) {
	        (state || (state = $injector.get('$state'))).go('main');
	
	        $cookies.remove('token');
	      }
	      return $q.reject(response);
	    }
	  };
	}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	'use strict';
	
	routerDecorator.$inject = ['$rootScope', '$state', 'Auth'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerDecorator = routerDecorator;
	function routerDecorator($rootScope, $state, Auth) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    if (!next.authenticate) {
	      return;
	    }
	
	    if (typeof next.authenticate === 'string') {
	      Auth.hasRole(next.authenticate).then(function (has) {
	        if (has) {
	          return;
	        }
	
	        event.preventDefault();
	        return Auth.isLoggedIn().then(function (is) {
	          $state.go(is ? 'home' : 'login');
	        });
	      });
	    } else {
	      Auth.isLoggedIn().then(function (is) {
	        if (is) {
	          return;
	        }
	
	        event.preventDefault();
	
	        $state.go('login');
	      });
	    }
	  });
	}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	'use strict';
	
	AuthService.$inject = ['$location', '$http', '$cookies', '$q', 'Util', 'User'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthService = AuthService;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _User = function _User() {
	  _classCallCheck(this, _User);
	
	  this._id = '';
	  this.name = '';
	  this.email = '';
	  this.role = '';
	  this.$promise = undefined;
	};
	
	function AuthService($location, $http, $cookies, $q, Util, User) {
	  'ngInject';
	
	  var safeCb = Util.safeCb;
	  var currentUser = new _User();
	  var userRoles = ['suite-user', 'suite-admin', 'suite-superadmin'];
	
	  var _hasRole = function _hasRole(userRoles, requiredRole) {
	    var userHasRole = false;
	
	    if (Array.isArray(userRoles)) {
	      userHasRole = userRoles.indexOf(requiredRole) !== -1;
	    } else {
	      userHasRole = userRoles === requiredRole;
	    }
	    return userHasRole;
	  };
	
	  if ($cookies.get('token') && $location.path() !== '/logout') {
	    currentUser = User.get();
	  }
	
	  var Auth = {
	    login: function login(_ref, callback) {
	      var email = _ref.email,
	          password = _ref.password;
	
	      return $http.post('/auth/local', {
	        email: email,
	        password: password
	      }).then(function (res) {
	        $cookies.put('token', res.data.token);
	        currentUser = User.get();
	        return currentUser.$promise;
	      }).then(function (user) {
	        safeCb(callback)(null, user);
	        return user;
	      }).catch(function (err) {
	        Auth.logout();
	        safeCb(callback)(err.data);
	        return $q.reject(err.data);
	      });
	    },
	    logout: function logout() {
	      $cookies.remove('token');
	      currentUser = new _User();
	    },
	    createUser: function createUser(user, callback) {
	      return User.save(user, function (data) {
	        $cookies.put('token', data.token);
	        currentUser = User.get();
	        return safeCb(callback)(null, user);
	      }, function (err) {
	        Auth.logout();
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    changePassword: function changePassword(oldPassword, newPassword, callback) {
	      return User.changePassword({
	        id: currentUser._id
	      }, {
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    validatePassword: function validatePassword(password, callback) {
	      return User.validatePassword({
	        id: currentUser._id
	      }, {
	        password: password
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    forgotPassword: function forgotPassword(email, callback) {
	      return User.forgotPassword({}, {
	        email: email
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    resetPassword: function resetPassword(id, token, newPassword, callback) {
	      return User.resetPassword({
	        id: id
	      }, {
	        token: token, newPassword: newPassword
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    changeEmail: function changeEmail(id, email, callback) {
	      return User.changeEmail({ id: id }, {
	        email: email
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    updateResidencies: function updateResidencies(id, residencies, callback) {
	      return User.updateResidencies({
	        id: id
	      }, residencies, function (resIds) {
	        return safeCb(callback)(resIds);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    getResidencies: function getResidencies(id, callback) {
	      return User.getResidencies({
	        id: id
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    getCurrentUser: function getCurrentUser(callback) {
	      var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;
	
	      return $q.when(value).then(function (user) {
	        safeCb(callback)(user);
	        return user;
	      }, function () {
	        safeCb(callback)({});
	        return {};
	      });
	    },
	    setCurrentUser: function setCurrentUser(user) {
	      if (typeof user == 'undefined') return;
	      currentUser = user;
	    },
	    getCurrentUserSync: function getCurrentUserSync() {
	      return currentUser;
	    },
	    isLoggedIn: function isLoggedIn(callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var is = _.get(user, 'role');
	
	        safeCb(callback)(is);
	        return is;
	      });
	    },
	    isLoggedInSync: function isLoggedInSync() {
	      return !!_.get(currentUser, 'role');
	    },
	    hasRole: function hasRole(role, callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var has = _hasRole(_.get(user, 'role'), role);
	
	        safeCb(callback)(has);
	        return has;
	      });
	    },
	    hasRoleSync: function hasRoleSync(role) {
	      return _hasRole(_.get(currentUser, 'role'), role);
	    },
	    isAdmin: function isAdmin() {
	      return Auth.hasRole.apply(Auth, _toConsumableArray([].concat.apply(['suite-admin'], arguments)));
	    },
	    isAdminSync: function isAdminSync() {
	      return Auth.hasRoleSync('suite-admin');
	    },
	    isSuperAdminSync: function isSuperAdminSync() {
	      return Auth.hasRoleSync('suite-superadmin');
	    },
	    getToken: function getToken() {
	      return $cookies.get('token');
	    },
	    updateUser: function updateUser(user, callback) {
	      return User.update({
	        id: currentUser._id
	      }, user, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    patchUserRoles: function patchUserRoles(user, callback) {
	      return User.update({
	        id: user._id
	      }, {
	        role: user.role
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    }
	  };
	
	  return Auth;
	}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	'use strict';
	
	UserResource.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserResource = UserResource;
	function UserResource($resource) {
	  'ngInject';
	
	  return $resource('/api/users/:id/:controller', {
	    id: '@_id'
	  }, {
	    changePassword: {
	      method: 'PUT',
	      params: {
	        controller: 'password'
	      }
	    },
	    validatePassword: {
	      method: 'PUT',
	      params: {
	        controller: 'password-validate'
	      }
	    },
	    forgotPassword: {
	      method: 'PATCH',
	      params: {
	        id: 'forgot',
	        controller: 'password'
	      }
	    },
	    resetPassword: {
	      method: 'PATCH',
	      params: {
	        controller: 'reset'
	      }
	    },
	    changeEmail: {
	      method: 'PATCH',
	      params: {
	        controller: 'email'
	      }
	    },
	    update: {
	      method: 'PATCH'
	    },
	    updateResidencies: {
	      method: 'PATCH',
	      params: {
	        controller: 'residencies'
	      },
	      isArray: true
	    },
	    getOne: {
	      method: 'GET'
	    },
	    get: {
	      method: 'GET',
	      params: {
	        id: 'me'
	      }
	    },
	    getResidencies: {
	      method: 'GET',
	      params: {
	        controller: 'residencies'
	      }
	    },
	    sendFeedback: {
	      method: 'POST',
	      params: {
	        controller: 'feedback'
	      }
	    }
	  });
	}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(28);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _account = __webpack_require__(175);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _signup = __webpack_require__(180);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _changePassword = __webpack_require__(182);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	var _forgotPassword = __webpack_require__(184);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	var _resetPassword = __webpack_require__(186);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('conduu.account', [_angularUiRouter2.default, _signup2.default, _changePassword2.default, _forgotPassword2.default, _resetPassword2.default]).config(_account2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('logout', {
	    url: '/logout?referrer',
	    referrer: 'main',
	    template: '',
	    controller: ['$state', 'Auth', 'Idle', function controller($state, Auth, Idle) {
	      'ngInject';
	
	      Idle.unwatch();
	
	      var referrer = $state.params.referrer || $state.current.referrer || 'main';
	      Auth.logout();
	      $state.go(referrer);
	    }]
	  }).state('register', {
	    url: '/register',
	    template: __webpack_require__(176),
	    controller: 'SignupController',
	    controllerAs: 'vm'
	  }).state('forgot-password', {
	    url: '/forgot-password',
	    template: __webpack_require__(177),
	    controller: 'ForgotPasswordController',
	    controllerAs: 'vm'
	  }).state('reset-password', {
	    url: '/reset/:id/:token',
	    template: __webpack_require__(178),
	    controller: 'ResetPasswordController',
	    controllerAs: 'vm'
	  }).state('change-password', {
	    url: '/change-password',
	    template: __webpack_require__(179),
	    controller: 'ChangePasswordController',
	    controllerAs: 'vm',
	    authenticate: true
	  });
	}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n      <h1>Register <small>as Business Partner</small></h1>\r\n      <p style=\"float:right; position:relative; top: -16px\">* = required</p>\r\n      <div class=\"bs-callout bs-callout-primary\">\r\n        <h4>Registration Process</h4>\r\n        <p>Thank you for your interest in becoming a business partner of CONDUU.</p>\r\n        <p>After you have submitted your registration, you will get immediate access to our partner portal. There you can login with the email and password provided in this form.</p>\r\n        <p>Inside our partner portal, you can apply as an affiliate partner to every association, which provides a preferred vendors section on its website.\r\n          You can create your listings as soon as the managers of the selected associations have approved your affiliation request.</p>\r\n        <p>If you have any questions, feel free to contact us at <a href=\"mailto:info@conduu.com\">info@conduu.com</a></p>\r\n        <p>We hope this brings you a lot of new opportunities!</p>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-12\">\r\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.register(form)\" novalidate>\r\n\r\n        <div class=\"col-sm-8\" style=\"padding:0px\">\r\n          <!-- Company Name -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.company.$valid && vm.submitted,\r\n                                              'has-error': form.company.$invalid && vm.submitted }\">\r\n            <label>Company Name *</label>\r\n\r\n            <input type=\"text\" name=\"company\" class=\"form-control\" ng-model=\"vm.user.company\" required />\r\n            <p class=\"help-block\" ng-show=\"form.company.$error.required && vm.submitted\">\r\n              A company name is required\r\n            </p>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-sm-4\" style=\"padding-right:0px\">\r\n          <!-- Phone -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.phone.$valid && vm.submitted,\r\n                                              'has-error': form.phone.$invalid && vm.submitted }\">\r\n            <label>Phone *</label>\r\n\r\n            <input type=\"phone\" name=\"phone\" class=\"form-control\" ng-model=\"vm.user.phone\"\r\n                   mongoose-error required/>\r\n            <p class=\"help-block\" ng-show=\"form.phone.$error.phone && vm.submitted\">\r\n              Doesn't look like a valid phone.\r\n            </p>\r\n            <p class=\"help-block\" ng-show=\"form.phone.$error.required && vm.submitted\">\r\n              Phone is required\r\n            </p>\r\n            <p class=\"help-block\" ng-show=\"form.phone.$error.mongoose\">\r\n              {{ vm.errors.phone }}\r\n            </p>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-xs-4\" style=\"padding-left:0px\">\r\n          <!-- Representative: First Name -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.firstName.$valid && vm.submitted,\r\n                                            'has-error': form.firstName.$invalid && vm.submitted }\">\r\n            <label>Representative: First Name *</label>\r\n\r\n            <input type=\"text\" name=\"firstName\" class=\"form-control\" ng-model=\"vm.user.firstName\"\r\n                   required/>\r\n            <p class=\"help-block\" ng-show=\"form.firstName.$error.required && vm.submitted\">\r\n              A first name is required\r\n            </p>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-xs-4\" style=\"padding:0px\">\r\n          <!-- Representative: Middle Name -->\r\n          <div class=\"form-group\">\r\n            <label>Middle Name</label>\r\n\r\n            <input type=\"text\" name=\"middleName\" class=\"form-control\" ng-model=\"vm.user.middleName\" />\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-xs-4\" style=\"padding-right:0px\">\r\n          <!-- Representative: Last Name -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.lastName.$valid && vm.submitted,\r\n                                            'has-error': form.lastName.$invalid && vm.submitted }\">\r\n            <label>Last Name *</label>\r\n\r\n            <input type=\"text\" name=\"lastName\" class=\"form-control\" ng-model=\"vm.user.lastName\"\r\n                   required/>\r\n            <p class=\"help-block\" ng-show=\"form.lastName.$error.required && vm.submitted\">\r\n              A last name is required\r\n            </p>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- E-Mail -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.email.$valid && vm.submitted,\r\n                                            'has-error': form.email.$invalid && vm.submitted }\">\r\n          <label>Email *</label>\r\n\r\n          <input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"vm.user.email\"\r\n                 required\r\n                 mongoose-error/>\r\n          <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\r\n            Doesn't look like a valid email.\r\n          </p>\r\n          <p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">\r\n            What's your email address?\r\n          </p>\r\n          <p class=\"help-block\" ng-show=\"form.email.$error.mongoose\">\r\n            {{ vm.errors.email }}\r\n          </p>\r\n        </div>\r\n\r\n        <!-- Password -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.password.$valid && vm.submitted,\r\n                                            'has-error': form.password.$invalid && vm.submitted }\">\r\n          <label>Password *<span ng-show=\"vm.signUpInfo.password\" style=\"font-weight:normal\"><br/>{{vm.signUpInfo.password}}</span></label>\r\n\r\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.password\"\r\n                 ng-minlength=\"5\"\r\n                 required\r\n                 mongoose-error/>\r\n          <p class=\"help-block\"\r\n             ng-show=\"(form.password.$error.minlength || form.password.$error.required) && vm.submitted\">\r\n            Password must be at least 5 characters.\r\n          </p>\r\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\r\n            {{ vm.errors.password }}\r\n          </p>\r\n        </div>\r\n\r\n        <!-- Password Confirm -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.confirmPassword.$valid && vm.submitted,\r\n                                            'has-error': form.confirmPassword.$invalid && vm.submitted }\">\r\n          <label>Confirm Password *</label>\r\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\r\n                 match=\"vm.user.password\"\r\n                 ng-minlength=\"5\" required/>\r\n          <p class=\"help-block\"\r\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\r\n            Passwords must match.\r\n          </p>\r\n        </div>\r\n\r\n        <!-- Web -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.url.$valid && vm.submitted,\r\n                                            'has-error': form.url.$invalid && vm.submitted }\">\r\n          <label>Website</label>\r\n\r\n          <input type=\"text\" name=\"url\" class=\"form-control\" ng-model=\"vm.user.url\" />\r\n        </div>\r\n\r\n        <hr/>\r\n\r\n        <!-- Address: Street -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.street.$valid && vm.submitted,\r\n                                              'has-error': form.street.$invalid && vm.submitted }\">\r\n          <label>Street</label>\r\n\r\n          <input type=\"text\" name=\"street\" class=\"form-control\" ng-model=\"vm.user.address.street\" />\r\n        </div>\r\n\r\n        <!-- Address: Street 2 -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.street2.$valid && vm.submitted,\r\n                                                'has-error': form.street2.$invalid && vm.submitted }\">\r\n          <label>Address Line 2</label>\r\n\r\n          <input type=\"text\" name=\"street2\" class=\"form-control\" ng-model=\"vm.user.address.street2\" />\r\n        </div>\r\n\r\n        <div class=\"col-sm-6\" style=\"padding-left:0px\">\r\n          <!-- Address: City -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.city.$valid && vm.submitted,\r\n                                                'has-error': form.city.$invalid && vm.submitted }\">\r\n            <label>City</label>\r\n\r\n            <input type=\"text\" name=\"city\" class=\"form-control\" ng-model=\"vm.user.address.city\" />\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"col-sm-4\" style=\"padding:0px\">\r\n          <!-- Address: State -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.state.$valid && vm.submitted,\r\n                                                'has-error': form.state.$invalid && vm.submitted }\">\r\n            <label>State</label>\r\n\r\n            <input type=\"text\" name=\"state\" class=\"form-control\" ng-model=\"vm.user.address.state\" />\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-sm-2\" style=\"padding-right:0px\">\r\n          <!-- Address: ZIP -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.zip.$valid && vm.submitted,\r\n                                                'has-error': form.zip.$invalid && vm.submitted }\">\r\n            <label>ZIP</label>\r\n\r\n            <input type=\"text\" name=\"zip\" class=\"form-control\" ng-model=\"vm.user.address.zip\" />\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Address: Country -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.country.$valid && vm.submitted,\r\n                                                'has-error': form.country.$invalid && vm.submitted }\">\r\n          <label>Country</label>\r\n\r\n          <input type=\"text\" name=\"country\" class=\"form-control\" ng-model=\"vm.user.address.country\" />\r\n        </div>\r\n\r\n        <!-- Buttons -->\r\n        <div>\r\n          <button class=\"btn btn-primary btn-register\" type=\"submit\">\r\n            Submit Registration\r\n          </button>\r\n        </div>\r\n\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n      <h1>Forgot Password</h1>\r\n    </div>\r\n    <div class=\"col-sm-12\">\r\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.submit(form)\" novalidate>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.email.$valid && vm.submitted,\r\n                                            'has-error': form.email.$invalid && vm.submitted }\">\r\n          <label>Email Address</label>\r\n\r\n          <input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"vm.user.email\" required>\r\n        </div>\r\n\r\n        <div class=\"form-group has-error\">\r\n          <p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">\r\n             Please enter your email address.\r\n          </p>\r\n          <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\r\n             Please enter a valid email.\r\n          </p>\r\n\r\n          <p class=\"help-block\">{{ vm.errors.forgot }}</p>\r\n        </div>\r\n\r\n        <div>\r\n          <button class=\"btn btn-primary btn-login\" type=\"submit\">\r\n            Get New Password\r\n          </button>\r\n        </div>\r\n\r\n        <br/>\r\n        <br/>\r\n\r\n        <div class=\"alert alert-info\" ng-show=\"vm.mailSendSuccess\">\r\n          <strong>Mail has been sent:</strong> Check your email for the confirmation link.\r\n        </div>\r\n\r\n        <div class=\"alert alert-warning\" ng-show=\"vm.mailNotRegistered\">\r\n          <strong>Email not found:</strong> There is no user with this email address.\r\n        </div>\r\n\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n      <h1>Reset Password</h1>\r\n      <p>Enter your new password below:</p>\r\n    </div>\r\n    <div class=\"col-sm-12\">\r\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.submit(form)\" novalidate>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.newPassword.$valid && vm.submitted,\r\n                                            'has-error': form.newPassword.$invalid && vm.submitted }\">\r\n          <label>New Password</label>\r\n\r\n          <input type=\"password\" name=\"newPassword\" class=\"form-control\" ng-model=\"vm.user.newPassword\"\r\n                 ng-minlength=\"3\"\r\n                 required/>\r\n          <p class=\"help-block\"\r\n             ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && (form.newPassword.$dirty || vm.submitted)\">\r\n            Password must be at least 3 characters.\r\n          </p>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.confirmPassword.$valid && vm.submitted,\r\n                                            'has-error': form.confirmPassword.$invalid && vm.submitted }\">\r\n          <label>Confirm New Password</label>\r\n\r\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\r\n                 match=\"vm.user.newPassword\"\r\n                 ng-minlength=\"3\"\r\n                 required=\"\"/>\r\n          <p class=\"help-block\"\r\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\r\n            Passwords must match.\r\n          </p>\r\n\r\n        </div>\r\n\r\n        <p>Hint: The password should be at least five characters long. To make it stronger, use upper and lower case letters and numbers</p>\r\n\r\n        <p class=\"help-block\"> {{ vm.message }} </p>\r\n\r\n        <button class=\"btn btn-primary\" type=\"submit\">Save changes</button>\r\n\r\n        <br/>\r\n        <br/>\r\n\r\n        <div class=\"alert alert-success\" ng-show=\"vm.passwordResetSuccess\">\r\n          <strong>Your password has been reset.</strong> You can now <button ui-sref=\"login\" class=\"btn btn-sm btn-success\">Log in</button> with your new password.\r\n        </div>\r\n\r\n        <div class=\"alert alert-danger\" ng-show=\"vm.passwordResetExpired\">\r\n          <strong>Expired!</strong> The password reset link you used is expired. You can request a new password reset link <a class=\"alert-link\" ui-sref=\"forgot-password\">here</a>.\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n      <h1>Change Password</h1>\r\n    </div>\r\n    <div class=\"col-sm-12\">\r\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.changePassword(form)\" novalidate>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.password.$valid && vm.submitted,\r\n                                            'has-error': form.password.$invalid && vm.submitted }\">\r\n          <label>Current Password</label>\r\n\r\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.oldPassword\"\r\n                 mongoose-error/>\r\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\r\n              {{ vm.errors.other }}\r\n          </p>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.newPassword.$valid && vm.submitted,\r\n                                            'has-error': form.newPassword.$invalid && vm.submitted }\">\r\n          <label>New Password</label>\r\n\r\n          <input type=\"password\" name=\"newPassword\" class=\"form-control\" ng-model=\"vm.user.newPassword\"\r\n                 ng-minlength=\"5\"\r\n                 required/>\r\n          <p class=\"help-block\"\r\n             ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && (form.newPassword.$dirty || vm.submitted)\">\r\n            Password must be at least 5 characters.\r\n          </p>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.confirmPassword.$valid && vm.submitted,\r\n                                            'has-error': form.confirmPassword.$invalid && vm.submitted }\">\r\n          <label>Confirm New Password</label>\r\n\r\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\r\n                 match=\"vm.user.newPassword\"\r\n                 ng-minlength=\"5\"\r\n                 required=\"\"/>\r\n          <p class=\"help-block\"\r\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\r\n            Passwords must match.\r\n          </p>\r\n\r\n        </div>\r\n\r\n        <p class=\"help-block\"> {{ vm.message }} </p>\r\n\r\n        <button class=\"btn btn-primary\" type=\"submit\">Save changes</button>\r\n\r\n        <br/>\r\n        <br/>\r\n\r\n        <div class=\"alert alert-success\" ng-show=\"vm.passwordChangeSuccess\">\r\n          <strong>Your password has been changed.</strong>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signup = __webpack_require__(181);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('conduuApp.signup', []).controller('SignupController', _signup2.default).name;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupController = function () {
	
	  /*@ngInject*/
	  SignupController.$inject = ['Auth', '$state'];
	  function SignupController(Auth, $state) {
	    _classCallCheck(this, SignupController);
	
	    this.errors = {};
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	
	    this.user = {
	      email: '',
	      password: '',
	      address: {}
	    };
	  }
	
	  _createClass(SignupController, [{
	    key: 'register',
	    value: function register(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        return this.Auth.createUser(this.user).then(function () {
	          _this.$state.go('home');
	        }).catch(function (err) {
	          err = err.data;
	          _this.errors = {};
	
	          if (err.name) {
	            _angular2.default.forEach(err.errors, function (error, field) {
	              form[field].$setValidity('mongoose', false);
	              _this.errors[field] = error.message;
	            });
	          }
	        });
	      }
	    }
	  }]);
	
	  return SignupController;
	}();
	
	exports.default = SignupController;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _changePassword = __webpack_require__(183);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('conduuApp.changePassword', []).controller('ChangePasswordController', _changePassword2.default).name;

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SettingsController = function () {
	
	  /*@ngInject*/
	  SettingsController.$inject = ['Auth'];
	  function SettingsController(Auth) {
	    _classCallCheck(this, SettingsController);
	
	    this.user = {
	      oldPassword: '',
	      newPassword: '',
	      confirmPassword: ''
	    };
	    this.errors = {
	      other: undefined
	    };
	    this.submitted = false;
	    this.passwordChangeSuccess = false;
	
	    this.Auth = Auth;
	  }
	
	  _createClass(SettingsController, [{
	    key: 'changePassword',
	    value: function changePassword(form) {
	      var _this = this;
	
	      this.submitted = true;
	      this.passwordChangeSuccess = false;
	
	      if (form.$valid) {
	        this.Auth.changePassword(this.user.oldPassword, this.user.newPassword).then(function () {
	          _this.passwordChangeSuccess = true;
	        }).catch(function () {
	          form.password.$setValidity('mongoose', false);
	          _this.errors.other = 'Incorrect password';
	        });
	      }
	    }
	  }]);
	
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _forgotPassword = __webpack_require__(185);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('conduuApp.forgotPassword', []).controller('ForgotPasswordController', _forgotPassword2.default).name;

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ForgotPasswordController = function () {
	
	  /*@ngInject*/
	  ForgotPasswordController.$inject = ['Auth', '$state'];
	  function ForgotPasswordController(Auth, $state) {
	    _classCallCheck(this, ForgotPasswordController);
	
	    this.user = {
	      email: ''
	    };
	    this.errors = {
	      forgot: undefined
	    };
	    this.submitted = false;
	    this.mailSendSuccess = false;
	    this.mailNotRegistered = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	  }
	
	  _createClass(ForgotPasswordController, [{
	    key: 'submit',
	    value: function submit(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      this.mailSendSuccess = false;
	      this.mailNotRegistered = false;
	
	      if (form.$valid) {
	        this.Auth.forgotPassword(this.user.email).then(function () {
	          _this.mailSendSuccess = true;
	        }).catch(function (err) {
	          _this.errors.login = err.message;
	          _this.mailNotRegistered = true;
	        });
	      }
	    }
	  }]);
	
	  return ForgotPasswordController;
	}();
	
	exports.default = ForgotPasswordController;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _resetPassword = __webpack_require__(187);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('conduuApp.resetPassword', []).controller('ResetPasswordController', _resetPassword2.default).name;

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResetPasswordController = function () {
	
	  /*@ngInject*/
	  ResetPasswordController.$inject = ['Auth', '$stateParams'];
	  function ResetPasswordController(Auth, $stateParams) {
	    _classCallCheck(this, ResetPasswordController);
	
	    this.user = {
	      newPassword: '',
	      confirmPassword: ''
	    };
	    this.errors = {
	      other: undefined
	    };
	    this.message = '';
	    this.submitted = false;
	    this.passwordResetSuccess = false;
	    this.passwordResetExpired = false;
	
	    this.Auth = Auth;
	    this.id = $stateParams.id;
	    this.token = $stateParams.token;
	  }
	
	  _createClass(ResetPasswordController, [{
	    key: 'submit',
	    value: function submit(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      this.passwordResetExpired = false;
	      this.passwordResetSuccess = false;
	
	      if (form.$valid) {
	        this.Auth.resetPassword(this.id, this.token, this.user.newPassword).then(function () {
	          _this.passwordResetSuccess = true;
	        }).catch(function () {
	          _this.passwordResetExpired = true;
	        });
	      }
	    }
	  }]);
	
	  return ResetPasswordController;
	}();
	
	exports.default = ResetPasswordController;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarComponent = exports.NavbarComponent = function () {
	  NavbarComponent.$inject = ['Auth', '$state', '$location', 'ViewSelection', 'CommunityService', 'SettingsService', 'RecentVisits', 'PinnedItems', '$scope'];
	  function NavbarComponent(Auth, $state, $location, ViewSelection, CommunityService, SettingsService, RecentVisits, PinnedItems, $scope) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, NavbarComponent);
	
	    this.isCollapsed = true;
	    this.ViewSelection = ViewSelection;
	
	    this.isLoggedIn = Auth.isLoggedInSync;
	    this.isAdmin = Auth.isAdminSync;
	    this.isSuperAdmin = Auth.isSuperAdminSync;
	    this.getCurrentUser = Auth.getCurrentUserSync;
	    this.$state = $state;
	    this.$location = $location;
	    this.RecentVisits = RecentVisits;
	    this.PinnedItems = PinnedItems;
	    this.CommunityService = CommunityService;
	    this.Auth = Auth;
	
	    this.communities = [];
	    this.communityEnum = [];
	
	    this.busy = true;
	
	    this.periodEnum = ["1/1/17 - 12/31/18"];
	
	    this.searchterm = null;
	    this.searchSubmitted = false;
	
	    SettingsService.getByName({ name: 'config.app' }, function (settings) {
	
	      _this.menu = settings.data.customMenu ? settings.data.customMenu : [{
	        title: 'Calendar',
	        url: '/calendar/list'
	      }, {
	        title: 'Portfolio',
	        subMenu: [{
	          title: 'Communities',
	          url: '/community/list'
	        }, {
	          title: 'Properties',
	          url: '/property/list'
	        }, {
	          title: 'Contacts',
	          url: '/contact/list'
	        }, {
	          title: 'Vendors',
	          url: '/vendor/list'
	        }, {
	          title: 'Projects (beta)',
	          url: '/project/list'
	        }, {
	          title: 'Web Access',
	          url: "/webaccess/list"
	        }]
	      }, {
	        title: 'Service Requests',
	        url: '/servicerequest/ticket/list'
	      }, {
	        title: 'Work Orders',
	        url: '/workorder/ticket/list'
	      }, {
	        title: 'Violations',
	        url: '/violation/ticket/list'
	      }, {
	        title: 'Reports',
	        url: '/reports'
	      }, {
	        title: 'Communication',
	        subMenu: [{
	          title: 'Mails',
	          url: '/mail/draft/list'
	        }, {
	          title: 'E-Forms',
	          url: '/e-form/list'
	        }]
	      }, {
	        title: 'Admin',
	        adminOnly: true,
	        subMenu: [{
	          title: 'Management Company',
	          url: '/admin/client/edit'
	        }, {
	          title: 'User Management',
	          url: '/admin/users'
	        }, {
	          separator: true
	        }, {
	          title: 'Work Order Codes',
	          url: '/workorder/code/list'
	        }, {
	          title: 'Violation Codes',
	          url: '/violation/code/list'
	        }, {
	          title: 'Letter Templates',
	          url: '/template/list'
	        }]
	      }];
	
	      _this.publicMenu = [];
	
	      SettingsService.getByName({ name: 'client' }, function (clientData) {
	        _this.communityEnum = [{
	          name: clientData.data.name,
	          group: "Management",
	          value: ""
	        }];
	
	        if (clientData.data.eVotingEnabled) {
	          _this.menu[1].subMenu.push({
	            title: "Voter Groups",
	            url: "/voter-group/list"
	          });
	        }
	
	        if (clientData.data.customPortfolio) {
	          _this.menu[1].subMenu.push({ separator: true });
	
	          clientData.data.customPortfolio.forEach(function (custom) {
	            _this.menu[1].subMenu.push({
	              title: custom.title,
	              url: custom.url
	            });
	          });
	        }
	
	        if (clientData.data.quickbooksEnabled) {
	          _this.quickbooksEnabled = true;
	          _this.menu.splice(5, 0, {
	            title: 'QB Balances',
	            url: '/admin/list/quickbooks-overview'
	          });
	        }
	
	        if (clientData.data.paymentsEnabled) {
	          _this.paymentsEnabled = true;
	          _this.menu.splice(5, 0, {
	            title: 'Payments',
	            url: '/payments'
	          });
	        }
	
	        if (clientData.data.customViews) {
	          var customViewEntries = [];
	          clientData.data.customViews.forEach(function (custom) {
	            customViewEntries.push({
	              title: custom.title,
	              url: custom.url
	            });
	          });
	          _this.menu.splice(2, 0, {
	            title: 'Views',
	            subMenu: customViewEntries
	          });
	        }
	
	        _this.busy = false;
	      });
	    });
	  }
	
	  _createClass(NavbarComponent, [{
	    key: '$doCheck',
	    value: function $doCheck() {
	      var _this2 = this;
	
	      this.isWebAccessMatter = this.$state.current.name == 'webaccess-reset-password';
	
	      if (!this.communities.length && !this.busy && this.Auth.isLoggedInSync()) {
	        this.busy = true;
	        this.CommunityService.query(function (communities) {
	          _this2.communities = communities;
	          communities.forEach(function (community) {
	            _this2.communityEnum.push({
	              name: community.name,
	              value: community.code,
	              group: "Associations"
	            });
	          });
	
	          _this2.busy = false;
	          _this2.communityChanged();
	        });
	      }
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(routePart) {
	      return this.$location.path().indexOf(routePart) !== -1;
	    }
	  }, {
	    key: 'communityChanged',
	    value: function communityChanged() {
	      var _this3 = this;
	
	      var cmty = this.communityEnum.find(function (cmty) {
	        return cmty.value == _this3.ViewSelection.selectedCommunityCode;
	      });
	      this.ViewSelection.selectedCommunity = cmty;
	    }
	  }, {
	    key: 'search',
	    value: function search(form) {
	      this.searchSubmitted = true;
	
	      if (form.$valid) {
	        this.searchSubmitted = false;
	        this.$state.go('search-result', { searchterm: this.searchterm });
	      }
	    }
	  }]);
	
	  return NavbarComponent;
	}();
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	  template: __webpack_require__(189),
	  controller: NavbarComponent
	}).name;

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"navbar yamm navbar-default navbar-static-top\" ng-hide=\"$ctrl.isActive('app-reset-password') || $ctrl.isWebAccessMatter\">\r\n  <div class=\"container-fluid\">\r\n    <div class=\"navbar-header\">\r\n      <button class=\"navbar-toggle\" type=\"button\" ng-click=\"$ctrl.isCollapsed = !$ctrl.isCollapsed\">\r\n        <span class=\"sr-only\">Toggle navigation</span>\r\n        <span class=\"icon-bar\"></span>\r\n        <span class=\"icon-bar\"></span>\r\n        <span class=\"icon-bar\"></span>\r\n      </button>\r\n      <a ng-hide=\"$ctrl.isLoggedIn()\" href=\"/\" class=\"navbar-brand\"><i class=\"fa fa-fw fa-line-chart\"></i>&nbsp;<b>CONDUU</b> Management Suite</a>\r\n      <a ng-show=\"$ctrl.isLoggedIn()\" href=\"/home\" class=\"navbar-brand\"><i class=\"fa fa-fw fa-home\"></i></a>\r\n    </div>\r\n    <div uib-collapse=\"$ctrl.isCollapsed\" class=\"navbar-collapse collapse\" id=\"navbar-main\">\r\n      <!-- Community Selector -->\r\n      <form name=\"communityform\" ng-show=\"$ctrl.isLoggedIn()\" class=\"navbar-form navbar-left\" style=\"padding-left:0; padding-right:0\">\r\n        <div class=\"input-group\">\r\n          <select class=\"form-control\" style=\"max-width:200px\" ng-options=\"o.value as o.name group by o.group for o in $ctrl.communityEnum\" ng-model=\"$ctrl.ViewSelection.selectedCommunityCode\"\r\n                  ng-change=\"$ctrl.communityChanged()\"></select>\r\n        </div>\r\n      </form>\r\n\r\n      <ul class=\"nav navbar-nav\">\r\n\r\n        <li ng-hide=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\" ng-repeat=\"menuEntry in $ctrl.publicMenu\">\r\n          <a ng-href=\"{{menuEntry.url}}\">{{menuEntry.title}}</a>\r\n        </li>\r\n\r\n        <li ng-if=\"$ctrl.isLoggedIn()\" class=\"dropdown\" ng-repeat=\"menuEntry in $ctrl.menu\" uib-dropdown=\"\">\r\n\r\n          <a ng-if=\"!menuEntry.subMenu && menuEntry.url && (!menuEntry.adminOnly || (menuEntry.adminOnly && $ctrl.isAdmin()))\"\r\n             ng-href=\"{{menuEntry.url}}\" class=\"navbar-button text-center\" role=\"button\">{{menuEntry.title}}</a>\r\n\r\n          <a ng-if=\"menuEntry.subMenu && (!menuEntry.adminOnly || (menuEntry.adminOnly && $ctrl.isAdmin()))\"\r\n             href=\"#\" class=\"dropdown-toggle navbar-button text-center\" data-toggle=\"dropdown\" uib-dropdown-toggle=\"\"\r\n             role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">{{menuEntry.title}} <span class=\"caret\"></span></a>\r\n\r\n          <ul ng-if=\"menuEntry.subMenu\" class=\"dropdown-menu\" uib-dropdown-menu=\"\">\r\n            <li ng-repeat-start=\"subMenuEntry in menuEntry.subMenu\" ng-hide=\"subMenuEntry.separator\">\r\n              <a ng-hide=\"subMenuEntry.download\" ng-if=\"!subMenuEntry.adminOnly || (subMenuEntry.adminOnly && $ctrl.isAdmin())\"\r\n                 ng-href=\"{{subMenuEntry.url}}\"><i ng-if=\"subMenuEntry.icon\" class=\"fa fa-fw fa-{{subMenuEntry.icon}}\"></i> {{subMenuEntry.title}}</a>\r\n              <a ng-if=\"subMenuEntry.download\"\r\n                 ng-href=\"{{subMenuEntry.url}}\" target=\"_blank\"><i class=\"fa fa-fw fa-download\"></i> {{subMenuEntry.title}}</a>\r\n            </li>\r\n            <li ng-repeat-end=\"\" ng-show=\"subMenuEntry.separator\" role=\"separator\" class=\"divider\"></li>\r\n          </ul>\r\n        </li>\r\n\r\n      </ul>\r\n\r\n      <ul class=\"nav navbar-nav navbar-right\">\r\n        <li ui-sref-active=\"active\"></li>\r\n\r\n        <!-- Most Recent -->\r\n        <li ng-if=\"$ctrl.isLoggedIn()\" class=\"dropdown yamm-fw\" uib-dropdown=\"\">\r\n          <a href=\"#\" class=\"dropdown-toggle navbar-button\" data-toggle=\"dropdown\" uib-dropdown-toggle=\"\" role=\"button\" aria-haspopup=\"true\"\r\n             aria-expanded=\"false\"><i class=\"fa fa-fw fa-history\"></i> <span class=\"caret\"></span></a>\r\n          <ul class=\"dropdown-menu\" uib-dropdown-menu=\"\">\r\n            <li>\r\n              <div class=\"yamm-content\">\r\n                <div class=\"row\">\r\n                  <ul class=\"col-sm-5 list-unstyled\">\r\n                    <li>\r\n                      <p><strong>Portfolio</strong></p>\r\n                    </li>\r\n                    <li><p><i class=\"fa fa-fw fa-history\"></i> Recently Viewed</p></li>\r\n                    <ul style=\"margin: 0 0 10px\">\r\n                      <li ng-repeat=\"recent in $ctrl.RecentVisits.portfolio\"><a ng-href=\"{{recent.path}}\">{{recent.name}}</a></li>\r\n                    </ul>\r\n                    <li><p><i class=\"fa fa-fw fa-map-pin\"></i> Pinned</p></li>\r\n                    <ul>\r\n                      <li ng-repeat=\"pinned in $ctrl.PinnedItems.portfolio\"><a ng-href=\"{{pinned.path}}\">{{pinned.name}}</a></li>\r\n                    </ul>\r\n                  </ul>\r\n                  <ul class=\"col-sm-4 list-unstyled\">\r\n                    <li>\r\n                      <p><strong>Work Items</strong></p>\r\n                    </li>\r\n                    <li><p><i class=\"fa fa-fw fa-history\"></i> Recently Viewed</p></li>\r\n                    <ul style=\"margin: 0 0 10px\">\r\n                      <li ng-repeat=\"recent in $ctrl.RecentVisits.workItems\"><a ng-href=\"{{recent.path}}\">{{recent.name}}</a></li>\r\n                    </ul>\r\n                    <li><p><i class=\"fa fa-fw fa-map-pin\"></i> Pinned</p></li>\r\n                    <ul>\r\n                      <li ng-repeat=\"pinned in $ctrl.PinnedItems.workItems\"><a ng-href=\"{{pinned.path}}\">{{pinned.name}}</a></li>\r\n                    </ul>\r\n                  </ul>\r\n                  <ul class=\"col-sm-3 list-unstyled\">\r\n                    <li>\r\n                      <p><strong>Projects</strong></p>\r\n                    </li>\r\n                    <li><p><i class=\"fa fa-fw fa-history\"></i> Recently Viewed</p></li>\r\n                    <ul style=\"margin: 0 0 10px\">\r\n                      <li ng-repeat=\"recent in $ctrl.RecentVisits.projects\"><a ng-href=\"{{recent.path}}\">{{recent.name}}</a></li>\r\n                    </ul>\r\n                    <li><p><i class=\"fa fa-fw fa-map-pin\"></i> Pinned</p></li>\r\n                    <ul>\r\n                      <li ng-repeat=\"pinned in $ctrl.PinnedItems.projects\"><a ng-href=\"{{pinned.path}}\">{{pinned.name}}</a></li>\r\n                    </ul>\r\n                  </ul>\r\n                </div>\r\n              </div>\r\n            </li>\r\n          </ul>\r\n        </li>\r\n\r\n        <!-- Super Admin Menu -->\r\n        <li ng-if=\"$ctrl.isLoggedIn() && $ctrl.isSuperAdmin()\" class=\"dropdown\" uib-dropdown=\"\">\r\n          <a href=\"#\" class=\"dropdown-toggle navbar-button\" data-toggle=\"dropdown\" uib-dropdown-toggle=\"\" role=\"button\" aria-haspopup=\"true\"\r\n             aria-expanded=\"false\"><i class=\"fa fa-fw fa-cogs\"></i> <span class=\"caret\"></span></a>\r\n          <ul class=\"dropdown-menu\" uib-dropdown-menu=\"\">\r\n            <li><a ui-sref=\"settings-list\">Settings</a></li>\r\n            <li><a ui-sref=\"ldap-db\">LDAP DB</a></li>\r\n            <li ng-if=\"$ctrl.quickbooksEnabled\"><a ui-sref=\"quickbooks-import\">Quickbooks Import</a></li>\r\n          </ul>\r\n        </li>\r\n\r\n        <!-- User Menu -->\r\n        <li ng-show=\"$ctrl.isLoggedIn()\" class=\"dropdown\" uib-dropdown=\"\">\r\n          <a href=\"#\" class=\"dropdown-toggle navbar-button\" data-toggle=\"dropdown\" uib-dropdown-toggle=\"\" role=\"button\" aria-haspopup=\"true\"\r\n             aria-expanded=\"false\"><i class=\"fa fa-fw fa-user\"></i><span class=\"caret\"></span></a>\r\n          <ul class=\"dropdown-menu\" uib-dropdown-menu=\"\">\r\n            <li><a ui-sref=\"profile\">Profile</a></li>\r\n            <li><a ui-sref=\"change-password\">Change Password</a></li>\r\n            <li><a ui-sref=\"logout\">Logout</a></li>\r\n          </ul>\r\n        </li>\r\n      </ul>\r\n\r\n      <!-- Accounting Period Selector -->\r\n      <!--\r\n      <form name=\"communityform\" ng-show=\"$ctrl.isLoggedIn()\" class=\"navbar-form navbar-left\" style=\"padding-left:0\">\r\n        <div class=\"input-group\">\r\n          <span class=\"input-group-addon\"><i class=\"fa fa-fw fa-calendar\"></i></span>\r\n          <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.periodEnum\" ng-model=\"$ctrl.selectedPeriod\"\r\n                  ng-change=\"$ctrl.periodChanged()\"></select>\r\n        </div>\r\n      </form>\r\n      -->\r\n\r\n      <!-- Searchbar -->\r\n      <form name=\"searchform\" ng-show=\"$ctrl.isLoggedIn()\" ng-submit=\"$ctrl.search(searchform)\"\r\n            class=\"navbar-form navbar-right\" role=\"search\" style=\"padding-right:0\">\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': searchform.searchterm.$valid && $ctrl.searchSubmitted,\r\n                                            'has-error': searchform.searchterm.$invalid && $ctrl.searchSubmitted }\">\r\n          <div class=\"input-group\">\r\n            <input name=\"searchterm\" ng-model=\"$ctrl.searchterm\" type=\"text\" class=\"form-control\"\r\n                   placeholder=\"Search\" ng-minlength=\"3\" style=\"width:160px\" required />\r\n            <span class=\"input-group-btn\">\r\n            <button type=\"submit\" class=\"btn btn-default\"><i class=\"fa fa-fw fa-search\"></i></button>\r\n          </span>\r\n          </div>\r\n        </div>\r\n      </form>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterComponent = exports.FooterComponent = function () {
	  FooterComponent.$inject = ['$state'];
	  function FooterComponent($state) {
	    'ngInject';
	
	    _classCallCheck(this, FooterComponent);
	
	    this.$state = $state;
	    this.isFrontpage = false;
	    this.year = new Date().getFullYear();
	  }
	
	  _createClass(FooterComponent, [{
	    key: '$doCheck',
	    value: function $doCheck() {
	      this.isFrontpage = this.$state.current.name == 'main';
	
	      if (this.isFrontpage) jQuery("body").addClass("frontpage-footer-background");else jQuery("body").removeClass("frontpage-footer-background");
	    }
	  }]);
	
	  return FooterComponent;
	}();
	
	exports.default = _angular2.default.module('directives.footer', []).component('footer', {
	  template: __webpack_require__(191),
	  controller: FooterComponent
	}).name;

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container text-center\" style=\"padding-bottom:12px\">\r\n  <hr ng-hide=\"$ctrl.isFrontpage\" />\r\n  <a class=\"hidden-xs\" href=\"http://www.conduu.com\" target=\"_blank\"><img src=\"assets/images/conduu-logo-full.png\" style=\"height:45px; float:left\" /></a>\r\n  <a class=\"visible-xs\" href=\"http://www.conduu.com\" target=\"_blank\"><img src=\"assets/images/conduu-logo-without.png\" style=\"height:45px; float:left\" /></a>\r\n  <a class=\"hidden-xs\" href=\"http://www.international-business-apps.com\" target=\"_blank\"><img src=\"assets/images/iba-logo-final.png\" style=\"height:45px; float:right\" /></a>\r\n  <p class=\"text-muted\"><i class=\"fa fa-copyright\"></i> {{$ctrl.year}} IBA Technology Consultants, LLC<br/>\r\n    <small>\r\n      <i class=\"fa fa-fw fa-facebook\"></i> <a href=\"https://www.facebook.com/conduu\" target=\"_blank\">Find us on Facebook</a>\r\n      <i class=\"fa fa-fw fa-envelope\"></i> <a href=\"mailto:info@conduu.com\">info@conduu.com</a>\r\n    </small>\r\n  </p>\r\n</div>\r\n"

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(14);
	
	exports.default = angular.module('directives.mongooseError', []).directive('mongooseError', function () {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      element.on('keydown', function () {
	        return ngModel.$setValidity('mongoose', true);
	      });
	    }
	  };
	}).name;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(28);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _main = __webpack_require__(194);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainController = exports.MainController = function () {
	  MainController.$inject = ['Auth', '$state', 'SettingsService', 'PermPermissionStore', 'Idle', '$analytics'];
	  function MainController(Auth, $state, SettingsService, PermPermissionStore, Idle, $analytics) {
	    'ngInject';
	
	    _classCallCheck(this, MainController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {
	      login: undefined
	    };
	    this.submitted = false;
	    this.$state = $state;
	    this.Auth = Auth;
	    this.Idle = Idle;
	    this.PermPermissionStore = PermPermissionStore;
	    this.$analytics = $analytics;
	
	    this.name = "";
	  }
	
	  _createClass(MainController, [{
	    key: 'login',
	    value: function login(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.login({
	          email: this.user.email.toLowerCase(),
	          password: this.user.password
	        }).then(function () {
	
	          if (_this.$analytics) {
	            _this.$analytics.setUsername(_this.user.email);
	          }
	
	          _this.Idle.watch();
	
	          _this.$state.go('home');
	        }).catch(function (err) {
	          _this.errors.login = err.message;
	        });
	      }
	    }
	  }]);
	
	  return MainController;
	}();
	
	exports.default = _angular2.default.module('conduu.main', [_angularUiRouter2.default]).config(_main2.default).component('main', {
	  template: __webpack_require__(195),
	  controller: MainController,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('main', {
	    url: '/',
	    template: '<main></main>'
	  });
	}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"frontpage\">\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n\r\n      <div class=\"card card-container sketchy\">\r\n        <img id=\"profile-img\" style=\"margin: 0 auto 10px;display: block; width:100%; max-width:320px\" src=\"/assets/images/conduu-logo-full.png\" />\r\n        <!--<p id=\"profile-name\" class=\"profile-name-card\" style=\"letter-spacing: 4px\">Management Suite</p>-->\r\n        <br/>\r\n        <form class=\"form-signin\" name=\"form\" ng-submit=\"ctrl.login(form)\">\r\n          <input type=\"email\" id=\"inputEmail\" class=\"form-control\" placeholder=\"Email address\" ng-model=\"ctrl.user.email\" required autofocus>\r\n          <input type=\"password\" id=\"inputPassword\" class=\"form-control\" placeholder=\"Password\" ng-model=\"ctrl.user.password\" required>\r\n          <button class=\"btn btn-primary btn-block\" type=\"submit\">Sign in</button>\r\n        </form>\r\n        <a href=\"/forgot-password\" class=\"forgot-password\">\r\n          Forgot the password?\r\n        </a>\r\n      </div>\r\n\r\n      <div class=\"alert alert-danger card card-container sketchy\" role=\"alert\" ng-show=\"(form.email.$error.required && form.password.$error.required && ctrl.submitted) || (form.email.$error.email && ctrl.submitted) || ctrl.errors.login\">\r\n        <i class=\"fa fa-fw fa-exclamation-triangle fa-3x\" style=\"float:left\"></i>\r\n        <strong>Sign In Failure</strong>\r\n\r\n        <p style=\"margin-top: 0px\" ng-show=\"form.email.$error.required && form.password.$error.required && ctrl.submitted\">\r\n          Please enter your email and password.\r\n        </p>\r\n        <p style=\"margin-top: 0px\" ng-show=\"form.email.$error.email && ctrl.submitted\">\r\n          Please enter a valid email.\r\n        </p>\r\n\r\n        <p style=\"margin-top: 0px\" ng-show=\"ctrl.errors.login\">{{ ctrl.errors.login }}</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Socket.$inject = ['socketFactory'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(197);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _socket = __webpack_require__(198);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function Socket(socketFactory) {
	  'ngInject';
	
	  var ioSocket = (0, _socket2.default)('', {
	    path: '/socket.io-client'
	  });
	
	  var socket = socketFactory({
	    ioSocket: ioSocket
	  });
	
	  return {
	    socket: socket,
	
	    syncUpdates: function syncUpdates(modelName, array, cb) {
	      cb = cb || _angular2.default.noop;
	
	      socket.on(modelName + ':save', function (item) {
	        var oldItem = _.find(array, {
	          _id: item._id
	        });
	        var index = array.indexOf(oldItem);
	        var event = 'created';
	
	        if (oldItem) {
	          array.splice(index, 1, item);
	          event = 'updated';
	        } else {
	          array.push(item);
	        }
	
	        cb(event, item, array);
	      });
	
	      socket.on(modelName + ':remove', function (item) {
	        var event = 'deleted';
	        _.remove(array, {
	          _id: item._id
	        });
	        cb(event, item, array);
	      });
	    },
	    unsyncUpdates: function unsyncUpdates(modelName) {
	      socket.removeAllListeners(modelName + ':save');
	      socket.removeAllListeners(modelName + ':remove');
	    }
	  };
	}
	
	exports.default = _angular2.default.module('conduu.socket', []).factory('socket', Socket).name;

/***/ }),
/* 197 */,
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(199);
	var parser = __webpack_require__(205);
	var Manager = __webpack_require__(215);
	var debug = __webpack_require__(201)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  } else if (opts && 'object' === typeof opts.query) {
	    opts.query = encodeQueryString(opts.query);
	  }
	  return io.socket(parsed.path, opts);
	}
	/**
	 *  Helper method to parse query objects to string.
	 * @param {object} query
	 * @returns {string}
	 */
	function encodeQueryString (obj) {
	  var str = [];
	  for (var p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	    }
	  }
	  return str.join('&');
	}
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(215);
	exports.Socket = __webpack_require__(246);


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(200);
	var debug = __webpack_require__(201)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || global.location;
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    return uri;
	};


/***/ }),
/* 201 */
[1138, 203],
/* 202 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 203 */
[1139, 204],
/* 204 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(206)('socket.io-parser');
	var json = __webpack_require__(209);
	var Emitter = __webpack_require__(211);
	var binary = __webpack_require__(212);
	var isBuf = __webpack_require__(214);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    encodeAsBinary(obj, callback);
	  }
	  else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	  var str = '';
	  var nsp = false;
	
	  // first is type
	  str += obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    str += obj.attachments;
	    str += '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' != obj.nsp) {
	    nsp = true;
	    str += obj.nsp;
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    if (nsp) {
	      str += ',';
	      nsp = false;
	    }
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    if (nsp) str += ',';
	    str += json.stringify(obj.data);
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an ecoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if ('string' == typeof obj) {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  }
	  else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  }
	  else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var p = {};
	  var i = 0;
	
	  // look up type
	  p.type = Number(str.charAt(0));
	  if (null == exports.types[p.type]) return error();
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
	    var buf = '';
	    while (str.charAt(++i) != '-') {
	      buf += str.charAt(i);
	      if (i == str.length) break;
	    }
	    if (buf != Number(buf) || str.charAt(i) != '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' == str.charAt(i + 1)) {
	    p.nsp = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' == c) break;
	      p.nsp += c;
	      if (i == str.length) break;
	    }
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    p.id = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      p.id += str.charAt(i);
	      if (i == str.length) break;
	    }
	    p.id = Number(p.id);
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    p = tryParse(p, str.substr(i));
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(p, str) {
	  try {
	    p.data = json.parse(str);
	  } catch(e){
	    return error();
	  }
	  return p; 
	};
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error(data){
	  return {
	    type: exports.ERROR,
	    data: 'parser error'
	  };
	}


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(207);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(208);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	;(function () {
	  // Detect the `define` function exposed by asynchronous module loaders. The
	  // strict `define` check is necessary for compatibility with `r.js`.
	  var isLoader = "function" === "function" && __webpack_require__(210);
	
	  // A set of types used to distinguish objects from primitives.
	  var objectTypes = {
	    "function": true,
	    "object": true
	  };
	
	  // Detect the `exports` object exposed by CommonJS implementations.
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  // Use the `global` object exposed by Node (including Browserify via
	  // `insert-module-globals`), Narwhal, and Ringo as the default context,
	  // and the `window` object in browsers. Rhino exports a `global` function
	  // instead.
	  var root = objectTypes[typeof window] && window || this,
	      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;
	
	  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  // Public: Initializes JSON 3 using the given `context` object, attaching the
	  // `stringify` and `parse` functions to the specified `exports` object.
	  function runInContext(context, exports) {
	    context || (context = root["Object"]());
	    exports || (exports = root["Object"]());
	
	    // Native constructor aliases.
	    var Number = context["Number"] || root["Number"],
	        String = context["String"] || root["String"],
	        Object = context["Object"] || root["Object"],
	        Date = context["Date"] || root["Date"],
	        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
	        TypeError = context["TypeError"] || root["TypeError"],
	        Math = context["Math"] || root["Math"],
	        nativeJSON = context["JSON"] || root["JSON"];
	
	    // Delegate to the native `stringify` and `parse` implementations.
	    if (typeof nativeJSON == "object" && nativeJSON) {
	      exports.stringify = nativeJSON.stringify;
	      exports.parse = nativeJSON.parse;
	    }
	
	    // Convenience aliases.
	    var objectProto = Object.prototype,
	        getClass = objectProto.toString,
	        isProperty, forEach, undef;
	
	    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
	    var isExtended = new Date(-3509827334573292);
	    try {
	      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
	      // results for certain dates in Opera >= 10.53.
	      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
	        // Safari < 2.0.2 stores the internal millisecond time value correctly,
	        // but clips the values returned by the date methods to the range of
	        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
	        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
	    } catch (exception) {}
	
	    // Internal: Determines whether the native `JSON.stringify` and `parse`
	    // implementations are spec-compliant. Based on work by Ken Snyder.
	    function has(name) {
	      if (has[name] !== undef) {
	        // Return cached feature test result.
	        return has[name];
	      }
	      var isSupported;
	      if (name == "bug-string-char-index") {
	        // IE <= 7 doesn't support accessing string characters using square
	        // bracket notation. IE 8 only supports this for primitives.
	        isSupported = "a"[0] != "a";
	      } else if (name == "json") {
	        // Indicates whether both `JSON.stringify` and `JSON.parse` are
	        // supported.
	        isSupported = has("json-stringify") && has("json-parse");
	      } else {
	        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
	        // Test `JSON.stringify`.
	        if (name == "json-stringify") {
	          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
	          if (stringifySupported) {
	            // A test function object with a custom `toJSON` method.
	            (value = function () {
	              return 1;
	            }).toJSON = value;
	            try {
	              stringifySupported =
	                // Firefox 3.1b1 and b2 serialize string, number, and boolean
	                // primitives as object literals.
	                stringify(0) === "0" &&
	                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
	                // literals.
	                stringify(new Number()) === "0" &&
	                stringify(new String()) == '""' &&
	                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
	                // does not define a canonical JSON representation (this applies to
	                // objects with `toJSON` properties as well, *unless* they are nested
	                // within an object or array).
	                stringify(getClass) === undef &&
	                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
	                // FF 3.1b3 pass this test.
	                stringify(undef) === undef &&
	                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
	                // respectively, if the value is omitted entirely.
	                stringify() === undef &&
	                // FF 3.1b1, 2 throw an error if the given value is not a number,
	                // string, array, object, Boolean, or `null` literal. This applies to
	                // objects with custom `toJSON` methods as well, unless they are nested
	                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
	                // methods entirely.
	                stringify(value) === "1" &&
	                stringify([value]) == "[1]" &&
	                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
	                // `"[null]"`.
	                stringify([undef]) == "[null]" &&
	                // YUI 3.0.0b1 fails to serialize `null` literals.
	                stringify(null) == "null" &&
	                // FF 3.1b1, 2 halts serialization if an array contains a function:
	                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
	                // elides non-JSON values from objects and arrays, unless they
	                // define custom `toJSON` methods.
	                stringify([undef, getClass, null]) == "[null,null,null]" &&
	                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
	                // where character escape codes are expected (e.g., `\b` => `\u0008`).
	                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
	                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
	                stringify(null, value) === "1" &&
	                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
	                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
	                // serialize extended years.
	                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
	                // The milliseconds are optional in ES 5, but required in 5.1.
	                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
	                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
	                // four-digit years instead of six-digit years. Credits: @Yaffle.
	                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
	                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
	                // values less than 1000. Credits: @Yaffle.
	                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
	            } catch (exception) {
	              stringifySupported = false;
	            }
	          }
	          isSupported = stringifySupported;
	        }
	        // Test `JSON.parse`.
	        if (name == "json-parse") {
	          var parse = exports.parse;
	          if (typeof parse == "function") {
	            try {
	              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
	              // Conforming implementations should also coerce the initial argument to
	              // a string prior to parsing.
	              if (parse("0") === 0 && !parse(false)) {
	                // Simple parsing test.
	                value = parse(serialized);
	                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
	                if (parseSupported) {
	                  try {
	                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
	                    parseSupported = !parse('"\t"');
	                  } catch (exception) {}
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
	                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
	                      // certain octal literals.
	                      parseSupported = parse("01") !== 1;
	                    } catch (exception) {}
	                  }
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
	                      // points. These environments, along with FF 3.1b1 and 2,
	                      // also allow trailing commas in JSON objects and arrays.
	                      parseSupported = parse("1.") !== 1;
	                    } catch (exception) {}
	                  }
	                }
	              }
	            } catch (exception) {
	              parseSupported = false;
	            }
	          }
	          isSupported = parseSupported;
	        }
	      }
	      return has[name] = !!isSupported;
	    }
	
	    if (!has("json")) {
	      // Common `[[Class]]` name aliases.
	      var functionClass = "[object Function]",
	          dateClass = "[object Date]",
	          numberClass = "[object Number]",
	          stringClass = "[object String]",
	          arrayClass = "[object Array]",
	          booleanClass = "[object Boolean]";
	
	      // Detect incomplete support for accessing string characters by index.
	      var charIndexBuggy = has("bug-string-char-index");
	
	      // Define additional utility methods if the `Date` methods are buggy.
	      if (!isExtended) {
	        var floor = Math.floor;
	        // A mapping between the months of the year and the number of days between
	        // January 1st and the first of the respective month.
	        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
	        // Internal: Calculates the number of days between the Unix epoch and the
	        // first day of the given month.
	        var getDay = function (year, month) {
	          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
	        };
	      }
	
	      // Internal: Determines if a property is a direct property of the given
	      // object. Delegates to the native `Object#hasOwnProperty` method.
	      if (!(isProperty = objectProto.hasOwnProperty)) {
	        isProperty = function (property) {
	          var members = {}, constructor;
	          if ((members.__proto__ = null, members.__proto__ = {
	            // The *proto* property cannot be set multiple times in recent
	            // versions of Firefox and SeaMonkey.
	            "toString": 1
	          }, members).toString != getClass) {
	            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
	            // supports the mutable *proto* property.
	            isProperty = function (property) {
	              // Capture and break the object's prototype chain (see section 8.6.2
	              // of the ES 5.1 spec). The parenthesized expression prevents an
	              // unsafe transformation by the Closure Compiler.
	              var original = this.__proto__, result = property in (this.__proto__ = null, this);
	              // Restore the original prototype chain.
	              this.__proto__ = original;
	              return result;
	            };
	          } else {
	            // Capture a reference to the top-level `Object` constructor.
	            constructor = members.constructor;
	            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
	            // other environments.
	            isProperty = function (property) {
	              var parent = (this.constructor || constructor).prototype;
	              return property in this && !(property in parent && this[property] === parent[property]);
	            };
	          }
	          members = null;
	          return isProperty.call(this, property);
	        };
	      }
	
	      // Internal: Normalizes the `for...in` iteration algorithm across
	      // environments. Each enumerated key is yielded to a `callback` function.
	      forEach = function (object, callback) {
	        var size = 0, Properties, members, property;
	
	        // Tests for bugs in the current environment's `for...in` algorithm. The
	        // `valueOf` property inherits the non-enumerable flag from
	        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
	        (Properties = function () {
	          this.valueOf = 0;
	        }).prototype.valueOf = 0;
	
	        // Iterate over a new instance of the `Properties` class.
	        members = new Properties();
	        for (property in members) {
	          // Ignore all properties inherited from `Object.prototype`.
	          if (isProperty.call(members, property)) {
	            size++;
	          }
	        }
	        Properties = members = null;
	
	        // Normalize the iteration algorithm.
	        if (!size) {
	          // A list of non-enumerable properties inherited from `Object.prototype`.
	          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
	          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
	          // properties.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, length;
	            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
	            for (property in object) {
	              // Gecko <= 1.0 enumerates the `prototype` property of functions under
	              // certain conditions; IE does not.
	              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for each non-enumerable property.
	            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
	          };
	        } else if (size == 2) {
	          // Safari <= 2.0.4 enumerates shadowed properties twice.
	          forEach = function (object, callback) {
	            // Create a set of iterated properties.
	            var members = {}, isFunction = getClass.call(object) == functionClass, property;
	            for (property in object) {
	              // Store each property name to prevent double enumeration. The
	              // `prototype` property of functions is not enumerated due to cross-
	              // environment inconsistencies.
	              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	          };
	        } else {
	          // No bugs detected; use the standard `for...in` algorithm.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
	            for (property in object) {
	              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for the `constructor` property due to
	            // cross-environment inconsistencies.
	            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
	              callback(property);
	            }
	          };
	        }
	        return forEach(object, callback);
	      };
	
	      // Public: Serializes a JavaScript `value` as a JSON string. The optional
	      // `filter` argument may specify either a function that alters how object and
	      // array members are serialized, or an array of strings and numbers that
	      // indicates which properties should be serialized. The optional `width`
	      // argument may be either a string or number that specifies the indentation
	      // level of the output.
	      if (!has("json-stringify")) {
	        // Internal: A map of control characters and their escaped equivalents.
	        var Escapes = {
	          92: "\\\\",
	          34: '\\"',
	          8: "\\b",
	          12: "\\f",
	          10: "\\n",
	          13: "\\r",
	          9: "\\t"
	        };
	
	        // Internal: Converts `value` into a zero-padded string such that its
	        // length is at least equal to `width`. The `width` must be <= 6.
	        var leadingZeroes = "000000";
	        var toPaddedString = function (width, value) {
	          // The `|| 0` expression is necessary to work around a bug in
	          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
	          return (leadingZeroes + (value || 0)).slice(-width);
	        };
	
	        // Internal: Double-quotes a string `value`, replacing all ASCII control
	        // characters (characters with code unit values between 0 and 31) with
	        // their escaped equivalents. This is an implementation of the
	        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
	        var unicodePrefix = "\\u00";
	        var quote = function (value) {
	          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
	          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
	          for (; index < length; index++) {
	            var charCode = value.charCodeAt(index);
	            // If the character is a control character, append its Unicode or
	            // shorthand escape sequence; otherwise, append the character as-is.
	            switch (charCode) {
	              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
	                result += Escapes[charCode];
	                break;
	              default:
	                if (charCode < 32) {
	                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
	                  break;
	                }
	                result += useCharIndex ? symbols[index] : value.charAt(index);
	            }
	          }
	          return result + '"';
	        };
	
	        // Internal: Recursively serializes an object. Implements the
	        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
	        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
	          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
	          try {
	            // Necessary for host object support.
	            value = object[property];
	          } catch (exception) {}
	          if (typeof value == "object" && value) {
	            className = getClass.call(value);
	            if (className == dateClass && !isProperty.call(value, "toJSON")) {
	              if (value > -1 / 0 && value < 1 / 0) {
	                // Dates are serialized according to the `Date#toJSON` method
	                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
	                // for the ISO 8601 date time string format.
	                if (getDay) {
	                  // Manually compute the year, month, date, hours, minutes,
	                  // seconds, and milliseconds if the `getUTC*` methods are
	                  // buggy. Adapted from @Yaffle's `date-shim` project.
	                  date = floor(value / 864e5);
	                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
	                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
	                  date = 1 + date - getDay(year, month);
	                  // The `time` value specifies the time within the day (see ES
	                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
	                  // to compute `A modulo B`, as the `%` operator does not
	                  // correspond to the `modulo` operation for negative numbers.
	                  time = (value % 864e5 + 864e5) % 864e5;
	                  // The hours, minutes, seconds, and milliseconds are obtained by
	                  // decomposing the time within the day. See section 15.9.1.10.
	                  hours = floor(time / 36e5) % 24;
	                  minutes = floor(time / 6e4) % 60;
	                  seconds = floor(time / 1e3) % 60;
	                  milliseconds = time % 1e3;
	                } else {
	                  year = value.getUTCFullYear();
	                  month = value.getUTCMonth();
	                  date = value.getUTCDate();
	                  hours = value.getUTCHours();
	                  minutes = value.getUTCMinutes();
	                  seconds = value.getUTCSeconds();
	                  milliseconds = value.getUTCMilliseconds();
	                }
	                // Serialize extended years correctly.
	                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
	                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
	                  // Months, dates, hours, minutes, and seconds should have two
	                  // digits; milliseconds should have three.
	                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
	                  // Milliseconds are optional in ES 5.0, but required in 5.1.
	                  "." + toPaddedString(3, milliseconds) + "Z";
	              } else {
	                value = null;
	              }
	            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
	              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
	              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
	              // ignores all `toJSON` methods on these objects unless they are
	              // defined directly on an instance.
	              value = value.toJSON(property);
	            }
	          }
	          if (callback) {
	            // If a replacement function was provided, call it to obtain the value
	            // for serialization.
	            value = callback.call(object, property, value);
	          }
	          if (value === null) {
	            return "null";
	          }
	          className = getClass.call(value);
	          if (className == booleanClass) {
	            // Booleans are represented literally.
	            return "" + value;
	          } else if (className == numberClass) {
	            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
	            // `"null"`.
	            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
	          } else if (className == stringClass) {
	            // Strings are double-quoted and escaped.
	            return quote("" + value);
	          }
	          // Recursively serialize objects and arrays.
	          if (typeof value == "object") {
	            // Check for cyclic structures. This is a linear search; performance
	            // is inversely proportional to the number of unique nested objects.
	            for (length = stack.length; length--;) {
	              if (stack[length] === value) {
	                // Cyclic structures cannot be serialized by `JSON.stringify`.
	                throw TypeError();
	              }
	            }
	            // Add the object to the stack of traversed objects.
	            stack.push(value);
	            results = [];
	            // Save the current indentation level and indent one additional level.
	            prefix = indentation;
	            indentation += whitespace;
	            if (className == arrayClass) {
	              // Recursively serialize array elements.
	              for (index = 0, length = value.length; index < length; index++) {
	                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
	                results.push(element === undef ? "null" : element);
	              }
	              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
	            } else {
	              // Recursively serialize object members. Members are selected from
	              // either a user-specified list of property names, or the object
	              // itself.
	              forEach(properties || value, function (property) {
	                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
	                if (element !== undef) {
	                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
	                  // is not the empty string, let `member` {quote(property) + ":"}
	                  // be the concatenation of `member` and the `space` character."
	                  // The "`space` character" refers to the literal space
	                  // character, not the `space` {width} argument provided to
	                  // `JSON.stringify`.
	                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
	                }
	              });
	              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
	            }
	            // Remove the object from the traversed object stack.
	            stack.pop();
	            return result;
	          }
	        };
	
	        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
	        exports.stringify = function (source, filter, width) {
	          var whitespace, callback, properties, className;
	          if (objectTypes[typeof filter] && filter) {
	            if ((className = getClass.call(filter)) == functionClass) {
	              callback = filter;
	            } else if (className == arrayClass) {
	              // Convert the property names array into a makeshift set.
	              properties = {};
	              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
	            }
	          }
	          if (width) {
	            if ((className = getClass.call(width)) == numberClass) {
	              // Convert the `width` to an integer and create a string containing
	              // `width` number of space characters.
	              if ((width -= width % 1) > 0) {
	                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
	              }
	            } else if (className == stringClass) {
	              whitespace = width.length <= 10 ? width : width.slice(0, 10);
	            }
	          }
	          // Opera <= 7.54u2 discards the values associated with empty string keys
	          // (`""`) only if they are used directly within an object member list
	          // (e.g., `!("" in { "": 1})`).
	          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
	        };
	      }
	
	      // Public: Parses a JSON source string.
	      if (!has("json-parse")) {
	        var fromCharCode = String.fromCharCode;
	
	        // Internal: A map of escaped control characters and their unescaped
	        // equivalents.
	        var Unescapes = {
	          92: "\\",
	          34: '"',
	          47: "/",
	          98: "\b",
	          116: "\t",
	          110: "\n",
	          102: "\f",
	          114: "\r"
	        };
	
	        // Internal: Stores the parser state.
	        var Index, Source;
	
	        // Internal: Resets the parser state and throws a `SyntaxError`.
	        var abort = function () {
	          Index = Source = null;
	          throw SyntaxError();
	        };
	
	        // Internal: Returns the next token, or `"$"` if the parser has reached
	        // the end of the source string. A token may be a string, number, `null`
	        // literal, or Boolean literal.
	        var lex = function () {
	          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
	          while (Index < length) {
	            charCode = source.charCodeAt(Index);
	            switch (charCode) {
	              case 9: case 10: case 13: case 32:
	                // Skip whitespace tokens, including tabs, carriage returns, line
	                // feeds, and space characters.
	                Index++;
	                break;
	              case 123: case 125: case 91: case 93: case 58: case 44:
	                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
	                // the current position.
	                value = charIndexBuggy ? source.charAt(Index) : source[Index];
	                Index++;
	                return value;
	              case 34:
	                // `"` delimits a JSON string; advance to the next character and
	                // begin parsing the string. String tokens are prefixed with the
	                // sentinel `@` character to distinguish them from punctuators and
	                // end-of-string tokens.
	                for (value = "@", Index++; Index < length;) {
	                  charCode = source.charCodeAt(Index);
	                  if (charCode < 32) {
	                    // Unescaped ASCII control characters (those with a code unit
	                    // less than the space character) are not permitted.
	                    abort();
	                  } else if (charCode == 92) {
	                    // A reverse solidus (`\`) marks the beginning of an escaped
	                    // control character (including `"`, `\`, and `/`) or Unicode
	                    // escape sequence.
	                    charCode = source.charCodeAt(++Index);
	                    switch (charCode) {
	                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
	                        // Revive escaped control characters.
	                        value += Unescapes[charCode];
	                        Index++;
	                        break;
	                      case 117:
	                        // `\u` marks the beginning of a Unicode escape sequence.
	                        // Advance to the first character and validate the
	                        // four-digit code point.
	                        begin = ++Index;
	                        for (position = Index + 4; Index < position; Index++) {
	                          charCode = source.charCodeAt(Index);
	                          // A valid sequence comprises four hexdigits (case-
	                          // insensitive) that form a single hexadecimal value.
	                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
	                            // Invalid Unicode escape sequence.
	                            abort();
	                          }
	                        }
	                        // Revive the escaped character.
	                        value += fromCharCode("0x" + source.slice(begin, Index));
	                        break;
	                      default:
	                        // Invalid escape sequence.
	                        abort();
	                    }
	                  } else {
	                    if (charCode == 34) {
	                      // An unescaped double-quote character marks the end of the
	                      // string.
	                      break;
	                    }
	                    charCode = source.charCodeAt(Index);
	                    begin = Index;
	                    // Optimize for the common case where a string is valid.
	                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
	                      charCode = source.charCodeAt(++Index);
	                    }
	                    // Append the string as-is.
	                    value += source.slice(begin, Index);
	                  }
	                }
	                if (source.charCodeAt(Index) == 34) {
	                  // Advance to the next character and return the revived string.
	                  Index++;
	                  return value;
	                }
	                // Unterminated string.
	                abort();
	              default:
	                // Parse numbers and literals.
	                begin = Index;
	                // Advance past the negative sign, if one is specified.
	                if (charCode == 45) {
	                  isSigned = true;
	                  charCode = source.charCodeAt(++Index);
	                }
	                // Parse an integer or floating-point value.
	                if (charCode >= 48 && charCode <= 57) {
	                  // Leading zeroes are interpreted as octal literals.
	                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
	                    // Illegal octal literal.
	                    abort();
	                  }
	                  isSigned = false;
	                  // Parse the integer component.
	                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
	                  // Floats cannot contain a leading decimal point; however, this
	                  // case is already accounted for by the parser.
	                  if (source.charCodeAt(Index) == 46) {
	                    position = ++Index;
	                    // Parse the decimal component.
	                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal trailing decimal.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Parse exponents. The `e` denoting the exponent is
	                  // case-insensitive.
	                  charCode = source.charCodeAt(Index);
	                  if (charCode == 101 || charCode == 69) {
	                    charCode = source.charCodeAt(++Index);
	                    // Skip past the sign following the exponent, if one is
	                    // specified.
	                    if (charCode == 43 || charCode == 45) {
	                      Index++;
	                    }
	                    // Parse the exponential component.
	                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal empty exponent.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Coerce the parsed value to a JavaScript number.
	                  return +source.slice(begin, Index);
	                }
	                // A negative sign may only precede numbers.
	                if (isSigned) {
	                  abort();
	                }
	                // `true`, `false`, and `null` literals.
	                if (source.slice(Index, Index + 4) == "true") {
	                  Index += 4;
	                  return true;
	                } else if (source.slice(Index, Index + 5) == "false") {
	                  Index += 5;
	                  return false;
	                } else if (source.slice(Index, Index + 4) == "null") {
	                  Index += 4;
	                  return null;
	                }
	                // Unrecognized token.
	                abort();
	            }
	          }
	          // Return the sentinel `$` character if the parser has reached the end
	          // of the source string.
	          return "$";
	        };
	
	        // Internal: Parses a JSON `value` token.
	        var get = function (value) {
	          var results, hasMembers;
	          if (value == "$") {
	            // Unexpected end of input.
	            abort();
	          }
	          if (typeof value == "string") {
	            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
	              // Remove the sentinel `@` character.
	              return value.slice(1);
	            }
	            // Parse object and array literals.
	            if (value == "[") {
	              // Parses a JSON array, returning a new JavaScript array.
	              results = [];
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing square bracket marks the end of the array literal.
	                if (value == "]") {
	                  break;
	                }
	                // If the array literal contains elements, the current token
	                // should be a comma separating the previous element from the
	                // next.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "]") {
	                      // Unexpected trailing `,` in array literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each array element.
	                    abort();
	                  }
	                }
	                // Elisions and leading commas are not permitted.
	                if (value == ",") {
	                  abort();
	                }
	                results.push(get(value));
	              }
	              return results;
	            } else if (value == "{") {
	              // Parses a JSON object, returning a new JavaScript object.
	              results = {};
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing curly brace marks the end of the object literal.
	                if (value == "}") {
	                  break;
	                }
	                // If the object literal contains members, the current token
	                // should be a comma separator.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "}") {
	                      // Unexpected trailing `,` in object literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each object member.
	                    abort();
	                  }
	                }
	                // Leading commas are not permitted, object property names must be
	                // double-quoted strings, and a `:` must separate each property
	                // name and value.
	                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
	                  abort();
	                }
	                results[value.slice(1)] = get(lex());
	              }
	              return results;
	            }
	            // Unexpected token encountered.
	            abort();
	          }
	          return value;
	        };
	
	        // Internal: Updates a traversed object member.
	        var update = function (source, property, callback) {
	          var element = walk(source, property, callback);
	          if (element === undef) {
	            delete source[property];
	          } else {
	            source[property] = element;
	          }
	        };
	
	        // Internal: Recursively traverses a parsed JSON object, invoking the
	        // `callback` function for each value. This is an implementation of the
	        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
	        var walk = function (source, property, callback) {
	          var value = source[property], length;
	          if (typeof value == "object" && value) {
	            // `forEach` can't be used to traverse an array in Opera <= 8.54
	            // because its `Object#hasOwnProperty` implementation returns `false`
	            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
	            if (getClass.call(value) == arrayClass) {
	              for (length = value.length; length--;) {
	                update(value, length, callback);
	              }
	            } else {
	              forEach(value, function (property) {
	                update(value, property, callback);
	              });
	            }
	          }
	          return callback.call(source, property, value);
	        };
	
	        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
	        exports.parse = function (source, callback) {
	          var result, value;
	          Index = 0;
	          Source = "" + source;
	          result = get(lex());
	          // If a JSON string contains multiple tokens, it is invalid.
	          if (lex() != "$") {
	            abort();
	          }
	          // Reset the parser state.
	          Index = Source = null;
	          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
	        };
	      }
	    }
	
	    exports["runInContext"] = runInContext;
	    return exports;
	  }
	
	  if (freeExports && !isLoader) {
	    // Export for CommonJS environments.
	    runInContext(root, freeExports);
	  } else {
	    // Export for web browsers and JavaScript engines.
	    var nativeJSON = root.JSON,
	        previousJSON = root["JSON3"],
	        isRestored = false;
	
	    var JSON3 = runInContext(root, (root["JSON3"] = {
	      // Public: Restores the original value of the global `JSON` object and
	      // returns a reference to the `JSON3` object.
	      "noConflict": function () {
	        if (!isRestored) {
	          isRestored = true;
	          root.JSON = nativeJSON;
	          root["JSON3"] = previousJSON;
	          nativeJSON = previousJSON = null;
	        }
	        return JSON3;
	      }
	    }));
	
	    root.JSON = {
	      "parse": JSON3.parse,
	      "stringify": JSON3.stringify
	    };
	  }
	
	  // Export for asynchronous module loaders.
	  if (isLoader) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return JSON3;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module), (function() { return this; }())))

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(213);
	var isBuf = __webpack_require__(214);
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet){
	  var buffers = [];
	  var packetData = packet.data;
	
	  function _deconstructPacket(data) {
	    if (!data) return data;
	
	    if (isBuf(data)) {
	      var placeholder = { _placeholder: true, num: buffers.length };
	      buffers.push(data);
	      return placeholder;
	    } else if (isArray(data)) {
	      var newData = new Array(data.length);
	      for (var i = 0; i < data.length; i++) {
	        newData[i] = _deconstructPacket(data[i]);
	      }
	      return newData;
	    } else if ('object' == typeof data && !(data instanceof Date)) {
	      var newData = {};
	      for (var key in data) {
	        newData[key] = _deconstructPacket(data[key]);
	      }
	      return newData;
	    }
	    return data;
	  }
	
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  var curPlaceHolder = 0;
	
	  function _reconstructPacket(data) {
	    if (data && data._placeholder) {
	      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
	      return buf;
	    } else if (isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        data[i] = _reconstructPacket(data[i]);
	      }
	      return data;
	    } else if (data && 'object' == typeof data) {
	      for (var key in data) {
	        data[key] = _reconstructPacket(data[key]);
	      }
	      return data;
	    }
	    return data;
	  }
	
	  packet.data = _reconstructPacket(packet.data);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((global.Blob && obj instanceof Blob) ||
	        (global.File && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 214 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	module.exports = isBuf;
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(216);
	var Socket = __webpack_require__(246);
	var Emitter = __webpack_require__(247);
	var parser = __webpack_require__(205);
	var on = __webpack_require__(249);
	var bind = __webpack_require__(250);
	var debug = __webpack_require__(201)('socket.io-client:manager');
	var indexOf = __webpack_require__(244);
	var Backoff = __webpack_require__(251);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  this.encoder = new parser.Encoder();
	  this.decoder = new parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.engine.id;
	    }
	  }
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.engine.id;
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting evnet is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(217);


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(218);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(225);


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(219);
	var Emitter = __webpack_require__(234);
	var debug = __webpack_require__(238)('engine.io-client:socket');
	var index = __webpack_require__(244);
	var parser = __webpack_require__(225);
	var parseuri = __webpack_require__(200);
	var parsejson = __webpack_require__(245);
	var parseqs = __webpack_require__(235);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (global.location && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (global.location ? location.hostname : 'localhost');
	  this.port = opts.port || (global.location && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // other options for Node.js client
	  var freeGlobal = typeof global === 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(224);
	Socket.transports = __webpack_require__(219);
	Socket.parser = __webpack_require__(225);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    agent: this.agent,
	    hostname: this.hostname,
	    port: this.port,
	    secure: this.secure,
	    path: this.path,
	    query: query,
	    forceJSONP: this.forceJSONP,
	    jsonp: this.jsonp,
	    forceBase64: this.forceBase64,
	    enablesXDR: this.enablesXDR,
	    timestampRequests: this.timestampRequests,
	    timestampParam: this.timestampParam,
	    policyPort: this.policyPort,
	    socket: this,
	    pfx: this.pfx,
	    key: this.key,
	    passphrase: this.passphrase,
	    cert: this.cert,
	    ca: this.ca,
	    ciphers: this.ciphers,
	    rejectUnauthorized: this.rejectUnauthorized,
	    perMessageDeflate: this.perMessageDeflate,
	    extraHeaders: this.extraHeaders,
	    forceNode: this.forceNode,
	    localAddress: this.localAddress
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(parsejson(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(220);
	var XHR = __webpack_require__(222);
	var JSONP = __webpack_require__(241);
	var websocket = __webpack_require__(242);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(221);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(220);
	var Polling = __webpack_require__(223);
	var Emitter = __webpack_require__(234);
	var inherit = __webpack_require__(236);
	var debug = __webpack_require__(238)('engine.io-client:polling-xhr');
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = opts.hostname !== global.location.hostname ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  } else {
	    this.extraHeaders = opts.extraHeaders;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	    if (this.supportsBinary) {
	      // This has to be done after open because Firefox is stupid
	      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
	      xhr.responseType = 'arraybuffer';
	    }
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = true;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(xhr.status);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (global.document) {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (global.document) {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
	    } catch (e) {}
	    if (contentType === 'application/octet-stream') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      if (!this.supportsBinary) {
	        data = this.xhr.responseText;
	      } else {
	        try {
	          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
	        } catch (e) {
	          var ui8Arr = new Uint8Array(this.xhr.response);
	          var dataArray = [];
	          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
	            dataArray.push(ui8Arr[idx]);
	          }
	
	          data = String.fromCharCode.apply(null, dataArray);
	        }
	      }
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (global.document) {
	  if (global.attachEvent) {
	    global.attachEvent('onunload', unloadHandler);
	  } else if (global.addEventListener) {
	    global.addEventListener('beforeunload', unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(224);
	var parseqs = __webpack_require__(235);
	var parser = __webpack_require__(225);
	var inherit = __webpack_require__(236);
	var yeast = __webpack_require__(237);
	var debug = __webpack_require__(238)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(220);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(225);
	var Emitter = __webpack_require__(234);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(226);
	var hasBinary = __webpack_require__(227);
	var sliceBuffer = __webpack_require__(229);
	var after = __webpack_require__(230);
	var utf8 = __webpack_require__(231);
	
	var base64encoder;
	if (global && global.ArrayBuffer) {
	  base64encoder = __webpack_require__(232);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(233);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if ('function' == typeof supportsBinary) {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if ('function' == typeof utf8encode) {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (Blob && data instanceof global.Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    packet.data = fr.result;
	    exports.encodePacket(packet, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (Blob && packet.data instanceof global.Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += global.btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data == 'string') {
	    if (data.charAt(0) == 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data);
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary == 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data != 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data == '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = ''
	    , n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (':' != chr) {
	      length += chr;
	    } else {
	      if ('' == length || (length != (n = Number(length)))) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      msg = data.substr(i + 1, n);
	
	      if (length != msg.length) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      if (msg.length) {
	        packet = exports.decodePacket(msg, binaryType, true);
	
	        if (err.type == packet.type && err.data == packet.data) {
	          // parser error in individual packet - ignoring payload
	          return callback(err, 0, 1);
	        }
	
	        var ret = callback(packet, i + n, l);
	        if (false === ret) return;
	      }
	
	      // advance cursor
	      i += n;
	      length = '';
	    }
	  }
	
	  if (length != '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  var numberTooLong = false;
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] == 255) break;
	
	      if (msgLength.length > 310) {
	        numberTooLong = true;
	        break;
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    if(numberTooLong) return callback(err, 0, 1);
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(228);
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Right now only Buffer and ArrayBuffer are supported..
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary(data) {
	
	  function _hasBinary(obj) {
	    if (!obj) return false;
	
	    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
	         (global.Blob && obj instanceof Blob) ||
	         (global.File && obj instanceof File)
	        ) {
	      return true;
	    }
	
	    if (isArray(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	          if (_hasBinary(obj[i])) {
	              return true;
	          }
	      }
	    } else if (obj && 'object' == typeof obj) {
	      // see: https://github.com/Automattic/has-binary/pull/4
	      if (obj.toJSON && 'function' == typeof obj.toJSON) {
	        obj = obj.toJSON();
	      }
	
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  return _hasBinary(data);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 228 */
213,
/* 229 */
/***/ (function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/wtf8 v1.0.0 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function wtf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte.
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read the first byte.
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				var byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid WTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function wtf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var wtf8 = {
			'version': '1.0.0',
			'encode': wtf8encode,
			'decode': wtf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return wtf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = wtf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in wtf8) {
					hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.wtf8 = wtf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module), (function() { return this; }())))

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(){
	  "use strict";
	
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	
	  // Use a lookup table to find the index.
	  var lookup = new Uint8Array(256);
	  for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	  }
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = lookup[base64.charCodeAt(i)];
	      encoded2 = lookup[base64.charCodeAt(i+1)];
	      encoded3 = lookup[base64.charCodeAt(i+2)];
	      encoded4 = lookup[base64.charCodeAt(i+3)];
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})();


/***/ }),
/* 233 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = global.BlobBuilder
	  || global.WebKitBlobBuilder
	  || global.MSBlobBuilder
	  || global.MozBlobBuilder;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  for (var i = 0; i < ary.length; i++) {
	    var chunk = ary[i];
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      ary[i] = buf;
	    }
	  }
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary);
	
	  for (var i = 0; i < ary.length; i++) {
	    bb.append(ary[i]);
	  }
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  mapArrayBufferViews(ary);
	  return new Blob(ary, options || {});
	};
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ }),
/* 236 */
/***/ (function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ }),
/* 238 */
[1138, 239],
/* 239 */
[1139, 240],
/* 240 */
204,
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(223);
	var inherit = __webpack_require__(236);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    if (!global.___eio) global.___eio = [];
	    callbacks = global.___eio;
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (global.document && global.addEventListener) {
	    global.addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(224);
	var parser = __webpack_require__(225);
	var parseqs = __webpack_require__(235);
	var inherit = __webpack_require__(236);
	var yeast = __webpack_require__(237);
	var debug = __webpack_require__(238)('engine.io-client:websocket');
	var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
	var NodeWebSocket;
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(243);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocket = BrowserWebSocket;
	if (!WebSocket && typeof window === 'undefined') {
	  WebSocket = NodeWebSocket;
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  if (!this.usingBrowserWebSocket) {
	    WebSocket = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = void (0);
	  var opts = {
	    agent: this.agent,
	    perMessageDeflate: this.perMessageDeflate
	  };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * JSON parse.
	 *
	 * @see Based on jQuery#parseJSON (MIT) and JSON2
	 * @api private
	 */
	
	var rvalidchars = /^[\],:{}\s]*$/;
	var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
	var rtrimLeft = /^\s+/;
	var rtrimRight = /\s+$/;
	
	module.exports = function parsejson(data) {
	  if ('string' != typeof data || !data) {
	    return null;
	  }
	
	  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');
	
	  // Attempt to parse using the native JSON parser first
	  if (global.JSON && JSON.parse) {
	    return JSON.parse(data);
	  }
	
	  if (rvalidchars.test(data.replace(rvalidescape, '@')
	      .replace(rvalidtokens, ']')
	      .replace(rvalidbraces, ''))) {
	    return (new Function('return ' + data))();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(205);
	var Emitter = __webpack_require__(247);
	var toArray = __webpack_require__(248);
	var on = __webpack_require__(249);
	var bind = __webpack_require__(250);
	var debug = __webpack_require__(201)('socket.io-client:socket');
	var hasBin = __webpack_require__(227);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var parserType = parser.EVENT; // default
	  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
	  var packet = { type: parserType, data: args };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  delete this.flags;
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      this.packet({type: parser.CONNECT, query: this.query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  if (packet.nsp !== this.nsp) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
	    self.packet({
	      type: type,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags = this.flags || {};
	  this.flags.compress = compress;
	  return this;
	};


/***/ }),
/* 247 */
234,
/* 248 */
/***/ (function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ }),
/* 249 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ }),
/* 250 */
/***/ (function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	StorageService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StorageService = StorageService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function StorageService($resource) {
	
	  return $resource('/api/storage/:id/:controller', {
	    id: '@_id'
	  }, {
	    getMeta: {
	      method: 'GET',
	      params: {
	        controller: 'meta'
	      }
	    },
	    queryByOwner: {
	      method: 'GET',
	      url: "/api/storage/owner/:userid",
	      isArray: true
	    },
	    getFileSize: {
	      method: 'GET',
	      url: '/api/storage/:id/file-size'
	    }
	  });
	}
	
	exports.default = angular.module('conduu.StorageService', []).factory('StorageService', StorageService).name;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HomeComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _home = __webpack_require__(254);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var HomeComponent = exports.HomeComponent = function () {
	  HomeComponent.$inject = ['$state', 'dialogs', '$uibModal', 'Auth', 'PropertyService', 'WorkOrderTicketsService', 'ViolationTicketsService', '$scope', 'ViewSelection', 'TaskService', 'HistoryService', 'ServiceRequestTicketsService', 'DTOptionsBuilder', 'ProjectItemService', 'DTState', 'SettingsService'];
	  function HomeComponent($state, dialogs, $uibModal, Auth, PropertyService, WorkOrderTicketsService, ViolationTicketsService, $scope, ViewSelection, TaskService, HistoryService, ServiceRequestTicketsService, DTOptionsBuilder, ProjectItemService, DTState, SettingsService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, HomeComponent);
	
	    this.$state = $state;
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.Auth = Auth;
	    this.TaskService = TaskService;
	    this.tasks = [];
	    this.items = [];
	    this.activities = [];
	    this.selectedCommunity = "";
	
	    SettingsService.getByName({ name: 'config.app' }, function (settings) {
	      _this.hideKPIs = settings.data.hide && settings.data.hide.dashboardKPIs;
	    });
	
	    this.dtOptionsWorkItems = DTOptionsBuilder.newOptions().withOption('order', [0, 'asc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save('WorkItems')).withOption('stateLoadCallback', DTState.restore('WorkItems')).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);
	
	    this.dtOptionsActivities = DTOptionsBuilder.newOptions().withOption('order', [0, 'desc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save('Activities')).withOption('stateLoadCallback', DTState.restore('Activities')).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);
	
	    Auth.getCurrentUser(function (user) {
	      _this.userId = user._id;
	
	
	      _this.filteredData = {
	        properties: [],
	        workOrders: [],
	        serviceRequests: [],
	        violations: []
	      };
	
	      _this.data = {
	        properties: [],
	        workOrders: [],
	        serviceRequests: [],
	        violations: []
	      };
	
	      _this.count = {
	        properties: 0,
	        workOrders: 0,
	        serviceRequests: 0,
	        violations: 0
	      };
	
	      var fetchCount = 0;
	      var maxFetchCount = 6;
	
	      var updateSelected = function updateSelected(val) {
	
	        if (!val) {
	          _this.filteredData.properties = _this.data.properties;
	          _this.filteredData.workOrders = _this.data.workOrders;
	          _this.filteredData.violations = _this.data.violations;
	          _this.filteredData.serviceRequests = _this.data.serviceRequests;
	        } else {
	          _this.filteredData.properties = _this.data.properties.filter(function (prop) {
	            return prop.community.code == val;
	          });
	          _this.filteredData.violations = _this.data.violations.filter(function (ccr) {
	            return ccr.property && ccr.property.community && ccr.property.community.code == val;
	          });
	          _this.filteredData.workOrders = _this.data.workOrders.filter(function (wo) {
	            return wo.community && wo.community.code == val || wo.property && wo.property.community && wo.property.community.code == val;
	          });
	          _this.filteredData.serviceRequests = _this.data.serviceRequests.filter(function (sr) {
	            return sr.requester && sr.requester.communityCode == val || sr.property && sr.property.community && sr.property.community.code == val;
	          });
	        }
	
	        _this.count.properties = _this.filteredData.properties.length;
	        _this.count.workOrders = _this.filteredData.workOrders.length;
	        _this.count.serviceRequests = _this.filteredData.serviceRequests.length;
	        _this.count.violations = _this.filteredData.violations.length;
	      };
	
	      var next = function next() {
	        fetchCount++;
	        if (fetchCount == maxFetchCount) {
	          updateSelected(ViewSelection.selectedCommunityCode);
	          var myWo = _this.data.workOrders.filter(function (wo) {
	            return wo.approvedBy && wo.approvedBy._id == _this.userId;
	          }).map(function (item) {
	            return {
	              _id: item._id,
	              priority: 0,
	              dueDate: item.targetDate,
	              type: 'workOrder',
	              subject: '<a href="/workorder/ticket/detail/' + item._id + '">' + item.code + ': ' + item.name + '</a>'
	            };
	          });
	          var myPi = _this.data.projectItems.filter(function (pi) {
	            return pi.assignedTo == _this.userId;
	          }).map(function (item) {
	            return {
	              _id: item._id,
	              priority: 0,
	              dueDate: item.dueDate,
	              type: 'projectItem',
	              subject: item.title
	            };
	          });
	          var myTask = _this.data.tasks.filter(function (task) {
	            return task.assignedTo && task.assignedTo._id == _this.userId;
	          }).map(function (item) {
	            return {
	              _id: item._id,
	              priority: item.priority,
	              dueDate: item.dueDate,
	              type: 'task',
	              subject: item.subject,
	              data: item
	            };
	          });
	
	          _this.items = [].concat(myWo, myPi, myTask);
	          _this.dataInitComplete = true;
	        }
	      };
	
	      PropertyService.query(function (data) {
	        _this.data.properties = data;
	        next();
	      });
	      WorkOrderTicketsService.query(function (data) {
	        _this.data.workOrders = data.filter(function (wo) {
	          return wo.status == 'open';
	        });
	
	        next();
	      });
	      ServiceRequestTicketsService.query(function (data) {
	        _this.data.serviceRequests = data.filter(function (wo) {
	          return wo.status == 'open';
	        });
	        next();
	      });
	      ViolationTicketsService.query(function (data) {
	        _this.data.violations = data.filter(function (wo) {
	          return wo.status == 'open';
	        });
	        next();
	      });
	
	      ProjectItemService.query(function (data) {
	        _this.data.projectItems = data;
	
	        next();
	      });
	
	      TaskService.query(function (data) {
	        _this.data.tasks = data;
	
	        next();
	      });
	
	      HistoryService.queryRecentActivities(function (data) {
	        return _this.activities = data;
	      });
	
	      $scope.ViewSelection = ViewSelection;
	      $scope.$watch('ViewSelection.selectedCommunity', function (newVal, oldVal, scope) {
	        _this.selectedCommunity = newVal.name;
	
	        updateSelected(newVal.value);
	      });
	    });
	  }
	
	  _createClass(HomeComponent, [{
	    key: 'createTask',
	    value: function createTask() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'taskEdit',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (task) {
	        that.tasks.push(task);
	      }, function () {});
	    }
	  }, {
	    key: 'editTask',
	    value: function editTask(task) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'taskEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: task
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (task) {
	        that.TaskService.query(function (data) {
	          return that.tasks = data;
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'deleteTask',
	    value: function deleteTask(task) {
	      var _this2 = this;
	
	      var dlg = this.dialogs.confirm("Delete Task?", "Do you really want to delete this task?<br/><br/>" + task.subject);
	      dlg.result.then(function () {
	        _this2.TaskService.delete({ id: task._id }, function (_) {
	          _this2.TaskService.query(function (data) {
	            return _this2.tasks = data;
	          });
	        });
	      });
	    }
	  }, {
	    key: 'showTask',
	    value: function showTask(task) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'taskShow',
	        resolve: {
	          config: function config() {
	            return {
	              data: task
	            };
	          }
	        },
	        size: 'md'
	      });
	    }
	  }]);
	
	  return HomeComponent;
	}();
	
	exports.default = angular.module('conduu.home', [uiRouter]).config(_home2.default).component('home', {
	  template: __webpack_require__(255),
	  controller: HomeComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('home', {
	    url: '/home',
	    template: '<home></home>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container dashboard-content\">\n\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <h2>Management Dashboard <small>{{ctrl.selectedCommunity}}</small></h2>\n      <li class=\"active\"><a href=\"#\">Management Dashboard</a></li>\n    </ol>\n\n    <div class=\"col-md-3 col-sm-6\" ng-hide=\"ctrl.hideKPIs\">\n      <div class=\"panel panel-primary\">\n        <div class=\"panel-heading\">\n          <div class=\"row\">\n            <div class=\"col-xs-3\"><i class=\"fa fa-home fa-5x\"></i></div>\n            <div class=\"col-xs-9 text-right\">\n              <div class=\"huge ng-binding\">{{ctrl.count.properties}}</div>\n              <div>Properties</div>\n            </div>\n          </div>\n        </div>\n        <a href=\"/property/list\">\n          <div class=\"panel-footer\"><span class=\"pull-left\">View Details</span> <span class=\"pull-right\"><i\n                  class=\"fa fa-arrow-circle-right\"></i></span>\n            <div class=\"clearfix\"></div>\n          </div>\n        </a></div>\n    </div>\n\n    <div class=\"col-md-3 col-sm-6\" ng-hide=\"ctrl.hideKPIs\">\n      <div class=\"panel panel-yellow\">\n        <div class=\"panel-heading\">\n          <div class=\"row\">\n            <div class=\"col-xs-3\"><i class=\"fa fa-bell fa-5x\"></i></div>\n            <div class=\"col-xs-9 text-right\">\n              <div class=\"huge ng-binding\">{{ctrl.count.serviceRequests}}</div>\n              <div>Service Requests</div>\n            </div>\n          </div>\n        </div>\n        <a href=\"/servicerequest/ticket/list\">\n          <div class=\"panel-footer\"><span class=\"pull-left\">View Details</span> <span class=\"pull-right\"><i\n                  class=\"fa fa-arrow-circle-right\"></i></span>\n            <div class=\"clearfix\"></div>\n          </div>\n        </a></div>\n    </div>\n\n    <div class=\"col-md-3 col-sm-6\" ng-hide=\"ctrl.hideKPIs\">\n      <div class=\"panel panel-yellow\">\n        <div class=\"panel-heading\">\n          <div class=\"row\">\n            <div class=\"col-xs-3\"><i class=\"fa fa-wrench fa-5x\"></i></div>\n            <div class=\"col-xs-9 text-right\">\n              <div class=\"huge ng-binding\">{{ctrl.count.workOrders}}</div>\n              <div>Work Orders</div>\n            </div>\n          </div>\n        </div>\n        <a href=\"/workorder/ticket/list\">\n          <div class=\"panel-footer\"><span class=\"pull-left\">View Details</span> <span class=\"pull-right\"><i\n                  class=\"fa fa-arrow-circle-right\"></i></span>\n            <div class=\"clearfix\"></div>\n          </div>\n        </a></div>\n    </div>\n\n    <div class=\"col-md-3 col-sm-6\" ng-hide=\"ctrl.hideKPIs\">\n      <div class=\"panel panel-red\">\n        <div class=\"panel-heading\">\n          <div class=\"row\">\n            <div class=\"col-xs-3\"><i class=\"fa fa-exclamation fa-5x\"></i></div>\n            <div class=\"col-xs-9 text-right\">\n              <div class=\"huge ng-binding\">{{ctrl.count.violations}}</div>\n              <div>Violations</div>\n            </div>\n          </div>\n        </div>\n        <a href=\"/violation/ticket/list\">\n          <div class=\"panel-footer\"><span class=\"pull-left\">View Details</span> <span class=\"pull-right\"><i\n                  class=\"fa fa-arrow-circle-right\"></i></span>\n            <div class=\"clearfix\"></div>\n          </div>\n        </a></div>\n    </div>\n\n  </div>\n\n  <div class=\"row\">\n\n    <div class=\"col-md-12 col-lg-6\">\n      <h3 class=\"separator\"><span><i class=\"fa fa-tasks\"></i> My Work Items <small><a ng-click=\"ctrl.createTask()\" style=\"text-decoration: none; cursor: pointer\"><i class=\"fa fa-fw fa-plus\"></i> Create New Task</a></small></span></h3>\n\n        <table ng-if=\"ctrl.dataInitComplete\" dt-options=\"ctrl.dtOptionsWorkItems\" datatable=\"ng\" class=\"table table-striped table-condensed\">\n          <thead>\n          <tr>\n            <th></th>\n            <th>Priority</th>\n            <th>Due</th>\n            <th>Type</th>\n            <th>Description</th>\n            <th></th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-class=\"{'text-danger': item.priority == 1}\"  ng-repeat=\"item in ctrl.items\">\n            <td>\n              <i ng-if=\"item.priority == 1\" class=\"fa fa-fw fa-long-arrow-up text-danger\"></i>\n              <i ng-if=\"item.priority == -1\" class=\"fa fa-fw fa-long-arrow-down text-success\"></i>\n            </td>\n            <td>\n              <span ng-if=\"item.priority == 1\">High</span>\n              <span ng-if=\"item.priority == 0\">Normal</span>\n              <span ng-if=\"item.priority == -1\">Low</span>\n            </td>\n            <td>{{item.dueDate | date:'M/d/yy'}}</td>\n            <td>\n              <span ng-show=\"item.type == 'workOrder'\" class=\"label label-warning\">Work Order</span>\n              <span ng-show=\"item.type == 'projectItem'\" class=\"label label-info\">Project Item</span>\n              <span ng-show=\"item.type == 'task'\" class=\"label label-primary\">Task</span>\n            </td>\n            <td ng-bind-html=\"item.subject\"></td>\n            <td class=\"text-right\">\n              <nobr ng-if=\"item.type == 'task'\">\n                <a href=\"#\" ng-click=\"ctrl.showTask(item.data)\" title=\"Show Task\"><i class=\"fa fa-fw fa-search\"></i></a>\n                <a href=\"#\" ng-click=\"ctrl.editTask(item.data)\" title=\"Edit Task\"><i class=\"fa fa-fw fa-pencil\"></i></a>\n                <a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.deleteTask(item.data)\" title=\"Delete Task\"><i class=\"fa fa-trash\"></i></a>\n              </nobr>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n\n    </div>\n\n    <div class=\"col-md-12 col-lg-6\">\n      <h3 class=\"separator\"><span><i class=\"fa fa-list\"></i> Activities</span></h3>\n\n      <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptionsActivities\" class=\"table table-striped table-condensed\">\n        <thead>\n        <tr>\n          <th>Date</th>\n          <th>Context</th>\n          <th>Entity</th>\n          <th>Activity</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"activity in ctrl.activities\">\n          <td><nobr class=\"text-lowercase\">{{activity.meta.creationDate | date:'M/d h:mma'}}</nobr></td>\n          <td>\n            <span ng-if=\"activity.entityType == 'violation'\">Violation</span>\n            <span ng-if=\"activity.entityType == 'workorder'\">Work Order</span>\n            <span ng-if=\"activity.entityType == 'servicerequest'\">Service Request</span>\n\n            <span ng-if=\"activity.entityType == 'community'\">Community</span>\n            <span ng-if=\"activity.entityType == 'property'\">Property</span>\n            <span ng-if=\"activity.entityType == 'contact'\">Contact</span>\n            <span ng-if=\"activity.entityType == 'vendor'\">Vendor</span>\n            <span ng-if=\"activity.entityType == 'task'\">Task</span>\n            <span ng-if=\"activity.entityType == 'webaccess'\">Web Access</span>\n          </td>\n          <td>\n            <a ng-if=\"activity.entityType == 'violation'\" ng-href=\"/violation/ticket/detail/{{activity.entityId}}\">{{activity.dataAfter.code}}: {{activity.dataAfter.name}}</a>\n            <a ng-if=\"activity.entityType == 'workorder'\" ng-href=\"/workorder/ticket/detail/{{activity.entityId}}\">{{activity.dataAfter.code}}: {{activity.dataAfter.name}}</a>\n            <a ng-if=\"activity.entityType == 'servicerequest'\" ng-href=\"/servicerequest/ticket/detail/{{activity.entityId}}\">{{activity.dataAfter.code}}: {{activity.dataAfter.name}}</a>\n\n            <a ng-if=\"activity.entityType == 'community'\" ng-href=\"/community/{{activity.entityId}}\">{{activity.dataAfter.code}}: {{activity.dataAfter.name}}</a>\n            <a ng-if=\"activity.entityType == 'property'\" ng-href=\"/property/{{activity.entityId}}\">{{activity.dataAfter.code}}: {{activity.dataAfter.name}}</a>\n            <a ng-if=\"activity.entityType == 'contact'\" ng-href=\"/contact/{{activity.entityId}}\">{{activity.dataAfter.code}}: {{activity.dataAfter.name}}</a>\n            <a ng-if=\"activity.entityType == 'vendor'\" ng-href=\"/vendor/{{activity.entityId}}\">{{activity.dataAfter.code}}: {{activity.dataAfter.name}}</a>\n            <a ng-if=\"activity.entityType == 'webaccess'\" ng-href=\"/webaccess/{{activity.entityId}}\">{{activity.dataAfter.code}}: {{activity.dataAfter.name}}</a>\n            <span ng-if=\"activity.entityType == 'task'\">{{activity.dataAfter.subject}}</span>\n\n\n          </td>\n          <td class=\"text-capitalize\">\n            <nobr>\n              <i ng-if=\"activity.actionType == 'created'\" class=\"fa fa-fw fa-asterisk\"></i>\n              <i ng-if=\"activity.actionType == 'edited'\" class=\"fa fa-fw fa-pencil-square-o\"></i>\n              <i ng-if=\"activity.actionType == 'deleted'\" class=\"fa fa-fw fa-trash\"></i>\n              {{activity.actionType}}\n            </nobr>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n\n  </div>\n\n</div>\n"

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	newlineToHtmlFilter.$inject = ['$sce'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newlineToHtmlFilter = newlineToHtmlFilter;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function newlineToHtmlFilter($sce) {
	  return function (input) {
	    if (!input) return;
	
	    return $sce.trustAsHtml(input.replace(/\n/g, '<br/>'));
	  };
	}
	
	exports.default = angular.module('conduu.newlineToHtml', []).filter('newlineToHtml', newlineToHtmlFilter).name;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(262);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(268);
	__webpack_require__(269);
	module.exports = 'datatables';


/***/ }),
/* 258 */
/***/ (function(module, exports) {

	/*!
	 * angular-datatables - v0.6.2
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables';
	}
	(function(window, document, $, angular) {
	
	    'use strict';
	
	    angular.module('datatables.directive', ['datatables.instances', 'datatables.renderer', 'datatables.options', 'datatables.util'])
	        .directive('datatable', dataTable);
	
	    /* @ngInject */
	    function dataTable($q, $http, $log, DTRendererFactory, DTRendererService, DTPropertyUtil) {
	        compileDirective.$inject = ['tElm'];
	        ControllerDirective.$inject = ['$scope'];
	        return {
	            restrict: 'A',
	            scope: {
	                dtOptions: '=',
	                dtColumns: '=',
	                dtColumnDefs: '=',
	                datatable: '@',
	                dtInstance: '='
	            },
	            compile: compileDirective,
	            controller: ControllerDirective
	        };
	
	        /* @ngInject */
	        function compileDirective(tElm) {
	            var _staticHTML = tElm[0].innerHTML;
	
	            return function postLink($scope, $elem, iAttrs, ctrl) {
	                function handleChanges(newVal, oldVal) {
	                    if (newVal !== oldVal) {
	                        ctrl.render($elem, ctrl.buildOptionsPromise(), _staticHTML);
	                    }
	                }
	
	                // Options can hold heavy data, and other deep/large objects.
	                // watchcollection can improve this by only watching shallowly
	                var watchFunction = iAttrs.dtDisableDeepWatchers ? '$watchCollection' : '$watch';
	                angular.forEach(['dtColumns', 'dtColumnDefs', 'dtOptions'], function(tableDefField) {
	                    $scope[watchFunction].call($scope, tableDefField, handleChanges, true);
	                });
	                DTRendererService.showLoading($elem, $scope);
	                ctrl.render($elem, ctrl.buildOptionsPromise(), _staticHTML);
	            };
	        }
	
	        /* @ngInject */
	        function ControllerDirective($scope) {
	            var _dtInstance;
	            var vm = this;
	            vm.buildOptionsPromise = buildOptionsPromise;
	            vm.render = render;
	
	            function buildOptionsPromise() {
	                var defer = $q.defer();
	                // Build options
	                $q.all([
	                    $q.when($scope.dtOptions),
	                    $q.when($scope.dtColumns),
	                    $q.when($scope.dtColumnDefs)
	                ]).then(function(results) {
	                    var dtOptions = results[0],
	                        dtColumns = results[1],
	                        dtColumnDefs = results[2];
	                    // Since Angular 1.3, the promise throws a "Maximum call stack size exceeded" when cloning
	                    // See https://github.com/l-lin/angular-datatables/issues/110
	                    DTPropertyUtil.deleteProperty(dtOptions, '$promise');
	                    DTPropertyUtil.deleteProperty(dtColumns, '$promise');
	                    DTPropertyUtil.deleteProperty(dtColumnDefs, '$promise');
	                    var options;
	                    if (angular.isDefined(dtOptions)) {
	                        options = {};
	                        angular.extend(options, dtOptions);
	                        // Set the columns
	                        if (angular.isArray(dtColumns)) {
	                            options.aoColumns = dtColumns;
	                        }
	
	                        // Set the column defs
	                        if (angular.isArray(dtColumnDefs)) {
	                            options.aoColumnDefs = dtColumnDefs;
	                        }
	
	                        // HACK to resolve the language source manually instead of DT
	                        // See https://github.com/l-lin/angular-datatables/issues/181
	                        if (options.language && options.language.url) {
	                            var languageDefer = $q.defer();
	                            var languageUrl = options.language.url;
	                            $http.get(options.language.url).then(function(language) {
	                                languageDefer.resolve(language.data);
	                            }, function() {
	                                $log.error('Could not fetch the content of the language from ' + languageUrl);
	                            });
	                            options.language = languageDefer.promise;
	                        }
	
	                    }
	                    return DTPropertyUtil.resolveObjectPromises(options, ['data', 'aaData', 'fnPromise']);
	                }).then(function(options) {
	                    defer.resolve(options);
	                });
	                return defer.promise;
	            }
	
	            function render($elem, optionsPromise, staticHTML) {
	                optionsPromise.then(function(options) {
	                    DTRendererService.preRender(options);
	
	                    var isNgDisplay = $scope.datatable && $scope.datatable === 'ng';
	                    // Render dataTable
	                    if (_dtInstance && _dtInstance._renderer) {
	                        _dtInstance._renderer.withOptions(options)
	                            .render($elem, $scope, staticHTML).then(function(dtInstance) {
	                                _dtInstance = dtInstance;
	                                _setDTInstance(dtInstance);
	                            });
	                    } else {
	                        DTRendererFactory.fromOptions(options, isNgDisplay)
	                            .render($elem, $scope, staticHTML).then(function(dtInstance) {
	                                _dtInstance = dtInstance;
	                                _setDTInstance(dtInstance);
	                            });
	                    }
	                });
	            }
	
	            function _setDTInstance(dtInstance) {
	                if (angular.isFunction($scope.dtInstance)) {
	                    $scope.dtInstance(dtInstance);
	                } else if (angular.isDefined($scope.dtInstance)) {
	                    $scope.dtInstance = dtInstance;
	                }
	            }
	        }
	    }
	    dataTable.$inject = ['$q', '$http', '$log', 'DTRendererFactory', 'DTRendererService', 'DTPropertyUtil'];
	
	    'use strict';
	    angular.module('datatables.factory', [])
	        .factory('DTOptionsBuilder', dtOptionsBuilder)
	        .factory('DTColumnBuilder', dtColumnBuilder)
	        .factory('DTColumnDefBuilder', dtColumnDefBuilder)
	        .factory('DTLoadingTemplate', dtLoadingTemplate);
	
	    /* @ngInject */
	    function dtOptionsBuilder() {
	        /**
	         * The wrapped datatables options class
	         * @param sAjaxSource the ajax source to fetch the data
	         * @param fnPromise the function that returns a promise to fetch the data
	         */
	        var DTOptions = {
	            /**
	             * Add the option to the datatables options
	             * @param key the key of the option
	             * @param value an object or a function of the option
	             * @returns {DTOptions} the options
	             */
	            withOption: function(key, value) {
	                if (angular.isString(key)) {
	                    this[key] = value;
	                }
	                return this;
	            },
	
	            /**
	             * Add the Ajax source to the options.
	             * This corresponds to the "ajax" option
	             * @param ajax the ajax source
	             * @returns {DTOptions} the options
	             */
	            withSource: function(ajax) {
	                this.ajax = ajax;
	                return this;
	            },
	
	            /**
	             * Add the ajax data properties.
	             * @param sAjaxDataProp the ajax data property
	             * @returns {DTOptions} the options
	             */
	            withDataProp: function(sAjaxDataProp) {
	                this.sAjaxDataProp = sAjaxDataProp;
	                return this;
	            },
	
	            /**
	             * Set the server data function.
	             * @param fn the function of the server retrieval
	             * @returns {DTOptions} the options
	             */
	            withFnServerData: function(fn) {
	                if (!angular.isFunction(fn)) {
	                    throw new Error('The parameter must be a function');
	                }
	                this.fnServerData = fn;
	                return this;
	            },
	
	            /**
	             * Set the pagination type.
	             * @param sPaginationType the pagination type
	             * @returns {DTOptions} the options
	             */
	            withPaginationType: function(sPaginationType) {
	                if (angular.isString(sPaginationType)) {
	                    this.sPaginationType = sPaginationType;
	                } else {
	                    throw new Error('The pagination type must be provided');
	                }
	                return this;
	            },
	
	            /**
	             * Set the language of the datatables
	             * @param language the language
	             * @returns {DTOptions} the options
	             */
	            withLanguage: function(language) {
	                this.language = language;
	                return this;
	            },
	
	            /**
	             * Set the language source
	             * @param languageSource the language source
	             * @returns {DTOptions} the options
	             */
	            withLanguageSource: function(languageSource) {
	                return this.withLanguage({
	                    url: languageSource
	                });
	            },
	
	            /**
	             * Set default number of items per page to display
	             * @param iDisplayLength the number of items per page
	             * @returns {DTOptions} the options
	             */
	            withDisplayLength: function(iDisplayLength) {
	                this.iDisplayLength = iDisplayLength;
	                return this;
	            },
	
	            /**
	             * Set the promise to fetch the data
	             * @param fnPromise the function that returns a promise
	             * @returns {DTOptions} the options
	             */
	            withFnPromise: function(fnPromise) {
	                this.fnPromise = fnPromise;
	                return this;
	            },
	
	            /**
	             * Set the Dom of the DataTables.
	             * @param dom the dom
	             * @returns {DTOptions} the options
	             */
	            withDOM: function(dom) {
	                this.dom = dom;
	                return this;
	            }
	        };
	
	        return {
	            /**
	             * Create a wrapped datatables options
	             * @returns {DTOptions} a wrapped datatables option
	             */
	            newOptions: function() {
	                return Object.create(DTOptions);
	            },
	            /**
	             * Create a wrapped datatables options with the ajax source setted
	             * @param ajax the ajax source
	             * @returns {DTOptions} a wrapped datatables option
	             */
	            fromSource: function(ajax) {
	                var options = Object.create(DTOptions);
	                options.ajax = ajax;
	                return options;
	            },
	            /**
	             * Create a wrapped datatables options with the data promise.
	             * @param fnPromise the function that returns a promise to fetch the data
	             * @returns {DTOptions} a wrapped datatables option
	             */
	            fromFnPromise: function(fnPromise) {
	                var options = Object.create(DTOptions);
	                options.fnPromise = fnPromise;
	                return options;
	            }
	        };
	    }
	
	    function dtColumnBuilder() {
	        /**
	         * The wrapped datatables column
	         * @param mData the data to display of the column
	         * @param sTitle the sTitle of the column title to display in the DOM
	         */
	        var DTColumn = {
	            /**
	             * Add the option of the column
	             * @param key the key of the option
	             * @param value an object or a function of the option
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            withOption: function(key, value) {
	                if (angular.isString(key)) {
	                    this[key] = value;
	                }
	                return this;
	            },
	
	            /**
	             * Set the title of the colum
	             * @param sTitle the sTitle of the column
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            withTitle: function(sTitle) {
	                this.sTitle = sTitle;
	                return this;
	            },
	
	            /**
	             * Set the CSS class of the column
	             * @param sClass the CSS class
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            withClass: function(sClass) {
	                this.sClass = sClass;
	                return this;
	            },
	
	            /**
	             * Hide the column
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            notVisible: function() {
	                this.bVisible = false;
	                return this;
	            },
	
	            /**
	             * Set the column as not sortable
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            notSortable: function() {
	                this.bSortable = false;
	                return this;
	            },
	
	            /**
	             * Render each cell with the given parameter
	             * @mRender mRender the function/string to render the data
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            renderWith: function(mRender) {
	                this.mRender = mRender;
	                return this;
	            }
	        };
	
	        return {
	            /**
	             * Create a new wrapped datatables column
	             * @param mData the data of the column to display
	             * @param sTitle the sTitle of the column title to display in the DOM
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            newColumn: function(mData, sTitle) {
	                if (angular.isUndefined(mData)) {
	                    throw new Error('The parameter "mData" is not defined!');
	                }
	                var column = Object.create(DTColumn);
	                column.mData = mData;
	                if (angular.isDefined(sTitle)) {
	                    column.sTitle = sTitle;
	                }
	                return column;
	            },
	            DTColumn: DTColumn
	        };
	    }
	
	    /* @ngInject */
	    function dtColumnDefBuilder(DTColumnBuilder) {
	        return {
	            newColumnDef: function(targets) {
	                if (angular.isUndefined(targets)) {
	                    throw new Error('The parameter "targets" must be defined! See https://datatables.net/reference/option/columnDefs.targets');
	                }
	                var column = Object.create(DTColumnBuilder.DTColumn);
	                if (angular.isArray(targets)) {
	                    column.aTargets = targets;
	                } else {
	                    column.aTargets = [targets];
	                }
	                return column;
	            }
	        };
	    }
	    dtColumnDefBuilder.$inject = ['DTColumnBuilder'];
	
	    function dtLoadingTemplate($compile, DTDefaultOptions, DT_LOADING_CLASS) {
	        return {
	            compileHtml: function($scope) {
	                return $compile(angular.element('<div class="' + DT_LOADING_CLASS + '">' + DTDefaultOptions.loadingTemplate + '</div>'))($scope);
	            },
	            isLoading: function(elem) {
	                return elem.hasClass(DT_LOADING_CLASS);
	            }
	        };
	    }
	    dtLoadingTemplate.$inject = ['$compile', 'DTDefaultOptions', 'DT_LOADING_CLASS'];
	
	    'use strict';
	
	    angular.module('datatables.instances', ['datatables.util'])
	        .factory('DTInstanceFactory', dtInstanceFactory);
	
	    function dtInstanceFactory() {
	        var DTInstance = {
	            reloadData: reloadData,
	            changeData: changeData,
	            rerender: rerender
	        };
	        return {
	            newDTInstance: newDTInstance,
	            copyDTProperties: copyDTProperties
	        };
	
	        function newDTInstance(renderer) {
	            var dtInstance = Object.create(DTInstance);
	            dtInstance._renderer = renderer;
	            return dtInstance;
	        }
	
	        function copyDTProperties(result, dtInstance) {
	            dtInstance.id = result.id;
	            dtInstance.DataTable = result.DataTable;
	            dtInstance.dataTable = result.dataTable;
	        }
	
	        function reloadData(callback, resetPaging) {
	            /*jshint validthis:true */
	            this._renderer.reloadData(callback, resetPaging);
	        }
	
	        function changeData(data) {
	            /*jshint validthis:true */
	            this._renderer.changeData(data);
	        }
	
	        function rerender() {
	            /*jshint validthis:true */
	            this._renderer.rerender();
	        }
	    }
	
	    'use strict';
	
	    angular.module('datatables', ['datatables.directive', 'datatables.factory'])
	        .run(initAngularDataTables);
	
	    /* @ngInject */
	    function initAngularDataTables() {
	        if ($.fn.DataTable.Api) {
	            /**
	             * Register an API to destroy a DataTable without detaching the tbody so that we can add new data
	             * when rendering with the "Angular way".
	             */
	            $.fn.DataTable.Api.register('ngDestroy()', function(remove) {
	                remove = remove || false;
	
	                return this.iterator('table', function(settings) {
	                    var orig = settings.nTableWrapper.parentNode;
	                    var classes = settings.oClasses;
	                    var table = settings.nTable;
	                    var tbody = settings.nTBody;
	                    var thead = settings.nTHead;
	                    var tfoot = settings.nTFoot;
	                    var jqTable = $(table);
	                    var jqTbody = $(tbody);
	                    var jqWrapper = $(settings.nTableWrapper);
	                    var rows = $.map(settings.aoData, function(r) {
	                        return r.nTr;
	                    });
	                    var ien;
	
	                    // Flag to note that the table is currently being destroyed - no action
	                    // should be taken
	                    settings.bDestroying = true;
	
	                    // Fire off the destroy callbacks for plug-ins etc
	                    $.fn.DataTable.ext.internal._fnCallbackFire(settings, 'aoDestroyCallback', 'destroy', [settings]);
	
	                    // If not being removed from the document, make all columns visible
	                    if (!remove) {
	                        new $.fn.DataTable.Api(settings).columns().visible(true);
	                    }
	
	                    // Blitz all `DT` namespaced events (these are internal events, the
	                    // lowercase, `dt` events are user subscribed and they are responsible
	                    // for removing them
	                    jqWrapper.unbind('.DT').find(':not(tbody *)').unbind('.DT');
	                    $(window).unbind('.DT-' + settings.sInstance);
	
	                    // When scrolling we had to break the table up - restore it
	                    if (table !== thead.parentNode) {
	                        jqTable.children('thead').detach();
	                        jqTable.append(thead);
	                    }
	
	                    if (tfoot && table !== tfoot.parentNode) {
	                        jqTable.children('tfoot').detach();
	                        jqTable.append(tfoot);
	                    }
	
	                    // Remove the DataTables generated nodes, events and classes
	                    jqTable.detach();
	                    jqWrapper.detach();
	
	                    settings.aaSorting = [];
	                    settings.aaSortingFixed = [];
	                    $.fn.DataTable.ext.internal._fnSortingClasses(settings);
	
	                    $(rows).removeClass(settings.asStripeClasses.join(' '));
	
	                    $('th, td', thead).removeClass(classes.sSortable + ' ' +
	                        classes.sSortableAsc + ' ' + classes.sSortableDesc + ' ' + classes.sSortableNone
	                    );
	
	                    if (settings.bJUI) {
	                        $('th span.' + classes.sSortIcon + ', td span.' + classes.sSortIcon, thead).detach();
	                        $('th, td', thead).each(function() {
	                            var wrapper = $('div.' + classes.sSortJUIWrapper, this);
	                            $(this).append(wrapper.contents());
	                            wrapper.detach();
	                        });
	                    }
	
	                    // -------------------------------------------------------------------------
	                    // This is the only change with the "destroy()" API (with DT v1.10.1)
	                    // -------------------------------------------------------------------------
	                    if (!remove && orig) {
	                        // insertBefore acts like appendChild if !arg[1]
	                        if (orig.contains(settings.nTableReinsertBefore)) {
	                            orig.insertBefore(table, settings.nTableReinsertBefore);
	                        } else {
	                            orig.appendChild(table);
	                        }
	                    }
	                    // Add the TR elements back into the table in their original order
	                    // jqTbody.children().detach();
	                    // jqTbody.append( rows );
	                    // -------------------------------------------------------------------------
	
	                    // Restore the width of the original table - was read from the style property,
	                    // so we can restore directly to that
	                    jqTable
	                        .css('width', settings.sDestroyWidth)
	                        .removeClass(classes.sTable);
	
	                    // If the were originally stripe classes - then we add them back here.
	                    // Note this is not fool proof (for example if not all rows had stripe
	                    // classes - but it's a good effort without getting carried away
	                    ien = settings.asDestroyStripes.length;
	
	                    if (ien) {
	                        jqTbody.children().each(function(i) {
	                            $(this).addClass(settings.asDestroyStripes[i % ien]);
	                        });
	                    }
	
	                    /* Remove the settings object from the settings array */
	                    var idx = $.inArray(settings, $.fn.DataTable.settings);
	                    if (idx !== -1) {
	                        $.fn.DataTable.settings.splice(idx, 1);
	                    }
	                });
	            });
	        }
	    }
	
	    'use strict';
	    angular.module('datatables.options', [])
	        .constant('DT_DEFAULT_OPTIONS', {
	            // Default ajax properties. See http://legacy.datatables.net/usage/options#sAjaxDataProp
	            sAjaxDataProp: '',
	            // Set default columns (used when none are provided)
	            aoColumns: []
	        })
	        .constant('DT_LOADING_CLASS', 'dt-loading')
	        .service('DTDefaultOptions', dtDefaultOptions);
	
	    function dtDefaultOptions() {
	        var options = {
	            loadingTemplate: '<h3>Loading...</h3>',
	            bootstrapOptions: {},
	            setLoadingTemplate: setLoadingTemplate,
	            setLanguageSource: setLanguageSource,
	            setLanguage: setLanguage,
	            setDisplayLength: setDisplayLength,
	            setBootstrapOptions: setBootstrapOptions,
	            setDOM: setDOM,
	            setOption: setOption
	        };
	
	        return options;
	
	        /**
	         * Set the default loading template
	         * @param loadingTemplate the HTML to display when loading the table
	         * @returns {DTDefaultOptions} the default option config
	         */
	        function setLoadingTemplate(loadingTemplate) {
	            options.loadingTemplate = loadingTemplate;
	            return options;
	        }
	
	        /**
	         * Set the default language source for all datatables
	         * @param sLanguageSource the language source
	         * @returns {DTDefaultOptions} the default option config
	         */
	        function setLanguageSource(sLanguageSource) {
	            // HACK to resolve the language source manually instead of DT
	            // See https://github.com/l-lin/angular-datatables/issues/356
	            $.ajax({
	                dataType: 'json',
	                url: sLanguageSource,
	                success: function(json) {
	                    $.extend(true, $.fn.DataTable.defaults, {
	                        language: json
	                    });
	                }
	            });
	            return options;
	        }
	
	        /**
	         * Set the language for all datatables
	         * @param language the language
	         * @returns {DTDefaultOptions} the default option config
	         */
	        function setLanguage(language) {
	            $.extend(true, $.fn.DataTable.defaults, {
	                language: language
	            });
	            return options;
	        }
	
	        /**
	         * Set the default number of items to display for all datatables
	         * @param displayLength the number of items to display
	         * @returns {DTDefaultOptions} the default option config
	         */
	        function setDisplayLength(displayLength) {
	            $.extend($.fn.DataTable.defaults, {
	                displayLength: displayLength
	            });
	            return options;
	        }
	
	        /**
	         * Set the default options to be use for Bootstrap integration.
	         * See https://github.com/l-lin/angular-datatables/blob/dev/src/angular-datatables.bootstrap.options.js to check
	         * what default options Angular DataTables is using.
	         * @param oBootstrapOptions an object containing the default options for Bootstrap integration
	         * @returns {DTDefaultOptions} the default option config
	         */
	        function setBootstrapOptions(oBootstrapOptions) {
	            options.bootstrapOptions = oBootstrapOptions;
	            return options;
	        }
	
	        /**
	         * Set the DOM for all DataTables.
	         * See https://datatables.net/reference/option/dom
	         * @param dom the dom
	         * @returns {DTDefaultoptions} the default option config
	         */
	        function setDOM(dom) {
	            $.extend($.fn.DataTable.defaults, {
	                dom: dom
	            });
	            return options;
	        }
	
	        /**
	         * Set global default option to all DataTables.
	         * @param key the key of the default option
	         * @param value the value of the default option
	         */
	        function setOption(key, value) {
	            if (angular.isString(key)) {
	                var obj = {};
	                obj[key] = value;
	                $.extend($.fn.DataTable.defaults, obj);
	            }
	        }
	    }
	
	    'use strict';
	    angular.module('datatables.renderer', ['datatables.instances', 'datatables.factory', 'datatables.options', 'datatables.instances'])
	        .factory('DTRendererService', dtRendererService)
	        .factory('DTRenderer', dtRenderer)
	        .factory('DTDefaultRenderer', dtDefaultRenderer)
	        .factory('DTNGRenderer', dtNGRenderer)
	        .factory('DTPromiseRenderer', dtPromiseRenderer)
	        .factory('DTAjaxRenderer', dtAjaxRenderer)
	        .factory('DTRendererFactory', dtRendererFactory);
	
	    /* @ngInject */
	    function dtRendererService(DTLoadingTemplate) {
	        var plugins = [];
	        var rendererService = {
	            showLoading: showLoading,
	            hideLoading: hideLoading,
	            renderDataTable: renderDataTable,
	            hideLoadingAndRenderDataTable: hideLoadingAndRenderDataTable,
	            registerPlugin: registerPlugin,
	            postRender: postRender,
	            preRender: preRender
	        };
	        return rendererService;
	
	        function showLoading($elem, $scope) {
	            var $loading = angular.element(DTLoadingTemplate.compileHtml($scope));
	            $elem.after($loading);
	            $elem.hide();
	            $loading.show();
	        }
	
	        function hideLoading($elem) {
	            $elem.show();
	            var next = $elem.next();
	            if (DTLoadingTemplate.isLoading(next)) {
	                next.remove();
	            }
	        }
	
	        function renderDataTable($elem, options) {
	            var dtId = '#' + $elem.attr('id');
	            if ($.fn.dataTable.isDataTable(dtId) && angular.isObject(options)) {
	                options.destroy = true;
	            }
	            // See http://datatables.net/manual/api#Accessing-the-API to understand the difference between DataTable and dataTable
	            var DT = $elem.DataTable(options);
	            var dt = $elem.dataTable();
	
	            var result = {
	                id: $elem.attr('id'),
	                DataTable: DT,
	                dataTable: dt
	            };
	
	            postRender(options, result);
	
	            return result;
	        }
	
	        function hideLoadingAndRenderDataTable($elem, options) {
	            rendererService.hideLoading($elem);
	            return rendererService.renderDataTable($elem, options);
	        }
	
	        function registerPlugin(plugin) {
	            plugins.push(plugin);
	        }
	
	        function postRender(options, result) {
	            angular.forEach(plugins, function(plugin) {
	                if (angular.isFunction(plugin.postRender)) {
	                    plugin.postRender(options, result);
	                }
	            });
	        }
	
	        function preRender(options) {
	            angular.forEach(plugins, function(plugin) {
	                if (angular.isFunction(plugin.preRender)) {
	                    plugin.preRender(options);
	                }
	            });
	        }
	    }
	    dtRendererService.$inject = ['DTLoadingTemplate'];
	
	    function dtRenderer() {
	        return {
	            withOptions: function(options) {
	                this.options = options;
	                return this;
	            }
	        };
	    }
	
	    /* @ngInject */
	    function dtDefaultRenderer($q, DTRenderer, DTRendererService, DTInstanceFactory) {
	        return {
	            create: create
	        };
	
	        function create(options) {
	            var _oTable;
	            var _$elem;
	            var _$scope;
	            var renderer = Object.create(DTRenderer);
	            renderer.name = 'DTDefaultRenderer';
	            renderer.options = options;
	            renderer.render = render;
	            renderer.reloadData = reloadData;
	            renderer.changeData = changeData;
	            renderer.rerender = rerender;
	
	            function render($elem, $scope) {
	                _$elem = $elem;
	                _$scope = $scope;
	                var dtInstance = DTInstanceFactory.newDTInstance(renderer);
	                var result = DTRendererService.hideLoadingAndRenderDataTable($elem, renderer.options);
	                _oTable = result.DataTable;
	                DTInstanceFactory.copyDTProperties(result, dtInstance);
	                return $q.when(dtInstance);
	            }
	
	            function reloadData() {
	                // Do nothing
	            }
	
	            function changeData() {
	                // Do nothing
	            }
	
	            function rerender() {
	                _oTable.destroy();
	                DTRendererService.showLoading(_$elem, _$scope);
	                render(_$elem, _$scope);
	            }
	            return renderer;
	        }
	    }
	    dtDefaultRenderer.$inject = ['$q', 'DTRenderer', 'DTRendererService', 'DTInstanceFactory'];
	
	    /* @ngInject */
	    function dtNGRenderer($log, $q, $compile, $timeout, DTRenderer, DTRendererService, DTInstanceFactory) {
	        /**
	         * Renderer for displaying the Angular way
	         * @param options
	         * @returns {{options: *}} the renderer
	         * @constructor
	         */
	        return {
	            create: create
	        };
	
	        function create(options) {
	            var _staticHTML;
	            var _oTable;
	            var _$elem;
	            var _parentScope;
	            var _newParentScope;
	            var dtInstance;
	            var renderer = Object.create(DTRenderer);
	            renderer.name = 'DTNGRenderer';
	            renderer.options = options;
	            renderer.render = render;
	            renderer.reloadData = reloadData;
	            renderer.changeData = changeData;
	            renderer.rerender = rerender;
	            return renderer;
	
	            function render($elem, $scope, staticHTML) {
	                _staticHTML = staticHTML;
	                _$elem = $elem;
	                _parentScope = $scope.$parent;
	                dtInstance = DTInstanceFactory.newDTInstance(renderer);
	
	                var defer = $q.defer();
	                var _$tableElem = _staticHTML.match(/<tbody([\s\S]*)<\/tbody>/i);
	                var _expression = _$tableElem[1];
	                // Find the resources from the comment <!-- ngRepeat: item in items --> displayed by angular in the DOM
	                // This regexp is inspired by the one used in the "ngRepeat" directive
	                var _match = _expression.match(/^\s*.+?\s+in\s+([a-zA-Z0-9\.-_$]*)\s*/m);
	
	                if (!_match) {
	                    throw new Error('Expected expression in form of "_item_ in _collection_[ track by _id_]" but got "{0}".', _expression);
	                }
	                var _ngRepeatAttr = _match[1];
	
	                var _alreadyRendered = false;
	
	                _parentScope.$watchCollection(_ngRepeatAttr, function() {
	                    if (_oTable && _alreadyRendered) {
	                        _destroyAndCompile();
	                    }
	                    $timeout(function() {
	                        _alreadyRendered = true;
	                        // Ensure that prerender is called when the collection is updated
	                        // See https://github.com/l-lin/angular-datatables/issues/502
	                        DTRendererService.preRender(renderer.options);
	                        var result = DTRendererService.hideLoadingAndRenderDataTable(_$elem, renderer.options);
	                        _oTable = result.DataTable;
	                        DTInstanceFactory.copyDTProperties(result, dtInstance);
	                        defer.resolve(dtInstance);
	                    }, 0, false);
	                }, true);
	                return defer.promise;
	            }
	
	            function reloadData() {
	                $log.warn('The Angular Renderer does not support reloading data. You need to do it directly on your model');
	            }
	
	            function changeData() {
	                $log.warn('The Angular Renderer does not support changing the data. You need to change your model directly.');
	            }
	
	            function rerender() {
	                _destroyAndCompile();
	                DTRendererService.showLoading(_$elem, _parentScope);
	                // Ensure that prerender is called after loadData from promise
	                // See https://github.com/l-lin/angular-datatables/issues/563
	                DTRendererService.preRender(options);
	                $timeout(function() {
	                    var result = DTRendererService.hideLoadingAndRenderDataTable(_$elem, renderer.options);
	                    _oTable = result.DataTable;
	                    DTInstanceFactory.copyDTProperties(result, dtInstance);
	                }, 0, false);
	            }
	
	            function _destroyAndCompile() {
	                if (_newParentScope) {
	                    _newParentScope.$destroy();
	                }
	                _oTable.ngDestroy();
	                // Re-compile because we lost the angular binding to the existing data
	                _$elem.html(_staticHTML);
	                _newParentScope = _parentScope.$new();
	                $compile(_$elem.contents())(_newParentScope);
	            }
	        }
	    }
	    dtNGRenderer.$inject = ['$log', '$q', '$compile', '$timeout', 'DTRenderer', 'DTRendererService', 'DTInstanceFactory'];
	
	    /* @ngInject */
	    function dtPromiseRenderer($q, $timeout, $log, DTRenderer, DTRendererService, DTInstanceFactory) {
	        /**
	         * Renderer for displaying with a promise
	         * @param options the options
	         * @returns {{options: *}} the renderer
	         * @constructor
	         */
	        return {
	            create: create
	        };
	
	        function create(options) {
	            var _oTable;
	            var _loadedPromise = null;
	            var _$elem;
	            var _$scope;
	
	            var dtInstance;
	            var renderer = Object.create(DTRenderer);
	            renderer.name = 'DTPromiseRenderer';
	            renderer.options = options;
	            renderer.render = render;
	            renderer.reloadData = reloadData;
	            renderer.changeData = changeData;
	            renderer.rerender = rerender;
	            return renderer;
	
	            function render($elem, $scope) {
	                var defer = $q.defer();
	                dtInstance = DTInstanceFactory.newDTInstance(renderer);
	                _$elem = $elem;
	                _$scope = $scope;
	                _resolve(renderer.options.fnPromise, DTRendererService.renderDataTable).then(function(result) {
	                    _oTable = result.DataTable;
	                    DTInstanceFactory.copyDTProperties(result, dtInstance);
	                    defer.resolve(dtInstance);
	                });
	                return defer.promise;
	            }
	
	            function reloadData(callback, resetPaging) {
	                var previousPage = _oTable && _oTable.page() ? _oTable.page() : 0;
	                if (angular.isFunction(renderer.options.fnPromise)) {
	                    _resolve(renderer.options.fnPromise, _redrawRows).then(function(result) {
	                        if (angular.isFunction(callback)) {
	                            callback(result.DataTable.data());
	                        }
	                        if (resetPaging === false) {
	                            result.DataTable.page(previousPage).draw(false);
	                        }
	                    });
	                } else {
	                    $log.warn('In order to use the reloadData functionality with a Promise renderer, you need to provide a function that returns a promise.');
	                }
	            }
	
	            function changeData(fnPromise) {
	                renderer.options.fnPromise = fnPromise;
	                // We also need to set the $scope.dtOptions, otherwise, when we change the columns, it will revert to the old data
	                // See https://github.com/l-lin/angular-datatables/issues/359
	                _$scope.dtOptions.fnPromise = fnPromise;
	                _resolve(renderer.options.fnPromise, _redrawRows);
	            }
	
	            function rerender() {
	                _oTable.destroy();
	                DTRendererService.showLoading(_$elem, _$scope);
	                // Ensure that prerender is called after loadData from promise
	                // See https://github.com/l-lin/angular-datatables/issues/563
	                DTRendererService.preRender(options);
	                render(_$elem, _$scope);
	            }
	
	            function _resolve(fnPromise, callback) {
	                var defer = $q.defer();
	                if (angular.isUndefined(fnPromise)) {
	                    throw new Error('You must provide a promise or a function that returns a promise!');
	                }
	                if (_loadedPromise) {
	                    _loadedPromise.then(function() {
	                        defer.resolve(_startLoading(fnPromise, callback));
	                    });
	                } else {
	                    defer.resolve(_startLoading(fnPromise, callback));
	                }
	                return defer.promise;
	            }
	
	            function _startLoading(fnPromise, callback) {
	                var defer = $q.defer();
	                if (angular.isFunction(fnPromise)) {
	                    _loadedPromise = fnPromise();
	                } else {
	                    _loadedPromise = fnPromise;
	                }
	                _loadedPromise.then(function(result) {
	                    var data = result;
	                    // In case the data is nested in an object
	                    if (renderer.options.sAjaxDataProp) {
	                        var properties = renderer.options.sAjaxDataProp.split('.');
	                        while (properties.length) {
	                            var property = properties.shift();
	                            if (property in data) {
	                                data = data[property];
	                            }
	                        }
	                    }
	                    _loadedPromise = null;
	                    defer.resolve(_doRender(renderer.options, _$elem, data, callback));
	                });
	                return defer.promise;
	            }
	
	            function _doRender(options, $elem, data, callback) {
	                var defer = $q.defer();
	                // Since Angular 1.3, the promise renderer is throwing "Maximum call stack size exceeded"
	                // By removing the $promise attribute, we avoid an infinite loop when jquery is cloning the data
	                // See https://github.com/l-lin/angular-datatables/issues/110
	                delete data.$promise;
	                options.aaData = data;
	                // Add $timeout to be sure that angular has finished rendering before calling datatables
	                $timeout(function() {
	                    DTRendererService.hideLoading($elem);
	                    // Set it to true in order to be able to redraw the dataTable
	                    options.bDestroy = true;
	                    defer.resolve(callback($elem, options));
	                }, 0, false);
	                return defer.promise;
	            }
	
	            function _redrawRows($elem, options) {
	                _oTable.clear();
	                _oTable.rows.add(options.aaData).draw(options.redraw);
	                return {
	                    id: dtInstance.id,
	                    DataTable: dtInstance.DataTable,
	                    dataTable: dtInstance.dataTable
	                };
	            }
	        }
	    }
	    dtPromiseRenderer.$inject = ['$q', '$timeout', '$log', 'DTRenderer', 'DTRendererService', 'DTInstanceFactory'];
	
	    /* @ngInject */
	    function dtAjaxRenderer($q, $timeout, DTRenderer, DTRendererService, DT_DEFAULT_OPTIONS, DTInstanceFactory) {
	        /**
	         * Renderer for displaying with Ajax
	         * @param options the options
	         * @returns {{options: *}} the renderer
	         * @constructor
	         */
	        return {
	            create: create
	        };
	
	        function create(options) {
	            var _oTable;
	            var _$elem;
	            var _$scope;
	            var renderer = Object.create(DTRenderer);
	            renderer.name = 'DTAjaxRenderer';
	            renderer.options = options;
	            renderer.render = render;
	            renderer.reloadData = reloadData;
	            renderer.changeData = changeData;
	            renderer.rerender = rerender;
	            return renderer;
	
	            function render($elem, $scope) {
	                _$elem = $elem;
	                _$scope = $scope;
	                var defer = $q.defer();
	                var dtInstance = DTInstanceFactory.newDTInstance(renderer);
	                // Define default values in case it is an ajax datatables
	                if (angular.isUndefined(renderer.options.sAjaxDataProp)) {
	                    renderer.options.sAjaxDataProp = DT_DEFAULT_OPTIONS.sAjaxDataProp;
	                }
	                if (angular.isUndefined(renderer.options.aoColumns)) {
	                    renderer.options.aoColumns = DT_DEFAULT_OPTIONS.aoColumns;
	                }
	                _doRender(renderer.options, $elem).then(function(result) {
	                    _oTable = result.DataTable;
	                    DTInstanceFactory.copyDTProperties(result, dtInstance);
	                    defer.resolve(dtInstance);
	                });
	                return defer.promise;
	            }
	
	            function reloadData(callback, resetPaging) {
	                if (_oTable) {
	                    _oTable.ajax.reload(callback, resetPaging);
	                }
	            }
	
	            function changeData(ajax) {
	                renderer.options.ajax = ajax;
	                // We also need to set the $scope.dtOptions, otherwise, when we change the columns, it will revert to the old data
	                // See https://github.com/l-lin/angular-datatables/issues/359
	                _$scope.dtOptions.ajax = ajax;
	            }
	
	            function rerender() {
	                // Ensure that prerender is called after loadData from promise
	                // See https://github.com/l-lin/angular-datatables/issues/563
	                DTRendererService.preRender(options);
	                render(_$elem, _$scope);
	            }
	
	            function _doRender(options, $elem) {
	                var defer = $q.defer();
	                // Destroy the table if it exists in order to be able to redraw the dataTable
	                options.bDestroy = true;
	                if (_oTable) {
	                    _oTable.destroy();
	                    DTRendererService.showLoading(_$elem, _$scope);
	                    // Empty in case of columns change
	                    $elem.empty();
	                }
	                DTRendererService.hideLoading($elem);
	                // Condition to refresh the dataTable
	                if (_shouldDeferRender(options)) {
	                    $timeout(function() {
	                        defer.resolve(DTRendererService.renderDataTable($elem, options));
	                    }, 0, false);
	                } else {
	                    defer.resolve(DTRendererService.renderDataTable($elem, options));
	                }
	                return defer.promise;
	            }
	            // See https://github.com/l-lin/angular-datatables/issues/147
	            function _shouldDeferRender(options) {
	                if (angular.isDefined(options) && angular.isDefined(options.dom)) {
	                    // S for scroller plugin
	                    return options.dom.indexOf('S') >= 0;
	                }
	                return false;
	            }
	        }
	    }
	    dtAjaxRenderer.$inject = ['$q', '$timeout', 'DTRenderer', 'DTRendererService', 'DT_DEFAULT_OPTIONS', 'DTInstanceFactory'];
	
	    /* @ngInject */
	    function dtRendererFactory(DTDefaultRenderer, DTNGRenderer, DTPromiseRenderer, DTAjaxRenderer) {
	        return {
	            fromOptions: fromOptions
	        };
	
	        function fromOptions(options, isNgDisplay) {
	            if (isNgDisplay) {
	                if (options && options.serverSide) {
	                    throw new Error('You cannot use server side processing along with the Angular renderer!');
	                }
	                return DTNGRenderer.create(options);
	            }
	            if (angular.isDefined(options)) {
	                if (angular.isDefined(options.fnPromise) && options.fnPromise !== null) {
	                    if (options.serverSide) {
	                        throw new Error('You cannot use server side processing along with the Promise renderer!');
	                    }
	                    return DTPromiseRenderer.create(options);
	                }
	                if (angular.isDefined(options.ajax) && options.ajax !== null ||
	                    angular.isDefined(options.ajax) && options.ajax !== null) {
	                    return DTAjaxRenderer.create(options);
	                }
	                return DTDefaultRenderer.create(options);
	            }
	            return DTDefaultRenderer.create();
	        }
	    }
	    dtRendererFactory.$inject = ['DTDefaultRenderer', 'DTNGRenderer', 'DTPromiseRenderer', 'DTAjaxRenderer'];
	
	    'use strict';
	
	    angular.module('datatables.util', [])
	        .factory('DTPropertyUtil', dtPropertyUtil);
	
	    /* @ngInject */
	    function dtPropertyUtil($q) {
	        return {
	            overrideProperties: overrideProperties,
	            deleteProperty: deleteProperty,
	            resolveObjectPromises: resolveObjectPromises,
	            resolveArrayPromises: resolveArrayPromises
	        };
	
	        /**
	         * Overrides the source property with the given target properties.
	         * Source is not written. It's making a fresh copy of it in order to ensure that we do not change the parameters.
	         * @param source the source properties to override
	         * @param target the target properties
	         * @returns {*} the object overrided
	         */
	        function overrideProperties(source, target) {
	            var result = angular.copy(source);
	
	            if (angular.isUndefined(result) || result === null) {
	                result = {};
	            }
	            if (angular.isUndefined(target) || target === null) {
	                return result;
	            }
	            if (angular.isObject(target)) {
	                for (var prop in target) {
	                    if (target.hasOwnProperty(prop)) {
	                        result[prop] = overrideProperties(result[prop], target[prop]);
	                    }
	                }
	            } else {
	                result = angular.copy(target);
	            }
	            return result;
	        }
	
	        /**
	         * Delete the property from the given object
	         * @param obj the object
	         * @param propertyName the property name
	         */
	        function deleteProperty(obj, propertyName) {
	            if (angular.isObject(obj)) {
	                delete obj[propertyName];
	            }
	        }
	
	        /**
	         * Resolve any promises from a given object if there are any.
	         * @param obj the object
	         * @param excludedPropertiesName the list of properties to ignore
	         * @returns {promise} the promise that the object attributes promises are all resolved
	         */
	        function resolveObjectPromises(obj, excludedPropertiesName) {
	            var defer = $q.defer(),
	                promises = [],
	                resolvedObj = {},
	                excludedProp = excludedPropertiesName || [];
	            if (!angular.isObject(obj) || angular.isArray(obj)) {
	                defer.resolve(obj);
	            } else {
	                resolvedObj = angular.extend(resolvedObj, obj);
	                for (var prop in resolvedObj) {
	                    if (resolvedObj.hasOwnProperty(prop) && $.inArray(prop, excludedProp) === -1) {
	                        if (angular.isArray(resolvedObj[prop])) {
	                            promises.push(resolveArrayPromises(resolvedObj[prop]));
	                        } else {
	                            promises.push($q.when(resolvedObj[prop]));
	                        }
	                    }
	                }
	                $q.all(promises).then(function(result) {
	                    var index = 0;
	                    for (var prop in resolvedObj) {
	                        if (resolvedObj.hasOwnProperty(prop) && $.inArray(prop, excludedProp) === -1) {
	                            resolvedObj[prop] = result[index++];
	                        }
	                    }
	                    defer.resolve(resolvedObj);
	                });
	            }
	            return defer.promise;
	        }
	
	        /**
	         * Resolve the given array promises
	         * @param array the array containing promise or not
	         * @returns {promise} the promise that the array contains a list of objects/values promises that are resolved
	         */
	        function resolveArrayPromises(array) {
	            var defer = $q.defer(),
	                promises = [],
	                resolveArray = [];
	            if (!angular.isArray(array)) {
	                defer.resolve(array);
	            } else {
	                angular.forEach(array, function(item) {
	                    if (angular.isObject(item)) {
	                        promises.push(resolveObjectPromises(item));
	                    } else {
	                        promises.push($q.when(item));
	                    }
	                });
	                $q.all(promises).then(function(result) {
	                    angular.forEach(result, function(item) {
	                        resolveArray.push(item);
	                    });
	                    defer.resolve(resolveArray);
	                });
	            }
	            return defer.promise;
	        }
	    }
	    dtPropertyUtil.$inject = ['$q'];
	
	
	})(window, document, jQuery, angular);


/***/ }),
/* 259 */
/***/ (function(module, exports) {

	/*!
	 * angular-datatables - v0.6.2
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables.bootstrap';
	}
	(function(window, document, $, angular) {
	
	    'use strict';
	    angular.module('datatables.bootstrap.colvis', ['datatables.bootstrap.options', 'datatables.util'])
	        .service('DTBootstrapColVis', dtBootstrapColVis);
	
	    /* @ngInject */
	    function dtBootstrapColVis(DTPropertyUtil, DTBootstrapDefaultOptions) {
	        var _initializedColVis = false;
	        return {
	            integrate: integrate,
	            deIntegrate: deIntegrate
	        };
	
	        function integrate(addDrawCallbackFunction, bootstrapOptions) {
	            if (!_initializedColVis) {
	                var colVisProperties = DTPropertyUtil.overrideProperties(
	                    DTBootstrapDefaultOptions.getOptions().ColVis,
	                    bootstrapOptions ? bootstrapOptions.ColVis : null
	                );
	                /* ColVis Bootstrap compatibility */
	                if ($.fn.DataTable.ColVis) {
	                    addDrawCallbackFunction(function() {
	                        $('.ColVis_MasterButton').attr('class', 'ColVis_MasterButton ' + colVisProperties.classes.masterButton);
	                        $('.ColVis_Button').removeClass('ColVis_Button');
	                    });
	                }
	
	                _initializedColVis = true;
	            }
	        }
	
	        function deIntegrate() {
	            if (_initializedColVis && $.fn.DataTable.ColVis) {
	                _initializedColVis = false;
	            }
	        }
	    }
	    dtBootstrapColVis.$inject = ['DTPropertyUtil', 'DTBootstrapDefaultOptions'];
	
	    'use strict';
	
	    // See http://getbootstrap.com
	    angular.module('datatables.bootstrap', [
	            'datatables.bootstrap.options',
	            'datatables.bootstrap.tabletools',
	            'datatables.bootstrap.colvis'
	        ])
	        .config(dtBootstrapConfig)
	        .run(initBootstrapPlugin)
	        .service('DTBootstrap', dtBootstrap);
	
	    /* @ngInject */
	    function dtBootstrapConfig($provide) {
	        $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	        function dtOptionsBuilderDecorator($delegate) {
	            var newOptions = $delegate.newOptions;
	            var fromSource = $delegate.fromSource;
	            var fromFnPromise = $delegate.fromFnPromise;
	
	            $delegate.newOptions = function() {
	                return _decorateOptions(newOptions);
	            };
	            $delegate.fromSource = function(ajax) {
	                return _decorateOptions(fromSource, ajax);
	            };
	            $delegate.fromFnPromise = function(fnPromise) {
	                return _decorateOptions(fromFnPromise, fnPromise);
	            };
	
	            return $delegate;
	
	            function _decorateOptions(fn, params) {
	                var options = fn(params);
	                options.withBootstrap = withBootstrap;
	                options.withBootstrapOptions = withBootstrapOptions;
	                return options;
	
	                /**
	                 * Add bootstrap compatibility
	                 * @returns {DTOptions} the options
	                 */
	                function withBootstrap() {
	                    options.hasBootstrap = true;
	                    // Override page button active CSS class
	                    if (angular.isObject(options.oClasses)) {
	                        options.oClasses.sPageButtonActive = 'active';
	                    } else {
	                        options.oClasses = {
	                            sPageButtonActive: 'active'
	                        };
	                    }
	                    return options;
	                }
	
	                /**
	                 * Add bootstrap options
	                 * @param bootstrapOptions the bootstrap options
	                 * @returns {DTOptions} the options
	                 */
	                function withBootstrapOptions(bootstrapOptions) {
	                    options.bootstrap = bootstrapOptions;
	                    return options;
	                }
	            }
	        }
	        dtOptionsBuilderDecorator.$inject = ['$delegate'];
	    }
	    dtBootstrapConfig.$inject = ['$provide'];
	
	    /* @ngInject */
	    function initBootstrapPlugin(DTRendererService, DTBootstrap) {
	        var columnFilterPlugin = {
	            preRender: preRender
	        };
	        DTRendererService.registerPlugin(columnFilterPlugin);
	
	        function preRender(options) {
	            // Integrate bootstrap (or not)
	            if (options && options.hasBootstrap) {
	                DTBootstrap.integrate(options);
	            } else {
	                DTBootstrap.deIntegrate();
	            }
	        }
	    }
	    initBootstrapPlugin.$inject = ['DTRendererService', 'DTBootstrap'];
	
	    /**
	     * Source: https://editor.datatables.net/release/DataTables/extras/Editor/examples/bootstrap.html
	     */
	    /* @ngInject */
	    function dtBootstrap(DTBootstrapTableTools, DTBootstrapColVis, DTBootstrapDefaultOptions, DTPropertyUtil) {
	        var _initialized = false,
	            _drawCallbackFunctionList = [],
	            _savedFn = {};
	
	        return {
	            integrate: integrate,
	            deIntegrate: deIntegrate
	        };
	
	        function _saveFnToBeOverrided() {
	            _savedFn.oStdClasses = angular.copy($.fn.dataTableExt.oStdClasses);
	            _savedFn.fnPagingInfo = $.fn.dataTableExt.oApi.fnPagingInfo;
	            _savedFn.renderer = angular.copy($.fn.DataTable.ext.renderer);
	            if ($.fn.DataTable.TableTools) {
	                _savedFn.TableTools = {
	                    classes: angular.copy($.fn.DataTable.TableTools.classes),
	                    oTags: angular.copy($.fn.DataTable.TableTools.DEFAULTS.oTags)
	                };
	            }
	        }
	
	        function _revertToDTFn() {
	            $.extend($.fn.dataTableExt.oStdClasses, _savedFn.oStdClasses);
	            $.fn.dataTableExt.oApi.fnPagingInfo = _savedFn.fnPagingInfo;
	            $.extend(true, $.fn.DataTable.ext.renderer, _savedFn.renderer);
	        }
	
	        function _overrideClasses() {
	            /* Default class modification */
	            $.extend($.fn.dataTableExt.oStdClasses, {
	                'sWrapper': 'dataTables_wrapper form-inline',
	                'sFilterInput': 'form-control input-sm',
	                'sLengthSelect': 'form-control input-sm',
	                'sFilter': 'dataTables_filter',
	                'sLength': 'dataTables_length'
	            });
	        }
	
	        function _overridePagingInfo() {
	            /* API method to get paging information */
	            $.fn.dataTableExt.oApi.fnPagingInfo = function(oSettings) {
	                return {
	                    'iStart': oSettings._iDisplayStart,
	                    'iEnd': oSettings.fnDisplayEnd(),
	                    'iLength': oSettings._iDisplayLength,
	                    'iTotal': oSettings.fnRecordsTotal(),
	                    'iFilteredTotal': oSettings.fnRecordsDisplay(),
	                    'iPage': oSettings._iDisplayLength === -1 ? 0 : Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength),
	                    'iTotalPages': oSettings._iDisplayLength === -1 ? 0 : Math.ceil(oSettings.fnRecordsDisplay() / oSettings._iDisplayLength)
	                };
	            };
	        }
	
	        function _overridePagination(bootstrapOptions) {
	            // Note: Copy paste with some changes from DataTables v1.10.1 source code
	            $.extend(true, $.fn.DataTable.ext.renderer, {
	                pageButton: {
	                    _: function(settings, host, idx, buttons, page, pages) {
	                        var classes = settings.oClasses;
	                        var lang = settings.language ? settings.language.oPaginate : settings.oLanguage.oPaginate;
	                        var btnDisplay, btnClass, counter = 0;
	                        var paginationClasses = DTPropertyUtil.overrideProperties(
	                            DTBootstrapDefaultOptions.getOptions().pagination,
	                            bootstrapOptions ? bootstrapOptions.pagination : null
	                        );
	                        var $paginationContainer = $('<ul></ul>', {
	                            'class': paginationClasses.classes.ul
	                        });
	
	                        var attach = function(container, buttons) {
	                            var i, ien, node, button;
	                            var clickHandler = function(e) {
	                                e.preventDefault();
	                                // IMPORTANT: Reference to internal functions of DT. It might change between versions
	                                $.fn.DataTable.ext.internal._fnPageChange(settings, e.data.action, true);
	                            };
	
	
	                            for (i = 0, ien = buttons.length; i < ien; i++) {
	                                button = buttons[i];
	
	                                if ($.isArray(button)) {
	                                    // Override DT element
	                                    button.DT_el = 'li';
	                                    var inner = $('<' + (button.DT_el || 'div') + '/>')
	                                        .appendTo($paginationContainer);
	                                    attach(inner, button);
	                                } else {
	                                    btnDisplay = '';
	                                    btnClass = '';
	                                    var $paginationBtn = $('<li></li>'),
	                                        isDisabled;
	
	                                    switch (button) {
	                                        case 'ellipsis':
	                                            $paginationContainer.append('<li class="disabled"><a href="#" onClick="event.preventDefault()">&hellip;</a></li>');
	                                            break;
	
	                                        case 'first':
	                                            btnDisplay = lang.sFirst;
	                                            btnClass = button;
	                                            if (page <= 0) {
	                                                $paginationBtn.addClass(classes.sPageButtonDisabled);
	                                                isDisabled = true;
	                                            }
	                                            break;
	
	                                        case 'previous':
	                                            btnDisplay = lang.sPrevious;
	                                            btnClass = button;
	                                            if (page <= 0) {
	                                                $paginationBtn.addClass(classes.sPageButtonDisabled);
	                                                isDisabled = true;
	                                            }
	                                            break;
	
	                                        case 'next':
	                                            btnDisplay = lang.sNext;
	                                            btnClass = button;
	                                            if (page >= pages - 1) {
	                                                $paginationBtn.addClass(classes.sPageButtonDisabled);
	                                                isDisabled = true;
	                                            }
	                                            break;
	
	                                        case 'last':
	                                            btnDisplay = lang.sLast;
	                                            btnClass = button;
	                                            if (page >= pages - 1) {
	                                                $paginationBtn.addClass(classes.sPageButtonDisabled);
	                                                isDisabled = true;
	                                            }
	                                            break;
	
	                                        default:
	                                            btnDisplay = button + 1;
	                                            btnClass = '';
	                                            if (page === button) {
	                                                $paginationBtn.addClass(classes.sPageButtonActive);
	                                            }
	                                            break;
	                                    }
	
	                                    if (btnDisplay) {
	                                        $paginationBtn.appendTo($paginationContainer);
	                                        node = $('<a>', {
	                                                'href': '#',
	                                                'class': btnClass,
	                                                'aria-controls': settings.sTableId,
	                                                'data-dt-idx': counter,
	                                                'tabindex': settings.iTabIndex,
	                                                'id': idx === 0 && typeof button === 'string' ?
	                                                    settings.sTableId + '_' + button : null
	                                            })
	                                            .html(btnDisplay)
	                                            .appendTo($paginationBtn);
	
	                                        // IMPORTANT: Reference to internal functions of DT. It might change between versions
	                                        $.fn.DataTable.ext.internal._fnBindAction(
	                                            node, {
	                                                action: button
	                                            }, clickHandler
	                                        );
	
	                                        counter++;
	                                    }
	                                }
	                            }
	                        };
	
	                        // IE9 throws an 'unknown error' if document.activeElement is used
	                        // inside an iframe or frame. Try / catch the error. Not good for
	                        // accessibility, but neither are frames.
	                        try {
	                            // Because this approach is destroying and recreating the paging
	                            // elements, focus is lost on the select button which is bad for
	                            // accessibility. So we want to restore focus once the draw has
	                            // completed
	                            var activeEl = $(document.activeElement).data('dt-idx');
	
	                            // Add <ul> to the pagination
	                            var container = $(host).empty();
	                            $paginationContainer.appendTo(container);
	                            attach(container, buttons);
	
	                            if (activeEl !== null) {
	                                $(host).find('[data-dt-idx=' + activeEl + ']').focus();
	                            }
	                        } catch (e) {}
	                    }
	                }
	            });
	        }
	
	        function _addDrawCallbackFunction(fn) {
	            if (angular.isFunction(fn)) {
	                _drawCallbackFunctionList.push(fn);
	            }
	        }
	
	        function _init(bootstrapOptions) {
	            if (!_initialized) {
	                _saveFnToBeOverrided();
	                _overrideClasses();
	                _overridePagingInfo();
	                _overridePagination(bootstrapOptions);
	
	                _addDrawCallbackFunction(function() {
	                    $('div.dataTables_filter').find('input').addClass('form-control');
	                    $('div.dataTables_length').find('select').addClass('form-control');
	                });
	
	                _initialized = true;
	            }
	        }
	
	        function _setDom(options) {
	            if (!options.dom || options.dom === $.fn.dataTable.defaults.sDom) {
	                return DTBootstrapDefaultOptions.getOptions().dom;
	            }
	            return options.dom;
	        }
	        /**
	         * Integrate Bootstrap
	         * @param options the datatables options
	         */
	        function integrate(options) {
	            _init(options.bootstrap);
	            DTBootstrapTableTools.integrate(options.bootstrap);
	            DTBootstrapColVis.integrate(_addDrawCallbackFunction, options.bootstrap);
	
	            options.dom = _setDom(options);
	            if (angular.isUndefined(options.fnDrawCallback)) {
	                // Call every drawcallback functions
	                options.fnDrawCallback = function() {
	                    for (var index = 0; index < _drawCallbackFunctionList.length; index++) {
	                        _drawCallbackFunctionList[index]();
	                    }
	                };
	            }
	        }
	
	        function deIntegrate() {
	            if (_initialized) {
	                _revertToDTFn();
	                DTBootstrapTableTools.deIntegrate();
	                DTBootstrapColVis.deIntegrate();
	                _initialized = false;
	            }
	        }
	    }
	    dtBootstrap.$inject = ['DTBootstrapTableTools', 'DTBootstrapColVis', 'DTBootstrapDefaultOptions', 'DTPropertyUtil'];
	
	    'use strict';
	    angular.module('datatables.bootstrap.options', ['datatables.options', 'datatables.util'])
	        .constant('DT_BOOTSTRAP_DEFAULT_OPTIONS', {
	            TableTools: {
	                classes: {
	                    container: 'DTTT btn-group',
	                    buttons: {
	                        normal: 'btn btn-default',
	                        disabled: 'disabled'
	                    },
	                    collection: {
	                        container: 'DTTT_dropdown dropdown-menu',
	                        buttons: {
	                            normal: '',
	                            disabled: 'disabled'
	                        }
	                    },
	                    print: {
	                        info: 'DTTT_print_info modal'
	                    },
	                    select: {
	                        row: 'active'
	                    }
	                },
	                DEFAULTS: {
	                    oTags: {
	                        collection: {
	                            container: 'ul',
	                            button: 'li',
	                            liner: 'a'
	                        }
	                    }
	                }
	            },
	            ColVis: {
	                classes: {
	                    masterButton: 'btn btn-default'
	                }
	            },
	            pagination: {
	                classes: {
	                    ul: 'pagination'
	                }
	            },
	            dom: '<\'row\'<\'col-xs-6\'l><\'col-xs-6\'f>r>t<\'row\'<\'col-xs-6\'i><\'col-xs-6\'p>>'
	        })
	        .factory('DTBootstrapDefaultOptions', dtBootstrapDefaultOptions);
	
	    /* @ngInject */
	    function dtBootstrapDefaultOptions(DTDefaultOptions, DTPropertyUtil, DT_BOOTSTRAP_DEFAULT_OPTIONS) {
	        return {
	            getOptions: getOptions
	        };
	        /**
	         * Get the default options for bootstrap integration
	         * @returns {*} the bootstrap default options
	         */
	        function getOptions() {
	            return DTPropertyUtil.overrideProperties(DT_BOOTSTRAP_DEFAULT_OPTIONS, DTDefaultOptions.bootstrapOptions);
	        }
	    }
	    dtBootstrapDefaultOptions.$inject = ['DTDefaultOptions', 'DTPropertyUtil', 'DT_BOOTSTRAP_DEFAULT_OPTIONS'];
	
	    'use strict';
	
	    angular.module('datatables.bootstrap.tabletools', ['datatables.bootstrap.options', 'datatables.util'])
	        .service('DTBootstrapTableTools', dtBootstrapTableTools);
	
	    /* @ngInject */
	    function dtBootstrapTableTools(DTPropertyUtil, DTBootstrapDefaultOptions) {
	        var _initializedTableTools = false,
	            _savedFn = {};
	
	        return {
	            integrate: integrate,
	            deIntegrate: deIntegrate
	        };
	
	        function integrate(bootstrapOptions) {
	            if (!_initializedTableTools) {
	                _saveFnToBeOverrided();
	
	                /*
	                 * TableTools Bootstrap compatibility
	                 * Required TableTools 2.1+
	                 */
	                if ($.fn.DataTable.TableTools) {
	                    var tableToolsOptions = DTPropertyUtil.overrideProperties(
	                        DTBootstrapDefaultOptions.getOptions().TableTools,
	                        bootstrapOptions ? bootstrapOptions.TableTools : null
	                    );
	                    // Set the classes that TableTools uses to something suitable for Bootstrap
	                    $.extend(true, $.fn.DataTable.TableTools.classes, tableToolsOptions.classes);
	
	                    // Have the collection use a bootstrap compatible dropdown
	                    $.extend(true, $.fn.DataTable.TableTools.DEFAULTS.oTags, tableToolsOptions.DEFAULTS.oTags);
	                }
	
	                _initializedTableTools = true;
	            }
	        }
	
	        function deIntegrate() {
	            if (_initializedTableTools && $.fn.DataTable.TableTools && _savedFn.TableTools) {
	                $.extend(true, $.fn.DataTable.TableTools.classes, _savedFn.TableTools.classes);
	                $.extend(true, $.fn.DataTable.TableTools.DEFAULTS.oTags, _savedFn.TableTools.oTags);
	                _initializedTableTools = false;
	            }
	        }
	
	        function _saveFnToBeOverrided() {
	            if ($.fn.DataTable.TableTools) {
	                _savedFn.TableTools = {
	                    classes: angular.copy($.fn.DataTable.TableTools.classes),
	                    oTags: angular.copy($.fn.DataTable.TableTools.DEFAULTS.oTags)
	                };
	            }
	        }
	    }
	    dtBootstrapTableTools.$inject = ['DTPropertyUtil', 'DTBootstrapDefaultOptions'];
	
	
	})(window, document, jQuery, angular);


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	/*!
	 * angular-datatables - v0.6.2
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables.colreorder';
	}
	(function(window, document, $, angular) {
	
	    'use strict';
	
	    // See https://datatables.net/extras/colreorder/
	    angular.module('datatables.colreorder', ['datatables'])
	        .config(dtColReorderConfig);
	
	    /* @ngInject */
	    function dtColReorderConfig($provide) {
	        $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	        function dtOptionsBuilderDecorator($delegate) {
	            var newOptions = $delegate.newOptions;
	            var fromSource = $delegate.fromSource;
	            var fromFnPromise = $delegate.fromFnPromise;
	
	            $delegate.newOptions = function() {
	                return _decorateOptions(newOptions);
	            };
	            $delegate.fromSource = function(ajax) {
	                return _decorateOptions(fromSource, ajax);
	            };
	            $delegate.fromFnPromise = function(fnPromise) {
	                return _decorateOptions(fromFnPromise, fnPromise);
	            };
	
	            return $delegate;
	
	            function _decorateOptions(fn, params) {
	                var options = fn(params);
	                options.withColReorder = withColReorder;
	                options.withColReorderOption = withColReorderOption;
	                options.withColReorderOrder = withColReorderOrder;
	                options.withColReorderCallback = withColReorderCallback;
	                return options;
	
	                /**
	                 * Add colReorder compatibility
	                 * @returns {DTOptions} the options
	                 */
	                function withColReorder() {
	                    var colReorderPrefix = 'R';
	                    options.dom = options.dom ? options.dom : $.fn.dataTable.defaults.sDom;
	                    if (options.dom.indexOf(colReorderPrefix) === -1) {
	                        options.dom = colReorderPrefix + options.dom;
	                    }
	                    options.hasColReorder = true;
	                    return options;
	                }
	
	                /**
	                 * Add option to "oColReorder" option
	                 * @param key the key of the option to add
	                 * @param value an object or a function of the function
	                 * @return {DTOptions} the options
	                 */
	                function withColReorderOption(key, value) {
	                    if (angular.isString(key)) {
	                        options.oColReorder = options.oColReorder && options.oColReorder !== null ? options.oColReorder : {};
	                        options.oColReorder[key] = value;
	                    }
	                    return options;
	                }
	
	                /**
	                 * Set the default column order
	                 * @param aiOrder the column order
	                 * @returns {DTOptions} the options
	                 */
	                function withColReorderOrder(aiOrder) {
	                    if (angular.isArray(aiOrder)) {
	                        options.withColReorderOption('aiOrder', aiOrder);
	                    }
	                    return options;
	                }
	
	                /**
	                 * Set the reorder callback function
	                 * @param fnReorderCallback the callback
	                 * @returns {DTOptions} the options
	                 */
	                function withColReorderCallback(fnReorderCallback) {
	                    if (angular.isFunction(fnReorderCallback)) {
	                        options.withColReorderOption('fnReorderCallback', fnReorderCallback);
	                    } else {
	                        throw new Error('The reorder callback must be a function');
	                    }
	                    return options;
	                }
	            }
	        }
	        dtOptionsBuilderDecorator.$inject = ['$delegate'];
	    }
	    dtColReorderConfig.$inject = ['$provide'];
	
	
	})(window, document, jQuery, angular);


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	/*!
	 * angular-datatables - v0.6.2
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables.columnfilter';
	}
	(function(window, document, $, angular) {
	
	    'use strict';
	
	    // See http://jquery-datatables-column-filter.googlecode.com/svn/trunk/index.html
	    angular.module('datatables.columnfilter', ['datatables'])
	        .config(dtColumnFilterConfig)
	        .run(initColumnFilterPlugin);
	
	    /* @ngInject */
	    function dtColumnFilterConfig($provide) {
	        $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	        function dtOptionsBuilderDecorator($delegate) {
	            var newOptions = $delegate.newOptions;
	            var fromSource = $delegate.fromSource;
	            var fromFnPromise = $delegate.fromFnPromise;
	
	            $delegate.newOptions = function() {
	                return _decorateOptions(newOptions);
	            };
	            $delegate.fromSource = function(ajax) {
	                return _decorateOptions(fromSource, ajax);
	            };
	            $delegate.fromFnPromise = function(fnPromise) {
	                return _decorateOptions(fromFnPromise, fnPromise);
	            };
	
	            return $delegate;
	
	            function _decorateOptions(fn, params) {
	                var options = fn(params);
	                options.withColumnFilter = withColumnFilter;
	                return options;
	
	                /**
	                 * Add column filter support
	                 * @param columnFilterOptions the plugins options
	                 * @returns {DTOptions} the options
	                 */
	                function withColumnFilter(columnFilterOptions) {
	                    options.hasColumnFilter = true;
	                    if (columnFilterOptions) {
	                        options.columnFilterOptions = columnFilterOptions;
	                    }
	                    return options;
	                }
	            }
	        }
	        dtOptionsBuilderDecorator.$inject = ['$delegate'];
	    }
	    dtColumnFilterConfig.$inject = ['$provide'];
	
	    /* @ngInject */
	    function initColumnFilterPlugin(DTRendererService) {
	        var columnFilterPlugin = {
	            postRender: postRender
	        };
	        DTRendererService.registerPlugin(columnFilterPlugin);
	
	        function postRender(options, result) {
	            if (options && options.hasColumnFilter) {
	                result.dataTable.columnFilter(options.columnFilterOptions);
	            }
	        }
	    }
	    initColumnFilterPlugin.$inject = ['DTRendererService'];
	
	
	})(window, document, jQuery, angular);


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	/*!
	 * angular-datatables - v0.6.2
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables.light-columnfilter';
	}
	(function(window, document, $, angular) {
	
	    'use strict';
	
	    // See https://github.com/thansen-solire/datatables-light-columnfilter
	    angular.module('datatables.light-columnfilter', ['datatables'])
	        .config(dtLightColumnFilterConfig)
	        .run(initLightColumnFilterPlugin);
	
	    /* @ngInject */
	    function dtLightColumnFilterConfig($provide) {
	        $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	        function dtOptionsBuilderDecorator($delegate) {
	            var newOptions = $delegate.newOptions;
	            var fromSource = $delegate.fromSource;
	            var fromFnPromise = $delegate.fromFnPromise;
	
	            $delegate.newOptions = function() {
	                return _decorateOptions(newOptions);
	            };
	            $delegate.fromSource = function(ajax) {
	                return _decorateOptions(fromSource, ajax);
	            };
	            $delegate.fromFnPromise = function(fnPromise) {
	                return _decorateOptions(fromFnPromise, fnPromise);
	            };
	
	            return $delegate;
	
	            function _decorateOptions(fn, params) {
	                var options = fn(params);
	                options.withLightColumnFilter = withLightColumnFilter;
	                return options;
	
	                /**
	                 * Add column filter support
	                 * @param lightColumnFilterOptions the plugins options
	                 * @returns {DTOptions} the options
	                 */
	                function withLightColumnFilter(lightColumnFilterOptions) {
	                    options.hasLightColumnFilter = true;
	                    if (lightColumnFilterOptions) {
	                        options.lightColumnFilterOptions = lightColumnFilterOptions;
	                    }
	                    return options;
	                }
	            }
	        }
	        dtOptionsBuilderDecorator.$inject = ['$delegate'];
	    }
	    dtLightColumnFilterConfig.$inject = ['$provide'];
	
	    /* @ngInject */
	    function initLightColumnFilterPlugin(DTRendererService) {
	        var lightColumnFilterPlugin = {
	            postRender: postRender
	        };
	        DTRendererService.registerPlugin(lightColumnFilterPlugin);
	
	        function postRender(options, result) {
	            if (options && options.hasLightColumnFilter) {
	                new $.fn.dataTable.ColumnFilter(result.DataTable, options.lightColumnFilterOptions);
	            }
	        }
	    }
	    initLightColumnFilterPlugin.$inject = ['DTRendererService'];
	
	
	})(window, document, jQuery, angular);


/***/ }),
/* 263 */
/***/ (function(module, exports) {

	/*!
	 * angular-datatables - v0.6.2
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables.colvis';
	}
	(function(window, document, $, angular) {
	
	    'use strict';
	
	    // See https://datatables.net/extras/colvis/
	    angular.module('datatables.colvis', ['datatables'])
	        .config(dtColVisConfig);
	
	    /* @ngInject */
	    function dtColVisConfig($provide) {
	        $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	        function dtOptionsBuilderDecorator($delegate) {
	            var newOptions = $delegate.newOptions;
	            var fromSource = $delegate.fromSource;
	            var fromFnPromise = $delegate.fromFnPromise;
	
	            $delegate.newOptions = function() {
	                return _decorateOptions(newOptions);
	            };
	            $delegate.fromSource = function(ajax) {
	                return _decorateOptions(fromSource, ajax);
	            };
	            $delegate.fromFnPromise = function(fnPromise) {
	                return _decorateOptions(fromFnPromise, fnPromise);
	            };
	
	            return $delegate;
	
	            function _decorateOptions(fn, params) {
	                var options = fn(params);
	                options.withColVis = withColVis;
	                options.withColVisOption = withColVisOption;
	                options.withColVisStateChange = withColVisStateChange;
	                return options;
	
	                /**
	                 * Add colVis compatibility
	                 * @returns {DTOptions} the options
	                 */
	                function withColVis() {
	                    console.warn('The colvis extension has been retired. Please use the button extension instead: https://datatables.net/extensions/buttons/');
	                    var colVisPrefix = 'C';
	                    options.dom = options.dom ? options.dom : $.fn.dataTable.defaults.sDom;
	                    if (options.dom.indexOf(colVisPrefix) === -1) {
	                        options.dom = colVisPrefix + options.dom;
	                    }
	                    options.hasColVis = true;
	                    return options;
	                }
	
	                /**
	                 * Add option to "oColVis" option
	                 * @param key the key of the option to add
	                 * @param value an object or a function of the function
	                 * @returns {DTOptions} the options
	                 */
	                function withColVisOption(key, value) {
	                    if (angular.isString(key)) {
	                        options.oColVis = options.oColVis && options.oColVis !== null ? options.oColVis : {};
	                        options.oColVis[key] = value;
	                    }
	                    return options;
	                }
	
	                /**
	                 * Set the state change function
	                 * @param fnStateChange  the state change function
	                 * @returns {DTOptions} the options
	                 */
	                function withColVisStateChange(fnStateChange) {
	                    if (angular.isFunction(fnStateChange)) {
	                        options.withColVisOption('fnStateChange', fnStateChange);
	                    } else {
	                        throw new Error('The state change must be a function');
	                    }
	                    return options;
	                }
	            }
	        }
	        dtOptionsBuilderDecorator.$inject = ['$delegate'];
	    }
	    dtColVisConfig.$inject = ['$provide'];
	
	
	})(window, document, jQuery, angular);


/***/ }),
/* 264 */
/***/ (function(module, exports) {

	/*!
	 * angular-datatables - v0.6.2
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables.fixedcolumns';
	}
	(function(window, document, $, angular) {
	
	    'use strict';
	
	    // See https://datatables.net/extensions/fixedcolumns/
	    angular.module('datatables.fixedcolumns', ['datatables'])
	        .config(dtFixedColumnsConfig);
	
	    /* @ngInject */
	    function dtFixedColumnsConfig($provide) {
	        $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	        function dtOptionsBuilderDecorator($delegate) {
	            var newOptions = $delegate.newOptions;
	            var fromSource = $delegate.fromSource;
	            var fromFnPromise = $delegate.fromFnPromise;
	
	            $delegate.newOptions = function() {
	                return _decorateOptions(newOptions);
	            };
	            $delegate.fromSource = function(ajax) {
	                return _decorateOptions(fromSource, ajax);
	            };
	            $delegate.fromFnPromise = function(fnPromise) {
	                return _decorateOptions(fromFnPromise, fnPromise);
	            };
	
	            return $delegate;
	
	            function _decorateOptions(fn, params) {
	                var options = fn(params);
	                options.withFixedColumns = withFixedColumns;
	                return options;
	
	                /**
	                 * Add fixed columns support
	                 * @param fixedColumnsOptions the plugin options
	                 * @returns {DTOptions} the options
	                 */
	                function withFixedColumns(fixedColumnsOptions) {
	                    options.fixedColumns = true;
	                    if (fixedColumnsOptions) {
	                        options.fixedColumns = fixedColumnsOptions;
	                    }
	                    return options;
	                }
	            }
	        }
	        dtOptionsBuilderDecorator.$inject = ['$delegate'];
	    }
	    dtFixedColumnsConfig.$inject = ['$provide'];
	
	
	})(window, document, jQuery, angular);


/***/ }),
/* 265 */
/***/ (function(module, exports) {

	/*!
	 * angular-datatables - v0.6.2
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables.fixedheader';
	}
	(function(window, document, $, angular) {
	
	    'use strict';
	
	    // See https://datatables.net/extensions/fixedheader/
	    angular.module('datatables.fixedheader', ['datatables'])
	        .config(dtFixedHeaderConfig)
	        .run(initFixedHeaderPlugin);
	
	    /* @ngInject */
	    function dtFixedHeaderConfig($provide) {
	        $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	        function dtOptionsBuilderDecorator($delegate) {
	            var newOptions = $delegate.newOptions;
	            var fromSource = $delegate.fromSource;
	            var fromFnPromise = $delegate.fromFnPromise;
	
	            $delegate.newOptions = function() {
	                return _decorateOptions(newOptions);
	            };
	            $delegate.fromSource = function(ajax) {
	                return _decorateOptions(fromSource, ajax);
	            };
	            $delegate.fromFnPromise = function(fnPromise) {
	                return _decorateOptions(fromFnPromise, fnPromise);
	            };
	
	            return $delegate;
	
	            function _decorateOptions(fn, params) {
	                var options = fn(params);
	                options.withFixedHeader = withFixedHeader;
	                return options;
	
	                /**
	                 * Add fixed header support
	                 * @param fixedHeaderOptions the plugin options
	                 * @returns {DTOptions} the options
	                 */
	                function withFixedHeader(fixedHeaderOptions) {
	                    options.hasFixedHeader = true;
	                    if (fixedHeaderOptions) {
	                        options.fixedHeaderOptions = fixedHeaderOptions;
	                    }
	                    return options;
	                }
	            }
	        }
	        dtOptionsBuilderDecorator.$inject = ['$delegate'];
	    }
	    dtFixedHeaderConfig.$inject = ['$provide'];
	
	    /* @ngInject */
	    function initFixedHeaderPlugin(DTRendererService) {
	        var fixedHeaderPlugin = {
	            postRender: postRender
	        };
	        DTRendererService.registerPlugin(fixedHeaderPlugin);
	
	        function postRender(options, result) {
	            if (options && options.hasFixedHeader) {
	                new $.fn.dataTable.FixedHeader(result.DataTable, options.fixedHeaderOptions);
	            }
	        }
	    }
	    initFixedHeaderPlugin.$inject = ['DTRendererService'];
	
	
	})(window, document, jQuery, angular);


/***/ }),
/* 266 */
/***/ (function(module, exports) {

	/*!
	 * angular-datatables - v0.6.2
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables.scroller';
	}
	(function(window, document, $, angular) {
	
	    'use strict';
	
	    // See http://datatables.net/extensions/scroller/
	    angular.module('datatables.scroller', ['datatables'])
	        .config(dtScrollerConfig);
	
	    /* @ngInject */
	    function dtScrollerConfig($provide) {
	        $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	        function dtOptionsBuilderDecorator($delegate) {
	            var newOptions = $delegate.newOptions;
	            var fromSource = $delegate.fromSource;
	            var fromFnPromise = $delegate.fromFnPromise;
	
	            $delegate.newOptions = function() {
	                return _decorateOptions(newOptions);
	            };
	            $delegate.fromSource = function(ajax) {
	                return _decorateOptions(fromSource, ajax);
	            };
	            $delegate.fromFnPromise = function(fnPromise) {
	                return _decorateOptions(fromFnPromise, fnPromise);
	            };
	
	            return $delegate;
	
	            function _decorateOptions(fn, params) {
	                var options = fn(params);
	                options.withScroller = withScroller;
	                return options;
	
	                /**
	                 * Add scroller compatibility
	                 * @returns {DTOptions} the options
	                 */
	                function withScroller() {
	                    var scrollerSuffix = 'S';
	                    options.dom = options.dom ? options.dom : $.fn.dataTable.defaults.sDom;
	                    if (options.dom.indexOf(scrollerSuffix) === -1) {
	                        options.dom = options.dom + scrollerSuffix;
	                    }
	                    return options;
	                }
	            }
	        }
	        dtOptionsBuilderDecorator.$inject = ['$delegate'];
	    }
	    dtScrollerConfig.$inject = ['$provide'];
	
	
	})(window, document, jQuery, angular);


/***/ }),
/* 267 */
/***/ (function(module, exports) {

	/*!
	 * angular-datatables - v0.6.2
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables.tabletools';
	}
	(function(window, document, $, angular) {
	
	    'use strict';
	
	    // See https://datatables.net/extras/tabletools/
	    angular.module('datatables.tabletools', ['datatables'])
	        .config(dtTableToolsConfig);
	
	    /* @ngInject */
	    function dtTableToolsConfig($provide) {
	        $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	        function dtOptionsBuilderDecorator($delegate) {
	            var newOptions = $delegate.newOptions;
	            var fromSource = $delegate.fromSource;
	            var fromFnPromise = $delegate.fromFnPromise;
	
	            $delegate.newOptions = function() {
	                return _decorateOptions(newOptions);
	            };
	            $delegate.fromSource = function(ajax) {
	                return _decorateOptions(fromSource, ajax);
	            };
	            $delegate.fromFnPromise = function(fnPromise) {
	                return _decorateOptions(fromFnPromise, fnPromise);
	            };
	
	            return $delegate;
	
	            function _decorateOptions(fn, params) {
	                var options = fn(params);
	                options.withTableTools = withTableTools;
	                options.withTableToolsOption = withTableToolsOption;
	                options.withTableToolsButtons = withTableToolsButtons;
	                return options;
	
	                /**
	                 * Add table tools compatibility
	                 * @param sSwfPath the path to the swf file to export in csv/xls
	                 * @returns {DTOptions} the options
	                 */
	                function withTableTools(sSwfPath) {
	                    console.warn('The tabletools extension has been retired. Please use the select and buttons extensions instead: https://datatables.net/extensions/select/ and https://datatables.net/extensions/buttons/');
	                    var tableToolsPrefix = 'T';
	                    options.dom = options.dom ? options.dom : $.fn.dataTable.defaults.sDom;
	                    if (options.dom.indexOf(tableToolsPrefix) === -1) {
	                        options.dom = tableToolsPrefix + options.dom;
	                    }
	                    options.hasTableTools = true;
	                    if (angular.isString(sSwfPath)) {
	                        options.withTableToolsOption('sSwfPath', sSwfPath);
	                    }
	                    return options;
	                }
	
	                /**
	                 * Add option to "oTableTools" option
	                 * @param key the key of the option to add
	                 * @param value an object or a function of the function
	                 * @returns {DTOptions} the options
	                 */
	                function withTableToolsOption(key, value) {
	                    if (angular.isString(key)) {
	                        options.oTableTools = options.oTableTools && options.oTableTools !== null ? options.oTableTools : {};
	                        options.oTableTools[key] = value;
	                    }
	                    return options;
	                }
	
	                /**
	                 * Set the table tools buttons to display
	                 * @param aButtons the array of buttons to display
	                 * @returns {DTOptions} the options
	                 */
	                function withTableToolsButtons(aButtons) {
	                    if (angular.isArray(aButtons)) {
	                        options.withTableToolsOption('aButtons', aButtons);
	                    }
	                    return options;
	                }
	            }
	        }
	        dtOptionsBuilderDecorator.$inject = ['$delegate'];
	    }
	    dtTableToolsConfig.$inject = ['$provide'];
	
	
	})(window, document, jQuery, angular);


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	/*!
	 * angular-datatables - v0.6.2
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables.buttons';
	}
	(function(window, document, $, angular) {
	
	    'use strict';
	
	    // See https://datatables.net/extensions/buttons/
	    angular.module('datatables.buttons', ['datatables'])
	        .config(dtButtonsConfig)
	        .run(initButtonsPlugin);
	
	    /* @ngInject */
	    function dtButtonsConfig($provide) {
	        $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	        function dtOptionsBuilderDecorator($delegate) {
	            var newOptions = $delegate.newOptions;
	            var fromSource = $delegate.fromSource;
	            var fromFnPromise = $delegate.fromFnPromise;
	
	            $delegate.newOptions = function() {
	                return _decorateOptions(newOptions);
	            };
	            $delegate.fromSource = function(ajax) {
	                return _decorateOptions(fromSource, ajax);
	            };
	            $delegate.fromFnPromise = function(fnPromise) {
	                return _decorateOptions(fromFnPromise, fnPromise);
	            };
	
	            return $delegate;
	
	            function _decorateOptions(fn, params) {
	                var options = fn(params);
	                options.withButtons = withButtons;
	                return options;
	
	                /**
	                 * Add buttons compatibility
	                 * @param buttonsOptions the options of the buttons extension (see https://datatables.net/reference/option/buttons#Examples)
	                 * @returns {DTOptions} the options
	                 */
	                function withButtons(buttonsOptions) {
	                    var buttonsPrefix = 'B';
	                    options.dom = options.dom ? options.dom : $.fn.dataTable.defaults.sDom;
	                    if (options.dom.indexOf(buttonsPrefix) === -1) {
	                        options.dom = buttonsPrefix + options.dom;
	                    }
	                    if (angular.isUndefined(buttonsOptions)) {
	                        throw new Error('You must define the options for the button extension. See https://datatables.net/reference/option/buttons#Examples for some example');
	                    }
	                    options.buttons = buttonsOptions;
	                    return options;
	                }
	            }
	        }
	        dtOptionsBuilderDecorator.$inject = ['$delegate'];
	    }
	    dtButtonsConfig.$inject = ['$provide'];
	
	    /* @ngInject */
	    function initButtonsPlugin(DTRendererService) {
	        var buttonsPlugin = {
	            preRender: preRender,
	            postRender: postRender
	        };
	        DTRendererService.registerPlugin(buttonsPlugin);
	
	        function preRender(options) {
	            if (options && angular.isArray(options.buttons)) {
	                // The extension buttons seems to clear the content of the options.buttons for some reasons...
	                // So, we save it in a tmp variable so that we can restore it afterwards
	                // See https://github.com/l-lin/angular-datatables/issues/502
	                options.buttonsTmp = options.buttons.slice();
	            }
	        }
	
	        function postRender(options) {
	            if (options && angular.isDefined(options.buttonsTmp)) {
	                // Restore the buttons options
	                options.buttons = options.buttonsTmp;
	                delete options.buttonsTmp;
	            }
	        }
	    }
	    initButtonsPlugin.$inject = ['DTRendererService'];
	
	
	})(window, document, jQuery, angular);


/***/ }),
/* 269 */
/***/ (function(module, exports) {

	/*!
	 * angular-datatables - v0.6.2
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables.select';
	}
	(function(window, document, $, angular) {
	
	    'use strict';
	
	    // See https://datatables.net/extensions/select/
	    angular.module('datatables.select', ['datatables'])
	        .config(dtSelectConfig);
	
	    /* @ngInject */
	    function dtSelectConfig($provide) {
	        $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	        function dtOptionsBuilderDecorator($delegate) {
	            var newOptions = $delegate.newOptions;
	            var fromSource = $delegate.fromSource;
	            var fromFnPromise = $delegate.fromFnPromise;
	
	            $delegate.newOptions = function() {
	                return _decorateOptions(newOptions);
	            };
	            $delegate.fromSource = function(ajax) {
	                return _decorateOptions(fromSource, ajax);
	            };
	            $delegate.fromFnPromise = function(fnPromise) {
	                return _decorateOptions(fromFnPromise, fnPromise);
	            };
	
	            return $delegate;
	
	            function _decorateOptions(fn, params) {
	                var options = fn(params);
	                options.withSelect = withSelect;
	                return options;
	
	                /**
	                 * Add select compatibility
	                 * @param selectOptions the options of the select extension (see https://datatables.net/reference/option/#select)
	                 * @returns {DTOptions} the options
	                 */
	                function withSelect(selectOptions) {
	                    if (angular.isUndefined(selectOptions)) {
	                        throw new Error('You must define the options for the select extension. See https://datatables.net/reference/option/#select');
	                    }
	                    options.select = selectOptions;
	                    return options;
	                }
	            }
	        }
	        dtOptionsBuilderDecorator.$inject = ['$delegate'];
	    }
	    dtSelectConfig.$inject = ['$provide'];
	
	
	})(window, document, jQuery, angular);


/***/ }),
/* 270 */
5,
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Responsive 2.1.1
	 * 2014-2016 SpryMedia Ltd - datatables.net/license
	 */
	
	/**
	 * @summary     Responsive
	 * @description Responsive tables plug-in for DataTables
	 * @version     2.1.1
	 * @file        dataTables.responsive.js
	 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
	 * @contact     www.sprymedia.co.uk/contact
	 * @copyright   Copyright 2014-2016 SpryMedia Ltd.
	 *
	 * This source file is free software, available under the following license:
	 *   MIT license - http://datatables.net/license/mit
	 *
	 * This source file is distributed in the hope that it will be useful, but
	 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
	 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
	 *
	 * For details please refer to: http://www.datatables.net
	 */
	(function( factory ){
		if ( true ) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
				return factory( $, window, document );
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if ( typeof exports === 'object' ) {
			// CommonJS
			module.exports = function (root, $) {
				if ( ! root ) {
					root = window;
				}
	
				if ( ! $ || ! $.fn.dataTable ) {
					$ = require('datatables.net')(root, $).$;
				}
	
				return factory( $, root, root.document );
			};
		}
		else {
			// Browser
			factory( jQuery, window, document );
		}
	}(function( $, window, document, undefined ) {
	'use strict';
	var DataTable = $.fn.dataTable;
	
	
	/**
	 * Responsive is a plug-in for the DataTables library that makes use of
	 * DataTables' ability to change the visibility of columns, changing the
	 * visibility of columns so the displayed columns fit into the table container.
	 * The end result is that complex tables will be dynamically adjusted to fit
	 * into the viewport, be it on a desktop, tablet or mobile browser.
	 *
	 * Responsive for DataTables has two modes of operation, which can used
	 * individually or combined:
	 *
	 * * Class name based control - columns assigned class names that match the
	 *   breakpoint logic can be shown / hidden as required for each breakpoint.
	 * * Automatic control - columns are automatically hidden when there is no
	 *   room left to display them. Columns removed from the right.
	 *
	 * In additional to column visibility control, Responsive also has built into
	 * options to use DataTables' child row display to show / hide the information
	 * from the table that has been hidden. There are also two modes of operation
	 * for this child row display:
	 *
	 * * Inline - when the control element that the user can use to show / hide
	 *   child rows is displayed inside the first column of the table.
	 * * Column - where a whole column is dedicated to be the show / hide control.
	 *
	 * Initialisation of Responsive is performed by:
	 *
	 * * Adding the class `responsive` or `dt-responsive` to the table. In this case
	 *   Responsive will automatically be initialised with the default configuration
	 *   options when the DataTable is created.
	 * * Using the `responsive` option in the DataTables configuration options. This
	 *   can also be used to specify the configuration options, or simply set to
	 *   `true` to use the defaults.
	 *
	 *  @class
	 *  @param {object} settings DataTables settings object for the host table
	 *  @param {object} [opts] Configuration options
	 *  @requires jQuery 1.7+
	 *  @requires DataTables 1.10.3+
	 *
	 *  @example
	 *      $('#example').DataTable( {
	 *        responsive: true
	 *      } );
	 *    } );
	 */
	var Responsive = function ( settings, opts ) {
		// Sanity check that we are using DataTables 1.10 or newer
		if ( ! DataTable.versionCheck || ! DataTable.versionCheck( '1.10.3' ) ) {
			throw 'DataTables Responsive requires DataTables 1.10.3 or newer';
		}
	
		this.s = {
			dt: new DataTable.Api( settings ),
			columns: [],
			current: []
		};
	
		// Check if responsive has already been initialised on this table
		if ( this.s.dt.settings()[0].responsive ) {
			return;
		}
	
		// details is an object, but for simplicity the user can give it as a string
		// or a boolean
		if ( opts && typeof opts.details === 'string' ) {
			opts.details = { type: opts.details };
		}
		else if ( opts && opts.details === false ) {
			opts.details = { type: false };
		}
		else if ( opts && opts.details === true ) {
			opts.details = { type: 'inline' };
		}
	
		this.c = $.extend( true, {}, Responsive.defaults, DataTable.defaults.responsive, opts );
		settings.responsive = this;
		this._constructor();
	};
	
	$.extend( Responsive.prototype, {
		/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
		 * Constructor
		 */
	
		/**
		 * Initialise the Responsive instance
		 *
		 * @private
		 */
		_constructor: function ()
		{
			var that = this;
			var dt = this.s.dt;
			var dtPrivateSettings = dt.settings()[0];
			var oldWindowWidth = $(window).width();
	
			dt.settings()[0]._responsive = this;
	
			// Use DataTables' throttle function to avoid processor thrashing on
			// resize
			$(window).on( 'resize.dtr orientationchange.dtr', DataTable.util.throttle( function () {
				// iOS has a bug whereby resize can fire when only scrolling
				// See: http://stackoverflow.com/questions/8898412
				var width = $(window).width();
	
				if ( width !== oldWindowWidth ) {
					that._resize();
					oldWindowWidth = width;
				}
			} ) );
	
			// DataTables doesn't currently trigger an event when a row is added, so
			// we need to hook into its private API to enforce the hidden rows when
			// new data is added
			dtPrivateSettings.oApi._fnCallbackReg( dtPrivateSettings, 'aoRowCreatedCallback', function (tr, data, idx) {
				if ( $.inArray( false, that.s.current ) !== -1 ) {
					$('>td, >th', tr).each( function ( i ) {
						var idx = dt.column.index( 'toData', i );
	
						if ( that.s.current[idx] === false ) {
							$(this).css('display', 'none');
						}
					} );
				}
			} );
	
			// Destroy event handler
			dt.on( 'destroy.dtr', function () {
				dt.off( '.dtr' );
				$( dt.table().body() ).off( '.dtr' );
				$(window).off( 'resize.dtr orientationchange.dtr' );
	
				// Restore the columns that we've hidden
				$.each( that.s.current, function ( i, val ) {
					if ( val === false ) {
						that._setColumnVis( i, true );
					}
				} );
			} );
	
			// Reorder the breakpoints array here in case they have been added out
			// of order
			this.c.breakpoints.sort( function (a, b) {
				return a.width < b.width ? 1 :
					a.width > b.width ? -1 : 0;
			} );
	
			this._classLogic();
			this._resizeAuto();
	
			// Details handler
			var details = this.c.details;
	
			if ( details.type !== false ) {
				that._detailsInit();
	
				// DataTables will trigger this event on every column it shows and
				// hides individually
				dt.on( 'column-visibility.dtr', function (e, ctx, col, vis) {
					that._classLogic();
					that._resizeAuto();
					that._resize();
				} );
	
				// Redraw the details box on each draw which will happen if the data
				// has changed. This is used until DataTables implements a native
				// `updated` event for rows
				dt.on( 'draw.dtr', function () {
					that._redrawChildren();
				} );
	
				$(dt.table().node()).addClass( 'dtr-'+details.type );
			}
	
			dt.on( 'column-reorder.dtr', function (e, settings, details) {
				that._classLogic();
				that._resizeAuto();
				that._resize();
			} );
	
			// Change in column sizes means we need to calc
			dt.on( 'column-sizing.dtr', function () {
				that._resizeAuto();
				that._resize();
			});
	
			// On Ajax reload we want to reopen any child rows which are displayed
			// by responsive
			dt.on( 'preXhr.dtr', function () {
				var rowIds = [];
				dt.rows().every( function () {
					if ( this.child.isShown() ) {
						rowIds.push( this.id(true) );
					}
				} );
	
				dt.one( 'draw.dtr', function () {
					dt.rows( rowIds ).every( function () {
						that._detailsDisplay( this, false );
					} );
				} );
			});
	
			dt.on( 'init.dtr', function (e, settings, details) {
				that._resizeAuto();
				that._resize();
	
				// If columns were hidden, then DataTables needs to adjust the
				// column sizing
				if ( $.inArray( false, that.s.current ) ) {
					dt.columns.adjust();
				}
			} );
	
			// First pass - draw the table for the current viewport size
			this._resize();
		},
	
	
		/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
		 * Private methods
		 */
	
		/**
		 * Calculate the visibility for the columns in a table for a given
		 * breakpoint. The result is pre-determined based on the class logic if
		 * class names are used to control all columns, but the width of the table
		 * is also used if there are columns which are to be automatically shown
		 * and hidden.
		 *
		 * @param  {string} breakpoint Breakpoint name to use for the calculation
		 * @return {array} Array of boolean values initiating the visibility of each
		 *   column.
		 *  @private
		 */
		_columnsVisiblity: function ( breakpoint )
		{
			var dt = this.s.dt;
			var columns = this.s.columns;
			var i, ien;
	
			// Create an array that defines the column ordering based first on the
			// column's priority, and secondly the column index. This allows the
			// columns to be removed from the right if the priority matches
			var order = columns
				.map( function ( col, idx ) {
					return {
						columnIdx: idx,
						priority: col.priority
					};
				} )
				.sort( function ( a, b ) {
					if ( a.priority !== b.priority ) {
						return a.priority - b.priority;
					}
					return a.columnIdx - b.columnIdx;
				} );
	
			// Class logic - determine which columns are in this breakpoint based
			// on the classes. If no class control (i.e. `auto`) then `-` is used
			// to indicate this to the rest of the function
			var display = $.map( columns, function ( col ) {
				return col.auto && col.minWidth === null ?
					false :
					col.auto === true ?
						'-' :
						$.inArray( breakpoint, col.includeIn ) !== -1;
			} );
	
			// Auto column control - first pass: how much width is taken by the
			// ones that must be included from the non-auto columns
			var requiredWidth = 0;
			for ( i=0, ien=display.length ; i<ien ; i++ ) {
				if ( display[i] === true ) {
					requiredWidth += columns[i].minWidth;
				}
			}
	
			// Second pass, use up any remaining width for other columns. For
			// scrolling tables we need to subtract the width of the scrollbar. It
			// may not be requires which makes this sub-optimal, but it would
			// require another full redraw to make complete use of those extra few
			// pixels
			var scrolling = dt.settings()[0].oScroll;
			var bar = scrolling.sY || scrolling.sX ? scrolling.iBarWidth : 0;
			var widthAvailable = dt.table().container().offsetWidth - bar;
			var usedWidth = widthAvailable - requiredWidth;
	
			// Control column needs to always be included. This makes it sub-
			// optimal in terms of using the available with, but to stop layout
			// thrashing or overflow. Also we need to account for the control column
			// width first so we know how much width is available for the other
			// columns, since the control column might not be the first one shown
			for ( i=0, ien=display.length ; i<ien ; i++ ) {
				if ( columns[i].control ) {
					usedWidth -= columns[i].minWidth;
				}
			}
	
			// Allow columns to be shown (counting by priority and then right to
			// left) until we run out of room
			var empty = false;
			for ( i=0, ien=order.length ; i<ien ; i++ ) {
				var colIdx = order[i].columnIdx;
	
				if ( display[colIdx] === '-' && ! columns[colIdx].control && columns[colIdx].minWidth ) {
					// Once we've found a column that won't fit we don't let any
					// others display either, or columns might disappear in the
					// middle of the table
					if ( empty || usedWidth - columns[colIdx].minWidth < 0 ) {
						empty = true;
						display[colIdx] = false;
					}
					else {
						display[colIdx] = true;
					}
	
					usedWidth -= columns[colIdx].minWidth;
				}
			}
	
			// Determine if the 'control' column should be shown (if there is one).
			// This is the case when there is a hidden column (that is not the
			// control column). The two loops look inefficient here, but they are
			// trivial and will fly through. We need to know the outcome from the
			// first , before the action in the second can be taken
			var showControl = false;
	
			for ( i=0, ien=columns.length ; i<ien ; i++ ) {
				if ( ! columns[i].control && ! columns[i].never && ! display[i] ) {
					showControl = true;
					break;
				}
			}
	
			for ( i=0, ien=columns.length ; i<ien ; i++ ) {
				if ( columns[i].control ) {
					display[i] = showControl;
				}
			}
	
			// Finally we need to make sure that there is at least one column that
			// is visible
			if ( $.inArray( true, display ) === -1 ) {
				display[0] = true;
			}
	
			return display;
		},
	
	
		/**
		 * Create the internal `columns` array with information about the columns
		 * for the table. This includes determining which breakpoints the column
		 * will appear in, based upon class names in the column, which makes up the
		 * vast majority of this method.
		 *
		 * @private
		 */
		_classLogic: function ()
		{
			var that = this;
			var calc = {};
			var breakpoints = this.c.breakpoints;
			var dt = this.s.dt;
			var columns = dt.columns().eq(0).map( function (i) {
				var column = this.column(i);
				var className = column.header().className;
				var priority = dt.settings()[0].aoColumns[i].responsivePriority;
	
				if ( priority === undefined ) {
					var dataPriority = $(column.header()).data('priority');
	
					priority = dataPriority !== undefined ?
						dataPriority * 1 :
						10000;
				}
	
				return {
					className: className,
					includeIn: [],
					auto:      false,
					control:   false,
					never:     className.match(/\bnever\b/) ? true : false,
					priority:  priority
				};
			} );
	
			// Simply add a breakpoint to `includeIn` array, ensuring that there are
			// no duplicates
			var add = function ( colIdx, name ) {
				var includeIn = columns[ colIdx ].includeIn;
	
				if ( $.inArray( name, includeIn ) === -1 ) {
					includeIn.push( name );
				}
			};
	
			var column = function ( colIdx, name, operator, matched ) {
				var size, i, ien;
	
				if ( ! operator ) {
					columns[ colIdx ].includeIn.push( name );
				}
				else if ( operator === 'max-' ) {
					// Add this breakpoint and all smaller
					size = that._find( name ).width;
	
					for ( i=0, ien=breakpoints.length ; i<ien ; i++ ) {
						if ( breakpoints[i].width <= size ) {
							add( colIdx, breakpoints[i].name );
						}
					}
				}
				else if ( operator === 'min-' ) {
					// Add this breakpoint and all larger
					size = that._find( name ).width;
	
					for ( i=0, ien=breakpoints.length ; i<ien ; i++ ) {
						if ( breakpoints[i].width >= size ) {
							add( colIdx, breakpoints[i].name );
						}
					}
				}
				else if ( operator === 'not-' ) {
					// Add all but this breakpoint
					for ( i=0, ien=breakpoints.length ; i<ien ; i++ ) {
						if ( breakpoints[i].name.indexOf( matched ) === -1 ) {
							add( colIdx, breakpoints[i].name );
						}
					}
				}
			};
	
			// Loop over each column and determine if it has a responsive control
			// class
			columns.each( function ( col, i ) {
				var classNames = col.className.split(' ');
				var hasClass = false;
	
				// Split the class name up so multiple rules can be applied if needed
				for ( var k=0, ken=classNames.length ; k<ken ; k++ ) {
					var className = $.trim( classNames[k] );
	
					if ( className === 'all' ) {
						// Include in all
						hasClass = true;
						col.includeIn = $.map( breakpoints, function (a) {
							return a.name;
						} );
						return;
					}
					else if ( className === 'none' || col.never ) {
						// Include in none (default) and no auto
						hasClass = true;
						return;
					}
					else if ( className === 'control' ) {
						// Special column that is only visible, when one of the other
						// columns is hidden. This is used for the details control
						hasClass = true;
						col.control = true;
						return;
					}
	
					$.each( breakpoints, function ( j, breakpoint ) {
						// Does this column have a class that matches this breakpoint?
						var brokenPoint = breakpoint.name.split('-');
						var re = new RegExp( '(min\\-|max\\-|not\\-)?('+brokenPoint[0]+')(\\-[_a-zA-Z0-9])?' );
						var match = className.match( re );
	
						if ( match ) {
							hasClass = true;
	
							if ( match[2] === brokenPoint[0] && match[3] === '-'+brokenPoint[1] ) {
								// Class name matches breakpoint name fully
								column( i, breakpoint.name, match[1], match[2]+match[3] );
							}
							else if ( match[2] === brokenPoint[0] && ! match[3] ) {
								// Class name matched primary breakpoint name with no qualifier
								column( i, breakpoint.name, match[1], match[2] );
							}
						}
					} );
				}
	
				// If there was no control class, then automatic sizing is used
				if ( ! hasClass ) {
					col.auto = true;
				}
			} );
	
			this.s.columns = columns;
		},
	
	
		/**
		 * Show the details for the child row
		 *
		 * @param  {DataTables.Api} row    API instance for the row
		 * @param  {boolean}        update Update flag
		 * @private
		 */
		_detailsDisplay: function ( row, update )
		{
			var that = this;
			var dt = this.s.dt;
			var details = this.c.details;
	
			if ( details && details.type !== false ) {
				var res = details.display( row, update, function () {
					return details.renderer(
						dt, row[0], that._detailsObj(row[0])
					);
				} );
	
				if ( res === true || res === false ) {
					$(dt.table().node()).triggerHandler( 'responsive-display.dt', [dt, row, res, update] );
				}
			}
		},
	
	
		/**
		 * Initialisation for the details handler
		 *
		 * @private
		 */
		_detailsInit: function ()
		{
			var that    = this;
			var dt      = this.s.dt;
			var details = this.c.details;
	
			// The inline type always uses the first child as the target
			if ( details.type === 'inline' ) {
				details.target = 'td:first-child, th:first-child';
			}
	
			// Keyboard accessibility
			dt.on( 'draw.dtr', function () {
				that._tabIndexes();
			} );
			that._tabIndexes(); // Initial draw has already happened
	
			$( dt.table().body() ).on( 'keyup.dtr', 'td, th', function (e) {
				if ( e.keyCode === 13 && $(this).data('dtr-keyboard') ) {
					$(this).click();
				}
			} );
	
			// type.target can be a string jQuery selector or a column index
			var target   = details.target;
			var selector = typeof target === 'string' ? target : 'td, th';
	
			// Click handler to show / hide the details rows when they are available
			$( dt.table().body() )
				.on( 'click.dtr mousedown.dtr mouseup.dtr', selector, function (e) {
					// If the table is not collapsed (i.e. there is no hidden columns)
					// then take no action
					if ( ! $(dt.table().node()).hasClass('collapsed' ) ) {
						return;
					}
	
					// Check that the row is actually a DataTable's controlled node
					if ( $.inArray( $(this).closest('tr').get(0), dt.rows().nodes().toArray() ) === -1 ) {
						return;
					}
	
					// For column index, we determine if we should act or not in the
					// handler - otherwise it is already okay
					if ( typeof target === 'number' ) {
						var targetIdx = target < 0 ?
							dt.columns().eq(0).length + target :
							target;
	
						if ( dt.cell( this ).index().column !== targetIdx ) {
							return;
						}
					}
	
					// $().closest() includes itself in its check
					var row = dt.row( $(this).closest('tr') );
	
					// Check event type to do an action
					if ( e.type === 'click' ) {
						// The renderer is given as a function so the caller can execute it
						// only when they need (i.e. if hiding there is no point is running
						// the renderer)
						that._detailsDisplay( row, false );
					}
					else if ( e.type === 'mousedown' ) {
						// For mouse users, prevent the focus ring from showing
						$(this).css('outline', 'none');
					}
					else if ( e.type === 'mouseup' ) {
						// And then re-allow at the end of the click
						$(this).blur().css('outline', '');
					}
				} );
		},
	
	
		/**
		 * Get the details to pass to a renderer for a row
		 * @param  {int} rowIdx Row index
		 * @private
		 */
		_detailsObj: function ( rowIdx )
		{
			var that = this;
			var dt = this.s.dt;
	
			return $.map( this.s.columns, function( col, i ) {
				// Never and control columns should not be passed to the renderer
				if ( col.never || col.control ) {
					return;
				}
	
				return {
					title:       dt.settings()[0].aoColumns[ i ].sTitle,
					data:        dt.cell( rowIdx, i ).render( that.c.orthogonal ),
					hidden:      dt.column( i ).visible() && !that.s.current[ i ],
					columnIndex: i,
					rowIndex:    rowIdx
				};
			} );
		},
	
	
		/**
		 * Find a breakpoint object from a name
		 *
		 * @param  {string} name Breakpoint name to find
		 * @return {object}      Breakpoint description object
		 * @private
		 */
		_find: function ( name )
		{
			var breakpoints = this.c.breakpoints;
	
			for ( var i=0, ien=breakpoints.length ; i<ien ; i++ ) {
				if ( breakpoints[i].name === name ) {
					return breakpoints[i];
				}
			}
		},
	
	
		/**
		 * Re-create the contents of the child rows as the display has changed in
		 * some way.
		 *
		 * @private
		 */
		_redrawChildren: function ()
		{
			var that = this;
			var dt = this.s.dt;
	
			dt.rows( {page: 'current'} ).iterator( 'row', function ( settings, idx ) {
				var row = dt.row( idx );
	
				that._detailsDisplay( dt.row( idx ), true );
			} );
		},
	
	
		/**
		 * Alter the table display for a resized viewport. This involves first
		 * determining what breakpoint the window currently is in, getting the
		 * column visibilities to apply and then setting them.
		 *
		 * @private
		 */
		_resize: function ()
		{
			var that = this;
			var dt = this.s.dt;
			var width = $(window).width();
			var breakpoints = this.c.breakpoints;
			var breakpoint = breakpoints[0].name;
			var columns = this.s.columns;
			var i, ien;
			var oldVis = this.s.current.slice();
	
			// Determine what breakpoint we are currently at
			for ( i=breakpoints.length-1 ; i>=0 ; i-- ) {
				if ( width <= breakpoints[i].width ) {
					breakpoint = breakpoints[i].name;
					break;
				}
			}
			
			// Show the columns for that break point
			var columnsVis = this._columnsVisiblity( breakpoint );
			this.s.current = columnsVis;
	
			// Set the class before the column visibility is changed so event
			// listeners know what the state is. Need to determine if there are
			// any columns that are not visible but can be shown
			var collapsedClass = false;
			for ( i=0, ien=columns.length ; i<ien ; i++ ) {
				if ( columnsVis[i] === false && ! columns[i].never && ! columns[i].control ) {
					collapsedClass = true;
					break;
				}
			}
	
			$( dt.table().node() ).toggleClass( 'collapsed', collapsedClass );
	
			var changed = false;
	
			dt.columns().eq(0).each( function ( colIdx, i ) {
				if ( columnsVis[i] !== oldVis[i] ) {
					changed = true;
					that._setColumnVis( colIdx, columnsVis[i] );
				}
			} );
	
			if ( changed ) {
				this._redrawChildren();
	
				// Inform listeners of the change
				$(dt.table().node()).trigger( 'responsive-resize.dt', [dt, this.s.current] );
			}
		},
	
	
		/**
		 * Determine the width of each column in the table so the auto column hiding
		 * has that information to work with. This method is never going to be 100%
		 * perfect since column widths can change slightly per page, but without
		 * seriously compromising performance this is quite effective.
		 *
		 * @private
		 */
		_resizeAuto: function ()
		{
			var dt = this.s.dt;
			var columns = this.s.columns;
	
			// Are we allowed to do auto sizing?
			if ( ! this.c.auto ) {
				return;
			}
	
			// Are there any columns that actually need auto-sizing, or do they all
			// have classes defined
			if ( $.inArray( true, $.map( columns, function (c) { return c.auto; } ) ) === -1 ) {
				return;
			}
	
			// Clone the table with the current data in it
			var tableWidth   = dt.table().node().offsetWidth;
			var columnWidths = dt.columns;
			var clonedTable  = dt.table().node().cloneNode( false );
			var clonedHeader = $( dt.table().header().cloneNode( false ) ).appendTo( clonedTable );
			var clonedBody   = $( dt.table().body() ).clone( false, false ).empty().appendTo( clonedTable ); // use jQuery because of IE8
	
			// Header
			var headerCells = dt.columns()
				.header()
				.filter( function (idx) {
					return dt.column(idx).visible();
				} )
				.to$()
				.clone( false )
				.css( 'display', 'table-cell' );
	
			// Body rows - we don't need to take account of DataTables' column
			// visibility since we implement our own here (hence the `display` set)
			$(clonedBody)
				.append( $(dt.rows( { page: 'current' } ).nodes()).clone( false ) )
				.find( 'th, td' ).css( 'display', '' );
	
			// Footer
			var footer = dt.table().footer();
			if ( footer ) {
				var clonedFooter = $( footer.cloneNode( false ) ).appendTo( clonedTable );
				var footerCells = dt.columns()
					.footer()
					.filter( function (idx) {
						return dt.column(idx).visible();
					} )
					.to$()
					.clone( false )
					.css( 'display', 'table-cell' );
	
				$('<tr/>')
					.append( footerCells )
					.appendTo( clonedFooter );
			}
	
			$('<tr/>')
				.append( headerCells )
				.appendTo( clonedHeader );
	
			// In the inline case extra padding is applied to the first column to
			// give space for the show / hide icon. We need to use this in the
			// calculation
			if ( this.c.details.type === 'inline' ) {
				$(clonedTable).addClass( 'dtr-inline collapsed' );
			}
			
			// It is unsafe to insert elements with the same name into the DOM
			// multiple times. For example, cloning and inserting a checked radio
			// clears the chcecked state of the original radio.
			$( clonedTable ).find( '[name]' ).removeAttr( 'name' );
			
			var inserted = $('<div/>')
				.css( {
					width: 1,
					height: 1,
					overflow: 'hidden'
				} )
				.append( clonedTable );
	
			inserted.insertBefore( dt.table().node() );
	
			// The cloned header now contains the smallest that each column can be
			headerCells.each( function (i) {
				var idx = dt.column.index( 'fromVisible', i );
				columns[ idx ].minWidth =  this.offsetWidth || 0;
			} );
	
			inserted.remove();
		},
	
		/**
		 * Set a column's visibility.
		 *
		 * We don't use DataTables' column visibility controls in order to ensure
		 * that column visibility can Responsive can no-exist. Since only IE8+ is
		 * supported (and all evergreen browsers of course) the control of the
		 * display attribute works well.
		 *
		 * @param {integer} col      Column index
		 * @param {boolean} showHide Show or hide (true or false)
		 * @private
		 */
		_setColumnVis: function ( col, showHide )
		{
			var dt = this.s.dt;
			var display = showHide ? '' : 'none'; // empty string will remove the attr
	
			$( dt.column( col ).header() ).css( 'display', display );
			$( dt.column( col ).footer() ).css( 'display', display );
			dt.column( col ).nodes().to$().css( 'display', display );
		},
	
	
		/**
		 * Update the cell tab indexes for keyboard accessibility. This is called on
		 * every table draw - that is potentially inefficient, but also the least
		 * complex option given that column visibility can change on the fly. Its a
		 * shame user-focus was removed from CSS 3 UI, as it would have solved this
		 * issue with a single CSS statement.
		 *
		 * @private
		 */
		_tabIndexes: function ()
		{
			var dt = this.s.dt;
			var cells = dt.cells( { page: 'current' } ).nodes().to$();
			var ctx = dt.settings()[0];
			var target = this.c.details.target;
	
			cells.filter( '[data-dtr-keyboard]' ).removeData( '[data-dtr-keyboard]' );
	
			var selector = typeof target === 'number' ?
				':eq('+target+')' :
				target;
	
			// This is a bit of a hack - we need to limit the selected nodes to just
			// those of this table
			if ( selector === 'td:first-child, th:first-child' ) {
				selector = '>td:first-child, >th:first-child';
			}
	
			$( selector, dt.rows( { page: 'current' } ).nodes() )
				.attr( 'tabIndex', ctx.iTabIndex )
				.data( 'dtr-keyboard', 1 );
		}
	} );
	
	
	/**
	 * List of default breakpoints. Each item in the array is an object with two
	 * properties:
	 *
	 * * `name` - the breakpoint name.
	 * * `width` - the breakpoint width
	 *
	 * @name Responsive.breakpoints
	 * @static
	 */
	Responsive.breakpoints = [
		{ name: 'desktop',  width: Infinity },
		{ name: 'tablet-l', width: 1024 },
		{ name: 'tablet-p', width: 768 },
		{ name: 'mobile-l', width: 480 },
		{ name: 'mobile-p', width: 320 }
	];
	
	
	/**
	 * Display methods - functions which define how the hidden data should be shown
	 * in the table.
	 *
	 * @namespace
	 * @name Responsive.defaults
	 * @static
	 */
	Responsive.display = {
		childRow: function ( row, update, render ) {
			if ( update ) {
				if ( $(row.node()).hasClass('parent') ) {
					row.child( render(), 'child' ).show();
	
					return true;
				}
			}
			else {
				if ( ! row.child.isShown()  ) {
					row.child( render(), 'child' ).show();
					$( row.node() ).addClass( 'parent' );
	
					return true;
				}
				else {
					row.child( false );
					$( row.node() ).removeClass( 'parent' );
	
					return false;
				}
			}
		},
	
		childRowImmediate: function ( row, update, render ) {
			if ( (! update && row.child.isShown()) || ! row.responsive.hasHidden() ) {
				// User interaction and the row is show, or nothing to show
				row.child( false );
				$( row.node() ).removeClass( 'parent' );
	
				return false;
			}
			else {
				// Display
				row.child( render(), 'child' ).show();
				$( row.node() ).addClass( 'parent' );
	
				return true;
			}
		},
	
		// This is a wrapper so the modal options for Bootstrap and jQuery UI can
		// have options passed into them. This specific one doesn't need to be a
		// function but it is for consistency in the `modal` name
		modal: function ( options ) {
			return function ( row, update, render ) {
				if ( ! update ) {
					// Show a modal
					var close = function () {
						modal.remove(); // will tidy events for us
						$(document).off( 'keypress.dtr' );
					};
	
					var modal = $('<div class="dtr-modal"/>')
						.append( $('<div class="dtr-modal-display"/>')
							.append( $('<div class="dtr-modal-content"/>')
								.append( render() )
							)
							.append( $('<div class="dtr-modal-close">&times;</div>' )
								.click( function () {
									close();
								} )
							)
						)
						.append( $('<div class="dtr-modal-background"/>')
							.click( function () {
								close();
							} )
						)
						.appendTo( 'body' );
	
					$(document).on( 'keyup.dtr', function (e) {
						if ( e.keyCode === 27 ) {
							e.stopPropagation();
	
							close();
						}
					} );
				}
				else {
					$('div.dtr-modal-content')
						.empty()
						.append( render() );
				}
	
				if ( options && options.header ) {
					$('div.dtr-modal-content').prepend(
						'<h2>'+options.header( row )+'</h2>'
					);
				}
			};
		}
	};
	
	
	/**
	 * Display methods - functions which define how the hidden data should be shown
	 * in the table.
	 *
	 * @namespace
	 * @name Responsive.defaults
	 * @static
	 */
	Responsive.renderer = {
		listHidden: function () {
			return function ( api, rowIdx, columns ) {
				var data = $.map( columns, function ( col ) {
					return col.hidden ?
						'<li data-dtr-index="'+col.columnIndex+'" data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
							'<span class="dtr-title">'+
								col.title+
							'</span> '+
							'<span class="dtr-data">'+
								col.data+
							'</span>'+
						'</li>' :
						'';
				} ).join('');
	
				return data ?
					$('<ul data-dtr-index="'+rowIdx+'" class="dtr-details"/>').append( data ) :
					false;
			}
		},
	
		tableAll: function ( options ) {
			options = $.extend( {
				tableClass: ''
			}, options );
	
			return function ( api, rowIdx, columns ) {
				var data = $.map( columns, function ( col ) {
					return '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
							'<td>'+col.title+':'+'</td> '+
							'<td>'+col.data+'</td>'+
						'</tr>';
				} ).join('');
	
				return $('<table class="'+options.tableClass+' dtr-details" width="100%"/>').append( data );
			}
		}
	};
	
	/**
	 * Responsive default settings for initialisation
	 *
	 * @namespace
	 * @name Responsive.defaults
	 * @static
	 */
	Responsive.defaults = {
		/**
		 * List of breakpoints for the instance. Note that this means that each
		 * instance can have its own breakpoints. Additionally, the breakpoints
		 * cannot be changed once an instance has been creased.
		 *
		 * @type {Array}
		 * @default Takes the value of `Responsive.breakpoints`
		 */
		breakpoints: Responsive.breakpoints,
	
		/**
		 * Enable / disable auto hiding calculations. It can help to increase
		 * performance slightly if you disable this option, but all columns would
		 * need to have breakpoint classes assigned to them
		 *
		 * @type {Boolean}
		 * @default  `true`
		 */
		auto: true,
	
		/**
		 * Details control. If given as a string value, the `type` property of the
		 * default object is set to that value, and the defaults used for the rest
		 * of the object - this is for ease of implementation.
		 *
		 * The object consists of the following properties:
		 *
		 * * `display` - A function that is used to show and hide the hidden details
		 * * `renderer` - function that is called for display of the child row data.
		 *   The default function will show the data from the hidden columns
		 * * `target` - Used as the selector for what objects to attach the child
		 *   open / close to
		 * * `type` - `false` to disable the details display, `inline` or `column`
		 *   for the two control types
		 *
		 * @type {Object|string}
		 */
		details: {
			display: Responsive.display.childRow,
	
			renderer: Responsive.renderer.listHidden(),
	
			target: 0,
	
			type: 'inline'
		},
	
		/**
		 * Orthogonal data request option. This is used to define the data type
		 * requested when Responsive gets the data to show in the child row.
		 *
		 * @type {String}
		 */
		orthogonal: 'display'
	};
	
	
	/*
	 * API
	 */
	var Api = $.fn.dataTable.Api;
	
	// Doesn't do anything - work around for a bug in DT... Not documented
	Api.register( 'responsive()', function () {
		return this;
	} );
	
	Api.register( 'responsive.index()', function ( li ) {
		li = $(li);
	
		return {
			column: li.data('dtr-index'),
			row:    li.parent().data('dtr-index')
		};
	} );
	
	Api.register( 'responsive.rebuild()', function () {
		return this.iterator( 'table', function ( ctx ) {
			if ( ctx._responsive ) {
				ctx._responsive._classLogic();
			}
		} );
	} );
	
	Api.register( 'responsive.recalc()', function () {
		return this.iterator( 'table', function ( ctx ) {
			if ( ctx._responsive ) {
				ctx._responsive._resizeAuto();
				ctx._responsive._resize();
			}
		} );
	} );
	
	Api.register( 'responsive.hasHidden()', function () {
		var ctx = this.context[0];
	
		return ctx._responsive ?
			$.inArray( false, ctx._responsive.s.current ) !== -1 :
			false;
	} );
	
	
	/**
	 * Version information
	 *
	 * @name Responsive.version
	 * @static
	 */
	Responsive.version = '2.1.1';
	
	
	$.fn.dataTable.Responsive = Responsive;
	$.fn.DataTable.Responsive = Responsive;
	
	// Attach a listener to the document which listens for DataTables initialisation
	// events so we can automatically initialise
	$(document).on( 'preInit.dt.dtr', function (e, settings, json) {
		if ( e.namespace !== 'dt' ) {
			return;
		}
	
		if ( $(settings.nTable).hasClass( 'responsive' ) ||
			 $(settings.nTable).hasClass( 'dt-responsive' ) ||
			 settings.oInit.responsive ||
			 DataTable.defaults.responsive
		) {
			var init = settings.oInit.responsive;
	
			if ( init !== false ) {
				new Responsive( settings, $.isPlainObject( init ) ? init : {}  );
			}
		}
	} );
	
	
	return Responsive;
	}));


/***/ }),
/* 273 */
5,
/* 274 */,
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Buttons for DataTables 1.4.1
	 * ©2016-2017 SpryMedia Ltd - datatables.net/license
	 */
	
	(function( factory ){
		if ( true ) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
				return factory( $, window, document );
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if ( typeof exports === 'object' ) {
			// CommonJS
			module.exports = function (root, $) {
				if ( ! root ) {
					root = window;
				}
	
				if ( ! $ || ! $.fn.dataTable ) {
					$ = require('datatables.net')(root, $).$;
				}
	
				return factory( $, root, root.document );
			};
		}
		else {
			// Browser
			factory( jQuery, window, document );
		}
	}(function( $, window, document, undefined ) {
	'use strict';
	var DataTable = $.fn.dataTable;
	
	
	// Used for namespacing events added to the document by each instance, so they
	// can be removed on destroy
	var _instCounter = 0;
	
	// Button namespacing counter for namespacing events on individual buttons
	var _buttonCounter = 0;
	
	var _dtButtons = DataTable.ext.buttons;
	
	/**
	 * [Buttons description]
	 * @param {[type]}
	 * @param {[type]}
	 */
	var Buttons = function( dt, config )
	{
		// If there is no config set it to an empty object
		if ( typeof( config ) === 'undefined' ) {
			config = {};	
		}
		
		// Allow a boolean true for defaults
		if ( config === true ) {
			config = {};
		}
	
		// For easy configuration of buttons an array can be given
		if ( $.isArray( config ) ) {
			config = { buttons: config };
		}
	
		this.c = $.extend( true, {}, Buttons.defaults, config );
	
		// Don't want a deep copy for the buttons
		if ( config.buttons ) {
			this.c.buttons = config.buttons;
		}
	
		this.s = {
			dt: new DataTable.Api( dt ),
			buttons: [],
			listenKeys: '',
			namespace: 'dtb'+(_instCounter++)
		};
	
		this.dom = {
			container: $('<'+this.c.dom.container.tag+'/>')
				.addClass( this.c.dom.container.className )
		};
	
		this._constructor();
	};
	
	
	$.extend( Buttons.prototype, {
		/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
		 * Public methods
		 */
	
		/**
		 * Get the action of a button
		 * @param  {int|string} Button index
		 * @return {function}
		 *//**
		 * Set the action of a button
		 * @param  {node} node Button element
		 * @param  {function} action Function to set
		 * @return {Buttons} Self for chaining
		 */
		action: function ( node, action )
		{
			var button = this._nodeToButton( node );
	
			if ( action === undefined ) {
				return button.conf.action;
			}
	
			button.conf.action = action;
	
			return this;
		},
	
		/**
		 * Add an active class to the button to make to look active or get current
		 * active state.
		 * @param  {node} node Button element
		 * @param  {boolean} [flag] Enable / disable flag
		 * @return {Buttons} Self for chaining or boolean for getter
		 */
		active: function ( node, flag ) {
			var button = this._nodeToButton( node );
			var klass = this.c.dom.button.active;
			var jqNode = $(button.node);
	
			if ( flag === undefined ) {
				return jqNode.hasClass( klass );
			}
	
			jqNode.toggleClass( klass, flag === undefined ? true : flag );
	
			return this;
		},
	
		/**
		 * Add a new button
		 * @param {object} config Button configuration object, base string name or function
		 * @param {int|string} [idx] Button index for where to insert the button
		 * @return {Buttons} Self for chaining
		 */
		add: function ( config, idx )
		{
			var buttons = this.s.buttons;
	
			if ( typeof idx === 'string' ) {
				var split = idx.split('-');
				var base = this.s;
	
				for ( var i=0, ien=split.length-1 ; i<ien ; i++ ) {
					base = base.buttons[ split[i]*1 ];
				}
	
				buttons = base.buttons;
				idx = split[ split.length-1 ]*1;
			}
	
			this._expandButton( buttons, config, false, idx );
			this._draw();
	
			return this;
		},
	
		/**
		 * Get the container node for the buttons
		 * @return {jQuery} Buttons node
		 */
		container: function ()
		{
			return this.dom.container;
		},
	
		/**
		 * Disable a button
		 * @param  {node} node Button node
		 * @return {Buttons} Self for chaining
		 */
		disable: function ( node ) {
			var button = this._nodeToButton( node );
	
			$(button.node).addClass( this.c.dom.button.disabled );
	
			return this;
		},
	
		/**
		 * Destroy the instance, cleaning up event handlers and removing DOM
		 * elements
		 * @return {Buttons} Self for chaining
		 */
		destroy: function ()
		{
			// Key event listener
			$('body').off( 'keyup.'+this.s.namespace );
	
			// Individual button destroy (so they can remove their own events if
			// needed). Take a copy as the array is modified by `remove`
			var buttons = this.s.buttons.slice();
			var i, ien;
			
			for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
				this.remove( buttons[i].node );
			}
	
			// Container
			this.dom.container.remove();
	
			// Remove from the settings object collection
			var buttonInsts = this.s.dt.settings()[0];
	
			for ( i=0, ien=buttonInsts.length ; i<ien ; i++ ) {
				if ( buttonInsts.inst === this ) {
					buttonInsts.splice( i, 1 );
					break;
				}
			}
	
			return this;
		},
	
		/**
		 * Enable / disable a button
		 * @param  {node} node Button node
		 * @param  {boolean} [flag=true] Enable / disable flag
		 * @return {Buttons} Self for chaining
		 */
		enable: function ( node, flag )
		{
			if ( flag === false ) {
				return this.disable( node );
			}
	
			var button = this._nodeToButton( node );
			$(button.node).removeClass( this.c.dom.button.disabled );
	
			return this;
		},
	
		/**
		 * Get the instance name for the button set selector
		 * @return {string} Instance name
		 */
		name: function ()
		{
			return this.c.name;
		},
	
		/**
		 * Get a button's node
		 * @param  {node} node Button node
		 * @return {jQuery} Button element
		 */
		node: function ( node )
		{
			var button = this._nodeToButton( node );
			return $(button.node);
		},
	
		/**
		 * Set / get a processing class on the selected button
		 * @param  {boolean} flag true to add, false to remove, undefined to get
		 * @return {boolean|Buttons} Getter value or this if a setter.
		 */
		processing: function ( node, flag )
		{
			var button = this._nodeToButton( node );
	
			if ( flag === undefined ) {
				return $(button.node).hasClass( 'processing' );
			}
	
			$(button.node).toggleClass( 'processing', flag );
	
			return this;
		},
	
		/**
		 * Remove a button.
		 * @param  {node} node Button node
		 * @return {Buttons} Self for chaining
		 */
		remove: function ( node )
		{
			var button = this._nodeToButton( node );
			var host = this._nodeToHost( node );
			var dt = this.s.dt;
	
			// Remove any child buttons first
			if ( button.buttons.length ) {
				for ( var i=button.buttons.length-1 ; i>=0 ; i-- ) {
					this.remove( button.buttons[i].node );
				}
			}
	
			// Allow the button to remove event handlers, etc
			if ( button.conf.destroy ) {
				button.conf.destroy.call( dt.button(node), dt, $(node), button.conf );
			}
	
			this._removeKey( button.conf );
	
			$(button.node).remove();
	
			var idx = $.inArray( button, host );
			host.splice( idx, 1 );
	
			return this;
		},
	
		/**
		 * Get the text for a button
		 * @param  {int|string} node Button index
		 * @return {string} Button text
		 *//**
		 * Set the text for a button
		 * @param  {int|string|function} node Button index
		 * @param  {string} label Text
		 * @return {Buttons} Self for chaining
		 */
		text: function ( node, label )
		{
			var button = this._nodeToButton( node );
			var buttonLiner = this.c.dom.collection.buttonLiner;
			var linerTag = button.inCollection && buttonLiner && buttonLiner.tag ?
				buttonLiner.tag :
				this.c.dom.buttonLiner.tag;
			var dt = this.s.dt;
			var jqNode = $(button.node);
			var text = function ( opt ) {
				return typeof opt === 'function' ?
					opt( dt, jqNode, button.conf ) :
					opt;
			};
	
			if ( label === undefined ) {
				return text( button.conf.text );
			}
	
			button.conf.text = label;
	
			if ( linerTag ) {
				jqNode.children( linerTag ).html( text(label) );
			}
			else {
				jqNode.html( text(label) );
			}
	
			return this;
		},
	
	
		/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
		 * Constructor
		 */
	
		/**
		 * Buttons constructor
		 * @private
		 */
		_constructor: function ()
		{
			var that = this;
			var dt = this.s.dt;
			var dtSettings = dt.settings()[0];
			var buttons =  this.c.buttons;
	
			if ( ! dtSettings._buttons ) {
				dtSettings._buttons = [];
			}
	
			dtSettings._buttons.push( {
				inst: this,
				name: this.c.name
			} );
	
			for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
				this.add( buttons[i] );
			}
	
			dt.on( 'destroy', function () {
				that.destroy();
			} );
	
			// Global key event binding to listen for button keys
			$('body').on( 'keyup.'+this.s.namespace, function ( e ) {
				if ( ! document.activeElement || document.activeElement === document.body ) {
					// SUse a string of characters for fast lookup of if we need to
					// handle this
					var character = String.fromCharCode(e.keyCode).toLowerCase();
	
					if ( that.s.listenKeys.toLowerCase().indexOf( character ) !== -1 ) {
						that._keypress( character, e );
					}
				}
			} );
		},
	
	
		/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
		 * Private methods
		 */
	
		/**
		 * Add a new button to the key press listener
		 * @param {object} conf Resolved button configuration object
		 * @private
		 */
		_addKey: function ( conf )
		{
			if ( conf.key ) {
				this.s.listenKeys += $.isPlainObject( conf.key ) ?
					conf.key.key :
					conf.key;
			}
		},
	
		/**
		 * Insert the buttons into the container. Call without parameters!
		 * @param  {node} [container] Recursive only - Insert point
		 * @param  {array} [buttons] Recursive only - Buttons array
		 * @private
		 */
		_draw: function ( container, buttons )
		{
			if ( ! container ) {
				container = this.dom.container;
				buttons = this.s.buttons;
			}
	
			container.children().detach();
	
			for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
				container.append( buttons[i].inserter );
				container.append( ' ' );
	
				if ( buttons[i].buttons && buttons[i].buttons.length ) {
					this._draw( buttons[i].collection, buttons[i].buttons );
				}
			}
		},
	
		/**
		 * Create buttons from an array of buttons
		 * @param  {array} attachTo Buttons array to attach to
		 * @param  {object} button Button definition
		 * @param  {boolean} inCollection true if the button is in a collection
		 * @private
		 */
		_expandButton: function ( attachTo, button, inCollection, attachPoint )
		{
			var dt = this.s.dt;
			var buttonCounter = 0;
			var buttons = ! $.isArray( button ) ?
				[ button ] :
				button;
	
			for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
				var conf = this._resolveExtends( buttons[i] );
	
				if ( ! conf ) {
					continue;
				}
	
				// If the configuration is an array, then expand the buttons at this
				// point
				if ( $.isArray( conf ) ) {
					this._expandButton( attachTo, conf, inCollection, attachPoint );
					continue;
				}
	
				var built = this._buildButton( conf, inCollection );
				if ( ! built ) {
					continue;
				}
	
				if ( attachPoint !== undefined ) {
					attachTo.splice( attachPoint, 0, built );
					attachPoint++;
				}
				else {
					attachTo.push( built );
				}
	
				if ( built.conf.buttons ) {
					var collectionDom = this.c.dom.collection;
					built.collection = $('<'+collectionDom.tag+'/>')
						.addClass( collectionDom.className )
						.attr( 'role', 'menu') ;
					built.conf._collection = built.collection;
	
					this._expandButton( built.buttons, built.conf.buttons, true, attachPoint );
				}
	
				// init call is made here, rather than buildButton as it needs to
				// be selectable, and for that it needs to be in the buttons array
				if ( conf.init ) {
					conf.init.call( dt.button( built.node ), dt, $(built.node), conf );
				}
	
				buttonCounter++;
			}
		},
	
		/**
		 * Create an individual button
		 * @param  {object} config            Resolved button configuration
		 * @param  {boolean} inCollection `true` if a collection button
		 * @return {jQuery} Created button node (jQuery)
		 * @private
		 */
		_buildButton: function ( config, inCollection )
		{
			var buttonDom = this.c.dom.button;
			var linerDom = this.c.dom.buttonLiner;
			var collectionDom = this.c.dom.collection;
			var dt = this.s.dt;
			var text = function ( opt ) {
				return typeof opt === 'function' ?
					opt( dt, button, config ) :
					opt;
			};
	
			if ( inCollection && collectionDom.button ) {
				buttonDom = collectionDom.button;
			}
	
			if ( inCollection && collectionDom.buttonLiner ) {
				linerDom = collectionDom.buttonLiner;
			}
	
			// Make sure that the button is available based on whatever requirements
			// it has. For example, Flash buttons require Flash
			if ( config.available && ! config.available( dt, config ) ) {
				return false;
			}
	
			var action = function ( e, dt, button, config ) {
				config.action.call( dt.button( button ), e, dt, button, config );
	
				$(dt.table().node()).triggerHandler( 'buttons-action.dt', [
					dt.button( button ), dt, button, config 
				] );
			};
	
			var button = $('<'+buttonDom.tag+'/>')
				.addClass( buttonDom.className )
				.attr( 'tabindex', this.s.dt.settings()[0].iTabIndex )
				.attr( 'aria-controls', this.s.dt.table().node().id )
				.on( 'click.dtb', function (e) {
					e.preventDefault();
	
					if ( ! button.hasClass( buttonDom.disabled ) && config.action ) {
						action( e, dt, button, config );
					}
	
					button.blur();
				} )
				.on( 'keyup.dtb', function (e) {
					if ( e.keyCode === 13 ) {
						if ( ! button.hasClass( buttonDom.disabled ) && config.action ) {
							action( e, dt, button, config );
						}
					}
				} );
	
			// Make `a` tags act like a link
			if ( buttonDom.tag.toLowerCase() === 'a' ) {
				button.attr( 'href', '#' );
			}
	
			if ( linerDom.tag ) {
				var liner = $('<'+linerDom.tag+'/>')
					.html( text( config.text ) )
					.addClass( linerDom.className );
	
				if ( linerDom.tag.toLowerCase() === 'a' ) {
					liner.attr( 'href', '#' );
				}
	
				button.append( liner );
			}
			else {
				button.html( text( config.text ) );
			}
	
			if ( config.enabled === false ) {
				button.addClass( buttonDom.disabled );
			}
	
			if ( config.className ) {
				button.addClass( config.className );
			}
	
			if ( config.titleAttr ) {
				button.attr( 'title', text( config.titleAttr ) );
			}
	
			if ( ! config.namespace ) {
				config.namespace = '.dt-button-'+(_buttonCounter++);
			}
	
			var buttonContainer = this.c.dom.buttonContainer;
			var inserter;
			if ( buttonContainer && buttonContainer.tag ) {
				inserter = $('<'+buttonContainer.tag+'/>')
					.addClass( buttonContainer.className )
					.append( button );
			}
			else {
				inserter = button;
			}
	
			this._addKey( config );
	
			return {
				conf:         config,
				node:         button.get(0),
				inserter:     inserter,
				buttons:      [],
				inCollection: inCollection,
				collection:   null
			};
		},
	
		/**
		 * Get the button object from a node (recursive)
		 * @param  {node} node Button node
		 * @param  {array} [buttons] Button array, uses base if not defined
		 * @return {object} Button object
		 * @private
		 */
		_nodeToButton: function ( node, buttons )
		{
			if ( ! buttons ) {
				buttons = this.s.buttons;
			}
	
			for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
				if ( buttons[i].node === node ) {
					return buttons[i];
				}
	
				if ( buttons[i].buttons.length ) {
					var ret = this._nodeToButton( node, buttons[i].buttons );
	
					if ( ret ) {
						return ret;
					}
				}
			}
		},
	
		/**
		 * Get container array for a button from a button node (recursive)
		 * @param  {node} node Button node
		 * @param  {array} [buttons] Button array, uses base if not defined
		 * @return {array} Button's host array
		 * @private
		 */
		_nodeToHost: function ( node, buttons )
		{
			if ( ! buttons ) {
				buttons = this.s.buttons;
			}
	
			for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
				if ( buttons[i].node === node ) {
					return buttons;
				}
	
				if ( buttons[i].buttons.length ) {
					var ret = this._nodeToHost( node, buttons[i].buttons );
	
					if ( ret ) {
						return ret;
					}
				}
			}
		},
	
		/**
		 * Handle a key press - determine if any button's key configured matches
		 * what was typed and trigger the action if so.
		 * @param  {string} character The character pressed
		 * @param  {object} e Key event that triggered this call
		 * @private
		 */
		_keypress: function ( character, e )
		{
			var run = function ( conf, node ) {
				if ( ! conf.key ) {
					return;
				}
	
				if ( conf.key === character ) {
					$(node).click();
				}
				else if ( $.isPlainObject( conf.key ) ) {
					if ( conf.key.key !== character ) {
						return;
					}
	
					if ( conf.key.shiftKey && ! e.shiftKey ) {
						return;
					}
	
					if ( conf.key.altKey && ! e.altKey ) {
						return;
					}
	
					if ( conf.key.ctrlKey && ! e.ctrlKey ) {
						return;
					}
	
					if ( conf.key.metaKey && ! e.metaKey ) {
						return;
					}
	
					// Made it this far - it is good
					$(node).click();
				}
			};
	
			var recurse = function ( a ) {
				for ( var i=0, ien=a.length ; i<ien ; i++ ) {
					run( a[i].conf, a[i].node );
	
					if ( a[i].buttons.length ) {
						recurse( a[i].buttons );
					}
				}
			};
	
			recurse( this.s.buttons );
		},
	
		/**
		 * Remove a key from the key listener for this instance (to be used when a
		 * button is removed)
		 * @param  {object} conf Button configuration
		 * @private
		 */
		_removeKey: function ( conf )
		{
			if ( conf.key ) {
				var character = $.isPlainObject( conf.key ) ?
					conf.key.key :
					conf.key;
	
				// Remove only one character, as multiple buttons could have the
				// same listening key
				var a = this.s.listenKeys.split('');
				var idx = $.inArray( character, a );
				a.splice( idx, 1 );
				this.s.listenKeys = a.join('');
			}
		},
	
		/**
		 * Resolve a button configuration
		 * @param  {string|function|object} conf Button config to resolve
		 * @return {object} Button configuration
		 * @private
		 */
		_resolveExtends: function ( conf )
		{
			var dt = this.s.dt;
			var i, ien;
			var toConfObject = function ( base ) {
				var loop = 0;
	
				// Loop until we have resolved to a button configuration, or an
				// array of button configurations (which will be iterated
				// separately)
				while ( ! $.isPlainObject(base) && ! $.isArray(base) ) {
					if ( base === undefined ) {
						return;
					}
	
					if ( typeof base === 'function' ) {
						base = base( dt, conf );
	
						if ( ! base ) {
							return false;
						}
					}
					else if ( typeof base === 'string' ) {
						if ( ! _dtButtons[ base ] ) {
							throw 'Unknown button type: '+base;
						}
	
						base = _dtButtons[ base ];
					}
	
					loop++;
					if ( loop > 30 ) {
						// Protect against misconfiguration killing the browser
						throw 'Buttons: Too many iterations';
					}
				}
	
				return $.isArray( base ) ?
					base :
					$.extend( {}, base );
			};
	
			conf = toConfObject( conf );
	
			while ( conf && conf.extend ) {
				// Use `toConfObject` in case the button definition being extended
				// is itself a string or a function
				if ( ! _dtButtons[ conf.extend ] ) {
					throw 'Cannot extend unknown button type: '+conf.extend;
				}
	
				var objArray = toConfObject( _dtButtons[ conf.extend ] );
				if ( $.isArray( objArray ) ) {
					return objArray;
				}
				else if ( ! objArray ) {
					// This is a little brutal as it might be possible to have a
					// valid button without the extend, but if there is no extend
					// then the host button would be acting in an undefined state
					return false;
				}
	
				// Stash the current class name
				var originalClassName = objArray.className;
	
				conf = $.extend( {}, objArray, conf );
	
				// The extend will have overwritten the original class name if the
				// `conf` object also assigned a class, but we want to concatenate
				// them so they are list that is combined from all extended buttons
				if ( originalClassName && conf.className !== originalClassName ) {
					conf.className = originalClassName+' '+conf.className;
				}
	
				// Buttons to be added to a collection  -gives the ability to define
				// if buttons should be added to the start or end of a collection
				var postfixButtons = conf.postfixButtons;
				if ( postfixButtons ) {
					if ( ! conf.buttons ) {
						conf.buttons = [];
					}
	
					for ( i=0, ien=postfixButtons.length ; i<ien ; i++ ) {
						conf.buttons.push( postfixButtons[i] );
					}
	
					conf.postfixButtons = null;
				}
	
				var prefixButtons = conf.prefixButtons;
				if ( prefixButtons ) {
					if ( ! conf.buttons ) {
						conf.buttons = [];
					}
	
					for ( i=0, ien=prefixButtons.length ; i<ien ; i++ ) {
						conf.buttons.splice( i, 0, prefixButtons[i] );
					}
	
					conf.prefixButtons = null;
				}
	
				// Although we want the `conf` object to overwrite almost all of
				// the properties of the object being extended, the `extend`
				// property should come from the object being extended
				conf.extend = objArray.extend;
			}
	
			return conf;
		}
	} );
	
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Statics
	 */
	
	/**
	 * Show / hide a background layer behind a collection
	 * @param  {boolean} Flag to indicate if the background should be shown or
	 *   hidden 
	 * @param  {string} Class to assign to the background
	 * @static
	 */
	Buttons.background = function ( show, className, fade ) {
		if ( fade === undefined ) {
			fade = 400;
		}
	
		if ( show ) {
			$('<div/>')
				.addClass( className )
				.css( 'display', 'none' )
				.appendTo( 'body' )
				.fadeIn( fade );
		}
		else {
			$('body > div.'+className)
				.fadeOut( fade, function () {
					$(this)
						.removeClass( className )
						.remove();
				} );
		}
	};
	
	/**
	 * Instance selector - select Buttons instances based on an instance selector
	 * value from the buttons assigned to a DataTable. This is only useful if
	 * multiple instances are attached to a DataTable.
	 * @param  {string|int|array} Instance selector - see `instance-selector`
	 *   documentation on the DataTables site
	 * @param  {array} Button instance array that was attached to the DataTables
	 *   settings object
	 * @return {array} Buttons instances
	 * @static
	 */
	Buttons.instanceSelector = function ( group, buttons )
	{
		if ( ! group ) {
			return $.map( buttons, function ( v ) {
				return v.inst;
			} );
		}
	
		var ret = [];
		var names = $.map( buttons, function ( v ) {
			return v.name;
		} );
	
		// Flatten the group selector into an array of single options
		var process = function ( input ) {
			if ( $.isArray( input ) ) {
				for ( var i=0, ien=input.length ; i<ien ; i++ ) {
					process( input[i] );
				}
				return;
			}
	
			if ( typeof input === 'string' ) {
				if ( input.indexOf( ',' ) !== -1 ) {
					// String selector, list of names
					process( input.split(',') );
				}
				else {
					// String selector individual name
					var idx = $.inArray( $.trim(input), names );
	
					if ( idx !== -1 ) {
						ret.push( buttons[ idx ].inst );
					}
				}
			}
			else if ( typeof input === 'number' ) {
				// Index selector
				ret.push( buttons[ input ].inst );
			}
		};
		
		process( group );
	
		return ret;
	};
	
	/**
	 * Button selector - select one or more buttons from a selector input so some
	 * operation can be performed on them.
	 * @param  {array} Button instances array that the selector should operate on
	 * @param  {string|int|node|jQuery|array} Button selector - see
	 *   `button-selector` documentation on the DataTables site
	 * @return {array} Array of objects containing `inst` and `idx` properties of
	 *   the selected buttons so you know which instance each button belongs to.
	 * @static
	 */
	Buttons.buttonSelector = function ( insts, selector )
	{
		var ret = [];
		var nodeBuilder = function ( a, buttons, baseIdx ) {
			var button;
			var idx;
	
			for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
				button = buttons[i];
	
				if ( button ) {
					idx = baseIdx !== undefined ?
						baseIdx+i :
						i+'';
	
					a.push( {
						node: button.node,
						name: button.conf.name,
						idx:  idx
					} );
	
					if ( button.buttons ) {
						nodeBuilder( a, button.buttons, idx+'-' );
					}
				}
			}
		};
	
		var run = function ( selector, inst ) {
			var i, ien;
			var buttons = [];
			nodeBuilder( buttons, inst.s.buttons );
	
			var nodes = $.map( buttons, function (v) {
				return v.node;
			} );
	
			if ( $.isArray( selector ) || selector instanceof $ ) {
				for ( i=0, ien=selector.length ; i<ien ; i++ ) {
					run( selector[i], inst );
				}
				return;
			}
	
			if ( selector === null || selector === undefined || selector === '*' ) {
				// Select all
				for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
					ret.push( {
						inst: inst,
						node: buttons[i].node
					} );
				}
			}
			else if ( typeof selector === 'number' ) {
				// Main button index selector
				ret.push( {
					inst: inst,
					node: inst.s.buttons[ selector ].node
				} );
			}
			else if ( typeof selector === 'string' ) {
				if ( selector.indexOf( ',' ) !== -1 ) {
					// Split
					var a = selector.split(',');
	
					for ( i=0, ien=a.length ; i<ien ; i++ ) {
						run( $.trim(a[i]), inst );
					}
				}
				else if ( selector.match( /^\d+(\-\d+)*$/ ) ) {
					// Sub-button index selector
					var indexes = $.map( buttons, function (v) {
						return v.idx;
					} );
	
					ret.push( {
						inst: inst,
						node: buttons[ $.inArray( selector, indexes ) ].node
					} );
				}
				else if ( selector.indexOf( ':name' ) !== -1 ) {
					// Button name selector
					var name = selector.replace( ':name', '' );
	
					for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
						if ( buttons[i].name === name ) {
							ret.push( {
								inst: inst,
								node: buttons[i].node
							} );
						}
					}
				}
				else {
					// jQuery selector on the nodes
					$( nodes ).filter( selector ).each( function () {
						ret.push( {
							inst: inst,
							node: this
						} );
					} );
				}
			}
			else if ( typeof selector === 'object' && selector.nodeName ) {
				// Node selector
				var idx = $.inArray( selector, nodes );
	
				if ( idx !== -1 ) {
					ret.push( {
						inst: inst,
						node: nodes[ idx ]
					} );
				}
			}
		};
	
	
		for ( var i=0, ien=insts.length ; i<ien ; i++ ) {
			var inst = insts[i];
	
			run( selector, inst );
		}
	
		return ret;
	};
	
	
	/**
	 * Buttons defaults. For full documentation, please refer to the docs/option
	 * directory or the DataTables site.
	 * @type {Object}
	 * @static
	 */
	Buttons.defaults = {
		buttons: [ 'copy', 'excel', 'csv', 'pdf', 'print' ],
		name: 'main',
		tabIndex: 0,
		dom: {
			container: {
				tag: 'div',
				className: 'dt-buttons'
			},
			collection: {
				tag: 'div',
				className: 'dt-button-collection'
			},
			button: {
				tag: 'a',
				className: 'dt-button',
				active: 'active',
				disabled: 'disabled'
			},
			buttonLiner: {
				tag: 'span',
				className: ''
			}
		}
	};
	
	/**
	 * Version information
	 * @type {string}
	 * @static
	 */
	Buttons.version = '1.4.1';
	
	
	$.extend( _dtButtons, {
		collection: {
			text: function ( dt ) {
				return dt.i18n( 'buttons.collection', 'Collection' );
			},
			className: 'buttons-collection',
			action: function ( e, dt, button, config ) {
				var host = button;
				var hostOffset = host.offset();
				var tableContainer = $( dt.table().container() );
				var multiLevel = false;
	
				// Remove any old collection
				if ( $('div.dt-button-background').length ) {
					multiLevel = $('.dt-button-collection').offset();
					$('body').trigger( 'click.dtb-collection' );
				}
	
				config._collection
					.addClass( config.collectionLayout )
					.css( 'display', 'none' )
					.appendTo( 'body' )
					.fadeIn( config.fade );
	
				var position = config._collection.css( 'position' );
	
				if ( multiLevel && position === 'absolute' ) {
					config._collection.css( {
						top: multiLevel.top,
						left: multiLevel.left
					} );
				}
				else if ( position === 'absolute' ) {
					config._collection.css( {
						top: hostOffset.top + host.outerHeight(),
						left: hostOffset.left
					} );
	
					// calculate overflow when positioned beneath
					var tableBottom = tableContainer.offset().top + tableContainer.height();
					var listBottom = hostOffset.top + host.outerHeight() + config._collection.outerHeight();
					var bottomOverflow = listBottom - tableBottom;
					
					// calculate overflow when positioned above
					var listTop = hostOffset.top - config._collection.outerHeight();
					var tableTop = tableContainer.offset().top;
					var topOverflow = tableTop - listTop;
					
					// if bottom overflow is larger, move to the top because it fits better
					if (bottomOverflow > topOverflow) {
						config._collection.css( 'top', hostOffset.top - config._collection.outerHeight() - 5);
					}
	
					var listRight = hostOffset.left + config._collection.outerWidth();
					var tableRight = tableContainer.offset().left + tableContainer.width();
					if ( listRight > tableRight ) {
						config._collection.css( 'left', hostOffset.left - ( listRight - tableRight ) );
					}
				}
				else {
					// Fix position - centre on screen
					var top = config._collection.height() / 2;
					if ( top > $(window).height() / 2 ) {
						top = $(window).height() / 2;
					}
	
					config._collection.css( 'marginTop', top*-1 );
				}
	
				if ( config.background ) {
					Buttons.background( true, config.backgroundClassName, config.fade );
				}
	
				// Need to break the 'thread' for the collection button being
				// activated by a click - it would also trigger this event
				setTimeout( function () {
					// This is bonkers, but if we don't have a click listener on the
					// background element, iOS Safari will ignore the body click
					// listener below. An empty function here is all that is
					// required to make it work...
					$('div.dt-button-background').on( 'click.dtb-collection', function () {} );
	
					$('body').on( 'click.dtb-collection', function (e) {
						// andSelf is deprecated in jQ1.8, but we want 1.7 compat
						var back = $.fn.addBack ? 'addBack' : 'andSelf';
	
						if ( ! $(e.target).parents()[back]().filter( config._collection ).length ) {
							config._collection
								.fadeOut( config.fade, function () {
									config._collection.detach();
								} );
	
							$('div.dt-button-background').off( 'click.dtb-collection' );
							Buttons.background( false, config.backgroundClassName, config.fade );
	
							$('body').off( 'click.dtb-collection' );
							dt.off( 'buttons-action.b-internal' );
						}
					} );
				}, 10 );
	
				if ( config.autoClose ) {
					dt.on( 'buttons-action.b-internal', function () {
						$('div.dt-button-background').click();
					} );
				}
			},
			background: true,
			collectionLayout: '',
			backgroundClassName: 'dt-button-background',
			autoClose: false,
			fade: 400
		},
		copy: function ( dt, conf ) {
			if ( _dtButtons.copyHtml5 ) {
				return 'copyHtml5';
			}
			if ( _dtButtons.copyFlash && _dtButtons.copyFlash.available( dt, conf ) ) {
				return 'copyFlash';
			}
		},
		csv: function ( dt, conf ) {
			// Common option that will use the HTML5 or Flash export buttons
			if ( _dtButtons.csvHtml5 && _dtButtons.csvHtml5.available( dt, conf ) ) {
				return 'csvHtml5';
			}
			if ( _dtButtons.csvFlash && _dtButtons.csvFlash.available( dt, conf ) ) {
				return 'csvFlash';
			}
		},
		excel: function ( dt, conf ) {
			// Common option that will use the HTML5 or Flash export buttons
			if ( _dtButtons.excelHtml5 && _dtButtons.excelHtml5.available( dt, conf ) ) {
				return 'excelHtml5';
			}
			if ( _dtButtons.excelFlash && _dtButtons.excelFlash.available( dt, conf ) ) {
				return 'excelFlash';
			}
		},
		pdf: function ( dt, conf ) {
			// Common option that will use the HTML5 or Flash export buttons
			if ( _dtButtons.pdfHtml5 && _dtButtons.pdfHtml5.available( dt, conf ) ) {
				return 'pdfHtml5';
			}
			if ( _dtButtons.pdfFlash && _dtButtons.pdfFlash.available( dt, conf ) ) {
				return 'pdfFlash';
			}
		},
		pageLength: function ( dt ) {
			var lengthMenu = dt.settings()[0].aLengthMenu;
			var vals = $.isArray( lengthMenu[0] ) ? lengthMenu[0] : lengthMenu;
			var lang = $.isArray( lengthMenu[0] ) ? lengthMenu[1] : lengthMenu;
			var text = function ( dt ) {
				return dt.i18n( 'buttons.pageLength', {
					"-1": 'Show all rows',
					_:    'Show %d rows'
				}, dt.page.len() );
			};
	
			return {
				extend: 'collection',
				text: text,
				className: 'buttons-page-length',
				autoClose: true,
				buttons: $.map( vals, function ( val, i ) {
					return {
						text: lang[i],
						className: 'button-page-length',
						action: function ( e, dt ) {
							dt.page.len( val ).draw();
						},
						init: function ( dt, node, conf ) {
							var that = this;
							var fn = function () {
								that.active( dt.page.len() === val );
							};
	
							dt.on( 'length.dt'+conf.namespace, fn );
							fn();
						},
						destroy: function ( dt, node, conf ) {
							dt.off( 'length.dt'+conf.namespace );
						}
					};
				} ),
				init: function ( dt, node, conf ) {
					var that = this;
					dt.on( 'length.dt'+conf.namespace, function () {
						that.text( text( dt ) );
					} );
				},
				destroy: function ( dt, node, conf ) {
					dt.off( 'length.dt'+conf.namespace );
				}
			};
		}
	} );
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * DataTables API
	 *
	 * For complete documentation, please refer to the docs/api directory or the
	 * DataTables site
	 */
	
	// Buttons group and individual button selector
	DataTable.Api.register( 'buttons()', function ( group, selector ) {
		// Argument shifting
		if ( selector === undefined ) {
			selector = group;
			group = undefined;
		}
	
		this.selector.buttonGroup = group;
	
		var res = this.iterator( true, 'table', function ( ctx ) {
			if ( ctx._buttons ) {
				return Buttons.buttonSelector(
					Buttons.instanceSelector( group, ctx._buttons ),
					selector
				);
			}
		}, true );
	
		res._groupSelector = group;
		return res;
	} );
	
	// Individual button selector
	DataTable.Api.register( 'button()', function ( group, selector ) {
		// just run buttons() and truncate
		var buttons = this.buttons( group, selector );
	
		if ( buttons.length > 1 ) {
			buttons.splice( 1, buttons.length );
		}
	
		return buttons;
	} );
	
	// Active buttons
	DataTable.Api.registerPlural( 'buttons().active()', 'button().active()', function ( flag ) {
		if ( flag === undefined ) {
			return this.map( function ( set ) {
				return set.inst.active( set.node );
			} );
		}
	
		return this.each( function ( set ) {
			set.inst.active( set.node, flag );
		} );
	} );
	
	// Get / set button action
	DataTable.Api.registerPlural( 'buttons().action()', 'button().action()', function ( action ) {
		if ( action === undefined ) {
			return this.map( function ( set ) {
				return set.inst.action( set.node );
			} );
		}
	
		return this.each( function ( set ) {
			set.inst.action( set.node, action );
		} );
	} );
	
	// Enable / disable buttons
	DataTable.Api.register( ['buttons().enable()', 'button().enable()'], function ( flag ) {
		return this.each( function ( set ) {
			set.inst.enable( set.node, flag );
		} );
	} );
	
	// Disable buttons
	DataTable.Api.register( ['buttons().disable()', 'button().disable()'], function () {
		return this.each( function ( set ) {
			set.inst.disable( set.node );
		} );
	} );
	
	// Get button nodes
	DataTable.Api.registerPlural( 'buttons().nodes()', 'button().node()', function () {
		var jq = $();
	
		// jQuery will automatically reduce duplicates to a single entry
		$( this.each( function ( set ) {
			jq = jq.add( set.inst.node( set.node ) );
		} ) );
	
		return jq;
	} );
	
	// Get / set button processing state
	DataTable.Api.registerPlural( 'buttons().processing()', 'button().processing()', function ( flag ) {
		if ( flag === undefined ) {
			return this.map( function ( set ) {
				return set.inst.processing( set.node );
			} );
		}
	
		return this.each( function ( set ) {
			set.inst.processing( set.node, flag );
		} );
	} );
	
	// Get / set button text (i.e. the button labels)
	DataTable.Api.registerPlural( 'buttons().text()', 'button().text()', function ( label ) {
		if ( label === undefined ) {
			return this.map( function ( set ) {
				return set.inst.text( set.node );
			} );
		}
	
		return this.each( function ( set ) {
			set.inst.text( set.node, label );
		} );
	} );
	
	// Trigger a button's action
	DataTable.Api.registerPlural( 'buttons().trigger()', 'button().trigger()', function () {
		return this.each( function ( set ) {
			set.inst.node( set.node ).trigger( 'click' );
		} );
	} );
	
	// Get the container elements
	DataTable.Api.registerPlural( 'buttons().containers()', 'buttons().container()', function () {
		var jq = $();
		var groupSelector = this._groupSelector;
	
		// We need to use the group selector directly, since if there are no buttons
		// the result set will be empty
		this.iterator( true, 'table', function ( ctx ) {
			if ( ctx._buttons ) {
				var insts = Buttons.instanceSelector( groupSelector, ctx._buttons );
	
				for ( var i=0, ien=insts.length ; i<ien ; i++ ) {
					jq = jq.add( insts[i].container() );
				}
			}
		} );
	
		return jq;
	} );
	
	// Add a new button
	DataTable.Api.register( 'button().add()', function ( idx, conf ) {
		var ctx = this.context;
	
		// Don't use `this` as it could be empty - select the instances directly
		if ( ctx.length ) {
			var inst = Buttons.instanceSelector( this._groupSelector, ctx[0]._buttons );
	
			if ( inst.length ) {
				inst[0].add( conf, idx );
			}
		}
	
		return this.button( this._groupSelector, idx );
	} );
	
	// Destroy the button sets selected
	DataTable.Api.register( 'buttons().destroy()', function () {
		this.pluck( 'inst' ).unique().each( function ( inst ) {
			inst.destroy();
		} );
	
		return this;
	} );
	
	// Remove a button
	DataTable.Api.registerPlural( 'buttons().remove()', 'buttons().remove()', function () {
		this.each( function ( set ) {
			set.inst.remove( set.node );
		} );
	
		return this;
	} );
	
	// Information box that can be used by buttons
	var _infoTimer;
	DataTable.Api.register( 'buttons.info()', function ( title, message, time ) {
		var that = this;
	
		if ( title === false ) {
			$('#datatables_buttons_info').fadeOut( function () {
				$(this).remove();
			} );
			clearTimeout( _infoTimer );
			_infoTimer = null;
	
			return this;
		}
	
		if ( _infoTimer ) {
			clearTimeout( _infoTimer );
		}
	
		if ( $('#datatables_buttons_info').length ) {
			$('#datatables_buttons_info').remove();
		}
	
		title = title ? '<h2>'+title+'</h2>' : '';
	
		$('<div id="datatables_buttons_info" class="dt-button-info"/>')
			.html( title )
			.append( $('<div/>')[ typeof message === 'string' ? 'html' : 'append' ]( message ) )
			.css( 'display', 'none' )
			.appendTo( 'body' )
			.fadeIn();
	
		if ( time !== undefined && time !== 0 ) {
			_infoTimer = setTimeout( function () {
				that.buttons.info( false );
			}, time );
		}
	
		return this;
	} );
	
	// Get data from the table for export - this is common to a number of plug-in
	// buttons so it is included in the Buttons core library
	DataTable.Api.register( 'buttons.exportData()', function ( options ) {
		if ( this.context.length ) {
			return _exportData( new DataTable.Api( this.context[0] ), options );
		}
	} );
	
	// Get information about the export that is common to many of the export data
	// types (DRY)
	DataTable.Api.register( 'buttons.exportInfo()', function ( conf ) {
		if ( ! conf ) {
			conf = {};
		}
	
		return {
			filename: _filename( conf ),
			title: _title( conf ),
			messageTop: _message(this, conf.messageTop || conf.message, 'top'),
			messageBottom: _message(this, conf.messageBottom, 'bottom')
		};
	} );
	
	
	
	/**
	 * Get the file name for an exported file.
	 *
	 * @param {object}	config Button configuration
	 * @param {boolean} incExtension Include the file name extension
	 */
	var _filename = function ( config )
	{
		// Backwards compatibility
		var filename = config.filename === '*' && config.title !== '*' && config.title !== undefined ?
			config.title :
			config.filename;
	
		if ( typeof filename === 'function' ) {
			filename = filename();
		}
	
		if ( filename === undefined || filename === null ) {
			return null;
		}
	
		if ( filename.indexOf( '*' ) !== -1 ) {
			filename = $.trim( filename.replace( '*', $('title').text() ) );
		}
	
		// Strip characters which the OS will object to
		filename = filename.replace(/[^a-zA-Z0-9_\u00A1-\uFFFF\.,\-_ !\(\)]/g, "");
	
		var extension = _stringOrFunction( config.extension );
		if ( ! extension ) {
			extension = '';
		}
	
		return filename + extension;
	};
	
	/**
	 * Simply utility method to allow parameters to be given as a function
	 *
	 * @param {undefined|string|function} option Option
	 * @return {null|string} Resolved value
	 */
	var _stringOrFunction = function ( option )
	{
		if ( option === null || option === undefined ) {
			return null;
		}
		else if ( typeof option === 'function' ) {
			return option();
		}
		return option;
	};
	
	/**
	 * Get the title for an exported file.
	 *
	 * @param {object} config	Button configuration
	 */
	var _title = function ( config )
	{
		var title = _stringOrFunction( config.title );
	
		return title === null ?
			null : title.indexOf( '*' ) !== -1 ?
				title.replace( '*', $('title').text() || 'Exported data' ) :
				title;
	};
	
	var _message = function ( dt, option, position )
	{
		var message = _stringOrFunction( option );
		if ( message === null ) {
			return null;
		}
	
		var caption = $('caption', dt.table().container()).eq(0);
		if ( message === '*' ) {
			var side = caption.css( 'caption-side' );
			if ( side !== position ) {
				return null;
			}
	
			return caption.length ?
				caption.text() :
				'';
		}
	
		return message;
	};
	
	
	
	
	
	
	
	var _exportTextarea = $('<textarea/>')[0];
	var _exportData = function ( dt, inOpts )
	{
		var config = $.extend( true, {}, {
			rows:           null,
			columns:        '',
			modifier:       {
				search: 'applied',
				order:  'applied'
			},
			orthogonal:     'display',
			stripHtml:      true,
			stripNewlines:  true,
			decodeEntities: true,
			trim:           true,
			format:         {
				header: function ( d ) {
					return strip( d );
				},
				footer: function ( d ) {
					return strip( d );
				},
				body: function ( d ) {
					return strip( d );
				}
			}
		}, inOpts );
	
		var strip = function ( str ) {
			if ( typeof str !== 'string' ) {
				return str;
			}
	
			// Always remove script tags
			str = str.replace( /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '' );
	
			if ( config.stripHtml ) {
				str = str.replace( /<[^>]*>/g, '' );
			}
	
			if ( config.trim ) {
				str = str.replace( /^\s+|\s+$/g, '' );
			}
	
			if ( config.stripNewlines ) {
				str = str.replace( /\n/g, ' ' );
			}
	
			if ( config.decodeEntities ) {
				_exportTextarea.innerHTML = str;
				str = _exportTextarea.value;
			}
	
			return str;
		};
	
	
		var header = dt.columns( config.columns ).indexes().map( function (idx) {
			var el = dt.column( idx ).header();
			return config.format.header( el.innerHTML, idx, el );
		} ).toArray();
	
		var footer = dt.table().footer() ?
			dt.columns( config.columns ).indexes().map( function (idx) {
				var el = dt.column( idx ).footer();
				return config.format.footer( el ? el.innerHTML : '', idx, el );
			} ).toArray() :
			null;
	
		var rowIndexes = dt.rows( config.rows, config.modifier ).indexes().toArray();
		var selectedCells = dt.cells( rowIndexes, config.columns );
		var cells = selectedCells
			.render( config.orthogonal )
			.toArray();
		var cellNodes = selectedCells
			.nodes()
			.toArray();
	
		var columns = header.length;
		var rows = columns > 0 ? cells.length / columns : 0;
		var body = new Array( rows );
		var cellCounter = 0;
	
		for ( var i=0, ien=rows ; i<ien ; i++ ) {
			var row = new Array( columns );
	
			for ( var j=0 ; j<columns ; j++ ) {
				row[j] = config.format.body( cells[ cellCounter ], i, j, cellNodes[ cellCounter ] );
				cellCounter++;
			}
	
			body[i] = row;
		}
	
		return {
			header: header,
			footer: footer,
			body:   body
		};
	};
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * DataTables interface
	 */
	
	// Attach to DataTables objects for global access
	$.fn.dataTable.Buttons = Buttons;
	$.fn.DataTable.Buttons = Buttons;
	
	
	
	// DataTables creation - check if the buttons have been defined for this table,
	// they will have been if the `B` option was used in `dom`, otherwise we should
	// create the buttons instance here so they can be inserted into the document
	// using the API. Listen for `init` for compatibility with pre 1.10.10, but to
	// be removed in future.
	$(document).on( 'init.dt plugin-init.dt', function (e, settings) {
		if ( e.namespace !== 'dt' ) {
			return;
		}
	
		var opts = settings.oInit.buttons || DataTable.defaults.buttons;
	
		if ( opts && ! settings._buttons ) {
			new Buttons( settings, opts ).container();
		}
	} );
	
	// DataTables `dom` feature option
	DataTable.ext.feature.push( {
		fnInit: function( settings ) {
			var api = new DataTable.Api( settings );
			var opts = api.init().buttons || DataTable.defaults.buttons;
	
			return new Buttons( api, opts ).container();
		},
		cFeature: "B"
	} );
	
	
	return Buttons;
	}));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Column visibility buttons for Buttons and DataTables.
	 * 2016 SpryMedia Ltd - datatables.net/license
	 */
	
	(function( factory ){
		if ( true ) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(1), __webpack_require__(275)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
				return factory( $, window, document );
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if ( typeof exports === 'object' ) {
			// CommonJS
			module.exports = function (root, $) {
				if ( ! root ) {
					root = window;
				}
	
				if ( ! $ || ! $.fn.dataTable ) {
					$ = require('datatables.net')(root, $).$;
				}
	
				if ( ! $.fn.dataTable.Buttons ) {
					require('datatables.net-buttons')(root, $);
				}
	
				return factory( $, root, root.document );
			};
		}
		else {
			// Browser
			factory( jQuery, window, document );
		}
	}(function( $, window, document, undefined ) {
	'use strict';
	var DataTable = $.fn.dataTable;
	
	
	$.extend( DataTable.ext.buttons, {
		// A collection of column visibility buttons
		colvis: function ( dt, conf ) {
			return {
				extend: 'collection',
				text: function ( dt ) {
					return dt.i18n( 'buttons.colvis', 'Column visibility' );
				},
				className: 'buttons-colvis',
				buttons: [ {
					extend: 'columnsToggle',
					columns: conf.columns,
					columnText: conf.columnText
				} ]
			};
		},
	
		// Selected columns with individual buttons - toggle column visibility
		columnsToggle: function ( dt, conf ) {
			var columns = dt.columns( conf.columns ).indexes().map( function ( idx ) {
				return {
					extend: 'columnToggle',
					columns: idx,
					columnText: conf.columnText
				};
			} ).toArray();
	
			return columns;
		},
	
		// Single button to toggle column visibility
		columnToggle: function ( dt, conf ) {
			return {
				extend: 'columnVisibility',
				columns: conf.columns,
				columnText: conf.columnText
			};
		},
	
		// Selected columns with individual buttons - set column visibility
		columnsVisibility: function ( dt, conf ) {
			var columns = dt.columns( conf.columns ).indexes().map( function ( idx ) {
				return {
					extend: 'columnVisibility',
					columns: idx,
					visibility: conf.visibility,
					columnText: conf.columnText
				};
			} ).toArray();
	
			return columns;
		},
	
		// Single button to set column visibility
		columnVisibility: {
			columns: undefined, // column selector
			text: function ( dt, button, conf ) {
				return conf._columnText( dt, conf );
			},
			className: 'buttons-columnVisibility',
			action: function ( e, dt, button, conf ) {
				var col = dt.columns( conf.columns );
				var curr = col.visible();
	
				col.visible( conf.visibility !== undefined ?
					conf.visibility :
					! (curr.length ? curr[0] : false )
				);
			},
			init: function ( dt, button, conf ) {
				var that = this;
	
				dt
					.on( 'column-visibility.dt'+conf.namespace, function (e, settings) {
						if ( ! settings.bDestroying && settings.nTable == dt.settings()[0].nTable ) {
							that.active( dt.column( conf.columns ).visible() );
						}
					} )
					.on( 'column-reorder.dt'+conf.namespace, function (e, settings, details) {
						// Don't rename buttons based on column name if the button
						// controls more than one column!
						if ( dt.columns( conf.columns ).count() !== 1 ) {
							return;
						}
	
						if ( typeof conf.columns === 'number' ) {
							conf.columns = details.mapping[ conf.columns ];
						}
	
						var col = dt.column( conf.columns );
	
						that.text( conf._columnText( dt, conf ) );
						that.active( col.visible() );
					} );
	
				this.active( dt.column( conf.columns ).visible() );
			},
			destroy: function ( dt, button, conf ) {
				dt
					.off( 'column-visibility.dt'+conf.namespace )
					.off( 'column-reorder.dt'+conf.namespace );
			},
	
			_columnText: function ( dt, conf ) {
				// Use DataTables' internal data structure until this is presented
				// is a public API. The other option is to use
				// `$( column(col).node() ).text()` but the node might not have been
				// populated when Buttons is constructed.
				var idx = dt.column( conf.columns ).index();
				var title = dt.settings()[0].aoColumns[ idx ].sTitle
					.replace(/\n/g," ")        // remove new lines
					.replace(/<br\s*\/?>/gi, " ")  // replace line breaks with spaces
					.replace( /<.*?>/g, "" )   // strip HTML
					.replace(/^\s+|\s+$/g,""); // trim
	
				return conf.columnText ?
					conf.columnText( dt, idx, title ) :
					title;
			}
		},
	
	
		colvisRestore: {
			className: 'buttons-colvisRestore',
	
			text: function ( dt ) {
				return dt.i18n( 'buttons.colvisRestore', 'Restore visibility' );
			},
	
			init: function ( dt, button, conf ) {
				conf._visOriginal = dt.columns().indexes().map( function ( idx ) {
					return dt.column( idx ).visible();
				} ).toArray();
			},
	
			action: function ( e, dt, button, conf ) {
				dt.columns().every( function ( i ) {
					// Take into account that ColReorder might have disrupted our
					// indexes
					var idx = dt.colReorder && dt.colReorder.transpose ?
						dt.colReorder.transpose( i, 'toOriginal' ) :
						i;
	
					this.visible( conf._visOriginal[ idx ] );
				} );
			}
		},
	
	
		colvisGroup: {
			className: 'buttons-colvisGroup',
	
			action: function ( e, dt, button, conf ) {
				dt.columns( conf.show ).visible( true, false );
				dt.columns( conf.hide ).visible( false, false );
	
				dt.columns.adjust();
			},
	
			show: [],
	
			hide: []
		}
	} );
	
	
	return DataTable.Buttons;
	}));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * HTML5 export buttons for Buttons and DataTables.
	 * 2016 SpryMedia Ltd - datatables.net/license
	 *
	 * FileSaver.js (1.3.3) - MIT license
	 * Copyright © 2016 Eli Grey - http://eligrey.com
	 */
	
	(function( factory ){
		if ( true ) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(1), __webpack_require__(275)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
				return factory( $, window, document );
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if ( typeof exports === 'object' ) {
			// CommonJS
			module.exports = function (root, $, jszip, pdfmake) {
				if ( ! root ) {
					root = window;
				}
	
				if ( ! $ || ! $.fn.dataTable ) {
					$ = require('datatables.net')(root, $).$;
				}
	
				if ( ! $.fn.dataTable.Buttons ) {
					require('datatables.net-buttons')(root, $);
				}
	
				return factory( $, root, root.document, jszip, pdfmake );
			};
		}
		else {
			// Browser
			factory( jQuery, window, document );
		}
	}(function( $, window, document, jszip, pdfmake, undefined ) {
	'use strict';
	var DataTable = $.fn.dataTable;
	
	// Allow the constructor to pass in JSZip and PDFMake from external requires.
	// Otherwise, use globally defined variables, if they are available.
	function _jsZip () {
		return jszip || window.JSZip;
	}
	function _pdfMake () {
		return pdfmake || window.pdfMake;
	}
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * FileSaver.js dependency
	 */
	
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	var _saveAs = (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	
	
	// Expose file saver on the DataTables API. Can't attach to `DataTables.Buttons`
	// since this file can be loaded before Button's core!
	DataTable.fileSave = _saveAs;
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Local (private) functions
	 */
	
	/**
	 * Get the sheet name for Excel exports.
	 *
	 * @param {object}	config Button configuration
	 */
	var _sheetname = function ( config )
	{
		var sheetName = 'Sheet1';
	
		if ( config.sheetName ) {
			sheetName = config.sheetName.replace(/[\[\]\*\/\\\?\:]/g, '');
		}
	
		return sheetName;
	};
	
	/**
	 * Get the newline character(s)
	 *
	 * @param {object}	config Button configuration
	 * @return {string}				Newline character
	 */
	var _newLine = function ( config )
	{
		return config.newline ?
			config.newline :
			navigator.userAgent.match(/Windows/) ?
				'\r\n' :
				'\n';
	};
	
	/**
	 * Combine the data from the `buttons.exportData` method into a string that
	 * will be used in the export file.
	 *
	 * @param	{DataTable.Api} dt		 DataTables API instance
	 * @param	{object}				config Button configuration
	 * @return {object}							 The data to export
	 */
	var _exportData = function ( dt, config )
	{
		var newLine = _newLine( config );
		var data = dt.buttons.exportData( config.exportOptions );
		var boundary = config.fieldBoundary;
		var separator = config.fieldSeparator;
		var reBoundary = new RegExp( boundary, 'g' );
		var escapeChar = config.escapeChar !== undefined ?
			config.escapeChar :
			'\\';
		var join = function ( a ) {
			var s = '';
	
			// If there is a field boundary, then we might need to escape it in
			// the source data
			for ( var i=0, ien=a.length ; i<ien ; i++ ) {
				if ( i > 0 ) {
					s += separator;
				}
	
				s += boundary ?
					boundary + ('' + a[i]).replace( reBoundary, escapeChar+boundary ) + boundary :
					a[i];
			}
	
			return s;
		};
	
		var header = config.header ? join( data.header )+newLine : '';
		var footer = config.footer && data.footer ? newLine+join( data.footer ) : '';
		var body = [];
	
		for ( var i=0, ien=data.body.length ; i<ien ; i++ ) {
			body.push( join( data.body[i] ) );
		}
	
		return {
			str: header + body.join( newLine ) + footer,
			rows: body.length
		};
	};
	
	/**
	 * Older versions of Safari (prior to tech preview 18) don't support the
	 * download option required.
	 *
	 * @return {Boolean} `true` if old Safari
	 */
	var _isDuffSafari = function ()
	{
		var safari = navigator.userAgent.indexOf('Safari') !== -1 &&
			navigator.userAgent.indexOf('Chrome') === -1 &&
			navigator.userAgent.indexOf('Opera') === -1;
	
		if ( ! safari ) {
			return false;
		}
	
		var version = navigator.userAgent.match( /AppleWebKit\/(\d+\.\d+)/ );
		if ( version && version.length > 1 && version[1]*1 < 603.1 ) {
			return true;
		}
	
		return false;
	};
	
	/**
	 * Convert from numeric position to letter for column names in Excel
	 * @param  {int} n Column number
	 * @return {string} Column letter(s) name
	 */
	function createCellPos( n ){
		var ordA = 'A'.charCodeAt(0);
		var ordZ = 'Z'.charCodeAt(0);
		var len = ordZ - ordA + 1;
		var s = "";
	
		while( n >= 0 ) {
			s = String.fromCharCode(n % len + ordA) + s;
			n = Math.floor(n / len) - 1;
		}
	
		return s;
	}
	
	try {
		var _serialiser = new XMLSerializer();
		var _ieExcel;
	}
	catch (t) {}
	
	/**
	 * Recursively add XML files from an object's structure to a ZIP file. This
	 * allows the XSLX file to be easily defined with an object's structure matching
	 * the files structure.
	 *
	 * @param {JSZip} zip ZIP package
	 * @param {object} obj Object to add (recursive)
	 */
	function _addToZip( zip, obj ) {
		if ( _ieExcel === undefined ) {
			// Detect if we are dealing with IE's _awful_ serialiser by seeing if it
			// drop attributes
			_ieExcel = _serialiser
				.serializeToString(
					$.parseXML( excelStrings['xl/worksheets/sheet1.xml'] )
				)
				.indexOf( 'xmlns:r' ) === -1;
		}
	
		$.each( obj, function ( name, val ) {
			if ( $.isPlainObject( val ) ) {
				var newDir = zip.folder( name );
				_addToZip( newDir, val );
			}
			else {
				if ( _ieExcel ) {
					// IE's XML serialiser will drop some name space attributes from
					// from the root node, so we need to save them. Do this by
					// replacing the namespace nodes with a regular attribute that
					// we convert back when serialised. Edge does not have this
					// issue
					var worksheet = val.childNodes[0];
					var i, ien;
					var attrs = [];
	
					for ( i=worksheet.attributes.length-1 ; i>=0 ; i-- ) {
						var attrName = worksheet.attributes[i].nodeName;
						var attrValue = worksheet.attributes[i].nodeValue;
	
						if ( attrName.indexOf( ':' ) !== -1 ) {
							attrs.push( { name: attrName, value: attrValue } );
	
							worksheet.removeAttribute( attrName );
						}
					}
	
					for ( i=0, ien=attrs.length ; i<ien ; i++ ) {
						var attr = val.createAttribute( attrs[i].name.replace( ':', '_dt_b_namespace_token_' ) );
						attr.value = attrs[i].value;
						worksheet.setAttributeNode( attr );
					}
				}
	
				var str = _serialiser.serializeToString(val);
	
				// Fix IE's XML
				if ( _ieExcel ) {
					// IE doesn't include the XML declaration
					if ( str.indexOf( '<?xml' ) === -1 ) {
						str = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+str;
					}
	
					// Return namespace attributes to being as such
					str = str.replace( /_dt_b_namespace_token_/g, ':' );
				}
	
				// Safari, IE and Edge will put empty name space attributes onto
				// various elements making them useless. This strips them out
				str = str.replace( /<([^<>]*?) xmlns=""([^<>]*?)>/g, '<$1 $2>' );
	
				zip.file( name, str );
			}
		} );
	}
	
	/**
	 * Create an XML node and add any children, attributes, etc without needing to
	 * be verbose in the DOM.
	 *
	 * @param  {object} doc      XML document
	 * @param  {string} nodeName Node name
	 * @param  {object} opts     Options - can be `attr` (attributes), `children`
	 *   (child nodes) and `text` (text content)
	 * @return {node}            Created node
	 */
	function _createNode( doc, nodeName, opts ) {
		var tempNode = doc.createElement( nodeName );
	
		if ( opts ) {
			if ( opts.attr ) {
				$(tempNode).attr( opts.attr );
			}
	
			if ( opts.children ) {
				$.each( opts.children, function ( key, value ) {
					tempNode.appendChild( value );
				} );
			}
	
			if ( opts.text !== null && opts.text !== undefined ) {
				tempNode.appendChild( doc.createTextNode( opts.text ) );
			}
		}
	
		return tempNode;
	}
	
	/**
	 * Get the width for an Excel column based on the contents of that column
	 * @param  {object} data Data for export
	 * @param  {int}    col  Column index
	 * @return {int}         Column width
	 */
	function _excelColWidth( data, col ) {
		var max = data.header[col].length;
		var len, lineSplit, str;
	
		if ( data.footer && data.footer[col].length > max ) {
			max = data.footer[col].length;
		}
	
		for ( var i=0, ien=data.body.length ; i<ien ; i++ ) {
			var point = data.body[i][col];
			str = point !== null && point !== undefined ?
				point.toString() :
				'';
	
			// If there is a newline character, workout the width of the column
			// based on the longest line in the string
			if ( str.indexOf('\n') !== -1 ) {
				lineSplit = str.split('\n');
				lineSplit.sort( function (a, b) {
					return b.length - a.length;
				} );
	
				len = lineSplit[0].length;
			}
			else {
				len = str.length;
			}
	
			if ( len > max ) {
				max = len;
			}
	
			// Max width rather than having potentially massive column widths
			if ( max > 40 ) {
				return 52; // 40 * 1.3
			}
		}
	
		max *= 1.3;
	
		// And a min width
		return max > 6 ? max : 6;
	}
	
	// Excel - Pre-defined strings to build a basic XLSX file
	var excelStrings = {
		"_rels/.rels":
			'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
			'<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'+
				'<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>'+
			'</Relationships>',
	
		"xl/_rels/workbook.xml.rels":
			'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
			'<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'+
				'<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>'+
				'<Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>'+
			'</Relationships>',
	
		"[Content_Types].xml":
			'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
			'<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">'+
				'<Default Extension="xml" ContentType="application/xml" />'+
				'<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml" />'+
				'<Default Extension="jpeg" ContentType="image/jpeg" />'+
				'<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" />'+
				'<Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" />'+
				'<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" />'+
			'</Types>',
	
		"xl/workbook.xml":
			'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
			'<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">'+
				'<fileVersion appName="xl" lastEdited="5" lowestEdited="5" rupBuild="24816"/>'+
				'<workbookPr showInkAnnotation="0" autoCompressPictures="0"/>'+
				'<bookViews>'+
					'<workbookView xWindow="0" yWindow="0" windowWidth="25600" windowHeight="19020" tabRatio="500"/>'+
				'</bookViews>'+
				'<sheets>'+
					'<sheet name="" sheetId="1" r:id="rId1"/>'+
				'</sheets>'+
			'</workbook>',
	
		"xl/worksheets/sheet1.xml":
			'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
			'<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">'+
				'<sheetData/>'+
				'<mergeCells count="0"/>'+
			'</worksheet>',
	
		"xl/styles.xml":
			'<?xml version="1.0" encoding="UTF-8"?>'+
			'<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">'+
				'<numFmts count="6">'+
					'<numFmt numFmtId="164" formatCode="#,##0.00_-\ [$$-45C]"/>'+
					'<numFmt numFmtId="165" formatCode="&quot;£&quot;#,##0.00"/>'+
					'<numFmt numFmtId="166" formatCode="[$€-2]\ #,##0.00"/>'+
					'<numFmt numFmtId="167" formatCode="0.0%"/>'+
					'<numFmt numFmtId="168" formatCode="#,##0;(#,##0)"/>'+
					'<numFmt numFmtId="169" formatCode="#,##0.00;(#,##0.00)"/>'+
				'</numFmts>'+
				'<fonts count="5" x14ac:knownFonts="1">'+
					'<font>'+
						'<sz val="11" />'+
						'<name val="Calibri" />'+
					'</font>'+
					'<font>'+
						'<sz val="11" />'+
						'<name val="Calibri" />'+
						'<color rgb="FFFFFFFF" />'+
					'</font>'+
					'<font>'+
						'<sz val="11" />'+
						'<name val="Calibri" />'+
						'<b />'+
					'</font>'+
					'<font>'+
						'<sz val="11" />'+
						'<name val="Calibri" />'+
						'<i />'+
					'</font>'+
					'<font>'+
						'<sz val="11" />'+
						'<name val="Calibri" />'+
						'<u />'+
					'</font>'+
				'</fonts>'+
				'<fills count="6">'+
					'<fill>'+
						'<patternFill patternType="none" />'+
					'</fill>'+
					'<fill/>'+ // Excel appears to use this as a dotted background regardless of values
					'<fill>'+
						'<patternFill patternType="solid">'+
							'<fgColor rgb="FFD9D9D9" />'+
							'<bgColor indexed="64" />'+
						'</patternFill>'+
					'</fill>'+
					'<fill>'+
						'<patternFill patternType="solid">'+
							'<fgColor rgb="FFD99795" />'+
							'<bgColor indexed="64" />'+
						'</patternFill>'+
					'</fill>'+
					'<fill>'+
						'<patternFill patternType="solid">'+
							'<fgColor rgb="ffc6efce" />'+
							'<bgColor indexed="64" />'+
						'</patternFill>'+
					'</fill>'+
					'<fill>'+
						'<patternFill patternType="solid">'+
							'<fgColor rgb="ffc6cfef" />'+
							'<bgColor indexed="64" />'+
						'</patternFill>'+
					'</fill>'+
				'</fills>'+
				'<borders count="2">'+
					'<border>'+
						'<left />'+
						'<right />'+
						'<top />'+
						'<bottom />'+
						'<diagonal />'+
					'</border>'+
					'<border diagonalUp="false" diagonalDown="false">'+
						'<left style="thin">'+
							'<color auto="1" />'+
						'</left>'+
						'<right style="thin">'+
							'<color auto="1" />'+
						'</right>'+
						'<top style="thin">'+
							'<color auto="1" />'+
						'</top>'+
						'<bottom style="thin">'+
							'<color auto="1" />'+
						'</bottom>'+
						'<diagonal />'+
					'</border>'+
				'</borders>'+
				'<cellStyleXfs count="1">'+
					'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" />'+
				'</cellStyleXfs>'+
				'<cellXfs count="67">'+
					'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="1" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="2" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="3" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="4" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="0" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="1" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="2" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="3" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="4" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="0" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="1" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="2" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="3" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="4" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="0" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="1" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="2" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="3" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="4" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="0" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="1" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="2" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="3" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="4" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="0" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="1" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="2" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="3" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="4" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="0" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="1" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="2" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="3" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="4" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="0" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="1" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="2" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="3" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="4" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="0" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="1" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="2" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="3" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="4" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="0" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="1" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="2" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="3" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="4" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
					'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
						'<alignment horizontal="left"/>'+
					'</xf>'+
					'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
						'<alignment horizontal="center"/>'+
					'</xf>'+
					'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
						'<alignment horizontal="right"/>'+
					'</xf>'+
					'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
						'<alignment horizontal="fill"/>'+
					'</xf>'+
					'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
						'<alignment textRotation="90"/>'+
					'</xf>'+
					'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
						'<alignment wrapText="1"/>'+
					'</xf>'+
					'<xf numFmtId="9"   fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
					'<xf numFmtId="164" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
					'<xf numFmtId="165" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
					'<xf numFmtId="166" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
					'<xf numFmtId="167" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
					'<xf numFmtId="168" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
					'<xf numFmtId="169" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
					'<xf numFmtId="3" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
					'<xf numFmtId="4" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
					'<xf numFmtId="1" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
					'<xf numFmtId="2" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'</cellXfs>'+
				'<cellStyles count="1">'+
					'<cellStyle name="Normal" xfId="0" builtinId="0" />'+
				'</cellStyles>'+
				'<dxfs count="0" />'+
				'<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4" />'+
			'</styleSheet>'
	};
	// Note we could use 3 `for` loops for the styles, but when gzipped there is
	// virtually no difference in size, since the above can be easily compressed
	
	// Pattern matching for special number formats. Perhaps this should be exposed
	// via an API in future?
	// Ref: section 3.8.30 - built in formatters in open spreadsheet
	//   https://www.ecma-international.org/news/TC45_current_work/Office%20Open%20XML%20Part%204%20-%20Markup%20Language%20Reference.pdf
	var _excelSpecials = [
		{ match: /^\-?\d+\.\d%$/,       style: 60, fmt: function (d) { return d/100; } }, // Precent with d.p.
		{ match: /^\-?\d+\.?\d*%$/,     style: 56, fmt: function (d) { return d/100; } }, // Percent
		{ match: /^\-?\$[\d,]+.?\d*$/,  style: 57 }, // Dollars
		{ match: /^\-?£[\d,]+.?\d*$/,   style: 58 }, // Pounds
		{ match: /^\-?€[\d,]+.?\d*$/,   style: 59 }, // Euros
		{ match: /^\-?\d+$/,            style: 65 }, // Numbers without thousand separators
		{ match: /^\-?\d+\.\d{2}$/,     style: 66 }, // Numbers 2 d.p. without thousands separators
		{ match: /^\([\d,]+\)$/,        style: 61, fmt: function (d) { return -1 * d.replace(/[\(\)]/g, ''); } },  // Negative numbers indicated by brackets
		{ match: /^\([\d,]+\.\d{2}\)$/, style: 62, fmt: function (d) { return -1 * d.replace(/[\(\)]/g, ''); } },  // Negative numbers indicated by brackets - 2d.p.
		{ match: /^\-?[\d,]+$/,         style: 63 }, // Numbers with thousand separators
		{ match: /^\-?[\d,]+\.\d{2}$/,  style: 64 }  // Numbers with 2 d.p. and thousands separators
	];
	
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Buttons
	 */
	
	//
	// Copy to clipboard
	//
	DataTable.ext.buttons.copyHtml5 = {
		className: 'buttons-copy buttons-html5',
	
		text: function ( dt ) {
			return dt.i18n( 'buttons.copy', 'Copy' );
		},
	
		action: function ( e, dt, button, config ) {
			this.processing( true );
	
			var that = this;
			var exportData = _exportData( dt, config );
			var info = dt.buttons.exportInfo( config );
			var newline = _newLine(config);
			var output = exportData.str;
			var hiddenDiv = $('<div/>')
				.css( {
					height: 1,
					width: 1,
					overflow: 'hidden',
					position: 'fixed',
					top: 0,
					left: 0
				} );
	
			if ( info.title ) {
				output = info.title + newline + newline + output;
			}
	
			if ( info.messageTop ) {
				output = info.messageTop + newline + newline + output;
			}
	
			if ( info.messageBottom ) {
				output = output + newline + newline + info.messageBottom;
			}
	
			if ( config.customize ) {
				output = config.customize( output, config );
			}
	
			var textarea = $('<textarea readonly/>')
				.val( output )
				.appendTo( hiddenDiv );
	
			// For browsers that support the copy execCommand, try to use it
			if ( document.queryCommandSupported('copy') ) {
				hiddenDiv.appendTo( dt.table().container() );
				textarea[0].focus();
				textarea[0].select();
	
				try {
					var successful = document.execCommand( 'copy' );
					hiddenDiv.remove();
	
					if (successful) {
						dt.buttons.info(
							dt.i18n( 'buttons.copyTitle', 'Copy to clipboard' ),
							dt.i18n( 'buttons.copySuccess', {
								1: 'Copied one row to clipboard',
								_: 'Copied %d rows to clipboard'
							}, exportData.rows ),
							2000
						);
	
						this.processing( false );
						return;
					}
				}
				catch (t) {}
			}
	
			// Otherwise we show the text box and instruct the user to use it
			var message = $('<span>'+dt.i18n( 'buttons.copyKeys',
					'Press <i>ctrl</i> or <i>\u2318</i> + <i>C</i> to copy the table data<br>to your system clipboard.<br><br>'+
					'To cancel, click this message or press escape.' )+'</span>'
				)
				.append( hiddenDiv );
	
			dt.buttons.info( dt.i18n( 'buttons.copyTitle', 'Copy to clipboard' ), message, 0 );
	
			// Select the text so when the user activates their system clipboard
			// it will copy that text
			textarea[0].focus();
			textarea[0].select();
	
			// Event to hide the message when the user is done
			var container = $(message).closest('.dt-button-info');
			var close = function () {
				container.off( 'click.buttons-copy' );
				$(document).off( '.buttons-copy' );
				dt.buttons.info( false );
			};
	
			container.on( 'click.buttons-copy', close );
			$(document)
				.on( 'keydown.buttons-copy', function (e) {
					if ( e.keyCode === 27 ) { // esc
						close();
						that.processing( false );
					}
				} )
				.on( 'copy.buttons-copy cut.buttons-copy', function () {
					close();
					that.processing( false );
				} );
		},
	
		exportOptions: {},
	
		fieldSeparator: '\t',
	
		fieldBoundary: '',
	
		header: true,
	
		footer: false,
	
		title: '*',
	
		messageTop: '*',
	
		messageBottom: '*'
	};
	
	//
	// CSV export
	//
	DataTable.ext.buttons.csvHtml5 = {
		bom: false,
	
		className: 'buttons-csv buttons-html5',
	
		available: function () {
			return window.FileReader !== undefined && window.Blob;
		},
	
		text: function ( dt ) {
			return dt.i18n( 'buttons.csv', 'CSV' );
		},
	
		action: function ( e, dt, button, config ) {
			this.processing( true );
	
			// Set the text
			var output = _exportData( dt, config ).str;
			var info = dt.buttons.exportInfo(config);
			var charset = config.charset;
	
			if ( config.customize ) {
				output = config.customize( output, config );
			}
	
			if ( charset !== false ) {
				if ( ! charset ) {
					charset = document.characterSet || document.charset;
				}
	
				if ( charset ) {
					charset = ';charset='+charset;
				}
			}
			else {
				charset = '';
			}
	
			if ( config.bom ) {
				output = '\ufeff' + output;
			}
	
			_saveAs(
				new Blob( [output], {type: 'text/csv'+charset} ),
				info.filename,
				true
			);
	
			this.processing( false );
		},
	
		filename: '*',
	
		extension: '.csv',
	
		exportOptions: {},
	
		fieldSeparator: ',',
	
		fieldBoundary: '"',
	
		escapeChar: '"',
	
		charset: null,
	
		header: true,
	
		footer: false
	};
	
	//
	// Excel (xlsx) export
	//
	DataTable.ext.buttons.excelHtml5 = {
		className: 'buttons-excel buttons-html5',
	
		available: function () {
			return window.FileReader !== undefined && _jsZip() !== undefined && ! _isDuffSafari() && _serialiser;
		},
	
		text: function ( dt ) {
			return dt.i18n( 'buttons.excel', 'Excel' );
		},
	
		action: function ( e, dt, button, config ) {
			this.processing( true );
	
			var that = this;
			var rowPos = 0;
			var getXml = function ( type ) {
				var str = excelStrings[ type ];
	
				//str = str.replace( /xmlns:/g, 'xmlns_' ).replace( /mc:/g, 'mc_' );
	
				return $.parseXML( str );
			};
			var rels = getXml('xl/worksheets/sheet1.xml');
			var relsGet = rels.getElementsByTagName( "sheetData" )[0];
	
			var xlsx = {
				_rels: {
					".rels": getXml('_rels/.rels')
				},
				xl: {
					_rels: {
						"workbook.xml.rels": getXml('xl/_rels/workbook.xml.rels')
					},
					"workbook.xml": getXml('xl/workbook.xml'),
					"styles.xml": getXml('xl/styles.xml'),
					"worksheets": {
						"sheet1.xml": rels
					}
	
				},
				"[Content_Types].xml": getXml('[Content_Types].xml')
			};
	
			var data = dt.buttons.exportData( config.exportOptions );
			var currentRow, rowNode;
			var addRow = function ( row ) {
				currentRow = rowPos+1;
				rowNode = _createNode( rels, "row", { attr: {r:currentRow} } );
	
				for ( var i=0, ien=row.length ; i<ien ; i++ ) {
					// Concat both the Cell Columns as a letter and the Row of the cell.
					var cellId = createCellPos(i) + '' + currentRow;
					var cell = null;
	
					// For null, undefined of blank cell, continue so it doesn't create the _createNode
					if ( row[i] === null || row[i] === undefined || row[i] === '' ) {
						continue;
					}
	
					row[i] = $.trim( row[i] );
	
					// Special number formatting options
					for ( var j=0, jen=_excelSpecials.length ; j<jen ; j++ ) {
						var special = _excelSpecials[j];
	
						// TODO Need to provide the ability for the specials to say
						// if they are returning a string, since at the moment it is
						// assumed to be a number
						if ( row[i].match && ! row[i].match(/^0\d+/) && row[i].match( special.match ) ) {
							var val = row[i].replace(/[^\d\.\-]/g, '');
	
							if ( special.fmt ) {
								val = special.fmt( val );
							}
	
							cell = _createNode( rels, 'c', {
								attr: {
									r: cellId,
									s: special.style
								},
								children: [
									_createNode( rels, 'v', { text: val } )
								]
							} );
	
							break;
						}
					}
	
					if ( ! cell ) {
						if ( typeof row[i] === 'number' || (
							row[i].match &&
							row[i].match(/^-?\d+(\.\d+)?$/) &&
							! row[i].match(/^0\d+/) )
						) {
							// Detect numbers - don't match numbers with leading zeros
							// or a negative anywhere but the start
							cell = _createNode( rels, 'c', {
								attr: {
									t: 'n',
									r: cellId
								},
								children: [
									_createNode( rels, 'v', { text: row[i] } )
								]
							} );
						}
						else {
							// String output - replace non standard characters for text output
							var text = ! row[i].replace ?
								row[i] :
								row[i].replace(/[\x00-\x09\x0B\x0C\x0E-\x1F\x7F-\x9F]/g, '');
	
							cell = _createNode( rels, 'c', {
								attr: {
									t: 'inlineStr',
									r: cellId
								},
								children:{
									row: _createNode( rels, 'is', {
										children: {
											row: _createNode( rels, 't', {
												text: text
											} )
										}
									} )
								}
							} );
						}
					}
	
					rowNode.appendChild( cell );
				}
	
				relsGet.appendChild(rowNode);
				rowPos++;
			};
	
			$( 'sheets sheet', xlsx.xl['workbook.xml'] ).attr( 'name', _sheetname( config ) );
	
			if ( config.customizeData ) {
				config.customizeData( data );
			}
	
			var mergeCells = function ( row, colspan ) {
				var mergeCells = $('mergeCells', rels);
	
				mergeCells[0].appendChild( _createNode( rels, 'mergeCell', {
					attr: {
						ref: 'A'+row+':'+createCellPos(colspan)+row
					}
				} ) );
				mergeCells.attr( 'count', mergeCells.attr( 'count' )+1 );
				$('row:eq('+(row-1)+') c', rels).attr( 's', '51' ); // centre
			};
	
			// Title and top messages
			var exportInfo = dt.buttons.exportInfo( config );
			if ( exportInfo.title ) {
				addRow( [exportInfo.title], rowPos );
				mergeCells( rowPos, data.header.length-1 );
			}
	
			if ( exportInfo.messageTop ) {
				addRow( [exportInfo.messageTop], rowPos );
				mergeCells( rowPos, data.header.length-1 );
			}
	
			// Table itself
			if ( config.header ) {
				addRow( data.header, rowPos );
				$('row:last c', rels).attr( 's', '2' ); // bold
			}
	
			for ( var n=0, ie=data.body.length ; n<ie ; n++ ) {
				addRow( data.body[n], rowPos );
			}
	
			if ( config.footer && data.footer ) {
				addRow( data.footer, rowPos);
				$('row:last c', rels).attr( 's', '2' ); // bold
			}
	
			// Below the table
			if ( exportInfo.messageBottom ) {
				addRow( [exportInfo.messageBottom], rowPos );
				mergeCells( rowPos, data.header.length-1 );
			}
	
			// Set column widths
			var cols = _createNode( rels, 'cols' );
			$('worksheet', rels).prepend( cols );
	
			for ( var i=0, ien=data.header.length ; i<ien ; i++ ) {
				cols.appendChild( _createNode( rels, 'col', {
					attr: {
						min: i+1,
						max: i+1,
						width: _excelColWidth( data, i ),
						customWidth: 1
					}
				} ) );
			}
	
			// Let the developer customise the document if they want to
			if ( config.customize ) {
				config.customize( xlsx );
			}
	
			var jszip = _jsZip();
			var zip = new jszip();
			var zipConfig = {
				type: 'blob',
				mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			};
	
			_addToZip( zip, xlsx );
	
			if ( zip.generateAsync ) {
				// JSZip 3+
				zip
					.generateAsync( zipConfig )
					.then( function ( blob ) {
						_saveAs( blob, exportInfo.filename );
						that.processing( false );
					} );
			}
			else {
				// JSZip 2.5
				_saveAs(
					zip.generate( zipConfig ),
					exportInfo.filename
				);
				this.processing( false );
			}
		},
	
		filename: '*',
	
		extension: '.xlsx',
	
		exportOptions: {},
	
		header: true,
	
		footer: false,
	
		title: '*',
	
		messageTop: '*',
	
		messageBottom: '*'
	};
	
	//
	// PDF export - using pdfMake - http://pdfmake.org
	//
	DataTable.ext.buttons.pdfHtml5 = {
		className: 'buttons-pdf buttons-html5',
	
		available: function () {
			return window.FileReader !== undefined && _pdfMake();
		},
	
		text: function ( dt ) {
			return dt.i18n( 'buttons.pdf', 'PDF' );
		},
	
		action: function ( e, dt, button, config ) {
			this.processing( true );
	
			var that = this;
			var data = dt.buttons.exportData( config.exportOptions );
			var info = dt.buttons.exportInfo( config );
			var rows = [];
	
			if ( config.header ) {
				rows.push( $.map( data.header, function ( d ) {
					return {
						text: typeof d === 'string' ? d : d+'',
						style: 'tableHeader'
					};
				} ) );
			}
	
			for ( var i=0, ien=data.body.length ; i<ien ; i++ ) {
				rows.push( $.map( data.body[i], function ( d ) {
					return {
						text: typeof d === 'string' ? d : d+'',
						style: i % 2 ? 'tableBodyEven' : 'tableBodyOdd'
					};
				} ) );
			}
	
			if ( config.footer && data.footer) {
				rows.push( $.map( data.footer, function ( d ) {
					return {
						text: typeof d === 'string' ? d : d+'',
						style: 'tableFooter'
					};
				} ) );
			}
	
			var doc = {
				pageSize: config.pageSize,
				pageOrientation: config.orientation,
				content: [
					{
						table: {
							headerRows: 1,
							body: rows
						},
						layout: 'noBorders'
					}
				],
				styles: {
					tableHeader: {
						bold: true,
						fontSize: 11,
						color: 'white',
						fillColor: '#2d4154',
						alignment: 'center'
					},
					tableBodyEven: {},
					tableBodyOdd: {
						fillColor: '#f3f3f3'
					},
					tableFooter: {
						bold: true,
						fontSize: 11,
						color: 'white',
						fillColor: '#2d4154'
					},
					title: {
						alignment: 'center',
						fontSize: 15
					},
					message: {}
				},
				defaultStyle: {
					fontSize: 10
				}
			};
	
			if ( info.messageTop ) {
				doc.content.unshift( {
					text: info.messageTop,
					style: 'message',
					margin: [ 0, 0, 0, 12 ]
				} );
			}
	
			if ( info.messageBottom ) {
				doc.content.push( {
					text: info.messageBottom,
					style: 'message',
					margin: [ 0, 0, 0, 12 ]
				} );
			}
	
			if ( info.title ) {
				doc.content.unshift( {
					text: info.title,
					style: 'title',
					margin: [ 0, 0, 0, 12 ]
				} );
			}
	
			if ( config.customize ) {
				config.customize( doc, config );
			}
	
			var pdf = _pdfMake().createPdf( doc );
	
			if ( config.download === 'open' && ! _isDuffSafari() ) {
				pdf.open();
				this.processing( false );
			}
			else {
				pdf.getBuffer( function (buffer) {
					var blob = new Blob( [buffer], {type:'application/pdf'} );
	
					_saveAs( blob, info.filename );
					that.processing( false );
				} );
			}
		},
	
		title: '*',
	
		filename: '*',
	
		extension: '.pdf',
	
		exportOptions: {},
	
		orientation: 'portrait',
	
		pageSize: 'A4',
	
		header: true,
	
		footer: false,
	
		messageTop: '*',
	
		messageBottom: '*',
	
		customize: null,
	
		download: 'download'
	};
	
	
	return DataTable.Buttons;
	}));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Print button for Buttons and DataTables.
	 * 2016 SpryMedia Ltd - datatables.net/license
	 */
	
	(function( factory ){
		if ( true ) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(1), __webpack_require__(275)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
				return factory( $, window, document );
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if ( typeof exports === 'object' ) {
			// CommonJS
			module.exports = function (root, $) {
				if ( ! root ) {
					root = window;
				}
	
				if ( ! $ || ! $.fn.dataTable ) {
					$ = require('datatables.net')(root, $).$;
				}
	
				if ( ! $.fn.dataTable.Buttons ) {
					require('datatables.net-buttons')(root, $);
				}
	
				return factory( $, root, root.document );
			};
		}
		else {
			// Browser
			factory( jQuery, window, document );
		}
	}(function( $, window, document, undefined ) {
	'use strict';
	var DataTable = $.fn.dataTable;
	
	
	var _link = document.createElement( 'a' );
	
	/**
	 * Clone link and style tags, taking into account the need to change the source
	 * path.
	 *
	 * @param  {node}     el Element to convert
	 */
	var _styleToAbs = function( el ) {
		var url;
		var clone = $(el).clone()[0];
		var linkHost;
	
		if ( clone.nodeName.toLowerCase() === 'link' ) {
			clone.href = _relToAbs( clone.href );
		}
	
		return clone.outerHTML;
	};
	
	/**
	 * Convert a URL from a relative to an absolute address so it will work
	 * correctly in the popup window which has no base URL.
	 *
	 * @param  {string} href URL
	 */
	var _relToAbs = function( href ) {
		// Assign to a link on the original page so the browser will do all the
		// hard work of figuring out where the file actually is
		_link.href = href;
		var linkHost = _link.host;
	
		// IE doesn't have a trailing slash on the host
		// Chrome has it on the pathname
		if ( linkHost.indexOf('/') === -1 && _link.pathname.indexOf('/') !== 0) {
			linkHost += '/';
		}
	
		return _link.protocol+"//"+linkHost+_link.pathname+_link.search;
	};
	
	
	DataTable.ext.buttons.print = {
		className: 'buttons-print',
	
		text: function ( dt ) {
			return dt.i18n( 'buttons.print', 'Print' );
		},
	
		action: function ( e, dt, button, config ) {
			var data = dt.buttons.exportData(
				$.extend( {decodeEntities: false}, config.exportOptions ) // XSS protection
			);
			var exportInfo = dt.buttons.exportInfo( config );
	
			var addRow = function ( d, tag ) {
				var str = '<tr>';
	
				for ( var i=0, ien=d.length ; i<ien ; i++ ) {
					str += '<'+tag+'>'+d[i]+'</'+tag+'>';
				}
	
				return str + '</tr>';
			};
	
			// Construct a table for printing
			var html = '<table class="'+dt.table().node().className+'">';
	
			if ( config.header ) {
				html += '<thead>'+ addRow( data.header, 'th' ) +'</thead>';
			}
	
			html += '<tbody>';
			for ( var i=0, ien=data.body.length ; i<ien ; i++ ) {
				html += addRow( data.body[i], 'td' );
			}
			html += '</tbody>';
	
			if ( config.footer && data.footer ) {
				html += '<tfoot>'+ addRow( data.footer, 'th' ) +'</tfoot>';
			}
			html += '</table>';
	
			// Open a new window for the printable table
			var win = window.open( '', '' );
			win.document.close();
	
			// Inject the title and also a copy of the style and link tags from this
			// document so the table can retain its base styling. Note that we have
			// to use string manipulation as IE won't allow elements to be created
			// in the host document and then appended to the new window.
			var head = '<title>'+exportInfo.title+'</title>';
			$('style, link').each( function () {
				head += _styleToAbs( this );
			} );
	
			try {
				win.document.head.innerHTML = head; // Work around for Edge
			}
			catch (e) {
				$(win.document.head).html( head ); // Old IE
			}
	
			// Inject the table and other surrounding information
			win.document.body.innerHTML =
				'<h1>'+exportInfo.title+'</h1>'+
				'<div>'+(exportInfo.messageTop || '')+'</div>'+
				html+
				'<div>'+(exportInfo.messageBottom || '')+'</div>';
	
			$(win.document.body).addClass('dt-print-view');
	
			$('img', win.document.body).each( function ( i, img ) {
				img.setAttribute( 'src', _relToAbs( img.getAttribute('src') ) );
			} );
	
			if ( config.customize ) {
				config.customize( win );
			}
	
			// Allow stylesheets time to load
			setTimeout( function () {
				if ( config.autoPrint ) {
					win.print(); // blocking - so close will not
					win.close(); // execute until this is done
				}
			}, 1000 );
		},
	
		title: '*',
	
		messageTop: '*',
	
		messageBottom: '*',
	
		exportOptions: {},
	
		header: true,
	
		footer: false,
	
		autoPrint: true,
	
		customize: null
	};
	
	
	return DataTable.Buttons;
	}));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 RowGroup 1.1.2
	 ©2017-2020 SpryMedia Ltd - datatables.net/license
	*/
	(function(c){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2),__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(i){return c(i,window,document)}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof exports?module.exports=function(i,d){i||(i=window);if(!d||!d.fn.dataTable)d=require("datatables.net")(i,d).$;return c(d,i,i.document)}:c(jQuery,window,document)})(function(c,i,d,k){var e=c.fn.dataTable,g=function(a,b){if(!e.versionCheck||!e.versionCheck("1.10.8"))throw"RowGroup requires DataTables 1.10.8 or newer";this.c=c.extend(!0,{},e.defaults.rowGroup,
	g.defaults,b);this.s={dt:new e.Api(a)};this.dom={};var m=this.s.dt.settings()[0],f=m.rowGroup;if(f)return f;m.rowGroup=this;this._constructor()};c.extend(g.prototype,{dataSrc:function(a){if(a===k)return this.c.dataSrc;var b=this.s.dt;this.c.dataSrc=a;c(b.table().node()).triggerHandler("rowgroup-datasrc.dt",[b,a]);return this},disable:function(){this.c.enable=!1;return this},enable:function(a){if(!1===a)return this.disable();this.c.enable=!0;return this},enabled:function(){return this.c.enable},_constructor:function(){var a=
	this,b=this.s.dt,c=b.settings()[0];b.on("draw.dtrg",function(b,e){a.c.enable&&c===e&&a._draw()});b.on("column-visibility.dt.dtrg responsive-resize.dt.dtrg",function(){a._adjustColspan()});b.on("destroy",function(){b.off(".dtrg")})},_adjustColspan:function(){c("tr."+this.c.className,this.s.dt.table().body()).find("td:visible").attr("colspan",this._colspan())},_colspan:function(){return this.s.dt.columns().visible().reduce(function(a,b){return a+b},0)},_draw:function(){var a=this._group(0,this.s.dt.rows({page:"current"}).indexes());
	this._groupDisplay(0,a)},_group:function(a,b){for(var m=c.isArray(this.c.dataSrc)?this.c.dataSrc:[this.c.dataSrc],f=e.ext.oApi._fnGetObjectDataFn(m[a]),i=this.s.dt,j,g,l=[],h=0,d=b.length;h<d;h++){var n=b[h];j=i.row(n).data();j=f(j);if(null===j||j===k)j=this.c.emptyDataGroup;if(g===k||j!==g)l.push({dataPoint:j,rows:[]}),g=j;l[l.length-1].rows.push(n)}if(m[a+1]!==k){h=0;for(d=l.length;h<d;h++)l[h].children=this._group(a+1,l[h].rows)}return l},_groupDisplay:function(a,b){for(var c=this.s.dt,f,e=0,g=
	b.length;e<g;e++){var d=b[e],i=d.dataPoint,h=d.rows;this.c.startRender&&(f=this.c.startRender.call(this,c.rows(h),i,a),(f=this._rowWrap(f,this.c.startClassName,a))&&f.insertBefore(c.row(h[0]).node()));this.c.endRender&&(f=this.c.endRender.call(this,c.rows(h),i,a),(f=this._rowWrap(f,this.c.endClassName,a))&&f.insertAfter(c.row(h[h.length-1]).node()));d.children&&this._groupDisplay(a+1,d.children)}},_rowWrap:function(a,b,e){if(null===a||""===a)a=this.c.emptyDataGroup;return a===k||null===a?null:("object"===
	typeof a&&a.nodeName&&"tr"===a.nodeName.toLowerCase()?c(a):a instanceof c&&a.length&&"tr"===a[0].nodeName.toLowerCase()?a:c("<tr/>").append(c("<td/>").attr("colspan",this._colspan()).append(a))).addClass(this.c.className).addClass(b).addClass("dtrg-level-"+e)}});g.defaults={className:"dtrg-group",dataSrc:0,emptyDataGroup:"No group",enable:!0,endClassName:"dtrg-end",endRender:null,startClassName:"dtrg-start",startRender:function(a,b){return b}};g.version="1.1.2";c.fn.dataTable.RowGroup=g;c.fn.DataTable.RowGroup=
	g;e.Api.register("rowGroup()",function(){return this});e.Api.register("rowGroup().disable()",function(){return this.iterator("table",function(a){a.rowGroup&&a.rowGroup.enable(!1)})});e.Api.register("rowGroup().enable()",function(a){return this.iterator("table",function(b){b.rowGroup&&b.rowGroup.enable(a===k?!0:a)})});e.Api.register("rowGroup().enabled()",function(){var a=this.context;return a.length&&a[0].rowGroup?a[0].rowGroup.enabled():!1});e.Api.register("rowGroup().dataSrc()",function(a){return a===
	k?this.context[0].rowGroup.dataSrc():this.iterator("table",function(b){b.rowGroup&&b.rowGroup.dataSrc(a)})});c(d).on("preInit.dt.dtrg",function(a,b){if("dt"===a.namespace){var d=b.oInit.rowGroup,f=e.defaults.rowGroup;if(d||f)f=c.extend({},f,d),!1!==d&&new g(b,f)}});return g});


/***/ }),
/* 280 */
5,
/* 281 */,
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Sortable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Sortable
	//>>group: Interactions
	//>>description: Enables items in a list to be sorted using the mouse.
	//>>docs: http://api.jqueryui.com/sortable/
	//>>demos: http://jqueryui.com/sortable/
	//>>css.structure: ../../themes/base/sortable.css
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(2),
				__webpack_require__(283),
				__webpack_require__(287),
				__webpack_require__(284),
				__webpack_require__(288),
				__webpack_require__(285),
				__webpack_require__(286)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	return $.widget( "ui.sortable", $.ui.mouse, {
		version: "1.12.1",
		widgetEventPrefix: "sort",
		ready: false,
		options: {
			appendTo: "parent",
			axis: false,
			connectWith: false,
			containment: false,
			cursor: "auto",
			cursorAt: false,
			dropOnEmpty: true,
			forcePlaceholderSize: false,
			forceHelperSize: false,
			grid: false,
			handle: false,
			helper: "original",
			items: "> *",
			opacity: false,
			placeholder: false,
			revert: false,
			scroll: true,
			scrollSensitivity: 20,
			scrollSpeed: 20,
			scope: "default",
			tolerance: "intersect",
			zIndex: 1000,
	
			// Callbacks
			activate: null,
			beforeStop: null,
			change: null,
			deactivate: null,
			out: null,
			over: null,
			receive: null,
			remove: null,
			sort: null,
			start: null,
			stop: null,
			update: null
		},
	
		_isOverAxis: function( x, reference, size ) {
			return ( x >= reference ) && ( x < ( reference + size ) );
		},
	
		_isFloating: function( item ) {
			return ( /left|right/ ).test( item.css( "float" ) ) ||
				( /inline|table-cell/ ).test( item.css( "display" ) );
		},
	
		_create: function() {
			this.containerCache = {};
			this._addClass( "ui-sortable" );
	
			//Get the items
			this.refresh();
	
			//Let's determine the parent's offset
			this.offset = this.element.offset();
	
			//Initialize mouse events for interaction
			this._mouseInit();
	
			this._setHandleClassName();
	
			//We're ready to go
			this.ready = true;
	
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
	
			if ( key === "handle" ) {
				this._setHandleClassName();
			}
		},
	
		_setHandleClassName: function() {
			var that = this;
			this._removeClass( this.element.find( ".ui-sortable-handle" ), "ui-sortable-handle" );
			$.each( this.items, function() {
				that._addClass(
					this.instance.options.handle ?
						this.item.find( this.instance.options.handle ) :
						this.item,
					"ui-sortable-handle"
				);
			} );
		},
	
		_destroy: function() {
			this._mouseDestroy();
	
			for ( var i = this.items.length - 1; i >= 0; i-- ) {
				this.items[ i ].item.removeData( this.widgetName + "-item" );
			}
	
			return this;
		},
	
		_mouseCapture: function( event, overrideHandle ) {
			var currentItem = null,
				validHandle = false,
				that = this;
	
			if ( this.reverting ) {
				return false;
			}
	
			if ( this.options.disabled || this.options.type === "static" ) {
				return false;
			}
	
			//We have to refresh the items data once first
			this._refreshItems( event );
	
			//Find out if the clicked node (or one of its parents) is a actual item in this.items
			$( event.target ).parents().each( function() {
				if ( $.data( this, that.widgetName + "-item" ) === that ) {
					currentItem = $( this );
					return false;
				}
			} );
			if ( $.data( event.target, that.widgetName + "-item" ) === that ) {
				currentItem = $( event.target );
			}
	
			if ( !currentItem ) {
				return false;
			}
			if ( this.options.handle && !overrideHandle ) {
				$( this.options.handle, currentItem ).find( "*" ).addBack().each( function() {
					if ( this === event.target ) {
						validHandle = true;
					}
				} );
				if ( !validHandle ) {
					return false;
				}
			}
	
			this.currentItem = currentItem;
			this._removeCurrentsFromItems();
			return true;
	
		},
	
		_mouseStart: function( event, overrideHandle, noActivation ) {
	
			var i, body,
				o = this.options;
	
			this.currentContainer = this;
	
			//We only need to call refreshPositions, because the refreshItems call has been moved to
			// mouseCapture
			this.refreshPositions();
	
			//Create and append the visible helper
			this.helper = this._createHelper( event );
	
			//Cache the helper size
			this._cacheHelperProportions();
	
			/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 */
	
			//Cache the margins of the original element
			this._cacheMargins();
	
			//Get the next scrolling parent
			this.scrollParent = this.helper.scrollParent();
	
			//The element's absolute position on the page minus margins
			this.offset = this.currentItem.offset();
			this.offset = {
				top: this.offset.top - this.margins.top,
				left: this.offset.left - this.margins.left
			};
	
			$.extend( this.offset, {
				click: { //Where the click happened, relative to the element
					left: event.pageX - this.offset.left,
					top: event.pageY - this.offset.top
				},
				parent: this._getParentOffset(),
	
				// This is a relative to absolute position minus the actual position calculation -
				// only used for relative positioned helper
				relative: this._getRelativeOffset()
			} );
	
			// Only after we got the offset, we can change the helper's position to absolute
			// TODO: Still need to figure out a way to make relative sorting possible
			this.helper.css( "position", "absolute" );
			this.cssPosition = this.helper.css( "position" );
	
			//Generate the original position
			this.originalPosition = this._generatePosition( event );
			this.originalPageX = event.pageX;
			this.originalPageY = event.pageY;
	
			//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
			( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );
	
			//Cache the former DOM position
			this.domPosition = {
				prev: this.currentItem.prev()[ 0 ],
				parent: this.currentItem.parent()[ 0 ]
			};
	
			// If the helper is not the original, hide the original so it's not playing any role during
			// the drag, won't cause anything bad this way
			if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
				this.currentItem.hide();
			}
	
			//Create the placeholder
			this._createPlaceholder();
	
			//Set a containment if given in the options
			if ( o.containment ) {
				this._setContainment();
			}
	
			if ( o.cursor && o.cursor !== "auto" ) { // cursor option
				body = this.document.find( "body" );
	
				// Support: IE
				this.storedCursor = body.css( "cursor" );
				body.css( "cursor", o.cursor );
	
				this.storedStylesheet =
					$( "<style>*{ cursor: " + o.cursor + " !important; }</style>" ).appendTo( body );
			}
	
			if ( o.opacity ) { // opacity option
				if ( this.helper.css( "opacity" ) ) {
					this._storedOpacity = this.helper.css( "opacity" );
				}
				this.helper.css( "opacity", o.opacity );
			}
	
			if ( o.zIndex ) { // zIndex option
				if ( this.helper.css( "zIndex" ) ) {
					this._storedZIndex = this.helper.css( "zIndex" );
				}
				this.helper.css( "zIndex", o.zIndex );
			}
	
			//Prepare scrolling
			if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ].tagName !== "HTML" ) {
				this.overflowOffset = this.scrollParent.offset();
			}
	
			//Call callbacks
			this._trigger( "start", event, this._uiHash() );
	
			//Recache the helper size
			if ( !this._preserveHelperProportions ) {
				this._cacheHelperProportions();
			}
	
			//Post "activate" events to possible containers
			if ( !noActivation ) {
				for ( i = this.containers.length - 1; i >= 0; i-- ) {
					this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
				}
			}
	
			//Prepare possible droppables
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.current = this;
			}
	
			if ( $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( this, event );
			}
	
			this.dragging = true;
	
			this._addClass( this.helper, "ui-sortable-helper" );
	
			// Execute the drag once - this causes the helper not to be visiblebefore getting its
			// correct position
			this._mouseDrag( event );
			return true;
	
		},
	
		_mouseDrag: function( event ) {
			var i, item, itemElement, intersection,
				o = this.options,
				scrolled = false;
	
			//Compute the helpers position
			this.position = this._generatePosition( event );
			this.positionAbs = this._convertPositionTo( "absolute" );
	
			if ( !this.lastPositionAbs ) {
				this.lastPositionAbs = this.positionAbs;
			}
	
			//Do scrolling
			if ( this.options.scroll ) {
				if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
						this.scrollParent[ 0 ].tagName !== "HTML" ) {
	
					if ( ( this.overflowOffset.top + this.scrollParent[ 0 ].offsetHeight ) -
							event.pageY < o.scrollSensitivity ) {
						this.scrollParent[ 0 ].scrollTop =
							scrolled = this.scrollParent[ 0 ].scrollTop + o.scrollSpeed;
					} else if ( event.pageY - this.overflowOffset.top < o.scrollSensitivity ) {
						this.scrollParent[ 0 ].scrollTop =
							scrolled = this.scrollParent[ 0 ].scrollTop - o.scrollSpeed;
					}
	
					if ( ( this.overflowOffset.left + this.scrollParent[ 0 ].offsetWidth ) -
							event.pageX < o.scrollSensitivity ) {
						this.scrollParent[ 0 ].scrollLeft = scrolled =
							this.scrollParent[ 0 ].scrollLeft + o.scrollSpeed;
					} else if ( event.pageX - this.overflowOffset.left < o.scrollSensitivity ) {
						this.scrollParent[ 0 ].scrollLeft = scrolled =
							this.scrollParent[ 0 ].scrollLeft - o.scrollSpeed;
					}
	
				} else {
	
					if ( event.pageY - this.document.scrollTop() < o.scrollSensitivity ) {
						scrolled = this.document.scrollTop( this.document.scrollTop() - o.scrollSpeed );
					} else if ( this.window.height() - ( event.pageY - this.document.scrollTop() ) <
							o.scrollSensitivity ) {
						scrolled = this.document.scrollTop( this.document.scrollTop() + o.scrollSpeed );
					}
	
					if ( event.pageX - this.document.scrollLeft() < o.scrollSensitivity ) {
						scrolled = this.document.scrollLeft(
							this.document.scrollLeft() - o.scrollSpeed
						);
					} else if ( this.window.width() - ( event.pageX - this.document.scrollLeft() ) <
							o.scrollSensitivity ) {
						scrolled = this.document.scrollLeft(
							this.document.scrollLeft() + o.scrollSpeed
						);
					}
	
				}
	
				if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
					$.ui.ddmanager.prepareOffsets( this, event );
				}
			}
	
			//Regenerate the absolute position used for position checks
			this.positionAbs = this._convertPositionTo( "absolute" );
	
			//Set the helper position
			if ( !this.options.axis || this.options.axis !== "y" ) {
				this.helper[ 0 ].style.left = this.position.left + "px";
			}
			if ( !this.options.axis || this.options.axis !== "x" ) {
				this.helper[ 0 ].style.top = this.position.top + "px";
			}
	
			//Rearrange
			for ( i = this.items.length - 1; i >= 0; i-- ) {
	
				//Cache variables and intersection, continue if no intersection
				item = this.items[ i ];
				itemElement = item.item[ 0 ];
				intersection = this._intersectsWithPointer( item );
				if ( !intersection ) {
					continue;
				}
	
				// Only put the placeholder inside the current Container, skip all
				// items from other containers. This works because when moving
				// an item from one container to another the
				// currentContainer is switched before the placeholder is moved.
				//
				// Without this, moving items in "sub-sortables" can cause
				// the placeholder to jitter between the outer and inner container.
				if ( item.instance !== this.currentContainer ) {
					continue;
				}
	
				// Cannot intersect with itself
				// no useless actions that have been done before
				// no action if the item moved is the parent of the item checked
				if ( itemElement !== this.currentItem[ 0 ] &&
					this.placeholder[ intersection === 1 ? "next" : "prev" ]()[ 0 ] !== itemElement &&
					!$.contains( this.placeholder[ 0 ], itemElement ) &&
					( this.options.type === "semi-dynamic" ?
						!$.contains( this.element[ 0 ], itemElement ) :
						true
					)
				) {
	
					this.direction = intersection === 1 ? "down" : "up";
	
					if ( this.options.tolerance === "pointer" || this._intersectsWithSides( item ) ) {
						this._rearrange( event, item );
					} else {
						break;
					}
	
					this._trigger( "change", event, this._uiHash() );
					break;
				}
			}
	
			//Post events to containers
			this._contactContainers( event );
	
			//Interconnect with droppables
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.drag( this, event );
			}
	
			//Call callbacks
			this._trigger( "sort", event, this._uiHash() );
	
			this.lastPositionAbs = this.positionAbs;
			return false;
	
		},
	
		_mouseStop: function( event, noPropagation ) {
	
			if ( !event ) {
				return;
			}
	
			//If we are using droppables, inform the manager about the drop
			if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
				$.ui.ddmanager.drop( this, event );
			}
	
			if ( this.options.revert ) {
				var that = this,
					cur = this.placeholder.offset(),
					axis = this.options.axis,
					animation = {};
	
				if ( !axis || axis === "x" ) {
					animation.left = cur.left - this.offset.parent.left - this.margins.left +
						( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
							0 :
							this.offsetParent[ 0 ].scrollLeft
						);
				}
				if ( !axis || axis === "y" ) {
					animation.top = cur.top - this.offset.parent.top - this.margins.top +
						( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
							0 :
							this.offsetParent[ 0 ].scrollTop
						);
				}
				this.reverting = true;
				$( this.helper ).animate(
					animation,
					parseInt( this.options.revert, 10 ) || 500,
					function() {
						that._clear( event );
					}
				);
			} else {
				this._clear( event, noPropagation );
			}
	
			return false;
	
		},
	
		cancel: function() {
	
			if ( this.dragging ) {
	
				this._mouseUp( new $.Event( "mouseup", { target: null } ) );
	
				if ( this.options.helper === "original" ) {
					this.currentItem.css( this._storedCSS );
					this._removeClass( this.currentItem, "ui-sortable-helper" );
				} else {
					this.currentItem.show();
				}
	
				//Post deactivating events to containers
				for ( var i = this.containers.length - 1; i >= 0; i-- ) {
					this.containers[ i ]._trigger( "deactivate", null, this._uiHash( this ) );
					if ( this.containers[ i ].containerCache.over ) {
						this.containers[ i ]._trigger( "out", null, this._uiHash( this ) );
						this.containers[ i ].containerCache.over = 0;
					}
				}
	
			}
	
			if ( this.placeholder ) {
	
				//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
				// it unbinds ALL events from the original node!
				if ( this.placeholder[ 0 ].parentNode ) {
					this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
				}
				if ( this.options.helper !== "original" && this.helper &&
						this.helper[ 0 ].parentNode ) {
					this.helper.remove();
				}
	
				$.extend( this, {
					helper: null,
					dragging: false,
					reverting: false,
					_noFinalSort: null
				} );
	
				if ( this.domPosition.prev ) {
					$( this.domPosition.prev ).after( this.currentItem );
				} else {
					$( this.domPosition.parent ).prepend( this.currentItem );
				}
			}
	
			return this;
	
		},
	
		serialize: function( o ) {
	
			var items = this._getItemsAsjQuery( o && o.connected ),
				str = [];
			o = o || {};
	
			$( items ).each( function() {
				var res = ( $( o.item || this ).attr( o.attribute || "id" ) || "" )
					.match( o.expression || ( /(.+)[\-=_](.+)/ ) );
				if ( res ) {
					str.push(
						( o.key || res[ 1 ] + "[]" ) +
						"=" + ( o.key && o.expression ? res[ 1 ] : res[ 2 ] ) );
				}
			} );
	
			if ( !str.length && o.key ) {
				str.push( o.key + "=" );
			}
	
			return str.join( "&" );
	
		},
	
		toArray: function( o ) {
	
			var items = this._getItemsAsjQuery( o && o.connected ),
				ret = [];
	
			o = o || {};
	
			items.each( function() {
				ret.push( $( o.item || this ).attr( o.attribute || "id" ) || "" );
			} );
			return ret;
	
		},
	
		/* Be careful with the following core functions */
		_intersectsWith: function( item ) {
	
			var x1 = this.positionAbs.left,
				x2 = x1 + this.helperProportions.width,
				y1 = this.positionAbs.top,
				y2 = y1 + this.helperProportions.height,
				l = item.left,
				r = l + item.width,
				t = item.top,
				b = t + item.height,
				dyClick = this.offset.click.top,
				dxClick = this.offset.click.left,
				isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t &&
					( y1 + dyClick ) < b ),
				isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l &&
					( x1 + dxClick ) < r ),
				isOverElement = isOverElementHeight && isOverElementWidth;
	
			if ( this.options.tolerance === "pointer" ||
				this.options.forcePointerForContainers ||
				( this.options.tolerance !== "pointer" &&
					this.helperProportions[ this.floating ? "width" : "height" ] >
					item[ this.floating ? "width" : "height" ] )
			) {
				return isOverElement;
			} else {
	
				return ( l < x1 + ( this.helperProportions.width / 2 ) && // Right Half
					x2 - ( this.helperProportions.width / 2 ) < r && // Left Half
					t < y1 + ( this.helperProportions.height / 2 ) && // Bottom Half
					y2 - ( this.helperProportions.height / 2 ) < b ); // Top Half
	
			}
		},
	
		_intersectsWithPointer: function( item ) {
			var verticalDirection, horizontalDirection,
				isOverElementHeight = ( this.options.axis === "x" ) ||
					this._isOverAxis(
						this.positionAbs.top + this.offset.click.top, item.top, item.height ),
				isOverElementWidth = ( this.options.axis === "y" ) ||
					this._isOverAxis(
						this.positionAbs.left + this.offset.click.left, item.left, item.width ),
				isOverElement = isOverElementHeight && isOverElementWidth;
	
			if ( !isOverElement ) {
				return false;
			}
	
			verticalDirection = this._getDragVerticalDirection();
			horizontalDirection = this._getDragHorizontalDirection();
	
			return this.floating ?
				( ( horizontalDirection === "right" || verticalDirection === "down" ) ? 2 : 1 )
				: ( verticalDirection && ( verticalDirection === "down" ? 2 : 1 ) );
	
		},
	
		_intersectsWithSides: function( item ) {
	
			var isOverBottomHalf = this._isOverAxis( this.positionAbs.top +
					this.offset.click.top, item.top + ( item.height / 2 ), item.height ),
				isOverRightHalf = this._isOverAxis( this.positionAbs.left +
					this.offset.click.left, item.left + ( item.width / 2 ), item.width ),
				verticalDirection = this._getDragVerticalDirection(),
				horizontalDirection = this._getDragHorizontalDirection();
	
			if ( this.floating && horizontalDirection ) {
				return ( ( horizontalDirection === "right" && isOverRightHalf ) ||
					( horizontalDirection === "left" && !isOverRightHalf ) );
			} else {
				return verticalDirection && ( ( verticalDirection === "down" && isOverBottomHalf ) ||
					( verticalDirection === "up" && !isOverBottomHalf ) );
			}
	
		},
	
		_getDragVerticalDirection: function() {
			var delta = this.positionAbs.top - this.lastPositionAbs.top;
			return delta !== 0 && ( delta > 0 ? "down" : "up" );
		},
	
		_getDragHorizontalDirection: function() {
			var delta = this.positionAbs.left - this.lastPositionAbs.left;
			return delta !== 0 && ( delta > 0 ? "right" : "left" );
		},
	
		refresh: function( event ) {
			this._refreshItems( event );
			this._setHandleClassName();
			this.refreshPositions();
			return this;
		},
	
		_connectWith: function() {
			var options = this.options;
			return options.connectWith.constructor === String ?
				[ options.connectWith ] :
				options.connectWith;
		},
	
		_getItemsAsjQuery: function( connected ) {
	
			var i, j, cur, inst,
				items = [],
				queries = [],
				connectWith = this._connectWith();
	
			if ( connectWith && connected ) {
				for ( i = connectWith.length - 1; i >= 0; i-- ) {
					cur = $( connectWith[ i ], this.document[ 0 ] );
					for ( j = cur.length - 1; j >= 0; j-- ) {
						inst = $.data( cur[ j ], this.widgetFullName );
						if ( inst && inst !== this && !inst.options.disabled ) {
							queries.push( [ $.isFunction( inst.options.items ) ?
								inst.options.items.call( inst.element ) :
								$( inst.options.items, inst.element )
									.not( ".ui-sortable-helper" )
									.not( ".ui-sortable-placeholder" ), inst ] );
						}
					}
				}
			}
	
			queries.push( [ $.isFunction( this.options.items ) ?
				this.options.items
					.call( this.element, null, { options: this.options, item: this.currentItem } ) :
				$( this.options.items, this.element )
					.not( ".ui-sortable-helper" )
					.not( ".ui-sortable-placeholder" ), this ] );
	
			function addItems() {
				items.push( this );
			}
			for ( i = queries.length - 1; i >= 0; i-- ) {
				queries[ i ][ 0 ].each( addItems );
			}
	
			return $( items );
	
		},
	
		_removeCurrentsFromItems: function() {
	
			var list = this.currentItem.find( ":data(" + this.widgetName + "-item)" );
	
			this.items = $.grep( this.items, function( item ) {
				for ( var j = 0; j < list.length; j++ ) {
					if ( list[ j ] === item.item[ 0 ] ) {
						return false;
					}
				}
				return true;
			} );
	
		},
	
		_refreshItems: function( event ) {
	
			this.items = [];
			this.containers = [ this ];
	
			var i, j, cur, inst, targetData, _queries, item, queriesLength,
				items = this.items,
				queries = [ [ $.isFunction( this.options.items ) ?
					this.options.items.call( this.element[ 0 ], event, { item: this.currentItem } ) :
					$( this.options.items, this.element ), this ] ],
				connectWith = this._connectWith();
	
			//Shouldn't be run the first time through due to massive slow-down
			if ( connectWith && this.ready ) {
				for ( i = connectWith.length - 1; i >= 0; i-- ) {
					cur = $( connectWith[ i ], this.document[ 0 ] );
					for ( j = cur.length - 1; j >= 0; j-- ) {
						inst = $.data( cur[ j ], this.widgetFullName );
						if ( inst && inst !== this && !inst.options.disabled ) {
							queries.push( [ $.isFunction( inst.options.items ) ?
								inst.options.items
									.call( inst.element[ 0 ], event, { item: this.currentItem } ) :
								$( inst.options.items, inst.element ), inst ] );
							this.containers.push( inst );
						}
					}
				}
			}
	
			for ( i = queries.length - 1; i >= 0; i-- ) {
				targetData = queries[ i ][ 1 ];
				_queries = queries[ i ][ 0 ];
	
				for ( j = 0, queriesLength = _queries.length; j < queriesLength; j++ ) {
					item = $( _queries[ j ] );
	
					// Data for target checking (mouse manager)
					item.data( this.widgetName + "-item", targetData );
	
					items.push( {
						item: item,
						instance: targetData,
						width: 0, height: 0,
						left: 0, top: 0
					} );
				}
			}
	
		},
	
		refreshPositions: function( fast ) {
	
			// Determine whether items are being displayed horizontally
			this.floating = this.items.length ?
				this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
				false;
	
			//This has to be redone because due to the item being moved out/into the offsetParent,
			// the offsetParent's position will change
			if ( this.offsetParent && this.helper ) {
				this.offset.parent = this._getParentOffset();
			}
	
			var i, item, t, p;
	
			for ( i = this.items.length - 1; i >= 0; i-- ) {
				item = this.items[ i ];
	
				//We ignore calculating positions of all connected containers when we're not over them
				if ( item.instance !== this.currentContainer && this.currentContainer &&
						item.item[ 0 ] !== this.currentItem[ 0 ] ) {
					continue;
				}
	
				t = this.options.toleranceElement ?
					$( this.options.toleranceElement, item.item ) :
					item.item;
	
				if ( !fast ) {
					item.width = t.outerWidth();
					item.height = t.outerHeight();
				}
	
				p = t.offset();
				item.left = p.left;
				item.top = p.top;
			}
	
			if ( this.options.custom && this.options.custom.refreshContainers ) {
				this.options.custom.refreshContainers.call( this );
			} else {
				for ( i = this.containers.length - 1; i >= 0; i-- ) {
					p = this.containers[ i ].element.offset();
					this.containers[ i ].containerCache.left = p.left;
					this.containers[ i ].containerCache.top = p.top;
					this.containers[ i ].containerCache.width =
						this.containers[ i ].element.outerWidth();
					this.containers[ i ].containerCache.height =
						this.containers[ i ].element.outerHeight();
				}
			}
	
			return this;
		},
	
		_createPlaceholder: function( that ) {
			that = that || this;
			var className,
				o = that.options;
	
			if ( !o.placeholder || o.placeholder.constructor === String ) {
				className = o.placeholder;
				o.placeholder = {
					element: function() {
	
						var nodeName = that.currentItem[ 0 ].nodeName.toLowerCase(),
							element = $( "<" + nodeName + ">", that.document[ 0 ] );
	
							that._addClass( element, "ui-sortable-placeholder",
									className || that.currentItem[ 0 ].className )
								._removeClass( element, "ui-sortable-helper" );
	
						if ( nodeName === "tbody" ) {
							that._createTrPlaceholder(
								that.currentItem.find( "tr" ).eq( 0 ),
								$( "<tr>", that.document[ 0 ] ).appendTo( element )
							);
						} else if ( nodeName === "tr" ) {
							that._createTrPlaceholder( that.currentItem, element );
						} else if ( nodeName === "img" ) {
							element.attr( "src", that.currentItem.attr( "src" ) );
						}
	
						if ( !className ) {
							element.css( "visibility", "hidden" );
						}
	
						return element;
					},
					update: function( container, p ) {
	
						// 1. If a className is set as 'placeholder option, we don't force sizes -
						// the class is responsible for that
						// 2. The option 'forcePlaceholderSize can be enabled to force it even if a
						// class name is specified
						if ( className && !o.forcePlaceholderSize ) {
							return;
						}
	
						//If the element doesn't have a actual height by itself (without styles coming
						// from a stylesheet), it receives the inline height from the dragged item
						if ( !p.height() ) {
							p.height(
								that.currentItem.innerHeight() -
								parseInt( that.currentItem.css( "paddingTop" ) || 0, 10 ) -
								parseInt( that.currentItem.css( "paddingBottom" ) || 0, 10 ) );
						}
						if ( !p.width() ) {
							p.width(
								that.currentItem.innerWidth() -
								parseInt( that.currentItem.css( "paddingLeft" ) || 0, 10 ) -
								parseInt( that.currentItem.css( "paddingRight" ) || 0, 10 ) );
						}
					}
				};
			}
	
			//Create the placeholder
			that.placeholder = $( o.placeholder.element.call( that.element, that.currentItem ) );
	
			//Append it after the actual current item
			that.currentItem.after( that.placeholder );
	
			//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
			o.placeholder.update( that, that.placeholder );
	
		},
	
		_createTrPlaceholder: function( sourceTr, targetTr ) {
			var that = this;
	
			sourceTr.children().each( function() {
				$( "<td>&#160;</td>", that.document[ 0 ] )
					.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
					.appendTo( targetTr );
			} );
		},
	
		_contactContainers: function( event ) {
			var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom,
				floating, axis,
				innermostContainer = null,
				innermostIndex = null;
	
			// Get innermost container that intersects with item
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
	
				// Never consider a container that's located within the item itself
				if ( $.contains( this.currentItem[ 0 ], this.containers[ i ].element[ 0 ] ) ) {
					continue;
				}
	
				if ( this._intersectsWith( this.containers[ i ].containerCache ) ) {
	
					// If we've already found a container and it's more "inner" than this, then continue
					if ( innermostContainer &&
							$.contains(
								this.containers[ i ].element[ 0 ],
								innermostContainer.element[ 0 ] ) ) {
						continue;
					}
	
					innermostContainer = this.containers[ i ];
					innermostIndex = i;
	
				} else {
	
					// container doesn't intersect. trigger "out" event if necessary
					if ( this.containers[ i ].containerCache.over ) {
						this.containers[ i ]._trigger( "out", event, this._uiHash( this ) );
						this.containers[ i ].containerCache.over = 0;
					}
				}
	
			}
	
			// If no intersecting containers found, return
			if ( !innermostContainer ) {
				return;
			}
	
			// Move the item into the container if it's not there already
			if ( this.containers.length === 1 ) {
				if ( !this.containers[ innermostIndex ].containerCache.over ) {
					this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
					this.containers[ innermostIndex ].containerCache.over = 1;
				}
			} else {
	
				// When entering a new container, we will find the item with the least distance and
				// append our item near it
				dist = 10000;
				itemWithLeastDistance = null;
				floating = innermostContainer.floating || this._isFloating( this.currentItem );
				posProperty = floating ? "left" : "top";
				sizeProperty = floating ? "width" : "height";
				axis = floating ? "pageX" : "pageY";
	
				for ( j = this.items.length - 1; j >= 0; j-- ) {
					if ( !$.contains(
							this.containers[ innermostIndex ].element[ 0 ], this.items[ j ].item[ 0 ] )
					) {
						continue;
					}
					if ( this.items[ j ].item[ 0 ] === this.currentItem[ 0 ] ) {
						continue;
					}
	
					cur = this.items[ j ].item.offset()[ posProperty ];
					nearBottom = false;
					if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
						nearBottom = true;
					}
	
					if ( Math.abs( event[ axis ] - cur ) < dist ) {
						dist = Math.abs( event[ axis ] - cur );
						itemWithLeastDistance = this.items[ j ];
						this.direction = nearBottom ? "up" : "down";
					}
				}
	
				//Check if dropOnEmpty is enabled
				if ( !itemWithLeastDistance && !this.options.dropOnEmpty ) {
					return;
				}
	
				if ( this.currentContainer === this.containers[ innermostIndex ] ) {
					if ( !this.currentContainer.containerCache.over ) {
						this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
						this.currentContainer.containerCache.over = 1;
					}
					return;
				}
	
				itemWithLeastDistance ?
					this._rearrange( event, itemWithLeastDistance, null, true ) :
					this._rearrange( event, null, this.containers[ innermostIndex ].element, true );
				this._trigger( "change", event, this._uiHash() );
				this.containers[ innermostIndex ]._trigger( "change", event, this._uiHash( this ) );
				this.currentContainer = this.containers[ innermostIndex ];
	
				//Update the placeholder
				this.options.placeholder.update( this.currentContainer, this.placeholder );
	
				this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
				this.containers[ innermostIndex ].containerCache.over = 1;
			}
	
		},
	
		_createHelper: function( event ) {
	
			var o = this.options,
				helper = $.isFunction( o.helper ) ?
					$( o.helper.apply( this.element[ 0 ], [ event, this.currentItem ] ) ) :
					( o.helper === "clone" ? this.currentItem.clone() : this.currentItem );
	
			//Add the helper to the DOM if that didn't happen already
			if ( !helper.parents( "body" ).length ) {
				$( o.appendTo !== "parent" ?
					o.appendTo :
					this.currentItem[ 0 ].parentNode )[ 0 ].appendChild( helper[ 0 ] );
			}
	
			if ( helper[ 0 ] === this.currentItem[ 0 ] ) {
				this._storedCSS = {
					width: this.currentItem[ 0 ].style.width,
					height: this.currentItem[ 0 ].style.height,
					position: this.currentItem.css( "position" ),
					top: this.currentItem.css( "top" ),
					left: this.currentItem.css( "left" )
				};
			}
	
			if ( !helper[ 0 ].style.width || o.forceHelperSize ) {
				helper.width( this.currentItem.width() );
			}
			if ( !helper[ 0 ].style.height || o.forceHelperSize ) {
				helper.height( this.currentItem.height() );
			}
	
			return helper;
	
		},
	
		_adjustOffsetFromHelper: function( obj ) {
			if ( typeof obj === "string" ) {
				obj = obj.split( " " );
			}
			if ( $.isArray( obj ) ) {
				obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
			}
			if ( "left" in obj ) {
				this.offset.click.left = obj.left + this.margins.left;
			}
			if ( "right" in obj ) {
				this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
			}
			if ( "top" in obj ) {
				this.offset.click.top = obj.top + this.margins.top;
			}
			if ( "bottom" in obj ) {
				this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
			}
		},
	
		_getParentOffset: function() {
	
			//Get the offsetParent and cache its position
			this.offsetParent = this.helper.offsetParent();
			var po = this.offsetParent.offset();
	
			// This is a special case where we need to modify a offset calculated on start, since the
			// following happened:
			// 1. The position of the helper is absolute, so it's position is calculated based on the
			// next positioned parent
			// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
			// the document, which means that the scroll is included in the initial calculation of the
			// offset of the parent, and never recalculated upon drag
			if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
				po.left += this.scrollParent.scrollLeft();
				po.top += this.scrollParent.scrollTop();
			}
	
			// This needs to be actually done for all browsers, since pageX/pageY includes this
			// information with an ugly IE fix
			if ( this.offsetParent[ 0 ] === this.document[ 0 ].body ||
					( this.offsetParent[ 0 ].tagName &&
					this.offsetParent[ 0 ].tagName.toLowerCase() === "html" && $.ui.ie ) ) {
				po = { top: 0, left: 0 };
			}
	
			return {
				top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
				left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
			};
	
		},
	
		_getRelativeOffset: function() {
	
			if ( this.cssPosition === "relative" ) {
				var p = this.currentItem.position();
				return {
					top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
						this.scrollParent.scrollTop(),
					left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
						this.scrollParent.scrollLeft()
				};
			} else {
				return { top: 0, left: 0 };
			}
	
		},
	
		_cacheMargins: function() {
			this.margins = {
				left: ( parseInt( this.currentItem.css( "marginLeft" ), 10 ) || 0 ),
				top: ( parseInt( this.currentItem.css( "marginTop" ), 10 ) || 0 )
			};
		},
	
		_cacheHelperProportions: function() {
			this.helperProportions = {
				width: this.helper.outerWidth(),
				height: this.helper.outerHeight()
			};
		},
	
		_setContainment: function() {
	
			var ce, co, over,
				o = this.options;
			if ( o.containment === "parent" ) {
				o.containment = this.helper[ 0 ].parentNode;
			}
			if ( o.containment === "document" || o.containment === "window" ) {
				this.containment = [
					0 - this.offset.relative.left - this.offset.parent.left,
					0 - this.offset.relative.top - this.offset.parent.top,
					o.containment === "document" ?
						this.document.width() :
						this.window.width() - this.helperProportions.width - this.margins.left,
					( o.containment === "document" ?
						( this.document.height() || document.body.parentNode.scrollHeight ) :
						this.window.height() || this.document[ 0 ].body.parentNode.scrollHeight
					) - this.helperProportions.height - this.margins.top
				];
			}
	
			if ( !( /^(document|window|parent)$/ ).test( o.containment ) ) {
				ce = $( o.containment )[ 0 ];
				co = $( o.containment ).offset();
				over = ( $( ce ).css( "overflow" ) !== "hidden" );
	
				this.containment = [
					co.left + ( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) +
						( parseInt( $( ce ).css( "paddingLeft" ), 10 ) || 0 ) - this.margins.left,
					co.top + ( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) +
						( parseInt( $( ce ).css( "paddingTop" ), 10 ) || 0 ) - this.margins.top,
					co.left + ( over ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
						( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) -
						( parseInt( $( ce ).css( "paddingRight" ), 10 ) || 0 ) -
						this.helperProportions.width - this.margins.left,
					co.top + ( over ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
						( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) -
						( parseInt( $( ce ).css( "paddingBottom" ), 10 ) || 0 ) -
						this.helperProportions.height - this.margins.top
				];
			}
	
		},
	
		_convertPositionTo: function( d, pos ) {
	
			if ( !pos ) {
				pos = this.position;
			}
			var mod = d === "absolute" ? 1 : -1,
				scroll = this.cssPosition === "absolute" &&
					!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
						this.offsetParent :
						this.scrollParent,
				scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );
	
			return {
				top: (
	
					// The absolute mouse position
					pos.top	+
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top * mod -
					( ( this.cssPosition === "fixed" ?
						-this.scrollParent.scrollTop() :
						( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod )
				),
				left: (
	
					// The absolute mouse position
					pos.left +
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left * mod	-
					( ( this.cssPosition === "fixed" ?
						-this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 :
						scroll.scrollLeft() ) * mod )
				)
			};
	
		},
	
		_generatePosition: function( event ) {
	
			var top, left,
				o = this.options,
				pageX = event.pageX,
				pageY = event.pageY,
				scroll = this.cssPosition === "absolute" &&
					!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
						this.offsetParent :
						this.scrollParent,
					scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );
	
			// This is another very weird special case that only happens for relative elements:
			// 1. If the css position is relative
			// 2. and the scroll parent is the document or similar to the offset parent
			// we have to refresh the relative offset during the scroll so there are no jumps
			if ( this.cssPosition === "relative" && !( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ] !== this.offsetParent[ 0 ] ) ) {
				this.offset.relative = this._getRelativeOffset();
			}
	
			/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */
	
			if ( this.originalPosition ) { //If we are not dragging yet, we won't check for options
	
				if ( this.containment ) {
					if ( event.pageX - this.offset.click.left < this.containment[ 0 ] ) {
						pageX = this.containment[ 0 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top < this.containment[ 1 ] ) {
						pageY = this.containment[ 1 ] + this.offset.click.top;
					}
					if ( event.pageX - this.offset.click.left > this.containment[ 2 ] ) {
						pageX = this.containment[ 2 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top > this.containment[ 3 ] ) {
						pageY = this.containment[ 3 ] + this.offset.click.top;
					}
				}
	
				if ( o.grid ) {
					top = this.originalPageY + Math.round( ( pageY - this.originalPageY ) /
						o.grid[ 1 ] ) * o.grid[ 1 ];
					pageY = this.containment ?
						( ( top - this.offset.click.top >= this.containment[ 1 ] &&
							top - this.offset.click.top <= this.containment[ 3 ] ) ?
								top :
								( ( top - this.offset.click.top >= this.containment[ 1 ] ) ?
									top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) :
									top;
	
					left = this.originalPageX + Math.round( ( pageX - this.originalPageX ) /
						o.grid[ 0 ] ) * o.grid[ 0 ];
					pageX = this.containment ?
						( ( left - this.offset.click.left >= this.containment[ 0 ] &&
							left - this.offset.click.left <= this.containment[ 2 ] ) ?
								left :
								( ( left - this.offset.click.left >= this.containment[ 0 ] ) ?
									left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) :
									left;
				}
	
			}
	
			return {
				top: (
	
					// The absolute mouse position
					pageY -
	
					// Click offset (relative to the element)
					this.offset.click.top -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top +
					( ( this.cssPosition === "fixed" ?
						-this.scrollParent.scrollTop() :
						( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) )
				),
				left: (
	
					// The absolute mouse position
					pageX -
	
					// Click offset (relative to the element)
					this.offset.click.left -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left +
					( ( this.cssPosition === "fixed" ?
						-this.scrollParent.scrollLeft() :
						scrollIsRootNode ? 0 : scroll.scrollLeft() ) )
				)
			};
	
		},
	
		_rearrange: function( event, i, a, hardRefresh ) {
	
			a ? a[ 0 ].appendChild( this.placeholder[ 0 ] ) :
				i.item[ 0 ].parentNode.insertBefore( this.placeholder[ 0 ],
					( this.direction === "down" ? i.item[ 0 ] : i.item[ 0 ].nextSibling ) );
	
			//Various things done here to improve the performance:
			// 1. we create a setTimeout, that calls refreshPositions
			// 2. on the instance, we have a counter variable, that get's higher after every append
			// 3. on the local scope, we copy the counter variable, and check in the timeout,
			// if it's still the same
			// 4. this lets only the last addition to the timeout stack through
			this.counter = this.counter ? ++this.counter : 1;
			var counter = this.counter;
	
			this._delay( function() {
				if ( counter === this.counter ) {
	
					//Precompute after each DOM insertion, NOT on mousemove
					this.refreshPositions( !hardRefresh );
				}
			} );
	
		},
	
		_clear: function( event, noPropagation ) {
	
			this.reverting = false;
	
			// We delay all events that have to be triggered to after the point where the placeholder
			// has been removed and everything else normalized again
			var i,
				delayedTriggers = [];
	
			// We first have to update the dom position of the actual currentItem
			// Note: don't do it if the current item is already removed (by a user), or it gets
			// reappended (see #4088)
			if ( !this._noFinalSort && this.currentItem.parent().length ) {
				this.placeholder.before( this.currentItem );
			}
			this._noFinalSort = null;
	
			if ( this.helper[ 0 ] === this.currentItem[ 0 ] ) {
				for ( i in this._storedCSS ) {
					if ( this._storedCSS[ i ] === "auto" || this._storedCSS[ i ] === "static" ) {
						this._storedCSS[ i ] = "";
					}
				}
				this.currentItem.css( this._storedCSS );
				this._removeClass( this.currentItem, "ui-sortable-helper" );
			} else {
				this.currentItem.show();
			}
	
			if ( this.fromOutside && !noPropagation ) {
				delayedTriggers.push( function( event ) {
					this._trigger( "receive", event, this._uiHash( this.fromOutside ) );
				} );
			}
			if ( ( this.fromOutside ||
					this.domPosition.prev !==
					this.currentItem.prev().not( ".ui-sortable-helper" )[ 0 ] ||
					this.domPosition.parent !== this.currentItem.parent()[ 0 ] ) && !noPropagation ) {
	
				// Trigger update callback if the DOM position has changed
				delayedTriggers.push( function( event ) {
					this._trigger( "update", event, this._uiHash() );
				} );
			}
	
			// Check if the items Container has Changed and trigger appropriate
			// events.
			if ( this !== this.currentContainer ) {
				if ( !noPropagation ) {
					delayedTriggers.push( function( event ) {
						this._trigger( "remove", event, this._uiHash() );
					} );
					delayedTriggers.push( ( function( c ) {
						return function( event ) {
							c._trigger( "receive", event, this._uiHash( this ) );
						};
					} ).call( this, this.currentContainer ) );
					delayedTriggers.push( ( function( c ) {
						return function( event ) {
							c._trigger( "update", event, this._uiHash( this ) );
						};
					} ).call( this, this.currentContainer ) );
				}
			}
	
			//Post events to containers
			function delayEvent( type, instance, container ) {
				return function( event ) {
					container._trigger( type, event, instance._uiHash( instance ) );
				};
			}
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				if ( !noPropagation ) {
					delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
				}
				if ( this.containers[ i ].containerCache.over ) {
					delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}
	
			//Do what was originally in plugins
			if ( this.storedCursor ) {
				this.document.find( "body" ).css( "cursor", this.storedCursor );
				this.storedStylesheet.remove();
			}
			if ( this._storedOpacity ) {
				this.helper.css( "opacity", this._storedOpacity );
			}
			if ( this._storedZIndex ) {
				this.helper.css( "zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex );
			}
	
			this.dragging = false;
	
			if ( !noPropagation ) {
				this._trigger( "beforeStop", event, this._uiHash() );
			}
	
			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
			// it unbinds ALL events from the original node!
			this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
	
			if ( !this.cancelHelperRemoval ) {
				if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
					this.helper.remove();
				}
				this.helper = null;
			}
	
			if ( !noPropagation ) {
				for ( i = 0; i < delayedTriggers.length; i++ ) {
	
					// Trigger all delayed events
					delayedTriggers[ i ].call( this, event );
				}
				this._trigger( "stop", event, this._uiHash() );
			}
	
			this.fromOutside = false;
			return !this.cancelHelperRemoval;
	
		},
	
		_trigger: function() {
			if ( $.Widget.prototype._trigger.apply( this, arguments ) === false ) {
				this.cancel();
			}
		},
	
		_uiHash: function( _inst ) {
			var inst = _inst || this;
			return {
				helper: inst.helper,
				placeholder: inst.placeholder || $( [] ),
				position: inst.position,
				originalPosition: inst.originalPosition,
				offset: inst.positionAbs,
				item: inst.currentItem,
				sender: _inst ? _inst.element : null
			};
		}
	
	} );
	
	} ) );


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Mouse 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Mouse
	//>>group: Widgets
	//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
	//>>docs: http://api.jqueryui.com/mouse/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(2),
				__webpack_require__(284),
				__webpack_require__(285),
				__webpack_require__(286)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var mouseHandled = false;
	$( document ).on( "mouseup", function() {
		mouseHandled = false;
	} );
	
	return $.widget( "ui.mouse", {
		version: "1.12.1",
		options: {
			cancel: "input, textarea, button, select, option",
			distance: 1,
			delay: 0
		},
		_mouseInit: function() {
			var that = this;
	
			this.element
				.on( "mousedown." + this.widgetName, function( event ) {
					return that._mouseDown( event );
				} )
				.on( "click." + this.widgetName, function( event ) {
					if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
						$.removeData( event.target, that.widgetName + ".preventClickEvent" );
						event.stopImmediatePropagation();
						return false;
					}
				} );
	
			this.started = false;
		},
	
		// TODO: make sure destroying one instance of mouse doesn't mess with
		// other instances of mouse
		_mouseDestroy: function() {
			this.element.off( "." + this.widgetName );
			if ( this._mouseMoveDelegate ) {
				this.document
					.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
					.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
			}
		},
	
		_mouseDown: function( event ) {
	
			// don't let more than one widget handle mouseStart
			if ( mouseHandled ) {
				return;
			}
	
			this._mouseMoved = false;
	
			// We may have missed mouseup (out of window)
			( this._mouseStarted && this._mouseUp( event ) );
	
			this._mouseDownEvent = event;
	
			var that = this,
				btnIsLeft = ( event.which === 1 ),
	
				// event.target.nodeName works around a bug in IE 8 with
				// disabled inputs (#7620)
				elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
					$( event.target ).closest( this.options.cancel ).length : false );
			if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
				return true;
			}
	
			this.mouseDelayMet = !this.options.delay;
			if ( !this.mouseDelayMet ) {
				this._mouseDelayTimer = setTimeout( function() {
					that.mouseDelayMet = true;
				}, this.options.delay );
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted = ( this._mouseStart( event ) !== false );
				if ( !this._mouseStarted ) {
					event.preventDefault();
					return true;
				}
			}
	
			// Click event may never have fired (Gecko & Opera)
			if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
				$.removeData( event.target, this.widgetName + ".preventClickEvent" );
			}
	
			// These delegates are required to keep context
			this._mouseMoveDelegate = function( event ) {
				return that._mouseMove( event );
			};
			this._mouseUpDelegate = function( event ) {
				return that._mouseUp( event );
			};
	
			this.document
				.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.on( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			event.preventDefault();
	
			mouseHandled = true;
			return true;
		},
	
		_mouseMove: function( event ) {
	
			// Only check for mouseups outside the document if you've moved inside the document
			// at least once. This prevents the firing of mouseup in the case of IE<9, which will
			// fire a mousemove event if content is placed under the cursor. See #7778
			// Support: IE <9
			if ( this._mouseMoved ) {
	
				// IE mouseup check - mouseup happened when mouse was out of window
				if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
						!event.button ) {
					return this._mouseUp( event );
	
				// Iframe mouseup check - mouseup occurred in another document
				} else if ( !event.which ) {
	
					// Support: Safari <=8 - 9
					// Safari sets which to 0 if you press any of the following keys
					// during a drag (#14461)
					if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
							event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
						this.ignoreMissingWhich = true;
					} else if ( !this.ignoreMissingWhich ) {
						return this._mouseUp( event );
					}
				}
			}
	
			if ( event.which || event.button ) {
				this._mouseMoved = true;
			}
	
			if ( this._mouseStarted ) {
				this._mouseDrag( event );
				return event.preventDefault();
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted =
					( this._mouseStart( this._mouseDownEvent, event ) !== false );
				( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
			}
	
			return !this._mouseStarted;
		},
	
		_mouseUp: function( event ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			if ( this._mouseStarted ) {
				this._mouseStarted = false;
	
				if ( event.target === this._mouseDownEvent.target ) {
					$.data( event.target, this.widgetName + ".preventClickEvent", true );
				}
	
				this._mouseStop( event );
			}
	
			if ( this._mouseDelayTimer ) {
				clearTimeout( this._mouseDelayTimer );
				delete this._mouseDelayTimer;
			}
	
			this.ignoreMissingWhich = false;
			mouseHandled = false;
			event.preventDefault();
		},
	
		_mouseDistanceMet: function( event ) {
			return ( Math.max(
					Math.abs( this._mouseDownEvent.pageX - event.pageX ),
					Math.abs( this._mouseDownEvent.pageY - event.pageY )
				) >= this.options.distance
			);
		},
	
		_mouseDelayMet: function( /* event */ ) {
			return this.mouseDelayMet;
		},
	
		// These are placeholder methods, to be overriden by extending plugin
		_mouseStart: function( /* event */ ) {},
		_mouseDrag: function( /* event */ ) {},
		_mouseStop: function( /* event */ ) {},
		_mouseCapture: function( /* event */ ) { return true; }
	} );
	
	} ) );


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(285) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	// This file is deprecated
	return $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
	} ) );


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	$.ui = $.ui || {};
	
	return $.ui.version = "1.12.1";
	
	} ) );


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Widget 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Widget
	//>>group: Core
	//>>description: Provides a factory for creating stateful widgets with a common API.
	//>>docs: http://api.jqueryui.com/jQuery.widget/
	//>>demos: http://jqueryui.com/widget/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(285) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var widgetUuid = 0;
	var widgetSlice = Array.prototype.slice;
	
	$.cleanData = ( function( orig ) {
		return function( elems ) {
			var events, elem, i;
			for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
				try {
	
					// Only trigger remove when necessary to save time
					events = $._data( elem, "events" );
					if ( events && events.remove ) {
						$( elem ).triggerHandler( "remove" );
					}
	
				// Http://bugs.jquery.com/ticket/8235
				} catch ( e ) {}
			}
			orig( elems );
		};
	} )( $.cleanData );
	
	$.widget = function( name, base, prototype ) {
		var existingConstructor, constructor, basePrototype;
	
		// ProxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		var proxiedPrototype = {};
	
		var namespace = name.split( "." )[ 0 ];
		name = name.split( "." )[ 1 ];
		var fullName = namespace + "-" + name;
	
		if ( !prototype ) {
			prototype = base;
			base = $.Widget;
		}
	
		if ( $.isArray( prototype ) ) {
			prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
		}
	
		// Create selector for plugin
		$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
			return !!$.data( elem, fullName );
		};
	
		$[ namespace ] = $[ namespace ] || {};
		existingConstructor = $[ namespace ][ name ];
		constructor = $[ namespace ][ name ] = function( options, element ) {
	
			// Allow instantiation without "new" keyword
			if ( !this._createWidget ) {
				return new constructor( options, element );
			}
	
			// Allow instantiation without initializing for simple inheritance
			// must use "new" keyword (the code above always passes args)
			if ( arguments.length ) {
				this._createWidget( options, element );
			}
		};
	
		// Extend with the existing constructor to carry over any static properties
		$.extend( constructor, existingConstructor, {
			version: prototype.version,
	
			// Copy the object used to create the prototype in case we need to
			// redefine the widget later
			_proto: $.extend( {}, prototype ),
	
			// Track widgets that inherit from this widget in case this widget is
			// redefined after a widget inherits from it
			_childConstructors: []
		} );
	
		basePrototype = new base();
	
		// We need to make the options hash a property directly on the new instance
		// otherwise we'll modify the options hash on the prototype that we're
		// inheriting from
		basePrototype.options = $.widget.extend( {}, basePrototype.options );
		$.each( prototype, function( prop, value ) {
			if ( !$.isFunction( value ) ) {
				proxiedPrototype[ prop ] = value;
				return;
			}
			proxiedPrototype[ prop ] = ( function() {
				function _super() {
					return base.prototype[ prop ].apply( this, arguments );
				}
	
				function _superApply( args ) {
					return base.prototype[ prop ].apply( this, args );
				}
	
				return function() {
					var __super = this._super;
					var __superApply = this._superApply;
					var returnValue;
	
					this._super = _super;
					this._superApply = _superApply;
	
					returnValue = value.apply( this, arguments );
	
					this._super = __super;
					this._superApply = __superApply;
	
					return returnValue;
				};
			} )();
		} );
		constructor.prototype = $.widget.extend( basePrototype, {
	
			// TODO: remove support for widgetEventPrefix
			// always use the name + a colon as the prefix, e.g., draggable:start
			// don't prefix for widgets that aren't DOM-based
			widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
		}, proxiedPrototype, {
			constructor: constructor,
			namespace: namespace,
			widgetName: name,
			widgetFullName: fullName
		} );
	
		// If this widget is being redefined then we need to find all widgets that
		// are inheriting from it and redefine all of them so that they inherit from
		// the new version of this widget. We're essentially trying to replace one
		// level in the prototype chain.
		if ( existingConstructor ) {
			$.each( existingConstructor._childConstructors, function( i, child ) {
				var childPrototype = child.prototype;
	
				// Redefine the child widget using the same prototype that was
				// originally used, but inherit from the new version of the base
				$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
					child._proto );
			} );
	
			// Remove the list of existing child constructors from the old constructor
			// so the old child constructors can be garbage collected
			delete existingConstructor._childConstructors;
		} else {
			base._childConstructors.push( constructor );
		}
	
		$.widget.bridge( name, constructor );
	
		return constructor;
	};
	
	$.widget.extend = function( target ) {
		var input = widgetSlice.call( arguments, 1 );
		var inputIndex = 0;
		var inputLength = input.length;
		var key;
		var value;
	
		for ( ; inputIndex < inputLength; inputIndex++ ) {
			for ( key in input[ inputIndex ] ) {
				value = input[ inputIndex ][ key ];
				if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
	
					// Clone objects
					if ( $.isPlainObject( value ) ) {
						target[ key ] = $.isPlainObject( target[ key ] ) ?
							$.widget.extend( {}, target[ key ], value ) :
	
							// Don't extend strings, arrays, etc. with objects
							$.widget.extend( {}, value );
	
					// Copy everything else by reference
					} else {
						target[ key ] = value;
					}
				}
			}
		}
		return target;
	};
	
	$.widget.bridge = function( name, object ) {
		var fullName = object.prototype.widgetFullName || name;
		$.fn[ name ] = function( options ) {
			var isMethodCall = typeof options === "string";
			var args = widgetSlice.call( arguments, 1 );
			var returnValue = this;
	
			if ( isMethodCall ) {
	
				// If this is an empty collection, we need to have the instance method
				// return undefined instead of the jQuery instance
				if ( !this.length && options === "instance" ) {
					returnValue = undefined;
				} else {
					this.each( function() {
						var methodValue;
						var instance = $.data( this, fullName );
	
						if ( options === "instance" ) {
							returnValue = instance;
							return false;
						}
	
						if ( !instance ) {
							return $.error( "cannot call methods on " + name +
								" prior to initialization; " +
								"attempted to call method '" + options + "'" );
						}
	
						if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
							return $.error( "no such method '" + options + "' for " + name +
								" widget instance" );
						}
	
						methodValue = instance[ options ].apply( instance, args );
	
						if ( methodValue !== instance && methodValue !== undefined ) {
							returnValue = methodValue && methodValue.jquery ?
								returnValue.pushStack( methodValue.get() ) :
								methodValue;
							return false;
						}
					} );
				}
			} else {
	
				// Allow multiple hashes to be passed on init
				if ( args.length ) {
					options = $.widget.extend.apply( null, [ options ].concat( args ) );
				}
	
				this.each( function() {
					var instance = $.data( this, fullName );
					if ( instance ) {
						instance.option( options || {} );
						if ( instance._init ) {
							instance._init();
						}
					} else {
						$.data( this, fullName, new object( options, this ) );
					}
				} );
			}
	
			return returnValue;
		};
	};
	
	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];
	
	$.Widget.prototype = {
		widgetName: "widget",
		widgetEventPrefix: "",
		defaultElement: "<div>",
	
		options: {
			classes: {},
			disabled: false,
	
			// Callbacks
			create: null
		},
	
		_createWidget: function( options, element ) {
			element = $( element || this.defaultElement || this )[ 0 ];
			this.element = $( element );
			this.uuid = widgetUuid++;
			this.eventNamespace = "." + this.widgetName + this.uuid;
	
			this.bindings = $();
			this.hoverable = $();
			this.focusable = $();
			this.classesElementLookup = {};
	
			if ( element !== this ) {
				$.data( element, this.widgetFullName, this );
				this._on( true, this.element, {
					remove: function( event ) {
						if ( event.target === element ) {
							this.destroy();
						}
					}
				} );
				this.document = $( element.style ?
	
					// Element within the document
					element.ownerDocument :
	
					// Element is window or document
					element.document || element );
				this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
			}
	
			this.options = $.widget.extend( {},
				this.options,
				this._getCreateOptions(),
				options );
	
			this._create();
	
			if ( this.options.disabled ) {
				this._setOptionDisabled( this.options.disabled );
			}
	
			this._trigger( "create", null, this._getCreateEventData() );
			this._init();
		},
	
		_getCreateOptions: function() {
			return {};
		},
	
		_getCreateEventData: $.noop,
	
		_create: $.noop,
	
		_init: $.noop,
	
		destroy: function() {
			var that = this;
	
			this._destroy();
			$.each( this.classesElementLookup, function( key, value ) {
				that._removeClass( value, key );
			} );
	
			// We can probably remove the unbind calls in 2.0
			// all event bindings should go through this._on()
			this.element
				.off( this.eventNamespace )
				.removeData( this.widgetFullName );
			this.widget()
				.off( this.eventNamespace )
				.removeAttr( "aria-disabled" );
	
			// Clean up events and states
			this.bindings.off( this.eventNamespace );
		},
	
		_destroy: $.noop,
	
		widget: function() {
			return this.element;
		},
	
		option: function( key, value ) {
			var options = key;
			var parts;
			var curOption;
			var i;
	
			if ( arguments.length === 0 ) {
	
				// Don't return a reference to the internal hash
				return $.widget.extend( {}, this.options );
			}
	
			if ( typeof key === "string" ) {
	
				// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
				options = {};
				parts = key.split( "." );
				key = parts.shift();
				if ( parts.length ) {
					curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
					for ( i = 0; i < parts.length - 1; i++ ) {
						curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
						curOption = curOption[ parts[ i ] ];
					}
					key = parts.pop();
					if ( arguments.length === 1 ) {
						return curOption[ key ] === undefined ? null : curOption[ key ];
					}
					curOption[ key ] = value;
				} else {
					if ( arguments.length === 1 ) {
						return this.options[ key ] === undefined ? null : this.options[ key ];
					}
					options[ key ] = value;
				}
			}
	
			this._setOptions( options );
	
			return this;
		},
	
		_setOptions: function( options ) {
			var key;
	
			for ( key in options ) {
				this._setOption( key, options[ key ] );
			}
	
			return this;
		},
	
		_setOption: function( key, value ) {
			if ( key === "classes" ) {
				this._setOptionClasses( value );
			}
	
			this.options[ key ] = value;
	
			if ( key === "disabled" ) {
				this._setOptionDisabled( value );
			}
	
			return this;
		},
	
		_setOptionClasses: function( value ) {
			var classKey, elements, currentElements;
	
			for ( classKey in value ) {
				currentElements = this.classesElementLookup[ classKey ];
				if ( value[ classKey ] === this.options.classes[ classKey ] ||
						!currentElements ||
						!currentElements.length ) {
					continue;
				}
	
				// We are doing this to create a new jQuery object because the _removeClass() call
				// on the next line is going to destroy the reference to the current elements being
				// tracked. We need to save a copy of this collection so that we can add the new classes
				// below.
				elements = $( currentElements.get() );
				this._removeClass( currentElements, classKey );
	
				// We don't use _addClass() here, because that uses this.options.classes
				// for generating the string of classes. We want to use the value passed in from
				// _setOption(), this is the new value of the classes option which was passed to
				// _setOption(). We pass this value directly to _classes().
				elements.addClass( this._classes( {
					element: elements,
					keys: classKey,
					classes: value,
					add: true
				} ) );
			}
		},
	
		_setOptionDisabled: function( value ) {
			this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );
	
			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this._removeClass( this.hoverable, null, "ui-state-hover" );
				this._removeClass( this.focusable, null, "ui-state-focus" );
			}
		},
	
		enable: function() {
			return this._setOptions( { disabled: false } );
		},
	
		disable: function() {
			return this._setOptions( { disabled: true } );
		},
	
		_classes: function( options ) {
			var full = [];
			var that = this;
	
			options = $.extend( {
				element: this.element,
				classes: this.options.classes || {}
			}, options );
	
			function processClassString( classes, checkOption ) {
				var current, i;
				for ( i = 0; i < classes.length; i++ ) {
					current = that.classesElementLookup[ classes[ i ] ] || $();
					if ( options.add ) {
						current = $( $.unique( current.get().concat( options.element.get() ) ) );
					} else {
						current = $( current.not( options.element ).get() );
					}
					that.classesElementLookup[ classes[ i ] ] = current;
					full.push( classes[ i ] );
					if ( checkOption && options.classes[ classes[ i ] ] ) {
						full.push( options.classes[ classes[ i ] ] );
					}
				}
			}
	
			this._on( options.element, {
				"remove": "_untrackClassesElement"
			} );
	
			if ( options.keys ) {
				processClassString( options.keys.match( /\S+/g ) || [], true );
			}
			if ( options.extra ) {
				processClassString( options.extra.match( /\S+/g ) || [] );
			}
	
			return full.join( " " );
		},
	
		_untrackClassesElement: function( event ) {
			var that = this;
			$.each( that.classesElementLookup, function( key, value ) {
				if ( $.inArray( event.target, value ) !== -1 ) {
					that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
				}
			} );
		},
	
		_removeClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, false );
		},
	
		_addClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, true );
		},
	
		_toggleClass: function( element, keys, extra, add ) {
			add = ( typeof add === "boolean" ) ? add : extra;
			var shift = ( typeof element === "string" || element === null ),
				options = {
					extra: shift ? keys : extra,
					keys: shift ? element : keys,
					element: shift ? this.element : element,
					add: add
				};
			options.element.toggleClass( this._classes( options ), add );
			return this;
		},
	
		_on: function( suppressDisabledCheck, element, handlers ) {
			var delegateElement;
			var instance = this;
	
			// No suppressDisabledCheck flag, shuffle arguments
			if ( typeof suppressDisabledCheck !== "boolean" ) {
				handlers = element;
				element = suppressDisabledCheck;
				suppressDisabledCheck = false;
			}
	
			// No element argument, shuffle and use this.element
			if ( !handlers ) {
				handlers = element;
				element = this.element;
				delegateElement = this.widget();
			} else {
				element = delegateElement = $( element );
				this.bindings = this.bindings.add( element );
			}
	
			$.each( handlers, function( event, handler ) {
				function handlerProxy() {
	
					// Allow widgets to customize the disabled handling
					// - disabled as an array instead of boolean
					// - disabled class as method for disabling individual parts
					if ( !suppressDisabledCheck &&
							( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
						return;
					}
					return ( typeof handler === "string" ? instance[ handler ] : handler )
						.apply( instance, arguments );
				}
	
				// Copy the guid so direct unbinding works
				if ( typeof handler !== "string" ) {
					handlerProxy.guid = handler.guid =
						handler.guid || handlerProxy.guid || $.guid++;
				}
	
				var match = event.match( /^([\w:-]*)\s*(.*)$/ );
				var eventName = match[ 1 ] + instance.eventNamespace;
				var selector = match[ 2 ];
	
				if ( selector ) {
					delegateElement.on( eventName, selector, handlerProxy );
				} else {
					element.on( eventName, handlerProxy );
				}
			} );
		},
	
		_off: function( element, eventName ) {
			eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
				this.eventNamespace;
			element.off( eventName ).off( eventName );
	
			// Clear the stack to avoid memory leaks (#10056)
			this.bindings = $( this.bindings.not( element ).get() );
			this.focusable = $( this.focusable.not( element ).get() );
			this.hoverable = $( this.hoverable.not( element ).get() );
		},
	
		_delay: function( handler, delay ) {
			function handlerProxy() {
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}
			var instance = this;
			return setTimeout( handlerProxy, delay || 0 );
		},
	
		_hoverable: function( element ) {
			this.hoverable = this.hoverable.add( element );
			this._on( element, {
				mouseenter: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
				},
				mouseleave: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
				}
			} );
		},
	
		_focusable: function( element ) {
			this.focusable = this.focusable.add( element );
			this._on( element, {
				focusin: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
				},
				focusout: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
				}
			} );
		},
	
		_trigger: function( type, event, data ) {
			var prop, orig;
			var callback = this.options[ type ];
	
			data = data || {};
			event = $.Event( event );
			event.type = ( type === this.widgetEventPrefix ?
				type :
				this.widgetEventPrefix + type ).toLowerCase();
	
			// The original event may come from any element
			// so we need to reset the target on the new event
			event.target = this.element[ 0 ];
	
			// Copy original event properties over to the new event
			orig = event.originalEvent;
			if ( orig ) {
				for ( prop in orig ) {
					if ( !( prop in event ) ) {
						event[ prop ] = orig[ prop ];
					}
				}
			}
	
			this.element.trigger( event, data );
			return !( $.isFunction( callback ) &&
				callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
				event.isDefaultPrevented() );
		}
	};
	
	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
		$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
			if ( typeof options === "string" ) {
				options = { effect: options };
			}
	
			var hasOptions;
			var effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
	
			options = options || {};
			if ( typeof options === "number" ) {
				options = { duration: options };
			}
	
			hasOptions = !$.isEmptyObject( options );
			options.complete = callback;
	
			if ( options.delay ) {
				element.delay( options.delay );
			}
	
			if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
				element[ method ]( options );
			} else if ( effectName !== method && element[ effectName ] ) {
				element[ effectName ]( options.duration, options.easing, callback );
			} else {
				element.queue( function( next ) {
					$( this )[ method ]();
					if ( callback ) {
						callback.call( element[ 0 ] );
					}
					next();
				} );
			}
		};
	} );
	
	return $.widget;
	
	} ) );


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI :data 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: :data Selector
	//>>group: Core
	//>>description: Selects elements which have data stored under the specified key.
	//>>docs: http://api.jqueryui.com/data-selector/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(285) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.extend( $.expr[ ":" ], {
		data: $.expr.createPseudo ?
			$.expr.createPseudo( function( dataName ) {
				return function( elem ) {
					return !!$.data( elem, dataName );
				};
			} ) :
	
			// Support: jQuery <1.8
			function( elem, i, match ) {
				return !!$.data( elem, match[ 3 ] );
			}
	} );
	} ) );


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Scroll Parent 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: scrollParent
	//>>group: Core
	//>>description: Get the closest ancestor element that is scrollable.
	//>>docs: http://api.jqueryui.com/scrollParent/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(285) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	return $.fn.scrollParent = function( includeHidden ) {
		var position = this.css( "position" ),
			excludeStaticParent = position === "absolute",
			overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
			scrollParent = this.parents().filter( function() {
				var parent = $( this );
				if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
					return false;
				}
				return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
					parent.css( "overflow-x" ) );
			} ).eq( 0 );
	
		return position === "fixed" || !scrollParent.length ?
			$( this[ 0 ].ownerDocument || document ) :
			scrollParent;
	};
	
	} ) );


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	/**
	 * angular-ui-sortable - This directive allows you to jQueryUI Sortable.
	 * @version v0.16.1 - 2016-12-16
	 * @link http://angular-ui.github.com
	 * @license MIT
	 */
	
	(function(window, angular, undefined) {
	'use strict';
	/*
	 jQuery UI Sortable plugin wrapper
	
	 @param [ui-sortable] {object} Options to pass to $.fn.sortable() merged onto ui.config
	 */
	angular.module('ui.sortable', [])
	  .value('uiSortableConfig',{
	    // the default for jquery-ui sortable is "> *", we need to restrict this to
	    // ng-repeat items
	    // if the user uses
	    items: '> [ng-repeat],> [data-ng-repeat],> [x-ng-repeat]'
	  })
	  .directive('uiSortable', [
	    'uiSortableConfig', '$timeout', '$log',
	    function(uiSortableConfig, $timeout, $log) {
	      return {
	        require: '?ngModel',
	        scope: {
	          ngModel: '=',
	          uiSortable: '='
	        },
	        link: function(scope, element, attrs, ngModel) {
	          var savedNodes;
	
	          function combineCallbacks(first, second){
	            var firstIsFunc = typeof first === 'function';
	            var secondIsFunc = typeof second === 'function';
	            if(firstIsFunc && secondIsFunc) {
	              return function() {
	                first.apply(this, arguments);
	                second.apply(this, arguments);
	              };
	            } else if (secondIsFunc) {
	              return second;
	            }
	            return first;
	          }
	
	          function getSortableWidgetInstance(element) {
	            // this is a fix to support jquery-ui prior to v1.11.x
	            // otherwise we should be using `element.sortable('instance')`
	            var data = element.data('ui-sortable');
	            if (data && typeof data === 'object' && data.widgetFullName === 'ui-sortable') {
	              return data;
	            }
	            return null;
	          }
	
	          function patchSortableOption(key, value) {
	            if (callbacks[key]) {
	              if( key === 'stop' ){
	                // call apply after stop
	                value = combineCallbacks(
	                  value, function() { scope.$apply(); });
	
	                value = combineCallbacks(value, afterStop);
	              }
	              // wrap the callback
	              value = combineCallbacks(callbacks[key], value);
	            } else if (wrappers[key]) {
	              value = wrappers[key](value);
	            }
	
	            // patch the options that need to have values set
	            if (!value && (key === 'items' || key === 'ui-model-items')) {
	              value = uiSortableConfig.items;
	            }
	
	            return value;
	          }
	
	          function patchUISortableOptions(newVal, oldVal, sortableWidgetInstance) {
	            function addDummyOptionKey(value, key) {
	              if (!(key in opts)) {
	                // add the key in the opts object so that
	                // the patch function detects and handles it
	                opts[key] = null;
	              }
	            }
	            // for this directive to work we have to attach some callbacks
	            angular.forEach(callbacks, addDummyOptionKey);
	
	            // only initialize it in case we have to
	            // update some options of the sortable
	            var optsDiff = null;
	
	            if (oldVal) {
	              // reset deleted options to default
	              var defaultOptions;
	              angular.forEach(oldVal, function(oldValue, key) {
	                if (!newVal || !(key in newVal)) {
	                  if (key in directiveOpts) {
	                    if (key === 'ui-floating') {
	                      opts[key] = 'auto';
	                    } else {
	                      opts[key] = patchSortableOption(key, undefined);
	                    }
	                    return;
	                  }
	
	                  if (!defaultOptions) {
	                    defaultOptions = angular.element.ui.sortable().options;
	                  }
	                  var defaultValue = defaultOptions[key];
	                  defaultValue = patchSortableOption(key, defaultValue);
	
	                  if (!optsDiff) {
	                    optsDiff = {};
	                  }
	                  optsDiff[key] = defaultValue;
	                  opts[key] = defaultValue;
	                }
	              });
	            }
	
	            // update changed options
	            angular.forEach(newVal, function(value, key) {
	              // if it's a custom option of the directive,
	              // handle it approprietly
	              if (key in directiveOpts) {
	                if (key === 'ui-floating' && (value === false || value === true) && sortableWidgetInstance) {
	                  sortableWidgetInstance.floating = value;
	                }
	
	                opts[key] = patchSortableOption(key, value);
	                return;
	              }
	
	              value = patchSortableOption(key, value);
	
	              if (!optsDiff) {
	                optsDiff = {};
	              }
	              optsDiff[key] = value;
	              opts[key] = value;
	            });
	
	            return optsDiff;
	          }
	
	          function getPlaceholderElement (element) {
	            var placeholder = element.sortable('option','placeholder');
	
	            // placeholder.element will be a function if the placeholder, has
	            // been created (placeholder will be an object).  If it hasn't
	            // been created, either placeholder will be false if no
	            // placeholder class was given or placeholder.element will be
	            // undefined if a class was given (placeholder will be a string)
	            if (placeholder && placeholder.element && typeof placeholder.element === 'function') {
	              var result = placeholder.element();
	              // workaround for jquery ui 1.9.x,
	              // not returning jquery collection
	              result = angular.element(result);
	              return result;
	            }
	            return null;
	          }
	
	          function getPlaceholderExcludesludes (element, placeholder) {
	            // exact match with the placeholder's class attribute to handle
	            // the case that multiple connected sortables exist and
	            // the placeholder option equals the class of sortable items
	            var notCssSelector = opts['ui-model-items'].replace(/[^,]*>/g, '');
	            var excludes = element.find('[class="' + placeholder.attr('class') + '"]:not(' + notCssSelector + ')');
	            return excludes;
	          }
	
	          function hasSortingHelper (element, ui) {
	            var helperOption = element.sortable('option','helper');
	            return helperOption === 'clone' || (typeof helperOption === 'function' && ui.item.sortable.isCustomHelperUsed());
	          }
	
	          function getSortingHelper (element, ui, savedNodes) {
	            var result = null;
	            if (hasSortingHelper(element, ui) &&
	                element.sortable( 'option', 'appendTo' ) === 'parent') {
	              // The .ui-sortable-helper element (that's the default class name)
	              // is placed last.
	              result = savedNodes.last();
	            }
	            return result;
	          }
	
	          // thanks jquery-ui
	          function isFloating (item) {
	            return (/left|right/).test(item.css('float')) || (/inline|table-cell/).test(item.css('display'));
	          }
	
	          function getElementContext(elementScopes, element) {
	            for (var i = 0; i < elementScopes.length; i++) {
	              var c = elementScopes[i];
	              if (c.element[0] === element[0]) {
	                return c;
	              }
	            }
	          }
	
	          function afterStop(e, ui) {
	            ui.item.sortable._destroy();
	          }
	
	          // return the index of ui.item among the items
	          // we can't just do ui.item.index() because there it might have siblings
	          // which are not items
	          function getItemIndex(item) {
	            return item.parent()
	              .find(opts['ui-model-items'])
	              .index(item);
	          }
	
	          var opts = {};
	
	          // directive specific options
	          var directiveOpts = {
	            'ui-floating': undefined,
	            'ui-model-items': uiSortableConfig.items
	          };
	
	          var callbacks = {
	            receive: null,
	            remove: null,
	            start: null,
	            stop: null,
	            update: null
	          };
	
	          var wrappers = {
	            helper: null
	          };
	
	          angular.extend(opts, directiveOpts, uiSortableConfig, scope.uiSortable);
	
	          if (!angular.element.fn || !angular.element.fn.jquery) {
	            $log.error('ui.sortable: jQuery should be included before AngularJS!');
	            return;
	          }
	
	          function wireUp () {
	            // When we add or remove elements, we need the sortable to 'refresh'
	            // so it can find the new/removed elements.
	            scope.$watchCollection('ngModel', function() {
	              // Timeout to let ng-repeat modify the DOM
	              $timeout(function() {
	                // ensure that the jquery-ui-sortable widget instance
	                // is still bound to the directive's element
	                if (!!getSortableWidgetInstance(element)) {
	                  element.sortable('refresh');
	                }
	              }, 0, false);
	            });
	
	            callbacks.start = function(e, ui) {
	              if (opts['ui-floating'] === 'auto') {
	                // since the drag has started, the element will be
	                // absolutely positioned, so we check its siblings
	                var siblings = ui.item.siblings();
	                var sortableWidgetInstance = getSortableWidgetInstance(angular.element(e.target));
	                sortableWidgetInstance.floating = isFloating(siblings);
	              }
	
	              // Save the starting position of dragged item
	              var index = getItemIndex(ui.item);
	              ui.item.sortable = {
	                model: ngModel.$modelValue[index],
	                index: index,
	                source: element,
	                sourceList: ui.item.parent(),
	                sourceModel: ngModel.$modelValue,
	                cancel: function () {
	                  ui.item.sortable._isCanceled = true;
	                },
	                isCanceled: function () {
	                  return ui.item.sortable._isCanceled;
	                },
	                isCustomHelperUsed: function () {
	                  return !!ui.item.sortable._isCustomHelperUsed;
	                },
	                _isCanceled: false,
	                _isCustomHelperUsed: ui.item.sortable._isCustomHelperUsed,
	                _destroy: function () {
	                  angular.forEach(ui.item.sortable, function(value, key) {
	                    ui.item.sortable[key] = undefined;
	                  });
	                },
	                _connectedSortables: [],
	                _getElementContext: function (element) {
	                  return getElementContext(this._connectedSortables, element);
	                }
	              };
	            };
	
	            callbacks.activate = function(e, ui) {
	              var isSourceContext = ui.item.sortable.source === element;
	              var savedNodesOrigin = isSourceContext ?
	                                     ui.item.sortable.sourceList :
	                                     element;
	              var elementContext = {
	                element: element,
	                scope: scope,
	                isSourceContext: isSourceContext,
	                savedNodesOrigin: savedNodesOrigin
	              };
	              // save the directive's scope so that it is accessible from ui.item.sortable
	              ui.item.sortable._connectedSortables.push(elementContext);
	
	              // We need to make a copy of the current element's contents so
	              // we can restore it after sortable has messed it up.
	              // This is inside activate (instead of start) in order to save
	              // both lists when dragging between connected lists.
	              savedNodes = savedNodesOrigin.contents();
	
	              // If this list has a placeholder (the connected lists won't),
	              // don't inlcude it in saved nodes.
	              var placeholder = getPlaceholderElement(element);
	              if (placeholder && placeholder.length) {
	                var excludes = getPlaceholderExcludesludes(element, placeholder);
	                savedNodes = savedNodes.not(excludes);
	              }
	            };
	
	            callbacks.update = function(e, ui) {
	              // Save current drop position but only if this is not a second
	              // update that happens when moving between lists because then
	              // the value will be overwritten with the old value
	              if(!ui.item.sortable.received) {
	                ui.item.sortable.dropindex = getItemIndex(ui.item);
	                var droptarget = ui.item.closest('[ui-sortable], [data-ui-sortable], [x-ui-sortable]');
	                ui.item.sortable.droptarget = droptarget;
	                ui.item.sortable.droptargetList = ui.item.parent();
	
	                var droptargetContext = ui.item.sortable._getElementContext(droptarget);
	                ui.item.sortable.droptargetModel = droptargetContext.scope.ngModel;
	
	                // Cancel the sort (let ng-repeat do the sort for us)
	                // Don't cancel if this is the received list because it has
	                // already been canceled in the other list, and trying to cancel
	                // here will mess up the DOM.
	                element.sortable('cancel');
	              }
	
	              // Put the nodes back exactly the way they started (this is very
	              // important because ng-repeat uses comment elements to delineate
	              // the start and stop of repeat sections and sortable doesn't
	              // respect their order (even if we cancel, the order of the
	              // comments are still messed up).
	              var sortingHelper = !ui.item.sortable.received && getSortingHelper(element, ui, savedNodes);
	              if (sortingHelper && sortingHelper.length) {
	                // Restore all the savedNodes except from the sorting helper element.
	                // That way it will be garbage collected.
	                savedNodes = savedNodes.not(sortingHelper);
	              }
	              var elementContext = ui.item.sortable._getElementContext(element);
	              savedNodes.appendTo(elementContext.savedNodesOrigin);
	
	              // If this is the target connected list then
	              // it's safe to clear the restored nodes since:
	              // update is currently running and
	              // stop is not called for the target list.
	              if(ui.item.sortable.received) {
	                savedNodes = null;
	              }
	
	              // If received is true (an item was dropped in from another list)
	              // then we add the new item to this list otherwise wait until the
	              // stop event where we will know if it was a sort or item was
	              // moved here from another list
	              if(ui.item.sortable.received && !ui.item.sortable.isCanceled()) {
	                scope.$apply(function () {
	                  ngModel.$modelValue.splice(ui.item.sortable.dropindex, 0,
	                                             ui.item.sortable.moved);
	                });
	              }
	            };
	
	            callbacks.stop = function(e, ui) {
	              // If the received flag hasn't be set on the item, this is a
	              // normal sort, if dropindex is set, the item was moved, so move
	              // the items in the list.
	              var wasMoved = ('dropindex' in ui.item.sortable) &&
	                              !ui.item.sortable.isCanceled();
	
	              if (wasMoved && !ui.item.sortable.received) {
	
	                scope.$apply(function () {
	                  ngModel.$modelValue.splice(
	                    ui.item.sortable.dropindex, 0,
	                    ngModel.$modelValue.splice(ui.item.sortable.index, 1)[0]);
	                });
	              } else if (!wasMoved &&
	                         !angular.equals(element.contents().toArray(), savedNodes.toArray())) {
	                // if the item was not moved
	                // and the DOM element order has changed,
	                // then restore the elements
	                // so that the ngRepeat's comment are correct.
	
	                var sortingHelper = getSortingHelper(element, ui, savedNodes);
	                if (sortingHelper && sortingHelper.length) {
	                  // Restore all the savedNodes except from the sorting helper element.
	                  // That way it will be garbage collected.
	                  savedNodes = savedNodes.not(sortingHelper);
	                }
	                var elementContext = ui.item.sortable._getElementContext(element);
	                savedNodes.appendTo(elementContext.savedNodesOrigin);
	              }
	
	              // It's now safe to clear the savedNodes
	              // since stop is the last callback.
	              savedNodes = null;
	            };
	
	            callbacks.receive = function(e, ui) {
	              // An item was dropped here from another list, set a flag on the
	              // item.
	              ui.item.sortable.received = true;
	            };
	
	            callbacks.remove = function(e, ui) {
	              // Workaround for a problem observed in nested connected lists.
	              // There should be an 'update' event before 'remove' when moving
	              // elements. If the event did not fire, cancel sorting.
	              if (!('dropindex' in ui.item.sortable)) {
	                element.sortable('cancel');
	                ui.item.sortable.cancel();
	              }
	
	              // Remove the item from this list's model and copy data into item,
	              // so the next list can retrive it
	              if (!ui.item.sortable.isCanceled()) {
	                scope.$apply(function () {
	                  ui.item.sortable.moved = ngModel.$modelValue.splice(
	                    ui.item.sortable.index, 1)[0];
	                });
	              }
	            };
	
	            wrappers.helper = function (inner) {
	              if (inner && typeof inner === 'function') {
	                return function (e, item) {
	                  var oldItemSortable = item.sortable;
	                  var index = getItemIndex(item);
	                  item.sortable = {
	                    model: ngModel.$modelValue[index],
	                    index: index,
	                    source: element,
	                    sourceList: item.parent(),
	                    sourceModel: ngModel.$modelValue,
	                    _restore: function () {
	                      angular.forEach(item.sortable, function(value, key) {
	                        item.sortable[key] = undefined;
	                      });
	
	                      item.sortable = oldItemSortable;
	                    }
	                  };
	
	                  var innerResult = inner.apply(this, arguments);
	                  item.sortable._restore();
	                  item.sortable._isCustomHelperUsed = item !== innerResult;
	                  return innerResult;
	                };
	              }
	              return inner;
	            };
	
	            scope.$watchCollection('uiSortable', function(newVal, oldVal) {
	              // ensure that the jquery-ui-sortable widget instance
	              // is still bound to the directive's element
	              var sortableWidgetInstance = getSortableWidgetInstance(element);
	              if (!!sortableWidgetInstance) {
	                var optsDiff = patchUISortableOptions(newVal, oldVal, sortableWidgetInstance);
	
	                if (optsDiff) {
	                  element.sortable('option', optsDiff);
	                }
	              }
	            }, true);
	
	            patchUISortableOptions(opts);
	          }
	
	          function init () {
	            if (ngModel) {
	              wireUp();
	            } else {
	              $log.info('ui.sortable: ngModel not provided!', element);
	            }
	
	            // Create sortable
	            element.sortable(opts);
	          }
	
	          function initIfEnabled () {
	            if (scope.uiSortable && scope.uiSortable.disabled) {
	              return false;
	            }
	
	            init();
	
	            // Stop Watcher
	            initIfEnabled.cancelWatcher();
	            initIfEnabled.cancelWatcher = angular.noop;
	
	            return true;
	          }
	
	          initIfEnabled.cancelWatcher = angular.noop;
	
	          if (!initIfEnabled()) {
	            initIfEnabled.cancelWatcher = scope.$watch('uiSortable.disabled', initIfEnabled);
	          }
	        }
	      };
	    }
	  ]);
	
	})(window, window.angular);


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	 (function(){
		'use strict';
	
		// Key codes
		var keys = {
			enter : 13,
			esc   : 27,
			left  : 37,
			right : 39
		};
	
		angular
		.module('thatisuday.ng-image-gallery', ['ngAnimate'])
		.provider('ngImageGalleryOpts', function(){
			var defOpts = {
				thumbnails  	:   true,
				thumbSize		: 	80,
				inline      	:   false,
				bubbles     	:   true,
				bubbleSize		: 	20,
				imgBubbles  	:   false,
				bgClose     	:   false,
				piracy 			: 	false,
				imgAnim 		: 	'fadeup',
				errorPlaceHolder:   'Error when loading the image!'
			};
	
			return{
				setOpts : function(newOpts){
					angular.extend(defOpts, newOpts);
				},
				$get : function(){
					return defOpts;
				}
			}
		})
		.filter('ngImageGalleryTrust', ['$sce', function($sce) {
	      return function(value, type) {
	        // Defaults to treating trusted value as `html`
	        return $sce.trustAs(type || 'html', value);
	      }
	    }])
	    .directive('ngRightClick', ['$parse', function($parse){
		    return {
		    	restrict: "A",
				scope : false,
				link : function(scope, element, attrs){
					element.bind('contextmenu', function(event){
						if(scope.piracy == false){
							event.preventDefault();
							return scope.piracy;
						}
					});
				}
		    };
		}])
		.directive("showImageAsync", [function(){
			return {
				restrict: "A",
				scope: false,
				link: function (scope, element, attributes){
					var image = new Image();
					image.src = attributes.showImageAsync;
					image.onload = function(){
						scope.$apply(function(){
							if(attributes.asyncKind == 'thumb'){
								element.css({ backgroundImage: 'url("' + attributes.showImageAsync + '")' });
								element.empty(); // remove loading animation element
							}
							else if(attributes.asyncKind == 'bubble'){
								element.css({ backgroundImage: 'url("' + attributes.showImageAsync + '")' });
							}
						});
					};
					image.onerror = function(){
						element.empty(); // remove loading animation element
					}
				}
			};
		}])
		.directive("bubbleAutoFit", ['$window', '$timeout', function($window, $timeout){
			return {
				restrict: "A",
				scope: false,
				link: {
					pre : function (scope, element, attributes){
						var autoFitBubbles = function(){
							var scrollerWidth = element[0].getBoundingClientRect().width;
							if(scrollerWidth == 0) return;
	
							var bubbleSize = scope.bubbleSize;
							var minMargin = 4 + 4; // left+right
							var bubbleSpace = (bubbleSize + minMargin);
							var rawQuotient = scrollerWidth / bubbleSpace;
							var bubblesInView = Math.floor(rawQuotient);
							var extraSpace = scrollerWidth - (bubblesInView * bubbleSpace);
							var extraMargin = extraSpace / bubblesInView;
							var bubbleMargin = minMargin + extraMargin;
							var finalBubbleSpace = bubbleMargin + bubbleSize;
	
							scope._bubblesInView = bubblesInView;
							scope._finalBubbleSpace = finalBubbleSpace;
							scope._bubbleMargin = '0 ' + (bubbleMargin/2) + 'px';
	
							scope._safeApply(angular.noop);
						};
	
						$timeout(autoFitBubbles);
	
						angular.element($window).bind('resize', function(){
							$timeout(autoFitBubbles);
						});
						scope.$watch('inline', function(){
							$timeout(autoFitBubbles);
						});
						scope.$watch('bubbleSize', function(){
							$timeout(autoFitBubbles);
						});
						scope.$watchCollection('images', function(){
							$timeout(autoFitBubbles);
						});
					}
				}
			};
		}])
		.directive("bubbleAutoScroll", ['$window', '$timeout', function($window, $timeout){
			return {
				restrict: "A",
				scope: false,
				link: function (scope, element, attributes){
	
					var indexCalc = function(){
						var relativeIndexToBubbleWrapper = scope._bubblesInView - (scope._bubblesInView - scope._activeImageIndex);
	
						$timeout(function(){
							if(relativeIndexToBubbleWrapper > scope._bubblesInView - 2){
								var outBubbles = ((scope._activeImageIndex+1) - scope._bubblesInView) + 1;
	
								if(scope._activeImageIndex != (scope.images.length - 1)){
									scope._bubblesContainerMarginLeft = '-' + (scope._finalBubbleSpace * outBubbles) + 'px';
								}
								else{
									scope._bubblesContainerMarginLeft = '-' + (scope._finalBubbleSpace * (outBubbles - 1)) + 'px';
								}
							}
							else{
								scope._bubblesContainerMarginLeft = '0px';
							}
						});
					}
	
					angular.element($window).bind('resize', function(){
						$timeout(indexCalc);
					});
					scope.$watch('_bubblesInView', function(){
						$timeout(indexCalc);
					});
					scope.$watch('_activeImageIndex', function(){
						$timeout(indexCalc);
					});
					scope.$watchCollection('images', function(){
						$timeout(indexCalc);
					});
				}
			};
		}])
		.directive('ngImageGallery', ['$rootScope', '$timeout', '$q', 'ngImageGalleryOpts',
		function($rootScope, $timeout, $q, ngImageGalleryOpts){
			return {
				replace : true,
				transclude : false,
				restrict : 'AE',
				scope : {
					images 			: 	'=',		// []
					methods 		: 	'=?',		// {}
					conf 			: 	'=?',		// {}
	
					thumbnails 		: 	'=?',		// true|false
					thumbSize		: 	'=?', 		// px
					inline 			: 	'=?',		// true|false
					bubbles 		: 	'=?',		// true|false
					bubbleSize 		: 	'=?',		// px
					imgBubbles 		: 	'=?',		// true|false
					bgClose 		: 	'=?',		// true|false
					piracy			: 	'=?',		// true|false
					imgAnim 		: 	'@?',		// {name}
					errorPlaceHolder: 	'@?',		// {name}
	
					onOpen 			: 	'&?',		// function
					onClose 		: 	'&?',		// function,
					onDelete		: 	'&?'
				},
				template : 	'<div class="ng-image-gallery img-move-dir-{{_imgMoveDirection}}" ng-class="{inline:inline}" ng-hide="images.length == 0">'+
	
								// Thumbnails container
								//  Hide for inline gallery
								'<div ng-if="thumbnails && !inline" class="ng-image-gallery-thumbnails">' +
	 								'<div class="thumb" ng-repeat="image in images track by image.id" ng-click="methods.open($index);" show-image-async="{{image.thumbUrl || image.url}}" async-kind="thumb" ng-style="{\'width\' : thumbSize+\'px\', \'height\' : thumbSize+\'px\'}">'+
	 									'<div class="loader"></div>'+
	 								'</div>' +
	 							'</div>' +
	
								// Modal container
								// (inline container for inline modal)
								'<div class="ng-image-gallery-modal" ng-if="opened" ng-cloak>' +
	
									// Gallery backdrop container
									// (hide for inline gallery)
									'<div class="ng-image-gallery-backdrop" ng-if="!inline"></div>'+
	
									// Gallery contents container
									// (hide when image is loading)
									'<div class="ng-image-gallery-content" ng-show="!imgLoading" ng-click="backgroundClose($event);">'+
	
										// actions icons container
										'<div class="actions-icons-container">'+
											// Delete image icon
											'<div class="delete-img" ng-repeat="image in images track by image.id" ng-if="_activeImg == image && image.deletable" title="Delete this image..." ng-click="_deleteImg(image)"></div>'+
										'</div>'+
	
										// control icons container
										'<div class="control-icons-container">'+
											// External link icon
											'<a class="ext-url" ng-repeat="image in images track by image.id" ng-if="_activeImg == image && image.extUrl" href="{{image.extUrl}}" target="_blank" title="Open image in new tab..."></a>'+
	
											// Close Icon (hidden in inline gallery)
											'<div class="close" ng-click="methods.close();" ng-if="!inline"></div>'+
										'</div>'+
	
										// Prev-Next Icons
										// Add `bubbles-on` class when bubbles are enabled (for offset)
										'<div class="prev" ng-click="methods.prev();" ng-class="{\'bubbles-on\':bubbles}" ng-hide="images.length == 1"></div>'+
										'<div class="next" ng-click="methods.next();" ng-class="{\'bubbles-on\':bubbles}" ng-hide="images.length == 1"></div>'+
	
										// Galleria container
										'<div class="galleria">'+
	
											// Images container
											'<div class="galleria-images img-anim-{{imgAnim}} img-move-dir-{{_imgMoveDirection}}">'+
												'<img class="galleria-image" ng-right-click ng-repeat="image in images track by image.id" ng-if="_activeImg == image" ng-src="{{image.url}}" ondragstart="return false;" ng-attr-alt="{{image.alt || undefined}}"/>'+
											'</div>'+
	
											// Image description container
											'<div class="galleria-title-description-wrapper">'+
												'<div ng-repeat="image in images track by image.id" ng-if="(image.title || image.desc) && (_activeImg == image)">'+
													'<div class="title" ng-if="image.title" ng-bind-html="image.title | ngImageGalleryTrust"></div>'+
													'<div class="desc" ng-if="image.desc" ng-bind-html="image.desc | ngImageGalleryTrust"></div>'+
												'</div>'+
											'</div>'+
	
											// Bubble navigation container
											'<div class="galleria-bubbles-wrapper" ng-if="bubbles && !imgBubbles" ng-hide="images.length == 1" ng-style="{\'height\' : bubbleSize+\'px\'}" bubble-auto-fit>'+
												'<div class="galleria-bubbles" bubble-auto-scroll ng-style="{\'margin-left\': _bubblesContainerMarginLeft}">'+
													'<span class="galleria-bubble" ng-click="_setActiveImg(image);" ng-repeat="image in images track by image.id" ng-class="{active : (_activeImg == image)}" ng-style="{\'width\' : bubbleSize+\'px\', \'height\' : bubbleSize+\'px\', margin: _bubbleMargin}"></span>'+
												'</div>'+
											'</div>'+
	
											// Image bubble navigation container
											'<div class="galleria-bubbles-wrapper" ng-if="bubbles && imgBubbles" ng-hide="images.length == 1" ng-style="{\'height\' : bubbleSize+\'px\'}" bubble-auto-fit>'+
												'<div class="galleria-bubbles" bubble-auto-scroll ng-style="{\'margin-left\': _bubblesContainerMarginLeft}">'+
													'<span class="galleria-bubble img-bubble" ng-click="_setActiveImg(image);" ng-repeat="image in images track by image.id" ng-class="{active : (_activeImg == image)}" show-image-async="{{image.bubbleUrl || image.thumbUrl || image.url}}" async-kind="bubble" ng-style="{\'width\' : bubbleSize+\'px\', \'height\' : bubbleSize+\'px\', \'border-width\' : bubbleSize/10+\'px\', margin: _bubbleMargin}"></span>'+
												'</div>'+
											'</div>'+
	
										'</div>'+
	
									'</div>'+
	
									// Loading animation overlay container
									// (show when image is loading)
									'<div class="ng-image-gallery-loader" ng-show="imgLoading">'+
										'<div class="spinner">'+
											'<div class="rect1"></div>'+
											'<div class="rect2"></div>'+
											'<div class="rect3"></div>'+
											'<div class="rect4"></div>'+
											'<div class="rect5"></div>'+
										'</div>'+
									'</div>'+
	
									// (show when image cannot be loaded)
									'<div class="ng-image-gallery-errorplaceholder" ng-show="imgError">'+
										'<div class="ng-image-gallery-error-placeholder" ng-bind-html="errorPlaceHolder | ngImageGalleryTrust"></div>'+
									'</div>'+
								'</div>'+
							'</div>',
	
				link : {
					pre : function(scope, elem, attr){
	
						/*
						 *	Operational functions
						**/
	
						// Show gallery loader
						scope._showLoader = function(){
							scope.imgLoading = true;
						}
	
						// Hide gallery loader
						scope._hideLoader = function(){
							scope.imgLoading = false;
						}
	
						// Image load complete promise
						scope._loadImg = function(imgObj){
	
							// Return rejected promise
							// if not image object received
							if(!imgObj) return $q.reject();
	
							var deferred =  $q.defer();
	
							// Show loder
							if(!imgObj.hasOwnProperty('cached')) scope._showLoader();
	
							// Process image
							var img = new Image();
							img.src = imgObj.url;
							img.onload = function(){
								// Hide loder
								if(!imgObj.hasOwnProperty('cached')) scope._hideLoader();
	
								// Cache image
								if(!imgObj.hasOwnProperty('cached')) imgObj.cached = true;
	
								deferred.resolve(imgObj);
							}
							img.onerror = function(){
								if(!imgObj.hasOwnProperty('cached')) scope._hideLoader();
	
								deferred.reject('Error when loading img');
							}
	
							return deferred.promise;
						}
	
						scope._setActiveImg = function(imgObj){
							// Get images move direction
							if(
								scope.images.indexOf(scope._activeImg) - scope.images.indexOf(imgObj) == (scope.images.length - 1) ||
								(
									scope.images.indexOf(scope._activeImg) - scope.images.indexOf(imgObj) <= 0 &&
									scope.images.indexOf(scope._activeImg) - scope.images.indexOf(imgObj) != -(scope.images.length - 1)
								)
	
							){
								scope._imgMoveDirection = 'forward';
							}
							else{
								scope._imgMoveDirection = 'backward';
							}
	
							// Load image
							scope._loadImg(imgObj).then(function(imgObj){
								scope._activeImg = imgObj;
								scope._activeImageIndex = scope.images.indexOf(imgObj);
								scope.imgError = false;
							}, function(){
								scope._activeImg = null;
								scope._activeImageIndex = scope.images.indexOf(imgObj);
								scope.imgError = true;
							})
							;
						}
	
						scope._safeApply = function(fn){
							var phase = this.$root.$$phase;
							if(phase == '$apply' || phase == '$digest'){
								if(fn && (typeof(fn) === 'function')){
									fn();
								}
							}else{
								this.$apply(fn);
							}
						};
	
						scope._deleteImg = function(img){
							var _deleteImgCallback = function(){
								var index = scope.images.indexOf(img);
								console.log(index);
								scope.images.splice(index, 1);
								scope._activeImageIndex = 0;
	
								/**/
							}
	
							scope.onDelete({img: img, cb: _deleteImgCallback});
						}
	
	
						/***************************************************/
	
	
						/*
						 *	Gallery settings
						**/
	
						// Modify scope models
						scope.images 	 	 = 	(scope.images 		!= undefined) ? scope.images 	 : 	[];
						scope.methods 	 	 = 	(scope.methods 		!= undefined) ? scope.methods 	 : 	{};
						scope.conf 	 		 = 	(scope.conf 		!= undefined) ? scope.conf 		 : 	{};
	
						// setting options
						scope.$watchCollection('conf', function(conf){
							scope.thumbnails 	 = 	(conf.thumbnails 	!= undefined) ? conf.thumbnails 	: 	(scope.thumbnails 	!= undefined) 	?  scope.thumbnails		: 	ngImageGalleryOpts.thumbnails;
							scope.thumbSize 	 = 	(conf.thumbSize 	!= undefined) ? conf.thumbSize 		: 	(scope.thumbSize 	!= undefined) 	?  scope.thumbSize		: 	ngImageGalleryOpts.thumbSize;
							scope.inline 	 	 = 	(conf.inline 		!= undefined) ? conf.inline 	 	: 	(scope.inline 		!= undefined) 	?  scope.inline			: 	ngImageGalleryOpts.inline;
							scope.bubbles 	 	 = 	(conf.bubbles 		!= undefined) ? conf.bubbles 	 	: 	(scope.bubbles 		!= undefined) 	?  scope.bubbles		: 	ngImageGalleryOpts.bubbles;
							scope.bubbleSize 	 = 	(conf.bubbleSize 	!= undefined) ? conf.bubbleSize 	 : 	(scope.bubbleSize 	!= undefined) 	?  scope.bubbleSize		: 	ngImageGalleryOpts.bubbleSize;
							scope.imgBubbles 	 = 	(conf.imgBubbles 	!= undefined) ? conf.imgBubbles 	: 	(scope.imgBubbles 	!= undefined) 	?  scope.imgBubbles		: 	ngImageGalleryOpts.imgBubbles;
							scope.bgClose 	 	 = 	(conf.bgClose 		!= undefined) ? conf.bgClose 	 	: 	(scope.bgClose 		!= undefined) 	?  scope.bgClose		: 	ngImageGalleryOpts.bgClose;
							scope.piracy 	 	 = 	(conf.piracy 		!= undefined) ? conf.piracy 	 	: 	(scope.piracy 		!= undefined) 	?  scope.piracy			: 	ngImageGalleryOpts.piracy;
							scope.imgAnim 	 	 = 	(conf.imgAnim 		!= undefined) ? conf.imgAnim 	 	: 	(scope.imgAnim 		!= undefined) 	?  scope.imgAnim		: 	ngImageGalleryOpts.imgAnim;
							scope.errorPlaceHolder = (conf.errorPlaceHolder != undefined) ? conf.errorPlaceHolder : (scope.errorPlaceHolder != undefined) ? scope.errorPlaceHolder : ngImageGalleryOpts.errorPlaceHolder;
						});
	
						scope.onOpen 	 = 	(scope.onOpen 	!= undefined) ? scope.onOpen 	 : 	angular.noop;
						scope.onClose 	 = 	(scope.onClose 	!= undefined) ? scope.onClose 	 : 	angular.noop;
						scope.onDelete 	 = 	(scope.onDelete != undefined) ? scope.onDelete 	 : 	angular.noop;
	
						// If images populate dynamically, reset gallery
						var imagesFirstWatch = true;
						scope.$watchCollection('images', function(){
							if(imagesFirstWatch){
								imagesFirstWatch = false;
							}
							else if(scope.images.length){
								scope._setActiveImg(scope.images[scope._activeImageIndex || 0]);
							}
						});
	
						// Watch index of visible/active image
						// If index changes, make sure to load/change image
						var activeImageIndexFirstWatch = true;
						scope.$watch('_activeImageIndex', function(newImgIndex){
							if(activeImageIndexFirstWatch){
								activeImageIndexFirstWatch = false;
							}
							else if(scope.images.length){
								scope._setActiveImg(
									scope.images[newImgIndex]
								);
							}
						});
	
						// Open modal automatically if inline
						scope.$watch('inline', function(){
							$timeout(function(){
								if(scope.inline) scope.methods.open();
							});
						});
	
	
						/***************************************************/
	
	
						/*
						 *	Methods
						**/
	
						// Open gallery modal
						scope.methods.open = function(imgIndex){
							// Open modal from an index if one passed
							scope._activeImageIndex = (imgIndex) ? imgIndex : 0;
	
							scope.opened = true;
	
							// set overflow hidden to body
							if(!scope.inline) angular.element(document.body).addClass('body-overflow-hidden');
	
							// call open event after transition
							$timeout(function(){
								scope.onOpen();
							}, 300);
						}
	
						// Close gallery modal
						scope.methods.close = function(){
							scope.opened = false; // Model closed
	
							// set overflow hidden to body
							angular.element(document.body).removeClass('body-overflow-hidden');
	
							// call close event after transition
							$timeout(function(){
								scope.onClose();
								scope._activeImageIndex = 0; // Reset index
							}, 300);
						}
	
						// Change image to next
						scope.methods.next = function(){
							if(scope._activeImageIndex == (scope.images.length - 1)){
								scope._activeImageIndex = 0;
							}
							else{
								scope._activeImageIndex = scope._activeImageIndex + 1;
							}
						}
	
						// Change image to prev
						scope.methods.prev = function(){
							if(scope._activeImageIndex == 0){
								scope._activeImageIndex = scope.images.length - 1;
							}
							else{
								scope._activeImageIndex--;
							}
						}
	
						// Close gallery on background click
						scope.backgroundClose = function(e){
							if(!scope.bgClose || scope.inline) return;
	
							var noCloseClasses = [
								'galleria-image',
								'destroy-icons-container',
								'ext-url',
								'close',
								'next',
								'prev',
								'galleria-bubble'
							];
	
							// check if clicked element has a class that
							// belongs to `noCloseClasses`
							for(var i = 0; i < e.target.classList.length; i++){
								if(noCloseClasses.indexOf(e.target.classList[i]) != -1){
									break;
								}
								else{
									scope.methods.close();
								}
							}
						}
	
	
						/***************************************************/
	
	
						/*
						 *	User interactions
						**/
	
						// Key events
						angular.element(document).bind('keyup', function(event){
							// If inline modal, do not interact
							if(scope.inline) return;
	
							if(event.which == keys.right || event.which == keys.enter){
								$timeout(function(){
									scope.methods.next();
								});
							}
							else if(event.which == keys.left){
								$timeout(function(){
									scope.methods.prev();
								});
							}
							else if(event.which == keys.esc){
								$timeout(function(){
									scope.methods.close();
								});
							}
						});
	
						// Swipe events
						if(window.Hammer){
							var hammerElem = new Hammer(elem[0]);
							hammerElem.on('swiperight', function(ev){
								$timeout(function(){
									scope.methods.prev();
								});
							});
							hammerElem.on('swipeleft', function(ev){
								$timeout(function(){
									scope.methods.next();
								});
							});
							hammerElem.on('doubletap', function(ev){
								if(scope.inline) return;
	
								$timeout(function(){
									scope.methods.close();
								});
							});
						};
	
	
						/***********************************************************/
	
	
						/*
						 *	Actions on angular events
						**/
	
						var removeClassFromDocumentBody = function(){
							angular.element(document.body).removeClass('body-overflow-hidden');
						};
	
						$rootScope.$on('$stateChangeSuccess', removeClassFromDocumentBody);
						$rootScope.$on('$routeChangeSuccess', removeClassFromDocumentBody);
	
					}
				}
			}
		}]);
	 })();

/***/ }),
/* 291 */
5,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * FullCalendar v3.5.0
	 * Docs & License: https://fullcalendar.io/
	 * (c) 2017 Adam Shaw
	 */
	!function(t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2),__webpack_require__(44)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=t(require("jquery"),require("moment")):t(jQuery,moment)}(function(t,e){function n(t){return j(t,Gt)}function i(t,e){e.left&&t.css({"border-left-width":1,"margin-left":e.left-1}),e.right&&t.css({"border-right-width":1,"margin-right":e.right-1})}function s(t){t.css({"margin-left":"","margin-right":"","border-left-width":"","border-right-width":""})}function r(){t("body").addClass("fc-not-allowed")}function o(){t("body").removeClass("fc-not-allowed")}function a(e,n,i){var s=Math.floor(n/e.length),r=Math.floor(n-s*(e.length-1)),o=[],a=[],u=[],c=0;l(e),e.each(function(n,i){var l=n===e.length-1?r:s,h=t(i).outerHeight(!0);h<l?(o.push(i),a.push(h),u.push(t(i).height())):c+=h}),i&&(n-=c,s=Math.floor(n/o.length),r=Math.floor(n-s*(o.length-1))),t(o).each(function(e,n){var i=e===o.length-1?r:s,l=a[e],c=u[e],h=i-(l-c);l<i&&t(n).height(h)})}function l(t){t.height("")}function u(e){var n=0;return e.find("> *").each(function(e,i){var s=t(i).outerWidth();s>n&&(n=s)}),n++,e.width(n),n}function c(t,e){var n,i=t.add(e);return i.css({position:"relative",left:-1}),n=t.outerHeight()-e.outerHeight(),i.css({position:"",left:""}),n}function h(e){var n=e.css("position"),i=e.parents().filter(function(){var e=t(this);return/(auto|scroll)/.test(e.css("overflow")+e.css("overflow-y")+e.css("overflow-x"))}).eq(0);return"fixed"!==n&&i.length?i:t(e[0].ownerDocument||document)}function d(t,e){var n=t.offset(),i=n.left-(e?e.left:0),s=n.top-(e?e.top:0);return{left:i,right:i+t.outerWidth(),top:s,bottom:s+t.outerHeight()}}function f(t,e){var n=t.offset(),i=p(t),s=n.left+w(t,"border-left-width")+i.left-(e?e.left:0),r=n.top+w(t,"border-top-width")+i.top-(e?e.top:0);return{left:s,right:s+t[0].clientWidth,top:r,bottom:r+t[0].clientHeight}}function g(t,e){var n=t.offset(),i=n.left+w(t,"border-left-width")+w(t,"padding-left")-(e?e.left:0),s=n.top+w(t,"border-top-width")+w(t,"padding-top")-(e?e.top:0);return{left:i,right:i+t.width(),top:s,bottom:s+t.height()}}function p(t){var e,n=t[0].offsetWidth-t[0].clientWidth,i=t[0].offsetHeight-t[0].clientHeight;return n=v(n),i=v(i),e={left:0,right:0,top:0,bottom:i},m()&&"rtl"==t.css("direction")?e.left=n:e.right=n,e}function v(t){return t=Math.max(0,t),t=Math.round(t)}function m(){return null===Wt&&(Wt=y()),Wt}function y(){var e=t("<div><div/></div>").css({position:"absolute",top:-1e3,left:0,border:0,padding:0,overflow:"scroll",direction:"rtl"}).appendTo("body"),n=e.children(),i=n.offset().left>e.offset().left;return e.remove(),i}function w(t,e){return parseFloat(t.css(e))||0}function D(t){return 1==t.which&&!t.ctrlKey}function b(t){var e=t.originalEvent.touches;return e&&e.length?e[0].pageX:t.pageX}function S(t){var e=t.originalEvent.touches;return e&&e.length?e[0].pageY:t.pageY}function E(t){return/^touch/.test(t.type)}function C(t){t.addClass("fc-unselectable").on("selectstart",R)}function T(t){t.removeClass("fc-unselectable").off("selectstart",R)}function R(t){t.preventDefault()}function I(t,e){var n={left:Math.max(t.left,e.left),right:Math.min(t.right,e.right),top:Math.max(t.top,e.top),bottom:Math.min(t.bottom,e.bottom)};return n.left<n.right&&n.top<n.bottom&&n}function H(t,e){return{left:Math.min(Math.max(t.left,e.left),e.right),top:Math.min(Math.max(t.top,e.top),e.bottom)}}function M(t){return{left:(t.left+t.right)/2,top:(t.top+t.bottom)/2}}function x(t,e){return{left:t.left-e.left,top:t.top-e.top}}function z(e){var n,i,s=[],r=[];for("string"==typeof e?r=e.split(/\s*,\s*/):"function"==typeof e?r=[e]:t.isArray(e)&&(r=e),n=0;n<r.length;n++)i=r[n],"string"==typeof i?s.push("-"==i.charAt(0)?{field:i.substring(1),order:-1}:{field:i,order:1}):"function"==typeof i&&s.push({func:i});return s}function F(t,e,n){var i,s;for(i=0;i<n.length;i++)if(s=P(t,e,n[i]))return s;return 0}function P(t,e,n){return n.func?n.func(t,e):B(t[n.field],e[n.field])*(n.order||1)}function B(e,n){return e||n?null==n?-1:null==e?1:"string"===t.type(e)||"string"===t.type(n)?String(e).localeCompare(String(n)):e-n:0}function k(t,n){return e.duration({days:t.clone().stripTime().diff(n.clone().stripTime(),"days"),ms:t.time()-n.time()})}function A(t,n){return e.duration({days:t.clone().stripTime().diff(n.clone().stripTime(),"days")})}function L(t,n,i){return e.duration(Math.round(t.diff(n,i,!0)),i)}function O(t,e){var n,i,s;for(n=0;n<qt.length&&(i=qt[n],!((s=V(i,t,e))>=1&&ot(s)));n++);return i}function N(t,e){var n=O(t);return"week"===n&&"object"==typeof e&&e.days&&(n="day"),n}function V(t,n,i){return null!=i?i.diff(n,t,!0):e.isDuration(n)?n.as(t):n.end.diff(n.start,t,!0)}function U(t,e,n){var i;return _(n)?(e-t)/n:(i=n.asMonths(),Math.abs(i)>=1&&ot(i)?e.diff(t,"months",!0)/i:e.diff(t,"days",!0)/n.asDays())}function G(t,e){var n,i;return _(t)||_(e)?t/e:(n=t.asMonths(),i=e.asMonths(),Math.abs(n)>=1&&ot(n)&&Math.abs(i)>=1&&ot(i)?n/i:t.asDays()/e.asDays())}function W(t,n){var i;return _(t)?e.duration(t*n):(i=t.asMonths(),Math.abs(i)>=1&&ot(i)?e.duration({months:i*n}):e.duration({days:t.asDays()*n}))}function _(t){return Boolean(t.hours()||t.minutes()||t.seconds()||t.milliseconds())}function q(t){return"[object Date]"===Object.prototype.toString.call(t)||t instanceof Date}function Y(t){return"string"==typeof t&&/^\d+\:\d+(?:\:\d+\.?(?:\d{3})?)?$/.test(t)}function j(t,e){var n,i,s,r,o,a,l={};if(e)for(n=0;n<e.length;n++){for(i=e[n],s=[],r=t.length-1;r>=0;r--)if("object"==typeof(o=t[r][i]))s.unshift(o);else if(void 0!==o){l[i]=o;break}s.length&&(l[i]=j(s))}for(n=t.length-1;n>=0;n--){a=t[n];for(i in a)i in l||(l[i]=a[i])}return l}function Z(t,e){for(var n in t)Q(t,n)&&(e[n]=t[n])}function Q(t,e){return Yt.call(t,e)}function $(e,n,i){if(t.isFunction(e)&&(e=[e]),e){var s,r;for(s=0;s<e.length;s++)r=e[s].apply(n,i)||r;return r}}function X(t,e){for(var n=0,i=0;i<t.length;)e(t[i])?(t.splice(i,1),n++):i++;return n}function K(t,e){for(var n=0,i=0;i<t.length;)t[i]===e?(t.splice(i,1),n++):i++;return n}function J(){for(var t=0;t<arguments.length;t++)if(void 0!==arguments[t])return arguments[t]}function tt(t){return(t+"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/'/g,"&#039;").replace(/"/g,"&quot;").replace(/\n/g,"<br />")}function et(t){return t.replace(/&.*?;/g,"")}function nt(e){var n=[];return t.each(e,function(t,e){null!=e&&n.push(t+":"+e)}),n.join(";")}function it(e){var n=[];return t.each(e,function(t,e){null!=e&&n.push(t+'="'+tt(e)+'"')}),n.join(" ")}function st(t){return t.charAt(0).toUpperCase()+t.slice(1)}function rt(t,e){return t-e}function ot(t){return t%1==0}function at(t,e){var n=t[e];return function(){return n.apply(t,arguments)}}function lt(t,e,n){var i,s,r,o,a,l=function(){var u=+new Date-o;u<e?i=setTimeout(l,e-u):(i=null,n||(a=t.apply(r,s),r=s=null))};return function(){r=this,s=arguments,o=+new Date;var u=n&&!i;return i||(i=setTimeout(l,e)),u&&(a=t.apply(r,s),r=s=null),a}}function ut(n,i,s){var r,o,a,l,u=n[0],c=1==n.length&&"string"==typeof u;return e.isMoment(u)||q(u)||void 0===u?l=e.apply(null,n):(r=!1,o=!1,c?jt.test(u)?(u+="-01",n=[u],r=!0,o=!0):(a=Zt.exec(u))&&(r=!a[5],o=!0):t.isArray(u)&&(o=!0),l=i||r?e.utc.apply(e,n):e.apply(null,n),r?(l._ambigTime=!0,l._ambigZone=!0):s&&(o?l._ambigZone=!0:c&&l.utcOffset(u))),l._fullCalendar=!0,l}function ct(t){return"en"!==t.locale()?t.clone().locale("en"):t}function ht(){}function dt(t,e){var n;return Q(e,"constructor")&&(n=e.constructor),"function"!=typeof n&&(n=e.constructor=function(){t.apply(this,arguments)}),n.prototype=Object.create(t.prototype),Z(e,n.prototype),Z(t,n),n}function ft(t,e){t.then=function(n){return"function"==typeof n?ae.resolve(n(e)):t}}function gt(t){t.then=function(e,n){return"function"==typeof n&&n(),t}}function pt(t,e){return!t&&!e||!(!t||!e)&&(t.component===e.component&&vt(t,e)&&vt(e,t))}function vt(t,e){for(var n in t)if(!/^(component|left|right|top|bottom)$/.test(n)&&t[n]!==e[n])return!1;return!0}function mt(n){var i,s,r,o,a=Vt.dataAttrPrefix;return a&&(a+="-"),i=n.data(a+"event")||null,i&&(i="object"==typeof i?t.extend({},i):{},s=i.start,null==s&&(s=i.time),r=i.duration,o=i.stick,delete i.start,delete i.time,delete i.duration,delete i.stick),null==s&&(s=n.data(a+"start")),null==s&&(s=n.data(a+"time")),null==r&&(r=n.data(a+"duration")),null==o&&(o=n.data(a+"stick")),s=null!=s?e.duration(s):null,r=null!=r?e.duration(r):null,o=Boolean(o),{eventProps:i,startTime:s,duration:r,stick:o}}function yt(t,e){var n,i;for(n=0;n<e.length;n++)if(i=e[n],i.leftCol<=t.rightCol&&i.rightCol>=t.leftCol)return!0;return!1}function wt(t,e){return t.leftCol-e.leftCol}function Dt(t){var e,n,i,s=[];for(e=0;e<t.length;e++){for(n=t[e],i=0;i<s.length&&Et(n,s[i]).length;i++);n.level=i,(s[i]||(s[i]=[])).push(n)}return s}function bt(t){var e,n,i,s,r;for(e=0;e<t.length;e++)for(n=t[e],i=0;i<n.length;i++)for(s=n[i],s.forwardSegs=[],r=e+1;r<t.length;r++)Et(s,t[r],s.forwardSegs)}function St(t){var e,n,i=t.forwardSegs,s=0;if(void 0===t.forwardPressure){for(e=0;e<i.length;e++)n=i[e],St(n),s=Math.max(s,1+n.forwardPressure);t.forwardPressure=s}}function Et(t,e,n){n=n||[];for(var i=0;i<e.length;i++)Ct(t,e[i])&&n.push(e[i]);return n}function Ct(t,e){return t.bottom>e.top&&t.top<e.bottom}function Tt(t){var e,n,i,s=[];for(e in t)for(n=t[e].eventInstances,i=0;i<n.length;i++)s.push(n[i].toLegacy());return s}function Rt(t){this.items=t||[]}function It(e,n){function i(t){n=t}function s(){n.layout?(g?g.empty():g=this.el=t("<div class='fc-toolbar "+n.extraClasses+"'/>"),g.append(o("left")).append(o("right")).append(o("center")).append('<div class="fc-clear"/>')):r()}function r(){g&&(g.remove(),g=f.el=null)}function o(i){var s=e.theme,r=t('<div class="fc-'+i+'"/>'),o=n.layout[i],a=e.opt("customButtons")||{},l=e.overrides.buttonText||{},u=e.opt("buttonText")||{};return o&&t.each(o.split(" "),function(n){var i,o=t(),c=!0;t.each(this.split(","),function(n,i){var r,h,d,f,g,v,m,y;"title"==i?(o=o.add(t("<h2>&nbsp;</h2>")),c=!1):((r=a[i])?(d=function(t){r.click&&r.click.call(y[0],t)},(f=s.getCustomButtonIconClass(r))||(f=s.getIconClass(i))||(g=r.text)):(h=e.getViewSpec(i))?(p.push(i),d=function(){e.changeView(i)},(g=h.buttonTextOverride)||(f=s.getIconClass(i))||(g=h.buttonTextDefault)):e[i]&&(d=function(){e[i]()},(g=l[i])||(f=s.getIconClass(i))||(g=u[i])),d&&(m=["fc-"+i+"-button",s.getClass("button"),s.getClass("stateDefault")],g?v=tt(g):f&&(v="<span class='"+f+"'></span>"),y=t('<button type="button" class="'+m.join(" ")+'">'+v+"</button>").click(function(t){y.hasClass(s.getClass("stateDisabled"))||(d(t),(y.hasClass(s.getClass("stateActive"))||y.hasClass(s.getClass("stateDisabled")))&&y.removeClass(s.getClass("stateHover")))}).mousedown(function(){y.not("."+s.getClass("stateActive")).not("."+s.getClass("stateDisabled")).addClass(s.getClass("stateDown"))}).mouseup(function(){y.removeClass(s.getClass("stateDown"))}).hover(function(){y.not("."+s.getClass("stateActive")).not("."+s.getClass("stateDisabled")).addClass(s.getClass("stateHover"))},function(){y.removeClass(s.getClass("stateHover")).removeClass(s.getClass("stateDown"))}),o=o.add(y)))}),c&&o.first().addClass(s.getClass("cornerLeft")).end().last().addClass(s.getClass("cornerRight")).end(),o.length>1?(i=t("<div/>"),c&&i.addClass(s.getClass("buttonGroup")),i.append(o),r.append(i)):r.append(o)}),r}function a(t){g&&g.find("h2").text(t)}function l(t){g&&g.find(".fc-"+t+"-button").addClass(e.theme.getClass("stateActive"))}function u(t){g&&g.find(".fc-"+t+"-button").removeClass(e.theme.getClass("stateActive"))}function c(t){g&&g.find(".fc-"+t+"-button").prop("disabled",!0).addClass(e.theme.getClass("stateDisabled"))}function h(t){g&&g.find(".fc-"+t+"-button").prop("disabled",!1).removeClass(e.theme.getClass("stateDisabled"))}function d(){return p}var f=this;f.setToolbarOptions=i,f.render=s,f.removeElement=r,f.updateTitle=a,f.activateButton=l,f.deactivateButton=u,f.disableButton=c,f.enableButton=h,f.getViewsWithButtons=d,f.el=null;var g,p=[]}function Ht(t,e,n){var i;for(i=0;i<t.length;i++)if(!e(t[i].eventInstance.toLegacy(),n?n.toLegacy():null))return!1;return!0}function Mt(t,e){var n,i,s,r,o=e.toLegacy();for(n=0;n<t.length;n++){if(i=t[n].eventInstance,s=i.def,!1===(r=s.getOverlap()))return!1;if("function"==typeof r&&!r(i.toLegacy(),o))return!1}return!0}function xt(e,n){return null==n?e:t.isFunction(n)?e.filter(n):(n+="",e.filter(function(t){return t.id==n}))}function zt(e){t.each(He,function(t,n){null==e[t]&&(e[t]=n(e))})}function Ft(t){return e.localeData(t)||e.localeData("en")}function Pt(t,e){var n,i,s=[],r=e.startMs;for(t.sort(Bt),n=0;n<t.length;n++)i=t[n],i.startMs>r&&s.push(new Me(r,i.startMs)),i.endMs>r&&(r=i.endMs);return r<e.endMs&&s.push(new Me(r,e.endMs)),s}function Bt(t,e){return t.startMs-e.startMs}function kt(t,e){return t.getPrimitive()==e.getPrimitive()}function At(t,e){var n,i=[];for(n=0;n<t.length;n++)i.push.apply(i,t[n].buildInstances(e));return i}function Lt(t){return t.map(function(t){return new Ve(t.dateProfile.unzonedRange,t.def,t)})}function Ot(t){return t.map(function(t){return t.dateProfile.unzonedRange})}function Nt(t){return t.map(function(t){return t.componentFootprint})}var Vt=t.fullCalendar={version:"3.5.0",internalApiVersion:9},Ut=Vt.views={};t.fn.fullCalendar=function(e){var n=Array.prototype.slice.call(arguments,1),i=this;return this.each(function(s,r){var o,a=t(r),l=a.data("fullCalendar");"string"==typeof e?"getCalendar"===e?s||(i=l):"destroy"===e?l&&(l.destroy(),a.removeData("fullCalendar")):l?t.isFunction(l[e])?(o=l[e].apply(l,n),s||(i=o),"destroy"===e&&a.removeData("fullCalendar")):Vt.warn("'"+e+"' is an unknown FullCalendar method."):Vt.warn("Attempting to call a FullCalendar method on an element with no calendar."):l||(l=new Ee(a,e),a.data("fullCalendar",l),l.render())}),i};var Gt=["header","footer","buttonText","buttonIcons","themeButtonIcons"];Vt.applyAll=$,Vt.debounce=lt,Vt.isInt=ot,Vt.htmlEscape=tt,Vt.cssToStr=nt,Vt.proxy=at,Vt.capitaliseFirstLetter=st,Vt.getOuterRect=d,Vt.getClientRect=f,Vt.getContentRect=g,Vt.getScrollbarWidths=p;var Wt=null;Vt.preventDefault=R,Vt.intersectRects=I,Vt.parseFieldSpecs=z,Vt.compareByFieldSpecs=F,Vt.compareByFieldSpec=P,Vt.flexibleCompare=B,Vt.computeGreatestUnit=O,Vt.divideRangeByDuration=U,Vt.divideDurationByDuration=G,Vt.multiplyDuration=W,Vt.durationHasTime=_;var _t=["sun","mon","tue","wed","thu","fri","sat"],qt=["year","month","week","day","hour","minute","second","millisecond"];Vt.log=function(){var t=window.console;if(t&&t.log)return t.log.apply(t,arguments)},Vt.warn=function(){var t=window.console;return t&&t.warn?t.warn.apply(t,arguments):Vt.log.apply(Vt,arguments)};var Yt={}.hasOwnProperty;Vt.removeExact=K;var jt=/^\s*\d{4}-\d\d$/,Zt=/^\s*\d{4}-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?)?$/,Qt=e.fn,$t=t.extend({},Qt),Xt=e.momentProperties;Xt.push("_fullCalendar"),Xt.push("_ambigTime"),Xt.push("_ambigZone"),Vt.moment=function(){return ut(arguments)},Vt.moment.utc=function(){var t=ut(arguments,!0);return t.hasTime()&&t.utc(),t},Vt.moment.parseZone=function(){return ut(arguments,!0,!0)},Qt.week=Qt.weeks=function(t){var e=this._locale._fullCalendar_weekCalc;return null==t&&"function"==typeof e?e(this):"ISO"===e?$t.isoWeek.apply(this,arguments):$t.week.apply(this,arguments)},Qt.time=function(t){if(!this._fullCalendar)return $t.time.apply(this,arguments);if(null==t)return e.duration({hours:this.hours(),minutes:this.minutes(),seconds:this.seconds(),milliseconds:this.milliseconds()});this._ambigTime=!1,e.isDuration(t)||e.isMoment(t)||(t=e.duration(t));var n=0;return e.isDuration(t)&&(n=24*Math.floor(t.asDays())),this.hours(n+t.hours()).minutes(t.minutes()).seconds(t.seconds()).milliseconds(t.milliseconds())},Qt.stripTime=function(){return this._ambigTime||(this.utc(!0),this.set({hours:0,minutes:0,seconds:0,ms:0}),this._ambigTime=!0,this._ambigZone=!0),this},Qt.hasTime=function(){return!this._ambigTime},Qt.stripZone=function(){var t;return this._ambigZone||(t=this._ambigTime,this.utc(!0),this._ambigTime=t||!1,this._ambigZone=!0),this},Qt.hasZone=function(){return!this._ambigZone},Qt.local=function(t){return $t.local.call(this,this._ambigZone||t),this._ambigTime=!1,this._ambigZone=!1,this},Qt.utc=function(t){return $t.utc.call(this,t),this._ambigTime=!1,this._ambigZone=!1,this},Qt.utcOffset=function(t){return null!=t&&(this._ambigTime=!1,this._ambigZone=!1),$t.utcOffset.apply(this,arguments)},Qt.format=function(){return this._fullCalendar&&arguments[0]?Kt(this,arguments[0]):this._ambigTime?te(ct(this),"YYYY-MM-DD"):this._ambigZone?te(ct(this),"YYYY-MM-DD[T]HH:mm:ss"):this._fullCalendar?te(ct(this)):$t.format.apply(this,arguments)},Qt.toISOString=function(){return this._ambigTime?te(ct(this),"YYYY-MM-DD"):this._ambigZone?te(ct(this),"YYYY-MM-DD[T]HH:mm:ss"):this._fullCalendar?$t.toISOString.apply(ct(this),arguments):$t.toISOString.apply(this,arguments)},function(){function t(t,e){return c(s(e).fakeFormatString,t)}function e(t,e){return $t.format.call(t,e)}function n(t,e,n,r,o){var a;return t=Vt.moment.parseZone(t),e=Vt.moment.parseZone(e),a=t.localeData(),n=a.longDateFormat(n)||n,i(s(n),t,e,r||" - ",o)}function i(t,e,n,i,s){var r,o,a,l=t.sameUnits,u=e.clone().stripZone(),c=n.clone().stripZone(),f=h(t.fakeFormatString,e),g=h(t.fakeFormatString,n),p="",v="",m="",y="",w="";for(r=0;r<l.length&&(!l[r]||u.isSame(c,l[r]));r++)p+=f[r];for(o=l.length-1;o>r&&(!l[o]||u.isSame(c,l[o]))&&(o-1!==r||"."!==f[o]);o--)v=f[o]+v;for(a=r;a<=o;a++)m+=f[a],y+=g[a];return(m||y)&&(w=s?y+i+m:m+i+y),d(p+w+v)}function s(t){return D[t]||(D[t]=r(t))}function r(t){var e=o(t);return{fakeFormatString:l(e),sameUnits:u(e)}}function o(t){for(var e,n=[],i=/\[([^\]]*)\]|\(([^\)]*)\)|(LTS|LT|(\w)\4*o?)|([^\w\[\(]+)/g;e=i.exec(t);)e[1]?n.push.apply(n,a(e[1])):e[2]?n.push({maybe:o(e[2])}):e[3]?n.push({token:e[3]}):e[5]&&n.push.apply(n,a(e[5]));return n}function a(t){return". "===t?["."," "]:[t]}function l(t){var e,n,i=[];for(e=0;e<t.length;e++)n=t[e],"string"==typeof n?i.push("["+n+"]"):n.token?n.token in y?i.push(p+"["+n.token+"]"):i.push(n.token):n.maybe&&i.push(v+l(n.maybe)+v);return i.join(g)}function u(t){var e,n,i,s=[];for(e=0;e<t.length;e++)n=t[e],n.token?(i=w[n.token.charAt(0)],s.push(i?i.unit:"second")):n.maybe?s.push.apply(s,u(n.maybe)):s.push(null);return s}function c(t,e){return d(h(t,e).join(""))}function h(t,n){var i,s,r=[],o=e(n,t),a=o.split(g);for(i=0;i<a.length;i++)s=a[i],s.charAt(0)===p?r.push(y[s.substring(1)](n)):r.push(s);return r}function d(t){return t.replace(m,function(t,e){return e.match(/[1-9]/)?e:""})}function f(t){var e,n,i,s,r=o(t);for(e=0;e<r.length;e++)n=r[e],n.token&&(i=w[n.token.charAt(0)])&&(!s||i.value>s.value)&&(s=i);return s?s.unit:null}Vt.formatDate=t,Vt.formatRange=n,Vt.oldMomentFormat=e,Vt.queryMostGranularFormatUnit=f;var g="\v",p="",v="",m=new RegExp(v+"([^"+v+"]*)"+v,"g"),y={t:function(t){return e(t,"a").charAt(0)},T:function(t){return e(t,"A").charAt(0)}},w={Y:{value:1,unit:"year"},M:{value:2,unit:"month"},W:{value:3,unit:"week"},w:{value:3,unit:"week"},D:{value:4,unit:"day"},d:{value:4,unit:"day"}},D={}}();var Kt=Vt.formatDate,Jt=Vt.formatRange,te=Vt.oldMomentFormat;Vt.Class=ht,ht.extend=function(){var t,e={};for(t=0;t<arguments.length;t++)Z(arguments[t],e);return dt(this,e)},ht.mixin=function(t){Z(t,this.prototype)};var ee=Vt.EmitterMixin={on:function(e,n){return t(this).on(e,this._prepareIntercept(n)),this},one:function(e,n){return t(this).one(e,this._prepareIntercept(n)),this},_prepareIntercept:function(e){var n=function(t,n){return e.apply(n.context||this,n.args||[])};return e.guid||(e.guid=t.guid++),n.guid=e.guid,n},off:function(e,n){return t(this).off(e,n),this},trigger:function(e){var n=Array.prototype.slice.call(arguments,1);return t(this).triggerHandler(e,{args:n}),this},triggerWith:function(e,n,i){return t(this).triggerHandler(e,{context:n,args:i}),this},hasHandlers:function(e){var n=t._data(this,"events");return n&&n[e]&&n[e].length>0}},ne=Vt.ListenerMixin=function(){var e=0;return{listenerId:null,listenTo:function(e,n,i){if("object"==typeof n)for(var s in n)n.hasOwnProperty(s)&&this.listenTo(e,s,n[s]);else"string"==typeof n&&e.on(n+"."+this.getListenerNamespace(),t.proxy(i,this))},stopListeningTo:function(t,e){t.off((e||"")+"."+this.getListenerNamespace())},getListenerNamespace:function(){return null==this.listenerId&&(this.listenerId=e++),"_listener"+this.listenerId}}}(),ie={standardPropMap:{},applyRawProps:function(t){var e,n=this.standardPropMap,i={},s={};for(e in t)!0===n[e]?this[e]=t[e]:!1===n[e]?i[e]=t[e]:s[e]=t[e];return this.applyOtherRawProps(s),this.applyManualRawProps(i)},applyManualRawProps:function(t){return!0},applyOtherRawProps:function(t){}},se=function(t){var e=this.prototype;e.standardPropMap=Object.create(e.standardPropMap),Z(t,e.standardPropMap)},re=function(t,e){var n,i=this.prototype.standardPropMap;for(n in i)null!=t[n]&&!0===i[n]&&(e[n]=t[n])},oe=ht.extend(ee,ne,{_props:null,_watchers:null,_globalWatchArgs:null,constructor:function(){this._watchers={},this._props={},this.applyGlobalWatchers()},applyGlobalWatchers:function(){var t,e=this._globalWatchArgs||[];for(t=0;t<e.length;t++)this.watch.apply(this,e[t])},has:function(t){return t in this._props},get:function(t){return void 0===t?this._props:this._props[t]},set:function(t,e){var n;"string"==typeof t?(n={},n[t]=void 0===e?null:e):n=t,this.setProps(n)},reset:function(t){var e,n=this._props,i={};for(e in n)i[e]=void 0;for(e in t)i[e]=t[e];this.setProps(i)},unset:function(t){var e,n,i={};for(e="string"==typeof t?[t]:t,n=0;n<e.length;n++)i[e[n]]=void 0;this.setProps(i)},setProps:function(t){var e,n,i={},s=0;for(e in t)"object"!=typeof(n=t[e])&&n===this._props[e]||(i[e]=n,s++);if(s){this.trigger("before:batchChange",i);for(e in i)n=i[e],this.trigger("before:change",e,n),this.trigger("before:change:"+e,n);for(e in i)n=i[e],void 0===n?delete this._props[e]:this._props[e]=n,this.trigger("change:"+e,n),this.trigger("change",e,n);this.trigger("batchChange",i)}},watch:function(t,e,n,i){var s=this;this.unwatch(t),this._watchers[t]=this._watchDeps(e,function(e){var i=n.call(s,e);i&&i.then?(s.unset(t),i.then(function(e){s.set(t,e)})):s.set(t,i)},function(){s.unset(t),i&&i.call(s)})},unwatch:function(t){var e=this._watchers[t];e&&(delete this._watchers[t],e.teardown())},_watchDeps:function(t,e,n){function i(t,e,i){1===++a&&u===l&&(d=!0,n(),d=!1)}function s(t,n,i){void 0===n?(i||void 0===c[t]||u--,delete c[t]):(i||void 0!==c[t]||u++,c[t]=n),--a||u===l&&(d||e(c))}function r(t,e){o.on(t,e),h.push([t,e])}var o=this,a=0,l=t.length,u=0,c={},h=[],d=!1;return t.forEach(function(t){var e=!1;"?"===t.charAt(0)&&(t=t.substring(1),e=!0),r("before:change:"+t,function(n){i(t,n,e)}),r("change:"+t,function(n){s(t,n,e)})}),t.forEach(function(t){var e=!1;"?"===t.charAt(0)&&(t=t.substring(1),e=!0),o.has(t)?(c[t]=o.get(t),u++):e&&u++}),u===l&&e(c),{teardown:function(){for(var t=0;t<h.length;t++)o.off(h[t][0],h[t][1]);h=null,u===l&&n()},flash:function(){u===l&&(n(),e(c))}}},flash:function(t){var e=this._watchers[t];e&&e.flash()}});oe.watch=function(){var t=this.prototype;t._globalWatchArgs||(t._globalWatchArgs=[]),t._globalWatchArgs.push(arguments)},Vt.Model=oe;var ae={construct:function(e){var n=t.Deferred(),i=n.promise();return"function"==typeof e&&e(function(t){n.resolve(t),ft(i,t)},function(){n.reject(),gt(i)}),i},resolve:function(e){var n=t.Deferred().resolve(e),i=n.promise();return ft(i,e),i},reject:function(){var e=t.Deferred().reject(),n=e.promise();return gt(n),n}};Vt.Promise=ae;var le=ht.extend(ee,{q:null,isPaused:!1,isRunning:!1,constructor:function(){this.q=[]},queue:function(){this.q.push.apply(this.q,arguments),this.tryStart()},pause:function(){this.isPaused=!0},resume:function(){this.isPaused=!1,this.tryStart()},tryStart:function(){!this.isRunning&&this.canRunNext()&&(this.isRunning=!0,this.trigger("start"),this.runNext())},canRunNext:function(){return!this.isPaused&&this.q.length},runNext:function(){this.runTask(this.q.shift())},runTask:function(t){this.runTaskFunc(t)},runTaskFunc:function(t){function e(){n.canRunNext()?n.runNext():(n.isRunning=!1,n.trigger("stop"))}var n=this,i=t();i&&i.then?i.then(e):e()}});Vt.TaskQueue=le;var ue=le.extend({waitsByNamespace:null,waitNamespace:null,waitId:null,constructor:function(t){le.call(this),this.waitsByNamespace=t||{}},queue:function(t,e,n){var i,s={func:t,namespace:e,type:n};e&&(i=this.waitsByNamespace[e]),this.waitNamespace&&(e===this.waitNamespace&&null!=i?this.delayWait(i):(this.clearWait(),this.tryStart())),this.compoundTask(s)&&(this.waitNamespace||null==i?this.tryStart():this.startWait(e,i))},startWait:function(t,e){this.waitNamespace=t,this.spawnWait(e)},delayWait:function(t){clearTimeout(this.waitId),this.spawnWait(t)},spawnWait:function(t){var e=this;this.waitId=setTimeout(function(){e.waitNamespace=null,e.tryStart()},t)},clearWait:function(){this.waitNamespace&&(clearTimeout(this.waitId),this.waitId=null,this.waitNamespace=null)},canRunNext:function(){if(!le.prototype.canRunNext.apply(this,arguments))return!1;if(this.waitNamespace){for(var t=this.q,e=0;e<t.length;e++)if(t[e].namespace!==this.waitNamespace)return!0;return!1}return!0},runTask:function(t){this.runTaskFunc(t.func)},compoundTask:function(t){var e,n,i=this.q,s=!0;if(t.namespace&&("destroy"===t.type||"init"===t.type)){for(e=i.length-1;e>=0;e--)n=i[e],n.namespace!==t.namespace||"add"!==n.type&&"remove"!==n.type||i.splice(e,1);"destroy"===t.type?i.length&&(n=i[i.length-1],n.namespace===t.namespace&&("init"===n.type?(s=!1,i.pop()):"destroy"===n.type&&(s=!1))):"init"===t.type&&i.length&&(n=i[i.length-1],n.namespace===t.namespace&&"init"===n.type&&i.pop())}return s&&i.push(t),s}});Vt.RenderQueue=ue;var ce=ht.extend(ne,{isHidden:!0,options:null,el:null,margin:10,constructor:function(t){this.options=t||{}},show:function(){this.isHidden&&(this.el||this.render(),this.el.show(),this.position(),this.isHidden=!1,this.trigger("show"))},hide:function(){this.isHidden||(this.el.hide(),this.isHidden=!0,this.trigger("hide"))},render:function(){var e=this,n=this.options;this.el=t('<div class="fc-popover"/>').addClass(n.className||"").css({top:0,left:0}).append(n.content).appendTo(n.parentEl),this.el.on("click",".fc-close",function(){e.hide()}),n.autoHide&&this.listenTo(t(document),"mousedown",this.documentMousedown)},documentMousedown:function(e){this.el&&!t(e.target).closest(this.el).length&&this.hide()},removeElement:function(){this.hide(),this.el&&(this.el.remove(),this.el=null),this.stopListeningTo(t(document),"mousedown")},position:function(){var e,n,i,s,r,o=this.options,a=this.el.offsetParent().offset(),l=this.el.outerWidth(),u=this.el.outerHeight(),c=t(window),d=h(this.el);s=o.top||0,r=void 0!==o.left?o.left:void 0!==o.right?o.right-l:0,d.is(window)||d.is(document)?(d=c,e=0,n=0):(i=d.offset(),e=i.top,n=i.left),e+=c.scrollTop(),n+=c.scrollLeft(),!1!==o.viewportConstrain&&(s=Math.min(s,e+d.outerHeight()-u-this.margin),s=Math.max(s,e+this.margin),r=Math.min(r,n+d.outerWidth()-l-this.margin),r=Math.max(r,n+this.margin)),this.el.css({top:s-a.top,left:r-a.left})},trigger:function(t){this.options[t]&&this.options[t].apply(this,Array.prototype.slice.call(arguments,1))}}),he=Vt.CoordCache=ht.extend({els:null,forcedOffsetParentEl:null,origin:null,boundingRect:null,isHorizontal:!1,isVertical:!1,lefts:null,rights:null,tops:null,bottoms:null,constructor:function(e){this.els=t(e.els),this.isHorizontal=e.isHorizontal,this.isVertical=e.isVertical,this.forcedOffsetParentEl=e.offsetParent?t(e.offsetParent):null},build:function(){var t=this.forcedOffsetParentEl;!t&&this.els.length>0&&(t=this.els.eq(0).offsetParent()),this.origin=t?t.offset():null,this.boundingRect=this.queryBoundingRect(),this.isHorizontal&&this.buildElHorizontals(),this.isVertical&&this.buildElVerticals()},clear:function(){this.origin=null,this.boundingRect=null,this.lefts=null,this.rights=null,this.tops=null,this.bottoms=null},ensureBuilt:function(){this.origin||this.build()},buildElHorizontals:function(){var e=[],n=[];this.els.each(function(i,s){var r=t(s),o=r.offset().left,a=r.outerWidth();e.push(o),n.push(o+a)}),this.lefts=e,this.rights=n},buildElVerticals:function(){var e=[],n=[];this.els.each(function(i,s){var r=t(s),o=r.offset().top,a=r.outerHeight();e.push(o),n.push(o+a)}),this.tops=e,this.bottoms=n},getHorizontalIndex:function(t){this.ensureBuilt();var e,n=this.lefts,i=this.rights,s=n.length;for(e=0;e<s;e++)if(t>=n[e]&&t<i[e])return e},getVerticalIndex:function(t){this.ensureBuilt();var e,n=this.tops,i=this.bottoms,s=n.length;for(e=0;e<s;e++)if(t>=n[e]&&t<i[e])return e},getLeftOffset:function(t){return this.ensureBuilt(),this.lefts[t]},getLeftPosition:function(t){return this.ensureBuilt(),this.lefts[t]-this.origin.left},getRightOffset:function(t){return this.ensureBuilt(),this.rights[t]},getRightPosition:function(t){return this.ensureBuilt(),this.rights[t]-this.origin.left},getWidth:function(t){return this.ensureBuilt(),this.rights[t]-this.lefts[t]},getTopOffset:function(t){return this.ensureBuilt(),this.tops[t]},getTopPosition:function(t){return this.ensureBuilt(),this.tops[t]-this.origin.top},getBottomOffset:function(t){return this.ensureBuilt(),this.bottoms[t]},getBottomPosition:function(t){return this.ensureBuilt(),this.bottoms[t]-this.origin.top},getHeight:function(t){return this.ensureBuilt(),this.bottoms[t]-this.tops[t]},queryBoundingRect:function(){var t;return this.els.length>0&&(t=h(this.els.eq(0)),!t.is(document))?f(t):null},isPointInBounds:function(t,e){return this.isLeftInBounds(t)&&this.isTopInBounds(e)},isLeftInBounds:function(t){return!this.boundingRect||t>=this.boundingRect.left&&t<this.boundingRect.right},isTopInBounds:function(t){return!this.boundingRect||t>=this.boundingRect.top&&t<this.boundingRect.bottom}}),de=Vt.DragListener=ht.extend(ne,{options:null,subjectEl:null,originX:null,originY:null,scrollEl:null,isInteracting:!1,isDistanceSurpassed:!1,isDelayEnded:!1,isDragging:!1,isTouch:!1,isGeneric:!1,delay:null,delayTimeoutId:null,minDistance:null,shouldCancelTouchScroll:!0,scrollAlwaysKills:!1,constructor:function(t){this.options=t||{}},startInteraction:function(e,n){if("mousedown"===e.type){if(ge.get().shouldIgnoreMouse())return;if(!D(e))return;e.preventDefault()}this.isInteracting||(n=n||{},this.delay=J(n.delay,this.options.delay,0),this.minDistance=J(n.distance,this.options.distance,0),this.subjectEl=this.options.subjectEl,C(t("body")),this.isInteracting=!0,this.isTouch=E(e),this.isGeneric="dragstart"===e.type,this.isDelayEnded=!1,this.isDistanceSurpassed=!1,this.originX=b(e),this.originY=S(e),this.scrollEl=h(t(e.target)),this.bindHandlers(),this.initAutoScroll(),this.handleInteractionStart(e),this.startDelay(e),this.minDistance||this.handleDistanceSurpassed(e))},handleInteractionStart:function(t){this.trigger("interactionStart",t)},endInteraction:function(e,n){this.isInteracting&&(this.endDrag(e),this.delayTimeoutId&&(clearTimeout(this.delayTimeoutId),this.delayTimeoutId=null),this.destroyAutoScroll(),this.unbindHandlers(),this.isInteracting=!1,this.handleInteractionEnd(e,n),T(t("body")))},handleInteractionEnd:function(t,e){this.trigger("interactionEnd",t,e||!1)},bindHandlers:function(){var e=ge.get();this.isGeneric?this.listenTo(t(document),{drag:this.handleMove,dragstop:this.endInteraction}):this.isTouch?this.listenTo(e,{touchmove:this.handleTouchMove,touchend:this.endInteraction,scroll:this.handleTouchScroll}):this.listenTo(e,{mousemove:this.handleMouseMove,mouseup:this.endInteraction}),this.listenTo(e,{selectstart:R,contextmenu:R})},unbindHandlers:function(){this.stopListeningTo(ge.get()),this.stopListeningTo(t(document))},startDrag:function(t,e){this.startInteraction(t,e),this.isDragging||(this.isDragging=!0,this.handleDragStart(t))},handleDragStart:function(t){this.trigger("dragStart",t)},handleMove:function(t){var e=b(t)-this.originX,n=S(t)-this.originY,i=this.minDistance;this.isDistanceSurpassed||e*e+n*n>=i*i&&this.handleDistanceSurpassed(t),this.isDragging&&this.handleDrag(e,n,t)},handleDrag:function(t,e,n){this.trigger("drag",t,e,n),
	this.updateAutoScroll(n)},endDrag:function(t){this.isDragging&&(this.isDragging=!1,this.handleDragEnd(t))},handleDragEnd:function(t){this.trigger("dragEnd",t)},startDelay:function(t){var e=this;this.delay?this.delayTimeoutId=setTimeout(function(){e.handleDelayEnd(t)},this.delay):this.handleDelayEnd(t)},handleDelayEnd:function(t){this.isDelayEnded=!0,this.isDistanceSurpassed&&this.startDrag(t)},handleDistanceSurpassed:function(t){this.isDistanceSurpassed=!0,this.isDelayEnded&&this.startDrag(t)},handleTouchMove:function(t){this.isDragging&&this.shouldCancelTouchScroll&&t.preventDefault(),this.handleMove(t)},handleMouseMove:function(t){this.handleMove(t)},handleTouchScroll:function(t){this.isDragging&&!this.scrollAlwaysKills||this.endInteraction(t,!0)},trigger:function(t){this.options[t]&&this.options[t].apply(this,Array.prototype.slice.call(arguments,1)),this["_"+t]&&this["_"+t].apply(this,Array.prototype.slice.call(arguments,1))}});de.mixin({isAutoScroll:!1,scrollBounds:null,scrollTopVel:null,scrollLeftVel:null,scrollIntervalId:null,scrollSensitivity:30,scrollSpeed:200,scrollIntervalMs:50,initAutoScroll:function(){var t=this.scrollEl;this.isAutoScroll=this.options.scroll&&t&&!t.is(window)&&!t.is(document),this.isAutoScroll&&this.listenTo(t,"scroll",lt(this.handleDebouncedScroll,100))},destroyAutoScroll:function(){this.endAutoScroll(),this.isAutoScroll&&this.stopListeningTo(this.scrollEl,"scroll")},computeScrollBounds:function(){this.isAutoScroll&&(this.scrollBounds=d(this.scrollEl))},updateAutoScroll:function(t){var e,n,i,s,r=this.scrollSensitivity,o=this.scrollBounds,a=0,l=0;o&&(e=(r-(S(t)-o.top))/r,n=(r-(o.bottom-S(t)))/r,i=(r-(b(t)-o.left))/r,s=(r-(o.right-b(t)))/r,e>=0&&e<=1?a=e*this.scrollSpeed*-1:n>=0&&n<=1&&(a=n*this.scrollSpeed),i>=0&&i<=1?l=i*this.scrollSpeed*-1:s>=0&&s<=1&&(l=s*this.scrollSpeed)),this.setScrollVel(a,l)},setScrollVel:function(t,e){this.scrollTopVel=t,this.scrollLeftVel=e,this.constrainScrollVel(),!this.scrollTopVel&&!this.scrollLeftVel||this.scrollIntervalId||(this.scrollIntervalId=setInterval(at(this,"scrollIntervalFunc"),this.scrollIntervalMs))},constrainScrollVel:function(){var t=this.scrollEl;this.scrollTopVel<0?t.scrollTop()<=0&&(this.scrollTopVel=0):this.scrollTopVel>0&&t.scrollTop()+t[0].clientHeight>=t[0].scrollHeight&&(this.scrollTopVel=0),this.scrollLeftVel<0?t.scrollLeft()<=0&&(this.scrollLeftVel=0):this.scrollLeftVel>0&&t.scrollLeft()+t[0].clientWidth>=t[0].scrollWidth&&(this.scrollLeftVel=0)},scrollIntervalFunc:function(){var t=this.scrollEl,e=this.scrollIntervalMs/1e3;this.scrollTopVel&&t.scrollTop(t.scrollTop()+this.scrollTopVel*e),this.scrollLeftVel&&t.scrollLeft(t.scrollLeft()+this.scrollLeftVel*e),this.constrainScrollVel(),this.scrollTopVel||this.scrollLeftVel||this.endAutoScroll()},endAutoScroll:function(){this.scrollIntervalId&&(clearInterval(this.scrollIntervalId),this.scrollIntervalId=null,this.handleScrollEnd())},handleDebouncedScroll:function(){this.scrollIntervalId||this.handleScrollEnd()},handleScrollEnd:function(){}});var fe=de.extend({component:null,origHit:null,hit:null,coordAdjust:null,constructor:function(t,e){de.call(this,e),this.component=t},handleInteractionStart:function(t){var e,n,i,s=this.subjectEl;this.component.hitsNeeded(),this.computeScrollBounds(),t?(n={left:b(t),top:S(t)},i=n,s&&(e=d(s),i=H(i,e)),this.origHit=this.queryHit(i.left,i.top),s&&this.options.subjectCenter&&(this.origHit&&(e=I(this.origHit,e)||e),i=M(e)),this.coordAdjust=x(i,n)):(this.origHit=null,this.coordAdjust=null),de.prototype.handleInteractionStart.apply(this,arguments)},handleDragStart:function(t){var e;de.prototype.handleDragStart.apply(this,arguments),(e=this.queryHit(b(t),S(t)))&&this.handleHitOver(e)},handleDrag:function(t,e,n){var i;de.prototype.handleDrag.apply(this,arguments),i=this.queryHit(b(n),S(n)),pt(i,this.hit)||(this.hit&&this.handleHitOut(),i&&this.handleHitOver(i))},handleDragEnd:function(){this.handleHitDone(),de.prototype.handleDragEnd.apply(this,arguments)},handleHitOver:function(t){var e=pt(t,this.origHit);this.hit=t,this.trigger("hitOver",this.hit,e,this.origHit)},handleHitOut:function(){this.hit&&(this.trigger("hitOut",this.hit),this.handleHitDone(),this.hit=null)},handleHitDone:function(){this.hit&&this.trigger("hitDone",this.hit)},handleInteractionEnd:function(){de.prototype.handleInteractionEnd.apply(this,arguments),this.origHit=null,this.hit=null,this.component.hitsNotNeeded()},handleScrollEnd:function(){de.prototype.handleScrollEnd.apply(this,arguments),this.isDragging&&(this.component.releaseHits(),this.component.prepareHits())},queryHit:function(t,e){return this.coordAdjust&&(t+=this.coordAdjust.left,e+=this.coordAdjust.top),this.component.queryHit(t,e)}});Vt.touchMouseIgnoreWait=500;var ge=ht.extend(ne,ee,{isTouching:!1,mouseIgnoreDepth:0,handleScrollProxy:null,bind:function(){var e=this;this.listenTo(t(document),{touchstart:this.handleTouchStart,touchcancel:this.handleTouchCancel,touchend:this.handleTouchEnd,mousedown:this.handleMouseDown,mousemove:this.handleMouseMove,mouseup:this.handleMouseUp,click:this.handleClick,selectstart:this.handleSelectStart,contextmenu:this.handleContextMenu}),window.addEventListener("touchmove",this.handleTouchMoveProxy=function(n){e.handleTouchMove(t.Event(n))},{passive:!1}),window.addEventListener("scroll",this.handleScrollProxy=function(n){e.handleScroll(t.Event(n))},!0)},unbind:function(){this.stopListeningTo(t(document)),window.removeEventListener("touchmove",this.handleTouchMoveProxy),window.removeEventListener("scroll",this.handleScrollProxy,!0)},handleTouchStart:function(t){this.stopTouch(t,!0),this.isTouching=!0,this.trigger("touchstart",t)},handleTouchMove:function(t){this.isTouching&&this.trigger("touchmove",t)},handleTouchCancel:function(t){this.isTouching&&(this.trigger("touchcancel",t),this.stopTouch(t))},handleTouchEnd:function(t){this.stopTouch(t)},handleMouseDown:function(t){this.shouldIgnoreMouse()||this.trigger("mousedown",t)},handleMouseMove:function(t){this.shouldIgnoreMouse()||this.trigger("mousemove",t)},handleMouseUp:function(t){this.shouldIgnoreMouse()||this.trigger("mouseup",t)},handleClick:function(t){this.shouldIgnoreMouse()||this.trigger("click",t)},handleSelectStart:function(t){this.trigger("selectstart",t)},handleContextMenu:function(t){this.trigger("contextmenu",t)},handleScroll:function(t){this.trigger("scroll",t)},stopTouch:function(t,e){this.isTouching&&(this.isTouching=!1,this.trigger("touchend",t),e||this.startTouchMouseIgnore())},startTouchMouseIgnore:function(){var t=this,e=Vt.touchMouseIgnoreWait;e&&(this.mouseIgnoreDepth++,setTimeout(function(){t.mouseIgnoreDepth--},e))},shouldIgnoreMouse:function(){return this.isTouching||Boolean(this.mouseIgnoreDepth)}});!function(){var t=null,e=0;ge.get=function(){return t||(t=new ge,t.bind()),t},ge.needed=function(){ge.get(),e++},ge.unneeded=function(){--e||(t.unbind(),t=null)}}();var pe=ht.extend(ne,{options:null,sourceEl:null,el:null,parentEl:null,top0:null,left0:null,y0:null,x0:null,topDelta:null,leftDelta:null,isFollowing:!1,isHidden:!1,isAnimating:!1,constructor:function(e,n){this.options=n=n||{},this.sourceEl=e,this.parentEl=n.parentEl?t(n.parentEl):e.parent()},start:function(e){this.isFollowing||(this.isFollowing=!0,this.y0=S(e),this.x0=b(e),this.topDelta=0,this.leftDelta=0,this.isHidden||this.updatePosition(),E(e)?this.listenTo(t(document),"touchmove",this.handleMove):this.listenTo(t(document),"mousemove",this.handleMove))},stop:function(e,n){function i(){s.isAnimating=!1,s.removeElement(),s.top0=s.left0=null,n&&n()}var s=this,r=this.options.revertDuration;this.isFollowing&&!this.isAnimating&&(this.isFollowing=!1,this.stopListeningTo(t(document)),e&&r&&!this.isHidden?(this.isAnimating=!0,this.el.animate({top:this.top0,left:this.left0},{duration:r,complete:i})):i())},getEl:function(){var t=this.el;return t||(t=this.el=this.sourceEl.clone().addClass(this.options.additionalClass||"").css({position:"absolute",visibility:"",display:this.isHidden?"none":"",margin:0,right:"auto",bottom:"auto",width:this.sourceEl.width(),height:this.sourceEl.height(),opacity:this.options.opacity||"",zIndex:this.options.zIndex}),t.addClass("fc-unselectable"),t.appendTo(this.parentEl)),t},removeElement:function(){this.el&&(this.el.remove(),this.el=null)},updatePosition:function(){var t,e;this.getEl(),null===this.top0&&(t=this.sourceEl.offset(),e=this.el.offsetParent().offset(),this.top0=t.top-e.top,this.left0=t.left-e.left),this.el.css({top:this.top0+this.topDelta,left:this.left0+this.leftDelta})},handleMove:function(t){this.topDelta=S(t)-this.y0,this.leftDelta=b(t)-this.x0,this.isHidden||this.updatePosition()},hide:function(){this.isHidden||(this.isHidden=!0,this.el&&this.el.hide())},show:function(){this.isHidden&&(this.isHidden=!1,this.updatePosition(),this.getEl().show())}}),ve=oe.extend({children:null,el:null,isRTL:!1,nextDayThreshold:null,constructor:function(){oe.call(this),this.children=[],this.nextDayThreshold=e.duration(this.opt("nextDayThreshold")),this.isRTL=this.opt("isRTL")},addChild:function(t){this.children.push(t)},opt:function(t){},publiclyTrigger:function(){var t=this._getCalendar();return t.publiclyTrigger.apply(t,arguments)},hasPublicHandlers:function(){var t=this._getCalendar();return t.hasPublicHandlers.apply(t,arguments)},setElement:function(t){this.el=t,this.bindGlobalHandlers(),this.renderSkeleton()},removeElement:function(){this.unrenderSkeleton(),this.unbindGlobalHandlers(),this.el.remove()},bindGlobalHandlers:function(){},unbindGlobalHandlers:function(){},renderSkeleton:function(){},unrenderSkeleton:function(){},renderDates:function(){},unrenderDates:function(){},getNowIndicatorUnit:function(){},renderNowIndicator:function(t){this.callChildren("renderNowIndicator",t)},unrenderNowIndicator:function(){this.callChildren("unrenderNowIndicator")},renderBusinessHours:function(){this.callChildren("renderBusinessHours")},unrenderBusinessHours:function(){this.callChildren("unrenderBusinessHours")},renderEventsPayload:function(t){this.callChildren("renderEventsPayload",t)},unrenderEvents:function(){this.callChildren("unrenderEvents")},getEventSegs:function(){var t,e=this.children,n=[];for(t=0;t<e.length;t++)n.push.apply(n,e[t].getEventSegs());return n},renderDrag:function(t,e){var n,i,s=null,r=this.children;for(n=0;n<r.length;n++)(i=r[n].renderDrag(t,e))&&(s=s?s.add(i):i);return s},unrenderDrag:function(){this.callChildren("unrenderDrag")},renderSelectionFootprint:function(t){this.callChildren("renderSelectionFootprint",t)},unrenderSelection:function(){this.callChildren("unrenderSelection")},hitsNeeded:function(){this.callChildren("hitsNeeded")},hitsNotNeeded:function(){this.callChildren("hitsNotNeeded")},prepareHits:function(){this.callChildren("prepareHits")},releaseHits:function(){this.callChildren("releaseHits")},queryHit:function(t,e){var n,i,s=this.children;for(n=0;n<s.length&&!(i=s[n].queryHit(t,e));n++);return i},isEventDefDraggable:function(t){return this.isEventDefStartEditable(t)},isEventDefStartEditable:function(t){var e=t.isStartExplicitlyEditable();return null==e&&null==(e=this.opt("eventStartEditable"))&&(e=this.isEventDefGenerallyEditable(t)),e},isEventDefGenerallyEditable:function(t){var e=t.isExplicitlyEditable();return null==e&&(e=this.opt("editable")),e},isEventDefResizableFromStart:function(t){return this.opt("eventResizableFromStart")&&this.isEventDefResizable(t)},isEventDefResizableFromEnd:function(t){return this.isEventDefResizable(t)},isEventDefResizable:function(t){var e=t.isDurationExplicitlyEditable();return null==e&&null==(e=this.opt("eventDurationEditable"))&&(e=this.isEventDefGenerallyEditable(t)),e},renderFgSegs:function(t){},unrenderFgSegs:function(){},renderFgSegEls:function(e,n){var i,s=this,r=this.hasPublicHandlers("eventRender"),o="",a=[];if(e.length){for(i=0;i<e.length;i++)o+=this.fgSegHtml(e[i],n);t(o).each(function(n,i){var o=e[n],l=t(i);r&&(l=s.filterEventRenderEl(o.footprint,l)),l&&(l.data("fc-seg",o),o.el=l,a.push(o))})}return a},fgSegHtml:function(t,e){},filterEventRenderEl:function(e,n){var i=e.getEventLegacy(),s=this.publiclyTrigger("eventRender",{context:i,args:[i,n,this._getView()]});return!1===s?n=null:s&&!0!==s&&(n=t(s)),n},buildGotoAnchorHtml:function(e,n,i){var s,r,o,a;return t.isPlainObject(e)?(s=e.date,r=e.type,o=e.forceOff):s=e,s=Vt.moment(s),a={date:s.format("YYYY-MM-DD"),type:r||"day"},"string"==typeof n&&(i=n,n=null),n=n?" "+it(n):"",i=i||"",!o&&this.opt("navLinks")?"<a"+n+' data-goto="'+tt(JSON.stringify(a))+'">'+i+"</a>":"<span"+n+">"+i+"</span>"},formatRange:function(t,e,n,i){var s=t.end;return e&&(s=s.clone().subtract(1)),Jt(t.start,s,n,i,this.isRTL)},getAllDayHtml:function(){return this.opt("allDayHtml")||tt(this.opt("allDayText"))},getDayClasses:function(t,e){var n,i=this._getView(),s=[];return i.activeUnzonedRange.containsDate(t)?(s.push("fc-"+_t[t.day()]),i.isDateInOtherMonth(t)&&s.push("fc-other-month"),n=i.calendar.getNow(),t.isSame(n,"day")?(s.push("fc-today"),!0!==e&&s.push(i.calendar.theme.getClass("today"))):t<n?s.push("fc-past"):s.push("fc-future")):s.push("fc-disabled-day"),s},computeDayRange:function(t){var e=this._getCalendar(),n=e.msToUtcMoment(t.startMs,!0),i=e.msToUtcMoment(t.endMs),s=+i.time(),r=i.clone().stripTime();return s&&s>=this.nextDayThreshold&&r.add(1,"days"),r<=n&&(r=n.clone().add(1,"days")),{start:n,end:r}},isMultiDayRange:function(t){var e=this.computeDayRange(t);return e.end.diff(e.start,"days")>1},callChildren:function(t){var e,n,i=Array.prototype.slice.call(arguments,1),s=this.children;for(e=0;e<s.length;e++)n=s[e],n[t].apply(n,i)},_getCalendar:function(){return this.calendar||this.view.calendar},_getView:function(){return this.view}}),me=Vt.Grid=ve.extend({hasDayInteractions:!0,view:null,isRTL:null,unzonedRange:null,hitsNeededDepth:0,dayClickListener:null,daySelectListener:null,segDragListener:null,segResizeListener:null,externalDragListener:null,constructor:function(t){this.view=t,ve.call(this),this.initFillInternals(),this.dayClickListener=this.buildDayClickListener(),this.daySelectListener=this.buildDaySelectListener()},opt:function(t){return this.view.opt(t)},setRange:function(t){this.unzonedRange=t,this.rangeUpdated(),this.processRangeOptions()},rangeUpdated:function(){},processRangeOptions:function(){var t,e;this.eventTimeFormat=this.opt("eventTimeFormat")||this.opt("timeFormat")||this.computeEventTimeFormat(),t=this.opt("displayEventTime"),null==t&&(t=this.computeDisplayEventTime()),e=this.opt("displayEventEnd"),null==e&&(e=this.computeDisplayEventEnd()),this.displayEventTime=t,this.displayEventEnd=e},hitsNeeded:function(){this.hitsNeededDepth++||this.prepareHits()},hitsNotNeeded:function(){this.hitsNeededDepth&&!--this.hitsNeededDepth&&this.releaseHits()},getSafeHitFootprint:function(t){var e=this.getHitFootprint(t);return this.view.activeUnzonedRange.containsRange(e.unzonedRange)?e:null},getHitFootprint:function(t){},getHitEl:function(t){},setElement:function(t){ve.prototype.setElement.apply(this,arguments),this.hasDayInteractions&&(C(t),this.bindDayHandler("touchstart",this.dayTouchStart),this.bindDayHandler("mousedown",this.dayMousedown)),this.bindSegHandlers()},bindDayHandler:function(e,n){var i=this;this.el.on(e,function(e){if(!t(e.target).is(i.segSelector+","+i.segSelector+" *,.fc-more,a[data-goto]"))return n.call(i,e)})},removeElement:function(){ve.prototype.removeElement.apply(this,arguments),this.clearDragListeners()},bindGlobalHandlers:function(){ve.prototype.bindGlobalHandlers.apply(this,arguments),this.listenTo(t(document),{dragstart:this.externalDragStart,sortstart:this.externalDragStart})},unbindGlobalHandlers:function(){ve.prototype.unbindGlobalHandlers.apply(this,arguments),this.stopListeningTo(t(document))},dayMousedown:function(t){ge.get().shouldIgnoreMouse()||(this.dayClickListener.startInteraction(t),this.opt("selectable")&&this.daySelectListener.startInteraction(t,{distance:this.opt("selectMinDistance")}))},dayTouchStart:function(t){var e,n=this.view;n.isSelected||n.selectedEvent||(e=this.opt("selectLongPressDelay"),null==e&&(e=this.opt("longPressDelay")),this.dayClickListener.startInteraction(t),this.opt("selectable")&&this.daySelectListener.startInteraction(t,{delay:e}))},clearDragListeners:function(){this.dayClickListener.endInteraction(),this.daySelectListener.endInteraction(),this.segDragListener&&this.segDragListener.endInteraction(),this.segResizeListener&&this.segResizeListener.endInteraction(),this.externalDragListener&&this.externalDragListener.endInteraction()},renderHighlight:function(t){this.renderFill("highlight",this.componentFootprintToSegs(t))},unrenderHighlight:function(){this.unrenderFill("highlight")},eventRangesToEventFootprints:function(t){var e,n=[];for(e=0;e<t.length;e++)n.push.apply(n,this.eventRangeToEventFootprints(t[e]));return n},eventRangeToEventFootprints:function(t){return[new Ue(new xe(t.unzonedRange,t.eventDef.isAllDay()),t.eventDef,t.eventInstance)]},eventFootprintsToSegs:function(t){var e,n=[];for(e=0;e<t.length;e++)n.push.apply(n,this.eventFootprintToSegs(t[e]));return n},eventFootprintToSegs:function(t,e){var n,i,s,r=t.componentFootprint.unzonedRange;for(e&&(r=r.intersect(e)),n=this.componentFootprintToSegs(t.componentFootprint),i=0;i<n.length;i++)s=n[i],r.isStart||(s.isStart=!1),r.isEnd||(s.isEnd=!1),s.footprint=t;return n},componentFootprintToSegs:function(t){}});me.mixin({buildDayClickListener:function(){var t,e=this,n=new fe(this,{scroll:this.opt("dragScroll"),interactionStart:function(){t=n.origHit},hitOver:function(e,n,i){n||(t=null)},hitOut:function(){t=null},interactionEnd:function(n,i){var s;!i&&t&&(s=e.getSafeHitFootprint(t))&&e.view.triggerDayClick(s,e.getHitEl(t),n)}});return n.shouldCancelTouchScroll=!1,n.scrollAlwaysKills=!0,n}}),me.mixin({buildDaySelectListener:function(){var t,e=this;return new fe(this,{scroll:this.opt("dragScroll"),interactionStart:function(){t=null},dragStart:function(){e.view.unselect()},hitOver:function(n,i,s){var o,a;s&&(o=e.getSafeHitFootprint(s),a=e.getSafeHitFootprint(n),t=o&&a?e.computeSelection(o,a):null,t?e.renderSelectionFootprint(t):!1===t&&r())},hitOut:function(){t=null,e.unrenderSelection()},hitDone:function(){o()},interactionEnd:function(n,i){!i&&t&&e.view.reportSelection(t,n)}})},renderSelectionFootprint:function(t){this.renderHighlight(t)},unrenderSelection:function(){this.unrenderHighlight()},computeSelection:function(t,e){var n=this.computeSelectionFootprint(t,e);return!(n&&!this.isSelectionFootprintAllowed(n))&&n},computeSelectionFootprint:function(t,e){var n=[t.unzonedRange.startMs,t.unzonedRange.endMs,e.unzonedRange.startMs,e.unzonedRange.endMs];return n.sort(rt),new xe(new Me(n[0],n[3]),t.isAllDay)},isSelectionFootprintAllowed:function(t){return this.view.validUnzonedRange.containsRange(t.unzonedRange)&&this.view.calendar.isSelectionFootprintAllowed(t)}}),me.mixin({businessHoursSegClasses:function(t){return["fc-nonbusiness","fc-bgevent"]},buildBusinessHourSegs:function(t){return this.eventFootprintsToSegs(this.buildBusinessHourEventFootprints(t))},buildBusinessHourEventFootprints:function(t){var e=this.view.calendar;return this._buildBusinessHourEventFootprints(t,e.opt("businessHours"))},_buildBusinessHourEventFootprints:function(t,e){var n,i,s=this.view.calendar;return n=s.buildBusinessInstanceGroup(t,e,this.unzonedRange),i=n?n.sliceRenderRanges(this.unzonedRange,s):[],this.eventRangesToEventFootprints(i)}}),me.mixin({segs:null,eventTimeFormat:null,displayEventTime:null,displayEventEnd:null,computeEventTimeFormat:function(){return this.opt("smallTimeFormat")},computeDisplayEventTime:function(){return!0},computeDisplayEventEnd:function(){return!0},renderEventsPayload:function(t){var e,n,i,s,r,o=[],a=[];for(e in t)n=t[e],i=n.sliceRenderRanges(this.view.activeUnzonedRange),s=this.eventRangesToEventFootprints(i),r=this.eventFootprintsToSegs(s),n.getEventDef().hasBgRendering()?o.push.apply(o,r):a.push.apply(a,r);this.segs=[].concat(this.renderBgSegs(o)||o,this.renderFgSegs(a)||a)},unrenderEvents:function(){this.handleSegMouseout(),this.clearDragListeners(),this.unrenderFgSegs(),this.unrenderBgSegs(),this.segs=null},getEventSegs:function(){return this.segs||[]},renderBgSegs:function(t){return this.renderFill("bgEvent",t)},unrenderBgSegs:function(){this.unrenderFill("bgEvent")},bgEventSegEl:function(t,e){return this.filterEventRenderEl(t.footprint,e)},bgEventSegClasses:function(t){var e=t.footprint.eventDef;return["fc-bgevent"].concat(e.className,e.source.className)},bgEventSegCss:function(t){return{"background-color":this.getSegSkinCss(t)["background-color"]}},getEventTimeText:function(t,e,n){return this._getEventTimeText(t.eventInstance.dateProfile.start,t.eventInstance.dateProfile.end,t.componentFootprint.isAllDay,e,n)},_getEventTimeText:function(t,e,n,i,s){return null==i&&(i=this.eventTimeFormat),null==s&&(s=this.displayEventEnd),this.displayEventTime&&!n?s&&e?this.view.formatRange({start:t,end:e},!1,i):t.format(i):""},getSegClasses:function(t,e,n){var i=this.view,s=["fc-event",t.isStart?"fc-start":"fc-not-start",t.isEnd?"fc-end":"fc-not-end"].concat(this.getSegCustomClasses(t));return e&&s.push("fc-draggable"),n&&s.push("fc-resizable"),i.isEventDefSelected(t.footprint.eventDef)&&s.push("fc-selected"),s},getSegCustomClasses:function(t){var e=t.footprint.eventDef;return[].concat(e.className,e.source.className)},getSegSkinCss:function(t){return{"background-color":this.getSegBackgroundColor(t),"border-color":this.getSegBorderColor(t),color:this.getSegTextColor(t)}},getSegBackgroundColor:function(t){var e=t.footprint.eventDef;return e.backgroundColor||e.color||this.getSegDefaultBackgroundColor(t)},getSegDefaultBackgroundColor:function(t){var e=t.footprint.eventDef.source;return e.backgroundColor||e.color||this.opt("eventBackgroundColor")||this.opt("eventColor")},getSegBorderColor:function(t){var e=t.footprint.eventDef;return e.borderColor||e.color||this.getSegDefaultBorderColor(t)},getSegDefaultBorderColor:function(t){var e=t.footprint.eventDef.source;return e.borderColor||e.color||this.opt("eventBorderColor")||this.opt("eventColor")},getSegTextColor:function(t){return t.footprint.eventDef.textColor||this.getSegDefaultTextColor(t)},getSegDefaultTextColor:function(t){return t.footprint.eventDef.source.textColor||this.opt("eventTextColor")},sortEventSegs:function(t){t.sort(at(this,"compareEventSegs"))},compareEventSegs:function(t,e){var n=t.footprint.componentFootprint,i=n.unzonedRange,s=e.footprint.componentFootprint,r=s.unzonedRange;return i.startMs-r.startMs||r.endMs-r.startMs-(i.endMs-i.startMs)||s.isAllDay-n.isAllDay||F(t.footprint.eventDef,e.footprint.eventDef,this.view.eventOrderSpecs)}}),me.mixin({segSelector:".fc-event-container > *",mousedOverSeg:null,largeUnit:null,diffDates:function(t,e){return this.largeUnit?L(t,e,this.largeUnit):k(t,e)},bindSegHandlers:function(){this.bindSegHandlersToEl(this.el)},bindSegHandlersToEl:function(t){this.bindSegHandlerToEl(t,"touchstart",this.handleSegTouchStart),this.bindSegHandlerToEl(t,"mouseenter",this.handleSegMouseover),this.bindSegHandlerToEl(t,"mouseleave",this.handleSegMouseout),this.bindSegHandlerToEl(t,"mousedown",this.handleSegMousedown),this.bindSegHandlerToEl(t,"click",this.handleSegClick)},bindSegHandlerToEl:function(e,n,i){var s=this;e.on(n,this.segSelector,function(e){var n=t(this).data("fc-seg");if(n&&!s.isDraggingSeg&&!s.isResizingSeg)return i.call(s,n,e)})},handleSegClick:function(t,e){!1===this.publiclyTrigger("eventClick",{context:t.el[0],args:[t.footprint.getEventLegacy(),e,this.view]})&&e.preventDefault()},handleSegMouseover:function(t,e){ge.get().shouldIgnoreMouse()||this.mousedOverSeg||(this.mousedOverSeg=t,this.view.isEventDefResizable(t.footprint.eventDef)&&t.el.addClass("fc-allow-mouse-resize"),this.publiclyTrigger("eventMouseover",{context:t.el[0],args:[t.footprint.getEventLegacy(),e,this.view]}))},handleSegMouseout:function(t,e){e=e||{},this.mousedOverSeg&&(t=t||this.mousedOverSeg,this.mousedOverSeg=null,this.view.isEventDefResizable(t.footprint.eventDef)&&t.el.removeClass("fc-allow-mouse-resize"),this.publiclyTrigger("eventMouseout",{context:t.el[0],args:[t.footprint.getEventLegacy(),e,this.view]}))},handleSegMousedown:function(t,e){!this.startSegResize(t,e,{distance:5})&&this.view.isEventDefDraggable(t.footprint.eventDef)&&this.buildSegDragListener(t).startInteraction(e,{distance:5})},handleSegTouchStart:function(t,e){var n,i,s=this.view,r=t.footprint.eventDef,o=s.isEventDefSelected(r),a=s.isEventDefDraggable(r),l=s.isEventDefResizable(r),u=!1;o&&l&&(u=this.startSegResize(t,e)),u||!a&&!l||(i=this.opt("eventLongPressDelay"),null==i&&(i=this.opt("longPressDelay")),n=a?this.buildSegDragListener(t):this.buildSegSelectListener(t),n.startInteraction(e,{delay:o?0:i}))},buildSegSelectListener:function(t){var e=this,n=this.view,i=t.footprint.eventDef,s=t.footprint.eventInstance;if(this.segDragListener)return this.segDragListener;var r=this.segDragListener=new de({dragStart:function(t){r.isTouch&&!n.isEventDefSelected(i)&&s&&n.selectEventInstance(s)},interactionEnd:function(t){e.segDragListener=null}});return r},isEventInstanceGroupAllowed:function(t){var e,n=this.eventRangesToEventFootprints(t.getAllEventRanges());for(e=0;e<n.length;e++)if(!this.view.validUnzonedRange.containsRange(n[e].componentFootprint.unzonedRange))return!1;return this.view.calendar.isEventInstanceGroupAllowed(t)},renderHelperEventFootprints:function(t,e){return this.renderHelperEventFootprintEls(t,e).addClass("fc-helper")},renderHelperEventFootprintEls:function(t,e){},unrenderHelper:function(){},fabricateEventFootprint:function(t){var e,n=this.view.calendar,i=n.footprintToDateProfile(t),s=new ke(new _e(n));return s.dateProfile=i,e=s.buildInstance(),new Ue(t,s,e)}}),me.mixin({isDraggingSeg:!1,buildSegDragListener:function(t){var e,n,i,s=this,a=this.view,l=a.calendar,u=l.eventManager,c=t.el,h=t.footprint.eventDef,d=t.footprint.eventInstance;if(this.segDragListener)return this.segDragListener;var f=this.segDragListener=new fe(a,{scroll:this.opt("dragScroll"),subjectEl:c,subjectCenter:!0,interactionStart:function(i){t.component=s,e=!1,n=new pe(t.el,{additionalClass:"fc-dragging",parentEl:a.el,opacity:f.isTouch?null:s.opt("dragOpacity"),revertDuration:s.opt("dragRevertDuration"),zIndex:2}),n.hide(),n.start(i)},dragStart:function(n){f.isTouch&&!a.isEventDefSelected(h)&&d&&a.selectEventInstance(d),e=!0,s.handleSegMouseout(t,n),s.segDragStart(t,n),a.hideEventsWithId(h.id)},hitOver:function(e,o,c){var d,g,p,v,m=!0;t.hit&&(c=t.hit),d=c.component.getSafeHitFootprint(c),g=e.component.getSafeHitFootprint(e),d&&g?(i=s.computeEventDropMutation(d,g,h),i?(p=u.buildMutatedEventInstanceGroup(h.id,i),m=s.isEventInstanceGroupAllowed(p)):m=!1):m=!1,m||(i=null,r()),i&&(v=a.renderDrag(s.eventRangesToEventFootprints(p.sliceRenderRanges(s.unzonedRange,l)),t))?(v.addClass("fc-dragging"),f.isTouch||s.applyDragOpacity(v),n.hide()):n.show(),o&&(i=null)},hitOut:function(){a.unrenderDrag(),n.show(),i=null},hitDone:function(){o()},interactionEnd:function(r){delete t.component,n.stop(!i,function(){e&&(a.unrenderDrag(),s.segDragStop(t,r)),i?a.reportEventDrop(d,i,c,r):a.showEventsWithId(h.id)}),s.segDragListener=null}});return f},segDragStart:function(t,e){this.isDraggingSeg=!0,this.publiclyTrigger("eventDragStart",{context:t.el[0],args:[t.footprint.getEventLegacy(),e,{},this.view]})},segDragStop:function(t,e){this.isDraggingSeg=!1,this.publiclyTrigger("eventDragStop",{context:t.el[0],args:[t.footprint.getEventLegacy(),e,{},this.view]})},computeEventDropMutation:function(t,e,n){var i,s,r,o=t.unzonedRange.getStart(),a=e.unzonedRange.getStart(),l=!1,u=!1,c=!1;return t.isAllDay!==e.isAllDay&&(l=!0,e.isAllDay?(c=!0,o.stripTime()):u=!0),i=this.diffDates(a,o),s=new We,s.clearEnd=l,s.forceTimed=u,s.forceAllDay=c,s.setDateDelta(i),r=new Ge,r.setDateMutation(s),r},applyDragOpacity:function(t){var e=this.opt("dragOpacity");null!=e&&t.css("opacity",e)}}),me.mixin({isResizingSeg:!1,startSegResize:function(e,n,i){return!!t(n.target).is(".fc-resizer")&&(this.buildSegResizeListener(e,t(n.target).is(".fc-start-resizer")).startInteraction(n,i),!0)},buildSegResizeListener:function(t,e){var n,i,s=this,a=this.view,l=a.calendar,u=l.eventManager,c=t.el,h=t.footprint.eventDef,d=t.footprint.eventInstance;return this.segResizeListener=new fe(this,{scroll:this.opt("dragScroll"),subjectEl:c,interactionStart:function(){n=!1},dragStart:function(e){n=!0,s.handleSegMouseout(t,e),s.segResizeStart(t,e)},hitOver:function(n,o,c){var d,f=!0,g=s.getSafeHitFootprint(c),p=s.getSafeHitFootprint(n);g&&p?(i=e?s.computeEventStartResizeMutation(g,p,t.footprint):s.computeEventEndResizeMutation(g,p,t.footprint),i?(d=u.buildMutatedEventInstanceGroup(h.id,i),f=s.isEventInstanceGroupAllowed(d)):f=!1):f=!1,f?i.isEmpty()&&(i=null):(i=null,r()),i&&(a.hideEventsWithId(h.id),s.renderEventResize(s.eventRangesToEventFootprints(d.sliceRenderRanges(s.unzonedRange,l)),t))},hitOut:function(){i=null,a.showEventsWithId(h.id)},hitDone:function(){s.unrenderEventResize(),o()},interactionEnd:function(e){n&&s.segResizeStop(t,e),i?a.reportEventResize(d,i,c,e):a.showEventsWithId(h.id),s.segResizeListener=null}})},segResizeStart:function(t,e){this.isResizingSeg=!0,this.publiclyTrigger("eventResizeStart",{context:t.el[0],args:[t.footprint.getEventLegacy(),e,{},this.view]})},segResizeStop:function(t,e){this.isResizingSeg=!1,this.publiclyTrigger("eventResizeStop",{context:t.el[0],args:[t.footprint.getEventLegacy(),e,{},this.view]})},computeEventStartResizeMutation:function(t,e,n){var i,s,r=n.componentFootprint.unzonedRange,o=this.diffDates(e.unzonedRange.getStart(),t.unzonedRange.getStart());return r.getStart().add(o)<r.getEnd()&&(i=new We,i.setStartDelta(o),s=new Ge,s.setDateMutation(i),s)},computeEventEndResizeMutation:function(t,e,n){var i,s,r=n.componentFootprint.unzonedRange,o=this.diffDates(e.unzonedRange.getEnd(),t.unzonedRange.getEnd());return r.getEnd().add(o)>r.getStart()&&(i=new We,i.setEndDelta(o),s=new Ge,s.setDateMutation(i),s)},renderEventResize:function(t,e){},unrenderEventResize:function(){}}),me.mixin({isDraggingExternal:!1,externalDragStart:function(e,n){var i,s;this.opt("droppable")&&(i=t((n?n.item:null)||e.target),s=this.opt("dropAccept"),(t.isFunction(s)?s.call(i[0],i):i.is(s))&&(this.isDraggingExternal||this.listenToExternalDrag(i,e,n)))},listenToExternalDrag:function(t,e,n){var i,s=this,a=this.view,l=mt(t);(s.externalDragListener=new fe(this,{interactionStart:function(){s.isDraggingExternal=!0},hitOver:function(t){var e,n=!0,o=t.component.getSafeHitFootprint(t);o?(i=s.computeExternalDrop(o,l),i?(e=new Oe(i.buildInstances()),n=l.eventProps?s.isEventInstanceGroupAllowed(e):s.isExternalInstanceGroupAllowed(e)):n=!1):n=!1,n||(i=null,r()),i&&s.renderDrag(s.eventRangesToEventFootprints(e.sliceRenderRanges(s.unzonedRange,a.calendar)))},hitOut:function(){i=null},hitDone:function(){o(),s.unrenderDrag()},interactionEnd:function(e){i&&a.reportExternalDrop(i,Boolean(l.eventProps),Boolean(l.stick),t,e,n),s.isDraggingExternal=!1,s.externalDragListener=null}})).startDrag(e)},computeExternalDrop:function(e,n){var i,s=this.view.calendar,r=Vt.moment.utc(e.unzonedRange.startMs).stripZone();return e.isAllDay&&(n.startTime?r.time(n.startTime):r.stripTime()),n.duration&&(i=r.clone().add(n.duration)),r=s.applyTimezone(r),i&&(i=s.applyTimezone(i)),ke.parse(t.extend({},n.eventProps,{start:r,end:i}),new _e(s))},isExternalInstanceGroupAllowed:function(t){var e,n=this.view.calendar,i=this.eventRangesToEventFootprints(t.getAllEventRanges());for(e=0;e<i.length;e++)if(!this.view.validUnzonedRange.containsRange(i[e].componentFootprint.unzonedRange))return!1;for(e=0;e<i.length;e++)if(!n.isSelectionFootprintAllowed(i[e].componentFootprint))return!1;return!0}}),Vt.dataAttrPrefix="",me.mixin({elsByFill:null,initFillInternals:function(){this.elsByFill={}},renderFill:function(t,e){},unrenderFill:function(t){var e=this.elsByFill[t];e&&(e.remove(),delete this.elsByFill[t])},renderFillSegEls:function(e,n){var i,s=this,r=this[e+"SegEl"],o="",a=[];if(n.length){
	for(i=0;i<n.length;i++)o+=this.fillSegHtml(e,n[i]);t(o).each(function(e,i){var o=n[e],l=t(i);r&&(l=r.call(s,o,l)),l&&(l=t(l),l.is(s.fillSegTag)&&(o.el=l,a.push(o)))})}return a},fillSegTag:"div",fillSegHtml:function(t,e){var n=this[t+"SegClasses"],i=this[t+"SegCss"],s=n?n.call(this,e):[],r=nt(i?i.call(this,e):{});return"<"+this.fillSegTag+(s.length?' class="'+s.join(" ")+'"':"")+(r?' style="'+r+'"':"")+" />"},highlightSegClasses:function(){return["fc-highlight"]}});var ye=Vt.DayTableMixin={breakOnWeeks:!1,dayDates:null,dayIndices:null,daysPerRow:null,rowCnt:null,colCnt:null,colHeadFormat:null,updateDayTable:function(){for(var t,e,n,i=this.view,s=i.calendar,r=s.msToUtcMoment(this.unzonedRange.startMs,!0),o=s.msToUtcMoment(this.unzonedRange.endMs,!0),a=-1,l=[],u=[];r.isBefore(o);)i.isHiddenDay(r)?l.push(a+.5):(a++,l.push(a),u.push(r.clone())),r.add(1,"days");if(this.breakOnWeeks){for(e=u[0].day(),t=1;t<u.length&&u[t].day()!=e;t++);n=Math.ceil(u.length/t)}else n=1,t=u.length;this.dayDates=u,this.dayIndices=l,this.daysPerRow=t,this.rowCnt=n,this.updateDayTableCols()},updateDayTableCols:function(){this.colCnt=this.computeColCnt(),this.colHeadFormat=this.opt("columnFormat")||this.computeColHeadFormat()},computeColCnt:function(){return this.daysPerRow},getCellDate:function(t,e){return this.dayDates[this.getCellDayIndex(t,e)].clone()},getCellRange:function(t,e){var n=this.getCellDate(t,e);return{start:n,end:n.clone().add(1,"days")}},getCellDayIndex:function(t,e){return t*this.daysPerRow+this.getColDayIndex(e)},getColDayIndex:function(t){return this.isRTL?this.colCnt-1-t:t},getDateDayIndex:function(t){var e=this.dayIndices,n=t.diff(this.dayDates[0],"days");return n<0?e[0]-1:n>=e.length?e[e.length-1]+1:e[n]},computeColHeadFormat:function(){return this.rowCnt>1||this.colCnt>10?"ddd":this.colCnt>1?this.opt("dayOfMonthFormat"):"dddd"},sliceRangeByRow:function(t){var e,n,i,s,r,o=this.daysPerRow,a=this.view.computeDayRange(t),l=this.getDateDayIndex(a.start),u=this.getDateDayIndex(a.end.clone().subtract(1,"days")),c=[];for(e=0;e<this.rowCnt;e++)n=e*o,i=n+o-1,s=Math.max(l,n),r=Math.min(u,i),s=Math.ceil(s),r=Math.floor(r),s<=r&&c.push({row:e,firstRowDayIndex:s-n,lastRowDayIndex:r-n,isStart:s===l,isEnd:r===u});return c},sliceRangeByDay:function(t){var e,n,i,s,r,o,a=this.daysPerRow,l=this.view.computeDayRange(t),u=this.getDateDayIndex(l.start),c=this.getDateDayIndex(l.end.clone().subtract(1,"days")),h=[];for(e=0;e<this.rowCnt;e++)for(n=e*a,i=n+a-1,s=n;s<=i;s++)r=Math.max(u,s),o=Math.min(c,s),r=Math.ceil(r),o=Math.floor(o),r<=o&&h.push({row:e,firstRowDayIndex:r-n,lastRowDayIndex:o-n,isStart:r===u,isEnd:o===c});return h},renderHeadHtml:function(){var t=this.view.calendar.theme;return'<div class="fc-row '+t.getClass("headerRow")+'"><table class="'+t.getClass("tableGrid")+'"><thead>'+this.renderHeadTrHtml()+"</thead></table></div>"},renderHeadIntroHtml:function(){return this.renderIntroHtml()},renderHeadTrHtml:function(){return"<tr>"+(this.isRTL?"":this.renderHeadIntroHtml())+this.renderHeadDateCellsHtml()+(this.isRTL?this.renderHeadIntroHtml():"")+"</tr>"},renderHeadDateCellsHtml:function(){var t,e,n=[];for(t=0;t<this.colCnt;t++)e=this.getCellDate(0,t),n.push(this.renderHeadDateCellHtml(e));return n.join("")},renderHeadDateCellHtml:function(t,e,n){var i=this.view,s=i.activeUnzonedRange.containsDate(t),r=["fc-day-header",i.calendar.theme.getClass("widgetHeader")],o=tt(t.format(this.colHeadFormat));return 1===this.rowCnt?r=r.concat(this.getDayClasses(t,!0)):r.push("fc-"+_t[t.day()]),'<th class="'+r.join(" ")+'"'+(1===(s&&this.rowCnt)?' data-date="'+t.format("YYYY-MM-DD")+'"':"")+(e>1?' colspan="'+e+'"':"")+(n?" "+n:"")+">"+(s?i.buildGotoAnchorHtml({date:t,forceOff:this.rowCnt>1||1===this.colCnt},o):o)+"</th>"},renderBgTrHtml:function(t){return"<tr>"+(this.isRTL?"":this.renderBgIntroHtml(t))+this.renderBgCellsHtml(t)+(this.isRTL?this.renderBgIntroHtml(t):"")+"</tr>"},renderBgIntroHtml:function(t){return this.renderIntroHtml()},renderBgCellsHtml:function(t){var e,n,i=[];for(e=0;e<this.colCnt;e++)n=this.getCellDate(t,e),i.push(this.renderBgCellHtml(n));return i.join("")},renderBgCellHtml:function(t,e){var n=this.view,i=n.activeUnzonedRange.containsDate(t),s=this.getDayClasses(t);return s.unshift("fc-day",n.calendar.theme.getClass("widgetContent")),'<td class="'+s.join(" ")+'"'+(i?' data-date="'+t.format("YYYY-MM-DD")+'"':"")+(e?" "+e:"")+"></td>"},renderIntroHtml:function(){},bookendCells:function(t){var e=this.renderIntroHtml();e&&(this.isRTL?t.append(e):t.prepend(e))}},we=Vt.DayGrid=me.extend(ye,{numbersVisible:!1,bottomCoordPadding:0,rowEls:null,cellEls:null,helperEls:null,rowCoordCache:null,colCoordCache:null,renderDates:function(t){var e,n,i=this.view,s=this.rowCnt,r=this.colCnt,o="";for(e=0;e<s;e++)o+=this.renderDayRowHtml(e,t);for(this.el.html(o),this.rowEls=this.el.find(".fc-row"),this.cellEls=this.el.find(".fc-day, .fc-disabled-day"),this.rowCoordCache=new he({els:this.rowEls,isVertical:!0}),this.colCoordCache=new he({els:this.cellEls.slice(0,this.colCnt),isHorizontal:!0}),e=0;e<s;e++)for(n=0;n<r;n++)this.publiclyTrigger("dayRender",{context:i,args:[this.getCellDate(e,n),this.getCellEl(e,n),i]})},unrenderDates:function(){this.removeSegPopover()},renderBusinessHours:function(){var t=this.buildBusinessHourSegs(!0);this.renderFill("businessHours",t,"bgevent")},unrenderBusinessHours:function(){this.unrenderFill("businessHours")},renderDayRowHtml:function(t,e){var n=this.view.calendar.theme,i=["fc-row","fc-week",n.getClass("dayRow")];return e&&i.push("fc-rigid"),'<div class="'+i.join(" ")+'"><div class="fc-bg"><table class="'+n.getClass("tableGrid")+'">'+this.renderBgTrHtml(t)+'</table></div><div class="fc-content-skeleton"><table>'+(this.numbersVisible?"<thead>"+this.renderNumberTrHtml(t)+"</thead>":"")+"</table></div></div>"},renderNumberTrHtml:function(t){return"<tr>"+(this.isRTL?"":this.renderNumberIntroHtml(t))+this.renderNumberCellsHtml(t)+(this.isRTL?this.renderNumberIntroHtml(t):"")+"</tr>"},renderNumberIntroHtml:function(t){return this.renderIntroHtml()},renderNumberCellsHtml:function(t){var e,n,i=[];for(e=0;e<this.colCnt;e++)n=this.getCellDate(t,e),i.push(this.renderNumberCellHtml(n));return i.join("")},renderNumberCellHtml:function(t){var e,n,i=this.view,s="",r=i.activeUnzonedRange.containsDate(t),o=i.dayNumbersVisible&&r;return o||i.cellWeekNumbersVisible?(e=this.getDayClasses(t),e.unshift("fc-day-top"),i.cellWeekNumbersVisible&&(n="ISO"===t._locale._fullCalendar_weekCalc?1:t._locale.firstDayOfWeek()),s+='<td class="'+e.join(" ")+'"'+(r?' data-date="'+t.format()+'"':"")+">",i.cellWeekNumbersVisible&&t.day()==n&&(s+=i.buildGotoAnchorHtml({date:t,type:"week"},{class:"fc-week-number"},t.format("w"))),o&&(s+=i.buildGotoAnchorHtml(t,{class:"fc-day-number"},t.date())),s+="</td>"):"<td/>"},computeEventTimeFormat:function(){return this.opt("extraSmallTimeFormat")},computeDisplayEventEnd:function(){return 1==this.colCnt},rangeUpdated:function(){this.updateDayTable()},componentFootprintToSegs:function(t){var e,n,i=this.sliceRangeByRow(t.unzonedRange);for(e=0;e<i.length;e++)n=i[e],this.isRTL?(n.leftCol=this.daysPerRow-1-n.lastRowDayIndex,n.rightCol=this.daysPerRow-1-n.firstRowDayIndex):(n.leftCol=n.firstRowDayIndex,n.rightCol=n.lastRowDayIndex);return i},prepareHits:function(){this.colCoordCache.build(),this.rowCoordCache.build(),this.rowCoordCache.bottoms[this.rowCnt-1]+=this.bottomCoordPadding},releaseHits:function(){this.colCoordCache.clear(),this.rowCoordCache.clear()},queryHit:function(t,e){if(this.colCoordCache.isLeftInBounds(t)&&this.rowCoordCache.isTopInBounds(e)){var n=this.colCoordCache.getHorizontalIndex(t),i=this.rowCoordCache.getVerticalIndex(e);if(null!=i&&null!=n)return this.getCellHit(i,n)}},getHitFootprint:function(t){var e=this.getCellRange(t.row,t.col);return new xe(new Me(e.start,e.end),!0)},getHitEl:function(t){return this.getCellEl(t.row,t.col)},getCellHit:function(t,e){return{row:t,col:e,component:this,left:this.colCoordCache.getLeftOffset(e),right:this.colCoordCache.getRightOffset(e),top:this.rowCoordCache.getTopOffset(t),bottom:this.rowCoordCache.getBottomOffset(t)}},getCellEl:function(t,e){return this.cellEls.eq(t*this.colCnt+e)},renderDrag:function(t,e){var n;for(n=0;n<t.length;n++)this.renderHighlight(t[n].componentFootprint);if(e&&e.component!==this)return this.renderHelperEventFootprints(t,e)},unrenderDrag:function(){this.unrenderHighlight(),this.unrenderHelper()},renderEventResize:function(t,e){var n;for(n=0;n<t.length;n++)this.renderHighlight(t[n].componentFootprint);return this.renderHelperEventFootprints(t,e)},unrenderEventResize:function(){this.unrenderHighlight(),this.unrenderHelper()},renderHelperEventFootprintEls:function(e,n){var i,s=[],r=this.eventFootprintsToSegs(e);return r=this.renderFgSegEls(r),i=this.renderSegRows(r),this.rowEls.each(function(e,r){var o,a=t(r),l=t('<div class="fc-helper-skeleton"><table/></div>');o=n&&n.row===e?n.el.position().top:a.find(".fc-content-skeleton tbody").position().top,l.css("top",o).find("table").append(i[e].tbodyEl),a.append(l),s.push(l[0])}),this.helperEls=t(s)},unrenderHelper:function(){this.helperEls&&(this.helperEls.remove(),this.helperEls=null)},fillSegTag:"td",renderFill:function(e,n,i){var s,r,o,a=[];for(n=this.renderFillSegEls(e,n),s=0;s<n.length;s++)r=n[s],o=this.renderFillRow(e,r,i),this.rowEls.eq(r.row).append(o),a.push(o[0]);return this.elsByFill[e]?this.elsByFill[e]=this.elsByFill[e].add(a):this.elsByFill[e]=t(a),n},renderFillRow:function(e,n,i){var s,r,o=this.colCnt,a=n.leftCol,l=n.rightCol+1;return i=i||e.toLowerCase(),s=t('<div class="fc-'+i+'-skeleton"><table><tr/></table></div>'),r=s.find("tr"),a>0&&r.append('<td colspan="'+a+'"/>'),r.append(n.el.attr("colspan",l-a)),l<o&&r.append('<td colspan="'+(o-l)+'"/>'),this.bookendCells(r),s}});we.mixin({rowStructs:null,unrenderEvents:function(){this.removeSegPopover(),me.prototype.unrenderEvents.apply(this,arguments)},getEventSegs:function(){return me.prototype.getEventSegs.call(this).concat(this.popoverSegs||[])},renderBgSegs:function(e){var n=t.grep(e,function(t){return t.footprint.componentFootprint.isAllDay});return me.prototype.renderBgSegs.call(this,n)},renderFgSegs:function(e){var n;return e=this.renderFgSegEls(e),n=this.rowStructs=this.renderSegRows(e),this.rowEls.each(function(e,i){t(i).find(".fc-content-skeleton > table").append(n[e].tbodyEl)}),e},unrenderFgSegs:function(){for(var t,e=this.rowStructs||[];t=e.pop();)t.tbodyEl.remove();this.rowStructs=null},renderSegRows:function(t){var e,n,i=[];for(e=this.groupSegRows(t),n=0;n<e.length;n++)i.push(this.renderSegRow(n,e[n]));return i},fgSegHtml:function(t,e){var n,i,s=this.view,r=t.footprint.eventDef,o=t.footprint.componentFootprint.isAllDay,a=s.isEventDefDraggable(r),l=!e&&o&&t.isStart&&s.isEventDefResizableFromStart(r),u=!e&&o&&t.isEnd&&s.isEventDefResizableFromEnd(r),c=this.getSegClasses(t,a,l||u),h=nt(this.getSegSkinCss(t)),d="";return c.unshift("fc-day-grid-event","fc-h-event"),t.isStart&&(n=this.getEventTimeText(t.footprint))&&(d='<span class="fc-time">'+tt(n)+"</span>"),i='<span class="fc-title">'+(tt(r.title||"")||"&nbsp;")+"</span>",'<a class="'+c.join(" ")+'"'+(r.url?' href="'+tt(r.url)+'"':"")+(h?' style="'+h+'"':"")+'><div class="fc-content">'+(this.isRTL?i+" "+d:d+" "+i)+"</div>"+(l?'<div class="fc-resizer fc-start-resizer" />':"")+(u?'<div class="fc-resizer fc-end-resizer" />':"")+"</a>"},renderSegRow:function(e,n){function i(e){for(;o<e;)c=(m[s-1]||[])[o],c?c.attr("rowspan",parseInt(c.attr("rowspan")||1,10)+1):(c=t("<td/>"),a.append(c)),v[s][o]=c,m[s][o]=c,o++}var s,r,o,a,l,u,c,h=this.colCnt,d=this.buildSegLevels(n),f=Math.max(1,d.length),g=t("<tbody/>"),p=[],v=[],m=[];for(s=0;s<f;s++){if(r=d[s],o=0,a=t("<tr/>"),p.push([]),v.push([]),m.push([]),r)for(l=0;l<r.length;l++){for(u=r[l],i(u.leftCol),c=t('<td class="fc-event-container"/>').append(u.el),u.leftCol!=u.rightCol?c.attr("colspan",u.rightCol-u.leftCol+1):m[s][o]=c;o<=u.rightCol;)v[s][o]=c,p[s][o]=u,o++;a.append(c)}i(h),this.bookendCells(a),g.append(a)}return{row:e,tbodyEl:g,cellMatrix:v,segMatrix:p,segLevels:d,segs:n}},buildSegLevels:function(t){var e,n,i,s=[];for(this.sortEventSegs(t),e=0;e<t.length;e++){for(n=t[e],i=0;i<s.length&&yt(n,s[i]);i++);n.level=i,(s[i]||(s[i]=[])).push(n)}for(i=0;i<s.length;i++)s[i].sort(wt);return s},groupSegRows:function(t){var e,n=[];for(e=0;e<this.rowCnt;e++)n.push([]);for(e=0;e<t.length;e++)n[t[e].row].push(t[e]);return n}}),we.mixin({segPopover:null,popoverSegs:null,removeSegPopover:function(){this.segPopover&&this.segPopover.hide()},limitRows:function(t){var e,n,i=this.rowStructs||[];for(e=0;e<i.length;e++)this.unlimitRow(e),!1!==(n=!!t&&("number"==typeof t?t:this.computeRowLevelLimit(e)))&&this.limitRow(e,n)},computeRowLevelLimit:function(e){function n(e,n){r=Math.max(r,t(n).outerHeight())}var i,s,r,o=this.rowEls.eq(e),a=o.height(),l=this.rowStructs[e].tbodyEl.children();for(i=0;i<l.length;i++)if(s=l.eq(i).removeClass("fc-limited"),r=0,s.find("> td > :first-child").each(n),s.position().top+r>a)return i;return!1},limitRow:function(e,n){function i(i){for(;S<i;)u=w.getCellSegs(e,S,n),u.length&&(d=r[n-1][S],y=w.renderMoreLink(e,S,u),m=t("<div/>").append(y),d.append(m),b.push(m[0])),S++}var s,r,o,a,l,u,c,h,d,f,g,p,v,m,y,w=this,D=this.rowStructs[e],b=[],S=0;if(n&&n<D.segLevels.length){for(s=D.segLevels[n-1],r=D.cellMatrix,o=D.tbodyEl.children().slice(n).addClass("fc-limited").get(),a=0;a<s.length;a++){for(l=s[a],i(l.leftCol),h=[],c=0;S<=l.rightCol;)u=this.getCellSegs(e,S,n),h.push(u),c+=u.length,S++;if(c){for(d=r[n-1][l.leftCol],f=d.attr("rowspan")||1,g=[],p=0;p<h.length;p++)v=t('<td class="fc-more-cell"/>').attr("rowspan",f),u=h[p],y=this.renderMoreLink(e,l.leftCol+p,[l].concat(u)),m=t("<div/>").append(y),v.append(m),g.push(v[0]),b.push(v[0]);d.addClass("fc-limited").after(t(g)),o.push(d[0])}}i(this.colCnt),D.moreEls=t(b),D.limitedEls=t(o)}},unlimitRow:function(t){var e=this.rowStructs[t];e.moreEls&&(e.moreEls.remove(),e.moreEls=null),e.limitedEls&&(e.limitedEls.removeClass("fc-limited"),e.limitedEls=null)},renderMoreLink:function(e,n,i){var s=this,r=this.view;return t('<a class="fc-more"/>').text(this.getMoreLinkText(i.length)).on("click",function(o){var a=s.opt("eventLimitClick"),l=s.getCellDate(e,n),u=t(this),c=s.getCellEl(e,n),h=s.getCellSegs(e,n),d=s.resliceDaySegs(h,l),f=s.resliceDaySegs(i,l);"function"==typeof a&&(a=s.publiclyTrigger("eventLimitClick",{context:r,args:[{date:l.clone(),dayEl:c,moreEl:u,segs:d,hiddenSegs:f},o,r]})),"popover"===a?s.showSegPopover(e,n,u,d):"string"==typeof a&&r.calendar.zoomTo(l,a)})},showSegPopover:function(t,e,n,i){var s,r,o=this,a=this.view,l=n.parent();s=1==this.rowCnt?a.el:this.rowEls.eq(t),r={className:"fc-more-popover "+a.calendar.theme.getClass("popover"),content:this.renderSegPopoverContent(t,e,i),parentEl:a.el,top:s.offset().top,autoHide:!0,viewportConstrain:this.opt("popoverViewportConstrain"),hide:function(){if(o.popoverSegs){var t,e,n;for(n=0;n<o.popoverSegs.length;++n)t=o.popoverSegs[n],e=t.footprint.getEventLegacy(),o.publiclyTrigger("eventDestroy",{context:e,args:[e,t.el,a]})}o.segPopover.removeElement(),o.segPopover=null,o.popoverSegs=null}},this.isRTL?r.right=l.offset().left+l.outerWidth()+1:r.left=l.offset().left-1,this.segPopover=new ce(r),this.segPopover.show(),this.bindSegHandlersToEl(this.segPopover.el)},renderSegPopoverContent:function(e,n,i){var s,r=this.view,o=r.calendar.theme,a=this.getCellDate(e,n).format(this.opt("dayPopoverFormat")),l=t('<div class="fc-header '+o.getClass("popoverHeader")+'"><span class="fc-close '+o.getIconClass("close")+'"></span><span class="fc-title">'+tt(a)+'</span><div class="fc-clear"/></div><div class="fc-body '+o.getClass("popoverContent")+'"><div class="fc-event-container"></div></div>'),u=l.find(".fc-event-container");for(i=this.renderFgSegEls(i,!0),this.popoverSegs=i,s=0;s<i.length;s++)this.hitsNeeded(),i[s].hit=this.getCellHit(e,n),this.hitsNotNeeded(),u.append(i[s].el);return l},resliceDaySegs:function(t,e){var n,i=e.clone(),s=i.clone().add(1,"days"),r=new Me(i,s),o=[];for(n=0;n<t.length;n++)o.push.apply(o,this.eventFootprintToSegs(t[n].footprint,r));return this.sortEventSegs(o),o},getMoreLinkText:function(t){var e=this.opt("eventLimitText");return"function"==typeof e?e(t):"+"+t+" "+e},getCellSegs:function(t,e,n){for(var i,s=this.rowStructs[t].segMatrix,r=n||0,o=[];r<s.length;)i=s[r][e],i&&o.push(i),r++;return o}});var De=Vt.TimeGrid=me.extend(ye,{dayRanges:null,slotDuration:null,snapDuration:null,snapsPerSlot:null,labelFormat:null,labelInterval:null,colEls:null,slatContainerEl:null,slatEls:null,nowIndicatorEls:null,colCoordCache:null,slatCoordCache:null,constructor:function(){me.apply(this,arguments),this.processOptions()},renderDates:function(){this.el.html(this.renderHtml()),this.colEls=this.el.find(".fc-day, .fc-disabled-day"),this.slatContainerEl=this.el.find(".fc-slats"),this.slatEls=this.slatContainerEl.find("tr"),this.colCoordCache=new he({els:this.colEls,isHorizontal:!0}),this.slatCoordCache=new he({els:this.slatEls,isVertical:!0}),this.renderContentSkeleton()},renderHtml:function(){var t=this.view.calendar.theme;return'<div class="fc-bg"><table class="'+t.getClass("tableGrid")+'">'+this.renderBgTrHtml(0)+'</table></div><div class="fc-slats"><table class="'+t.getClass("tableGrid")+'">'+this.renderSlatRowHtml()+"</table></div>"},renderSlatRowHtml:function(){for(var t,n,i,s=this.view,r=s.calendar,o=r.theme,a=this.isRTL,l="",u=e.duration(+this.view.minTime),c=e.duration(0);u<s.maxTime;)t=r.msToUtcMoment(this.unzonedRange.startMs).time(u),n=ot(G(c,this.labelInterval)),i='<td class="fc-axis fc-time '+o.getClass("widgetContent")+'" '+s.axisStyleAttr()+">"+(n?"<span>"+tt(t.format(this.labelFormat))+"</span>":"")+"</td>",l+='<tr data-time="'+t.format("HH:mm:ss")+'"'+(n?"":' class="fc-minor"')+">"+(a?"":i)+'<td class="'+o.getClass("widgetContent")+'"/>'+(a?i:"")+"</tr>",u.add(this.slotDuration),c.add(this.slotDuration);return l},processOptions:function(){var n,i=this.opt("slotDuration"),s=this.opt("snapDuration");i=e.duration(i),s=s?e.duration(s):i,this.slotDuration=i,this.snapDuration=s,this.snapsPerSlot=i/s,n=this.opt("slotLabelFormat"),t.isArray(n)&&(n=n[n.length-1]),this.labelFormat=n||this.opt("smallTimeFormat"),n=this.opt("slotLabelInterval"),this.labelInterval=n?e.duration(n):this.computeLabelInterval(i)},computeLabelInterval:function(t){var n,i,s;for(n=ln.length-1;n>=0;n--)if(i=e.duration(ln[n]),s=G(i,t),ot(s)&&s>1)return i;return e.duration(t)},computeEventTimeFormat:function(){return this.opt("noMeridiemTimeFormat")},computeDisplayEventEnd:function(){return!0},prepareHits:function(){this.colCoordCache.build(),this.slatCoordCache.build()},releaseHits:function(){this.colCoordCache.clear()},queryHit:function(t,e){var n=this.snapsPerSlot,i=this.colCoordCache,s=this.slatCoordCache;if(i.isLeftInBounds(t)&&s.isTopInBounds(e)){var r=i.getHorizontalIndex(t),o=s.getVerticalIndex(e);if(null!=r&&null!=o){var a=s.getTopOffset(o),l=s.getHeight(o),u=(e-a)/l,c=Math.floor(u*n),h=o*n+c,d=a+c/n*l,f=a+(c+1)/n*l;return{col:r,snap:h,component:this,left:i.getLeftOffset(r),right:i.getRightOffset(r),top:d,bottom:f}}}},getHitFootprint:function(t){var e,n=this.getCellDate(0,t.col),i=this.computeSnapTime(t.snap);return n.time(i),e=n.clone().add(this.snapDuration),new xe(new Me(n,e),!1)},getHitEl:function(t){return this.colEls.eq(t.col)},rangeUpdated:function(){var t=this.view;this.updateDayTable(),this.dayRanges=this.dayDates.map(function(e){return new Me(e.clone().add(t.minTime),e.clone().add(t.maxTime))})},computeSnapTime:function(t){return e.duration(this.view.minTime+this.snapDuration*t)},componentFootprintToSegs:function(t){var e,n=this.sliceRangeByTimes(t.unzonedRange);for(e=0;e<n.length;e++)this.isRTL?n[e].col=this.daysPerRow-1-n[e].dayIndex:n[e].col=n[e].dayIndex;return n},sliceRangeByTimes:function(t){var e,n,i=[];for(n=0;n<this.daysPerRow;n++)(e=t.intersect(this.dayRanges[n]))&&i.push({startMs:e.startMs,endMs:e.endMs,isStart:e.isStart,isEnd:e.isEnd,dayIndex:n});return i},updateSize:function(t){this.slatCoordCache.build(),t&&this.updateSegVerticals([].concat(this.fgSegs||[],this.bgSegs||[],this.businessSegs||[]))},getTotalSlatHeight:function(){return this.slatContainerEl.outerHeight()},computeDateTop:function(t,n){return this.computeTimeTop(e.duration(t-n.clone().stripTime()))},computeTimeTop:function(t){var e,n,i=this.slatEls.length,s=(t-this.view.minTime)/this.slotDuration;return s=Math.max(0,s),s=Math.min(i,s),e=Math.floor(s),e=Math.min(e,i-1),n=s-e,this.slatCoordCache.getTopPosition(e)+this.slatCoordCache.getHeight(e)*n},renderDrag:function(t,e){var n;if(e)return this.renderHelperEventFootprints(t);for(n=0;n<t.length;n++)this.renderHighlight(t[n].componentFootprint)},unrenderDrag:function(){this.unrenderHelper(),this.unrenderHighlight()},renderEventResize:function(t,e){return this.renderHelperEventFootprints(t,e)},unrenderEventResize:function(){this.unrenderHelper()},renderHelperEventFootprintEls:function(t,e){var n=this.eventFootprintsToSegs(t);return this.renderHelperSegs(n,e)},unrenderHelper:function(){this.unrenderHelperSegs()},renderBusinessHours:function(){this.renderBusinessSegs(this.buildBusinessHourSegs())},unrenderBusinessHours:function(){this.unrenderBusinessSegs()},getNowIndicatorUnit:function(){return"minute"},renderNowIndicator:function(e){var n,i=this.componentFootprintToSegs(new xe(new Me(e,e.valueOf()+1),!1)),s=this.computeDateTop(e,e),r=[];for(n=0;n<i.length;n++)r.push(t('<div class="fc-now-indicator fc-now-indicator-line"></div>').css("top",s).appendTo(this.colContainerEls.eq(i[n].col))[0]);i.length>0&&r.push(t('<div class="fc-now-indicator fc-now-indicator-arrow"></div>').css("top",s).appendTo(this.el.find(".fc-content-skeleton"))[0]),this.nowIndicatorEls=t(r)},unrenderNowIndicator:function(){this.nowIndicatorEls&&(this.nowIndicatorEls.remove(),this.nowIndicatorEls=null)},renderSelectionFootprint:function(t){this.opt("selectHelper")?this.renderHelperEventFootprints([this.fabricateEventFootprint(t)]):this.renderHighlight(t)},unrenderSelection:function(){this.unrenderHelper(),this.unrenderHighlight()},renderHighlight:function(t){this.renderHighlightSegs(this.componentFootprintToSegs(t))},unrenderHighlight:function(){this.unrenderHighlightSegs()}});De.mixin({colContainerEls:null,fgContainerEls:null,bgContainerEls:null,helperContainerEls:null,highlightContainerEls:null,businessContainerEls:null,fgSegs:null,bgSegs:null,helperSegs:null,highlightSegs:null,businessSegs:null,renderContentSkeleton:function(){var e,n,i="";for(e=0;e<this.colCnt;e++)i+='<td><div class="fc-content-col"><div class="fc-event-container fc-helper-container"></div><div class="fc-event-container"></div><div class="fc-highlight-container"></div><div class="fc-bgevent-container"></div><div class="fc-business-container"></div></div></td>';n=t('<div class="fc-content-skeleton"><table><tr>'+i+"</tr></table></div>"),this.colContainerEls=n.find(".fc-content-col"),this.helperContainerEls=n.find(".fc-helper-container"),this.fgContainerEls=n.find(".fc-event-container:not(.fc-helper-container)"),this.bgContainerEls=n.find(".fc-bgevent-container"),this.highlightContainerEls=n.find(".fc-highlight-container"),this.businessContainerEls=n.find(".fc-business-container"),this.bookendCells(n.find("tr")),this.el.append(n)},renderFgSegs:function(t){return t=this.renderFgSegsIntoContainers(t,this.fgContainerEls),this.fgSegs=t,t},unrenderFgSegs:function(){this.unrenderNamedSegs("fgSegs")},renderHelperSegs:function(e,n){var i,s,r,o=[];for(e=this.renderFgSegsIntoContainers(e,this.helperContainerEls),i=0;i<e.length;i++)s=e[i],n&&n.col===s.col&&(r=n.el,s.el.css({left:r.css("left"),right:r.css("right"),"margin-left":r.css("margin-left"),"margin-right":r.css("margin-right")})),o.push(s.el[0]);return this.helperSegs=e,t(o)},unrenderHelperSegs:function(){this.unrenderNamedSegs("helperSegs")},renderBgSegs:function(t){return t=this.renderFillSegEls("bgEvent",t),this.updateSegVerticals(t),this.attachSegsByCol(this.groupSegsByCol(t),this.bgContainerEls),this.bgSegs=t,t},unrenderBgSegs:function(){this.unrenderNamedSegs("bgSegs")},renderHighlightSegs:function(t){t=this.renderFillSegEls("highlight",t),this.updateSegVerticals(t),this.attachSegsByCol(this.groupSegsByCol(t),this.highlightContainerEls),this.highlightSegs=t},unrenderHighlightSegs:function(){this.unrenderNamedSegs("highlightSegs")},renderBusinessSegs:function(t){t=this.renderFillSegEls("businessHours",t),this.updateSegVerticals(t),this.attachSegsByCol(this.groupSegsByCol(t),this.businessContainerEls),this.businessSegs=t},unrenderBusinessSegs:function(){this.unrenderNamedSegs("businessSegs")},groupSegsByCol:function(t){var e,n=[];for(e=0;e<this.colCnt;e++)n.push([]);for(e=0;e<t.length;e++)n[t[e].col].push(t[e]);return n},attachSegsByCol:function(t,e){var n,i,s;for(n=0;n<this.colCnt;n++)for(i=t[n],s=0;s<i.length;s++)e.eq(n).append(i[s].el)},unrenderNamedSegs:function(t){var e,n=this[t];if(n){for(e=0;e<n.length;e++)n[e].el.remove();this[t]=null}},renderFgSegsIntoContainers:function(t,e){var n,i;for(t=this.renderFgSegEls(t),n=this.groupSegsByCol(t),i=0;i<this.colCnt;i++)this.updateFgSegCoords(n[i]);return this.attachSegsByCol(n,e),t},fgSegHtml:function(t,e){var n,i,s,r=this.view,o=r.calendar,a=t.footprint.componentFootprint,l=a.isAllDay,u=t.footprint.eventDef,c=r.isEventDefDraggable(u),h=!e&&t.isStart&&r.isEventDefResizableFromStart(u),d=!e&&t.isEnd&&r.isEventDefResizableFromEnd(u),f=this.getSegClasses(t,c,h||d),g=nt(this.getSegSkinCss(t));if(f.unshift("fc-time-grid-event","fc-v-event"),r.isMultiDayRange(a.unzonedRange)){if(t.isStart||t.isEnd){var p=o.msToMoment(t.startMs),v=o.msToMoment(t.endMs);n=this._getEventTimeText(p,v,l),i=this._getEventTimeText(p,v,l,"LT"),s=this._getEventTimeText(p,v,l,null,!1)}}else n=this.getEventTimeText(t.footprint),i=this.getEventTimeText(t.footprint,"LT"),s=this.getEventTimeText(t.footprint,null,!1);return'<a class="'+f.join(" ")+'"'+(u.url?' href="'+tt(u.url)+'"':"")+(g?' style="'+g+'"':"")+'><div class="fc-content">'+(n?'<div class="fc-time" data-start="'+tt(s)+'" data-full="'+tt(i)+'"><span>'+tt(n)+"</span></div>":"")+(u.title?'<div class="fc-title">'+tt(u.title)+"</div>":"")+'</div><div class="fc-bg"/>'+(d?'<div class="fc-resizer fc-end-resizer" />':"")+"</a>"},updateSegVerticals:function(t){this.computeSegVerticals(t),this.assignSegVerticals(t)},computeSegVerticals:function(t){var e,n,i;for(e=0;e<t.length;e++)n=t[e],i=this.dayDates[n.dayIndex],n.top=this.computeDateTop(n.startMs,i),n.bottom=this.computeDateTop(n.endMs,i)},assignSegVerticals:function(t){var e,n;for(e=0;e<t.length;e++)n=t[e],n.el.css(this.generateSegVerticalCss(n))},generateSegVerticalCss:function(t){return{top:t.top,bottom:-t.bottom}},updateFgSegCoords:function(t){this.computeSegVerticals(t),this.computeFgSegHorizontals(t),this.assignSegVerticals(t),this.assignFgSegHorizontals(t)},computeFgSegHorizontals:function(t){var e,n,i;if(this.sortEventSegs(t),e=Dt(t),bt(e),n=e[0]){for(i=0;i<n.length;i++)St(n[i]);for(i=0;i<n.length;i++)this.computeFgSegForwardBack(n[i],0,0)}},computeFgSegForwardBack:function(t,e,n){var i,s=t.forwardSegs;if(void 0===t.forwardCoord)for(s.length?(this.sortForwardSegs(s),this.computeFgSegForwardBack(s[0],e+1,n),t.forwardCoord=s[0].backwardCoord):t.forwardCoord=1,t.backwardCoord=t.forwardCoord-(t.forwardCoord-n)/(e+1),i=0;i<s.length;i++)this.computeFgSegForwardBack(s[i],0,t.forwardCoord)},sortForwardSegs:function(t){t.sort(at(this,"compareForwardSegs"))},compareForwardSegs:function(t,e){return e.forwardPressure-t.forwardPressure||(t.backwardCoord||0)-(e.backwardCoord||0)||this.compareEventSegs(t,e)},assignFgSegHorizontals:function(t){var e,n;for(e=0;e<t.length;e++)n=t[e],n.el.css(this.generateFgSegHorizontalCss(n)),n.bottom-n.top<30&&n.el.addClass("fc-short")},generateFgSegHorizontalCss:function(t){var e,n,i=this.opt("slotEventOverlap"),s=t.backwardCoord,r=t.forwardCoord,o=this.generateSegVerticalCss(t);return i&&(r=Math.min(1,s+2*(r-s))),this.isRTL?(e=1-r,n=s):(e=s,n=1-r),o.zIndex=t.level+1,o.left=100*e+"%",o.right=100*n+"%",i&&t.forwardPressure&&(o[this.isRTL?"marginLeft":"marginRight"]=20),o}});var be=Vt.View=ve.extend({type:null,name:null,title:null,calendar:null,viewSpec:null,options:null,renderQueue:null,batchRenderDepth:0,isDatesRendered:!1,isEventsRendered:!1,isBaseRendered:!1,queuedScroll:null,isSelected:!1,selectedEventInstance:null,eventOrderSpecs:null,isHiddenDayHash:null,isNowIndicatorRendered:null,initialNowDate:null,initialNowQueriedMs:null,nowIndicatorTimeoutID:null,nowIndicatorIntervalID:null,constructor:function(t,e){this.calendar=t,this.viewSpec=e,this.type=e.type,this.options=e.options,this.name=this.type,ve.call(this),this.initHiddenDays(),this.eventOrderSpecs=z(this.opt("eventOrder")),this.renderQueue=this.buildRenderQueue(),this.initAutoBatchRender(),this.initialize()},buildRenderQueue:function(){var t=this,e=new ue({event:this.opt("eventRenderWait")});return e.on("start",function(){t.freezeHeight(),t.addScroll(t.queryScroll())}),e.on("stop",function(){t.thawHeight(),t.popScroll()}),e},initAutoBatchRender:function(){var t=this;this.on("before:change",function(){t.startBatchRender()}),this.on("change",function(){t.stopBatchRender()})},startBatchRender:function(){this.batchRenderDepth++||this.renderQueue.pause()},stopBatchRender:function(){--this.batchRenderDepth||this.renderQueue.resume()},initialize:function(){},opt:function(t){return this.options[t]},computeTitle:function(){var t;return t=/^(year|month)$/.test(this.currentRangeUnit)?this.currentUnzonedRange:this.activeUnzonedRange,this.formatRange({start:this.calendar.msToMoment(t.startMs,this.isRangeAllDay),end:this.calendar.msToMoment(t.endMs,this.isRangeAllDay)},this.isRangeAllDay,this.opt("titleFormat")||this.computeTitleFormat(),this.opt("titleRangeSeparator"))},computeTitleFormat:function(){return"year"==this.currentRangeUnit?"YYYY":"month"==this.currentRangeUnit?this.opt("monthYearFormat"):this.currentRangeAs("days")>1?"ll":"LL"},setElement:function(t){ve.prototype.setElement.apply(this,arguments),this.bindBaseRenderHandlers()},removeElement:function(){this.unsetDate(),this.unbindBaseRenderHandlers(),ve.prototype.removeElement.apply(this,arguments)},setDate:function(t){var e=this.get("dateProfile"),n=this.buildDateProfile(t,null,!0);return e&&e.activeUnzonedRange.equals(n.activeUnzonedRange)||this.set("dateProfile",n),n.date},unsetDate:function(){this.unset("dateProfile")},requestDateRender:function(t){var e=this;this.renderQueue.queue(function(){e.executeDateRender(t)},"date","init")},requestDateUnrender:function(){var t=this;this.renderQueue.queue(function(){t.executeDateUnrender()},"date","destroy")},fetchInitialEvents:function(t){var e=this.calendar,n=t.isRangeAllDay&&!this.usesMinMaxTime;return e.requestEvents(e.msToMoment(t.activeUnzonedRange.startMs,n),e.msToMoment(t.activeUnzonedRange.endMs,n))},bindEventChanges:function(){this.listenTo(this.calendar,"eventsReset",this.resetEvents)},unbindEventChanges:function(){this.stopListeningTo(this.calendar,"eventsReset")},setEvents:function(t){this.set("currentEvents",t),this.set("hasEvents",!0)},unsetEvents:function(){this.unset("currentEvents"),this.unset("hasEvents")},resetEvents:function(t){this.startBatchRender(),this.unsetEvents(),this.setEvents(t),this.stopBatchRender()},requestEventsRender:function(t){var e=this;this.renderQueue.queue(function(){e.executeEventsRender(t)},"event","init")},requestEventsUnrender:function(){var t=this;this.renderQueue.queue(function(){t.executeEventsUnrender()},"event","destroy")},executeDateRender:function(t,e){this.setDateProfileForRendering(t),this.render&&this.render(),this.renderDates(),this.updateSize(),this.renderBusinessHours(),this.startNowIndicator(),e||this.addScroll(this.computeInitialDateScroll()),this.isDatesRendered=!0,this.trigger("datesRendered")},executeDateUnrender:function(){this.unselect(),this.stopNowIndicator(),this.trigger("before:datesUnrendered"),this.unrenderBusinessHours(),this.unrenderDates(),
	this.destroy&&this.destroy(),this.isDatesRendered=!1},bindBaseRenderHandlers:function(){var t=this;this.on("datesRendered.baseHandler",function(){t.onBaseRender()}),this.on("before:datesUnrendered.baseHandler",function(){t.onBeforeBaseUnrender()})},unbindBaseRenderHandlers:function(){this.off(".baseHandler")},onBaseRender:function(){this.applyScreenState(),this.publiclyTrigger("viewRender",{context:this,args:[this,this.el]})},onBeforeBaseUnrender:function(){this.applyScreenState(),this.publiclyTrigger("viewDestroy",{context:this,args:[this,this.el]})},bindGlobalHandlers:function(){this.listenTo(ge.get(),{touchstart:this.processUnselect,mousedown:this.handleDocumentMousedown})},unbindGlobalHandlers:function(){this.stopListeningTo(ge.get())},startNowIndicator:function(){var t,n,i,s=this;this.opt("nowIndicator")&&(t=this.getNowIndicatorUnit())&&(n=at(this,"updateNowIndicator"),this.initialNowDate=this.calendar.getNow(),this.initialNowQueriedMs=+new Date,this.renderNowIndicator(this.initialNowDate),this.isNowIndicatorRendered=!0,i=this.initialNowDate.clone().startOf(t).add(1,t)-this.initialNowDate,this.nowIndicatorTimeoutID=setTimeout(function(){s.nowIndicatorTimeoutID=null,n(),i=+e.duration(1,t),i=Math.max(100,i),s.nowIndicatorIntervalID=setInterval(n,i)},i))},updateNowIndicator:function(){this.isNowIndicatorRendered&&(this.unrenderNowIndicator(),this.renderNowIndicator(this.initialNowDate.clone().add(new Date-this.initialNowQueriedMs)))},stopNowIndicator:function(){this.isNowIndicatorRendered&&(this.nowIndicatorTimeoutID&&(clearTimeout(this.nowIndicatorTimeoutID),this.nowIndicatorTimeoutID=null),this.nowIndicatorIntervalID&&(clearTimeout(this.nowIndicatorIntervalID),this.nowIndicatorIntervalID=null),this.unrenderNowIndicator(),this.isNowIndicatorRendered=!1)},updateSize:function(t){var e;t&&(e=this.queryScroll()),this.updateHeight(t),this.updateWidth(t),this.updateNowIndicator(),t&&this.applyScroll(e)},updateWidth:function(t){},updateHeight:function(t){var e=this.calendar;this.setHeight(e.getSuggestedViewHeight(),e.isHeightAuto())},setHeight:function(t,e){},addForcedScroll:function(e){this.addScroll(t.extend(e,{isForced:!0}))},addScroll:function(e){var n=this.queuedScroll||(this.queuedScroll={});n.isForced||t.extend(n,e)},popScroll:function(){this.applyQueuedScroll(),this.queuedScroll=null},applyQueuedScroll:function(){this.queuedScroll&&this.applyScroll(this.queuedScroll)},queryScroll:function(){var e={};return this.isDatesRendered&&t.extend(e,this.queryDateScroll()),e},applyScroll:function(t){this.isDatesRendered&&this.applyDateScroll(t)},computeInitialDateScroll:function(){return{}},queryDateScroll:function(){return{}},applyDateScroll:function(t){},freezeHeight:function(){this.calendar.freezeContentHeight()},thawHeight:function(){this.calendar.thawContentHeight()},executeEventsRender:function(t){this.renderEvents?this.renderEvents(Tt(t)):this.renderEventsPayload(t),this.isEventsRendered=!0,this.onEventsRender()},executeEventsUnrender:function(){this.onBeforeEventsUnrender(),this.destroyEvents&&this.destroyEvents(),this.unrenderEvents(),this.isEventsRendered=!1},onEventsRender:function(){var t=this,e=this.hasPublicHandlers("eventAfterRender");(e||this.hasPublicHandlers("eventAfterAllRender"))&&this.applyScreenState(),e&&this.getEventSegs().forEach(function(e){var n;e.el&&(n=e.footprint.getEventLegacy(),t.publiclyTrigger("eventAfterRender",{context:n,args:[n,e.el,t]}))}),this.publiclyTrigger("eventAfterAllRender",{context:this,args:[this]})},onBeforeEventsUnrender:function(){var t=this;this.hasPublicHandlers("eventDestroy")&&(this.applyScreenState(),this.getEventSegs().forEach(function(e){var n;e.el&&(n=e.footprint.getEventLegacy(),t.publiclyTrigger("eventDestroy",{context:n,args:[n,e.el,t]}))}))},applyScreenState:function(){this.thawHeight(),this.freezeHeight(),this.applyQueuedScroll()},showEventsWithId:function(t){this.getEventSegs().forEach(function(e){e.footprint.eventDef.id===t&&e.el&&e.el.css("visibility","")})},hideEventsWithId:function(t){this.getEventSegs().forEach(function(e){e.footprint.eventDef.id===t&&e.el&&e.el.css("visibility","hidden")})},reportEventDrop:function(t,n,i,s){var r=this.calendar.eventManager,o=r.mutateEventsWithId(t.def.id,n,this.calendar),a=n.dateMutation;a&&(t.dateProfile=a.buildNewDateProfile(t.dateProfile,this.calendar)),this.triggerEventDrop(t,a&&a.dateDelta||e.duration(),o,i,s)},triggerEventDrop:function(t,e,n,i,s){this.publiclyTrigger("eventDrop",{context:i[0],args:[t.toLegacy(),e,n,s,{},this]})},reportExternalDrop:function(t,e,n,i,s,r){e&&this.calendar.eventManager.addEventDef(t,n),this.triggerExternalDrop(t,e,i,s,r)},triggerExternalDrop:function(t,e,n,i,s){this.publiclyTrigger("drop",{context:n[0],args:[t.dateProfile.start.clone(),i,s,this]}),e&&this.publiclyTrigger("eventReceive",{context:this,args:[t.buildInstance().toLegacy(),this]})},reportEventResize:function(t,e,n,i){var s=this.calendar.eventManager,r=s.mutateEventsWithId(t.def.id,e,this.calendar);t.dateProfile=e.dateMutation.buildNewDateProfile(t.dateProfile,this.calendar),this.triggerEventResize(t,e.dateMutation.endDelta,r,n,i)},triggerEventResize:function(t,e,n,i,s){this.publiclyTrigger("eventResize",{context:i[0],args:[t.toLegacy(),e,n,s,{},this]})},select:function(t,e){this.unselect(e),this.renderSelectionFootprint(t),this.reportSelection(t,e)},renderSelectionFootprint:function(t,e){this.renderSelection?this.renderSelection(t.toLegacy(this.calendar)):ve.prototype.renderSelectionFootprint.apply(this,arguments)},reportSelection:function(t,e){this.isSelected=!0,this.triggerSelect(t,e)},triggerSelect:function(t,e){var n=this.calendar.footprintToDateProfile(t);this.publiclyTrigger("select",{context:this,args:[n.start,n.end,e,this]})},unselect:function(t){this.isSelected&&(this.isSelected=!1,this.destroySelection&&this.destroySelection(),this.unrenderSelection(),this.publiclyTrigger("unselect",{context:this,args:[t,this]}))},selectEventInstance:function(t){this.selectedEventInstance&&this.selectedEventInstance===t||(this.unselectEventInstance(),this.getEventSegs().forEach(function(e){e.footprint.eventInstance===t&&e.el&&e.el.addClass("fc-selected")}),this.selectedEventInstance=t)},unselectEventInstance:function(){this.selectedEventInstance&&(this.getEventSegs().forEach(function(t){t.el&&t.el.removeClass("fc-selected")}),this.selectedEventInstance=null)},isEventDefSelected:function(t){return this.selectedEventInstance&&this.selectedEventInstance.def.id===t.id},handleDocumentMousedown:function(t){D(t)&&this.processUnselect(t)},processUnselect:function(t){this.processRangeUnselect(t),this.processEventUnselect(t)},processRangeUnselect:function(e){var n;this.isSelected&&this.opt("unselectAuto")&&((n=this.opt("unselectCancel"))&&t(e.target).closest(n).length||this.unselect(e))},processEventUnselect:function(e){this.selectedEventInstance&&(t(e.target).closest(".fc-selected").length||this.unselectEventInstance())},triggerDayClick:function(t,e,n){var i=this.calendar.footprintToDateProfile(t);this.publiclyTrigger("dayClick",{context:e,args:[i.start,n,this]})}});be.watch("displayingDates",["dateProfile"],function(t){this.requestDateRender(t.dateProfile)},function(){this.requestDateUnrender()}),be.watch("initialEvents",["dateProfile"],function(t){return this.fetchInitialEvents(t.dateProfile)}),be.watch("bindingEvents",["initialEvents"],function(t){this.setEvents(t.initialEvents),this.bindEventChanges()},function(){this.unbindEventChanges(),this.unsetEvents()}),be.watch("displayingEvents",["displayingDates","hasEvents"],function(){this.requestEventsRender(this.get("currentEvents"))},function(){this.requestEventsUnrender()}),be.mixin({currentUnzonedRange:null,currentRangeUnit:null,isRangeAllDay:!1,renderUnzonedRange:null,activeUnzonedRange:null,validUnzonedRange:null,dateIncrement:null,minTime:null,maxTime:null,usesMinMaxTime:!1,start:null,end:null,intervalStart:null,intervalEnd:null,setDateProfileForRendering:function(t){var e=this.calendar;this.currentUnzonedRange=t.currentUnzonedRange,this.currentRangeUnit=t.currentRangeUnit,this.isRangeAllDay=t.isRangeAllDay,this.renderUnzonedRange=t.renderUnzonedRange,this.activeUnzonedRange=t.activeUnzonedRange,this.validUnzonedRange=t.validUnzonedRange,this.dateIncrement=t.dateIncrement,this.minTime=t.minTime,this.maxTime=t.maxTime,this.start=e.msToMoment(t.activeUnzonedRange.startMs,this.isRangeAllDay),this.end=e.msToMoment(t.activeUnzonedRange.endMs,this.isRangeAllDay),this.intervalStart=e.msToMoment(t.currentUnzonedRange.startMs,this.isRangeAllDay),this.intervalEnd=e.msToMoment(t.currentUnzonedRange.endMs,this.isRangeAllDay),this.title=this.computeTitle(),this.calendar.reportViewDatesChanged(this,t)},buildPrevDateProfile:function(t){var e=t.clone().startOf(this.currentRangeUnit).subtract(this.dateIncrement);return this.buildDateProfile(e,-1)},buildNextDateProfile:function(t){var e=t.clone().startOf(this.currentRangeUnit).add(this.dateIncrement);return this.buildDateProfile(e,1)},buildDateProfile:function(t,n,i){var s,r,o,a,l=!t.hasTime(),u=this.buildValidRange(),c=null,h=null;return i&&(t=this.calendar.msToUtcMoment(u.constrainDate(t),l)),s=this.buildCurrentRangeInfo(t,n),r=this.buildRenderRange(s.unzonedRange,s.unit),o=r.clone(),this.opt("showNonCurrentDates")||(o=o.intersect(s.unzonedRange)),c=e.duration(this.opt("minTime")),h=e.duration(this.opt("maxTime")),o=this.adjustActiveRange(o,c,h),o=o.intersect(u),o&&(t=this.calendar.msToUtcMoment(o.constrainDate(t),l)),a=s.unzonedRange.intersectsWith(u),{validUnzonedRange:u,currentUnzonedRange:s.unzonedRange,currentRangeUnit:s.unit,isRangeAllDay:/^(year|month|week|day)$/.test(s.unit),activeUnzonedRange:o,renderUnzonedRange:r,minTime:c,maxTime:h,isValid:a,date:t,dateIncrement:this.buildDateIncrement(s.duration)}},buildValidRange:function(){return this.getUnzonedRangeOption("validRange",this.calendar.getNow())||new Me},buildCurrentRangeInfo:function(t,e){var n,i=null,s=null,r=null;return this.viewSpec.duration?(i=this.viewSpec.duration,s=this.viewSpec.durationUnit,r=this.buildRangeFromDuration(t,e,i,s)):(n=this.opt("dayCount"))?(s="day",r=this.buildRangeFromDayCount(t,e,n)):(r=this.buildCustomVisibleRange(t))?s=O(r.getStart(),r.getEnd()):(i=this.getFallbackDuration(),s=O(i),r=this.buildRangeFromDuration(t,e,i,s)),{duration:i,unit:s,unzonedRange:r}},getFallbackDuration:function(){return e.duration({days:1})},adjustActiveRange:function(t,e,n){var i=t.getStart(),s=t.getEnd();return this.usesMinMaxTime&&(e<0&&i.time(0).add(e),n>864e5&&s.time(n-864e5)),new Me(i,s)},buildRangeFromDuration:function(t,n,i,s){var r,o,a,l=this.opt("dateAlignment"),u=t.clone();return i.as("days")<=1&&this.isHiddenDay(u)&&(u=this.skipHiddenDays(u,n),u.startOf("day")),l||(o=this.opt("dateIncrement"),o?(a=e.duration(o),l=a<i?N(a,o):s):l=s),u.startOf(l),r=u.clone().add(i),new Me(u,r)},buildRangeFromDayCount:function(t,e,n){var i,s=this.opt("dateAlignment"),r=0,o=t.clone();s&&o.startOf(s),o.startOf("day"),o=this.skipHiddenDays(o,e),i=o.clone();do{i.add(1,"day"),this.isHiddenDay(i)||r++}while(r<n);return new Me(o,i)},buildCustomVisibleRange:function(t){var e=this.getUnzonedRangeOption("visibleRange",this.calendar.applyTimezone(t));return!e||null!==e.startMs&&null!==e.endMs?e:null},buildRenderRange:function(t,e){return this.trimHiddenDays(t)},buildDateIncrement:function(t){var n,i=this.opt("dateIncrement");return i?e.duration(i):(n=this.opt("dateAlignment"))?e.duration(1,n):t||e.duration({days:1})},trimHiddenDays:function(t){var e=t.getStart(),n=t.getEnd();return e=this.skipHiddenDays(e),n=this.skipHiddenDays(n,-1,!0),new Me(e,n)},currentRangeAs:function(t){var n=this.currentUnzonedRange;return e.utc(n.endMs).diff(e.utc(n.startMs),t,!0)},isDateInOtherMonth:function(t){return!1},getUnzonedRangeOption:function(t){var e=this.opt(t);if("function"==typeof e&&(e=e.apply(null,Array.prototype.slice.call(arguments,1))),e)return this.calendar.parseUnzonedRange(e)},initHiddenDays:function(){var e,n=this.opt("hiddenDays")||[],i=[],s=0;for(!1===this.opt("weekends")&&n.push(0,6),e=0;e<7;e++)(i[e]=-1!==t.inArray(e,n))||s++;if(!s)throw"invalid hiddenDays";this.isHiddenDayHash=i},isHiddenDay:function(t){return e.isMoment(t)&&(t=t.day()),this.isHiddenDayHash[t]},skipHiddenDays:function(t,e,n){var i=t.clone();for(e=e||1;this.isHiddenDayHash[(i.day()+(n?e:0)+7)%7];)i.add(e,"days");return i}});var Se=Vt.Scroller=ht.extend({el:null,scrollEl:null,overflowX:null,overflowY:null,constructor:function(t){t=t||{},this.overflowX=t.overflowX||t.overflow||"auto",this.overflowY=t.overflowY||t.overflow||"auto"},render:function(){this.el=this.renderEl(),this.applyOverflow()},renderEl:function(){return this.scrollEl=t('<div class="fc-scroller"></div>')},clear:function(){this.setHeight("auto"),this.applyOverflow()},destroy:function(){this.el.remove()},applyOverflow:function(){this.scrollEl.css({"overflow-x":this.overflowX,"overflow-y":this.overflowY})},lockOverflow:function(t){var e=this.overflowX,n=this.overflowY;t=t||this.getScrollbarWidths(),"auto"===e&&(e=t.top||t.bottom||this.scrollEl[0].scrollWidth-1>this.scrollEl[0].clientWidth?"scroll":"hidden"),"auto"===n&&(n=t.left||t.right||this.scrollEl[0].scrollHeight-1>this.scrollEl[0].clientHeight?"scroll":"hidden"),this.scrollEl.css({"overflow-x":e,"overflow-y":n})},setHeight:function(t){this.scrollEl.height(t)},getScrollTop:function(){return this.scrollEl.scrollTop()},setScrollTop:function(t){this.scrollEl.scrollTop(t)},getClientWidth:function(){return this.scrollEl[0].clientWidth},getClientHeight:function(){return this.scrollEl[0].clientHeight},getScrollbarWidths:function(){return p(this.scrollEl)}});Rt.prototype.proxyCall=function(t){var e=Array.prototype.slice.call(arguments,1),n=[];return this.items.forEach(function(i){n.push(i[t].apply(i,e))}),n};var Ee=Vt.Calendar=ht.extend(ee,{view:null,viewsByType:null,currentDate:null,theme:null,loadingLevel:0,constructor:function(t,e){ge.needed(),this.el=t,this.viewsByType={},this.viewSpecCache={},this.initOptionsInternals(e),this.initMomentInternals(),this.initCurrentDate(),this.initEventManager(),ze.call(this),this.initialize()},initialize:function(){},getView:function(){return this.view},publiclyTrigger:function(e,n){var i,s,r=this.opt(e);if(t.isPlainObject(n)?(i=n.context,s=n.args):t.isArray(n)&&(s=n),null==i&&(i=this.el[0]),s||(s=[]),this.triggerWith(e,i,s),r)return r.apply(i,s)},hasPublicHandlers:function(t){return this.hasHandlers(t)||this.opt(t)},instantiateView:function(t){var e=this.getViewSpec(t);return new e.class(this,e)},isValidViewType:function(t){return Boolean(this.getViewSpec(t))},changeView:function(t,e){e&&(e.start&&e.end?this.recordOptionOverrides({visibleRange:e}):this.currentDate=this.moment(e).stripZone()),this.renderView(t)},zoomTo:function(t,e){var n;e=e||"day",n=this.getViewSpec(e)||this.getUnitViewSpec(e),this.currentDate=t.clone(),this.renderView(n?n.type:null)},initCurrentDate:function(){var t=this.opt("defaultDate");this.currentDate=null!=t?this.moment(t).stripZone():this.getNow()},reportViewDatesChanged:function(t,e){this.currentDate=e.date,this.setToolbarsTitle(t.title),this.updateToolbarButtons()},prev:function(){var t=this.view.buildPrevDateProfile(this.currentDate);t.isValid&&(this.currentDate=t.date,this.renderView())},next:function(){var t=this.view.buildNextDateProfile(this.currentDate);t.isValid&&(this.currentDate=t.date,this.renderView())},prevYear:function(){this.currentDate.add(-1,"years"),this.renderView()},nextYear:function(){this.currentDate.add(1,"years"),this.renderView()},today:function(){this.currentDate=this.getNow(),this.renderView()},gotoDate:function(t){this.currentDate=this.moment(t).stripZone(),this.renderView()},incrementDate:function(t){this.currentDate.add(e.duration(t)),this.renderView()},getDate:function(){return this.applyTimezone(this.currentDate)},pushLoading:function(){this.loadingLevel++||this.publiclyTrigger("loading",[!0,this.view])},popLoading:function(){--this.loadingLevel||this.publiclyTrigger("loading",[!1,this.view])},select:function(t,e){this.view.select(this.buildSelectFootprint.apply(this,arguments))},unselect:function(){this.view&&this.view.unselect()},buildSelectFootprint:function(t,e){var n,i=this.moment(t).stripZone();return n=e?this.moment(e).stripZone():i.hasTime()?i.clone().add(this.defaultTimedEventDuration):i.clone().add(this.defaultAllDayEventDuration),new xe(new Me(i,n),!i.hasTime())},parseUnzonedRange:function(t){var e=null,n=null;return t.start&&(e=this.moment(t.start).stripZone()),t.end&&(n=this.moment(t.end).stripZone()),e||n?e&&n&&n.isBefore(e)?null:new Me(e,n):null},rerenderEvents:function(){this.elementVisible()&&this.view.flash("displayingEvents")},initEventManager:function(){var t=this,e=new ze(this),n=this.opt("eventSources")||[],i=this.opt("events");this.eventManager=e,i&&n.unshift(i),e.on("release",function(e){t.trigger("eventsReset",e)}),e.freeze(),n.forEach(function(n){var i=qe.parse(n,t);i&&e.addSource(i)}),e.thaw()},requestEvents:function(t,e){return this.eventManager.requestEvents(t,e,this.opt("timezone"),this.opt("lazyFetching"))}});Ee.mixin({dirDefaults:null,localeDefaults:null,overrides:null,dynamicOverrides:null,optionsModel:null,initOptionsInternals:function(e){this.overrides=t.extend({},e),this.dynamicOverrides={},this.optionsModel=new oe,this.populateOptionsHash()},option:function(t,e){var n;if("string"==typeof t){if(void 0===e)return this.optionsModel.get(t);n={},n[t]=e,this.setOptions(n)}else"object"==typeof t&&this.setOptions(t)},opt:function(t){return this.optionsModel.get(t)},setOptions:function(t){var e,n=0;this.recordOptionOverrides(t);for(e in t)n++;if(1===n){if("height"===e||"contentHeight"===e||"aspectRatio"===e)return void this.updateSize(!0);if("defaultDate"===e)return;if("businessHours"===e)return void(this.view&&(this.view.unrenderBusinessHours(),this.view.renderBusinessHours()));if("timezone"===e)return void this.view.flash("initialEvents")}this.renderHeader(),this.renderFooter(),this.viewsByType={},this.reinitView()},populateOptionsHash:function(){var t,e,i,s,r;t=J(this.dynamicOverrides.locale,this.overrides.locale),e=Te[t],e||(t=Ee.defaults.locale,e=Te[t]||{}),i=J(this.dynamicOverrides.isRTL,this.overrides.isRTL,e.isRTL,Ee.defaults.isRTL),s=i?Ee.rtlDefaults:{},this.dirDefaults=s,this.localeDefaults=e,r=n([Ee.defaults,s,e,this.overrides,this.dynamicOverrides]),zt(r),this.optionsModel.reset(r)},recordOptionOverrides:function(t){var e;for(e in t)this.dynamicOverrides[e]=t[e];this.viewSpecCache={},this.populateOptionsHash()}}),Ee.mixin({defaultAllDayEventDuration:null,defaultTimedEventDuration:null,localeData:null,initMomentInternals:function(){var t=this;this.defaultAllDayEventDuration=e.duration(this.opt("defaultAllDayEventDuration")),this.defaultTimedEventDuration=e.duration(this.opt("defaultTimedEventDuration")),this.optionsModel.watch("buildingMomentLocale",["?locale","?monthNames","?monthNamesShort","?dayNames","?dayNamesShort","?firstDay","?weekNumberCalculation"],function(e){var n,i=e.weekNumberCalculation,s=e.firstDay;"iso"===i&&(i="ISO");var r=Object.create(Ft(e.locale));e.monthNames&&(r._months=e.monthNames),e.monthNamesShort&&(r._monthsShort=e.monthNamesShort),e.dayNames&&(r._weekdays=e.dayNames),e.dayNamesShort&&(r._weekdaysShort=e.dayNamesShort),null==s&&"ISO"===i&&(s=1),null!=s&&(n=Object.create(r._week),n.dow=s,r._week=n),"ISO"!==i&&"local"!==i&&"function"!=typeof i||(r._fullCalendar_weekCalc=i),t.localeData=r,t.currentDate&&t.localizeMoment(t.currentDate)})},moment:function(){var t;return"local"===this.opt("timezone")?(t=Vt.moment.apply(null,arguments),t.hasTime()&&t.local()):t="UTC"===this.opt("timezone")?Vt.moment.utc.apply(null,arguments):Vt.moment.parseZone.apply(null,arguments),this.localizeMoment(t),t},msToMoment:function(t,e){var n=Vt.moment.utc(t);return e?n.stripTime():n=this.applyTimezone(n),this.localizeMoment(n),n},msToUtcMoment:function(t,e){var n=Vt.moment.utc(t);return e&&n.stripTime(),this.localizeMoment(n),n},localizeMoment:function(t){t._locale=this.localeData},getIsAmbigTimezone:function(){return"local"!==this.opt("timezone")&&"UTC"!==this.opt("timezone")},applyTimezone:function(t){if(!t.hasTime())return t.clone();var e,n=this.moment(t.toArray()),i=t.time()-n.time();return i&&(e=n.clone().add(i),t.time()-e.time()==0&&(n=e)),n},footprintToDateProfile:function(t,e){var n,i=Vt.moment.utc(t.unzonedRange.startMs);return e||(n=Vt.moment.utc(t.unzonedRange.endMs)),t.isAllDay?(i.stripTime(),n&&n.stripTime()):(i=this.applyTimezone(i),n&&(n=this.applyTimezone(n))),new Ne(i,n,this)},getNow:function(){var t=this.opt("now");return"function"==typeof t&&(t=t()),this.moment(t).stripZone()},humanizeDuration:function(t){return t.locale(this.opt("locale")).humanize()},getEventEnd:function(t){return t.end?t.end.clone():this.getDefaultEventEnd(t.allDay,t.start)},getDefaultEventEnd:function(t,e){var n=e.clone();return t?n.stripTime().add(this.defaultAllDayEventDuration):n.add(this.defaultTimedEventDuration),this.getIsAmbigTimezone()&&n.stripZone(),n}}),Ee.mixin({viewSpecCache:null,getViewSpec:function(t){var e=this.viewSpecCache;return e[t]||(e[t]=this.buildViewSpec(t))},getUnitViewSpec:function(e){var n,i,s;if(-1!=t.inArray(e,qt))for(n=this.header.getViewsWithButtons(),t.each(Vt.views,function(t){n.push(t)}),i=0;i<n.length;i++)if((s=this.getViewSpec(n[i]))&&s.singleUnit==e)return s},buildViewSpec:function(t){for(var i,s,r,o,a,l=this.overrides.views||{},u=[],c=[],h=[],d=t;d;)i=Ut[d],s=l[d],d=null,"function"==typeof i&&(i={class:i}),i&&(u.unshift(i),c.unshift(i.defaults||{}),r=r||i.duration,d=d||i.type),s&&(h.unshift(s),r=r||s.duration,d=d||s.type);return i=j(u),i.type=t,!!i.class&&(r=r||this.dynamicOverrides.duration||this.overrides.duration,r&&(o=e.duration(r),o.valueOf()&&(a=N(o,r),i.duration=o,i.durationUnit=a,1===o.as(a)&&(i.singleUnit=a,h.unshift(l[a]||{})))),i.defaults=n(c),i.overrides=n(h),this.buildViewSpecOptions(i),this.buildViewSpecButtonText(i,t),i)},buildViewSpecOptions:function(t){t.options=n([Ee.defaults,t.defaults,this.dirDefaults,this.localeDefaults,this.overrides,t.overrides,this.dynamicOverrides]),zt(t.options)},buildViewSpecButtonText:function(t,e){function n(n){var i=n.buttonText||{};return i[e]||(t.buttonTextKey?i[t.buttonTextKey]:null)||(t.singleUnit?i[t.singleUnit]:null)}t.buttonTextOverride=n(this.dynamicOverrides)||n(this.overrides)||t.overrides.buttonText,t.buttonTextDefault=n(this.localeDefaults)||n(this.dirDefaults)||t.defaults.buttonText||n(Ee.defaults)||(t.duration?this.humanizeDuration(t.duration):null)||e}}),Ee.mixin({el:null,contentEl:null,suggestedViewHeight:null,windowResizeProxy:null,ignoreWindowResize:0,render:function(){this.contentEl?this.elementVisible()&&(this.calcSize(),this.renderView()):this.initialRender()},initialRender:function(){var e=this,n=this.el;n.addClass("fc"),n.on("click.fc","a[data-goto]",function(n){var i=t(this),s=i.data("goto"),r=e.moment(s.date),o=s.type,a=e.view.opt("navLink"+st(o)+"Click");"function"==typeof a?a(r,n):("string"==typeof a&&(o=a),e.zoomTo(r,o))}),this.optionsModel.watch("settingTheme",["?theme","?themeSystem"],function(t){var i=Qe.getThemeClass(t.themeSystem||t.theme),s=new i(e.optionsModel),r=s.getClass("widget");e.theme=s,r&&n.addClass(r)},function(){var t=e.theme.getClass("widget");e.theme=null,t&&n.removeClass(t)}),this.optionsModel.watch("applyingDirClasses",["?isRTL","?locale"],function(t){n.toggleClass("fc-ltr",!t.isRTL),n.toggleClass("fc-rtl",t.isRTL)}),this.contentEl=t("<div class='fc-view-container'/>").prependTo(n),this.initToolbars(),this.renderHeader(),this.renderFooter(),this.renderView(this.opt("defaultView")),this.opt("handleWindowResize")&&t(window).resize(this.windowResizeProxy=lt(this.windowResize.bind(this),this.opt("windowResizeDelay")))},destroy:function(){this.view&&this.view.removeElement(),this.toolbarsManager.proxyCall("removeElement"),this.contentEl.remove(),this.el.removeClass("fc fc-ltr fc-rtl"),this.optionsModel.unwatch("settingTheme"),this.el.off(".fc"),this.windowResizeProxy&&(t(window).unbind("resize",this.windowResizeProxy),this.windowResizeProxy=null),ge.unneeded()},elementVisible:function(){return this.el.is(":visible")},renderView:function(e,n){this.ignoreWindowResize++;var i=this.view&&e&&this.view.type!==e;i&&(this.freezeContentHeight(),this.clearView()),!this.view&&e&&(this.view=this.viewsByType[e]||(this.viewsByType[e]=this.instantiateView(e)),this.view.setElement(t("<div class='fc-view fc-"+e+"-view' />").appendTo(this.contentEl)),this.toolbarsManager.proxyCall("activateButton",e)),this.view&&(n&&this.view.addForcedScroll(n),this.elementVisible()&&this.view.setDate(this.currentDate)),i&&this.thawContentHeight(),this.ignoreWindowResize--},clearView:function(){this.toolbarsManager.proxyCall("deactivateButton",this.view.type),this.view.removeElement(),this.view=null},reinitView:function(){this.ignoreWindowResize++,this.freezeContentHeight();var t=this.view.type,e=this.view.queryScroll();this.clearView(),this.calcSize(),this.renderView(t,e),this.thawContentHeight(),this.ignoreWindowResize--},getSuggestedViewHeight:function(){return null===this.suggestedViewHeight&&this.calcSize(),this.suggestedViewHeight},isHeightAuto:function(){return"auto"===this.opt("contentHeight")||"auto"===this.opt("height")},updateSize:function(t){if(this.elementVisible())return t&&this._calcSize(),this.ignoreWindowResize++,this.view.updateSize(!0),this.ignoreWindowResize--,!0},calcSize:function(){this.elementVisible()&&this._calcSize()},_calcSize:function(){var t=this.opt("contentHeight"),e=this.opt("height");this.suggestedViewHeight="number"==typeof t?t:"function"==typeof t?t():"number"==typeof e?e-this.queryToolbarsHeight():"function"==typeof e?e()-this.queryToolbarsHeight():"parent"===e?this.el.parent().height()-this.queryToolbarsHeight():Math.round(this.contentEl.width()/Math.max(this.opt("aspectRatio"),.5))},windowResize:function(t){!this.ignoreWindowResize&&t.target===window&&this.view.renderUnzonedRange&&this.updateSize(!0)&&this.publiclyTrigger("windowResize",[this.view])},freezeContentHeight:function(){this.contentEl.css({width:"100%",height:this.contentEl.height(),overflow:"hidden"})},thawContentHeight:function(){this.contentEl.css({width:"",height:"",overflow:""})}}),Ee.mixin({header:null,footer:null,toolbarsManager:null,initToolbars:function(){this.header=new It(this,this.computeHeaderOptions()),this.footer=new It(this,this.computeFooterOptions()),this.toolbarsManager=new Rt([this.header,this.footer])},computeHeaderOptions:function(){return{extraClasses:"fc-header-toolbar",layout:this.opt("header")}},computeFooterOptions:function(){return{extraClasses:"fc-footer-toolbar",layout:this.opt("footer")}},renderHeader:function(){var t=this.header;t.setToolbarOptions(this.computeHeaderOptions()),t.render(),t.el&&this.el.prepend(t.el)},renderFooter:function(){var t=this.footer;t.setToolbarOptions(this.computeFooterOptions()),t.render(),t.el&&this.el.append(t.el)},setToolbarsTitle:function(t){this.toolbarsManager.proxyCall("updateTitle",t)},updateToolbarButtons:function(){var t=this.getNow(),e=this.view,n=e.buildDateProfile(t),i=e.buildPrevDateProfile(this.currentDate),s=e.buildNextDateProfile(this.currentDate);this.toolbarsManager.proxyCall(n.isValid&&!e.currentUnzonedRange.containsDate(t)?"enableButton":"disableButton","today"),this.toolbarsManager.proxyCall(i.isValid?"enableButton":"disableButton","prev"),this.toolbarsManager.proxyCall(s.isValid?"enableButton":"disableButton","next")},queryToolbarsHeight:function(){return this.toolbarsManager.items.reduce(function(t,e){return t+(e.el?e.el.outerHeight(!0):0)},0)}});var Ce={start:"09:00",end:"17:00",dow:[1,2,3,4,5],rendering:"inverse-background"};Ee.prototype.buildCurrentBusinessFootprints=function(t){return this._buildCurrentBusinessFootprints(t,this.opt("businessHours"))},Ee.prototype._buildCurrentBusinessFootprints=function(t,e){var n,i=this.eventManager.currentPeriod;return i&&(n=this.buildBusinessInstanceGroup(t,e,i.unzonedRange))?this.eventInstancesToFootprints(n.eventInstances):[]},Ee.prototype.buildBusinessInstanceGroup=function(t,e,n){var i,s=this.buildBusinessDefs(t,e);if(s.length)return i=new Oe(At(s,n)),i.explicitEventDef=s[0],i},Ee.prototype.buildBusinessDefs=function(e,n){var i,s=[],r=!1,o=[];for(!0===n?s=[{}]:t.isPlainObject(n)?s=[n]:t.isArray(n)&&(s=n,r=!0),i=0;i<s.length;i++)r&&!s[i].dow||o.push(this.buildBusinessDef(e,s[i]));return o},Ee.prototype.buildBusinessDef=function(e,n){var i=t.extend({},Ce,n);return e&&(i.start=null,i.end=null),Ae.parse(i,new _e(this))},Ee.prototype.isEventInstanceGroupAllowed=function(t){var e,n=t.getEventDef(),i=this.eventRangesToEventFootprints(t.getAllEventRanges()),s=this.getPeerEventInstances(n),r=Lt(s),o=this.eventRangesToEventFootprints(r),a=n.getConstraint(),l=n.getOverlap(),u=this.opt("eventAllow");for(e=0;e<i.length;e++)if(!this.isFootprintAllowed(i[e].componentFootprint,o,a,l,i[e].eventInstance))return!1;if(u)for(e=0;e<i.length;e++)if(!1===u(i[e].componentFootprint.toLegacy(this),i[e].getEventLegacy()))return!1;return!0},Ee.prototype.getPeerEventInstances=function(t){return this.eventManager.getEventInstancesWithoutId(t.id)},Ee.prototype.isSelectionFootprintAllowed=function(t){var e,n=this.eventManager.getEventInstances(),i=Lt(n),s=this.eventRangesToEventFootprints(i);return!!this.isFootprintAllowed(t,s,this.opt("selectConstraint"),this.opt("selectOverlap"))&&(!(e=this.opt("selectAllow"))||!1!==e(t.toLegacy(this)))},Ee.prototype.isFootprintAllowed=function(t,e,n,i,s){var r,o;if(null!=n&&(r=this.constraintValToFootprints(n,t.isAllDay),!this.isFootprintWithinConstraints(t,r)))return!1;if(o=this.collectOverlapEventFootprints(e,t),!1===i){if(o.length)return!1}else if("function"==typeof i&&!Ht(o,i,s))return!1;return!(s&&!Mt(o,s))},Ee.prototype.isFootprintWithinConstraints=function(t,e){var n;for(n=0;n<e.length;n++)if(this.footprintContainsFootprint(e[n],t))return!0;return!1},Ee.prototype.constraintValToFootprints=function(t,e){var n;return"businessHours"===t?this.buildCurrentBusinessFootprints(e):"object"==typeof t?(n=this.parseEventDefToInstances(t),n?this.eventInstancesToFootprints(n):this.parseFootprints(t)):null!=t?(n=this.eventManager.getEventInstancesWithId(t),this.eventInstancesToFootprints(n)):void 0},Ee.prototype.eventInstancesToFootprints=function(t){return Nt(this.eventRangesToEventFootprints(Lt(t)))},Ee.prototype.collectOverlapEventFootprints=function(t,e){var n,i=[];for(n=0;n<t.length;n++)this.footprintsIntersect(e,t[n].componentFootprint)&&i.push(t[n]);return i},Ee.prototype.parseEventDefToInstances=function(t){var e=this.eventManager.currentPeriod,n=Pe.parse(t,new _e(this));return!!n&&(e?n.buildInstances(e.unzonedRange):[])},Ee.prototype.eventRangesToEventFootprints=function(t){var e,n=[];for(e=0;e<t.length;e++)n.push.apply(n,this.eventRangeToEventFootprints(t[e]));return n},Ee.prototype.eventRangeToEventFootprints=function(t){return[new Ue(new xe(t.unzonedRange,t.eventDef.isAllDay()),t.eventDef,t.eventInstance)]},Ee.prototype.parseFootprints=function(t){var e,n;return t.start&&(e=this.moment(t.start),e.isValid()||(e=null)),t.end&&(n=this.moment(t.end),n.isValid()||(n=null)),[new xe(new Me(e,n),e&&!e.hasTime()||n&&!n.hasTime())]},Ee.prototype.footprintContainsFootprint=function(t,e){return t.unzonedRange.containsRange(e.unzonedRange)},Ee.prototype.footprintsIntersect=function(t,e){return t.unzonedRange.intersectsWith(e.unzonedRange)},Ee.mixin({getEventSources:function(){return this.eventManager.otherSources.slice()},getEventSourceById:function(t){return this.eventManager.getSourceById(_e.normalizeId(t))},addEventSource:function(t){var e=qe.parse(t,this);e&&this.eventManager.addSource(e)},removeEventSources:function(t){var e,n,i=this.eventManager;if(null==t)this.eventManager.removeAllSources();else{for(e=i.multiQuerySources(t),i.freeze(),n=0;n<e.length;n++)i.removeSource(e[n]);i.thaw()}},removeEventSource:function(t){var e,n=this.eventManager,i=n.querySources(t);for(n.freeze(),e=0;e<i.length;e++)n.removeSource(i[e]);n.thaw()},
	refetchEventSources:function(t){var e,n=this.eventManager,i=n.multiQuerySources(t);for(n.freeze(),e=0;e<i.length;e++)n.refetchSource(i[e]);n.thaw()},refetchEvents:function(){this.eventManager.refetchAllSources()},renderEvents:function(t,e){this.eventManager.freeze();for(var n=0;n<t.length;n++)this.renderEvent(t[n],e);this.eventManager.thaw()},renderEvent:function(t,e){var n=this.eventManager,i=Pe.parse(t,t.source||n.stickySource);i&&n.addEventDef(i,e)},removeEvents:function(t){var e,n,i,s=this.eventManager,r=s.getEventInstances(),o={};if(null==t)s.removeAllEventDefs();else{for(e=r.map(function(t){return t.toLegacy()}),e=xt(e,t),i=0;i<e.length;i++)n=this.eventManager.getEventDefByUid(e[i]._id),o[n.id]=!0;s.freeze();for(i in o)s.removeEventDefsById(i);s.thaw()}},clientEvents:function(t){return xt(this.eventManager.getEventInstances().map(function(t){return t.toLegacy()}),t)},updateEvents:function(t){this.eventManager.freeze();for(var e=0;e<t.length;e++)this.updateEvent(t[e]);this.eventManager.thaw()},updateEvent:function(t){var e,n,i=this.eventManager.getEventDefByUid(t._id);i instanceof ke&&(e=i.buildInstance(),n=Ge.createFromRawProps(e,t,null),this.eventManager.mutateEventsWithId(i.id,n))}}),Ee.defaults={titleRangeSeparator:" – ",monthYearFormat:"MMMM YYYY",defaultTimedEventDuration:"02:00:00",defaultAllDayEventDuration:{days:1},forceEventDuration:!1,nextDayThreshold:"09:00:00",defaultView:"month",aspectRatio:1.35,header:{left:"title",center:"",right:"today prev,next"},weekends:!0,weekNumbers:!1,weekNumberTitle:"W",weekNumberCalculation:"local",scrollTime:"06:00:00",minTime:"00:00:00",maxTime:"24:00:00",showNonCurrentDates:!0,lazyFetching:!0,startParam:"start",endParam:"end",timezoneParam:"timezone",timezone:!1,isRTL:!1,buttonText:{prev:"prev",next:"next",prevYear:"prev year",nextYear:"next year",year:"year",today:"today",month:"month",week:"week",day:"day"},allDayText:"all-day",theme:!1,dragOpacity:.75,dragRevertDuration:500,dragScroll:!0,unselectAuto:!0,dropAccept:"*",eventOrder:"title",eventLimit:!1,eventLimitText:"more",eventLimitClick:"popover",dayPopoverFormat:"LL",handleWindowResize:!0,windowResizeDelay:100,longPressDelay:1e3},Ee.englishDefaults={dayPopoverFormat:"dddd, MMMM D"},Ee.rtlDefaults={header:{left:"next,prev today",center:"",right:"title"},buttonIcons:{prev:"right-single-arrow",next:"left-single-arrow",prevYear:"right-double-arrow",nextYear:"left-double-arrow"},themeButtonIcons:{prev:"circle-triangle-e",next:"circle-triangle-w",nextYear:"seek-prev",prevYear:"seek-next"}};var Te=Vt.locales={};Vt.datepickerLocale=function(e,n,i){var s=Te[e]||(Te[e]={});s.isRTL=i.isRTL,s.weekNumberTitle=i.weekHeader,t.each(Re,function(t,e){s[t]=e(i)}),t.datepicker&&(t.datepicker.regional[n]=t.datepicker.regional[e]=i,t.datepicker.regional.en=t.datepicker.regional[""],t.datepicker.setDefaults(i))},Vt.locale=function(e,i){var s,r;s=Te[e]||(Te[e]={}),i&&(s=Te[e]=n([s,i])),r=Ft(e),t.each(Ie,function(t,e){null==s[t]&&(s[t]=e(r,s))}),Ee.defaults.locale=e};var Re={buttonText:function(t){return{prev:et(t.prevText),next:et(t.nextText),today:et(t.currentText)}},monthYearFormat:function(t){return t.showMonthAfterYear?"YYYY["+t.yearSuffix+"] MMMM":"MMMM YYYY["+t.yearSuffix+"]"}},Ie={dayOfMonthFormat:function(t,e){var n=t.longDateFormat("l");return n=n.replace(/^Y+[^\w\s]*|[^\w\s]*Y+$/g,""),e.isRTL?n+=" ddd":n="ddd "+n,n},mediumTimeFormat:function(t){return t.longDateFormat("LT").replace(/\s*a$/i,"a")},smallTimeFormat:function(t){return t.longDateFormat("LT").replace(":mm","(:mm)").replace(/(\Wmm)$/,"($1)").replace(/\s*a$/i,"a")},extraSmallTimeFormat:function(t){return t.longDateFormat("LT").replace(":mm","(:mm)").replace(/(\Wmm)$/,"($1)").replace(/\s*a$/i,"t")},hourFormat:function(t){return t.longDateFormat("LT").replace(":mm","").replace(/(\Wmm)$/,"").replace(/\s*a$/i,"a")},noMeridiemTimeFormat:function(t){return t.longDateFormat("LT").replace(/\s*a$/i,"")}},He={smallDayDateFormat:function(t){return t.isRTL?"D dd":"dd D"},weekFormat:function(t){return t.isRTL?"w[ "+t.weekNumberTitle+"]":"["+t.weekNumberTitle+" ]w"},smallWeekFormat:function(t){return t.isRTL?"w["+t.weekNumberTitle+"]":"["+t.weekNumberTitle+"]w"}};Vt.locale("en",Ee.englishDefaults);var Me=Vt.UnzonedRange=ht.extend({startMs:null,endMs:null,isStart:!0,isEnd:!0,constructor:function(t,n){e.isMoment(t)&&(t=t.clone().stripZone()),e.isMoment(n)&&(n=n.clone().stripZone()),t&&(this.startMs=t.valueOf()),n&&(this.endMs=n.valueOf())},intersect:function(t){var e=this.startMs,n=this.endMs,i=null;return null!==t.startMs&&(e=null===e?t.startMs:Math.max(e,t.startMs)),null!==t.endMs&&(n=null===n?t.endMs:Math.min(n,t.endMs)),(null===e||null===n||e<n)&&(i=new Me(e,n),i.isStart=this.isStart&&e===this.startMs,i.isEnd=this.isEnd&&n===this.endMs),i},intersectsWith:function(t){return(null===this.endMs||null===t.startMs||this.endMs>t.startMs)&&(null===this.startMs||null===t.endMs||this.startMs<t.endMs)},containsRange:function(t){return(null===this.startMs||null!==t.startMs&&t.startMs>=this.startMs)&&(null===this.endMs||null!==t.endMs&&t.endMs<=this.endMs)},containsDate:function(t){var e=t.valueOf();return(null===this.startMs||e>=this.startMs)&&(null===this.endMs||e<this.endMs)},constrainDate:function(t){var e=t.valueOf();return null!==this.startMs&&e<this.startMs&&(e=this.startMs),null!==this.endMs&&e>=this.endMs&&(e=this.endMs-1),e},equals:function(t){return this.startMs===t.startMs&&this.endMs===t.endMs},clone:function(){var t=new Me(this.startMs,this.endMs);return t.isStart=this.isStart,t.isEnd=this.isEnd,t},getStart:function(){if(null!==this.startMs)return Vt.moment.utc(this.startMs).stripZone()},getEnd:function(){if(null!==this.endMs)return Vt.moment.utc(this.endMs).stripZone()}}),xe=Vt.ComponentFootprint=ht.extend({unzonedRange:null,isAllDay:!1,constructor:function(t,e){this.unzonedRange=t,this.isAllDay=e},toLegacy:function(t){return{start:t.msToMoment(this.unzonedRange.startMs,this.isAllDay),end:t.msToMoment(this.unzonedRange.endMs,this.isAllDay)}}}),ze=ht.extend(ee,ne,{currentPeriod:null,calendar:null,stickySource:null,otherSources:null,constructor:function(t){this.calendar=t,this.stickySource=new Ye(t),this.otherSources=[]},requestEvents:function(t,e,n,i){return!i&&this.currentPeriod&&this.currentPeriod.isWithinRange(t,e)||this.setPeriod(new Fe(t,e,n)),this.currentPeriod.whenReleased()},addSource:function(t){this.otherSources.push(t),this.currentPeriod&&this.currentPeriod.requestSource(t)},removeSource:function(t){K(this.otherSources,t),this.currentPeriod&&this.currentPeriod.purgeSource(t)},removeAllSources:function(){this.otherSources=[],this.currentPeriod&&this.currentPeriod.purgeAllSources()},refetchSource:function(t){var e=this.currentPeriod;e&&(e.freeze(),e.purgeSource(t),e.requestSource(t),e.thaw())},refetchAllSources:function(){var t=this.currentPeriod;t&&(t.freeze(),t.purgeAllSources(),t.requestSources(this.getSources()),t.thaw())},getSources:function(){return[this.stickySource].concat(this.otherSources)},multiQuerySources:function(e){e?t.isArray(e)||(e=[e]):e=[];var n,i=[];for(n=0;n<e.length;n++)i.push.apply(i,this.querySources(e[n]));return i},querySources:function(e){var n,i,s=this.otherSources;for(n=0;n<s.length;n++)if((i=s[n])===e)return[i];return(i=this.getSourceById(_e.normalizeId(e)))?[i]:(e=qe.parse(e,this.calendar),e?t.grep(s,function(t){return kt(e,t)}):void 0)},getSourceById:function(e){return t.grep(this.otherSources,function(t){return t.id&&t.id===e})[0]},setPeriod:function(t){this.currentPeriod&&(this.unbindPeriod(this.currentPeriod),this.currentPeriod=null),this.currentPeriod=t,this.bindPeriod(t),t.requestSources(this.getSources())},bindPeriod:function(t){this.listenTo(t,"release",function(t){this.trigger("release",t)})},unbindPeriod:function(t){this.stopListeningTo(t)},getEventDefByUid:function(t){if(this.currentPeriod)return this.currentPeriod.getEventDefByUid(t)},addEventDef:function(t,e){e&&this.stickySource.addEventDef(t),this.currentPeriod&&this.currentPeriod.addEventDef(t)},removeEventDefsById:function(t){this.getSources().forEach(function(e){e.removeEventDefsById(t)}),this.currentPeriod&&this.currentPeriod.removeEventDefsById(t)},removeAllEventDefs:function(){this.getSources().forEach(function(t){t.removeAllEventDefs()}),this.currentPeriod&&this.currentPeriod.removeAllEventDefs()},mutateEventsWithId:function(t,e){var n,i=this.currentPeriod,s=[];return i?(i.freeze(),n=i.getEventDefsById(t),n.forEach(function(t){i.removeEventDef(t),s.push(e.mutateSingle(t)),i.addEventDef(t)}),i.thaw(),function(){i.freeze();for(var t=0;t<n.length;t++)i.removeEventDef(n[t]),s[t](),i.addEventDef(n[t]);i.thaw()}):function(){}},buildMutatedEventInstanceGroup:function(t,e){var n,i,s=this.getEventDefsById(t),r=[];for(n=0;n<s.length;n++)(i=s[n].clone())instanceof ke&&(e.mutateSingle(i),r.push.apply(r,i.buildInstances()));return new Oe(r)},freeze:function(){this.currentPeriod&&this.currentPeriod.freeze()},thaw:function(){this.currentPeriod&&this.currentPeriod.thaw()}});["getEventDefsById","getEventInstances","getEventInstancesWithId","getEventInstancesWithoutId"].forEach(function(t){ze.prototype[t]=function(){var e=this.currentPeriod;return e?e[t].apply(e,arguments):[]}});var Fe=ht.extend(ee,{start:null,end:null,timezone:null,unzonedRange:null,requestsByUid:null,pendingCnt:0,freezeDepth:0,stuntedReleaseCnt:0,releaseCnt:0,eventDefsByUid:null,eventDefsById:null,eventInstanceGroupsById:null,constructor:function(t,e,n){this.start=t,this.end=e,this.timezone=n,this.unzonedRange=new Me(t.clone().stripZone(),e.clone().stripZone()),this.requestsByUid={},this.eventDefsByUid={},this.eventDefsById={},this.eventInstanceGroupsById={}},isWithinRange:function(t,e){return!t.isBefore(this.start)&&!e.isAfter(this.end)},requestSources:function(t){this.freeze();for(var e=0;e<t.length;e++)this.requestSource(t[e]);this.thaw()},requestSource:function(t){var e=this,n={source:t,status:"pending"};this.requestsByUid[t.uid]=n,this.pendingCnt+=1,t.fetch(this.start,this.end,this.timezone).then(function(t){"cancelled"!==n.status&&(n.status="completed",n.eventDefs=t,e.addEventDefs(t),e.pendingCnt--,e.tryRelease())},function(){"cancelled"!==n.status&&(n.status="failed",e.pendingCnt--,e.tryRelease())})},purgeSource:function(t){var e=this.requestsByUid[t.uid];e&&(delete this.requestsByUid[t.uid],"pending"===e.status?(e.status="cancelled",this.pendingCnt--,this.tryRelease()):"completed"===e.status&&e.eventDefs.forEach(this.removeEventDef.bind(this)))},purgeAllSources:function(){var t,e,n=this.requestsByUid,i=0;for(t in n)e=n[t],"pending"===e.status?e.status="cancelled":"completed"===e.status&&i++;this.requestsByUid={},this.pendingCnt=0,i&&this.removeAllEventDefs()},getEventDefByUid:function(t){return this.eventDefsByUid[t]},getEventDefsById:function(t){var e=this.eventDefsById[t];return e?e.slice():[]},addEventDefs:function(t){for(var e=0;e<t.length;e++)this.addEventDef(t[e])},addEventDef:function(t){var e,n=this.eventDefsById,i=t.id,s=n[i]||(n[i]=[]),r=t.buildInstances(this.unzonedRange);for(s.push(t),this.eventDefsByUid[t.uid]=t,e=0;e<r.length;e++)this.addEventInstance(r[e],i)},removeEventDefsById:function(t){var e=this;this.getEventDefsById(t).forEach(function(t){e.removeEventDef(t)})},removeAllEventDefs:function(){var e=t.isEmptyObject(this.eventDefsByUid);this.eventDefsByUid={},this.eventDefsById={},this.eventInstanceGroupsById={},e||this.tryRelease()},removeEventDef:function(t){var e=this.eventDefsById,n=e[t.id];delete this.eventDefsByUid[t.uid],n&&(K(n,t),n.length||delete e[t.id],this.removeEventInstancesForDef(t))},getEventInstances:function(){var t,e=this.eventInstanceGroupsById,n=[];for(t in e)n.push.apply(n,e[t].eventInstances);return n},getEventInstancesWithId:function(t){var e=this.eventInstanceGroupsById[t];return e?e.eventInstances.slice():[]},getEventInstancesWithoutId:function(t){var e,n=this.eventInstanceGroupsById,i=[];for(e in n)e!==t&&i.push.apply(i,n[e].eventInstances);return i},addEventInstance:function(t,e){var n=this.eventInstanceGroupsById;(n[e]||(n[e]=new Oe)).eventInstances.push(t),this.tryRelease()},removeEventInstancesForDef:function(t){var e,n=this.eventInstanceGroupsById,i=n[t.id];i&&(e=X(i.eventInstances,function(e){return e.def===t}),i.eventInstances.length||delete n[t.id],e&&this.tryRelease())},tryRelease:function(){this.pendingCnt||(this.freezeDepth?this.stuntedReleaseCnt++:this.release())},release:function(){this.releaseCnt++,this.trigger("release",this.eventInstanceGroupsById)},whenReleased:function(){var t=this;return this.releaseCnt?ae.resolve(this.eventInstanceGroupsById):ae.construct(function(e){t.one("release",e)})},freeze:function(){this.freezeDepth++||(this.stuntedReleaseCnt=0)},thaw:function(){--this.freezeDepth||!this.stuntedReleaseCnt||this.pendingCnt||this.release()}}),Pe={parse:function(t,n){return Y(t.start)||e.isDuration(t.start)||Y(t.end)||e.isDuration(t.end)?Ae.parse(t,n):ke.parse(t,n)}},Be=Vt.EventDef=ht.extend(ie,{source:null,id:null,rawId:null,uid:null,title:null,url:null,rendering:null,constraint:null,overlap:null,editable:null,startEditable:null,durationEditable:null,color:null,backgroundColor:null,borderColor:null,textColor:null,className:null,miscProps:null,constructor:function(t){this.uid=String(Be.uuid++),this.source=t,this.className=[],this.miscProps={}},isAllDay:function(){},buildInstances:function(t){},clone:function(){var e=new this.constructor(this.source);return e.id=this.id,e.rawId=this.rawId,e.uid=this.uid,Be.copyVerbatimStandardProps(this,e),e.className=this.className,e.miscProps=t.extend({},this.miscProps),e},hasInverseRendering:function(){return"inverse-background"===this.getRendering()},hasBgRendering:function(){var t=this.getRendering();return"inverse-background"===t||"background"===t},getRendering:function(){return null!=this.rendering?this.rendering:this.source.rendering},getConstraint:function(){return null!=this.constraint?this.constraint:null!=this.source.constraint?this.source.constraint:this.source.calendar.opt("eventConstraint")},getOverlap:function(){return null!=this.overlap?this.overlap:null!=this.source.overlap?this.source.overlap:this.source.calendar.opt("eventOverlap")},isStartExplicitlyEditable:function(){return null!==this.startEditable?this.startEditable:this.source.startEditable},isDurationExplicitlyEditable:function(){return null!==this.durationEditable?this.durationEditable:this.source.durationEditable},isExplicitlyEditable:function(){return null!==this.editable?this.editable:this.source.editable},toLegacy:function(){var e=t.extend({},this.miscProps);return e._id=this.uid,e.source=this.source,e.className=this.className,e.allDay=this.isAllDay(),null!=this.rawId&&(e.id=this.rawId),Be.copyVerbatimStandardProps(this,e),e},applyManualRawProps:function(e){return null!=e.id?this.id=Be.normalizeId(this.rawId=e.id):this.id=Be.generateId(),t.isArray(e.className)&&(this.className=e.className),"string"==typeof e.className&&(this.className=e.className.split(/\s+/)),!0},applyOtherRawProps:function(t){this.miscProps=t}});Be.allowRawProps=se,Be.copyVerbatimStandardProps=re,Be.uuid=0,Be.normalizeId=function(t){return String(t)},Be.generateId=function(){return"_fc"+Be.uuid++},Be.allowRawProps({id:!1,className:!1,source:!1,title:!0,url:!0,rendering:!0,constraint:!0,overlap:!0,editable:!0,startEditable:!0,durationEditable:!0,color:!0,backgroundColor:!0,borderColor:!0,textColor:!0}),Be.parse=function(t,e){var n=new this(e),i=e.calendar.opt("eventDataTransform"),s=e.eventDataTransform;return i&&(t=i(t)),s&&(t=s(t)),!!n.applyRawProps(t)&&n};var ke=Be.extend({dateProfile:null,buildInstances:function(){return[this.buildInstance()]},buildInstance:function(){return new Le(this,this.dateProfile)},isAllDay:function(){return this.dateProfile.isAllDay()},clone:function(){var t=Be.prototype.clone.call(this);return t.dateProfile=this.dateProfile,t},rezone:function(){var t=this.source.calendar,e=this.dateProfile;this.dateProfile=new Ne(t.moment(e.start),e.end?t.moment(e.end):null,t)},applyManualRawProps:function(t){var e=Be.prototype.applyManualRawProps.apply(this,arguments),n=Ne.parse(t,this.source);return!!n&&(this.dateProfile=n,e)}});ke.allowRawProps({start:!1,date:!1,end:!1,allDay:!1});var Ae=Be.extend({startTime:null,endTime:null,dowHash:null,isAllDay:function(){return!this.startTime&&!this.endTime},buildInstances:function(t){for(var e,n,i,s=this.source.calendar,r=t.getStart(),o=t.getEnd(),a=[];r.isBefore(o);)this.dowHash&&!this.dowHash[r.day()]||(e=s.applyTimezone(r),n=e.clone(),i=null,this.startTime?n.time(this.startTime):n.stripTime(),this.endTime&&(i=e.clone().time(this.endTime)),a.push(new Le(this,new Ne(n,i,s)))),r.add(1,"days");return a},setDow:function(t){this.dowHash||(this.dowHash={});for(var e=0;e<t.length;e++)this.dowHash[t[e]]=!0},clone:function(){var n=Be.prototype.clone.call(this);return n.startTime&&(n.startTime=e.duration(this.startTime)),n.endTime&&(n.endTime=e.duration(this.endTime)),this.dowHash&&(n.dowHash=t.extend({},this.dowHash)),n},applyRawProps:function(t){var n=Be.prototype.applyRawProps.apply(this,arguments);return t.start&&(this.startTime=e.duration(t.start)),t.end&&(this.endTime=e.duration(t.end)),t.dow&&this.setDow(t.dow),n}});Ae.allowRawProps({start:!1,end:!1,dow:!1});var Le=ht.extend({def:null,dateProfile:null,constructor:function(t,e){this.def=t,this.dateProfile=e},toLegacy:function(){var t=this.dateProfile,e=this.def.toLegacy();return e.start=t.start.clone(),e.end=t.end?t.end.clone():null,e}}),Oe=ht.extend({eventInstances:null,explicitEventDef:null,constructor:function(t){this.eventInstances=t||[]},getAllEventRanges:function(){return Lt(this.eventInstances)},sliceRenderRanges:function(t){return this.isInverse()?this.sliceInverseRenderRanges(t):this.sliceNormalRenderRanges(t)},sliceNormalRenderRanges:function(t){var e,n,i,s=this.eventInstances,r=[];for(e=0;e<s.length;e++)n=s[e],(i=n.dateProfile.unzonedRange.intersect(t))&&r.push(new Ve(i,n.def,n));return r},sliceInverseRenderRanges:function(t){var e=Ot(this.eventInstances),n=this.getEventDef();return e=Pt(e,t),e.map(function(t){return new Ve(t,n)})},isInverse:function(){return this.getEventDef().hasInverseRendering()},getEventDef:function(){return this.explicitEventDef||this.eventInstances[0].def}}),Ne=ht.extend({start:null,end:null,unzonedRange:null,constructor:function(t,e,n){this.start=t,this.end=e||null,this.unzonedRange=this.buildUnzonedRange(n)},isAllDay:function(){return!(this.start.hasTime()||this.end&&this.end.hasTime())},buildUnzonedRange:function(t){var e=this.start.clone().stripZone().valueOf(),n=this.getEnd(t).stripZone().valueOf();return new Me(e,n)},getEnd:function(t){return this.end?this.end.clone():t.getDefaultEventEnd(this.isAllDay(),this.start)}});Ne.parse=function(t,e){var n=t.start||t.date,i=t.end;if(!n)return!1;var s=e.calendar,r=s.moment(n),o=i?s.moment(i):null,a=t.allDay,l=s.opt("forceEventDuration");return!!r.isValid()&&(!o||o.isValid()&&o.isAfter(r)||(o=null),null==a&&null==(a=e.allDayDefault)&&(a=s.opt("allDayDefault")),!0===a?(r.stripTime(),o&&o.stripTime()):!1===a&&(r.hasTime()||r.time(0),o&&!o.hasTime()&&o.time(0)),!o&&l&&(o=s.getDefaultEventEnd(!r.hasTime(),r)),new Ne(r,o,s))};var Ve=ht.extend({unzonedRange:null,eventDef:null,eventInstance:null,constructor:function(t,e,n){this.unzonedRange=t,this.eventDef=e,n&&(this.eventInstance=n)}}),Ue=Vt.EventFootprint=ht.extend({componentFootprint:null,eventDef:null,eventInstance:null,constructor:function(t,e,n){this.componentFootprint=t,this.eventDef=e,n&&(this.eventInstance=n)},getEventLegacy:function(){return(this.eventInstance||this.eventDef).toLegacy()}}),Ge=Vt.EventDefMutation=ht.extend({dateMutation:null,rawProps:null,mutateSingle:function(t){var e;return this.dateMutation&&(e=t.dateProfile,t.dateProfile=this.dateMutation.buildNewDateProfile(e,t.source.calendar)),this.rawProps&&t.applyRawProps(this.rawProps),e?function(){t.dateProfile=e}:function(){}},setDateMutation:function(t){t&&!t.isEmpty()?this.dateMutation=t:this.dateMutation=null},isEmpty:function(){return!this.dateMutation}});Ge.createFromRawProps=function(t,e,n){var i,s,r,o,a=t.def,l={};for(i in e)"object"!=typeof e[i]&&"start"!==i&&"end"!==i&&"allDay"!==i&&"source"!==i&&"_id"!==i&&(l[i]=e[i]);return s=Ne.parse(e,a.source),s&&(r=We.createFromDiff(t.dateProfile,s,n)),o=new Ge,o.rawProps=l,r&&(o.dateMutation=r),o};var We=ht.extend({clearEnd:!1,forceTimed:!1,forceAllDay:!1,dateDelta:null,startDelta:null,endDelta:null,buildNewDateProfile:function(t,e){var n=t.start.clone(),i=null,s=!1;return!this.clearEnd&&t.end&&(i=t.end.clone()),this.forceTimed?(s=!0,n.hasTime()||n.time(0),i&&!i.hasTime()&&i.time(0)):this.forceAllDay&&(n.hasTime()&&n.stripTime(),i&&i.hasTime()&&i.stripTime()),this.dateDelta&&(s=!0,n.add(this.dateDelta),i&&i.add(this.dateDelta)),this.endDelta&&(s=!0,i||(i=e.getDefaultEventEnd(t.isAllDay(),n)),i.add(this.endDelta)),this.startDelta&&(s=!0,n.add(this.startDelta)),s&&(n=e.applyTimezone(n),i&&(i=e.applyTimezone(i))),!i&&e.opt("forceEventDuration")&&(i=e.getDefaultEventEnd(t.isAllDay(),n)),new Ne(n,i,e)},setDateDelta:function(t){t&&t.valueOf()?this.dateDelta=t:this.dateDelta=null},setStartDelta:function(t){t&&t.valueOf()?this.startDelta=t:this.startDelta=null},setEndDelta:function(t){t&&t.valueOf()?this.endDelta=t:this.endDelta=null},isEmpty:function(){return!(this.clearEnd||this.forceTimed||this.forceAllDay||this.dateDelta||this.startDelta||this.endDelta)}});We.createFromDiff=function(t,e,n){function i(t,i){return n?L(t,i,n):e.isAllDay()?A(t,i):k(t,i)}var s,r,o,a,l=t.end&&!e.end,u=t.isAllDay()&&!e.isAllDay(),c=!t.isAllDay()&&e.isAllDay();return s=i(e.start,t.start),e.end&&(r=i(e.unzonedRange.getEnd(),t.unzonedRange.getEnd()),o=r.subtract(s)),a=new We,a.clearEnd=l,a.forceTimed=u,a.forceAllDay=c,a.setDateDelta(s),a.setEndDelta(o),a};var _e=ht.extend(ie,{calendar:null,id:null,uid:null,color:null,backgroundColor:null,borderColor:null,textColor:null,className:null,editable:null,startEditable:null,durationEditable:null,rendering:null,overlap:null,constraint:null,allDayDefault:null,eventDataTransform:null,constructor:function(t){this.calendar=t,this.className=[],this.uid=String(_e.uuid++)},fetch:function(t,e,n){},removeEventDefsById:function(t){},removeAllEventDefs:function(){},getPrimitive:function(t){},parseEventDefs:function(t){var e,n,i=[];for(e=0;e<t.length;e++)(n=Pe.parse(t[e],this))&&i.push(n);return i},applyManualRawProps:function(e){return null!=e.id&&(this.id=_e.normalizeId(e.id)),t.isArray(e.className)?this.className=e.className:"string"==typeof e.className&&(this.className=e.className.split(/\s+/)),!0}});_e.allowRawProps=se,_e.uuid=0,_e.normalizeId=function(t){return t?String(t):null},_e.allowRawProps({id:!1,className:!1,color:!0,backgroundColor:!0,borderColor:!0,textColor:!0,editable:!0,startEditable:!0,durationEditable:!0,rendering:!0,overlap:!0,constraint:!0,allDayDefault:!0,eventDataTransform:!0}),_e.parse=function(t,e){var n=new this(e);return!("object"!=typeof t||!n.applyRawProps(t))&&n},Vt.EventSource=_e;var qe={sourceClasses:[],registerClass:function(t){this.sourceClasses.unshift(t)},parse:function(t,e){var n,i,s=this.sourceClasses;for(n=0;n<s.length;n++)if(i=s[n].parse(t,e))return i}};Vt.EventSourceParser=qe;var Ye=_e.extend({rawEventDefs:null,eventDefs:null,currentTimezone:null,constructor:function(t){_e.apply(this,arguments),this.eventDefs=[]},setRawEventDefs:function(t){this.rawEventDefs=t,this.eventDefs=this.parseEventDefs(t)},fetch:function(t,e,n){var i,s=this.eventDefs;if(null!==this.currentTimezone&&this.currentTimezone!==n)for(i=0;i<s.length;i++)s[i]instanceof ke&&s[i].rezone();return this.currentTimezone=n,ae.resolve(s)},addEventDef:function(t){this.eventDefs.push(t)},removeEventDefsById:function(t){return X(this.eventDefs,function(e){return e.id===t})},removeAllEventDefs:function(){this.eventDefs=[]},getPrimitive:function(){return this.rawEventDefs},applyManualRawProps:function(t){var e=_e.prototype.applyManualRawProps.apply(this,arguments);return this.setRawEventDefs(t.events),e}});Ye.allowRawProps({events:!1}),Ye.parse=function(e,n){var i;return t.isArray(e.events)?i=e:t.isArray(e)&&(i={events:e}),!!i&&_e.parse.call(this,i,n)},qe.registerClass(Ye),Vt.ArrayEventSource=Ye;var je=_e.extend({func:null,fetch:function(t,e,n){var i=this;return ae.construct(function(s){i.func.call(this.calendar,t.clone(),e.clone(),n,function(t){s(i.parseEventDefs(t))})})},getPrimitive:function(){return this.func},applyManualRawProps:function(t){var e=_e.prototype.applyManualRawProps.apply(this,arguments);return this.func=t.events,e}});je.allowRawProps({events:!1}),je.parse=function(e,n){var i;return t.isFunction(e.events)?i=e:t.isFunction(e)&&(i={events:e}),!!i&&_e.parse.call(this,i,n)},qe.registerClass(je),Vt.FuncEventSource=je;var Ze=_e.extend({startParam:null,endParam:null,timezoneParam:null,ajaxSettings:null,fetch:function(e,n,i){var s=this,r=this.ajaxSettings,o=r.success,a=r.error,l=this.buildRequestParams(e,n,i);return ae.construct(function(e,n){t.ajax(t.extend({},Ze.AJAX_DEFAULTS,r,{data:l,success:function(i){var r;i?(r=$(o,this,arguments),t.isArray(r)&&(i=r),e(s.parseEventDefs(i))):n()},error:function(){$(a,this,arguments),n()}}))})},buildRequestParams:function(e,n,i){var s,r,o,a,l=this.calendar,u=this.ajaxSettings,c={};return s=this.startParam,null==s&&(s=l.opt("startParam")),r=this.endParam,null==r&&(r=l.opt("endParam")),o=this.timezoneParam,null==o&&(o=l.opt("timezoneParam")),a=t.isFunction(u.data)?u.data():u.data||{},t.extend(c,a),c[s]=e.format(),c[r]=n.format(),i&&"local"!==i&&(c[o]=i),c},getPrimitive:function(){return this.ajaxSettings.url},applyOtherRawProps:function(t){_e.prototype.applyOtherRawProps.apply(this,arguments),this.ajaxSettings=t}});Ze.AJAX_DEFAULTS={dataType:"json",cache:!1},Ze.allowRawProps({startParam:!0,endParam:!0,timezoneParam:!0}),Ze.parse=function(t,e){var n;return"string"==typeof t.url?n=t:"string"==typeof t&&(n={url:t}),!!n&&_e.parse.call(this,n,e)},qe.registerClass(Ze),Vt.JsonFeedEventSource=Ze;var Qe=Vt.ThemeRegistry={themeClassHash:{},register:function(t,e){this.themeClassHash[t]=e},getThemeClass:function(t){return t?!0===t?Ke:this.themeClassHash[t]:Xe}},$e=Vt.Theme=ht.extend({classes:{},iconClasses:{},baseIconClass:"",iconOverrideOption:null,iconOverrideCustomButtonOption:null,iconOverridePrefix:"",constructor:function(t){this.optionsModel=t,this.processIconOverride()},processIconOverride:function(){this.iconOverrideOption&&this.setIconOverride(this.optionsModel.get(this.iconOverrideOption))},setIconOverride:function(e){var n,i;if(t.isPlainObject(e)){n=t.extend({},this.iconClasses);for(i in e)n[i]=this.applyIconOverridePrefix(e[i]);this.iconClasses=n}else!1===e&&(this.iconClasses={})},applyIconOverridePrefix:function(t){var e=this.iconOverridePrefix;return e&&0!==t.indexOf(e)&&(t=e+t),t},getClass:function(t){return this.classes[t]||""},getIconClass:function(t){var e=this.iconClasses[t];return e?this.baseIconClass+" "+e:""},getCustomButtonIconClass:function(t){var e;return this.iconOverrideCustomButtonOption&&(e=t[this.iconOverrideCustomButtonOption])?this.baseIconClass+" "+this.applyIconOverridePrefix(e):""}}),Xe=$e.extend({classes:{widget:"fc-unthemed",widgetHeader:"fc-widget-header",widgetContent:"fc-widget-content",buttonGroup:"fc-button-group",button:"fc-button",cornerLeft:"fc-corner-left",cornerRight:"fc-corner-right",stateDefault:"fc-state-default",stateActive:"fc-state-active",stateDisabled:"fc-state-disabled",stateHover:"fc-state-hover",stateDown:"fc-state-down",popoverHeader:"fc-widget-header",popoverContent:"fc-widget-content",headerRow:"fc-widget-header",dayRow:"fc-widget-content",listView:"fc-widget-content"},baseIconClass:"fc-icon",iconClasses:{close:"fc-icon-x",prev:"fc-icon-left-single-arrow",next:"fc-icon-right-single-arrow",prevYear:"fc-icon-left-double-arrow",nextYear:"fc-icon-right-double-arrow"},iconOverrideOption:"buttonIcons",iconOverrideCustomButtonOption:"icon",iconOverridePrefix:"fc-icon-"});Qe.register("standard",Xe);var Ke=$e.extend({classes:{widget:"ui-widget",widgetHeader:"ui-widget-header",widgetContent:"ui-widget-content",buttonGroup:"fc-button-group",button:"ui-button",cornerLeft:"ui-corner-left",cornerRight:"ui-corner-right",stateDefault:"ui-state-default",stateActive:"ui-state-active",stateDisabled:"ui-state-disabled",stateHover:"ui-state-hover",stateDown:"ui-state-down",today:"ui-state-highlight",popoverHeader:"ui-widget-header",popoverContent:"ui-widget-content",headerRow:"ui-widget-header",dayRow:"ui-widget-content",listView:"ui-widget-content"},baseIconClass:"ui-icon",iconClasses:{close:"ui-icon-closethick",prev:"ui-icon-circle-triangle-w",next:"ui-icon-circle-triangle-e",prevYear:"ui-icon-seek-prev",nextYear:"ui-icon-seek-next"},iconOverrideOption:"themeButtonIcons",iconOverrideCustomButtonOption:"themeIcon",iconOverridePrefix:"ui-icon-"});Qe.register("jquery-ui",Ke);var Je=$e.extend({classes:{widget:"fc-bootstrap3",tableGrid:"table-bordered",tableList:"table table-striped",buttonGroup:"btn-group",button:"btn btn-default",stateActive:"active",stateDisabled:"disabled",today:"alert alert-info",popover:"panel panel-default",popoverHeader:"panel-heading",popoverContent:"panel-body",headerRow:"panel-default",dayRow:"panel-default",listView:"panel panel-default"},baseIconClass:"glyphicon",iconClasses:{close:"glyphicon-remove",prev:"glyphicon-chevron-left",next:"glyphicon-chevron-right",prevYear:"glyphicon-backward",nextYear:"glyphicon-forward"},iconOverrideOption:"bootstrapGlyphicons",iconOverrideCustomButtonOption:"bootstrapGlyphicon",iconOverridePrefix:"glyphicon-"});Qe.register("bootstrap3",Je);var tn=Vt.BasicView=be.extend({scroller:null,dayGridClass:we,dayGrid:null,dayNumbersVisible:!1,colWeekNumbersVisible:!1,cellWeekNumbersVisible:!1,weekNumberWidth:null,headContainerEl:null,headRowEl:null,initialize:function(){this.dayGrid=this.instantiateDayGrid(),this.addChild(this.dayGrid),this.scroller=new Se({overflowX:"hidden",overflowY:"auto"})},instantiateDayGrid:function(){return new(this.dayGridClass.extend(en))(this)},buildRenderRange:function(t,e){var n=be.prototype.buildRenderRange.apply(this,arguments),i=this.calendar.msToUtcMoment(n.startMs,this.isRangeAllDay),s=this.calendar.msToUtcMoment(n.endMs,this.isRangeAllDay);return/^(year|month)$/.test(e)&&(i.startOf("week"),s.weekday()&&s.add(1,"week").startOf("week")),this.trimHiddenDays(new Me(i,s))},renderDates:function(){this.dayGrid.breakOnWeeks=/year|month|week/.test(this.currentRangeUnit),this.dayGrid.setRange(this.renderUnzonedRange),this.dayNumbersVisible=this.dayGrid.rowCnt>1,this.opt("weekNumbers")&&(this.opt("weekNumbersWithinDays")?(this.cellWeekNumbersVisible=!0,this.colWeekNumbersVisible=!1):(this.cellWeekNumbersVisible=!1,this.colWeekNumbersVisible=!0)),this.dayGrid.numbersVisible=this.dayNumbersVisible||this.cellWeekNumbersVisible||this.colWeekNumbersVisible,this.el.addClass("fc-basic-view").html(this.renderSkeletonHtml()),this.renderHead(),this.scroller.render();var e=this.scroller.el.addClass("fc-day-grid-container"),n=t('<div class="fc-day-grid" />').appendTo(e);this.el.find(".fc-body > tr > td").append(e),this.dayGrid.setElement(n),this.dayGrid.renderDates(this.hasRigidRows())},renderHead:function(){this.headContainerEl=this.el.find(".fc-head-container").html(this.dayGrid.renderHeadHtml()),this.headRowEl=this.headContainerEl.find(".fc-row")},unrenderDates:function(){this.dayGrid.unrenderDates(),this.dayGrid.removeElement(),this.scroller.destroy()},renderSkeletonHtml:function(){var t=this.calendar.theme;return'<table class="'+t.getClass("tableGrid")+'"><thead class="fc-head"><tr><td class="fc-head-container '+t.getClass("widgetHeader")+'"></td></tr></thead><tbody class="fc-body"><tr><td class="'+t.getClass("widgetContent")+'"></td></tr></tbody></table>'},weekNumberStyleAttr:function(){return null!==this.weekNumberWidth?'style="width:'+this.weekNumberWidth+'px"':""},hasRigidRows:function(){var t=this.opt("eventLimit");return t&&"number"!=typeof t},updateWidth:function(){
	this.colWeekNumbersVisible&&(this.weekNumberWidth=u(this.el.find(".fc-week-number")))},setHeight:function(t,e){var n,r,o=this.opt("eventLimit");this.scroller.clear(),s(this.headRowEl),this.dayGrid.removeSegPopover(),o&&"number"==typeof o&&this.dayGrid.limitRows(o),n=this.computeScrollerHeight(t),this.setGridHeight(n,e),o&&"number"!=typeof o&&this.dayGrid.limitRows(o),e||(this.scroller.setHeight(n),r=this.scroller.getScrollbarWidths(),(r.left||r.right)&&(i(this.headRowEl,r),n=this.computeScrollerHeight(t),this.scroller.setHeight(n)),this.scroller.lockOverflow(r))},computeScrollerHeight:function(t){return t-c(this.el,this.scroller.el)},setGridHeight:function(t,e){e?l(this.dayGrid.rowEls):a(this.dayGrid.rowEls,t,!0)},computeInitialDateScroll:function(){return{top:0}},queryDateScroll:function(){return{top:this.scroller.getScrollTop()}},applyDateScroll:function(t){void 0!==t.top&&this.scroller.setScrollTop(t.top)},renderEventsPayload:function(t){this.dayGrid.renderEventsPayload(t),this.updateHeight()}}),en={renderHeadIntroHtml:function(){var t=this.view;return t.colWeekNumbersVisible?'<th class="fc-week-number '+t.calendar.theme.getClass("widgetHeader")+'" '+t.weekNumberStyleAttr()+"><span>"+tt(this.opt("weekNumberTitle"))+"</span></th>":""},renderNumberIntroHtml:function(t){var e=this.view,n=this.getCellDate(t,0);return e.colWeekNumbersVisible?'<td class="fc-week-number" '+e.weekNumberStyleAttr()+">"+e.buildGotoAnchorHtml({date:n,type:"week",forceOff:1===this.colCnt},n.format("w"))+"</td>":""},renderBgIntroHtml:function(){var t=this.view;return t.colWeekNumbersVisible?'<td class="fc-week-number '+t.calendar.theme.getClass("widgetContent")+'" '+t.weekNumberStyleAttr()+"></td>":""},renderIntroHtml:function(){var t=this.view;return t.colWeekNumbersVisible?'<td class="fc-week-number" '+t.weekNumberStyleAttr()+"></td>":""}},nn=Vt.MonthView=tn.extend({buildRenderRange:function(){var t,e=tn.prototype.buildRenderRange.apply(this,arguments),n=this.calendar.msToUtcMoment(e.startMs,this.isRangeAllDay),i=this.calendar.msToUtcMoment(e.endMs,this.isRangeAllDay);return this.isFixedWeeks()&&(t=Math.ceil(i.diff(n,"weeks",!0)),i.add(6-t,"weeks")),new Me(n,i)},setGridHeight:function(t,e){e&&(t*=this.rowCnt/6),a(this.dayGrid.rowEls,t,!e)},isFixedWeeks:function(){return this.opt("fixedWeekCount")},isDateInOtherMonth:function(t){return t.month()!==e.utc(this.currentUnzonedRange.startMs).month()}});Ut.basic={class:tn},Ut.basicDay={type:"basic",duration:{days:1}},Ut.basicWeek={type:"basic",duration:{weeks:1}},Ut.month={class:nn,duration:{months:1},defaults:{fixedWeekCount:!0}};var sn=Vt.AgendaView=be.extend({scroller:null,timeGridClass:De,timeGrid:null,dayGridClass:we,dayGrid:null,axisWidth:null,headContainerEl:null,noScrollRowEls:null,bottomRuleEl:null,usesMinMaxTime:!0,initialize:function(){this.timeGrid=this.instantiateTimeGrid(),this.addChild(this.timeGrid),this.opt("allDaySlot")&&(this.dayGrid=this.instantiateDayGrid(),this.addChild(this.dayGrid)),this.scroller=new Se({overflowX:"hidden",overflowY:"auto"})},instantiateTimeGrid:function(){return new(this.timeGridClass.extend(rn))(this)},instantiateDayGrid:function(){return new(this.dayGridClass.extend(on))(this)},renderDates:function(){this.timeGrid.setRange(this.renderUnzonedRange),this.dayGrid&&this.dayGrid.setRange(this.renderUnzonedRange),this.el.addClass("fc-agenda-view").html(this.renderSkeletonHtml()),this.renderHead(),this.scroller.render();var e=this.scroller.el.addClass("fc-time-grid-container"),n=t('<div class="fc-time-grid" />').appendTo(e);this.el.find(".fc-body > tr > td").append(e),this.timeGrid.setElement(n),this.timeGrid.renderDates(),this.bottomRuleEl=t('<hr class="fc-divider '+this.calendar.theme.getClass("widgetHeader")+'"/>').appendTo(this.timeGrid.el),this.dayGrid&&(this.dayGrid.setElement(this.el.find(".fc-day-grid")),this.dayGrid.renderDates(),this.dayGrid.bottomCoordPadding=this.dayGrid.el.next("hr").outerHeight()),this.noScrollRowEls=this.el.find(".fc-row:not(.fc-scroller *)")},renderHead:function(){this.headContainerEl=this.el.find(".fc-head-container").html(this.timeGrid.renderHeadHtml())},unrenderDates:function(){this.timeGrid.unrenderDates(),this.timeGrid.removeElement(),this.dayGrid&&(this.dayGrid.unrenderDates(),this.dayGrid.removeElement()),this.scroller.destroy()},renderSkeletonHtml:function(){var t=this.calendar.theme;return'<table class="'+t.getClass("tableGrid")+'"><thead class="fc-head"><tr><td class="fc-head-container '+t.getClass("widgetHeader")+'"></td></tr></thead><tbody class="fc-body"><tr><td class="'+t.getClass("widgetContent")+'">'+(this.dayGrid?'<div class="fc-day-grid"/><hr class="fc-divider '+t.getClass("widgetHeader")+'"/>':"")+"</td></tr></tbody></table>"},axisStyleAttr:function(){return null!==this.axisWidth?'style="width:'+this.axisWidth+'px"':""},getNowIndicatorUnit:function(){return this.timeGrid.getNowIndicatorUnit()},updateSize:function(t){this.timeGrid.updateSize(t),be.prototype.updateSize.call(this,t)},updateWidth:function(){this.axisWidth=u(this.el.find(".fc-axis"))},setHeight:function(t,e){var n,r,o;this.bottomRuleEl.hide(),this.scroller.clear(),s(this.noScrollRowEls),this.dayGrid&&(this.dayGrid.removeSegPopover(),n=this.opt("eventLimit"),n&&"number"!=typeof n&&(n=an),n&&this.dayGrid.limitRows(n)),e||(r=this.computeScrollerHeight(t),this.scroller.setHeight(r),o=this.scroller.getScrollbarWidths(),(o.left||o.right)&&(i(this.noScrollRowEls,o),r=this.computeScrollerHeight(t),this.scroller.setHeight(r)),this.scroller.lockOverflow(o),this.timeGrid.getTotalSlatHeight()<r&&this.bottomRuleEl.show())},computeScrollerHeight:function(t){return t-c(this.el,this.scroller.el)},computeInitialDateScroll:function(){var t=e.duration(this.opt("scrollTime")),n=this.timeGrid.computeTimeTop(t);return n=Math.ceil(n),n&&n++,{top:n}},queryDateScroll:function(){return{top:this.scroller.getScrollTop()}},applyDateScroll:function(t){void 0!==t.top&&this.scroller.setScrollTop(t.top)},getHitFootprint:function(t){return t.component.getHitFootprint(t)},getHitEl:function(t){return t.component.getHitEl(t)},renderEventsPayload:function(t){var e,n,i={},s={};for(e in t)n=t[e],n.getEventDef().isAllDay()?i[e]=n:s[e]=n;this.timeGrid.renderEventsPayload(s),this.dayGrid&&this.dayGrid.renderEventsPayload(i),this.updateHeight()},renderDrag:function(t,e){if(t.length){if(!t[0].componentFootprint.isAllDay)return this.timeGrid.renderDrag(t,e);if(this.dayGrid)return this.dayGrid.renderDrag(t,e)}},renderSelectionFootprint:function(t){t.isAllDay?this.dayGrid&&this.dayGrid.renderSelectionFootprint(t):this.timeGrid.renderSelectionFootprint(t)}}),rn={renderHeadIntroHtml:function(){var t,e=this.view,n=e.calendar.msToUtcMoment(this.unzonedRange.startMs,!0);return this.opt("weekNumbers")?(t=n.format(this.opt("smallWeekFormat")),'<th class="fc-axis fc-week-number '+e.calendar.theme.getClass("widgetHeader")+'" '+e.axisStyleAttr()+">"+e.buildGotoAnchorHtml({date:n,type:"week",forceOff:this.colCnt>1},tt(t))+"</th>"):'<th class="fc-axis '+e.calendar.theme.getClass("widgetHeader")+'" '+e.axisStyleAttr()+"></th>"},renderBgIntroHtml:function(){var t=this.view;return'<td class="fc-axis '+t.calendar.theme.getClass("widgetContent")+'" '+t.axisStyleAttr()+"></td>"},renderIntroHtml:function(){return'<td class="fc-axis" '+this.view.axisStyleAttr()+"></td>"}},on={renderBgIntroHtml:function(){var t=this.view;return'<td class="fc-axis '+t.calendar.theme.getClass("widgetContent")+'" '+t.axisStyleAttr()+"><span>"+t.getAllDayHtml()+"</span></td>"},renderIntroHtml:function(){return'<td class="fc-axis" '+this.view.axisStyleAttr()+"></td>"}},an=5,ln=[{hours:1},{minutes:30},{minutes:15},{seconds:30},{seconds:15}];Ut.agenda={class:sn,defaults:{allDaySlot:!0,slotDuration:"00:30:00",slotEventOverlap:!0}},Ut.agendaDay={type:"agenda",duration:{days:1}},Ut.agendaWeek={type:"agenda",duration:{weeks:1}};var un=be.extend({grid:null,scroller:null,initialize:function(){this.grid=new cn(this),this.addChild(this.grid),this.scroller=new Se({overflowX:"hidden",overflowY:"auto"})},renderSkeleton:function(){this.el.addClass("fc-list-view "+this.calendar.theme.getClass("listView")),this.scroller.render(),this.scroller.el.appendTo(this.el),this.grid.setElement(this.scroller.scrollEl)},unrenderSkeleton:function(){this.scroller.destroy()},setHeight:function(t,e){this.scroller.setHeight(this.computeScrollerHeight(t))},computeScrollerHeight:function(t){return t-c(this.el,this.scroller.el)},renderDates:function(){this.grid.setRange(this.renderUnzonedRange)},isEventDefResizable:function(t){return!1},isEventDefDraggable:function(t){return!1}}),cn=me.extend({dayDates:null,dayRanges:null,segSelector:".fc-list-item",hasDayInteractions:!1,rangeUpdated:function(){for(var t=this.view.calendar,e=t.msToUtcMoment(this.unzonedRange.startMs,!0),n=t.msToUtcMoment(this.unzonedRange.endMs,!0),i=[],s=[];e<n;)i.push(e.clone()),s.push(new Me(e,e.clone().add(1,"day"))),e.add(1,"day");this.dayDates=i,this.dayRanges=s},componentFootprintToSegs:function(t){var e,n,i,s=this.view,r=this.dayRanges,o=[];for(e=0;e<r.length;e++)if((n=t.unzonedRange.intersect(r[e]))&&(i={startMs:n.startMs,endMs:n.endMs,isStart:n.isStart,isEnd:n.isEnd,dayIndex:e},o.push(i),!i.isEnd&&!t.isAllDay&&t.unzonedRange.endMs<r[e+1].startMs+s.nextDayThreshold)){i.endMs=t.unzonedRange.endMs,i.isEnd=!0;break}return o},computeEventTimeFormat:function(){return this.opt("mediumTimeFormat")},handleSegClick:function(e,n){var i;me.prototype.handleSegClick.apply(this,arguments),t(n.target).closest("a[href]").length||(i=e.footprint.eventDef.url)&&!n.isDefaultPrevented()&&(window.location.href=i)},renderFgSegs:function(t){return t=this.renderFgSegEls(t),t.length?this.renderSegList(t):this.renderEmptyMessage(),t},renderEmptyMessage:function(){this.el.html('<div class="fc-list-empty-wrap2"><div class="fc-list-empty-wrap1"><div class="fc-list-empty">'+tt(this.opt("noEventsMessage"))+"</div></div></div>")},renderSegList:function(e){var n,i,s,r=this.groupSegsByDay(e),o=t('<table class="fc-list-table '+this.view.calendar.theme.getClass("tableList")+'"><tbody/></table>'),a=o.find("tbody");for(n=0;n<r.length;n++)if(i=r[n])for(a.append(this.dayHeaderHtml(this.dayDates[n])),this.sortEventSegs(i),s=0;s<i.length;s++)a.append(i[s].el);this.el.empty().append(o)},groupSegsByDay:function(t){var e,n,i=[];for(e=0;e<t.length;e++)n=t[e],(i[n.dayIndex]||(i[n.dayIndex]=[])).push(n);return i},dayHeaderHtml:function(t){var e=this.view,n=this.opt("listDayFormat"),i=this.opt("listDayAltFormat");return'<tr class="fc-list-heading" data-date="'+t.format("YYYY-MM-DD")+'"><td class="'+e.calendar.theme.getClass("widgetHeader")+'" colspan="3">'+(n?e.buildGotoAnchorHtml(t,{class:"fc-list-heading-main"},tt(t.format(n))):"")+(i?e.buildGotoAnchorHtml(t,{class:"fc-list-heading-alt"},tt(t.format(i))):"")+"</td></tr>"},fgSegHtml:function(t){var e,n=this.view,i=n.calendar,s=i.theme,r=["fc-list-item"].concat(this.getSegCustomClasses(t)),o=this.getSegBackgroundColor(t),a=t.footprint,l=a.eventDef,u=a.componentFootprint,c=l.url;return e=u.isAllDay?n.getAllDayHtml():n.isMultiDayRange(u.unzonedRange)?t.isStart||t.isEnd?tt(this._getEventTimeText(i.msToMoment(t.startMs),i.msToMoment(t.endMs),u.isAllDay)):n.getAllDayHtml():tt(this.getEventTimeText(a)),c&&r.push("fc-has-url"),'<tr class="'+r.join(" ")+'">'+(this.displayEventTime?'<td class="fc-list-item-time '+s.getClass("widgetContent")+'">'+(e||"")+"</td>":"")+'<td class="fc-list-item-marker '+s.getClass("widgetContent")+'"><span class="fc-event-dot"'+(o?' style="background-color:'+o+'"':"")+'></span></td><td class="fc-list-item-title '+s.getClass("widgetContent")+'"><a'+(c?' href="'+tt(c)+'"':"")+">"+tt(l.title||"")+"</a></td></tr>"}});return Ut.list={class:un,buttonTextKey:"list",defaults:{buttonText:"list",listDayFormat:"LL",noEventsMessage:"No events to display"}},Ut.listDay={type:"list",duration:{days:1},defaults:{listDayFormat:"dddd"}},Ut.listWeek={type:"list",duration:{weeks:1},defaults:{listDayFormat:"dddd",listDayAltFormat:"LL"}},Ut.listMonth={type:"list",duration:{month:1},defaults:{listDayAltFormat:"dddd"}},Ut.listYear={type:"list",duration:{year:1},defaults:{listDayAltFormat:"dddd"}},Vt});

/***/ }),
/* 303 */
5,
/* 304 */,
/* 305 */
/***/ (function(module, exports) {

	/*
	*  AngularJs Fullcalendar Wrapper for the JQuery FullCalendar
	*  API @ http://arshaw.com/fullcalendar/
	*
	*  Angular Calendar Directive that takes in the [eventSources] nested array object as the ng-model and watches it deeply changes.
	*       Can also take in multiple event urls as a source object(s) and feed the events per view.
	*       The calendar will watch any eventSource array and update itself when a change is made.
	*
	*/
	
	angular.module('ui.calendar', [])
	  .constant('uiCalendarConfig', {calendars: {}})
	  .controller('uiCalendarCtrl', ['$scope', 
	                                 '$locale', function(
	                                  $scope, 
	                                  $locale){
	
	      var sources = $scope.eventSources,
	          extraEventSignature = $scope.calendarWatchEvent ? $scope.calendarWatchEvent : angular.noop,
	
	          wrapFunctionWithScopeApply = function(functionToWrap){
	              return function(){
	                  // This may happen outside of angular context, so create one if outside.
	
	                  if ($scope.$root.$$phase) {
	                      return functionToWrap.apply(this, arguments);
	                  } else {
	                      var args = arguments;
	                      var self = this;
	                      return $scope.$root.$apply(function(){
	                          return functionToWrap.apply(self, args);
	                      });
	                  }
	              };
	          };
	
	      var eventSerialId = 1;
	      // @return {String} fingerprint of the event object and its properties
	      this.eventFingerprint = function(e) {
	        if (!e._id) {
	          e._id = eventSerialId++;
	        }
	        
	        var extraSignature = extraEventSignature({event: e}) || '';
	        var start = moment.isMoment(e.start) ? e.start.unix() : (e.start ? moment(e.start).unix() : '');
	        var end =   moment.isMoment(e.end)   ? e.end.unix()   : (e.end   ? moment(e.end).unix()   : '');
	        
	        // This extracts all the information we need from the event. http://jsperf.com/angular-calendar-events-fingerprint/3
	        return "" + e._id + (e.id || '') + (e.title || '') + (e.url || '') + start + end +
	          (e.allDay || '') + (e.className || '') + extraSignature;
	      };
	
	      var sourceSerialId = 1, sourceEventsSerialId = 1;
	      // @return {String} fingerprint of the source object and its events array
	      this.sourceFingerprint = function(source) {
	          var fp = '' + (source.__id || (source.__id = sourceSerialId++)),
	              events = angular.isObject(source) && source.events;
	          if (events) {
	              fp = fp + '-' + (events.__id || (events.__id = sourceEventsSerialId++));
	          }
	          return fp;
	      };
	
	      // @return {Array} all events from all sources
	      this.allEvents = function() {
	        // do sources.map(&:events).flatten(), but we don't have flatten
	        var arraySources = [];
	        for (var i = 0, srcLen = sources.length; i < srcLen; i++) {
	          var source = sources[i];
	          if (angular.isArray(source)) {
	            // event source as array
	            arraySources.push(source);
	          } else if(angular.isObject(source) && angular.isArray(source.events)){
	            // event source as object, ie extended form
	            var extEvent = {};
	            for(var key in source){
	              if(key !== '_id' && key !== 'events'){
	                 extEvent[key] = source[key];
	              }
	            }
	            for(var eI = 0;eI < source.events.length;eI++){
	              angular.extend(source.events[eI],extEvent);
	            }
	            arraySources.push(source.events);
	          }
	        }
	        return Array.prototype.concat.apply([], arraySources);
	      };
	
	      // Track changes in array of objects by assigning id tokens to each element and watching the scope for changes in the tokens
	      // @param {Array|Function} arraySource array of objects to watch
	      // @param tokenFn {Function} that returns the token for a given object
	      // @return {Object}
	      //  subscribe: function(scope, function(newTokens, oldTokens))
	      //    called when source has changed. return false to prevent individual callbacks from firing
	      //  onAdded/Removed/Changed:
	      //    when set to a callback, called each item where a respective change is detected
	      this.changeWatcher = function(arraySource, tokenFn) {
	        var self;
	        var getTokens = function() {
	          var array = angular.isFunction(arraySource) ? arraySource() : arraySource;
	          var result = [], token, el;
	          for (var i = 0, n = array.length; i < n; i++) {
	            el = array[i];
	            token = tokenFn(el);
	            map[token] = el;
	            result.push(token);
	          }
	          return result;
	        };
	
	        // @param {Array} a
	        // @param {Array} b
	        // @return {Array} elements in that are in a but not in b
	        // @example
	        //  subtractAsSets([6, 100, 4, 5], [4, 5, 7]) // [6, 100]
	        var subtractAsSets = function(a, b) {
	          var result = [], inB = {}, i, n;
	          for (i = 0, n = b.length; i < n; i++) {
	            inB[b[i]] = true;
	          }
	          for (i = 0, n = a.length; i < n; i++) {
	            if (!inB[a[i]]) {
	              result.push(a[i]);
	            }
	          }
	          return result;
	        };
	
	        // Map objects to tokens and vice-versa
	        var map = {};
	
	        // Compare newTokens to oldTokens and call onAdded, onRemoved, and onChanged handlers for each affected event respectively.
	        var applyChanges = function(newTokens, oldTokens) {
	          var i, n, el, token;
	          var replacedTokens = {};
	          var removedTokens = subtractAsSets(oldTokens, newTokens);
	          for (i = 0, n = removedTokens.length; i < n; i++) {
	            var removedToken = removedTokens[i];
	            el = map[removedToken];
	            delete map[removedToken];
	            var newToken = tokenFn(el);
	            // if the element wasn't removed but simply got a new token, its old token will be different from the current one
	            if (newToken === removedToken) {
	              self.onRemoved(el);
	            } else {
	              replacedTokens[newToken] = removedToken;
	              self.onChanged(el);
	            }
	          }
	
	          var addedTokens = subtractAsSets(newTokens, oldTokens);
	          for (i = 0, n = addedTokens.length; i < n; i++) {
	            token = addedTokens[i];
	            el = map[token];
	            if (!replacedTokens[token]) {
	              self.onAdded(el);
	            }
	          }
	        };
	        return self = {
	          subscribe: function(scope, onArrayChanged) {
	            scope.$watch(getTokens, function(newTokens, oldTokens) {
	              var notify = !(onArrayChanged && onArrayChanged(newTokens, oldTokens) === false);
	              if (notify) {
	                applyChanges(newTokens, oldTokens);
	              }
	            }, true);
	          },
	          onAdded: angular.noop,
	          onChanged: angular.noop,
	          onRemoved: angular.noop
	        };
	      };
	
	      this.getFullCalendarConfig = function(calendarSettings, uiCalendarConfig){
	          var config = {};
	
	          angular.extend(config, uiCalendarConfig);
	          angular.extend(config, calendarSettings);
	
	          angular.forEach(config, function(value,key){
	            if (typeof value === 'function'){
	              config[key] = wrapFunctionWithScopeApply(config[key]);
	            }
	          });
	
	          return config;
	      };
	
	    this.getLocaleConfig = function(fullCalendarConfig) {
	      if (!fullCalendarConfig.lang || fullCalendarConfig.useNgLocale) {
	        // Configure to use locale names by default
	        var tValues = function(data) {
	          // convert {0: "Jan", 1: "Feb", ...} to ["Jan", "Feb", ...]
	          var r, k;
	          r = [];
	          for (k in data) {
	            r[k] = data[k];
	          }
	          return r;
	        };
	        var dtf = $locale.DATETIME_FORMATS;
	        return {
	          monthNames: tValues(dtf.MONTH),
	          monthNamesShort: tValues(dtf.SHORTMONTH),
	          dayNames: tValues(dtf.DAY),
	          dayNamesShort: tValues(dtf.SHORTDAY)
	        };
	      }
	      return {};
	    };
	  }])
	  .directive('uiCalendar', ['uiCalendarConfig', function(uiCalendarConfig) {
	    return {
	      restrict: 'A',
	      scope: {eventSources:'=ngModel',calendarWatchEvent: '&'},
	      controller: 'uiCalendarCtrl',
	      link: function(scope, elm, attrs, controller) {
	
	        var sources = scope.eventSources,
	            sourcesChanged = false,
	            calendar,
	            eventSourcesWatcher = controller.changeWatcher(sources, controller.sourceFingerprint),
	            eventsWatcher = controller.changeWatcher(controller.allEvents, controller.eventFingerprint),
	            options = null;
	
	        function getOptions(){
	          var calendarSettings = attrs.uiCalendar ? scope.$parent.$eval(attrs.uiCalendar) : {},
	              fullCalendarConfig;
	
	          fullCalendarConfig = controller.getFullCalendarConfig(calendarSettings, uiCalendarConfig);
	
	          var localeFullCalendarConfig = controller.getLocaleConfig(fullCalendarConfig);
	          angular.extend(localeFullCalendarConfig, fullCalendarConfig);
	          options = { eventSources: sources };
	          angular.extend(options, localeFullCalendarConfig);
	          //remove calendars from options
	          options.calendars = null;
	
	          var options2 = {};
	          for(var o in options){
	            if(o !== 'eventSources'){
	              options2[o] = options[o];
	            }
	          }
	          return JSON.stringify(options2);
	        }
	
	        scope.destroyCalendar = function(){
	          if(calendar && calendar.fullCalendar){
	            calendar.fullCalendar('destroy');
	          }
	          if(attrs.calendar) {
	            calendar = uiCalendarConfig.calendars[attrs.calendar] = $(elm).html('');
	          } else {
	            calendar = $(elm).html('');
	          }
	        };
	
	        scope.initCalendar = function(){
	          if (!calendar) {
	            calendar = angular.element(elm).html('');
	          }
	          calendar.fullCalendar(options);
	          if(attrs.calendar) {
	            uiCalendarConfig.calendars[attrs.calendar] = calendar;
	          }          
	        };
	        scope.$on('$destroy', function() {
	          scope.destroyCalendar();
	        });
	
	        eventSourcesWatcher.onAdded = function(source) {
	          if (calendar && calendar.fullCalendar) {
	            calendar.fullCalendar(options);
	            if (attrs.calendar) {
	                uiCalendarConfig.calendars[attrs.calendar] = calendar;
	            }
	            calendar.fullCalendar('addEventSource', source);
	            sourcesChanged = true;
	          }
	        };
	
	        eventSourcesWatcher.onRemoved = function(source) {
	          if (calendar && calendar.fullCalendar) {
	            calendar.fullCalendar('removeEventSource', source);
	            sourcesChanged = true;
	          }
	        };
	
	        eventSourcesWatcher.onChanged = function() {
	          if (calendar && calendar.fullCalendar) {
	            calendar.fullCalendar('refetchEvents');
	            sourcesChanged = true;
	          }
	
	        };
	
	        eventsWatcher.onAdded = function(event) {
	          if (calendar && calendar.fullCalendar) {
	            calendar.fullCalendar('renderEvent', event, (event.stick ? true : false));
	          }
	        };
	
	        eventsWatcher.onRemoved = function(event) {
	          if (calendar && calendar.fullCalendar) {
	            calendar.fullCalendar('removeEvents', event._id);
	          }
	        };
	
	        eventsWatcher.onChanged = function(event) {
	          if (calendar && calendar.fullCalendar) {
	            var clientEvents = calendar.fullCalendar('clientEvents', event._id);
	            for (var i = 0; i < clientEvents.length; i++) {
	              var clientEvent = clientEvents[i];
	              clientEvent = angular.extend(clientEvent, event);
	              calendar.fullCalendar('updateEvent', clientEvent);
	            }
	          }
	        };
	
	        eventSourcesWatcher.subscribe(scope);
	        eventsWatcher.subscribe(scope, function() {
	          if (sourcesChanged === true) {
	            sourcesChanged = false;
	            // return false to prevent onAdded/Removed/Changed handlers from firing in this case
	            return false;
	          }
	        });
	
	        scope.$watch(getOptions, function(newValue, oldValue) {
	          if(newValue !== oldValue) {
	            scope.destroyCalendar();
	            scope.initCalendar();
	          } else if((newValue && angular.isUndefined(calendar))) {
	            scope.initCalendar();
	          }
	        });
	      }
	    };
	}]);


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	/** See the file "LICENSE" for the full license governing this code.
	 *
	 * @author Dale "Ducky" Lotts
	 * @since 9/11/16.
	 */
	
	__webpack_require__(307);
	__webpack_require__(310);
	
	module.exports = 'ui.bootstrap.datetimepicker';


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* globals define, jQuery, module, require, angular, moment */
	/* jslint vars:true */
	
	/**
	 * @license angular-bootstrap-datetimepicker
	 * Copyright 2016 Knight Rider Consulting, Inc. http://www.knightrider.com
	 * License: MIT
	 *
	 * @author        Dale "Ducky" Lotts
	 * @since        2013-Jul-8
	 */
	
	;(function (root, factory) {
	  'use strict'
	  /* istanbul ignore if */
	  if (typeof module !== 'undefined' && module.exports) {
	    var ng = typeof angular === 'undefined' ? __webpack_require__(308) : angular
	    var mt = typeof moment === 'undefined' ? __webpack_require__(44) : moment
	    factory(ng, mt)
	    module.exports = 'ui.bootstrap.datetimepicker'
	    /* istanbul ignore next */
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(308), __webpack_require__(44)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  } else {
	    factory(root.angular, root.moment)
	  }
	}(this, function (angular, moment) {
	  'use strict'
	  angular.module('ui.bootstrap.datetimepicker', [])
	    .service('dateTimePickerConfig', DateTimePickerConfigProvider)
	    .service('dateTimePickerValidator', DateTimePickerValidatorService)
	    .directive('datetimepicker', DatetimepickerDirective)
	
	  DatetimepickerDirective.$inject = ['dateTimePickerConfig', 'dateTimePickerValidator']
	
	  function DatetimepickerDirective (defaultConfig, configurationValidator) {
	    var directiveDefinition = {
	      bindToController: false,
	      controller: DirectiveController,
	      controllerAs: 'dateTimePickerController',
	      replace: true,
	      require: 'ngModel',
	      restrict: 'E',
	      scope: {
	        beforeRender: '&',
	        onSetTime: '&'
	      },
	      templateUrl: 'templates/datetimepicker.html'
	    }
	
	    DirectiveController.$inject = ['$scope', '$element', '$attrs']
	
	    function DirectiveController ($scope, $element, $attrs) {
	      // Configuration
	      var ngModelController = $element.controller('ngModel')
	
	      var configuration = createConfiguration()
	      $scope.screenReader = configuration.screenReader
	
	      // Behavior
	      $scope.changeView = changeView
	      ngModelController.$render = $render
	
	      if (configuration.configureOn) {
	        $scope.$on(configuration.configureOn, function () {
	          configuration = createConfiguration()
	          $scope.screenReader = configuration.screenReader
	          ngModelController.$render()
	        })
	      }
	
	      if (configuration.renderOn) {
	        $scope.$on(configuration.renderOn, ngModelController.$render)
	      }
	
	      // Implementation
	
	      var viewToModelFactory = {
	        year: yearModelFactory,
	
	        month: monthModelFactory,
	
	        day: dayModelFactory,
	
	        hour: hourModelFactory,
	
	        minute: minuteModelFactory,
	
	        setTime: setTime
	      }
	
	      function changeView (viewName, dateObject, event) {
	        if (event) {
	          event.stopPropagation()
	          event.preventDefault()
	        }
	
	        if (viewName && (dateObject.utcDateValue > -Infinity) && dateObject.selectable && viewToModelFactory[viewName]) {
	          var result = viewToModelFactory[viewName](dateObject.utcDateValue)
	
	          var weekDates = []
	          if (result.weeks) {
	            for (var i = 0; i < result.weeks.length; i += 1) {
	              var week = result.weeks[i]
	              for (var j = 0; j < week.dates.length; j += 1) {
	                var weekDate = week.dates[j]
	                weekDates.push(weekDate)
	              }
	            }
	          }
	
	          $scope.beforeRender({
	            $view: result.currentView,
	            $dates: result.dates || weekDates,
	            $leftDate: result.leftDate,
	            $upDate: result.previousViewDate,
	            $rightDate: result.rightDate
	          })
	
	          $scope.data = result
	        }
	      }
	
	      function yearModelFactory (milliseconds) {
	        var selectedDate = moment.utc(milliseconds).startOf('year')
	        // View starts one year before the decade starts and ends one year after the decade ends
	        // i.e. passing in a date of 1/1/2013 will give a range of 2009 to 2020
	        // Truncate the last digit from the current year and subtract 1 to get the start of the decade
	        var startDecade = (parseInt(selectedDate.year() / 10, 10) * 10)
	        var startDate = moment.utc(startOfDecade(milliseconds)).subtract(1, 'year').startOf('year')
	
	        var yearFormat = 'YYYY'
	        var activeFormat = formatValue(ngModelController.$modelValue, yearFormat)
	        var currentFormat = moment().format(yearFormat)
	
	        var result = {
	          'currentView': 'year',
	          'nextView': configuration.minView === 'year' ? 'setTime' : 'month',
	          'previousViewDate': new DateObject({
	            utcDateValue: null,
	            display: startDecade + '-' + (startDecade + 9)
	          }),
	          'leftDate': new DateObject({utcDateValue: moment.utc(startDate).subtract(9, 'year').valueOf()}),
	          'rightDate': new DateObject({utcDateValue: moment.utc(startDate).add(11, 'year').valueOf()}),
	          'dates': []
	        }
	
	        for (var i = 0; i < 12; i += 1) {
	          var yearMoment = moment.utc(startDate).add(i, 'years')
	          var dateValue = {
	            'active': yearMoment.format(yearFormat) === activeFormat,
	            'current': yearMoment.format(yearFormat) === currentFormat,
	            'display': yearMoment.format(yearFormat),
	            'future': yearMoment.year() > startDecade + 9,
	            'past': yearMoment.year() < startDecade,
	            'utcDateValue': yearMoment.valueOf()
	          }
	
	          result.dates.push(new DateObject(dateValue))
	        }
	
	        return result
	      }
	
	      function monthModelFactory (milliseconds) {
	        var startDate = moment.utc(milliseconds).startOf('year')
	        var previousViewDate = startOfDecade(milliseconds)
	
	        var monthFormat = 'YYYY-MMM'
	        var activeFormat = formatValue(ngModelController.$modelValue, monthFormat)
	        var currentFormat = moment().format(monthFormat)
	
	        var result = {
	          'previousView': 'year',
	          'currentView': 'month',
	          'nextView': configuration.minView === 'month' ? 'setTime' : 'day',
	          'previousViewDate': new DateObject({
	            utcDateValue: previousViewDate.valueOf(),
	            display: startDate.format('YYYY')
	          }),
	          'leftDate': new DateObject({utcDateValue: moment.utc(startDate).subtract(1, 'year').valueOf()}),
	          'rightDate': new DateObject({utcDateValue: moment.utc(startDate).add(1, 'year').valueOf()}),
	          'dates': []
	        }
	
	        for (var i = 0; i < 12; i += 1) {
	          var monthMoment = moment.utc(startDate).add(i, 'months')
	          var dateValue = {
	            'active': monthMoment.format(monthFormat) === activeFormat,
	            'current': monthMoment.format(monthFormat) === currentFormat,
	            'display': monthMoment.format('MMM'),
	            'utcDateValue': monthMoment.valueOf()
	          }
	
	          result.dates.push(new DateObject(dateValue))
	        }
	
	        return result
	      }
	
	      function dayModelFactory (milliseconds) {
	        var selectedDate = moment.utc(milliseconds)
	        var startOfMonth = moment.utc(selectedDate).startOf('month')
	        var previousViewDate = moment.utc(selectedDate).startOf('year')
	        var endOfMonth = moment.utc(selectedDate).endOf('month')
	
	        var startDate = moment.utc(startOfMonth).subtract(Math.abs(startOfMonth.weekday()), 'days')
	
	        var dayFormat = 'YYYY-MMM-DD'
	        var activeFormat = formatValue(ngModelController.$modelValue, dayFormat)
	        var currentFormat = moment().format(dayFormat)
	
	        var result = {
	          'previousView': 'month',
	          'currentView': 'day',
	          'nextView': configuration.minView === 'day' ? 'setTime' : 'hour',
	          'previousViewDate': new DateObject({
	            utcDateValue: previousViewDate.valueOf(),
	            display: startOfMonth.format('YYYY-MMM')
	          }),
	          'leftDate': new DateObject({utcDateValue: moment.utc(startOfMonth).subtract(1, 'months').valueOf()}),
	          'rightDate': new DateObject({utcDateValue: moment.utc(startOfMonth).add(1, 'months').valueOf()}),
	          'dayNames': [],
	          'weeks': []
	        }
	
	        for (var dayNumber = 0; dayNumber < 7; dayNumber += 1) {
	          result.dayNames.push(moment.utc().weekday(dayNumber).format('dd'))
	        }
	
	        for (var i = 0; i < 6; i += 1) {
	          var week = {dates: []}
	          for (var j = 0; j < 7; j += 1) {
	            var dayMoment = moment.utc(startDate).add((i * 7) + j, 'days')
	            var dateValue = {
	              'active': dayMoment.format(dayFormat) === activeFormat,
	              'current': dayMoment.format(dayFormat) === currentFormat,
	              'display': dayMoment.format('D'),
	              'future': dayMoment.isAfter(endOfMonth),
	              'past': dayMoment.isBefore(startOfMonth),
	              'utcDateValue': dayMoment.valueOf()
	            }
	            week.dates.push(new DateObject(dateValue))
	          }
	          result.weeks.push(week)
	        }
	
	        return result
	      }
	
	      function hourModelFactory (milliseconds) {
	        var selectedDate = moment.utc(milliseconds).startOf('day')
	        var previousViewDate = moment.utc(selectedDate).startOf('month')
	
	        var hourFormat = 'YYYY-MM-DD H'
	        var activeFormat = formatValue(ngModelController.$modelValue, hourFormat)
	        var currentFormat = moment().format(hourFormat)
	
	        var result = {
	          'previousView': 'day',
	          'currentView': 'hour',
	          'nextView': configuration.minView === 'hour' ? 'setTime' : 'minute',
	          'previousViewDate': new DateObject({
	            utcDateValue: previousViewDate.valueOf(),
	            display: selectedDate.format('ll')
	          }),
	          'leftDate': new DateObject({utcDateValue: moment.utc(selectedDate).subtract(1, 'days').valueOf()}),
	          'rightDate': new DateObject({utcDateValue: moment.utc(selectedDate).add(1, 'days').valueOf()}),
	          'dates': []
	        }
	
	        for (var i = 0; i < 24; i += 1) {
	          var hourMoment = moment.utc(selectedDate).add(i, 'hours')
	          var dateValue = {
	            'active': hourMoment.format(hourFormat) === activeFormat,
	            'current': hourMoment.format(hourFormat) === currentFormat,
	            'display': hourMoment.format('LT'),
	            'utcDateValue': hourMoment.valueOf()
	          }
	
	          result.dates.push(new DateObject(dateValue))
	        }
	
	        return result
	      }
	
	      function minuteModelFactory (milliseconds) {
	        var selectedDate = moment.utc(milliseconds).startOf('hour')
	        var previousViewDate = moment.utc(selectedDate).startOf('day')
	
	        var minuteFormat = 'YYYY-MM-DD H:mm'
	        var activeFormat = formatValue(ngModelController.$modelValue, minuteFormat)
	        var currentFormat = moment().format(minuteFormat)
	
	        var result = {
	          'previousView': 'hour',
	          'currentView': 'minute',
	          'nextView': 'setTime',
	          'previousViewDate': new DateObject({
	            utcDateValue: previousViewDate.valueOf(),
	            display: selectedDate.format('lll')
	          }),
	          'leftDate': new DateObject({utcDateValue: moment.utc(selectedDate).subtract(1, 'hours').valueOf()}),
	          'rightDate': new DateObject({utcDateValue: moment.utc(selectedDate).add(1, 'hours').valueOf()}),
	          'dates': []
	        }
	
	        var limit = 60 / configuration.minuteStep
	
	        for (var i = 0; i < limit; i += 1) {
	          var hourMoment = moment.utc(selectedDate).add(i * configuration.minuteStep, 'minute')
	          var dateValue = {
	            'active': hourMoment.format(minuteFormat) === activeFormat,
	            'current': hourMoment.format(minuteFormat) === currentFormat,
	            'display': hourMoment.format('LT'),
	            'utcDateValue': hourMoment.valueOf()
	          }
	
	          result.dates.push(new DateObject(dateValue))
	        }
	
	        return result
	      }
	
	      function setTime (milliseconds) {
	        var tempDate = new Date(milliseconds)
	        var newDate = new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds(), tempDate.getUTCMilliseconds())
	
	        switch (configuration.modelType) {
	          case 'Date':
	            // No additional work needed
	            break
	          case 'moment':
	            newDate = moment([tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds(), tempDate.getUTCMilliseconds()])
	            break
	          case 'milliseconds':
	            newDate = milliseconds
	            break
	          default: // It is assumed that the modelType is a formatting string.
	            newDate = moment([tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds(), tempDate.getUTCMilliseconds()]).format(configuration.modelType)
	        }
	
	        var oldDate = ngModelController.$modelValue
	        ngModelController.$setViewValue(newDate)
	
	        if (configuration.dropdownSelector) {
	          jQuery(configuration.dropdownSelector).dropdown('toggle')
	        }
	
	        $scope.onSetTime({newDate: newDate, oldDate: oldDate})
	
	        return viewToModelFactory[configuration.startView](milliseconds)
	      }
	
	      function $render () {
	        $scope.changeView(configuration.startView, new DateObject({utcDateValue: getUTCTime(ngModelController.$viewValue)}))
	      }
	
	      function startOfDecade (milliseconds) {
	        var startYear = (parseInt(moment.utc(milliseconds).year() / 10, 10) * 10)
	        return moment.utc(milliseconds).year(startYear).startOf('year')
	      }
	
	      function formatValue (timeValue, formatString) {
	        if (timeValue) {
	          return getMoment(timeValue).format(formatString)
	        } else {
	          return ''
	        }
	      }
	
	      /**
	       * Converts a time value into a moment.
	       *
	       * This function is now necessary because moment logs a warning when parsing a string without a format.
	       * @param modelValue
	       *  a time value in any of the supported formats (Date, moment, milliseconds, and string)
	       * @returns {moment}
	       *  representing the specified time value.
	       */
	
	      function getMoment (modelValue) {
	        return moment(modelValue, angular.isString(modelValue) ? configuration.parseFormat : undefined)
	      }
	
	      /**
	       * Converts a time value to UCT/GMT time.
	       * @param modelValue
	       *  a time value in any of the supported formats (Date, moment, milliseconds, and string)
	       * @returns {number}
	       *  number of milliseconds since 1/1/1970
	       */
	
	      function getUTCTime (modelValue) {
	        var tempDate = new Date()
	        if (modelValue) {
	          var tempMoment = getMoment(modelValue)
	          if (tempMoment.isValid()) {
	            tempDate = tempMoment.toDate()
	          } else {
	            throw new Error('Invalid date: ' + modelValue)
	          }
	        }
	        return tempDate.getTime() - (tempDate.getTimezoneOffset() * 60000)
	      }
	
	      function createConfiguration () {
	        var directiveConfig = {}
	
	        if ($attrs.datetimepickerConfig) {
	          directiveConfig = $scope.$parent.$eval($attrs.datetimepickerConfig)
	        }
	
	        var configuration = angular.extend({}, defaultConfig, directiveConfig)
	
	        configurationValidator.validate(configuration)
	
	        return configuration
	      }
	    }
	
	    function DateObject () {
	      var tempDate = new Date(arguments[0].utcDateValue)
	      var localOffset = tempDate.getTimezoneOffset() * 60000
	
	      this.utcDateValue = tempDate.getTime()
	      this.selectable = true
	
	      this.localDateValue = function localDateValue () {
	        return this.utcDateValue + localOffset
	      }
	
	      var validProperties = ['active', 'current', 'display', 'future', 'past', 'selectable', 'utcDateValue']
	
	      var constructorObject = arguments[0]
	
	      Object.keys(constructorObject).filter(function (key) {
	        return validProperties.indexOf(key) >= 0
	      }).forEach(function (key) {
	        this[key] = constructorObject[key]
	      }, this)
	    }
	
	    return directiveDefinition
	  }
	
	  function DateTimePickerConfigProvider () {
	    var defaultConfiguration = {
	      configureOn: null,
	      dropdownSelector: null,
	      minuteStep: 5,
	      minView: 'minute',
	      modelType: 'Date',
	      parseFormat: 'YYYY-MM-DDTHH:mm:ss.SSSZZ',
	      renderOn: null,
	      startView: 'day'
	    }
	
	    var defaultLocalization = {
	      'bg': {previous: 'предишна', next: 'следваща'},
	      'ca': {previous: 'anterior', next: 'següent'},
	      'da': {previous: 'forrige', next: 'næste'},
	      'de': {previous: 'vorige', next: 'weiter'},
	      'en-au': {previous: 'previous', next: 'next'},
	      'en-gb': {previous: 'previous', next: 'next'},
	      'en': {previous: 'previous', next: 'next'},
	      'es-us': {previous: 'atrás', next: 'siguiente'},
	      'es': {previous: 'atrás', next: 'siguiente'},
	      'fi': {previous: 'edellinen', next: 'seuraava'},
	      'fr': {previous: 'précédent', next: 'suivant'},
	      'hu': {previous: 'előző', next: 'következő'},
	      'it': {previous: 'precedente', next: 'successivo'},
	      'ja': {previous: '前へ', next: '次へ'},
	      'ml': {previous: 'മുൻപുള്ളത്', next: 'അടുത്തത്'},
	      'nl': {previous: 'vorige', next: 'volgende'},
	      'pl': {previous: 'poprzednia', next: 'następna'},
	      'pt-br': {previous: 'anteriores', next: 'próximos'},
	      'pt': {previous: 'anterior', next: 'próximo'},
	      'ro': {previous: 'anterior', next: 'următor'},
	      'ru': {previous: 'предыдущая', next: 'следующая'},
	      'sk': {previous: 'predošlá', next: 'ďalšia'},
	      'sv': {previous: 'föregående', next: 'nästa'},
	      'tr': {previous: 'önceki', next: 'sonraki'},
	      'uk': {previous: 'назад', next: 'далі'},
	      'zh-cn': {previous: '上一页', next: '下一页'},
	      'zh-tw': {previous: '上一頁', next: '下一頁'}
	    }
	
	    var screenReader = defaultLocalization[moment.locale().toLowerCase()]
	
	    return angular.extend({}, defaultConfiguration, {screenReader: screenReader})
	  }
	
	  DateTimePickerValidatorService.$inject = ['$log']
	
	  function DateTimePickerValidatorService ($log) {
	    return {
	      validate: validator
	    }
	
	    function validator (configuration) {
	      var validOptions = [
	        'configureOn',
	        'dropdownSelector',
	        'minuteStep',
	        'minView',
	        'modelType',
	        'parseFormat',
	        'renderOn',
	        'startView',
	        'screenReader'
	      ]
	
	      var invalidOptions = Object.keys(configuration).filter(function (key) {
	        return (validOptions.indexOf(key) < 0)
	      })
	
	      if (invalidOptions.length) {
	        throw new Error('Invalid options: ' + invalidOptions.join(', '))
	      }
	
	      // Order of the elements in the validViews array is significant.
	      var validViews = ['minute', 'hour', 'day', 'month', 'year']
	
	      if (validViews.indexOf(configuration.startView) < 0) {
	        throw new Error('invalid startView value: ' + configuration.startView)
	      }
	
	      if (validViews.indexOf(configuration.minView) < 0) {
	        throw new Error('invalid minView value: ' + configuration.minView)
	      }
	
	      if (validViews.indexOf(configuration.minView) > validViews.indexOf(configuration.startView)) {
	        throw new Error('startView must be greater than minView')
	      }
	
	      if (!angular.isNumber(configuration.minuteStep)) {
	        throw new Error('minuteStep must be numeric')
	      }
	      if (configuration.minuteStep <= 0 || configuration.minuteStep >= 60) {
	        throw new Error('minuteStep must be greater than zero and less than 60')
	      }
	      if (configuration.configureOn !== null && !angular.isString(configuration.configureOn)) {
	        throw new Error('configureOn must be a string')
	      }
	      if (configuration.configureOn !== null && configuration.configureOn.length < 1) {
	        throw new Error('configureOn must not be an empty string')
	      }
	      if (configuration.renderOn !== null && !angular.isString(configuration.renderOn)) {
	        throw new Error('renderOn must be a string')
	      }
	      if (configuration.renderOn !== null && configuration.renderOn.length < 1) {
	        throw new Error('renderOn must not be an empty string')
	      }
	      if (configuration.modelType !== null && !angular.isString(configuration.modelType)) {
	        throw new Error('modelType must be a string')
	      }
	      if (configuration.modelType !== null && configuration.modelType.length < 1) {
	        throw new Error('modelType must not be an empty string')
	      }
	      if (configuration.modelType !== 'Date' && configuration.modelType !== 'moment' && configuration.modelType !== 'milliseconds') {
	        // modelType contains string format, overriding parseFormat with modelType
	        configuration.parseFormat = configuration.modelType
	      }
	      if (configuration.dropdownSelector !== null && !angular.isString(configuration.dropdownSelector)) {
	        throw new Error('dropdownSelector must be a string')
	      }
	
	      /* istanbul ignore next */
	      if (configuration.dropdownSelector !== null && ((typeof jQuery === 'undefined') || (typeof jQuery().dropdown !== 'function'))) {
	        $log.error('Please DO NOT specify the dropdownSelector option unless you are using jQuery AND Bootstrap.js. ' +
	          'Please include jQuery AND Bootstrap.js, or write code to close the dropdown in the on-set-time callback. \n\n' +
	          'The dropdownSelector configuration option is being removed because it will not function properly.')
	        delete configuration.dropdownSelector
	      }
	    }
	  }
	})); // eslint-disable-line semi


/***/ }),
/* 308 */
[1140, 309],
/* 309 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.6
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/* exported
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth
	*/
	
	var minErrConfig = {
	  objectMaxDepth: 5
	};
	
	/**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index];
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.6.6/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  manualLowercase,
	  manualUppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isError,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @ngdoc function
	 * @name angular.lowercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @ngdoc function
	 * @name angular.uppercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	  /* eslint-enable */
	};
	var manualUppercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	  /* eslint-enable */
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @deprecated
	* sinceVersion="1.6.5"
	* This function is deprecated, but will not be removed in the 1.x lifecycle.
	* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
	* supported by this function. We suggest
	* using [lodash's merge()](https://lodash.com/docs/4.17.4#merge) instead.
	*
	* @knownIssue
	* This is a list of (known) object types that are not handled correctly by this function:
	* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
	* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
	* - AngularJS {@link $rootScope.Scope scopes};
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`. Alias of Array.isArray.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @description
	 * Determines if a reference is an `Error`.
	 * Loosely based on https://www.npmjs.com/package/iserror
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Error`.
	 */
	function isError(value) {
	  var tag = toString.call(value);
	  switch (tag) {
	    case '[object Error]': return true;
	    case '[object Exception]': return true;
	    case '[object DOMException]': return true;
	    default: return value instanceof Error;
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>master = {{master | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.master = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.master);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.master);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-15+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone().empty();
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // Support: IE 9-11 only
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for non-whitelisted schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('Angular: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, 'events');
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* exported toDebugString */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    // This file is also included in `angular-loader`, so `copy()` might not always be available in
	    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
	    obj = angular.copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.6.6',
	  major: 1,
	  minor: 6,
	  dot: 6,
	  codeName: 'interdimensional-cable'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$stringify': stringify
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.6.6' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, '', '']
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (' ' + (element.getAttribute('class') || '') + ' ')
	          .replace(/[\n\t]/g, ' ')
	          .replace(' ' + trim(cssClass) + ' ', ' '))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key === this._lastKey) {
	      return this._lastIndex;
	    }
	    this._lastKey = key;
	    this._lastIndex = this._keys.indexOf(key);
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        // Support: Edge 12-13 only
	        // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	        result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	  var customFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#customFilter
	   *
	   * @description
	   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
	   * determine if an animation is allowed or not. When no filter is specified (the default), no
	   * animation will be blocked. Setting the `customFilter` value will only allow animations for
	   * which the filter function's return value is truthy.
	   *
	   * This allows to easily create arbitrarily complex rules for filtering animations, such as
	   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
	   * Filtering animations can also boost performance for low-powered devices, as well as
	   * applications containing a lot of structural operations.
	   *
	   * <div class="alert alert-success">
	   *   **Best Practice:**
	   *   Keep the filtering function as lean as possible, because it will be called for each DOM
	   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
	   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
	   *   directives that support animations.
	   *   Performing computationally expensive or time-consuming operations on each call of the
	   *   filtering function can make your animations sluggish.
	   * </div>
	   *
	   * **Note:** If present, `customFilter` will be checked before
	   * {@link $animateProvider#classNameFilter classNameFilter}.
	   *
	   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
	   *   If a falsy value is returned, no animation will be performed. The function will be called
	   *   with the following arguments:
	   *   - **node** `{DOMElement}` - The DOM element to be animated.
	   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
	   *     etc).
	   *   - **options** `{Object}` - A collection of options/styles used for the animation.
	   * @return {Function} The current filter function or `null` if there is none set.
	   */
	  this.customFilter = function(filterFn) {
	    if (arguments.length === 1) {
	      customFilter = isFunction(filterFn) ? filterFn : null;
	    }
	
	    return customFilter;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   *
	   * **Note:** If present, `classNameFilter` will be checked after
	   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
	   * false, `classNameFilter` will not be checked.
	   *
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        if (runner.end) {
	          runner.end();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,'\'');
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with Angular 2 life-cycle hooks
	 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
	 *
	 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular 2 you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
	 *   `ngDoCheck` in Angular 2
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** if `$compileProcvider.preAssignBindingsEnabled(true)` was called, bindings for non-ES6 class
	 * controllers are bound to `this` before the controller constructor is called but this use is now deprecated. Please
	 * place initialization code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	 *
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	   *    or an object map of components where the keys are the names and the values are the component definition objects.
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    if (!isString(name)) {
	      forEach(name, reverseParams(bind(this, registerComponent)));
	      return this;
	    }
	
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in Angular looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#preAssignBindingsEnabled
	   *
	   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
	   * current preAssignBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable whether directive controllers are assigned bindings before
	   * calling the controller's constructor.
	   * If enabled (true), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   *
	   * If disabled (false), the compiler calls the constructor first before assigning bindings.
	   *
	   * The default value is false.
	   *
	   * @deprecated
	   * sinceVersion="1.6.0"
	   * removeVersion="1.7.0"
	   *
	   * This method and the option to assign the bindings before calling the controller's constructor
	   * will be removed in v1.7.0.
	   */
	  var preAssignBindingsEnabled = false;
	  this.preAssignBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      preAssignBindingsEnabled = enabled;
	      return this;
	    }
	    return preAssignBindingsEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#strictComponentBindingsEnabled
	   *
	   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided, otherwise just return the
	   * current strictComponentBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable strict component bindings check. If enabled, the compiler will enforce that
	   * for all bindings of a component that are not set as optional with `?`, an attribute needs to be provided
	   * on the component's HTML tag.
	   *
	   * The default value is false.
	   */
	  var strictComponentBindingsEnabled = false;
	  this.strictComponentBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      strictComponentBindingsEnabled = enabled;
	      return this;
	    }
	    return strictComponentBindingsEnabled;
	  };
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          var errors = [];
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              errors.push(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	          if (errors.length) {
	            throw errors;
	          }
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = '';
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (' ' + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (' ' + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
	            if (isNgAttr) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (preAssignBindingsEnabled) {
	            if (bindings) {
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            } else {
	              controller.bindingInfo = {};
	            }
	
	            var controllerResult = controller();
	            if (controllerResult !== controller.instance) {
	              // If the controller constructor has a return value, overwrite the instance
	              // from setupControllers
	              controller.instance = controllerResult;
	              $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	              if (controller.bindingInfo.removeWatches) {
	                controller.bindingInfo.removeWatches();
	              }
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            }
	          } else {
	            controller.instance = controller();
	            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (isError(error)) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // All tags with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media tags.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      } else if (attrNormalizedName === 'xlinkHref' ||
	          (tag === 'form' && attrNormalizedName === 'action') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (tag === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var trustedContext = getTrustedContext(node, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName_(node) === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents',
	            'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' +
	                'ng- versions (such as ng-click instead of onclick) instead.');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	    function strictBindingsCheck(attrName, directiveName) {
	      if (strictComponentBindingsEnabled) {
	        throw $compileMinErr('missingattr',
	          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
	          attrName, directiveName);
	      }
	    }
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	              destination[scopeName] = attrs[attrName] = undefined;
	
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var deepWatch = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, deepWatch);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	            }
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, fnCamelCaseReplace);
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   *
	   * @deprecated
	   * sinceVersion="v1.3.0"
	   * removeVersion="v1.7.0"
	   * This method of finding controllers has been deprecated.
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (deprecated, not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value) || isFunction(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);
	
	      if (hasJsonContentType || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          if (!hasJsonContentType) {
	            return data;
	          }
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.transformRequest`** -
	   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
	   * An array of functions (or a single function) which are applied to the request data.
	   * By default, this is an array with one request transformation function:
	   *
	   *   - If the `data` property of the request configuration object contains an object, serialize it
	   *     into JSON format.
	   *
	   * - **`defaults.transformResponse`** -
	   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
	   * An array of functions (or a single function) which are applied to the response data. By default,
	   * this is an array which applies one response transformation function that does two things:
	   *
	   *  - If XSRF prefix is detected, strip it
	   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
	   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *    deserialize it using a JSON parser.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest (`complete`, `error`, `timeout` or `abort`).
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
	     * an array with one function that does the following:
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
	     * an array with one function that does the following:
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *      deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must whitelist the JSONP endpoint that we are using to show that we trust it
	      $sceDelegateProvider.resourceUrlWhitelist([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount();
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop);
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the whitelist via
	     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText, xhrStatus) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText, xhrStatus);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText, xhrStatus) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText,
	          xhrStatus: xhrStatus
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, key) {
	      if (/[&?][^=]+=JSON_CALLBACK/.test(url)) {
	        // Throw if the url already contains a reference to JSON_CALLBACK
	        throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	      }
	
	      var callbackParamRegex = new RegExp('[&?]' + key + '=');
	      if (callbackParamRegex.test(url)) {
	        // Throw if the callback param was already provided
	        throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', key, url);
	      }
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + key + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text, 'complete');
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText,
	            'complete');
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'error');
	      };
	
	      var requestAborted = function() {
	        completeRequest(callback, -1, null, null, '', 'abort');
	      };
	
	      var requestTimeout = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'timeout');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestAborted;
	      xhr.ontimeout = requestTimeout;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText, xhrStatus);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape Angular
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	      *   are passed (see below), the function is called with the current iteration count.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	      *
	      * @example
	      * <example module="intervalExample" name="interval-service">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        // Interval cancels should not report as unhandled promise.
	        markQExceptionHandled(intervals[promise.$$intervalId].promise);
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang URL and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = trimEmptyHash($browser.url());
	        var newUrl = trimEmptyHash($location.absUrl());
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = oldUrl !== newUrl ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * To reveal the location of the calls to `$log` in the JavaScript console,
	 * you can "blackbox" the AngularJS source in your browser:
	 *
	 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
	 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
	 *
	 * Note: Not all browsers support blackboxing.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (isError(arg)) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop;
	
	      return function() {
	        var args = [];
	        forEach(arguments, function(arg) {
	          args.push(formatError(arg));
	        });
	        // Support: IE 9 only
	        // console methods don't inherit from Function.prototype in IE 9 so we can't
	        // call `logFn.apply(console, args)` directly.
	        return Function.prototype.apply.call(logFn, console, args);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	var PURITY_ABSOLUTE = 1;
	var PURITY_RELATIVE = 2;
	
	// Detect nodes which could depend on non-shallow state of objects
	function isPure(node, parentIsPure) {
	  switch (node.type) {
	    // Computed members might invoke a stateful toString()
	    case AST.MemberExpression:
	      if (node.computed) {
	        return false;
	      }
	      break;
	
	    // Unary always convert to primative
	    case AST.UnaryExpression:
	      return PURITY_ABSOLUTE;
	
	    // The binary + operator can invoke a stateful toString().
	    case AST.BinaryExpression:
	      return node.operator !== '+' ? PURITY_ABSOLUTE : false;
	
	    // Functions / filters probably read state from within objects
	    case AST.CallExpression:
	      return false;
	  }
	
	  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
	}
	
	function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	
	  var astIsPure = ast.isPure = isPure(ast, parentIsPure);
	
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
	      allConstants = allConstants && property.value.constant;
	      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      if (property.computed) {
	        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
	        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
	        allConstants = allConstants && property.key.constant;
	        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var inputs = this.state.inputs;
	    var self = this;
	    forEach(inputs, function(input) {
	      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
	      if (input.isPure) {
	        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
	      }
	    });
	    if (inputs.length) {
	      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        input.isPure = watch.isPure;
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.ast.ast(text);
	    var fn = this.astCompiler.compile(ast);
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in Angular expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, oneTime, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var unwatch, lastValue;
	      if (parsedExpression.inputs) {
	        unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
	      } else {
	        unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
	      }
	      return unwatch;
	
	      function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }
	      function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      return unwatch;
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      useInputs = !parsedExpression.inputs;
	      if (watchDelegate && watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = watchDelegate;
	        fn.inputs = parsedExpression.inputs;
	      } else if (!interceptorFn.$stateful) {
	        // Treat interceptor like filters - assume non-stateful by default and use the inputsWatchDelegate
	        fn.$$watchDelegate = inputsWatchDelegate;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      if (fn.inputs) {
	        fn.inputs = fn.inputs.map(function(e) {
	              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
	              // potentially non-pure interceptor function.
	              if (e.isPure === PURITY_RELATIVE) {
	                return function depurifier(s) { return e(s); };
	              }
	              return e;
	            });
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        markQStateExceptionHandled(state);
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!isStateExceptionHandled(toCheck)) {
	        markQStateExceptionHandled(toCheck);
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (isError(toCheck.value)) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function isStateExceptionHandled(state) {
	  return !!state.pur;
	}
	function markQStateExceptionHandled(state) {
	  state.pur = true;
	}
	function markQExceptionHandled(q) {
	  markQStateExceptionHandled(q.$$state);
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are
	       *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * `$watchGroup` is more performant than watching each expression individually, and should be
	       * used when the listener does not need to know which expression has changed.
	       * If the listener needs to know which expression has changed,
	       * {@link ng.$rootScope.Scope#$watch $watch()} or
	       * {@link ng.$rootScope.Scope#$watchCollection $watchCollection()} should be used.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`.
	       *
	       *    Note that `newValues` and `oldValues` reflect the differences in each **individual**
	       *    expression, and not the difference of the values between each call of the listener.
	       *    That means the difference between `newValues` and `oldValues` cannot be used to determine
	       *    which expression has changed / remained stable:
	       *
	       *    ```js
	       *
	       *    $scope.$watchGroup(['v1', 'v2'], function(newValues, oldValues) {
	       *      console.log(newValues, oldValues);
	       *    });
	       *
	       *    // newValues, oldValues initially
	       *    // [undefined, undefined], [undefined, undefined]
	       *
	       *    $scope.v1 = 'a';
	       *    $scope.v2 = 'a';
	       *
	       *    // ['a', 'a'], [undefined, undefined]
	       *
	       *    $scope.v2 = 'b'
	       *
	       *    // v1 hasn't changed since it became `'a'`, therefore its oldValue is still `undefined`
	       *    // ['a', 'b'], [undefined, 'a']
	       *
	       *    ```
	       *
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it does not refer to a resource that loads code. Currently
	  // unused in AngularJS.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
	 * places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
	 * and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty whitelist will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
	 * for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set whitelist array.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
	   * with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the blacklist is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} The currently set blacklist array.
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes any input, and either returns a value that's safe to use in the specified context, or
	     * throws an exception.
	     *
	     * In practice, there are several cases. When given a string, this function runs checks
	     * and sanitization to make it safe without prior assumptions. When given the result of a {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call, it returns the originally supplied
	     * value if that value's context is valid for this call's context. Finally, this function can
	     * also throw when there is no way to turn `maybeTrusted` in a safe value (e.g., no sanitization
	     * is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // Otherwise, if we get here, then we may either make it safe, or throw an exception. This
	      // depends on the context: some are sanitizatible (HTML), some use whitelists (RESOURCE_URL),
	      // some are impossible to do (JS). This step isn't implemented for CSS and URL, as AngularJS
	      // has no corresponding sinks.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        // RESOURCE_URL uses a whitelist.
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ## Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
	 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
	 * can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ## In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works. The `$sceDelegate` will
	 * also use the `$sanitize` service if it is available when binding untrusted values to
	 * `$sce.HTML` context. AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered, and the {@link ngSanitize.$sanitize $sanitize} service is available (implemented by the {@link ngSanitize ngSanitize} module) this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently, no bindings require this context. Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=`, `<img src=`, and some others sanitize their urls and don't constitute an SCE context.) |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does (it's not just the URL that matters, but also what is at the end of it), and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently, no bindings require this context.  Feel free to use it in your own directives. |
	 *
	 *
	 * Be aware that `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}. There's no CSS-, URL-, or JS-context bindings
	 * in AngularJS currently, so their corresponding `$sce.trustAs` functions aren't useful yet. This
	 * might evolve.
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through whitelisting again for keys that already
	        // are included in there. This also makes Angular accept any script
	        // directive, no matter its name. However, we still need to unwrap trusted
	        // types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            $templateCache.put(tpl, response.data);
	            return response.data;
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        // Timeout cancels should not report an unhandled promise.
	        markQExceptionHandled(deferreds[promise.$$timeoutId].promise);
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services.Angular comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 *
	 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
	 *
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @example
	   <example module="uppercaseFilterExample" name="filter-uppercase">
	     <file name="index.html">
	       <script>
	         angular.module('uppercaseFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.title = 'This is a title';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <!-- This title should be formatted normally -->
	         <h1>{{title}}</h1>
	         <!-- This title should be capitalized -->
	         <h1>{{title | uppercase}}</h1>
	       </div>
	     </file>
	   </example>
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * If a custom comparator still can't distinguish between two items, then they will be sorted based
	 * on their index using the built-in comparator.
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
	 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
	 *           other values.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = type1 < type2 ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Internet Explorer and Edge do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>List</summary>
	            <ul>
	              <li>Apple</li>
	              <li>Orange</li>
	              <li>Durian</li>
	            </ul>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $pending An object hash, containing references to controls or forms with
	 *  pending validators, where:
	 *
	 *  - keys are validations tokens (error names).
	 *  - values are arrays of controls or forms that have a pending validator for the given error name.
	 *
	 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
	 *
	 * @property {Object} $error An object hash, containing references to controls or forms with failing
	 *  validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for the given error name.
	 *
	 *  Built-in validation tokens:
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  $setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    this.$$parentForm.$setSubmitted();
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Change the validity state of the form, and notify the parent form (if any).
	 *
	 * Application developers will rarely need to call this method directly. It is used internally, by
	 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
	 * control's validity state to the parent `FormController`.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
	 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
	 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
	 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
	 *        class name. Example: `myError` will result in `ng-valid-my-error` and
	 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
	 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
	 *        `$asyncValidators` do not run because any of the `$validators` failed.
	 * @param {NgModelController | FormController} controller - The controller whose validity state is
	 *        triggering the change.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for Angular:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * Angular will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, Angular will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the Angular will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {string=} ngChange Angular expression to be executed when the ngModel value changes due
	   *                  to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options.getOption('timezone');
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var minVal;
	  var maxVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      minVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      maxVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal;
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	             isValidForStep(viewValue, minVal || 0, stepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      stepVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    attr.$observe(htmlAttrName, changeFn);
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (supportsRange && ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when Angular tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var expression = attr[name].trim();
	        var isOneTime = (expression.charAt(0) === ':') && (expression.charAt(1) === ':');
	
	        var watchInterceptor = isOneTime ? toFlatValue : toClassString;
	        var watchExpression = $parse(expression, watchInterceptor);
	        var watchAction = isOneTime ? ngClassOneTimeWatchAction : ngClassWatchAction;
	
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch(watchExpression, watchAction, isOneTime);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClass[OneTime]WatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClass[OneTime]WatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassOneTimeWatchAction(newClassValue) {
	          var newClassString = toClassString(newClassValue);
	
	          if (newClassString !== oldClassString) {
	            ngClassWatchAction(newClassString);
	          }
	        }
	
	        function ngClassWatchAction(newClassString) {
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    }
	
	    return classString;
	  }
	
	  function toFlatValue(classValue) {
	    var flatValue = classValue;
	
	    if (isArray(classValue)) {
	      flatValue = classValue.map(toFlatValue);
	    } else if (isObject(classValue)) {
	      var hasUndefined = false;
	
	      flatValue = Object.keys(classValue).filter(function(key) {
	        var value = classValue[key];
	
	        if (!hasUndefined && isUndefined(value)) {
	          hasUndefined = true;
	        }
	
	        return value;
	      });
	
	      if (hasUndefined) {
	        // Prevent the `oneTimeLiteralWatchInterceptor` from unregistering
	        // the watcher, by including at least one `undefined` value.
	        flatValue.push(undefined);
	      }
	    }
	
	    return flatValue;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (deprecated, not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * Angular has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell Angular not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect Angular:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. Angular makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating Angular expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. Angular makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function MainController() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  try {
	                    eval('1+2'); // eslint-disable-line no-eval
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // NOTE:
	          // We expose the powerful `$event` object on the scope that provides access to the Window,
	          // etc. This is OK, because expressions are not sandboxed any more (and the expression
	          // sandbox was never meant to be a security feature anyway).
	          var fn = $parse(attr[directiveName]);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event: event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	
	  this.$$currentValidationRunId = 0;
	
	  // https://github.com/angular/angular.js/issues/15833
	  // Prevent `$$scope` from being iterated over by `copy` when NgModelController is deep watched
	  Object.defineProperty(this, '$$scope', {value: $scope});
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName || 'parse';
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default'])) {
	      debounceDelay = debounceDelay['default'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$scope.$root.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	        // eslint-disable-next-line no-self-compare
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      ctrl.$$parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        // It is possible that model and view value have been updated during render
	        ctrl.$$runValidators(ctrl.$modelValue, ctrl.$viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by Angular when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options.getOption('updateOn')) {
	            element.on(modelCtrl.$options.getOption('updateOn'), function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /* @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an Angular expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div "ng-model-options"="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example name="ng-non-bindable">
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      // The empty option will be compiled and rendered before we first generate the options
	      selectElement.empty();
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            selectCtrl.selectUnknownOrEmptyOption(value);
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        selectElement.prepend(selectCtrl.emptyOption);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                var needsRerender = selectCtrl.$isEmptyOptionSelected();
	
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	
	                if (needsRerender) ngModelCtrl.$render();
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // Support: IE 11 only, Edge 12-13 only
	        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so Angular relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have a unique identifier property, you should track
	 * by this identifier instead of the object instance. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this significantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 *
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * Avoid using `track by $index` when the repeated template contains
	 * {@link guide/expression#one-time-binding one-time bindings}. In such cases, the `nth` DOM
	 * element will always be matched with the `nth` item of the array, so the bindings on that element
	 * will not be updated even when the corresponding item changes, essentially causing the view to get
	 * out-of-sync with the underlying data.
	 * </div>
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 *    <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression.
	 *     </div>
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true" name="ng-repeat">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - clone: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    terminal: true,
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value);
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 *
	 * @description
	 * The controller for the {@link ng.select select} directive. The controller exposes
	 * a few utility methods that can be used to augment the behavior of a regular or an
	 * {@link ng.ngOptions ngOptions} select element.
	 *
	 * @example
	 * ### Set a custom error when the unknown option is selected
	 *
	 * This example sets a custom error "unknownValue" on the ngModelController
	 * when the select element's unknown option is selected, i.e. when the model is set to a value
	 * that is not matched by any option.
	 *
	 * <example name="select-unknown-value-error" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Single select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-error>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span ng-if="myForm.testSelect.$error.unknownValue">Error: The current model doesn't match any option</span>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueError', function() {
	 *     return {
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
	 *           if (selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return true;
	 *         };
	 *       }
	 *
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 * @example
	 * ### Set the "required" error when the unknown option is selected.
	 *
	 * By default, the "required" error on the ngModelController is only set on a required select
	 * when the empty option is selected. This example adds a custom directive that also sets the
	 * error when the unknown option is selected.
	 *
	 * <example name="select-unknown-value-required" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-required>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueRequired', function() {
	 *     return {
	 *       priority: 1, // This directive must run after the required directive has added its validator
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
	 *
	 *         ngModelCtrl.$validators.required = function() {
	 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return originalRequiredValidator.apply(this, arguments);
	 *         };
	 *       }
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that the application developer can
	  // provide inside the select. It is always selectable and indicates that a "null" selection has
	  // been made by the user.
	  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
	  // the empty option is selected.
	  // If the model is set to a different unmatched value, the unknown option is rendered and
	  // selected, i.e both are present, because a "null" selection and an unknown value are different.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      setOptionSelectedStatus(self.emptyOption, false);
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      self.selectUnknownOrEmptyOption(value);
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$hasEmptyOption
	   *
	   * @description
	   *
	   * Returns `true` if the select element currently has an empty option
	   * element, i.e. an option that signifies that the select is empty / the selection is null.
	   *
	   */
	  self.$hasEmptyOption = function() {
	    return self.hasEmptyOption;
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isUnknownOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element's unknown option is selected. The unknown option is added
	   * and automatically selected whenever the select model doesn't match any option.
	   *
	   */
	  self.$isUnknownOptionSelected = function() {
	    // Presence of the unknown option means it is selected
	    return $element[0].options[0] === self.unknownOption[0];
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isEmptyOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element has an empty option and this empty option is currently
	   * selected. Returns `false` if the select element has no empty option or it is not selected.
	   *
	   */
	  self.$isEmptyOptionSelected = function() {
	    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
	  };
	
	  self.selectUnknownOrEmptyOption = function(value) {
	    if (value == null && self.emptyOption) {
	      self.removeUnknownOption();
	      self.selectEmptyOption();
	    } else if (self.unknownOption.parent().length) {
	      self.updateUnknownOption(value);
	    } else {
	      self.renderUnknownOption(value);
	    }
	  };
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal = NaN;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * The {@link select.SelectController select controller} exposes utility functions that can be used
	 * to manipulate the select's behavior.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 *
	 * @knownIssue
	 *
	 * In Firefox, the select model is only updated when the select element is blurred. For example,
	 * when switching between options with the keyboard, the select model is only set to the
	 * currently selected option when the select is blurred, e.g via tab key or clicking the mouse
	 * outside the select.
	 *
	 * This is due to an ambiguity in the select element specification. See the
	 * [issue on the Firefox bug tracker](https://bugzilla.mozilla.org/show_bug.cgi?id=126379)
	 * for more information, and this
	 * [Github comment for a workaround](https://github.com/angular/angular.js/issues/9134#issuecomment-130800488)
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // Support: IE 9-11 only, Edge 12-15+
	            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if necessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNumberNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load angular more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* globals define, module, require, angular */
	
	/**
	 * @license angular-bootstrap-datetimepicker
	 * Copyright 2016 Knight Rider Consulting, Inc. http://www.knightrider.com
	 * License: MIT
	 *
	 * @author       Dale "Ducky" Lotts
	 * @since        2016-Jan-31
	 */
	
	;(function (root, factory) {
	  'use strict'
	  /* istanbul ignore if */
	  if (typeof module !== 'undefined' && module.exports) {
	    var ng = typeof angular === 'undefined' ? __webpack_require__(308) : angular
	    factory(ng)
	    module.exports = 'ui.bootstrap.datetimepicker.templates'
	    /* istanbul ignore next */
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(308)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  } else {
	    factory(root.angular, root.moment)
	  }
	}(this, function (angular) {
	  'use strict'
	  angular.module('ui.bootstrap.datetimepicker').run(['$templateCache', function ($templateCache) {
	    $templateCache.put('templates/datetimepicker.html', '<div class="datetimepicker table-responsive">\n    <table class="table table-condensed {{ data.currentView }}-view">\n        <thead>\n        <tr>\n            <th class="left" data-ng-click="changeView(data.currentView, data.leftDate, $event)" data-ng-show="data.leftDate.selectable"><i class="glyphicon glyphicon-arrow-left"><span class="sr-only">{{ screenReader.previous }}</span></i>\n            </th>\n            <th class="switch" colspan="5" data-ng-show="data.previousViewDate.selectable" data-ng-click="changeView(data.previousView, data.previousViewDate, $event)">{{ data.previousViewDate.display }}</th>\n            <th class="right" data-ng-click="changeView(data.currentView, data.rightDate, $event)" data-ng-show="data.rightDate.selectable"><i class="glyphicon glyphicon-arrow-right"><span class="sr-only">{{ screenReader.next }}</span></i>\n            </th>\n        </tr>\n        <tr>\n            <th class="dow" data-ng-repeat="day in data.dayNames">{{ day }}</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr data-ng-if="data.currentView !== \'day\'">\n            <td colspan="7">\n                          <span class="{{ data.currentView }}" data-ng-repeat="dateObject in data.dates" data-ng-class="{current: dateObject.current, active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}" data-ng-click="changeView(data.nextView, dateObject, $event)">{{ dateObject.display }}</span></td>\n        </tr>\n        <tr data-ng-if="data.currentView === \'day\'" data-ng-repeat="week in data.weeks">\n            <td data-ng-repeat="dateObject in week.dates" data-ng-click="changeView(data.nextView, dateObject, $event)" class="day" data-ng-class="{current: dateObject.current, active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}">{{ dateObject.display }}</td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n')
	  }])
	})); // eslint-disable-line semi


/***/ }),
/* 311 */
5,
/* 312 */,
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	SettingsService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SettingsService = SettingsService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function SettingsService($resource) {
	  return $resource('/api/settings/:id', {
	    name: '@_id'
	  }, {
	    getByName: {
	      method: 'GET',
	      url: "/api/settings/name/:name"
	    },
	    update: {
	      method: 'PUT'
	    },
	    getLDAPDB: {
	      method: 'GET',
	      url: "/api/integrations/ldapdb"
	    },
	    rebuildLDAPB: {
	      method: 'GET',
	      url: "/api/integrations/rebuild-ldapdb"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.SettingsService', []).factory('SettingsService', SettingsService).name;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SettingsListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _settingsList = __webpack_require__(315);
	
	var _settingsList2 = _interopRequireDefault(_settingsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var SettingsListComponent = exports.SettingsListComponent = function () {
	  SettingsListComponent.$inject = ['Auth', 'SettingsService', 'DTOptionsBuilder', 'dialogs', '$uibModal'];
	  function SettingsListComponent(Auth, SettingsService, DTOptionsBuilder, dialogs, $uibModal) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, SettingsListComponent);
	
	    this.SettingsService = SettingsService;
	    this.data = [];
	    this.isAdmin = Auth.isAdminSync;
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	
	    this.SettingsService.query(function (data) {
	      _this.data = data.filter(function (setting) {
	        return !setting.name.startsWith("$");
	      });
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve settings.");
	    });
	  }
	
	  _createClass(SettingsListComponent, [{
	    key: 'delete',
	    value: function _delete(settings) {
	      var that = this;
	
	      var settingsText = "<br/><br/><b>" + settings.name + "</b><br/><p>" + settings.description + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Settings?", "Do you really want to delete the settings?" + settingsText);
	      dlg.result.then(function () {
	        that.SettingsService.delete({ id: settings._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== settings._id;
	          });
	        }, function (err) {
	          alert("Could not delete settings");
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'openPreviewModal',
	    value: function openPreviewModal(settings) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'jsonViewer',
	        resolve: {
	          config: function config() {
	            return {
	              data: settings.data
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }]);
	
	  return SettingsListComponent;
	}();
	
	exports.default = angular.module('conduu.settingsList', [uiRouter]).config(_settingsList2.default).component('settingsList', {
	  template: __webpack_require__(316),
	  controller: SettingsListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('settings-list', {
	    url: '/admin/settings/list',
	    template: '<settings-list></settings-list>',
	    authenticate: 'suite-superadmin'
	  });
	}];

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" href=\"/admin/settings/edit/\"><i class=\"fa fa-plus\"></i> Create New Settings</a>\r\n      <h1>Settings</h1>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>Name</th>\r\n          <th>Description</th>\r\n          <th>Date</th>\r\n          <th></th>\r\n          <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"settings in ctrl.data | orderBy: 'meta.creationDate':true\">\r\n          <td>{{settings.name}}</td>\r\n          <td><span ng-bind-html=\"settings.description | newlineToHtml\"></span></td>\r\n          <td>\r\n            <nobr>{{settings.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td>\r\n            <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.openPreviewModal(settings)\"><i\r\n              class=\"fa fa-eye fa-fw\"></i> View</button>\r\n          </td>\r\n          <td>\r\n            <a class=\"btn btn-sm btn-primary\" ng-href=\"/admin/settings/edit/{{settings._id}}\"><i class=\"fa fa-pencil fa-fw\"></i>\r\n              Edit</a>\r\n            <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(settings)\"><i class=\"fa fa-trash-o fa-fw\"></i> Delete</button>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SettingsEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _settingsEdit = __webpack_require__(318);
	
	var _settingsEdit2 = _interopRequireDefault(_settingsEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var SettingsEditComponent = exports.SettingsEditComponent = function () {
	  SettingsEditComponent.$inject = ['SettingsService', 'Auth', '$state', '$stateParams', 'dialogs'];
	  function SettingsEditComponent(SettingsService, Auth, $state, $stateParams, dialogs) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, SettingsEditComponent);
	
	    this.SettingsService = SettingsService;
	
	    this.settingsId = $stateParams.id;
	
	    this.dialogs = dialogs;
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.settingsTemplate = {
	      name: '',
	      description: '',
	      data: {},
	      meta: {
	        creationUser: Auth.getCurrentUserSync()._id,
	        active: true
	      }
	    };
	
	    this.settings = angular.copy(this.settingsTemplate);
	
	    if (this.settingsId) {
	      this.SettingsService.get({ id: this.settingsId }, function (data) {
	        _this.settings = data;
	        _this.jsonValue = data.data === null ? '' : angular.toJson(data.data, true);
	      }, function (err) {
	        console.log('Could not load settings from server');
	      });
	    }
	
	    CodeMirror.defineOption("matchBrackets", true);
	    CodeMirror.defineOption("autoCloseBrackets", true);
	    CodeMirror.defineOption("lineWrapping", true);
	    CodeMirror.defineOption("tabSize", 2);
	    CodeMirror.defineOption("mode", "application/json");
	    CodeMirror.defineOption("gutters", ["CodeMirror-lint-markers"]);
	    CodeMirror.defineOption("lint", true);
	    CodeMirror.defineOption("styleActiveLine", true);
	    CodeMirror.defineOption("lineNumbers", true);
	  }
	
	  _createClass(SettingsEditComponent, [{
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          _this2.settings = angular.copy(_this2.settingsTemplate);
	          _this2.submitted = false;
	
	          var actionString = _this2.settingsId ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "The settings have been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("settings-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.settings.data = angular.fromJson(this.jsonValue);
	
	        if (this.settingsId) {
	          this.SettingsService.update({ id: this.settingsId }, this.settings, onSuccess, onError);
	        } else {
	          this.SettingsService.save(this.settings, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return SettingsEditComponent;
	}();
	
	exports.default = angular.module('conduu.settingsEdit', [uiRouter]).config(_settingsEdit2.default).component('settingsEdit', {
	  template: __webpack_require__(319),
	  controller: SettingsEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('settings-edit', {
	    url: '/admin/settings/edit/:id',
	    template: '<settings-edit></settings-edit>',
	    authenticate: 'suite-superadmin'
	  });
	}];

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <h1>Settings Editor</h1>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form class=\"form\" name=\"form\" ng-submit=\"ctrl.create(form)\" novalidate>\r\n\r\n        <!-- Title -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Name</label>\r\n          <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"ctrl.settings.name\" required />\r\n          <p class=\"help-block\" ng-show=\"form.name.$error.required && ctrl.submitted\">\r\n            You must specify a name for the settings.\r\n          </p>\r\n        </div>\r\n\r\n        <!-- Description -->\r\n        <div class=\"form-group\">\r\n          <label>Description</label>\r\n          <input type=\"text\" name=\"description\" class=\"form-control\" ng-model=\"ctrl.settings.description\" />\r\n        </div>\r\n\r\n        <!-- Page Content -->\r\n        <div class=\"form-group\">\r\n          <label>Settings</label>\r\n          <textarea ui-codemirror ng-model=\"ctrl.jsonValue\" name=\"data\" ng-required=\"true\"></textarea>\r\n        </div>\r\n\r\n        <hr/>\r\n\r\n        <div ng-show=\"ctrl.sendFailure\" class=\"alert alert-danger\">\r\n          There has been an error. Your settings could not be created.\r\n        </div>\r\n\r\n        <button ng-hide=\"ctrl.settingsId\" class=\"btn btn-primary\" type=\"submit\">Create Settings</button>\r\n\r\n        <button ng-show=\"ctrl.settingsId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"settings-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DynamicPageComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dynamicPage = __webpack_require__(321);
	
	var _dynamicPage2 = _interopRequireDefault(_dynamicPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var DynamicPageComponent = exports.DynamicPageComponent = function () {
	  DynamicPageComponent.$inject = ['$stateParams', 'DynamicPageService'];
	  function DynamicPageComponent($stateParams, DynamicPageService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, DynamicPageComponent);
	
	    this.pageName = $stateParams.name;
	    this.pageParam = $stateParams.param;
	
	    var METHOD = this.public ? "getPublicByName" : "getByName";
	
	    DynamicPageService[METHOD]({ name: this.pageName }, function (page) {
	      _this.html = _this.convertShortcode(page.data);
	    }, function (err) {
	      _this.pageNotFound = true;
	    });
	  }
	
	  _createClass(DynamicPageComponent, [{
	    key: 'convertShortcode',
	    value: function convertShortcode(html) {
	      return html.replace(/\[/g, "<").replace(/\]/g, ">");
	    }
	  }]);
	
	  return DynamicPageComponent;
	}();
	
	exports.default = angular.module('conduu.dynamicPage', [uiRouter]).config(_dynamicPage2.default).component('dynamicPage', {
	  template: __webpack_require__(322),
	  controller: DynamicPageComponent,
	  controllerAs: 'ctrl',
	  bindings: {
	    public: '<'
	  }
	}).name;

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('dynamic-page', {
	    url: '/page/:name',
	    template: '<dynamic-page ></dynamic-page>',
	    authenticate: true
	  }).state('dynamic-page-param', {
	    url: '/page/:name/:param',
	    template: '<dynamic-page></dynamic-page>',
	    authenticate: true
	  }).state('public-dynamic-page', {
	    url: '/public/page/:name',
	    template: '<dynamic-page public="true"></dynamic-page>'
	  });
	}];

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"ctrl.pageNotFound\" class=\"container\">\r\n  <br/>\r\n  <div class=\"alert alert-dismissible alert-warning\">\r\n    <i class=\"fa fa-fw fa-4x fa-meh-o\" style=\"float:left\"></i>\r\n    <h4>Oops! Page Not Found</h4>\r\n    <p>The page you are looking for is not (longer) available.</p>\r\n  </div>\r\n</div>\r\n\r\n<div ng-hide=\"ctrl.pageNotFound\" class=\"container\" bind-dynamic-page=\"ctrl.html\">\r\n</div>\r\n"

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DynamicPageService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DynamicPageService = DynamicPageService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function DynamicPageService($resource) {
	  return $resource('/api/pages/:id', {
	    id: '@_id'
	  }, {
	    getByName: {
	      method: 'GET',
	      url: "/api/pages/name/:name"
	    },
	    getPublicByName: {
	      method: 'GET',
	      url: "/api/pages/public/name/:name"
	    },
	    update: {
	      method: 'PUT'
	    }
	  });
	}
	
	exports.default = angular.module('conduu.DynamicPageService', []).factory('DynamicPageService', DynamicPageService).name;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var jsonViewerComponent = exports.jsonViewerComponent = function () {
	  /*@ngInject*/
	  function jsonViewerComponent() {
	    _classCallCheck(this, jsonViewerComponent);
	  }
	
	  _createClass(jsonViewerComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.data = this.resolve.config.data;
	    }
	  }]);
	
	  return jsonViewerComponent;
	}();
	
	exports.default = angular.module('conduu.jsonViewer', []).component('jsonViewer', {
	  template: '<json-view value="$ctrl.data"></json-view>',
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: jsonViewerComponent
	}).name;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var angular = __webpack_require__(14);
	
	exports.default = angular.module('conduuHQ.jsonView', []).directive('jsonView', ['$compile', function ($compile) {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&'
	        },
	        link: function link(scope, element, attrs) {
	            scope.guessType = function (obj) {
	                var type = Object.prototype.toString.call(obj);
	
	                if (type === "[object Object]") {
	                    return "Object";
	                }
	
	                if (type === "[object Array]") {
	                    return "Array";
	                }
	
	                return "Literal";
	            };
	
	            var template = '<span ng-switch="guessType(value())">\n    <table class="table table-condensed" ng-switch-when="Array" style="margin-bottom: 0">\n        <tbody>\n            <tr ng-repeat="val in value() track by $index">\n                <td style="width:0px; border: none;"><code style="color:darkgrey">{{$index}}</code></td>\n                <td ng-switch="guessType(val)" style="border: none">\n                    <json-view ng-switch-when="Object" value="::val"></json-view>\n                    <json-view ng-switch-when="Array" value="::val"></json-view>\n                    <span ng-switch-when="Literal">{{ val }}</span>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n    <table class="table table-condensed table-bordered" ng-switch-when="Object" style="margin-bottom: 0">\n        <tbody>\n            <tr ng-repeat="(key, val) in value() track by key">\n                <th class="active">{{ key }}</th>\n                <td ng-switch="guessType(val)">\n                    <json-view ng-switch-when="Object" value="::val"></json-view>\n                    <json-view ng-switch-when="Array" value="::val"></json-view>\n                    <span ng-switch-when="Literal">{{ val }}</span>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n</span>';
	
	            var newElement = angular.element(template);
	            $compile(newElement)(scope);
	            element.replaceWith(newElement);
	        }
	    };
	}]).name;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var datatableComponent = exports.datatableComponent = function () {
	  function datatableComponent() {
	    'ngInject';
	
	    _classCallCheck(this, datatableComponent);
	  }
	
	  _createClass(datatableComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cols = this.columns.split(',');
	    }
	  }]);
	
	  return datatableComponent;
	}();
	
	exports.default = angular.module('conduu.datatable-loading-placeholder', []).component('datatableLoadingPlaceholder', {
	  template: __webpack_require__(327),
	  bindings: {
	    columns: '@'
	  },
	  controller: datatableComponent
	}).name;

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"dataTables_wrapper no-footer\" >\r\n    <div class=\"dataTables_length\"><label>Show <select>\r\n        <option value=\"10\">10</option>\r\n    </select> entries</label></div>\r\n    <div class=\"dt-buttons\">\r\n        <a class=\"dt-button buttons-excel buttons-html5\" href=\"#\"><span>Excel</span></a>\r\n        <a class=\"dt-button buttons-csv buttons-html5\" href=\"#\"><span>CSV</span></a>\r\n        <a class=\"dt-button buttons-pdf buttons-html5\" href=\"#\"><span>PDF</span></a>\r\n        <a class=\"dt-button buttons-print\" href=\"#\"><span>Print</span></a></div>\r\n    <div class=\"dataTables_filter\">\r\n        <label>Search:<input class=\"\" placeholder=\"\" type=\"search\"></label>\r\n    </div>\r\n\r\n    <div class=\"ph-item\">\r\n\r\n        <table class=\"table table-striped\" style=\"width:100%\">\r\n            <thead>\r\n            <tr>\r\n                <th ng-repeat=\"col in $ctrl.cols\">{{col}}</th>\r\n                <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr>\r\n                <td ng-repeat=\"col in $ctrl.cols\"><div style=\"padding:6px 12px; height:14px; background-color:#bbb; width:70%\"></div></td>\r\n                <td class=\"text-right\">\r\n                    <nobr>\r\n                        <a ng-disabled=\"true\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n                        <button ng-disabled=\"true\" class=\"btn btn-sm btn-danger\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n                    </nobr>\r\n                </td>\r\n            </tr><tr>\r\n                <td ng-repeat=\"col in $ctrl.cols\"><div style=\"padding:6px 12px; height:14px; background-color:#bbb; width:70%\"></div></td>\r\n                <td class=\"text-right\">\r\n                    <nobr>\r\n                        <a ng-disabled=\"true\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n                        <button ng-disabled=\"true\" class=\"btn btn-sm btn-danger\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n                    </nobr>\r\n                </td>\r\n            </tr><tr>\r\n                <td ng-repeat=\"col in $ctrl.cols\"><div style=\"padding:6px 12px; height:14px; background-color:#ccc; width:70%\"></div></td>\r\n                <td class=\"text-right\">\r\n                    <nobr>\r\n                        <a ng-disabled=\"true\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n                        <button ng-disabled=\"true\" class=\"btn btn-sm btn-danger\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n                    </nobr>\r\n                </td>\r\n            </tr><tr>\r\n                <td ng-repeat=\"col in $ctrl.cols\"><div style=\"padding:6px 12px; height:14px; background-color:#ddd; width:70%\"></div></td>\r\n                <td class=\"text-right\">\r\n                    <nobr>\r\n                        <a ng-disabled=\"true\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n                        <button ng-disabled=\"true\" class=\"btn btn-sm btn-danger\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n                    </nobr>\r\n                </td>\r\n            </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>"

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.startFromFilter = startFromFilter;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function startFromFilter() {
	  return function (input, start) {
	    start = +start;
	    return input.slice(start);
	  };
	}
	
	exports.default = angular.module('conduu.startFromFilter', []).filter('startFrom', startFromFilter).name;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var feedbackFormularComponent = exports.feedbackFormularComponent = function () {
	  /*@ngInject*/
	  function feedbackFormularComponent() {
	    _classCallCheck(this, feedbackFormularComponent);
	
	    this.$onInit = function () {};
	  }
	
	  _createClass(feedbackFormularComponent, [{
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.feedback });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return feedbackFormularComponent;
	}();
	
	exports.default = angular.module('conduu.feedbackFormular', []).component('feedbackFormular', {
	  template: __webpack_require__(330),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: feedbackFormularComponent
	}).name;

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\"><i class=\"fa fa-fw fa-comments\"></i> Feedback</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <p>Kindly submit your feedback below:</p>\r\n  <textarea style=\"width:100%; font-size:large\" rows=\"7\" ng-model=\"$ctrl.feedback\"></textarea>\r\n\r\n  <div ng-show=\"$ctrl.feedbackEmpty && !$ctrl.feedback\" class=\"alert alert-danger\">\r\n    Can not send empty feedback formular.\r\n  </div>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!$ctrl.feedback\" ng-click=\"$ctrl.ok()\">Submit Feedback</button>\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchResultComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _searchResult = __webpack_require__(332);
	
	var _searchResult2 = _interopRequireDefault(_searchResult);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var SearchResultComponent = exports.SearchResultComponent = function () {
	  SearchResultComponent.$inject = ['$stateParams', 'Auth', 'dialogs', '$uibModal', 'PropertyService', 'CommunityService', 'ContactService', 'WorkOrderTicketsService', 'ViolationTicketsService', 'ServiceRequestTicketsService', 'VendorService'];
	  function SearchResultComponent($stateParams, Auth, dialogs, $uibModal, PropertyService, CommunityService, ContactService, WorkOrderTicketsService, ViolationTicketsService, ServiceRequestTicketsService, VendorService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, SearchResultComponent);
	
	    this.searchterm = $stateParams.searchterm;
	    this.type = $stateParams.type;
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.Auth = Auth;
	
	    this.found = {
	      communities: [],
	      properties: [],
	      contacts: [],
	      vendors: [],
	      workOrders: [],
	      violations: [],
	      serviceRequests: []
	    };
	
	    CommunityService.query(function (data) {
	      return _this.found.communities = data.filter(function (cmty) {
	        return JSON.stringify(cmty).toLowerCase().indexOf(_this.searchterm.toLowerCase()) != -1;
	      });
	    });
	    PropertyService.query(function (data) {
	      return _this.found.properties = data.filter(function (prop) {
	        return JSON.stringify(prop).toLowerCase().indexOf(_this.searchterm.toLowerCase()) != -1;
	      });
	    });
	    ContactService.query(function (data) {
	      return _this.found.contacts = data.filter(function (contact) {
	        return JSON.stringify(contact).toLowerCase().indexOf(_this.searchterm.toLowerCase()) != -1;
	      });
	    });
	    VendorService.query(function (data) {
	      return _this.found.vendors = data.filter(function (vendor) {
	        return JSON.stringify(vendor).toLowerCase().indexOf(_this.searchterm.toLowerCase()) != -1;
	      });
	    });
	    WorkOrderTicketsService.query(function (data) {
	      return _this.found.workOrders = data.filter(function (wo) {
	        return JSON.stringify(wo).toLowerCase().indexOf(_this.searchterm.toLowerCase()) != -1;
	      });
	    });
	    ServiceRequestTicketsService.query(function (data) {
	      return _this.found.serviceRequests = data.filter(function (sr) {
	        return JSON.stringify(sr).toLowerCase().indexOf(_this.searchterm.toLowerCase()) != -1;
	      });
	    });
	    ViolationTicketsService.query(function (data) {
	      return _this.found.violations = data.filter(function (ccr) {
	        return JSON.stringify(ccr).toLowerCase().indexOf(_this.searchterm.toLowerCase()) != -1;
	      });
	    });
	  }
	
	  _createClass(SearchResultComponent, [{
	    key: 'getPlaintext',
	    value: function getPlaintext(html) {
	      return html ? html.replace(/<[^>]+>/gm, ' ').substr(0, 120) : "";
	    }
	  }]);
	
	  return SearchResultComponent;
	}();
	
	exports.default = angular.module('conduu.searchResult', [uiRouter]).config(_searchResult2.default).component('searchResult', {
	  template: __webpack_require__(333),
	  controller: SearchResultComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('search-result', {
	    url: '/search/result',
	    params: { searchterm: null },
	    template: '<search-result></search-result>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <h1>Search results for <em>{{ctrl.searchterm}}</em></h1>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <br/>\r\n\r\n      <h4><i class=\"fa fa-fw fa-building\"></i> Communities <span class=\"badge\">{{ctrl.found.communities.length}}</span></h4>\r\n      <p ng-show=\"ctrl.found.communities.length === 0\">Nothing found here</p>\r\n\r\n      <ul>\r\n        <li ng-repeat=\"cmty in ctrl.found.communities\" style=\"padding-bottom: 8px;\">\r\n          <a ng-href=\"/community/{{cmty._id}}\" style=\"text-decoration: none;\">\r\n            <b>{{cmty.code}}: </b><em>{{cmty.name}}</em>\r\n          </a> |\r\n          <a ng-href=\"/community/edit/{{cmty._id}}\" style=\"text-decoration: none;\"><i class=\"fa fa-fw fa-pencil\"></i></a>\r\n        </li>\r\n      </ul>\r\n\r\n      <br/>\r\n\r\n      <h4><i class=\"fa fa-fw fa-home\"></i> Properties <span class=\"badge\">{{ctrl.found.properties.length}}</span></h4>\r\n      <p ng-show=\"ctrl.found.properties.length === 0\">Nothing found here</p>\r\n\r\n      <ul>\r\n        <li ng-repeat=\"ppty in ctrl.found.properties\" style=\"padding-bottom: 8px;\">\r\n          <a ng-href=\"/property/{{ppty._id}}\" style=\"text-decoration: none;\">\r\n            <b>{{ppty.lotNo}}: </b><em>{{ppty.address.street}}, {{ppty.address.city}} {{ppty.address.state}}, {{ppty.address.zip}}</em>\r\n          </a> |\r\n          <a ng-href=\"/property/edit/{{ppty._id}}\" style=\"text-decoration: none;\"><i class=\"fa fa-fw fa-pencil\"></i></a>\r\n        </li>\r\n      </ul>\r\n\r\n      <br/>\r\n\r\n      <h4><i class=\"fa fa-fw fa-user\"></i> Contacts <span class=\"badge\">{{ctrl.found.contacts.length}}</span></h4>\r\n      <p ng-show=\"ctrl.found.contacts.length === 0\">Nothing found here</p>\r\n\r\n      <ul>\r\n        <li ng-repeat=\"contact in ctrl.found.contacts\" style=\"padding-bottom: 8px;\">\r\n          <a ng-href=\"/contact/{{contact._id}}\" style=\"text-decoration: none;\">\r\n            {{contact.firstName}} {{contact.middleName}} <b>{{contact.lastName}}</b>\r\n          </a> |\r\n          <a ng-href=\"/contact/edit/{{contact._id}}\" style=\"text-decoration: none;\"><i class=\"fa fa-fw fa-pencil\"></i></a>\r\n        </li>\r\n      </ul>\r\n\r\n      <br/>\r\n\r\n      <h4><i class=\"fa fa-fw fa-briefcase\"></i> Vendors <span class=\"badge\">{{ctrl.found.vendors.length}}</span></h4>\r\n      <p ng-show=\"ctrl.found.vendors.length === 0\">Nothing found here</p>\r\n\r\n      <ul>\r\n        <li ng-repeat=\"vendor in ctrl.found.vendors\" style=\"padding-bottom: 8px;\">\r\n          <a ng-href=\"/venor/{{vendor._id}}\" style=\"text-decoration: none;\">\r\n            <b>{{vendor.name}}</b> / <span class=\"text-capitalize\">{{vendor.type}}</span>\r\n          </a> |\r\n          <a ng-href=\"/venor/edit/{{vendor._id}}\" style=\"text-decoration: none;\"><i class=\"fa fa-fw fa-pencil\"></i></a>\r\n        </li>\r\n      </ul>\r\n\r\n      <br/>\r\n\r\n      <h4><i class=\"fa fa-fw fa-bell\"></i> Service Requests <span class=\"badge\">{{ctrl.found.serviceRequests.length}}</span></h4>\r\n      <p ng-show=\"ctrl.found.serviceRequests.length === 0\">Nothing found here</p>\r\n\r\n      <ul>\r\n        <li ng-repeat=\"sr in ctrl.found.serviceRequests\" style=\"padding-bottom: 8px;\">\r\n          <a ng-href=\"/servicerequest/ticket/detail/{{sr._id}}\" style=\"text-decoration: none;\">\r\n            <b>{{sr.code}}</b>: {{sr.name}}\r\n          </a> |\r\n          <a ng-href=\"/servicerequest/ticket/edit/{{sr._id}}\" style=\"text-decoration: none;\"><i class=\"fa fa-fw fa-pencil\"></i></a>\r\n        </li>\r\n      </ul>\r\n\r\n      <br/>\r\n\r\n      <h4><i class=\"fa fa-fw fa-wrench\"></i> Work Orders <span class=\"badge\">{{ctrl.found.workOrders.length}}</span></h4>\r\n      <p ng-show=\"ctrl.found.workOrders.length === 0\">Nothing found here</p>\r\n\r\n      <ul>\r\n        <li ng-repeat=\"wo in ctrl.found.workOrders\" style=\"padding-bottom: 8px;\">\r\n          <a ng-href=\"/workorder/ticket/detail/{{wo._id}}\" style=\"text-decoration: none;\">\r\n            <b>{{wo.code}}</b>: {{wo.name}}\r\n          </a> |\r\n          <a ng-href=\"/workorder/ticket/edit/{{wo._id}}\" style=\"text-decoration: none;\"><i class=\"fa fa-fw fa-pencil\"></i></a>\r\n        </li>\r\n      </ul>\r\n\r\n      <br/>\r\n\r\n      <h4><i class=\"fa fa-fw fa-exclamation\"></i> Violations <span class=\"badge\">{{ctrl.found.violations.length}}</span></h4>\r\n      <p ng-show=\"ctrl.found.violations.length === 0\">Nothing found here</p>\r\n\r\n      <ul>\r\n        <li ng-repeat=\"ccr in ctrl.found.violations\" style=\"padding-bottom: 8px;\">\r\n          <a ng-href=\"/violation/ticket/detail/{{ccr._id}}\" style=\"text-decoration: none;\">\r\n            <b>{{ccr.code}}</b>: {{ccr.name}}\r\n          </a> |\r\n          <a ng-href=\"/violation/ticket/edit/{{ccr._id}}\" style=\"text-decoration: none;\"><i class=\"fa fa-fw fa-pencil\"></i></a>\r\n        </li>\r\n      </ul>\r\n\r\n      <br/>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.7'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(336);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot\");src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2\") format(\"woff2\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff\") format(\"woff\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf\") format(\"truetype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\") format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:transparent}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.428571429;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.428571429}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{content:\" \";display:table}.dl-horizontal dd:after{clear:both}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.428571429;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.428571429}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.428571429;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container-fluid:after,.container-fluid:before{content:\" \";display:table}.container-fluid:after{clear:both}.row{margin-left:-15px;margin-right:-15px}.row:after,.row:before{content:\" \";display:table}.row:after{clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-1{width:8.3333333333%}.col-xs-2{width:16.6666666667%}.col-xs-3{width:25%}.col-xs-4{width:33.3333333333%}.col-xs-5{width:41.6666666667%}.col-xs-6{width:50%}.col-xs-7{width:58.3333333333%}.col-xs-8{width:66.6666666667%}.col-xs-9{width:75%}.col-xs-10{width:83.3333333333%}.col-xs-11{width:91.6666666667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.3333333333%}.col-xs-pull-2{right:16.6666666667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.3333333333%}.col-xs-pull-5{right:41.6666666667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.3333333333%}.col-xs-pull-8{right:66.6666666667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.3333333333%}.col-xs-pull-11{right:91.6666666667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.3333333333%}.col-xs-push-2{left:16.6666666667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.3333333333%}.col-xs-push-5{left:41.6666666667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.3333333333%}.col-xs-push-8{left:66.6666666667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.3333333333%}.col-xs-push-11{left:91.6666666667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.3333333333%}.col-xs-offset-2{margin-left:16.6666666667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.3333333333%}.col-xs-offset-5{margin-left:41.6666666667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.3333333333%}.col-xs-offset-8{margin-left:66.6666666667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.3333333333%}.col-xs-offset-11{margin-left:91.6666666667%}.col-xs-offset-12{margin-left:100%}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1{width:8.3333333333%}.col-sm-2{width:16.6666666667%}.col-sm-3{width:25%}.col-sm-4{width:33.3333333333%}.col-sm-5{width:41.6666666667%}.col-sm-6{width:50%}.col-sm-7{width:58.3333333333%}.col-sm-8{width:66.6666666667%}.col-sm-9{width:75%}.col-sm-10{width:83.3333333333%}.col-sm-11{width:91.6666666667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.3333333333%}.col-sm-pull-2{right:16.6666666667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.3333333333%}.col-sm-pull-5{right:41.6666666667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.3333333333%}.col-sm-pull-8{right:66.6666666667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.3333333333%}.col-sm-pull-11{right:91.6666666667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.3333333333%}.col-sm-push-2{left:16.6666666667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.3333333333%}.col-sm-push-5{left:41.6666666667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.3333333333%}.col-sm-push-8{left:66.6666666667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.3333333333%}.col-sm-push-11{left:91.6666666667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.3333333333%}.col-sm-offset-2{margin-left:16.6666666667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.3333333333%}.col-sm-offset-5{margin-left:41.6666666667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.3333333333%}.col-sm-offset-8{margin-left:66.6666666667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.3333333333%}.col-sm-offset-11{margin-left:91.6666666667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.3333333333%}.col-md-2{width:16.6666666667%}.col-md-3{width:25%}.col-md-4{width:33.3333333333%}.col-md-5{width:41.6666666667%}.col-md-6{width:50%}.col-md-7{width:58.3333333333%}.col-md-8{width:66.6666666667%}.col-md-9{width:75%}.col-md-10{width:83.3333333333%}.col-md-11{width:91.6666666667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.3333333333%}.col-md-pull-2{right:16.6666666667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.3333333333%}.col-md-pull-5{right:41.6666666667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.3333333333%}.col-md-pull-8{right:66.6666666667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.3333333333%}.col-md-pull-11{right:91.6666666667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.3333333333%}.col-md-push-2{left:16.6666666667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.3333333333%}.col-md-push-5{left:41.6666666667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.3333333333%}.col-md-push-8{left:66.6666666667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.3333333333%}.col-md-push-11{left:91.6666666667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.3333333333%}.col-md-offset-2{margin-left:16.6666666667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.3333333333%}.col-md-offset-5{margin-left:41.6666666667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.3333333333%}.col-md-offset-8{margin-left:66.6666666667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.3333333333%}.col-md-offset-11{margin-left:91.6666666667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.3333333333%}.col-lg-2{width:16.6666666667%}.col-lg-3{width:25%}.col-lg-4{width:33.3333333333%}.col-lg-5{width:41.6666666667%}.col-lg-6{width:50%}.col-lg-7{width:58.3333333333%}.col-lg-8{width:66.6666666667%}.col-lg-9{width:75%}.col-lg-10{width:83.3333333333%}.col-lg-11{width:91.6666666667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.3333333333%}.col-lg-pull-2{right:16.6666666667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.3333333333%}.col-lg-pull-5{right:41.6666666667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.3333333333%}.col-lg-pull-8{right:66.6666666667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.3333333333%}.col-lg-pull-11{right:91.6666666667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.3333333333%}.col-lg-push-2{left:16.6666666667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.3333333333%}.col-lg-push-5{left:41.6666666667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.3333333333%}.col-lg-push-8{left:66.6666666667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.3333333333%}.col-lg-push-11{left:91.6666666667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.3333333333%}.col-lg-offset-2{margin-left:16.6666666667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.3333333333%}.col-lg-offset-5{margin-left:41.6666666667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.3333333333%}.col-lg-offset-8{margin-left:66.6666666667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.3333333333%}.col-lg-offset-11{margin-left:91.6666666667%}.col-lg-offset-12{margin-left:100%}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.428571429;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.428571429;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm>.input-group-btn>input[type=date].btn,.input-group-sm>.input-group-btn>input[type=datetime-local].btn,.input-group-sm>.input-group-btn>input[type=month].btn,.input-group-sm>.input-group-btn>input[type=time].btn,.input-group-sm>input[type=date].form-control,.input-group-sm>input[type=date].input-group-addon,.input-group-sm>input[type=datetime-local].form-control,.input-group-sm>input[type=datetime-local].input-group-addon,.input-group-sm>input[type=month].form-control,.input-group-sm>input[type=month].input-group-addon,.input-group-sm>input[type=time].form-control,.input-group-sm>input[type=time].input-group-addon,.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input[type=date].btn,.input-group-lg>.input-group-btn>input[type=datetime-local].btn,.input-group-lg>.input-group-btn>input[type=month].btn,.input-group-lg>.input-group-btn>input[type=time].btn,.input-group-lg>input[type=date].form-control,.input-group-lg>input[type=date].input-group-addon,.input-group-lg>input[type=datetime-local].form-control,.input-group-lg>input[type=datetime-local].input-group-addon,.input-group-lg>input[type=month].form-control,.input-group-lg>input[type=month].input-group-addon,.input-group-lg>input[type=time].form-control,.input-group-lg>input[type=time].input-group-addon,.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-left:0;padding-right:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select[multiple].btn,.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select[multiple].btn,.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{content:\" \";display:table}.form-horizontal .form-group:after{clear:both}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.428571429;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.btn-default.dropdown-toggle{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.428571429;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.428571429;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{content:\" \";display:table}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav:after,.nav:before{content:\" \";display:table}.nav:after{clear:both}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.428571429;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}.navbar:after,.navbar:before{content:\" \";display:table}.navbar:after{clear:both}@media (min-width:768px){.navbar{border-radius:4px}}.navbar-header:after,.navbar-header:before{content:\" \";display:table}.navbar-header:after{clear:both}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{content:\" \";display:table}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#090909;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.428571429;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#337ab7;border-color:#337ab7;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager:after,.pager:before{content:\" \";display:table}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto;margin-left:auto;margin-right:auto}.thumbnail .caption{padding:9px;color:#333}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-body:after,.panel-body:before{content:\" \";display:table}.panel-body:after{clear:both}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transform:translateY(-25%);transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{-webkit-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{content:\" \";display:table}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.428571429}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{content:\" \";display:table}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{-webkit-transform:translateZ(0);transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?v=4.7.0\");src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.2857142857em;text-align:center}.fa-ul{padding-left:0;margin-left:2.1428571429em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.1428571429em;width:2.1428571429em;top:.1428571429em;text-align:center}.fa-li.fa-lg{left:-1.8571428571em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}body{background:url(/assets/images/background.jpg) no-repeat 50% fixed;background-size:cover}.text-bold{font-weight:700}.text-italic{font-style:italic}.text-underlined{text-decoration:underline}body.frontpage-footer-background{background:#fff!important}div[ui-view] .container,footer .container{background-color:#fff;box-shadow:0 0 5px 5px #fff}div.frontpage .container{background-color:transparent;box-shadow:none}a.btn.btn-more:hover{color:#000}.timeline-panel{width:100%!important}ol.breadcrumb{background-image:url(\"/assets/images/background-header-1.png\")}h3.separator,h4.separator{position:relative;text-align:left}h3.separator span,h4.separator span{background:#fff;padding-right:5px;position:relative}h3.separator:before,h4.separator:before{background:#ddd;content:\"\";display:block;height:3px;position:absolute;top:50%;width:100%;left:0}@font-face{font-family:weather;src:url(\"https://s3-us-west-2.amazonaws.com/s.cdpn.io/93/artill_clean_icons-webfont.eot\");src:url(\"https://s3-us-west-2.amazonaws.com/s.cdpn.io/93/artill_clean_icons-webfont.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://s3-us-west-2.amazonaws.com/s.cdpn.io/93/artill_clean_icons-webfont.woff\") format(\"woff\"),url(\"https://s3-us-west-2.amazonaws.com/s.cdpn.io/93/artill_clean_icons-webfont.ttf\") format(\"truetype\"),url(\"https://s3-us-west-2.amazonaws.com/s.cdpn.io/93/artill_clean_icons-webfont.svg#artill_clean_weather_iconsRg\") format(\"svg\");font-weight:400;font-style:normal}.modal-header{background:url(/assets/images/grey_wash_wall.png)}.modal-header h1,.modal-header h2,.modal-header h3,.modal-header h4,.modal-header h5{color:#eee}.modal-footer{background:url(/assets/images/subtle_grunge.png)}dl.dl-horizontal .btn-group-sm>button.btn,dl.dl-horizontal button.btn.btn-sm{margin-bottom:3px}.btn-ms-action{padding:2px 5px!important;margin:2px!important}.xl-modal .modal-dialog{max-width:1490px!important;min-width:971px!important;width:95%!important}.button-base-alignment{position:relative;top:24px}table.borderless tbody td{border:none}tr.totals td{font-weight:700}tr.sub-totals{border-top:1px solid #d3d3d3}tr.totals{border-top:2px solid #d3d3d3}tr.heading td{font-size:larger;padding:16px!important;padding-top:32px!important;letter-spacing:5px}tr.voided{text-decoration:line-through}form.editable-checklist div.editable-controls{padding-top:4px;border-top:2px solid #d3d3d3;margin-top:8px}form.editable-checklist label{margin-right:8px}form.editable-checklist label input{margin-right:2px}form.editable-checklist span.editable-buttons{display:block}.ta-editor{min-height:300px;height:auto;overflow:auto;font-family:inherit;font-size:100%;margin:8px 0}div.storageContentBox{padding:8px;margin:4px;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px;overflow:hidden}.placeholder{background:#aef}#map{height:600px}.controls{margin-top:10px;border:1px solid transparent;border-radius:2px 0 0 2px;box-sizing:border-box;-moz-box-sizing:border-box;height:32px;outline:none;box-shadow:0 2px 6px rgba(0,0,0,.3)}#pac-input{background-color:#fff;font-family:Roboto;font-size:15px;font-weight:300;margin-left:12px;padding:0 11px 0 13px;text-overflow:ellipsis;width:300px}#pac-input:focus{border-color:#4d90fe}.pac-container{font-family:Roboto}.infoWindowContent{font-size:14px!important;border-top:1px solid #ccc;padding-top:10px}.fc-event-container,.fc-list-item{cursor:pointer!important}custom-edit form .has-success label{color:#666!important}custom-edit fieldset legend{font-size:16px}custom-edit div.big-textfield textarea{height:90px!important}custom-edit div.bigger-textfield textarea{height:120px!important}table.custom-view-grouped tr.dtrg-group.dtrg-level-0 td{font-weight:700;background-color:#ddd}table.custom-view-grouped tr.dtrg-group.dtrg-level-1 td{background-color:#eee;padding-left:1em}table.custom-view-grouped tr.even td,table.custom-view-grouped tr.odd td{background-color:#fff}table.custom-view-grouped tr.even td:first-child,table.custom-view-grouped tr.odd td:first-child{padding-left:2em}e-form-browser img{border:1px solid #468847;border-radius:5px}e-form-edit .preview{border-left:2px dotted #a9a9a9;background:#eee}e-form-edit .preview input,e-form-edit .preview select,e-form-edit .preview textarea{background:none}h4 hr{padding:0;margin:0;position:relative;top:-9px;border:1px solid;opacity:.25}.carousel-overlay-text{color:#fff;position:absolute;z-index:12;top:20%;left:10%;width:80%;text-align:center}.white-black-shadow{color:#fff;text-shadow:#000 .1em .1em .2em}#fullCalendarMain .fc-toolbar{display:none}#fullCalendarMain .fc-scroller{height:auto!important}ul.external-link-list{list-style:none;padding:0}ul.external-link-list li{padding-left:1.3em}ul.external-link-list li:before{content:\"\\F14C\";font-family:FontAwesome;display:inline-block;margin-left:-1.3em;width:1.3em}a.heading{color:inherit}a.heading,a.heading:hover{text-decoration:none}.dashboard-content .panel table{margin-bottom:0}.dashboard-content .panel-default .panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.dashboard-content .panel-green a,.dashboard-content .panel-red a,.dashboard-content .panel-yellow a{color:#337ab7}.dashboard-content .panel-green a.btn-default,.dashboard-content .panel-red a.btn-default,.dashboard-content .panel-yellow a.btn-default{color:#333}.dashboard-content .panel-green .panel-heading a,.dashboard-content .panel-red .panel-heading a,.dashboard-content .panel-yellow .panel-heading a{color:#fff}.dashboard-content .grid{border:none}.dashboard-content .panel-green{border-color:#5cb85c}.dashboard-content .panel-green .panel-heading{border-color:#5cb85c;color:#fff;background-color:#5cb85c}.dashboard-content .panel-green a{color:#5cb85c}.dashboard-content .panel-green a:hover{color:#3d8b3d}.dashboard-content .panel-red{border-color:#d9534f}.dashboard-content .panel-red .panel-heading{border-color:#d9534f;color:#fff;background-color:#d9534f}.dashboard-content .panel-red a{color:#d9534f}.dashboard-content .panel-red a:hover{color:#b52b27}.dashboard-content .panel-yellow{border-color:#f0ad4e}.dashboard-content .panel-yellow .panel-heading{border-color:#f0ad4e;color:#fff;background-color:#f0ad4e}.dashboard-content .panel-yellow a{color:#f0ad4e}.dashboard-content .panel-yellow a:hover{color:#df8a13}.dashboard-content .huge{font-size:40px}.thing-form{margin:20px 0}#banner{border-bottom:none;margin-top:-20px}#banner h1{font-size:60px;line-height:1;letter-spacing:-1px}.hero-unit{position:relative;padding:30px 15px;color:#f5f5f5;text-align:center;text-shadow:0 1px 0 rgba(0,0,0,.1);background:#f5f5f5}.navbar-text{margin-left:15px}.frontpage{background-image:url(/assets/images/frontpage.jpeg);background-position:50%;background-color:#fff;background-repeat:no-repeat;background-size:cover;position:relative;top:-24px;border-bottom:1px solid #a9a9a9;height:640px}.frontpage .welcome-facts p{text-align:justify}.frontpage .jumbotron{margin-right:25%}@media (max-width:576px){.frontpage .jumbotron{margin:0!important}}header#slider{height:100vh;position:relative;top:-20px}.active,.carousel,.carousel-inner,.fill,.item{height:100%}.fill{width:100%;background-position:50%;background-size:cover;-o-background-size:cover}.carousel.fade{opacity:1}.carousel.fade .item{transition:opacity .7s ease-in-out;left:0!important;opacity:0;top:0;position:absolute;width:100%;display:block!important;z-index:1}.carousel.fade .item:first-child{top:auto;position:relative}.carousel.fade .item.active{opacity:1;transition:opacity .7s ease-in-out;z-index:2}.card-container.card{max-width:400px;padding:40px}.card-container.card.sketchy{border:2px solid #333;border-radius:555px 25px 15px 25px/25px 5px 35px 555px}.card{background-color:#f7f7f7;padding:20px 25px 30px;margin:0 auto 25px;margin-top:50px;border-radius:2px;box-shadow:0 2px 2px rgba(0,0,0,.3)}.profile-img-card{height:96px;margin:0 auto 10px;display:block;border-radius:50%}.profile-name-card{font-size:28px;font-weight:700;text-align:center;margin:10px 0 0;min-height:1em}.form-signin #inputEmail,.form-signin #inputPassword{direction:ltr;height:44px;font-size:16px}.form-signin input[type=email],.form-signin input[type=password],.form-signin input[type=text]{width:100%;display:block;margin-bottom:10px;z-index:1;position:relative;box-sizing:border-box}.form-signin .form-control:focus{border-color:#6891a2;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px #6891a2}main div.card.card-container{background:#eee;background:linear-gradient(180deg,#eee 0,#ddd)}.open>.dropdown-toggle{border-color:red}quickbooks-overview ul.nav-tabs li.separator-right{margin-right:12px;padding-right:5px;padding-left:5px;border-right:1px solid;border-image:linear-gradient(180deg,transparent,#d3d3d3) 1 100%}.borderless td,.borderless th,.ph-item{border:none!important}.ph-item{position:relative;width:100%;margin:0!important;padding:0!important;overflow:hidden;background-color:#fff}.ph-item,.ph-item *,.ph-item :after,.ph-item :before{box-sizing:border-box}.ph-item:before{content:\" \";position:absolute;top:0;right:0;bottom:0;left:50%;z-index:1;width:500%;margin-left:-250%;-webkit-animation:phAnimation .8s linear infinite;animation:phAnimation .8s linear infinite;background:linear-gradient(90deg,hsla(0,0%,100%,0) 46%,hsla(0,0%,100%,.35) 50%,hsla(0,0%,100%,0) 54%) 50% 50%}.ph-item>*{padding-right:15px;padding-left:15px}.ph-row{display:flex;flex-wrap:wrap;margin-bottom:7.5px}.ph-row div{height:10px;margin-bottom:7.5px;background-color:#ced4da}.ph-row .big,.ph-row.big div{height:20px;margin-bottom:15px}.ph-row .empty{background-color:hsla(0,0%,100%,0)}.ph-col-2{flex:0 0 16.66667%}.ph-col-4{flex:0 0 33.33333%}.ph-col-6{flex:0 0 50%}.ph-col-8{flex:0 0 66.66667%}.ph-col-10{flex:0 0 83.33333%}.ph-col-12{flex:0 0 100%}.ph-avatar{position:relative;width:100%;min-width:60px;background-color:#ced4da;margin-bottom:15px;border-radius:50%;overflow:hidden}.ph-avatar:before{content:\" \";display:block;padding-top:100%}.ph-picture{width:100%;height:120px;background-color:#ced4da;margin-bottom:15px}@-webkit-keyframes phAnimation{0%{transform:translate3d(-30%,0,0)}to{transform:translate3d(30%,0,0)}}@keyframes phAnimation{0%{transform:translate3d(-30%,0,0)}to{transform:translate3d(30%,0,0)}}.strike{text-decoration:line-through}div.dt-buttons{float:right;padding-left:12px;position:relative;top:-3px}.col-sep{border-right:3px solid #ddd}voter-list ul.nav-tabs li:nth-child(3){margin-right:5px;padding-right:5px;padding-left:5px;border-right:1px solid;border-image:linear-gradient(180deg,transparent,#d3d3d3) 1 100%}reports a:hover i{color:#000!important}#fullCalendarSearch .fc-toolbar{display:none}#fullCalendarSearch .fc-scroller{height:auto!important}service-request-ticket-list ul.nav-tabs li.separator-right{margin-right:12px;padding-right:5px;padding-left:5px;border-right:1px solid;border-image:linear-gradient(180deg,transparent,#d3d3d3) 1 100%}.chat{list-style:none;margin:0;padding:0}.chat li:not(:last-child){margin-bottom:10px;padding-bottom:5px;border-bottom:1px dotted #b3a9a9}.chat li.left .chat-body{margin-left:50px}.chat li.right .chat-body{margin-right:50px}.chat li .chat-body p{margin:0;color:#777}.cropArea{background:#e4e4e4;overflow:hidden;width:500px;height:350px}table.edittable td{padding:8px}tr.edit-highlight{background-color:rgba(0,125,255,.05);border:1px dotted #add8e6}table.edittable tr td:first-child{padding-right:4px;width:32px}table.edittable tr td:nth-child(2){padding-right:12px}violation-ticket-list ul.nav-tabs li.separator-right{margin-right:12px;padding-right:5px;padding-left:5px;border-right:1px solid;border-image:linear-gradient(180deg,transparent,#d3d3d3) 1 100%}service-request-ticket-show .card-container.card,violations-ticket-show .card-container.card,work-order-ticket-show .card-container.card{max-width:350px}service-request-ticket-show .card-container.card .paper-clip,violations-ticket-show .card-container.card .paper-clip,work-order-ticket-show .card-container.card .paper-clip{position:absolute;right:16px;top:-20px}service-request-ticket-show .card,violations-ticket-show .card,work-order-ticket-show .card{background-color:#fafad2;margin:0 auto 25px;margin-top:16px;margin-left:16px;border-radius:2px;box-shadow:0 2px 2px rgba(0,0,0,.3)}service-request-ticket-show .profile-img-card,violations-ticket-show .profile-img-card,work-order-ticket-show .profile-img-card{height:96px;margin:0 auto 10px;display:block;border-radius:50%}service-request-ticket-show .profile-name-card,violations-ticket-show .profile-name-card,work-order-ticket-show .profile-name-card{font-size:16px;font-weight:700;text-align:center;margin:10px 0 0;min-height:1em}.card-danger{background-color:#fff5ee!important}.progress-danger{font-weight:700}.progress-bar-danger{background-color:red!important}webaccess-list ul.nav-tabs li:nth-child(3),webaccess-list ul.nav-tabs li:nth-child(4){margin-right:5px;padding-right:5px;padding-left:5px;border-right:1px solid;border-image:linear-gradient(180deg,transparent,#d3d3d3) 1 100%}work-order-ticket-edit .card-container.card{max-width:350px}work-order-ticket-edit .card-container.card .paper-clip{position:absolute;right:16px;top:-20px}work-order-ticket-edit .card{background-color:#fafad2;margin:0 auto 25px;margin-top:16px;margin-left:16px;border-radius:2px;box-shadow:0 2px 2px rgba(0,0,0,.3)}work-order-ticket-edit .profile-img-card{height:96px;margin:0 auto 10px;display:block;border-radius:50%}work-order-ticket-edit .profile-name-card{font-size:16px;font-weight:700;text-align:center;margin:10px 0 0;min-height:1em}work-order-ticket-list ul.nav-tabs li.separator-right{margin-right:12px;padding-right:5px;padding-left:5px;border-right:1px solid;border-image:linear-gradient(180deg,transparent,#d3d3d3) 1 100%}textarea.big-textfield{height:90px!important}textarea.bigger-textfield{height:120px!important}violations-ticket-show .card-container.card{max-width:350px}violations-ticket-show .card-container.card .paper-clip{position:absolute;right:16px;top:-20px}violations-ticket-show .card{background-color:#fafad2;margin:0 auto 25px;margin-top:16px;margin-left:16px;border-radius:2px;box-shadow:0 2px 2px rgba(0,0,0,.3)}violations-ticket-show .profile-img-card{height:96px;margin:0 auto 10px;display:block;border-radius:50%}violations-ticket-show .profile-name-card{font-size:16px;font-weight:700;text-align:center;margin:10px 0 0;min-height:1em}div.asset-upload-progress-bar{color:#fff;font-weight:700;font-size:small;background:#337ab7;padding:4px}.bs-callout{padding:20px;margin:20px 0;border:1px solid #eee;border-left-width:5px;border-radius:3px;background-image:url(\"/assets/images/background-callout.png\")}.bs-callout h4{margin-top:0;margin-bottom:5px}.bs-callout p:last-child{margin-bottom:0}.bs-callout code{border-radius:3px}.bs-callout+.bs-callout{margin-top:-5px}.bs-callout-default{border-left-color:#777}.bs-callout-default h4{color:#777}.bs-callout-primary{border-left-color:#428bca}.bs-callout-primary h4{color:#428bca}.bs-callout-success{border-left-color:#5cb85c}.bs-callout-success h4{color:#5cb85c}.bs-callout-danger{border-left-color:#d9534f}.bs-callout-danger h4{color:#d9534f}.bs-callout-warning{border-left-color:#f0ad4e}.bs-callout-warning h4{color:#f0ad4e}.bs-callout-info{border-left-color:#5bc0de}.bs-callout-info h4{color:#5bc0de}community-list .bs-card,dashboard .bs-card,vendor-list .bs-card{position:relative;display:block;margin-bottom:20px;background-color:#fff;border:1px solid #ddd;border-radius:4px}community-list .card-block,dashboard .card-block,vendor-list .card-block{padding:15px}community-list .card-block:after,community-list .card-block:before,dashboard .card-block:after,dashboard .card-block:before,vendor-list .card-block:after,vendor-list .card-block:before{content:\" \";display:table}community-list .card-block:after,dashboard .card-block:after,vendor-list .card-block:after{clear:both}community-list .card-title,dashboard .card-title,vendor-list .card-title{margin-top:0}community-list .card-subtitle,dashboard .card-subtitle,vendor-list .card-subtitle{margin-bottom:8px}community-list .card-text:last-child,dashboard .card-text:last-child,vendor-list .card-text:last-child{margin-bottom:0}community-list .card-link:hover,dashboard .card-link:hover,vendor-list .card-link:hover{text-decoration:none}community-list .card-link+.card-link,dashboard .card-link+.card-link,vendor-list .card-link+.card-link{margin-left:15px}community-list .bs-card>.list-group:first-child .list-group-item:first-child,dashboard .bs-card>.list-group:first-child .list-group-item:first-child,vendor-list .bs-card>.list-group:first-child .list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}community-list .bs-card>.list-group:last-child .list-group-item:last-child,dashboard .bs-card>.list-group:last-child .list-group-item:last-child,vendor-list .bs-card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}community-list .bs-card .list-group li,dashboard .bs-card .list-group li,vendor-list .bs-card .list-group li{border-left:0;border-right:0}community-list .card-header,dashboard .card-header,vendor-list .card-header{padding:10px 15px;background-color:#f5f5f5;border-bottom:1px solid #ddd}community-list .card-header:after,community-list .card-header:before,dashboard .card-header:after,dashboard .card-header:before,vendor-list .card-header:after,vendor-list .card-header:before{content:\" \";display:table}community-list .card-header:after,dashboard .card-header:after,vendor-list .card-header:after{clear:both}community-list .card-header:first-child,dashboard .card-header:first-child,vendor-list .card-header:first-child{border-radius:4px 4px 0 0}community-list .card-footer,dashboard .card-footer,vendor-list .card-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd}community-list .card-footer:after,community-list .card-footer:before,dashboard .card-footer:after,dashboard .card-footer:before,vendor-list .card-footer:after,vendor-list .card-footer:before{content:\" \";display:table}community-list .card-footer:after,dashboard .card-footer:after,vendor-list .card-footer:after{clear:both}community-list .card-footer:last-child,dashboard .card-footer:last-child,vendor-list .card-footer:last-child{border-radius:0 0 4px 4px}community-list .card-header-tabs,dashboard .card-header-tabs,vendor-list .card-header-tabs{margin-right:-5px;margin-left:-5px;border-bottom:0;position:relative;top:10px}community-list .card-header-pills,dashboard .card-header-pills,vendor-list .card-header-pills{margin-right:-5px;margin-left:-5px}community-list .card-primary,dashboard .card-primary,vendor-list .card-primary{background-color:#337ab7;border-color:#337ab7}community-list .card-primary .card-footer,community-list .card-primary .card-header,dashboard .card-primary .card-footer,dashboard .card-primary .card-header,vendor-list .card-primary .card-footer,vendor-list .card-primary .card-header{background-color:transparent}community-list .card-success,dashboard .card-success,vendor-list .card-success{background-color:#5cb85c;border-color:#5cb85c}community-list .card-success .card-footer,community-list .card-success .card-header,dashboard .card-success .card-footer,dashboard .card-success .card-header,vendor-list .card-success .card-footer,vendor-list .card-success .card-header{background-color:transparent}community-list .card-info,dashboard .card-info,vendor-list .card-info{background-color:#5bc0de;border-color:#5bc0de}community-list .card-info .card-footer,community-list .card-info .card-header,dashboard .card-info .card-footer,dashboard .card-info .card-header,vendor-list .card-info .card-footer,vendor-list .card-info .card-header{background-color:transparent}community-list .card-warning,dashboard .card-warning,vendor-list .card-warning{background-color:#f0ad4e;border-color:#f0ad4e}community-list .card-warning .card-footer,community-list .card-warning .card-header,dashboard .card-warning .card-footer,dashboard .card-warning .card-header,vendor-list .card-warning .card-footer,vendor-list .card-warning .card-header{background-color:transparent}community-list .card-danger,dashboard .card-danger,vendor-list .card-danger{background-color:#d9534f;border-color:#d9534f}community-list .card-danger .card-footer,community-list .card-danger .card-header,dashboard .card-danger .card-footer,dashboard .card-danger .card-header,vendor-list .card-danger .card-footer,vendor-list .card-danger .card-header{background-color:transparent}community-list .card-outline-primary,dashboard .card-outline-primary,vendor-list .card-outline-primary{background-color:transparent;border-color:#337ab7}community-list .card-outline-secondary,dashboard .card-outline-secondary,vendor-list .card-outline-secondary{background-color:transparent;border-color:#ccc}community-list .card-outline-info,dashboard .card-outline-info,vendor-list .card-outline-info{background-color:transparent;border-color:#5bc0de}community-list .card-outline-success,dashboard .card-outline-success,vendor-list .card-outline-success{background-color:transparent;border-color:#5cb85c}community-list .card-outline-warning,dashboard .card-outline-warning,vendor-list .card-outline-warning{background-color:transparent;border-color:#f0ad4e}community-list .card-outline-danger,dashboard .card-outline-danger,vendor-list .card-outline-danger{background-color:transparent;border-color:#d9534f}community-list .card-inverse .card-footer,community-list .card-inverse .card-header,dashboard .card-inverse .card-footer,dashboard .card-inverse .card-header,vendor-list .card-inverse .card-footer,vendor-list .card-inverse .card-header{border-color:hsla(0,0%,100%,.2)}community-list .card-inverse .card-blockquote,community-list .card-inverse .card-footer,community-list .card-inverse .card-header,community-list .card-inverse .card-title,dashboard .card-inverse .card-blockquote,dashboard .card-inverse .card-footer,dashboard .card-inverse .card-header,dashboard .card-inverse .card-title,vendor-list .card-inverse .card-blockquote,vendor-list .card-inverse .card-footer,vendor-list .card-inverse .card-header,vendor-list .card-inverse .card-title{color:#fff}community-list .card-inverse .card-blockquote .blockquote-footer,community-list .card-inverse .card-link,community-list .card-inverse .card-subtitle,community-list .card-inverse .card-text,dashboard .card-inverse .card-blockquote .blockquote-footer,dashboard .card-inverse .card-link,dashboard .card-inverse .card-subtitle,dashboard .card-inverse .card-text,vendor-list .card-inverse .card-blockquote .blockquote-footer,vendor-list .card-inverse .card-link,vendor-list .card-inverse .card-subtitle,vendor-list .card-inverse .card-text{color:hsla(0,0%,100%,.65)}community-list .card-inverse .card-link:focus,community-list .card-inverse .card-link:hover,dashboard .card-inverse .card-link:focus,dashboard .card-inverse .card-link:hover,vendor-list .card-inverse .card-link:focus,vendor-list .card-inverse .card-link:hover{color:#fff}community-list .card-blockquote,dashboard .card-blockquote,vendor-list .card-blockquote{padding:0;margin-bottom:0;border-left:0}community-list .card-img,dashboard .card-img,vendor-list .card-img{border-radius:.25em}community-list .card-img-overlay,dashboard .card-img-overlay,vendor-list .card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:15px}community-list .card-img-top,dashboard .card-img-top,vendor-list .card-img-top{border-top-right-radius:4px;border-top-left-radius:4px}community-list .card-img-bottom,dashboard .card-img-bottom,vendor-list .card-img-bottom{border-bottom-right-radius:4px;border-bottom-left-radius:4px}footer.footer{text-align:center;padding:30px 0;margin-top:70px;border-top:1px solid #e5e5e5}iframe-preview html-iframe iframe{height:480px;border:0;width:100%}.modal-danger .modal-header,.modal-info .modal-header,.modal-primary .modal-header,.modal-success .modal-header,.modal-warning .modal-header{color:#fff;border-radius:5px 5px 0 0}.modal-primary .modal-header{background:#337ab7}.modal-info .modal-header{background:#5bc0de}.modal-success .modal-header{background:#5cb85c}.modal-warning .modal-header{background:#f0ad4e}.modal-danger .modal-header{background:#d9534f}.tabs-right.align ul.nav-tabs{position:relative;top:-22px}.tabs-left .tab-content>.active,.tabs-right .tab-content>.active{display:flex}.tabs-below>.nav-tabs,.tabs-left>.nav-tabs,.tabs-right>.nav-tabs{border-bottom:0}.pill-content>.pill-pane,.tab-content>.tab-pane{display:none}.pill-content>.active,.tab-content>.active{display:block}.tabs-below>.nav-tabs{border-top:1px solid #ddd}.tabs-below>.nav-tabs>li{margin-top:-1px;margin-bottom:0}.tabs-below>.nav-tabs>li>a{border-radius:0 0 4px 4px}.tabs-below>.nav-tabs>li>a:focus,.tabs-below>.nav-tabs>li>a:hover{border-top-color:#ddd;border-bottom-color:transparent}.tabs-below>.nav-tabs>.active>a,.tabs-below>.nav-tabs>.active>a:focus,.tabs-below>.nav-tabs>.active>a:hover{border-color:transparent #ddd #ddd}.tabs-left>.nav-tabs>li,.tabs-right>.nav-tabs>li{float:none}.tabs-left>.nav-tabs>li>a,.tabs-right>.nav-tabs>li>a{min-width:74px;margin-right:0;margin-bottom:3px}.tabs-left>.nav-tabs{float:left;margin-right:19px;border-right:1px solid #ddd}.tabs-left>.nav-tabs>li>a{margin-right:-1px;border-radius:4px 0 0 4px}.tabs-left>.nav-tabs>li>a:focus,.tabs-left>.nav-tabs>li>a:hover{border-color:#eee #ddd #eee #eee}.tabs-left>.nav-tabs .active>a,.tabs-left>.nav-tabs .active>a:focus,.tabs-left>.nav-tabs .active>a:hover{border-color:#ddd transparent #ddd #ddd;*border-right-color:#fff}.tabs-right>.nav-tabs{float:right;margin-left:19px;border-left:1px solid #ddd}.tabs-right>.nav-tabs>li>a{margin-left:-1px;border-radius:0 4px 4px 0}.tabs-right>.nav-tabs>li>a:focus,.tabs-right>.nav-tabs>li>a:hover{border-color:#eee #eee #eee #ddd}.tabs-right>.nav-tabs .active>a,.tabs-right>.nav-tabs .active>a:focus,.tabs-right>.nav-tabs .active>a:hover{border-color:#ddd #ddd #ddd transparent;*border-left-color:#fff}photo-card div.photo{padding:5px!important}photo-card a{color:#483d8b;border-bottom:1px dotted #483d8b}photo-card a:hover{border-bottom:none}@media (min-width:768px){photo-card .dl-horizontal dt{width:16px}photo-card .dl-horizontal dd{margin-left:24px}}user-card a{color:#483d8b;border-bottom:1px dotted #483d8b}user-card a:hover{border-bottom:none}@media (min-width:768px){user-card .dl-horizontal dt{width:16px}user-card .dl-horizontal dd{margin-left:24px}}/*!\r\n * Yamm!3 - Yet another megamenu for Bootstrap 3\r\n * http://geedmo.github.com/yamm3\r\n *\r\n * @geedmo - Licensed under the MIT license\r\n */.yamm .collapse,.yamm .dropdown,.yamm .dropup,.yamm .nav{position:static}.yamm .container{position:relative}.yamm .dropdown-menu{left:auto}.yamm .yamm-content{padding:20px 30px}.yamm .dropdown.yamm-fw .dropdown-menu{left:0;right:0;border-left:0;border-right:0}", ""]);
	
	// exports


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Binds a CodeMirror widget to a <textarea> element.
	 */
	uiCodemirrorDirective.$inject = ['$timeout', 'uiCodemirrorConfig'];
	angular.module('ui.codemirror', [])
	  .constant('uiCodemirrorConfig', {})
	  .directive('uiCodemirror', uiCodemirrorDirective);
	
	/**
	 * @ngInject
	 */
	function uiCodemirrorDirective($timeout, uiCodemirrorConfig) {
	
	  return {
	    restrict: 'EA',
	    require: '?ngModel',
	    compile: function compile() {
	
	      // Require CodeMirror
	      if (angular.isUndefined(window.CodeMirror)) {
	        throw new Error('ui-codemirror needs CodeMirror to work... (o rly?)');
	      }
	
	      return postLink;
	    }
	  };
	
	  function postLink(scope, iElement, iAttrs, ngModel) {
	
	    var codemirrorOptions = angular.extend(
	      { value: iElement.text() },
	      uiCodemirrorConfig.codemirror || {},
	      scope.$eval(iAttrs.uiCodemirror),
	      scope.$eval(iAttrs.uiCodemirrorOpts)
	    );
	
	    var codemirror = newCodemirrorEditor(iElement, codemirrorOptions);
	
	    configOptionsWatcher(
	      codemirror,
	      iAttrs.uiCodemirror || iAttrs.uiCodemirrorOpts,
	      scope
	    );
	
	    configNgModelLink(codemirror, ngModel, scope);
	
	    configUiRefreshAttribute(codemirror, iAttrs.uiRefresh, scope);
	
	    // Allow access to the CodeMirror instance through a broadcasted event
	    // eg: $broadcast('CodeMirror', function(cm){...});
	    scope.$on('CodeMirror', function(event, callback) {
	      if (angular.isFunction(callback)) {
	        callback(codemirror);
	      } else {
	        throw new Error('the CodeMirror event requires a callback function');
	      }
	    });
	
	    // onLoad callback
	    if (angular.isFunction(codemirrorOptions.onLoad)) {
	      codemirrorOptions.onLoad(codemirror);
	    }
	  }
	
	  function newCodemirrorEditor(iElement, codemirrorOptions) {
	    var codemirrot;
	
	    if (iElement[0].tagName === 'TEXTAREA') {
	      // Might bug but still ...
	      codemirrot = window.CodeMirror.fromTextArea(iElement[0], codemirrorOptions);
	    } else {
	      iElement.html('');
	      codemirrot = new window.CodeMirror(function(cm_el) {
	        iElement.append(cm_el);
	      }, codemirrorOptions);
	    }
	
	    return codemirrot;
	  }
	
	  function configOptionsWatcher(codemirrot, uiCodemirrorAttr, scope) {
	    if (!uiCodemirrorAttr) { return; }
	
	    var codemirrorDefaultsKeys = Object.keys(window.CodeMirror.defaults);
	    scope.$watch(uiCodemirrorAttr, updateOptions, true);
	    function updateOptions(newValues, oldValue) {
	      if (!angular.isObject(newValues)) { return; }
	      codemirrorDefaultsKeys.forEach(function(key) {
	        if (newValues.hasOwnProperty(key)) {
	
	          if (oldValue && newValues[key] === oldValue[key]) {
	            return;
	          }
	
	          codemirrot.setOption(key, newValues[key]);
	        }
	      });
	    }
	  }
	
	  function configNgModelLink(codemirror, ngModel, scope) {
	    if (!ngModel) { return; }
	    // CodeMirror expects a string, so make sure it gets one.
	    // This does not change the model.
	    ngModel.$formatters.push(function(value) {
	      if (angular.isUndefined(value) || value === null) {
	        return '';
	      } else if (angular.isObject(value) || angular.isArray(value)) {
	        throw new Error('ui-codemirror cannot use an object or an array as a model');
	      }
	      return value;
	    });
	
	
	    // Override the ngModelController $render method, which is what gets called when the model is updated.
	    // This takes care of the synchronizing the codeMirror element with the underlying model, in the case that it is changed by something else.
	    ngModel.$render = function() {
	      //Code mirror expects a string so make sure it gets one
	      //Although the formatter have already done this, it can be possible that another formatter returns undefined (for example the required directive)
	      var safeViewValue = ngModel.$viewValue || '';
	      codemirror.setValue(safeViewValue);
	    };
	
	
	    // Keep the ngModel in sync with changes from CodeMirror
	    codemirror.on('change', function(instance) {
	      var newValue = instance.getValue();
	      if (newValue !== ngModel.$viewValue) {
	        scope.$evalAsync(function() {
	          ngModel.$setViewValue(newValue);
	        });
	      }
	    });
	  }
	
	  function configUiRefreshAttribute(codeMirror, uiRefreshAttr, scope) {
	    if (!uiRefreshAttr) { return; }
	
	    scope.$watch(uiRefreshAttr, function(newVal, oldVal) {
	      // Skip the initial watch firing
	      if (newVal !== oldVal) {
	        $timeout(function() {
	          codeMirror.refresh();
	        });
	      }
	    });
	  }
	
	}


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	'use strict';
	angular.module('angular-timeline', []);// Source: src/timeline-badge-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-badge
	 * @restrict AE
	 *
	 * @description
	 * Shown in the centre pane (or left on narrow devices) to indicate the activity.
	 */
	angular.module('angular-timeline').directive('timelineBadge', function() {
	  return {
	    require: '^timelineEvent',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-badge" ng-transclude></div>'
	  };
	});
	
	// Source: src/timeline-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline
	 * @restrict AE
	 *
	 * @description
	 * Primary container for displaying a vertical set of timeline events.
	 */
	angular.module('angular-timeline').directive('timeline', function() {
	  return {
	    restrict: 'AE',
	    transclude: true,
	    template: '<ul class="timeline" ng-transclude></ul>',
	    controller: function() {}
	  };
	});
	
	// Source: src/timeline-event-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline
	 * @restrict AE
	 *
	 * @description
	 * Represents an event occuring at a point in time, displayed on the left or the right
	 * of the timeline line.
	 *
	 * You typically embed a `timeline-badge` and `timeline-panel` element within a `timeline-event`.
	 *
	 * @param {string=} side  Define the side of the element (i.e. side="left", side="right", or use an {{ expression }}).
	 */
	
	angular.module('angular-timeline').directive('timelineEvent', function() {
	  return {
	    require: '^timeline',
	    restrict: 'AE',
	    transclude: true,
	    template: '<li class="timeline-event" ng-class-odd="oddClass" ng-class-even="evenClass" ng-transclude></li>',
	    link: function(scope, element, attrs, controller) {
	
	      var checkClass = function(side, leftSide) {
	
	        var leftClass = '';
	        var rightClass = 'timeline-inverted';
	
	        if (side === 'left' || (!side && leftSide === true)) {
	          return leftClass;
	        }
	        else if ((side === 'alternate' || !side) && leftSide === false) {
	          return rightClass;
	        }
	        else if (side === 'right') {
	          return rightClass;
	        }
	        else {
	          return leftClass;
	        }
	      };
	
	      var updateRowClasses = function(value) {
	        scope.oddClass = checkClass(value, true);
	        scope.evenClass = checkClass(value, false);
	      };
	
	      attrs.$observe('side', function(newValue) {
	        updateRowClasses(newValue);
	      });
	
	      updateRowClasses(attrs.side);
	    }
	  };
	});
	
	// Source: src/timeline-footer-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-footer
	 * @restrict AE
	 *
	 * @description
	 * Optional element to add a footer section to the `timeline-panel` for links or other actions.
	 */
	angular.module('angular-timeline').directive('timelineFooter', function() {
	  return {
	    require: '^timelinePanel',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-footer" ng-transclude></div>'
	  };
	});
	
	// Source: src/timeline-heading-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-heading
	 * @restrict AE
	 *
	 * @description
	 * Optional element to show the heading for a `timeline-panel`.
	 */
	angular.module('angular-timeline').directive('timelineHeading', function() {
	  return {
	    require: '^timelinePanel',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-heading" ng-transclude></div>'
	  };
	});
	
	// Source: src/timeline-panel-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-panel
	 * @restrict AE
	 *
	 * @description
	 * An panel inside the `timeline-event` which shows detailed information about the event.
	 */
	angular.module('angular-timeline').directive('timelinePanel', function() {
	  return {
	    require: '^timeline',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-panel" ng-transclude></div>'
	  };
	});


/***/ }),
/* 339 */
5,
/* 340 */,
/* 341 */
5,
/* 342 */,
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	HistoryService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HistoryService = HistoryService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function HistoryService($resource) {
	  return $resource('/api/histories/:id', {
	    name: '@_id'
	  }, {
	    getByEntity: {
	      method: 'GET',
	      url: "/api/histories/entity/:id",
	      isArray: true
	    },
	    getInsight: {
	      method: 'GET',
	      url: "/api/histories/insight/:year/:month/:id",
	      isArray: true
	    },
	    queryRecentActivities: {
	      method: 'GET',
	      url: "/api/histories/recent",
	      isArray: true
	    }
	  });
	}
	
	exports.default = angular.module('conduu.HistoryService', []).factory('HistoryService', HistoryService).name;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProfileComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _profile = __webpack_require__(345);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ProfileComponent = exports.ProfileComponent = function () {
	
	  /*@ngInject*/
	  ProfileComponent.$inject = ['Auth', 'User', 'dialogs', '$q', '$stateParams', 'SettingsService'];
	  function ProfileComponent(Auth, User, dialogs, $q, $stateParams, SettingsService) {
	    var _this = this;
	
	    _classCallCheck(this, ProfileComponent);
	
	    this.user = {};
	    this.residencyRelations = {};
	    this.datepickerOpened = {};
	
	    this.Auth = Auth;
	    this.dialogs = dialogs;
	    this.$q = $q;
	
	    SettingsService.getByName({ name: 'config.app' }, function (settings) {
	      var appConfig = settings.data;
	
	      _this.config = appConfig;
	      _this.gender = appConfig.gender;
	      _this.phoneTypes = appConfig.phoneTypes;
	      _this.socialMediaTypes = appConfig.socialMediaTypes;
	      _this.mailTypes = appConfig.mailTypes;
	      _this.addressTypes = appConfig.addressTypes;
	      _this.labelPrivate = appConfig.profileLabelPrivate || 'Private';
	      _this.labelPublic = appConfig.profileLabelPublic || 'Public';
	    });
	
	    this.userId = $stateParams.id;
	
	    if (this.userId == 'unknown') {
	      this.unknown = true;
	      return;
	    }
	
	    if (this.userId) {
	      this.isForeignProfile = true;
	
	      User.get({ id: this.userId }, function (user) {
	        _this.user = user;
	
	        _this.isRealtorProfile = _this.user.role.indexOf("realtor") != -1;
	      });
	    } else {
	      Auth.getCurrentUser().then(function (user) {
	        _this.user = user;
	      });
	    }
	  }
	
	  _createClass(ProfileComponent, [{
	    key: 'formatDialogElementInfo',
	    value: function formatDialogElementInfo(elmInfo) {
	      return "<br/><br/><b>" + elmInfo + "</b>";
	    }
	  }, {
	    key: 'addPhone',
	    value: function addPhone() {
	      this.user.profile.phone.push({
	        type: this.config.defaultPhoneType,
	        number: '',
	        private: false
	      });
	    }
	  }, {
	    key: 'removePhone',
	    value: function removePhone(idx) {
	      var _this2 = this;
	
	      var phone = this.user.profile.phone[idx];
	      var phoneString = phone.type + " " + phone.number;
	
	      var dlg = this.dialogs.confirm("Remove phone number?", "Do you really want to delete this phone number?" + this.formatDialogElementInfo(phoneString));
	      dlg.result.then(function () {
	        _this2.user.profile.phone.splice(idx, 1);
	        _this2.saveChanges();
	      }, function () {});
	    }
	  }, {
	    key: 'addMail',
	    value: function addMail() {
	      this.user.profile.email.push({
	        type: this.config.defaultMailType,
	        address: '',
	        private: false
	      });
	    }
	  }, {
	    key: 'removeMail',
	    value: function removeMail(idx) {
	      var _this3 = this;
	
	      var mail = this.user.profile.email[idx];
	      var mailString = mail.type + " " + mail.address;
	
	      var dlg = this.dialogs.confirm("Remove email?", "Do you really want to delete this email address?" + this.formatDialogElementInfo(mailString));
	      dlg.result.then(function () {
	        _this3.user.profile.email.splice(idx, 1);
	        _this3.saveChanges();
	      }, function () {});
	    }
	  }, {
	    key: 'addSocialMedia',
	    value: function addSocialMedia() {
	      this.user.profile.socialMedia.push({
	        type: this.config.defaultSocialMediaType,
	        link: ''
	      });
	    }
	  }, {
	    key: 'removeSocialMedia',
	    value: function removeSocialMedia(idx) {
	      var _this4 = this;
	
	      var social = this.user.profile.socialMedia[idx];
	      var socialString = social.type + " " + social.link;
	
	      var dlg = this.dialogs.confirm("Remove social link?", "Do you really want to delete this social media entry?" + this.formatDialogElementInfo(socialString));
	      dlg.result.then(function () {
	        _this4.user.profile.socialMedia.splice(idx, 1);
	        _this4.saveChanges();
	      }, function () {});
	    }
	  }, {
	    key: 'addAddress',
	    value: function addAddress() {
	      this.user.profile.address.push({
	        type: this.config.defaultAddressType
	      });
	    }
	  }, {
	    key: 'removeAddress',
	    value: function removeAddress(idx) {
	      var _this5 = this;
	
	      var address = this.user.profile.address[idx];
	      var addressString = (address.street || '') + "<br/>" + (address.street2 || '') + "<br/>" + (address.city || '') + " " + (address.state || '') + " " + (address.zip || '') + "<br/>" + (address.country || '');
	
	      var dlg = this.dialogs.confirm("Remove address?", "Do you really want to delete this address?" + this.formatDialogElementInfo(addressString));
	      dlg.result.then(function () {
	        _this5.user.profile.address.splice(idx, 1);
	        _this5.saveChanges();
	      }, function () {});
	    }
	  }, {
	    key: 'saveChanges',
	    value: function saveChanges() {
	      this.Auth.updateUser(this.user);
	    }
	  }, {
	    key: 'checkValidPhone',
	    value: function checkValidPhone(phoneNumber) {
	      var reUsPhoneNumber = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
	      if (!reUsPhoneNumber.test(phoneNumber)) {
	        return "Please enter a valid phone number in the following format: (xxx) xxx-xxxx";
	      }
	    }
	  }, {
	    key: 'changePrimaryMail',
	    value: function changePrimaryMail(mail, index) {
	      var reBasicEmailValidation = /\S+@\S+\.\S+/;
	      if (!reBasicEmailValidation.test(mail)) {
	        return "Please enter a valid email address";
	      }
	
	      var primary = index === 0;
	
	      if (!primary) return;
	
	      var defer = this.$q.defer();
	
	      this.user.email = mail;
	
	      this.Auth.changeEmail(this.user._id, mail).then(function () {
	        defer.resolve();
	      }).catch(function (res) {
	        defer.resolve(res.data.errors.email.message);
	      });
	
	      return defer.promise;
	    }
	  }]);
	
	  return ProfileComponent;
	}();
	
	exports.default = angular.module('conduuApp.profile', [uiRouter]).config(_profile2.default).component('profile', {
	  template: __webpack_require__(346),
	  controller: ProfileComponent,
	  controllerAs: 'profileCtrl',
	  bindings: {
	    type: '@'
	  }
	}).name;

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('profile', {
	    url: '/profile',
	    template: '<profile></profile>',
	    authenticate: true
	  }).state('user-profile', {
	    url: '/profile/user/:id',
	    template: '<profile></profile>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"profileCtrl.unknown\" class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n\r\n      <br/>\r\n\r\n      <div class=\"alert alert-warning\">\r\n        <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n        <h4>This user is unknown!</h4>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div ng-if=\"!profileCtrl.unknown\" class=\"container\">\r\n  <div class=\"row\">\r\n\r\n    <div class=\"col-xs-8\">\r\n\r\n      <!-- Full Name (First, Middle and Last while Editing) -->\r\n      <table style=\"width: 100%\" class=\"edittable\">\r\n        <tr>\r\n          <td colspan=\"4\">\r\n            <h3>Basic Information</h3>\r\n            <hr/>\r\n          </td>\r\n        </tr>\r\n\r\n        <tr ng-class=\"{ 'edit-highlight': editableForm.$visible }\">\r\n          <td><i class=\"fa fa-user fa-fw\"></i></td>\r\n          <td>Full Name</td>\r\n          <td>\r\n            <span ng-if=\"profileCtrl.isForeignProfile\">\r\n              <b>{{ profileCtrl.user.firstName || '' }}</b>\r\n              <b>{{ profileCtrl.user.middleName || '' }}</b>\r\n              <b>{{ profileCtrl.user.lastName || '' }}</b>\r\n            </span>\r\n            <form ng-if=\"!profileCtrl.isForeignProfile\" editable-form name=\"editableForm\" onaftersave=\"profileCtrl.saveChanges()\">\r\n              <span inplace-edit-hover ng-class=\"{'inplace-edit-hover-disabled': editableForm.$visible}\">\r\n                <span editable-text=\"profileCtrl.user.firstName\" ng-click=\"editableForm.$show()\" e-label=\"First Name\"\r\n                      ng-hide=\"editableForm.$visible\"><b>{{ profileCtrl.user.firstName || '' }}</b></span>\r\n                <span editable-text=\"profileCtrl.user.middleName\" ng-click=\"editableForm.$show()\" e-label=\"Middle Name\"\r\n                      ng-hide=\"editableForm.$visible\"><b>{{ profileCtrl.user.middleName || '' }}</b></span>\r\n                <span editable-text=\"profileCtrl.user.lastName\" ng-click=\"editableForm.$show()\" e-label=\"Last Name\"\r\n                      ng-hide=\"editableForm.$visible\"><b>{{ profileCtrl.user.lastName || '' }}</b></span>\r\n              </span>\r\n\r\n              <span ng-show=\"editableForm.$visible\">\r\n              <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"editableForm.$waiting\">\r\n                Save\r\n              </button>\r\n              <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"editableForm.$waiting\"\r\n                      ng-click=\"editableForm.$cancel()\">\r\n                Cancel\r\n              </button>\r\n              </span>\r\n            </form>\r\n          </td>\r\n          <td>&nbsp;</td>\r\n        </tr>\r\n\r\n        <!-- Birthday -->\r\n        <tr ng-hide=\"profileCtrl.isRealtorProfile\" id=\"profile-section-birthday\" ng-class=\"{ 'edit-highlight': birthdayEditForm.$visible }\">\r\n          <td><i class=\"fa fa-birthday-cake fa-fw\"></i></td>\r\n          <td>Birthday</td>\r\n          <td>\r\n            <span ng-if=\"profileCtrl.isForeignProfile\">\r\n              <b>{{ (profileCtrl.user.profile.birthday | date:\"MMM d, y\") || 'n/a' }}</b>\r\n            </span>\r\n            <span ng-if=\"!profileCtrl.isForeignProfile\" style=\"font-weight:bold; text-decoration:none\"\r\n               inplace-edit-hover href=\"#\" editable-combodate=\"profileCtrl.user.profile.birthday\"\r\n               e-single e-min-year=\"1920\" ng-click=\"frmBirthday.$show()\" e-format=\"{{null}}\" e-template=\"MMM D, YYYY\"\r\n               e-max-year=\"2015\" e-form=\"frmBirthday\" ng-hide=\"frmBirthday.$visible\"\r\n                  onaftersave=\"profileCtrl.saveChanges()\">\r\n              {{ (profileCtrl.user.profile.birthday | date:'MMM d, y') || 'n/a' }}\r\n            </span>\r\n          </td>\r\n          <td>&nbsp;</td>\r\n        </tr>\r\n\r\n        <!-- Gender -->\r\n        <tr ng-hide=\"profileCtrl.isRealtorProfile\" id=\"profile-section-gender\" ng-class=\"{ 'edit-highlight': genderEditForm.$visible }\">\r\n          <td><i class=\"fa fa-venus-mars fa-fw\"></i></td>\r\n          <td>Gender</td>\r\n          <td>\r\n            <span ng-if=\"profileCtrl.isForeignProfile\">\r\n              <b>{{ profileCtrl.user.profile.gender || 'n/a' }}</b>\r\n            </span>\r\n            <span ng-if=\"!profileCtrl.isForeignProfile\" inplace-edit-hover editable-select=\"profileCtrl.user.profile.gender\"\r\n                  onaftersave=\"profileCtrl.saveChanges()\" e-ng-options=\"g as g for g in profileCtrl.gender\"\r\n                  e-form=\"genderEditForm\" ng-click=\"genderEditForm.$show()\" ng-hide=\"genderEditForm.$visible\">\r\n              <b>{{ profileCtrl.user.profile.gender || 'n/a' }}</b>\r\n            </span>\r\n          </td>\r\n          <td>&nbsp;</td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n\r\n    <div class=\"col-xs-4 text-right\">\r\n      <div class=\"row\" style=\"padding: 16px\">\r\n        <img style=\"width:192px;\"\r\n             ng-show=\"!profileCtrl.user.profile.picture && profileCtrl.user.profile.gender == 'female'\"\r\n             src=\"https://cdn0.iconfinder.com/data/icons/people-groups/512/User_Female-512.png\"/>\r\n        <img style=\"width:192px;\"\r\n             ng-show=\"!profileCtrl.user.profile.picture && profileCtrl.user.profile.gender == 'male'\"\r\n             src=\"https://cdn0.iconfinder.com/data/icons/people-groups/512/User_Male-512.png\"/>\r\n        <img style=\"width:192px;\" ng-show=\"profileCtrl.user.profile.picture\"\r\n             ng-src=\"/api/storage/{{profileCtrl.user.profile.picture}}\"/>\r\n      </div>\r\n      <div class=\"row\" style=\"padding: 16px; padding-top:0px\">\r\n        <button ng-hide=\"profileCtrl.isForeignProfile\" class=\"btn btn-primary btn-sm\" ui-sref=\"profile-picture-upload\"><i class=\"fa fa-fw fa-pencil\"></i> Change Profile Picture</button>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n\r\n      <table style=\"width:100%\" class=\"edittable\">\r\n\r\n        <tr>\r\n          <td colspan=\"4\">\r\n            <h3>Contact Information</h3>\r\n            <hr/>\r\n          </td>\r\n        </tr>\r\n\r\n        <!-- Address -->\r\n        <tr ng-repeat=\"adr in profileCtrl.user.profile.address\"\r\n            ng-class=\"{ 'edit-highlight': editableForm.$visible || editableType.$visible }\">\r\n          <td><i class=\"fa fa-user fa-fw\"></i></td>\r\n          <td>\r\n            <span ng-if=\"profileCtrl.isForeignProfile\">\r\n              {{ adr.type || 'empty' }}\r\n            </span>\r\n            <span ng-if=\"!profileCtrl.isForeignProfile\" inplace-edit-hover editable-select=\"adr.type\" onaftersave=\"profileCtrl.saveChanges()\"\r\n                  e-ng-options=\"t as t for t in profileCtrl.addressTypes\"\r\n                  e-form=\"editableType\" ng-click=\"editableType.$show()\" ng-hide=\"editableType.$visible\">\r\n              {{ adr.type || 'enter here' }}\r\n            </span>\r\n          </td>\r\n          <td>\r\n            <form editable-form name=\"editableForm\" onaftersave=\"profileCtrl.saveChanges()\">\r\n              <span ng-if=\"profileCtrl.isForeignProfile\">\r\n                <span ng-hide=\"editableForm.$visible\"><b>{{ adr.street || '' }}</b></span><br ng-show=\"adr.street\"/>\r\n                <span ng-hide=\"editableForm.$visible || !adr.street2\"><b>{{ adr.street2 || '' }}</b></span><br\r\n                ng-show=\"adr.street2\"/>\r\n                <span ng-hide=\"editableForm.$visible\"><b>{{ adr.city || '' }}</b></span>\r\n                <span ng-hide=\"editableForm.$visible\"><b>{{ adr.state || '' }}</b></span>\r\n                <span ng-hide=\"editableForm.$visible\"><b>{{ adr.zip || '' }}</b></span><br\r\n                ng-show=\"adr.city || adr.state || adr.zip\"/>\r\n                <span ng-hide=\"editableForm.$visible\"><b>{{ adr.country || '' }}</b></span>\r\n              </span>\r\n              <span ng-if=\"!profileCtrl.isForeignProfile\" inplace-edit-hover ng-class=\"{'inplace-edit-hover-disabled': editableForm.$visible}\">\r\n                <span editable-text=\"adr.street\" ng-click=\"editableForm.$show()\" e-label=\"Street\"\r\n                      ng-hide=\"editableForm.$visible\"><b>{{ adr.street || '' }}</b></span><br ng-show=\"adr.street\"/>\r\n                <span editable-text=\"adr.street2\" ng-click=\"editableForm.$show()\" e-label=\"Address Line 2\"\r\n                      ng-hide=\"editableForm.$visible || !adr.street2\"><b>{{ adr.street2 || '' }}</b></span><br\r\n                ng-show=\"adr.street2\"/>\r\n                <span editable-text=\"adr.city\" ng-click=\"editableForm.$show()\" e-label=\"City\"\r\n                      ng-hide=\"editableForm.$visible\"><b>{{ adr.city || '' }}</b></span>\r\n                <span editable-text=\"adr.state\" ng-click=\"editableForm.$show()\" e-label=\"State\"\r\n                      ng-hide=\"editableForm.$visible\"><b>{{ adr.state || '' }}</b></span>\r\n                <span editable-text=\"adr.zip\" ng-click=\"editableForm.$show()\" e-label=\"Zip\"\r\n                      ng-hide=\"editableForm.$visible\"><b>{{ adr.zip || '' }}</b></span><br\r\n                ng-show=\"adr.city || adr.state || adr.zip\"/>\r\n                <span editable-text=\"adr.country\" ng-click=\"editableForm.$show()\" e-label=\"Country\"\r\n                      ng-hide=\"editableForm.$visible\"><b>{{ adr.country || '' }}</b></span>\r\n\r\n                <span ng-click=\"editableForm.$show()\"\r\n                      ng-hide=\"editableForm.$visible || adr.street || adr.street2 || adr.city || adr.state || adr.zip || adr.country\"><b>enter here</b></span>\r\n              </span>\r\n\r\n              <span ng-show=\"editableForm.$visible\">\r\n              <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"editableForm.$waiting\">\r\n                Save\r\n              </button>\r\n              <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"editableForm.$waiting\"\r\n                      ng-click=\"editableForm.$cancel()\">\r\n                Cancel\r\n              </button>\r\n              </span>\r\n            </form>\r\n          </td>\r\n          <td>\r\n            <div ng-show=\"$index > 0 && !profileCtrl.isForeignProfile\">\r\n              <a class=\"btn btn-danger\" ng-hide=\"editableForm.$visible\" ng-click=\"profileCtrl.removeAddress($index)\"><i\r\n                class=\"fa fa-trash\"></i></a>\r\n            </div>\r\n          </td>\r\n        </tr>\r\n\r\n        <!-- ADD Address -->\r\n        <tr ng-if=\"!profileCtrl.isForeignProfile\">\r\n          <td colspan=\"4\">\r\n            <button class=\"btn btn-sm btn-primary\" ng-click=\"profileCtrl.addAddress()\"><i class=\"fa fa-plus\"></i> Add\r\n              Address\r\n            </button>\r\n          </td>\r\n        </tr>\r\n\r\n        <!-- -------- -->\r\n        <tr>\r\n          <td colspan=\"4\">\r\n            &nbsp;\r\n          </td>\r\n        </tr>\r\n\r\n        <!-- Phone Numbers -->\r\n        <tr ng-repeat=\"tel in profileCtrl.user.profile.phone track by $index\"\r\n            ng-class=\"{ 'edit-highlight': phoneNumberForm.$visible || phoneTypeForm.$visible }\">\r\n          <td>\r\n            <i class=\"fa fa-phone fa-fw\" ng-hide=\"tel.type == 'Cell'\"></i>\r\n            <i class=\"fa fa-mobile fa-2x\" ng-show=\"tel.type == 'Cell'\" style=\"padding-left:2px\"></i>\r\n          </td>\r\n          <td>\r\n            <span ng-if=\"profileCtrl.isForeignProfile\">\r\n              {{ tel.type || 'Phone Number' }}\r\n            </span>\r\n            <span ng-if=\"!profileCtrl.isForeignProfile\" inplace-edit-hover editable-select=\"tel.type\" onaftersave=\"profileCtrl.saveChanges()\"\r\n                  e-ng-options=\"t as t for t in profileCtrl.phoneTypes\"\r\n                  e-form=\"phoneTypeForm\" ng-click=\"phoneTypeForm.$show()\" ng-hide=\"phoneTypeForm.$visible\">\r\n              {{ tel.type || 'Phone Number' }}\r\n            </span>\r\n          </td>\r\n          <td ng-if=\"profileCtrl.isForeignProfile && !tel.private\">\r\n            <b>{{ tel.number || 'empty' }}</b>\r\n          </td>\r\n          <td ng-if=\"!profileCtrl.isForeignProfile\" >\r\n            <span inplace-edit-hover editable-tel=\"tel.number\" onaftersave=\"profileCtrl.saveChanges()\"\r\n                  onbeforesave=\"profileCtrl.checkValidPhone($data)\"\r\n                  e-pattern=\"^(\\([0-9]{3}\\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$\" e-title=\"(xxx) xxx-xxxx\"\r\n                  e-form=\"phoneNumberForm\" ng-click=\"phoneNumberForm.$show()\" ng-hide=\"phoneNumberForm.$visible\"><b>{{ tel.number || 'enter here' }}</b></span>\r\n            <span ng-hide=\"phoneNumberForm.$visible\" inplace-edit-hover editable-checkbox=\"tel.private\"\r\n                  e-title=\"This phone number is private and should not be visible in the {{profileCtrl.labelPublic}} directories\"\r\n                  class=\"label inplace-edit-hover-on-label\" ng-class=\"{ 'label-default': !tel.private, 'label-danger': tel.private }\"\r\n                  onaftersave=\"profileCtrl.saveChanges()\" style=\"margin-left:24px\">{{ tel.private && profileCtrl.labelPrivate || profileCtrl.labelPublic }}</span>\r\n          </td>\r\n          <td>\r\n            <a ng-if=\"!profileCtrl.isForeignProfile\" class=\"btn btn-danger\" ng-hide=\"phoneNumberForm.$visible\" ng-click=\"profileCtrl.removePhone($index)\"><i\r\n              class=\"fa fa-trash\"></i></a>\r\n          </td>\r\n        </tr>\r\n\r\n        <!-- ADD Phone Number -->\r\n        <tr ng-if=\"!profileCtrl.isForeignProfile\">\r\n          <td colspan=\"4\">\r\n            <button class=\"btn btn-sm btn-primary\" ng-click=\"profileCtrl.addPhone()\"><i class=\"fa fa-plus\"></i> Add\r\n              Phone Number\r\n            </button>\r\n          </td>\r\n        </tr>\r\n\r\n        <!-- -------- -->\r\n        <tr>\r\n          <td colspan=\"4\">\r\n            &nbsp;\r\n          </td>\r\n        </tr>\r\n\r\n        <!-- E-Mail Addresses -->\r\n        <tr ng-repeat=\"mail in profileCtrl.user.profile.email track by $index\"\r\n            ng-class=\"{ 'edit-highlight': mailAddressForm.$visible || mailTypeForm.$visible}\">\r\n          <td>\r\n            <i class=\"fa fa-envelope fa-fw\"></i>\r\n          </td>\r\n          <td>\r\n            <span ng-if=\"profileCtrl.isForeignProfile\">\r\n              {{ mail.type || 'EMail' }}\r\n            </span>\r\n            <span ng-if=\"!profileCtrl.isForeignProfile\" inplace-edit-hover editable-select=\"mail.type\" onaftersave=\"profileCtrl.saveChanges()\"\r\n                  e-ng-options=\"t as t for t in profileCtrl.mailTypes\"\r\n                  e-form=\"mailTypeForm\" ng-click=\"mailTypeForm.$show()\" ng-hide=\"mailTypeForm.$visible\">\r\n              {{ mail.type || 'EMail' }}\r\n            </span>\r\n          </td>\r\n          <td ng-if=\"profileCtrl.isForeignProfile && !mail.private\">\r\n            <b>{{ mail.address || 'empty' }}</b>\r\n          </td>\r\n          <td ng-if=\"!profileCtrl.isForeignProfile\">\r\n            <span inplace-edit-hover editable-email=\"mail.address\"\r\n                  onbeforesave=\"profileCtrl.changePrimaryMail($data, $index)\" onaftersave=\"profileCtrl.saveChanges()\"\r\n                  e-form=\"mailAddressForm\" ng-click=\"mailAddressForm.$show()\" ng-hide=\"mailAddressForm.$visible\"\r\n                  e-required><b>{{ mail.address || 'enter here' }}</b></span>\r\n            <span ng-hide=\"mailAddressForm.$visible\" inplace-edit-hover editable-checkbox=\"mail.private\"\r\n                  e-title=\"This Email is private and should not be visible in the {{profileCtrl.labelPublic}} directories\"\r\n                  class=\"label inplace-edit-hover-on-label\" ng-class=\"{ 'label-default': !mail.private, 'label-danger': mail.private }\"\r\n                  onaftersave=\"profileCtrl.saveChanges()\" style=\"margin-left:24px\">{{ mail.private && profileCtrl.labelPrivate || profileCtrl.labelPublic }}</span>\r\n            <span class=\"label label-primary\" ng-show=\"$index == 0\">Primary</span>\r\n          </td>\r\n          <td>\r\n            <div ng-show=\"$index > 0 && !profileCtrl.isForeignProfile\">\r\n              <a class=\"btn btn-danger\" ng-hide=\"mailAddressForm.$visible\" ng-click=\"profileCtrl.removeMail($index)\"><i\r\n                class=\"fa fa-trash\"></i></a>\r\n            </div>\r\n          </td>\r\n        </tr>\r\n\r\n        <!-- ADD EMaiL -->\r\n        <tr ng-if=\"!profileCtrl.isForeignProfile\">\r\n          <td colspan=\"4\">\r\n            <button class=\"btn btn-sm btn-primary\" ng-click=\"profileCtrl.addMail()\"><i class=\"fa fa-plus\"></i> Add\r\n              Email\r\n            </button>\r\n          </td>\r\n        </tr>\r\n\r\n        <!-- -------- -->\r\n        <tr>\r\n          <td colspan=\"4\">\r\n            &nbsp;\r\n          </td>\r\n        </tr>\r\n\r\n        <!-- Social Media -->\r\n        <tr ng-repeat=\"social in profileCtrl.user.profile.socialMedia track by $index\"\r\n            ng-class=\"{ 'edit-highlight': socialLinkForm.$visible || socialTypeForm.$visible}\">\r\n          <td>\r\n            <i class=\"fa fa-facebook fa-fw\" ng-show=\"social.type == 'Facebook'\"></i>\r\n            <i class=\"fa fa-twitter fa-fw\" ng-show=\"social.type == 'Twitter'\"></i>\r\n            <i class=\"fa fa-instagram fa-fw\" ng-show=\"social.type == 'Instagram'\"></i>\r\n            <i class=\"fa fa-google-plus fa-fw\" ng-show=\"social.type == 'Google+'\"></i>\r\n            <i class=\"fa fa-linkedin fa-fw\" ng-show=\"social.type == 'LinkedIn'\"></i>\r\n          </td>\r\n          <td>\r\n            <span ng-if=\"profileCtrl.isForeignProfile\">\r\n              {{ social.type || 'empty' }}\r\n            </span>\r\n            <span ng-if=\"!profileCtrl.isForeignProfile\" inplace-edit-hover editable-select=\"social.type\"\r\n                  e-ng-options=\"t as t for t in profileCtrl.socialMediaTypes\"\r\n                  e-form=\"socialTypeForm\" ng-click=\"socialTypeForm.$show()\" ng-hide=\"socialTypeForm.$visible\"\r\n                  onaftersave=\"profileCtrl.saveChanges()\">\r\n              {{ social.type || 'enter here' }}\r\n            </span>\r\n          </td>\r\n          <td>\r\n            <span ng-if=\"profileCtrl.isForeignProfile\">\r\n              <b>{{ social.link || 'empty' }}</b>\r\n            </span>\r\n            <span ng-if=\"!profileCtrl.isForeignProfile\" inplace-edit-hover editable-text=\"social.link\"\r\n                  onaftersave=\"profileCtrl.saveChanges()\"\r\n                  e-form=\"socialLinkForm\" ng-click=\"socialLinkForm.$show()\" ng-hide=\"socialLinkForm.$visible\"><b>{{ social.link || 'enter here' }}</b></span>\r\n          </td>\r\n          <td>\r\n            <a ng-if=\"!profileCtrl.isForeignProfile\" class=\"btn btn-danger\" ng-hide=\"socialLinkForm.$visible\"\r\n               ng-click=\"profileCtrl.removeSocialMedia($index)\"><i class=\"fa fa-trash\"></i></a>\r\n          </td>\r\n        </tr>\r\n\r\n        <!-- ADD Social Media -->\r\n        <tr ng-if=\"!profileCtrl.isForeignProfile\">\r\n          <td colspan=\"4\">\r\n            <button class=\"btn btn-sm btn-primary\" ng-click=\"profileCtrl.addSocialMedia()\"><i class=\"fa fa-plus\"></i>\r\n              Add Social Media\r\n            </button>\r\n          </td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td colspan=\"4\">\r\n            <h3>About me</h3>\r\n            <hr/>\r\n          </td>\r\n        </tr>\r\n\r\n        <!-- About me -->\r\n        <tr ng-class=\"{ 'edit-highlight': aboutMeForm.$visible }\">\r\n          <td colspan=\"4\">\r\n            <p ng-if=\"profileCtrl.isForeignProfile\" ng-bind-html=\"profileCtrl.user.profile.about | newlineToHtml\"></p>\r\n            <p ng-if=\"!profileCtrl.isForeignProfile\" inplace-edit-hover style=\"background-color:inherit; border: 0px; padding:0px\" e-form=\"aboutMeForm\"\r\n                 onaftersave=\"profileCtrl.saveChanges()\"\r\n                 ng-click=\"aboutMeForm.$show()\" ng-hide=\"aboutMeForm.$visible\"\r\n                 editable-textarea=\"profileCtrl.user.profile.about\" e-rows=\"7\" e-cols=\"40\" ng-bind-html=\"profileCtrl.user.profile.about || 'no description' | newlineToHtml\"></p>\r\n          </td>\r\n        </tr>\r\n\r\n      </table>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProfilePictureUploadComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _profilePictureUpload = __webpack_require__(348);
	
	var _profilePictureUpload2 = _interopRequireDefault(_profilePictureUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ProfilePictureUploadComponent = exports.ProfilePictureUploadComponent = function () {
	  /*@ngInject*/
	  ProfilePictureUploadComponent.$inject = ['$timeout', 'Upload', '$state', 'User', 'Auth'];
	  function ProfilePictureUploadComponent($timeout, Upload, $state, User, Auth) {
	    _classCallCheck(this, ProfilePictureUploadComponent);
	
	    this.$timeout = $timeout;
	    this.$state = $state;
	    this.Upload = Upload;
	    this.UserService = User;
	    this.Auth = Auth;
	  }
	
	  _createClass(ProfilePictureUploadComponent, [{
	    key: 'upload',
	    value: function upload(dataUrl, name) {
	      var _this = this;
	
	      var gotoProfile = function gotoProfile() {
	        _this.$state.go("profile");
	      };
	
	      this.Upload.upload({
	        url: '/api/storage',
	        data: {
	          name: name,
	          file: this.Upload.dataUrltoBlob(dataUrl, name),
	          creationUser: this.Auth.getCurrentUserSync()._id
	        }
	      }).then(function (res) {
	
	        var user = _this.Auth.getCurrentUserSync();
	        user.profile.picture = res.data;
	
	        _this.UserService.update(user, function (user) {
	          gotoProfile();
	        }, function (err) {
	          alert('Could not set profile picture.');
	        });
	      }, function (err) {
	        alert('Could not upload profile image.');
	      });
	    }
	  }]);
	
	  return ProfilePictureUploadComponent;
	}();
	
	exports.default = angular.module('conduuApp.profile-picture-upload', [uiRouter]).config(_profilePictureUpload2.default).component('profilePictureUpload', {
	  template: __webpack_require__(349),
	  controller: ProfilePictureUploadComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('profile-picture-upload', {
	    url: '/profile-picture-upload',
	    template: '<profile-picture-upload></profile-picture-upload>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n\r\n      <h1>Profile Picture</h1>\r\n\r\n      <img ng-show=\"ctrl.picFile\" ng-src=\"{{ctrl.croppedDataUrl}}\" style=\"width:128px\"/>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <h2>Profile Picture Settings</h2>\r\n\r\n        <form name=\"myForm\">\r\n\r\n          <br />\r\n\r\n          <div class=\"alert alert-info\">\r\n            1. Select the image you want to use as your profile picture, by click on the \"Select Picture\" button.\r\n          </div>\r\n\r\n          <button class=\"btn btn-primary\" ngf-select ng-model=\"ctrl.picFile\" accept=\"image/*\">\r\n            Select Picture\r\n          </button>\r\n\r\n          <br />\r\n          <br />\r\n\r\n          <div ng-show=\"ctrl.picFile\" class=\"alert alert-info\">\r\n            2. Select the part of the image, you want to use as your new profile picture.\r\n          </div>\r\n\r\n          <div ng-show=\"ctrl.picFile\" ngf-drop ng-model=\"ctrl.picFile\" ngf-pattern=\"image/*\"\r\n               class=\"cropArea\">\r\n            <img-crop image=\"ctrl.picFile | ngfDataUrl\"\r\n                      result-image=\"ctrl.croppedDataUrl\" ng-init=\"ctrl.croppedDataUrl=''\">\r\n            </img-crop>\r\n          </div>\r\n        </form>\r\n\r\n        <br />\r\n\r\n        <div ng-show=\"ctrl.picFile\" class=\"alert alert-info\">\r\n          3. Save the new profile picture by clicking \"Save Changes\"\r\n        </div>\r\n\r\n        <button class=\"btn btn-primary btn-sm\" ng-click=\"ctrl.upload(ctrl.croppedDataUrl, ctrl.picFile.name)\">\r\n          Save Changes\r\n        </button>\r\n\r\n        <button class=\"btn btn-warning btn-sm\" ui-sref=\"profile\">Dissmiss Changes</button>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @namespace Chart
	 */
	var Chart = __webpack_require__(351)();
	
	__webpack_require__(352)(Chart);
	__webpack_require__(358)(Chart);
	__webpack_require__(360)(Chart);
	__webpack_require__(361)(Chart);
	__webpack_require__(362)(Chart);
	__webpack_require__(363)(Chart);
	__webpack_require__(364)(Chart);
	__webpack_require__(365)(Chart);
	__webpack_require__(366)(Chart);
	__webpack_require__(367)(Chart);
	__webpack_require__(368)(Chart);
	__webpack_require__(369)(Chart);
	__webpack_require__(370)(Chart);
	__webpack_require__(371)(Chart);
	
	__webpack_require__(372)(Chart);
	__webpack_require__(373)(Chart);
	__webpack_require__(374)(Chart);
	__webpack_require__(375)(Chart);
	
	__webpack_require__(376)(Chart);
	__webpack_require__(377)(Chart);
	__webpack_require__(378)(Chart);
	__webpack_require__(379)(Chart);
	__webpack_require__(380)(Chart);
	__webpack_require__(381)(Chart);
	
	// Controllers must be loaded after elements
	// See Chart.core.datasetController.dataElementType
	__webpack_require__(382)(Chart);
	__webpack_require__(383)(Chart);
	__webpack_require__(384)(Chart);
	__webpack_require__(385)(Chart);
	__webpack_require__(386)(Chart);
	__webpack_require__(387)(Chart);
	
	__webpack_require__(388)(Chart);
	__webpack_require__(389)(Chart);
	__webpack_require__(390)(Chart);
	__webpack_require__(391)(Chart);
	__webpack_require__(392)(Chart);
	__webpack_require__(393)(Chart);
	__webpack_require__(394)(Chart);
	
	// Loading built-it plugins
	var plugins = [];
	
	plugins.push(
	    __webpack_require__(395)(Chart),
	    __webpack_require__(396)(Chart),
	    __webpack_require__(397)(Chart)
	);
	
	Chart.plugins.register(plugins);
	
	module.exports = Chart;
	if (typeof window !== 'undefined') {
		window.Chart = Chart;
	}


/***/ }),
/* 351 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function() {
	
		// Occupy the global variable of Chart, and create a simple base class
		var Chart = function(item, config) {
			this.construct(item, config);
			return this;
		};
	
		// Globally expose the defaults to allow for user updating/changing
		Chart.defaults = {
			global: {
				responsive: true,
				responsiveAnimationDuration: 0,
				maintainAspectRatio: true,
				events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
				hover: {
					onHover: null,
					mode: 'nearest',
					intersect: true,
					animationDuration: 400
				},
				onClick: null,
				defaultColor: 'rgba(0,0,0,0.1)',
				defaultFontColor: '#666',
				defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
				defaultFontSize: 12,
				defaultFontStyle: 'normal',
				showLines: true,
	
				// Element defaults defined in element extensions
				elements: {},
	
				// Legend callback string
				legendCallback: function(chart) {
					var text = [];
					text.push('<ul class="' + chart.id + '-legend">');
					for (var i = 0; i < chart.data.datasets.length; i++) {
						text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
						if (chart.data.datasets[i].label) {
							text.push(chart.data.datasets[i].label);
						}
						text.push('</li>');
					}
					text.push('</ul>');
	
					return text.join('');
				}
			}
		};
	
		Chart.Chart = Chart;
	
		return Chart;
	};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	/* global window: false */
	/* global document: false */
	'use strict';
	
	var color = __webpack_require__(353);
	
	module.exports = function(Chart) {
		// Global Chart helpers object for utility methods and classes
		var helpers = Chart.helpers = {};
	
		// -- Basic js utility methods
		helpers.each = function(loopable, callback, self, reverse) {
			// Check to see if null or undefined firstly.
			var i, len;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						callback.call(self, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						callback.call(self, loopable[i], i);
					}
				}
			} else if (typeof loopable === 'object') {
				var keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					callback.call(self, loopable[keys[i]], keys[i]);
				}
			}
		};
		helpers.clone = function(obj) {
			var objClone = {};
			helpers.each(obj, function(value, key) {
				if (helpers.isArray(value)) {
					objClone[key] = value.slice(0);
				} else if (typeof value === 'object' && value !== null) {
					objClone[key] = helpers.clone(value);
				} else {
					objClone[key] = value;
				}
			});
			return objClone;
		};
		helpers.extend = function(base) {
			var setFn = function(value, key) {
				base[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; i++) {
				helpers.each(arguments[i], setFn);
			}
			return base;
		};
		// Need a special merge function to chart configs since they are now grouped
		helpers.configMerge = function(_base) {
			var base = helpers.clone(_base);
			helpers.each(Array.prototype.slice.call(arguments, 1), function(extension) {
				helpers.each(extension, function(value, key) {
					var baseHasProperty = base.hasOwnProperty(key);
					var baseVal = baseHasProperty ? base[key] : {};
	
					if (key === 'scales') {
						// Scale config merging is complex. Add our own function here for that
						base[key] = helpers.scaleMerge(baseVal, value);
					} else if (key === 'scale') {
						// Used in polar area & radar charts since there is only one scale
						base[key] = helpers.configMerge(baseVal, Chart.scaleService.getScaleDefaults(value.type), value);
					} else if (baseHasProperty
							&& typeof baseVal === 'object'
							&& !helpers.isArray(baseVal)
							&& baseVal !== null
							&& typeof value === 'object'
							&& !helpers.isArray(value)) {
						// If we are overwriting an object with an object, do a merge of the properties.
						base[key] = helpers.configMerge(baseVal, value);
					} else {
						// can just overwrite the value in this case
						base[key] = value;
					}
				});
			});
	
			return base;
		};
		helpers.scaleMerge = function(_base, extension) {
			var base = helpers.clone(_base);
	
			helpers.each(extension, function(value, key) {
				if (key === 'xAxes' || key === 'yAxes') {
					// These properties are arrays of items
					if (base.hasOwnProperty(key)) {
						helpers.each(value, function(valueObj, index) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							var axisDefaults = Chart.scaleService.getScaleDefaults(axisType);
							if (index >= base[key].length || !base[key][index].type) {
								base[key].push(helpers.configMerge(axisDefaults, valueObj));
							} else if (valueObj.type && valueObj.type !== base[key][index].type) {
								// Type changed. Bring in the new defaults before we bring in valueObj so that valueObj can override the correct scale defaults
								base[key][index] = helpers.configMerge(base[key][index], axisDefaults, valueObj);
							} else {
								// Type is the same
								base[key][index] = helpers.configMerge(base[key][index], valueObj);
							}
						});
					} else {
						base[key] = [];
						helpers.each(value, function(valueObj) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							base[key].push(helpers.configMerge(Chart.scaleService.getScaleDefaults(axisType), valueObj));
						});
					}
				} else if (base.hasOwnProperty(key) && typeof base[key] === 'object' && base[key] !== null && typeof value === 'object') {
					// If we are overwriting an object with an object, do a merge of the properties.
					base[key] = helpers.configMerge(base[key], value);
	
				} else {
					// can just overwrite the value in this case
					base[key] = value;
				}
			});
	
			return base;
		};
		helpers.getValueAtIndexOrDefault = function(value, index, defaultValue) {
			if (value === undefined || value === null) {
				return defaultValue;
			}
	
			if (helpers.isArray(value)) {
				return index < value.length ? value[index] : defaultValue;
			}
	
			return value;
		};
		helpers.getValueOrDefault = function(value, defaultValue) {
			return value === undefined ? defaultValue : value;
		};
		helpers.indexOf = Array.prototype.indexOf?
			function(array, item) {
				return array.indexOf(item);
			}:
			function(array, item) {
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (array[i] === item) {
						return i;
					}
				}
				return -1;
			};
		helpers.where = function(collection, filterCallback) {
			if (helpers.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers.findIndex = Array.prototype.findIndex?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.inherits = function(extensions) {
			// Basic javascript inheritance based on the model created in Backbone.js
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
	
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
	
			return ChartElement;
		};
		helpers.noop = function() {};
		helpers.uid = (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}());
		// -- Math methods
		helpers.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
		};
		helpers.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers.sign = Math.sign?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers.log10 = Math.log10?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				return Math.log(x) / Math.LN10;
			};
		helpers.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x,
				distanceFromYCenter = anglePoint.y - centrePoint.y,
				radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
		helpers.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint,
				current = middlePoint,
				next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers.EPSILON = Number.EPSILON || 1e-14;
		helpers.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers.niceNum = function(range, round) {
			var exponent = Math.floor(helpers.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Easing functions adapted from Robert Penner's easing equations
		// http://www.robertpenner.com/easing/
		var easingEffects = helpers.easingEffects = {
			linear: function(t) {
				return t;
			},
			easeInQuad: function(t) {
				return t * t;
			},
			easeOutQuad: function(t) {
				return -1 * t * (t - 2);
			},
			easeInOutQuad: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t;
				}
				return -1 / 2 * ((--t) * (t - 2) - 1);
			},
			easeInCubic: function(t) {
				return t * t * t;
			},
			easeOutCubic: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t + 1);
			},
			easeInOutCubic: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t + 2);
			},
			easeInQuart: function(t) {
				return t * t * t * t;
			},
			easeOutQuart: function(t) {
				return -1 * ((t = t / 1 - 1) * t * t * t - 1);
			},
			easeInOutQuart: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t;
				}
				return -1 / 2 * ((t -= 2) * t * t * t - 2);
			},
			easeInQuint: function(t) {
				return 1 * (t /= 1) * t * t * t * t;
			},
			easeOutQuint: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t * t * t + 1);
			},
			easeInOutQuint: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t * t * t + 2);
			},
			easeInSine: function(t) {
				return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1;
			},
			easeOutSine: function(t) {
				return 1 * Math.sin(t / 1 * (Math.PI / 2));
			},
			easeInOutSine: function(t) {
				return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1);
			},
			easeInExpo: function(t) {
				return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1));
			},
			easeOutExpo: function(t) {
				return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1);
			},
			easeInOutExpo: function(t) {
				if (t === 0) {
					return 0;
				}
				if (t === 1) {
					return 1;
				}
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * Math.pow(2, 10 * (t - 1));
				}
				return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
			},
			easeInCirc: function(t) {
				if (t >= 1) {
					return t;
				}
				return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1);
			},
			easeOutCirc: function(t) {
				return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t);
			},
			easeInOutCirc: function(t) {
				if ((t /= 1 / 2) < 1) {
					return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
				}
				return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
			},
			easeInElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
			},
			easeOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1;
			},
			easeInOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1 / 2) === 2) {
					return 1;
				}
				if (!p) {
					p = 1 * (0.3 * 1.5);
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				if (t < 1) {
					return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
				}
				return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
			},
			easeInBack: function(t) {
				var s = 1.70158;
				return 1 * (t /= 1) * t * ((s + 1) * t - s);
			},
			easeOutBack: function(t) {
				var s = 1.70158;
				return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1);
			},
			easeInOutBack: function(t) {
				var s = 1.70158;
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s));
				}
				return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
			},
			easeInBounce: function(t) {
				return 1 - easingEffects.easeOutBounce(1 - t);
			},
			easeOutBounce: function(t) {
				if ((t /= 1) < (1 / 2.75)) {
					return 1 * (7.5625 * t * t);
				} else if (t < (2 / 2.75)) {
					return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75);
				} else if (t < (2.5 / 2.75)) {
					return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375);
				}
				return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375);
			},
			easeInOutBounce: function(t) {
				if (t < 1 / 2) {
					return easingEffects.easeInBounce(t * 2) * 0.5;
				}
				return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5;
			}
		};
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt,
				canvas = evt.currentTarget || evt.srcElement,
				boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
		helpers.addEvent = function(node, eventType, method) {
			if (node.addEventListener) {
				node.addEventListener(eventType, method);
			} else if (node.attachEvent) {
				node.attachEvent('on' + eventType, method);
			} else {
				node['on' + eventType] = method;
			}
		};
		helpers.removeEvent = function(node, eventType, handler) {
			if (node.removeEventListener) {
				node.removeEventListener(eventType, handler, false);
			} else if (node.detachEvent) {
				node.detachEvent('on' + eventType, handler);
			} else {
				node['on' + eventType] = helpers.noop;
			}
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof(styleValue) === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = domNode.parentNode;
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		helpers.getMaximumWidth = function(domNode) {
			var container = domNode.parentNode;
			var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
			var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
			var w = container.clientWidth - paddingLeft - paddingRight;
			var cw = helpers.getConstraintWidth(domNode);
			return isNaN(cw)? w : Math.min(w, cw);
		};
		helpers.getMaximumHeight = function(domNode) {
			var container = domNode.parentNode;
			var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
			var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
			var h = container.clientHeight - paddingTop - paddingBottom;
			var ch = helpers.getConstraintHeight(domNode);
			return isNaN(ch)? h : Math.min(h, ch);
		};
		helpers.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers.retinaScale = function(chart) {
			var pixelRatio = chart.currentDevicePixelRatio = window.devicePixelRatio || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		};
		// -- Canvas methods
		helpers.clear = function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		};
		helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
					longest = helpers.measureText(ctx, data, gc, longest, thing);
				} else if (helpers.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
							longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers.each(arrayOfThings, function(thing) {
				if (helpers.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
		helpers.drawRoundedRectangle = function(ctx, x, y, width, height, radius) {
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
		};
	
		helpers.color = !color?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = Chart.defaults.global.defaultColor;
				}
	
				return color(value);
			};
	
		helpers.isArray = Array.isArray?
			function(obj) {
				return Array.isArray(obj);
			} :
			function(obj) {
				return Object.prototype.toString.call(obj) === '[object Array]';
			};
		// ! @see http://stackoverflow.com/a/14853974
		helpers.arrayEquals = function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen=a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		};
		helpers.callback = function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				fn.apply(thisArg, args);
			}
		};
		helpers.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern) ?
				colorValue :
				helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	
		/**
		 * Provided for backward compatibility, use Chart.helpers#callback instead.
		 * @function Chart.helpers#callCallback
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 */
		helpers.callCallback = helpers.callback;
	};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(354);
	var string = __webpack_require__(356);
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = string.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = string.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = string.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return string.hexString(this.values.rgb);
		},
		rgbString: function () {
			return string.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return string.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return string.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return string.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return string.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return string.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return string.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = convert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	module.exports = Color;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(355);
	
	var convert = function() {
	   return new Converter();
	}
	
	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);
	
	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];
	
	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};
	
	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword
	
	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}
	
	
	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};
	
	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }
	
	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};
	
	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);
	
	      this.convs[space] = vals;
	   }
	  return vals;
	};
	
	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   }
	});
	
	module.exports = convert;

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	/* MIT license */
	
	module.exports = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,
	
	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,
	
	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,
	
	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,
	
	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,
	
	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,
	
	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,
	
	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,
	
	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	}
	
	
	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  l = (min + max) / 2;
	
	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;
	
	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  v = ((max / 255) * 1000) / 10;
	
	  return [h, s, v];
	}
	
	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));
	
	  return [h, w * 100, b * 100];
	}
	
	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}
	
	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}
	
	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
	  return [x * 100, y *100, z * 100];
	}
	
	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}
	
	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;
	
	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}
	
	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}
	
	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}
	
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}
	
	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}
	
	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;
	
	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }
	
	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation
	
	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}
	
	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}
	
	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}
	
	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}
	
	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}
	
	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}
	
	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}
	
	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}
	
	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}
	
	
	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;
	
	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);
	
	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);
	
	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}
	
	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;
	
	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);
	
	  return [x, y, z];
	}
	
	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}
	
	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}
	
	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}
	
	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}
	
	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}
	
	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}
	
	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}
	
	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}
	
	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}
	
	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}
	
	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}
	
	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}
	
	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(357);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3})$/,
	       hex =  /^#([a-fA-F0-9]{6})$/,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr);
	   if (match) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	   }
	   else if (match = string.match(hex)) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgb) {
	   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
	              + hexDouble(rgb[2]);
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ }),
/* 357 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// By default, select the browser (DOM) platform.
	// @TODO Make possible to select another platform at build time.
	var implementation = __webpack_require__(359);
	
	module.exports = function(Chart) {
		/**
		 * @namespace Chart.platform
		 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
		 * @since 2.4.0
		 */
		Chart.platform = {
			/**
			 * Called at chart construction time, returns a context2d instance implementing
			 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
			 * @param {*} item - The native item from which to acquire context (platform specific)
			 * @param {Object} options - The chart options
			 * @returns {CanvasRenderingContext2D} context2d instance
			 */
			acquireContext: function() {},
	
			/**
			 * Called at chart destruction time, releases any resources associated to the context
			 * previously returned by the acquireContext() method.
			 * @param {CanvasRenderingContext2D} context - The context2d instance
			 * @returns {Boolean} true if the method succeeded, else false
			 */
			releaseContext: function() {},
	
			/**
			 * Registers the specified listener on the given chart.
			 * @param {Chart} chart - Chart from which to listen for event
			 * @param {String} type - The ({@link IEvent}) type to listen for
			 * @param {Function} listener - Receives a notification (an object that implements
			 * the {@link IEvent} interface) when an event of the specified type occurs.
			 */
			addEventListener: function() {},
	
			/**
			 * Removes the specified listener previously registered with addEventListener.
			 * @param {Chart} chart -Chart from which to remove the listener
			 * @param {String} type - The ({@link IEvent}) type to remove
			 * @param {Function} listener - The listener function to remove from the event target.
			 */
			removeEventListener: function() {}
		};
	
		/**
		 * @interface IPlatform
		 * Allows abstracting platform dependencies away from the chart
		 * @borrows Chart.platform.acquireContext as acquireContext
		 * @borrows Chart.platform.releaseContext as releaseContext
		 * @borrows Chart.platform.addEventListener as addEventListener
		 * @borrows Chart.platform.removeEventListener as removeEventListener
		 */
	
		/**
		 * @interface IEvent
		 * @prop {String} type - The event type name, possible values are:
		 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
		 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
		 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
		 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
		 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
		 */
	
		Chart.helpers.extend(Chart.platform, implementation(Chart));
	};


/***/ }),
/* 359 */
/***/ (function(module, exports) {

	'use strict';
	
	// Chart.Platform implementation for targeting a web browser
	module.exports = function(Chart) {
		var helpers = Chart.helpers;
	
		// DOM event types -> Chart.js event types.
		// Note: only events with different types are mapped.
		// https://developer.mozilla.org/en-US/docs/Web/Events
		var eventTypeMap = {
			// Touch events
			touchstart: 'mousedown',
			touchmove: 'mousemove',
			touchend: 'mouseup',
	
			// Pointer events
			pointerenter: 'mouseenter',
			pointerdown: 'mousedown',
			pointermove: 'mousemove',
			pointerup: 'mouseup',
			pointerleave: 'mouseout',
			pointerout: 'mouseout'
		};
	
		/**
		 * The "used" size is the final value of a dimension property after all calculations have
		 * been performed. This method uses the computed style of `element` but returns undefined
		 * if the computed style is not expressed in pixels. That can happen in some cases where
		 * `element` has a size relative to its parent and this last one is not yet displayed,
		 * for example because of `display: none` on a parent node.
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
		 * @returns {Number} Size in pixels or undefined if unknown.
		 */
		function readUsedSize(element, property) {
			var value = helpers.getStyle(element, property);
			var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
			return matches? Number(matches[1]) : undefined;
		}
	
		/**
		 * Initializes the canvas style and render size without modifying the canvas display size,
		 * since responsiveness is handled by the controller.resize() method. The config is used
		 * to determine the aspect ratio to apply in case no explicit height has been specified.
		 */
		function initCanvas(canvas, config) {
			var style = canvas.style;
	
			// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
			// returns null or '' if no explicit value has been set to the canvas attribute.
			var renderHeight = canvas.getAttribute('height');
			var renderWidth = canvas.getAttribute('width');
	
			// Chart.js modifies some canvas values that we want to restore on destroy
			canvas._chartjs = {
				initial: {
					height: renderHeight,
					width: renderWidth,
					style: {
						display: style.display,
						height: style.height,
						width: style.width
					}
				}
			};
	
			// Force canvas to display as block to avoid extra space caused by inline
			// elements, which would interfere with the responsive resize process.
			// https://github.com/chartjs/Chart.js/issues/2538
			style.display = style.display || 'block';
	
			if (renderWidth === null || renderWidth === '') {
				var displayWidth = readUsedSize(canvas, 'width');
				if (displayWidth !== undefined) {
					canvas.width = displayWidth;
				}
			}
	
			if (renderHeight === null || renderHeight === '') {
				if (canvas.style.height === '') {
					// If no explicit render height and style height, let's apply the aspect ratio,
					// which one can be specified by the user but also by charts as default option
					// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
					canvas.height = canvas.width / (config.options.aspectRatio || 2);
				} else {
					var displayHeight = readUsedSize(canvas, 'height');
					if (displayWidth !== undefined) {
						canvas.height = displayHeight;
					}
				}
			}
	
			return canvas;
		}
	
		function createEvent(type, chart, x, y, nativeEvent) {
			return {
				type: type,
				chart: chart,
				native: nativeEvent || null,
				x: x !== undefined? x : null,
				y: y !== undefined? y : null,
			};
		}
	
		function fromNativeEvent(event, chart) {
			var type = eventTypeMap[event.type] || event.type;
			var pos = helpers.getRelativePosition(event, chart);
			return createEvent(type, chart, pos.x, pos.y, event);
		}
	
		function createResizer(handler) {
			var iframe = document.createElement('iframe');
			iframe.className = 'chartjs-hidden-iframe';
			iframe.style.cssText =
				'display:block;'+
				'overflow:hidden;'+
				'border:0;'+
				'margin:0;'+
				'top:0;'+
				'left:0;'+
				'bottom:0;'+
				'right:0;'+
				'height:100%;'+
				'width:100%;'+
				'position:absolute;'+
				'pointer-events:none;'+
				'z-index:-1;';
	
			// Prevent the iframe to gain focus on tab.
			// https://github.com/chartjs/Chart.js/issues/3090
			iframe.tabIndex = -1;
	
			// If the iframe is re-attached to the DOM, the resize listener is removed because the
			// content is reloaded, so make sure to install the handler after the iframe is loaded.
			// https://github.com/chartjs/Chart.js/issues/3521
			helpers.addEvent(iframe, 'load', function() {
				helpers.addEvent(iframe.contentWindow || iframe, 'resize', handler);
	
				// The iframe size might have changed while loading, which can also
				// happen if the size has been changed while detached from the DOM.
				handler();
			});
	
			return iframe;
		}
	
		function addResizeListener(node, listener, chart) {
			var stub = node._chartjs = {
				ticking: false
			};
	
			// Throttle the callback notification until the next animation frame.
			var notify = function() {
				if (!stub.ticking) {
					stub.ticking = true;
					helpers.requestAnimFrame.call(window, function() {
						if (stub.resizer) {
							stub.ticking = false;
							return listener(createEvent('resize', chart));
						}
					});
				}
			};
	
			// Let's keep track of this added iframe and thus avoid DOM query when removing it.
			stub.resizer = createResizer(notify);
	
			node.insertBefore(stub.resizer, node.firstChild);
		}
	
		function removeResizeListener(node) {
			if (!node || !node._chartjs) {
				return;
			}
	
			var resizer = node._chartjs.resizer;
			if (resizer) {
				resizer.parentNode.removeChild(resizer);
				node._chartjs.resizer = null;
			}
	
			delete node._chartjs;
		}
	
		return {
			acquireContext: function(item, config) {
				if (typeof item === 'string') {
					item = document.getElementById(item);
				} else if (item.length) {
					// Support for array based queries (such as jQuery)
					item = item[0];
				}
	
				if (item && item.canvas) {
					// Support for any object associated to a canvas (including a context2d)
					item = item.canvas;
				}
	
				// To prevent canvas fingerprinting, some add-ons undefine the getContext
				// method, for example: https://github.com/kkapsner/CanvasBlocker
				// https://github.com/chartjs/Chart.js/issues/2807
				var context = item && item.getContext && item.getContext('2d');
	
				// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
				// inside an iframe or when running in a protected environment. We could guess the
				// types from their toString() value but let's keep things flexible and assume it's
				// a sufficient condition if the item has a context2D which has item as `canvas`.
				// https://github.com/chartjs/Chart.js/issues/3887
				// https://github.com/chartjs/Chart.js/issues/4102
				// https://github.com/chartjs/Chart.js/issues/4152
				if (context && context.canvas === item) {
					initCanvas(item, config);
					return context;
				}
	
				return null;
			},
	
			releaseContext: function(context) {
				var canvas = context.canvas;
				if (!canvas._chartjs) {
					return;
				}
	
				var initial = canvas._chartjs.initial;
				['height', 'width'].forEach(function(prop) {
					var value = initial[prop];
					if (value === undefined || value === null) {
						canvas.removeAttribute(prop);
					} else {
						canvas.setAttribute(prop, value);
					}
				});
	
				helpers.each(initial.style || {}, function(value, key) {
					canvas.style[key] = value;
				});
	
				// The canvas render size might have been changed (and thus the state stack discarded),
				// we can't use save() and restore() to restore the initial state. So make sure that at
				// least the canvas context is reset to the default state by setting the canvas width.
				// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
				canvas.width = canvas.width;
	
				delete canvas._chartjs;
			},
	
			addEventListener: function(chart, type, listener) {
				var canvas = chart.canvas;
				if (type === 'resize') {
					// Note: the resize event is not supported on all browsers.
					addResizeListener(canvas.parentNode, listener, chart);
					return;
				}
	
				var stub = listener._chartjs || (listener._chartjs = {});
				var proxies = stub.proxies || (stub.proxies = {});
				var proxy = proxies[chart.id + '_' + type] = function(event) {
					listener(fromNativeEvent(event, chart));
				};
	
				helpers.addEvent(canvas, type, proxy);
			},
	
			removeEventListener: function(chart, type, listener) {
				var canvas = chart.canvas;
				if (type === 'resize') {
					// Note: the resize event is not supported on all browsers.
					removeResizeListener(canvas.parentNode, listener);
					return;
				}
	
				var stub = listener._chartjs || {};
				var proxies = stub.proxies || {};
				var proxy = proxies[chart.id + '_' + type];
				if (!proxy) {
					return;
				}
	
				helpers.removeEvent(canvas, type, proxy);
			}
		};
	};


/***/ }),
/* 360 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		// Global Chart canvas helpers object for drawing items to canvas
		var helpers = Chart.canvasHelpers = {};
	
		helpers.drawPoint = function(ctx, pointStyle, radius, x, y) {
			var type, edgeLength, xOffset, yOffset, height, size;
	
			if (typeof pointStyle === 'object') {
				type = pointStyle.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(pointStyle, x - pointStyle.width / 2, y - pointStyle.height / 2, pointStyle.width, pointStyle.height);
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			switch (pointStyle) {
			// Default includes circle
			default:
				ctx.beginPath();
				ctx.arc(x, y, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'triangle':
				ctx.beginPath();
				edgeLength = 3 * radius / Math.sqrt(3);
				height = edgeLength * Math.sqrt(3) / 2;
				ctx.moveTo(x - edgeLength / 2, y + height / 3);
				ctx.lineTo(x + edgeLength / 2, y + height / 3);
				ctx.lineTo(x, y - 2 * height / 3);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rect':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
				ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
				break;
			case 'rectRounded':
				var offset = radius / Math.SQRT2;
				var leftX = x - offset;
				var topY = y - offset;
				var sideSize = Math.SQRT2 * radius;
				Chart.helpers.drawRoundedRectangle(ctx, leftX, topY, sideSize, sideSize, radius / 2);
				ctx.fill();
				break;
			case 'rectRot':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.moveTo(x - size, y);
				ctx.lineTo(x, y + size);
				ctx.lineTo(x + size, y);
				ctx.lineTo(x, y - size);
				ctx.closePath();
				ctx.fill();
				break;
			case 'cross':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'crossRot':
				ctx.beginPath();
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'star':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'line':
				ctx.beginPath();
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'dash':
				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			}
	
			ctx.stroke();
		};
	
		helpers.clipArea = function(ctx, clipArea) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(clipArea.left, clipArea.top, clipArea.right - clipArea.left, clipArea.bottom - clipArea.top);
			ctx.clip();
		};
	
		helpers.unclipArea = function(ctx) {
			ctx.restore();
		};
	
		helpers.lineTo = function(ctx, previous, target, flip) {
			if (target.steppedLine) {
				if (target.steppedLine === 'after') {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip? previous.controlPointPreviousX : previous.controlPointNextX,
				flip? previous.controlPointPreviousY : previous.controlPointNextY,
				flip? target.controlPointNextX : target.controlPointPreviousX,
				flip? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		};
	
		Chart.helpers.canvas = helpers;
	};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var color = __webpack_require__(353);
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		function interpolate(start, view, model, ease) {
			var keys = Object.keys(model);
			var i, ilen, key, actual, origin, target, type, c0, c1;
	
			for (i=0, ilen=keys.length; i<ilen; ++i) {
				key = keys[i];
	
				target = model[key];
	
				// if a value is added to the model after pivot() has been called, the view
				// doesn't contain it, so let's initialize the view to the target value.
				if (!view.hasOwnProperty(key)) {
					view[key] = target;
				}
	
				actual = view[key];
	
				if (actual === target || key[0] === '_') {
					continue;
				}
	
				if (!start.hasOwnProperty(key)) {
					start[key] = actual;
				}
	
				origin = start[key];
	
				type = typeof(target);
	
				if (type === typeof(origin)) {
					if (type === 'string') {
						c0 = color(origin);
						if (c0.valid) {
							c1 = color(target);
							if (c1.valid) {
								view[key] = c1.mix(c0, ease).rgbString();
								continue;
							}
						}
					} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
						view[key] = origin + (target - origin) * ease;
						continue;
					}
				}
	
				view[key] = target;
			}
		}
	
		Chart.elements = {};
	
		Chart.Element = function(configuration) {
			helpers.extend(this, configuration);
			this.initialize.apply(this, arguments);
		};
	
		helpers.extend(Chart.Element.prototype, {
	
			initialize: function() {
				this.hidden = false;
			},
	
			pivot: function() {
				var me = this;
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
				me._start = {};
				return me;
			},
	
			transition: function(ease) {
				var me = this;
				var model = me._model;
				var start = me._start;
				var view = me._view;
	
				// No animation -> No Transition
				if (!model || ease === 1) {
					me._view = model;
					me._start = null;
					return me;
				}
	
				if (!view) {
					view = me._view = {};
				}
	
				if (!start) {
					start = me._start = {};
				}
	
				interpolate(start, view, model, ease);
	
				return me;
			},
	
			tooltipPosition: function() {
				return {
					x: this._model.x,
					y: this._model.y
				};
			},
	
			hasValue: function() {
				return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
			}
		});
	
		Chart.Element.extend = helpers.inherits;
	};


/***/ }),
/* 362 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.plugins = {};
	
		/**
		 * The plugin service singleton
		 * @namespace Chart.plugins
		 * @since 2.1.0
		 */
		Chart.plugins = {
			/**
			 * Globally registered plugins.
			 * @private
			 */
			_plugins: [],
	
			/**
			 * This identifier is used to invalidate the descriptors cache attached to each chart
			 * when a global plugin is registered or unregistered. In this case, the cache ID is
			 * incremented and descriptors are regenerated during following API calls.
			 * @private
			 */
			_cacheId: 0,
	
			/**
			 * Registers the given plugin(s) if not already registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			register: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					if (p.indexOf(plugin) === -1) {
						p.push(plugin);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Unregisters the given plugin(s) only if registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			unregister: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					var idx = p.indexOf(plugin);
					if (idx !== -1) {
						p.splice(idx, 1);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Remove all registered plugins.
			 * @since 2.1.5
			 */
			clear: function() {
				this._plugins = [];
				this._cacheId++;
			},
	
			/**
			 * Returns the number of registered plugins?
			 * @returns {Number}
			 * @since 2.1.5
			 */
			count: function() {
				return this._plugins.length;
			},
	
			/**
			 * Returns all registered plugin instances.
			 * @returns {Array} array of plugin objects.
			 * @since 2.1.5
			 */
			getAll: function() {
				return this._plugins;
			},
	
			/**
			 * Calls enabled plugins for `chart` on the specified hook and with the given args.
			 * This method immediately returns as soon as a plugin explicitly returns false. The
			 * returned value can be used, for instance, to interrupt the current action.
			 * @param {Object} chart - The chart instance for which plugins should be called.
			 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
			 * @param {Array} [args] - Extra arguments to apply to the hook call.
			 * @returns {Boolean} false if any of the plugins return false, else returns true.
			 */
			notify: function(chart, hook, args) {
				var descriptors = this.descriptors(chart);
				var ilen = descriptors.length;
				var i, descriptor, plugin, params, method;
	
				for (i=0; i<ilen; ++i) {
					descriptor = descriptors[i];
					plugin = descriptor.plugin;
					method = plugin[hook];
					if (typeof method === 'function') {
						params = [chart].concat(args || []);
						params.push(descriptor.options);
						if (method.apply(plugin, params) === false) {
							return false;
						}
					}
				}
	
				return true;
			},
	
			/**
			 * Returns descriptors of enabled plugins for the given chart.
			 * @returns {Array} [{ plugin, options }]
			 * @private
			 */
			descriptors: function(chart) {
				var cache = chart._plugins || (chart._plugins = {});
				if (cache.id === this._cacheId) {
					return cache.descriptors;
				}
	
				var plugins = [];
				var descriptors = [];
				var config = (chart && chart.config) || {};
				var defaults = Chart.defaults.global.plugins;
				var options = (config.options && config.options.plugins) || {};
	
				this._plugins.concat(config.plugins || []).forEach(function(plugin) {
					var idx = plugins.indexOf(plugin);
					if (idx !== -1) {
						return;
					}
	
					var id = plugin.id;
					var opts = options[id];
					if (opts === false) {
						return;
					}
	
					if (opts === true) {
						opts = helpers.clone(defaults[id]);
					}
	
					plugins.push(plugin);
					descriptors.push({
						plugin: plugin,
						options: opts || {}
					});
				});
	
				cache.descriptors = descriptors;
				cache.id = this._cacheId;
				return descriptors;
			}
		};
	
		/**
		 * Plugin extension hooks.
		 * @interface IPlugin
		 * @since 2.1.0
		 */
		/**
		 * @method IPlugin#beforeInit
		 * @desc Called before initializing `chart`.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterInit
		 * @desc Called after `chart` has been initialized and before the first update.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeUpdate
		 * @desc Called before updating `chart`. If any plugin returns `false`, the update
		 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart update.
		 */
		/**
		 * @method IPlugin#afterUpdate
		 * @desc Called after `chart` has been updated and before rendering. Note that this
		 * hook will not be called if the chart update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsUpdate
	 	 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
		 * the datasets update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} false to cancel the datasets update.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#afterDatasetsUpdate
		 * @desc Called after the `chart` datasets have been updated. Note that this hook
		 * will not be called if the datasets update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#beforeDatasetUpdate
	 	 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
		 * returns `false`, the datasets update is cancelled until another `update` is triggered.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Object} args.index - The dataset index.
		 * @param {Number} args.meta - The dataset metadata.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetUpdate
	 	 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
		 * that this hook will not be called if the datasets update has been previously cancelled.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Object} args.index - The dataset index.
		 * @param {Number} args.meta - The dataset metadata.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeLayout
		 * @desc Called before laying out `chart`. If any plugin returns `false`,
		 * the layout update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart layout.
		 */
		/**
		 * @method IPlugin#afterLayout
		 * @desc Called after the `chart` has been layed out. Note that this hook will not
		 * be called if the layout update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeRender
		 * @desc Called before rendering `chart`. If any plugin returns `false`,
		 * the rendering is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart rendering.
		 */
		/**
		 * @method IPlugin#afterRender
		 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
		 * that this hook will not be called if the rendering has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDraw
		 * @desc Called before drawing `chart` at every animation frame specified by the given
		 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
		 * another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart drawing.
		 */
		/**
		 * @method IPlugin#afterDraw
		 * @desc Called after the `chart` has been drawn for the specific easing value. Note
		 * that this hook will not be called if the drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsDraw
	 	 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
		 * the datasets drawing is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetsDraw
		 * @desc Called after the `chart` datasets have been drawn. Note that this hook
		 * will not be called if the datasets drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetDraw
	 	 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
		 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
		 * is cancelled until another `render` is triggered.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Object} args.index - The dataset index.
		 * @param {Number} args.meta - The dataset metadata.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetDraw
	 	 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
		 * (datasets are drawn in the reverse order). Note that this hook will not be called
		 * if the datasets drawing has been previously cancelled.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Object} args.index - The dataset index.
		 * @param {Number} args.meta - The dataset metadata.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeEvent
	 	 * @desc Called before processing the specified `event`. If any plugin returns `false`,
		 * the event will be discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterEvent
		 * @desc Called after the `event` has been consumed. Note that this hook
		 * will not be called if the `event` has been previously discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#resize
		 * @desc Called after the chart as been resized.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#destroy
		 * @desc Called after the chart as been destroyed.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
	
		/**
		 * Provided for backward compatibility, use Chart.plugins instead
		 * @namespace Chart.pluginService
		 * @deprecated since version 2.1.5
		 * @todo remove at version 3
		 * @private
		 */
		Chart.pluginService = Chart.plugins;
	
		/**
		 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
		 * effect, instead simply create/register plugins via plain JavaScript objects.
		 * @interface Chart.PluginBase
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.PluginBase = Chart.Element.extend({});
	};


/***/ }),
/* 363 */
/***/ (function(module, exports) {

	/* global window: false */
	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.animation = {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers.noop,
			onComplete: helpers.noop
		};
	
		Chart.Animation = Chart.Element.extend({
			chart: null, // the animation associated chart instance
			currentStep: 0, // the current animation step
			numSteps: 60, // default number of steps
			easing: '', // the easing to use for this animation
			render: null, // render function used by the animation service
	
			onAnimationProgress: null, // user specified callback to fire on each step of the animation
			onAnimationComplete: null, // user specified callback to fire when the animation finishes
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			request: null,
	
			/**
			 * @param {Chart} chart - The chart to animate.
			 * @param {Chart.Animation} animation - The animation that we will animate.
			 * @param {Number} duration - The animation duration in ms.
			 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
			 */
			addAnimation: function(chart, animation, duration, lazy) {
				var animations = this.animations;
				var i, ilen;
	
				animation.chart = chart;
	
				if (!lazy) {
					chart.animating = true;
				}
	
				for (i=0, ilen=animations.length; i < ilen; ++i) {
					if (animations[i].chart === chart) {
						animations[i] = animation;
						return;
					}
				}
	
				animations.push(animation);
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (animations.length === 1) {
					this.requestAnimationFrame();
				}
			},
	
			cancelAnimation: function(chart) {
				var index = helpers.findIndex(this.animations, function(animation) {
					return animation.chart === chart;
				});
	
				if (index !== -1) {
					this.animations.splice(index, 1);
					chart.animating = false;
				}
			},
	
			requestAnimationFrame: function() {
				var me = this;
				if (me.request === null) {
					// Skip animation frame requests until the active one is executed.
					// This can happen when processing mouse events, e.g. 'mousemove'
					// and 'mouseout' events will trigger multiple renders.
					me.request = helpers.requestAnimFrame.call(window, function() {
						me.request = null;
						me.startDigest();
					});
				}
			},
	
			/**
			 * @private
			 */
			startDigest: function() {
				var me = this;
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if (me.dropFrames > 1) {
					framesToDrop = Math.floor(me.dropFrames);
					me.dropFrames = me.dropFrames % 1;
				}
	
				me.advance(1 + framesToDrop);
	
				var endTime = Date.now();
	
				me.dropFrames += (endTime - startTime) / me.frameDuration;
	
				// Do we have more stuff to animate?
				if (me.animations.length > 0) {
					me.requestAnimationFrame();
				}
			},
	
			/**
			 * @private
			 */
			advance: function(count) {
				var animations = this.animations;
				var animation, chart;
				var i = 0;
	
				while (i < animations.length) {
					animation = animations[i];
					chart = animation.chart;
	
					animation.currentStep = (animation.currentStep || 0) + count;
					animation.currentStep = Math.min(animation.currentStep, animation.numSteps);
	
					helpers.callback(animation.render, [chart, animation], chart);
					helpers.callback(animation.onAnimationProgress, [animation], chart);
	
					if (animation.currentStep >= animation.numSteps) {
						helpers.callback(animation.onAnimationComplete, [animation], chart);
						chart.animating = false;
						animations.splice(i, 1);
					} else {
						++i;
					}
				}
			}
		};
	
		/**
		 * Provided for backward compatibility, use Chart.Animation instead
		 * @prop Chart.Animation#animationObject
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 */
		Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
			get: function() {
				return this;
			}
		});
	
		/**
		 * Provided for backward compatibility, use Chart.Animation#chart instead
		 * @prop Chart.Animation#chartInstance
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 */
		Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
			get: function() {
				return this.chart;
			},
			set: function(value) {
				this.chart = value;
			}
		});
	
	};


/***/ }),
/* 364 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var plugins = Chart.plugins;
		var platform = Chart.platform;
	
		// Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		// Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};
	
		/**
		 * Initializes the given config with global and chart default values.
		 */
		function initConfig(config) {
			config = config || {};
	
			// Do NOT use configMerge() for the data object because this method merges arrays
			// and so would change references to labels and datasets, preventing data updates.
			var data = config.data = config.data || {};
			data.datasets = data.datasets || [];
			data.labels = data.labels || [];
	
			config.options = helpers.configMerge(
				Chart.defaults.global,
				Chart.defaults[config.type],
				config.options || {});
	
			return config;
		}
	
		/**
		 * Updates the config of the chart
		 * @param chart {Chart} chart to update the options for
		 */
		function updateConfig(chart) {
			var newOptions = chart.options;
	
			// Update Scale(s) with options
			if (newOptions.scale) {
				chart.scale.options = newOptions.scale;
			} else if (newOptions.scales) {
				newOptions.scales.xAxes.concat(newOptions.scales.yAxes).forEach(function(scaleOptions) {
					chart.scales[scaleOptions.id].options = scaleOptions;
				});
			}
	
			// Tooltip
			chart.tooltip._options = newOptions.tooltips;
		}
	
		function positionIsHorizontal(position) {
			return position === 'top' || position === 'bottom';
		}
	
		helpers.extend(Chart.prototype, /** @lends Chart */ {
			/**
			 * @private
			 */
			construct: function(item, config) {
				var me = this;
	
				config = initConfig(config);
	
				var context = platform.acquireContext(item, config);
				var canvas = context && context.canvas;
				var height = canvas && canvas.height;
				var width = canvas && canvas.width;
	
				me.id = helpers.uid();
				me.ctx = context;
				me.canvas = canvas;
				me.config = config;
				me.width = width;
				me.height = height;
				me.aspectRatio = height? width / height : null;
				me.options = config.options;
				me._bufferedRender = false;
	
				/**
				 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
				 * the "instance" still need to be defined since it might be called from plugins.
				 * @prop Chart#chart
				 * @deprecated since version 2.6.0
				 * @todo remove at version 3
				 * @private
				 */
				me.chart = me;
				me.controller = me;  // chart.chart.controller #inception
	
				// Add the chart instance to the global namespace
				Chart.instances[me.id] = me;
	
				// Define alias to the config data: `chart.data === chart.config.data`
				Object.defineProperty(me, 'data', {
					get: function() {
						return me.config.data;
					},
					set: function(value) {
						me.config.data = value;
					}
				});
	
				if (!context || !canvas) {
					// The given item is not a compatible context2d element, let's return before finalizing
					// the chart initialization but after setting basic chart / controller properties that
					// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
					// https://github.com/chartjs/Chart.js/issues/2807
					console.error("Failed to create chart: can't acquire context from the given item");
					return;
				}
	
				me.initialize();
				me.update();
			},
	
			/**
			 * @private
			 */
			initialize: function() {
				var me = this;
	
				// Before init plugin notification
				plugins.notify(me, 'beforeInit');
	
				helpers.retinaScale(me);
	
				me.bindEvents();
	
				if (me.options.responsive) {
					// Initial resize before chart draws (must be silent to preserve initial animations).
					me.resize(true);
				}
	
				// Make sure scales have IDs and are built before we build any controllers.
				me.ensureScalesHaveIDs();
				me.buildScales();
				me.initToolTip();
	
				// After init plugin notification
				plugins.notify(me, 'afterInit');
	
				return me;
			},
	
			clear: function() {
				helpers.clear(this);
				return this;
			},
	
			stop: function() {
				// Stops any current animation loop occurring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
	
			resize: function(silent) {
				var me = this;
				var options = me.options;
				var canvas = me.canvas;
				var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
				// the canvas render width and height will be casted to integers so make sure that
				// the canvas display style uses the same integer values to avoid blurring effect.
				var newWidth = Math.floor(helpers.getMaximumWidth(canvas));
				var newHeight = Math.floor(aspectRatio? newWidth / aspectRatio : helpers.getMaximumHeight(canvas));
	
				if (me.width === newWidth && me.height === newHeight) {
					return;
				}
	
				canvas.width = me.width = newWidth;
				canvas.height = me.height = newHeight;
				canvas.style.width = newWidth + 'px';
				canvas.style.height = newHeight + 'px';
	
				helpers.retinaScale(me);
	
				if (!silent) {
					// Notify any plugins about the resize
					var newSize = {width: newWidth, height: newHeight};
					plugins.notify(me, 'resize', [newSize]);
	
					// Notify of resize
					if (me.options.onResize) {
						me.options.onResize(me, newSize);
					}
	
					me.stop();
					me.update(me.options.responsiveAnimationDuration);
				}
			},
	
			ensureScalesHaveIDs: function() {
				var options = this.options;
				var scalesOptions = options.scales || {};
				var scaleOptions = options.scale;
	
				helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
					xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
				});
	
				helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
					yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
				});
	
				if (scaleOptions) {
					scaleOptions.id = scaleOptions.id || 'scale';
				}
			},
	
			/**
			 * Builds a map of scale ID to scale object for future lookup.
			 */
			buildScales: function() {
				var me = this;
				var options = me.options;
				var scales = me.scales = {};
				var items = [];
	
				if (options.scales) {
					items = items.concat(
						(options.scales.xAxes || []).map(function(xAxisOptions) {
							return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
						}),
						(options.scales.yAxes || []).map(function(yAxisOptions) {
							return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
						})
					);
				}
	
				if (options.scale) {
					items.push({
						options: options.scale,
						dtype: 'radialLinear',
						isDefault: true,
						dposition: 'chartArea'
					});
				}
	
				helpers.each(items, function(item) {
					var scaleOptions = item.options;
					var scaleType = helpers.getValueOrDefault(scaleOptions.type, item.dtype);
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
	
					if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
						scaleOptions.position = item.dposition;
					}
	
					var scale = new scaleClass({
						id: scaleOptions.id,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
	
					scales[scale.id] = scale;
	
					// TODO(SB): I think we should be able to remove this custom case (options.scale)
					// and consider it as a regular scale part of the "scales"" map only! This would
					// make the logic easier and remove some useless? custom code.
					if (item.isDefault) {
						me.scale = scale;
					}
				});
	
				Chart.scaleService.addScalesToLayout(this);
			},
	
			buildOrUpdateControllers: function() {
				var me = this;
				var types = [];
				var newControllers = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					var meta = me.getDatasetMeta(datasetIndex);
					if (!meta.type) {
						meta.type = dataset.type || me.config.type;
					}
	
					types.push(meta.type);
	
					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
					} else {
						var ControllerClass = Chart.controllers[meta.type];
						if (ControllerClass === undefined) {
							throw new Error('"' + meta.type + '" is not a chart type.');
						}
	
						meta.controller = new ControllerClass(me, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, me);
	
				if (types.length > 1) {
					for (var i = 1; i < types.length; i++) {
						if (types[i] !== types[i - 1]) {
							me.isCombo = true;
							break;
						}
					}
				}
	
				return newControllers;
			},
	
			/**
			 * Reset the elements of all datasets
			 * @private
			 */
			resetElements: function() {
				var me = this;
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.reset();
				}, me);
			},
	
			/**
			* Resets the chart back to it's state before the initial animation
			*/
			reset: function() {
				this.resetElements();
				this.tooltip.initialize();
			},
	
			update: function(animationDuration, lazy) {
				var me = this;
	
				updateConfig(me);
	
				if (plugins.notify(me, 'beforeUpdate') === false) {
					return;
				}
	
				// In case the entire data object changed
				me.tooltip._data = me.data;
	
				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = me.buildOrUpdateControllers();
	
				// Make sure all dataset controllers have correct meta data counts
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, me);
	
				me.updateLayout();
	
				// Can only reset the new controllers after the scales have been updated
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
	
				me.updateDatasets();
	
				// Do this before render so that any plugins that need final scale updates can use it
				plugins.notify(me, 'afterUpdate');
	
				if (me._bufferedRender) {
					me._bufferedRequest = {
						lazy: lazy,
						duration: animationDuration
					};
				} else {
					me.render(animationDuration, lazy);
				}
			},
	
			/**
			 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
			 * hook, in which case, plugins will not be called on `afterLayout`.
			 * @private
			 */
			updateLayout: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeLayout') === false) {
					return;
				}
	
				Chart.layoutService.update(this, this.width, this.height);
	
				/**
				 * Provided for backward compatibility, use `afterLayout` instead.
				 * @method IPlugin#afterScaleUpdate
				 * @deprecated since version 2.5.0
				 * @todo remove at version 3
				 * @private
				 */
				plugins.notify(me, 'afterScaleUpdate');
				plugins.notify(me, 'afterLayout');
			},
	
			/**
			 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
			 * @private
			 */
			updateDatasets: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
					return;
				}
	
				for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.updateDataset(i);
				}
	
				plugins.notify(me, 'afterDatasetsUpdate');
			},
	
			/**
			 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
			 * @private
			 */
			updateDataset: function(index) {
				var me = this;
				var meta = me.getDatasetMeta(index);
				var args = {
					meta: meta,
					index: index
				};
	
				if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
					return;
				}
	
				meta.controller.update();
	
				plugins.notify(me, 'afterDatasetUpdate', [args]);
			},
	
			render: function(duration, lazy) {
				var me = this;
	
				if (plugins.notify(me, 'beforeRender') === false) {
					return;
				}
	
				var animationOptions = me.options.animation;
				var onComplete = function(animation) {
					plugins.notify(me, 'afterRender');
					helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
				};
	
				if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
					var animation = new Chart.Animation({
						numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
						easing: animationOptions.easing,
	
						render: function(chart, animationObject) {
							var easingFunction = helpers.easingEffects[animationObject.easing];
							var currentStep = animationObject.currentStep;
							var stepDecimal = currentStep / animationObject.numSteps;
	
							chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
						},
	
						onAnimationProgress: animationOptions.onProgress,
						onAnimationComplete: onComplete
					});
	
					Chart.animationService.addAnimation(me, animation, duration, lazy);
				} else {
					me.draw();
	
					// See https://github.com/chartjs/Chart.js/issues/3781
					onComplete(new Chart.Animation({numSteps: 0, chart: me}));
				}
	
				return me;
			},
	
			draw: function(easingValue) {
				var me = this;
	
				me.clear();
	
				if (easingValue === undefined || easingValue === null) {
					easingValue = 1;
				}
	
				me.transition(easingValue);
	
				if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw all the scales
				helpers.each(me.boxes, function(box) {
					box.draw(me.chartArea);
				}, me);
	
				if (me.scale) {
					me.scale.draw();
				}
	
				me.drawDatasets(easingValue);
	
				// Finally draw the tooltip
				me.tooltip.draw();
	
				plugins.notify(me, 'afterDraw', [easingValue]);
			},
	
			/**
			 * @private
			 */
			transition: function(easingValue) {
				var me = this;
	
				for (var i=0, ilen=(me.data.datasets || []).length; i<ilen; ++i) {
					if (me.isDatasetVisible(i)) {
						me.getDatasetMeta(i).controller.transition(easingValue);
					}
				}
	
				me.tooltip.transition(easingValue);
			},
	
			/**
			 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
			 * @private
			 */
			drawDatasets: function(easingValue) {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw datasets reversed to support proper line stacking
				for (var i=(me.data.datasets || []).length - 1; i >= 0; --i) {
					if (me.isDatasetVisible(i)) {
						me.drawDataset(i, easingValue);
					}
				}
	
				plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
			},
	
			/**
			 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
			 * @private
			 */
			drawDataset: function(index, easingValue) {
				var me = this;
				var meta = me.getDatasetMeta(index);
				var args = {
					meta: meta,
					index: index,
					easingValue: easingValue
				};
	
				if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
					return;
				}
	
				meta.controller.draw(easingValue);
	
				plugins.notify(me, 'afterDatasetDraw', [args]);
			},
	
			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				return Chart.Interaction.modes.single(this, e);
			},
	
			getElementsAtEvent: function(e) {
				return Chart.Interaction.modes.label(this, e, {intersect: true});
			},
	
			getElementsAtXAxis: function(e) {
				return Chart.Interaction.modes['x-axis'](this, e, {intersect: true});
			},
	
			getElementsAtEventForMode: function(e, mode, options) {
				var method = Chart.Interaction.modes[mode];
				if (typeof method === 'function') {
					return method(this, e, options);
				}
	
				return [];
			},
	
			getDatasetAtEvent: function(e) {
				return Chart.Interaction.modes.dataset(this, e, {intersect: true});
			},
	
			getDatasetMeta: function(datasetIndex) {
				var me = this;
				var dataset = me.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}
	
				var meta = dataset._meta[me.id];
				if (!meta) {
					meta = dataset._meta[me.id] = {
						type: null,
						data: [],
						dataset: null,
						controller: null,
						hidden: null,			// See isDatasetVisible() comment
						xAxisID: null,
						yAxisID: null
					};
				}
	
				return meta;
			},
	
			getVisibleDatasetCount: function() {
				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i<ilen; ++i) {
					if (this.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},
	
			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);
	
				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean'? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},
	
			generateLegend: function() {
				return this.options.legendCallback(this);
			},
	
			destroy: function() {
				var me = this;
				var canvas = me.canvas;
				var meta, i, ilen;
	
				me.stop();
	
				// dataset controllers need to cleanup associated data
				for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					meta = me.getDatasetMeta(i);
					if (meta.controller) {
						meta.controller.destroy();
						meta.controller = null;
					}
				}
	
				if (canvas) {
					me.unbindEvents();
					helpers.clear(me);
					platform.releaseContext(me.ctx);
					me.canvas = null;
					me.ctx = null;
				}
	
				plugins.notify(me, 'destroy');
	
				delete Chart.instances[me.id];
			},
	
			toBase64Image: function() {
				return this.canvas.toDataURL.apply(this.canvas, arguments);
			},
	
			initToolTip: function() {
				var me = this;
				me.tooltip = new Chart.Tooltip({
					_chart: me,
					_chartInstance: me,            // deprecated, backward compatibility
					_data: me.data,
					_options: me.options.tooltips
				}, me);
				me.tooltip.initialize();
			},
	
			/**
			 * @private
			 */
			bindEvents: function() {
				var me = this;
				var listeners = me._listeners = {};
				var listener = function() {
					me.eventHandler.apply(me, arguments);
				};
	
				helpers.each(me.options.events, function(type) {
					platform.addEventListener(me, type, listener);
					listeners[type] = listener;
				});
	
				// Responsiveness is currently based on the use of an iframe, however this method causes
				// performance issues and could be troublesome when used with ad blockers. So make sure
				// that the user is still able to create a chart without iframe when responsive is false.
				// See https://github.com/chartjs/Chart.js/issues/2210
				if (me.options.responsive) {
					listener = function() {
						me.resize();
					};
	
					platform.addEventListener(me, 'resize', listener);
					listeners.resize = listener;
				}
			},
	
			/**
			 * @private
			 */
			unbindEvents: function() {
				var me = this;
				var listeners = me._listeners;
				if (!listeners) {
					return;
				}
	
				delete me._listeners;
				helpers.each(listeners, function(listener, type) {
					platform.removeEventListener(me, type, listener);
				});
			},
	
			updateHoverStyle: function(elements, mode, enabled) {
				var method = enabled? 'setHoverStyle' : 'removeHoverStyle';
				var element, i, ilen;
	
				for (i=0, ilen=elements.length; i<ilen; ++i) {
					element = elements[i];
					if (element) {
						this.getDatasetMeta(element._datasetIndex).controller[method](element);
					}
				}
			},
	
			/**
			 * @private
			 */
			eventHandler: function(e) {
				var me = this;
				var tooltip = me.tooltip;
	
				if (plugins.notify(me, 'beforeEvent', [e]) === false) {
					return;
				}
	
				// Buffer any update calls so that renders do not occur
				me._bufferedRender = true;
				me._bufferedRequest = null;
	
				var changed = me.handleEvent(e);
				changed |= tooltip && tooltip.handleEvent(e);
	
				plugins.notify(me, 'afterEvent', [e]);
	
				var bufferedRequest = me._bufferedRequest;
				if (bufferedRequest) {
					// If we have an update that was triggered, we need to do a normal render
					me.render(bufferedRequest.duration, bufferedRequest.lazy);
				} else if (changed && !me.animating) {
					// If entering, leaving, or changing elements, animate the change via pivot
					me.stop();
	
					// We only need to render at this point. Updating will cause scales to be
					// recomputed generating flicker & using more memory than necessary.
					me.render(me.options.hover.animationDuration, true);
				}
	
				me._bufferedRender = false;
				me._bufferedRequest = null;
	
				return me;
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event the event to handle
			 * @return {Boolean} true if the chart needs to re-render
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me.options || {};
				var hoverOptions = options.hover;
				var changed = false;
	
				me.lastActive = me.lastActive || [];
	
				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					me.active = [];
				} else {
					me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
				}
	
				// On Hover hook
				if (hoverOptions.onHover) {
					// Need to call with native event here to not break backwards compatibility
					hoverOptions.onHover.call(me, e.native, me.active);
				}
	
				if (e.type === 'mouseup' || e.type === 'click') {
					if (options.onClick) {
						// Use e.native here for backwards compatibility
						options.onClick.call(me, e.native, me.active);
					}
				}
	
				// Remove styling for last active (even if it may still be active)
				if (me.lastActive.length) {
					me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
				}
	
				// Built in hover styling
				if (me.active.length && hoverOptions.mode) {
					me.updateHoverStyle(me.active, hoverOptions.mode, true);
				}
	
				changed = !helpers.arrayEquals(me.active, me.lastActive);
	
				// Remember Last Actives
				me.lastActive = me.active;
	
				return changed;
			}
		});
	
		/**
		 * Provided for backward compatibility, use Chart instead.
		 * @class Chart.Controller
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.Controller = Chart;
	};


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
		/**
		 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
		 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
		 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
		 */
		function listenArrayEvents(array, listener) {
			if (array._chartjs) {
				array._chartjs.listeners.push(listener);
				return;
			}
	
			Object.defineProperty(array, '_chartjs', {
				configurable: true,
				enumerable: false,
				value: {
					listeners: [listener]
				}
			});
	
			arrayEvents.forEach(function(key) {
				var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
				var base = array[key];
	
				Object.defineProperty(array, key, {
					configurable: true,
					enumerable: false,
					value: function() {
						var args = Array.prototype.slice.call(arguments);
						var res = base.apply(this, args);
	
						helpers.each(array._chartjs.listeners, function(object) {
							if (typeof object[method] === 'function') {
								object[method].apply(object, args);
							}
						});
	
						return res;
					}
				});
			});
		}
	
		/**
		 * Removes the given array event listener and cleanup extra attached properties (such as
		 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
		 */
		function unlistenArrayEvents(array, listener) {
			var stub = array._chartjs;
			if (!stub) {
				return;
			}
	
			var listeners = stub.listeners;
			var index = listeners.indexOf(listener);
			if (index !== -1) {
				listeners.splice(index, 1);
			}
	
			if (listeners.length > 0) {
				return;
			}
	
			arrayEvents.forEach(function(key) {
				delete array[key];
			});
	
			delete array._chartjs;
		}
	
		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize(chart, datasetIndex);
		};
	
		helpers.extend(Chart.DatasetController.prototype, {
	
			/**
			 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
			 * @type {Chart.core.element}
			 */
			datasetElementType: null,
	
			/**
			 * Element type used to generate a meta data (e.g. Chart.element.Point).
			 * @type {Chart.core.element}
			 */
			dataElementType: null,
	
			initialize: function(chart, datasetIndex) {
				var me = this;
				me.chart = chart;
				me.index = datasetIndex;
				me.linkScales();
				me.addElements();
			},
	
			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},
	
			linkScales: function() {
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				if (meta.xAxisID === null) {
					meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null) {
					meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
				}
			},
	
			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},
	
			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},
	
			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},
	
			reset: function() {
				this.update(true);
			},
	
			/**
			 * @private
			 */
			destroy: function() {
				if (this._data) {
					unlistenArrayEvents(this._data, this);
				}
			},
	
			createMetaDataset: function() {
				var me = this;
				var type = me.datasetElementType;
				return type && new type({
					_chart: me.chart,
					_datasetIndex: me.index
				});
			},
	
			createMetaData: function(index) {
				var me = this;
				var type = me.dataElementType;
				return type && new type({
					_chart: me.chart,
					_datasetIndex: me.index,
					_index: index
				});
			},
	
			addElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data || [];
				var metaData = meta.data;
				var i, ilen;
	
				for (i=0, ilen=data.length; i<ilen; ++i) {
					metaData[i] = metaData[i] || me.createMetaData(i);
				}
	
				meta.dataset = meta.dataset || me.createMetaDataset();
			},
	
			addElementAndReset: function(index) {
				var element = this.createMetaData(index);
				this.getMeta().data.splice(index, 0, element);
				this.updateElement(element, index, true);
			},
	
			buildOrUpdateElements: function() {
				var me = this;
				var dataset = me.getDataset();
				var data = dataset.data || (dataset.data = []);
	
				// In order to correctly handle data addition/deletion animation (an thus simulate
				// real-time charts), we need to monitor these data modifications and synchronize
				// the internal meta data accordingly.
				if (me._data !== data) {
					if (me._data) {
						// This case happens when the user replaced the data array instance.
						unlistenArrayEvents(me._data, me);
					}
	
					listenArrayEvents(data, me);
					me._data = data;
				}
	
				// Re-sync meta data in case the user replaced the data array or if we missed
				// any updates and so make sure that we handle number of datapoints changing.
				me.resyncElements();
			},
	
			update: helpers.noop,
	
			transition: function(easingValue) {
				var meta = this.getMeta();
				var elements = meta.data || [];
				var ilen = elements.length;
				var i = 0;
	
				for (; i<ilen; ++i) {
					elements[i].transition(easingValue);
				}
	
				if (meta.dataset) {
					meta.dataset.transition(easingValue);
				}
			},
	
			draw: function() {
				var meta = this.getMeta();
				var elements = meta.data || [];
				var ilen = elements.length;
				var i = 0;
	
				if (meta.dataset) {
					meta.dataset.draw();
				}
	
				for (; i<ilen; ++i) {
					elements[i].draw();
				}
			},
	
			removeHoverStyle: function(element, elementOpts) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					model = element._model;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
			},
	
			setHoverStyle: function(element) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					getHoverColor = helpers.getHoverColor,
					model = element._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			/**
			 * @private
			 */
			resyncElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data;
				var numMeta = meta.data.length;
				var numData = data.length;
	
				if (numData < numMeta) {
					meta.data.splice(numData, numMeta - numData);
				} else if (numData > numMeta) {
					me.insertElements(numMeta, numData - numMeta);
				}
			},
	
			/**
			 * @private
			 */
			insertElements: function(start, count) {
				for (var i=0; i<count; ++i) {
					this.addElementAndReset(start + i);
				}
			},
	
			/**
			 * @private
			 */
			onDataPush: function() {
				this.insertElements(this.getDataset().data.length-1, arguments.length);
			},
	
			/**
			 * @private
			 */
			onDataPop: function() {
				this.getMeta().data.pop();
			},
	
			/**
			 * @private
			 */
			onDataShift: function() {
				this.getMeta().data.shift();
			},
	
			/**
			 * @private
			 */
			onDataSplice: function(start, count) {
				this.getMeta().data.splice(start, count);
				this.insertElements(start, arguments.length - 2);
			},
	
			/**
			 * @private
			 */
			onDataUnshift: function() {
				this.insertElements(0, arguments.length);
			}
		});
	
		Chart.DatasetController.extend = helpers.inherits;
	};


/***/ }),
/* 366 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		function filterByPosition(array, position) {
			return helpers.where(array, function(v) {
				return v.position === position;
			});
		}
	
		function sortByWeight(array, reverse) {
			array.forEach(function(v, i) {
				v._tmpIndex_ = i;
				return v;
			});
			array.sort(function(a, b) {
				var v0 = reverse ? b : a;
				var v1 = reverse ? a : b;
				return v0.weight === v1.weight ?
					v0._tmpIndex_ - v1._tmpIndex_ :
					v0.weight - v1.weight;
			});
			array.forEach(function(v) {
				delete v._tmpIndex_;
			});
		}
	
		/**
		 * @interface ILayoutItem
		 * @prop {String} position - The position of the item in the chart layout. Possible values are
		 * 'left', 'top', 'right', 'bottom', and 'chartArea'
		 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
		 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
		 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
		 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
		 * @prop {Function} getPadding -  Returns an object with padding on the edges
		 * @prop {Number} width - Width of item. Must be valid after update()
		 * @prop {Number} height - Height of item. Must be valid after update()
		 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
		 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
		 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
		 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
		 */
	
		// The layout service is very self explanatory.  It's responsible for the layout within a chart.
		// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
		// It is this service's responsibility of carrying out that layout.
		Chart.layoutService = {
			defaults: {},
	
			/**
			 * Register a box to a chart.
			 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
			 * @param {Chart} chart - the chart to use
			 * @param {ILayoutItem} item - the item to add to be layed out
			 */
			addBox: function(chart, item) {
				if (!chart.boxes) {
					chart.boxes = [];
				}
	
				// initialize item with default values
				item.fullWidth = item.fullWidth || false;
				item.position = item.position || 'top';
				item.weight = item.weight || 0;
	
				chart.boxes.push(item);
			},
	
			/**
			 * Remove a layoutItem from a chart
			 * @param {Chart} chart - the chart to remove the box from
			 * @param {Object} layoutItem - the item to remove from the layout
			 */
			removeBox: function(chart, layoutItem) {
				var index = chart.boxes? chart.boxes.indexOf(layoutItem) : -1;
				if (index !== -1) {
					chart.boxes.splice(index, 1);
				}
			},
	
			/**
			 * Sets (or updates) options on the given `item`.
			 * @param {Chart} chart - the chart in which the item lives (or will be added to)
			 * @param {Object} item - the item to configure with the given options
			 * @param {Object} options - the new item options.
			 */
			configure: function(chart, item, options) {
				var props = ['fullWidth', 'position', 'weight'];
				var ilen = props.length;
				var i = 0;
				var prop;
	
				for (; i<ilen; ++i) {
					prop = props[i];
					if (options.hasOwnProperty(prop)) {
						item[prop] = options[prop];
					}
				}
			},
	
			/**
			 * Fits boxes of the given chart into the given size by having each box measure itself
			 * then running a fitting algorithm
			 * @param {Chart} chart - the chart
			 * @param {Number} width - the width to fit into
			 * @param {Number} height - the height to fit into
			 */
			update: function(chart, width, height) {
				if (!chart) {
					return;
				}
	
				var layoutOptions = chart.options.layout;
				var padding = layoutOptions ? layoutOptions.padding : null;
	
				var leftPadding = 0;
				var rightPadding = 0;
				var topPadding = 0;
				var bottomPadding = 0;
	
				if (!isNaN(padding)) {
					// options.layout.padding is a number. assign to all
					leftPadding = padding;
					rightPadding = padding;
					topPadding = padding;
					bottomPadding = padding;
				} else {
					leftPadding = padding.left || 0;
					rightPadding = padding.right || 0;
					topPadding = padding.top || 0;
					bottomPadding = padding.bottom || 0;
				}
	
				var leftBoxes = filterByPosition(chart.boxes, 'left');
				var rightBoxes = filterByPosition(chart.boxes, 'right');
				var topBoxes = filterByPosition(chart.boxes, 'top');
				var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
				var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');
	
				// Sort boxes by weight. A higher weight is further away from the chart area
				sortByWeight(leftBoxes, true);
				sortByWeight(rightBoxes, false);
				sortByWeight(topBoxes, true);
				sortByWeight(bottomBoxes, false);
	
				// Essentially we now have any number of boxes on each of the 4 sides.
				// Our canvas looks like the following.
				// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
				// B1 is the bottom axis
				// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
				// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
				// an error will be thrown.
				//
				// |----------------------------------------------------|
				// |                  T1 (Full Width)                   |
				// |----------------------------------------------------|
				// |    |    |                 T2                  |    |
				// |    |----|-------------------------------------|----|
				// |    |    | C1 |                           | C2 |    |
				// |    |    |----|                           |----|    |
				// |    |    |                                     |    |
				// | L1 | L2 |           ChartArea (C0)            | R1 |
				// |    |    |                                     |    |
				// |    |    |----|                           |----|    |
				// |    |    | C3 |                           | C4 |    |
				// |    |----|-------------------------------------|----|
				// |    |    |                 B1                  |    |
				// |----------------------------------------------------|
				// |                  B2 (Full Width)                   |
				// |----------------------------------------------------|
				//
				// What we do to find the best sizing, we do the following
				// 1. Determine the minimum size of the chart area.
				// 2. Split the remaining width equally between each vertical axis
				// 3. Split the remaining height equally between each horizontal axis
				// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
				// 5. Adjust the sizes of each axis based on it's minimum reported size.
				// 6. Refit each axis
				// 7. Position each axis in the final location
				// 8. Tell the chart the final location of the chart area
				// 9. Tell any axes that overlay the chart area the positions of the chart area
	
				// Step 1
				var chartWidth = width - leftPadding - rightPadding;
				var chartHeight = height - topPadding - bottomPadding;
				var chartAreaWidth = chartWidth / 2; // min 50%
				var chartAreaHeight = chartHeight / 2; // min 50%
	
				// Step 2
				var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);
	
				// Step 3
				var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);
	
				// Step 4
				var maxChartAreaWidth = chartWidth;
				var maxChartAreaHeight = chartHeight;
				var minBoxSizes = [];
	
				function getMinimumBoxSize(box) {
					var minSize;
					var isHorizontal = box.isHorizontal();
	
					if (isHorizontal) {
						minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
						maxChartAreaHeight -= minSize.height;
					} else {
						minSize = box.update(verticalBoxWidth, chartAreaHeight);
						maxChartAreaWidth -= minSize.width;
					}
	
					minBoxSizes.push({
						horizontal: isHorizontal,
						minSize: minSize,
						box: box,
					});
				}
	
				helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);
	
				// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
				var maxHorizontalLeftPadding = 0;
				var maxHorizontalRightPadding = 0;
				var maxVerticalTopPadding = 0;
				var maxVerticalBottomPadding = 0;
	
				helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
					if (horizontalBox.getPadding) {
						var boxPadding = horizontalBox.getPadding();
						maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
						maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
					}
				});
	
				helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
					if (verticalBox.getPadding) {
						var boxPadding = verticalBox.getPadding();
						maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
						maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
					}
				});
	
				// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
				// be if the axes are drawn at their minimum sizes.
				// Steps 5 & 6
				var totalLeftBoxesWidth = leftPadding;
				var totalRightBoxesWidth = rightPadding;
				var totalTopBoxesHeight = topPadding;
				var totalBottomBoxesHeight = bottomPadding;
	
				// Function to fit a box
				function fitBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
						return minBox.box === box;
					});
	
					if (minBoxSize) {
						if (box.isHorizontal()) {
							var scaleMargin = {
								left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
								right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
								top: 0,
								bottom: 0
							};
	
							// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
							// on the margin. Sometimes they need to increase in size slightly
							box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
						} else {
							box.update(minBoxSize.minSize.width, maxChartAreaHeight);
						}
					}
				}
	
				// Update, and calculate the left and right margins for the horizontal boxes
				helpers.each(leftBoxes.concat(rightBoxes), fitBox);
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				// Set the Left and Right margins for the horizontal boxes
				helpers.each(topBoxes.concat(bottomBoxes), fitBox);
	
				// Figure out how much margin is on the top and bottom of the vertical boxes
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
	
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				function finalFitVerticalBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
						return minSize.box === box;
					});
	
					var scaleMargin = {
						left: 0,
						right: 0,
						top: totalTopBoxesHeight,
						bottom: totalBottomBoxesHeight
					};
	
					if (minBoxSize) {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
					}
				}
	
				// Let the left layout know the final margin
				helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);
	
				// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
				totalLeftBoxesWidth = leftPadding;
				totalRightBoxesWidth = rightPadding;
				totalTopBoxesHeight = topPadding;
				totalBottomBoxesHeight = bottomPadding;
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				// We may be adding some padding to account for rotated x axis labels
				var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
				totalLeftBoxesWidth += leftPaddingAddition;
				totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);
	
				var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
				totalTopBoxesHeight += topPaddingAddition;
				totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);
	
				// Figure out if our chart area changed. This would occur if the dataset layout label rotation
				// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
				// without calling `fit` again
				var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
				var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;
	
				if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
					helpers.each(leftBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(rightBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(topBoxes, function(box) {
						if (!box.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					helpers.each(bottomBoxes, function(box) {
						if (!box.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					maxChartAreaHeight = newMaxChartAreaHeight;
					maxChartAreaWidth = newMaxChartAreaWidth;
				}
	
				// Step 7 - Position the boxes
				var left = leftPadding + leftPaddingAddition;
				var top = topPadding + topPaddingAddition;
	
				function placeBox(box) {
					if (box.isHorizontal()) {
						box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
						box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
						box.top = top;
						box.bottom = top + box.height;
	
						// Move to next point
						top = box.bottom;
	
					} else {
	
						box.left = left;
						box.right = left + box.width;
						box.top = totalTopBoxesHeight;
						box.bottom = totalTopBoxesHeight + maxChartAreaHeight;
	
						// Move to next point
						left = box.right;
					}
				}
	
				helpers.each(leftBoxes.concat(topBoxes), placeBox);
	
				// Account for chart width and height
				left += maxChartAreaWidth;
				top += maxChartAreaHeight;
	
				helpers.each(rightBoxes, placeBox);
				helpers.each(bottomBoxes, placeBox);
	
				// Step 8
				chart.chartArea = {
					left: totalLeftBoxesWidth,
					top: totalTopBoxesHeight,
					right: totalLeftBoxesWidth + maxChartAreaWidth,
					bottom: totalTopBoxesHeight + maxChartAreaHeight
				};
	
				// Step 9
				helpers.each(chartAreaBoxes, function(box) {
					box.left = chart.chartArea.left;
					box.top = chart.chartArea.top;
					box.right = chart.chartArea.right;
					box.bottom = chart.chartArea.bottom;
	
					box.update(maxChartAreaWidth, maxChartAreaHeight);
				});
			}
		};
	};


/***/ }),
/* 367 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.scaleService = {
			// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
			// use the new chart options to grab the correct scale
			constructors: {},
			// Use a registration function so that we can move to an ES6 map when we no longer need to support
			// old browsers
	
			// Scale config defaults
			defaults: {},
			registerScaleType: function(type, scaleConstructor, defaults) {
				this.constructors[type] = scaleConstructor;
				this.defaults[type] = helpers.clone(defaults);
			},
			getScaleConstructor: function(type) {
				return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
			},
			getScaleDefaults: function(type) {
				// Return the scale defaults merged with the global settings so that we always use the latest ones
				return this.defaults.hasOwnProperty(type) ? helpers.scaleMerge(Chart.defaults.scale, this.defaults[type]) : {};
			},
			updateScaleDefaults: function(type, additions) {
				var defaults = this.defaults;
				if (defaults.hasOwnProperty(type)) {
					defaults[type] = helpers.extend(defaults[type], additions);
				}
			},
			addScalesToLayout: function(chart) {
				// Adds each scale to the chart.boxes array to be sized accordingly
				helpers.each(chart.scales, function(scale) {
					// Set ILayoutItem parameters for backwards compatibility
					scale.fullWidth = scale.options.fullWidth;
					scale.position = scale.options.position;
					scale.weight = scale.options.weight;
					Chart.layoutService.addBox(chart, scale);
				});
			}
		};
	};


/***/ }),
/* 368 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		/**
		 * Namespace to hold static tick generation functions
		 * @namespace Chart.Ticks
		 */
		Chart.Ticks = {
			/**
			 * Namespace to hold generators for different types of ticks
			 * @namespace Chart.Ticks.generators
			 */
			generators: {
				/**
				 * Interface for the options provided to the numeric tick generator
				 * @interface INumericTickGenerationOptions
				 */
				/**
				 * The maximum number of ticks to display
				 * @name INumericTickGenerationOptions#maxTicks
				 * @type Number
				 */
				/**
				 * The distance between each tick.
				 * @name INumericTickGenerationOptions#stepSize
				 * @type Number
				 * @optional
				 */
				/**
				 * Forced minimum for the ticks. If not specified, the minimum of the data range is used to calculate the tick minimum
				 * @name INumericTickGenerationOptions#min
				 * @type Number
				 * @optional
				 */
				/**
				 * The maximum value of the ticks. If not specified, the maximum of the data range is used to calculate the tick maximum
				 * @name INumericTickGenerationOptions#max
				 * @type Number
				 * @optional
				 */
	
				/**
				 * Generate a set of linear ticks
				 * @method Chart.Ticks.generators.linear
				 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
				 * @param dataRange {IRange} the range of the data
				 * @returns {Array<Number>} array of tick values
				 */
				linear: function(generationOptions, dataRange) {
					var ticks = [];
					// To get a "nice" value for the tick spacing, we will use the appropriately named
					// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
					// for details.
	
					var spacing;
					if (generationOptions.stepSize && generationOptions.stepSize > 0) {
						spacing = generationOptions.stepSize;
					} else {
						var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
						spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
					}
					var niceMin = Math.floor(dataRange.min / spacing) * spacing;
					var niceMax = Math.ceil(dataRange.max / spacing) * spacing;
	
					// If min, max and stepSize is set and they make an evenly spaced scale use it.
					if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
						// If very close to our whole number, use it.
						if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
							niceMin = generationOptions.min;
							niceMax = generationOptions.max;
						}
					}
	
					var numSpaces = (niceMax - niceMin) / spacing;
					// If very close to our rounded value, use it.
					if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
						numSpaces = Math.round(numSpaces);
					} else {
						numSpaces = Math.ceil(numSpaces);
					}
	
					// Put the values into the ticks array
					ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
					for (var j = 1; j < numSpaces; ++j) {
						ticks.push(niceMin + (j * spacing));
					}
					ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);
	
					return ticks;
				},
	
				/**
				 * Generate a set of logarithmic ticks
				 * @method Chart.Ticks.generators.logarithmic
				 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
				 * @param dataRange {IRange} the range of the data
				 * @returns {Array<Number>} array of tick values
				 */
				logarithmic: function(generationOptions, dataRange) {
					var ticks = [];
					var getValueOrDefault = helpers.getValueOrDefault;
	
					// Figure out what the max number of ticks we can support it is based on the size of
					// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
					// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
					// the graph
					var tickVal = getValueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));
	
					var endExp = Math.floor(helpers.log10(dataRange.max));
					var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
					var exp;
					var significand;
	
					if (tickVal === 0) {
						exp = Math.floor(helpers.log10(dataRange.minNotZero));
						significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
						ticks.push(tickVal);
						tickVal = significand * Math.pow(10, exp);
					} else {
						exp = Math.floor(helpers.log10(tickVal));
						significand = Math.floor(tickVal / Math.pow(10, exp));
					}
	
					do {
						ticks.push(tickVal);
	
						++significand;
						if (significand === 10) {
							significand = 1;
							++exp;
						}
	
						tickVal = significand * Math.pow(10, exp);
					} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
					var lastTick = getValueOrDefault(generationOptions.max, tickVal);
					ticks.push(lastTick);
	
					return ticks;
				}
			},
	
			/**
			 * Namespace to hold formatters for different types of ticks
			 * @namespace Chart.Ticks.formatters
			 */
			formatters: {
				/**
				 * Formatter for value labels
				 * @method Chart.Ticks.formatters.values
				 * @param value the value to display
				 * @return {String|Array} the label to display
				 */
				values: function(value) {
					return helpers.isArray(value) ? value : '' + value;
				},
	
				/**
				 * Formatter for linear numeric ticks
				 * @method Chart.Ticks.formatters.linear
				 * @param tickValue {Number} the value to be formatted
				 * @param index {Number} the position of the tickValue parameter in the ticks array
				 * @param ticks {Array<Number>} the list of ticks being converted
				 * @return {String} string representation of the tickValue parameter
				 */
				linear: function(tickValue, index, ticks) {
					// If we have lots of ticks, don't use the ones
					var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
					// If we have a number like 2.5 as the delta, figure out how many decimal places we need
					if (Math.abs(delta) > 1) {
						if (tickValue !== Math.floor(tickValue)) {
							// not an integer
							delta = tickValue - Math.floor(tickValue);
						}
					}
	
					var logDelta = helpers.log10(Math.abs(delta));
					var tickString = '';
	
					if (tickValue !== 0) {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					} else {
						tickString = '0'; // never show decimal places for 0
					}
	
					return tickString;
				},
	
				logarithmic: function(tickValue, index, ticks) {
					var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));
	
					if (tickValue === 0) {
						return '0';
					} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
						return tickValue.toExponential();
					}
					return '';
				}
			}
		};
	};


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.scale = {
			display: true,
			position: 'left',
	
			// grid line settings
			gridLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1,
				drawBorder: true,
				drawOnChartArea: true,
				drawTicks: true,
				tickMarkLength: 10,
				zeroLineWidth: 1,
				zeroLineColor: 'rgba(0,0,0,0.25)',
				zeroLineBorderDash: [],
				zeroLineBorderDashOffset: 0.0,
				offsetGridLines: false,
				borderDash: [],
				borderDashOffset: 0.0
			},
	
			// scale label
			scaleLabel: {
				// actual label
				labelString: '',
	
				// display property
				display: false
			},
	
			// label settings
			ticks: {
				beginAtZero: false,
				minRotation: 0,
				maxRotation: 50,
				mirror: false,
				padding: 0,
				reverse: false,
				display: true,
				autoSkip: true,
				autoSkipPadding: 0,
				labelOffset: 0,
				// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
				callback: Chart.Ticks.formatters.values
			}
		};
	
		function computeTextSize(context, tick, font) {
			return helpers.isArray(tick) ?
				helpers.longestText(context, font, tick) :
				context.measureText(tick).width;
		}
	
		function parseFontOptions(options) {
			var getValueOrDefault = helpers.getValueOrDefault;
			var globalDefaults = Chart.defaults.global;
			var size = getValueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var style = getValueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
			var family = getValueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);
	
			return {
				size: size,
				style: style,
				family: family,
				font: helpers.fontString(size, style, family)
			};
		}
	
		Chart.Scale = Chart.Element.extend({
			/**
			 * Get the padding needed for the scale
			 * @method getPadding
			 * @private
			 * @returns {Padding} the necessary padding
			 */
			getPadding: function() {
				var me = this;
				return {
					left: me.paddingLeft || 0,
					top: me.paddingTop || 0,
					right: me.paddingRight || 0,
					bottom: me.paddingBottom || 0
				};
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all scale types.
			// Any function can be extended by the scale type
	
			beforeUpdate: function() {
				helpers.callback(this.options.beforeUpdate, [this]);
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = helpers.extend({
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}, margins);
				me.longestTextCache = me.longestTextCache || {};
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
	
				// Data min/max
				me.beforeDataLimits();
				me.determineDataLimits();
				me.afterDataLimits();
	
				// Ticks
				me.beforeBuildTicks();
				me.buildTicks();
				me.afterBuildTicks();
	
				me.beforeTickToLabelConversion();
				me.convertTicksToLabels();
				me.afterTickToLabelConversion();
	
				// Tick Rotation
				me.beforeCalculateTickRotation();
				me.calculateTickRotation();
				me.afterCalculateTickRotation();
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: function() {
				helpers.callback(this.options.afterUpdate, [this]);
			},
	
			//
	
			beforeSetDimensions: function() {
				helpers.callback(this.options.beforeSetDimensions, [this]);
			},
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
			},
			afterSetDimensions: function() {
				helpers.callback(this.options.afterSetDimensions, [this]);
			},
	
			// Data limits
			beforeDataLimits: function() {
				helpers.callback(this.options.beforeDataLimits, [this]);
			},
			determineDataLimits: helpers.noop,
			afterDataLimits: function() {
				helpers.callback(this.options.afterDataLimits, [this]);
			},
	
			//
			beforeBuildTicks: function() {
				helpers.callback(this.options.beforeBuildTicks, [this]);
			},
			buildTicks: helpers.noop,
			afterBuildTicks: function() {
				helpers.callback(this.options.afterBuildTicks, [this]);
			},
	
			beforeTickToLabelConversion: function() {
				helpers.callback(this.options.beforeTickToLabelConversion, [this]);
			},
			convertTicksToLabels: function() {
				var me = this;
				// Convert ticks to strings
				var tickOpts = me.options.ticks;
				me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback);
			},
			afterTickToLabelConversion: function() {
				helpers.callback(this.options.afterTickToLabelConversion, [this]);
			},
	
			//
	
			beforeCalculateTickRotation: function() {
				helpers.callback(this.options.beforeCalculateTickRotation, [this]);
			},
			calculateTickRotation: function() {
				var me = this;
				var context = me.ctx;
				var tickOpts = me.options.ticks;
	
				// Get the width of each grid by calculating the difference
				// between x offsets between 0 and 1.
				var tickFont = parseFontOptions(tickOpts);
				context.font = tickFont.font;
	
				var labelRotation = tickOpts.minRotation || 0;
	
				if (me.options.display && me.isHorizontal()) {
					var originalLabelWidth = helpers.longestText(context, tickFont.font, me.ticks, me.longestTextCache);
					var labelWidth = originalLabelWidth;
					var cosRotation;
					var sinRotation;
	
					// Allow 3 pixels x2 padding either side for label readability
					var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;
	
					// Max label rotation can be set or default to 90 - also act as a loop counter
					while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
						var angleRadians = helpers.toRadians(labelRotation);
						cosRotation = Math.cos(angleRadians);
						sinRotation = Math.sin(angleRadians);
	
						if (sinRotation * originalLabelWidth > me.maxHeight) {
							// go back one step
							labelRotation--;
							break;
						}
	
						labelRotation++;
						labelWidth = cosRotation * originalLabelWidth;
					}
				}
	
				me.labelRotation = labelRotation;
			},
			afterCalculateTickRotation: function() {
				helpers.callback(this.options.afterCalculateTickRotation, [this]);
			},
	
			//
	
			beforeFit: function() {
				helpers.callback(this.options.beforeFit, [this]);
			},
			fit: function() {
				var me = this;
				// Reset
				var minSize = me.minSize = {
					width: 0,
					height: 0
				};
	
				var opts = me.options;
				var tickOpts = opts.ticks;
				var scaleLabelOpts = opts.scaleLabel;
				var gridLineOpts = opts.gridLines;
				var display = opts.display;
				var isHorizontal = me.isHorizontal();
	
				var tickFont = parseFontOptions(tickOpts);
				var scaleLabelFontSize = parseFontOptions(scaleLabelOpts).size * 1.5;
				var tickMarkLength = opts.gridLines.tickMarkLength;
	
				// Width
				if (isHorizontal) {
					// subtract the margins to line up with the chartArea if we are a full width scale
					minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
				} else {
					minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				}
	
				// height
				if (isHorizontal) {
					minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				} else {
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Are we showing a title for the scale?
				if (scaleLabelOpts.display && display) {
					if (isHorizontal) {
						minSize.height += scaleLabelFontSize;
					} else {
						minSize.width += scaleLabelFontSize;
					}
				}
	
				// Don't bother fitting the ticks if we are not showing them
				if (tickOpts.display && display) {
					var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, me.ticks, me.longestTextCache);
					var tallestLabelHeightInLines = helpers.numberOfLabelLines(me.ticks);
					var lineSpace = tickFont.size * 0.5;
	
					if (isHorizontal) {
						// A horizontal axis is more constrained by the height.
						me.longestLabelWidth = largestTextWidth;
	
						var angleRadians = helpers.toRadians(me.labelRotation);
						var cosRotation = Math.cos(angleRadians);
						var sinRotation = Math.sin(angleRadians);
	
						// TODO - improve this calculation
						var labelHeight = (sinRotation * largestTextWidth)
							+ (tickFont.size * tallestLabelHeightInLines)
							+ (lineSpace * tallestLabelHeightInLines);
	
						minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight);
						me.ctx.font = tickFont.font;
	
						var firstTick = me.ticks[0];
						var firstLabelWidth = computeTextSize(me.ctx, firstTick, tickFont.font);
	
						var lastTick = me.ticks[me.ticks.length - 1];
						var lastLabelWidth = computeTextSize(me.ctx, lastTick, tickFont.font);
	
						// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned which means that the right padding is dominated
						// by the font height
						if (me.labelRotation !== 0) {
							me.paddingLeft = opts.position === 'bottom'? (cosRotation * firstLabelWidth) + 3: (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
							me.paddingRight = opts.position === 'bottom'? (cosRotation * lineSpace) + 3: (cosRotation * lastLabelWidth) + 3;
						} else {
							me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
							me.paddingRight = lastLabelWidth / 2 + 3;
						}
					} else {
						// A vertical axis is more constrained by the width. Labels are the dominant factor here, so get that length first
						// Account for padding
	
						if (tickOpts.mirror) {
							largestTextWidth = 0;
						} else {
							largestTextWidth += me.options.ticks.padding;
						}
						minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);
						me.paddingTop = tickFont.size / 2;
						me.paddingBottom = tickFont.size / 2;
					}
				}
	
				me.handleMargins();
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
	
			/**
			 * Handle margins and padding interactions
			 * @private
			 */
			handleMargins: function() {
				var me = this;
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
					me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
				}
			},
	
			afterFit: function() {
				helpers.callback(this.options.afterFit, [this]);
			},
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
			isFullWidth: function() {
				return (this.options.fullWidth);
			},
	
			// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
			getRightValue: function(rawValue) {
				// Null and undefined values first
				if (rawValue === null || typeof(rawValue) === 'undefined') {
					return NaN;
				}
				// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
				if (typeof(rawValue) === 'number' && !isFinite(rawValue)) {
					return NaN;
				}
				// If it is in fact an object, dive in one more level
				if (typeof(rawValue) === 'object') {
					if ((rawValue instanceof Date) || (rawValue.isValid)) {
						return rawValue;
					}
					return this.getRightValue(this.isHorizontal() ? rawValue.x : rawValue.y);
				}
	
				// Value is good, return it
				return rawValue;
			},
	
			// Used to get the value to display in the tooltip for the data at the given index
			// function getLabelForIndex(index, datasetIndex)
			getLabelForIndex: helpers.noop,
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: helpers.noop,
	
			// Used to get the data value from a given pixel. This is the inverse of getPixelForValue
			getValueForPixel: helpers.noop,
	
			// Used for tick location, should
			getPixelForTick: function(index, includeOffset) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var tickWidth = innerWidth / Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
					var pixel = (tickWidth * index) + me.paddingLeft;
	
					if (includeOffset) {
						pixel += tickWidth / 2;
					}
	
					var finalVal = me.left + Math.round(pixel);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				return me.top + (index * (innerHeight / (me.ticks.length - 1)));
			},
	
			// Utility for getting the pixel location of a percentage of scale
			getPixelForDecimal: function(decimal /* , includeOffset*/) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
					var finalVal = me.left + Math.round(valueOffset);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				return me.top + (decimal * me.height);
			},
	
			getBasePixel: function() {
				return this.getPixelForValue(this.getBaseValue());
			},
	
			getBaseValue: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.beginAtZero ? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0;
			},
	
			// Actually draw the scale on the canvas
			// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
			draw: function(chartArea) {
				var me = this;
				var options = me.options;
				if (!options.display) {
					return;
				}
	
				var context = me.ctx;
				var globalDefaults = Chart.defaults.global;
				var optionTicks = options.ticks;
				var gridLines = options.gridLines;
				var scaleLabel = options.scaleLabel;
	
				var isRotated = me.labelRotation !== 0;
				var skipRatio;
				var useAutoskipper = optionTicks.autoSkip;
				var isHorizontal = me.isHorizontal();
	
				// figure out the maximum number of gridlines to show
				var maxTicks;
				if (optionTicks.maxTicksLimit) {
					maxTicks = optionTicks.maxTicksLimit;
				}
	
				var tickFontColor = helpers.getValueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
				var tickFont = parseFontOptions(optionTicks);
	
				var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;
	
				var scaleLabelFontColor = helpers.getValueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
				var scaleLabelFont = parseFontOptions(scaleLabel);
	
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
				var cosRotation = Math.cos(labelRotationRadians);
				var longestRotatedLabel = me.longestLabelWidth * cosRotation;
	
				// Make sure we draw text in the correct color and font
				context.fillStyle = tickFontColor;
	
				var itemsToDraw = [];
	
				if (isHorizontal) {
					skipRatio = false;
	
					if ((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length > (me.width - (me.paddingLeft + me.paddingRight))) {
						skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length) / (me.width - (me.paddingLeft + me.paddingRight)));
					}
	
					// if they defined a max number of optionTicks,
					// increase skipRatio until that number is met
					if (maxTicks && me.ticks.length > maxTicks) {
						while (!skipRatio || me.ticks.length / (skipRatio || 1) > maxTicks) {
							if (!skipRatio) {
								skipRatio = 1;
							}
							skipRatio += 1;
						}
					}
	
					if (!useAutoskipper) {
						skipRatio = false;
					}
				}
	
	
				var xTickStart = options.position === 'right' ? me.left : me.right - tl;
				var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
				var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
				var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;
	
				helpers.each(me.ticks, function(label, index) {
					// If the callback returned a null or undefined value, do not draw this line
					if (label === undefined || label === null) {
						return;
					}
	
					var isLastTick = me.ticks.length === index + 1;
	
					// Since we always show the last tick,we need may need to hide the last shown one before
					var shouldSkip = (skipRatio > 1 && index % skipRatio > 0) || (index % skipRatio === 0 && index + skipRatio >= me.ticks.length);
					if (shouldSkip && !isLastTick || (label === undefined || label === null)) {
						return;
					}
	
					var lineWidth, lineColor, borderDash, borderDashOffset;
					if (index === (typeof me.zeroLineIndex !== 'undefined' ? me.zeroLineIndex : 0)) {
						// Draw the first index specially
						lineWidth = gridLines.zeroLineWidth;
						lineColor = gridLines.zeroLineColor;
						borderDash = gridLines.zeroLineBorderDash;
						borderDashOffset = gridLines.zeroLineBorderDashOffset;
					} else {
						lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, index);
						lineColor = helpers.getValueAtIndexOrDefault(gridLines.color, index);
						borderDash = helpers.getValueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
						borderDashOffset = helpers.getValueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
					}
	
					// Common properties
					var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
					var textAlign = 'middle';
					var textBaseline = 'middle';
	
					if (isHorizontal) {
	
						if (options.position === 'bottom') {
							// bottom
							textBaseline = !isRotated? 'top':'middle';
							textAlign = !isRotated? 'center': 'right';
							labelY = me.top + tl;
						} else {
							// top
							textBaseline = !isRotated? 'bottom':'middle';
							textAlign = !isRotated? 'center': 'left';
							labelY = me.bottom - tl;
						}
	
						var xLineValue = me.getPixelForTick(index) + helpers.aliasPixel(lineWidth); // xvalues for grid lines
						labelX = me.getPixelForTick(index, gridLines.offsetGridLines) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)
	
						tx1 = tx2 = x1 = x2 = xLineValue;
						ty1 = yTickStart;
						ty2 = yTickEnd;
						y1 = chartArea.top;
						y2 = chartArea.bottom;
					} else {
						var isLeft = options.position === 'left';
						var tickPadding = optionTicks.padding;
						var labelXOffset;
	
						if (optionTicks.mirror) {
							textAlign = isLeft ? 'left' : 'right';
							labelXOffset = tickPadding;
						} else {
							textAlign = isLeft ? 'right' : 'left';
							labelXOffset = tl + tickPadding;
						}
	
						labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;
	
						var yLineValue = me.getPixelForTick(index); // xvalues for grid lines
						yLineValue += helpers.aliasPixel(lineWidth);
						labelY = me.getPixelForTick(index, gridLines.offsetGridLines);
	
						tx1 = xTickStart;
						tx2 = xTickEnd;
						x1 = chartArea.left;
						x2 = chartArea.right;
						ty1 = ty2 = y1 = y2 = yLineValue;
					}
	
					itemsToDraw.push({
						tx1: tx1,
						ty1: ty1,
						tx2: tx2,
						ty2: ty2,
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						labelX: labelX,
						labelY: labelY,
						glWidth: lineWidth,
						glColor: lineColor,
						glBorderDash: borderDash,
						glBorderDashOffset: borderDashOffset,
						rotation: -1 * labelRotationRadians,
						label: label,
						textBaseline: textBaseline,
						textAlign: textAlign
					});
				});
	
				// Draw all of the tick labels, tick marks, and grid lines at the correct places
				helpers.each(itemsToDraw, function(itemToDraw) {
					if (gridLines.display) {
						context.save();
						context.lineWidth = itemToDraw.glWidth;
						context.strokeStyle = itemToDraw.glColor;
						if (context.setLineDash) {
							context.setLineDash(itemToDraw.glBorderDash);
							context.lineDashOffset = itemToDraw.glBorderDashOffset;
						}
	
						context.beginPath();
	
						if (gridLines.drawTicks) {
							context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
							context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
						}
	
						if (gridLines.drawOnChartArea) {
							context.moveTo(itemToDraw.x1, itemToDraw.y1);
							context.lineTo(itemToDraw.x2, itemToDraw.y2);
						}
	
						context.stroke();
						context.restore();
					}
	
					if (optionTicks.display) {
						context.save();
						context.translate(itemToDraw.labelX, itemToDraw.labelY);
						context.rotate(itemToDraw.rotation);
						context.font = tickFont.font;
						context.textBaseline = itemToDraw.textBaseline;
						context.textAlign = itemToDraw.textAlign;
	
						var label = itemToDraw.label;
						if (helpers.isArray(label)) {
							for (var i = 0, y = 0; i < label.length; ++i) {
								// We just make sure the multiline element is a string here..
								context.fillText('' + label[i], 0, y);
								// apply same lineSpacing as calculated @ L#320
								y += (tickFont.size * 1.5);
							}
						} else {
							context.fillText(label, 0, 0);
						}
						context.restore();
					}
				});
	
				if (scaleLabel.display) {
					// Draw the scale label
					var scaleLabelX;
					var scaleLabelY;
					var rotation = 0;
	
					if (isHorizontal) {
						scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
						scaleLabelY = options.position === 'bottom' ? me.bottom - (scaleLabelFont.size / 2) : me.top + (scaleLabelFont.size / 2);
					} else {
						var isLeft = options.position === 'left';
						scaleLabelX = isLeft ? me.left + (scaleLabelFont.size / 2) : me.right - (scaleLabelFont.size / 2);
						scaleLabelY = me.top + ((me.bottom - me.top) / 2);
						rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
					}
	
					context.save();
					context.translate(scaleLabelX, scaleLabelY);
					context.rotate(rotation);
					context.textAlign = 'center';
					context.textBaseline = 'middle';
					context.fillStyle = scaleLabelFontColor; // render in correct colour
					context.font = scaleLabelFont.font;
					context.fillText(scaleLabel.labelString, 0, 0);
					context.restore();
				}
	
				if (gridLines.drawBorder) {
					// Draw the line at the edge of the axis
					context.lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, 0);
					context.strokeStyle = helpers.getValueAtIndexOrDefault(gridLines.color, 0);
					var x1 = me.left,
						x2 = me.right,
						y1 = me.top,
						y2 = me.bottom;
	
					var aliasPixel = helpers.aliasPixel(context.lineWidth);
					if (isHorizontal) {
						y1 = y2 = options.position === 'top' ? me.bottom : me.top;
						y1 += aliasPixel;
						y2 += aliasPixel;
					} else {
						x1 = x2 = options.position === 'left' ? me.right : me.left;
						x1 += aliasPixel;
						x2 += aliasPixel;
					}
	
					context.beginPath();
					context.moveTo(x1, y1);
					context.lineTo(x2, y2);
					context.stroke();
				}
			}
		});
	};


/***/ }),
/* 370 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		var helpers = Chart.helpers;
	
		/**
		 * Helper function to get relative position for an event
		 * @param {Event|IEvent} event - The event to get the position for
		 * @param {Chart} chart - The chart
		 * @returns {Point} the event position
		 */
		function getRelativePosition(e, chart) {
			if (e.native) {
				return {
					x: e.x,
					y: e.y
				};
			}
	
			return helpers.getRelativePosition(e, chart);
		}
	
		/**
		 * Helper function to traverse all of the visible elements in the chart
		 * @param chart {chart} the chart
		 * @param handler {Function} the callback to execute for each visible item
		 */
		function parseVisibleItems(chart, handler) {
			var datasets = chart.data.datasets;
			var meta, i, j, ilen, jlen;
	
			for (i = 0, ilen = datasets.length; i < ilen; ++i) {
				if (!chart.isDatasetVisible(i)) {
					continue;
				}
	
				meta = chart.getDatasetMeta(i);
				for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
					var element = meta.data[j];
					if (!element._view.skip) {
						handler(element);
					}
				}
			}
		}
	
		/**
		 * Helper function to get the items that intersect the event position
		 * @param items {ChartElement[]} elements to filter
		 * @param position {Point} the point to be nearest to
		 * @return {ChartElement[]} the nearest items
		 */
		function getIntersectItems(chart, position) {
			var elements = [];
	
			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
				}
			});
	
			return elements;
		}
	
		/**
		 * Helper function to get the items nearest to the event position considering all visible items in teh chart
		 * @param chart {Chart} the chart to look at elements from
		 * @param position {Point} the point to be nearest to
		 * @param intersect {Boolean} if true, only consider items that intersect the position
		 * @param distanceMetric {Function} Optional function to provide the distance between
		 * @return {ChartElement[]} the nearest items
		 */
		function getNearestItems(chart, position, intersect, distanceMetric) {
			var minDistance = Number.POSITIVE_INFINITY;
			var nearestItems = [];
	
			if (!distanceMetric) {
				distanceMetric = helpers.distanceBetweenPoints;
			}
	
			parseVisibleItems(chart, function(element) {
				if (intersect && !element.inRange(position.x, position.y)) {
					return;
				}
	
				var center = element.getCenterPoint();
				var distance = distanceMetric(position, center);
	
				if (distance < minDistance) {
					nearestItems = [element];
					minDistance = distance;
				} else if (distance === minDistance) {
					// Can have multiple items at the same distance in which case we sort by size
					nearestItems.push(element);
				}
			});
	
			return nearestItems;
		}
	
		function indexMode(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var distanceMetric = function(pt1, pt2) {
				return Math.abs(pt1.x - pt2.x);
			};
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
			var elements = [];
	
			if (!items.length) {
				return [];
			}
	
			chart.data.datasets.forEach(function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex),
						element = meta.data[items[0]._index];
	
					// don't count items that are skipped (null data)
					if (element && !element._view.skip) {
						elements.push(element);
					}
				}
			});
	
			return elements;
		}
	
		/**
		 * @interface IInteractionOptions
		 */
		/**
		 * If true, only consider items that intersect the point
		 * @name IInterfaceOptions#boolean
		 * @type Boolean
		 */
	
		/**
		 * Contains interaction related functions
		 * @namespace Chart.Interaction
		 */
		Chart.Interaction = {
			// Helper function for different modes
			modes: {
				single: function(chart, e) {
					var position = getRelativePosition(e, chart);
					var elements = [];
	
					parseVisibleItems(chart, function(element) {
						if (element.inRange(position.x, position.y)) {
							elements.push(element);
							return elements;
						}
					});
	
					return elements.slice(0, 1);
				},
	
				/**
				 * @function Chart.Interaction.modes.label
				 * @deprecated since version 2.4.0
		 		 * @todo remove at version 3
				 * @private
				 */
				label: indexMode,
	
				/**
				 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
				 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
				 * @function Chart.Interaction.modes.index
				 * @since v2.4.0
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use during interaction
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				index: indexMode,
	
				/**
				 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
				 * If the options.intersect is false, we find the nearest item and return the items in that dataset
				 * @function Chart.Interaction.modes.dataset
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use during interaction
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				dataset: function(chart, e, options) {
					var position = getRelativePosition(e, chart);
					var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false);
	
					if (items.length > 0) {
						items = chart.getDatasetMeta(items[0]._datasetIndex).data;
					}
	
					return items;
				},
	
				/**
				 * @function Chart.Interaction.modes.x-axis
				 * @deprecated since version 2.4.0. Use index mode and intersect == true
				 * @todo remove at version 3
				 * @private
				 */
				'x-axis': function(chart, e) {
					return indexMode(chart, e, true);
				},
	
				/**
				 * Point mode returns all elements that hit test based on the event position
				 * of the event
				 * @function Chart.Interaction.modes.intersect
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				point: function(chart, e) {
					var position = getRelativePosition(e, chart);
					return getIntersectItems(chart, position);
				},
	
				/**
				 * nearest mode returns the element closest to the point
				 * @function Chart.Interaction.modes.intersect
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				nearest: function(chart, e, options) {
					var position = getRelativePosition(e, chart);
					var nearestItems = getNearestItems(chart, position, options.intersect);
	
					// We have multiple items at the same distance from the event. Now sort by smallest
					if (nearestItems.length > 1) {
						nearestItems.sort(function(a, b) {
							var sizeA = a.getArea();
							var sizeB = b.getArea();
							var ret = sizeA - sizeB;
	
							if (ret === 0) {
								// if equal sort by dataset index
								ret = a._datasetIndex - b._datasetIndex;
							}
	
							return ret;
						});
					}
	
					// Return only 1 item
					return nearestItems.slice(0, 1);
				},
	
				/**
				 * x mode returns the elements that hit-test at the current x coordinate
				 * @function Chart.Interaction.modes.x
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				x: function(chart, e, options) {
					var position = getRelativePosition(e, chart);
					var items = [];
					var intersectsItem = false;
	
					parseVisibleItems(chart, function(element) {
						if (element.inXRange(position.x)) {
							items.push(element);
						}
	
						if (element.inRange(position.x, position.y)) {
							intersectsItem = true;
						}
					});
	
					// If we want to trigger on an intersect and we don't have any items
					// that intersect the position, return nothing
					if (options.intersect && !intersectsItem) {
						items = [];
					}
					return items;
				},
	
				/**
				 * y mode returns the elements that hit-test at the current y coordinate
				 * @function Chart.Interaction.modes.y
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				y: function(chart, e, options) {
					var position = getRelativePosition(e, chart);
					var items = [];
					var intersectsItem = false;
	
					parseVisibleItems(chart, function(element) {
						if (element.inYRange(position.y)) {
							items.push(element);
						}
	
						if (element.inRange(position.x, position.y)) {
							intersectsItem = true;
						}
					});
	
					// If we want to trigger on an intersect and we don't have any items
					// that intersect the position, return nothing
					if (options.intersect && !intersectsItem) {
						items = [];
					}
					return items;
				}
			}
		};
	};


/***/ }),
/* 371 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		/**
	 	 * Helper method to merge the opacity into a color
	 	 */
		function mergeOpacity(colorString, opacity) {
			var color = helpers.color(colorString);
			return color.alpha(opacity * color.alpha()).rgbaString();
		}
	
		Chart.defaults.global.tooltips = {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
	
						if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					label += tooltipItem.yLabel;
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				afterLabel: helpers.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers.noop,
				footer: helpers.noop,
				afterFooter: helpers.noop
			}
		};
	
		// Helper to push or concat based on if the 2nd parameter is an array or not
		function pushOrConcat(base, toPush) {
			if (toPush) {
				if (helpers.isArray(toPush)) {
					// base = base.concat(toPush);
					Array.prototype.push.apply(base, toPush);
				} else {
					base.push(toPush);
				}
			}
	
			return base;
		}
	
		// Private helper to create a tooltip item model
		// @param element : the chart element (point, arc, bar) to create the tooltip item for
		// @return : new tooltip item
		function createTooltipItem(element) {
			var xScale = element._xScale;
			var yScale = element._yScale || element._scale; // handle radar || polarArea charts
			var index = element._index,
				datasetIndex = element._datasetIndex;
	
			return {
				xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
				yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
				index: index,
				datasetIndex: datasetIndex,
				x: element._model.x,
				y: element._model.y
			};
		}
	
		/**
		 * Helper to get the reset model for the tooltip
		 * @param tooltipOpts {Object} the tooltip options
		 */
		function getBaseModel(tooltipOpts) {
			var globalDefaults = Chart.defaults.global;
			var getValueOrDefault = helpers.getValueOrDefault;
	
			return {
				// Positioning
				xPadding: tooltipOpts.xPadding,
				yPadding: tooltipOpts.yPadding,
				xAlign: tooltipOpts.xAlign,
				yAlign: tooltipOpts.yAlign,
	
				// Body
				bodyFontColor: tooltipOpts.bodyFontColor,
				_bodyFontFamily: getValueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
				_bodyFontStyle: getValueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
				_bodyAlign: tooltipOpts.bodyAlign,
				bodyFontSize: getValueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
				bodySpacing: tooltipOpts.bodySpacing,
	
				// Title
				titleFontColor: tooltipOpts.titleFontColor,
				_titleFontFamily: getValueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
				_titleFontStyle: getValueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
				titleFontSize: getValueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
				_titleAlign: tooltipOpts.titleAlign,
				titleSpacing: tooltipOpts.titleSpacing,
				titleMarginBottom: tooltipOpts.titleMarginBottom,
	
				// Footer
				footerFontColor: tooltipOpts.footerFontColor,
				_footerFontFamily: getValueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
				_footerFontStyle: getValueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
				footerFontSize: getValueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
				_footerAlign: tooltipOpts.footerAlign,
				footerSpacing: tooltipOpts.footerSpacing,
				footerMarginTop: tooltipOpts.footerMarginTop,
	
				// Appearance
				caretSize: tooltipOpts.caretSize,
				cornerRadius: tooltipOpts.cornerRadius,
				backgroundColor: tooltipOpts.backgroundColor,
				opacity: 0,
				legendColorBackground: tooltipOpts.multiKeyBackground,
				displayColors: tooltipOpts.displayColors,
				borderColor: tooltipOpts.borderColor,
				borderWidth: tooltipOpts.borderWidth
			};
		}
	
		/**
		 * Get the size of the tooltip
		 */
		function getTooltipSize(tooltip, model) {
			var ctx = tooltip._chart.ctx;
	
			var height = model.yPadding * 2; // Tooltip Padding
			var width = 0;
	
			// Count of all lines in the body
			var body = model.body;
			var combinedBodyLength = body.reduce(function(count, bodyItem) {
				return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
			}, 0);
			combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
			var titleLineCount = model.title.length;
			var footerLineCount = model.footer.length;
			var titleFontSize = model.titleFontSize,
				bodyFontSize = model.bodyFontSize,
				footerFontSize = model.footerFontSize;
	
			height += titleLineCount * titleFontSize; // Title Lines
			height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
			height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
			height += combinedBodyLength * bodyFontSize; // Body Lines
			height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
			height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
			height += footerLineCount * (footerFontSize); // Footer Lines
			height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
			// Title width
			var widthPadding = 0;
			var maxLineWidth = function(line) {
				width = Math.max(width, ctx.measureText(line).width + widthPadding);
			};
	
			ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
			helpers.each(model.title, maxLineWidth);
	
			// Body width
			ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
			helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
			// Body lines may include some extra width due to the color box
			widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
			helpers.each(body, function(bodyItem) {
				helpers.each(bodyItem.before, maxLineWidth);
				helpers.each(bodyItem.lines, maxLineWidth);
				helpers.each(bodyItem.after, maxLineWidth);
			});
	
			// Reset back to 0
			widthPadding = 0;
	
			// Footer width
			ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
			helpers.each(model.footer, maxLineWidth);
	
			// Add padding
			width += 2 * model.xPadding;
	
			return {
				width: width,
				height: height
			};
		}
	
		/**
		 * Helper to get the alignment of a tooltip given the size
		 */
		function determineAlignment(tooltip, size) {
			var model = tooltip._model;
			var chart = tooltip._chart;
			var chartArea = tooltip._chart.chartArea;
			var xAlign = 'center';
			var yAlign = 'center';
	
			if (model.y < size.height) {
				yAlign = 'top';
			} else if (model.y > (chart.height - size.height)) {
				yAlign = 'bottom';
			}
	
			var lf, rf; // functions to determine left, right alignment
			var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
			var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
			var midX = (chartArea.left + chartArea.right) / 2;
			var midY = (chartArea.top + chartArea.bottom) / 2;
	
			if (yAlign === 'center') {
				lf = function(x) {
					return x <= midX;
				};
				rf = function(x) {
					return x > midX;
				};
			} else {
				lf = function(x) {
					return x <= (size.width / 2);
				};
				rf = function(x) {
					return x >= (chart.width - (size.width / 2));
				};
			}
	
			olf = function(x) {
				return x + size.width > chart.width;
			};
			orf = function(x) {
				return x - size.width < 0;
			};
			yf = function(y) {
				return y <= midY ? 'top' : 'bottom';
			};
	
			if (lf(model.x)) {
				xAlign = 'left';
	
				// Is tooltip too wide and goes over the right side of the chart.?
				if (olf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			} else if (rf(model.x)) {
				xAlign = 'right';
	
				// Is tooltip too wide and goes outside left edge of canvas?
				if (orf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			}
	
			var opts = tooltip._options;
			return {
				xAlign: opts.xAlign ? opts.xAlign : xAlign,
				yAlign: opts.yAlign ? opts.yAlign : yAlign
			};
		}
	
		/**
		 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
		 */
		function getBackgroundPoint(vm, size, alignment) {
			// Background Position
			var x = vm.x;
			var y = vm.y;
	
			var caretSize = vm.caretSize,
				caretPadding = vm.caretPadding,
				cornerRadius = vm.cornerRadius,
				xAlign = alignment.xAlign,
				yAlign = alignment.yAlign,
				paddingAndSize = caretSize + caretPadding,
				radiusAndPadding = cornerRadius + caretPadding;
	
			if (xAlign === 'right') {
				x -= size.width;
			} else if (xAlign === 'center') {
				x -= (size.width / 2);
			}
	
			if (yAlign === 'top') {
				y += paddingAndSize;
			} else if (yAlign === 'bottom') {
				y -= size.height + paddingAndSize;
			} else {
				y -= (size.height / 2);
			}
	
			if (yAlign === 'center') {
				if (xAlign === 'left') {
					x += paddingAndSize;
				} else if (xAlign === 'right') {
					x -= paddingAndSize;
				}
			} else if (xAlign === 'left') {
				x -= radiusAndPadding;
			} else if (xAlign === 'right') {
				x += radiusAndPadding;
			}
	
			return {
				x: x,
				y: y
			};
		}
	
		Chart.Tooltip = Chart.Element.extend({
			initialize: function() {
				this._model = getBaseModel(this._options);
			},
	
			// Get the title
			// Args are: (tooltipItem, data)
			getTitle: function() {
				var me = this;
				var opts = me._options;
				var callbacks = opts.callbacks;
	
				var beforeTitle = callbacks.beforeTitle.apply(me, arguments),
					title = callbacks.title.apply(me, arguments),
					afterTitle = callbacks.afterTitle.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeTitle);
				lines = pushOrConcat(lines, title);
				lines = pushOrConcat(lines, afterTitle);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getBeforeBody: function() {
				var lines = this._options.callbacks.beforeBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Args are: (tooltipItem, data)
			getBody: function(tooltipItems, data) {
				var me = this;
				var callbacks = me._options.callbacks;
				var bodyItems = [];
	
				helpers.each(tooltipItems, function(tooltipItem) {
					var bodyItem = {
						before: [],
						lines: [],
						after: []
					};
					pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));
	
					bodyItems.push(bodyItem);
				});
	
				return bodyItems;
			},
	
			// Args are: (tooltipItem, data)
			getAfterBody: function() {
				var lines = this._options.callbacks.afterBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Get the footer and beforeFooter and afterFooter lines
			// Args are: (tooltipItem, data)
			getFooter: function() {
				var me = this;
				var callbacks = me._options.callbacks;
	
				var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
				var footer = callbacks.footer.apply(me, arguments);
				var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeFooter);
				lines = pushOrConcat(lines, footer);
				lines = pushOrConcat(lines, afterFooter);
	
				return lines;
			},
	
			update: function(changed) {
				var me = this;
				var opts = me._options;
	
				// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
				// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
				// which breaks any animations.
				var existingModel = me._model;
				var model = me._model = getBaseModel(opts);
				var active = me._active;
	
				var data = me._data;
	
				// In the case where active.length === 0 we need to keep these at existing values for good animations
				var alignment = {
					xAlign: existingModel.xAlign,
					yAlign: existingModel.yAlign
				};
				var backgroundPoint = {
					x: existingModel.x,
					y: existingModel.y
				};
				var tooltipSize = {
					width: existingModel.width,
					height: existingModel.height
				};
				var tooltipPosition = {
					x: existingModel.caretX,
					y: existingModel.caretY
				};
	
				var i, len;
	
				if (active.length) {
					model.opacity = 1;
	
					var labelColors = [];
					tooltipPosition = Chart.Tooltip.positioners[opts.position](active, me._eventPosition);
	
					var tooltipItems = [];
					for (i = 0, len = active.length; i < len; ++i) {
						tooltipItems.push(createTooltipItem(active[i]));
					}
	
					// If the user provided a filter function, use it to modify the tooltip items
					if (opts.filter) {
						tooltipItems = tooltipItems.filter(function(a) {
							return opts.filter(a, data);
						});
					}
	
					// If the user provided a sorting function, use it to modify the tooltip items
					if (opts.itemSort) {
						tooltipItems = tooltipItems.sort(function(a, b) {
							return opts.itemSort(a, b, data);
						});
					}
	
					// Determine colors for boxes
					helpers.each(tooltipItems, function(tooltipItem) {
						labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					});
	
					// Build the Text Lines
					model.title = me.getTitle(tooltipItems, data);
					model.beforeBody = me.getBeforeBody(tooltipItems, data);
					model.body = me.getBody(tooltipItems, data);
					model.afterBody = me.getAfterBody(tooltipItems, data);
					model.footer = me.getFooter(tooltipItems, data);
	
					// Initial positioning and colors
					model.x = Math.round(tooltipPosition.x);
					model.y = Math.round(tooltipPosition.y);
					model.caretPadding = opts.caretPadding;
					model.labelColors = labelColors;
	
					// data points
					model.dataPoints = tooltipItems;
	
					// We need to determine alignment of the tooltip
					tooltipSize = getTooltipSize(this, model);
					alignment = determineAlignment(this, tooltipSize);
					// Final Size and Position
					backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment);
				} else {
					model.opacity = 0;
				}
	
				model.xAlign = alignment.xAlign;
				model.yAlign = alignment.yAlign;
				model.x = backgroundPoint.x;
				model.y = backgroundPoint.y;
				model.width = tooltipSize.width;
				model.height = tooltipSize.height;
	
				// Point where the caret on the tooltip points to
				model.caretX = tooltipPosition.x;
				model.caretY = tooltipPosition.y;
	
				me._model = model;
	
				if (changed && opts.custom) {
					opts.custom.call(me, model);
				}
	
				return me;
			},
			drawCaret: function(tooltipPoint, size) {
				var ctx = this._chart.ctx;
				var vm = this._view;
				var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
				ctx.lineTo(caretPosition.x1, caretPosition.y1);
				ctx.lineTo(caretPosition.x2, caretPosition.y2);
				ctx.lineTo(caretPosition.x3, caretPosition.y3);
			},
			getCaretPosition: function(tooltipPoint, size, vm) {
				var x1, x2, x3;
				var y1, y2, y3;
				var caretSize = vm.caretSize;
				var cornerRadius = vm.cornerRadius;
				var xAlign = vm.xAlign,
					yAlign = vm.yAlign;
				var ptX = tooltipPoint.x,
					ptY = tooltipPoint.y;
				var width = size.width,
					height = size.height;
	
				if (yAlign === 'center') {
					y2 = ptY + (height / 2);
	
					if (xAlign === 'left') {
						x1 = ptX;
						x2 = x1 - caretSize;
						x3 = x1;
	
						y1 = y2 + caretSize;
						y3 = y2 - caretSize;
					} else {
						x1 = ptX + width;
						x2 = x1 + caretSize;
						x3 = x1;
	
						y1 = y2 - caretSize;
						y3 = y2 + caretSize;
					}
				} else {
					if (xAlign === 'left') {
						x2 = ptX + cornerRadius + (caretSize);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					} else if (xAlign === 'right') {
						x2 = ptX + width - cornerRadius - caretSize;
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					} else {
						x2 = ptX + (width / 2);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					}
					if (yAlign === 'top') {
						y1 = ptY;
						y2 = y1 - caretSize;
						y3 = y1;
					} else {
						y1 = ptY + height;
						y2 = y1 + caretSize;
						y3 = y1;
						// invert drawing order
						var tmp = x3;
						x3 = x1;
						x1 = tmp;
					}
				}
				return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
			},
			drawTitle: function(pt, vm, ctx, opacity) {
				var title = vm.title;
	
				if (title.length) {
					ctx.textAlign = vm._titleAlign;
					ctx.textBaseline = 'top';
	
					var titleFontSize = vm.titleFontSize,
						titleSpacing = vm.titleSpacing;
	
					ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
					ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
					var i, len;
					for (i = 0, len = title.length; i < len; ++i) {
						ctx.fillText(title[i], pt.x, pt.y);
						pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
						if (i + 1 === title.length) {
							pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
						}
					}
				}
			},
			drawBody: function(pt, vm, ctx, opacity) {
				var bodyFontSize = vm.bodyFontSize;
				var bodySpacing = vm.bodySpacing;
				var body = vm.body;
	
				ctx.textAlign = vm._bodyAlign;
				ctx.textBaseline = 'top';
	
				var textColor = mergeOpacity(vm.bodyFontColor, opacity);
				ctx.fillStyle = textColor;
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
				// Before Body
				var xLinePadding = 0;
				var fillLineOfText = function(line) {
					ctx.fillText(line, pt.x + xLinePadding, pt.y);
					pt.y += bodyFontSize + bodySpacing;
				};
	
				// Before body lines
				helpers.each(vm.beforeBody, fillLineOfText);
	
				var drawColorBoxes = vm.displayColors;
				xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;
	
				// Draw body lines now
				helpers.each(body, function(bodyItem, i) {
					helpers.each(bodyItem.before, fillLineOfText);
	
					helpers.each(bodyItem.lines, function(line) {
						// Draw Legend-like boxes if needed
						if (drawColorBoxes) {
							// Fill a white rect so that colours merge nicely if the opacity is < 1
							ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
							ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Border
							ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
							ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Inner square
							ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
							ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
	
							ctx.fillStyle = textColor;
						}
	
						fillLineOfText(line);
					});
	
					helpers.each(bodyItem.after, fillLineOfText);
				});
	
				// Reset back to 0 for after body
				xLinePadding = 0;
	
				// After body lines
				helpers.each(vm.afterBody, fillLineOfText);
				pt.y -= bodySpacing; // Remove last body spacing
			},
			drawFooter: function(pt, vm, ctx, opacity) {
				var footer = vm.footer;
	
				if (footer.length) {
					pt.y += vm.footerMarginTop;
	
					ctx.textAlign = vm._footerAlign;
					ctx.textBaseline = 'top';
	
					ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
					ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
					helpers.each(footer, function(line) {
						ctx.fillText(line, pt.x, pt.y);
						pt.y += vm.footerFontSize + vm.footerSpacing;
					});
				}
			},
			drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
				ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
				ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
				ctx.lineWidth = vm.borderWidth;
				var xAlign = vm.xAlign;
				var yAlign = vm.yAlign;
				var x = pt.x;
				var y = pt.y;
				var width = tooltipSize.width;
				var height = tooltipSize.height;
				var radius = vm.cornerRadius;
	
				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				if (yAlign === 'top') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + width - radius, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
				if (yAlign === 'center' && xAlign === 'right') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + width, y + height - radius);
				ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
				if (yAlign === 'bottom') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + radius, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
				if (yAlign === 'center' && xAlign === 'left') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x, y + radius);
				ctx.quadraticCurveTo(x, y, x + radius, y);
				ctx.closePath();
	
				ctx.fill();
	
				if (vm.borderWidth > 0) {
					ctx.stroke();
				}
			},
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				if (vm.opacity === 0) {
					return;
				}
	
				var tooltipSize = {
					width: vm.width,
					height: vm.height
				};
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				// IE11/Edge does not like very small opacities, so snap to 0
				var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
				// Truthy/falsey value for empty tooltip
				var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
				if (this._options.enabled && hasTooltipContent) {
					// Draw Background
					this.drawBackground(pt, vm, ctx, tooltipSize, opacity);
	
					// Draw Title, Body, and Footer
					pt.x += vm.xPadding;
					pt.y += vm.yPadding;
	
					// Titles
					this.drawTitle(pt, vm, ctx, opacity);
	
					// Body
					this.drawBody(pt, vm, ctx, opacity);
	
					// Footer
					this.drawFooter(pt, vm, ctx, opacity);
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @returns {Boolean} true if the tooltip changed
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me._options;
				var changed = false;
	
				me._lastActive = me._lastActive || [];
	
				// Find Active Elements for tooltips
				if (e.type === 'mouseout') {
					me._active = [];
				} else {
					me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				}
	
				// Remember Last Actives
				changed = !helpers.arrayEquals(me._active, me._lastActive);
	
				// If tooltip didn't change, do not handle the target event
				if (!changed) {
					return false;
				}
	
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					var model = me._model;
					me.update(true);
					me.pivot();
	
					// See if our tooltip position changed
					changed |= (model.x !== me._model.x) || (model.y !== me._model.y);
				}
	
				return changed;
			}
		});
	
		/**
		 * @namespace Chart.Tooltip.positioners
		 */
		Chart.Tooltip.positioners = {
			/**
			 * Average mode places the tooltip at the average position of the elements shown
			 * @function Chart.Tooltip.positioners.average
			 * @param elements {ChartElement[]} the elements being displayed in the tooltip
			 * @returns {Point} tooltip position
			 */
			average: function(elements) {
				if (!elements.length) {
					return false;
				}
	
				var i, len;
				var x = 0;
				var y = 0;
				var count = 0;
	
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var pos = el.tooltipPosition();
						x += pos.x;
						y += pos.y;
						++count;
					}
				}
	
				return {
					x: Math.round(x / count),
					y: Math.round(y / count)
				};
			},
	
			/**
			 * Gets the tooltip position nearest of the item nearest to the event position
			 * @function Chart.Tooltip.positioners.nearest
			 * @param elements {Chart.Element[]} the tooltip elements
			 * @param eventPosition {Point} the position of the event in canvas coordinates
			 * @returns {Point} the tooltip position
			 */
			nearest: function(elements, eventPosition) {
				var x = eventPosition.x;
				var y = eventPosition.y;
	
				var nearestElement;
				var minDistance = Number.POSITIVE_INFINITY;
				var i, len;
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var center = el.getCenterPoint();
						var d = helpers.distanceBetweenPoints(eventPosition, center);
	
						if (d < minDistance) {
							minDistance = d;
							nearestElement = el;
						}
					}
				}
	
				if (nearestElement) {
					var tp = nearestElement.tooltipPosition();
					x = tp.x;
					y = tp.y;
				}
	
				return {
					x: x,
					y: y
				};
			}
		};
	};


/***/ }),
/* 372 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global;
	
		globalOpts.elements.arc = {
			backgroundColor: globalOpts.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		};
	
		Chart.elements.Arc = Chart.Element.extend({
			inLabelRange: function(mouseX) {
				var vm = this._view;
	
				if (vm) {
					return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
				}
				return false;
			},
			inRange: function(chartX, chartY) {
				var vm = this._view;
	
				if (vm) {
					var pointRelativePosition = helpers.getAngleFromPoint(vm, {
							x: chartX,
							y: chartY
						}),
						angle = pointRelativePosition.angle,
						distance = pointRelativePosition.distance;
	
					// Sanitise angle range
					var startAngle = vm.startAngle;
					var endAngle = vm.endAngle;
					while (endAngle < startAngle) {
						endAngle += 2.0 * Math.PI;
					}
					while (angle > endAngle) {
						angle -= 2.0 * Math.PI;
					}
					while (angle < startAngle) {
						angle += 2.0 * Math.PI;
					}
	
					// Check if within the range of the open/close angle
					var betweenAngles = (angle >= startAngle && angle <= endAngle),
						withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
					return (betweenAngles && withinRadius);
				}
				return false;
			},
			getCenterPoint: function() {
				var vm = this._view;
				var halfAngle = (vm.startAngle + vm.endAngle) / 2;
				var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
				return {
					x: vm.x + Math.cos(halfAngle) * halfRadius,
					y: vm.y + Math.sin(halfAngle) * halfRadius
				};
			},
			getArea: function() {
				var vm = this._view;
				return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
			},
			tooltipPosition: function() {
				var vm = this._view;
	
				var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2),
					rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
				return {
					x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
					y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
				};
			},
			draw: function() {
	
				var ctx = this._chart.ctx,
					vm = this._view,
					sA = vm.startAngle,
					eA = vm.endAngle;
	
				ctx.beginPath();
	
				ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
				ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
	
				ctx.closePath();
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = vm.borderWidth;
	
				ctx.fillStyle = vm.backgroundColor;
	
				ctx.fill();
				ctx.lineJoin = 'bevel';
	
				if (vm.borderWidth) {
					ctx.stroke();
				}
			}
		});
	};


/***/ }),
/* 373 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		Chart.defaults.global.elements.line = {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		};
	
		Chart.elements.Line = Chart.Element.extend({
			draw: function() {
				var me = this;
				var vm = me._view;
				var ctx = me._chart.ctx;
				var spanGaps = vm.spanGaps;
				var points = me._children.slice(); // clone array
				var globalOptionLineElements = globalDefaults.elements.line;
				var lastDrawnIndex = -1;
				var index, current, previous, currentVM;
	
				// If we are looping, adding the first point again
				if (me._loop && points.length) {
					points.push(points[0]);
				}
	
				ctx.save();
	
				// Stroke Line Options
				ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
				// IE 9 and 10 do not support line dash
				if (ctx.setLineDash) {
					ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
				}
	
				ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
				ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
				ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
				ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
				// Stroke Line
				ctx.beginPath();
				lastDrawnIndex = -1;
	
				for (index = 0; index < points.length; ++index) {
					current = points[index];
					previous = helpers.previousItem(points, index);
					currentVM = current._view;
	
					// First point moves to it's starting position no matter what
					if (index === 0) {
						if (!currentVM.skip) {
							ctx.moveTo(currentVM.x, currentVM.y);
							lastDrawnIndex = index;
						}
					} else {
						previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
						if (!currentVM.skip) {
							if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
								// There was a gap and this is the first point after the gap
								ctx.moveTo(currentVM.x, currentVM.y);
							} else {
								// Line to next point
								helpers.canvas.lineTo(ctx, previous._view, current._view);
							}
							lastDrawnIndex = index;
						}
					}
				}
	
				ctx.stroke();
				ctx.restore();
			}
		});
	};


/***/ }),
/* 374 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global,
			defaultColor = globalOpts.defaultColor;
	
		globalOpts.elements.point = {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderWidth: 1,
			borderColor: defaultColor,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		};
	
		function xRange(mouseX) {
			var vm = this._view;
			return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
		}
	
		function yRange(mouseY) {
			var vm = this._view;
			return vm ? (Math.pow(mouseY - vm.y, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
		}
	
		Chart.elements.Point = Chart.Element.extend({
			inRange: function(mouseX, mouseY) {
				var vm = this._view;
				return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
			},
	
			inLabelRange: xRange,
			inXRange: xRange,
			inYRange: yRange,
	
			getCenterPoint: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y
				};
			},
			getArea: function() {
				return Math.PI * Math.pow(this._view.radius, 2);
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y,
					padding: vm.radius + vm.borderWidth
				};
			},
			draw: function(chartArea) {
				var vm = this._view;
				var model = this._model;
				var ctx = this._chart.ctx;
				var pointStyle = vm.pointStyle;
				var radius = vm.radius;
				var x = vm.x;
				var y = vm.y;
				var color = Chart.helpers.color;
				var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
				var ratio = 0;
	
				if (vm.skip) {
					return;
				}
	
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = helpers.getValueOrDefault(vm.borderWidth, globalOpts.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
	
				// Cliping for Points.
				// going out from inner charArea?
				if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right*errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom*errMargin < model.y))) {
					// Point fade out
					if (model.x < chartArea.left) {
						ratio = (x - model.x) / (chartArea.left - model.x);
					} else if (chartArea.right*errMargin < model.x) {
						ratio = (model.x - x) / (model.x - chartArea.right);
					} else if (model.y < chartArea.top) {
						ratio = (y - model.y) / (chartArea.top - model.y);
					} else if (chartArea.bottom*errMargin < model.y) {
						ratio = (model.y - y) / (model.y - chartArea.bottom);
					}
					ratio = Math.round(ratio*100) / 100;
					ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
					ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
				}
	
				Chart.canvasHelpers.drawPoint(ctx, pointStyle, radius, x, y);
			}
		});
	};


/***/ }),
/* 375 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var globalOpts = Chart.defaults.global;
	
		globalOpts.elements.rectangle = {
			backgroundColor: globalOpts.defaultColor,
			borderWidth: 0,
			borderColor: globalOpts.defaultColor,
			borderSkipped: 'bottom'
		};
	
		function isVertical(bar) {
			return bar._view.width !== undefined;
		}
	
		/**
		 * Helper function to get the bounds of the bar regardless of the orientation
		 * @private
		 * @param bar {Chart.Element.Rectangle} the bar
		 * @return {Bounds} bounds of the bar
		 */
		function getBarBounds(bar) {
			var vm = bar._view;
			var x1, x2, y1, y2;
	
			if (isVertical(bar)) {
				// vertical
				var halfWidth = vm.width / 2;
				x1 = vm.x - halfWidth;
				x2 = vm.x + halfWidth;
				y1 = Math.min(vm.y, vm.base);
				y2 = Math.max(vm.y, vm.base);
			} else {
				// horizontal bar
				var halfHeight = vm.height / 2;
				x1 = Math.min(vm.x, vm.base);
				x2 = Math.max(vm.x, vm.base);
				y1 = vm.y - halfHeight;
				y2 = vm.y + halfHeight;
			}
	
			return {
				left: x1,
				top: y1,
				right: x2,
				bottom: y2
			};
		}
	
		Chart.elements.Rectangle = Chart.Element.extend({
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
				var left, right, top, bottom, signX, signY, borderSkipped;
				var borderWidth = vm.borderWidth;
	
				if (!vm.horizontal) {
					// bar
					left = vm.x - vm.width / 2;
					right = vm.x + vm.width / 2;
					top = vm.y;
					bottom = vm.base;
					signX = 1;
					signY = bottom > top? 1: -1;
					borderSkipped = vm.borderSkipped || 'bottom';
				} else {
					// horizontal bar
					left = vm.base;
					right = vm.x;
					top = vm.y - vm.height / 2;
					bottom = vm.y + vm.height / 2;
					signX = right > left? 1: -1;
					signY = 1;
					borderSkipped = vm.borderSkipped || 'left';
				}
	
				// Canvas doesn't allow us to stroke inside the width so we can
				// adjust the sizes to fit if we're setting a stroke on the line
				if (borderWidth) {
					// borderWidth shold be less than bar width and bar height.
					var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
					borderWidth = borderWidth > barSize? barSize: borderWidth;
					var halfStroke = borderWidth / 2;
					// Adjust borderWidth when bar top position is near vm.base(zero).
					var borderLeft = left + (borderSkipped !== 'left'? halfStroke * signX: 0);
					var borderRight = right + (borderSkipped !== 'right'? -halfStroke * signX: 0);
					var borderTop = top + (borderSkipped !== 'top'? halfStroke * signY: 0);
					var borderBottom = bottom + (borderSkipped !== 'bottom'? -halfStroke * signY: 0);
					// not become a vertical line?
					if (borderLeft !== borderRight) {
						top = borderTop;
						bottom = borderBottom;
					}
					// not become a horizontal line?
					if (borderTop !== borderBottom) {
						left = borderLeft;
						right = borderRight;
					}
				}
	
				ctx.beginPath();
				ctx.fillStyle = vm.backgroundColor;
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = borderWidth;
	
				// Corner points, from bottom-left to bottom-right clockwise
				// | 1 2 |
				// | 0 3 |
				var corners = [
					[left, bottom],
					[left, top],
					[right, top],
					[right, bottom]
				];
	
				// Find first (starting) corner with fallback to 'bottom'
				var borders = ['bottom', 'left', 'top', 'right'];
				var startCorner = borders.indexOf(borderSkipped, 0);
				if (startCorner === -1) {
					startCorner = 0;
				}
	
				function cornerAt(index) {
					return corners[(startCorner + index) % 4];
				}
	
				// Draw rectangle from 'startCorner'
				var corner = cornerAt(0);
				ctx.moveTo(corner[0], corner[1]);
	
				for (var i = 1; i < 4; i++) {
					corner = cornerAt(i);
					ctx.lineTo(corner[0], corner[1]);
				}
	
				ctx.fill();
				if (borderWidth) {
					ctx.stroke();
				}
			},
			height: function() {
				var vm = this._view;
				return vm.base - vm.y;
			},
			inRange: function(mouseX, mouseY) {
				var inRange = false;
	
				if (this._view) {
					var bounds = getBarBounds(this);
					inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
				}
	
				return inRange;
			},
			inLabelRange: function(mouseX, mouseY) {
				var me = this;
				if (!me._view) {
					return false;
				}
	
				var inRange = false;
				var bounds = getBarBounds(me);
	
				if (isVertical(me)) {
					inRange = mouseX >= bounds.left && mouseX <= bounds.right;
				} else {
					inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
				}
	
				return inRange;
			},
			inXRange: function(mouseX) {
				var bounds = getBarBounds(this);
				return mouseX >= bounds.left && mouseX <= bounds.right;
			},
			inYRange: function(mouseY) {
				var bounds = getBarBounds(this);
				return mouseY >= bounds.top && mouseY <= bounds.bottom;
			},
			getCenterPoint: function() {
				var vm = this._view;
				var x, y;
				if (isVertical(this)) {
					x = vm.x;
					y = (vm.y + vm.base) / 2;
				} else {
					x = (vm.x + vm.base) / 2;
					y = vm.y;
				}
	
				return {x: x, y: y};
			},
			getArea: function() {
				var vm = this._view;
				return vm.width * Math.abs(vm.y - vm.base);
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y
				};
			}
		});
	
	};


/***/ }),
/* 376 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			noop = helpers.noop;
	
		Chart.LinearScaleBase = Chart.Scale.extend({
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (tickOpts.beginAtZero) {
					var minSign = helpers.sign(me.min);
					var maxSign = helpers.sign(me.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						me.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the bottom down to 0
						me.min = 0;
					}
				}
	
				if (tickOpts.min !== undefined) {
					me.min = tickOpts.min;
				} else if (tickOpts.suggestedMin !== undefined) {
					if (me.min === null) {
						me.min = tickOpts.suggestedMin;
					} else {
						me.min = Math.min(me.min, tickOpts.suggestedMin);
					}
				}
	
				if (tickOpts.max !== undefined) {
					me.max = tickOpts.max;
				} else if (tickOpts.suggestedMax !== undefined) {
					if (me.max === null) {
						me.max = tickOpts.suggestedMax;
					} else {
						me.max = Math.max(me.max, tickOpts.suggestedMax);
					}
				}
	
				if (me.min === me.max) {
					me.max++;
	
					if (!tickOpts.beginAtZero) {
						me.min--;
					}
				}
			},
			getTickLimit: noop,
			handleDirectionalChanges: noop,
	
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph. Make sure we always have at least 2 ticks
				var maxTicks = me.getTickLimit();
				maxTicks = Math.max(2, maxTicks);
	
				var numericGeneratorOptions = {
					maxTicks: maxTicks,
					min: tickOpts.min,
					max: tickOpts.max,
					stepSize: helpers.getValueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
				};
				var ticks = me.ticks = Chart.Ticks.generators.linear(numericGeneratorOptions, me);
	
				me.handleDirectionalChanges();
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsNumbers = me.ticks.slice();
				me.zeroLineIndex = me.ticks.indexOf(0);
	
				Chart.Scale.prototype.convertTicksToLabels.call(me);
			}
		});
	};


/***/ }),
/* 377 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		// Default config for a category scale
		var defaultConfig = {
			position: 'bottom'
		};
	
		var DatasetScale = Chart.Scale.extend({
			/**
			* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
			* else fall back to data.labels
			* @private
			*/
			getLabels: function() {
				var data = this.chart.data;
				return (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
			},
	
			determineDataLimits: function() {
				var me = this;
				var labels = me.getLabels();
				me.minIndex = 0;
				me.maxIndex = labels.length - 1;
				var findIndex;
	
				if (me.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = helpers.indexOf(labels, me.options.ticks.min);
					me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
				}
	
				if (me.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = helpers.indexOf(labels, me.options.ticks.max);
					me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
				}
	
				me.min = labels[me.minIndex];
				me.max = labels[me.maxIndex];
			},
	
			buildTicks: function() {
				var me = this;
				var labels = me.getLabels();
				// If we are viewing some subset of labels, slice the original array
				me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var isHorizontal = me.isHorizontal();
	
				if (data.yLabels && !isHorizontal) {
					return me.getRightValue(data.datasets[datasetIndex].data[index]);
				}
				return me.ticks[index - me.minIndex];
			},
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index, datasetIndex, includeOffset) {
				var me = this;
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
	
				// If value is a data object, then index is the index in the data array,
				// not the index of the scale. We need to change that.
				var valueCategory;
				if (value !== undefined && value !== null) {
					valueCategory = me.isHorizontal() ? value.x : value.y;
				}
				if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
					var labels = me.getLabels();
					value = valueCategory || value;
					var idx = labels.indexOf(value);
					index = idx !== -1 ? idx : index;
				}
	
				if (me.isHorizontal()) {
					var valueWidth = me.width / offsetAmt;
					var widthOffset = (valueWidth * (index - me.minIndex));
	
					if (me.options.gridLines.offsetGridLines && includeOffset || me.maxIndex === me.minIndex && includeOffset) {
						widthOffset += (valueWidth / 2);
					}
	
					return me.left + Math.round(widthOffset);
				}
				var valueHeight = me.height / offsetAmt;
				var heightOffset = (valueHeight * (index - me.minIndex));
	
				if (me.options.gridLines.offsetGridLines && includeOffset) {
					heightOffset += (valueHeight / 2);
				}
	
				return me.top + Math.round(heightOffset);
			},
			getPixelForTick: function(index, includeOffset) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null, includeOffset);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var value;
				var offsetAmt = Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
				var horz = me.isHorizontal();
				var valueDimension = (horz ? me.width : me.height) / offsetAmt;
	
				pixel -= horz ? me.left : me.top;
	
				if (me.options.gridLines.offsetGridLines) {
					pixel -= (valueDimension / 2);
				}
	
				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}
	
				return value;
			},
			getBasePixel: function() {
				return this.bottom;
			}
		});
	
		Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);
	
	};


/***/ }),
/* 378 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
			ticks: {
				callback: Chart.Ticks.formatters.linear
			}
		};
	
		var LinearScale = Chart.LinearScaleBase.extend({
	
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
				var DEFAULT_MIN = 0;
				var DEFAULT_MAX = 1;
	
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// First Calculate the range
				me.min = null;
				me.max = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = {
								positiveValues: [],
								negativeValues: []
							};
						}
	
						// Store these per type
						var positiveValues = valuesPerStack[key].positiveValues;
						var negativeValues = valuesPerStack[key].negativeValues;
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;
	
								if (opts.relativePoints) {
									positiveValues[index] = 100;
								} else if (value < 0) {
									negativeValues[index] += value;
								} else {
									positiveValues[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers.min(values);
						var maxVal = helpers.max(values);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
							});
						}
					});
				}
	
				me.min = isFinite(me.min) ? me.min : DEFAULT_MIN;
				me.max = isFinite(me.max) ? me.max : DEFAULT_MAX;
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				this.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var maxTicks;
				var me = this;
				var tickOpts = me.options.ticks;
	
				if (me.isHorizontal()) {
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, Chart.defaults.global.defaultFontSize);
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
				}
	
				return maxTicks;
			},
			// Called after the ticks are built. We need
			handleDirectionalChanges: function() {
				if (!this.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			// Utils
			getPixelForValue: function(value) {
				// This must be called after fit has been run so that
				// this.left, this.top, this.right, and this.bottom have been defined
				var me = this;
				var start = me.start;
	
				var rightValue = +me.getRightValue(value);
				var pixel;
				var range = me.end - start;
	
				if (me.isHorizontal()) {
					pixel = me.left + (me.width / range * (rightValue - start));
					return Math.round(pixel);
				}
	
				pixel = me.bottom - (me.height / range * (rightValue - start));
				return Math.round(pixel);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var isHorizontal = me.isHorizontal();
				var innerDimension = isHorizontal ? me.width : me.height;
				var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
				return me.start + ((me.end - me.start) * offset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticksAsNumbers[index]);
			}
		});
		Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);
	
	};


/***/ }),
/* 379 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
	
			// label settings
			ticks: {
				callback: Chart.Ticks.formatters.logarithmic
			}
		};
	
		var LogarithmicScale = Chart.Scale.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var getValueOrDefault = helpers.getValueOrDefault;
				var isHorizontal = me.isHorizontal();
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// Calculate Range
				me.min = null;
				me.max = null;
				me.minNotZero = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							if (valuesPerStack[key] === undefined) {
								valuesPerStack[key] = [];
							}
	
							helpers.each(dataset.data, function(rawValue, index) {
								var values = valuesPerStack[key];
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								values[index] = values[index] || 0;
	
								if (opts.relativePoints) {
									values[index] = 100;
								} else {
									// Don't need to split positive and negative since the log scale can't handle a 0 crossing
									values[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
	
								if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
									me.minNotZero = value;
								}
							});
						}
					});
				}
	
				me.min = getValueOrDefault(tickOpts.min, me.min);
				me.max = getValueOrDefault(tickOpts.max, me.max);
	
				if (me.min === me.max) {
					if (me.min !== 0 && me.min !== null) {
						me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
						me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
					} else {
						me.min = 1;
						me.max = 10;
					}
				}
			},
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				var generationOptions = {
					min: tickOpts.min,
					max: tickOpts.max
				};
				var ticks = me.ticks = Chart.Ticks.generators.logarithmic(generationOptions, me);
	
				if (!me.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					ticks.reverse();
				}
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickValues[index]);
			},
			getPixelForValue: function(value) {
				var me = this;
				var innerDimension;
				var pixel;
	
				var start = me.start;
				var newVal = +me.getRightValue(value);
				var range;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				if (me.isHorizontal()) {
					range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
					if (newVal === 0) {
						pixel = me.left;
					} else {
						innerDimension = me.width;
						pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				} else {
					// Bottom - top since pixels increase downward on a screen
					innerDimension = me.height;
					if (start === 0 && !tickOpts.reverse) {
						range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
						if (newVal === start) {
							pixel = me.bottom;
						} else if (newVal === me.minNotZero) {
							pixel = me.bottom - innerDimension * 0.02;
						} else {
							pixel = me.bottom - innerDimension * 0.02 - (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else if (me.end === 0 && tickOpts.reverse) {
						range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
						if (newVal === me.end) {
							pixel = me.top;
						} else if (newVal === me.minNotZero) {
							pixel = me.top + innerDimension * 0.02;
						} else {
							pixel = me.top + innerDimension * 0.02 + (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else if (newVal === 0) {
						pixel = tickOpts.reverse ? me.top : me.bottom;
					} else {
						range = helpers.log10(me.end) - helpers.log10(start);
						innerDimension = me.height;
						pixel = me.bottom - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var range = helpers.log10(me.end) - helpers.log10(me.start);
				var value, innerDimension;
	
				if (me.isHorizontal()) {
					innerDimension = me.width;
					value = me.start * Math.pow(10, (pixel - me.left) * range / innerDimension);
				} else {  // todo: if start === 0
					innerDimension = me.height;
					value = Math.pow(10, (me.bottom - pixel) * range / innerDimension) / me.start;
				}
				return value;
			}
		});
		Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
	
	};


/***/ }),
/* 380 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		var defaultConfig = {
			display: true,
	
			// Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			position: 'chartArea',
	
			angleLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1
			},
	
			gridLines: {
				circular: false
			},
	
			// label settings
			ticks: {
				// Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,
	
				// String - The colour of the label backdrop
				backdropColor: 'rgba(255,255,255,0.75)',
	
				// Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,
	
				// Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2,
	
				callback: Chart.Ticks.formatters.linear
			},
	
			pointLabels: {
				// Boolean - if true, show point labels
				display: true,
	
				// Number - Point label font size in pixels
				fontSize: 10,
	
				// Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};
	
		function getValueCount(scale) {
			var opts = scale.options;
			return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
		}
	
		function getPointLabelFontOptions(scale) {
			var pointLabelOptions = scale.options.pointLabels;
			var fontSize = helpers.getValueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = helpers.getValueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = helpers.getValueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
			var font = helpers.fontString(fontSize, fontStyle, fontFamily);
	
			return {
				size: fontSize,
				style: fontStyle,
				family: fontFamily,
				font: font
			};
		}
	
		function measureLabelSize(ctx, fontSize, label) {
			if (helpers.isArray(label)) {
				return {
					w: helpers.longestText(ctx, ctx.font, label),
					h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
				};
			}
	
			return {
				w: ctx.measureText(label).width,
				h: fontSize
			};
		}
	
		function determineLimits(angle, pos, size, min, max) {
			if (angle === min || angle === max) {
				return {
					start: pos - (size / 2),
					end: pos + (size / 2)
				};
			} else if (angle < min || angle > max) {
				return {
					start: pos - size - 5,
					end: pos
				};
			}
	
			return {
				start: pos,
				end: pos + size + 5
			};
		}
	
		/**
		 * Helper function to fit a radial linear scale with point labels
		 */
		function fitWithPointLabels(scale) {
			/*
			 * Right, this is really confusing and there is a lot of maths going on here
			 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
			 *
			 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
			 *
			 * Solution:
			 *
			 * We assume the radius of the polygon is half the size of the canvas at first
			 * at each index we check if the text overlaps.
			 *
			 * Where it does, we store that angle and that index.
			 *
			 * After finding the largest index and angle we calculate how much we need to remove
			 * from the shape radius to move the point inwards by that x.
			 *
			 * We average the left and right distances to get the maximum shape radius that can fit in the box
			 * along with labels.
			 *
			 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
			 * on each side, removing that from the size, halving it and adding the left x protrusion width.
			 *
			 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
			 * and position it in the most space efficient manner
			 *
			 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
			 */
	
			var plFont = getPointLabelFontOptions(scale);
	
			// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
			// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			var furthestLimits = {
				r: scale.width,
				l: 0,
				t: scale.height,
				b: 0
			};
			var furthestAngles = {};
			var i;
			var textSize;
			var pointPosition;
	
			scale.ctx.font = plFont.font;
			scale._pointLabelSizes = [];
	
			var valueCount = getValueCount(scale);
			for (i = 0; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, largestPossibleRadius);
				textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
				scale._pointLabelSizes[i] = textSize;
	
				// Add quarter circle to make degree 0 mean top of circle
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians) % 360;
				var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
				var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
				if (hLimits.start < furthestLimits.l) {
					furthestLimits.l = hLimits.start;
					furthestAngles.l = angleRadians;
				}
	
				if (hLimits.end > furthestLimits.r) {
					furthestLimits.r = hLimits.end;
					furthestAngles.r = angleRadians;
				}
	
				if (vLimits.start < furthestLimits.t) {
					furthestLimits.t = vLimits.start;
					furthestAngles.t = angleRadians;
				}
	
				if (vLimits.end > furthestLimits.b) {
					furthestLimits.b = vLimits.end;
					furthestAngles.b = angleRadians;
				}
			}
	
			scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
		}
	
		/**
		 * Helper function to fit a radial linear scale with no point labels
		 */
		function fit(scale) {
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			scale.drawingArea = Math.round(largestPossibleRadius);
			scale.setCenterPoint(0, 0, 0, 0);
		}
	
		function getTextAlignForAngle(angle) {
			if (angle === 0 || angle === 180) {
				return 'center';
			} else if (angle < 180) {
				return 'left';
			}
	
			return 'right';
		}
	
		function fillText(ctx, text, position, fontSize) {
			if (helpers.isArray(text)) {
				var y = position.y;
				var spacing = 1.5 * fontSize;
	
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], position.x, y);
					y+= spacing;
				}
			} else {
				ctx.fillText(text, position.x, position.y);
			}
		}
	
		function adjustPointPositionForLabelHeight(angle, textSize, position) {
			if (angle === 90 || angle === 270) {
				position.y -= (textSize.h / 2);
			} else if (angle > 270 || angle < 90) {
				position.y -= textSize.h;
			}
		}
	
		function drawPointLabels(scale) {
			var ctx = scale.ctx;
			var getValueOrDefault = helpers.getValueOrDefault;
			var opts = scale.options;
			var angleLineOpts = opts.angleLines;
			var pointLabelOpts = opts.pointLabels;
	
			ctx.lineWidth = angleLineOpts.lineWidth;
			ctx.strokeStyle = angleLineOpts.color;
	
			var outerDistance = scale.getDistanceFromCenterForValue(opts.reverse ? scale.min : scale.max);
	
			// Point Label Font
			var plFont = getPointLabelFontOptions(scale);
	
			ctx.textBaseline = 'top';
	
			for (var i = getValueCount(scale) - 1; i >= 0; i--) {
				if (angleLineOpts.display) {
					var outerPosition = scale.getPointPosition(i, outerDistance);
					ctx.beginPath();
					ctx.moveTo(scale.xCenter, scale.yCenter);
					ctx.lineTo(outerPosition.x, outerPosition.y);
					ctx.stroke();
					ctx.closePath();
				}
	
				if (pointLabelOpts.display) {
					// Extra 3px out for some label spacing
					var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);
	
					// Keep this in loop since we may support array properties here
					var pointLabelFontColor = getValueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
					ctx.font = plFont.font;
					ctx.fillStyle = pointLabelFontColor;
	
					var angleRadians = scale.getIndexAngle(i);
					var angle = helpers.toDegrees(angleRadians);
					ctx.textAlign = getTextAlignForAngle(angle);
					adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
					fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
				}
			}
		}
	
		function drawRadiusLine(scale, gridLineOpts, radius, index) {
			var ctx = scale.ctx;
			ctx.strokeStyle = helpers.getValueAtIndexOrDefault(gridLineOpts.color, index - 1);
			ctx.lineWidth = helpers.getValueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);
	
			if (scale.options.gridLines.circular) {
				// Draw circular arcs between the points
				ctx.beginPath();
				ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.stroke();
			} else {
				// Draw straight lines connecting each index
				var valueCount = getValueCount(scale);
	
				if (valueCount === 0) {
					return;
				}
	
				ctx.beginPath();
				var pointPosition = scale.getPointPosition(0, radius);
				ctx.moveTo(pointPosition.x, pointPosition.y);
	
				for (var i = 1; i < valueCount; i++) {
					pointPosition = scale.getPointPosition(i, radius);
					ctx.lineTo(pointPosition.x, pointPosition.y);
				}
	
				ctx.closePath();
				ctx.stroke();
			}
		}
	
		function numberOrZero(param) {
			return helpers.isNumber(param) ? param : 0;
		}
	
		var LinearRadialScale = Chart.LinearScaleBase.extend({
			setDimensions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				// Set the unconstrained dimension before label rotation
				me.width = me.maxWidth;
				me.height = me.maxHeight;
				me.xCenter = Math.round(me.width / 2);
				me.yCenter = Math.round(me.height / 2);
	
				var minSize = helpers.min([me.height, me.width]);
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var min = Number.POSITIVE_INFINITY;
				var max = Number.NEGATIVE_INFINITY;
	
				helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);
	
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							min = Math.min(value, min);
							max = Math.max(value, max);
						});
					}
				});
	
				me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
				me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				me.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var tickOpts = this.options.ticks;
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
			},
			convertTicksToLabels: function() {
				var me = this;
				Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);
	
				// Point labels
				me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				if (this.options.pointLabels.display) {
					fitWithPointLabels(this);
				} else {
					fit(this);
				}
			},
			/**
			 * Set radius reductions and determine new radius and center point
			 * @private
			 */
			setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
				var me = this;
				var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
				var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
				var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
				var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);
	
				radiusReductionLeft = numberOrZero(radiusReductionLeft);
				radiusReductionRight = numberOrZero(radiusReductionRight);
				radiusReductionTop = numberOrZero(radiusReductionTop);
				radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
				me.drawingArea = Math.min(
					Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
					Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
				me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
			},
			setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
				var me = this;
				var maxRight = me.width - rightMovement - me.drawingArea,
					maxLeft = leftMovement + me.drawingArea,
					maxTop = topMovement + me.drawingArea,
					maxBottom = me.height - bottomMovement - me.drawingArea;
	
				me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
				me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
			},
	
			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / getValueCount(this);
				var startAngle = this.chart.options && this.chart.options.startAngle ?
					this.chart.options.startAngle :
					0;
	
				var startAngleRadians = startAngle * Math.PI * 2 / 360;
	
				// Start from the top instead of right, so remove a quarter of the circle
				return index * angleMultiplier + startAngleRadians;
			},
			getDistanceFromCenterForValue: function(value) {
				var me = this;
	
				if (value === null) {
					return 0; // null always in center
				}
	
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = me.drawingArea / (me.max - me.min);
				if (me.options.reverse) {
					return (me.max - value) * scalingFactor;
				}
				return (value - me.min) * scalingFactor;
			},
			getPointPosition: function(index, distanceFromCenter) {
				var me = this;
				var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},
	
			getBasePosition: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPointPositionForValue(0,
					me.beginAtZero? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0);
			},
	
			draw: function() {
				var me = this;
				var opts = me.options;
				var gridLineOpts = opts.gridLines;
				var tickOpts = opts.ticks;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				if (opts.display) {
					var ctx = me.ctx;
	
					// Tick Font
					var tickFontSize = getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
					var tickFontStyle = getValueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
					var tickFontFamily = getValueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
					var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
					helpers.each(me.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || opts.reverse) {
							var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
							var yHeight = me.yCenter - yCenterOffset;
	
							// Draw circular lines around the scale
							if (gridLineOpts.display && index !== 0) {
								drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
							}
	
							if (tickOpts.display) {
								var tickFontColor = getValueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
								ctx.font = tickLabelFont;
	
								if (tickOpts.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = tickOpts.backdropColor;
									ctx.fillRect(
										me.xCenter - labelWidth / 2 - tickOpts.backdropPaddingX,
										yHeight - tickFontSize / 2 - tickOpts.backdropPaddingY,
										labelWidth + tickOpts.backdropPaddingX * 2,
										tickFontSize + tickOpts.backdropPaddingY * 2
									);
								}
	
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, me.xCenter, yHeight);
							}
						}
					});
	
					if (opts.angleLines.display || opts.pointLabels.display) {
						drawPointLabels(me);
					}
				}
			}
		});
		Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
	
	};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var moment = __webpack_require__(44);
	moment = typeof(moment) === 'function' ? moment : window.moment;
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var interval = {
			millisecond: {
				size: 1,
				steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
			},
			second: {
				size: 1000,
				steps: [1, 2, 5, 10, 30]
			},
			minute: {
				size: 60000,
				steps: [1, 2, 5, 10, 30]
			},
			hour: {
				size: 3600000,
				steps: [1, 2, 3, 6, 12]
			},
			day: {
				size: 86400000,
				steps: [1, 2, 5]
			},
			week: {
				size: 604800000,
				maxStep: 4
			},
			month: {
				size: 2.628e9,
				maxStep: 3
			},
			quarter: {
				size: 7.884e9,
				maxStep: 4
			},
			year: {
				size: 3.154e10,
				maxStep: false
			}
		};
	
		var defaultConfig = {
			position: 'bottom',
	
			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
				minUnit: 'millisecond',
	
				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					second: 'h:mm:ss a', // 11:20:01 AM
					minute: 'h:mm:ss a', // 11:20:01 AM
					hour: 'MMM D, hA', // Sept 4, 5PM
					day: 'll', // Sep 4 2015
					week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					month: 'MMM YYYY', // Sept 2015
					quarter: '[Q]Q - YYYY', // Q3
					year: 'YYYY' // 2015
				},
			},
			ticks: {
				autoSkip: false
			}
		};
	
		/**
		 * Helper function to parse time to a moment object
		 * @param axis {TimeAxis} the time axis
		 * @param label {Date|string|number|Moment} The thing to parse
		 * @return {Moment} parsed time
		 */
		function parseTime(axis, label) {
			var timeOpts = axis.options.time;
			if (typeof timeOpts.parser === 'string') {
				return moment(label, timeOpts.parser);
			}
			if (typeof timeOpts.parser === 'function') {
				return timeOpts.parser(label);
			}
			if (typeof label.getMonth === 'function' || typeof label === 'number') {
				// Date objects
				return moment(label);
			}
			if (label.isValid && label.isValid()) {
				// Moment support
				return label;
			}
			var format = timeOpts.format;
			if (typeof format !== 'string' && format.call) {
				// Custom parsing (return an instance of moment)
				console.warn('options.time.format is deprecated and replaced by options.time.parser.');
				return format(label);
			}
			// Moment format parsing
			return moment(label, format);
		}
	
		/**
		 * Figure out which is the best unit for the scale
		 * @param minUnit {String} minimum unit to use
		 * @param min {Number} scale minimum
		 * @param max {Number} scale maximum
		 * @return {String} the unit to use
		 */
		function determineUnit(minUnit, min, max, maxTicks) {
			var units = Object.keys(interval);
			var unit;
			var numUnits = units.length;
	
			for (var i = units.indexOf(minUnit); i < numUnits; i++) {
				unit = units[i];
				var unitDetails = interval[unit];
				var steps = (unitDetails.steps && unitDetails.steps[unitDetails.steps.length - 1]) || unitDetails.maxStep;
				if (steps === undefined || Math.ceil((max - min) / (steps * unitDetails.size)) <= maxTicks) {
					break;
				}
			}
	
			return unit;
		}
	
		/**
		 * Determines how we scale the unit
		 * @param min {Number} the scale minimum
		 * @param max {Number} the scale maximum
		 * @param unit {String} the unit determined by the {@see determineUnit} method
		 * @return {Number} the axis step size as a multiple of unit
		 */
		function determineStepSize(min, max, unit, maxTicks) {
			// Using our unit, figoure out what we need to scale as
			var unitDefinition = interval[unit];
			var unitSizeInMilliSeconds = unitDefinition.size;
			var sizeInUnits = Math.ceil((max - min) / unitSizeInMilliSeconds);
			var multiplier = 1;
			var range = max - min;
	
			if (unitDefinition.steps) {
				// Have an array of steps
				var numSteps = unitDefinition.steps.length;
				for (var i = 0; i < numSteps && sizeInUnits > maxTicks; i++) {
					multiplier = unitDefinition.steps[i];
					sizeInUnits = Math.ceil(range / (unitSizeInMilliSeconds * multiplier));
				}
			} else {
				while (sizeInUnits > maxTicks && maxTicks > 0) {
					++multiplier;
					sizeInUnits = Math.ceil(range / (unitSizeInMilliSeconds * multiplier));
				}
			}
	
			return multiplier;
		}
	
		/**
		 * Helper for generating axis labels.
		 * @param options {ITimeGeneratorOptions} the options for generation
		 * @param dataRange {IRange} the data range
		 * @param niceRange {IRange} the pretty range to display
		 * @return {Number[]} ticks
		 */
		function generateTicks(options, dataRange, niceRange) {
			var ticks = [];
			if (options.maxTicks) {
				var stepSize = options.stepSize;
				ticks.push(options.min !== undefined ? options.min : niceRange.min);
				var cur = moment(niceRange.min);
				while (cur.add(stepSize, options.unit).valueOf() < niceRange.max) {
					ticks.push(cur.valueOf());
				}
				var realMax = options.max || niceRange.max;
				if (ticks[ticks.length - 1] !== realMax) {
					ticks.push(realMax);
				}
			}
			return ticks;
		}
	
		/**
		 * @function Chart.Ticks.generators.time
		 * @param options {ITimeGeneratorOptions} the options for generation
		 * @param dataRange {IRange} the data range
		 * @return {Number[]} ticks
		 */
		Chart.Ticks.generators.time = function(options, dataRange) {
			var niceMin;
			var niceMax;
			var isoWeekday = options.isoWeekday;
			if (options.unit === 'week' && isoWeekday !== false) {
				niceMin = moment(dataRange.min).startOf('isoWeek').isoWeekday(isoWeekday).valueOf();
				niceMax = moment(dataRange.max).startOf('isoWeek').isoWeekday(isoWeekday);
				if (dataRange.max - niceMax > 0) {
					niceMax.add(1, 'week');
				}
				niceMax = niceMax.valueOf();
			} else {
				niceMin = moment(dataRange.min).startOf(options.unit).valueOf();
				niceMax = moment(dataRange.max).startOf(options.unit);
				if (dataRange.max - niceMax > 0) {
					niceMax.add(1, options.unit);
				}
				niceMax = niceMax.valueOf();
			}
			return generateTicks(options, dataRange, {
				min: niceMin,
				max: niceMax
			});
		};
	
		var TimeScale = Chart.Scale.extend({
			initialize: function() {
				if (!moment) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}
	
				Chart.Scale.prototype.initialize.call(this);
			},
			determineDataLimits: function() {
				var me = this;
				var timeOpts = me.options.time;
	
				// We store the data range as unix millisecond timestamps so dataMin and dataMax will always be integers.
				var dataMin = Number.MAX_SAFE_INTEGER;
				var dataMax = Number.MIN_SAFE_INTEGER;
	
				var chartData = me.chart.data;
				var parsedData = {
					labels: [],
					datasets: []
				};
	
				var timestamp;
	
				helpers.each(chartData.labels, function(label, labelIndex) {
					var labelMoment = parseTime(me, label);
	
					if (labelMoment.isValid()) {
						// We need to round the time
						if (timeOpts.round) {
							labelMoment.startOf(timeOpts.round);
						}
	
						timestamp = labelMoment.valueOf();
						dataMin = Math.min(timestamp, dataMin);
						dataMax = Math.max(timestamp, dataMax);
	
						// Store this value for later
						parsedData.labels[labelIndex] = timestamp;
					}
				});
	
				helpers.each(chartData.datasets, function(dataset, datasetIndex) {
					var timestamps = [];
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null && me.chart.isDatasetVisible(datasetIndex)) {
						// We have potential point data, so we need to parse this
						helpers.each(dataset.data, function(value, dataIndex) {
							var dataMoment = parseTime(me, me.getRightValue(value));
	
							if (dataMoment.isValid()) {
								if (timeOpts.round) {
									dataMoment.startOf(timeOpts.round);
								}
	
								timestamp = dataMoment.valueOf();
								dataMin = Math.min(timestamp, dataMin);
								dataMax = Math.max(timestamp, dataMax);
								timestamps[dataIndex] = timestamp;
							}
						});
					} else {
						// We have no x coordinates, so use the ones from the labels
						timestamps = parsedData.labels.slice();
					}
	
					parsedData.datasets[datasetIndex] = timestamps;
				});
	
				me.dataMin = dataMin;
				me.dataMax = dataMax;
				me._parsedData = parsedData;
			},
			buildTicks: function() {
				var me = this;
				var timeOpts = me.options.time;
	
				var minTimestamp;
				var maxTimestamp;
				var dataMin = me.dataMin;
				var dataMax = me.dataMax;
	
				if (timeOpts.min) {
					var minMoment = parseTime(me, timeOpts.min);
					if (timeOpts.round) {
						minMoment.round(timeOpts.round);
					}
					minTimestamp = minMoment.valueOf();
				}
	
				if (timeOpts.max) {
					maxTimestamp = parseTime(me, timeOpts.max).valueOf();
				}
	
				var maxTicks = me.getLabelCapacity(minTimestamp || dataMin);
				var unit = timeOpts.unit || determineUnit(timeOpts.minUnit, minTimestamp || dataMin, maxTimestamp || dataMax, maxTicks);
				me.displayFormat = timeOpts.displayFormats[unit];
	
				var stepSize = timeOpts.stepSize || determineStepSize(minTimestamp || dataMin, maxTimestamp || dataMax, unit, maxTicks);
				me.ticks = Chart.Ticks.generators.time({
					maxTicks: maxTicks,
					min: minTimestamp,
					max: maxTimestamp,
					stepSize: stepSize,
					unit: unit,
					isoWeekday: timeOpts.isoWeekday
				}, {
					min: dataMin,
					max: dataMax
				});
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(me.ticks);
				me.min = helpers.min(me.ticks);
			},
			// Get tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var label = me.chart.data.labels && index < me.chart.data.labels.length ? me.chart.data.labels[index] : '';
				var value = me.chart.data.datasets[datasetIndex].data[index];
	
				if (value !== null && typeof value === 'object') {
					label = me.getRightValue(value);
				}
	
				// Format nicely
				if (me.options.time.tooltipFormat) {
					label = parseTime(me, label).format(me.options.time.tooltipFormat);
				}
	
				return label;
			},
			// Function to format an individual tick mark
			tickFormatFunction: function(tick, index, ticks) {
				var formattedTick = tick.format(this.displayFormat);
				var tickOpts = this.options.ticks;
				var callback = helpers.getValueOrDefault(tickOpts.callback, tickOpts.userCallback);
	
				if (callback) {
					return callback(formattedTick, index, ticks);
				}
				return formattedTick;
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsTimestamps = me.ticks;
				me.ticks = me.ticks.map(function(tick) {
					return moment(tick);
				}).map(me.tickFormatFunction, me);
			},
			getPixelForOffset: function(offset) {
				var me = this;
				var epochWidth = me.max - me.min;
				var decimal = epochWidth ? (offset - me.min) / epochWidth : 0;
	
				if (me.isHorizontal()) {
					var valueOffset = (me.width * decimal);
					return me.left + Math.round(valueOffset);
				}
	
				var heightOffset = (me.height * decimal);
				return me.top + Math.round(heightOffset);
			},
			getPixelForValue: function(value, index, datasetIndex) {
				var me = this;
				var offset = null;
				if (index !== undefined && datasetIndex !== undefined) {
					offset = me._parsedData.datasets[datasetIndex][index];
				}
	
				if (offset === null) {
					if (!value || !value.isValid) {
						// not already a moment object
						value = parseTime(me, me.getRightValue(value));
					}
	
					if (value && value.isValid && value.isValid()) {
						offset = value.valueOf();
					}
				}
	
				if (offset !== null) {
					return me.getPixelForOffset(offset);
				}
			},
			getPixelForTick: function(index) {
				return this.getPixelForOffset(this.ticksAsTimestamps[index]);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var innerDimension = me.isHorizontal() ? me.width : me.height;
				var offset = (pixel - (me.isHorizontal() ? me.left : me.top)) / innerDimension;
				return moment(me.min + (offset * (me.max - me.min)));
			},
			// Crude approximation of what the label width might be
			getLabelWidth: function(label) {
				var me = this;
				var ticks = me.options.ticks;
	
				var tickLabelWidth = me.ctx.measureText(label).width;
				var cosRotation = Math.cos(helpers.toRadians(ticks.maxRotation));
				var sinRotation = Math.sin(helpers.toRadians(ticks.maxRotation));
				var tickFontSize = helpers.getValueOrDefault(ticks.fontSize, Chart.defaults.global.defaultFontSize);
				return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
			},
			getLabelCapacity: function(exampleTime) {
				var me = this;
	
				me.displayFormat = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation
				var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, []);
				var tickLabelWidth = me.getLabelWidth(exampleLabel);
	
				var innerWidth = me.isHorizontal() ? me.width : me.height;
				var labelCapacity = innerWidth / tickLabelWidth;
				return labelCapacity;
			}
		});
		Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
	
	};


/***/ }),
/* 382 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
	
					// Specific to Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}],
				yAxes: [{
					type: 'linear'
				}]
			}
		};
	
		Chart.controllers.bar = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Rectangle,
	
			initialize: function() {
				var me = this;
				var meta;
	
				Chart.DatasetController.prototype.initialize.apply(me, arguments);
	
				meta = me.getMeta();
				meta.stack = me.getDataset().stack;
				meta.bar = true;
			},
	
			update: function(reset) {
				var me = this;
				var elements = me.getMeta().data;
				var i, ilen;
	
				me._ruler = me.getRuler();
	
				for (i = 0, ilen = elements.length; i < ilen; ++i) {
					me.updateElement(elements[i], i, reset);
				}
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var dataset = me.getDataset();
				var custom = rectangle.custom || {};
				var rectangleOptions = chart.options.elements.rectangle;
	
				rectangle._xScale = me.getScaleForId(meta.xAxisID);
				rectangle._yScale = me.getScaleForId(meta.yAxisID);
				rectangle._datasetIndex = me.index;
				rectangle._index = index;
	
				rectangle._model = {
					datasetLabel: dataset.label,
					label: chart.data.labels[index],
					borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
				};
	
				me.updateElementGeometry(rectangle, index, reset);
	
				rectangle.pivot();
			},
	
			/**
			 * @private
			 */
			updateElementGeometry: function(rectangle, index, reset) {
				var me = this;
				var model = rectangle._model;
				var vscale = me.getValueScale();
				var base = vscale.getBasePixel();
				var horizontal = vscale.isHorizontal();
				var ruler = me._ruler || me.getRuler();
				var vpixels = me.calculateBarValuePixels(me.index, index);
				var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);
	
				model.horizontal = horizontal;
				model.base = reset? base : vpixels.base;
				model.x = horizontal? reset? base : vpixels.head : ipixels.center;
				model.y = horizontal? ipixels.center : reset? base : vpixels.head;
				model.height = horizontal? ipixels.size : undefined;
				model.width = horizontal? undefined : ipixels.size;
			},
	
			/**
			 * @private
			 */
			getValueScaleId: function() {
				return this.getMeta().yAxisID;
			},
	
			/**
			 * @private
			 */
			getIndexScaleId: function() {
				return this.getMeta().xAxisID;
			},
	
			/**
			 * @private
			 */
			getValueScale: function() {
				return this.getScaleForId(this.getValueScaleId());
			},
	
			/**
			 * @private
			 */
			getIndexScale: function() {
				return this.getScaleForId(this.getIndexScaleId());
			},
	
			/**
			 * Returns the effective number of stacks based on groups and bar visibility.
			 * @private
			 */
			getStackCount: function(last) {
				var me = this;
				var chart = me.chart;
				var scale = me.getIndexScale();
				var stacked = scale.options.stacked;
				var ilen = last === undefined? chart.data.datasets.length : last + 1;
				var stacks = [];
				var i, meta;
	
				for (i = 0; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					if (meta.bar && chart.isDatasetVisible(i) &&
						(stacked === false ||
						(stacked === true && stacks.indexOf(meta.stack) === -1) ||
						(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
						stacks.push(meta.stack);
					}
				}
	
				return stacks.length;
			},
	
			/**
			 * Returns the stack index for the given dataset based on groups and bar visibility.
			 * @private
			 */
			getStackIndex: function(datasetIndex) {
				return this.getStackCount(datasetIndex) - 1;
			},
	
			/**
			 * @private
			 */
			getRuler: function() {
				var me = this;
				var scale = me.getIndexScale();
				var options = scale.options;
				var stackCount = me.getStackCount();
				var fullSize = scale.isHorizontal()? scale.width : scale.height;
				var tickSize = fullSize / scale.ticks.length;
				var categorySize = tickSize * options.categoryPercentage;
				var fullBarSize = categorySize / stackCount;
				var barSize = fullBarSize * options.barPercentage;
	
				barSize = Math.min(
					helpers.getValueOrDefault(options.barThickness, barSize),
					helpers.getValueOrDefault(options.maxBarThickness, Infinity));
	
				return {
					stackCount: stackCount,
					tickSize: tickSize,
					categorySize: categorySize,
					categorySpacing: tickSize - categorySize,
					fullBarSize: fullBarSize,
					barSize: barSize,
					barSpacing: fullBarSize - barSize,
					scale: scale
				};
			},
	
			/**
			 * Note: pixel values are not clamped to the scale area.
			 * @private
			 */
			calculateBarValuePixels: function(datasetIndex, index) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var scale = me.getValueScale();
				var datasets = chart.data.datasets;
				var value = Number(datasets[datasetIndex].data[index]);
				var stacked = scale.options.stacked;
				var stack = meta.stack;
				var start = 0;
				var i, imeta, ivalue, base, head, size;
	
				if (stacked || (stacked === undefined && stack !== undefined)) {
					for (i = 0; i < datasetIndex; ++i) {
						imeta = chart.getDatasetMeta(i);
	
						if (imeta.bar &&
							imeta.stack === stack &&
							imeta.controller.getValueScaleId() === scale.id &&
							chart.isDatasetVisible(i)) {
	
							ivalue = Number(datasets[i].data[index]);
							if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
								start += ivalue;
							}
						}
					}
				}
	
				base = scale.getPixelForValue(start);
				head = scale.getPixelForValue(start + value);
				size = (head - base) / 2;
	
				return {
					size: size,
					base: base,
					head: head,
					center: head + size / 2
				};
			},
	
			/**
			 * @private
			 */
			calculateBarIndexPixels: function(datasetIndex, index, ruler) {
				var me = this;
				var scale = ruler.scale;
				var isCombo = me.chart.isCombo;
				var stackIndex = me.getStackIndex(datasetIndex);
				var base = scale.getPixelForValue(null, index, datasetIndex, isCombo);
				var size = ruler.barSize;
	
				base -= isCombo? ruler.tickSize / 2 : 0;
				base += ruler.fullBarSize * stackIndex;
				base += ruler.categorySpacing / 2;
				base += ruler.barSpacing / 2;
	
				return {
					size: size,
					base: base,
					head: base + size,
					center: base + size / 2
				};
			},
	
			draw: function() {
				var me = this;
				var chart = me.chart;
				var elements = me.getMeta().data;
				var dataset = me.getDataset();
				var ilen = elements.length;
				var i = 0;
				var d;
	
				helpers.canvas.clipArea(chart.ctx, chart.chartArea);
	
				for (; i<ilen; ++i) {
					d = dataset.data[i];
					if (d !== null && d !== undefined && !isNaN(d)) {
						elements[i].draw();
					}
				}
	
				helpers.canvas.unclipArea(chart.ctx);
			},
	
			setHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				var rectangleElementOptions = this.chart.options.elements.rectangle;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
			}
		});
	
	
		// including horizontalBar in the bar file, instead of a file of its own
		// it extends bar (like pie extends doughnut)
		Chart.defaults.horizontalBar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'linear',
					position: 'bottom'
				}],
				yAxes: [{
					position: 'left',
					type: 'category',
	
					// Specific to Horizontal Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}]
			},
			elements: {
				rectangle: {
					borderSkipped: 'left'
				}
			},
			tooltips: {
				callbacks: {
					title: function(tooltipItems, data) {
						// Pick first xLabel for now
						var title = '';
	
						if (tooltipItems.length > 0) {
							if (tooltipItems[0].yLabel) {
								title = tooltipItems[0].yLabel;
							} else if (data.labels.length > 0 && tooltipItems[0].index < data.labels.length) {
								title = data.labels[tooltipItems[0].index];
							}
						}
	
						return title;
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						return datasetLabel + ': ' + tooltipItem.xLabel;
					}
				}
			}
		};
	
		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
			/**
			 * @private
			 */
			getValueScaleId: function() {
				return this.getMeta().xAxisID;
			},
	
			/**
			 * @private
			 */
			getIndexScaleId: function() {
				return this.getMeta().yAxisID;
			}
		});
	};


/***/ }),
/* 383 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bubble = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // bubble should probably use a linear scale by default
					position: 'bottom',
					id: 'x-axis-0' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-0'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						var dataPoint = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return datasetLabel + ': (' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ', ' + dataPoint.r + ')';
					}
				}
			}
		};
	
		Chart.controllers.bubble = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data;
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				});
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
	
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var data = dataset.data[index];
				var pointElementOptions = me.chart.options.elements.point;
				var dsIndex = me.index;
	
				helpers.extend(point, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: dsIndex,
					_index: index,
	
					// Desired view properties
					_model: {
						x: reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex, me.chart.isCombo),
						y: reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex),
						// Appearance
						radius: reset ? 0 : custom.radius ? custom.radius : me.getRadius(data),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				// Trick to reset the styles of the point
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, pointElementOptions);
	
				var model = point._model;
				model.skip = custom.skip ? custom.skip : (isNaN(model.x) || isNaN(model.y));
	
				point.pivot();
			},
	
			getRadius: function(value) {
				return value.r || this.chart.options.elements.point.radius;
			},
	
			setHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.setHoverStyle.call(me, point);
	
				// Radius
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
				model.radius = custom.hoverRadius ? custom.hoverRadius : (helpers.getValueAtIndexOrDefault(dataset.hoverRadius, index, me.chart.options.elements.point.hoverRadius)) + me.getRadius(dataset.data[index]);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, me.chart.options.elements.point);
	
				var dataVal = me.chart.data.datasets[point._datasetIndex].data[point._index];
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.radius ? custom.radius : me.getRadius(dataVal);
			}
		});
	};


/***/ }),
/* 384 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			defaults = Chart.defaults;
	
		defaults.doughnut = {
			animation: {
				// Boolean - Whether we animate the rotation of the Doughnut
				animateRotate: true,
				// Boolean - Whether we animate scaling the Doughnut from the centre
				animateScale: false
			},
			aspectRatio: 1,
			hover: {
				mode: 'single'
			},
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc && arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						// toggle visibility of index if exists
						if (meta.data[index]) {
							meta.data[index].hidden = !meta.data[index].hidden;
						}
					}
	
					chart.update();
				}
			},
	
			// The percentage of the chart that we cut out of the middle.
			cutoutPercentage: 50,
	
			// The rotation of the chart, where the first data arc begins.
			rotation: Math.PI * -0.5,
	
			// The total circumference of the chart.
			circumference: Math.PI * 2.0,
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						var dataLabel = data.labels[tooltipItem.index];
						var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
						if (helpers.isArray(dataLabel)) {
							// show value on first line of multiline label
							// need to clone because we are changing the value
							dataLabel = dataLabel.slice();
							dataLabel[0] += value;
						} else {
							dataLabel += value;
						}
	
						return dataLabel;
					}
				}
			}
		};
	
		defaults.pie = helpers.clone(defaults.doughnut);
		helpers.extend(defaults.pie, {
			cutoutPercentage: 0
		});
	
	
		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function(datasetIndex) {
				var ringIndex = 0;
	
				for (var j = 0; j < datasetIndex; ++j) {
					if (this.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}
	
				return ringIndex;
			},
	
			update: function(reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					arcOpts = opts.elements.arc,
					availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth,
					availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth,
					minSize = Math.min(availableWidth, availableHeight),
					offset = {
						x: 0,
						y: 0
					},
					meta = me.getMeta(),
					cutoutPercentage = opts.cutoutPercentage,
					circumference = opts.circumference;
	
				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (circumference < Math.PI * 2.0) {
					var startAngle = opts.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && 0 <= endAngle) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}
	
				chart.borderWidth = me.getMaxBorderWidth(meta.data);
				chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
				chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
				chart.offsetX = offset.x * chart.outerRadius;
				chart.offsetY = offset.y * chart.outerRadius;
	
				meta.total = me.calculateTotal();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
				me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					animationOpts = opts.animation,
					centerX = (chartArea.left + chartArea.right) / 2,
					centerY = (chartArea.top + chartArea.bottom) / 2,
					startAngle = opts.rotation, // non reset case handled later
					endAngle = opts.rotation, // non reset case handled later
					dataset = me.getDataset(),
					circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI)),
					innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius,
					outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius,
					valueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: centerX + chart.offsetX,
						y: centerY + chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
						label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					}
				});
	
				var model = arc._model;
				// Resets the visual styles
				this.removeHoverStyle(arc);
	
				// Set correct angles if not resetting
				if (!reset || !animationOpts.animateRotate) {
					if (index === 0) {
						model.startAngle = opts.rotation;
					} else {
						model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
					}
	
					model.endAngle = model.startAngle + model.circumference;
				}
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;
	
				helpers.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});
	
				/* if (total === 0) {
					total = NaN;
				}*/
	
				return total;
			},
	
			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (value / total);
				}
				return 0;
			},
	
			// gets the max border or hover width to properly scale pie charts
			getMaxBorderWidth: function(elements) {
				var max = 0,
					index = this.index,
					length = elements.length,
					borderWidth,
					hoverWidth;
	
				for (var i = 0; i < length; i++) {
					borderWidth = elements[i]._model ? elements[i]._model.borderWidth : 0;
					hoverWidth = elements[i]._chart ? elements[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
				return max;
			}
		});
	};


/***/ }),
/* 385 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.line = {
			showLines: true,
			spanGaps: false,
	
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
					id: 'x-axis-0'
				}],
				yAxes: [{
					type: 'linear',
					id: 'y-axis-0'
				}]
			}
		};
	
		function lineEnabled(dataset, options) {
			return helpers.getValueOrDefault(dataset.showLine, options.showLines);
		}
	
		Chart.controllers.line = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data || [];
				var options = me.chart.options;
				var lineElementOptions = options.elements.line;
				var scale = me.getScaleForId(meta.yAxisID);
				var i, ilen, custom;
				var dataset = me.getDataset();
				var showLine = lineEnabled(dataset, options);
	
				// Update Line
				if (showLine) {
					custom = line.custom || {};
	
					// Compatibility: If the properties are defined with only the old name, use those values
					if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
						dataset.lineTension = dataset.tension;
					}
	
					// Utility
					line._scale = scale;
					line._datasetIndex = me.index;
					// Data
					line._children = points;
					// Model
					line._model = {
						// Appearance
						// The default behavior of lines is to break at null values, according
						// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
						// This option gives lines the ability to span gaps
						spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						steppedLine: custom.steppedLine ? custom.steppedLine : helpers.getValueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
						cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.getValueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
					};
	
					line.pivot();
				}
	
				// Update Points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					me.updateElement(points[i], i, reset);
				}
	
				if (showLine && line._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
	
				// Now pivot the point for animation
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].pivot();
				}
			},
	
			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.backgroundColor) {
					backgroundColor = custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}
	
				return backgroundColor;
			},
	
			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderColor) {
					borderColor = custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}
	
				return borderColor;
			},
	
			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (!isNaN(custom.borderWidth)) {
					borderWidth = custom.borderWidth;
				} else if (!isNaN(dataset.pointBorderWidth)) {
					borderWidth = helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (!isNaN(dataset.borderWidth)) {
					borderWidth = dataset.borderWidth;
				}
	
				return borderWidth;
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var datasetIndex = me.index;
				var value = dataset.data[index];
				var yScale = me.getScaleForId(meta.yAxisID);
				var xScale = me.getScaleForId(meta.xAxisID);
				var pointOptions = me.chart.options.elements.point;
				var x, y;
				var labels = me.chart.data.labels || [];
				var includeOffset = (labels.length === 1 || dataset.data.length === 1) || me.chart.isCombo;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex, includeOffset);
				y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
				// Utility
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = datasetIndex;
				point._index = index;
	
				// Desired view properties
				point._model = {
					x: x,
					y: y,
					skip: custom.skip || isNaN(x) || isNaN(y),
					// Appearance
					radius: custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
					pointStyle: custom.pointStyle || helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
					backgroundColor: me.getPointBackgroundColor(point, index),
					borderColor: me.getPointBorderColor(point, index),
					borderWidth: me.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
					// Tooltip
					hitRadius: custom.hitRadius || helpers.getValueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
				};
			},
	
			calculatePointY: function(value, index, datasetIndex) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var sumPos = 0;
				var sumNeg = 0;
				var i, ds, dsMeta;
	
				if (yScale.options.stacked) {
					for (i = 0; i < datasetIndex; i++) {
						ds = chart.data.datasets[i];
						dsMeta = chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
							if (stackedRightValue < 0) {
								sumNeg += stackedRightValue || 0;
							} else {
								sumPos += stackedRightValue || 0;
							}
						}
					}
	
					var rightValue = Number(yScale.getRightValue(value));
					if (rightValue < 0) {
						return yScale.getPixelForValue(sumNeg + rightValue);
					}
					return yScale.getPixelForValue(sumPos + rightValue);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			updateBezierControlPoints: function() {
				var me = this;
				var meta = me.getMeta();
				var area = me.chart.chartArea;
				var points = (meta.data || []);
				var i, ilen, point, model, controlPoints;
	
				// Only consider points that are drawn in case the spanGaps option is used
				if (meta.dataset._model.spanGaps) {
					points = points.filter(function(pt) {
						return !pt._model.skip;
					});
				}
	
				function capControlPoint(pt, min, max) {
					return Math.max(Math.min(pt, max), min);
				}
	
				if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
					helpers.splineCurveMonotone(points);
				} else {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						point = points[i];
						model = point._model;
						controlPoints = helpers.splineCurve(
							helpers.previousItem(points, i)._model,
							model,
							helpers.nextItem(points, i)._model,
							meta.dataset._model.tension
						);
						model.controlPointPreviousX = controlPoints.previous.x;
						model.controlPointPreviousY = controlPoints.previous.y;
						model.controlPointNextX = controlPoints.next.x;
						model.controlPointNextY = controlPoints.next.y;
					}
				}
	
				if (me.chart.options.elements.line.capBezierPoints) {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						model = points[i]._model;
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			},
	
			draw: function() {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var points = meta.data || [];
				var area = chart.chartArea;
				var ilen = points.length;
				var i = 0;
	
				Chart.canvasHelpers.clipArea(chart.ctx, area);
	
				if (lineEnabled(me.getDataset(), chart.options)) {
					meta.dataset.draw();
				}
	
				Chart.canvasHelpers.unclipArea(chart.ctx);
	
				// Draw the points
				for (; i<ilen; ++i) {
					points[i].draw(area);
				}
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.hoverRadius || helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
	
				model.radius = custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
				model.backgroundColor = me.getPointBackgroundColor(point, index);
				model.borderColor = me.getPointBorderColor(point, index);
				model.borderWidth = me.getPointBorderWidth(point, index);
			}
		});
	};


/***/ }),
/* 386 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.polarArea = {
	
			scale: {
				type: 'radialLinear',
				angleLines: {
					display: false
				},
				gridLines: {
					circular: true
				},
				pointLabels: {
					display: false
				},
				ticks: {
					beginAtZero: true
				}
			},
	
			// Boolean - Whether to animate the rotation of the chart
			animation: {
				animateRotate: true,
				animateScale: true
			},
	
			startAngle: -0.5 * Math.PI,
			aspectRatio: 1,
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						meta.data[index].hidden = !meta.data[index].hidden;
					}
	
					chart.update();
				}
			},
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
					}
				}
			}
		};
	
		Chart.controllers.polarArea = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var meta = me.getMeta();
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
				chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
				chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				meta.count = me.countVisibleElements();
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var dataset = me.getDataset();
				var opts = chart.options;
				var animationOpts = opts.animation;
				var scale = chart.scale;
				var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
				var labels = chart.data.labels;
	
				var circumference = me.calculateCircumference(dataset.data[index]);
				var centerX = scale.xCenter;
				var centerY = scale.yCenter;
	
				// If there is NaN data before us, we need to calculate the starting angle correctly.
				// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
				var visibleCount = 0;
				var meta = me.getMeta();
				for (var i = 0; i < index; ++i) {
					if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
						++visibleCount;
					}
				}
	
				// var negHalfPI = -0.5 * Math.PI;
				var datasetStartAngle = opts.startAngle;
				var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
				var startAngle = datasetStartAngle + (circumference * visibleCount);
				var endAngle = startAngle + (arc.hidden ? 0 : circumference);
	
				var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: reset ? resetRadius : distance,
						startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
						endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
						label: getValueAtIndexOrDefault(labels, index, labels[index])
					}
				});
	
				// Apply border and fill style
				me.removeHoverStyle(arc);
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;
	
				helpers.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});
	
				return count;
			},
	
			calculateCircumference: function(value) {
				var count = this.getMeta().count;
				if (count > 0 && !isNaN(value)) {
					return (2 * Math.PI) / count;
				}
				return 0;
			}
		});
	};


/***/ }),
/* 387 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.radar = {
			aspectRatio: 1,
			scale: {
				type: 'radialLinear'
			},
			elements: {
				line: {
					tension: 0 // no bezier in radar
				}
			}
		};
	
		Chart.controllers.radar = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data;
				var custom = line.custom || {};
				var dataset = me.getDataset();
				var lineElementOptions = me.chart.options.elements.line;
				var scale = me.chart.scale;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}
	
				helpers.extend(meta.dataset, {
					// Utility
					_datasetIndex: me.index,
					_scale: scale,
					// Data
					_children: points,
					_loop: true,
					// Model
					_model: {
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					}
				});
	
				meta.dataset.pivot();
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				}, me);
	
				// Update bezier control points
				me.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var me = this;
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var scale = me.chart.scale;
				var pointElementOptions = me.chart.options.elements.point;
				var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				helpers.extend(point, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? scale.yCenter : pointPosition.y,
	
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
						radius: custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
						pointStyle: custom.pointStyle ? custom.pointStyle : helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var chartArea = this.chart.chartArea;
				var meta = this.getMeta();
	
				helpers.each(meta.data, function(point, index) {
					var model = point._model;
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index, true)._model,
						model,
						helpers.nextItem(meta.data, index, true)._model,
						model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
					model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);
	
					model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
					model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
	
				model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
				var pointElementOptions = this.chart.options.elements.point;
	
				model.radius = custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
			}
		});
	};


/***/ }),
/* 388 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bar = function(context, config) {
			config.type = 'bar';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 389 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bubble = function(context, config) {
			config.type = 'bubble';
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 390 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Doughnut = function(context, config) {
			config.type = 'doughnut';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 391 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Line = function(context, config) {
			config.type = 'line';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.PolarArea = function(context, config) {
			config.type = 'polarArea';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Radar = function(context, config) {
			config.type = 'radar';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 394 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // scatter should not use a category axis
					position: 'bottom',
					id: 'x-axis-1' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-1'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem) {
						return '(' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ')';
					}
				}
			}
		};
	
		// Register the default config for this type
		Chart.defaults.scatter = defaultConfig;
	
		// Scatter charts use line controllers
		Chart.controllers.scatter = Chart.controllers.line;
	
		Chart.Scatter = function(context, config) {
			config.type = 'scatter';
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 395 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		/**
		 * Plugin based on discussion from the following Chart.js issues:
		 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
		 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
		 */
		Chart.defaults.global.plugins.filler = {
			propagate: true
		};
	
		var defaults = Chart.defaults;
		var helpers = Chart.helpers;
		var mappers = {
			dataset: function(source) {
				var index = source.fill;
				var chart = source.chart;
				var meta = chart.getDatasetMeta(index);
				var visible = meta && chart.isDatasetVisible(index);
				var points = (visible && meta.dataset._children) || [];
	
				return !points.length? null : function(point, i) {
					return points[i]._view || null;
				};
			},
	
			boundary: function(source) {
				var boundary = source.boundary;
				var x = boundary? boundary.x : null;
				var y = boundary? boundary.y : null;
	
				return function(point) {
					return {
						x: x === null? point.x : x,
						y: y === null? point.y : y,
					};
				};
			}
		};
	
		// @todo if (fill[0] === '#')
		function decodeFill(el, index, count) {
			var model = el._model || {};
			var fill = model.fill;
			var target;
	
			if (fill === undefined) {
				fill = !!model.backgroundColor;
			}
	
			if (fill === false || fill === null) {
				return false;
			}
	
			if (fill === true) {
				return 'origin';
			}
	
			target = parseFloat(fill, 10);
			if (isFinite(target) && Math.floor(target) === target) {
				if (fill[0] === '-' || fill[0] === '+') {
					target = index + target;
				}
	
				if (target === index || target < 0 || target >= count) {
					return false;
				}
	
				return target;
			}
	
			switch (fill) {
			// compatibility
			case 'bottom':
				return 'start';
			case 'top':
				return 'end';
			case 'zero':
				return 'origin';
			// supported boundaries
			case 'origin':
			case 'start':
			case 'end':
				return fill;
			// invalid fill values
			default:
				return false;
			}
		}
	
		function computeBoundary(source) {
			var model = source.el._model || {};
			var scale = source.el._scale || {};
			var fill = source.fill;
			var target = null;
			var horizontal;
	
			if (isFinite(fill)) {
				return null;
			}
	
			// Backward compatibility: until v3, we still need to support boundary values set on
			// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
			// controllers might still use it (e.g. the Smith chart).
	
			if (fill === 'start') {
				target = model.scaleBottom === undefined? scale.bottom : model.scaleBottom;
			} else if (fill === 'end') {
				target = model.scaleTop === undefined? scale.top : model.scaleTop;
			} else if (model.scaleZero !== undefined) {
				target = model.scaleZero;
			} else if (scale.getBasePosition) {
				target = scale.getBasePosition();
			} else if (scale.getBasePixel) {
				target = scale.getBasePixel();
			}
	
			if (target !== undefined && target !== null) {
				if (target.x !== undefined && target.y !== undefined) {
					return target;
				}
	
				if (typeof target === 'number' && isFinite(target)) {
					horizontal = scale.isHorizontal();
					return {
						x: horizontal? target : null,
						y: horizontal? null : target
					};
				}
			}
	
			return null;
		}
	
		function resolveTarget(sources, index, propagate) {
			var source = sources[index];
			var fill = source.fill;
			var visited = [index];
			var target;
	
			if (!propagate) {
				return fill;
			}
	
			while (fill !== false && visited.indexOf(fill) === -1) {
				if (!isFinite(fill)) {
					return fill;
				}
	
				target = sources[fill];
				if (!target) {
					return false;
				}
	
				if (target.visible) {
					return fill;
				}
	
				visited.push(fill);
				fill = target.fill;
			}
	
			return false;
		}
	
		function createMapper(source) {
			var fill = source.fill;
			var type = 'dataset';
	
			if (fill === false) {
				return null;
			}
	
			if (!isFinite(fill)) {
				type = 'boundary';
			}
	
			return mappers[type](source);
		}
	
		function isDrawable(point) {
			return point && !point.skip;
		}
	
		function drawArea(ctx, curve0, curve1, len0, len1) {
			var i;
	
			if (!len0 || !len1) {
				return;
			}
	
			// building first area curve (normal)
			ctx.moveTo(curve0[0].x, curve0[0].y);
			for (i=1; i<len0; ++i) {
				helpers.canvas.lineTo(ctx, curve0[i-1], curve0[i]);
			}
	
			// joining the two area curves
			ctx.lineTo(curve1[len1-1].x, curve1[len1-1].y);
	
			// building opposite area curve (reverse)
			for (i=len1-1; i>0; --i) {
				helpers.canvas.lineTo(ctx, curve1[i], curve1[i-1], true);
			}
		}
	
		function doFill(ctx, points, mapper, view, color, loop) {
			var count = points.length;
			var span = view.spanGaps;
			var curve0 = [];
			var curve1 = [];
			var len0 = 0;
			var len1 = 0;
			var i, ilen, index, p0, p1, d0, d1;
	
			ctx.beginPath();
	
			for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
				index = i%count;
				p0 = points[index]._view;
				p1 = mapper(p0, index, view);
				d0 = isDrawable(p0);
				d1 = isDrawable(p1);
	
				if (d0 && d1) {
					len0 = curve0.push(p0);
					len1 = curve1.push(p1);
				} else if (len0 && len1) {
					if (!span) {
						drawArea(ctx, curve0, curve1, len0, len1);
						len0 = len1 = 0;
						curve0 = [];
						curve1 = [];
					} else {
						if (d0) {
							curve0.push(p0);
						}
						if (d1) {
							curve1.push(p1);
						}
					}
				}
			}
	
			drawArea(ctx, curve0, curve1, len0, len1);
	
			ctx.closePath();
			ctx.fillStyle = color;
			ctx.fill();
		}
	
		return {
			id: 'filler',
	
			afterDatasetsUpdate: function(chart, options) {
				var count = (chart.data.datasets || []).length;
				var propagate = options.propagate;
				var sources = [];
				var meta, i, el, source;
	
				for (i = 0; i < count; ++i) {
					meta = chart.getDatasetMeta(i);
					el = meta.dataset;
					source = null;
	
					if (el && el._model && el instanceof Chart.elements.Line) {
						source = {
							visible: chart.isDatasetVisible(i),
							fill: decodeFill(el, i, count),
							chart: chart,
							el: el
						};
					}
	
					meta.$filler = source;
					sources.push(source);
				}
	
				for (i=0; i<count; ++i) {
					source = sources[i];
					if (!source) {
						continue;
					}
	
					source.fill = resolveTarget(sources, i, propagate);
					source.boundary = computeBoundary(source);
					source.mapper = createMapper(source);
				}
			},
	
			beforeDatasetDraw: function(chart, args) {
				var meta = args.meta.$filler;
				if (!meta) {
					return;
				}
	
				var el = meta.el;
				var view = el._view;
				var points = el._children || [];
				var mapper = meta.mapper;
				var color = view.backgroundColor || defaults.global.defaultColor;
	
				if (mapper && color && points.length) {
					doFill(chart.ctx, points, mapper, view, color, el._loop);
				}
			}
		};
	};


/***/ }),
/* 396 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var layout = Chart.layoutService;
		var noop = helpers.noop;
	
		Chart.defaults.global.legend = {
			display: true,
			position: 'top',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		};
	
		/**
		 * Helper function to get the box width based on the usePointStyle option
		 * @param labelopts {Object} the label options on the legend
		 * @param fontSize {Number} the label font size
		 * @return {Number} width of the color box area
		 */
		function getBoxWidth(labelOpts, fontSize) {
			return labelOpts.usePointStyle ?
				fontSize * Math.SQRT2 :
				labelOpts.boxWidth;
		}
	
		Chart.Legend = Chart.Element.extend({
	
			initialize: function(config) {
				helpers.extend(this, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				this.legendHitBoxes = [];
	
				// Are we in doughnut mode which has a different data type
				this.doughnutMode = false;
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
			// Any function defined here is inherited by all legend types.
			// Any function can be extended by the legend type
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: function() {
				var me = this;
				var labelOpts = me.options.labels;
				var legendItems = labelOpts.generateLabels.call(me, me.chart);
	
				if (labelOpts.filter) {
					legendItems = legendItems.filter(function(item) {
						return labelOpts.filter(item, me.chart.data);
					});
				}
	
				if (me.options.reverse) {
					legendItems.reverse();
				}
	
				me.legendItems = legendItems;
			},
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var display = opts.display;
	
				var ctx = me.ctx;
	
				var globalDefault = Chart.defaults.global,
					itemOrDefault = helpers.getValueOrDefault,
					fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
					fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
					fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
					labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
				// Reset hit boxes
				var hitboxes = me.legendHitBoxes = [];
	
				var minSize = me.minSize;
				var isHorizontal = me.isHorizontal();
	
				if (isHorizontal) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? 10 : 0;
				} else {
					minSize.width = display ? 10 : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Increase sizes here
				if (display) {
					ctx.font = labelFont;
	
					if (isHorizontal) {
						// Labels
	
						// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
						var lineWidths = me.lineWidths = [0];
						var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;
	
						ctx.textAlign = 'left';
						ctx.textBaseline = 'top';
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
								totalHeight += fontSize + (labelOpts.padding);
								lineWidths[lineWidths.length] = me.left;
							}
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: width,
								height: fontSize
							};
	
							lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
						});
	
						minSize.height += totalHeight;
	
					} else {
						var vPadding = labelOpts.padding;
						var columnWidths = me.columnWidths = [];
						var totalWidth = labelOpts.padding;
						var currentColWidth = 0;
						var currentColHeight = 0;
						var itemHeight = fontSize + vPadding;
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							// If too tall, go to new column
							if (currentColHeight + itemHeight > minSize.height) {
								totalWidth += currentColWidth + labelOpts.padding;
								columnWidths.push(currentColWidth); // previous column width
	
								currentColWidth = 0;
								currentColHeight = 0;
							}
	
							// Get max width
							currentColWidth = Math.max(currentColWidth, itemWidth);
							currentColHeight += itemHeight;
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: itemWidth,
								height: fontSize
							};
						});
	
						totalWidth += currentColWidth;
						columnWidths.push(currentColWidth);
						minSize.width += totalWidth;
					}
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
	
			// Actually draw the legend on the canvas
			draw: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var globalDefault = Chart.defaults.global,
					lineDefault = globalDefault.elements.line,
					legendWidth = me.width,
					lineWidths = me.lineWidths;
	
				if (opts.display) {
					var ctx = me.ctx,
						cursor,
						itemOrDefault = helpers.getValueOrDefault,
						fontColor = itemOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor),
						fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
						fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
						fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
						labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
					// Canvas setup
					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';
					ctx.lineWidth = 0.5;
					ctx.strokeStyle = fontColor; // for strikethrough effect
					ctx.fillStyle = fontColor; // render in correct colour
					ctx.font = labelFont;
	
					var boxWidth = getBoxWidth(labelOpts, fontSize),
						hitboxes = me.legendHitBoxes;
	
					// current position
					var drawLegendBox = function(x, y, legendItem) {
						if (isNaN(boxWidth) || boxWidth <= 0) {
							return;
						}
	
						// Set the ctx for the box
						ctx.save();
	
						ctx.fillStyle = itemOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
						ctx.lineCap = itemOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
						ctx.lineDashOffset = itemOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
						ctx.lineJoin = itemOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
						ctx.lineWidth = itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
						ctx.strokeStyle = itemOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
						var isLineWidthZero = (itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);
	
						if (ctx.setLineDash) {
							// IE 9 and 10 do not support line dash
							ctx.setLineDash(itemOrDefault(legendItem.lineDash, lineDefault.borderDash));
						}
	
						if (opts.labels && opts.labels.usePointStyle) {
							// Recalculate x and y for drawPoint() because its expecting
							// x and y to be center of figure (instead of top left)
							var radius = fontSize * Math.SQRT2 / 2;
							var offSet = radius / Math.SQRT2;
							var centerX = x + offSet;
							var centerY = y + offSet;
	
							// Draw pointStyle as legend symbol
							Chart.canvasHelpers.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
						} else {
							// Draw box as legend symbol
							if (!isLineWidthZero) {
								ctx.strokeRect(x, y, boxWidth, fontSize);
							}
							ctx.fillRect(x, y, boxWidth, fontSize);
						}
	
						ctx.restore();
					};
					var fillText = function(x, y, legendItem, textWidth) {
						ctx.fillText(legendItem.text, boxWidth + (fontSize / 2) + x, y);
	
						if (legendItem.hidden) {
							// Strikethrough the text if hidden
							ctx.beginPath();
							ctx.lineWidth = 2;
							ctx.moveTo(boxWidth + (fontSize / 2) + x, y + (fontSize / 2));
							ctx.lineTo(boxWidth + (fontSize / 2) + x + textWidth, y + (fontSize / 2));
							ctx.stroke();
						}
					};
	
					// Horizontal
					var isHorizontal = me.isHorizontal();
					if (isHorizontal) {
						cursor = {
							x: me.left + ((legendWidth - lineWidths[0]) / 2),
							y: me.top + labelOpts.padding,
							line: 0
						};
					} else {
						cursor = {
							x: me.left + labelOpts.padding,
							y: me.top + labelOpts.padding,
							line: 0
						};
					}
	
					var itemHeight = fontSize + labelOpts.padding;
					helpers.each(me.legendItems, function(legendItem, i) {
						var textWidth = ctx.measureText(legendItem.text).width,
							width = boxWidth + (fontSize / 2) + textWidth,
							x = cursor.x,
							y = cursor.y;
	
						if (isHorizontal) {
							if (x + width >= legendWidth) {
								y = cursor.y += itemHeight;
								cursor.line++;
								x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
							}
						} else if (y + itemHeight > me.bottom) {
							x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
							y = cursor.y = me.top + labelOpts.padding;
							cursor.line++;
						}
	
						drawLegendBox(x, y, legendItem);
	
						hitboxes[i].left = x;
						hitboxes[i].top = y;
	
						// Fill the actual label
						fillText(x, y, legendItem, textWidth);
	
						if (isHorizontal) {
							cursor.x += width + (labelOpts.padding);
						} else {
							cursor.y += itemHeight;
						}
	
					});
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @return {Boolean} true if a change occured
			 */
			handleEvent: function(e) {
				var me = this;
				var opts = me.options;
				var type = e.type === 'mouseup' ? 'click' : e.type;
				var changed = false;
	
				if (type === 'mousemove') {
					if (!opts.onHover) {
						return;
					}
				} else if (type === 'click') {
					if (!opts.onClick) {
						return;
					}
				} else {
					return;
				}
	
				// Chart event already has relative position in it
				var x = e.x,
					y = e.y;
	
				if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
					// See if we are touching one of the dataset boxes
					var lh = me.legendHitBoxes;
					for (var i = 0; i < lh.length; ++i) {
						var hitBox = lh[i];
	
						if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
							// Touching an element
							if (type === 'click') {
								// use e.native for backwards compatibility
								opts.onClick.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							} else if (type === 'mousemove') {
								// use e.native for backwards compatibility
								opts.onHover.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							}
						}
					}
				}
	
				return changed;
			}
		});
	
		function createNewLegendAndAttach(chart, legendOpts) {
			var legend = new Chart.Legend({
				ctx: chart.ctx,
				options: legendOpts,
				chart: chart
			});
	
			layout.configure(chart, legend, legendOpts);
			layout.addBox(chart, legend);
			chart.legend = legend;
		}
	
		return {
			id: 'legend',
	
			beforeInit: function(chart) {
				var legendOpts = chart.options.legend;
	
				if (legendOpts) {
					createNewLegendAndAttach(chart, legendOpts);
				}
			},
	
			beforeUpdate: function(chart) {
				var legendOpts = chart.options.legend;
				var legend = chart.legend;
	
				if (legendOpts) {
					legendOpts = helpers.configMerge(Chart.defaults.global.legend, legendOpts);
	
					if (legend) {
						layout.configure(chart, legend, legendOpts);
						legend.options = legendOpts;
					} else {
						createNewLegendAndAttach(chart, legendOpts);
					}
				} else if (legend) {
					layout.removeBox(chart, legend);
					delete chart.legend;
				}
			},
	
			afterEvent: function(chart, e) {
				var legend = chart.legend;
				if (legend) {
					legend.handleEvent(e);
				}
			}
		};
	};


/***/ }),
/* 397 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var layout = Chart.layoutService;
		var noop = helpers.noop;
	
		Chart.defaults.global.title = {
			display: false,
			position: 'top',
			fullWidth: true,
			weight: 2000,        // by default greater than legend (1000) to be above
			fontStyle: 'bold',
			padding: 10,
	
			// actual title
			text: ''
		};
	
		Chart.Title = Chart.Element.extend({
			initialize: function(config) {
				var me = this;
				helpers.extend(me, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				me.legendHitBoxes = [];
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: noop,
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global,
					display = opts.display,
					fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
					minSize = me.minSize;
	
				if (me.isHorizontal()) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? fontSize + (opts.padding * 2) : 0;
				} else {
					minSize.width = display ? fontSize + (opts.padding * 2) : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				var pos = this.options.position;
				return pos === 'top' || pos === 'bottom';
			},
	
			// Actually draw the title block on the canvas
			draw: function() {
				var me = this,
					ctx = me.ctx,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global;
	
				if (opts.display) {
					var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
						fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle),
						fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily),
						titleFont = helpers.fontString(fontSize, fontStyle, fontFamily),
						rotation = 0,
						titleX,
						titleY,
						top = me.top,
						left = me.left,
						bottom = me.bottom,
						right = me.right,
						maxWidth;
	
					ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
					ctx.font = titleFont;
	
					// Horizontal
					if (me.isHorizontal()) {
						titleX = left + ((right - left) / 2); // midpoint of the width
						titleY = top + ((bottom - top) / 2); // midpoint of the height
						maxWidth = right - left;
					} else {
						titleX = opts.position === 'left' ? left + (fontSize / 2) : right - (fontSize / 2);
						titleY = top + ((bottom - top) / 2);
						maxWidth = bottom - top;
						rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
					}
	
					ctx.save();
					ctx.translate(titleX, titleY);
					ctx.rotate(rotation);
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					ctx.fillText(opts.text, 0, 0, maxWidth);
					ctx.restore();
				}
			}
		});
	
		function createNewTitleBlockAndAttach(chart, titleOpts) {
			var title = new Chart.Title({
				ctx: chart.ctx,
				options: titleOpts,
				chart: chart
			});
	
			layout.configure(chart, title, titleOpts);
			layout.addBox(chart, title);
			chart.titleBlock = title;
		}
	
		return {
			id: 'title',
	
			beforeInit: function(chart) {
				var titleOpts = chart.options.title;
	
				if (titleOpts) {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			},
	
			beforeUpdate: function(chart) {
				var titleOpts = chart.options.title;
				var titleBlock = chart.titleBlock;
	
				if (titleOpts) {
					titleOpts = helpers.configMerge(Chart.defaults.global.title, titleOpts);
	
					if (titleBlock) {
						layout.configure(chart, titleBlock, titleOpts);
						titleBlock.options = titleOpts;
					} else {
						createNewTitleBlockAndAttach(chart, titleOpts);
					}
				} else if (titleBlock) {
					Chart.layoutService.removeBox(chart, titleBlock);
					delete chart.titleBlock;
				}
			}
		};
	};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	(function (factory) {
	  'use strict';
	  if (true) {
	    // Node/CommonJS
	    module.exports = factory(
	      typeof angular !== 'undefined' ? angular : __webpack_require__(14),
	      typeof Chart !== 'undefined' ? Chart : __webpack_require__(399));
	  }  else if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module.
	    define(['angular', 'chart'], factory);
	  } else {
	    // Browser globals
	    if (typeof angular === 'undefined') {
	        throw new Error('AngularJS framework needs to be included, see https://angularjs.org/');
	    } else if (typeof Chart === 'undefined') {
	      throw new Error('Chart.js library needs to be included, see http://jtblin.github.io/angular-chart.js/');
	    }
	    factory(angular, Chart);
	  }
	}(function (angular, Chart) {
	  'use strict';
	
	  Chart.defaults.global.multiTooltipTemplate = '<%if (datasetLabel){%><%=datasetLabel%>: <%}%><%= value %>';
	  Chart.defaults.global.tooltips.mode = 'label';
	  Chart.defaults.global.elements.line.borderWidth = 2;
	  Chart.defaults.global.elements.rectangle.borderWidth = 2;
	  Chart.defaults.global.legend.display = false;
	  Chart.defaults.global.colors = [
	    '#97BBCD', // blue
	    '#DCDCDC', // light grey
	    '#F7464A', // red
	    '#46BFBD', // green
	    '#FDB45C', // yellow
	    '#949FB1', // grey
	    '#4D5360'  // dark grey
	  ];
	
	  var useExcanvas = typeof window.G_vmlCanvasManager === 'object' &&
	    window.G_vmlCanvasManager !== null &&
	    typeof window.G_vmlCanvasManager.initElement === 'function';
	
	  if (useExcanvas) Chart.defaults.global.animation = false;
	
	  return angular.module('chart.js', [])
	    .provider('ChartJs', ChartJsProvider)
	    .factory('ChartJsFactory', ['ChartJs', '$timeout', ChartJsFactory])
	    .directive('chartBase', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory(); }])
	    .directive('chartLine', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('line'); }])
	    .directive('chartBar', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('bar'); }])
	    .directive('chartHorizontalBar', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('horizontalBar'); }])
	    .directive('chartRadar', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('radar'); }])
	    .directive('chartDoughnut', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('doughnut'); }])
	    .directive('chartPie', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('pie'); }])
	    .directive('chartPolarArea', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('polarArea'); }])
	    .directive('chartBubble', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('bubble'); }])
	    .name;
	
	  /**
	   * Wrapper for chart.js
	   * Allows configuring chart js using the provider
	   *
	   * angular.module('myModule', ['chart.js']).config(function(ChartJsProvider) {
	   *   ChartJsProvider.setOptions({ responsive: false });
	   *   ChartJsProvider.setOptions('Line', { responsive: true });
	   * })))
	   */
	  function ChartJsProvider () {
	    var options = { responsive: true };
	    var ChartJs = {
	      Chart: Chart,
	      getOptions: function (type) {
	        var typeOptions = type && options[type] || {};
	        return angular.extend({}, options, typeOptions);
	      }
	    };
	
	    /**
	     * Allow to set global options during configuration
	     */
	    this.setOptions = function (type, customOptions) {
	      // If no type was specified set option for the global object
	      if (! customOptions) {
	        customOptions = type;
	        options = angular.merge(options, customOptions);
	      } else {
	        // Set options for the specific chart
	        options[type] = angular.merge(options[type] || {}, customOptions);
	      }
	
	      angular.merge(ChartJs.Chart.defaults, options);
	    };
	
	    this.$get = function () {
	      return ChartJs;
	    };
	  }
	
	  function ChartJsFactory (ChartJs, $timeout) {
	    return function chart (type) {
	      return {
	        restrict: 'CA',
	        scope: {
	          chartGetColor: '=?',
	          chartType: '=',
	          chartData: '=?',
	          chartLabels: '=?',
	          chartOptions: '=?',
	          chartSeries: '=?',
	          chartColors: '=?',
	          chartClick: '=?',
	          chartHover: '=?',
	          chartDatasetOverride: '=?'
	        },
	        link: function (scope, elem/*, attrs */) {
	          if (useExcanvas) window.G_vmlCanvasManager.initElement(elem[0]);
	
	          // Order of setting "watch" matter
	          scope.$watch('chartData', watchData, true);
	          scope.$watch('chartSeries', watchOther, true);
	          scope.$watch('chartLabels', watchOther, true);
	          scope.$watch('chartOptions', watchOther, true);
	          scope.$watch('chartColors', watchOther, true);
	          scope.$watch('chartDatasetOverride', watchOther, true);
	          scope.$watch('chartType', watchType, false);
	
	          scope.$on('$destroy', function () {
	            destroyChart(scope);
	          });
	
	          scope.$on('$resize', function () {
	            if (scope.chart) scope.chart.resize();
	          });
	
	          function watchData (newVal, oldVal) {
	            if (! newVal || ! newVal.length || (Array.isArray(newVal[0]) && ! newVal[0].length)) {
	              destroyChart(scope);
	              return;
	            }
	            var chartType = type || scope.chartType;
	            if (! chartType) return;
	
	            if (scope.chart && canUpdateChart(newVal, oldVal))
	              return updateChart(newVal, scope);
	
	            createChart(chartType, scope, elem);
	          }
	
	          function watchOther (newVal, oldVal) {
	            if (isEmpty(newVal)) return;
	            if (angular.equals(newVal, oldVal)) return;
	            var chartType = type || scope.chartType;
	            if (! chartType) return;
	
	            // chart.update() doesn't work for series and labels
	            // so we have to re-create the chart entirely
	            createChart(chartType, scope, elem);
	          }
	
	          function watchType (newVal, oldVal) {
	            if (isEmpty(newVal)) return;
	            if (angular.equals(newVal, oldVal)) return;
	            createChart(newVal, scope, elem);
	          }
	        }
	      };
	    };
	
	    function createChart (type, scope, elem) {
	      var options = getChartOptions(type, scope);
	      if (! hasData(scope) || ! canDisplay(type, scope, elem, options)) return;
	
	      var cvs = elem[0];
	      var ctx = cvs.getContext('2d');
	
	      scope.chartGetColor = getChartColorFn(scope);
	      var data = getChartData(type, scope);
	      // Destroy old chart if it exists to avoid ghost charts issue
	      // https://github.com/jtblin/angular-chart.js/issues/187
	      destroyChart(scope);
	
	      scope.chart = new ChartJs.Chart(ctx, {
	        type: type,
	        data: data,
	        options: options
	      });
	      scope.$emit('chart-create', scope.chart);
	      bindEvents(cvs, scope);
	    }
	
	    function canUpdateChart (newVal, oldVal) {
	      if (newVal && oldVal && newVal.length && oldVal.length) {
	        return Array.isArray(newVal[0]) ?
	        newVal.length === oldVal.length && newVal.every(function (element, index) {
	          return element.length === oldVal[index].length; }) :
	          oldVal.reduce(sum, 0) > 0 ? newVal.length === oldVal.length : false;
	      }
	      return false;
	    }
	
	    function sum (carry, val) {
	      return carry + val;
	    }
	
	    function getEventHandler (scope, action, triggerOnlyOnChange) {
	      var lastState = {
	        point: void 0,
	        points: void 0
	      };
	      return function (evt) {
	        var atEvent = scope.chart.getElementAtEvent || scope.chart.getPointAtEvent;
	        var atEvents = scope.chart.getElementsAtEvent || scope.chart.getPointsAtEvent;
	        if (atEvents) {
	          var points = atEvents.call(scope.chart, evt);
	          var point = atEvent ? atEvent.call(scope.chart, evt)[0] : void 0;
	
	          if (triggerOnlyOnChange === false ||
	            (! angular.equals(lastState.points, points) && ! angular.equals(lastState.point, point))
	          ) {
	            lastState.point = point;
	            lastState.points = points;
	            scope[action](points, evt, point);
	          }
	        }
	      };
	    }
	
	    function getColors (type, scope) {
	      var colors = angular.copy(scope.chartColors ||
	        ChartJs.getOptions(type).chartColors ||
	        Chart.defaults.global.colors
	      );
	      var notEnoughColors = colors.length < scope.chartData.length;
	      while (colors.length < scope.chartData.length) {
	        colors.push(scope.chartGetColor());
	      }
	      // mutate colors in this case as we don't want
	      // the colors to change on each refresh
	      if (notEnoughColors) scope.chartColors = colors;
	      return colors.map(convertColor);
	    }
	
	    function convertColor (color) {
	      // Allows RGB and RGBA colors to be input as a string: e.g.: "rgb(159,204,0)", "rgba(159,204,0, 0.5)"
	      if (typeof color === 'string' && color[0] === 'r') return getColor(rgbStringToRgb(color));
	      // Allows hex colors to be input as a string.
	      if (typeof color === 'string' && color[0] === '#') return getColor(hexToRgb(color.substr(1)));
	      // Allows colors to be input as an object, bypassing getColor() entirely
	      if (typeof color === 'object' && color !== null) return color;
	      return getRandomColor();
	    }
	
	    function getRandomColor () {
	      var color = [getRandomInt(0, 255), getRandomInt(0, 255), getRandomInt(0, 255)];
	      return getColor(color);
	    }
	
	    function getColor (color) {
	      var alpha = color[3] || 1;
	      color = color.slice(0, 3);
	      return {
	        backgroundColor: rgba(color, 0.2),
	        pointBackgroundColor: rgba(color, alpha),
	        pointHoverBackgroundColor: rgba(color, 0.8),
	        borderColor: rgba(color, alpha),
	        pointBorderColor: '#fff',
	        pointHoverBorderColor: rgba(color, alpha)
	      };
	    }
	
	    function getRandomInt (min, max) {
	      return Math.floor(Math.random() * (max - min + 1)) + min;
	    }
	
	    function rgba (color, alpha) {
	      // rgba not supported by IE8
	      return useExcanvas ? 'rgb(' + color.join(',') + ')' : 'rgba(' + color.concat(alpha).join(',') + ')';
	    }
	
	    // Credit: http://stackoverflow.com/a/11508164/1190235
	    function hexToRgb (hex) {
	      var bigint = parseInt(hex, 16),
	        r = (bigint >> 16) & 255,
	        g = (bigint >> 8) & 255,
	        b = bigint & 255;
	
	      return [r, g, b];
	    }
	
	    function rgbStringToRgb (color) {
	      var match = color.match(/^rgba?\(([\d,.]+)\)$/);
	      if (! match) throw new Error('Cannot parse rgb value');
	      color = match[1].split(',');
	      return color.map(Number);
	    }
	
	    function hasData (scope) {
	      return scope.chartData && scope.chartData.length;
	    }
	
	    function getChartColorFn (scope) {
	      return typeof scope.chartGetColor === 'function' ? scope.chartGetColor : getRandomColor;
	    }
	
	    function getChartData (type, scope) {
	      var colors = getColors(type, scope);
	      return Array.isArray(scope.chartData[0]) ?
	        getDataSets(scope.chartLabels, scope.chartData, scope.chartSeries || [], colors, scope.chartDatasetOverride) :
	        getData(scope.chartLabels, scope.chartData, colors, scope.chartDatasetOverride);
	    }
	
	    function getDataSets (labels, data, series, colors, datasetOverride) {
	      return {
	        labels: labels,
	        datasets: data.map(function (item, i) {
	          var dataset = angular.extend({}, colors[i], {
	            label: series[i],
	            data: item
	          });
	          if (datasetOverride && datasetOverride.length >= i) {
	            angular.merge(dataset, datasetOverride[i]);
	          }
	          return dataset;
	        })
	      };
	    }
	
	    function getData (labels, data, colors, datasetOverride) {
	      var dataset = {
	        labels: labels,
	        datasets: [{
	          data: data,
	          backgroundColor: colors.map(function (color) {
	            return color.pointBackgroundColor;
	          }),
	          hoverBackgroundColor: colors.map(function (color) {
	            return color.backgroundColor;
	          })
	        }]
	      };
	      if (datasetOverride) {
	        angular.merge(dataset.datasets[0], datasetOverride);
	      }
	      return dataset;
	    }
	
	    function getChartOptions (type, scope) {
	      return angular.extend({}, ChartJs.getOptions(type), scope.chartOptions);
	    }
	
	    function bindEvents (cvs, scope) {
	      cvs.onclick = scope.chartClick ? getEventHandler(scope, 'chartClick', false) : angular.noop;
	      cvs.onmousemove = scope.chartHover ? getEventHandler(scope, 'chartHover', true) : angular.noop;
	    }
	
	    function updateChart (values, scope) {
	      if (Array.isArray(scope.chartData[0])) {
	        scope.chart.data.datasets.forEach(function (dataset, i) {
	          dataset.data = values[i];
	        });
	      } else {
	        scope.chart.data.datasets[0].data = values;
	      }
	
	      scope.chart.update();
	      scope.$emit('chart-update', scope.chart);
	    }
	
	    function isEmpty (value) {
	      return ! value ||
	        (Array.isArray(value) && ! value.length) ||
	        (typeof value === 'object' && ! Object.keys(value).length);
	    }
	
	    function canDisplay (type, scope, elem, options) {
	      // TODO: check parent?
	      if (options.responsive && elem[0].clientHeight === 0) {
	        $timeout(function () {
	          createChart(type, scope, elem);
	        }, 50, false);
	        return false;
	      }
	      return true;
	    }
	
	    function destroyChart(scope) {
	      if(! scope.chart) return;
	      scope.chart.destroy();
	      scope.$emit('chart-destroy', scope.chart);
	    }
	  }
	}));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @namespace Chart
	 */
	var Chart = __webpack_require__(400)();
	
	__webpack_require__(401)(Chart);
	__webpack_require__(402)(Chart);
	__webpack_require__(403)(Chart);
	__webpack_require__(404)(Chart);
	__webpack_require__(405)(Chart);
	__webpack_require__(406)(Chart);
	__webpack_require__(407)(Chart);
	__webpack_require__(408)(Chart);
	__webpack_require__(409)(Chart);
	__webpack_require__(410)(Chart);
	__webpack_require__(411)(Chart);
	__webpack_require__(412)(Chart);
	__webpack_require__(413)(Chart);
	
	__webpack_require__(414)(Chart);
	__webpack_require__(415)(Chart);
	__webpack_require__(416)(Chart);
	__webpack_require__(417)(Chart);
	
	__webpack_require__(418)(Chart);
	__webpack_require__(419)(Chart);
	__webpack_require__(420)(Chart);
	__webpack_require__(421)(Chart);
	__webpack_require__(422)(Chart);
	__webpack_require__(423)(Chart);
	
	// Controllers must be loaded after elements
	// See Chart.core.datasetController.dataElementType
	__webpack_require__(424)(Chart);
	__webpack_require__(425)(Chart);
	__webpack_require__(426)(Chart);
	__webpack_require__(427)(Chart);
	__webpack_require__(428)(Chart);
	__webpack_require__(429)(Chart);
	
	__webpack_require__(430)(Chart);
	__webpack_require__(431)(Chart);
	__webpack_require__(432)(Chart);
	__webpack_require__(433)(Chart);
	__webpack_require__(434)(Chart);
	__webpack_require__(435)(Chart);
	__webpack_require__(436)(Chart);
	
	window.Chart = module.exports = Chart;


/***/ }),
/* 400 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function() {
	
		// Occupy the global variable of Chart, and create a simple base class
		var Chart = function(context, config) {
			var me = this;
			var helpers = Chart.helpers;
			me.config = config || {
				data: {
					datasets: []
				}
			};
	
			// Support a jQuery'd canvas element
			if (context.length && context[0].getContext) {
				context = context[0];
			}
	
			// Support a canvas domnode
			if (context.getContext) {
				context = context.getContext('2d');
			}
	
			me.ctx = context;
			me.canvas = context.canvas;
	
			context.canvas.style.display = context.canvas.style.display || 'block';
	
			// Figure out what the size of the chart will be.
			// If the canvas has a specified width and height, we use those else
			// we look to see if the canvas node has a CSS width and height.
			// If there is still no height, fill the parent container
			me.width = context.canvas.width || parseInt(helpers.getStyle(context.canvas, 'width'), 10) || helpers.getMaximumWidth(context.canvas);
			me.height = context.canvas.height || parseInt(helpers.getStyle(context.canvas, 'height'), 10) || helpers.getMaximumHeight(context.canvas);
	
			me.aspectRatio = me.width / me.height;
	
			if (isNaN(me.aspectRatio) || isFinite(me.aspectRatio) === false) {
				// If the canvas has no size, try and figure out what the aspect ratio will be.
				// Some charts prefer square canvases (pie, radar, etc). If that is specified, use that
				// else use the canvas default ratio of 2
				me.aspectRatio = config.aspectRatio !== undefined ? config.aspectRatio : 2;
			}
	
			// Store the original style of the element so we can set it back
			me.originalCanvasStyleWidth = context.canvas.style.width;
			me.originalCanvasStyleHeight = context.canvas.style.height;
	
			// High pixel density displays - multiply the size of the canvas height/width by the device pixel ratio, then scale.
			helpers.retinaScale(me);
			me.controller = new Chart.Controller(me);
	
			// Always bind this so that if the responsive state changes we still work
			helpers.addResizeListener(context.canvas.parentNode, function() {
				if (me.controller && me.controller.config.options.responsive) {
					me.controller.resize();
				}
			});
	
			return me.controller ? me.controller : me;
	
		};
	
		// Globally expose the defaults to allow for user updating/changing
		Chart.defaults = {
			global: {
				responsive: true,
				responsiveAnimationDuration: 0,
				maintainAspectRatio: true,
				events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
				hover: {
					onHover: null,
					mode: 'single',
					animationDuration: 400
				},
				onClick: null,
				defaultColor: 'rgba(0,0,0,0.1)',
				defaultFontColor: '#666',
				defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
				defaultFontSize: 12,
				defaultFontStyle: 'normal',
				showLines: true,
	
				// Element defaults defined in element extensions
				elements: {},
	
				// Legend callback string
				legendCallback: function(chart) {
					var text = [];
					text.push('<ul class="' + chart.id + '-legend">');
					for (var i = 0; i < chart.data.datasets.length; i++) {
						text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
						if (chart.data.datasets[i].label) {
							text.push(chart.data.datasets[i].label);
						}
						text.push('</li>');
					}
					text.push('</ul>');
	
					return text.join('');
				}
			}
		};
	
		Chart.Chart = Chart;
	
		return Chart;
	
	};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	/* global window: false */
	/* global document: false */
	'use strict';
	
	var color = __webpack_require__(353);
	
	module.exports = function(Chart) {
		// Global Chart helpers object for utility methods and classes
		var helpers = Chart.helpers = {};
	
		// -- Basic js utility methods
		helpers.each = function(loopable, callback, self, reverse) {
			// Check to see if null or undefined firstly.
			var i, len;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						callback.call(self, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						callback.call(self, loopable[i], i);
					}
				}
			} else if (typeof loopable === 'object') {
				var keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					callback.call(self, loopable[keys[i]], keys[i]);
				}
			}
		};
		helpers.clone = function(obj) {
			var objClone = {};
			helpers.each(obj, function(value, key) {
				if (helpers.isArray(value)) {
					objClone[key] = value.slice(0);
				} else if (typeof value === 'object' && value !== null) {
					objClone[key] = helpers.clone(value);
				} else {
					objClone[key] = value;
				}
			});
			return objClone;
		};
		helpers.extend = function(base) {
			var setFn = function(value, key) {
				base[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; i++) {
				helpers.each(arguments[i], setFn);
			}
			return base;
		};
		// Need a special merge function to chart configs since they are now grouped
		helpers.configMerge = function(_base) {
			var base = helpers.clone(_base);
			helpers.each(Array.prototype.slice.call(arguments, 1), function(extension) {
				helpers.each(extension, function(value, key) {
					if (key === 'scales') {
						// Scale config merging is complex. Add out own function here for that
						base[key] = helpers.scaleMerge(base.hasOwnProperty(key) ? base[key] : {}, value);
	
					} else if (key === 'scale') {
						// Used in polar area & radar charts since there is only one scale
						base[key] = helpers.configMerge(base.hasOwnProperty(key) ? base[key] : {}, Chart.scaleService.getScaleDefaults(value.type), value);
					} else if (base.hasOwnProperty(key) && helpers.isArray(base[key]) && helpers.isArray(value)) {
						// In this case we have an array of objects replacing another array. Rather than doing a strict replace,
						// merge. This allows easy scale option merging
						var baseArray = base[key];
	
						helpers.each(value, function(valueObj, index) {
	
							if (index < baseArray.length) {
								if (typeof baseArray[index] === 'object' && baseArray[index] !== null && typeof valueObj === 'object' && valueObj !== null) {
									// Two objects are coming together. Do a merge of them.
									baseArray[index] = helpers.configMerge(baseArray[index], valueObj);
								} else {
									// Just overwrite in this case since there is nothing to merge
									baseArray[index] = valueObj;
								}
							} else {
								baseArray.push(valueObj); // nothing to merge
							}
						});
	
					} else if (base.hasOwnProperty(key) && typeof base[key] === 'object' && base[key] !== null && typeof value === 'object') {
						// If we are overwriting an object with an object, do a merge of the properties.
						base[key] = helpers.configMerge(base[key], value);
	
					} else {
						// can just overwrite the value in this case
						base[key] = value;
					}
				});
			});
	
			return base;
		};
		helpers.scaleMerge = function(_base, extension) {
			var base = helpers.clone(_base);
	
			helpers.each(extension, function(value, key) {
				if (key === 'xAxes' || key === 'yAxes') {
					// These properties are arrays of items
					if (base.hasOwnProperty(key)) {
						helpers.each(value, function(valueObj, index) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							var axisDefaults = Chart.scaleService.getScaleDefaults(axisType);
							if (index >= base[key].length || !base[key][index].type) {
								base[key].push(helpers.configMerge(axisDefaults, valueObj));
							} else if (valueObj.type && valueObj.type !== base[key][index].type) {
								// Type changed. Bring in the new defaults before we bring in valueObj so that valueObj can override the correct scale defaults
								base[key][index] = helpers.configMerge(base[key][index], axisDefaults, valueObj);
							} else {
								// Type is the same
								base[key][index] = helpers.configMerge(base[key][index], valueObj);
							}
						});
					} else {
						base[key] = [];
						helpers.each(value, function(valueObj) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							base[key].push(helpers.configMerge(Chart.scaleService.getScaleDefaults(axisType), valueObj));
						});
					}
				} else if (base.hasOwnProperty(key) && typeof base[key] === 'object' && base[key] !== null && typeof value === 'object') {
					// If we are overwriting an object with an object, do a merge of the properties.
					base[key] = helpers.configMerge(base[key], value);
	
				} else {
					// can just overwrite the value in this case
					base[key] = value;
				}
			});
	
			return base;
		};
		helpers.getValueAtIndexOrDefault = function(value, index, defaultValue) {
			if (value === undefined || value === null) {
				return defaultValue;
			}
	
			if (helpers.isArray(value)) {
				return index < value.length ? value[index] : defaultValue;
			}
	
			return value;
		};
		helpers.getValueOrDefault = function(value, defaultValue) {
			return value === undefined ? defaultValue : value;
		};
		helpers.indexOf = Array.prototype.indexOf?
			function(array, item) {
				return array.indexOf(item);
			}:
			function(array, item) {
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (array[i] === item) {
						return i;
					}
				}
				return -1;
			};
		helpers.where = function(collection, filterCallback) {
			if (helpers.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers.findIndex = Array.prototype.findIndex?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.inherits = function(extensions) {
			// Basic javascript inheritance based on the model created in Backbone.js
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
	
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
	
			return ChartElement;
		};
		helpers.noop = function() {};
		helpers.uid = (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}());
		// -- Math methods
		helpers.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers.sign = Math.sign?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers.log10 = Math.log10?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				return Math.log(x) / Math.LN10;
			};
		helpers.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x,
				distanceFromYCenter = anglePoint.y - centrePoint.y,
				radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint,
				current = middlePoint,
				next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers.EPSILON = Number.EPSILON || 1e-14;
		helpers.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					pointCurrent.deltaK = (pointAfter.model.y - pointCurrent.model.y) / (pointAfter.model.x - pointCurrent.model.x);
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers.niceNum = function(range, round) {
			var exponent = Math.floor(helpers.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Easing functions adapted from Robert Penner's easing equations
		// http://www.robertpenner.com/easing/
		var easingEffects = helpers.easingEffects = {
			linear: function(t) {
				return t;
			},
			easeInQuad: function(t) {
				return t * t;
			},
			easeOutQuad: function(t) {
				return -1 * t * (t - 2);
			},
			easeInOutQuad: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t;
				}
				return -1 / 2 * ((--t) * (t - 2) - 1);
			},
			easeInCubic: function(t) {
				return t * t * t;
			},
			easeOutCubic: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t + 1);
			},
			easeInOutCubic: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t + 2);
			},
			easeInQuart: function(t) {
				return t * t * t * t;
			},
			easeOutQuart: function(t) {
				return -1 * ((t = t / 1 - 1) * t * t * t - 1);
			},
			easeInOutQuart: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t;
				}
				return -1 / 2 * ((t -= 2) * t * t * t - 2);
			},
			easeInQuint: function(t) {
				return 1 * (t /= 1) * t * t * t * t;
			},
			easeOutQuint: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t * t * t + 1);
			},
			easeInOutQuint: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t * t * t + 2);
			},
			easeInSine: function(t) {
				return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1;
			},
			easeOutSine: function(t) {
				return 1 * Math.sin(t / 1 * (Math.PI / 2));
			},
			easeInOutSine: function(t) {
				return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1);
			},
			easeInExpo: function(t) {
				return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1));
			},
			easeOutExpo: function(t) {
				return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1);
			},
			easeInOutExpo: function(t) {
				if (t === 0) {
					return 0;
				}
				if (t === 1) {
					return 1;
				}
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * Math.pow(2, 10 * (t - 1));
				}
				return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
			},
			easeInCirc: function(t) {
				if (t >= 1) {
					return t;
				}
				return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1);
			},
			easeOutCirc: function(t) {
				return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t);
			},
			easeInOutCirc: function(t) {
				if ((t /= 1 / 2) < 1) {
					return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
				}
				return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
			},
			easeInElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
			},
			easeOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1;
			},
			easeInOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1 / 2) === 2) {
					return 1;
				}
				if (!p) {
					p = 1 * (0.3 * 1.5);
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				if (t < 1) {
					return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
				}
				return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
			},
			easeInBack: function(t) {
				var s = 1.70158;
				return 1 * (t /= 1) * t * ((s + 1) * t - s);
			},
			easeOutBack: function(t) {
				var s = 1.70158;
				return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1);
			},
			easeInOutBack: function(t) {
				var s = 1.70158;
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s));
				}
				return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
			},
			easeInBounce: function(t) {
				return 1 - easingEffects.easeOutBounce(1 - t);
			},
			easeOutBounce: function(t) {
				if ((t /= 1) < (1 / 2.75)) {
					return 1 * (7.5625 * t * t);
				} else if (t < (2 / 2.75)) {
					return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75);
				} else if (t < (2.5 / 2.75)) {
					return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375);
				}
				return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375);
			},
			easeInOutBounce: function(t) {
				if (t < 1 / 2) {
					return easingEffects.easeInBounce(t * 2) * 0.5;
				}
				return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5;
			}
		};
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers.requestAnimFrame = (function() {
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		helpers.cancelAnimFrame = (function() {
			return window.cancelAnimationFrame ||
				window.webkitCancelAnimationFrame ||
				window.mozCancelAnimationFrame ||
				window.oCancelAnimationFrame ||
				window.msCancelAnimationFrame ||
				function(callback) {
					return window.clearTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt,
				canvas = evt.currentTarget || evt.srcElement,
				boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
		helpers.addEvent = function(node, eventType, method) {
			if (node.addEventListener) {
				node.addEventListener(eventType, method);
			} else if (node.attachEvent) {
				node.attachEvent('on' + eventType, method);
			} else {
				node['on' + eventType] = method;
			}
		};
		helpers.removeEvent = function(node, eventType, handler) {
			if (node.removeEventListener) {
				node.removeEventListener(eventType, handler, false);
			} else if (node.detachEvent) {
				node.detachEvent('on' + eventType, handler);
			} else {
				node['on' + eventType] = helpers.noop;
			}
		};
		helpers.bindEvents = function(chartInstance, arrayOfEvents, handler) {
			// Create the events object if it's not already present
			var events = chartInstance.events = chartInstance.events || {};
	
			helpers.each(arrayOfEvents, function(eventName) {
				events[eventName] = function() {
					handler.apply(chartInstance, arguments);
				};
				helpers.addEvent(chartInstance.chart.canvas, eventName, events[eventName]);
			});
		};
		helpers.unbindEvents = function(chartInstance, arrayOfEvents) {
			var canvas = chartInstance.chart.canvas;
			helpers.each(arrayOfEvents, function(handler, eventName) {
				helpers.removeEvent(canvas, eventName, handler);
			});
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof(styleValue) === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = domNode.parentNode;
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		helpers.getMaximumWidth = function(domNode) {
			var container = domNode.parentNode;
			var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
			var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
			var w = container.clientWidth - paddingLeft - paddingRight;
			var cw = helpers.getConstraintWidth(domNode);
			return isNaN(cw)? w : Math.min(w, cw);
		};
		helpers.getMaximumHeight = function(domNode) {
			var container = domNode.parentNode;
			var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
			var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
			var h = container.clientHeight - paddingTop - paddingBottom;
			var ch = helpers.getConstraintHeight(domNode);
			return isNaN(ch)? h : Math.min(h, ch);
		};
		helpers.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers.retinaScale = function(chart) {
			var ctx = chart.ctx;
			var canvas = chart.canvas;
			var width = canvas.width;
			var height = canvas.height;
			var pixelRatio = chart.currentDevicePixelRatio = window.devicePixelRatio || 1;
	
			if (pixelRatio !== 1) {
				canvas.height = height * pixelRatio;
				canvas.width = width * pixelRatio;
				ctx.scale(pixelRatio, pixelRatio);
	
				// Store the device pixel ratio so that we can go backwards in `destroy`.
				// The devicePixelRatio changes with zoom, so there are no guarantees that it is the same
				// when destroy is called
				chart.originalDevicePixelRatio = chart.originalDevicePixelRatio || pixelRatio;
			}
	
			canvas.style.width = width + 'px';
			canvas.style.height = height + 'px';
		};
		// -- Canvas methods
		helpers.clear = function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		};
		helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
					longest = helpers.measureText(ctx, data, gc, longest, thing);
				} else if (helpers.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
							longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers.each(arrayOfThings, function(thing) {
				if (helpers.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
		helpers.drawRoundedRectangle = function(ctx, x, y, width, height, radius) {
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
		};
		helpers.color = function(c) {
			if (!color) {
				console.error('Color.js not found!');
				return c;
			}
	
			/* global CanvasGradient */
			if (c instanceof CanvasGradient) {
				return color(Chart.defaults.global.defaultColor);
			}
	
			return color(c);
		};
		helpers.addResizeListener = function(node, callback) {
			// Hide an iframe before the node
			var hiddenIframe = document.createElement('iframe');
			var hiddenIframeClass = 'chartjs-hidden-iframe';
	
			if (hiddenIframe.classlist) {
				// can use classlist
				hiddenIframe.classlist.add(hiddenIframeClass);
			} else {
				hiddenIframe.setAttribute('class', hiddenIframeClass);
			}
	
			// Set the style
			hiddenIframe.tabIndex = -1;
			var style = hiddenIframe.style;
			style.width = '100%';
			style.display = 'block';
			style.border = 0;
			style.height = 0;
			style.margin = 0;
			style.position = 'absolute';
			style.left = 0;
			style.right = 0;
			style.top = 0;
			style.bottom = 0;
	
			// Insert the iframe so that contentWindow is available
			node.insertBefore(hiddenIframe, node.firstChild);
	
			(hiddenIframe.contentWindow || hiddenIframe).onresize = function() {
				if (callback) {
					return callback();
				}
			};
		};
		helpers.removeResizeListener = function(node) {
			var hiddenIframe = node.querySelector('.chartjs-hidden-iframe');
	
			// Remove the resize detect iframe
			if (hiddenIframe) {
				hiddenIframe.parentNode.removeChild(hiddenIframe);
			}
		};
		helpers.isArray = Array.isArray?
			function(obj) {
				return Array.isArray(obj);
			} :
			function(obj) {
				return Object.prototype.toString.call(obj) === '[object Array]';
			};
		// ! @see http://stackoverflow.com/a/14853974
		helpers.arrayEquals = function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen=a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		};
		helpers.callCallback = function(fn, args, _tArg) {
			if (fn && typeof fn.call === 'function') {
				fn.apply(_tArg, args);
			}
		};
		helpers.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern) ?
				colorValue :
				helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};


/***/ }),
/* 402 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		// Global Chart canvas helpers object for drawing items to canvas
		var helpers = Chart.canvasHelpers = {};
	
		helpers.drawPoint = function(ctx, pointStyle, radius, x, y) {
			var type, edgeLength, xOffset, yOffset, height, size;
	
			if (typeof pointStyle === 'object') {
				type = pointStyle.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(pointStyle, x - pointStyle.width / 2, y - pointStyle.height / 2);
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			switch (pointStyle) {
			// Default includes circle
			default:
				ctx.beginPath();
				ctx.arc(x, y, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'triangle':
				ctx.beginPath();
				edgeLength = 3 * radius / Math.sqrt(3);
				height = edgeLength * Math.sqrt(3) / 2;
				ctx.moveTo(x - edgeLength / 2, y + height / 3);
				ctx.lineTo(x + edgeLength / 2, y + height / 3);
				ctx.lineTo(x, y - 2 * height / 3);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rect':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
				ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
				break;
			case 'rectRot':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.moveTo(x - size, y);
				ctx.lineTo(x, y + size);
				ctx.lineTo(x + size, y);
				ctx.lineTo(x, y - size);
				ctx.closePath();
				ctx.fill();
				break;
			case 'cross':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'crossRot':
				ctx.beginPath();
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'star':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'line':
				ctx.beginPath();
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'dash':
				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			}
	
			ctx.stroke();
		};
	};


/***/ }),
/* 403 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.elements = {};
	
		Chart.Element = function(configuration) {
			helpers.extend(this, configuration);
			this.initialize.apply(this, arguments);
		};
	
		helpers.extend(Chart.Element.prototype, {
	
			initialize: function() {
				this.hidden = false;
			},
	
			pivot: function() {
				var me = this;
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
				me._start = helpers.clone(me._view);
				return me;
			},
	
			transition: function(ease) {
				var me = this;
	
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
	
				// No animation -> No Transition
				if (ease === 1) {
					me._view = me._model;
					me._start = null;
					return me;
				}
	
				if (!me._start) {
					me.pivot();
				}
	
				helpers.each(me._model, function(value, key) {
	
					if (key[0] === '_') {
						// Only non-underscored properties
					// Init if doesn't exist
					} else if (!me._view.hasOwnProperty(key)) {
						if (typeof value === 'number' && !isNaN(me._view[key])) {
							me._view[key] = value * ease;
						} else {
							me._view[key] = value;
						}
					// No unnecessary computations
					} else if (value === me._view[key]) {
						// It's the same! Woohoo!
					// Color transitions if possible
					} else if (typeof value === 'string') {
						try {
							var color = helpers.color(me._model[key]).mix(helpers.color(me._start[key]), ease);
							me._view[key] = color.rgbString();
						} catch (err) {
							me._view[key] = value;
						}
					// Number transitions
					} else if (typeof value === 'number') {
						var startVal = me._start[key] !== undefined && isNaN(me._start[key]) === false ? me._start[key] : 0;
						me._view[key] = ((me._model[key] - startVal) * ease) + startVal;
					// Everything else
					} else {
						me._view[key] = value;
					}
				}, me);
	
				return me;
			},
	
			tooltipPosition: function() {
				return {
					x: this._model.x,
					y: this._model.y
				};
			},
	
			hasValue: function() {
				return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
			}
		});
	
		Chart.Element.extend = helpers.inherits;
	
	};


/***/ }),
/* 404 */
/***/ (function(module, exports) {

	/* global window: false */
	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.animation = {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers.noop,
			onComplete: helpers.noop
		};
	
		Chart.Animation = Chart.Element.extend({
			currentStep: null, // the current animation step
			numSteps: 60, // default number of steps
			easing: '', // the easing to use for this animation
			render: null, // render function used by the animation service
	
			onAnimationProgress: null, // user specified callback to fire on each step of the animation
			onAnimationComplete: null // user specified callback to fire when the animation finishes
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			request: null,
			addAnimation: function(chartInstance, animationObject, duration, lazy) {
				var me = this;
	
				if (!lazy) {
					chartInstance.animating = true;
				}
	
				for (var index = 0; index < me.animations.length; ++index) {
					if (me.animations[index].chartInstance === chartInstance) {
						// replacing an in progress animation
						me.animations[index].animationObject = animationObject;
						return;
					}
				}
	
				me.animations.push({
					chartInstance: chartInstance,
					animationObject: animationObject
				});
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (me.animations.length === 1) {
					me.requestAnimationFrame();
				}
			},
			// Cancel the animation for a given chart instance
			cancelAnimation: function(chartInstance) {
				var index = helpers.findIndex(this.animations, function(animationWrapper) {
					return animationWrapper.chartInstance === chartInstance;
				});
	
				if (index !== -1) {
					this.animations.splice(index, 1);
					chartInstance.animating = false;
				}
			},
			requestAnimationFrame: function() {
				var me = this;
				if (me.request === null) {
					// Skip animation frame requests until the active one is executed.
					// This can happen when processing mouse events, e.g. 'mousemove'
					// and 'mouseout' events will trigger multiple renders.
					me.request = helpers.requestAnimFrame.call(window, function() {
						me.request = null;
						me.startDigest();
					});
				}
			},
			startDigest: function() {
				var me = this;
	
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if (me.dropFrames > 1) {
					framesToDrop = Math.floor(me.dropFrames);
					me.dropFrames = me.dropFrames % 1;
				}
	
				var i = 0;
				while (i < me.animations.length) {
					if (me.animations[i].animationObject.currentStep === null) {
						me.animations[i].animationObject.currentStep = 0;
					}
	
					me.animations[i].animationObject.currentStep += 1 + framesToDrop;
	
					if (me.animations[i].animationObject.currentStep > me.animations[i].animationObject.numSteps) {
						me.animations[i].animationObject.currentStep = me.animations[i].animationObject.numSteps;
					}
	
					me.animations[i].animationObject.render(me.animations[i].chartInstance, me.animations[i].animationObject);
					if (me.animations[i].animationObject.onAnimationProgress && me.animations[i].animationObject.onAnimationProgress.call) {
						me.animations[i].animationObject.onAnimationProgress.call(me.animations[i].chartInstance, me.animations[i]);
					}
	
					if (me.animations[i].animationObject.currentStep === me.animations[i].animationObject.numSteps) {
						if (me.animations[i].animationObject.onAnimationComplete && me.animations[i].animationObject.onAnimationComplete.call) {
							me.animations[i].animationObject.onAnimationComplete.call(me.animations[i].chartInstance, me.animations[i]);
						}
	
						// executed the last frame. Remove the animation.
						me.animations[i].chartInstance.animating = false;
	
						me.animations.splice(i, 1);
					} else {
						++i;
					}
				}
	
				var endTime = Date.now();
				var dropFrames = (endTime - startTime) / me.frameDuration;
	
				me.dropFrames += dropFrames;
	
				// Do we have more stuff to animate?
				if (me.animations.length > 0) {
					me.requestAnimationFrame();
				}
			}
		};
	};


/***/ }),
/* 405 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		// Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		// Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};
	
		/**
		 * @class Chart.Controller
		 * The main controller of a chart.
		 */
		Chart.Controller = function(instance) {
	
			this.chart = instance;
			this.config = instance.config;
			this.options = this.config.options = helpers.configMerge(Chart.defaults.global, Chart.defaults[this.config.type], this.config.options || {});
			this.id = helpers.uid();
	
			Object.defineProperty(this, 'data', {
				get: function() {
					return this.config.data;
				}
			});
	
			// Add the chart instance to the global namespace
			Chart.instances[this.id] = this;
	
			if (this.options.responsive) {
				// Silent resize before chart draws
				this.resize(true);
			}
	
			this.initialize();
	
			return this;
		};
	
		helpers.extend(Chart.Controller.prototype, /** @lends Chart.Controller */ {
	
			initialize: function() {
				var me = this;
				// Before init plugin notification
				Chart.plugins.notify('beforeInit', [me]);
	
				me.bindEvents();
	
				// Make sure controllers are built first so that each dataset is bound to an axis before the scales
				// are built
				me.ensureScalesHaveIDs();
				me.buildOrUpdateControllers();
				me.buildScales();
				me.updateLayout();
				me.resetElements();
				me.initToolTip();
				me.update();
	
				// After init plugin notification
				Chart.plugins.notify('afterInit', [me]);
	
				return me;
			},
	
			clear: function() {
				helpers.clear(this.chart);
				return this;
			},
	
			stop: function() {
				// Stops any current animation loop occuring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
	
			resize: function(silent) {
				var me = this;
				var chart = me.chart;
				var canvas = chart.canvas;
				var newWidth = helpers.getMaximumWidth(canvas);
				var aspectRatio = chart.aspectRatio;
				var newHeight = (me.options.maintainAspectRatio && isNaN(aspectRatio) === false && isFinite(aspectRatio) && aspectRatio !== 0) ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas);
	
				var sizeChanged = chart.width !== newWidth || chart.height !== newHeight;
	
				if (!sizeChanged) {
					return me;
				}
	
				canvas.width = chart.width = newWidth;
				canvas.height = chart.height = newHeight;
	
				helpers.retinaScale(chart);
	
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				Chart.plugins.notify('resize', [me, newSize]);
	
				// Notify of resize
				if (me.options.onResize) {
					me.options.onResize(me, newSize);
				}
	
				if (!silent) {
					me.stop();
					me.update(me.options.responsiveAnimationDuration);
				}
	
				return me;
			},
	
			ensureScalesHaveIDs: function() {
				var options = this.options;
				var scalesOptions = options.scales || {};
				var scaleOptions = options.scale;
	
				helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
					xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
				});
	
				helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
					yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
				});
	
				if (scaleOptions) {
					scaleOptions.id = scaleOptions.id || 'scale';
				}
			},
	
			/**
			 * Builds a map of scale ID to scale object for future lookup.
			 */
			buildScales: function() {
				var me = this;
				var options = me.options;
				var scales = me.scales = {};
				var items = [];
	
				if (options.scales) {
					items = items.concat(
						(options.scales.xAxes || []).map(function(xAxisOptions) {
							return {options: xAxisOptions, dtype: 'category'};
						}),
						(options.scales.yAxes || []).map(function(yAxisOptions) {
							return {options: yAxisOptions, dtype: 'linear'};
						})
					);
				}
	
				if (options.scale) {
					items.push({options: options.scale, dtype: 'radialLinear', isDefault: true});
				}
	
				helpers.each(items, function(item) {
					var scaleOptions = item.options;
					var scaleType = helpers.getValueOrDefault(scaleOptions.type, item.dtype);
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
	
					var scale = new scaleClass({
						id: scaleOptions.id,
						options: scaleOptions,
						ctx: me.chart.ctx,
						chart: me
					});
	
					scales[scale.id] = scale;
	
					// TODO(SB): I think we should be able to remove this custom case (options.scale)
					// and consider it as a regular scale part of the "scales"" map only! This would
					// make the logic easier and remove some useless? custom code.
					if (item.isDefault) {
						me.scale = scale;
					}
				});
	
				Chart.scaleService.addScalesToLayout(this);
			},
	
			updateLayout: function() {
				Chart.layoutService.update(this, this.chart.width, this.chart.height);
			},
	
			buildOrUpdateControllers: function() {
				var me = this;
				var types = [];
				var newControllers = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					var meta = me.getDatasetMeta(datasetIndex);
					if (!meta.type) {
						meta.type = dataset.type || me.config.type;
					}
	
					types.push(meta.type);
	
					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
					} else {
						meta.controller = new Chart.controllers[meta.type](me, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, me);
	
				if (types.length > 1) {
					for (var i = 1; i < types.length; i++) {
						if (types[i] !== types[i - 1]) {
							me.isCombo = true;
							break;
						}
					}
				}
	
				return newControllers;
			},
	
			resetElements: function() {
				var me = this;
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.reset();
				}, me);
			},
	
			update: function(animationDuration, lazy) {
				var me = this;
				Chart.plugins.notify('beforeUpdate', [me]);
	
				// In case the entire data object changed
				me.tooltip._data = me.data;
	
				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = me.buildOrUpdateControllers();
	
				// Make sure all dataset controllers have correct meta data counts
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, me);
	
				Chart.layoutService.update(me, me.chart.width, me.chart.height);
	
				// Apply changes to the dataets that require the scales to have been calculated i.e BorderColor chages
				Chart.plugins.notify('afterScaleUpdate', [me]);
	
				// Can only reset the new controllers after the scales have been updated
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
	
				me.updateDatasets();
	
				// Do this before render so that any plugins that need final scale updates can use it
				Chart.plugins.notify('afterUpdate', [me]);
	
				me.render(animationDuration, lazy);
			},
	
			/**
			 * @method beforeDatasetsUpdate
			 * @description Called before all datasets are updated. If a plugin returns false,
			 * the datasets update will be cancelled until another chart update is triggered.
			 * @param {Object} instance the chart instance being updated.
			 * @returns {Boolean} false to cancel the datasets update.
			 * @memberof Chart.PluginBase
			 * @since version 2.1.5
			 * @instance
			 */
	
			/**
			 * @method afterDatasetsUpdate
			 * @description Called after all datasets have been updated. Note that this
			 * extension will not be called if the datasets update has been cancelled.
			 * @param {Object} instance the chart instance being updated.
			 * @memberof Chart.PluginBase
			 * @since version 2.1.5
			 * @instance
			 */
	
			/**
			 * Updates all datasets unless a plugin returns false to the beforeDatasetsUpdate
			 * extension, in which case no datasets will be updated and the afterDatasetsUpdate
			 * notification will be skipped.
			 * @protected
			 * @instance
			 */
			updateDatasets: function() {
				var me = this;
				var i, ilen;
	
				if (Chart.plugins.notify('beforeDatasetsUpdate', [me])) {
					for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
						me.getDatasetMeta(i).controller.update();
					}
	
					Chart.plugins.notify('afterDatasetsUpdate', [me]);
				}
			},
	
			render: function(duration, lazy) {
				var me = this;
				Chart.plugins.notify('beforeRender', [me]);
	
				var animationOptions = me.options.animation;
				if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
					var animation = new Chart.Animation();
					animation.numSteps = (duration || animationOptions.duration) / 16.66; // 60 fps
					animation.easing = animationOptions.easing;
	
					// render function
					animation.render = function(chartInstance, animationObject) {
						var easingFunction = helpers.easingEffects[animationObject.easing];
						var stepDecimal = animationObject.currentStep / animationObject.numSteps;
						var easeDecimal = easingFunction(stepDecimal);
	
						chartInstance.draw(easeDecimal, stepDecimal, animationObject.currentStep);
					};
	
					// user events
					animation.onAnimationProgress = animationOptions.onProgress;
					animation.onAnimationComplete = animationOptions.onComplete;
	
					Chart.animationService.addAnimation(me, animation, duration, lazy);
				} else {
					me.draw();
					if (animationOptions && animationOptions.onComplete && animationOptions.onComplete.call) {
						animationOptions.onComplete.call(me);
					}
				}
				return me;
			},
	
			draw: function(ease) {
				var me = this;
				var easingDecimal = ease || 1;
				me.clear();
	
				Chart.plugins.notify('beforeDraw', [me, easingDecimal]);
	
				// Draw all the scales
				helpers.each(me.boxes, function(box) {
					box.draw(me.chartArea);
				}, me);
				if (me.scale) {
					me.scale.draw();
				}
	
				Chart.plugins.notify('beforeDatasetsDraw', [me, easingDecimal]);
	
				// Draw each dataset via its respective controller (reversed to support proper line stacking)
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						me.getDatasetMeta(datasetIndex).controller.draw(ease);
					}
				}, me, true);
	
				Chart.plugins.notify('afterDatasetsDraw', [me, easingDecimal]);
	
				// Finally draw the tooltip
				me.tooltip.transition(easingDecimal).draw();
	
				Chart.plugins.notify('afterDraw', [me, easingDecimal]);
			},
	
			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				var me = this;
				var eventPosition = helpers.getRelativePosition(e, me.chart);
				var elementsArray = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						var meta = me.getDatasetMeta(datasetIndex);
						helpers.each(meta.data, function(element) {
							if (element.inRange(eventPosition.x, eventPosition.y)) {
								elementsArray.push(element);
								return elementsArray;
							}
						});
					}
				});
	
				return elementsArray.slice(0, 1);
			},
	
			getElementsAtEvent: function(e) {
				var me = this;
				var eventPosition = helpers.getRelativePosition(e, me.chart);
				var elementsArray = [];
	
				var found = function() {
					if (me.data.datasets) {
						for (var i = 0; i < me.data.datasets.length; i++) {
							var meta = me.getDatasetMeta(i);
							if (me.isDatasetVisible(i)) {
								for (var j = 0; j < meta.data.length; j++) {
									if (meta.data[j].inRange(eventPosition.x, eventPosition.y)) {
										return meta.data[j];
									}
								}
							}
						}
					}
				}.call(me);
	
				if (!found) {
					return elementsArray;
				}
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						var meta = me.getDatasetMeta(datasetIndex),
							element = meta.data[found._index];
						if (element && !element._view.skip) {
							elementsArray.push(element);
						}
					}
				}, me);
	
				return elementsArray;
			},
	
			getElementsAtXAxis: function(e) {
				var me = this;
				var eventPosition = helpers.getRelativePosition(e, me.chart);
				var elementsArray = [];
	
				var found = function() {
					if (me.data.datasets) {
						for (var i = 0; i < me.data.datasets.length; i++) {
							var meta = me.getDatasetMeta(i);
							if (me.isDatasetVisible(i)) {
								for (var j = 0; j < meta.data.length; j++) {
									if (meta.data[j].inLabelRange(eventPosition.x, eventPosition.y)) {
										return meta.data[j];
									}
								}
							}
						}
					}
				}.call(me);
	
				if (!found) {
					return elementsArray;
				}
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						var meta = me.getDatasetMeta(datasetIndex);
						var index = helpers.findIndex(meta.data, function(it) {
							return found._model.x === it._model.x;
						});
						if (index !== -1 && !meta.data[index]._view.skip) {
							elementsArray.push(meta.data[index]);
						}
					}
				}, me);
	
				return elementsArray;
			},
	
			getElementsAtEventForMode: function(e, mode) {
				var me = this;
				switch (mode) {
				case 'single':
					return me.getElementAtEvent(e);
				case 'label':
					return me.getElementsAtEvent(e);
				case 'dataset':
					return me.getDatasetAtEvent(e);
				case 'x-axis':
					return me.getElementsAtXAxis(e);
				default:
					return e;
				}
			},
	
			getDatasetAtEvent: function(e) {
				var elementsArray = this.getElementAtEvent(e);
	
				if (elementsArray.length > 0) {
					elementsArray = this.getDatasetMeta(elementsArray[0]._datasetIndex).data;
				}
	
				return elementsArray;
			},
	
			getDatasetMeta: function(datasetIndex) {
				var me = this;
				var dataset = me.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}
	
				var meta = dataset._meta[me.id];
				if (!meta) {
					meta = dataset._meta[me.id] = {
						type: null,
						data: [],
						dataset: null,
						controller: null,
						hidden: null,			// See isDatasetVisible() comment
						xAxisID: null,
						yAxisID: null
					};
				}
	
				return meta;
			},
	
			getVisibleDatasetCount: function() {
				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i<ilen; ++i) {
					if (this.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},
	
			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);
	
				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean'? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},
	
			generateLegend: function() {
				return this.options.legendCallback(this);
			},
	
			destroy: function() {
				var me = this;
				me.stop();
				me.clear();
				helpers.unbindEvents(me, me.events);
				helpers.removeResizeListener(me.chart.canvas.parentNode);
	
				// Reset canvas height/width attributes
				var canvas = me.chart.canvas;
				canvas.width = me.chart.width;
				canvas.height = me.chart.height;
	
				// if we scaled the canvas in response to a devicePixelRatio !== 1, we need to undo that transform here
				if (me.chart.originalDevicePixelRatio !== undefined) {
					me.chart.ctx.scale(1 / me.chart.originalDevicePixelRatio, 1 / me.chart.originalDevicePixelRatio);
				}
	
				// Reset to the old style since it may have been changed by the device pixel ratio changes
				canvas.style.width = me.chart.originalCanvasStyleWidth;
				canvas.style.height = me.chart.originalCanvasStyleHeight;
	
				Chart.plugins.notify('destroy', [me]);
	
				delete Chart.instances[me.id];
			},
	
			toBase64Image: function() {
				return this.chart.canvas.toDataURL.apply(this.chart.canvas, arguments);
			},
	
			initToolTip: function() {
				var me = this;
				me.tooltip = new Chart.Tooltip({
					_chart: me.chart,
					_chartInstance: me,
					_data: me.data,
					_options: me.options.tooltips
				}, me);
			},
	
			bindEvents: function() {
				var me = this;
				helpers.bindEvents(me, me.options.events, function(evt) {
					me.eventHandler(evt);
				});
			},
	
			updateHoverStyle: function(elements, mode, enabled) {
				var method = enabled? 'setHoverStyle' : 'removeHoverStyle';
				var element, i, ilen;
	
				switch (mode) {
				case 'single':
					elements = [elements[0]];
					break;
				case 'label':
				case 'dataset':
				case 'x-axis':
					// elements = elements;
					break;
				default:
					// unsupported mode
					return;
				}
	
				for (i=0, ilen=elements.length; i<ilen; ++i) {
					element = elements[i];
					if (element) {
						this.getDatasetMeta(element._datasetIndex).controller[method](element);
					}
				}
			},
	
			eventHandler: function(e) {
				var me = this;
				var tooltip = me.tooltip;
				var options = me.options || {};
				var hoverOptions = options.hover;
				var tooltipsOptions = options.tooltips;
	
				me.lastActive = me.lastActive || [];
				me.lastTooltipActive = me.lastTooltipActive || [];
	
				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					me.active = [];
					me.tooltipActive = [];
				} else {
					me.active = me.getElementsAtEventForMode(e, hoverOptions.mode);
					me.tooltipActive = me.getElementsAtEventForMode(e, tooltipsOptions.mode);
				}
	
				// On Hover hook
				if (hoverOptions.onHover) {
					hoverOptions.onHover.call(me, me.active);
				}
	
				if (me.legend && me.legend.handleEvent) {
					me.legend.handleEvent(e);
				}
	
				if (e.type === 'mouseup' || e.type === 'click') {
					if (options.onClick) {
						options.onClick.call(me, e, me.active);
					}
				}
	
				// Remove styling for last active (even if it may still be active)
				if (me.lastActive.length) {
					me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
				}
	
				// Built in hover styling
				if (me.active.length && hoverOptions.mode) {
					me.updateHoverStyle(me.active, hoverOptions.mode, true);
				}
	
				// Built in Tooltips
				if (tooltipsOptions.enabled || tooltipsOptions.custom) {
					tooltip.initialize();
					tooltip._active = me.tooltipActive;
					tooltip.update(true);
				}
	
				// Hover animations
				tooltip.pivot();
	
				if (!me.animating) {
					// If entering, leaving, or changing elements, animate the change via pivot
					if (!helpers.arrayEquals(me.active, me.lastActive) ||
						!helpers.arrayEquals(me.tooltipActive, me.lastTooltipActive)) {
	
						me.stop();
	
						if (tooltipsOptions.enabled || tooltipsOptions.custom) {
							tooltip.update(true);
						}
	
						// We only need to render at this point. Updating will cause scales to be
						// recomputed generating flicker & using more memory than necessary.
						me.render(hoverOptions.animationDuration, true);
					}
				}
	
				// Remember Last Actives
				me.lastActive = me.active;
				me.lastTooltipActive = me.tooltipActive;
				return me;
			}
		});
	};


/***/ }),
/* 406 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var noop = helpers.noop;
	
		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize(chart, datasetIndex);
		};
	
		helpers.extend(Chart.DatasetController.prototype, {
	
			/**
			 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
			 * @type {Chart.core.element}
			 */
			datasetElementType: null,
	
			/**
			 * Element type used to generate a meta data (e.g. Chart.element.Point).
			 * @type {Chart.core.element}
			 */
			dataElementType: null,
	
			initialize: function(chart, datasetIndex) {
				var me = this;
				me.chart = chart;
				me.index = datasetIndex;
				me.linkScales();
				me.addElements();
			},
	
			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},
	
			linkScales: function() {
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				if (meta.xAxisID === null) {
					meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null) {
					meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
				}
			},
	
			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},
	
			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},
	
			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},
	
			reset: function() {
				this.update(true);
			},
	
			createMetaDataset: function() {
				var me = this;
				var type = me.datasetElementType;
				return type && new type({
					_chart: me.chart.chart,
					_datasetIndex: me.index
				});
			},
	
			createMetaData: function(index) {
				var me = this;
				var type = me.dataElementType;
				return type && new type({
					_chart: me.chart.chart,
					_datasetIndex: me.index,
					_index: index
				});
			},
	
			addElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data || [];
				var metaData = meta.data;
				var i, ilen;
	
				for (i=0, ilen=data.length; i<ilen; ++i) {
					metaData[i] = metaData[i] || me.createMetaData(meta, i);
				}
	
				meta.dataset = meta.dataset || me.createMetaDataset();
			},
	
			addElementAndReset: function(index) {
				var me = this;
				var element = me.createMetaData(index);
				me.getMeta().data.splice(index, 0, element);
				me.updateElement(element, index, true);
			},
	
			buildOrUpdateElements: function() {
				// Handle the number of data points changing
				var meta = this.getMeta(),
					md = meta.data,
					numData = this.getDataset().data.length,
					numMetaData = md.length;
	
				// Make sure that we handle number of datapoints changing
				if (numData < numMetaData) {
					// Remove excess bars for data points that have been removed
					md.splice(numData, numMetaData - numData);
				} else if (numData > numMetaData) {
					// Add new elements
					for (var index = numMetaData; index < numData; ++index) {
						this.addElementAndReset(index);
					}
				}
			},
	
			update: noop,
	
			draw: function(ease) {
				var easingDecimal = ease || 1;
				helpers.each(this.getMeta().data, function(element) {
					element.transition(easingDecimal).draw();
				});
			},
	
			removeHoverStyle: function(element, elementOpts) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					model = element._model;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
			},
	
			setHoverStyle: function(element) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					getHoverColor = helpers.getHoverColor,
					model = element._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			}
	
		});
	
		Chart.DatasetController.extend = helpers.inherits;
	};


/***/ }),
/* 407 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		// The layout service is very self explanatory.  It's responsible for the layout within a chart.
		// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
		// It is this service's responsibility of carrying out that layout.
		Chart.layoutService = {
			defaults: {},
	
			// Register a box to a chartInstance. A box is simply a reference to an object that requires layout. eg. Scales, Legend, Plugins.
			addBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					chartInstance.boxes = [];
				}
				chartInstance.boxes.push(box);
			},
	
			removeBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					return;
				}
				chartInstance.boxes.splice(chartInstance.boxes.indexOf(box), 1);
			},
	
			// The most important function
			update: function(chartInstance, width, height) {
	
				if (!chartInstance) {
					return;
				}
	
				var xPadding = 0;
				var yPadding = 0;
	
				var leftBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'left';
				});
				var rightBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'right';
				});
				var topBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'top';
				});
				var bottomBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'bottom';
				});
	
				// Boxes that overlay the chartarea such as the radialLinear scale
				var chartAreaBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'chartArea';
				});
	
				// Ensure that full width boxes are at the very top / bottom
				topBoxes.sort(function(a, b) {
					return (b.options.fullWidth ? 1 : 0) - (a.options.fullWidth ? 1 : 0);
				});
				bottomBoxes.sort(function(a, b) {
					return (a.options.fullWidth ? 1 : 0) - (b.options.fullWidth ? 1 : 0);
				});
	
				// Essentially we now have any number of boxes on each of the 4 sides.
				// Our canvas looks like the following.
				// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
				// B1 is the bottom axis
				// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
				// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
				// an error will be thrown.
				//
				// |----------------------------------------------------|
				// |                  T1 (Full Width)                   |
				// |----------------------------------------------------|
				// |    |    |                 T2                  |    |
				// |    |----|-------------------------------------|----|
				// |    |    | C1 |                           | C2 |    |
				// |    |    |----|                           |----|    |
				// |    |    |                                     |    |
				// | L1 | L2 |           ChartArea (C0)            | R1 |
				// |    |    |                                     |    |
				// |    |    |----|                           |----|    |
				// |    |    | C3 |                           | C4 |    |
				// |    |----|-------------------------------------|----|
				// |    |    |                 B1                  |    |
				// |----------------------------------------------------|
				// |                  B2 (Full Width)                   |
				// |----------------------------------------------------|
				//
				// What we do to find the best sizing, we do the following
				// 1. Determine the minimum size of the chart area.
				// 2. Split the remaining width equally between each vertical axis
				// 3. Split the remaining height equally between each horizontal axis
				// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
				// 5. Adjust the sizes of each axis based on it's minimum reported size.
				// 6. Refit each axis
				// 7. Position each axis in the final location
				// 8. Tell the chart the final location of the chart area
				// 9. Tell any axes that overlay the chart area the positions of the chart area
	
				// Step 1
				var chartWidth = width - (2 * xPadding);
				var chartHeight = height - (2 * yPadding);
				var chartAreaWidth = chartWidth / 2; // min 50%
				var chartAreaHeight = chartHeight / 2; // min 50%
	
				// Step 2
				var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);
	
				// Step 3
				var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);
	
				// Step 4
				var maxChartAreaWidth = chartWidth;
				var maxChartAreaHeight = chartHeight;
				var minBoxSizes = [];
	
				function getMinimumBoxSize(box) {
					var minSize;
					var isHorizontal = box.isHorizontal();
	
					if (isHorizontal) {
						minSize = box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
						maxChartAreaHeight -= minSize.height;
					} else {
						minSize = box.update(verticalBoxWidth, chartAreaHeight);
						maxChartAreaWidth -= minSize.width;
					}
	
					minBoxSizes.push({
						horizontal: isHorizontal,
						minSize: minSize,
						box: box
					});
				}
	
				helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);
	
				// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
				// be if the axes are drawn at their minimum sizes.
	
				// Steps 5 & 6
				var totalLeftBoxesWidth = xPadding;
				var totalRightBoxesWidth = xPadding;
				var totalTopBoxesHeight = yPadding;
				var totalBottomBoxesHeight = yPadding;
	
				// Function to fit a box
				function fitBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
						return minBox.box === box;
					});
	
					if (minBoxSize) {
						if (box.isHorizontal()) {
							var scaleMargin = {
								left: totalLeftBoxesWidth,
								right: totalRightBoxesWidth,
								top: 0,
								bottom: 0
							};
	
							// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
							// on the margin. Sometimes they need to increase in size slightly
							box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
						} else {
							box.update(minBoxSize.minSize.width, maxChartAreaHeight);
						}
					}
				}
	
				// Update, and calculate the left and right margins for the horizontal boxes
				helpers.each(leftBoxes.concat(rightBoxes), fitBox);
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				// Set the Left and Right margins for the horizontal boxes
				helpers.each(topBoxes.concat(bottomBoxes), fitBox);
	
				// Figure out how much margin is on the top and bottom of the vertical boxes
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
	
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				function finalFitVerticalBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
						return minSize.box === box;
					});
	
					var scaleMargin = {
						left: 0,
						right: 0,
						top: totalTopBoxesHeight,
						bottom: totalBottomBoxesHeight
					};
	
					if (minBoxSize) {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
					}
				}
	
				// Let the left layout know the final margin
				helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);
	
				// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
				totalLeftBoxesWidth = xPadding;
				totalRightBoxesWidth = xPadding;
				totalTopBoxesHeight = yPadding;
				totalBottomBoxesHeight = yPadding;
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				// Figure out if our chart area changed. This would occur if the dataset layout label rotation
				// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
				// without calling `fit` again
				var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
				var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;
	
				if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
					helpers.each(leftBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(rightBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(topBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					helpers.each(bottomBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					maxChartAreaHeight = newMaxChartAreaHeight;
					maxChartAreaWidth = newMaxChartAreaWidth;
				}
	
				// Step 7 - Position the boxes
				var left = xPadding;
				var top = yPadding;
	
				function placeBox(box) {
					if (box.isHorizontal()) {
						box.left = box.options.fullWidth ? xPadding : totalLeftBoxesWidth;
						box.right = box.options.fullWidth ? width - xPadding : totalLeftBoxesWidth + maxChartAreaWidth;
						box.top = top;
						box.bottom = top + box.height;
	
						// Move to next point
						top = box.bottom;
	
					} else {
	
						box.left = left;
						box.right = left + box.width;
						box.top = totalTopBoxesHeight;
						box.bottom = totalTopBoxesHeight + maxChartAreaHeight;
	
						// Move to next point
						left = box.right;
					}
				}
	
				helpers.each(leftBoxes.concat(topBoxes), placeBox);
	
				// Account for chart width and height
				left += maxChartAreaWidth;
				top += maxChartAreaHeight;
	
				helpers.each(rightBoxes, placeBox);
				helpers.each(bottomBoxes, placeBox);
	
				// Step 8
				chartInstance.chartArea = {
					left: totalLeftBoxesWidth,
					top: totalTopBoxesHeight,
					right: totalLeftBoxesWidth + maxChartAreaWidth,
					bottom: totalTopBoxesHeight + maxChartAreaHeight
				};
	
				// Step 9
				helpers.each(chartAreaBoxes, function(box) {
					box.left = chartInstance.chartArea.left;
					box.top = chartInstance.chartArea.top;
					box.right = chartInstance.chartArea.right;
					box.bottom = chartInstance.chartArea.bottom;
	
					box.update(maxChartAreaWidth, maxChartAreaHeight);
				});
			}
		};
	};


/***/ }),
/* 408 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.scaleService = {
			// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
			// use the new chart options to grab the correct scale
			constructors: {},
			// Use a registration function so that we can move to an ES6 map when we no longer need to support
			// old browsers
	
			// Scale config defaults
			defaults: {},
			registerScaleType: function(type, scaleConstructor, defaults) {
				this.constructors[type] = scaleConstructor;
				this.defaults[type] = helpers.clone(defaults);
			},
			getScaleConstructor: function(type) {
				return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
			},
			getScaleDefaults: function(type) {
				// Return the scale defaults merged with the global settings so that we always use the latest ones
				return this.defaults.hasOwnProperty(type) ? helpers.scaleMerge(Chart.defaults.scale, this.defaults[type]) : {};
			},
			updateScaleDefaults: function(type, additions) {
				var defaults = this.defaults;
				if (defaults.hasOwnProperty(type)) {
					defaults[type] = helpers.extend(defaults[type], additions);
				}
			},
			addScalesToLayout: function(chartInstance) {
				// Adds each scale to the chart.boxes array to be sized accordingly
				helpers.each(chartInstance.scales, function(scale) {
					Chart.layoutService.addBox(chartInstance, scale);
				});
			}
		};
	};


/***/ }),
/* 409 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var noop = Chart.helpers.noop;
	
		/**
		 * The plugin service singleton
		 * @namespace Chart.plugins
		 * @since 2.1.0
		 */
		Chart.plugins = {
			_plugins: [],
	
			/**
			 * Registers the given plugin(s) if not already registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			register: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					if (p.indexOf(plugin) === -1) {
						p.push(plugin);
					}
				});
			},
	
			/**
			 * Unregisters the given plugin(s) only if registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			unregister: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					var idx = p.indexOf(plugin);
					if (idx !== -1) {
						p.splice(idx, 1);
					}
				});
			},
	
			/**
			 * Remove all registered p^lugins.
			 * @since 2.1.5
			 */
			clear: function() {
				this._plugins = [];
			},
	
			/**
			 * Returns the number of registered plugins?
			 * @returns {Number}
			 * @since 2.1.5
			 */
			count: function() {
				return this._plugins.length;
			},
	
			/**
			 * Returns all registered plugin intances.
			 * @returns {Array} array of plugin objects.
			 * @since 2.1.5
			 */
			getAll: function() {
				return this._plugins;
			},
	
			/**
			 * Calls registered plugins on the specified extension, with the given args. This
			 * method immediately returns as soon as a plugin explicitly returns false. The
			 * returned value can be used, for instance, to interrupt the current action.
			 * @param {String} extension the name of the plugin method to call (e.g. 'beforeUpdate').
			 * @param {Array} [args] extra arguments to apply to the extension call.
			 * @returns {Boolean} false if any of the plugins return false, else returns true.
			 */
			notify: function(extension, args) {
				var plugins = this._plugins;
				var ilen = plugins.length;
				var i, plugin;
	
				for (i=0; i<ilen; ++i) {
					plugin = plugins[i];
					if (typeof plugin[extension] === 'function') {
						if (plugin[extension].apply(plugin, args || []) === false) {
							return false;
						}
					}
				}
	
				return true;
			}
		};
	
		/**
		 * Plugin extension methods.
		 * @interface Chart.PluginBase
		 * @since 2.1.0
		 */
		Chart.PluginBase = Chart.Element.extend({
			// Called at start of chart init
			beforeInit: noop,
	
			// Called at end of chart init
			afterInit: noop,
	
			// Called at start of update
			beforeUpdate: noop,
	
			// Called at end of update
			afterUpdate: noop,
	
			// Called at start of draw
			beforeDraw: noop,
	
			// Called at end of draw
			afterDraw: noop,
	
			// Called during destroy
			destroy: noop
		});
	
		/**
		 * Provided for backward compatibility, use Chart.plugins instead
		 * @namespace Chart.pluginService
		 * @deprecated since version 2.1.5
		 * @todo remove me at version 3
		 */
		Chart.pluginService = Chart.plugins;
	};


/***/ }),
/* 410 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.scale = {
			display: true,
			position: 'left',
	
			// grid line settings
			gridLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1,
				drawBorder: true,
				drawOnChartArea: true,
				drawTicks: true,
				tickMarkLength: 10,
				zeroLineWidth: 1,
				zeroLineColor: 'rgba(0,0,0,0.25)',
				offsetGridLines: false,
				borderDash: [],
				borderDashOffset: 0.0
			},
	
			// scale label
			scaleLabel: {
				// actual label
				labelString: '',
	
				// display property
				display: false
			},
	
			// label settings
			ticks: {
				beginAtZero: false,
				minRotation: 0,
				maxRotation: 50,
				mirror: false,
				padding: 10,
				reverse: false,
				display: true,
				autoSkip: true,
				autoSkipPadding: 0,
				labelOffset: 0,
				// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
				callback: function(value) {
					return helpers.isArray(value) ? value : '' + value;
				}
			}
		};
	
		Chart.Scale = Chart.Element.extend({
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all scale types.
			// Any function can be extended by the scale type
	
			beforeUpdate: function() {
				helpers.callCallback(this.options.beforeUpdate, [this]);
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = helpers.extend({
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}, margins);
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
	
				// Data min/max
				me.beforeDataLimits();
				me.determineDataLimits();
				me.afterDataLimits();
	
				// Ticks
				me.beforeBuildTicks();
				me.buildTicks();
				me.afterBuildTicks();
	
				me.beforeTickToLabelConversion();
				me.convertTicksToLabels();
				me.afterTickToLabelConversion();
	
				// Tick Rotation
				me.beforeCalculateTickRotation();
				me.calculateTickRotation();
				me.afterCalculateTickRotation();
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: function() {
				helpers.callCallback(this.options.afterUpdate, [this]);
			},
	
			//
	
			beforeSetDimensions: function() {
				helpers.callCallback(this.options.beforeSetDimensions, [this]);
			},
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
			},
			afterSetDimensions: function() {
				helpers.callCallback(this.options.afterSetDimensions, [this]);
			},
	
			// Data limits
			beforeDataLimits: function() {
				helpers.callCallback(this.options.beforeDataLimits, [this]);
			},
			determineDataLimits: helpers.noop,
			afterDataLimits: function() {
				helpers.callCallback(this.options.afterDataLimits, [this]);
			},
	
			//
			beforeBuildTicks: function() {
				helpers.callCallback(this.options.beforeBuildTicks, [this]);
			},
			buildTicks: helpers.noop,
			afterBuildTicks: function() {
				helpers.callCallback(this.options.afterBuildTicks, [this]);
			},
	
			beforeTickToLabelConversion: function() {
				helpers.callCallback(this.options.beforeTickToLabelConversion, [this]);
			},
			convertTicksToLabels: function() {
				var me = this;
				// Convert ticks to strings
				me.ticks = me.ticks.map(function(numericalTick, index, ticks) {
					if (me.options.ticks.userCallback) {
						return me.options.ticks.userCallback(numericalTick, index, ticks);
					}
					return me.options.ticks.callback(numericalTick, index, ticks);
				},
				me);
			},
			afterTickToLabelConversion: function() {
				helpers.callCallback(this.options.afterTickToLabelConversion, [this]);
			},
	
			//
	
			beforeCalculateTickRotation: function() {
				helpers.callCallback(this.options.beforeCalculateTickRotation, [this]);
			},
			calculateTickRotation: function() {
				var me = this;
				var context = me.ctx;
				var globalDefaults = Chart.defaults.global;
				var optionTicks = me.options.ticks;
	
				// Get the width of each grid by calculating the difference
				// between x offsets between 0 and 1.
				var tickFontSize = helpers.getValueOrDefault(optionTicks.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(optionTicks.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(optionTicks.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				context.font = tickLabelFont;
	
				var firstWidth = context.measureText(me.ticks[0]).width;
				var lastWidth = context.measureText(me.ticks[me.ticks.length - 1]).width;
				var firstRotated;
	
				me.labelRotation = optionTicks.minRotation || 0;
				me.paddingRight = 0;
				me.paddingLeft = 0;
	
				if (me.options.display) {
					if (me.isHorizontal()) {
						me.paddingRight = lastWidth / 2 + 3;
						me.paddingLeft = firstWidth / 2 + 3;
	
						if (!me.longestTextCache) {
							me.longestTextCache = {};
						}
						var originalLabelWidth = helpers.longestText(context, tickLabelFont, me.ticks, me.longestTextCache);
						var labelWidth = originalLabelWidth;
						var cosRotation;
						var sinRotation;
	
						// Allow 3 pixels x2 padding either side for label readability
						// only the index matters for a dataset scale, but we want a consistent interface between scales
						var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;
	
						// Max label rotation can be set or default to 90 - also act as a loop counter
						while (labelWidth > tickWidth && me.labelRotation < optionTicks.maxRotation) {
							cosRotation = Math.cos(helpers.toRadians(me.labelRotation));
							sinRotation = Math.sin(helpers.toRadians(me.labelRotation));
	
							firstRotated = cosRotation * firstWidth;
	
							// We're right aligning the text now.
							if (firstRotated + tickFontSize / 2 > me.yLabelWidth) {
								me.paddingLeft = firstRotated + tickFontSize / 2;
							}
	
							me.paddingRight = tickFontSize / 2;
	
							if (sinRotation * originalLabelWidth > me.maxHeight) {
								// go back one step
								me.labelRotation--;
								break;
							}
	
							me.labelRotation++;
							labelWidth = cosRotation * originalLabelWidth;
						}
					}
				}
	
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				}
			},
			afterCalculateTickRotation: function() {
				helpers.callCallback(this.options.afterCalculateTickRotation, [this]);
			},
	
			//
	
			beforeFit: function() {
				helpers.callCallback(this.options.beforeFit, [this]);
			},
			fit: function() {
				var me = this;
				// Reset
				var minSize = me.minSize = {
					width: 0,
					height: 0
				};
	
				var opts = me.options;
				var globalDefaults = Chart.defaults.global;
				var tickOpts = opts.ticks;
				var scaleLabelOpts = opts.scaleLabel;
				var gridLineOpts = opts.gridLines;
				var display = opts.display;
				var isHorizontal = me.isHorizontal();
	
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
				var scaleLabelFontSize = helpers.getValueOrDefault(scaleLabelOpts.fontSize, globalDefaults.defaultFontSize);
	
				var tickMarkLength = opts.gridLines.tickMarkLength;
	
				// Width
				if (isHorizontal) {
					// subtract the margins to line up with the chartArea if we are a full width scale
					minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
				} else {
					minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				}
	
				// height
				if (isHorizontal) {
					minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				} else {
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Are we showing a title for the scale?
				if (scaleLabelOpts.display && display) {
					if (isHorizontal) {
						minSize.height += (scaleLabelFontSize * 1.5);
					} else {
						minSize.width += (scaleLabelFontSize * 1.5);
					}
				}
	
				if (tickOpts.display && display) {
					// Don't bother fitting the ticks if we are not showing them
					if (!me.longestTextCache) {
						me.longestTextCache = {};
					}
	
					var largestTextWidth = helpers.longestText(me.ctx, tickLabelFont, me.ticks, me.longestTextCache);
					var tallestLabelHeightInLines = helpers.numberOfLabelLines(me.ticks);
					var lineSpace = tickFontSize * 0.5;
	
					if (isHorizontal) {
						// A horizontal axis is more constrained by the height.
						me.longestLabelWidth = largestTextWidth;
	
						// TODO - improve this calculation
						var labelHeight = (Math.sin(helpers.toRadians(me.labelRotation)) * me.longestLabelWidth) + (tickFontSize * tallestLabelHeightInLines) + (lineSpace * tallestLabelHeightInLines);
	
						minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight);
						me.ctx.font = tickLabelFont;
	
						var firstLabelWidth = me.ctx.measureText(me.ticks[0]).width;
						var lastLabelWidth = me.ctx.measureText(me.ticks[me.ticks.length - 1]).width;
	
						// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned which means that the right padding is dominated
						// by the font height
						var cosRotation = Math.cos(helpers.toRadians(me.labelRotation));
						var sinRotation = Math.sin(helpers.toRadians(me.labelRotation));
						me.paddingLeft = me.labelRotation !== 0 ? (cosRotation * firstLabelWidth) + 3 : firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
						me.paddingRight = me.labelRotation !== 0 ? (sinRotation * (tickFontSize / 2)) + 3 : lastLabelWidth / 2 + 3; // when rotated
					} else {
						// A vertical axis is more constrained by the width. Labels are the dominant factor here, so get that length first
						var maxLabelWidth = me.maxWidth - minSize.width;
	
						// Account for padding
						var mirror = tickOpts.mirror;
						if (!mirror) {
							largestTextWidth += me.options.ticks.padding;
						} else {
							// If mirrored text is on the inside so don't expand
							largestTextWidth = 0;
						}
	
						if (largestTextWidth < maxLabelWidth) {
							// We don't need all the room
							minSize.width += largestTextWidth;
						} else {
							// Expand to max size
							minSize.width = me.maxWidth;
						}
	
						me.paddingTop = tickFontSize / 2;
						me.paddingBottom = tickFontSize / 2;
					}
				}
	
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
					me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: function() {
				helpers.callCallback(this.options.afterFit, [this]);
			},
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
			isFullWidth: function() {
				return (this.options.fullWidth);
			},
	
			// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
			getRightValue: function(rawValue) {
				// Null and undefined values first
				if (rawValue === null || typeof(rawValue) === 'undefined') {
					return NaN;
				}
				// isNaN(object) returns true, so make sure NaN is checking for a number
				if (typeof(rawValue) === 'number' && isNaN(rawValue)) {
					return NaN;
				}
				// If it is in fact an object, dive in one more level
				if (typeof(rawValue) === 'object') {
					if ((rawValue instanceof Date) || (rawValue.isValid)) {
						return rawValue;
					}
					return this.getRightValue(this.isHorizontal() ? rawValue.x : rawValue.y);
				}
	
				// Value is good, return it
				return rawValue;
			},
	
			// Used to get the value to display in the tooltip for the data at the given index
			// function getLabelForIndex(index, datasetIndex)
			getLabelForIndex: helpers.noop,
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: helpers.noop,
	
			// Used to get the data value from a given pixel. This is the inverse of getPixelForValue
			getValueForPixel: helpers.noop,
	
			// Used for tick location, should
			getPixelForTick: function(index, includeOffset) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var tickWidth = innerWidth / Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
					var pixel = (tickWidth * index) + me.paddingLeft;
	
					if (includeOffset) {
						pixel += tickWidth / 2;
					}
	
					var finalVal = me.left + Math.round(pixel);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				return me.top + (index * (innerHeight / (me.ticks.length - 1)));
			},
	
			// Utility for getting the pixel location of a percentage of scale
			getPixelForDecimal: function(decimal /* , includeOffset*/) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
					var finalVal = me.left + Math.round(valueOffset);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				return me.top + (decimal * me.height);
			},
	
			getBasePixel: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPixelForValue(
					me.beginAtZero? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0);
			},
	
			// Actualy draw the scale on the canvas
			// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
			draw: function(chartArea) {
				var me = this;
				var options = me.options;
				if (!options.display) {
					return;
				}
	
				var context = me.ctx;
				var globalDefaults = Chart.defaults.global;
				var optionTicks = options.ticks;
				var gridLines = options.gridLines;
				var scaleLabel = options.scaleLabel;
	
				var isRotated = me.labelRotation !== 0;
				var skipRatio;
				var useAutoskipper = optionTicks.autoSkip;
				var isHorizontal = me.isHorizontal();
	
				// figure out the maximum number of gridlines to show
				var maxTicks;
				if (optionTicks.maxTicksLimit) {
					maxTicks = optionTicks.maxTicksLimit;
				}
	
				var tickFontColor = helpers.getValueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
				var tickFontSize = helpers.getValueOrDefault(optionTicks.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(optionTicks.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(optionTicks.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				var tl = gridLines.tickMarkLength;
				var borderDash = helpers.getValueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
				var borderDashOffset = helpers.getValueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
	
				var scaleLabelFontColor = helpers.getValueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
				var scaleLabelFontSize = helpers.getValueOrDefault(scaleLabel.fontSize, globalDefaults.defaultFontSize);
				var scaleLabelFontStyle = helpers.getValueOrDefault(scaleLabel.fontStyle, globalDefaults.defaultFontStyle);
				var scaleLabelFontFamily = helpers.getValueOrDefault(scaleLabel.fontFamily, globalDefaults.defaultFontFamily);
				var scaleLabelFont = helpers.fontString(scaleLabelFontSize, scaleLabelFontStyle, scaleLabelFontFamily);
	
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
				var cosRotation = Math.cos(labelRotationRadians);
				var longestRotatedLabel = me.longestLabelWidth * cosRotation;
	
				// Make sure we draw text in the correct color and font
				context.fillStyle = tickFontColor;
	
				var itemsToDraw = [];
	
				if (isHorizontal) {
					skipRatio = false;
	
					// Only calculate the skip ratio with the half width of longestRotateLabel if we got an actual rotation
					// See #2584
					if (isRotated) {
						longestRotatedLabel /= 2;
					}
	
					if ((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length > (me.width - (me.paddingLeft + me.paddingRight))) {
						skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length) / (me.width - (me.paddingLeft + me.paddingRight)));
					}
	
					// if they defined a max number of optionTicks,
					// increase skipRatio until that number is met
					if (maxTicks && me.ticks.length > maxTicks) {
						while (!skipRatio || me.ticks.length / (skipRatio || 1) > maxTicks) {
							if (!skipRatio) {
								skipRatio = 1;
							}
							skipRatio += 1;
						}
					}
	
					if (!useAutoskipper) {
						skipRatio = false;
					}
				}
	
	
				var xTickStart = options.position === 'right' ? me.left : me.right - tl;
				var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
				var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
				var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;
	
				helpers.each(me.ticks, function(label, index) {
					// If the callback returned a null or undefined value, do not draw this line
					if (label === undefined || label === null) {
						return;
					}
	
					var isLastTick = me.ticks.length === index + 1;
	
					// Since we always show the last tick,we need may need to hide the last shown one before
					var shouldSkip = (skipRatio > 1 && index % skipRatio > 0) || (index % skipRatio === 0 && index + skipRatio >= me.ticks.length);
					if (shouldSkip && !isLastTick || (label === undefined || label === null)) {
						return;
					}
	
					var lineWidth, lineColor;
					if (index === (typeof me.zeroLineIndex !== 'undefined' ? me.zeroLineIndex : 0)) {
						// Draw the first index specially
						lineWidth = gridLines.zeroLineWidth;
						lineColor = gridLines.zeroLineColor;
					} else {
						lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, index);
						lineColor = helpers.getValueAtIndexOrDefault(gridLines.color, index);
					}
	
					// Common properties
					var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
					var textAlign = 'middle';
					var textBaseline = 'middle';
	
					if (isHorizontal) {
						if (!isRotated) {
							textBaseline = options.position === 'top' ? 'bottom' : 'top';
						}
	
						textAlign = isRotated ? 'right' : 'center';
	
						var xLineValue = me.getPixelForTick(index) + helpers.aliasPixel(lineWidth); // xvalues for grid lines
						labelX = me.getPixelForTick(index, gridLines.offsetGridLines) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)
						labelY = (isRotated) ? me.top + 12 : options.position === 'top' ? me.bottom - tl : me.top + tl;
	
						tx1 = tx2 = x1 = x2 = xLineValue;
						ty1 = yTickStart;
						ty2 = yTickEnd;
						y1 = chartArea.top;
						y2 = chartArea.bottom;
					} else {
						if (options.position === 'left') {
							if (optionTicks.mirror) {
								labelX = me.right + optionTicks.padding;
								textAlign = 'left';
							} else {
								labelX = me.right - optionTicks.padding;
								textAlign = 'right';
							}
						// right side
						} else if (optionTicks.mirror) {
							labelX = me.left - optionTicks.padding;
							textAlign = 'right';
						} else {
							labelX = me.left + optionTicks.padding;
							textAlign = 'left';
						}
	
						var yLineValue = me.getPixelForTick(index); // xvalues for grid lines
						yLineValue += helpers.aliasPixel(lineWidth);
						labelY = me.getPixelForTick(index, gridLines.offsetGridLines);
	
						tx1 = xTickStart;
						tx2 = xTickEnd;
						x1 = chartArea.left;
						x2 = chartArea.right;
						ty1 = ty2 = y1 = y2 = yLineValue;
					}
	
					itemsToDraw.push({
						tx1: tx1,
						ty1: ty1,
						tx2: tx2,
						ty2: ty2,
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						labelX: labelX,
						labelY: labelY,
						glWidth: lineWidth,
						glColor: lineColor,
						glBorderDash: borderDash,
						glBorderDashOffset: borderDashOffset,
						rotation: -1 * labelRotationRadians,
						label: label,
						textBaseline: textBaseline,
						textAlign: textAlign
					});
				});
	
				// Draw all of the tick labels, tick marks, and grid lines at the correct places
				helpers.each(itemsToDraw, function(itemToDraw) {
					if (gridLines.display) {
						context.save();
						context.lineWidth = itemToDraw.glWidth;
						context.strokeStyle = itemToDraw.glColor;
						if (context.setLineDash) {
							context.setLineDash(itemToDraw.glBorderDash);
							context.lineDashOffset = itemToDraw.glBorderDashOffset;
						}
	
						context.beginPath();
	
						if (gridLines.drawTicks) {
							context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
							context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
						}
	
						if (gridLines.drawOnChartArea) {
							context.moveTo(itemToDraw.x1, itemToDraw.y1);
							context.lineTo(itemToDraw.x2, itemToDraw.y2);
						}
	
						context.stroke();
						context.restore();
					}
	
					if (optionTicks.display) {
						context.save();
						context.translate(itemToDraw.labelX, itemToDraw.labelY);
						context.rotate(itemToDraw.rotation);
						context.font = tickLabelFont;
						context.textBaseline = itemToDraw.textBaseline;
						context.textAlign = itemToDraw.textAlign;
	
						var label = itemToDraw.label;
						if (helpers.isArray(label)) {
							for (var i = 0, y = -(label.length - 1)*tickFontSize*0.75; i < label.length; ++i) {
								// We just make sure the multiline element is a string here..
								context.fillText('' + label[i], 0, y);
								// apply same lineSpacing as calculated @ L#320
								y += (tickFontSize * 1.5);
							}
						} else {
							context.fillText(label, 0, 0);
						}
						context.restore();
					}
				});
	
				if (scaleLabel.display) {
					// Draw the scale label
					var scaleLabelX;
					var scaleLabelY;
					var rotation = 0;
	
					if (isHorizontal) {
						scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
						scaleLabelY = options.position === 'bottom' ? me.bottom - (scaleLabelFontSize / 2) : me.top + (scaleLabelFontSize / 2);
					} else {
						var isLeft = options.position === 'left';
						scaleLabelX = isLeft ? me.left + (scaleLabelFontSize / 2) : me.right - (scaleLabelFontSize / 2);
						scaleLabelY = me.top + ((me.bottom - me.top) / 2);
						rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
					}
	
					context.save();
					context.translate(scaleLabelX, scaleLabelY);
					context.rotate(rotation);
					context.textAlign = 'center';
					context.textBaseline = 'middle';
					context.fillStyle = scaleLabelFontColor; // render in correct colour
					context.font = scaleLabelFont;
					context.fillText(scaleLabel.labelString, 0, 0);
					context.restore();
				}
	
				if (gridLines.drawBorder) {
					// Draw the line at the edge of the axis
					context.lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, 0);
					context.strokeStyle = helpers.getValueAtIndexOrDefault(gridLines.color, 0);
					var x1 = me.left,
						x2 = me.right,
						y1 = me.top,
						y2 = me.bottom;
	
					var aliasPixel = helpers.aliasPixel(context.lineWidth);
					if (isHorizontal) {
						y1 = y2 = options.position === 'top' ? me.bottom : me.top;
						y1 += aliasPixel;
						y2 += aliasPixel;
					} else {
						x1 = x2 = options.position === 'left' ? me.right : me.left;
						x1 += aliasPixel;
						x2 += aliasPixel;
					}
	
					context.beginPath();
					context.moveTo(x1, y1);
					context.lineTo(x2, y2);
					context.stroke();
				}
			}
		});
	};


/***/ }),
/* 411 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.title = {
			display: false,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
	
			fontStyle: 'bold',
			padding: 10,
	
			// actual title
			text: ''
		};
	
		var noop = helpers.noop;
		Chart.Title = Chart.Element.extend({
	
			initialize: function(config) {
				var me = this;
				helpers.extend(me, config);
				me.options = helpers.configMerge(Chart.defaults.global.title, config.options);
	
				// Contains hit boxes for each dataset (in dataset order)
				me.legendHitBoxes = [];
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
	
			beforeUpdate: function() {
				var chartOpts = this.chart.options;
				if (chartOpts && chartOpts.title) {
					this.options = helpers.configMerge(Chart.defaults.global.title, chartOpts.title);
				}
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: noop,
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global,
					display = opts.display,
					fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
					minSize = me.minSize;
	
				if (me.isHorizontal()) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? fontSize + (opts.padding * 2) : 0;
				} else {
					minSize.width = display ? fontSize + (opts.padding * 2) : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				var pos = this.options.position;
				return pos === 'top' || pos === 'bottom';
			},
	
			// Actualy draw the title block on the canvas
			draw: function() {
				var me = this,
					ctx = me.ctx,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global;
	
				if (opts.display) {
					var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
						fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle),
						fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily),
						titleFont = helpers.fontString(fontSize, fontStyle, fontFamily),
						rotation = 0,
						titleX,
						titleY,
						top = me.top,
						left = me.left,
						bottom = me.bottom,
						right = me.right;
	
					ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
					ctx.font = titleFont;
	
					// Horizontal
					if (me.isHorizontal()) {
						titleX = left + ((right - left) / 2); // midpoint of the width
						titleY = top + ((bottom - top) / 2); // midpoint of the height
					} else {
						titleX = opts.position === 'left' ? left + (fontSize / 2) : right - (fontSize / 2);
						titleY = top + ((bottom - top) / 2);
						rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
					}
	
					ctx.save();
					ctx.translate(titleX, titleY);
					ctx.rotate(rotation);
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					ctx.fillText(opts.text, 0, 0);
					ctx.restore();
				}
			}
		});
	
		// Register the title plugin
		Chart.plugins.register({
			beforeInit: function(chartInstance) {
				var opts = chartInstance.options;
				var titleOpts = opts.title;
	
				if (titleOpts) {
					chartInstance.titleBlock = new Chart.Title({
						ctx: chartInstance.chart.ctx,
						options: titleOpts,
						chart: chartInstance
					});
	
					Chart.layoutService.addBox(chartInstance, chartInstance.titleBlock);
				}
			}
		});
	};


/***/ }),
/* 412 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var noop = helpers.noop;
	
		Chart.defaults.global.legend = {
	
			display: true,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
			reverse: false,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		};
	
		Chart.Legend = Chart.Element.extend({
	
			initialize: function(config) {
				helpers.extend(this, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				this.legendHitBoxes = [];
	
				// Are we in doughnut mode which has a different data type
				this.doughnutMode = false;
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all legend types.
			// Any function can be extended by the legend type
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: function() {
				var me = this;
				me.legendItems = me.options.labels.generateLabels.call(me, me.chart);
				if (me.options.reverse) {
					me.legendItems.reverse();
				}
			},
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var display = opts.display;
	
				var ctx = me.ctx;
	
				var globalDefault = Chart.defaults.global,
					itemOrDefault = helpers.getValueOrDefault,
					fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
					fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
					fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
					labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
				// Reset hit boxes
				var hitboxes = me.legendHitBoxes = [];
	
				var minSize = me.minSize;
				var isHorizontal = me.isHorizontal();
	
				if (isHorizontal) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? 10 : 0;
				} else {
					minSize.width = display ? 10 : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Increase sizes here
				if (display) {
					ctx.font = labelFont;
	
					if (isHorizontal) {
						// Labels
	
						// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
						var lineWidths = me.lineWidths = [0];
						var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;
	
						ctx.textAlign = 'left';
						ctx.textBaseline = 'top';
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = labelOpts.usePointStyle ?
								fontSize * Math.sqrt(2) :
								labelOpts.boxWidth;
	
							var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
							if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
								totalHeight += fontSize + (labelOpts.padding);
								lineWidths[lineWidths.length] = me.left;
							}
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: width,
								height: fontSize
							};
	
							lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
						});
	
						minSize.height += totalHeight;
	
					} else {
						var vPadding = labelOpts.padding;
						var columnWidths = me.columnWidths = [];
						var totalWidth = labelOpts.padding;
						var currentColWidth = 0;
						var currentColHeight = 0;
						var itemHeight = fontSize + vPadding;
	
						helpers.each(me.legendItems, function(legendItem, i) {
							// If usePointStyle is set, multiple boxWidth by 2 since it represents
							// the radius and not truly the width
							var boxWidth = labelOpts.usePointStyle ? 2 * labelOpts.boxWidth : labelOpts.boxWidth;
	
							var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							// If too tall, go to new column
							if (currentColHeight + itemHeight > minSize.height) {
								totalWidth += currentColWidth + labelOpts.padding;
								columnWidths.push(currentColWidth); // previous column width
	
								currentColWidth = 0;
								currentColHeight = 0;
							}
	
							// Get max width
							currentColWidth = Math.max(currentColWidth, itemWidth);
							currentColHeight += itemHeight;
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: itemWidth,
								height: fontSize
							};
						});
	
						totalWidth += currentColWidth;
						columnWidths.push(currentColWidth);
						minSize.width += totalWidth;
					}
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
	
			// Actualy draw the legend on the canvas
			draw: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var globalDefault = Chart.defaults.global,
					lineDefault = globalDefault.elements.line,
					legendWidth = me.width,
					lineWidths = me.lineWidths;
	
				if (opts.display) {
					var ctx = me.ctx,
						cursor,
						itemOrDefault = helpers.getValueOrDefault,
						fontColor = itemOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor),
						fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
						fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
						fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
						labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
					// Canvas setup
					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';
					ctx.lineWidth = 0.5;
					ctx.strokeStyle = fontColor; // for strikethrough effect
					ctx.fillStyle = fontColor; // render in correct colour
					ctx.font = labelFont;
	
					var boxWidth = labelOpts.boxWidth,
						hitboxes = me.legendHitBoxes;
	
					// current position
					var drawLegendBox = function(x, y, legendItem) {
						if (isNaN(boxWidth) || boxWidth <= 0) {
							return;
						}
	
						// Set the ctx for the box
						ctx.save();
	
						ctx.fillStyle = itemOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
						ctx.lineCap = itemOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
						ctx.lineDashOffset = itemOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
						ctx.lineJoin = itemOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
						ctx.lineWidth = itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
						ctx.strokeStyle = itemOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
						var isLineWidthZero = (itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);
	
						if (ctx.setLineDash) {
							// IE 9 and 10 do not support line dash
							ctx.setLineDash(itemOrDefault(legendItem.lineDash, lineDefault.borderDash));
						}
	
						if (opts.labels && opts.labels.usePointStyle) {
							// Recalulate x and y for drawPoint() because its expecting
							// x and y to be center of figure (instead of top left)
							var radius = fontSize * Math.SQRT2 / 2;
							var offSet = radius / Math.SQRT2;
							var centerX = x + offSet;
							var centerY = y + offSet;
	
							// Draw pointStyle as legend symbol
							Chart.canvasHelpers.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
						} else {
							// Draw box as legend symbol
							if (!isLineWidthZero) {
								ctx.strokeRect(x, y, boxWidth, fontSize);
							}
							ctx.fillRect(x, y, boxWidth, fontSize);
						}
	
						ctx.restore();
					};
					var fillText = function(x, y, legendItem, textWidth) {
						ctx.fillText(legendItem.text, boxWidth + (fontSize / 2) + x, y);
	
						if (legendItem.hidden) {
							// Strikethrough the text if hidden
							ctx.beginPath();
							ctx.lineWidth = 2;
							ctx.moveTo(boxWidth + (fontSize / 2) + x, y + (fontSize / 2));
							ctx.lineTo(boxWidth + (fontSize / 2) + x + textWidth, y + (fontSize / 2));
							ctx.stroke();
						}
					};
	
					// Horizontal
					var isHorizontal = me.isHorizontal();
					if (isHorizontal) {
						cursor = {
							x: me.left + ((legendWidth - lineWidths[0]) / 2),
							y: me.top + labelOpts.padding,
							line: 0
						};
					} else {
						cursor = {
							x: me.left + labelOpts.padding,
							y: me.top + labelOpts.padding,
							line: 0
						};
					}
	
					var itemHeight = fontSize + labelOpts.padding;
					helpers.each(me.legendItems, function(legendItem, i) {
						var textWidth = ctx.measureText(legendItem.text).width,
							width = labelOpts.usePointStyle ?
								fontSize + (fontSize / 2) + textWidth :
								boxWidth + (fontSize / 2) + textWidth,
							x = cursor.x,
							y = cursor.y;
	
						if (isHorizontal) {
							if (x + width >= legendWidth) {
								y = cursor.y += itemHeight;
								cursor.line++;
								x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
							}
						} else if (y + itemHeight > me.bottom) {
							x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
							y = cursor.y = me.top;
							cursor.line++;
						}
	
						drawLegendBox(x, y, legendItem);
	
						hitboxes[i].left = x;
						hitboxes[i].top = y;
	
						// Fill the actual label
						fillText(x, y, legendItem, textWidth);
	
						if (isHorizontal) {
							cursor.x += width + (labelOpts.padding);
						} else {
							cursor.y += itemHeight;
						}
	
					});
				}
			},
	
			// Handle an event
			handleEvent: function(e) {
				var me = this;
				var opts = me.options;
				var type = e.type === 'mouseup' ? 'click' : e.type;
	
				if (type === 'mousemove') {
					if (!opts.onHover) {
						return;
					}
				} else if (type === 'click') {
					if (!opts.onClick) {
						return;
					}
				} else {
					return;
				}
	
				var position = helpers.getRelativePosition(e, me.chart.chart),
					x = position.x,
					y = position.y;
	
				if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
					// See if we are touching one of the dataset boxes
					var lh = me.legendHitBoxes;
					for (var i = 0; i < lh.length; ++i) {
						var hitBox = lh[i];
	
						if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
							// Touching an element
							if (type === 'click') {
								opts.onClick.call(me, e, me.legendItems[i]);
								break;
							} else if (type === 'mousemove') {
								opts.onHover.call(me, e, me.legendItems[i]);
								break;
							}
						}
					}
				}
			}
		});
	
		// Register the legend plugin
		Chart.plugins.register({
			beforeInit: function(chartInstance) {
				var opts = chartInstance.options;
				var legendOpts = opts.legend;
	
				if (legendOpts) {
					chartInstance.legend = new Chart.Legend({
						ctx: chartInstance.chart.ctx,
						options: legendOpts,
						chart: chartInstance
					});
	
					Chart.layoutService.addBox(chartInstance, chartInstance.legend);
				}
			}
		});
	};


/***/ }),
/* 413 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.tooltips = {
			enabled: true,
			custom: null,
			mode: 'single',
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			yAlign: 'center',
			xAlign: 'center',
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
	
						if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers.noop,
				label: function(tooltipItem, data) {
					var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
					return datasetLabel + ': ' + tooltipItem.yLabel;
				},
				labelColor: function(tooltipItem, chartInstance) {
					var meta = chartInstance.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				afterLabel: helpers.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers.noop,
				footer: helpers.noop,
				afterFooter: helpers.noop
			}
		};
	
		// Helper to push or concat based on if the 2nd parameter is an array or not
		function pushOrConcat(base, toPush) {
			if (toPush) {
				if (helpers.isArray(toPush)) {
					// base = base.concat(toPush);
					Array.prototype.push.apply(base, toPush);
				} else {
					base.push(toPush);
				}
			}
	
			return base;
		}
	
		function getAveragePosition(elements) {
			if (!elements.length) {
				return false;
			}
	
			var i, len;
			var xPositions = [];
			var yPositions = [];
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					xPositions.push(pos.x);
					yPositions.push(pos.y);
				}
			}
	
			var x = 0,
				y = 0;
			for (i = 0; i < xPositions.length; ++i) {
				if (xPositions[i]) {
					x += xPositions[i];
					y += yPositions[i];
				}
			}
	
			return {
				x: Math.round(x / xPositions.length),
				y: Math.round(y / xPositions.length)
			};
		}
	
		// Private helper to create a tooltip iteam model
		// @param element : the chart element (point, arc, bar) to create the tooltip item for
		// @return : new tooltip item
		function createTooltipItem(element) {
			var xScale = element._xScale;
			var yScale = element._yScale || element._scale; // handle radar || polarArea charts
			var index = element._index,
				datasetIndex = element._datasetIndex;
	
			return {
				xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
				yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
				index: index,
				datasetIndex: datasetIndex
			};
		}
	
		Chart.Tooltip = Chart.Element.extend({
			initialize: function() {
				var me = this;
				var globalDefaults = Chart.defaults.global;
				var tooltipOpts = me._options;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				helpers.extend(me, {
					_model: {
						// Positioning
						xPadding: tooltipOpts.xPadding,
						yPadding: tooltipOpts.yPadding,
						xAlign: tooltipOpts.xAlign,
						yAlign: tooltipOpts.yAlign,
	
						// Body
						bodyFontColor: tooltipOpts.bodyFontColor,
						_bodyFontFamily: getValueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
						_bodyFontStyle: getValueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
						_bodyAlign: tooltipOpts.bodyAlign,
						bodyFontSize: getValueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
						bodySpacing: tooltipOpts.bodySpacing,
	
						// Title
						titleFontColor: tooltipOpts.titleFontColor,
						_titleFontFamily: getValueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
						_titleFontStyle: getValueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
						titleFontSize: getValueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
						_titleAlign: tooltipOpts.titleAlign,
						titleSpacing: tooltipOpts.titleSpacing,
						titleMarginBottom: tooltipOpts.titleMarginBottom,
	
						// Footer
						footerFontColor: tooltipOpts.footerFontColor,
						_footerFontFamily: getValueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
						_footerFontStyle: getValueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
						footerFontSize: getValueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
						_footerAlign: tooltipOpts.footerAlign,
						footerSpacing: tooltipOpts.footerSpacing,
						footerMarginTop: tooltipOpts.footerMarginTop,
	
						// Appearance
						caretSize: tooltipOpts.caretSize,
						cornerRadius: tooltipOpts.cornerRadius,
						backgroundColor: tooltipOpts.backgroundColor,
						opacity: 0,
						legendColorBackground: tooltipOpts.multiKeyBackground
					}
				});
			},
	
			// Get the title
			// Args are: (tooltipItem, data)
			getTitle: function() {
				var me = this;
				var opts = me._options;
				var callbacks = opts.callbacks;
	
				var beforeTitle = callbacks.beforeTitle.apply(me, arguments),
					title = callbacks.title.apply(me, arguments),
					afterTitle = callbacks.afterTitle.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeTitle);
				lines = pushOrConcat(lines, title);
				lines = pushOrConcat(lines, afterTitle);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getBeforeBody: function() {
				var lines = this._options.callbacks.beforeBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Args are: (tooltipItem, data)
			getBody: function(tooltipItems, data) {
				var me = this;
				var callbacks = me._options.callbacks;
				var bodyItems = [];
	
				helpers.each(tooltipItems, function(tooltipItem) {
					var bodyItem = {
						before: [],
						lines: [],
						after: []
					};
					pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));
	
					bodyItems.push(bodyItem);
				});
	
				return bodyItems;
			},
	
			// Args are: (tooltipItem, data)
			getAfterBody: function() {
				var lines = this._options.callbacks.afterBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Get the footer and beforeFooter and afterFooter lines
			// Args are: (tooltipItem, data)
			getFooter: function() {
				var me = this;
				var callbacks = me._options.callbacks;
	
				var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
				var footer = callbacks.footer.apply(me, arguments);
				var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeFooter);
				lines = pushOrConcat(lines, footer);
				lines = pushOrConcat(lines, afterFooter);
	
				return lines;
			},
	
			update: function(changed) {
				var me = this;
				var opts = me._options;
				var model = me._model;
				var active = me._active;
	
				var data = me._data;
				var chartInstance = me._chartInstance;
	
				var i, len;
	
				if (active.length) {
					model.opacity = 1;
	
					var labelColors = [],
						tooltipPosition = getAveragePosition(active);
	
					var tooltipItems = [];
					for (i = 0, len = active.length; i < len; ++i) {
						tooltipItems.push(createTooltipItem(active[i]));
					}
	
					// If the user provided a sorting function, use it to modify the tooltip items
					if (opts.itemSort) {
						tooltipItems = tooltipItems.sort(function(a, b) {
							return opts.itemSort(a, b, data);
						});
					}
	
					// If there is more than one item, show color items
					if (active.length > 1) {
						helpers.each(tooltipItems, function(tooltipItem) {
							labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, chartInstance));
						});
					}
	
					// Build the Text Lines
					helpers.extend(model, {
						title: me.getTitle(tooltipItems, data),
						beforeBody: me.getBeforeBody(tooltipItems, data),
						body: me.getBody(tooltipItems, data),
						afterBody: me.getAfterBody(tooltipItems, data),
						footer: me.getFooter(tooltipItems, data),
						x: Math.round(tooltipPosition.x),
						y: Math.round(tooltipPosition.y),
						caretPadding: helpers.getValueOrDefault(tooltipPosition.padding, 2),
						labelColors: labelColors
					});
	
					// We need to determine alignment of
					var tooltipSize = me.getTooltipSize(model);
					me.determineAlignment(tooltipSize); // Smart Tooltip placement to stay on the canvas
	
					helpers.extend(model, me.getBackgroundPoint(model, tooltipSize));
				} else {
					me._model.opacity = 0;
				}
	
				if (changed && opts.custom) {
					opts.custom.call(me, model);
				}
	
				return me;
			},
			getTooltipSize: function(vm) {
				var ctx = this._chart.ctx;
	
				var size = {
					height: vm.yPadding * 2, // Tooltip Padding
					width: 0
				};
	
				// Count of all lines in the body
				var body = vm.body;
				var combinedBodyLength = body.reduce(function(count, bodyItem) {
					return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
				}, 0);
				combinedBodyLength += vm.beforeBody.length + vm.afterBody.length;
	
				var titleLineCount = vm.title.length;
				var footerLineCount = vm.footer.length;
				var titleFontSize = vm.titleFontSize,
					bodyFontSize = vm.bodyFontSize,
					footerFontSize = vm.footerFontSize;
	
				size.height += titleLineCount * titleFontSize; // Title Lines
				size.height += (titleLineCount - 1) * vm.titleSpacing; // Title Line Spacing
				size.height += titleLineCount ? vm.titleMarginBottom : 0; // Title's bottom Margin
				size.height += combinedBodyLength * bodyFontSize; // Body Lines
				size.height += combinedBodyLength ? (combinedBodyLength - 1) * vm.bodySpacing : 0; // Body Line Spacing
				size.height += footerLineCount ? vm.footerMarginTop : 0; // Footer Margin
				size.height += footerLineCount * (footerFontSize); // Footer Lines
				size.height += footerLineCount ? (footerLineCount - 1) * vm.footerSpacing : 0; // Footer Line Spacing
	
				// Title width
				var widthPadding = 0;
				var maxLineWidth = function(line) {
					size.width = Math.max(size.width, ctx.measureText(line).width + widthPadding);
				};
	
				ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
				helpers.each(vm.title, maxLineWidth);
	
				// Body width
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
				helpers.each(vm.beforeBody.concat(vm.afterBody), maxLineWidth);
	
				// Body lines may include some extra width due to the color box
				widthPadding = body.length > 1 ? (bodyFontSize + 2) : 0;
				helpers.each(body, function(bodyItem) {
					helpers.each(bodyItem.before, maxLineWidth);
					helpers.each(bodyItem.lines, maxLineWidth);
					helpers.each(bodyItem.after, maxLineWidth);
				});
	
				// Reset back to 0
				widthPadding = 0;
	
				// Footer width
				ctx.font = helpers.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
				helpers.each(vm.footer, maxLineWidth);
	
				// Add padding
				size.width += 2 * vm.xPadding;
	
				return size;
			},
			determineAlignment: function(size) {
				var me = this;
				var model = me._model;
				var chart = me._chart;
				var chartArea = me._chartInstance.chartArea;
	
				if (model.y < size.height) {
					model.yAlign = 'top';
				} else if (model.y > (chart.height - size.height)) {
					model.yAlign = 'bottom';
				}
	
				var lf, rf; // functions to determine left, right alignment
				var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
				var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
				var midX = (chartArea.left + chartArea.right) / 2;
				var midY = (chartArea.top + chartArea.bottom) / 2;
	
				if (model.yAlign === 'center') {
					lf = function(x) {
						return x <= midX;
					};
					rf = function(x) {
						return x > midX;
					};
				} else {
					lf = function(x) {
						return x <= (size.width / 2);
					};
					rf = function(x) {
						return x >= (chart.width - (size.width / 2));
					};
				}
	
				olf = function(x) {
					return x + size.width > chart.width;
				};
				orf = function(x) {
					return x - size.width < 0;
				};
				yf = function(y) {
					return y <= midY ? 'top' : 'bottom';
				};
	
				if (lf(model.x)) {
					model.xAlign = 'left';
	
					// Is tooltip too wide and goes over the right side of the chart.?
					if (olf(model.x)) {
						model.xAlign = 'center';
						model.yAlign = yf(model.y);
					}
				} else if (rf(model.x)) {
					model.xAlign = 'right';
	
					// Is tooltip too wide and goes outside left edge of canvas?
					if (orf(model.x)) {
						model.xAlign = 'center';
						model.yAlign = yf(model.y);
					}
				}
			},
			getBackgroundPoint: function(vm, size) {
				// Background Position
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				var caretSize = vm.caretSize,
					caretPadding = vm.caretPadding,
					cornerRadius = vm.cornerRadius,
					xAlign = vm.xAlign,
					yAlign = vm.yAlign,
					paddingAndSize = caretSize + caretPadding,
					radiusAndPadding = cornerRadius + caretPadding;
	
				if (xAlign === 'right') {
					pt.x -= size.width;
				} else if (xAlign === 'center') {
					pt.x -= (size.width / 2);
				}
	
				if (yAlign === 'top') {
					pt.y += paddingAndSize;
				} else if (yAlign === 'bottom') {
					pt.y -= size.height + paddingAndSize;
				} else {
					pt.y -= (size.height / 2);
				}
	
				if (yAlign === 'center') {
					if (xAlign === 'left') {
						pt.x += paddingAndSize;
					} else if (xAlign === 'right') {
						pt.x -= paddingAndSize;
					}
				} else if (xAlign === 'left') {
					pt.x -= radiusAndPadding;
				} else if (xAlign === 'right') {
					pt.x += radiusAndPadding;
				}
	
				return pt;
			},
			drawCaret: function(tooltipPoint, size, opacity) {
				var vm = this._view;
				var ctx = this._chart.ctx;
				var x1, x2, x3;
				var y1, y2, y3;
				var caretSize = vm.caretSize;
				var cornerRadius = vm.cornerRadius;
				var xAlign = vm.xAlign,
					yAlign = vm.yAlign;
				var ptX = tooltipPoint.x,
					ptY = tooltipPoint.y;
				var width = size.width,
					height = size.height;
	
				if (yAlign === 'center') {
					// Left or right side
					if (xAlign === 'left') {
						x1 = ptX;
						x2 = x1 - caretSize;
						x3 = x1;
					} else {
						x1 = ptX + width;
						x2 = x1 + caretSize;
						x3 = x1;
					}
	
					y2 = ptY + (height / 2);
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				} else {
					if (xAlign === 'left') {
						x1 = ptX + cornerRadius;
						x2 = x1 + caretSize;
						x3 = x2 + caretSize;
					} else if (xAlign === 'right') {
						x1 = ptX + width - cornerRadius;
						x2 = x1 - caretSize;
						x3 = x2 - caretSize;
					} else {
						x2 = ptX + (width / 2);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					}
	
					if (yAlign === 'top') {
						y1 = ptY;
						y2 = y1 - caretSize;
						y3 = y1;
					} else {
						y1 = ptY + height;
						y2 = y1 + caretSize;
						y3 = y1;
					}
				}
	
				var bgColor = helpers.color(vm.backgroundColor);
				ctx.fillStyle = bgColor.alpha(opacity * bgColor.alpha()).rgbString();
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.lineTo(x3, y3);
				ctx.closePath();
				ctx.fill();
			},
			drawTitle: function(pt, vm, ctx, opacity) {
				var title = vm.title;
	
				if (title.length) {
					ctx.textAlign = vm._titleAlign;
					ctx.textBaseline = 'top';
	
					var titleFontSize = vm.titleFontSize,
						titleSpacing = vm.titleSpacing;
	
					var titleFontColor = helpers.color(vm.titleFontColor);
					ctx.fillStyle = titleFontColor.alpha(opacity * titleFontColor.alpha()).rgbString();
					ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
					var i, len;
					for (i = 0, len = title.length; i < len; ++i) {
						ctx.fillText(title[i], pt.x, pt.y);
						pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
						if (i + 1 === title.length) {
							pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
						}
					}
				}
			},
			drawBody: function(pt, vm, ctx, opacity) {
				var bodyFontSize = vm.bodyFontSize;
				var bodySpacing = vm.bodySpacing;
				var body = vm.body;
	
				ctx.textAlign = vm._bodyAlign;
				ctx.textBaseline = 'top';
	
				var bodyFontColor = helpers.color(vm.bodyFontColor);
				var textColor = bodyFontColor.alpha(opacity * bodyFontColor.alpha()).rgbString();
				ctx.fillStyle = textColor;
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
				// Before Body
				var xLinePadding = 0;
				var fillLineOfText = function(line) {
					ctx.fillText(line, pt.x + xLinePadding, pt.y);
					pt.y += bodyFontSize + bodySpacing;
				};
	
				// Before body lines
				helpers.each(vm.beforeBody, fillLineOfText);
	
				var drawColorBoxes = body.length > 1;
				xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;
	
				// Draw body lines now
				helpers.each(body, function(bodyItem, i) {
					helpers.each(bodyItem.before, fillLineOfText);
	
					helpers.each(bodyItem.lines, function(line) {
						// Draw Legend-like boxes if needed
						if (drawColorBoxes) {
							// Fill a white rect so that colours merge nicely if the opacity is < 1
							ctx.fillStyle = helpers.color(vm.legendColorBackground).alpha(opacity).rgbaString();
							ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Border
							ctx.strokeStyle = helpers.color(vm.labelColors[i].borderColor).alpha(opacity).rgbaString();
							ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Inner square
							ctx.fillStyle = helpers.color(vm.labelColors[i].backgroundColor).alpha(opacity).rgbaString();
							ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
	
							ctx.fillStyle = textColor;
						}
	
						fillLineOfText(line);
					});
	
					helpers.each(bodyItem.after, fillLineOfText);
				});
	
				// Reset back to 0 for after body
				xLinePadding = 0;
	
				// After body lines
				helpers.each(vm.afterBody, fillLineOfText);
				pt.y -= bodySpacing; // Remove last body spacing
			},
			drawFooter: function(pt, vm, ctx, opacity) {
				var footer = vm.footer;
	
				if (footer.length) {
					pt.y += vm.footerMarginTop;
	
					ctx.textAlign = vm._footerAlign;
					ctx.textBaseline = 'top';
	
					var footerFontColor = helpers.color(vm.footerFontColor);
					ctx.fillStyle = footerFontColor.alpha(opacity * footerFontColor.alpha()).rgbString();
					ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
					helpers.each(footer, function(line) {
						ctx.fillText(line, pt.x, pt.y);
						pt.y += vm.footerFontSize + vm.footerSpacing;
					});
				}
			},
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				if (vm.opacity === 0) {
					return;
				}
	
				var tooltipSize = this.getTooltipSize(vm);
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				// IE11/Edge does not like very small opacities, so snap to 0
				var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
				if (this._options.enabled) {
					// Draw Background
					var bgColor = helpers.color(vm.backgroundColor);
					ctx.fillStyle = bgColor.alpha(opacity * bgColor.alpha()).rgbString();
					helpers.drawRoundedRectangle(ctx, pt.x, pt.y, tooltipSize.width, tooltipSize.height, vm.cornerRadius);
					ctx.fill();
	
					// Draw Caret
					this.drawCaret(pt, tooltipSize, opacity);
	
					// Draw Title, Body, and Footer
					pt.x += vm.xPadding;
					pt.y += vm.yPadding;
	
					// Titles
					this.drawTitle(pt, vm, ctx, opacity);
	
					// Body
					this.drawBody(pt, vm, ctx, opacity);
	
					// Footer
					this.drawFooter(pt, vm, ctx, opacity);
				}
			}
		});
	};


/***/ }),
/* 414 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global;
	
		globalOpts.elements.arc = {
			backgroundColor: globalOpts.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		};
	
		Chart.elements.Arc = Chart.Element.extend({
			inLabelRange: function(mouseX) {
				var vm = this._view;
	
				if (vm) {
					return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
				}
				return false;
			},
			inRange: function(chartX, chartY) {
				var vm = this._view;
	
				if (vm) {
					var pointRelativePosition = helpers.getAngleFromPoint(vm, {
							x: chartX,
							y: chartY
						}),
						angle = pointRelativePosition.angle,
						distance = pointRelativePosition.distance;
	
					// Sanitise angle range
					var startAngle = vm.startAngle;
					var endAngle = vm.endAngle;
					while (endAngle < startAngle) {
						endAngle += 2.0 * Math.PI;
					}
					while (angle > endAngle) {
						angle -= 2.0 * Math.PI;
					}
					while (angle < startAngle) {
						angle += 2.0 * Math.PI;
					}
	
					// Check if within the range of the open/close angle
					var betweenAngles = (angle >= startAngle && angle <= endAngle),
						withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
					return (betweenAngles && withinRadius);
				}
				return false;
			},
			tooltipPosition: function() {
				var vm = this._view;
	
				var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2),
					rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
				return {
					x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
					y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
				};
			},
			draw: function() {
	
				var ctx = this._chart.ctx,
					vm = this._view,
					sA = vm.startAngle,
					eA = vm.endAngle;
	
				ctx.beginPath();
	
				ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
				ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
	
				ctx.closePath();
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = vm.borderWidth;
	
				ctx.fillStyle = vm.backgroundColor;
	
				ctx.fill();
				ctx.lineJoin = 'bevel';
	
				if (vm.borderWidth) {
					ctx.stroke();
				}
			}
		});
	};


/***/ }),
/* 415 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		Chart.defaults.global.elements.line = {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true // do we fill in the area between the line and its base axis
		};
	
		Chart.elements.Line = Chart.Element.extend({
			draw: function() {
				var me = this;
				var vm = me._view;
				var spanGaps = vm.spanGaps;
				var scaleZero = vm.scaleZero;
				var loop = me._loop;
	
				var ctx = me._chart.ctx;
				ctx.save();
	
				// Helper function to draw a line to a point
				function lineToPoint(previousPoint, point) {
					var pointVM = point._view;
					if (point._view.steppedLine === true) {
						ctx.lineTo(pointVM.x, previousPoint._view.y);
						ctx.lineTo(pointVM.x, pointVM.y);
					} else if (point._view.tension === 0) {
						ctx.lineTo(pointVM.x, pointVM.y);
					} else {
						ctx.bezierCurveTo(
							previousPoint._view.controlPointNextX,
							previousPoint._view.controlPointNextY,
							pointVM.controlPointPreviousX,
							pointVM.controlPointPreviousY,
							pointVM.x,
							pointVM.y
						);
					}
				}
	
				var points = me._children.slice(); // clone array
				var lastDrawnIndex = -1;
	
				// If we are looping, adding the first point again
				if (loop && points.length) {
					points.push(points[0]);
				}
	
				var index, current, previous, currentVM;
	
				// Fill Line
				if (points.length && vm.fill) {
					ctx.beginPath();
	
					for (index = 0; index < points.length; ++index) {
						current = points[index];
						previous = helpers.previousItem(points, index);
						currentVM = current._view;
	
						// First point moves to it's starting position no matter what
						if (index === 0) {
							if (loop) {
								ctx.moveTo(scaleZero.x, scaleZero.y);
							} else {
								ctx.moveTo(currentVM.x, scaleZero);
							}
	
							if (!currentVM.skip) {
								lastDrawnIndex = index;
								ctx.lineTo(currentVM.x, currentVM.y);
							}
						} else {
							previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
							if (currentVM.skip) {
								// Only do this if this is the first point that is skipped
								if (!spanGaps && lastDrawnIndex === (index - 1)) {
									if (loop) {
										ctx.lineTo(scaleZero.x, scaleZero.y);
									} else {
										ctx.lineTo(previous._view.x, scaleZero);
									}
								}
							} else {
								if (lastDrawnIndex !== (index - 1)) {
									// There was a gap and this is the first point after the gap. If we've never drawn a point, this is a special case.
									// If the first data point is NaN, then there is no real gap to skip
									if (spanGaps && lastDrawnIndex !== -1) {
										// We are spanning the gap, so simple draw a line to this point
										lineToPoint(previous, current);
									} else if (loop) {
										ctx.lineTo(currentVM.x, currentVM.y);
									} else {
										ctx.lineTo(currentVM.x, scaleZero);
										ctx.lineTo(currentVM.x, currentVM.y);
									}
								} else {
									// Line to next point
									lineToPoint(previous, current);
								}
								lastDrawnIndex = index;
							}
						}
					}
	
					if (!loop && lastDrawnIndex !== -1) {
						ctx.lineTo(points[lastDrawnIndex]._view.x, scaleZero);
					}
	
					ctx.fillStyle = vm.backgroundColor || globalDefaults.defaultColor;
					ctx.closePath();
					ctx.fill();
				}
	
				// Stroke Line Options
				var globalOptionLineElements = globalDefaults.elements.line;
				ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
				// IE 9 and 10 do not support line dash
				if (ctx.setLineDash) {
					ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
				}
	
				ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
				ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
				ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
				ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
				// Stroke Line
				ctx.beginPath();
				lastDrawnIndex = -1;
	
				for (index = 0; index < points.length; ++index) {
					current = points[index];
					previous = helpers.previousItem(points, index);
					currentVM = current._view;
	
					// First point moves to it's starting position no matter what
					if (index === 0) {
						if (!currentVM.skip) {
							ctx.moveTo(currentVM.x, currentVM.y);
							lastDrawnIndex = index;
						}
					} else {
						previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
						if (!currentVM.skip) {
							if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
								// There was a gap and this is the first point after the gap
								ctx.moveTo(currentVM.x, currentVM.y);
							} else {
								// Line to next point
								lineToPoint(previous, current);
							}
							lastDrawnIndex = index;
						}
					}
				}
	
				ctx.stroke();
				ctx.restore();
			}
		});
	};


/***/ }),
/* 416 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global,
			defaultColor = globalOpts.defaultColor;
	
		globalOpts.elements.point = {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderWidth: 1,
			borderColor: defaultColor,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		};
	
		Chart.elements.Point = Chart.Element.extend({
			inRange: function(mouseX, mouseY) {
				var vm = this._view;
				return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
			},
			inLabelRange: function(mouseX) {
				var vm = this._view;
				return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y,
					padding: vm.radius + vm.borderWidth
				};
			},
			draw: function() {
				var vm = this._view;
				var ctx = this._chart.ctx;
				var pointStyle = vm.pointStyle;
				var radius = vm.radius;
				var x = vm.x;
				var y = vm.y;
	
				if (vm.skip) {
					return;
				}
	
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = helpers.getValueOrDefault(vm.borderWidth, globalOpts.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
	
				Chart.canvasHelpers.drawPoint(ctx, pointStyle, radius, x, y);
			}
		});
	};


/***/ }),
/* 417 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var globalOpts = Chart.defaults.global;
	
		globalOpts.elements.rectangle = {
			backgroundColor: globalOpts.defaultColor,
			borderWidth: 0,
			borderColor: globalOpts.defaultColor,
			borderSkipped: 'bottom'
		};
	
		Chart.elements.Rectangle = Chart.Element.extend({
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				var halfWidth = vm.width / 2,
					leftX = vm.x - halfWidth,
					rightX = vm.x + halfWidth,
					top = vm.base - (vm.base - vm.y),
					halfStroke = vm.borderWidth / 2;
	
				// Canvas doesn't allow us to stroke inside the width so we can
				// adjust the sizes to fit if we're setting a stroke on the line
				if (vm.borderWidth) {
					leftX += halfStroke;
					rightX -= halfStroke;
					top += halfStroke;
				}
	
				ctx.beginPath();
				ctx.fillStyle = vm.backgroundColor;
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = vm.borderWidth;
	
				// Corner points, from bottom-left to bottom-right clockwise
				// | 1 2 |
				// | 0 3 |
				var corners = [
					[leftX, vm.base],
					[leftX, top],
					[rightX, top],
					[rightX, vm.base]
				];
	
				// Find first (starting) corner with fallback to 'bottom'
				var borders = ['bottom', 'left', 'top', 'right'];
				var startCorner = borders.indexOf(vm.borderSkipped, 0);
				if (startCorner === -1) {
					startCorner = 0;
				}
	
				function cornerAt(index) {
					return corners[(startCorner + index) % 4];
				}
	
				// Draw rectangle from 'startCorner'
				ctx.moveTo.apply(ctx, cornerAt(0));
				for (var i = 1; i < 4; i++) {
					ctx.lineTo.apply(ctx, cornerAt(i));
				}
	
				ctx.fill();
				if (vm.borderWidth) {
					ctx.stroke();
				}
			},
			height: function() {
				var vm = this._view;
				return vm.base - vm.y;
			},
			inRange: function(mouseX, mouseY) {
				var vm = this._view;
				return vm ?
						(vm.y < vm.base ?
							(mouseX >= vm.x - vm.width / 2 && mouseX <= vm.x + vm.width / 2) && (mouseY >= vm.y && mouseY <= vm.base) :
							(mouseX >= vm.x - vm.width / 2 && mouseX <= vm.x + vm.width / 2) && (mouseY >= vm.base && mouseY <= vm.y)) :
						false;
			},
			inLabelRange: function(mouseX) {
				var vm = this._view;
				return vm ? (mouseX >= vm.x - vm.width / 2 && mouseX <= vm.x + vm.width / 2) : false;
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y
				};
			}
		});
	
	};


/***/ }),
/* 418 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			noop = helpers.noop;
	
		Chart.LinearScaleBase = Chart.Scale.extend({
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (tickOpts.beginAtZero) {
					var minSign = helpers.sign(me.min);
					var maxSign = helpers.sign(me.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						me.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the botttom down to 0
						me.min = 0;
					}
				}
	
				if (tickOpts.min !== undefined) {
					me.min = tickOpts.min;
				} else if (tickOpts.suggestedMin !== undefined) {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
	
				if (tickOpts.max !== undefined) {
					me.max = tickOpts.max;
				} else if (tickOpts.suggestedMax !== undefined) {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
	
				if (me.min === me.max) {
					me.max++;
	
					if (!tickOpts.beginAtZero) {
						me.min--;
					}
				}
			},
			getTickLimit: noop,
			handleDirectionalChanges: noop,
	
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var ticks = me.ticks = [];
				var tickOpts = opts.ticks;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
	
				var maxTicks = me.getTickLimit();
	
				// Make sure we always have at least 2 ticks
				maxTicks = Math.max(2, maxTicks);
	
				// To get a "nice" value for the tick spacing, we will use the appropriately named
				// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
				// for details.
	
				var spacing;
				var fixedStepSizeSet = (tickOpts.fixedStepSize && tickOpts.fixedStepSize > 0) || (tickOpts.stepSize && tickOpts.stepSize > 0);
				if (fixedStepSizeSet) {
					spacing = getValueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize);
				} else {
					var niceRange = helpers.niceNum(me.max - me.min, false);
					spacing = helpers.niceNum(niceRange / (maxTicks - 1), true);
				}
				var niceMin = Math.floor(me.min / spacing) * spacing;
				var niceMax = Math.ceil(me.max / spacing) * spacing;
				var numSpaces = (niceMax - niceMin) / spacing;
	
				// If very close to our rounded value, use it.
				if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
					numSpaces = Math.round(numSpaces);
				} else {
					numSpaces = Math.ceil(numSpaces);
				}
	
				// Put the values into the ticks array
				ticks.push(tickOpts.min !== undefined ? tickOpts.min : niceMin);
				for (var j = 1; j < numSpaces; ++j) {
					ticks.push(niceMin + (j * spacing));
				}
				ticks.push(tickOpts.max !== undefined ? tickOpts.max : niceMax);
	
				me.handleDirectionalChanges();
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsNumbers = me.ticks.slice();
				me.zeroLineIndex = me.ticks.indexOf(0);
	
				Chart.Scale.prototype.convertTicksToLabels.call(me);
			}
		});
	};


/***/ }),
/* 419 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		// Default config for a category scale
		var defaultConfig = {
			position: 'bottom'
		};
	
		var DatasetScale = Chart.Scale.extend({
			/**
			* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use tose
			* else fall back to data.labels
			* @private
			*/
			getLabels: function() {
				var data = this.chart.data;
				return (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
			},
			// Implement this so that
			determineDataLimits: function() {
				var me = this;
				var labels = me.getLabels();
				me.minIndex = 0;
				me.maxIndex = labels.length - 1;
				var findIndex;
	
				if (me.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = helpers.indexOf(labels, me.options.ticks.min);
					me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
				}
	
				if (me.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = helpers.indexOf(labels, me.options.ticks.max);
					me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
				}
	
				me.min = labels[me.minIndex];
				me.max = labels[me.maxIndex];
			},
	
			buildTicks: function() {
				var me = this;
				var labels = me.getLabels();
				// If we are viewing some subset of labels, slice the original array
				me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var isHorizontal = me.isHorizontal();
	
				if ((data.xLabels && isHorizontal) || (data.yLabels && !isHorizontal)) {
					return me.getRightValue(data.datasets[datasetIndex].data[index]);
				}
				return me.ticks[index];
			},
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index, datasetIndex, includeOffset) {
				var me = this;
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
	
				if (value !== undefined && isNaN(index)) {
					var labels = me.getLabels();
					var idx = labels.indexOf(value);
					index = idx !== -1 ? idx : index;
				}
	
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueWidth = innerWidth / offsetAmt;
					var widthOffset = (valueWidth * (index - me.minIndex)) + me.paddingLeft;
	
					if (me.options.gridLines.offsetGridLines && includeOffset || me.maxIndex === me.minIndex && includeOffset) {
						widthOffset += (valueWidth / 2);
					}
	
					return me.left + Math.round(widthOffset);
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				var valueHeight = innerHeight / offsetAmt;
				var heightOffset = (valueHeight * (index - me.minIndex)) + me.paddingTop;
	
				if (me.options.gridLines.offsetGridLines && includeOffset) {
					heightOffset += (valueHeight / 2);
				}
	
				return me.top + Math.round(heightOffset);
			},
			getPixelForTick: function(index, includeOffset) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null, includeOffset);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var value;
				var offsetAmt = Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
				var horz = me.isHorizontal();
				var innerDimension = horz ? me.width - (me.paddingLeft + me.paddingRight) : me.height - (me.paddingTop + me.paddingBottom);
				var valueDimension = innerDimension / offsetAmt;
	
				pixel -= horz ? me.left : me.top;
	
				if (me.options.gridLines.offsetGridLines) {
					pixel -= (valueDimension / 2);
				}
				pixel -= horz ? me.paddingLeft : me.paddingTop;
	
				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}
	
				return value;
			},
			getBasePixel: function() {
				return this.bottom;
			}
		});
	
		Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);
	
	};


/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
			ticks: {
				callback: function(tickValue, index, ticks) {
					// If we have lots of ticks, don't use the ones
					var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
					// If we have a number like 2.5 as the delta, figure out how many decimal places we need
					if (Math.abs(delta) > 1) {
						if (tickValue !== Math.floor(tickValue)) {
							// not an integer
							delta = tickValue - Math.floor(tickValue);
						}
					}
	
					var logDelta = helpers.log10(Math.abs(delta));
					var tickString = '';
	
					if (tickValue !== 0) {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					} else {
						tickString = '0'; // never show decimal places for 0
					}
	
					return tickString;
				}
			}
		};
	
		var LinearScale = Chart.LinearScaleBase.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
	
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// First Calculate the range
				me.min = null;
				me.max = null;
	
				if (opts.stacked) {
					var valuesPerType = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (valuesPerType[meta.type] === undefined) {
							valuesPerType[meta.type] = {
								positiveValues: [],
								negativeValues: []
							};
						}
	
						// Store these per type
						var positiveValues = valuesPerType[meta.type].positiveValues;
						var negativeValues = valuesPerType[meta.type].negativeValues;
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;
	
								if (opts.relativePoints) {
									positiveValues[index] = 100;
								} else if (value < 0) {
									negativeValues[index] += value;
								} else {
									positiveValues[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerType, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers.min(values);
						var maxVal = helpers.max(values);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
							});
						}
					});
				}
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				this.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var maxTicks;
				var me = this;
				var tickOpts = me.options.ticks;
	
				if (me.isHorizontal()) {
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, Chart.defaults.global.defaultFontSize);
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
				}
	
				return maxTicks;
			},
			// Called after the ticks are built. We need
			handleDirectionalChanges: function() {
				if (!this.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			// Utils
			getPixelForValue: function(value) {
				// This must be called after fit has been run so that
				// this.left, this.top, this.right, and this.bottom have been defined
				var me = this;
				var paddingLeft = me.paddingLeft;
				var paddingBottom = me.paddingBottom;
				var start = me.start;
	
				var rightValue = +me.getRightValue(value);
				var pixel;
				var innerDimension;
				var range = me.end - start;
	
				if (me.isHorizontal()) {
					innerDimension = me.width - (paddingLeft + me.paddingRight);
					pixel = me.left + (innerDimension / range * (rightValue - start));
					return Math.round(pixel + paddingLeft);
				}
				innerDimension = me.height - (me.paddingTop + paddingBottom);
				pixel = (me.bottom - paddingBottom) - (innerDimension / range * (rightValue - start));
				return Math.round(pixel);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var isHorizontal = me.isHorizontal();
				var paddingLeft = me.paddingLeft;
				var paddingBottom = me.paddingBottom;
				var innerDimension = isHorizontal ? me.width - (paddingLeft + me.paddingRight) : me.height - (me.paddingTop + paddingBottom);
				var offset = (isHorizontal ? pixel - me.left - paddingLeft : me.bottom - paddingBottom - pixel) / innerDimension;
				return me.start + ((me.end - me.start) * offset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticksAsNumbers[index]);
			}
		});
		Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);
	
	};


/***/ }),
/* 421 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
	
			// label settings
			ticks: {
				callback: function(value, index, arr) {
					var remain = value / (Math.pow(10, Math.floor(helpers.log10(value))));
	
					if (value === 0) {
						return '0';
					} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === arr.length - 1) {
						return value.toExponential();
					}
					return '';
				}
			}
		};
	
		var LogarithmicScale = Chart.Scale.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var getValueOrDefault = helpers.getValueOrDefault;
				var isHorizontal = me.isHorizontal();
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// Calculate Range
				me.min = null;
				me.max = null;
				me.minNotZero = null;
	
				if (opts.stacked) {
					var valuesPerType = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							if (valuesPerType[meta.type] === undefined) {
								valuesPerType[meta.type] = [];
							}
	
							helpers.each(dataset.data, function(rawValue, index) {
								var values = valuesPerType[meta.type];
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								values[index] = values[index] || 0;
	
								if (opts.relativePoints) {
									values[index] = 100;
								} else {
									// Don't need to split positive and negative since the log scale can't handle a 0 crossing
									values[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerType, function(valuesForType) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
	
								if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
									me.minNotZero = value;
								}
							});
						}
					});
				}
	
				me.min = getValueOrDefault(tickOpts.min, me.min);
				me.max = getValueOrDefault(tickOpts.max, me.max);
	
				if (me.min === me.max) {
					if (me.min !== 0 && me.min !== null) {
						me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
						me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
					} else {
						me.min = 1;
						me.max = 10;
					}
				}
			},
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				// Reset the ticks array. Later on, we will draw a grid line at these positions
				// The array simply contains the numerical value of the spots where ticks will be
				var ticks = me.ticks = [];
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
	
				var tickVal = getValueOrDefault(tickOpts.min, Math.pow(10, Math.floor(helpers.log10(me.min))));
	
				while (tickVal < me.max) {
					ticks.push(tickVal);
	
					var exp;
					var significand;
	
					if (tickVal === 0) {
						exp = Math.floor(helpers.log10(me.minNotZero));
						significand = Math.round(me.minNotZero / Math.pow(10, exp));
					} else {
						exp = Math.floor(helpers.log10(tickVal));
						significand = Math.floor(tickVal / Math.pow(10, exp)) + 1;
					}
	
					if (significand === 10) {
						significand = 1;
						++exp;
					}
	
					tickVal = significand * Math.pow(10, exp);
				}
	
				var lastTick = getValueOrDefault(tickOpts.max, tickVal);
				ticks.push(lastTick);
	
				if (!me.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					ticks.reverse();
				}
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickValues[index]);
			},
			getPixelForValue: function(value) {
				var me = this;
				var innerDimension;
				var pixel;
	
				var start = me.start;
				var newVal = +me.getRightValue(value);
				var range;
				var paddingTop = me.paddingTop;
				var paddingBottom = me.paddingBottom;
				var paddingLeft = me.paddingLeft;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				if (me.isHorizontal()) {
					range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
					if (newVal === 0) {
						pixel = me.left + paddingLeft;
					} else {
						innerDimension = me.width - (paddingLeft + me.paddingRight);
						pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
						pixel += paddingLeft;
					}
				} else {
					// Bottom - top since pixels increase downard on a screen
					innerDimension = me.height - (paddingTop + paddingBottom);
					if (start === 0 && !tickOpts.reverse) {
						range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
						if (newVal === start) {
							pixel = me.bottom - paddingBottom;
						} else if (newVal === me.minNotZero) {
							pixel = me.bottom - paddingBottom - innerDimension * 0.02;
						} else {
							pixel = me.bottom - paddingBottom - innerDimension * 0.02 - (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else if (me.end === 0 && tickOpts.reverse) {
						range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
						if (newVal === me.end) {
							pixel = me.top + paddingTop;
						} else if (newVal === me.minNotZero) {
							pixel = me.top + paddingTop + innerDimension * 0.02;
						} else {
							pixel = me.top + paddingTop + innerDimension * 0.02 + (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else {
						range = helpers.log10(me.end) - helpers.log10(start);
						innerDimension = me.height - (paddingTop + paddingBottom);
						pixel = (me.bottom - paddingBottom) - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var range = helpers.log10(me.end) - helpers.log10(me.start);
				var value, innerDimension;
	
				if (me.isHorizontal()) {
					innerDimension = me.width - (me.paddingLeft + me.paddingRight);
					value = me.start * Math.pow(10, (pixel - me.left - me.paddingLeft) * range / innerDimension);
				} else {  // todo: if start === 0
					innerDimension = me.height - (me.paddingTop + me.paddingBottom);
					value = Math.pow(10, (me.bottom - me.paddingBottom - pixel) * range / innerDimension) / me.start;
				}
				return value;
			}
		});
		Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
	
	};


/***/ }),
/* 422 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		var defaultConfig = {
			display: true,
	
			// Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			lineArc: false,
			position: 'chartArea',
	
			angleLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1
			},
	
			// label settings
			ticks: {
				// Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,
	
				// String - The colour of the label backdrop
				backdropColor: 'rgba(255,255,255,0.75)',
	
				// Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,
	
				// Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2
			},
	
			pointLabels: {
				// Number - Point label font size in pixels
				fontSize: 10,
	
				// Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};
	
		var LinearRadialScale = Chart.LinearScaleBase.extend({
			getValueCount: function() {
				return this.chart.data.labels.length;
			},
			setDimensions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				// Set the unconstrained dimension before label rotation
				me.width = me.maxWidth;
				me.height = me.maxHeight;
				me.xCenter = Math.round(me.width / 2);
				me.yCenter = Math.round(me.height / 2);
	
				var minSize = helpers.min([me.height, me.width]);
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				me.min = null;
				me.max = null;
	
	
				helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);
	
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}
	
							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				me.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var tickOpts = this.options.ticks;
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
			},
			convertTicksToLabels: function() {
				var me = this;
				Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);
	
				// Point labels
				me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				/*
				 * Right, this is really confusing and there is a lot of maths going on here
				 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
				 *
				 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
				 *
				 * Solution:
				 *
				 * We assume the radius of the polygon is half the size of the canvas at first
				 * at each index we check if the text overlaps.
				 *
				 * Where it does, we store that angle and that index.
				 *
				 * After finding the largest index and angle we calculate how much we need to remove
				 * from the shape radius to move the point inwards by that x.
				 *
				 * We average the left and right distances to get the maximum shape radius that can fit in the box
				 * along with labels.
				 *
				 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
				 * on each side, removing that from the size, halving it and adding the left x protrusion width.
				 *
				 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
				 * and position it in the most space efficient manner
				 *
				 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
				 */
	
				var pointLabels = this.options.pointLabels;
				var pointLabelFontSize = helpers.getValueOrDefault(pointLabels.fontSize, globalDefaults.defaultFontSize);
				var pointLabeFontStyle = helpers.getValueOrDefault(pointLabels.fontStyle, globalDefaults.defaultFontStyle);
				var pointLabeFontFamily = helpers.getValueOrDefault(pointLabels.fontFamily, globalDefaults.defaultFontFamily);
				var pointLabeFont = helpers.fontString(pointLabelFontSize, pointLabeFontStyle, pointLabeFontFamily);
	
				// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
				// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
				var largestPossibleRadius = helpers.min([(this.height / 2 - pointLabelFontSize - 5), this.width / 2]),
					pointPosition,
					i,
					textWidth,
					halfTextWidth,
					furthestRight = this.width,
					furthestRightIndex,
					furthestRightAngle,
					furthestLeft = 0,
					furthestLeftIndex,
					furthestLeftAngle,
					xProtrusionLeft,
					xProtrusionRight,
					radiusReductionRight,
					radiusReductionLeft;
				this.ctx.font = pointLabeFont;
	
				for (i = 0; i < this.getValueCount(); i++) {
					// 5px to space the text slightly out - similar to what we do in the draw function.
					pointPosition = this.getPointPosition(i, largestPossibleRadius);
					textWidth = this.ctx.measureText(this.pointLabels[i] ? this.pointLabels[i] : '').width + 5;
	
					// Add quarter circle to make degree 0 mean top of circle
					var angleRadians = this.getIndexAngle(i) + (Math.PI / 2);
					var angle = (angleRadians * 360 / (2 * Math.PI)) % 360;
	
					if (angle === 0 || angle === 180) {
						// At angle 0 and 180, we're at exactly the top/bottom
						// of the radar chart, so text will be aligned centrally, so we'll half it and compare
						// w/left and right text sizes
						halfTextWidth = textWidth / 2;
						if (pointPosition.x + halfTextWidth > furthestRight) {
							furthestRight = pointPosition.x + halfTextWidth;
							furthestRightIndex = i;
						}
						if (pointPosition.x - halfTextWidth < furthestLeft) {
							furthestLeft = pointPosition.x - halfTextWidth;
							furthestLeftIndex = i;
						}
					} else if (angle < 180) {
						// Less than half the values means we'll left align the text
						if (pointPosition.x + textWidth > furthestRight) {
							furthestRight = pointPosition.x + textWidth;
							furthestRightIndex = i;
						}
					// More than half the values means we'll right align the text
					} else if (pointPosition.x - textWidth < furthestLeft) {
						furthestLeft = pointPosition.x - textWidth;
						furthestLeftIndex = i;
					}
				}
	
				xProtrusionLeft = furthestLeft;
				xProtrusionRight = Math.ceil(furthestRight - this.width);
	
				furthestRightAngle = this.getIndexAngle(furthestRightIndex);
				furthestLeftAngle = this.getIndexAngle(furthestLeftIndex);
	
				radiusReductionRight = xProtrusionRight / Math.sin(furthestRightAngle + Math.PI / 2);
				radiusReductionLeft = xProtrusionLeft / Math.sin(furthestLeftAngle + Math.PI / 2);
	
				// Ensure we actually need to reduce the size of the chart
				radiusReductionRight = (helpers.isNumber(radiusReductionRight)) ? radiusReductionRight : 0;
				radiusReductionLeft = (helpers.isNumber(radiusReductionLeft)) ? radiusReductionLeft : 0;
	
				this.drawingArea = Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2);
				this.setCenterPoint(radiusReductionLeft, radiusReductionRight);
			},
			setCenterPoint: function(leftMovement, rightMovement) {
				var me = this;
				var maxRight = me.width - rightMovement - me.drawingArea,
					maxLeft = leftMovement + me.drawingArea;
	
				me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
				// Always vertically in the centre as the text height doesn't change
				me.yCenter = Math.round((me.height / 2) + me.top);
			},
	
			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / this.getValueCount();
				var startAngle = this.chart.options && this.chart.options.startAngle ?
					this.chart.options.startAngle :
					0;
	
				var startAngleRadians = startAngle * Math.PI * 2 / 360;
	
				// Start from the top instead of right, so remove a quarter of the circle
				return index * angleMultiplier - (Math.PI / 2) + startAngleRadians;
			},
			getDistanceFromCenterForValue: function(value) {
				var me = this;
	
				if (value === null) {
					return 0; // null always in center
				}
	
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = me.drawingArea / (me.max - me.min);
				if (me.options.reverse) {
					return (me.max - value) * scalingFactor;
				}
				return (value - me.min) * scalingFactor;
			},
			getPointPosition: function(index, distanceFromCenter) {
				var me = this;
				var thisAngle = me.getIndexAngle(index);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},
	
			getBasePosition: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPointPositionForValue(0,
					me.beginAtZero? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0);
			},
	
			draw: function() {
				var me = this;
				var opts = me.options;
				var gridLineOpts = opts.gridLines;
				var tickOpts = opts.ticks;
				var angleLineOpts = opts.angleLines;
				var pointLabelOpts = opts.pointLabels;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				if (opts.display) {
					var ctx = me.ctx;
	
					// Tick Font
					var tickFontSize = getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
					var tickFontStyle = getValueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
					var tickFontFamily = getValueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
					var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
					helpers.each(me.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || opts.reverse) {
							var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
							var yHeight = me.yCenter - yCenterOffset;
	
							// Draw circular lines around the scale
							if (gridLineOpts.display && index !== 0) {
								ctx.strokeStyle = helpers.getValueAtIndexOrDefault(gridLineOpts.color, index - 1);
								ctx.lineWidth = helpers.getValueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);
	
								if (opts.lineArc) {
									// Draw circular arcs between the points
									ctx.beginPath();
									ctx.arc(me.xCenter, me.yCenter, yCenterOffset, 0, Math.PI * 2);
									ctx.closePath();
									ctx.stroke();
								} else {
									// Draw straight lines connecting each index
									ctx.beginPath();
									for (var i = 0; i < me.getValueCount(); i++) {
										var pointPosition = me.getPointPosition(i, yCenterOffset);
										if (i === 0) {
											ctx.moveTo(pointPosition.x, pointPosition.y);
										} else {
											ctx.lineTo(pointPosition.x, pointPosition.y);
										}
									}
									ctx.closePath();
									ctx.stroke();
								}
							}
	
							if (tickOpts.display) {
								var tickFontColor = getValueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
								ctx.font = tickLabelFont;
	
								if (tickOpts.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = tickOpts.backdropColor;
									ctx.fillRect(
										me.xCenter - labelWidth / 2 - tickOpts.backdropPaddingX,
										yHeight - tickFontSize / 2 - tickOpts.backdropPaddingY,
										labelWidth + tickOpts.backdropPaddingX * 2,
										tickFontSize + tickOpts.backdropPaddingY * 2
									);
								}
	
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, me.xCenter, yHeight);
							}
						}
					});
	
					if (!opts.lineArc) {
						ctx.lineWidth = angleLineOpts.lineWidth;
						ctx.strokeStyle = angleLineOpts.color;
	
						var outerDistance = me.getDistanceFromCenterForValue(opts.reverse ? me.min : me.max);
	
						// Point Label Font
						var pointLabelFontSize = getValueOrDefault(pointLabelOpts.fontSize, globalDefaults.defaultFontSize);
						var pointLabeFontStyle = getValueOrDefault(pointLabelOpts.fontStyle, globalDefaults.defaultFontStyle);
						var pointLabeFontFamily = getValueOrDefault(pointLabelOpts.fontFamily, globalDefaults.defaultFontFamily);
						var pointLabeFont = helpers.fontString(pointLabelFontSize, pointLabeFontStyle, pointLabeFontFamily);
	
						for (var i = me.getValueCount() - 1; i >= 0; i--) {
							if (angleLineOpts.display) {
								var outerPosition = me.getPointPosition(i, outerDistance);
								ctx.beginPath();
								ctx.moveTo(me.xCenter, me.yCenter);
								ctx.lineTo(outerPosition.x, outerPosition.y);
								ctx.stroke();
								ctx.closePath();
							}
							// Extra 3px out for some label spacing
							var pointLabelPosition = me.getPointPosition(i, outerDistance + 5);
	
							// Keep this in loop since we may support array properties here
							var pointLabelFontColor = getValueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
							ctx.font = pointLabeFont;
							ctx.fillStyle = pointLabelFontColor;
	
							var pointLabels = me.pointLabels;
	
							// Add quarter circle to make degree 0 mean top of circle
							var angleRadians = this.getIndexAngle(i) + (Math.PI / 2);
							var angle = (angleRadians * 360 / (2 * Math.PI)) % 360;
	
							if (angle === 0 || angle === 180) {
								ctx.textAlign = 'center';
							} else if (angle < 180) {
								ctx.textAlign = 'left';
							} else {
								ctx.textAlign = 'right';
							}
	
							// Set the correct text baseline based on outer positioning
							if (angle === 90 || angle === 270) {
								ctx.textBaseline = 'middle';
							} else if (angle > 270 || angle < 90) {
								ctx.textBaseline = 'bottom';
							} else {
								ctx.textBaseline = 'top';
							}
	
							ctx.fillText(pointLabels[i] ? pointLabels[i] : '', pointLabelPosition.x, pointLabelPosition.y);
						}
					}
				}
			}
		});
		Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
	
	};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var moment = __webpack_require__(44);
	moment = typeof(moment) === 'function' ? moment : window.moment;
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var time = {
			units: [{
				name: 'millisecond',
				steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
			}, {
				name: 'second',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'minute',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'hour',
				steps: [1, 2, 3, 6, 12]
			}, {
				name: 'day',
				steps: [1, 2, 5]
			}, {
				name: 'week',
				maxStep: 4
			}, {
				name: 'month',
				maxStep: 3
			}, {
				name: 'quarter',
				maxStep: 4
			}, {
				name: 'year',
				maxStep: false
			}]
		};
	
		var defaultConfig = {
			position: 'bottom',
	
			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
				minUnit: 'millisecond',
	
				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					second: 'h:mm:ss a', // 11:20:01 AM
					minute: 'h:mm:ss a', // 11:20:01 AM
					hour: 'MMM D, hA', // Sept 4, 5PM
					day: 'll', // Sep 4 2015
					week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					month: 'MMM YYYY', // Sept 2015
					quarter: '[Q]Q - YYYY', // Q3
					year: 'YYYY' // 2015
				}
			},
			ticks: {
				autoSkip: false
			}
		};
	
		var TimeScale = Chart.Scale.extend({
			initialize: function() {
				if (!moment) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}
	
				Chart.Scale.prototype.initialize.call(this);
			},
			getLabelMoment: function(datasetIndex, index) {
				if (datasetIndex === null || index === null) {
					return null;
				}
	
				if (typeof this.labelMoments[datasetIndex] !== 'undefined') {
					return this.labelMoments[datasetIndex][index];
				}
	
				return null;
			},
			getLabelDiff: function(datasetIndex, index) {
				var me = this;
				if (datasetIndex === null || index === null) {
					return null;
				}
	
				if (me.labelDiffs === undefined) {
					me.buildLabelDiffs();
				}
	
				if (typeof me.labelDiffs[datasetIndex] !== 'undefined') {
					return me.labelDiffs[datasetIndex][index];
				}
	
				return null;
			},
			getMomentStartOf: function(tick) {
				var me = this;
				if (me.options.time.unit === 'week' && me.options.time.isoWeekday !== false) {
					return tick.clone().startOf('isoWeek').isoWeekday(me.options.time.isoWeekday);
				}
				return tick.clone().startOf(me.tickUnit);
			},
			determineDataLimits: function() {
				var me = this;
				me.labelMoments = [];
	
				// Only parse these once. If the dataset does not have data as x,y pairs, we will use
				// these
				var scaleLabelMoments = [];
				if (me.chart.data.labels && me.chart.data.labels.length > 0) {
					helpers.each(me.chart.data.labels, function(label) {
						var labelMoment = me.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (me.options.time.round) {
								labelMoment.startOf(me.options.time.round);
							}
							scaleLabelMoments.push(labelMoment);
						}
					}, me);
	
					me.firstTick = moment.min.call(me, scaleLabelMoments);
					me.lastTick = moment.max.call(me, scaleLabelMoments);
				} else {
					me.firstTick = null;
					me.lastTick = null;
				}
	
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var momentsForDataset = [];
					var datasetVisible = me.chart.isDatasetVisible(datasetIndex);
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null) {
						helpers.each(dataset.data, function(value) {
							var labelMoment = me.parseTime(me.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (me.options.time.round) {
									labelMoment.startOf(me.options.time.round);
								}
								momentsForDataset.push(labelMoment);
	
								if (datasetVisible) {
									// May have gone outside the scale ranges, make sure we keep the first and last ticks updated
									me.firstTick = me.firstTick !== null ? moment.min(me.firstTick, labelMoment) : labelMoment;
									me.lastTick = me.lastTick !== null ? moment.max(me.lastTick, labelMoment) : labelMoment;
								}
							}
						}, me);
					} else {
						// We have no labels. Use the ones from the scale
						momentsForDataset = scaleLabelMoments;
					}
	
					me.labelMoments.push(momentsForDataset);
				}, me);
	
				// Set these after we've done all the data
				if (me.options.time.min) {
					me.firstTick = me.parseTime(me.options.time.min);
				}
	
				if (me.options.time.max) {
					me.lastTick = me.parseTime(me.options.time.max);
				}
	
				// We will modify these, so clone for later
				me.firstTick = (me.firstTick || moment()).clone();
				me.lastTick = (me.lastTick || moment()).clone();
			},
			buildLabelDiffs: function() {
				var me = this;
				me.labelDiffs = [];
				var scaleLabelDiffs = [];
				// Parse common labels once
				if (me.chart.data.labels && me.chart.data.labels.length > 0) {
					helpers.each(me.chart.data.labels, function(label) {
						var labelMoment = me.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (me.options.time.round) {
								labelMoment.startOf(me.options.time.round);
							}
							scaleLabelDiffs.push(labelMoment.diff(me.firstTick, me.tickUnit, true));
						}
					}, me);
				}
	
				helpers.each(me.chart.data.datasets, function(dataset) {
					var diffsForDataset = [];
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null) {
						helpers.each(dataset.data, function(value) {
							var labelMoment = me.parseTime(me.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (me.options.time.round) {
									labelMoment.startOf(me.options.time.round);
								}
								diffsForDataset.push(labelMoment.diff(me.firstTick, me.tickUnit, true));
							}
						}, me);
					} else {
						// We have no labels. Use common ones
						diffsForDataset = scaleLabelDiffs;
					}
	
					me.labelDiffs.push(diffsForDataset);
				}, me);
			},
			buildTicks: function() {
				var me = this;
	
				me.ctx.save();
				var tickFontSize = helpers.getValueOrDefault(me.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(me.options.ticks.fontStyle, Chart.defaults.global.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(me.options.ticks.fontFamily, Chart.defaults.global.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				me.ctx.font = tickLabelFont;
	
				me.ticks = [];
				me.unitScale = 1; // How much we scale the unit by, ie 2 means 2x unit per step
				me.scaleSizeInUnits = 0; // How large the scale is in the base unit (seconds, minutes, etc)
	
				// Set unit override if applicable
				if (me.options.time.unit) {
					me.tickUnit = me.options.time.unit || 'day';
					me.displayFormat = me.options.time.displayFormats[me.tickUnit];
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, 1);
				} else {
					// Determine the smallest needed unit of the time
					var innerWidth = me.isHorizontal() ? me.width - (me.paddingLeft + me.paddingRight) : me.height - (me.paddingTop + me.paddingBottom);
	
					// Crude approximation of what the label length might be
					var tempFirstLabel = me.tickFormatFunction(me.firstTick, 0, []);
					var tickLabelWidth = me.ctx.measureText(tempFirstLabel).width;
					var cosRotation = Math.cos(helpers.toRadians(me.options.ticks.maxRotation));
					var sinRotation = Math.sin(helpers.toRadians(me.options.ticks.maxRotation));
					tickLabelWidth = (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
					var labelCapacity = innerWidth / (tickLabelWidth);
	
					// Start as small as possible
					me.tickUnit = me.options.time.minUnit;
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					me.displayFormat = me.options.time.displayFormats[me.tickUnit];
	
					var unitDefinitionIndex = 0;
					var unitDefinition = time.units[unitDefinitionIndex];
	
					// While we aren't ideal and we don't have units left
					while (unitDefinitionIndex < time.units.length) {
						// Can we scale this unit. If `false` we can scale infinitely
						me.unitScale = 1;
	
						if (helpers.isArray(unitDefinition.steps) && Math.ceil(me.scaleSizeInUnits / labelCapacity) < helpers.max(unitDefinition.steps)) {
							// Use one of the prefedined steps
							for (var idx = 0; idx < unitDefinition.steps.length; ++idx) {
								if (unitDefinition.steps[idx] >= Math.ceil(me.scaleSizeInUnits / labelCapacity)) {
									me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, unitDefinition.steps[idx]);
									break;
								}
							}
	
							break;
						} else if ((unitDefinition.maxStep === false) || (Math.ceil(me.scaleSizeInUnits / labelCapacity) < unitDefinition.maxStep)) {
							// We have a max step. Scale this unit
							me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, Math.ceil(me.scaleSizeInUnits / labelCapacity));
							break;
						} else {
							// Move to the next unit up
							++unitDefinitionIndex;
							unitDefinition = time.units[unitDefinitionIndex];
	
							me.tickUnit = unitDefinition.name;
							var leadingUnitBuffer = me.firstTick.diff(me.getMomentStartOf(me.firstTick), me.tickUnit, true);
							var trailingUnitBuffer = me.getMomentStartOf(me.lastTick.clone().add(1, me.tickUnit)).diff(me.lastTick, me.tickUnit, true);
							me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true) + leadingUnitBuffer + trailingUnitBuffer;
							me.displayFormat = me.options.time.displayFormats[unitDefinition.name];
						}
					}
				}
	
				var roundedStart;
	
				// Only round the first tick if we have no hard minimum
				if (!me.options.time.min) {
					me.firstTick = me.getMomentStartOf(me.firstTick);
					roundedStart = me.firstTick;
				} else {
					roundedStart = me.getMomentStartOf(me.firstTick);
				}
	
				// Only round the last tick if we have no hard maximum
				if (!me.options.time.max) {
					var roundedEnd = me.getMomentStartOf(me.lastTick);
					var delta = roundedEnd.diff(me.lastTick, me.tickUnit, true);
					if (delta < 0) {
						// Do not use end of because we need me to be in the next time unit
						me.lastTick = me.getMomentStartOf(me.lastTick.add(1, me.tickUnit));
					} else if (delta >= 0) {
						me.lastTick = roundedEnd;
					}
	
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
				}
	
				// Tick displayFormat override
				if (me.options.time.displayFormat) {
					me.displayFormat = me.options.time.displayFormat;
				}
	
				// first tick. will have been rounded correctly if options.time.min is not specified
				me.ticks.push(me.firstTick.clone());
	
				// For every unit in between the first and last moment, create a moment and add it to the ticks tick
				for (var i = 1; i <= me.scaleSizeInUnits; ++i) {
					var newTick = roundedStart.clone().add(i, me.tickUnit);
	
					// Are we greater than the max time
					if (me.options.time.max && newTick.diff(me.lastTick, me.tickUnit, true) >= 0) {
						break;
					}
	
					if (i % me.unitScale === 0) {
						me.ticks.push(newTick);
					}
				}
	
				// Always show the right tick
				var diff = me.ticks[me.ticks.length - 1].diff(me.lastTick, me.tickUnit);
				if (diff !== 0 || me.scaleSizeInUnits === 0) {
					// this is a weird case. If the <max> option is the same as the end option, we can't just diff the times because the tick was created from the roundedStart
					// but the last tick was not rounded.
					if (me.options.time.max) {
						me.ticks.push(me.lastTick.clone());
						me.scaleSizeInUnits = me.lastTick.diff(me.ticks[0], me.tickUnit, true);
					} else {
						me.ticks.push(me.lastTick.clone());
						me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					}
				}
	
				me.ctx.restore();
	
				// Invalidate label diffs cache
				me.labelDiffs = undefined;
			},
			// Get tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var label = me.chart.data.labels && index < me.chart.data.labels.length ? me.chart.data.labels[index] : '';
	
				if (typeof me.chart.data.datasets[datasetIndex].data[0] === 'object') {
					label = me.getRightValue(me.chart.data.datasets[datasetIndex].data[index]);
				}
	
				// Format nicely
				if (me.options.time.tooltipFormat) {
					label = me.parseTime(label).format(me.options.time.tooltipFormat);
				}
	
				return label;
			},
			// Function to format an individual tick mark
			tickFormatFunction: function(tick, index, ticks) {
				var formattedTick = tick.format(this.displayFormat);
				var tickOpts = this.options.ticks;
				var callback = helpers.getValueOrDefault(tickOpts.callback, tickOpts.userCallback);
	
				if (callback) {
					return callback(formattedTick, index, ticks);
				}
				return formattedTick;
			},
			convertTicksToLabels: function() {
				var me = this;
				me.tickMoments = me.ticks;
				me.ticks = me.ticks.map(me.tickFormatFunction, me);
			},
			getPixelForValue: function(value, index, datasetIndex) {
				var me = this;
				var offset = null;
				if (index !== undefined && datasetIndex !== undefined) {
					offset = me.getLabelDiff(datasetIndex, index);
				}
	
				if (offset === null) {
					if (!value || !value.isValid) {
						// not already a moment object
						value = me.parseTime(me.getRightValue(value));
					}
					if (value && value.isValid && value.isValid()) {
						offset = value.diff(me.firstTick, me.tickUnit, true);
					}
				}
	
				if (offset !== null) {
					var decimal = offset !== 0 ? offset / me.scaleSizeInUnits : offset;
	
					if (me.isHorizontal()) {
						var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
						var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
						return me.left + Math.round(valueOffset);
					}
					var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
					var heightOffset = (innerHeight * decimal) + me.paddingTop;
	
					return me.top + Math.round(heightOffset);
				}
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickMoments[index], null, null);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var innerDimension = me.isHorizontal() ? me.width - (me.paddingLeft + me.paddingRight) : me.height - (me.paddingTop + me.paddingBottom);
				var offset = (pixel - (me.isHorizontal() ? me.left + me.paddingLeft : me.top + me.paddingTop)) / innerDimension;
				offset *= me.scaleSizeInUnits;
				return me.firstTick.clone().add(moment.duration(offset, me.tickUnit).asSeconds(), 'seconds');
			},
			parseTime: function(label) {
				var me = this;
				if (typeof me.options.time.parser === 'string') {
					return moment(label, me.options.time.parser);
				}
				if (typeof me.options.time.parser === 'function') {
					return me.options.time.parser(label);
				}
				// Date objects
				if (typeof label.getMonth === 'function' || typeof label === 'number') {
					return moment(label);
				}
				// Moment support
				if (label.isValid && label.isValid()) {
					return label;
				}
				// Custom parsing (return an instance of moment)
				if (typeof me.options.time.format !== 'string' && me.options.time.format.call) {
					console.warn('options.time.format is deprecated and replaced by options.time.parser. See http://nnnick.github.io/Chart.js/docs-v2/#scales-time-scale');
					return me.options.time.format(label);
				}
				// Moment format parsing
				return moment(label, me.options.time.format);
			}
		});
		Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
	
	};


/***/ }),
/* 424 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
	
					// Specific to Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}],
				yAxes: [{
					type: 'linear'
				}]
			}
		};
	
		Chart.controllers.bar = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Rectangle,
	
			initialize: function(chart, datasetIndex) {
				Chart.DatasetController.prototype.initialize.call(this, chart, datasetIndex);
	
				// Use this to indicate that this is a bar dataset.
				this.getMeta().bar = true;
			},
	
			// Get the number of datasets that display bars. We use this to correctly calculate the bar width
			getBarCount: function() {
				var me = this;
				var barCount = 0;
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var meta = me.chart.getDatasetMeta(datasetIndex);
					if (meta.bar && me.chart.isDatasetVisible(datasetIndex)) {
						++barCount;
					}
				}, me);
				return barCount;
			},
	
			update: function(reset) {
				var me = this;
				helpers.each(me.getMeta().data, function(rectangle, index) {
					me.updateElement(rectangle, index, reset);
				}, me);
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var scaleBase = yScale.getBasePixel();
				var rectangleElementOptions = me.chart.options.elements.rectangle;
				var custom = rectangle.custom || {};
				var dataset = me.getDataset();
	
				helpers.extend(rectangle, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: me.calculateBarX(index, me.index),
						y: reset ? scaleBase : me.calculateBarY(index, me.index),
	
						// Tooltip
						label: me.chart.data.labels[index],
						datasetLabel: dataset.label,
	
						// Appearance
						base: reset ? scaleBase : me.calculateBarBase(me.index, index),
						width: me.calculateBarWidth(index),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor),
						borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleElementOptions.borderSkipped,
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth)
					}
				});
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var base = 0;
	
				if (yScale.options.stacked) {
					var chart = me.chart;
					var datasets = chart.data.datasets;
					var value = Number(datasets[datasetIndex].data[index]);
	
					for (var i = 0; i < datasetIndex; i++) {
						var currentDs = datasets[i];
						var currentDsMeta = chart.getDatasetMeta(i);
						if (currentDsMeta.bar && currentDsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var currentVal = Number(currentDs.data[index]);
							base += value < 0 ? Math.min(currentVal, 0) : Math.max(currentVal, 0);
						}
					}
	
					return yScale.getPixelForValue(base);
				}
	
				return yScale.getBasePixel();
			},
	
			getRuler: function(index) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var datasetCount = me.getBarCount();
	
				var tickWidth;
	
				if (xScale.options.type === 'category') {
					tickWidth = xScale.getPixelForTick(index + 1) - xScale.getPixelForTick(index);
				} else {
					// Average width
					tickWidth = xScale.width / xScale.ticks.length;
				}
				var categoryWidth = tickWidth * xScale.options.categoryPercentage;
				var categorySpacing = (tickWidth - (tickWidth * xScale.options.categoryPercentage)) / 2;
				var fullBarWidth = categoryWidth / datasetCount;
	
				if (xScale.ticks.length !== me.chart.data.labels.length) {
					var perc = xScale.ticks.length / me.chart.data.labels.length;
					fullBarWidth = fullBarWidth * perc;
				}
	
				var barWidth = fullBarWidth * xScale.options.barPercentage;
				var barSpacing = fullBarWidth - (fullBarWidth * xScale.options.barPercentage);
	
				return {
					datasetCount: datasetCount,
					tickWidth: tickWidth,
					categoryWidth: categoryWidth,
					categorySpacing: categorySpacing,
					fullBarWidth: fullBarWidth,
					barWidth: barWidth,
					barSpacing: barSpacing
				};
			},
	
			calculateBarWidth: function(index) {
				var xScale = this.getScaleForId(this.getMeta().xAxisID);
				if (xScale.options.barThickness) {
					return xScale.options.barThickness;
				}
				var ruler = this.getRuler(index);
				return xScale.options.stacked ? ruler.categoryWidth : ruler.barWidth;
			},
	
			// Get bar index from the given dataset index accounting for the fact that not all bars are visible
			getBarIndex: function(datasetIndex) {
				var barIndex = 0;
				var meta, j;
	
				for (j = 0; j < datasetIndex; ++j) {
					meta = this.chart.getDatasetMeta(j);
					if (meta.bar && this.chart.isDatasetVisible(j)) {
						++barIndex;
					}
				}
	
				return barIndex;
			},
	
			calculateBarX: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var barIndex = me.getBarIndex(datasetIndex);
	
				var ruler = me.getRuler(index);
				var leftTick = xScale.getPixelForValue(null, index, datasetIndex, me.chart.isCombo);
				leftTick -= me.chart.isCombo ? (ruler.tickWidth / 2) : 0;
	
				if (xScale.options.stacked) {
					return leftTick + (ruler.categoryWidth / 2) + ruler.categorySpacing;
				}
	
				return leftTick +
					(ruler.barWidth / 2) +
					ruler.categorySpacing +
					(ruler.barWidth * barIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * barIndex);
			},
	
			calculateBarY: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var value = Number(me.getDataset().data[index]);
	
				if (yScale.options.stacked) {
	
					var sumPos = 0,
						sumNeg = 0;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = me.chart.data.datasets[i];
						var dsMeta = me.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.yAxisID === yScale.id && me.chart.isDatasetVisible(i)) {
							var stackedVal = Number(ds.data[index]);
							if (stackedVal < 0) {
								sumNeg += stackedVal || 0;
							} else {
								sumPos += stackedVal || 0;
							}
						}
					}
	
					if (value < 0) {
						return yScale.getPixelForValue(sumNeg + value);
					}
					return yScale.getPixelForValue(sumPos + value);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			draw: function(ease) {
				var me = this;
				var easingDecimal = ease || 1;
				helpers.each(me.getMeta().data, function(rectangle, index) {
					var d = me.getDataset().data[index];
					if (d !== null && d !== undefined && !isNaN(d)) {
						rectangle.transition(easingDecimal).draw();
					}
				}, me);
			},
	
			setHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
	
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				var rectangleElementOptions = this.chart.options.elements.rectangle;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
			}
	
		});
	
	
		// including horizontalBar in the bar file, instead of a file of its own
		// it extends bar (like pie extends doughnut)
		Chart.defaults.horizontalBar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'linear',
					position: 'bottom'
				}],
				yAxes: [{
					position: 'left',
					type: 'category',
	
					// Specific to Horizontal Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}]
			},
			elements: {
				rectangle: {
					borderSkipped: 'left'
				}
			},
			tooltips: {
				callbacks: {
					title: function(tooltipItems, data) {
						// Pick first xLabel for now
						var title = '';
	
						if (tooltipItems.length > 0) {
							if (tooltipItems[0].yLabel) {
								title = tooltipItems[0].yLabel;
							} else if (data.labels.length > 0 && tooltipItems[0].index < data.labels.length) {
								title = data.labels[tooltipItems[0].index];
							}
						}
	
						return title;
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						return datasetLabel + ': ' + tooltipItem.xLabel;
					}
				}
			}
		};
	
		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var scaleBase = xScale.getBasePixel();
				var custom = rectangle.custom || {};
				var dataset = me.getDataset();
				var rectangleElementOptions = me.chart.options.elements.rectangle;
	
				helpers.extend(rectangle, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: reset ? scaleBase : me.calculateBarX(index, me.index),
						y: me.calculateBarY(index, me.index),
	
						// Tooltip
						label: me.chart.data.labels[index],
						datasetLabel: dataset.label,
	
						// Appearance
						base: reset ? scaleBase : me.calculateBarBase(me.index, index),
						height: me.calculateBarHeight(index),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor),
						borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleElementOptions.borderSkipped,
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth)
					},
	
					draw: function() {
						var ctx = this._chart.ctx;
						var vm = this._view;
	
						var halfHeight = vm.height / 2,
							topY = vm.y - halfHeight,
							bottomY = vm.y + halfHeight,
							right = vm.base - (vm.base - vm.x),
							halfStroke = vm.borderWidth / 2;
	
						// Canvas doesn't allow us to stroke inside the width so we can
						// adjust the sizes to fit if we're setting a stroke on the line
						if (vm.borderWidth) {
							topY += halfStroke;
							bottomY -= halfStroke;
							right += halfStroke;
						}
	
						ctx.beginPath();
	
						ctx.fillStyle = vm.backgroundColor;
						ctx.strokeStyle = vm.borderColor;
						ctx.lineWidth = vm.borderWidth;
	
						// Corner points, from bottom-left to bottom-right clockwise
						// | 1 2 |
						// | 0 3 |
						var corners = [
							[vm.base, bottomY],
							[vm.base, topY],
							[right, topY],
							[right, bottomY]
						];
	
						// Find first (starting) corner with fallback to 'bottom'
						var borders = ['bottom', 'left', 'top', 'right'];
						var startCorner = borders.indexOf(vm.borderSkipped, 0);
						if (startCorner === -1) {
							startCorner = 0;
						}
	
						function cornerAt(cornerIndex) {
							return corners[(startCorner + cornerIndex) % 4];
						}
	
						// Draw rectangle from 'startCorner'
						ctx.moveTo.apply(ctx, cornerAt(0));
						for (var i = 1; i < 4; i++) {
							ctx.lineTo.apply(ctx, cornerAt(i));
						}
	
						ctx.fill();
						if (vm.borderWidth) {
							ctx.stroke();
						}
					},
	
					inRange: function(mouseX, mouseY) {
						var vm = this._view;
						var inRange = false;
	
						if (vm) {
							if (vm.x < vm.base) {
								inRange = (mouseY >= vm.y - vm.height / 2 && mouseY <= vm.y + vm.height / 2) && (mouseX >= vm.x && mouseX <= vm.base);
							} else {
								inRange = (mouseY >= vm.y - vm.height / 2 && mouseY <= vm.y + vm.height / 2) && (mouseX >= vm.base && mouseX <= vm.x);
							}
						}
	
						return inRange;
					}
				});
	
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var base = 0;
	
				if (xScale.options.stacked) {
					var chart = me.chart;
					var datasets = chart.data.datasets;
					var value = Number(datasets[datasetIndex].data[index]);
	
					for (var i = 0; i < datasetIndex; i++) {
						var currentDs = datasets[i];
						var currentDsMeta = chart.getDatasetMeta(i);
						if (currentDsMeta.bar && currentDsMeta.xAxisID === xScale.id && chart.isDatasetVisible(i)) {
							var currentVal = Number(currentDs.data[index]);
							base += value < 0 ? Math.min(currentVal, 0) : Math.max(currentVal, 0);
						}
					}
	
					return xScale.getPixelForValue(base);
				}
	
				return xScale.getBasePixel();
			},
	
			getRuler: function(index) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var datasetCount = me.getBarCount();
	
				var tickHeight;
				if (yScale.options.type === 'category') {
					tickHeight = yScale.getPixelForTick(index + 1) - yScale.getPixelForTick(index);
				} else {
					// Average width
					tickHeight = yScale.width / yScale.ticks.length;
				}
				var categoryHeight = tickHeight * yScale.options.categoryPercentage;
				var categorySpacing = (tickHeight - (tickHeight * yScale.options.categoryPercentage)) / 2;
				var fullBarHeight = categoryHeight / datasetCount;
	
				if (yScale.ticks.length !== me.chart.data.labels.length) {
					var perc = yScale.ticks.length / me.chart.data.labels.length;
					fullBarHeight = fullBarHeight * perc;
				}
	
				var barHeight = fullBarHeight * yScale.options.barPercentage;
				var barSpacing = fullBarHeight - (fullBarHeight * yScale.options.barPercentage);
	
				return {
					datasetCount: datasetCount,
					tickHeight: tickHeight,
					categoryHeight: categoryHeight,
					categorySpacing: categorySpacing,
					fullBarHeight: fullBarHeight,
					barHeight: barHeight,
					barSpacing: barSpacing
				};
			},
	
			calculateBarHeight: function(index) {
				var me = this;
				var yScale = me.getScaleForId(me.getMeta().yAxisID);
				if (yScale.options.barThickness) {
					return yScale.options.barThickness;
				}
				var ruler = me.getRuler(index);
				return yScale.options.stacked ? ruler.categoryHeight : ruler.barHeight;
			},
	
			calculateBarX: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var value = Number(me.getDataset().data[index]);
	
				if (xScale.options.stacked) {
	
					var sumPos = 0,
						sumNeg = 0;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = me.chart.data.datasets[i];
						var dsMeta = me.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.xAxisID === xScale.id && me.chart.isDatasetVisible(i)) {
							var stackedVal = Number(ds.data[index]);
							if (stackedVal < 0) {
								sumNeg += stackedVal || 0;
							} else {
								sumPos += stackedVal || 0;
							}
						}
					}
	
					if (value < 0) {
						return xScale.getPixelForValue(sumNeg + value);
					}
					return xScale.getPixelForValue(sumPos + value);
				}
	
				return xScale.getPixelForValue(value);
			},
	
			calculateBarY: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var barIndex = me.getBarIndex(datasetIndex);
	
				var ruler = me.getRuler(index);
				var topTick = yScale.getPixelForValue(null, index, datasetIndex, me.chart.isCombo);
				topTick -= me.chart.isCombo ? (ruler.tickHeight / 2) : 0;
	
				if (yScale.options.stacked) {
					return topTick + (ruler.categoryHeight / 2) + ruler.categorySpacing;
				}
	
				return topTick +
					(ruler.barHeight / 2) +
					ruler.categorySpacing +
					(ruler.barHeight * barIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * barIndex);
			}
		});
	};


/***/ }),
/* 425 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bubble = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // bubble should probably use a linear scale by default
					position: 'bottom',
					id: 'x-axis-0' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-0'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						var dataPoint = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return datasetLabel + ': (' + dataPoint.x + ', ' + dataPoint.y + ', ' + dataPoint.r + ')';
					}
				}
			}
		};
	
		Chart.controllers.bubble = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data;
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				});
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
	
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var data = dataset.data[index];
				var pointElementOptions = me.chart.options.elements.point;
				var dsIndex = me.index;
	
				helpers.extend(point, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: dsIndex,
					_index: index,
	
					// Desired view properties
					_model: {
						x: reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex, me.chart.isCombo),
						y: reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex),
						// Appearance
						radius: reset ? 0 : custom.radius ? custom.radius : me.getRadius(data),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				// Trick to reset the styles of the point
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, pointElementOptions);
	
				var model = point._model;
				model.skip = custom.skip ? custom.skip : (isNaN(model.x) || isNaN(model.y));
	
				point.pivot();
			},
	
			getRadius: function(value) {
				return value.r || this.chart.options.elements.point.radius;
			},
	
			setHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.setHoverStyle.call(me, point);
	
				// Radius
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
				model.radius = custom.hoverRadius ? custom.hoverRadius : (helpers.getValueAtIndexOrDefault(dataset.hoverRadius, index, me.chart.options.elements.point.hoverRadius)) + me.getRadius(dataset.data[index]);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, me.chart.options.elements.point);
	
				var dataVal = me.chart.data.datasets[point._datasetIndex].data[point._index];
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.radius ? custom.radius : me.getRadius(dataVal);
			}
		});
	};


/***/ }),
/* 426 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			defaults = Chart.defaults;
	
		defaults.doughnut = {
			animation: {
				// Boolean - Whether we animate the rotation of the Doughnut
				animateRotate: true,
				// Boolean - Whether we animate scaling the Doughnut from the centre
				animateScale: false
			},
			aspectRatio: 1,
			hover: {
				mode: 'single'
			},
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc && arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						// toggle visibility of index if exists
						if (meta.data[index]) {
							meta.data[index].hidden = !meta.data[index].hidden;
						}
					}
	
					chart.update();
				}
			},
	
			// The percentage of the chart that we cut out of the middle.
			cutoutPercentage: 50,
	
			// The rotation of the chart, where the first data arc begins.
			rotation: Math.PI * -0.5,
	
			// The total circumference of the chart.
			circumference: Math.PI * 2.0,
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
					}
				}
			}
		};
	
		defaults.pie = helpers.clone(defaults.doughnut);
		helpers.extend(defaults.pie, {
			cutoutPercentage: 0
		});
	
	
		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function(datasetIndex) {
				var ringIndex = 0;
	
				for (var j = 0; j < datasetIndex; ++j) {
					if (this.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}
	
				return ringIndex;
			},
	
			update: function(reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					arcOpts = opts.elements.arc,
					availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth,
					availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth,
					minSize = Math.min(availableWidth, availableHeight),
					offset = {
						x: 0,
						y: 0
					},
					meta = me.getMeta(),
					cutoutPercentage = opts.cutoutPercentage,
					circumference = opts.circumference;
	
				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (circumference < Math.PI * 2.0) {
					var startAngle = opts.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && 0 <= endAngle) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}
	
				chart.borderWidth = me.getMaxBorderWidth(meta.data);
				chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
				chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
				chart.offsetX = offset.x * chart.outerRadius;
				chart.offsetY = offset.y * chart.outerRadius;
	
				meta.total = me.calculateTotal();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					animationOpts = opts.animation,
					centerX = (chartArea.left + chartArea.right) / 2,
					centerY = (chartArea.top + chartArea.bottom) / 2,
					startAngle = opts.rotation, // non reset case handled later
					endAngle = opts.rotation, // non reset case handled later
					dataset = me.getDataset(),
					circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI)),
					innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius,
					outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius,
					valueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: centerX + chart.offsetX,
						y: centerY + chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
						label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					}
				});
	
				var model = arc._model;
				// Resets the visual styles
				this.removeHoverStyle(arc);
	
				// Set correct angles if not resetting
				if (!reset || !animationOpts.animateRotate) {
					if (index === 0) {
						model.startAngle = opts.rotation;
					} else {
						model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
					}
	
					model.endAngle = model.startAngle + model.circumference;
				}
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;
	
				helpers.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});
	
				/* if (total === 0) {
					total = NaN;
				}*/
	
				return total;
			},
	
			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (value / total);
				}
				return 0;
			},
	
			// gets the max border or hover width to properly scale pie charts
			getMaxBorderWidth: function(elements) {
				var max = 0,
					index = this.index,
					length = elements.length,
					borderWidth,
					hoverWidth;
	
				for (var i = 0; i < length; i++) {
					borderWidth = elements[i]._model ? elements[i]._model.borderWidth : 0;
					hoverWidth = elements[i]._chart ? elements[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
				return max;
			}
		});
	};


/***/ }),
/* 427 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.line = {
			showLines: true,
			spanGaps: false,
	
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
					id: 'x-axis-0'
				}],
				yAxes: [{
					type: 'linear',
					id: 'y-axis-0'
				}]
			}
		};
	
		function lineEnabled(dataset, options) {
			return helpers.getValueOrDefault(dataset.showLine, options.showLines);
		}
	
		Chart.controllers.line = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			addElementAndReset: function(index) {
				var me = this;
				var options = me.chart.options;
				var meta = me.getMeta();
	
				Chart.DatasetController.prototype.addElementAndReset.call(me, index);
	
				// Make sure bezier control points are updated
				if (lineEnabled(me.getDataset(), options) && meta.dataset._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
			},
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data || [];
				var options = me.chart.options;
				var lineElementOptions = options.elements.line;
				var scale = me.getScaleForId(meta.yAxisID);
				var i, ilen, custom;
				var dataset = me.getDataset();
				var showLine = lineEnabled(dataset, options);
	
				// Update Line
				if (showLine) {
					custom = line.custom || {};
	
					// Compatibility: If the properties are defined with only the old name, use those values
					if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
						dataset.lineTension = dataset.tension;
					}
	
					// Utility
					line._scale = scale;
					line._datasetIndex = me.index;
					// Data
					line._children = points;
					// Model
					line._model = {
						// Appearance
						// The default behavior of lines is to break at null values, according
						// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
						// This option gives linse the ability to span gaps
						spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						steppedLine: custom.steppedLine ? custom.steppedLine : helpers.getValueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
						cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.getValueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scale.getBasePixel()
					};
	
					line.pivot();
				}
	
				// Update Points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					me.updateElement(points[i], i, reset);
				}
	
				if (showLine && line._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
	
				// Now pivot the point for animation
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].pivot();
				}
			},
	
			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.backgroundColor) {
					backgroundColor = custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}
	
				return backgroundColor;
			},
	
			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderColor) {
					borderColor = custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}
	
				return borderColor;
			},
	
			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderWidth) {
					borderWidth = custom.borderWidth;
				} else if (dataset.pointBorderWidth) {
					borderWidth = helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (dataset.borderWidth) {
					borderWidth = dataset.borderWidth;
				}
	
				return borderWidth;
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var datasetIndex = me.index;
				var value = dataset.data[index];
				var yScale = me.getScaleForId(meta.yAxisID);
				var xScale = me.getScaleForId(meta.xAxisID);
				var pointOptions = me.chart.options.elements.point;
				var x, y;
				var labels = me.chart.data.labels || [];
				var includeOffset = (labels.length === 1 || dataset.data.length === 1) || me.chart.isCombo;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex, includeOffset);
				y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
				// Utility
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = datasetIndex;
				point._index = index;
	
				// Desired view properties
				point._model = {
					x: x,
					y: y,
					skip: custom.skip || isNaN(x) || isNaN(y),
					// Appearance
					radius: custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
					pointStyle: custom.pointStyle || helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
					backgroundColor: me.getPointBackgroundColor(point, index),
					borderColor: me.getPointBorderColor(point, index),
					borderWidth: me.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
					// Tooltip
					hitRadius: custom.hitRadius || helpers.getValueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
				};
			},
	
			calculatePointY: function(value, index, datasetIndex) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var sumPos = 0;
				var sumNeg = 0;
				var i, ds, dsMeta;
	
				if (yScale.options.stacked) {
					for (i = 0; i < datasetIndex; i++) {
						ds = chart.data.datasets[i];
						dsMeta = chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
							if (stackedRightValue < 0) {
								sumNeg += stackedRightValue || 0;
							} else {
								sumPos += stackedRightValue || 0;
							}
						}
					}
	
					var rightValue = Number(yScale.getRightValue(value));
					if (rightValue < 0) {
						return yScale.getPixelForValue(sumNeg + rightValue);
					}
					return yScale.getPixelForValue(sumPos + rightValue);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			updateBezierControlPoints: function() {
				var me = this;
				var meta = me.getMeta();
				var area = me.chart.chartArea;
				var points = (meta.data || []);
				var i, ilen, point, model, controlPoints;
	
				// Only consider points that are drawn in case the spanGaps option is used
				if (meta.dataset._model.spanGaps) {
					points = points.filter(function(pt) {
						return !pt._model.skip;
					});
				}
	
				function capControlPoint(pt, min, max) {
					return Math.max(Math.min(pt, max), min);
				}
	
				if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
					helpers.splineCurveMonotone(points);
				} else {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						point = points[i];
						model = point._model;
						controlPoints = helpers.splineCurve(
							helpers.previousItem(points, i)._model,
							model,
							helpers.nextItem(points, i)._model,
							meta.dataset._model.tension
						);
						model.controlPointPreviousX = controlPoints.previous.x;
						model.controlPointPreviousY = controlPoints.previous.y;
						model.controlPointNextX = controlPoints.next.x;
						model.controlPointNextY = controlPoints.next.y;
					}
				}
	
				if (me.chart.options.elements.line.capBezierPoints) {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						model = points[i]._model;
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			},
	
			draw: function(ease) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data || [];
				var easingDecimal = ease || 1;
				var i, ilen;
	
				// Transition Point Locations
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].transition(easingDecimal);
				}
	
				// Transition and Draw the line
				if (lineEnabled(me.getDataset(), me.chart.options)) {
					meta.dataset.transition(easingDecimal).draw();
				}
	
				// Draw the points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].draw();
				}
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.hoverRadius || helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
	
				model.radius = custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
				model.backgroundColor = me.getPointBackgroundColor(point, index);
				model.borderColor = me.getPointBorderColor(point, index);
				model.borderWidth = me.getPointBorderWidth(point, index);
			}
		});
	};


/***/ }),
/* 428 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.polarArea = {
	
			scale: {
				type: 'radialLinear',
				lineArc: true, // so that lines are circular
				ticks: {
					beginAtZero: true
				}
			},
	
			// Boolean - Whether to animate the rotation of the chart
			animation: {
				animateRotate: true,
				animateScale: true
			},
	
			startAngle: -0.5 * Math.PI,
			aspectRatio: 1,
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '">');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</span></li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						meta.data[index].hidden = !meta.data[index].hidden;
					}
	
					chart.update();
				}
			},
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
					}
				}
			}
		};
	
		Chart.controllers.polarArea = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var meta = me.getMeta();
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
				chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
				chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				meta.count = me.countVisibleElements();
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var dataset = me.getDataset();
				var opts = chart.options;
				var animationOpts = opts.animation;
				var scale = chart.scale;
				var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
				var labels = chart.data.labels;
	
				var circumference = me.calculateCircumference(dataset.data[index]);
				var centerX = scale.xCenter;
				var centerY = scale.yCenter;
	
				// If there is NaN data before us, we need to calculate the starting angle correctly.
				// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
				var visibleCount = 0;
				var meta = me.getMeta();
				for (var i = 0; i < index; ++i) {
					if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
						++visibleCount;
					}
				}
	
				// var negHalfPI = -0.5 * Math.PI;
				var datasetStartAngle = opts.startAngle;
				var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
				var startAngle = datasetStartAngle + (circumference * visibleCount);
				var endAngle = startAngle + (arc.hidden ? 0 : circumference);
	
				var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: reset ? resetRadius : distance,
						startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
						endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
						label: getValueAtIndexOrDefault(labels, index, labels[index])
					}
				});
	
				// Apply border and fill style
				me.removeHoverStyle(arc);
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;
	
				helpers.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});
	
				return count;
			},
	
			calculateCircumference: function(value) {
				var count = this.getMeta().count;
				if (count > 0 && !isNaN(value)) {
					return (2 * Math.PI) / count;
				}
				return 0;
			}
		});
	};


/***/ }),
/* 429 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.radar = {
			scale: {
				type: 'radialLinear'
			},
			elements: {
				line: {
					tension: 0 // no bezier in radar
				}
			}
		};
	
		Chart.controllers.radar = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			linkScales: helpers.noop,
	
			addElementAndReset: function(index) {
				Chart.DatasetController.prototype.addElementAndReset.call(this, index);
	
				// Make sure bezier control points are updated
				this.updateBezierControlPoints();
			},
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data;
				var custom = line.custom || {};
				var dataset = me.getDataset();
				var lineElementOptions = me.chart.options.elements.line;
				var scale = me.chart.scale;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}
	
				helpers.extend(meta.dataset, {
					// Utility
					_datasetIndex: me.index,
					// Data
					_children: points,
					_loop: true,
					// Model
					_model: {
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
	
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scale.getBasePosition()
					}
				});
	
				meta.dataset.pivot();
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				}, me);
	
	
				// Update bezier control points
				me.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var me = this;
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var scale = me.chart.scale;
				var pointElementOptions = me.chart.options.elements.point;
				var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
	
				helpers.extend(point, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? scale.yCenter : pointPosition.y,
	
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.tension, me.chart.options.elements.line.tension),
						radius: custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
						pointStyle: custom.pointStyle ? custom.pointStyle : helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var chartArea = this.chart.chartArea;
				var meta = this.getMeta();
	
				helpers.each(meta.data, function(point, index) {
					var model = point._model;
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index, true)._model,
						model,
						helpers.nextItem(meta.data, index, true)._model,
						model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
					model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);
	
					model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
					model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				});
			},
	
			draw: function(ease) {
				var meta = this.getMeta();
				var easingDecimal = ease || 1;
	
				// Transition Point Locations
				helpers.each(meta.data, function(point) {
					point.transition(easingDecimal);
				});
	
				// Transition and Draw the line
				meta.dataset.transition(easingDecimal).draw();
	
				// Draw the points
				helpers.each(meta.data, function(point) {
					point.draw();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
	
				model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
				var pointElementOptions = this.chart.options.elements.point;
	
				model.radius = custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.radius, index, pointElementOptions.radius);
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
			}
		});
	};


/***/ }),
/* 430 */
388,
/* 431 */
389,
/* 432 */
390,
/* 433 */
391,
/* 434 */
392,
/* 435 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Radar = function(context, config) {
			config.options = Chart.helpers.configMerge({aspectRatio: 1}, config.options);
			config.type = 'radar';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 436 */
394,
/* 437 */
/***/ (function(module, exports) {

	angular.module('cgPrompt',['ui.bootstrap']);
	
	angular.module('cgPrompt').factory('prompt',['$uibModal','$q',function($uibModal,$q){
	
	    var prompt = function(options){
	
	        var defaults = {
	            title: '',
	            message: '',
	            input: false,
	            label: '',
	            value: '',
	            values: false,
	            buttons: [
	                {label:'Cancel',cancel:true},
	                {label:'OK',primary:true}
	            ]
	        };
	
	        if (options === undefined){
	            options = {};
	        }
	
	        for (var key in defaults) {
	            if (options[key] === undefined) {
	                options[key] = defaults[key];
	            }
	        }
	
	        var defer = $q.defer();
	
	        $uibModal.open({
	            templateUrl:'angular-prompt.html',
	            controller: 'cgPromptCtrl',
	            resolve: {
	                options:function(){
	                    return options;
	                }
	            }
	        }).result.then(function(result){
	            if (options.input){
	                defer.resolve(result.input);
	            } else {
	                defer.resolve(result.button);
	            }
	        }, function(){
	            defer.reject();
	        });
	
	        return defer.promise;
	    };
	
	    return prompt;
		}
	]);
	
	angular.module('cgPrompt').controller('cgPromptCtrl',['$scope','options','$timeout',function($scope,options,$timeout){
	
	    $scope.input = {name:options.value};
	
	    $scope.options = options;
	
	    $scope.form = {};
	
	    $scope.buttonClicked = function(button){
	        if (button.cancel){
	            $scope.$dismiss();
	            return;
	        }
	        if (options.input && $scope.form.cgPromptForm.$invalid){
	            $scope.changed = true;
	            return;
	        }
	        $scope.$close({button:button,input:$scope.input.name});
	    };
	
	    $scope.submit = function(){
	        var ok;
	        angular.forEach($scope.options.buttons,function(button){
	            if (button.primary){
	                ok = button;
	            }
	        });
	        if (ok){
	            $scope.buttonClicked(ok);
	        }
	    };
	
	    $timeout(function(){
	        var elem = document.querySelector('#cgPromptInput');
	        if (elem) {
	            if (elem.select) {
	                elem.select();
	            }
	            if (elem.focus) {
	                elem.focus();
	            }
	        }
	    },100);
	
	
	}]);
	
	
	angular.module('cgPrompt').run(['$templateCache', function($templateCache) {
	  'use strict';
	
	  $templateCache.put('angular-prompt.html',
	    "<div>\n" +
	    "    <div class=\"modal-header\">\n" +
	    "        <button type=\"button\" class=\"close pull-right\" ng-click=\"$dismiss()\" aria-hidden=\"true\">×</button>\n" +
	    "        <h4 class=\"modal-title\">{{options.title}}</h4>\n" +
	    "    </div>\n" +
	    "    <div class=\"modal-body\">\n" +
	    "\n" +
	    "        <p ng-if=\"options.message\">\n" +
	    "            {{options.message}}\n" +
	    "        </p>\n" +
	    "\n" +
	    "        <form id=\"cgPromptForm\" name=\"form.cgPromptForm\" ng-if=\"options.input\" ng-submit=\"submit()\">\n" +
	    "            <div class=\"form-group\" ng-class=\"{'has-error':cgPromptForm.$invalid && changed}\">\n" +
	    "                <label for=\"cgPromptInput\">{{options.label}}</label>\n" +
	    "                <input id=\"cgPromptInput\" type=\"text\" class=\"form-control\"  placeholder=\"{{options.label}}\" ng-model=\"input.name\" required ng-change=\"changed=true\" ng-if=\"!options.values || options.values.length === 0\"/ autofocus=\"autofocus\">\n" +
	    "                <div class=\"input-group\" ng-if=\"options.values\">\n" +
	    "                    <input id=\"cgPromptInput\" type=\"text\" class=\"form-control\" placeholder=\"{{options.label}}\" ng-model=\"input.name\" required ng-change=\"changed=true\" autofocus=\"autofocus\"/>\n" +
	    "\n" +
	    "                    <div class=\"input-group-btn\" dropdown>\n" +
	    "                        <button type=\"button\" class=\"btn btn-default dropdown-toggle\" dropdown-toggle data-toggle=\"dropdown\"><span class=\"caret\"></span></button>\n" +
	    "                        <ul class=\"dropdown-menu pull-right\">\n" +
	    "                            <li ng-repeat=\"value in options.values\"><a href=\"\" ng-click=\"input.name = value\">{{value}}</a></li>\n" +
	    "                        </ul>\n" +
	    "                    </div>\n" +
	    "                </div>\n" +
	    "            </div>\n" +
	    "         </form>\n" +
	    "\n" +
	    "    </div>\n" +
	    "    <div class=\"modal-footer\">\n" +
	    "        <button ng-repeat=\"button in options.buttons track by button.label\" class=\"btn btn-default {{button.class}}\" ng-class=\"{'btn-primary':button.primary}\" ng-click=\"buttonClicked(button)\">{{button.label}}</button>\n" +
	    "    </div>\n" +
	    "</div>"
	  );
	
	}]);


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	CommunityService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CommunityService = CommunityService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function CommunityService($resource) {
	  return $resource('/api/communities/:id', {
	    id: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	    },
	    patch: {
	      method: 'PATCH'
	    },
	    addAttachments: {
	      method: 'PUT',
	      url: "/api/communities/:id/attachments"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.CommunityService', []).factory('CommunityService', CommunityService).name;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	PropertyService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PropertyService = PropertyService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function PropertyService($resource) {
	  return $resource('/api/properties/:id', {
	    id: '@_id'
	  }, {
	    getByContact: {
	      method: 'GET',
	      url: "/api/properties/contact/:contactId",
	      isArray: true
	    },
	    getByCommunity: {
	      method: 'GET',
	      url: "/api/properties/community/:communityId",
	      isArray: true
	    },
	    getContacts: {
	      method: 'GET',
	      url: "/api/properties/:id/contacts",
	      isArray: true
	    },
	    update: {
	      method: 'PUT'
	    },
	    patch: {
	      method: 'PATCH'
	    },
	    addAttachments: {
	      method: 'PUT',
	      url: "/api/properties/:id/attachments"
	    },
	    getPropertiesByVoter: {
	      method: 'GET',
	      url: "/api/properties/voter/:contactId",
	      isArray: true
	    },
	    queryWithContacts: {
	      method: 'GET',
	      url: "/api/properties/contacts",
	      isArray: true
	    }
	  });
	}
	
	exports.default = angular.module('conduu.PropertyService', []).factory('PropertyService', PropertyService).name;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ContactsService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContactsService = ContactsService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function ContactsService($resource) {
	  return $resource('/api/contacts/:id', {
	    id: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	    },
	    patch: {
	      method: 'PATCH'
	    },
	    addAttachments: {
	      method: 'PUT',
	      url: "/api/contacts/:id/attachments"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.ContactService', []).factory('ContactService', ContactsService).name;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViolationsCodeListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _violationsCodeList = __webpack_require__(442);
	
	var _violationsCodeList2 = _interopRequireDefault(_violationsCodeList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ViolationsCodeListComponent = exports.ViolationsCodeListComponent = function () {
	  ViolationsCodeListComponent.$inject = ['Auth', 'ViolationCodesService', 'dialogs', 'DTOptionsBuilder', 'DTState'];
	  function ViolationsCodeListComponent(Auth, ViolationCodesService, dialogs, DTOptionsBuilder, DTState) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ViolationsCodeListComponent);
	
	    this.ViolationCodesService = ViolationCodesService;
	    this.data = [];
	
	    this.dialogs = dialogs;
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'desc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "CC&R Codes"
	    }, {
	      extend: 'csv',
	      title: "CC&R Codes"
	    }, {
	      title: "CC&R Codes",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'portrait',
	      pageSize: 'LETTER'
	    }, {
	      extend: 'print',
	      title: "CC&R Codes"
	    }]);
	
	    this.ViolationCodesService.query(function (data) {
	      _this.data = data;
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve violation codes.");
	    });
	  }
	
	  _createClass(ViolationsCodeListComponent, [{
	    key: 'delete',
	    value: function _delete(code) {
	      var that = this;
	
	      var codeText = "<br/><br/><b>" + code.code + ': ' + code.name + "</b><br/><p>" + code.description + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Violation Code?", "Do you really want to delete the violation code?" + codeText);
	      dlg.result.then(function () {
	        that.ViolationCodesService.delete({ id: code._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== code._id;
	          });
	        }, function (err) {
	          alert("Could not delete violation code");
	        });
	      }, function () {});
	    }
	  }]);
	
	  return ViolationsCodeListComponent;
	}();
	
	exports.default = angular.module('conduu.violationCodeList', [uiRouter]).config(_violationsCodeList2.default).component('violationCodeList', {
	  template: __webpack_require__(443),
	  controller: ViolationsCodeListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('violation-code-list', {
	    url: '/violation/code/list',
	    template: '<violation-code-list></violation-code-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" href=\"/violation/code/edit/\"><i class=\"fa fa-plus\"></i> Create New Code</a>\r\n      <h2>Violation Codes</h2>\r\n      <li class=\"active\"><a href=\"#\">Violation Codes</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>Violation</th>\r\n          <th>Code</th>\r\n          <th>Description</th>\r\n          <th>Creation Date</th>\r\n          <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"code in ctrl.data | orderBy: 'meta.creationDate':true\">\r\n          <td>{{code.name}}</td>\r\n          <td>{{code.code}}</td>\r\n          <td>{{code.description}}</td>\r\n          <td>\r\n            <nobr>{{code.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td>\r\n            <nobr>\r\n              <a class=\"btn btn-sm btn-primary\" ng-href=\"/violation/code/edit/{{code._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n              <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(code)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n            </nobr>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViolationsCodeEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _violationsCodeEdit = __webpack_require__(445);
	
	var _violationsCodeEdit2 = _interopRequireDefault(_violationsCodeEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ViolationsCodeEditComponent = exports.ViolationsCodeEditComponent = function () {
	  ViolationsCodeEditComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'ViolationCodesService', 'TemplateService', '$uibModal', '$timeout'];
	  function ViolationsCodeEditComponent(Auth, $state, $stateParams, dialogs, ViolationCodesService, TemplateService, $uibModal, $timeout) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ViolationsCodeEditComponent);
	
	    this.codeId = $stateParams.id;
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.ViolationCodesService = ViolationCodesService;
	    this.TemplateService = TemplateService;
	    this.Auth = Auth;
	
	    this.jsonValue = "";
	    this.$state = $state;
	    this.$timeout = $timeout;
	
	    this.toolbarDefinition = [["bold", "italics", "underline"], ["h3", "h4", "h5"], ["p", "quote", "clear"], ["ul", "ol"], ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"], ["undo", "redo"]];
	
	    this.TemplateService.query(function (data) {
	      _this.templates = data;
	    });
	
	    this.model = {
	      sequence: [{
	        fee: 0
	      }]
	    };
	
	    if (this.codeId) {
	      this.ViolationCodesService.get({ id: this.codeId }, function (data) {
	        _this.model = data;
	        _this.$timeout(function (_) {
	          _this.active = 0;
	        }, 0);
	      }, function (err) {
	        console.log('Could not load violation code from server');
	      });
	    }
	  }
	
	  _createClass(ViolationsCodeEditComponent, [{
	    key: 'removeLevel',
	    value: function removeLevel(idx) {
	      this.model.sequence.splice(idx, 1);
	    }
	  }, {
	    key: 'addLevel',
	    value: function addLevel() {
	      this.model.sequence.push({ fee: 0 });
	    }
	  }, {
	    key: 'templateLookup',
	    value: function templateLookup(idx) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'templateLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (template) {
	        that.model.sequence[idx].template = template._id;
	      }, function () {});
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this2.codeId ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "The violation code has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("violation-code-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        if (this.codeId) {
	          this.ViolationCodesService.update({ id: this.codeId }, this.model, onSuccess, onError);
	        } else {
	          this.model.meta = { creationUser: this.Auth.getCurrentUserSync()._id };
	          this.ViolationCodesService.save(this.model, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return ViolationsCodeEditComponent;
	}();
	
	exports.default = angular.module('conduu.violationsCodeEdit', [uiRouter]).config(_violationsCodeEdit2.default).component('violationsCodeEdit', {
	  template: __webpack_require__(446),
	  controller: ViolationsCodeEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('violations-code-edit', {
	    url: '/violation/code/edit/:id',
	    template: '<violations-code-edit></violations-code-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Violation Code Editor</h2>\r\n      <li><a href=\"/violation/code/list\">Violation Codes</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Name</label>\r\n          <br/>\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.model.name\" />\r\n        </div>\r\n        \r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.code.$valid && ctrl.submitted,\r\n                                            'has-error': form.code.$invalid && ctrl.submitted }\">\r\n          <label>Code</label>\r\n          <br/>\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.model.code\" />\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.description.$valid && ctrl.submitted,\r\n                                            'has-error': form.description.$invalid && ctrl.submitted }\">\r\n          <label>Description</label>\r\n          <br/>\r\n          <textarea name=\"description\" class=\"form-control big-textfield\" ng-model=\"ctrl.model.description\"></textarea>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.article.$valid && ctrl.submitted,\r\n                                            'has-error': form.article.$invalid && ctrl.submitted }\">\r\n          <label>Article</label>\r\n          <br/>\r\n          <textarea name=\"article\" class=\"form-control bigger-textfield\" ng-model=\"ctrl.model.article\"></textarea>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.resolveBy.$valid && ctrl.submitted,\r\n                                            'has-error': form.resolveBy.$invalid && ctrl.submitted }\">\r\n          <label>Resolve by</label>\r\n          <br/>\r\n          <textarea name=\"resolveBy\" class=\"form-control big-textfield\" ng-model=\"ctrl.model.resolveBy\"></textarea>\r\n        </div>\r\n\r\n        <uib-tabset active=\"ctrl.active\">\r\n          <uib-tab index=\"$index\" ng-repeat=\"sequence in ctrl.model.sequence\" heading=\"{{$index+1}}. Level\">\r\n\r\n            <a ng-if=\"ctrl.model.sequence.length > 1\" href=\"#\" style=\"float:right;position:relative; top:4px\" ng-click=\"ctrl.removeLevel($index)\"\r\n               class=\"btn btn-sm btn-danger\"><i class=\"fa fa-fw fa-trash\"></i> Remove This Level</a>\r\n            <br/>\r\n\r\n            <div class=\"form-group\">\r\n              <label>Action Level</label>\r\n              <br/>\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"sequence.level\" />\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label>Days From</label>\r\n              <br/>\r\n              <input type=\"number\" class=\"form-control\" ng-model=\"sequence.days\" />\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label>Administration Fee</label>\r\n              <br/>\r\n              <input type=\"number\" class=\"form-control\" ng-model=\"sequence.fee\" />\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label>Document Template</label>\r\n              <br/>\r\n\r\n              <div class=\"input-group\" style=\"display: inline-block\">\r\n                <select class=\"form-control\" ng-options=\"o._id as o.name for o in ctrl.templates\" ng-model=\"sequence.template\"\r\n                        style=\"display: inline-block; width: auto\"></select>\r\n                <span class=\"input-group-btn\">\r\n                  <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.templateLookup($index)\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                  <a class=\"btn btn-danger\" ng-disabled=\"!sequence.template\" ng-click=\"sequence.template = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n                </span>\r\n              </div>\r\n            </div>\r\n\r\n            <!--\r\n            <div class=\"form-group\">\r\n              <label>Document Template</label>\r\n              <br/>\r\n\r\n              <div class=\"input-group\" style=\"display: inline-block\">\r\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.templateEnum\" ng-model=\"sequence.template\"\r\n                        style=\"display: inline-block; width: auto\"></select>\r\n                <span class=\"input-group-btn\">\r\n                  <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.templateLookup($index)\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                  <a class=\"btn btn-danger\" ng-disabled=\"!sequence.template\" ng-click=\"sequence.template = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n                </span>\r\n              </div>\r\n            </div>-->\r\n\r\n            <!-- Mail Subject -->\r\n            <div class=\"form-group\">\r\n              <label>Email Subject Template</label>\r\n              <input type=\"text\" name=\"subject\" class=\"form-control\" ng-model=\"sequence.mailSubjectTemplate\"/>\r\n            </div>\r\n\r\n            <!-- Mail Body -->\r\n            <div class=\"form-group\">\r\n              <label>Email Body Template</label>\r\n              <text-angular ng-model=\"sequence.mailBodyTemplate\" ta-toolbar=\"ctrl.toolbarDefinition\"></text-angular>\r\n              <!--<textarea name=\"body\" rows=\"8\" class=\"form-control\" ng-model=\"sequence.mailBodyTemplate\"></textarea>-->\r\n            </div>\r\n\r\n          </uib-tab>\r\n          <a href=\"#\" class=\"btn btn-default\" ng-click=\"ctrl.addLevel()\" style=\"position: relative; top: 2px;\"><i class=\"fa fa-fw fa-plus\"></i> Add level</a>\r\n        </uib-tabset>\r\n\r\n        <br/>\r\n\r\n        <button ng-hide=\"ctrl.codeId\" class=\"btn btn-primary\" type=\"submit\">Create Code</button>\r\n\r\n        <button ng-show=\"ctrl.codeId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"violation-code-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ViolationCodesService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViolationCodesService = ViolationCodesService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function ViolationCodesService($resource) {
	  return $resource('/api/violation-codes/:id', {
	    name: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	    }
	  });
	}
	
	exports.default = angular.module('conduu.ViolationCodesService', []).factory('ViolationCodesService', ViolationCodesService).name;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViolationsTicketListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _violationsTicketList = __webpack_require__(449);
	
	var _violationsTicketList2 = _interopRequireDefault(_violationsTicketList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ViolationsTicketListComponent = exports.ViolationsTicketListComponent = function () {
	  ViolationsTicketListComponent.$inject = ['ViolationTicketsService', 'ViolationCodesService', 'dialogs', '$scope', 'ViewSelection', 'DTOptionsBuilder', '$timeout', 'ChartJs', 'DTState', 'Util'];
	  function ViolationsTicketListComponent(ViolationTicketsService, ViolationCodesService, dialogs, $scope, ViewSelection, DTOptionsBuilder, $timeout, ChartJs, DTState, Util) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ViolationsTicketListComponent);
	
	    this.$scope = $scope;
	    this.ViewSelection = ViewSelection;
	
	    this.ViolationTicketsService = ViolationTicketsService;
	    this.ViolationCodesService = ViolationCodesService;
	    this.filteredData = [];
	    this.data = [];
	    this.selectedCommunityCode = "";
	    this.visibleStatus = 'open';
	    this.$timeout = $timeout;
	
	    this.dialogs = dialogs;
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'desc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Violation Tickets",
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }, {
	      extend: 'csv',
	      title: "Violation Tickets",
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }, {
	      title: "Violation Tickets",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'landscape',
	      pageSize: 'LETTER',
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }, {
	      extend: 'print',
	      title: "Violation Tickets",
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }]);
	
	    this.dtOptions.columnDefs = [{
	      targets: [2, 3],
	      render: Util.dataTableExportBreakToNewlineRenderer
	    }, {
	      targets: [5],
	      render: function render(data, type, row) {
	        if (type === 'export') {
	          console.log(data);
	          return data.replaceAll('<i ng-if="level.active" class="text-danger fa fa-exclamation ng-scope" ng-repeat="level in ticket.sequence"></i>', 'I');
	        }
	        return data;
	      }
	    }];
	
	    this.chartLabels = {
	      'open': [],
	      'total': [],
	      'asn': []
	    };
	
	    this.chartOptions = {
	      'open': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Open per Type'
	        },
	        animation: false
	      },
	      'total': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Total per Type'
	        },
	        animation: false
	      },
	      'asn': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Total per Community'
	        },
	        animation: false
	      },
	      'overtime': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Violations Over Time'
	        }
	      }
	    };
	
	    this.chartColorsDefault = ChartJs.getOptions('pie').global.colors;
	    this.chartColors = {
	      'total': [],
	      'open': [],
	      'asn': []
	    };
	
	    this.labelsOvertime = ["01/18", "02/18", "03/18", "04/18", "05/18", "06/18", "07/18", "08/18", "09/18", "10/18", "11/18", "12/18", "01/19", "02/19", "03/19", "04/19", "05/19", "06/19", "07/19", "08/19", "09/19", "10/19", "11/19", "12/19", "01/20", "02/20", "03/20", "04/20", "05/20", "06/20", "07/20", "08/20", "09/20", "10/20", "11/20", "12/20"];
	    this.seriesOvertime = ['Total Open', 'Opened This Month', 'Closed This Month'];
	
	    this.ViolationCodesService.query(function (data) {
	      _this.codes = data;
	      _this.chartLabels['open'] = data.map(function (code) {
	        return code.code;
	      });
	      _this.chartLabels['total'] = data.map(function (code) {
	        return code.code;
	      });
	    }, function (err) {
	      console.log("Could not retrieve violation codes.");
	    });
	
	    this.ViolationTicketsService.query(function (data) {
	      _this.data = data;
	      _this.filterData(ViewSelection.selectedCommunityCode);
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve violation tickets.");
	    });
	
	    $scope.ViewSelection = ViewSelection;
	    $scope.$watch('ViewSelection.selectedCommunity', function (newVal, oldVal, scope) {
	      _this.selectedCommunity = newVal.name;
	      _this.selectedCommunityCode = newVal.value;
	      _this.filterData(_this.selectedCommunityCode, _this.selectedCode);
	    });
	  }
	
	  _createClass(ViolationsTicketListComponent, [{
	    key: 'buildGraphData',
	    value: function buildGraphData() {
	      var _this2 = this;
	
	      this.dataOvertime = [[], [], []];
	      this.chartData = {
	        'open': [],
	        'total': [],
	        'asn': []
	      };
	
	      this.filteredData.forEach(function (ccr) {
	        var creationMonth = moment(ccr.meta.creationDate).format("MM/YY");
	        var indexOpen = _this2.labelsOvertime.findIndex(function (elm) {
	          return elm == creationMonth;
	        });
	        if (indexOpen) {
	          if (!_this2.dataOvertime[1][indexOpen]) _this2.dataOvertime[1][indexOpen] = 1;else _this2.dataOvertime[1][indexOpen]++;
	        }
	
	        if (ccr.closeDate) {
	          var closeMonth = moment(ccr.closeDate).format("MM/YY");
	          var indexClose = _this2.labelsOvertime.findIndex(function (elm) {
	            return elm == closeMonth;
	          });
	          if (indexClose) {
	            if (!_this2.dataOvertime[2][indexClose]) _this2.dataOvertime[2][indexClose] = -1;else _this2.dataOvertime[2][indexClose]--;
	          }
	        }
	      });
	
	      for (var i = 0; i < this.labelsOvertime.length; i++) {
	        if (!this.dataOvertime[0][i]) this.dataOvertime[0][i] = 0;
	        if (!this.dataOvertime[1][i]) this.dataOvertime[1][i] = 0;
	        if (!this.dataOvertime[2][i]) this.dataOvertime[2][i] = 0;
	      }
	
	      for (var _i = 0; _i < this.labelsOvertime.length; _i++) {
	        if (_i == 0) this.dataOvertime[0][0] = this.dataOvertime[0][1] - this.dataOvertime[0][2];else this.dataOvertime[0][_i] = this.dataOvertime[0][_i - 1] + this.dataOvertime[1][_i] + this.dataOvertime[2][_i];
	      }
	
	      this.$timeout(function (_) {
	        var referenceData1 = _this2.selectedCommunityCode ? _this2.data.filter(function (ccr) {
	          return ccr.property && ccr.property.community && ccr.property.community.code == _this2.selectedCommunityCode;
	        }) : _this2.data;
	        _this2.chartLabels['open'].forEach(function (code) {
	          _this2.chartData['open'].push(referenceData1.filter(function (ccr) {
	            return ccr.code == code && ccr.status == 'open';
	          }).length);
	          _this2.chartData['total'].push(referenceData1.filter(function (ccr) {
	            return ccr.code == code;
	          }).length);
	        });
	
	        var referenceData2 = _this2.selectedCode ? _this2.data.filter(function (ccr) {
	          return ccr.code == _this2.selectedCode;
	        }) : _this2.data;
	        referenceData2.forEach(function (ccr) {
	          if (!_this2.chartLabels['asn'].includes(ccr.property.community.code)) _this2.chartLabels['asn'].push(ccr.property.community.code);
	        });
	        _this2.chartLabels['asn'].forEach(function (asn) {
	          _this2.chartData['asn'].push(referenceData2.filter(function (ccr) {
	            return ccr.property.community.code == asn;
	          }).length);
	        });
	      }, 0);
	    }
	  }, {
	    key: 'resetCodeFilter',
	    value: function resetCodeFilter() {
	      this.selectedCode = null;
	      this.applyCodeFilter();
	    }
	  }, {
	    key: 'applyCodeFilter',
	    value: function applyCodeFilter() {
	      if (this.selectedCode) this.filterData(this.selectedCommunityCode, this.selectedCode);else this.filterData(this.selectedCommunityCode);
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += "<br/>" + contact.company;
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'getPrimaryOwner',
	    value: function getPrimaryOwner(property) {
	      var primary = property.contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary || !primary.contact) return "-";
	
	      return this.getComposedName(primary.contact);
	    }
	  }, {
	    key: 'filterData',
	    value: function filterData(communityCode, ticketCode) {
	      var _this3 = this;
	
	      if (communityCode) {
	        this.filteredData = this.data.filter(function (ccr) {
	          return ccr.property && ccr.property.community && ccr.property.community.code == communityCode;
	        });
	      } else {
	        this.filteredData = this.data;
	      }
	
	      if (ticketCode) {
	        this.filteredData = this.filteredData.filter(function (ccr) {
	          return ccr.code == ticketCode;
	        });
	      }
	
	      this.buildGraphData();
	
	      this.chartColors['asn'] = communityCode ? this.chartLabels['asn'].map(function (code) {
	        var idx = _this3.chartLabels['asn'].indexOf(code);
	        return code == _this3.selectedCommunityCode ? _this3.chartColorsDefault[idx] : "#eeeeee";
	      }) : this.chartColorsDefault;
	
	      this.chartColors['total'] = ticketCode ? this.chartLabels['total'].map(function (code) {
	        var idx = _this3.chartLabels['total'].indexOf(code);
	        return code == _this3.selectedCode ? _this3.chartColorsDefault[idx] : "#eeeeee";
	      }) : this.chartColorsDefault;
	
	      this.chartColors['open'] = this.chartColors['total'];
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(ticket) {
	      var that = this;
	
	      var ticketText = "<br/><br/><b>" + ticket.code + ': ' + ticket.name + "</b><br/><p>" + ticket.description + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Violation ticket?", "Do you really want to delete the violation ticket?" + ticketText);
	      dlg.result.then(function () {
	        that.ViolationTicketsService.delete({ id: ticket._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== ticket._id;
	          });
	
	          that.filterData(that.selectedCommunityCode);
	        }, function (err) {
	          alert("Could not delete ticket");
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount(cat) {
	      return this.filteredData.reduce(function (acc, obj) {
	        return acc + (obj.status === cat);
	      }, 0);
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter(cat) {
	      var _this4 = this;
	
	      this.dataInitComplete = false;
	      this.visibleStatus = cat;
	
	      this.$timeout(function (_) {
	        _this4.dataInitComplete = true;
	      }, 0);
	    }
	  }]);
	
	  return ViolationsTicketListComponent;
	}();
	
	exports.default = angular.module('conduu.violationTicketList', [uiRouter]).config(_violationsTicketList2.default).component('violationTicketList', {
	  template: __webpack_require__(450),
	  controller: ViolationsTicketListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('violation-ticket-list', {
	    url: '/violation/ticket/list',
	    template: '<violation-ticket-list></violation-ticket-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" href=\"/violation/ticket/edit/\"><i class=\"fa fa-plus\"></i> Create New Ticket</a>\n      <h2>Violation Tickets <small>{{ctrl.selectedCommunity}}</small></h2>\n      <li><a href=\"#\">{{ctrl.selectedCommunity}}</a></li>\n      <li class=\"active\"><a href=\"#\">Violation Tickets</a></li>\n    </ol>\n\n    <div class=\"col-xs-12\">\n\n      <div class=\"form-inline pull-right\" style=\"padding-top: 6px\">\n        <label for=\"code-selector\">Filter:&nbsp;\n          <select id=\"code-selector\" ng-options=\"o.code as o.code for o in ctrl.codes\" ng-model=\"ctrl.selectedCode\" ng-change=\"ctrl.applyCodeFilter()\"></select>\n        </label>\n        <a href=\"#\" ng-if=\"ctrl.selectedCode\" ng-click=\"ctrl.resetCodeFilter()\"><i class=\"fa fa-fw fa-times\"></i></a>\n      </div>\n\n      <uib-tabset active=\"ctrl.activeTabIndex\">\n        <uib-tab select=\"ctrl.setFilter('open')\">\n          <uib-tab-heading><b>Open</b> <span class=\"badge\">{{ctrl.getCount('open')}}</span></uib-tab-heading>\n        </uib-tab>\n        <uib-tab select=\"ctrl.setFilter('closed')\">\n          <uib-tab-heading><b>Closed</b> <span class=\"badge\">{{ctrl.getCount('closed')}}</span></uib-tab-heading>\n        </uib-tab>\n        <uib-tab select=\"ctrl.setFilter('')\" class=\"pull-right separator-right\">\n          <uib-tab-heading><i class=\"fa fa-fw fa-line-chart\"></i></uib-tab-heading>\n          <br/>\n          <div class=\"row\">\n            <div class=\"col-xs-12\">\n              <canvas id=\"overtime\" class=\"chart chart-line\" chart-data=\"ctrl.dataOvertime\"\n                      chart-labels=\"ctrl.labelsOvertime\" chart-series=\"ctrl.seriesOvertime\"\n                      chart-options=\"ctrl.chartOptions['overtime']\">\n              </canvas>\n            </div>\n          </div>\n        </uib-tab>\n        <uib-tab select=\"ctrl.setFilter('')\" class=\"pull-right\">\n          <uib-tab-heading><i class=\"fa fa-fw fa-pie-chart\"></i></uib-tab-heading>\n          <br/>\n          <div class=\"row\">\n\n            <div class=\"col-xs-4\">\n              <canvas id=\"doughnut\" class=\"chart chart-doughnut\"\n                      chart-data=\"ctrl.chartData['open']\" chart-labels=\"ctrl.chartLabels['open']\" chart-options=\"ctrl.chartOptions['open']\"\n                      chart-colors=\"ctrl.chartColors['open']\">\n              </canvas>\n            </div>\n\n            <div class=\"col-xs-4\">\n              <canvas id=\"doughnut2\" class=\"chart chart-doughnut\"\n                      chart-data=\"ctrl.chartData['total']\" chart-labels=\"ctrl.chartLabels['total']\" chart-options=\"ctrl.chartOptions['total']\"\n                      chart-colors=\"ctrl.chartColors['total']\">\n              </canvas>\n            </div>\n\n            <div class=\"col-xs-4\">\n              <canvas id=\"doughnut3\" class=\"chart chart-doughnut\"\n                      chart-data=\"ctrl.chartData['asn']\" chart-labels=\"ctrl.chartLabels['asn']\" chart-options=\"ctrl.chartOptions['asn']\"\n                      chart-colors=\"ctrl.chartColors['asn']\">\n              </canvas>\n            </div>\n\n          </div>\n          <hr>\n        </uib-tab>\n      </uib-tabset>\n\n      <br/>\n\n      <div ng-if=\"ctrl.dataInitComplete && ctrl.activeTabIndex != 2\">\n        <table datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\" style=\"width:100%\"> <!-- datatable=\"ng\" -->\n          <thead>\n          <tr>\n            <th>Date</th>\n            <th>Community</th>\n            <th>Property</th>\n            <th>Primary Owner</th>\n            <th>Violation</th>\n            <th>Level</th>\n            <th>Status</th>\n            <th>By</th>\n            <th></th>\n            <th></th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-if=\"!ctrl.visibleStatus || ticket.status == ctrl.visibleStatus\" ng-repeat=\"ticket in ctrl.filteredData | orderBy: 'meta.creationDate':true\">\n            <td>\n              <nobr>{{ticket.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\n            </td>\n            <td>{{ticket.property.community.code}}</td>\n            <td>\n              <a ng-if=\"ticket.property\" ng-href=\"/property/{{ticket.property._id}}\">{{ticket.property.address.street}}<br/>{{ticket.property.address.city}} {{ticket.property.address.state}}, {{ticket.property.address.zip}}</a>\n            </td>\n            <td ng-bind-html=\"ctrl.getPrimaryOwner(ticket.property)\"></td>\n            <td>{{ticket.code}}: {{ticket.name}}</td>\n            <td><i ng-if=\"level.active\" class=\"text-danger fa fa-exclamation\" ng-repeat=\"level in ticket.sequence\"></i></td>\n            <td>\n              <span ng-if=\"ticket.status == 'open'\" class=\"label label-primary\">Open</span>\n              <span ng-if=\"ticket.status == 'closed'\" class=\"label label-default\">Closed</span>\n            </td>\n            <td>{{ticket.meta.creationUser.shortName || '-'}}</td>\n            <td><a class=\"btn btn-sm btn-primary\" ng-href=\"/violation/ticket/detail/{{ticket._id}}\"><i class=\"fa fa-folder-open fa-fw\"></i></a></td>\n            <td>\n              <nobr>\n                <a class=\"btn btn-sm btn-primary\" ng-href=\"/violation/ticket/edit/{{ticket._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\n                <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(ticket)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\n              </nobr>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViolationsTicketEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _violationsTicketEdit = __webpack_require__(452);
	
	var _violationsTicketEdit2 = _interopRequireDefault(_violationsTicketEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ViolationsTicketEditComponent = exports.ViolationsTicketEditComponent = function () {
	  ViolationsTicketEditComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'ViolationCodesService', 'ViolationTicketsService', 'PropertyService', '$uibModal'];
	  function ViolationsTicketEditComponent(Auth, $state, $stateParams, dialogs, ViolationCodesService, ViolationTicketsService, PropertyService, $uibModal) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ViolationsTicketEditComponent);
	
	    this.ticketId = $stateParams.id;
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.ViolationTicketsService = ViolationTicketsService;
	    this.ViolationCodesService = ViolationCodesService;
	    this.PropertyService = PropertyService;
	    this.$stateParams = $stateParams;
	    this.Auth = Auth;
	
	    this.codes = [];
	    this.codesEnum = [];
	    this.schema = {};
	    this.properties = [];
	
	    this.PropertyService.query(function (data) {
	      _this.properties = data.map(function (property) {
	        var address = "-";
	        try {
	          address = property.address.street + ', ' + property.address.city + ' ' + property.address.state + ', ' + property.address.zip;
	        } catch (e) {}
	
	        return {
	          value: property._id,
	          name: address + ' / ' + property.lotNo,
	          community: property.community.name
	        };
	      });
	    });
	
	    this.ViolationCodesService.query(function (data) {
	      _this.codes = data;
	      _this.codesEnum = data.map(function (code) {
	        return code.code;
	      });
	    });
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.model = {};
	
	    if (this.ticketId) {
	      this.ViolationTicketsService.get({ id: this.ticketId }, function (data) {
	        _this.model = data;
	
	        if (_this.model.property) _this.model.property = _this.model.property._id;
	      }, function (err) {
	        console.log('Could not load violation ticket from server');
	      });
	    } else if (this.$stateParams.propertyId) {
	      this.model.property = this.$stateParams.propertyId;
	    }
	  }
	
	  _createClass(ViolationsTicketEditComponent, [{
	    key: 'codeChanged',
	    value: function codeChanged() {
	      var _this2 = this;
	
	      var oCode = this.codes.find(function (code) {
	        return code.code == _this2.model.code;
	      });
	
	      if (!oCode) return;
	
	      this.model.sequence = oCode.sequence;
	      this.model.name = oCode.name;
	      this.model.description = oCode.description;
	      this.model.article = oCode.article;
	      this.model.resolveBy = oCode.resolveBy;
	    }
	  }, {
	    key: 'propertyLookup',
	    value: function propertyLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'propertyLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (property) {
	        that.selectedProperty = property;
	        that.model.property = property._id;
	      }, function () {});
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this3 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this3.ticketId ? "changed" : "created";
	          var dlg = _this3.dialogs.notify("Success", "The violation ticket has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("violation-ticket-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this3.sendFailure = true;
	        };
	
	        if (this.ticketId) {
	          this.ViolationTicketsService.update({ id: this.ticketId }, this.model, onSuccess, onError);
	        } else {
	          this.model.meta = { creationUser: this.Auth.getCurrentUserSync()._id };
	          this.ViolationTicketsService.save(this.model, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return ViolationsTicketEditComponent;
	}();
	
	exports.default = angular.module('conduu.violationsTicketEdit', [uiRouter]).config(_violationsTicketEdit2.default).component('violationsTicketEdit', {
	  template: __webpack_require__(453),
	  controller: ViolationsTicketEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('violations-ticket-edit', {
	    url: '/violation/ticket/edit/:id',
	    params: { propertyId: null },
	    template: '<violations-ticket-edit></violations-ticket-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Violation Ticket Editor</h2>\r\n      <li><a href=\"/violation/ticket/list\">Violation Tickets</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n        <div class=\"form-group\">\r\n          <label>Property</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <select class=\"form-control\" ng-options=\"o.value as o.name group by o.community for o in ctrl.properties | orderBy:'name'\" ng-model=\"ctrl.model.property\"\r\n                    style=\"display: inline-block; width: auto\"></select>\r\n            <span class=\"input-group-btn\">\r\n              <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.propertyLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n              <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.property\" ng-click=\"ctrl.model.property = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n            </span>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.title.$valid && ctrl.submitted,\r\n                                            'has-error': form.title.$invalid && ctrl.submitted }\">\r\n          <label>Code</label>\r\n          <br/>\r\n          <select class=\"form-control\" ng-options=\"o as o for o in ctrl.codesEnum\" ng-model=\"ctrl.model.code\"\r\n                  ng-change=\"ctrl.codeChanged()\" style=\"display: inline-block; width: auto\"></select>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.description.$valid && ctrl.submitted,\r\n                                            'has-error': form.description.$invalid && ctrl.submitted }\">\r\n          <label>Description</label>\r\n          <br/>\r\n          <textarea name=\"description\" class=\"form-control big-textfield\" ng-model=\"ctrl.model.description\"></textarea>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.article.$valid && ctrl.submitted,\r\n                                            'has-error': form.article.$invalid && ctrl.submitted }\">\r\n          <label>Article</label>\r\n          <br/>\r\n          <textarea name=\"article\" class=\"form-control bigger-textfield\" ng-model=\"ctrl.model.article\"></textarea>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.resolveBy.$valid && ctrl.submitted,\r\n                                            'has-error': form.resolveBy.$invalid && ctrl.submitted }\">\r\n          <label>Resolve by</label>\r\n          <br/>\r\n          <textarea name=\"resolveBy\" class=\"form-control big-textfield\" ng-model=\"ctrl.model.resolveBy\"></textarea>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <button ng-hide=\"ctrl.ticketId\" class=\"btn btn-primary\" type=\"submit\">Create Ticket</button>\r\n\r\n        <button ng-show=\"ctrl.ticketId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"violation-ticket-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViolationsTicketShowComponent = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _violationsTicketShow = __webpack_require__(455);
	
	var _violationsTicketShow2 = _interopRequireDefault(_violationsTicketShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ViolationsTicketShowComponent = exports.ViolationsTicketShowComponent = function () {
	  ViolationsTicketShowComponent.$inject = ['$state', '$stateParams', 'dialogs', 'ViolationTicketsService', '$uibModal', '$window', 'Auth', 'RecentVisits', 'PinnedItems', '$timeout'];
	  function ViolationsTicketShowComponent($state, $stateParams, dialogs, ViolationTicketsService, $uibModal, $window, Auth, RecentVisits, PinnedItems, $timeout) {
	    'ngInject';
	
	    _classCallCheck(this, ViolationsTicketShowComponent);
	
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.Auth = Auth;
	    this.ticketId = $stateParams.id;
	    this.prompt = prompt;
	    this.tasks = [];
	
	    this.activities = [];
	    this.$uibModal = $uibModal;
	    this.$timeout = $timeout;
	
	    this.dialogs = dialogs;
	    this.ViolationTicketsService = ViolationTicketsService;
	    this.RecentVisits = RecentVisits;
	    this.PinnedItems = PinnedItems;
	
	    this.$state = $state;
	
	    this.hook = {
	      openSendAttachmentModal: this.openSendAttachmentModal.bind(this)
	    };
	
	    this.refreshData();
	  }
	
	  _createClass(ViolationsTicketShowComponent, [{
	    key: 'addToAttachments',
	    value: function addToAttachments(id, level) {
	      var that = this;
	
	      var mapType = {
	        'primary-owner': 'Primary Owner',
	        'owner': 'Owner',
	        'renter': 'Renter',
	        'tenant': 'Tenant',
	        'previous-owner': 'Previous Owner'
	      };
	
	      var addresses = [];
	
	      if (this.ticket.property && this.ticket.property.address && this.ticket.property.address.street) {
	        var propertyAddress = angular.copy(this.ticket.property.address);
	        propertyAddress.type = 'Property';
	        propertyAddress.group = "Property Address";
	        addresses.push(propertyAddress);
	      }
	
	      if (this.ticket.property && this.ticket.property.contacts && this.ticket.property.contacts.length) {
	        this.ticket.property.contacts.forEach(function (contact) {
	          if (contact.contact && contact.contact.address && contact.contact.address.length) {
	            contact.contact.address.forEach(function (adr) {
	              var contactAddress = angular.copy(adr);
	              contactAddress.firstName = contact.contact.firstName;
	              contactAddress.lastName = contact.contact.lastName;
	              contactAddress.group = contact.contact.firstName + ' ' + contact.contact.lastName + ' (' + mapType[contact.type] + ')';
	              addresses.push(contactAddress);
	            });
	          }
	        });
	      }
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'letterAddressSelectModal',
	        resolve: {
	          config: function config() {
	            return {
	              addresses: addresses
	            };
	          }
	        },
	        size: 'sm'
	      });
	
	      modalInstance.result.then(function (address) {
	        var base64Adr = btoa(JSON.stringify(address));
	        that.ViolationTicketsService.createPDFAndAttach({ id: id, level: level, address: base64Adr }, function (_) {
	          that.refreshData();
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'getLetter',
	    value: function getLetter(id, level, filetype) {
	      var that = this;
	
	      var mapType = {
	        'primary-owner': 'Primary Owner',
	        'owner': 'Owner',
	        'renter': 'Renter',
	        'tenant': 'Tenant',
	        'previous-owner': 'Previous Owner'
	      };
	
	      var addresses = [];
	
	      if (this.ticket.property && this.ticket.property.address && this.ticket.property.address.street) {
	        var propertyAddress = angular.copy(this.ticket.property.address);
	        propertyAddress.type = 'Property';
	        propertyAddress.group = "Property Address";
	        addresses.push(propertyAddress);
	      }
	
	      if (this.ticket.property && this.ticket.property.contacts && this.ticket.property.contacts.length) {
	        this.ticket.property.contacts.forEach(function (contact) {
	          if (contact.contact && contact.contact.address && contact.contact.address.length) {
	            contact.contact.address.forEach(function (adr) {
	              var contactAddress = angular.copy(adr);
	              contactAddress.firstName = contact.contact.firstName;
	              contactAddress.lastName = contact.contact.lastName;
	              contactAddress.group = contact.contact.firstName + ' ' + contact.contact.lastName + ' (' + mapType[contact.type] + ')';
	              addresses.push(contactAddress);
	            });
	          }
	        });
	      }
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'letterAddressDownloadModal',
	        resolve: {
	          config: function config() {
	            return {
	              endpoint: 'violations',
	              id: id,
	              level: level,
	              filetype: filetype,
	              addresses: addresses
	            };
	          }
	        },
	        size: 'sm'
	      });
	
	      modalInstance.result.then(function () {
	        that.refreshAttachments();
	      }, function () {
	        that.refreshAttachments();
	      });
	    }
	  }, {
	    key: 'getEmails',
	    value: function getEmails() {
	      var emails = [];
	
	      this.ticket.property.contacts.forEach(function (entry) {
	        if (!entry.contact || _typeof(entry.contact) !== 'object') return;
	
	        entry.contact.email.forEach(function (email) {
	          var group = entry.contact.firstName + " " + entry.contact.lastName + " (" + entry.type.replace("-", " ").toUpperCase() + ")";
	
	          var description = email.address + " (" + email.type + ")";
	
	          if (email.isPrimary) {
	            description += " (PRIMARY)";
	          }
	
	          emails.push({
	            group: group,
	            email: email.address,
	            description: description
	          });
	        });
	      });
	
	      return emails;
	    }
	  }, {
	    key: 'openSendAttachmentModal',
	    value: function openSendAttachmentModal(attachment) {
	      var that = this;
	
	      var primary = that.ticket.property && that.ticket.property.contacts ? that.ticket.property.contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      }) : null;
	
	      var owner = primary && primary.contact ? primary.contact.firstName + ' ' + primary.contact.lastName : '-';
	
	      var mailAddr1 = that.ticket.property && that.ticket.property.address ? that.ticket.property.address.street : '';
	
	      var mailAddr2 = that.ticket.property && that.ticket.property.address && that.ticket.property.address.street2 ? that.ticket.property.address.street2 : '';
	
	      var stateCityZip = that.ticket.property && that.ticket.property.address ? that.ticket.property.address.city + ', ' + that.ticket.property.address.state + ' ' + that.ticket.property.address.zip : '';
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'sendAttachmentEmail',
	        resolve: {
	          config: function config() {
	            return {
	              attachment: attachment ? attachment._id : null,
	              attachments: that.ticket.attachments.filter(function (attachment) {
	                return attachment.contentType !== 'text/html';
	              }),
	              emails: that.getEmails(),
	              templates: that.ticket.sequence,
	              contextVars: {
	                ASSOCIATION_NAME: that.ticket.property.community.name,
	                VIOLATION: that.ticket.code + ': ' + that.ticket.name,
	                ARTICLE: that.ticket.article ? that.ticket.article.split(/\n/).join("<br/>") : '',
	                RESOLVE_BY: that.ticket.resolveBy ? that.ticket.resolveBy.split(/\n/).join("<br/>") : '',
	                DESCRIPTION: that.ticket.description ? that.ticket.description.split(/\n/).join("<br/>") : '',
	                TODAYS_DATE: moment().format('l'),
	                LEVEL2_DAYS: that.ticket.sequence[1] ? that.ticket.sequence[1].days : '-',
	                LEVEL3_DAYS: that.ticket.sequence[2] ? that.ticket.sequence[2].days : '-',
	                LEVEL4_DAYS: that.ticket.sequence[3] ? that.ticket.sequence[3].days : '-',
	                LEVEL5_DAYS: that.ticket.sequence[4] ? that.ticket.sequence[4].days : '-',
	                OWNER_NAME: owner,
	                MAILING_ADDRESS_LINE_1: mailAddr1,
	                MAILING_ADDRESS_LINE_2: mailAddr2,
	                MAILING_STATE_CITY_ZIP: stateCityZip,
	                PROPERTY_STREET_ADDRESS: mailAddr1,
	                ENTITY_LINK: '<a target=\'_blank\' href=\'http://192.168.178.47:3000/violation/ticket/detail/' + that.ticket._id + '\'>Open Violation in Management Suite</a>' }
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (mail) {
	
	        that.ViolationTicketsService.sendAttachmentMail({ id: that.ticketId }, mail, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log(err);
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'refreshAttachments',
	    value: function refreshAttachments() {
	      var _this = this;
	
	      var count = this.ticket.attachments.length;
	
	      this.$timeout(function (_) {
	        _this.refreshData(function (_) {
	          if (_this.ticket.attachments.length === count) {
	            _this.$timeout(function (_) {
	              _this.refreshData(function (_) {
	                if (_this.ticket.attachments.length === count) {
	                  _this.$timeout(function (_) {
	                    _this.refreshData(function (_) {
	                      if (_this.ticket.attachments.length === count) {
	                        _this.$timeout(function (_) {
	                          _this.refreshData();
	                        }, 10000);
	                      }
	                    });
	                  }, 5000);
	                }
	              });
	            }, 2500);
	          }
	        });
	      }, 2500);
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData(cbDone) {
	      var _this2 = this;
	
	      if (this.ticketId) {
	        this.ViolationTicketsService.get({ id: this.ticketId }, function (data) {
	          _this2.ticket = data;
	
	          _this2.RecentVisits.addWorkItem(_this2.ticketId, "ccr", _this2.ticket.code + ': ' + _this2.ticket.name);
	          _this2.isPinned = _this2.PinnedItems.isPinnedWorkItem(_this2.ticketId);
	
	          _this2.ticket.sequence.forEach(function (lvl) {
	            lvl.dueDate = moment(_this2.ticket.meta.creationDate, "YYYY-MM-DD").add(lvl.days, 'days').toDate();
	          });
	
	          if (cbDone) {
	            cbDone();
	          }
	        }, function (err) {
	          console.log('Could not load violation ticket from server');
	        });
	      }
	    }
	  }, {
	    key: 'changeState',
	    value: function changeState() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'stateChangeForm',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (stateChange) {
	        that.ticket.status = stateChange.status;
	
	        if (stateChange.reason) {
	          that.ticket.notes.push({
	            meta: {
	              creationUser: that.Auth.getCurrentUserSync()._id
	            },
	            note: "Changed the state to '" + stateChange.status + "' because: " + stateChange.reason
	          });
	        }
	
	        if (stateChange.status == 'open') {
	          delete that.ticket.closeDate;
	        } else {
	          that.ticket.closeDate = new Date();
	        }
	
	        that.ViolationTicketsService.update({ id: that.ticketId }, that.ticket, function (_) {
	          return that.refreshData();
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'takeActionLevel',
	    value: function takeActionLevel(idx) {
	      var _this3 = this;
	
	      this.ViolationTicketsService.patch({ id: this.ticketId }, [{ "op": "replace", "path": "/sequence/" + idx + "/active", "value": "true" }], function (_) {
	        _this3.ViolationTicketsService.get({ id: _this3.ticketId }, function (data) {
	          _this3.ticket = data;
	
	          _this3.ticket.sequence.forEach(function (lvl) {
	            lvl.dueDate = moment(_this3.ticket.meta.creationDate, "YYYY-MM-DD").add(lvl.days, 'days').toDate();
	          });
	        }, function (err) {
	          console.log('Could not load violation ticket from server');
	        });
	      });
	    }
	  }, {
	    key: 'showButtonTakeAction',
	    value: function showButtonTakeAction(idx) {
	      if (this.ticket.sequence[idx].active) return false;
	
	      if (idx == 0) return true;
	
	      return this.ticket.sequence[idx - 1].active == true;
	    }
	  }, {
	    key: 'showButtonPrintLetter',
	    value: function showButtonPrintLetter(idx) {
	      return this.ticket.sequence[idx].active;
	    }
	  }, {
	    key: 'showStateCurrent',
	    value: function showStateCurrent(idx) {
	      if (!this.ticket.sequence[idx].active) return false;
	
	      if (idx < this.ticket.sequence.length - 1 && !this.ticket.sequence[idx + 1].active) return true;
	
	      if (idx == this.ticket.sequence.length - 1) return true;
	
	      return false;
	    }
	  }, {
	    key: 'showStateNext',
	    value: function showStateNext(idx) {
	      if (!this.ticket.sequence[idx].active && idx == 0) return true;
	
	      if (!this.ticket.sequence[idx].active && idx > 0 && this.ticket.sequence[idx - 1].active) return true;
	
	      return false;
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (resultIds) {
	        that.ViolationTicketsService.addAttachments({ id: that.ticketId }, resultIds, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not add attachments to ticket');
	        });
	      }, function () {});
	    }
	  }]);
	
	  return ViolationsTicketShowComponent;
	}();
	
	exports.default = angular.module('conduu.violationsTicketShow', [uiRouter]).config(_violationsTicketShow2.default).component('violationsTicketShow', {
	  template: __webpack_require__(456),
	  controller: ViolationsTicketShowComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('violations-ticket-show', {
	    url: '/violation/ticket/detail/:id',
	    template: '<violations-ticket-show></violations-ticket-show>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>{{ctrl.ticket.code}}: {{ctrl.ticket.name}}</h2>\r\n      <li><a href=\"/violation/ticket/list\">Violation Tickets</a></li>\r\n      <li class=\"active\"><a href=\"#\">{{ctrl.ticket.code}}: {{ctrl.ticket.name}}</a></li>\r\n    </ol>\r\n    \r\n    <div class=\"col-xs-12\">\r\n      <!-- Closed Stamp -->\r\n      <img ng-if=\"ctrl.ticket.status == 'closed'\" style=\"position: absolute;right: 80px;top: -30px;z-index: 1;width: 250px;\" src=\"assets/images/closed_stamp.png\" />\r\n\r\n      <!-- PostIt: Work Order for Property -->\r\n      <user-card property=\"ctrl.ticket.property\"></user-card>\r\n\r\n      <div style=\"min-height: 360px;\">\r\n        <h3>CCR Article / Summary</h3>\r\n        <div ng-bind-html=\"ctrl.ticket.article | newlineToHtml\"></div>\r\n\r\n        <h3>Detail Description</h3>\r\n        <div ng-bind-html=\"ctrl.ticket.description | newlineToHtml\"></div>\r\n\r\n        <h3>Action to Resolve</h3>\r\n        <div ng-bind-html=\"ctrl.ticket.resolveBy | newlineToHtml\"></div>\r\n      </div>\r\n\r\n      <br/>\r\n\r\n      <div class=\"col-xs-8\" style=\"padding-left:0\">\r\n\r\n        <h3 class=\"separator\"><span>Escalation</span></h3>\r\n\r\n        <table class=\"table table-striped table-condensed\" style=\"width:100%\">\r\n          <thead>\r\n          <tr>\r\n            <th>#</th>\r\n            <th>State</th>\r\n            <th>Level Name</th>\r\n            <th>Date Level Reached</th>\r\n            <th></th>\r\n          </tr>\r\n          </thead>\r\n          <tbody>\r\n          <tr ng-repeat=\"seq in ctrl.ticket.sequence\">\r\n            <td>{{$index + 1}}</td>\r\n            <td ng-if=\"ctrl.showStateCurrent($index)\">Current</td>\r\n            <td ng-if=\"ctrl.showStateNext($index)\">Next</td>\r\n            <td ng-if=\"!ctrl.showStateCurrent($index) && !ctrl.showStateNext($index)\">-</td>\r\n            <td>{{seq.level}}</td>\r\n            <td>{{seq.dueDate | date: 'mediumDate'}}</td>\r\n            <td class=\"text-right\" style=\"padding:0\" ng-if=\"ctrl.showButtonTakeAction($index)\"><button class=\"btn btn-sm btn-danger btn-ms-action\" ng-click=\"ctrl.takeActionLevel($index)\"><i class=\"fa fa-gears fa-fw\"></i> Take This Action</button></td>\r\n            <td class=\"text-right\" style=\"padding:0\" ng-if=\"ctrl.showButtonPrintLetter($index)\">\r\n              <a class=\"btn btn-sm btn-primary btn-ms-action\" title=\"Download Word Document\" ng-click=\"ctrl.getLetter(ctrl.ticket._id, $index, 'docx')\"><i class=\"fa fa-file-word-o fa-fw\"></i> Word</a>\r\n              <a class=\"btn btn-sm btn-primary btn-ms-action\" title=\"Download PDF\" ng-click=\"ctrl.getLetter(ctrl.ticket._id, $index, 'pdf')\"><i class=\"fa fa-file-pdf-o fa-fw\"></i> PDF</a>\r\n              <a class=\"btn btn-sm btn-primary btn-ms-action\" title=\"Add PDF to Attachments\" ng-click=\"ctrl.addToAttachments(ctrl.ticket._id, $index)\"><i class=\"fa fa-file-pdf-o\"></i><i class=\"fa fa-level-down\"></i> Attach</a>\r\n            </td>\r\n            <td class=\"text-right\" ng-if=\"!ctrl.showButtonTakeAction($index) && !ctrl.showButtonPrintLetter($index)\">&nbsp;</td>\r\n          </tr>\r\n          </tbody>\r\n        </table>\r\n      </div>\r\n\r\n      <div class=\"col-xs-4\" style=\"text-align:right; padding-right:0\">\r\n        <h3 class=\"separator\"><span>Actions</span></h3>\r\n        <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.openSendAttachmentModal()\"><i class=\"fa fa-fw fa-envelope\"></i> Send Attachment</button>\r\n        <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.changeState()\"><i class=\"fa fa-refresh fa-fw\"></i> Change Status</button>\r\n      </div>\r\n\r\n      <div style=\"clear: both\"></div>\r\n\r\n      <nta-section context=\"violation\" context-id=\"ctrl.ticketId\" data=\"ctrl.ticket\" service=\"ctrl.ViolationTicketsService\" on-refresh=\"ctrl.refreshData()\"></nta-section>\r\n\r\n      <h3 class=\"separator\"><span>Attachments <small><a href=\"#\" ng-click=\"ctrl.openAssetUploadModal()\"><i class=\"fa fa-upload\"></i> Upload Files</a></small></span></h3>\r\n\r\n      <attachment-list attachments=\"ctrl.ticket.attachments\" context-id=\"ctrl.ticketId\" service=\"ctrl.ViolationTicketsService\" hook=\"ctrl.hook\"></attachment-list>\r\n\r\n      <br/>\r\n\r\n      <div style=\"float:right\" >\r\n        <label>{{ctrl.isPinned ? 'Pinned' : \"Not Pinned\"}}&nbsp;</label> <toggle ng-model=\"ctrl.isPinned\" ng-change=\"ctrl.PinnedItems.toggleWorkItem(ctrl.ticketId, 'ccr', ctrl.ticket.code + ': ' + ctrl.ticket.name)\" on=\"<i class='fa fa-fw fa-map-pin'>\" off=\"<i class='fa fa-fw fa-times'>\" onstyle=\"btn-success\" offstyle=\"btn-default\"></toggle>\r\n      </div>\r\n      <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ViolationTicketsService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViolationTicketsService = ViolationTicketsService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function ViolationTicketsService($resource) {
	  return $resource('/api/violations/:id', {
	    name: '@_id'
	  }, {
	    letter: {
	      method: 'GET',
	      url: "/api/violations/:id/letter/:level"
	    },
	    update: {
	      method: 'PUT'
	    },
	    patch: {
	      method: 'PATCH'
	    },
	    getByProperty: {
	      method: 'GET',
	      url: "/api/violations/property/:id",
	      isArray: true
	    },
	    addAttachments: {
	      method: 'PUT',
	      url: "/api/violations/:id/attachments"
	    },
	    createPDFAndAttach: {
	      method: 'GET',
	      url: "/api/violations/:id/attach-letter/:level/:address"
	    },
	    sendAttachmentMail: {
	      method: 'POST',
	      url: "/api/violations/:id/attachments/mail"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.ViolationTicketsService', []).factory('ViolationTicketsService', ViolationTicketsService).name;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CommunityListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _communityList = __webpack_require__(459);
	
	var _communityList2 = _interopRequireDefault(_communityList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var CommunityListComponent = exports.CommunityListComponent = function () {
	  CommunityListComponent.$inject = ['Auth', 'CommunityService', 'dialogs', '$localStorage', 'DTOptionsBuilder', 'DTState'];
	  function CommunityListComponent(Auth, CommunityService, dialogs, $localStorage, DTOptionsBuilder, DTState) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, CommunityListComponent);
	
	    this.CommunityService = CommunityService;
	    this.data = [];
	
	    this.dialogs = dialogs;
	    this.$localStorage = $localStorage;
	
	    this.asTable = !!$localStorage.communityListAsTable;
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'asc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Communities"
	    }, {
	      extend: 'csv',
	      title: "Communities"
	    }, {
	      title: "Communities",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'portrait',
	      pageSize: 'LETTER'
	    }, {
	      extend: 'print',
	      title: "Communities"
	    }]);
	
	    this.CommunityService.query(function (data) {
	      _this.data = data;
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve communities.");
	    });
	  }
	
	  _createClass(CommunityListComponent, [{
	    key: 'setAsTable',
	    value: function setAsTable(val) {
	      this.asTable = val;
	      this.$localStorage.communityListAsTable = val;
	    }
	  }, {
	    key: 'getPrimaryAddress',
	    value: function getPrimaryAddress(community, newline) {
	
	      if (!community.address) return "-";
	
	      var address = community.address.find(function (adr) {
	        return adr.isPrimary;
	      }) || community.address[0] || {};
	
	      if (!address.city) return "-";
	
	      var addBreak = newline ? "<br/>" : "";
	
	      var adrString = [];
	
	      adrString.push(address.street);
	      if (address.street2) adrString.push(address.street2);
	      adrString.push(addBreak + address.city + ' ' + address.state + ', ' + address.zip);
	      if (address.country) adrString.push(address.country);
	
	      return adrString.join(', ');
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(community) {
	      var that = this;
	
	      var communityText = "<br/><br/><b>" + community.code + "</b><br/><p>" + community.name + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Community?", "Do you really want to delete this community?" + communityText);
	      dlg.result.then(function () {
	        that.CommunityService.delete({ id: community._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== community._id;
	          });
	        }, function (err) {
	          alert("Could not delete community");
	        });
	      }, function () {});
	    }
	  }]);
	
	  return CommunityListComponent;
	}();
	
	exports.default = angular.module('conduu.communityList', [uiRouter]).config(_communityList2.default).component('communityList', {
	  template: __webpack_require__(460),
	  controller: CommunityListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('community-list', {
	    url: '/community/list',
	    template: '<community-list></community-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <!-- permission permission-only=\"'community.create'\" -->\r\n      <a style=\"float:right; margin-top:4px\" class=\"btn btn-primary\" href=\"/community/edit/\"><i class=\"fa fa-plus\"></i> Create New Community</a>\r\n      <h2>Communities</h2>\r\n      <li class=\"active\"><a href=\"#\">Communities</a></li>\r\n      <div class=\"btn-group\" role=\"group\" style=\"float: right; position:relative; top:-16px\">\r\n        <button type=\"button\" ng-click=\"ctrl.setAsTable(true)\"  class=\"btn btn-default\" ng-class=\"{'active': ctrl.asTable}\"><i class=\"fa fa-fw fa-table\"></i></button>\r\n        <button type=\"button\" ng-click=\"ctrl.setAsTable(false)\" class=\"btn btn-default\" ng-class=\"{'active': !ctrl.asTable}\"><i class=\"fa fa-fw fa-th\"></i></button>\r\n      </div>\r\n    </ol>\r\n\r\n    <div ng-if=\"!ctrl.asTable\" class=\"col-md-4 col-sm-6 col-xs-12\" ng-repeat-start=\"community in ctrl.data track by $index\">\r\n      <div class=\"bs-card\">\r\n        <img class=\"card-img-top\" ng-if=\"community.profilePicture\" ng-src=\"/api/storage/{{community.profilePicture}}\" style=\"width:100%\">\r\n        <div class=\"card-block\">\r\n          <h4 class=\"card-title\"><a ng-href=\"/community/{{community._id}}\"><strong>{{community.code}}: {{community.name}}</strong></a></h4>\r\n          <p class=\"card-text\" ng-bind-html=\"ctrl.getPrimaryAddress(community, true)\"></p>\r\n        </div>\r\n        <div class=\"card-block\">\r\n          <a ng-href=\"/community/edit/{{community._id}}\" class=\"card-link\">Edit</a>\r\n          <a href=\"#\" class=\"card-link text-danger\" ng-click=\"ctrl.delete(community)\">Delete</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"hidden-xs hidden-md hidden-lg\" ng-if=\"$index % 2 == 1\" style=\"clear:both\"></div>\r\n    <div class=\"hidden-xs hidden-sm\" ng-if=\"$index % 3 == 2\" style=\"clear:both\"></div>\r\n    <div ng-repeat-end=\"\"></div>\r\n\r\n    <div ng-if=\"ctrl.asTable\" class=\"col-xs-12\">\r\n      <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>Code</th>\r\n          <th>Name</th>\r\n          <th>Address</th>\r\n          <th>Creation Date</th>\r\n          <th></th>\r\n          <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"community in ctrl.data | orderBy: 'meta.creationDate':true\">\r\n          <td>{{community.code}}</td>\r\n          <td>{{community.name}}</td>\r\n          <td>{{ctrl.getPrimaryAddress(community)}}</td>\r\n          <td>\r\n            <nobr>{{community.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td><a class=\"btn btn-sm btn-primary\" ng-href=\"/community/{{community._id}}\"><i class=\"fa fa-folder-open fa-fw\"></i></a></td>\r\n          <td>\r\n            <nobr>\r\n              <a class=\"btn btn-sm btn-primary\" ng-href=\"/community/edit/{{community._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n              <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(community)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n            </nobr>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CommunityEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _communityEdit = __webpack_require__(462);
	
	var _communityEdit2 = _interopRequireDefault(_communityEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var CommunityEditComponent = exports.CommunityEditComponent = function () {
	  CommunityEditComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'CommunityService', 'SettingsService', '$uibModal'];
	  function CommunityEditComponent(Auth, $state, $stateParams, dialogs, CommunityService, SettingsService, $uibModal) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, CommunityEditComponent);
	
	    this.communityId = $stateParams.id;
	
	    this.dialogs = dialogs;
	    this.CommunityService = CommunityService;
	    this.SettingsService = SettingsService;
	    this.$uibModal = $uibModal;
	    this.Auth = Auth;
	
	    this.activationTypes = [{
	      type: "initial",
	      name: "Initial Password"
	    }, {
	      type: "invitation",
	      name: "Invitation"
	    }];
	
	    this.SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	      _this.phoneTypes = appSettings.data.phoneTypes;
	      _this.mailTypes = appSettings.data.mailTypes;
	      _this.addressTypes = appSettings.data.addressTypes;
	      _this.socialTypes = appSettings.data.socialTypes;
	      _this.webAccessGroupConfig = [{
	        "name": "- None -",
	        "website": "",
	        "code": "",
	        "roles": []
	      }];
	      if (appSettings.data.webAccessGroupConfig) {
	        appSettings.data.webAccessGroupConfig.forEach(function (gcfg) {
	          _this.webAccessGroupConfig.push(gcfg);
	        });
	      }
	    });
	
	    this.SettingsService.getByName({ name: 'custom-fields' }, function (customFieldSettings) {
	      if (customFieldSettings.data.hasOwnProperty("community")) {
	        _this.customSchema = customFieldSettings.data.community;
	        _this.customForm = ["*"];
	      }
	    });
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.model = {
	      phone: [],
	      email: [],
	      web: [],
	      address: [],
	      webAccess: {}
	    };
	
	    if (this.communityId) {
	      this.CommunityService.get({ id: this.communityId }, function (data) {
	        _this.model = data;
	        _this.customFields = _this.model.customFields || {};
	      }, function (err) {
	        console.log('Could not load community data from server');
	      });
	    }
	  }
	
	  _createClass(CommunityEditComponent, [{
	    key: 'getRolesByCode',
	    value: function getRolesByCode(code) {
	      var selected = this.webAccessGroupConfig.find(function (gc) {
	        return gc.code == code;
	      });
	      if (selected) {
	        return selected.roles;
	      }
	    }
	  }, {
	    key: 'removeProfilePicture',
	    value: function removeProfilePicture() {
	      this.model.profilePicture = null;
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {
	              acceptedFileTypes: 'image/*'
	            };
	          }
	        }
	      });
	
	      modalInstance.result.then(function (result) {
	
	        if (result && result.length > 0) {
	          that.model.profilePicture = result[0];
	        }
	      }, function () {});
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this2.communityId ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "The community has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("community-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.model.customFields = this.customFields || {};
	
	        if (this.communityId) {
	          this.CommunityService.update({ id: this.communityId }, this.model, onSuccess, onError);
	        } else {
	          this.model.meta = { creationUser: this.Auth.getCurrentUserSync()._id };
	          this.CommunityService.save(this.model, onSuccess, onError);
	        }
	      }
	    }
	  }, {
	    key: 'addressEdit',
	    value: function addressEdit(idx, address) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'addressEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: address
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (address) {
	
	        that.model.address[idx] = address;
	      }, function () {});
	    }
	  }, {
	    key: 'updatePrimaryPhone',
	    value: function updatePrimaryPhone(idx) {
	      angular.forEach(this.model.phone, function (phone, index) {
	        phone.isPrimary = idx == index;
	      });
	    }
	  }, {
	    key: 'addPhone',
	    value: function addPhone() {
	      this.model.phone.push({
	        type: this.phoneTypes[0],
	        number: '',
	        isPrimary: !this.model.phone.length
	      });
	    }
	  }, {
	    key: 'removePhone',
	    value: function removePhone(idx) {
	      var primaryRemoved = this.model.phone[idx].isPrimary;
	
	      this.model.phone.splice(idx, 1);
	
	      if (primaryRemoved && this.model.phone.length > 0) {
	        this.model.phone[0].isPrimary = true;
	      }
	    }
	  }, {
	    key: 'addSocial',
	    value: function addSocial() {
	      this.model.web.push({
	        type: this.socialTypes[0],
	        link: ''
	      });
	    }
	  }, {
	    key: 'removeSocial',
	    value: function removeSocial(idx) {
	      this.model.web.splice(idx, 1);
	    }
	  }, {
	    key: 'updatePrimaryEmail',
	    value: function updatePrimaryEmail(idx) {
	      angular.forEach(this.model.email, function (email, index) {
	        email.isPrimary = idx == index;
	      });
	    }
	  }, {
	    key: 'addEmail',
	    value: function addEmail() {
	      this.model.email.push({
	        type: this.phoneTypes[0],
	        address: '',
	        isPrimary: !this.model.email.length
	      });
	    }
	  }, {
	    key: 'removeEmail',
	    value: function removeEmail(idx) {
	      var primaryRemoved = this.model.email[idx].isPrimary;
	
	      this.model.email.splice(idx, 1);
	
	      if (primaryRemoved && this.model.email.length > 0) {
	        this.model.email[0].isPrimary = true;
	      }
	    }
	  }, {
	    key: 'updatePrimaryAddress',
	    value: function updatePrimaryAddress(idx) {
	      angular.forEach(this.model.address, function (address, index) {
	        address.isPrimary = idx == index;
	      });
	    }
	  }, {
	    key: 'addAddress',
	    value: function addAddress() {
	      var idx = this.model.address.length;
	      this.addressEdit(idx, {
	        type: this.phoneTypes[0],
	        state: 'FL',
	        isPrimary: !idx
	      });
	    }
	  }, {
	    key: 'removeAddress',
	    value: function removeAddress(idx) {
	      var primaryRemoved = this.model.address[idx].isPrimary;
	
	      this.model.address.splice(idx, 1);
	
	      if (primaryRemoved && this.model.address.length > 0) {
	        this.model.address[0].isPrimary = true;
	      }
	    }
	  }]);
	
	  return CommunityEditComponent;
	}();
	
	exports.default = angular.module('conduu.communityEdit', [uiRouter]).config(_communityEdit2.default).component('communityEdit', {
	  template: __webpack_require__(463),
	  controller: CommunityEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('community-edit', {
	    url: '/community/edit/:id',
	    template: '<community-edit></community-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Community Editor</h2>\r\n      <li><a href=\"/community/list\">Communities</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n        <h3 class=\"separator\"><span>General</span></h3>\r\n\r\n        <!--Community Name -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Name</label>\r\n\r\n          <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"ctrl.model.name\"\r\n                 required/>\r\n          <p class=\"help-block\" ng-show=\"form.name.$error.required && ctrl.submitted\">\r\n            A community name is required\r\n          </p>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6\">\r\n            <!--Community Code -->\r\n            <div class=\"form-group\" ng-class=\"{ 'has-success': form.code.$valid && ctrl.submitted,\r\n                                            'has-error': form.code.$invalid && ctrl.submitted }\">\r\n              <label>Code</label>\r\n\r\n              <input type=\"text\" name=\"code\" class=\"form-control\" ng-model=\"ctrl.model.code\"\r\n                     required/>\r\n              <p class=\"help-block\" ng-show=\"form.code.$error.required && ctrl.submitted\">\r\n                A community code is required\r\n              </p>\r\n            </div>\r\n\r\n            <!-- Max Properties -->\r\n            <div class=\"form-group\" ng-class=\"{ 'has-success': form.maxProperties.$valid && ctrl.submitted,\r\n                                            'has-error': form.maxProperties.$invalid && ctrl.submitted }\">\r\n              <label>Max # of Properties</label>\r\n\r\n              <input type=\"number\" name=\"maxProperties\" class=\"form-control\" ng-model=\"ctrl.model.maxProperties\" />\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <!-- Section: Images -->\r\n            <div class=\"form-group\">\r\n              <label>Picture</label>\r\n              <div>\r\n                <img ng-if=\"!ctrl.model.profilePicture\" src=\"assets/images/nopicture.gif\" style=\"height:100px\" />\r\n                <img ng-if=\"ctrl.model.profilePicture\" ng-src=\"/api/storage/{{ctrl.model.profilePicture}}/thumb\" style=\"height:100px\" />\r\n\r\n                <!--<a ng-if=\"!section.picture\" class=\"btn btn-primary\" ng-click=\"ctrl.openAssetBrowserModal(section)\"><i class=\"fa fa-fw fa-hand-pointer-o\"></i> Select Picture</a>-->\r\n                <a ng-if=\"!ctrl.model.profilePicture\" class=\"btn btn-primary\" ng-click=\"ctrl.openAssetUploadModal()\"><i class=\"fa fa-fw fa-upload\"></i> Upload Picture</a>\r\n\r\n                <a ng-if=\"ctrl.model.profilePicture\" class=\"btn btn-danger\" ng-click=\"ctrl.removeProfilePicture()\"><i class=\"fa fa-fw fa-trash\"></i> Remove Picture</a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <h3 class=\"separator\"><span>Phone <small>&nbsp;&nbsp;<a href=\"#\" style=\"text-decoration: none\" ng-click=\"ctrl.addPhone()\"><i class=\"fa fa fa-plus\"></i> Add</a></small></span></h3>\r\n\r\n        <!-- Phone -->\r\n        <div class=\"form-group\">\r\n          <table ng-show=\"ctrl.model.phone.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\r\n            <thead>\r\n            <tr>\r\n              <th>Type</th>\r\n              <th>Number</th>\r\n              <th>Is Primary?</th>\r\n              <th></th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody ui-sortable ng-model=\"ctrl.model.phone\">\r\n            <tr ng-repeat=\"phone in ctrl.model.phone\" style=\"cursor: move;\">\r\n              <td>\r\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.phoneTypes\" ng-model=\"phone.type\"></select>\r\n              </td>\r\n              <td>\r\n                <input class=\"form-control\" type=\"text\" ui-mask=\"(?9?9?9) ?9?9?9-?9?9?9?9\" ng-model=\"phone.number\" />\r\n              </td>\r\n              <td>\r\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"phone.isPrimary\" ng-click=\"ctrl.updatePrimaryPhone($index)\" />\r\n              </td>\r\n              <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.removePhone($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\r\n              <td style=\"cursor: move; width:16px\">\r\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <h3 class=\"separator\"><span>Email <small>&nbsp;&nbsp;<a href=\"#\" style=\"text-decoration: none\" ng-click=\"ctrl.addEmail()\"><i class=\"fa fa fa-plus\"></i> Add</a></small></span></h3>\r\n\r\n        <!-- Email -->\r\n        <div class=\"form-group\">\r\n          <table ng-show=\"ctrl.model.email.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\r\n            <thead>\r\n            <tr>\r\n              <th>Type</th>\r\n              <th>Email</th>\r\n              <th>Is Primary?</th>\r\n              <th></th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody ui-sortable ng-model=\"ctrl.model.email\">\r\n            <tr ng-repeat=\"email in ctrl.model.email\" style=\"cursor: move;\">\r\n              <td>\r\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.mailTypes\" ng-model=\"email.type\"></select>\r\n              </td>\r\n              <td>\r\n                <input class=\"form-control\" type=\"text\" ng-model=\"email.address\" />\r\n              </td>\r\n              <td>\r\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"email.isPrimary\" ng-click=\"ctrl.updatePrimaryEmail($index)\" />\r\n              </td>\r\n              <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.removeEmail($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\r\n              <td style=\"cursor: move; width:16px\">\r\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <h3 class=\"separator\"><span>Web / Social <small>&nbsp;&nbsp;<a href=\"#\" style=\"text-decoration: none\" ng-click=\"ctrl.addSocial()\"><i class=\"fa fa fa-plus\"></i> Add</a></small></span></h3>\r\n\r\n        <!-- Web -->\r\n        <div class=\"form-group\">\r\n\r\n          <table ng-show=\"ctrl.model.web.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\r\n            <thead>\r\n            <tr>\r\n              <th>Type</th>\r\n              <th>Link</th>\r\n              <th></th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody ui-sortable ng-model=\"ctrl.model.web\">\r\n            <tr ng-repeat=\"web in ctrl.model.web\" style=\"cursor: move;\">\r\n              <td>\r\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.socialTypes\" ng-model=\"web.type\"></select>\r\n              </td>\r\n              <td>\r\n                <input class=\"form-control\" type=\"text\" ng-model=\"web.link\" />\r\n              </td>\r\n              <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.removeSocial($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\r\n              <td style=\"cursor: move; width:16px\">\r\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <h3 class=\"separator\"><span>Address <small>&nbsp;&nbsp;<a href=\"#\" style=\"text-decoration: none\" ng-click=\"ctrl.addAddress()\"><i class=\"fa fa fa-plus\"></i> Add</a></small></span></h3>\r\n\r\n        <!-- Address -->\r\n        <div class=\"form-group\">\r\n          <table ng-show=\"ctrl.model.address.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\r\n            <thead>\r\n            <tr>\r\n              <th>Type</th>\r\n              <th>Address</th>\r\n              <th>Is Primary?</th>\r\n              <th></th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody ui-sortable ng-model=\"ctrl.model.address\">\r\n            <tr ng-repeat=\"address in ctrl.model.address\" style=\"cursor: move;\">\r\n              <td>\r\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.addressTypes\" ng-model=\"address.type\"></select>\r\n              </td>\r\n              <td>\r\n                <a href=\"#\" ng-click=\"ctrl.addressEdit($index,address)\">\r\n                  {{address.street}}<br/>{{address.city}} {{address.state}}, {{address.zip}}\r\n                </a>\r\n              </td>\r\n              <td>\r\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"address.isPrimary\" ng-click=\"ctrl.updatePrimaryAddress($index)\" />\r\n              </td>\r\n              <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.removeAddress($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\r\n              <td style=\"cursor: move; width:16px\">\r\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <!-- ======================================================================================================= -->\r\n\r\n        <!-- Web Access -->\r\n        <h3 class=\"separator\"><span>Web Access</span></h3>\r\n\r\n        <!-- Enabled -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Enabled</label>\r\n\r\n          <input class=\"form-control\" type=\"checkbox\" ng-model=\"ctrl.model.webAccess.enabled\" />\r\n        </div>\r\n\r\n        <!-- Group -->\r\n        <div ng-if=\"ctrl.model.webAccess.enabled\" class=\"form-group\">\r\n          <label>Part of Access Group</label>\r\n\r\n          <select class=\"form-control\" ng-options=\"o.code as o.name for o in ctrl.webAccessGroupConfig\" ng-model=\"ctrl.model.webAccess.accessGroupCode\"></select>\r\n        </div>\r\n\r\n        <!-- Website -->\r\n        <div ng-if=\"ctrl.model.webAccess.enabled && !ctrl.model.webAccess.accessGroupCode\"\r\n             class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Website URL</label>\r\n\r\n          <input type=\"url\" name=\"website\" class=\"form-control\" ng-model=\"ctrl.model.webAccess.website\"\r\n                 required/>\r\n          <p class=\"help-block\" ng-show=\"form.website.$error.required && ctrl.submitted\">\r\n            A website url is required\r\n          </p>\r\n        </div>\r\n\r\n        <!-- Default Roles -->\r\n        <div ng-if=\"ctrl.model.webAccess.enabled\" class=\"form-group\">\r\n          <label>Default Roles</label>\r\n          <tags-input ng-show=\"!ctrl.model.webAccess.accessGroupCode\"\r\n                      use-strings=\"true\" placeholder=\"+ Role\" ng-model=\"ctrl.model.webAccess.defaultRoles\"></tags-input>\r\n          <div ng-if=\"ctrl.model.webAccess.accessGroupCode\">\r\n            <span class=\"label label-primary\" ng-repeat=\"role in ctrl.getRolesByCode(ctrl.model.webAccess.accessGroupCode)\">{{role}}</span>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\" ng-if=\"ctrl.model.webAccess.enabled\">\r\n          <div class=\"col-md-6\">\r\n            <!-- Aditional Owner Role -->\r\n            <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                                'has-error': form.name.$invalid && ctrl.submitted }\">\r\n              <label>Additional Owner Roles</label>\r\n\r\n              <tags-input use-strings=\"true\" placeholder=\"+ Role\" ng-model=\"ctrl.model.webAccess.ownerAddRoles\"></tags-input>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <!-- Aditional Renter Role -->\r\n            <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                                'has-error': form.name.$invalid && ctrl.submitted }\">\r\n              <label>Additional Renter Roles</label>\r\n\r\n              <tags-input use-strings=\"true\" placeholder=\"+ Role\" ng-model=\"ctrl.model.webAccess.renterAddRoles\"></tags-input>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Preferred Activation Type -->\r\n        <div ng-if=\"ctrl.model.webAccess.enabled && !ctrl.model.webAccess.accessGroupCode\"\r\n             class=\"form-group\" ng-class=\"{ 'has-success': form.activationType.$valid && ctrl.submitted,\r\n                                            'has-error': form.activationType.$invalid && ctrl.submitted }\">\r\n          <label>Preferred Activation Type</label>\r\n\r\n          <select name=\"activationType\" ng-options=\"o.type as o.name for o in ctrl.activationTypes\"\r\n                  class=\"form-control\" ng-model=\"ctrl.model.webAccess.activationType\" required>\r\n          </select>\r\n        </div>\r\n\r\n        <!-- Default Initial Password -->\r\n        <div ng-if=\"ctrl.model.webAccess.enabled && ctrl.model.webAccess.activationType == 'initial' && !ctrl.model.webAccess.accessGroupCode\"\r\n             class=\"form-group\" ng-class=\"{ 'has-success': form.defaultPassword.$valid && ctrl.submitted,\r\n                                            'has-error': form.defaultPassword.$invalid && ctrl.submitted }\">\r\n          <label>Default Initial Password</label>\r\n\r\n          <input type=\"text\" name=\"defaultPassword\" class=\"form-control\" ng-model=\"ctrl.model.webAccess.defaultPassword\"\r\n                 required/>\r\n          <p class=\"help-block\" ng-show=\"form.defaultPassword.$error.required && ctrl.submitted\">\r\n            A default password is required\r\n          </p>\r\n        </div>\r\n\r\n        <!-- ======================================================================================================= -->\r\n\r\n        <!-- E-Voting -->\r\n        <h3 class=\"separator\"><span>E-Voting Access</span></h3>\r\n\r\n        <!-- Enabled -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Enabled</label>\r\n\r\n          <input class=\"form-control\" type=\"checkbox\" ng-model=\"ctrl.model.eVoting.enabled\" />\r\n        </div>\r\n\r\n        <!-- E-Voting URL -->\r\n        <div ng-if=\"ctrl.model.eVoting.enabled\"\r\n             class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>E-Voting URL</label>\r\n\r\n          <input type=\"url\" name=\"evotingurl\" class=\"form-control\" ng-model=\"ctrl.model.eVoting.url\"\r\n                 required/>\r\n          <p class=\"help-block\" ng-show=\"form.evotingurl.$error.required && ctrl.submitted\">\r\n            An url is required\r\n          </p>\r\n        </div>\r\n\r\n        <!-- ======================================================================================================= -->\r\n\r\n        <!-- Stripe -->\r\n        <h3 class=\"separator\"><span>Online Payments</span></h3>\r\n\r\n        <!-- Enabled -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Enabled</label>\r\n\r\n          <input class=\"form-control\" type=\"checkbox\" ng-model=\"ctrl.model.stripe.enabled\" />\r\n        </div>\r\n\r\n        <!-- Connected Account Id -->\r\n        <div ng-if=\"ctrl.model.stripe.enabled\"\r\n             class=\"form-group\" ng-class=\"{ 'has-success': form.connectedAccountId.$valid && ctrl.submitted,\r\n                                            'has-error': form.connectedAccountId.$invalid && ctrl.submitted }\">\r\n          <label>Connected Account Id</label>\r\n\r\n          <input type=\"text\" name=\"connectedAccountId\" class=\"form-control\" ng-model=\"ctrl.model.stripe.connectedAccountId\" />\r\n        </div>\r\n\r\n        <!-- Custom Fields -->\r\n\r\n        <div ng-if=\"ctrl.customForm\">\r\n          <h3 class=\"separator\"><span>Custom Fields</span></h3>\r\n          <div sf-schema=\"ctrl.customSchema\" sf-form=\"ctrl.customForm\" sf-model=\"ctrl.customFields\"></div>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <button ng-hide=\"ctrl.communityId\" class=\"btn btn-primary\" type=\"submit\">Create Community</button>\r\n\r\n        <button ng-show=\"ctrl.communityId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"community-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CommunityShowComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _communityShow = __webpack_require__(465);
	
	var _communityShow2 = _interopRequireDefault(_communityShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var CommunityShowComponent = exports.CommunityShowComponent = function () {
	  CommunityShowComponent.$inject = ['$stateParams', 'CommunityService', 'WorkOrderTicketsService', '$uibModal', '$window', 'RecentVisits', 'PinnedItems', '$state', 'StripeService', 'SettingsService', 'CustomEntityService'];
	  function CommunityShowComponent($stateParams, CommunityService, WorkOrderTicketsService, $uibModal, $window, RecentVisits, PinnedItems, $state, StripeService, SettingsService, CustomEntityService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, CommunityShowComponent);
	
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.communityId = $stateParams.id;
	    this.$uibModal = $uibModal;
	    this.$state = $state;
	
	    this.tasks = [];
	    this.activities = [];
	    this.custom = {};
	
	    this.CommunityService = CommunityService;
	    this.StripeService = StripeService;
	    this.RecentVisits = RecentVisits;
	    this.PinnedItems = PinnedItems;
	
	    this.connectedBankingAccounts = [];
	    this.connectedAccountsMap = {};
	
	    this.paymentIntegrationMenu = [{
	      icon: 'info',
	      title: 'Show Details',
	      action: function action(_) {
	        _this.openDetailModal();
	      }
	    }, {
	      icon: 'usd',
	      title: 'Show Payments',
	      action: function action(_) {
	        _this.openStripePaymentsModal();
	      }
	    }];
	
	    SettingsService.getByName({ name: 'custom-entities-views' }, function (settings) {
	      _this.customEntitiesConfig = settings.data.community || { display: [] };
	      _this.customEntitiesConfig.display.forEach(function (customType) {
	        var typeConfig = _this.customEntitiesConfig[customType];
	        _this.custom[customType] = CustomEntityService.getCustomList({ type: customType, refField: typeConfig.refField, refId: $stateParams.id });
	      });
	    });
	
	    this.refreshData();
	
	    WorkOrderTicketsService.getByCommunity({ id: this.communityId }, function (data) {
	      _this.issues = data;
	    });
	  }
	
	  _createClass(CommunityShowComponent, [{
	    key: 'createWorkOrder',
	    value: function createWorkOrder() {
	      this.$state.go('workorder-ticket-edit', { communityId: this.communityId });
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData() {
	      var _this2 = this;
	
	      if (this.communityId) {
	        this.CommunityService.get({ id: this.communityId }, function (data) {
	          _this2.community = data;
	
	          if (_this2.community.stripe.enabled) {
	            var total = _this2.community.stripe.connectedAccountIds.length;
	            var count = 0;
	
	            var doneFn = function doneFn() {
	              _this2.stripeDataLoaded = true;
	            };
	
	            if (!total) {
	              doneFn();
	            }
	
	            _this2.community.stripe.connectedAccountIds.forEach(function (accountId) {
	              _this2.StripeService.getAccount({ id: accountId }, function (account) {
	                _this2.connectedAccountsMap[accountId] = account;
	                _this2.connectedBankingAccounts = _this2.connectedBankingAccounts.concat(account.external_accounts.data.filter(function (act) {
	                  return act.object == 'bank_account';
	                }));
	
	                count++;
	                if (count == total) doneFn();
	              }, function (_) {
	                count++;
	                if (count == total) doneFn();
	              });
	            });
	          }
	
	          _this2.RecentVisits.addPortfolio(_this2.communityId, "community", _this2.community.code + ': ' + _this2.community.name);
	          _this2.isPinned = _this2.PinnedItems.isPinnedPortfolio(_this2.communityId);
	        }, function (err) {
	          console.log('Could not load violation ticket from server');
	        });
	      }
	    }
	  }, {
	    key: 'openDetailModal',
	    value: function openDetailModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'connectedAccountDetails',
	        resolve: {
	          config: function config() {
	            return {
	              data: that.connectedAccount
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }, {
	    key: 'openStripePaymentsModal',
	    value: function openStripePaymentsModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'connectedAccountCharges',
	        resolve: {
	          config: function config() {
	            return {
	              accountId: that.connectedAccount.id,
	              name: that.community.name
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (resultIds) {
	        that.CommunityService.addAttachments({ id: that.communityId }, resultIds, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not add attachments to ticket');
	        });
	      }, function () {});
	    }
	  }]);
	
	  return CommunityShowComponent;
	}();
	
	exports.default = angular.module('conduu.communityShow', [uiRouter]).config(_communityShow2.default).component('communityShow', {
	  template: __webpack_require__(466),
	  controller: CommunityShowComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('community-show', {
	    url: '/community/:id',
	    template: '<community-show></community-show>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <img ng-if=\"ctrl.community.profilePicture\" style=\"float:right;margin-left: 24px; height: 82px; border-radius: 5% 25%\" ng-src=\"/api/storage/{{ctrl.community.profilePicture}}\" />\n      <h2>{{ctrl.community.code}}: {{ctrl.community.name}}</h2>\n      <li><a href=\"/community/list\">Communities</a></li>\n      <li class=\"active\"><a href=\"#\">{{ctrl.community.code}}: {{ctrl.community.name}}</a></li>\n    </ol>\n\n    <div class=\"col-md-6\">\n      <h3 style=\"margin-top: 0\" class=\"separator\"><span>General</span></h3>\n      <dl class=\"dl-horizontal\">\n        <dt>Community</dt>\n        <dd>{{ctrl.community.name}}</dd>\n\n        <dt>Code</dt>\n        <dd>{{ctrl.community.code}}</dd>\n\n        <dt>Max Properties</dt>\n        <dd>{{ctrl.community.maxProperties}}</dd>\n      </dl>\n\n      <!-- Stripe onbaording -->\n      <div ng-if=\"ctrl.community.stripe.enabled && !ctrl.community.stripe.connectedAccountId && !ctrl.community.stripe.connectedAccountIds.length\">\n        <h3 class=\"separator\"><span>Payment Integration</span></h3>\n        <a ng-href=\"/api/integrations/stripe/onboard/{{ctrl.community._id}}\" target=\"_blank\"><i class=\"fa fa-fw fa-external-link\"></i> Stripe Account Onboarding</a>\n        <br/>\n        <br/>\n      </div>\n\n      <!-- Stripe Details -->\n      <div ng-if=\"ctrl.community.stripe.enabled && (ctrl.community.stripe.connectedAccountId || ctrl.community.stripe.connectedAccountIds.length)\">\n        <h3 class=\"separator\"><span>Payment Integration <small><header-dropdown-menu icon=\"info\" title=\"\" menu=\"ctrl.paymentIntegrationMenu\"></header-dropdown-menu></small></span></h3>\n        <dl class=\"dl-horizontal\">\n\n          <dt ng-hide=\"ctrl.connectedBankingAccounts.length || ctrl.stripeDataLoaded\">Banking Account</dt>\n          <dd ng-hide=\"ctrl.connectedBankingAccounts.length || ctrl.stripeDataLoaded\"><i class=\"fa fa-spinner fa-pulse fa-fw\"></i></dd>\n\n          <dt ng-repeat-start=\"account in ctrl.connectedBankingAccounts\">Banking Account</dt>\n          <dd ng-repeat-end=\"\">***{{account.last4}} ({{account.bank_name}})</dd>\n\n          <dt>Stripe</dt>\n          <dd><i class=\"fa fa-fw fa-external-link\"></i> <a href=\"https://dashboard.stripe.com/\" target=\"_blank\">Payment Dashboard</a> | <i class=\"fa fa-fw fa-external-link\"></i> <a ng-href=\"/api/integrations/stripe/onboard/{{ctrl.community._id}}\" target=\"_blank\">Account Onboarding</a></dd>\n        </dl>\n      </div>\n\n      <h3 ng-if=\"ctrl.community.address.length\" style=\"margin-top: 0\" class=\"separator\"><span>Address</span></h3>\n      <dl class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"address in ctrl.community.address\">{{address.type}}</dt>\n        <dd ng-repeat-end=\"\">{{address.street}}<br/>{{address.city}} {{address.state}}, {{address.zip}}</dd>\n      </dl>\n    </div>\n\n    <div class=\"col-md-6\">\n      <h3 ng-if=\"ctrl.community.phone.length\" style=\"margin-top: 0\" class=\"separator\"><span>Phone</span></h3>\n      <dl class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"phone in ctrl.community.phone\">{{phone.type}}</dt>\n        <dd ng-repeat-end=\"\">{{phone.number | usPhone}}</dd>\n      </dl>\n\n      <h3 ng-if=\"ctrl.community.email.length\" style=\"margin-top: 0\" class=\"separator\"><span>Email</span></h3>\n      <dl class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"email in ctrl.community.email\">{{email.type}}</dt>\n        <dd ng-repeat-end=\"\">{{email.address}}</dd>\n      </dl>\n\n      <h3 ng-if=\"ctrl.community.web.length\" style=\"margin-top: 0\" class=\"separator\"><span>Web / Social</span></h3>\n      <dl class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"web in ctrl.community.web\">{{web.type}}</dt>\n        <dd ng-repeat-end=\"\">{{web.link}}</dd>\n      </dl>\n    </div>\n\n    <div style=\"clear: both\"></div>\n\n    <div class=\"col-xs-12\">\n\n      <h3 class=\"separator\"><span>Open Work Orders</span></h3>\n      <button class=\"btn btn-sm btn-primary\" style=\"float:right\" ng-click=\"ctrl.createWorkOrder()\"><i class=\"fa fa-fw fa-wrench\"></i> Create Work Order</button>\n      <h5 ng-show=\"!ctrl.issues.length\">No Open Work Orders for this Community</h5>\n      <dl ng-if=\"ctrl.issues.length\" class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"issue in ctrl.issues | orderBy: 'meta.creationDate':false\">Work Order</dt>\n        <dd ng-repeat-end=\"\"><a ng-href=\"/workorder/ticket/detail/{{issue._id}}\">{{issue.code}}: {{issue.name}}</a> <span class=\"text-muted\">from {{issue.meta.creationDate | date:'MM/dd/yyyy'}}</span></dd>\n      </dl>\n\n      <div  ng-repeat=\"customType in ctrl.customEntitiesConfig.display\">\n        <h3 ng-if=\"ctrl.custom[customType].length\" class=\"separator\"><span>{{ctrl.customEntitiesConfig[customType].title}}</span></h3>\n\n        <dl ng-if=\"ctrl.custom[customType].length\" class=\"dl-horizontal\">\n          <dt ng-repeat-start=\"entity in ctrl.custom[customType] | orderBy: 'meta.creationDate':false\" bind-dynamic-page=\"ctrl.customEntitiesConfig[customType].dtTemplate\"></dt>\n          <dd ng-repeat-end=\"\" bind-dynamic-page=\"ctrl.customEntitiesConfig[customType].ddTemplate\"></dd>\n        </dl>\n      </div>\n\n      <nta-section context=\"community\" context-id=\"ctrl.communityId\" data=\"ctrl.community\" service=\"ctrl.CommunityService\" on-refresh=\"ctrl.refreshData()\"></nta-section>\n\n      <h3 class=\"separator\"><span>Attachments <small><a href=\"#\" ng-click=\"ctrl.openAssetUploadModal()\"><i class=\"fa fa-upload\"></i> Upload Files</a></small></span></h3>\n\n      <attachment-list attachments=\"ctrl.community.attachments\" context-id=\"ctrl.communityId\" service=\"ctrl.CommunityService\"></attachment-list>\n\n      <br/>\n\n      <div style=\"float:right\" >\n        <label>{{ctrl.isPinned ? 'Pinned' : \"Not Pinned\"}}&nbsp;</label> <toggle ng-model=\"ctrl.isPinned\" ng-change=\"ctrl.PinnedItems.togglePortfolio(ctrl.communityId, 'community', ctrl.community.code + ': ' + ctrl.community.name)\" on=\"<i class='fa fa-fw fa-map-pin'>\" off=\"<i class='fa fa-fw fa-times'>\" onstyle=\"btn-success\" offstyle=\"btn-default\"></toggle>\n      </div>\n      <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\n\n    </div>\n\n  </div>\n</div>\n\n"

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContactListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contactList = __webpack_require__(468);
	
	var _contactList2 = _interopRequireDefault(_contactList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ContactListComponent = exports.ContactListComponent = function () {
	  ContactListComponent.$inject = ['Auth', 'ContactService', 'dialogs', 'DTOptionsBuilder', 'DTDefaultOptions', 'DTState', 'Util'];
	  function ContactListComponent(Auth, ContactService, dialogs, DTOptionsBuilder, DTDefaultOptions, DTState, Util) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ContactListComponent);
	
	    this.ContactService = ContactService;
	    this.data = [];
	
	    this.dialogs = dialogs;
	
	    DTDefaultOptions.setLoadingTemplate("<datatable-loading-placeholder columns='Name, Address, Phone, Mail, Creation Date' />");
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'asc']).withOption('deferRender', true).withOption('initComplete', function (_) {
	      _this.initComplete = true;
	    }).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Contacts",
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }, {
	      extend: 'csv',
	      title: "Contacts",
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }, {
	      title: "Contacts",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'landscape',
	      pageSize: 'LETTER',
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }, {
	      extend: 'print',
	      title: "Contacts",
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }]);
	
	    this.dtOptions.columnDefs = [{
	      targets: [0, 1],
	      render: Util.dataTableExportBreakToNewlineRenderer
	    }];
	
	    this.ContactService.query(function (data) {
	      _this.data = data;
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve contacts.");
	    });
	  }
	
	  _createClass(ContactListComponent, [{
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += "<br/>" + contact.company;
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'getPrimaryEmailSoftBreak',
	    value: function getPrimaryEmailSoftBreak(contact) {
	      var email = this.getPrimaryEmail(contact);
	
	      return email.replace('@', '@&#8203;').replace('.', '&#8203;.').replace('-', '-&#8203;').replace('_', '_&#8203;');
	    }
	  }, {
	    key: 'getPrimaryEmail',
	    value: function getPrimaryEmail(contact) {
	      if (!contact || !contact.email || !contact.email.length) return "-";
	
	      var email = contact.email.find(function (email) {
	        return email.isPrimary;
	      }) || contact.email[0] || { address: '-' };
	
	      return email.address;
	    }
	  }, {
	    key: 'getPrimaryPhone',
	    value: function getPrimaryPhone(contact) {
	      if (!contact || !contact.phone || !contact.phone.length) return "-";
	
	      var phone = contact.phone.find(function (phone) {
	        return phone.isPrimary;
	      }) || contact.phone[0] || { number: '-' };
	
	      return phone.number;
	    }
	  }, {
	    key: 'getPrimaryAddress',
	    value: function getPrimaryAddress(contact) {
	      if (!contact || !contact.address || !contact.address.length) return "-";
	
	      var address = contact.address.find(function (adr) {
	        return adr.isPrimary;
	      }) || contact.address[0] || {};
	
	      return address.street + "<br/>" + address.city + ', ' + address.state + ' ' + address.zip;
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(contact) {
	      var that = this;
	
	      var contactText = "<br/><br/><b>" + contact.lastName + "</b><br/><p>" + contact.firstName + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Contact?", "Do you really want to delete this contact?" + contactText);
	      dlg.result.then(function () {
	        that.ContactService.delete({ id: contact._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== contact._id;
	          });
	        }, function (err) {
	          alert("Could not delete contact");
	        });
	      }, function () {});
	    }
	  }]);
	
	  return ContactListComponent;
	}();
	
	exports.default = angular.module('conduu.contactList', [uiRouter]).config(_contactList2.default).component('contactList', {
	  template: __webpack_require__(469),
	  controller: ContactListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('contact-list', {
	    url: '/contact/list',
	    template: '<contact-list></contact-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" href=\"/contact/edit/\"><i class=\"fa fa-plus\"></i> Create New Contact</a>\r\n      <h2>Contacts</h2>\r\n      <li class=\"active\"><a href=\"#\">Contacts</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <datatable-loading-placeholder ng-hide=\"ctrl.dataInitComplete\" columns=\"Name, Address, Phone, Mail, Creation Date\" />\r\n\r\n      <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>Name</th>\r\n          <th>Address</th>\r\n          <th>Phone</th>\r\n          <th>Mail</th>\r\n          <th>Creation Date</th>\r\n          <th></th>\r\n          <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"contact in ctrl.data | orderBy: 'meta.creationDate':true\">\r\n          <td><a ng-href=\"/contact/{{contact._id}}\" ng-bind-html=\"ctrl.getComposedName(contact)\"></a></td>\r\n          <td ng-bind-html=\"ctrl.getPrimaryAddress(contact)\"></td>\r\n          <td>{{ctrl.getPrimaryPhone(contact) | usPhone}}</td>\r\n          <td><a ng-href=\"mailto:{{ctrl.getPrimaryEmail(contact)}}\" ng-bind-html=\"ctrl.getPrimaryEmailSoftBreak(contact)\"></a></td>\r\n          <td>\r\n            <nobr>{{contact.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td><a class=\"btn btn-sm btn-primary\" ng-href=\"/contact/{{contact._id}}\"><i class=\"fa fa-folder-open fa-fw\"></i></a></td>\r\n          <td>\r\n            <nobr>\r\n              <a class=\"btn btn-sm btn-primary\" ng-href=\"/contact/edit/{{contact._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n              <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(contact)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n            </nobr>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContactEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contactEdit = __webpack_require__(471);
	
	var _contactEdit2 = _interopRequireDefault(_contactEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ContactEditComponent = exports.ContactEditComponent = function () {
	  ContactEditComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'ContactService', 'SettingsService', '$uibModal', '$window'];
	  function ContactEditComponent(Auth, $state, $stateParams, dialogs, ContactService, SettingsService, $uibModal, $window) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ContactEditComponent);
	
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.contactId = $stateParams.id;
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.ContactService = ContactService;
	    this.SettingsService = SettingsService;
	    this.Auth = Auth;
	
	    this.SettingsService.getByName({ name: 'custom-fields' }, function (customFieldSettings) {
	      if (customFieldSettings.data.hasOwnProperty("contact")) {
	        _this.customSchema = customFieldSettings.data.contact;
	        _this.customForm = ["*"];
	      }
	    });
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	      _this.phoneTypes = appSettings.data.phoneTypes;
	      _this.mailTypes = appSettings.data.mailTypes;
	      _this.addressTypes = appSettings.data.addressTypes;
	      _this.socialTypes = appSettings.data.socialTypes;
	    });
	
	    this.model = {
	      phone: [],
	      email: [],
	      web: [],
	      address: [],
	      customFields: {}
	    };
	
	    this.customFields = {};
	
	    if (this.contactId) {
	      this.ContactService.get({ id: this.contactId }, function (data) {
	        _this.model = data;
	        if (!_this.model.address) _this.model.address = [];
	
	        _this.customFields = _this.model.customFields || {};
	      }, function (err) {
	        console.log('Could not load contact data from server');
	      });
	    }
	  }
	
	  _createClass(ContactEditComponent, [{
	    key: 'addressEdit',
	    value: function addressEdit(idx, address) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'addressEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: address
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (address) {
	
	        that.model.address[idx] = address;
	      }, function () {});
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this2.codeId ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "The contact has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("contact-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.model.customFields = this.customFields || {};
	
	        if (this.contactId) {
	          this.ContactService.update({ id: this.contactId }, this.model, onSuccess, onError);
	        } else {
	          this.model.meta = { creationUser: this.Auth.getCurrentUserSync()._id };
	          this.ContactService.save(this.model, onSuccess, onError);
	        }
	      }
	    }
	  }, {
	    key: 'updatePrimaryPhone',
	    value: function updatePrimaryPhone(idx) {
	      angular.forEach(this.model.phone, function (phone, index) {
	        phone.isPrimary = idx == index;
	      });
	    }
	  }, {
	    key: 'addPhone',
	    value: function addPhone() {
	      this.model.phone.push({
	        type: this.phoneTypes[0],
	        number: '',
	        isPrimary: !this.model.phone.length
	      });
	    }
	  }, {
	    key: 'removePhone',
	    value: function removePhone(idx) {
	      var primaryRemoved = this.model.phone[idx].isPrimary;
	
	      this.model.phone.splice(idx, 1);
	
	      if (primaryRemoved && this.model.phone.length > 0) {
	        this.model.phone[0].isPrimary = true;
	      }
	    }
	  }, {
	    key: 'addSocial',
	    value: function addSocial() {
	      this.model.web.push({
	        type: this.socialTypes[0],
	        link: ''
	      });
	    }
	  }, {
	    key: 'removeSocial',
	    value: function removeSocial(idx) {
	      this.model.web.splice(idx, 1);
	    }
	  }, {
	    key: 'updatePrimaryEmail',
	    value: function updatePrimaryEmail(idx) {
	      angular.forEach(this.model.email, function (email, index) {
	        email.isPrimary = idx == index;
	      });
	    }
	  }, {
	    key: 'addEmail',
	    value: function addEmail() {
	      this.model.email.push({
	        type: this.mailTypes[0],
	        address: '',
	        isPrimary: !this.model.email.length
	      });
	    }
	  }, {
	    key: 'removeEmail',
	    value: function removeEmail(idx) {
	      var primaryRemoved = this.model.email[idx].isPrimary;
	
	      this.model.email.splice(idx, 1);
	
	      if (primaryRemoved && this.model.email.length > 0) {
	        this.model.email[0].isPrimary = true;
	      }
	    }
	  }, {
	    key: 'updatePrimaryAddress',
	    value: function updatePrimaryAddress(idx) {
	      angular.forEach(this.model.address, function (address, index) {
	        address.isPrimary = idx == index;
	      });
	    }
	  }, {
	    key: 'updateMailingAddress',
	    value: function updateMailingAddress(idx) {
	      if (this.model.address[idx].isMailing) {
	        angular.forEach(this.model.address, function (address, index) {
	          address.isMailing = idx == index;
	        });
	      } else {
	        this.model.address[idx].isMailing = false;
	      }
	    }
	  }, {
	    key: 'addAddress',
	    value: function addAddress() {
	      var idx = this.model.address.length;
	      this.addressEdit(idx, {
	        type: this.phoneTypes[0],
	        state: 'FL',
	        isPrimary: !idx
	      });
	    }
	  }, {
	    key: 'removeAddress',
	    value: function removeAddress(idx) {
	      var primaryRemoved = this.model.address[idx].isPrimary;
	
	      this.model.address.splice(idx, 1);
	
	      if (primaryRemoved && this.model.address.length > 0) {
	        this.model.address[0].isPrimary = true;
	      }
	    }
	  }]);
	
	  return ContactEditComponent;
	}();
	
	exports.default = angular.module('conduu.contactEdit', [uiRouter]).config(_contactEdit2.default).component('contactEdit', {
	  template: __webpack_require__(472),
	  controller: ContactEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('contact-edit', {
	    url: '/contact/edit/:id',
	    template: '<contact-edit></contact-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <h2>Contact Editor</h2>\n      <li><a href=\"/contact/list\">Contacts</a></li>\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\n    </ol>\n\n    <div class=\"col-xs-12\">\n\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\n\n        <h3 class=\"separator\"><span>Name</span></h3>\n\n        <div class=\"col-sm-4\" style=\"padding:0px\">\n          <!-- First Name -->\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.firstName.$valid && ctrl.submitted,\n                                            'has-error': form.firstName.$invalid && ctrl.submitted }\">\n            <label>First</label>\n\n            <input type=\"text\" name=\"firstName\" class=\"form-control\" ng-model=\"ctrl.model.firstName\" />\n          </div>\n        </div>\n\n        <div class=\"col-sm-4\" style=\"padding-right:0px\">\n          <!-- Middle Name -->\n          <div class=\"form-group\"  ng-class=\"{ 'has-success': form.middleName.$valid & $ctrl.submitted,\n                                            'has-error': form.middleName.$invalid && ctrl.submitted }\">\n            <label>Middle</label>\n\n            <input type=\"text\" name=\"middleName\" class=\"form-control\" ng-model=\"ctrl.model.middleName\" />\n          </div>\n        </div>\n\n        <div class=\"col-sm-4\" style=\"padding-right:0px\">\n          <!-- Last Name -->\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.lastName.$valid && ctrl.submitted,\n                                            'has-error': form.lastName.$invalid && ctrl.submitted }\">\n            <label>Last</label>\n\n            <input type=\"text\" name=\"lastName\" class=\"form-control\" ng-model=\"ctrl.model.lastName\" />\n          </div>\n        </div>\n\n        <div class=\"col-sm-12\" style=\"padding-left:0px; padding-right: 0px\">\n          <!-- Comapny, Trust, Seconnd Contact Line -->\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.company.$valid && ctrl.submitted,\n                                            'has-error': form.company.$invalid && ctrl.submitted }\">\n            <label>Company / Trust / Additional Name</label>\n\n            <input type=\"text\" name=\"company\" class=\"form-control\" ng-model=\"ctrl.model.company\" />\n          </div>\n        </div>\n\n        <div class=\"col-sm-12\" style=\"padding-left:0px\">\n          <!-- Privacy -->\n          <label><input type=\"checkbox\" name=\"hideInDirectory\" ng-model=\"ctrl.model.hideInDirectory\" /> Hide Contact in Web Portal Directory</label>\n        </div>\n\n        <div style=\"clear:both\"></div>\n\n        <h3 class=\"separator\"><span>Phone <small>&nbsp;&nbsp;<a href=\"#\" style=\"text-decoration: none\" ng-click=\"ctrl.addPhone()\"><i class=\"fa fa fa-plus\"></i> Add</a></small></span></h3>\n\n        <!-- Phone -->\n        <div class=\"form-group\">\n          <table ng-show=\"ctrl.model.phone.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\n            <thead>\n            <tr>\n              <th>Type</th>\n              <th>Number</th>\n              <th>Is Primary?</th>\n              <th>Is Private?</th>\n              <th></th>\n              <th></th>\n            </tr>\n            </thead>\n            <tbody ui-sortable ng-model=\"ctrl.model.phone\">\n            <tr ng-repeat=\"phone in ctrl.model.phone\" style=\"cursor: move;\">\n              <td>\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.phoneTypes\" ng-model=\"phone.type\"></select>\n              </td>\n              <td>\n                <input class=\"form-control\" type=\"text\" ui-mask=\"(?9?9?9) ?9?9?9-?9?9?9?9\" ng-model=\"phone.number\" />\n              </td>\n              <td>\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"phone.isPrimary\" ng-click=\"ctrl.updatePrimaryPhone($index)\" />\n              </td>\n              <td>\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"phone.isPrivate\" />\n              </td>\n              <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.removePhone($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\n              <td style=\"cursor: move; width:16px\">\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\n              </td>\n            </tr>\n            </tbody>\n          </table>\n        </div>\n\n        <h3 class=\"separator\"><span>Email <small>&nbsp;&nbsp;<a href=\"#\" style=\"text-decoration: none\" ng-click=\"ctrl.addEmail()\"><i class=\"fa fa fa-plus\"></i> Add</a></small></span></h3>\n\n        <!-- Email -->\n        <div class=\"form-group\">\n          <table ng-show=\"ctrl.model.email.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\n            <thead>\n            <tr>\n              <th>Type</th>\n              <th>Email</th>\n              <th>Is Primary?</th>\n              <th>Is Private?</th>\n              <th></th>\n              <th></th>\n            </tr>\n            </thead>\n            <tbody ui-sortable ng-model=\"ctrl.model.email\">\n            <tr ng-repeat=\"email in ctrl.model.email\" style=\"cursor: move;\">\n              <td>\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.mailTypes\" ng-model=\"email.type\"></select>\n              </td>\n              <td>\n                <input class=\"form-control\" type=\"text\" ng-model=\"email.address\" />\n              </td>\n              <td>\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"email.isPrimary\" ng-click=\"ctrl.updatePrimaryEmail($index)\" />\n              </td>\n              <td>\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"email.isPrivate\" />\n              </td>\n              <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.removeEmail($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\n              <td style=\"cursor: move; width:16px\">\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\n              </td>\n            </tr>\n            </tbody>\n          </table>\n        </div>\n\n        <h3 class=\"separator\"><span>Web / Social <small>&nbsp;&nbsp;<a href=\"#\" style=\"text-decoration: none\" ng-click=\"ctrl.addSocial()\"><i class=\"fa fa fa-plus\"></i> Add</a></small></span></h3>\n\n        <!-- Web -->\n        <div class=\"form-group\">\n\n          <table ng-show=\"ctrl.model.web.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\n            <thead>\n            <tr>\n              <th>Type</th>\n              <th>Link</th>\n              <th></th>\n              <th></th>\n            </tr>\n            </thead>\n            <tbody ui-sortable ng-model=\"ctrl.model.web\">\n            <tr ng-repeat=\"web in ctrl.model.web\" style=\"cursor: move;\">\n              <td>\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.socialTypes\" ng-model=\"web.type\"></select>\n              </td>\n              <td>\n                <input class=\"form-control\" type=\"text\" ng-model=\"web.link\" />\n              </td>\n              <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.removeSocial($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\n              <td style=\"cursor: move; width:16px\">\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\n              </td>\n            </tr>\n            </tbody>\n          </table>\n        </div>\n\n        <h3 class=\"separator\"><span>Address <small>&nbsp;&nbsp;<a href=\"#\" style=\"text-decoration: none\" ng-click=\"ctrl.addAddress()\"><i class=\"fa fa fa-plus\"></i> Add</a></small></span></h3>\n\n        <!-- Address -->\n        <div class=\"form-group\">\n          <table ng-show=\"ctrl.model.address.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\n            <thead>\n            <tr>\n              <th>Type</th>\n              <th>Address</th>\n              <th>Is Primary?</th>\n              <th>Is Mailing?</th>\n              <th>Is Private?</th>\n              <th></th>\n              <th></th>\n            </tr>\n            </thead>\n            <tbody ui-sortable ng-model=\"ctrl.model.address\">\n            <tr ng-repeat=\"address in ctrl.model.address\" style=\"cursor: move;\">\n              <td>\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.addressTypes\" ng-model=\"address.type\"></select>\n              </td>\n              <td>\n                <a href=\"#\" ng-click=\"ctrl.addressEdit($index,address)\">\n                  {{address.street}}<br/>{{address.city}}, {{address.state}} {{address.zip}}\n                </a>\n              </td>\n              <td>\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"address.isPrimary\" ng-click=\"ctrl.updatePrimaryAddress($index)\" />\n              </td>\n              <td>\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"address.isMailing\" ng-click=\"ctrl.updateMailingAddress($index)\" />\n              </td>\n              <td>\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"address.isPrivate\" />\n              </td>\n              <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.removeAddress($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\n              <td style=\"cursor: move; width:16px\">\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\n              </td>\n            </tr>\n            </tbody>\n          </table>\n        </div>\n\n        <div ng-if=\"ctrl.customForm\">\n          <h3 class=\"separator\"><span>Custom Fields</span></h3>\n          <div sf-schema=\"ctrl.customSchema\" sf-form=\"ctrl.customForm\" sf-model=\"ctrl.customFields\"></div>\n        </div>\n\n        <br/>\n\n        <button ng-hide=\"ctrl.contactId\" class=\"btn btn-primary\" type=\"submit\">Create Contact</button>\n\n        <button ng-show=\"ctrl.contactId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\n        <a class=\"btn btn-warning\" href=\"#\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-times\"></i> Cancel</a>\n      </form>\n\n    </div>\n\n  </div>\n</div>\n\n"

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContactShowComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contactShow = __webpack_require__(474);
	
	var _contactShow2 = _interopRequireDefault(_contactShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ContactShowComponent = exports.ContactShowComponent = function () {
	  ContactShowComponent.$inject = ['$stateParams', 'CommunityService', 'ContactService', '$uibModal', '$window', 'RecentVisits', 'PinnedItems', 'PropertyService', 'TaskService', 'ServiceRequestTicketsService', 'WorkOrderTicketsService', 'ViolationTicketsService', 'WebAccessService', 'QuickbooksImportService', 'CustomEntityService', 'SettingsService', 'StripeService'];
	  function ContactShowComponent($stateParams, CommunityService, ContactService, $uibModal, $window, RecentVisits, PinnedItems, PropertyService, TaskService, ServiceRequestTicketsService, WorkOrderTicketsService, ViolationTicketsService, WebAccessService, QuickbooksImportService, CustomEntityService, SettingsService, StripeService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ContactShowComponent);
	
	    this.back = function (_) {
	      return $window.history.back();
	    };
	    this.QuickbooksImportService = QuickbooksImportService;
	    this.StripeService = StripeService;
	
	    this.contactId = $stateParams.id;
	    this.$uibModal = $uibModal;
	
	    this.tasks = [];
	    this.activities = [];
	    this.custom = [];
	    this.balances = [];
	
	    this.contactTypesMap = {};
	    this.contactTypes = [];
	
	    this.count = {
	      workOrders: 0,
	      violations: 0,
	      serviceRequests: 0,
	      tasks: 0
	    };
	
	    this.SettingsService = SettingsService;
	    this.ContactService = ContactService;
	    this.RecentVisits = RecentVisits;
	    this.PinnedItems = PinnedItems;
	    this.PropertyService = PropertyService;
	    this.CommunityService = CommunityService;
	
	    this.TaskService = TaskService;
	    this.ServiceRequestTicketsService = ServiceRequestTicketsService;
	    this.WorkOrderTicketsService = WorkOrderTicketsService;
	    this.ViolationTicketsService = ViolationTicketsService;
	
	    CommunityService.query(function (data) {
	      _this.communities = data;
	      _this.communityMap = {};
	      data.forEach(function (cmty) {
	        return _this.communityMap[cmty.code] = cmty.name;
	      });
	    });
	
	    WebAccessService.getByContact({ contactId: this.contactId }, function (data) {
	      _this.webaccess = data;
	    });
	
	    SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	      _this.contactTypesMap = appSettings.data.contactTypesMap;
	      _this.contactTypes = Object.keys(_this.contactTypesMap);
	    });
	
	    SettingsService.getByName({ name: 'custom-fields-views' }, function (settings) {
	      _this.customFieldsConfig = settings.data.contact || {};
	    });
	
	    SettingsService.getByName({ name: 'custom-entities-views' }, function (settings) {
	      _this.customEntitiesConfig = settings.data.contact || { display: [] };
	      _this.customEntitiesConfig.display.forEach(function (customType) {
	        var typeConfig = _this.customEntitiesConfig[customType];
	        _this.custom[customType] = CustomEntityService.getCustomList({ type: customType, refField: typeConfig.refField, refId: $stateParams.id });
	      });
	    });
	
	    this.refreshData();
	  }
	
	  _createClass(ContactShowComponent, [{
	    key: 'getSectionTemplate',
	    value: function getSectionTemplate(section) {
	      if (!this.customFieldsConfig.sectionTemplate || !this.customFieldsConfig.sectionTemplate[section]) return null;
	
	      return this.customFieldsConfig.sectionTemplate[section];
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	
	        composedName = contact.firstName;
	
	        if (contact.middleName) composedName += " " + contact.middleName;
	
	        composedName += " " + contact.lastName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += ", " + contact.company;
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'getPrimaryEmail',
	    value: function getPrimaryEmail(contact) {
	      if (!contact || !contact.email || !contact.email.length) return "-";
	
	      var email = contact.email.find(function (email) {
	        return email.isPrimary;
	      }) || contact.email[0] || { address: '-' };
	
	      return email.address;
	    }
	  }, {
	    key: 'getAssociations',
	    value: function getAssociations(wa) {
	      var _this2 = this;
	
	      if (wa.associations && wa.associations.length) {
	        return wa.associations.map(function (code) {
	          return _this2.communityMap[code];
	        }).join(', ');
	      } else {
	        return this.communityMap[wa.associationOrGroupCode];
	      }
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(address) {
	      try {
	        return address.street + ', ' + address.city + ', ' + address.state + ' ' + address.zip;
	      } catch (e) {
	        return "-";
	      }
	    }
	  }, {
	    key: 'getAccessForLabel',
	    value: function getAccessForLabel(wa) {
	      if (!wa) return "";
	
	      var assns = this.getAssociations(wa);
	
	      if (assns && wa.eVotingCode) {
	        return assns + " and E-Voting (" + wa.eVotingCode + ")";
	      } else if (assns) {
	        return assns;
	      } else if (wa.eVotingCode) {
	        return "E-Voting (" + wa.eVotingCode + ")";
	      }
	
	      return "";
	    }
	  }, {
	    key: 'getContactType',
	    value: function getContactType(contact) {
	      if (this.contactTypesMap && this.contactTypes.includes(contact.type)) return this.contactTypesMap[contact.type];
	
	      return contact.type.split("-").join(" ");
	    }
	  }, {
	    key: 'getSectionEditAction',
	    value: function getSectionEditAction(section) {
	      if (!this.customFieldsConfig.editAction || !this.customFieldsConfig.editAction[section]) return null;
	
	      return this.customFieldsConfig.editAction[section];
	    }
	  }, {
	    key: 'editSection',
	    value: function editSection(section) {
	      var _this3 = this;
	
	      var fields = this.getSectionEditAction(section).split(',').map(function (field) {
	        return field.trim();
	      });
	
	      var that = this;
	
	      this.SettingsService.getByName({ name: 'custom-fields' }, function (customFieldSettings) {
	        if (customFieldSettings.data.hasOwnProperty("contact")) {
	          var customSchema = customFieldSettings.data.contact;
	
	          var sectionSchema = {
	            type: "object",
	            properties: {}
	          };
	
	          fields.forEach(function (field) {
	            sectionSchema.properties[field] = angular.copy(customSchema.properties[field]);
	          });
	
	          var REGEX_ALL = /([^\W_]+[^\s-]*) */g;
	          var REGEX_FIRST = /([^\W_]+[^\s-]*)/;
	          var capitalize = function capitalize(input, all) {
	            if (!input) return '';
	            var regex = all ? REGEX_ALL : REGEX_FIRST;
	            return input.replace(regex, function (txt) {
	              return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	            });
	          };
	
	          var modalInstance = _this3.$uibModal.open({
	            animation: true,
	            component: 'schemaFormModal',
	            resolve: {
	              config: function config() {
	                return {
	                  title: capitalize(section, true),
	                  icon: "pencil-square-o",
	                  model: that.contact.customFields ? angular.copy(that.contact.customFields) : {},
	                  schema: sectionSchema
	                };
	              }
	            },
	            size: 'md'
	          });
	
	          modalInstance.result.then(function (editedCustomFields) {
	
	            that.contact.customFields = editedCustomFields;
	
	            that.ContactService.update({ id: that.contactId }, that.contact, function (_) {
	              that.refreshData();
	            }, function (err) {
	              console.log('could not edit contacts of property');
	            });
	          }, function () {});
	        }
	      });
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData() {
	      var _this4 = this;
	
	      if (this.contactId) {
	        this.ContactService.get({ id: this.contactId }, function (data) {
	          _this4.contact = data;
	
	          _this4.PropertyService.getPropertiesByVoter({ contactId: _this4.contactId }, function (data) {
	            _this4.voterRelations = data.map(function (property) {
	              return {
	                type: "Property",
	                propertyId: property._id,
	                property: _this4.getAddress(property.address) + (' / ' + property.lotNo),
	                lotNo: property.lotNo,
	                communityId: property.community._id,
	                community: property.community.code + ': ' + property.community.name
	              };
	            });
	          });
	
	          _this4.PropertyService.getByContact({ contactId: _this4.contactId }, function (data) {
	            _this4.propertyRelations = data.map(function (property) {
	              var idx = property.contacts.findIndex(function (contact) {
	                return contact.contact == _this4.contactId;
	              });
	
	              if (idx != -1) {
	                return {
	                  type: _this4.getContactType(property.contacts[idx]),
	                  propertyId: property._id,
	                  property: _this4.getAddress(property.address) + (' / ' + property.lotNo),
	                  lotNo: property.lotNo,
	                  communityId: property.community._id,
	                  community: property.community.code + ': ' + property.community.name,
	                  stripeConnectedAccount: property.community && property.community.stripe && property.community.stripe.enabled && property.community.stripe.connectedAccountId ? property.community.stripe.connectedAccountId : null
	                };
	              }
	            });
	
	            _this4.mapAccount = {};
	            _this4.propertyRelations.filter(function (pr) {
	              return pr.stripeConnectedAccount;
	            }).forEach(function (pr) {
	              return _this4.mapAccount[pr.stripeConnectedAccount] = pr.community;
	            });
	
	            _this4.contactStripeAccounts = [].concat(_toConsumableArray(new Set(_this4.propertyRelations.filter(function (r) {
	              return r.stripeConnectedAccount;
	            }).map(function (r) {
	              return r.stripeConnectedAccount;
	            }))));
	
	            _this4.payments = [];
	            _this4.contactStripeAccounts.forEach(function (acct) {
	              _this4.StripeService.getPayments({ id: acct }, function (data) {
	                _this4.payments = _this4.payments.concat(data.filter(function (li) {
	                  return li.source && li.source.metadata && li.source.metadata.creationUser == _this4.contactId;
	                }).map(function (li) {
	                  li.community = _this4.mapAccount[acct];
	                  return li;
	                }));
	              });
	            });
	
	            _this4.propertyRelations.forEach(function (relation) {
	              relation.count = {
	                workOrders: 0,
	                violations: 0,
	                serviceRequests: 0,
	                tasks: 0
	              };
	
	              _this4.TaskService.getByContext({ id: relation.propertyId }, function (data) {
	                var filteredData = data.filter(function (task) {
	                  return task.status == 'open';
	                });
	                relation.count.tasks = filteredData.length;
	                _this4.count.tasks += relation.count.tasks;
	              });
	
	              _this4.ServiceRequestTicketsService.getByProperty({ id: relation.propertyId }, function (data) {
	                var filteredData = data.filter(function (sr) {
	                  return sr.status == 'open';
	                });
	                relation.count.serviceRequests = filteredData.length;
	                _this4.count.serviceRequests += relation.count.serviceRequests;
	              });
	
	              _this4.WorkOrderTicketsService.getByProperty({ id: relation.propertyId }, function (data) {
	                var filteredData = data.filter(function (wo) {
	                  return wo.status == 'open';
	                });
	                relation.count.workOrders = filteredData.length;
	                _this4.count.workOrders += relation.count.workOrders;
	              });
	
	              _this4.ViolationTicketsService.getByProperty({ id: relation.propertyId }, function (data) {
	                var filteredData = data.filter(function (ccr) {
	                  return ccr.status == 'open';
	                });
	                relation.count.violations = filteredData.length;
	                _this4.count.violations += relation.count.violations;
	              });
	
	              _this4.QuickbooksImportService.getBalance({ propertyId: relation.propertyId }, function (data) {
	                for (var account in data) {
	                  if (data.hasOwnProperty(account) && !account.startsWith("$")) {
	                    var balance = angular.copy(data[account]);
	                    balance.account = account;
	                    balance.propertyId = relation.propertyId;
	                    balance.lotNo = relation.lotNo;
	                    _this4.balances.push(balance);
	                  }
	                }
	              });
	            });
	          });
	
	          _this4.RecentVisits.addPortfolio(_this4.contactId, "contact", _this4.contact.firstName + ' ' + _this4.contact.lastName);
	          _this4.isPinned = _this4.PinnedItems.isPinnedPortfolio(_this4.contactId);
	        }, function (err) {
	          console.log('Could not load contact from server');
	        });
	
	        this.TaskService.getByContext({ id: this.contactId }, function (data) {
	          var filteredData = data.filter(function (task) {
	            return task.status == 'open';
	          });
	          _this4.count.tasks += filteredData.length;
	        });
	      }
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (resultIds) {
	        that.ContactService.addAttachments({ id: that.contactId }, resultIds, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not add attachments to contact');
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'openSingleAddressLabelModal',
	    value: function openSingleAddressLabelModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'singleAddressLabelModal',
	        resolve: {
	          config: function config() {
	            var owner = that.contact.firstName;
	            if (that.contact.middleName) owner += " " + that.contact.middleName;
	            owner += " " + that.contact.lastName;
	
	            return {
	              owner: owner,
	              addresses: that.contact.address
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }, {
	    key: 'emailSectionEdit',
	    value: function emailSectionEdit() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'emailSectionEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: that.contact.email
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (newEmails) {
	        that.contact.email = newEmails;
	
	        that.ContactService.update({ id: that.contactId }, that.contact, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not edit emails of contact');
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'phoneSectionEdit',
	    value: function phoneSectionEdit() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'phoneSectionEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: that.contact.phone
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (newPhones) {
	        that.contact.phone = newPhones;
	
	        that.ContactService.update({ id: that.contactId }, that.contact, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not edit phones of contact');
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'addressSectionEdit',
	    value: function addressSectionEdit() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'addressSectionEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: that.contact.address
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (newAddresses) {
	        that.contact.address = newAddresses;
	
	        that.ContactService.update({ id: that.contactId }, that.contact, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not edit addresses of contact');
	        });
	      }, function () {});
	    }
	  }]);
	
	  return ContactShowComponent;
	}();
	
	exports.default = angular.module('conduu.contactShow', [uiRouter]).config(_contactShow2.default).component('contactShow', {
	  template: __webpack_require__(475),
	  controller: ContactShowComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('contact-show', {
	    url: '/contact/:id',
	    template: '<contact-show></contact-show>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <img style=\"float:right;margin-left: 24px;\" ng-src=\"https://ui-avatars.com/api/?name={{ctrl.getComposedName(ctrl.contact)}}&background=333&rounded=true&color=eee&size=82\" />\n      <dl class=\"dl-horizontal\" style=\"display:inline-block; float:right\">\n        <dt ng-class=\"{'text-danger':ctrl.count.violations}\">Violations <i class=\"fa fa-fw fa-exclamation\"></i></dt>\n        <dd ng-class=\"{'text-danger':ctrl.count.violations}\">{{ctrl.count.violations || '-'}}</dd>\n\n        <dt>Work Orders <i class=\"fa fa-fw fa-wrench\"></i></dt>\n        <dd>{{ctrl.count.workOrders || '-'}}</dd>\n\n        <dt>Service Req. <i class=\"fa fa-fw fa-bell\"></i></dt>\n        <dd>{{ctrl.count.serviceRequests || '-'}}</dd>\n\n        <dt>Tasks <i class=\"fa fa-fw fa-tasks\"></i></dt>\n        <dd>{{ctrl.count.tasks || '-'}}</dd>\n      </dl>\n      <h2 ng-bind-html=\"ctrl.getComposedName(ctrl.contact)\"></h2>\n      <li><a href=\"/contact/list\">Contacts</a></li>\n      <li class=\"active\"><a href=\"#\" ng-bind-html=\"ctrl.getComposedName(ctrl.contact)\"></a></li>\n    </ol>\n\n    <div class=\"col-md-6\">\n      <h3 style=\"margin-top: 0\" class=\"separator\"><span>General</span></h3>\n      <dl class=\"dl-horizontal\">\n        <dt ng-if=\"ctrl.contact.lastName\">Name</dt>\n        <dd ng-if=\"ctrl.contact.lastName\">{{ctrl.contact.firstName}} {{ctrl.contact.middleName || ''}} {{ctrl.contact.lastName}} <i ng-if=\"ctrl.contact.hideInDirectory\" title=\"Contact is hidden in Web Portal directory\" class=\"fa fa-fw fa-eye-slash\"></i></dd>\n        <dt ng-if=\"ctrl.contact.company\">Company / Trust</dt>\n        <dd ng-if=\"ctrl.contact.company\">{{ctrl.contact.company}}</dd>\n      </dl>\n\n      <h3 ng-if=\"ctrl.balances.length\" class=\"separator\"><span>Quickbook Balances</span></h3>\n      <dl ng-if=\"ctrl.balances.length\" class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"entry in ctrl.balances\">Lot# {{entry.lotNo}}</dt>\n        <dd ng-repeat-end=\"\"><span ng-class=\"{'text-danger': entry.balance > 0, 'text-success': entry.balance < 0}\">$ {{entry.balance | number:2}}</span> ({{entry.account}})</dd>\n      </dl>\n\n      <h3 style=\"margin-top: 0\" class=\"separator\"><span>Address <small><a href=\"#\" ng-click=\"ctrl.addressSectionEdit()\"><i class=\"fa fa-pencil-square-o\"></i></a></small></span></h3>\n      <dl class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"address in ctrl.contact.address\">{{address.type}}</dt>\n        <dd ng-repeat-end=\"\">{{ctrl.getAddress(address)}} <i ng-if=\"address.isPrimary && ctrl.contact.address.length > 1\" title=\"Primary Address\" class=\"fa fa-fw fa-star-o\"></i><i ng-if=\"address.isMailing\" title=\"Address is Mailing Address\" class=\"fa fa-fw fa-envelope-o\"></i><i ng-if=\"address.isPrivate\" title=\"Address is Private\" class=\"fa fa-fw fa-eye-slash\"></i></dd>\n\n        <dt ng-if=\"!ctrl.contact.address.length\" class=\"text-muted\"><i class=\"fa fa-times\"></i></dt>\n        <dd ng-if=\"!ctrl.contact.address.length\" class=\"text-muted\">No data available</dd>\n      </dl>\n    </div>\n\n    <div class=\"col-md-6\">\n      <h3 style=\"margin-top: 0\" class=\"separator\"><span>Phone <small><a href=\"#\" ng-click=\"ctrl.phoneSectionEdit()\"><i class=\"fa fa-pencil-square-o\"></i></a></small></span></h3>\n      <dl class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"phone in ctrl.contact.phone\">{{phone.type}}</dt>\n        <dd ng-repeat-end=\"\">{{phone.number | usPhone}} <i ng-if=\"phone.isPrimary && ctrl.contact.phone.length > 1\" title=\"Primary Phone\" class=\"fa fa-fw fa-star-o\"></i><i ng-if=\"phone.isPrivate\" title=\"Phone is Private\" class=\"fa fa-fw fa-eye-slash\"></i></dd>\n\n        <dt ng-if=\"!ctrl.contact.phone.length\" class=\"text-muted\"><i class=\"fa fa-times\"></i></dt>\n        <dd ng-if=\"!ctrl.contact.phone.length\" class=\"text-muted\">No data available</dd>\n      </dl>\n\n      <h3 style=\"margin-top: 0\" class=\"separator\"><span>Email <small><a href=\"#\" ng-click=\"ctrl.emailSectionEdit()\"><i class=\"fa fa-pencil-square-o\"></i></a></small></span></h3>\n      <dl class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"email in ctrl.contact.email\">{{email.type}}</dt>\n        <dd ng-repeat-end=\"\"><a ng-href=\"mailto:{{email.address}}\">{{email.address}}</a> <i ng-if=\"email.isPrimary && ctrl.contact.email.length > 1\" title=\"Primary Email\" class=\"fa fa-fw fa-star-o\"></i><i ng-if=\"email.isPrivate\" title=\"Email is Private\" class=\"fa fa-fw fa-eye-slash\"></i></dd>\n\n        <dt ng-if=\"!ctrl.contact.email.length\" class=\"text-muted\"><i class=\"fa fa-times\"></i></dt>\n        <dd ng-if=\"!ctrl.contact.email.length\" class=\"text-muted\">No data available</dd>\n      </dl>\n\n      <h3 ng-if=\"ctrl.contact.web.length\" style=\"margin-top: 0\" class=\"separator\"><span>Web / Social</span></h3>\n      <dl class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"web in ctrl.contact.web\">{{web.type}}</dt>\n        <dd ng-repeat-end=\"\">{{web.link}}</dd>\n      </dl>\n    </div>\n\n    <div class=\"col-xs-6\" ng-repeat=\"section in ctrl.customFieldsConfig.display\">\n\n      <h3 style=\"margin-top: 0\" class=\"separator\"><span class=\"text-capitalize\">{{section}} <small ng-if=\"ctrl.getSectionEditAction(section)\"><a href=\"#\" ng-click=\"ctrl.editSection(section)\"><i class=\"fa fa-pencil-square-o\"></i></a></small></span></h3>\n      <dl class=\"dl-horizontal\" ng-if=\"!ctrl.getSectionTemplate(section)\">\n        <dt ng-repeat-start=\"field in ctrl.customFieldsConfig[section]\">{{field.label}}</dt>\n        <dd ng-show=\"field.template\" bind-dynamic-page=\"field.template\"></dd>\n        <dd ng-hide=\"field.template\" ng-repeat-end=\"\">{{ctrl.contact.customFields[field.data] || '-'}}</dd>\n      </dl>\n      <div ng-if=\"ctrl.getSectionTemplate(section)\" bind-dynamic-page=\"ctrl.getSectionTemplate(section)\"></div>\n\n    </div>\n\n    <div class=\"col-xs-6\" style=\"padding-right:0\">\n      <h3 style=\"margin-top: 0\" class=\"separator\"><span>Actions</span></h3>\n\n      <dl class=\"dl-horizontal\">\n        <dt>\n          Label\n        </dt>\n        <dd>\n          <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.openSingleAddressLabelModal()\"><i class=\"fa fa-fw fa-th\"></i> Address Label</button>\n        </dd>\n      </dl>\n    </div>\n\n    <div style=\"clear: both\"></div>\n\n    <div class=\"col-xs-12\">\n\n      <h3 ng-if=\"ctrl.propertyRelations.length\" class=\"separator\"><span>Properties</span></h3>\n      <dl ng-if=\"ctrl.propertyRelations.length\" class=\"dl-horizontal\">\n        <dt class=\"text-capitalize\" ng-repeat-start=\"relation in ctrl.propertyRelations\">{{relation.type}}</dt>\n        <dd ng-repeat-end=\"\">\n          <a ng-href=\"/property/{{relation.propertyId}}\">{{relation.property}}</a> <span class=\"text-muted\">at {{relation.community}}</span>\n          <span ng-if=\"relation.count.violations\">| <i class=\"text-danger fa fa-exclamation\"></i> {{relation.count.violations}}</span>\n          <span ng-if=\"relation.count.workOrders\">| <i class=\"fa fa-wrench\"></i> {{relation.count.workOrders}}</span>\n          <span ng-if=\"relation.count.serviceRequests\">| <i class=\"fa fa-bell\"></i> {{relation.count.serviceRequests}}</span>\n          <span ng-if=\"relation.count.tasks\">| <i class=\"fa fa-tasks\"></i> {{relation.count.tasks}}</span>\n        </dd>\n      </dl>\n\n      <h3 ng-if=\"ctrl.voterRelations.length\" class=\"separator\"><span>Voter</span></h3>\n      <dl ng-if=\"ctrl.voterRelations.length\" class=\"dl-horizontal\">\n        <dt class=\"text-capitalize\" ng-repeat-start=\"relation in ctrl.voterRelations\">{{relation.type}}</dt>\n        <dd ng-repeat-end=\"\">\n          <a ng-href=\"/property/{{relation.propertyId}}\">{{relation.property}}</a> <span class=\"text-muted\">at {{relation.community}}</span>\n        </dd>\n      </dl>\n\n      <h3 ng-if=\"ctrl.payments && ctrl.payments.length\" class=\"separator\"><span>Payments</span></h3>\n      <dl ng-if=\"ctrl.payments && ctrl.payments.length\" class=\"dl-horizontal\">\n        <dt ng-class=\"{'text-danger': !payment.paid}\" ng-repeat-start=\"payment in ctrl.payments\">$ {{(payment.metadata.netAmount || payment.amount) / 100 | number:'2'}}</dt>\n        <dd ng-repeat-end=\"\">\n          <span ng-class=\"{'strike': !payment.paid}\">\n          {{payment.description}} <span class=\"text-muted\"><i>on {{payment.source.metadata.creationDate | date}}</i> for {{payment.community}}</span>\n          </span>\n          <span class=\"text-danger\" ng-if=\"!payment.paid\"><br/><i class=\"fa fa-fw fa-exclamation-circle\"></i> {{payment.failure_message}}</span>\n        </dd>\n      </dl>\n\n      <h3 ng-if=\"ctrl.webaccess && ctrl.webaccess.length\" class=\"separator\"><span>Web Access</span></h3>\n      <dl ng-if=\"ctrl.webaccess && ctrl.webaccess.length\" class=\"dl-horizontal\">\n        <dt class=\"text-capitalize\" ng-repeat-start=\"wa in ctrl.webaccess\"><i class=\"fa fa-fw fa-sign-in\"></i></dt>\n        <dd ng-repeat-end=\"\">\n          <a ng-href=\"/webaccess/{{wa._id}}\">Login <i>{{wa.email}}</i> for {{ctrl.getAccessForLabel(wa)}}</a>\n        </dd>\n      </dl>\n\n      <div ng-repeat=\"customType in ctrl.customEntitiesConfig.display\">\n        <h3 ng-if=\"ctrl.custom[customType].length\" class=\"separator\"><span>{{ctrl.customEntitiesConfig[customType].title}}</span></h3>\n\n        <dl ng-if=\"ctrl.custom[customType].length\" class=\"dl-horizontal\">\n          <dt ng-repeat-start=\"entity in ctrl.custom[customType] | orderBy: 'meta.creationDate':false\" bind-dynamic-page=\"ctrl.customEntitiesConfig[customType].dtTemplate\"></dt>\n          <dd ng-repeat-end=\"\" bind-dynamic-page=\"ctrl.customEntitiesConfig[customType].ddTemplate\"></dd>\n        </dl>\n      </div>\n\n      <nta-section context=\"contact\" context-id=\"ctrl.contactId\" data=\"ctrl.contact\" service=\"ctrl.ContactService\" on-refresh=\"ctrl.refreshData()\"></nta-section>\n\n      <h3 class=\"separator\"><span>Attachments <small><a href=\"#\" ng-click=\"ctrl.openAssetUploadModal()\"><i class=\"fa fa-upload\"></i> Upload Files</a></small></span></h3>\n\n      <attachment-list attachments=\"ctrl.contact.attachments\" context-id=\"ctrl.contactId\" service=\"ctrl.ContactService\"></attachment-list>\n\n      <br/>\n\n      <div style=\"float:right\" >\n        <label>{{ctrl.isPinned ? 'Pinned' : \"Not Pinned\"}}&nbsp;</label> <toggle ng-model=\"ctrl.isPinned\" ng-change=\"ctrl.PinnedItems.togglePortfolio(ctrl.contactId, 'contact', ctrl.contact.firstName + ' ' + ctrl.contact.lastName)\" on=\"<i class='fa fa-fw fa-map-pin'>\" off=\"<i class='fa fa-fw fa-times'>\" onstyle=\"btn-success\" offstyle=\"btn-default\"></toggle>\n      </div>\n      <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\n    </div>\n\n  </div>\n</div>\n\n"

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PropertyListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propertyList = __webpack_require__(477);
	
	var _propertyList2 = _interopRequireDefault(_propertyList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var moment = __webpack_require__(44);
	
	var PropertyListComponent = exports.PropertyListComponent = function () {
	  PropertyListComponent.$inject = ['Auth', 'PropertyService', 'dialogs', '$scope', 'ViewSelection', 'DTOptionsBuilder', 'DTDefaultOptions', 'DTState', 'SettingsService'];
	  function PropertyListComponent(Auth, PropertyService, dialogs, $scope, ViewSelection, DTOptionsBuilder, DTDefaultOptions, DTState, SettingsService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, PropertyListComponent);
	
	    this.$scope = $scope;
	    this.ViewSelection = ViewSelection;
	
	    this.PropertyService = PropertyService;
	    this.filteredData = [];
	    this.data = [];
	    this.selectedCommunityCode = "";
	
	    this.dialogs = dialogs;
	
	    SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	      _this.contactTypes = appSettings.data.propertyListContactTypes || ["primary-owner", "owner", "renter"];
	      _this.contactTypesMap = appSettings.data.contactTypesMap || {
	        'primary-owner': "Primary Owner",
	        'owner': "Other Owner",
	        'renter': "Active Tenant"
	      };
	
	      var preloadCols = "Cmty, Lot#, Address," + _this.contactTypes.map(function (type) {
	        return _this.contactTypesMap[type];
	      }).join(', ');
	      DTDefaultOptions.setLoadingTemplate('<datatable-loading-placeholder columns="' + preloadCols + '" />');
	
	      _this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'asc']).withOption('deferRender', true).withOption('initComplete', function (_) {
	        _this.initComplete = true;
	      }).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	        extend: 'excel',
	        title: "Properties"
	      }, {
	        extend: 'csv',
	        title: "Properties"
	      }, {
	        title: "Properties",
	        message: 'As of ' + moment().format("MMMM Do YYYY"),
	        extend: 'pdf',
	        orientation: 'portrait',
	        pageSize: 'LETTER'
	      }, {
	        extend: 'print',
	        title: "Properties",
	        orthogonal: 'export'
	      }]);
	
	      _this.PropertyService.query(function (data) {
	        _this.data = data;
	        _this.filterData(ViewSelection.selectedCommunityCode);
	        _this.dataInitComplete = true;
	      }, function (err) {
	        console.log("Could not retrieve properties.");
	      });
	    });
	
	    $scope.ViewSelection = ViewSelection;
	    $scope.$watch('ViewSelection.selectedCommunity', function (newVal, oldVal, scope) {
	      _this.selectedCommunity = newVal.name;
	      _this.selectedCommunityCode = newVal.value;
	      _this.filterData(_this.selectedCommunityCode);
	    });
	  }
	
	  _createClass(PropertyListComponent, [{
	    key: 'filterData',
	    value: function filterData(code) {
	      if (code) {
	        this.filteredData = this.data.filter(function (ppty) {
	          return ppty.community && ppty.community.code == code;
	        });
	      } else {
	        this.filteredData = this.data;
	      }
	    }
	  }, {
	    key: 'isActiveTenant',
	    value: function isActiveTenant(contact) {
	      if (!contact.from && !contact.till) return true;
	
	      if (contact.from && contact.till) {
	        return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
	      }
	
	      if (!contact.from && contact.till) {
	        return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
	      }
	
	      if (contact.from && !contact.till) {
	        return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
	      }
	    }
	  }, {
	    key: 'getContacts',
	    value: function getContacts(property, type) {
	      var _this2 = this;
	
	      var contacts = property.contacts.filter(function (c) {
	        return c.type == type;
	      });
	
	      if (type == 'renter') {
	        contacts = contacts.filter(function (c) {
	          return _this2.isActiveTenant(c);
	        });
	      }
	
	      var htmlContact = [];
	
	      contacts.forEach(function (c) {
	        if (!c.contact || !c.contact._id) {
	          htmlContact.push('<span className="text-muted">Removed Contact</span>');
	        } else {
	          htmlContact.push('<a ng-href="/contact/' + c.contact._id + '">' + _this2.getComposedName(c.contact) + '</a>');
	        }
	      });
	
	      return htmlContact.join('<br/>');
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") {
	          composedName += contact.company;
	        } else {
	          composedName += "<br/>" + contact.company;
	        }
	      }
	
	      return composedName;
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(property) {
	      try {
	        var address = property.address.street;
	
	        if (property.address.city && property.address.state && property.address.zip) {
	          address += ', ' + property.address.city + ', ' + property.address.state + ' ' + property.address.zip;
	        } else if (property.address.city) {
	          address += ', ' + property.address.city;
	        } else if (property.address.state && property.address.zip) {
	          address += ', ' + property.address.state + ' ' + property.address.zip;
	        }
	
	        return address;
	      } catch (e) {
	        return "-";
	      }
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(property) {
	      var that = this;
	
	      var address = "";
	      try {
	        address = this.getAddress(property);
	      } catch (e) {}
	
	      var propertyText = "<br/><br/><b> Unit/Lot# " + property.lotNo + "</b><br/><p>" + address + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Property?", "Do you really want to delete this property?" + propertyText);
	      dlg.result.then(function () {
	        that.PropertyService.delete({ id: property._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== property._id;
	          });
	
	          that.filterData(that.selectedCommunityCode);
	        }, function (err) {
	          alert("Could not delete property");
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'getPrimaryOwnerId',
	    value: function getPrimaryOwnerId(contacts) {
	      var primary = contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary) return 0;else if (!primary.contact || !primary.contact._id) return -1;else return primary.contact._id;
	    }
	  }, {
	    key: 'getOtherOwnerId',
	    value: function getOtherOwnerId(contacts) {
	      var other = contacts.find(function (contact) {
	        return contact.type == 'owner';
	      });
	
	      if (!other) return 0;else if (!other.contact || !other.contact._id) return -1;else return other.contact._id;
	    }
	  }, {
	    key: 'getActiveTenantId',
	    value: function getActiveTenantId(contacts) {
	      var activeTenant = contacts.find(function (contact) {
	        try {
	          if (contact.type == 'renter') {
	
	            if (!contact.from && !contact.till) return true;
	
	            if (contact.from && contact.till) {
	              return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
	            }
	
	            if (!contact.from && contact.till) {
	              return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
	            }
	
	            if (contact.from && !contact.till) {
	              return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
	            }
	          } else {
	            return false;
	          }
	        } catch (e) {
	          console.log(e);
	          return false;
	        }
	      });
	
	      if (!activeTenant) return 0;else if (!activeTenant.contact || !activeTenant.contact._id) return -1;else return activeTenant.contact._id;
	    }
	  }, {
	    key: 'getPrimaryOwner',
	    value: function getPrimaryOwner(contacts) {
	      if (!contacts || !contacts.length) return "-";
	
	      var primary = contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary) return "-";
	
	      return this.getComposedName(primary.contact);
	    }
	  }, {
	    key: 'getOtherOwner',
	    value: function getOtherOwner(contacts) {
	      if (!contacts || !contacts.length) return "-";
	
	      var other = contacts.find(function (contact) {
	        return contact.type == 'owner';
	      });
	
	      if (!other) return "-";
	
	      return this.getComposedName(other.contact);
	    }
	  }, {
	    key: 'getActiveTenant',
	    value: function getActiveTenant(contacts) {
	      if (!contacts || !contacts.length) return "-";
	
	      var activeTenant = contacts.find(function (contact) {
	        try {
	          if (contact.type == 'renter') {
	
	            if (!contact.from && !contact.till) return true;
	
	            if (contact.from && contact.till) {
	              return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
	            }
	
	            if (!contact.from && contact.till) {
	              return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
	            }
	
	            if (contact.from && !contact.till) {
	              return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
	            }
	          } else {
	            return false;
	          }
	        } catch (e) {
	          console.log(e);
	          return false;
	        }
	      });
	
	      if (!activeTenant) return "-";
	
	      return this.getComposedName(activeTenant.contact);
	    }
	  }]);
	
	  return PropertyListComponent;
	}();
	
	exports.default = angular.module('conduu.propertyList', [uiRouter]).config(_propertyList2.default).component('propertyList', {
	  template: __webpack_require__(478),
	  controller: PropertyListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 477 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('property-list', {
	    url: '/property/list',
	    template: '<property-list></property-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" href=\"/property/edit/\"><i class=\"fa fa-plus\"></i> Create New Property</a>\n      <h2>Properties <small>{{ctrl.selectedCommunity}}</small></h2>\n      <li><a href=\"#\">{{ctrl.selectedCommunity}}</a></li>\n      <li class=\"active\"><a href=\"#\">Properties</a></li>\n    </ol>\n\n    <div class=\"col-xs-12\">\n\n      <datatable-loading-placeholder ng-hide=\"ctrl.dataInitComplete\" columns=\"Cmty, Lot#, Address, Primary Owner, Other Owner, Active Tenant\" />\n\n      <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\" style=\"width:100%\"> <!-- datatable=\"ng\" -->\n        <thead>\n        <tr>\n          <th ng-hide=\"ctrl.selectedCommunityCode\">Cmty</th>\n          <th>Lot#</th>\n          <th>Address</th>\n          <th class=\"text-capitalize\" ng-repeat=\"type in ctrl.contactTypes\">{{ctrl.contactTypesMap[type] || type}}</th>\n          <th></th>\n          <th></th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"property in ctrl.filteredData | orderBy: 'meta.creationDate':true\">\n          <td ng-hide=\"ctrl.selectedCommunityCode\"><a ng-href=\"/community/{{property.community._id}}\" title=\"{{property.community.name}}\">{{property.community.code}}</a></td>\n          <td>{{property.lotNo}}</td>\n          <td>{{ctrl.getAddress(property)}}</td>\n          <td ng-repeat=\"type in ctrl.contactTypes\" bind-dynamic-page=\"ctrl.getContacts(property, type)\"></td>\n          <td><a class=\"btn btn-sm btn-primary\" ng-href=\"/property/{{property._id}}\"><i class=\"fa fa-folder-open fa-fw\"></i></a></td>\n          <td>\n            <nobr>\n              <a class=\"btn btn-sm btn-primary\" ng-href=\"/property/edit/{{property._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\n              <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(property)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\n            </nobr>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PropertyEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propertyEdit = __webpack_require__(480);
	
	var _propertyEdit2 = _interopRequireDefault(_propertyEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var PropertyEditComponent = exports.PropertyEditComponent = function () {
	  PropertyEditComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'CommunityService', 'PropertyService', '$uibModal', 'SettingsService'];
	  function PropertyEditComponent(Auth, $state, $stateParams, dialogs, CommunityService, PropertyService, $uibModal, SettingsService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, PropertyEditComponent);
	
	    this.propertyId = $stateParams.id;
	    this.states = ["AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV", "WI", "WY"];
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.PropertyService = PropertyService;
	    this.CommunityService = CommunityService;
	    this.SettingsService = SettingsService;
	    this.Auth = Auth;
	
	    this.SettingsService.getByName({ name: 'custom-fields' }, function (customFieldSettings) {
	      if (customFieldSettings.data.hasOwnProperty("property")) {
	        _this.customSchema = customFieldSettings.data.property;
	        _this.customForm = ["*"];
	      }
	    });
	
	    this.schema = {};
	    this.owners = [];
	
	    this.CommunityService.query(function (data) {
	      _this.communities = data.map(function (cmty) {
	        return {
	          value: cmty._id,
	          name: cmty.code + ": " + cmty.name
	        };
	      });
	    });
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.model = {
	      address: {},
	      customFields: {}
	    };
	
	    this.customFields = {};
	
	    if (this.propertyId) {
	      this.PropertyService.get({ id: this.propertyId }, function (data) {
	        _this.model = data;
	
	        if (_this.model.community) _this.model.community = _this.model.community._id;
	
	        _this.customFields = _this.model.customFields || {};
	      }, function (err) {
	        console.log('Could not load property from server');
	      });
	    }
	  }
	
	  _createClass(PropertyEditComponent, [{
	    key: 'communityLookup',
	    value: function communityLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'communityLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (community) {
	        that.model.community = community._id;
	      }, function () {});
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this2.propertyId ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "The property has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("property-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.model.customFields = this.customFields || {};
	
	        if (this.propertyId) {
	          this.PropertyService.update({ id: this.propertyId }, this.model, onSuccess, onError);
	        } else {
	          this.model.meta = { creationUser: this.Auth.getCurrentUserSync()._id };
	          this.PropertyService.save(this.model, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return PropertyEditComponent;
	}();
	
	exports.default = angular.module('conduu.propertyEdit', [uiRouter]).config(_propertyEdit2.default).component('propertyEdit', {
	  template: __webpack_require__(481),
	  controller: PropertyEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('property-edit', {
	    url: '/property/edit/:id',
	    template: '<property-edit></property-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Property Editor</h2>\r\n      <li><a href=\"/property/list\">Properties</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n\r\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n        <div class=\"col-md-6\">\r\n         <h3 class=\"separator\"><span>General</span></h3>\r\n\r\n          <!--Lot / Unit -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.lotNo.$valid && ctrl.submitted,\r\n                                            'has-error': form.lotNo.$invalid && ctrl.submitted }\">\r\n            <label>Lot / Unit #</label>\r\n\r\n            <input type=\"text\" name=\"lotNo\" class=\"form-control\" ng-model=\"ctrl.model.lotNo\"\r\n                   required/>\r\n            <p class=\"help-block\" ng-show=\"form.lotNo.$error.required && ctrl.submitted\">\r\n              A lot or unit number is required\r\n            </p>\r\n          </div>\r\n\r\n          <!--Building -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.buildingNo.$valid && ctrl.submitted,\r\n                                            'has-error': form.buildingNo.$invalid && ctrl.submitted }\">\r\n            <label>Building #</label>\r\n\r\n            <input type=\"text\" name=\"buildingNo\" class=\"form-control\" ng-model=\"ctrl.model.buildingNo\" />\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"col-md-6\">\r\n          <h3 class=\"separator\"><span>Belonging</span></h3>\r\n\r\n          <!-- Community -->\r\n          <div class=\"form-group\">\r\n            <label>Community</label>\r\n            <br/>\r\n\r\n            <div class=\"input-group\" style=\"display: inline-block\">\r\n              <select class=\"form-control\" ng-options=\"o.value as o.name for o in ctrl.communities\" ng-model=\"ctrl.model.community\"\r\n                      style=\"display: inline-block; width: auto\"></select>\r\n              <span class=\"input-group-btn\">\r\n                  <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.communityLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                  <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.community\" ng-click=\"ctrl.model.community = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n                </span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div style=\"clear:both\"></div>\r\n\r\n        <div class=\"col-xs-12\">\r\n\r\n        <h3 class=\"separator\"><span>Address</span></h3>\r\n\r\n        <!-- Address: Street -->\r\n        <div class=\"form-group\">\r\n          <label>Street</label>\r\n\r\n          <input type=\"text\" name=\"street\" class=\"form-control\" ng-model=\"ctrl.model.address.street\" />\r\n        </div>\r\n\r\n        <!-- Address: Street 2 -->\r\n        <div class=\"form-group\">\r\n          <label>Address Line 2</label>\r\n\r\n          <input type=\"text\" name=\"street2\" class=\"form-control\" ng-model=\"ctrl.model.address.street2\" />\r\n        </div>\r\n\r\n        <div class=\"col-sm-6\" style=\"padding-left:0px\">\r\n          <!-- Address: City -->\r\n          <div class=\"form-group\">\r\n            <label>City</label>\r\n\r\n            <input type=\"text\" name=\"city\" class=\"form-control\" ng-model=\"ctrl.model.address.city\" />\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"col-sm-4\" style=\"padding:0px\">\r\n          <!-- Address: State -->\r\n          <div class=\"form-group\">\r\n            <label>State</label>\r\n\r\n            <select class=\"form-control\" ng-options=\"o as o for o in ctrl.states\" ng-model=\"ctrl.model.address.state\"></select>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-sm-2\" style=\"padding-right:0px\">\r\n          <!-- Address: ZIP -->\r\n          <div class=\"form-group\">\r\n            <label>ZIP</label>\r\n\r\n            <input type=\"text\" name=\"zip\" class=\"form-control\" ng-model=\"ctrl.model.address.zip\" />\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Address: Country -->\r\n        <div class=\"form-group\">\r\n          <label>Country</label>\r\n\r\n          <input type=\"text\" name=\"country\" class=\"form-control\" ng-model=\"ctrl.model.address.country\" />\r\n        </div>\r\n\r\n        <div sf-schema=\"ctrl.schema\" sf-form=\"ctrl.form\" sf-model=\"ctrl.model\"></div>\r\n\r\n        <div ng-if=\"ctrl.customForm\">\r\n          <br/>\r\n          <h4 class=\"text-muted text-right\" style=\"padding:0\">Custom Fields</h4>\r\n          <hr style=\"margin-top: 0px\"/>\r\n          <div sf-schema=\"ctrl.customSchema\" sf-form=\"ctrl.customForm\" sf-model=\"ctrl.customFields\"></div>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <button ng-hide=\"ctrl.propertyId\" class=\"btn btn-primary\" type=\"submit\">Create Property</button>\r\n\r\n        <button ng-show=\"ctrl.propertyId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"property-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n\r\n    </div>\r\n\r\n      </form>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PropertyShowComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propertyShow = __webpack_require__(483);
	
	var _propertyShow2 = _interopRequireDefault(_propertyShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var PropertyShowComponent = exports.PropertyShowComponent = function () {
	  PropertyShowComponent.$inject = ['$stateParams', 'PropertyService', 'ServiceRequestTicketsService', 'WorkOrderTicketsService', 'ViolationTicketsService', 'TaskService', '$uibModal', '$window', 'RecentVisits', 'PinnedItems', '$state', 'CustomEntityService', 'SettingsService', 'ContactService', 'CommunityService', 'QuickbooksImportService', 'EFormResultsService'];
	  function PropertyShowComponent($stateParams, PropertyService, ServiceRequestTicketsService, WorkOrderTicketsService, ViolationTicketsService, TaskService, $uibModal, $window, RecentVisits, PinnedItems, $state, CustomEntityService, SettingsService, ContactService, CommunityService, QuickbooksImportService, EFormResultsService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, PropertyShowComponent);
	
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.propertyId = $stateParams.id;
	    this.$uibModal = $uibModal;
	    this.$state = $state;
	
	    this.tasks = [];
	    this.activities = [];
	    this.issues = [];
	    this.custom = {};
	
	    this.RecentVisits = RecentVisits;
	    this.PinnedItems = PinnedItems;
	
	    this.ContactService = ContactService;
	    this.CommunityService = CommunityService;
	    this.SettingsService = SettingsService;
	
	    this.QuickbooksImportService = QuickbooksImportService;
	    this.EFormResultsService = EFormResultsService;
	
	    this.contactTypesMap = {};
	    this.contactTypes = [];
	
	    this.ownerDropdownMenu = [{
	      title: 'Add Primary Owner',
	      action: function action(_) {
	        _this.openAddContactModal('primary-owner');
	      }
	    }, {
	      title: 'Add Owner',
	      action: function action(_) {
	        _this.openAddContactModal('owner');
	      }
	    }, {
	      title: 'Add Renter',
	      action: function action(_) {
	        _this.openAddContactModal('renter');
	      }
	    }, {
	      title: 'Add Previous Owner',
	      action: function action(_) {
	        _this.openAddContactModal('previous-owner');
	      }
	    }, {
	      title: 'Change Contacts and Dates',
	      action: function action(_) {
	        _this.openEditContactsModal();
	      }
	    }];
	
	    this.count = {
	      workOrders: 0,
	      violations: 0,
	      serviceRequests: 0,
	      tasks: 0
	    };
	
	    this.PropertyService = PropertyService;
	    this.refreshData();
	
	    SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	      _this.contactTypesMap = appSettings.data.contactTypesMap;
	      _this.contactTypes = Object.keys(_this.contactTypesMap);
	
	      if (_this.contactTypes) {
	        _this.ownerDropdownMenu = [];
	        _this.contactTypes.forEach(function (type) {
	          _this.ownerDropdownMenu.push({
	            title: 'Add ' + _this.contactTypesMap[type],
	            action: function action(_) {
	              _this.openAddContactModal(type);
	            }
	          });
	        });
	        _this.ownerDropdownMenu.push({
	          title: 'Change Contacts and Dates',
	          action: function action(_) {
	            _this.openEditContactsModal();
	          }
	        });
	      }
	    });
	
	    EFormResultsService.queryBySuiteConnectionProperty({ propertyId: this.propertyId }, function (eforms) {
	      _this.eforms = eforms;
	    });
	
	    TaskService.getByContext({ id: this.propertyId }, function (data) {
	      var filteredData = data.filter(function (task) {
	        return task.status == 'open';
	      });
	      _this.count.tasks = filteredData.length;
	    });
	
	    ServiceRequestTicketsService.getByProperty({ id: this.propertyId }, function (data) {
	      var filteredData = data.filter(function (sr) {
	        return sr.status == 'open';
	      });
	      _this.count.serviceRequests = filteredData.length;
	      _this.issues = _this.issues.concat(filteredData.map(function (sr) {
	        return {
	          type: 'Service Request',
	          name: sr.code + ": " + sr.name,
	          date: sr.meta.creationDate,
	          url: "/servicerequest/ticket/detail/" + sr._id
	        };
	      }));
	    });
	
	    WorkOrderTicketsService.getByProperty({ id: this.propertyId }, function (data) {
	      var filteredData = data.filter(function (wo) {
	        return wo.status == 'open';
	      });
	      _this.count.workOrders = filteredData.length;
	      _this.issues = _this.issues.concat(filteredData.map(function (wo) {
	        return {
	          type: 'Work Order',
	          name: wo.code + ": " + wo.name,
	          date: wo.meta.creationDate,
	          url: "/workorder/ticket/detail/" + wo._id
	        };
	      }));
	    });
	
	    ViolationTicketsService.getByProperty({ id: this.propertyId }, function (data) {
	      var filteredData = data.filter(function (ccr) {
	        return ccr.status == 'open';
	      });
	      _this.count.violations = filteredData.length;
	      _this.issues = _this.issues.concat(filteredData.map(function (ccr) {
	        return {
	          type: 'Violation',
	          name: ccr.code + ": " + ccr.name,
	          date: ccr.meta.creationDate,
	          url: "/violation/ticket/detail/" + ccr._id
	        };
	      }));
	    });
	
	    SettingsService.getByName({ name: 'custom-fields-views' }, function (settings) {
	      _this.customFieldsConfig = settings.data.property || {};
	    });
	
	    SettingsService.getByName({ name: 'custom-entities-views' }, function (settings) {
	      _this.customEntitiesConfig = settings.data.property || { display: [] };
	      _this.customEntitiesConfig.display.forEach(function (customType) {
	        var typeConfig = _this.customEntitiesConfig[customType];
	        _this.custom[customType] = CustomEntityService.getCustomList({ type: customType, refField: typeConfig.refField, refId: $stateParams.id });
	      });
	    });
	  }
	
	  _createClass(PropertyShowComponent, [{
	    key: 'openEFormResultModal',
	    value: function openEFormResultModal(eFormId, eFormResultId) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'eFormResultModal',
	        resolve: {
	          config: function config() {
	            return {
	              eFormId: eFormId,
	              eFormResultId: eFormResultId
	            };
	          }
	        }
	      });
	
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.firstName) composedName += contact.firstName;
	
	      if (contact.middleName) composedName += " " + contact.middleName;
	
	      if (contact.lastName) composedName += " " + contact.lastName;
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += ", " + contact.company;
	      }
	
	      return composedName;
	    }
	  }, {
	    key: 'getPrimaryEmail',
	    value: function getPrimaryEmail(contact) {
	      if (!contact || !contact.email || !contact.email.length) return "-";
	
	      var email = contact.email.find(function (email) {
	        return email.isPrimary;
	      }) || contact.email[0] || { address: '-' };
	
	      return email.address;
	    }
	  }, {
	    key: 'openStripePaymentsModal',
	    value: function openStripePaymentsModal() {
	      var _this2 = this;
	
	      this.CommunityService.get({ id: this.property.community._id }, function (community) {
	
	        if (!community.stripe || !community.stripe.enabled || !community.stripe.connectedAccountId) {
	          alert('no stripe enabled or connected id available');
	          return;
	        }
	
	        var connectedAccountId = community.stripe.connectedAccountId;
	
	        var primary = _this2.property.contacts.find(function (contact) {
	          return contact.type == 'primary-owner';
	        });
	
	        if (!primary || primary == "-") {
	          alert('no primary owner');
	          return;
	        }
	
	        _this2.ContactService.get({ id: primary.contact._id }, function (contact) {
	
	          var email = _this2.getPrimaryEmail(contact);
	
	          if (!email || email == "-") {
	            alert('no primary email on primary owner');
	            return;
	          }
	
	          var name = contact.firstName + " " + contact.lastName;
	
	          var that = _this2;
	
	          var modalInstance = _this2.$uibModal.open({
	            animation: true,
	            component: 'connectedAccountCharges',
	            resolve: {
	              config: function config() {
	                return {
	                  accountId: connectedAccountId,
	                  name: name,
	                  title: "Payments " + name + " (" + community.name + ")",
	                  contactEmail: email
	                };
	              }
	            },
	            size: 'lg'
	          });
	
	          modalInstance.result.then(function () {}, function () {});
	        });
	      });
	    }
	  }, {
	    key: 'getSectionTemplate',
	    value: function getSectionTemplate(section) {
	      if (!this.customFieldsConfig.sectionTemplate || !this.customFieldsConfig.sectionTemplate[section]) return null;
	
	      return this.customFieldsConfig.sectionTemplate[section];
	    }
	  }, {
	    key: 'getSectionEditAction',
	    value: function getSectionEditAction(section) {
	      if (!this.customFieldsConfig.editAction || !this.customFieldsConfig.editAction[section]) return null;
	
	      return this.customFieldsConfig.editAction[section];
	    }
	  }, {
	    key: 'editSection',
	    value: function editSection(section) {
	      var _this3 = this;
	
	      var fields = this.getSectionEditAction(section).split(',').map(function (field) {
	        return field.trim();
	      });
	
	      var that = this;
	
	      this.SettingsService.getByName({ name: 'custom-fields' }, function (customFieldSettings) {
	        if (customFieldSettings.data.hasOwnProperty("property")) {
	          var customSchema = customFieldSettings.data.property;
	
	          var sectionSchema = {
	            type: "object",
	            properties: {}
	          };
	
	          fields.forEach(function (field) {
	            sectionSchema.properties[field] = angular.copy(customSchema.properties[field]);
	          });
	
	          var REGEX_ALL = /([^\W_]+[^\s-]*) */g;
	          var REGEX_FIRST = /([^\W_]+[^\s-]*)/;
	          var capitalize = function capitalize(input, all) {
	            if (!input) return '';
	            var regex = all ? REGEX_ALL : REGEX_FIRST;
	            return input.replace(regex, function (txt) {
	              return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	            });
	          };
	
	          var modalInstance = _this3.$uibModal.open({
	            animation: true,
	            component: 'schemaFormModal',
	            resolve: {
	              config: function config() {
	                return {
	                  title: capitalize(section, true),
	                  icon: "pencil-square-o",
	                  model: that.property.customFields ? angular.copy(that.property.customFields) : {},
	                  schema: sectionSchema
	                };
	              }
	            },
	            size: 'md'
	          });
	
	          modalInstance.result.then(function (editedCustomFields) {
	
	            that.property.customFields = editedCustomFields;
	
	            that.PropertyService.update({ id: that.propertyId }, that.property, function (_) {
	              that.refreshData();
	            }, function (err) {
	              console.log('could not edit contacts of property');
	            });
	          }, function () {});
	        }
	      });
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData() {
	      var _this4 = this;
	
	      if (this.propertyId) {
	        this.PropertyService.get({ id: this.propertyId }, function (data) {
	          _this4.property = data;
	
	          if (_this4.property.customFields && _this4.property.customFields.quickbooksName) {
	            _this4.QuickbooksImportService.getBalance({ propertyId: _this4.property._id }, function (data) {
	              _this4.balances = data;
	            });
	          }
	
	          _this4.CommunityService.get({ id: _this4.property.community._id }, function (cmty) {
	            _this4.eVotingEnabled = cmty.eVoting && cmty.eVoting.enabled;
	
	            if (_this4.eVotingEnabled && _this4.property.eVoting && _this4.property.eVoting.voter) {
	              _this4.ContactService.get({ id: _this4.property.eVoting.voter }, function (contact) {
	                _this4.voter = contact;
	              });
	            }
	          });
	
	          _this4.RecentVisits.addPortfolio(_this4.propertyId, "property", _this4.property.address.street + ', ' + _this4.property.address.city + ' ' + _this4.property.address.state + ', ' + _this4.property.address.zip + ' / ' + _this4.property.lotNo);
	          _this4.isPinned = _this4.PinnedItems.isPinnedPortfolio(_this4.propertyId);
	        }, function (err) {
	          console.log('Could not load violation ticket from server');
	        });
	      }
	    }
	  }, {
	    key: 'editVoting',
	    value: function editVoting() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'schemaFormModal',
	        resolve: {
	          config: function config() {
	            return {
	              title: "Voting",
	              icon: "pencil-square-o",
	              model: that.property.eVoting ? angular.copy(that.property.eVoting) : {},
	              schema: {
	                type: "object",
	                properties: {
	                  voter: {
	                    "title": "Voter",
	                    "type": "string",
	                    "x-schema-form": {
	                      "type": "entitylookup",
	                      "lookuptype": "contact"
	                    }
	                  },
	                  blocked: {
	                    type: "boolean",
	                    title: "Blocked",
	                    description: "The voter is not allowed to cast a vote for this property currently"
	                  },
	                  votingCertificate: {
	                    type: "string",
	                    title: "Voting Certificate",
	                    "x-schema-form": {
	                      type: "single-file-upload"
	                    }
	                  }
	                },
	                required: []
	              }
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (editedEVoting) {
	        that.property.eVoting = editedEVoting;
	
	        that.PropertyService.update({ id: that.propertyId }, that.property, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not edit contacts of property');
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'openCustomEntityLetterWithContactSelect',
	    value: function openCustomEntityLetterWithContactSelect(entityId, entityName, template) {
	      var _this5 = this;
	
	      var that = this;
	
	      var MAP_GROUP = { 'primary-owner': "Primary Owner", 'owner': "Owner", 'renter': 'Renter', 'previous-owner': "Previous Owner", "vistor": "Visitor" };
	
	      this.PropertyService.getContacts({ id: this.propertyId }, function (contacts) {
	
	        var pickContactPreselects = [];
	
	        contacts.forEach(function (oContact) {
	
	          var group = MAP_GROUP[oContact.type];
	          var name = oContact.contact.firstName + " " + oContact.contact.lastName;
	          var phone = "";
	          var email = "";
	
	          if (oContact.phone && oContact.phone.length) {
	            var primaryPhone = oContact.phone.find(function (p) {
	              return p.isPrimary;
	            });
	            if (primaryPhone) {
	              phone = primaryPhone.number;
	            }
	          }
	
	          if (oContact.email && oContact.email.length) {
	            var primaryEmail = oContact.email.find(function (e) {
	              return e.isPrimary;
	            });
	            if (primaryEmail) {
	              email = primaryEmail.address;
	            }
	          }
	
	          oContact.contact.address.forEach(function (addr) {
	
	            var composedName = name + ", " + addr.street + " (" + addr.type + ")";
	            if (addr.isPrimary) composedName += " (PRIMARY)";
	
	            pickContactPreselects.push({
	              name: composedName,
	              group: group,
	              payload: {
	                name: name,
	                address: addr.street,
	                address2: addr.street2,
	                phone: phone,
	                email: email
	              }
	            });
	          });
	        });
	
	        var modalInstance = _this5.$uibModal.open({
	          animation: true,
	          component: 'reportFilterModal',
	          resolve: {
	            config: function config() {
	              return {
	                filter: [{ type: "pick-contact-preselect" }],
	                pickContactPreselects: pickContactPreselects,
	                title: "Create and Download Letter",
	                report: 'custom-entity-letter',
	                entityId: entityId,
	                entityName: entityName,
	                template: template,
	                fileTypes: ['docx', 'odt', 'pdf']
	
	              };
	            }
	          },
	          size: 'md'
	        });
	
	        modalInstance.result.then(function () {}, function () {});
	      });
	    }
	  }, {
	    key: 'openEditContactsModal',
	    value: function openEditContactsModal() {
	      var _this6 = this;
	
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'editPropertyContacts',
	        size: 'lg',
	        resolve: {
	          config: function config() {
	            return {
	              contacts: that.property.contacts,
	              contactTypes: that.contactTypes.length ? that.contactTypesMap : null
	            };
	          }
	        }
	      });
	
	      modalInstance.result.then(function (newContacts) {
	
	        that.property.contacts = newContacts;
	
	        that.PropertyService.update({ id: that.propertyId }, _this6.property, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not edit contacts of property');
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(property) {
	      try {
	        return property.address.street + ', ' + property.address.city + ', ' + property.address.state + ' ' + property.address.zip;
	      } catch (e) {
	        return "-";
	      }
	    }
	  }, {
	    key: 'openAddContactModal',
	    value: function openAddContactModal(type) {
	      var _this7 = this;
	
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'addPropertyContact',
	        size: 'lg',
	        resolve: {
	          config: function config() {
	            return {
	              type: type,
	              contactTypes: that.contactTypes.length ? that.contactTypesMap : null
	            };
	          }
	        }
	      });
	
	      modalInstance.result.then(function (newContact) {
	
	        that.property.contacts.push(newContact);
	
	        that.PropertyService.update({ id: that.propertyId }, _this7.property, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not add contact to property');
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (resultIds) {
	        that.PropertyService.addAttachments({ id: that.propertyId }, resultIds, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not add attachments to property');
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'createWorkOrder',
	    value: function createWorkOrder() {
	      this.$state.go('workorder-ticket-edit', { propertyId: this.propertyId });
	    }
	  }, {
	    key: 'createViolation',
	    value: function createViolation() {
	      this.$state.go('violations-ticket-edit', { propertyId: this.propertyId });
	    }
	  }, {
	    key: 'getContactType',
	    value: function getContactType(contact) {
	      if (this.contactTypesMap && this.contactTypes.includes(contact.type)) return this.contactTypesMap[contact.type];
	
	      return contact.type.split("-").join(" ");
	    }
	  }]);
	
	  return PropertyShowComponent;
	}();
	
	exports.default = angular.module('conduu.propertyShow', [uiRouter]).config(_propertyShow2.default).component('propertyShow', {
	  template: __webpack_require__(484),
	  controller: PropertyShowComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('property-show', {
	    url: '/property/:id',
	    template: '<property-show></property-show>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <dl class=\"dl-horizontal\" style=\"display:inline-block; float:right\">\n        <dt ng-class=\"{'text-danger':ctrl.count.violations}\">Violations <i class=\"fa fa-fw fa-exclamation\"></i></dt>\n        <dd ng-class=\"{'text-danger':ctrl.count.violations}\">{{ctrl.count.violations || '-'}}</dd>\n\n        <dt>Work Orders <i class=\"fa fa-fw fa-wrench\"></i></dt>\n        <dd>{{ctrl.count.workOrders || '-'}}</dd>\n\n        <dt>Service Req. <i class=\"fa fa-fw fa-bell\"></i></dt>\n        <dd>{{ctrl.count.serviceRequests || '-'}}</dd>\n\n        <dt>Tasks <i class=\"fa fa-fw fa-tasks\"></i></dt>\n        <dd>{{ctrl.count.tasks || '-'}}</dd>\n      </dl>\n      <h2>Property <small>{{ctrl.getAddress(ctrl.property)}} / {{ctrl.property.lotNo}}</small></h2>\n      <li><a href=\"/property/list\">Properties</a></li>\n      <li class=\"active\"><a href=\"#\">Property</a></li>\n    </ol>\n\n    <div class=\"col-xs-12\">\n\n      <div class=\"col-xs-6\" style=\"padding-left:0\">\n        <h3 style=\"margin-top: 0\" class=\"separator\"><span>General <small><a ng-href=\"/property/edit/{{ctrl.propertyId}}\"><i class=\"fa fa fa-pencil-square-o\"></i></a></small></span></h3>\n\n        <dl class=\"dl-horizontal\">\n          <dt>Community</dt>\n          <dd>{{ctrl.property.community.name}}</dd>\n\n          <dt>Address</dt>\n          <dd>{{ctrl.getAddress(ctrl.property)}}</dd>\n\n          <dt>Lot No</dt>\n          <dd>{{ctrl.property.lotNo}}</dd>\n\n          <dt ng-if=\"ctrl.property.buildingNo\">Building No</dt>\n          <dd ng-if=\"ctrl.property.buildingNo\">{{ctrl.property.buildingNo}}</dd>\n        </dl>\n\n        <h3 ng-if=\"ctrl.balances\" class=\"separator\"><span>Quickbook Balances <small><a ng-href=\"/admin/list/quickbooks/{{ctrl.property._id}}\"><i class=\"fa fa-fw fa-table\"></i></a></small></span></h3>\n        <dl ng-if=\"ctrl.balances\" class=\"dl-horizontal\">\n          <dt ng-repeat-start=\"entry in ctrl.balances\">{{entry.account}}</dt>\n          <dd ng-repeat-end=\"\" ng-class=\"{'text-danger': entry.balance > 0, 'text-success': entry.balance < 0}\">$ {{entry.balance | number:2}}</dd>\n        </dl>\n      </div>\n\n      <div class=\"col-xs-6\" style=\"padding-right:0\">\n        <h3 style=\"margin-top: 0\" class=\"separator\"><span>Actions</span></h3>\n\n        <dl class=\"dl-horizontal\">\n          <dt>\n            Work Order\n          </dt>\n          <dd>\n            <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.createWorkOrder()\"><i class=\"fa fa-fw fa-wrench\"></i> Create Work Order</button>\n          </dd>\n          <dt>\n            Violation\n          </dt>\n          <dd>\n            <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.createViolation()\"><i class=\"fa fa-fw fa-exclamation\"></i> Create Violation</button>\n          </dd>\n        </dl>\n      </div>\n\n      <div class=\"col-xs-6\" ng-repeat=\"section in ctrl.customFieldsConfig.display\">\n\n          <h3 style=\"margin-top: 0\" class=\"separator\"><span class=\"text-capitalize\">{{section}} <small ng-if=\"ctrl.getSectionEditAction(section)\"><a href=\"#\" ng-click=\"ctrl.editSection(section)\"><i class=\"fa fa-pencil-square-o\"></i></a></small></span></h3>\n          <dl class=\"dl-horizontal\" ng-if=\"!ctrl.getSectionTemplate(section)\">\n            <dt ng-repeat-start=\"field in ctrl.customFieldsConfig[section]\">{{field.label}}</dt>\n            <dd ng-show=\"field.template\" bind-dynamic-page=\"field.template\"></dd>\n            <dd ng-hide=\"field.template\" ng-repeat-end=\"\">{{ctrl.property.customFields[field.data] || '-'}}</dd>\n          </dl>\n          <div ng-if=\"ctrl.getSectionTemplate(section)\" bind-dynamic-page=\"ctrl.getSectionTemplate(section)\"></div>\n\n      </div>\n\n      <div class=\"col-xs-6\" ng-if=\"ctrl.eVotingEnabled\">\n        <h3 style=\"margin-top: 0\" class=\"separator\"><span>Voting <small><a href=\"#\" ng-click=\"ctrl.editVoting()\"><i class=\"fa fa fa-pencil-square-o\"></i></a></small></span></h3>\n        <dl class=\"dl-horizontal\">\n          <dt>Voter</dt>\n          <dd>\n            <span ng-if=\"!ctrl.voter\">-</span>\n            <a ng-if=\"ctrl.voter\" ng-href=\"/contact/{{ctrl.voter._id}}\">{{ctrl.getComposedName(ctrl.voter)}}</a>\n          </dd>\n          <dt>Voting Certificate</dt>\n          <dd>\n            <span ng-if=\"!ctrl.property.eVoting.votingCertificate\">-</span>\n            <span ng-if=\"ctrl.property.eVoting.votingCertificate\"> <a ng-href=\"/api/storage/{{ctrl.property.eVoting.votingCertificate}}\" target=\"_blank\"><i class=\"fa fa-fw fa-download\"></i></a></span>\n          </dd>\n          <dt>Blocked</dt>\n          <dd>\n            {{(ctrl.property.eVoting && ctrl.property.eVoting.blocked) ? \"Yes\" : \"No\"}}\n            <i class=\"fa fa-fw fa-ban text-danger\" ng-if=\"ctrl.property.eVoting && ctrl.property.eVoting.blocked\"></i>\n          </dd>\n          <dt>E-Voting Consent</dt>\n          <dd>\n            <span>{{(ctrl.voter.customFields.eVotingConsent) ? \"Yes\" : \"No\"}}</span>\n            <span ng-if=\"ctrl.voter.customFields.eVotingConsentForm\">(via E-Form)</span>\n          </dd>\n        </dl>\n      </div>\n\n      <div style=\"clear: both;\"></div>\n\n      <h3 class=\"separator\"><span>Owners and Tenants <small><header-dropdown-menu title=\"Actions\" menu=\"ctrl.ownerDropdownMenu\"></header-dropdown-menu></small></span></h3>\n\n      <dl class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"contactEntry in ctrl.property.contacts\" class=\"text-capitalize\">{{ctrl.getContactType(contactEntry)}}</dt>\n        <dd ng-repeat-end=\"\">\n          <span ng-if=\"contactEntry.contact\"><a ng-href=\"/contact/{{contactEntry.contact._id}}\">{{ctrl.getComposedName(contactEntry.contact)}}</a>,</span>\n          <span ng-if=\"!contactEntry.contact\"><span class=\"text-muted\">removed</span>,</span>\n\n          <span ng-if=\"contactEntry.from && contactEntry.till\">{{contactEntry.from | date:'MM/dd/yyyy'}} - {{contactEntry.till | date:'MM/dd/yyyy'}}</span>\n          <span ng-if=\"contactEntry.from && !contactEntry.till\">{{contactEntry.from | date:'MM/dd/yyyy'}} - today</span>\n          <span ng-if=\"!contactEntry.from && contactEntry.till\">? - {{contactEntry.till | date:'MM/dd/yyyy'}}</span>\n          <span ng-if=\"!contactEntry.from && !contactEntry.till\"> -</span>\n\n          <!--<span ng-if=\"contactEntry.type == 'primary-owner'\"> [<a href=\"#\" ng-click=\"ctrl.openStripePaymentsModal()\">Show payments</a>]</span>-->\n        </dd>\n      </dl>\n\n      <h3 ng-if=\"ctrl.issues.length\" class=\"separator\"><span>Open Issues</span></h3>\n\n      <dl ng-if=\"ctrl.issues.length\" class=\"dl-horizontal\">\n        <dt ng-class=\"{'text-danger': issue.type == 'Violation'}\" ng-repeat-start=\"issue in ctrl.issues | orderBy: 'date':false\">{{issue.type}}</dt>\n        <dd ng-repeat-end=\"\"><a ng-href=\"{{issue.url}}\">{{issue.name}}</a> <span class=\"text-muted\">from {{issue.date | date:'MM/dd/yyyy'}}</span></dd>\n      </dl>\n\n      <h3 ng-if=\"ctrl.eforms.length\" class=\"separator\"><span>E-Forms</span></h3>\n\n      <dl ng-if=\"ctrl.eforms.length\" class=\"dl-horizontal\">\n        <dt  ng-repeat-start=\"eform in ctrl.eforms | orderBy: 'meta.creationDate':false\">{{eform.meta.creationDate | date:'short'}}</dt>\n        <dd ng-repeat-end=\"\"><a ng-href=\"#\" ng-click=\"ctrl.openEFormResultModal(eform.form._id, eform._id)\">{{eform.form.name}}</a></dd>\n      </dl>\n\n      <div ng-repeat=\"customType in ctrl.customEntitiesConfig.display\">\n        <h3 ng-if=\"ctrl.custom[customType].length\" class=\"separator\"><span>{{ctrl.customEntitiesConfig[customType].title}}</span></h3>\n\n        <dl ng-if=\"ctrl.custom[customType].length\" class=\"dl-horizontal\">\n          <dt ng-repeat-start=\"entity in ctrl.custom[customType] | orderBy: 'meta.creationDate':false\" bind-dynamic-page=\"ctrl.customEntitiesConfig[customType].dtTemplate\"></dt>\n          <dd ng-repeat-end=\"\" bind-dynamic-page=\"ctrl.customEntitiesConfig[customType].ddTemplate\"></dd>\n        </dl>\n      </div>\n\n      <!--\n      <h3 ng-if=\"ctrl.trailerStorages.length\" class=\"separator\"><span>Trailer Storages</span></h3>\n\n      <dl ng-if=\"ctrl.trailerStorages.length\" class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"trailerStorage in ctrl.trailerStorages | orderBy: 'meta.creationDate':false\">Space #{{trailerStorage.data.spaceNo}}</dt>\n        <dd ng-repeat-end=\"\"><a ng-href=\"/custom/trailer-storage/{{trailerStorage._id}}\">Tag # {{trailerStorage.data.tagNo}}, {{vehicle.data.begin}} till {{trailerStorage.data.end}}</a></dd>\n      </dl>\n\n      <h3 ng-if=\"ctrl.vehicles.length\" class=\"separator\"><span>Vehicles</span></h3>\n\n      <dl ng-if=\"ctrl.vehicles.length\" class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"vehicle in ctrl.vehicles | orderBy: 'meta.creationDate':false\"><span class=\"label label-success\">{{vehicle.data.licenseNumber}}</span></dt>\n        <dd ng-repeat-end=\"\"><a ng-href=\"/custom/vehicle/{{vehicle._id}}\">{{vehicle.data.make}}, {{vehicle.data.model}}, {{vehicle.data.year}}, {{vehicle.data.color}}, #{{vehicle.data.securityStickerNumber}}</a></dd>\n      </dl>\n\n      <h3 ng-if=\"ctrl.pets.length\" class=\"separator\"><span>Pets</span></h3>\n\n      <dl ng-if=\"ctrl.pets.length\" class=\"dl-horizontal\">\n        <dt ng-repeat-start=\"pet in ctrl.pets | orderBy: 'meta.creationDate':false\"><span class=\"text-capitalize\">{{pet.data.type}}</span></dt>\n        <dd ng-repeat-end=\"\"><a ng-href=\"/custom/pet/{{pet._id}}\">{{pet.data.name}}</a></dd>\n      </dl>\n-->\n       <nta-section context=\"property\" context-id=\"ctrl.propertyId\" data=\"ctrl.property\" service=\"ctrl.PropertyService\" on-refresh=\"ctrl.refreshData()\"></nta-section>\n\n      <h3 class=\"separator\"><span>Attachments <small><a href=\"#\" ng-click=\"ctrl.openAssetUploadModal()\"><i class=\"fa fa-upload\"></i> Upload Files</a></small></span></h3>\n\n      <attachment-list attachments=\"ctrl.property.attachments\" context-id=\"ctrl.propertyId\" service=\"ctrl.PropertyService\"></attachment-list>\n\n      <br/>\n\n      <div style=\"float:right\" >\n        <label>{{ctrl.isPinned ? 'Pinned' : \"Not Pinned\"}}&nbsp;</label> <toggle ng-model=\"ctrl.isPinned\" ng-change=\"ctrl.PinnedItems.togglePortfolio(ctrl.propertyId, 'property', ctrl.property.address.street + ', ' + ctrl.property.address.city + ' ' + ctrl.property.address.state + ', ' + ctrl.property.address.zip + ' / ' + ctrl.property.lotNo)\" on=\"<i class='fa fa-fw fa-map-pin'>\" off=\"<i class='fa fa-fw fa-times'>\" onstyle=\"btn-success\" offstyle=\"btn-default\"></toggle>\n      </div>\n      <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\n\n    </div>\n\n  </div>\n</div>\n\n"

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VendorListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vendorList = __webpack_require__(486);
	
	var _vendorList2 = _interopRequireDefault(_vendorList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var VendorListComponent = exports.VendorListComponent = function () {
	  VendorListComponent.$inject = ['Auth', 'VendorService', 'SettingsService', 'dialogs', '$localStorage', 'DTOptionsBuilder', 'DTState', '$timeout'];
	  function VendorListComponent(Auth, VendorService, SettingsService, dialogs, $localStorage, DTOptionsBuilder, DTState, $timeout) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, VendorListComponent);
	
	    this.VendorService = VendorService;
	    this.data = [];
	    this.$timeout = $timeout;
	
	    this.filteredData = [];
	    this.asTable = !!$localStorage.vendorListAsTable;
	
	    this.dialogs = dialogs;
	    this.$localStorage = $localStorage;
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'asc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Vendors"
	    }, {
	      extend: 'csv',
	      title: "Vendors"
	    }, {
	      title: "Vendors",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'portrait',
	      pageSize: 'LETTER'
	    }, {
	      extend: 'print',
	      title: "Vendors"
	    }]);
	
	    SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	      _this.categories = appSettings.data.businessTypes;
	    });
	
	    this.VendorService.query(function (data) {
	      _this.data = data;
	      _this.filteredData = data;
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve vendors.");
	    });
	  }
	
	  _createClass(VendorListComponent, [{
	    key: 'getCount',
	    value: function getCount(cat) {
	      return this.data.reduce(function (acc, obj) {
	        return acc + (obj.type === cat);
	      }, 0);
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter(cat) {
	      console.log("setFilter", cat);
	      if (cat == '') {
	        this.filteredData = this.data;
	      } else {
	        this.filteredData = this.data.filter(function (item) {
	          return item.type == cat;
	        });
	      }
	
	      jQuery("table.dataTable").DataTable().columns(1).search(cat).draw();
	    }
	  }, {
	    key: 'setAsTable',
	    value: function setAsTable(val) {
	      this.asTable = val;
	      this.$localStorage.vendorListAsTable = val;
	    }
	  }, {
	    key: 'getPrimaryEmail',
	    value: function getPrimaryEmail(owner) {
	      if (!owner || !owner.email || !owner.email.length) return "-";
	
	      var email = owner.email.find(function (email) {
	        return email.isPrimary;
	      }) || owner.email[0] || { address: '-' };
	
	      return email.address;
	    }
	  }, {
	    key: 'getPrimaryPhone',
	    value: function getPrimaryPhone(owner) {
	      if (!owner || !owner.phone || !owner.phone.length) return "-";
	
	      var phone = owner.phone.find(function (phone) {
	        return phone.isPrimary;
	      }) || owner.phone[0] || { number: '-' };
	
	      return phone.number;
	    }
	  }, {
	    key: 'getPrimaryAddress',
	    value: function getPrimaryAddress(owner) {
	      if (!owner || !owner.address || !owner.address.length) return "-";
	
	      var address = owner.address.find(function (adr) {
	        return adr.isPrimary;
	      }) || owner.address[0] || {};
	
	      return address.street + "<br/>" + address.city + ' ' + address.state + ', ' + address.zip;
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(vendor) {
	      var that = this;
	
	      var vendorText = "<br/><br/><b>" + vendor.name + "</b><br/><p>" + vendor.description + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Vendor?", "Do you really want to delete this vendor?" + vendorText);
	      dlg.result.then(function () {
	        that.VendorService.delete({ id: vendor._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== vendor._id;
	          });
	        }, function (err) {
	          alert("Could not delete vendor");
	        });
	      }, function () {});
	    }
	  }]);
	
	  return VendorListComponent;
	}();
	
	exports.default = angular.module('conduu.vendorList', [uiRouter]).config(_vendorList2.default).component('vendorList', {
	  template: __webpack_require__(487),
	  controller: VendorListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vendor-list', {
	    url: '/vendor/list',
	    template: '<vendor-list></vendor-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <a style=\"float:right; margin-top:4px\" class=\"btn btn-primary\" href=\"/vendor/edit/\"><i class=\"fa fa-plus\"></i> Create New Vendor</a>\r\n      <h2>Vendors</h2>\r\n      <li class=\"active\"><a href=\"#\">Vendors</a></li>\r\n      <div class=\"btn-group\" role=\"group\" style=\"float: right; position:relative; top:-16px\">\r\n        <button type=\"button\" ng-click=\"ctrl.setAsTable(true)\"  class=\"btn btn-default\" ng-class=\"{'active': ctrl.asTable}\"><i class=\"fa fa-fw fa-table\"></i></button>\r\n        <button type=\"button\" ng-click=\"ctrl.setAsTable(false)\" class=\"btn btn-default\" ng-class=\"{'active': !ctrl.asTable}\"><i class=\"fa fa-fw fa-th\"></i></button>\r\n      </div>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <uib-tabset active=\"ctrl.activeTabIndex\" style=\"font-size:x-small\">\r\n        <uib-tab select=\"ctrl.setFilter('')\">\r\n          <uib-tab-heading><b>All</b> <span class=\"badge\" style=\"font-size:xx-small\">{{ctrl.data.length || 0}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter(cat)\" ng-repeat=\"cat in ctrl.categories\">\r\n          <uib-tab-heading class=\"text-capitalize\"><b>{{cat}}</b> <span class=\"badge\" style=\"font-size:xx-small\">{{ctrl.getCount(cat)}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n      </uib-tabset>\r\n\r\n      <br/>\r\n    </div>\r\n\r\n    <div ng-if=\"!ctrl.asTable\" class=\"col-md-4 col-sm-6 col-xs-12\" ng-repeat-start=\"vendor in ctrl.filteredData track by $index\">\r\n      <div class=\"bs-card\">\r\n        <div class=\"card-body\">\r\n          <div class=\"card-block\">\r\n            <h5 class=\"card-title\"><a ng-href=\"/vendor/{{vendor._id}}\"><strong>{{vendor.name}}</strong></a></h5>\r\n            <h6 class=\"card-subtitle mb-2 text-muted\"><strong>{{vendor.type}}</strong> | {{vendor.description}}</h6>\r\n            <p class=\"card-text\" ng-if=\"vendor.address[0]\"><span ng-bind-html=\"ctrl.getPrimaryAddress(vendor)\"></span></p>\r\n            <p class=\"card-text\" ng-if=\"vendor.phone[0]\"><i class=\"fa fa-fw fa-phone\"></i> {{ctrl.getPrimaryPhone(vendor) | usPhone}}</p>\r\n            <p class=\"card-text\" ng-if=\"vendor.email[0]\"><i class=\"fa fa-fw fa-envelope\"></i> <a ng-href=\"mailto:{{ctrl.getPrimaryEmail(vendor)}}\">{{ctrl.getPrimaryEmail(vendor)}}</a></p>\r\n            <a ng-href=\"/vendor/edit/{{vendor._id}}\" class=\"card-link\">Edit</a>\r\n            <a href=\"#\" class=\"card-link text-danger\" ng-click=\"ctrl.delete(vendor)\">Delete</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"hidden-xs hidden-md hidden-lg\" ng-if=\"$index % 2 == 1\" style=\"clear:both\"></div>\r\n    <div class=\"hidden-xs hidden-sm\" ng-if=\"$index % 3 == 2\" style=\"clear:both\"></div>\r\n    <div ng-repeat-end=\"\"></div>\r\n\r\n    <div ng-if=\"ctrl.asTable\" class=\"col-xs-12\">\r\n      <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\"  class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>Name</th>\r\n          <th>Type</th>\r\n          <th>Description</th>\r\n          <th>Creation Date</th>\r\n          <th></th>\r\n          <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"vendor in ctrl.data | orderBy: 'meta.creationDate':true\">\r\n          <td><a ng-href=\"/vendor/{{vendor._id}}\">{{vendor.name}}</a></td>\r\n          <td>{{vendor.type}}</td>\r\n          <td>{{vendor.description}}</td>\r\n          <td>\r\n            <nobr>{{vendor.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td><a class=\"btn btn-sm btn-primary\" ng-href=\"/vendor/{{vendor._id}}\"><i class=\"fa fa-folder-open fa-fw\"></i></a></td>\r\n          <td>\r\n            <nobr>\r\n              <a class=\"btn btn-sm btn-primary\" ng-href=\"/vendor/edit/{{vendor._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n              <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(vendor)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n            </nobr>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VendorEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vendorEdit = __webpack_require__(489);
	
	var _vendorEdit2 = _interopRequireDefault(_vendorEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var VendorEditComponent = exports.VendorEditComponent = function () {
	  VendorEditComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'VendorService', 'SettingsService', '$uibModal'];
	  function VendorEditComponent(Auth, $state, $stateParams, dialogs, VendorService, SettingsService, $uibModal) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, VendorEditComponent);
	
	    this.vendorId = $stateParams.id;
	
	    this.dialogs = dialogs;
	    this.VendorService = VendorService;
	    this.SettingsService = SettingsService;
	    this.$uibModal = $uibModal;
	    this.Auth = Auth;
	
	    this.SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	      _this.businessTypes = appSettings.data.businessTypes;
	      _this.phoneTypes = appSettings.data.phoneTypes;
	      _this.mailTypes = appSettings.data.mailTypes;
	      _this.addressTypes = appSettings.data.addressTypes;
	      _this.socialTypes = appSettings.data.socialTypes;
	    });
	
	    this.SettingsService.getByName({ name: 'custom-fields' }, function (customFieldSettings) {
	      if (customFieldSettings.data.hasOwnProperty("vendor")) {
	        _this.customSchema = customFieldSettings.data.vendor;
	        _this.customForm = ["*"];
	      }
	    });
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.model = {
	      phone: [],
	      email: [],
	      web: [],
	      address: []
	    };
	
	    if (this.vendorId) {
	      this.VendorService.get({ id: this.vendorId }, function (data) {
	        _this.model = data;
	        _this.customFields = _this.model.customFields || {};
	      }, function (err) {
	        console.log('Could not load vendor from server');
	      });
	    }
	  }
	
	  _createClass(VendorEditComponent, [{
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this2.vendorId ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "The vendor has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("vendor-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.model.customFields = this.customFields || {};
	
	        if (this.vendorId) {
	          this.VendorService.update({ id: this.vendorId }, this.model, onSuccess, onError);
	        } else {
	          this.model.meta = { creationUser: this.Auth.getCurrentUserSync()._id };
	          this.VendorService.save(this.model, onSuccess, onError);
	        }
	      }
	    }
	  }, {
	    key: 'addressEdit',
	    value: function addressEdit(idx, address) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'addressEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: address
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (address) {
	
	        that.model.address[idx] = address;
	      }, function () {});
	    }
	  }, {
	    key: 'updatePrimaryPhone',
	    value: function updatePrimaryPhone(idx) {
	      angular.forEach(this.model.phone, function (phone, index) {
	        phone.isPrimary = idx == index;
	      });
	    }
	  }, {
	    key: 'addPhone',
	    value: function addPhone() {
	      this.model.phone.push({
	        type: this.phoneTypes[0],
	        number: '',
	        isPrimary: !this.model.phone.length
	      });
	    }
	  }, {
	    key: 'removePhone',
	    value: function removePhone(idx) {
	      var primaryRemoved = this.model.phone[idx].isPrimary;
	
	      this.model.phone.splice(idx, 1);
	
	      if (primaryRemoved && this.model.phone.length > 0) {
	        this.model.phone[0].isPrimary = true;
	      }
	    }
	  }, {
	    key: 'addSocial',
	    value: function addSocial() {
	      this.model.web.push({
	        type: this.socialTypes[0],
	        link: ''
	      });
	    }
	  }, {
	    key: 'removeSocial',
	    value: function removeSocial(idx) {
	      this.model.web.splice(idx, 1);
	    }
	  }, {
	    key: 'updatePrimaryEmail',
	    value: function updatePrimaryEmail(idx) {
	      angular.forEach(this.model.email, function (email, index) {
	        email.isPrimary = idx == index;
	      });
	    }
	  }, {
	    key: 'addEmail',
	    value: function addEmail() {
	      this.model.email.push({
	        type: this.phoneTypes[0],
	        address: '',
	        isPrimary: !this.model.email.length
	      });
	    }
	  }, {
	    key: 'removeEmail',
	    value: function removeEmail(idx) {
	      var primaryRemoved = this.model.email[idx].isPrimary;
	
	      this.model.email.splice(idx, 1);
	
	      if (primaryRemoved && this.model.email.length > 0) {
	        this.model.email[0].isPrimary = true;
	      }
	    }
	  }, {
	    key: 'updatePrimaryAddress',
	    value: function updatePrimaryAddress(idx) {
	      angular.forEach(this.model.address, function (address, index) {
	        address.isPrimary = idx == index;
	      });
	    }
	  }, {
	    key: 'addAddress',
	    value: function addAddress() {
	      var idx = this.model.address.length;
	      this.addressEdit(idx, {
	        type: this.phoneTypes[0],
	        state: 'FL',
	        isPrimary: !idx
	      });
	    }
	  }, {
	    key: 'removeAddress',
	    value: function removeAddress(idx) {
	      var primaryRemoved = this.model.address[idx].isPrimary;
	
	      this.model.address.splice(idx, 1);
	
	      if (primaryRemoved && this.model.address.length > 0) {
	        this.model.address[0].isPrimary = true;
	      }
	    }
	  }]);
	
	  return VendorEditComponent;
	}();
	
	exports.default = angular.module('conduu.vendorEdit', [uiRouter]).config(_vendorEdit2.default).component('vendorEdit', {
	  template: __webpack_require__(490),
	  controller: VendorEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vendor-edit', {
	    url: '/vendor/edit/:id',
	    template: '<vendor-edit></vendor-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Vendor Editor</h2>\r\n      <li><a href=\"/vendor/list\">Vendors</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n    \r\n    <div class=\"col-xs-12\">\r\n\r\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n\r\n        <h3 class=\"separator\"><span>General</span></h3>\r\n\r\n        <!-- Vendor Name -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Name</label>\r\n\r\n          <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"ctrl.model.name\"\r\n                 required/>\r\n          <p class=\"help-block\" ng-show=\"form.name.$error.required && ctrl.submitted\">\r\n            A vendor name is required\r\n          </p>\r\n        </div>\r\n\r\n        <!-- Business Type -->\r\n        <div class=\"form-group\">\r\n          <label>Business Type</label>\r\n          <br/>\r\n\r\n          <select class=\"form-control\" ng-options=\"o as o for o in ctrl.businessTypes\" ng-model=\"ctrl.model.type\"\r\n                  style=\"display: inline-block; width: auto\"></select>\r\n        </div>\r\n\r\n        <!-- Description -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.description.$valid && ctrl.submitted,\r\n                                            'has-error': form.description.$invalid && ctrl.submitted }\">\r\n          <label>Description</label>\r\n\r\n          <input type=\"text\" name=\"description\" class=\"form-control\" ng-model=\"ctrl.model.description\"/>\r\n        </div>\r\n\r\n        <h3 class=\"separator\"><span>Phone <small>&nbsp;&nbsp;<a href=\"#\" style=\"text-decoration: none\" ng-click=\"ctrl.addPhone()\"><i class=\"fa fa fa-plus\"></i> Add</a></small></span></h3>\r\n\r\n        <!-- Phone -->\r\n        <div class=\"form-group\">\r\n          <table ng-show=\"ctrl.model.phone.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\r\n            <thead>\r\n            <tr>\r\n              <th>Type</th>\r\n              <th>Number</th>\r\n              <th>Is Primary?</th>\r\n              <th></th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody ui-sortable ng-model=\"ctrl.model.phone\">\r\n            <tr ng-repeat=\"phone in ctrl.model.phone\" style=\"cursor: move;\">\r\n              <td>\r\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.phoneTypes\" ng-model=\"phone.type\"></select>\r\n              </td>\r\n              <td>\r\n                <input class=\"form-control\" type=\"text\" ui-mask=\"(?9?9?9) ?9?9?9-?9?9?9?9\" ng-model=\"phone.number\" />\r\n              </td>\r\n              <td>\r\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"phone.isPrimary\" ng-click=\"ctrl.updatePrimaryPhone($index)\" />\r\n              </td>\r\n              <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.removePhone($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\r\n              <td style=\"cursor: move; width:16px\">\r\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <h3 class=\"separator\"><span>Email <small>&nbsp;&nbsp;<a href=\"#\" style=\"text-decoration: none\" ng-click=\"ctrl.addEmail()\"><i class=\"fa fa fa-plus\"></i> Add</a></small></span></h3>\r\n\r\n        <!-- Email -->\r\n        <div class=\"form-group\">\r\n          <table ng-show=\"ctrl.model.email.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\r\n            <thead>\r\n            <tr>\r\n              <th>Type</th>\r\n              <th>Email</th>\r\n              <th>Is Primary?</th>\r\n              <th></th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody ui-sortable ng-model=\"ctrl.model.email\">\r\n            <tr ng-repeat=\"email in ctrl.model.email\" style=\"cursor: move;\">\r\n              <td>\r\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.mailTypes\" ng-model=\"email.type\"></select>\r\n              </td>\r\n              <td>\r\n                <input class=\"form-control\" type=\"text\" ng-model=\"email.address\" />\r\n              </td>\r\n              <td>\r\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"email.isPrimary\" ng-click=\"ctrl.updatePrimaryEmail($index)\" />\r\n              </td>\r\n              <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.removeEmail($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\r\n              <td style=\"cursor: move; width:16px\">\r\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <h3 class=\"separator\"><span>Web / Social <small>&nbsp;&nbsp;<a href=\"#\" style=\"text-decoration: none\" ng-click=\"ctrl.addSocial()\"><i class=\"fa fa fa-plus\"></i> Add</a></small></span></h3>\r\n\r\n        <!-- Web -->\r\n        <div class=\"form-group\">\r\n\r\n          <table ng-show=\"ctrl.model.web.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\r\n            <thead>\r\n            <tr>\r\n              <th>Type</th>\r\n              <th>Link</th>\r\n              <th></th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody ui-sortable ng-model=\"ctrl.model.web\">\r\n            <tr ng-repeat=\"web in ctrl.model.web\" style=\"cursor: move;\">\r\n              <td>\r\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.socialTypes\" ng-model=\"web.type\"></select>\r\n              </td>\r\n              <td>\r\n                <input class=\"form-control\" type=\"text\" ng-model=\"web.link\" />\r\n              </td>\r\n              <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.removeSocial($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\r\n              <td style=\"cursor: move; width:16px\">\r\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <h3 class=\"separator\"><span>Address <small>&nbsp;&nbsp;<a href=\"#\" style=\"text-decoration: none\" ng-click=\"ctrl.addAddress()\"><i class=\"fa fa fa-plus\"></i> Add</a></small></span></h3>\r\n\r\n        <!-- Address -->\r\n        <div class=\"form-group\">\r\n          <table ng-show=\"ctrl.model.address.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\r\n            <thead>\r\n            <tr>\r\n              <th>Type</th>\r\n              <th>Address</th>\r\n              <th>Is Primary?</th>\r\n              <th></th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody ui-sortable ng-model=\"ctrl.model.address\">\r\n            <tr ng-repeat=\"address in ctrl.model.address\" style=\"cursor: move;\">\r\n              <td>\r\n                <select class=\"form-control\" ng-options=\"o as o for o in ctrl.addressTypes\" ng-model=\"address.type\"></select>\r\n              </td>\r\n              <td>\r\n                <a href=\"#\" ng-click=\"ctrl.addressEdit($index,address)\">\r\n                  {{address.street}}<br/>{{address.city}} {{address.state}}, {{address.zip}}\r\n                </a>\r\n              </td>\r\n              <td>\r\n                <input class=\"form-control\" type=\"checkbox\" ng-model=\"address.isPrimary\" ng-click=\"ctrl.updatePrimaryAddress($index)\" />\r\n              </td>\r\n              <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"ctrl.removeAddress($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\r\n              <td style=\"cursor: move; width:16px\">\r\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <div ng-if=\"ctrl.customForm\">\r\n          <h3 class=\"separator\"><span>Custom Fields</span></h3>\r\n          <div sf-schema=\"ctrl.customSchema\" sf-form=\"ctrl.customForm\" sf-model=\"ctrl.customFields\"></div>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <button ng-hide=\"ctrl.vendorId\" class=\"btn btn-primary\" type=\"submit\">Create Vendor</button>\r\n\r\n        <button ng-show=\"ctrl.vendorId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"vendor-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VendorShowComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vendorShow = __webpack_require__(492);
	
	var _vendorShow2 = _interopRequireDefault(_vendorShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var VendorShowComponent = exports.VendorShowComponent = function () {
	  VendorShowComponent.$inject = ['$stateParams', 'VendorService', '$uibModal', '$window', 'RecentVisits', 'PinnedItems', 'WorkOrderTicketsService', 'SettingsService', 'CustomEntityService'];
	  function VendorShowComponent($stateParams, VendorService, $uibModal, $window, RecentVisits, PinnedItems, WorkOrderTicketsService, SettingsService, CustomEntityService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, VendorShowComponent);
	
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.vendorId = $stateParams.id;
	    this.$uibModal = $uibModal;
	
	    this.tasks = [];
	    this.activities = [];
	    this.custom = {};
	
	    this.VendorService = VendorService;
	    this.RecentVisits = RecentVisits;
	    this.PinnedItems = PinnedItems;
	
	    WorkOrderTicketsService.getByVendor({ id: this.vendorId }, function (data) {
	      var filteredData = data.filter(function (wo) {
	        return wo.status == 'open';
	      });
	      _this.workOrders = filteredData.map(function (wo) {
	        return {
	          type: 'Work Order',
	          name: wo.code + ": " + wo.name,
	          date: wo.meta.creationDate,
	          targetDate: wo.targetDate,
	          url: "/workorder/ticket/detail/" + wo._id
	        };
	      });
	    });
	
	    SettingsService.getByName({ name: 'custom-entities-views' }, function (settings) {
	      _this.customEntitiesConfig = settings.data.vendor || { display: [] };
	      _this.customEntitiesConfig.display.forEach(function (customType) {
	        var typeConfig = _this.customEntitiesConfig[customType];
	        _this.custom[customType] = CustomEntityService.getCustomList({ type: customType, refField: typeConfig.refField, refId: $stateParams.id });
	      });
	    });
	
	    this.refreshData();
	  }
	
	  _createClass(VendorShowComponent, [{
	    key: 'refreshData',
	    value: function refreshData() {
	      var _this2 = this;
	
	      if (this.vendorId) {
	        this.VendorService.get({ id: this.vendorId }, function (data) {
	          _this2.vendor = data;
	
	          _this2.RecentVisits.addPortfolio(_this2.vendorId, "vendor", _this2.vendor.name);
	          _this2.isPinned = _this2.PinnedItems.isPinnedPortfolio(_this2.vendorId);
	        }, function (err) {
	          console.log('Could not load vendor from server');
	        });
	      }
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (resultIds) {
	        that.VendorService.addAttachments({ id: that.vendorId }, resultIds, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not add attachments to vendor');
	        });
	      }, function () {});
	    }
	  }]);
	
	  return VendorShowComponent;
	}();
	
	exports.default = angular.module('conduu.vendorShow', [uiRouter]).config(_vendorShow2.default).component('vendorShow', {
	  template: __webpack_require__(493),
	  controller: VendorShowComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vendor-show', {
	    url: '/vendor/:id',
	    template: '<vendor-show></vendor-show>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 493 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>{{ctrl.vendor.name}}</h2>\r\n      <li><a href=\"/vendor/list\">Vendors</a></li>\r\n      <li class=\"active\"><a href=\"#\">{{ctrl.vendor.name}}</a></li>\r\n    </ol>\r\n\r\n      <div class=\"col-md-6\">\r\n        <h3 style=\"margin-top: 0\" class=\"separator\"><span>General</span></h3>\r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Name</dt>\r\n          <dd>{{ctrl.vendor.name}}</dd>\r\n\r\n          <dt>Business Type</dt>\r\n          <dd>{{ctrl.vendor.type}}</dd>\r\n\r\n          <dt>Description</dt>\r\n          <dd>{{ctrl.vendor.description}}</dd>\r\n        </dl>\r\n\r\n        <h3 ng-if=\"ctrl.vendor.address.length\" style=\"margin-top: 0\" class=\"separator\"><span>Address</span></h3>\r\n        <dl class=\"dl-horizontal\">\r\n          <dt ng-repeat-start=\"address in ctrl.vendor.address\">{{address.type}}</dt>\r\n          <dd ng-repeat-end=\"\">{{address.street}}<br/>{{address.city}} {{address.state}}, {{address.zip}}</dd>\r\n        </dl>\r\n      </div>\r\n\r\n      <div class=\"col-md-6\">\r\n        <h3 ng-if=\"ctrl.vendor.phone.length\" style=\"margin-top: 0\" class=\"separator\"><span>Phone</span></h3>\r\n        <dl class=\"dl-horizontal\">\r\n          <dt ng-repeat-start=\"phone in ctrl.vendor.phone\">{{phone.type}}</dt>\r\n          <dd ng-repeat-end=\"\">{{phone.number | usPhone}}</dd>\r\n        </dl>\r\n\r\n        <h3 ng-if=\"ctrl.vendor.email.length\" style=\"margin-top: 0\" class=\"separator\"><span>Email</span></h3>\r\n        <dl class=\"dl-horizontal\">\r\n          <dt ng-repeat-start=\"email in ctrl.vendor.email\">{{email.type}}</dt>\r\n          <dd ng-repeat-end=\"\">{{email.address}}</dd>\r\n        </dl>\r\n\r\n        <h3 ng-if=\"ctrl.vendor.web.length\" style=\"margin-top: 0\" class=\"separator\"><span>Web / Social</span></h3>\r\n        <dl class=\"dl-horizontal\">\r\n          <dt ng-repeat-start=\"web in ctrl.vendor.web\">{{web.type}}</dt>\r\n          <dd ng-repeat-end=\"\">{{web.link}}</dd>\r\n        </dl>\r\n\r\n        <div style=\"clear: both\"></div>\r\n\r\n      </div>\r\n\r\n\r\n    <div class=\"col-xs-12\">\r\n      <h3 ng-if=\"ctrl.workOrders.length\" class=\"separator\"><span>Assigned Work Items</span></h3>\r\n\r\n      <dl ng-if=\"ctrl.workOrders.length\" class=\"dl-horizontal\">\r\n        <dt ng-repeat-start=\"wo in ctrl.workOrders | orderBy: 'date':false\">Work Order</dt>\r\n        <dd ng-repeat-end=\"\"><a ng-href=\"{{wo.url}}\">{{wo.name}}</a> <span class=\"text-muted\">from {{wo.date | date:'MM/dd/yyyy'}}</span> <span ng-if=\"wo.targetDate\" class=\"text-muted\">with target date {{wo.targetDate | date:'MM/dd/yyyy'}}</span></dd>\r\n      </dl>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\" ng-repeat=\"customType in ctrl.customEntitiesConfig.display\">\r\n      <h3 ng-if=\"ctrl.custom[customType].length\" class=\"separator\"><span>{{ctrl.customEntitiesConfig[customType].title}}</span></h3>\r\n\r\n      <dl ng-if=\"ctrl.custom[customType].length\" class=\"dl-horizontal\">\r\n        <dt ng-repeat-start=\"entity in ctrl.custom[customType] | orderBy: 'meta.creationDate':false\" bind-dynamic-page=\"ctrl.customEntitiesConfig[customType].dtTemplate\"></dt>\r\n        <dd ng-repeat-end=\"\" bind-dynamic-page=\"ctrl.customEntitiesConfig[customType].ddTemplate\"></dd>\r\n      </dl>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\">\r\n      \r\n      <nta-section context=\"vendor\" context-id=\"ctrl.vendorId\" data=\"ctrl.vendor\" service=\"ctrl.VendorService\" on-refresh=\"ctrl.refreshData()\"></nta-section>\r\n\r\n      <h3 class=\"separator\"><span>Attachments <small><a href=\"#\" ng-click=\"ctrl.openAssetUploadModal()\"><i class=\"fa fa-upload\"></i> Upload Files</a></small></span></h3>\r\n\r\n      <attachment-list attachments=\"ctrl.vendor.attachments\" context-id=\"ctrl.vendorId\" service=\"ctrl.VendorService\"></attachment-list>\r\n\r\n      <br/>\r\n\r\n      <div style=\"float:right\" >\r\n        <label>{{ctrl.isPinned ? 'Pinned' : \"Not Pinned\"}}&nbsp;</label> <toggle ng-model=\"ctrl.isPinned\" ng-change=\"ctrl.PinnedItems.togglePortfolio(ctrl.vendorId, 'vendor', ctrl.vendor.name)\" on=\"<i class='fa fa-fw fa-map-pin'>\" off=\"<i class='fa fa-fw fa-times'>\" onstyle=\"btn-success\" offstyle=\"btn-default\"></toggle>\r\n      </div>\r\n      <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	VendorService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VendorService = VendorService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function VendorService($resource) {
	  return $resource('/api/vendors/:id', {
	    id: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	    },
	    patch: {
	      method: 'PATCH'
	    },
	    addAttachments: {
	      method: 'PUT',
	      url: "/api/vendors/:id/attachments"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.VendorService', []).factory('VendorService', VendorService).name;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkOrderCodeListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _workordersCodeList = __webpack_require__(496);
	
	var _workordersCodeList2 = _interopRequireDefault(_workordersCodeList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var WorkOrderCodeListComponent = exports.WorkOrderCodeListComponent = function () {
	  WorkOrderCodeListComponent.$inject = ['Auth', 'WorkOrderCodesService', 'dialogs', 'DTOptionsBuilder', 'DTState'];
	  function WorkOrderCodeListComponent(Auth, WorkOrderCodesService, dialogs, DTOptionsBuilder, DTState) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, WorkOrderCodeListComponent);
	
	    this.WorkOrderCodesService = WorkOrderCodesService;
	    this.data = [];
	
	    this.dialogs = dialogs;
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'desc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Work Order Codes"
	    }, {
	      extend: 'csv',
	      title: "Work Order Codes"
	    }, {
	      title: "Work Order Codes",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'portrait',
	      pageSize: 'LETTER'
	    }, {
	      extend: 'print',
	      title: "Work Order Codes"
	    }]);
	
	    this.WorkOrderCodesService.query(function (data) {
	      _this.data = data;
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve work order codes.");
	    });
	  }
	
	  _createClass(WorkOrderCodeListComponent, [{
	    key: 'delete',
	    value: function _delete(code) {
	      var that = this;
	
	      var codeText = "<br/><br/><b>" + code.code + ': ' + code.name + "</b><br/><p>" + code.description + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Work Order Code?", "Do you really want to delete the work order code?" + codeText);
	      dlg.result.then(function () {
	        that.WorkOrderCodesService.delete({ id: code._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== code._id;
	          });
	        }, function (err) {
	          alert("Could not delete work order code");
	        });
	      }, function () {});
	    }
	  }]);
	
	  return WorkOrderCodeListComponent;
	}();
	
	exports.default = angular.module('conduu.workOrderCodeList', [uiRouter]).config(_workordersCodeList2.default).component('workOrderCodeList', {
	  template: __webpack_require__(497),
	  controller: WorkOrderCodeListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('workorder-code-list', {
	    url: '/workorder/code/list',
	    template: '<work-order-code-list></work-order-code-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" href=\"/workorder/code/edit/\"><i class=\"fa fa-plus\"></i> Create New Code</a>\r\n      <h2>Work Order Codes</h2>\r\n      <li class=\"active\"><a href=\"#\">Work Order Codes</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>Name</th>\r\n          <th>Code</th>\r\n          <th title=\"Published as Service Request\"><nobr>Published <small><i class=\"fa fa-fw fa-info-circle\"></i></small></nobr></th>\r\n          <th>Description</th>\r\n          <th>Creation Date</th>\r\n          <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"code in ctrl.data | orderBy: 'meta.creationDate':true\">\r\n          <td>{{code.name}}</td>\r\n          <td>{{code.code}}</td>\r\n          <td>\r\n            <span ng-if=\"code.published\" ><i class=\"fa fa-fw fa-check\"></i> Yes</span>\r\n            <span ng-if=\"!code.published\"><i class=\"fa fa-fw fa-times text-muted\"></i> No</span>\r\n          </td>\r\n          <td>{{code.description}}</td>\r\n          <td>\r\n            <nobr>{{code.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td>\r\n            <nobr>\r\n              <a class=\"btn btn-sm btn-primary\" ng-href=\"/workorder/code/edit/{{code._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n              <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(code)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n            </nobr>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkOrderCodeEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _workordersCodeEdit = __webpack_require__(499);
	
	var _workordersCodeEdit2 = _interopRequireDefault(_workordersCodeEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var WorkOrderCodeEditComponent = exports.WorkOrderCodeEditComponent = function () {
	  WorkOrderCodeEditComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'WorkOrderCodesService', 'TemplateService', '$uibModal'];
	  function WorkOrderCodeEditComponent(Auth, $state, $stateParams, dialogs, WorkOrderCodesService, TemplateService, $uibModal) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, WorkOrderCodeEditComponent);
	
	    this.codeId = $stateParams.id;
	
	    this.dialogs = dialogs;
	    this.WorkOrderCodesService = WorkOrderCodesService;
	    this.TemplateService = TemplateService;
	    this.Auth = Auth;
	    this.$uibModal = $uibModal;
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.allowedFileTypes = [{
	      mime: '',
	      name: 'All Files'
	    }, {
	      mime: 'image/*',
	      name: "Images"
	    }, {
	      mime: 'application/pdf',
	      name: "PDF Documents"
	    }];
	
	    this.toolbarDefinition = [["bold", "italics", "underline"], ["h3", "h4", "h5"], ["p", "quote", "clear"], ["ul", "ol"], ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"], ["undo", "redo"]];
	
	    this.templates = [];
	
	    this.TemplateService.query(function (data) {
	      _this.templates = data;
	    });
	
	    this.model = {};
	
	    if (this.codeId) {
	      this.WorkOrderCodesService.get({ id: this.codeId }, function (data) {
	        _this.model = data;
	        _this.recipients = !data.recipients ? '' : data.recipients.join("\n");
	      }, function (err) {
	        console.log('Could not load work order code from server');
	      });
	    }
	  }
	
	  _createClass(WorkOrderCodeEditComponent, [{
	    key: 'templateLookup',
	    value: function templateLookup(idx) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'templateLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (template) {
	        that.model.template = template._id;
	      }, function () {});
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this2.codeId ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "The work order code has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("workorder-code-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        var lines = this.recipients.split(/\n/);
	        this.model.recipients = [];
	        for (var i = 0; i < lines.length; i++) {
	          if (/\S/.test(lines[i])) {
	            this.model.recipients.push(lines[i].trim());
	          }
	        }
	
	        if (this.codeId) {
	          this.WorkOrderCodesService.update({ id: this.codeId }, this.model, onSuccess, onError);
	        } else {
	          this.model.meta = { creationUser: this.Auth.getCurrentUserSync()._id };
	          this.WorkOrderCodesService.save(this.model, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return WorkOrderCodeEditComponent;
	}();
	
	exports.default = angular.module('conduu.workOrderCodeEdit', [uiRouter]).config(_workordersCodeEdit2.default).component('workOrderCodeEdit', {
	  template: __webpack_require__(500),
	  controller: WorkOrderCodeEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 499 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('workorder-code-edit', {
	    url: '/workorder/code/edit/:id',
	    template: '<work-order-code-edit></work-order-code-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Work Order Code Editor</h2>\r\n      <li><a href=\"/workorder/code/list\">Work Order Codes</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n        <uib-tabset active=\"ctrl.active\">\r\n          <uib-tab index=\"0\" heading=\"General\">\r\n\r\n            <br/>\r\n\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Name</label>\r\n          <br/>\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.model.name\" />\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.code.$valid && ctrl.submitted,\r\n                                            'has-error': form.code.$invalid && ctrl.submitted }\">\r\n          <label>Code</label>\r\n          <br/>\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.model.code\" />\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.description.$valid && ctrl.submitted,\r\n                                            'has-error': form.description.$invalid && ctrl.submitted }\">\r\n          <label>Description</label>\r\n          <br/>\r\n          <textarea name=\"description\" class=\"form-control big-textfield\" ng-model=\"ctrl.model.description\"></textarea>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.instructions.$valid && ctrl.submitted,\r\n                                            'has-error': form.instructions.$invalid && ctrl.submitted }\">\r\n          <label>Instructions</label>\r\n          <br/>\r\n          <textarea name=\"instructions\" class=\"form-control big-textfield\" ng-model=\"ctrl.model.instructions\"></textarea>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label>Template</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <select class=\"form-control\" ng-options=\"o._id as o.name for o in ctrl.templates\" ng-model=\"ctrl.model.template\"\r\n                    style=\"display: inline-block; width: auto\"></select>\r\n            <span class=\"input-group-btn\">\r\n                  <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.templateLookup($index)\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                  <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.template\" ng-click=\"ctrl.model.template = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n                </span>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Mail Subject -->\r\n        <div class=\"form-group\">\r\n          <label>Email Subject Template</label>\r\n          <input type=\"text\" name=\"subject\" class=\"form-control\" ng-model=\"ctrl.model.mailSubjectTemplate\"/>\r\n        </div>\r\n\r\n        <!-- Mail Body -->\r\n        <div class=\"form-group\">\r\n          <label>Email Body Template</label>\r\n          <text-angular ng-model=\"ctrl.model.mailBodyTemplate\" ta-toolbar=\"ctrl.toolbarDefinition\"></text-angular>\r\n          <!--<textarea name=\"body\" rows=\"8\" class=\"form-control\" ng-model=\"ctrl.model.mailBodyTemplate\"></textarea>-->\r\n        </div>\r\n\r\n          </uib-tab>\r\n          <uib-tab index=\"1\" heading=\"Service Request\">\r\n\r\n            <br/>\r\n\r\n            <div class=\"row\">\r\n\r\n              <!-- Publish as Service Request -->\r\n              <div class=\"form-group col-xs-6\">\r\n                <label>Publish as Service Request</label>\r\n                <input type=\"checkbox\" name=\"publish\" class=\"form-control\" ng-model=\"ctrl.model.published\"/>\r\n              </div>\r\n\r\n              <!-- Service Request: Property Bound -->\r\n              <div class=\"form-group col-xs-6\">\r\n                <label>Property Bound</label>\r\n                <input type=\"checkbox\" name=\"propertyBound\" class=\"form-control\" ng-disabled=\"!ctrl.model.published\" ng-model=\"ctrl.model.propertyBound\"/>\r\n              </div>\r\n\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n\r\n              <div class=\"form-group col-xs-6\">\r\n                <label>Allow Upload</label>\r\n                <input type=\"checkbox\" ng-disabled=\"!ctrl.model.published\" name=\"allowUpload\" class=\"form-control\" ng-model=\"ctrl.model.uploadAllowed\"/>\r\n              </div>\r\n\r\n              <!-- Service Request: Property Bound -->\r\n              <div class=\"form-group col-xs-6\">\r\n                <label>Allowed File Types</label>\r\n                <select class=\"form-control\" ng-disabled=\"!ctrl.model.published || !ctrl.model.uploadAllowed\"  ng-options=\"o.mime as o.name for o in ctrl.allowedFileTypes\" ng-model=\"ctrl.model.uploadFileTypes\"></select>\r\n              </div>\r\n\r\n            </div>\r\n\r\n              <!-- Mail Addresses -->\r\n              <div class=\"form-group\">\r\n                <label>Recipients</label> (One Email per Line)\r\n                <textarea class=\"form-control\" rows=\"6\" ng-disabled=\"!ctrl.model.published\" ng-model=\"ctrl.recipients\" name=\"recipients\"></textarea>\r\n              </div>\r\n\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-6\">\r\n                <div class=\"form-group\">\r\n                  <label>Send Notification to <u>Recipients</u> when Owner </label>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-xs-6\">\r\n                <div class=\"form-group\">\r\n                  <label>\r\n                    <input type=\"checkbox\" name=\"notifyCreated\" ng-disabled=\"!ctrl.model.published\" ng-model=\"ctrl.model.notifyCreated\"/>\r\n                    Created\r\n                  </label>\r\n                  |\r\n                  <label>\r\n                    <input type=\"checkbox\" name=\"notifyEdited\" ng-disabled=\"!ctrl.model.published\" ng-model=\"ctrl.model.notifyEdited\"/>\r\n                    Changed\r\n                  </label>\r\n                  |\r\n                  <label>\r\n                    <input type=\"checkbox\" name=\"notifyClosed\" ng-disabled=\"!ctrl.model.published\" ng-model=\"ctrl.model.notifyClosed\"/>\r\n                    Closed Service Request\r\n                  </label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-6\">\r\n                <div class=\"form-group\">\r\n                  <label>Send Notification to <u>Owner</u> when Admin</label>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-xs-6\">\r\n                <div class=\"form-group\">\r\n                  <label>\r\n                    <input type=\"checkbox\" name=\"notifyOwnerCreated\" ng-disabled=\"!ctrl.model.published\" ng-model=\"ctrl.model.notifyOwnerCreated\"/>\r\n                    Created\r\n                  </label>\r\n                  |\r\n                  <label>\r\n                    <input type=\"checkbox\" name=\"notifyOwnerEdited\" ng-disabled=\"!ctrl.model.published\" ng-model=\"ctrl.model.notifyOwnerEdited\"/>\r\n                    Changed\r\n                  </label>\r\n                  |\r\n                  <label>\r\n                    <input type=\"checkbox\" name=\"notifyOwnerClosed\" ng-disabled=\"!ctrl.model.published\" ng-model=\"ctrl.model.notifyOwnerClosed\"/>\r\n                    Closed Service Request\r\n                  </label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n          </uib-tab>\r\n        </uib-tabset>\r\n        <br/>\r\n\r\n        <button ng-hide=\"ctrl.codeId\" class=\"btn btn-primary\" type=\"submit\">Create Code</button>\r\n\r\n        <button ng-show=\"ctrl.codeId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"workorder-code-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkOrderTicketListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _workorderTicketList = __webpack_require__(502);
	
	var _workorderTicketList2 = _interopRequireDefault(_workorderTicketList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var WorkOrderTicketListComponent = exports.WorkOrderTicketListComponent = function () {
	  WorkOrderTicketListComponent.$inject = ['WorkOrderTicketsService', 'WorkOrderCodesService', 'dialogs', '$scope', 'ViewSelection', 'DTOptionsBuilder', '$timeout', 'ChartJs', 'DTState', 'Util'];
	  function WorkOrderTicketListComponent(WorkOrderTicketsService, WorkOrderCodesService, dialogs, $scope, ViewSelection, DTOptionsBuilder, $timeout, ChartJs, DTState, Util) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, WorkOrderTicketListComponent);
	
	    this.WorkOrderTicketsService = WorkOrderTicketsService;
	    this.WorkOrderCodesService = WorkOrderCodesService;
	    this.filteredData = [];
	    this.data = [];
	    this.selectedCommunityCode = "";
	    this.visibleStatus = 'open';
	    this.$timeout = $timeout;
	
	    this.dialogs = dialogs;
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'desc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Work Order Tickets",
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }, {
	      extend: 'csv',
	      title: "Work Order Tickets",
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }, {
	      title: "Work Order Tickets",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'landscape',
	      pageSize: 'LETTER',
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }, {
	      extend: 'print',
	      title: "Work Order Tickets",
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }]);
	
	    this.dtOptions.columnDefs = [{
	      targets: [2, 3],
	      render: Util.dataTableExportBreakToNewlineRenderer
	    }];
	
	    this.chartData = {
	      'open': [],
	      'total': [],
	      'asn': []
	    };
	    this.chartLabels = {
	      'open': [],
	      'total': [],
	      'asn': []
	    };
	
	    this.chartOptions = {
	      'open': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Open per Type'
	        },
	        animation: false
	      },
	      'total': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Total per Type'
	        },
	        animation: false
	      },
	      'asn': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Total per Community'
	        },
	        animation: false
	      },
	      'overtime': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Work Orders Over Time'
	        }
	      }
	    };
	
	    this.chartColorsDefault = ChartJs.getOptions('pie').global.colors;
	    this.chartColors = {
	      'total': [],
	      'open': [],
	      'asn': []
	    };
	
	    this.labelsOvertime = ["01/18", "02/18", "03/18", "04/18", "05/18", "06/18", "07/18", "08/18", "09/18", "10/18", "11/18", "12/18", "01/19", "02/19", "03/19", "04/19", "05/19", "06/19", "07/19", "08/19", "09/19", "10/19", "11/19", "12/19", "01/20", "02/20", "03/20", "04/20", "05/20", "06/20", "07/20", "08/20", "09/20", "10/20", "11/20", "12/20"];
	    this.seriesOvertime = ['Total Open', 'Opened This Month', 'Closed This Month'];
	    this.dataOvertime = [[], [], []];
	
	    this.WorkOrderCodesService.query(function (data) {
	      _this.codes = data;
	      _this.chartLabels['open'] = data.map(function (code) {
	        return code.code;
	      });
	      _this.chartLabels['total'] = data.map(function (code) {
	        return code.code;
	      });
	    }, function (err) {
	      console.log("Could not retrieve work order codes.");
	    });
	
	    this.WorkOrderTicketsService.query(function (data) {
	      _this.data = data;
	      _this.filterData(ViewSelection.selectedCommunityCode);
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve work order tickets.");
	    });
	
	    $scope.ViewSelection = ViewSelection;
	    $scope.$watch('ViewSelection.selectedCommunity', function (newVal, oldVal, scope) {
	      _this.selectedCommunity = newVal.name;
	      _this.selectedCommunityCode = newVal.value;
	      _this.filterData(_this.selectedCommunityCode, _this.selectedCode);
	    });
	  }
	
	  _createClass(WorkOrderTicketListComponent, [{
	    key: 'buildGraphData',
	    value: function buildGraphData() {
	      var _this2 = this;
	
	      this.dataOvertime = [[], [], []];
	      this.chartData = {
	        'open': [],
	        'total': [],
	        'asn': []
	      };
	
	      this.filteredData.forEach(function (wo) {
	        var creationMonth = moment(wo.meta.creationDate).format("MM/YY");
	        var indexOpen = _this2.labelsOvertime.findIndex(function (elm) {
	          return elm == creationMonth;
	        });
	        if (indexOpen) {
	          if (!_this2.dataOvertime[1][indexOpen]) _this2.dataOvertime[1][indexOpen] = 1;else _this2.dataOvertime[1][indexOpen]++;
	        }
	
	        if (wo.closeDate) {
	          var closeMonth = moment(wo.closeDate).format("MM/YY");
	          var indexClose = _this2.labelsOvertime.findIndex(function (elm) {
	            return elm == closeMonth;
	          });
	          if (indexClose) {
	            if (!_this2.dataOvertime[2][indexClose]) _this2.dataOvertime[2][indexClose] = -1;else _this2.dataOvertime[2][indexClose]--;
	          }
	        }
	      });
	
	      for (var i = 0; i < this.labelsOvertime.length; i++) {
	        if (!this.dataOvertime[0][i]) this.dataOvertime[0][i] = 0;
	        if (!this.dataOvertime[1][i]) this.dataOvertime[1][i] = 0;
	        if (!this.dataOvertime[2][i]) this.dataOvertime[2][i] = 0;
	      }
	
	      for (var _i = 0; _i < this.labelsOvertime.length; _i++) {
	        if (_i == 0) this.dataOvertime[0][0] = this.dataOvertime[0][1] - this.dataOvertime[0][2];else this.dataOvertime[0][_i] = this.dataOvertime[0][_i - 1] + this.dataOvertime[1][_i] + this.dataOvertime[2][_i];
	      }
	
	      this.$timeout(function (_) {
	        var referenceData1 = _this2.selectedCommunityCode ? _this2.data.filter(function (wo) {
	          return wo.community && wo.community.code == _this2.selectedCommunityCode || wo.property && wo.property.community && wo.property.community.code == _this2.selectedCommunityCode;
	        }) : _this2.data;
	        _this2.chartLabels['open'].forEach(function (code) {
	          _this2.chartData['open'].push(referenceData1.filter(function (wo) {
	            return wo.code == code && wo.status == 'open';
	          }).length);
	          _this2.chartData['total'].push(referenceData1.filter(function (wo) {
	            return wo.code == code;
	          }).length);
	        });
	
	        var referenceData2 = _this2.selectedCode ? _this2.data.filter(function (wo) {
	          return wo.code == _this2.selectedCode;
	        }) : _this2.data;
	        referenceData2.forEach(function (wo) {
	          if (!wo.property && !wo.community) return;
	
	          var code = wo.property ? wo.property.community.code : wo.community.code;
	          if (!_this2.chartLabels['asn'].includes(code)) _this2.chartLabels['asn'].push(code);
	        });
	
	        _this2.chartLabels['asn'].forEach(function (asn) {
	          _this2.chartData['asn'].push(referenceData2.filter(function (wo) {
	            return wo.property && wo.property.community.code == asn || wo.community && wo.community.code == asn;
	          }).length);
	        });
	      }, 0);
	    }
	  }, {
	    key: 'resetCodeFilter',
	    value: function resetCodeFilter() {
	      this.selectedCode = null;
	      this.applyCodeFilter();
	    }
	  }, {
	    key: 'applyCodeFilter',
	    value: function applyCodeFilter() {
	      if (this.selectedCode) this.filterData(this.selectedCommunityCode, this.selectedCode);else this.filterData(this.selectedCommunityCode);
	    }
	  }, {
	    key: 'filterData',
	    value: function filterData(communityCode, ticketCode) {
	      var _this3 = this;
	
	      if (communityCode) {
	        this.filteredData = this.data.filter(function (wo) {
	          return wo.community && wo.community.code == communityCode || wo.property && wo.property.community && wo.property.community.code == communityCode;
	        });
	      } else {
	        this.filteredData = this.data;
	      }
	
	      if (ticketCode) {
	        this.filteredData = this.filteredData.filter(function (wo) {
	          return wo.code == ticketCode;
	        });
	      }
	
	      this.buildGraphData();
	
	      this.chartColors['asn'] = communityCode ? this.chartLabels['asn'].map(function (code) {
	        var idx = _this3.chartLabels['asn'].indexOf(code);
	        return code == _this3.selectedCommunityCode ? _this3.chartColorsDefault[idx] : "#eeeeee";
	      }) : this.chartColorsDefault;
	
	      this.chartColors['total'] = ticketCode ? this.chartLabels['total'].map(function (code) {
	        var idx = _this3.chartLabels['total'].indexOf(code);
	        return code == _this3.selectedCode ? _this3.chartColorsDefault[idx] : "#eeeeee";
	      }) : this.chartColorsDefault;
	
	      this.chartColors['open'] = this.chartColors['total'];
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += "<br/>" + contact.company;
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(property) {
	      if (!property || !property.address) return "";
	
	      return property.address.street + "<br/>" + property.address.city + ' ' + property.address.state + ', ' + property.address.zip;
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(ticket) {
	      var that = this;
	
	      var ticketText = "<br/><br/><b>" + ticket.code + ': ' + ticket.name + "</b><br/><p>" + ticket.description + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Work Order ticket?", "Do you really want to delete the work order ticket?" + ticketText);
	      dlg.result.then(function () {
	        that.WorkOrderTicketsService.delete({ id: ticket._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== ticket._id;
	          });
	
	          that.filterData(that.selectedCommunityCode);
	        }, function (err) {
	          alert("Could not delete ticket");
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount(cat) {
	      return this.filteredData.reduce(function (acc, obj) {
	        return acc + (obj.status === cat);
	      }, 0);
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter(cat) {
	      var _this4 = this;
	
	      this.dataInitComplete = false;
	      this.visibleStatus = cat;
	
	      this.$timeout(function (_) {
	        _this4.dataInitComplete = true;
	      }, 0);
	    }
	  }, {
	    key: 'getPrimaryOwner',
	    value: function getPrimaryOwner(property) {
	      try {
	        var primary = property.contacts.find(function (contact) {
	          return contact.type == 'primary-owner';
	        });
	
	        if (!primary || !primary.contact) return "-";
	
	        return this.getComposedName(primary.contact);
	      } catch (e) {
	        return "-";
	      }
	    }
	  }]);
	
	  return WorkOrderTicketListComponent;
	}();
	
	exports.default = angular.module('conduu.workOrderTicketList', [uiRouter]).config(_workorderTicketList2.default).component('workOrderTicketList', {
	  template: __webpack_require__(503),
	  controller: WorkOrderTicketListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('workorder-ticket-list', {
	    url: '/workorder/ticket/list',
	    template: '<work-order-ticket-list></work-order-ticket-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 503 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" href=\"/workorder/ticket/edit/\"><i class=\"fa fa-plus\"></i> Create New Ticket</a>\n      <h2>Work Order Tickets <small>{{ctrl.selectedCommunity}}</small></h2>\n      <li><a href=\"#\">{{ctrl.selectedCommunity}}</a></li>\n      <li class=\"active\"><a href=\"#\">Work Order Tickets</a></li>\n    </ol>\n\n    <div class=\"col-xs-12\">\n\n      <div class=\"form-inline pull-right\" style=\"padding-top: 6px\">\n        <label for=\"code-selector\">Filter:&nbsp;\n          <select id=\"code-selector\" ng-options=\"o.code as o.code for o in ctrl.codes\" ng-model=\"ctrl.selectedCode\" ng-change=\"ctrl.applyCodeFilter()\"></select>\n        </label>\n        <a href=\"#\" ng-if=\"ctrl.selectedCode\" ng-click=\"ctrl.resetCodeFilter()\"><i class=\"fa fa-fw fa-times\"></i></a>\n      </div>\n\n      <uib-tabset active=\"ctrl.activeTabIndex\">\n        <uib-tab select=\"ctrl.setFilter('open')\">\n          <uib-tab-heading><b>Open</b> <span class=\"badge\">{{ctrl.getCount('open')}}</span></uib-tab-heading>\n        </uib-tab>\n        <uib-tab select=\"ctrl.setFilter('closed')\">\n          <uib-tab-heading><b>Closed</b> <span class=\"badge\">{{ctrl.getCount('closed')}}</span></uib-tab-heading>\n        </uib-tab>\n        <uib-tab select=\"ctrl.setFilter('')\" class=\"pull-right separator-right\">\n          <uib-tab-heading><i class=\"fa fa-fw fa-line-chart\"></i></uib-tab-heading>\n          <br/>\n          <div class=\"row\">\n            <div class=\"col-xs-12\">\n              <!-- class= chart-bar for override / chart-dataset-override=\"ctrl.datasetOverride\"-->\n              <canvas id=\"overtime\" class=\"chart chart-line\" chart-data=\"ctrl.dataOvertime\"\n                      chart-labels=\"ctrl.labelsOvertime\" chart-series=\"ctrl.seriesOvertime\"\n                      chart-options=\"ctrl.chartOptions['overtime']\">\n              </canvas>\n            </div>\n          </div>\n        </uib-tab>\n        <uib-tab select=\"ctrl.setFilter('')\" class=\"pull-right\">\n          <uib-tab-heading><i class=\"fa fa-fw fa-pie-chart\"></i></uib-tab-heading>\n          <br/>\n          <div class=\"row\">\n\n            <div class=\"col-xs-4\">\n              <canvas id=\"doughnut\" class=\"chart chart-doughnut\"\n                      chart-data=\"ctrl.chartData['open']\" chart-labels=\"ctrl.chartLabels['open']\" chart-options=\"ctrl.chartOptions['open']\"\n                      chart-colors=\"ctrl.chartColors['open']\">\n              </canvas>\n            </div>\n\n            <div class=\"col-xs-4\">\n              <canvas id=\"doughnut2\" class=\"chart chart-doughnut\"\n                      chart-data=\"ctrl.chartData['total']\" chart-labels=\"ctrl.chartLabels['total']\" chart-options=\"ctrl.chartOptions['total']\"\n                      chart-colors=\"ctrl.chartColors['total']\">\n              </canvas>\n            </div>\n\n            <div class=\"col-xs-4\">\n              <canvas id=\"doughnut3\" class=\"chart chart-doughnut\"\n                      chart-data=\"ctrl.chartData['asn']\" chart-labels=\"ctrl.chartLabels['asn']\" chart-options=\"ctrl.chartOptions['asn']\"\n                      chart-colors=\"ctrl.chartColors['asn']\">\n              </canvas>\n            </div>\n\n          </div>\n          <hr>\n        </uib-tab>\n\n      </uib-tabset>\n\n      <br/>\n\n      <div ng-if=\"ctrl.dataInitComplete && ctrl.activeTabIndex != 2\">\n        <table datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\" style=\"width:100%\"> <!-- datatable=\"ng\" -->\n          <thead>\n          <tr>\n            <th>Target Date</th>\n            <th>Community</th>\n            <th>Property</th>\n            <th>Primary Owner</th>\n            <th>Work Order</th>\n            <th>Status</th>\n            <th>By</th>\n            <th></th>\n            <th></th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-if=\"!ctrl.visibleStatus || ticket.status == ctrl.visibleStatus\" ng-repeat=\"ticket in ctrl.filteredData | orderBy: 'meta.creationDate':true\">\n            <td>\n              <nobr>{{ticket.targetDate | date:'yyyy-MM-dd'}}</nobr>\n            </td>\n            <td>{{ticket.community.code || ticket.property.community.code}}</td>\n            <td><a ng-href=\"/property/{{ticket.property._id}}\"><span ng-bind-html=\"ctrl.getAddress(ticket.property)\"></span></a></td>\n            <td ng-bind-html=\"ctrl.getPrimaryOwner(ticket.property)\"></td>\n            <td>{{ticket.code}}: {{ticket.name}}</td>\n            <td>\n              <span ng-if=\"ticket.status == 'open'\" class=\"label label-primary\">Open</span>\n              <span ng-if=\"ticket.status == 'closed'\" class=\"label label-default\">Closed</span>\n            </td>\n            <td>{{ticket.meta.creationUser.shortName || '-'}}</td>\n            <td><a class=\"btn btn-sm btn-primary\" ng-href=\"/workorder/ticket/detail/{{ticket._id}}\"><i class=\"fa fa-folder-open fa-fw\"></i></a></td>\n            <td>\n              <nobr>\n                <a class=\"btn btn-sm btn-primary\" ng-href=\"/workorder/ticket/edit/{{ticket._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\n                <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(ticket)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\n              </nobr>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkOrderTicketEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _workorderTicketEdit = __webpack_require__(505);
	
	var _workorderTicketEdit2 = _interopRequireDefault(_workorderTicketEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var WorkOrderTicketEditComponent = exports.WorkOrderTicketEditComponent = function () {
	  WorkOrderTicketEditComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'WorkOrderCodesService', 'WorkOrderTicketsService', 'PropertyService', 'VendorService', 'CommunityService', 'User', '$uibModal', 'TemplateService'];
	  function WorkOrderTicketEditComponent(Auth, $state, $stateParams, dialogs, WorkOrderCodesService, WorkOrderTicketsService, PropertyService, VendorService, CommunityService, User, $uibModal, TemplateService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, WorkOrderTicketEditComponent);
	
	    this.ticketId = $stateParams.id;
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.WorkOrderTicketsService = WorkOrderTicketsService;
	    this.WorkOrderCodesService = WorkOrderCodesService;
	    this.PropertyService = PropertyService;
	    this.VendorService = VendorService;
	    this.CommunityService = CommunityService;
	    this.TemplateService = TemplateService;
	    this.User = User;
	    this.$stateParams = $stateParams;
	    this.Auth = Auth;
	
	    this.codes = [];
	    this.codesEnum = [];
	    this.schema = {};
	    this.users = [];
	    this.properties = [];
	    this.vendors = [];
	
	    this.TemplateService.query(function (data) {
	      _this.templates = data;
	    });
	
	    var resCount = 0;
	    var maxResCount = 5;
	
	    this.User.query(function (data) {
	      _this.users = data.map(function (user) {
	        return {
	          value: user._id,
	          name: user.shortName || user.firstName + ' ' + user.lastName
	        };
	      });
	
	      resCount++;
	      if (resCount == maxResCount) _this.fetchData();
	    });
	
	    this.WorkOrderCodesService.query(function (data) {
	      _this.codes = data;
	      _this.codesEnum = data.map(function (code) {
	        return code.code;
	      });
	
	      resCount++;
	      if (resCount == maxResCount) _this.fetchData();
	    });
	
	    this.VendorService.query(function (data) {
	      _this.vendors = data.map(function (vendor) {
	        return {
	          value: vendor._id,
	          name: vendor.name,
	          type: vendor.type
	        };
	      });
	
	      resCount++;
	      if (resCount == maxResCount) _this.fetchData();
	    });
	
	    this.CommunityService.query(function (data) {
	      _this.communities = data.map(function (community) {
	        return {
	          value: community._id,
	          name: community.code + ": " + community.name
	        };
	      });
	
	      resCount++;
	      if (resCount == maxResCount) _this.fetchData();
	    });
	
	    this.PropertyService.query(function (data) {
	      _this.properties = data.map(function (property) {
	        var address = "-";
	        try {
	          address = property.address.street + ', ' + property.address.city + ' ' + property.address.state + ', ' + property.address.zip;
	        } catch (e) {}
	
	        return {
	          value: property._id,
	          name: address + ' / ' + property.lotNo,
	          community: property.community.name
	        };
	      });
	
	      if (++resCount == maxResCount) _this.fetchData();
	    });
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.model = {};
	  }
	
	  _createClass(WorkOrderTicketEditComponent, [{
	    key: 'fetchData',
	    value: function fetchData() {
	      var _this2 = this;
	
	      if (this.ticketId) {
	        this.WorkOrderTicketsService.get({ id: this.ticketId }, function (data) {
	          _this2.model = data;
	
	          if (_this2.model.targetDate) _this2.model.targetDate = new Date(_this2.model.targetDate);
	
	          if (_this2.model.property) _this2.model.property = _this2.model.property._id;
	
	          if (_this2.model.community) _this2.model.community = _this2.model.community._id;
	
	          if (_this2.model.issuedTo) _this2.model.issuedTo = _this2.model.issuedTo._id;
	
	          if (_this2.model.approvedBy) _this2.model.approvedBy = _this2.model.approvedBy._id;
	        }, function (err) {
	          console.log('Could not load work order ticket from server');
	        });
	      } else if (this.$stateParams.propertyId) {
	        this.model.property = this.$stateParams.propertyId;
	      } else if (this.$stateParams.communityId) {
	        this.model.community = this.$stateParams.communityId;
	      }
	
	      this.activeTab = this.model.community ? 1 : 0;
	    }
	  }, {
	    key: 'templateLookup',
	    value: function templateLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'templateLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (template) {
	        that.model.template = template._id;
	      }, function () {});
	    }
	  }, {
	    key: 'codeChanged',
	    value: function codeChanged() {
	      var _this3 = this;
	
	      var oCode = this.codes.find(function (code) {
	        return code.code == _this3.model.code;
	      });
	
	      if (!oCode) return;
	
	      this.model.template = oCode.template;
	      this.model.mailSubjectTemplate = oCode.mailSubjectTemplate;
	      this.model.mailBodyTemplate = oCode.mailBodyTemplate;
	      this.model.name = oCode.name;
	      this.model.description = oCode.description;
	      this.model.instructions = oCode.instructions;
	    }
	  }, {
	    key: 'openTargetDatePopup',
	    value: function openTargetDatePopup() {
	      this.targetDatePopupOpened = true;
	    }
	  }, {
	    key: 'propertyLookup',
	    value: function propertyLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'propertyLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (property) {
	        that.selectedProperty = property;
	        that.model.property = property._id;
	      }, function () {});
	    }
	  }, {
	    key: 'communityLookup',
	    value: function communityLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'communityLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (community) {
	        that.model.community = community._id;
	      }, function () {});
	    }
	  }, {
	    key: 'userLookup',
	    value: function userLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'userLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (user) {
	        that.model.approvedBy = user._id;
	      }, function () {});
	    }
	  }, {
	    key: 'vendorLookup',
	    value: function vendorLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'vendorLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (vendor) {
	        that.selectedVendor = vendor;
	        that.model.issuedTo = vendor._id;
	      }, function () {});
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this4 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this4.ticketId ? "changed" : "created";
	          var dlg = _this4.dialogs.notify("Success", "The work order ticket has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("workorder-ticket-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this4.sendFailure = true;
	        };
	
	        if (this.ticketId) {
	          this.WorkOrderTicketsService.update({ id: this.ticketId }, this.model, onSuccess, onError);
	        } else {
	          this.model.meta = { creationUser: this.Auth.getCurrentUserSync()._id };
	          this.WorkOrderTicketsService.save(this.model, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return WorkOrderTicketEditComponent;
	}();
	
	exports.default = angular.module('conduu.workOrderTicketEdit', [uiRouter]).config(_workorderTicketEdit2.default).component('workOrderTicketEdit', {
	  template: __webpack_require__(506),
	  controller: WorkOrderTicketEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 505 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('workorder-ticket-edit', {
	    url: '/workorder/ticket/edit/:id',
	    params: { propertyId: null, communityId: null },
	    template: '<work-order-ticket-edit></work-order-ticket-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Work Order Ticket Editor</h2>\r\n      <li><a href=\"/workorder/ticket/list\">Work Order Tickets</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <form class=\"form\" name=\"form\" ng-submit=\"ctrl.create(form)\" novalidate>\r\n\r\n        <uib-tabset active=\"ctrl.activeTab\">\r\n          <uib-tab index=\"0\" heading=\"Work Order for Property\">\r\n            <br/>\r\n            <div class=\"form-group\">\r\n              <label>Property</label>\r\n              <br/>\r\n\r\n              <div class=\"input-group\" style=\"display: inline-block\">\r\n                <select class=\"form-control\" ng-options=\"o.value as o.name group by o.community for o in ctrl.properties | orderBy:'name'\" ng-model=\"ctrl.model.property\"\r\n                        style=\"display: inline-block; width: auto\"></select>\r\n                <span class=\"input-group-btn\">\r\n                  <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.propertyLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                  <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.property\" ng-click=\"ctrl.model.property = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n                </span>\r\n              </div>\r\n            </div>\r\n\r\n          </uib-tab>\r\n          <uib-tab index=\"1\" heading=\"Work Order for Community\">\r\n            <br/>\r\n            <div class=\"form-group\">\r\n              <label>Community</label>\r\n              <br/>\r\n\r\n              <div class=\"input-group\" style=\"display: inline-block\">\r\n                <select class=\"form-control\" ng-options=\"o.value as o.name for o in ctrl.communities\" ng-model=\"ctrl.model.community\"\r\n                        style=\"display: inline-block; width: auto\"></select>\r\n                <span class=\"input-group-btn\">\r\n                  <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.communityLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                  <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.community\" ng-click=\"ctrl.model.community = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n                </span>\r\n              </div>\r\n            </div>\r\n\r\n          </uib-tab>\r\n        </uib-tabset>\r\n\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.title.$valid && ctrl.submitted,\r\n                                            'has-error': form.title.$invalid && ctrl.submitted }\">\r\n          <label>Code</label>\r\n          <br/>\r\n          <select class=\"form-control\" ng-options=\"o as o for o in ctrl.codesEnum\" ng-model=\"ctrl.model.code\"\r\n                  ng-change=\"ctrl.codeChanged()\" style=\"display: inline-block; width: auto\"></select>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Work Order</label>\r\n          <br/>\r\n          <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"ctrl.model.name\" required/>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.description.$valid && ctrl.submitted,\r\n                                            'has-error': form.description.$invalid && ctrl.submitted }\">\r\n          <label>Description</label>\r\n          <br/>\r\n          <textarea name=\"description\" class=\"form-control big-textfield\" ng-model=\"ctrl.model.description\"></textarea>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.instructions.$valid && ctrl.submitted,\r\n                                            'has-error': form.instructions.$invalid && ctrl.submitted }\">\r\n          <label>Instructions</label>\r\n          <br/>\r\n          <textarea name=\"instructions\" class=\"form-control big-textfield\" ng-model=\"ctrl.model.instructions\"></textarea>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label>Template</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <select class=\"form-control\" ng-options=\"o._id as o.name for o in ctrl.templates\" ng-model=\"ctrl.model.template\"\r\n                    style=\"display: inline-block; width: auto\"></select>\r\n            <span class=\"input-group-btn\">\r\n                  <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.templateLookup($index)\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                  <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.template\" ng-click=\"ctrl.model.template = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n                </span>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Target Date -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.targetDate.$valid && ctrl.submitted,\r\n                                        'has-error': form.targetDate.$invalid && ctrl.submitted }\">\r\n          <label>Target Date</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"ctrl.model.targetDate\" is-open=\"ctrl.targetDatePopupOpened\"\r\n                   close-text=\"Close\" style=\"display: inline-block; width: auto; min-width:180px\" />\r\n            <span class=\"input-group-btn\">\r\n          <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.openTargetDatePopup()\"><i class=\"fa fa-fw fa-calendar\"></i></button>\r\n        </span>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.title.$valid && ctrl.submitted,\r\n                                            'has-error': form.title.$invalid && ctrl.submitted }\">\r\n          <label>Approved By</label>\r\n          <br/>\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <select class=\"form-control\" ng-options=\"o.value as o.name for o in ctrl.users\" ng-model=\"ctrl.model.approvedBy\"\r\n                    style=\"display: inline-block; width: auto\"></select>\r\n            <span class=\"input-group-btn\">\r\n              <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.userLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n              <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.approvedBy\" ng-click=\"ctrl.model.approvedBy = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n            </span>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.title.$valid && ctrl.submitted,\r\n                                            'has-error': form.title.$invalid && ctrl.submitted }\">\r\n          <label>Issued To</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <select class=\"form-control\" ng-options=\"o.value as o.name group by o.type for o in ctrl.vendors\" ng-model=\"ctrl.model.issuedTo\"\r\n                    style=\"display: inline-block; width: auto\"></select>\r\n            <span class=\"input-group-btn\">\r\n              <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.vendorLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n              <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.issuedTo\" ng-click=\"ctrl.model.issuedTo = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n            </span>\r\n          </div>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <button ng-hide=\"ctrl.ticketId\" class=\"btn btn-primary\" type=\"submit\">Create Ticket</button>\r\n\r\n        <button ng-show=\"ctrl.ticketId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"workorder-ticket-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkorderTicketShowComponent = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _workorderTicketShow = __webpack_require__(508);
	
	var _workorderTicketShow2 = _interopRequireDefault(_workorderTicketShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var WorkorderTicketShowComponent = exports.WorkorderTicketShowComponent = function () {
	  WorkorderTicketShowComponent.$inject = ['$state', '$stateParams', 'dialogs', 'WorkOrderTicketsService', '$uibModal', '$window', 'Auth', 'RecentVisits', 'PinnedItems', '$timeout'];
	  function WorkorderTicketShowComponent($state, $stateParams, dialogs, WorkOrderTicketsService, $uibModal, $window, Auth, RecentVisits, PinnedItems, $timeout) {
	    'ngInject';
	
	    _classCallCheck(this, WorkorderTicketShowComponent);
	
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.Auth = Auth;
	    this.ticketId = $stateParams.id;
	    this.prompt = prompt;
	    this.$uibModal = $uibModal;
	    this.tasks = [];
	    this.activities = [];
	    this.$timeout = $timeout;
	
	    this.dialogs = dialogs;
	    this.WorkOrderTicketsService = WorkOrderTicketsService;
	    this.RecentVisits = RecentVisits;
	    this.PinnedItems = PinnedItems;
	
	    this.$state = $state;
	
	    this.hook = {
	      openSendAttachmentModal: this.openSendAttachmentModal.bind(this)
	    };
	
	    this.refreshData();
	  }
	
	  _createClass(WorkorderTicketShowComponent, [{
	    key: 'refreshAttachments',
	    value: function refreshAttachments() {
	      var _this = this;
	
	      var count = this.ticket.attachments.length;
	
	      this.$timeout(function (_) {
	        _this.refreshData(function (_) {
	          if (_this.ticket.attachments.length === count) {
	            _this.$timeout(function (_) {
	              _this.refreshData(function (_) {
	                if (_this.ticket.attachments.length === count) {
	                  _this.$timeout(function (_) {
	                    _this.refreshData(function (_) {
	                      if (_this.ticket.attachments.length === count) {
	                        _this.$timeout(function (_) {
	                          _this.refreshData();
	                        }, 10000);
	                      }
	                    });
	                  }, 5000);
	                }
	              });
	            }, 2500);
	          }
	        });
	      }, 2500);
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData() {
	      var _this2 = this;
	
	      if (this.ticketId) {
	        this.WorkOrderTicketsService.get({ id: this.ticketId }, function (data) {
	          _this2.ticket = data;
	
	          _this2.RecentVisits.addWorkItem(_this2.ticketId, "wo", _this2.ticket.code + ': ' + _this2.ticket.name);
	          _this2.isPinned = _this2.PinnedItems.isPinnedWorkItem(_this2.ticketId);
	        }, function (err) {
	          console.log('Could not load work order ticket from server');
	        });
	      }
	    }
	  }, {
	    key: 'addToAttachments',
	    value: function addToAttachments(id) {
	      var _this3 = this;
	
	      this.WorkOrderTicketsService.createPDFAndAttach({ id: id }, function (_) {
	        _this3.refreshData();
	      });
	    }
	  }, {
	    key: 'getEmails',
	    value: function getEmails() {
	      var _this4 = this;
	
	      var emails = [];
	
	      if (this.ticket.issuedTo) {
	        this.ticket.issuedTo.email.forEach(function (email) {
	          var group = _this4.ticket.issuedTo.name + " (Vendor)";
	
	          var description = email.address + " (" + email.type + ")";
	
	          if (email.isPrimary) {
	            description += " (PRIMARY)";
	          }
	
	          emails.push({
	            group: group,
	            email: email.address,
	            description: description
	          });
	        });
	      }
	
	      this.ticket.property.contacts.forEach(function (entry) {
	        if (!entry.contact || _typeof(entry.contact) !== 'object') return;
	
	        entry.contact.email.forEach(function (email) {
	          var group = entry.contact.firstName + " " + entry.contact.lastName + " (" + entry.type.replace("-", " ").toUpperCase() + ")";
	
	          var description = email.address + " (" + email.type + ")";
	
	          if (email.isPrimary) {
	            description += " (PRIMARY)";
	          }
	
	          emails.push({
	            group: group,
	            email: email.address,
	            description: description
	          });
	        });
	      });
	
	      return emails;
	    }
	  }, {
	    key: 'openSendAttachmentModal',
	    value: function openSendAttachmentModal(attachment) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'sendAttachmentEmail',
	        resolve: {
	          config: function config() {
	            return {
	              attachment: attachment ? attachment._id : null,
	              attachments: that.ticket.attachments.filter(function (attachment) {
	                return attachment.contentType !== 'text/html';
	              }),
	              emails: that.getEmails(),
	              templates: that.ticket.mailBodyTemplate ? [{
	                level: "Template",
	                mailSubjectTemplate: that.ticket.mailSubjectTemplate,
	                mailBodyTemplate: that.ticket.mailBodyTemplate
	              }] : [],
	              contextVars: {
	                ASSOCIATION_NAME: that.ticket.property.community.name,
	                WORK_ORDER: that.ticket.code + ': ' + that.ticket.name,
	                DESCRIPTION: that.ticket.description ? that.ticket.description.split(/\n/).join("<br/>") : '',
	                INSTRUCTIONS: that.ticket.instructions ? that.ticket.instructions.split(/\n/).join("<br/>") : '',
	                ENTITY_LINK: '<a target=\'_blank\' href=\'http://192.168.178.47:3000/workorder/ticket/detail/' + that.ticket._id + '\'>Open Work Order in Management Suite</a>'
	              }
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (mail) {
	
	        that.WorkOrderTicketsService.sendAttachmentMail({ id: that.ticketId }, mail, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log(err);
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'changeState',
	    value: function changeState() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'stateChangeForm',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (stateChange) {
	        that.ticket.status = stateChange.status;
	
	        if (stateChange.reason) {
	          that.ticket.notes.push({
	            meta: {
	              creationUser: that.Auth.getCurrentUserSync()._id
	            },
	            note: "Changed the state to '" + stateChange.status + "' because: " + stateChange.reason
	          });
	        }
	
	        if (stateChange.status == 'open') {
	          delete that.ticket.closeDate;
	        } else {
	          that.ticket.closeDate = new Date();
	        }
	
	        that.WorkOrderTicketsService.update({ id: that.ticketId }, that.ticket, function (_) {
	          return that.refreshData();
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'changeTargetDate',
	    value: function changeTargetDate() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'targetDateChangeForm',
	        resolve: {
	          config: function config() {
	            return {
	              data: that.ticket
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (change) {
	        that.ticket.targetDate = change.targetDate;
	
	        if (change.note) {
	          that.ticket.notes.push({
	            meta: {
	              creationUser: that.Auth.getCurrentUserSync()._id
	            },
	            note: change.note
	          });
	        }
	
	        that.WorkOrderTicketsService.update({ id: that.ticketId }, that.ticket, function (_) {
	          return that.refreshData();
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'changeIssuedTo',
	    value: function changeIssuedTo() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'issuedToChangeForm',
	        resolve: {
	          config: function config() {
	            return {
	              data: that.ticket
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (change) {
	        that.ticket.issuedTo = change.issuedTo;
	
	        if (change.note) {
	          that.ticket.notes.push({
	            meta: {
	              creationUser: that.Auth.getCurrentUserSync()._id
	            },
	            note: change.note
	          });
	        }
	
	        that.WorkOrderTicketsService.update({ id: that.ticketId }, that.ticket, function (_) {
	          return that.refreshData();
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'approve',
	    value: function approve() {
	      var _this5 = this;
	
	      var dlg = this.dialogs.confirm("Approve Work Order?", "Do you want to approve this work order?");
	      dlg.result.then(function () {
	        _this5.ticket.approvedBy = _this5.Auth.getCurrentUserSync()._id;
	        _this5.WorkOrderTicketsService.update({ id: _this5.ticketId }, _this5.ticket, function (_) {
	          return _this5.refreshData();
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (resultIds) {
	        that.WorkOrderTicketsService.addAttachments({ id: that.ticketId }, resultIds, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not add attachments to ticket');
	        });
	      }, function () {});
	    }
	  }]);
	
	  return WorkorderTicketShowComponent;
	}();
	
	exports.default = angular.module('conduu.workOrderTicketShow', [uiRouter]).config(_workorderTicketShow2.default).component('workOrderTicketShow', {
	  template: __webpack_require__(509),
	  controller: WorkorderTicketShowComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('workorder-ticket-show', {
	    url: '/workorder/ticket/detail/:id',
	    template: '<work-order-ticket-show></work-order-ticket-show>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>{{ctrl.ticket.code}}: {{ctrl.ticket.name}}</h2>\r\n      <li><a href=\"/workorder/ticket/list\">Work Order Tickets</a></li>\r\n      <li class=\"active\"><a href=\"#\">{{ctrl.ticket.code}}: {{ctrl.ticket.name}}</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <!-- Closed Stamp -->\r\n      <img ng-if=\"ctrl.ticket.status == 'closed'\" style=\"position: absolute;right: 80px;top: -30px;z-index: 1;width: 250px;\" src=\"assets/images/closed_stamp.png\" />\r\n\r\n      <!-- PostIt: Work Order for Community -->\r\n      <user-card community=\"ctrl.ticket.community\"></user-card>\r\n\r\n      <!-- PostIt: Work Order for Property -->\r\n      <user-card property=\"ctrl.ticket.property\"></user-card>\r\n\r\n      <div style=\"min-height: 360px;\">\r\n        <h3 style=\"margin-top: 0px\">Description</h3>\r\n        <div ng-bind-html=\"ctrl.ticket.description | newlineToHtml\"></div>\r\n\r\n        <h3>Instructions</h3>\r\n        <div ng-bind-html=\"ctrl.ticket.instructions | newlineToHtml\"></div>\r\n      </div>\r\n\r\n      <div class=\"col-xs-6\" style=\"padding-left:0\">\r\n        <h3 class=\"separator\"><span>General</span></h3>\r\n\r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Target Date</dt>\r\n          <dd>\r\n            <span ng-if=\"ctrl.ticket.targetDate\">{{ctrl.ticket.targetDate | date:'yyyy-MM-dd'}}</span>\r\n            <span ng-if=\"!ctrl.ticket.targetDate\">-</span>\r\n          </dd>\r\n\r\n          <dt>Approved By</dt>\r\n          <dd>\r\n            <span ng-if=\"ctrl.ticket.approvedBy\">{{ctrl.ticket.approvedBy.firstName}} {{ctrl.ticket.approvedBy.middleName || ''}} {{ctrl.ticket.approvedBy.lastName}}</span>\r\n            <span ng-if=\"!ctrl.ticket.approvedBy\">-</span>\r\n          </dd>\r\n\r\n          <dt>Issued To</dt>\r\n          <dd>\r\n            <a ng-href=\"/vendor/{{ctrl.ticket.issuedTo._id}}\" ng-if=\"ctrl.ticket.issuedTo\">{{ctrl.ticket.issuedTo.name}}</a>\r\n            <span ng-if=\"!ctrl.ticket.issuedTo\">-</span>\r\n          </dd>\r\n        </dl>\r\n      </div>\r\n\r\n      <div class=\"col-xs-6\">\r\n        <h3 class=\"separator\"><span>Actions</span></h3>\r\n\r\n        <dl>\r\n          <dt>Management</dt>\r\n          <dd>\r\n            <button class=\"btn btn-sm btn-primary\" ng-disabled=\"ctrl.ticket.approvedBy\" ng-click=\"ctrl.approve()\"><i class=\"fa fa-fw fa-check\"></i> Approve</button>\r\n            <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.changeTargetDate()\"><i class=\"fa fa-calendar-check-o fa-fw\"></i> Change Target Date</button>\r\n            <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.changeIssuedTo()\"><i class=\"fa fa-briefcase fa-fw\"></i> Change Issued To</button>\r\n            <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.changeState()\"><i class=\"fa fa-refresh fa-fw\"></i> Change Status</button>\r\n          </dd>\r\n          <br/>\r\n          <dt>Letters</dt>\r\n          <dd>\r\n            <a class=\"btn btn-sm btn-primary\" target=\"_blank\" ng-click=\"ctrl.refreshAttachments()\" ng-href=\"/api/workorders/{{ctrl.ticket._id}}/letter/docx\"><i class=\"fa fa-file-word-o fa-fw\"></i> Letter Word</a>\r\n            <a class=\"btn btn-sm btn-primary\" target=\"_blank\" ng-click=\"ctrl.refreshAttachments()\" ng-href=\"/api/workorders/{{ctrl.ticket._id}}/letter/pdf\"><i class=\"fa fa-file-pdf-o fa-fw\"></i> Letter PDF</a>\r\n            <a class=\"btn btn-sm btn-primary\" title=\"Add PDF to Attachments\" ng-click=\"ctrl.addToAttachments(ctrl.ticket._id)\"><i class=\"fa fa-file-pdf-o\"></i><i class=\"fa fa-level-down\"></i> Attach</a>\r\n            <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.openSendAttachmentModal()\"><i class=\"fa fa-fw fa-envelope\"></i> Send Attachment</button>\r\n          </dd>\r\n        </dl>\r\n      </div>\r\n\r\n      <div style=\"clear:both\"></div>\r\n\r\n      <nta-section context=\"workorder\" context-id=\"ctrl.ticketId\" data=\"ctrl.ticket\" service=\"ctrl.WorkOrderTicketsService\" on-refresh=\"ctrl.refreshData()\"></nta-section>\r\n\r\n      <h3 class=\"separator\"><span>Attachments <small><a href=\"#\" ng-click=\"ctrl.openAssetUploadModal()\"><i class=\"fa fa-upload\"></i> Upload Files</a></small></span></h3>\r\n\r\n      <attachment-list attachments=\"ctrl.ticket.attachments\" context-id=\"ctrl.ticketId\"\r\n                       service=\"ctrl.WorkOrderTicketsService\" hook=\"ctrl.hook\"></attachment-list>\r\n\r\n      <br/>\r\n      <div style=\"float:right\" >\r\n        <label>{{ctrl.isPinned ? 'Pinned' : \"Not Pinned\"}}&nbsp;</label> <toggle ng-model=\"ctrl.isPinned\" ng-change=\"ctrl.PinnedItems.toggleWorkItem(ctrl.ticketId, 'wo', ctrl.ticket.code + ': ' + ctrl.ticket.name)\" on=\"<i class='fa fa-fw fa-map-pin'>\" off=\"<i class='fa fa-fw fa-times'>\" onstyle=\"btn-success\" offstyle=\"btn-default\"></toggle>\r\n      </div>\r\n      <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	WorkOrderCodesService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkOrderCodesService = WorkOrderCodesService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function WorkOrderCodesService($resource) {
	  return $resource('/api/workorder-codes/:id', {
	    name: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	    }
	  });
	}
	
	exports.default = angular.module('conduu.WorkOrderCodesService', []).factory('WorkOrderCodesService', WorkOrderCodesService).name;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	WorkOrderTicketsService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkOrderTicketsService = WorkOrderTicketsService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function WorkOrderTicketsService($resource) {
	  return $resource('/api/workorders/:id', {
	    name: '@_id'
	  }, {
	    letter: {
	      method: 'GET',
	      url: "/api/workorders/:id/letter"
	    },
	    update: {
	      method: 'PUT'
	    },
	    patch: {
	      method: 'PATCH'
	    },
	    getByVendor: {
	      method: 'GET',
	      url: "/api/workorders/vendor/:id",
	      isArray: true
	    },
	    getByProperty: {
	      method: 'GET',
	      url: "/api/workorders/property/:id",
	      isArray: true
	    },
	    getByCommunity: {
	      method: 'GET',
	      url: "/api/workorders/community/:id",
	      isArray: true
	    },
	    addAttachments: {
	      method: 'PUT',
	      url: "/api/workorders/:id/attachments"
	    },
	    createPDFAndAttach: {
	      method: 'GET',
	      url: "/api/workorders/:id/attach-letter"
	    },
	    sendAttachmentMail: {
	      method: 'POST',
	      url: "/api/workorders/:id/attachments/mail"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.WorkOrderTicketsService', []).factory('WorkOrderTicketsService', WorkOrderTicketsService).name;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ServiceRequestTicketListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _servicerequestTicketList = __webpack_require__(513);
	
	var _servicerequestTicketList2 = _interopRequireDefault(_servicerequestTicketList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ServiceRequestTicketListComponent = exports.ServiceRequestTicketListComponent = function () {
	  ServiceRequestTicketListComponent.$inject = ['ServiceRequestTicketsService', 'WorkOrderCodesService', 'dialogs', '$scope', 'ViewSelection', 'DTOptionsBuilder', '$timeout', 'ChartJs', 'DTState', 'Util'];
	  function ServiceRequestTicketListComponent(ServiceRequestTicketsService, WorkOrderCodesService, dialogs, $scope, ViewSelection, DTOptionsBuilder, $timeout, ChartJs, DTState, Util) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ServiceRequestTicketListComponent);
	
	    this.ServiceRequestTicketsService = ServiceRequestTicketsService;
	    this.WorkOrderCodesService = WorkOrderCodesService;
	    this.filteredData = [];
	    this.data = [];
	    this.selectedCommunityCode = "";
	    this.visibleStatus = 'open';
	    this.$timeout = $timeout;
	
	    this.dialogs = dialogs;
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'desc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Service Requests",
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }, {
	      extend: 'csv',
	      title: "Service Requests",
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }, {
	      title: "Service Requests",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'landscape',
	      pageSize: 'LETTER',
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }, {
	      extend: 'print',
	      title: "Service Requests",
	      exportOptions: {
	        orthogonal: 'export'
	      }
	    }]);
	
	    this.dtOptions.columnDefs = [{
	      targets: [1, 3, 4],
	      render: Util.dataTableExportBreakToNewlineRenderer
	    }];
	
	    this.chartLabels = {
	      'open': [],
	      'total': [],
	      'asn': []
	    };
	
	    this.chartOptions = {
	      'open': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Open per Type'
	        },
	        animation: false
	      },
	      'total': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Total per Type'
	        },
	        animation: false
	      },
	      'asn': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Total per Community'
	        },
	        animation: false
	      },
	      'overtime': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Service Requests Over Time'
	        }
	      }
	    };
	
	    this.chartColorsDefault = ChartJs.getOptions('pie').global.colors;
	    this.chartColors = {
	      'total': [],
	      'open': [],
	      'asn': []
	    };
	
	    this.labelsOvertime = ["01/18", "02/18", "03/18", "04/18", "05/18", "06/18", "07/18", "08/18", "09/18", "10/18", "11/18", "12/18", "01/19", "02/19", "03/19", "04/19", "05/19", "06/19", "07/19", "08/19", "09/19", "10/19", "11/19", "12/19", "01/20", "02/20", "03/20", "04/20", "05/20", "06/20", "07/20", "08/20", "09/20", "10/20", "11/20", "12/20"];
	    this.seriesOvertime = ['Total Open', 'Opened This Month', 'Closed This Month'];
	
	    this.WorkOrderCodesService.query(function (data) {
	      _this.codes = data;
	      _this.chartLabels['open'] = data.map(function (code) {
	        return code.code;
	      });
	      _this.chartLabels['total'] = data.map(function (code) {
	        return code.code;
	      });
	    }, function (err) {
	      console.log("Could not retrieve work order codes.");
	    });
	
	    this.ServiceRequestTicketsService.query(function (data) {
	      _this.data = data;
	      _this.filterData(ViewSelection.selectedCommunityCode);
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve work order tickets.");
	    });
	
	    $scope.ViewSelection = ViewSelection;
	    $scope.$watch('ViewSelection.selectedCommunity', function (newVal, oldVal, scope) {
	      _this.selectedCommunity = newVal.name;
	      _this.selectedCommunityCode = newVal.value;
	      _this.filterData(_this.selectedCommunityCode, _this.selectedCode);
	    });
	  }
	
	  _createClass(ServiceRequestTicketListComponent, [{
	    key: 'buildGraphData',
	    value: function buildGraphData() {
	      var _this2 = this;
	
	      this.dataOvertime = [[], [], []];
	      this.chartData = {
	        'open': [],
	        'total': [],
	        'asn': []
	      };
	
	      this.filteredData.forEach(function (sr) {
	        var creationMonth = moment(sr.meta.creationDate).format("MM/YY");
	        var indexOpen = _this2.labelsOvertime.findIndex(function (elm) {
	          return elm == creationMonth;
	        });
	        if (indexOpen) {
	          if (!_this2.dataOvertime[1][indexOpen]) _this2.dataOvertime[1][indexOpen] = 1;else _this2.dataOvertime[1][indexOpen]++;
	        }
	
	        if (sr.closeDate) {
	          var closeMonth = moment(sr.closeDate).format("MM/YY");
	          var indexClose = _this2.labelsOvertime.findIndex(function (elm) {
	            return elm == closeMonth;
	          });
	          if (indexClose) {
	            if (!_this2.dataOvertime[2][indexClose]) _this2.dataOvertime[2][indexClose] = -1;else _this2.dataOvertime[2][indexClose]--;
	          }
	        }
	      });
	
	      for (var i = 0; i < this.labelsOvertime.length; i++) {
	        if (!this.dataOvertime[0][i]) this.dataOvertime[0][i] = 0;
	        if (!this.dataOvertime[1][i]) this.dataOvertime[1][i] = 0;
	        if (!this.dataOvertime[2][i]) this.dataOvertime[2][i] = 0;
	      }
	
	      for (var _i = 0; _i < this.labelsOvertime.length; _i++) {
	        if (_i == 0) this.dataOvertime[0][0] = this.dataOvertime[0][1] - this.dataOvertime[0][2];else this.dataOvertime[0][_i] = this.dataOvertime[0][_i - 1] + this.dataOvertime[1][_i] + this.dataOvertime[2][_i];
	      }
	
	      this.$timeout(function (_) {
	        var referenceData1 = _this2.selectedCommunityCode ? _this2.data.filter(function (sr) {
	          return sr.property && sr.property.community && sr.property.community.code == _this2.selectedCommunityCode || sr.requester && sr.requester.communityCode == _this2.selectedCommunityCode;
	        }) : _this2.data;
	        _this2.chartLabels['open'].forEach(function (code) {
	          _this2.chartData['open'].push(referenceData1.filter(function (sr) {
	            return sr.code == code && sr.status == 'open';
	          }).length);
	          _this2.chartData['total'].push(referenceData1.filter(function (sr) {
	            return sr.code == code;
	          }).length);
	        });
	
	        var referenceData2 = _this2.selectedCode ? _this2.data.filter(function (sr) {
	          return sr.code == _this2.selectedCode;
	        }) : _this2.data;
	        referenceData2.forEach(function (sr) {
	          if (!sr.property) return;
	
	          if (!_this2.chartLabels['asn'].includes(sr.property.community.code)) _this2.chartLabels['asn'].push(sr.property.community.code);
	        });
	        _this2.chartLabels['asn'].forEach(function (asn) {
	          _this2.chartData['asn'].push(referenceData2.filter(function (sr) {
	            return sr.property && sr.property.community && sr.property.community.code == asn || sr.requester && sr.requester.communityCode == asn;
	          }).length);
	        });
	      }, 0);
	    }
	  }, {
	    key: 'resetCodeFilter',
	    value: function resetCodeFilter() {
	      this.selectedCode = null;
	      this.applyCodeFilter();
	    }
	  }, {
	    key: 'applyCodeFilter',
	    value: function applyCodeFilter() {
	      if (this.selectedCode) this.filterData(this.selectedCommunityCode, this.selectedCode);else this.filterData(this.selectedCommunityCode);
	    }
	  }, {
	    key: 'filterData',
	    value: function filterData(communityCode, ticketCode) {
	      var _this3 = this;
	
	      if (communityCode) {
	        this.filteredData = this.data.filter(function (sr) {
	          return sr.property && sr.property.community && sr.property.community.code == communityCode || sr.requester && sr.requester.communityCode == communityCode;
	        });
	      } else {
	        this.filteredData = this.data;
	      }
	
	      if (ticketCode) {
	        this.filteredData = this.filteredData.filter(function (sr) {
	          return sr.code == ticketCode;
	        });
	      }
	
	      this.buildGraphData();
	
	      this.chartColors['asn'] = communityCode ? this.chartLabels['asn'].map(function (code) {
	        var idx = _this3.chartLabels['asn'].indexOf(code);
	        return code == _this3.selectedCommunityCode ? _this3.chartColorsDefault[idx] : "#eeeeee";
	      }) : this.chartColorsDefault;
	
	      this.chartColors['total'] = ticketCode ? this.chartLabels['total'].map(function (code) {
	        var idx = _this3.chartLabels['total'].indexOf(code);
	        return code == _this3.selectedCode ? _this3.chartColorsDefault[idx] : "#eeeeee";
	      }) : this.chartColorsDefault;
	
	      this.chartColors['open'] = this.chartColors['total'];
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += "<br/>" + contact.company;
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'getPrimaryOwner',
	    value: function getPrimaryOwner(property) {
	      var primary = property.contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary || !primary.contact) return "-";
	
	      return this.getComposedName(primary.contact);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(ticket) {
	      var that = this;
	
	      var ticketText = "<br/><br/><b>" + ticket.code + ': ' + ticket.name + "</b><br/><p>" + ticket.description + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Service Request ticket?", "Do you really want to delete the service request ticket?" + ticketText);
	      dlg.result.then(function () {
	        that.ServiceRequestTicketsService.delete({ id: ticket._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== ticket._id;
	          });
	
	          that.filterData(that.selectedCommunityCode);
	        }, function (err) {
	          alert("Could not delete ticket");
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount(cat) {
	      return this.filteredData.reduce(function (acc, obj) {
	        return acc + (obj.status === cat);
	      }, 0);
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter(cat) {
	      var _this4 = this;
	
	      this.dataInitComplete = false;
	      this.visibleStatus = cat;
	
	      this.$timeout(function (_) {
	        _this4.dataInitComplete = true;
	      }, 0);
	    }
	  }]);
	
	  return ServiceRequestTicketListComponent;
	}();
	
	exports.default = angular.module('conduu.serviceRequestTicketList', [uiRouter]).config(_servicerequestTicketList2.default).component('serviceRequestTicketList', {
	  template: __webpack_require__(514),
	  controller: ServiceRequestTicketListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('servicerequest-ticket-list', {
	    url: '/servicerequest/ticket/list',
	    template: '<service-request-ticket-list></service-request-ticket-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" href=\"/servicerequest/ticket/edit/\"><i class=\"fa fa-plus\"></i> Create New Ticket</a>\n      <h2>Service Request Tickets <small>{{ctrl.selectedCommunity}}</small></h2>\n      <li><a href=\"#\">{{ctrl.selectedCommunity}}</a></li>\n      <li class=\"active\"><a href=\"#\">Service Request Tickets</a></li>\n    </ol>\n\n    <div class=\"col-xs-12\">\n\n      <div class=\"form-inline pull-right\" style=\"padding-top: 6px\">\n        <label for=\"code-selector\">Filter:&nbsp;\n          <select id=\"code-selector\" ng-options=\"o.code as o.code for o in ctrl.codes\" ng-model=\"ctrl.selectedCode\" ng-change=\"ctrl.applyCodeFilter()\"></select>\n        </label>\n        <a href=\"#\" ng-if=\"ctrl.selectedCode\" ng-click=\"ctrl.resetCodeFilter()\"><i class=\"fa fa-fw fa-times\"></i></a>\n      </div>\n\n      <uib-tabset active=\"ctrl.activeTabIndex\">\n        <uib-tab select=\"ctrl.setFilter('open')\">\n          <uib-tab-heading><b>Open</b> <span class=\"badge\">{{ctrl.getCount('open')}}</span></uib-tab-heading>\n        </uib-tab>\n        <uib-tab select=\"ctrl.setFilter('closed')\">\n          <uib-tab-heading><b>Closed</b> <span class=\"badge\">{{ctrl.getCount('closed')}}</span></uib-tab-heading>\n        </uib-tab>\n        <uib-tab select=\"ctrl.setFilter('')\" class=\"pull-right separator-right\">\n          <uib-tab-heading><i class=\"fa fa-fw fa-line-chart\"></i></uib-tab-heading>\n          <br/>\n          <div class=\"row\">\n            <div class=\"col-xs-12\">\n              <canvas id=\"overtime\" class=\"chart chart-line\" chart-data=\"ctrl.dataOvertime\"\n                      chart-labels=\"ctrl.labelsOvertime\" chart-series=\"ctrl.seriesOvertime\"\n                      chart-options=\"ctrl.chartOptions['overtime']\">\n              </canvas>\n            </div>\n          </div>\n        </uib-tab>\n        <uib-tab select=\"ctrl.setFilter('')\" class=\"pull-right\">\n          <uib-tab-heading><i class=\"fa fa-fw fa-pie-chart\"></i></uib-tab-heading>\n          <br/>\n          <div class=\"row\">\n\n            <div class=\"col-xs-4\">\n              <canvas id=\"doughnut\" class=\"chart chart-doughnut\"\n                      chart-data=\"ctrl.chartData['open']\" chart-labels=\"ctrl.chartLabels['open']\" chart-options=\"ctrl.chartOptions['open']\"\n                      chart-colors=\"ctrl.chartColors['open']\">\n              </canvas>\n            </div>\n\n            <div class=\"col-xs-4\">\n              <canvas id=\"doughnut2\" class=\"chart chart-doughnut\"\n                      chart-data=\"ctrl.chartData['total']\" chart-labels=\"ctrl.chartLabels['total']\" chart-options=\"ctrl.chartOptions['total']\"\n                      chart-colors=\"ctrl.chartColors['total']\">\n              </canvas>\n            </div>\n\n            <div class=\"col-xs-4\">\n              <canvas id=\"doughnut3\" class=\"chart chart-doughnut\"\n                      chart-data=\"ctrl.chartData['asn']\" chart-labels=\"ctrl.chartLabels['asn']\" chart-options=\"ctrl.chartOptions['asn']\"\n                      chart-colors=\"ctrl.chartColors['asn']\">\n              </canvas>\n            </div>\n\n          </div>\n          <hr>\n        </uib-tab>\n      </uib-tabset>\n\n      <br/>\n\n      <div ng-if=\"ctrl.dataInitComplete && ctrl.activeTabIndex != 2\">\n        <table datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\" style=\"width:100%\"> <!-- datatable=\"ng\" -->\n          <thead>\n          <tr>\n            <th>Date</th>\n            <th>Requester</th>\n            <th>Community</th>\n            <th>Property</th>\n            <th>Primary Owner</th>\n            <th>Service Request</th>\n            <th>Status</th>\n            <th>By</th>\n            <th></th>\n            <th></th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-if=\"!ctrl.visibleStatus || ticket.status == ctrl.visibleStatus\" ng-repeat=\"ticket in ctrl.filteredData | orderBy: 'meta.creationDate':true\">\n            <td>\n              <nobr>{{ticket.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\n            </td>\n            <td>\n              <span ng-if=\"ticket.requester\"><a ng-href=\"mailto:{{ticket.requester.email}}\"><i class=\"fa fa-external-link\"></i> {{ticket.requester.fullName}}</a></span>\n            </td>\n            <td>{{ticket.property.community.code || ticket.requester.communityCode}}</td>\n            <td>\n              <a ng-if=\"ticket.property\" ng-href=\"/property/{{ticket.property._id}}\">{{ticket.property.address.street}}<br/>{{ticket.property.address.city}} {{ticket.property.address.state}}, {{ticket.property.address.zip}}</a>\n            </td>\n            <td ng-bind-html=\"ctrl.getPrimaryOwner(ticket.property)\"></td>\n            <td>{{ticket.code}}: {{ticket.name}}</td>\n            <td>\n              <span ng-if=\"ticket.status == 'open'\" class=\"label label-primary\">Open</span>\n              <span ng-if=\"ticket.status == 'closed'\" class=\"label label-default\">Closed</span>\n            </td>\n            <td>{{ticket.meta.creationUser.shortName || '-'}}</td>\n            <td><a class=\"btn btn-sm btn-primary\" ng-href=\"/servicerequest/ticket/detail/{{ticket._id}}\"><i class=\"fa fa-folder-open fa-fw\"></i></a></td>\n            <td>\n              <nobr>\n                <a class=\"btn btn-sm btn-primary\" ng-href=\"/servicerequest/ticket/edit/{{ticket._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\n                <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(ticket)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\n              </nobr>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ServiceRequestTicketEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _servicerequestTicketEdit = __webpack_require__(516);
	
	var _servicerequestTicketEdit2 = _interopRequireDefault(_servicerequestTicketEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ServiceRequestTicketEditComponent = exports.ServiceRequestTicketEditComponent = function () {
	  ServiceRequestTicketEditComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'WorkOrderCodesService', 'ServiceRequestTicketsService', 'PropertyService', 'User', '$uibModal'];
	  function ServiceRequestTicketEditComponent(Auth, $state, $stateParams, dialogs, WorkOrderCodesService, ServiceRequestTicketsService, PropertyService, User, $uibModal) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ServiceRequestTicketEditComponent);
	
	    this.ticketId = $stateParams.id;
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.ServiceRequestTicketsService = ServiceRequestTicketsService;
	    this.WorkOrderCodesService = WorkOrderCodesService;
	    this.PropertyService = PropertyService;
	    this.User = User;
	    this.Auth = Auth;
	
	    this.codes = [];
	    this.codesEnum = [];
	    this.schema = {};
	    this.properties = [];
	
	    this.WorkOrderCodesService.query(function (data) {
	      _this.codes = data;
	      _this.codesEnum = data.map(function (code) {
	        return code.code;
	      });
	    });
	
	    this.PropertyService.query(function (data) {
	      _this.properties = data.map(function (property) {
	        var address = "-";
	        try {
	          address = property.address.street + ', ' + property.address.city + ' ' + property.address.state + ', ' + property.address.zip;
	        } catch (e) {}
	
	        return {
	          value: property._id,
	          name: address + ' / ' + property.lotNo,
	          community: property.community.name
	        };
	      });
	    });
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.model = {};
	
	    if (this.ticketId) {
	      this.ServiceRequestTicketsService.get({ id: this.ticketId }, function (data) {
	        _this.model = data;
	
	        if (_this.model.property) _this.model.property = _this.model.property._id;
	      }, function (err) {
	        console.log('Could not load service request ticket from server');
	      });
	    }
	  }
	
	  _createClass(ServiceRequestTicketEditComponent, [{
	    key: 'codeChanged',
	    value: function codeChanged() {
	      var _this2 = this;
	
	      var oCode = this.codes.find(function (code) {
	        return code.code == _this2.model.code;
	      });
	
	      if (!oCode) return;
	
	      this.model.sequence = oCode.sequence;
	      this.model.name = oCode.name;
	      this.model.description = oCode.description;
	      this.model.instructions = oCode.instructions;
	    }
	  }, {
	    key: 'propertyLookup',
	    value: function propertyLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'propertyLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (property) {
	        that.selectedProperty = property;
	        that.model.property = property._id;
	      }, function () {});
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this3 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this3.ticketId ? "changed" : "created";
	          var dlg = _this3.dialogs.notify("Success", "The service request ticket has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("servicerequest-ticket-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this3.sendFailure = true;
	        };
	
	        if (this.ticketId) {
	          this.ServiceRequestTicketsService.update({ id: this.ticketId }, this.model, onSuccess, onError);
	        } else {
	          this.model.meta = { creationUser: this.Auth.getCurrentUserSync()._id };
	          this.ServiceRequestTicketsService.save(this.model, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return ServiceRequestTicketEditComponent;
	}();
	
	exports.default = angular.module('conduu.serviceRequestTicketEdit', [uiRouter]).config(_servicerequestTicketEdit2.default).component('serviceRequestTicketEdit', {
	  template: __webpack_require__(517),
	  controller: ServiceRequestTicketEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('servicerequest-ticket-edit', {
	    url: '/servicerequest/ticket/edit/:id',
	    template: '<service-request-ticket-edit></service-request-ticket-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Service Request Ticket Editor</h2>\r\n      <li><a href=\"/workorder/ticket/list\">Service Request Tickets</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <form class=\"form\" name=\"form\" ng-submit=\"ctrl.create(form)\" novalidate>\r\n\r\n        <div class=\"form-group\">\r\n          <label>Property</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <select class=\"form-control\" ng-options=\"o.value as o.name group by o.community for o in ctrl.properties\" ng-model=\"ctrl.model.property\"\r\n                    style=\"display: inline-block; width: auto\"></select>\r\n            <span class=\"input-group-btn\">\r\n                  <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.propertyLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                  <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.property\" ng-click=\"ctrl.model.property = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n                </span>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.title.$valid && ctrl.submitted,\r\n                                            'has-error': form.title.$invalid && ctrl.submitted }\">\r\n          <label>Code</label>\r\n          <br/>\r\n          <select class=\"form-control\" ng-options=\"o as o for o in ctrl.codesEnum\" ng-model=\"ctrl.model.code\"\r\n                  ng-change=\"ctrl.codeChanged()\" style=\"display: inline-block; width: auto\"></select>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Service Request</label>\r\n          <br/>\r\n          <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"ctrl.model.name\" required/>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.description.$valid && ctrl.submitted,\r\n                                            'has-error': form.description.$invalid && ctrl.submitted }\">\r\n          <label>Description</label>\r\n          <br/>\r\n          <textarea name=\"description\" class=\"form-control big-textfield\" ng-model=\"ctrl.model.description\"></textarea>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.instructions.$valid && ctrl.submitted,\r\n                                            'has-error': form.instructions.$invalid && ctrl.submitted }\">\r\n          <label>Instructions</label>\r\n          <br/>\r\n          <textarea name=\"instructions\" class=\"form-control big-textfield\" ng-model=\"ctrl.model.instructions\"></textarea>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <button ng-hide=\"ctrl.ticketId\" class=\"btn btn-primary\" type=\"submit\">Create Ticket</button>\r\n\r\n        <button ng-show=\"ctrl.ticketId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"servicerequest-ticket-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ServicerequestTicketShowComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _servicerequestTicketShow = __webpack_require__(519);
	
	var _servicerequestTicketShow2 = _interopRequireDefault(_servicerequestTicketShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ServicerequestTicketShowComponent = exports.ServicerequestTicketShowComponent = function () {
	  ServicerequestTicketShowComponent.$inject = ['$state', '$stateParams', 'dialogs', 'ServiceRequestTicketsService', '$uibModal', '$window', 'Auth', 'RecentVisits', 'PinnedItems', 'WorkOrderTicketsService', 'prompt'];
	  function ServicerequestTicketShowComponent($state, $stateParams, dialogs, ServiceRequestTicketsService, $uibModal, $window, Auth, RecentVisits, PinnedItems, WorkOrderTicketsService, prompt) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ServicerequestTicketShowComponent);
	
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.Auth = Auth;
	    this.ticketId = $stateParams.id;
	    this.prompt = prompt;
	    this.$uibModal = $uibModal;
	    this.tasks = [];
	    this.activities = [];
	
	    this.dialogs = dialogs;
	    this.ServiceRequestTicketsService = ServiceRequestTicketsService;
	    this.WorkOrderTicketsService = WorkOrderTicketsService;
	    this.RecentVisits = RecentVisits;
	    this.PinnedItems = PinnedItems;
	
	    this.cards = [];
	
	    Auth.getCurrentUser(function (user) {
	      _this.user = user;
	      _this.userId = user._id;
	    });
	
	    this.$state = $state;
	
	    this.refreshData();
	  }
	
	  _createClass(ServicerequestTicketShowComponent, [{
	    key: 'getPathPhoto',
	    value: function getPathPhoto(idx) {
	      var _idx = idx ? idx - 1 : 0;
	      return "/api/storage/" + this.cards[_idx];
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData() {
	      var _this2 = this;
	
	      if (this.ticketId) {
	        this.cards = [];
	        this.ServiceRequestTicketsService.get({ id: this.ticketId }, function (data) {
	          _this2.ticket = data;
	
	          _this2.RecentVisits.addWorkItem(_this2.ticketId, "sr", _this2.ticket.code + ': ' + _this2.ticket.name);
	          _this2.isPinned = _this2.PinnedItems.isPinnedWorkItem(_this2.ticketId);
	
	          _this2.cards = _this2.ticket.attachments.filter(function (att) {
	            return att.contentType.startsWith('image/');
	          }).map(function (att) {
	            return att._id;
	          });
	
	          if (_this2.ticket.property) _this2.cards.unshift(null);
	        }, function (err) {
	          console.log('Could not load service request ticket from server');
	        });
	      }
	    }
	  }, {
	    key: 'propertyAssign',
	    value: function propertyAssign() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'propertyLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (property) {
	        that.ticket.property = property._id;
	        that.ServiceRequestTicketsService.update({ id: that.ticketId }, that.ticket, function (_) {
	          return that.refreshData();
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'changeState',
	    value: function changeState() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'stateChangeForm',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (stateChange) {
	        that.ticket.status = stateChange.status;
	
	        if (stateChange.reason) {
	          that.ticket.notes.push({
	            meta: {
	              creationUser: that.Auth.getCurrentUserSync()._id
	            },
	            note: "Changed the state to '" + stateChange.status + "' because: " + stateChange.reason
	          });
	        }
	
	        if (stateChange.status == 'open') {
	          delete that.ticket.closeDate;
	        } else {
	          that.ticket.closeDate = new Date();
	        }
	
	        that.ServiceRequestTicketsService.update({ id: that.ticketId }, that.ticket, function (_) {
	          return that.refreshData();
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'createWorkOrder',
	    value: function createWorkOrder() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'serviceRequestToWorkorderForm',
	        resolve: {
	          config: function config() {
	            return {
	              data: that.ticket
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (workOrderSettings) {
	
	        var workOrder = angular.copy(that.ticket);
	
	        delete workOrder._id;
	        delete workOrder.customFields;
	        delete workOrder.attachments;
	        delete workOrder.requester;
	
	        workOrder.meta = {
	          creationUser: that.Auth.getCurrentUserSync()._id
	        };
	
	        workOrder.code = workOrderSettings.code;
	        workOrder.status = "open";
	        workOrder.notes = [{
	          note: "Created from Service Request <a href='/servicerequest/ticket/detail/" + that.ticketId + "'>" + that.ticket.code + ": " + that.ticket.name + "</a>",
	          meta: {
	            creationUser: that.Auth.getCurrentUserSync()._id
	          }
	        }];
	
	        that.WorkOrderTicketsService.save(workOrder, function (_) {}, function (err) {
	          console.log(err);
	        });
	
	        var patchObject = [];
	
	        if (workOrderSettings.close) {
	          patchObject.push({ "op": "replace", "path": "/status", "value": "closed" });
	        }
	
	        if (workOrderSettings.note) {
	          var noteObj = {
	            firstName: that.user.firstName,
	            middleName: that.user.middleName,
	            lastName: that.user.lastName,
	            meta: {
	              suiteUser: that.userId
	            },
	            note: workOrderSettings.note
	          };
	          patchObject.push({ "op": "add", "path": "/chat/-", "value": noteObj });
	        }
	
	        if (patchObject.length) {
	          that.ServiceRequestTicketsService.patch({ id: that.ticketId }, patchObject, function (data) {
	            that.refreshData();
	          });
	        }
	      }, function () {});
	    }
	  }, {
	    key: 'addMessage',
	    value: function addMessage() {
	      var _this3 = this;
	
	      this.prompt({
	        title: 'Add Message for Owner',
	        message: 'Add your message below',
	        input: true,
	        label: '',
	        value: ''
	      }).then(function (note) {
	
	        var msgObj = {
	          note: note,
	          firstName: _this3.user.firstName,
	          middleName: _this3.user.middleName,
	          lastName: _this3.user.lastName,
	          meta: {
	            suiteUser: _this3.userId
	          }
	        };
	
	        _this3.ServiceRequestTicketsService.patch({ id: _this3.ticketId }, [{ "op": "add", "path": "/chat/-", "value": msgObj }], function (data) {
	          _this3.refreshData();
	        });
	      });
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (resultIds) {
	        that.ServiceRequestTicketsService.addAttachments({ id: that.ticketId }, resultIds, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not add attachments to ticket');
	        });
	      }, function () {});
	    }
	  }]);
	
	  return ServicerequestTicketShowComponent;
	}();
	
	exports.default = angular.module('conduu.serviceRequestTicketShow', [uiRouter]).config(_servicerequestTicketShow2.default).component('serviceRequestTicketShow', {
	  template: __webpack_require__(520),
	  controller: ServicerequestTicketShowComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('servicerequest-ticket-show', {
	    url: '/servicerequest/ticket/detail/:id',
	    template: '<service-request-ticket-show></service-request-ticket-show>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>{{ctrl.ticket.code}}: {{ctrl.ticket.name}}</h2>\r\n      <li><a href=\"/servicerequest/ticket/list\">Service Request Tickets</a></li>\r\n      <li class=\"active\"><a href=\"#\">{{ctrl.ticket.code}}: {{ctrl.ticket.name}}</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <!-- Closed Stamp -->\r\n      <img ng-if=\"ctrl.ticket.status == 'closed'\" style=\"position: absolute;right: 80px;top: -30px;z-index: 1;width: 250px;\" src=\"assets/images/closed_stamp.png\" />\r\n\r\n      <div class=\"pull-right\" ng-if=\"ctrl.cards.length\">\r\n      <!-- PostIt: Work Order for Property -->\r\n      <user-card ng-if=\"ctrl.ticket.property && (!ctrl.currentCardsPage || ctrl.currentCardsPage == 1)\" property=\"ctrl.ticket.property\"></user-card>\r\n\r\n      <photo-card ng-if=\"(ctrl.ticket.property && ctrl.currentCardsPage && ctrl.currentCardsPage > 1) || !ctrl.ticket.property\" photo=\"{{ctrl.getPathPhoto(ctrl.currentCardsPage)}}\"></photo-card>\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div style=\"text-align: right; position: relative; top:-32px\">\r\n        <ul ng-if=\"ctrl.cards.length > 1\" style=\"padding:0; margin:0\"\r\n            uib-pagination total-items=\"ctrl.cards.length\" ng-model=\"ctrl.currentCardsPage\"\r\n            class=\"pagination pagination-sm\" items-per-page=\"1\"></ul>\r\n        </div>\r\n      </div>\r\n\r\n      <div style=\"min-height: 360px;\">\r\n        <h3>Description</h3>\r\n        <div ng-bind-html=\"ctrl.ticket.description | newlineToHtml\"></div>\r\n\r\n        <h3>Instructions</h3>\r\n        <div ng-bind-html=\"ctrl.ticket.instructions | newlineToHtml\"></div>\r\n      </div>\r\n\r\n      <div style=\"clear:both\"></div>\r\n\r\n      <div class=\"col-xs-6\" style=\"padding-left:0\">\r\n        <h3 class=\"separator\"><span>General</span></h3>\r\n\r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Community</dt>\r\n          <dd>{{ctrl.ticket.property.community.code || ctrl.ticket.requester.communityCode}}</dd>\r\n\r\n          <dt>Requester Name</dt>\r\n          <dd>{{ctrl.ticket.requester.fullName || '-'}}</dd>\r\n\r\n          <dt>Requester Email</dt>\r\n          <dd>{{ctrl.ticket.requester.email || '-'}}</dd>\r\n        </dl>\r\n\r\n        <h3 class=\"separator\"><span>Actions</span></h3>\r\n\r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Management</dt>\r\n          <dd>\r\n            <button ng-hide=\"ctrl.ticket.property\" class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.propertyAssign()\"><i class=\"fa fa-arrow-circle-o-right fa-fw\"></i> Assign Property</button>\r\n            <button ng-hide=\"!ctrl.ticket.property\" class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.createWorkOrder()\"><i class=\"fa fa-wrench fa-fw\"></i> Create Work Order</button>\r\n            <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.changeState()\"><i class=\"fa fa-refresh fa-fw\"></i> Change Status</button>\r\n          </dd>\r\n        </dl>\r\n      </div>\r\n\r\n      <div class=\"col-xs-6\">\r\n\r\n        <h3 class=\"separator\"><span>Communication <small><a href=\"#\" ng-click=\"ctrl.addMessage()\"><i class=\"fa fa-comment-o\"></i> Reply</a></small></span></h3>\r\n\r\n        <ul class=\"chat\">\r\n\r\n            <!-- Webaccess User (Owner) -->\r\n          <li ng-repeat-start=\"msg in ctrl.ticket.chat\" ng-if=\"msg.meta.webaccessUser\" class=\"left clearfix\">\r\n            <span class=\"chat-img pull-left\">\r\n                <img ng-src=\"https://ui-avatars.com/api/?name={{msg.firstName}}+{{msg.lastName}}&background=333&rounded=true&color=eee&size=40\" />\r\n            </span>\r\n            <div class=\"chat-body clearfix\">\r\n              <div class=\"header\">\r\n                <strong class=\"primary-font\">{{msg.firstName}} {{msg.lastName}}</strong>\r\n                <small class=\"pull-right text-muted\">\r\n                  <span class=\"glyphicon glyphicon-time\"></span>&nbsp;\r\n                  <span am-time-ago=\"msg.meta.creationDate\"></span>\r\n                </small>\r\n              </div>\r\n              <p ng-bind-html=\"msg.note | newlineToHtml\"></p>\r\n            </div>\r\n          </li>\r\n\r\n            <!-- Suite User (Mgnt) -->\r\n          <li ng-repeat-end=\"\" ng-if=\"msg.meta.suiteUser\" class=\"right clearfix\">\r\n            <span class=\"chat-img pull-right\">\r\n                <img ng-src=\"https://ui-avatars.com/api/?name={{msg.firstName}}+{{msg.lastName}}&background=446e9b&rounded=true&color=eee&size=40\" />\r\n            </span>\r\n            <div class=\"chat-body clearfix\">\r\n              <div class=\"header\">\r\n                <small class=\" text-muted\">\r\n                  <span class=\"glyphicon glyphicon-time\"></span>&nbsp;\r\n                  <span am-time-ago=\"msg.meta.creationDate\"></span>\r\n                </small>\r\n                <strong class=\"pull-right primary-font\">{{msg.firstName}} {{msg.lastName}}</strong>\r\n              </div>\r\n              <p ng-bind-html=\"msg.note | newlineToHtml\"></p>\r\n            </div>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n\r\n      <div style=\"clear:both\"></div>\r\n\r\n      <!--<div><span><i class=\"fa fa-fw fa-info-circle\"></i> Notes in Service Requests will also be visible to the person who requested the service. S/he can add notes too, which will be visible here.</span></div>-->\r\n\r\n      <nta-section context=\"servicerequest\" context-id=\"ctrl.ticketId\" data=\"ctrl.ticket\" service=\"ctrl.ServiceRequestTicketsService\" on-refresh=\"ctrl.refreshData()\"></nta-section>\r\n\r\n      <h3 class=\"separator\"><span>Attachments <small><a href=\"#\" ng-click=\"ctrl.openAssetUploadModal()\"><i class=\"fa fa-upload\"></i> Upload Files</a></small></span></h3>\r\n\r\n      <attachment-list attachments=\"ctrl.ticket.attachments\" context-id=\"ctrl.ticketId\" service=\"ctrl.ServiceRequestTicketsService\"></attachment-list>\r\n\r\n      <br/>\r\n      <div style=\"float:right\" >\r\n        <label>{{ctrl.isPinned ? 'Pinned' : \"Not Pinned\"}}&nbsp;</label> <toggle ng-model=\"ctrl.isPinned\" ng-change=\"ctrl.PinnedItems.toggleWorkItem(ctrl.ticketId, 'sr', ctrl.ticket.code + ': ' + ctrl.ticket.name)\" on=\"<i class='fa fa-fw fa-map-pin'>\" off=\"<i class='fa fa-fw fa-times'>\" onstyle=\"btn-success\" offstyle=\"btn-default\"></toggle>\r\n      </div>\r\n      <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ServiceRequestTicketsService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ServiceRequestTicketsService = ServiceRequestTicketsService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function ServiceRequestTicketsService($resource) {
	  return $resource('/api/servicerequests/:id', {
	    name: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	    },
	    patch: {
	      method: 'PATCH'
	    },
	    getByProperty: {
	      method: 'GET',
	      url: "/api/servicerequests/property/:id",
	      isArray: true
	    },
	    addAttachments: {
	      method: 'PUT',
	      url: "/api/servicerequests/:id/attachments"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.ServiceRequestTicketsService', []).factory('ServiceRequestTicketsService', ServiceRequestTicketsService).name;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClientSettingsEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _clientEdit = __webpack_require__(523);
	
	var _clientEdit2 = _interopRequireDefault(_clientEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ClientSettingsEditComponent = exports.ClientSettingsEditComponent = function () {
	  ClientSettingsEditComponent.$inject = ['SettingsService', 'Auth', '$state', 'dialogs'];
	  function ClientSettingsEditComponent(SettingsService, Auth, $state, dialogs) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ClientSettingsEditComponent);
	
	    this.SettingsService = SettingsService;
	    this.dialogs = dialogs;
	    this.$state = $state;
	
	    this.SettingsService.getByName({ name: 'custom-fields' }, function (customFieldSettings) {
	      if (customFieldSettings.data.hasOwnProperty("client")) {
	        _this.customSchema = customFieldSettings.data.client;
	        _this.customForm = ["*"];
	      }
	    });
	
	    this.SettingsService.getByName({ name: "client" }, function (data) {
	      _this.settings = data;
	
	      _this.schema = {
	        type: "object",
	        properties: {
	          name: {
	            type: "string",
	            title: "Management Company Name"
	          },
	          address: {
	            type: "string",
	            title: 'Address of Management Company'
	          },
	          phone: {
	            title: "Phone Number",
	            type: "string"
	          },
	          fax: {
	            title: "Fax Number",
	            type: "string"
	          },
	          templateMailHeader: {
	            title: "HTML Mail Header",
	            type: "string",
	            "x-schema-form": {
	              type: "codemirror",
	              codemirrorOptions: {
	                "lineWrapping": true,
	                "lineNumbers": true,
	                "mode": "text/html",
	                "styleActiveLine": true,
	                "matchClosing": true,
	                "tabSize": 2,
	                "lint": true,
	                "gutters": ["CodeMirror-lint-markers"]
	              }
	            }
	          },
	          customInvitation: {
	            title: "Use Custom Invitation",
	            type: "boolean"
	          },
	          customInvitationSubject: {
	            title: "Invitation E-Mail Subject",
	            type: "string",
	            "x-schema-form": {
	              condition: 'model.customInvitation'
	            }
	          },
	          customInvitationTemplate: {
	            title: "Invitation E-Mail Template",
	            type: "string",
	            "x-schema-form": {
	              condition: 'model.customInvitation',
	              type: "codemirror",
	              codemirrorOptions: {
	                "lineWrapping": true,
	                "lineNumbers": true,
	                "mode": "text/html",
	                "styleActiveLine": true,
	                "matchClosing": true,
	                "tabSize": 2,
	                "lint": true,
	                "gutters": ["CodeMirror-lint-markers"]
	              }
	            }
	          },
	          customInvitationSuccessSubject: {
	            title: "Invitation Success E-Mail Subject",
	            type: "string",
	            "x-schema-form": {
	              condition: 'model.customInvitation'
	            }
	          },
	          customInvitationSuccessTemplate: {
	            title: "Invitation Success E-Mail Template",
	            type: "string",
	            "x-schema-form": {
	              condition: 'model.customInvitation',
	              type: "codemirror",
	              codemirrorOptions: {
	                "lineWrapping": true,
	                "lineNumbers": true,
	                "mode": "text/html",
	                "styleActiveLine": true,
	                "matchClosing": true,
	                "tabSize": 2,
	                "lint": true,
	                "gutters": ["CodeMirror-lint-markers"]
	              }
	            }
	          }
	        }
	      };
	
	      var SPACER = {
	        "type": "help",
	        "helpvalue": "<br/>"
	      };
	      var LINE = {
	        "type": "help",
	        "helpvalue": "<hr/>"
	      };
	
	      _this.form = [{
	        "type": "tabs",
	        "tabs": [{
	          "title": "Basic",
	          "items": [SPACER, "name", "address", "phone", "fax"]
	        }, {
	          "title": "Invitation Mail",
	          "items": [SPACER, "customInvitation", SPACER, "customInvitationSubject", "customInvitationTemplate", LINE, "customInvitationSuccessSubject", "customInvitationSuccessTemplate"]
	        }, {
	          "title": "Advanced",
	          "items": [SPACER, "templateMailHeader"]
	        }]
	      }];
	
	      _this.model = _this.settings.data;
	      _this.customFields = _this.model.customFields || {};
	
	      if (_this.customFields.dt) {
	        console.log(_this.customFields.dt);
	        _this.customFields.dt = new Date(_this.customFields.dt);
	        console.log(_this.customFields.dt);
	      }
	    }, function (err) {
	      console.log('Could not load settings from server');
	    });
	  }
	
	  _createClass(ClientSettingsEditComponent, [{
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var dlg = _this2.dialogs.notify("Success", "The client settings have been changed successfully");
	          dlg.result.then(function () {
	            that.$state.go("home");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.settings.data = this.model;
	        this.model.customFields = this.customFields || {};
	
	        this.SettingsService.update({ id: this.settings._id }, this.settings, onSuccess, onError);
	      }
	    }
	  }]);
	
	  return ClientSettingsEditComponent;
	}();
	
	exports.default = angular.module('conduu.clientSettingsEdit', [uiRouter]).config(_clientEdit2.default).component('clientSettingsEdit', {
	  template: __webpack_require__(524),
	  controller: ClientSettingsEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('client-settings-edit', {
	    url: '/admin/client/edit',
	    template: '<client-settings-edit></client-settings-edit>',
	    authenticate: 'suite-admin'
	  });
	}];

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Management Company Settings</h2>\r\n      <li class=\"active\"><a href=\"#\">Management Company Settings</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n        <div sf-schema=\"ctrl.schema\" sf-form=\"ctrl.form\" sf-model=\"ctrl.model\"></div>\r\n\r\n        <div ng-if=\"ctrl.customForm\">\r\n          <br/>\r\n          <h4 class=\"text-muted text-right\" style=\"padding:0\">Custom Fields</h4>\r\n          <hr style=\"margin-top: 0px\"/>\r\n          <div sf-schema=\"ctrl.customSchema\" sf-form=\"ctrl.customForm\" sf-model=\"ctrl.customFields\"></div>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <button class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"home\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n    <!--\r\n    <div class=\"col-xs-12\">\r\n      <pre>{{ctrl.customFields | json}}</pre>\r\n    </div>-->\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	TemplatesService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TemplatesService = TemplatesService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function TemplatesService($resource) {
	  return $resource('/api/templates/:id', {
	    id: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	    }
	  });
	}
	
	exports.default = angular.module('conduu.TemplateService', []).factory('TemplateService', TemplatesService).name;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TemplateListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateList = __webpack_require__(527);
	
	var _templateList2 = _interopRequireDefault(_templateList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var TemplateListComponent = exports.TemplateListComponent = function () {
	  TemplateListComponent.$inject = ['Auth', 'TemplateService', 'dialogs', 'DTOptionsBuilder', 'DTState'];
	  function TemplateListComponent(Auth, TemplateService, dialogs, DTOptionsBuilder, DTState) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, TemplateListComponent);
	
	    this.TemplateService = TemplateService;
	    this.data = [];
	
	    this.dialogs = dialogs;
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'desc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Letter Templates"
	    }, {
	      extend: 'csv',
	      title: "Letter Templates"
	    }, {
	      title: "Letter Templates",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'portrait',
	      pageSize: 'LETTER'
	    }, {
	      extend: 'print',
	      title: "Letter Templates"
	    }]);
	
	    this.TemplateService.query(function (data) {
	      _this.data = data;
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve templates.");
	    });
	  }
	
	  _createClass(TemplateListComponent, [{
	    key: 'delete',
	    value: function _delete(template) {
	      var that = this;
	
	      var templateText = "<br/><br/><b>" + template.name + "</b><br/><p>" + template.description + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Template?", "Do you really want to delete this template?" + templateText);
	      dlg.result.then(function () {
	        that.TemplateService.delete({ id: template._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== template._id;
	          });
	        }, function (err) {
	          alert("Could not delete template");
	        });
	      }, function () {});
	    }
	  }]);
	
	  return TemplateListComponent;
	}();
	
	exports.default = angular.module('conduu.templateList', [uiRouter]).config(_templateList2.default).component('templateList', {
	  template: __webpack_require__(528),
	  controller: TemplateListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('template-list', {
	    url: '/template/list',
	    template: '<template-list></template-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" href=\"/template/upload\"><i class=\"fa fa-plus\"></i> Create New Template</a>\r\n      <h2>Templates</h2>\r\n      <li class=\"active\"><a href=\"#\">Templates</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>Name</th>\r\n          <th>Description</th>\r\n          <th>Creation Date</th>\r\n          <th></th>\r\n          <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"template in ctrl.data | orderBy: 'meta.creationDate':true\">\r\n          <td>{{template.name}}</td>\r\n          <td>{{template.description}}</td>\r\n          <td>\r\n            <nobr>{{template.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td class=\"text-right\">\r\n            <a ng-disabled=\"!template.template\" class=\"btn btn-sm btn-primary\" ng-href=\"/api/storage/{{template.template}}\" target=\"_blank\"><i class=\"fa fa-fw fa-download\"></i></a>\r\n          </td>\r\n          <td class=\"text-right\">\r\n            <nobr>\r\n              <a class=\"btn btn-sm btn-primary\" ng-href=\"/template/edit/{{template._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n              <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(template)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n            </nobr>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TemplateEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateEdit = __webpack_require__(530);
	
	var _templateEdit2 = _interopRequireDefault(_templateEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var TemplateEditComponent = exports.TemplateEditComponent = function () {
	  TemplateEditComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'TemplateService', 'Upload', 'StorageService'];
	  function TemplateEditComponent(Auth, $state, $stateParams, dialogs, TemplateService, Upload, StorageService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, TemplateEditComponent);
	
	    this.templateId = $stateParams.id;
	
	    this.dialogs = dialogs;
	    this.TemplateService = TemplateService;
	    this.Auth = Auth;
	    this.Upload = Upload;
	    this.StorageService = StorageService;
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.schema = {
	      type: "object",
	      properties: {
	        name: {
	          type: "string",
	          minLength: 3,
	          title: "Name"
	        },
	        description: {
	          type: "string",
	          title: 'Description'
	        }
	      }
	    };
	
	    this.form = ["*"];
	
	    this.model = {};
	
	    if (this.templateId) {
	      this.TemplateService.get({ id: this.templateId }, function (data) {
	        _this.model = data;
	
	        _this.StorageService.getMeta({ id: data.template }, function (meta) {
	          _this.templateMeta = meta;
	          console.log(_this.templateMeta);
	        });
	      }, function (err) {
	        console.log('Could not load template data from server');
	      });
	    }
	  }
	
	  _createClass(TemplateEditComponent, [{
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this2.templateId ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "The template has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("template-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        if (this.replaceTemplateFile && this.templateFile) {
	          this.Upload.upload({
	            url: '/api/storage',
	            data: {
	              name: this.templateFile.name,
	              file: this.templateFile,
	              storageStrategy: 'local',
	              creationUser: this.Auth.getCurrentUserSync()._id,
	              active: true
	            }
	          }).then(function (res) {
	
	            _this2.model.template = res.data;
	            _this2.TemplateService.update({ id: _this2.templateId }, _this2.model, onSuccess, onError);
	          }, function (err) {
	            _this2.sendFailure = true;
	          });
	        } else {
	          this.TemplateService.update({ id: this.templateId }, this.model, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return TemplateEditComponent;
	}();
	
	exports.default = angular.module('conduu.templateEdit', [uiRouter]).config(_templateEdit2.default).component('templateEdit', {
	  template: __webpack_require__(531),
	  controller: TemplateEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('template-edit', {
	    url: '/template/edit/:id',
	    template: '<template-edit></template-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Template Editor</h2>\r\n      <li><a href=\"/template/list\">Templates</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n        <div sf-schema=\"ctrl.schema\" sf-form=\"ctrl.form\" sf-model=\"ctrl.model\"></div>\r\n\r\n        <!-- Template -->\r\n        <div class=\"form-group\" ng-if=\"ctrl.model.template\">\r\n          <label>Template File</label>\r\n          <br/>\r\n          <a ng-href=\"/api/storage/{{ctrl.model.template}}\" target=\"_blank\"><i class=\"fa fa-fw fa-download\"></i>{{ctrl.templateMeta.filename}}</a>\r\n        </div>\r\n\r\n        <hr>\r\n\r\n        <!-- Template Upload -->\r\n        <div class=\"form-group\">\r\n          <label><input type=\"checkbox\" ng-model=\"ctrl.replaceTemplateFile\"> I want to replace the template file</label>\r\n          <br/>\r\n\r\n        </div>\r\n        <div ng-if=\"ctrl.replaceTemplateFile\"\r\n             class=\"form-group\" ng-class=\"{ 'has-success': form.template.$valid && ctrl.submitted,\r\n                                            'has-error': form.template.$invalid && ctrl.submitted }\">\r\n          <label>New Template File</label>\r\n          <br/>\r\n          <input type=\"file\" ngf-select name=\"template\" ng-model=\"ctrl.templateFile\" accept=\"application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword\" required />\r\n\r\n          <p class=\"help-block\" ng-show=\"form.template.$error.required && ctrl.submitted\">\r\n            Please select a template file to upload\r\n          </p>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <button ng-hide=\"ctrl.templateId\" class=\"btn btn-primary\" type=\"submit\">Create Template</button>\r\n\r\n        <button ng-show=\"ctrl.templateId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"template-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TemplateUploadComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateUpload = __webpack_require__(533);
	
	var _templateUpload2 = _interopRequireDefault(_templateUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var TemplateUploadComponent = exports.TemplateUploadComponent = function () {
	  TemplateUploadComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'TemplateService', 'Upload'];
	  function TemplateUploadComponent(Auth, $state, $stateParams, dialogs, TemplateService, Upload) {
	    'ngInject';
	
	    _classCallCheck(this, TemplateUploadComponent);
	
	    this.templateId = $stateParams.id;
	
	    this.dialogs = dialogs;
	    this.TemplateService = TemplateService;
	    this.Auth = Auth;
	    this.Upload = Upload;
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.schema = {
	      type: "object",
	      properties: {
	        name: {
	          type: "string",
	          title: "Name"
	        },
	        description: {
	          type: "string",
	          title: 'Description'
	        }
	      }
	    };
	
	    this.form = ["*"];
	
	    this.model = {};
	  }
	
	  _createClass(TemplateUploadComponent, [{
	    key: 'create',
	    value: function create(form) {
	      var _this = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var dlg = _this.dialogs.notify("Success", "The template has been created successfully");
	          dlg.result.then(function () {
	            that.$state.go("template-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this.sendFailure = true;
	        };
	
	        var userId = this.Auth.getCurrentUserSync()._id;
	
	        this.Upload.upload({
	          url: '/api/storage',
	          data: {
	            name: this.templateFile.name,
	            file: this.templateFile,
	            storageStrategy: 'local',
	            creationUser: userId,
	            active: true
	          }
	        }).then(function (res) {
	
	          _this.model.template = res.data;
	          _this.model.meta = { creationUser: userId };
	          _this.TemplateService.save(_this.model, onSuccess, onError);
	        }, function (err) {
	          _this.sendFailure = true;
	        });
	      }
	    }
	  }]);
	
	  return TemplateUploadComponent;
	}();
	
	exports.default = angular.module('conduu.templateUpload', [uiRouter]).config(_templateUpload2.default).component('templateUpload', {
	  template: __webpack_require__(534),
	  controller: TemplateUploadComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('template-upload', {
	    url: '/template/upload',
	    template: '<template-upload></template-upload>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Template Upload</h2>\r\n      <li><a href=\"/template/list\">Templates</a></li>\r\n      <li class=\"active\"><a href=\"#\">Upload</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n        <div sf-schema=\"ctrl.schema\" sf-form=\"ctrl.form\" sf-model=\"ctrl.model\"></div>\r\n\r\n        <!-- Template Upload -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.template.$valid && ctrl.submitted,\r\n                                            'has-error': form.template.$invalid && ctrl.submitted }\">\r\n          <label>Template File</label>\r\n          <br/>\r\n          <input type=\"file\" ngf-select name=\"template\" ng-model=\"ctrl.templateFile\" accept=\"application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword\" required />\r\n\r\n          <p class=\"help-block\" ng-show=\"form.template.$error.required && ctrl.submitted\">\r\n            Please select a template file to upload\r\n          </p>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <button class=\"btn btn-primary\" type=\"submit\">Create Template</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"template-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["tv4"] = __webpack_require__(536);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	Author: Geraint Luff and others
	Year: 2013
	
	This code is released into the "public domain" by its author(s).  Anybody may use, alter and distribute the code without restriction.  The author makes no guarantees, and takes no liability of any kind for use of this code.
	
	If you find a bug or make an improvement, it would be courteous to let the author know, but it is not compulsory.
	*/
	(function (global, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== 'undefined' && module.exports){
	    // CommonJS. Define export.
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.tv4 = factory();
	  }
	}(this, function () {
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FObject%2Fkeys
	if (!Object.keys) {
		Object.keys = (function () {
			var hasOwnProperty = Object.prototype.hasOwnProperty,
				hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
				dontEnums = [
					'toString',
					'toLocaleString',
					'valueOf',
					'hasOwnProperty',
					'isPrototypeOf',
					'propertyIsEnumerable',
					'constructor'
				],
				dontEnumsLength = dontEnums.length;
	
			return function (obj) {
				if (typeof obj !== 'object' && typeof obj !== 'function' || obj === null) {
					throw new TypeError('Object.keys called on non-object');
				}
	
				var result = [];
	
				for (var prop in obj) {
					if (hasOwnProperty.call(obj, prop)) {
						result.push(prop);
					}
				}
	
				if (hasDontEnumBug) {
					for (var i=0; i < dontEnumsLength; i++) {
						if (hasOwnProperty.call(obj, dontEnums[i])) {
							result.push(dontEnums[i]);
						}
					}
				}
				return result;
			};
		})();
	}
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
	if (!Object.create) {
		Object.create = (function(){
			function F(){}
	
			return function(o){
				if (arguments.length !== 1) {
					throw new Error('Object.create implementation only accepts one parameter.');
				}
				F.prototype = o;
				return new F();
			};
		})();
	}
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FArray%2FisArray
	if(!Array.isArray) {
		Array.isArray = function (vArg) {
			return Object.prototype.toString.call(vArg) === "[object Array]";
		};
	}
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FArray%2FindexOf
	if (!Array.prototype.indexOf) {
		Array.prototype.indexOf = function (searchElement /*, fromIndex */ ) {
			if (this === null) {
				throw new TypeError();
			}
			var t = Object(this);
			var len = t.length >>> 0;
	
			if (len === 0) {
				return -1;
			}
			var n = 0;
			if (arguments.length > 1) {
				n = Number(arguments[1]);
				if (n !== n) { // shortcut for verifying if it's NaN
					n = 0;
				} else if (n !== 0 && n !== Infinity && n !== -Infinity) {
					n = (n > 0 || -1) * Math.floor(Math.abs(n));
				}
			}
			if (n >= len) {
				return -1;
			}
			var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
			for (; k < len; k++) {
				if (k in t && t[k] === searchElement) {
					return k;
				}
			}
			return -1;
		};
	}
	
	// Grungey Object.isFrozen hack
	if (!Object.isFrozen) {
		Object.isFrozen = function (obj) {
			var key = "tv4_test_frozen_key";
			while (obj.hasOwnProperty(key)) {
				key += Math.random();
			}
			try {
				obj[key] = true;
				delete obj[key];
				return false;
			} catch (e) {
				return true;
			}
		};
	}
	var ValidatorContext = function ValidatorContext(parent, collectMultiple, errorMessages, checkRecursive, trackUnknownProperties) {
		this.missing = [];
		this.missingMap = {};
		this.formatValidators = parent ? Object.create(parent.formatValidators) : {};
		this.schemas = parent ? Object.create(parent.schemas) : {};
		this.collectMultiple = collectMultiple;
		this.errors = [];
		this.handleError = collectMultiple ? this.collectError : this.returnError;
		if (checkRecursive) {
			this.checkRecursive = true;
			this.scanned = [];
			this.scannedFrozen = [];
			this.scannedFrozenSchemas = [];
			this.scannedFrozenValidationErrors = [];
			this.validatedSchemasKey = 'tv4_validation_id';
			this.validationErrorsKey = 'tv4_validation_errors_id';
		}
		if (trackUnknownProperties) {
			this.trackUnknownProperties = true;
			this.knownPropertyPaths = {};
			this.unknownPropertyPaths = {};
		}
		this.errorMessages = errorMessages;
		this.definedKeywords = {};
		if (parent) {
			for (var key in parent.definedKeywords) {
				this.definedKeywords[key] = parent.definedKeywords[key].slice(0);
			}
		}
	};
	ValidatorContext.prototype.defineKeyword = function (keyword, keywordFunction) {
		this.definedKeywords[keyword] = this.definedKeywords[keyword] || [];
		this.definedKeywords[keyword].push(keywordFunction);
	};
	ValidatorContext.prototype.createError = function (code, messageParams, dataPath, schemaPath, subErrors) {
		var messageTemplate = this.errorMessages[code] || ErrorMessagesDefault[code];
		if (typeof messageTemplate !== 'string') {
			return new ValidationError(code, "Unknown error code " + code + ": " + JSON.stringify(messageParams), dataPath, schemaPath, subErrors);
		}
		// Adapted from Crockford's supplant()
		var message = messageTemplate.replace(/\{([^{}]*)\}/g, function (whole, varName) {
			var subValue = messageParams[varName];
			return typeof subValue === 'string' || typeof subValue === 'number' ? subValue : whole;
		});
		return new ValidationError(code, message, dataPath, schemaPath, subErrors);
	};
	ValidatorContext.prototype.returnError = function (error) {
		return error;
	};
	ValidatorContext.prototype.collectError = function (error) {
		if (error) {
			this.errors.push(error);
		}
		return null;
	};
	ValidatorContext.prototype.prefixErrors = function (startIndex, dataPath, schemaPath) {
		for (var i = startIndex; i < this.errors.length; i++) {
			this.errors[i] = this.errors[i].prefixWith(dataPath, schemaPath);
		}
		return this;
	};
	ValidatorContext.prototype.banUnknownProperties = function () {
		for (var unknownPath in this.unknownPropertyPaths) {
			var error = this.createError(ErrorCodes.UNKNOWN_PROPERTY, {path: unknownPath}, unknownPath, "");
			var result = this.handleError(error);
			if (result) {
				return result;
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.addFormat = function (format, validator) {
		if (typeof format === 'object') {
			for (var key in format) {
				this.addFormat(key, format[key]);
			}
			return this;
		}
		this.formatValidators[format] = validator;
	};
	ValidatorContext.prototype.resolveRefs = function (schema, urlHistory) {
		if (schema['$ref'] !== undefined) {
			urlHistory = urlHistory || {};
			if (urlHistory[schema['$ref']]) {
				return this.createError(ErrorCodes.CIRCULAR_REFERENCE, {urls: Object.keys(urlHistory).join(', ')}, '', '');
			}
			urlHistory[schema['$ref']] = true;
			schema = this.getSchema(schema['$ref'], urlHistory);
		}
		return schema;
	};
	ValidatorContext.prototype.getSchema = function (url, urlHistory) {
		var schema;
		if (this.schemas[url] !== undefined) {
			schema = this.schemas[url];
			return this.resolveRefs(schema, urlHistory);
		}
		var baseUrl = url;
		var fragment = "";
		if (url.indexOf('#') !== -1) {
			fragment = url.substring(url.indexOf("#") + 1);
			baseUrl = url.substring(0, url.indexOf("#"));
		}
		if (typeof this.schemas[baseUrl] === 'object') {
			schema = this.schemas[baseUrl];
			var pointerPath = decodeURIComponent(fragment);
			if (pointerPath === "") {
				return this.resolveRefs(schema, urlHistory);
			} else if (pointerPath.charAt(0) !== "/") {
				return undefined;
			}
			var parts = pointerPath.split("/").slice(1);
			for (var i = 0; i < parts.length; i++) {
				var component = parts[i].replace(/~1/g, "/").replace(/~0/g, "~");
				if (schema[component] === undefined) {
					schema = undefined;
					break;
				}
				schema = schema[component];
			}
			if (schema !== undefined) {
				return this.resolveRefs(schema, urlHistory);
			}
		}
		if (this.missing[baseUrl] === undefined) {
			this.missing.push(baseUrl);
			this.missing[baseUrl] = baseUrl;
			this.missingMap[baseUrl] = baseUrl;
		}
	};
	ValidatorContext.prototype.searchSchemas = function (schema, url) {
		if (schema && typeof schema === "object") {
			if (typeof schema.id === "string") {
				if (isTrustedUrl(url, schema.id)) {
					if (this.schemas[schema.id] === undefined) {
						this.schemas[schema.id] = schema;
					}
				}
			}
			for (var key in schema) {
				if (key !== "enum") {
					if (typeof schema[key] === "object") {
						this.searchSchemas(schema[key], url);
					} else if (key === "$ref") {
						var uri = getDocumentUri(schema[key]);
						if (uri && this.schemas[uri] === undefined && this.missingMap[uri] === undefined) {
							this.missingMap[uri] = uri;
						}
					}
				}
			}
		}
	};
	ValidatorContext.prototype.addSchema = function (url, schema) {
		//overload
		if (typeof url !== 'string' || typeof schema === 'undefined') {
			if (typeof url === 'object' && typeof url.id === 'string') {
				schema = url;
				url = schema.id;
			}
			else {
				return;
			}
		}
		if (url = getDocumentUri(url) + "#") {
			// Remove empty fragment
			url = getDocumentUri(url);
		}
		this.schemas[url] = schema;
		delete this.missingMap[url];
		normSchema(schema, url);
		this.searchSchemas(schema, url);
	};
	
	ValidatorContext.prototype.getSchemaMap = function () {
		var map = {};
		for (var key in this.schemas) {
			map[key] = this.schemas[key];
		}
		return map;
	};
	
	ValidatorContext.prototype.getSchemaUris = function (filterRegExp) {
		var list = [];
		for (var key in this.schemas) {
			if (!filterRegExp || filterRegExp.test(key)) {
				list.push(key);
			}
		}
		return list;
	};
	
	ValidatorContext.prototype.getMissingUris = function (filterRegExp) {
		var list = [];
		for (var key in this.missingMap) {
			if (!filterRegExp || filterRegExp.test(key)) {
				list.push(key);
			}
		}
		return list;
	};
	
	ValidatorContext.prototype.dropSchemas = function () {
		this.schemas = {};
		this.reset();
	};
	ValidatorContext.prototype.reset = function () {
		this.missing = [];
		this.missingMap = {};
		this.errors = [];
	};
	
	ValidatorContext.prototype.validateAll = function (data, schema, dataPathParts, schemaPathParts, dataPointerPath) {
		var topLevel;
		schema = this.resolveRefs(schema);
		if (!schema) {
			return null;
		} else if (schema instanceof ValidationError) {
			this.errors.push(schema);
			return schema;
		}
	
		var startErrorCount = this.errors.length;
		var frozenIndex, scannedFrozenSchemaIndex = null, scannedSchemasIndex = null;
		if (this.checkRecursive && data && typeof data === 'object') {
			topLevel = !this.scanned.length;
			if (data[this.validatedSchemasKey]) {
				var schemaIndex = data[this.validatedSchemasKey].indexOf(schema);
				if (schemaIndex !== -1) {
					this.errors = this.errors.concat(data[this.validationErrorsKey][schemaIndex]);
					return null;
				}
			}
			if (Object.isFrozen(data)) {
				frozenIndex = this.scannedFrozen.indexOf(data);
				if (frozenIndex !== -1) {
					var frozenSchemaIndex = this.scannedFrozenSchemas[frozenIndex].indexOf(schema);
					if (frozenSchemaIndex !== -1) {
						this.errors = this.errors.concat(this.scannedFrozenValidationErrors[frozenIndex][frozenSchemaIndex]);
						return null;
					}
				}
			}
			this.scanned.push(data);
			if (Object.isFrozen(data)) {
				if (frozenIndex === -1) {
					frozenIndex = this.scannedFrozen.length;
					this.scannedFrozen.push(data);
					this.scannedFrozenSchemas.push([]);
				}
				scannedFrozenSchemaIndex = this.scannedFrozenSchemas[frozenIndex].length;
				this.scannedFrozenSchemas[frozenIndex][scannedFrozenSchemaIndex] = schema;
				this.scannedFrozenValidationErrors[frozenIndex][scannedFrozenSchemaIndex] = [];
			} else {
				if (!data[this.validatedSchemasKey]) {
					try {
						Object.defineProperty(data, this.validatedSchemasKey, {
							value: [],
							configurable: true
						});
						Object.defineProperty(data, this.validationErrorsKey, {
							value: [],
							configurable: true
						});
					} catch (e) {
						//IE 7/8 workaround
						data[this.validatedSchemasKey] = [];
						data[this.validationErrorsKey] = [];
					}
				}
				scannedSchemasIndex = data[this.validatedSchemasKey].length;
				data[this.validatedSchemasKey][scannedSchemasIndex] = schema;
				data[this.validationErrorsKey][scannedSchemasIndex] = [];
			}
		}
	
		var errorCount = this.errors.length;
		var error = this.validateBasic(data, schema, dataPointerPath)
			|| this.validateNumeric(data, schema, dataPointerPath)
			|| this.validateString(data, schema, dataPointerPath)
			|| this.validateArray(data, schema, dataPointerPath)
			|| this.validateObject(data, schema, dataPointerPath)
			|| this.validateCombinations(data, schema, dataPointerPath)
			|| this.validateFormat(data, schema, dataPointerPath)
			|| this.validateDefinedKeywords(data, schema, dataPointerPath)
			|| null;
	
		if (topLevel) {
			while (this.scanned.length) {
				var item = this.scanned.pop();
				delete item[this.validatedSchemasKey];
			}
			this.scannedFrozen = [];
			this.scannedFrozenSchemas = [];
		}
	
		if (error || errorCount !== this.errors.length) {
			while ((dataPathParts && dataPathParts.length) || (schemaPathParts && schemaPathParts.length)) {
				var dataPart = (dataPathParts && dataPathParts.length) ? "" + dataPathParts.pop() : null;
				var schemaPart = (schemaPathParts && schemaPathParts.length) ? "" + schemaPathParts.pop() : null;
				if (error) {
					error = error.prefixWith(dataPart, schemaPart);
				}
				this.prefixErrors(errorCount, dataPart, schemaPart);
			}
		}
		
		if (scannedFrozenSchemaIndex !== null) {
			this.scannedFrozenValidationErrors[frozenIndex][scannedFrozenSchemaIndex] = this.errors.slice(startErrorCount);
		} else if (scannedSchemasIndex !== null) {
			data[this.validationErrorsKey][scannedSchemasIndex] = this.errors.slice(startErrorCount);
		}
	
		return this.handleError(error);
	};
	ValidatorContext.prototype.validateFormat = function (data, schema) {
		if (typeof schema.format !== 'string' || !this.formatValidators[schema.format]) {
			return null;
		}
		var errorMessage = this.formatValidators[schema.format].call(null, data, schema);
		if (typeof errorMessage === 'string' || typeof errorMessage === 'number') {
			return this.createError(ErrorCodes.FORMAT_CUSTOM, {message: errorMessage}).prefixWith(null, "format");
		} else if (errorMessage && typeof errorMessage === 'object') {
			return this.createError(ErrorCodes.FORMAT_CUSTOM, {message: errorMessage.message || "?"}, errorMessage.dataPath || null, errorMessage.schemaPath || "/format");
		}
		return null;
	};
	ValidatorContext.prototype.validateDefinedKeywords = function (data, schema) {
		for (var key in this.definedKeywords) {
			if (typeof schema[key] === 'undefined') {
				continue;
			}
			var validationFunctions = this.definedKeywords[key];
			for (var i = 0; i < validationFunctions.length; i++) {
				var func = validationFunctions[i];
				var result = func(data, schema[key], schema);
				if (typeof result === 'string' || typeof result === 'number') {
					return this.createError(ErrorCodes.KEYWORD_CUSTOM, {key: key, message: result}).prefixWith(null, "format");
				} else if (result && typeof result === 'object') {
					var code = result.code || ErrorCodes.KEYWORD_CUSTOM;
					if (typeof code === 'string') {
						if (!ErrorCodes[code]) {
							throw new Error('Undefined error code (use defineError): ' + code);
						}
						code = ErrorCodes[code];
					}
					var messageParams = (typeof result.message === 'object') ? result.message : {key: key, message: result.message || "?"};
					var schemaPath = result.schemaPath ||( "/" + key.replace(/~/g, '~0').replace(/\//g, '~1'));
					return this.createError(code, messageParams, result.dataPath || null, schemaPath);
				}
			}
		}
		return null;
	};
	
	function recursiveCompare(A, B) {
		if (A === B) {
			return true;
		}
		if (typeof A === "object" && typeof B === "object") {
			if (Array.isArray(A) !== Array.isArray(B)) {
				return false;
			} else if (Array.isArray(A)) {
				if (A.length !== B.length) {
					return false;
				}
				for (var i = 0; i < A.length; i++) {
					if (!recursiveCompare(A[i], B[i])) {
						return false;
					}
				}
			} else {
				var key;
				for (key in A) {
					if (B[key] === undefined && A[key] !== undefined) {
						return false;
					}
				}
				for (key in B) {
					if (A[key] === undefined && B[key] !== undefined) {
						return false;
					}
				}
				for (key in A) {
					if (!recursiveCompare(A[key], B[key])) {
						return false;
					}
				}
			}
			return true;
		}
		return false;
	}
	
	ValidatorContext.prototype.validateBasic = function validateBasic(data, schema, dataPointerPath) {
		var error;
		if (error = this.validateType(data, schema, dataPointerPath)) {
			return error.prefixWith(null, "type");
		}
		if (error = this.validateEnum(data, schema, dataPointerPath)) {
			return error.prefixWith(null, "type");
		}
		return null;
	};
	
	ValidatorContext.prototype.validateType = function validateType(data, schema) {
		if (schema.type === undefined) {
			return null;
		}
		var dataType = typeof data;
		if (data === null) {
			dataType = "null";
		} else if (Array.isArray(data)) {
			dataType = "array";
		}
		var allowedTypes = schema.type;
		if (typeof allowedTypes !== "object") {
			allowedTypes = [allowedTypes];
		}
	
		for (var i = 0; i < allowedTypes.length; i++) {
			var type = allowedTypes[i];
			if (type === dataType || (type === "integer" && dataType === "number" && (data % 1 === 0))) {
				return null;
			}
		}
		return this.createError(ErrorCodes.INVALID_TYPE, {type: dataType, expected: allowedTypes.join("/")});
	};
	
	ValidatorContext.prototype.validateEnum = function validateEnum(data, schema) {
		if (schema["enum"] === undefined) {
			return null;
		}
		for (var i = 0; i < schema["enum"].length; i++) {
			var enumVal = schema["enum"][i];
			if (recursiveCompare(data, enumVal)) {
				return null;
			}
		}
		return this.createError(ErrorCodes.ENUM_MISMATCH, {value: (typeof JSON !== 'undefined') ? JSON.stringify(data) : data});
	};
	
	ValidatorContext.prototype.validateNumeric = function validateNumeric(data, schema, dataPointerPath) {
		return this.validateMultipleOf(data, schema, dataPointerPath)
			|| this.validateMinMax(data, schema, dataPointerPath)
			|| null;
	};
	
	ValidatorContext.prototype.validateMultipleOf = function validateMultipleOf(data, schema) {
		var multipleOf = schema.multipleOf || schema.divisibleBy;
		if (multipleOf === undefined) {
			return null;
		}
		if (typeof data === "number") {
			if (data % multipleOf !== 0) {
				return this.createError(ErrorCodes.NUMBER_MULTIPLE_OF, {value: data, multipleOf: multipleOf});
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateMinMax = function validateMinMax(data, schema) {
		if (typeof data !== "number") {
			return null;
		}
		if (schema.minimum !== undefined) {
			if (data < schema.minimum) {
				return this.createError(ErrorCodes.NUMBER_MINIMUM, {value: data, minimum: schema.minimum}).prefixWith(null, "minimum");
			}
			if (schema.exclusiveMinimum && data === schema.minimum) {
				return this.createError(ErrorCodes.NUMBER_MINIMUM_EXCLUSIVE, {value: data, minimum: schema.minimum}).prefixWith(null, "exclusiveMinimum");
			}
		}
		if (schema.maximum !== undefined) {
			if (data > schema.maximum) {
				return this.createError(ErrorCodes.NUMBER_MAXIMUM, {value: data, maximum: schema.maximum}).prefixWith(null, "maximum");
			}
			if (schema.exclusiveMaximum && data === schema.maximum) {
				return this.createError(ErrorCodes.NUMBER_MAXIMUM_EXCLUSIVE, {value: data, maximum: schema.maximum}).prefixWith(null, "exclusiveMaximum");
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateString = function validateString(data, schema, dataPointerPath) {
		return this.validateStringLength(data, schema, dataPointerPath)
			|| this.validateStringPattern(data, schema, dataPointerPath)
			|| null;
	};
	
	ValidatorContext.prototype.validateStringLength = function validateStringLength(data, schema) {
		if (typeof data !== "string") {
			return null;
		}
		if (schema.minLength !== undefined) {
			if (data.length < schema.minLength) {
				return this.createError(ErrorCodes.STRING_LENGTH_SHORT, {length: data.length, minimum: schema.minLength}).prefixWith(null, "minLength");
			}
		}
		if (schema.maxLength !== undefined) {
			if (data.length > schema.maxLength) {
				return this.createError(ErrorCodes.STRING_LENGTH_LONG, {length: data.length, maximum: schema.maxLength}).prefixWith(null, "maxLength");
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateStringPattern = function validateStringPattern(data, schema) {
		if (typeof data !== "string" || schema.pattern === undefined) {
			return null;
		}
		var regexp = new RegExp(schema.pattern);
		if (!regexp.test(data)) {
			return this.createError(ErrorCodes.STRING_PATTERN, {pattern: schema.pattern}).prefixWith(null, "pattern");
		}
		return null;
	};
	ValidatorContext.prototype.validateArray = function validateArray(data, schema, dataPointerPath) {
		if (!Array.isArray(data)) {
			return null;
		}
		return this.validateArrayLength(data, schema, dataPointerPath)
			|| this.validateArrayUniqueItems(data, schema, dataPointerPath)
			|| this.validateArrayItems(data, schema, dataPointerPath)
			|| null;
	};
	
	ValidatorContext.prototype.validateArrayLength = function validateArrayLength(data, schema) {
		var error;
		if (schema.minItems !== undefined) {
			if (data.length < schema.minItems) {
				error = (this.createError(ErrorCodes.ARRAY_LENGTH_SHORT, {length: data.length, minimum: schema.minItems})).prefixWith(null, "minItems");
				if (this.handleError(error)) {
					return error;
				}
			}
		}
		if (schema.maxItems !== undefined) {
			if (data.length > schema.maxItems) {
				error = (this.createError(ErrorCodes.ARRAY_LENGTH_LONG, {length: data.length, maximum: schema.maxItems})).prefixWith(null, "maxItems");
				if (this.handleError(error)) {
					return error;
				}
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateArrayUniqueItems = function validateArrayUniqueItems(data, schema) {
		if (schema.uniqueItems) {
			for (var i = 0; i < data.length; i++) {
				for (var j = i + 1; j < data.length; j++) {
					if (recursiveCompare(data[i], data[j])) {
						var error = (this.createError(ErrorCodes.ARRAY_UNIQUE, {match1: i, match2: j})).prefixWith(null, "uniqueItems");
						if (this.handleError(error)) {
							return error;
						}
					}
				}
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateArrayItems = function validateArrayItems(data, schema, dataPointerPath) {
		if (schema.items === undefined) {
			return null;
		}
		var error, i;
		if (Array.isArray(schema.items)) {
			for (i = 0; i < data.length; i++) {
				if (i < schema.items.length) {
					if (error = this.validateAll(data[i], schema.items[i], [i], ["items", i], dataPointerPath + "/" + i)) {
						return error;
					}
				} else if (schema.additionalItems !== undefined) {
					if (typeof schema.additionalItems === "boolean") {
						if (!schema.additionalItems) {
							error = (this.createError(ErrorCodes.ARRAY_ADDITIONAL_ITEMS, {})).prefixWith("" + i, "additionalItems");
							if (this.handleError(error)) {
								return error;
							}
						}
					} else if (error = this.validateAll(data[i], schema.additionalItems, [i], ["additionalItems"], dataPointerPath + "/" + i)) {
						return error;
					}
				}
			}
		} else {
			for (i = 0; i < data.length; i++) {
				if (error = this.validateAll(data[i], schema.items, [i], ["items"], dataPointerPath + "/" + i)) {
					return error;
				}
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateObject = function validateObject(data, schema, dataPointerPath) {
		if (typeof data !== "object" || data === null || Array.isArray(data)) {
			return null;
		}
		return this.validateObjectMinMaxProperties(data, schema, dataPointerPath)
			|| this.validateObjectRequiredProperties(data, schema, dataPointerPath)
			|| this.validateObjectProperties(data, schema, dataPointerPath)
			|| this.validateObjectDependencies(data, schema, dataPointerPath)
			|| null;
	};
	
	ValidatorContext.prototype.validateObjectMinMaxProperties = function validateObjectMinMaxProperties(data, schema) {
		var keys = Object.keys(data);
		var error;
		if (schema.minProperties !== undefined) {
			if (keys.length < schema.minProperties) {
				error = this.createError(ErrorCodes.OBJECT_PROPERTIES_MINIMUM, {propertyCount: keys.length, minimum: schema.minProperties}).prefixWith(null, "minProperties");
				if (this.handleError(error)) {
					return error;
				}
			}
		}
		if (schema.maxProperties !== undefined) {
			if (keys.length > schema.maxProperties) {
				error = this.createError(ErrorCodes.OBJECT_PROPERTIES_MAXIMUM, {propertyCount: keys.length, maximum: schema.maxProperties}).prefixWith(null, "maxProperties");
				if (this.handleError(error)) {
					return error;
				}
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateObjectRequiredProperties = function validateObjectRequiredProperties(data, schema) {
		if (schema.required !== undefined) {
			for (var i = 0; i < schema.required.length; i++) {
				var key = schema.required[i];
				if (data[key] === undefined) {
					var error = this.createError(ErrorCodes.OBJECT_REQUIRED, {key: key}).prefixWith(null, "" + i).prefixWith(null, "required");
					if (this.handleError(error)) {
						return error;
					}
				}
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateObjectProperties = function validateObjectProperties(data, schema, dataPointerPath) {
		var error;
		for (var key in data) {
			var keyPointerPath = dataPointerPath + "/" + key.replace(/~/g, '~0').replace(/\//g, '~1');
			var foundMatch = false;
			if (schema.properties !== undefined && schema.properties[key] !== undefined) {
				foundMatch = true;
				if (error = this.validateAll(data[key], schema.properties[key], [key], ["properties", key], keyPointerPath)) {
					return error;
				}
			}
			if (schema.patternProperties !== undefined) {
				for (var patternKey in schema.patternProperties) {
					var regexp = new RegExp(patternKey);
					if (regexp.test(key)) {
						foundMatch = true;
						if (error = this.validateAll(data[key], schema.patternProperties[patternKey], [key], ["patternProperties", patternKey], keyPointerPath)) {
							return error;
						}
					}
				}
			}
			if (!foundMatch) {
				if (schema.additionalProperties !== undefined) {
					if (this.trackUnknownProperties) {
						this.knownPropertyPaths[keyPointerPath] = true;
						delete this.unknownPropertyPaths[keyPointerPath];
					}
					if (typeof schema.additionalProperties === "boolean") {
						if (!schema.additionalProperties) {
							error = this.createError(ErrorCodes.OBJECT_ADDITIONAL_PROPERTIES, {}).prefixWith(key, "additionalProperties");
							if (this.handleError(error)) {
								return error;
							}
						}
					} else {
						if (error = this.validateAll(data[key], schema.additionalProperties, [key], ["additionalProperties"], keyPointerPath)) {
							return error;
						}
					}
				} else if (this.trackUnknownProperties && !this.knownPropertyPaths[keyPointerPath]) {
					this.unknownPropertyPaths[keyPointerPath] = true;
				}
			} else if (this.trackUnknownProperties) {
				this.knownPropertyPaths[keyPointerPath] = true;
				delete this.unknownPropertyPaths[keyPointerPath];
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateObjectDependencies = function validateObjectDependencies(data, schema, dataPointerPath) {
		var error;
		if (schema.dependencies !== undefined) {
			for (var depKey in schema.dependencies) {
				if (data[depKey] !== undefined) {
					var dep = schema.dependencies[depKey];
					if (typeof dep === "string") {
						if (data[dep] === undefined) {
							error = this.createError(ErrorCodes.OBJECT_DEPENDENCY_KEY, {key: depKey, missing: dep}).prefixWith(null, depKey).prefixWith(null, "dependencies");
							if (this.handleError(error)) {
								return error;
							}
						}
					} else if (Array.isArray(dep)) {
						for (var i = 0; i < dep.length; i++) {
							var requiredKey = dep[i];
							if (data[requiredKey] === undefined) {
								error = this.createError(ErrorCodes.OBJECT_DEPENDENCY_KEY, {key: depKey, missing: requiredKey}).prefixWith(null, "" + i).prefixWith(null, depKey).prefixWith(null, "dependencies");
								if (this.handleError(error)) {
									return error;
								}
							}
						}
					} else {
						if (error = this.validateAll(data, dep, [], ["dependencies", depKey], dataPointerPath)) {
							return error;
						}
					}
				}
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateCombinations = function validateCombinations(data, schema, dataPointerPath) {
		return this.validateAllOf(data, schema, dataPointerPath)
			|| this.validateAnyOf(data, schema, dataPointerPath)
			|| this.validateOneOf(data, schema, dataPointerPath)
			|| this.validateNot(data, schema, dataPointerPath)
			|| null;
	};
	
	ValidatorContext.prototype.validateAllOf = function validateAllOf(data, schema, dataPointerPath) {
		if (schema.allOf === undefined) {
			return null;
		}
		var error;
		for (var i = 0; i < schema.allOf.length; i++) {
			var subSchema = schema.allOf[i];
			if (error = this.validateAll(data, subSchema, [], ["allOf", i], dataPointerPath)) {
				return error;
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateAnyOf = function validateAnyOf(data, schema, dataPointerPath) {
		if (schema.anyOf === undefined) {
			return null;
		}
		var errors = [];
		var startErrorCount = this.errors.length;
		var oldUnknownPropertyPaths, oldKnownPropertyPaths;
		if (this.trackUnknownProperties) {
			oldUnknownPropertyPaths = this.unknownPropertyPaths;
			oldKnownPropertyPaths = this.knownPropertyPaths;
		}
		var errorAtEnd = true;
		for (var i = 0; i < schema.anyOf.length; i++) {
			if (this.trackUnknownProperties) {
				this.unknownPropertyPaths = {};
				this.knownPropertyPaths = {};
			}
			var subSchema = schema.anyOf[i];
	
			var errorCount = this.errors.length;
			var error = this.validateAll(data, subSchema, [], ["anyOf", i], dataPointerPath);
	
			if (error === null && errorCount === this.errors.length) {
				this.errors = this.errors.slice(0, startErrorCount);
	
				if (this.trackUnknownProperties) {
					for (var knownKey in this.knownPropertyPaths) {
						oldKnownPropertyPaths[knownKey] = true;
						delete oldUnknownPropertyPaths[knownKey];
					}
					for (var unknownKey in this.unknownPropertyPaths) {
						if (!oldKnownPropertyPaths[unknownKey]) {
							oldUnknownPropertyPaths[unknownKey] = true;
						}
					}
					// We need to continue looping so we catch all the property definitions, but we don't want to return an error
					errorAtEnd = false;
					continue;
				}
	
				return null;
			}
			if (error) {
				errors.push(error.prefixWith(null, "" + i).prefixWith(null, "anyOf"));
			}
		}
		if (this.trackUnknownProperties) {
			this.unknownPropertyPaths = oldUnknownPropertyPaths;
			this.knownPropertyPaths = oldKnownPropertyPaths;
		}
		if (errorAtEnd) {
			errors = errors.concat(this.errors.slice(startErrorCount));
			this.errors = this.errors.slice(0, startErrorCount);
			return this.createError(ErrorCodes.ANY_OF_MISSING, {}, "", "/anyOf", errors);
		}
	};
	
	ValidatorContext.prototype.validateOneOf = function validateOneOf(data, schema, dataPointerPath) {
		if (schema.oneOf === undefined) {
			return null;
		}
		var validIndex = null;
		var errors = [];
		var startErrorCount = this.errors.length;
		var oldUnknownPropertyPaths, oldKnownPropertyPaths;
		if (this.trackUnknownProperties) {
			oldUnknownPropertyPaths = this.unknownPropertyPaths;
			oldKnownPropertyPaths = this.knownPropertyPaths;
		}
		for (var i = 0; i < schema.oneOf.length; i++) {
			if (this.trackUnknownProperties) {
				this.unknownPropertyPaths = {};
				this.knownPropertyPaths = {};
			}
			var subSchema = schema.oneOf[i];
	
			var errorCount = this.errors.length;
			var error = this.validateAll(data, subSchema, [], ["oneOf", i], dataPointerPath);
	
			if (error === null && errorCount === this.errors.length) {
				if (validIndex === null) {
					validIndex = i;
				} else {
					this.errors = this.errors.slice(0, startErrorCount);
					return this.createError(ErrorCodes.ONE_OF_MULTIPLE, {index1: validIndex, index2: i}, "", "/oneOf");
				}
				if (this.trackUnknownProperties) {
					for (var knownKey in this.knownPropertyPaths) {
						oldKnownPropertyPaths[knownKey] = true;
						delete oldUnknownPropertyPaths[knownKey];
					}
					for (var unknownKey in this.unknownPropertyPaths) {
						if (!oldKnownPropertyPaths[unknownKey]) {
							oldUnknownPropertyPaths[unknownKey] = true;
						}
					}
				}
			} else if (error) {
				errors.push(error.prefixWith(null, "" + i).prefixWith(null, "oneOf"));
			}
		}
		if (this.trackUnknownProperties) {
			this.unknownPropertyPaths = oldUnknownPropertyPaths;
			this.knownPropertyPaths = oldKnownPropertyPaths;
		}
		if (validIndex === null) {
			errors = errors.concat(this.errors.slice(startErrorCount));
			this.errors = this.errors.slice(0, startErrorCount);
			return this.createError(ErrorCodes.ONE_OF_MISSING, {}, "", "/oneOf", errors);
		} else {
			this.errors = this.errors.slice(0, startErrorCount);
		}
		return null;
	};
	
	ValidatorContext.prototype.validateNot = function validateNot(data, schema, dataPointerPath) {
		if (schema.not === undefined) {
			return null;
		}
		var oldErrorCount = this.errors.length;
		var oldUnknownPropertyPaths, oldKnownPropertyPaths;
		if (this.trackUnknownProperties) {
			oldUnknownPropertyPaths = this.unknownPropertyPaths;
			oldKnownPropertyPaths = this.knownPropertyPaths;
			this.unknownPropertyPaths = {};
			this.knownPropertyPaths = {};
		}
		var error = this.validateAll(data, schema.not, null, null, dataPointerPath);
		var notErrors = this.errors.slice(oldErrorCount);
		this.errors = this.errors.slice(0, oldErrorCount);
		if (this.trackUnknownProperties) {
			this.unknownPropertyPaths = oldUnknownPropertyPaths;
			this.knownPropertyPaths = oldKnownPropertyPaths;
		}
		if (error === null && notErrors.length === 0) {
			return this.createError(ErrorCodes.NOT_PASSED, {}, "", "/not");
		}
		return null;
	};
	
	// parseURI() and resolveUrl() are from https://gist.github.com/1088850
	//   -  released as public domain by author ("Yaffle") - see comments on gist
	
	function parseURI(url) {
		var m = String(url).replace(/^\s+|\s+$/g, '').match(/^([^:\/?#]+:)?(\/\/(?:[^:@]*(?::[^:@]*)?@)?(([^:\/?#]*)(?::(\d*))?))?([^?#]*)(\?[^#]*)?(#[\s\S]*)?/);
		// authority = '//' + user + ':' + pass '@' + hostname + ':' port
		return (m ? {
			href     : m[0] || '',
			protocol : m[1] || '',
			authority: m[2] || '',
			host     : m[3] || '',
			hostname : m[4] || '',
			port     : m[5] || '',
			pathname : m[6] || '',
			search   : m[7] || '',
			hash     : m[8] || ''
		} : null);
	}
	
	function resolveUrl(base, href) {// RFC 3986
	
		function removeDotSegments(input) {
			var output = [];
			input.replace(/^(\.\.?(\/|$))+/, '')
				.replace(/\/(\.(\/|$))+/g, '/')
				.replace(/\/\.\.$/, '/../')
				.replace(/\/?[^\/]*/g, function (p) {
					if (p === '/..') {
						output.pop();
					} else {
						output.push(p);
					}
			});
			return output.join('').replace(/^\//, input.charAt(0) === '/' ? '/' : '');
		}
	
		href = parseURI(href || '');
		base = parseURI(base || '');
	
		return !href || !base ? null : (href.protocol || base.protocol) +
			(href.protocol || href.authority ? href.authority : base.authority) +
			removeDotSegments(href.protocol || href.authority || href.pathname.charAt(0) === '/' ? href.pathname : (href.pathname ? ((base.authority && !base.pathname ? '/' : '') + base.pathname.slice(0, base.pathname.lastIndexOf('/') + 1) + href.pathname) : base.pathname)) +
			(href.protocol || href.authority || href.pathname ? href.search : (href.search || base.search)) +
			href.hash;
	}
	
	function getDocumentUri(uri) {
		return uri.split('#')[0];
	}
	function normSchema(schema, baseUri) {
		if (schema && typeof schema === "object") {
			if (baseUri === undefined) {
				baseUri = schema.id;
			} else if (typeof schema.id === "string") {
				baseUri = resolveUrl(baseUri, schema.id);
				schema.id = baseUri;
			}
			if (Array.isArray(schema)) {
				for (var i = 0; i < schema.length; i++) {
					normSchema(schema[i], baseUri);
				}
			} else {
				if (typeof schema['$ref'] === "string") {
					schema['$ref'] = resolveUrl(baseUri, schema['$ref']);
				}
				for (var key in schema) {
					if (key !== "enum") {
						normSchema(schema[key], baseUri);
					}
				}
			}
		}
	}
	
	var ErrorCodes = {
		INVALID_TYPE: 0,
		ENUM_MISMATCH: 1,
		ANY_OF_MISSING: 10,
		ONE_OF_MISSING: 11,
		ONE_OF_MULTIPLE: 12,
		NOT_PASSED: 13,
		// Numeric errors
		NUMBER_MULTIPLE_OF: 100,
		NUMBER_MINIMUM: 101,
		NUMBER_MINIMUM_EXCLUSIVE: 102,
		NUMBER_MAXIMUM: 103,
		NUMBER_MAXIMUM_EXCLUSIVE: 104,
		// String errors
		STRING_LENGTH_SHORT: 200,
		STRING_LENGTH_LONG: 201,
		STRING_PATTERN: 202,
		// Object errors
		OBJECT_PROPERTIES_MINIMUM: 300,
		OBJECT_PROPERTIES_MAXIMUM: 301,
		OBJECT_REQUIRED: 302,
		OBJECT_ADDITIONAL_PROPERTIES: 303,
		OBJECT_DEPENDENCY_KEY: 304,
		// Array errors
		ARRAY_LENGTH_SHORT: 400,
		ARRAY_LENGTH_LONG: 401,
		ARRAY_UNIQUE: 402,
		ARRAY_ADDITIONAL_ITEMS: 403,
		// Custom/user-defined errors
		FORMAT_CUSTOM: 500,
		KEYWORD_CUSTOM: 501,
		// Schema structure
		CIRCULAR_REFERENCE: 600,
		// Non-standard validation options
		UNKNOWN_PROPERTY: 1000
	};
	var ErrorCodeLookup = {};
	for (var key in ErrorCodes) {
		ErrorCodeLookup[ErrorCodes[key]] = key;
	}
	var ErrorMessagesDefault = {
		INVALID_TYPE: "invalid type: {type} (expected {expected})",
		ENUM_MISMATCH: "No enum match for: {value}",
		ANY_OF_MISSING: "Data does not match any schemas from \"anyOf\"",
		ONE_OF_MISSING: "Data does not match any schemas from \"oneOf\"",
		ONE_OF_MULTIPLE: "Data is valid against more than one schema from \"oneOf\": indices {index1} and {index2}",
		NOT_PASSED: "Data matches schema from \"not\"",
		// Numeric errors
		NUMBER_MULTIPLE_OF: "Value {value} is not a multiple of {multipleOf}",
		NUMBER_MINIMUM: "Value {value} is less than minimum {minimum}",
		NUMBER_MINIMUM_EXCLUSIVE: "Value {value} is equal to exclusive minimum {minimum}",
		NUMBER_MAXIMUM: "Value {value} is greater than maximum {maximum}",
		NUMBER_MAXIMUM_EXCLUSIVE: "Value {value} is equal to exclusive maximum {maximum}",
		// String errors
		STRING_LENGTH_SHORT: "String is too short ({length} chars), minimum {minimum}",
		STRING_LENGTH_LONG: "String is too long ({length} chars), maximum {maximum}",
		STRING_PATTERN: "String does not match pattern: {pattern}",
		// Object errors
		OBJECT_PROPERTIES_MINIMUM: "Too few properties defined ({propertyCount}), minimum {minimum}",
		OBJECT_PROPERTIES_MAXIMUM: "Too many properties defined ({propertyCount}), maximum {maximum}",
		OBJECT_REQUIRED: "Missing required property: {key}",
		OBJECT_ADDITIONAL_PROPERTIES: "Additional properties not allowed",
		OBJECT_DEPENDENCY_KEY: "Dependency failed - key must exist: {missing} (due to key: {key})",
		// Array errors
		ARRAY_LENGTH_SHORT: "Array is too short ({length}), minimum {minimum}",
		ARRAY_LENGTH_LONG: "Array is too long ({length}), maximum {maximum}",
		ARRAY_UNIQUE: "Array items are not unique (indices {match1} and {match2})",
		ARRAY_ADDITIONAL_ITEMS: "Additional items not allowed",
		// Format errors
		FORMAT_CUSTOM: "Format validation failed ({message})",
		KEYWORD_CUSTOM: "Keyword failed: {key} ({message})",
		// Schema structure
		CIRCULAR_REFERENCE: "Circular $refs: {urls}",
		// Non-standard validation options
		UNKNOWN_PROPERTY: "Unknown property (not in schema)"
	};
	
	function ValidationError(code, message, dataPath, schemaPath, subErrors) {
		Error.call(this);
		if (code === undefined) {
			throw new Error ("No code supplied for error: "+ message);
		}
		this.message = message;
		this.code = code;
		this.dataPath = dataPath || "";
		this.schemaPath = schemaPath || "";
		this.subErrors = subErrors || null;
	
		var err = new Error(this.message);
		this.stack = err.stack || err.stacktrace;
		if (!this.stack) {
			try {
				throw err;
			}
			catch(err) {
				this.stack = err.stack || err.stacktrace;
			}
		}
	}
	ValidationError.prototype = Object.create(Error.prototype);
	ValidationError.prototype.constructor = ValidationError;
	ValidationError.prototype.name = 'ValidationError';
	
	ValidationError.prototype.prefixWith = function (dataPrefix, schemaPrefix) {
		if (dataPrefix !== null) {
			dataPrefix = dataPrefix.replace(/~/g, "~0").replace(/\//g, "~1");
			this.dataPath = "/" + dataPrefix + this.dataPath;
		}
		if (schemaPrefix !== null) {
			schemaPrefix = schemaPrefix.replace(/~/g, "~0").replace(/\//g, "~1");
			this.schemaPath = "/" + schemaPrefix + this.schemaPath;
		}
		if (this.subErrors !== null) {
			for (var i = 0; i < this.subErrors.length; i++) {
				this.subErrors[i].prefixWith(dataPrefix, schemaPrefix);
			}
		}
		return this;
	};
	
	function isTrustedUrl(baseUrl, testUrl) {
		if(testUrl.substring(0, baseUrl.length) === baseUrl){
			var remainder = testUrl.substring(baseUrl.length);
			if ((testUrl.length > 0 && testUrl.charAt(baseUrl.length - 1) === "/")
				|| remainder.charAt(0) === "#"
				|| remainder.charAt(0) === "?") {
				return true;
			}
		}
		return false;
	}
	
	var languages = {};
	function createApi(language) {
		var globalContext = new ValidatorContext();
		var currentLanguage = language || 'en';
		var api = {
			addFormat: function () {
				globalContext.addFormat.apply(globalContext, arguments);
			},
			language: function (code) {
				if (!code) {
					return currentLanguage;
				}
				if (!languages[code]) {
					code = code.split('-')[0]; // fall back to base language
				}
				if (languages[code]) {
					currentLanguage = code;
					return code; // so you can tell if fall-back has happened
				}
				return false;
			},
			addLanguage: function (code, messageMap) {
				var key;
				for (key in ErrorCodes) {
					if (messageMap[key] && !messageMap[ErrorCodes[key]]) {
						messageMap[ErrorCodes[key]] = messageMap[key];
					}
				}
				var rootCode = code.split('-')[0];
				if (!languages[rootCode]) { // use for base language if not yet defined
					languages[code] = messageMap;
					languages[rootCode] = messageMap;
				} else {
					languages[code] = Object.create(languages[rootCode]);
					for (key in messageMap) {
						if (typeof languages[rootCode][key] === 'undefined') {
							languages[rootCode][key] = messageMap[key];
						}
						languages[code][key] = messageMap[key];
					}
				}
				return this;
			},
			freshApi: function (language) {
				var result = createApi();
				if (language) {
					result.language(language);
				}
				return result;
			},
			validate: function (data, schema, checkRecursive, banUnknownProperties) {
				var context = new ValidatorContext(globalContext, false, languages[currentLanguage], checkRecursive, banUnknownProperties);
				if (typeof schema === "string") {
					schema = {"$ref": schema};
				}
				context.addSchema("", schema);
				var error = context.validateAll(data, schema, null, null, "");
				if (!error && banUnknownProperties) {
					error = context.banUnknownProperties();
				}
				this.error = error;
				this.missing = context.missing;
				this.valid = (error === null);
				return this.valid;
			},
			validateResult: function () {
				var result = {};
				this.validate.apply(result, arguments);
				return result;
			},
			validateMultiple: function (data, schema, checkRecursive, banUnknownProperties) {
				var context = new ValidatorContext(globalContext, true, languages[currentLanguage], checkRecursive, banUnknownProperties);
				if (typeof schema === "string") {
					schema = {"$ref": schema};
				}
				context.addSchema("", schema);
				context.validateAll(data, schema, null, null, "");
				if (banUnknownProperties) {
					context.banUnknownProperties();
				}
				var result = {};
				result.errors = context.errors;
				result.missing = context.missing;
				result.valid = (result.errors.length === 0);
				return result;
			},
			addSchema: function () {
				return globalContext.addSchema.apply(globalContext, arguments);
			},
			getSchema: function () {
				return globalContext.getSchema.apply(globalContext, arguments);
			},
			getSchemaMap: function () {
				return globalContext.getSchemaMap.apply(globalContext, arguments);
			},
			getSchemaUris: function () {
				return globalContext.getSchemaUris.apply(globalContext, arguments);
			},
			getMissingUris: function () {
				return globalContext.getMissingUris.apply(globalContext, arguments);
			},
			dropSchemas: function () {
				globalContext.dropSchemas.apply(globalContext, arguments);
			},
			defineKeyword: function () {
				globalContext.defineKeyword.apply(globalContext, arguments);
			},
			defineError: function (codeName, codeNumber, defaultMessage) {
				if (typeof codeName !== 'string' || !/^[A-Z]+(_[A-Z]+)*$/.test(codeName)) {
					throw new Error('Code name must be a string in UPPER_CASE_WITH_UNDERSCORES');
				}
				if (typeof codeNumber !== 'number' || codeNumber%1 !== 0 || codeNumber < 10000) {
					throw new Error('Code number must be an integer > 10000');
				}
				if (typeof ErrorCodes[codeName] !== 'undefined') {
					throw new Error('Error already defined: ' + codeName + ' as ' + ErrorCodes[codeName]);
				}
				if (typeof ErrorCodeLookup[codeNumber] !== 'undefined') {
					throw new Error('Error code already used: ' + ErrorCodeLookup[codeNumber] + ' as ' + codeNumber);
				}
				ErrorCodes[codeName] = codeNumber;
				ErrorCodeLookup[codeNumber] = codeName;
				ErrorMessagesDefault[codeName] = ErrorMessagesDefault[codeNumber] = defaultMessage;
				for (var langCode in languages) {
					var language = languages[langCode];
					if (language[codeName]) {
						language[codeNumber] = language[codeNumber] || language[codeName];
					}
				}
			},
			reset: function () {
				globalContext.reset();
				this.error = null;
				this.missing = [];
				this.valid = true;
			},
			missing: [],
			error: null,
			valid: true,
			normSchema: normSchema,
			resolveUrl: resolveUrl,
			getDocumentUri: getDocumentUri,
			errorCodes: ErrorCodes
		};
		return api;
	}
	
	var tv4 = createApi();
	tv4.addLanguage('en-gb', ErrorMessagesDefault);
	
	//legacy property
	tv4.tv4 = tv4;
	
	return tv4; // used by _header.js to globalise.
	
	}));

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14),__webpack_require__(538),__webpack_require__(540)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=t(require("angular"),require("objectpath"),require("tv4")):e.schemaForm=t(e.angular,e.objectpath,e.tv4)}(this,function(e,t,r){var n=[];try{e.module("ngSanitize"),n.push("ngSanitize")}catch(i){}try{e.module("ui.sortable"),n.push("ui.sortable")}catch(i){}try{e.module("angularSpectrumColorpicker"),n.push("angularSpectrumColorpicker")}catch(i){}var o=e.module("schemaForm",n);return e.module("schemaForm").provider("sfPath",[function(){var r=window.ObjectPath||t,n={parse:r.parse};1===e.version.major&&e.version.minor<3?n.stringify=function(e){return Array.isArray(e)?e.join("."):e.toString()}:n.stringify=r.stringify,n.normalize=function(e,t){return n.stringify(Array.isArray(e)?e:n.parse(e),t)},this.parse=n.parse,this.stringify=n.stringify,this.normalize=n.normalize,this.$get=function(){return n}}]),e.module("schemaForm").provider("sfBuilder",["sfPathProvider",function(t){var r=/[A-Z]/g,n=function(e,t){return t=t||"_",e.replace(r,function(e,r){return(r?t:"")+e.toLowerCase()})},i=0,o={sfField:function(e){e.fieldFrag.firstChild.setAttribute("sf-field",i),e.lookup["f"+i]=e.form,i++},ngModel:function(e){if(e.form.key){var r=e.form.key;e.state.keyRedaction&&(r=r.slice(e.state.keyRedaction));var n;if(e.state.modelValue)n=e.state.modelValue;else{var i=t.stringify(r).replace(/"/g,"&quot;");n=e.state.modelName||"model",i&&(n+=("["!==i[0]?".":"")+i)}for(var o=e.fieldFrag.querySelectorAll("[sf-field-model]"),a=0;a<o.length;a++){var l=o[a],s=l.getAttribute("sf-field-model");if(s&&""!==s)if("replaceAll"===s)for(var u=l.attributes,c=0;c<u.length;c++)u[c].value&&-1!==u[c].value.indexOf("$$value")&&(u[c].value=u[c].value.replace(/\$\$value\$\$/g,n));else{var f=l.getAttribute(s);f&&f.indexOf("$$value$$")?l.setAttribute(s,f.replace(/\$\$value\$\$/g,n)):l.setAttribute(s,n)}else l.setAttribute("ng-model",n)}}},simpleTransclusion:function(e){var t=e.build(e.form.items,e.path+".items",e.state);e.fieldFrag.firstChild.appendChild(t)},ngModelOptions:function(e){e.form.ngModelOptions&&Object.keys(e.form.ngModelOptions).length>0&&e.fieldFrag.firstChild.setAttribute("ng-model-options",JSON.stringify(e.form.ngModelOptions))},transclusion:function(e){var t=e.fieldFrag.querySelectorAll("[sf-field-transclude]");if(t.length)for(var r=0;r<t.length;r++){var n=t[r],i=n.getAttribute("sf-field-transclude")||"items",o=e.form[i];if(o){var a=e.build(o,e.path+"."+i,e.state);n.appendChild(a)}}},condition:function(e){if(e.form.condition){var r="evalExpr("+e.path+'.condition, { model: model, "arrayIndex": $index})';if(e.form.key){var n=t.stringify(e.form.key);r="evalExpr("+e.path+'.condition,{ model: model, "arrayIndex": $index, "modelValue": model'+("["===n[0]?"":".")+n+"})"}for(var i=e.fieldFrag.children||e.fieldFrag.childNodes,o=0;o<i.length;o++){var a=i[o],l=a.getAttribute("ng-if");a.setAttribute("ng-if",l?"("+l+") || ("+r+")":r)}}},array:function(r){var n=r.fieldFrag.querySelector("[schema-form-array-items]");if(n){if(state=e.copy(r.state),state.keyRedaction=state.keyRedaction||0,state.keyRedaction+=r.form.key.length+1,r.form.schema&&r.form.schema.items&&r.form.schema.items.type&&-1===r.form.schema.items.type.indexOf("object")&&-1===r.form.schema.items.type.indexOf("array")){t.stringify(r.form.key).replace(/"/g,"&quot;")+"[$index]";state.modelValue="modelArray[$index]"}else state.modelName="item";state.arrayCompatFlag=!0;var i=r.build(r.form.items,r.path+".items",state);n.appendChild(i)}}};this.builders=o;var a=[o.sfField,o.ngModel,o.ngModelOptions,o.condition];this.stdBuilders=a,this.$get=["$templateCache","schemaFormDecorators","sfPath",function(e,t,r){var i=function(e,t){if(e.key){var n=t[r.stringify(e.key)];if(n){for(;n.firstChild;)n.removeChild(n.firstChild);return n}}},l=function(e,t,r,o,a,s,u){s=s||{},u=u||Object.create(null),a=a||"schemaForm.form";var c=document.createDocumentFragment();return e.reduce(function(e,c,f){if(!c.type)return e;var d=t[c.type]||t["default"];if(d.replace){var m;s.arrayCompatFlag=!1;var p=document.createElement("div"),h=r(c,d)||r(c,t["default"]);for(p.innerHTML=h,m=document.createDocumentFragment();p.childNodes.length>0;)m.appendChild(p.childNodes[0]);var v={fieldFrag:m,form:c,lookup:u,state:s,path:a+"["+f+"]",build:function(e,n,i){return l(e,t,r,o,n,i,u)}},y=c.builder||d.builder;"function"==typeof y?y(v):y.forEach(function(e){e(v)}),(i(c,o)||e).appendChild(m)}else{var g=document.createElement(n(t.__name,"-"));s.arrayCompatFlag?g.setAttribute("form","copyWithIndex($index)"):g.setAttribute("form",a+"["+f+"]"),(i(c,o)||e).appendChild(g)}return e},c),c};return{build:function(t,r,n,i){return l(t,r,function(t,r){return"template"===t.type?t.template:e.get(r.template)},n,void 0,void 0,i)},builder:o,stdBuilders:a,internalBuild:l}}]}]),e.module("schemaForm").provider("schemaFormDecorators",["$compileProvider","sfPathProvider",function(t,r){var n="",i={},o=function(e,t){"sfDecorator"===e&&(e=n);var r=i[e];return r[t.type]?r[t.type].template:r["default"].template},a=function(n){t.directive(n,["$parse","$compile","$http","$templateCache","$interpolate","$q","sfErrorMessage","sfPath","sfSelect",function(t,i,a,l,s,u,c,f,d){return{restrict:"AE",replace:!1,transclude:!1,scope:!0,require:"?^sfSchema",link:function(t,m,p,h){t.$on("schemaFormPropagateNgModelController",function(e,r){e.stopPropagation(),e.preventDefault(),t.ngModel=r}),t.showTitle=function(){return t.form&&t.form.notitle!==!0&&t.form.title},t.listToCheckboxValues=function(t){var r={};return e.forEach(t,function(e){r[e]=!0}),r},t.checkboxValuesToList=function(t){var r=[];return e.forEach(t,function(e,t){e&&r.push(t)}),r},t.buttonClick=function(r,n){e.isFunction(n.onClick)?n.onClick(r,n):e.isString(n.onClick)&&(h?h.evalInParentScope(n.onClick,{$event:r,form:n}):t.$eval(n.onClick,{$event:r,form:n}))},t.evalExpr=function(e,r){return h?h.evalInParentScope(e,r):t.$eval(e,r)},t.evalInScope=function(e,r){return e?t.$eval(e,r):void 0},t.interp=function(e,t){return e&&s(e)(t)},t.hasSuccess=function(){return t.ngModel?t.ngModel.$valid&&(!t.ngModel.$pristine||!t.ngModel.$isEmpty(t.ngModel.$modelValue)):!1},t.hasError=function(){return t.ngModel?t.ngModel.$invalid&&!t.ngModel.$pristine:!1},t.errorMessage=function(e){return c.interpolate(e&&e.code+""||"default",t.ngModel&&t.ngModel.$modelValue||"",t.ngModel&&t.ngModel.$viewValue||"",t.form,t.options&&t.options.validationMessage)};var v=t.$watch(p.form,function(s){if(s){s.ngModelOptions=s.ngModelOptions||{},t.form=s;var c;if("template"===s.type&&s.template)c=u.when(s.template);else{var p="template"===s.type?s.templateUrl:o(n,s);c=a.get(p,{cache:l}).then(function(e){return e.data})}c.then(function(n){if(s.key){var o=s.key?r.stringify(s.key).replace(/"/g,"&quot;"):"";n=n.replace(/\$\$value\$\$/g,"model"+("["!==o[0]?".":"")+o)}if(m.html(n),s.condition){var a='evalExpr(form.condition,{ model: model, "arrayIndex": arrayIndex})';s.key&&(a='evalExpr(form.condition,{ model: model, "arrayIndex": arrayIndex, "modelValue": model'+f.stringify(s.key)+"})"),e.forEach(m.children(),function(e){var t=e.getAttribute("ng-if");e.setAttribute("ng-if",t?"("+t+") || ("+a+")":a)})}i(m.contents())(t)}),s.key&&(t.$on("schemaForm.error."+s.key.join("."),function(e,r,n,i){(n===!0||n===!1)&&(i=n,n=void 0),t.ngModel&&r&&(t.ngModel.$setDirty?t.ngModel.$setDirty():(t.ngModel.$dirty=!0,t.ngModel.$pristine=!1),n&&(s.validationMessage||(s.validationMessage={}),s.validationMessage[r]=n),t.ngModel.$setValidity(r,i===!0),i===!0&&(t.ngModel.$validate(),t.$broadcast("schemaFormValidate")))}),t.$on("$destroy",function(){if(!t.externalDestructionInProgress){var e=s.destroyStrategy||t.options&&t.options.destroyStrategy||"remove";if(s.key&&"retain"!==e){var r=t.model;if(s.key.length>1&&(r=d(s.key.slice(0,s.key.length-1),r)),void 0===r)return;var n=s.schema&&s.schema.type||"";"empty"===e&&-1!==n.indexOf("string")?r[s.key.slice(-1)]="":"empty"===e&&-1!==n.indexOf("object")?r[s.key.slice(-1)]={}:"empty"===e&&-1!==n.indexOf("array")?r[s.key.slice(-1)]=[]:"null"===e?r[s.key.slice(-1)]=null:delete r[s.key.slice(-1)]}}})),v()}})}}}])},l=function(r,n,i){i=e.isDefined(i)?i:!1,t.directive("sf"+e.uppercase(r[0])+r.substr(1),function(){return{restrict:"EAC",scope:!0,replace:!0,transclude:i,template:'<sf-decorator form="form"></sf-decorator>',link:function(t,n,i){var o={items:"c",titleMap:"c",schema:"c"},a={type:r},l=!0;e.forEach(i,function(r,n){if("$"!==n[0]&&0!==n.indexOf("ng")&&"sfField"!==n){var s=function(r){e.isDefined(r)&&r!==a[n]&&(a[n]=r,l&&a.type&&(a.key||e.isUndefined(i.key))&&(t.form=a,l=!1))};"model"===n?t.$watch(r,function(e){e&&t.model!==e&&(t.model=e)}):"c"===o[n]?t.$watchCollection(r,s):i.$observe(n,s)}})}}})};this.createDecorator=function(t,r){i[t]={__name:t},e.forEach(r,function(e,r){i[t][r]={template:e,replace:!1,builder:[]}}),i[n]||(n=t),a(t)},this.defineDecorator=function(t,r){i[t]={__name:t},e.forEach(r,function(r,n){r.builder=r.builder||[],r.replace=e.isDefined(r.replace)?r.replace:!0,i[t][n]=r}),i[n]||(n=t),a(t)},this.createDirective=l,this.createDirectives=function(t){e.forEach(t,function(e,t){l(t,e)})},this.decorator=function(e){return e=e||n,i[e]},this.addMapping=function(e,t,r,n,o){i[e]&&(i[e][t]={template:r,builder:n,replace:!!o})},this.defineAddOn=function(e,t,r,n){i[e]&&(i[e][t]={template:r,builder:n,replace:!0})},this.$get=function(){return{decorator:function(e){return i[e]||i[n]},defaultDecorator:n}},a("sfDecorator")}]),e.module("schemaForm").provider("sfErrorMessage",function(){var t={"default":"Field does not validate",0:"Invalid type, expected {{schema.type}}",1:"No enum match for: {{viewValue}}",10:'Data does not match any schemas from "anyOf"',11:'Data does not match any schemas from "oneOf"',12:'Data is valid against more than one schema from "oneOf"',13:'Data matches schema from "not"',100:"Value is not a multiple of {{schema.multipleOf}}",101:"{{viewValue}} is less than the allowed minimum of {{schema.minimum}}",102:"{{viewValue}} is equal to the exclusive minimum {{schema.minimum}}",103:"{{viewValue}} is greater than the allowed maximum of {{schema.maximum}}",104:"{{viewValue}} is equal to the exclusive maximum {{schema.maximum}}",105:"Value is not a valid number",200:"String is too short ({{viewValue.length}} chars), minimum {{schema.minLength}}",201:"String is too long ({{viewValue.length}} chars), maximum {{schema.maxLength}}",202:"String does not match pattern: {{schema.pattern}}",300:"Too few properties defined, minimum {{schema.minProperties}}",301:"Too many properties defined, maximum {{schema.maxProperties}}",302:"Required",303:"Additional properties not allowed",304:"Dependency failed - key must exist",400:"Array is too short ({{value.length}}), minimum {{schema.minItems}}",401:"Array is too long ({{value.length}}), maximum {{schema.maxItems}}",402:"Array items are not unique",403:"Additional items not allowed",500:"Format validation failed",501:'Keyword failed: "{{title}}"',600:"Circular $refs",1e3:"Unknown property (not in schema)"};t.number=t[105],t.required=t[302],t.min=t[101],t.max=t[103],t.maxlength=t[201],t.minlength=t[200],t.pattern=t[202],this.setDefaultMessages=function(e){t=e},this.getDefaultMessages=function(){return t},this.setDefaultMessage=function(e,r){t[e]=r},this.$get=["$interpolate",function(r){var n={};return n.defaultMessages=t,n.interpolate=function(n,i,o,a,l){l=l||{};var s=a.validationMessage||{};0===n.indexOf("tv4-")&&(n=n.substring(4));var u=s["default"]||l["default"]||"";[s,l,t].some(function(t){return e.isString(t)||e.isFunction(t)?(u=t,!0):t&&t[n]?(u=t[n],!0):void 0});var c={error:n,value:i,viewValue:o,form:a,schema:a.schema,title:a.title||a.schema&&a.schema.title};return e.isFunction(u)?u(c):r(u)(c)},n}]}),e.module("schemaForm").provider("schemaForm",["sfPathProvider",function(t){var r=function(e){if(Array.isArray(e)&&2==e.length){if("null"===e[0])return e[1];if("null"===e[1])return e[0]}return e},n=function(e){var t=[];return e.forEach(function(e){t.push({name:e,value:e})}),t},i=function(t,r){if(!e.isArray(t)){var n=[];return r?e.forEach(r,function(e,r){n.push({name:t[e],value:e})}):e.forEach(t,function(e,t){n.push({name:e,value:t})}),n}return t},o=function(t,n,i){var o=h[r(n.type)];if(o)for(var a,l=0;l<o.length;l++)if(a=o[l](t,n,i))return a.schema["x-schema-form"]&&e.isObject(a.schema["x-schema-form"])&&(a=e.extend(a,a.schema["x-schema-form"])),a},a=function(t,r,n){n=n||{};var o=n.global&&n.global.formDefaults?e.copy(n.global.formDefaults):{};return n.global&&n.global.supressPropertyTitles===!0?o.title=r.title:o.title=r.title||t,r.description&&(o.description=r.description),(n.required===!0||r.required===!0)&&(o.required=!0),r.maxLength&&(o.maxlength=r.maxLength),r.minLength&&(o.minlength=r.minLength),(r.readOnly||r.readonly)&&(o.readonly=!0),r.minimum&&(o.minimum=r.minimum+(r.exclusiveMinimum?1:0)),r.maximum&&(o.maximum=r.maximum-(r.exclusiveMaximum?1:0)),r.validationMessage&&(o.validationMessage=r.validationMessage),r.enumNames&&(o.titleMap=i(r.enumNames,r["enum"])),o.schema=r,o.ngModelOptions=o.ngModelOptions||{},o},l=function(e,n,i){if("string"===r(n.type)&&!n["enum"]){var o=a(e,n,i);return o.key=i.path,o.type="text",i.lookup[t.stringify(i.path)]=o,o}},s=function(e,n,i){if("number"===r(n.type)){var o=a(e,n,i);return o.key=i.path,o.type="number",i.lookup[t.stringify(i.path)]=o,o}},u=function(e,n,i){if("integer"===r(n.type)){var o=a(e,n,i);return o.key=i.path,o.type="number",i.lookup[t.stringify(i.path)]=o,o}},c=function(e,n,i){if("boolean"===r(n.type)){var o=a(e,n,i);return o.key=i.path,o.type="checkbox",i.lookup[t.stringify(i.path)]=o,o}},f=function(e,i,o){if("string"===r(i.type)&&i["enum"]){var l=a(e,i,o);return l.key=o.path,l.type="select",l.titleMap||(l.titleMap=n(i["enum"])),o.lookup[t.stringify(o.path)]=l,l}},d=function(e,i,o){if("array"===r(i.type)&&i.items&&i.items["enum"]){var l=a(e,i,o);return l.key=o.path,l.type="checkboxes",l.titleMap||(l.titleMap=n(i.items["enum"])),o.lookup[t.stringify(o.path)]=l,l}},m=function(n,i,l){if("object"===r(i.type)){var s=a(n,i,l);return s.type="fieldset",s.items=[],l.lookup[t.stringify(l.path)]=s,e.forEach(i.properties,function(e,r){var n=l.path.slice();if(n.push(r),l.ignore[t.stringify(n)]!==!0){var a=i.required&&-1!==i.required.indexOf(r),u=o(r,e,{path:n,required:a||!1,lookup:l.lookup,ignore:l.ignore,global:l.global});u&&s.items.push(u)}}),s}},p=function(e,n,i){if("array"===r(n.type)){var l=a(e,n,i);l.type="array",l.key=i.path,i.lookup[t.stringify(i.path)]=l;var s=n.required&&-1!==n.required.indexOf(i.path[i.path.length-1]),u=i.path.slice();return u.push(""),l.items=[o(e,n.items,{path:u,required:s||!1,lookup:i.lookup,ignore:i.ignore,global:i.global})],l}},h={string:[f,l],object:[m],number:[s],integer:[u],"boolean":[c],array:[d,p]},v=function(e){return e};this.defaults=h,this.stdFormObj=a,this.defaultFormDefinition=o,this.postProcess=function(e){v=e},this.appendRule=function(e,t){h[e]||(h[e]=[]),h[e].push(t)},this.prependRule=function(e,t){h[e]||(h[e]=[]),h[e].unshift(t)},this.createStandardForm=a,this.$get=function(){var n={};return n.merge=function(r,o,a,l,s,u){o=o||["*"],l=l||{},s=s||r.readonly||r.readOnly;var c=n.defaults(r,a,l),f=o.indexOf("*");-1!==f&&(o=o.slice(0,f).concat(c.form).concat(o.slice(f+1)));var d=c.lookup;return v(o.map(function(o){if("string"==typeof o&&(o={key:o}),o.key&&"string"==typeof o.key&&(o.key=t.parse(o.key)),o.titleMap&&(o.titleMap=i(o.titleMap)),o.itemForm){o.items=[];var c=t.stringify(o.key),f=d[c];e.forEach(f.items,function(t){var r=e.copy(o.itemForm);r.key=t.key,o.items.push(r)})}if(o.key){var m=t.stringify(o.key);if(d[m]){var p=d[m];e.forEach(p,function(e,t){void 0===o[t]&&(o[t]=p[t])})}}return s===!0&&(o.readonly=!0),o.items&&(o.items=n.merge(r,o.items,a,l,o.readonly,u)),o.tabs&&e.forEach(o.tabs,function(e){e.items=n.merge(r,e.items,a,l,o.readonly,u)}),"checkbox"===o.type&&e.isUndefined(o.schema["default"])&&(o.schema["default"]=!1),u&&"template"===o.type&&!o.template&&o.templateUrl&&u.push(o),o}))},n.defaults=function(t,n,i){var a=[],l={};if(n=n||{},i=i||{},"object"!==r(t.type))throw new Error('Not implemented. Only type "object" allowed at root level of schema.');return e.forEach(t.properties,function(e,r){if(n[r]!==!0){var s=t.required&&-1!==t.required.indexOf(r),u=o(r,e,{path:[r],lookup:l,ignore:n,required:s,global:i});u&&a.push(u)}}),{form:a,lookup:l}},n.traverseSchema=function(t,r,n,i){i=e.isDefined(i)?i:!0,n=n||[];var o=function(t,r,n){if(r(t,n),e.forEach(t.properties,function(e,t){var i=n.slice();i.push(t),o(e,r,i)}),!i&&t.items){var a=n.slice();a.push(""),o(t.items,r,a)}};o(t,r,n||[])},n.traverseForm=function(t,r){r(t),e.forEach(t.items,function(e){n.traverseForm(e,r)}),t.tabs&&e.forEach(t.tabs,function(t){e.forEach(t.items,function(e){n.traverseForm(e,r)})})},n}}]),e.module("schemaForm").factory("sfSelect",["sfPath",function(e){var t=/^\d+$/;return function(r,n,i){n||(n=this);var o="string"==typeof r?e.parse(r):r;if("undefined"!=typeof i&&1===o.length)return n[o[0]]=i,n;"undefined"!=typeof i&&"undefined"==typeof n[o[0]]&&(n[o[0]]=o.length>2&&t.test(o[1])?[]:{});for(var a=n[o[0]],l=1;l<o.length;l++){if(""===o[l])return void 0;if("undefined"!=typeof i){if(l===o.length-1)return a[o[l]]=i,i;var s=a[o[l]];("undefined"==typeof s||null===s)&&(s=t.test(o[l+1])?[]:{},a[o[l]]=s),a=s}else a&&(a=a[o[l]])}return a}}]),e.module("schemaForm").factory("sfValidator",[function(){var t={};return t.validate=function(t,n){if(!t)return{valid:!0};var i=t.schema;if(!i)return{valid:!0};""===n&&(n=void 0),"number"===t.type&&null===n&&(n=void 0);var o={type:"object",properties:{}},a=t.key[t.key.length-1];o.properties[a]=i,t.required&&(o.required=[a]);var l={};return e.isDefined(n)&&(l[a]=n),r.validateResult(l,o)},t}]),e.module("schemaForm").directive("sfArray",["sfSelect","schemaForm","sfValidator","sfPath",function(t,r,n,i){var o=function(e){return function(t){t.key&&(t.key[t.key.indexOf("")]=e)}};return{restrict:"A",scope:!0,require:"?ngModel",link:function(a,l,s,u){var c={};a.validateArray=e.noop,u&&a.$emit("schemaFormPropagateNgModelController",u);var f=a.$watch(s.sfArray,function(l){if(l){var s=t(l.key,a.model),d=i.normalize(l.key);if(a.$watch("model"+("["!==d[0]?".":"")+d,function(e){s=a.modelArray=e}),e.isUndefined(s)&&(s=[],t(l.key,a.model,s)),a.modelArray=s,l.items){var m=l.items[0];l.items.length>1&&(m={type:"section",items:l.items.map(function(t){return t.ngModelOptions=l.ngModelOptions,e.isUndefined(t.readonly)&&(t.readonly=l.readonly),t})})}if(a.copyWithIndex=function(t){if(!c[t]&&m){var n=e.copy(m);n.arrayIndex=t,r.traverseForm(n,o(t)),c[t]=n}return c[t]},a.appendToArray=function(){var n=s.length,i=a.copyWithIndex(n);if(r.traverseForm(i,function(r){if(r.key){var n;e.isDefined(r["default"])&&(n=r["default"]),e.isDefined(r.schema)&&e.isDefined(r.schema["default"])&&(n=r.schema["default"]),e.isDefined(n)&&t(r.key,a.model,n)}}),n===s.length){var o,u=t("schema.items.type",l);"object"===u?o={}:"array"===u&&(o=[]),s.push(o)}return a.validateArray(),s},a.deleteFromArray=function(e){return s.splice(e,1),a.validateArray(),u&&u.$setDirty&&u.$setDirty(),s},l.titleMap||l.startEmpty===!0||0!==s.length||a.appendToArray(),l.titleMap&&l.titleMap.length>0){a.titleMapValues=[];var p=function(e){a.titleMapValues=[],e=e||[],l.titleMap.forEach(function(t){a.titleMapValues.push(-1!==e.indexOf(t.value))})};p(a.modelArray),a.$watchCollection("modelArray",p),a.$watchCollection("titleMapValues",function(e,t){if(e&&e!==t){for(var r=a.modelArray;r.length>0;)r.pop();l.titleMap.forEach(function(t,n){e[n]&&r.push(t.value)}),a.validateArray()}})}if(u){var h;a.validateArray=function(){var e=n.validate(l,a.modelArray.length>0?a.modelArray:void 0);Object.keys(u.$error).filter(function(e){return 0===e.indexOf("tv4-")}).forEach(function(e){u.$setValidity(e,!0)}),e.valid!==!1||!e.error||""!==e.error.dataPath&&e.error.dataPath!=="/"+l.key[l.key.length-1]||(u.$setViewValue(a.modelArray),h=e.error,u.$setValidity("tv4-"+e.error.code,!1))},a.$on("schemaFormValidate",a.validateArray),a.hasSuccess=function(){return a.options&&a.options.pristine&&a.options.pristine.success===!1?u.$valid&&!u.$pristine&&!u.$isEmpty(u.$modelValue):u.$valid&&(!u.$pristine||!u.$isEmpty(u.$modelValue))},a.hasError=function(){return a.options&&a.options.pristine&&a.options.pristine.errors===!1?u.$invalid&&!u.$pristine:u.$invalid},a.schemaError=function(){return h}}f()}})}}}]),e.module("schemaForm").directive("sfChanged",function(){return{require:"ngModel",restrict:"AC",scope:!1,link:function(t,r,n,i){var o=t.$eval(n.sfChanged);o&&o.onChange&&i.$viewChangeListeners.push(function(){e.isFunction(o.onChange)?o.onChange(i.$modelValue,o):t.evalExpr(o.onChange,{modelValue:i.$modelValue,form:o})})}}}),e.module("schemaForm").directive("sfField",["$parse","$compile","$http","$templateCache","$interpolate","$q","sfErrorMessage","sfPath","sfSelect",function(t,r,n,i,o,a,l,s,u){return{restrict:"AE",replace:!1,transclude:!1,scope:!0,require:"^sfSchema",link:{pre:function(e,t,r,n){e.$on("schemaFormPropagateNgModelController",function(t,r){t.stopPropagation(),t.preventDefault(),e.ngModel=r}),e.form=n.lookup["f"+r.sfField]},post:function(t,r,n,i){t.showTitle=function(){return t.form&&t.form.notitle!==!0&&t.form.title},t.listToCheckboxValues=function(t){var r={};return e.forEach(t,function(e){r[e]=!0}),r},t.checkboxValuesToList=function(t){var r=[];return e.forEach(t,function(e,t){e&&r.push(t)}),r},t.buttonClick=function(r,n){e.isFunction(n.onClick)?n.onClick(r,n):e.isString(n.onClick)&&(i?i.evalInParentScope(n.onClick,{$event:r,form:n}):t.$eval(n.onClick,{$event:r,form:n}))},t.evalExpr=function(e,r){return i?i.evalInParentScope(e,r):t.$eval(e,r)},t.evalInScope=function(e,r){return e?t.$eval(e,r):void 0},t.interp=function(e,t){return e&&o(e)(t)},t.hasSuccess=function(){return t.ngModel?t.options&&t.options.pristine&&t.options.pristine.success===!1?t.ngModel.$valid&&!t.ngModel.$pristine&&!t.ngModel.$isEmpty(t.ngModel.$modelValue):t.ngModel.$valid&&(!t.ngModel.$pristine||!t.ngModel.$isEmpty(t.ngModel.$modelValue)):!1},t.hasError=function(){return t.ngModel?t.options&&t.options.pristine&&t.options.pristine.errors===!1?t.ngModel.$invalid&&!t.ngModel.$pristine:t.ngModel.$invalid:!1},t.errorMessage=function(e){return l.interpolate(e&&e.code+""||"default",t.ngModel&&t.ngModel.$modelValue||"",t.ngModel&&t.ngModel.$viewValue||"",t.form,t.options&&t.options.validationMessage)};var a=t.form;a.key&&(t.$on("schemaForm.error."+a.key.join("."),function(e,r,n,i){(n===!0||n===!1)&&(i=n,n=void 0),t.ngModel&&r&&(t.ngModel.$setDirty?t.ngModel.$setDirty():(t.ngModel.$dirty=!0,t.ngModel.$pristine=!1),n&&(a.validationMessage||(a.validationMessage={}),a.validationMessage[r]=n),t.ngModel.$setValidity(r,i===!0),i===!0&&(t.ngModel.$validate(),t.$broadcast("schemaFormValidate")))}),t.$on("$destroy",function(){if(!t.externalDestructionInProgress){var e=a.destroyStrategy||t.options&&t.options.destroyStrategy||"remove";if(a.key&&"retain"!==e){var r=t.model;if(a.key.length>1&&(r=u(a.key.slice(0,a.key.length-1),r)),void 0===r)return;var n=a.schema&&a.schema.type||"";"empty"===e&&-1!==n.indexOf("string")?r[a.key.slice(-1)]="":"empty"===e&&-1!==n.indexOf("object")?r[a.key.slice(-1)]={}:"empty"===e&&-1!==n.indexOf("array")?r[a.key.slice(-1)]=[]:"null"===e?r[a.key.slice(-1)]=null:delete r[a.key.slice(-1)]}}}))}}}}]),e.module("schemaForm").directive("sfMessage",["$injector","sfErrorMessage",function(t,r){var n=t.has("$sanitize")?t.get("$sanitize"):function(e){return e};return{scope:!1,restrict:"EA",link:function(t,i,o){var a="";o.sfMessage&&t.$watch(o.sfMessage,function(e){e&&(a=n(e),u(!!t.ngModel))});var l,s=function(e){e!==l&&(i.html(e),l=e)},u=function(n){if(n)if(t.hasError()){var i=[];e.forEach(t.ngModel&&t.ngModel.$error,function(e,t){e&&i.push(t)}),i=i.filter(function(e){return"schemaForm"!==e});var o=i[0];s(o?r.interpolate(o,t.ngModel.$modelValue,t.ngModel.$viewValue,t.form,t.options&&t.options.validationMessage):a)}else s(a);else s(a)};u();var c=t.$watch("ngModel",function(e){e&&(e.$parsers.push(function(e){return u(!0),e}),e.$formatters.push(function(e){return u(!0),e}),c())});t.$watchCollection("ngModel.$error",function(){u(!!t.ngModel)})}}}]),e.module("schemaForm").directive("sfNewArray",["sfSelect","sfPath","schemaForm",function(t,r,n){return{scope:!1,link:function(i,o,a){i.min=0,i.modelArray=i.$eval(a.sfNewArray);var l=function(){i.modelArray=i.$eval(a.sfNewArray),(!(i.ngModel&&i.ngModel.$pristine&&i.firstDigest)||i.options&&i.options.validateOnRender===!0)&&i.validateField&&i.validateField()},s=function(){i.form&&i.form.onChange&&(e.isFunction(i.form.onChange)?i.form.onChange(i.modelArray,i.form):i.evalExpr(i.form.onChange,{modelValue:i.modelArray,form:i.form}))},u=function(){var e=i.modelArray;if(!e){var n=r.parse(a.sfNewArray);e=[],t(n,i,e),i.modelArray=e}return e},c=i.$watch("form",function(e){if(e){if(e.titleMap||e.startEmpty===!0||i.modelArray&&0!==i.modelArray.length||i.appendToArray(),i.form&&i.form.schema&&i.form.schema.uniqueItems===!0?(i.$watch(a.sfNewArray,l,!0),i.$watch([a.sfNewArray,a.sfNewArray+".length"],s)):i.$watchGroup?i.$watchGroup([a.sfNewArray,a.sfNewArray+".length"],function(){l(),s()}):(i.$watch(a.sfNewArray,function(){l(),s()}),i.$watch(a.sfNewArray+".length",function(){l(),s()})),e.titleMap&&e.titleMap.length>0){i.titleMapValues=[];var t=function(t){i.titleMapValues=[],t=t||[],e.titleMap.forEach(function(e){i.titleMapValues.push(-1!==t.indexOf(e.value))})};t(i.modelArray),i.$watchCollection("modelArray",t),i.$watchCollection("titleMapValues",function(t,r){if(t&&t!==r){for(var n=u();n.length>0;)n.pop();e.titleMap.forEach(function(e,r){t[r]&&n.push(e.value)}),i.validateField&&i.validateField()}})}c()}});i.appendToArray=function(){var r,o=u();if(i.form&&i.form.schema&&i.form.schema.items){var a=i.form.schema.items;a.type&&-1!==a.type.indexOf("object")?(r={},i.options&&i.options.setSchemaDefaults===!1||(r=e.isDefined(a["default"])?a["default"]:r,r&&n.traverseSchema(a,function(n,i){e.isDefined(n["default"])&&t(i,r,n["default"])}))):a.type&&-1!==a.type.indexOf("array")?(r=[],i.options&&i.options.setSchemaDefaults===!1||(r=a["default"]||r)):i.options&&i.options.setSchemaDefaults===!1||(r=a["default"]||r)}return o.push(r),o},i.deleteFromArray=function(e){var t=i.modelArray;return t&&t.splice(e,1),t};var f=function(e){return function(t){t.key&&(t.key[t.key.indexOf("")]=e)}},d={};i.copyWithIndex=function(t){var r=i.form;if(!d[t]){var o=r.items[0];if(r.items.length>1&&(o={type:"section",items:r.items.map(function(t){return t.ngModelOptions=r.ngModelOptions,e.isUndefined(t.readonly)&&(t.readonly=r.readonly),t})}),o){var a=e.copy(o);a.arrayIndex=t,n.traverseForm(a,f(t)),d[t]=a}}return d[t]}}}}]),e.module("schemaForm").directive("sfSchema",["$compile","$http","$templateCache","$q","schemaForm","schemaFormDecorators","sfSelect","sfPath","sfBuilder",function(t,r,n,i,o,a,l,s,u){return{scope:{schema:"=sfSchema",initialForm:"=sfForm",model:"=sfModel",options:"=sfOptions"},controller:["$scope",function(e){this.evalInParentScope=function(t,r){return e.$parent.$eval(t,r)};var t=this;e.lookup=function(e){return e&&(t.lookup=e),t.lookup}}],replace:!1,restrict:"A",transclude:!0,require:"?form",link:function(s,c,f,d,m){s.formCtrl=d;var p={};m(s,function(e){if(e.addClass("schema-form-ignore"),c.prepend(e),c[0].querySelectorAll){var t=c[0].querySelectorAll("[ng-model]");if(t)for(var r=0;r<t.length;r++){var n=t[r].getAttribute("ng-model");p[n.substring(n.indexOf(".")+1)]=!0}}});var h,v={},y=function(e,t){var a=[],l=o.merge(e,t,p,s.options,void 0,a);a.length>0?i.all(a.map(function(e){return r.get(e.templateUrl,{cache:n}).then(function(t){e.template=t.data})})).then(function(){g(e,t,l)}):g(e,t,l)},g=function(r,n,i){h&&(s.externalDestructionInProgress=!0,h.$destroy(),s.externalDestructionInProgress=!1),h=s.$new(),h.schemaForm={form:i,schema:r},c.children(":not(.schema-form-ignore)").remove();for(var d={},m=c[0].querySelectorAll("*[sf-insert-field]"),p=0;p<m.length;p++)d[m[p].getAttribute("sf-insert-field")]=m[p];var v=a.decorator(f.sfUseDecorator),y=Object.create(null);s.lookup(y),c[0].appendChild(u.build(i,v,d,y)),h.firstDigest=!0,setTimeout(function(){h.firstDigest=!1},0),t(c.children())(h),s.options&&s.options.setSchemaDefaults===!1||o.traverseSchema(r,function(t,r){if(e.isDefined(t["default"])){var n=l(r,s.model);e.isUndefined(n)&&l(r,s.model,t["default"])}}),s.$emit("sf-render-finished",c)},$=["*"];s.$watch(function(){var e=s.schema,t=s.initialForm||$;t&&e&&e.type&&(v.form!==t||v.schema!==e)&&Object.keys(e.properties).length>0&&(v.schema=e,v.form=t,y(e,t))}),s.$on("schemaFormRedraw",function(){var t=s.schema,r=s.initialForm?e.copy(s.initialForm):["*"];t&&y(t,r)}),s.$on("$destroy",function(){s.externalDestructionInProgress=!0}),s.evalExpr=function(e,t){return s.$parent.$eval(e,t)}}}}]),e.module("schemaForm").directive("schemaValidate",["sfValidator","$parse","sfSelect",function(t,r,n){return{restrict:"A",scope:!1,priority:500,require:"ngModel",link:function(r,i,o,a){r.$emit("schemaFormPropagateNgModelController",a);var l=null,s=r.$eval(o.schemaValidate);s.copyValueTo&&a.$viewChangeListeners.push(function(){var t=s.copyValueTo;e.forEach(t,function(e){n(e,r.model,a.$modelValue)})});var u=function(e){if(!s)return e;if(r.options&&r.options.tv4Validation===!1)return e;var n=t.validate(s,e);return Object.keys(a.$error).filter(function(e){return 0===e.indexOf("tv4-")}).forEach(function(e){a.$setValidity(e,!0)}),n.valid?e:(a.$setValidity("tv4-"+n.error.code,!1),l=n.error,a.$validators?e:void 0)};"function"==typeof s.ngModel&&s.ngModel(a),["$parsers","$viewChangeListeners","$formatters"].forEach(function(e){s[e]&&a[e]&&s[e].forEach(function(t){a[e].push(t)})}),["$validators","$asyncValidators"].forEach(function(t){s[t]&&a[t]&&e.forEach(s[t],function(e,r){a[t][r]=e})}),a.$parsers.push(u),a.$validators&&(a.$validators.schemaForm=function(){return!Object.keys(a.$error).some(function(e){return"schemaForm"!==e})});var c=s.schema;r.validateField=function(e){(void 0==e||a.$$parentForm.$name===e)&&(c&&-1!==c.type.indexOf("array")&&u(a.$modelValue),a.$setDirty?(a.$setDirty(),a.$setViewValue(a.$viewValue),a.$commitViewValue(),s.required&&a.$isEmpty(a.$modelValue)&&a.$setValidity("tv4-302",!1)):a.$setViewValue(a.$viewValue))},a.$formatters.push(function(e){return!a.$pristine||!r.firstDigest||r.options&&r.options.validateOnRender===!0?(u(a.$modelValue),e):e}),r.$on("schemaFormValidate",function(e,t){r.validateField(t)}),r.schemaError=function(){return l}}}}]),o});

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(539).ObjectPath;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	;!function(undefined) {
	
		var ObjectPath = {
			parse: function(str){
				if(typeof str !== 'string'){
					throw new TypeError('ObjectPath.parse must be passed a string');
				}
	
				var i = 0;
				var parts = [];
				var d, b, q, c;
				while (i < str.length){
					d = str.indexOf('.', i);
					b = str.indexOf('[', i);
	
					// we've reached the end
					if (d === -1 && b === -1){
						parts.push(str.slice(i, str.length));
						i = str.length;
					}
	
					// dots
					else if (b === -1 || (d !== -1 && d < b)) {
						parts.push(str.slice(i, d));
						i = d + 1;
					}
	
					// brackets
					else {
						if (b > i){
							parts.push(str.slice(i, b));
							i = b;
						}
						q = str.slice(b+1, b+2);
						if (q !== '"' && q !=='\'') {
							c = str.indexOf(']', b);
							if (c === -1) c = str.length;
							parts.push(str.slice(i + 1, c));
							i = (str.slice(c + 1, c + 2) === '.') ? c + 2 : c + 1;
						} else {
							c = str.indexOf(q+']', b);
							if (c === -1) c = str.length;
							while (str.slice(c - 1, c) === '\\' && b < str.length){
								b++;
								c = str.indexOf(q+']', b);
							}
							parts.push(str.slice(i + 2, c).replace(new RegExp('\\'+q,'g'), q));
							i = (str.slice(c + 2, c + 3) === '.') ? c + 3 : c + 2;
						}
					}
				}
				return parts;
			},
	
			// root === true : auto calculate root; must be dot-notation friendly
			// root String : the string to use as root
			stringify: function(arr, quote){
	
				if(!Array.isArray(arr))
					arr = [arr.toString()];
	
				quote = quote === '"' ? '"' : '\'';
	
				return arr.map(function(n){ return '[' + quote + (n.toString()).replace(new RegExp(quote, 'g'), '\\' + quote) + quote + ']'; }).join('');
			},
	
			normalize: function(data, quote){
				return ObjectPath.stringify(Array.isArray(data) ? data : ObjectPath.parse(data), quote);
			},
	
			// Angular
			registerModule: function(angular) {
				angular.module('ObjectPath', []).provider('ObjectPath', function(){
					this.parse = ObjectPath.parse;
					this.stringify = ObjectPath.stringify;
					this.normalize = ObjectPath.normalize;
					this.$get = function(){
						return ObjectPath;
					};
				});
			}
		};
	
		// AMD
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return {ObjectPath: ObjectPath};
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
		// CommonJS
		else if (typeof exports === 'object') {
			exports.ObjectPath = ObjectPath;
		}
	
		// Browser global
		else {
			window.ObjectPath = ObjectPath;
		}
		
	}();

/***/ }),
/* 540 */
536,
/* 541 */
/***/ (function(module, exports) {

	angular.module("schemaForm").run(["$templateCache", function($templateCache) {$templateCache.put("decorators/bootstrap/actions-trcl.html","<div class=\"btn-group schema-form-actions {{form.htmlClass}}\" ng-transclude=\"\"></div>");
	$templateCache.put("decorators/bootstrap/actions.html","<div class=\"btn-group schema-form-actions {{form.htmlClass}}\"><input ng-repeat-start=\"item in form.items\" type=\"submit\" class=\"btn {{ item.style || \'btn-default\' }} {{form.fieldHtmlClass}}\" value=\"{{item.title}}\" ng-if=\"item.type === \'submit\'\"> <button ng-repeat-end=\"\" class=\"btn {{ item.style || \'btn-default\' }} {{form.fieldHtmlClass}}\" type=\"button\" ng-disabled=\"form.readonly\" ng-if=\"item.type !== \'submit\'\" ng-click=\"buttonClick($event,item)\"><span ng-if=\"item.icon\" class=\"{{item.icon}}\"></span>{{item.title}}</button></div>");
	$templateCache.put("decorators/bootstrap/array.html","<div class=\"schema-form-array {{form.htmlClass}}\" sf-field-model=\"sf-new-array\" sf-new-array=\"\"><label class=\"control-label\" ng-show=\"showTitle()\">{{ form.title }}</label><ol class=\"list-group\" sf-field-model=\"\" ui-sortable=\"form.sortOptions\"><li class=\"list-group-item {{form.fieldHtmlClass}}\" schema-form-array-items=\"\" sf-field-model=\"ng-repeat\" ng-repeat=\"item in $$value$$ track by $index\"><button ng-hide=\"form.readonly || form.remove === null\" ng-click=\"deleteFromArray($index)\" ng-disabled=\"form.schema.minItems >= modelArray.length\" style=\"position: relative; z-index: 20;\" type=\"button\" class=\"close pull-right\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button></li></ol><div class=\"clearfix\" style=\"padding: 15px;\" ng-model=\"modelArray\" schema-validate=\"form\"><div class=\"help-block\" ng-show=\"(hasError() && errorMessage(schemaError())) || form.description\" ng-bind-html=\"(hasError() && errorMessage(schemaError())) || form.description\"></div><button ng-hide=\"form.readonly || form.add === null\" ng-click=\"appendToArray()\" ng-disabled=\"form.schema.maxItems <= modelArray.length\" type=\"button\" class=\"btn {{ form.style.add || \'btn-default\' }} pull-right\"><i class=\"glyphicon glyphicon-plus\"></i> {{ form.add || \'Add\'}}</button></div></div>");
	$templateCache.put("decorators/bootstrap/checkbox.html","<div class=\"checkbox schema-form-checkbox {{form.htmlClass}}\" ng-class=\"{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}\"><label class=\"{{form.labelHtmlClass}}\"><input type=\"checkbox\" sf-changed=\"form\" ng-disabled=\"form.readonly\" sf-field-model=\"\" schema-validate=\"form\" class=\"{{form.fieldHtmlClass}}\" name=\"{{form.key.slice(-1)[0]}}\"> <span ng-bind-html=\"form.title\"></span></label><div class=\"help-block\" sf-message=\"form.description\"></div></div>");
	$templateCache.put("decorators/bootstrap/checkboxes.html","<div sf-field-model=\"sf-new-array\" sf-new-array=\"\" class=\"form-group schema-form-checkboxes {{form.htmlClass}}\" ng-class=\"{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}\"><label class=\"control-label {{form.labelHtmlClass}}\" sf-field-model=\"\" schema-validate=\"form\" ng-show=\"showTitle()\">{{form.title}}</label><div class=\"checkbox\" ng-repeat=\"val in titleMapValues track by $index\"><label><input type=\"checkbox\" ng-disabled=\"form.readonly\" sf-changed=\"form\" class=\"{{form.fieldHtmlClass}}\" ng-model=\"titleMapValues[$index]\" name=\"{{form.key.slice(-1)[0]}}\"> <span ng-bind-html=\"form.titleMap[$index].name\"></span></label></div><div class=\"help-block\" sf-message=\"form.description\"></div></div>");
	$templateCache.put("decorators/bootstrap/default.html","<div class=\"form-group schema-form-{{form.type}} {{form.htmlClass}}\" ng-class=\"{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false }\"><label class=\"control-label {{form.labelHtmlClass}}\" ng-class=\"{\'sr-only\': !showTitle()}\" for=\"{{form.key.slice(-1)[0]}}\">{{form.title}}</label> <input ng-if=\"!form.fieldAddonLeft && !form.fieldAddonRight\" ng-show=\"form.key\" type=\"{{form.type}}\" step=\"any\" sf-changed=\"form\" placeholder=\"{{form.placeholder}}\" class=\"form-control {{form.fieldHtmlClass}}\" id=\"{{form.key.slice(-1)[0]}}\" sf-field-model=\"\" ng-disabled=\"form.readonly\" schema-validate=\"form\" name=\"{{form.key.slice(-1)[0]}}\" aria-describedby=\"{{form.key.slice(-1)[0] + \'Status\'}}\"><div ng-if=\"form.fieldAddonLeft || form.fieldAddonRight\" ng-class=\"{\'input-group\': (form.fieldAddonLeft || form.fieldAddonRight)}\"><span ng-if=\"form.fieldAddonLeft\" class=\"input-group-addon\" ng-bind-html=\"form.fieldAddonLeft\"></span> <input ng-show=\"form.key\" type=\"{{form.type}}\" step=\"any\" sf-changed=\"form\" placeholder=\"{{form.placeholder}}\" class=\"form-control {{form.fieldHtmlClass}}\" id=\"{{form.key.slice(-1)[0]}}\" sf-field-model=\"\" ng-disabled=\"form.readonly\" schema-validate=\"form\" name=\"{{form.key.slice(-1)[0]}}\" aria-describedby=\"{{form.key.slice(-1)[0] + \'Status\'}}\"> <span ng-if=\"form.fieldAddonRight\" class=\"input-group-addon\" ng-bind-html=\"form.fieldAddonRight\"></span></div><span ng-if=\"form.feedback !== false\" class=\"form-control-feedback\" ng-class=\"evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }\" aria-hidden=\"true\"></span> <span ng-if=\"hasError() || hasSuccess()\" id=\"{{form.key.slice(-1)[0] + \'Status\'}}\" class=\"sr-only\">{{ hasSuccess() ? \'(success)\' : \'(error)\' }}</span><div class=\"help-block\" sf-message=\"form.description\"></div></div>");
	$templateCache.put("decorators/bootstrap/fieldset.html","<fieldset ng-disabled=\"form.readonly\" class=\"schema-form-fieldset {{form.htmlClass}}\"><legend ng-class=\"{\'sr-only\': !showTitle() }\">{{ form.title }}</legend><div class=\"help-block\" ng-show=\"form.description\" ng-bind-html=\"form.description\"></div></fieldset>");
	$templateCache.put("decorators/bootstrap/help.html","<div class=\"helpvalue schema-form-helpvalue {{form.htmlClass}}\" ng-bind-html=\"form.helpvalue\"></div>");
	$templateCache.put("decorators/bootstrap/radio-buttons.html","<div class=\"form-group schema-form-radiobuttons {{form.htmlClass}}\" ng-class=\"{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}\"><div><label class=\"control-label {{form.labelHtmlClass}}\" ng-show=\"showTitle()\">{{form.title}}</label></div><div class=\"btn-group\"><label sf-field-model=\"replaceAll\" class=\"btn {{ (item.value === $$value$$) ? form.style.selected || \'btn-default\' : form.style.unselected || \'btn-default\'; }}\" ng-class=\"{ active: item.value === $$value$$ }\" ng-repeat=\"item in form.titleMap\"><input type=\"radio\" class=\"{{form.fieldHtmlClass}}\" sf-changed=\"form\" style=\"display: none;\" ng-disabled=\"form.readonly\" sf-field-model=\"\" schema-validate=\"form\" ng-value=\"item.value\" name=\"{{form.key.join(\'.\')}}\"> <span ng-bind-html=\"item.name\"></span></label></div><div class=\"help-block\" sf-message=\"form.description\"></div></div>");
	$templateCache.put("decorators/bootstrap/radios-inline.html","<div class=\"form-group schema-form-radios-inline {{form.htmlClass}}\" ng-class=\"{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}\"><label class=\"control-label {{form.labelHtmlClass}}\" ng-show=\"showTitle()\" sf-field-model=\"\" schema-validate=\"form\">{{form.title}}</label><div><label class=\"radio-inline\" ng-repeat=\"item in form.titleMap\"><input type=\"radio\" class=\"{{form.fieldHtmlClass}}\" sf-changed=\"form\" ng-disabled=\"form.readonly\" sf-field-model=\"\" ng-value=\"item.value\" name=\"{{form.key.join(\'.\')}}\"> <span ng-bind-html=\"item.name\"></span></label></div><div class=\"help-block\" sf-message=\"form.description\"></div></div>");
	$templateCache.put("decorators/bootstrap/radios.html","<div class=\"form-group schema-form-radios {{form.htmlClass}}\" ng-class=\"{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}\"><label class=\"control-label {{form.labelHtmlClass}}\" sf-field-model=\"\" schema-validate=\"form\" ng-show=\"showTitle()\">{{form.title}}</label><div class=\"radio\" ng-repeat=\"item in form.titleMap\"><label><input type=\"radio\" class=\"{{form.fieldHtmlClass}}\" sf-changed=\"form\" ng-disabled=\"form.readonly\" sf-field-model=\"\" ng-value=\"item.value\" name=\"{{form.key.join(\'.\')}}\"> <span ng-bind-html=\"item.name\"></span></label></div><div class=\"help-block\" sf-message=\"form.description\"></div></div>");
	$templateCache.put("decorators/bootstrap/section.html","<div class=\"schema-form-section {{form.htmlClass}}\"></div>");
	$templateCache.put("decorators/bootstrap/select.html","<div class=\"form-group {{form.htmlClass}} schema-form-select\" ng-class=\"{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false}\"><label class=\"control-label {{form.labelHtmlClass}}\" ng-show=\"showTitle()\">{{form.title}}</label><select sf-field-model=\"\" ng-disabled=\"form.readonly\" sf-changed=\"form\" class=\"form-control {{form.fieldHtmlClass}}\" schema-validate=\"form\" ng-options=\"item.value as item.name group by item.group for item in form.titleMap\" name=\"{{form.key.slice(-1)[0]}}\"></select><div class=\"help-block\" sf-message=\"form.description\"></div></div>");
	$templateCache.put("decorators/bootstrap/submit.html","<div class=\"form-group schema-form-submit {{form.htmlClass}}\"><input type=\"submit\" class=\"btn {{ form.style || \'btn-primary\' }} {{form.fieldHtmlClass}}\" value=\"{{form.title}}\" ng-disabled=\"form.readonly\" ng-if=\"form.type === \'submit\'\"> <button class=\"btn {{ form.style || \'btn-default\' }}\" type=\"button\" ng-click=\"buttonClick($event,form)\" ng-disabled=\"form.readonly\" ng-if=\"form.type !== \'submit\'\"><span ng-if=\"form.icon\" class=\"{{form.icon}}\"></span> {{form.title}}</button></div>");
	$templateCache.put("decorators/bootstrap/tabarray.html","<div ng-init=\"selected = { tab: 0 }\" ng-model=\"modelArray\" schema-validate=\"form\" sf-field-model=\"sf-new-array\" sf-new-array=\"\" class=\"clearfix schema-form-tabarray schema-form-tabarray-{{form.tabType || \'left\'}} {{form.htmlClass}}\"><div ng-if=\"!form.tabType || form.tabType !== \'right\'\" ng-class=\"{\'col-xs-3\': !form.tabType || form.tabType === \'left\'}\"><ul class=\"nav nav-tabs\" ng-class=\"{ \'tabs-left\': !form.tabType || form.tabType === \'left\'}\"><li sf-field-model=\"ng-repeat\" ng-repeat=\"item in $$value$$ track by $index\" ng-click=\"$event.preventDefault() || (selected.tab = $index)\" ng-class=\"{active: selected.tab === $index}\"><a href=\"#\">{{interp(form.title,{\'$index\':$index, value: item}) || $index}}</a></li><li ng-hide=\"form.readonly\" ng-disabled=\"form.schema.maxItems <= modelArray.length\" ng-click=\"$event.preventDefault() || (selected.tab = appendToArray().length - 1)\"><a href=\"#\"><i class=\"glyphicon glyphicon-plus\"></i> {{ form.add || \'Add\'}}</a></li></ul></div><div ng-class=\"{\'col-xs-9\': !form.tabType || form.tabType === \'left\' || form.tabType === \'right\'}\"><div class=\"tab-content {{form.fieldHtmlClass}}\"><div class=\"tab-pane clearfix tab{{selected.tab}} index{{$index}}\" sf-field-model=\"ng-repeat\" ng-repeat=\"item in $$value$$ track by $index\" ng-show=\"selected.tab === $index\" ng-class=\"{active: selected.tab === $index}\"><div schema-form-array-items=\"\"></div><button ng-hide=\"form.readonly\" ng-click=\"selected.tab = deleteFromArray($index).length - 1\" ng-disabled=\"form.schema.minItems >= modelArray.length\" type=\"button\" class=\"btn {{ form.style.remove || \'btn-default\' }} pull-right\"><i class=\"glyphicon glyphicon-trash\"></i> {{ form.remove || \'Remove\'}}</button></div><div class=\"help-block\" ng-show=\"(hasError() && errorMessage(schemaError())) || form.description\" ng-bind-html=\"(hasError() && errorMessage(schemaError())) || form.description\"></div></div></div></div><div ng-if=\"form.tabType === \'right\'\" class=\"col-xs-3\"><ul class=\"nav nav-tabs tabs-right\"><li sf-field-model=\"ng-repeat\" ng-repeat=\"item in $$value$$ track by $index\" ng-click=\"$event.preventDefault() || (selected.tab = $index)\" ng-class=\"{active: selected.tab === $index}\"><a href=\"#\">{{interp(form.title,{\'$index\':$index, value: item}) || $index}}</a></li><li ng-hide=\"form.readonly\" ng-disabled=\"form.schema.maxItems <= modelArray.length\" ng-click=\"$event.preventDefault() || (selected.tab = appendToArray().length - 1)\"><a href=\"#\"><i class=\"glyphicon glyphicon-plus\"></i> {{ form.add || \'Add\'}}</a></li></ul></div>");
	$templateCache.put("decorators/bootstrap/tabs.html","<div ng-init=\"selected = { tab: 0 }\" class=\"schema-form-tabs {{form.htmlClass}}\"><ul class=\"nav nav-tabs\"><li ng-repeat=\"tab in form.tabs\" ng-disabled=\"form.readonly\" ng-click=\"$event.preventDefault() || (selected.tab = $index)\" ng-class=\"{active: selected.tab === $index}\"><a href=\"#\">{{ tab.title }}</a></li></ul><div class=\"tab-content {{form.fieldHtmlClass}}\"></div></div>");
	$templateCache.put("decorators/bootstrap/textarea.html","<div class=\"form-group has-feedback {{form.htmlClass}} schema-form-textarea\" ng-class=\"{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}\"><label class=\"control-label {{form.labelHtmlClass}}\" ng-class=\"{\'sr-only\': !showTitle()}\" for=\"{{form.key.slice(-1)[0]}}\">{{form.title}}</label> <textarea ng-if=\"!form.fieldAddonLeft && !form.fieldAddonRight\" class=\"form-control {{form.fieldHtmlClass}}\" id=\"{{form.key.slice(-1)[0]}}\" sf-changed=\"form\" placeholder=\"{{form.placeholder}}\" ng-disabled=\"form.readonly\" sf-field-model=\"\" schema-validate=\"form\" name=\"{{form.key.slice(-1)[0]}}\"></textarea><div ng-if=\"form.fieldAddonLeft || form.fieldAddonRight\" ng-class=\"{\'input-group\': (form.fieldAddonLeft || form.fieldAddonRight)}\"><span ng-if=\"form.fieldAddonLeft\" class=\"input-group-addon\" ng-bind-html=\"form.fieldAddonLeft\"></span> <textarea class=\"form-control {{form.fieldHtmlClass}}\" id=\"{{form.key.slice(-1)[0]}}\" sf-changed=\"form\" placeholder=\"{{form.placeholder}}\" ng-disabled=\"form.readonly\" sf-field-model=\"\" schema-validate=\"form\" name=\"{{form.key.slice(-1)[0]}}\"></textarea> <span ng-if=\"form.fieldAddonRight\" class=\"input-group-addon\" ng-bind-html=\"form.fieldAddonRight\"></span></div><span class=\"help-block\" sf-message=\"form.description\"></span></div>");}]);
	angular.module('schemaForm').config(['schemaFormDecoratorsProvider', 'sfBuilderProvider', 'sfPathProvider',
	function(decoratorsProvider, sfBuilderProvider, sfPathProvider) {
	  var base = 'decorators/bootstrap/';
	
	  var simpleTransclusion  = sfBuilderProvider.builders.simpleTransclusion;
	  var ngModelOptions      = sfBuilderProvider.builders.ngModelOptions;
	  var ngModel             = sfBuilderProvider.builders.ngModel;
	  var sfField             = sfBuilderProvider.builders.sfField;
	  var condition           = sfBuilderProvider.builders.condition;
	  var array               = sfBuilderProvider.builders.array;
	
	  // Tabs is so bootstrap specific that it stays here.
	  var tabs = function(args) {
	    if (args.form.tabs && args.form.tabs.length > 0) {
	      var tabContent = args.fieldFrag.querySelector('.tab-content');
	
	      args.form.tabs.forEach(function(tab, index) {
	        var div = document.createElement('div');
	        div.className = 'tab-pane';
	        div.setAttribute('ng-disabled', 'form.readonly');
	        div.setAttribute('ng-show', 'selected.tab === ' + index);
	        div.setAttribute('ng-class', '{active: selected.tab === ' + index + '}');
	
	        var childFrag = args.build(tab.items, args.path + '.tabs[' + index + '].items', args.state);
	        div.appendChild(childFrag);
	        tabContent.appendChild(div);
	      });
	    }
	  };
	
	  var defaults = [sfField, ngModel, ngModelOptions, condition];
	  decoratorsProvider.defineDecorator('bootstrapDecorator', {
	    textarea: {template: base + 'textarea.html', builder: defaults},
	    fieldset: {template: base + 'fieldset.html', builder: [sfField, simpleTransclusion, condition]},
	    array: {template: base + 'array.html', builder: [sfField, ngModelOptions, ngModel, array, condition]},
	    tabarray: {template: base + 'tabarray.html', builder: [sfField, ngModelOptions, ngModel, array, condition]},
	    tabs: {template: base + 'tabs.html', builder: [sfField, ngModelOptions, tabs, condition]},
	    section: {template: base + 'section.html', builder: [sfField, simpleTransclusion, condition]},
	    conditional: {template: base + 'section.html', builder: [sfField, simpleTransclusion, condition]},
	    actions: {template: base + 'actions.html', builder: defaults},
	    select: {template: base + 'select.html', builder: defaults},
	    checkbox: {template: base + 'checkbox.html', builder: defaults},
	    checkboxes: {template: base + 'checkboxes.html', builder: [sfField, ngModelOptions, ngModel, array, condition]},
	    number: {template: base + 'default.html', builder: defaults},
	    password: {template: base + 'default.html', builder: defaults},
	    submit: {template: base + 'submit.html', builder: defaults},
	    button: {template: base + 'submit.html', builder: defaults},
	    radios: {template: base + 'radios.html', builder: defaults},
	    'radios-inline': {template: base + 'radios-inline.html', builder: defaults},
	    radiobuttons: {template: base + 'radio-buttons.html', builder: defaults},
	    help: {template: base + 'help.html', builder: defaults},
	    'default': {template: base + 'default.html', builder: defaults}
	  }, []);
	
	}]);


/***/ }),
/* 542 */
/***/ (function(module, exports) {

	angular.module("schemaForm").run(["$templateCache",function(e){e.put("decorators/bootstrap/actions-trcl.html",'<div class="btn-group schema-form-actions {{form.htmlClass}}" ng-transclude=""></div>'),e.put("decorators/bootstrap/actions.html",'<div class="btn-group schema-form-actions {{form.htmlClass}}"><input ng-repeat-start="item in form.items" type="submit" class="btn {{ item.style || \'btn-default\' }} {{form.fieldHtmlClass}}" value="{{item.title}}" ng-if="item.type === \'submit\'"> <button ng-repeat-end="" class="btn {{ item.style || \'btn-default\' }} {{form.fieldHtmlClass}}" type="button" ng-disabled="form.readonly" ng-if="item.type !== \'submit\'" ng-click="buttonClick($event,item)"><span ng-if="item.icon" class="{{item.icon}}"></span>{{item.title}}</button></div>'),e.put("decorators/bootstrap/array.html",'<div class="schema-form-array {{form.htmlClass}}" sf-field-model="sf-new-array" sf-new-array=""><label class="control-label" ng-show="showTitle()">{{ form.title }}</label><ol class="list-group" sf-field-model="" ui-sortable="form.sortOptions"><li class="list-group-item {{form.fieldHtmlClass}}" schema-form-array-items="" sf-field-model="ng-repeat" ng-repeat="item in $$value$$ track by $index"><button ng-hide="form.readonly || form.remove === null" ng-click="deleteFromArray($index)" ng-disabled="form.schema.minItems >= modelArray.length" style="position: relative; z-index: 20;" type="button" class="close pull-right"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button></li></ol><div class="clearfix" style="padding: 15px;" ng-model="modelArray" schema-validate="form"><div class="help-block" ng-show="(hasError() && errorMessage(schemaError())) || form.description" ng-bind-html="(hasError() && errorMessage(schemaError())) || form.description"></div><button ng-hide="form.readonly || form.add === null" ng-click="appendToArray()" ng-disabled="form.schema.maxItems <= modelArray.length" type="button" class="btn {{ form.style.add || \'btn-default\' }} pull-right"><i class="glyphicon glyphicon-plus"></i> {{ form.add || \'Add\'}}</button></div></div>'),e.put("decorators/bootstrap/checkbox.html",'<div class="checkbox schema-form-checkbox {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><label class="{{form.labelHtmlClass}}"><input type="checkbox" sf-changed="form" ng-disabled="form.readonly" sf-field-model="" schema-validate="form" class="{{form.fieldHtmlClass}}" name="{{form.key.slice(-1)[0]}}"> <span ng-bind-html="form.title"></span></label><div class="help-block" sf-message="form.description"></div></div>'),e.put("decorators/bootstrap/checkboxes.html",'<div sf-field-model="sf-new-array" sf-new-array="" class="form-group schema-form-checkboxes {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><label class="control-label {{form.labelHtmlClass}}" sf-field-model="" schema-validate="form" ng-show="showTitle()">{{form.title}}</label><div class="checkbox" ng-repeat="val in titleMapValues track by $index"><label><input type="checkbox" ng-disabled="form.readonly" sf-changed="form" class="{{form.fieldHtmlClass}}" ng-model="titleMapValues[$index]" name="{{form.key.slice(-1)[0]}}"> <span ng-bind-html="form.titleMap[$index].name"></span></label></div><div class="help-block" sf-message="form.description"></div></div>'),e.put("decorators/bootstrap/default.html",'<div class="form-group schema-form-{{form.type}} {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false }"><label class="control-label {{form.labelHtmlClass}}" ng-class="{\'sr-only\': !showTitle()}" for="{{form.key.slice(-1)[0]}}">{{form.title}}</label> <input ng-if="!form.fieldAddonLeft && !form.fieldAddonRight" ng-show="form.key" type="{{form.type}}" step="any" sf-changed="form" placeholder="{{form.placeholder}}" class="form-control {{form.fieldHtmlClass}}" id="{{form.key.slice(-1)[0]}}" sf-field-model="" ng-disabled="form.readonly" schema-validate="form" name="{{form.key.slice(-1)[0]}}" aria-describedby="{{form.key.slice(-1)[0] + \'Status\'}}"><div ng-if="form.fieldAddonLeft || form.fieldAddonRight" ng-class="{\'input-group\': (form.fieldAddonLeft || form.fieldAddonRight)}"><span ng-if="form.fieldAddonLeft" class="input-group-addon" ng-bind-html="form.fieldAddonLeft"></span> <input ng-show="form.key" type="{{form.type}}" step="any" sf-changed="form" placeholder="{{form.placeholder}}" class="form-control {{form.fieldHtmlClass}}" id="{{form.key.slice(-1)[0]}}" sf-field-model="" ng-disabled="form.readonly" schema-validate="form" name="{{form.key.slice(-1)[0]}}" aria-describedby="{{form.key.slice(-1)[0] + \'Status\'}}"> <span ng-if="form.fieldAddonRight" class="input-group-addon" ng-bind-html="form.fieldAddonRight"></span></div><span ng-if="form.feedback !== false" class="form-control-feedback" ng-class="evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }" aria-hidden="true"></span> <span ng-if="hasError() || hasSuccess()" id="{{form.key.slice(-1)[0] + \'Status\'}}" class="sr-only">{{ hasSuccess() ? \'(success)\' : \'(error)\' }}</span><div class="help-block" sf-message="form.description"></div></div>'),e.put("decorators/bootstrap/fieldset.html",'<fieldset ng-disabled="form.readonly" class="schema-form-fieldset {{form.htmlClass}}"><legend ng-class="{\'sr-only\': !showTitle() }">{{ form.title }}</legend><div class="help-block" ng-show="form.description" ng-bind-html="form.description"></div></fieldset>'),e.put("decorators/bootstrap/help.html",'<div class="helpvalue schema-form-helpvalue {{form.htmlClass}}" ng-bind-html="form.helpvalue"></div>'),e.put("decorators/bootstrap/radio-buttons.html",'<div class="form-group schema-form-radiobuttons {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><div><label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">{{form.title}}</label></div><div class="btn-group"><label sf-field-model="replaceAll" class="btn {{ (item.value === $$value$$) ? form.style.selected || \'btn-default\' : form.style.unselected || \'btn-default\'; }}" ng-class="{ active: item.value === $$value$$ }" ng-repeat="item in form.titleMap"><input type="radio" class="{{form.fieldHtmlClass}}" sf-changed="form" style="display: none;" ng-disabled="form.readonly" sf-field-model="" schema-validate="form" ng-value="item.value" name="{{form.key.join(\'.\')}}"> <span ng-bind-html="item.name"></span></label></div><div class="help-block" sf-message="form.description"></div></div>'),e.put("decorators/bootstrap/radios-inline.html",'<div class="form-group schema-form-radios-inline {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()" sf-field-model="" schema-validate="form">{{form.title}}</label><div><label class="radio-inline" ng-repeat="item in form.titleMap"><input type="radio" class="{{form.fieldHtmlClass}}" sf-changed="form" ng-disabled="form.readonly" sf-field-model="" ng-value="item.value" name="{{form.key.join(\'.\')}}"> <span ng-bind-html="item.name"></span></label></div><div class="help-block" sf-message="form.description"></div></div>'),e.put("decorators/bootstrap/radios.html",'<div class="form-group schema-form-radios {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><label class="control-label {{form.labelHtmlClass}}" sf-field-model="" schema-validate="form" ng-show="showTitle()">{{form.title}}</label><div class="radio" ng-repeat="item in form.titleMap"><label><input type="radio" class="{{form.fieldHtmlClass}}" sf-changed="form" ng-disabled="form.readonly" sf-field-model="" ng-value="item.value" name="{{form.key.join(\'.\')}}"> <span ng-bind-html="item.name"></span></label></div><div class="help-block" sf-message="form.description"></div></div>'),e.put("decorators/bootstrap/section.html",'<div class="schema-form-section {{form.htmlClass}}"></div>'),e.put("decorators/bootstrap/select.html",'<div class="form-group {{form.htmlClass}} schema-form-select" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false}"><label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">{{form.title}}</label><select sf-field-model="" ng-disabled="form.readonly" sf-changed="form" class="form-control {{form.fieldHtmlClass}}" schema-validate="form" ng-options="item.value as item.name group by item.group for item in form.titleMap" name="{{form.key.slice(-1)[0]}}"></select><div class="help-block" sf-message="form.description"></div></div>'),e.put("decorators/bootstrap/submit.html",'<div class="form-group schema-form-submit {{form.htmlClass}}"><input type="submit" class="btn {{ form.style || \'btn-primary\' }} {{form.fieldHtmlClass}}" value="{{form.title}}" ng-disabled="form.readonly" ng-if="form.type === \'submit\'"> <button class="btn {{ form.style || \'btn-default\' }}" type="button" ng-click="buttonClick($event,form)" ng-disabled="form.readonly" ng-if="form.type !== \'submit\'"><span ng-if="form.icon" class="{{form.icon}}"></span> {{form.title}}</button></div>'),e.put("decorators/bootstrap/tabarray.html",'<div ng-init="selected = { tab: 0 }" ng-model="modelArray" schema-validate="form" sf-field-model="sf-new-array" sf-new-array="" class="clearfix schema-form-tabarray schema-form-tabarray-{{form.tabType || \'left\'}} {{form.htmlClass}}"><div ng-if="!form.tabType || form.tabType !== \'right\'" ng-class="{\'col-xs-3\': !form.tabType || form.tabType === \'left\'}"><ul class="nav nav-tabs" ng-class="{ \'tabs-left\': !form.tabType || form.tabType === \'left\'}"><li sf-field-model="ng-repeat" ng-repeat="item in $$value$$ track by $index" ng-click="$event.preventDefault() || (selected.tab = $index)" ng-class="{active: selected.tab === $index}"><a href="#">{{interp(form.title,{\'$index\':$index, value: item}) || $index}}</a></li><li ng-hide="form.readonly" ng-disabled="form.schema.maxItems <= modelArray.length" ng-click="$event.preventDefault() || (selected.tab = appendToArray().length - 1)"><a href="#"><i class="glyphicon glyphicon-plus"></i> {{ form.add || \'Add\'}}</a></li></ul></div><div ng-class="{\'col-xs-9\': !form.tabType || form.tabType === \'left\' || form.tabType === \'right\'}"><div class="tab-content {{form.fieldHtmlClass}}"><div class="tab-pane clearfix tab{{selected.tab}} index{{$index}}" sf-field-model="ng-repeat" ng-repeat="item in $$value$$ track by $index" ng-show="selected.tab === $index" ng-class="{active: selected.tab === $index}"><div schema-form-array-items=""></div><button ng-hide="form.readonly" ng-click="selected.tab = deleteFromArray($index).length - 1" ng-disabled="form.schema.minItems >= modelArray.length" type="button" class="btn {{ form.style.remove || \'btn-default\' }} pull-right"><i class="glyphicon glyphicon-trash"></i> {{ form.remove || \'Remove\'}}</button></div><div class="help-block" ng-show="(hasError() && errorMessage(schemaError())) || form.description" ng-bind-html="(hasError() && errorMessage(schemaError())) || form.description"></div></div></div></div><div ng-if="form.tabType === \'right\'" class="col-xs-3"><ul class="nav nav-tabs tabs-right"><li sf-field-model="ng-repeat" ng-repeat="item in $$value$$ track by $index" ng-click="$event.preventDefault() || (selected.tab = $index)" ng-class="{active: selected.tab === $index}"><a href="#">{{interp(form.title,{\'$index\':$index, value: item}) || $index}}</a></li><li ng-hide="form.readonly" ng-disabled="form.schema.maxItems <= modelArray.length" ng-click="$event.preventDefault() || (selected.tab = appendToArray().length - 1)"><a href="#"><i class="glyphicon glyphicon-plus"></i> {{ form.add || \'Add\'}}</a></li></ul></div>'),e.put("decorators/bootstrap/tabs.html",'<div ng-init="selected = { tab: 0 }" class="schema-form-tabs {{form.htmlClass}}"><ul class="nav nav-tabs"><li ng-repeat="tab in form.tabs" ng-disabled="form.readonly" ng-click="$event.preventDefault() || (selected.tab = $index)" ng-class="{active: selected.tab === $index}"><a href="#">{{ tab.title }}</a></li></ul><div class="tab-content {{form.fieldHtmlClass}}"></div></div>'),e.put("decorators/bootstrap/textarea.html",'<div class="form-group has-feedback {{form.htmlClass}} schema-form-textarea" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><label class="control-label {{form.labelHtmlClass}}" ng-class="{\'sr-only\': !showTitle()}" for="{{form.key.slice(-1)[0]}}">{{form.title}}</label> <textarea ng-if="!form.fieldAddonLeft && !form.fieldAddonRight" class="form-control {{form.fieldHtmlClass}}" id="{{form.key.slice(-1)[0]}}" sf-changed="form" placeholder="{{form.placeholder}}" ng-disabled="form.readonly" sf-field-model="" schema-validate="form" name="{{form.key.slice(-1)[0]}}"></textarea><div ng-if="form.fieldAddonLeft || form.fieldAddonRight" ng-class="{\'input-group\': (form.fieldAddonLeft || form.fieldAddonRight)}"><span ng-if="form.fieldAddonLeft" class="input-group-addon" ng-bind-html="form.fieldAddonLeft"></span> <textarea class="form-control {{form.fieldHtmlClass}}" id="{{form.key.slice(-1)[0]}}" sf-changed="form" placeholder="{{form.placeholder}}" ng-disabled="form.readonly" sf-field-model="" schema-validate="form" name="{{form.key.slice(-1)[0]}}"></textarea> <span ng-if="form.fieldAddonRight" class="input-group-addon" ng-bind-html="form.fieldAddonRight"></span></div><span class="help-block" sf-message="form.description"></span></div>')}]),angular.module("schemaForm").config(["schemaFormDecoratorsProvider","sfBuilderProvider","sfPathProvider",function(e,l,s){var a="decorators/bootstrap/",t=l.builders.simpleTransclusion,r=l.builders.ngModelOptions,o=l.builders.ngModel,i=l.builders.sfField,d=l.builders.condition,m=l.builders.array,n=function(e){if(e.form.tabs&&e.form.tabs.length>0){var l=e.fieldFrag.querySelector(".tab-content");e.form.tabs.forEach(function(s,a){var t=document.createElement("div");t.className="tab-pane",t.setAttribute("ng-disabled","form.readonly"),t.setAttribute("ng-show","selected.tab === "+a),t.setAttribute("ng-class","{active: selected.tab === "+a+"}");var r=e.build(s.items,e.path+".tabs["+a+"].items",e.state);t.appendChild(r),l.appendChild(t)})}},f=[i,o,r,d];e.defineDecorator("bootstrapDecorator",{textarea:{template:a+"textarea.html",builder:f},fieldset:{template:a+"fieldset.html",builder:[i,t,d]},array:{template:a+"array.html",builder:[i,r,o,m,d]},tabarray:{template:a+"tabarray.html",builder:[i,r,o,m,d]},tabs:{template:a+"tabs.html",builder:[i,r,n,d]},section:{template:a+"section.html",builder:[i,t,d]},conditional:{template:a+"section.html",builder:[i,t,d]},actions:{template:a+"actions.html",builder:f},select:{template:a+"select.html",builder:f},checkbox:{template:a+"checkbox.html",builder:f},checkboxes:{template:a+"checkboxes.html",builder:[i,r,o,m,d]},number:{template:a+"default.html",builder:f},password:{template:a+"default.html",builder:f},submit:{template:a+"submit.html",builder:f},button:{template:a+"submit.html",builder:f},radios:{template:a+"radios.html",builder:f},"radios-inline":{template:a+"radios-inline.html",builder:f},radiobuttons:{template:a+"radio-buttons.html",builder:f},help:{template:a+"help.html",builder:f},"default":{template:a+"default.html",builder:f}},[])}]);

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	angular.module("schemaForm").run(["$templateCache",function(e){e.put("directives/decorators/bootstrap/datepicker/datepicker.html",'<div class="form-group {{form.htmlClass}}" ng-class="{\'has-error\': hasError()}"><label class="control-label" ng-show="showTitle()">{{form.title}}</label><div ng-class="{\'input-group\': (form.fieldAddonLeft || form.fieldAddonRight)}"><span ng-if="form.fieldAddonLeft" class="input-group-addon" ng-bind-html="form.fieldAddonLeft"></span><input ng-show="form.key" style="background-color: white" type="text" class="form-control {{form.fieldHtmlClass}}" schema-validate="form" ng-model="$$value$$" ng-disabled="form.readonly" pick-a-date="form.pickadate" min-date="form.minDate" max-date="form.maxDate" name="{{form.key.slice(-1)[0]}}" format="form.format"><span ng-if="form.fieldAddonRight" class="input-group-addon" ng-bind-html="form.fieldAddonRight"></span></div><span class="help-block">{{ (hasError() && errorMessage(schemaError())) || form.description}}</span></div>')}]),angular.module("schemaForm").directive("pickADate",function(){var e=function(e){return angular.isString(e)||angular.isNumber(e)?new Date(e):e};return{restrict:"A",require:"ngModel",scope:{ngModel:"=",pickADate:"=",minDate:"=",maxDate:"=",format:"="},link:function(a,t,r,o){if(t.pickadate){var i={onClose:function(){t.blur()},formatSubmit:null};a.pickADate&&angular.extend(i,a.pickADate),t.pickadate(i);var n="yyyy-mm-dd",d=$.fn.pickadate.defaults.format,s=t.pickadate("picker");if(o.$formatters.push(function(e){return angular.isUndefined(e)||null===e?e:(s.set("view",e,{format:a.format||n}),s.set("highlight",e,{format:a.format||n}),s.get("highlight",d))}),o.$parsers.push(function(){return s.get("select",a.format||n)}),angular.isDefined(r.minDate))var m=a.$watch("minDate",function(a){a&&(s.set("min",e(a)),m())},!0);if(angular.isDefined(r.maxDate))var l=a.$watch("maxDate",function(a){a&&(s.set("max",e(a)),l())},!0)}}}}),angular.module("schemaForm").config(["schemaFormProvider","schemaFormDecoratorsProvider","sfPathProvider",function(e,a,t){var r=function(a,r,o){if("string"===r.type&&("date"===r.format||"date-time"===r.format)){var i=e.stdFormObj(a,r,o);return i.key=o.path,i.type="datepicker",o.lookup[t.stringify(o.path)]=i,i}};e.defaults.string.unshift(r),a.addMapping("bootstrapDecorator","datepicker","directives/decorators/bootstrap/datepicker/datepicker.html"),a.createDirective("datepicker","directives/decorators/bootstrap/datepicker/datepicker.html")}]);

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(545);
	__webpack_require__(546);
	module.exports = 'mgcrea.ngStrap';


/***/ }),
/* 545 */
/***/ (function(module, exports) {

	/**
	 * angular-strap
	 * @version v2.3.12 - 2017-01-26
	 * @link http://mgcrea.github.io/angular-strap
	 * @author Olivier Louvignes <olivier@mg-crea.com> (https://github.com/mgcrea)
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(window, document, undefined) {
	  'use strict';
	  bsCompilerService.$inject = [ '$q', '$http', '$injector', '$compile', '$controller', '$templateCache' ];
	  angular.module('mgcrea.ngStrap.typeahead', [ 'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.helpers.parseOptions' ]).provider('$typeahead', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'typeahead',
	      prefixEvent: '$typeahead',
	      placement: 'bottom-left',
	      templateUrl: 'typeahead/typeahead.tpl.html',
	      trigger: 'focus',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0,
	      minLength: 1,
	      filter: 'bsAsyncFilter',
	      limit: 6,
	      autoSelect: false,
	      comparator: '',
	      trimValue: true
	    };
	    this.$get = [ '$window', '$rootScope', '$tooltip', '$$rAF', '$timeout', function($window, $rootScope, $tooltip, $$rAF, $timeout) {
	      function TypeaheadFactory(element, controller, config) {
	        var $typeahead = {};
	        var options = angular.extend({}, defaults, config);
	        $typeahead = $tooltip(element, options);
	        var parentScope = config.scope;
	        var scope = $typeahead.$scope;
	        scope.$resetMatches = function() {
	          scope.$matches = [];
	          scope.$activeIndex = options.autoSelect ? 0 : -1;
	        };
	        scope.$resetMatches();
	        scope.$activate = function(index) {
	          scope.$$postDigest(function() {
	            $typeahead.activate(index);
	          });
	        };
	        scope.$select = function(index, evt) {
	          scope.$$postDigest(function() {
	            $typeahead.select(index);
	          });
	        };
	        scope.$isVisible = function() {
	          return $typeahead.$isVisible();
	        };
	        $typeahead.update = function(matches) {
	          scope.$matches = matches;
	          if (scope.$activeIndex >= matches.length) {
	            scope.$activeIndex = options.autoSelect ? 0 : -1;
	          }
	          safeDigest(scope);
	          $$rAF($typeahead.$applyPlacement);
	        };
	        $typeahead.activate = function(index) {
	          scope.$activeIndex = index;
	        };
	        $typeahead.select = function(index) {
	          if (index === -1) return;
	          var value = scope.$matches[index].value;
	          controller.$setViewValue(value);
	          controller.$render();
	          scope.$resetMatches();
	          if (parentScope) parentScope.$digest();
	          scope.$emit(options.prefixEvent + '.select', value, index, $typeahead);
	          if (angular.isDefined(options.onSelect) && angular.isFunction(options.onSelect)) {
	            options.onSelect(value, index, $typeahead);
	          }
	        };
	        $typeahead.$isVisible = function() {
	          if (!options.minLength || !controller) {
	            return !!scope.$matches.length;
	          }
	          return scope.$matches.length && angular.isString(controller.$viewValue) && controller.$viewValue.length >= options.minLength;
	        };
	        $typeahead.$getIndex = function(value) {
	          var index;
	          for (index = scope.$matches.length; index--; ) {
	            if (angular.equals(scope.$matches[index].value, value)) break;
	          }
	          return index;
	        };
	        $typeahead.$onMouseDown = function(evt) {
	          evt.preventDefault();
	          evt.stopPropagation();
	        };
	        $typeahead.$$updateScrollTop = function(container, index) {
	          if (index > -1 && index < container.children.length) {
	            var active = container.children[index];
	            var clientTop = active.offsetTop;
	            var clientBottom = active.offsetTop + active.clientHeight;
	            var highWatermark = container.scrollTop;
	            var lowWatermark = container.scrollTop + container.clientHeight;
	            if (clientBottom >= highWatermark && clientTop < highWatermark) {
	              container.scrollTop = Math.max(0, container.scrollTop - container.clientHeight);
	            } else if (clientBottom > lowWatermark) {
	              container.scrollTop = clientTop;
	            }
	          }
	        };
	        $typeahead.$onKeyDown = function(evt) {
	          if (!/(38|40|13)/.test(evt.keyCode)) return;
	          if ($typeahead.$isVisible() && !(evt.keyCode === 13 && scope.$activeIndex === -1)) {
	            evt.preventDefault();
	            evt.stopPropagation();
	          }
	          if (evt.keyCode === 13 && scope.$matches.length) {
	            $typeahead.select(scope.$activeIndex);
	          } else if (evt.keyCode === 38 && scope.$activeIndex > 0) {
	            scope.$activeIndex--;
	          } else if (evt.keyCode === 40 && scope.$activeIndex < scope.$matches.length - 1) {
	            scope.$activeIndex++;
	          } else if (angular.isUndefined(scope.$activeIndex)) {
	            scope.$activeIndex = 0;
	          }
	          $typeahead.$$updateScrollTop($typeahead.$element[0], scope.$activeIndex);
	          scope.$digest();
	        };
	        var show = $typeahead.show;
	        $typeahead.show = function() {
	          show();
	          $timeout(function() {
	            if ($typeahead.$element) {
	              $typeahead.$element.on('mousedown', $typeahead.$onMouseDown);
	              if (options.keyboard) {
	                if (element) element.on('keydown', $typeahead.$onKeyDown);
	              }
	            }
	          }, 0, false);
	        };
	        var hide = $typeahead.hide;
	        $typeahead.hide = function() {
	          if ($typeahead.$element) $typeahead.$element.off('mousedown', $typeahead.$onMouseDown);
	          if (options.keyboard) {
	            if (element) element.off('keydown', $typeahead.$onKeyDown);
	          }
	          if (!options.autoSelect) {
	            $typeahead.activate(-1);
	          }
	          hide();
	        };
	        return $typeahead;
	      }
	      function safeDigest(scope) {
	        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
	      }
	      TypeaheadFactory.defaults = defaults;
	      return TypeaheadFactory;
	    } ];
	  }).filter('bsAsyncFilter', [ '$filter', function($filter) {
	    return function(array, expression, comparator) {
	      if (array && angular.isFunction(array.then)) {
	        return array.then(function(results) {
	          return $filter('filter')(results, expression, comparator);
	        });
	      }
	      return $filter('filter')(array, expression, comparator);
	    };
	  } ]).directive('bsTypeahead', [ '$window', '$parse', '$q', '$typeahead', '$parseOptions', function($window, $parse, $q, $typeahead, $parseOptions) {
	    var defaults = $typeahead.defaults;
	    return {
	      restrict: 'EAC',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        element.off('change');
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'filter', 'limit', 'minLength', 'watchOptions', 'selectMode', 'autoSelect', 'comparator', 'id', 'prefixEvent', 'prefixClass' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'trimValue', 'filter' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide', 'onSelect' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        if (!element.attr('autocomplete')) element.attr('autocomplete', 'off');
	        var filter = angular.isDefined(options.filter) ? options.filter : defaults.filter;
	        var limit = options.limit || defaults.limit;
	        var comparator = options.comparator || defaults.comparator;
	        var bsOptions = attr.bsOptions;
	        if (filter) {
	          bsOptions += ' | ' + filter + ':$viewValue';
	          if (comparator) bsOptions += ':' + comparator;
	        }
	        if (limit) bsOptions += ' | limitTo:' + limit;
	        var parsedOptions = $parseOptions(bsOptions);
	        var typeahead = $typeahead(element, controller, options);
	        if (options.watchOptions) {
	          var watchedOptions = parsedOptions.$match[7].replace(/\|.+/, '').replace(/\(.*\)/g, '').trim();
	          scope.$watchCollection(watchedOptions, function(newValue, oldValue) {
	            parsedOptions.valuesFn(scope, controller).then(function(values) {
	              typeahead.update(values);
	              controller.$render();
	            });
	          });
	        }
	        scope.$watch(attr.ngModel, function(newValue, oldValue) {
	          scope.$modelValue = newValue;
	          parsedOptions.valuesFn(scope, controller).then(function(values) {
	            if (options.selectMode && !values.length && newValue.length > 0) {
	              controller.$setViewValue(controller.$viewValue.substring(0, controller.$viewValue.length - 1));
	              return;
	            }
	            if (values.length > limit) values = values.slice(0, limit);
	            typeahead.update(values);
	            controller.$render();
	          });
	        });
	        controller.$formatters.push(function(modelValue) {
	          var displayValue = parsedOptions.displayValue(modelValue);
	          if (displayValue) {
	            return displayValue;
	          }
	          if (angular.isDefined(modelValue) && typeof modelValue !== 'object') {
	            return modelValue;
	          }
	          return '';
	        });
	        controller.$render = function() {
	          if (controller.$isEmpty(controller.$viewValue)) {
	            return element.val('');
	          }
	          var index = typeahead.$getIndex(controller.$modelValue);
	          var selected = index !== -1 ? typeahead.$scope.$matches[index].label : controller.$viewValue;
	          selected = angular.isObject(selected) ? parsedOptions.displayValue(selected) : selected;
	          var value = selected ? selected.toString().replace(/<(?:.|\n)*?>/gm, '') : '';
	          var ss = element[0].selectionStart;
	          var sd = element[0].selectionEnd;
	          element.val(options.trimValue === false ? value : value.trim());
	          element[0].setSelectionRange(ss, sd);
	        };
	        scope.$on('$destroy', function() {
	          if (typeahead) typeahead.destroy();
	          options = null;
	          typeahead = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.tooltip', [ 'mgcrea.ngStrap.core', 'mgcrea.ngStrap.helpers.dimensions' ]).provider('$tooltip', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      customClass: '',
	      prefixClass: 'tooltip',
	      prefixEvent: 'tooltip',
	      container: false,
	      target: false,
	      placement: 'top',
	      templateUrl: 'tooltip/tooltip.tpl.html',
	      template: '',
	      titleTemplate: false,
	      trigger: 'hover focus',
	      keyboard: false,
	      html: false,
	      show: false,
	      title: '',
	      type: '',
	      delay: 0,
	      autoClose: false,
	      bsEnabled: true,
	      mouseDownPreventDefault: true,
	      mouseDownStopPropagation: true,
	      viewport: {
	        selector: 'body',
	        padding: 0
	      }
	    };
	    this.$get = [ '$window', '$rootScope', '$bsCompiler', '$q', '$templateCache', '$http', '$animate', '$sce', 'dimensions', '$$rAF', '$timeout', function($window, $rootScope, $bsCompiler, $q, $templateCache, $http, $animate, $sce, dimensions, $$rAF, $timeout) {
	      var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	      var isTouch = 'createTouch' in $window.document && isNative;
	      var $body = angular.element($window.document);
	      function TooltipFactory(element, config) {
	        var $tooltip = {};
	        var options = $tooltip.$options = angular.extend({}, defaults, config);
	        var promise = $tooltip.$promise = $bsCompiler.compile(options);
	        var scope = $tooltip.$scope = options.scope && options.scope.$new() || $rootScope.$new();
	        var nodeName = element[0].nodeName.toLowerCase();
	        if (options.delay && angular.isString(options.delay)) {
	          var split = options.delay.split(',').map(parseFloat);
	          options.delay = split.length > 1 ? {
	            show: split[0],
	            hide: split[1]
	          } : split[0];
	        }
	        $tooltip.$id = options.id || element.attr('id') || '';
	        if (options.title) {
	          scope.title = $sce.trustAsHtml(options.title);
	        }
	        scope.$setEnabled = function(isEnabled) {
	          scope.$$postDigest(function() {
	            $tooltip.setEnabled(isEnabled);
	          });
	        };
	        scope.$hide = function() {
	          scope.$$postDigest(function() {
	            $tooltip.hide();
	          });
	        };
	        scope.$show = function() {
	          scope.$$postDigest(function() {
	            $tooltip.show();
	          });
	        };
	        scope.$toggle = function() {
	          scope.$$postDigest(function() {
	            $tooltip.toggle();
	          });
	        };
	        $tooltip.$isShown = scope.$isShown = false;
	        var timeout;
	        var hoverState;
	        var compileData;
	        var tipElement;
	        var tipContainer;
	        var tipScope;
	        promise.then(function(data) {
	          compileData = data;
	          $tooltip.init();
	        });
	        $tooltip.init = function() {
	          if (options.delay && angular.isNumber(options.delay)) {
	            options.delay = {
	              show: options.delay,
	              hide: options.delay
	            };
	          }
	          if (options.container === 'self') {
	            tipContainer = element;
	          } else if (angular.isElement(options.container)) {
	            tipContainer = options.container;
	          } else if (options.container) {
	            tipContainer = findElement(options.container);
	          }
	          bindTriggerEvents();
	          if (options.target) {
	            options.target = angular.isElement(options.target) ? options.target : findElement(options.target);
	          }
	          if (options.show) {
	            scope.$$postDigest(function() {
	              if (options.trigger === 'focus') {
	                element[0].focus();
	              } else {
	                $tooltip.show();
	              }
	            });
	          }
	        };
	        $tooltip.destroy = function() {
	          unbindTriggerEvents();
	          destroyTipElement();
	          scope.$destroy();
	        };
	        $tooltip.enter = function() {
	          clearTimeout(timeout);
	          hoverState = 'in';
	          if (!options.delay || !options.delay.show) {
	            return $tooltip.show();
	          }
	          timeout = setTimeout(function() {
	            if (hoverState === 'in') $tooltip.show();
	          }, options.delay.show);
	        };
	        $tooltip.show = function() {
	          if (!options.bsEnabled || $tooltip.$isShown) return;
	          scope.$emit(options.prefixEvent + '.show.before', $tooltip);
	          if (angular.isDefined(options.onBeforeShow) && angular.isFunction(options.onBeforeShow)) {
	            options.onBeforeShow($tooltip);
	          }
	          var parent;
	          var after;
	          if (options.container) {
	            parent = tipContainer;
	            if (tipContainer[0].lastChild) {
	              after = angular.element(tipContainer[0].lastChild);
	            } else {
	              after = null;
	            }
	          } else {
	            parent = null;
	            after = element;
	          }
	          if (tipElement) destroyTipElement();
	          tipScope = $tooltip.$scope.$new();
	          tipElement = $tooltip.$element = compileData.link(tipScope, function(clonedElement, scope) {});
	          tipElement.css({
	            top: '-9999px',
	            left: '-9999px',
	            right: 'auto',
	            display: 'block',
	            visibility: 'hidden'
	          });
	          if (options.animation) tipElement.addClass(options.animation);
	          if (options.type) tipElement.addClass(options.prefixClass + '-' + options.type);
	          if (options.customClass) tipElement.addClass(options.customClass);
	          if (after) {
	            after.after(tipElement);
	          } else {
	            parent.prepend(tipElement);
	          }
	          $tooltip.$isShown = scope.$isShown = true;
	          safeDigest(scope);
	          $tooltip.$applyPlacement();
	          if (angular.version.minor <= 2) {
	            $animate.enter(tipElement, parent, after, enterAnimateCallback);
	          } else {
	            $animate.enter(tipElement, parent, after).then(enterAnimateCallback);
	          }
	          safeDigest(scope);
	          $$rAF(function() {
	            if (tipElement) tipElement.css({
	              visibility: 'visible'
	            });
	            if (options.keyboard) {
	              if (options.trigger !== 'focus') {
	                $tooltip.focus();
	              }
	              bindKeyboardEvents();
	            }
	          });
	          if (options.autoClose) {
	            bindAutoCloseEvents();
	          }
	        };
	        function enterAnimateCallback() {
	          scope.$emit(options.prefixEvent + '.show', $tooltip);
	          if (angular.isDefined(options.onShow) && angular.isFunction(options.onShow)) {
	            options.onShow($tooltip);
	          }
	        }
	        $tooltip.leave = function() {
	          clearTimeout(timeout);
	          hoverState = 'out';
	          if (!options.delay || !options.delay.hide) {
	            return $tooltip.hide();
	          }
	          timeout = setTimeout(function() {
	            if (hoverState === 'out') {
	              $tooltip.hide();
	            }
	          }, options.delay.hide);
	        };
	        var _blur;
	        var _tipToHide;
	        $tooltip.hide = function(blur) {
	          if (!$tooltip.$isShown) return;
	          scope.$emit(options.prefixEvent + '.hide.before', $tooltip);
	          if (angular.isDefined(options.onBeforeHide) && angular.isFunction(options.onBeforeHide)) {
	            options.onBeforeHide($tooltip);
	          }
	          _blur = blur;
	          _tipToHide = tipElement;
	          if (tipElement !== null) {
	            if (angular.version.minor <= 2) {
	              $animate.leave(tipElement, leaveAnimateCallback);
	            } else {
	              $animate.leave(tipElement).then(leaveAnimateCallback);
	            }
	          }
	          $tooltip.$isShown = scope.$isShown = false;
	          safeDigest(scope);
	          if (options.keyboard && tipElement !== null) {
	            unbindKeyboardEvents();
	          }
	          if (options.autoClose && tipElement !== null) {
	            unbindAutoCloseEvents();
	          }
	        };
	        function leaveAnimateCallback() {
	          scope.$emit(options.prefixEvent + '.hide', $tooltip);
	          if (angular.isDefined(options.onHide) && angular.isFunction(options.onHide)) {
	            options.onHide($tooltip);
	          }
	          if (tipElement === _tipToHide) {
	            if (_blur && options.trigger === 'focus') {
	              return element[0].blur();
	            }
	            destroyTipElement();
	          }
	        }
	        $tooltip.toggle = function(evt) {
	          if (evt) {
	            evt.preventDefault();
	          }
	          if ($tooltip.$isShown) {
	            $tooltip.leave();
	          } else {
	            $tooltip.enter();
	          }
	        };
	        $tooltip.focus = function() {
	          tipElement[0].focus();
	        };
	        $tooltip.setEnabled = function(isEnabled) {
	          options.bsEnabled = isEnabled;
	        };
	        $tooltip.setViewport = function(viewport) {
	          options.viewport = viewport;
	        };
	        $tooltip.$applyPlacement = function() {
	          if (!tipElement) return;
	          var placement = options.placement;
	          var autoToken = /\s?auto?\s?/i;
	          var autoPlace = autoToken.test(placement);
	          if (autoPlace) {
	            placement = placement.replace(autoToken, '') || defaults.placement;
	          }
	          tipElement.addClass(options.placement);
	          var elementPosition = getPosition();
	          var tipWidth = tipElement.prop('offsetWidth');
	          var tipHeight = tipElement.prop('offsetHeight');
	          $tooltip.$viewport = options.viewport && findElement(options.viewport.selector || options.viewport);
	          if (autoPlace) {
	            var originalPlacement = placement;
	            var viewportPosition = getPosition($tooltip.$viewport);
	            if (/bottom/.test(originalPlacement) && elementPosition.bottom + tipHeight > viewportPosition.bottom) {
	              placement = originalPlacement.replace('bottom', 'top');
	            } else if (/top/.test(originalPlacement) && elementPosition.top - tipHeight < viewportPosition.top) {
	              placement = originalPlacement.replace('top', 'bottom');
	            }
	            if (/left/.test(originalPlacement) && elementPosition.left - tipWidth < viewportPosition.left) {
	              placement = placement.replace('left', 'right');
	            } else if (/right/.test(originalPlacement) && elementPosition.right + tipWidth > viewportPosition.width) {
	              placement = placement.replace('right', 'left');
	            }
	            tipElement.removeClass(originalPlacement).addClass(placement);
	          }
	          var tipPosition = getCalculatedOffset(placement, elementPosition, tipWidth, tipHeight);
	          applyPlacement(tipPosition, placement);
	        };
	        $tooltip.$onKeyUp = function(evt) {
	          if (evt.which === 27 && $tooltip.$isShown) {
	            $tooltip.hide();
	            evt.stopPropagation();
	          }
	        };
	        $tooltip.$onFocusKeyUp = function(evt) {
	          if (evt.which === 27) {
	            element[0].blur();
	            evt.stopPropagation();
	          }
	        };
	        $tooltip.$onFocusElementMouseDown = function(evt) {
	          if (options.mouseDownPreventDefault) {
	            evt.preventDefault();
	          }
	          if (options.mouseDownStopPropagation) {
	            evt.stopPropagation();
	          }
	          if ($tooltip.$isShown) {
	            element[0].blur();
	          } else {
	            element[0].focus();
	          }
	        };
	        function bindTriggerEvents() {
	          var triggers = options.trigger.split(' ');
	          angular.forEach(triggers, function(trigger) {
	            if (trigger === 'click' || trigger === 'contextmenu') {
	              element.on(trigger, $tooltip.toggle);
	            } else if (trigger !== 'manual') {
	              element.on(trigger === 'hover' ? 'mouseenter' : 'focus', $tooltip.enter);
	              element.on(trigger === 'hover' ? 'mouseleave' : 'blur', $tooltip.leave);
	              if (nodeName === 'button' && trigger !== 'hover') {
	                element.on(isTouch ? 'touchstart' : 'mousedown', $tooltip.$onFocusElementMouseDown);
	              }
	            }
	          });
	        }
	        function unbindTriggerEvents() {
	          var triggers = options.trigger.split(' ');
	          for (var i = triggers.length; i--; ) {
	            var trigger = triggers[i];
	            if (trigger === 'click' || trigger === 'contextmenu') {
	              element.off(trigger, $tooltip.toggle);
	            } else if (trigger !== 'manual') {
	              element.off(trigger === 'hover' ? 'mouseenter' : 'focus', $tooltip.enter);
	              element.off(trigger === 'hover' ? 'mouseleave' : 'blur', $tooltip.leave);
	              if (nodeName === 'button' && trigger !== 'hover') {
	                element.off(isTouch ? 'touchstart' : 'mousedown', $tooltip.$onFocusElementMouseDown);
	              }
	            }
	          }
	        }
	        function bindKeyboardEvents() {
	          if (options.trigger !== 'focus') {
	            tipElement.on('keyup', $tooltip.$onKeyUp);
	          } else {
	            element.on('keyup', $tooltip.$onFocusKeyUp);
	          }
	        }
	        function unbindKeyboardEvents() {
	          if (options.trigger !== 'focus') {
	            tipElement.off('keyup', $tooltip.$onKeyUp);
	          } else {
	            element.off('keyup', $tooltip.$onFocusKeyUp);
	          }
	        }
	        var _autoCloseEventsBinded = false;
	        function bindAutoCloseEvents() {
	          $timeout(function() {
	            tipElement.on('click', stopEventPropagation);
	            $body.on('click', $tooltip.hide);
	            _autoCloseEventsBinded = true;
	          }, 0, false);
	        }
	        function unbindAutoCloseEvents() {
	          if (_autoCloseEventsBinded) {
	            tipElement.off('click', stopEventPropagation);
	            $body.off('click', $tooltip.hide);
	            _autoCloseEventsBinded = false;
	          }
	        }
	        function stopEventPropagation(event) {
	          event.stopPropagation();
	        }
	        function getPosition($element) {
	          $element = $element || (options.target || element);
	          var el = $element[0];
	          var isBody = el.tagName === 'BODY';
	          var elRect = el.getBoundingClientRect();
	          var rect = {};
	          for (var p in elRect) {
	            rect[p] = elRect[p];
	          }
	          if (rect.width === null) {
	            rect = angular.extend({}, rect, {
	              width: elRect.right - elRect.left,
	              height: elRect.bottom - elRect.top
	            });
	          }
	          var elOffset = isBody ? {
	            top: 0,
	            left: 0
	          } : dimensions.offset(el);
	          var scroll = {
	            scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.prop('scrollTop') || 0
	          };
	          var outerDims = isBody ? {
	            width: document.documentElement.clientWidth,
	            height: $window.innerHeight
	          } : null;
	          return angular.extend({}, rect, scroll, outerDims, elOffset);
	        }
	        function getCalculatedOffset(placement, position, actualWidth, actualHeight) {
	          var offset;
	          var split = placement.split('-');
	          switch (split[0]) {
	           case 'right':
	            offset = {
	              top: position.top + position.height / 2 - actualHeight / 2,
	              left: position.left + position.width
	            };
	            break;
	
	           case 'bottom':
	            offset = {
	              top: position.top + position.height,
	              left: position.left + position.width / 2 - actualWidth / 2
	            };
	            break;
	
	           case 'left':
	            offset = {
	              top: position.top + position.height / 2 - actualHeight / 2,
	              left: position.left - actualWidth
	            };
	            break;
	
	           default:
	            offset = {
	              top: position.top - actualHeight,
	              left: position.left + position.width / 2 - actualWidth / 2
	            };
	            break;
	          }
	          if (!split[1]) {
	            return offset;
	          }
	          if (split[0] === 'top' || split[0] === 'bottom') {
	            switch (split[1]) {
	             case 'left':
	              offset.left = position.left;
	              break;
	
	             case 'right':
	              offset.left = position.left + position.width - actualWidth;
	              break;
	
	             default:
	              break;
	            }
	          } else if (split[0] === 'left' || split[0] === 'right') {
	            switch (split[1]) {
	             case 'top':
	              offset.top = position.top - actualHeight + position.height;
	              break;
	
	             case 'bottom':
	              offset.top = position.top;
	              break;
	
	             default:
	              break;
	            }
	          }
	          return offset;
	        }
	        function applyPlacement(offset, placement) {
	          var tip = tipElement[0];
	          var width = tip.offsetWidth;
	          var height = tip.offsetHeight;
	          var marginTop = parseInt(dimensions.css(tip, 'margin-top'), 10);
	          var marginLeft = parseInt(dimensions.css(tip, 'margin-left'), 10);
	          if (isNaN(marginTop)) marginTop = 0;
	          if (isNaN(marginLeft)) marginLeft = 0;
	          offset.top = offset.top + marginTop;
	          offset.left = offset.left + marginLeft;
	          dimensions.setOffset(tip, angular.extend({
	            using: function(props) {
	              tipElement.css({
	                top: Math.round(props.top) + 'px',
	                left: Math.round(props.left) + 'px',
	                right: ''
	              });
	            }
	          }, offset), 0);
	          var actualWidth = tip.offsetWidth;
	          var actualHeight = tip.offsetHeight;
	          if (placement === 'top' && actualHeight !== height) {
	            offset.top = offset.top + height - actualHeight;
	          }
	          if (/top-left|top-right|bottom-left|bottom-right/.test(placement)) return;
	          var delta = getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
	          if (delta.left) {
	            offset.left += delta.left;
	          } else {
	            offset.top += delta.top;
	          }
	          dimensions.setOffset(tip, offset);
	          if (/top|right|bottom|left/.test(placement)) {
	            var isVertical = /top|bottom/.test(placement);
	            var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
	            var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';
	            replaceArrow(arrowDelta, tip[arrowOffsetPosition], isVertical);
	          }
	        }
	        function getViewportAdjustedDelta(placement, position, actualWidth, actualHeight) {
	          var delta = {
	            top: 0,
	            left: 0
	          };
	          if (!$tooltip.$viewport) return delta;
	          var viewportPadding = options.viewport && options.viewport.padding || 0;
	          var viewportDimensions = getPosition($tooltip.$viewport);
	          if (/right|left/.test(placement)) {
	            var topEdgeOffset = position.top - viewportPadding - viewportDimensions.scroll;
	            var bottomEdgeOffset = position.top + viewportPadding - viewportDimensions.scroll + actualHeight;
	            if (topEdgeOffset < viewportDimensions.top) {
	              delta.top = viewportDimensions.top - topEdgeOffset;
	            } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
	              delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
	            }
	          } else {
	            var leftEdgeOffset = position.left - viewportPadding;
	            var rightEdgeOffset = position.left + viewportPadding + actualWidth;
	            if (leftEdgeOffset < viewportDimensions.left) {
	              delta.left = viewportDimensions.left - leftEdgeOffset;
	            } else if (rightEdgeOffset > viewportDimensions.right) {
	              delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
	            }
	          }
	          return delta;
	        }
	        function replaceArrow(delta, dimension, isHorizontal) {
	          var $arrow = findElement('.tooltip-arrow, .arrow', tipElement[0]);
	          $arrow.css(isHorizontal ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isHorizontal ? 'top' : 'left', '');
	        }
	        function destroyTipElement() {
	          clearTimeout(timeout);
	          if ($tooltip.$isShown && tipElement !== null) {
	            if (options.autoClose) {
	              unbindAutoCloseEvents();
	            }
	            if (options.keyboard) {
	              unbindKeyboardEvents();
	            }
	          }
	          if (tipScope) {
	            tipScope.$destroy();
	            tipScope = null;
	          }
	          if (tipElement) {
	            tipElement.remove();
	            tipElement = $tooltip.$element = null;
	          }
	        }
	        return $tooltip;
	      }
	      function safeDigest(scope) {
	        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
	      }
	      function findElement(query, element) {
	        return angular.element((element || document).querySelectorAll(query));
	      }
	      return TooltipFactory;
	    } ];
	  }).directive('bsTooltip', [ '$window', '$location', '$sce', '$parse', '$tooltip', '$$rAF', function($window, $location, $sce, $parse, $tooltip, $$rAF) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr, transclusion) {
	        var tooltip;
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'titleTemplate', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'backdropAnimation', 'type', 'customClass', 'id' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
	            options[key] = false;
	          }
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        var dataTarget = element.attr('data-target');
	        if (angular.isDefined(dataTarget)) {
	          if (falseValueRegExp.test(dataTarget)) {
	            options.target = false;
	          } else {
	            options.target = dataTarget;
	          }
	        }
	        if (!scope.hasOwnProperty('title')) {
	          scope.title = '';
	        }
	        attr.$observe('title', function(newValue) {
	          if (angular.isDefined(newValue) || !scope.hasOwnProperty('title')) {
	            var oldValue = scope.title;
	            scope.title = $sce.trustAsHtml(newValue);
	            if (angular.isDefined(oldValue)) {
	              $$rAF(function() {
	                if (tooltip) tooltip.$applyPlacement();
	              });
	            }
	          }
	        });
	        attr.$observe('disabled', function(newValue) {
	          if (newValue && tooltip.$isShown) {
	            tooltip.hide();
	          }
	        });
	        if (attr.bsTooltip) {
	          scope.$watch(attr.bsTooltip, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.title = newValue;
	            }
	            if (angular.isDefined(oldValue)) {
	              $$rAF(function() {
	                if (tooltip) tooltip.$applyPlacement();
	              });
	            }
	          }, true);
	        }
	        if (attr.bsShow) {
	          scope.$watch(attr.bsShow, function(newValue, oldValue) {
	            if (!tooltip || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(tooltip),?/i);
	            if (newValue === true) {
	              tooltip.show();
	            } else {
	              tooltip.hide();
	            }
	          });
	        }
	        if (attr.bsEnabled) {
	          scope.$watch(attr.bsEnabled, function(newValue, oldValue) {
	            if (!tooltip || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|1|,?(tooltip),?/i);
	            if (newValue === false) {
	              tooltip.setEnabled(false);
	            } else {
	              tooltip.setEnabled(true);
	            }
	          });
	        }
	        if (attr.viewport) {
	          scope.$watch(attr.viewport, function(newValue) {
	            if (!tooltip || !angular.isDefined(newValue)) return;
	            tooltip.setViewport(newValue);
	          });
	        }
	        tooltip = $tooltip(element, options);
	        scope.$on('$destroy', function() {
	          if (tooltip) tooltip.destroy();
	          options = null;
	          tooltip = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.timepicker', [ 'mgcrea.ngStrap.helpers.dateParser', 'mgcrea.ngStrap.helpers.dateFormatter', 'mgcrea.ngStrap.tooltip' ]).provider('$timepicker', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      defaultDate: 'auto',
	      prefixClass: 'timepicker',
	      placement: 'bottom-left',
	      templateUrl: 'timepicker/timepicker.tpl.html',
	      trigger: 'focus',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0,
	      useNative: true,
	      timeType: 'date',
	      timeFormat: 'shortTime',
	      timezone: null,
	      modelTimeFormat: null,
	      autoclose: false,
	      minTime: -Infinity,
	      maxTime: +Infinity,
	      length: 5,
	      hourStep: 1,
	      minuteStep: 5,
	      secondStep: 5,
	      roundDisplay: false,
	      iconUp: 'glyphicon glyphicon-chevron-up',
	      iconDown: 'glyphicon glyphicon-chevron-down',
	      arrowBehavior: 'pager'
	    };
	    this.$get = [ '$window', '$document', '$rootScope', '$sce', '$dateFormatter', '$tooltip', '$timeout', function($window, $document, $rootScope, $sce, $dateFormatter, $tooltip, $timeout) {
	      var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	      var isTouch = 'createTouch' in $window.document && isNative;
	      if (!defaults.lang) {
	        defaults.lang = $dateFormatter.getDefaultLocale();
	      }
	      function timepickerFactory(element, controller, config) {
	        var $timepicker = $tooltip(element, angular.extend({}, defaults, config));
	        var parentScope = config.scope;
	        var options = $timepicker.$options;
	        var scope = $timepicker.$scope;
	        var lang = options.lang;
	        var formatDate = function(date, format, timezone) {
	          return $dateFormatter.formatDate(date, format, lang, timezone);
	        };
	        function floorMinutes(time) {
	          var coeff = 1e3 * 60 * options.minuteStep;
	          return new Date(Math.floor(time.getTime() / coeff) * coeff);
	        }
	        var selectedIndex = 0;
	        var defaultDate = options.roundDisplay ? floorMinutes(new Date()) : new Date();
	        var startDate = controller.$dateValue || defaultDate;
	        var viewDate = {
	          hour: startDate.getHours(),
	          meridian: startDate.getHours() < 12,
	          minute: startDate.getMinutes(),
	          second: startDate.getSeconds(),
	          millisecond: startDate.getMilliseconds()
	        };
	        var format = $dateFormatter.getDatetimeFormat(options.timeFormat, lang);
	        var hoursFormat = $dateFormatter.hoursFormat(format);
	        var timeSeparator = $dateFormatter.timeSeparator(format);
	        var minutesFormat = $dateFormatter.minutesFormat(format);
	        var secondsFormat = $dateFormatter.secondsFormat(format);
	        var showSeconds = $dateFormatter.showSeconds(format);
	        var showAM = $dateFormatter.showAM(format);
	        scope.$iconUp = options.iconUp;
	        scope.$iconDown = options.iconDown;
	        scope.$select = function(date, index) {
	          $timepicker.select(date, index);
	        };
	        scope.$moveIndex = function(value, index) {
	          $timepicker.$moveIndex(value, index);
	        };
	        scope.$switchMeridian = function(date) {
	          $timepicker.switchMeridian(date);
	        };
	        $timepicker.update = function(date) {
	          if (angular.isDate(date) && !isNaN(date.getTime())) {
	            $timepicker.$date = date;
	            angular.extend(viewDate, {
	              hour: date.getHours(),
	              minute: date.getMinutes(),
	              second: date.getSeconds(),
	              millisecond: date.getMilliseconds()
	            });
	            $timepicker.$build();
	          } else if (!$timepicker.$isBuilt) {
	            $timepicker.$build();
	          }
	        };
	        $timepicker.select = function(date, index, keep) {
	          if (!controller.$dateValue || isNaN(controller.$dateValue.getTime())) {
	            controller.$dateValue = options.defaultDate === 'today' ? new Date() : new Date(1970, 0, 1);
	          }
	          if (!angular.isDate(date)) date = new Date(date);
	          if (index === 0) controller.$dateValue.setHours(date.getHours()); else if (index === 1) controller.$dateValue.setMinutes(date.getMinutes()); else if (index === 2) controller.$dateValue.setSeconds(date.getSeconds());
	          controller.$setViewValue(angular.copy(controller.$dateValue));
	          controller.$render();
	          if (options.autoclose && !keep) {
	            $timeout(function() {
	              $timepicker.hide(true);
	            });
	          }
	        };
	        $timepicker.switchMeridian = function(date) {
	          if (!controller.$dateValue || isNaN(controller.$dateValue.getTime())) {
	            return;
	          }
	          var hours = (date || controller.$dateValue).getHours();
	          controller.$dateValue.setHours(hours < 12 ? hours + 12 : hours - 12);
	          controller.$setViewValue(angular.copy(controller.$dateValue));
	          controller.$render();
	        };
	        $timepicker.$build = function() {
	          var i;
	          var midIndex = scope.midIndex = parseInt(options.length / 2, 10);
	          var hours = [];
	          var hour;
	          for (i = 0; i < options.length; i++) {
	            hour = new Date(1970, 0, 1, viewDate.hour - (midIndex - i) * options.hourStep);
	            hours.push({
	              date: hour,
	              label: formatDate(hour, hoursFormat),
	              selected: $timepicker.$date && $timepicker.$isSelected(hour, 0),
	              disabled: $timepicker.$isDisabled(hour, 0)
	            });
	          }
	          var minutes = [];
	          var minute;
	          for (i = 0; i < options.length; i++) {
	            minute = new Date(1970, 0, 1, 0, viewDate.minute - (midIndex - i) * options.minuteStep);
	            minutes.push({
	              date: minute,
	              label: formatDate(minute, minutesFormat),
	              selected: $timepicker.$date && $timepicker.$isSelected(minute, 1),
	              disabled: $timepicker.$isDisabled(minute, 1)
	            });
	          }
	          var seconds = [];
	          var second;
	          for (i = 0; i < options.length; i++) {
	            second = new Date(1970, 0, 1, 0, 0, viewDate.second - (midIndex - i) * options.secondStep);
	            seconds.push({
	              date: second,
	              label: formatDate(second, secondsFormat),
	              selected: $timepicker.$date && $timepicker.$isSelected(second, 2),
	              disabled: $timepicker.$isDisabled(second, 2)
	            });
	          }
	          var rows = [];
	          for (i = 0; i < options.length; i++) {
	            if (showSeconds) {
	              rows.push([ hours[i], minutes[i], seconds[i] ]);
	            } else {
	              rows.push([ hours[i], minutes[i] ]);
	            }
	          }
	          scope.rows = rows;
	          scope.showSeconds = showSeconds;
	          scope.showAM = showAM;
	          scope.isAM = ($timepicker.$date || hours[midIndex].date).getHours() < 12;
	          scope.timeSeparator = timeSeparator;
	          $timepicker.$isBuilt = true;
	        };
	        $timepicker.$isSelected = function(date, index) {
	          if (!$timepicker.$date) return false; else if (index === 0) {
	            return date.getHours() === $timepicker.$date.getHours();
	          } else if (index === 1) {
	            return date.getMinutes() === $timepicker.$date.getMinutes();
	          } else if (index === 2) {
	            return date.getSeconds() === $timepicker.$date.getSeconds();
	          }
	        };
	        $timepicker.$isDisabled = function(date, index) {
	          var selectedTime;
	          if (index === 0) {
	            selectedTime = date.getTime() + viewDate.minute * 6e4 + viewDate.second * 1e3;
	          } else if (index === 1) {
	            selectedTime = date.getTime() + viewDate.hour * 36e5 + viewDate.second * 1e3;
	          } else if (index === 2) {
	            selectedTime = date.getTime() + viewDate.hour * 36e5 + viewDate.minute * 6e4;
	          }
	          return selectedTime < options.minTime * 1 || selectedTime > options.maxTime * 1;
	        };
	        scope.$arrowAction = function(value, index) {
	          if (options.arrowBehavior === 'picker') {
	            $timepicker.$setTimeByStep(value, index);
	          } else {
	            $timepicker.$moveIndex(value, index);
	          }
	        };
	        $timepicker.$setTimeByStep = function(value, index) {
	          var newDate = new Date($timepicker.$date || startDate);
	          var hours = newDate.getHours();
	          var minutes = newDate.getMinutes();
	          var seconds = newDate.getSeconds();
	          if (index === 0) {
	            newDate.setHours(hours - parseInt(options.hourStep, 10) * value);
	          } else if (index === 1) {
	            newDate.setMinutes(minutes - parseInt(options.minuteStep, 10) * value);
	          } else if (index === 2) {
	            newDate.setSeconds(seconds - parseInt(options.secondStep, 10) * value);
	          }
	          $timepicker.select(newDate, index, true);
	        };
	        $timepicker.$moveIndex = function(value, index) {
	          var targetDate;
	          if (index === 0) {
	            targetDate = new Date(1970, 0, 1, viewDate.hour + value * options.length, viewDate.minute, viewDate.second);
	            angular.extend(viewDate, {
	              hour: targetDate.getHours()
	            });
	          } else if (index === 1) {
	            targetDate = new Date(1970, 0, 1, viewDate.hour, viewDate.minute + value * options.length * options.minuteStep, viewDate.second);
	            angular.extend(viewDate, {
	              minute: targetDate.getMinutes()
	            });
	          } else if (index === 2) {
	            targetDate = new Date(1970, 0, 1, viewDate.hour, viewDate.minute, viewDate.second + value * options.length * options.secondStep);
	            angular.extend(viewDate, {
	              second: targetDate.getSeconds()
	            });
	          }
	          $timepicker.$build();
	        };
	        $timepicker.$onMouseDown = function(evt) {
	          if (evt.target.nodeName.toLowerCase() !== 'input') evt.preventDefault();
	          evt.stopPropagation();
	          if (isTouch) {
	            var targetEl = angular.element(evt.target);
	            if (targetEl[0].nodeName.toLowerCase() !== 'button') {
	              targetEl = targetEl.parent();
	            }
	            targetEl.triggerHandler('click');
	          }
	        };
	        $timepicker.$onKeyDown = function(evt) {
	          if (!/(38|37|39|40|13)/.test(evt.keyCode) || evt.shiftKey || evt.altKey) return;
	          evt.preventDefault();
	          evt.stopPropagation();
	          if (evt.keyCode === 13) {
	            $timepicker.hide(true);
	            return;
	          }
	          var newDate = new Date($timepicker.$date);
	          var hours = newDate.getHours();
	          var hoursLength = formatDate(newDate, hoursFormat).length;
	          var minutes = newDate.getMinutes();
	          var minutesLength = formatDate(newDate, minutesFormat).length;
	          var seconds = newDate.getSeconds();
	          var secondsLength = formatDate(newDate, secondsFormat).length;
	          var sepLength = 1;
	          var lateralMove = /(37|39)/.test(evt.keyCode);
	          var count = 2 + showSeconds * 1 + showAM * 1;
	          if (lateralMove) {
	            if (evt.keyCode === 37) selectedIndex = selectedIndex < 1 ? count - 1 : selectedIndex - 1; else if (evt.keyCode === 39) selectedIndex = selectedIndex < count - 1 ? selectedIndex + 1 : 0;
	          }
	          var selectRange = [ 0, hoursLength ];
	          var incr = 0;
	          if (evt.keyCode === 38) incr = -1;
	          if (evt.keyCode === 40) incr = +1;
	          var isSeconds = selectedIndex === 2 && showSeconds;
	          var isMeridian = selectedIndex === 2 && !showSeconds || selectedIndex === 3 && showSeconds;
	          if (selectedIndex === 0) {
	            newDate.setHours(hours + incr * parseInt(options.hourStep, 10));
	            hoursLength = formatDate(newDate, hoursFormat).length;
	            selectRange = [ 0, hoursLength ];
	          } else if (selectedIndex === 1) {
	            newDate.setMinutes(minutes + incr * parseInt(options.minuteStep, 10));
	            minutesLength = formatDate(newDate, minutesFormat).length;
	            selectRange = [ hoursLength + sepLength, minutesLength ];
	          } else if (isSeconds) {
	            newDate.setSeconds(seconds + incr * parseInt(options.secondStep, 10));
	            secondsLength = formatDate(newDate, secondsFormat).length;
	            selectRange = [ hoursLength + sepLength + minutesLength + sepLength, secondsLength ];
	          } else if (isMeridian) {
	            if (!lateralMove) $timepicker.switchMeridian();
	            selectRange = [ hoursLength + sepLength + minutesLength + sepLength + (secondsLength + sepLength) * showSeconds, 2 ];
	          }
	          $timepicker.select(newDate, selectedIndex, true);
	          createSelection(selectRange[0], selectRange[1]);
	          parentScope.$digest();
	        };
	        function createSelection(start, length) {
	          var end = start + length;
	          if (element[0].createTextRange) {
	            var selRange = element[0].createTextRange();
	            selRange.collapse(true);
	            selRange.moveStart('character', start);
	            selRange.moveEnd('character', end);
	            selRange.select();
	          } else if (element[0].setSelectionRange) {
	            element[0].setSelectionRange(start, end);
	          } else if (angular.isUndefined(element[0].selectionStart)) {
	            element[0].selectionStart = start;
	            element[0].selectionEnd = end;
	          }
	        }
	        function focusElement() {
	          element[0].focus();
	        }
	        var _init = $timepicker.init;
	        $timepicker.init = function() {
	          if (isNative && options.useNative) {
	            element.prop('type', 'time');
	            element.css('-webkit-appearance', 'textfield');
	            return;
	          } else if (isTouch) {
	            element.prop('type', 'text');
	            element.attr('readonly', 'true');
	            element.on('click', focusElement);
	          }
	          _init();
	        };
	        var _destroy = $timepicker.destroy;
	        $timepicker.destroy = function() {
	          if (isNative && options.useNative) {
	            element.off('click', focusElement);
	          }
	          _destroy();
	        };
	        var _show = $timepicker.show;
	        $timepicker.show = function() {
	          if (!isTouch && element.attr('readonly') || element.attr('disabled')) return;
	          _show();
	          $timeout(function() {
	            if ($timepicker.$element) $timepicker.$element.on(isTouch ? 'touchstart' : 'mousedown', $timepicker.$onMouseDown);
	            if (options.keyboard) {
	              if (element) element.on('keydown', $timepicker.$onKeyDown);
	            }
	          }, 0, false);
	        };
	        var _hide = $timepicker.hide;
	        $timepicker.hide = function(blur) {
	          if (!$timepicker.$isShown) return;
	          if ($timepicker.$element) $timepicker.$element.off(isTouch ? 'touchstart' : 'mousedown', $timepicker.$onMouseDown);
	          if (options.keyboard) {
	            if (element) element.off('keydown', $timepicker.$onKeyDown);
	          }
	          _hide(blur);
	        };
	        return $timepicker;
	      }
	      timepickerFactory.defaults = defaults;
	      return timepickerFactory;
	    } ];
	  }).directive('bsTimepicker', [ '$window', '$parse', '$q', '$dateFormatter', '$dateParser', '$timepicker', function($window, $parse, $q, $dateFormatter, $dateParser, $timepicker) {
	    var defaults = $timepicker.defaults;
	    var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	    return {
	      restrict: 'EAC',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'autoclose', 'timeType', 'timeFormat', 'timezone', 'modelTimeFormat', 'useNative', 'hourStep', 'minuteStep', 'secondStep', 'length', 'arrowBehavior', 'iconUp', 'iconDown', 'roundDisplay', 'id', 'prefixClass', 'prefixEvent', 'defaultDate' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'autoclose', 'useNative', 'roundDisplay' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
	            options[key] = false;
	          }
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        if (isNative && (options.useNative || defaults.useNative)) options.timeFormat = 'HH:mm';
	        var timepicker = $timepicker(element, controller, options);
	        options = timepicker.$options;
	        var lang = options.lang;
	        var formatDate = function(date, format, timezone) {
	          return $dateFormatter.formatDate(date, format, lang, timezone);
	        };
	        if (attr.bsShow) {
	          scope.$watch(attr.bsShow, function(newValue, oldValue) {
	            if (!timepicker || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(timepicker),?/i);
	            if (newValue === true) {
	              timepicker.show();
	            } else {
	              timepicker.hide();
	            }
	          });
	        }
	        var dateParser = $dateParser({
	          format: options.timeFormat,
	          lang: lang
	        });
	        angular.forEach([ 'minTime', 'maxTime' ], function(key) {
	          if (angular.isDefined(attr[key])) {
	            attr.$observe(key, function(newValue) {
	              timepicker.$options[key] = dateParser.getTimeForAttribute(key, newValue);
	              if (!isNaN(timepicker.$options[key])) timepicker.$build();
	              validateAgainstMinMaxTime(controller.$dateValue);
	            });
	          }
	        });
	        scope.$watch(attr.ngModel, function(newValue, oldValue) {
	          timepicker.update(controller.$dateValue);
	        }, true);
	        function validateAgainstMinMaxTime(parsedTime) {
	          if (!angular.isDate(parsedTime)) return;
	          var isMinValid = isNaN(options.minTime) || new Date(parsedTime.getTime()).setFullYear(1970, 0, 1) >= options.minTime;
	          var isMaxValid = isNaN(options.maxTime) || new Date(parsedTime.getTime()).setFullYear(1970, 0, 1) <= options.maxTime;
	          var isValid = isMinValid && isMaxValid;
	          controller.$setValidity('date', isValid);
	          controller.$setValidity('min', isMinValid);
	          controller.$setValidity('max', isMaxValid);
	          if (!isValid) {
	            return;
	          }
	          controller.$dateValue = parsedTime;
	        }
	        controller.$parsers.unshift(function(viewValue) {
	          var date;
	          if (!viewValue) {
	            controller.$setValidity('date', true);
	            return null;
	          }
	          var parsedTime = angular.isDate(viewValue) ? viewValue : dateParser.parse(viewValue, controller.$dateValue);
	          if (!parsedTime || isNaN(parsedTime.getTime())) {
	            controller.$setValidity('date', false);
	            return undefined;
	          }
	          validateAgainstMinMaxTime(parsedTime);
	          if (options.timeType === 'string') {
	            date = dateParser.timezoneOffsetAdjust(parsedTime, options.timezone, true);
	            return formatDate(date, options.modelTimeFormat || options.timeFormat);
	          }
	          date = dateParser.timezoneOffsetAdjust(controller.$dateValue, options.timezone, true);
	          if (options.timeType === 'number') {
	            return date.getTime();
	          } else if (options.timeType === 'unix') {
	            return date.getTime() / 1e3;
	          } else if (options.timeType === 'iso') {
	            return date.toISOString();
	          }
	          return new Date(date);
	        });
	        controller.$formatters.push(function(modelValue) {
	          var date;
	          if (angular.isUndefined(modelValue) || modelValue === null) {
	            date = NaN;
	          } else if (angular.isDate(modelValue)) {
	            date = modelValue;
	          } else if (options.timeType === 'string') {
	            date = dateParser.parse(modelValue, null, options.modelTimeFormat);
	          } else if (options.timeType === 'unix') {
	            date = new Date(modelValue * 1e3);
	          } else {
	            date = new Date(modelValue);
	          }
	          controller.$dateValue = dateParser.timezoneOffsetAdjust(date, options.timezone);
	          return getTimeFormattedString();
	        });
	        controller.$render = function() {
	          element.val(getTimeFormattedString());
	        };
	        function getTimeFormattedString() {
	          return !controller.$dateValue || isNaN(controller.$dateValue.getTime()) ? '' : formatDate(controller.$dateValue, options.timeFormat);
	        }
	        scope.$on('$destroy', function() {
	          if (timepicker) timepicker.destroy();
	          options = null;
	          timepicker = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.tab', []).provider('$tab', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      template: 'tab/tab.tpl.html',
	      navClass: 'nav-tabs',
	      activeClass: 'active'
	    };
	    var controller = this.controller = function($scope, $element, $attrs) {
	      var self = this;
	      self.$options = angular.copy(defaults);
	      angular.forEach([ 'animation', 'navClass', 'activeClass' ], function(key) {
	        if (angular.isDefined($attrs[key])) self.$options[key] = $attrs[key];
	      });
	      $scope.$navClass = self.$options.navClass;
	      $scope.$activeClass = self.$options.activeClass;
	      self.$panes = $scope.$panes = [];
	      self.$activePaneChangeListeners = self.$viewChangeListeners = [];
	      self.$push = function(pane) {
	        if (angular.isUndefined(self.$panes.$active)) {
	          $scope.$setActive(pane.name || 0);
	        }
	        self.$panes.push(pane);
	      };
	      self.$remove = function(pane) {
	        var index = self.$panes.indexOf(pane);
	        var active = self.$panes.$active;
	        var activeIndex;
	        if (angular.isString(active)) {
	          activeIndex = self.$panes.map(function(pane) {
	            return pane.name;
	          }).indexOf(active);
	        } else {
	          activeIndex = self.$panes.$active;
	        }
	        self.$panes.splice(index, 1);
	        if (index < activeIndex) {
	          activeIndex--;
	        } else if (index === activeIndex && activeIndex === self.$panes.length) {
	          activeIndex--;
	        }
	        if (activeIndex >= 0 && activeIndex < self.$panes.length) {
	          self.$setActive(self.$panes[activeIndex].name || activeIndex);
	        } else {
	          self.$setActive();
	        }
	      };
	      self.$setActive = $scope.$setActive = function(value) {
	        self.$panes.$active = value;
	        self.$activePaneChangeListeners.forEach(function(fn) {
	          fn();
	        });
	      };
	      self.$isActive = $scope.$isActive = function($pane, $index) {
	        return self.$panes.$active === $pane.name || self.$panes.$active === $index;
	      };
	    };
	    this.$get = function() {
	      var $tab = {};
	      $tab.defaults = defaults;
	      $tab.controller = controller;
	      return $tab;
	    };
	  }).directive('bsTabs', [ '$window', '$animate', '$tab', '$parse', function($window, $animate, $tab, $parse) {
	    var defaults = $tab.defaults;
	    return {
	      require: [ '?ngModel', 'bsTabs' ],
	      transclude: true,
	      scope: true,
	      controller: [ '$scope', '$element', '$attrs', $tab.controller ],
	      templateUrl: function(element, attr) {
	        return attr.template || defaults.template;
	      },
	      link: function postLink(scope, element, attrs, controllers) {
	        var ngModelCtrl = controllers[0];
	        var bsTabsCtrl = controllers[1];
	        if (ngModelCtrl) {
	          bsTabsCtrl.$activePaneChangeListeners.push(function() {
	            ngModelCtrl.$setViewValue(bsTabsCtrl.$panes.$active);
	          });
	          ngModelCtrl.$formatters.push(function(modelValue) {
	            bsTabsCtrl.$setActive(modelValue);
	            return modelValue;
	          });
	        }
	        if (attrs.bsActivePane) {
	          var parsedBsActivePane = $parse(attrs.bsActivePane);
	          bsTabsCtrl.$activePaneChangeListeners.push(function() {
	            parsedBsActivePane.assign(scope, bsTabsCtrl.$panes.$active);
	          });
	          scope.$watch(attrs.bsActivePane, function(newValue, oldValue) {
	            bsTabsCtrl.$setActive(newValue);
	          }, true);
	        }
	      }
	    };
	  } ]).directive('bsPane', [ '$window', '$animate', '$sce', function($window, $animate, $sce) {
	    return {
	      require: [ '^?ngModel', '^bsTabs' ],
	      scope: true,
	      link: function postLink(scope, element, attrs, controllers) {
	        var bsTabsCtrl = controllers[1];
	        element.addClass('tab-pane');
	        attrs.$observe('title', function(newValue, oldValue) {
	          scope.title = $sce.trustAsHtml(newValue);
	        });
	        scope.name = attrs.name;
	        if (bsTabsCtrl.$options.animation) {
	          element.addClass(bsTabsCtrl.$options.animation);
	        }
	        attrs.$observe('disabled', function(newValue, oldValue) {
	          scope.disabled = scope.$eval(newValue);
	        });
	        bsTabsCtrl.$push(scope);
	        scope.$on('$destroy', function() {
	          bsTabsCtrl.$remove(scope);
	        });
	        function render() {
	          var index = bsTabsCtrl.$panes.indexOf(scope);
	          $animate[bsTabsCtrl.$isActive(scope, index) ? 'addClass' : 'removeClass'](element, bsTabsCtrl.$options.activeClass);
	        }
	        bsTabsCtrl.$activePaneChangeListeners.push(function() {
	          render();
	        });
	        render();
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.select', [ 'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.helpers.parseOptions' ]).provider('$select', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'select',
	      prefixEvent: '$select',
	      placement: 'bottom-left',
	      templateUrl: 'select/select.tpl.html',
	      trigger: 'focus',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0,
	      multiple: false,
	      allNoneButtons: false,
	      sort: true,
	      caretHtml: '&nbsp;<span class="caret"></span>',
	      placeholder: 'Choose among the following...',
	      allText: 'All',
	      noneText: 'None',
	      maxLength: 3,
	      maxLengthHtml: 'selected',
	      iconCheckmark: 'glyphicon glyphicon-ok',
	      toggle: false
	    };
	    this.$get = [ '$window', '$document', '$rootScope', '$tooltip', '$timeout', function($window, $document, $rootScope, $tooltip, $timeout) {
	      var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	      var isTouch = 'createTouch' in $window.document && isNative;
	      function SelectFactory(element, controller, config) {
	        var $select = {};
	        var options = angular.extend({}, defaults, config);
	        $select = $tooltip(element, options);
	        var scope = $select.$scope;
	        scope.$matches = [];
	        if (options.multiple) {
	          scope.$activeIndex = [];
	        } else {
	          scope.$activeIndex = -1;
	        }
	        scope.$isMultiple = options.multiple;
	        scope.$showAllNoneButtons = options.allNoneButtons && options.multiple;
	        scope.$iconCheckmark = options.iconCheckmark;
	        scope.$allText = options.allText;
	        scope.$noneText = options.noneText;
	        scope.$activate = function(index) {
	          scope.$$postDigest(function() {
	            $select.activate(index);
	          });
	        };
	        scope.$select = function(index, evt) {
	          scope.$$postDigest(function() {
	            $select.select(index);
	          });
	        };
	        scope.$isVisible = function() {
	          return $select.$isVisible();
	        };
	        scope.$isActive = function(index) {
	          return $select.$isActive(index);
	        };
	        scope.$selectAll = function() {
	          for (var i = 0; i < scope.$matches.length; i++) {
	            if (!scope.$isActive(i)) {
	              scope.$select(i);
	            }
	          }
	        };
	        scope.$selectNone = function() {
	          for (var i = 0; i < scope.$matches.length; i++) {
	            if (scope.$isActive(i)) {
	              scope.$select(i);
	            }
	          }
	        };
	        $select.update = function(matches) {
	          scope.$matches = matches;
	          $select.$updateActiveIndex();
	        };
	        $select.activate = function(index) {
	          if (options.multiple) {
	            if ($select.$isActive(index)) {
	              scope.$activeIndex.splice(scope.$activeIndex.indexOf(index), 1);
	            } else {
	              scope.$activeIndex.push(index);
	            }
	            if (options.sort) scope.$activeIndex.sort(function(a, b) {
	              return a - b;
	            });
	          } else {
	            scope.$activeIndex = index;
	          }
	          return scope.$activeIndex;
	        };
	        $select.select = function(index) {
	          if (angular.isUndefined(index) || index < 0 || index >= scope.$matches.length) {
	            return;
	          }
	          var value = scope.$matches[index].value;
	          scope.$apply(function() {
	            $select.activate(index);
	            if (options.multiple) {
	              controller.$setViewValue(scope.$activeIndex.map(function(index) {
	                if (angular.isUndefined(scope.$matches[index])) {
	                  return null;
	                }
	                return scope.$matches[index].value;
	              }));
	            } else {
	              if (options.toggle) {
	                controller.$setViewValue(value === controller.$modelValue ? undefined : value);
	              } else {
	                controller.$setViewValue(value);
	              }
	              $select.hide();
	            }
	          });
	          scope.$emit(options.prefixEvent + '.select', value, index, $select);
	          if (angular.isDefined(options.onSelect) && angular.isFunction(options.onSelect)) {
	            options.onSelect(value, index, $select);
	          }
	        };
	        $select.$updateActiveIndex = function() {
	          if (options.multiple) {
	            if (angular.isArray(controller.$modelValue)) {
	              scope.$activeIndex = controller.$modelValue.map(function(value) {
	                return $select.$getIndex(value);
	              });
	            } else {
	              scope.$activeIndex = [];
	            }
	          } else {
	            if (angular.isDefined(controller.$modelValue) && scope.$matches.length) {
	              scope.$activeIndex = $select.$getIndex(controller.$modelValue);
	            } else {
	              scope.$activeIndex = -1;
	            }
	          }
	        };
	        $select.$isVisible = function() {
	          if (!options.minLength || !controller) {
	            return scope.$matches.length;
	          }
	          return scope.$matches.length && controller.$viewValue.length >= options.minLength;
	        };
	        $select.$isActive = function(index) {
	          if (options.multiple) {
	            return scope.$activeIndex.indexOf(index) !== -1;
	          }
	          return scope.$activeIndex === index;
	        };
	        $select.$getIndex = function(value) {
	          var index;
	          for (index = scope.$matches.length; index--; ) {
	            if (angular.equals(scope.$matches[index].value, value)) break;
	          }
	          return index;
	        };
	        $select.$onMouseDown = function(evt) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          if (isTouch) {
	            var targetEl = angular.element(evt.target);
	            var anchor;
	            if (evt.target.nodeName !== 'A') {
	              var anchorCandidate = targetEl.parent();
	              while (!anchor && anchorCandidate.length > 0) {
	                if (anchorCandidate[0].nodeName === 'A') {
	                  anchor = anchorCandidate;
	                }
	                anchorCandidate = anchorCandidate.parent();
	              }
	            }
	            if (anchor) {
	              angular.element(anchor).triggerHandler('click');
	            } else {
	              targetEl.triggerHandler('click');
	            }
	          }
	        };
	        $select.$onKeyDown = function(evt) {
	          if (!/(9|13|38|40)/.test(evt.keyCode)) return;
	          if (evt.keyCode !== 9) {
	            evt.preventDefault();
	            evt.stopPropagation();
	          }
	          if (options.multiple && evt.keyCode === 9) {
	            return $select.hide();
	          }
	          if (!options.multiple && (evt.keyCode === 13 || evt.keyCode === 9)) {
	            return $select.select(scope.$activeIndex);
	          }
	          if (!options.multiple) {
	            if (evt.keyCode === 38 && scope.$activeIndex > 0) scope.$activeIndex--; else if (evt.keyCode === 38 && scope.$activeIndex < 0) scope.$activeIndex = scope.$matches.length - 1; else if (evt.keyCode === 40 && scope.$activeIndex < scope.$matches.length - 1) scope.$activeIndex++; else if (angular.isUndefined(scope.$activeIndex)) scope.$activeIndex = 0;
	            scope.$digest();
	          }
	        };
	        $select.$isIE = function() {
	          var ua = $window.navigator.userAgent;
	          return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0;
	        };
	        $select.$selectScrollFix = function(e) {
	          if ($document[0].activeElement.tagName === 'UL') {
	            e.preventDefault();
	            e.stopImmediatePropagation();
	            e.target.focus();
	          }
	        };
	        var _show = $select.show;
	        $select.show = function() {
	          _show();
	          if (options.multiple) {
	            $select.$element.addClass('select-multiple');
	          }
	          $timeout(function() {
	            $select.$element.on(isTouch ? 'touchstart' : 'mousedown', $select.$onMouseDown);
	            if (options.keyboard) {
	              element.on('keydown', $select.$onKeyDown);
	            }
	          }, 0, false);
	        };
	        var _hide = $select.hide;
	        $select.hide = function() {
	          if (!options.multiple && angular.isUndefined(controller.$modelValue)) {
	            scope.$activeIndex = -1;
	          }
	          $select.$element.off(isTouch ? 'touchstart' : 'mousedown', $select.$onMouseDown);
	          if (options.keyboard) {
	            element.off('keydown', $select.$onKeyDown);
	          }
	          _hide(true);
	        };
	        return $select;
	      }
	      SelectFactory.defaults = defaults;
	      return SelectFactory;
	    } ];
	  }).directive('bsSelect', [ '$window', '$parse', '$q', '$select', '$parseOptions', function($window, $parse, $q, $select, $parseOptions) {
	    var defaults = $select.defaults;
	    return {
	      restrict: 'EAC',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = {
	          scope: scope,
	          placeholder: defaults.placeholder
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'placeholder', 'allNoneButtons', 'maxLength', 'maxLengthHtml', 'allText', 'noneText', 'iconCheckmark', 'autoClose', 'id', 'sort', 'caretHtml', 'prefixClass', 'prefixEvent', 'toggle' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'allNoneButtons', 'sort' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
	            options[key] = false;
	          }
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide', 'onSelect' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        var dataMultiple = element.attr('data-multiple');
	        if (angular.isDefined(dataMultiple)) {
	          if (falseValueRegExp.test(dataMultiple)) {
	            options.multiple = false;
	          } else {
	            options.multiple = dataMultiple;
	          }
	        }
	        if (element[0].nodeName.toLowerCase() === 'select') {
	          var inputEl = element;
	          inputEl.css('display', 'none');
	          element = angular.element('<button type="button" class="btn btn-default"></button>');
	          inputEl.after(element);
	        }
	        var parsedOptions = $parseOptions(attr.bsOptions);
	        var select = $select(element, controller, options);
	        if (select.$isIE()) {
	          element[0].addEventListener('blur', select.$selectScrollFix);
	        }
	        var watchedOptions = parsedOptions.$match[7].replace(/\|.+/, '').trim();
	        scope.$watch(watchedOptions, function(newValue, oldValue) {
	          parsedOptions.valuesFn(scope, controller).then(function(values) {
	            select.update(values);
	            controller.$render();
	          });
	        }, true);
	        scope.$watch(attr.ngModel, function(newValue, oldValue) {
	          select.$updateActiveIndex();
	          controller.$render();
	        }, true);
	        controller.$render = function() {
	          var selected;
	          var index;
	          if (options.multiple && angular.isArray(controller.$modelValue)) {
	            selected = controller.$modelValue.map(function(value) {
	              index = select.$getIndex(value);
	              return index !== -1 ? select.$scope.$matches[index].label : false;
	            }).filter(angular.isDefined);
	            if (selected.length > (options.maxLength || defaults.maxLength)) {
	              selected = selected.length + ' ' + (options.maxLengthHtml || defaults.maxLengthHtml);
	            } else {
	              selected = selected.join(', ');
	            }
	          } else {
	            index = select.$getIndex(controller.$modelValue);
	            selected = index !== -1 ? select.$scope.$matches[index].label : false;
	          }
	          element.html((selected || options.placeholder) + (options.caretHtml || defaults.caretHtml));
	        };
	        if (options.multiple) {
	          controller.$isEmpty = function(value) {
	            return !value || value.length === 0;
	          };
	        }
	        scope.$on('$destroy', function() {
	          if (select) select.destroy();
	          options = null;
	          select = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.scrollspy', [ 'mgcrea.ngStrap.helpers.debounce', 'mgcrea.ngStrap.helpers.dimensions' ]).provider('$scrollspy', function() {
	    var spies = this.$$spies = {};
	    var defaults = this.defaults = {
	      debounce: 150,
	      throttle: 100,
	      offset: 100
	    };
	    this.$get = [ '$window', '$document', '$rootScope', 'dimensions', 'debounce', 'throttle', function($window, $document, $rootScope, dimensions, debounce, throttle) {
	      var windowEl = angular.element($window);
	      var docEl = angular.element($document.prop('documentElement'));
	      var bodyEl = angular.element($window.document.body);
	      function nodeName(element, name) {
	        return element[0].nodeName && element[0].nodeName.toLowerCase() === name.toLowerCase();
	      }
	      function ScrollSpyFactory(config) {
	        var options = angular.extend({}, defaults, config);
	        if (!options.element) options.element = bodyEl;
	        var isWindowSpy = nodeName(options.element, 'body');
	        var scrollEl = isWindowSpy ? windowEl : options.element;
	        var scrollId = isWindowSpy ? 'window' : options.id;
	        if (spies[scrollId]) {
	          spies[scrollId].$$count++;
	          return spies[scrollId];
	        }
	        var $scrollspy = {};
	        var unbindViewContentLoaded;
	        var unbindIncludeContentLoaded;
	        var trackedElements = $scrollspy.$trackedElements = [];
	        var sortedElements = [];
	        var activeTarget;
	        var debouncedCheckPosition;
	        var throttledCheckPosition;
	        var debouncedCheckOffsets;
	        var viewportHeight;
	        var scrollTop;
	        $scrollspy.init = function() {
	          this.$$count = 1;
	          debouncedCheckPosition = debounce(this.checkPosition, options.debounce);
	          throttledCheckPosition = throttle(this.checkPosition, options.throttle);
	          scrollEl.on('click', this.checkPositionWithEventLoop);
	          windowEl.on('resize', debouncedCheckPosition);
	          scrollEl.on('scroll', throttledCheckPosition);
	          debouncedCheckOffsets = debounce(this.checkOffsets, options.debounce);
	          unbindViewContentLoaded = $rootScope.$on('$viewContentLoaded', debouncedCheckOffsets);
	          unbindIncludeContentLoaded = $rootScope.$on('$includeContentLoaded', debouncedCheckOffsets);
	          debouncedCheckOffsets();
	          if (scrollId) {
	            spies[scrollId] = $scrollspy;
	          }
	        };
	        $scrollspy.destroy = function() {
	          this.$$count--;
	          if (this.$$count > 0) {
	            return;
	          }
	          scrollEl.off('click', this.checkPositionWithEventLoop);
	          windowEl.off('resize', debouncedCheckPosition);
	          scrollEl.off('scroll', throttledCheckPosition);
	          unbindViewContentLoaded();
	          unbindIncludeContentLoaded();
	          if (scrollId) {
	            delete spies[scrollId];
	          }
	        };
	        $scrollspy.checkPosition = function() {
	          if (!sortedElements.length) return;
	          scrollTop = (isWindowSpy ? $window.pageYOffset : scrollEl.prop('scrollTop')) || 0;
	          viewportHeight = Math.max($window.innerHeight, docEl.prop('clientHeight'));
	          if (scrollTop < sortedElements[0].offsetTop && activeTarget !== sortedElements[0].target) {
	            return $scrollspy.$activateElement(sortedElements[0]);
	          }
	          for (var i = sortedElements.length; i--; ) {
	            if (angular.isUndefined(sortedElements[i].offsetTop) || sortedElements[i].offsetTop === null) continue;
	            if (activeTarget === sortedElements[i].target) continue;
	            if (scrollTop < sortedElements[i].offsetTop) continue;
	            if (sortedElements[i + 1] && scrollTop > sortedElements[i + 1].offsetTop) continue;
	            return $scrollspy.$activateElement(sortedElements[i]);
	          }
	        };
	        $scrollspy.checkPositionWithEventLoop = function() {
	          setTimeout($scrollspy.checkPosition, 1);
	        };
	        $scrollspy.$activateElement = function(element) {
	          if (activeTarget) {
	            var activeElement = $scrollspy.$getTrackedElement(activeTarget);
	            if (activeElement) {
	              activeElement.source.removeClass('active');
	              if (nodeName(activeElement.source, 'li') && nodeName(activeElement.source.parent().parent(), 'li')) {
	                activeElement.source.parent().parent().removeClass('active');
	              }
	            }
	          }
	          activeTarget = element.target;
	          element.source.addClass('active');
	          if (nodeName(element.source, 'li') && nodeName(element.source.parent().parent(), 'li')) {
	            element.source.parent().parent().addClass('active');
	          }
	        };
	        $scrollspy.$getTrackedElement = function(target) {
	          return trackedElements.filter(function(obj) {
	            return obj.target === target;
	          })[0];
	        };
	        $scrollspy.checkOffsets = function() {
	          angular.forEach(trackedElements, function(trackedElement) {
	            var targetElement = document.querySelector(trackedElement.target);
	            trackedElement.offsetTop = targetElement ? dimensions.offset(targetElement).top : null;
	            if (options.offset && trackedElement.offsetTop !== null) trackedElement.offsetTop -= options.offset * 1;
	          });
	          sortedElements = trackedElements.filter(function(el) {
	            return el.offsetTop !== null;
	          }).sort(function(a, b) {
	            return a.offsetTop - b.offsetTop;
	          });
	          debouncedCheckPosition();
	        };
	        $scrollspy.trackElement = function(target, source) {
	          trackedElements.push({
	            target: target,
	            source: source
	          });
	        };
	        $scrollspy.untrackElement = function(target, source) {
	          var toDelete;
	          for (var i = trackedElements.length; i--; ) {
	            if (trackedElements[i].target === target && trackedElements[i].source === source) {
	              toDelete = i;
	              break;
	            }
	          }
	          trackedElements.splice(toDelete, 1);
	        };
	        $scrollspy.activate = function(i) {
	          trackedElements[i].addClass('active');
	        };
	        $scrollspy.init();
	        return $scrollspy;
	      }
	      return ScrollSpyFactory;
	    } ];
	  }).directive('bsScrollspy', [ '$rootScope', 'debounce', 'dimensions', '$scrollspy', function($rootScope, debounce, dimensions, $scrollspy) {
	    return {
	      restrict: 'EAC',
	      link: function postLink(scope, element, attr) {
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'offset', 'target' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var scrollspy = $scrollspy(options);
	        scrollspy.trackElement(options.target, element);
	        scope.$on('$destroy', function() {
	          if (scrollspy) {
	            scrollspy.untrackElement(options.target, element);
	            scrollspy.destroy();
	          }
	          options = null;
	          scrollspy = null;
	        });
	      }
	    };
	  } ]).directive('bsScrollspyList', [ '$rootScope', 'debounce', 'dimensions', '$scrollspy', function($rootScope, debounce, dimensions, $scrollspy) {
	    return {
	      restrict: 'A',
	      compile: function postLink(element, attr) {
	        var children = element[0].querySelectorAll('li > a[href]');
	        angular.forEach(children, function(child) {
	          var childEl = angular.element(child);
	          childEl.parent().attr('bs-scrollspy', '').attr('data-target', childEl.attr('href'));
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.popover', [ 'mgcrea.ngStrap.tooltip' ]).provider('$popover', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      customClass: '',
	      container: false,
	      target: false,
	      placement: 'right',
	      templateUrl: 'popover/popover.tpl.html',
	      contentTemplate: false,
	      trigger: 'click',
	      keyboard: true,
	      html: false,
	      title: '',
	      content: '',
	      delay: 0,
	      autoClose: false
	    };
	    this.$get = [ '$tooltip', function($tooltip) {
	      function PopoverFactory(element, config) {
	        var options = angular.extend({}, defaults, config);
	        var $popover = $tooltip(element, options);
	        if (options.content) {
	          $popover.$scope.content = options.content;
	        }
	        return $popover;
	      }
	      return PopoverFactory;
	    } ];
	  }).directive('bsPopover', [ '$window', '$sce', '$popover', function($window, $sce, $popover) {
	    var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr) {
	        var popover;
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'customClass', 'autoClose', 'id', 'prefixClass', 'prefixEvent', 'bsEnabled' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'autoClose' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        var dataTarget = element.attr('data-target');
	        if (angular.isDefined(dataTarget)) {
	          if (falseValueRegExp.test(dataTarget)) {
	            options.target = false;
	          } else {
	            options.target = dataTarget;
	          }
	        }
	        angular.forEach([ 'title', 'content' ], function(key) {
	          if (attr[key]) {
	            attr.$observe(key, function(newValue, oldValue) {
	              scope[key] = $sce.trustAsHtml(newValue);
	              if (angular.isDefined(oldValue)) {
	                requestAnimationFrame(function() {
	                  if (popover) popover.$applyPlacement();
	                });
	              }
	            });
	          }
	        });
	        if (attr.bsPopover) {
	          scope.$watch(attr.bsPopover, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.content = newValue;
	            }
	            if (angular.isDefined(oldValue)) {
	              requestAnimationFrame(function() {
	                if (popover) popover.$applyPlacement();
	              });
	            }
	          }, true);
	        }
	        if (attr.bsShow) {
	          scope.$watch(attr.bsShow, function(newValue, oldValue) {
	            if (!popover || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(popover),?/i);
	            if (newValue === true) {
	              popover.show();
	            } else {
	              popover.hide();
	            }
	          });
	        }
	        if (attr.bsEnabled) {
	          scope.$watch(attr.bsEnabled, function(newValue) {
	            if (!popover || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|1|,?(popover),?/i);
	            if (newValue === false) {
	              popover.setEnabled(false);
	            } else {
	              popover.setEnabled(true);
	            }
	          });
	        }
	        if (attr.viewport) {
	          scope.$watch(attr.viewport, function(newValue) {
	            if (!popover || !angular.isDefined(newValue)) return;
	            popover.setViewport(newValue);
	          });
	        }
	        popover = $popover(element, options);
	        scope.$on('$destroy', function() {
	          if (popover) popover.destroy();
	          options = null;
	          popover = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.navbar', []).provider('$navbar', function() {
	    var defaults = this.defaults = {
	      activeClass: 'active',
	      routeAttr: 'data-match-route',
	      strict: false
	    };
	    this.$get = function() {
	      return {
	        defaults: defaults
	      };
	    };
	  }).directive('bsNavbar', [ '$window', '$location', '$navbar', function($window, $location, $navbar) {
	    var defaults = $navbar.defaults;
	    return {
	      restrict: 'A',
	      link: function postLink(scope, element, attr, controller) {
	        var options = angular.copy(defaults);
	        angular.forEach(Object.keys(defaults), function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        scope.$watch(function() {
	          return $location.path();
	        }, function(newValue, oldValue) {
	          var liElements = element[0].querySelectorAll('li[' + options.routeAttr + ']');
	          angular.forEach(liElements, function(li) {
	            var liElement = angular.element(li);
	            var pattern = liElement.attr(options.routeAttr).replace('/', '\\/');
	            if (options.strict) {
	              pattern = '^' + pattern + '$';
	            }
	            var regexp = new RegExp(pattern, 'i');
	            if (regexp.test(newValue)) {
	              liElement.addClass(options.activeClass);
	            } else {
	              liElement.removeClass(options.activeClass);
	            }
	          });
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.modal', [ 'mgcrea.ngStrap.core', 'mgcrea.ngStrap.helpers.dimensions' ]).provider('$modal', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      backdropAnimation: 'am-fade',
	      customClass: '',
	      prefixClass: 'modal',
	      prefixEvent: 'modal',
	      placement: 'top',
	      templateUrl: 'modal/modal.tpl.html',
	      template: '',
	      contentTemplate: false,
	      container: false,
	      element: null,
	      backdrop: true,
	      keyboard: true,
	      html: false,
	      show: true,
	      size: null,
	      zIndex: null
	    };
	    this.$get = [ '$window', '$rootScope', '$bsCompiler', '$animate', '$timeout', '$sce', 'dimensions', function($window, $rootScope, $bsCompiler, $animate, $timeout, $sce, dimensions) {
	      var forEach = angular.forEach;
	      var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;
	      var bodyElement = angular.element($window.document.body);
	      var backdropCount = 0;
	      var dialogBaseZindex = 1050;
	      var backdropBaseZindex = 1040;
	      var validSizes = {
	        lg: 'modal-lg',
	        sm: 'modal-sm'
	      };
	      function ModalFactory(config) {
	        var $modal = {};
	        var options = $modal.$options = angular.extend({}, defaults, config);
	        var promise = $modal.$promise = $bsCompiler.compile(options);
	        var scope = $modal.$scope = options.scope && options.scope.$new() || $rootScope.$new();
	        if (!options.element && !options.container) {
	          options.container = 'body';
	        }
	        if (options.zIndex) {
	          dialogBaseZindex = parseInt(options.zIndex, 10);
	          backdropBaseZindex = dialogBaseZindex - 10;
	        }
	        $modal.$id = options.id || options.element && options.element.attr('id') || '';
	        forEach([ 'title', 'content' ], function(key) {
	          if (options[key]) scope[key] = $sce.trustAsHtml(options[key]);
	        });
	        scope.$hide = function() {
	          scope.$$postDigest(function() {
	            $modal.hide();
	          });
	        };
	        scope.$show = function() {
	          scope.$$postDigest(function() {
	            $modal.show();
	          });
	        };
	        scope.$toggle = function() {
	          scope.$$postDigest(function() {
	            $modal.toggle();
	          });
	        };
	        $modal.$isShown = scope.$isShown = false;
	        var compileData;
	        var modalElement;
	        var modalScope;
	        var backdropElement = angular.element('<div class="' + options.prefixClass + '-backdrop"/>');
	        backdropElement.css({
	          position: 'fixed',
	          top: '0px',
	          left: '0px',
	          bottom: '0px',
	          right: '0px'
	        });
	        promise.then(function(data) {
	          compileData = data;
	          $modal.init();
	        });
	        $modal.init = function() {
	          if (options.show) {
	            scope.$$postDigest(function() {
	              $modal.show();
	            });
	          }
	        };
	        $modal.destroy = function() {
	          destroyModalElement();
	          if (backdropElement) {
	            backdropElement.remove();
	            backdropElement = null;
	          }
	          scope.$destroy();
	        };
	        $modal.show = function() {
	          if ($modal.$isShown) return;
	          var parent;
	          var after;
	          if (angular.isElement(options.container)) {
	            parent = options.container;
	            after = options.container[0].lastChild ? angular.element(options.container[0].lastChild) : null;
	          } else {
	            if (options.container) {
	              parent = findElement(options.container);
	              after = parent[0] && parent[0].lastChild ? angular.element(parent[0].lastChild) : null;
	            } else {
	              parent = null;
	              after = options.element;
	            }
	          }
	          if (modalElement) destroyModalElement();
	          modalScope = $modal.$scope.$new();
	          modalElement = $modal.$element = compileData.link(modalScope, function(clonedElement, scope) {});
	          if (options.backdrop) {
	            modalElement.css({
	              'z-index': dialogBaseZindex + backdropCount * 20
	            });
	            backdropElement.css({
	              'z-index': backdropBaseZindex + backdropCount * 20
	            });
	            backdropCount++;
	          }
	          if (scope.$emit(options.prefixEvent + '.show.before', $modal).defaultPrevented) {
	            return;
	          }
	          if (angular.isDefined(options.onBeforeShow) && angular.isFunction(options.onBeforeShow)) {
	            options.onBeforeShow($modal);
	          }
	          modalElement.css({
	            display: 'block'
	          }).addClass(options.placement);
	          if (options.customClass) {
	            modalElement.addClass(options.customClass);
	          }
	          if (options.size && validSizes[options.size]) {
	            angular.element(findElement('.modal-dialog', modalElement[0])).addClass(validSizes[options.size]);
	          }
	          if (options.animation) {
	            if (options.backdrop) {
	              backdropElement.addClass(options.backdropAnimation);
	            }
	            modalElement.addClass(options.animation);
	          }
	          if (options.backdrop) {
	            $animate.enter(backdropElement, bodyElement, null);
	          }
	          if (angular.version.minor <= 2) {
	            $animate.enter(modalElement, parent, after, enterAnimateCallback);
	          } else {
	            $animate.enter(modalElement, parent, after).then(enterAnimateCallback);
	          }
	          $modal.$isShown = scope.$isShown = true;
	          safeDigest(scope);
	          var el = modalElement[0];
	          requestAnimationFrame(function() {
	            el.focus();
	          });
	          bodyElement.addClass(options.prefixClass + '-open');
	          if (options.animation) {
	            bodyElement.addClass(options.prefixClass + '-with-' + options.animation);
	          }
	          bindBackdropEvents();
	          bindKeyboardEvents();
	        };
	        function enterAnimateCallback() {
	          scope.$emit(options.prefixEvent + '.show', $modal);
	          if (angular.isDefined(options.onShow) && angular.isFunction(options.onShow)) {
	            options.onShow($modal);
	          }
	        }
	        $modal.hide = function() {
	          if (!$modal.$isShown) return;
	          if (scope.$emit(options.prefixEvent + '.hide.before', $modal).defaultPrevented) {
	            return;
	          }
	          if (angular.isDefined(options.onBeforeHide) && angular.isFunction(options.onBeforeHide)) {
	            options.onBeforeHide($modal);
	          }
	          if (angular.version.minor <= 2) {
	            $animate.leave(modalElement, leaveAnimateCallback);
	          } else {
	            $animate.leave(modalElement).then(leaveAnimateCallback);
	          }
	          if (options.backdrop) {
	            backdropCount--;
	            $animate.leave(backdropElement);
	          }
	          $modal.$isShown = scope.$isShown = false;
	          safeDigest(scope);
	          unbindBackdropEvents();
	          unbindKeyboardEvents();
	        };
	        function leaveAnimateCallback() {
	          scope.$emit(options.prefixEvent + '.hide', $modal);
	          if (angular.isDefined(options.onHide) && angular.isFunction(options.onHide)) {
	            options.onHide($modal);
	          }
	          if (findElement('.modal').length <= 0) {
	            bodyElement.removeClass(options.prefixClass + '-open');
	          }
	          if (options.animation) {
	            bodyElement.removeClass(options.prefixClass + '-with-' + options.animation);
	          }
	        }
	        $modal.toggle = function() {
	          if ($modal.$isShown) {
	            $modal.hide();
	          } else {
	            $modal.show();
	          }
	        };
	        $modal.focus = function() {
	          modalElement[0].focus();
	        };
	        $modal.$onKeyUp = function(evt) {
	          if (evt.which === 27 && $modal.$isShown) {
	            $modal.hide();
	            evt.stopPropagation();
	          }
	        };
	        function bindBackdropEvents() {
	          if (options.backdrop) {
	            modalElement.on('click', hideOnBackdropClick);
	            backdropElement.on('click', hideOnBackdropClick);
	            backdropElement.on('wheel', preventEventDefault);
	          }
	        }
	        function unbindBackdropEvents() {
	          if (options.backdrop) {
	            modalElement.off('click', hideOnBackdropClick);
	            backdropElement.off('click', hideOnBackdropClick);
	            backdropElement.off('wheel', preventEventDefault);
	          }
	        }
	        function bindKeyboardEvents() {
	          if (options.keyboard) {
	            modalElement.on('keyup', $modal.$onKeyUp);
	          }
	        }
	        function unbindKeyboardEvents() {
	          if (options.keyboard) {
	            modalElement.off('keyup', $modal.$onKeyUp);
	          }
	        }
	        function hideOnBackdropClick(evt) {
	          if (evt.target !== evt.currentTarget) return;
	          if (options.backdrop === 'static') {
	            $modal.focus();
	          } else {
	            $modal.hide();
	          }
	        }
	        function preventEventDefault(evt) {
	          evt.preventDefault();
	        }
	        function destroyModalElement() {
	          if ($modal.$isShown && modalElement !== null) {
	            unbindBackdropEvents();
	            unbindKeyboardEvents();
	          }
	          if (modalScope) {
	            modalScope.$destroy();
	            modalScope = null;
	          }
	          if (modalElement) {
	            modalElement.remove();
	            modalElement = $modal.$element = null;
	          }
	        }
	        return $modal;
	      }
	      function safeDigest(scope) {
	        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
	      }
	      function findElement(query, element) {
	        return angular.element((element || document).querySelectorAll(query));
	      }
	      return ModalFactory;
	    } ];
	  }).directive('bsModal', [ '$window', '$sce', '$parse', '$modal', function($window, $sce, $parse, $modal) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr, transclusion) {
	        var options = {
	          scope: scope,
	          element: element,
	          show: false
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'backdrop', 'keyboard', 'html', 'container', 'animation', 'backdropAnimation', 'id', 'prefixEvent', 'prefixClass', 'customClass', 'modalClass', 'size', 'zIndex' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        if (options.modalClass) {
	          options.customClass = options.modalClass;
	        }
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'backdrop', 'keyboard', 'html', 'container' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        angular.forEach([ 'title', 'content' ], function(key) {
	          if (attr[key]) {
	            attr.$observe(key, function(newValue, oldValue) {
	              scope[key] = $sce.trustAsHtml(newValue);
	            });
	          }
	        });
	        if (attr.bsModal) {
	          scope.$watch(attr.bsModal, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.content = newValue;
	            }
	          }, true);
	        }
	        var modal = $modal(options);
	        element.on(attr.trigger || 'click', modal.toggle);
	        scope.$on('$destroy', function() {
	          if (modal) modal.destroy();
	          options = null;
	          modal = null;
	        });
	      }
	    };
	  } ]);
	  if (angular.version.minor < 3 && angular.version.dot < 14) {
	    angular.module('ng').factory('$$rAF', [ '$window', '$timeout', function($window, $timeout) {
	      var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame || $window.mozRequestAnimationFrame;
	      var cancelAnimationFrame = $window.cancelAnimationFrame || $window.webkitCancelAnimationFrame || $window.mozCancelAnimationFrame || $window.webkitCancelRequestAnimationFrame;
	      var rafSupported = !!requestAnimationFrame;
	      var raf = rafSupported ? function(fn) {
	        var id = requestAnimationFrame(fn);
	        return function() {
	          cancelAnimationFrame(id);
	        };
	      } : function(fn) {
	        var timer = $timeout(fn, 16.66, false);
	        return function() {
	          $timeout.cancel(timer);
	        };
	      };
	      raf.supported = rafSupported;
	      return raf;
	    } ]);
	  }
	  angular.module('mgcrea.ngStrap.helpers.parseOptions', []).provider('$parseOptions', function() {
	    var defaults = this.defaults = {
	      regexp: /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/
	    };
	    this.$get = [ '$parse', '$q', function($parse, $q) {
	      function ParseOptionsFactory(attr, config) {
	        var $parseOptions = {};
	        var options = angular.extend({}, defaults, config);
	        $parseOptions.$values = [];
	        var match;
	        var displayFn;
	        var valueName;
	        var keyName;
	        var groupByFn;
	        var valueFn;
	        var valuesFn;
	        $parseOptions.init = function() {
	          $parseOptions.$match = match = attr.match(options.regexp);
	          displayFn = $parse(match[2] || match[1]);
	          valueName = match[4] || match[6];
	          keyName = match[5];
	          groupByFn = $parse(match[3] || '');
	          valueFn = $parse(match[2] ? match[1] : valueName);
	          valuesFn = $parse(match[7]);
	        };
	        $parseOptions.valuesFn = function(scope, controller) {
	          return $q.when(valuesFn(scope, controller)).then(function(values) {
	            if (!angular.isArray(values)) {
	              values = [];
	            }
	            $parseOptions.$values = values.length ? parseValues(values, scope) : [];
	            return $parseOptions.$values;
	          });
	        };
	        $parseOptions.displayValue = function(modelValue) {
	          var scope = {};
	          scope[valueName] = modelValue;
	          return displayFn(scope);
	        };
	        function parseValues(values, scope) {
	          return values.map(function(match, index) {
	            var locals = {};
	            var label;
	            var value;
	            locals[valueName] = match;
	            label = displayFn(scope, locals);
	            value = valueFn(scope, locals);
	            return {
	              label: label,
	              value: value,
	              index: index
	            };
	          });
	        }
	        $parseOptions.init();
	        return $parseOptions;
	      }
	      return ParseOptionsFactory;
	    } ];
	  });
	  angular.module('mgcrea.ngStrap.helpers.dimensions', []).factory('dimensions', function() {
	    var fn = {};
	    var nodeName = fn.nodeName = function(element, name) {
	      return element.nodeName && element.nodeName.toLowerCase() === name.toLowerCase();
	    };
	    fn.css = function(element, prop, extra) {
	      var value;
	      if (element.currentStyle) {
	        value = element.currentStyle[prop];
	      } else if (window.getComputedStyle) {
	        value = window.getComputedStyle(element)[prop];
	      } else {
	        value = element.style[prop];
	      }
	      return extra === true ? parseFloat(value) || 0 : value;
	    };
	    fn.offset = function(element) {
	      var boxRect = element.getBoundingClientRect();
	      var docElement = element.ownerDocument;
	      return {
	        width: boxRect.width || element.offsetWidth,
	        height: boxRect.height || element.offsetHeight,
	        top: boxRect.top + (window.pageYOffset || docElement.documentElement.scrollTop) - (docElement.documentElement.clientTop || 0),
	        left: boxRect.left + (window.pageXOffset || docElement.documentElement.scrollLeft) - (docElement.documentElement.clientLeft || 0)
	      };
	    };
	    fn.setOffset = function(element, options, i) {
	      var curPosition;
	      var curLeft;
	      var curCSSTop;
	      var curTop;
	      var curOffset;
	      var curCSSLeft;
	      var calculatePosition;
	      var position = fn.css(element, 'position');
	      var curElem = angular.element(element);
	      var props = {};
	      if (position === 'static') {
	        element.style.position = 'relative';
	      }
	      curOffset = fn.offset(element);
	      curCSSTop = fn.css(element, 'top');
	      curCSSLeft = fn.css(element, 'left');
	      calculatePosition = (position === 'absolute' || position === 'fixed') && (curCSSTop + curCSSLeft).indexOf('auto') > -1;
	      if (calculatePosition) {
	        curPosition = fn.position(element);
	        curTop = curPosition.top;
	        curLeft = curPosition.left;
	      } else {
	        curTop = parseFloat(curCSSTop) || 0;
	        curLeft = parseFloat(curCSSLeft) || 0;
	      }
	      if (angular.isFunction(options)) {
	        options = options.call(element, i, curOffset);
	      }
	      if (options.top !== null) {
	        props.top = options.top - curOffset.top + curTop;
	      }
	      if (options.left !== null) {
	        props.left = options.left - curOffset.left + curLeft;
	      }
	      if ('using' in options) {
	        options.using.call(curElem, props);
	      } else {
	        curElem.css({
	          top: props.top + 'px',
	          left: props.left + 'px'
	        });
	      }
	    };
	    fn.position = function(element) {
	      var offsetParentRect = {
	        top: 0,
	        left: 0
	      };
	      var offsetParentEl;
	      var offset;
	      if (fn.css(element, 'position') === 'fixed') {
	        offset = element.getBoundingClientRect();
	      } else {
	        offsetParentEl = offsetParentElement(element);
	        offset = fn.offset(element);
	        if (!nodeName(offsetParentEl, 'html')) {
	          offsetParentRect = fn.offset(offsetParentEl);
	        }
	        offsetParentRect.top += fn.css(offsetParentEl, 'borderTopWidth', true);
	        offsetParentRect.left += fn.css(offsetParentEl, 'borderLeftWidth', true);
	      }
	      return {
	        width: element.offsetWidth,
	        height: element.offsetHeight,
	        top: offset.top - offsetParentRect.top - fn.css(element, 'marginTop', true),
	        left: offset.left - offsetParentRect.left - fn.css(element, 'marginLeft', true)
	      };
	    };
	    function offsetParentElement(element) {
	      var docElement = element.ownerDocument;
	      var offsetParent = element.offsetParent || docElement;
	      if (nodeName(offsetParent, '#document')) return docElement.documentElement;
	      while (offsetParent && !nodeName(offsetParent, 'html') && fn.css(offsetParent, 'position') === 'static') {
	        offsetParent = offsetParent.offsetParent;
	      }
	      return offsetParent || docElement.documentElement;
	    }
	    fn.height = function(element, outer) {
	      var value = element.offsetHeight;
	      if (outer) {
	        value += fn.css(element, 'marginTop', true) + fn.css(element, 'marginBottom', true);
	      } else {
	        value -= fn.css(element, 'paddingTop', true) + fn.css(element, 'paddingBottom', true) + fn.css(element, 'borderTopWidth', true) + fn.css(element, 'borderBottomWidth', true);
	      }
	      return value;
	    };
	    fn.width = function(element, outer) {
	      var value = element.offsetWidth;
	      if (outer) {
	        value += fn.css(element, 'marginLeft', true) + fn.css(element, 'marginRight', true);
	      } else {
	        value -= fn.css(element, 'paddingLeft', true) + fn.css(element, 'paddingRight', true) + fn.css(element, 'borderLeftWidth', true) + fn.css(element, 'borderRightWidth', true);
	      }
	      return value;
	    };
	    return fn;
	  });
	  angular.module('mgcrea.ngStrap.helpers.debounce', []).factory('debounce', [ '$timeout', function($timeout) {
	    return function(func, wait, immediate) {
	      var timeout = null;
	      return function() {
	        var context = this;
	        var args = arguments;
	        var callNow = immediate && !timeout;
	        if (timeout) {
	          $timeout.cancel(timeout);
	        }
	        timeout = $timeout(function later() {
	          timeout = null;
	          if (!immediate) {
	            func.apply(context, args);
	          }
	        }, wait, false);
	        if (callNow) {
	          func.apply(context, args);
	        }
	        return timeout;
	      };
	    };
	  } ]).factory('throttle', [ '$timeout', function($timeout) {
	    return function(func, wait, options) {
	      var timeout = null;
	      if (!options) options = {};
	      return function() {
	        var context = this;
	        var args = arguments;
	        if (!timeout) {
	          if (options.leading !== false) {
	            func.apply(context, args);
	          }
	          timeout = $timeout(function later() {
	            timeout = null;
	            if (options.trailing !== false) {
	              func.apply(context, args);
	            }
	          }, wait, false);
	        }
	      };
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.helpers.dateParser', []).provider('$dateParser', [ '$localeProvider', function($localeProvider) {
	    function ParseDate() {
	      this.year = 1970;
	      this.month = 0;
	      this.day = 1;
	      this.hours = 0;
	      this.minutes = 0;
	      this.seconds = 0;
	      this.milliseconds = 0;
	    }
	    ParseDate.prototype.setMilliseconds = function(value) {
	      this.milliseconds = value;
	    };
	    ParseDate.prototype.setSeconds = function(value) {
	      this.seconds = value;
	    };
	    ParseDate.prototype.setMinutes = function(value) {
	      this.minutes = value;
	    };
	    ParseDate.prototype.setHours = function(value) {
	      this.hours = value;
	    };
	    ParseDate.prototype.getHours = function() {
	      return this.hours;
	    };
	    ParseDate.prototype.setDate = function(value) {
	      this.day = value;
	    };
	    ParseDate.prototype.setMonth = function(value) {
	      this.month = value;
	    };
	    ParseDate.prototype.setFullYear = function(value) {
	      this.year = value;
	    };
	    ParseDate.prototype.fromDate = function(value) {
	      this.year = value.getFullYear();
	      this.month = value.getMonth();
	      this.day = value.getDate();
	      this.hours = value.getHours();
	      this.minutes = value.getMinutes();
	      this.seconds = value.getSeconds();
	      this.milliseconds = value.getMilliseconds();
	      return this;
	    };
	    ParseDate.prototype.toDate = function() {
	      return new Date(this.year, this.month, this.day, this.hours, this.minutes, this.seconds, this.milliseconds);
	    };
	    var proto = ParseDate.prototype;
	    function noop() {}
	    function isNumeric(n) {
	      return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	    function indexOfCaseInsensitive(array, value) {
	      var len = array.length;
	      var str = value.toString().toLowerCase();
	      for (var i = 0; i < len; i++) {
	        if (array[i].toLowerCase() === str) {
	          return i;
	        }
	      }
	      return -1;
	    }
	    var defaults = this.defaults = {
	      format: 'shortDate',
	      strict: false
	    };
	    this.$get = [ '$locale', 'dateFilter', function($locale, dateFilter) {
	      var DateParserFactory = function(config) {
	        var options = angular.extend({}, defaults, config);
	        var $dateParser = {};
	        var regExpMap = {
	          sss: '[0-9]{3}',
	          ss: '[0-5][0-9]',
	          s: options.strict ? '[1-5]?[0-9]' : '[0-9]|[0-5][0-9]',
	          mm: '[0-5][0-9]',
	          m: options.strict ? '[1-5]?[0-9]' : '[0-9]|[0-5][0-9]',
	          HH: '[01][0-9]|2[0-3]',
	          H: options.strict ? '1?[0-9]|2[0-3]' : '[01]?[0-9]|2[0-3]',
	          hh: '[0][1-9]|[1][012]',
	          h: options.strict ? '[1-9]|1[012]' : '0?[1-9]|1[012]',
	          a: 'AM|PM',
	          EEEE: $locale.DATETIME_FORMATS.DAY.join('|'),
	          EEE: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
	          dd: '0[1-9]|[12][0-9]|3[01]',
	          d: options.strict ? '[1-9]|[1-2][0-9]|3[01]' : '0?[1-9]|[1-2][0-9]|3[01]',
	          MMMM: $locale.DATETIME_FORMATS.MONTH.join('|'),
	          MMM: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	          MM: '0[1-9]|1[012]',
	          M: options.strict ? '[1-9]|1[012]' : '0?[1-9]|1[012]',
	          yyyy: '[1]{1}[0-9]{3}|[2]{1}[0-9]{3}',
	          yy: '[0-9]{2}',
	          y: options.strict ? '-?(0|[1-9][0-9]{0,3})' : '-?0*[0-9]{1,4}'
	        };
	        var setFnMap = {
	          sss: proto.setMilliseconds,
	          ss: proto.setSeconds,
	          s: proto.setSeconds,
	          mm: proto.setMinutes,
	          m: proto.setMinutes,
	          HH: proto.setHours,
	          H: proto.setHours,
	          hh: proto.setHours,
	          h: proto.setHours,
	          EEEE: noop,
	          EEE: noop,
	          dd: proto.setDate,
	          d: proto.setDate,
	          a: function(value) {
	            var hours = this.getHours() % 12;
	            return this.setHours(value.match(/pm/i) ? hours + 12 : hours);
	          },
	          MMMM: function(value) {
	            return this.setMonth(indexOfCaseInsensitive($locale.DATETIME_FORMATS.MONTH, value));
	          },
	          MMM: function(value) {
	            return this.setMonth(indexOfCaseInsensitive($locale.DATETIME_FORMATS.SHORTMONTH, value));
	          },
	          MM: function(value) {
	            return this.setMonth(1 * value - 1);
	          },
	          M: function(value) {
	            return this.setMonth(1 * value - 1);
	          },
	          yyyy: proto.setFullYear,
	          yy: function(value) {
	            return this.setFullYear(2e3 + 1 * value);
	          },
	          y: function(value) {
	            return 1 * value <= 50 && value.length === 2 ? this.setFullYear(2e3 + 1 * value) : this.setFullYear(1 * value);
	          }
	        };
	        var regex;
	        var setMap;
	        $dateParser.init = function() {
	          $dateParser.$format = $locale.DATETIME_FORMATS[options.format] || options.format;
	          regex = regExpForFormat($dateParser.$format);
	          setMap = setMapForFormat($dateParser.$format);
	        };
	        $dateParser.isValid = function(date) {
	          if (angular.isDate(date)) return !isNaN(date.getTime());
	          return regex.test(date);
	        };
	        $dateParser.parse = function(value, baseDate, format, timezone) {
	          if (format) format = $locale.DATETIME_FORMATS[format] || format;
	          if (angular.isDate(value)) value = dateFilter(value, format || $dateParser.$format, timezone);
	          var formatRegex = format ? regExpForFormat(format) : regex;
	          var formatSetMap = format ? setMapForFormat(format) : setMap;
	          var matches = formatRegex.exec(value);
	          if (!matches) return false;
	          var date = baseDate && !isNaN(baseDate.getTime()) ? new ParseDate().fromDate(baseDate) : new ParseDate().fromDate(new Date(1970, 0, 1, 0));
	          for (var i = 0; i < matches.length - 1; i++) {
	            if (formatSetMap[i]) formatSetMap[i].call(date, matches[i + 1]);
	          }
	          var newDate = date.toDate();
	          if (parseInt(date.day, 10) !== newDate.getDate()) {
	            return false;
	          }
	          return newDate;
	        };
	        $dateParser.getDateForAttribute = function(key, value) {
	          var date;
	          if (value === 'today') {
	            var today = new Date();
	            date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (key === 'maxDate' ? 1 : 0), 0, 0, 0, key === 'minDate' ? 0 : -1);
	          } else if (angular.isString(value) && value.match(/^".+"$/)) {
	            date = new Date(value.substr(1, value.length - 2));
	          } else if (isNumeric(value)) {
	            date = new Date(parseInt(value, 10));
	          } else if (angular.isString(value) && value.length === 0) {
	            date = key === 'minDate' ? -Infinity : +Infinity;
	          } else {
	            date = new Date(value);
	          }
	          return date;
	        };
	        $dateParser.getTimeForAttribute = function(key, value) {
	          var time;
	          if (value === 'now') {
	            time = new Date().setFullYear(1970, 0, 1);
	          } else if (angular.isString(value) && value.match(/^".+"$/)) {
	            time = new Date(value.substr(1, value.length - 2)).setFullYear(1970, 0, 1);
	          } else if (isNumeric(value)) {
	            time = new Date(parseInt(value, 10)).setFullYear(1970, 0, 1);
	          } else if (angular.isString(value) && value.length === 0) {
	            time = key === 'minTime' ? -Infinity : +Infinity;
	          } else {
	            time = $dateParser.parse(value, new Date(1970, 0, 1, 0));
	          }
	          return time;
	        };
	        $dateParser.daylightSavingAdjust = function(date) {
	          if (!date) {
	            return null;
	          }
	          date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
	          return date;
	        };
	        $dateParser.timezoneOffsetAdjust = function(date, timezone, undo) {
	          if (!date) {
	            return null;
	          }
	          if (timezone && timezone === 'UTC') {
	            date = new Date(date.getTime());
	            date.setMinutes(date.getMinutes() + (undo ? -1 : 1) * date.getTimezoneOffset());
	          }
	          return date;
	        };
	        function regExpForFormat(format) {
	          var re = buildDateAbstractRegex(format);
	          return buildDateParseRegex(re);
	        }
	        function buildDateAbstractRegex(format) {
	          var escapedFormat = escapeReservedSymbols(format);
	          var escapedLiteralFormat = escapedFormat.replace(/''/g, '\\\'');
	          var literalRegex = /('(?:\\'|.)*?')/;
	          var formatParts = escapedLiteralFormat.split(literalRegex);
	          var dateElements = Object.keys(regExpMap);
	          var dateRegexParts = [];
	          angular.forEach(formatParts, function(part) {
	            if (isFormatStringLiteral(part)) {
	              part = trimLiteralEscapeChars(part);
	            } else {
	              for (var i = 0; i < dateElements.length; i++) {
	                part = part.split(dateElements[i]).join('${' + i + '}');
	              }
	            }
	            dateRegexParts.push(part);
	          });
	          return dateRegexParts.join('');
	        }
	        function escapeReservedSymbols(text) {
	          return text.replace(/\\/g, '[\\\\]').replace(/-/g, '[-]').replace(/\./g, '[.]').replace(/\*/g, '[*]').replace(/\+/g, '[+]').replace(/\?/g, '[?]').replace(/\$/g, '[$]').replace(/\^/g, '[^]').replace(/\//g, '[/]').replace(/\\s/g, '[\\s]');
	        }
	        function isFormatStringLiteral(text) {
	          return /^'.*'$/.test(text);
	        }
	        function trimLiteralEscapeChars(text) {
	          return text.replace(/^'(.*)'$/, '$1');
	        }
	        function buildDateParseRegex(abstractRegex) {
	          var dateElements = Object.keys(regExpMap);
	          var re = abstractRegex;
	          for (var i = 0; i < dateElements.length; i++) {
	            re = re.split('${' + i + '}').join('(' + regExpMap[dateElements[i]] + ')');
	          }
	          return new RegExp('^' + re + '$', [ 'i' ]);
	        }
	        function setMapForFormat(format) {
	          var re = buildDateAbstractRegex(format);
	          return buildDateParseValuesMap(re);
	        }
	        function buildDateParseValuesMap(abstractRegex) {
	          var dateElements = Object.keys(regExpMap);
	          var valuesRegex = new RegExp('\\${(\\d+)}', 'g');
	          var valuesMatch;
	          var keyIndex;
	          var valueKey;
	          var valueFunction;
	          var valuesFunctionMap = [];
	          while ((valuesMatch = valuesRegex.exec(abstractRegex)) !== null) {
	            keyIndex = valuesMatch[1];
	            valueKey = dateElements[keyIndex];
	            valueFunction = setFnMap[valueKey];
	            valuesFunctionMap.push(valueFunction);
	          }
	          return valuesFunctionMap;
	        }
	        $dateParser.init();
	        return $dateParser;
	      };
	      return DateParserFactory;
	    } ];
	  } ]);
	  angular.module('mgcrea.ngStrap.helpers.dateFormatter', []).service('$dateFormatter', [ '$locale', 'dateFilter', function($locale, dateFilter) {
	    this.getDefaultLocale = function() {
	      return $locale.id;
	    };
	    this.getDatetimeFormat = function(format, lang) {
	      return $locale.DATETIME_FORMATS[format] || format;
	    };
	    this.weekdaysShort = function(lang) {
	      return $locale.DATETIME_FORMATS.SHORTDAY;
	    };
	    function splitTimeFormat(format) {
	      return /(h+)([:\.])?(m+)([:\.])?(s*)[ ]?(a?)/i.exec(format).slice(1);
	    }
	    this.hoursFormat = function(timeFormat) {
	      return splitTimeFormat(timeFormat)[0];
	    };
	    this.minutesFormat = function(timeFormat) {
	      return splitTimeFormat(timeFormat)[2];
	    };
	    this.secondsFormat = function(timeFormat) {
	      return splitTimeFormat(timeFormat)[4];
	    };
	    this.timeSeparator = function(timeFormat) {
	      return splitTimeFormat(timeFormat)[1];
	    };
	    this.showSeconds = function(timeFormat) {
	      return !!splitTimeFormat(timeFormat)[4];
	    };
	    this.showAM = function(timeFormat) {
	      return !!splitTimeFormat(timeFormat)[5];
	    };
	    this.formatDate = function(date, format, lang, timezone) {
	      return dateFilter(date, format, timezone);
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.core', []).service('$bsCompiler', bsCompilerService);
	  function bsCompilerService($q, $http, $injector, $compile, $controller, $templateCache) {
	    this.compile = function(options) {
	      if (options.template && /\.html$/.test(options.template)) {
	        console.warn('Deprecated use of `template` option to pass a file. Please use the `templateUrl` option instead.');
	        options.templateUrl = options.template;
	        options.template = '';
	      }
	      var templateUrl = options.templateUrl;
	      var template = options.template || '';
	      var controller = options.controller;
	      var controllerAs = options.controllerAs;
	      var resolve = options.resolve || {};
	      var locals = options.locals || {};
	      var transformTemplate = options.transformTemplate || angular.identity;
	      var bindToController = options.bindToController;
	      angular.forEach(resolve, function(value, key) {
	        if (angular.isString(value)) {
	          resolve[key] = $injector.get(value);
	        } else {
	          resolve[key] = $injector.invoke(value);
	        }
	      });
	      angular.extend(resolve, locals);
	      if (template) {
	        resolve.$template = $q.when(template);
	      } else if (templateUrl) {
	        resolve.$template = fetchTemplate(templateUrl);
	      } else {
	        throw new Error('Missing `template` / `templateUrl` option.');
	      }
	      if (options.titleTemplate) {
	        resolve.$template = $q.all([ resolve.$template, fetchTemplate(options.titleTemplate) ]).then(function(templates) {
	          var templateEl = angular.element(templates[0]);
	          findElement('[ng-bind="title"]', templateEl[0]).removeAttr('ng-bind').html(templates[1]);
	          return templateEl[0].outerHTML;
	        });
	      }
	      if (options.contentTemplate) {
	        resolve.$template = $q.all([ resolve.$template, fetchTemplate(options.contentTemplate) ]).then(function(templates) {
	          var templateEl = angular.element(templates[0]);
	          var contentEl = findElement('[ng-bind="content"]', templateEl[0]).removeAttr('ng-bind').html(templates[1]);
	          if (!options.templateUrl) contentEl.next().remove();
	          return templateEl[0].outerHTML;
	        });
	      }
	      return $q.all(resolve).then(function(locals) {
	        var template = transformTemplate(locals.$template);
	        if (options.html) {
	          template = template.replace(/ng-bind="/gi, 'ng-bind-html="');
	        }
	        var element = angular.element('<div>').html(template.trim()).contents();
	        var linkFn = $compile(element);
	        return {
	          locals: locals,
	          element: element,
	          link: function link(scope) {
	            locals.$scope = scope;
	            if (controller) {
	              var invokeCtrl = $controller(controller, locals, true);
	              if (bindToController) {
	                angular.extend(invokeCtrl.instance, locals);
	              }
	              var ctrl = angular.isObject(invokeCtrl) ? invokeCtrl : invokeCtrl();
	              element.data('$ngControllerController', ctrl);
	              element.children().data('$ngControllerController', ctrl);
	              if (controllerAs) {
	                scope[controllerAs] = ctrl;
	              }
	            }
	            return linkFn.apply(null, arguments);
	          }
	        };
	      });
	    };
	    function findElement(query, element) {
	      return angular.element((element || document).querySelectorAll(query));
	    }
	    var fetchPromises = {};
	    function fetchTemplate(template) {
	      if (fetchPromises[template]) return fetchPromises[template];
	      return fetchPromises[template] = $http.get(template, {
	        cache: $templateCache
	      }).then(function(res) {
	        return res.data;
	      });
	    }
	  }
	  angular.module('mgcrea.ngStrap.dropdown', [ 'mgcrea.ngStrap.tooltip' ]).provider('$dropdown', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'dropdown',
	      prefixEvent: 'dropdown',
	      placement: 'bottom-left',
	      templateUrl: 'dropdown/dropdown.tpl.html',
	      trigger: 'click',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0
	    };
	    this.$get = [ '$window', '$rootScope', '$tooltip', '$timeout', function($window, $rootScope, $tooltip, $timeout) {
	      var bodyEl = angular.element($window.document.body);
	      var matchesSelector = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector;
	      function DropdownFactory(element, config) {
	        var $dropdown = {};
	        var options = angular.extend({}, defaults, config);
	        $dropdown.$scope = options.scope && options.scope.$new() || $rootScope.$new();
	        $dropdown = $tooltip(element, options);
	        var parentEl = element.parent();
	        $dropdown.$onKeyDown = function(evt) {
	          if (!/(38|40)/.test(evt.keyCode)) return;
	          evt.preventDefault();
	          evt.stopPropagation();
	          var items = angular.element($dropdown.$element[0].querySelectorAll('li:not(.divider) a'));
	          if (!items.length) return;
	          var index;
	          angular.forEach(items, function(el, i) {
	            if (matchesSelector && matchesSelector.call(el, ':focus')) index = i;
	          });
	          if (evt.keyCode === 38 && index > 0) index--; else if (evt.keyCode === 40 && index < items.length - 1) index++; else if (angular.isUndefined(index)) index = 0;
	          items.eq(index)[0].focus();
	        };
	        var show = $dropdown.show;
	        $dropdown.show = function() {
	          show();
	          $timeout(function() {
	            if (options.keyboard && $dropdown.$element) $dropdown.$element.on('keydown', $dropdown.$onKeyDown);
	            bodyEl.on('click', onBodyClick);
	          }, 0, false);
	          if (parentEl.hasClass('dropdown')) parentEl.addClass('open');
	        };
	        var hide = $dropdown.hide;
	        $dropdown.hide = function() {
	          if (!$dropdown.$isShown) return;
	          if (options.keyboard && $dropdown.$element) $dropdown.$element.off('keydown', $dropdown.$onKeyDown);
	          bodyEl.off('click', onBodyClick);
	          if (parentEl.hasClass('dropdown')) parentEl.removeClass('open');
	          hide();
	        };
	        var destroy = $dropdown.destroy;
	        $dropdown.destroy = function() {
	          bodyEl.off('click', onBodyClick);
	          destroy();
	        };
	        function onBodyClick(evt) {
	          if (evt.target === element[0]) return;
	          return evt.target !== element[0] && $dropdown.hide();
	        }
	        return $dropdown;
	      }
	      return DropdownFactory;
	    } ];
	  }).directive('bsDropdown', [ '$window', '$sce', '$dropdown', function($window, $sce, $dropdown) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      compile: function(tElement, tAttrs) {
	        if (!tAttrs.bsDropdown) {
	          var nextSibling = tElement[0].nextSibling;
	          while (nextSibling && nextSibling.nodeType !== 1) {
	            nextSibling = nextSibling.nextSibling;
	          }
	          if (nextSibling && nextSibling.className.split(' ').indexOf('dropdown-menu') >= 0) {
	            tAttrs.template = nextSibling.outerHTML;
	            tAttrs.templateUrl = undefined;
	            nextSibling.parentNode.removeChild(nextSibling);
	          }
	        }
	        return function postLink(scope, element, attr) {
	          var options = {
	            scope: scope
	          };
	          angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'id', 'autoClose' ], function(key) {
	            if (angular.isDefined(tAttrs[key])) options[key] = tAttrs[key];
	          });
	          var falseValueRegExp = /^(false|0|)$/i;
	          angular.forEach([ 'html', 'container' ], function(key) {
	            if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	          });
	          angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	            var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	            if (angular.isDefined(attr[bsKey])) {
	              options[key] = scope.$eval(attr[bsKey]);
	            }
	          });
	          if (attr.bsDropdown) {
	            scope.$watch(attr.bsDropdown, function(newValue, oldValue) {
	              scope.content = newValue;
	            }, true);
	          }
	          var dropdown = $dropdown(element, options);
	          if (attr.bsShow) {
	            scope.$watch(attr.bsShow, function(newValue, oldValue) {
	              if (!dropdown || !angular.isDefined(newValue)) return;
	              if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(dropdown),?/i);
	              if (newValue === true) {
	                dropdown.show();
	              } else {
	                dropdown.hide();
	              }
	            });
	          }
	          scope.$on('$destroy', function() {
	            if (dropdown) dropdown.destroy();
	            options = null;
	            dropdown = null;
	          });
	        };
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.button', []).provider('$button', function() {
	    var defaults = this.defaults = {
	      activeClass: 'active',
	      toggleEvent: 'click'
	    };
	    this.$get = function() {
	      return {
	        defaults: defaults
	      };
	    };
	  }).directive('bsCheckboxGroup', function() {
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      compile: function postLink(element, attr) {
	        element.attr('data-toggle', 'buttons');
	        element.removeAttr('ng-model');
	        var children = element[0].querySelectorAll('input[type="checkbox"]');
	        angular.forEach(children, function(child) {
	          var childEl = angular.element(child);
	          childEl.attr('bs-checkbox', '');
	          childEl.attr('ng-model', attr.ngModel + '.' + childEl.attr('value'));
	        });
	      }
	    };
	  }).directive('bsCheckbox', [ '$button', '$$rAF', function($button, $$rAF) {
	    var defaults = $button.defaults;
	    var constantValueRegExp = /^(true|false|\d+)$/;
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = defaults;
	        var isInput = element[0].nodeName === 'INPUT';
	        var activeElement = isInput ? element.parent() : element;
	        var trueValue = angular.isDefined(attr.trueValue) ? attr.trueValue : true;
	        if (constantValueRegExp.test(attr.trueValue)) {
	          trueValue = scope.$eval(attr.trueValue);
	        }
	        var falseValue = angular.isDefined(attr.falseValue) ? attr.falseValue : false;
	        if (constantValueRegExp.test(attr.falseValue)) {
	          falseValue = scope.$eval(attr.falseValue);
	        }
	        var hasExoticValues = typeof trueValue !== 'boolean' || typeof falseValue !== 'boolean';
	        if (hasExoticValues) {
	          controller.$parsers.push(function(viewValue) {
	            return viewValue ? trueValue : falseValue;
	          });
	          controller.$formatters.push(function(modelValue) {
	            return angular.equals(modelValue, trueValue);
	          });
	        }
	        controller.$render = function() {
	          var isActive = !!controller.$viewValue;
	          $$rAF(function() {
	            if (isInput) element[0].checked = isActive;
	            activeElement.toggleClass(options.activeClass, isActive);
	          });
	        };
	        element.bind(options.toggleEvent, function() {
	          scope.$apply(function() {
	            if (!isInput) {
	              controller.$setViewValue(!activeElement.hasClass('active'));
	            }
	            controller.$render();
	          });
	        });
	      }
	    };
	  } ]).directive('bsRadioGroup', function() {
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      compile: function postLink(element, attr) {
	        element.attr('data-toggle', 'buttons');
	        element.removeAttr('ng-model');
	        var children = element[0].querySelectorAll('input[type="radio"]');
	        angular.forEach(children, function(child) {
	          angular.element(child).attr('bs-radio', '');
	          angular.element(child).attr('ng-model', attr.ngModel);
	        });
	      }
	    };
	  }).directive('bsRadio', [ '$button', '$$rAF', function($button, $$rAF) {
	    var defaults = $button.defaults;
	    var constantValueRegExp = /^(true|false|\d+)$/;
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = defaults;
	        var isInput = element[0].nodeName === 'INPUT';
	        var activeElement = isInput ? element.parent() : element;
	        var value;
	        attr.$observe('value', function(v) {
	          if (typeof v !== 'boolean' && constantValueRegExp.test(v)) {
	            value = scope.$eval(v);
	          } else {
	            value = v;
	          }
	          controller.$render();
	        });
	        controller.$render = function() {
	          var isActive = angular.equals(controller.$viewValue, value);
	          $$rAF(function() {
	            if (isInput) element[0].checked = isActive;
	            activeElement.toggleClass(options.activeClass, isActive);
	          });
	        };
	        element.bind(options.toggleEvent, function() {
	          scope.$apply(function() {
	            controller.$setViewValue(value);
	            controller.$render();
	          });
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.datepicker', [ 'mgcrea.ngStrap.helpers.dateParser', 'mgcrea.ngStrap.helpers.dateFormatter', 'mgcrea.ngStrap.tooltip' ]).provider('$datepicker', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'datepicker',
	      placement: 'bottom-left',
	      templateUrl: 'datepicker/datepicker.tpl.html',
	      trigger: 'focus',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0,
	      useNative: false,
	      dateType: 'date',
	      dateFormat: 'shortDate',
	      timezone: null,
	      modelDateFormat: null,
	      dayFormat: 'dd',
	      monthFormat: 'MMM',
	      yearFormat: 'yyyy',
	      monthTitleFormat: 'MMMM yyyy',
	      yearTitleFormat: 'yyyy',
	      strictFormat: false,
	      autoclose: false,
	      minDate: -Infinity,
	      maxDate: +Infinity,
	      startView: 0,
	      minView: 0,
	      startWeek: 0,
	      daysOfWeekDisabled: '',
	      hasToday: false,
	      hasClear: false,
	      iconLeft: 'glyphicon glyphicon-chevron-left',
	      iconRight: 'glyphicon glyphicon-chevron-right'
	    };
	    this.$get = [ '$window', '$document', '$rootScope', '$sce', '$dateFormatter', 'datepickerViews', '$tooltip', '$timeout', function($window, $document, $rootScope, $sce, $dateFormatter, datepickerViews, $tooltip, $timeout) {
	      var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	      var isTouch = 'createTouch' in $window.document && isNative;
	      if (!defaults.lang) defaults.lang = $dateFormatter.getDefaultLocale();
	      function DatepickerFactory(element, controller, config) {
	        var $datepicker = $tooltip(element, angular.extend({}, defaults, config));
	        var parentScope = config.scope;
	        var options = $datepicker.$options;
	        var scope = $datepicker.$scope;
	        if (options.startView) options.startView -= options.minView;
	        var pickerViews = datepickerViews($datepicker);
	        $datepicker.$views = pickerViews.views;
	        var viewDate = pickerViews.viewDate;
	        scope.$mode = options.startView;
	        scope.$iconLeft = options.iconLeft;
	        scope.$iconRight = options.iconRight;
	        scope.$hasToday = options.hasToday;
	        scope.$hasClear = options.hasClear;
	        var $picker = $datepicker.$views[scope.$mode];
	        scope.$select = function(date, disabled) {
	          if (disabled) return;
	          $datepicker.select(date);
	        };
	        scope.$selectPane = function(value) {
	          $datepicker.$selectPane(value);
	        };
	        scope.$toggleMode = function() {
	          $datepicker.setMode((scope.$mode + 1) % $datepicker.$views.length);
	        };
	        scope.$setToday = function() {
	          if (options.autoclose) {
	            $datepicker.setMode(0);
	            $datepicker.select(new Date());
	          } else {
	            $datepicker.select(new Date(), true);
	          }
	        };
	        scope.$clear = function() {
	          if (options.autoclose) {
	            $datepicker.setMode(0);
	            $datepicker.select(null);
	          } else {
	            $datepicker.select(null, true);
	          }
	        };
	        $datepicker.update = function(date) {
	          if (angular.isDate(date) && !isNaN(date.getTime())) {
	            $datepicker.$date = date;
	            $picker.update.call($picker, date);
	          }
	          $datepicker.$build(true);
	        };
	        $datepicker.updateDisabledDates = function(dateRanges) {
	          options.disabledDateRanges = dateRanges;
	          for (var i = 0, l = scope.rows.length; i < l; i++) {
	            angular.forEach(scope.rows[i], $datepicker.$setDisabledEl);
	          }
	        };
	        $datepicker.select = function(date, keep) {
	          if (angular.isDate(date)) {
	            if (!angular.isDate(controller.$dateValue) || isNaN(controller.$dateValue.getTime())) {
	              controller.$dateValue = new Date(date);
	            }
	          } else {
	            controller.$dateValue = null;
	          }
	          if (!scope.$mode || keep) {
	            controller.$setViewValue(angular.copy(date));
	            controller.$render();
	            if (options.autoclose && !keep) {
	              $timeout(function() {
	                $datepicker.hide(true);
	              });
	            }
	          } else {
	            angular.extend(viewDate, {
	              year: date.getFullYear(),
	              month: date.getMonth(),
	              date: date.getDate()
	            });
	            $datepicker.setMode(scope.$mode - 1);
	            $datepicker.$build();
	          }
	        };
	        $datepicker.setMode = function(mode) {
	          scope.$mode = mode;
	          $picker = $datepicker.$views[scope.$mode];
	          $datepicker.$build();
	        };
	        $datepicker.$build = function(pristine) {
	          if (pristine === true && $picker.built) return;
	          if (pristine === false && !$picker.built) return;
	          $picker.build.call($picker);
	        };
	        $datepicker.$updateSelected = function() {
	          for (var i = 0, l = scope.rows.length; i < l; i++) {
	            angular.forEach(scope.rows[i], updateSelected);
	          }
	        };
	        $datepicker.$isSelected = function(date) {
	          return $picker.isSelected(date);
	        };
	        $datepicker.$setDisabledEl = function(el) {
	          el.disabled = $picker.isDisabled(el.date);
	        };
	        $datepicker.$selectPane = function(value) {
	          var steps = $picker.steps;
	          var targetDate = new Date(Date.UTC(viewDate.year + (steps.year || 0) * value, viewDate.month + (steps.month || 0) * value, 1));
	          angular.extend(viewDate, {
	            year: targetDate.getUTCFullYear(),
	            month: targetDate.getUTCMonth(),
	            date: targetDate.getUTCDate()
	          });
	          $datepicker.$build();
	        };
	        $datepicker.$onMouseDown = function(evt) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          if (isTouch) {
	            var targetEl = angular.element(evt.target);
	            if (targetEl[0].nodeName.toLowerCase() !== 'button') {
	              targetEl = targetEl.parent();
	            }
	            targetEl.triggerHandler('click');
	          }
	        };
	        $datepicker.$onKeyDown = function(evt) {
	          if (!/(38|37|39|40|13)/.test(evt.keyCode) || evt.shiftKey || evt.altKey) return;
	          evt.preventDefault();
	          evt.stopPropagation();
	          if (evt.keyCode === 13) {
	            if (!scope.$mode) {
	              $datepicker.hide(true);
	            } else {
	              scope.$apply(function() {
	                $datepicker.setMode(scope.$mode - 1);
	              });
	            }
	            return;
	          }
	          $picker.onKeyDown(evt);
	          parentScope.$digest();
	        };
	        function updateSelected(el) {
	          el.selected = $datepicker.$isSelected(el.date);
	        }
	        function focusElement() {
	          element[0].focus();
	        }
	        var _init = $datepicker.init;
	        $datepicker.init = function() {
	          if (isNative && options.useNative) {
	            element.prop('type', 'date');
	            element.css('-webkit-appearance', 'textfield');
	            return;
	          } else if (isTouch) {
	            element.prop('type', 'text');
	            element.attr('readonly', 'true');
	            element.on('click', focusElement);
	          }
	          _init();
	        };
	        var _destroy = $datepicker.destroy;
	        $datepicker.destroy = function() {
	          if (isNative && options.useNative) {
	            element.off('click', focusElement);
	          }
	          _destroy();
	        };
	        var _show = $datepicker.show;
	        $datepicker.show = function() {
	          if (!isTouch && element.attr('readonly') || element.attr('disabled')) return;
	          _show();
	          $timeout(function() {
	            if (!$datepicker.$isShown) return;
	            $datepicker.$element.on(isTouch ? 'touchstart' : 'mousedown', $datepicker.$onMouseDown);
	            if (options.keyboard) {
	              element.on('keydown', $datepicker.$onKeyDown);
	            }
	          }, 0, false);
	        };
	        var _hide = $datepicker.hide;
	        $datepicker.hide = function(blur) {
	          if (!$datepicker.$isShown) return;
	          $datepicker.$element.off(isTouch ? 'touchstart' : 'mousedown', $datepicker.$onMouseDown);
	          if (options.keyboard) {
	            element.off('keydown', $datepicker.$onKeyDown);
	          }
	          _hide(blur);
	        };
	        return $datepicker;
	      }
	      DatepickerFactory.defaults = defaults;
	      return DatepickerFactory;
	    } ];
	  }).directive('bsDatepicker', [ '$window', '$parse', '$q', '$dateFormatter', '$dateParser', '$datepicker', function($window, $parse, $q, $dateFormatter, $dateParser, $datepicker) {
	    var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	    return {
	      restrict: 'EAC',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'autoclose', 'dateType', 'dateFormat', 'timezone', 'modelDateFormat', 'dayFormat', 'strictFormat', 'startWeek', 'startDate', 'useNative', 'lang', 'startView', 'minView', 'iconLeft', 'iconRight', 'daysOfWeekDisabled', 'id', 'prefixClass', 'prefixEvent', 'hasToday', 'hasClear' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'autoclose', 'useNative', 'hasToday', 'hasClear' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
	            options[key] = false;
	          }
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        var datepicker = $datepicker(element, controller, options);
	        options = datepicker.$options;
	        if (isNative && options.useNative) options.dateFormat = 'yyyy-MM-dd';
	        var lang = options.lang;
	        var formatDate = function(date, format) {
	          return $dateFormatter.formatDate(date, format, lang);
	        };
	        var dateParser = $dateParser({
	          format: options.dateFormat,
	          lang: lang,
	          strict: options.strictFormat
	        });
	        if (attr.bsShow) {
	          scope.$watch(attr.bsShow, function(newValue, oldValue) {
	            if (!datepicker || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(datepicker),?/i);
	            if (newValue === true) {
	              datepicker.show();
	            } else {
	              datepicker.hide();
	            }
	          });
	        }
	        angular.forEach([ 'minDate', 'maxDate' ], function(key) {
	          if (angular.isDefined(attr[key])) {
	            attr.$observe(key, function(newValue) {
	              datepicker.$options[key] = dateParser.getDateForAttribute(key, newValue);
	              if (!isNaN(datepicker.$options[key])) datepicker.$build(false);
	              validateAgainstMinMaxDate(controller.$dateValue);
	            });
	          }
	        });
	        if (angular.isDefined(attr.dateFormat)) {
	          attr.$observe('dateFormat', function(newValue) {
	            datepicker.$options.dateFormat = newValue;
	          });
	        }
	        scope.$watch(attr.ngModel, function(newValue, oldValue) {
	          datepicker.update(controller.$dateValue);
	        }, true);
	        function normalizeDateRanges(ranges) {
	          if (!ranges || !ranges.length) return null;
	          return ranges;
	        }
	        if (angular.isDefined(attr.disabledDates)) {
	          scope.$watch(attr.disabledDates, function(disabledRanges, previousValue) {
	            disabledRanges = normalizeDateRanges(disabledRanges);
	            previousValue = normalizeDateRanges(previousValue);
	            if (disabledRanges) {
	              datepicker.updateDisabledDates(disabledRanges);
	            }
	          });
	        }
	        function validateAgainstMinMaxDate(parsedDate) {
	          if (!angular.isDate(parsedDate)) return;
	          var isMinValid = isNaN(datepicker.$options.minDate) || parsedDate.getTime() >= datepicker.$options.minDate;
	          var isMaxValid = isNaN(datepicker.$options.maxDate) || parsedDate.getTime() <= datepicker.$options.maxDate;
	          var isValid = isMinValid && isMaxValid;
	          controller.$setValidity('date', isValid);
	          controller.$setValidity('min', isMinValid);
	          controller.$setValidity('max', isMaxValid);
	          if (isValid) controller.$dateValue = parsedDate;
	        }
	        controller.$parsers.unshift(function(viewValue) {
	          var date;
	          if (!viewValue) {
	            controller.$setValidity('date', true);
	            return null;
	          }
	          var parsedDate = dateParser.parse(viewValue, controller.$dateValue);
	          if (!parsedDate || isNaN(parsedDate.getTime())) {
	            controller.$setValidity('date', false);
	            return;
	          }
	          validateAgainstMinMaxDate(parsedDate);
	          if (options.dateType === 'string') {
	            date = dateParser.timezoneOffsetAdjust(parsedDate, options.timezone, true);
	            return formatDate(date, options.modelDateFormat || options.dateFormat);
	          }
	          date = dateParser.timezoneOffsetAdjust(controller.$dateValue, options.timezone, true);
	          if (options.dateType === 'number') {
	            return date.getTime();
	          } else if (options.dateType === 'unix') {
	            return date.getTime() / 1e3;
	          } else if (options.dateType === 'iso') {
	            return date.toISOString();
	          }
	          return new Date(date);
	        });
	        controller.$formatters.push(function(modelValue) {
	          var date;
	          if (angular.isUndefined(modelValue) || modelValue === null) {
	            date = NaN;
	          } else if (angular.isDate(modelValue)) {
	            date = modelValue;
	          } else if (options.dateType === 'string') {
	            date = dateParser.parse(modelValue, null, options.modelDateFormat);
	          } else if (options.dateType === 'unix') {
	            date = new Date(modelValue * 1e3);
	          } else {
	            date = new Date(modelValue);
	          }
	          controller.$dateValue = dateParser.timezoneOffsetAdjust(date, options.timezone);
	          return getDateFormattedString();
	        });
	        controller.$render = function() {
	          element.val(getDateFormattedString());
	        };
	        function getDateFormattedString() {
	          return !controller.$dateValue || isNaN(controller.$dateValue.getTime()) ? '' : formatDate(controller.$dateValue, options.dateFormat);
	        }
	        scope.$on('$destroy', function() {
	          if (datepicker) datepicker.destroy();
	          options = null;
	          datepicker = null;
	        });
	      }
	    };
	  } ]).provider('datepickerViews', function() {
	    function split(arr, size) {
	      var arrays = [];
	      while (arr.length > 0) {
	        arrays.push(arr.splice(0, size));
	      }
	      return arrays;
	    }
	    function mod(n, m) {
	      return (n % m + m) % m;
	    }
	    this.$get = [ '$dateFormatter', '$dateParser', '$sce', function($dateFormatter, $dateParser, $sce) {
	      return function(picker) {
	        var scope = picker.$scope;
	        var options = picker.$options;
	        var lang = options.lang;
	        var formatDate = function(date, format) {
	          return $dateFormatter.formatDate(date, format, lang);
	        };
	        var dateParser = $dateParser({
	          format: options.dateFormat,
	          lang: lang,
	          strict: options.strictFormat
	        });
	        var weekDaysMin = $dateFormatter.weekdaysShort(lang);
	        var weekDaysLabels = weekDaysMin.slice(options.startWeek).concat(weekDaysMin.slice(0, options.startWeek));
	        var weekDaysLabelsHtml = $sce.trustAsHtml('<th class="dow text-center">' + weekDaysLabels.join('</th><th class="dow text-center">') + '</th>');
	        var startDate = picker.$date || (options.startDate ? dateParser.getDateForAttribute('startDate', options.startDate) : new Date());
	        var viewDate = {
	          year: startDate.getFullYear(),
	          month: startDate.getMonth(),
	          date: startDate.getDate()
	        };
	        var views = [ {
	          format: options.dayFormat,
	          split: 7,
	          steps: {
	            month: 1
	          },
	          update: function(date, force) {
	            if (!this.built || force || date.getFullYear() !== viewDate.year || date.getMonth() !== viewDate.month) {
	              angular.extend(viewDate, {
	                year: picker.$date.getFullYear(),
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$build();
	            } else if (date.getDate() !== viewDate.date || date.getDate() === 1) {
	              viewDate.date = picker.$date.getDate();
	              picker.$updateSelected();
	            }
	          },
	          build: function() {
	            var firstDayOfMonth = new Date(viewDate.year, viewDate.month, 1);
	            var firstDayOfMonthOffset = firstDayOfMonth.getTimezoneOffset();
	            var firstDate = new Date(+firstDayOfMonth - mod(firstDayOfMonth.getDay() - options.startWeek, 7) * 864e5);
	            var firstDateOffset = firstDate.getTimezoneOffset();
	            var today = dateParser.timezoneOffsetAdjust(new Date(), options.timezone).toDateString();
	            if (firstDateOffset !== firstDayOfMonthOffset) firstDate = new Date(+firstDate + (firstDateOffset - firstDayOfMonthOffset) * 6e4);
	            var days = [];
	            var day;
	            for (var i = 0; i < 42; i++) {
	              day = dateParser.daylightSavingAdjust(new Date(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate() + i));
	              days.push({
	                date: day,
	                isToday: day.toDateString() === today,
	                label: formatDate(day, this.format),
	                selected: picker.$date && this.isSelected(day),
	                muted: day.getMonth() !== viewDate.month,
	                disabled: this.isDisabled(day)
	              });
	            }
	            scope.title = formatDate(firstDayOfMonth, options.monthTitleFormat);
	            scope.showLabels = true;
	            scope.labels = weekDaysLabelsHtml;
	            scope.rows = split(days, this.split);
	            scope.isTodayDisabled = this.isDisabled(new Date());
	            this.built = true;
	          },
	          isSelected: function(date) {
	            return picker.$date && date.getFullYear() === picker.$date.getFullYear() && date.getMonth() === picker.$date.getMonth() && date.getDate() === picker.$date.getDate();
	          },
	          isDisabled: function(date) {
	            var time = date.getTime();
	            if (time < options.minDate || time > options.maxDate) return true;
	            if (options.daysOfWeekDisabled.indexOf(date.getDay()) !== -1) return true;
	            if (options.disabledDateRanges) {
	              for (var i = 0; i < options.disabledDateRanges.length; i++) {
	                if (time >= options.disabledDateRanges[i].start && time <= options.disabledDateRanges[i].end) {
	                  return true;
	                }
	              }
	            }
	            return false;
	          },
	          onKeyDown: function(evt) {
	            if (!picker.$date) {
	              return;
	            }
	            var actualTime = picker.$date.getTime();
	            var newDate;
	            if (evt.keyCode === 37) newDate = new Date(actualTime - 1 * 864e5); else if (evt.keyCode === 38) newDate = new Date(actualTime - 7 * 864e5); else if (evt.keyCode === 39) newDate = new Date(actualTime + 1 * 864e5); else if (evt.keyCode === 40) newDate = new Date(actualTime + 7 * 864e5);
	            if (!this.isDisabled(newDate)) picker.select(newDate, true);
	          }
	        }, {
	          name: 'month',
	          format: options.monthFormat,
	          split: 4,
	          steps: {
	            year: 1
	          },
	          update: function(date, force) {
	            if (!this.built || date.getFullYear() !== viewDate.year) {
	              angular.extend(viewDate, {
	                year: picker.$date.getFullYear(),
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$build();
	            } else if (date.getMonth() !== viewDate.month) {
	              angular.extend(viewDate, {
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$updateSelected();
	            }
	          },
	          build: function() {
	            var months = [];
	            var month;
	            for (var i = 0; i < 12; i++) {
	              month = new Date(viewDate.year, i, 1);
	              months.push({
	                date: month,
	                label: formatDate(month, this.format),
	                selected: picker.$isSelected(month),
	                disabled: this.isDisabled(month)
	              });
	            }
	            scope.title = formatDate(month, options.yearTitleFormat);
	            scope.showLabels = false;
	            scope.rows = split(months, this.split);
	            this.built = true;
	          },
	          isSelected: function(date) {
	            return picker.$date && date.getFullYear() === picker.$date.getFullYear() && date.getMonth() === picker.$date.getMonth();
	          },
	          isDisabled: function(date) {
	            var lastDate = +new Date(date.getFullYear(), date.getMonth() + 1, 0);
	            return lastDate < options.minDate || date.getTime() > options.maxDate;
	          },
	          onKeyDown: function(evt) {
	            if (!picker.$date) {
	              return;
	            }
	            var actualMonth = picker.$date.getMonth();
	            var newDate = new Date(picker.$date);
	            if (evt.keyCode === 37) newDate.setMonth(actualMonth - 1); else if (evt.keyCode === 38) newDate.setMonth(actualMonth - 4); else if (evt.keyCode === 39) newDate.setMonth(actualMonth + 1); else if (evt.keyCode === 40) newDate.setMonth(actualMonth + 4);
	            if (!this.isDisabled(newDate)) picker.select(newDate, true);
	          }
	        }, {
	          name: 'year',
	          format: options.yearFormat,
	          split: 4,
	          steps: {
	            year: 12
	          },
	          update: function(date, force) {
	            if (!this.built || force || parseInt(date.getFullYear() / 20, 10) !== parseInt(viewDate.year / 20, 10)) {
	              angular.extend(viewDate, {
	                year: picker.$date.getFullYear(),
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$build();
	            } else if (date.getFullYear() !== viewDate.year) {
	              angular.extend(viewDate, {
	                year: picker.$date.getFullYear(),
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$updateSelected();
	            }
	          },
	          build: function() {
	            var firstYear = viewDate.year - viewDate.year % (this.split * 3);
	            var years = [];
	            var year;
	            for (var i = 0; i < 12; i++) {
	              year = new Date(firstYear + i, 0, 1);
	              years.push({
	                date: year,
	                label: formatDate(year, this.format),
	                selected: picker.$isSelected(year),
	                disabled: this.isDisabled(year)
	              });
	            }
	            scope.title = years[0].label + '-' + years[years.length - 1].label;
	            scope.showLabels = false;
	            scope.rows = split(years, this.split);
	            this.built = true;
	          },
	          isSelected: function(date) {
	            return picker.$date && date.getFullYear() === picker.$date.getFullYear();
	          },
	          isDisabled: function(date) {
	            var lastDate = +new Date(date.getFullYear() + 1, 0, 0);
	            return lastDate < options.minDate || date.getTime() > options.maxDate;
	          },
	          onKeyDown: function(evt) {
	            if (!picker.$date) {
	              return;
	            }
	            var actualYear = picker.$date.getFullYear();
	            var newDate = new Date(picker.$date);
	            if (evt.keyCode === 37) newDate.setYear(actualYear - 1); else if (evt.keyCode === 38) newDate.setYear(actualYear - 4); else if (evt.keyCode === 39) newDate.setYear(actualYear + 1); else if (evt.keyCode === 40) newDate.setYear(actualYear + 4);
	            if (!this.isDisabled(newDate)) picker.select(newDate, true);
	          }
	        } ];
	        return {
	          views: options.minView ? Array.prototype.slice.call(views, options.minView) : views,
	          viewDate: viewDate
	        };
	      };
	    } ];
	  });
	  angular.module('mgcrea.ngStrap.collapse', []).provider('$collapse', function() {
	    var defaults = this.defaults = {
	      animation: 'am-collapse',
	      disallowToggle: false,
	      activeClass: 'in',
	      startCollapsed: false,
	      allowMultiple: false
	    };
	    var controller = this.controller = function($scope, $element, $attrs) {
	      var self = this;
	      self.$options = angular.copy(defaults);
	      angular.forEach([ 'animation', 'disallowToggle', 'activeClass', 'startCollapsed', 'allowMultiple' ], function(key) {
	        if (angular.isDefined($attrs[key])) self.$options[key] = $attrs[key];
	      });
	      var falseValueRegExp = /^(false|0|)$/i;
	      angular.forEach([ 'disallowToggle', 'startCollapsed', 'allowMultiple' ], function(key) {
	        if (angular.isDefined($attrs[key]) && falseValueRegExp.test($attrs[key])) {
	          self.$options[key] = false;
	        }
	      });
	      self.$toggles = [];
	      self.$targets = [];
	      self.$viewChangeListeners = [];
	      self.$registerToggle = function(element) {
	        self.$toggles.push(element);
	      };
	      self.$registerTarget = function(element) {
	        self.$targets.push(element);
	      };
	      self.$unregisterToggle = function(element) {
	        var index = self.$toggles.indexOf(element);
	        self.$toggles.splice(index, 1);
	      };
	      self.$unregisterTarget = function(element) {
	        var index = self.$targets.indexOf(element);
	        self.$targets.splice(index, 1);
	        if (self.$options.allowMultiple) {
	          deactivateItem(element);
	        }
	        fixActiveItemIndexes(index);
	        self.$viewChangeListeners.forEach(function(fn) {
	          fn();
	        });
	      };
	      self.$targets.$active = !self.$options.startCollapsed ? [ 0 ] : [];
	      self.$setActive = $scope.$setActive = function(value) {
	        if (angular.isArray(value)) {
	          self.$targets.$active = value;
	        } else if (!self.$options.disallowToggle && isActive(value)) {
	          deactivateItem(value);
	        } else {
	          activateItem(value);
	        }
	        self.$viewChangeListeners.forEach(function(fn) {
	          fn();
	        });
	      };
	      self.$activeIndexes = function() {
	        if (self.$options.allowMultiple) {
	          return self.$targets.$active;
	        }
	        return self.$targets.$active.length === 1 ? self.$targets.$active[0] : -1;
	      };
	      function fixActiveItemIndexes(index) {
	        var activeIndexes = self.$targets.$active;
	        for (var i = 0; i < activeIndexes.length; i++) {
	          if (index < activeIndexes[i]) {
	            activeIndexes[i] = activeIndexes[i] - 1;
	          }
	          if (activeIndexes[i] === self.$targets.length) {
	            activeIndexes[i] = self.$targets.length - 1;
	          }
	        }
	      }
	      function isActive(value) {
	        var activeItems = self.$targets.$active;
	        return activeItems.indexOf(value) !== -1;
	      }
	      function deactivateItem(value) {
	        var index = self.$targets.$active.indexOf(value);
	        if (index !== -1) {
	          self.$targets.$active.splice(index, 1);
	        }
	      }
	      function activateItem(value) {
	        if (!self.$options.allowMultiple) {
	          self.$targets.$active.splice(0, 1);
	        }
	        if (self.$targets.$active.indexOf(value) === -1) {
	          self.$targets.$active.push(value);
	        }
	      }
	    };
	    this.$get = function() {
	      var $collapse = {};
	      $collapse.defaults = defaults;
	      $collapse.controller = controller;
	      return $collapse;
	    };
	  }).directive('bsCollapse', [ '$window', '$animate', '$collapse', function($window, $animate, $collapse) {
	    return {
	      require: [ '?ngModel', 'bsCollapse' ],
	      controller: [ '$scope', '$element', '$attrs', $collapse.controller ],
	      link: function postLink(scope, element, attrs, controllers) {
	        var ngModelCtrl = controllers[0];
	        var bsCollapseCtrl = controllers[1];
	        if (ngModelCtrl) {
	          bsCollapseCtrl.$viewChangeListeners.push(function() {
	            ngModelCtrl.$setViewValue(bsCollapseCtrl.$activeIndexes());
	          });
	          ngModelCtrl.$formatters.push(function(modelValue) {
	            if (angular.isArray(modelValue)) {
	              bsCollapseCtrl.$setActive(modelValue);
	            } else {
	              var activeIndexes = bsCollapseCtrl.$activeIndexes();
	              if (angular.isArray(activeIndexes)) {
	                if (activeIndexes.indexOf(modelValue * 1) === -1) {
	                  bsCollapseCtrl.$setActive(modelValue * 1);
	                }
	              } else if (activeIndexes !== modelValue * 1) {
	                bsCollapseCtrl.$setActive(modelValue * 1);
	              }
	            }
	            return modelValue;
	          });
	        }
	      }
	    };
	  } ]).directive('bsCollapseToggle', function() {
	    return {
	      require: [ '^?ngModel', '^bsCollapse' ],
	      link: function postLink(scope, element, attrs, controllers) {
	        var bsCollapseCtrl = controllers[1];
	        element.attr('data-toggle', 'collapse');
	        bsCollapseCtrl.$registerToggle(element);
	        scope.$on('$destroy', function() {
	          bsCollapseCtrl.$unregisterToggle(element);
	        });
	        element.on('click', function() {
	          if (!attrs.disabled) {
	            var index = attrs.bsCollapseToggle && attrs.bsCollapseToggle !== 'bs-collapse-toggle' ? attrs.bsCollapseToggle : bsCollapseCtrl.$toggles.indexOf(element);
	            bsCollapseCtrl.$setActive(index * 1);
	            scope.$apply();
	          }
	        });
	      }
	    };
	  }).directive('bsCollapseTarget', [ '$animate', function($animate) {
	    return {
	      require: [ '^?ngModel', '^bsCollapse' ],
	      link: function postLink(scope, element, attrs, controllers) {
	        var bsCollapseCtrl = controllers[1];
	        element.addClass('collapse');
	        if (bsCollapseCtrl.$options.animation) {
	          element.addClass(bsCollapseCtrl.$options.animation);
	        }
	        bsCollapseCtrl.$registerTarget(element);
	        scope.$on('$destroy', function() {
	          bsCollapseCtrl.$unregisterTarget(element);
	        });
	        function render() {
	          var index = bsCollapseCtrl.$targets.indexOf(element);
	          var active = bsCollapseCtrl.$activeIndexes();
	          var action = 'removeClass';
	          if (angular.isArray(active)) {
	            if (active.indexOf(index) !== -1) {
	              action = 'addClass';
	            }
	          } else if (index === active) {
	            action = 'addClass';
	          }
	          $animate[action](element, bsCollapseCtrl.$options.activeClass);
	        }
	        bsCollapseCtrl.$viewChangeListeners.push(function() {
	          render();
	        });
	        render();
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.aside', [ 'mgcrea.ngStrap.modal' ]).provider('$aside', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade-and-slide-right',
	      prefixClass: 'aside',
	      prefixEvent: 'aside',
	      placement: 'right',
	      templateUrl: 'aside/aside.tpl.html',
	      contentTemplate: false,
	      container: false,
	      element: null,
	      backdrop: true,
	      keyboard: true,
	      html: false,
	      show: true
	    };
	    this.$get = [ '$modal', function($modal) {
	      function AsideFactory(config) {
	        var $aside = {};
	        var options = angular.extend({}, defaults, config);
	        $aside = $modal(options);
	        return $aside;
	      }
	      return AsideFactory;
	    } ];
	  }).directive('bsAside', [ '$window', '$sce', '$aside', function($window, $sce, $aside) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr, transclusion) {
	        var options = {
	          scope: scope,
	          element: element,
	          show: false
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'backdrop', 'keyboard', 'html', 'container', 'animation' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'backdrop', 'keyboard', 'html', 'container' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        angular.forEach([ 'title', 'content' ], function(key) {
	          if (attr[key]) {
	            attr.$observe(key, function(newValue, oldValue) {
	              scope[key] = $sce.trustAsHtml(newValue);
	            });
	          }
	        });
	        if (attr.bsAside) {
	          scope.$watch(attr.bsAside, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.content = newValue;
	            }
	          }, true);
	        }
	        var aside = $aside(options);
	        element.on(attr.trigger || 'click', aside.toggle);
	        scope.$on('$destroy', function() {
	          if (aside) aside.destroy();
	          options = null;
	          aside = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.alert', [ 'mgcrea.ngStrap.modal' ]).provider('$alert', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'alert',
	      prefixEvent: 'alert',
	      placement: null,
	      templateUrl: 'alert/alert.tpl.html',
	      container: false,
	      element: null,
	      backdrop: false,
	      keyboard: true,
	      show: true,
	      duration: false,
	      type: false,
	      dismissable: true
	    };
	    this.$get = [ '$modal', '$timeout', function($modal, $timeout) {
	      function AlertFactory(config) {
	        var $alert = {};
	        var options = angular.extend({}, defaults, config);
	        $alert = $modal(options);
	        $alert.$scope.dismissable = !!options.dismissable;
	        if (options.type) {
	          $alert.$scope.type = options.type;
	        }
	        var show = $alert.show;
	        if (options.duration) {
	          $alert.show = function() {
	            show();
	            $timeout(function() {
	              $alert.hide();
	            }, options.duration * 1e3);
	          };
	        }
	        return $alert;
	      }
	      return AlertFactory;
	    } ];
	  }).directive('bsAlert', [ '$window', '$sce', '$alert', function($window, $sce, $alert) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr, transclusion) {
	        var options = {
	          scope: scope,
	          element: element,
	          show: false
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'keyboard', 'html', 'container', 'animation', 'duration', 'dismissable' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'keyboard', 'html', 'container', 'dismissable' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        if (!scope.hasOwnProperty('title')) {
	          scope.title = '';
	        }
	        angular.forEach([ 'title', 'content', 'type' ], function(key) {
	          if (attr[key]) {
	            attr.$observe(key, function(newValue, oldValue) {
	              scope[key] = $sce.trustAsHtml(newValue);
	            });
	          }
	        });
	        if (attr.bsAlert) {
	          scope.$watch(attr.bsAlert, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.content = newValue;
	            }
	          }, true);
	        }
	        var alert = $alert(options);
	        element.on(attr.trigger || 'click', alert.toggle);
	        scope.$on('$destroy', function() {
	          if (alert) alert.destroy();
	          options = null;
	          alert = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.affix', [ 'mgcrea.ngStrap.helpers.dimensions', 'mgcrea.ngStrap.helpers.debounce' ]).provider('$affix', function() {
	    var defaults = this.defaults = {
	      offsetTop: 'auto',
	      inlineStyles: true,
	      setWidth: true
	    };
	    this.$get = [ '$window', 'debounce', 'dimensions', function($window, debounce, dimensions) {
	      var bodyEl = angular.element($window.document.body);
	      var windowEl = angular.element($window);
	      function AffixFactory(element, config) {
	        var $affix = {};
	        var options = angular.extend({}, defaults, config);
	        var targetEl = options.target;
	        var reset = 'affix affix-top affix-bottom';
	        var setWidth = false;
	        var initialAffixTop = 0;
	        var initialOffsetTop = 0;
	        var offsetTop = 0;
	        var offsetBottom = 0;
	        var affixed = null;
	        var unpin = null;
	        var parent = element.parent();
	        if (options.offsetParent) {
	          if (options.offsetParent.match(/^\d+$/)) {
	            for (var i = 0; i < options.offsetParent * 1 - 1; i++) {
	              parent = parent.parent();
	            }
	          } else {
	            parent = angular.element(options.offsetParent);
	          }
	        }
	        $affix.init = function() {
	          this.$parseOffsets();
	          initialOffsetTop = dimensions.offset(element[0]).top + initialAffixTop;
	          setWidth = options.setWidth && !element[0].style.width;
	          targetEl.on('scroll', this.checkPosition);
	          targetEl.on('click', this.checkPositionWithEventLoop);
	          windowEl.on('resize', this.$debouncedOnResize);
	          this.checkPosition();
	          this.checkPositionWithEventLoop();
	        };
	        $affix.destroy = function() {
	          targetEl.off('scroll', this.checkPosition);
	          targetEl.off('click', this.checkPositionWithEventLoop);
	          windowEl.off('resize', this.$debouncedOnResize);
	        };
	        $affix.checkPositionWithEventLoop = function() {
	          setTimeout($affix.checkPosition, 1);
	        };
	        $affix.checkPosition = function() {
	          var scrollTop = getScrollTop();
	          var position = dimensions.offset(element[0]);
	          var elementHeight = dimensions.height(element[0]);
	          var affix = getRequiredAffixClass(unpin, position, elementHeight);
	          if (affixed === affix) return;
	          affixed = affix;
	          if (affix === 'top') {
	            unpin = null;
	            if (setWidth) {
	              element.css('width', '');
	            }
	            if (options.inlineStyles) {
	              element.css('position', options.offsetParent ? '' : 'relative');
	              element.css('top', '');
	            }
	          } else if (affix === 'bottom') {
	            if (options.offsetUnpin) {
	              unpin = -(options.offsetUnpin * 1);
	            } else {
	              unpin = position.top - scrollTop;
	            }
	            if (setWidth) {
	              element.css('width', '');
	            }
	            if (options.inlineStyles) {
	              element.css('position', options.offsetParent ? '' : 'relative');
	              element.css('top', options.offsetParent ? '' : bodyEl[0].offsetHeight - offsetBottom - elementHeight - initialOffsetTop + 'px');
	            }
	          } else {
	            unpin = null;
	            if (setWidth) {
	              element.css('width', element[0].offsetWidth + 'px');
	            }
	            if (options.inlineStyles) {
	              element.css('position', 'fixed');
	              element.css('top', initialAffixTop + 'px');
	            }
	          }
	          element.removeClass(reset).addClass('affix' + (affix !== 'middle' ? '-' + affix : ''));
	        };
	        $affix.$onResize = function() {
	          $affix.$parseOffsets();
	          $affix.checkPosition();
	        };
	        $affix.$debouncedOnResize = debounce($affix.$onResize, 50);
	        $affix.$parseOffsets = function() {
	          var initialPosition = element[0].style.position;
	          var initialTop = element[0].style.top;
	          if (options.inlineStyles) {
	            element.css('position', options.offsetParent ? '' : 'relative');
	            element.css('top', '');
	          }
	          if (options.offsetTop) {
	            if (options.offsetTop === 'auto') {
	              options.offsetTop = '+0';
	            }
	            if (options.offsetTop.match(/^[-+]\d+$/)) {
	              initialAffixTop = -options.offsetTop * 1;
	              if (options.offsetParent) {
	                offsetTop = dimensions.offset(parent[0]).top + options.offsetTop * 1;
	              } else {
	                offsetTop = dimensions.offset(element[0]).top - dimensions.css(element[0], 'marginTop', true) + options.offsetTop * 1;
	              }
	            } else {
	              offsetTop = options.offsetTop * 1;
	            }
	          }
	          if (options.offsetBottom) {
	            if (options.offsetParent && options.offsetBottom.match(/^[-+]\d+$/)) {
	              offsetBottom = getScrollHeight() - (dimensions.offset(parent[0]).top + dimensions.height(parent[0])) + options.offsetBottom * 1 + 1;
	            } else {
	              offsetBottom = options.offsetBottom * 1;
	            }
	          }
	          if (options.inlineStyles) {
	            element.css('position', initialPosition);
	            element.css('top', initialTop);
	          }
	        };
	        function getRequiredAffixClass(_unpin, position, elementHeight) {
	          var scrollTop = getScrollTop();
	          var scrollHeight = getScrollHeight();
	          if (scrollTop <= offsetTop) {
	            return 'top';
	          } else if (_unpin !== null) {
	            return scrollTop + _unpin <= position.top ? 'middle' : 'bottom';
	          } else if (offsetBottom !== null && position.top + elementHeight + initialAffixTop >= scrollHeight - offsetBottom) {
	            return 'bottom';
	          }
	          return 'middle';
	        }
	        function getScrollTop() {
	          return targetEl[0] === $window ? $window.pageYOffset : targetEl[0].scrollTop;
	        }
	        function getScrollHeight() {
	          return targetEl[0] === $window ? $window.document.body.scrollHeight : targetEl[0].scrollHeight;
	        }
	        $affix.init();
	        return $affix;
	      }
	      return AffixFactory;
	    } ];
	  }).directive('bsAffix', [ '$affix', '$window', '$timeout', function($affix, $window, $timeout) {
	    return {
	      restrict: 'EAC',
	      require: '^?bsAffixTarget',
	      link: function postLink(scope, element, attr, affixTarget) {
	        var options = {
	          scope: scope,
	          target: affixTarget ? affixTarget.$element : angular.element($window)
	        };
	        angular.forEach([ 'offsetTop', 'offsetBottom', 'offsetParent', 'offsetUnpin', 'inlineStyles', 'setWidth' ], function(key) {
	          if (angular.isDefined(attr[key])) {
	            var option = attr[key];
	            if (/true/i.test(option)) option = true;
	            if (/false/i.test(option)) option = false;
	            options[key] = option;
	          }
	        });
	        var affix;
	        $timeout(function() {
	          affix = $affix(element, options);
	        });
	        scope.$on('$destroy', function() {
	          if (affix) affix.destroy();
	          options = null;
	          affix = null;
	        });
	      }
	    };
	  } ]).directive('bsAffixTarget', function() {
	    return {
	      controller: [ '$element', function($element) {
	        this.$element = $element;
	      } ]
	    };
	  });
	  angular.module('mgcrea.ngStrap', [ 'mgcrea.ngStrap.modal', 'mgcrea.ngStrap.aside', 'mgcrea.ngStrap.alert', 'mgcrea.ngStrap.button', 'mgcrea.ngStrap.select', 'mgcrea.ngStrap.datepicker', 'mgcrea.ngStrap.timepicker', 'mgcrea.ngStrap.navbar', 'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.popover', 'mgcrea.ngStrap.dropdown', 'mgcrea.ngStrap.typeahead', 'mgcrea.ngStrap.scrollspy', 'mgcrea.ngStrap.affix', 'mgcrea.ngStrap.tab', 'mgcrea.ngStrap.collapse' ]);
	})(window, document);

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	/**
	 * angular-strap
	 * @version v2.3.12 - 2017-01-26
	 * @link http://mgcrea.github.io/angular-strap
	 * @author Olivier Louvignes <olivier@mg-crea.com> (https://github.com/mgcrea)
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	!function(t,e,n){'use strict';angular.module('mgcrea.ngStrap.alert').run(['$templateCache',function(t){t.put('alert/alert.tpl.html','<div class="alert" ng-class="[type ? \'alert-\' + type : null]"><button type="button" class="close" ng-if="dismissable" ng-click="$hide()">&times;</button> <span ng-if="title"><strong ng-bind="title"></strong>&nbsp;<span ng-bind-html="content"></span> </span><span ng-if="!title" ng-bind-html="content"></span></div>')}]),angular.module('mgcrea.ngStrap.aside').run(['$templateCache',function(t){t.put('aside/aside.tpl.html','<div class="aside" tabindex="-1" role="dialog"><div class="aside-dialog"><div class="aside-content"><div class="aside-header" ng-show="title"><button type="button" class="close" ng-click="$hide()">&times;</button><h4 class="aside-title" ng-bind="title"></h4></div><div class="aside-body" ng-bind="content"></div><div class="aside-footer"><button type="button" class="btn btn-default" ng-click="$hide()">Close</button></div></div></div></div>')}]),angular.module('mgcrea.ngStrap.datepicker').run(['$templateCache',function(t){t.put('datepicker/datepicker.tpl.html','<div class="dropdown-menu datepicker" ng-class="\'datepicker-mode-\' + $mode" style="max-width: 320px"><table style="table-layout: fixed; height: 100%; width: 100%"><thead><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$selectPane(-1)"><i class="{{$iconLeft}}"></i></button></th><th colspan="{{ rows[0].length - 2 }}"><button tabindex="-1" type="button" class="btn btn-default btn-block text-strong" ng-click="$toggleMode()"><strong style="text-transform: capitalize" ng-bind="title"></strong></button></th><th><button tabindex="-1" type="button" class="btn btn-default pull-right" ng-click="$selectPane(+1)"><i class="{{$iconRight}}"></i></button></th></tr><tr ng-if="showLabels" ng-bind-html="labels"></tr></thead><tbody><tr ng-repeat="(i, row) in rows" height="{{ 100 / rows.length }}%"><td class="text-center" ng-repeat="(j, el) in row"><button tabindex="-1" type="button" class="btn btn-default" style="width: 100%" ng-class="{\'btn-primary\': el.selected, \'btn-info btn-today\': el.isToday && !el.selected}" ng-click="$select(el.date, el.disabled)" ng-disabled="el.disabled"><span ng-class="{\'text-muted\': el.muted}" ng-bind="el.label"></span></button></td></tr></tbody><tfoot><tr><td colspan="{{ rows[0].length }}"><div class="btn-group btn-group-justified" role="group"><div class="btn-group" role="group" ng-if="$hasToday"><button type="button" class="btn btn-default today" ng-click="$setToday()" ng-disabled="isTodayDisabled"><strong style="text-transform: capitalize">Today</strong></button></div><div class="btn-group" role="group" ng-if="$hasClear"><button type="button" class="btn btn-default clear" ng-click="$clear()"><strong style="text-transform: capitalize">Clear</strong></button></div></div></td></tr></tfoot></table></div>')}]),angular.module('mgcrea.ngStrap.dropdown').run(['$templateCache',function(t){t.put('dropdown/dropdown.tpl.html','<ul tabindex="-1" class="dropdown-menu" role="menu" ng-show="content && content.length"><li role="presentation" ng-class="{divider: item.divider, active: item.active}" ng-repeat="item in content"><a role="menuitem" tabindex="-1" ng-href="{{item.href}}" ng-if="!item.divider && item.href" target="{{item.target || \'\'}}" ng-bind="item.text"></a> <a role="menuitem" tabindex="-1" href="javascript:void(0)" ng-if="!item.divider && item.click" ng-click="$eval(item.click);$hide()" ng-bind="item.text"></a></li></ul>')}]),angular.module('mgcrea.ngStrap.modal').run(['$templateCache',function(t){t.put('modal/modal.tpl.html','<div class="modal" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header" ng-show="title"><button type="button" class="close" aria-label="Close" ng-click="$hide()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" ng-bind="title"></h4></div><div class="modal-body" ng-bind="content"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$hide()">Close</button></div></div></div></div>')}]),angular.module('mgcrea.ngStrap.popover').run(['$templateCache',function(t){t.put('popover/popover.tpl.html','<div class="popover" tabindex="-1"><div class="arrow"></div><h3 class="popover-title" ng-bind="title" ng-show="title"></h3><div class="popover-content" ng-bind="content"></div></div>')}]),angular.module('mgcrea.ngStrap.select').run(['$templateCache',function(t){t.put('select/select.tpl.html','<ul tabindex="-1" class="select dropdown-menu" ng-show="$isVisible()" role="select"><li ng-if="$showAllNoneButtons"><div class="btn-group" style="margin-bottom: 5px; margin-left: 5px"><button type="button" class="btn btn-default btn-xs" ng-click="$selectAll()">{{$allText}}</button> <button type="button" class="btn btn-default btn-xs" ng-click="$selectNone()">{{$noneText}}</button></div></li><li role="presentation" ng-repeat="match in $matches" ng-class="{active: $isActive($index)}"><a style="cursor: default" role="menuitem" tabindex="-1" ng-click="$select($index, $event)"><i class="{{$iconCheckmark}} pull-right" ng-if="$isMultiple && $isActive($index)"></i> <span ng-bind="match.label"></span></a></li></ul>')}]),angular.module('mgcrea.ngStrap.tab').run(['$templateCache',function(t){t.put('tab/tab.tpl.html','<ul class="nav" ng-class="$navClass" role="tablist"><li role="presentation" ng-repeat="$pane in $panes track by $index" ng-class="[ $isActive($pane, $index) ? $activeClass : \'\', $pane.disabled ? \'disabled\' : \'\' ]"><a role="tab" data-toggle="tab" ng-click="!$pane.disabled && $setActive($pane.name || $index)" data-index="{{ $index }}" ng-bind-html="$pane.title" aria-controls="$pane.title" href=""></a></li></ul><div ng-transclude class="tab-content"></div>')}]),angular.module('mgcrea.ngStrap.timepicker').run(['$templateCache',function(t){t.put('timepicker/timepicker.tpl.html','<div class="dropdown-menu timepicker" style="min-width: 0px;width: auto"><table height="100%"><thead><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 0)"><i class="{{ $iconUp }}"></i></button></th><th>&nbsp;</th><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 1)"><i class="{{ $iconUp }}"></i></button></th><th ng-if="showSeconds">&nbsp;</th><th ng-if="showSeconds"><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 2)"><i class="{{ $iconUp }}"></i></button></th></tr></thead><tbody><tr ng-repeat="(i, row) in rows"><td class="text-center"><button tabindex="-1" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[0].selected}" ng-click="$select(row[0].date, 0)" ng-disabled="row[0].disabled"><span ng-class="{\'text-muted\': row[0].muted}" ng-bind="row[0].label"></span></button></td><td><span ng-bind="i == midIndex ? timeSeparator : \' \'"></span></td><td class="text-center"><button tabindex="-1" ng-if="row[1].date" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[1].selected}" ng-click="$select(row[1].date, 1)" ng-disabled="row[1].disabled"><span ng-class="{\'text-muted\': row[1].muted}" ng-bind="row[1].label"></span></button></td><td ng-if="showSeconds"><span ng-bind="i == midIndex ? timeSeparator : \' \'"></span></td><td ng-if="showSeconds" class="text-center"><button tabindex="-1" ng-if="row[2].date" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[2].selected}" ng-click="$select(row[2].date, 2)" ng-disabled="row[2].disabled"><span ng-class="{\'text-muted\': row[2].muted}" ng-bind="row[2].label"></span></button></td><td ng-if="showAM">&nbsp;</td><td ng-if="showAM"><button tabindex="-1" ng-show="i == midIndex - !isAM * 1" style="width: 100%" type="button" ng-class="{\'btn-primary\': !!isAM}" class="btn btn-default" ng-click="$switchMeridian()" ng-disabled="el.disabled">AM</button> <button tabindex="-1" ng-show="i == midIndex + 1 - !isAM * 1" style="width: 100%" type="button" ng-class="{\'btn-primary\': !isAM}" class="btn btn-default" ng-click="$switchMeridian()" ng-disabled="el.disabled">PM</button></td></tr></tbody><tfoot><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 0)"><i class="{{ $iconDown }}"></i></button></th><th>&nbsp;</th><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 1)"><i class="{{ $iconDown }}"></i></button></th><th ng-if="showSeconds">&nbsp;</th><th ng-if="showSeconds"><button ng-if="showSeconds" tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 2)"><i class="{{ $iconDown }}"></i></button></th></tr></tfoot></table></div>')}]),angular.module('mgcrea.ngStrap.tooltip').run(['$templateCache',function(t){t.put('tooltip/tooltip.tpl.html','<div class="tooltip in" ng-show="title"><div class="tooltip-arrow"></div><div class="tooltip-inner" ng-bind="title"></div></div>')}]),angular.module('mgcrea.ngStrap.typeahead').run(['$templateCache',function(t){t.put('typeahead/typeahead.tpl.html','<ul tabindex="-1" class="typeahead dropdown-menu" ng-show="$isVisible()" role="select"><li role="presentation" ng-repeat="match in $matches" ng-class="{active: $index == $activeIndex}"><a role="menuitem" tabindex="-1" ng-click="$select($index, $event)" ng-bind="match.label"></a></li></ul>')}])}(window,document);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(537)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory(require('angular-schema-form'));
	  } else {
	    root.angularSchemaFormDynamicSelect = factory(root.schemaForm);
	  }
	}(this, function(schemaForm) {
	angular.module("schemaForm").run(["$templateCache", function($templateCache) {$templateCache.put("directives/decorators/bootstrap/strap/strapmultiselect.html","<div ng-controller=\"dynamicSelectController\" class=\"form-group {{form.htmlClass}}\"\n     ng-class=\"{\'has-error\': hasError(), \'has-success\': hasSuccess()}\">\n    <label class=\"control-label {{form.labelHtmlClass}}\" ng-show=\"showTitle()\">{{form.title}}</label>\n\n    <div class=\"form-group {{form.fieldHtmlClass}}\" ng-init=\"populateTitleMap(form)\">\n        <button type=\"button\" class=\"btn btn-default\" sf-changed=\"form\" schema-validate=\"form\" ng-model=\"$$value$$\"\n                data-placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\')}}\"\n                data-html=\"1\"\n                data-multiple=\"1\"  data-multiple=\"1\" data-max-length=\"{{form.options.inlineMaxLength}}\"\n                data-max-length-html=\"{{form.options.inlineMaxLengthHtml}}\"\n                bs-options=\"item.value as item.name for item in form.titleMap | selectFilter:this:$$value$$:&quot;$$value$$&quot;\"\n                bs-select>\n        </button>\n        <span class=\"help-block\">{{ (hasError() && errorMessage(schemaError())) || form.description}}</span>\n    </div>\n</div>\n");
	$templateCache.put("directives/decorators/bootstrap/strap/strapselect.html","<div ng-controller=\"dynamicSelectController\" class=\"form-group {{form.htmlClass}}\"\n     ng-class=\"{\'has-error\': hasError(), \'has-success\': hasSuccess()}\">\n    <label class=\"control-label {{form.labelHtmlClass}}\" ng-show=\"showTitle()\">{{form.title}}</label>\n\n    <div class=\"form-group {{form.fieldHtmlClass}}\" ng-init=\"populateTitleMap(form)\">\n        <button ng-if=\"(form.options.multiple == \'true\') || (form.options.multiple == true)\"\n                type=\"button\" class=\"btn btn-default\" sf-changed=\"form\" schema-validate=\"form\" ng-model=\"$$value$$\"\n                data-placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\')}}\"\n                data-html=\"1\" data-multiple=\"1\" data-max-length=\"{{form.options.inlineMaxLength}}\"\n                data-max-length-html=\"{{form.options.inlineMaxLengthHtml}}\"\n                bs-options=\"item.value as item.name for item in form.titleMap | selectFilter:this:$$value$$:&quot;$$value$$&quot;\"\n                bs-select>\n        </button>\n        <button ng-if=\"!((form.options.multiple == \'true\') || (form.options.multiple == true))\"\n                type=\"button\" class=\"btn btn-default\" sf-changed=\"form\" schema-validate=\"form\" ng-model=\"$$value$$\"\n                data-placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\')}}\"\n                data-html=\"1\"\n                bs-options=\"item.value as item.name for item in form.titleMap | selectFilter:this:$$value$$:&quot;$$value$$&quot;\"\n                bs-select>\n        </button>\n        <span class=\"help-block\">{{ (hasError() && errorMessage(schemaError())) || form.description}} </span>\n    </div>\n</div>\n\n");}]);
	angular.module("schemaForm").run(["$templateCache", function($templateCache) {$templateCache.put("directives/decorators/bootstrap/uiselect/uiselect.html","<div ng-controller=\"dynamicSelectController\" class=\"form-group\"\n     ng-class=\"{\'has-error\': hasError(), \'has-success\': hasSuccess(), \'has-feedback\': form.feedback !== false}\"\n         ng-init=\"insideModel=$$value$$;\">\n    <label class=\"control-label\" ng-show=\"showTitle()\">{{form.title}}</label>\n\n    <div class=\"form-group\">\n        <ui-select ng-model=\"select_model.selected\"\n                   ng-if=\"!(form.options.tagging||false)\" theme=\"bootstrap\" ng-disabled=\"form.disabled\"\n                   on-select=\"$$value$$=$item.value\" class=\"{{form.options.uiClass}}\">\n            <ui-select-match\n                    placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\' | translate)}}\">\n                {{select_model.selected.name}}\n            </ui-select-match>\n            <ui-select-choices refresh=\"populateTitleMap(form, $select.search)\"\n                               refresh-delay=\"form.options.refreshDelay\" group-by=\"form.options.groupBy\"\n                               repeat=\"item in form.titleMap | propsFilter: {name: $select.search, description: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\') }\">\n                <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n                <div ng-if=\"item.description\">\n                    <span ng-bind-html=\"\'<small>\' + (\'\'+item.description | highlight: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\'))+ \'</small>\'\"></span>\n                </div>\n            </ui-select-choices>\n        </ui-select>\n        <ui-select ng-controller=\"dynamicSelectController\" ng-model=\"select_model.selected\"\n                   ng-if=\"(form.options.tagging||false) && !(form.options.groupBy || false)\"\n                   tagging=\"form.options.tagging||false\" tagging-label=\"form.options.taggingLabel\"\n                   tagging-tokens=\"form.options.taggingTokens\"\n                   theme=\"bootstrap\" ng-disabled=\"form.disabled\" on-select=\"$$value$$=$item.value\"\n                   class=\"{{form.options.uiClass}}\">\n            <ui-select-match\n                    placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\' | translate)}}\">\n                {{select_model.selected.name}}&nbsp;\n                <small>{{(select_model.selected.isTag===true ? form.options.taggingLabel : \'\')}}</small>\n            </ui-select-match>\n            <!--repeat code because tagging does not display properly under group by but is still useful -->\n            <ui-select-choices refresh=\"populateTitleMap(form, $select.search))\"\n                               refresh-delay=\"form.options.refreshDelay\"\n                               repeat=\"item in form.titleMap | propsFilter: {name: $select.search, description: (form.options.searchDescription===true ? $select.search : \'NOTSEARCHINGFORTHIS\') }\">\n                <div ng-if=\"item.isTag\"\n                     ng-bind-html=\"\'<div>\' + (item.name   | highlight: $select.search) + \' \' + form.options.taggingLabel + \'</div><div class=&quot;divider&quot;></div>\'\"></div>\n                <div ng-if=\"!item.isTag\" ng-bind-html=\"item.name + item.isTag| highlight: $select.search\"></div>\n                <div ng-if=\"item.description\">\n                    <span ng-bind-html=\"\'<small>\' + (\'\'+item.description | highlight: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\')) + \'</small>\'\"></span>\n                </div>\n            </ui-select-choices>\n        </ui-select>\n\n        <!--repeat code because tagging does not display properly under group by but is still useful -->\n\n        <ui-select ng-controller=\"dynamicSelectController\" ng-model=\"select_model.selected\"\n                   ng-if=\"(form.options.tagging||false) && (form.options.groupBy || false)\"\n                   tagging=\"form.options.tagging||false\" tagging-label=\"form.options.taggingLabel\"\n                   tagging-tokens=\"form.options.taggingTokens\"\n                   theme=\"bootstrap\" ng-disabled=\"form.disabled\" on-select=\"$$value$$=$item.value\"\n                   class=\"{{form.options.uiClass}}\">\n            <ui-select-match\n                    placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\' | translate)}}\">\n                {{select_model.selected.name}}&nbsp;\n                <small>{{(select_model.selected.isTag===true ? form.options.taggingLabel : \'\')}}</small>\n            </ui-select-match>\n            <ui-select-choices group-by=\"form.options.groupBy\"\n                               refresh=\"populateTitleMap(form, $select.search)\"\n                               refresh-delay=\"form.options.refreshDelay\"\n                               repeat=\"item in form.titleMap | propsFilter: {name: $select.search, description: (form.options.searchDescription===true ? $select.search : \'NOTSEARCHINGFORTHIS\') }\">\n                <div ng-if=\"item.isTag\"\n                     ng-bind-html=\"\'<div>\' + (item.name  | highlight: $select.search) + \' \' + form.options.taggingLabel + \'</div><div class=&quot;divider&quot;></div>\'\"></div>\n                <div ng-if=\"!item.isTag\" ng-bind-html=\"item.name + item.isTag| highlight: $select.search\"></div>\n                <div ng-if=\"item.description\">\n                    <span ng-bind-html=\"\'<small>\' + (\'\'+item.description | highlight: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\')) + \'</small>\'\"></span>\n                </div>\n            </ui-select-choices>\n        </ui-select>\n\n        <input type=\"hidden\" toggle-single-model sf-changed=\"form\" ng-model=\"insideModel\" schema-validate=\"form\"/>\n    <span ng-if=\"form.feedback !== false\"\n          class=\"form-control-feedback\"\n          ng-class=\"evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }\"></span>\n\n        <div class=\"help-block\"\n             ng-show=\"(hasError() && errorMessage(schemaError())) || form.description\"\n             ng-bind-html=\"(hasError() && errorMessage(schemaError())) || form.description\"></div>\n    </div>\n</div>\n");
	$templateCache.put("directives/decorators/bootstrap/uiselect/uiselectmultiple.html","\n<div class=\"form-group\" ng-class=\"{\'has-error\': hasError(), \'has-success\': hasSuccess(), \'has-feedback\': form.feedback !== false}\"\n        ng-controller=\"dynamicSelectController\" ng-init=\"$$value$$=$$value$$||[];uiMultiSelectInitInternalModel($$value$$)\">\n  <label class=\"control-label\" ng-show=\"showTitle()\">{{form.title}}</label>\n  <div class=\"form-group\">\n    <ui-select multiple sortable-options=\"{{form.sortableOptions}}\" ng-model=\"internalModel\" theme=\"bootstrap\"\n               on-select=\"$$value$$.push($item.value)\" on-remove=\"$$value$$.splice($$value$$.indexOf($item.value), 1)\"\n               class=\"{{form.options.uiClass}}\">\n      <ui-select-match placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\' | translate)}}\">{{$item.name}}</ui-select-match>\n      <ui-select-choices repeat=\"item in form.titleMap | propsFilter: {name: $select.search}\"\n         refresh=\"populateTitleMap(form, $select.search)\"\n         refresh-delay=\"form.options.refreshDelay\"\n         group-by=\"form.options.groupBy\">\n        <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n      </ui-select-choices>\n    </ui-select>\n    <span ng-if=\"form.feedback !== false\"\n      class=\"form-control-feedback\"\n      ng-class=\"evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }\"></span>\n    <div class=\"help-block\"\n      ng-show=\"(hasError() && errorMessage(schemaError())) || form.description\"\n      ng-bind-html=\"(hasError() && errorMessage(schemaError())) || form.description\"></div>\n  </div>\n</div>\n");}]);
	angular.module('schemaForm').config(
	    ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
	        function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
	
	            var select = function (name, schema, options) {
	                if ((schema.type === 'string') && ("enum" in schema)) {
	                    var f = schemaFormProvider.stdFormObj(name, schema, options);
	                    f.key = options.path;
	                    f.type = 'strapselect';
	                    options.lookup[sfPathProvider.stringify(options.path)] = f;
	                    return f;
	                }
	            };
	
	            schemaFormProvider.defaults.string.unshift(select);
	
	            //Add to the bootstrap directive
	            schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'strapselect',
	                'directives/decorators/bootstrap/strap/strapselect.html')
	            schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'strapmultiselect',
	                'directives/decorators/bootstrap/strap/strapmultiselect.html');
	
	            schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'strapselectdynamic',
	                'directives/decorators/bootstrap/strap/strapselect.html');
	
	            schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'strapmultiselectdynamic',
	                'directives/decorators/bootstrap/strap/strapmultiselect.html');
	
	
	            // UI SELECT
	            //Add to the bootstrap directive
	            schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'uiselect',
	                'directives/decorators/bootstrap/uiselect/uiselect.html')
	
	
	            schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'uiselectmultiple',
	                'directives/decorators/bootstrap/uiselect/uiselectmultiple.html')
	
	
	        }])
	  .directive("toggleSingleModel", function() {
	    // some how we get this to work ...
	    return {
	      require: 'ngModel',
	      restrict: "A",
	      scope: {},
	      replace: true,
	      controller: ['$scope', function($scope)  {
	        $scope.$parent.$watch('select_model.selected',function(){
	          if($scope.$parent.select_model.selected != undefined) {
	            $scope.$parent.insideModel = $scope.$parent.select_model.selected.value;
	            $scope.$parent.ngModel.$setViewValue($scope.$parent.select_model.selected.value);
	          }
	        });
	      }]
	    };
	  })
	
	  .directive('multipleOn', function() {
	    return {
	    link: function($scope, $element, $attrs) {
	        $scope.$watch(
	            function () { return $element.attr('multiple-on'); },
	            function (newVal) {
	
	                if(newVal == "true") {
	                    var select_scope = angular.element($element).scope().$$childTail;
	                    select_scope.$isMultiple = true;
	                    select_scope.options.multiple = true;
	                    select_scope.$select.$element.addClass('select-multiple');
	                }
	                else {
	                    angular.element($element).scope().$$childTail.$isMultiple = false;
	                }
	            }
	        );
	      }
	    };
	  })
	  .filter('whereMulti', function() {
	    return function(items, key, values) {
	      var out = [];
	
	      if (angular.isArray(values) && items !== undefined) {
	          values.forEach(function (value) {
	              for (var i = 0; i < items.length; i++) {
	                  if (value == items[i][key]) {
	                      out.push(items[i]);
	                      break;
	                  }
	              }
	          });
	      } else {
	        // Let the output be the input untouched
	        out = items;
	      }
	
	      return out;
	    };
	  })
	  .filter('propsFilter', function() {
	        return function (items, props) {
	            var out = [];
	
	            if (angular.isArray(items)) {
	                items.forEach(function (item) {
	                    var itemMatches = false;
	
	                    var keys = Object.keys(props);
	                    for (var i = 0; i < keys.length; i++) {
	                        var prop = keys[i];
	                        if (item.hasOwnProperty(prop)) {
	                            //only match if this property is actually in the item to avoid
	                            var text = props[prop].toLowerCase();
	                            //search for either a space before the text or the textg at the start of the string so that the middle of words are not matched
	                            if (item[prop].toString().toLowerCase().indexOf(text) === 0 || ( item[prop].toString()).toLowerCase().indexOf(' ' + text) !== -1) {
	                                itemMatches = true;
	                                break;
	                            }
	                        }
	                    }
	
	                    if (itemMatches) {
	                        out.push(item);
	                    }
	                });
	            } else {
	                // Let the output be the input untouched
	                out = items;
	            }
	
	            return out;
	        };
	    });
	
	angular.module('schemaForm').controller('dynamicSelectController', ['$scope', '$http', '$timeout', function ($scope, $http, $timeout) {
	
	    if (!$scope.form.options) {
	        $scope.form.options = {};
	    }
	
	    $scope.select_model = {};
	
	    console.log("Setting options." + $scope.form.options.toString());
	    $scope.form.options.scope = $scope;
	
	    $scope.triggerTitleMap = function () {
	        console.log("listener triggered");
	        // Ugly workaround to trigger titleMap expression re-evaluation so that the selectFilter it reapplied.
	        $scope.form.titleMap.push({"value": "345890u340598u3405u9", "name": "34095u3p4ouij"})
	        $timeout(function () { $scope.form.titleMap.pop() })
	
	    };
	
	    $scope.initFiltering = function (localModel) {
	        if ($scope.form.options.filterTriggers) {
	            $scope.form.options.filterTriggers.forEach(function (trigger) {
	                $scope.$parent.$watch(trigger, $scope.triggerTitleMap)
	
	            });
	        }
	        // This is set here, as the model value may become unitialized and typeless if validation fails.
	        $scope.localModelType =  Object.prototype.toString.call(localModel);
	        $scope.filteringInitialized = true;
	    };
	
	
	    $scope.finalizeTitleMap = function (form, data, newOptions) {
	        // Remap the data
	
	        form.titleMap = [];
	
	        if (newOptions && "map" in newOptions && newOptions .map) {
	            var current_row = null,
				final = newOptions.map.nameProperty.length - 1,
				separator = newOptions.map.separatorValue ? newOptions.map.separatorValue : ' - ';
					data.forEach(function (current_row) {
	                current_row["value"] = current_row[newOptions .map.valueProperty];
					//check if the value passed is a string or not
					if(typeof newOptions.map.nameProperty != 'string'){
						//loop through the object/array
	                    var newName = "";
						for (var i in newOptions.map.nameProperty) {
	    					newName += current_row[newOptions .map.nameProperty[i]]; 
	    					if(i != final){newName += separator};
						}	
	                    current_row["name"] = newName; //init the 'name' property
					}
	                else{
						//if it is a string
						current_row["name"] = current_row[newOptions .map.nameProperty];
					}
	                form.titleMap.push(current_row);
	            });
	
	        }
	        else {
	            data.forEach(function (item) {
	                    if ("text" in item) {
	                        item.name = item.text
	                    }
	                }
	            );
	            form.titleMap = data;
	        }
	
	        if ($scope.insideModel && $scope.select_model.selected === undefined) {
	          $scope.select_model.selected = $scope.find_in_titleMap($scope.insideModel);
	        }
	
	        // The ui-selects needs to be reinitialized (UI select sets the internalModel and externalModel.
	        if ($scope.internalModel) {
	            console.log("Call uiMultiSelectInitInternalModel");
	            $scope.uiMultiSelectInitInternalModel($scope.externalModel);
	        }
	    };
	
	    $scope.clone = function (obj) {
	        // Clone an object (except references to this scope)
	        if (null == obj || "object" != typeof(obj)) return obj;
	
	        var copy = obj.constructor();
	        for (var attr in obj) {
	            // Do not clone if it is this scope
	            if (obj[attr] != $scope) {
	                if (obj.hasOwnProperty(attr)) copy[attr] = $scope.clone(obj[attr]);
	            }
	        }
	        return copy;
	    };
	
	
	    $scope.getCallback = function (callback) {
	        if (typeof(callback) == "string") {
	            var _result = $scope.$parent.evalExpr(callback);
	            if (typeof(_result) == "function") {
	                return _result;
	            }
	            else {
	                throw("A callback string must match name of a function in the parent scope")
	            }
	
	        }
	        else if (typeof(callback) == "function") {
	            return callback;
	        }
	        else {
	            throw("A callback must either be a string matching the name of a function in the parent scope or a " +
	            "direct function reference")
	
	        }
	    };
	
	    $scope.getOptions = function (options, search) {
	        // If defined, let the a callback function manipulate the options
	        if (options.httpPost && options.httpPost.optionsCallback) {
	            newOptionInstance = $scope.clone(options);
	            return $scope.getCallback(options.httpPost.optionsCallback)(newOptionInstance, search);
	        }
	        if (options.httpGet && options.httpGet.optionsCallback) {
	            newOptionInstance = $scope.clone(options);
	            return $scope.getCallback(options.httpGet.optionsCallback)(newOptionInstance, search);
	        }
	        else {
	            return options;
	        }
	    };
	
	    $scope.test = function (form) {
	        form.titleMap.pop();
	    };
	
	
	    $scope.populateTitleMap = function (form, search) {
	
	        if (form.schema && "enum" in form.schema) {
	            form.titleMap = [];
	            form.schema.enum.forEach(function (item) {
	                    form.titleMap.push({"value": item, "name": item})
	                }
	            );
	
	        }
	        else if (!form.options) {
	
	            console.log("dynamicSelectController.populateTitleMap(key:" + form.key + ") : No options set, needed for dynamic selects");
	        }
	        else if (form.options.callback) {
	            form.titleMap = $scope.getCallback(form.options.callback)(form.options, search);
	            $scope.finalizeTitleMap(form,form.titleMap, form.options);
	            console.log("callback items: ", form.titleMap);
	        }
	        else if (form.options.asyncCallback) {
	            return $scope.getCallback(form.options.asyncCallback)(form.options, search).then(
	                function (_data) {
	                    $scope.finalizeTitleMap(form, _data.data, form.options);
	                    console.log('asyncCallback items', form.titleMap);
	                },
	                function (data, status) {
	                    alert("Loading select items failed(Options: '" + String(form.options) +
	                    "\nError: " + status);
	                });
	        }
	        else if (form.options.httpPost) {
	            var finalOptions = $scope.getOptions(form.options, search);
	
	            return $http.post(finalOptions.httpPost.url, finalOptions.httpPost.parameter).then(
	                function (_data) {
	
	                    $scope.finalizeTitleMap(form, _data.data, finalOptions);
	                    console.log('httpPost items', form.titleMap);
	                },
	                function (data, status) {
	                    alert("Loading select items failed (URL: '" + String(finalOptions.httpPost.url) +
	                    "' Parameter: " + String(finalOptions.httpPost.parameter) + "\nError: " + status);
	                });
	        }
	        else if (form.options.httpGet) {
	            var finalOptions = $scope.getOptions(form.options, search);
	            return $http.get(finalOptions.httpGet.url, finalOptions.httpGet.parameter).then(
	                function (data) {
	                    $scope.finalizeTitleMap(form, data.data, finalOptions);
	                    console.log('httpGet items', form.titleMap);
	                },
	                function (data, status) {
	                    alert("Loading select items failed (URL: '" + String(finalOptions.httpGet.url) +
	                    "\nError: " + status);
	                });
	        }
	    };
	
	
	    $scope.find_in_titleMap = function (value) {
	        for (i = 0; i < $scope.form.titleMap.length; i++) {
	            if ($scope.form.titleMap[i].value == value) {
	                return {"value": $scope.form.titleMap[i].value, "name": $scope.form.titleMap[i].name}
	            }
	        }
	
	    };
	
	    $scope.uiMultiSelectInitInternalModel = function(supplied_model)
	    {
	
	
	        console.log("$scope.externalModel: Key: " +$scope.form.key.toString() + " Model: " + supplied_model.toString());
	        $scope.externalModel = supplied_model;
	        $scope.internalModel = [];
	        if ($scope.form.titleMap) {
	            if (supplied_model !== undefined && angular.isArray(supplied_model)){
	                supplied_model.forEach(function (value) {
	                        $scope.internalModel.push($scope.find_in_titleMap(value));
	                    }
	                )
	            }
	        }
	    };
	
	}]);
	
	angular.module('schemaForm').filter('selectFilter', [function ($filter) {
	    return function (inputArray, controller, localModel, strLocalModel) {
	        // As the controllers' .model is the global and its form is the local, we need to get the local model as well.
	        // We also need tp be able to set it if is undefined after a validation failure,so for that we need
	        // its string representation as well as we do not know its name. A typical value if strLocalModel is model['groups']
	        // This is very ugly, though. TODO: Find out why the model is set to undefined after validation failure.
	
	        if (!angular.isDefined(inputArray) || !angular.isDefined(controller.form.options) ||
	            !angular.isDefined(controller.form.options.filter) || controller.form.options.filter == '') {
	            return inputArray;
	        }
	
	
	
	        console.log("----- In filtering for " + controller.form.key + "(" + controller.form.title +"), model value: " + JSON.stringify( localModel) + "----");
	        console.log("Filter:" + controller.form.options.filter);
	        if (!controller.filteringInitialized) {
	            console.log("Initialize filter");
	            controller.initFiltering(localModel);
	        }
	
	
	        var data = [];
	
	
	        angular.forEach(inputArray, function (curr_item) {
	            //console.log("Compare: curr_item: " + JSON.stringify(curr_item) +
	            //"with : " + JSON.stringify( controller.$eval(controller.form.options.filterTriggers[0])));
	            if (controller.$eval(controller.form.options.filter, {item: curr_item})) {
	                data.push(curr_item);
	            }
	            else if (localModel) {
	                // If not in list, also remove the set value
	
	                if (controller.localModelType == "[object Array]" && localModel.indexOf(curr_item.value) > -1) {
	                    localModel.splice(localModel.indexOf(curr_item.value), 1);
	                }
	                else if (localModel == curr_item.value) {
	                    console.log("Setting model of type " + controller.localModelType  + "to null.");
	                    localModel = null;
	                }
	            }
	        });
	
	        if (controller.localModelType == "[object Array]" && !localModel) {
	            // An undefined local model seems to mess up bootstrap select's indicators
	            console.log("Resetting model of type " + controller.localModelType  + " to [].");
	
	            controller.$eval(strLocalModel + "=[]");
	        }
	
	        //console.log("Input: " + JSON.stringify(inputArray));
	        //console.log("Output: " + JSON.stringify(data));
	        //console.log("Model value out : " + JSON.stringify(localModel));
	        console.log("----- Exiting filter for " + controller.form.title + "-----");
	
	        return data;
	    };
	}]);
	
	}));


/***/ }),
/* 548 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("schemaForm").run(["$templateCache", function (o) {
	  o.put("directives/decorators/bootstrap/codemirror/codemirror.html", '<div class="form-group" ng-class="{\'has-error\': hasError()}" ng-init="codemirrorOptions = {foo: \'bar\'}"><label class="control-label" ng-show="showTitle()">{{form.title}}</label><div ng-if="form.codemirrorButtons" class="cm-buttons"><span class="btn-group" ng-repeat="buttonGroup in form.codemirrorButtons"><button ng-repeat="button in buttonGroup" ng-click="evalInScope(button.onClick)" type="button" class="btn btn-sm btn-default" id="btnBold" title="{{ button.title }}"><span ng-if="button.icon" class="glyphicon" ng-class="\'glyphicon-\' + button.icon"></span> <span ng-if="button.label" ng-bind-html="button.label"></span></button></span></div><div codemirror-buttons="" ui-codemirror="" ui-codemirror-opts="getCodemirrorOptions()" ng-style="form.style" ng-model="$$value$$" schema-validate="form"></div><span class="help-block">{{ (hasError() && errorMessage(schemaError())) || form.description}}</span></div>');
	}]), angular.module("schemaForm").config(["schemaFormProvider", "schemaFormDecoratorsProvider", function (o, r) {
	  r.addMapping("bootstrapDecorator", "codemirror", "directives/decorators/bootstrap/codemirror/codemirror.html"), r.createDirective("codemirror", "directives/decorators/bootstrap/codemirror/codemirror.html");
	}]).directive("codemirrorButtons", function () {
	  return { controller: ["$scope", function (o) {
	      o.getCodemirrorOptions = function () {
	        var r = angular.copy(o.form.codemirrorOptions);return r.onLoad = function (r) {
	          o.cm = r;
	        }, r;
	      };
	    }] };
	});

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Datepicker for Bootstrap v1.7.1 (https://github.com/uxsolutions/bootstrap-datepicker)
	 *
	 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
	 */
	
	!function(a){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):a("object"==typeof exports?require("jquery"):jQuery)}(function(a,b){function c(){return new Date(Date.UTC.apply(Date,arguments))}function d(){var a=new Date;return c(a.getFullYear(),a.getMonth(),a.getDate())}function e(a,b){return a.getUTCFullYear()===b.getUTCFullYear()&&a.getUTCMonth()===b.getUTCMonth()&&a.getUTCDate()===b.getUTCDate()}function f(c,d){return function(){return d!==b&&a.fn.datepicker.deprecated(d),this[c].apply(this,arguments)}}function g(a){return a&&!isNaN(a.getTime())}function h(b,c){function d(a,b){return b.toLowerCase()}var e,f=a(b).data(),g={},h=new RegExp("^"+c.toLowerCase()+"([A-Z])");c=new RegExp("^"+c.toLowerCase());for(var i in f)c.test(i)&&(e=i.replace(h,d),g[e]=f[i]);return g}function i(b){var c={};if(q[b]||(b=b.split("-")[0],q[b])){var d=q[b];return a.each(p,function(a,b){b in d&&(c[b]=d[b])}),c}}var j=function(){var b={get:function(a){return this.slice(a)[0]},contains:function(a){for(var b=a&&a.valueOf(),c=0,d=this.length;c<d;c++)if(0<=this[c].valueOf()-b&&this[c].valueOf()-b<864e5)return c;return-1},remove:function(a){this.splice(a,1)},replace:function(b){b&&(a.isArray(b)||(b=[b]),this.clear(),this.push.apply(this,b))},clear:function(){this.length=0},copy:function(){var a=new j;return a.replace(this),a}};return function(){var c=[];return c.push.apply(c,arguments),a.extend(c,b),c}}(),k=function(b,c){a.data(b,"datepicker",this),this._process_options(c),this.dates=new j,this.viewDate=this.o.defaultViewDate,this.focusDate=null,this.element=a(b),this.isInput=this.element.is("input"),this.inputField=this.isInput?this.element:this.element.find("input"),this.component=!!this.element.hasClass("date")&&this.element.find(".add-on, .input-group-addon, .btn"),this.component&&0===this.component.length&&(this.component=!1),this.isInline=!this.component&&this.element.is("div"),this.picker=a(r.template),this._check_template(this.o.templates.leftArrow)&&this.picker.find(".prev").html(this.o.templates.leftArrow),this._check_template(this.o.templates.rightArrow)&&this.picker.find(".next").html(this.o.templates.rightArrow),this._buildEvents(),this._attachEvents(),this.isInline?this.picker.addClass("datepicker-inline").appendTo(this.element):this.picker.addClass("datepicker-dropdown dropdown-menu"),this.o.rtl&&this.picker.addClass("datepicker-rtl"),this.o.calendarWeeks&&this.picker.find(".datepicker-days .datepicker-switch, thead .datepicker-title, tfoot .today, tfoot .clear").attr("colspan",function(a,b){return Number(b)+1}),this._process_options({startDate:this._o.startDate,endDate:this._o.endDate,daysOfWeekDisabled:this.o.daysOfWeekDisabled,daysOfWeekHighlighted:this.o.daysOfWeekHighlighted,datesDisabled:this.o.datesDisabled}),this._allow_update=!1,this.setViewMode(this.o.startView),this._allow_update=!0,this.fillDow(),this.fillMonths(),this.update(),this.isInline&&this.show()};k.prototype={constructor:k,_resolveViewName:function(b){return a.each(r.viewModes,function(c,d){if(b===c||a.inArray(b,d.names)!==-1)return b=c,!1}),b},_resolveDaysOfWeek:function(b){return a.isArray(b)||(b=b.split(/[,\s]*/)),a.map(b,Number)},_check_template:function(c){try{if(c===b||""===c)return!1;if((c.match(/[<>]/g)||[]).length<=0)return!0;var d=a(c);return d.length>0}catch(a){return!1}},_process_options:function(b){this._o=a.extend({},this._o,b);var e=this.o=a.extend({},this._o),f=e.language;q[f]||(f=f.split("-")[0],q[f]||(f=o.language)),e.language=f,e.startView=this._resolveViewName(e.startView),e.minViewMode=this._resolveViewName(e.minViewMode),e.maxViewMode=this._resolveViewName(e.maxViewMode),e.startView=Math.max(this.o.minViewMode,Math.min(this.o.maxViewMode,e.startView)),e.multidate!==!0&&(e.multidate=Number(e.multidate)||!1,e.multidate!==!1&&(e.multidate=Math.max(0,e.multidate))),e.multidateSeparator=String(e.multidateSeparator),e.weekStart%=7,e.weekEnd=(e.weekStart+6)%7;var g=r.parseFormat(e.format);e.startDate!==-(1/0)&&(e.startDate?e.startDate instanceof Date?e.startDate=this._local_to_utc(this._zero_time(e.startDate)):e.startDate=r.parseDate(e.startDate,g,e.language,e.assumeNearbyYear):e.startDate=-(1/0)),e.endDate!==1/0&&(e.endDate?e.endDate instanceof Date?e.endDate=this._local_to_utc(this._zero_time(e.endDate)):e.endDate=r.parseDate(e.endDate,g,e.language,e.assumeNearbyYear):e.endDate=1/0),e.daysOfWeekDisabled=this._resolveDaysOfWeek(e.daysOfWeekDisabled||[]),e.daysOfWeekHighlighted=this._resolveDaysOfWeek(e.daysOfWeekHighlighted||[]),e.datesDisabled=e.datesDisabled||[],a.isArray(e.datesDisabled)||(e.datesDisabled=e.datesDisabled.split(",")),e.datesDisabled=a.map(e.datesDisabled,function(a){return r.parseDate(a,g,e.language,e.assumeNearbyYear)});var h=String(e.orientation).toLowerCase().split(/\s+/g),i=e.orientation.toLowerCase();if(h=a.grep(h,function(a){return/^auto|left|right|top|bottom$/.test(a)}),e.orientation={x:"auto",y:"auto"},i&&"auto"!==i)if(1===h.length)switch(h[0]){case"top":case"bottom":e.orientation.y=h[0];break;case"left":case"right":e.orientation.x=h[0]}else i=a.grep(h,function(a){return/^left|right$/.test(a)}),e.orientation.x=i[0]||"auto",i=a.grep(h,function(a){return/^top|bottom$/.test(a)}),e.orientation.y=i[0]||"auto";else;if(e.defaultViewDate instanceof Date||"string"==typeof e.defaultViewDate)e.defaultViewDate=r.parseDate(e.defaultViewDate,g,e.language,e.assumeNearbyYear);else if(e.defaultViewDate){var j=e.defaultViewDate.year||(new Date).getFullYear(),k=e.defaultViewDate.month||0,l=e.defaultViewDate.day||1;e.defaultViewDate=c(j,k,l)}else e.defaultViewDate=d()},_events:[],_secondaryEvents:[],_applyEvents:function(a){for(var c,d,e,f=0;f<a.length;f++)c=a[f][0],2===a[f].length?(d=b,e=a[f][1]):3===a[f].length&&(d=a[f][1],e=a[f][2]),c.on(e,d)},_unapplyEvents:function(a){for(var c,d,e,f=0;f<a.length;f++)c=a[f][0],2===a[f].length?(e=b,d=a[f][1]):3===a[f].length&&(e=a[f][1],d=a[f][2]),c.off(d,e)},_buildEvents:function(){var b={keyup:a.proxy(function(b){a.inArray(b.keyCode,[27,37,39,38,40,32,13,9])===-1&&this.update()},this),keydown:a.proxy(this.keydown,this),paste:a.proxy(this.paste,this)};this.o.showOnFocus===!0&&(b.focus=a.proxy(this.show,this)),this.isInput?this._events=[[this.element,b]]:this.component&&this.inputField.length?this._events=[[this.inputField,b],[this.component,{click:a.proxy(this.show,this)}]]:this._events=[[this.element,{click:a.proxy(this.show,this),keydown:a.proxy(this.keydown,this)}]],this._events.push([this.element,"*",{blur:a.proxy(function(a){this._focused_from=a.target},this)}],[this.element,{blur:a.proxy(function(a){this._focused_from=a.target},this)}]),this.o.immediateUpdates&&this._events.push([this.element,{"changeYear changeMonth":a.proxy(function(a){this.update(a.date)},this)}]),this._secondaryEvents=[[this.picker,{click:a.proxy(this.click,this)}],[this.picker,".prev, .next",{click:a.proxy(this.navArrowsClick,this)}],[this.picker,".day:not(.disabled)",{click:a.proxy(this.dayCellClick,this)}],[a(window),{resize:a.proxy(this.place,this)}],[a(document),{"mousedown touchstart":a.proxy(function(a){this.element.is(a.target)||this.element.find(a.target).length||this.picker.is(a.target)||this.picker.find(a.target).length||this.isInline||this.hide()},this)}]]},_attachEvents:function(){this._detachEvents(),this._applyEvents(this._events)},_detachEvents:function(){this._unapplyEvents(this._events)},_attachSecondaryEvents:function(){this._detachSecondaryEvents(),this._applyEvents(this._secondaryEvents)},_detachSecondaryEvents:function(){this._unapplyEvents(this._secondaryEvents)},_trigger:function(b,c){var d=c||this.dates.get(-1),e=this._utc_to_local(d);this.element.trigger({type:b,date:e,viewMode:this.viewMode,dates:a.map(this.dates,this._utc_to_local),format:a.proxy(function(a,b){0===arguments.length?(a=this.dates.length-1,b=this.o.format):"string"==typeof a&&(b=a,a=this.dates.length-1),b=b||this.o.format;var c=this.dates.get(a);return r.formatDate(c,b,this.o.language)},this)})},show:function(){if(!(this.inputField.prop("disabled")||this.inputField.prop("readonly")&&this.o.enableOnReadonly===!1))return this.isInline||this.picker.appendTo(this.o.container),this.place(),this.picker.show(),this._attachSecondaryEvents(),this._trigger("show"),(window.navigator.msMaxTouchPoints||"ontouchstart"in document)&&this.o.disableTouchKeyboard&&a(this.element).blur(),this},hide:function(){return this.isInline||!this.picker.is(":visible")?this:(this.focusDate=null,this.picker.hide().detach(),this._detachSecondaryEvents(),this.setViewMode(this.o.startView),this.o.forceParse&&this.inputField.val()&&this.setValue(),this._trigger("hide"),this)},destroy:function(){return this.hide(),this._detachEvents(),this._detachSecondaryEvents(),this.picker.remove(),delete this.element.data().datepicker,this.isInput||delete this.element.data().date,this},paste:function(b){var c;if(b.originalEvent.clipboardData&&b.originalEvent.clipboardData.types&&a.inArray("text/plain",b.originalEvent.clipboardData.types)!==-1)c=b.originalEvent.clipboardData.getData("text/plain");else{if(!window.clipboardData)return;c=window.clipboardData.getData("Text")}this.setDate(c),this.update(),b.preventDefault()},_utc_to_local:function(a){if(!a)return a;var b=new Date(a.getTime()+6e4*a.getTimezoneOffset());return b.getTimezoneOffset()!==a.getTimezoneOffset()&&(b=new Date(a.getTime()+6e4*b.getTimezoneOffset())),b},_local_to_utc:function(a){return a&&new Date(a.getTime()-6e4*a.getTimezoneOffset())},_zero_time:function(a){return a&&new Date(a.getFullYear(),a.getMonth(),a.getDate())},_zero_utc_time:function(a){return a&&c(a.getUTCFullYear(),a.getUTCMonth(),a.getUTCDate())},getDates:function(){return a.map(this.dates,this._utc_to_local)},getUTCDates:function(){return a.map(this.dates,function(a){return new Date(a)})},getDate:function(){return this._utc_to_local(this.getUTCDate())},getUTCDate:function(){var a=this.dates.get(-1);return a!==b?new Date(a):null},clearDates:function(){this.inputField.val(""),this.update(),this._trigger("changeDate"),this.o.autoclose&&this.hide()},setDates:function(){var b=a.isArray(arguments[0])?arguments[0]:arguments;return this.update.apply(this,b),this._trigger("changeDate"),this.setValue(),this},setUTCDates:function(){var b=a.isArray(arguments[0])?arguments[0]:arguments;return this.setDates.apply(this,a.map(b,this._utc_to_local)),this},setDate:f("setDates"),setUTCDate:f("setUTCDates"),remove:f("destroy","Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead"),setValue:function(){var a=this.getFormattedDate();return this.inputField.val(a),this},getFormattedDate:function(c){c===b&&(c=this.o.format);var d=this.o.language;return a.map(this.dates,function(a){return r.formatDate(a,c,d)}).join(this.o.multidateSeparator)},getStartDate:function(){return this.o.startDate},setStartDate:function(a){return this._process_options({startDate:a}),this.update(),this.updateNavArrows(),this},getEndDate:function(){return this.o.endDate},setEndDate:function(a){return this._process_options({endDate:a}),this.update(),this.updateNavArrows(),this},setDaysOfWeekDisabled:function(a){return this._process_options({daysOfWeekDisabled:a}),this.update(),this},setDaysOfWeekHighlighted:function(a){return this._process_options({daysOfWeekHighlighted:a}),this.update(),this},setDatesDisabled:function(a){return this._process_options({datesDisabled:a}),this.update(),this},place:function(){if(this.isInline)return this;var b=this.picker.outerWidth(),c=this.picker.outerHeight(),d=10,e=a(this.o.container),f=e.width(),g="body"===this.o.container?a(document).scrollTop():e.scrollTop(),h=e.offset(),i=[0];this.element.parents().each(function(){var b=a(this).css("z-index");"auto"!==b&&0!==Number(b)&&i.push(Number(b))});var j=Math.max.apply(Math,i)+this.o.zIndexOffset,k=this.component?this.component.parent().offset():this.element.offset(),l=this.component?this.component.outerHeight(!0):this.element.outerHeight(!1),m=this.component?this.component.outerWidth(!0):this.element.outerWidth(!1),n=k.left-h.left,o=k.top-h.top;"body"!==this.o.container&&(o+=g),this.picker.removeClass("datepicker-orient-top datepicker-orient-bottom datepicker-orient-right datepicker-orient-left"),"auto"!==this.o.orientation.x?(this.picker.addClass("datepicker-orient-"+this.o.orientation.x),"right"===this.o.orientation.x&&(n-=b-m)):k.left<0?(this.picker.addClass("datepicker-orient-left"),n-=k.left-d):n+b>f?(this.picker.addClass("datepicker-orient-right"),n+=m-b):this.o.rtl?this.picker.addClass("datepicker-orient-right"):this.picker.addClass("datepicker-orient-left");var p,q=this.o.orientation.y;if("auto"===q&&(p=-g+o-c,q=p<0?"bottom":"top"),this.picker.addClass("datepicker-orient-"+q),"top"===q?o-=c+parseInt(this.picker.css("padding-top")):o+=l,this.o.rtl){var r=f-(n+m);this.picker.css({top:o,right:r,zIndex:j})}else this.picker.css({top:o,left:n,zIndex:j});return this},_allow_update:!0,update:function(){if(!this._allow_update)return this;var b=this.dates.copy(),c=[],d=!1;return arguments.length?(a.each(arguments,a.proxy(function(a,b){b instanceof Date&&(b=this._local_to_utc(b)),c.push(b)},this)),d=!0):(c=this.isInput?this.element.val():this.element.data("date")||this.inputField.val(),c=c&&this.o.multidate?c.split(this.o.multidateSeparator):[c],delete this.element.data().date),c=a.map(c,a.proxy(function(a){return r.parseDate(a,this.o.format,this.o.language,this.o.assumeNearbyYear)},this)),c=a.grep(c,a.proxy(function(a){return!this.dateWithinRange(a)||!a},this),!0),this.dates.replace(c),this.o.updateViewDate&&(this.dates.length?this.viewDate=new Date(this.dates.get(-1)):this.viewDate<this.o.startDate?this.viewDate=new Date(this.o.startDate):this.viewDate>this.o.endDate?this.viewDate=new Date(this.o.endDate):this.viewDate=this.o.defaultViewDate),d?(this.setValue(),this.element.change()):this.dates.length&&String(b)!==String(this.dates)&&d&&(this._trigger("changeDate"),this.element.change()),!this.dates.length&&b.length&&(this._trigger("clearDate"),this.element.change()),this.fill(),this},fillDow:function(){if(this.o.showWeekDays){var b=this.o.weekStart,c="<tr>";for(this.o.calendarWeeks&&(c+='<th class="cw">&#160;</th>');b<this.o.weekStart+7;)c+='<th class="dow',a.inArray(b,this.o.daysOfWeekDisabled)!==-1&&(c+=" disabled"),c+='">'+q[this.o.language].daysMin[b++%7]+"</th>";c+="</tr>",this.picker.find(".datepicker-days thead").append(c)}},fillMonths:function(){for(var a,b=this._utc_to_local(this.viewDate),c="",d=0;d<12;d++)a=b&&b.getMonth()===d?" focused":"",c+='<span class="month'+a+'">'+q[this.o.language].monthsShort[d]+"</span>";this.picker.find(".datepicker-months td").html(c)},setRange:function(b){b&&b.length?this.range=a.map(b,function(a){return a.valueOf()}):delete this.range,this.fill()},getClassNames:function(b){var c=[],f=this.viewDate.getUTCFullYear(),g=this.viewDate.getUTCMonth(),h=d();return b.getUTCFullYear()<f||b.getUTCFullYear()===f&&b.getUTCMonth()<g?c.push("old"):(b.getUTCFullYear()>f||b.getUTCFullYear()===f&&b.getUTCMonth()>g)&&c.push("new"),this.focusDate&&b.valueOf()===this.focusDate.valueOf()&&c.push("focused"),this.o.todayHighlight&&e(b,h)&&c.push("today"),this.dates.contains(b)!==-1&&c.push("active"),this.dateWithinRange(b)||c.push("disabled"),this.dateIsDisabled(b)&&c.push("disabled","disabled-date"),a.inArray(b.getUTCDay(),this.o.daysOfWeekHighlighted)!==-1&&c.push("highlighted"),this.range&&(b>this.range[0]&&b<this.range[this.range.length-1]&&c.push("range"),a.inArray(b.valueOf(),this.range)!==-1&&c.push("selected"),b.valueOf()===this.range[0]&&c.push("range-start"),b.valueOf()===this.range[this.range.length-1]&&c.push("range-end")),c},_fill_yearsView:function(c,d,e,f,g,h,i){for(var j,k,l,m="",n=e/10,o=this.picker.find(c),p=Math.floor(f/e)*e,q=p+9*n,r=Math.floor(this.viewDate.getFullYear()/n)*n,s=a.map(this.dates,function(a){return Math.floor(a.getUTCFullYear()/n)*n}),t=p-n;t<=q+n;t+=n)j=[d],k=null,t===p-n?j.push("old"):t===q+n&&j.push("new"),a.inArray(t,s)!==-1&&j.push("active"),(t<g||t>h)&&j.push("disabled"),t===r&&j.push("focused"),i!==a.noop&&(l=i(new Date(t,0,1)),l===b?l={}:"boolean"==typeof l?l={enabled:l}:"string"==typeof l&&(l={classes:l}),l.enabled===!1&&j.push("disabled"),l.classes&&(j=j.concat(l.classes.split(/\s+/))),l.tooltip&&(k=l.tooltip)),m+='<span class="'+j.join(" ")+'"'+(k?' title="'+k+'"':"")+">"+t+"</span>";o.find(".datepicker-switch").text(p+"-"+q),o.find("td").html(m)},fill:function(){var d,e,f=new Date(this.viewDate),g=f.getUTCFullYear(),h=f.getUTCMonth(),i=this.o.startDate!==-(1/0)?this.o.startDate.getUTCFullYear():-(1/0),j=this.o.startDate!==-(1/0)?this.o.startDate.getUTCMonth():-(1/0),k=this.o.endDate!==1/0?this.o.endDate.getUTCFullYear():1/0,l=this.o.endDate!==1/0?this.o.endDate.getUTCMonth():1/0,m=q[this.o.language].today||q.en.today||"",n=q[this.o.language].clear||q.en.clear||"",o=q[this.o.language].titleFormat||q.en.titleFormat;if(!isNaN(g)&&!isNaN(h)){this.picker.find(".datepicker-days .datepicker-switch").text(r.formatDate(f,o,this.o.language)),this.picker.find("tfoot .today").text(m).css("display",this.o.todayBtn===!0||"linked"===this.o.todayBtn?"table-cell":"none"),this.picker.find("tfoot .clear").text(n).css("display",this.o.clearBtn===!0?"table-cell":"none"),this.picker.find("thead .datepicker-title").text(this.o.title).css("display","string"==typeof this.o.title&&""!==this.o.title?"table-cell":"none"),this.updateNavArrows(),this.fillMonths();var p=c(g,h,0),s=p.getUTCDate();p.setUTCDate(s-(p.getUTCDay()-this.o.weekStart+7)%7);var t=new Date(p);p.getUTCFullYear()<100&&t.setUTCFullYear(p.getUTCFullYear()),t.setUTCDate(t.getUTCDate()+42),t=t.valueOf();for(var u,v,w=[];p.valueOf()<t;){if(u=p.getUTCDay(),u===this.o.weekStart&&(w.push("<tr>"),this.o.calendarWeeks)){var x=new Date(+p+(this.o.weekStart-u-7)%7*864e5),y=new Date(Number(x)+(11-x.getUTCDay())%7*864e5),z=new Date(Number(z=c(y.getUTCFullYear(),0,1))+(11-z.getUTCDay())%7*864e5),A=(y-z)/864e5/7+1;w.push('<td class="cw">'+A+"</td>")}v=this.getClassNames(p),v.push("day");var B=p.getUTCDate();this.o.beforeShowDay!==a.noop&&(e=this.o.beforeShowDay(this._utc_to_local(p)),e===b?e={}:"boolean"==typeof e?e={enabled:e}:"string"==typeof e&&(e={classes:e}),e.enabled===!1&&v.push("disabled"),e.classes&&(v=v.concat(e.classes.split(/\s+/))),e.tooltip&&(d=e.tooltip),e.content&&(B=e.content)),v=a.isFunction(a.uniqueSort)?a.uniqueSort(v):a.unique(v),w.push('<td class="'+v.join(" ")+'"'+(d?' title="'+d+'"':"")+' data-date="'+p.getTime().toString()+'">'+B+"</td>"),d=null,u===this.o.weekEnd&&w.push("</tr>"),p.setUTCDate(p.getUTCDate()+1)}this.picker.find(".datepicker-days tbody").html(w.join(""));var C=q[this.o.language].monthsTitle||q.en.monthsTitle||"Months",D=this.picker.find(".datepicker-months").find(".datepicker-switch").text(this.o.maxViewMode<2?C:g).end().find("tbody span").removeClass("active");if(a.each(this.dates,function(a,b){b.getUTCFullYear()===g&&D.eq(b.getUTCMonth()).addClass("active")}),(g<i||g>k)&&D.addClass("disabled"),g===i&&D.slice(0,j).addClass("disabled"),g===k&&D.slice(l+1).addClass("disabled"),this.o.beforeShowMonth!==a.noop){var E=this;a.each(D,function(c,d){var e=new Date(g,c,1),f=E.o.beforeShowMonth(e);f===b?f={}:"boolean"==typeof f?f={enabled:f}:"string"==typeof f&&(f={classes:f}),f.enabled!==!1||a(d).hasClass("disabled")||a(d).addClass("disabled"),f.classes&&a(d).addClass(f.classes),f.tooltip&&a(d).prop("title",f.tooltip)})}this._fill_yearsView(".datepicker-years","year",10,g,i,k,this.o.beforeShowYear),this._fill_yearsView(".datepicker-decades","decade",100,g,i,k,this.o.beforeShowDecade),this._fill_yearsView(".datepicker-centuries","century",1e3,g,i,k,this.o.beforeShowCentury)}},updateNavArrows:function(){if(this._allow_update){var a,b,c=new Date(this.viewDate),d=c.getUTCFullYear(),e=c.getUTCMonth(),f=this.o.startDate!==-(1/0)?this.o.startDate.getUTCFullYear():-(1/0),g=this.o.startDate!==-(1/0)?this.o.startDate.getUTCMonth():-(1/0),h=this.o.endDate!==1/0?this.o.endDate.getUTCFullYear():1/0,i=this.o.endDate!==1/0?this.o.endDate.getUTCMonth():1/0,j=1;switch(this.viewMode){case 0:a=d<=f&&e<=g,b=d>=h&&e>=i;break;case 4:j*=10;case 3:j*=10;case 2:j*=10;case 1:a=Math.floor(d/j)*j<=f,b=Math.floor(d/j)*j+j>=h}this.picker.find(".prev").toggleClass("disabled",a),this.picker.find(".next").toggleClass("disabled",b)}},click:function(b){b.preventDefault(),b.stopPropagation();var e,f,g,h;e=a(b.target),e.hasClass("datepicker-switch")&&this.viewMode!==this.o.maxViewMode&&this.setViewMode(this.viewMode+1),e.hasClass("today")&&!e.hasClass("day")&&(this.setViewMode(0),this._setDate(d(),"linked"===this.o.todayBtn?null:"view")),e.hasClass("clear")&&this.clearDates(),e.hasClass("disabled")||(e.hasClass("month")||e.hasClass("year")||e.hasClass("decade")||e.hasClass("century"))&&(this.viewDate.setUTCDate(1),f=1,1===this.viewMode?(h=e.parent().find("span").index(e),g=this.viewDate.getUTCFullYear(),this.viewDate.setUTCMonth(h)):(h=0,g=Number(e.text()),this.viewDate.setUTCFullYear(g)),this._trigger(r.viewModes[this.viewMode-1].e,this.viewDate),this.viewMode===this.o.minViewMode?this._setDate(c(g,h,f)):(this.setViewMode(this.viewMode-1),this.fill())),this.picker.is(":visible")&&this._focused_from&&this._focused_from.focus(),delete this._focused_from},dayCellClick:function(b){var c=a(b.currentTarget),d=c.data("date"),e=new Date(d);this.o.updateViewDate&&(e.getUTCFullYear()!==this.viewDate.getUTCFullYear()&&this._trigger("changeYear",this.viewDate),e.getUTCMonth()!==this.viewDate.getUTCMonth()&&this._trigger("changeMonth",this.viewDate)),this._setDate(e)},navArrowsClick:function(b){var c=a(b.currentTarget),d=c.hasClass("prev")?-1:1;0!==this.viewMode&&(d*=12*r.viewModes[this.viewMode].navStep),this.viewDate=this.moveMonth(this.viewDate,d),this._trigger(r.viewModes[this.viewMode].e,this.viewDate),this.fill()},_toggle_multidate:function(a){var b=this.dates.contains(a);if(a||this.dates.clear(),b!==-1?(this.o.multidate===!0||this.o.multidate>1||this.o.toggleActive)&&this.dates.remove(b):this.o.multidate===!1?(this.dates.clear(),this.dates.push(a)):this.dates.push(a),"number"==typeof this.o.multidate)for(;this.dates.length>this.o.multidate;)this.dates.remove(0)},_setDate:function(a,b){b&&"date"!==b||this._toggle_multidate(a&&new Date(a)),(!b&&this.o.updateViewDate||"view"===b)&&(this.viewDate=a&&new Date(a)),this.fill(),this.setValue(),b&&"view"===b||this._trigger("changeDate"),this.inputField.trigger("change"),!this.o.autoclose||b&&"date"!==b||this.hide()},moveDay:function(a,b){var c=new Date(a);return c.setUTCDate(a.getUTCDate()+b),c},moveWeek:function(a,b){return this.moveDay(a,7*b)},moveMonth:function(a,b){if(!g(a))return this.o.defaultViewDate;if(!b)return a;var c,d,e=new Date(a.valueOf()),f=e.getUTCDate(),h=e.getUTCMonth(),i=Math.abs(b);if(b=b>0?1:-1,1===i)d=b===-1?function(){return e.getUTCMonth()===h}:function(){return e.getUTCMonth()!==c},c=h+b,e.setUTCMonth(c),c=(c+12)%12;else{for(var j=0;j<i;j++)e=this.moveMonth(e,b);c=e.getUTCMonth(),e.setUTCDate(f),d=function(){return c!==e.getUTCMonth()}}for(;d();)e.setUTCDate(--f),e.setUTCMonth(c);return e},moveYear:function(a,b){return this.moveMonth(a,12*b)},moveAvailableDate:function(a,b,c){do{if(a=this[c](a,b),!this.dateWithinRange(a))return!1;c="moveDay"}while(this.dateIsDisabled(a));return a},weekOfDateIsDisabled:function(b){return a.inArray(b.getUTCDay(),this.o.daysOfWeekDisabled)!==-1},dateIsDisabled:function(b){return this.weekOfDateIsDisabled(b)||a.grep(this.o.datesDisabled,function(a){return e(b,a)}).length>0},dateWithinRange:function(a){return a>=this.o.startDate&&a<=this.o.endDate},keydown:function(a){if(!this.picker.is(":visible"))return void(40!==a.keyCode&&27!==a.keyCode||(this.show(),a.stopPropagation()));var b,c,d=!1,e=this.focusDate||this.viewDate;switch(a.keyCode){case 27:this.focusDate?(this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.fill()):this.hide(),a.preventDefault(),a.stopPropagation();break;case 37:case 38:case 39:case 40:if(!this.o.keyboardNavigation||7===this.o.daysOfWeekDisabled.length)break;b=37===a.keyCode||38===a.keyCode?-1:1,0===this.viewMode?a.ctrlKey?(c=this.moveAvailableDate(e,b,"moveYear"),c&&this._trigger("changeYear",this.viewDate)):a.shiftKey?(c=this.moveAvailableDate(e,b,"moveMonth"),c&&this._trigger("changeMonth",this.viewDate)):37===a.keyCode||39===a.keyCode?c=this.moveAvailableDate(e,b,"moveDay"):this.weekOfDateIsDisabled(e)||(c=this.moveAvailableDate(e,b,"moveWeek")):1===this.viewMode?(38!==a.keyCode&&40!==a.keyCode||(b*=4),c=this.moveAvailableDate(e,b,"moveMonth")):2===this.viewMode&&(38!==a.keyCode&&40!==a.keyCode||(b*=4),c=this.moveAvailableDate(e,b,"moveYear")),c&&(this.focusDate=this.viewDate=c,this.setValue(),this.fill(),a.preventDefault());break;case 13:if(!this.o.forceParse)break;e=this.focusDate||this.dates.get(-1)||this.viewDate,this.o.keyboardNavigation&&(this._toggle_multidate(e),d=!0),this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.setValue(),this.fill(),this.picker.is(":visible")&&(a.preventDefault(),a.stopPropagation(),this.o.autoclose&&this.hide());break;case 9:this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.fill(),this.hide()}d&&(this.dates.length?this._trigger("changeDate"):this._trigger("clearDate"),this.inputField.trigger("change"))},setViewMode:function(a){this.viewMode=a,this.picker.children("div").hide().filter(".datepicker-"+r.viewModes[this.viewMode].clsName).show(),this.updateNavArrows(),this._trigger("changeViewMode",new Date(this.viewDate))}};var l=function(b,c){a.data(b,"datepicker",this),this.element=a(b),this.inputs=a.map(c.inputs,function(a){return a.jquery?a[0]:a}),delete c.inputs,this.keepEmptyValues=c.keepEmptyValues,delete c.keepEmptyValues,n.call(a(this.inputs),c).on("changeDate",a.proxy(this.dateUpdated,this)),this.pickers=a.map(this.inputs,function(b){return a.data(b,"datepicker")}),this.updateDates()};l.prototype={updateDates:function(){this.dates=a.map(this.pickers,function(a){return a.getUTCDate()}),this.updateRanges()},updateRanges:function(){var b=a.map(this.dates,function(a){return a.valueOf()});a.each(this.pickers,function(a,c){c.setRange(b)})},dateUpdated:function(c){if(!this.updating){this.updating=!0;var d=a.data(c.target,"datepicker");if(d!==b){var e=d.getUTCDate(),f=this.keepEmptyValues,g=a.inArray(c.target,this.inputs),h=g-1,i=g+1,j=this.inputs.length;if(g!==-1){if(a.each(this.pickers,function(a,b){b.getUTCDate()||b!==d&&f||b.setUTCDate(e)}),e<this.dates[h])for(;h>=0&&e<this.dates[h];)this.pickers[h--].setUTCDate(e);else if(e>this.dates[i])for(;i<j&&e>this.dates[i];)this.pickers[i++].setUTCDate(e);this.updateDates(),delete this.updating}}}},destroy:function(){a.map(this.pickers,function(a){a.destroy()}),a(this.inputs).off("changeDate",this.dateUpdated),delete this.element.data().datepicker},remove:f("destroy","Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead")};var m=a.fn.datepicker,n=function(c){var d=Array.apply(null,arguments);d.shift();var e;if(this.each(function(){var b=a(this),f=b.data("datepicker"),g="object"==typeof c&&c;if(!f){var j=h(this,"date"),m=a.extend({},o,j,g),n=i(m.language),p=a.extend({},o,n,j,g);b.hasClass("input-daterange")||p.inputs?(a.extend(p,{inputs:p.inputs||b.find("input").toArray()}),f=new l(this,p)):f=new k(this,p),b.data("datepicker",f)}"string"==typeof c&&"function"==typeof f[c]&&(e=f[c].apply(f,d))}),e===b||e instanceof k||e instanceof l)return this;if(this.length>1)throw new Error("Using only allowed for the collection of a single element ("+c+" function)");return e};a.fn.datepicker=n;var o=a.fn.datepicker.defaults={assumeNearbyYear:!1,autoclose:!1,beforeShowDay:a.noop,beforeShowMonth:a.noop,beforeShowYear:a.noop,beforeShowDecade:a.noop,beforeShowCentury:a.noop,calendarWeeks:!1,clearBtn:!1,toggleActive:!1,daysOfWeekDisabled:[],daysOfWeekHighlighted:[],datesDisabled:[],endDate:1/0,forceParse:!0,format:"mm/dd/yyyy",keepEmptyValues:!1,keyboardNavigation:!0,language:"en",minViewMode:0,maxViewMode:4,multidate:!1,multidateSeparator:",",orientation:"auto",rtl:!1,startDate:-(1/0),startView:0,todayBtn:!1,todayHighlight:!1,updateViewDate:!0,weekStart:0,disableTouchKeyboard:!1,enableOnReadonly:!0,showOnFocus:!0,zIndexOffset:10,container:"body",immediateUpdates:!1,title:"",templates:{leftArrow:"&#x00AB;",rightArrow:"&#x00BB;"},showWeekDays:!0},p=a.fn.datepicker.locale_opts=["format","rtl","weekStart"];a.fn.datepicker.Constructor=k;var q=a.fn.datepicker.dates={en:{days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],today:"Today",clear:"Clear",titleFormat:"MM yyyy"}},r={viewModes:[{names:["days","month"],clsName:"days",e:"changeMonth"},{names:["months","year"],clsName:"months",e:"changeYear",navStep:1},{names:["years","decade"],clsName:"years",e:"changeDecade",navStep:10},{names:["decades","century"],clsName:"decades",e:"changeCentury",navStep:100},{names:["centuries","millennium"],clsName:"centuries",e:"changeMillennium",navStep:1e3}],validParts:/dd?|DD?|mm?|MM?|yy(?:yy)?/g,nonpunctuation:/[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,parseFormat:function(a){if("function"==typeof a.toValue&&"function"==typeof a.toDisplay)return a;var b=a.replace(this.validParts,"\0").split("\0"),c=a.match(this.validParts);if(!b||!b.length||!c||0===c.length)throw new Error("Invalid date format.");return{separators:b,parts:c}},parseDate:function(c,e,f,g){function h(a,b){return b===!0&&(b=10),a<100&&(a+=2e3,a>(new Date).getFullYear()+b&&(a-=100)),a}function i(){var a=this.slice(0,j[n].length),b=j[n].slice(0,a.length);return a.toLowerCase()===b.toLowerCase()}if(!c)return b;if(c instanceof Date)return c;if("string"==typeof e&&(e=r.parseFormat(e)),e.toValue)return e.toValue(c,e,f);var j,l,m,n,o,p={d:"moveDay",m:"moveMonth",w:"moveWeek",y:"moveYear"},s={yesterday:"-1d",today:"+0d",tomorrow:"+1d"};if(c in s&&(c=s[c]),/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/i.test(c)){for(j=c.match(/([\-+]\d+)([dmwy])/gi),c=new Date,n=0;n<j.length;n++)l=j[n].match(/([\-+]\d+)([dmwy])/i),m=Number(l[1]),o=p[l[2].toLowerCase()],c=k.prototype[o](c,m);return k.prototype._zero_utc_time(c)}j=c&&c.match(this.nonpunctuation)||[];var t,u,v={},w=["yyyy","yy","M","MM","m","mm","d","dd"],x={yyyy:function(a,b){return a.setUTCFullYear(g?h(b,g):b)},m:function(a,b){if(isNaN(a))return a;for(b-=1;b<0;)b+=12;for(b%=12,a.setUTCMonth(b);a.getUTCMonth()!==b;)a.setUTCDate(a.getUTCDate()-1);return a},d:function(a,b){return a.setUTCDate(b)}};x.yy=x.yyyy,x.M=x.MM=x.mm=x.m,x.dd=x.d,c=d();var y=e.parts.slice();if(j.length!==y.length&&(y=a(y).filter(function(b,c){return a.inArray(c,w)!==-1}).toArray()),j.length===y.length){var z;for(n=0,z=y.length;n<z;n++){if(t=parseInt(j[n],10),l=y[n],isNaN(t))switch(l){case"MM":u=a(q[f].months).filter(i),t=a.inArray(u[0],q[f].months)+1;break;case"M":u=a(q[f].monthsShort).filter(i),t=a.inArray(u[0],q[f].monthsShort)+1}v[l]=t}var A,B;for(n=0;n<w.length;n++)B=w[n],B in v&&!isNaN(v[B])&&(A=new Date(c),x[B](A,v[B]),isNaN(A)||(c=A))}return c},formatDate:function(b,c,d){if(!b)return"";if("string"==typeof c&&(c=r.parseFormat(c)),c.toDisplay)return c.toDisplay(b,c,d);var e={d:b.getUTCDate(),D:q[d].daysShort[b.getUTCDay()],DD:q[d].days[b.getUTCDay()],m:b.getUTCMonth()+1,M:q[d].monthsShort[b.getUTCMonth()],MM:q[d].months[b.getUTCMonth()],yy:b.getUTCFullYear().toString().substring(2),yyyy:b.getUTCFullYear()};e.dd=(e.d<10?"0":"")+e.d,e.mm=(e.m<10?"0":"")+e.m,b=[];for(var f=a.extend([],c.separators),g=0,h=c.parts.length;g<=h;g++)f.length&&b.push(f.shift()),b.push(e[c.parts[g]]);return b.join("")},headTemplate:'<thead><tr><th colspan="7" class="datepicker-title"></th></tr><tr><th class="prev">'+o.templates.leftArrow+'</th><th colspan="5" class="datepicker-switch"></th><th class="next">'+o.templates.rightArrow+"</th></tr></thead>",
	contTemplate:'<tbody><tr><td colspan="7"></td></tr></tbody>',footTemplate:'<tfoot><tr><th colspan="7" class="today"></th></tr><tr><th colspan="7" class="clear"></th></tr></tfoot>'};r.template='<div class="datepicker"><div class="datepicker-days"><table class="table-condensed">'+r.headTemplate+"<tbody></tbody>"+r.footTemplate+'</table></div><div class="datepicker-months"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-years"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-decades"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-centuries"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+"</table></div></div>",a.fn.datepicker.DPGlobal=r,a.fn.datepicker.noConflict=function(){return a.fn.datepicker=m,this},a.fn.datepicker.version="1.7.1",a.fn.datepicker.deprecated=function(a){var b=window.console;b&&b.warn&&b.warn("DEPRECATED: "+a)},a(document).on("focus.datepicker.data-api click.datepicker.data-api",'[data-provide="datepicker"]',function(b){var c=a(this);c.data("datepicker")||(b.preventDefault(),n.call(c,"show"))}),a(function(){n.call(a('[data-provide="datepicker-inline"]'))})});

/***/ }),
/* 550 */
5,
/* 551 */,
/* 552 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("schemaForm").run(["$templateCache", function ($templateCache) {
	  $templateCache.put("directives/decorators/bootstrap/number/currency.html", "<div class=\"form-group\" ng-class=\"{\'has-error\': hasError(), \'has-success\': hasSuccess(), \'has-feedback\': form.feedback !== false }\">\n  <label class=\"control-label\" ng-show=\"showTitle()\">{{form.title}}</label>\n  <div class=\"input-group\">\n    <div class=\"input-group-addon\">{{form.options.unit || (\'number.currency.format.unit\' | translate)}}</div>\n    <input type=\"number\" class=\"form-control\" \n      step=\"any\"\n      sf-changed=\"form\"\n      class=\"{{form.options.uiClass}}\"\n      placeholder=\"{{form.placeholder}}\"\n      ng-model-options=\"form.ngModelOptions\"\n      ng-model=\"$$value$$\"\n      schema-validate=\"form\" />\n  </div>\n  <span ng-if=\"form.feedback !== false\"\n    class=\"form-control-feedback\"\n    ng-class=\"evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }\"></span>\n  <div class=\"help-block\"\n    ng-show=\"(hasError() && errorMessage(schemaError())) || form.description\"\n    ng-bind-html=\"(hasError() && errorMessage(schemaError())) || form.description\"></div>\n</div>\n");
	}]);
	angular.module('schemaForm-currency', ['schemaForm']).config(['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider', function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
	
	  var currency = function currency(name, schema, options) {
	    if (schema.type == 'number' && schema.format == 'currency') {
	      var f = schemaFormProvider.stdFormObj(name, schema, options);
	      f.key = options.path;
	      f.type = 'currency';
	      options.lookup[sfPathProvider.stringify(options.path)] = f;
	      return f;
	    }
	  };
	
	  schemaFormProvider.defaults.number.unshift(currency);
	
	  schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'currency', 'directives/decorators/bootstrap/number/currency.html');
	  schemaFormDecoratorsProvider.createDirective('currency', 'directives/decorators/bootstrap/number/currency.html');
	}]);

/***/ }),
/* 553 */
/***/ (function(module, exports) {

	"use strict";
	
	var dsfsefdffx = "<div class=\"form-group\" ng-class=\"{\'has-error\': hasError(), \'has-success\': hasSuccess(), \'has-feedback\': form.feedback !== false }\">" + "  <label class=\"control-label\" ng-show=\"showTitle()\">{{form.title}}</label>" + "  <div class=\"input-group\">" + "    <div class=\"input-group-addon\">{{form.options.unit || (\'number.currency.format.unit\' | translate)}}</div>" + "    <input type=\"number\" class=\"form-control\" " + "      step=\"any\"" + "      sf-changed=\"form\"" + "      class=\"{{form.options.uiClass}}\"" + "      placeholder=\"{{form.placeholder}}\"" + "      ng-model-options=\"form.ngModelOptions\"" + "      ng-model=\"$$value$$\"" + "      schema-validate=\"form\" />" + "  </div>" + "  <span ng-if=\"form.feedback !== false\"" + "    class=\"form-control-feedback\"" + "    ng-class=\"evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }\"></span>" + "  <div class=\"help-block\"" + "    ng-show=\"(hasError() && errorMessage(schemaError())) || form.description\"" + "    ng-bind-html=\"(hasError() && errorMessage(schemaError())) || form.description\"></div>" + "</div>";
	
	var templateSchemaFormPicklist = "\n    <div class=\"form-group\" ng-class=\"{'has-error': hasError(), 'has-success': hasSuccess(), 'has-feedback': form.feedback !== false }\" >\n        <label class=\"control-label\" ng-show=\"showTitle()\">{{form.title}}</label>\n        <picklist name=\"{{form.name}}\" size=\"10\" data-picklist=\"\" data-pick-model=\"$$value$$\" data-pick-options=\"o.id as o.name for o in form.schema.items\"></picklist>\n        <pre>{{model | json}}</pre>\n    </div>\n";
	
	angular.module("schemaForm").run(["$templateCache", function ($templateCache) {
	  $templateCache.put("directives/decorators/bootstrap/array/picklist.html", templateSchemaFormPicklist);
	}]);
	
	angular.module('schemaForm-picklist', ['schemaForm']).config(['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider', function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
	
	  var picklist = function picklist(name, schema, options) {
	
	    console.log(name);
	    console.log(schema);
	    console.log(options);
	
	    if (schema.type == 'array' && schema.format == 'picklist') {
	      var f = schemaFormProvider.stdFormObj(name, schema, options);
	      f.key = options.path;
	      f.type = 'picklist';
	      options.lookup[sfPathProvider.stringify(options.path)] = f;
	      return f;
	    }
	  };
	
	  schemaFormProvider.defaults.array.unshift(picklist);
	
	  schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'picklist', 'directives/decorators/bootstrap/array/picklist.html');
	  schemaFormDecoratorsProvider.createDirective('picklist', 'directives/decorators/bootstrap/array/picklist.html');
	}]);

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	"use strict";
	
	var templateSchemaFormDateTimePicker = "\n    <div class=\"form-group\" ng-init=\"popupOpen=false\" ng-class=\"{'has-error': hasError(), 'has-success': hasSuccess(), 'has-feedback': form.feedback !== false }\" >\n        <label class=\"control-label\" ng-show=\"showTitle()\">{{form.title}}</label>\n\n        <p class=\"input-group\">\n           <input type=\"text\" class=\"form-control\" ng-model=\"$$value$$\" uib-datepicker-popup is-open=\"popupOpen\" close-text=\"Close\" />\n           <span class=\"input-group-btn\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"popupOpen=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n          </span>\n        </p>\n\n       <!-- <combined-date-time-picker sf-field-model=\"model\" form=\"form\"></combined-date-time-picker> -->\n    </div>\n";
	
	angular.module("schemaForm").run(["$templateCache", function ($templateCache) {
	  $templateCache.put("directives/decorators/bootstrap/dtpicker/dtpicker.html", templateSchemaFormDateTimePicker);
	}]);
	
	angular.module('schemaForm-dtpicker', ['schemaForm']).config(['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider', function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
	
	  var dtpicker = function dtpicker(name, schema, options) {
	
	    if (schema.type == 'string' && schema.format == 'date') {
	
	      var f = schemaFormProvider.stdFormObj(name, schema, options);
	      f.key = options.path;
	      f.type = 'dtpicker';
	      options.lookup[sfPathProvider.stringify(options.path)] = f;
	      return f;
	    }
	  };
	
	  schemaFormProvider.defaults.string.unshift(dtpicker);
	
	  schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'dtpicker', 'directives/decorators/bootstrap/dtpicker/dtpicker.html');
	  schemaFormDecoratorsProvider.createDirective('dtpicker', 'directives/decorators/bootstrap/dtpicker/dtpicker.html');
	}]);

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	"use strict";
	
	var templateSchemaFormPercent = "\n    <div class=\"form-group\" ng-class=\"{'has-error': hasError(), 'has-success': hasSuccess(), 'has-feedback': form.feedback !== false }\" >\n        <label class=\"control-label\" ng-show=\"showTitle()\">{{form.title}}</label>\n        <span style=\"float: right\">{{$$value$$ | number:'0'}}%</span>\n        <input type=\"range\" min=\"0\" max=\"100\" ng-model=\"$$value$$\" form=\"form\" />\n    </div>\n";
	
	angular.module("schemaForm").run(["$templateCache", function ($templateCache) {
	  $templateCache.put("directives/decorators/bootstrap/range/percent.html", templateSchemaFormPercent);
	}]);
	
	angular.module('schemaForm-percent', ['schemaForm']).config(['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider', function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
	
	  var percent = function percent(name, schema, options) {
	
	    console.log(name);
	    console.log(schema);
	    console.log(options);
	
	    if (schema.type == 'number' && schema.format == 'percent') {
	      var f = schemaFormProvider.stdFormObj(name, schema, options);
	      f.key = options.path;
	      f.type = 'percent';
	      options.lookup[sfPathProvider.stringify(options.path)] = f;
	      return f;
	    }
	  };
	
	  schemaFormProvider.defaults.number.unshift(percent);
	
	  schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'percent', 'directives/decorators/bootstrap/range/percent.html');
	  schemaFormDecoratorsProvider.createDirective('percent', 'directives/decorators/bootstrap/range/percent.html');
	}]);

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AcctstComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _acctst = __webpack_require__(557);
	
	var _acctst2 = _interopRequireDefault(_acctst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var AcctstComponent = exports.AcctstComponent = function () {
	  AcctstComponent.$inject = ['AccountingService'];
	  function AcctstComponent(AccountingService) {
	    'ngInject';
	
	    _classCallCheck(this, AcctstComponent);
	
	    this.AccountingService = AccountingService;
	  }
	
	  _createClass(AcctstComponent, [{
	    key: 'showId',
	    value: function showId(id) {
	      prompt('Journal ID', id);
	    }
	  }, {
	    key: 'getTransactions',
	    value: function getTransactions() {
	      var _this = this;
	
	      this.AccountingService.transactions({ book: 'test', account: this.account }, function (data) {
	        _this.transactions = data;
	      });
	    }
	  }, {
	    key: 'getJournal',
	    value: function getJournal() {
	      var _this2 = this;
	
	      this.AccountingService.journal({ book: 'test' }, function (data) {
	        _this2.journal = data;
	      });
	    }
	  }, {
	    key: 'getBalance',
	    value: function getBalance() {
	      var _this3 = this;
	
	      this.AccountingService.balance({ book: 'test', account: this.account }, function (data) {
	        _this3.balance = data;
	      });
	    }
	  }, {
	    key: 'voidEntry',
	    value: function voidEntry() {
	      var _this4 = this;
	
	      var body = this.voidReason ? { reason: this.voidReason } : {};
	
	      this.AccountingService.void({ book: 'test', id: this.voidId }, body, function (data) {
	        _this4.voidResult = data;
	      });
	    }
	  }, {
	    key: 'postEntry',
	    value: function postEntry() {
	      var _this5 = this;
	
	      this.AccountingService.entry({ book: 'test' }, {
	        entry: this.entry,
	        transactions: [{
	          type: 'debit',
	          account: this.debitAccount,
	          amount: this.debitAmount
	        }, {
	          type: 'credit',
	          account: this.creditAccount,
	          amount: this.creditAmount
	        }]
	      }, function (data) {
	        _this5.entryResult = data;
	      });
	    }
	  }]);
	
	  return AcctstComponent;
	}();
	
	exports.default = angular.module('conduuApp.acctst', [uiRouter]).config(_acctst2.default).component('acctst', {
	  template: __webpack_require__(558),
	  controller: AcctstComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('acctst', {
	    url: '/acctst',
	    template: '<acctst></acctst>'
	  });
	}];

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <ol class=\"breadcrumb\">\r\n            <h2>Accounting Test</h2>\r\n            <li class=\"active\"><a href=\"#\">Accounting Test</a></li>\r\n        </ol>\r\n\r\n        <div class=\"col-xs-12\">\r\n\r\n            <uib-tabset active=\"active\">\r\n                <uib-tab index=\"0\" heading=\"Create Entry\">\r\n                    <br/>\r\n                    <form name=\"form\" ng-submit=\"ctrl.postEntry()\">\r\n                        <label>Entry: <input type=\"text\" name=\"entry\" ng-model=\"ctrl.entry\" /></label>\r\n                        <br/>\r\n                        <label>Debit Account: <input type=\"text\" name=\"debitAccount\" ng-model=\"ctrl.debitAccount\" /></label>\r\n                        <label>Debit Amount: <input type=\"text\" name=\"debitAmount\" ng-model=\"ctrl.debitAmount\" /></label>\r\n                        <br/>\r\n                        <label>Credit Account: <input type=\"text\" name=\"creditAccount\" ng-model=\"ctrl.creditAccount\" /></label>\r\n                        <label>Credit Amount: <input type=\"text\" name=\"creditAmount\" ng-model=\"ctrl.creditAmount\" /></label>\r\n                        <input type=\"submit\" value=\"Go\" />\r\n                    </form>\r\n                    <br/>\r\n                    <pre>\r\n                        {{ctrl.entryResult | json}}\r\n                    </pre>\r\n                </uib-tab>\r\n                <uib-tab index=\"1\" heading=\"Transactions\">\r\n                    <br/>\r\n                    <form name=\"form\" ng-submit=\"ctrl.getTransactions()\">\r\n                        <label>Account: <input type=\"text\" name=\"account\" ng-model=\"ctrl.account\" /></label>\r\n                        <input type=\"submit\" value=\"Go\" />\r\n                    </form>\r\n\r\n                    <table class=\"table table-striped\" style=\"width:100%\">\r\n                        <thead>\r\n                        <tr>\r\n                            <th>Book</th>\r\n                            <th>Account</th>\r\n                            <th>Amount</th>\r\n                            <th>Date</th>\r\n                            <th>Memo</th>\r\n                            <th>Status</th>\r\n                        </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                        <tr ng-class=\"{'text-muted voided': tx.voided}\" ng-repeat=\"tx in ctrl.transactions.results | orderBy: 'datetime':true\">\r\n                            <td>{{tx.book}}</td>\r\n                            <td>{{tx.accounts}}</td>\r\n                            <td ng-if=\"tx.credit\" ng-class=\"{'text-success': tx.credit > 0}\">$ {{tx.credit | number:2}}</td>\r\n                            <td ng-if=\"tx.debit\" ng-class=\"{'text-danger': tx.debit > 0}\">$ ({{tx.debit | number:2}})</td>\r\n                            <td>{{tx.datetime | date:'short'}}</td>\r\n                            <td>{{tx.memo}}</td>\r\n                            <td ng-if=\"tx.approved && !tx.voided\"><i class=\"fa fa-check\" title=\"Accepted\"></i></td>\r\n                            <td ng-if=\"tx.voided\"><i class=\"fa fa-times\" title=\"Voided\"></i></td>\r\n                        </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </uib-tab>\r\n                <uib-tab index=\"2\" heading=\"Journal\">\r\n                    <br/>\r\n                    <form name=\"form\" ng-submit=\"ctrl.getJournal()\">\r\n                        <input type=\"submit\" value=\"Go\" />\r\n                    </form>\r\n\r\n                    <table class=\"table table-striped\" style=\"width:100%\">\r\n                        <thead>\r\n                        <tr>\r\n                            <th>Id</th>\r\n                            <th>Date</th>\r\n                            <th>Status</th>\r\n                            <th>Memo</th>\r\n                            <th>Transactions</th>\r\n                        </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                        <tr ng-repeat=\"jrnl in ctrl.journal | orderBy: 'datetime':true\">\r\n                            <td><a href=\"#\" ng-click=\"ctrl.showId(jrnl._id)\" title=\"{{jrnl._id}}\">Show</a></td>\r\n                            <td>{{jrnl.datetime | date:'short'}}</td>\r\n                            <td ng-if=\"jrnl.approved\"><i class=\"fa fa-check\"></i></td>\r\n                            <td ng-if=\"jrnl.voided\"><i class=\"fa fa-times\"></i></td>\r\n                            <td>{{jrnl._transactions[0].memo}}</td>\r\n                            <td style=\"padding:0\">\r\n                                <table style=\"width:100%; margin: 4px; margin-left: 8px\">\r\n                                    <!--<thead>\r\n                                    <tr>\r\n                                        <th style=\"width:50%\">Account</th>\r\n                                        <th>Credit</th>\r\n                                        <th>Debit</th>\r\n                                    </tr>\r\n                                    </thead>-->\r\n                                    <tbody>\r\n                                    <tr ng-repeat=\"tx in jrnl._transactions | orderBy: 'datetime':true\">\r\n                                        <td style=\"width:50%\">{{tx.accounts}}</td>\r\n                                        <td style=\"width:25%\" ng-class=\"{'text-success': tx.credit > 0, 'text-muted': tx.credit == 0}\">$ {{tx.credit | number:2}}</td>\r\n                                        <td style=\"width:25%\" ng-class=\"{'text-danger': tx.debit > 0, 'text-muted': tx.debit == 0}\">$ ({{tx.debit | number:2}})</td>\r\n                                    </tr>\r\n                                    </tbody>\r\n                                </table>\r\n                            </td>\r\n                        </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </uib-tab>\r\n                <uib-tab index=\"3\" heading=\"Balance\">\r\n                    <br/>\r\n                    <form name=\"form\" ng-submit=\"ctrl.getBalance()\">\r\n                        <label>Account: <input type=\"text\" name=\"account\" ng-model=\"ctrl.account\" /></label>\r\n                        <input type=\"submit\" value=\"Go\" />\r\n                    </form>\r\n\r\n                    <span ng-class=\"{'text-danger': ctrl.balance.balance.balance < 0, 'text-success': ctrl.balance.balance.balance >= 0}\">{{ctrl.balance.balance.balance | number:2}}</span>\r\n                </uib-tab>\r\n                <uib-tab index=\"4\" heading=\"Void Journal Entry\">\r\n                    <br/>\r\n                    <form name=\"form\" ng-submit=\"ctrl.voidEntry()\">\r\n                        <label>Journal Id: <input type=\"text\" name=\"entry\" ng-model=\"ctrl.voidId\" /></label>\r\n                        <label>Reason: <input type=\"text\" name=\"voidReason\" ng-model=\"ctrl.voidReason\" /></label>\r\n                        <input type=\"submit\" value=\"Go\" />\r\n                    </form>\r\n                    <br/>\r\n                    <pre>\r\n                        {{ctrl.voidResult | json}}\r\n                    </pre>\r\n                </uib-tab>\r\n            </uib-tabset>\r\n\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AccountingService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountingService = AccountingService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function AccountingService($resource) {
	  return $resource('/api/accounting/:id', {
	    id: '@_id'
	  }, {
	    balance: {
	      method: 'GET',
	      url: '/api/accounting/:book/balance/:account'
	    },
	    transactions: {
	      method: 'GET',
	      url: '/api/accounting/:book/transactions/:account'
	    },
	    entry: {
	      method: 'POST',
	      url: '/api/accounting/:book/entries'
	    },
	    void: {
	      method: 'PUT',
	      url: '/api/accounting/:book/void/:id'
	    },
	    journal: {
	      method: 'GET',
	      url: '/api/accounting/:book/journal',
	      isArray: true
	    }
	  });
	}
	
	exports.default = angular.module('conduu.AccountingService', []).factory('AccountingService', AccountingService).name;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JournalEntriesComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _journalEntries = __webpack_require__(561);
	
	var _journalEntries2 = _interopRequireDefault(_journalEntries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var JournalEntriesComponent = exports.JournalEntriesComponent = function () {
	  JournalEntriesComponent.$inject = ['AccountingService', 'dialogs'];
	  function JournalEntriesComponent(AccountingService, dialogs) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, JournalEntriesComponent);
	
	    this.AccountingService = AccountingService;
	    this.dialogs = dialogs;
	
	    this.AccountingService.journal({ book: 'test' }, function (data) {
	      _this.journal = data;
	    });
	  }
	
	  _createClass(JournalEntriesComponent, [{
	    key: 'showId',
	    value: function showId(id) {
	      prompt('Journal ID', id);
	    }
	  }, {
	    key: 'voidEntry',
	    value: function voidEntry(entry) {
	      var _this2 = this;
	
	      var that = this;
	
	      var text = "<br/> <br/>" + "<table class='table' style='width:100%'>" + "<thead>" + "<tr>" + "<th>Account</th>" + "<th>Credit</th>" + "<th>Debit</th>" + "<th>Memo</th>" + "</tr>" + "</thead>" + "<tbody>";
	
	      entry._transactions.forEach(function (tx) {
	        text += "<tr>" + "<td>" + tx.accounts + "</td>" + "<td>" + tx.credit + "</td>" + "<td>" + tx.debit + "</td>" + "<td>" + tx.memo + "</td>" + "</tr>";
	      });
	
	      text += "</tbody>" + "</table>";
	
	      var dlg = this.dialogs.confirm("Void Journal Entry?", "Do you really want to void the journal entry?" + text);
	      dlg.result.then(function () {
	        that.AccountingService.void({ book: 'test', id: entry._id }, {}, function () {
	          _this2.AccountingService.journal({ book: 'test' }, function (data) {
	            _this2.journal = data;
	          });
	        }, function (err) {
	          alert("Could not void journal entry");
	        });
	      }, function () {});
	    }
	  }]);
	
	  return JournalEntriesComponent;
	}();
	
	exports.default = angular.module('conduuApp.journalEntries', [uiRouter]).config(_journalEntries2.default).component('journalEntries', {
	  template: __webpack_require__(562),
	  controller: JournalEntriesComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('journal-entries', {
	    url: '/accounting/journal',
	    template: '<journal-entries></journal-entries>'
	  });
	}];

/***/ }),
/* 562 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <ol class=\"breadcrumb\">\r\n            <h2>Journal Entries</h2>\r\n            <li class=\"active\"><a href=\"#\">Journal Entries</a></li>\r\n        </ol>\r\n\r\n        <div class=\"col-xs-12\">\r\n\r\n            <table class=\"table table-striped\" style=\"width:100%\">\r\n                <thead>\r\n                <tr>\r\n                    <th>Id</th>\r\n                    <th>Date</th>\r\n                    <th>Status</th>\r\n                    <th>Transactions</th>\r\n                    <th>Void</th>\r\n                </tr>\r\n                </thead>\r\n                <tbody>\r\n                <tr ng-repeat=\"jrnl in ctrl.journal | orderBy: 'datetime':true\">\r\n                    <td><a href=\"#\" ng-click=\"ctrl.showId(jrnl._id)\" title=\"{{jrnl._id}}\">Show</a></td>\r\n                    <td>{{jrnl.datetime | date:'short'}}</td>\r\n                    <td ng-if=\"jrnl._transactions[0].approved && !jrnl._transactions[0].voided\"><i class=\"fa fa-check\"></i></td>\r\n                    <td ng-if=\"jrnl._transactions[0].voided\"><i class=\"fa fa-times\"></i></td>\r\n                    <td>\r\n                        <table class=\"table table-bordered\" style=\"width:100%\">\r\n                            <thead>\r\n                            <tr>\r\n                                <th>Account</th>\r\n                                <th>Credit</th>\r\n                                <th>Debit</th>\r\n                                <th>Memo</th>\r\n                            </tr>\r\n                            </thead>\r\n                            <tbody>\r\n                            <tr ng-class=\"{'text-muted voided': tx.voided}\" ng-repeat=\"tx in jrnl._transactions | orderBy: 'datetime':true\">\r\n                                <td>{{tx.accounts}}</td>\r\n                                <td ng-class=\"{'text-success': tx.credit > 0}\">$ {{tx.credit | number:2}}</td>\r\n                                <td ng-class=\"{'text-danger': tx.debit > 0}\">$ ({{tx.debit | number:2}})</td>\r\n                                <td>{{tx.memo}}</td>\r\n                            </tr>\r\n                            </tbody>\r\n                        </table>\r\n                    </td>\r\n                    <td><button class=\"btn btn-sm btn-warning\" ng-class=\"{'disabled': jrnl._transactions[0].voided}\" ng-click=\"ctrl.voidEntry(jrnl)\"><i class=\"fa fa-refresh\"></i></button></td>\r\n                </tr>\r\n                </tbody>\r\n            </table>\r\n\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChartOfAccountComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _chartOfAccounts = __webpack_require__(564);
	
	var _chartOfAccounts2 = _interopRequireDefault(_chartOfAccounts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ChartOfAccountComponent = exports.ChartOfAccountComponent = function () {
	  ChartOfAccountComponent.$inject = ['AccountingService', 'SettingsService'];
	  function ChartOfAccountComponent(AccountingService, SettingsService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ChartOfAccountComponent);
	
	    this.asTable = false;
	
	    this.treeOptions = {
	      nodeChildren: "subAccounts",
	      dirSelectable: true,
	      injectClasses: {
	        ul: "a1",
	        li: "a2",
	        liSelected: "a7",
	        iExpanded: "a3",
	        iCollapsed: "a4",
	        iLeaf: "a5",
	        label: "a6",
	        labelSelected: "a8"
	      }
	    };
	
	    this.showSelected = function (node) {
	      console.log(node);
	    };
	
	    this.AccountingService = AccountingService;
	    this.SettingsService = SettingsService;
	
	    this.flattedAccounts = [];
	
	    this.SettingsService.getByName({ name: 'chart-of-accounts' }, function (coa) {
	      _this.data = coa.data;
	
	      _this.data.forEach(function (headAccount) {
	        _this.flattedAccounts.push({
	          account: headAccount.account,
	          code: headAccount.code,
	          description: headAccount.description
	        });
	
	        if (headAccount.hasOwnProperty('subAccounts')) {
	
	          headAccount.subAccounts.forEach(function (subAccount) {
	
	            _this.flattedAccounts.push({
	              account: [headAccount.account, subAccount.account].join(' / '),
	              code: subAccount.code,
	              description: subAccount.description
	            });
	
	            if (subAccount.hasOwnProperty('subAccounts')) {
	
	              subAccount.subAccounts.forEach(function (subSubAccount) {
	
	                _this.flattedAccounts.push({
	                  account: [headAccount.account, subAccount.account, subSubAccount.account].join(' / '),
	                  code: subSubAccount.code,
	                  description: subSubAccount.description
	                });
	              });
	            }
	          });
	        }
	      });
	    });
	  }
	
	  _createClass(ChartOfAccountComponent, [{
	    key: 'setAsTable',
	    value: function setAsTable(val) {
	      this.asTable = val;
	    }
	  }]);
	
	  return ChartOfAccountComponent;
	}();
	
	exports.default = angular.module('conduuApp.chartOfAccounts', [uiRouter]).config(_chartOfAccounts2.default).component('chartOfAccounts', {
	  template: __webpack_require__(565),
	  controller: ChartOfAccountComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('chart-of-accounts', {
	    url: '/accounting/accounts',
	    template: '<chart-of-accounts></chart-of-accounts>'
	  });
	}];

/***/ }),
/* 565 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <ol class=\"breadcrumb\">\r\n            <a style=\"float:right; margin-top:8px\" class=\"btn btn-primary\" href=\"/violation/ticket/edit/\"><i class=\"fa fa-plus\"></i> Create New Account</a>\r\n            <h2><i class=\"fa fa-fw fa-th-list text-primary\"></i> Chart of Accounts</h2>\r\n            <li class=\"active\"><a href=\"#\">Chart of Accounts</a></li>\r\n            <div class=\"btn-group\" role=\"group\" style=\"float: right; position:relative; top:-16px\">\r\n                <button type=\"button\" ng-click=\"ctrl.setAsTable(true)\"  class=\"btn btn-default\" ng-class=\"{'active': ctrl.asTable}\"><i class=\"fa fa-fw fa-table\"></i></button>\r\n                <button type=\"button\" ng-click=\"ctrl.setAsTable(false)\" class=\"btn btn-default\" ng-class=\"{'active': !ctrl.asTable}\"><i class=\"fa fa-fw fa-th-list\"></i></button>\r\n            </div>\r\n        </ol>\r\n\r\n        <div class=\"col-xs-12\">\r\n\r\n            <div class=\"row\" ng-hide=\"ctrl.asTable\">\r\n                <div class=\"col-xs-8\">\r\n                    <treecontrol class=\"tree-boot\"\r\n                                 tree-model=\"ctrl.data\"\r\n                                 options=\"ctrl.treeOptions\"\r\n                                 on-selection=\"ctrl.showSelected(node)\"\r\n                                 selected-node=\"ctrl.node\">\r\n                        <span title=\"{{node.description}}\" style=\"font-size:larger\">{{node.code}} {{node.account}}</span>\r\n                    </treecontrol>\r\n                </div>\r\n                <div class=\"col-sm-4\" ng-if=\"ctrl.node\" style=\"float:right\">\r\n                    <dl>\r\n                        <dt>Code</dt>\r\n                        <dd>{{ctrl.node.code}}</dd>\r\n                        <dt>Account</dt>\r\n                        <dd>{{ctrl.node.account}}</dd>\r\n                        <dt>Description</dt>\r\n                        <dd>{{ctrl.node.description}}</dd>\r\n                    </dl>\r\n                </div>\r\n            </div>\r\n\r\n            <div ng-show=\"ctrl.asTable\">\r\n                <table datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n                    <thead>\r\n                    <tr>\r\n                        <th>Code</th>\r\n                        <th>Account</th>\r\n                        <th>Description</th>\r\n                    </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                    <tr ng-repeat=\"account in ctrl.flattedAccounts\">\r\n                        <td>{{account.code}}</td>\r\n                        <td>{{account.account}}</td>\r\n                        <td>{{account.description}}</td>\r\n                    </tr>\r\n                    </tbody>\r\n                </table>\r\n            </div>\r\n            \r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BalanceSheetComponent = undefined;
	
	var _balanceSheet = __webpack_require__(567);
	
	var _balanceSheet2 = _interopRequireDefault(_balanceSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var BalanceSheetComponent = exports.BalanceSheetComponent = ['AccountingService', 'SettingsService', function BalanceSheetComponent(AccountingService, SettingsService) {
	  'ngInject';
	
	  var _this = this;
	
	  _classCallCheck(this, BalanceSheetComponent);
	
	  this.AccountingService = AccountingService;
	  this.SettingsService = SettingsService;
	
	  this.flattedAccounts = [];
	
	  this.SettingsService.getByName({ name: 'chart-of-accounts' }, function (coa) {
	    _this.data = coa.data;
	
	    _this.data.forEach(function (headAccount) {
	      _this.flattedAccounts.push({
	        account: headAccount.account,
	        code: headAccount.code,
	        description: headAccount.description
	      });
	
	      if (headAccount.hasOwnProperty('subAccounts')) {
	
	        headAccount.subAccounts.forEach(function (subAccount) {
	
	          _this.flattedAccounts.push({
	            account: [headAccount.account, subAccount.account].join(' / '),
	            code: subAccount.code,
	            description: subAccount.description
	          });
	
	          if (subAccount.hasOwnProperty('subAccounts')) {
	
	            subAccount.subAccounts.forEach(function (subSubAccount) {
	
	              _this.flattedAccounts.push({
	                account: [headAccount.account, subAccount.account, subSubAccount.account].join(' / '),
	                code: subSubAccount.code,
	                description: subSubAccount.description
	              });
	            });
	          }
	        });
	      }
	    });
	  });
	}];
	
	exports.default = angular.module('conduuApp.balanceSheet', [uiRouter]).config(_balanceSheet2.default).component('balanceSheet', {
	  template: __webpack_require__(568),
	  controller: BalanceSheetComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('balance-sheet', {
	    url: '/accounting/balance-sheet',
	    template: '<balance-sheet></balance-sheet>'
	  });
	}];

/***/ }),
/* 568 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <ol class=\"breadcrumb\">\r\n            <h2>Balance Sheet</h2>\r\n            <li class=\"active\"><a href=\"#\">Balance Sheet</a></li>\r\n        </ol>\r\n\r\n        <div class=\"col-xs-12\">\r\n\r\n            <table class=\"table borderless\" style=\"width:100%\">\r\n                <thead>\r\n                <tr>\r\n                    <th>Code</th>\r\n                    <th>Account</th>\r\n                    <th>Operating</th>\r\n                    <th>Reserves</th>\r\n                    <th>Other</th>\r\n                    <th>Totals</th>\r\n                </tr>\r\n                </thead>\r\n                <tbody>\r\n                <tr class=\"heading\">\r\n                    <td colspan=\"6\" class=\"text-center\">&mdash; ASSETS &mdash;</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>1310</td>\r\n                    <td>Assessments Receivable</td>\r\n                    <td>18,339.36</td>\r\n                    <td></td>\r\n                    <td></td>\r\n                    <td>18,339.36</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>1510</td>\r\n                    <td>A/R Other</td>\r\n                    <td>17,720.19</td>\r\n                    <td></td>\r\n                    <td></td>\r\n                    <td>17,720.19</td>\r\n                </tr>\r\n                <tr class=\"totals\">\r\n                    <td></td>\r\n                    <td>TOTAL ASSETS</td>\r\n                    <td>34,567.90</td>\r\n                    <td>.00</td>\r\n                    <td>.00</td>\r\n                    <td>34,567.90</td>\r\n                </tr>\r\n\r\n                <tr class=\"heading\">\r\n                    <td colspan=\"6\" class=\"text-center\">&mdash; LIABILITIES & EQUITY &mdash;</td>\r\n                </tr>\r\n\r\n                <tr>\r\n                    <td></td>\r\n                    <td style=\"letter-spacing: 2px\">CURRENT LIABILITIES</td>\r\n                    <td colspan=\"4\"></td>\r\n                </tr>\r\n                <tr>\r\n                    <td>3010</td>\r\n                    <td>Accounts Payable</td>\r\n                    <td>18,339.36</td>\r\n                    <td></td>\r\n                    <td></td>\r\n                    <td>18,339.36</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>3020</td>\r\n                    <td>Prepaid Owner Assesments</td>\r\n                    <td>17,720.19</td>\r\n                    <td></td>\r\n                    <td></td>\r\n                    <td>17,720.19</td>\r\n                </tr>\r\n                <tr class=\"sub-totals\">\r\n                    <td></td>\r\n                    <td>Subtotal Current Liab.</td>\r\n                    <td>34,567.90</td>\r\n                    <td>.00</td>\r\n                    <td>.00</td>\r\n                    <td>34,567.90</td>\r\n                </tr>\r\n\r\n                <tr>\r\n                    <td colspan=\"6\"></td>\r\n                </tr>\r\n\r\n                <tr>\r\n                    <td></td>\r\n                    <td style=\"letter-spacing: 2px\">RESERVES</td>\r\n                    <td colspan=\"4\"></td>\r\n                </tr>\r\n                <tr>\r\n                    <td>5010</td>\r\n                    <td>Reserves - Unallocated</td>\r\n                    <td></td>\r\n                    <td>18,339.36</td>\r\n                    <td></td>\r\n                    <td>18,339.36</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>5020</td>\r\n                    <td>Reserves - Pavement</td>\r\n                    <td></td>\r\n                    <td>17,720.19</td>\r\n                    <td></td>\r\n                    <td>17,720.19</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>530</td>\r\n                    <td>Reserves - Pool</td>\r\n                    <td></td>\r\n                    <td>4,120.49</td>\r\n                    <td></td>\r\n                    <td>4,120.49</td>\r\n                </tr>\r\n                <tr class=\"sub-totals\">\r\n                    <td></td>\r\n                    <td>Subtotal Reserves</td>\r\n                    <td>.00</td>\r\n                    <td>34,568.90</td>\r\n                    <td>.00</td>\r\n                    <td>34,568.90</td>\r\n                </tr>\r\n\r\n                <tr>\r\n                    <td colspan=\"6\"></td>\r\n                </tr>\r\n\r\n                <tr>\r\n                    <td></td>\r\n                    <td style=\"letter-spacing: 2px\">EQUITY</td>\r\n                    <td colspan=\"4\"></td>\r\n                </tr>\r\n                <tr>\r\n                    <td></td>\r\n                    <td>Current Year Net Income/(Loss)</td>\r\n                    <td>(149,091.45)</td>\r\n                    <td>.00</td>\r\n                    <td>.00</td>\r\n                    <td>(149,091.45)</td>\r\n                </tr>\r\n                <tr class=\"sub-totals\">\r\n                    <td></td>\r\n                    <td>Subtotal Equity</td>\r\n                    <td>(149,091.45)</td>\r\n                    <td>.00</td>\r\n                    <td>.00</td>\r\n                    <td>(149,091.45)</td>\r\n                </tr>\r\n\r\n                <tr>\r\n                    <td colspan=\"6\"></td>\r\n                </tr>\r\n\r\n                <tr class=\"totals\">\r\n                    <td></td>\r\n                    <td>TOTAL LIABILITIES & EQUITY</td>\r\n                    <td>344,567.90</td>\r\n                    <td>12,345.00</td>\r\n                    <td>.00</td>\r\n                    <td>434,567.90</td>\r\n                </tr>\r\n\r\n                </tbody>\r\n            </table>\r\n\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddJournalEntryComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _addJournalEntry = __webpack_require__(570);
	
	var _addJournalEntry2 = _interopRequireDefault(_addJournalEntry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var AddJournalEntryComponent = exports.AddJournalEntryComponent = function () {
	  AddJournalEntryComponent.$inject = ['SettingsService', 'Auth', '$state', 'dialogs', 'AccountingService', '$uibModal'];
	  function AddJournalEntryComponent(SettingsService, Auth, $state, dialogs, AccountingService, $uibModal) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, AddJournalEntryComponent);
	
	    this.SettingsService = SettingsService;
	    this.AccountingService = AccountingService;
	    this.$uibModal = $uibModal;
	    this.dialogs = dialogs;
	    this.$state = $state;
	    this.flattedAccountsEnum = [];
	    this.flattedAccountsMap = [];
	    this.rules = [];
	    this.rulesEnum = [];
	
	    this.SettingsService.getByName({ name: "chart-of-accounts" }, function (coa) {
	      _this.coa = coa.data;
	
	      _this.coa.forEach(function (headAccount) {
	        _this.flattedAccountsEnum.push(headAccount.account);
	        _this.flattedAccountsMap.push({ value: headAccount.account, name: headAccount.account });
	
	        if (headAccount.hasOwnProperty('subAccounts')) {
	          headAccount.subAccounts.forEach(function (subAccount) {
	
	            var accounts = [headAccount.account, subAccount.account].join(':');
	
	            _this.flattedAccountsEnum.push(accounts);
	            _this.flattedAccountsMap.push({ value: accounts, name: accounts.split(':').join(' / ') });
	
	            if (subAccount.hasOwnProperty('subAccounts')) {
	              subAccount.subAccounts.forEach(function (subSubAccount) {
	
	                var accounts = [headAccount.account, subAccount.account, subSubAccount.account].join(':');
	
	                _this.flattedAccountsEnum.push(accounts);
	                _this.flattedAccountsMap.push({ value: accounts, name: accounts.split(':').join(' / ') });
	              });
	            }
	          });
	        }
	      });
	
	      _this.SettingsService.getByName({ name: 'accounting-rules' }, function (rules) {
	
	        _this.rules = rules.data;
	        _this.rulesEnum = rules.data.map(function (code) {
	          return code.name;
	        });
	
	        _this.model = {
	          entry: "",
	          debit: [{
	            account: '',
	            amount: 0
	          }],
	          credit: [{
	            account: '',
	            amount: 0
	          }]
	        };
	      }, function (err) {
	        console.log('Could not load settings from server');
	      });
	    }, function (err) {
	      console.log('Could not load settings from server');
	    });
	  }
	
	  _createClass(AddJournalEntryComponent, [{
	    key: 'removeDebitAccount',
	    value: function removeDebitAccount(idx) {
	      this.model.debit.splice(idx, 1);
	    }
	  }, {
	    key: 'removeCreditAccount',
	    value: function removeCreditAccount(idx) {
	      this.model.credit.splice(idx, 1);
	    }
	  }, {
	    key: 'addDebitAccount',
	    value: function addDebitAccount() {
	      this.model.debit.push({
	        account: '',
	        amount: 0
	      });
	    }
	  }, {
	    key: 'addCreditAccount',
	    value: function addCreditAccount() {
	      this.model.credit.push({
	        account: '',
	        amount: 0
	      });
	    }
	  }, {
	    key: 'accountingRuleChanged',
	    value: function accountingRuleChanged() {
	      var _this2 = this;
	
	      var oRule = this.rules.find(function (rule) {
	        return rule.name == _this2.selectedAccountingRule;
	      });
	
	      if (!oRule) return;
	
	      this.model.debit = [];
	      this.model.credit = [];
	
	      oRule.accounts.debit.forEach(function (debitAcc) {
	        _this2.model.debit.push({
	          account: debitAcc,
	          amount: 0
	        });
	      });
	
	      oRule.accounts.credit.forEach(function (creditAcc) {
	        _this2.model.credit.push({
	          account: creditAcc,
	          amount: 0
	        });
	      });
	    }
	  }, {
	    key: 'lookupAccount',
	    value: function lookupAccount(style, type, idx) {
	      var that = this;
	
	      var component = 'accountLookup';
	
	      if (style == 'tree') component = 'accountTree';
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: component,
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (selectedAccount) {
	        that.model[type][idx].account = selectedAccount.accounts;
	      }, function () {});
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this3 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      var entry = {
	        entry: this.model.entry,
	        transactions: []
	      };
	
	      this.model.debit.forEach(function (debit) {
	        entry.transactions.push({
	          type: 'debit',
	          account: debit.account,
	          amount: debit.amount
	        });
	      });
	
	      this.model.credit.forEach(function (credit) {
	        entry.transactions.push({
	          type: 'credit',
	          account: credit.account,
	          amount: credit.amount
	        });
	      });
	
	      console.log(entry);
	
	      this.AccountingService.entry({ book: 'test' }, entry, function (data) {
	        _this3.model = data;
	      });
	    }
	  }]);
	
	  return AddJournalEntryComponent;
	}();
	
	exports.default = angular.module('conduu.addJournalEntry', [uiRouter]).config(_addJournalEntry2.default).component('addJournalEntry', {
	  template: __webpack_require__(571),
	  controller: AddJournalEntryComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('add-journal-entry', {
	    url: '/accounting/journal/add',
	    template: '<add-journal-entry></add-journal-entry>'
	  });
	}];

/***/ }),
/* 571 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Add Journal Entry</h2>\r\n      <li class=\"active\"><a href=\"#\">Add Journal Entry</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <div class=\"bs-callout bs-callout-info\" style=\"margin:0\">\r\n        <div class=\"form-group col-xs-5\">\r\n          <label>Accounting Rule</label>\r\n          <select class=\"form-control\" ng-options=\"o as o for o in ctrl.rulesEnum\" ng-model=\"ctrl.selectedAccountingRule\"\r\n          ng-change=\"ctrl.accountingRuleChanged()\"></select>\r\n        </div>\r\n        <div class=\"col-xs-7\">\r\n          <p>You can select an accounting rule above, or add the debit/credit account as you need them. But be aware that changes will be overwritten if the accounting rule is selected after some changes have been made.</p>\r\n        </div>\r\n        <div style=\"clear:both\"></div>\r\n      </div>\r\n\r\n      <br/>\r\n      \r\n      <form class=\"form\" name=\"form\" ng-submit=\"ctrl.create(form)\" novalidate>\r\n\r\n        <!-- Title -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.title.$valid && ctrl.submitted,\r\n                                            'has-error': form.title.$invalid && ctrl.submitted }\">\r\n          <label>Short Description / Memo</label>\r\n          <input type=\"text\" name=\"entry\" class=\"form-control\" ng-model=\"ctrl.model.entry\" required/>\r\n          <p class=\"help-block\" ng-show=\"form.entry.$error.required && ctrl.submitted\">\r\n            You must specify a memo for the entry.\r\n          </p>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <!-- Debit Accounts -->\r\n        <div class=\"form-group\">\r\n          <a style=\"float:right\" class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.addDebitAccount()\"><i class=\"fa fa-fw fa-plus\"></i> Add Debit Account</a>\r\n\r\n          <label>Debit Accounts</label>\r\n\r\n          <table style=\"width:100%;\" class=\"table\">\r\n            <thead>\r\n            <tr>\r\n              <th>Account</th>\r\n              <th>Amount</th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat=\"account in ctrl.model.debit\">\r\n              <td>\r\n                <div class=\"input-group\">\r\n                  <span class=\"input-group-btn\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.lookupAccount('tree','debit',$index)\"><i class=\"fa fa-fw fa-th-list\"></i></button>\r\n                  </span>\r\n                  <select class=\"form-control\" ng-options=\"o as o for o in ctrl.flattedAccountsEnum\" ng-model=\"account.account\"></select>\r\n                  <span class=\"input-group-btn\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.lookupAccount('table','debit',$index)\"><i class=\"fa fa-fw fa-search\"></i></button>\r\n                  </span>\r\n                </div>\r\n              </td>\r\n              <td>\r\n                <div class=\"input-group\">\r\n                  <span class=\"input-group-addon\">$</span>\r\n                  <input type=\"number\" step=\"0.01\" class=\"form-control\" ng-model=\"account.amount\" required/>\r\n                </div>\r\n              </td>\r\n              <td style=\"text-align: right\"><a class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.removeDebitAccount($index)\"><i class=\"fa fa-times\"></i></a></td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <!-- Credit Accounts -->\r\n        <div class=\"form-group\">\r\n          <a style=\"float:right\" class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.addCreditAccount()\"><i class=\"fa fa-fw fa-plus\"></i> Add Credit Account</a>\r\n\r\n          <label>Credit Accounts</label>\r\n\r\n          <table style=\"width:100%;\" class=\"table\">\r\n            <thead>\r\n            <tr>\r\n              <th>Account</th>\r\n              <th>Amount</th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat=\"account in ctrl.model.credit\">\r\n              <td>\r\n                <div class=\"input-group\">\r\n                  <span class=\"input-group-btn\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.lookupAccount('tree','credit',$index)\"><i class=\"fa fa-fw fa-th-list\"></i></button>\r\n                  </span>\r\n                  <select class=\"form-control\" ng-options=\"o as o for o in ctrl.flattedAccountsEnum\" ng-model=\"account.account\"></select>\r\n                  <span class=\"input-group-btn\">\r\n                      <button class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.lookupAccount('credit',$index)\"><i class=\"fa fa-fw fa-search\"></i></button>\r\n                    </span>\r\n                </div>\r\n              </td>\r\n              <td>\r\n                <div class=\"input-group\">\r\n                  <span class=\"input-group-addon\">$</span>\r\n                  <input type=\"number\" step=\"0.01\" class=\"form-control\" ng-model=\"account.amount\" required />\r\n                </div>\r\n              </td>\r\n              <td style=\"text-align: right\"><a class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.removeCreditAccount($index)\"><i class=\"fa fa-times\"></i></a></td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        \r\n        <br/>\r\n        <br/>\r\n\r\n        <button class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Create Journal Entry</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"home\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n      <br/>\r\n      <br/>\r\n\r\n      <pre>{{ctrl.model | json}}</pre>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var AccountTreeComponent = exports.AccountTreeComponent = function () {
	  /*@ngInject*/
	  AccountTreeComponent.$inject = ['SettingsService'];
	  function AccountTreeComponent(SettingsService) {
	    var _this = this;
	
	    _classCallCheck(this, AccountTreeComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	    };
	
	    this.SettingsService = SettingsService;
	
	    this.treeOptions = {
	      nodeChildren: "subAccounts",
	      dirSelectable: true,
	      injectClasses: {
	        ul: "a1",
	        li: "a2",
	        liSelected: "a7",
	        iExpanded: "a3",
	        iCollapsed: "a4",
	        iLeaf: "a5",
	        label: "a6",
	        labelSelected: "a8"
	      }
	    };
	
	    this.flattedAccounts = [];
	
	    this.SettingsService.getByName({ name: "chart-of-accounts" }, function (coa) {
	      _this.coa = coa.data;
	
	      _this.coa.forEach(function (headAccount) {
	        _this.flattedAccounts.push({
	          code: headAccount.code,
	          accounts: headAccount.account,
	          description: headAccount.description
	        });
	
	        if (headAccount.hasOwnProperty('subAccounts')) {
	          headAccount.subAccounts.forEach(function (subAccount) {
	
	            var accounts = [headAccount.account, subAccount.account].join(':');
	
	            _this.flattedAccounts.push({
	              code: subAccount.code,
	              accounts: accounts,
	              description: subAccount.description
	            });
	
	            if (subAccount.hasOwnProperty('subAccounts')) {
	              subAccount.subAccounts.forEach(function (subSubAccount) {
	
	                var accounts = [headAccount.account, subAccount.account, subSubAccount.account].join(':');
	
	                _this.flattedAccounts.push({
	                  code: subSubAccount.code,
	                  accounts: accounts,
	                  description: subSubAccount.description
	                });
	              });
	            }
	          });
	        }
	      });
	    });
	  }
	
	  _createClass(AccountTreeComponent, [{
	    key: 'ok',
	    value: function ok() {
	
	      var code = this.node.code;
	
	      var account = this.flattedAccounts.find(function (acc) {
	        return acc.code == code;
	      });
	
	      this.close({ $value: account });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return AccountTreeComponent;
	}();
	
	exports.default = angular.module('conduu.accountTree', []).component('accountTree', {
	  template: __webpack_require__(573),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: AccountTreeComponent
	}).name;

/***/ }),
/* 573 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">Account Tree</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <treecontrol class=\"tree-boot\"\r\n               tree-model=\"$ctrl.coa\"\r\n               options=\"$ctrl.treeOptions\"\r\n               selected-node=\"$ctrl.node\">\r\n    <span title=\"{{node.description}}\" style=\"font-size:larger\">{{node.code}} {{node.account}}</span>\r\n  </treecontrol>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!$ctrl.node\" ng-click=\"$ctrl.ok()\">OK</button>\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var AccountLookupComponent = exports.AccountLookupComponent = function () {
	  /*@ngInject*/
	  AccountLookupComponent.$inject = ['SettingsService'];
	  function AccountLookupComponent(SettingsService) {
	    var _this = this;
	
	    _classCallCheck(this, AccountLookupComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	    };
	
	    this.SettingsService = SettingsService;
	
	    this.flattedAccounts = [];
	
	    this.SettingsService.getByName({ name: "chart-of-accounts" }, function (coa) {
	      _this.coa = coa.data;
	
	      _this.coa.forEach(function (headAccount) {
	        _this.flattedAccounts.push({
	          code: headAccount.code,
	          accounts: headAccount.account,
	          description: headAccount.description
	        });
	
	        if (headAccount.hasOwnProperty('subAccounts')) {
	          headAccount.subAccounts.forEach(function (subAccount) {
	
	            var accounts = [headAccount.account, subAccount.account].join(':');
	
	            _this.flattedAccounts.push({
	              code: subAccount.code,
	              accounts: accounts,
	              description: subAccount.description
	            });
	
	            if (subAccount.hasOwnProperty('subAccounts')) {
	              subAccount.subAccounts.forEach(function (subSubAccount) {
	
	                var accounts = [headAccount.account, subAccount.account, subSubAccount.account].join(':');
	
	                _this.flattedAccounts.push({
	                  code: subSubAccount.code,
	                  accounts: accounts,
	                  description: subSubAccount.description
	                });
	              });
	            }
	          });
	        }
	      });
	    });
	  }
	
	  _createClass(AccountLookupComponent, [{
	    key: 'ok',
	    value: function ok(account) {
	      this.close({ $value: account });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return AccountLookupComponent;
	}();
	
	exports.default = angular.module('conduu.accountLookup', []).component('accountLookup', {
	  template: __webpack_require__(575),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: AccountLookupComponent
	}).name;

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">Account Lookup</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <table datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n    <thead>\r\n    <tr>\r\n      <th>Code</th>\r\n      <th>Account</th>\r\n      <th>Description</th>\r\n      <th>Select</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-repeat=\"account in $ctrl.flattedAccounts\">\r\n      <td>{{account.code}}</td>\r\n      <td>{{account.accounts}}</td>\r\n      <td>{{account.description}}</td>\r\n      <td>\r\n        <a class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.ok(account)\">\r\n          <i class=\"fa fa-hand-pointer-o fa-fw\"></i> Select\r\n        </a>\r\n      </td>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var PropertyLookupComponent = exports.PropertyLookupComponent = function () {
	  /*@ngInject*/
	  PropertyLookupComponent.$inject = ['PropertyService', '$scope'];
	  function PropertyLookupComponent(PropertyService, $scope) {
	    _classCallCheck(this, PropertyLookupComponent);
	
	    this.PropertyService = PropertyService;
	    this.$scope = $scope;
	
	    this.dtInstance = {};
	
	    this.data = [];
	
	    this.selected = {};
	  }
	
	  _createClass(PropertyLookupComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.config = this.resolve.config;
	
	      this.PropertyService.query(function (data) {
	        if (_this.config && _this.config.exclude) {
	          var excludeList = Array.isArray(_this.config.exclude) ? _this.config.exclude : [_this.config.exclude];
	          _this.data = data.filter(function (contact) {
	            return !excludeList.includes(String(contact._id));
	          });
	        } else {
	          _this.data = data;
	        }
	
	        if (_this.config.multiple && _this.config.checkAll) _this.checkAll();
	
	        _this.dataInitComplete = true;
	      }, function (err) {
	        console.log("Could not retrieve properties.");
	      });
	    }
	  }, {
	    key: 'checkAll',
	    value: function checkAll() {
	
	      var that = this;
	
	      var api = this.dtInstance.DataTable;
	      api.rows({ search: 'applied' }).every(function () {
	
	        var _id = api.cell({ row: this.index(), column: 0 }).nodes().to$().find('span')[0].getAttribute('x-filter-id');
	
	        that.selected[_id] = true;
	      });
	      this.dtInstance.DataTable.draw();
	    }
	  }, {
	    key: 'uncheckAll',
	    value: function uncheckAll() {
	      var that = this;
	
	      var api = this.dtInstance.DataTable;
	      api.rows({ search: 'applied' }).every(function () {
	
	        var _id = api.cell({ row: this.index(), column: 0 }).nodes().to$().find('span')[0].getAttribute('x-filter-id');
	
	        that.selected[_id] = false;
	      });
	      this.dtInstance.DataTable.draw();
	    }
	  }, {
	    key: 'getSelectedCount',
	    value: function getSelectedCount() {
	      var _this2 = this;
	
	      return this.data.filter(function (wa) {
	        return _this2.selected[wa._id];
	      }).map(function (wa) {
	        return wa._id;
	      }).length;
	    }
	  }, {
	    key: 'okMultiple',
	    value: function okMultiple() {
	      var _this3 = this;
	
	      var selectedData = this.data.filter(function (ppty) {
	        return _this3.selected[ppty._id];
	      }).map(function (ppty) {
	        return ppty._id;
	      });
	      this.close({ $value: selectedData });
	    }
	  }, {
	    key: 'ok',
	    value: function ok(property) {
	      this.close({ $value: property });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += "<br/>" + contact.company;
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'getPrimaryOwner',
	    value: function getPrimaryOwner(property) {
	      var primary = property.contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary || !primary.contact) return "-";
	
	      return this.getComposedName(primary.contact);
	    }
	  }, {
	    key: 'getOtherOwner',
	    value: function getOtherOwner(property) {
	      var other = property.contacts.find(function (contact) {
	        return contact.type == 'owner';
	      });
	
	      if (!other) return "-";
	
	      return this.getComposedName(other.contact);
	    }
	  }]);
	
	  return PropertyLookupComponent;
	}();
	
	exports.default = angular.module('conduu.propertyLookup', []).component('propertyLookup', {
	  template: __webpack_require__(577),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: PropertyLookupComponent
	}).name;

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">Property Lookup</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <table ng-if=\"$ctrl.dataInitComplete\" datatable=\"ng\" dt-instance=\"$ctrl.dtInstance\" class=\"table table-striped\" style=\"width:100%\">\r\n    <thead>\r\n    <tr>\r\n      <th ng-if=\"$ctrl.config.multiple\"></th>\r\n      <th>Cmty.</th>\r\n      <th>LotNo</th>\r\n      <th>Primary Owner</th>\r\n      <th>Other Owner</th>\r\n      <th>Address</th>\r\n      <th ng-if=\"!$ctrl.config.multiple\">Select</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-repeat=\"property in $ctrl.data | orderBy: 'meta.creationDate':true\">\r\n      <td ng-if=\"$ctrl.config.multiple\">\r\n        <input type=\"checkbox\" ng-model=\"$ctrl.selected[property._id]\">\r\n        <span x-filter-id=\"{{property._id}}\" style=\"display: none\"></span>\r\n      </td>\r\n      <td>{{property.community.code}}</td>\r\n      <td>{{property.lotNo}}</td>\r\n      <td ng-bind-html=\"$ctrl.getPrimaryOwner(property)\"></td>\r\n      <td ng-bind-html=\"$ctrl.getOtherOwner(property)\"></td>\r\n      <td>{{property.address.street}}<br/>{{property.address.city}} {{property.address.state}}, {{property.address.zip}}</td>\r\n      <td ng-if=\"!$ctrl.config.multiple\">\r\n        <a class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.ok(property)\">\r\n          <i class=\"fa fa-hand-pointer-o fa-fw\"></i> Select\r\n        </a>\r\n      </td>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"modal-footer\">\r\n\r\n  <div ng-if=\"$ctrl.config.multiple\" style=\"float:left; text-align: left\">\r\n    <span>{{$ctrl.getSelectedCount()}} Entries selected</span><br/>\r\n    <a style=\"cursor: pointer; text-decoration: none\" ng-click=\"$ctrl.checkAll()\"><i class=\"fa fa-fw fa-check-square-o\"></i> Check All</a> | <a style=\"cursor: pointer; text-decoration: none\" ng-click=\"$ctrl.uncheckAll()\"><i class=\"fa fa-fw fa-times\"></i> Uncheck All</a>\r\n  </div>\r\n  <button ng-if=\"$ctrl.config.multiple\" class=\"btn btn-primary\" ng-disabled=\"!$ctrl.getSelectedCount()\" type=\"button\" ng-click=\"$ctrl.okMultiple()\">OK</button>\r\n\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var VendorLookupComponent = exports.VendorLookupComponent = function () {
	  /*@ngInject*/
	  VendorLookupComponent.$inject = ['VendorService'];
	  function VendorLookupComponent(VendorService) {
	    var _this = this;
	
	    _classCallCheck(this, VendorLookupComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	    };
	
	    this.VendorService = VendorService;
	
	    this.data = [];
	
	    this.VendorService.query(function (data) {
	      _this.data = data;
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve vendors.");
	    });
	  }
	
	  _createClass(VendorLookupComponent, [{
	    key: 'ok',
	    value: function ok(property) {
	      this.close({ $value: property });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }, {
	    key: 'getPrimaryAddress',
	    value: function getPrimaryAddress(vendor) {
	      var primary = vendor.address.find(function (addr) {
	        return addr.isPrimary == true;
	      });
	
	      if (!primary) return "-";
	
	      return primary.street + "<br/>" + primary.city + ' ' + primary.state + ', ' + primary.zip;
	    }
	  }]);
	
	  return VendorLookupComponent;
	}();
	
	exports.default = angular.module('conduu.vendorLookup', []).component('vendorLookup', {
	  template: __webpack_require__(579),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: VendorLookupComponent
	}).name;

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">Vendor Lookup</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <table ng-if=\"$ctrl.dataInitComplete\" datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n    <thead>\r\n    <tr>\r\n      <th>Name</th>\r\n      <th>Business Type</th>\r\n      <th>Address</th>\r\n      <th>Select</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-repeat=\"vendor in $ctrl.data | orderBy: 'meta.creationDate':true\">\r\n      <td>{{vendor.name}}</td>\r\n      <td>{{vendor.type}}</td>\r\n      <td ng-bind-html=\"$ctrl.getPrimaryAddress(vendor)\"></td>\r\n      <td>\r\n        <a class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.ok(vendor)\">\r\n          <i class=\"fa fa-hand-pointer-o fa-fw\"></i> Select\r\n        </a>\r\n      </td>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var UserLookupComponent = exports.UserLookupComponent = function () {
	  /*@ngInject*/
	  UserLookupComponent.$inject = ['User'];
	  function UserLookupComponent(User) {
	    var _this = this;
	
	    _classCallCheck(this, UserLookupComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	    };
	
	    this.User = User;
	
	    this.data = [];
	
	    this.User.query(function (data) {
	      _this.data = data;
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve properties.");
	    });
	  }
	
	  _createClass(UserLookupComponent, [{
	    key: 'ok',
	    value: function ok(user) {
	      this.close({ $value: user });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return UserLookupComponent;
	}();
	
	exports.default = angular.module('conduu.userLookup', []).component('userLookup', {
	  template: __webpack_require__(581),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: UserLookupComponent
	}).name;

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">User Lookup</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <table ng-if=\"$ctrl.dataInitComplete\" datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n    <thead>\r\n    <tr>\r\n      <th>First Name</th>\r\n      <th>Middle Name</th>\r\n      <th>Last Name</th>\r\n      <th>Select</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-repeat=\"user in $ctrl.data | orderBy: 'meta.creationDate':true\">\r\n      <td>{{user.firstName}}</td>\r\n      <td>{{user.middleName}}</td>\r\n      <td>{{user.lastName}}</td>\r\n      <td>\r\n        <a class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.ok(user)\">\r\n          <i class=\"fa fa-hand-pointer-o fa-fw\"></i> Select\r\n        </a>\r\n      </td>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var CommunityLookupComponent = exports.CommunityLookupComponent = function () {
	  /*@ngInject*/
	  CommunityLookupComponent.$inject = ['CommunityService'];
	  function CommunityLookupComponent(CommunityService) {
	    var _this = this;
	
	    _classCallCheck(this, CommunityLookupComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	    };
	
	    this.CommunityService = CommunityService;
	
	    this.data = [];
	
	    this.CommunityService.query(function (data) {
	      _this.data = data;
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve properties.");
	    });
	  }
	
	  _createClass(CommunityLookupComponent, [{
	    key: 'ok',
	    value: function ok(user) {
	      this.close({ $value: user });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }, {
	    key: 'getPrimaryAddress',
	    value: function getPrimaryAddress(community) {
	      var primary = community.address.find(function (addr) {
	        return addr.isPrimary == true;
	      });
	
	      if (!primary) return "-";
	
	      return primary.street + "<br/>" + primary.city + ' ' + primary.state + ', ' + primary.zip;
	    }
	  }]);
	
	  return CommunityLookupComponent;
	}();
	
	exports.default = angular.module('conduu.communityLookup', []).component('communityLookup', {
	  template: __webpack_require__(583),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: CommunityLookupComponent
	}).name;

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">Community Lookup</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <table ng-if=\"$ctrl.dataInitComplete\" datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n    <thead>\r\n    <tr>\r\n      <th>Code</th>\r\n      <th>Name</th>\r\n      <th>Address</th>\r\n      <th>Select</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-repeat=\"community in $ctrl.data | orderBy: 'meta.creationDate':true\">\r\n      <td>{{community.code}}</td>\r\n      <td>{{community.name}}</td>\r\n      <td ng-bind-html=\"$ctrl.getPrimaryAddress(community)\"></td>\r\n      <td>\r\n        <a class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.ok(community)\">\r\n          <i class=\"fa fa-hand-pointer-o fa-fw\"></i> Select\r\n        </a>\r\n      </td>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var TemplateLookupComponent = exports.TemplateLookupComponent = function () {
	  /*@ngInject*/
	  TemplateLookupComponent.$inject = ['TemplateService'];
	  function TemplateLookupComponent(TemplateService) {
	    var _this = this;
	
	    _classCallCheck(this, TemplateLookupComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	    };
	
	    this.TemplateService = TemplateService;
	
	    this.data = [];
	
	    this.TemplateService.query(function (data) {
	      _this.data = data;
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve templates.");
	    });
	  }
	
	  _createClass(TemplateLookupComponent, [{
	    key: 'ok',
	    value: function ok(template) {
	      this.close({ $value: template });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return TemplateLookupComponent;
	}();
	
	exports.default = angular.module('conduu.templateLookup', []).component('templateLookup', {
	  template: __webpack_require__(585),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: TemplateLookupComponent
	}).name;

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">Template Lookup</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <table ng-if=\"$ctrl.dataInitComplete\" datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n    <thead>\r\n    <tr>\r\n      <th>Name</th>\r\n      <th>Description</th>\r\n      <th>Select</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-repeat=\"template in $ctrl.data | orderBy: 'meta.creationDate':true\">\r\n      <td>{{template.name}}</td>\r\n      <td>{{template.description}}</td>\r\n      <td>\r\n        <a class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.ok(template)\">\r\n          <i class=\"fa fa-hand-pointer-o fa-fw\"></i> Select\r\n        </a>\r\n      </td>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var ContactLookupComponent = exports.ContactLookupComponent = function () {
	  /*@ngInject*/
	  ContactLookupComponent.$inject = ['ContactService'];
	  function ContactLookupComponent(ContactService) {
	    _classCallCheck(this, ContactLookupComponent);
	
	    this.ContactService = ContactService;
	    this.dtInstance = {};
	
	    this.data = [];
	
	    this.selected = {};
	  }
	
	  _createClass(ContactLookupComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.config = this.resolve.config;
	
	      this.ContactService.query(function (data) {
	        if (_this.config && _this.config.exclude) {
	          var excludeList = Array.isArray(_this.config.exclude) ? _this.config.exclude : [_this.config.exclude];
	          _this.data = data.filter(function (contact) {
	            return !excludeList.includes(String(contact._id));
	          });
	        } else {
	          _this.data = data;
	        }
	
	        if (_this.config.multiple && _this.config.checkAll) _this.checkAll();
	
	        _this.dataInitComplete = true;
	      }, function (err) {
	        console.log("Could not retrieve contacts.");
	      });
	    }
	  }, {
	    key: 'checkAll',
	    value: function checkAll() {
	
	      var that = this;
	
	      var api = this.dtInstance.DataTable;
	      api.rows({ search: 'applied' }).every(function () {
	
	        var _id = api.cell({ row: this.index(), column: 0 }).nodes().to$().find('span')[0].getAttribute('x-filter-id');
	
	        that.selected[_id] = true;
	      });
	      this.dtInstance.DataTable.draw();
	    }
	  }, {
	    key: 'uncheckAll',
	    value: function uncheckAll() {
	      var that = this;
	
	      var api = this.dtInstance.DataTable;
	      api.rows({ search: 'applied' }).every(function () {
	
	        var _id = api.cell({ row: this.index(), column: 0 }).nodes().to$().find('span')[0].getAttribute('x-filter-id');
	
	        that.selected[_id] = false;
	      });
	      this.dtInstance.DataTable.draw();
	    }
	  }, {
	    key: 'getSelectedCount',
	    value: function getSelectedCount() {
	      var _this2 = this;
	
	      return this.data.filter(function (wa) {
	        return _this2.selected[wa._id];
	      }).map(function (wa) {
	        return wa._id;
	      }).length;
	    }
	  }, {
	    key: 'okMultiple',
	    value: function okMultiple() {
	      var _this3 = this;
	
	      var selectedData = this.data.filter(function (ppty) {
	        return _this3.selected[ppty._id];
	      }).map(function (ppty) {
	        return ppty._id;
	      });
	      this.close({ $value: selectedData });
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += "<br/>" + contact.company;
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'getPrimaryEmail',
	    value: function getPrimaryEmail(contact) {
	      if (!contact || !contact.email || !contact.email.length) return "-";
	
	      var email = contact.email.find(function (email) {
	        return email.isPrimary;
	      }) || contact.email[0] || { address: '-' };
	
	      return email.address;
	    }
	  }, {
	    key: 'getPrimaryEmailSoftBreak',
	    value: function getPrimaryEmailSoftBreak(contact) {
	      var email = this.getPrimaryEmail(contact);
	
	      return email.replace('@', '@&#8203;').replace('.', '&#8203;.').replace('-', '-&#8203;').replace('_', '_&#8203;');
	    }
	  }, {
	    key: 'getPrimaryPhone',
	    value: function getPrimaryPhone(contact) {
	      if (!contact || !contact.phone || !contact.phone.length) return "-";
	
	      var phone = contact.phone.find(function (phone) {
	        return phone.isPrimary;
	      }) || contact.phone[0] || { number: '-' };
	
	      return phone.number;
	    }
	  }, {
	    key: 'getPrimaryAddress',
	    value: function getPrimaryAddress(contact) {
	      if (!contact || !contact.address || !contact.address.length) return "-";
	
	      var address = contact.address.find(function (adr) {
	        return adr.isPrimary;
	      }) || contact.address[0] || {};
	
	      return address.street + "<br/>" + address.city + ' ' + address.state + ', ' + address.zip;
	    }
	  }, {
	    key: 'ok',
	    value: function ok(contact) {
	      this.close({ $value: contact });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return ContactLookupComponent;
	}();
	
	exports.default = angular.module('conduu.contactLookup', []).component('contactLookup', {
	  template: __webpack_require__(587),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: ContactLookupComponent
	}).name;

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">Contact Lookup</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <table ng-if=\"$ctrl.dataInitComplete\" datatable=\"ng\" dt-instance=\"$ctrl.dtInstance\" class=\"table table-striped\" style=\"width:100%\">\r\n    <thead>\r\n    <tr>\r\n      <th ng-if=\"$ctrl.config.multiple\"></th>\r\n      <th>Name</th>\r\n      <th>Address</th>\r\n      <th>Phone</th>\r\n      <th>Mail</th>\r\n      <th ng-if=\"!$ctrl.config.multiple\">Select</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-repeat=\"contact in $ctrl.data | orderBy: 'meta.creationDate':true\">\r\n      <td ng-if=\"$ctrl.config.multiple\">\r\n        <input type=\"checkbox\" ng-model=\"$ctrl.selected[contact._id]\">\r\n        <span x-filter-id=\"{{contact._id}}\" style=\"display: none\"></span>\r\n      </td>\r\n      <td><a ng-href=\"/contact/{{contact._id}}\" ng-bind-html=\"$ctrl.getComposedName(contact)\"></a></td>\r\n      <td ng-bind-html=\"$ctrl.getPrimaryAddress(contact)\"></td>\r\n      <td>{{$ctrl.getPrimaryPhone(contact) | usPhone}}</td>\r\n      <td ng-bind-html=\"$ctrl.getPrimaryEmailSoftBreak(contact)\"></td>\r\n      <td ng-if=\"!$ctrl.config.multiple\">\r\n        <a class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.ok(contact)\">\r\n          <i class=\"fa fa-hand-pointer-o fa-fw\"></i> Select\r\n        </a>\r\n      </td>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <div ng-if=\"$ctrl.config.multiple\" style=\"float:left; text-align: left\">\r\n    <span>{{$ctrl.getSelectedCount()}} Entries selected</span><br/>\r\n    <a style=\"cursor: pointer; text-decoration: none\" ng-click=\"$ctrl.checkAll()\"><i class=\"fa fa-fw fa-check-square-o\"></i> Check All</a> | <a style=\"cursor: pointer; text-decoration: none\" ng-click=\"$ctrl.uncheckAll()\"><i class=\"fa fa-fw fa-times\"></i> Uncheck All</a>\r\n  </div>\r\n  <button ng-if=\"$ctrl.config.multiple\" class=\"btn btn-primary\" ng-disabled=\"!$ctrl.getSelectedCount()\" type=\"button\" ng-click=\"$ctrl.okMultiple()\">OK</button>\r\n\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = 'treeControl';
	}
	(function ( angular ) {
	    'use strict';
	
	    function createPath(startScope) {
	        return function path() {
	            var _path = [];
	            var scope = startScope;
	            var prevNode;
	            while (scope && scope.node !== startScope.synteticRoot) {
	                if (prevNode !== scope.node)
	                    _path.push(scope.node);
	                prevNode = scope.node;
	                scope = scope.$parent;
	            }
	            return _path;
	        }
	    }
	
	    function ensureDefault(obj, prop, value) {
	        if (!obj.hasOwnProperty(prop))
	            obj[prop] = value;
	    }
	
	    function defaultIsLeaf(node, $scope) {
	        return !node[$scope.options.nodeChildren] || node[$scope.options.nodeChildren].length === 0;
	    }
	
	    function shallowCopy(src, dst) {
	        if (angular.isArray(src)) {
	            dst = dst || [];
	
	            for (var i = 0; i < src.length; i++) {
	                dst[i] = src[i];
	            }
	        } else if (angular.isObject(src)) {
	            dst = dst || {};
	
	            for (var key in src) {
	                if (hasOwnProperty.call(src, key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	                    dst[key] = src[key];
	                }
	            }
	        }
	
	        return dst || src;
	    }
	    function defaultEquality(a, b,$scope) {
	        if (!a || !b)
	            return false;
	        a = shallowCopy(a);
	        a[$scope.options.nodeChildren] = [];
	        b = shallowCopy(b);
	        b[$scope.options.nodeChildren] = [];
	        return angular.equals(a, b);
	    }
	
	    function defaultIsSelectable() {
	        return true;
	    }
	
	    function ensureAllDefaultOptions($scope) {
	        ensureDefault($scope.options, "multiSelection", false);
	        ensureDefault($scope.options, "nodeChildren", "children");
	        ensureDefault($scope.options, "dirSelectable", "true");
	        ensureDefault($scope.options, "injectClasses", {});
	        ensureDefault($scope.options.injectClasses, "ul", "");
	        ensureDefault($scope.options.injectClasses, "li", "");
	        ensureDefault($scope.options.injectClasses, "liSelected", "");
	        ensureDefault($scope.options.injectClasses, "iExpanded", "");
	        ensureDefault($scope.options.injectClasses, "iCollapsed", "");
	        ensureDefault($scope.options.injectClasses, "iLeaf", "");
	        ensureDefault($scope.options.injectClasses, "label", "");
	        ensureDefault($scope.options.injectClasses, "labelSelected", "");
	        ensureDefault($scope.options, "equality", defaultEquality);
	        ensureDefault($scope.options, "isLeaf", defaultIsLeaf);
	        ensureDefault($scope.options, "allowDeselect", true);
	        ensureDefault($scope.options, "isSelectable", defaultIsSelectable);
	    }
	
	    angular.module( 'treeControl', ['contextMenu'] )
	        .constant('treeConfig', {
	            templateUrl: null
	        })
	
	        .directive( 'treecontrol', ['$compile', function( $compile ) {
	            /**
	             * @param cssClass - the css class
	             * @param addClassProperty - should we wrap the class name with class=""
	             */
	            function classIfDefined(cssClass, addClassProperty) {
	                if (cssClass) {
	                    if (addClassProperty)
	                        return 'class="' + cssClass + '"';
	                    else
	                        return cssClass;
	                }
	                else
	                    return "";
	            }
	            return {
	                restrict: 'EA',
	                require: "treecontrol",
	                transclude: true,
	                scope: {
	                    treeModel: "=",
	                    selectedNode: "=?",
	                    selectedNodes: "=?",
	                    expandedNodes: "=?",
	                    onSelection: "&",
	                    onNodeToggle: "&",
	                    onRightClick: "&",
	                    menuId: "@",
	                    options: "=?",
	                    orderBy: "=?",
	                    reverseOrder: "@",
	                    filterExpression: "=?",
	                    filterComparator: "=?"
	                },
	                controller: ['$scope', '$templateCache', '$interpolate', 'treeConfig', function ($scope, $templateCache, $interpolate, treeConfig) {
	
	                    $scope.options = $scope.options || {};
	
	                    ensureAllDefaultOptions($scope);
	
	                    $scope.selectedNodes = $scope.selectedNodes || [];
	                    $scope.expandedNodes = $scope.expandedNodes || [];
	                    $scope.expandedNodesMap = {};
	                    for (var i=0; i < $scope.expandedNodes.length; i++) {
	                        $scope.expandedNodesMap["a"+i] = $scope.expandedNodes[i];
	                    }
	                    $scope.parentScopeOfTree = $scope.$parent;
	
	
	                    function isSelectedNode(node) {
	                        if (!$scope.options.multiSelection && ($scope.options.equality(node, $scope.selectedNode , $scope)))
	                            return true;
	                        else if ($scope.options.multiSelection && $scope.selectedNodes) {
	                            for (var i = 0; (i < $scope.selectedNodes.length); i++) {
	                                if ($scope.options.equality(node, $scope.selectedNodes[i] , $scope)) {
	                                    return true;
	                                }
	                            }
	                            return false;
	                        }
	                    }
	
	                    $scope.headClass = function(node) {
	                        var liSelectionClass = classIfDefined($scope.options.injectClasses.liSelected, false);
	                        var injectSelectionClass = "";
	                        if (liSelectionClass && isSelectedNode(node))
	                            injectSelectionClass = " " + liSelectionClass;
	                        if ($scope.options.isLeaf(node, $scope))
	                            return "tree-leaf" + injectSelectionClass;
	                        if ($scope.expandedNodesMap[this.$id])
	                            return "tree-expanded" + injectSelectionClass;
	                        else
	                            return "tree-collapsed" + injectSelectionClass;
	                    };
	
	                    $scope.iBranchClass = function() {
	                        if ($scope.expandedNodesMap[this.$id])
	                            return classIfDefined($scope.options.injectClasses.iExpanded);
	                        else
	                            return classIfDefined($scope.options.injectClasses.iCollapsed);
	                    };
	
	                    $scope.nodeExpanded = function() {
	                        return !!$scope.expandedNodesMap[this.$id];
	                    };
	
	                    $scope.selectNodeHead = function() {
	                        var transcludedScope = this;
	                        var expanding = $scope.expandedNodesMap[transcludedScope.$id] === undefined;
	                        $scope.expandedNodesMap[transcludedScope.$id] = (expanding ? transcludedScope.node : undefined);
	                        if (expanding) {
	                            $scope.expandedNodes.push(transcludedScope.node);
	                        }
	                        else {
	                            var index;
	                            for (var i=0; (i < $scope.expandedNodes.length) && !index; i++) {
	                                if ($scope.options.equality($scope.expandedNodes[i], transcludedScope.node , $scope)) {
	                                    index = i;
	                                }
	                            }
	                            if (index !== undefined)
	                                $scope.expandedNodes.splice(index, 1);
	                        }
	                        if ($scope.onNodeToggle) {
	                            var parentNode = (transcludedScope.$parent.node === transcludedScope.synteticRoot)?null:transcludedScope.$parent.node;
	                            var path = createPath(transcludedScope);
	                            $scope.onNodeToggle({node: transcludedScope.node, $parentNode: parentNode, $path: path,
	                              $index: transcludedScope.$index, $first: transcludedScope.$first, $middle: transcludedScope.$middle,
	                              $last: transcludedScope.$last, $odd: transcludedScope.$odd, $even: transcludedScope.$even, expanded: expanding});
	
	                        }
	                    };
	
	                    $scope.selectNodeLabel = function( selectedNode){
	                        var transcludedScope = this;
	                        if(!$scope.options.isLeaf(selectedNode, $scope) && (!$scope.options.dirSelectable || !$scope.options.isSelectable(selectedNode))) {
	                            // Branch node is not selectable, expand
	                            this.selectNodeHead();
	                        }
	                        else if($scope.options.isLeaf(selectedNode, $scope) && (!$scope.options.isSelectable(selectedNode))) {
	                            // Leaf node is not selectable
	                            return;
	                        }
	                        else {
	                            var selected = false;
	                            if ($scope.options.multiSelection) {
	                                var pos = -1;
	                                for (var i=0; i < $scope.selectedNodes.length; i++) {
	                                    if($scope.options.equality(selectedNode, $scope.selectedNodes[i] , $scope)) {
	                                        pos = i;
	                                        break;
	                                    }
	                                }
	                                if (pos === -1) {
	                                    $scope.selectedNodes.push(selectedNode);
	                                    selected = true;
	                                } else {
	                                    $scope.selectedNodes.splice(pos, 1);
	                                }
	                            } else {
	                                if (!$scope.options.equality(selectedNode, $scope.selectedNode , $scope)) {
	                                    $scope.selectedNode = selectedNode;
	                                    selected = true;
	                                }
	                                else {
	                                    if ($scope.options.allowDeselect) {
	                                        $scope.selectedNode = undefined;
	                                    } else {
	                                        $scope.selectedNode = selectedNode;
	                                        selected = true;
	                                    }
	                                }
	                            }
	                            if ($scope.onSelection) {
	                                var parentNode = (transcludedScope.$parent.node === transcludedScope.synteticRoot)?null:transcludedScope.$parent.node;
	                                var path = createPath(transcludedScope)
	                                $scope.onSelection({node: selectedNode, selected: selected, $parentNode: parentNode, $path: path,
	                                  $index: transcludedScope.$index, $first: transcludedScope.$first, $middle: transcludedScope.$middle,
	                                  $last: transcludedScope.$last, $odd: transcludedScope.$odd, $even: transcludedScope.$even});
	                            }
	                        }
	                    };
	
	                    $scope.rightClickNodeLabel = function( targetNode, $event ) {
	
	                        // Is there a right click function??
	                        if($scope.onRightClick) {
	
	                            // Turn off the browser default context-menu
	                            if($event)
	                                $event.preventDefault();
	
	                            // Are are we changing the 'selected' node (as well)?
	                            if ($scope.selectedNode != targetNode) {
	                                this.selectNodeLabel(targetNode);
	                            }
	
	                            // Finally go do what they asked
	                            $scope.onRightClick({node: targetNode});
	                        }
	                    };
	
	                    $scope.selectedClass = function() {
	                        var isThisNodeSelected = isSelectedNode(this.node);
	                        var labelSelectionClass = classIfDefined($scope.options.injectClasses.labelSelected, false);
	                        var injectSelectionClass = "";
	                        if (labelSelectionClass && isThisNodeSelected)
	                            injectSelectionClass = " " + labelSelectionClass;
	
	                        return isThisNodeSelected ? "tree-selected" + injectSelectionClass : "";
	                    };
	
	                    $scope.unselectableClass = function() {
	                        var isThisNodeUnselectable = !$scope.options.isSelectable(this.node);
	                        var labelUnselectableClass = classIfDefined($scope.options.injectClasses.labelUnselectable, false);
	                        return isThisNodeUnselectable ? "tree-unselectable " + labelUnselectableClass : "";
	                    };
	
	                    //tree template
	                    var rcLabel = $scope.onRightClick ? ' tree-right-click="rightClickNodeLabel(node)"' : '';
	                    var ctxMenuId = $scope.menuId ? ' context-menu-id="'+ $scope.menuId+'"' : '';
	
	                    $scope.isReverse = function() {
	                      return !($scope.reverseOrder === 'false' || $scope.reverseOrder === 'False' || $scope.reverseOrder === '' || $scope.reverseOrder === false);
	                    };
	
	                    $scope.orderByFunc = function() {
	                      return $scope.orderBy;
	                    };
	
	                    var templateOptions = {
	                        orderBy: $scope.orderBy ? " | orderBy:orderByFunc():isReverse()" : '',
	                        ulClass: classIfDefined($scope.options.injectClasses.ul, true),
	                        nodeChildren:  $scope.options.nodeChildren,
	                        liClass: classIfDefined($scope.options.injectClasses.li, true),
	                        iLeafClass: classIfDefined($scope.options.injectClasses.iLeaf, false),
	                        labelClass: classIfDefined($scope.options.injectClasses.label, false)
	                    };
	
	                    var template;
	                    var templateUrl = $scope.options.templateUrl || treeConfig.templateUrl;
	
	                    if(templateUrl) {
	                        template = $templateCache.get(templateUrl);
	                    }
	
	                    if(!template) {
	                        template =
	                            '<ul {{options.ulClass}} >' +
	                            '<li ng-repeat="node in node.{{options.nodeChildren}} | filter:filterExpression:filterComparator {{options.orderBy}}" ng-class="headClass(node)" {{options.liClass}}' +
	                            'set-node-to-data>' +
	                            '<i class="tree-branch-head" ng-class="iBranchClass()" ng-click="selectNodeHead(node)"></i>' +
	                            '<i class="tree-leaf-head {{options.iLeafClass}}"></i>' +
	                            '<div class="tree-label {{options.labelClass}}" ng-class="[selectedClass(), unselectableClass()]" ng-click="selectNodeLabel(node)" ' + rcLabel + ctxMenuId + ' tree-transclude></div>' +
	                            '<treeitem ng-if="nodeExpanded()"></treeitem>' +
	                            '</li>' +
	                            '</ul>';
	                    }
	
	                    this.template = $compile($interpolate(template)({options: templateOptions}));
	                }],
	
	                compile: function(element, attrs, childTranscludeFn) {
	                    return function ( scope, element, attrs, treemodelCntr ) {
	
	                        scope.$watch("treeModel", function updateNodeOnRootScope(newValue) {
	                            if (angular.isArray(newValue)) {
	                                if (angular.isDefined(scope.node) && angular.equals(scope.node[scope.options.nodeChildren], newValue))
	                                    return;
	                                scope.node = {};
	                                scope.synteticRoot = scope.node;
	                                scope.node[scope.options.nodeChildren] = newValue;
	                            }
	                            else {
	                                if (angular.equals(scope.node, newValue))
	                                    return;
	                                scope.node = newValue;
	                            }
	                        });
	
	                        scope.$watchCollection('expandedNodes', function(newValue, oldValue) {
	                            var notFoundIds = 0;
	                            var newExpandedNodesMap = {};
	                            var $liElements = element.find('li');
	                            var existingScopes = [];
	                            // find all nodes visible on the tree and the scope $id of the scopes including them
	                            angular.forEach($liElements, function(liElement) {
	                                var $liElement = angular.element(liElement);
	                                var liScope = {
	                                    $id: $liElement.data('scope-id'),
	                                    node: $liElement.data('node')
	                                };
	                                existingScopes.push(liScope);
	                            });
	                            // iterate over the newValue, the new expanded nodes, and for each find it in the existingNodesAndScopes
	                            // if found, add the mapping $id -> node into newExpandedNodesMap
	                            // if not found, add the mapping num -> node into newExpandedNodesMap
	                            angular.forEach(newValue, function(newExNode) {
	                                var found = false;
	                                for (var i=0; (i < existingScopes.length) && !found; i++) {
	                                    var existingScope = existingScopes[i];
	                                    if (scope.options.equality(newExNode, existingScope.node , scope)) {
	                                        newExpandedNodesMap[existingScope.$id] = existingScope.node;
	                                        found = true;
	                                    }
	                                }
	                                if (!found)
	                                    newExpandedNodesMap['a' + notFoundIds++] = newExNode;
	                            });
	                            scope.expandedNodesMap = newExpandedNodesMap;
	                        });
	
	//                        scope.$watch('expandedNodesMap', function(newValue) {
	//
	//                        });
	
	                        //Rendering template for a root node
	                        treemodelCntr.template( scope, function(clone) {
	                            element.html('').append( clone );
	                        });
	                        // save the transclude function from compile (which is not bound to a scope as apposed to the one from link)
	                        // we can fix this to work with the link transclude function with angular 1.2.6. as for angular 1.2.0 we need
	                        // to keep using the compile function
	                        scope.$treeTransclude = childTranscludeFn;
	                    };
	                }
	            };
	        }])
	        .directive("setNodeToData", ['$parse', function($parse) {
	            return {
	                restrict: 'A',
	                link: function($scope, $element, $attrs) {
	                    $element.data('node', $scope.node);
	                    $element.data('scope-id', $scope.$id);
	                }
	            };
	        }])
	
	        .directive('treeRightClick', ['$parse', function($parse) {
	            return function(scope, element, attrs) {
	                var fn = $parse(attrs.treeRightClick);
	                element.bind('contextmenu', function(event) {
	                    scope.$apply(function() {
	                        fn(scope, {$event:event});    // go do our stuff
	                    });
	                });
	            };
	        }])
	
	        .directive("treeitem", function() {
	            return {
	                restrict: 'E',
	                require: "^treecontrol",
	                link: function( scope, element, attrs, treemodelCntr) {
	                    // Rendering template for the current node
	                    treemodelCntr.template(scope, function(clone) {
	                        element.html('').append(clone);
	                    });
	                }
	            };
	        })
	        .directive("treeTransclude", function () {
	            return {
	                controller: ['$scope',function ($scope) {
	                    ensureAllDefaultOptions($scope);
	                }],
	
	                link: function(scope, element, attrs, controller) {
	                    if (!scope.options.isLeaf(scope.node, scope)) {
	                        angular.forEach(scope.expandedNodesMap, function (node, id) {
	                            if (scope.options.equality(node, scope.node , scope)) {
	                                scope.expandedNodesMap[scope.$id] = scope.node;
	                                scope.expandedNodesMap[id] = undefined;
	                            }
	                        });
	                    }
	                    if (!scope.options.multiSelection && scope.options.equality(scope.node, scope.selectedNode , scope)) {
	                        scope.selectedNode = scope.node;
	                    } else if (scope.options.multiSelection) {
	                        var newSelectedNodes = [];
	                        for (var i = 0; (i < scope.selectedNodes.length); i++) {
	                            if (scope.options.equality(scope.node, scope.selectedNodes[i] , scope)) {
	                                newSelectedNodes.push(scope.node);
	                            }
	                        }
	                        scope.selectedNodes = newSelectedNodes;
	                    }
	
	                    // create a scope for the transclusion, whos parent is the parent of the tree control
	                    scope.transcludeScope = scope.parentScopeOfTree.$new();
	                    scope.transcludeScope.node = scope.node;
	                    scope.transcludeScope.$path = createPath(scope);
	                    scope.transcludeScope.$parentNode = (scope.$parent.node === scope.synteticRoot)?null:scope.$parent.node;
	                    scope.transcludeScope.$index = scope.$index;
	                    scope.transcludeScope.$first = scope.$first;
	                    scope.transcludeScope.$middle = scope.$middle;
	                    scope.transcludeScope.$last = scope.$last;
	                    scope.transcludeScope.$odd = scope.$odd;
	                    scope.transcludeScope.$even = scope.$even;
	                    scope.$on('$destroy', function() {
	                        scope.transcludeScope.$destroy();
	                    });
	
	                    scope.$treeTransclude(scope.transcludeScope, function(clone) {
	                        element.empty();
	                        element.append(clone);
	                    });
	                }
	            };
	        });
	})( angular );


/***/ }),
/* 589 */
/***/ (function(module, exports) {

	(function ( angular ) {
	    'use strict';
	
	    /* Figure out page (viewport) dimensions of current page, by
	     * putting an empty DIV in the bottom right, and checking its offset.
	     */
	    function getPageDimensions() {
	      var bttmRight = document.createElement("div");
	      bttmRight.setAttribute("style" , "visibility:hidden;position:fixed;bottom:0px;right:0px;");
	      document.getElementsByTagName("body")[0].appendChild(bttmRight);
	      var pageWidth = bttmRight.offsetLeft;
	      var pageHeight = bttmRight.offsetTop;
	      bttmRight.parentNode.removeChild(bttmRight);
	      return { width:pageWidth, height:pageHeight };
	    }
	
	    angular.module( 'contextMenu', [] )
	
	        .directive('contextMenuId', ['$document', function($document) {
	
	            return {
	                restrict    : 'A',
	                scope       : '@&',
	                compile: function compile(tElement, tAttrs, transclude) {
	
	                    return {
	                        post: function postLink(scope, iElement, iAttrs, controller) {
	
	                            var ul = angular.element(document.querySelector('#' + iAttrs.contextMenuId));
	
	                            ul.css({ 'display' : 'none'});
	
	                            // right-click on context-menu will show the menu
	                            iElement.bind('contextmenu', function showContextMenu(event) {
	
	                                // don't do the normal browser right-click context menu
	                                event.preventDefault();
	
	                                // Organise to show off the menu (in roughly the right place)
	                                ul.css({
	                                    visibility:"hidden",
	                                    position: "fixed",
	                                    display: "block",
	                                    left: event.clientX + 'px',
	                                    top: event.clientY + 'px'
	                                });
	
	                                var ulDim = { height: ul.prop("clientHeight"),
	                                              width:  ul.prop("cientWidth")
	                                            };
	
	                                var pgDim = getPageDimensions();
	
	                                // will ctxMenu fit on screen (height-wise) ?
	                                // TODO: figure out why we need the fudge-factor of 14
	                                var ulTop = event.clientY + ulDim.height <= pgDim.height - 14
	                                          ? event.clientY
	                                          : pgDim.height - ulDim.height - 14;
	
	                                // will ctxMenu fit on screen (width-wise) ?
	                                var ulLeft = event.clientX + ulDim.width <= pgDim.width - 2
	                                           ? event.clientX
	                                           : pgDim.width - ulDim.width - 2;
	
	                                // Ok, now show it off in the right place
	                                ul.css({
	                                    visibility:"visible",
	                                    position: "fixed",
	                                    display: "block",
	                                    left: ulLeft + 'px',
	                                    top:  ulTop  + 'px'
	                                });
	
	                                // setup a one-time click event on the document to hide the dropdown-menu
	                                $document.one('click', function hideContextMenu(event) {
	                                    ul.css({
	                                        'display' : 'none'
	                                    });
	                                });
	                            });
	                        }
	                    };
	                }
	            };
	        }])
	
	        .directive('contextSubmenuId', ['$document', function($document) {
	            return {
	                restrict    : 'A',
	                scope       : '@&',
	                compile: function compile(tElement, tAttrs, transclude) {
	                    return {
	                        post: function postLink(scope, iElement, iAttrs, controller) {
	
	                            var ul = angular.element(document.querySelector('#' + iAttrs.contextSubmenuId));
	
	                            ul.css({ 'display' : 'none'});
	
	
	                            iElement.bind('mouseover', function showSubContextMenu(event) {
	                                // use CSS to move and show the sub dropdown-menu
	                                if(ul.css("display") == 'none') {
	
	                                    // Organise to show off the sub-menu (in roughly the right place)
	                                    ul.css({
	                                        visibility:"hidden",
	                                        position: "fixed",
	                                        display: "block",
	                                        left: event.clientX + 'px',
	                                        top: event.clientY + 'px'
	                                    });
	
	                                    var ulDim = { height: ul.prop("clientHeight"),
	                                                  width:  ul.prop("clientWidth")
	                                                };
	
	                                    var pgDim = getPageDimensions();
	
	
	                                  // Will ctxSubMenu fit (height-wise) ?
	                                  // TODO: figure out why we need the fudge-factor of 14
	                                  var ulTop = event.clientY + ulDim.height <= pgDim.height - 14
	                                            ? event.clientY
	                                            : pgDim.height - ulDim.height - 14;
	
	                                  // Will ctxSubMenu fit (on the right of parent menu) ?
	                                  var ulLeft =
	                                    (event.target.offsetParent.offsetLeft +
	                                     event.target.clientWidth + ulDim.width < pgDim.width)
	                                              ? event.target.offsetParent.offsetLeft +
	                                                event.target.clientWidth
	
	                                              : event.target.offsetParent.offsetLeft - ulDim.width;
	
	                                    // OK, now show it off in the right place
	                                    ul.css({
	                                        visibility:"visible",
	                                        position: "fixed",
	                                        display: "block",
	                                        left: ulLeft + 'px',
	                                        top:  ulTop + 'px'
	                                    });
	
	                                    // Each uncle/aunt menu item needs a mouseover event to make the subContext menu disappear
	                                    angular.forEach(iElement[0].parentElement.parentElement.children, function(child, ndx) {
	                                        if(child !== iElement[0].parentElement) {
	                                            angular.element(child).one('mouseover', function(event) {
	                                                if(ul.css("display") == 'block') {
	                                                    ul.css({
	                                                        'display' : 'none'
	                                                    });
	                                                }
	                                            });
	                                        }
	                                    });
	                                }
	
	                                // setup a one-time click event on the document to hide the sub dropdown-menu
	                                $document.one('click', function hideContextMenu(event) {
	                                    if(ul.css("display") == 'block') {
	                                        ul.css({
	                                            'display' : 'none'
	                                        });
	                                    }
	                                });
	                            });
	                        }
	                    };
	                }
	            };
	        }]);
	
	})( angular );


/***/ }),
/* 590 */
5,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */
5,
/* 600 */,
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	//https://github.com/angular/angular.js/pull/10732
	
	var angular = __webpack_require__(14);
	var mask = __webpack_require__(602);
	
	module.exports = 'ui.mask';


/***/ }),
/* 602 */
/***/ (function(module, exports) {

	/*!
	 * angular-ui-mask
	 * https://github.com/angular-ui/ui-mask
	 * Version: 1.8.7 - 2016-07-26T16:01:23.393Z
	 * License: MIT
	 */
	
	
	(function () { 
	'use strict';
	/*
	 Attaches input mask onto input element
	 */
	angular.module('ui.mask', [])
	        .value('uiMaskConfig', {
	            maskDefinitions: {
	                '9': /\d/,
	                'A': /[a-zA-Z]/,
	                '*': /[a-zA-Z0-9]/
	            },
	            clearOnBlur: true,
	            clearOnBlurPlaceholder: false,
	            escChar: '\\',
	            eventsToHandle: ['input', 'keyup', 'click', 'focus'],
	            addDefaultPlaceholder: true,
	            allowInvalidValue: false
	        })
	        .provider('uiMask.Config', function() {
	            var options = {};
	
	            this.maskDefinitions = function(maskDefinitions) {
	                return options.maskDefinitions = maskDefinitions;
	            };
	            this.clearOnBlur = function(clearOnBlur) {
	                return options.clearOnBlur = clearOnBlur;
	            };
	            this.clearOnBlurPlaceholder = function(clearOnBlurPlaceholder) {
	                return options.clearOnBlurPlaceholder = clearOnBlurPlaceholder;
	            };
	            this.eventsToHandle = function(eventsToHandle) {
	                return options.eventsToHandle = eventsToHandle;
	            };
	            this.addDefaultPlaceholder = function(addDefaultPlaceholder) {
	                return options.addDefaultPlaceholder = addDefaultPlaceholder;
	            };
	            this.allowInvalidValue = function(allowInvalidValue) {
	                return options.allowInvalidValue = allowInvalidValue;
	            };
	            this.$get = ['uiMaskConfig', function(uiMaskConfig) {
	                var tempOptions = uiMaskConfig;
	                for(var prop in options) {
	                    if (angular.isObject(options[prop]) && !angular.isArray(options[prop])) {
	                        angular.extend(tempOptions[prop], options[prop]);
	                    } else {
	                        tempOptions[prop] = options[prop];
	                    }
	                }
	
	                return tempOptions;
	            }];
	        })
	        .directive('uiMask', ['uiMask.Config', function(maskConfig) {
	                function isFocused (elem) {
	                  return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	                }
	
	                return {
	                    priority: 100,
	                    require: 'ngModel',
	                    restrict: 'A',
	                    compile: function uiMaskCompilingFunction() {
	                        var options = angular.copy(maskConfig);
	
	                        return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller) {
	                            var maskProcessed = false, eventsBound = false,
	                                    maskCaretMap, maskPatterns, maskPlaceholder, maskComponents,
	                                    // Minimum required length of the value to be considered valid
	                                    minRequiredLength,
	                                    value, valueMasked, isValid,
	                                    // Vars for initializing/uninitializing
	                                    originalPlaceholder = iAttrs.placeholder,
	                                    originalMaxlength = iAttrs.maxlength,
	                                    // Vars used exclusively in eventHandler()
	                                    oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength,
	                                    // Used for communicating if a backspace operation should be allowed between
	                                    // keydownHandler and eventHandler
	                                    preventBackspace;
	
	                            var originalIsEmpty = controller.$isEmpty;
	                            controller.$isEmpty = function(value) {
	                                if (maskProcessed) {
	                                    return originalIsEmpty(unmaskValue(value || ''));
	                                } else {
	                                    return originalIsEmpty(value);
	                                }
	                            };
	
	                            function initialize(maskAttr) {
	                                if (!angular.isDefined(maskAttr)) {
	                                    return uninitialize();
	                                }
	                                processRawMask(maskAttr);
	                                if (!maskProcessed) {
	                                    return uninitialize();
	                                }
	                                initializeElement();
	                                bindEventListeners();
	                                return true;
	                            }
	
	                            function initPlaceholder(placeholderAttr) {
	                                if ( ! placeholderAttr) {
	                                    return;
	                                }
	
	                                maskPlaceholder = placeholderAttr;
	
	                                // If the mask is processed, then we need to update the value
	                                // but don't set the value if there is nothing entered into the element
	                                // and there is a placeholder attribute on the element because that
	                                // will only set the value as the blank maskPlaceholder
	                                // and override the placeholder on the element
	                                if (maskProcessed && !(iElement.val().length === 0 && angular.isDefined(iAttrs.placeholder))) {
	                                    iElement.val(maskValue(unmaskValue(iElement.val())));
	                                }
	                            }
	
	                            function initPlaceholderChar() {
	                                return initialize(iAttrs.uiMask);
	                            }
	
	                            var modelViewValue = false;
	                            iAttrs.$observe('modelViewValue', function(val) {
	                                if (val === 'true') {
	                                    modelViewValue = true;
	                                }
	                            });
	
	                            iAttrs.$observe('allowInvalidValue', function(val) {
	                                linkOptions.allowInvalidValue = val === ''
	                                    ? true
	                                    : !!val;
	                                formatter(controller.$modelValue);
	                            });
	
	                            function formatter(fromModelValue) {
	                                if (!maskProcessed) {
	                                    return fromModelValue;
	                                }
	                                value = unmaskValue(fromModelValue || '');
	                                isValid = validateValue(value);
	                                controller.$setValidity('mask', isValid);
	
	                                if (!value.length) return undefined;
	                                if (isValid || linkOptions.allowInvalidValue) {
	                                    return maskValue(value);
	                                } else {
	                                    return undefined;
	                                }
	                            }
	
	                            function parser(fromViewValue) {
	                                if (!maskProcessed) {
	                                    return fromViewValue;
	                                }
	                                value = unmaskValue(fromViewValue || '');
	                                isValid = validateValue(value);
	                                // We have to set viewValue manually as the reformatting of the input
	                                // value performed by eventHandler() doesn't happen until after
	                                // this parser is called, which causes what the user sees in the input
	                                // to be out-of-sync with what the controller's $viewValue is set to.
	                                controller.$viewValue = value.length ? maskValue(value) : '';
	                                controller.$setValidity('mask', isValid);
	
	                                if (isValid || linkOptions.allowInvalidValue) {
	                                    return modelViewValue ? controller.$viewValue : value;
	                                }
	                            }
	
	                            var linkOptions = {};
	
	                            if (iAttrs.uiOptions) {
	                                linkOptions = scope.$eval('[' + iAttrs.uiOptions + ']');
	                                if (angular.isObject(linkOptions[0])) {
	                                    // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
	                                    linkOptions = (function(original, current) {
	                                        for (var i in original) {
	                                            if (Object.prototype.hasOwnProperty.call(original, i)) {
	                                                if (current[i] === undefined) {
	                                                    current[i] = angular.copy(original[i]);
	                                                } else {
	                                                    if (angular.isObject(current[i]) && !angular.isArray(current[i])) {
	                                                        current[i] = angular.extend({}, original[i], current[i]);
	                                                    }
	                                                }
	                                            }
	                                        }
	                                        return current;
	                                    })(options, linkOptions[0]);
	                                } else {
	                                    linkOptions = options;  //gotta be a better way to do this..
	                                }
	                            } else {
	                                linkOptions = options;
	                            }
	
	                            iAttrs.$observe('uiMask', initialize);
	                            if (angular.isDefined(iAttrs.uiMaskPlaceholder)) {
	                                iAttrs.$observe('uiMaskPlaceholder', initPlaceholder);
	                            }
	                            else {
	                                iAttrs.$observe('placeholder', initPlaceholder);
	                            }
	                            if (angular.isDefined(iAttrs.uiMaskPlaceholderChar)) {
	                                iAttrs.$observe('uiMaskPlaceholderChar', initPlaceholderChar);
	                            }
	
	                            controller.$formatters.unshift(formatter);
	                            controller.$parsers.unshift(parser);
	
	                            function uninitialize() {
	                                maskProcessed = false;
	                                unbindEventListeners();
	
	                                if (angular.isDefined(originalPlaceholder)) {
	                                    iElement.attr('placeholder', originalPlaceholder);
	                                } else {
	                                    iElement.removeAttr('placeholder');
	                                }
	
	                                if (angular.isDefined(originalMaxlength)) {
	                                    iElement.attr('maxlength', originalMaxlength);
	                                } else {
	                                    iElement.removeAttr('maxlength');
	                                }
	
	                                iElement.val(controller.$modelValue);
	                                controller.$viewValue = controller.$modelValue;
	                                return false;
	                            }
	
	                            function initializeElement() {
	                                value = oldValueUnmasked = unmaskValue(controller.$modelValue || '');
	                                valueMasked = oldValue = maskValue(value);
	                                isValid = validateValue(value);
	                                if (iAttrs.maxlength) { // Double maxlength to allow pasting new val at end of mask
	                                    iElement.attr('maxlength', maskCaretMap[maskCaretMap.length - 1] * 2);
	                                }
	                                if ( ! originalPlaceholder && linkOptions.addDefaultPlaceholder) {
	                                    iElement.attr('placeholder', maskPlaceholder);
	                                }
	                                var viewValue = controller.$modelValue;
	                                var idx = controller.$formatters.length;
	                                while(idx--) {
	                                    viewValue = controller.$formatters[idx](viewValue);
	                                }
	                                controller.$viewValue = viewValue || '';
	                                controller.$render();
	                                // Not using $setViewValue so we don't clobber the model value and dirty the form
	                                // without any kind of user interaction.
	                            }
	
	                            function bindEventListeners() {
	                                if (eventsBound) {
	                                    return;
	                                }
	                                iElement.bind('blur', blurHandler);
	                                iElement.bind('mousedown mouseup', mouseDownUpHandler);
	                                iElement.bind('keydown', keydownHandler);
	                                iElement.bind(linkOptions.eventsToHandle.join(' '), eventHandler);
	                                eventsBound = true;
	                            }
	
	                            function unbindEventListeners() {
	                                if (!eventsBound) {
	                                    return;
	                                }
	                                iElement.unbind('blur', blurHandler);
	                                iElement.unbind('mousedown', mouseDownUpHandler);
	                                iElement.unbind('mouseup', mouseDownUpHandler);
	                                iElement.unbind('keydown', keydownHandler);
	                                iElement.unbind('input', eventHandler);
	                                iElement.unbind('keyup', eventHandler);
	                                iElement.unbind('click', eventHandler);
	                                iElement.unbind('focus', eventHandler);
	                                eventsBound = false;
	                            }
	
	                            function validateValue(value) {
	                                // Zero-length value validity is ngRequired's determination
	                                return value.length ? value.length >= minRequiredLength : true;
	                            }
	
	                            function unmaskValue(value) {
	                                var valueUnmasked = '',
	                                    input = iElement[0],
	                                    maskPatternsCopy = maskPatterns.slice(),
	                                    selectionStart = oldCaretPosition,
	                                    selectionEnd = selectionStart + getSelectionLength(input),
	                                    valueOffset, valueDelta, tempValue = '';
	                                // Preprocess by stripping mask components from value
	                                value = value.toString();
	                                valueOffset = 0;
	                                valueDelta = value.length - maskPlaceholder.length;
	                                angular.forEach(maskComponents, function(component) {
	                                    var position = component.position;
	                                    //Only try and replace the component if the component position is not within the selected range
	                                    //If component was in selected range then it was removed with the user input so no need to try and remove that component
	                                    if (!(position >= selectionStart && position < selectionEnd)) {
	                                        if (position >= selectionStart) {
	                                            position += valueDelta;
	                                        }
	                                        if (value.substring(position, position + component.value.length) === component.value) {
	                                            tempValue += value.slice(valueOffset, position);// + value.slice(position + component.value.length);
	                                            valueOffset = position + component.value.length;
	                                        }
	                                    }
	                                });
	                                value = tempValue + value.slice(valueOffset);
	                                angular.forEach(value.split(''), function(chr) {
	                                    if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
	                                        valueUnmasked += chr;
	                                        maskPatternsCopy.shift();
	                                    }
	                                });
	
	                                return valueUnmasked;
	                            }
	
	                            function maskValue(unmaskedValue) {
	                                var valueMasked = '',
	                                        maskCaretMapCopy = maskCaretMap.slice();
	
	                                angular.forEach(maskPlaceholder.split(''), function(chr, i) {
	                                    if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
	                                        valueMasked += unmaskedValue.charAt(0) || '_';
	                                        unmaskedValue = unmaskedValue.substr(1);
	                                        maskCaretMapCopy.shift();
	                                    }
	                                    else {
	                                        valueMasked += chr;
	                                    }
	                                });
	                                return valueMasked;
	                            }
	
	                            function getPlaceholderChar(i) {
	                                var placeholder = angular.isDefined(iAttrs.uiMaskPlaceholder) ? iAttrs.uiMaskPlaceholder : iAttrs.placeholder,
	                                    defaultPlaceholderChar;
	
	                                if (angular.isDefined(placeholder) && placeholder[i]) {
	                                    return placeholder[i];
	                                } else {
	                                    defaultPlaceholderChar = angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar ? iAttrs.uiMaskPlaceholderChar : '_';
	                                    return (defaultPlaceholderChar.toLowerCase() === 'space') ? ' ' : defaultPlaceholderChar[0];
	                                }
	                            }
	
	                            // Generate array of mask components that will be stripped from a masked value
	                            // before processing to prevent mask components from being added to the unmasked value.
	                            // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
	                            function getMaskComponents() {
	                                var maskPlaceholderChars = maskPlaceholder.split(''),
	                                        maskPlaceholderCopy, components;
	
	                                //maskCaretMap can have bad values if the input has the ui-mask attribute implemented as an obversable property, e.g. the demo page
	                                if (maskCaretMap && !isNaN(maskCaretMap[0])) {
	                                    //Instead of trying to manipulate the RegEx based on the placeholder characters
	                                    //we can simply replace the placeholder characters based on the already built
	                                    //maskCaretMap to underscores and leave the original working RegEx to get the proper
	                                    //mask components
	                                    angular.forEach(maskCaretMap, function(value) {
	                                        maskPlaceholderChars[value] = '_';
	                                    });
	                                }
	                                maskPlaceholderCopy = maskPlaceholderChars.join('');
	                                components = maskPlaceholderCopy.replace(/[_]+/g, '_').split('_');
	                                components = components.filter(function(s) {
	                                    return s !== '';
	                                });
	
	                                // need a string search offset in cases where the mask contains multiple identical components
	                                // E.g., a mask of 99.99.99-999.99
	                                var offset = 0;
	                                return components.map(function(c) {
	                                    var componentPosition = maskPlaceholderCopy.indexOf(c, offset);
	                                    offset = componentPosition + 1;
	                                    return {
	                                        value: c,
	                                        position: componentPosition
	                                    };
	                                });
	                            }
	
	                            function processRawMask(mask) {
	                                var characterCount = 0;
	
	                                maskCaretMap = [];
	                                maskPatterns = [];
	                                maskPlaceholder = '';
	
	                                if (angular.isString(mask)) {
	                                    minRequiredLength = 0;
	
	                                    var isOptional = false,
	                                            numberOfOptionalCharacters = 0,
	                                            splitMask = mask.split('');
	
	                                    var inEscape = false;
	                                    angular.forEach(splitMask, function(chr, i) {
	                                        if (inEscape) {
	                                            inEscape = false;
	                                            maskPlaceholder += chr;
	                                            characterCount++;
	                                        }
	                                        else if (linkOptions.escChar === chr) {
	                                            inEscape = true;
	                                        }
	                                        else if (linkOptions.maskDefinitions[chr]) {
	                                            maskCaretMap.push(characterCount);
	
	                                            maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);
	                                            maskPatterns.push(linkOptions.maskDefinitions[chr]);
	
	                                            characterCount++;
	                                            if (!isOptional) {
	                                                minRequiredLength++;
	                                            }
	
	                                            isOptional = false;
	                                        }
	                                        else if (chr === '?') {
	                                            isOptional = true;
	                                            numberOfOptionalCharacters++;
	                                        }
	                                        else {
	                                            maskPlaceholder += chr;
	                                            characterCount++;
	                                        }
	                                    });
	                                }
	                                // Caret position immediately following last position is valid.
	                                maskCaretMap.push(maskCaretMap.slice().pop() + 1);
	
	                                maskComponents = getMaskComponents();
	                                maskProcessed = maskCaretMap.length > 1 ? true : false;
	                            }
	
	                            var prevValue = iElement.val();
	                            function blurHandler() {
	                                if (linkOptions.clearOnBlur || ((linkOptions.clearOnBlurPlaceholder) && (value.length === 0) && iAttrs.placeholder)) {
	                                    oldCaretPosition = 0;
	                                    oldSelectionLength = 0;
	                                    if (!isValid || value.length === 0) {
	                                        valueMasked = '';
	                                        iElement.val('');
	                                        scope.$apply(function() {
	                                            //only $setViewValue when not $pristine to avoid changing $pristine state.
	                                            if (!controller.$pristine) {
	                                                controller.$setViewValue('');
	                                            }
	                                        });
	                                    }
	                                }
	                                //Check for different value and trigger change.
	                                //Check for different value and trigger change.
	                                if (value !== prevValue) {
	                                    // #157 Fix the bug from the trigger when backspacing exactly on the first letter (emptying the field)
	                                    // and then blurring out.
	                                    // Angular uses html element and calls setViewValue(element.value.trim()), setting it to the trimmed mask
	                                    // when it should be empty
	                                    var currentVal = iElement.val();
	                                    var isTemporarilyEmpty = value === '' && currentVal && angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar === 'space'; 
	                                    if(isTemporarilyEmpty) {
	                                        iElement.val('');
	                                    }
	                                    triggerChangeEvent(iElement[0]);
	                                    if(isTemporarilyEmpty) {
	                                        iElement.val(currentVal);
	                                    }
	                                }
	                                prevValue = value;
	                            }
	
	                            function triggerChangeEvent(element) {
	                                var change;
	                                if (angular.isFunction(window.Event) && !element.fireEvent) {
	                                    // modern browsers and Edge
	                                    change = new Event('change', {
	                                        view: window,
	                                        bubbles: true,
	                                        cancelable: false
	                                    });
	                                    element.dispatchEvent(change);
	                                } else if ('createEvent' in document) {
	                                    // older browsers
	                                    change = document.createEvent('HTMLEvents');
	                                    change.initEvent('change', false, true);
	                                    element.dispatchEvent(change);
	                                }
	                                else if (element.fireEvent) {
	                                    // IE <= 11
	                                    element.fireEvent('onchange');
	                                }
	                            }
	
	                            function mouseDownUpHandler(e) {
	                                if (e.type === 'mousedown') {
	                                    iElement.bind('mouseout', mouseoutHandler);
	                                } else {
	                                    iElement.unbind('mouseout', mouseoutHandler);
	                                }
	                            }
	
	                            iElement.bind('mousedown mouseup', mouseDownUpHandler);
	
	                            function mouseoutHandler() {
	                                /*jshint validthis: true */
	                                oldSelectionLength = getSelectionLength(this);
	                                iElement.unbind('mouseout', mouseoutHandler);
	                            }
	
	                            function keydownHandler(e) {
			              	/*jshint validthis: true */
					var isKeyBackspace = e.which === 8,
					caretPos = getCaretPosition(this) - 1 || 0, //value in keydown is pre change so bump caret position back to simulate post change
					isCtrlZ = e.which === 90 && e.ctrlKey; //ctrl+z pressed
			
					if (isKeyBackspace) {
						while(caretPos >= 0) {
							if (isValidCaretPosition(caretPos)) {
							//re-adjust the caret position.
							//Increment to account for the initial decrement to simulate post change caret position
							setCaretPosition(this, caretPos + 1);
							break;
							}
						caretPos--;
						}
					preventBackspace = caretPos === -1;
					}
					
					if (isCtrlZ) {
						// prevent IE bug - value should be returned to initial state
						iElement.val('');
						e.preventDefault();
					}
				}
	
	                            function eventHandler(e) {
	                                /*jshint validthis: true */
	                                e = e || {};
	                                // Allows more efficient minification
	                                var eventWhich = e.which,
	                                        eventType = e.type;
	
	                                // Prevent shift and ctrl from mucking with old values
	                                if (eventWhich === 16 || eventWhich === 91) {
	                                    return;
	                                }
	
	                                var val = iElement.val(),
	                                        valOld = oldValue,
	                                        valMasked,
	                                        valAltered = false,
	                                        valUnmasked = unmaskValue(val),
	                                        valUnmaskedOld = oldValueUnmasked,
	                                        caretPos = getCaretPosition(this) || 0,
	                                        caretPosOld = oldCaretPosition || 0,
	                                        caretPosDelta = caretPos - caretPosOld,
	                                        caretPosMin = maskCaretMap[0],
	                                        caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(),
	                                        selectionLenOld = oldSelectionLength || 0,
	                                        isSelected = getSelectionLength(this) > 0,
	                                        wasSelected = selectionLenOld > 0,
	                                        // Case: Typing a character to overwrite a selection
	                                        isAddition = (val.length > valOld.length) || (selectionLenOld && val.length > valOld.length - selectionLenOld),
	                                        // Case: Delete and backspace behave identically on a selection
	                                        isDeletion = (val.length < valOld.length) || (selectionLenOld && val.length === valOld.length - selectionLenOld),
	                                        isSelection = (eventWhich >= 37 && eventWhich <= 40) && e.shiftKey, // Arrow key codes
	
	                                        isKeyLeftArrow = eventWhich === 37,
	                                        // Necessary due to "input" event not providing a key code
	                                        isKeyBackspace = eventWhich === 8 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === -1)),
	                                        isKeyDelete = eventWhich === 46 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === 0) && !wasSelected),
	                                        // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
	                                        // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
	                                        // non-mask character. Also applied to click since users are (arguably) more likely to backspace
	                                        // a character when clicking within a filled input.
	                                        caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === 'click') && caretPos > caretPosMin;
	
	                                oldSelectionLength = getSelectionLength(this);
	
	                                // These events don't require any action
	                                if (isSelection || (isSelected && (eventType === 'click' || eventType === 'keyup' || eventType === 'focus'))) {
	                                    return;
	                                }
	
	                                if (isKeyBackspace && preventBackspace) {
	                                    iElement.val(maskPlaceholder);
	                                    // This shouldn't be needed but for some reason after aggressive backspacing the controller $viewValue is incorrect.
	                                    // This keeps the $viewValue updated and correct.
	                                    scope.$apply(function () {
	                                        controller.$setViewValue(''); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                                    });
	                                    setCaretPosition(this, caretPosOld);
	                                    return;
	                                }
	
	                                // Value Handling
	                                // ==============
	
	                                // User attempted to delete but raw value was unaffected--correct this grievous offense
	                                if ((eventType === 'input') && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
	                                    while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
	                                        caretPos--;
	                                    }
	                                    while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {
	                                        caretPos++;
	                                    }
	                                    var charIndex = maskCaretMap.indexOf(caretPos);
	                                    // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
	                                    valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
	
	                                    // If value has not changed, don't want to call $setViewValue, may be caused by IE raising input event due to placeholder
	                                    if (valUnmasked !== valUnmaskedOld)
	                                        valAltered = true;
	                                }
	
	                                // Update values
	                                valMasked = maskValue(valUnmasked);
	
	                                oldValue = valMasked;
	                                oldValueUnmasked = valUnmasked;
	
	                                //additional check to fix the problem where the viewValue is out of sync with the value of the element.
	                                //better fix for commit 2a83b5fb8312e71d220a497545f999fc82503bd9 (I think)
	                                if (!valAltered && val.length > valMasked.length)
	                                    valAltered = true;
	
	                                iElement.val(valMasked);
	
	                                //we need this check.  What could happen if you don't have it is that you'll set the model value without the user
	                                //actually doing anything.  Meaning, things like pristine and touched will be set.
	                                if (valAltered) {
	                                    scope.$apply(function () {
	                                        controller.$setViewValue(valMasked); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                                    });
	                                }
	
	                                // Caret Repositioning
	                                // ===================
	
	                                // Ensure that typing always places caret ahead of typed character in cases where the first char of
	                                // the input is a mask char and the caret is placed at the 0 position.
	                                if (isAddition && (caretPos <= caretPosMin)) {
	                                    caretPos = caretPosMin + 1;
	                                }
	
	                                if (caretBumpBack) {
	                                    caretPos--;
	                                }
	
	                                // Make sure caret is within min and max position limits
	                                caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;
	
	                                // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
	                                while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
	                                    caretPos += caretBumpBack ? -1 : 1;
	                                }
	
	                                if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {
	                                    caretPos++;
	                                }
	                                oldCaretPosition = caretPos;
	                                setCaretPosition(this, caretPos);
	                            }
	
	                            function isValidCaretPosition(pos) {
	                                return maskCaretMap.indexOf(pos) > -1;
	                            }
	
	                            function getCaretPosition(input) {
	                                if (!input)
	                                    return 0;
	                                if (input.selectionStart !== undefined) {
	                                    return input.selectionStart;
	                                } else if (document.selection) {
	                                    if (isFocused(iElement[0])) {
	                                        // Curse you IE
	                                        input.focus();
	                                        var selection = document.selection.createRange();
	                                        selection.moveStart('character', input.value ? -input.value.length : 0);
	                                        return selection.text.length;
	                                    }
	                                }
	                                return 0;
	                            }
	
	                            function setCaretPosition(input, pos) {
	                                if (!input)
	                                    return 0;
	                                if (input.offsetWidth === 0 || input.offsetHeight === 0) {
	                                    return; // Input's hidden
	                                }
	                                if (input.setSelectionRange) {
	                                    if (isFocused(iElement[0])) {
	                                        input.focus();
	                                        input.setSelectionRange(pos, pos);
	                                    }
	                                }
	                                else if (input.createTextRange) {
	                                    // Curse you IE
	                                    var range = input.createTextRange();
	                                    range.collapse(true);
	                                    range.moveEnd('character', pos);
	                                    range.moveStart('character', pos);
	                                    range.select();
	                                }
	                            }
	
	                            function getSelectionLength(input) {
	                                if (!input)
	                                    return 0;
	                                if (input.selectionStart !== undefined) {
	                                    return (input.selectionEnd - input.selectionStart);
	                                }
	                                if (window.getSelection) {
	                                    return (window.getSelection().toString().length);
	                                }
	                                if (document.selection) {
	                                    return (document.selection.createRange().text.length);
	                                }
	                                return 0;
	                            }
	
	                            // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
	                            if (!Array.prototype.indexOf) {
	                                Array.prototype.indexOf = function(searchElement /*, fromIndex */) {
	                                    if (this === null) {
	                                        throw new TypeError();
	                                    }
	                                    var t = Object(this);
	                                    var len = t.length >>> 0;
	                                    if (len === 0) {
	                                        return -1;
	                                    }
	                                    var n = 0;
	                                    if (arguments.length > 1) {
	                                        n = Number(arguments[1]);
	                                        if (n !== n) { // shortcut for verifying if it's NaN
	                                            n = 0;
	                                        } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
	                                            n = (n > 0 || -1) * Math.floor(Math.abs(n));
	                                        }
	                                    }
	                                    if (n >= len) {
	                                        return -1;
	                                    }
	                                    var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
	                                    for (; k < len; k++) {
	                                        if (k in t && t[k] === searchElement) {
	                                            return k;
	                                        }
	                                    }
	                                    return -1;
	                                };
	                            }
	
	                        };
	                    }
	                };
	            }
	        ]);
	
	}());

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViewSelectionService = ViewSelectionService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function ViewSelectionService() {
	
	  var view = {
	    selectedCommunityCode: "",
	    selectedCommunity: {}
	  };
	
	  return view;
	}
	
	exports.default = angular.module('conduuApp.viewSelection', []).factory('ViewSelection', ViewSelectionService).name;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	TasksService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TasksService = TasksService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function TasksService($resource) {
	  return $resource('/api/tasks/:id', {
	    id: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	    },
	    getByContext: {
	      method: 'GET',
	      url: "/api/tasks/context/:id",
	      isArray: true
	    },
	    addAttachments: {
	      method: 'PUT',
	      url: "/api/tasks/:id/attachments"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.TaskService', []).factory('TaskService', TasksService).name;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var TaskEditComponent = exports.TaskEditComponent = function () {
	  /*@ngInject*/
	  TaskEditComponent.$inject = ['TaskService', '$uibModal', 'User', 'dialogs', 'SettingsService'];
	  function TaskEditComponent(TaskService, $uibModal, User, dialogs, SettingsService) {
	    var _this = this;
	
	    _classCallCheck(this, TaskEditComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	
	      if (this.config.hasOwnProperty("data")) {
	        this.task = angular.copy(this.config.data);
	
	        if (_typeof(this.task.assignedTo) == "object" && this.task.assignedTo !== null) {
	          this.task.assignedTo = this.task.assignedTo._id;
	        }
	
	        this.task.dueDate = new Date(this.task.dueDate);
	        this.customFields = this.task.customFields || {};
	      } else if (this.config.hasOwnProperty("context")) {
	        this.task.context = this.config.context;
	      }
	    };
	
	    this.TaskService = TaskService;
	    this.$uibModal = $uibModal;
	    this.dialogs = dialogs;
	    this.User = User;
	    this.SettingsService = SettingsService;
	
	    this.SettingsService.getByName({ name: 'custom-fields' }, function (customFieldSettings) {
	      if (customFieldSettings.data.hasOwnProperty("task")) {
	        _this.customSchema = customFieldSettings.data.task;
	        _this.customForm = ["*"];
	      }
	    });
	
	    this.task = {
	      priority: 0,
	      status: "open"
	    };
	    this.customFields = {};
	    this.users = [];
	
	    this.statusEnum = ["open", "closed"];
	    this.priorities = [{
	      value: 1,
	      name: "High"
	    }, {
	      value: 0,
	      name: "Normal"
	    }, {
	      value: -1,
	      name: "Low"
	    }];
	
	    this.dueDatePopupOpened = false;
	
	    this.User.query(function (data) {
	      _this.users = data.map(function (user) {
	        return {
	          value: user._id,
	          name: user.shortName || user.firstName + ' ' + user.lastName
	        };
	      });
	    });
	  }
	
	  _createClass(TaskEditComponent, [{
	    key: 'openDueDatePopup',
	    value: function openDueDatePopup() {
	      this.dueDatePopupOpened = true;
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          that.ok();
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.task.customFields = this.customFields || {};
	
	        if (this.config.data) {
	          this.TaskService.update({ id: this.task._id }, this.task, onSuccess, onError);
	        } else {
	          this.TaskService.save(this.task, onSuccess, onError);
	        }
	      }
	    }
	  }, {
	    key: 'userLookup',
	    value: function userLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'userLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (user) {
	        that.task.assignedTo = user._id;
	      }, function () {});
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.task });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return TaskEditComponent;
	}();
	
	exports.default = angular.module('conduu.taskEdit', []).component('taskEdit', {
	  template: __webpack_require__(606),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: TaskEditComponent
	}).name;

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"form\" name=\"form\" ng-submit=\"$ctrl.create(form)\" novalidate>\r\n  <div class=\"modal-header\">\r\n    <h3 class=\"modal-title\" id=\"modal-title\">Task Edit</h3>\r\n  </div>\r\n  <div class=\"modal-body\" id=\"modal-body\">\r\n\r\n\r\n      <div class=\"col-md-6 col-xs-12\" style=\"padding:0px\">\r\n        <!-- Assigned To -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.assignedTo.$valid && ctrl.submitted,\r\n                                          'has-error': form.assignedTo.$invalid && ctrl.submitted }\">\r\n          <label>Assigned To</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <select class=\"form-control\" ng-options=\"o.value as o.name for o in $ctrl.users\" ng-model=\"$ctrl.task.assignedTo\"\r\n                    style=\"display: inline-block; width: auto; min-width:180px\"></select>\r\n            <span class=\"input-group-btn\">\r\n                <a class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.userLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                <a class=\"btn btn-danger\" ng-disabled=\"!$ctrl.task.assignedTo\" ng-click=\"$ctrl.task.assignedTo = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n          </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"col-md-6 col-xs-12\" style=\"padding:0px\">\r\n        <!-- Status -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.status.$valid && ctrl.submitted,\r\n                                          'has-error': form.status.$invalid && ctrl.submitted }\">\r\n          <label>Status</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.statusEnum\" ng-model=\"$ctrl.task.status\"\r\n                    style=\"display: inline-block; width: auto; min-width:180px\"></select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"col-md-6 col-xs-12\" style=\"padding:0px\">\r\n        <!-- Due Date -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.dueDate.$valid && ctrl.submitted,\r\n                                          'has-error': form.dueDate.$invalid && ctrl.submitted }\">\r\n          <label>Due Date</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"$ctrl.task.dueDate\" is-open=\"$ctrl.dueDatePopupOpened\"\r\n                   ng-required=\"true\" close-text=\"Close\" style=\"display: inline-block; width: auto; min-width:180px\" />\r\n            <span class=\"input-group-btn\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.openDueDatePopup()\"><i class=\"fa fa-fw fa-calendar\"></i></button>\r\n          </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"col-md-6 col-xs-12\" style=\"padding:0px\">\r\n        <!-- Priority -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.priority.$valid && ctrl.submitted,\r\n                                          'has-error': form.priority.$invalid && ctrl.submitted }\">\r\n          <label>Priority</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <select class=\"form-control\" ng-options=\"o.value as o.name for o in $ctrl.priorities\" ng-model=\"$ctrl.task.priority\"\r\n                    style=\"display: inline-block; width: auto; min-width:180px\"></select>\r\n          </div>\r\n          <i ng-if=\"$ctrl.task.priority == 1\" style=\"position: relative;top: -8px;\" class=\"fa fa-fw fa-2x fa-long-arrow-up text-danger\"></i>\r\n          <i ng-if=\"$ctrl.task.priority == -1\" style=\"position: relative;top: -8px;\" class=\"fa fa-fw fa-2x fa-long-arrow-down text-success\"></i>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Subject -->\r\n      <div class=\"form-group\" ng-class=\"{ 'has-success': form.subject.$valid && $ctrl.submitted,\r\n                                          'has-error': form.subject.$invalid && $ctrl.submitted }\">\r\n        <label>Subject</label>\r\n        <br/>\r\n        <input type=\"text\" name=\"subject\" class=\"form-control\" ng-model=\"$ctrl.task.subject\" required/>\r\n      </div>\r\n\r\n      <!-- Message -->\r\n      <div class=\"form-group\" ng-class=\"{ 'has-success': form.description.$valid && $ctrl.submitted,\r\n                                          'has-error': form.description.$invalid && $ctrl.submitted }\">\r\n        <label>Description</label>\r\n        <br/>\r\n        <textarea name=\"description\" class=\"form-control big-textfield\" ng-model=\"$ctrl.task.description\"></textarea>\r\n      </div>\r\n\r\n      <!-- Custom Fields -->\r\n      <div ng-if=\"$ctrl.customForm\">\r\n          <br/>\r\n          <h4 class=\"text-muted text-right\" style=\"padding:0\">Custom Fields</h4>\r\n          <hr style=\"margin-top: 0px\"/>\r\n          <div sf-schema=\"$ctrl.customSchema\" sf-form=\"$ctrl.customForm\" sf-model=\"$ctrl.customFields\"></div>\r\n      </div>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"!($ctrl.task.assignedTo && $ctrl.task.dueDate && $ctrl.task.subject)\" type=\"button\">OK</button>\r\n    <a class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\">Cancel</a>\r\n  </div>\r\n</form>"

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var TaskShowComponent = exports.TaskShowComponent = function () {
	  /*@ngInject*/
	  TaskShowComponent.$inject = ['ViolationTicketsService', 'WorkOrderTicketsService', 'ServiceRequestTicketsService', 'CommunityService', 'PropertyService', 'ContactService', 'VendorService', 'CustomEntityService'];
	  function TaskShowComponent(ViolationTicketsService, WorkOrderTicketsService, ServiceRequestTicketsService, CommunityService, PropertyService, ContactService, VendorService, CustomEntityService) {
	    _classCallCheck(this, TaskShowComponent);
	
	    this.$onInit = function () {
	      var _this = this;
	
	      this.config = this.resolve.config;
	
	      this.task = this.config.data;
	
	      if (this.task.context && this.task.context.type != 'unbound') {
	        var contextId = this.task.context.reference;
	        var type = this.task.context.type;
	        if (type == 'violation') {
	          this.ViolationTicketsService.get({ id: contextId }, function (ccr) {
	            _this.context = '<a href="/violation/ticket/detail/' + ccr._id + '">' + ccr.code + ': ' + ccr.name + '</a>';
	          });
	        } else if (type == 'workorder') {
	          this.WorkOrderTicketsService.get({ id: contextId }, function (wo) {
	            _this.context = '<a href="/workorder/ticket/detail/' + wo._id + '">' + wo.code + ': ' + wo.name + '</a>';
	          });
	        } else if (type == 'servicerequest') {
	          this.ServiceRequestTicketsService.get({ id: contextId }, function (sr) {
	            _this.context = '<a href="/servicerequest/ticket/detail/' + sr._id + '">' + sr.code + ': ' + sr.name + '</a>';
	          });
	        } else if (type == 'community') {
	          this.CommunityService.get({ id: contextId }, function (cmty) {
	            _this.context = '<a href="/community/' + cmty._id + '">' + cmty.code + ': ' + cmty.name + '</a>';
	          });
	        } else if (type == 'property') {
	          this.PropertyService.get({ id: contextId }, function (cmty) {
	            _this.context = '<a href="/property/' + cmty._id + '">Property ' + cmty.address.street + ', ' + cmty.address.city + '</a>';
	          });
	        } else if (type == 'contact') {
	          this.ContactService.get({ id: contextId }, function (contact) {
	            _this.context = '<a href="/contact/' + contact._id + '">' + contact.firstName + ' ' + (contact.middleName || '') + ' ' + contact.lastName + '</a>';
	          });
	        } else if (type == 'vendor') {
	          this.VendorService.get({ id: contextId }, function (vendor) {
	            _this.context = '<a href="/vendor/' + vendor._id + '">' + vendor.name + '</a>';
	          });
	        } else if (type == 'entity') {
	          this.CustomEntityService.get({ id: contextId }, function (entity) {
	            _this.context = '<a class="text-capitalize" href="/custom/' + entity.schemaSettings + '/' + entity._id + '">' + entity.schemaSettings + '</a>';
	          });
	        }
	      }
	    };
	
	    this.ViolationTicketsService = ViolationTicketsService;
	    this.WorkOrderTicketsService = WorkOrderTicketsService;
	    this.ServiceRequestTicketsService = ServiceRequestTicketsService;
	    this.CommunityService = CommunityService;
	    this.PropertyService = PropertyService;
	    this.ContactService = ContactService;
	    this.VendorService = VendorService;
	    this.CustomEntityService = CustomEntityService;
	  }
	
	  _createClass(TaskShowComponent, [{
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.task });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return TaskShowComponent;
	}();
	
	exports.default = angular.module('conduu.taskShow', []).component('taskShow', {
	  template: __webpack_require__(608),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: TaskShowComponent
	}).name;

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <h3 class=\"modal-title\" id=\"modal-title\">Task</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n\r\n  <dl class=\"dl-horizontal bs-callout bs-callout-primary\" style=\"margin:0\">\r\n      <dt>Assigned To</dt>\r\n      <dd>{{$ctrl.task.assignedTo.shortName || '-'}}</dd>\r\n\r\n      <dt>Status</dt>\r\n      <dd class=\"text-capitalize\">{{$ctrl.task.status}}</dd>\r\n\r\n      <dt>Due Date</dt>\r\n      <dd>{{$ctrl.task.dueDate | date:'fullDate'}}</dd>\r\n\r\n      <dt>Priority</dt>\r\n      <dd>\r\n          <span ng-if=\"$ctrl.task.priority == 1\">High</span>\r\n          <span ng-if=\"$ctrl.task.priority == 0\">Normal</span>\r\n          <span ng-if=\"$ctrl.task.priority == -1\">Low</span>\r\n          <i ng-if=\"$ctrl.task.priority == 1\" class=\"fa fa-fw fa-long-arrow-up text-danger\"></i>\r\n          <i ng-if=\"$ctrl.task.priority == -1\" class=\"fa fa-fw fa-long-arrow-down text-success\"></i>\r\n      </dd>\r\n\r\n      <br/>\r\n\r\n      <dt>Subject</dt>\r\n      <dd>{{$ctrl.task.subject}}</dd>\r\n\r\n      <dt>Message</dt>\r\n      <dd>{{$ctrl.task.description || '-'}}</dd>\r\n\r\n      <br/>\r\n      <dt ng-if=\"$ctrl.context\">Context</dt>\r\n      <dd ng-if=\"$ctrl.context\" ng-bind-html=\"$ctrl.context\"></dd>\r\n\r\n  </dl>\r\n</div>\r\n<div class=\"modal-footer\">\r\n    <a class=\"btn btn-primary\" ng-click=\"$ctrl.cancel()\" type=\"button\">OK</a>\r\n</div>\r\n"

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var ntaSectionComponent = exports.ntaSectionComponent = function () {
	  ntaSectionComponent.$inject = ['TaskService', 'HistoryService', 'prompt', 'dialogs', '$uibModal', 'Auth'];
	  function ntaSectionComponent(TaskService, HistoryService, prompt, dialogs, $uibModal, Auth) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ntaSectionComponent);
	
	    this.$uibModal = $uibModal;
	    this.prompt = prompt;
	    this.dialogs = dialogs;
	    this.Auth = Auth;
	
	    this.TaskService = TaskService;
	    this.HistoryService = HistoryService;
	
	    this.dropdownMenu = [{
	      icon: 'list',
	      title: 'Add New Note',
	      action: function action(_) {
	        _this.addNote();
	      }
	    }, {
	      icon: 'sticky-note',
	      title: 'Add New Task',
	      action: function action(_) {
	        _this.createTask();
	      }
	    }];
	  }
	
	  _createClass(ntaSectionComponent, [{
	    key: 'getUsername',
	    value: function getUsername(note) {
	      if (!note.meta.creationUser) return "-";
	
	      var name = note.meta.creationUser.firstName;
	      if (note.meta.creationUser.middleName) name += " " + note.meta.creationUser.middleName.substr(0, 1) + ".";
	      name += " " + note.meta.creationUser.lastName;
	
	      return name;
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.TaskService.getByContext({ id: this.contextId }, function (tasks) {
	        _this2.tasks = tasks;
	      });
	
	      this.HistoryService.getByEntity({ id: this.contextId }, function (activities) {
	        _this2.activities = activities;
	      });
	    }
	  }, {
	    key: 'refreshHook',
	    value: function refreshHook() {
	      var _this3 = this;
	
	      this.onRefresh();
	
	      this.HistoryService.getByEntity({ id: this.contextId }, function (activities) {
	        _this3.activities = activities;
	      });
	    }
	  }, {
	    key: 'createTask',
	    value: function createTask() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'taskEdit',
	        resolve: {
	          config: function config() {
	            return {
	              context: {
	                type: that.context,
	                reference: that.contextId
	              }
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (task) {
	        that.TaskService.getByContext({ id: that.contextId }, function (tasks) {
	          that.tasks = tasks;
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'editTask',
	    value: function editTask(task) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'taskEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: task
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (task) {
	        that.TaskService.getByContext({ id: that.contextId }, function (tasks) {
	          that.tasks = tasks;
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'deleteTask',
	    value: function deleteTask(task) {
	      var _this4 = this;
	
	      var dlg = this.dialogs.confirm("Delete Task?", "Do you really want to delete this task?<br/><br/>" + task.subject);
	      dlg.result.then(function () {
	        _this4.TaskService.delete({ id: task._id }, function (_) {
	
	          _this4.TaskService.getByContext({ id: _this4.contextId }, function (tasks) {
	            _this4.tasks = tasks;
	          });
	        });
	      });
	    }
	  }, {
	    key: 'showTask',
	    value: function showTask(task) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'taskShow',
	        resolve: {
	          config: function config() {
	            return {
	              data: task
	            };
	          }
	        },
	        size: 'md'
	      });
	    }
	  }, {
	    key: 'addNote',
	    value: function addNote() {
	      var _this5 = this;
	
	      this.prompt({
	        title: 'Add Note',
	        message: 'Add your note below',
	        input: true,
	        label: '',
	        value: ''
	      }).then(function (note) {
	
	        var noteObj = {
	          meta: {
	            creationUser: _this5.Auth.getCurrentUserSync()._id
	          },
	          note: note
	        };
	
	        _this5.service.patch({ id: _this5.contextId }, [{ "op": "add", "path": "/notes/-", "value": noteObj }], function (data) {
	          _this5.refreshHook();
	        });
	      });
	    }
	  }, {
	    key: 'deleteNote',
	    value: function deleteNote(idx) {
	      var _this6 = this;
	
	      var dlg = this.dialogs.confirm("Delete Note?", "Do you really want to delete this note?<br/><br/>" + this.data.notes[idx].note);
	      dlg.result.then(function () {
	        _this6.service.patch({ id: _this6.contextId }, [{ "op": "remove", "path": "/notes/" + idx }], function (data) {
	          _this6.data.notes.splice(idx, 1);
	        });
	      }, function () {});
	    }
	  }]);
	
	  return ntaSectionComponent;
	}();
	
	exports.default = angular.module('conduuApp.ntaSection', []).component('ntaSection', {
	  template: __webpack_require__(610),
	  bindings: {
	    context: '@',
	    contextId: '<',
	    data: '<',
	    service: '<',
	    onRefresh: '&'
	  },
	  controller: ntaSectionComponent
	}).name;

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	module.exports = "<h3 class=\"separator\" style=\"z-index:100\"><span>Notes, Tasks and Activities <small><header-dropdown-menu icon=\"plus\" title=\"Add New\" menu=\"$ctrl.dropdownMenu\"></header-dropdown-menu></small></span></h3>\n\n<!-- alt: class=\"tabs-right align\" -->\n<uib-tabset>\n    <!-- Tab: Notes -->\n    <uib-tab index=\"0\" class=\"active\">\n        <uib-tab-heading>\n            <i class=\"fa fa-fw fa-sticky-note\" title=\"Notes\"></i> <span class=\"badge\">{{$ctrl.data.notes.length || '0'}}</span>\n        </uib-tab-heading>\n\n        <table ng-if=\"$ctrl.data.notes && $ctrl.data.notes.length\" class=\"table table-condensed borderless\">\n            <tbody>\n            <tr ng-repeat=\"note in $ctrl.data.notes | orderBy: 'meta.creationDate':true track by $index \">\n                <td><nobr>{{note.meta.creationUser.shortName || '-'}} {{note.meta.creationDate | date: 'short'}}:</nobr></td>\n                <td style=\"width:100%; font-weight: bold\"><span ng-bind-html=\"note.note\"></span></td>\n                <td style=\"text-align: right\">\n                    <a href=\"#\" class=\"text-danger\" ng-click=\"$ctrl.deleteNote($index)\" title=\"Delete Note\"><i class=\"fa fa-trash\"></i></a>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n\n        <h5 ng-if=\"!$ctrl.data.notes || !$ctrl.data.notes.length\">No notes available</h5>\n    </uib-tab>\n    <!-- Tab: Tasks -->\n    <uib-tab index=\"1\">\n        <uib-tab-heading>\n            <i class=\"fa fa-fw fa-list\" title=\"Tasks\"></i> <span class=\"badge\">{{$ctrl.tasks.length || '0'}}</span>\n        </uib-tab-heading>\n\n        <table ng-if=\"$ctrl.tasks && $ctrl.tasks.length\" class=\"table table-condensed borderless\">\n            <tbody>\n            <tr ng-class=\"{'text-danger': task.priority == 1 && task.status == 'open', 'text-muted': task.status == 'closed'}\"  ng-repeat=\"task in $ctrl.tasks\">\n                <td>\n                    <i ng-if=\"task.priority == 1\" class=\"fa fa-fw fa-long-arrow-up text-danger\"></i>\n                    <i ng-if=\"task.priority == -1\" class=\"fa fa-fw fa-long-arrow-down text-success\"></i>\n                </td>\n                <td>\n                    <span ng-if=\"task.priority == 1\">High</span>\n                    <span ng-if=\"task.priority == 0\">Normal</span>\n                    <span ng-if=\"task.priority == -1\">Low</span>\n                </td>\n                <td><i class=\"fa fa-fw fa-calendar-o\"></i> {{task.dueDate | date:'M/d/yy'}}</td>\n                <td>\n                    <span ng-show=\"task.status == 'open'\" class=\"label label-primary\">Open</span>\n                    <span ng-show=\"task.status == 'closed'\" class=\"label label-default\">Closed</span>\n                </td>\n                <td><i class=\"fa fa-fw fa-user-circle-o\"></i> {{task.assignedTo.shortName || '-'}}</td>\n                <td><span title=\"{{task.description}}\"><b>{{task.subject}}</b> <i ng-if=\"task.description\" class=\"fa fa-fw fa-commenting\"></i></span></td>\n                <td class=\"text-right\">\n                    <nobr>\n                        <a href=\"#\" ng-click=\"$ctrl.showTask(task)\" title=\"Open Task\"><i class=\"fa fa-fw fa-search\"></i></a>\n                        <a href=\"#\" ng-click=\"$ctrl.editTask(task)\" title=\"Edit Task\"><i class=\"fa fa-fw fa-pencil\"></i></a>\n                        <a href=\"#\" class=\"text-danger\" ng-click=\"$ctrl.deleteTask(task)\" title=\"Delete Task\"><i class=\"fa fa-trash\"></i></a>\n                    </nobr>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n\n        <h5 ng-if=\"!$ctrl.tasks || !$ctrl.tasks.length\">No tasks available</h5>\n    </uib-tab>\n    <!-- Tab: Activities -->\n    <uib-tab index=\"2\">\n        <uib-tab-heading>\n            <i class=\"fa fa-fw fa-history\" title=\"Activities\"></i> <span class=\"badge\">{{$ctrl.activities.length || '0'}}</span>\n        </uib-tab-heading>\n\n        <table ng-if=\"$ctrl.activities && $ctrl.activities.length\" class=\"table table-condensed borderless\">\n            <tbody>\n            <tr ng-repeat=\"activity in $ctrl.activities\">\n                <td>{{activity.meta.creationDate | date:'short'}}</td>\n                <td>\n                    <i ng-if=\"activity.actionType == 'created'\" class=\"fa fa-fw fa-asterisk\"></i>\n                    <i ng-if=\"activity.actionType == 'edited'\" class=\"fa fa-fw fa-pencil-square-o\"></i>\n                    <i ng-if=\"activity.actionType == 'loggedIn'\" class=\"fa fa-fw fa-sign-in\"></i>\n                    <i ng-if=\"activity.actionType == 'invitation'\" class=\"fa fa-fw fa-envelope-o\"></i>\n                    {{activity.action}}\n                </td>\n                <td>{{activity.meta.creationUser.shortName || '-'}}</td>\n            </tr>\n            </tbody>\n        </table>\n\n        <h5 ng-if=\"!$ctrl.activities || !$ctrl.activities.length\">No activities available</h5>\n    </uib-tab>\n</uib-tabset>\n\n<div class=\"clearfix\" />\n"

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var AddressEditComponent = exports.AddressEditComponent = function () {
	  /*@ngInject*/
	  function AddressEditComponent() {
	    _classCallCheck(this, AddressEditComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	
	      if (this.config.hasOwnProperty("data")) {
	        this.address = angular.copy(this.config.data);
	      }
	    };
	
	    var states_us = ["AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV", "WI", "WY"];
	    var states_can = ["AB", "BC", "MB", "NB", "NL", "NT", "NS", "NU", "ON", "PE", "QC", "SK", "YT"];
	
	    this.states = [].concat(states_us.map(function (state) {
	      return { country: 'United States', state: state };
	    }), states_can.map(function (state) {
	      return { country: 'Canada', state: state };
	    }), [{ country: 'Other', state: 'XX' }]);
	  }
	
	  _createClass(AddressEditComponent, [{
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.address });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return AddressEditComponent;
	}();
	
	exports.default = angular.module('conduu.addressEdit', []).component('addressEdit', {
	  template: __webpack_require__(612),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: AddressEditComponent
	}).name;

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	module.exports = "\r\n  <div class=\"modal-header\">\r\n    <h3 class=\"modal-title\" id=\"modal-title\">Address Edit</h3>\r\n  </div>\r\n  <div class=\"modal-body\" id=\"modal-body\">\r\n\r\n      <!-- Address: Street -->\r\n      <div class=\"form-group\">\r\n          <label>Street</label>\r\n\r\n          <input type=\"text\" name=\"street\" class=\"form-control\" ng-model=\"$ctrl.address.street\" />\r\n      </div>\r\n\r\n      <!-- Address: Street 2 -->\r\n      <div class=\"form-group\">\r\n          <label>Address Line 2</label>\r\n\r\n          <input type=\"text\" name=\"street2\" class=\"form-control\" ng-model=\"$ctrl.address.street2\" />\r\n      </div>\r\n\r\n      <div class=\"col-sm-6\" style=\"padding-left:0px\">\r\n          <!-- Address: City -->\r\n          <div class=\"form-group\">\r\n              <label>City</label>\r\n\r\n              <input type=\"text\" name=\"city\" class=\"form-control\" ng-model=\"$ctrl.address.city\" />\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"col-sm-4\" style=\"padding:0px\">\r\n          <!-- Address: State -->\r\n          <div class=\"form-group\">\r\n              <label>State</label>\r\n\r\n              <select class=\"form-control\" ng-options=\"o.state as o.state group by o.country for o in $ctrl.states\" ng-model=\"$ctrl.address.state\"></select>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"col-sm-2\" style=\"padding-right:0px\">\r\n          <!-- Address: ZIP -->\r\n          <div class=\"form-group\">\r\n              <label>ZIP</label>\r\n\r\n              <input type=\"text\" name=\"zip\" class=\"form-control\" ng-model=\"$ctrl.address.zip\" />\r\n          </div>\r\n      </div>\r\n\r\n      <!-- Address: Country -->\r\n      <div class=\"form-group\">\r\n          <label>Country</label>\r\n\r\n          <input type=\"text\" name=\"country\" class=\"form-control\" ng-model=\"$ctrl.address.country\" />\r\n      </div>\r\n\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button class=\"btn btn-primary\" type=\"submit\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\r\n    <a class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\">Cancel</a>\r\n  </div>\r\n"

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var headerDropdownMenuComponent =
	/*@ngInject*/
	exports.headerDropdownMenuComponent = function headerDropdownMenuComponent() {
	  _classCallCheck(this, headerDropdownMenuComponent);
	};
	
	exports.default = angular.module('conduuApp.headerDropdownMenu', []).component('headerDropdownMenu', {
	  template: __webpack_require__(614),
	  bindings: {
	    icon: '@',
	    title: '@',
	    menu: '<'
	  },
	  controller: headerDropdownMenuComponent
	}).name;

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	module.exports = "<div style=\"display:inline\" class=\"dropdown\" uib-dropdown=\"\">\r\n    <a href=\"#\" class=\"dropdown-toggle navbar-button text-center\" data-toggle=\"dropdown\" uib-dropdown-toggle=\"\"\r\n       role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"><i ng-if=\"$ctrl.icon\" class=\"fa fa-fw fa-{{$ctrl.icon}}\"></i>{{$ctrl.title}} <i class=\"fa fa-caret-down\"></i></a>\r\n\r\n    <ul class=\"dropdown-menu\" uib-dropdown-menu=\"\">\r\n        <li ng-repeat=\"menuItem in $ctrl.menu\">\r\n            <a ng-if=\"menuItem.url\" ng-href=\"{{menuItem.url}}\"><i ng-if=\"menuItem.icon\" class=\"fa fa-fw fa-{{menuItem.icon}}\"></i> {{menuItem.title}}</a>\r\n            <a ng-if=\"menuItem.action\" href=\"#\" ng-click=\"menuItem.action()\"><i ng-if=\"menuItem.icon\" class=\"fa fa-fw fa-{{menuItem.icon}}\"></i> {{menuItem.title}}</a>\r\n        </li>\r\n    </ul>\r\n</div>"

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var inlineDropdownMenuComponent =
	/*@ngInject*/
	exports.inlineDropdownMenuComponent = function inlineDropdownMenuComponent() {
	  _classCallCheck(this, inlineDropdownMenuComponent);
	};
	
	exports.default = angular.module('conduuApp.inlineDropdownMenu', []).component('inlineDropdownMenu', {
	  template: __webpack_require__(616),
	  bindings: {
	    icon: '@',
	    title: '@',
	    menu: '<',
	    context: '<'
	  },
	  controller: inlineDropdownMenuComponent
	}).name;

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	module.exports = "<div style=\"display:inline\" class=\"dropdown\" uib-dropdown=\"\">\r\n    <a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-fw fa-{{$ctrl.icon}}\"></i></a>\r\n    <ul class=\"dropdown-menu\" uib-dropdown-menu=\"\">\r\n        <li ng-repeat=\"menuItem in $ctrl.menu\">\r\n            <a ng-if=\"menuItem.url\" ng-href=\"{{menuItem.url}}\"><i ng-if=\"menuItem.icon\" class=\"fa fa-fw fa-{{menuItem.icon}}\"></i> {{menuItem.title}}</a>\r\n            <a ng-if=\"menuItem.action\" href=\"#\" ng-click=\"menuItem.action($ctrl.context)\"><i ng-if=\"menuItem.icon\" class=\"fa fa-fw fa-{{menuItem.icon}}\"></i> {{menuItem.title}}</a>\r\n        </li>\r\n    </ul>\r\n</div>"

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var userCardComponent = exports.userCardComponent = function () {
	  /*@ngInject*/
	  function userCardComponent() {
	    _classCallCheck(this, userCardComponent);
	  }
	
	  _createClass(userCardComponent, [{
	    key: 'getPrimaryEmail',
	    value: function getPrimaryEmail(owner) {
	      if (!owner || !owner.email || !owner.email.length) return "-";
	
	      var email = owner.email.find(function (email) {
	        return email.isPrimary;
	      }) || owner.email[0] || { address: '-' };
	
	      return email.address;
	    }
	  }, {
	    key: 'getPrimaryPhone',
	    value: function getPrimaryPhone(owner) {
	      if (!owner || !owner.phone || !owner.phone.length) return "-";
	
	      var phone = owner.phone.find(function (phone) {
	        return phone.isPrimary;
	      }) || owner.phone[0] || { number: '-' };
	
	      return phone.number;
	    }
	  }, {
	    key: 'getPrimaryAddress',
	    value: function getPrimaryAddress(owner) {
	      if (!owner || !owner.address || !owner.address.length) return "-";
	
	      var address = owner.address.find(function (adr) {
	        return adr.isPrimary;
	      }) || owner.address[0] || {};
	
	      var adrString = [];
	
	      adrString.push(address.street);
	      if (address.street2) adrString.push(address.street2);
	      adrString.push(address.city + ' ' + address.state + ', ' + address.zip);
	      if (address.country) adrString.push(address.country);
	
	      return adrString.join(', ');
	    }
	  }, {
	    key: 'getPrimaryOwnerName',
	    value: function getPrimaryOwnerName() {
	      var primary = this.property.contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary) return "-";
	
	      return this.getComposedName(primary.contact);
	    }
	  }, {
	    key: 'getPrimaryOwnerId',
	    value: function getPrimaryOwnerId() {
	      var primary = this.property.contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary || !primary.contact) return 0;
	
	      return primary.contact._id;
	    }
	  }, {
	    key: 'getPrimaryOwner',
	    value: function getPrimaryOwner() {
	      var primary = this.property.contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary) return null;
	
	      return primary.contact;
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += "<br/>" + contact.company;
	      }
	
	      return composedName || "-";
	    }
	  }]);
	
	  return userCardComponent;
	}();
	
	exports.default = angular.module('conduuApp.userCard', []).component('userCard', {
	  template: __webpack_require__(618),
	  bindings: {
	    community: '<',
	    property: '<'
	  },
	  controller: userCardComponent
	}).name;

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	module.exports = "<!-- PostIt: Work Order for Community -->\r\n<div ng-if=\"$ctrl.community\" class=\"card card-container\" style=\"float:right;position:relative;top:-32px\">\r\n    <img class=\"paper-clip\" src=\"assets/images/paperclip.png\" />\r\n    <img ng-if=\"!$ctrl.community.profilePicture\" class=\"profile-img-card\" ng-src=\"https://ui-avatars.com/api/?name={{$ctrl.community.name}}&background=eee&color=333&size=96\" />\r\n    <img ng-if=\"$ctrl.community.profilePicture\" class=\"profile-img-card\" style=\"max-height:100px; max-width:100%; border-radius: 5% 25%\" ng-src=\"/api/storage/{{$ctrl.community.profilePicture}}\" />\r\n    <p id=\"profile-name\" class=\"profile-name-card\"><a ng-href=\"/community/{{$ctrl.community._id}}\">{{$ctrl.community.code}}: {{$ctrl.community.name}}</a></p>\r\n    <br/>\r\n    <dl class=\"dl-horizontal\">\r\n        <dt><i class=\"fa fa-fw fa-map-marker\"></i></dt>\r\n        <dd>\r\n            <p>{{$ctrl.getPrimaryAddress($ctrl.community)}}</p>\r\n        </dd>\r\n        <dt><i class=\"fa fa-fw fa-phone\"></i></dt>\r\n        <dd>\r\n            <p>{{$ctrl.getPrimaryPhone($ctrl.community) | usPhone}}</p>\r\n        <dt><i class=\"fa fa-fw fa-envelope\"></i></dt>\r\n        <dd>\r\n            <p>{{$ctrl.getPrimaryEmail($ctrl.community)}}</p>\r\n        </dd>\r\n    </dl>\r\n</div>\r\n\r\n<!-- PostIt: Work Order for Property -->\r\n<div ng-if=\"$ctrl.property\" class=\"card card-container\" style=\"float:right;position:relative;top:-32px\">\r\n    <img class=\"paper-clip\" src=\"assets/images/paperclip.png\" />\r\n    <img class=\"profile-img-card\" ng-src=\"https://ui-avatars.com/api/?name={{$ctrl.getPrimaryOwnerName()}}&background=333&rounded=true&color=eee&size=96\" />\r\n    <p id=\"profile-name\" class=\"profile-name-card\"><a ng-href=\"/contact/{{$ctrl.getPrimaryOwnerId()}}\" ng-bind-html=\"$ctrl.getPrimaryOwnerName()\"></a></p>\r\n    <br/>\r\n    <dl class=\"dl-horizontal\">\r\n        <dt><i class=\"fa fa-fw fa-map-marker\"></i></dt>\r\n        <dd>\r\n            <p><a ng-href=\"/property/{{$ctrl.property._id}}\">{{$ctrl.property.address.street}}, {{$ctrl.property.address.city}} {{$ctrl.property.address.state}}, {{$ctrl.property.address.zip}}</a></p>\r\n        </dd>\r\n        <dt><i class=\"fa fa-fw fa-phone\"></i></dt>\r\n        <dd>\r\n            <p>{{$ctrl.getPrimaryPhone($ctrl.getPrimaryOwner()) | usPhone}}</p>\r\n        </dd>\r\n        <dt><i class=\"fa fa-fw fa-envelope\"></i></dt>\r\n        <dd><p><a ng-href=\"mailto:{{$ctrl.getPrimaryEmail($ctrl.getPrimaryOwner())}}\">{{$ctrl.getPrimaryEmail($ctrl.getPrimaryOwner())}}</a></p></dd>\r\n    </dl>\r\n</div>"

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarEdit = __webpack_require__(620);
	
	var _calendarEdit2 = _interopRequireDefault(_calendarEdit);
	
	var _calendarList = __webpack_require__(623);
	
	var _calendarList2 = _interopRequireDefault(_calendarList);
	
	var _calendarEventDetail = __webpack_require__(626);
	
	var _calendarEventDetail2 = _interopRequireDefault(_calendarEventDetail);
	
	var _event = __webpack_require__(628);
	
	var _event2 = _interopRequireDefault(_event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('conduuApp.calendar', [_calendarEdit2.default, _calendarList2.default, _calendarEventDetail2.default, _event2.default]).name;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CalendarEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _calendarEdit = __webpack_require__(621);
	
	var _calendarEdit2 = _interopRequireDefault(_calendarEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	__webpack_require__(44);
	
	var uiRouter = __webpack_require__(28);
	
	var CalendarEditComponent = exports.CalendarEditComponent = function () {
	  /*@ngInject*/
	  CalendarEditComponent.$inject = ['Auth', '$timeout', '$stateParams', '$state', 'dialogs', '$uibModal', 'StorageService', 'CalendarEventService', 'Upload', '$q'];
	  function CalendarEditComponent(Auth, $timeout, $stateParams, $state, dialogs, $uibModal, StorageService, CalendarEventService, Upload, $q) {
	    var _this = this;
	
	    _classCallCheck(this, CalendarEditComponent);
	
	    _initialiseProps.call(this);
	
	    this.Auth = Auth;
	    this.CalendarService = CalendarEventService;
	    this.StorageService = StorageService;
	    this.toolbarDefinition = [["bold", "italics", "underline", "strikeThrough"], ["h3", "h4", "h5"], ["p", "pre", "quote", "clear"], ["ul", "ol"], ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"], ["indent", "outdent"], ["undo", "redo"], ["html"], ["insertImage", "insertLink", "insertVideo"]];
	
	    this.timezone = "America/New_York";
	    this.clientLocation = {
	      "lat": 26.832421,
	      "lng": -80.05589350000002,
	      "address": "116 Lakeshore Dr, North Palm Beach, FL 33408, USA"
	    };
	
	    this.$timeout = $timeout;
	    this.eventId = $stateParams.id;
	    this.eventType = "event";
	
	    this.pageTitle = "Event Edit";
	
	    this.$state = $state;
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.Upload = Upload;
	    this.$q = $q;
	
	    this.dayOfWeek = [false, false, false, false, false, false, false];
	
	    this.eventTemplate = {
	      title: '',
	      description: '',
	      start: new Date(),
	      end: '',
	      allDay: false,
	      type: this.eventType,
	      meta: {
	        creationUser: Auth.getCurrentUserSync()._id,
	        active: true
	      }
	    };
	
	    this.event = angular.copy(this.eventTemplate);
	    this.assets = [];
	
	    if (this.eventId) {
	      this.CalendarService.get({ id: this.eventId }, function (data) {
	        _this.event = data;
	        _this.assets = data.attachments;
	
	        _this.event.start = _this.applyTimezoneChanges(_this.event.start, 'subtract');
	
	        if (_this.event.end) {
	          _this.event.end = _this.applyTimezoneChanges(_this.event.end, 'subtract');
	        }
	
	        if (data.location) {
	          _this.createMarker(data.location);
	          _this.map.panTo(new google.maps.LatLng(data.location.lat, data.location.lng));
	        }
	
	        _this.activeTab = _this.event.isRecurring ? 1 : 0;
	
	        if (_this.event.isRecurring) {
	          _this.event.recurrence.dayOfWeek.forEach(function (dow) {
	            _this.dayOfWeek[dow] = true;
	          });
	          _this.repeatUntil = _this.event.recurrence.until;
	        }
	      }, function (err) {
	        console.log('Could not load calendar event from server');
	      });
	    }
	
	    this.mapOptions = {
	      zoom: 15,
	      center: new google.maps.LatLng(this.clientLocation.lat, this.clientLocation.lng),
	      mapTypeId: google.maps.MapTypeId.TERRAIN
	    };
	
	    this.map = new google.maps.Map(document.getElementById('map'), this.mapOptions);
	    this.marker = null;
	
	    this.infoWindow = new google.maps.InfoWindow();
	
	    var that = this;
	
	    var input = document.getElementById('pac-input');
	    if (this.map && this.map.controls && this.map.controls[google.maps.ControlPosition.TOP_LEFT]) {
	      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
	      this.autocomplete = new google.maps.places.Autocomplete(input);
	
	      this.autocomplete.addListener('place_changed', function () {
	        that.$timeout(function () {
	          that.event.location = that.setPlace();
	        }, 0);
	      });
	    }
	
	    var that = this;
	
	    this.dropHandler = function (file, insertAction) {
	
	      var isImage = that.isImageMime(file.type);
	      var isPdf = that.isPdfMime(file.type);
	
	      if (!isImage && !isPdf) {
	        return;
	      }
	
	      var defer = that.$q.defer();
	
	      that.Upload.upload({
	        url: '/api/storage',
	        data: {
	          name: file.name,
	          file: file,
	          storageStrategy: 'local',
	          isPublic: true,
	          creationUser: that.Auth.getCurrentUserSync()._id,
	          active: true
	        }
	      }).then(function (response) {
	
	        if (isImage) {
	          insertAction("insertImage", "/api/storage/" + response.data, true);
	          defer.resolve(true);
	        } else if (isPdf) {
	          that.StorageService.getMeta({ id: response.data }, function (data) {
	            that.assets.push(data);
	            defer.resolve(true);
	          }, function (err) {
	            console.log('could not retrieved storage from server');
	            defer.reject();
	          });
	        }
	      }, function (response) {
	        if (response.status > 0) {
	          alert(response.status + ': ' + response.data);
	          defer.reject();
	        }
	      });
	
	      return defer.promise;
	    };
	  }
	
	  _createClass(CalendarEditComponent, [{
	    key: 'isImageMime',
	    value: function isImageMime(mime) {
	      return mime.startsWith('image/');
	    }
	  }, {
	    key: 'isPdfMime',
	    value: function isPdfMime(mime) {
	      return mime === 'application/pdf';
	    }
	  }, {
	    key: 'removeAsset',
	    value: function removeAsset(idx) {
	      this.assets.splice(idx, 1);
	    }
	  }, {
	    key: 'removeLocation',
	    value: function removeLocation() {
	      if (this.marker != null) {
	        this.marker.setMap(null);
	        this.marker = null;
	      }
	
	      this.event.location = {};
	    }
	  }, {
	    key: 'setPlace',
	    value: function setPlace() {
	      var place = this.autocomplete.getPlace();
	      if (!place.geometry) {
	        console.log("Autocomplete's returned place contains no geometry");
	        return;
	      }
	
	      var placeData = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng(), address: place.formatted_address };
	
	      if (place.geometry.viewport) {
	        this.map.fitBounds(place.geometry.viewport);
	      } else {
	        this.map.setCenter(place.geometry.location);
	      }
	
	      this.createMarker(placeData);
	
	      return placeData;
	    }
	  }, {
	    key: 'createMarker',
	    value: function createMarker(info) {
	      var marker = new google.maps.Marker({
	        map: this.map,
	        position: new google.maps.LatLng(info.lat, info.lng),
	        title: info.address
	      });
	      marker.content = '<div class="infoWindowContent">' + info.address + '</div>';
	
	      var that = this;
	
	      google.maps.event.addListener(marker, 'click', function () {
	        that.infoWindow.setContent('<h4>' + marker.title + '</h4>' + marker.content);
	        that.infoWindow.open(this.map, marker);
	      });
	
	      if (this.marker != null) {
	        this.marker.setMap(null);
	        this.marker = null;
	      }
	
	      this.marker = marker;
	    }
	  }, {
	    key: 'openInfoWindow',
	    value: function openInfoWindow(e, selectedMarker) {
	      e.preventDefault();
	      google.maps.event.trigger(selectedMarker, 'click');
	    }
	  }, {
	    key: 'getTimezoneDifference',
	    value: function getTimezoneDifference(targetTimezone, userTimezone) {
	      var now = moment();
	
	      if (typeof userTimezone != 'undefined') {
	        now = moment.tz(userTimezone);
	      }
	
	      var localOffset = now.utcOffset();
	
	      now.tz(targetTimezone);
	
	      var centralOffset = now.utcOffset();
	      var diffInMinutes = localOffset - centralOffset;
	
	      return diffInMinutes;
	    }
	  }, {
	    key: 'applyTimezoneChanges',
	    value: function applyTimezoneChanges(datetime, operation) {
	      return moment.utc(datetime)[operation](this.getTimezoneDifference(this.timezone), 'minutes').format();
	    }
	  }, {
	    key: 'setRecurrenceState',
	    value: function setRecurrenceState(isRecurring) {
	      this.event.isRecurring = isRecurring;
	
	      var allEmpty = function allEmpty(dow) {
	        var atLeastOneTrue = false;
	
	        dow.forEach(function (day) {
	          if (day) atLeastOneTrue = true;
	        });
	
	        return !atLeastOneTrue;
	      };
	
	      if (isRecurring && allEmpty(this.dayOfWeek) && this.event.start) {
	        var dow = moment(this.event.start).day();
	
	        this.dayOfWeek[dow] = true;
	      }
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      if (this.event.isRecurring && !this.repeatUntil) return;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          _this2.event = angular.copy(_this2.eventTemplate);
	          _this2.submitted = false;
	
	          var actionString = _this2.eventId ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "Your calendar event has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("calendar-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.event.attachments = this.assets.map(function (asset) {
	          return asset._id;
	        });
	
	        this.event.start = this.applyTimezoneChanges(this.event.start, 'add');
	
	        if (this.event.end) {
	          this.event.end = this.applyTimezoneChanges(this.event.end, 'add');
	        }
	
	        if (this.event.isRecurring) {
	          if (this.event.recurrence) this.recurrenceAlreadyExists = true;
	
	          this.event.recurrence = {
	            until: this.repeatUntil,
	            dayOfWeek: []
	          };
	
	          for (var dow = 0; dow <= 6; dow++) {
	            if (this.dayOfWeek[dow]) this.event.recurrence.dayOfWeek.push(dow);
	          }
	        } else {
	          if (this.event.recurrence) {
	            this.event.recurrence = {};
	            this.recurrenceHasBeenRemoved = true;
	          }
	        }
	
	        if (this.eventId) {
	          this.CalendarService.update({ id: this.eventId }, this.event, onSuccess, onError);
	        } else {
	          this.CalendarService.save(this.event, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return CalendarEditComponent;
	}();
	
	var _initialiseProps = function _initialiseProps() {
	  this.checkStartDate = function (data) {
	    if (this.event.end && new Date(data) > new Date(this.event.end)) {
	      return "The start date must not be after the end date";
	    }
	  };
	
	  this.checkEndDate = function (data) {
	    if (new Date(data) < new Date(this.event.start)) {
	      return "The end date, if given, must not be before the start date";
	    }
	  };
	
	  this.checkRepeatUntilDate = function (data) {
	    if (new Date(data) < new Date(this.event.start)) {
	      return "The end date of recurrence must not be before the start date";
	    }
	  };
	
	  this.openAssetBrowserModal = function () {
	    var that = this;
	
	    var modalInstance = this.$uibModal.open({
	      animation: true,
	      component: 'assetBrowser',
	      resolve: {
	        config: function config() {
	          return {
	            restrictToUserAssets: !that.Auth.isAdminSync(),
	            userId: that.Auth.getCurrentUserSync()._id
	          };
	        }
	      },
	      size: 'lg'
	    });
	
	    modalInstance.result.then(function (newlySelectedAssets) {
	      that.assets = that.assets.concat(newlySelectedAssets);
	    }, function () {});
	  };
	
	  this.openAssetUploadModal = function () {
	    var that = this;
	
	    var modalInstance = this.$uibModal.open({
	      animation: true,
	      component: 'assetUpload',
	      resolve: {
	        config: function config() {
	          return {
	            acceptedFileTypes: 'application/pdf,image/*'
	          };
	        }
	      }
	    });
	
	    modalInstance.result.then(function (result) {
	
	      result.forEach(function (storageId) {
	        that.StorageService.getMeta({ id: storageId }, function (data) {
	          that.assets.push(data);
	        }, function (err) {
	          console.log('could not retrieved storage from server');
	        });
	      });
	    }, function () {});
	  };
	};
	
	exports.default = angular.module('conduuApp.calendarEdit', [uiRouter]).config(_calendarEdit2.default).component('calendarEdit', {
	  template: __webpack_require__(622),
	  controller: CalendarEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('calendar-edit', {
	    url: '/calendar/event/edit/:id',
	    template: '<calendar-edit></calendar-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>{{ctrl.pageTitle}}</h2>\r\n      <li><a href=\"/calendar/list\">Calendar</a></li>\r\n      <li class=\"active\"><a href=\"#\">{{ctrl.pageTitle}}</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form class=\"form\" name=\"form\" ng-submit=\"ctrl.create(form)\" novalidate>\r\n\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.title.$valid && ctrl.submitted,\r\n                                              'has-error': form.title.$invalid && ctrl.submitted }\">\r\n            <label>Title</label>\r\n            <input type=\"text\" name=\"title\" class=\"form-control\" ng-model=\"ctrl.event.title\" required/>\r\n            <p class=\"help-block\" ng-show=\"form.title.$error.required && ctrl.submitted\">\r\n              You must specify a title for the event.\r\n            </p>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label>Description</label>\r\n            <text-angular ng-model=\"ctrl.event.description\" ta-toolbar=\"ctrl.toolbarDefinition\" ta-file-drop=\"ctrl.dropHandler\"></text-angular>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label>Contact</label>\r\n            <textarea name=\"contact\" rows=\"5\" class=\"form-control\" ng-model=\"ctrl.event.contact\"></textarea>\r\n          </div>\r\n\r\n        <hr />\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.start.$valid && ctrl.submitted,\r\n                                        'has-error': form.start.$invalid && ctrl.submitted }\">\r\n          <label>Start</label>\r\n\r\n          <div>\r\n            <a style=\"font-weight:bold; text-decoration:none\"\r\n               inplace-edit-hover href=\"#\" editable-combodate=\"ctrl.event.start\" e-format=\"{{null}}\"\r\n               e-single e-min-year=\"2015\" e-template=\"MMM D, YYYY  h:mm a\" ng-click=\"frmStart.$show()\"\r\n               e-max-year=\"2025\" e-form=\"frmStart\" ng-hide=\"frmStart.$visible\"\r\n               onbeforesave=\"ctrl.checkStartDate($data)\">\r\n              {{ (ctrl.event.start | date:'MMM d, y h:mm a') || 'empty' }}\r\n            </a>\r\n          </div>\r\n\r\n          <p class=\"help-block\" ng-show=\"form.start.$error.required && ctrl.submitted\">\r\n            You must specify a start date for the event.\r\n          </p>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.end.$valid && ctrl.submitted,\r\n                                        'has-error': form.end.$invalid && ctrl.submitted }\">\r\n          <label>End</label>\r\n\r\n          <div>\r\n            <a style=\"font-weight:bold; text-decoration:none\"\r\n               inplace-edit-hover href=\"#\" editable-combodate=\"ctrl.event.end\" e-format=\"{{null}}\"\r\n               e-single e-min-year=\"2015\" ng-click=\"frmEnd.$show()\"\r\n               e-max-year=\"2025\" e-form=\"frmEnd\" e-template=\"MMM D, YYYY  h:mm a\" ng-hide=\"frmEnd.$visible\"\r\n               onbeforesave=\"ctrl.checkEndDate($data)\">\r\n              {{ (ctrl.event.end | date:'MMM d, y h:mm a') || 'not set' }}\r\n            </a>\r\n            <a class=\"btn btn-xs btn-more\" style=\"position: absolute; left: 200px\"\r\n               ng-click=\"ctrl.event.end = null\" ng-show=\"ctrl.event.end && !frmEnd.$visible\"><i class=\"fa fa-times\"></i> Remove</a>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div ng-show=\"ctrl.getTimezoneDifference(ctrl.timezone)\" class=\"alert alert-info\">\r\n          <i class=\"fa fa-fw fa-clock-o\"></i> Start and end date are displayed in your community's local time\r\n        </div>\r\n\r\n        <uib-tabset active=\"ctrl.activeTab\">\r\n\r\n          <uib-tab index=\"0\" select=\"ctrl.setRecurrenceState(false)\" heading=\"One-time Event\">\r\n            <br />\r\n\r\n            <div class=\"form-group\">\r\n              <label>All day</label>\r\n              <input type=\"checkbox\" name=\"allDay\" class=\"form-control\" ng-model=\"ctrl.event.allDay\"/>\r\n            </div>\r\n          </uib-tab>\r\n\r\n          <uib-tab index=\"1\" select=\"ctrl.setRecurrenceState(true)\"  heading=\"Recurring Event\">\r\n\r\n            <br />\r\n\r\n            <div class=\"form-group\">\r\n              <label>Repeat every week on</label>\r\n              <br/>\r\n              <div class=\"btn-group\">\r\n                <label class=\"btn btn-default\" ng-model=\"ctrl.dayOfWeek[0]\" uib-btn-checkbox>Sun</label>\r\n                <label class=\"btn btn-default\" ng-model=\"ctrl.dayOfWeek[1]\" uib-btn-checkbox>Mon</label>\r\n                <label class=\"btn btn-default\" ng-model=\"ctrl.dayOfWeek[2]\" uib-btn-checkbox>Tue</label>\r\n                <label class=\"btn btn-default\" ng-model=\"ctrl.dayOfWeek[3]\" uib-btn-checkbox>Wed</label>\r\n                <label class=\"btn btn-default\" ng-model=\"ctrl.dayOfWeek[4]\" uib-btn-checkbox>Thu</label>\r\n                <label class=\"btn btn-default\" ng-model=\"ctrl.dayOfWeek[5]\" uib-btn-checkbox>Fri</label>\r\n                <label class=\"btn btn-default\" ng-model=\"ctrl.dayOfWeek[6]\" uib-btn-checkbox>Sat</label>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\" ng-class=\"{ 'has-error': ctrl.event.isRecurring && !ctrl.repeatUntil && ctrl.submitted }\">\r\n              <label>Repeat until</label>\r\n\r\n              <div>\r\n                <a style=\"font-weight:bold; text-decoration:none\"\r\n                   inplace-edit-hover href=\"#\" editable-combodate=\"ctrl.repeatUntil\" e-format=\"{{null}}\"\r\n                   e-single e-min-year=\"2015\" ng-click=\"frmRepeatUntil.$show()\" e-template=\"MMM D, YYYY\"\r\n                   e-max-year=\"2025\" e-form=\"frmRepeatUntil\" ng-hide=\"frmRepeatUntil.$visible\"\r\n                   onbeforesave=\"ctrl.checkRepeatUntilDate($data)\">\r\n                  {{ (ctrl.repeatUntil | date:'MMM d, y') || 'not set' }}\r\n                </a>\r\n                <a class=\"btn btn-xs btn-more\" style=\"position: absolute; left: 120px\"\r\n                   ng-click=\"ctrl.repeatUntil = null\" ng-show=\"ctrl.repeatUntil && !frmRepeatUntil.$visible\"><i class=\"fa fa-times\"></i> Remove</a>\r\n              </div>\r\n\r\n              <p class=\"help-block\" ng-show=\"ctrl.event.isRecurring && !ctrl.repeatUntil && ctrl.submitted\">\r\n                You must specify an end date for an recurring event.\r\n              </p>\r\n            </div>\r\n\r\n          </uib-tab>\r\n        </uib-tabset>\r\n\r\n        <hr />\r\n\r\n        <div class=\"form-group\">\r\n          <label>Address / Location\r\n            <a class=\"btn btn-xs btn-more\" ng-click=\"ctrl.removeLocation()\" ng-show=\"ctrl.event.location.address\"><i class=\"fa fa-times\"></i> Remove</a>\r\n          </label>\r\n\r\n          <input id=\"pac-input\" class=\"controls\" type=\"text\" placeholder=\"Enter a location\">\r\n          <div id=\"map\"></div>\r\n        </div>\r\n\r\n        <!-- Attachments -->\r\n        <div class=\"form-group\">\r\n          <label>Attachments</label>\r\n\r\n          <table ng-show=\"ctrl.assets.length > 0\" style=\"width:100%;\" class=\"table table-striped\">\r\n            <thead>\r\n            <tr>\r\n              <th>#</th>\r\n              <th></th>\r\n              <th>Name</th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody ui-sortable ng-model=\"ctrl.assets\">\r\n            <tr ng-repeat=\"asset in ctrl.assets\" style=\"cursor: move;\">\r\n              <td>{{$index}}</td>\r\n              <td>\r\n                <p style=\"margin: 0px\">\r\n                  <img ng-if=\"ctrl.isImageMime(asset.contentType)\" ng-src=\"/api/storage/{{asset._id}}/thumb\" style=\"height:40px\" />\r\n                  <i ng-if=\"ctrl.isPdfMime(asset.contentType)\" class=\"fa fa-fw fa-file-pdf-o fa-3x\"></i>\r\n                </p>\r\n              </td>\r\n              <td>{{asset.filename}}</td>\r\n              <td style=\"text-align: right\"><a class=\"btn btn-danger\" ng-click=\"ctrl.removeAsset($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <a class=\"btn btn-primary\" ng-click=\"ctrl.openAssetBrowserModal()\"><i class=\"fa fa-fw fa-hand-pointer-o\"></i> Select Files</a>\r\n        <a class=\"btn btn-primary\" ng-click=\"ctrl.openAssetUploadModal()\"><i class=\"fa fa-fw fa-upload\"></i> Upload Files</a>\r\n\r\n        <hr/>\r\n\r\n        <div ng-show=\"ctrl.sendFailure\" class=\"alert alert-danger\">\r\n          There has been an error. Your calendar event could not be created.\r\n        </div>\r\n\r\n        <button ng-hide=\"ctrl.eventId\" class=\"btn btn-primary\" type=\"submit\">Create Event</button>\r\n\r\n        <button ng-show=\"ctrl.eventId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button ng-show=\"ctrl.eventId\" class=\"btn btn-warning\" ui-sref=\"calendar-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CalendarListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _calendarList = __webpack_require__(624);
	
	var _calendarList2 = _interopRequireDefault(_calendarList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var CalendarListComponent = exports.CalendarListComponent = function () {
	  CalendarListComponent.$inject = ['CalendarEventService', '$uibModal', '$timeout', 'Auth', '$state', 'TaskService', 'ViolationTicketsService', 'WorkOrderTicketsService', '$scope', 'ViewSelection'];
	  function CalendarListComponent(CalendarEventService, $uibModal, $timeout, Auth, $state, TaskService, ViolationTicketsService, WorkOrderTicketsService, $scope, ViewSelection) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, CalendarListComponent);
	
	    this.Auth = Auth;
	    this.eventSources = [];
	    this.$uibModal = $uibModal;
	    this.$timeout = $timeout;
	    this.isAdmin = function () {
	      return true;
	    };
	    this.loading = true;
	
	    this.display = {
	      "task": true,
	      "event": true,
	      "wo": true,
	      "ccr": true
	    };
	
	    this.type = "event";
	
	    this.calendarConfig = {
	      "event": {
	        "color": "#ffcc66",
	        "textColor": "black"
	      },
	      "task": {
	        "color": "#aaf",
	        "textColor": "black"
	      }
	    };
	    this.calendarEventUserContributionAllowed = ["event"];
	
	    this.timezone = "America/New_York";
	
	    var eventSourceEvents = {
	      events: [],
	      color: '#228B22',
	      textColor: 'white'
	    };
	
	    var eventSourceTasks = {
	      events: [],
	      color: '#446e9b',
	      textColor: 'white'
	    };
	
	    var eventSourceViolations = {
	      events: [],
	      color: '#d9534f',
	      textColor: 'white'
	    };
	
	    var eventSourceWorkOrders = {
	      events: [],
	      color: '#DAA520',
	      textColor: 'white'
	    };
	
	    this.eventSources.push(eventSourceEvents);
	    this.eventSources.push(eventSourceTasks);
	    this.eventSources.push(eventSourceViolations);
	    this.eventSources.push(eventSourceWorkOrders);
	
	    $scope.ViewSelection = ViewSelection;
	    $scope.$watch('ViewSelection.selectedCommunity', function (newVal, oldVal, scope) {
	      _this.selectedCommunity = newVal.name;
	      _this.selectedCommunityCode = newVal.value;
	
	      if (maxResCount == resCount) _this.filterData(_this.selectedCommunityCode);
	    });
	
	    this.filterData = function (code) {
	      console.log("enter filderData");
	      if (code) {
	        _this.filteredData.workorder = _this.data.workorder.filter(function (wo) {
	          return wo.workOrderData && wo.workOrderData.community && wo.workOrderData.community.code == code || wo.workOrderData && wo.workOrderData.property && wo.workOrderData.property.community && wo.workOrderData.property.community.code == code;
	        });
	
	        _this.filteredData.violation = _this.data.violation.filter(function (ccr) {
	          return ccr.violationData && ccr.violationData.property && ccr.violationData.property.community && ccr.violationData.property.community.code == code;
	        });
	
	        _this.filteredData.task = _this.data.task;
	        _this.filteredData.event = _this.data.event;
	      } else {
	        _this.filteredData.workorder = _this.data.workorder;
	        _this.filteredData.violation = _this.data.violation;
	        _this.filteredData.task = _this.data.task;
	        _this.filteredData.event = _this.data.event;
	      }
	
	      if (!_this.display.task) _this.filteredData.task = [];
	      if (!_this.display.event) _this.filteredData.event = [];
	      if (!_this.display.wo) _this.filteredData.workorder = [];
	      if (!_this.display.ccr) _this.filteredData.violation = [];
	
	      for (var i = 0; i <= 3; i++) {
	        if (_this.eventSources.length && _this.eventSources[i].events.length) {
	          _this.eventSources[i].events.splice(0, _this.eventSources[i].events.length);
	        }
	      }
	
	      _this.filteredData.workorder.forEach(function (wo) {
	        _this.eventSources[3].events.push(wo);
	      });
	
	      _this.filteredData.violation.forEach(function (ccr) {
	        _this.eventSources[2].events.push(ccr);
	      });
	
	      _this.filteredData.task.forEach(function (task) {
	        _this.eventSources[1].events.push(task);
	      });
	
	      _this.filteredData.event.forEach(function (event) {
	        _this.eventSources[0].events.push(event);
	      });
	
	      _this.loading = false;
	
	      _this.$timeout(function () {
	        jQuery('#fullCalendar').fullCalendar('removeEvents');
	        _this.eventSources.forEach(function (eventSource) {
	          jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
	        });
	      }, 0);
	    };
	
	    var that = this;
	
	    this.data = {
	      workorder: [],
	      violation: [],
	      task: [],
	      event: []
	    };
	
	    this.filteredData = {
	      workorder: [],
	      violation: [],
	      task: [],
	      event: []
	    };
	
	    var resCount = 0;
	    var maxResCount = 4;
	
	    var getData = function getData() {
	      WorkOrderTicketsService.query(function (data) {
	
	        var targetData = data.filter(function (wo) {
	          return wo.hasOwnProperty("targetDate");
	        });
	
	        targetData.forEach(function (wo) {
	          _this.data.workorder.push({
	            title: wo.code + ": " + wo.name,
	            description: wo.description,
	            start: moment(wo.targetDate),
	            end: '',
	            allDay: true,
	            type: "workorder",
	            workOrderData: wo
	          });
	        });
	
	        resCount++;
	        if (resCount == maxResCount) _this.filterData(_this.selectedCommunityCode);
	      });
	
	      TaskService.query(function (data) {
	
	        data.forEach(function (task) {
	          _this.data.task.push({
	            title: task.subject,
	            description: task.description,
	            start: moment(task.dueDate),
	            end: '',
	            allDay: true,
	            type: "task",
	            taskData: task
	          });
	        });
	
	        resCount++;
	        if (resCount == maxResCount) _this.filterData(_this.selectedCommunityCode);
	      });
	
	      ViolationTicketsService.query(function (data) {
	        data.forEach(function (ccr) {
	
	          ccr.sequence.forEach(function (lvl) {
	            var dueDate = moment(ccr.meta.creationDate, "YYYY-MM-DD").add(lvl.days, 'days').toDate();
	            _this.data.violation.push({
	              title: ccr.code + ': ' + ccr.name + " / " + lvl.level,
	              description: ccr.article,
	              start: dueDate,
	              end: '',
	              allDay: true,
	              type: "violation",
	              violationData: ccr,
	              levelData: lvl
	            });
	          });
	        });
	
	        resCount++;
	        if (resCount == maxResCount) _this.filterData(_this.selectedCommunityCode);
	      });
	
	      CalendarEventService.getByType({ type: that.type }, function (data) {
	
	        if (that.eventSources.length && that.eventSources[0].events.length) {
	          that.eventSources[0].events.splice(0, that.eventSources[0].events.length);
	        }
	
	        data.forEach(function (evt) {
	
	          var event = evt;
	          event.eventId = evt._id;
	
	          if (event.isRecurring) {
	            event.range = { start: event.start, end: event.recurrence.until };
	
	            event.start = moment(event.start).format("HH:mm");
	
	            if (event.end) event.end = moment(event.end).format("HH:mm");
	
	            event.dow = event.recurrence.dayOfWeek;
	            event.id = event._id;
	          }
	
	          _this.data.event.push(event);
	        });
	
	        resCount++;
	        if (resCount == maxResCount) _this.filterData(_this.selectedCommunityCode);
	      }, function (err) {
	        console.log('could not retrieve events from server');
	      });
	    };
	
	    this.getData = getData;
	    getData();
	
	    this.uiConfig = {
	      calendar: {
	        timezone: 'local',
	        header: {
	          left: 'title',
	          center: 'month,agendaWeek,listMonth',
	          right: 'today prev,next'
	        },
	        viewRender: function viewRender(view, el) {
	          jQuery('#fullCalendar').fullCalendar('removeEvents');
	          _this.eventSources.forEach(function (eventSource) {
	            jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
	          });
	        },
	        eventRender: function eventRender(event, el) {
	          if (event.isRecurring) {
	            if (!(event.start.isBefore(event.range.end) && event.start.isAfter(event.range.start))) return false;
	          }
	
	          var timeZoneDiffMin = _this.getTimezoneDifference(_this.timezone);
	
	          var getTimezoneDiffString = function getTimezoneDiffString(mins) {
	            var prefix = "+";
	            if (mins < 0) prefix = "-";
	
	            mins = Math.abs(mins);
	
	            var h = mins / 60 | 0,
	                m = mins % 60 | 0;
	
	            if (String(h).length == 1) h = "0" + String(h);
	
	            if (String(m).length == 1) m = "0" + String(m);
	
	            return prefix + String(h) + ":" + String(m);
	          };
	
	          var timeZoneDiffStr = getTimezoneDiffString(timeZoneDiffMin);
	
	          if (!event.allDay && timeZoneDiffMin != 0) {
	            el.find('.fc-title').after(jQuery('<div class="tzo text-muted"/>').text(timeZoneDiffStr));
	          }
	        },
	        eventClick: function eventClick(_calendarEvent, jsEvent, view) {
	
	          var that = _this;
	
	          if (_calendarEvent.type == 'task') {
	            var modalInstance = _this.$uibModal.open({
	              animation: true,
	              component: 'taskShow',
	              resolve: {
	                config: function config() {
	                  return {
	                    data: _calendarEvent.taskData
	                  };
	                }
	              },
	              size: 'md'
	            });
	          } else if (_calendarEvent.type == 'workorder') {
	            var modalInstance = _this.$uibModal.open({
	              animation: true,
	              component: 'workOrderShow',
	              resolve: {
	                config: function config() {
	                  return {
	                    workOrder: _calendarEvent.workOrderData
	                  };
	                }
	              },
	              size: 'md'
	            });
	          } else if (_calendarEvent.type == 'violation') {
	            var modalInstance = _this.$uibModal.open({
	              animation: true,
	              component: 'violationShow',
	              resolve: {
	                config: function config() {
	                  return {
	                    violation: _calendarEvent.violationData,
	                    level: _calendarEvent.levelData,
	                    levelDate: _calendarEvent.start
	                  };
	                }
	              },
	              size: 'md'
	            });
	          } else {
	            var modalInstance = _this.$uibModal.open({
	              animation: true,
	              component: 'calendarEventDetail',
	              resolve: {
	                calendarEvent: function calendarEvent() {
	                  return _calendarEvent;
	                },
	                config: function config() {
	                  return {
	                    userHasPermission: that.Auth.isAdminSync() || that.Auth.getCurrentUserSync()._id === _calendarEvent.meta.creationUser
	                  };
	                }
	              }
	            });
	
	            modalInstance.result.then(function (result) {
	
	              if (result.action === 'removed') {
	                that.$timeout(function () {
	                  that.getData();
	                }, 0);
	              }
	            }, function () {});
	          }
	        }
	      }
	    };
	  }
	
	  _createClass(CalendarListComponent, [{
	    key: 'doFilterData',
	    value: function doFilterData() {
	      var _this2 = this;
	
	      this.loading = true;
	      this.$timeout(function () {
	        _this2.filterData(_this2.selectedCommunityCode);
	      }, 0);
	    }
	  }, {
	    key: 'userContributionAllowed',
	    value: function userContributionAllowed() {
	      return this.calendarEventUserContributionAllowed && this.calendarEventUserContributionAllowed.indexOf(this.type) !== -1;
	    }
	  }, {
	    key: 'getTimezoneDifference',
	    value: function getTimezoneDifference(targetTimezone, userTimezone) {
	      var now = moment();
	
	      if (typeof userTimezone != 'undefined') {
	        now = moment.tz(userTimezone);
	      }
	
	      var localOffset = now.utcOffset();
	
	      now.tz(targetTimezone);
	
	      var centralOffset = now.utcOffset();
	      var diffInMinutes = localOffset - centralOffset;
	
	      return diffInMinutes;
	    }
	  }]);
	
	  return CalendarListComponent;
	}();
	
	exports.default = angular.module('conduuApp.calendarList', [uiRouter]).config(_calendarList2.default).component('calendarList', {
	  template: __webpack_require__(625),
	  controller: CalendarListComponent,
	  bindings: {},
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('calendar-list', {
	    url: '/calendar/list',
	    template: '<calendar-list></calendar-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" ng-href=\"/calendar/event/edit/\"><i class=\"fa fa-plus\"></i> Add Event</a>\n      <div style=\"float:right; line-height:0px; margin-right:16px;\">\n        <label style=\"color:#446e9b\">\n          <input type=\"checkbox\" ng-model=\"ctrl.display.task\" ng-change=\"ctrl.doFilterData()\" />&nbsp;Task\n        </label><br/>\n        <label style=\"color:#228B22\">\n          <input type=\"checkbox\" ng-model=\"ctrl.display.event\" ng-change=\"ctrl.doFilterData()\" />&nbsp;Event\n        </label><br/>\n        <label style=\"color:#DAA520\">\n          <input type=\"checkbox\" ng-model=\"ctrl.display.wo\" ng-change=\"ctrl.doFilterData()\" />&nbsp;Work Order\n        </label><br/>\n        <label style=\"color:#d9534f\">\n          <input type=\"checkbox\" ng-model=\"ctrl.display.ccr\" ng-change=\"ctrl.doFilterData()\" />&nbsp;Violation\n        </label>\n      </div>\n      <h2>Calendar <small>{{ctrl.selectedCommunity}}</small></h2>\n      <li class=\"active\"><a href=\"#\">Calendar</a></li>\n    </ol>\n\n    <div class=\"col-xs-12\" ng-hide=\"ctrl.loading\">\n      <div id=\"fullCalendar\" ui-calendar=\"ctrl.uiConfig.calendar\" class=\"span8 calendar\" ng-model=\"ctrl.eventSources\"></div>\n    </div>\n\n    <div class=\"col-xs-12\" ng-show=\"ctrl.loading\">\n      <h5><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> Loading Calendar Data ...</h5>\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var calendarEventDetailComponent = exports.calendarEventDetailComponent = function () {
	  /*@ngInject*/
	  calendarEventDetailComponent.$inject = ['dialogs', 'CalendarEventService', '$timeout'];
	  function calendarEventDetailComponent(dialogs, CalendarEventService, $timeout) {
	    _classCallCheck(this, calendarEventDetailComponent);
	
	    this.dialogs = dialogs;
	    this.CalendarEventService = CalendarEventService;
	    this.$timeout = $timeout;
	  }
	
	  _createClass(calendarEventDetailComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.calendarEvent = this.resolve.calendarEvent;
	      this.userHasPermission = this.resolve.config.userHasPermission;
	
	      this.galleryImages = this.calendarEvent.attachments.filter(function (attachment) {
	        return _this.isImageMime(attachment.contentType);
	      });
	
	      this.galleryImages = this.galleryImages.map(function (obj) {
	        var rObj = {};
	
	        rObj.title = obj.filename;
	        rObj.alt = obj.filename;
	        rObj.url = "/api/storage/" + obj._id;
	        rObj.thumbUrl = '/api/storage/' + obj._id + '/thumb';
	
	        return rObj;
	      });
	
	      if (this.calendarEvent.location) {
	
	        this.mapOptions = {
	          zoom: 15,
	          center: new google.maps.LatLng(this.calendarEvent.location.lat, this.calendarEvent.location.lng),
	          mapTypeId: google.maps.MapTypeId.TERRAIN
	        };
	
	        var that = this;
	
	        this.$timeout(function () {
	          that.map = new google.maps.Map(document.getElementById('gMap'), that.mapOptions);
	
	          var marker = new google.maps.Marker({
	            map: that.map,
	            position: new google.maps.LatLng(that.calendarEvent.location.lat, that.calendarEvent.location.lng),
	            title: that.calendarEvent.location.address
	          });
	
	          marker.content = '<div class="infoWindowContent">' + that.calendarEvent.location.address + '</div>';
	        }, 500);
	      }
	    }
	  }, {
	    key: 'countPdfAttachments',
	    value: function countPdfAttachments(attachs) {
	      var _this2 = this;
	
	      return attachs.reduce(function (acc, obj) {
	        return acc + _this2.isPdfMime(obj.contentType);
	      }, 0);
	    }
	  }, {
	    key: 'isImageMime',
	    value: function isImageMime(mime) {
	      return mime.startsWith('image/');
	    }
	  }, {
	    key: 'isPdfMime',
	    value: function isPdfMime(mime) {
	      return mime === 'application/pdf';
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var that = this;
	      var eventId = this.calendarEvent.eventId;
	
	      var dlg = this.dialogs.confirm("Delete this Calendar Event?", "Do you really want to delete this calendar event?");
	      dlg.result.then(function () {
	        that.CalendarEventService.delete({ id: eventId }, function () {
	          that.close({ $value: { action: 'removed', id: eventId } });
	        }, function (err) {
	          alert("Could not delete calendar event");
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return calendarEventDetailComponent;
	}();
	
	exports.default = angular.module('conduuApp.calendarEventDetail', []).component('calendarEventDetail', {
	  template: __webpack_require__(627),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: calendarEventDetailComponent
	}).name;

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\">\r\n    {{$ctrl.calendarEvent.title}}\r\n    <small>\r\n      <span ng-show=\"$ctrl.calendarEvent.allDay\">{{$ctrl.calendarEvent.start.toDate() | date:\"MMM d, y 'all day'\"}}</span>\r\n      <span ng-hide=\"$ctrl.calendarEvent.allDay\">{{$ctrl.calendarEvent.start.toDate() | date:\"M/d/yy h:mm a\"}}</span>\r\n      <span ng-hide=\"$ctrl.calendarEvent.allDay || !$ctrl.calendarEvent.end\"> - {{$ctrl.calendarEvent.end.toDate() | date:\"M/d/yy h:mm a\"}}</span>\r\n    </small>\r\n  </h3>\r\n</div>\r\n<div class=\"modal-body\">\r\n\r\n  <div class=\"bs-callout bs-callout-success\" style=\"margin:0\">\r\n    <span ng-show=\"$ctrl.calendarEvent.description\" ng-bind-html=\"$ctrl.calendarEvent.description\"></span>\r\n    <span ng-hide=\"$ctrl.calendarEvent.description\"><em>No description available</em></span>\r\n  </div>\r\n  \r\n  <div ng-show=\"$ctrl.countPdfAttachments($ctrl.calendarEvent.attachments)\">\r\n    <hr />\r\n    <h5><i class=\"fa fa-fw fa-file-pdf-o\"></i> Attachments</h5>\r\n\r\n    <!-- PDFs are embedded in the doc -->\r\n    <div class=\"row\">\r\n      <div ng-repeat=\"attachment in $ctrl.calendarEvent.attachments\" ng-show=\"$ctrl.isPdfMime(attachment.contentType)\"\r\n           class=\"col-xs-6\" style=\"overflow:hidden; padding:12px; margin:0px;\">\r\n        <a ng-if=\"$ctrl.isPdfMime(attachment.contentType)\" title=\"{{attachment.filename}}\"\r\n           ng-href=\"/api/storage/{{attachment._id}}\" target=\"_blank\" style=\"cursor: pointer\">\r\n          <i class=\"fa fa-fw fa-file-pdf-o fa-3x\" style=\"float:left\"></i>\r\n          <em>{{attachment.filename}}</em>\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div ng-if=\"$ctrl.calendarEvent.location\">\r\n    <hr />\r\n    <h5><i class=\"fa fa-fw fa-map-marker\"></i> {{$ctrl.calendarEvent.location.address}}</h5>\r\n    <!-- GMaps -->\r\n    <div id=\"gMap\" style=\"height:240px\"></div>\r\n  </div>\r\n\r\n  <div ng-if=\"$ctrl.calendarEvent.contact\">\r\n    <hr />\r\n    <h5><i class=\"fa fa-fw fa-user\"></i> Contact</h5>\r\n    <span ng-bind-html=\"$ctrl.calendarEvent.contact | newlineToHtml\"></span>\r\n  </div>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <!-- Than we have the image gallery in left hand side of the footer -->\r\n  <div ng-show=\"$ctrl.galleryImages.length\" style=\"float:left;\">\r\n      <ng-image-gallery images=\"$ctrl.galleryImages\" style=\"position: absolute;bottom: 12px;\"></ng-image-gallery>\r\n  </div>\r\n\r\n  <button ng-show=\"$ctrl.userHasPermission\" class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.delete()\">Delete</button>\r\n\r\n  <a ng-show=\"$ctrl.userHasPermission\" class=\"btn btn-primary\" type=\"button\" ng-href=\"/calendar/{{$ctrl.calendarEvent.type}}/edit/{{$ctrl.calendarEvent.eventId}}\" ng-click=\"$ctrl.ok()\">Edit</a>\r\n\r\n  <a class=\"btn btn-primary\" type=\"button\" target=\"_blank\" ng-href=\"/api/calendar-events/{{$ctrl.calendarEvent.eventId}}/ical\" ><i class=\"fa fa-download\"></i> iCal</a>\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">Close</button>\r\n\r\n</div>\r\n"

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	CalendarEventService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CalendarEventService = CalendarEventService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function CalendarEventService($resource) {
	  return $resource('/api/calendar-events/:id', {
	    id: '@_id'
	  }, {
	    getByType: {
	      method: 'GET',
	      url: "/api/calendar-events/type/:type",
	      isArray: true
	    },
	    patch: {
	      method: 'PATCH'
	    },
	    update: {
	      method: 'PUT'
	    },
	    getIcalFile: {
	      method: 'GET',
	      url: "/api/calendar-events/:id/ical"
	    },
	    getUpcoming: {
	      method: 'GET',
	      url: "/api/calendar-events/upcoming/:count",
	      isArray: true
	    }
	  });
	}
	
	exports.default = angular.module('conduuApp.CalendarEventService', []).factory('CalendarEventService', CalendarEventService).name;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var assetUploadComponent = exports.assetUploadComponent = function () {
	  /*@ngInject*/
	  assetUploadComponent.$inject = ['Upload', 'Auth'];
	  function assetUploadComponent(Upload, Auth) {
	    _classCallCheck(this, assetUploadComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	    };
	
	    this.Upload = Upload;
	    this.Auth = Auth;
	  }
	
	  _createClass(assetUploadComponent, [{
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.storageIds });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }, {
	    key: 'isImageMime',
	    value: function isImageMime(mime) {
	      return mime.startsWith('image/');
	    }
	  }, {
	    key: 'isPdfMime',
	    value: function isPdfMime(mime) {
	      return mime === 'application/pdf';
	    }
	  }, {
	    key: 'isHtmlMime',
	    value: function isHtmlMime(mime) {
	      return mime == 'text/html';
	    }
	  }, {
	    key: 'isWordMime',
	    value: function isWordMime(mime) {
	      return mime == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || mime == 'application/msword';
	    }
	  }, {
	    key: 'isPowerPointMime',
	    value: function isPowerPointMime(mime) {
	      return mime == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || mime == 'application/vnd.ms-powerpoint';
	    }
	  }, {
	    key: 'isExcelMime',
	    value: function isExcelMime(mime) {
	      return mime == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	    }
	  }, {
	    key: 'isOpenDocumentPresentation',
	    value: function isOpenDocumentPresentation(mime) {
	      return mime == 'application/vnd.oasis.opendocument.presentation';
	    }
	  }, {
	    key: 'isOpenDocumentText',
	    value: function isOpenDocumentText(mime) {
	      return mime == 'application/vnd.oasis.opendocument.text';
	    }
	  }, {
	    key: 'isOpenDocumentSpreadsheet',
	    value: function isOpenDocumentSpreadsheet(mime) {
	      return mime == 'application/vnd.oasis.opendocument.spreadsheet';
	    }
	  }, {
	    key: 'getIconByMime',
	    value: function getIconByMime(mime) {
	      if (this.isImageMime(mime)) return "fa-file-image-o";else if (this.isPdfMime(mime)) return "fa-file-pdf-o";else if (this.isHtmlMime(mime)) return "fa-file-code-o";else if (this.isWordMime(mime)) return "fa-file-word-o";else if (this.isOpenDocumentText(mime)) return "fa-file-word-o";else if (this.isExcelMime(mime)) return "fa-file-excel-o";else if (this.isOpenDocumentSpreadsheet(mime)) return "fa-file-excel-o";else if (this.isPowerPointMime(mime)) return "fa-file-powerpoint-o";else if (this.isOpenDocumentPresentation(mime)) return "fa-file-powerpoint-o";else return "fa-file-o";
	    }
	  }, {
	    key: 'selectFiles',
	    value: function selectFiles(files) {
	      this.files = files;
	
	      this.files.forEach(function (file) {
	        file.isPublic = false;
	        file.permission = ["user"];
	      });
	    }
	  }, {
	    key: 'uploadFiles',
	    value: function uploadFiles() {
	      var _this = this;
	
	      var files = this.files;
	
	      this.storageIds = [];
	      this.allDone = false;
	      this.progress = 0;
	
	      var that = this;
	
	      if (files && files.length) {
	
	        var count = 0;
	
	        files.forEach(function (file) {
	
	          var permission = file.permission || [];
	
	          _this.Upload.upload({
	            url: '/api/storage',
	            data: {
	              name: file.name,
	              file: file,
	              isPublic: file.isPublic,
	              permission: permission.join(','),
	              storageStrategy: 'local',
	              creationUser: _this.Auth.getCurrentUserSync()._id,
	              active: true
	            }
	          }).then(function (response) {
	            that.storageIds.push(response.data);
	
	            count++;
	
	            that.progress = Math.floor(count / files.length) * 100;
	
	            if (count === files.length) {
	              that.allDone = true;
	              that.progress = 100;
	
	              that.ok();
	            }
	          }, function (response) {
	            if (response.status > 0) {
	              alert(response.status + ': ' + response.data);
	            }
	          });
	        });
	      }
	    }
	  }]);
	
	  return assetUploadComponent;
	}();
	
	exports.default = angular.module('conduu.sm.asset.upload', []).component('assetUpload', {
	  template: __webpack_require__(630),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: assetUploadComponent
	}).name;

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">File Upload</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n\r\n  <button ng-if=\"!$ctrl.files\" class=\"btn btn-primary\" ngf-select=\"$ctrl.selectFiles($files)\"\r\n          multiple accept=\"{{$ctrl.config.acceptedFileTypes}}\"><i class=\"fa fa-fw fa-upload\"></i> Select Files to Upload</button>\r\n\r\n  <div ng-if=\"$ctrl.files && $ctrl.isAdmin()\" class=\"bs-callout bs-callout-info\" style=\"margin-top:0px\">\r\n    <p><i class=\"fa fa-fw fa-info\"></i> In the table below you can change the permission for each file</p>\r\n  </div>\r\n\r\n  <table ng-if=\"$ctrl.files\" class=\"table table-striped\" style=\"width:100%\">\r\n    <thead>\r\n    <tr>\r\n      <th></th>\r\n      <th>Name</th>\r\n      <th>Size</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-repeat=\"file in $ctrl.files\">\r\n      <td>\r\n        <i class=\"fa {{$ctrl.getIconByMime(file.type)}}\"></i>\r\n      </td>\r\n      <td>{{file.name}}</td>\r\n      <td>{{file.size / 1024 | number:0}} KB</td>\r\n    </tr>\r\n    </tbody>\r\n  </table>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <span ng-show=\"$ctrl.progress >= 0\" style=\"display: inline-block; float:left; width: 200px; border: 1px solid #2e6da4; margin:6px\">\r\n        <div class=\"asset-upload-progress-bar\" ng-style=\"{width: $ctrl.progress + '%'}\" ng-bind=\"$ctrl.progress + '%'\"></div>\r\n  </span>\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!$ctrl.files || $ctrl.progress\" ng-click=\"$ctrl.uploadFiles()\">Upload</button>\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var AttachmentListComponent = exports.AttachmentListComponent = function () {
	  AttachmentListComponent.$inject = ['dialogs', '$uibModal'];
	  function AttachmentListComponent(dialogs, $uibModal) {
	    'ngInject';
	
	    _classCallCheck(this, AttachmentListComponent);
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	  }
	
	  _createClass(AttachmentListComponent, [{
	    key: 'isNonViewableMime',
	    value: function isNonViewableMime(mime) {
	      return !(this.isHtmlMime(mime) || this.isImageMime(mime) || this.isPdfMime(mime));
	    }
	  }, {
	    key: 'isImageMime',
	    value: function isImageMime(mime) {
	      return mime.startsWith('image/');
	    }
	  }, {
	    key: 'isPdfMime',
	    value: function isPdfMime(mime) {
	      return mime === 'application/pdf';
	    }
	  }, {
	    key: 'isHtmlMime',
	    value: function isHtmlMime(mime) {
	      return mime == 'text/html';
	    }
	  }, {
	    key: 'isWordMime',
	    value: function isWordMime(mime) {
	      return mime == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || mime == 'application/msword';
	    }
	  }, {
	    key: 'isPowerPointMime',
	    value: function isPowerPointMime(mime) {
	      return mime == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || mime == 'application/vnd.ms-powerpoint';
	    }
	  }, {
	    key: 'isExcelMime',
	    value: function isExcelMime(mime) {
	      return mime == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	    }
	  }, {
	    key: 'isOpenDocumentPresentation',
	    value: function isOpenDocumentPresentation(mime) {
	      return mime == 'application/vnd.oasis.opendocument.presentation';
	    }
	  }, {
	    key: 'isOpenDocumentText',
	    value: function isOpenDocumentText(mime) {
	      return mime == 'application/vnd.oasis.opendocument.text';
	    }
	  }, {
	    key: 'isOpenDocumentSpreadsheet',
	    value: function isOpenDocumentSpreadsheet(mime) {
	      return mime == 'application/vnd.oasis.opendocument.spreadsheet';
	    }
	  }, {
	    key: 'getIconByMime',
	    value: function getIconByMime(mime) {
	      if (this.isImageMime(mime)) return "fa-file-image-o";else if (this.isPdfMime(mime)) return "fa-file-pdf-o";else if (this.isHtmlMime(mime)) return "fa-file-code-o";else if (this.isWordMime(mime)) return "fa-file-word-o";else if (this.isOpenDocumentText(mime)) return "fa-file-word-o";else if (this.isExcelMime(mime)) return "fa-file-excel-o";else if (this.isOpenDocumentSpreadsheet(mime)) return "fa-file-excel-o";else if (this.isPowerPointMime(mime)) return "fa-file-powerpoint-o";else if (this.isOpenDocumentPresentation(mime)) return "fa-file-powerpoint-o";else return "fa-file-o";
	    }
	  }, {
	    key: 'openSendAttachmentModal',
	    value: function openSendAttachmentModal(attachment) {
	      if (this.hook.openSendAttachmentModal) {
	        this.hook.openSendAttachmentModal(attachment);
	      }
	    }
	  }, {
	    key: 'removeAsset',
	    value: function removeAsset(idx) {
	      var _this = this;
	
	      var dlg = this.dialogs.confirm("Delete Attachment?", "<i class='fa fa-5x fa-fw text-danger fa-warning' style='float:right'></i>Do you really want to delete this attachment?<br/><br/>" + this.attachments[idx].filename);
	      dlg.result.then(function () {
	        _this.service.patch({ id: _this.contextId }, [{ "op": "remove", "path": "/attachments/" + idx }], function (data) {
	          _this.attachments.splice(idx, 1);
	        });
	      }, function (err) {
	        console.log("Could not remove attachment");
	      });
	    }
	  }]);
	
	  return AttachmentListComponent;
	}();
	
	exports.default = angular.module('conduuApp.attachmentList', []).component('attachmentList', {
	  template: __webpack_require__(632),
	  bindings: {
	    attachments: '<',
	    contextId: '<',
	    service: '<',
	    hook: '<'
	  },
	  controller: AttachmentListComponent
	}).name;

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	module.exports = "<!-- Attachments -->\r\n<div class=\"form-group\">\r\n    <table ng-show=\"$ctrl.attachments.length\" style=\"width:100%;\" class=\"table table-condensed borderless\">\r\n        <tbody>\r\n        <tr ng-repeat=\"asset in $ctrl.attachments\">\r\n            <td>\r\n                <p style=\"margin: 0px\">\r\n                    <i class=\"fa {{$ctrl.getIconByMime(asset.contentType)}}\"></i>\r\n                </p>\r\n            </td>\r\n            <td>{{asset.filename}}</td>\r\n            <td>{{asset.meta.creationDate | date:'MMM d, y h:mm a'}}</td>\r\n            <td style=\"text-align: right; padding:0\">\r\n                <a class=\"btn btn-sm btn-primary btn-ms-action\" target=\"_blank\"\r\n                   ng-href=\"/api/storage/{{asset._id}}/download\" title=\"Download Attachment\"\r\n                   analytics-on=\"click\" analytics-value=\"{{asset.filename}}\" analytics-label=\"Attachment Download\"\r\n                   analytics-category=\"Attachment Download\" analytics-event=\"{{asset.filename}}\">\r\n                    <i class=\"fa fa-download fa-fw\"></i></a>\r\n                <a class=\"btn btn-sm btn-primary btn-ms-action\" target=\"_blank\"\r\n                   ng-href=\"/api/storage/{{asset._id}}\" title=\"Show Attachment\"\r\n                   ng-disabled=\"$ctrl.isNonViewableMime(asset.contentType)\"\r\n                   analytics-on=\"click\" analytics-value=\"{{asset.filename}}\" analytics-label=\"Attachment View\"\r\n                   analytics-category=\"Attachment View\" analytics-event=\"{{asset.filename}}\">\r\n                    <i class=\"fa fa-eye fa-fw\"></i></a>\r\n                <!--<a href=\"#\" class=\"btn btn-sm btn-primary\" ng-disabled=\"true\"><i class=\"fa fa-history\"></i></a>-->\r\n                <button ng-if=\"$ctrl.hook.openSendAttachmentModal\" ng-disabled=\"asset.contentType == 'text/html'\" class=\"btn btn-sm btn-primary btn-ms-action\" ng-click=\"$ctrl.openSendAttachmentModal(asset)\"><i class=\"fa fa-fw fa-envelope\"></i> Send</button>\r\n                &nbsp;\r\n                <a href=\"#\" class=\"text-danger\" ng-click=\"$ctrl.removeAsset($index)\" title=\"Delete Attachment\"><i class=\"fa fa-trash\"></i></a>\r\n            </td>\r\n        </tr>\r\n        </tbody>\r\n    </table>\r\n</div>\r\n\r\n<h5 ng-hide=\"$ctrl.attachments.length\">No attachments available</h5>\r\n"

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var editPropertyContactsComponent = exports.editPropertyContactsComponent = function () {
	  editPropertyContactsComponent.$inject = ['ContactService', '$uibModal'];
	  function editPropertyContactsComponent(ContactService, $uibModal) {
	    'ngInject';
	
	    var _this2 = this;
	
	    _classCallCheck(this, editPropertyContactsComponent);
	
	    this.$onInit = function () {
	      var _this = this;
	
	      this.config = this.resolve.config;
	
	      if (this.config.hasOwnProperty("contacts")) {
	        var contacts = angular.copy(this.config.contacts);
	
	        contacts.forEach(function (contactEntry) {
	          if (contactEntry.contact) contactEntry.contact = contactEntry.contact._id;
	
	          if (contactEntry.from) contactEntry.from = new Date(contactEntry.from);
	
	          if (contactEntry.till) contactEntry.till = new Date(contactEntry.till);
	        });
	
	        this.contactEntries = contacts;
	
	        if (this.config.hasOwnProperty("contactTypes")) {
	          var contactTypes = [];
	          Object.keys(this.config.contactTypes).forEach(function (type) {
	            contactTypes.push({
	              value: type,
	              name: _this.config.contactTypes[type]
	            });
	          });
	          this.contactTypes = contactTypes;
	        }
	      }
	    };
	
	    this.$uibModal = $uibModal;
	    this.contactTypes = [{
	      value: "primary-owner",
	      name: "Primary Owner"
	    }, {
	      value: "owner",
	      name: "Owner"
	    }, {
	      value: "previous-owner",
	      name: "Previous Owner"
	    }, {
	      value: "renter",
	      name: "Renter"
	    }, {
	      value: "visitor",
	      name: "Visitor"
	    }];
	
	    ContactService.query(function (data) {
	      _this2.contacts = data.map(function (contact) {
	        return {
	          value: contact._id,
	          name: _this2.getComposedName(contact)
	        };
	      });
	    });
	  }
	
	  _createClass(editPropertyContactsComponent, [{
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += " (" + contact.company + ")";
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'contactLookup',
	    value: function contactLookup(contact) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'contactLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (contactEntry) {
	        contact.contact = contactEntry._id;
	      }, function () {});
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.contactEntries });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }, {
	    key: 'remove',
	    value: function remove(idx) {
	      this.contactEntries.splice(idx, 1);
	    }
	  }, {
	    key: 'openDatePopup',
	    value: function openDatePopup(contcat, ctx) {
	      if (ctx == 'from') contcat.fromOpened = true;else contcat.tillOpened = true;
	    }
	  }]);
	
	  return editPropertyContactsComponent;
	}();
	
	exports.default = angular.module('conduuApp.editPropertyContacts', []).component('editPropertyContacts', {
	  template: __webpack_require__(634),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: editPropertyContactsComponent
	}).name;

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">Edit Contacts and Dates</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n\n    <table style=\"width:100%;\" class=\"table\">\n        <thead>\n        <tr>\n            <th>Contact</th>\n            <th>Type</th>\n            <th>From</th>\n            <th>Till</th>\n            <th></th>\n            <th></th>\n        </tr>\n        </thead>\n        <tbody ui-sortable ng-model=\"$ctrl.contactEntries\">\n        <tr ng-repeat=\"contactEntry in $ctrl.contactEntries\" style=\"cursor: move;\">\n            <td>\n                <div class=\"input-group\" style=\"max-width: 260px\">\n                    <select class=\"form-control\" ng-options=\"o.value as o.name for o in $ctrl.contacts\" ng-model=\"contactEntry.contact\"\n                            style=\"display: inline-block; width: auto; max-width: 260px\"></select>\n                    <span class=\"input-group-btn\">\n                      <a class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.contactLookup(contactEntry)\"><i class=\"fa fa-fw fa-search\"></i></a>\n                    </span>\n                </div>\n            </td>\n            <td>\n                <select class=\"form-control\" ng-options=\"o.value as o.name for o in $ctrl.contactTypes\" ng-model=\"contactEntry.type\"></select>\n            </td>\n            <td>\n                <div class=\"input-group\" style=\"max-width: 130px\">\n                    <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"shortDate\" ng-model=\"contactEntry.from\" is-open=\"contactEntry.fromOpened\"\n                           ng-required=\"true\" close-text=\"Close\" style=\"max-width: 130px\" />\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.openDatePopup(contactEntry,'from')\"><i class=\"fa fa-fw fa-calendar\"></i></button>\n                    </span>\n                </div>\n            </td>\n            <td>\n                <div class=\"input-group\" style=\"max-width: 130px\">\n                    <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"shortDate\" ng-model=\"contactEntry.till\" is-open=\"contactEntry.tillOpened\"\n                           ng-required=\"true\" close-text=\"Close\" style=\"max-width: 130px\"/>\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.openDatePopup(contactEntry,'till')\"><i class=\"fa fa-fw fa-calendar\"></i></button>\n                    </span>\n                </div>\n            </td>\n            <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"$ctrl.remove($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\n            <td style=\"cursor: move; width:16px\">\n                <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" type=\"submit\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\n    <a class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\">Cancel</a>\n</div>\n"

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var addPropertyContactComponent = exports.addPropertyContactComponent = function () {
	  addPropertyContactComponent.$inject = ['ContactService', '$uibModal', 'SettingsService'];
	  function addPropertyContactComponent(ContactService, $uibModal, SettingsService) {
	    'ngInject';
	
	    var _this2 = this;
	
	    _classCallCheck(this, addPropertyContactComponent);
	
	    this.$onInit = function () {
	      var _this = this;
	
	      this.config = this.resolve.config;
	      this.contactEntry = {
	        type: this.config.type || 'owner'
	      };
	
	      if (this.config.hasOwnProperty("contactTypes")) {
	        var contactTypes = [];
	        Object.keys(this.config.contactTypes).forEach(function (type) {
	          contactTypes.push({
	            value: type,
	            name: _this.config.contactTypes[type]
	          });
	        });
	        this.contactTypes = contactTypes;
	      }
	    };
	
	    this.$uibModal = $uibModal;
	    this.ContactService = ContactService;
	
	    var states_us = ["AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV", "WI", "WY"];
	    var states_can = ["AB", "BC", "MB", "NB", "NL", "NT", "NS", "NU", "ON", "PE", "QC", "SK", "YT"];
	
	    this.states = [].concat(states_us.map(function (state) {
	      return { country: 'United States', state: state };
	    }), states_can.map(function (state) {
	      return { country: 'Canada', state: state };
	    }), [{ country: 'Other', state: 'XX' }]);
	
	    SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	      _this2.phoneTypes = appSettings.data.phoneTypes;
	      _this2.mailTypes = appSettings.data.mailTypes;
	      _this2.addressTypes = appSettings.data.addressTypes;
	      _this2.socialTypes = appSettings.data.socialTypes;
	
	      _this2.contact = {
	        phone: [{
	          type: _this2.phoneTypes[0],
	          isPrimary: true
	        }],
	        address: [{
	          type: _this2.addressTypes[0],
	          isPrimary: true
	        }],
	        email: [{
	          type: _this2.mailTypes[0],
	          isPrimary: true
	        }]
	      };
	    });
	
	    this.contactTypes = [{
	      value: "primary-owner",
	      name: "Primary Owner"
	    }, {
	      value: "owner",
	      name: "Owner"
	    }, {
	      value: "previous-owner",
	      name: "Previous Owner"
	    }, {
	      value: "renter",
	      name: "Renter"
	    }, {
	      value: "visitor",
	      name: "Visitor"
	    }];
	
	    ContactService.query(function (data) {
	      _this2.contacts = data.map(function (contact) {
	        return {
	          value: contact._id,
	          name: _this2.getComposedName(contact)
	        };
	      });
	    });
	  }
	
	  _createClass(addPropertyContactComponent, [{
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += " (" + contact.company + ")";
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'contactLookup',
	    value: function contactLookup(contact) {
	      var _this3 = this;
	
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'contactLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (contact) {
	        _this3.contactEntry.contact = contact._id;
	      }, function () {});
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this4 = this;
	
	      if (this.activeTab == 1) {
	        if (!this.contact.phone[0].number) delete this.contact.phone;
	
	        if (!this.contact.email[0].address) delete this.contact.email;
	
	        if (!this.contact.address[0].street && !this.contact.address[0].city) delete this.contact.address;
	
	        this.ContactService.save(this.contact, function (newContact) {
	          _this4.contactEntry.contact = newContact._id;
	          _this4.close({ $value: _this4.contactEntry });
	        }, function (_) {
	          console.log("There has been an error trying to create a new owner as contact");
	        });
	      } else {
	        this.close({ $value: this.contactEntry });
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }, {
	    key: 'openDatePopup',
	    value: function openDatePopup(ctx) {
	      if (ctx == 'from') this.fromOpened = true;else this.tillOpened = true;
	    }
	  }]);
	
	  return addPropertyContactComponent;
	}();
	
	exports.default = angular.module('conduuApp.addPropertyContact', []).component('addPropertyContact', {
	  template: __webpack_require__(636),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: addPropertyContactComponent
	}).name;

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	module.exports = "\r\n<div class=\"modal-header\">\r\n    <h3 class=\"modal-title\" id=\"modal-title\">Add Contact</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n\r\n    <form class=\"form\" name=\"form\" ng-submit=\"$ctrl.create(form)\" novalidate>\r\n\r\n        <div class=\"col-xs-4\" style=\"padding-left:0\">\r\n            <div class=\"form-group\">\r\n                <label>Contact Type</label>\r\n                <br/>\r\n\r\n                <select class=\"form-control\" ng-options=\"o.value as o.name for o in $ctrl.contactTypes\" ng-model=\"$ctrl.contactEntry.type\"></select>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"col-xs-4\" style=\"padding:0\">\r\n            <div class=\"form-group\">\r\n                <label>From</label>\r\n                <br/>\r\n\r\n                <div class=\"input-group\">\r\n                <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"$ctrl.contactEntry.from\" is-open=\"$ctrl.fromOpened\"\r\n                       ng-required=\"true\" close-text=\"Close\" />\r\n                <span class=\"input-group-btn\">\r\n                <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.openDatePopup('from')\"><i class=\"fa fa-fw fa-calendar\"></i></button>\r\n            </span>\r\n            </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"col-xs-4\" style=\"padding-right:0\">\r\n            <div class=\"form-group\">\r\n                <label>Till</label>\r\n                <br/>\r\n                <div class=\"input-group\">\r\n                <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"$ctrl.contactEntry.till\" is-open=\"$ctrl.tillOpened\"\r\n                       ng-required=\"true\" close-text=\"Close\" />\r\n                <span class=\"input-group-btn\">\r\n                <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.openDatePopup('till')\"><i class=\"fa fa-fw fa-calendar\"></i></button>\r\n            </span>\r\n            </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div style=\"clear:both\"></div>\r\n        \r\n        <br/>\r\n\r\n        <uib-tabset active=\"$ctrl.activeTab\">\r\n            <uib-tab index=\"0\" heading=\"Existing Contact\">\r\n                <br/>\r\n                <!-- Contact -->\r\n                <div class=\"form-group\">\r\n                    <label>Contact</label>\r\n                    <br/>\r\n\r\n                    <div class=\"input-group\" style=\"display: inline-block\">\r\n                        <select class=\"form-control\" ng-options=\"o.value as o.name for o in $ctrl.contacts\" ng-model=\"$ctrl.contactEntry.contact\"\r\n                                style=\"display: inline-block; width: auto\"></select>\r\n                        <span class=\"input-group-btn\">\r\n                          <a class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.contactLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                          <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.contactEntry.contact\" ng-click=\"$ctrl.contactEntry.contact = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n                        </span>\r\n                    </div>\r\n                </div>\r\n            </uib-tab>\r\n            <uib-tab index=\"1\" heading=\"New Contact\">\r\n                <br/>\r\n\r\n                <div class=\"col-sm-4\" style=\"padding:0px\">\r\n                    <!-- First Name -->\r\n                    <div class=\"form-group\" ng-class=\"{ 'has-success': form.firstName.$valid && ctrl.submitted,\r\n                                            'has-error': form.firstName.$invalid && ctrl.submitted }\">\r\n                        <label>First Name</label>\r\n\r\n                        <input type=\"text\" name=\"firstName\" class=\"form-control\" ng-model=\"$ctrl.contact.firstName\" />\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-4\" style=\"padding-right:0px\">\r\n                    <!-- Middle Name -->\r\n                    <div class=\"form-group\"  ng-class=\"{ 'has-success': form.middleName.$valid & $ctrl.submitted,\r\n                                            'has-error': form.middleName.$invalid && ctrl.submitted }\">\r\n                        <label>Middle Name</label>\r\n\r\n                        <input type=\"text\" name=\"middleName\" class=\"form-control\" ng-model=\"$ctrl.contact.middleName\" />\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-4\" style=\"padding-right:0px\">\r\n                    <!-- Last Name -->\r\n                    <div class=\"form-group\" ng-class=\"{ 'has-success': form.lastName.$valid && ctrl.submitted,\r\n                                            'has-error': form.lastName.$invalid && ctrl.submitted }\">\r\n                        <label>Last Name</label>\r\n\r\n                        <input type=\"text\" name=\"lastName\" class=\"form-control\" ng-model=\"$ctrl.contact.lastName\" />\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-12\" style=\"padding-left:0px; padding-right:0px\">\r\n                    <!-- Last Name -->\r\n                    <div class=\"form-group\" ng-class=\"{ 'has-success': form.company.$valid && ctrl.submitted,\r\n                                            'has-error': form.company.$invalid && ctrl.submitted }\">\r\n                        <label>Company / Trust</label>\r\n\r\n                        <input type=\"text\" name=\"company\" class=\"form-control\" ng-model=\"$ctrl.contact.company\" />\r\n                    </div>\r\n                </div>\r\n\r\n                <div style=\"clear:both\"></div>\r\n\r\n                <h4 class=\"separator\"><span>Primary Phone</span></h4>\r\n\r\n                <div class=\"col-sm-4\" style=\"padding:0px\">\r\n                    <div class=\"form-group\">\r\n                        <label>Type</label>\r\n\r\n                        <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.phoneTypes\" ng-model=\"$ctrl.contact.phone[0].type\"></select>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-8\" style=\"padding:0px\">\r\n                    <div class=\"form-group\">\r\n                        <label>Number</label>\r\n\r\n                        <input class=\"form-control\" type=\"text\" ui-mask=\"(?9?9?9) ?9?9?9-?9?9?9?9\" ng-model=\"$ctrl.contact.phone[0].number\" />\r\n                    </div>\r\n                </div>\r\n\r\n                <div style=\"clear:both\"></div>\r\n\r\n                <h4 class=\"separator\"><span>Primary Email</span></h4>\r\n\r\n                <div class=\"col-sm-4\" style=\"padding:0px\">\r\n                    <div class=\"form-group\">\r\n                        <label>Type</label>\r\n\r\n                        <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.mailTypes\" ng-model=\"$ctrl.contact.email[0].type\"></select>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-8\" style=\"padding:0px\">\r\n                    <div class=\"form-group\">\r\n                        <label>Email</label>\r\n\r\n                        <input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.contact.email[0].address\" />\r\n                    </div>\r\n                </div>\r\n\r\n                <div style=\"clear:both\"></div>\r\n                \r\n                <h4 class=\"separator\"><span>Primary Address</span></h4>\r\n\r\n                <div>\r\n                    <div class=\"form-group\">\r\n                        <label>Type</label>\r\n\r\n                        <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.addressTypes\" ng-model=\"$ctrl.contact.address[0].type\"></select>\r\n                    </div>\r\n                </div>\r\n\r\n                <!-- Address: Street -->\r\n                <div class=\"form-group\">\r\n                    <label>Street</label>\r\n\r\n                    <input type=\"text\" name=\"street\" class=\"form-control\" ng-model=\"$ctrl.contact.address[0].street\" />\r\n                </div>\r\n\r\n                <!-- Address: Street 2 -->\r\n                <div class=\"form-group\">\r\n                    <label>Address Line 2</label>\r\n\r\n                    <input type=\"text\" name=\"street2\" class=\"form-control\" ng-model=\"$ctrl.contact.address[0].street2\" />\r\n                </div>\r\n\r\n                <div class=\"col-sm-6\" style=\"padding-left:0px\">\r\n                    <!-- Address: City -->\r\n                    <div class=\"form-group\">\r\n                        <label>City</label>\r\n\r\n                        <input type=\"text\" name=\"city\" class=\"form-control\" ng-model=\"$ctrl.contact.address[0].city\" />\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-4\" style=\"padding:0px\">\r\n                    <!-- Address: State -->\r\n                    <div class=\"form-group\">\r\n                        <label>State</label>\r\n\r\n                        <select class=\"form-control\" ng-options=\"o.state as o.state group by o.country for o in $ctrl.states\" ng-model=\"$ctrl.contact.address[0].state\"></select>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-2\" style=\"padding-right:0px\">\r\n                    <!-- Address: ZIP -->\r\n                    <div class=\"form-group\">\r\n                        <label>ZIP</label>\r\n\r\n                        <input type=\"text\" name=\"zip\" class=\"form-control\" ng-model=\"$ctrl.contact.address[0].zip\" />\r\n                    </div>\r\n                </div>\r\n\r\n                <!-- Address: Country -->\r\n                <div class=\"form-group\">\r\n                    <label>Country</label>\r\n\r\n                    <input type=\"text\" name=\"country\" class=\"form-control\" ng-model=\"$ctrl.contact.address[0].country\" />\r\n                </div>\r\n\r\n            </uib-tab>\r\n        </uib-tabset>\r\n\r\n    </form>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n    <button class=\"btn btn-primary\" type=\"submit\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\r\n    <a class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\">Cancel</a>\r\n</div>\r\n"

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usPhoneFilter = usPhoneFilter;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function usPhoneFilter() {
	  return function (tel) {
	    if (!tel) {
	      return '';
	    }
	
	    var value = tel.toString().trim().replace(/^\+/, '');
	
	    if (value.match(/[^0-9]/)) {
	      return tel;
	    }
	
	    var country, city, number;
	
	    switch (value.length) {
	      case 10:
	        country = 1;
	        city = value.slice(0, 3);
	        number = value.slice(3);
	        break;
	
	      case 11:
	        country = value[0];
	        city = value.slice(1, 4);
	        number = value.slice(4);
	        break;
	
	      case 12:
	        country = value.slice(0, 3);
	        city = value.slice(3, 5);
	        number = value.slice(5);
	        break;
	
	      default:
	        return tel;
	    }
	
	    if (country == 1) {
	      country = "";
	    }
	
	    number = number.slice(0, 3) + '-' + number.slice(3);
	
	    return (country + " (" + city + ") " + number).trim();
	  };
	}
	
	exports.default = angular.module('conduuApp.usPhone', []).filter('usPhone', usPhoneFilter).name;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var workOrderShowComponent = exports.workOrderShowComponent = function () {
	  /*@ngInject*/
	  workOrderShowComponent.$inject = ['dialogs', 'CalendarEventService', '$timeout'];
	  function workOrderShowComponent(dialogs, CalendarEventService, $timeout) {
	    _classCallCheck(this, workOrderShowComponent);
	
	    this.dialogs = dialogs;
	    this.CalendarEventService = CalendarEventService;
	    this.$timeout = $timeout;
	  }
	
	  _createClass(workOrderShowComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.workOrder = this.resolve.config.workOrder;
	      this.userHasPermission = this.resolve.config.userHasPermission;
	
	      this.galleryImages = this.workOrder.attachments.filter(function (attachment) {
	        return _this.isImageMime(attachment.contentType);
	      });
	
	      this.galleryImages = this.galleryImages.map(function (obj) {
	        var rObj = {};
	
	        rObj.title = obj.filename;
	        rObj.alt = obj.filename;
	        rObj.url = "/api/storage/" + obj._id;
	        rObj.thumbUrl = '/api/storage/' + obj._id + '/thumb';
	
	        return rObj;
	      });
	    }
	  }, {
	    key: 'countPdfAttachments',
	    value: function countPdfAttachments(attachs) {
	      var _this2 = this;
	
	      return attachs.reduce(function (acc, obj) {
	        return acc + _this2.isPdfMime(obj.contentType);
	      }, 0);
	    }
	  }, {
	    key: 'isImageMime',
	    value: function isImageMime(mime) {
	      return mime.startsWith('image/');
	    }
	  }, {
	    key: 'isPdfMime',
	    value: function isPdfMime(mime) {
	      return mime === 'application/pdf';
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return workOrderShowComponent;
	}();
	
	exports.default = angular.module('conduuApp.workOrderShow', []).component('workOrderShow', {
	  template: __webpack_require__(639),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: workOrderShowComponent
	}).name;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\">\r\n    {{$ctrl.workOrder.code}}: {{$ctrl.workOrder.name}}\r\n    <small>\r\n      <span ng-show=\"$ctrl.workOrder.targetDate\">{{$ctrl.workOrder.targetDate | date:\"MMM d, y 'all day'\"}}</span>\r\n    </small>\r\n  </h3>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <dl class=\"dl-horizontal bs-callout bs-callout-warning\" style=\"margin:0\">\r\n    <dt>Community</dt>\r\n    <dd>{{$ctrl.workOrder.community.code || $ctrl.workOrder.property.community.code}}: {{$ctrl.workOrder.community.name || $ctrl.workOrder.property.community.name}}</dd>\r\n\r\n    <dt>Property</dt>\r\n    <dd>\r\n      <span ng-if=\"$ctrl.workOrder.property\">{{$ctrl.workOrder.property.address.street}}, {{$ctrl.workOrder.property.address.city}} {{$ctrl.workOrder.property.address.state}}, {{$ctrl.workOrder.property.address.zip}}</span>\r\n      <span ng-if=\"!$ctrl.workOrder.property\">-</span>\r\n    </dd>\r\n\r\n    <dt>Target Date</dt>\r\n    <dd>{{$ctrl.workOrder.targetDate | date:'yyyy-MM-dd'}}</dd>\r\n\r\n    <dt>Approved By</dt>\r\n    <dd>\r\n      <span ng-if=\"$ctrl.workOrder.approvedBy\">{{$ctrl.workOrder.approvedBy.firstName}} {{$ctrl.workOrder.approvedBy.middleName || ''}} {{$ctrl.workOrder.approvedBy.lastName}}</span>\r\n      <span ng-if=\"!$ctrl.workOrder.approvedBy\">-</span>\r\n    </dd>\r\n\r\n    <dt>Issued To</dt>\r\n    <dd>\r\n      <span ng-if=\"$ctrl.workOrder.issuedTo\">{{$ctrl.workOrder.issuedTo.name}}</span>\r\n      <span ng-if=\"!$ctrl.workOrder.issuedTo\">-</span>\r\n    </dd>\r\n  </dl>\r\n\r\n  <hr/>\r\n\r\n  <h4>Description</h4>\r\n  <span ng-show=\"$ctrl.workOrder.description\" ng-bind-html=\"$ctrl.workOrder.description\"></span>\r\n  <span ng-hide=\"$ctrl.workOrder.description\"><em>No description available</em></span>\r\n\r\n  <h4>Instructions</h4>\r\n  <span ng-show=\"$ctrl.workOrder.instructions\" ng-bind-html=\"$ctrl.workOrder.instructions\"></span>\r\n  <span ng-hide=\"$ctrl.workOrder.instructions\"><em>No instructions available</em></span>\r\n\r\n  <div ng-show=\"$ctrl.countPdfAttachments($ctrl.workOrder.attachments)\">\r\n    <hr />\r\n    <h5><i class=\"fa fa-fw fa-file-pdf-o\"></i> Attachments</h5>\r\n\r\n    <!-- PDFs are embedded in the doc -->\r\n    <div class=\"row\">\r\n      <div ng-repeat=\"attachment in $ctrl.workOrder.attachments\" ng-show=\"$ctrl.isPdfMime(attachment.contentType)\"\r\n           class=\"col-xs-6\" style=\"overflow:hidden; padding:12px; margin:0px;\">\r\n        <a ng-if=\"$ctrl.isPdfMime(attachment.contentType)\" title=\"{{attachment.filename}}\"\r\n           ng-href=\"/api/storage/{{attachment._id}}\" target=\"_blank\" style=\"cursor: pointer\">\r\n          <i class=\"fa fa-fw fa-file-pdf-o fa-3x\" style=\"float:left\"></i>\r\n          <em>{{attachment.filename}}</em>\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <!-- Than we have the image gallery in left hand side of the footer -->\r\n  <div ng-show=\"$ctrl.galleryImages.length\" style=\"float:left;\">\r\n      <ng-image-gallery images=\"$ctrl.galleryImages\" style=\"position: absolute;bottom: 12px;\"></ng-image-gallery>\r\n  </div>\r\n\r\n  <!--<button ng-show=\"$ctrl.userHasPermission\" class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.delete()\">Delete</button>-->\r\n\r\n  <a class=\"btn btn-primary\" type=\"button\" ng-href=\"/workorder/ticket/detail/{{$ctrl.workOrder._id}}\" ng-click=\"$ctrl.ok()\">Open</a>\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">Close</button>\r\n\r\n</div>\r\n"

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var violationShowComponent = exports.violationShowComponent = function () {
	  /*@ngInject*/
	  violationShowComponent.$inject = ['dialogs', 'CalendarEventService', '$timeout'];
	  function violationShowComponent(dialogs, CalendarEventService, $timeout) {
	    _classCallCheck(this, violationShowComponent);
	
	    this.dialogs = dialogs;
	    this.CalendarEventService = CalendarEventService;
	    this.$timeout = $timeout;
	  }
	
	  _createClass(violationShowComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.violation = this.resolve.config.violation;
	      this.level = this.resolve.config.level;
	
	      this.levelDate = new Date(this.resolve.config.levelDate);
	      this.userHasPermission = this.resolve.config.userHasPermission;
	
	      this.galleryImages = this.violation.attachments.filter(function (attachment) {
	        return _this.isImageMime(attachment.contentType);
	      });
	
	      this.galleryImages = this.galleryImages.map(function (obj) {
	        var rObj = {};
	
	        rObj.title = obj.filename;
	        rObj.alt = obj.filename;
	        rObj.url = "/api/storage/" + obj._id;
	        rObj.thumbUrl = '/api/storage/' + obj._id + '/thumb';
	
	        return rObj;
	      });
	    }
	  }, {
	    key: 'countPdfAttachments',
	    value: function countPdfAttachments(attachs) {
	      var _this2 = this;
	
	      return attachs.reduce(function (acc, obj) {
	        return acc + _this2.isPdfMime(obj.contentType);
	      }, 0);
	    }
	  }, {
	    key: 'isImageMime',
	    value: function isImageMime(mime) {
	      return mime.startsWith('image/');
	    }
	  }, {
	    key: 'isPdfMime',
	    value: function isPdfMime(mime) {
	      return mime === 'application/pdf';
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return violationShowComponent;
	}();
	
	exports.default = angular.module('conduuApp.violationShow', []).component('violationShow', {
	  template: __webpack_require__(641),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: violationShowComponent
	}).name;

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\">\r\n    {{$ctrl.violation.code}}: {{$ctrl.violation.name}}\r\n    <small>\r\n      <span>{{$ctrl.levelDate | date:\"MMM d, y 'all day'\"}}</span>\r\n    </small>\r\n  </h3>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <dl class=\"dl-horizontal bs-callout bs-callout-danger\" style=\"margin:0\">\r\n    <dt>Community</dt>\r\n    <dd>{{$ctrl.violation.property.community.code}}: {{$ctrl.violation.property.community.name}}</dd>\r\n\r\n    <dt>Property</dt>\r\n    <dd>\r\n      <span ng-if=\"$ctrl.violation.property\">{{$ctrl.violation.property.address.street}}, {{$ctrl.violation.property.address.city}} {{$ctrl.violation.property.address.state}}, {{$ctrl.violation.property.address.zip}}</span>\r\n      <span ng-if=\"!$ctrl.violation.property\">-</span>\r\n    </dd>\r\n\r\n    <br/>\r\n\r\n    <dt>Level</dt>\r\n    <dd>{{$ctrl.level.level}}</dd>\r\n\r\n    <dt>Level Due Date</dt>\r\n    <dd>{{$ctrl.levelDate | date:'yyyy-MM-dd'}}</dd>\r\n  </dl>\r\n\r\n  <hr/>\r\n\r\n  <h4>Description</h4>\r\n  <span ng-show=\"$ctrl.violation.description\" ng-bind-html=\"$ctrl.violation.description\"></span>\r\n  <span ng-hide=\"$ctrl.violation.description\"><em>No description available</em></span>\r\n\r\n  <h4>Article</h4>\r\n  <span ng-show=\"$ctrl.violation.article\" ng-bind-html=\"$ctrl.violation.article\"></span>\r\n  <span ng-hide=\"$ctrl.violation.article\"><em>No instructions available</em></span>\r\n\r\n  <h4>Action to Resolve</h4>\r\n  <span ng-show=\"$ctrl.violation.resolveBy\" ng-bind-html=\"$ctrl.violation.resolveBy\"></span>\r\n  <span ng-hide=\"$ctrl.violation.resolveBy\"><em>No instructions available</em></span>\r\n\r\n  <div ng-show=\"$ctrl.countPdfAttachments($ctrl.violation.attachments)\">\r\n    <hr />\r\n    <h5><i class=\"fa fa-fw fa-file-pdf-o\"></i> Attachments</h5>\r\n\r\n    <!-- PDFs are embedded in the doc -->\r\n    <div class=\"row\">\r\n      <div ng-repeat=\"attachment in $ctrl.violation.attachments\" ng-show=\"$ctrl.isPdfMime(attachment.contentType)\"\r\n           class=\"col-xs-6\" style=\"overflow:hidden; padding:12px; margin:0px;\">\r\n        <a ng-if=\"$ctrl.isPdfMime(attachment.contentType)\" title=\"{{attachment.filename}}\"\r\n           ng-href=\"/api/storage/{{attachment._id}}\" target=\"_blank\" style=\"cursor: pointer\">\r\n          <i class=\"fa fa-fw fa-file-pdf-o fa-3x\" style=\"float:left\"></i>\r\n          <em>{{attachment.filename}}</em>\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <!-- Than we have the image gallery in left hand side of the footer -->\r\n  <div ng-show=\"$ctrl.galleryImages.length\" style=\"float:left;\">\r\n      <ng-image-gallery images=\"$ctrl.galleryImages\" style=\"position: absolute;bottom: 12px;\"></ng-image-gallery>\r\n  </div>\r\n\r\n  <!--<button ng-show=\"$ctrl.userHasPermission\" class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.delete()\">Delete</button>-->\r\n\r\n  <a class=\"btn btn-primary\" type=\"button\" ng-href=\"/violation/ticket/detail/{{$ctrl.violation._id}}\" ng-click=\"$ctrl.ok()\">Open</a>\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">Close</button>\r\n\r\n</div>\r\n"

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var stateChangeFormComponent = exports.stateChangeFormComponent = function () {
	  /*@ngInject*/
	  function stateChangeFormComponent() {
	    _classCallCheck(this, stateChangeFormComponent);
	
	    this.$onInit = function () {};
	
	    this.statusEnum = ["open", "closed"];
	  }
	
	  _createClass(stateChangeFormComponent, [{
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: {
	          status: this.status,
	          reason: this.reason
	        } });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return stateChangeFormComponent;
	}();
	
	exports.default = angular.module('conduu.stateChangeForm', []).component('stateChangeForm', {
	  template: __webpack_require__(643),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: stateChangeFormComponent
	}).name;

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">Status Change</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <!-- Status -->\r\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.status.$valid && ctrl.submitted,\r\n                                        'has-error': form.status.$invalid && ctrl.submitted }\">\r\n    <label>Status</label>\r\n    <br/>\r\n\r\n    <div class=\"input-group\" style=\"display: inline-block\">\r\n      <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.statusEnum\" ng-model=\"$ctrl.status\"\r\n              style=\"display: inline-block; width: auto; min-width:180px\"></select>\r\n    </div>\r\n  </div>\r\n  <!-- Reason -->\r\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.reason.$valid && $ctrl.submitted,\r\n                                        'has-error': form.reason.$invalid && $ctrl.submitted }\">\r\n    <label>Reason</label>\r\n    <br/>\r\n\r\n    <div class=\"input-group\" style=\"width:100%\">\r\n      <textarea class=\"form-control\" style=\"width:100%\" rows=\"4\" ng-model=\"$ctrl.reason\"></textarea>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!$ctrl.status\" ng-click=\"$ctrl.ok()\">Change Status</button>\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RoleEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _roleEdit = __webpack_require__(645);
	
	var _roleEdit2 = _interopRequireDefault(_roleEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var RoleEditComponent = exports.RoleEditComponent = function () {
	  RoleEditComponent.$inject = ['SettingsService', 'Auth', '$state', '$stateParams', 'dialogs', '$uibModal'];
	  function RoleEditComponent(SettingsService, Auth, $state, $stateParams, dialogs, $uibModal) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, RoleEditComponent);
	
	    this.SettingsService = SettingsService;
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.modules = ["community", "property", "owner", "vendor", "violation", "work-order", "task", "service-request"];
	
	    SettingsService.getByName({ name: 'roles-and-permissions' }, function (settings) {
	      _this.settings = settings;
	
	      _this.rolesData = _this.settings.data;
	      _this.roles = Object.keys(_this.rolesData);
	      _this.data = _this.rolesData[_this.roles[0]];
	    });
	  }
	
	  _createClass(RoleEditComponent, [{
	    key: 'switchData',
	    value: function switchData(role) {
	      this.data = this.rolesData[role];
	    }
	  }, {
	    key: 'getPathByResourceAndPermType',
	    value: function getPathByResourceAndPermType(resource, permType) {
	      switch (permType) {
	        case 'community':
	
	          switch (resource) {
	            case 'violation':
	            case 'work-order':
	              return "property.community.code";
	            case 'property':
	              return 'community.code';
	            case 'community':
	              return 'code';
	            default:
	              return '';
	          }
	
	        default:
	          return '';
	      }
	    }
	  }, {
	    key: 'permissionEdit',
	    value: function permissionEdit(module) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'permissionEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: that.data[module]
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (permissions) {
	
	        that.data[module] = permissions;
	      }, function () {});
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      var onSuccess = function onSuccess() {
	        var dlg = _this2.dialogs.notify("Success", "The roles and permissions gave been saved successfully");
	        dlg.result.then(function () {});
	      };
	
	      var onError = function onError(err) {
	        var dlg = _this2.dialogs.error("Error", "There has been an error trying to save the roles and permissions:<br/>" + err.toString());
	        console.log(err);
	      };
	
	      this.SettingsService.update({ id: this.settings._id }, this.settings, onSuccess, onError);
	    }
	  }]);
	
	  return RoleEditComponent;
	}();
	
	exports.default = angular.module('conduu.roleEdit', [uiRouter]).config(_roleEdit2.default).component('roleEdit', {
	  template: __webpack_require__(646),
	  controller: RoleEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('role-edit', {
	    url: '/admin/roles/edit',
	    template: '<role-edit></role-edit>',
	    authenticate: 'suite-superadmin'
	  });
	}];

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <h1>Role and Permission Editor</h1>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n\r\n      <uib-tabset active=\"ctrl.active\">\r\n\r\n        <uib-tab index=\"$index\" ng-repeat=\"role in ctrl.roles\" heading=\"{{role}}\" select=\"ctrl.switchData(role)\" style=\"padding-top: 8px;\">\r\n          <form class=\"form\" name=\"form\" novalidate>\r\n\r\n            <div ng-repeat=\"module in ctrl.modules\" class=\"col-lg-6\">\r\n              <h3 class=\"separator\"><span class=\"text-capitalize\">{{module}} <small><a href=\"#\" ng-click=\"ctrl.permissionEdit(module)\"><i class=\"fa fa-fw fa-pencil\"></i> Edit Permissions</a></small></span></h3>\r\n\r\n              <table class=\"table\">\r\n                <thead>\r\n                <tr>\r\n                  <th style=\"width:15%\">Action</th>\r\n                  <th>Permissions</th>\r\n                </tr>\r\n                </thead>\r\n                <tbody>\r\n                <tr>\r\n                  <td><nobr><i class=\"fa fa-fw fa-plus text-muted\"></i> Create</nobr></td>\r\n                  <td>\r\n                <span ng-repeat=\"permission in ctrl.data[module].create\">\r\n                  <span ng-if=\"permission == 'all'\" class=\"label label-success\">All</span>\r\n                  <span ng-if=\"permission == 'own'\" class=\"label label-info\">Own</span>\r\n                  <span ng-if=\"permission.startsWith('community')\" class=\"label label-primary text-capitalize\">{{permission}}</span>\r\n                </span>\r\n                    <span ng-if=\"!ctrl.data[module].create.length\" class=\"label label-default\">None</span>\r\n                  </td>\r\n                </tr>\r\n\r\n                <tr>\r\n                  <td><nobr><i class=\"fa fa-fw fa-book text-muted\"></i> Read</nobr></td>\r\n                  <td>\r\n                <span ng-repeat=\"permission in ctrl.data[module].read\">\r\n                  <span ng-if=\"permission == 'all'\" class=\"label label-success\">All</span>\r\n                  <span ng-if=\"permission == 'own'\" class=\"label label-info\">Own</span>\r\n                  <span ng-if=\"permission.startsWith('community')\" class=\"label label-primary text-capitalize\">{{permission}}</span>\r\n                </span>\r\n                    <span ng-if=\"!ctrl.data[module].read.length\" class=\"label label-default\">None</span>\r\n                  </td>\r\n                </tr>\r\n\r\n                <tr>\r\n                  <td><nobr><i class=\"fa fa-fw fa-pencil text-muted\"></i> Update</nobr></td>\r\n                  <td>\r\n                <span ng-repeat=\"permission in ctrl.data[module].update\">\r\n                  <span ng-if=\"permission == 'all'\" class=\"label label-success\">All</span>\r\n                  <span ng-if=\"permission == 'own'\" class=\"label label-info\">Own</span>\r\n                  <span ng-if=\"permission.startsWith('community')\" class=\"label label-primary text-capitalize\">{{permission}}</span>\r\n                </span>\r\n                    <span ng-if=\"!ctrl.data[module].update.length\" class=\"label label-default\">None</span>\r\n                  </td>\r\n                </tr>\r\n                <tr>\r\n                  <td><nobr><i class=\"fa fa-fw fa-trash text-muted\"></i> Delete</nobr></td>\r\n                  <td>\r\n                <span ng-repeat=\"permission in ctrl.data[module].delete\">\r\n                  <span ng-if=\"permission == 'all'\" class=\"label label-success\">All</span>\r\n                  <span ng-if=\"permission == 'own'\" class=\"label label-info\">Own</span>\r\n                  <span ng-if=\"permission.startsWith('community')\" class=\"label label-primary text-capitalize\">{{permission}}</span>\r\n                </span>\r\n                    <span ng-if=\"!ctrl.data[module].delete.length\" class=\"label label-default\">None</span>\r\n                  </td>\r\n                </tr>\r\n                </tbody>\r\n              </table>\r\n            </div>\r\n\r\n          </form>\r\n\r\n        </uib-tab>\r\n      </uib-tabset>\r\n\r\n\r\n      <hr/>\r\n\r\n      <button class=\"btn btn-primary\" ng-click=\"ctrl.save()\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var PermissionEditComponent = exports.PermissionEditComponent = function () {
	  /*@ngInject*/
	  function PermissionEditComponent() {
	    _classCallCheck(this, PermissionEditComponent);
	
	    this.$onInit = function () {
	      var _this = this;
	
	      this.config = this.resolve.config;
	
	      if (this.config.hasOwnProperty("data")) {
	        this.permissions = angular.copy(this.config.data);
	
	        this.readOwn = false;
	        this.updateOwn = false;
	        this.deleteOwn = false;
	
	        this.customCreatePermissions = [];
	        this.customReadPermissions = [];
	        this.customUpdatePermissions = [];
	        this.customDeletePermissions = [];
	
	        this.entityTypes = ["community"];
	        this.entities = {
	          "community": ["DEMO", "SUN"]
	        };
	
	        if (!this.permissions.create.length) {
	          this.createState = "None";
	        } else if (this.permissions.create.indexOf("all") != -1) {
	          this.createState = "All";
	        } else {
	          this.createState = "Custom";
	
	          this.permissions.create.forEach(function (permission) {
	            var parts = permission.split(":");
	            if (parts.length == 2) {
	              _this.customCreatePermissions.push({
	                type: parts[0],
	                entity: parts[1]
	              });
	            }
	          });
	        }
	
	        if (!this.permissions.read.length) {
	          this.readState = "None";
	        } else if (this.permissions.read.indexOf("all") != -1) {
	          this.readState = "All";
	        } else {
	          this.readState = "Custom";
	          this.readOwn = this.permissions.read.indexOf("own") != -1;
	
	          this.permissions.read.forEach(function (permission) {
	            var parts = permission.split(":");
	            if (parts.length == 2) {
	              _this.customReadPermissions.push({
	                type: parts[0],
	                entity: parts[1]
	              });
	            }
	          });
	        }
	
	        if (!this.permissions.update.length) {
	          this.updateState = "None";
	        } else if (this.permissions.update.indexOf("all") != -1) {
	          this.updateState = "All";
	        } else {
	          this.updateState = "Custom";
	          this.editOwn = this.permissions.update.indexOf("own") != -1;
	
	          this.permissions.update.forEach(function (permission) {
	            var parts = permission.split(":");
	            if (parts.length == 2) {
	              _this.customUpdatePermissions.push({
	                type: parts[0],
	                entity: parts[1]
	              });
	            }
	          });
	        }
	
	        if (!this.permissions.delete.length) {
	          this.deleteState = "None";
	        } else if (this.permissions.delete.indexOf("all") != -1) {
	          this.deleteState = "All";
	        } else {
	          this.deleteState = "Custom";
	          this.deleteOwn = this.permissions.delete.indexOf("own") != -1;
	
	          this.permissions.delete.forEach(function (permission) {
	            var parts = permission.split(":");
	            if (parts.length == 2) {
	              _this.customDeletePermissions.push({
	                type: parts[0],
	                entity: parts[1]
	              });
	            }
	          });
	        }
	      }
	    };
	
	    this.permissions = {};
	  }
	
	  _createClass(PermissionEditComponent, [{
	    key: 'addCustom',
	    value: function addCustom(section) {
	
	      var custom = [];
	
	      switch (section) {
	        case "create":
	          custom = this.customCreatePermissions;
	          break;
	        case "read":
	          custom = this.customReadPermissions;
	          break;
	        case "update":
	          custom = this.customUpdatePermissions;
	          break;
	        case "delete":
	          custom = this.customDeletePermissions;
	          break;
	      }
	
	      custom.push({ type: '', entity: '' });
	      this.update(section);
	    }
	  }, {
	    key: 'removeCustom',
	    value: function removeCustom(section, idx) {
	      var custom = [];
	      switch (section) {
	        case "create":
	          custom = this.customCreatePermissions;
	          break;
	        case "read":
	          custom = this.customReadPermissions;
	          break;
	        case "update":
	          custom = this.customUpdatePermissions;
	          break;
	        case "delete":
	          custom = this.customDeletePermissions;
	          break;
	      }
	
	      custom.splice(idx, 1);
	      this.update(section);
	    }
	  }, {
	    key: 'update',
	    value: function update(section) {
	      var _this2 = this;
	
	      var custom = "";
	      var state = "";
	
	      switch (section) {
	        case "create":
	          custom = this.customCreatePermissions;
	          state = this.createState;
	          break;
	        case "read":
	          custom = this.customReadPermissions;
	          state = this.readState;
	          break;
	        case "update":
	          custom = this.customUpdatePermissions;
	          state = this.updateState;
	          break;
	        case "delete":
	          custom = this.customDeletePermissions;
	          state = this.deleteState;
	          break;
	      }
	
	      switch (state) {
	        case 'None':
	          this.permissions[section] = [];
	          break;
	        case 'All':
	          this.permissions[section] = ["all"];
	          break;
	        case 'Custom':
	          this.permissions[section] = [];
	
	          custom.forEach(function (perm) {
	            if (perm.type && perm.entity) {
	              _this2.permissions[section].push(perm.type + ":" + perm.entity);
	            }
	          });
	
	          if (this[section + "Own"]) this.permissions[section].push("own");
	          break;
	      }
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.permissions });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return PermissionEditComponent;
	}();
	
	exports.default = angular.module('conduu.permissionEdit', []).component('permissionEdit', {
	  template: __webpack_require__(648),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: PermissionEditComponent
	}).name;

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	module.exports = "\r\n  <div class=\"modal-header\">\r\n    <h3 class=\"modal-title\" id=\"modal-title\">Permission Edit</h3>\r\n  </div>\r\n  <div class=\"modal-body\" id=\"modal-body\">\r\n\r\n      <uib-tabset>\r\n          <!-- Tab: Create -->\r\n          <uib-tab index=\"0\" class=\"active\">\r\n              <uib-tab-heading>\r\n                  <nobr><i class=\"fa fa-fw fa-plus\"></i> Create</nobr>\r\n              </uib-tab-heading>\r\n              <br/>\r\n\r\n              <table class=\"table borderless table-condensed\">\r\n                  <tbody>\r\n                  <tr>\r\n                      <td style=\"width:15%\"><label style=\"padding-top: 4px\">Permission</label></td>\r\n                      <td>\r\n                          <div class=\"btn-group\">\r\n                              <label class=\"btn btn-sm btn-default\" ng-model=\"$ctrl.createState\" ng-click=\"$ctrl.update('create')\" uib-btn-radio=\"'None'\">\r\n                                  None <i ng-show=\"$ctrl.createState == 'None'\" class=\"fa fa-fw fa-check\"></i>\r\n                              </label>\r\n                              <label class=\"btn btn-sm btn-success\" ng-model=\"$ctrl.createState\" ng-click=\"$ctrl.update('create')\" uib-btn-radio=\"'All'\">\r\n                                  All <i ng-show=\"$ctrl.createState == 'All'\" class=\"fa fa-fw fa-check\"></i>\r\n                              </label>\r\n                              <label class=\"btn btn-sm btn-primary\" ng-model=\"$ctrl.createState\" ng-click=\"$ctrl.update('create')\" uib-btn-radio=\"'Custom'\">\r\n                                  Mixed/Custom <i ng-show=\"$ctrl.createState == 'Custom'\" class=\"fa fa-fw fa-check\"></i>\r\n                              </label>\r\n                          </div>\r\n                      </td>\r\n                  </tr>\r\n                  <tr ng-if=\"$ctrl.createState == 'Custom'\">\r\n                      <td><label style=\"padding-top: 4px\">Others</label></td>\r\n                      <td>\r\n                          <table class=\"table borderless table-condensed\">\r\n                              <tbody>\r\n                              <tr ng-repeat=\"permission in $ctrl.customCreatePermissions track by $index\">\r\n                                  <td>\r\n                                      <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.entityTypes\" ng-change=\"$ctrl.update('create')\" ng-model=\"permission.type\"></select>\r\n                                  </td>\r\n                                  <td>\r\n                                      <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.entities[permission.type]\" ng-change=\"$ctrl.update('create')\" ng-model=\"permission.entity\"></select>\r\n                                  </td>\r\n                                  <td>\r\n                                      <button class=\"btn btn-sm btn-danger\" ng-click=\"$ctrl.removeCustom('create', $index)\"><i class=\"fa fa-fw fa-trash fa-2x\"></i></button>\r\n                                  </td>\r\n                              </tr>\r\n                              </tbody>\r\n                          </table>\r\n                          <button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.addCustom('create')\"><i class=\"fa fa-fw fa-plus\"></i> Add</button>\r\n                      </td>\r\n                  </tr>\r\n                  </tbody>\r\n              </table>\r\n          </uib-tab>\r\n          <!-- Tab: Read -->\r\n          <uib-tab index=\"1\">\r\n              <uib-tab-heading>\r\n                  <nobr><i class=\"fa fa-fw fa-book\"></i> Read</nobr>\r\n              </uib-tab-heading>\r\n              <br/>\r\n\r\n              <table class=\"table borderless table-condensed\">\r\n                  <tbody>\r\n                  <tr>\r\n                      <td style=\"width:15%\"><label style=\"padding-top: 4px\">Permission</label></td>\r\n                      <td>\r\n                          <div class=\"btn-group\">\r\n                              <label class=\"btn btn-sm btn-default\" ng-model=\"$ctrl.readState\" ng-click=\"$ctrl.update('read')\" uib-btn-radio=\"'None'\">\r\n                                  None <i ng-show=\"$ctrl.readState == 'None'\" class=\"fa fa-fw fa-check\"></i>\r\n                              </label>\r\n                              <label class=\"btn btn-sm btn-success\" ng-model=\"$ctrl.readState\" ng-click=\"$ctrl.update('read')\" uib-btn-radio=\"'All'\">\r\n                                  All <i ng-show=\"$ctrl.readState == 'All'\" class=\"fa fa-fw fa-check\"></i>\r\n                              </label>\r\n                              <label class=\"btn btn-sm btn-primary\" ng-model=\"$ctrl.readState\" ng-click=\"$ctrl.update('read')\" uib-btn-radio=\"'Custom'\">\r\n                                  Mixed/Custom <i ng-show=\"$ctrl.readState == 'Custom'\" class=\"fa fa-fw fa-check\"></i>\r\n                              </label>\r\n                          </div>\r\n                      </td>\r\n                  </tr>\r\n                  <tr ng-if=\"$ctrl.readState == 'Custom'\">\r\n                      <td><label style=\"padding-top: 4px\">Own</label></td>\r\n                      <td>\r\n                          <button type=\"button\" class=\"btn btn-sm btn-info\" ng-model=\"$ctrl.readOwn\" ng-click=\"$ctrl.update('read')\" uib-btn-checkbox btn-checkbox-true=\"true\" btn-checkbox-false=\"false\">\r\n                              Can Read Own <i ng-show=\"$ctrl.readOwn\" class=\"fa fa-fw fa-check\"></i><i ng-hide=\"$ctrl.readOwn\" class=\"fa fa-fw fa-times\"></i>\r\n                          </button>\r\n                      </td>\r\n                  </tr>\r\n                  <tr ng-if=\"$ctrl.readState == 'Custom'\">\r\n                      <td><label style=\"padding-top: 4px\">Others</label></td>\r\n                      <td>\r\n                          <table class=\"table borderless table-condensed\">\r\n                              <tbody>\r\n                              <tr ng-repeat=\"permission in $ctrl.customReadPermissions track by $index\">\r\n                                  <td>\r\n                                      <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.entityTypes\" ng-change=\"$ctrl.update('read')\" ng-model=\"permission.type\"></select>\r\n                                  </td>\r\n                                  <td>\r\n                                      <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.entities[permission.type]\" ng-change=\"$ctrl.update('read')\" ng-model=\"permission.entity\"></select>\r\n                                  </td>\r\n                                  <td>\r\n                                      <button class=\"btn btn-sm btn-danger\" ng-click=\"$ctrl.removeCustom('read', $index)\"><i class=\"fa fa-fw fa-trash fa-2x\"></i></button>\r\n                                  </td>\r\n                              </tr>\r\n                              </tbody>\r\n                          </table>\r\n                          <button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.addCustom('read')\"><i class=\"fa fa-fw fa-plus\"></i> Add</button>\r\n                      </td>\r\n                  </tr>\r\n                  </tbody>\r\n              </table>\r\n              \r\n          </uib-tab>\r\n          <!-- Tab: Update -->\r\n          <uib-tab index=\"2\">\r\n              <uib-tab-heading>\r\n                  <nobr><i class=\"fa fa-fw fa-pencil\"></i> Update</nobr>\r\n              </uib-tab-heading>\r\n              <br/>\r\n\r\n              <table class=\"table borderless table-condensed\">\r\n                  <tbody>\r\n                  <tr>\r\n                      <td style=\"width:15%\"><label style=\"padding-top: 4px\">Permission</label></td>\r\n                      <td>\r\n                          <div class=\"btn-group\">\r\n                              <label class=\"btn btn-sm btn-default\" ng-model=\"$ctrl.updateState\" ng-click=\"$ctrl.update('update')\" uib-btn-radio=\"'None'\">\r\n                                  None <i ng-show=\"$ctrl.updateState == 'None'\" class=\"fa fa-fw fa-check\"></i>\r\n                              </label>\r\n                              <label class=\"btn btn-sm btn-success\" ng-model=\"$ctrl.updateState\" ng-click=\"$ctrl.update('update')\" uib-btn-radio=\"'All'\">\r\n                                  All <i ng-show=\"$ctrl.updateState == 'All'\" class=\"fa fa-fw fa-check\"></i>\r\n                              </label>\r\n                              <label class=\"btn btn-sm btn-primary\" ng-model=\"$ctrl.updateState\" ng-click=\"$ctrl.update('update')\" uib-btn-radio=\"'Custom'\">\r\n                                  Mixed/Custom <i ng-show=\"$ctrl.updateState == 'Custom'\" class=\"fa fa-fw fa-check\"></i>\r\n                              </label>\r\n                          </div>\r\n                      </td>\r\n                  </tr>\r\n                  <tr ng-if=\"$ctrl.updateState == 'Custom'\">\r\n                      <td><label style=\"padding-top: 4px\">Own</label></td>\r\n                      <td>\r\n                          <button type=\"button\" class=\"btn btn-sm btn-info\" ng-model=\"$ctrl.updateOwn\" ng-click=\"$ctrl.update('update')\" uib-btn-checkbox btn-checkbox-true=\"true\" btn-checkbox-false=\"false\">\r\n                              Can Update Own <i ng-show=\"$ctrl.updateOwn\" class=\"fa fa-fw fa-check\"></i><i ng-hide=\"$ctrl.updateOwn\" class=\"fa fa-fw fa-times\"></i>\r\n                          </button>\r\n                      </td>\r\n                  </tr>\r\n                  <tr ng-if=\"$ctrl.updateState == 'Custom'\">\r\n                      <td><label style=\"padding-top: 4px\">Others</label></td>\r\n                      <td>\r\n                          <table class=\"table borderless table-condensed\">\r\n                              <tbody>\r\n                              <tr ng-repeat=\"permission in $ctrl.customUpdatePermissions track by $index\">\r\n                                  <td>\r\n                                      <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.entityTypes\" ng-change=\"$ctrl.update('update')\" ng-model=\"permission.type\"></select>\r\n                                  </td>\r\n                                  <td>\r\n                                      <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.entities[permission.type]\" ng-change=\"$ctrl.update('update')\" ng-model=\"permission.entity\"></select>\r\n                                  </td>\r\n                                  <td>\r\n                                      <button class=\"btn btn-sm btn-danger\" ng-click=\"$ctrl.removeCustom('update', $index)\"><i class=\"fa fa-fw fa-trash fa-2x\"></i></button>\r\n                                  </td>\r\n                              </tr>\r\n                              </tbody>\r\n                          </table>\r\n                          <button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.addCustom('update')\"><i class=\"fa fa-fw fa-plus\"></i> Add</button>\r\n                      </td>\r\n                  </tr>\r\n                  </tbody>\r\n              </table>\r\n          </uib-tab>\r\n          <!-- Tab: Delete -->\r\n          <uib-tab index=\"3\">\r\n              <uib-tab-heading>\r\n                  <nobr><i class=\"fa fa-fw fa-trash\"></i> Delete</nobr>\r\n              </uib-tab-heading>\r\n              <br/>\r\n\r\n              <table class=\"table borderless table-condensed\">\r\n                  <tbody>\r\n                  <tr>\r\n                      <td style=\"width:15%\"><label style=\"padding-top: 4px\">Permission</label></td>\r\n                      <td>\r\n                          <div class=\"btn-group\">\r\n                              <label class=\"btn btn-sm btn-default\" ng-model=\"$ctrl.deleteState\" ng-click=\"$ctrl.update('delete')\" uib-btn-radio=\"'None'\">\r\n                                  None <i ng-show=\"$ctrl.deleteState == 'None'\" class=\"fa fa-fw fa-check\"></i>\r\n                              </label>\r\n                              <label class=\"btn btn-sm btn-success\" ng-model=\"$ctrl.deleteState\" ng-click=\"$ctrl.update('delete')\" uib-btn-radio=\"'All'\">\r\n                                  All <i ng-show=\"$ctrl.deleteState == 'All'\" class=\"fa fa-fw fa-check\"></i>\r\n                              </label>\r\n                              <label class=\"btn btn-sm btn-primary\" ng-model=\"$ctrl.deleteState\" ng-click=\"$ctrl.update('delete')\" uib-btn-radio=\"'Custom'\">\r\n                                  Mixed/Custom <i ng-show=\"$ctrl.deleteState == 'Custom'\" class=\"fa fa-fw fa-check\"></i>\r\n                              </label>\r\n                          </div>\r\n                      </td>\r\n                  </tr>\r\n                  <tr ng-if=\"$ctrl.deleteState == 'Custom'\">\r\n                      <td><label style=\"padding-top: 4px\">Own</label></td>\r\n                      <td>\r\n                          <button type=\"button\" class=\"btn btn-sm btn-info\" ng-model=\"$ctrl.deleteOwn\" ng-click=\"$ctrl.update('delete')\" uib-btn-checkbox btn-checkbox-true=\"true\" btn-checkbox-false=\"false\">\r\n                              Can Delete Own <i ng-show=\"$ctrl.deleteOwn\" class=\"fa fa-fw fa-check\"></i><i ng-hide=\"$ctrl.deleteOwn\" class=\"fa fa-fw fa-times\"></i>\r\n                          </button>\r\n                      </td>\r\n                  </tr>\r\n                  <tr ng-if=\"$ctrl.deleteState == 'Custom'\">\r\n                      <td><label style=\"padding-top: 4px\">Others</label></td>\r\n                      <td>\r\n                          <table class=\"table borderless table-condensed\">\r\n                              <tbody>\r\n                              <tr ng-repeat=\"permission in $ctrl.customDeletePermissions track by $index\">\r\n                                  <td>\r\n                                      <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.entityTypes\" ng-change=\"$ctrl.update('delete')\" ng-model=\"permission.type\"></select>\r\n                                  </td>\r\n                                  <td>\r\n                                      <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.entities[permission.type]\" ng-change=\"$ctrl.update('delete')\" ng-model=\"permission.entity\"></select>\r\n                                  </td>\r\n                                  <td>\r\n                                      <button class=\"btn btn-sm btn-danger\" ng-click=\"$ctrl.removeCustom('delete', $index)\"><i class=\"fa fa-fw fa-trash fa-2x\"></i></button>\r\n                                  </td>\r\n                              </tr>\r\n                              </tbody>\r\n                          </table>\r\n                          <button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.addCustom('delete')\"><i class=\"fa fa-fw fa-plus\"></i> Add</button>\r\n                      </td>\r\n                  </tr>\r\n                  </tbody>\r\n              </table>\r\n          </uib-tab>\r\n      </uib-tabset>\r\n\r\n      <div style=\"clear:both\"></div>\r\n      <h4 class=\"separator\"><span>Summary</span></h4>\r\n      <table class=\"table borderless\">\r\n          <tbody>\r\n          <tr>\r\n              <td><nobr><i class=\"fa fa-fw fa-plus text-muted\"></i> Create</nobr></td>\r\n              <td>\r\n                <span ng-repeat=\"permission in $ctrl.permissions.create\">\r\n                  <span ng-if=\"permission == 'all'\" class=\"label label-success\">All</span>\r\n                  <span ng-if=\"permission == 'own'\" class=\"label label-info\">Own</span>\r\n                  <span ng-if=\"permission.startsWith('community')\" class=\"label label-primary text-capitalize\">{{permission}}</span>\r\n                </span>\r\n                  <span ng-if=\"!$ctrl.permissions.create.length\" class=\"label label-default\">None</span>\r\n              </td>\r\n          </tr>\r\n          <tr>\r\n              <td style=\"width:15%\"><nobr><i class=\"fa fa-fw fa-book text-muted\"></i> Read</nobr></td>\r\n              <td>\r\n                <span ng-repeat=\"permission in $ctrl.permissions.read\">\r\n                  <span ng-if=\"permission == 'all'\" class=\"label label-success\">All</span>\r\n                  <span ng-if=\"permission == 'own'\" class=\"label label-info\">Own</span>\r\n                  <span ng-if=\"permission.startsWith('community')\" class=\"label label-primary text-capitalize\">{{permission}}</span>\r\n                </span>\r\n                  <span ng-if=\"!$ctrl.permissions.read.length\" class=\"label label-default\">None</span>\r\n              </td>\r\n          </tr>\r\n          <tr>\r\n              <td><nobr><i class=\"fa fa-fw fa-pencil text-muted\"></i> Update</nobr></td>\r\n              <td>\r\n                <span ng-repeat=\"permission in $ctrl.permissions.update\">\r\n                  <span ng-if=\"permission == 'all'\" class=\"label label-success\">All</span>\r\n                  <span ng-if=\"permission == 'own'\" class=\"label label-info\">Own</span>\r\n                  <span ng-if=\"permission.startsWith('community')\" class=\"label label-primary text-capitalize\">{{permission}}</span>\r\n                </span>\r\n                  <span ng-if=\"!$ctrl.permissions.update.length\" class=\"label label-default\">None</span>\r\n              </td>\r\n          </tr>\r\n          <tr>\r\n              <td><nobr><i class=\"fa fa-fw fa-trash text-muted\"></i> Delete</nobr></td>\r\n              <td>\r\n                <span ng-repeat=\"permission in $ctrl.permissions.delete\">\r\n                  <span ng-if=\"permission == 'all'\" class=\"label label-success\">All</span>\r\n                  <span ng-if=\"permission == 'own'\" class=\"label label-info\">Own</span>\r\n                  <span ng-if=\"permission.startsWith('community')\" class=\"label label-primary text-capitalize\">{{permission}}</span>\r\n                </span>\r\n                  <span ng-if=\"!$ctrl.permissions.delete.length\" class=\"label label-default\">None</span>\r\n              </td>\r\n          </tr>\r\n          </tbody>\r\n      </table>\r\n  </div>\r\n\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button class=\"btn btn-primary\" type=\"submit\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\r\n    <a class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\">Cancel</a>\r\n  </div>\r\n"

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	!function(){"use strict";angular.module("as.sortable",[]).constant("sortableConfig",{itemClass:"as-sortable-item",handleClass:"as-sortable-item-handle",placeHolderClass:"as-sortable-placeholder",dragClass:"as-sortable-drag",hiddenClass:"as-sortable-hidden",dragging:"as-sortable-dragging"})}(),function(){"use strict";var mainModule=angular.module("as.sortable");mainModule.factory("$helper",["$document","$window",function($document,$window){return{height:function(element){return element[0].getBoundingClientRect().height},width:function(element){return element[0].getBoundingClientRect().width},offset:function(element,scrollableContainer){var boundingClientRect=element[0].getBoundingClientRect();return scrollableContainer||(scrollableContainer=$document[0].documentElement),{width:boundingClientRect.width||element.prop("offsetWidth"),height:boundingClientRect.height||element.prop("offsetHeight"),top:boundingClientRect.top+($window.pageYOffset||scrollableContainer.scrollTop-scrollableContainer.offsetTop),left:boundingClientRect.left+($window.pageXOffset||scrollableContainer.scrollLeft-scrollableContainer.offsetLeft)}},eventObj:function(event){var obj=event;return void 0!==event.targetTouches?obj=event.targetTouches.item(0):void 0!==event.originalEvent&&void 0!==event.originalEvent.targetTouches&&(obj=event.originalEvent.targetTouches.item(0)),obj},isTouchInvalid:function(event){var touchInvalid=!1;return void 0!==event.touches&&event.touches.length>1?touchInvalid=!0:void 0!==event.originalEvent&&void 0!==event.originalEvent.touches&&event.originalEvent.touches.length>1&&(touchInvalid=!0),touchInvalid},positionStarted:function(event,target,scrollableContainer){var pos={};return pos.offsetX=event.pageX-this.offset(target,scrollableContainer).left,pos.offsetY=event.pageY-this.offset(target,scrollableContainer).top,pos.startX=pos.lastX=event.pageX,pos.startY=pos.lastY=event.pageY,pos.nowX=pos.nowY=pos.distX=pos.distY=pos.dirAx=0,pos.dirX=pos.dirY=pos.lastDirX=pos.lastDirY=pos.distAxX=pos.distAxY=0,pos},calculatePosition:function(pos,event){pos.lastX=pos.nowX,pos.lastY=pos.nowY,pos.nowX=event.pageX,pos.nowY=event.pageY,pos.distX=pos.nowX-pos.lastX,pos.distY=pos.nowY-pos.lastY,pos.lastDirX=pos.dirX,pos.lastDirY=pos.dirY,pos.dirX=0===pos.distX?0:pos.distX>0?1:-1,pos.dirY=0===pos.distY?0:pos.distY>0?1:-1;var newAx=Math.abs(pos.distX)>Math.abs(pos.distY)?1:0;pos.dirAx!==newAx?(pos.distAxX=0,pos.distAxY=0):(pos.distAxX+=Math.abs(pos.distX),0!==pos.dirX&&pos.dirX!==pos.lastDirX&&(pos.distAxX=0),pos.distAxY+=Math.abs(pos.distY),0!==pos.dirY&&pos.dirY!==pos.lastDirY&&(pos.distAxY=0)),pos.dirAx=newAx},movePosition:function(event,element,pos,container,containerPositioning,scrollableContainer){var bounds,useRelative="relative"===containerPositioning;element.x=event.pageX-pos.offsetX,element.y=event.pageY-pos.offsetY,container&&(bounds=this.offset(container,scrollableContainer),useRelative&&(element.x-=bounds.left,element.y-=bounds.top,bounds.left=0,bounds.top=0),element.x<bounds.left?element.x=bounds.left:element.x>=bounds.width+bounds.left-this.offset(element).width&&(element.x=bounds.width+bounds.left-this.offset(element).width),element.y<bounds.top?element.y=bounds.top:element.y>=bounds.height+bounds.top-this.offset(element).height&&(element.y=bounds.height+bounds.top-this.offset(element).height)),element.css({left:element.x+"px",top:element.y+"px"}),this.calculatePosition(pos,event)},dragItem:function(item){return{index:item.index(),parent:item.sortableScope,source:item,targetElement:null,targetElementOffset:null,sourceInfo:{index:item.index(),itemScope:item.itemScope,sortableScope:item.sortableScope},canMove:function(itemPosition,targetElement,targetElementOffset){return this.targetElement!==targetElement?(this.targetElement=targetElement,this.targetElementOffset=targetElementOffset,!0):itemPosition.dirX*(targetElementOffset.left-this.targetElementOffset.left)>0||itemPosition.dirY*(targetElementOffset.top-this.targetElementOffset.top)>0?(this.targetElementOffset=targetElementOffset,!0):!1},moveTo:function(parent,index){this.parent=parent,this.isSameParent()&&this.source.index()<index&&!this.sourceInfo.sortableScope.cloning&&(index-=1),this.index=index},isSameParent:function(){return this.parent.element===this.sourceInfo.sortableScope.element},isOrderChanged:function(){return this.index!==this.sourceInfo.index},eventArgs:function(){return{source:this.sourceInfo,dest:{index:this.index,sortableScope:this.parent}}},apply:function(){this.sourceInfo.sortableScope.cloning?this.parent.options.clone||this.parent.insertItem(this.index,angular.copy(this.source.modelValue)):(this.sourceInfo.sortableScope.removeItem(this.sourceInfo.index),(this.parent.options.allowDuplicates||this.parent.modelValue.indexOf(this.source.modelValue)<0)&&this.parent.insertItem(this.index,this.source.modelValue))}}},noDrag:function(element){return void 0!==element.attr("no-drag")||void 0!==element.attr("data-no-drag")},findAncestor:function(el,selector){el=el[0];for(var matches=Element.matches||Element.prototype.mozMatchesSelector||Element.prototype.msMatchesSelector||Element.prototype.oMatchesSelector||Element.prototype.webkitMatchesSelector;(el=el.parentElement)&&!matches.call(el,selector););return el?angular.element(el):angular.element(document.body)}}}])}(),function(){"use strict";var mainModule=angular.module("as.sortable");mainModule.controller("as.sortable.sortableController",["$scope",function($scope){this.scope=$scope,$scope.modelValue=null,$scope.callbacks=null,$scope.type="sortable",$scope.options={longTouch:!1},$scope.isDisabled=!1,$scope.insertItem=function(index,itemData){$scope.options.allowDuplicates?$scope.modelValue.splice(index,0,angular.copy(itemData)):$scope.modelValue.splice(index,0,itemData)},$scope.removeItem=function(index){var removedItem=null;return index>-1&&(removedItem=$scope.modelValue.splice(index,1)[0]),removedItem},$scope.isEmpty=function(){return $scope.modelValue&&0===$scope.modelValue.length},$scope.accept=function(sourceItemHandleScope,destScope,destItemScope){return $scope.callbacks.accept(sourceItemHandleScope,destScope,destItemScope)}}]),mainModule.directive("asSortable",function(){return{require:"ngModel",restrict:"A",scope:!0,controller:"as.sortable.sortableController",link:function(scope,element,attrs,ngModelController){var ngModel,callbacks;ngModel=ngModelController,ngModel&&(ngModel.$render=function(){scope.modelValue=ngModel.$modelValue},scope.element=element,element.data("_scope",scope),callbacks={accept:null,orderChanged:null,itemMoved:null,dragStart:null,dragMove:null,dragCancel:null,dragEnd:null},callbacks.accept=function(sourceItemHandleScope,destSortableScope,destItemScope){return!0},callbacks.orderChanged=function(event){},callbacks.itemMoved=function(event){},callbacks.dragStart=function(event){},callbacks.dragMove=angular.noop,callbacks.dragCancel=function(event){},callbacks.dragEnd=function(event){},scope.$watch(attrs.asSortable,function(newVal,oldVal){angular.forEach(newVal,function(value,key){callbacks[key]?"function"==typeof value&&(callbacks[key]=value):scope.options[key]=value}),scope.callbacks=callbacks},!0),angular.isDefined(attrs.isDisabled)&&scope.$watch(attrs.isDisabled,function(newVal,oldVal){angular.isUndefined(newVal)||(scope.isDisabled=newVal)},!0))}}})}(),function(){"use strict";function isParent(possibleParent,elem){return elem&&"HTML"!==elem.nodeName?elem.parentNode===possibleParent?!0:isParent(possibleParent,elem.parentNode):!1}var mainModule=angular.module("as.sortable");mainModule.controller("as.sortable.sortableItemHandleController",["$scope",function($scope){this.scope=$scope,$scope.itemScope=null,$scope.type="handle"}]),mainModule.directive("asSortableItemHandle",["sortableConfig","$helper","$window","$document","$timeout",function(sortableConfig,$helper,$window,$document,$timeout){return{require:"^asSortableItem",scope:!0,restrict:"A",controller:"as.sortable.sortableItemHandleController",link:function(scope,element,attrs,itemController){function insertBefore(targetElement,targetScope){"table-row"!==placeHolder.css("display")&&placeHolder.css("display","block"),targetScope.sortableScope.options.clone||(targetElement[0].parentNode.insertBefore(placeHolder[0],targetElement[0]),dragItemInfo.moveTo(targetScope.sortableScope,targetScope.index()))}function insertAfter(targetElement,targetScope){"table-row"!==placeHolder.css("display")&&placeHolder.css("display","block"),targetScope.sortableScope.options.clone||(targetElement.after(placeHolder),dragItemInfo.moveTo(targetScope.sortableScope,targetScope.index()+1))}function fetchScope(element){for(var scope;!scope&&element.length;)scope=element.data("_scope"),scope||(element=element.parent());return scope}function rollbackDragChanges(){scope.itemScope.sortableScope.cloning||placeElement.replaceWith(scope.itemScope.element),placeHolder.remove(),dragElement.remove(),dragElement=null,dragHandled=!1,containment.css("cursor",""),containment.removeClass("as-sortable-un-selectable")}var dragElement,placeHolder,placeElement,itemPosition,dragItemInfo,containment,containerPositioning,dragListen,scrollableContainer,dragStart,dragMove,dragEnd,dragCancel,isDraggable,placeHolderIndex,bindDrag,unbindDrag,bindEvents,unBindEvents,hasTouch,isIOS,longTouchStart,longTouchCancel,longTouchTimer,dragHandled,createPlaceholder,isPlaceHolderPresent,escapeListen,isDisabled=!1,isLongTouch=!1;hasTouch="ontouchstart"in $window,isIOS=/iPad|iPhone|iPod/.test($window.navigator.userAgent)&&!$window.MSStream,sortableConfig.handleClass&&element.addClass(sortableConfig.handleClass),scope.itemScope=itemController.scope,element.data("_scope",scope),scope.$watchGroup(["sortableScope.isDisabled","sortableScope.options.longTouch"],function(newValues){isDisabled!==newValues[0]?(isDisabled=newValues[0],isDisabled?unbindDrag():bindDrag()):isLongTouch!==newValues[1]?(isLongTouch=newValues[1],unbindDrag(),bindDrag()):bindDrag()}),scope.$on("$destroy",function(){angular.element($document[0].body).unbind("keydown",escapeListen)}),createPlaceholder=function(itemScope){return"function"==typeof scope.sortableScope.options.placeholder?angular.element(scope.sortableScope.options.placeholder(itemScope)):"string"==typeof scope.sortableScope.options.placeholder?angular.element(scope.sortableScope.options.placeholder):angular.element($document[0].createElement(itemScope.element.prop("tagName")))},dragListen=function(event){var startPosition,unbindMoveListen=function(){angular.element($document).unbind("mousemove",moveListen),angular.element($document).unbind("touchmove",moveListen),element.unbind("mouseup",unbindMoveListen),element.unbind("touchend",unbindMoveListen),element.unbind("touchcancel",unbindMoveListen)},moveListen=function(e){e.preventDefault();var eventObj=$helper.eventObj(e);startPosition||(startPosition={clientX:eventObj.clientX,clientY:eventObj.clientY}),Math.abs(eventObj.clientX-startPosition.clientX)+Math.abs(eventObj.clientY-startPosition.clientY)>10&&(unbindMoveListen(),dragStart(event))};angular.element($document).bind("mousemove",moveListen),angular.element($document).bind("touchmove",moveListen),element.bind("mouseup",unbindMoveListen),element.bind("touchend",unbindMoveListen),element.bind("touchcancel",unbindMoveListen),event.stopPropagation()},dragStart=function(event){var eventObj,tagName;(hasTouch||2!==event.button&&3!==event.which)&&(hasTouch&&$helper.isTouchInvalid(event)||!dragHandled&&isDraggable(event)&&(dragHandled=!0,event.preventDefault(),eventObj=$helper.eventObj(event),scope.sortableScope=scope.sortableScope||scope.itemScope.sortableScope,scope.callbacks=scope.callbacks||scope.itemScope.callbacks,scope.itemScope.sortableScope.options.clone||scope.itemScope.sortableScope.options.ctrlClone&&event.ctrlKey?scope.itemScope.sortableScope.cloning=!0:scope.itemScope.sortableScope.cloning=!1,scrollableContainer=angular.element($document[0].querySelector(scope.sortableScope.options.scrollableContainer)).length>0?$document[0].querySelector(scope.sortableScope.options.scrollableContainer):$document[0].documentElement,containment=scope.sortableScope.options.containment?$helper.findAncestor(element,scope.sortableScope.options.containment):angular.element($document[0].body),containment.css("cursor","move"),containment.css("cursor","-webkit-grabbing"),containment.css("cursor","-moz-grabbing"),containment.addClass("as-sortable-un-selectable"),containerPositioning=scope.sortableScope.options.containerPositioning||"absolute",dragItemInfo=$helper.dragItem(scope),tagName=scope.itemScope.element.prop("tagName"),dragElement=angular.element($document[0].createElement(scope.sortableScope.element.prop("tagName"))).addClass(scope.sortableScope.element.attr("class")).addClass(sortableConfig.dragClass),dragElement.css("width",$helper.width(scope.itemScope.element)+"px"),dragElement.css("height",$helper.height(scope.itemScope.element)+"px"),placeHolder=createPlaceholder(scope.itemScope).addClass(sortableConfig.placeHolderClass).addClass(scope.sortableScope.options.additionalPlaceholderClass),placeHolder.css("width",$helper.width(scope.itemScope.element)+"px"),placeHolder.css("height",$helper.height(scope.itemScope.element)+"px"),placeElement=angular.element($document[0].createElement(tagName)),sortableConfig.hiddenClass&&placeElement.addClass(sortableConfig.hiddenClass),itemPosition=$helper.positionStarted(eventObj,scope.itemScope.element,scrollableContainer),scope.itemScope.sortableScope.options.clone||scope.itemScope.element.after(placeHolder),scope.itemScope.sortableScope.cloning?dragElement.append(scope.itemScope.element.clone()):(scope.itemScope.element.after(placeElement),dragElement.append(scope.itemScope.element)),containment.append(dragElement),$helper.movePosition(eventObj,dragElement,itemPosition,containment,containerPositioning,scrollableContainer),scope.sortableScope.$apply(function(){scope.callbacks.dragStart(dragItemInfo.eventArgs())}),bindEvents()))},isDraggable=function(event){var elementClicked,sourceScope,isDraggable;for(elementClicked=angular.element(event.target),sourceScope=fetchScope(elementClicked),isDraggable=sourceScope&&"handle"===sourceScope.type;isDraggable&&elementClicked[0]!==element[0];)$helper.noDrag(elementClicked)&&(isDraggable=!1),elementClicked=elementClicked.parent();return isDraggable},dragMove=function(event){var eventObj,targetX,targetY,targetScope,targetElement;if((!hasTouch||!$helper.isTouchInvalid(event))&&dragHandled&&dragElement){if(event.preventDefault(),eventObj=$helper.eventObj(event),scope.callbacks.dragMove!==angular.noop&&scope.sortableScope.$apply(function(){scope.callbacks.dragMove(itemPosition,containment,eventObj)}),targetX=eventObj.pageX-$document[0].documentElement.scrollLeft,targetY=eventObj.pageY-($window.pageYOffset||$document[0].documentElement.scrollTop),dragElement.addClass(sortableConfig.hiddenClass),targetElement=angular.element($document[0].elementFromPoint(targetX,targetY)),dragElement.removeClass(sortableConfig.hiddenClass),$helper.movePosition(eventObj,dragElement,itemPosition,containment,containerPositioning,scrollableContainer),dragElement.addClass(sortableConfig.dragging),targetScope=fetchScope(targetElement),!targetScope||!targetScope.type)return;if("handle"===targetScope.type&&(targetScope=targetScope.itemScope),"item"!==targetScope.type&&"sortable"!==targetScope.type)return;if("item"===targetScope.type&&targetScope.accept(scope,targetScope.sortableScope,targetScope)){targetElement=targetScope.element;var targetElementOffset=$helper.offset(targetElement,scrollableContainer);if(!dragItemInfo.canMove(itemPosition,targetElement,targetElementOffset))return;var placeholderIndex=placeHolderIndex(targetScope.sortableScope.element);0>placeholderIndex?insertBefore(targetElement,targetScope):placeholderIndex<=targetScope.index()?insertAfter(targetElement,targetScope):insertBefore(targetElement,targetScope)}"sortable"===targetScope.type&&targetScope.accept(scope,targetScope)&&!isParent(targetScope.element[0],targetElement[0])&&(isPlaceHolderPresent(targetElement)||targetScope.options.clone||(targetElement[0].appendChild(placeHolder[0]),dragItemInfo.moveTo(targetScope,targetScope.modelValue.length)))}},placeHolderIndex=function(targetElement){var itemElements,i;if(targetElement.hasClass(sortableConfig.placeHolderClass))return 0;for(itemElements=targetElement.children(),i=0;i<itemElements.length;i+=1)if(angular.element(itemElements[i]).hasClass(sortableConfig.placeHolderClass))return i;return-1},isPlaceHolderPresent=function(targetElement){return placeHolderIndex(targetElement)>=0},dragEnd=function(event){dragHandled&&(event.preventDefault(),dragElement&&(rollbackDragChanges(),dragItemInfo.apply(),scope.sortableScope.$apply(function(){dragItemInfo.isSameParent()?dragItemInfo.isOrderChanged()&&scope.callbacks.orderChanged(dragItemInfo.eventArgs()):scope.callbacks.itemMoved(dragItemInfo.eventArgs())}),scope.sortableScope.$apply(function(){scope.callbacks.dragEnd(dragItemInfo.eventArgs())}),dragItemInfo=null),unBindEvents())},dragCancel=function(event){dragHandled&&(event.preventDefault(),dragElement&&(rollbackDragChanges(),scope.sortableScope.$apply(function(){scope.callbacks.dragCancel(dragItemInfo.eventArgs())}),dragItemInfo=null),unBindEvents())},bindDrag=function(){hasTouch&&(isLongTouch?isIOS?(element.bind("touchstart",longTouchStart),element.bind("touchend",longTouchCancel),element.bind("touchmove",longTouchCancel)):element.bind("contextmenu",dragListen):element.bind("touchstart",dragListen)),element.bind("mousedown",dragListen)},unbindDrag=function(){element.unbind("touchstart",longTouchStart),element.unbind("touchend",longTouchCancel),element.unbind("touchmove",longTouchCancel),element.unbind("contextmenu",dragListen),element.unbind("touchstart",dragListen),element.unbind("mousedown",dragListen)},longTouchStart=function(event){longTouchTimer=$timeout(function(){dragListen(event)},500)},longTouchCancel=function(){$timeout.cancel(longTouchTimer)},escapeListen=function(event){27===event.keyCode&&dragCancel(event)},angular.element($document[0].body).bind("keydown",escapeListen),bindEvents=function(){angular.element($document).bind("touchmove",dragMove),angular.element($document).bind("touchend",dragEnd),angular.element($document).bind("touchcancel",dragCancel),angular.element($document).bind("mousemove",dragMove),angular.element($document).bind("mouseup",dragEnd)},unBindEvents=function(){angular.element($document).unbind("touchend",dragEnd),angular.element($document).unbind("touchcancel",dragCancel),angular.element($document).unbind("touchmove",dragMove),angular.element($document).unbind("mouseup",dragEnd),angular.element($document).unbind("mousemove",dragMove)}}}}])}(),function(){"use strict";var mainModule=angular.module("as.sortable");mainModule.controller("as.sortable.sortableItemController",["$scope",function($scope){this.scope=$scope,$scope.sortableScope=null,$scope.modelValue=null,$scope.type="item",$scope.index=function(){return $scope.$index},$scope.itemData=function(){return $scope.sortableScope.modelValue[$scope.$index]}}]),mainModule.directive("asSortableItem",["sortableConfig",function(sortableConfig){return{require:["^asSortable","?ngModel"],restrict:"A",controller:"as.sortable.sortableItemController",link:function(scope,element,attrs,ctrl){var sortableController=ctrl[0],ngModelController=ctrl[1];sortableConfig.itemClass&&element.addClass(sortableConfig.itemClass),scope.sortableScope=sortableController.scope,ngModelController?ngModelController.$render=function(){scope.modelValue=ngModelController.$modelValue}:scope.modelValue=sortableController.scope.modelValue[scope.$index],scope.element=element,element.data("_scope",scope)}}}])}();

/***/ }),
/* 650 */
5,
/* 651 */,
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProjectListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _projectList = __webpack_require__(653);
	
	var _projectList2 = _interopRequireDefault(_projectList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ProjectListComponent = exports.ProjectListComponent = function () {
	  ProjectListComponent.$inject = ['Auth', 'ProjectService', 'dialogs', 'DTOptionsBuilder', 'DTState'];
	  function ProjectListComponent(Auth, ProjectService, dialogs, DTOptionsBuilder, DTState) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ProjectListComponent);
	
	    this.ProjectService = ProjectService;
	    this.data = [];
	
	    this.dialogs = dialogs;
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'desc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Projects"
	    }, {
	      extend: 'csv',
	      title: "Projects"
	    }, {
	      title: "Projects",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'portrait',
	      pageSize: 'LETTER'
	    }, {
	      extend: 'print',
	      title: "Projects"
	    }]);
	
	    this.ProjectService.query(function (data) {
	      _this.data = data;
	      _this.dataInitComplete = true;
	    }, function (err) {
	      console.log("Could not retrieve project.");
	    });
	  }
	
	  _createClass(ProjectListComponent, [{
	    key: 'delete',
	    value: function _delete(project) {
	      var that = this;
	
	      var projectText = "<br/><br/><b>" + project.name + "</b><br/><p>" + project.description + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Project?", "<i class='fa fa-5x fa-fw text-danger fa-warning' style='float:right'></i>Do you really want to delete this project?" + projectText);
	      dlg.result.then(function () {
	        that.ProjectService.delete({ id: project._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== project._id;
	          });
	        }, function (err) {
	          alert("Could not delete project");
	        });
	      }, function () {});
	    }
	  }]);
	
	  return ProjectListComponent;
	}();
	
	exports.default = angular.module('conduu.projectList', [uiRouter]).config(_projectList2.default).component('projectList', {
	  template: __webpack_require__(654),
	  controller: ProjectListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('project-list', {
	    url: '/project/list',
	    template: '<project-list></project-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" href=\"/project/edit/\"><i class=\"fa fa-plus\"></i> Create New Project</a>\r\n      <h2>Projects</h2>\r\n      <li class=\"active\"><a href=\"#\">Projects</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>Name</th>\r\n          <th>Project Lead</th>\r\n          <th>Start Date</th>\r\n          <th>Target Date</th>\r\n          <th>Progress</th>\r\n          <th>Creation Date</th>\r\n          <th></th>\r\n          <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"project in ctrl.data | orderBy: 'meta.creationDate':true\">\r\n          <td><a ng-href=\"/project/{{project._id}}\">{{project.name}}</a></td>\r\n          <td>{{project.projectLead.shortName || '-'}}</td>\r\n          <td><nobr>{{project.startDate | date:'yyyy-MM-dd'}}</nobr></td>\r\n          <td><nobr>{{project.targetDate | date:'yyyy-MM-dd'}}</nobr></td>\r\n          <td>{{project.progress || 0}}%</td>\r\n          <td>\r\n            <nobr>{{project.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td><a class=\"btn btn-sm btn-primary\" ng-href=\"/project/{{project._id}}\"><i class=\"fa fa-folder-open fa-fw\"></i></a></td>\r\n          <td>\r\n            <nobr>\r\n              <a class=\"btn btn-sm btn-primary\" ng-href=\"/project/edit/{{project._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n              <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(project)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n            </nobr>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProjectEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _projectEdit = __webpack_require__(656);
	
	var _projectEdit2 = _interopRequireDefault(_projectEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ProjectEditComponent = exports.ProjectEditComponent = function () {
	  ProjectEditComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'ProjectService', 'SettingsService', '$uibModal', 'User'];
	  function ProjectEditComponent(Auth, $state, $stateParams, dialogs, ProjectService, SettingsService, $uibModal, User) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ProjectEditComponent);
	
	    this.projectId = $stateParams.id;
	
	    this.dialogs = dialogs;
	    this.ProjectService = ProjectService;
	    this.SettingsService = SettingsService;
	    this.$uibModal = $uibModal;
	    this.User = User;
	    this.Auth = Auth;
	
	    this.jsonValue = "";
	    this.users = [];
	    this.$state = $state;
	
	    this.model = {};
	
	    SettingsService.getByName({ name: 'project-board-presets' }, function (setting) {
	      _this.presets = setting.data;
	    });
	
	    if (this.projectId) {
	      this.ProjectService.get({ id: this.projectId }, function (data) {
	        _this.model = data;
	
	        if (_this.model.startDate) _this.model.startDate = new Date(_this.model.startDate);
	
	        if (_this.model.targetDate) _this.model.targetDate = new Date(_this.model.targetDate);
	
	        if (_this.model.projectLead) _this.model.projectLead = _this.model.projectLead._id;
	      }, function (err) {
	        console.log('Could not load vendor from server');
	      });
	    }
	
	    this.User.query(function (data) {
	      _this.users = data.map(function (user) {
	        return {
	          value: user._id,
	          name: user.shortName || user.firstName + ' ' + user.lastName
	        };
	      });
	    });
	  }
	
	  _createClass(ProjectEditComponent, [{
	    key: 'setColumns',
	    value: function setColumns() {
	      var name = this.selectedPreset;
	
	      var idx = this.presets.findIndex(function (preset) {
	        return preset.name == name;
	      });
	
	      if (idx !== -1) {
	        this.selectedPresetDescription = this.presets[idx].description;
	        this.model.columns = this.presets[idx].columns;
	      }
	    }
	  }, {
	    key: 'openStartDatePopup',
	    value: function openStartDatePopup() {
	      this.startDatePopupOpened = true;
	    }
	  }, {
	    key: 'openTargetDatePopup',
	    value: function openTargetDatePopup() {
	      this.targetDatePopupOpened = true;
	    }
	  }, {
	    key: 'userLookup',
	    value: function userLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'userLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (user) {
	        that.model.projectLead = user._id;
	      }, function () {});
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this2.projectId ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "The project has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("project-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        if (this.projectId) {
	          this.ProjectService.update({ id: this.projectId }, this.model, onSuccess, onError);
	        } else {
	          this.model.meta = { creationUser: this.Auth.getCurrentUserSync()._id };
	          this.ProjectService.save(this.model, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return ProjectEditComponent;
	}();
	
	exports.default = angular.module('conduu.projectEdit', [uiRouter]).config(_projectEdit2.default).component('projectEdit', {
	  template: __webpack_require__(657),
	  controller: ProjectEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('project-edit', {
	    url: '/project/edit/:id',
	    template: '<project-edit></project-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Project Editor</h2>\r\n      <li><a href=\"/project/list\">Projects</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n\r\n        <h3 class=\"separator\"><span>General</span></h3>\r\n\r\n        <!-- Vendor Name -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Name</label>\r\n\r\n          <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"ctrl.model.name\"\r\n                 required/>\r\n          <p class=\"help-block\" ng-show=\"form.name.$error.required && ctrl.submitted\">\r\n            A project name is required\r\n          </p>\r\n        </div>\r\n\r\n        <!-- Description -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.description.$valid && ctrl.submitted,\r\n                                            'has-error': form.description.$invalid && ctrl.submitted }\">\r\n          <label>Description</label>\r\n\r\n          <input type=\"text\" name=\"description\" class=\"form-control\" ng-model=\"ctrl.model.description\"/>\r\n        </div>\r\n\r\n        <!-- Project Lead -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.projectLead.$valid && ctrl.submitted,\r\n                                            'has-error': form.projectLead.$invalid && ctrl.submitted }\">\r\n          <label>Project Lead</label>\r\n          <br/>\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <select class=\"form-control\" ng-options=\"o.value as o.name for o in ctrl.users\" ng-model=\"ctrl.model.projectLead\"\r\n                    style=\"display: inline-block; width: auto\"></select>\r\n            <span class=\"input-group-btn\">\r\n                <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.userLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.projectLead\" ng-click=\"ctrl.model.projectLead = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n              </span>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <!-- Start Date -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.startDate.$valid && ctrl.submitted,\r\n                                        'has-error': form.startDate.$invalid && ctrl.submitted }\">\r\n          <label>Start Date</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"ctrl.model.startDate\" is-open=\"ctrl.startDatePopupOpened\"\r\n                   close-text=\"Close\" style=\"display: inline-block; width: auto; min-width:180px\" />\r\n            <span class=\"input-group-btn\">\r\n          <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.openStartDatePopup()\"><i class=\"fa fa-fw fa-calendar\"></i></button>\r\n        </span>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Target Date -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.targetDate.$valid && ctrl.submitted,\r\n                                        'has-error': form.targetDate.$invalid && ctrl.submitted }\">\r\n          <label>Target Date</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"ctrl.model.targetDate\" is-open=\"ctrl.targetDatePopupOpened\"\r\n                   close-text=\"Close\" style=\"display: inline-block; width: auto; min-width:180px\" />\r\n            <span class=\"input-group-btn\">\r\n          <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.openTargetDatePopup()\"><i class=\"fa fa-fw fa-calendar\"></i></button>\r\n        </span>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Board Style -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.projectLead.$valid && ctrl.submitted,\r\n                                            'has-error': form.projectLead.$invalid && ctrl.submitted }\">\r\n          <label>Project Board Style</label>\r\n          <span class=\"text-warning\">&nbsp;&nbsp;(<i class=\"fa fa-fw fa-warning\"></i> Style <b>can not</b> be changed after creation)</span>\r\n          <br/>\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n            <select class=\"form-control\" ng-options=\"o.name as o.name for o in ctrl.presets\" ng-change=\"ctrl.setColumns()\" ng-model=\"ctrl.selectedPreset\"\r\n                    style=\"display: inline-block; width: auto\"></select>\r\n          </div>\r\n          <span>{{ctrl.selectedPresetDescription}}</span>\r\n        </div>\r\n\r\n        <h3 ng-if=\"ctrl.model.columns\" class=\"separator\"><span>Board Preview</span></h3>\r\n\r\n        <div ng-if=\"ctrl.model.columns\" class=\"col-md-{{12/ctrl.model.columns.length}} col-sm-6 col-xs-12\" style=\"padding:4px\"\r\n             ng-repeat=\"column in ctrl.model.columns\">\r\n          <div class=\"column bs-callout bs-callout-{{column.color}}\">\r\n            <div class=\"columnHeader\">\r\n              <h4 class=\"separator\"><span>{{column.name}}</span></h4>\r\n            </div>\r\n            <ul class=\"cards card-list list-unstyled\" style=\"padding:8px\">\r\n              <li class=\"card\">...</li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <button ng-hide=\"ctrl.projectId\" class=\"btn btn-primary\" type=\"submit\">Create Project</button>\r\n\r\n        <button ng-show=\"ctrl.projectId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"project-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProjectBoardComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _projectBoard = __webpack_require__(659);
	
	var _projectBoard2 = _interopRequireDefault(_projectBoard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ProjectBoardComponent = exports.ProjectBoardComponent = function () {
	  ProjectBoardComponent.$inject = ['$stateParams', 'ProjectService', 'ProjectItemService', '$uibModal', '$window', 'dialogs', 'RecentVisits', 'PinnedItems', 'DTOptionsBuilder', 'DTState'];
	  function ProjectBoardComponent($stateParams, ProjectService, ProjectItemService, $uibModal, $window, dialogs, RecentVisits, PinnedItems, DTOptionsBuilder, DTState) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ProjectBoardComponent);
	
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.projectId = $stateParams.id;
	    this.$uibModal = $uibModal;
	    this.dialogs = dialogs;
	
	    this.tasks = [];
	    this.activities = [];
	
	    this.asTable = false;
	
	    this.ProjectService = ProjectService;
	    this.ProjectItemService = ProjectItemService;
	
	    this.RecentVisits = RecentVisits;
	    this.PinnedItems = PinnedItems;
	    this.DTOptionsBuilder = DTOptionsBuilder;
	
	    this.refreshData(true);
	
	    this.persistOrder = function (event) {
	      var sourceColumnIndex = event.source.sortableScope.element[0].getAttribute('column-idx');
	      var destColumnIndex = event.dest.sortableScope.element[0].getAttribute('column-idx');
	
	      var sourceItemIndex = event.source.index;
	      var destItemIndex = event.dest.index;
	
	      _this.ProjectService.patch({ id: _this.projectId }, [{ "op": "move", "from": "/columns/" + sourceColumnIndex + "/items/" + sourceItemIndex, "path": "/columns/" + destColumnIndex + "/items/" + destItemIndex }], function (_) {
	        _this.refreshData();
	      }, function (err) {
	        console.log('Could not update project');
	      });
	    };
	
	    this.dragControlListeners = {
	      accept: function accept(sourceItemHandleScope, destSortableScope) {
	        return true;
	      },
	      itemMoved: this.persistOrder,
	      orderChanged: this.persistOrder
	    };
	
	    this.dropdownmenu = [{
	      title: 'Edit',
	      icon: 'pencil',
	      action: function action(item) {
	        _this.openEditProjectItemModal(item);
	      }
	    }, {
	      title: 'Delete',
	      icon: 'trash',
	      action: function action(item) {
	        _this.delete(item);
	      }
	    }];
	  }
	
	  _createClass(ProjectBoardComponent, [{
	    key: 'setAsTable',
	    value: function setAsTable(val) {
	      var _this2 = this;
	
	      if (val == true) {
	        this.items = [];
	        this.project.columns.forEach(function (column) {
	          column.items.forEach(function (item) {
	            var _item = angular.copy(item);
	            _item.state = column.name;
	            _item.color = column.color;
	            _this2.items.push(_item);
	          });
	        });
	        console.log(this.items);
	      }
	
	      this.asTable = val;
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (resultIds) {
	        that.ProjectService.addAttachments({ id: that.projectId }, resultIds, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not add attachments to project');
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'calcPercentageProject',
	    value: function calcPercentageProject() {
	
	      var sumTarget = 0;
	      var sumActual = 0;
	
	      this.project.columns.forEach(function (column) {
	        column.items.forEach(function (item) {
	
	          if (item.progressTarget) {
	
	            sumTarget += item.progressTarget;
	
	            if (item.progressActual) {
	
	              if (item.progressActual > item.progressTarget) {
	                sumActual += item.progressTarget;
	              } else {
	                sumActual += item.progressActual;
	              }
	            }
	          }
	        });
	      });
	
	      if (sumTarget == 0) return 0;
	
	      var percent = sumActual / sumTarget * 100;
	
	      return percent.toFixed(0);
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData(init) {
	      var _this3 = this;
	
	      if (this.projectId) {
	        this.ProjectService.get({ id: this.projectId }, function (data) {
	          _this3.project = data;
	          _this3.project.progress = _this3.calcPercentageProject();
	
	          _this3.RecentVisits.addProject(_this3.projectId, _this3.project.name);
	          _this3.isPinned = _this3.PinnedItems.isPinnedProject(_this3.projectId);
	
	          if (init) {
	            _this3.dtOptions = _this3.DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('rowGroup', {
	              dataSrc: [1]
	            }).withOption('columnDefs', [{
	              targets: [0, 1],
	              visible: false
	            }]).withOption('buttons', [{
	              extend: 'excel',
	              title: _this3.project.name
	            }, {
	              extend: 'csv',
	              title: _this3.project.name
	            }, {
	              title: _this3.project.name,
	              message: 'As of ' + moment().format("MMMM Do YYYY"),
	              extend: 'pdf',
	              orientation: 'portrait',
	              pageSize: 'LETTER'
	            }, {
	              extend: 'print',
	              title: _this3.project.name
	            }]);
	          }
	
	          if (!init) _this3.ProjectService.patch({ id: _this3.projectId }, [{ "op": "add", "path": "/progress", "value": _this3.project.progress }]);
	        }, function (err) {
	          console.log('Could not load project from server');
	        });
	      }
	    }
	  }, {
	    key: 'openEditProjectItemModal',
	    value: function openEditProjectItemModal(item) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'projectItemEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: item
	            };
	          }
	        }
	      });
	
	      modalInstance.result.then(function (projectItem) {
	        that.refreshData();
	      }, function () {});
	    }
	  }, {
	    key: 'openNewProjectItemModal',
	    value: function openNewProjectItemModal(columnIndex) {
	      var _this4 = this;
	
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'projectItemEdit',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (projectItem) {
	        _this4.ProjectService.patch({ id: _this4.projectId }, [{ "op": "add", "path": "/columns/" + columnIndex + "/items/-", "value": projectItem._id }], function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('Could not update project');
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(card) {
	      var _this5 = this;
	
	      var that = this;
	
	      var cardIndex = -1;
	      var columnIndex = -1;
	
	      for (var colIdx = 0; colIdx <= this.project.columns.length; colIdx++) {
	        var _cardIndex = this.project.columns[colIdx].items.findIndex(function (item) {
	          return card._id == item._id;
	        });
	
	        if (_cardIndex !== -1) {
	          cardIndex = _cardIndex;
	          columnIndex = colIdx;
	          break;
	        }
	      }
	
	      if (cardIndex == -1 || columnIndex == -1) {
	        console.log("Could not delete item");
	        return;
	      }
	
	      var cardText = "<br/><br/><b>" + card.title + "</b><br/><p>" + card.description + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Project Item?", "<i class='fa fa-5x fa-fw text-danger fa-warning' style='float:right'></i>Do you really want to delete this project item?" + cardText);
	      dlg.result.then(function () {
	        _this5.ProjectService.patch({ id: _this5.projectId }, [{ "op": "remove", "path": "/columns/" + columnIndex + "/items/" + cardIndex }], function (_) {
	          that.ProjectItemService.delete({ id: card._id }, function () {
	            that.refreshData();
	          }, function (err) {
	            alert("Could not delete project item");
	          });
	        }, function (err) {
	          console.log('Could not update project');
	        });
	      }, function () {});
	    }
	  }]);
	
	  return ProjectBoardComponent;
	}();
	
	exports.default = angular.module('conduu.projectBoard', [uiRouter]).config(_projectBoard2.default).component('projectBoard', {
	  template: __webpack_require__(660),
	  controller: ProjectBoardComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('project-board', {
	    url: '/project/:id',
	    template: '<project-board></project-board>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>{{ctrl.project.name}}</h2>\r\n      <li><a href=\"/project/list\">Projects</a></li>\r\n      <li class=\"active\"><a href=\"#\">{{ctrl.project.name}}</a></li>\r\n      <div class=\"btn-group\" role=\"group\" style=\"float: right; position:relative; top:-16px\">\r\n        <button type=\"button\" ng-click=\"ctrl.setAsTable(false)\" class=\"btn btn-default\" ng-class=\"{'active': !ctrl.asTable}\"><i class=\"fa fa-fw fa-th\"></i></button>\r\n        <button type=\"button\" ng-click=\"ctrl.setAsTable(true)\"  class=\"btn btn-default\" ng-class=\"{'active': ctrl.asTable}\"><i class=\"fa fa-fw fa-table\"></i></button>\r\n      </div>\r\n    </ol>\r\n\r\n    <div class=\"col-md-6\">\r\n      <h3 class=\"separator\"><span>General</span></h3>\r\n\r\n      <dl class=\"dl-horizontal\">\r\n        <dt>Project Manager</dt>\r\n        <dd>{{ctrl.project.projectLead.shortName || '-'}}</dd>\r\n\r\n        <dt>Project Start</dt>\r\n        <dd>{{ctrl.project.startDate | date:'yyyy-MM-dd'}}</dd>\r\n\r\n        <dt>Target Date</dt>\r\n        <dd>{{ctrl.project.targetDate | date:'yyyy-MM-dd'}}</dd>\r\n\r\n        <dt>Progress</dt>\r\n        <dd>\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-10\">\r\n              <div class=\"progress\" style=\"height: 3px; margin-top:10px\">\r\n                <div class=\"progress-bar progress-bar-primary\" style=\"width: {{ctrl.project.progress}}%\"></div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-xs-2\">\r\n              {{ctrl.project.progress || 0}}%\r\n            </div>\r\n          </div>\r\n        </dd>\r\n      </dl>\r\n    </div>\r\n\r\n    <div class=\"col-md-6\">\r\n      <h3 class=\"separator\"><span>Description</span></h3>\r\n      <span>{{ctrl.project.description}}</span>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <h3 class=\"separator\" ng-hide=\"ctrl.asTable\"><span>Project Board</span></h3>\r\n      <h3 class=\"separator\" ng-show=\"ctrl.asTable\"><span>Project Items</span></h3>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\" ng-show=\"ctrl.asTable\">\r\n      <table ng-if=\"ctrl.items\" dt-options=\"ctrl.dtOptions\" datatable=\"ng\" class=\"table table-striped custom-view-grouped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>#</th>\r\n          <th>Status</th>\r\n          <th>Title</th>\r\n          <th>Description</th>\r\n          <th>Assigned</th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"item in ctrl.items track by $index\" class=\"text-{{item.color}}\">\r\n          <td>{{$index}}</td>\r\n          <td>{{item.state}}</td>\r\n          <td>{{item.title}}</td>\r\n          <td>{{item.description}}</td>\r\n          <td>-</td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n    <div data-ng-model=\"ctrl.project\" id=\"board\" ng-hide=\"ctrl.asTable\">\r\n\r\n      <div id=\"columns\">\r\n        <div class=\"col-md-{{12/ctrl.project.columns.length | number:'0'}} col-sm-6 col-xs-12\"\r\n             style=\"padding:4px\"\r\n             ng-repeat=\"column in ctrl.project.columns\"\r\n             data-columnindex=\"{{$index}}\" id=\"column{{$index}}\">\r\n          <div class=\"column bs-callout bs-callout-{{column.color}}\">\r\n            <div class=\"columnHeader\">\r\n              <h4 class=\"separator\"><span>{{column.name}} ({{column.items.length}})</span><span style=\"float:right\"><a href=\"#\" ng-click=\"ctrl.openNewProjectItemModal($index)\" style=\"text-decoration:none\"><i class=\"fa fa-fw fa-plus\"></i></a></span></h4>\r\n            </div>\r\n            <div ng-if=\"!column.items.length\" class=\"text-muted\"><p style=\"text-align:center\"><br/><a href=\"#\" ng-click=\"ctrl.openNewProjectItemModal($index)\">Create an item</a> or drop one here<br/><i class=\"fa fa-arrow-down\"></i></p></div>\r\n            <ul class=\"cards card-list\" column-idx=\"{{$index}}\" data-as-sortable=\"ctrl.dragControlListeners\" data-ng-model=\"column.items\" style=\"padding:8px\">\r\n              <li class=\"card\" ng-repeat=\"card in column.items\" as-sortable-item style=\"margin-top: 20px; padding-bottom: 12px;background-color: cornsilk;\" ng-style=\"card.highlight && {'border': '1px solid ' + column.colorcode} \" ng-class=\"{'card-danger':card.progressActual && card.progressTarget && card.progressActual > card.progressTarget}\">\r\n                <!-- style: background-color: papayawhip; -->\r\n                <div as-sortable-item-handle>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-xs-12\">\r\n                      <inline-dropdown-menu style=\"position:absolute; right: -2px; top:-12px\" icon=\"ellipsis-v\" context=\"card\" menu=\"ctrl.dropdownmenu\"></inline-dropdown-menu>\r\n                      <span class=\"card-title\">{{card.title}}</span>\r\n                      <br/>\r\n                      <span style=\"font-size: x-small\">{{card.description}}</span>\r\n                      <br/><br/>\r\n                    </div>\r\n                    <div class=\"col-xs-12\">\r\n                      <div class=\"progress\" style=\"height: 1px; margin-bottom: 8px\">\r\n                        <div ng-if=\"!card.progressActual || !card.progressTarget\" class=\"progress-bar\" role=\"progressbar\" style=\"width: 0%;\"></div>\r\n                        <div ng-if=\"card.progressActual && card.progressTarget\" class=\"progress-bar\" role=\"progressbar\" ng-class=\"{'progress-bar-danger':card.progressActual && card.progressTarget && card.progressActual > card.progressTarget}\" style=\"width: {{card.progressActual / card.progressTarget * 100}}%; background-color:{{column.colorcode}}\"></div>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"col-xs-12\">\r\n                      <div style=\"float:left\">\r\n                        <img ng-if=\"card.assignedTo.profile.image\" ng-src=\"{{card.userImage}}\" style=\"height:16px; width:16px\" />\r\n                        <img ng-if=\"!card.assignedTo.profile.image && card.assignedTo.lastName\" ng-src=\"https://ui-avatars.com/api/?name={{card.assignedTo.firstName}}+{{card.assignedTo.lastName}}&background=333&&color=eee&size=16\" style=\"height:16px; width:16px\" />\r\n                        <span ng-if=\"card.assignedTo.lastName\" style=\"font-size:smaller;\">{{card.assignedTo.shortName}}</span>\r\n                        <span ng-if=\"!card.assignedTo.lastName\" style=\"font-size:smaller;\" class=\"text-muted\">Unassigned</span>\r\n                      </div>\r\n                      <div style=\"float:right\">\r\n                        <span ng-if=\"card.progressActual && card.progressTarget\" ng-class=\"{'text-danger progress-danger':card.progressActual > card.progressTarget}\" style=\"font-size:smaller;\">{{card.progressActual}}/{{card.progressTarget}}</span>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <nta-section context=\"project\" context-id=\"ctrl.projectId\" data=\"ctrl.project\" service=\"ctrl.ProjectService\" on-refresh=\"ctrl.refreshData()\"></nta-section>\r\n\r\n      <h3 class=\"separator\"><span>Attachments <small><a href=\"#\" ng-click=\"ctrl.openAssetUploadModal()\"><i class=\"fa fa-upload\"></i> Upload Files</a></small></span></h3>\r\n\r\n      <attachment-list attachments=\"ctrl.project.attachments\" context-id=\"ctrl.projectId\" service=\"ctrl.ProjectService\"></attachment-list>\r\n\r\n      <br/>\r\n\r\n      <div style=\"float:right\" >\r\n        <label>{{ctrl.isPinned ? 'Pinned' : \"Not Pinned\"}}&nbsp;</label> <toggle ng-model=\"ctrl.isPinned\" ng-change=\"ctrl.PinnedItems.toggleProject(ctrl.projectId, ctrl.project.name)\" on=\"<i class='fa fa-fw fa-map-pin'>\" off=\"<i class='fa fa-fw fa-times'>\" onstyle=\"btn-success\" offstyle=\"btn-default\"></toggle>\r\n      </div>\r\n      <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var ProjectItemEditComponent = exports.ProjectItemEditComponent = function () {
	  /*@ngInject*/
	  ProjectItemEditComponent.$inject = ['ProjectItemService', '$uibModal', 'User', 'dialogs', 'SettingsService'];
	  function ProjectItemEditComponent(ProjectItemService, $uibModal, User, dialogs, SettingsService) {
	    var _this = this;
	
	    _classCallCheck(this, ProjectItemEditComponent);
	
	    this.$onInit = function () {
	      _this.config = _this.resolve.config;
	
	      if (_this.config.hasOwnProperty("data")) {
	        _this.projectItem = angular.copy(_this.config.data);
	
	        if (_this.projectItem.assignedTo) _this.projectItem.assignedTo = _this.projectItem.assignedTo._id;
	
	        if (_this.projectItem.progressActual || _this.projectItem.progressTarget) _this.trackTime = true;
	      }
	    };
	
	    this.ProjectItemService = ProjectItemService;
	    this.$uibModal = $uibModal;
	    this.dialogs = dialogs;
	    this.User = User;
	
	    this.projectItem = {
	      highlight: false
	    };
	    this.users = [];
	
	    this.User.query(function (data) {
	      _this.users = data.map(function (user) {
	        return {
	          value: user._id,
	          name: user.shortName || user.firstName + ' ' + user.lastName
	        };
	      });
	    });
	  }
	
	  _createClass(ProjectItemEditComponent, [{
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess(projectItem) {
	          var infotxt = that.config.data ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "The project item has been " + infotxt + " successfully");
	          dlg.result.then(function () {
	            that.close({ $value: projectItem });
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        if (!this.trackTime) {
	          delete this.projectItem.progressActual;
	          delete this.projectItem.progressTarget;
	        }
	
	        if (this.config.data) {
	          this.ProjectItemService.update({ id: this.projectItem._id }, this.projectItem, onSuccess, onError);
	        } else {
	          this.ProjectItemService.save(this.projectItem, onSuccess, onError);
	        }
	      }
	    }
	  }, {
	    key: 'userLookup',
	    value: function userLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'userLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (user) {
	        that.projectItem.assignedTo = user._id;
	      }, function () {});
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return ProjectItemEditComponent;
	}();
	
	exports.default = angular.module('conduu.projectItemEdit', []).component('projectItemEdit', {
	  template: __webpack_require__(662),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: ProjectItemEditComponent
	}).name;

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"form\" name=\"form\" ng-submit=\"$ctrl.create(form)\" novalidate>\r\n  <div class=\"modal-header\">\r\n    <h3 class=\"modal-title\" id=\"modal-title\">Project Item Edit</h3>\r\n  </div>\r\n  <div class=\"modal-body\" id=\"modal-body\">\r\n\r\n      <!-- Title -->\r\n      <div class=\"form-group\" ng-class=\"{ 'has-success': form.title.$valid && $ctrl.submitted,\r\n                                          'has-error': form.title.$invalid && $ctrl.submitted }\">\r\n        <label>Title</label>\r\n        <br/>\r\n        <input type=\"text\" name=\"subject\" class=\"form-control\" ng-model=\"$ctrl.projectItem.title\" required/>\r\n      </div>\r\n\r\n      <!-- Description -->\r\n      <div class=\"form-group\" ng-class=\"{ 'has-success': form.description.$valid && $ctrl.submitted,\r\n                                          'has-error': form.description.$invalid && $ctrl.submitted }\">\r\n        <label>Description</label>\r\n        <br/>\r\n        <textarea name=\"description\" class=\"form-control big-textfield\" ng-model=\"$ctrl.projectItem.description\"></textarea>\r\n      </div>\r\n\r\n      <!-- Assigned To -->\r\n      <div class=\"form-group\" ng-class=\"{ 'has-success': form.assignedTo.$valid && ctrl.submitted,\r\n                                          'has-error': form.assignedTo.$invalid && ctrl.submitted }\">\r\n          <label>Assigned To</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\" style=\"display: inline-block\">\r\n              <select class=\"form-control\" ng-options=\"o.value as o.name for o in $ctrl.users\" ng-model=\"$ctrl.projectItem.assignedTo\"\r\n                      style=\"display: inline-block; width: auto; min-width:180px\"></select>\r\n              <span class=\"input-group-btn\">\r\n                <a class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.userLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                <a class=\"btn btn-danger\" ng-disabled=\"!$ctrl.projectItem.assignedTo\" ng-click=\"$ctrl.projectItem.assignedTo = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n          </span>\r\n          </div>\r\n      </div>\r\n\r\n      <!-- Track Time -->\r\n      <div class=\"form-group\">\r\n          <label><input type=\"checkbox\" ng-model=\"$ctrl.trackTime\"> Track Progress</label>\r\n      </div>\r\n\r\n      <div class=\"col-xs-6\" ng-show=\"$ctrl.trackTime\">\r\n          <!-- Progress Actual -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.title.$valid && $ctrl.submitted,\r\n                                          'has-error': form.title.$invalid && $ctrl.submitted }\">\r\n              <label>Progress (Actual)</label>\r\n              <br/>\r\n              <input type=\"number\" min=\"0\" step=\"0.25\" name=\"subject\" class=\"form-control\" ng-model=\"$ctrl.projectItem.progressActual\" />\r\n          </div>\r\n      </div>\r\n      <div class=\"col-xs-6\" ng-show=\"$ctrl.trackTime\">\r\n          <!-- Progress Target -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.title.$valid && $ctrl.submitted,\r\n                                          'has-error': form.title.$invalid && $ctrl.submitted }\">\r\n              <label>Progress (Target/Planned)</label>\r\n              <br/>\r\n              <input type=\"number\" min=\"0\" step=\"0.25\" name=\"subject\" class=\"form-control\" ng-model=\"$ctrl.projectItem.progressTarget\" />\r\n          </div>\r\n      </div>\r\n\r\n      <!-- Highlight -->\r\n      <div class=\"form-group\">\r\n          <label><input type=\"checkbox\" ng-model=\"$ctrl.projectItem.highlight\"> Highlight this item</label>\r\n      </div>\r\n\r\n      <!-- Due Date\r\n<div class=\"col-md-6 col-xs-12\" style=\"padding:0px\">\r\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.dueDate.$valid && ctrl.submitted,\r\n                                    'has-error': form.dueDate.$invalid && ctrl.submitted }\">\r\n    <label>Due Date</label>\r\n    <br/>\r\n\r\n    <div class=\"input-group\" style=\"display: inline-block\">\r\n      <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"$ctrl.task.dueDate\" is-open=\"$ctrl.dueDatePopupOpened\"\r\n             ng-required=\"true\" close-text=\"Close\" style=\"display: inline-block; width: auto; min-width:180px\" />\r\n      <span class=\"input-group-btn\">\r\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.openDueDatePopup()\"><i class=\"fa fa-fw fa-calendar\"></i></button>\r\n    </span>\r\n    </div>\r\n  </div>\r\n</div>\r\n-->\r\n\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"!$ctrl.projectItem.title\" type=\"button\">OK</button>\r\n    <a class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\">Cancel</a>\r\n  </div>\r\n</form>"

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ProjectService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProjectService = ProjectService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function ProjectService($resource) {
	  return $resource('/api/projects/:id', {
	    id: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	    },
	    patch: {
	      method: 'PATCH'
	    },
	    addAttachments: {
	      method: 'PUT',
	      url: "/api/projects/:id/attachments"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.ProjectService', []).factory('ProjectService', ProjectService).name;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ProjectItemService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProjectItemService = ProjectItemService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function ProjectItemService($resource) {
	  return $resource('/api/project-items/:id', {
	    id: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	    },
	    patch: {
	      method: 'PATCH'
	    }
	  });
	}
	
	exports.default = angular.module('conduu.ProjectItemService', []).factory('ProjectItemService', ProjectItemService).name;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! ngstorage 0.3.10 | Copyright (c) 2016 Gias Kay Lee | MIT License */!function(a,b){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):a.hasOwnProperty("angular")?b(a.angular):"object"==typeof exports&&(module.exports=b(require("angular")))}(this,function(a){"use strict";function b(a,b){var c;try{c=a[b]}catch(d){c=!1}if(c){var e="__"+Math.round(1e7*Math.random());try{a[b].setItem(e,e),a[b].removeItem(e,e)}catch(d){c=!1}}return c}function c(c){var d=b(window,c);return function(){var e="ngStorage-";this.setKeyPrefix=function(a){if("string"!=typeof a)throw new TypeError("[ngStorage] - "+c+"Provider.setKeyPrefix() expects a String.");e=a};var f=a.toJson,g=a.fromJson;this.setSerializer=function(a){if("function"!=typeof a)throw new TypeError("[ngStorage] - "+c+"Provider.setSerializer expects a function.");f=a},this.setDeserializer=function(a){if("function"!=typeof a)throw new TypeError("[ngStorage] - "+c+"Provider.setDeserializer expects a function.");g=a},this.supported=function(){return!!d},this.get=function(a){return d&&g(d.getItem(e+a))},this.set=function(a,b){return d&&d.setItem(e+a,f(b))},this.remove=function(a){d&&d.removeItem(e+a)},this.$get=["$rootScope","$window","$log","$timeout","$document",function(d,h,i,j,k){var l,m,n=e.length,o=b(h,c),p=o||(i.warn("This browser does not support Web Storage!"),{setItem:a.noop,getItem:a.noop,removeItem:a.noop}),q={$default:function(b){for(var c in b)a.isDefined(q[c])||(q[c]=a.copy(b[c]));return q.$sync(),q},$reset:function(a){for(var b in q)"$"===b[0]||delete q[b]&&p.removeItem(e+b);return q.$default(a)},$sync:function(){for(var a,b=0,c=p.length;c>b;b++)(a=p.key(b))&&e===a.slice(0,n)&&(q[a.slice(n)]=g(p.getItem(a)))},$apply:function(){var b;if(m=null,!a.equals(q,l)){b=a.copy(l),a.forEach(q,function(c,d){a.isDefined(c)&&"$"!==d[0]&&(p.setItem(e+d,f(c)),delete b[d])});for(var c in b)p.removeItem(e+c);l=a.copy(q)}},$supported:function(){return!!o}};return q.$sync(),l=a.copy(q),d.$watch(function(){m||(m=j(q.$apply,100,!1))}),h.addEventListener&&h.addEventListener("storage",function(b){if(b.key){var c=k[0];c.hasFocus&&c.hasFocus()||e!==b.key.slice(0,n)||(b.newValue?q[b.key.slice(n)]=g(b.newValue):delete q[b.key.slice(n)],l=a.copy(q),d.$apply())}}),h.addEventListener&&h.addEventListener("beforeunload",function(){q.$apply()}),q}]}}return a=a&&a.module?a:window.angular,a.module("ngStorage",[]).provider("$localStorage",c("localStorage")).provider("$sessionStorage",c("sessionStorage"))});

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	recentVisitsService.$inject = ['$localStorage'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.recentVisitsService = recentVisitsService;
	var angular = __webpack_require__(14);
	
	function recentVisitsService($localStorage) {
	  'ngInject';
	
	  var limit = 7;
	
	  var typeMap = {
	    "wo": "workItems",
	    "ccr": "workItems",
	    "sr": "workItems",
	
	    "project": "projects",
	
	    "community": "portfolio",
	    "property": "portfolio",
	    "contact": "portfolio",
	    "vendor": "portfolio",
	    "webaccess": "portfolio",
	    "custom": "portfolio"
	  };
	
	  var addToSessionStore = function addToSessionStore(type, item) {
	    var id = item.id;
	    var collection = typeMap[type];
	
	    var idx = $localStorage.recent[collection].findIndex(function (storageItem) {
	      return storageItem.id == item.id;
	    });
	
	    if (idx == -1) {
	      $localStorage.recent[collection].unshift(item);
	    } else {
	      $localStorage.recent[collection].splice(idx, 1);
	      $localStorage.recent[collection].unshift(item);
	    }
	
	    if ($localStorage.recent[collection].length > limit) {
	      $localStorage.recent[collection].splice(limit, 1);
	    }
	  };
	
	  var typeUrlMap = {
	    "wo": "/workorder/ticket/detail/",
	    "sr": "/servicerequest/ticket/detail/",
	    "ccr": "/violation/ticket/detail/",
	
	    "community": "/community/",
	    "property": "/property/",
	    "contact": "/contact/",
	    "vendor": "/vendor/",
	
	    "webaccess": "/webaccess/",
	    "custom": "/custom/"
	  };
	
	  if (!$localStorage.recent) $localStorage.recent = {};
	
	  if (!$localStorage.recent.workItems) $localStorage.recent.workItems = [];
	
	  if (!$localStorage.recent.projects) $localStorage.recent.projects = [];
	
	  if (!$localStorage.recent.portfolio) $localStorage.recent.portfolio = [];
	
	  return {
	
	    workItems: $localStorage.recent.workItems,
	    projects: $localStorage.recent.projects,
	    portfolio: $localStorage.recent.portfolio,
	
	    addWorkItem: function addWorkItem(id, type, name) {
	      addToSessionStore(type, {
	        id: id,
	        name: name,
	        path: typeUrlMap[type] + id
	      });
	    },
	    addProject: function addProject(id, name) {
	      addToSessionStore("project", {
	        id: id,
	        name: name,
	        path: "/project/" + id
	      });
	    },
	    addPortfolio: function addPortfolio(id, type, name) {
	      addToSessionStore(type, {
	        id: id,
	        name: name,
	        path: typeUrlMap[type] + id
	      });
	    },
	    addCustomPortfolio: function addCustomPortfolio(id, type, customType, name) {
	      addToSessionStore(type, {
	        id: id,
	        name: name,
	        path: typeUrlMap[type] + customType + "/" + id
	      });
	    }
	  };
	}
	
	exports.default = angular.module('conduu.recentVisits', []).factory('RecentVisits', recentVisitsService).name;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	pinnedItemsService.$inject = ['$localStorage'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pinnedItemsService = pinnedItemsService;
	var angular = __webpack_require__(14);
	
	function pinnedItemsService($localStorage) {
	  'ngInject';
	
	  var typeMap = {
	    "wo": "workItems",
	    "ccr": "workItems",
	    "sr": "workItems",
	
	    "project": "projects",
	
	    "community": "portfolio",
	    "property": "portfolio",
	    "contact": "portfolio",
	    "vendor": "portfolio",
	    "webaccess": "portfolio",
	    "custom": "portfolio"
	  };
	
	  var toggleInStore = function toggleInStore(type, item) {
	    var id = item.id;
	    var collection = typeMap[type];
	    var idx = $localStorage.pinned[collection].findIndex(function (storageItem) {
	      return storageItem.id == item.id;
	    });
	
	    if (idx == -1) {
	      $localStorage.pinned[collection].push(item);
	    } else {
	      $localStorage.pinned[collection].splice(idx, 1);
	    }
	  };
	
	  var typeUrlMap = {
	    "wo": "/workorder/ticket/detail/",
	    "sr": "/servicerequest/ticket/detail/",
	    "ccr": "/violation/ticket/detail/",
	
	    "community": "/community/",
	    "property": "/property/",
	    "contact": "/contact/",
	    "vendor": "/vendor/",
	    "webaccess": "/webaccess/",
	    "custom": "/custom/"
	
	  };
	
	  if (!$localStorage.pinned) $localStorage.pinned = {};
	
	  if (!$localStorage.pinned.workItems) $localStorage.pinned.workItems = [];
	
	  if (!$localStorage.pinned.projects) $localStorage.pinned.projects = [];
	
	  if (!$localStorage.pinned.portfolio) $localStorage.pinned.portfolio = [];
	
	  return {
	
	    workItems: $localStorage.pinned.workItems,
	    projects: $localStorage.pinned.projects,
	    portfolio: $localStorage.pinned.portfolio,
	
	    isPinnedWorkItem: function isPinnedWorkItem(id) {
	      return $localStorage.pinned.workItems.findIndex(function (item) {
	        return item.id == id;
	      }) !== -1;
	    },
	    toggleWorkItem: function toggleWorkItem(id, type, name) {
	      toggleInStore(type, {
	        id: id,
	        name: name,
	        path: typeUrlMap[type] + id
	      });
	    },
	    isPinnedProject: function isPinnedProject(id) {
	      return $localStorage.pinned.projects.findIndex(function (item) {
	        return item.id == id;
	      }) !== -1;
	    },
	    toggleProject: function toggleProject(id, name) {
	      toggleInStore("project", {
	        id: id,
	        name: name,
	        path: "/project/" + id
	      });
	    },
	    isPinnedPortfolio: function isPinnedPortfolio(id) {
	      return $localStorage.pinned.portfolio.findIndex(function (item) {
	        return item.id == id;
	      }) !== -1;
	    },
	    togglePortfolio: function togglePortfolio(id, type, name) {
	      toggleInStore(type, {
	        id: id,
	        name: name,
	        path: typeUrlMap[type] + id
	      });
	    },
	    toggleCustomPortfolio: function toggleCustomPortfolio(id, type, customType, name) {
	      toggleInStore(type, {
	        id: id,
	        name: name,
	        path: typeUrlMap[type] + customType + "/" + id
	      });
	    }
	  };
	}
	
	exports.default = angular.module('conduu.pinnedItems', []).factory('PinnedItems', pinnedItemsService).name;

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	!function(){"use strict";angular.module("ui.toggle",[]).value("$toggleSuppressError",!1).constant("toggleConfig",{on:"On",off:"Off",size:"",onstyle:"btn-primary",offstyle:"btn-default",style:""}).controller("ToggleController",["$scope","$attrs","$interpolate","$log","toggleConfig","$toggleSuppressError",function(e,t,n,l,o){var s=this,a={$setViewValue:angular.noop};angular.forEach(["on","off","size","onstyle","offstyle","style"],function(l,a){s[l]=angular.isDefined(t[l])?6>a?n(t[l])(e.$parent):e.$parent.$eval(t[l]):o[l]}),this.init=function(n){a=n,s.computeStyle(),a.$render=function(){s.toggle()},a.$viewChangeListeners.push(function(){e.$eval(t.ngChange)})},this.computeStyle=function(){var t=s.element.find("label");angular.element(t[0]).html(s.on),angular.element(t[1]).html(s.off);var n=s.element.find("span"),l=s.width||Math.max(t[0].offsetWidth,t[1].offsetWidth)+n[0].offsetWidth/2,o=s.height||Math.max(t[0].offsetHeight,t[1].offsetHeight),a=s.element.find("div"),i=a[0].offsetWidth,r=a[1].offsetHeight;e.wrapperStyle={},e.wrapperStyle.width=l>i?l+"px":i+"px",e.wrapperStyle.height=o>r&&"btn-xs"!==s.size&&"btn-sm"!==s.size?o+"px":r+"px",e.onClass=[s.onstyle,s.size,"toggle-on"],e.offClass=[s.offstyle,s.size,"toggle-off"],e.handleClass=[s.size,"toggle-handle"]},this.toggle=function(){this.isOn=angular.isDefined(a.$viewValue)?a.$viewValue:!1,e.wrapperClass=this.isOn?[s.onstyle,s.size,s.style]:[s.offstyle,"off ",s.size,s.style]},e.onSwitch=function(){a.$setViewValue(!a.$viewValue),a.$render()},angular.forEach(["ngModel"],function(n){var l=e.$parent.$watch(t[n],function(){a.$render()});e.$parent.$on("$destroy",function(){l()})}),angular.forEach(["on","off","size","onstyle","offstyle","style"],function(e){t.$observe(e,function(t){s[e]!==t&&(s[e]=t,s.computeStyle())})})}]).directive("toggle",function(){return{restrict:"E",transclude:!0,template:'<div class="toggle btn" ng-class="wrapperClass" ng-style="wrapperStyle" ng-click="onSwitch()"><div class="toggle-group"><label class="btn" ng-class="onClass"></label><label class="btn active" ng-class="offClass"></label><span class="btn btn-default" ng-class="handleClass"></span></div></div>',scope:{bindModel:"=ngModel"},require:["toggle","ngModel"],controller:"ToggleController",controllerAs:"toggle",compile:function(){return{pre:function(e,t,n,l){var o=l[0],s=l[1];o.element=t,o.init(s)},post:function(){}}}}})}();

/***/ }),
/* 669 */
5,
/* 670 */,
/* 671 */
/***/ (function(module, exports) {

	
	'use strict';
	
	angular.module('ui.dashboard', ['ui.bootstrap', 'ui.sortable']);
	
	angular.module('ui.dashboard').directive('dashboard', ['WidgetModel', 'WidgetDefCollection', '$uibModal', 'DashboardState', '$log', function (WidgetModel, WidgetDefCollection, $uibModal, DashboardState, $log) {
	
	  return {
	    restrict: 'A',
	    templateUrl: function templateUrl(element, attr) {
	      return attr.templateUrl ? attr.templateUrl : 'components/directives/dashboard/dashboard.html';
	    },
	    scope: true,
	
	    controller: ['$scope', '$attrs', function (scope, attrs) {
	      var defaults = {
	        stringifyStorage: true,
	        hideWidgetSettings: false,
	        hideWidgetClose: false,
	        settingsModalOptions: {
	          templateUrl: 'components/directives/dashboard/widget-settings-template.html',
	          controller: 'WidgetSettingsCtrl'
	        },
	        onSettingsClose: function onSettingsClose(result, widget) {
	          jQuery.extend(true, widget, result);
	        },
	        onSettingsDismiss: function onSettingsDismiss(reason) {
	          $log.info('widget settings were dismissed. Reason: ', reason);
	        }
	      };
	
	      scope.options = scope.$eval(attrs.dashboard);
	
	      scope.options.settingsModalOptions = scope.options.settingsModalOptions !== undefined ? scope.options.settingsModalOptions : {};
	
	      _.defaults(scope.options.settingsModalOptions, defaults.settingsModalOptions);
	
	      _.defaults(scope.options, defaults);
	
	      var sortableDefaults = {
	        stop: function stop() {
	          scope.saveDashboard();
	        },
	        handle: '.widget-header',
	        distance: 5
	      };
	      scope.sortableOptions = angular.extend({}, sortableDefaults, scope.options.sortableOptions || {});
	    }],
	    link: function link(scope) {
	      scope.defaultWidgets = scope.options.defaultWidgets;
	
	      scope.widgetDefs = new WidgetDefCollection(scope.options.widgetDefinitions);
	      var count = 1;
	
	      scope.dashboardState = new DashboardState(scope.options.storage, scope.options.storageId, scope.options.storageHash, scope.widgetDefs, scope.options.stringifyStorage);
	
	      function getWidget(widgetToInstantiate) {
	        if (typeof widgetToInstantiate === 'string') {
	          widgetToInstantiate = {
	            name: widgetToInstantiate
	          };
	        }
	
	        var defaultWidgetDefinition = scope.widgetDefs.getByName(widgetToInstantiate.name);
	        if (!defaultWidgetDefinition) {
	          throw 'Widget ' + widgetToInstantiate.name + ' is not found.';
	        }
	
	        var title;
	        if (!widgetToInstantiate.title && !defaultWidgetDefinition.title) {
	          widgetToInstantiate.title = 'Widget ' + count++;
	        }
	
	        return new WidgetModel(defaultWidgetDefinition, widgetToInstantiate);
	      }
	
	      scope.addWidget = function (widgetToInstantiate, doNotSave) {
	        var widget = getWidget(widgetToInstantiate);
	
	        scope.widgets.push(widget);
	        if (!doNotSave) {
	          scope.saveDashboard();
	        }
	
	        return widget;
	      };
	
	      scope.prependWidget = function (widgetToInstantiate, doNotSave) {
	        var widget = getWidget(widgetToInstantiate);
	
	        scope.widgets.unshift(widget);
	        if (!doNotSave) {
	          scope.saveDashboard();
	        }
	
	        return widget;
	      };
	
	      scope.removeWidget = function (widget) {
	        scope.widgets.splice(_.indexOf(scope.widgets, widget), 1);
	        scope.saveDashboard();
	      };
	
	      scope.openWidgetSettings = function (_widget) {
	        var options = _.defaults({ scope: scope }, _widget.settingsModalOptions, scope.options.settingsModalOptions);
	
	        options.resolve = {
	          widget: function widget() {
	            return _widget;
	          }
	        };
	
	        var modalInstance = $uibModal.open(options);
	        var onClose = _widget.onSettingsClose || scope.options.onSettingsClose;
	        var onDismiss = _widget.onSettingsDismiss || scope.options.onSettingsDismiss;
	
	        modalInstance.result.then(function (result) {
	          onClose(result, _widget, scope);
	
	          scope.$emit('widgetChanged', _widget);
	        }, function (reason) {
	          onDismiss(reason, scope);
	        });
	      };
	
	      scope.clear = function (doNotSave) {
	        scope.widgets = [];
	        if (doNotSave === true) {
	          return;
	        }
	        scope.saveDashboard();
	      };
	
	      scope.addWidgetInternal = function (event, widgetDef) {
	        event.preventDefault();
	        scope.addWidget(widgetDef);
	      };
	
	      scope.saveDashboard = function (force) {
	        if (!scope.options.explicitSave) {
	          return scope.dashboardState.save(scope.widgets);
	        } else {
	          if (!angular.isNumber(scope.options.unsavedChangeCount)) {
	            scope.options.unsavedChangeCount = 0;
	          }
	          if (force) {
	            scope.options.unsavedChangeCount = 0;
	            return scope.dashboardState.save(scope.widgets);
	          } else {
	            ++scope.options.unsavedChangeCount;
	          }
	        }
	      };
	
	      scope.externalSaveDashboard = function (force) {
	        if (angular.isDefined(force)) {
	          return scope.saveDashboard(force);
	        } else {
	          return scope.saveDashboard(true);
	        }
	      };
	
	      scope.loadWidgets = function (widgets) {
	        scope.savedWidgetDefs = widgets;
	        scope.clear(true);
	        _.each(widgets, function (widgetDef) {
	          scope.addWidget(widgetDef, true);
	        });
	      };
	
	      scope.resetWidgetsToDefault = function () {
	        scope.loadWidgets(scope.defaultWidgets);
	        scope.saveDashboard();
	      };
	
	      var savedWidgetDefs = scope.dashboardState.load();
	
	      function handleStateLoad(saved) {
	        scope.options.unsavedChangeCount = 0;
	        if (saved && saved.length) {
	          scope.loadWidgets(saved);
	        } else if (scope.defaultWidgets) {
	          scope.loadWidgets(scope.defaultWidgets);
	        } else {
	          scope.clear(true);
	        }
	      }
	
	      if (angular.isArray(savedWidgetDefs)) {
	        handleStateLoad(savedWidgetDefs);
	      } else if (savedWidgetDefs && angular.isObject(savedWidgetDefs) && angular.isFunction(savedWidgetDefs.then)) {
	        savedWidgetDefs.then(handleStateLoad, handleStateLoad);
	      } else {
	        handleStateLoad();
	      }
	
	      scope.options.addWidget = scope.addWidget;
	      scope.options.prependWidget = scope.prependWidget;
	      scope.options.loadWidgets = scope.loadWidgets;
	      scope.options.saveDashboard = scope.externalSaveDashboard;
	      scope.options.removeWidget = scope.removeWidget;
	      scope.options.openWidgetSettings = scope.openWidgetSettings;
	      scope.options.clear = scope.clear;
	      scope.options.resetWidgetsToDefault = scope.resetWidgetsToDefault;
	      scope.options.currentWidgets = scope.widgets;
	
	      scope.$on('widgetChanged', function (event) {
	        event.stopPropagation();
	        scope.saveDashboard();
	      });
	    }
	  };
	}]);
	
	angular.module("ui.dashboard").run(["$templateCache", function ($templateCache) {
	  $templateCache.put("components/directives/dashboard/altDashboard.html", "<div>\n    <div class=\"btn-toolbar\" ng-if=\"!options.hideToolbar\">\n        <div class=\"btn-group\" ng-if=\"!options.widgetButtons\">\n            <span class=\"dropdown\" on-toggle=\"toggled(open)\">\n              <button type=\"button\" class=\"btn btn-primary dropdown-toggle\" ng-disabled=\"disabled\">\n                Button dropdown <span class=\"caret\"></span>\n              </button>\n              <ul class=\"dropdown-menu\" role=\"menu\">\n                <li ng-repeat=\"widget in widgetDefs\">\n                  <a href=\"#\" ng-click=\"addWidgetInternal($event, widget);\" class=\"dropdown-toggle\">{{widget.name}}</a>\n                </li>\n              </ul>\n            </span>\n        </div>\n\n        <div class=\"btn-group\" ng-if=\"options.widgetButtons\">\n            <button ng-repeat=\"widget in widgetDefs\"\n                    ng-click=\"addWidgetInternal($event, widget);\" type=\"button\" class=\"btn btn-primary\">\n                {{widget.name}}\n            </button>\n        </div>\n\n        <button class=\"btn btn-warning\" ng-click=\"resetWidgetsToDefault()\">Default Widgets</button>\n\n        <button ng-if=\"options.storage && options.explicitSave\" ng-click=\"options.saveDashboard()\" class=\"btn btn-success\" ng-hide=\"!options.unsavedChangeCount\">{{ !options.unsavedChangeCount ? \"Alternative - No Changes\" : \"Save\" }}</button>\n\n        <button ng-click=\"clear();\" ng-hide=\"!widgets.length\" type=\"button\" class=\"btn btn-info\">Clear</button>\n    </div>\n\n    <div ui-sortable=\"sortableOptions\" ng-model=\"widgets\" class=\"dashboard-widget-area\">\n        <div ng-repeat=\"widget in widgets\" ng-style=\"widget.style\" class=\"widget-container\" widget>\n            <div class=\"widget panel panel-default\">\n                <div class=\"widget-header panel-heading\">\n                    <h3 class=\"panel-title\">\n                        <span class=\"widget-title\" ng-dblclick=\"editTitle(widget)\" ng-hide=\"widget.editingTitle\">{{widget.title}}</span>\n                        <form action=\"\" class=\"widget-title\" ng-show=\"widget.editingTitle\" ng-submit=\"saveTitleEdit(widget, $event)\">\n                            <input type=\"text\" ng-model=\"widget.title\" ng-blur=\"titleLostFocus(widget, $event)\" class=\"form-control\">\n                        </form>\n                        <span class=\"label label-primary\" ng-if=\"!options.hideWidgetName\">{{widget.name}}</span>\n                        <span ng-click=\"removeWidget(widget);\" class=\"glyphicon glyphicon-remove\" ng-if=\"!options.hideWidgetClose\"></span>\n                        <span ng-click=\"openWidgetSettings(widget);\" class=\"glyphicon glyphicon-cog\" ng-if=\"!options.hideWidgetSettings\"></span>\n                    </h3>\n                </div>\n                <div class=\"panel-body widget-content\"></div>\n                <div class=\"widget-w-resizer\">\n                    <div ng-if=\"widget.enableVerticalResize\" class=\"nw-resizer\" ng-mousedown=\"grabResizer($event, \'nw\')\"></div>\n                    <div class=\"w-resizer\" ng-mousedown=\"grabResizer($event, \'w\')\"></div>\n                    <div ng-if=\"widget.enableVerticalResize\" class=\"sw-resizer\" ng-mousedown=\"grabResizer($event, \'sw\')\"></div>\n                </div>\n                <div class=\"widget-e-resizer\">\n                    <div ng-if=\"widget.enableVerticalResize\" class=\"ne-resizer\" ng-mousedown=\"grabResizer($event, \'ne\')\"></div>\n                    <div class=\"e-resizer\" ng-mousedown=\"grabResizer($event, \'e\')\"></div>\n                    <div ng-if=\"widget.enableVerticalResize\" class=\"se-resizer\" ng-mousedown=\"grabResizer($event, \'se\')\"></div>\n                </div>\n                <div ng-if=\"widget.enableVerticalResize\" class=\"widget-n-resizer\">\n                    <div class=\"nw-resizer\" ng-mousedown=\"grabResizer($event, \'nw\')\"></div>\n                    <div class=\"n-resizer\" ng-mousedown=\"grabResizer($event, \'n\')\"></div>\n                    <div class=\"ne-resizer\" ng-mousedown=\"grabResizer($event, \'ne\')\"></div>\n                </div>\n                <div ng-if=\"widget.enableVerticalResize\" class=\"widget-s-resizer\">\n                    <div class=\"sw-resizer\" ng-mousedown=\"grabResizer($event, \'sw\')\"></div>\n                    <div class=\"s-resizer\" ng-mousedown=\"grabResizer($event, \'s\')\"></div>\n                    <div class=\"se-resizer\" ng-mousedown=\"grabResizer($event, \'se\')\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
	  $templateCache.put("components/directives/dashboard/dashboard.html", "<div>\n    <div class=\"btn-toolbar\" ng-if=\"!options.hideToolbar\">\n        <div class=\"btn-group\" ng-if=\"!options.widgetButtons\">\n            <span class=\"dropdown\" on-toggle=\"toggled(open)\">\n              <button type=\"button\" class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\">\n                Button dropdown <span class=\"caret\"></span>\n              </button>\n              <ul class=\"dropdown-menu\" role=\"menu\">\n                <li ng-repeat=\"widget in widgetDefs\">\n                  <a href=\"#\" ng-click=\"addWidgetInternal($event, widget);\" class=\"dropdown-toggle\"><span class=\"label label-primary\">{{widget.name}}</span></a>\n                </li>\n              </ul>\n            </span>\n    </div>\n        <div class=\"btn-group\" ng-if=\"options.widgetButtons\">\n            <button ng-repeat=\"widget in widgetDefs\"\n                    ng-click=\"addWidgetInternal($event, widget);\" type=\"button\" class=\"btn btn-primary\">\n                {{widget.name}}\n            </button>\n        </div>\n\n        <button class=\"btn btn-warning\" ng-click=\"resetWidgetsToDefault()\">Default Widgets</button>\n\n        <button ng-if=\"options.storage && options.explicitSave\" ng-click=\"options.saveDashboard()\" class=\"btn btn-success\" ng-disabled=\"!options.unsavedChangeCount\">{{ !options.unsavedChangeCount ? \"all saved\" : \"save changes (\" + options.unsavedChangeCount + \")\" }}</button>\n\n        <button ng-click=\"clear();\" type=\"button\" class=\"btn btn-info\">Clear</button>\n    </div>\n\n    <div ui-sortable=\"sortableOptions\" ng-model=\"widgets\" class=\"dashboard-widget-area\">\n        <div ng-repeat=\"widget in widgets\" ng-style=\"widget.containerStyle\" class=\"widget-container\" widget>\n            <div class=\"widget panel panel-default\">\n                <div class=\"widget-header panel-heading\">\n                    <h3 class=\"panel-title\">\n                        <span class=\"widget-title\" ng-dblclick=\"editTitle(widget)\" ng-hide=\"widget.editingTitle\">{{widget.title}}</span>\n                        <form action=\"\" class=\"widget-title\" ng-show=\"widget.editingTitle\" ng-submit=\"saveTitleEdit(widget, $event)\">\n                            <input type=\"text\" ng-model=\"widget.title\" ng-blur=\"titleLostFocus(widget, $event)\" class=\"form-control\">\n                        </form>\n                        <span class=\"label label-primary\" ng-if=\"!options.hideWidgetName\">{{widget.name}}</span>\n                    </h3>\n                    <div class=\"buttons\">\n                        <span ng-click=\"removeWidget(widget);\" class=\"glyphicon glyphicon-remove\" ng-if=\"!options.hideWidgetClose\"></span>\n                        <span ng-click=\"openWidgetSettings(widget);\" class=\"glyphicon glyphicon-cog\" ng-if=\"!options.hideWidgetSettings\"></span>\n                        <span ng-click=\"widget.contentStyle.display = widget.contentStyle.display === \'none\' ? \'block\' : \'none\'\" class=\"glyphicon\" ng-class=\"{\'glyphicon-plus\': widget.contentStyle.display === \'none\', \'glyphicon-minus\': widget.contentStyle.display !== \'none\' }\"></span>\n                    </div>\n                </div>\n                <div class=\"panel-body widget-content\" ng-style=\"widget.contentStyle\"></div>\n                <div class=\"widget-w-resizer\">\n                    <div ng-if=\"widget.enableVerticalResize\" class=\"nw-resizer\" ng-mousedown=\"grabResizer($event, \'nw\')\"></div>\n                    <div class=\"w-resizer\" ng-mousedown=\"grabResizer($event, \'w\')\"></div>\n                    <div ng-if=\"widget.enableVerticalResize\" class=\"sw-resizer\" ng-mousedown=\"grabResizer($event, \'sw\')\"></div>\n                </div>\n                <div class=\"widget-e-resizer\">\n                    <div ng-if=\"widget.enableVerticalResize\" class=\"ne-resizer\" ng-mousedown=\"grabResizer($event, \'ne\')\"></div>\n                    <div class=\"e-resizer\" ng-mousedown=\"grabResizer($event, \'e\')\"></div>\n                    <div ng-if=\"widget.enableVerticalResize\" class=\"se-resizer\" ng-mousedown=\"grabResizer($event, \'se\')\"></div>\n                </div>\n                <div ng-if=\"widget.enableVerticalResize\" class=\"widget-n-resizer\">\n                    <div class=\"nw-resizer\" ng-mousedown=\"grabResizer($event, \'nw\')\"></div>\n                    <div class=\"n-resizer\" ng-mousedown=\"grabResizer($event, \'n\')\"></div>\n                    <div class=\"ne-resizer\" ng-mousedown=\"grabResizer($event, \'ne\')\"></div>\n                </div>\n                <div ng-if=\"widget.enableVerticalResize\" class=\"widget-s-resizer\">\n                    <div class=\"sw-resizer\" ng-mousedown=\"grabResizer($event, \'sw\')\"></div>\n                    <div class=\"s-resizer\" ng-mousedown=\"grabResizer($event, \'s\')\"></div>\n                    <div class=\"se-resizer\" ng-mousedown=\"grabResizer($event, \'se\')\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>");
	  $templateCache.put("components/directives/dashboard/widget-settings-template.html", "<div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h3>Widget Options <small>{{widget.title}}</small></h3>\n</div>\n\n<div class=\"modal-body\">\n    <form name=\"form\" novalidate class=\"form-horizontal\">\n        <div class=\"form-group\">\n            <label for=\"widgetTitle\" class=\"col-sm-2 control-label\">Title</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" name=\"widgetTitle\" ng-model=\"result.title\">\n            </div>\n        </div>\n        <div ng-if=\"widget.settingsModalOptions.partialTemplateUrl\"\n             ng-include=\"widget.settingsModalOptions.partialTemplateUrl\"></div>\n    </form>\n</div>\n\n<div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"cancel()\">Cancel</button>\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">OK</button>\n</div>");
	  $templateCache.put("components/directives/dashboardLayouts/SaveChangesModal.html", "<div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h3>Unsaved Changes to \"{{layout.title}}\"</h3>\n</div>\n\n<div class=\"modal-body\">\n    <p>You have {{layout.dashboard.unsavedChangeCount}} unsaved changes on this dashboard. Would you like to save them?</p>\n</div>\n\n<div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"cancel()\">Don\'t Save</button>\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Save</button>\n</div>");
	  $templateCache.put("components/directives/dashboardLayouts/dashboardLayouts.html", "<ul ui-sortable=\"sortableOptions\" ng-model=\"layouts\" class=\"nav nav-tabs layout-tabs\">\n    <li ng-repeat=\"layout in layouts\" ng-class=\"{ active: layout.active }\">\n        <a ng-click=\"makeLayoutActive(layout)\">\n            <span ng-dblclick=\"editTitle(layout)\" ng-show=\"!layout.editingTitle\">{{layout.title}}</span>\n            <form action=\"\" class=\"layout-title\" ng-show=\"layout.editingTitle\" ng-submit=\"saveTitleEdit(layout, $event)\">\n                <input type=\"text\" ng-model=\"layout.title\" ng-blur=\"titleLostFocus(layout, $event)\" class=\"form-control\" data-layout=\"{{layout.id}}\">\n            </form>\n            <span ng-if=\"!layout.locked\" ng-click=\"removeLayout(layout)\" class=\"glyphicon glyphicon-remove remove-layout-icon\"></span>\n            <!-- <span class=\"glyphicon glyphicon-pencil\"></span> -->\n            <!-- <span class=\"glyphicon glyphicon-remove\"></span> -->\n        </a>\n    </li>\n    <li>\n        <a ng-click=\"createNewLayout()\">\n            <span class=\"glyphicon glyphicon-plus\"></span>\n        </a>\n    </li>\n</ul>\n<div ng-repeat=\"layout in layouts | filter:isActive\" dashboard=\"layout.dashboard\" template-url=\"components/directives/dashboard/dashboard.html\"></div>");
	}]);
	
	
	'use strict';
	
	angular.module('ui.dashboard').directive('widget', ['$injector', function ($injector) {
	
	  return {
	
	    controller: 'DashboardWidgetCtrl',
	
	    link: function link(scope) {
	
	      var widget = scope.widget;
	      var dataModelType = widget.dataModelType;
	
	      if (dataModelType) {
	        var DataModelConstructor;
	
	        if (angular.isFunction(dataModelType)) {
	          DataModelConstructor = dataModelType;
	        } else if (angular.isString(dataModelType)) {
	          $injector.invoke([dataModelType, function (DataModelType) {
	            DataModelConstructor = DataModelType;
	          }]);
	        } else {
	          throw new Error('widget dataModelType should be function or string');
	        }
	
	        var ds;
	        if (widget.dataModelArgs) {
	          ds = new DataModelConstructor(widget.dataModelArgs);
	        } else {
	          ds = new DataModelConstructor();
	        }
	        widget.dataModel = ds;
	        ds.setup(widget, scope);
	        ds.init();
	        scope.$on('$destroy', _.bind(ds.destroy, ds));
	      }
	
	      scope.compileTemplate();
	      scope.$emit('widgetAdded', widget);
	    }
	
	  };
	}]);
	
	'use strict';
	
	angular.module('ui.dashboard').controller('DashboardWidgetCtrl', ['$scope', '$element', '$compile', '$window', '$timeout', function ($scope, $element, $compile, $window, $timeout) {
	
	  $scope.status = {
	    isopen: false
	  };
	  var resizeTimeoutId;
	
	  $scope.makeTemplateString = function () {
	
	    var widget = $scope.widget;
	
	    var templateString = '';
	    if (widget.templateUrl) {
	      templateString = '<div ng-include="\'' + widget.templateUrl + '\'"></div>';
	    } else if (widget.template) {
	      templateString = widget.template;
	    } else {
	      templateString = '<div ' + widget.directive;
	
	      if (widget.dataAttrName) {
	        widget.attrs = widget.attrs || {};
	        widget.attrs[widget.dataAttrName] = 'widgetData';
	      }
	
	      if (widget.attrs) {
	        if (widget.attrs[widget.directive]) {
	          templateString += '="' + widget.attrs[widget.directive] + '"';
	        }
	
	        _.each(widget.attrs, function (value, attr) {
	          if (attr !== widget.directive) {
	            templateString += ' ' + attr + '="' + value + '"';
	          }
	        });
	      }
	      templateString += '></div>';
	    }
	    return templateString;
	  };
	
	  $scope.grabResizer = function (e, region) {
	
	    var widget = $scope.widget;
	    var widgetElm = $element.find('.widget');
	
	    if (e.which !== 1) {
	      return;
	    }
	
	    e.stopPropagation();
	    e.originalEvent.preventDefault();
	
	    var initX = e.clientX;
	    var initY = e.clientY;
	
	    var currentWidthPixel = widgetElm.width() + 2;
	    var currentHeightPixel = widgetElm.height() + 2;
	    var widthUnits = (widget.containerStyle.width || '0%').match(/\%|px/)[0];
	
	    var parentWidth = $element.parent().width();
	
	    var headerHeight = 0;
	    var header = widgetElm.find('.widget-header.panel-heading');
	
	    if (header && header.outerHeight) {
	      headerHeight = header.outerHeight() || 0;
	    }
	
	    var marginRight = parseInt(widgetElm.css('margin-right') || '0');
	
	    var minWidth;
	    if (widget.size && widget.size.minWidth) {
	      if (widget.size.minWidth.indexOf('%') > -1) {
	        minWidth = parseInt(widget.size.minWidth) * parentWidth / 100 - marginRight;
	      } else {
	        minWidth = parseInt(widget.size.minWidth) - marginRight;
	      }
	    } else {
	      minWidth = 40;
	    }
	
	    var maxWidth = widthUnits === '%' ? parentWidth - marginRight : Infinity;
	
	    var minHeight;
	    if (widget.size && widget.size.minHeight) {
	      minHeight = parseInt(widget.size.minHeight) + headerHeight + 4;
	    } else {
	      minHeight = 40 + headerHeight;
	    }
	
	    var maxHeight = Infinity;
	    if (widget.size && widget.size.heightToWidthRatio !== undefined) {
	      maxHeight = (maxWidth + marginRight) * widget.size.heightToWidthRatio + headerHeight + 4;
	    }
	
	    var $marquee = angular.element('<div class="widget-resizer-marquee ' + region + '" style="height: ' + currentHeightPixel + 'px; width: ' + currentWidthPixel + 'px;"></div>');
	    $marquee.css('top', '-1px');
	    $marquee.css('left', '-1px');
	    widgetElm.append($marquee);
	
	    var calculateHeight = function calculateHeight(width, includeMargins) {
	      if ($scope.widget.size && $scope.widget.size.heightToWidthRatio !== undefined) {
	        if (includeMargins) {
	          return (width + marginRight) * $scope.widget.size.heightToWidthRatio + headerHeight + 4;
	        } else {
	          return width * $scope.widget.size.heightToWidthRatio;
	        }
	      }
	    };
	
	    var calculateWidth = function calculateWidth(height, includeMargins) {
	      if ($scope.widget.size && $scope.widget.size.heightToWidthRatio !== undefined) {
	        if (includeMargins) {
	          return (height - headerHeight - 4) / $scope.widget.size.heightToWidthRatio - marginRight;
	        } else {
	          return height / $scope.widget.size.heightToWidthRatio;
	        }
	      }
	    };
	
	    var mousemove = function mousemove(e) {
	      var newWidth, newHeight, top, left;
	      switch (region) {
	        case 'nw':
	          newWidth = Math.min(maxWidth, Math.max(minWidth, currentWidthPixel + initX - e.clientX));
	          newHeight = calculateHeight(newWidth, true) || Math.max(minHeight, currentHeightPixel + initY - e.clientY);
	          left = currentWidthPixel - newWidth - 2;
	          top = currentHeightPixel - newHeight - 2;
	          break;
	        case 'n':
	          newHeight = Math.min(maxHeight, Math.max(minHeight, currentHeightPixel + initY - e.clientY));
	          newWidth = calculateWidth(newHeight, true);
	          top = currentHeightPixel - newHeight - 2;
	          break;
	        case 'ne':
	          newWidth = Math.min(maxWidth, Math.max(minWidth, currentWidthPixel + e.clientX - initX));
	          newHeight = calculateHeight(newWidth, true) || Math.max(minHeight, currentHeightPixel + initY - e.clientY);
	          top = currentHeightPixel - newHeight - 2;
	          break;
	        case 'e':
	          newWidth = Math.min(maxWidth, Math.max(minWidth, currentWidthPixel + e.clientX - initX));
	          newHeight = calculateHeight(newWidth, true);
	          break;
	        case 'se':
	          newWidth = Math.min(maxWidth, Math.max(minWidth, currentWidthPixel + e.clientX - initX));
	          newHeight = calculateHeight(newWidth, true) || Math.max(minHeight, currentHeightPixel + e.clientY - initY);
	          break;
	        case 's':
	          newHeight = Math.min(maxHeight, Math.max(minHeight, currentHeightPixel + e.clientY - initY));
	          newWidth = calculateWidth(newHeight, true);
	          break;
	        case 'sw':
	          newWidth = Math.max(minWidth, currentWidthPixel + initX - e.clientX);
	          newHeight = calculateHeight(newWidth, true) || Math.max(minHeight, currentHeightPixel + e.clientY - initY);
	          left = currentWidthPixel - newWidth - 2;
	          break;
	        case 'w':
	          newWidth = Math.min(maxWidth, Math.max(minWidth, currentWidthPixel + initX - e.clientX));
	          left = currentWidthPixel - newWidth - 2;
	          newHeight = calculateHeight(newWidth, true);
	          break;
	      }
	      if (top !== undefined) {
	        $marquee.css('top', top + 'px');
	      }
	      if (left !== undefined) {
	        $marquee.css('left', left);
	      }
	      if (newWidth !== undefined) {
	        $marquee.css('width', newWidth + 'px');
	      }
	      if (newHeight !== undefined) {
	        $marquee.css('height', newHeight + 'px');
	      }
	    };
	
	    var mouseup = function mouseup(e) {
	      jQuery($window).off('mousemove', mousemove);
	
	      var marqueeWidth = parseInt($marquee.width()) + 4;
	      var marqueeHeight = parseInt($marquee.height()) + 4;
	
	      $marquee.remove();
	
	      var newWidth, newHeight, newWidthPixels;
	
	      if (marqueeWidth !== currentWidthPixel && ['nw', 'w', 'sw', 'ne', 'e', 'se'].indexOf(region) > -1) {
	        newWidthPixels = marqueeWidth + marginRight;
	        if (widthUnits === '%') {
	          newWidth = (marqueeWidth + marginRight) / parentWidth * 100;
	        } else {
	          newWidth = newWidthPixels;
	        }
	      }
	      if (marqueeHeight !== currentHeightPixel && ['nw', 'n', 'ne', 'sw', 's', 'se'].indexOf(region) > -1) {
	        newHeight = marqueeHeight - headerHeight - 2;
	      }
	
	      if (newWidthPixels !== undefined && ['w', 'e'].indexOf(region) > -1) {
	        newHeight = calculateHeight(newWidthPixels);
	      }
	
	      if (newHeight !== undefined && ['n', 's'].indexOf(region) > -1) {
	        newWidthPixels = calculateWidth(newHeight);
	        if (newWidthPixels !== undefined) {
	          if (widthUnits === '%') {
	            newWidth = (marqueeWidth + marginRight) / parentWidth * 100;
	          } else {
	            newWidth = newWidthPixels;
	          }
	        }
	      }
	
	      var obj = {};
	      if (newWidth !== undefined) {
	        obj.width = widget.setWidth(newWidth, widthUnits);
	        obj.widthPixels = newWidthPixels;
	      }
	      if (newHeight !== undefined) {
	        obj.height = parseInt(widget.setHeight(newHeight));
	      }
	      $scope.$emit('widgetChanged', widget);
	      $scope.$apply();
	      $scope.$broadcast('widgetResized', obj);
	    };
	    jQuery($window).on('mousemove', mousemove).one('mouseup', mouseup);
	  };
	
	  $scope.editTitle = function (widget) {
	    var widgetElm = $element.find('.widget');
	    widget.editingTitle = true;
	
	    $timeout(function () {
	      widgetElm.find('form.widget-title input:eq(0)').focus()[0].setSelectionRange(0, 9999);
	    });
	  };
	
	  $scope.saveTitleEdit = function (widget, event) {
	    widget.editingTitle = false;
	    $scope.$emit('widgetChanged', widget);
	
	    var evt = event || window.event;
	    if (evt) {
	      evt.preventDefault();
	    }
	  };
	
	  $scope.titleLostFocus = function (widget, event) {
	    if (widget.editingTitle) {
	      $scope.saveTitleEdit(widget, event);
	    }
	  };
	
	  $scope.compileTemplate = function () {
	    var container = $scope.findWidgetContainer($element);
	    var templateString = $scope.makeTemplateString();
	    var widgetElement = angular.element(templateString);
	
	    if ($scope.widget.size && $scope.widget.size.contentOverflow) {
	      $scope.widget.contentStyle.overflow = $scope.widget.size.contentOverflow;
	    }
	    container.empty();
	    container.append(widgetElement);
	    return $compile(widgetElement)($scope);
	  };
	
	  $scope.findWidgetContainer = function (element) {
	    return element.find('.widget-content');
	  };
	
	  function applyMinWidth() {
	    var parentWidth, width, minWidth, widthUnit, minWidthUnit, newWidth, tmp;
	
	    if ($scope.widget.size && $scope.widget.size.minWidth) {
	      minWidth = parseFloat($scope.widget.size.minWidth);
	      tmp = $scope.widget.size.minWidth.match(/px$|%$/i);
	    } else if ($scope.widget.style && $scope.widget.style.minWidth) {
	      minWidth = parseFloat($scope.widget.style.minWidth);
	      tmp = $scope.widget.style.minWidth.match(/px$|%$/i);
	    }
	    if (!minWidth || isNaN(minWidth)) {
	      return false;
	    }
	    minWidthUnit = tmp ? tmp[0].toLowerCase() : 'px';
	    if ($scope.widget.size && $scope.widget.size.width) {
	      width = parseFloat($scope.widget.size.width);
	      tmp = $scope.widget.size.width.match(/px$|%$/i);
	    } else if ($scope.widget.style && $scope.widget.style.width) {
	      width = parseFloat($scope.widget.style.width);
	      tmp = $scope.widget.style.width.match(/px$|%$/i);
	    }
	    widthUnit = tmp ? tmp[0].toLowerCase() : 'px';
	
	    if (!width || isNaN(width)) {
	      return false;
	    }
	
	    if (widthUnit === minWidthUnit) {
	      return false;
	    }
	
	    parentWidth = $element.parent().width();
	
	    newWidth = widthUnit === '%' ? parentWidth * width / 100 : width;
	
	    minWidth = minWidthUnit === '%' ? parentWidth * minWidth / 100 : minWidth;
	
	    if (newWidth < minWidth) {
	      $element.width(minWidth);
	      return true;
	    } else {
	      $element.width(width + widthUnit);
	      return false;
	    }
	  }
	
	  function applyMinHeight() {
	    if ($scope.widget.size && $scope.widget.size.minHeight) {
	      var minHeight = parseInt($scope.widget.size.minHeight);
	      if ($element.height() < minHeight) {
	        $scope.widget.setHeight(minHeight);
	      }
	    }
	  }
	
	  function applyHeightRatio() {
	    if ($scope.widget.size && $scope.widget.size.heightToWidthRatio !== undefined) {
	      $scope.widget.setHeight($element.width() * $scope.widget.size.heightToWidthRatio);
	    }
	  }
	
	  jQuery($window).on('resize', function () {
	    if ($element.width() > 0 && $element.height() > 0) {
	      $timeout.cancel(resizeTimeoutId);
	
	      var time = $scope.widget && $scope.widget.resizeTimeout !== undefined ? $scope.widget.resizeTimeout : 100;
	      resizeTimeoutId = $timeout(function () {
	        applyMinWidth();
	        applyMinHeight();
	        applyHeightRatio();
	        $scope.$broadcast('widgetResized', {
	          widthPixels: $element.width(),
	          height: $element.height()
	        });
	      }, time);
	    }
	  });
	
	  $scope.$on('widgetAdded', function () {
	    $timeout(function () {
	      applyMinWidth();
	      applyMinHeight();
	      applyHeightRatio();
	    }, 0);
	  });
	}]);
	
	
	'use strict';
	
	angular.module('ui.dashboard').directive('dashboardLayouts', ['LayoutStorage', '$timeout', '$uibModal', function (LayoutStorage, $timeout, $uibModal) {
	  return {
	    scope: true,
	    templateUrl: function templateUrl(element, attr) {
	      return attr.templateUrl ? attr.templateUrl : 'components/directives/dashboardLayouts/dashboardLayouts.html';
	    },
	    link: function link(scope, element, attrs) {
	
	      scope.options = scope.$eval(attrs.dashboardLayouts);
	
	      var layoutStorage = new LayoutStorage(scope.options);
	
	      scope.layouts = layoutStorage.layouts;
	
	      scope.createNewLayout = function () {
	        var newLayout = {
	          title: 'Custom',
	          defaultWidgets: scope.options.defaultWidgets || []
	        };
	        layoutStorage.add(newLayout);
	        scope.makeLayoutActive(newLayout);
	        layoutStorage.save();
	        return newLayout;
	      };
	
	      scope.removeLayout = function (layout) {
	        layoutStorage.remove(layout);
	        layoutStorage.save();
	      };
	
	      scope.makeLayoutActive = function (_layout) {
	
	        var current = layoutStorage.getActiveLayout();
	
	        if (current && current.dashboard.unsavedChangeCount) {
	          var modalInstance = $uibModal.open({
	            templateUrl: 'template/SaveChangesModal.html',
	            resolve: {
	              layout: function layout() {
	                return _layout;
	              }
	            },
	            controller: 'SaveChangesModalCtrl'
	          });
	
	          modalInstance.result.then(function () {
	            current.dashboard.saveDashboard();
	            scope._makeLayoutActive(_layout);
	          }, function () {
	            scope._makeLayoutActive(_layout);
	          });
	        } else {
	          scope._makeLayoutActive(_layout);
	        }
	      };
	
	      scope._makeLayoutActive = function (layout) {
	        angular.forEach(scope.layouts, function (l) {
	          if (l !== layout) {
	            l.active = false;
	          } else {
	            l.active = true;
	          }
	        });
	        layoutStorage.save();
	      };
	
	      scope.isActive = function (layout) {
	        return !!layout.active;
	      };
	
	      scope.editTitle = function (layout) {
	        if (layout.locked) {
	          return;
	        }
	
	        var input = element.find('input[data-layout="' + layout.id + '"]');
	        layout.editingTitle = true;
	
	        $timeout(function () {
	          input.focus()[0].setSelectionRange(0, 9999);
	        });
	      };
	
	      scope.saveTitleEdit = function (layout, event) {
	        layout.editingTitle = false;
	        layoutStorage.save();
	
	        var evt = event || window.event;
	        if (evt) {
	          evt.preventDefault();
	        }
	      };
	
	      scope.titleLostFocus = function (layout, event) {
	        if (layout && layout.editingTitle) {
	          if (layout.title !== '') {
	            scope.saveTitleEdit(layout, event);
	          } else {
	            var input = element.find('input[data-layout="' + layout.id + '"]');
	            $timeout(function () {
	              input.focus();
	            });
	          }
	        }
	      };
	
	      scope.options.saveLayouts = function () {
	        layoutStorage.save(true);
	      };
	      scope.options.addWidget = function () {
	        var layout = layoutStorage.getActiveLayout();
	        if (layout) {
	          layout.dashboard.addWidget.apply(layout.dashboard, arguments);
	        }
	      };
	      scope.options.prependWidget = function () {
	        var layout = layoutStorage.getActiveLayout();
	        if (layout) {
	          layout.dashboard.prependWidget.apply(layout.dashboard, arguments);
	        }
	      };
	      scope.options.loadWidgets = function () {
	        var layout = layoutStorage.getActiveLayout();
	        if (layout) {
	          layout.dashboard.loadWidgets.apply(layout.dashboard, arguments);
	        }
	      };
	      scope.options.saveDashboard = function () {
	        var layout = layoutStorage.getActiveLayout();
	        if (layout) {
	          layout.dashboard.saveDashboard.apply(layout.dashboard, arguments);
	        }
	      };
	
	      var sortableDefaults = {
	        stop: function stop() {
	          scope.options.saveLayouts();
	        },
	        distance: 5
	      };
	      scope.sortableOptions = angular.extend({}, sortableDefaults, scope.options.sortableOptions || {});
	    }
	  };
	}]);
	
	
	'use strict';
	
	angular.module('ui.dashboard').controller('SaveChangesModalCtrl', ['$scope', '$uibModalInstance', 'layout', function ($scope, $uibModalInstance, layout) {
	  $scope.layout = layout;
	
	  $scope.ok = function () {
	    $uibModalInstance.close();
	  };
	
	  $scope.cancel = function () {
	    $uibModalInstance.dismiss();
	  };
	}]);
	
	
	'use strict';
	
	angular.module('ui.dashboard').controller('WidgetSettingsCtrl', ['$scope', '$uibModalInstance', 'widget', function ($scope, $uibModalInstance, widget) {
	  $scope.widget = widget;
	
	  $scope.result = jQuery.extend(true, {}, widget);
	
	  $scope.ok = function () {
	    $uibModalInstance.close($scope.result);
	  };
	
	  $scope.cancel = function () {
	    $uibModalInstance.dismiss('cancel');
	  };
	}]);
	
	
	'use strict';
	
	angular.module('ui.dashboard').factory('WidgetModel', ["$log", function ($log) {
	
	  function defaults() {
	    return {
	      title: 'Widget',
	      style: {},
	      size: { width: '33%' },
	      enableVerticalResize: true,
	      containerStyle: { width: '33%' },
	      contentStyle: {}
	    };
	  };
	
	  function WidgetModel(widgetDefinition, overrides) {
	    angular.extend(this, defaults(), _.merge(angular.copy(widgetDefinition), overrides));
	
	    this.updateContainerStyle(this.style);
	
	    if (!this.templateUrl && !this.template && !this.directive) {
	      this.directive = widgetDefinition.name;
	    }
	
	    if (this.size && _.has(this.size, 'height')) {
	      this.setHeight(this.size.height);
	    }
	
	    if (this.style && _.has(this.style, 'width')) {
	      this.setWidth(this.style.width);
	    }
	
	    if (this.size && _.has(this.size, 'width')) {
	      this.setWidth(this.size.width);
	    }
	  }
	
	  WidgetModel.prototype = {
	    setWidth: function setWidth(width, units) {
	      width = width.toString();
	      units = units || width.replace(/^[-\.\d]+/, '') || '%';
	
	      this.widthUnits = units;
	      width = parseFloat(width);
	
	      if (this.size && _.has(this.size, 'minWidth') && _.endsWith(this.size.minWidth, units)) {
	        width = _.max([parseFloat(this.size.minWidth), width]);
	      }
	      if (width < 0 || isNaN(width)) {
	        $log.warn('malhar-angular-dashboard: setWidth was called when width was ' + width);
	        return;
	      }
	
	      if (units === '%') {
	        width = Math.min(100, width);
	        width = Math.max(0, width);
	      }
	
	      this.containerStyle.width = width + '' + units;
	
	      this.updateSize(this.containerStyle);
	
	      return width + units;
	    },
	
	    setHeight: function setHeight(height) {
	      this.contentStyle.height = height;
	      this.updateSize(this.contentStyle);
	
	      return height + 'px';
	    },
	
	    setStyle: function setStyle(style) {
	      this.style = style;
	      this.updateContainerStyle(style);
	    },
	
	    updateSize: function updateSize(size) {
	      angular.extend(this.size, size);
	    },
	
	    updateContainerStyle: function updateContainerStyle(style) {
	      angular.extend(this.containerStyle, style);
	    },
	    serialize: function serialize() {
	      return _.pick(this, ['title', 'name', 'style', 'size', 'dataModelOptions', 'attrs', 'storageHash']);
	    }
	  };
	
	  return WidgetModel;
	}]);
	
	
	'use strict';
	
	angular.module('ui.dashboard').factory('WidgetDefCollection', function () {
	
	  function convertToDefinition(d) {
	    if (typeof d === 'function') {
	      return new d();
	    }
	    return d;
	  }
	
	  function WidgetDefCollection(widgetDefs) {
	
	    widgetDefs = widgetDefs.map(convertToDefinition);
	
	    this.push.apply(this, widgetDefs);
	
	    var map = {};
	    _.each(widgetDefs, function (widgetDef) {
	      map[widgetDef.name] = widgetDef;
	    });
	    this.map = map;
	  }
	
	  WidgetDefCollection.prototype = Object.create(Array.prototype);
	
	  WidgetDefCollection.prototype.getByName = function (name) {
	    return this.map[name];
	  };
	
	  WidgetDefCollection.prototype.add = function (def) {
	    def = convertToDefinition(def);
	    this.push(def);
	    this.map[def.name] = def;
	  };
	
	  return WidgetDefCollection;
	});
	
	'use strict';
	
	angular.module('ui.dashboard').factory('WidgetDataModel', function () {
	  function WidgetDataModel() {}
	
	  WidgetDataModel.prototype = {
	    setup: function setup(widget, scope) {
	      this.dataAttrName = widget.dataAttrName;
	      this.dataModelOptions = widget.dataModelOptions;
	      this.widgetScope = scope;
	    },
	
	    updateScope: function updateScope(data) {
	      this.widgetScope.widgetData = data;
	    },
	
	    init: function init() {},
	
	    destroy: function destroy() {}
	  };
	
	  return WidgetDataModel;
	});
	
	
	'use strict';
	
	angular.module('ui.dashboard').factory('LayoutStorage', function () {
	
	  var noopStorage = {
	    setItem: function setItem() {},
	    getItem: function getItem() {},
	    removeItem: function removeItem() {}
	  };
	
	  function LayoutStorage(options) {
	
	    var defaults = {
	      storage: noopStorage,
	      storageHash: '',
	      stringifyStorage: true
	    };
	
	    angular.extend(defaults, options);
	    angular.extend(options, defaults);
	
	    this.id = options.storageId;
	    this.storage = options.storage;
	    this.storageHash = options.storageHash;
	    this.stringifyStorage = options.stringifyStorage;
	    this.widgetDefinitions = options.widgetDefinitions;
	    this.defaultLayouts = options.defaultLayouts;
	    this.lockDefaultLayouts = options.lockDefaultLayouts;
	    this.widgetButtons = options.widgetButtons;
	    this.explicitSave = options.explicitSave;
	    this.defaultWidgets = options.defaultWidgets;
	    this.settingsModalOptions = options.settingsModalOptions;
	    this.onSettingsClose = options.onSettingsClose;
	    this.onSettingsDismiss = options.onSettingsDismiss;
	    this.options = options;
	    this.options.unsavedChangeCount = 0;
	
	    this.layouts = [];
	    this.states = {};
	    this.load();
	    this._ensureActiveLayout();
	  }
	
	  LayoutStorage.prototype = {
	
	    add: function add(layouts) {
	      if (!angular.isArray(layouts)) {
	        layouts = [layouts];
	      }
	      var self = this;
	      angular.forEach(layouts, function (layout) {
	        layout.dashboard = layout.dashboard || {};
	        layout.dashboard.storage = self;
	        layout.dashboard.storageId = layout.id = self._getLayoutId.call(self, layout);
	        layout.dashboard.widgetDefinitions = layout.widgetDefinitions || self.widgetDefinitions;
	        layout.dashboard.stringifyStorage = false;
	        layout.dashboard.defaultWidgets = layout.defaultWidgets || self.defaultWidgets;
	        layout.dashboard.widgetButtons = self.widgetButtons;
	        layout.dashboard.explicitSave = self.explicitSave;
	        layout.dashboard.settingsModalOptions = self.settingsModalOptions;
	        layout.dashboard.onSettingsClose = self.onSettingsClose;
	        layout.dashboard.onSettingsDismiss = self.onSettingsDismiss;
	        self.layouts.push(layout);
	      });
	    },
	
	    remove: function remove(layout) {
	      var index = this.layouts.indexOf(layout);
	      if (index >= 0) {
	        this.layouts.splice(index, 1);
	        delete this.states[layout.id];
	
	        if (layout.active && this.layouts.length) {
	          var nextActive = index > 0 ? index - 1 : 0;
	          this.layouts[nextActive].active = true;
	        }
	      }
	    },
	
	    save: function save() {
	
	      var state = {
	        layouts: this._serializeLayouts(),
	        states: this.states,
	        storageHash: this.storageHash
	      };
	
	      if (this.stringifyStorage) {
	        state = JSON.stringify(state);
	      }
	
	      this.storage.setItem(this.id, state);
	      this.options.unsavedChangeCount = 0;
	    },
	
	    load: function load() {
	
	      var serialized = this.storage.getItem(this.id);
	
	      this.clear();
	
	      if (serialized) {
	        if (angular.isObject(serialized) && angular.isFunction(serialized.then)) {
	          this._handleAsyncLoad(serialized);
	        } else {
	          this._handleSyncLoad(serialized);
	        }
	      } else {
	        this._addDefaultLayouts();
	      }
	    },
	
	    clear: function clear() {
	      this.layouts = [];
	      this.states = {};
	    },
	
	    setItem: function setItem(id, value) {
	      this.states[id] = value;
	      this.save();
	    },
	
	    getItem: function getItem(id) {
	      return this.states[id];
	    },
	
	    removeItem: function removeItem(id) {
	      delete this.states[id];
	      this.save();
	    },
	
	    getActiveLayout: function getActiveLayout() {
	      var len = this.layouts.length;
	      for (var i = 0; i < len; i++) {
	        var layout = this.layouts[i];
	        if (layout.active) {
	          return layout;
	        }
	      }
	      return false;
	    },
	
	    _addDefaultLayouts: function _addDefaultLayouts() {
	      var self = this;
	      var defaults = this.lockDefaultLayouts ? { locked: true } : {};
	      angular.forEach(this.defaultLayouts, function (layout) {
	        self.add(angular.extend(_.clone(defaults), layout));
	      });
	    },
	
	    _serializeLayouts: function _serializeLayouts() {
	      var result = [];
	      angular.forEach(this.layouts, function (l) {
	        result.push({
	          title: l.title,
	          id: l.id,
	          active: l.active,
	          locked: l.locked,
	          defaultWidgets: l.dashboard.defaultWidgets
	        });
	      });
	      return result;
	    },
	
	    _handleSyncLoad: function _handleSyncLoad(serialized) {
	
	      var deserialized;
	
	      if (this.stringifyStorage) {
	        try {
	
	          deserialized = JSON.parse(serialized);
	        } catch (e) {
	          this._addDefaultLayouts();
	          return;
	        }
	      } else {
	
	        deserialized = serialized;
	      }
	
	      if (this.storageHash !== deserialized.storageHash) {
	        this._addDefaultLayouts();
	        return;
	      }
	      this.states = deserialized.states;
	      this.add(deserialized.layouts);
	    },
	
	    _handleAsyncLoad: function _handleAsyncLoad(promise) {
	      var self = this;
	      promise.then(angular.bind(self, this._handleSyncLoad), angular.bind(self, this._addDefaultLayouts));
	    },
	
	    _ensureActiveLayout: function _ensureActiveLayout() {
	      for (var i = 0; i < this.layouts.length; i++) {
	        var layout = this.layouts[i];
	        if (layout.active) {
	          return;
	        }
	      }
	      if (this.layouts[0]) {
	        this.layouts[0].active = true;
	      }
	    },
	
	    _getLayoutId: function _getLayoutId(layout) {
	      if (layout.id) {
	        return layout.id;
	      }
	      var max = 0;
	      for (var i = 0; i < this.layouts.length; i++) {
	        var id = this.layouts[i].id;
	        max = Math.max(max, id * 1);
	      }
	      return max + 1;
	    }
	
	  };
	  return LayoutStorage;
	});
	
	
	'use strict';
	
	angular.module('ui.dashboard').factory('DashboardState', ['$log', '$q', function ($log, $q) {
	  function DashboardState(storage, id, hash, widgetDefinitions, stringify) {
	    this.storage = storage;
	    this.id = id;
	    this.hash = hash;
	    this.widgetDefinitions = widgetDefinitions;
	    this.stringify = stringify;
	  }
	
	  DashboardState.prototype = {
	    save: function save(widgets) {
	
	      if (!this.storage) {
	        return true;
	      }
	
	      var serialized = _.map(widgets, function (widget) {
	        return widget.serialize();
	      });
	
	      var item = { widgets: serialized, hash: this.hash };
	
	      if (this.stringify) {
	        item = JSON.stringify(item);
	      }
	
	      return this.storage.setItem(this.id, item) || true;
	    },
	
	    load: function load() {
	
	      if (!this.storage) {
	        return null;
	      }
	
	      var serialized;
	
	      serialized = this.storage.getItem(this.id);
	
	      if (serialized) {
	        if (angular.isObject(serialized) && angular.isFunction(serialized.then)) {
	          return this._handleAsyncLoad(serialized);
	        }
	
	        return this._handleSyncLoad(serialized);
	      } else {
	        return null;
	      }
	    },
	
	    _handleSyncLoad: function _handleSyncLoad(serialized) {
	
	      var deserialized,
	          result = [];
	
	      if (!serialized) {
	        return null;
	      }
	
	      if (this.stringify) {
	        try {
	
	          deserialized = JSON.parse(serialized);
	        } catch (e) {
	          $log.warn('Serialized dashboard state was malformed and could not be parsed: ', serialized);
	          return null;
	        }
	      } else {
	        deserialized = serialized;
	      }
	
	      if (deserialized.hash !== this.hash) {
	
	        $log.info('Serialized dashboard from storage was stale (old hash: ' + deserialized.hash + ', new hash: ' + this.hash + ')');
	        this.storage.removeItem(this.id);
	        return null;
	      }
	
	      var savedWidgetDefs = deserialized.widgets;
	
	      for (var i = 0; i < savedWidgetDefs.length; i++) {
	        var savedWidgetDef = savedWidgetDefs[i];
	
	        var widgetDefinition = this.widgetDefinitions.getByName(savedWidgetDef.name);
	
	        if (!widgetDefinition) {
	          $log.warn('Widget with name "' + savedWidgetDef.name + '" was not found in given widget definition objects');
	          continue;
	        }
	
	        if (widgetDefinition.hasOwnProperty('storageHash') && widgetDefinition.storageHash !== savedWidgetDef.storageHash) {
	          $log.info('Widget Definition Object with name "' + savedWidgetDef.name + '" was found ' + 'but the storageHash property on the widget definition is different from that on the ' + 'serialized widget loaded from storage. hash from storage: "' + savedWidgetDef.storageHash + '"' + ', hash from WDO: "' + widgetDefinition.storageHash + '"');
	          continue;
	        }
	
	        result.push(savedWidgetDef);
	      }
	
	      return result;
	    },
	
	    _handleAsyncLoad: function _handleAsyncLoad(promise) {
	      var self = this;
	      var deferred = $q.defer();
	      promise.then(function (res) {
	        var result = self._handleSyncLoad(res);
	        if (result) {
	          deferred.resolve(result);
	        } else {
	          deferred.reject(result);
	        }
	      }, function (res) {
	        deferred.reject(res);
	      });
	
	      return deferred.promise;
	    }
	
	  };
	  return DashboardState;
	}]);

/***/ }),
/* 672 */
5,
/* 673 */,
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DashboardComponent = undefined;
	
	var _dashboard = __webpack_require__(675);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var DashboardComponent = exports.DashboardComponent = ['$interval', 'widgetDefinitions', 'defaultWidgets', '$window', function DashboardComponent($interval, widgetDefinitions, defaultWidgets, $window) {
	  'ngInject';
	
	  var _this = this;
	
	  _classCallCheck(this, DashboardComponent);
	
	  this.dashboardOptions = {
	    widgetButtons: true,
	    widgetDefinitions: widgetDefinitions,
	    defaultWidgets: defaultWidgets,
	    storage: $window.localStorage,
	    storageId: 'demo_simple'
	  };
	  this.randomValue = Math.random();
	  $interval(function (_) {
	    _this.randomValue = Math.random();
	  }, 500);
	
	  this.prependWidget = function () {
	    this.dashboardOptions.prependWidget({ name: 'random', title: 'Prepend Widget' });
	  };
	}];
	
	exports.default = angular.module('conduu.dashboard', [uiRouter]).config(_dashboard2.default).directive('wtTime', ['$interval', function ($interval) {
	  return {
	    restrict: 'A',
	    scope: true,
	    replace: true,
	    template: '<div>Time<div class="alert alert-success">{{time}}</div></div>',
	    link: function link(scope) {
	      function update() {
	        scope.time = new Date().toLocaleTimeString();
	      }
	
	      update();
	
	      var promise = $interval(update, 500);
	
	      scope.$on('$destroy', function () {
	        $interval.cancel(promise);
	      });
	    }
	  };
	}]).directive('wtScopeWatch', function () {
	  return {
	    restrict: 'A',
	    replace: true,
	    template: '<div>Value<div class="alert alert-info">{{value}}</div></div>',
	    scope: {
	      value: '=value'
	    }
	  };
	}).directive('wtFluid', function () {
	  return {
	    restrict: 'A',
	    replace: true,
	    templateUrl: 'app/template/fluid.html',
	    scope: true,
	    controller: ['$scope', function controller($scope) {
	      $scope.$on('widgetResized', function (event, size) {
	        $scope.width = size.width || $scope.width;
	        $scope.height = size.height || $scope.height;
	      });
	    }]
	  };
	}).factory('widgetDefinitions', ['RandomDataModel', function (RandomDataModel) {
	  return [{
	    name: 'random',
	    directive: 'wt-scope-watch',
	    attrs: {
	      value: 'randomValue'
	    }
	  }, {
	    name: 'time',
	    directive: 'wt-time'
	  }, {
	    name: 'datamodel',
	    directive: 'wt-scope-watch',
	    dataAttrName: 'value',
	    dataModelType: RandomDataModel
	  }, {
	    name: 'resizable',
	    templateUrl: 'app/template/resizable.html',
	    attrs: {
	      class: 'demo-widget-resizable'
	    }
	  }, {
	    name: 'fluid',
	    directive: 'wt-fluid',
	    size: {
	      width: '50%',
	      height: '250px'
	    }
	  }];
	}]).value('defaultWidgets', [{ name: 'random' }, { name: 'time' }, { name: 'datamodel' }, {
	  name: 'random',
	  style: {
	    width: '50%',
	    minWidth: '39%'
	  }
	}, {
	  name: 'time',
	  style: {
	    width: '50%'
	  }
	}]).factory('RandomDataModel', ['$interval', 'WidgetDataModel', function ($interval, WidgetDataModel) {
	  function RandomDataModel() {}
	
	  RandomDataModel.prototype = Object.create(WidgetDataModel.prototype);
	  RandomDataModel.prototype.constructor = WidgetDataModel;
	
	  angular.extend(RandomDataModel.prototype, {
	    init: function init() {
	      var dataModelOptions = this.dataModelOptions;
	      this.limit = dataModelOptions && dataModelOptions.limit ? dataModelOptions.limit : 100;
	
	      this.updateScope('-');
	      this.startInterval();
	    },
	
	    startInterval: function startInterval() {
	      $interval.cancel(this.intervalPromise);
	
	      this.intervalPromise = $interval(function () {
	        var value = Math.floor(Math.random() * this.limit);
	        this.updateScope(value);
	      }.bind(this), 500);
	    },
	
	    updateLimit: function updateLimit(limit) {
	      this.dataModelOptions = this.dataModelOptions ? this.dataModelOptions : {};
	      this.dataModelOptions.limit = limit;
	      this.limit = limit;
	    },
	
	    destroy: function destroy() {
	      WidgetDataModel.prototype.destroy.call(this);
	      $interval.cancel(this.intervalPromise);
	    }
	  });
	
	  return RandomDataModel;
	}]).component('dashboard', {
	  template: __webpack_require__(676),
	  controller: DashboardComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('dashboard', {
	    url: '/dashboard',
	    template: '<dashboard></dashboard>'
	  });
	}];

/***/ }),
/* 676 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <p>\r\n            <a ng-click=\"ctrl.prependWidget()\">Click here</a> to add new widget to beginning of dashboard.  This demonstrates the prependWidget function.\tSee <a href=\"https://github.com/DataTorrent/malhar-angular-dashboard/issues/141\" target=\"_blank\">issue #141</a>.\r\n        </p>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <div dashboard=\"ctrl.dashboardOptions\" class=\"dashboard-container\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"col-lg-4\">\r\n        <div class=\"bs-card\">\r\n            <img class=\"card-img-top\" src=\"https://picsum.photos/400/300\" style=\"width:100%\" alt=\"Card image cap\">\r\n            <div class=\"card-block\">\r\n                <h4 class=\"card-title\">Card title</h4>\r\n                <p class=\"card-text\">Some quick example text to build on the card title and make up the bulk of the card's content.</p>\r\n            </div>\r\n            <ul class=\"list-group\">\r\n                <li class=\"list-group-item\">Cras justo odio</li>\r\n                <li class=\"list-group-item\">Dapibus ac facilisis in</li>\r\n                <li class=\"list-group-item\">Vestibulum at eros</li>\r\n            </ul>\r\n            <div class=\"card-block\">\r\n                <a href=\"#\" class=\"card-link\">Card link</a>\r\n                <a href=\"#\" class=\"card-link\">Another link</a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-lg-4\">\r\n        <div class=\"bs-card\">\r\n            <img class=\"card-img-top\" src=\"assets/images/doc-preview.jpeg\" style=\"width:100%\" alt=\"Card image cap\">\r\n            <div class=\"card-block\">\r\n                <h4 class=\"card-title\">Articles of Incorporation</h4>\r\n                <p class=\"card-text\">Official Record Book 11111 pages 222-333</p>\r\n            </div>\r\n            <ul class=\"list-group\">\r\n                <li class=\"list-group-item\"><i class=\"fa fa-fw fa-calendar\"></i> 2018-05-17</li>\r\n            </ul>\r\n            <div class=\"card-block\" style=\"padding-top:0\">\r\n                <div class=\"col-xs-6\"><button style=\"color:black\" class=\"btn btn-block\"><i class=\"fa fa-fw fa-eye\"></i> View</button></div>\r\n                <div class=\"col-xs-6\"><button style=\"color:black\"  class=\"btn btn-block\"><i class=\"fa fa-fw fa-download\"></i> Download</button></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-lg-4\">\r\n        <div class=\"bs-card\">\r\n            <div class=\"card-header\">\r\n                <span><strong>Awesome Card</strong></span>\r\n                <ul class=\"nav nav-tabs card-header-tabs\">\r\n                    <li class=\"active\">\r\n                        <a class=\"nav-link active\" href=\"#\">Active</a>\r\n                    </li>\r\n                    <li class=\"nav-item\">\r\n                        <a class=\"nav-link\" href=\"#\">Link</a>\r\n                    </li>\r\n                    <li class=\"nav-item\">\r\n                        <a class=\"nav-link disabled\" href=\"#\">Disabled</a>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n            <div class=\"card-block\">\r\n                <h4 class=\"card-title\">Special title treatment</h4>\r\n                <p class=\"card-text\">With supporting text below as a natural lead-in to additional content.</p>\r\n                <a href=\"#\" class=\"btn btn-primary\">Go somewhere</a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div style=\"clear:both\"></div>\r\n\r\n    <div class=\"col-lg-6\">\r\n        <div class=\"bs-card card-outline-danger\" style=\"color:white\">\r\n            <img class=\"card-img\" src=\"https://picsum.photos/600/400\" style=\"width:100%; height:100%\" alt=\"Card image\">\r\n            <div class=\"card-img-overlay\">\r\n                <h4 class=\"card-title\" style=\"color:lightgoldenrodyellow\"><strong>Card title</strong></h4>\r\n                <p class=\"card-text\">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>\r\n                <p class=\"card-text\">Last updated 3 mins ago</p>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"col-lg-6\">\r\n        <div class=\"bs-card text-center\">\r\n            <div class=\"card-header\">\r\n                Featured\r\n            </div>\r\n            <div class=\"card-body\">\r\n                <div class=\"card-block\">\r\n                    <h5 class=\"card-title\">Special title treatment</h5>\r\n                    <p class=\"card-text\">With supporting text below as a natural lead-in to additional content.</p>\r\n                    <a href=\"#\" class=\"btn btn-primary\">Go somewhere</a>\r\n                </div>\r\n            </div>\r\n            <div class=\"card-footer text-muted\">\r\n                2 days ago\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"col-lg-4\">\r\n        <div class=\"bs-card\">\r\n            <div class=\"card-body\">\r\n                <div class=\"card-block\">\r\n                    <h5 class=\"card-title\">Card title</h5>\r\n                    <h6 class=\"card-subtitle mb-2 text-muted\">Card subtitle</h6>\r\n                    <p class=\"card-text\">Some quick example text to build on the card title and make up the bulk of the card's content.</p>\r\n                    <a href=\"#\" class=\"card-link\">Card link</a>\r\n                    <a href=\"#\" class=\"card-link\">Another link</a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n\r\n\r\n</div>\r\n\r\n"

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RolesConfigService.$inject = ['SettingsService'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RolesConfigService = RolesConfigService;
	var angular = __webpack_require__(14);
	
	function RolesConfigService(SettingsService) {
	  'ngInject';
	
	  var ROLES_CONFIG = {};
	
	  SettingsService.getByName({ name: 'roles-and-permissions' }, function (setting) {
	    ROLES_CONFIG = setting.data;
	
	    return {
	      can: function can(user, action) {
	
	        return true;
	
	        if (!user || !user.role || !user.role.length) return false;
	
	        var roles = user.role;
	
	        switch (action) {
	          case "community.create":
	            roles.forEach(function (role) {
	              console.log(role);
	              console.log(ROLES_CONFIG[role]);
	              if (ROLES_CONFIG[role].community.create.length) return true;
	            });
	            return false;
	            break;
	          default:
	            return false;
	        }
	      }
	    };
	  });
	}
	
	exports.default = angular.module('conduu.RolesConfig', []).factory('RolesConfig', RolesConfigService).name;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * angular-permission
	 * Fully featured role and permission based access control for your angular applications
	 * @version v6.0.0 - 2018-01-20
	 * @link https://github.com/Narzerus/angular-permission
	 * @author Rafael Vidaurre <narzerus@gmail.com> (http://www.rafaelvidaurre.com), Blazej Krysiak <blazej.krysiak@gmail.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	(function () {
	  'use strict';
	
	  var permission = __webpack_require__(679),
	    ngPermission = __webpack_require__(680),
	    uiPermission = __webpack_require__(681);
	
	  module.exports = {
	    permission: permission,
	    ngPermission: ngPermission,
	    uiPermission: uiPermission
	  };
	})();


/***/ }),
/* 679 */
/***/ (function(module, exports) {

	/**
	 * angular-permission
	 * Fully featured role and permission based access control for your angular applications
	 * @version v6.0.0 - 2018-01-20
	 * @link https://github.com/Narzerus/angular-permission
	 * @author Rafael Vidaurre <narzerus@gmail.com> (http://www.rafaelvidaurre.com), Blazej Krysiak <blazej.krysiak@gmail.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	(function (window, angular, undefined) {
	  'use strict';
	
	  /**
	   * @namespace permission
	   */
	
	  $q.$inject = ['$delegate'];
	  PermPermission.$inject = ['$q', '$injector', 'PermTransitionProperties'];
	  PermRole.$inject = ['$q', '$injector', 'PermPermissionStore', 'PermTransitionProperties'];
	  PermPermissionStore.$inject = ['PermPermission'];
	  PermRoleStore.$inject = ['PermRole'];
	  PermissionDirective.$inject = ['$log', '$injector', 'PermPermissionMap', 'PermPermissionStrategies'];
	  PermAuthorization.$inject = ['$q'];
	  PermPermissionMap.$inject = ['$q', '$log', '$injector', '$permission', 'PermTransitionProperties', 'PermRoleStore', 'PermPermissionStore'];
	  var permission = angular.module('permission', []);
	
	  /* istanbul ignore if  */
	  if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
	    module.exports = permission.name;
	  }
	
	  /**
	   * Permission module configuration provider
	   *
	   * @name permission.permissionProvider
	   */
	  function $permission() {
	    'ngInject';
	
	    var defaultOnAuthorizedMethod = 'showElement';
	    var defaultOnUnauthorizedMethod = 'hideElement';
	    var suppressUndefinedPermissionWarning = false;
	
	    /**
	     * Methods allowing to alter default directive onAuthorized behaviour in permission directive
	     * @methodOf permission.permissionProvider
	     *
	     * @param onAuthorizedMethod {String} One of permission.PermPermissionStrategies method names
	     */
	    this.setDefaultOnAuthorizedMethod = function (onAuthorizedMethod) { // jshint ignore:line
	      defaultOnAuthorizedMethod = onAuthorizedMethod;
	    };
	
	    /**
	     * Methods allowing to alter default directive onUnauthorized behaviour in permission directive
	     * @methodOf permission.permissionProvider
	     *
	     * @param onUnauthorizedMethod {String} One of permission.PermPermissionStrategies method names
	     */
	    this.setDefaultOnUnauthorizedMethod = function (onUnauthorizedMethod) { // jshint ignore:line
	      defaultOnUnauthorizedMethod = onUnauthorizedMethod;
	    };
	
	
	    /**
	     * When set to true hides permission warning for undefined roles and permissions
	     * @methodOf permission.permissionProvider
	     *
	     * @param value {Boolean}
	     */
	    this.suppressUndefinedPermissionWarning = function (value) { // jshint ignore:line
	      suppressUndefinedPermissionWarning = value;
	    };
	
	
	    this.$get = function () { // jshint ignore:line
	      return {
	        defaultOnAuthorizedMethod: defaultOnAuthorizedMethod,
	        defaultOnUnauthorizedMethod: defaultOnUnauthorizedMethod,
	        suppressUndefinedPermissionWarning: suppressUndefinedPermissionWarning
	      };
	    };
	  }
	
	  angular
	    .module('permission')
	    .provider('$permission', $permission);
	
	  /**
	   * Extends $q implementation by A+ *any* method
	   * @name permission.$q
	   *
	   * @extends {angular.$q}
	   *
	   * @param $delegate {Object} Parent instance being extended
	   */
	  function $q($delegate) {
	    'ngInject';
	
	    $delegate.any = any;
	
	    /**
	     * Implementation of missing $q `any` method that wits for first resolution of provided promise set
	     * @methodOf permission.$q
	     *
	     * @param promises {Array|promise} Single or set of promises
	     *
	     * @returns {Promise} Returns a single promise that will be rejected with an array/hash of values,
	     *  each value corresponding to the promise at the same index/key in the `promises` array/hash.
	     *  If any of the promises is resolved, this resulting promise will be returned
	     *  with the same resolution value.
	     */
	    function any(promises) {
	      var deferred = $delegate.defer(),
	        counter = 0,
	        results = angular.isArray(promises) ? [] : {};
	
	      angular.forEach(promises, function (promise, key) {
	        counter++;
	        $delegate
	          .when(promise)
	          .then(function (value) {
	            deferred.resolve(value);
	          })
	          .catch(function (reason) {
	            results[key] = reason;
	            if (!(--counter)) {
	              deferred.reject(reason);
	            }
	          });
	      });
	
	      if (counter === 0) {
	        deferred.reject(results);
	      }
	
	      return deferred.promise;
	    }
	
	    return $delegate;
	  }
	
	  angular
	    .module('permission')
	    .decorator('$q', $q);
	
	
	  /**
	   * Pre-defined available configurable behaviours of directive `permission`
	   * @name permission.PermPermissionStrategies
	   * @readonly
	   *
	   * @example
	   * <div permission
	   *      permission-except="'MANAGER'"
	   *      permission-on-authorized="PermPermissionStrategies.renderContent"
	   *      permission-on-unauthorized="PermPermissionStrategies.removeContent">
	   * </div>
	   *
	   * @property enableElement {Function}
	   * @property disableElement {Function}
	   * @property showElement {Function}
	   * @property hideElement {Function}
	   */
	  var PermPermissionStrategies = {
	    enableElement: function ($element) {
	      $element.removeAttr('disabled');
	    },
	    disableElement: function ($element) {
	      $element.attr('disabled', 'disabled');
	    },
	    showElement: function ($element) {
	      $element.removeClass('ng-hide');
	    },
	    hideElement: function ($element) {
	      $element.addClass('ng-hide');
	    }
	  };
	
	  angular
	    .module('permission')
	    .value('PermPermissionStrategies', PermPermissionStrategies)
	    .value('PermissionStrategies', PermPermissionStrategies);
	
	
	  /**
	   * Helper object used for storing ui-router/ng-route transition parameters
	   * @name permission.PermTransitionProperties
	   *
	   * @type {Object.<String,Object>}
	   *
	   * Transition properties for ui-router:
	   * @property toState {Object} Target state object [ui-router]
	   * @property toParams {Object} Target state params [ui-router]
	   * @property fromState {Object} Source state object [ui-router]
	   * @property fromParams {Object} Source state params [ui-router]
	   * @property options {Object} Transition options [ui-router]
	   *
	   * Transition properties for ng-route:
	   * @property current {Object} Current state properties [ng-route]
	   * @property next {Object} Next state properties [ng-route]
	   */
	  var PermTransitionProperties = {};
	
	  angular
	    .module('permission')
	    .value('PermTransitionProperties', PermTransitionProperties);
	
	  /**
	   * Interface responsible for managing and emitting events dependent on router implementation
	   * @name permission.PermTransitionEvents
	   */
	  function PermTransitionEvents() {
	    'ngInject';
	
	    this.broadcastPermissionStartEvent = function () {
	      throw new Error('Method broadcastPermissionStartEvent in PermTransitionEvents interface must be implemented');
	    };
	
	    this.broadcastPermissionAcceptedEvent = function () {
	      throw new Error('Method broadcastPermissionAcceptedEvent in PermTransitionEvents interface must be implemented');
	    };
	
	    this.broadcastPermissionDeniedEvent = function () {
	      throw new Error('Method broadcastPermissionDeniedEvent in PermTransitionEvents interface must be implemented');
	    };
	  }
	
	  angular
	    .module('permission')
	    .service('PermTransitionEvents', PermTransitionEvents);
	
	
	  /**
	   * PermPermission definition factory
	   * @function
	   *
	   * @param $q {Object} Angular promise implementation
	   * @param $injector {Object} Dependency injection instance
	   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing ui-router transition parameters
	   *
	   * @return {Permission}
	   */
	  function PermPermission($q, $injector, PermTransitionProperties) {
	    'ngInject';
	
	    /**
	     * PermPermission definition object constructor
	     * @constructor Permission
	     *
	     * @param permissionName {String} Name repressing permission
	     * @param validationFunction {Function} Function used to check if permission is valid
	     */
	    function Permission(permissionName, validationFunction) {
	      validateConstructor(permissionName, validationFunction);
	
	      this.permissionName = permissionName;
	      this.validationFunction = annotateValidationFunction(validationFunction);
	    }
	
	    /**
	     * Checks if permission is still valid
	     * @methodOf permission.Permission
	     *
	     * @returns {Promise}
	     */
	    Permission.prototype.validatePermission = function () {
	      var validationLocals = {
	        permissionName: this.permissionName,
	        transitionProperties: PermTransitionProperties
	      };
	      var validationResult = $injector.invoke(this.validationFunction, null, validationLocals);
	
	      if (!angular.isFunction(validationResult.then)) {
	        validationResult = wrapInPromise(validationResult, this.permissionName);
	      }
	
	      return validationResult;
	    };
	
	    /**
	     * Converts a value into a promise, if the value is truthy it resolves it, otherwise it rejects it
	     * @methodOf permission.Permission
	     * @private
	     *
	     * @param result {Boolean} Function to be wrapped into promise
	     * @param permissionName {String} Returned value in promise
	     *
	     * @return {Promise}
	     */
	    function wrapInPromise(result, permissionName) {
	      if (result) {
	        return $q.resolve(permissionName);
	      }
	
	      return $q.reject(permissionName);
	    }
	
	    /**
	     * Checks if provided permission has accepted parameter types
	     * @methodOf permission.Permission
	     * @private
	     *
	     * @throws {TypeError}
	     *
	     * @param permissionName {String} Name repressing permission
	     * @param validationFunction {Function} Function used to check if permission is valid
	     */
	    function validateConstructor(permissionName, validationFunction) {
	      if (!angular.isString(permissionName)) {
	        throw new TypeError('Parameter "permissionName" name must be String');
	      }
	      if (!angular.isFunction(validationFunction) && !angular.isArray(validationFunction)) {
	        throw new TypeError('Parameter "validationFunction" must be Function or an injectable Function using explicit annotation');
	      }
	    }
	
	    /**
	     * Ensures the validation is injectable using explicit annotation.
	     * Wraps a non-injectable function for backwards compatibility
	     * @methodOf permission.Permission
	     * @private
	     *
	     * @param validationFunction {Function} Function to wrap with injectable if needed
	     *
	     * @return {Function} Explicitly injectable function
	     */
	    function annotateValidationFunction(validationFunction) {
	      if (!angular.isArray(validationFunction.$inject || validationFunction)) {
	        // The function is not explicitly annotated, so assume using old-style parameters
	        // and manually prepare for injection using our known old API parameters
	        validationFunction = ['permissionName', 'transitionProperties', validationFunction];
	      }
	
	      return validationFunction;
	    }
	
	    return Permission;
	  }
	
	  angular
	    .module('permission')
	    .factory('PermPermission', PermPermission);
	
	  /**
	   * Role definition factory
	   * @function
	   *
	   * @param $q {Object} Angular promise implementation
	   * @param $injector {Object} Dependency injection instance
	   * @param PermPermissionStore {permission.PermPermissionStore} Permission definition storage
	   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing ui-router transition parameters
	   *
	   * @return {Role}
	   */
	  function PermRole($q, $injector, PermPermissionStore, PermTransitionProperties) {
	    'ngInject';
	
	    /**
	     * Role definition constructor
	     * @constructor Role
	     *
	     * @param roleName {String} Name representing role
	     * @param validationFunction {Function|Array<String>} Optional function used to validate if permissions are still
	     *   valid or list of permission names representing role
	     */
	    function Role(roleName, validationFunction) {
	      validateConstructor(roleName, validationFunction);
	
	      this.roleName = roleName;
	      this.validationFunction = annotateValidationFunction(validationFunction);
	    }
	
	    /**
	     * Checks if role is still valid
	     * @methodOf permission.Role
	     *
	     * @returns {Promise} $q.promise object
	     */
	    Role.prototype.validateRole = function () {
	      var validationLocals = {
	        roleName: this.roleName,
	        transitionProperties: PermTransitionProperties
	      };
	      var validationResult = $injector.invoke(this.validationFunction, null, validationLocals);
	
	      if (!angular.isFunction(validationResult.then)) {
	        validationResult = wrapInPromise(validationResult, this.roleName);
	      }
	
	      return validationResult;
	    };
	
	    /**
	     * Converts a value into a promise, if the value is truthy it resolves it, otherwise it rejects it
	     * @methodOf permission.Role
	     * @private
	     *
	     * @param result {Boolean} Function to be wrapped into promise
	     * @param [roleName] {String} Returned value in promise
	     *
	     * @return {Promise}
	     */
	    function wrapInPromise(result, roleName) {
	      if (result) {
	        return $q.resolve(roleName);
	      }
	
	      return $q.reject(roleName);
	    }
	
	    /**
	     * Checks if provided permission has accepted parameter types
	     * @methodOf permission.Role
	     * @private
	     *
	     * @throws {TypeError}
	     *
	     * @param roleName {String} Name representing role
	     * @param validationFunction {Function|Array<String>} Optional function used to validate if permissions are still
	     *   valid or list of permission names representing role
	     */
	    function validateConstructor(roleName, validationFunction) {
	      if (!angular.isString(roleName)) {
	        throw new TypeError('Parameter "roleName" name must be String');
	      }
	
	      if (!angular.isArray(validationFunction) && !angular.isFunction(validationFunction)) {
	        throw new TypeError('Parameter "validationFunction" must be array or function');
	      }
	    }
	
	
	    /**
	     * Ensures the validation is injectable using explicit annotation.
	     * Wraps a non-injectable function for backwards compatibility
	     * @methodOf permission.Role
	     * @private
	     *
	     * @param validationFunction {Function|Array} Function to wrap with injectable if needed
	     *
	     * @return {Function} Explicitly injectable function
	     */
	    function annotateValidationFunction(validationFunction) {
	      // Test if the validation function is just an array of permission names
	      if (angular.isArray(validationFunction) && !angular.isFunction(validationFunction[validationFunction.length - 1])) {
	        validationFunction = preparePermissionEvaluation(validationFunction);
	      } else if (!angular.isArray(validationFunction.$inject || validationFunction)) {
	        // The function is not explicitly annotated, so assume using old-style parameters
	        // and manually prepare for injection using our known old API parameters
	        validationFunction = ['roleName', 'transitionProperties', validationFunction];
	      }
	
	      return validationFunction;
	    }
	
	    /**
	     * Creates an injectable function that evaluates a set of permissions in place of a role validation function
	     * @methodOf permission.Role
	     * @private
	     *
	     * @param permissions {Array<String>} List of permissions to evaluate
	     *
	     * @return {Function}
	     */
	    function preparePermissionEvaluation(permissions) {
	      return function () {
	        var promises = permissions.map(function (permissionName) {
	          if (PermPermissionStore.hasPermissionDefinition(permissionName)) {
	            var permission = PermPermissionStore.getPermissionDefinition(permissionName);
	
	            return permission.validatePermission();
	          }
	
	          return $q.reject(permissionName);
	        });
	
	        return $q.all(promises);
	      };
	    }
	
	    return Role;
	  }
	
	  angular
	    .module('permission')
	    .factory('PermRole', PermRole);
	
	  /**
	   * Permission definition storage
	   * @name permission.PermPermissionStore
	   *
	   * @param PermPermission {permission.PermPermission|Function}
	   */
	  function PermPermissionStore(PermPermission) {
	    'ngInject';
	
	    /**
	     * @property permissionStore
	     *
	     * @type {Object}
	     */
	    var permissionStore = {};
	
	    this.definePermission = definePermission;
	    this.defineManyPermissions = defineManyPermissions;
	    this.removePermissionDefinition = removePermissionDefinition;
	    this.hasPermissionDefinition = hasPermissionDefinition;
	    this.getPermissionDefinition = getPermissionDefinition;
	    this.getStore = getStore;
	    this.clearStore = clearStore;
	
	    /**
	     * Allows to define permission on application configuration
	     * @methodOf permission.PermPermissionStore
	     *
	     * @param permissionName {String} Name of defined permission
	     * @param validationFunction {Function} Function used to validate if permission is valid
	     */
	    function definePermission(permissionName, validationFunction) {
	      permissionStore[permissionName] = new PermPermission(permissionName, validationFunction);
	    }
	
	    /**
	     * Allows to define set of permissionNames with shared validation function on application configuration
	     * @methodOf permission.PermPermissionStore
	     * @throws {TypeError}
	     *
	     * @param permissionNames {Array<Number>} Set of permission names
	     * @param validationFunction {Function} Function used to validate if permission is valid
	     */
	    function defineManyPermissions(permissionNames, validationFunction) {
	      if (!angular.isArray(permissionNames)) {
	        throw new TypeError('Parameter "permissionNames" name must be Array');
	      }
	
	      angular.forEach(permissionNames, function (permissionName) {
	        definePermission(permissionName, validationFunction);
	      });
	    }
	
	    /**
	     * Deletes permission
	     * @methodOf permission.PermPermissionStore
	     *
	     * @param permissionName {String} Name of defined permission
	     */
	    function removePermissionDefinition(permissionName) {
	      delete permissionStore[permissionName];
	    }
	
	    /**
	     * Checks if permission exists
	     * @methodOf permission.PermPermissionStore
	     *
	     * @param permissionName {String} Name of defined permission
	     * @returns {Boolean}
	     */
	    function hasPermissionDefinition(permissionName) {
	      return angular.isDefined(permissionStore[permissionName]);
	    }
	
	    /**
	     * Returns permission by it's name
	     * @methodOf permission.PermPermissionStore
	     *
	     * @returns {permission.Permission} Permissions definition object
	     */
	    function getPermissionDefinition(permissionName) {
	      return permissionStore[permissionName];
	    }
	
	    /**
	     * Returns all permissions
	     * @methodOf permission.PermPermissionStore
	     *
	     * @returns {Object} Permissions collection
	     */
	    function getStore() {
	      return permissionStore;
	    }
	
	    /**
	     * Removes all permissions
	     * @methodOf permission.PermPermissionStore
	     */
	    function clearStore() {
	      permissionStore = {};
	    }
	  }
	
	  angular
	    .module('permission')
	    .service('PermPermissionStore', PermPermissionStore);
	
	
	  /**
	   * Role definition storage
	   * @name permission.PermRoleStore
	   *
	   * @param PermRole {permission.PermRole} Role definition constructor
	   */
	  function PermRoleStore(PermRole) {
	    'ngInject';
	
	    var roleStore = {};
	
	    this.defineRole = defineRole;
	    this.defineManyRoles = defineManyRoles;
	    this.getRoleDefinition = getRoleDefinition;
	    this.hasRoleDefinition = hasRoleDefinition;
	    this.removeRoleDefinition = removeRoleDefinition;
	    this.getStore = getStore;
	    this.clearStore = clearStore;
	
	    /**
	     * Allows to add single role definition to the store by providing it's name and validation function
	     * @methodOf permission.PermRoleStore
	     *
	     * @param roleName {String} Name of defined role
	     * @param [validationFunction] {Function|Array<String>} Function used to validate if role is valid or set of
	     *   permission names that has to be owned to have a role
	     */
	    function defineRole(roleName, validationFunction) {
	      roleStore[roleName] = new PermRole(roleName, validationFunction);
	    }
	
	    /**
	     * Allows to define set of roleNames with shared validation function
	     * @methodOf permission.PermPermissionStore
	     * @throws {TypeError}
	     *
	     * @param roleMap {String, Function|Array<String>} Map of roles with matching validators
	     */
	    function defineManyRoles(roleMap) {
	      if (!angular.isObject(roleMap)) {
	        throw new TypeError('Parameter "roleNames" name must be object');
	      }
	
	      angular.forEach(roleMap, function (validationFunction, roleName) {
	        defineRole(roleName, validationFunction);
	      });
	    }
	
	    /**
	     * Deletes role from store
	     * @method permission.PermRoleStore
	     *
	     * @param roleName {String} Name of defined permission
	     */
	    function removeRoleDefinition(roleName) {
	      delete roleStore[roleName];
	    }
	
	    /**
	     * Checks if role is defined in store
	     * @method permission.PermRoleStore
	     *
	     * @param roleName {String} Name of role
	     * @returns {Boolean}
	     */
	    function hasRoleDefinition(roleName) {
	      return angular.isDefined(roleStore[roleName]);
	    }
	
	    /**
	     * Returns role definition object by it's name
	     * @method permission.PermRoleStore
	     *
	     * @returns {permission.PermRole} PermRole definition object
	     */
	    function getRoleDefinition(roleName) {
	      return roleStore[roleName];
	    }
	
	    /**
	     * Returns all role definitions
	     * @method permission.PermRoleStore
	     *
	     * @returns {Object} Defined roles collection
	     */
	    function getStore() {
	      return roleStore;
	    }
	
	    /**
	     * Removes all role definitions
	     * @method permission.PermRoleStore
	     */
	    function clearStore() {
	      roleStore = {};
	    }
	  }
	
	  angular
	    .module('permission')
	    .service('PermRoleStore', PermRoleStore);
	
	  /**
	   * Handles authorization based on provided permissions/roles.
	   * @name permission.permissionDirective
	   *
	   * Directive accepts single or combined attributes `permission-only` and `permission-except` that checks on
	   * DOM rendering if permissions/roles are met. Attributes can be passed either as String, Array or variable from
	   * parent scope. Directive also will watch for changes if applied and automatically update the view.
	   *
	   * @example
	   * <div permission
	   *      permission-only="'USER'">
	   * </div>
	   * <div permission
	   *      permission-only="['USER','ADMIN']"
	   *      permission-except="'MANAGER'">
	   * </div>
	   * <div permission permission-sref="'app.login'"></div>
	   *
	   * By default directive will show/hide elements if provided permissions matches.
	   * You can override this behaviour by passing `permission-on-authorized` and `permission-on-unauthorized`
	   *   attributes that will pass to your function `$element` as argument that you can freely manipulate your DOM
	   *   behaviour.
	   *
	   * Important! Function should be as references - `vm.disableElement` not `vm.disableElement()` to be able to
	   *   accept passed $element reference from inside of permissionDirective
	   *
	   * @example
	   * <div permission
	   *      permission-only="['USER','ADMIN']"
	   *      permission-on-authorized="PermPermissionStrategies.disableElement"
	   *      permission-on-unauthorized="PermPermissionStrategies.enableElement">
	   * </div>
	   *
	   * @param $log {Object} Logging service
	   * @param $injector {Object} Injector instance object
	   * @param PermPermissionMap {permission.permPermissionMap|Function} Map of state access rights
	   * @param PermPermissionStrategies {permission.permPermissionStrategies} Set of pre-defined directive behaviours
	   *
	   * @returns {{
	   *   restrict: string,
	   *   bindToController: {
	   *     sref: string
	   *     only: string,
	   *     except: string,
	   *     onAuthorized: function,
	   *     onUnauthorized: function
	   *   },
	   *   controllerAs: string,
	   *   controller: controller
	   * }} Directive instance
	   */
	  function PermissionDirective($log, $injector, PermPermissionMap, PermPermissionStrategies) {
	    'ngInject';
	
	    return {
	      restrict: 'A',
	      bindToController: {
	        sref: '=?permissionSref',
	        only: '=?permissionOnly',
	        except: '=?permissionExcept',
	        onAuthorized: '&?permissionOnAuthorized',
	        onUnauthorized: '&?permissionOnUnauthorized'
	      },
	      controllerAs: 'permission',
	      controller: ['$scope', '$element', '$permission', function ($scope, $element, $permission) {
	        var permission = this;
	
	        $scope.$watchGroup(['permission.only', 'permission.except', 'sref'],
	          function () {
	            try {
	              if (isSrefStateDefined()) {
	                var PermStateAuthorization = $injector.get('PermStateAuthorization');
	
	                PermStateAuthorization
	                  .authorizeByStateName(permission.sref)
	                  .then(function () {
	                    onAuthorizedAccess();
	                  })
	                  .catch(function () {
	                    onUnauthorizedAccess();
	                  });
	              } else {
	                var PermAuthorization = $injector.get('PermAuthorization');
	                var permissionMap = new PermPermissionMap({
	                  only: permission.only,
	                  except: permission.except
	                });
	
	                PermAuthorization
	                  .authorizeByPermissionMap(permissionMap)
	                  .then(function () {
	                    onAuthorizedAccess();
	                  })
	                  .catch(function () {
	                    onUnauthorizedAccess();
	                  });
	              }
	            } catch (e) {
	              onUnauthorizedAccess();
	              $log.error(e.message);
	            }
	          });
	
	        /**
	         * Returns true when permissions should be checked based on state name
	         * @private
	         *
	         * @returns {boolean}
	         */
	        function isSrefStateDefined() {
	          return $injector.has('$state') && permission.sref;
	        }
	
	        /**
	         * Calls `onAuthorized` function if provided or show element
	         * @private
	         */
	        function onAuthorizedAccess() {
	          if (angular.isFunction(permission.onAuthorized)) {
	            permission.onAuthorized()($element);
	          } else {
	            var onAuthorizedMethodName = $permission.defaultOnAuthorizedMethod;
	            PermPermissionStrategies[onAuthorizedMethodName]($element);
	          }
	        }
	
	        /**
	         * Calls `onUnauthorized` function if provided or hide element
	         * @private
	         */
	        function onUnauthorizedAccess() {
	          if (angular.isFunction(permission.onUnauthorized)) {
	            permission.onUnauthorized()($element);
	          } else {
	            var onUnauthorizedMethodName = $permission.defaultOnUnauthorizedMethod;
	            PermPermissionStrategies[onUnauthorizedMethodName]($element);
	          }
	        }
	      }]
	    };
	  }
	
	  angular
	    .module('permission')
	    .directive('permission', PermissionDirective);
	
	
	  /**
	   * Service responsible for handling view based authorization
	   * @name permission.PermAuthorization
	   *
	   * @param $q {Object} Angular promise implementation
	   */
	  function PermAuthorization($q) {
	    'ngInject';
	
	    this.authorizeByPermissionMap = authorizeByPermissionMap;
	
	    /**
	     * Handles authorization based on provided permissions map
	     * @methodOf permission.PermAuthorization
	     *
	     * @param map {permission.PermissionMap} Map of permission names
	     *
	     * @returns {promise} $q.promise object
	     */
	    function authorizeByPermissionMap(map) {
	      var deferred = $q.defer();
	
	      resolveExceptPrivilegeMap(deferred, map);
	
	      return deferred.promise;
	    }
	
	    /**
	     * Resolves flat set of "except" privileges
	     * @methodOf permission.PermAuthorization
	     * @private
	     *
	     * @param deferred {Object} Promise defer
	     * @param map {permission.PermissionMap} Access rights map
	     *
	     */
	    function resolveExceptPrivilegeMap(deferred, map) {
	      var exceptPromises = map.resolvePropertyValidity(map.except);
	
	      $q.any(exceptPromises)
	        .then(function (rejectedPermissions) {
	          deferred.reject(rejectedPermissions);
	        })
	        .catch(function () {
	          resolveOnlyPermissionMap(deferred, map);
	        });
	    }
	
	    /**
	     * Resolves flat set of "only" privileges
	     * @methodOf permission.PermAuthorization
	     * @private
	     *
	     * @param deferred {Object} Promise defer
	     * @param map {permission.PermissionMap} Access rights map
	     */
	    function resolveOnlyPermissionMap(deferred, map) {
	      if (!map.only.length) {
	        deferred.resolve();
	        return;
	      }
	
	      var onlyPromises = map.resolvePropertyValidity(map.only);
	      $q.any(onlyPromises)
	        .then(function (resolvedPermissions) {
	          deferred.resolve(resolvedPermissions);
	        })
	        .catch(function (rejectedPermission) {
	          deferred.reject(rejectedPermission);
	        });
	    }
	  }
	
	  angular
	    .module('permission')
	    .service('PermAuthorization', PermAuthorization);
	
	
	  /**
	   * Access rights map factory
	   * @name permission.PermPermissionMap
	   *
	   * @param $q {Object} Angular promise implementation
	   * @param $log {Object} Angular logging utility
	   * @param $injector {Object} Dependency injection instance
	   * @param $permission {Object} Permission module configuration object
	   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing ui-router transition parameters
	   * @param PermRoleStore {permission.PermRoleStore} Role definition storage
	   * @param PermPermissionStore {permission.PermPermissionStore} Permission definition storage
	   *
	   * @return {permission.PermissionMap}
	   */
	  function PermPermissionMap($q, $log, $injector, $permission, PermTransitionProperties, PermRoleStore, PermPermissionStore) {
	    'ngInject';
	
	    /**
	     * Constructs map object instructing authorization service how to handle authorizing
	     * @constructor permission.PermissionMap
	     *
	     * @param [permissionMap] {Object} Map of permissions provided to authorization service
	     * @param [permissionMap.only] {String|Array|Function} List of exclusive access right names allowed for
	     *   authorization
	     * @param [permissionMap.except] {String|Array|Function} List of exclusive access right names denied for
	     *   authorization
	     * @param [permissionMap.redirectTo] {String|Function|Object|promise} Handling redirection when rejected
	     *   authorization
	     */
	    function PermissionMap(permissionMap) {
	      // Suppress not defined object errors
	      permissionMap = permissionMap || {};
	
	      this.only = normalizeOnlyAndExceptProperty(permissionMap.only);
	      this.except = normalizeOnlyAndExceptProperty(permissionMap.except);
	      this.redirectTo = normalizeRedirectToProperty(permissionMap.redirectTo);
	    }
	
	    /**
	     * Redirects to fallback states when permissions fail
	     * @methodOf permission.PermissionMap
	     *
	     * @param [rejectedPermissionName] {String} Permission name
	     *
	     * @return {Promise}
	     */
	    PermissionMap.prototype.resolveRedirectState = function (rejectedPermissionName) {
	
	      // If redirectTo definition is not found stay where you are
	      if (!angular.isDefined(this.redirectTo)) {
	        return $q.reject();
	      }
	
	      var redirectState = this.redirectTo[rejectedPermissionName] || this.redirectTo['default'];
	
	      return resolveRedirectState(redirectState, rejectedPermissionName);
	    };
	
	    /**
	     * Resolves weather permissions set for "only" or "except" property are valid
	     * @methodOf permission.PermissionMap
	     *
	     * @param property {Array} "only" or "except" map property
	     *
	     * @return {Array<Promise>}
	     */
	    PermissionMap.prototype.resolvePropertyValidity = function (property) {
	
	      return property.map(function (privilegeName) {
	        if (PermRoleStore.hasRoleDefinition(privilegeName)) {
	          var role = PermRoleStore.getRoleDefinition(privilegeName);
	          return role.validateRole();
	        }
	
	        if (PermPermissionStore.hasPermissionDefinition(privilegeName)) {
	          var permission = PermPermissionStore.getPermissionDefinition(privilegeName);
	          return permission.validatePermission();
	        }
	
	        if (!$permission.suppressUndefinedPermissionWarning) {
	          $log.warn('Permission or role ' + privilegeName + ' was not defined.');
	        }
	        return $q.reject(privilegeName);
	      });
	    };
	
	    /**
	     * Handles function based redirection for rejected permissions
	     * @methodOf permission.PermissionMap
	     *
	     * @throws {TypeError}
	     *
	     * @param redirectFunction {Function} Redirection function
	     * @param rejectedPermissionName {String} Rejected permission
	     *
	     * @return {Promise}
	     */
	    function resolveRedirectState(redirectFunction, rejectedPermissionName) {
	      return $q
	        .when($injector.invoke(redirectFunction, null, {
	          rejectedPermission: rejectedPermissionName,
	          transitionProperties: PermTransitionProperties
	        }))
	        .then(function (redirectState) {
	          if (angular.isString(redirectState)) {
	            return {
	              state: redirectState
	            };
	          }
	
	          if (angular.isObject(redirectState)) {
	            return redirectState;
	          }
	
	          return $q.reject();
	        });
	    }
	
	    /**
	     * Handles extraction of permission map "only" and "except" properties and converts them into array objects
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param property {String|Array|Function} PermPermission map property "only" or "except"
	     *
	     * @returns {Array<String>} Array of permission "only" or "except" names
	     */
	    function normalizeOnlyAndExceptProperty(property) {
	      if (angular.isString(property)) {
	        return [property];
	      }
	
	      if (angular.isArray(property)) {
	        return property;
	      }
	
	      if (angular.isFunction(property)) {
	        return property.call(null, PermTransitionProperties);
	      }
	
	      return [];
	    }
	
	    /**
	     * Convert user provided input into key value dictionary with permission/role name as a key and injectable resolver
	     * function as a value
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param redirectTo {String|Function|Array|Object} PermPermission map property "redirectTo"
	     *
	     * @returns {Object<String, Object>} Redirection dictionary object
	     */
	    function normalizeRedirectToProperty(redirectTo) {
	      if (!angular.isDefined(redirectTo)) {
	        return;
	      }
	
	      if (isInjectable(redirectTo) || angular.isFunction(redirectTo)) {
	        return normalizeFunctionRedirectionRule(redirectTo);
	      }
	
	      if (angular.isObject(redirectTo)) {
	        if (isObjectSingleRedirectionRule(redirectTo)) {
	          return normalizeObjectSingleRedirectionRule(redirectTo);
	        }
	
	        return normalizeObjectMultipleRedirectionRule(redirectTo);
	      }
	
	      if (angular.isString(redirectTo)) {
	        return normalizeStringRedirectionRule(redirectTo);
	      }
	
	      throw new ReferenceError('Property "redirectTo" must be String, Function, Array or Object');
	    }
	
	    /**
	     * Convert string redirection rule into single-element redirection dictionary
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param redirectTo {String} PermPermission map property "redirectTo"
	     *
	     * @returns {Object<String, Object>} Redirection dictionary object
	     */
	    function normalizeStringRedirectionRule(redirectTo) {
	      var redirectionMap = {};
	
	      redirectionMap.default = function () {
	        return {
	          state: redirectTo
	        };
	      };
	      redirectionMap.default.$inject = ['rejectedPermission', 'transitionProperties'];
	
	      return redirectionMap;
	    }
	
	    /**
	     * Checks if redirection object is single rule type
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param redirectTo {Object} PermPermission map property "redirectTo"
	     *
	     * @returns {boolean}
	     */
	    function isObjectSingleRedirectionRule(redirectTo) {
	      return angular.isDefined(redirectTo.state);
	    }
	
	    /**
	     * Convert single redirection rule object into single-element redirection dictionary
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param redirectTo {Object} PermPermission map property "redirectTo"
	     *
	     * @returns {Object<String, Object>} Redirection dictionary object
	     */
	    function normalizeObjectSingleRedirectionRule(redirectTo) {
	      var redirectionMap = {};
	
	      redirectionMap.default = function () {
	        return redirectTo;
	      };
	
	      return redirectionMap;
	    }
	
	    /**
	     * Convert multiple redirection rule object into redirection dictionary
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param redirectTo {Object} PermPermission map property "redirectTo"
	     *
	     * @returns {Object<String, Object>} Redirection dictionary object
	     */
	    function normalizeObjectMultipleRedirectionRule(redirectTo) {
	      var redirectionMap = {};
	
	      angular.forEach(redirectTo, function (redirection, permission) {
	        if (isInjectable(redirection)) {
	          redirectionMap[permission] = redirection;
	        } else {
	          if (angular.isFunction(redirection)) {
	            redirectionMap[permission] = redirection;
	            redirectionMap[permission].$inject = [];
	          }
	        }
	
	        if (angular.isObject(redirection)) {
	          redirectionMap[permission] = function () {
	            return redirection;
	          };
	          redirectionMap[permission].$inject = [];
	        }
	
	        if (angular.isString(redirection)) {
	          redirectionMap[permission] = function () {
	            return {
	              state: redirection
	            };
	          };
	          redirectionMap[permission].$inject = [];
	        }
	      });
	
	      return redirectionMap;
	    }
	
	    /**
	     * Checks if property is injectable
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param property {Array|Object}
	     *
	     * @returns {boolean}
	     */
	    function isInjectable(property) {
	      return angular.isArray(property) || (angular.isFunction(property) && angular.isArray(property.$inject));
	    }
	
	    /**
	     * Convert function redirection rule into redirection dictionary
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param redirectTo {Function} PermPermission map property "redirectTo"
	     *
	     * @returns {Object<String, Object>} Redirection dictionary object
	     */
	    function normalizeFunctionRedirectionRule(redirectTo) {
	      var redirectionMap = {};
	
	      redirectionMap.default = redirectTo;
	
	      if (!angular.isDefined(redirectTo.$inject)) {
	        redirectionMap.default.$inject = ['rejectedPermission', 'transitionProperties'];
	      }
	
	      return redirectionMap;
	    }
	
	    return PermissionMap;
	  }
	
	  angular
	    .module('permission')
	    .factory('PermPermissionMap', PermPermissionMap);
	
	}(window, window.angular));


/***/ }),
/* 680 */
/***/ (function(module, exports) {

	/**
	 * angular-permission-ng
	 * Extension module of angular-permission for access control within angular-route
	 * @version v6.0.0 - 2018-01-20
	 * @link https://github.com/Narzerus/angular-permission
	 * @author Rafael Vidaurre <narzerus@gmail.com> (http://www.rafaelvidaurre.com), Blazej Krysiak <blazej.krysiak@gmail.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	(function (window, angular, undefined) {
	  'use strict';
	
	  /**
	   * @namespace permission.ng
	   */
	
	  /**
	   * @param $rootScope {Object}
	   * @param $location {Object}
	   * @param PermTransitionProperties {permission.PermTransitionProperties}
	   * @param PermTransitionEvents {permission.ng.PermTransitionEvents}
	   * @param PermAuthorization {permission.PermAuthorization}
	   * @param PermPermissionMap {permission.PermPermissionMap|Function}
	   */
	  run.$inject = ['$rootScope', '$location', 'PermTransitionProperties', 'PermTransitionEvents', 'PermAuthorization', 'PermPermissionMap'];
	  PermTransitionEvents.$inject = ['$delegate', '$rootScope', 'PermTransitionProperties', 'PermTransitionEventNames'];
	
	  function run($rootScope, $location, PermTransitionProperties, PermTransitionEvents, PermAuthorization, PermPermissionMap) {
	    'ngInject';
	
	    /**
	     * State transition interceptor
	     */
	    $rootScope.$on('$routeChangeStart', function (event, next, current) {
	      setTransitionProperties();
	
	      if (areSetRoutePermissions() && !PermTransitionEvents.areEventsDefaultPrevented()) {
	
	        PermTransitionEvents.broadcastPermissionStartEvent();
	
	        next.$$route.resolve = next.$$route.resolve || {};
	        next.$$route.resolve.$$permission = permissionResolver;
	      }
	
	      /**
	       * Checks if route has set permissions restrictions
	       * @method
	       * @private
	       *
	       * @returns {boolean}
	       */
	      function areSetRoutePermissions() {
	        try {
	          return !!next.$$route.data.permissions;
	        } catch (e) {
	          return false;
	        }
	      }
	
	      /**
	       * Updates values of `PermTransitionProperties` holder object
	       * @method
	       * @private
	       */
	      function setTransitionProperties() {
	        PermTransitionProperties.next = next;
	        PermTransitionProperties.current = current;
	      }
	
	      function permissionResolver() {
	        var PermissionMap = new PermPermissionMap({
	          only: next.$$route.data.permissions.only,
	          except: next.$$route.data.permissions.except,
	          redirectTo: next.$$route.data.permissions.redirectTo
	        });
	
	        var authorizationResult = PermAuthorization.authorizeByPermissionMap(PermissionMap);
	
	        authorizationResult
	          .then(function () {
	            handleAuthorizedState();
	          })
	          .catch(function (rejectedPermission) {
	            handleUnauthorizedState(rejectedPermission, PermissionMap);
	          });
	
	        return authorizationResult;
	      }
	
	      /**
	       * Handles redirection for authorized access
	       * @method
	       * @private
	       */
	      function handleAuthorizedState() {
	        PermTransitionEvents.broadcastPermissionAcceptedEvent();
	      }
	
	      /**
	       * Handles redirection for unauthorized access
	       * @method
	       * @private
	       *
	       * @param rejectedPermission {String} Rejected access right
	       * @param permissionMap {permission.PermPermissionMap} State permission map
	       */
	      function handleUnauthorizedState(rejectedPermission, permissionMap) {
	        PermTransitionEvents.broadcastPermissionDeniedEvent();
	
	        permissionMap
	          .resolveRedirectState(rejectedPermission)
	          .then(function (redirect) {
	            $location.path(redirect.state).replace();
	          });
	      }
	    });
	  }
	
	  var ngPermission = angular
	    .module('permission.ng', ['permission', 'ngRoute'])
	    .run(run);
	
	  if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
	    module.exports = ngPermission.name;
	  }
	
	  /**
	   * Service responsible for managing and emitting events
	   * @name permission.ng.PermTransitionEvents
	   *
	   * @extends {permission.PermTransitionEvents}
	   *
	   * @param $delegate {Object} Parent instance being extended
	   * @param $rootScope {Object} Top-level angular scope
	   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing transition parameters
	   * @param PermTransitionEventNames {permission.ng.PermTransitionEventNames} Constant storing event names
	   */
	  function PermTransitionEvents($delegate, $rootScope, PermTransitionProperties, PermTransitionEventNames) {
	    'ngInject';
	
	    $delegate.areEventsDefaultPrevented = areEventsDefaultPrevented;
	    $delegate.broadcastPermissionStartEvent = broadcastPermissionStartEvent;
	    $delegate.broadcastPermissionAcceptedEvent = broadcastPermissionAcceptedEvent;
	    $delegate.broadcastPermissionDeniedEvent = broadcastPermissionDeniedEvent;
	
	    /**
	     * Checks if state events are not prevented by default
	     * @methodOf permission.ng.PermTransitionEvents
	     *
	     * @returns {boolean}
	     */
	    function areEventsDefaultPrevented() {
	      return isRouteChangePermissionStartDefaultPrevented();
	    }
	
	    /**
	     * Broadcasts "$routeChangePermissionStart" event from $rootScope
	     * @methodOf permission.ng.PermTransitionEvents
	     */
	    function broadcastPermissionStartEvent() {
	      $rootScope.$broadcast(PermTransitionEventNames.permissionStart, PermTransitionProperties.next);
	    }
	
	    /**
	     * Broadcasts "$routeChangePermissionAccepted" event from $rootScope
	     * @methodOf permission.ng.PermTransitionEvents
	     */
	    function broadcastPermissionAcceptedEvent() {
	      $rootScope.$broadcast(PermTransitionEventNames.permissionAccepted, PermTransitionProperties.next);
	    }
	
	    /**
	     * Broadcasts "$routeChangePermissionDenied" event from $rootScope
	     * @methodOf permission.ng.PermTransitionEvents
	     */
	    function broadcastPermissionDeniedEvent() {
	      $rootScope.$broadcast(PermTransitionEventNames.permissionDenied, PermTransitionProperties.next);
	    }
	
	    /**
	     * Checks if event $routeChangePermissionStart hasn't been disabled by default
	     * @methodOf permission.ng.PermTransitionEvents
	     * @private
	     *
	     * @returns {boolean}
	     */
	    function isRouteChangePermissionStartDefaultPrevented() {
	      return $rootScope.$broadcast(PermTransitionEventNames.permissionStart, PermTransitionProperties.next).defaultPrevented;
	    }
	
	    return $delegate;
	  }
	
	  angular
	    .module('permission.ng')
	    .decorator('PermTransitionEvents', PermTransitionEvents);
	
	  /**
	   * Constant storing event names for ng-route
	   * @name permission.ng.PermTransitionEventNames
	   *
	   * @type {Object.<String,Object>}
	   *
	   * @property permissionStart {String} Event name called when started checking for permissions
	   * @property permissionAccepted {String} Event name called when authorized
	   * @property permissionDenied {String} Event name called when unauthorized
	   */
	  var PermTransitionEventNames = {
	    permissionStart: '$routeChangePermissionStart',
	    permissionAccepted: '$routeChangePermissionAccepted',
	    permissionDenied: '$routeChangePermissionDenied'
	  };
	
	  angular
	    .module('permission.ng')
	    .value('PermTransitionEventNames', PermTransitionEventNames);
	
	}(window, window.angular));


/***/ }),
/* 681 */
/***/ (function(module, exports) {

	/**
	 * angular-permission-ui
	 * Extension module of angular-permission for access control within ui-router
	 * @version v6.0.0 - 2018-01-20
	 * @link https://github.com/Narzerus/angular-permission
	 * @author Rafael Vidaurre <narzerus@gmail.com> (http://www.rafaelvidaurre.com), Blazej Krysiak <blazej.krysiak@gmail.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	(function (window, angular, undefined) {
	  'use strict';
	
	  /**
	   * @namespace permission.ui
	   */
	
	  /**
	   * @param $stateProvider {Object}
	   */
	  config.$inject = ['$stateProvider'];
	  run.$inject = ['$injector', '$rootScope', '$state', 'PermTransitionProperties', 'PermTransitionEvents', 'PermStateAuthorization', 'PermStatePermissionMap'];
	  PermTransitionEvents.$inject = ['$delegate', '$rootScope', 'PermTransitionProperties', 'PermTransitionEventNames'];
	  PermStateAuthorization.$inject = ['$q', '$state', 'PermStatePermissionMap'];
	  PermStatePermissionMap.$inject = ['PermPermissionMap'];
	
	  function config($stateProvider) {
	    'ngInject';
	
	    $stateProvider.decorator('$delegate', function ($delegate) {
	
	      /**
	       * Property containing full state object definition
	       *
	       * This decorator is required to access full state object instead of just it's configuration
	       * Can be removed when implemented https://github.com/angular-ui/ui-router/issues/13.
	       *
	       * @returns {Object}
	       */
	      $delegate.self.$$permissionState = function () {
	        return $delegate;
	      };
	
	      return $delegate;
	    });
	  }
	
	  /**
	   * @param $injector {Object}
	   * @param $rootScope {Object}
	   * @param $state {Object}
	   * @param PermTransitionProperties {permission.PermTransitionProperties}
	   * @param PermTransitionEvents {permission.ui.PermTransitionEvents}
	   * @param PermStateAuthorization {permission.ui.PermStateAuthorization}
	   * @param PermStatePermissionMap {permission.ui.PermStatePermissionMap}
	   */
	  function run($injector, $rootScope, $state, PermTransitionProperties, PermTransitionEvents, PermStateAuthorization, PermStatePermissionMap) {
	    'ngInject';
	
	    // For ui-router 1.x use $transitions web hook
	    if ($injector.has('$transitions')) {
	      var $transitions = $injector.get('$transitions');
	      $transitions.onBefore({}, handleOnBeforeWebHook);
	      // For ui-router 0.x use old-style eventing
	    } else {
	      $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
	        handleStateChangeStartEvent(event, toState, toParams, fromState, fromParams, options);
	      });
	    }
	
	    /**
	     * State transition web hook
	     * @param transition {Object}
	     */
	    function handleOnBeforeWebHook(transition) {
	      setTransitionProperties(transition);
	      var statePermissionMap = new PermStatePermissionMap(PermTransitionProperties.toState);
	
	      return PermStateAuthorization
	        .authorizeByPermissionMap(statePermissionMap)
	        .catch(function (rejectedPermission) {
	          return statePermissionMap
	            .resolveRedirectState(rejectedPermission)
	            .then(function (redirect) {
	              return transition.router.stateService.target(redirect.state, redirect.params, redirect.options);
	            });
	        });
	
	      /**
	       * Updates values of `PermTransitionProperties` holder object
	       * @method
	       * @private
	       */
	      function setTransitionProperties(transition) {
	        PermTransitionProperties.toState = transition.to();
	        PermTransitionProperties.toParams = transition.params('to');
	        PermTransitionProperties.fromState = transition.from();
	        PermTransitionProperties.fromParams = transition.params('from');
	        PermTransitionProperties.options = transition.options();
	      }
	    }
	
	    /**
	     * State transition event interceptor
	     */
	    function handleStateChangeStartEvent(event, toState, toParams, fromState, fromParams, options) {
	      if (!isAuthorizationFinished()) {
	        setStateAuthorizationStatus(true);
	        setTransitionProperties();
	
	        if (!PermTransitionEvents.areEventsDefaultPrevented()) {
	          PermTransitionEvents.broadcastPermissionStartEvent();
	
	          event.preventDefault();
	          var statePermissionMap = new PermStatePermissionMap(PermTransitionProperties.toState);
	
	          PermStateAuthorization
	            .authorizeByPermissionMap(statePermissionMap)
	            .then(function () {
	              handleAuthorizedState();
	            })
	            .catch(function (rejectedPermission) {
	              handleUnauthorizedState(rejectedPermission, statePermissionMap);
	            })
	            .finally(function () {
	              setStateAuthorizationStatus(false);
	            });
	        } else {
	          setStateAuthorizationStatus(false);
	        }
	      }
	
	
	      /**
	       * Updates values of `PermTransitionProperties` holder object
	       * @method
	       * @private
	       */
	      function setTransitionProperties() {
	        PermTransitionProperties.toState = toState;
	        PermTransitionProperties.toParams = toParams;
	        PermTransitionProperties.fromState = fromState;
	        PermTransitionProperties.fromParams = fromParams;
	        PermTransitionProperties.options = options;
	      }
	
	      /**
	       * Sets internal state `$$finishedAuthorization` variable to prevent looping
	       * @method
	       * @private
	       *
	       * @param status {boolean} When true authorization has been already preceded
	       */
	      function setStateAuthorizationStatus(status) {
	        angular.extend(toState, {
	          '$$isAuthorizationFinished': status
	        });
	      }
	
	      /**
	       * Checks if state has been already checked for authorization
	       * @method
	       * @private
	       *
	       * @returns {boolean}
	       */
	      function isAuthorizationFinished() {
	        return toState.$$isAuthorizationFinished;
	      }
	
	      /**
	       * Handles redirection for authorized access
	       * @method
	       * @private
	       */
	      function handleAuthorizedState() {
	        PermTransitionEvents.broadcastPermissionAcceptedEvent();
	
	        // Overwrite notify option to broadcast it later
	        var transitionOptions = angular.extend({}, PermTransitionProperties.options, {
	          notify: false,
	          location: true
	        });
	
	        $state
	          .go(PermTransitionProperties.toState.name, PermTransitionProperties.toParams, transitionOptions)
	          .then(function () {
	            PermTransitionEvents.broadcastStateChangeSuccessEvent();
	          });
	      }
	
	      /**
	       * Handles redirection for unauthorized access
	       * @method
	       * @private
	       *
	       * @param rejectedPermission {String} Rejected access right
	       * @param statePermissionMap {permission.ui.PermPermissionMap} State permission map
	       */
	      function handleUnauthorizedState(rejectedPermission, statePermissionMap) {
	        PermTransitionEvents.broadcastPermissionDeniedEvent();
	
	        statePermissionMap
	          .resolveRedirectState(rejectedPermission)
	          .then(function (redirect) {
	            $state.go(redirect.state, redirect.params, redirect.options);
	          });
	      }
	    }
	  }
	
	  var uiPermission = angular
	    .module('permission.ui', ['permission', 'ui.router'])
	    .config(config)
	    .run(run);
	
	  if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
	    module.exports = uiPermission.name;
	  }
	
	
	  /**
	   * Service responsible for managing and emitting events
	   * @name permission.ui.PermTransitionEvents
	   *
	   * @extends permission.PermTransitionEvents
	   *
	   * @param $delegate {Object} Parent instance being extended
	   * @param $rootScope {Object} Top-level angular scope
	   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing transition parameters
	   * @param PermTransitionEventNames {permission.ui.PermTransitionEventNames} Constant storing event names
	   */
	  function PermTransitionEvents($delegate, $rootScope, PermTransitionProperties, PermTransitionEventNames) {
	    'ngInject';
	
	    $delegate.areEventsDefaultPrevented = areEventsDefaultPrevented;
	    $delegate.broadcastStateChangeSuccessEvent = broadcastStateChangeSuccessEvent;
	    $delegate.broadcastPermissionStartEvent = broadcastPermissionStartEvent;
	    $delegate.broadcastPermissionAcceptedEvent = broadcastPermissionAcceptedEvent;
	    $delegate.broadcastPermissionDeniedEvent = broadcastPermissionDeniedEvent;
	
	    /**
	     * Checks if state events are not prevented by default
	     * @methodOf permission.ui.PermTransitionEvents
	     *
	     * @returns {boolean}
	     */
	    function areEventsDefaultPrevented() {
	      return isStateChangePermissionStartDefaultPrevented() || isStateChangeStartDefaultPrevented();
	    }
	
	    /**
	     * Broadcasts "$stateChangePermissionStart" event from $rootScope
	     * @methodOf permission.ui.PermTransitionEvents
	     */
	    function broadcastPermissionStartEvent() {
	      $rootScope.$broadcast(PermTransitionEventNames.permissionStart,
	        PermTransitionProperties.toState, PermTransitionProperties.toParams,
	        PermTransitionProperties.options);
	    }
	
	    /**
	     * Broadcasts "$stateChangePermissionAccepted" event from $rootScope
	     * @methodOf permission.ui.PermTransitionEvents
	     */
	    function broadcastPermissionAcceptedEvent() {
	      $rootScope.$broadcast(PermTransitionEventNames.permissionAccepted,
	        PermTransitionProperties.toState, PermTransitionProperties.toParams,
	        PermTransitionProperties.options);
	    }
	
	    /**
	     * Broadcasts "$tateChangePermissionDenied" event from $rootScope
	     * @methodOf permission.ui.PermTransitionEvents
	     */
	    function broadcastPermissionDeniedEvent() {
	      $rootScope.$broadcast(PermTransitionEventNames.permissionDenies,
	        PermTransitionProperties.toState, PermTransitionProperties.toParams,
	        PermTransitionProperties.options);
	    }
	
	    /**
	     * Broadcasts "$stateChangeSuccess" event from $rootScope
	     * @methodOf permission.ui.PermTransitionEvents
	     */
	    function broadcastStateChangeSuccessEvent() {
	      $rootScope.$broadcast('$stateChangeSuccess',
	        PermTransitionProperties.toState, PermTransitionProperties.toParams,
	        PermTransitionProperties.fromState, PermTransitionProperties.fromParams);
	    }
	
	    /**
	     * Checks if event $stateChangePermissionStart hasn't been disabled by default
	     * @methodOf permission.ui.PermTransitionEvents
	     * @private
	     *
	     * @returns {boolean}
	     */
	    function isStateChangePermissionStartDefaultPrevented() {
	      return $rootScope.$broadcast(PermTransitionEventNames.permissionStart,
	        PermTransitionProperties.toState, PermTransitionProperties.toParams,
	        PermTransitionProperties.options).defaultPrevented;
	    }
	
	    /**
	     * Checks if event $stateChangeStart hasn't been disabled by default
	     * @methodOf permission.ui.PermTransitionEvents
	     * @private
	     *
	     * @returns {boolean}
	     */
	    function isStateChangeStartDefaultPrevented() {
	      return $rootScope.$broadcast('$stateChangeStart',
	        PermTransitionProperties.toState, PermTransitionProperties.toParams,
	        PermTransitionProperties.fromState, PermTransitionProperties.fromParams,
	        PermTransitionProperties.options).defaultPrevented;
	    }
	
	    return $delegate;
	  }
	
	  angular
	    .module('permission.ui')
	    .decorator('PermTransitionEvents', PermTransitionEvents);
	
	  /**
	   * Constant storing event names for ng-route
	   * @name permission.ui.PermTransitionEventNames
	   *
	   * @type {Object.<String,Object>}
	   *
	   * @property permissionStart {String} Event name called when started checking for permissions
	   * @property permissionAccepted {String} Event name called when authorized
	   * @property permissionDenies {String} Event name called when unauthorized
	   */
	  var PermTransitionEventNames = {
	    permissionStart: '$stateChangePermissionStart',
	    permissionAccepted: '$stateChangePermissionAccepted',
	    permissionDenies: '$stateChangePermissionDenied'
	  };
	
	  angular
	    .module('permission.ui')
	    .value('PermTransitionEventNames', PermTransitionEventNames);
	
	
	  /**
	   * Service responsible for handling inheritance-enabled state-based authorization in ui-router
	   * @extends permission.PermPermissionMap
	   * @name permission.ui.PermStateAuthorization
	   *
	   * @param $q {Object} Angular promise implementation
	   * @param $state {Object} State object
	   * @param PermStatePermissionMap {permission.ui.PermStatePermissionMap|Function} Angular promise implementation
	   */
	  function PermStateAuthorization($q, $state, PermStatePermissionMap) {
	    'ngInject';
	
	    this.authorizeByPermissionMap = authorizeByPermissionMap;
	    this.authorizeByStateName = authorizeByStateName;
	
	    /**
	     * Handles authorization based on provided state permission map
	     * @methodOf permission.ui.PermStateAuthorization
	     *
	     * @param statePermissionMap
	     *
	     * @return {promise}
	     */
	    function authorizeByPermissionMap(statePermissionMap) {
	      return authorizeStatePermissionMap(statePermissionMap);
	    }
	
	    /**
	     * Authorizes uses by provided state name
	     * @methodOf permission.ui.PermStateAuthorization
	     *
	     * @param stateName {String}
	     * @returns {promise}
	     */
	    function authorizeByStateName(stateName) {
	      var srefState = $state.get(stateName);
	      var permissionMap = new PermStatePermissionMap(srefState);
	
	      return authorizeByPermissionMap(permissionMap);
	    }
	
	    /**
	     * Checks authorization for complex state inheritance
	     * @methodOf permission.ui.PermStateAuthorization
	     * @private
	     *
	     * @param map {permission.ui.StatePermissionMap} State access rights map
	     *
	     * @returns {promise} $q.promise object
	     */
	    function authorizeStatePermissionMap(map) {
	      var deferred = $q.defer();
	
	      resolveExceptStatePermissionMap(deferred, map);
	
	      return deferred.promise;
	    }
	
	    /**
	     * Resolves compensated set of "except" privileges
	     * @methodOf permission.ui.PermStateAuthorization
	     * @private
	     *
	     * @param deferred {Object} Promise defer
	     * @param map {permission.ui.StatePermissionMap} State access rights map
	     */
	    function resolveExceptStatePermissionMap(deferred, map) {
	      var exceptPromises = resolveStatePermissionMap(map.except, map);
	
	      // Reverse the promises, so if any "except" privileges are not met, the promise rejects
	      $q.all(reversePromises(exceptPromises))
	        .then(function () {
	          resolveOnlyStatePermissionMap(deferred, map);
	        })
	        .catch(function (rejectedPermissions) {
	
	          if (!angular.isArray(rejectedPermissions)) {
	            rejectedPermissions = [rejectedPermissions];
	          }
	
	          deferred.reject(rejectedPermissions[0]);
	        });
	    }
	
	    /**
	     * Resolves compensated set of "only" privileges
	     * @methodOf permission.ui.PermStateAuthorization
	     * @private
	     *
	     * @param deferred {Object} Promise defer
	     * @param map {permission.ui.StatePermissionMap} State access rights map
	     */
	    function resolveOnlyStatePermissionMap(deferred, map) {
	      if (!map.only.length) {
	        deferred.resolve();
	        return;
	      }
	
	      var onlyPromises = resolveStatePermissionMap(map.only, map);
	
	      $q.all(onlyPromises)
	        .then(function (resolvedPermissions) {
	          deferred.resolve(resolvedPermissions);
	        })
	        .catch(function (rejectedPermission) {
	          deferred.reject(rejectedPermission);
	        });
	    }
	
	    /**
	     * Performs iteration over list of privileges looking for matches
	     * @methodOf permission.ui.PermStateAuthorization
	     * @private
	     *
	     * @param privilegesNames {Array} Array of sets of access rights
	     * @param map {permission.ui.StatePermissionMap} State access rights map
	     *
	     * @returns {Array<Promise>} Promise collection
	     */
	    function resolveStatePermissionMap(privilegesNames, map) {
	      if (!privilegesNames.length) {
	        return [$q.reject()];
	      }
	
	      return privilegesNames.map(function (statePrivileges) {
	        var resolvedStatePrivileges = map.resolvePropertyValidity(statePrivileges);
	        return $q.any(resolvedStatePrivileges)
	          .then(function (resolvedPermissions) {
	            if (angular.isArray(resolvedPermissions)) {
	              return resolvedPermissions[0];
	            }
	            return resolvedPermissions;
	          });
	      });
	    }
	
	    /**
	     * Creates an Array of Promises that resolve when rejected, and reject when resolved
	     * @methodOf permission.ui.PermStateAuthorization
	     * @private
	     *
	     * @param promises {Array} Array of promises
	     *
	     * @returns {Array<Promise>} Promise collection
	     */
	    function reversePromises(promises) {
	      return promises.map(function (promise) {
	        var d = $q.defer();
	        promise.then(d.reject, d.resolve);
	        return d.promise;
	      });
	    }
	  }
	
	  angular
	    .module('permission')
	    .service('PermStateAuthorization', PermStateAuthorization);
	
	  /**
	   * State Access rights map factory
	   * @function
	   * @name permission.ui.PermStatePermissionMap
	   *
	   * @param PermPermissionMap {permission.PermPermissionMap|Function}
	   *
	   * @return {permission.ui.PermStatePermissionMap}
	   */
	  function PermStatePermissionMap(PermPermissionMap) {
	    'ngInject';
	
	    StatePermissionMap.prototype = new PermPermissionMap();
	
	    /**
	     * Constructs map instructing authorization service how to handle authorizing
	     * @constructor permission.ui.PermStatePermissionMap
	     * @extends permission.PermPermissionMap
	     */
	    function StatePermissionMap(state) {
	      var toStateObject = state.$$permissionState();
	      var toStatePath = toStateObject.path;
	
	      angular.forEach(toStatePath, function (state) {
	        if (areSetStatePermissions(state)) {
	          var permissionMap = new PermPermissionMap(state.data.permissions);
	          this.extendPermissionMap(permissionMap);
	        }
	      }, this);
	    }
	
	    /**
	     * Extends permission map by pushing to it state's permissions
	     * @methodOf permission.ui.StatePermissionMap
	     *
	     * @param permissionMap {permission.PermPermissionMap} Compensated permission map
	     */
	    StatePermissionMap.prototype.extendPermissionMap = function (permissionMap) {
	      if (permissionMap.only.length) {
	        this.only = this.only.concat([permissionMap.only]);
	      }
	      if (permissionMap.except.length) {
	        this.except = this.except.concat([permissionMap.except]);
	      }
	
	      if (angular.isDefined(permissionMap.redirectTo)) {
	        this.redirectTo = angular.extend({}, this.redirectTo, permissionMap.redirectTo);
	      }
	    };
	
	
	    /**
	     * Checks if state has set permissions
	     * We check for hasOwnProperty, because ui-router lets the `data` property inherit from its parent
	     * @methodOf permission.ui.StatePermissionMap
	     * @private
	     *
	     * @returns {boolean}
	     */
	    function areSetStatePermissions(state) {
	      try {
	        return Object.prototype.hasOwnProperty.call(state.data, 'permissions');
	      } catch (e) {
	        return false;
	      }
	    }
	
	    return StatePermissionMap;
	  }
	
	  angular
	    .module('permission.ui')
	    .factory('PermStatePermissionMap', PermStatePermissionMap);
	
	}(window, window.angular));


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var serviceRequestToWorkorderFormComponent = exports.serviceRequestToWorkorderFormComponent = function () {
	  /*@ngInject*/
	  serviceRequestToWorkorderFormComponent.$inject = ['WorkOrderCodesService'];
	  function serviceRequestToWorkorderFormComponent(WorkOrderCodesService) {
	    var _this = this;
	
	    _classCallCheck(this, serviceRequestToWorkorderFormComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	
	      this.serviceRequest = this.config.data;
	      this.code = this.serviceRequest.code;
	    };
	
	    WorkOrderCodesService.query(function (data) {
	      _this.codes = data.map(function (code) {
	        return code.code;
	      });
	    });
	
	    this.closeServiceRequest = true;
	  }
	
	  _createClass(serviceRequestToWorkorderFormComponent, [{
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: {
	          code: this.code,
	          note: this.note,
	          close: this.closeServiceRequest
	        } });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return serviceRequestToWorkorderFormComponent;
	}();
	
	exports.default = angular.module('conduu.serviceRequestToWorkorderForm', []).component('serviceRequestToWorkorderForm', {
	  template: __webpack_require__(683),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: serviceRequestToWorkorderFormComponent
	}).name;

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">Create Work Order from Service Request</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <!-- Status -->\r\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.code.$valid && ctrl.submitted,\r\n                                        'has-error': form.code.$invalid && ctrl.submitted }\">\r\n    <label>Work Order Code</label>\r\n    <br/>\r\n\r\n    <div class=\"input-group\" style=\"display: inline-block\">\r\n      <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.codes\" ng-model=\"$ctrl.code\"\r\n              style=\"display: inline-block; width: auto; min-width:180px\"></select>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Note -->\r\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.note.$valid && $ctrl.submitted,\r\n                                        'has-error': form.note.$invalid && $ctrl.submitted }\">\r\n    <label>Message for Owner</label>\r\n    <br/>\r\n\r\n    <div class=\"input-group\" style=\"width:100%\">\r\n      <textarea class=\"form-control\" style=\"width:100%\" rows=\"4\" ng-model=\"$ctrl.note\"></textarea>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Close Service Request -->\r\n  <div class=\"form-group\">\r\n    <label><input type=\"checkbox\" ng-model=\"$ctrl.closeServiceRequest\" />&nbsp;Close Service Request</label>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!$ctrl.code\" ng-click=\"$ctrl.ok()\">Create Work Order</button>\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var targetDateChangeFormComponent = exports.targetDateChangeFormComponent = function () {
	  /*@ngInject*/
	  function targetDateChangeFormComponent() {
	    _classCallCheck(this, targetDateChangeFormComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	
	      if (this.config.data.targetDate) this.targetDate = new Date(this.config.data.targetDate);
	    };
	  }
	
	  _createClass(targetDateChangeFormComponent, [{
	    key: 'openTargetDatePopup',
	    value: function openTargetDatePopup() {
	      this.targetDatePopupOpened = true;
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: {
	          targetDate: this.targetDate,
	          note: this.note
	        } });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return targetDateChangeFormComponent;
	}();
	
	exports.default = angular.module('conduu.targetDateChangeForm', []).component('targetDateChangeForm', {
	  template: __webpack_require__(685),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: targetDateChangeFormComponent
	}).name;

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">Target Date Change</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <!-- Target Date -->\r\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.targetDate.$valid && $ctrl.submitted,\r\n                                        'has-error': form.targetDate.$invalid && $ctrl.submitted }\">\r\n    <label>Target Date</label>\r\n    <br/>\r\n\r\n    <div class=\"input-group\" style=\"display: inline-block\">\r\n      <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"$ctrl.targetDate\" is-open=\"$ctrl.targetDatePopupOpened\"\r\n             close-text=\"Close\" style=\"display: inline-block; width: auto; min-width:180px\" />\r\n      <span class=\"input-group-btn\">\r\n          <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.openTargetDatePopup()\"><i class=\"fa fa-fw fa-calendar\"></i></button>\r\n        </span>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Note -->\r\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.note.$valid && $ctrl.submitted,\r\n                                        'has-error': form.note.$invalid && $ctrl.submitted }\">\r\n    <label>Note</label>\r\n    <br/>\r\n\r\n    <div class=\"input-group\" style=\"width:100%\">\r\n      <textarea class=\"form-control\" style=\"width:100%\" rows=\"4\" ng-model=\"$ctrl.note\"></textarea>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!$ctrl.targetDate\" ng-click=\"$ctrl.ok()\">Change Target Date</button>\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var issuedToChangeFormComponent = exports.issuedToChangeFormComponent = function () {
	  issuedToChangeFormComponent.$inject = ['$uibModal', 'VendorService'];
	  function issuedToChangeFormComponent($uibModal, VendorService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, issuedToChangeFormComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	
	      if (this.config.data.issuedTo) this.issuedTo = this.config.data.issuedTo._id;
	    };
	
	    this.$uibModal = $uibModal;
	
	    VendorService.query(function (data) {
	      _this.vendors = data.map(function (vendor) {
	        return {
	          value: vendor._id,
	          name: vendor.name,
	          type: vendor.type
	        };
	      });
	    });
	  }
	
	  _createClass(issuedToChangeFormComponent, [{
	    key: 'vendorLookup',
	    value: function vendorLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'vendorLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (vendor) {
	        that.selectedVendor = vendor;
	        that.issuedTo = vendor._id;
	      }, function () {});
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: {
	          issuedTo: this.issuedTo,
	          note: this.note
	        } });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return issuedToChangeFormComponent;
	}();
	
	exports.default = angular.module('conduu.issuedToChangeForm', []).component('issuedToChangeForm', {
	  template: __webpack_require__(687),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: issuedToChangeFormComponent
	}).name;

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">Vendor/Staff Change</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.title.$valid && $ctrl.submitted,\r\n                                            'has-error': form.title.$invalid && $ctrl.submitted }\">\r\n    <label>Issued To</label>\r\n    <br/>\r\n\r\n    <div class=\"input-group\" style=\"display: inline-block\">\r\n      <select class=\"form-control\" ng-options=\"o.value as o.name group by o.type for o in $ctrl.vendors\" ng-model=\"$ctrl.issuedTo\"\r\n              style=\"display: inline-block; width: auto\"></select>\r\n      <span class=\"input-group-btn\">\r\n              <a class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.vendorLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n              <a class=\"btn btn-danger\" ng-disabled=\"!$ctrl.issuedTo\" ng-click=\"$ctrl.issuedTo = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n            </span>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Note -->\r\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.note.$valid && $ctrl.submitted,\r\n                                        'has-error': form.note.$invalid && $ctrl.submitted }\">\r\n    <label>Note</label>\r\n    <br/>\r\n\r\n    <div class=\"input-group\" style=\"width:100%\">\r\n      <textarea class=\"form-control\" style=\"width:100%\" rows=\"4\" ng-model=\"$ctrl.note\"></textarea>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!$ctrl.issuedTo\" ng-click=\"$ctrl.ok()\">Change Vendor/Staff</button>\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReportsComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reports = __webpack_require__(689);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var ReportsComponent = exports.ReportsComponent = function () {
	  ReportsComponent.$inject = ['$uibModal', 'SettingsService'];
	  function ReportsComponent($uibModal, SettingsService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, ReportsComponent);
	
	    this.$uibModal = $uibModal;
	
	    SettingsService.getByName({ name: 'reports' }, function (settings) {
	      _this.reports = settings.data;
	    });
	  }
	
	  _createClass(ReportsComponent, [{
	    key: 'openReportFilterModal',
	    value: function openReportFilterModal(report) {
	      var that = this;
	
	      if (report.report == 'script' && report.script) {
	        delete report.script;
	      }
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'reportFilterModal',
	        resolve: {
	          config: function config() {
	            return report;
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }]);
	
	  return ReportsComponent;
	}();
	
	exports.default = angular.module('conduu.reports', [uiRouter]).config(_reports2.default).component('reports', {
	  template: __webpack_require__(690),
	  controller: ReportsComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('reports', {
	    url: '/reports',
	    template: '<reports></reports>'
	  });
	}];

/***/ }),
/* 690 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n\r\n    <div class=\"row\">\r\n        <ol class=\"breadcrumb\">\r\n            <h2>Reports</h2>\r\n            <li class=\"active\"><a href=\"#\">Reports</a></li>\r\n        </ol>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-4 col-sm-12\">\r\n            <h4>Portfolio Reports</h4>\r\n\r\n            <div class=\"list-group\">\r\n                <a ng-repeat-start=\"report in ctrl.reports.portfolio\" ng-if=\"report.href\" target=\"_blank\" ng-href=\"{{report.href}}\" class=\"list-group-item\">\r\n                    <i class=\"fa fa-fw fa-{{report.icon}} text-muted pull-right\"></i>\r\n                    <h5 class=\"list-group-item-heading\"><strong>{{report.title}}</strong></h5>\r\n                    <p class=\"list-group-item-text\">{{report.description}}</p>\r\n                </a>\r\n                <a ng-repeat-end=\"\" ng-if=\"!report.href\" href=\"#\" ng-click=\"ctrl.openReportFilterModal(report)\" class=\"list-group-item\">\r\n                    <i class=\"fa fa-fw fa-{{report.icon}} text-muted pull-right\"></i>\r\n                    <h5 class=\"list-group-item-heading\"><strong>{{report.title}}</strong></h5>\r\n                    <p class=\"list-group-item-text\">{{report.description}}</p>\r\n                </a>\r\n            </div>\r\n\r\n        </div>\r\n        <div class=\"col-md-4 col-sm-12\">\r\n            <h4>Work Item Reports</h4>\r\n\r\n            <div class=\"list-group\">\r\n                <a ng-repeat-start=\"report in ctrl.reports.workitem\" ng-if=\"report.href\" target=\"_blank\" ng-href=\"{{report.href}}\" class=\"list-group-item\">\r\n                    <i class=\"fa fa-fw fa-{{report.icon}} text-muted pull-right\"></i>\r\n                    <h5 class=\"list-group-item-heading\"><strong>{{report.title}}</strong></h5>\r\n                    <p class=\"list-group-item-text\">{{report.description}}</p>\r\n                </a>\r\n                <a ng-repeat-end=\"\" ng-if=\"!report.href\" href=\"#\" ng-click=\"ctrl.openReportFilterModal(report)\" class=\"list-group-item\">\r\n                    <i class=\"fa fa-fw fa-{{report.icon}} text-muted pull-right\"></i>\r\n                    <h5 class=\"list-group-item-heading\"><strong>{{report.title}}</strong></h5>\r\n                    <p class=\"list-group-item-text\">{{report.description}}</p>\r\n                </a>\r\n            </div>\r\n        </div>\r\n        <div class=\"col-md-4 col-sm-12\">\r\n            <h4>Custom Reports</h4>\r\n\r\n            <div class=\"list-group\">\r\n                <a ng-repeat-start=\"report in ctrl.reports.custom\" ng-if=\"report.href\" target=\"_blank\" ng-href=\"{{report.href}}\" class=\"list-group-item\">\r\n                    <i class=\"fa fa-fw fa-{{report.icon}} text-muted pull-right\"></i>\r\n                    <h5 class=\"list-group-item-heading\"><strong>{{report.title}}</strong></h5>\r\n                    <p class=\"list-group-item-text\">{{report.description}}</p>\r\n                </a>\r\n                <a ng-repeat-end=\"\" ng-if=\"!report.href\" href=\"#\" ng-click=\"ctrl.openReportFilterModal(report)\" class=\"list-group-item\">\r\n                    <i class=\"fa fa-fw fa-{{report.icon}} text-muted pull-right\"></i>\r\n                    <h5 class=\"list-group-item-heading\"><strong>{{report.title}}</strong></h5>\r\n                    <p class=\"list-group-item-text\">{{report.description}}</p>\r\n                </a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>"

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomListComponent = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _customList = __webpack_require__(692);
	
	var _customList2 = _interopRequireDefault(_customList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var _pluralize = __webpack_require__(693);
	
	var CustomListComponent = exports.CustomListComponent = function () {
	  CustomListComponent.$inject = ['Auth', 'CustomEntityService', 'dialogs', '$uibModal', '$stateParams', 'SettingsService', '$filter', 'DTOptionsBuilder', 'DTState'];
	  function CustomListComponent(Auth, CustomEntityService, dialogs, $uibModal, $stateParams, SettingsService, $filter, DTOptionsBuilder, DTState) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, CustomListComponent);
	
	    this.CustomEntityService = CustomEntityService;
	    this.isAdmin = Auth.isAdminSync;
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.$filter = $filter;
	
	    this.type = $stateParams.type;
	    this.dehyphendType = this.type.replace(/-/g, " ");
	
	    var aggregationColumnsSum = [];
	
	    var REGEX_ALL = /([^\W_]+[^\s-]*) */g;
	    var REGEX_FIRST = /([^\W_]+[^\s-]*)/;
	
	    var capitalize = function capitalize(input, all) {
	      if (!input) return '';
	      var regex = all ? REGEX_ALL : REGEX_FIRST;
	      return input.replace(regex, function (txt) {
	        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	      });
	    };
	
	    SettingsService.getByName({ name: 'custom-entities' }, function (settings) {
	      _this.fields = settings.data.entityList[_this.type];
	      _this.tabs = settings.data.entityListTabs[_this.type] ? settings.data.entityListTabs[_this.type].tabs : [];
	      _this.tabsDataAttribute = settings.data.entityListTabs[_this.type] ? settings.data.entityListTabs[_this.type].data : "";
	      _this.tabsHiddenAttributes = settings.data.entityListTabs[_this.type] ? settings.data.entityListTabs[_this.type].hidden : {};
	
	      _this.filter = settings.data.entityListTabs[_this.type] && settings.data.entityListTabs[_this.type].filter ? settings.data.entityListTabs[_this.type].filter : {};
	
	      _this.rowStyle = settings.data.entityListTabs[_this.type] && settings.data.entityListTabs[_this.type].rowStyle ? settings.data.entityListTabs[_this.type].rowStyle : {};
	
	      _this.CustomEntityService.getByType({ type: _this.type }, function (data) {
	        _this.rawData = data.map(function (entity) {
	
	          var colIndex = -1;
	          _this.fields.forEach(function (field) {
	
	            colIndex++;
	
	            if (field.aggregation) {
	              switch (field.aggregation) {
	                case 'sum':
	                default:
	                  aggregationColumnsSum.push(colIndex);
	              }
	            }
	
	            var oData = entity.data[field.data];
	
	            switch (field.type) {
	              case 'email':
	                entity.data[field.data] = '<a href=\'mailto:' + oData + '\'>' + oData + '</a>';
	                break;
	              case 'currency':
	                entity.data[field.data] = _this.$filter('currency')(entity.data[field.data]);
	                break;
	              case 'date':
	                var format = field.format || 'medium';
	                entity.data[field.data] = _this.$filter('date')(entity.data[field.data], format);
	                break;
	              case 'reference':
	
	                var oId = entity.data[field.refId];
	                if (oId) {
	                  switch (field.refType) {
	                    case 'community':
	                    case 'property':
	                    case 'contact':
	                    case 'vendor':
	                    case 'project':
	                      entity.data[field.data] = '<a href=\'/' + field.refType + '/' + oId + '\'>' + oData + '</a>';
	                      break;
	                    case 'user':
	                      entity.data[field.data] = '<a href=\'/profile/user/' + oId + '\'>' + oData + '</a>';
	                      break;
	                    case 'entity':
	                      entity.data[field.data] = '<a href=\'/custom/' + field.entityType + '/' + oId + '\'>' + oData + '</a>';
	                      break;
	                    default:
	                      entity.data[field.data] = '<a href=\'/custom/' + field.refType + '/' + oId + '\'>' + oData + '</a>';
	                      break;
	                  }
	                }
	
	                break;
	            }
	          });
	
	          return entity;
	        });
	        _this.data = _this.rawData;
	        _this.setFilter('all');
	        _this.dataInitComplete = true;
	      }, function (err) {
	        console.log("Could not retrieve e-forms.");
	      });
	    });
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'asc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: capitalize(this.pluralize(this.dehyphendType), true)
	    }, {
	      extend: 'csv',
	      title: capitalize(this.pluralize(this.dehyphendType), true)
	    }, {
	      title: capitalize(this.pluralize(this.dehyphendType), true),
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'portrait',
	      pageSize: 'LETTER'
	    }, {
	      extend: 'print',
	      title: capitalize(this.pluralize(this.dehyphendType), true)
	    }]).withOption('fnFooterCallback', function (row, data, start, end, display) {
	      var api = this.api(),
	          data;
	
	      var intVal = function intVal(i) {
	        console.log(typeof i === 'undefined' ? 'undefined' : _typeof(i), i);
	        return typeof i === 'string' ? i.replace(/[\$,]/g, '') * 1 : typeof i === 'number' ? i : 0;
	      };
	
	      var roundCorrectly = function roundCorrectly(number) {
	        return Math.round(number * 100) / 100;
	      };
	
	      aggregationColumnsSum.forEach(function (colNo) {
	        var total = api.column(colNo).data().reduce(function (a, b) {
	          return intVal(a) + intVal(b);
	        }, 0);
	
	        var pageTotal = api.column(colNo, { page: 'current' }).data().reduce(function (a, b) {
	          return intVal(a) + intVal(b);
	        }, 0);
	
	        var visibleTotal = api.column(colNo, { search: 'applied' }).data().reduce(function (a, b) {
	          return intVal(a) + intVal(b);
	        }, 0);
	
	        $(api.column(colNo).footer()).html('<nobr><span> $' + $filter('number')(roundCorrectly(visibleTotal), 2) + '</span></nobr>');
	      });
	    });
	  }
	
	  _createClass(CustomListComponent, [{
	    key: 'computeRowStyle',
	    value: function computeRowStyle(entity) {
	      var _this2 = this;
	
	      var style = {};
	
	      var conditionBuilder = function conditionBuilder(field, condition, value) {
	        if (!entity.data[field]) return false;
	
	        var dataValueNumeric = null;
	        if (["lt", "lte", "gt", "gte", "eq"].includes(condition)) {
	          dataValueNumeric = typeof entity.data[field] == 'string' ? parseFloat(entity.data[field].replace(/,/g, '').replace(/\$/g, '')) : entity.data[field];
	        }
	
	        var dataValueDate = null;
	        if (condition.startsWith("date:")) {
	          dataValueDate = moment(entity.data[field]);
	
	          if (!dataValueDate.isValid()) return false;
	        }
	
	        switch (condition) {
	          case 'str:eq':
	            return entity.data[field] == value;
	          case 'lt':
	            return dataValueNumeric < value;
	          case 'lte':
	            return dataValueNumeric <= value;
	          case 'gt':
	            return dataValueNumeric > value;
	          case 'gte':
	            return dataValueNumeric >= value;
	          case 'eq':
	            return dataValueNumeric == value;
	          case 'date:lt':
	            switch (value) {
	              case 'today':
	                return dataValueDate.isBefore(new Date(), 'day');
	              default:
	                return dataValueDate.isBefore(value, 'day');
	            }
	          case 'date:lte':
	            switch (value) {
	              case 'today':
	                return dataValueDate.isSameOrBefore(new Date(), 'day');
	              default:
	                return dataValueDate.isSameOrBefore(value, 'day');
	            }
	          case 'date:gt':
	            switch (value) {
	              case 'today':
	                return dataValueDate.isAfter(new Date(), 'day');
	              default:
	                return dataValueDate.isAfter(value, 'day');
	            }
	          case 'date:gte':
	            switch (value) {
	              case 'today':
	                return dataValueDate.isSameOrAfter(new Date(), 'day');
	              default:
	                return dataValueDate.isSameOrAfter(value, 'day');
	            }
	          case 'date:eq':
	            switch (value) {
	              case 'today':
	                return dataValueDate.isSame(new Date(), 'day');
	              default:
	                return dataValueDate.isSame(value, 'day');
	            }
	          default:
	            return false;
	        }
	      };
	
	      Object.keys(this.rowStyle).forEach(function (klass) {
	        var multipleConditions = Array.isArray(_this2.rowStyle[klass][0]);
	
	        style[klass] = multipleConditions ? _this2.rowStyle[klass].every(function (condition) {
	          return conditionBuilder.apply(undefined, _toConsumableArray(condition));
	        }) : conditionBuilder.apply(undefined, _toConsumableArray(_this2.rowStyle[klass]));
	      });
	
	      console.log(entity, style);
	
	      return style;
	    }
	  }, {
	    key: 'resetFilter',
	    value: function resetFilter() {
	      this.selectedFilter = null;
	      this.applyFilter();
	    }
	  }, {
	    key: 'applyFilter',
	    value: function applyFilter() {
	      var _this3 = this;
	
	      if (this.selectedFilter) this.data = this.rawData.filter(function (row) {
	        return row.data[_this3.filter.data] == _this3.selectedFilter;
	      });else this.data = this.rawData;
	
	      this.setFilter(this.visibleAttribute);
	    }
	  }, {
	    key: 'pluralize',
	    value: function pluralize(word) {
	      return _pluralize(word, 2);
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount(cat) {
	      var _this4 = this;
	
	      if (!cat || cat == 'all') {
	        return this.data.length;
	      } else {
	        return this.data.reduce(function (acc, obj) {
	          return acc + (obj.data[_this4.tabsDataAttribute] === cat);
	        }, 0);
	      }
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter(cat) {
	      var _this5 = this;
	
	      if (!cat || cat == 'all' || !this.tabsDataAttribute) {
	        this.filteredData = this.data;
	      } else {
	        this.filteredData = this.data.filter(function (entity) {
	          return entity.data[_this5.tabsDataAttribute] == cat;
	        });
	      }
	
	      this.visibleAttribute = cat;
	    }
	  }, {
	    key: 'copyToClipboard',
	    value: function copyToClipboard(eform) {
	      var path = "/e-form/" + eform._id;
	      window.prompt("Link to E-Form:", path);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(entity) {
	      var that = this;
	
	      var dlg = this.dialogs.confirm("Delete?", "Do you really want to this entity?");
	      dlg.result.then(function () {
	        that.CustomEntityService.delete({ id: entity._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== entity._id;
	          });
	        }, function (err) {
	          alert("Could not delete custom entity");
	        });
	      }, function () {});
	    }
	  }]);
	
	  return CustomListComponent;
	}();
	
	exports.default = angular.module('conduu.customList', [uiRouter]).config(_customList2.default).component('customList', {
	  template: __webpack_require__(694),
	  controller: CustomListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 692 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('custom-list', {
	    url: '/custom/:type/list',
	    template: '<custom-list></custom-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	/* global define */
	
	(function (root, pluralize) {
	  /* istanbul ignore else */
	  if (true) {
	    // Node.
	    module.exports = pluralize();
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD, registers as an anonymous module.
	    define(function () {
	      return pluralize();
	    });
	  } else {
	    // Browser global.
	    root.pluralize = pluralize();
	  }
	})(this, function () {
	  // Rule storage - pluralize and singularize need to be run sequentially,
	  // while other rules can be optimized using an object for instant lookups.
	  var pluralRules = [];
	  var singularRules = [];
	  var uncountables = {};
	  var irregularPlurals = {};
	  var irregularSingles = {};
	
	  /**
	   * Sanitize a pluralization rule to a usable regular expression.
	   *
	   * @param  {(RegExp|string)} rule
	   * @return {RegExp}
	   */
	  function sanitizeRule (rule) {
	    if (typeof rule === 'string') {
	      return new RegExp('^' + rule + '$', 'i');
	    }
	
	    return rule;
	  }
	
	  /**
	   * Pass in a word token to produce a function that can replicate the case on
	   * another word.
	   *
	   * @param  {string}   word
	   * @param  {string}   token
	   * @return {Function}
	   */
	  function restoreCase (word, token) {
	    // Tokens are an exact match.
	    if (word === token) return token;
	
	    // Lower cased words. E.g. "hello".
	    if (word === word.toLowerCase()) return token.toLowerCase();
	
	    // Upper cased words. E.g. "WHISKY".
	    if (word === word.toUpperCase()) return token.toUpperCase();
	
	    // Title cased words. E.g. "Title".
	    if (word[0] === word[0].toUpperCase()) {
	      return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
	    }
	
	    // Lower cased words. E.g. "test".
	    return token.toLowerCase();
	  }
	
	  /**
	   * Interpolate a regexp string.
	   *
	   * @param  {string} str
	   * @param  {Array}  args
	   * @return {string}
	   */
	  function interpolate (str, args) {
	    return str.replace(/\$(\d{1,2})/g, function (match, index) {
	      return args[index] || '';
	    });
	  }
	
	  /**
	   * Replace a word using a rule.
	   *
	   * @param  {string} word
	   * @param  {Array}  rule
	   * @return {string}
	   */
	  function replace (word, rule) {
	    return word.replace(rule[0], function (match, index) {
	      var result = interpolate(rule[1], arguments);
	
	      if (match === '') {
	        return restoreCase(word[index - 1], result);
	      }
	
	      return restoreCase(match, result);
	    });
	  }
	
	  /**
	   * Sanitize a word by passing in the word and sanitization rules.
	   *
	   * @param  {string}   token
	   * @param  {string}   word
	   * @param  {Array}    rules
	   * @return {string}
	   */
	  function sanitizeWord (token, word, rules) {
	    // Empty string or doesn't need fixing.
	    if (!token.length || uncountables.hasOwnProperty(token)) {
	      return word;
	    }
	
	    var len = rules.length;
	
	    // Iterate over the sanitization rules and use the first one to match.
	    while (len--) {
	      var rule = rules[len];
	
	      if (rule[0].test(word)) return replace(word, rule);
	    }
	
	    return word;
	  }
	
	  /**
	   * Replace a word with the updated word.
	   *
	   * @param  {Object}   replaceMap
	   * @param  {Object}   keepMap
	   * @param  {Array}    rules
	   * @return {Function}
	   */
	  function replaceWord (replaceMap, keepMap, rules) {
	    return function (word) {
	      // Get the correct token and case restoration functions.
	      var token = word.toLowerCase();
	
	      // Check against the keep object map.
	      if (keepMap.hasOwnProperty(token)) {
	        return restoreCase(word, token);
	      }
	
	      // Check against the replacement map for a direct word replacement.
	      if (replaceMap.hasOwnProperty(token)) {
	        return restoreCase(word, replaceMap[token]);
	      }
	
	      // Run all the rules against the word.
	      return sanitizeWord(token, word, rules);
	    };
	  }
	
	  /**
	   * Check if a word is part of the map.
	   */
	  function checkWord (replaceMap, keepMap, rules, bool) {
	    return function (word) {
	      var token = word.toLowerCase();
	
	      if (keepMap.hasOwnProperty(token)) return true;
	      if (replaceMap.hasOwnProperty(token)) return false;
	
	      return sanitizeWord(token, token, rules) === token;
	    };
	  }
	
	  /**
	   * Pluralize or singularize a word based on the passed in count.
	   *
	   * @param  {string}  word      The word to pluralize
	   * @param  {number}  count     How many of the word exist
	   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
	   * @return {string}
	   */
	  function pluralize (word, count, inclusive) {
	    var pluralized = count === 1
	      ? pluralize.singular(word) : pluralize.plural(word);
	
	    return (inclusive ? count + ' ' : '') + pluralized;
	  }
	
	  /**
	   * Pluralize a word.
	   *
	   * @type {Function}
	   */
	  pluralize.plural = replaceWord(
	    irregularSingles, irregularPlurals, pluralRules
	  );
	
	  /**
	   * Check if a word is plural.
	   *
	   * @type {Function}
	   */
	  pluralize.isPlural = checkWord(
	    irregularSingles, irregularPlurals, pluralRules
	  );
	
	  /**
	   * Singularize a word.
	   *
	   * @type {Function}
	   */
	  pluralize.singular = replaceWord(
	    irregularPlurals, irregularSingles, singularRules
	  );
	
	  /**
	   * Check if a word is singular.
	   *
	   * @type {Function}
	   */
	  pluralize.isSingular = checkWord(
	    irregularPlurals, irregularSingles, singularRules
	  );
	
	  /**
	   * Add a pluralization rule to the collection.
	   *
	   * @param {(string|RegExp)} rule
	   * @param {string}          replacement
	   */
	  pluralize.addPluralRule = function (rule, replacement) {
	    pluralRules.push([sanitizeRule(rule), replacement]);
	  };
	
	  /**
	   * Add a singularization rule to the collection.
	   *
	   * @param {(string|RegExp)} rule
	   * @param {string}          replacement
	   */
	  pluralize.addSingularRule = function (rule, replacement) {
	    singularRules.push([sanitizeRule(rule), replacement]);
	  };
	
	  /**
	   * Add an uncountable word rule.
	   *
	   * @param {(string|RegExp)} word
	   */
	  pluralize.addUncountableRule = function (word) {
	    if (typeof word === 'string') {
	      uncountables[word.toLowerCase()] = true;
	      return;
	    }
	
	    // Set singular and plural references for the word.
	    pluralize.addPluralRule(word, '$0');
	    pluralize.addSingularRule(word, '$0');
	  };
	
	  /**
	   * Add an irregular word definition.
	   *
	   * @param {string} single
	   * @param {string} plural
	   */
	  pluralize.addIrregularRule = function (single, plural) {
	    plural = plural.toLowerCase();
	    single = single.toLowerCase();
	
	    irregularSingles[single] = plural;
	    irregularPlurals[plural] = single;
	  };
	
	  /**
	   * Irregular rules.
	   */
	  [
	    // Pronouns.
	    ['I', 'we'],
	    ['me', 'us'],
	    ['he', 'they'],
	    ['she', 'they'],
	    ['them', 'them'],
	    ['myself', 'ourselves'],
	    ['yourself', 'yourselves'],
	    ['itself', 'themselves'],
	    ['herself', 'themselves'],
	    ['himself', 'themselves'],
	    ['themself', 'themselves'],
	    ['is', 'are'],
	    ['was', 'were'],
	    ['has', 'have'],
	    ['this', 'these'],
	    ['that', 'those'],
	    // Words ending in with a consonant and `o`.
	    ['echo', 'echoes'],
	    ['dingo', 'dingoes'],
	    ['volcano', 'volcanoes'],
	    ['tornado', 'tornadoes'],
	    ['torpedo', 'torpedoes'],
	    // Ends with `us`.
	    ['genus', 'genera'],
	    ['viscus', 'viscera'],
	    // Ends with `ma`.
	    ['stigma', 'stigmata'],
	    ['stoma', 'stomata'],
	    ['dogma', 'dogmata'],
	    ['lemma', 'lemmata'],
	    ['schema', 'schemata'],
	    ['anathema', 'anathemata'],
	    // Other irregular rules.
	    ['ox', 'oxen'],
	    ['axe', 'axes'],
	    ['die', 'dice'],
	    ['yes', 'yeses'],
	    ['foot', 'feet'],
	    ['eave', 'eaves'],
	    ['goose', 'geese'],
	    ['tooth', 'teeth'],
	    ['quiz', 'quizzes'],
	    ['human', 'humans'],
	    ['proof', 'proofs'],
	    ['carve', 'carves'],
	    ['valve', 'valves'],
	    ['looey', 'looies'],
	    ['thief', 'thieves'],
	    ['groove', 'grooves'],
	    ['pickaxe', 'pickaxes'],
	    ['passerby', 'passersby']
	  ].forEach(function (rule) {
	    return pluralize.addIrregularRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Pluralization rules.
	   */
	  [
	    [/s?$/i, 's'],
	    [/[^\u0000-\u007F]$/i, '$0'],
	    [/([^aeiou]ese)$/i, '$1'],
	    [/(ax|test)is$/i, '$1es'],
	    [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, '$1es'],
	    [/(e[mn]u)s?$/i, '$1s'],
	    [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, '$1'],
	    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
	    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
	    [/(seraph|cherub)(?:im)?$/i, '$1im'],
	    [/(her|at|gr)o$/i, '$1oes'],
	    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
	    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
	    [/sis$/i, 'ses'],
	    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
	    [/([^aeiouy]|qu)y$/i, '$1ies'],
	    [/([^ch][ieo][ln])ey$/i, '$1ies'],
	    [/(x|ch|ss|sh|zz)$/i, '$1es'],
	    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
	    [/\b((?:tit)?m|l)(?:ice|ouse)$/i, '$1ice'],
	    [/(pe)(?:rson|ople)$/i, '$1ople'],
	    [/(child)(?:ren)?$/i, '$1ren'],
	    [/eaux$/i, '$0'],
	    [/m[ae]n$/i, 'men'],
	    ['thou', 'you']
	  ].forEach(function (rule) {
	    return pluralize.addPluralRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Singularization rules.
	   */
	  [
	    [/s$/i, ''],
	    [/(ss)$/i, '$1'],
	    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
	    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
	    [/ies$/i, 'y'],
	    [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'],
	    [/\b(mon|smil)ies$/i, '$1ey'],
	    [/\b((?:tit)?m|l)ice$/i, '$1ouse'],
	    [/(seraph|cherub)im$/i, '$1'],
	    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, '$1'],
	    [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, '$1sis'],
	    [/(movie|twelve|abuse|e[mn]u)s$/i, '$1'],
	    [/(test)(?:is|es)$/i, '$1is'],
	    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
	    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
	    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
	    [/(alumn|alg|vertebr)ae$/i, '$1a'],
	    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
	    [/(matr|append)ices$/i, '$1ix'],
	    [/(pe)(rson|ople)$/i, '$1rson'],
	    [/(child)ren$/i, '$1'],
	    [/(eau)x?$/i, '$1'],
	    [/men$/i, 'man']
	  ].forEach(function (rule) {
	    return pluralize.addSingularRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Uncountable rules.
	   */
	  [
	    // Singular words with no plurals.
	    'adulthood',
	    'advice',
	    'agenda',
	    'aid',
	    'aircraft',
	    'alcohol',
	    'ammo',
	    'analytics',
	    'anime',
	    'athletics',
	    'audio',
	    'bison',
	    'blood',
	    'bream',
	    'buffalo',
	    'butter',
	    'carp',
	    'cash',
	    'chassis',
	    'chess',
	    'clothing',
	    'cod',
	    'commerce',
	    'cooperation',
	    'corps',
	    'debris',
	    'diabetes',
	    'digestion',
	    'elk',
	    'energy',
	    'equipment',
	    'excretion',
	    'expertise',
	    'firmware',
	    'flounder',
	    'fun',
	    'gallows',
	    'garbage',
	    'graffiti',
	    'hardware',
	    'headquarters',
	    'health',
	    'herpes',
	    'highjinks',
	    'homework',
	    'housework',
	    'information',
	    'jeans',
	    'justice',
	    'kudos',
	    'labour',
	    'literature',
	    'machinery',
	    'mackerel',
	    'mail',
	    'media',
	    'mews',
	    'moose',
	    'music',
	    'mud',
	    'manga',
	    'news',
	    'only',
	    'personnel',
	    'pike',
	    'plankton',
	    'pliers',
	    'police',
	    'pollution',
	    'premises',
	    'rain',
	    'research',
	    'rice',
	    'salmon',
	    'scissors',
	    'series',
	    'sewage',
	    'shambles',
	    'shrimp',
	    'software',
	    'species',
	    'staff',
	    'swine',
	    'tennis',
	    'traffic',
	    'transportation',
	    'trout',
	    'tuna',
	    'wealth',
	    'welfare',
	    'whiting',
	    'wildebeest',
	    'wildlife',
	    'you',
	    /pok[eé]mon$/i,
	    // Regexes.
	    /[^aeiou]ese$/i, // "chinese", "japanese"
	    /deer$/i, // "deer", "reindeer"
	    /fish$/i, // "fish", "blowfish", "angelfish"
	    /measles$/i,
	    /o[iu]s$/i, // "carnivorous"
	    /pox$/i, // "chickpox", "smallpox"
	    /sheep$/i
	  ].forEach(pluralize.addUncountableRule);
	
	  return pluralize;
	});


/***/ }),
/* 694 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <!-- permission permission-only=\"'community.create'\" -->\n      <a style=\"float:right; margin-top:4px\" class=\"btn btn-primary text-capitalize\" ng-href=\"/custom/{{ctrl.type}}/edit/\"><i class=\"fa fa-plus\"></i> Add {{ctrl.dehyphendType}}</a>\n      <h2 class=\"text-capitalize\">{{ctrl.pluralize(ctrl.dehyphendType)}}</h2>\n      <div class=\"form-inline pull-right\" style=\"position:relative; top: -6px\" ng-if=\"ctrl.filter.enum && !ctrl.tabs.length\">\n        <label for=\"code-selector\">Filter:&nbsp;\n          <select id=\"code-selector\" ng-options=\"o as o for o in ctrl.filter.enum\" ng-model=\"ctrl.selectedFilter\" ng-change=\"ctrl.applyFilter()\"></select>\n        </label>\n        <a href=\"#\" ng-if=\"ctrl.selectedFilter\" ng-click=\"ctrl.resetFilter()\"><i class=\"fa fa-fw fa-times\"></i></a>\n      </div>\n      <li class=\"active\"><a class=\"text-capitalize\" href=\"#\">{{ctrl.pluralize(ctrl.dehyphendType)}}</a></li>\n    </ol>\n\n    <div class=\"col-xs-12\">\n\n      <div class=\"form-inline pull-right\" style=\"padding-top: 6px\" ng-if=\"ctrl.filter.enum && ctrl.tabs.length\">\n        <label for=\"code-selector\">Filter:&nbsp;\n          <select id=\"code-selector\" ng-options=\"o as o for o in ctrl.filter.enum\" ng-model=\"ctrl.selectedFilter\" ng-change=\"ctrl.applyFilter()\"></select>\n        </label>\n        <a href=\"#\" ng-if=\"ctrl.selectedFilter\" ng-click=\"ctrl.resetFilter()\"><i class=\"fa fa-fw fa-times\"></i></a>\n      </div>\n\n      <div ng-if=\"ctrl.tabs.length && ctrl.dataInitComplete\">\n        <uib-tabset active=\"ctrl.activeTabIndex\">\n          <uib-tab select=\"ctrl.setFilter('all')\">\n            <uib-tab-heading><b class=\"text-capitalize\">all</b> <span class=\"badge\">{{ctrl.getCount('all')}}</span></uib-tab-heading>\n          </uib-tab>\n          <uib-tab ng-repeat=\"tab in ctrl.tabs\" select=\"ctrl.setFilter(tab)\">\n            <uib-tab-heading><b class=\"text-capitalize\">{{tab}}</b> <span class=\"badge\">{{ctrl.getCount(tab)}}</span></uib-tab-heading>\n          </uib-tab>\n        </uib-tabset>\n\n        <br/>\n      </div>\n\n      <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\" style=\"width:100%\">\n        <thead>\n        <tr>\n          <th ng-show=\"!ctrl.tabsHiddenAttributes[ctrl.visibleAttribute] || (ctrl.tabsHiddenAttributes[ctrl.visibleAttribute] && !ctrl.tabsHiddenAttributes[ctrl.visibleAttribute][field.name])\"\n              ng-repeat=\"field in ctrl.fields\">{{field.name}}</th>\n          <th></th>\n          <th></th>\n        </tr>\n        </thead>\n        <tbody>\n        <!-- ng-if=\"!ctrl.tabsDataAttribute || (ctrl.tabsDataAttribute && entity.data[ctrl.tabsDataAttribute] == ctrl.visibleAttribute)\" -->\n        <tr ng-repeat=\"entity in ctrl.filteredData | orderBy: 'meta.creationDate':true\" ng-class=\"ctrl.computeRowStyle(entity)\">\n\n          <td ng-show=\"!ctrl.tabsHiddenAttributes[ctrl.visibleAttribute] || (ctrl.tabsHiddenAttributes[ctrl.visibleAttribute] && !ctrl.tabsHiddenAttributes[ctrl.visibleAttribute][field.name])\"\n              ng-repeat=\"field in ctrl.fields\">\n\n            <span ng-if=\"!field.template\" ng-bind-html=\"entity.data[field.data]\"></span>\n            <span ng-if=\"field.template\" bind-dynamic-page=\"field.template\"></span>\n          </td>\n\n          <td><a class=\"btn btn-sm btn-primary\" ng-href=\"/custom/{{ctrl.type}}/{{entity._id}}\"><i class=\"fa fa-folder-open fa-fw\"></i></a></td>\n          <td>\n            <nobr>\n              <a ng-href=\"/custom/{{entity.schemaSettings}}/edit/{{entity._id}}\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-fw fa-pencil\"></i></a>\n              <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(entity)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\n            </nobr>\n          </td>\n        </tr>\n        </tbody>\n        <tfoot>\n        <tr>\n          <th ng-show=\"!ctrl.tabsHiddenAttributes[ctrl.visibleAttribute] || (ctrl.tabsHiddenAttributes[ctrl.visibleAttribute] && !ctrl.tabsHiddenAttributes[ctrl.visibleAttribute][field.name])\"\n              ng-repeat=\"field in ctrl.fields\">\n          </th>\n          <th></th>\n          <th></th>\n        </tr>\n        </tfoot>\n      </table>\n\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _customEdit = __webpack_require__(696);
	
	var _customEdit2 = _interopRequireDefault(_customEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var _pluralize = __webpack_require__(693);
	
	var CustomEditComponent = exports.CustomEditComponent = function () {
	  CustomEditComponent.$inject = ['Auth', '$state', 'dialogs', '$filter', '$stateParams', '$uibModal', 'CustomEntityService', '$scope', '$location', 'SettingsService', 'PropertyService', 'ContactService', 'CommunityService', 'User', '$timeout', 'VendorService'];
	  function CustomEditComponent(Auth, $state, dialogs, $filter, $stateParams, $uibModal, CustomEntityService, $scope, $location, SettingsService, PropertyService, ContactService, CommunityService, User, $timeout, VendorService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, CustomEditComponent);
	
	    this.CustomEntityService = CustomEntityService;
	    this.PropertyService = PropertyService;
	    this.ContactService = ContactService;
	    this.VendorService = VendorService;
	    this.dialogs = dialogs;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.entityId = $stateParams.id;
	    this.model = {};
	    this.$filter = $filter;
	    this.$location = $location;
	    this.$timeout = $timeout;
	    this.$uibModal = $uibModal;
	
	    this.type = $stateParams.type;
	    this.dehyphendType = this.type.replace(/-/g, " ");
	
	    var getCustomEntityName = function getCustomEntityName(entity, nameParts) {
	      var arrayNameParts = Array.isArray(nameParts) ? nameParts : [nameParts];
	
	      var name = [];
	
	      arrayNameParts.forEach(function (np) {
	        if (np.startsWith("$")) {
	          var dataKey = np.substring(1).trim();
	          name.push(entity.data[dataKey]);
	        } else {
	          name.push(np);
	        }
	      });
	
	      return name.join('');
	    };
	
	    SettingsService.getByName({ name: 'custom-entities' }, function (settings) {
	      _this.schema = settings.data.entitySchema[_this.type];
	      _this.listConfig = settings.data.entityList[_this.type];
	
	      _this.count = 0;
	      _this.maxCount = 6;
	
	      var fnReady = function fnReady(_) {
	        var keys = Object.keys(_this.schema.properties);
	        keys.forEach(function (key) {
	          if (_this.schema.properties[key].hasOwnProperty("x-schema-form")) {
	            var ref = _this.schema.properties[key]["x-schema-form"];
	            if (ref.type === 'entitylookup') {
	
	              switch (ref.lookuptype) {
	                case 'property':
	                  _this.schema.properties[key]["entityLookupData"] = _this.propertyData;
	                  _this.schema.properties[key]["fnLookup"] = function (key) {
	                    _this.propertyLookup(key);
	                  };
	                  break;
	                case 'user':
	                  _this.schema.properties[key]["entityLookupData"] = _this.userData;
	                  _this.schema.properties[key]["fnLookup"] = function (key) {
	                    _this.userLookup(key);
	                  };
	                  break;
	                case 'contact':
	                  _this.schema.properties[key]["entityLookupData"] = _this.contactData;
	                  _this.schema.properties[key]["fnLookup"] = function (key) {
	                    _this.contactLookup(key);
	                  };
	                  break;
	                case 'community':
	                  _this.schema.properties[key]["entityLookupData"] = _this.communityData;
	                  _this.schema.properties[key]["fnLookup"] = function (key) {
	                    _this.communityLookup(key);
	                  };
	                  break;
	                case 'vendor':
	                  _this.schema.properties[key]["entityLookupData"] = _this.vendorData;
	                  _this.schema.properties[key]["fnLookup"] = function (key) {
	                    _this.vendorLookup(key);
	                  };
	                  break;
	                case 'entity':
	                  _this.schema.properties[key]["entityLookupData"] = _this.customEntityData.filter(function (entity) {
	                    return entity.group == ref.config.entityType;
	                  });
	                  _this.schema.properties[key]["fnLookup"] = function (key) {
	                    _this.customEntityLookup(key, ref.config);
	                  };
	                  break;
	              }
	            }
	          }
	        });
	
	        if (_this.entityId) {
	          _this.CustomEntityService.get({ id: _this.entityId }, function (entity) {
	            _this.form = ["*"];
	            _this.entity = entity;
	            _this.model = _this.entity.data;
	
	            Object.keys(_this.schema.properties).forEach(function (key) {
	              if (_this.schema.properties[key].type == 'string' && _this.schema.properties[key].format == 'date') {
	                if (_this.model[key]) {
	                  _this.model[key] = new Date(_this.model[key]);
	                }
	              }
	            });
	
	            _this.$scope.$broadcast('schemaFormRedraw');
	          }, function (_) {
	            console.log("Could not load e-form schema from server");
	            _this.formNotFound = true;
	          });
	        }
	      };
	
	      PropertyService.query(function (data) {
	        _this.propertyData = data.filter(function (entity) {
	          return !!entity.address;
	        }).map(function (entity) {
	          return {
	            value: entity._id,
	            name: entity.address.street + ", " + entity.address.city + ", " + entity.address.state + ", " + entity.address.zip,
	            group: entity.community.name
	          };
	        });
	
	        _this.count++;
	        if (_this.count == _this.maxCount) fnReady();
	      });
	
	      ContactService.query(function (data) {
	        _this.contactData = data.map(function (entity) {
	          return {
	            value: entity._id,
	            name: _this.getComposedName(entity),
	            group: "General"
	          };
	        });
	
	        _this.count++;
	        if (_this.count == _this.maxCount) fnReady();
	      });
	
	      CommunityService.query(function (data) {
	        _this.communityData = data.map(function (entity) {
	          return {
	            value: entity._id,
	            name: entity.code + ": " + entity.name,
	            group: "General"
	          };
	        });
	
	        _this.count++;
	        if (_this.count == _this.maxCount) fnReady();
	      });
	
	      VendorService.query(function (data) {
	        _this.vendorData = data.map(function (entity) {
	          return {
	            value: entity._id,
	            name: entity.name,
	            group: entity.businessType
	          };
	        });
	
	        _this.count++;
	        if (_this.count == _this.maxCount) fnReady();
	      });
	
	      CustomEntityService.query(function (data) {
	        _this.customEntityData = data.map(function (entity) {
	
	          var field = _this.listConfig.find(function (f) {
	            return f.entityType && f.entityType == entity.schemaSettings;
	          });
	          var name = getCustomEntityName(entity, field && field.nameBuilder ? field.nameBuilder : 'Entity');
	
	          return {
	            value: entity._id,
	            name: name,
	            group: entity.schemaSettings
	          };
	        });
	
	        _this.count++;
	        if (_this.count == _this.maxCount) fnReady();
	      });
	
	      User.query(function (users) {
	        _this.userData = users.map(function (user) {
	          return {
	            value: user._id,
	            name: user.shortName,
	            group: 'General'
	          };
	        });
	
	        _this.count++;
	        if (_this.count == _this.maxCount) fnReady();
	      });
	    });
	
	    this.entity = {
	      schemaSettings: this.type,
	      data: {}
	    };
	
	    this.isLoggedIn = Auth.isLoggedInSync();
	    this.user = Auth.getCurrentUserSync();
	  }
	
	  _createClass(CustomEditComponent, [{
	    key: 'contactLookup',
	    value: function contactLookup(key) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'contactLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (contact) {
	        that.model[key] = contact._id;
	      }, function () {});
	    }
	  }, {
	    key: 'userLookup',
	    value: function userLookup(key) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'userLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (user) {
	        that.model[key] = user._id;
	      }, function () {});
	    }
	  }, {
	    key: 'propertyLookup',
	    value: function propertyLookup(key) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'propertyLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (property) {
	        that.model[key] = property._id;
	      }, function () {});
	    }
	  }, {
	    key: 'communityLookup',
	    value: function communityLookup(key) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'communityLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (community) {
	        that.model[key] = community._id;
	      }, function () {});
	    }
	  }, {
	    key: 'vendorLookup',
	    value: function vendorLookup(key) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'vendorLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (vendor) {
	        that.model[key] = vendor._id;
	      }, function () {});
	    }
	  }, {
	    key: 'customEntityLookup',
	    value: function customEntityLookup(key, _config) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'customEntityLookup',
	        resolve: {
	          config: function config() {
	            return _config;
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (entity) {
	        that.model[key] = entity._id;
	      }, function () {});
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += " (" + contact.company + ")";
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'pluralize',
	    value: function pluralize(word) {
	      return _pluralize(word, 2);
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      this.$scope.$broadcast('schemaFormValidate');
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this2.entityId ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "The entity has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$location.url("/custom/" + _this2.type + "/list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.entity.data = this.model;
	
	        if (!this.entityId) {
	          this.CustomEntityService.save(this.entity, onSuccess, onError);
	        } else {
	          this.CustomEntityService.update({ id: this.entityId }, this.entity, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return CustomEditComponent;
	}();
	
	exports.default = angular.module('conduu.customEdit', [uiRouter]).config(_customEdit2.default).component('customEdit', {
	  template: __webpack_require__(697),
	  controller: CustomEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('custom-edit', {
	    url: '/custom/:type/edit/:id',
	    template: '<custom-edit></custom-edit>'
	  });
	}];

/***/ }),
/* 697 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2 class=\"text-capitalize\">{{ctrl.dehyphendType}} Editor</h2>\r\n      <li><a class=\"text-capitalize\" ng-href=\"/custom/{{ctrl.type}}/list\">{{ctrl.pluralize(ctrl.dehyphendType)}}</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form ng-if=\"ctrl.schema\" name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n        <div sf-schema=\"ctrl.schema\" sf-form=\"ctrl.form\" sf-model=\"ctrl.model\"\r\n             sf-options=\"{ formDefaults: { feedback: false }}\"></div>\r\n\r\n        <br/>\r\n\r\n        <button ng-hide=\"ctrl.entityId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-send-o\"></i> Create</button>\r\n\r\n        <button ng-show=\"ctrl.entityId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <a class=\"btn btn-warning\" ng-href=\"/custom/{{ctrl.type}}/list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</a>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomShowComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _customShow = __webpack_require__(699);
	
	var _customShow2 = _interopRequireDefault(_customShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var _pluralize = __webpack_require__(693);
	
	var CustomShowComponent = exports.CustomShowComponent = function () {
	  CustomShowComponent.$inject = ['$stateParams', 'VendorService', '$uibModal', '$window', 'RecentVisits', 'PinnedItems', 'CustomEntityService', 'SettingsService', 'PropertyService', '$timeout'];
	  function CustomShowComponent($stateParams, VendorService, $uibModal, $window, RecentVisits, PinnedItems, CustomEntityService, SettingsService, PropertyService, $timeout) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, CustomShowComponent);
	
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.entityId = $stateParams.id;
	    this.type = $stateParams.type;
	    this.dehyphendType = this.type.replace(/-/g, " ");
	    this.$uibModal = $uibModal;
	
	    this.tasks = [];
	    this.activities = [];
	    this.custom = {};
	
	    this.CustomEntityService = CustomEntityService;
	    this.SettingsService = SettingsService;
	    this.RecentVisits = RecentVisits;
	    this.PinnedItems = PinnedItems;
	
	    this.PropertyService = PropertyService;
	    this.$timeout = $timeout;
	
	    this.SettingsService.getByName({ name: 'custom-entities' }, function (settings) {
	      _this.view = settings.data.entityView[_this.type];
	    });
	
	    this.SettingsService.getByName({ name: 'custom-entities-views' }, function (settings) {
	      _this.customEntitiesConfig = settings.data["entity:" + _this.type] || { display: [] };
	      _this.customEntitiesConfig.display.forEach(function (customType) {
	        var typeConfig = _this.customEntitiesConfig[customType];
	        _this.custom[customType] = CustomEntityService.getCustomList({ type: customType, refField: typeConfig.refField, refId: $stateParams.id });
	      });
	    });
	
	    var REGEX_ALL = /([^\W_]+[^\s-]*) */g;
	    var REGEX_FIRST = /([^\W_]+[^\s-]*)/;
	
	    this.capitalize = function (input, all) {
	      if (!input) return '';
	      var regex = all ? REGEX_ALL : REGEX_FIRST;
	      return input.replace(regex, function (txt) {
	        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	      });
	    };
	
	    this.refreshData();
	  }
	
	  _createClass(CustomShowComponent, [{
	    key: 'openCustomEntityLetterWithContactSelect',
	    value: function openCustomEntityLetterWithContactSelect(entityId, entityName, propertyId, template, attach) {
	      var _this2 = this;
	
	      var that = this;
	
	      var MAP_GROUP = { 'primary-owner': "Primary Owner", 'owner': "Owner", 'renter': 'Renter', 'previous-owner': "Previous Owner", "vistor": "Visitor" };
	
	      this.PropertyService.getContacts({ id: propertyId }, function (contacts) {
	
	        var pickContactPreselects = [];
	
	        contacts.forEach(function (oContact) {
	
	          var group = MAP_GROUP[oContact.type];
	          var name = oContact.contact.firstName + " " + oContact.contact.lastName;
	          var phone = "";
	          var email = "";
	
	          if (oContact.phone && oContact.phone.length) {
	            var primaryPhone = oContact.phone.find(function (p) {
	              return p.isPrimary;
	            });
	            if (primaryPhone) {
	              phone = primaryPhone.number;
	            }
	          }
	
	          if (oContact.email && oContact.email.length) {
	            var primaryEmail = oContact.email.find(function (e) {
	              return e.isPrimary;
	            });
	            if (primaryEmail) {
	              email = primaryEmail.address;
	            }
	          }
	
	          oContact.contact.address.forEach(function (addr) {
	
	            var composedName = name + ", " + addr.street + " (" + addr.type + ")";
	            if (addr.isPrimary) composedName += " (PRIMARY)";
	
	            pickContactPreselects.push({
	              name: composedName,
	              group: group,
	              payload: {
	                name: name,
	                address: addr.street,
	                address2: addr.street2,
	                phone: phone,
	                email: email
	              }
	            });
	          });
	        });
	
	        var modalInstance = _this2.$uibModal.open({
	          animation: true,
	          component: 'reportFilterModal',
	          resolve: {
	            config: function config() {
	              return {
	                filter: [{ type: "pick-contact-preselect" }],
	                pickContactPreselects: pickContactPreselects,
	                title: "Create and Download Letter",
	                report: 'custom-entity-letter',
	                entityId: entityId,
	                entityName: entityName,
	                template: template,
	                fileTypes: ['docx', 'odt', 'pdf'],
	                attach: attach
	              };
	            }
	          },
	          size: 'md'
	        });
	
	        modalInstance.result.then(function () {
	          if (attach) {
	            that.refreshAttachments();
	          }
	        }, function () {
	          if (attach) {
	            that.refreshAttachments();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'openCustomEntityLetterReportModal',
	    value: function openCustomEntityLetterReportModal(templateId, attach) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'reportFilterModal',
	        resolve: {
	          config: function config() {
	            return {
	              title: "Create and Download Letter",
	              report: 'custom-entity-letter',
	              entityId: that.entityId,
	              template: templateId,
	              fileTypes: ['docx', 'odt', 'pdf'],
	              attach: attach
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function () {
	        if (attach) {
	          that.refreshAttachments();
	        }
	      }, function () {
	        if (attach) {
	          that.refreshAttachments();
	        }
	      });
	    }
	  }, {
	    key: 'refreshAttachments',
	    value: function refreshAttachments() {
	      var _this3 = this;
	
	      var count = this.entity.attachments.length;
	
	      this.$timeout(function (_) {
	        _this3.refreshData(function (_) {
	          if (_this3.entity.attachments.length === count) {
	            _this3.$timeout(function (_) {
	              _this3.refreshData(function (_) {
	                if (_this3.entity.attachments.length === count) {
	                  _this3.$timeout(function (_) {
	                    _this3.refreshData(function (_) {
	                      if (_this3.entity.attachments.length === count) {
	                        _this3.$timeout(function (_) {
	                          _this3.refreshData();
	                        }, 10000);
	                      }
	                    });
	                  }, 5000);
	                }
	              });
	            }, 2500);
	          }
	        });
	      }, 2500);
	    }
	  }, {
	    key: 'getSectionClass',
	    value: function getSectionClass(section) {
	      if (!this.view.sectionStyle || !this.view.sectionStyle[section] || !this.view.sectionStyle[section].class) return "col-xs-12";
	
	      return this.view.sectionStyle[section].class;
	    }
	  }, {
	    key: 'getSectionTemplate',
	    value: function getSectionTemplate(section) {
	      if (!this.view.sectionTemplate || !this.view.sectionTemplate[section]) return null;
	
	      return this.view.sectionTemplate[section];
	    }
	  }, {
	    key: 'pluralize',
	    value: function pluralize(word) {
	      return _pluralize(word, 2);
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData() {
	      var _this4 = this;
	
	      if (this.entityId) {
	        this.CustomEntityService.get({ id: this.entityId }, function (data) {
	          _this4.entity = data;
	
	          _this4.RecentVisits.addCustomPortfolio(_this4.entityId, "custom", _this4.type, _this4.entity.data[_this4.view.titleData] + " (" + _this4.capitalize(_this4.dehyphendType) + ")");
	          _this4.isPinned = _this4.PinnedItems.isPinnedPortfolio(_this4.entityId);
	        }, function (err) {
	          console.log('Could not load custom entity from server');
	        });
	      }
	    }
	  }, {
	    key: 'getSelectedOrFirstAttachmentImage',
	    value: function getSelectedOrFirstAttachmentImage(selected) {
	
	      if (selected) {
	        return "/api/storage/" + selected;
	      }
	
	      var images = this.entity.attachments.filter(function (att) {
	        return att.contentType.startsWith("image");
	      });
	
	      if (images.length) {
	        return "/api/storage/" + images[0]._id;
	      }
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (resultIds) {
	        that.CustomEntityService.addAttachments({ id: that.entityId }, resultIds, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not add attachments to entity');
	        });
	      }, function () {});
	    }
	  }]);
	
	  return CustomShowComponent;
	}();
	
	exports.default = angular.module('conduu.customShow', [uiRouter]).config(_customShow2.default).component('customShow', {
	  template: __webpack_require__(700),
	  controller: CustomShowComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('custom-show', {
	    url: '/custom/:type/:id',
	    template: '<custom-show></custom-show>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>{{ctrl.entity.data[ctrl.view.titleData]}}</h2>\r\n      <li><a class=\"text-capitalize\" href=\"/custom/{{ctrl.type}}/list\">{{ctrl.pluralize(ctrl.dehyphendType)}}</a></li>\r\n      <li class=\"active\"><a href=\"#\">{{ctrl.entity.data[ctrl.view.titleData]}}</a></li>\r\n    </ol>\r\n\r\n    <div class=\"{{ctrl.getSectionClass(section)}}\" ng-repeat=\"section in ctrl.view.display\" ng-switch=\"section\">\r\n\r\n      <div ng-switch-when=\"stamp\">\r\n        <div ng-if=\"ctrl.getSectionTemplate(section)\" bind-dynamic-page=\"ctrl.getSectionTemplate(section)\"></div>\r\n      </div>\r\n\r\n      <div ng-switch-when=\"relations\" ng-repeat=\"customType in ctrl.customEntitiesConfig.display\">\r\n        <h3 ng-if=\"ctrl.custom[customType].length\" class=\"separator\"><span>{{ctrl.customEntitiesConfig[customType].title}}</span></h3>\r\n\r\n        <dl ng-if=\"ctrl.custom[customType].length\" class=\"dl-horizontal\">\r\n          <dt ng-repeat-start=\"entity in ctrl.custom[customType] | orderBy: 'meta.creationDate':false\" bind-dynamic-page=\"ctrl.customEntitiesConfig[customType].dtTemplate\"></dt>\r\n          <dd ng-repeat-end=\"\" bind-dynamic-page=\"ctrl.customEntitiesConfig[customType].ddTemplate\"></dd>\r\n        </dl>\r\n      </div>\r\n\r\n      <div ng-switch-when=\"nta\">\r\n        <nta-section context=\"entity\" context-id=\"ctrl.entityId\" data=\"ctrl.entity\" service=\"ctrl.CustomEntityService\" on-refresh=\"ctrl.refreshData()\"></nta-section>\r\n      </div>\r\n\r\n      <div ng-switch-when=\"attachments\">\r\n        <h3 class=\"separator\"><span>Attachments <small><a href=\"#\" ng-click=\"ctrl.openAssetUploadModal()\"><i class=\"fa fa-upload\"></i> Upload Files</a></small></span></h3>\r\n\r\n        <attachment-list attachments=\"ctrl.entity.attachments\" context-id=\"ctrl.entityId\" service=\"ctrl.CustomEntityService\"></attachment-list>\r\n      </div>\r\n\r\n      <div ng-switch-default=\"\">\r\n        <h3 style=\"margin-top: 0\" class=\"separator\"><span class=\"text-capitalize\">{{section}}</span></h3>\r\n        <dl class=\"dl-horizontal\" ng-if=\"!ctrl.getSectionTemplate(section)\">\r\n          <dt ng-repeat-start=\"field in ctrl.view[section]\">{{field.label}}</dt>\r\n          <dd ng-show=\"field.template\" bind-dynamic-page=\"field.template\"></dd>\r\n          <dd ng-hide=\"field.template\" ng-repeat-end=\"\">{{ctrl.entity.data[field.data]}}</dd>\r\n        </dl>\r\n        <div ng-if=\"ctrl.getSectionTemplate(section)\" bind-dynamic-page=\"ctrl.getSectionTemplate(section)\"></div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <br/>\r\n\r\n      <div style=\"float:right\" >\r\n        <label>{{ctrl.isPinned ? 'Pinned' : \"Not Pinned\"}}&nbsp;</label>\r\n        <toggle ng-model=\"ctrl.isPinned\" ng-change=\"ctrl.PinnedItems.toggleCustomPortfolio(ctrl.entityId, 'custom', ctrl.type, ctrl.entity.data[ctrl.view.titleData] + ' (' + ctrl.capitalize(ctrl.dehyphendType) +  ')')\"\r\n                on=\"<i class='fa fa-fw fa-map-pin'>\" off=\"<i class='fa fa-fw fa-times'>\" onstyle=\"btn-success\" offstyle=\"btn-default\"></toggle>\r\n      </div>\r\n      <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	CustomEntityService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomEntityService = CustomEntityService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function CustomEntityService($resource) {
	  return $resource('/api/custom-entities/:id', {
	    name: '@_id'
	  }, {
	    getByType: {
	      method: 'GET',
	      isArray: true,
	      url: "/api/custom-entities/type/:type"
	    },
	    getCustomList: {
	      method: 'GET',
	      isArray: true,
	      url: "/api/custom-entities/:type/list-by/:refField/:refId"
	    },
	    update: {
	      method: 'PUT'
	    },
	    patch: {
	      method: 'PATCH'
	    },
	    addAttachments: {
	      method: 'PUT',
	      url: "/api/custom-entities/:id/attachments"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.CustomEntityService', []).factory('CustomEntityService', CustomEntityService).name;

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	/*** Directives and services for responding to idle users in AngularJS
	* @author Mike Grabski <me@mikegrabski.com>
	* @version v1.3.2
	* @link https://github.com/HackedByChinese/ng-idle.git
	* @license MIT
	*/
	
	!function(a,b,c){"use strict";b.module("ngIdle",["ngIdle.keepalive","ngIdle.idle","ngIdle.countdown","ngIdle.title","ngIdle.localStorage"]),b.module("ngIdle.keepalive",[]).provider("Keepalive",function(){var a={http:null,interval:600};this.http=function(c){if(!c)throw new Error("Argument must be a string containing a URL, or an object containing the HTTP request configuration.");b.isString(c)&&(c={url:c,method:"GET"}),c.cache=!1,a.http=c};var c=this.interval=function(b){if(b=parseInt(b),isNaN(b)||0>=b)throw new Error("Interval must be expressed in seconds and be greater than 0.");a.interval=b};this.$get=["$rootScope","$log","$interval","$http",function(d,e,f,g){function h(a){d.$broadcast("KeepaliveResponse",a.data,a.status)}function i(){d.$broadcast("Keepalive"),b.isObject(a.http)&&g(a.http).then(h)["catch"](h)}var j={ping:null};return{_options:function(){return a},setInterval:c,start:function(){return f.cancel(j.ping),j.ping=f(i,1e3*a.interval),j.ping},stop:function(){f.cancel(j.ping)},ping:function(){i()}}}]}),b.module("ngIdle.idle",["ngIdle.keepalive","ngIdle.localStorage"]).provider("Idle",function(){var a={idle:1200,timeout:30,autoResume:"idle",interrupt:"mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll",windowInterrupt:null,keepalive:!0},c=this.timeout=function(c){if(c===!1)a.timeout=0;else{if(!(b.isNumber(c)&&c>=0))throw new Error("Timeout must be zero or false to disable the feature, or a positive integer (in seconds) to enable it.");a.timeout=c}};this.interrupt=function(b){a.interrupt=b},this.windowInterrupt=function(b){a.windowInterrupt=b};var d=this.idle=function(b){if(0>=b)throw new Error("Idle must be a value in seconds, greater than 0.");a.idle=b};this.autoResume=function(b){b===!0?a.autoResume="idle":b===!1?a.autoResume="off":a.autoResume=b},this.keepalive=function(b){a.keepalive=b===!0},this.$get=["$interval","$log","$rootScope","$document","Keepalive","IdleLocalStorage","$window",function(e,f,g,h,i,j,k){function l(){a.keepalive&&(u.running&&i.ping(),i.start())}function m(){a.keepalive&&i.stop()}function n(){u.idling=!u.idling;var b=u.idling?"IdleStart":"IdleEnd";u.idling?(g.$broadcast(b),m(),a.timeout&&(u.countdown=a.timeout,o(),u.timeout=e(o,1e3,a.timeout,!1))):(l(),g.$broadcast(b)),e.cancel(u.idle)}function o(){if(u.idling){if(u.countdown<=0)return void q();g.$broadcast("IdleWarn",u.countdown),u.countdown--}}function p(a){g.$broadcast("IdleInterrupt",a)}function q(){m(),e.cancel(u.idle),e.cancel(u.timeout),u.idling=!0,u.running=!1,u.countdown=0,g.$broadcast("IdleTimeout")}function r(a,b,c){var d=a.running();a.unwatch(),b(c),d&&a.watch()}function s(){var a=j.get("expiry");return a&&a.time?new Date(a.time):null}function t(a){a?j.set("expiry",{id:v,time:a}):j.remove("expiry")}var u={idle:null,timeout:null,idling:!1,running:!1,countdown:null},v=(new Date).getTime(),w={_options:function(){return a},_getNow:function(){return new Date},getIdle:function(){return a.idle},getTimeout:function(){return a.timeout},setIdle:function(a){r(this,d,a)},setTimeout:function(a){r(this,c,a)},isExpired:function(){var a=s();return null!==a&&a<=this._getNow()},running:function(){return u.running},idling:function(){return u.idling},watch:function(b){e.cancel(u.idle),e.cancel(u.timeout);var c=a.timeout?a.timeout:0;b||t(new Date((new Date).getTime()+1e3*(a.idle+c))),u.idling?n():u.running||l(),u.running=!0,u.idle=e(n,1e3*a.idle,0,!1)},unwatch:function(){e.cancel(u.idle),e.cancel(u.timeout),u.idling=!1,u.running=!1,t(null),m()},interrupt:function(b){if(u.running){if(a.timeout&&this.isExpired())return void q();p(b),(b||"idle"===a.autoResume||"notIdle"===a.autoResume&&!u.idling)&&this.watch(b)}}},x={clientX:null,clientY:null,swap:function(a){var b={clientX:this.clientX,clientY:this.clientY};return this.clientX=a.clientX,this.clientY=a.clientY,b},hasMoved:function(a){var b=this.swap(a);return null===this.clientX||a.movementX||a.movementY?!0:b.clientX!=a.clientX||b.clientY!=a.clientY?!0:!1}};if(h.find("html").on(a.interrupt,function(a){"mousemove"===a.type&&a.originalEvent&&0===a.originalEvent.movementX&&0===a.originalEvent.movementY||("mousemove"!==a.type||x.hasMoved(a))&&w.interrupt()}),a.windowInterrupt)for(var y=a.windowInterrupt.split(" "),z=function(){w.interrupt()},A=0;A<y.length;A++)k.addEventListener?k.addEventListener(y[A],z,!1):k.attachEvent(y[A],z);var B=function(a){if("ngIdle.expiry"===a.key&&a.newValue&&a.newValue!==a.oldValue){var c=b.fromJson(a.newValue);if(c.id===v)return;w.interrupt(!0)}};return k.addEventListener?k.addEventListener("storage",B,!1):k.attachEvent&&k.attachEvent("onstorage",B),w}]}),b.module("ngIdle.countdown",["ngIdle.idle"]).directive("idleCountdown",["Idle",function(a){return{restrict:"A",scope:{value:"=idleCountdown"},link:function(b){b.value=a.getTimeout(),b.$on("IdleWarn",function(a,c){b.$evalAsync(function(){b.value=c})}),b.$on("IdleTimeout",function(){b.$evalAsync(function(){b.value=0})})}}}]),b.module("ngIdle.title",[]).provider("Title",function(){function a(a,b,c){return new Array(b-String(a).length+1).join(c||"0")+a}var c={enabled:!0},d=this.enabled=function(a){c.enabled=a===!0};this.$get=["$document","$interpolate",function(e,f){var g={original:null,idle:"{{minutes}}:{{seconds}} until your session times out!",timedout:"Your session has expired."};return{setEnabled:d,isEnabled:function(){return c.enabled},original:function(a){return b.isUndefined(a)?g.original:void(g.original=a)},store:function(a){(a||!g.original)&&(g.original=this.value())},value:function(a){return b.isUndefined(a)?e[0].title:void(e[0].title=a)},idleMessage:function(a){return b.isUndefined(a)?g.idle:void(g.idle=a)},timedOutMessage:function(a){return b.isUndefined(a)?g.timedout:void(g.timedout=a)},setAsIdle:function(b){this.store();var c={totalSeconds:b};c.minutes=Math.floor(b/60),c.seconds=a(b-60*c.minutes,2),this.value(f(this.idleMessage())(c))},setAsTimedOut:function(){this.store(),this.value(this.timedOutMessage())},restore:function(){this.original()&&this.value(this.original())}}}]}).directive("title",["Title",function(a){return{restrict:"E",link:function(b,c,d){a.isEnabled()&&!d.idleDisabled&&(a.store(!0),b.$on("IdleStart",function(){a.original(c[0].innerText)}),b.$on("IdleWarn",function(b,c){a.setAsIdle(c)}),b.$on("IdleEnd",function(){a.restore()}),b.$on("IdleTimeout",function(){a.setAsTimedOut()}))}}}]),b.module("ngIdle.localStorage",[]).service("IdleStorageAccessor",["$window",function(a){return{get:function(){return a.localStorage}}}]).service("IdleLocalStorage",["IdleStorageAccessor",function(a){function d(){var a={};this.setItem=function(b,c){a[b]=c},this.getItem=function(b){return"undefined"!=typeof a[b]?a[b]:null},this.removeItem=function(b){a[b]=c}}function e(){try{var b=a.get();return b.setItem("ngIdleStorage",""),b.removeItem("ngIdleStorage"),b}catch(c){return new d}}var f=e();return{set:function(a,c){f.setItem("ngIdle."+a,b.toJson(c))},get:function(a){return b.fromJson(f.getItem("ngIdle."+a))},remove:function(a){f.removeItem("ngIdle."+a)},_wrapped:function(){return f}}}])}(window,window.angular);
	//# sourceMappingURL=angular-idle.map

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module("stBlurredDialog", []).constant('stBlurredDialogClasses', {
		blurredRegion: 'st-blurred-region'
	}).factory('stBlurredDialog', ['$timeout', function ($timeout) {
		var state = {
			subscribers: [],
			isOpen: false,
			dialogData: null
		};
	
		return {
			open: function open(pathToTemplate, data) {
				$timeout(function () {
					state.dialogData = data;
					state.isOpen = true;
					angular.forEach(state.subscribers, function (subscriberCb) {
						subscriberCb(state.isOpen, pathToTemplate);
					});
				});
			},
			close: function close() {
				$timeout(function () {
					state.isOpen = false;
					angular.forEach(state.subscribers, function (subscriberCb) {
						subscriberCb(state.isOpen);
					});
				});
			},
			isOpen: function isOpen() {
				return state.isOpen;
			},
			getDialogData: function getDialogData() {
				return state.dialogData;
			},
			subscribe: function subscribe(cb) {
				state.subscribers.push(cb);
			}
		};
	}]).directive('stBlurredDialogRegion', [function () {
		return {
			restrict: "A",
			scope: {},
			controller: ['$scope', 'stBlurredDialog', '$element', 'stBlurredDialogClasses', function ($scope, stBlurredDialog, $element, stBlurredDialogClasses) {
	
				stBlurredDialog.subscribe(function (isOpen, path, data) {
					if (isOpen) {
						$element.addClass(stBlurredDialogClasses.blurredRegion);
					} else {
						$element.removeClass(stBlurredDialogClasses.blurredRegion);
					}
				});
			}],
			link: function link(scope, element, attrs) {}
		};
	}]).directive('stBlurredDialogOverlay', [function () {
		return {
			restrict: "E",
			replace: true,
			template: __webpack_require__(704),
			controller: ['$scope', 'stBlurredDialog', '$element', 'Auth', 'Idle', '$localStorage', function ($scope, stBlurredDialog, $element, Auth, Idle, $localStorage) {
				'ngInject';
	
				$scope.model = {
					isOpen: false,
					pathToTemplate: null
				};
	
				stBlurredDialog.subscribe(function (isOpen, path) {
					$scope.model.isOpen = isOpen;
					$scope.model.pathToTemplate = path;
					$scope.user = Auth.getCurrentUserSync();
				});
	
				$scope.validate = function () {
					Auth.validatePassword($scope.model.password).then(function () {
						$localStorage.screenIsLocked = false;
						$scope.model.password = '';
						$scope.close();
						Idle.watch();
					}).catch(function () {
						$scope.error = 'Incorrect password';
					});
				};
	
				$scope.close = function () {
					stBlurredDialog.close();
				};
			}],
			link: function link(scope, element, attrs) {}
		};
	}]);

/***/ }),
/* 704 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if='model.isOpen' class='st-blurred-region-overlay'>\r\n    <!--<div style='text-align:right;'><button ng-click='close()' class='st-blurred-region-close'>&#10006;</button></div>-->\r\n\r\n    <div class=\"col-sm-6 col-md-4 col-md-offset-4\">\r\n\r\n        <div class=\"panel panel-default account-panel\">\r\n            <div class=\"panel-heading\">\r\n                <h3 class=\"panel-title\"><span class=\"glyphicon glyphicon-lock\"></span> Enter password to unlock</h3>\r\n            </div>\r\n            <div class=\"panel-body\">\r\n                <div class=\"center-block text-center\">\r\n                    <h5>For you and your clients' privacy and security:<br/>Your screen has been locked due to an idle time.</h5>\r\n                    <hr/>\r\n                    <img class=\"img-thumbnail img-circle\" ng-src=\"https://ui-avatars.com/api/?name={{user.firstName}}+{{user.lastName}}&background=333&rounded=true&color=eee&size=130\"\r\n                         alt=\"\">\r\n                    <p>{{user.email}}</p>\r\n                    <form class=\"unlock-form\">\r\n                        <div class=\"input-group\">\r\n                                    <span class=\"input-group-addon\">\r\n                                        <i class=\"glyphicon glyphicon-lock\"></i>\r\n                                    </span>\r\n                            <input type=\"password\" class=\"form-control\" placeholder=\"Password\" ng-model=\"model.password\" ng-keyup=\"$event.keyCode == 13 && validate()\" required autofocus>\r\n                        </div>\r\n                        <button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"validate()\" ng-disabled=\"!model.password\">Unlock</button>\r\n                        <span class=\"text-danger\" ng-if=\"error\"><br/>{{error}}</span>\r\n                    </form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n\r\n</div>"

/***/ }),
/* 705 */
5,
/* 706 */,
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(14);
	
	exports.default = angular.module('conduu.ap.components.bindDynamicPage', []).directive('bindDynamicPage', ['$compile', function ($compile) {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      scope.$watch(function (scope) {
	        return scope.$eval(attrs.bindDynamicPage);
	      }, function (value) {
	        element.html(value);
	        $compile(element.contents())(scope);
	      });
	    }
	  };
	}]).name;

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	/*! ngTagsInput v3.2.0 License: MIT */!function(){"use strict";var a={backspace:8,tab:9,enter:13,escape:27,space:32,up:38,down:40,left:37,right:39,"delete":46,comma:188},b=9007199254740991,c=["text","email","url"],d=angular.module("ngTagsInput",[]);d.directive("tagsInput",["$timeout","$document","$window","$q","tagsInputConfig","tiUtil",function(d,e,f,g,h,i){function j(a,b,c,d){var e,f,h,j,k={};return e=function(b){return i.safeToString(b[a.displayProperty])},f=function(b,c){b[a.displayProperty]=c},h=function(b){var d=e(b),f=d&&d.length>=a.minLength&&d.length<=a.maxLength&&a.allowedTagsPattern.test(d)&&!i.findInObjectArray(k.items,b,a.keyProperty||a.displayProperty);return g.when(f&&c({$tag:b})).then(i.promisifyValue)},j=function(a){return g.when(d({$tag:a})).then(i.promisifyValue)},k.items=[],k.addText=function(a){var b={};return f(b,a),k.add(b)},k.add=function(c){var d=e(c);return a.replaceSpacesWithDashes&&(d=i.replaceSpacesWithDashes(d)),f(c,d),h(c).then(function(){k.items.push(c),b.trigger("tag-added",{$tag:c})})["catch"](function(){d&&b.trigger("invalid-tag",{$tag:c})})},k.remove=function(a){var c=k.items[a];return j(c).then(function(){return k.items.splice(a,1),k.clearSelection(),b.trigger("tag-removed",{$tag:c}),c})},k.select=function(a){0>a?a=k.items.length-1:a>=k.items.length&&(a=0),k.index=a,k.selected=k.items[a]},k.selectPrior=function(){k.select(--k.index)},k.selectNext=function(){k.select(++k.index)},k.removeSelected=function(){return k.remove(k.index)},k.clearSelection=function(){k.selected=null,k.index=-1},k.getItems=function(){return a.useStrings?k.items.map(e):k.items},k.clearSelection(),k}function k(a){return-1!==c.indexOf(a)}return{restrict:"E",require:"ngModel",scope:{tags:"=ngModel",text:"=?",templateScope:"=?",tagClass:"&",onTagAdding:"&",onTagAdded:"&",onInvalidTag:"&",onTagRemoving:"&",onTagRemoved:"&",onTagClicked:"&"},replace:!1,transclude:!0,templateUrl:"ngTagsInput/tags-input.html",controller:["$scope","$attrs","$element",function(a,c,d){a.events=i.simplePubSub(),h.load("tagsInput",a,c,{template:[String,"ngTagsInput/tag-item.html"],type:[String,"text",k],placeholder:[String,"Add a tag"],tabindex:[Number,null],removeTagSymbol:[String,String.fromCharCode(215)],replaceSpacesWithDashes:[Boolean,!0],minLength:[Number,3],maxLength:[Number,b],addOnEnter:[Boolean,!0],addOnSpace:[Boolean,!1],addOnComma:[Boolean,!0],addOnBlur:[Boolean,!0],addOnPaste:[Boolean,!1],pasteSplitPattern:[RegExp,/,/],allowedTagsPattern:[RegExp,/.+/],enableEditingLastTag:[Boolean,!1],minTags:[Number,0],maxTags:[Number,b],displayProperty:[String,"text"],keyProperty:[String,""],allowLeftoverText:[Boolean,!1],addFromAutocompleteOnly:[Boolean,!1],spellcheck:[Boolean,!0],useStrings:[Boolean,!1]}),a.tagList=new j(a.options,a.events,i.handleUndefinedResult(a.onTagAdding,!0),i.handleUndefinedResult(a.onTagRemoving,!0)),this.registerAutocomplete=function(){d.find("input");return{addTag:function(b){return a.tagList.add(b)},getTags:function(){return a.tagList.items},getCurrentTagText:function(){return a.newTag.text()},getOptions:function(){return a.options},getTemplateScope:function(){return a.templateScope},on:function(b,c){return a.events.on(b,c,!0),this}}},this.registerTagItem=function(){return{getOptions:function(){return a.options},removeTag:function(b){a.disabled||a.tagList.remove(b)}}}}],link:function(b,c,g,h){var j,k,l=[a.enter,a.comma,a.space,a.backspace,a["delete"],a.left,a.right],m=b.tagList,n=b.events,o=b.options,p=c.find("input"),q=["minTags","maxTags","allowLeftoverText"];j=function(){h.$setValidity("maxTags",m.items.length<=o.maxTags),h.$setValidity("minTags",m.items.length>=o.minTags),h.$setValidity("leftoverText",b.hasFocus||o.allowLeftoverText?!0:!b.newTag.text())},k=function(){d(function(){p[0].focus()})},h.$isEmpty=function(a){return!a||!a.length},b.newTag={text:function(a){return angular.isDefined(a)?(b.text=a,void n.trigger("input-change",a)):b.text||""},invalid:null},b.track=function(a){return a[o.keyProperty||o.displayProperty]},b.getTagClass=function(a,c){var d=a===m.selected;return[b.tagClass({$tag:a,$index:c,$selected:d}),{selected:d}]},b.$watch("tags",function(a){if(a){if(m.items=i.makeObjectArray(a,o.displayProperty),o.useStrings)return;b.tags=m.items}else m.items=[]}),b.$watch("tags.length",function(){j(),h.$validate()}),g.$observe("disabled",function(a){b.disabled=a}),b.eventHandlers={input:{keydown:function(a){n.trigger("input-keydown",a)},focus:function(){b.hasFocus||(b.hasFocus=!0,n.trigger("input-focus"))},blur:function(){d(function(){var a=e.prop("activeElement"),d=a===p[0],f=c[0].contains(a);(d||!f)&&(b.hasFocus=!1,n.trigger("input-blur"))})},paste:function(a){a.getTextData=function(){var b=a.clipboardData||a.originalEvent&&a.originalEvent.clipboardData;return b?b.getData("text/plain"):f.clipboardData.getData("Text")},n.trigger("input-paste",a)}},host:{click:function(){b.disabled||k()}},tag:{click:function(a){n.trigger("tag-clicked",{$tag:a})}}},n.on("tag-added",b.onTagAdded).on("invalid-tag",b.onInvalidTag).on("tag-removed",b.onTagRemoved).on("tag-clicked",b.onTagClicked).on("tag-added",function(){b.newTag.text("")}).on("tag-added tag-removed",function(){b.tags=m.getItems(),h.$setDirty(),k()}).on("invalid-tag",function(){b.newTag.invalid=!0}).on("option-change",function(a){-1!==q.indexOf(a.name)&&j()}).on("input-change",function(){m.clearSelection(),b.newTag.invalid=null}).on("input-focus",function(){c.triggerHandler("focus"),h.$setValidity("leftoverText",!0)}).on("input-blur",function(){o.addOnBlur&&!o.addFromAutocompleteOnly&&m.addText(b.newTag.text()),c.triggerHandler("blur"),j()}).on("input-keydown",function(c){var d,e,f,g,h=c.keyCode,j={};i.isModifierOn(c)||-1===l.indexOf(h)||(j[a.enter]=o.addOnEnter,j[a.comma]=o.addOnComma,j[a.space]=o.addOnSpace,d=!o.addFromAutocompleteOnly&&j[h],e=(h===a.backspace||h===a["delete"])&&m.selected,g=h===a.backspace&&0===b.newTag.text().length&&o.enableEditingLastTag,f=(h===a.backspace||h===a.left||h===a.right)&&0===b.newTag.text().length&&!o.enableEditingLastTag,d?m.addText(b.newTag.text()):g?(m.selectPrior(),m.removeSelected().then(function(a){a&&b.newTag.text(a[o.displayProperty])})):e?m.removeSelected():f&&(h===a.left||h===a.backspace?m.selectPrior():h===a.right&&m.selectNext()),(d||f||e||g)&&c.preventDefault())}).on("input-paste",function(a){if(o.addOnPaste){var b=a.getTextData(),c=b.split(o.pasteSplitPattern);c.length>1&&(c.forEach(function(a){m.addText(a)}),a.preventDefault())}})}}}]),d.directive("tiTagItem",["tiUtil",function(a){return{restrict:"E",require:"^tagsInput",template:'<ng-include src="$$template"></ng-include>',scope:{$scope:"=scope",data:"="},link:function(b,c,d,e){var f=e.registerTagItem(),g=f.getOptions();b.$$template=g.template,b.$$removeTagSymbol=g.removeTagSymbol,b.$getDisplayText=function(){return a.safeToString(b.data[g.displayProperty])},b.$removeTag=function(){f.removeTag(b.$index)},b.$watch("$parent.$index",function(a){b.$index=a})}}}]),d.directive("autoComplete",["$document","$timeout","$sce","$q","tagsInputConfig","tiUtil",function(b,c,d,e,f,g){function h(a,b,c){var d,f,h,i={};return h=function(){return b.tagsInput.keyProperty||b.tagsInput.displayProperty},d=function(a,c){return a.filter(function(a){return!g.findInObjectArray(c,a,h(),function(a,c){return b.tagsInput.replaceSpacesWithDashes&&(a=g.replaceSpacesWithDashes(a),c=g.replaceSpacesWithDashes(c)),g.defaultComparer(a,c)})})},i.reset=function(){f=null,i.items=[],i.visible=!1,i.index=-1,i.selected=null,i.query=null},i.show=function(){b.selectFirstMatch?i.select(0):i.selected=null,i.visible=!0},i.load=g.debounce(function(c,j){i.query=c;var k=e.when(a({$query:c}));f=k,k.then(function(a){k===f&&(a=g.makeObjectArray(a.data||a,h()),a=d(a,j),i.items=a.slice(0,b.maxResultsToShow),i.items.length>0?i.show():i.reset())})},b.debounceDelay),i.selectNext=function(){i.select(++i.index)},i.selectPrior=function(){i.select(--i.index)},i.select=function(a){0>a?a=i.items.length-1:a>=i.items.length&&(a=0),i.index=a,i.selected=i.items[a],c.trigger("suggestion-selected",a)},i.reset(),i}function i(a,b){var c=a.find("li").eq(b),d=c.parent(),e=c.prop("offsetTop"),f=c.prop("offsetHeight"),g=d.prop("clientHeight"),h=d.prop("scrollTop");h>e?d.prop("scrollTop",e):e+f>g+h&&d.prop("scrollTop",e+f-g)}return{restrict:"E",require:"^tagsInput",scope:{source:"&",matchClass:"&"},templateUrl:"ngTagsInput/auto-complete.html",controller:["$scope","$element","$attrs",function(a,b,c){a.events=g.simplePubSub(),f.load("autoComplete",a,c,{template:[String,"ngTagsInput/auto-complete-match.html"],debounceDelay:[Number,100],minLength:[Number,3],highlightMatchedText:[Boolean,!0],maxResultsToShow:[Number,10],loadOnDownArrow:[Boolean,!1],loadOnEmpty:[Boolean,!1],loadOnFocus:[Boolean,!1],selectFirstMatch:[Boolean,!0],displayProperty:[String,""]}),a.suggestionList=new h(a.source,a.options,a.events),this.registerAutocompleteMatch=function(){return{getOptions:function(){return a.options},getQuery:function(){return a.suggestionList.query}}}}],link:function(b,c,d,e){var f,h=[a.enter,a.tab,a.escape,a.up,a.down],j=b.suggestionList,k=e.registerAutocomplete(),l=b.options,m=b.events;l.tagsInput=k.getOptions(),f=function(a){return a&&a.length>=l.minLength||!a&&l.loadOnEmpty},b.templateScope=k.getTemplateScope(),b.addSuggestionByIndex=function(a){j.select(a),b.addSuggestion()},b.addSuggestion=function(){var a=!1;return j.selected&&(k.addTag(angular.copy(j.selected)),j.reset(),a=!0),a},b.track=function(a){return a[l.tagsInput.keyProperty||l.tagsInput.displayProperty]},b.getSuggestionClass=function(a,c){var d=a===j.selected;return[b.matchClass({$match:a,$index:c,$selected:d}),{selected:d}]},k.on("tag-added tag-removed invalid-tag input-blur",function(){j.reset()}).on("input-change",function(a){f(a)?j.load(a,k.getTags()):j.reset()}).on("input-focus",function(){var a=k.getCurrentTagText();l.loadOnFocus&&f(a)&&j.load(a,k.getTags())}).on("input-keydown",function(c){var d=c.keyCode,e=!1;if(!g.isModifierOn(c)&&-1!==h.indexOf(d))return j.visible?d===a.down?(j.selectNext(),e=!0):d===a.up?(j.selectPrior(),e=!0):d===a.escape?(j.reset(),e=!0):(d===a.enter||d===a.tab)&&(e=b.addSuggestion()):d===a.down&&b.options.loadOnDownArrow&&(j.load(k.getCurrentTagText(),k.getTags()),e=!0),e?(c.preventDefault(),c.stopImmediatePropagation(),!1):void 0}),m.on("suggestion-selected",function(a){i(c,a)})}}}]),d.directive("tiAutocompleteMatch",["$sce","tiUtil",function(a,b){return{restrict:"E",require:"^autoComplete",template:'<ng-include src="$$template"></ng-include>',scope:{$scope:"=scope",data:"="},link:function(c,d,e,f){var g=f.registerAutocompleteMatch(),h=g.getOptions();c.$$template=h.template,c.$index=c.$parent.$index,c.$highlight=function(c){return h.highlightMatchedText&&(c=b.safeHighlight(c,g.getQuery())),a.trustAsHtml(c)},c.$getDisplayText=function(){return b.safeToString(c.data[h.displayProperty||h.tagsInput.displayProperty])}}}}]),d.directive("tiTranscludeAppend",function(){return function(a,b,c,d,e){e(function(a){b.append(a)})}}),d.directive("tiAutosize",["tagsInputConfig",function(a){return{restrict:"A",require:"ngModel",link:function(b,c,d,e){var f,g,h=a.getTextAutosizeThreshold();f=angular.element('<span class="input"></span>'),f.css("display","none").css("visibility","hidden").css("width","auto").css("white-space","pre"),c.parent().append(f),g=function(a){var b,e=a;return angular.isString(e)&&0===e.length&&(e=d.placeholder),e&&(f.text(e),f.css("display",""),b=f.prop("offsetWidth"),f.css("display","none")),c.css("width",b?b+h+"px":""),a},e.$parsers.unshift(g),e.$formatters.unshift(g),d.$observe("placeholder",function(a){e.$modelValue||g(a)})}}}]),d.directive("tiBindAttrs",function(){return function(a,b,c){a.$watch(c.tiBindAttrs,function(a){angular.forEach(a,function(a,b){c.$set(b,a)})},!0)}}),d.provider("tagsInputConfig",function(){var a={},b={},c=3;this.setDefaults=function(b,c){return a[b]=c,this},this.setActiveInterpolation=function(a,c){return b[a]=c,this},this.setTextAutosizeThreshold=function(a){return c=a,this},this.$get=["$interpolate",function(d){var e={};return e[String]=function(a){return a},e[Number]=function(a){return parseInt(a,10)},e[Boolean]=function(a){return"true"===a.toLowerCase()},e[RegExp]=function(a){return new RegExp(a)},{load:function(c,f,g,h){var i=function(){return!0};f.options={},angular.forEach(h,function(h,j){var k,l,m,n,o,p;k=h[0],l=h[1],m=h[2]||i,n=e[k],o=function(){var b=a[c]&&a[c][j];return angular.isDefined(b)?b:l},p=function(a){f.options[j]=a&&m(a)?n(a):o()},b[c]&&b[c][j]?g.$observe(j,function(a){p(a),f.events.trigger("option-change",{name:j,newValue:a})}):p(g[j]&&d(g[j])(f.$parent))})},getTextAutosizeThreshold:function(){return c}}}]}),d.factory("tiUtil",["$timeout","$q",function(a,b){var c={};return c.debounce=function(b,c){var d;return function(){var e=arguments;a.cancel(d),d=a(function(){b.apply(null,e)},c)}},c.makeObjectArray=function(a,b){if(!angular.isArray(a)||0===a.length||angular.isObject(a[0]))return a;var c=[];return a.forEach(function(a){var d={};d[b]=a,c.push(d)}),c},c.findInObjectArray=function(a,b,d,e){var f=null;return e=e||c.defaultComparer,a.some(function(a){return e(a[d],b[d])?(f=a,!0):void 0}),f},c.defaultComparer=function(a,b){return c.safeToString(a).toLowerCase()===c.safeToString(b).toLowerCase()},c.safeHighlight=function(a,b){function d(a){return a.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}if(a=c.encodeHTML(a),b=c.encodeHTML(b),!b)return a;var e=new RegExp("&[^;]+;|"+d(b),"gi");return a.replace(e,function(a){return a.toLowerCase()===b.toLowerCase()?"<em>"+a+"</em>":a})},c.safeToString=function(a){return angular.isUndefined(a)||null==a?"":a.toString().trim()},c.encodeHTML=function(a){return c.safeToString(a).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")},c.handleUndefinedResult=function(a,b){return function(){var c=a.apply(null,arguments);return angular.isUndefined(c)?b:c}},c.replaceSpacesWithDashes=function(a){return c.safeToString(a).replace(/\s/g,"-")},c.isModifierOn=function(a){return a.shiftKey||a.ctrlKey||a.altKey||a.metaKey},c.promisifyValue=function(a){return a=angular.isUndefined(a)?!0:a,b[a?"when":"reject"]()},c.simplePubSub=function(){var a={};return{on:function(b,c,d){return b.split(" ").forEach(function(b){a[b]||(a[b]=[]);var e=d?[].unshift:[].push;e.call(a[b],c)}),this},trigger:function(b,d){var e=a[b]||[];return e.every(function(a){return c.handleUndefinedResult(a,!0)(d)}),this}}},c}]),d.run(["$templateCache",function(a){a.put("ngTagsInput/tags-input.html",'<div class="host" tabindex="-1" ng-click="eventHandlers.host.click()" ti-transclude-append><div class="tags" ng-class="{focused: hasFocus}"><ul class="tag-list"><li class="tag-item" ng-repeat="tag in tagList.items track by track(tag)" ng-class="getTagClass(tag, $index)" ng-click="eventHandlers.tag.click(tag)"><ti-tag-item scope="templateScope" data="::tag"></ti-tag-item></li></ul><input class="input" autocomplete="off" ng-model="newTag.text" ng-model-options="{getterSetter: true}" ng-keydown="eventHandlers.input.keydown($event)" ng-focus="eventHandlers.input.focus($event)" ng-blur="eventHandlers.input.blur($event)" ng-paste="eventHandlers.input.paste($event)" ng-trim="false" ng-class="{\'invalid-tag\': newTag.invalid}" ng-disabled="disabled" ti-bind-attrs="{type: options.type, placeholder: options.placeholder, tabindex: options.tabindex, spellcheck: options.spellcheck}" ti-autosize></div></div>'),a.put("ngTagsInput/tag-item.html",'<span ng-bind="$getDisplayText()"></span> <a class="remove-button" ng-click="$removeTag()" ng-bind="::$$removeTagSymbol"></a>'),a.put("ngTagsInput/auto-complete.html",'<div class="autocomplete" ng-if="suggestionList.visible"><ul class="suggestion-list"><li class="suggestion-item" ng-repeat="item in suggestionList.items track by track(item)" ng-class="getSuggestionClass(item, $index)" ng-click="addSuggestionByIndex($index)" ng-mouseenter="suggestionList.select($index)"><ti-autocomplete-match scope="templateScope" data="::item"></ti-autocomplete-match></li></ul></div>'),a.put("ngTagsInput/auto-complete-match.html",'<span ng-bind-html="$highlight($getDisplayText())"></span>')}])}();

/***/ }),
/* 709 */
5,
/* 710 */,
/* 711 */
5,
/* 712 */,
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebaccessListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webaccessList = __webpack_require__(714);
	
	var _webaccessList2 = _interopRequireDefault(_webaccessList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var WebaccessListComponent = exports.WebaccessListComponent = function () {
	  WebaccessListComponent.$inject = ['Auth', 'WebAccessService', 'SettingsService', 'dialogs', '$localStorage', 'DTOptionsBuilder', 'CommunityService', 'ViewSelection', '$scope', '$uibModal', 'DTState'];
	  function WebaccessListComponent(Auth, WebAccessService, SettingsService, dialogs, $localStorage, DTOptionsBuilder, CommunityService, ViewSelection, $scope, $uibModal, DTState) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, WebaccessListComponent);
	
	    this.WebAccessService = WebAccessService;
	    this.ViewSelection = ViewSelection;
	    this.data = [];
	    this.filteredData = [];
	    this.selectedCommunityCode = "";
	    this.activeTabIndex = 0;
	    this.$uibModal = $uibModal;
	
	    CommunityService.query(function (data) {
	      _this.communityMap = {};
	      data.forEach(function (cmty) {
	        return _this.communityMap[cmty.code] = cmty.name;
	      });
	
	      SettingsService.getByName({ name: 'client' }, function (clientData) {
	        _this.eVotingEnabled = clientData.data.eVotingEnabled;
	      });
	
	      SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	        _this.webAccessGroupConfig = appSettings.data.webAccessGroupConfig || [];
	
	        _this.WebAccessService.query(function (data) {
	          _this.data = data;
	          _this.filterData(ViewSelection.selectedCommunityCode);
	          _this.dataInitComplete = true;
	        }, function (err) {
	          console.log("Could not retrieve website access.");
	        });
	      });
	    });
	
	    this.dialogs = dialogs;
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'desc']).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Website Access"
	    }, {
	      extend: 'csv',
	      title: "Website Access"
	    }, {
	      title: "Website Access",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'portrait',
	      pageSize: 'LETTER'
	    }, {
	      extend: 'print',
	      title: "Website Access"
	    }]);
	
	    $scope.ViewSelection = ViewSelection;
	    $scope.$watch('ViewSelection.selectedCommunity', function (newVal, oldVal, scope) {
	      _this.selectedCommunity = newVal.name;
	      _this.selectedCommunityCode = newVal.value;
	      _this.filterData(_this.selectedCommunityCode);
	      if (!_this.filter) {
	        _this.setFilter('all');
	      } else {
	        _this.setFilter(_this.filter);
	      }
	    });
	  }
	
	  _createClass(WebaccessListComponent, [{
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += "<br/>" + contact.company;
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount(option) {
	
	      switch (option) {
	        case 'all':
	          return this.rawFilteredData.length;
	        case 'active':
	          return this.rawFilteredData.filter(function (wa) {
	            return (wa.lastLogin || wa.lastLoginVoting) && !wa.isBlocked;
	          }).length;
	        case 'blocked':
	          return this.rawFilteredData.filter(function (wa) {
	            return wa.isBlocked;
	          }).length;
	        case 'initial':
	          return this.rawFilteredData.filter(function (wa) {
	            return !(wa.lastLogin || wa.lastLoginVoting || wa.accountActivated) && wa.activationType == 'initial' && !wa.isBlocked;
	          }).length;
	        case 'invite-no-activation':
	          return this.rawFilteredData.filter(function (wa) {
	            return wa.lastInvite && !(wa.lastLogin || wa.lastLoginVoting || wa.accountActivated) && wa.activationType == 'invitation' && !wa.isBlocked;
	          }).length;
	        case 'no-invite-no-activation':
	          return this.rawFilteredData.filter(function (wa) {
	            return !wa.lastInvite && !(wa.lastLogin || wa.lastLoginVoting || wa.accountActivated) && wa.activationType == 'invitation' && !wa.isBlocked;
	          }).length;
	      }
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter(option) {
	
	      switch (option) {
	        case 'all':
	          this.filter = null;
	          this.filterData(this.selectedCommunityCode);
	          break;
	        case 'active':
	          this.filter = option;
	          this.filterData(this.selectedCommunityCode);
	          this.filteredData = this.filteredData.filter(function (wa) {
	            return (wa.lastLogin || wa.lastLoginVoting) && !wa.isBlocked;
	          });
	          break;
	        case 'blocked':
	          this.filter = option;
	          this.filterData(this.selectedCommunityCode);
	          this.filteredData = this.filteredData.filter(function (wa) {
	            return wa.isBlocked;
	          });
	          break;
	        case 'initial':
	          this.filter = option;
	          this.filterData(this.selectedCommunityCode);
	          this.filteredData = this.filteredData.filter(function (wa) {
	            return !(wa.lastLogin || wa.lastLoginVoting || wa.accountActivated) && wa.activationType == 'initial' && !wa.isBlocked;
	          });
	          break;
	        case 'invite-no-activation':
	          this.filter = option;
	          this.filterData(this.selectedCommunityCode);
	          this.filteredData = this.filteredData.filter(function (wa) {
	            return wa.lastInvite && !(wa.lastLogin || wa.lastLoginVoting || wa.accountActivated) && wa.activationType == 'invitation' && !wa.isBlocked;
	          });
	          break;
	        case 'no-invite-no-activation':
	          this.filter = option;
	          this.filterData(this.selectedCommunityCode);
	          this.filteredData = this.filteredData.filter(function (wa) {
	            return !wa.lastInvite && !(wa.lastLogin || wa.lastLoginVoting || wa.accountActivated) && wa.activationType == 'invitation' && !wa.isBlocked;
	          });
	          break;
	      }
	    }
	  }, {
	    key: 'openSendInvitationModal',
	    value: function openSendInvitationModal(resend) {
	      var that = this;
	
	      var title = resend ? "Resend Invitation" : "Send Invitation";
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'webaccessPicker',
	        resolve: {
	          config: function config() {
	            return {
	              data: that.filteredData,
	              title: title
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (selectedWAIds) {
	        that.WebAccessService.sendInvitations({ ids: selectedWAIds }, function (_) {
	
	          if (that.filter == "no-invite-no-activation") {
	            that.WebAccessService.query(function (data) {
	              that.data = data;
	              that.filterData(that.ViewSelection.selectedCommunityCode);
	              that.setFilter(that.filter);
	            }, function (err) {
	              console.log("Could not retrieve website access.");
	            });
	          }
	        }, function (err) {
	          return console.log(err);
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'getAssociations',
	    value: function getAssociations(wa) {
	      var _this2 = this;
	
	      if (!wa || !wa.associationOrGroupCode) return "-";
	
	      var groupConfig = this.webAccessGroupConfig.find(function (cfg) {
	        return cfg.code == wa.associationOrGroupCode;
	      });
	      var IS_GROUP = !!groupConfig;
	
	      if (IS_GROUP) {
	        if (wa.associations && wa.associations.length) {
	          return wa.associations.map(function (code) {
	            return _this2.communityMap[code];
	          }).join(', ');
	        }
	      } else {
	        return this.communityMap[wa.associationOrGroupCode];
	      }
	    }
	  }, {
	    key: 'getEvoting',
	    value: function getEvoting(wa) {
	      if (!wa || !wa.eVotingCode) return "-";
	
	      return this.communityMap[wa.eVotingCode];
	    }
	  }, {
	    key: 'filterData',
	    value: function filterData(code) {
	      if (code) {
	        this.filteredData = this.data.filter(function (wa) {
	          return wa.associationOrGroupCode == code || wa.associations.includes(code) || wa.eVotingCode == code;
	        });
	      } else {
	        this.filteredData = this.data;
	      }
	
	      this.rawFilteredData = angular.copy(this.filteredData);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(wa) {
	      var that = this;
	
	      var waText = "<br/><br/><b>" + wa.email + "</b><br/><p>" + this.getAssociations(wa) + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Web Access?", "Do you really want to delete this web access?" + waText);
	      dlg.result.then(function () {
	        that.WebAccessService.delete({ id: wa._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== wa._id;
	          });
	          that.filteredData = that.filteredData.filter(function (obj) {
	            return obj._id !== wa._id;
	          });
	        }, function (err) {
	          alert("Could not delete web access");
	        });
	      }, function () {});
	    }
	  }]);
	
	  return WebaccessListComponent;
	}();
	
	exports.default = angular.module('conduu.webaccessList', [uiRouter]).config(_webaccessList2.default).component('webaccessList', {
	  template: __webpack_require__(715),
	  controller: WebaccessListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('webaccess-list', {
	    url: '/webaccess/list',
	    template: '<webaccess-list></webaccess-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <a style=\"float:right; margin-top:4px\" class=\"btn btn-primary\" href=\"/webaccess/edit/\"><i class=\"fa fa-plus\"></i> Create New Web Access</a>\r\n      <h2>Website Access</h2>\r\n      <li class=\"active\"><a href=\"#\">Website Access</a></li>\r\n      <a ng-if=\"ctrl.filter == 'invite-no-activation'\" style=\"float:right; margin-top:-16px\" class=\"btn btn-primary\" ng-click=\"ctrl.openSendInvitationModal(true)\"><i class=\"fa fa-refresh\"></i> Resend Invitation</a>\r\n      <a ng-if=\"ctrl.filter == 'no-invite-no-activation'\" style=\"float:right; margin-top:-16px\" class=\"btn btn-primary\" ng-click=\"ctrl.openSendInvitationModal()\"><i class=\"fa fa-envelope\"></i> Send Invitation</a>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <uib-tabset active=\"ctrl.activeTabIndex\">\r\n        <uib-tab select=\"ctrl.setFilter('all')\">\r\n          <uib-tab-heading><b>All</b> <span class=\"badge\">{{ctrl.getCount('all')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter('active')\">\r\n          <uib-tab-heading><b>Active</b> <span class=\"badge\">{{ctrl.getCount('active')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter('blocked')\">\r\n          <uib-tab-heading><b>Blocked</b> <span class=\"badge\">{{ctrl.getCount('blocked')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter('initial')\">\r\n          <uib-tab-heading><b>Initial</b> <span class=\"badge\">{{ctrl.getCount('initial')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter('invite-no-activation')\">\r\n          <uib-tab-heading><b>Invitation / No Activation</b> <span class=\"badge\">{{ctrl.getCount('invite-no-activation')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter('no-invite-no-activation')\">\r\n          <uib-tab-heading><b>No Invitation / No Activation</b> <span class=\"badge\">{{ctrl.getCount('no-invite-no-activation')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n      </uib-tabset>\r\n\r\n      <br/>\r\n\r\n      <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\"  class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>Website(s)</th>\r\n          <th ng-show=\"ctrl.eVotingEnabled\"><nobr>E-Voting</nobr></th>\r\n          <th>Login</th>\r\n          <th>Contact</th>\r\n          <th ng-show=\"!ctrl.filter || ctrl.filter == 'no-invite-no-activation'\">Creation Date</th>\r\n          <th ng-show=\"ctrl.filter == 'active'\">Last Login Web</th>\r\n          <th ng-show=\"ctrl.filter == 'active'\">Last Login Voting</th>\r\n          <th ng-show=\"ctrl.filter == 'invite-no-activation'\">Last Invitation</th>\r\n          <th></th>\r\n          <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"wa in ctrl.filteredData | orderBy: 'meta.creationDate':true\">\r\n          <td>{{ctrl.getAssociations(wa)}}</td>\r\n          <td ng-show=\"ctrl.eVotingEnabled\">{{ctrl.getEvoting(wa)}}</td>\r\n          <td><a ng-href=\"/webaccess/{{wa._id}}\">{{wa.email}}</a></td>\r\n          <td><a ng-href=\"/contact/{{wa.contact._id}}\" ng-bind-html=\"ctrl.getComposedName(wa.contact)\"></a></td>\r\n          <td ng-show=\"!ctrl.filter || ctrl.filter == 'no-invite-no-activation'\">\r\n            <nobr>{{wa.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td ng-show=\"ctrl.filter == 'active'\">\r\n            <nobr>{{wa.lastLogin | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td ng-show=\"ctrl.filter == 'active'\">\r\n            <nobr>{{wa.lastLoginVoting | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td ng-show=\"ctrl.filter == 'invite-no-activation'\">\r\n            <nobr>{{wa.lastInvite | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td><a class=\"btn btn-sm btn-primary\" ng-href=\"/webaccess/{{wa._id}}\"><i class=\"fa fa-folder-open fa-fw\"></i></a></td>\r\n          <td>\r\n            <nobr>\r\n              <a class=\"btn btn-sm btn-primary\" ng-href=\"/webaccess/edit/{{wa._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n              <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(wa)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n            </nobr>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebaccessEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webaccessEdit = __webpack_require__(717);
	
	var _webaccessEdit2 = _interopRequireDefault(_webaccessEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var WebaccessEditComponent = exports.WebaccessEditComponent = function () {
	  WebaccessEditComponent.$inject = ['Auth', '$state', '$stateParams', 'dialogs', 'WebAccessService', 'SettingsService', '$uibModal', 'User', 'ContactService', 'CustomEntityService', 'CommunityService', 'prompt'];
	  function WebaccessEditComponent(Auth, $state, $stateParams, dialogs, WebAccessService, SettingsService, $uibModal, User, ContactService, CustomEntityService, CommunityService, prompt) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, WebaccessEditComponent);
	
	    this.webaccessId = $stateParams.id;
	
	    this.dialogs = dialogs;
	    this.WebAccessService = WebAccessService;
	    this.SettingsService = SettingsService;
	    this.$uibModal = $uibModal;
	    this.User = User;
	    this.Auth = Auth;
	    this.prompt = prompt;
	
	    this.jsonValue = "";
	    this.users = [];
	    this.$state = $state;
	
	    this.selectedSubs = {};
	
	    this.activationType = "invitation";
	    this.activationTypes = [{
	      type: "initial",
	      name: "Initial Password"
	    }, {
	      type: "invitation",
	      name: "Invitation"
	    }];
	
	    ContactService.query(function (data) {
	      _this.contacts = data.map(function (contact) {
	        contact.value = contact._id;
	        contact.name = _this.getComposedName(contact);
	        return contact;
	      });
	    });
	    this.customEntities = CustomEntityService.query();
	
	    this.model = {};
	
	    SettingsService.getByName({ name: 'client' }, function (clientData) {
	      _this.eVotingEnabled = clientData.data.eVotingEnabled;
	    });
	
	    SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	      _this.webAccessGroupConfig = appSettings.data.webAccessGroupConfig || [];
	
	      CommunityService.query(function (data) {
	        var websites = [];
	        var evotingSites = [];
	
	        _this.subAssociationMap = {};
	
	        _this.webAccessGroupConfig.forEach(function (grp) {
	          _this.subAssociationMap[grp.code] = [];
	          websites.push({
	            type: 'Association Group Sites',
	            code: grp.code,
	            name: grp.name + ' (' + grp.website + ')'
	          });
	        });
	
	        _this.communities = data;
	        data.forEach(function (site) {
	          if (!site.eVoting || !site.eVoting.enabled) return;
	
	          evotingSites.push({
	            code: site.code,
	            name: site.name + ' (' + site.eVoting.url + ')'
	          });
	
	          _this.evotingSites = evotingSites;
	        });
	        data.forEach(function (site) {
	
	          if (!site.webAccess.enabled) return;
	
	          if (site.webAccess.accessGroupCode) {
	            _this.subAssociationMap[site.webAccess.accessGroupCode].push({ code: site.code, name: site.name });
	          } else {
	            websites.push({
	              type: 'Individual Sites',
	              code: site.code,
	              name: site.name + ' (' + site.webAccess.website + ')'
	            });
	          }
	        });
	
	        _this.websites = websites;
	      });
	    });
	
	    if (this.webaccessId) {
	      this.WebAccessService.get({ id: this.webaccessId }, function (data) {
	        _this.model = data;
	
	        if (_this.model.associations) {
	          _this.model.associations.forEach(function (code) {
	            _this.selectedSubs[code] = true;
	          });
	        }
	      }, function (err) {
	        console.log('Could not load webaccess from server');
	      });
	    }
	  }
	
	  _createClass(WebaccessEditComponent, [{
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += " (" + contact.company + ")";
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'updateEmail',
	    value: function updateEmail() {
	      var _this2 = this;
	
	      if (this.model.contact) {
	        var oContact = this.contacts.find(function (o) {
	          return o._id == _this2.model.contact;
	        });
	
	        if (oContact) {
	          var primaryEmail = this.getPrimaryEmail(oContact);
	          if (primaryEmail !== '-') {
	
	            if (!this.model.email || this.model.email == primaryEmail) {
	              this.model.email = primaryEmail;
	            } else {
	
	              this.prompt({
	                "title": "Replace Email?",
	                "message": "The selected contact has another primary email as the one that is currently defined. Do you want to replace the current email?",
	                "buttons": [{
	                  "label": "Cancel",
	                  "cancel": true,
	                  "primary": false
	                }, {
	                  "label": "Yes",
	                  "cancel": false,
	                  "primary": true
	                }]
	              }).then(function (result) {
	                _this2.model.email = primaryEmail;
	              });
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'populateActivationType',
	    value: function populateActivationType() {
	      var _this3 = this;
	
	      if (!this.webaccessId) {
	        var group = this.webAccessGroupConfig.find(function (gc) {
	          return gc.code == _this3.model.associationOrGroupCode;
	        });
	        if (group) {
	          this.model.activationType = group.activationType || 'invitation';
	          this.model.password = group.defaultPassword;
	        } else {
	          var cmty = this.communities.find(function (cmty) {
	            return cmty.code == _this3.model.associationOrGroupCode;
	          });
	          if (cmty) {
	            this.model.activationType = cmty.webAccess.activationType || 'invitation';
	            this.model.password = cmty.webAccess.defaultPassword;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'getPrimaryEmail',
	    value: function getPrimaryEmail(contact) {
	      if (!contact || !contact.email || !contact.email.length) return "-";
	
	      var email = contact.email.find(function (email) {
	        return email.isPrimary;
	      }) || contact.email[0] || { address: '-' };
	
	      return email.address;
	    }
	  }, {
	    key: 'getRolesByCode',
	    value: function getRolesByCode(code) {
	      var selected = this.webAccessGroupConfig.find(function (gc) {
	        return gc.code == code;
	      });
	      if (selected) {
	        return selected.roles;
	      }
	    }
	  }, {
	    key: 'contactLookup',
	    value: function contactLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'contactLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (contact) {
	        that.model.contact = contact._id;
	        that.updateEmail();
	      }, function () {});
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this4 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (!this.model.associationOrGroupCode && !this.model.eVotingCode) {
	        alert('You must choose a website or an e-voting app to grant access to');
	        return;
	      }
	
	      if (this.model.associationOrGroupCode) {
	        var subs = [];
	
	        if (this.subAssociationMap[this.model.associationOrGroupCode]) {
	          subs = this.subAssociationMap[this.model.associationOrGroupCode].filter(function (sub) {
	            return _this4.selectedSubs[sub.code];
	          }).map(function (sub) {
	            return sub.code;
	          });
	        }
	
	        this.model.associations = subs;
	      } else {
	        this.model.associations = [];
	      }
	
	      if (this.model.eVotingCode) {
	        if (!this.model.additionalRoles) this.model.additionalRoles = [];
	
	        if (this.model.additionalRoles.indexOf("evoting-user") === -1) this.model.additionalRoles.push("evoting-user");
	      } else {
	        if (this.model.additionalRoles && Array.isArray(this.model.additionalRoles) && this.model.additionalRoles.indexOf("evoting-user") !== -1) {
	          this.model.additionalRoles = this.model.additionalRoles.filter(function (role) {
	            return role !== "evoting-user";
	          });
	        }
	      }
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var actionString = _this4.webaccessId ? "changed" : "created";
	          var dlg = _this4.dialogs.notify("Success", "The web acccess has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("webaccess-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this4.sendFailure = true;
	        };
	
	        this.model.email = this.model.email.trim().toLowerCase();
	
	        if (this.webaccessId) {
	          this.WebAccessService.update({ id: this.webaccessId }, this.model, onSuccess, onError);
	        } else {
	          this.model.meta = { creationUser: this.Auth.getCurrentUserSync()._id };
	          this.WebAccessService.save(this.model, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return WebaccessEditComponent;
	}();
	
	exports.default = angular.module('conduu.webaccessEdit', [uiRouter]).config(_webaccessEdit2.default).component('webaccessEdit', {
	  template: __webpack_require__(718),
	  controller: WebaccessEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('webaccess-edit', {
	    url: '/webaccess/edit/:id',
	    template: '<webaccess-edit></webaccess-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Web Access Editor</h2>\r\n      <li><a href=\"/webaccess/list\">Web Access</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.contact.$valid && ctrl.submitted,\r\n                                            'has-error': form.contact.$invalid && ctrl.submitted }\">\r\n          <label>Contact</label>\r\n          <br/>\r\n\r\n          <div class=\"input-group\">\r\n            <select class=\"form-control\" ng-options=\"o.value as o.name for o in ctrl.contacts | orderBy:'name'\" ng-model=\"ctrl.model.contact\"\r\n                    name=\"contact\" ng-change=\"ctrl.updateEmail()\" required></select>\r\n            <span class=\"input-group-btn\">\r\n                <a class=\"btn btn-default\" type=\"button\" ng-click=\"ctrl.contactLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\r\n                <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.contact\" ng-click=\"ctrl.model.contact = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n              </span>\r\n          </div>\r\n          <p class=\"help-block\" ng-show=\"form.contact.$error.required && ctrl.submitted\">\r\n            A contact is required\r\n          </p>\r\n        </div>\r\n\r\n        <!-- Email  -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.email.$valid && ctrl.submitted,\r\n                                            'has-error': form.email.$invalid && ctrl.submitted }\">\r\n          <label>Email (as Login)</label>\r\n\r\n          <input type=\"text\" name=\"email\" class=\"form-control\" ng-model=\"ctrl.model.email\"\r\n                 required/>\r\n          <p class=\"help-block\" ng-show=\"form.name.$error.required && ctrl.submitted\">\r\n            An email is required in order to login\r\n          </p>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <div class=\"col-sm-12 col-xs-12 col-md-6 col-lg-6\">\r\n          <div class=\"panel panel-default\">\r\n            <div class=\"panel-heading\">\r\n              <h5 class=\"panel-title\">Website</h5>\r\n            </div>\r\n            <div class=\"panel-body\">\r\n\r\n          <!-- Association Website -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.associationOrGroupCode.$valid && ctrl.submitted,\r\n                                            'has-error': form.associationOrGroupCode.$invalid && ctrl.submitted }\">\r\n\r\n\r\n            <div class=\"input-group\">\r\n              <select name=\"associationOrGroupCode\" ng-options=\"o.code as o.name group by o.type for o in ctrl.websites\"\r\n                      class=\"form-control\" ng-model=\"ctrl.model.associationOrGroupCode\" ng-change=\"ctrl.populateActivationType()\">\r\n              </select>\r\n              <span class=\"input-group-btn\">\r\n              <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.associationOrGroupCode\" ng-click=\"ctrl.model.associationOrGroupCode = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n            </span>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- If Association Group Website: Associations to grant access to (in order to set roles correctly) -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.associationOrGroupCode.$valid && ctrl.submitted,\r\n                                            'has-error': form.associationOrGroupCode.$invalid && ctrl.submitted }\">\r\n            <!-- Associated Community Website -->\r\n            <div class=\"form-group\" ng-repeat=\"sub in ctrl.subAssociationMap[ctrl.model.associationOrGroupCode]\">\r\n              <label class=\"checkbox\" style=\"padding-left:20px\">\r\n                <input type=\"checkbox\" ng-model=\"ctrl.selectedSubs[sub.code]\"/>{{sub.name}}</label>\r\n            </div>\r\n\r\n          </div>\r\n\r\n          <!-- Additional Roles -->\r\n          <div class=\"form-group\" ng-if=\"ctrl.model.associationOrGroupCode\">\r\n            <label>Additional Roles</label>\r\n\r\n            <tags-input use-strings=\"true\" placeholder=\"+ Roles\" ng-model=\"ctrl.model.additionalRoles\"></tags-input>\r\n          </div>\r\n\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"col-sm-12 col-xs-12 col-md-6 col-lg-6\" ng-show=\"ctrl.eVotingEnabled\">\r\n\r\n          <div class=\"panel panel-default\">\r\n            <div class=\"panel-heading\">\r\n              <h5 class=\"panel-title\">E-Voting App</h5>\r\n            </div>\r\n            <div class=\"panel-body\">\r\n\r\n          <!-- E-Voting Access -->\r\n          <div class=\"form-group\" ng-class=\"{ 'has-success': form.eVotingCode.$valid && ctrl.submitted,\r\n                                              'has-error': form.eVotingCode.$invalid && ctrl.submitted }\">\r\n\r\n            <div class=\"input-group\">\r\n              <select name=\"eVotingCode\" ng-options=\"o.code as o.name for o in ctrl.evotingSites\"\r\n                      class=\"form-control\" ng-model=\"ctrl.model.eVotingCode\">\r\n              </select>\r\n              <span class=\"input-group-btn\">\r\n                <a class=\"btn btn-danger\" ng-disabled=\"!ctrl.model.eVotingCode\" ng-click=\"ctrl.model.eVotingCode = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\r\n              </span>\r\n            </div>\r\n          </div>\r\n\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <!-- Activation Type -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.activationType.$valid && ctrl.submitted,\r\n                                            'has-error': form.activationType.$invalid && ctrl.submitted }\">\r\n          <label>Activation Type</label>\r\n\r\n          <select name=\"activationType\" ng-options=\"o.type as o.name for o in ctrl.activationTypes\"\r\n                  class=\"form-control\" ng-model=\"ctrl.model.activationType\" required ng-disabled=\"ctrl.webaccessId\">\r\n          </select>\r\n          <p class=\"help-block\" ng-show=\"form.activationType.$error.required && ctrl.submitted\">\r\n            Activation Type is required\r\n          </p>\r\n        </div>\r\n\r\n        <!-- Initial Password -->\r\n        <div ng-if=\"ctrl.model.activationType == 'initial' && !ctrl.webaccessId\" class=\"form-group\"\r\n             ng-class=\"{ 'has-success': form.password.$valid && ctrl.submitted,\r\n                         'has-error': form.password.$invalid && ctrl.submitted }\">\r\n          <label>Initial Password</label>\r\n\r\n          <input type=\"text\" name=\"password\" class=\"form-control\" ng-model=\"ctrl.model.password\"\r\n                 required/>\r\n          <p class=\"help-block\" ng-show=\"form.password.$error.required && ctrl.submitted\">\r\n            A initial password is required\r\n          </p>\r\n        </div>\r\n\r\n        <br/>\r\n\r\n        <button ng-hide=\"ctrl.webaccessId\" class=\"btn btn-primary\" type=\"submit\">Create Web Access</button>\r\n\r\n        <button ng-show=\"ctrl.webaccessId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"webaccess-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebaccessShowComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webaccessShow = __webpack_require__(720);
	
	var _webaccessShow2 = _interopRequireDefault(_webaccessShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var WebaccessShowComponent = exports.WebaccessShowComponent = function () {
	  WebaccessShowComponent.$inject = ['$stateParams', 'CommunityService', 'WebAccessService', '$uibModal', '$window', 'RecentVisits', 'SettingsService', 'PinnedItems', '$state', 'ContactService'];
	  function WebaccessShowComponent($stateParams, CommunityService, WebAccessService, $uibModal, $window, RecentVisits, SettingsService, PinnedItems, $state, ContactService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, WebaccessShowComponent);
	
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.webaccessId = $stateParams.id;
	    this.$uibModal = $uibModal;
	    this.$state = $state;
	
	    this.WebAccessService = WebAccessService;
	    this.ContactService = ContactService;
	
	    this.RecentVisits = RecentVisits;
	    this.PinnedItems = PinnedItems;
	
	    this.tasks = [];
	    this.activities = [];
	
	    CommunityService.query(function (data) {
	      _this.communities = data;
	      _this.communityMap = {};
	      data.forEach(function (cmty) {
	        return _this.communityMap[cmty.code] = cmty.name;
	      });
	
	      SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	        _this.webAccessGroupConfig = appSettings.data.webAccessGroupConfig || [];
	
	        _this.refreshData();
	      });
	    });
	
	    this.RecentVisits = RecentVisits;
	    this.PinnedItems = PinnedItems;
	  }
	
	  _createClass(WebaccessShowComponent, [{
	    key: 'sendInvitation',
	    value: function sendInvitation() {
	      var _this2 = this;
	
	      this.WebAccessService.sendInvitations({ ids: [this.wa._id] }, function (_) {
	        _this2.refreshData();
	      }, function (err) {
	        return console.log(err);
	      });
	    }
	  }, {
	    key: 'block',
	    value: function block() {
	      var _this3 = this;
	
	      this.WebAccessService.update({ id: this.webaccessId }, {
	        isBlocked: true
	      }, function (_) {
	        _this3.refreshData();
	      }, function (err) {
	        console.log("Could not set to blocked");
	      });
	    }
	  }, {
	    key: 'unblock',
	    value: function unblock() {
	      var _this4 = this;
	
	      this.WebAccessService.update({ id: this.webaccessId }, {
	        isBlocked: false
	      }, function (_) {
	        _this4.refreshData();
	      }, function (err) {
	        console.log("Could not set to unblocked");
	      });
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'webaccessResetPassword',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (password) {
	
	        that.WebAccessService.resetPassword({ id: that.webaccessId }, { password: password }, function (_) {
	          console.log('success');
	        }, function (err) {
	          return console.log(err);
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'getAccessForLabel',
	    value: function getAccessForLabel(wa) {
	      if (!wa) return "";
	
	      var assns = this.getAssociations(wa);
	
	      if (assns && wa.eVotingCode) {
	        return assns + " and E-Voting (" + wa.eVotingCode + ")";
	      } else if (assns) {
	        return assns;
	      } else if (wa.eVotingCode) {
	        return "E-Voting (" + wa.eVotingCode + ")";
	      }
	
	      return "";
	    }
	  }, {
	    key: 'getAssociations',
	    value: function getAssociations(wa) {
	      var _this5 = this;
	
	      if (!wa) return "";
	
	      var groupConfig = this.webAccessGroupConfig.find(function (cfg) {
	        return cfg.code == wa.associationOrGroupCode;
	      });
	      var IS_GROUP = !!groupConfig;
	
	      if (IS_GROUP) {
	        if (wa.associations && wa.associations.length) {
	          return wa.associations.map(function (code) {
	            return _this5.communityMap[code];
	          }).join(', ');
	        }
	      } else {
	        return this.communityMap[wa.associationOrGroupCode];
	      }
	    }
	  }, {
	    key: 'computedRoles',
	    value: function computedRoles(wa) {
	      var _this6 = this;
	
	      if (!wa) return [];
	
	      var _roles = [];
	      var groupConfig = this.webAccessGroupConfig.find(function (cfg) {
	        return cfg.code == wa.associationOrGroupCode;
	      });
	      var IS_GROUP = !!groupConfig;
	
	      if (IS_GROUP) {
	        _roles = _roles.concat(groupConfig.roles);
	
	        wa.associations.forEach(function (code) {
	          var cmty = _this6.communities.find(function (cmty) {
	            return cmty.code == code;
	          });
	          if (cmty && cmty.webAccess.enabled) {
	            if (wa.contact) _roles = _roles.concat(cmty.webAccess.ownerAddRoles);
	          }
	        });
	      } else {
	        _roles = _roles.concat();
	
	        var cmty = this.communities.find(function (cmty) {
	          return cmty.code == wa.associationOrGroupCode;
	        });
	        if (cmty && cmty.webAccess.enabled) {
	          _roles = _roles.concat(cmty.webAccess.defaultRoles);
	
	          if (wa.contact) _roles = _roles.concat(cmty.webAccess.ownerAddRoles);
	        }
	      }
	
	      if (wa.additionalRoles) _roles = _roles.concat(wa.additionalRoles);
	
	      return [].concat(_toConsumableArray(new Set(_roles)));
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData() {
	      var _this7 = this;
	
	      if (this.webaccessId) {
	        this.WebAccessService.get({ id: this.webaccessId }, function (data) {
	          _this7.wa = data;
	
	          if (_this7.wa.contact) {
	            _this7.ContactService.get({ id: _this7.wa.contact }, function (contact) {
	              _this7.wa.contact = contact;
	            });
	          }
	
	          _this7.RecentVisits.addPortfolio(_this7.webaccessId, "webaccess", '' + _this7.wa.email);
	          _this7.isPinned = _this7.PinnedItems.isPinnedPortfolio(_this7.webaccessId);
	        }, function (err) {
	          console.log('Could not load violation ticket from server');
	        });
	      }
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += "<br/>" + contact.company;
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (resultIds) {
	        that.WebAccessService.addAttachments({ id: that.communityId }, resultIds, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not add attachments to ticket');
	        });
	      }, function () {});
	    }
	  }]);
	
	  return WebaccessShowComponent;
	}();
	
	exports.default = angular.module('conduu.webaccessShow', [uiRouter]).config(_webaccessShow2.default).component('webaccessShow', {
	  template: __webpack_require__(721),
	  controller: WebaccessShowComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('webaccess-show', {
	    url: '/webaccess/:id',
	    template: '<webaccess-show></webaccess-show>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>\r\n        <i ng-if=\"ctrl.wa.isBlocked\" class=\"fa fa-2x fa-fw fa-ban text-danger pull-right\"></i>\r\n        {{ctrl.wa.email}} <small>for {{ctrl.getAccessForLabel(ctrl.wa)}}</small>\r\n      </h2>\r\n      <li><a href=\"/webaccess/list\">Web Access</a></li>\r\n      <li class=\"active\"><a href=\"#\">{{ctrl.wa.email}} for {{ctrl.getAssociations(ctrl.wa)}}</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-md-6\">\r\n      <h3 style=\"margin-top: 0\" class=\"separator\"><span>General</span></h3>\r\n      <dl class=\"dl-horizontal\">\r\n        <dt>Email (Login)</dt>\r\n        <dd>{{ctrl.wa.email}}</dd>\r\n\r\n        <dt ng-if=\"ctrl.wa.contact\">Contact</dt>\r\n        <dd ng-if=\"ctrl.wa.contact\" ng-bind-html=\"ctrl.getComposedName(ctrl.wa.contact)\"></dd>\r\n      </dl>\r\n\r\n      <h3 style=\"margin-top: 0\" class=\"separator\"><span>Login Info</span></h3>\r\n      <dl class=\"dl-horizontal\">\r\n        <dt ng-if=\"ctrl.getAssociations(ctrl.wa)\">Last Login Web</dt>\r\n        <dd ng-if=\"ctrl.getAssociations(ctrl.wa) && ctrl.wa.lastLogin\">{{ctrl.wa.lastLogin | date:'medium'}}</dd>\r\n        <dd ng-if=\"ctrl.getAssociations(ctrl.wa) && !ctrl.wa.lastLogin\">-</dd>\r\n\r\n        <dt ng-if=\"ctrl.wa.eVotingCode\">Last Login E-Voting</dt>\r\n        <dd ng-if=\"ctrl.wa.eVotingCode && ctrl.wa.lastLoginVoting\">{{ctrl.wa.lastLoginVoting | date:'medium'}}</dd>\r\n        <dd ng-if=\"ctrl.wa.eVotingCode && !ctrl.wa.lastLoginVoting\">-</dd>\r\n\r\n        <dt ng-show=\"ctrl.wa.activationType == 'invitation'\">Last Invite Date</dt>\r\n        <dd ng-show=\"ctrl.wa.activationType == 'invitation' && ctrl.wa.lastInvite\">{{ctrl.wa.lastInvite | date:'medium'}}</dd>\r\n        <dd ng-show=\"ctrl.wa.activationType == 'invitation' && !ctrl.wa.lastInvite\">-</dd>\r\n\r\n        <dt ng-show=\"ctrl.wa.activationType == 'invitation'\">Account Activated</dt>\r\n        <dd ng-show=\"ctrl.wa.activationType == 'invitation' && ctrl.wa.accountActivated\">{{ctrl.wa.accountActivated | date:'medium'}}</dd>\r\n        <dd ng-show=\"ctrl.wa.activationType == 'invitation' && !ctrl.wa.accountActivated\">-</dd>\r\n      </dl>\r\n    </div>\r\n\r\n    <div class=\"col-md-6\">\r\n      <h3 style=\"margin-top: 0\" class=\"separator\"><span>Access</span></h3>\r\n      <dl class=\"dl-horizontal\">\r\n        <dt ng-if=\"ctrl.getAssociations(ctrl.wa)\">Association(s)</dt>\r\n        <dd ng-if=\"ctrl.getAssociations(ctrl.wa)\">{{ctrl.getAssociations(ctrl.wa)}}</dd>\r\n\r\n        <dt ng-if=\"ctrl.wa.eVotingCode\">E-Voting</dt>\r\n        <dd ng-if=\"ctrl.wa.eVotingCode\">{{ctrl.wa.eVotingCode}}</dd>\r\n\r\n        <dt>Roles</dt>\r\n        <dd><span ng-repeat=\"role in ctrl.computedRoles(ctrl.wa)\" class=\"badge\">{{role}}</span></dd>\r\n\r\n        <dt>Access</dt>\r\n        <dd ng-hide=\"ctrl.wa.isBlocked\"><i class=\"fa fa-fw fa-check text-success\"></i> Granted</dd>\r\n        <dd ng-show=\"ctrl.wa.isBlocked\"><i class=\"fa fa-fw fa-ban text-danger\"></i> Blocked</dd>\r\n      </dl>\r\n\r\n      <h3 style=\"margin-top: 0\" class=\"separator\"><span>Actions</span></h3>\r\n      <dl class=\"dl-horizontal\">\r\n        <dt>Access</dt>\r\n        <dd ng-hide=\"ctrl.wa.isBlocked\">\r\n          <button class=\"btn btn-warning btn-sm\" ng-click=\"ctrl.block()\"><i class=\"fa fa-fw fa-ban\"></i> Block Web Access</button>\r\n        </dd>\r\n        <dd ng-show=\"ctrl.wa.isBlocked\">\r\n          <button class=\"btn btn-warning btn-sm\" ng-click=\"ctrl.unblock()\"><i class=\"fa fa-fw fa-check\"></i> Grant Web Access</button>\r\n        </dd>\r\n        <dt>Password</dt>\r\n        <dd>\r\n          <button ng-disabled=\"ctrl.wa.isBlocked\" class=\"btn btn-primary btn-sm\" ng-click=\"ctrl.resetPassword()\"><i class=\"fa fa-fw fa-unlock-alt\"></i> Reset Password</button>\r\n        </dd>\r\n        <dt ng-hide=\"ctrl.wa.accountActivated || ctrl.wa.activationType != 'invitation'\">Invitation</dt>\r\n        <dd ng-hide=\"ctrl.wa.accountActivated || ctrl.wa.activationType != 'invitation'\">\r\n          <button ng-if=\"!ctrl.wa.lastInvite && !(ctrl.wa.lastLogin || ctrl.wa.accountActivated) && ctrl.wa.activationType == 'invitation' && !ctrl.wa.isBlocked\" class=\"btn btn-primary btn-sm\" ng-click=\"ctrl.sendInvitation()\"><i class=\"fa fa-fw fa-envelope\"></i> Send Invitation</button>\r\n          <button ng-if=\"ctrl.wa.lastInvite && !(ctrl.wa.lastLogin || ctrl.wa.accountActivated) && ctrl.wa.activationType == 'invitation' && !ctrl.wa.isBlocked\" class=\"btn btn-primary btn-sm\" ng-click=\"ctrl.sendInvitation()\"><i class=\"fa fa-fw fa-refresh\"></i> Resend Invitation</button>\r\n        </dd>\r\n      </dl>\r\n    </div>\r\n\r\n    <div style=\"clear: both\"></div>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <nta-section context=\"webaccess\" context-id=\"ctrl.webaccessId\" data=\"ctrl.wa\" service=\"ctrl.WebAccessService\" on-refresh=\"ctrl.refreshData()\"></nta-section>\r\n\r\n      <h3 class=\"separator\"><span>Attachments <small><a href=\"#\" ng-click=\"ctrl.openAssetUploadModal()\"><i class=\"fa fa-upload\"></i> Upload Files</a></small></span></h3>\r\n\r\n      <attachment-list attachments=\"ctrl.wa.attachments\" context-id=\"ctrl.webaccessId\" service=\"ctrl.WebAccessService\"></attachment-list>\r\n\r\n      <br/>\r\n\r\n      <div style=\"float:right\" >\r\n        <label>{{ctrl.isPinned ? 'Pinned' : \"Not Pinned\"}}&nbsp;</label> <toggle ng-model=\"ctrl.isPinned\" ng-change=\"ctrl.PinnedItems.togglePortfolio(ctrl.webaccessId, 'webaccess', ctrl.wa.email)\" on=\"<i class='fa fa-fw fa-map-pin'>\" off=\"<i class='fa fa-fw fa-times'>\" onstyle=\"btn-success\" offstyle=\"btn-default\"></toggle>\r\n      </div>\r\n      <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	WebAccessService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebAccessService = WebAccessService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function WebAccessService($resource) {
	  return $resource('/api/webaccess/:id', {
	    id: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	    },
	    patch: {
	      method: 'PATCH'
	    },
	    addAttachments: {
	      method: 'PUT',
	      url: "/api/webaccess/:id/attachments"
	    },
	    getByContact: {
	      method: 'GET',
	      url: "/api/webaccess/by-contact/:contactId",
	      isArray: true
	    },
	    resetPassword: {
	      method: 'PUT',
	      url: "/api/webaccess/reset-password/:id"
	    },
	    sendInvitations: {
	      method: 'POST',
	      url: "/api/webaccess/send-invitations"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.WebAccessService', []).factory('WebAccessService', WebAccessService).name;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var webaccessResetPasswordComponent = exports.webaccessResetPasswordComponent = function () {
	  /*@ngInject*/
	  webaccessResetPasswordComponent.$inject = ['WebAccessService'];
	  function webaccessResetPasswordComponent(WebAccessService) {
	    _classCallCheck(this, webaccessResetPasswordComponent);
	
	    this.$onInit = function () {};
	  }
	
	  _createClass(webaccessResetPasswordComponent, [{
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.password });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return webaccessResetPasswordComponent;
	}();
	
	exports.default = angular.module('conduu.webaccessResetPassword', []).component('webaccessResetPassword', {
	  template: __webpack_require__(724),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: webaccessResetPasswordComponent
	}).name;

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\"><i class=\"fa fa-fw fa-unlock-alt\"></i> Password Reset</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n\r\n  <div class=\"bs-callout bs-callout-warning\">\r\n    <h4><i class=\"fa fa-fw fa-warning\"></i> Reset Password Warning</h4>\r\n    When you reset the password the user will not longer be able to login with his current password.\r\n  </div>\r\n\r\n  <!-- Reset Password -->\r\n  <div class=\"form-group\">\r\n    <label class=\"checkbox\" style=\"padding-left:20px\">\r\n      <input type=\"checkbox\" ng-model=\"$ctrl.resetPassword\"/> Reset the user's password</label>\r\n  </div>\r\n\r\n  <!-- New Password -->\r\n  <div ng-if=\"$ctrl.resetPassword\"\r\n       class=\"form-group\" ng-class=\"{ 'has-success': form.password.$valid && ctrl.submitted,\r\n                                            'has-error': form.password.$invalid && ctrl.submitted }\">\r\n    <label>New Password</label>\r\n\r\n    <input type=\"text\" name=\"password\" class=\"form-control\" ng-model=\"$ctrl.password\"\r\n           required/>\r\n    <p class=\"help-block\" ng-show=\"form.password.$error.required && ctrl.submitted\">\r\n      The new password is required\r\n    </p>\r\n  </div>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!$ctrl.password\" ng-click=\"$ctrl.ok()\">Reset Password</button>\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var WebaccessPickerComponent = exports.WebaccessPickerComponent = function () {
	  /*@ngInject*/
	  function WebaccessPickerComponent() {
	    _classCallCheck(this, WebaccessPickerComponent);
	
	    this.selected = {};
	  }
	
	  _createClass(WebaccessPickerComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.config = this.resolve.config;
	      this.data = this.config.data;
	      this.title = this.config.title || 'Web Access Select';
	
	      this.checkAll();
	    }
	  }, {
	    key: 'checkAll',
	    value: function checkAll() {
	      var _this = this;
	
	      this.data.forEach(function (wa) {
	        return _this.selected[wa._id] = true;
	      });
	    }
	  }, {
	    key: 'uncheckAll',
	    value: function uncheckAll() {
	      var _this2 = this;
	
	      this.data.forEach(function (wa) {
	        return _this2.selected[wa._id] = false;
	      });
	    }
	  }, {
	    key: 'getSelectedCount',
	    value: function getSelectedCount() {
	      var _this3 = this;
	
	      return this.data.filter(function (wa) {
	        return _this3.selected[wa._id];
	      }).map(function (wa) {
	        return wa._id;
	      }).length;
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this4 = this;
	
	      var selectedData = this.data.filter(function (wa) {
	        return _this4.selected[wa._id];
	      }).map(function (wa) {
	        return wa._id;
	      });
	      this.close({ $value: selectedData });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return WebaccessPickerComponent;
	}();
	
	exports.default = angular.module('conduu.webaccessPicker', []).component('webaccessPicker', {
	  template: __webpack_require__(726),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: WebaccessPickerComponent
	}).name;

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">{{$ctrl.title}}</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <table datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n    <thead>\r\n    <tr>\r\n      <th></th>\r\n      <th>Login</th>\r\n      <th>Contact</th>\r\n      <th>Association</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-repeat=\"wa in $ctrl.data | orderBy: 'meta.creationDate':true\">\r\n      <td><input type=\"checkbox\" ng-model=\"$ctrl.selected[wa._id]\"></td>\r\n      <td>{{wa.email}}</td>\r\n      <td>\r\n        <span ng-if=\"wa.contact.lastName && !wa.contact.company\">{{wa.contact.lastName}}, {{wa.contact.firstName}} {{wa.contact.middleName || ''}}</span>\r\n        <span ng-if=\"!wa.contact.lastName && wa.contact.company\">{{wa.contact.company}}</span>\r\n        <span ng-if=\"wa.contact.lastName && wa.contact.company\">{{wa.contact.lastName}}, {{wa.contact.firstName}} {{wa.contact.middleName || ''}}<br/>{{wa.contact.company}}</span>\r\n      </td>\r\n      <td>\r\n        <span ng-show=\"wa.associations.length\">{{wa.associations.join(', ')}}</span>\r\n        <span ng-hide=\"wa.associations.length\">{{wa.associationOrGroupCode}}</span>\r\n      </td>\r\n    </tr>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <div style=\"float:left; text-align: left\">\r\n    <span>{{$ctrl.getSelectedCount()}} Entries selected</span><br/>\r\n    <a style=\"cursor: pointer; text-decoration: none\" ng-click=\"$ctrl.checkAll()\"><i class=\"fa fa-fw fa-check-square-o\"></i> Check All</a> | <a style=\"cursor: pointer; text-decoration: none\" ng-click=\"$ctrl.uncheckAll()\"><i class=\"fa fa-fw fa-times\"></i> Uncheck All</a>\r\n  </div>\r\n  <button class=\"btn btn-primary\" ng-disabled=\"!$ctrl.getSelectedCount()\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LdapDBComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ldapDb = __webpack_require__(728);
	
	var _ldapDb2 = _interopRequireDefault(_ldapDb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var LdapDBComponent = exports.LdapDBComponent = function () {
	  LdapDBComponent.$inject = ['SettingsService', 'Auth', '$state', 'dialogs', '$http'];
	  function LdapDBComponent(SettingsService, Auth, $state, dialogs, $http) {
	    'ngInject';
	
	    _classCallCheck(this, LdapDBComponent);
	
	    this.SettingsService = SettingsService;
	    this.dialogs = dialogs;
	    this.$state = $state;
	    this.$http = $http;
	
	    this.search = "";
	
	    this.ldapdb = SettingsService.getLDAPDB();
	
	    this.treeOptions = {
	      nodeChildren: "sub",
	      dirSelectable: true,
	      injectClasses: {
	        ul: "a1",
	        li: "a2",
	        liSelected: "a7",
	        iExpanded: "a3",
	        iCollapsed: "a4",
	        iLeaf: "a5",
	        label: "a6",
	        labelSelected: "a8"
	      }
	    };
	
	    this.tselected = [];
	    this.toptions = [{
	      id: 1,
	      name: "Option 1"
	    }, {
	      id: 2,
	      name: "Option 2"
	    }, {
	      id: 3,
	      name: "Option 3"
	    }];
	  }
	
	  _createClass(LdapDBComponent, [{
	    key: 'applySearch',
	    value: function applySearch() {
	
	      var SEARCH = this.search.toLowerCase();
	
	      var TREE = angular.copy(this.data);
	
	      var rFn = function rFn(node, search, folderHit) {
	        var found = node.entry.toLowerCase().indexOf(search) !== -1;
	
	        node.visible = found;
	
	        var subFound = !!folderHit;
	
	        var parentFolderHit = found || folderHit;
	
	        if (node.sub.length) {
	          for (var i = 0; i < node.sub.length; i++) {
	            var ret = rFn(node.sub[i], search, parentFolderHit);
	
	            if (ret) subFound = true;
	          }
	        }
	
	        var retVal = found || subFound;
	
	        if (retVal) node.visible = true;
	
	        return retVal;
	      };
	
	      TREE.forEach(function (mainCat) {
	        return rFn(mainCat, SEARCH);
	      });
	
	      var newTree = [];
	      var pFn = function pFn(node, o, root) {
	
	        if (node.visible) {
	
	          o.push({
	            entry: node.entry,
	            fields: node.fields,
	            json: node.json,
	            data: node.data,
	            sub: []
	          });
	
	          node.sub.forEach(function (child) {
	            return pFn(child, o[o.length - 1].sub, false);
	          });
	        }
	      };
	
	      TREE.forEach(function (rootNode) {
	        return pFn(rootNode, newTree, true);
	      });
	
	      this.filteredData = newTree;
	    }
	  }, {
	    key: 'resetSearch',
	    value: function resetSearch() {
	      this.search = '';
	      this.applySearch();
	    }
	  }, {
	    key: 'applyFilter',
	    value: function applyFilter() {
	      var _this = this;
	
	      var keys = Object.keys(this.ldapdb);
	      var filteredKeys = keys.filter(function (key) {
	        return key.includes(_this.filter);
	      });
	
	      var _data = [{
	        "entry": "o=conduu",
	        "sub": [{
	          "entry": "ou=users, o=conduu",
	          "sub": []
	        }, {
	          "entry": "ou=directory, o=conduu",
	          "sub": []
	        }, {
	          "entry": "ou=webaccess, o=conduu",
	          "sub": []
	        }, {
	          "entry": "ou=quickbooks, o=conduu",
	          "sub": []
	        }, {
	          "entry": "ou=recipientLists, o=conduu",
	          "sub": []
	        }, {
	          "entry": "ou=connectedAccounts, o=conduu",
	          "sub": []
	        }, {
	          "entry": "ou=evotingProperties, o=conduu",
	          "sub": []
	        }, {
	          "entry": "ou=contactProperties, o=conduu",
	          "sub": []
	        }, {
	          "entry": "ou=voterGroups, o=conduu",
	          "sub": []
	        }, {
	          "entry": "ou=evotingAccess, o=conduu",
	          "sub": []
	        }, {
	          "entry": "ou=contact, o=conduu",
	          "sub": []
	        }]
	      }];
	
	      filteredKeys.forEach(function (cn) {
	        try {
	          var splittedCN = cn.split(", ");
	
	          if (splittedCN.length < 3) return;
	
	          var folder = [splittedCN[1], splittedCN[2]].join(", ");
	          var idx = _data[0].sub.findIndex(function (o) {
	            return o.entry == folder;
	          });
	
	          var item = _this.ldapdb[cn];
	          var fJson = null;
	          var fData = null;
	
	          if (item.json) {
	            fJson = JSON.parse(item.json);
	            delete item.json;
	
	            if (fJson.password) {
	              fJson.password = "***";
	            }
	          }
	
	          if (item.data) {
	            fData = JSON.parse(item.data);
	            delete item.data;
	
	            if (fData.password) {
	              fData.password = "***";
	            }
	          }
	
	          if (item.userPassword) {
	            item.userPassword = "***";
	          }
	
	          _data[0].sub[idx].sub.push({
	            entry: splittedCN[0],
	            fields: item,
	            json: fJson,
	            data: fData,
	            sub: []
	          });
	        } catch (err) {
	          console.log(cn);
	          console.log(err);
	        }
	      });
	
	      this.data = _data;
	      this.applySearch();
	    }
	  }, {
	    key: 'showSelected',
	    value: function showSelected(node) {
	      this.activeTab = 0;
	    }
	  }, {
	    key: 'rebuild',
	    value: function rebuild() {
	      this.SettingsService.rebuildLDAPB();
	    }
	  }, {
	    key: 'testEmail',
	    value: function testEmail() {
	      this.$http({
	        method: 'GET',
	        url: '/api/integrations/test-mail/' + this.email
	      }).then(function (res) {});
	    }
	  }]);
	
	  return LdapDBComponent;
	}();
	
	exports.default = angular.module('conduu.ldapDb', [uiRouter]).config(_ldapDb2.default).component('ldapDb', {
	  template: __webpack_require__(729),
	  controller: LdapDBComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('ldap-db', {
	    url: '/admin/ldap-db',
	    template: '<ldap-db></ldap-db>',
	    authenticate: 'suite-superadmin'
	  });
	}];

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <button class=\"btn btn-warning pull-right\" style=\"margin-top:12px\" ng-click=\"ctrl.rebuild()\"><i class=\"fa fa-fw fa-refresh\"></i> Rebuild DB</button>\r\n      <h2>LDAP DB</h2>\r\n      <li class=\"active\"><a href=\"#\">LDAP DB</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-6\">\r\n      <form class=\"form-inline\">\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.filter\" />\r\n        <button class=\"btn btn-warning\" ng-click=\"ctrl.applyFilter()\"><i class=\"fa fa-fw fa-search\"></i> Find</button>\r\n      </form>\r\n    </div>\r\n\r\n    <div class=\"col-xs-6\">\r\n      <form class=\"form-inline pull-right\">\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.email\" />\r\n        <button class=\"btn btn-warning\" ng-click=\"ctrl.testEmail()\"><i class=\"fa fa-fw fa-envelope\"></i> Send Test Mail</button>\r\n      </form>\r\n    </div>\r\n    \r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <div class=\"row\" ng-if=\"ctrl.data\">\r\n        <hr>\r\n        <div class=\"col-xs-5\">\r\n          <form class=\"form-inline\">\r\n            <div class=\"form-group\">\r\n              <label for=\"filter\">Search&nbsp;&nbsp;</label>\r\n              <div class=\"input-group\">\r\n                <input id=\"filter\" type=\"text\" class=\"form-control input-sm\" ng-model=\"ctrl.search\" ng-change=\"ctrl.applySearch()\" />\r\n                <span class=\"input-group-btn\" ng-if=\"ctrl.search\">\r\n            <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"ctrl.resetSearch()\"><i class=\"fa fa-fw fa-times\"></i></button>\r\n          </span>\r\n              </div>\r\n            </div>\r\n          </form>\r\n\r\n          <br>\r\n          <span ng-hide=\"ctrl.filteredData.length\">There are no results.</span>\r\n\r\n          <treecontrol class=\"tree-boot\"\r\n                       tree-model=\"ctrl.filteredData\"\r\n                       options=\"ctrl.treeOptions\"\r\n                       on-selection=\"ctrl.showSelected(node)\"\r\n                       selected-node=\"ctrl.node\">\r\n            <span>{{node.entry}}</span>\r\n            <span class=\"badge pull-right\" style=\"position: absolute;right: 0px;\" ng-if=\"node.sub.length\" ng-show=\"node.sub\">{{node.sub.length}}</span>\r\n            <span class=\"badge pull-right\" style=\"position: absolute;right: 0px;background-color: #999999\" ng-if=\"node.sub.length\" ng-hide=\"node.sub\">0</span>\r\n          </treecontrol>\r\n        </div>\r\n        <div class=\"col-sm-7\" ng-if=\"ctrl.node\" style=\"float:right\">\r\n\r\n          <uib-tabset active=\"ctrl.activeTab\">\r\n            <uib-tab index=\"0\" heading=\"Fields\">\r\n              <div style=\"height: 2px\"></div>\r\n              <json-view value=\"ctrl.node.fields\"></json-view>\r\n            </uib-tab>\r\n            <uib-tab index=\"1\" heading=\"JSON\" ng-if=\"ctrl.node.json\">\r\n              <div style=\"height: 2px\"></div>\r\n              <json-view value=\"ctrl.node.json\"></json-view>\r\n            </uib-tab>\r\n            <uib-tab index=\"2\" heading=\"Data\" ng-if=\"ctrl.node.data\">\r\n              <div style=\"height: 2px\"></div>\r\n              <json-view value=\"ctrl.node.data\"></json-view>\r\n            </uib-tab>\r\n          </uib-tabset>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuickbooksImportComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quickbooksImport = __webpack_require__(731);
	
	var _quickbooksImport2 = _interopRequireDefault(_quickbooksImport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var QuickbooksImportComponent = exports.QuickbooksImportComponent = function () {
	  QuickbooksImportComponent.$inject = ['QuickbooksImportService', 'PropertyService', 'CommunityService', 'Upload', '$scope', '$timeout'];
	  function QuickbooksImportComponent(QuickbooksImportService, PropertyService, CommunityService, Upload, $scope, $timeout) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, QuickbooksImportComponent);
	
	    this.QuickbooksImportService = QuickbooksImportService;
	    this.PropertyService = PropertyService;
	    this.Upload = Upload;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	
	    this.importProgress = 0;
	    this.progressType = "primary";
	
	    this.mapByOwner = {};
	    this.mapTotalByOwner = {};
	    this.mapOwnerChecked = {};
	    this.mapContactId = {};
	    this.mapQuickbooksNameContactId = {};
	
	    this.countEntries = 0;
	    this.countChecks = 0;
	
	    this.contacts = [];
	    this.unassignedContacts = [];
	
	    CommunityService.query(function (data) {
	      _this.communities = data.map(function (community) {
	        return {
	          value: community._id,
	          name: community.name
	        };
	      });
	    });
	
	    this.data = [];
	    this.owners = [];
	  }
	
	  _createClass(QuickbooksImportComponent, [{
	    key: 'doAnalyze',
	    value: function doAnalyze() {
	      var _this2 = this;
	
	      var currentOwner = null;
	
	      var HEADER = { "Transaction type": null, "Date": null, "Amount": null, "Balance": null, "Open balance": null };
	
	      var headerIdx = -1;
	      var HEADER_FIND_ARR = Object.keys(HEADER);
	      for (var i = 0; i <= this.data.length; i++) {
	        if (this.data[i] && this.data[i].some(function (col) {
	          return HEADER_FIND_ARR.includes(col);
	        })) {
	          headerIdx = i;
	          console.log("Header row found at " + headerIdx);
	          break;
	        }
	      }
	
	      if (headerIdx === -1) {
	        alert('This file does not meet the requirements for data import: No header row found');
	        return;
	      }
	
	      for (var _i = 0; _i <= this.data[headerIdx].length; _i++) {
	        if (this.data[headerIdx][_i]) {
	          HEADER[this.data[headerIdx][_i]] = _i;
	        }
	      }
	
	      for (var idx in HEADER) {
	        if (!HEADER[idx]) {
	
	          console.log(HEADER);
	
	          alert('This file does not meet the requirements for data import: Type, Date, Account, Amount and Balance required');
	          return;
	        }
	      }
	
	      var currentAccount = "";
	
	      this.data.forEach(function (entry, idx) {
	
	        if (idx <= headerIdx) {
	          console.log("Ignoring row " + idx);
	          return;
	        }
	
	        try {
	          if (!entry.length || entry[HEADER["Transaction Type"]] == "Transaction Type" || entry[0] == "TOTAL") return;
	
	          if (entry[0] && !entry[0].startsWith('Total')) {
	            if (entry[0] == 'zz Accounting use only') {
	              currentOwner = 'zz Accounting use only';
	            } else {
	              currentOwner = entry[0].trim();
	
	              currentAccount = "Accounts Receivable";
	
	              if (currentOwner.toLowerCase().startsWith("sa ")) {
	                currentOwner = currentOwner.substring(3);
	                currentAccount = "Special Assessment";
	              }
	
	              if (!_this2.mapByOwner[currentOwner]) {
	                _this2.mapByOwner[currentOwner] = [];
	              }
	            }
	            return;
	          } else if (entry[0] && currentOwner != 'zz Accounting use only') {
	            _this2.mapTotalByOwner[currentOwner] = entry[HEADER["Open Balance"]];
	            _this2.mapOwnerChecked[currentOwner] = true;
	            return;
	          }
	
	          if (currentOwner == 'zz Accounting use only' || entry[HEADER["Date"]] == 'TOTAL') return;
	
	          _this2.mapByOwner[currentOwner].push({
	            "type": entry[HEADER["Transaction Type"]],
	            "date": entry[HEADER["Date"]],
	            "num": HEADER["Num"] ? entry[HEADER["Num"]] : entry[8],
	            "account": currentAccount,
	            "amount": parseFloat(entry[HEADER["Amount"]]) || 0,
	            "balance": parseFloat(entry[HEADER["Balance"]]),
	            "name": currentOwner,
	            "meta": { active: true }
	          });
	        } catch (e) {
	          console.log(e);
	        }
	      });
	
	      this.owners = Object.keys(this.mapTotalByOwner);
	      this.updateMappingInfo();
	      this.$scope.$apply();
	    }
	  }, {
	    key: 'getContactById',
	    value: function getContactById(id) {
	      var contact = this.contacts.find(function (o) {
	        return o.id == id;
	      });
	      if (contact) {
	        return contact.name;
	      }
	    }
	  }, {
	    key: 'updateMappingInfo',
	    value: function updateMappingInfo(owner, removed) {
	      var _this3 = this;
	
	      this.dirty = true;
	      var contactId = this.mapContactId[owner];
	      var contact = this.contacts.find(function (o) {
	        return o.id == contactId;
	      });
	      if (contact) {
	        contact.state = removed ? "Unassigned" : "Assigned";
	      }
	      this.unassignedContacts = this.contacts.filter(function (contact) {
	        return contact.state == "Unassigned";
	      });
	      this.$timeout(function (_) {
	        _this3.dirty = false;
	      }, 0);
	    }
	  }, {
	    key: 'prevent',
	    value: function prevent(e) {
	      e.stopPropagation();
	      e.preventDefault();
	    }
	  }, {
	    key: 'getCheckCount',
	    value: function getCheckCount() {}
	  }, {
	    key: 'getEntryCount',
	    value: function getEntryCount() {}
	  }, {
	    key: 'import',
	    value: function _import() {
	      var _this4 = this;
	
	      this.owners.forEach(function (owner) {
	        _this4.mapByOwner[owner].forEach(function (entry) {
	          entry.community = _this4.selectedCommunityId;
	        });
	
	        if (_this4.mapContactId[owner]) {
	          _this4.mapByOwner[owner].forEach(function (entry) {
	            entry.property = _this4.mapContactId[owner];
	          });
	        }
	      });
	
	      var datasets = this.owners.filter(function (owner) {
	        return _this4.mapOwnerChecked[owner];
	      });
	      var count = 0;
	      datasets.forEach(function (dataset) {
	        _this4.QuickbooksImportService.createBulk({ name: dataset, communityId: _this4.selectedCommunityId }, _this4.mapByOwner[dataset], function (success) {
	          count++;
	          if (count == datasets.length) {
	            _this4.progressType = "success";
	            _this4.importProgress = 100;
	          } else {
	            _this4.importProgress = count / datasets.length;
	          }
	        }, function (err) {
	          _this4.progressType = "danger";
	          console.log(err);
	        });
	      });
	    }
	  }, {
	    key: 'analyze',
	    value: function analyze(file) {
	      var _this5 = this;
	
	      var reader = new FileReader();
	      reader.onload = function (e) {
	        var data = e.target.result;
	        var workbook = XLSX.read(data, { type: 'binary', cellDates: true });
	
	        var sheetKeys = Object.keys(workbook.Sheets);
	        _this5.data = XLSX.utils.sheet_to_json(workbook.Sheets[sheetKeys[0]], { header: 1 });
	
	        _this5.doAnalyze();
	      };
	      reader.readAsBinaryString(file);
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += " (" + contact.company + ")";
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'changeCommunitySelection',
	    value: function changeCommunitySelection() {
	      var _this6 = this;
	
	      this.contacts = [];
	      this.mapContactId = {};
	      this.mapQuickbooksNameContactId = {};
	
	      this.PropertyService.getByCommunity({ communityId: this.selectedCommunityId }, function (data) {
	        data.forEach(function (property) {
	          property.contacts.filter(function (contact) {
	            return contact.type == "primary-owner" && contact.contact && contact.contact._id;
	          }).map(function (contact) {
	            return {
	              'id': property._id,
	              'name': property.lotNo + " - " + _this6.getComposedName(contact.contact),
	              'quickbooksName': property.customFields && property.customFields.quickbooksName ? property.customFields.quickbooksName : ''
	            };
	          }).forEach(function (contact) {
	            if (contact.quickbooksName) {
	              _this6.mapQuickbooksNameContactId[contact.quickbooksName] = contact.id;
	            }
	
	            contact.state = "Unassigned";
	            _this6.contacts.push(contact);
	          });
	
	          _this6.owners.forEach(function (owner) {
	            if (_this6.mapQuickbooksNameContactId[owner]) {
	              _this6.mapContactId[owner] = _this6.mapQuickbooksNameContactId[owner];
	
	              var contactId = _this6.mapContactId[owner];
	              var contact = _this6.contacts.find(function (o) {
	                return o.id == contactId;
	              });
	              if (contact) {
	                contact.state = "Assigned";
	              }
	            }
	          });
	
	          _this6.unassignedContacts = _this6.contacts.filter(function (contact) {
	            return contact.state == "Unassigned";
	          });
	        });
	      }, function (_err) {
	        console.log(_err);
	      });
	    }
	  }]);
	
	  return QuickbooksImportComponent;
	}();
	
	exports.default = angular.module('conduu.quickbooksImport', [uiRouter]).config(_quickbooksImport2.default).component('quickbooksImport', {
	  template: __webpack_require__(732),
	  controller: QuickbooksImportComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('quickbooks-import', {
	    url: '/admin/import/quickbooks',
	    template: '<quickbooks-import></quickbooks-import>',
	    authenticate: 'suite-superadmin'
	  });
	}];

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <label class=\"pull-right\" style=\"margin-top:16px\"><input type=\"checkbox\" ng-model=\"ctrl.hideLineItems\"> Hide Line Items</label>\n            <h1>Quickbooks Import</h1>\n            <br />\n        </div>\n    </div>\n\n    <div class=\"row\">\n\n        <div class=\"col-xs-4\">\n            <div class=\"form-group\">\n                <label for=\"fileUpload\">Quickbook Export File</label>\n                <input id=\"fileUpload\" type=\"file\" ngf-select=\"ctrl.analyze($file)\" ngf-accept=\"'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'\"></input>\n                <!--<input id=\"fileUpload\" type=\"file\" />-->\n\n            </div>\n        </div>\n        <div class=\"col-xs-4\">\n            <div class=\"form-group\">\n                <label for=\"communitySelect\">Import for Community: </label>\n                <select id=\"communitySelect\" ng-options=\"o.value as o.name for o in ctrl.communities | orderBy:'name'\"\n                        ng-change=\"ctrl.changeCommunitySelection()\" ng-model=\"ctrl.selectedCommunityId\"></select>\n            </div>\n        </div>\n        <div class=\"col-xs-4\">\n            <button ng-disabled=\"!ctrl.selectedCommunityId\" class=\"btn btn-sm btn-primary pull-right\" ng-click=\"ctrl.import()\"><i class=\"fa fa-fw fa-gears\"></i> Start Import</button>\n        </div>\n\n        <div class=\"col-xs-12\" ng-show=\"ctrl.importProgress\">\n            Importing <b>{{ctrl.getCheckCount()}}</b> data sets with a total of <b>{{ctrl.getEntryCount()}}</b> entries\n            <uib-progressbar value=\"ctrl.importProgress\" type=\"{{ctrl.progressType}}\"><b>{{ctrl.importProgress | number:'.0'}}%</b></uib-progressbar>\n        </div>\n\n        <div class=\"col-xs-12\">\n            <hr />\n        </div>\n\n    </div>\n    <div class=\"row\">\n\n        <div class=\"col-xs-12\" ng-repeat=\"owner in ctrl.owners\">\n            <uib-accordion close-others=\"false\">\n\n                <div uib-accordion-group class=\"panel\" ng-class=\"{'panel-success': ctrl.mapContactId[owner], 'panel-default': !ctrl.mapContactId[owner]}\">\n                    <uib-accordion-heading>\n                        <input type=\"checkbox\" style=\"margin-right:8px\" ng-model=\"ctrl.mapOwnerChecked[owner]\" ng-click=\"$event.stopPropagation()\" />\n                        <b>{{owner}}</b> <span class=\"badge\" style=\"margin-left: 4px\">{{ctrl.mapByOwner[owner].length}}</span>\n\n                        <i class=\"fa fa-fw fa-caret-right\"></i>\n\n                        <select ng-if=\"!ctrl.mapContactId[owner] && !ctrl.dirty\"\n                                ng-options=\"o.id as o.name group by o.state for o in ctrl.unassignedContacts | orderBy:'name'\"\n                                ng-model=\"ctrl.mapContactId[owner]\" ng-change=\"ctrl.updateMappingInfo(owner)\" ng-click=\"ctrl.prevent($event)\"></select>\n\n                        <span ng-if=\"ctrl.mapContactId[owner]\">{{ctrl.getContactById(ctrl.mapContactId[owner])}}</span>\n\n                        <a ng-if=\"ctrl.mapContactId[owner]\" ng-click=\"ctrl.updateMappingInfo(owner,true); ctrl.mapContactId[owner] = undefined; ctrl.prevent($event)\"><i class=\"fa fa-fw fa-times\"></i></a>\n\n                        <span class=\"pull-right\">$ {{ctrl.mapTotalByOwner[owner] | number:2}}</span>\n                    </uib-accordion-heading>\n\n                    <div class=\"panel-body\" ng-if=\"!ctrl.hideLineItems\">\n                    <table class=\"table table-condensed\">\n                        <thead>\n                        <tr>\n                            <th>Date</th>\n                            <th>Type</th>\n                            <th>Account</th>\n                            <th class=\"text-right\">Amount</th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr ng-repeat=\"li in ctrl.mapByOwner[owner]\">\n                            <td>{{li.date | date:'mediumDate'}}</td>\n                            <td>{{li.type}}</td>\n                            <td>{{li.account}}</td>\n                            <td class=\"text-right\" ng-class=\"{'text-danger': li.amount > 0, 'text-success': li.amount < 0}\">$ {{li.amount | number:2}}</td>\n                        </tr>\n                        </tbody>\n                      <!--\n                        <tfoot>\n                        <tr>\n                            <th colspan=\"3\" style=\"text-align: right\"> Balance&nbsp;&nbsp;</th>\n                            <th class=\"text-right\" ng-class=\"{'text-danger': ctrl.mapTotalByOwner[owner] > 0, 'text-success': ctrl.mapTotalByOwner[owner] < 0}\">$ {{ctrl.mapTotalByOwner[owner] | number:2}}</th>\n                        </tr>\n                        </tfoot>\n                        -->\n                    </table>\n                    </div>\n                </div>\n            </uib-accordion>\n\n        </div>\n\n    </div>\n</div>\n"

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuickbooksListComponent = undefined;
	
	var _quickbooksList = __webpack_require__(734);
	
	var _quickbooksList2 = _interopRequireDefault(_quickbooksList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var QuickbooksListComponent = exports.QuickbooksListComponent = ['QuickbooksImportService', '$stateParams', '$window', 'PropertyService', function QuickbooksListComponent(QuickbooksImportService, $stateParams, $window, PropertyService) {
	  'ngInject';
	
	  var _this = this;
	
	  _classCallCheck(this, QuickbooksListComponent);
	
	  this.propertyId = $stateParams.propertyId;
	  this.back = function (_) {
	    return $window.history.back();
	  };
	
	  this.data = {};
	
	  QuickbooksImportService.getByProperty({ propertyId: this.propertyId }, function (data) {
	    data.forEach(function (entry) {
	      if (!_this.data[entry.account]) {
	        _this.data[entry.account] = [];
	      }
	
	      _this.data[entry.account].push(entry);
	    });
	
	    _this.accounts = Object.keys(_this.data);
	  }, function (err) {
	    console.log(err);
	  });
	
	  PropertyService.get({ id: this.propertyId }, function (property) {
	    return _this.name = "Lot# " + property.lotNo;
	  });
	
	  QuickbooksImportService.getBalance({ propertyId: this.propertyId }, function (data) {
	    _this.balances = data;
	  });
	}];
	
	exports.default = angular.module('conduu.quickbooksList', [uiRouter]).config(_quickbooksList2.default).component('quickbooksList', {
	  template: __webpack_require__(735),
	  controller: QuickbooksListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 734 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('quickbooks-list', {
	    url: '/admin/list/quickbooks/:propertyId',
	    template: '<quickbooks-list></quickbooks-list>',
	    authenticate: 'suite-superadmin'
	  });
	}];

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <div class=\"row\">\n        <ol class=\"breadcrumb\">\n            <h2>{{ctrl.name}}</h2>\n            <li><a href=\"/admin/list/quickbooks-overview\">Quickbooks Balances</a></li>\n            <li class=\"active\"><a href=\"#\">{{ctrl.name}}</a></li>\n        </ol>\n\n        <div class=\"col-xs-12\">\n\n            <uib-tabset active=\"ctrl.active\">\n                <uib-tab ng-repeat=\"account in ctrl.accounts track by $index\" index=\"$index\">\n                    <uib-tab-heading>{{account}}</uib-tab-heading>\n                    <br/>\n                    <table class=\"table table-hover\">\n                        <thead>\n                        <tr>\n                            <th>Date</th>\n                            <th>Type</th>\n                            <th>Account</th>\n                            <th class=\"text-muted\">Import Date</th>\n                            <th class=\"text-right\">Amount</th>\n                            <th class=\"text-right\">Balance</th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr ng-repeat=\"li in ctrl.data[account]\">\n                            <td>{{li.date | date:'mediumDate'}}</td>\n                            <td>{{li.type}}</td>\n                            <td>{{li.account}}</td>\n                            <td class=\"text-muted\">{{li.meta.creationDate | date:'mediumDate'}}</td>\n                            <td class=\"text-right\" ng-class=\"{'text-danger': li.amount > 0, 'text-success': li.amount < 0}\">$ {{li.amount | number:2}}</td>\n                            <td class=\"text-right\" ng-class=\"{'text-danger': li.balance > 0, 'text-success': li.balance < 0}\">$ {{li.balance | number:2}}</td>\n                        </tr>\n                        </tbody>\n                        <tfoot>\n                        <tr>\n                            <th colspan=\"5\">&nbsp;</th>\n                            <th class=\"text-right\" ng-class=\"{'text-danger': ctrl.balances[account].balance > 0, 'text-success': ctrl.balances[account].balance < 0}\">$ <span>{{ctrl.balances[account].balance | number:2}}</span></th>\n                        </tr>\n                        </tfoot>\n                    </table>\n                </uib-tab>\n            </uib-tabset>\n\n            <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\n\n        </div>\n\n    </div>\n</div>\n"

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuickbooksOverviewComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quickbooksOverview = __webpack_require__(737);
	
	var _quickbooksOverview2 = _interopRequireDefault(_quickbooksOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var QuickbooksOverviewComponent = exports.QuickbooksOverviewComponent = function () {
	  QuickbooksOverviewComponent.$inject = ['QuickbooksImportService', '$stateParams', '$window', 'ContactService', 'DTOptionsBuilder', '$filter', '$scope', 'ViewSelection', 'DTDefaultOptions', 'DTState'];
	  function QuickbooksOverviewComponent(QuickbooksImportService, $stateParams, $window, ContactService, DTOptionsBuilder, $filter, $scope, ViewSelection, DTDefaultOptions, DTState) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, QuickbooksOverviewComponent);
	
	    this.$scope = $scope;
	    this.ViewSelection = ViewSelection;
	
	    this.contactId = $stateParams.contactId;
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.count = { all: 0, debit: 0, balanced: 0, credit: 0, unassigned: 0 };
	
	    $scope.ViewSelection = ViewSelection;
	    $scope.$watch('ViewSelection.selectedCommunity', function (newVal, oldVal, scope) {
	      _this.selectedCommunity = newVal.name;
	      _this.selectedCommunityCode = newVal.value;
	      _this.filterData(_this.selectedCommunityCode, _this.cat);
	    });
	
	    this.chartData = {
	      'dist': [],
	      'asn': [[], [], []]
	    };
	    this.chartLabels = {
	      'dist': ["Debit", "Balanced", "Credit"],
	      'asn': []
	    };
	    this.chartColors = {
	      'dist': ['#C70039', '#A0A0A0', '#2ECC71'],
	      'asn': ['#C70039', '#A0A0A0', '#2ECC71']
	    };
	
	    this.chartSeries = {
	      'asn': ["Debit", "Balanced", "Credit"]
	    };
	
	    this.chartOptions = {
	      'dist': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Account Balance Distribution'
	        },
	        animation: false
	      },
	      'asn': {
	        title: {
	          display: true,
	          text: 'Account Balance Distribution per Association'
	        },
	        animation: false,
	        plugins: {
	          stacked100: { enable: true }
	        },
	        scales: {
	          xAxes: [{
	            stacked: true
	          }],
	          yAxes: [{
	            stacked: true
	          }]
	        }
	      }
	    };
	
	    DTDefaultOptions.setLoadingTemplate("<datatable-loading-placeholder columns='Contact, Account, Community, Import Date, Balance />");
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [[0, 'asc'], [1, 'asc']]).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Quickbook Balances"
	    }, {
	      extend: 'csv',
	      title: "Quickbook Balances"
	    }, {
	      title: "Quickbook Balances",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'portrait',
	      pageSize: 'LETTER'
	    }, {
	      extend: 'print',
	      title: "Quickbook Balances"
	    }]).withOption('fnFooterCallback', function (row, data, start, end, display) {
	      var api = this.api(),
	          data;
	
	      var intVal = function intVal(i) {
	        return typeof i === 'string' ? i.replace(/[\$,]/g, '') * 1 : typeof i === 'number' ? i : 0;
	      };
	
	      var roundCorrectly = function roundCorrectly(number) {
	        return Math.round(number * 100) / 100;
	      };
	
	      var total = api.column(5).data().reduce(function (a, b) {
	        return intVal(a) + intVal(b);
	      }, 0);
	
	      var pageTotal = api.column(5, { page: 'current' }).data().reduce(function (a, b) {
	        return intVal(a) + intVal(b);
	      }, 0);
	
	      var visibleTotal = api.column(5, { search: 'applied' }).data().reduce(function (a, b) {
	        return intVal(a) + intVal(b);
	      }, 0);
	
	      var modifier = "";
	      if (visibleTotal > 0) {
	        modifier = " class='text-danger' ";
	      } else if (visibleTotal < 0) {
	        modifier = " class='text-success' ";
	      }
	
	      $(api.column(5).footer()).html('<nobr><span ' + modifier + '> $ ' + $filter('number')(roundCorrectly(visibleTotal), 2) + '</span></nobr>');
	    });
	
	    QuickbooksImportService.queryUnassigned(function (dataUnassigned) {
	      _this.dataUnassigned = dataUnassigned;
	      _this.filterData(ViewSelection.selectedCommunityCode);
	    });
	
	    QuickbooksImportService.query(function (data) {
	      _this.data = data;
	      _this.filterData(ViewSelection.selectedCommunityCode);
	      _this.dataInitComplete = true;
	
	      var asnDistChart = {};
	
	      _this.data.forEach(function (account) {
	        var key = account.community.code;
	        if (!asnDistChart[key]) {
	          asnDistChart[key] = {
	            debit: 0,
	            balanced: 0,
	            credit: 0
	          };
	        }
	
	        if (account.balance == 0) {
	          asnDistChart[key].balanced++;
	        } else if (account.balance > 0) {
	          asnDistChart[key].debit++;
	        } else {
	          asnDistChart[key].credit++;
	        }
	      });
	
	      Object.keys(asnDistChart).forEach(function (code) {
	        _this.chartLabels['asn'].push(code);
	        _this.chartData['asn'][0].push(asnDistChart[code].debit);
	        _this.chartData['asn'][1].push(asnDistChart[code].balanced);
	        _this.chartData['asn'][2].push(asnDistChart[code].credit);
	      });
	    });
	  }
	
	  _createClass(QuickbooksOverviewComponent, [{
	    key: 'getPrimaryOwner',
	    value: function getPrimaryOwner(property) {
	      var primary = property.contacts.find(function (c) {
	        return c.type == 'primary-owner';
	      });
	      if (primary) return primary.contact;else return null;
	    }
	  }, {
	    key: 'getPrimaryOwnerId',
	    value: function getPrimaryOwnerId(property) {
	      var primary = this.getPrimaryOwner(property);
	      if (primary) return primary._id;
	    }
	  }, {
	    key: 'roundCorrectly',
	    value: function roundCorrectly(number) {
	      return Math.round(number * 100) / 100;
	    }
	  }, {
	    key: 'filterData',
	    value: function filterData(code, cat) {
	      if (code) {
	        this.filteredData = this.c.filter(function (ppty) {
	          return ppty.community && ppty.community.code == code;
	        });
	      } else {
	        this.filteredData = this.data;
	      }
	
	      if (this.dataUnassigned && this.dataUnassigned.length) {
	        if (code) {
	          this.filteredDataUnassigned = this.dataUnassigned.filter(function (ppty) {
	            return ppty.community.code == code;
	          });
	        } else {
	          this.filteredDataUnassigned = this.dataUnassigned;
	        }
	      }
	
	      this.count.all = this.getCount('all');
	      this.count.debit = this.getCount('debit');
	      this.count.balanced = this.getCount('balanced');
	      this.count.credit = this.getCount('credit');
	
	      this.count.unassigned = this.dataUnassigned && this.dataUnassigned.length ? this.filteredDataUnassigned.length : 0;
	
	      this.chartData['dist'] = [this.count.debit, this.count.balanced, this.count.credit];
	
	      if (cat && cat !== 'all') {
	        switch (cat) {
	          case 'credit':
	            this.filteredData = this.filteredData.filter(function (li) {
	              return li.balance < 0;
	            });
	            break;
	          case 'debit':
	            this.filteredData = this.filteredData.filter(function (li) {
	              return li.balance > 0;
	            });
	            break;
	          case 'balanced':
	            this.filteredData = this.filteredData.filter(function (li) {
	              return li.balance == 0;
	            });
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount(cat) {
	      if (!this.filteredData || !this.filteredData.length) return 0;
	
	      return this.filteredData.reduce(function (acc, obj) {
	        switch (cat) {
	          case 'balanced':
	            return acc + (obj.balance == 0);
	          case 'credit':
	            return acc + (obj.balance < 0);
	          case 'debit':
	            return acc + (obj.balance > 0);
	          default:
	            return acc + 1;
	        }
	      }, 0);
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter(cat) {
	      this.cat = cat;
	      this.filterData(this.selectedCommunityCode, this.cat);
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += " (" + contact.company + ")";
	      }
	
	      return composedName || "-";
	    }
	  }]);
	
	  return QuickbooksOverviewComponent;
	}();
	
	exports.default = angular.module('conduu.quickbooksOverview', [uiRouter]).config(_quickbooksOverview2.default).component('quickbooksOverview', {
	  template: __webpack_require__(738),
	  controller: QuickbooksOverviewComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('quickbooks-overview', {
	    url: '/admin/list/quickbooks-overview',
	    template: '<quickbooks-overview></quickbooks-overview>',
	    authenticate: 'suite-superadmin'
	  });
	}];

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <ol class=\"breadcrumb\">\r\n            <h2>Quickbooks Balances <small>{{ctrl.selectedCommunity}}</small></h2>\r\n            <li class=\"active\"><a href=\"#\">Quickbooks Balances</a></li>\r\n        </ol>\r\n\r\n        <div class=\"col-xs-12\">\r\n\r\n            <!--<label><input type=\"checkbox\" ng-model=\"ctrl.openonly\" ng-click=\"ctrl.applyFilter()\" /> Only Open</label>-->\r\n\r\n            <uib-tabset active=\"ctrl.activeTabIndex\">\r\n                <uib-tab select=\"ctrl.setFilter('all')\">\r\n                    <uib-tab-heading><b>All</b> <span class=\"badge\">{{ctrl.count['all']}}</span></uib-tab-heading>\r\n                </uib-tab>\r\n                <uib-tab select=\"ctrl.setFilter('debit')\">\r\n                    <uib-tab-heading><b>Debit</b> <span class=\"badge\">{{ctrl.count['debit']}}</span></uib-tab-heading>\r\n                </uib-tab>\r\n                <uib-tab select=\"ctrl.setFilter('balanced')\">\r\n                    <uib-tab-heading><b>Balanced</b> <span class=\"badge\">{{ctrl.count['balanced']}}</span></uib-tab-heading>\r\n                </uib-tab>\r\n                <uib-tab select=\"ctrl.setFilter('credit')\" class=\"separator-right\">\r\n                    <uib-tab-heading><b>Credit</b> <span class=\"badge\">{{ctrl.count['credit']}}</span></uib-tab-heading>\r\n                </uib-tab>\r\n\r\n                <uib-tab>\r\n                    <uib-tab-heading><b>Unassigned</b> <span class=\"badge\">{{ctrl.count['unassigned']}}</span></uib-tab-heading>\r\n                </uib-tab>\r\n\r\n                <uib-tab select=\"ctrl.setFilter('all')\" class=\"pull-right\">\r\n                    <uib-tab-heading><i class=\"fa fa-fw fa-pie-chart\"></i></uib-tab-heading>\r\n                    <br/>\r\n                    <div class=\"row\">\r\n\r\n                        <div class=\"col-xs-4\">\r\n                            <canvas id=\"doughnut\" class=\"chart chart-doughnut\"\r\n                                    chart-data=\"ctrl.chartData['dist']\" chart-labels=\"ctrl.chartLabels['dist']\" chart-options=\"ctrl.chartOptions['dist']\"\r\n                                    chart-colors=\"ctrl.chartColors['dist']\">\r\n                            </canvas>\r\n                        </div>\r\n\r\n                        <div class=\"col-xs-8\">\r\n                            <canvas id=\"bar\" class=\"chart chart-horizontal-bar\"\r\n                                    chart-data=\"ctrl.chartData['asn']\" chart-labels=\"ctrl.chartLabels['asn']\" chart-options=\"ctrl.chartOptions['asn']\"\r\n                                    chart-colors=\"ctrl.chartColors['asn']\" chart-series=\"ctrl.chartSeries['asn']\">\r\n                            </canvas>\r\n                        </div>\r\n\r\n                    </div>\r\n                    <hr>\r\n                </uib-tab>\r\n            </uib-tabset>\r\n\r\n            <br/>\r\n\r\n            <div ng-hide=\"ctrl.activeTabIndex == 4\">\r\n                <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-hover\">\r\n                    <thead>\r\n                    <tr>\r\n                        <th>Cmty</th>\r\n                        <th>Lot</th>\r\n                        <th>Contact</th>\r\n                        <th>Account</th>\r\n                        <th>Import Date</th>\r\n                        <th class=\"text-right\">Balance</th>\r\n                    </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                    <tr ng-repeat=\"li in ctrl.filteredData\">\r\n                        <td>{{li.community.code}}</td>\r\n                        <td><a ng-href=\"/property/{{li.property._id}}\">{{li.property.lotNo}}</a></td>\r\n                        <td><a ng-href=\"/contact/{{ctrl.getPrimaryOwnerId(li.property)}}\" ng-bind-html=\"ctrl.getComposedName(ctrl.getPrimaryOwner(li.property))\"></a></td>\r\n                        <td><a ng-href=\"/admin/list/quickbooks/{{li.property._id}}\">{{li.account}}</a></td>\r\n                        <td>{{li.importDate | date:'mediumDate'}}</td>\r\n                        <td class=\"text-right\" ng-class=\"{'text-danger': li.balance > 0, 'text-success': li.balance < 0}\">$ {{li.balance | number:2}}</td>\r\n                    </tr>\r\n                    </tbody>\r\n                    <tfoot>\r\n                    <tr>\r\n                        <th colspan=\"5\" style=\"text-align: right\"> TOTAL&nbsp;&nbsp;</th>\r\n                        <th class=\"text-right\"></th>\r\n                    </tr>\r\n                    </tfoot>\r\n                </table>\r\n            </div>\r\n\r\n            <div ng-show=\"ctrl.activeTabIndex == 4\">\r\n                <table ng-if=\"ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-hover\">\r\n                    <thead>\r\n                    <tr>\r\n                        <th>Cmty</th>\r\n                        <th>Quickbooks Name</th>\r\n                        <th>Account</th>\r\n                        <th></th>\r\n                        <th>Import Date</th>\r\n                        <th class=\"text-right\">Balance</th>\r\n                    </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                    <tr ng-repeat=\"li in ctrl.filteredDataUnassigned\">\r\n                        <td>{{li.community.code}}</td>\r\n                        <td>{{li.name}}</td>\r\n                        <td>{{li.account}}</td>\r\n                        <td></td>\r\n                        <td>{{li.importDate | date:'mediumDate'}}</td>\r\n                        <td class=\"text-right\" ng-class=\"{'text-danger': li.balance > 0, 'text-success': li.balance < 0}\">$ {{li.balance | number:2}}</td>\r\n                    </tr>\r\n                    </tbody>\r\n                    <tfoot>\r\n                    <tr>\r\n                        <th colspan=\"5\" style=\"text-align: right\"> TOTAL&nbsp;&nbsp;</th>\r\n                        <th class=\"text-right\"></th>\r\n                    </tr>\r\n                    </tfoot>\r\n                </table>\r\n            </div>\r\n\r\n            <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	QuickbooksImportService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuickbooksImportService = QuickbooksImportService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function QuickbooksImportService($resource) {
	  return $resource('/api/quickbooks-imports/:id', {
	    name: '@_id'
	  }, {
	    indexByQuickbooksName: {
	      method: 'GET',
	      isArray: true,
	      url: "/api/quickbooks-imports/name/:name"
	    },
	    queryUnassigned: {
	      method: 'GET',
	      isArray: true,
	      url: "/api/quickbooks-imports/unassigned"
	    },
	    getByProperty: {
	      method: 'GET',
	      isArray: true,
	      url: "/api/quickbooks-imports/property/:propertyId"
	    },
	    update: {
	      method: 'PUT'
	    },
	    patch: {
	      method: 'PATCH'
	    },
	    createBulk: {
	      method: 'POST',
	      url: "/api/quickbooks-imports/bulk/:communityId/:name",
	      isArray: true
	    },
	    getBalance: {
	      method: 'GET',
	      url: "/api/quickbooks-imports/balance/:propertyId"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.QuickbooksImportService', []).factory('QuickbooksImportService', QuickbooksImportService).name;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	var Mustache = __webpack_require__(741);
	
	var SendAttachmentEmailComponent = exports.SendAttachmentEmailComponent = function () {
	  /*@ngInject*/
	  SendAttachmentEmailComponent.$inject = ['$uibModal', 'SettingsService'];
	  function SendAttachmentEmailComponent($uibModal, SettingsService) {
	    var _this = this;
	
	    _classCallCheck(this, SendAttachmentEmailComponent);
	
	    this.$uibModal = $uibModal;
	
	    this.toolbarDefinition = [["bold", "italics", "underline"], ["h3", "h4", "h5"], ["p", "quote", "clear"], ["ul", "ol"], ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"], ["undo", "redo"]];
	
	    SettingsService.getByName({ name: 'client' }, function (clientConfig) {
	      _this.clientVars = {
	        MGNT_COMPANY_NAME: clientConfig.data.name,
	        MGNT_COMPANY_ADDRESS: clientConfig.data.address,
	        MGNT_COMPANY_PHONE: clientConfig.data.phone || '-',
	        MGNT_COMPANY_FAX: clientConfig.data.fax || '-'
	      };
	    });
	  }
	
	  _createClass(SendAttachmentEmailComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.config = this.resolve.config;
	
	      this.contextVars = this.config.contextVars;
	
	      this.attachments = this.config.attachments || [];
	      this.emails = this.config.emails || [];
	      var _sequences = this.config.templates || [];
	
	      this.templates = _sequences.map(function (sequence) {
	        return {
	          subject: sequence.mailSubjectTemplate,
	          body: sequence.mailBodyTemplate,
	          level: sequence.level
	        };
	      });
	
	      this.email = {
	        attachment: this.config.attachments.find(function (att) {
	          return att._id == _this2.config.attachment;
	        }),
	        additionalAttachments: []
	      };
	    }
	  }, {
	    key: 'openPreviewModal',
	    value: function openPreviewModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'iframePreview',
	        resolve: {
	          config: function config() {
	            return {
	              content: that.generateMailBody(that.email)
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }, {
	    key: 'isImageMime',
	    value: function isImageMime(mime) {
	      return mime.startsWith('image/');
	    }
	  }, {
	    key: 'isPdfMime',
	    value: function isPdfMime(mime) {
	      return mime === 'application/pdf';
	    }
	  }, {
	    key: 'isWordMime',
	    value: function isWordMime(mime) {
	      return mime == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || mime == 'application/msword';
	    }
	  }, {
	    key: 'removeAttachment',
	    value: function removeAttachment(idx) {
	      this.email.additionalAttachments.splice(idx, 1);
	    }
	  }, {
	    key: 'updateTemplate',
	    value: function updateTemplate() {
	      var _this3 = this;
	
	      var template = this.templates.find(function (t) {
	        return t.level == _this3.selectedTemplateLevel;
	      });
	
	      if (template) {
	        this.email.subject = template.subject;
	        this.email.body = template.body;
	      }
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.email.body = this.generateMailBody(this.email);
	      this.close({ $value: this.email });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }, {
	    key: 'addMoreAttachments',
	    value: function addMoreAttachments() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'attachmentPicker',
	        resolve: {
	          config: function config() {
	            return {
	              attachments: that.attachments.filter(function (att) {
	                return att._id != that.email.attachment._id;
	              }),
	              selectedIds: that.email.additionalAttachments.map(function (att) {
	                return att._id;
	              })
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (selectedAttachments) {
	        that.email.additionalAttachments = selectedAttachments;
	      }, function () {});
	    }
	  }, {
	    key: 'generateMailBody',
	    value: function generateMailBody(mail) {
	      if (!mail || !mail.body) return "";
	
	      var TMPL_TAG_SUBJECT = "{tmpl:subject}";
	      var TMPL_TAG_CONTENT = "{tmpl:content}";
	      var TMPL_TAG_HEADER = "{tmpl:header}";
	      var TMPL_TAG_DATE = "{tmpl:date}";
	      var TMPL_TAG_MAIL_URL = "{tmpl:mailurl}";
	
	      var TMPL_TAG_OPEN_SECTION = "{tmpl:section-start}";
	      var TMPL_TAG_CLOSE_SECTION = "{tmpl:section-end}";
	
	      var TMPL_HTML_FRAME2 = __webpack_require__(742);
	
	      var content = mail.body.split(/\n/).join("<br/>");
	
	
	      var pageTemplate = TMPL_HTML_FRAME2.replace(TMPL_TAG_CONTENT, content);
	
	      pageTemplate = pageTemplate.replace(TMPL_TAG_SUBJECT, mail.subject);
	
	
	      var sectionTemplate = pageTemplate.substring(pageTemplate.lastIndexOf(TMPL_TAG_OPEN_SECTION) + TMPL_TAG_OPEN_SECTION.length, pageTemplate.lastIndexOf(TMPL_TAG_CLOSE_SECTION));
	
	      var __VARS = Object.assign({}, this.contextVars, this.clientVars);
	
	      return Mustache.render(pageTemplate, __VARS);
	    }
	  }]);
	
	  return SendAttachmentEmailComponent;
	}();
	
	exports.default = angular.module('conduu.sendAttachmentEmail', []).component('sendAttachmentEmail', {
	  template: __webpack_require__(743),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: SendAttachmentEmailComponent
	}).name;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	(function(global,factory){ true?module.exports=factory():typeof define==="function"&&define.amd?define(factory):(global=global||self,global.Mustache=factory())})(this,function(){"use strict";var objectToString=Object.prototype.toString;var isArray=Array.isArray||function isArrayPolyfill(object){return objectToString.call(object)==="[object Array]"};function isFunction(object){return typeof object==="function"}function typeStr(obj){return isArray(obj)?"array":typeof obj}function escapeRegExp(string){return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")}function hasProperty(obj,propName){return obj!=null&&typeof obj==="object"&&propName in obj}function primitiveHasOwnProperty(primitive,propName){return primitive!=null&&typeof primitive!=="object"&&primitive.hasOwnProperty&&primitive.hasOwnProperty(propName)}var regExpTest=RegExp.prototype.test;function testRegExp(re,string){return regExpTest.call(re,string)}var nonSpaceRe=/\S/;function isWhitespace(string){return!testRegExp(nonSpaceRe,string)}var entityMap={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;","`":"&#x60;","=":"&#x3D;"};function escapeHtml(string){return String(string).replace(/[&<>"'`=\/]/g,function fromEntityMap(s){return entityMap[s]})}var whiteRe=/\s*/;var spaceRe=/\s+/;var equalsRe=/\s*=/;var curlyRe=/\s*\}/;var tagRe=/#|\^|\/|>|\{|&|=|!/;function parseTemplate(template,tags){if(!template)return[];var lineHasNonSpace=false;var sections=[];var tokens=[];var spaces=[];var hasTag=false;var nonSpace=false;var indentation="";var tagIndex=0;function stripSpace(){if(hasTag&&!nonSpace){while(spaces.length)delete tokens[spaces.pop()]}else{spaces=[]}hasTag=false;nonSpace=false}var openingTagRe,closingTagRe,closingCurlyRe;function compileTags(tagsToCompile){if(typeof tagsToCompile==="string")tagsToCompile=tagsToCompile.split(spaceRe,2);if(!isArray(tagsToCompile)||tagsToCompile.length!==2)throw new Error("Invalid tags: "+tagsToCompile);openingTagRe=new RegExp(escapeRegExp(tagsToCompile[0])+"\\s*");closingTagRe=new RegExp("\\s*"+escapeRegExp(tagsToCompile[1]));closingCurlyRe=new RegExp("\\s*"+escapeRegExp("}"+tagsToCompile[1]))}compileTags(tags||mustache.tags);var scanner=new Scanner(template);var start,type,value,chr,token,openSection;while(!scanner.eos()){start=scanner.pos;value=scanner.scanUntil(openingTagRe);if(value){for(var i=0,valueLength=value.length;i<valueLength;++i){chr=value.charAt(i);if(isWhitespace(chr)){spaces.push(tokens.length);indentation+=chr}else{nonSpace=true;lineHasNonSpace=true;indentation+=" "}tokens.push(["text",chr,start,start+1]);start+=1;if(chr==="\n"){stripSpace();indentation="";tagIndex=0;lineHasNonSpace=false}}}if(!scanner.scan(openingTagRe))break;hasTag=true;type=scanner.scan(tagRe)||"name";scanner.scan(whiteRe);if(type==="="){value=scanner.scanUntil(equalsRe);scanner.scan(equalsRe);scanner.scanUntil(closingTagRe)}else if(type==="{"){value=scanner.scanUntil(closingCurlyRe);scanner.scan(curlyRe);scanner.scanUntil(closingTagRe);type="&"}else{value=scanner.scanUntil(closingTagRe)}if(!scanner.scan(closingTagRe))throw new Error("Unclosed tag at "+scanner.pos);if(type==">"){token=[type,value,start,scanner.pos,indentation,tagIndex,lineHasNonSpace]}else{token=[type,value,start,scanner.pos]}tagIndex++;tokens.push(token);if(type==="#"||type==="^"){sections.push(token)}else if(type==="/"){openSection=sections.pop();if(!openSection)throw new Error('Unopened section "'+value+'" at '+start);if(openSection[1]!==value)throw new Error('Unclosed section "'+openSection[1]+'" at '+start)}else if(type==="name"||type==="{"||type==="&"){nonSpace=true}else if(type==="="){compileTags(value)}}stripSpace();openSection=sections.pop();if(openSection)throw new Error('Unclosed section "'+openSection[1]+'" at '+scanner.pos);return nestTokens(squashTokens(tokens))}function squashTokens(tokens){var squashedTokens=[];var token,lastToken;for(var i=0,numTokens=tokens.length;i<numTokens;++i){token=tokens[i];if(token){if(token[0]==="text"&&lastToken&&lastToken[0]==="text"){lastToken[1]+=token[1];lastToken[3]=token[3]}else{squashedTokens.push(token);lastToken=token}}}return squashedTokens}function nestTokens(tokens){var nestedTokens=[];var collector=nestedTokens;var sections=[];var token,section;for(var i=0,numTokens=tokens.length;i<numTokens;++i){token=tokens[i];switch(token[0]){case"#":case"^":collector.push(token);sections.push(token);collector=token[4]=[];break;case"/":section=sections.pop();section[5]=token[2];collector=sections.length>0?sections[sections.length-1][4]:nestedTokens;break;default:collector.push(token)}}return nestedTokens}function Scanner(string){this.string=string;this.tail=string;this.pos=0}Scanner.prototype.eos=function eos(){return this.tail===""};Scanner.prototype.scan=function scan(re){var match=this.tail.match(re);if(!match||match.index!==0)return"";var string=match[0];this.tail=this.tail.substring(string.length);this.pos+=string.length;return string};Scanner.prototype.scanUntil=function scanUntil(re){var index=this.tail.search(re),match;switch(index){case-1:match=this.tail;this.tail="";break;case 0:match="";break;default:match=this.tail.substring(0,index);this.tail=this.tail.substring(index)}this.pos+=match.length;return match};function Context(view,parentContext){this.view=view;this.cache={".":this.view};this.parent=parentContext}Context.prototype.push=function push(view){return new Context(view,this)};Context.prototype.lookup=function lookup(name){var cache=this.cache;var value;if(cache.hasOwnProperty(name)){value=cache[name]}else{var context=this,intermediateValue,names,index,lookupHit=false;while(context){if(name.indexOf(".")>0){intermediateValue=context.view;names=name.split(".");index=0;while(intermediateValue!=null&&index<names.length){if(index===names.length-1)lookupHit=hasProperty(intermediateValue,names[index])||primitiveHasOwnProperty(intermediateValue,names[index]);intermediateValue=intermediateValue[names[index++]]}}else{intermediateValue=context.view[name];lookupHit=hasProperty(context.view,name)}if(lookupHit){value=intermediateValue;break}context=context.parent}cache[name]=value}if(isFunction(value))value=value.call(this.view);return value};function Writer(){this.templateCache={_cache:{},set:function set(key,value){this._cache[key]=value},get:function get(key){return this._cache[key]},clear:function clear(){this._cache={}}}}Writer.prototype.clearCache=function clearCache(){if(typeof this.templateCache!=="undefined"){this.templateCache.clear()}};Writer.prototype.parse=function parse(template,tags){var cache=this.templateCache;var cacheKey=template+":"+(tags||mustache.tags).join(":");var isCacheEnabled=typeof cache!=="undefined";var tokens=isCacheEnabled?cache.get(cacheKey):undefined;if(tokens==undefined){tokens=parseTemplate(template,tags);isCacheEnabled&&cache.set(cacheKey,tokens)}return tokens};Writer.prototype.render=function render(template,view,partials,tags){var tokens=this.parse(template,tags);var context=view instanceof Context?view:new Context(view,undefined);return this.renderTokens(tokens,context,partials,template,tags)};Writer.prototype.renderTokens=function renderTokens(tokens,context,partials,originalTemplate,tags){var buffer="";var token,symbol,value;for(var i=0,numTokens=tokens.length;i<numTokens;++i){value=undefined;token=tokens[i];symbol=token[0];if(symbol==="#")value=this.renderSection(token,context,partials,originalTemplate);else if(symbol==="^")value=this.renderInverted(token,context,partials,originalTemplate);else if(symbol===">")value=this.renderPartial(token,context,partials,tags);else if(symbol==="&")value=this.unescapedValue(token,context);else if(symbol==="name")value=this.escapedValue(token,context);else if(symbol==="text")value=this.rawValue(token);if(value!==undefined)buffer+=value}return buffer};Writer.prototype.renderSection=function renderSection(token,context,partials,originalTemplate){var self=this;var buffer="";var value=context.lookup(token[1]);function subRender(template){return self.render(template,context,partials)}if(!value)return;if(isArray(value)){for(var j=0,valueLength=value.length;j<valueLength;++j){buffer+=this.renderTokens(token[4],context.push(value[j]),partials,originalTemplate)}}else if(typeof value==="object"||typeof value==="string"||typeof value==="number"){buffer+=this.renderTokens(token[4],context.push(value),partials,originalTemplate)}else if(isFunction(value)){if(typeof originalTemplate!=="string")throw new Error("Cannot use higher-order sections without the original template");value=value.call(context.view,originalTemplate.slice(token[3],token[5]),subRender);if(value!=null)buffer+=value}else{buffer+=this.renderTokens(token[4],context,partials,originalTemplate)}return buffer};Writer.prototype.renderInverted=function renderInverted(token,context,partials,originalTemplate){var value=context.lookup(token[1]);if(!value||isArray(value)&&value.length===0)return this.renderTokens(token[4],context,partials,originalTemplate)};Writer.prototype.indentPartial=function indentPartial(partial,indentation,lineHasNonSpace){var filteredIndentation=indentation.replace(/[^ \t]/g,"");var partialByNl=partial.split("\n");for(var i=0;i<partialByNl.length;i++){if(partialByNl[i].length&&(i>0||!lineHasNonSpace)){partialByNl[i]=filteredIndentation+partialByNl[i]}}return partialByNl.join("\n")};Writer.prototype.renderPartial=function renderPartial(token,context,partials,tags){if(!partials)return;var value=isFunction(partials)?partials(token[1]):partials[token[1]];if(value!=null){var lineHasNonSpace=token[6];var tagIndex=token[5];var indentation=token[4];var indentedValue=value;if(tagIndex==0&&indentation){indentedValue=this.indentPartial(value,indentation,lineHasNonSpace)}return this.renderTokens(this.parse(indentedValue,tags),context,partials,indentedValue)}};Writer.prototype.unescapedValue=function unescapedValue(token,context){var value=context.lookup(token[1]);if(value!=null)return value};Writer.prototype.escapedValue=function escapedValue(token,context){var value=context.lookup(token[1]);if(value!=null)return mustache.escape(value)};Writer.prototype.rawValue=function rawValue(token){return token[1]};var mustache={name:"mustache.js",version:"4.0.0",tags:["{{","}}"],clearCache:undefined,escape:undefined,parse:undefined,render:undefined,Scanner:undefined,Context:undefined,Writer:undefined,set templateCache(cache){defaultWriter.templateCache=cache},get templateCache(){return defaultWriter.templateCache}};var defaultWriter=new Writer;mustache.clearCache=function clearCache(){return defaultWriter.clearCache()};mustache.parse=function parse(template,tags){return defaultWriter.parse(template,tags)};mustache.render=function render(template,view,partials,tags){if(typeof template!=="string"){throw new TypeError('Invalid template! Template should be a "string" '+'but "'+typeStr(template)+'" was given as the first '+"argument for mustache#render(template, view, partials)")}return defaultWriter.render(template,view,partials,tags)};mustache.escape=escapeHtml;mustache.Scanner=Scanner;mustache.Context=Context;mustache.Writer=Writer;return mustache});


/***/ }),
/* 742 */
/***/ (function(module, exports) {

	module.exports = "<!doctype html>\r\n<html>\r\n<head>\r\n    <meta name=\"viewport\" content=\"width=device-width\" />\r\n    <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\" />\r\n    <title>{tmpl:subject}</title>\r\n    <style>\r\n        /* -------------------------------------\r\n            GLOBAL RESETS\r\n        ------------------------------------- */\r\n        img {\r\n            border: none;\r\n            -ms-interpolation-mode: bicubic;\r\n            max-width: 100%; }\r\n\r\n        body {\r\n            background-color: #f6f6f6;\r\n            font-family: sans-serif;\r\n            -webkit-font-smoothing: antialiased;\r\n            font-size: 14px;\r\n            line-height: 1.4;\r\n            margin: 0;\r\n            padding: 0;\r\n            -ms-text-size-adjust: 100%;\r\n            -webkit-text-size-adjust: 100%; }\r\n\r\n        table {\r\n            border-collapse: separate;\r\n            mso-table-lspace: 0pt;\r\n            mso-table-rspace: 0pt;\r\n            width: 100%; }\r\n        table td {\r\n            font-family: sans-serif;\r\n            font-size: 14px;\r\n            vertical-align: top; }\r\n\r\n        /* -------------------------------------\r\n            BODY & CONTAINER\r\n        ------------------------------------- */\r\n\r\n        .body {\r\n            background-color: #f6f6f6;\r\n            width: 100%; }\r\n\r\n        /* Set a max-width, and make it display as block so it will automatically stretch to that width, but will also shrink down on a phone or something */\r\n        .container {\r\n            display: block;\r\n            Margin: 0 auto !important;\r\n            /* makes it centered */\r\n            max-width: 580px;\r\n            padding: 10px;\r\n            width: 580px; }\r\n\r\n        /* This should also be a block element, so that it will fill 100% of the .container */\r\n        .content {\r\n            box-sizing: border-box;\r\n            display: block;\r\n            Margin: 0 auto;\r\n            max-width: 580px;\r\n            padding: 10px; }\r\n\r\n        /* -------------------------------------\r\n            HEADER, FOOTER, MAIN\r\n        ------------------------------------- */\r\n        .main {\r\n            background: #ffffff;\r\n            border-radius: 3px;\r\n            width: 100%; }\r\n\r\n        .wrapper {\r\n            box-sizing: border-box;\r\n            padding: 20px; }\r\n\r\n        .content-block {\r\n            padding-bottom: 10px;\r\n            padding-top: 10px;\r\n        }\r\n\r\n        .footer {\r\n            clear: both;\r\n            Margin-top: 10px;\r\n            text-align: center;\r\n            width: 100%; }\r\n        .footer td,\r\n        .footer p,\r\n        .footer span,\r\n        .footer a {\r\n            color: #999999;\r\n            font-size: 12px;\r\n            text-align: center; }\r\n\r\n        /* -------------------------------------\r\n            TYPOGRAPHY\r\n        ------------------------------------- */\r\n        h1,\r\n        h2,\r\n        h3,\r\n        h4 {\r\n            color: #000000;\r\n            font-family: sans-serif;\r\n            font-weight: 400;\r\n            line-height: 1.4;\r\n            margin: 0;\r\n            Margin-bottom: 30px; }\r\n\r\n        h1 {\r\n            font-size: 35px;\r\n            font-weight: 300;\r\n            text-align: center;\r\n            text-transform: capitalize; }\r\n\r\n        p,\r\n        ul,\r\n        ol {\r\n            font-family: sans-serif;\r\n            font-size: 14px;\r\n            font-weight: normal;\r\n            margin: 0;\r\n            Margin-bottom: 15px; }\r\n        p li,\r\n        ul li,\r\n        ol li {\r\n            list-style-position: inside;\r\n            margin-left: 5px; }\r\n\r\n        a {\r\n            color: #3498db;\r\n            text-decoration: underline; }\r\n\r\n        /* -------------------------------------\r\n            BUTTONS\r\n        ------------------------------------- */\r\n        .btn {\r\n            box-sizing: border-box;\r\n            width: 100%; }\r\n        .btn > tbody > tr > td {\r\n            padding-bottom: 15px; }\r\n        .btn table {\r\n            width: auto; }\r\n        .btn table td {\r\n            background-color: #ffffff;\r\n            border-radius: 5px;\r\n            text-align: center; }\r\n        .btn a {\r\n            background-color: #ffffff;\r\n            border: solid 1px #3498db;\r\n            border-radius: 5px;\r\n            box-sizing: border-box;\r\n            color: #3498db;\r\n            cursor: pointer;\r\n            display: inline-block;\r\n            font-size: 14px;\r\n            font-weight: bold;\r\n            margin: 0;\r\n            padding: 12px 25px;\r\n            text-decoration: none;\r\n            text-transform: capitalize; }\r\n\r\n        .btn-primary table td {\r\n            background-color: #3498db; }\r\n\r\n        .btn-primary a {\r\n            background-color: #3498db;\r\n            border-color: #3498db;\r\n            color: #ffffff; }\r\n\r\n        /* -------------------------------------\r\n            OTHER STYLES THAT MIGHT BE USEFUL\r\n        ------------------------------------- */\r\n        .last {\r\n            margin-bottom: 0; }\r\n\r\n        .first {\r\n            margin-top: 0; }\r\n\r\n        .align-center {\r\n            text-align: center; }\r\n\r\n        .align-right {\r\n            text-align: right; }\r\n\r\n        .align-left {\r\n            text-align: left; }\r\n\r\n        .clear {\r\n            clear: both; }\r\n\r\n        .mt0 {\r\n            margin-top: 0; }\r\n\r\n        .mb0 {\r\n            margin-bottom: 0; }\r\n\r\n        .preheader {\r\n            color: transparent;\r\n            display: none;\r\n            height: 0;\r\n            max-height: 0;\r\n            max-width: 0;\r\n            opacity: 0;\r\n            overflow: hidden;\r\n            mso-hide: all;\r\n            visibility: hidden;\r\n            width: 0; }\r\n\r\n        .powered-by a {\r\n            text-decoration: none; }\r\n\r\n        hr {\r\n            border: 0;\r\n            border-bottom: 1px solid #f6f6f6;\r\n            Margin: 20px 0; }\r\n\r\n        /* -------------------------------------\r\n            RESPONSIVE AND MOBILE FRIENDLY STYLES\r\n        ------------------------------------- */\r\n        @media only screen and (max-width: 620px) {\r\n            table[class=body] h1 {\r\n                font-size: 28px !important;\r\n                margin-bottom: 10px !important; }\r\n            table[class=body] p,\r\n            table[class=body] ul,\r\n            table[class=body] ol,\r\n            table[class=body] td,\r\n            table[class=body] span,\r\n            table[class=body] a {\r\n                font-size: 16px !important; }\r\n            table[class=body] .wrapper,\r\n            table[class=body] .article {\r\n                padding: 10px !important; }\r\n            table[class=body] .content {\r\n                padding: 0 !important; }\r\n            table[class=body] .container {\r\n                padding: 0 !important;\r\n                width: 100% !important; }\r\n            table[class=body] .main {\r\n                border-left-width: 0 !important;\r\n                border-radius: 0 !important;\r\n                border-right-width: 0 !important; }\r\n            table[class=body] .btn table {\r\n                width: 100% !important; }\r\n            table[class=body] .btn a {\r\n                width: 100% !important; }\r\n            table[class=body] .img-responsive {\r\n                height: auto !important;\r\n                max-width: 100% !important;\r\n                width: auto !important; }}\r\n\r\n        /* -------------------------------------\r\n            PRESERVE THESE STYLES IN THE HEAD\r\n        ------------------------------------- */\r\n        @media all {\r\n            .ExternalClass {\r\n                width: 100%; }\r\n            .ExternalClass,\r\n            .ExternalClass p,\r\n            .ExternalClass span,\r\n            .ExternalClass font,\r\n            .ExternalClass td,\r\n            .ExternalClass div {\r\n                line-height: 100%; }\r\n            .apple-link a {\r\n                color: inherit !important;\r\n                font-family: inherit !important;\r\n                font-size: inherit !important;\r\n                font-weight: inherit !important;\r\n                line-height: inherit !important;\r\n                text-decoration: none !important; }\r\n            .btn-primary table td:hover {\r\n                background-color: #34495e !important; }\r\n            .btn-primary a:hover {\r\n                background-color: #34495e !important;\r\n                border-color: #34495e !important; } }\r\n\r\n    </style>\r\n</head>\r\n<body class=\"\">\r\n<table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" class=\"body\">\r\n    <tr>\r\n        <td>&nbsp;</td>\r\n        <td class=\"container\">\r\n            <div class=\"content\">\r\n\r\n                <!-- START CENTERED WHITE CONTAINER -->\r\n                <span class=\"preheader\"></span>\r\n\r\n                <table class=\"main\">\r\n\r\n                    <!-- START MAIN CONTENT AREA -->\r\n                    <tr>\r\n                        <td class=\"wrapper\">\r\n                            <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\">\r\n                                <tr>\r\n                                    <td>\r\n                                        {tmpl:content}\r\n                                    </td>\r\n                                </tr>\r\n                            </table>\r\n                        </td>\r\n                    </tr>\r\n                </table>\r\n\r\n                <!-- START FOOTER -->\r\n                <div class=\"footer\">\r\n                    <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\">\r\n                        <tr>\r\n                            <td class=\"content-block\">\r\n                                <span class=\"apple-link\"><b>{{{ENTITY_LINK}}}</b> | Powered by <a target='_blank' href=\"http://conduu.com\">CONDUU</a></span>\r\n                            </td>\r\n                        </tr>\r\n                    </table>\r\n\r\n\r\n                </div>\r\n                <!-- END FOOTER -->\r\n\r\n\r\n                <!-- END CENTERED WHITE CONTAINER -->\r\n            </div>\r\n        </td>\r\n        <td>&nbsp;</td>\r\n    </tr>\r\n</table>\r\n</body>\r\n</html>"

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">Send Attachment via Email</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n\n  <!-- Attachment -->\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.attachment.$valid && $ctrl.submitted,\n                                      'has-error': form.attachment.$invalid && $ctrl.submitted }\">\n    <span class=\"pull-right\"><a href=\"#\" ng-click=\"$ctrl.addMoreAttachments()\"><i class=\"fa fa-fw fa-plus\"></i> Additional Attachments</a></span>\n    <label>Attachment</label>\n\n    <select type=\"text\" name=\"attachment\" class=\"form-control\" ng-model=\"$ctrl.email.attachment\"\n            ng-options=\"o as o.filename for o in $ctrl.attachments\"></select>\n    <p class=\"help-block\" ng-show=\"form.attachment.$error.required && $ctrl.submitted\">\n      Please specify the attachment you want to send\n    </p>\n  </div>\n\n  <!-- Attachments -->\n  <div class=\"form-group\" ng-show=\"$ctrl.email.additionalAttachments.length > 0\">\n    <label>Additional Attachments</label>\n\n    <table style=\"width:100%;\" class=\"table table-condensed\">\n      <!--<thead>\n      <tr>\n        <th></th>\n        <th>Attachments</th>\n        <th></th>\n      </tr>\n      </thead>-->\n      <tbody>\n      <tr ng-repeat=\"attachment in $ctrl.email.additionalAttachments\">\n        <td>\n          <p style=\"margin: 0px\">\n            <i ng-if=\"$ctrl.isImageMime(attachment.contentType)\" class=\"fa fa-fw fa-file-image-o\"></i>\n            <i ng-if=\"$ctrl.isPdfMime(attachment.contentType)\" class=\"fa fa-fw fa-file-pdf-o\"></i>\n            <i ng-if=\"$ctrl.isWordMime(attachment.contentType)\" class=\"fa fa-fw fa-file-word-o\"></i>\n          </p>\n        </td>\n        <td>{{attachment.filename}}</td>\n        <td style=\"text-align: right\"><a class=\"text-danger\" href=\"#\" ng-click=\"$ctrl.removeAttachment($index)\"><i class=\"fa fa fa-trash\"></i></a></td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n\n  <div ng-if=\"$ctrl.totalAttachmentSize() > 10*1024*1024\" class=\"bs-callout bs-callout-danger\">\n    <h4>Attachment Size Exceeds Limit</h4>\n    The total attachment size must not exceed the limit of 10 MB\n  </div>\n\n  <!-- Email Address -->\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.attachment.$valid && $ctrl.submitted,\n                                      'has-error': form.attachment.$invalid && $ctrl.submitted }\">\n    <label>Email</label>\n\n    <select type=\"text\" name=\"email\" class=\"form-control\" ng-model=\"$ctrl.email.email\"\n            ng-options=\"o.email as o.description group by o.group for o in $ctrl.emails\"></select>\n    <p class=\"help-block\" ng-show=\"form.email.$error.required && ctrl.submitted\">\n      Please specify the email you want to send to\n    </p>\n  </div>\n\n  <hr />\n\n  <!-- Email Template -->\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.template.$valid && $ctrl.submitted,\n                                      'has-error': form.template.$invalid && $ctrl.submitted }\">\n    <label>Template</label>\n\n    <select type=\"text\" name=\"template\" class=\"form-control\" ng-model=\"$ctrl.selectedTemplateLevel\"\n            ng-options=\"o.level as o.level group by o.group for o in $ctrl.templates\"\n            ng-change=\"$ctrl.updateTemplate()\"></select>\n    <p class=\"help-block\" ng-show=\"form.template.$error.required && ctrl.submitted\">\n      Please specify the email you want to send to\n    </p>\n  </div>\n\n  <!-- Mail Subject -->\n  <div class=\"form-group\" ng-class=\"{ 'has-success': form.title.$valid && ctrl.submitted,\n                                            'has-error': form.title.$invalid && ctrl.submitted }\">\n    <label>Subject</label>\n    <input type=\"text\" name=\"subject\" class=\"form-control\" ng-model=\"$ctrl.email.subject\" required/>\n    <p class=\"help-block\" ng-show=\"form.name.$error.required && $ctrl.submitted\">\n      You must specify a subject for the mail\n    </p>\n  </div>\n\n  <!-- Mail Body -->\n  <div class=\"form-group\">\n    <a ng-click=\"$ctrl.openPreviewModal()\" style=\"float:right; cursor: pointer\"><i class=\"fa fa-fw fa-eye\"></i> Preview</a>\n    <label>Mail Text</label>\n    <text-angular ng-model=\"$ctrl.email.body\" ta-toolbar=\"$ctrl.toolbarDefinition\"></text-angular>\n\n    <!--<textarea name=\"body\" rows=\"12\" class=\"form-control\" ng-model=\"$ctrl.email.body\"></textarea>-->\n  </div>\n\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\" ng-disabled=\"$ctrl.totalAttachmentSize() > 10*1024*1024\">Send</button>\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n</div>\n"

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(14);
	
	exports.default = angular.module('conduuApp.htmliframe', []).directive('htmlIframe', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      content: "<"
	    },
	    link: function link(scope, element, attrs) {
	
	      var iframe = document.createElement('iframe');
	      var element0 = element[0];
	      element0.appendChild(iframe);
	
	      scope.$watch('content', function () {
	        iframe.contentWindow.document.open('text/htmlreplace');
	        iframe.contentWindow.document.write(scope.content);
	        iframe.contentWindow.document.close();
	      });
	    }
	  };
	}).name;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var iframePreviewComponent = exports.iframePreviewComponent = function () {
	  /*@ngInject*/
	  function iframePreviewComponent() {
	    _classCallCheck(this, iframePreviewComponent);
	  }
	
	  _createClass(iframePreviewComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.config = this.resolve.config;
	      this.content = this.config.content;
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.cancel();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return iframePreviewComponent;
	}();
	
	exports.default = angular.module('conduApp.iframePreview', []).component('iframePreview', {
	  template: __webpack_require__(746),
	  bindings: {
	    resolve: '<',
	    dismiss: '&'
	  },
	  controller: iframePreviewComponent
	}).name;

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">{{$ctrl.config.title || 'Preview'}}</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\" style=\"padding:0px !important\">\r\n\r\n  <html-iframe content=\"$ctrl.content\"></html-iframe>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">Close</button>\r\n</div>\r\n"

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	StripeService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StripeService = StripeService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function StripeService($resource) {
	  return $resource('/api/integrations/stripe/:id', {
	    id: '@_id'
	  }, {
	    getAccount: {
	      method: 'GET',
	      url: '/api/integrations/stripe/account/:id'
	    },
	    getPayments: {
	      method: 'GET',
	      url: '/api/integrations/stripe/account/:id/payments',
	      isArray: true
	    },
	    getPaymentsByContact: {
	      method: 'GET',
	      url: '/api/integrations/stripe/account/:id/contact/:email/payments',
	      isArray: true
	    }
	  });
	}
	
	exports.default = angular.module('conduu.StripeService', []).factory('StripeService', StripeService).name;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var ConnectedAccountDetailsComponent = exports.ConnectedAccountDetailsComponent = function () {
	  /*@ngInject*/
	  function ConnectedAccountDetailsComponent() {
	    _classCallCheck(this, ConnectedAccountDetailsComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	      this.data = this.config.data;
	    };
	  }
	
	  _createClass(ConnectedAccountDetailsComponent, [{
	    key: 'ok',
	    value: function ok() {
	      this.close();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return ConnectedAccountDetailsComponent;
	}();
	
	exports.default = angular.module('conduu.connectedAccountDetails', []).component('connectedAccountDetails', {
	  template: __webpack_require__(749),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: ConnectedAccountDetailsComponent
	}).name;

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">Connected Account Details</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n\r\n  <h4 class=\"separator\"><span>General</span></h4>\r\n  <dl class=\"dl-horizontal\">\r\n    <dt>Country</dt>\r\n    <dd>{{$ctrl.data.country}}</dd>\r\n\r\n    <dt>Email</dt>\r\n    <dd>{{$ctrl.data.email}}</dd>\r\n\r\n    <dt>Business Type</dt>\r\n    <dd>{{$ctrl.data.business_type}}</dd>\r\n  </dl>\r\n\r\n  <h4 class=\"separator\"><span>Business Profile</span></h4>\r\n  <dl class=\"dl-horizontal\">\r\n    <dt>Name</dt>\r\n    <dd>{{$ctrl.data.business_profile.name}}</dd>\r\n\r\n    <dt>URL</dt>\r\n    <dd>{{$ctrl.data.business_profile.url}}</dd>\r\n  </dl>\r\n\r\n  <h4 class=\"separator\"><span>Banking Accounts</span></h4>\r\n  <table class=\"table table-condensed\">\r\n    <thead>\r\n      <tr>\r\n        <th>Account Holder</th>\r\n        <th>Type</th>\r\n        <th>Account&nbsp;#</th>\r\n        <th>Routing&nbsp;#</th>\r\n        <th>Bank</th>\r\n      </tr>\r\n    </thead>\r\n    <tboday>\r\n      <tr ng-repeat=\"ba in $ctrl.data.external_accounts.data\">\r\n        <td>{{ba.account_holder_name}}</td>\r\n        <td>{{ba.account_holder_type}}</td>\r\n        <td>***{{ba.last4}}</td>\r\n        <td>{{ba.routing_number}}</td>\r\n        <td>{{ba.bank_name}}</td>\r\n      </tr>\r\n    </tboday>\r\n  </table>\r\n\r\n  <h4 class=\"separator\"><span>Capabilities</span></h4>\r\n  <dl class=\"dl-horizontal\">\r\n    <dt>Payouts Enabled</dt>\r\n    <dd>\r\n      <span ng-show=\"$ctrl.data.payouts_enabled\"><i class=\"fa fa-fw fa-check\"></i> Yes</span>\r\n      <span ng-show=\"!$ctrl.data.payouts_enabled\"><i class=\"fa fa-fw fa-times\"></i> No</span>\r\n    </dd>\r\n\r\n    <dt>Charges Enabled</dt>\r\n    <dd>\r\n      <span ng-show=\"$ctrl.data.charges_enabled\"><i class=\"fa fa-fw fa-check\"></i> Yes</span>\r\n      <span ng-show=\"!$ctrl.data.charges_enabled\"><i class=\"fa fa-fw fa-times\"></i> No</span>\r\n    </dd>\r\n  </dl>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.cancel()\">Close</button>\r\n</div>\r\n"

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var ConnectedAccountChargesComponent = exports.ConnectedAccountChargesComponent = function () {
	  /*@ngInject*/
	  ConnectedAccountChargesComponent.$inject = ['StripeService', 'DTOptionsBuilder', 'WebAccessService'];
	  function ConnectedAccountChargesComponent(StripeService, DTOptionsBuilder, WebAccessService) {
	    _classCallCheck(this, ConnectedAccountChargesComponent);
	
	    this.StripeService = StripeService;
	    this.DTOptionsBuilder = DTOptionsBuilder;
	    this.WebAccessService = WebAccessService;
	
	    this.mapContact = {};
	    this.isLoading = true;
	  }
	
	  _createClass(ConnectedAccountChargesComponent, [{
	    key: 'loadData',
	    value: function loadData() {
	      var _this = this;
	
	      if (this.config.accountId && this.config.contactEmail) {
	        this.StripeService.getPaymentsByContact({ id: this.config.accountId, email: this.config.contactEmail }, function (data) {
	          _this.data = data;
	          _this.isLoading = false;
	        });
	      } else {
	        this.StripeService.getPayments({ id: this.config.accountId }, function (data) {
	          _this.data = data;
	          _this.isLoading = false;
	        });
	      }
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.config = this.resolve.config;
	
	      this.title = this.config.title || 'Connected Account Payments';
	
	      this.dtOptions = this.DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [0, 'asc']).withOption('responsive', true).withOption('buttons', [{
	        extend: 'excel',
	        title: "Payments " + this.config.name
	      }, {
	        extend: 'csv',
	        title: "Payments " + this.config.name
	      }, {
	        title: "Payments " + this.config.name,
	        message: 'As of ' + moment().format("MMMM Do YYYY"),
	        extend: 'pdf',
	        orientation: 'landscape',
	        pageSize: 'LETTER'
	      }, {
	        extend: 'print',
	        title: "Payments " + this.config.name
	      }]);
	
	      if (!this.config.contactEmail) {
	        this.WebAccessService.query(function (data) {
	          data.forEach(function (wa) {
	            return _this2.mapContact[wa._id] = wa;
	          });
	          _this2.loadData();
	        }, function (err) {
	          console.log("Could not retrieve website access.");
	        });
	      } else {
	        this.loadData();
	      }
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.close();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return ConnectedAccountChargesComponent;
	}();
	
	exports.default = angular.module('conduu.connectedAccountCharges', []).component('connectedAccountCharges', {
	  template: __webpack_require__(751),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: ConnectedAccountChargesComponent
	}).name;

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">{{$ctrl.title}}</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n\r\n  <h5 ng-if=\"$ctrl.isLoading\"><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> Retrieving Payments Data</h5>\r\n\r\n  <table ng-if=\"$ctrl.data.length && !$ctrl.isLoading\" datatable=\"ng\" dt-options=\"$ctrl.dtOptions\" class=\"table\">\r\n    <thead>\r\n    <tr>\r\n      <th ng-if=\"!$ctrl.config.contactEmail\">Contact</th>\r\n      <th>Amount</th>\r\n      <th>Date</th>\r\n      <th>Description</th>\r\n      <th>Payment Method</th>\r\n      <th>Status</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n      <tr ng-repeat=\"payment in $ctrl.data\" ng-class=\"{'text-danger': !payment.paid}\">\r\n        <td ng-if=\"!$ctrl.config.contactEmail\">\r\n          <span ng-if=\"payment.metadata.webaccessId\">{{$ctrl.mapContact[payment.metadata.webaccessId].contact.lastName}}, {{$ctrl.mapContact[payment.metadata.webaccessId].contact.firstName}}</span>\r\n        </td>\r\n        <td>$&nbsp;{{(payment.metadata.netAmount || payment.amount) / 100 | number:'2'}}</td>\r\n        <td>{{payment.metadata.creationDate | date:'short'}}</td>\r\n        <td>{{payment.description}}</td>\r\n        <td>\r\n          <span ng-if=\"payment.payment_method_details.type == 'card'\" class=\"text-uppercase\"><i class=\"fa fa-fw fa-credit-card\"></i> ***{{payment.payment_method_details.card.last4}} <nobr>({{payment.payment_method_details.card.network}})</nobr></span>\r\n          <span ng-if=\"payment.payment_method_details.type == 'ach_debit'\"><i class=\"fa fa-fw fa-university\"></i> ***{{payment.payment_method_details.ach_debit.last4}} <nobr>({{payment.payment_method_details.ach_debit.bank_name}})</nobr></span>\r\n        </td>\r\n        <td>\r\n          <span ng-if=\"payment.paid\"><i class=\"fa fa-fw fa-check\"></i> Paid</span>\r\n          <span ng-if=\"!payment.paid\"><i class=\"fa fa-fw fa-times\"></i> {{payment.failure_message}}</span>\r\n        </td>\r\n      </tr>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.cancel()\">Close</button>\r\n</div>\r\n"

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(14);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _admin = __webpack_require__(753);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _admin3 = __webpack_require__(755);
	
	var _admin4 = _interopRequireDefault(_admin3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uiRouter = __webpack_require__(28);
	
	exports.default = _angular2.default.module('conduu.userList', [uiRouter]).config(_admin2.default).controller('AdminController', _admin4.default).name;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('admin', {
	    url: '/admin/users',
	    template: __webpack_require__(754),
	    controller: 'AdminController',
	    controllerAs: 'admin',
	    authenticate: 'suite-admin'
	  });
	}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" ng-click=\"admin.openAddUserModal()\"><i class=\"fa fa-plus\"></i> Add User</a>\r\n      <h2>User Management</h2>\r\n      <li class=\"active\"><a href=\"#\">User Management</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <table datatable=\"ng\" dt-options=\"admin.dtOptions\" class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>Name</th>\r\n          <th>Mail</th>\r\n          <th>Roles</th>\r\n          <th>Admin</th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr ng-repeat=\"user in admin.users\">\r\n            <td>\r\n              <strong><a ng-href=\"/profile/user/{{user._id}}\">{{user.lastName}}, {{user.firstName}} {{user.middleName}}</a></strong>\r\n            </td>\r\n            <td>\r\n              <span>{{user.email}}</span>\r\n            </td>\r\n            <td ng-if=\"!admin.isSuperAdmin()\">\r\n              <span class=\"label\" style=\"margin-right:2px\" ng-class=\"role.indexOf('ev') !== -1 ? 'label-default' : role.indexOf('suite') !== -1 ? 'label-primary' : 'label-info'\"\r\n                    ng-repeat=\"role in user.role\">{{role}}</span>\r\n            </td>\r\n            <td ng-if=\"admin.isSuperAdmin()\">\r\n              <a style=\"text-decoration: none; color:black;\" href=\"#\" e-single inplace-edit-hover\r\n                 editable-checklist=\"user.role\" e-ng-options=\"r as r for r in admin.roles\"\r\n                 onaftersave=\"admin.patchUserRoles(user)\">\r\n                <span class=\"label\" style=\"margin-right:2px\" ng-class=\"role.indexOf('ev') !== -1 ? 'label-default' : role.indexOf('suite') !== -1 ? 'label-primary' : 'label-info'\" ng-repeat=\"role in user.role\">{{role}}</span>\r\n                <span ng-if=\"user.role.length == 0\">no role assigned</span>\r\n              </a>\r\n            </td>\r\n            <td>\r\n              <nobr>\r\n                <!--<a ng-show=\"admin.isSuperAdmin()\" class=\"btn btn-primary btn-sm\" ng-href=\"/history/{{user._id}}\"><i class=\"fa fa-fw fa-history\"></i> Activity</a>-->\r\n                <a ng-click=\"admin.delete(user)\" class=\"btn btn-danger btn-sm\"><span class=\"fa fa-trash\"></span> Delete</a>\r\n              </nobr>\r\n            </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminController = function () {
	  /*@ngInject*/
	  AdminController.$inject = ['User', 'dialogs', 'Auth', 'DTOptionsBuilder', '$uibModal', 'DTState', 'SettingsService'];
	  function AdminController(User, dialogs, Auth, DTOptionsBuilder, $uibModal, DTState, SettingsService) {
	    var _this = this;
	
	    _classCallCheck(this, AdminController);
	
	    this.users = User.query();
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.isSuperAdmin = Auth.isSuperAdminSync;
	    this.isAdmin = Auth.isAdminSync;
	    this.roles = ["user", "admin", "superadmin", "suite-user", "suite-admin", "suite-superadmin"];
	    this.Auth = Auth;
	    this.User = User;
	
	    SettingsService.getByName({ name: 'client' }, function (clientData) {
	      _this.eVotingEnabled = clientData.data.eVotingEnabled;
	
	      if (_this.eVotingEnabled) {
	        _this.roles = _this.roles.concat(['ev-user', 'ev-admin', 'ev-superadmin']);
	      }
	    });
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: 'User List'
	    }, {
	      extend: 'csv',
	      title: 'User List'
	    }, {
	      title: 'User List',
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'landscape',
	      pageSize: 'LETTER'
	    }, 'print']);
	  }
	
	  _createClass(AdminController, [{
	    key: "patchUserRoles",
	    value: function patchUserRoles(user) {
	      this.Auth.patchUserRoles(user);
	    }
	  }, {
	    key: "openAddUserModal",
	    value: function openAddUserModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'schemaFormModal',
	        resolve: {
	          config: function config() {
	            return {
	              title: "Add User",
	              icon: "user-plus",
	              intro: "<p>* Required</p>",
	              outro: "<h5>If checked, the new user will get an invitation email with login instructions (including the initial password). If you are not sending out the invitation email, it is up to you to communicate the initial credentials to the new user!</h5>",
	              schema: {
	                type: "object",
	                properties: {
	                  firstName: {
	                    type: "string",
	                    title: "First Name *"
	                  },
	                  lastName: {
	                    type: "string",
	                    title: "Last Name *"
	                  },
	                  email: {
	                    type: "string",
	                    title: 'Email *',
	                    pattern: "^\\S+@\\S+$",
	                    validationMessage: "Must be a valid email"
	                  },
	                  password: {
	                    type: "string",
	                    title: "Initial Password *"
	                  },
	                  sendInvitationEmail: {
	                    type: "boolean",
	                    title: "Send Invitation Email"
	                  }
	                },
	                required: ["firstName", "lastName", "email", "password"]
	              }
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (newUser) {
	        that.User.save(newUser, function (_) {
	          that.users = that.User.query();
	        }, function (err) {
	          console.log("the user could not be created");
	        });
	      }, function () {});
	    }
	  }, {
	    key: "delete",
	    value: function _delete(user) {
	      var _this2 = this;
	
	      var userStr = "<br/><br/><b>" + user.firstName + ' ' + user.lastName + "</b>";
	      var dlg = this.dialogs.confirm("Delete user?", "Do you really want to delete this user?" + userStr);
	      dlg.result.then(function () {
	        user.$remove();
	        _this2.users.splice(_this2.users.indexOf(user), 1);
	      }, function () {});
	    }
	  }]);
	
	  return AdminController;
	}();
	
	exports.default = AdminController;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var SchemaFormModalComponent = exports.SchemaFormModalComponent = function () {
	  /*@ngInject*/
	  SchemaFormModalComponent.$inject = ['$scope', 'PropertyService', 'ContactService', 'CommunityService', 'User', '$uibModal', 'StorageService'];
	  function SchemaFormModalComponent($scope, PropertyService, ContactService, CommunityService, User, $uibModal, StorageService) {
	    _classCallCheck(this, SchemaFormModalComponent);
	
	    this.$scope = $scope;
	    this.$uibModal = $uibModal;
	
	    this.StorageService = StorageService;
	    this.PropertyService = PropertyService;
	    this.ContactService = ContactService;
	    this.CommunityService = CommunityService;
	    this.User = User;
	  }
	
	  _createClass(SchemaFormModalComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.config = this.resolve.config;
	      this.schema = this.config.schema;
	      this.title = this.config.title || "Form";
	      this.model = this.config.model || {};
	      this.form = this.config.form || ["*"];
	
	      this.intro = this.config.intro;
	      this.outro = this.config.outro;
	
	      this.icon = this.config.icon;
	
	      this.count = 0;
	      this.maxCount = 4;
	
	      var fnReady = function fnReady(_) {
	        var keys = Object.keys(_this.schema.properties);
	        keys.forEach(function (key) {
	          if (_this.schema.properties[key].hasOwnProperty("x-schema-form")) {
	            var ref = _this.schema.properties[key]["x-schema-form"];
	            if (ref.type === 'entitylookup') {
	
	              switch (ref.lookuptype) {
	                case 'property':
	                  _this.schema.properties[key]["entityLookupData"] = _this.propertyData;
	                  _this.schema.properties[key]["fnLookup"] = function (key) {
	                    _this.propertyLookup(key);
	                  };
	                  break;
	                case 'user':
	                  _this.schema.properties[key]["entityLookupData"] = _this.userData;
	                  _this.schema.properties[key]["fnLookup"] = function (key) {
	                    _this.userLookup(key);
	                  };
	                  break;
	                case 'contact':
	                  _this.schema.properties[key]["entityLookupData"] = _this.contactData;
	                  _this.schema.properties[key]["fnLookup"] = function (key) {
	                    _this.contactLookup(key);
	                  };
	                  break;
	                case 'community':
	                  _this.schema.properties[key]["entityLookupData"] = _this.communityData;
	                  _this.schema.properties[key]["fnLookup"] = function (key) {
	                    _this.communityLookup(key);
	                  };
	                  break;
	              }
	            } else if (ref.type == 'single-file-upload') {
	              _this.schema.properties[key]["fnOpenAssetUploadModal"] = function (key) {
	                _this.openAssetUploadModal(key);
	              };
	            }
	          }
	        });
	      };
	
	      this.PropertyService.query(function (data) {
	        _this.propertyData = data.filter(function (entity) {
	          return !!entity.address;
	        }).map(function (entity) {
	          return {
	            value: entity._id,
	            name: entity.address.street + ", " + entity.address.city + ", " + entity.address.state + ", " + entity.address.zip,
	            group: entity.community.name
	          };
	        });
	
	        _this.count++;
	        if (_this.count == _this.maxCount) fnReady();
	      });
	
	      this.ContactService.query(function (data) {
	        _this.contactData = data.map(function (entity) {
	          return {
	            value: entity._id,
	            name: _this.getComposedName(entity),
	            group: "General"
	          };
	        });
	
	        _this.count++;
	        if (_this.count == _this.maxCount) fnReady();
	      });
	
	      this.CommunityService.query(function (data) {
	        _this.communityData = data.map(function (entity) {
	          return {
	            value: entity._id,
	            name: entity.code + ": " + entity.name,
	            group: "General"
	          };
	        });
	
	        _this.count++;
	        if (_this.count == _this.maxCount) fnReady();
	      });
	
	      this.User.query(function (users) {
	        _this.userData = users.map(function (user) {
	          return {
	            value: user._id,
	            name: user.shortName,
	            group: 'General'
	          };
	        });
	
	        _this.count++;
	        if (_this.count == _this.maxCount) fnReady();
	      });
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal(key) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        }
	      });
	
	      modalInstance.result.then(function (result) {
	
	        if (result && result.length > 0) {
	          that.model[key] = result[0];
	        }
	      }, function () {});
	    }
	  }, {
	    key: 'contactLookup',
	    value: function contactLookup(key) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'contactLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (contact) {
	        that.model[key] = contact._id;
	      }, function () {});
	    }
	  }, {
	    key: 'userLookup',
	    value: function userLookup(key) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'userLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (user) {
	        that.model[key] = user._id;
	      }, function () {});
	    }
	  }, {
	    key: 'propertyLookup',
	    value: function propertyLookup(key) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'propertyLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (property) {
	        that.model[key] = property._id;
	      }, function () {});
	    }
	  }, {
	    key: 'communityLookup',
	    value: function communityLookup(key) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'communityLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (community) {
	        that.model[key] = community._id;
	      }, function () {});
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += " (" + contact.company + ")";
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'ok',
	    value: function ok(model) {
	      this.close({ $value: model });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      this.submitted = true;
	      this.sendFailure = false;
	
	      this.$scope.$broadcast('schemaFormValidate');
	
	      if (form.$valid) {
	        this.ok(this.model);
	      }
	    }
	  }]);
	
	  return SchemaFormModalComponent;
	}();
	
	exports.default = angular.module('conduu.schemaFormModal', []).component('schemaFormModal', {
	  template: __webpack_require__(757),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: SchemaFormModalComponent
	}).name;

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	module.exports = "<form name=\"form\" ng-submit=\"$ctrl.create(form)\">\r\n\r\n  <div class=\"modal-header\">\r\n    <h3 class=\"modal-title\" id=\"modal-title\"><i ng-if=\"$ctrl.icon\" class=\"fa fa-fw fa-{{$ctrl.icon}}\"></i> {{$ctrl.title}}</h3>\r\n  </div>\r\n\r\n  <div class=\"modal-body\" id=\"modal-body\">\r\n\r\n    <div ng-if=\"$ctrl.intro\" ng-bind-html=\"$ctrl.intro\"></div>\r\n\r\n    <div sf-schema=\"$ctrl.schema\" sf-form=\"$ctrl.form\" sf-model=\"$ctrl.model\"></div>\r\n\r\n    <div ng-if=\"$ctrl.outro\" ng-bind-html=\"$ctrl.outro\"></div>\r\n\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n    <button class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n  </div>\r\n\r\n</form>\r\n"

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(14);
	var $ = __webpack_require__(2);
	
	exports.default = angular.module('conduu.ap.components.inplaceEditHover', []).directive('inplaceEditHover', function () {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	
	      $(element).hover(function () {
	        var preventBehaviour = $(this).hasClass("inplace-edit-hover-disabled");
	        var editOnLabel = $(this).hasClass("inplace-edit-hover-on-label");
	
	        if (!preventBehaviour) {
	          if (editOnLabel) {
	            $(this).css('cursor', 'pointer').append("<span class='inplace-edit label label-default' style='margin-left:4px; margin-top:2px; position:absolute;'><i class='fa fa-pencil fa-2x'></i></span>");
	          } else {
	            $(this).css('cursor', 'pointer').append("<i class='fa fa-pencil' style='padding-left:4px; position:absolute;'></i>");
	          }
	        }
	      }, function () {
	        var editOnLabel = $(this).hasClass("inplace-edit-hover-on-label");
	        if (editOnLabel) {
	          $(this).css('cursor', '').children("span.inplace-edit").remove();
	        } else {
	          $(this).css('cursor', '').children("i").remove();
	        }
	      });
	    }
	  };
	}).name;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(760);
	module.exports = 'angulartics';


/***/ }),
/* 760 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics
	 * (c) 2013 Luis Farzati http://angulartics.github.io/
	 * License: MIT
	 */
	(function(angular, analytics) {
	'use strict';
	
	var angulartics = window.angulartics || (window.angulartics = {});
	angulartics.waitForVendorCount = 0;
	angulartics.waitForVendorApi = function (objectName, delay, containsField, registerFn, onTimeout) {
	  if (!onTimeout) { angulartics.waitForVendorCount++; }
	  if (!registerFn) { registerFn = containsField; containsField = undefined; }
	  if (!Object.prototype.hasOwnProperty.call(window, objectName) || (containsField !== undefined && window[objectName][containsField] === undefined)) {
	    setTimeout(function () { angulartics.waitForVendorApi(objectName, delay, containsField, registerFn, true); }, delay);
	  }
	  else {
	    angulartics.waitForVendorCount--;
	    registerFn(window[objectName]);
	  }
	};
	
	/**
	 * @ngdoc overview
	 * @name angulartics
	 */
	angular.module('angulartics', [])
	.provider('$analytics', $analytics)
	.run(['$rootScope', '$window', '$analytics', '$injector', $analyticsRun])
	.directive('analyticsOn', ['$analytics', analyticsOn])
	.config(['$provide', exceptionTrack]);
	
	function $analytics() {
	  var vm = this;
	
	  var settings = {
	    pageTracking: {
	      autoTrackFirstPage: true,
	      autoTrackVirtualPages: true,
	      trackRelativePath: false,
	      trackRoutes: true,
	      trackStates: true,
	      autoBasePath: false,
	      basePath: '',
	      excludedRoutes: [],
	      queryKeysWhitelisted: [],
	      queryKeysBlacklisted: [],
	      filterUrlSegments: []
	    },
	    eventTracking: {},
	    bufferFlushDelay: 1000, // Support only one configuration for buffer flush delay to simplify buffering
	    trackExceptions: false,
	    optOut: false,
	    developerMode: false // Prevent sending data in local/development environment
	  };
	
	  // List of known handlers that plugins can register themselves for
	  var knownHandlers = [
	    'pageTrack',
	    'eventTrack',
	    'exceptionTrack',
	    'transactionTrack',
	    'setAlias',
	    'setUsername',
	    'setUserProperties',
	    'setUserPropertiesOnce',
	    'setSuperProperties',
	    'setSuperPropertiesOnce',
	    'incrementProperty',
	    'userTimings',
	    'clearCookies'
	  ];
	  // Cache and handler properties will match values in 'knownHandlers' as the buffering functons are installed.
	  var cache = {};
	  var handlers = {};
	  var handlerOptions = {};
	
	  // General buffering handler
	  function bufferedHandler(handlerName){
	    return function(){
	      if(angulartics.waitForVendorCount){
	        if(!cache[handlerName]){ cache[handlerName] = []; }
	        cache[handlerName].push(arguments);
	      }
	    };
	  }
	
	  // As handlers are installed by plugins, they get pushed into a list and invoked in order.
	  function updateHandlers(handlerName, fn, options){
	    if(!handlers[handlerName]){
	      handlers[handlerName] = [];
	    }
	    handlers[handlerName].push(fn);
	    handlerOptions[fn] = options;
	    return function(){
	      if(!this.settings.optOut) {
	        var handlerArgs = Array.prototype.slice.apply(arguments);
	        return this.$inject(['$q', angular.bind(this, function($q) {
	          return $q.all(handlers[handlerName].map(function(handlerFn) {
	            var options = handlerOptions[handlerFn] || {};
	            if (options.async) {
	              var deferred = $q.defer();
	              var currentArgs = angular.copy(handlerArgs);
	              currentArgs.unshift(deferred.resolve);
	              handlerFn.apply(this, currentArgs);
	              return deferred.promise;
	            } else{
	              return $q.when(handlerFn.apply(this, handlerArgs));
	            }
	          }, this));
	        })]);
	      }
	    };
	  }
	
	  // The api (returned by this provider) gets populated with handlers below.
	  var api = {
	    settings: settings
	  };
	
	  // Opt in and opt out functions
	  api.setOptOut = function(optOut) {
	    this.settings.optOut = optOut;
	    triggerRegister();
	  };
	
	  api.getOptOut = function() {
	    return this.settings.optOut;
	  };
	
	
	  // Will run setTimeout if delay is > 0
	  // Runs immediately if no delay to make sure cache/buffer is flushed before anything else.
	  // Plugins should take care to register handlers by order of precedence.
	  function onTimeout(fn, delay){
	    if(delay){
	      setTimeout(fn, delay);
	    } else {
	      fn();
	    }
	  }
	
	  var provider = {
	    $get: ['$injector', function($injector) {
	      return apiWithInjector($injector);
	    }],
	    api: api,
	    settings: settings,
	    virtualPageviews: function (value) { this.settings.pageTracking.autoTrackVirtualPages = value; },
	    trackStates: function (value) { this.settings.pageTracking.trackStates = value; },
	    trackRoutes: function (value) { this.settings.pageTracking.trackRoutes = value; },
	    excludeRoutes: function(routes) { this.settings.pageTracking.excludedRoutes = routes; },
	    queryKeysWhitelist: function(keys) { this.settings.pageTracking.queryKeysWhitelisted = keys; },
	    queryKeysBlacklist: function(keys) { this.settings.pageTracking.queryKeysBlacklisted = keys; },
	    filterUrlSegments: function(filters) { this.settings.pageTracking.filterUrlSegments = filters; },
	    firstPageview: function (value) { this.settings.pageTracking.autoTrackFirstPage = value; },
	    withBase: function (value) {
	      this.settings.pageTracking.basePath = (value) ? angular.element(document).find('base').attr('href') : '';
	    },
	    withAutoBase: function (value) { this.settings.pageTracking.autoBasePath = value; },
	    trackExceptions: function (value) { this.settings.trackExceptions = value; },
	    developerMode: function(value) { this.settings.developerMode = value; }
	  };
	
	  // General function to register plugin handlers. Flushes buffers immediately upon registration according to the specified delay.
	  function register(handlerName, fn, options){
	    // Do not add a handler if developerMode is true
	    if (settings.developerMode) {
	        return;
	    }
	    api[handlerName] = updateHandlers(handlerName, fn, options);
	    var handlerSettings = settings[handlerName];
	    var handlerDelay = (handlerSettings) ? handlerSettings.bufferFlushDelay : null;
	    var delay = (handlerDelay !== null) ? handlerDelay : settings.bufferFlushDelay;
	    angular.forEach(cache[handlerName], function (args, index) {
	      onTimeout(function () { fn.apply(this, args); }, index * delay);
	    });
	  }
	
	  function capitalize(input) {
	      return input.replace(/^./, function (match) {
	          return match.toUpperCase();
	      });
	  }
	
	  //provide a method to inject services into handlers
	  var apiWithInjector = function(injector) {
	    return angular.extend(api, {
	      '$inject': injector.invoke
	    });
	  };
	
	  // Adds to the provider a 'register#{handlerName}' function that manages multiple plugins and buffer flushing.
	  function installHandlerRegisterFunction(handlerName){
	    var registerName = 'register'+capitalize(handlerName);
	    provider[registerName] = function(fn, options){
	      register(handlerName, fn, options);
	    };
	    api[handlerName] = updateHandlers(handlerName, bufferedHandler(handlerName));
	  }
	
	  function startRegistering(_provider, _knownHandlers, _installHandlerRegisterFunction) {
	    angular.forEach(_knownHandlers, _installHandlerRegisterFunction);
	
	    for (var key in _provider) {
	      vm[key] = _provider[key];
	    }
	  }
	
	  // Allow $angulartics to trigger the register to update opt in/out
	  var triggerRegister = function() {
	    startRegistering(provider, knownHandlers, installHandlerRegisterFunction);
	  };
	
	  // Initial register
	  startRegistering(provider, knownHandlers, installHandlerRegisterFunction);
	
	}
	
	function $analyticsRun($rootScope, $window, $analytics, $injector) {
	
	  function matchesExcludedRoute(url) {
	    for (var i = 0; i < $analytics.settings.pageTracking.excludedRoutes.length; i++) {
	      var excludedRoute = $analytics.settings.pageTracking.excludedRoutes[i];
	      if ((excludedRoute instanceof RegExp && excludedRoute.test(url)) || url.indexOf(excludedRoute) > -1) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function arrayDifference(a1, a2) {
	    var result = [];
	    for (var i = 0; i < a1.length; i++) {
	      if (a2.indexOf(a1[i]) === -1) {
	        result.push(a1[i]);
	      }
	    }
	    return result;
	  }
	
	  function filterQueryString(url, keysMatchArr, thisType){
	    if (/\?/.test(url) && keysMatchArr.length > 0) {
	      var urlArr = url.split('?');
	      var urlBase = urlArr[0];
	      var pairs = urlArr[1].split('&');
	      var matchedPairs = [];
	
	      for (var i = 0; i < keysMatchArr.length; i++) {
	        var listedKey = keysMatchArr[i];
	        for (var j = 0; j < pairs.length; j++) {
	          if ((listedKey instanceof RegExp && listedKey.test(pairs[j])) || pairs[j].indexOf(listedKey) > -1) matchedPairs.push(pairs[j]);
	        }
	      }
	
	      var matchedPairsArr = (thisType == 'white' ? matchedPairs : arrayDifference(pairs,matchedPairs));
	      if(matchedPairsArr.length > 0){
	        return urlBase + '?' + matchedPairsArr.join('&');
	      }else{
	        return urlBase;
	      }
	    } else {
	      return url;
	    }
	  }
	
	  function whitelistQueryString(url){
	    return filterQueryString(url, $analytics.settings.pageTracking.queryKeysWhitelisted, 'white');
	  }
	
	  function blacklistQueryString(url){
	    return filterQueryString(url, $analytics.settings.pageTracking.queryKeysBlacklisted, 'black');
	  }
	
	  function filterUrlSegments(url){
	    var segmentFiltersArr = $analytics.settings.pageTracking.filterUrlSegments;
	
	    if (segmentFiltersArr.length > 0) {
	      var urlArr = url.split('?');
	      var urlBase = urlArr[0];
	
	      var segments = urlBase.split('/');
	
	      for (var i = 0; i < segmentFiltersArr.length; i++) {
	        var segmentFilter = segmentFiltersArr[i];
	
	        for (var j = 1; j < segments.length; j++) {
	          /* First segment will be host/protocol or base path. */
	          if ((segmentFilter instanceof RegExp && segmentFilter.test(segments[j])) || segments[j].indexOf(segmentFilter) > -1) {
	            segments[j] = 'FILTERED';
	          }
	        }
	      }
	
	      return segments.join('/');
	    } else {
	      return url;
	    }
	  }
	
	  function pageTrack(url, $location) {
	    if (!matchesExcludedRoute(url)) {
	      url = whitelistQueryString(url);
	      url = blacklistQueryString(url);
	      url = filterUrlSegments(url);
	      $analytics.pageTrack(url, $location);
	    }
	  }
	
	  if ($analytics.settings.pageTracking.autoTrackFirstPage) {
	    /* Only track the 'first page' if there are no routes or states on the page */
	    var noRoutesOrStates = true;
	    if ($injector.has('$route')) {
	       var $route = $injector.get('$route');
	       if ($route) {
	        for (var route in $route.routes) {
	          noRoutesOrStates = false;
	          break;
	        }
	       } else if ($route === null){
	        noRoutesOrStates = false;
	       }
	    } else if ($injector.has('$state')) {
	      var $state = $injector.get('$state');
	      if ($state.get().length > 1) noRoutesOrStates = false;
	    }
	    if (noRoutesOrStates) {
	      if ($analytics.settings.pageTracking.autoBasePath) {
	        $analytics.settings.pageTracking.basePath = $window.location.pathname;
	      }
	      $injector.invoke(['$location', function ($location) {
	        if ($analytics.settings.pageTracking.trackRelativePath) {
	          var url = $analytics.settings.pageTracking.basePath + $location.url();
	          pageTrack(url, $location);
	        } else {
	          pageTrack($location.absUrl(), $location);
	        }
	      }]);
	    }
	  }
	
	  if ($analytics.settings.pageTracking.autoTrackVirtualPages) {
	    if ($analytics.settings.pageTracking.autoBasePath) {
	      /* Add the full route to the base. */
	      $analytics.settings.pageTracking.basePath = $window.location.pathname + "#";
	    }
	    var noRoutesOrStates = true;
	
	    if ($analytics.settings.pageTracking.trackRoutes) {
	      if ($injector.has('$route')) {
	        var $route = $injector.get('$route');
	        if ($route) {
	          for (var route in $route.routes) {
	            noRoutesOrStates = false;
	            break;
	          }
	        } else if ($route === null){
	          noRoutesOrStates = false;
	        }
	        $rootScope.$on('$routeChangeSuccess', function (event, current) {
	          if (current && (current.$$route||current).redirectTo) return;
	          $injector.invoke(['$location', function ($location) {
	            var url = $analytics.settings.pageTracking.basePath + $location.url();
	            pageTrack(url, $location);
	          }]);
	        });
	      }
	    }
	
	    if ($analytics.settings.pageTracking.trackStates) {
	      if ($injector.has('$state') && !$injector.has('$transitions')) {
	        noRoutesOrStates = false;
	        $rootScope.$on('$stateChangeSuccess', function (event, current) {
	          $injector.invoke(['$location', function ($location) {
	            var url = $analytics.settings.pageTracking.basePath + $location.url();
	            pageTrack(url, $location);
	          }]);
	        });
	      }
	      if ($injector.has('$state') && $injector.has('$transitions')) {
	        noRoutesOrStates = false;
	        $injector.invoke(['$transitions', function($transitions) {
	          $transitions.onSuccess({}, function($transition$) {
	            var transitionOptions = $transition$.options();
	
	            // only track for transitions that would have triggered $stateChangeSuccess
	            if (transitionOptions.notify) {
	              $injector.invoke(['$location', function ($location) {
	                var url = $analytics.settings.pageTracking.basePath + $location.url();
	                pageTrack(url, $location);
	              }]);
	            }
	          });
	        }]);
	      }
	    }
	
	    if (noRoutesOrStates) {
	      $rootScope.$on('$locationChangeSuccess', function (event, current) {
	        if (current && (current.$$route || current).redirectTo) return;
	        $injector.invoke(['$location', function ($location) {
	          if ($analytics.settings.pageTracking.trackRelativePath) {
	            var url = $analytics.settings.pageTracking.basePath + $location.url();
	            pageTrack(url, $location);
	          } else {
	            pageTrack($location.absUrl(), $location);
	          }
	        }]);
	      });
	    }
	  }
	  if ($analytics.settings.developerMode) {
	    angular.forEach($analytics, function(attr, name) {
	      if (typeof attr === 'function') {
	        $analytics[name] = function(){};
	      }
	    });
	  }
	}
	
	function analyticsOn($analytics) {
	  return {
	    restrict: 'A',
	    link: function ($scope, $element, $attrs) {
	      var eventType = $attrs.analyticsOn || 'click';
	      var trackingData = {};
	
	      angular.forEach($attrs.$attr, function(attr, name) {
	        if (isProperty(name)) {
	          trackingData[propertyName(name)] = $attrs[name];
	          $attrs.$observe(name, function(value){
	            trackingData[propertyName(name)] = value;
	          });
	        }
	      });
	
	      angular.element($element[0]).on(eventType, function ($event) {
	        var eventName = $attrs.analyticsEvent || inferEventName($element[0]);
	        trackingData.eventType = $event.type;
	
	        if($attrs.analyticsIf){
	          if(! $scope.$eval($attrs.analyticsIf)){
	            return; // Cancel this event if we don't pass the analytics-if condition
	          }
	        }
	        // Allow components to pass through an expression that gets merged on to the event properties
	        // eg. analytics-properites='myComponentScope.someConfigExpression.$analyticsProperties'
	        if($attrs.analyticsProperties){
	          angular.extend(trackingData, $scope.$eval($attrs.analyticsProperties));
	        }
	        $analytics.eventTrack(eventName, trackingData);
	      });
	    }
	  };
	}
	
	function exceptionTrack($provide) {
	  $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function ($delegate, $injector) {
	    return function (error, cause) {
	      var result = $delegate(error, cause);
	      var $analytics = $injector.get('$analytics');
	      if ($analytics.settings.trackExceptions) {
	        $analytics.exceptionTrack(error, cause);
	      }
	      return result;
	    };
	  }]);
	}
	
	function isCommand(element) {
	  return ['a:','button:','button:button','button:submit','input:button','input:submit'].indexOf(
	    element.tagName.toLowerCase()+':'+(element.type||'')) >= 0;
	}
	
	function inferEventType(element) {
	  if (isCommand(element)) return 'click';
	  return 'click';
	}
	
	function inferEventName(element) {
	  if (isCommand(element)) return element.innerText || element.value;
	  return element.id || element.name || element.tagName;
	}
	
	function isProperty(name) {
	  return name.substr(0, 9) === 'analytics' && ['On', 'Event', 'If', 'Properties', 'EventType'].indexOf(name.substr(9)) === -1;
	}
	
	function propertyName(name) {
	  var s = name.slice(9); // slice off the 'analytics' prefix
	  if (typeof s !== 'undefined' && s!==null && s.length > 0) {
	    return s.substring(0, 1).toLowerCase() + s.substring(1);
	  }
	  else {
	    return s;
	  }
	}
	})(angular);


/***/ }),
/* 761 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * Piwik 2.1.x update contributed by http://github.com/highskillz
	 * License: MIT
	 */
	
	/* global _paq */
	
	(function (angular) {
	    'use strict';
	
	    /**
	     * @ngdoc overview
	     * @name angulartics.piwik
	     * Enables analytics support for Piwik (http://piwik.org/docs/tracking-api/)
	     */
	    angular.module('angulartics.piwik', ['angulartics'])
	        .config(['$analyticsProvider', '$windowProvider',
	            function ($analyticsProvider, $windowProvider) {
	
	                var $window = $windowProvider.$get();
	
	                $analyticsProvider.settings.pageTracking.trackRelativePath = true;
	
	                // Add piwik specific trackers to angulartics API
	
	                // Requires the CustomDimensions plugin for Piwik.
	                $analyticsProvider.api.setCustomDimension = function (dimensionId, value) {
	
	                    if ($window._paq) {
	                        $window._paq.push(['setCustomDimension', dimensionId, value]);
	                    }
	                };
	
	                // Requires the CustomDimensions plugin for Piwik.
	                $analyticsProvider.api.deleteCustomDimension = function (dimensionId) {
	
	                    if ($window._paq) {
	                        $window._paq.push(['deleteCustomDimension', dimensionId]);
	                    }
	                };
	
	                // scope: visit or page. Defaults to 'page'
	                $analyticsProvider.api.setCustomVariable = function (varIndex, varName, value, scope) {
	
	                    if ($window._paq) {
	                        scope = scope || 'page';
	                        $window._paq.push(['setCustomVariable', varIndex, varName, value, scope]);
	                    }
	                };
	
	                // scope: visit or page. Defaults to 'page'
	                $analyticsProvider.api.deleteCustomVariable = function (varIndex, scope) {
	
	                    if ($window._paq) {
	                        scope = scope || 'page';
	                        $window._paq.push(['deleteCustomVariable', varIndex, scope]);
	                    }
	                };
	
	                // trackSiteSearch(keyword, category, [searchCount])
	                $analyticsProvider.api.trackSiteSearch = function (keyword, category, searchCount) {
	
	                    // keyword is required
	                    if ($window._paq && keyword) {
	
	                        var params = ['trackSiteSearch', keyword, category || false];
	
	                        // searchCount is optional
	                        if (angular.isDefined(searchCount)) {
	                            params.push(searchCount);
	                        }
	
	                        $window._paq.push(params);
	                    }
	                };
	
	                // logs a conversion for goal 1. revenue is optional
	                // trackGoal(goalID, [revenue]);
	                $analyticsProvider.api.trackGoal = function (goalID, revenue) {
	                    if ($window._paq) {
	                        _paq.push(['trackGoal', goalID, revenue || 0]);
	                    }
	                };
	
	                // track outlink or download
	                // linkType is 'link' or 'download', 'link' by default
	                // trackLink(url, [linkType]);
	                $analyticsProvider.api.trackLink = function (url, linkType) {
	                    var type = linkType || 'link';
	                    if ($window._paq) {
	                        $window._paq.push(['trackLink', url, type]);
	                    }
	                };
	
	                // Set default angulartics page and event tracking
	
	                // $analytics.setUsername(username)
	                $analyticsProvider.registerSetUsername(function (username) {
	                    if ($window._paq) {
	                        $window._paq.push(['setUserId', username]);
	                    }
	                });
	
	                // $analytics.setAlias(alias)
	                // $analyticsProvider.registerSetAlias(function(param) {
	                //     // TODO: No piwik corresponding function found. Use setCustomVariable instead
	                // });
	
	                // $analytics.setUserProperties(properties)
	                // $analyticsProvider.registerSetUserProperties(function(param) {
	                //     // TODO: No piwik corresponding function found. Use setCustomVariable instead
	                // });
	
	                // locationObj is the angular $location object
	                $analyticsProvider.registerPageTrack(function (path, locationObj) {
	
	                    if ($window._paq) {
	                        $window._paq.push(['setDocumentTitle', $window.document.title]);
	                        $window._paq.push(['setCustomUrl', path]);
	                        $window._paq.push(['trackPageView']);
	                    }
	                });
	
	                /**
	                 * @name eventTrack
	                 * Track a basic event in Piwik, or send an ecommerce event.
	                 *
	                 * @param {string} action A string corresponding to the type of event that needs to be tracked.
	                 * @param {object} properties The properties that need to be logged with the event.
	                 */
	                $analyticsProvider.registerEventTrack(function (action, properties) {
	
	                    if ($window._paq) {
	                        properties = properties || {};
	
	                        switch (action) {
	
	                            /**
	                             * @description Sets the current page view as a product or category page view. When you call
	                             * setEcommerceView it must be followed by a call to trackPageView to record the product or
	                             * category page view.
	                             *
	                             * @link https://piwik.org/docs/ecommerce-analytics/#tracking-product-page-views-category-page-views-optional
	                             * @link https://developer.piwik.org/api-reference/tracking-javascript#ecommerce
	                             *
	                             * @property productSKU (required) SKU: Product unique identifier
	                             * @property productName (optional) Product name
	                             * @property categoryName (optional) Product category, or array of up to 5 categories
	                             * @property price (optional) Product Price as displayed on the page
	                             */
	                            case 'setEcommerceView':
	                                $window._paq.push(['setEcommerceView',
	                                    properties.productSKU,
	                                    properties.productName,
	                                    properties.categoryName,
	                                    properties.price]);
	                                break;
	
	                            /**
	                             * @description Adds a product into the ecommerce order. Must be called for each product in
	                             * the order.
	                             *
	                             * @link https://piwik.org/docs/ecommerce-analytics/#tracking-ecommerce-orders-items-purchased-required
	                             * @link https://developer.piwik.org/api-reference/tracking-javascript#ecommerce
	                             *
	                             * @property productSKU (required) SKU: Product unique identifier
	                             * @property productName (optional) Product name
	                             * @property categoryName (optional) Product category, or array of up to 5 categories
	                             * @property price (recommended) Product price
	                             * @property quantity (optional, default to 1) Product quantity
	                             */
	                            case 'addEcommerceItem':
	                                $window._paq.push(['addEcommerceItem',
	                                    properties.productSKU,
	                                    properties.productName,
	                                    properties.productCategory,
	                                    properties.price,
	                                    properties.quantity]);
	                                break;
	
	                            /**
	                             * @description Tracks a shopping cart. Call this javascript function every time a user is
	                             * adding, updating or deleting a product from the cart.
	                             *
	                             * @link https://piwik.org/docs/ecommerce-analytics/#tracking-add-to-cart-items-added-to-the-cart-optional
	                             * @link https://developer.piwik.org/api-reference/tracking-javascript#ecommerce
	                             *
	                             * @property grandTotal (required) Cart amount
	                             */
	                            case 'trackEcommerceCartUpdate':
	                                $window._paq.push(['trackEcommerceCartUpdate', properties.grandTotal]);
	                                break;
	
	                            /**
	                             * @description Tracks an Ecommerce order, including any ecommerce item previously added to
	                             * the order. orderId and grandTotal (ie. revenue) are required parameters.
	                             *
	                             * @link https://piwik.org/docs/ecommerce-analytics/#tracking-ecommerce-orders-items-purchased-required
	                             * @link https://developer.piwik.org/api-reference/tracking-javascript#ecommerce
	                             *
	                             * @property orderId (required) Unique Order ID
	                             * @property grandTotal (required) Order Revenue grand total (includes tax, shipping, and subtracted discount)
	                             * @property subTotal (optional) Order sub total (excludes shipping)
	                             * @property tax (optional) Tax amount
	                             * @property shipping (optional) Shipping amount
	                             * @property discount (optional) Discount offered (set to false for unspecified parameter)
	                             */
	                            case 'trackEcommerceOrder':
	                                $window._paq.push(['trackEcommerceOrder',
	                                    properties.orderId,
	                                    properties.grandTotal,
	                                    properties.subTotal,
	                                    properties.tax,
	                                    properties.shipping,
	                                    properties.discount]);
	                                break;
	
	                            /**
	                             * @description Logs an event with an event category (Videos, Music, Games...), an event
	                             * action (Play, Pause, Duration, Add Playlist, Downloaded, Clicked...), and an optional
	                             * event name and optional numeric value.
	                             *
	                             * @link https://piwik.org/docs/event-tracking/
	                             * @link https://developer.piwik.org/api-reference/tracking-javascript#using-the-tracker-object
	                             *
	                             * @property category
	                             * @property action
	                             * @property name (optional, recommended)
	                             * @property value (optional)
	                             */
	                            default:
	                                // PAQ requires that eventValue be an integer, see: http://piwik.org/docs/event-tracking
	                                if (properties.value) {
	                                    var parsed = parseInt(properties.value, 10);
	                                    properties.value = isNaN(parsed) ? 0 : parsed;
	                                }
	
	                                $window._paq.push(['trackEvent',
	                                    properties.category,
	                                    action,
	                                    properties.name || properties.label, // Changed in favour of Piwik documentation. Added fallback so it's backwards compatible.
	                                    properties.value]);
	                        }
	                    }
	                });
	
	                /**
	                 * @name exceptionTrack
	                 * Sugar on top of the eventTrack method for easily handling errors
	                 *
	                 * @param {object} error An Error object to track: error.toString() used for event 'action', error.stack used for event 'label'.
	                 * @param {object} cause The cause of the error given from $exceptionHandler, not used.
	                 */
	                $analyticsProvider.registerExceptionTrack(function (error, cause) {
	                    if ($window._paq) {
	                        $window._paq.push(['trackEvent', 'Exceptions', error.toString(), error.stack, 0]);
	                    }
	                });
	            }
	        ]);
	})(angular);


/***/ }),
/* 762 */
/***/ (function(module, exports) {

	'use strict';
	
	fxPickList.$inject = ['$compile', '$templateCache'];
	fxPickListForm.$inject = ['$compile', '$templateCache'];
	fxPickListSrc.$inject = ['$compile', '$templateCache'];
	fxPickListDest.$inject = ['$compile', '$templateCache'];
	function fxPickList($compile, $templateCache) {
	  return {
	    replace: true,
	    priority: 99,
	    templateUrl: "picklist.html",
	    restrict: 'E',
	    terminal: false,
	    scope: true,
	    controller: ['$scope', '$element', '$attrs', '$parse', function controller($scope, $element, $attrs, $parse) {
	      $scope.size = $attrs.size;
	      if (!angular.isDefined($scope.size)) {
	        $scope.size = 10;
	      }
	
	      $scope.formname = $attrs.name;
	
	      $scope.ngOptions = $attrs.pickOptions;
	
	      $scope.ngModel = $attrs.ngModel;
	      if (!angular.isDefined($attrs.ngModel)) {
	        $scope.ngModel = $attrs.pickModel;
	      }
	
	      delete $attrs['ngModel'];
	      $element.removeAttr('data-ng-model');
	      $element.removeAttr('ng-model');
	
	      $scope.picklist_src = [];
	      $scope.picklist_dest = [];
	
	      var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	      var match = $scope.ngOptions.match(NG_OPTIONS_REGEXP);
	      $scope.srcoptionsExp = match[7];
	      var displayFn = $parse(match[2] || match[1]),
	          valueName = match[4] || match[6],
	          keyName = match[5],
	          groupByFn = $parse(match[3] || ''),
	          valueFn = $parse(match[2] ? match[1] : valueName),
	          valuesFn = $parse(match[7]),
	          track = match[8],
	          trackFn = track ? $parse(match[8]) : null;
	
	      var hasValueFn = match[2] ? true : false;
	
	      var modelFn = $parse($scope.ngModel);
	      var models = modelFn($scope);
	
	      if (!angular.isDefined(models) || models == null) {
	        modelFn.assign($scope, []);
	      }
	
	      $scope.srcoptions = [];
	      $scope.destoptions = [];
	
	      $scope.valueToItem = function (value) {
	        if (!hasValueFn) {
	          return value;
	        }
	        return $scope.valueMap[value];
	      };
	
	      $scope.itemToValue = function (item) {
	        if (!hasValueFn) {
	          return item;
	        }
	        var local = {};
	        local[valueName] = item;
	        return valueFn($scope, local);
	      };
	
	      $scope.init = function () {
	        $scope.srcoptions.length = 0;
	        $scope.destoptions.length = 0;
	        $scope.valueMap = {};
	
	        var getter = $parse($scope.srcoptionsExp);
	        var options = getter($scope);
	        if (!options) {
	          return;
	        }
	        for (var i = 0; i < options.length; i++) {
	          $scope.srcoptions.push(options[i]);
	
	          if (hasValueFn) {
	            var value = $scope.itemToValue(options[i]);
	            $scope.valueMap[value] = options[i];
	          }
	        }
	        var models = $parse($scope.ngModel)($scope);
	
	        angular.forEach(models, function (v) {
	          $scope.destoptions.push($scope.valueToItem(v));
	        });
	        $scope.removeLeftFromRight($scope.destoptions, $scope.srcoptions);
	      };
	
	      $scope.$watchCollection($scope.srcoptionsExp, $scope.init);
	      $scope.$watchCollection($scope.ngModel, $scope.init);
	
	      $scope.rightShift = function () {
	        var models = modelFn($scope);
	        for (var i = 0; i < $scope.picklist_src.length; i++) {
	          models.push($scope.itemToValue($scope.picklist_src[i]));
	        }
	        $scope.removeLeftFromRight($scope.picklist_src, $scope.srcoptions);
	        $scope.picklist_src.length = 0;
	      };
	      $scope.rightShiftAll = function () {
	        var models = modelFn($scope);
	        for (var i = 0; i < $scope.srcoptions.length; i++) {
	          models.push($scope.itemToValue($scope.srcoptions[i]));
	        }
	        $scope.picklist_src.length = 0;
	        $scope.srcoptions.length = 0;
	      };
	      $scope.leftShift = function () {
	        var models = modelFn($scope);
	        for (var i = 0; i < $scope.picklist_dest.length; i++) {
	          $scope.srcoptions.push($scope.picklist_dest[i]);
	        }
	        $scope.removeLeftFromRight($scope.picklist_dest, $scope.destoptions);
	        while (models.length > 0) {
	          models.pop();
	        }
	        angular.forEach($scope.destoptions, function (item) {
	          models.push($scope.itemToValue(item));
	        });
	        $scope.picklist_dest.length = 0;
	      };
	
	      $scope.leftShiftAll = function () {
	        for (var i = 0; i < $scope.destoptions.length; i++) {
	          $scope.srcoptions.push($scope.destoptions[i]);
	        }
	        $scope.picklist_dest.length = 0;
	        $scope.destoptions.length = 0;
	        while (models.length > 0) {
	          models.pop();
	        }
	      };
	      $scope.arrowUp = function () {
	        var idxs = new Array();
	        for (var i = 0; i < $scope.picklist_dest.length; i++) {
	          for (var j = 0; j < $scope.destoptions.length; j++) {
	            if ($scope.picklist_dest[i] == $scope.destoptions[j]) {
	              idxs.push(j);
	            }
	          }
	        }
	        idxs.sort();
	        for (var i = 0; i < idxs.length; i++) {
	          var idx = idxs[i];
	          if (idx > 0) {
	            var temp = $scope.destoptions[idx - 1];
	            $scope.destoptions[idx - 1] = $scope.destoptions[idx];
	            $scope.destoptions[idx] = temp;
	          }
	        }
	        while (models.length > 0) {
	          models.pop();
	        }
	        angular.forEach($scope.destoptions, function (item) {
	          models.push($scope.itemToValue(item));
	        });
	      };
	      $scope.arrowDown = function () {
	        var idxs = new Array();
	        for (var i = 0; i < $scope.picklist_dest.length; i++) {
	          for (var j = 0; j < $scope.destoptions.length; j++) {
	            if ($scope.picklist_dest[i] == $scope.destoptions[j]) {
	              idxs.push(j);
	            }
	          }
	        }
	        idxs.sort();
	        for (var i = idxs.length - 1; i >= 0; i--) {
	          var idx = idxs[i];
	          if (idx < $scope.destoptions.length - 1) {
	            var temp = $scope.destoptions[idx + 1];
	            $scope.destoptions[idx + 1] = $scope.destoptions[idx];
	            $scope.destoptions[idx] = temp;
	          }
	        }
	        while (models.length > 0) {
	          models.pop();
	        }
	        angular.forEach($scope.destoptions, function (item) {
	          models.push($scope.itemToValue(item));
	        });
	      };
	
	      $scope.removeLeftFromRight = function (left, right) {
	        for (var i = 0; i < left.length; i++) {
	          for (var j = 0; j < right.length; j++) {
	            if (left[i] === right[j]) {
	              right.splice(j, 1);
	              break;
	            }
	          }
	        }
	      };
	    }]
	  };
	}
	
	function fxPickListForm($compile, $templateCache) {
	  return {
	    require: "^picklist",
	    priority: 99,
	    restrict: 'A',
	    controller: ['$scope', '$element', '$attrs', function controller($scope, $element, $attrs) {
	      if (angular.isDefined($attrs.ngForm) && angular.isDefined($scope.formname)) {
	        $attrs.ngForm = $scope.formname;
	      }
	    }]
	  };
	}
	
	function fxPickListSrc($compile, $templateCache) {
	  return {
	    require: "^picklist",
	    priority: 99,
	    restrict: 'A',
	    controller: ['$scope', '$element', '$attrs', function controller($scope, $element, $attrs) {
	      $attrs.ngOptions = $scope.ngOptions;
	      $attrs.size = $scope.size;
	      $element.attr("size", $scope.size);
	      $attrs.name = $scope.formname + "_src";
	
	      $attrs.ngOptions = $scope.ngOptions.replace($scope.srcoptionsExp, "srcoptions").replace(/^.+\s+as\s+/, "");
	    }]
	  };
	}
	
	function fxPickListDest($compile, $templateCache) {
	  return {
	    require: "^picklist",
	    priority: 99,
	    restrict: 'A',
	    controller: ['$scope', '$element', '$attrs', function controller($scope, $element, $attrs) {
	      $attrs.size = $scope.size;
	      $element.attr("size", $scope.size);
	
	      $attrs.ngOptions = $scope.ngOptions.replace($scope.srcoptionsExp, "destoptions").replace(/^.+\s+as\s+/, "");
	      $attrs.name = $scope.formname + "_dest";
	    }]
	  };
	}
	
	var fxPickListTpl = "			  <div style=\"display: table;width:100%\" data-ng-form=\"fake\" data-picklist-form>" + "		<div style=\"display: table-row;\">" + "			<div style=\"display: table-cell; width: 40%;vertical-align: middle;\">" + "				<select multiple size=\"5\" class=\"form-control\" data-ng-options=\"fake\" name=\"fake\" data-ng-model=\"picklist_src\" data-picklist-src>" + "				</select>" + "			</div>" + "			<div style=\"display: table-cell; width: 10%; vertical-align: middle; text-align: center;\" class=\"btn-group-vertical\">" + "				<div>" + "					<button type=\"button\" class=\"btn btn-info\" data-ng-click=\"rightShift();\">" + "						<span class=\"glyphicon glyphicon-step-forward\"></span>" + "					</button>" + "				</div>" + "				<div style='margin-bottom: 4px'>" + "					<button type=\"button\" class=\"btn btn-default\" data-ng-click=\"rightShiftAll();\">" + "						<span class=\"glyphicon glyphicon-fast-forward\"></span>" + "					</button>" + "				</div>" + "				<div>" + "					<button type=\"button\" class=\"btn btn-info\" data-ng-click=\"leftShift();\">" + "						<span class=\"glyphicon glyphicon-step-backward\"></span>" + "					</button>" + "				</div>" + "				<div>" + "					<button type=\"button\" class=\"btn btn-default\" data-ng-click=\"leftShiftAll();\">" + "						<span class=\"glyphicon glyphicon-fast-backward\"></span>" + "					</button>" + "				</div>" + "			</div>" + "			<div style=\"display: table-cell; width: 40%;vertical-align: middle;\">" + "				<select multiple size=\"5\" class=\"form-control\" data-ng-options=\"fake\" name=\"fake\" data-ng-model=\"picklist_dest\" data-picklist-dest>" + "				</select>" + "			</div>" + "			<div style=\"display: table-cell; width: 10%; vertical-align: middle; text-align:center;\" class=\"btn-group-vertical\">" + "				<div>" + "					<button type=\"button\" class=\"btn btn-default\" data-ng-click=\"arrowUp();\">" + "						<span class=\"glyphicon glyphicon-arrow-up\"></span>" + "					</button>" + "				</div>" + "				<div>" + "					<button type=\"button\" class=\"btn btn-default\" data-ng-click=\"arrowDown();\">" + "						<span class=\"glyphicon glyphicon-arrow-down\"></span>" + "					</button>" + "				</div>" + "			</div>" + "		</div>" + "	</div>";
	
	angular.module("fxpicklist", []).directive("picklist", fxPickList).directive("picklistForm", fxPickListForm).directive("picklistSrc", fxPickListSrc).directive("picklistDest", fxPickListDest).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("picklist.html", fxPickListTpl);
	}]);

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.17.0 - 2017-12-21
	 * 
	 * Copyright (c) 2017 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	!function(t,e){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return e()}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=e():e()}(0,function(){
	t.$inject = ['t'];
	e.$inject = ['t', 'e', 'n', 'a'];
	n.$inject = ['t', 'e'];
	a.$inject = ['t', 'e', 'n', 'a', 'i'];
	i.$inject = ['t', 'e'];
	o.$inject = ['t', 'e'];
	c.$inject = ['t', 'e'];
	f.$inject = ['t'];function t(t){"use strict";var e=t.storageKey(),n=t.storage(),a=function(){var a=t.preferredLanguage();angular.isString(a)?t.use(a):n.put(e,t.use())};a.displayName="fallbackFromIncorrectStorageValue",n?n.get(e)?t.use(n.get(e)).catch(a):a():angular.isString(t.preferredLanguage())&&t.use(t.preferredLanguage())}function e(t,e,n,a){"use strict";var r,i,s,o,u,l,c,f,g,p,h,d,v,m,$,y,b={},S=[],L=t,j=[],w="translate-cloak",C=!1,N=!1,O=".",E=!1,k=!1,P=0,A=!0,z="default",T={default:function(t){return(t||"").split("-").join("_")},java:function(t){var e=(t||"").split("-").join("_"),n=e.split("_");return n.length>1?n[0].toLowerCase()+"_"+n[1].toUpperCase():e},bcp47:function(t){var e=(t||"").split("_").join("-"),n=e.split("-");switch(n.length){case 1:n[0]=n[0].toLowerCase();break;case 2:n[0]=n[0].toLowerCase(),4===n[1].length?n[1]=n[1].charAt(0).toUpperCase()+n[1].slice(1).toLowerCase():n[1]=n[1].toUpperCase();break;case 3:n[0]=n[0].toLowerCase(),n[1]=n[1].charAt(0).toUpperCase()+n[1].slice(1).toLowerCase(),n[2]=n[2].toUpperCase();break;default:return e}return n.join("-")},"iso639-1":function(t){return(t||"").split("_").join("-").split("-")[0].toLowerCase()}},x=function(){if(angular.isFunction(a.getLocale))return a.getLocale();var t,n,r=e.$get().navigator,i=["language","browserLanguage","systemLanguage","userLanguage"];if(angular.isArray(r.languages))for(t=0;t<r.languages.length;t++)if((n=r.languages[t])&&n.length)return n;for(t=0;t<i.length;t++)if((n=r[i[t]])&&n.length)return n;return null};x.displayName="angular-translate/service: getFirstBrowserLanguage";var F=function(){var t=x()||"";return T[z]&&(t=T[z](t)),t};F.displayName="angular-translate/service: getLocale";var I=function(t,e){for(var n=0,a=t.length;n<a;n++)if(t[n]===e)return n;return-1},_=function(){return this.toString().replace(/^\s+|\s+$/g,"")},V=function(t){return angular.isString(t)?t.toLowerCase():t},R=function(t){if(t){for(var e=[],n=V(t),a=0,r=S.length;a<r;a++)e.push(V(S[a]));if((a=I(e,n))>-1)return S[a];if(i){var s;for(var o in i)if(i.hasOwnProperty(o)){var u=!1,l=Object.prototype.hasOwnProperty.call(i,o)&&V(o)===V(t);if("*"===o.slice(-1)&&(u=V(o.slice(0,-1))===V(t.slice(0,o.length-1))),(l||u)&&(s=i[o],I(e,V(s))>-1))return s}}var c=t.split("_");return c.length>1&&I(e,V(c[0]))>-1?c[0]:void 0}},D=function(t,e){if(!t&&!e)return b;if(t&&!e){if(angular.isString(t))return b[t]}else angular.isObject(b[t])||(b[t]={}),angular.extend(b[t],K(e));return this};this.translations=D,this.cloakClassName=function(t){return t?(w=t,this):w},this.nestedObjectDelimeter=function(t){return t?(O=t,this):O};var K=function(t,e,n,a){var r,i,s;e||(e=[]),n||(n={});for(r in t)Object.prototype.hasOwnProperty.call(t,r)&&(s=t[r],angular.isObject(s)?K(s,e.concat(r),n,r):(i=e.length?""+e.join(O)+O+r:r,e.length&&r===a&&(n[""+e.join(O)]="@:"+i),n[i]=s));return n};K.displayName="flatObject",this.addInterpolation=function(t){return j.push(t),this},this.useMessageFormatInterpolation=function(){return this.useInterpolation("$translateMessageFormatInterpolation")},this.useInterpolation=function(t){return p=t,this},this.useSanitizeValueStrategy=function(t){return n.useStrategy(t),this},this.preferredLanguage=function(t){return t?(U(t),this):r};var U=function(t){return t&&(r=t),r};this.translationNotFoundIndicator=function(t){return this.translationNotFoundIndicatorLeft(t),this.translationNotFoundIndicatorRight(t),this},this.translationNotFoundIndicatorLeft=function(t){return t?(v=t,this):v},this.translationNotFoundIndicatorRight=function(t){return t?(m=t,this):m},this.fallbackLanguage=function(t){return M(t),this};var M=function(t){return t?(angular.isString(t)?(o=!0,s=[t]):angular.isArray(t)&&(o=!1,s=t),angular.isString(r)&&I(s,r)<0&&s.push(r),this):o?s[0]:s};this.use=function(t){if(t){if(!b[t]&&!h)throw new Error("$translateProvider couldn't find translationTable for langKey: '"+t+"'");return u=t,this}return u},this.resolveClientLocale=function(){return F()};var H=function(t){return t?(L=t,this):f?f+L:L};this.storageKey=H,this.useUrlLoader=function(t,e){return this.useLoader("$translateUrlLoader",angular.extend({url:t},e))},this.useStaticFilesLoader=function(t){return this.useLoader("$translateStaticFilesLoader",t)},this.useLoader=function(t,e){return h=t,d=e||{},this},this.useLocalStorage=function(){return this.useStorage("$translateLocalStorage")},this.useCookieStorage=function(){return this.useStorage("$translateCookieStorage")},this.useStorage=function(t){return c=t,this},this.storagePrefix=function(t){return t?(f=t,this):t},this.useMissingTranslationHandlerLog=function(){return this.useMissingTranslationHandler("$translateMissingTranslationHandlerLog")},this.useMissingTranslationHandler=function(t){return g=t,this},this.usePostCompiling=function(t){return C=!!t,this},this.forceAsyncReload=function(t){return N=!!t,this},this.uniformLanguageTag=function(t){return t?angular.isString(t)&&(t={standard:t}):t={},z=t.standard,this},this.determinePreferredLanguage=function(t){var e=t&&angular.isFunction(t)?t():F();return r=S.length?R(e)||e:e,this},this.registerAvailableLanguageKeys=function(t,e){return t?(S=t,e&&(i=e),this):S},this.useLoaderCache=function(t){return!1===t?$=void 0:!0===t?$=!0:void 0===t?$="$translationCache":t&&($=t),this},this.directivePriority=function(t){return void 0===t?P:(P=t,this)},this.statefulFilter=function(t){return void 0===t?A:(A=t,this)},this.postProcess=function(t){return y=t||void 0,this},this.keepContent=function(t){return k=!!t,this},this.$get=["$log","$injector","$rootScope","$q",function(t,e,n,a){var i,f,z,T=e.get(p||"$translateDefaultInterpolation"),x=!1,V={},G={},q=function(t,e,n,o,l,g){!u&&r&&(u=r);var p=l&&l!==u?R(l)||l:u;if(l&&lt(l),angular.isArray(t)){return function(t){for(var r={},i=[],s=0,u=t.length;s<u;s++)i.push(function(t){var i=a.defer(),s=function(e){r[t]=e,i.resolve([t,e])};return q(t,e,n,o,l,g).then(s,s),i.promise}(t[s]));return a.all(i).then(function(){return r})}(t)}var h=a.defer();t&&(t=_.apply(t));var d=function(){var t=G[p]||G[r];if(f=0,c&&!t){var e=i.get(L);if(t=G[e],s&&s.length){var n=I(s,e);f=0===n?1:0,I(s,r)<0&&s.push(r)}}return t}();if(d){var v=function(){l||(p=u),it(t,e,n,o,p,g).then(h.resolve,h.reject)};v.displayName="promiseResolved",d.finally(v).catch(angular.noop)}else it(t,e,n,o,p,g).then(h.resolve,h.reject);return h.promise},Y=function(t){return v&&(t=[v,t].join(" ")),m&&(t=[t,m].join(" ")),t},B=function(t){u=t,c&&i.put(q.storageKey(),u),n.$emit("$translateChangeSuccess",{language:t}),T.setLocale(u);var e=function(t,e){V[e].setLocale(u)};e.displayName="eachInterpolatorLocaleSetter",angular.forEach(V,e),n.$emit("$translateChangeEnd",{language:t})},J=function(t){if(!t)throw"No language key specified for loading.";var r=a.defer();n.$emit("$translateLoadingStart",{language:t}),x=!0;var i=$;"string"==typeof i&&(i=e.get(i));var s=angular.extend({},d,{key:t,$http:angular.extend({},{cache:i},d.$http)}),o=function(e){var a={};n.$emit("$translateLoadingSuccess",{language:t}),angular.isArray(e)?angular.forEach(e,function(t){angular.extend(a,K(t))}):angular.extend(a,K(e)),x=!1,r.resolve({key:t,table:a}),n.$emit("$translateLoadingEnd",{language:t})};o.displayName="onLoaderSuccess";var u=function(t){n.$emit("$translateLoadingError",{language:t}),r.reject(t),n.$emit("$translateLoadingEnd",{language:t})};return u.displayName="onLoaderError",e.get(h)(s).then(o,u),r.promise};if(c&&(!(i=e.get(c)).get||!i.put))throw new Error("Couldn't use storage '"+c+"', missing get() or put() method!");if(j.length){var Q=function(t){var n=e.get(t);n.setLocale(r||u),V[n.getInterpolationIdentifier()]=n};Q.displayName="interpolationFactoryAdder",angular.forEach(j,Q)}var W=function(t){var e=a.defer();if(Object.prototype.hasOwnProperty.call(b,t))e.resolve(b[t]);else if(G[t]){var n=function(t){D(t.key,t.table),e.resolve(t.table)};n.displayName="translationTableResolver",G[t].then(n,e.reject)}else e.reject();return e.promise},X=function(t,e,n,r,i){var s=a.defer(),o=function(a){if(Object.prototype.hasOwnProperty.call(a,e)&&null!==a[e]){r.setLocale(t);var o=a[e];if("@:"===o.substr(0,2))X(t,o.substr(2),n,r,i).then(s.resolve,s.reject);else{var l=r.interpolate(a[e],n,"service",i,e);l=ut(e,a[e],l,n,t),s.resolve(l)}r.setLocale(u)}else s.reject()};return o.displayName="fallbackTranslationResolver",W(t).then(o,s.reject),s.promise},Z=function(t,e,n,a,r){var i,s=b[t];if(s&&Object.prototype.hasOwnProperty.call(s,e)&&null!==s[e]){if(a.setLocale(t),i=a.interpolate(s[e],n,"filter",r,e),i=ut(e,s[e],i,n,t,r),!angular.isString(i)&&angular.isFunction(i.$$unwrapTrustedValue)){var o=i.$$unwrapTrustedValue();if("@:"===o.substr(0,2))return Z(t,o.substr(2),n,a,r)}else if("@:"===i.substr(0,2))return Z(t,i.substr(2),n,a,r);a.setLocale(u)}return i},tt=function(t,n,a,r){return g?e.get(g)(t,u,n,a,r):t},et=function(t,e,n,r,i,o){var u=a.defer();if(t<s.length){var l=s[t];X(l,e,n,r,o).then(function(t){u.resolve(t)},function(){return et(t+1,e,n,r,i,o).then(u.resolve,u.reject)})}else if(i)u.resolve(i);else{var c=tt(e,n,i);g&&c?u.resolve(c):u.reject(Y(e))}return u.promise},nt=function(t,e,n,a,r){var i;if(t<s.length){var o=s[t];(i=Z(o,e,n,a,r))||""===i||(i=nt(t+1,e,n,a))}return i},at=function(t,e,n,a,r){return et(z>0?z:f,t,e,n,a,r)},rt=function(t,e,n,a){return nt(z>0?z:f,t,e,n,a)},it=function(t,e,n,r,i,o){var u=a.defer(),l=i?b[i]:b,c=n?V[n]:T;if(l&&Object.prototype.hasOwnProperty.call(l,t)&&null!==l[t]){var f=l[t];if("@:"===f.substr(0,2))q(f.substr(2),e,n,r,i,o).then(u.resolve,u.reject);else{var p=c.interpolate(f,e,"service",o,t);p=ut(t,f,p,e,i),u.resolve(p)}}else{var h;g&&!x&&(h=tt(t,e,r)),i&&s&&s.length?at(t,e,c,r,o).then(function(t){u.resolve(t)},function(t){u.reject(Y(t))}):g&&!x&&h?r?u.resolve(r):u.resolve(h):r?u.resolve(r):u.reject(Y(t))}return u.promise},st=function(t,e,n,a,r){var i,o=a?b[a]:b,u=T;if(V&&Object.prototype.hasOwnProperty.call(V,n)&&(u=V[n]),o&&Object.prototype.hasOwnProperty.call(o,t)&&null!==o[t]){var l=o[t];"@:"===l.substr(0,2)?i=st(l.substr(2),e,n,a,r):(i=u.interpolate(l,e,"filter",r,t),i=ut(t,l,i,e,a,r))}else{var c;g&&!x&&(c=tt(t,e,r)),a&&s&&s.length?(f=0,i=rt(t,e,u,r)):i=g&&!x&&c?c:Y(t)}return i},ot=function(t){l===t&&(l=void 0),G[t]=void 0},ut=function(t,n,a,r,i,s){var o=y;return o&&("string"==typeof o&&(o=e.get(o)),o)?o(t,n,a,r,i,s):a},lt=function(t){b[t]||!h||G[t]||(G[t]=J(t).then(function(t){return D(t.key,t.table),t}))};q.preferredLanguage=function(t){return t&&U(t),r},q.cloakClassName=function(){return w},q.nestedObjectDelimeter=function(){return O},q.fallbackLanguage=function(t){if(void 0!==t&&null!==t){if(M(t),h&&s&&s.length)for(var e=0,n=s.length;e<n;e++)G[s[e]]||(G[s[e]]=J(s[e]));q.use(q.use())}return o?s[0]:s},q.useFallbackLanguage=function(t){if(void 0!==t&&null!==t)if(t){var e=I(s,t);e>-1&&(z=e)}else z=0},q.proposedLanguage=function(){return l},q.storage=function(){return i},q.negotiateLocale=R,q.use=function(t){if(!t)return u;var e=a.defer();e.promise.then(null,angular.noop),n.$emit("$translateChangeStart",{language:t});var r=R(t);return S.length>0&&!r?a.reject(t):(r&&(t=r),l=t,!N&&b[t]||!h||G[t]?G[t]?G[t].then(function(t){return l===t.key&&B(t.key),e.resolve(t.key),t},function(t){return!u&&s&&s.length>0&&s[0]!==t?q.use(s[0]).then(e.resolve,e.reject):e.reject(t)}):(e.resolve(t),B(t)):(G[t]=J(t).then(function(n){return D(n.key,n.table),e.resolve(n.key),l===t&&B(n.key),n},function(t){return n.$emit("$translateChangeError",{language:t}),e.reject(t),n.$emit("$translateChangeEnd",{language:t}),a.reject(t)}),G[t].finally(function(){ot(t)}).catch(angular.noop)),e.promise)},q.resolveClientLocale=function(){return F()},q.storageKey=function(){return H()},q.isPostCompilingEnabled=function(){return C},q.isForceAsyncReloadEnabled=function(){return N},q.isKeepContent=function(){return k},q.refresh=function(t){function e(t){var e=J(t);return G[t]=e,e.then(function(e){b[t]={},D(t,e.table),i[t]=!0},angular.noop),e}if(!h)throw new Error("Couldn't refresh translation table, no loader registered!");n.$emit("$translateRefreshStart",{language:t});var r=a.defer(),i={};if(r.promise.then(function(){for(var t in b)b.hasOwnProperty(t)&&(t in i||delete b[t]);u&&B(u)},angular.noop).finally(function(){n.$emit("$translateRefreshEnd",{language:t})}),t)b[t]?e(t).then(r.resolve,r.reject):r.reject();else{var o=s&&s.slice()||[];u&&-1===o.indexOf(u)&&o.push(u),a.all(o.map(e)).then(r.resolve,r.reject)}return r.promise},q.instant=function(t,e,n,a,i){var o=a&&a!==u?R(a)||a:u;if(null===t||angular.isUndefined(t))return t;if(a&&lt(a),angular.isArray(t)){for(var l={},c=0,f=t.length;c<f;c++)l[t[c]]=q.instant(t[c],e,n,a,i);return l}if(angular.isString(t)&&t.length<1)return t;t&&(t=_.apply(t));var p,h=[];r&&h.push(r),o&&h.push(o),s&&s.length&&(h=h.concat(s));for(var d=0,$=h.length;d<$;d++){var y=h[d];if(b[y]&&void 0!==b[y][t]&&(p=st(t,e,n,o,i)),void 0!==p)break}if(!p&&""!==p)if(v||m)p=Y(t);else{p=T.interpolate(t,e,"filter",i);var S;g&&!x&&(S=tt(t,e,i)),g&&!x&&S&&(p=S)}return p},q.versionInfo=function(){return"2.17.0"},q.loaderCache=function(){return $},q.directivePriority=function(){return P},q.statefulFilter=function(){return A},q.isReady=function(){return E};var ct=a.defer();ct.promise.then(function(){E=!0}),q.onReady=function(t){var e=a.defer();return angular.isFunction(t)&&e.promise.then(t),E?e.resolve():ct.promise.then(e.resolve),e.promise},q.getAvailableLanguageKeys=function(){return S.length>0?S:null},q.getTranslationTable=function(t){return(t=t||q.use())&&b[t]?angular.copy(b[t]):null};var ft=n.$on("$translateReady",function(){ct.resolve(),ft(),ft=null}),gt=n.$on("$translateChangeEnd",function(){ct.resolve(),gt(),gt=null});if(h){if(angular.equals(b,{})&&q.use()&&q.use(q.use()),s&&s.length)for(var pt=0,ht=s.length;pt<ht;pt++){var dt=s[pt];!N&&b[dt]||(G[dt]=J(dt).then(function(t){return D(t.key,t.table),n.$emit("$translateChangeEnd",{language:t.key}),t}))}}else n.$emit("$translateReady",{language:q.use()});return q}]}function n(t,e){"use strict";var n,a={};return a.setLocale=function(t){n=t},a.getInterpolationIdentifier=function(){return"default"},a.useSanitizeValueStrategy=function(t){return e.useStrategy(t),this},a.interpolate=function(n,a,r,i,s){a=a||{},a=e.sanitize(a,"params",i,r);var o;return angular.isNumber(n)?o=""+n:angular.isString(n)?(o=t(n)(a),o=e.sanitize(o,"text",i,r)):o="",o},a}function a(t,e,n,a,i){"use strict";var s=function(){return this.toString().replace(/^\s+|\s+$/g,"")},o=function(t){return angular.isString(t)?t.toLowerCase():t};return{restrict:"AE",scope:!0,priority:t.directivePriority(),compile:function(u,l){var c=l.translateValues?l.translateValues:void 0,f=l.translateInterpolation?l.translateInterpolation:void 0,g=l.translateSanitizeStrategy?l.translateSanitizeStrategy:void 0,p=u[0].outerHTML.match(/translate-value-+/i),h="^(.*)("+e.startSymbol()+".*"+e.endSymbol()+")(.*)",d="^(.*)"+e.startSymbol()+"(.*)"+e.endSymbol()+"(.*)";return function(u,v,m){u.interpolateParams={},u.preText="",u.postText="",u.translateNamespace=r(u);var $={},y=function(t){if(angular.isFunction(y._unwatchOld)&&(y._unwatchOld(),y._unwatchOld=void 0),angular.equals(t,"")||!angular.isDefined(t)){var n=s.apply(v.text()),a=n.match(h);if(angular.isArray(a)){u.preText=a[1],u.postText=a[3],$.translate=e(a[2])(u.$parent);var r=n.match(d);angular.isArray(r)&&r[2]&&r[2].length&&(y._unwatchOld=u.$watch(r[2],function(t){$.translate=t,j()}))}else $.translate=n||void 0}else $.translate=t;j()};!function(t,e,n){if(e.translateValues&&angular.extend(t,a(e.translateValues)(u.$parent)),p)for(var r in n)Object.prototype.hasOwnProperty.call(e,r)&&"translateValue"===r.substr(0,14)&&"translateValues"!==r&&(t[o(r.substr(14,1))+r.substr(15)]=n[r])}(u.interpolateParams,m,l);var b=!0;m.$observe("translate",function(t){void 0===t?y(""):""===t&&b||($.translate=t,j()),b=!1});for(var S in m)m.hasOwnProperty(S)&&"translateAttr"===S.substr(0,13)&&S.length>13&&function(t){m.$observe(t,function(e){$[t]=e,j()})}(S);if(m.$observe("translateDefault",function(t){u.defaultText=t,j()}),g&&m.$observe("translateSanitizeStrategy",function(t){u.sanitizeStrategy=a(t)(u.$parent),j()}),c&&m.$observe("translateValues",function(t){t&&u.$parent.$watch(function(){angular.extend(u.interpolateParams,a(t)(u.$parent))})}),p){for(var L in m)Object.prototype.hasOwnProperty.call(m,L)&&"translateValue"===L.substr(0,14)&&"translateValues"!==L&&function(t){m.$observe(t,function(e){var n=o(t.substr(14,1))+t.substr(15);u.interpolateParams[n]=e})}(L)}var j=function(){for(var t in $)$.hasOwnProperty(t)&&void 0!==$[t]&&w(t,$[t],u,u.interpolateParams,u.defaultText,u.translateNamespace)},w=function(e,n,a,r,i,s){n?(s&&"."===n.charAt(0)&&(n=s+n),t(n,r,f,i,a.translateLanguage,a.sanitizeStrategy).then(function(t){C(t,a,!0,e)},function(t){C(t,a,!1,e)})):C(n,a,!1,e)},C=function(e,a,r,i){if(r||void 0!==a.defaultText&&(e=a.defaultText),"translate"===i){(r||!r&&!t.isKeepContent()&&void 0===m.translateKeepContent)&&v.empty().append(a.preText+e+a.postText);var s=t.isPostCompilingEnabled(),o=void 0!==l.translateCompile,u=o&&"false"!==l.translateCompile;(s&&!o||u)&&n(v.contents())(a)}else{var c=m.$attr[i];"data-"===c.substr(0,5)&&(c=c.substr(5)),c=c.substr(15),v.attr(c,e)}};(c||p||m.translateDefault)&&u.$watch("interpolateParams",j,!0),u.$on("translateLanguageChanged",j);var N=i.$on("$translateChangeSuccess",j);v.text().length?y(m.translate?m.translate:""):m.translate&&y(m.translate),j(),u.$on("$destroy",N)}}}}function r(t){"use strict";return t.translateNamespace?t.translateNamespace:t.$parent?r(t.$parent):void 0}function i(t,e){"use strict";return{restrict:"A",priority:t.directivePriority(),link:function(n,a,r){var i,o,u,l={},c=function(){angular.forEach(i,function(e,i){e&&(l[i]=!0,n.translateNamespace&&"."===e.charAt(0)&&(e=n.translateNamespace+e),t(e,o,r.translateInterpolation,void 0,n.translateLanguage,u).then(function(t){a.attr(i,t)},function(t){a.attr(i,t)}))}),angular.forEach(l,function(t,e){i[e]||(a.removeAttr(e),delete l[e])})};s(n,r.translateAttr,function(t){i=t},c),s(n,r.translateValues,function(t){o=t},c),s(n,r.translateSanitizeStrategy,function(t){u=t},c),r.translateValues&&n.$watch(r.translateValues,c,!0),n.$on("translateLanguageChanged",c);var f=e.$on("$translateChangeSuccess",c);c(),n.$on("$destroy",f)}}}function s(t,e,n,a){"use strict";e&&("::"===e.substr(0,2)?e=e.substr(2):t.$watch(e,function(t){n(t),a()},!0),n(t.$eval(e)))}function o(t,e){"use strict";return{compile:function(n){var a=function(e){e.addClass(t.cloakClassName())},r=function(e){e.removeClass(t.cloakClassName())};return a(n),function(n,i,s){var o=r.bind(this,i),u=a.bind(this,i);s.translateCloak&&s.translateCloak.length?(s.$observe("translateCloak",function(e){t(e).then(o,u)}),e.$on("$translateChangeSuccess",function(){t(s.translateCloak).then(o,u)})):t.onReady(o)}}}}function u(){"use strict";return{restrict:"A",scope:!0,compile:function(){return{pre:function(t,e,n){t.translateNamespace=r(t),t.translateNamespace&&"."===n.translateNamespace.charAt(0)?t.translateNamespace+=n.translateNamespace:t.translateNamespace=n.translateNamespace}}}}}function r(t){"use strict";return t.translateNamespace?t.translateNamespace:t.$parent?r(t.$parent):void 0}function l(){"use strict";return{restrict:"A",scope:!0,compile:function(){return function(t,e,n){n.$observe("translateLanguage",function(e){t.translateLanguage=e}),t.$watch("translateLanguage",function(){t.$broadcast("translateLanguageChanged")})}}}}function c(t,e){"use strict";var n=function(n,a,r,i){if(!angular.isObject(a)){var s=this||{__SCOPE_IS_NOT_AVAILABLE:"More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f"};a=t(a)(s)}return e.instant(n,a,r,i)};return e.statefulFilter()&&(n.$stateful=!0),n}function f(t){"use strict";return t("translations")}return t.$inject=["$translate"],e.$inject=["$STORAGE_KEY","$windowProvider","$translateSanitizationProvider","pascalprechtTranslateOverrider"],n.$inject=["$interpolate","$translateSanitization"],a.$inject=["$translate","$interpolate","$compile","$parse","$rootScope"],i.$inject=["$translate","$rootScope"],o.$inject=["$translate","$rootScope"],c.$inject=["$parse","$translate"],f.$inject=["$cacheFactory"],angular.module("pascalprecht.translate",["ng"]).run(t),t.displayName="runTranslate",angular.module("pascalprecht.translate").provider("$translateSanitization",function(){"use strict";var t,e,n,a=null,r=!1,i=!1;(n={sanitize:function(t,e){return"text"===e&&(t=o(t)),t},escape:function(t,e){return"text"===e&&(t=s(t)),t},sanitizeParameters:function(t,e){return"params"===e&&(t=l(t,o)),t},escapeParameters:function(t,e){return"params"===e&&(t=l(t,s)),t},sce:function(t,e,n){return"text"===e?t=u(t):"params"===e&&"filter"!==n&&(t=l(t,s)),t},sceParameters:function(t,e){return"params"===e&&(t=l(t,u)),t}}).escaped=n.escapeParameters,this.addStrategy=function(t,e){return n[t]=e,this},this.removeStrategy=function(t){return delete n[t],this},this.useStrategy=function(t){return r=!0,a=t,this},this.$get=["$injector","$log",function(s,o){var u={},l=function(t,e,a,r){return angular.forEach(r,function(r){if(angular.isFunction(r))t=r(t,e,a);else if(angular.isFunction(n[r]))t=n[r](t,e,a);else{if(!angular.isString(n[r]))throw new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '"+r+"'");if(!u[n[r]])try{u[n[r]]=s.get(n[r])}catch(t){throw u[n[r]]=function(){},new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '"+r+"'")}t=u[n[r]](t,e,a)}}),t},c=function(){r||i||(o.warn("pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details."),i=!0)};return s.has("$sanitize")&&(t=s.get("$sanitize")),s.has("$sce")&&(e=s.get("$sce")),{useStrategy:function(t){return function(e){t.useStrategy(e)}}(this),sanitize:function(t,e,n,r){if(a||c(),n||null===n||(n=a),!n)return t;r||(r="service");var i=angular.isArray(n)?n:[n];return l(t,e,r,i)}}}];var s=function(t){var e=angular.element("<div></div>");return e.text(t),e.html()},o=function(e){if(!t)throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as 'escape'.");return t(e)},u=function(t){if(!e)throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sce service.");return e.trustAsHtml(t)},l=function(t,e,n){if(angular.isDate(t))return t;if(angular.isObject(t)){var a=angular.isArray(t)?[]:{};if(n){if(n.indexOf(t)>-1)throw new Error("pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object")}else n=[];return n.push(t),angular.forEach(t,function(t,r){angular.isFunction(t)||(a[r]=l(t,e,n))}),n.splice(-1,1),a}return angular.isNumber(t)?t:!0===t||!1===t?t:angular.isUndefined(t)||null===t?t:e(t)}}),angular.module("pascalprecht.translate").constant("pascalprechtTranslateOverrider",{}).provider("$translate",e),e.displayName="displayName",angular.module("pascalprecht.translate").factory("$translateDefaultInterpolation",n),n.displayName="$translateDefaultInterpolation",angular.module("pascalprecht.translate").constant("$STORAGE_KEY","NG_TRANSLATE_LANG_KEY"),angular.module("pascalprecht.translate").directive("translate",a),a.displayName="translateDirective",angular.module("pascalprecht.translate").directive("translateAttr",i),i.displayName="translateAttrDirective",angular.module("pascalprecht.translate").directive("translateCloak",o),o.displayName="translateCloakDirective",angular.module("pascalprecht.translate").directive("translateNamespace",u),u.displayName="translateNamespaceDirective",angular.module("pascalprecht.translate").directive("translateLanguage",l),l.displayName="translateLanguageDirective",angular.module("pascalprecht.translate").filter("translate",c),c.displayName="translateFilterFactory",angular.module("pascalprecht.translate").factory("$translationCache",f),f.displayName="$translationCache","pascalprecht.translate"});

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	(function(Chart) {
	  var isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'object' && !!obj;
	  }
	
	  var dataValue = function(dataPoint, isHorizontal) {
	    if (isObject(dataPoint)) {
	      return isHorizontal ? dataPoint.x : dataPoint.y;
	    }
	
	    return dataPoint;
	  }
	
	  var cloneArray = function(srcAry) {
	    var dstAry = [];
	    var length = srcAry.length;
	
	    for (var i = 0; i < length; i++) {
	      dstAry.push(srcAry[i]);
	    }
	    return dstAry;
	  };
	
	  var setOriginalData = function(data) {
	    data.originalData = data.datasets.map(function(dataset) {
	      return cloneArray(dataset.data);
	    });
	  };
	
	  // set calculated rate (xx%) to data.calculatedData
	  var calculateRate = function(data, isHorizontal, precision) {
	    var visibles = data.datasets.map(function(dataset) {
	      if (!dataset._meta) return true;
	
	      for (var i in dataset._meta) {
	        return !dataset._meta[i].hidden;
	      }
	    });
	    
	    var datasetDataLength = 0;
	    if (data && data.datasets && data.datasets[0] && data.datasets[0].data) {
	      datasetDataLength = data.datasets[0].data.length;
	    }
	    var totals = Array.apply(null, new Array(datasetDataLength)).map(function(el, i) {
	      return data.datasets.reduce(function(sum, dataset, j) {
	        var key = dataset.stack;
	        if (!sum[key]) sum[key] = 0;
	        sum[key] += Math.abs(dataValue(dataset.data[i], isHorizontal)) * visibles[j];
	
	        return sum;
	      }, {});
	    });
	
	    data.calculatedData = data.datasets.map(function(dataset, i) {
	      return dataset.data.map(function(val, i) {
	        var total = totals[i][dataset.stack];
	        var dv = dataValue(val, isHorizontal);
	        return dv && total ? round(dv / total, precision) : 0;
	      });
	    });
	  };
	
	  var getPrecision = function(pluginOptions) {
	    // return the (validated) configured precision from pluginOptions or default 1
	    var defaultPrecision = 1;
	    if (!pluginOptions.hasOwnProperty("precision")) return defaultPrecision;
	    if (!pluginOptions.precision) return defaultPrecision;
	    var optionsPrecision = Math.floor(pluginOptions.precision);
	    if (isNaN(optionsPrecision)) return defaultPrecision;
	    if (optionsPrecision < 0 || optionsPrecision > 16) return defaultPrecision; 
	    return optionsPrecision;
	  };
	
	  var round = function(value, precision) {
	    var multiplicator = Math.pow(10, precision);
	    return Math.round(value * 100 * multiplicator) / multiplicator;
	  };
	
	  var tooltipLabel = function(isHorizontal) {
	    return function(tooltipItem, data) {
	      var datasetIndex = tooltipItem.datasetIndex;
	      var index = tooltipItem.index;
	      var datasetLabel = data.datasets[datasetIndex].label || "";
	      var originalValue = data.originalData[datasetIndex][index];
	      var rateValue = data.calculatedData[datasetIndex][index];
	
	      return "" + datasetLabel + ": " + rateValue + "% (" + dataValue(originalValue, isHorizontal) + ")";
	    }
	  };
	
	  var reflectData = function(srcData, datasets) {
	    if (!srcData) return;
	
	    srcData.forEach(function(data, i) {
	      datasets[i].data = data;
	    });
	  };
	
	  var isHorizontalChart = function(chartInstance) {
	    return chartInstance.config.type === "horizontalBar";
	  }
	
	  var Stacked100Plugin = {
	    id: "stacked100",
	
	    beforeInit: function(chartInstance, pluginOptions) {
	      if (!pluginOptions.enable) return;
	
	      var xAxes = chartInstance.options.scales.xAxes;
	      var yAxes = chartInstance.options.scales.yAxes;
	      var isVertical = chartInstance.config.type === "bar" || chartInstance.config.type === "line";
	
	      [xAxes, yAxes].forEach(function(axes) {
	        axes.forEach(function(hash) {
	          hash.stacked = true;
	        });
	      });
	      (isVertical ? yAxes : xAxes).forEach(function(hash) {
	        if (!hash.ticks.min) {
	          var hasNegative = chartInstance.data.datasets.some(function(dataset) {
	            return dataset.data.some(function(value) {
	              return value < 0;
	            });
	          });
	          hash.ticks.min = hasNegative ? -100 : 0;
	        }
	        if (!hash.ticks.max) hash.ticks.max = 100;
	      });
	
	      // Replace tooltips
	      if (pluginOptions.hasOwnProperty("replaceTooltipLabel") && !pluginOptions.replaceTooltipLabel) return;
	      chartInstance.options.tooltips.callbacks.label = tooltipLabel(isHorizontalChart(chartInstance));
	    },
	
	    beforeDatasetsUpdate: function(chartInstance, pluginOptions) {
	      if (!pluginOptions.enable) return;
	
	      setOriginalData(chartInstance.data);
	      var precision = getPrecision(pluginOptions);
	      calculateRate(chartInstance.data, isHorizontalChart(chartInstance), precision);
	      reflectData(chartInstance.data.calculatedData, chartInstance.data.datasets);
	    },
	
	    afterDatasetsUpdate: function(chartInstance, pluginOptions) {
	      if (!pluginOptions.enable) return;
	
	      reflectData(chartInstance.data.originalData, chartInstance.data.datasets);
	    }
	  };
	
	  Chart.pluginService.register(Stacked100Plugin);
	}.call(this, Chart));


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DbAdminService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DbAdminService = DbAdminService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function DbAdminService($resource) {
	  return $resource('/api/db-admin/:collection/:id', {
	    collection: '@collection',
	    id: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	
	    }
	  });
	}
	
	exports.default = angular.module('conduu.DBAdminService', []).factory('DBAdminService', DbAdminService).name;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DbAdminListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dbAdminList = __webpack_require__(767);
	
	var _dbAdminList2 = _interopRequireDefault(_dbAdminList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var DbAdminListComponent = exports.DbAdminListComponent = function () {
	  DbAdminListComponent.$inject = ['Auth', 'DBAdminService', 'dialogs', '$stateParams', '$uibModal'];
	  function DbAdminListComponent(Auth, DBAdminService, dialogs, $stateParams, $uibModal) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, DbAdminListComponent);
	
	    this.DBAdminService = DBAdminService;
	    this.data = [];
	    this.isAdmin = Auth.isAdminSync;
	    this.$uibModal = $uibModal;
	
	    this.collection = $stateParams.collection;
	
	    this.dialogs = dialogs;
	
	    this.settings = {
	      collections: ["users", "", "communities", "properties", "contacts", "vendors", "webaccess", "custom-entities", "", "calendarevents", "tasks", "projects", "project-items", "servicerequests", "workorders", "workorder-codes", "violations", "violation-codes", "templates", "", "settings", "storages", "histories", "sessions"],
	      colDef: {
	        "users": ["_id", "firstName", "lastName", "email"],
	        "communities": ["_id", "code", "name"],
	        "properties": ["_id", "code", "name"],
	        "contacts": ["_id", "firstName", "lastName"],
	        "vendors": ["_id", "name", "type"],
	        "webaccess": ["_id", "email"],
	        "custom-entities": ["_id", "schemaSettings"],
	        "calendarevents": ["_id", "title", "type", "start"],
	        "tasks": ["_id", "subject", "priority", "dueDate", "status"],
	        "projects": ["_id", "name"],
	        "project-items": ["_id", "title"],
	        "servicerequests": ["_id", "code", "name"],
	        "workorders": ["_id", "code", "name"],
	        "workorder-codes": ["_id", "code", "name"],
	        "violations": ["_id", "code", "name"],
	        "violation-codes": ["_id", "code", "name"],
	        "templates": ["_id", "name", "fileName"],
	        "settings": ["_id", "name", "isPublic", "tags"],
	        "storages": ["_id", "filename", "contentType", "storageStrategy", "permission", "isPublic", "dataUrl"],
	        "histories": ["_id", "entityId", "entityType", "action", "actionType"],
	        "sessions": ["_id", "expires"]
	      }
	    };
	
	    this.settings.collections.forEach(function (c) {
	      if (!_this.settings.colDef[c]) _this.settings.colDef[c] = ["_id"];
	    });
	
	    this.DBAdminService.query({ collection: this.collection }, function (data) {
	      _this.data = data;
	    }, function (err) {
	      console.log("Could not retrieve entities.");
	    });
	  }
	
	  _createClass(DbAdminListComponent, [{
	    key: 'openPreviewModal',
	    value: function openPreviewModal(entity) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'jsonViewer',
	        resolve: {
	          config: function config() {
	            return {
	              data: entity
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }]);
	
	  return DbAdminListComponent;
	}();
	
	exports.default = angular.module('conduu.ap.dbAdmin.list', [uiRouter]).config(_dbAdminList2.default).component('dbAdminList', {
	  template: __webpack_require__(768),
	  controller: DbAdminListComponent,
	  controllerAs: 'ctrl'
	
	}).name;

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('db-admin-list', {
	    url: '/db-admin/:collection',
	    template: '<db-admin-list></db-admin-list>',
	    authenticate: 'suite-superadmin'
	  });
	}];

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <h1>DB Admin List</h1>\r\n    </div>\r\n\r\n\r\n    <div class=\"col-md-2 col-xs-12\">\r\n      <br/>\r\n      <div class=\"list-group\">\r\n        <a ng-repeat=\"collection in ctrl.settings.collections track by $index\" href=\"/db-admin/{{collection}}\"\r\n           class=\"list-group-item text-capitalize\" style=\"padding: 2px 6px;\" ng-class=\"{'disabled': collection == '', 'active': ctrl.collection == collection}\">\r\n          {{collection}}\r\n          <!--<span class=\"badge\" style=\"float:none; position: absolute; right: 8px;\">?</span>-->\r\n        </a>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-md-10 col-xs-12\" style=\"overflow-x: scroll;\">\r\n\r\n      <!--<pre ng-repeat=\"entity in ctrl.data\">{{entity | json}}</pre>-->\r\n\r\n      <table ng-if=\"ctrl.data\" class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n          <tr>\r\n            <th ng-repeat=\"col in ctrl.settings.colDef[ctrl.collection]\">{{col}}</th>\r\n            <th></th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr ng-repeat=\"entity in ctrl.data\">\r\n            <td ng-repeat=\"col in ctrl.settings.colDef[ctrl.collection]\">{{entity[col]}}</td>\r\n            <td>\r\n              <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.openPreviewModal(entity)\"><i\r\n                      class=\"fa fa-fw fa-eye\"></i></button>\r\n              <a class=\"btn btn-sm btn-primary\" ng-href=\"/db-admin/{{ctrl.collection}}/{{entity._id}}\"><i\r\n                      class=\"fa fa-fw fa-edit\"></i></a>\r\n            </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n      <!--\r\n      <table datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>Name</th>\r\n          <th>Description</th>\r\n          <th>Public</th>\r\n          <th>Admin Editable</th>\r\n          <th>Date</th>\r\n          <th></th>\r\n          <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"page in ctrl.data | orderBy: 'meta.creationDate':true\">\r\n          <td>{{page.name}}</td>\r\n          <td><span ng-bind-html=\"page.description | newlineToHtml\"></span></td>\r\n          <td><span ng-show=\"page.isPublic\"><i class=\"fa fa-check\"></i></span></td>\r\n          <td><span ng-show=\"page.isAdminEditable\"><i class=\"fa fa-check\"></i></span></td>\r\n          <td>\r\n            <nobr>{{page.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td>\r\n            <a class=\"btn btn-sm btn-primary\" target=\"_blank\" href=\"/page/{{page.name}}\"><i\r\n              class=\"fa fa-eye fa-fw\"></i> View</a>\r\n          </td>\r\n          <td>\r\n            <nobr>\r\n              <a class=\"btn btn-sm btn-primary\" ng-href=\"/admin/dynpage/edit/{{page._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n              <a class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(page)\"><i class=\"fa fa-trash-o fa-fw\"></i></a>\r\n            </nobr>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n      -->\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DbAdminEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dbAdminEdit = __webpack_require__(770);
	
	var _dbAdminEdit2 = _interopRequireDefault(_dbAdminEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var DbAdminEditComponent = exports.DbAdminEditComponent = function () {
	  DbAdminEditComponent.$inject = ['DBAdminService', 'Auth', '$state', '$stateParams', 'dialogs', '$location'];
	  function DbAdminEditComponent(DBAdminService, Auth, $state, $stateParams, dialogs, $location) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, DbAdminEditComponent);
	
	    this.DBAdminService = DBAdminService;
	
	    this.entityId = $stateParams.id;
	    this.collection = $stateParams.collection;
	
	    this.$location = $location;
	
	    this.dialogs = dialogs;
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.DBAdminService.get({ collection: this.collection, id: this.entityId }, function (data) {
	      _this.jsonValue = angular.toJson(data, true);
	    }, function (err) {
	      console.log('Could not load entity from server');
	    });
	
	    CodeMirror.defineOption("matchBrackets", true);
	    CodeMirror.defineOption("autoCloseBrackets", true);
	    CodeMirror.defineOption("lineWrapping", true);
	    CodeMirror.defineOption("tabSize", 2);
	    CodeMirror.defineOption("mode", "application/json");
	    CodeMirror.defineOption("gutters", ["CodeMirror-lint-markers"]);
	    CodeMirror.defineOption("lint", true);
	    CodeMirror.defineOption("styleActiveLine", true);
	    CodeMirror.defineOption("lineNumbers", true);
	  }
	
	  _createClass(DbAdminEditComponent, [{
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          _this2.submitted = false;
	
	          var dlg = _this2.dialogs.notify("Success", "The entity has been saved successfully");
	          dlg.result.then(function () {
	            that.$location.url("/db-admin/" + that.collection);
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.DBAdminService.update({ collection: this.collection, id: this.entityId }, angular.fromJson(this.jsonValue), onSuccess, onError);
	      }
	    }
	  }]);
	
	  return DbAdminEditComponent;
	}();
	
	exports.default = angular.module('conduu.ap.dbAdmin.edit', [uiRouter]).config(_dbAdminEdit2.default).component('dbAdminEdit', {
	  template: __webpack_require__(771),
	  controller: DbAdminEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('db-admin-edit', {
	    url: '/db-admin/:collection/:id',
	    template: '<db-admin-edit></db-admin-edit>',
	    authenticate: 'suite-superadmin'
	  });
	}];

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <h1>Entity Editor</h1>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form class=\"form\" name=\"form\" ng-submit=\"ctrl.create(form)\" novalidate>\r\n\r\n        <textarea ui-codemirror ng-model=\"ctrl.jsonValue\" name=\"data\" ng-required=\"true\"></textarea>\r\n\r\n        <hr/>\r\n\r\n        <div ng-show=\"ctrl.sendFailure\" class=\"alert alert-danger\">\r\n          There has been an error. Your entity could not be edited.\r\n        </div>\r\n\r\n        <button class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <a class=\"btn btn-warning\" ng-href=\"/db-admin/{{ctrl.collection}}\"><i class=\"fa fa-fw fa-times\"></i> Cancel</a>\r\n      </form>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var ReportFilterModalComponent = exports.ReportFilterModalComponent = function () {
	  /*@ngInject*/
	  ReportFilterModalComponent.$inject = ['$scope', 'CommunityService', '$uibModal'];
	  function ReportFilterModalComponent($scope, CommunityService, $uibModal) {
	    var _this = this;
	
	    _classCallCheck(this, ReportFilterModalComponent);
	
	    this.$scope = $scope;
	    this.$uibModal = $uibModal;
	
	    this.model = {};
	    this.$scope.model = this.model;
	
	    this.mapFileType = {
	      'docx': "Word Document (DOCX)",
	      'odt': 'Open Office Document (ODT)',
	      'pdf': 'Portable Document Format (PDF)'
	    };
	
	    CommunityService.query(function (data) {
	      _this.communities = data.map(function (community) {
	        return {
	          value: community._id,
	          name: community.code + ": " + community.name
	        };
	      });
	    });
	
	    $scope.$watch("model", function (_) {
	      return _this.filterb64 = btoa(JSON.stringify(_this.model));
	    }, true);
	  }
	
	  _createClass(ReportFilterModalComponent, [{
	    key: 'communityLookup',
	    value: function communityLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'communityLookup',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (community) {
	        that.model.community = community._id;
	      }, function () {});
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.config = this.resolve.config;
	      this.icon = this.config.icon || 'download';
	      var fields = [];
	
	      this.config.filter.forEach(function (def) {
	
	        switch (def.type) {
	          case 'contactTypes':
	            _this2.contactTypesMap = {};
	            _this2.contactTypes = def.contactTypes;
	            _this2.contactTypes.forEach(function (type) {
	              return _this2.contactTypesMap[type] = true;
	            });
	            _this2.updateModelContactTypes();
	            fields.push(def);
	            break;
	          default:
	            def.model = def.model || 'selectField';
	            fields.push(def);
	            break;
	        }
	      });
	
	      this.fields = fields;
	
	      var filetypes = this.config.fileTypes || ["docx"];
	      this.fileTypes = filetypes.map(function (fileType) {
	        return { fileType: fileType, name: _this2.mapFileType[fileType] };
	      });
	
	      this.model.report = this.config.report;
	      this.model.title = this.config.title;
	      this.model.template = this.config.template;
	      this.model.fileType = this.config.defaultFileType || "docx";
	
	      if (this.config.entityId) {
	        this.model.entityId = this.config.entityId;
	        this.model.entityName = this.config.entityName;
	        this.model.attach = this.config.attach;
	        this.pickContactPreselects = this.config.pickContactPreselects;
	      }
	
	      this.filterb64 = btoa(JSON.stringify(this.model));
	    }
	  }, {
	    key: 'ok',
	    value: function ok(model) {
	      this.close({ $value: model });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }, {
	    key: 'getContactTypeName',
	    value: function getContactTypeName(type) {
	      switch (type) {
	        case 'primary-owner':
	          return "Primary Owner";
	        case 'owner':
	          return "Owner";
	        case 'renter':
	          return "Renter";
	        case 'previous-owner':
	          return "Previous Owner";
	        case 'visitor':
	          return "Visitor";
	        default:
	          return type;
	      }
	    }
	  }, {
	    key: 'updateModelContactTypes',
	    value: function updateModelContactTypes() {
	      var _this3 = this;
	
	      var selectedContactTypes = [];
	      this.contactTypes.forEach(function (type) {
	        if (_this3.contactTypesMap[type]) selectedContactTypes.push(type);
	      });
	      this.model.contactTypes = selectedContactTypes;
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      this.submitted = true;
	      this.sendFailure = false;
	
	      this.$scope.$broadcast('schemaFormValidate');
	
	      if (form.$valid) {
	        this.ok(this.model);
	      }
	    }
	  }]);
	
	  return ReportFilterModalComponent;
	}();
	
	exports.default = angular.module('conduu.reportFilterModal', []).component('reportFilterModal', {
	  template: __webpack_require__(773),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: ReportFilterModalComponent
	}).name;

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\"><i ng-if=\"$ctrl.icon\" class=\"fa fa-fw fa-{{$ctrl.icon}}\"></i> {{$ctrl.config.title}}</h3>\n</div>\n\n<div class=\"modal-body\" id=\"modal-body\">\n\n  <pre>{{$ctrl.fields | json}}</pre>\n  <pre>{{$ctrl.model | json}}</pre>\n\n  <span ng-if=\"!$ctrl.fields.length\">No additional filter available for this report.</span>\n\n  <div ng-repeat=\"field in $ctrl.fields\" ng-switch=\"field.type\">\n\n    <!-- Pick Contact from Preselection -->\n    <div ng-switch-when=\"pick-contact-preselect\" class=\"form-group\">\n      <label>Contact</label>\n      <br/>\n\n      <select class=\"form-control\" ng-options=\"o.payload as o.name group by o.group for o in $ctrl.pickContactPreselects\"\n              ng-model=\"$ctrl.model.pickContactPreselect\"></select>\n    </div>\n\n    <!-- Community Picker -->\n    <div ng-switch-when=\"community\" class=\"form-group\">\n      <label>Community</label>\n      <br/>\n\n      <div class=\"input-group\" style=\"display: inline-block\">\n        <select class=\"form-control\" ng-options=\"o.value as o.name for o in $ctrl.communities\" ng-model=\"$ctrl.model.community\"\n                style=\"display: inline-block; width: auto\"></select>\n        <span class=\"input-group-btn\">\n        <a class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.communityLookup()\"><i class=\"fa fa-fw fa-search\"></i></a>\n        <a class=\"btn btn-danger\" ng-disabled=\"!$ctrl.model.community\" ng-click=\"$ctrl.model.community = ''\"><i class=\"fa fa-fw fa-times\"></i></a>\n      </span>\n      </div>\n    </div>\n\n    <!-- Contact Type -->\n    <div ng-switch-when=\"contactTypes\" class=\"form-group\">\n      <label>Contact Types</label>\n      <br/>\n      <ul class=\"list-group\">\n        <li ng-repeat=\"type in $ctrl.contactTypes\" class=\"list-group-item\">\n          <label style=\"font-weight: normal\"><input type=\"checkbox\" ng-model=\"$ctrl.contactTypesMap[type]\" ng-click=\"$ctrl.updateModelContactTypes()\">&nbsp;&nbsp;{{$ctrl.getContactTypeName(type)}}</label>\n        </li>\n      </ul>\n    </div>\n\n    <!-- Generic Select -->\n    <div ng-switch-when=\"select\" class=\"form-group\">\n      <label>{{field.title}}</label>\n      <br/>\n\n        <select class=\"form-control\" ng-options=\"o as o for o in field.enum\" ng-model=\"$ctrl.model[field.model]\"></select>\n    </div>\n\n  </div>\n\n</div>\n<div class=\"modal-footer\">\n  <div style=\"float: left\">\n    <i ng-if=\"$ctrl.model.fileType == 'pdf'\" class=\"fa fa-fw fa-2x fa-file-pdf-o\" style=\"position: relative; top: 4px;\"></i>\n    <i ng-if=\"$ctrl.model.fileType == 'docx'\" class=\"fa fa-fw fa-2x fa-file-word-o\" style=\"position: relative; top: 4px;\"></i>\n    <i ng-if=\"$ctrl.model.fileType == 'odt'\" class=\"fa fa-fw fa-2x fa-file-text-o\" style=\"position: relative; top: 4px;\"></i>\n    <select class=\"form-control\" ng-options=\"o.fileType as o.name for o in $ctrl.fileTypes\" ng-model=\"$ctrl.model.fileType\"\n            style=\"display: inline-block; width: auto\"></select>\n  </div>\n  <a class=\"btn btn-primary\" target=\"_blank\" ng-href=\"/api/reports/q/{{$ctrl.filterb64}}\"><i class=\"fa fa-fw fa-download\"></i> Download</a>\n  <button class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\"><i class=\"fa fa-fw fa-times\"></i> Close</button>\n</div>\n"

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var SingleAddressLabelModalComponent = exports.SingleAddressLabelModalComponent = function () {
	  /*@ngInject*/
	  SingleAddressLabelModalComponent.$inject = ['$scope', 'CommunityService', '$uibModal', 'SettingsService'];
	  function SingleAddressLabelModalComponent($scope, CommunityService, $uibModal, SettingsService) {
	    var _this = this;
	
	    _classCallCheck(this, SingleAddressLabelModalComponent);
	
	    this.$scope = $scope;
	    this.$uibModal = $uibModal;
	
	    this.model = {
	      position: 1
	    };
	    this.$scope.model = this.model;
	
	    this.positions = [];
	    for (var i = 1; i <= 30; i++) {
	      this.positions.push(i);
	    }this.mapFileType = {
	      'docx': "Word Document (DOCX)",
	      'odt': 'Open Office Document (ODT)',
	      'pdf': 'Portable Document Format (PDF)'
	    };
	
	    SettingsService.getByName({ name: "client" }, function (settings) {
	      _this.model.template = settings.data.templates["single-address-label"];
	    });
	
	    $scope.$watch("model", function (_) {
	      return _this.filterb64 = btoa(JSON.stringify(_this.model));
	    }, true);
	  }
	
	  _createClass(SingleAddressLabelModalComponent, [{
	    key: 'getAddress',
	    value: function getAddress(address) {
	      try {
	        return address.street + ', ' + address.city + ' ' + address.state + ', ' + address.zip;
	      } catch (e) {
	        return "-";
	      }
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.config = this.resolve.config;
	
	
	      var filetypes = this.config.fileTypes || ["docx", "pdf", "odt"];
	      this.fileTypes = filetypes.map(function (fileType) {
	        return { fileType: fileType, name: _this2.mapFileType[fileType] };
	      });
	
	      this.addresses = this.config.addresses.map(function (adr) {
	
	        var primaryMark = adr.isPrimary ? " (Primary)" : "";
	
	        if (adr.isPrimary) _this2.model.address = adr;
	
	        return {
	          name: _this2.getAddress(adr) + " (" + adr.type + ")" + primaryMark,
	          json: adr
	        };
	      });
	
	      this.model.report = "single-address-label";
	      this.model.fileType = this.config.defaultFileType || "docx";
	
	      this.model.owner = this.config.owner;
	
	      this.filterb64 = btoa(JSON.stringify(this.model));
	    }
	  }, {
	    key: 'ok',
	    value: function ok(model) {
	      this.close({ $value: model });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      this.submitted = true;
	      this.sendFailure = false;
	
	      this.$scope.$broadcast('schemaFormValidate');
	
	      if (form.$valid) {
	        this.ok(this.model);
	      }
	    }
	  }]);
	
	  return SingleAddressLabelModalComponent;
	}();
	
	exports.default = angular.module('conduu.singleAddressLabelModal', []).component('singleAddressLabelModal', {
	  template: __webpack_require__(775),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: SingleAddressLabelModalComponent
	}).name;

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\"><i class=\"fa fa-fw fa-th\"></i> Address Label</h3>\r\n</div>\r\n\r\n<div class=\"modal-body\" id=\"modal-body\" ng-switch=\"$ctrl.fields\">\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-8\">\r\n\r\n      <div class=\"form-group\">\r\n        <label>Address</label>\r\n        <br/>\r\n\r\n        <select class=\"form-control\" ng-options=\"o.json as o.name for o in $ctrl.addresses\" ng-model=\"$ctrl.model.address\"></select>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Label Position</label>\r\n        <select class=\"form-control\" ng-options=\"o for o in $ctrl.positions\" ng-model=\"$ctrl.model.position\"></select>\r\n      </div>\r\n\r\n    </div>\r\n    <div class=\"col-xs-4\">\r\n      <div style=\"width: 140px;\">\r\n        <div ng-repeat-start=\"i in $ctrl.positions\" class=\"col-xs-4\" ng-if=\"i!=$ctrl.model.position\" ng-click=\"$ctrl.model.position = i\" style=\"cursor: pointer; font-size: x-small; height: 16px; text-align: center; border: 1px solid lightgray\">{{i}}</div>\r\n        <div ng-repeat-end=\"\" ng-if=\"i==$ctrl.model.position\" class=\"col-xs-4\" style=\"cursor: pointer; background-color: lightblue; font-weight:bold; font-size: x-small; height: 16px; text-align: center; border: 1px solid lightgray\">{{i}}</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <div style=\"float: left\">\r\n    <i ng-if=\"$ctrl.model.fileType == 'pdf'\" class=\"fa fa-fw fa-2x fa-file-pdf-o\" style=\"position: relative; top: 4px;\"></i>\r\n    <i ng-if=\"$ctrl.model.fileType == 'docx'\" class=\"fa fa-fw fa-2x fa-file-word-o\" style=\"position: relative; top: 4px;\"></i>\r\n    <i ng-if=\"$ctrl.model.fileType == 'odt'\" class=\"fa fa-fw fa-2x fa-file-text-o\" style=\"position: relative; top: 4px;\"></i>\r\n    <select class=\"form-control\" ng-options=\"o.fileType as o.name for o in $ctrl.fileTypes\" ng-model=\"$ctrl.model.fileType\"\r\n            style=\"display: inline-block; width: auto\"></select>\r\n  </div>\r\n  <a class=\"btn btn-primary\" target=\"_blank\" ng-href=\"/api/reports/q/{{$ctrl.filterb64}}\"><i class=\"fa fa-fw fa-floppy-o\"></i> Download</a>\r\n  <button class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\"><i class=\"fa fa-fw fa-times\"></i> Close</button>\r\n</div>\r\n"

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomViewComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _customView = __webpack_require__(777);
	
	var _customView2 = _interopRequireDefault(_customView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var pluralize = __webpack_require__(693);
	
	var unflatten = __webpack_require__(778).unflatten;
	
	var CustomViewComponent = exports.CustomViewComponent = function () {
	  CustomViewComponent.$inject = ['Auth', 'CustomViewService', 'dialogs', '$uibModal', '$stateParams', 'SettingsService', '$filter', 'DTOptionsBuilder', 'DTState', 'Util'];
	  function CustomViewComponent(Auth, CustomViewService, dialogs, $uibModal, $stateParams, SettingsService, $filter, DTOptionsBuilder, DTState, Util) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, CustomViewComponent);
	
	    this.CustomViewService = CustomViewService;
	    this.isAdmin = Auth.isAdminSync;
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.$filter = $filter;
	
	    this.type = $stateParams.type;
	
	    SettingsService.getByName({ name: "custom-views" }, function (settings) {
	      _this.config = settings.data[_this.type].view;
	
	      var oSortOrder = _this.config.order || [0, 'asc'];
	
	      _this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', oSortOrder).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	        extend: 'excel',
	        title: _this.config.title,
	        exportOptions: {
	          orthogonal: 'export'
	        }
	      }, {
	        extend: 'csv',
	        title: _this.config.title,
	        exportOptions: {
	          orthogonal: 'export'
	        }
	      }, {
	        title: _this.config.title,
	        message: 'As of ' + moment().format("MMMM Do YYYY"),
	        extend: 'pdf',
	        orientation: 'portrait',
	        pageSize: 'LETTER',
	        exportOptions: {
	          orthogonal: 'export'
	        }
	      }, {
	        extend: 'print',
	        title: _this.config.title,
	        exportOptions: {
	          orthogonal: 'export'
	        }
	      }]);
	
	      if (_this.config.rowGroup) {
	        _this.dtOptions.rowGroup = {
	          dataSrc: _this.config.rowGroup
	        };
	
	        _this.dtOptions.columnDefs = [{
	          targets: _this.config.rowGroup,
	          visible: false
	        }];
	      }
	
	      for (var i = 0; i < _this.config.colDefs.length; i++) {
	        if (_this.config.colDefs[i].exportBreakToNewline) {
	          if (!_this.dtOptions.columnDefs || !Array.isArray(_this.dtOptions.columnDefs)) _this.dtOptions.columnDefs = [];
	
	          _this.dtOptions.columnDefs.push({
	            targets: [i],
	            render: Util.dataTableExportBreakToNewlineRenderer
	          });
	        }
	      }
	
	      console.log(_this.config.colDefs, _this.dtOptions);
	    }, function (_) {
	      console.log("Could not retrieve custom views settings");
	    });
	
	    var METHOD = this.script ? "getCustomViewScript" : "getCustomView";
	
	    this.CustomViewService[METHOD]({ type: this.type }, function (data) {
	      _this.data = data;
	    }, function (err) {
	      console.log("Could not retrieve custom view data.");
	    });
	  }
	
	  _createClass(CustomViewComponent, [{
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (!contact) {
	        return "Removed Contact";
	      }
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") {
	          composedName += contact.company;
	        } else {
	          composedName += "<br/>" + contact.company;
	        }
	      }
	
	      return composedName;
	    }
	  }, {
	    key: 'getFromByContactId',
	    value: function getFromByContactId(entry, contactId, path) {
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.property;
	      if (path) ref = oEntry[path];
	
	      var matchContact = ref.contacts.find(function (c) {
	        return c.contact == contactId;
	      });
	      if (matchContact) return matchContact.from ? matchContact.from : "";
	
	      return "";
	    }
	  }, {
	    key: 'getTillByContactId',
	    value: function getTillByContactId(entry, contactId, path) {
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.property;
	      if (path) ref = oEntry[path];
	
	      var matchContact = ref.contacts.find(function (c) {
	        return c.contact == contactId;
	      });
	      if (matchContact) return matchContact.till ? matchContact.till : "";
	
	      return "";
	    }
	  }, {
	    key: 'getActiveTenant',
	    value: function getActiveTenant(entry, path) {
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.property;
	      if (path) ref = oEntry[path];
	
	      var activeTenant = ref.contacts.find(function (contact) {
	        try {
	          if (contact.type == 'renter') {
	
	            if (!contact.from && !contact.till) return true;
	
	            if (contact.from && contact.till) {
	              return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
	            }
	
	            if (!contact.from && contact.till) {
	              return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
	            }
	
	            if (contact.from && !contact.till) {
	              return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
	            }
	          } else {
	            return false;
	          }
	        } catch (e) {
	          console.log(e);
	          return null;
	        }
	      });
	
	      if (!activeTenant) return null;
	
	      return activeTenant.contact;
	    }
	  }, {
	    key: 'getContactId',
	    value: function getContactId(contact) {
	      return contact._id;
	    }
	  }, {
	    key: 'getActiveTenantName',
	    value: function getActiveTenantName(entry, path) {
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.property;
	      if (path) ref = oEntry[path];
	
	      var activeTenant = ref.contacts.find(function (contact) {
	        try {
	          if (contact.type == 'renter') {
	
	            if (!contact.from && !contact.till) return true;
	
	            if (contact.from && contact.till) {
	              return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
	            }
	
	            if (!contact.from && contact.till) {
	              return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
	            }
	
	            if (contact.from && !contact.till) {
	              return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
	            }
	          } else {
	            return false;
	          }
	        } catch (e) {
	          console.log(e);
	          return "-";
	        }
	      });
	
	      if (!activeTenant) return "-";
	
	      return this.getComposedName(activeTenant.contact);
	    }
	  }, {
	    key: 'getActiveTenantsNames',
	    value: function getActiveTenantsNames(entry, path) {
	      var _this2 = this;
	
	      var joinSymbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "<br/>";
	
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.property;
	      if (path) ref = oEntry[path];
	
	      var allActivateTenants = ref.contacts.filter(function (contact) {
	        try {
	          if (contact.type == 'renter') {
	
	            if (!contact.from && !contact.till) return true;
	
	            if (contact.from && contact.till) {
	              return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
	            }
	
	            if (!contact.from && contact.till) {
	              return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
	            }
	
	            if (contact.from && !contact.till) {
	              return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
	            }
	          } else {
	            return false;
	          }
	        } catch (e) {
	          console.log(e);
	          return false;
	        }
	      });
	
	      if (!allActivateTenants.length) return "-";
	
	      var allNames = allActivateTenants.map(function (o) {
	        return _this2.getComposedName(o.contact);
	      });
	
	      return allNames.join(joinSymbol);
	    }
	  }, {
	    key: 'getPrimaryOwnerName',
	    value: function getPrimaryOwnerName(entry, path) {
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.property;
	      if (path) ref = oEntry[path];
	
	      var primary = ref.contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary) return "-";
	
	      return this.getComposedName(primary.contact);
	    }
	  }, {
	    key: 'getOtherOwnerName',
	    value: function getOtherOwnerName(entry, path) {
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.property;
	      if (path) ref = oEntry[path];
	
	      var other = ref.contacts.find(function (contact) {
	        return contact.type == 'owner';
	      });
	
	      if (!other) return "-";
	
	      return this.getComposedName(other.contact);
	    }
	  }, {
	    key: 'getPrimaryOwner',
	    value: function getPrimaryOwner(entry, path) {
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.property;
	      if (path) ref = oEntry[path];
	
	      var primary = ref.contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary) return null;
	
	      return primary.contact;
	    }
	  }, {
	    key: 'getContactNameByTypeAndIndex',
	    value: function getContactNameByTypeAndIndex(entry, path, type, index) {
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.property;
	      if (path) ref = oEntry[path];
	
	      var allByType = ref.contacts.filter(function (contact) {
	        return contact.type == type;
	      });
	      var matchedByIndex = allByType[index];
	
	      if (!matchedByIndex) return "-";
	
	      return this.getComposedName(matchedByIndex.contact);
	    }
	  }, {
	    key: 'getContactNamesByType',
	    value: function getContactNamesByType(entry, path, type) {
	      var _this3 = this;
	
	      var joinSymbol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "<br/>";
	
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.property;
	      if (path) ref = oEntry[path];
	
	      var allByType = ref.contacts.filter(function (contact) {
	        return contact.type == type;
	      });
	
	      if (!allByType.length) return "-";
	
	      var allNames = allByType.map(function (o) {
	        return _this3.getComposedName(o.contact);
	      });
	
	      return allNames.join(joinSymbol);
	    }
	  }, {
	    key: 'getPrimaryAddress',
	    value: function getPrimaryAddress(contact) {
	      if (!contact || !contact.address || !contact.address.length) return "-";
	
	      var address = contact.address.find(function (adr) {
	        return adr.isPrimary;
	      }) || contact.address[0] || {};
	
	      return address.street + "<br/>" + address.city + ' ' + address.state + ', ' + address.zip;
	    }
	  }, {
	    key: 'getPrimaryAddressFlatted',
	    value: function getPrimaryAddressFlatted(entry, path) {
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.contact;
	      if (path) ref = oEntry[path];
	
	      return this.getPrimaryAddress(ref);
	    }
	  }, {
	    key: 'getPrimaryEmailFlatted',
	    value: function getPrimaryEmailFlatted(entry, path) {
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.contact;
	      if (path) ref = oEntry[path];
	
	      return this.getPrimaryEmailSoftBreak(ref);
	    }
	  }, {
	    key: 'getPrimaryPhoneFlatted',
	    value: function getPrimaryPhoneFlatted(entry, path) {
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.contact;
	      if (path) ref = oEntry[path];
	
	      return this.getPrimaryPhone(ref);
	    }
	  }, {
	    key: 'getOtherOwner',
	    value: function getOtherOwner(entry, path) {
	      var oEntry = unflatten(entry);
	
	      var ref = oEntry.property;
	      if (path) ref = oEntry[path];
	
	      var other = ref.contacts.find(function (contact) {
	        return contact.type == 'owner';
	      });
	
	      if (!other) return null;
	
	      return other.contact;
	    }
	  }, {
	    key: 'getPrimaryEmailSoftBreak',
	    value: function getPrimaryEmailSoftBreak(contact) {
	      var email = this.getPrimaryEmail(contact);
	
	      return email.replace('@', '@&#8203;').replace('.', '&#8203;.').replace('-', '-&#8203;').replace('_', '_&#8203;');
	    }
	  }, {
	    key: 'getPrimaryEmail',
	    value: function getPrimaryEmail(contact) {
	      if (!contact || !contact.email || !contact.email.length) return "-";
	
	      var email = contact.email.find(function (email) {
	        return email.isPrimary;
	      }) || contact.email[0] || { address: '-' };
	
	      return email.address;
	    }
	  }, {
	    key: 'getPrimaryPhone',
	    value: function getPrimaryPhone(contact) {
	      if (!contact || !contact.phone || !contact.phone.length) return "-";
	
	      var phone = contact.phone.find(function (phone) {
	        return phone.isPrimary;
	      }) || contact.phone[0] || { number: '-' };
	
	      return phone.number;
	    }
	  }, {
	    key: 'getPrimaryAddress',
	    value: function getPrimaryAddress(contact) {
	      if (!contact || !contact.address || !contact.address.length) return "-";
	
	      var address = contact.address.find(function (adr) {
	        return adr.isPrimary;
	      }) || contact.address[0] || {};
	
	      return address.street + "<br/>" + address.city + ' ' + address.state + ', ' + address.zip;
	    }
	  }]);
	
	  return CustomViewComponent;
	}();
	
	exports.default = angular.module('conduu.customView', [uiRouter]).config(_customView2.default).component('customView', {
	  template: __webpack_require__(780),
	  controller: CustomViewComponent,
	  controllerAs: 'ctrl',
	  bindings: {
	    script: '@'
	  }
	}).name;

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('custom-view', {
	    url: '/custom-view/:type',
	    template: '<custom-view></custom-view>',
	    authenticate: true
	  }).state('custom-view-script', {
	    url: '/custom-view/script/:type',
	    template: '<custom-view script="true"></custom-view>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var isBuffer = __webpack_require__(779)
	
	module.exports = flatten
	flatten.flatten = flatten
	flatten.unflatten = unflatten
	
	function flatten (target, opts) {
	  opts = opts || {}
	
	  var delimiter = opts.delimiter || '.'
	  var maxDepth = opts.maxDepth
	  var output = {}
	
	  function step (object, prev, currentDepth) {
	    currentDepth = currentDepth || 1
	    Object.keys(object).forEach(function (key) {
	      var value = object[key]
	      var isarray = opts.safe && Array.isArray(value)
	      var type = Object.prototype.toString.call(value)
	      var isbuffer = isBuffer(value)
	      var isobject = (
	        type === '[object Object]' ||
	        type === '[object Array]'
	      )
	
	      var newKey = prev
	        ? prev + delimiter + key
	        : key
	
	      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
	        (!opts.maxDepth || currentDepth < maxDepth)) {
	        return step(value, newKey, currentDepth + 1)
	      }
	
	      output[newKey] = value
	    })
	  }
	
	  step(target)
	
	  return output
	}
	
	function unflatten (target, opts) {
	  opts = opts || {}
	
	  var delimiter = opts.delimiter || '.'
	  var overwrite = opts.overwrite || false
	  var result = {}
	
	  var isbuffer = isBuffer(target)
	  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
	    return target
	  }
	
	  // safely ensure that the key is
	  // an integer.
	  function getkey (key) {
	    var parsedKey = Number(key)
	
	    return (
	      isNaN(parsedKey) ||
	      key.indexOf('.') !== -1 ||
	      opts.object
	    ) ? key
	      : parsedKey
	  }
	
	  var sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
	    return keyA.length - keyB.length
	  })
	
	  sortedKeys.forEach(function (key) {
	    var split = key.split(delimiter)
	    var key1 = getkey(split.shift())
	    var key2 = getkey(split[0])
	    var recipient = result
	
	    while (key2 !== undefined) {
	      var type = Object.prototype.toString.call(recipient[key1])
	      var isobject = (
	        type === '[object Object]' ||
	        type === '[object Array]'
	      )
	
	      // do not write over falsey, non-undefined values if overwrite is false
	      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
	        return
	      }
	
	      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
	        recipient[key1] = (
	          typeof key2 === 'number' &&
	          !opts.object ? [] : {}
	        )
	      }
	
	      recipient = recipient[key1]
	      if (split.length > 0) {
	        key1 = getkey(split.shift())
	        key2 = getkey(split[0])
	      }
	    }
	
	    // unflatten again for 'messy objects'
	    recipient[key1] = unflatten(target[key], opts)
	  })
	
	  return result
	}


/***/ }),
/* 779 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 780 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>{{ctrl.config.title}}</h2>\r\n      <li class=\"active\"><a class=\"text-capitalize\" href=\"#\">{{ctrl.config.title}}</a></li>\r\n    </ol>\r\n    \r\n    <div class=\"col-xs-12\">\r\n\r\n      <table datatable=\"ng\" ng-if=\"ctrl.data && ctrl.config\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\"\r\n             ng-class=\"{'custom-view-grouped': ctrl.config.rowGroup}\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th ng-repeat=\"col in ctrl.config.colDefs\">{{col.name}}</th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"entity in ctrl.data | orderBy: 'meta.creationDate':true\">\r\n          <td ng-repeat=\"col in ctrl.config.colDefs\" class=\"{{col.cssClass || ''}}\" bind-dynamic-page=\"col.template\"></td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	CustomViewService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomViewService = CustomViewService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function CustomViewService($resource) {
	  return $resource('/api/custom-views/:id', {
	    name: '@_id'
	  }, {
	    getCustomView: {
	      method: 'GET',
	      isArray: true,
	      url: "/api/custom-views/:type"
	    }, getCustomViewScript: {
	      method: 'GET',
	      isArray: true,
	      url: "/api/custom-views/script/:type"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.CustomViewService', []).factory('CustomViewService', CustomViewService).name;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	datatablesStateService.$inject = ['$localStorage', '$location'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.datatablesStateService = datatablesStateService;
	var angular = __webpack_require__(14);
	
	function datatablesStateService($localStorage, $location) {
	  'ngInject';
	
	  var BASE_KEY = "DTState$";
	
	  if (!$localStorage.dtState) $localStorage.dtState = {};
	
	  return {
	    save: function save(key) {
	      var SAVE_KEY = BASE_KEY;
	      if (key) {
	        SAVE_KEY += key + "$";
	      }
	      SAVE_KEY += $location.url();
	
	      return function (settings, data) {
	        $localStorage.dtState[SAVE_KEY] = data;
	      };
	    },
	    restore: function restore(key) {
	      var RESTORE_KEY = BASE_KEY;
	      if (key) {
	        RESTORE_KEY += key + "$";
	      }
	      RESTORE_KEY += $location.url();
	
	      return function (settings, callback) {
	        if ($localStorage.dtState && $localStorage.dtState[RESTORE_KEY]) {
	          callback($localStorage.dtState[RESTORE_KEY]);
	        } else {
	          callback({});
	        }
	      };
	    }
	  };
	}
	
	exports.default = angular.module('conduu.datatablesState', []).factory('DTState', datatablesStateService).name;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var combinedDateTimePickerComponent = exports.combinedDateTimePickerComponent = function () {
	  function combinedDateTimePickerComponent() {
	    'ngInject';
	
	    _classCallCheck(this, combinedDateTimePickerComponent);
	  }
	
	  _createClass(combinedDateTimePickerComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.datetime = moment(this.model).toDate();
	    }
	  }, {
	    key: 'dateChange',
	    value: function dateChange() {}
	  }]);
	
	  return combinedDateTimePickerComponent;
	}();
	
	exports.default = angular.module('conduuApp.combinedDateTimePicker', []).component('combinedDateTimePicker', {
	  template: __webpack_require__(784),
	  bindings: {
	    model: "=",
	    form: "<"
	  },
	  controller: combinedDateTimePickerComponent
	}).name;

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	module.exports = "<p class=\"input-group\">\r\n    <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{$ctrl.form.format}}\" ng-model=\"$ctrl.datetime\"\r\n           is-open=\"$ctrl.opened\" datepicker-options=\"$ctrl.form.dateOptions\" ng-required=\"$ctrl.form.required\"\r\n           close-text=\"Close\" alt-input-formats=\"$ctrl.form.altInputFormats\" ng-change=\"$ctrl.dateChange()\" />\r\n    <span class=\"input-group-btn\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.opened = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n      </span>\r\n</p>\r\n\r\n<div uib-timepicker ng-model=\"$ctrl.datetime\" hour-step=\"$ctrl.form.hstep || 1\" minute-step=\"$ctrl.form.mstep || 15\" show-meridian=\"$ctrl.form.ismeridian || true\"></div>"

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var LetterAddressSelectModalComponent = exports.LetterAddressSelectModalComponent = function () {
	  /*@ngInject*/
	  function LetterAddressSelectModalComponent() {
	    _classCallCheck(this, LetterAddressSelectModalComponent);
	  }
	
	  _createClass(LetterAddressSelectModalComponent, [{
	    key: 'getAddress',
	    value: function getAddress(address) {
	      try {
	        return address.street + ', ' + address.city + ' ' + address.state + ', ' + address.zip;
	      } catch (e) {
	        return "-";
	      }
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.config = this.resolve.config;
	
	      this.addresses = this.config.addresses.map(function (adr) {
	
	        var primaryMark = adr.isPrimary ? " (Primary)" : "";
	
	        return {
	          group: adr.group,
	          name: _this.getAddress(adr) + " (" + adr.type + ")" + primaryMark,
	          json: adr
	        };
	      });
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.selectedAddress });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return LetterAddressSelectModalComponent;
	}();
	
	exports.default = angular.module('conduu.letterAddressSelectModalComponent', []).component('letterAddressSelectModal', {
	  template: __webpack_require__(786),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: LetterAddressSelectModalComponent
	}).name;

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\"><i class=\"fa fa-fw fa-envelope-o\"></i> Select Address</h3>\r\n</div>\r\n\r\n<div class=\"modal-body\" id=\"modal-body\" ng-switch=\"$ctrl.fields\">\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n\r\n      <div class=\"form-group\">\r\n        <label>Address</label>\r\n        <br/>\r\n\r\n        <select class=\"form-control\" ng-options=\"o.json as o.name group by o.group for o in $ctrl.addresses\" ng-model=\"$ctrl.selectedAddress\"></select>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\" ng-disabled=\"!$ctrl.selectedAddress\"><i class=\"fa fa-fw fa-check\"></i> OK</button>\r\n  <button class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var LetterAddressDownloadModalComponent = exports.LetterAddressDownloadModalComponent = function () {
	  /*@ngInject*/
	  function LetterAddressDownloadModalComponent() {
	    _classCallCheck(this, LetterAddressDownloadModalComponent);
	  }
	
	  _createClass(LetterAddressDownloadModalComponent, [{
	    key: 'getAddress',
	    value: function getAddress(address) {
	      try {
	        return address.street + ', ' + address.city + ' ' + address.state + ', ' + address.zip;
	      } catch (e) {
	        return "-";
	      }
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.config = this.resolve.config;
	
	      this.addresses = this.config.addresses.map(function (adr) {
	
	        var primaryMark = adr.isPrimary ? " (Primary)" : "";
	
	        return {
	          group: adr.group,
	          name: _this.getAddress(adr) + " (" + adr.type + ")" + primaryMark,
	          json: adr
	        };
	      });
	    }
	  }, {
	    key: 'adrChanged',
	    value: function adrChanged() {
	      this.addressb64 = btoa(JSON.stringify(this.selectedAddress));
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return LetterAddressDownloadModalComponent;
	}();
	
	exports.default = angular.module('conduu.letterAddressDownloadModalComponent', []).component('letterAddressDownloadModal', {
	  template: __webpack_require__(788),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: LetterAddressDownloadModalComponent
	}).name;

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\"><i class=\"fa fa-fw fa-envelope-o\"></i> Select Address</h3>\r\n</div>\r\n\r\n<div class=\"modal-body\" id=\"modal-body\" ng-switch=\"$ctrl.fields\">\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n\r\n      <div class=\"form-group\">\r\n        <label>Address</label>\r\n        <br/>\r\n\r\n        <select class=\"form-control\" ng-options=\"o.json as o.name group by o.group for o in $ctrl.addresses\"\r\n                ng-change=\"$ctrl.adrChanged()\"\r\n                ng-model=\"$ctrl.selectedAddress\"></select>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <a ng-if=\"$ctrl.config.endpoint == 'violations'\" class=\"btn btn-primary\" target=\"_blank\" ng-href=\"/api/violations/{{$ctrl.config.id}}/letter/{{$ctrl.config.level}}/{{$ctrl.config.filetype}}/{{$ctrl.addressb64}}\"><i class=\"fa fa-fw fa-floppy-o\"></i> Download</a>\r\n  <button class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\"><i class=\"fa fa-fw fa-times\"></i> Close</button>\r\n</div>\r\n"

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VoterGroupListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _voterGroupList = __webpack_require__(790);
	
	var _voterGroupList2 = _interopRequireDefault(_voterGroupList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var VoterGroupListComponent = exports.VoterGroupListComponent = function () {
	  VoterGroupListComponent.$inject = ['Auth', 'VoterGroupsService', 'DTOptionsBuilder', 'dialogs', '$uibModal'];
	  function VoterGroupListComponent(Auth, VoterGroupsService, DTOptionsBuilder, dialogs, $uibModal) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, VoterGroupListComponent);
	
	    this.VoterGroupsService = VoterGroupsService;
	    this.data = [];
	    this.isAdmin = Auth.isAdminSync;
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	
	    this.VoterGroupsService.query(function (data) {
	      _this.data = data;
	    }, function (err) {
	      console.log("Could not retrieve voter groups.");
	    });
	  }
	
	  _createClass(VoterGroupListComponent, [{
	    key: 'delete',
	    value: function _delete(group) {
	      var that = this;
	
	      var groupText = "<br/><br/><b>" + group.name + "</b><br/><p>" + group.description + "</p>";
	
	      var dlg = this.dialogs.confirm("Delete Voter Group?", "Do you really want to delete the voter group?" + groupText);
	      dlg.result.then(function () {
	        that.VoterGroupsService.delete({ id: group._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== group._id;
	          });
	        }, function (err) {
	          alert("Could not delete group");
	        });
	      }, function () {});
	    }
	  }]);
	
	  return VoterGroupListComponent;
	}();
	
	exports.default = angular.module('conduu.voterGroupList', [uiRouter]).config(_voterGroupList2.default).component('voterGroupList', {
	  template: __webpack_require__(791),
	  controller: VoterGroupListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('voter-group-list', {
	    url: '/voter-group/list',
	    template: '<voter-group-list></voter-group-list>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" href=\"/voter-group/edit/\"><i class=\"fa fa-plus\"></i> Create New Voter Group</a>\r\n      <h2>Voter Groups</h2>\r\n      <li class=\"active\"><a href=\"#\">Voter Groups</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <table datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n        <thead>\r\n        <tr>\r\n          <th>Name</th>\r\n          <th></th>\r\n          <th>Description</th>\r\n          <th>Date</th>\r\n          <th></th>\r\n          <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"group in ctrl.data | orderBy: 'meta.creationDate':true\">\r\n          <td><a ng-href=\"/voter-group/{{group._id}}\">{{group.name}}</a></td>\r\n          <td>\r\n            <span class=\"badge\" ng-if=\"group.type == 'properties'\">{{group.properties.length}}</span>\r\n            <span class=\"badge\" ng-if=\"group.type == 'contacts'\">{{group.contacts.length}}</span>\r\n          </td>\r\n          <td><span ng-bind-html=\"group.description | newlineToHtml\"></span></td>\r\n          <td>\r\n            <nobr>{{group.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\r\n          </td>\r\n          <td><a class=\"btn btn-sm btn-primary\" ng-href=\"/voter-group/{{group._id}}\"><i class=\"fa fa-folder-open fa-fw\"></i></a></td>\r\n          <td>\r\n            <a class=\"btn btn-sm btn-primary\" ng-href=\"/voter-group/edit/{{group._id}}\"><i class=\"fa fa-pencil fa-fw\"></i></a>\r\n            <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(group)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VoterGroupEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _voterGroupEdit = __webpack_require__(793);
	
	var _voterGroupEdit2 = _interopRequireDefault(_voterGroupEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var VoterGroupEditComponent = exports.VoterGroupEditComponent = function () {
	  VoterGroupEditComponent.$inject = ['VoterGroupsService', 'Auth', '$state', '$stateParams', 'dialogs', '$uibModal', 'PropertyService', 'ContactService'];
	  function VoterGroupEditComponent(VoterGroupsService, Auth, $state, $stateParams, dialogs, $uibModal, PropertyService, ContactService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, VoterGroupEditComponent);
	
	    this.VoterGroupsService = VoterGroupsService;
	    this.PropertyService = PropertyService;
	    this.ContactService = ContactService;
	
	    this.$uibModal = $uibModal;
	
	    this.groupId = $stateParams.id;
	
	    this.dialogs = dialogs;
	
	    this.jsonValue = "";
	    this.$state = $state;
	
	    this.contacts = ContactService.query();
	    this.properties = PropertyService.query();
	
	    this.types = [{
	      name: "Properties",
	      type: "properties"
	    }, {
	      name: "Contacts",
	      type: "contacts"
	    }];
	
	    this.groupTemplate = {
	      name: '',
	      description: '',
	      type: "properties",
	      contacts: [],
	      properties: [],
	      meta: {
	        creationUser: Auth.getCurrentUserSync()._id,
	        active: true
	      }
	    };
	
	    this.group = angular.copy(this.groupTemplate);
	
	    if (this.groupId) {
	      this.VoterGroupsService.getWithData({ id: this.groupId }, function (data) {
	        _this.group = data;
	      }, function (err) {
	        console.log('Could not load voter group from server');
	      });
	    }
	  }
	
	  _createClass(VoterGroupEditComponent, [{
	    key: 'contactLookup',
	    value: function contactLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'contactLookup',
	        resolve: {
	          config: function config() {
	            return {
	              multiple: true,
	              exclude: that.group.contacts.map(function (contact) {
	                return String(contact._id);
	              })
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (contacts) {
	        contacts.forEach(function (contactId) {
	          that.group.contacts.push(that.contacts.find(function (contact) {
	            return contact._id == contactId;
	          }));
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'propertyLookup',
	    value: function propertyLookup() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'propertyLookup',
	        resolve: {
	          config: function config() {
	            return {
	              multiple: true,
	              exclude: that.group.properties.map(function (ppty) {
	                return String(ppty._id);
	              })
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (properties) {
	        properties.forEach(function (pptyId) {
	          return that.group.properties.push(that.properties.find(function (ppty) {
	            return ppty._id == pptyId;
	          }));
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'getPrimaryOwner',
	    value: function getPrimaryOwner(contacts) {
	      if (!contacts || !contacts.length) return "-";
	
	      var primary = contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary) return "-";
	
	      return this.getComposedName(primary.contact);
	    }
	  }, {
	    key: 'getPrimaryOwnerId',
	    value: function getPrimaryOwnerId(contacts) {
	      var primary = contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary) return 0;else if (!primary.contact || !primary.contact._id) return -1;else return primary.contact._id;
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") {
	          composedName += contact.company;
	        } else {
	          composedName += "<br/>" + contact.company;
	        }
	      }
	
	      return composedName;
	    }
	  }, {
	    key: 'deleteContact',
	    value: function deleteContact(idx) {
	      this.group.contacts.splice(idx, 1);
	    }
	  }, {
	    key: 'deleteProperty',
	    value: function deleteProperty(idx) {
	      this.group.properties.splice(idx, 1);
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          _this2.group = angular.copy(_this2.groupTemplate);
	          _this2.submitted = false;
	
	          var actionString = _this2.groupId ? "changed" : "created";
	          var dlg = _this2.dialogs.notify("Success", "The voter group has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("voter-group-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.group.contacts = this.group.contacts.map(function (contact) {
	          return contact._id;
	        });
	        this.group.properties = this.group.properties.map(function (property) {
	          return property._id;
	        });
	
	        if (this.groupId) {
	          this.VoterGroupsService.update({ id: this.groupId }, this.group, onSuccess, onError);
	        } else {
	          this.VoterGroupsService.save(this.group, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return VoterGroupEditComponent;
	}();
	
	exports.default = angular.module('conduu.voterGroupEdit', [uiRouter]).config(_voterGroupEdit2.default).component('voterGroupEdit', {
	  template: __webpack_require__(794),
	  controller: VoterGroupEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 793 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('voter-group-edit', {
	    url: '/voter-group/edit/:id',
	    template: '<voter-group-edit></voter-group-edit>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Voter Group Editor</h2>\r\n      <li><a href=\"/voter-group/list\">Voter Groups</a></li>\r\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <form class=\"form\" name=\"form\" ng-submit=\"ctrl.create(form)\" novalidate>\r\n\r\n        <!-- Title -->\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\r\n                                            'has-error': form.name.$invalid && ctrl.submitted }\">\r\n          <label>Name</label>\r\n          <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"ctrl.group.name\" required />\r\n          <p class=\"help-block\" ng-show=\"form.name.$error.required && ctrl.submitted\">\r\n            You must specify a name for the voter group.\r\n          </p>\r\n        </div>\r\n\r\n        <!-- Description -->\r\n        <div class=\"form-group\">\r\n          <label>Description</label>\r\n          <input type=\"text\" name=\"description\" class=\"form-control\" ng-model=\"ctrl.group.description\" />\r\n        </div>\r\n\r\n        <!-- Type -->\r\n        <div class=\"form-group\">\r\n          <label>Type</label>\r\n          <select class=\"form-control\" ng-options=\"o.type as o.name for o in ctrl.types\" ng-model=\"ctrl.group.type\"></select>\r\n        </div>\r\n\r\n        <hr>\r\n\r\n        <!-- Properties as Voters -->\r\n        <div class=\"form-group\" ng-if=\"ctrl.group.type == 'properties'\">\r\n          <a ng-click=\"ctrl.propertyLookup()\" class=\"btn btn-primary pull-right btn-sm\" style=\"position: relative; top: -8px\"><i class=\"fa fa-fw fa-plus\"></i> Add Properties</a>\r\n          <label>Properties</label>\r\n          <table datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n            <thead>\r\n            <tr>\r\n              <th>Lot#</th>\r\n              <th>Address</th>\r\n              <th>Primary Owner</th>\r\n              <th>Voter</th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat=\"property in ctrl.group.properties track by $index\">\r\n              <td>{{property.lotNo}}</td>\r\n              <td>{{property.address.street}}</td>\r\n              <td>\r\n                <a ng-if=\"ctrl.getPrimaryOwnerId(property.contacts) !== 0 && ctrl.getPrimaryOwnerId(property.contacts) !== -1\" ng-href=\"/contact/{{ctrl.getPrimaryOwnerId(property.contacts)}}\" ng-bind-html=\"ctrl.getPrimaryOwner(property.contacts)\"></a>\r\n                <span ng-if=\"ctrl.getPrimaryOwnerId(property.contacts) === -1\" class=\"text-muted\">Removed Contact</span>\r\n              </td>\r\n              <td>\r\n                <a ng-if=\"property.eVoting.voter\" ng-href=\"/contact/{{property.eVoting.voter._id}}\" ng-bind-html=\"ctrl.getComposedName(property.eVoting.voter)\"></a>\r\n              </td>\r\n              <td class=\"pull-right\"><a class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.deleteProperty($index)\"><i class=\"fa fa-times fa-fw\"></i> </a></td>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <!-- Contacts as Voters -->\r\n        <div class=\"form-group\" ng-if=\"ctrl.group.type == 'contacts'\">\r\n          <a ng-click=\"ctrl.contactLookup()\" class=\"btn btn-primary pull-right btn-sm\" style=\"position: relative; top: -8px\"><i class=\"fa fa-fw fa-plus\"></i> Add Contacts</a>\r\n          <label>Contacts</label>\r\n          <table datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n            <thead>\r\n            <tr>\r\n              <th>Name</th>\r\n              <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat=\"contact in ctrl.group.contacts track by $index\">\r\n              <td ng-bind-html=\"ctrl.getComposedName(contact)\"></td>\r\n              <td class=\"pull-right\"><a class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.deleteContact($index)\"><i class=\"fa fa-times fa-fw\"></i> </a></td>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <hr/>\r\n\r\n        <div ng-show=\"ctrl.sendFailure\" class=\"alert alert-danger\">\r\n          There has been an error. Your voter group could not be created.\r\n        </div>\r\n\r\n        <button ng-hide=\"ctrl.groupId\" class=\"btn btn-primary\" type=\"submit\">Create Voter Group</button>\r\n\r\n        <button ng-show=\"ctrl.groupId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"voter-group-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VoterGroupShowComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _voterGroupShow = __webpack_require__(796);
	
	var _voterGroupShow2 = _interopRequireDefault(_voterGroupShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var moment = __webpack_require__(44);
	
	var VoterGroupShowComponent = exports.VoterGroupShowComponent = function () {
	  VoterGroupShowComponent.$inject = ['Auth', 'PropertyService', 'WebAccessService', 'dialogs', '$scope', '$uibModal', 'DTOptionsBuilder', 'DTDefaultOptions', 'DTState', 'SettingsService', '$stateParams', 'VoterGroupsService', '$window', '$timeout'];
	  function VoterGroupShowComponent(Auth, PropertyService, WebAccessService, dialogs, $scope, $uibModal, DTOptionsBuilder, DTDefaultOptions, DTState, SettingsService, $stateParams, VoterGroupsService, $window, $timeout) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, VoterGroupShowComponent);
	
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.$scope = $scope;
	    this.$uibModal = $uibModal;
	    this.$timeout = $timeout;
	
	    this.id = $stateParams.id;
	    this.PropertyService = PropertyService;
	    this.WebAccessService = WebAccessService;
	    this.VoterGroupsService = VoterGroupsService;
	    this.filteredData = [];
	    this.data = [];
	
	    this.dialogs = dialogs;
	
	    this.isCollapsed = true;
	
	    this.chartData = {
	      'dist': [],
	      'asn': [[], [], []]
	    };
	    this.chartLabels = {
	      'dist': ["E-Voter", "Blocked", "Paper Voter"],
	      'asn': []
	    };
	    this.chartColors = {
	      'dist': ['#2ECC71', '#C70039', '#00008b'],
	      'asn': ['#2ECC71', '#C70039', '#00008b']
	    };
	
	    this.chartSeries = {
	      'asn': ["E-Voter", "Blocked", "Paper Voter"]
	    };
	
	    this.chartOptions = {
	      'dist': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Voting Preference Distribution'
	        },
	        animation: false
	      },
	      'asn': {
	        title: {
	          display: true,
	          text: 'Voting Preference Distribution per Association'
	        },
	        animation: false,
	        plugins: {
	          stacked100: { enable: true }
	        },
	        scales: {
	          xAxes: [{
	            stacked: true
	          }],
	          yAxes: [{
	            stacked: true
	          }]
	        }
	      }
	    };
	
	    SettingsService.getByName({ name: 'client' }, function (settings) {
	      _this.optInOutRequired = settings.data.optInOut && settings.data.optInOut.required;
	      if (_this.optInOutRequired) {
	        _this.optInOutSettings = settings.data.optInOut;
	      }
	
	      _this.templateAddressLabels = settings.data.templateAddressLabels;
	      _this.templateCoverLetter = settings.data.templateCoverLetter;
	    });
	
	    DTDefaultOptions.setLoadingTemplate('<datatable-loading-placeholder columns="Cmty, Lot#, Address, Primary Owner, Other Owner, Active Tenant" />');
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [[0, 'asc'], [1, 'asc']]).withOption('deferRender', true).withOption('initComplete', function (_) {
	      _this.initComplete = true;
	    }).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('columnDefs', [{ className: "col-sep", "targets": [2] }]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Voters"
	    }, {
	      extend: 'csv',
	      title: "Voters"
	    }, {
	      title: "Voters",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'portrait',
	      pageSize: 'LETTER'
	    }, {
	      extend: 'print',
	      title: "Voters"
	    }]);
	
	    this.refreshData();
	  }
	
	  _createClass(VoterGroupShowComponent, [{
	    key: 'filterData',
	    value: function filterData() {
	      this.filteredData = this.data;
	      this.rawFilteredData = angular.copy(this.filteredData);
	    }
	  }, {
	    key: 'openReportFilterModal',
	    value: function openReportFilterModal(report) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'reportFilterModal',
	        resolve: {
	          config: function config() {
	            return report;
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }, {
	    key: 'printLabels',
	    value: function printLabels() {
	      this.openReportFilterModal({
	        report: 'voter-group-labels-paper-voter',
	        template: this.templateAddressLabels,
	        voterGroupId: this.id,
	        title: 'Address Labels for Paper Voters',
	        icon: 'th'
	      });
	    }
	  }, {
	    key: 'printLetters',
	    value: function printLetters() {
	      this.openReportFilterModal({
	        report: 'voter-group-cover-letter-paper-voter',
	        template: this.templateCoverLetter,
	        voterGroupId: this.id,
	        title: 'Cover Letter for Paper Voters',
	        icon: 'file-text-o'
	      });
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount(option) {
	
	      switch (option) {
	        case 'all':
	          return this.rawFilteredData.length;
	        case 'evoter':
	          return this.rawFilteredData.filter(function (ppty) {
	            return ppty.eVoting && ppty.eVoting.voter && !ppty.eVoting.blocked && ppty.eVoting.voter.customFields && ppty.eVoting.voter.customFields.eVotingConsent;
	          }).length;
	        case 'papervoter':
	          return this.rawFilteredData.filter(function (ppty) {
	            return ppty.eVoting && ppty.eVoting.voter && !ppty.eVoting.blocked && (!ppty.eVoting.voter.customFields || !ppty.eVoting.voter.customFields.eVotingConsent);
	          }).length;
	        case 'blocked':
	          return this.rawFilteredData.filter(function (ppty) {
	            return ppty.eVoting && ppty.eVoting.voter && ppty.eVoting.blocked;
	          }).length;
	        case 'novoter':
	          return this.rawFilteredData.filter(function (ppty) {
	            return !ppty.eVoting || !ppty.eVoting.voter;
	          }).length;
	        case 'nowebaccess':
	          return this.rawFilteredData.filter(function (ppty) {
	            return ppty.eVoting && ppty.eVoting.voter && ppty.eVoting.voter.customFields && ppty.eVoting.voter.customFields.eVotingConsent && !ppty.hasWebAccessVoter;
	          }).length;
	        case 'contactnoweb':
	          return this.rawFilteredData.filter(function (contact) {
	            return !contact.hasWebAccess;
	          }).length;
	      }
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter(option) {
	
	      switch (option) {
	        case 'all':
	          this.filter = null;
	          this.filterData();
	          break;
	        case 'evoter':
	          this.filter = option;
	          this.filterData();
	          this.filteredData = this.filteredData.filter(function (ppty) {
	            return ppty.eVoting && ppty.eVoting.voter && !ppty.eVoting.blocked && ppty.eVoting.voter.customFields && ppty.eVoting.voter.customFields.eVotingConsent;
	          });
	          break;
	        case 'papervoter':
	          this.filter = option;
	          this.filterData();
	          this.filteredData = this.filteredData.filter(function (ppty) {
	            return ppty.eVoting && ppty.eVoting.voter && !ppty.eVoting.blocked && (!ppty.eVoting.voter.customFields || !ppty.eVoting.voter.customFields.eVotingConsent);
	          });
	          break;
	        case 'blocked':
	          this.filter = option;
	          this.filterData();
	          this.filteredData = this.filteredData.filter(function (ppty) {
	            return ppty.eVoting && ppty.eVoting.voter && ppty.eVoting.blocked;
	          });
	          break;
	        case 'novoter':
	          this.filter = option;
	          this.filterData();
	          this.filteredData = this.filteredData.filter(function (ppty) {
	            return !ppty.eVoting || !ppty.eVoting.voter;
	          });
	          break;
	        case 'nowebaccess':
	          this.filter = option;
	          this.filterData();
	          this.filteredData = this.filteredData.filter(function (ppty) {
	            return ppty.eVoting && ppty.eVoting.voter && ppty.eVoting.voter.customFields && ppty.eVoting.voter.customFields.eVotingConsent && !ppty.hasWebAccessVoter;
	          });
	          break;
	        case 'contactnoweb':
	          this.filter = option;
	          this.filterData();
	          this.filteredData = this.filteredData.filter(function (contact) {
	            return !contact.hasWebAccess;
	          });
	      }
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData() {
	      var _this2 = this;
	
	      this.VoterGroupsService.getWithData({ id: this.id }, function (group) {
	        _this2.group = group;
	
	        if (group.type == 'properties') {
	          _this2.data = group.properties;
	        } else {
	          _this2.data = group.contacts;
	        }
	
	        _this2.filterData();
	
	        _this2.WebAccessService.query(function (data) {
	          _this2.webAccesses = data;
	
	          _this2.data.forEach(function (ppty) {
	            ppty.hasWebAccessVoter = ppty.eVoting && ppty.eVoting.voter ? _this2.hasWebAccess(ppty.eVoting.voter) : false;
	          });
	
	          _this2.data.forEach(function (contact) {
	            contact.hasWebAccess = _this2.hasWebAccess(contact);
	          });
	
	          _this2.chartData = {
	            'dist': [],
	            'asn': [[], [], []]
	          };
	          _this2.chartLabels = {
	            'dist': ["E-Voter", "Blocked", "Paper Voter"],
	            'asn': []
	          };
	
	          _this2.chartData.dist.push(_this2.getCount("evoter"));
	          _this2.chartData.dist.push(_this2.getCount("blocked"));
	          _this2.chartData.dist.push(_this2.getCount("papervoter"));
	
	          _this2.dataInitComplete = true;
	
	          var asnDistChart = {};
	
	          _this2.data.forEach(function (ppty) {
	            var key = "Community";
	            if (!asnDistChart[key]) {
	              asnDistChart[key] = {
	                evoter: 0,
	                blocked: 0,
	                papervoter: 0
	              };
	            }
	
	            if (ppty.eVoting && ppty.eVoting.voter && !ppty.eVoting.blocked && ppty.eVoting.voter.customFields && ppty.eVoting.voter.customFields.eVotingConsent) {
	              asnDistChart[key].evoter++;
	            } else if (ppty.eVoting && ppty.eVoting.voter && !ppty.eVoting.blocked && (!ppty.eVoting.voter.customFields || !ppty.eVoting.voter.customFields.eVotingConsent)) {
	              asnDistChart[key].papervoter++;
	            } else if (ppty.eVoting && ppty.eVoting.voter && ppty.eVoting.blocked) {
	              asnDistChart[key].blocked++;
	            }
	          });
	
	          Object.keys(asnDistChart).forEach(function (code) {
	            _this2.chartLabels['asn'].push(code);
	            _this2.chartData['asn'][0].push(asnDistChart[code].evoter);
	            _this2.chartData['asn'][1].push(asnDistChart[code].blocked);
	            _this2.chartData['asn'][2].push(asnDistChart[code].papervoter);
	          });
	        }, function (err) {
	          console.log("Could not retrieve website access.");
	        });
	      }, function (err) {
	        console.log("Could not retrieve properties.");
	      });
	    }
	  }, {
	    key: 'openEFormResultModal',
	    value: function openEFormResultModal(eFormResultId) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'eFormResultModal',
	        resolve: {
	          config: function config() {
	            return {
	              eFormId: that.optInOutSettings.optInForm,
	              eFormResultId: eFormResultId
	            };
	          }
	        }
	      });
	
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }, {
	    key: 'editVoting',
	    value: function editVoting(property) {
	      var that = this;
	
	      var eVoting = {};
	      if (property.eVoting && property.eVoting.voter) {
	        eVoting = angular.copy(property.eVoting);
	        eVoting.voter = eVoting.voter._id;
	      }
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'schemaFormModal',
	        resolve: {
	          config: function config() {
	            return {
	              title: "Voting",
	              icon: "check-square-o",
	              model: eVoting,
	              schema: {
	                type: "object",
	                properties: {
	                  voter: {
	                    "title": "Voter",
	                    "type": "string",
	                    "x-schema-form": {
	                      "type": "entitylookup",
	                      "lookuptype": "contact"
	                    }
	                  },
	                  blocked: {
	                    type: "boolean",
	                    title: "Blocked",
	                    description: "The voter is not allowed to cast a vote for this property currently"
	                  },
	                  votingCertificate: {
	                    type: "string",
	                    title: "Voting Certificate",
	                    "x-schema-form": {
	                      type: "single-file-upload"
	                    }
	                  }
	                },
	                required: []
	              }
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (editedEVoting) {
	        property.eVoting = editedEVoting;
	
	        that.PropertyService.update({ id: property._id }, property, function (_) {
	          that.refreshData();
	        }, function (err) {
	          console.log('could not edit contacts of property');
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'hasWebAccess',
	    value: function hasWebAccess(voter) {
	      return !!this.webAccesses.find(function (wa) {
	        return wa.contact && wa.contact._id && wa.contact._id == voter._id;
	      });
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") {
	          composedName += contact.company;
	        } else {
	          composedName += "<br/>" + contact.company;
	        }
	      }
	
	      return composedName;
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(property) {
	      try {
	        var address = property.address.street;
	
	        if (property.address.city && property.address.state && property.address.zip) {
	          address += ', ' + property.address.city + ', ' + property.address.state + ' ' + property.address.zip;
	        } else if (property.address.city) {
	          address += ', ' + property.address.city;
	        } else if (property.address.state && property.address.zip) {
	          address += ', ' + property.address.state + ' ' + property.address.zip;
	        }
	
	        return address;
	      } catch (e) {
	        return "-";
	      }
	    }
	  }, {
	    key: 'getPrimaryOwnerId',
	    value: function getPrimaryOwnerId(contacts) {
	      var primary = contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary) return 0;else if (!primary.contact || !primary.contact._id) return -1;else return primary.contact._id;
	    }
	  }, {
	    key: 'getOtherOwnerId',
	    value: function getOtherOwnerId(contacts) {
	      var other = contacts.find(function (contact) {
	        return contact.type == 'owner';
	      });
	
	      if (!other) return 0;else if (!other.contact || !other.contact._id) return -1;else return other.contact._id;
	    }
	  }, {
	    key: 'getActiveTenantId',
	    value: function getActiveTenantId(contacts) {
	      var activeTenant = contacts.find(function (contact) {
	        try {
	          if (contact.type == 'renter') {
	
	            if (!contact.from && !contact.till) return true;
	
	            if (contact.from && contact.till) {
	              return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
	            }
	
	            if (!contact.from && contact.till) {
	              return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
	            }
	
	            if (contact.from && !contact.till) {
	              return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
	            }
	          } else {
	            return false;
	          }
	        } catch (e) {
	          console.log(e);
	          return false;
	        }
	      });
	
	      if (!activeTenant) return 0;else if (!activeTenant.contact || !activeTenant.contact._id) return -1;else return activeTenant.contact._id;
	    }
	  }, {
	    key: 'getPrimaryOwner',
	    value: function getPrimaryOwner(contacts) {
	      if (!contacts || !contacts.length) return "-";
	
	      var primary = contacts.find(function (contact) {
	        return contact.type == 'primary-owner';
	      });
	
	      if (!primary) return "-";
	
	      return this.getComposedName(primary.contact);
	    }
	  }, {
	    key: 'getOtherOwner',
	    value: function getOtherOwner(contacts) {
	      if (!contacts || !contacts.length) return "-";
	
	      var other = contacts.find(function (contact) {
	        return contact.type == 'owner';
	      });
	
	      if (!other) return "-";
	
	      return this.getComposedName(other.contact);
	    }
	  }, {
	    key: 'getActiveTenant',
	    value: function getActiveTenant(contacts) {
	      if (!contacts || !contacts.length) return "-";
	
	      var activeTenant = contacts.find(function (contact) {
	        try {
	          if (contact.type == 'renter') {
	
	            if (!contact.from && !contact.till) return true;
	
	            if (contact.from && contact.till) {
	              return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
	            }
	
	            if (!contact.from && contact.till) {
	              return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
	            }
	
	            if (contact.from && !contact.till) {
	              return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
	            }
	          } else {
	            return false;
	          }
	        } catch (e) {
	          console.log(e);
	          return false;
	        }
	      });
	
	      if (!activeTenant) return "-";
	
	      return this.getComposedName(activeTenant.contact);
	    }
	  }]);
	
	  return VoterGroupShowComponent;
	}();
	
	exports.default = angular.module('conduu.voterGroupShow', [uiRouter]).config(_voterGroupShow2.default).component('voterGroupShow', {
	  template: __webpack_require__(797),
	  controller: VoterGroupShowComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('voter-group-show', {
	    url: '/voter-group/:id',
	    template: '<voter-group-show></voter-group-show>',
	    authenticate: true
	  });
	}];

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>{{ctrl.group.name}}</h2>\r\n      <li><a href=\"/voter-group/list\">Voter Groups</a></li>\r\n      <li class=\"active\"><a href=\"#\">{{ctrl.group.name}}</a></li>\r\n      <div class=\"dropdown\" ng-if=\"ctrl.filter == 'papervoter' && (ctrl.templateAddressLabels || ctrl.templateCoverLetter)\" style=\"float:right; margin-top:-16px\">\r\n        <button class=\"btn btn-primary dropdown-toggle\" type=\"button\" id=\"dropdownMenu1\"\r\n                data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\"\r\n                ng-click=\"ctrl.isCollapsed = !ctrl.isCollapsed\">\r\n          <i class=\"fa fa-fw fa-print\"></i> Print\r\n          <span class=\"caret\"></span>\r\n        </button>\r\n        <ul uib-collapse=\"ctrl.isCollapsed\" class=\"dropdown-menu dropdown-menu-right collapse\" aria-labelledby=\"dropdownMenu1\">\r\n          <li ng-if=\"ctrl.templateAddressLabels\"><a href=\"#\" ng-click=\"ctrl.printLabels()\"><i class=\"fa fa-fw fa-th\"></i> Address Labels</a></li>\r\n          <li ng-if=\"ctrl.templateCoverLetter\"><a href=\"#\" ng-click=\"ctrl.printLetters()\"><i class=\"fa fa-fw fa-file-text-o\"></i> Cover Letters</a></li>\r\n        </ul>\r\n      </div>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n\r\n      <!-- PROPERTIES -->\r\n\r\n      <uib-tabset active=\"ctrl.activeTabIndex\" ng-if=\"ctrl.group.type == 'properties' && ctrl.dataInitComplete\">\r\n        <uib-tab select=\"ctrl.setFilter('all')\">\r\n          <uib-tab-heading><b>All</b> <span class=\"badge\">{{ctrl.getCount('all')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter('evoter')\">\r\n          <uib-tab-heading><b>E-Voter</b> <span class=\"badge\">{{ctrl.getCount('evoter')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter('papervoter')\">\r\n          <uib-tab-heading><b>Paper Voter</b> <span class=\"badge\">{{ctrl.getCount('papervoter')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter('blocked')\">\r\n          <uib-tab-heading><b>Blocked</b> <span class=\"badge\">{{ctrl.getCount('blocked')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter('novoter')\">\r\n          <uib-tab-heading><b>No Voter</b> <span class=\"badge\">{{ctrl.getCount('novoter')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter('nowebaccess')\">\r\n          <uib-tab-heading><b>E-Voter w/o Web Access</b> <span class=\"badge\">{{ctrl.getCount('nowebaccess')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter('all')\" class=\"pull-right\">\r\n          <uib-tab-heading><i class=\"fa fa-fw fa-pie-chart\"></i></uib-tab-heading>\r\n          <br/>\r\n          <div class=\"row\">\r\n\r\n            <div class=\"col-xs-4\">\r\n              <canvas id=\"doughnut\" class=\"chart chart-doughnut\"\r\n                      chart-data=\"ctrl.chartData['dist']\" chart-labels=\"ctrl.chartLabels['dist']\" chart-options=\"ctrl.chartOptions['dist']\"\r\n                      chart-colors=\"ctrl.chartColors['dist']\">\r\n              </canvas>\r\n            </div>\r\n\r\n            <div class=\"col-xs-8\">\r\n              <canvas id=\"bar\" class=\"chart chart-horizontal-bar\"\r\n                      chart-data=\"ctrl.chartData['asn']\" chart-labels=\"ctrl.chartLabels['asn']\" chart-options=\"ctrl.chartOptions['asn']\"\r\n                      chart-colors=\"ctrl.chartColors['asn']\" chart-series=\"ctrl.chartSeries['asn']\">\r\n              </canvas>\r\n            </div>\r\n\r\n          </div>\r\n          <hr>\r\n        </uib-tab>\r\n      </uib-tabset>\r\n\r\n      <br/>\r\n\r\n      <datatable-loading-placeholder ng-if=\"ctrl.group.type == 'properties'\" ng-hide=\"ctrl.dataInitComplete\" columns=\"Cmty, Lot#, Address, Voter, E-Voter, Blocked, Web Access\" />\r\n\r\n      <table ng-if=\"ctrl.group.type == 'properties' && ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped\" style=\"width:100%\"> <!-- datatable=\"ng\" -->\r\n        <thead>\r\n        <tr>\r\n          <th>Lot#</th>\r\n          <th>Address</th>\r\n          <th>Primary Owner</th>\r\n          <th title=\"Voting Certificate\">VC</th>\r\n          <th>Voter</th>\r\n          <th>Is E-Voter?</th>\r\n          <th>Is Blocked?</th>\r\n          <th>Has Web Access?</th>\r\n          <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"property in ctrl.filteredData | orderBy: 'meta.creationDate':true\"\r\n            ng-class=\"{'danger': property.eVoting.voter && property.eVoting.voter.customFields.eVotingConsent && !property.hasWebAccessVoter}\">\r\n          <td><a ng-href=\"/property/{{property._id}}\">{{property.lotNo}}</a></td>\r\n          <td>{{ctrl.getAddress(property)}}</td>\r\n          <td>\r\n            <a ng-if=\"ctrl.getPrimaryOwnerId(property.contacts) !== 0 && ctrl.getPrimaryOwnerId(property.contacts) !== -1\" ng-href=\"/contact/{{ctrl.getPrimaryOwnerId(property.contacts)}}\" ng-bind-html=\"ctrl.getPrimaryOwner(property.contacts)\"></a>\r\n            <span ng-if=\"ctrl.getPrimaryOwnerId(property.contacts) === -1\" class=\"text-muted\">Removed Contact</span>\r\n          </td>\r\n          <td>\r\n            <a ng-if=\"property.eVoting.votingCertificate\" target=\"_blank\" ng-href=\"/api/storage/{{property.eVoting.votingCertificate}}\"><i class=\"fa fa-fw fa-download\"> </i></a>\r\n          </td>\r\n          <td>\r\n            <a ng-if=\"property.eVoting.voter\" ng-href=\"/contact/{{property.eVoting.voter._id}}\" ng-bind-html=\"ctrl.getComposedName(property.eVoting.voter)\"></a>\r\n          </td>\r\n          <td>\r\n           <span ng-if=\"property.eVoting.voter && property.eVoting.voter.customFields.eVotingConsent\">Yes\r\n             <!--\r\n             <a ng-if=\"property.eVoting.voter.customFields.eVotingConsentForm\" href=\"#\"\r\n                ng-click=\"ctrl.openEFormResultModal(property.eVoting.voter.customFields.eVotingConsentForm)\">\r\n               <i class=\"fa fa-fw fa-file-text-o\"></i>\r\n             </a>\r\n             -->\r\n           </span>\r\n           <span ng-if=\"property.eVoting.voter && !property.eVoting.voter.customFields.eVotingConsent\">No</span>\r\n          </td>\r\n          <td>\r\n            <span ng-if=\"property.eVoting.voter && property.eVoting.blocked\">Yes</span>\r\n            <span ng-if=\"property.eVoting.voter && !property.eVoting.blocked\">No</span>\r\n          </td>\r\n          <td>\r\n            <span ng-if=\"property.eVoting.voter\">{{property.hasWebAccessVoter ? \"Yes\" : \"No\"}}</span>\r\n          </td>\r\n          <td>\r\n            <button class=\"btn-sm btn-primary\" ng-click=\"ctrl.editVoting(property)\"><i class=\"fa fa-fw fa-pencil\"></i></button>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n      <!-- CONTACTS -->\r\n\r\n      <uib-tabset active=\"ctrl.activeTabIndex\" ng-if=\"ctrl.group.type == 'contacts' && ctrl.dataInitComplete\">\r\n        <uib-tab select=\"ctrl.setFilter('all')\">\r\n          <uib-tab-heading><b>All</b> <span class=\"badge\">{{ctrl.getCount('all')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n        <uib-tab select=\"ctrl.setFilter('contactnoweb')\">\r\n          <uib-tab-heading><b>No Web Access</b> <span class=\"badge\">{{ctrl.getCount('contactnoweb')}}</span></uib-tab-heading>\r\n        </uib-tab>\r\n      </uib-tabset>\r\n\r\n      <br/>\r\n\r\n      <datatable-loading-placeholder ng-if=\"ctrl.group.type == 'contacts'\" ng-hide=\"ctrl.dataInitComplete\" columns=\"Name, Web Access\" />\r\n\r\n      <table ng-if=\"ctrl.group.type == 'contacts' && ctrl.dataInitComplete\" datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\"> <!-- datatable=\"ng\" -->\r\n        <thead>\r\n        <tr>\r\n          <th>Name</th>\r\n          <th>Has Web Access?</th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"contact in ctrl.filteredData | orderBy: 'meta.creationDate':true\" ng-class=\"{'danger': !contact.hasWebAccess}\">\r\n          <td><a ng-href=\"/contact/{{contact._id}}\" ng-bind-html=\"ctrl.getComposedName(contact)\"></a></td>\r\n          <td>\r\n            <span>{{contact.hasWebAccess ? \"Yes\" : \"No\"}}</span>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n\r\n      <br/>\r\n\r\n      <button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	VoterGroupsService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VoterGroupsService = VoterGroupsService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function VoterGroupsService($resource) {
	  return $resource('/api/voter-groups/:id', {
	    name: '@_id'
	  }, {
	    getWithData: {
	      method: 'GET',
	      url: "/api/voter-groups/:id/data"
	    },
	    update: {
	      method: 'PUT'
	    }
	  });
	}
	
	exports.default = angular.module('conduu.VoterGroupsService', []).factory('VoterGroupsService', VoterGroupsService).name;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var CustomEntityLookupComponent = exports.CustomEntityLookupComponent = function () {
	  /*@ngInject*/
	  CustomEntityLookupComponent.$inject = ['CustomEntityService'];
	  function CustomEntityLookupComponent(CustomEntityService) {
	    _classCallCheck(this, CustomEntityLookupComponent);
	
	    this.$onInit = function () {
	      var _this = this;
	
	      this.config = this.resolve.config;
	
	      this.CustomEntityService.query(function (data) {
	        _this.data = data.filter(function (entity) {
	          return entity.schemaSettings == _this.config.entityType;
	        }).map(function (entity) {
	          entity.data._id = entity._id;
	          return entity.data;
	        });
	        _this.dataInitComplete = true;
	      }, function (err) {
	        console.log("Could not retrieve custom entities.");
	      });
	    };
	
	    this.CustomEntityService = CustomEntityService;
	
	    this.data = [];
	  }
	
	  _createClass(CustomEntityLookupComponent, [{
	    key: 'ok',
	    value: function ok(user) {
	      this.close({ $value: user });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return CustomEntityLookupComponent;
	}();
	
	exports.default = angular.module('conduu.customEntityLookup', []).component('customEntityLookup', {
	  template: __webpack_require__(800),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: CustomEntityLookupComponent
	}).name;

/***/ }),
/* 800 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title text-capitalize\" id=\"modal-title\">{{$ctrl.config.entityType}} Lookup</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <table ng-if=\"$ctrl.dataInitComplete\" datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\r\n    <thead>\r\n    <tr>\r\n      <th ng-repeat=\"col in $ctrl.config.columns\">{{col.name}}</th>\r\n      <th>Select</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-repeat=\"entity in $ctrl.data | orderBy: 'meta.creationDate':true\">\r\n      <td ng-repeat=\"col in $ctrl.config.columns\">{{entity[col.data]}}</td>\r\n      <td>\r\n        <a class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.ok(entity)\">\r\n          <i class=\"fa fa-hand-pointer-o fa-fw\"></i> Select\r\n        </a>\r\n      </td>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentsOverviewComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _paymentsOverview = __webpack_require__(802);
	
	var _paymentsOverview2 = _interopRequireDefault(_paymentsOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var PaymentsOverviewComponent = exports.PaymentsOverviewComponent = function () {
	  PaymentsOverviewComponent.$inject = ['StripeService', '$stateParams', '$window', 'ContactService', 'DTOptionsBuilder', '$filter', '$scope', 'ViewSelection', 'DTDefaultOptions', 'DTState', 'WebAccessService', 'CommunityService'];
	  function PaymentsOverviewComponent(StripeService, $stateParams, $window, ContactService, DTOptionsBuilder, $filter, $scope, ViewSelection, DTDefaultOptions, DTState, WebAccessService, CommunityService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, PaymentsOverviewComponent);
	
	    this.$scope = $scope;
	    this.ViewSelection = ViewSelection;
	
	    this.WebAccessService = WebAccessService;
	    this.CommunityService = CommunityService;
	
	    this.contactId = $stateParams.contactId;
	    this.back = function (_) {
	      return $window.history.back();
	    };
	
	    this.mapContact = {};
	
	    this.count = { all: 0, paid: 0, failed: 0 };
	
	    $scope.ViewSelection = ViewSelection;
	    $scope.$watch('ViewSelection.selectedCommunity', function (newVal, oldVal, scope) {
	      _this.selectedCommunity = newVal.name;
	      _this.selectedCommunityCode = newVal.value;
	      _this.filterData(_this.selectedCommunityCode, _this.cat);
	    });
	
	    this.data = [];
	
	    this.WebAccessService.query(function (data) {
	      data.forEach(function (wa) {
	        return _this.mapContact[wa._id] = wa;
	      });
	
	      _this.connectedAccountMap = {};
	      CommunityService.query(function (cmtys) {
	        cmtys.filter(function (cmty) {
	          return cmty.stripe && cmty.stripe.enabled && cmty.stripe.connectedAccountIds.length;
	        }).forEach(function (cmty) {
	          _this.connectedAccountMap[cmty.code] = cmty.stripe.connectedAccountIds;
	        });
	
	        var fnDone = function fnDone() {
	          _this.filterData(ViewSelection.selectedCommunityCode);
	          _this.dataInitComplete = true;
	
	          var asnDistChart = {};
	
	          _this.data.forEach(function (li) {
	            var key = li.code;
	            if (!asnDistChart[key]) {
	              asnDistChart[key] = {
	                paid: 0,
	                failed: 0
	              };
	            }
	
	            if (li.paid) {
	              asnDistChart[key].paid++;
	            } else {
	              asnDistChart[key].failed++;
	            }
	          });
	
	          Object.keys(asnDistChart).forEach(function (code) {
	            _this.chartLabels['asn'].push(code);
	            _this.chartData['asn'][0].push(asnDistChart[code].paid);
	            _this.chartData['asn'][1].push(asnDistChart[code].failed);
	          });
	        };
	
	        var codes = Object.keys(_this.connectedAccountMap);
	        var codesDone = 0;
	        if (codes.length) {
	          codes.forEach(function (cmtyCode) {
	
	            var idsDone = 0;
	            var idsLength = _this.connectedAccountMap[cmtyCode].length;
	
	            _this.connectedAccountMap[cmtyCode].forEach(function (id) {
	              StripeService.getPayments({ id: id }, function (data) {
	                _this.data = _this.data.concat(data.map(function (li) {
	                  li.code = cmtyCode;
	                  return li;
	                }));
	
	                idsDone++;
	
	                if (idsDone == idsLength) codesDone++;
	
	                if (codesDone == codes.length) fnDone();
	              }, function (err) {
	                console.log(err);
	
	                idsDone++;
	
	                if (idsDone == idsLength) codesDone++;
	
	                codesDone++;
	                if (codesDone == codes.length) fnDone();
	              });
	            });
	          });
	        }
	      });
	    }, function (err) {
	      console.log("Could not retrieve website access.");
	    });
	
	    this.chartData = {
	      'dist': [],
	      'asn': [[], []]
	    };
	    this.chartLabels = {
	      'dist': ["Paid", "Failed"],
	      'asn': []
	    };
	    this.chartColors = {
	      'dist': ['#2ECC71', '#C70039'],
	      'asn': ['#2ECC71', '#C70039']
	    };
	
	    this.chartSeries = {
	      'asn': ["Paid", "Failed"]
	    };
	
	    this.chartOptions = {
	      'dist': {
	        legend: {
	          display: true,
	          position: 'bottom'
	        },
	        title: {
	          display: true,
	          text: 'Payment Status'
	        },
	        animation: false
	      },
	      'asn': {
	        title: {
	          display: true,
	          text: 'Payment Status per Association'
	        },
	        animation: false,
	        plugins: {
	          stacked100: { enable: true }
	        },
	        scales: {
	          xAxes: [{
	            stacked: true
	          }],
	          yAxes: [{
	            stacked: true
	          }]
	        }
	      }
	    };
	
	    DTDefaultOptions.setLoadingTemplate("<datatable-loading-placeholder columns='Contact, Account, Community, Import Date, Balance />");
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('dom', 'lBfrtip').withOption('order', [[0, 'asc'], [1, 'asc']]).withOption('stateSave', true).withOption('stateSaveCallback', DTState.save()).withOption('stateLoadCallback', DTState.restore()).withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]).withOption('buttons', [{
	      extend: 'excel',
	      title: "Payments"
	    }, {
	      extend: 'csv',
	      title: "Payments"
	    }, {
	      title: "Payments",
	      message: 'As of ' + moment().format("MMMM Do YYYY"),
	      extend: 'pdf',
	      orientation: 'portrait',
	      pageSize: 'LETTER'
	    }, {
	      extend: 'print',
	      title: "Payments"
	    }]).withOption('fnFooterCallback', function (row, data, start, end, display) {
	      var api = this.api(),
	          data;
	
	      var intVal = function intVal(i) {
	        return typeof i === 'string' ? i.replace(/[\$,]/g, '') * 1 : typeof i === 'number' ? i : 0;
	      };
	
	      var roundCorrectly = function roundCorrectly(number) {
	        return Math.round(number * 100) / 100;
	      };
	
	      var total = api.column(1).data().reduce(function (a, b) {
	        return intVal(a) + intVal(b);
	      }, 0);
	
	      var pageTotal = api.column(1, { page: 'current' }).data().reduce(function (a, b) {}, 0);
	
	      var visibleTotal = api.column(1, { search: 'applied' }).data().reduce(function (a, b) {
	        return intVal(a) + intVal(b);
	      }, 0);
	
	      $(api.column(1).footer()).html('<nobr>$ ' + $filter('number')(roundCorrectly(visibleTotal), 2) + '</nobr>');
	    });
	  }
	
	  _createClass(PaymentsOverviewComponent, [{
	    key: 'getPrimaryOwner',
	    value: function getPrimaryOwner(property) {
	      var primary = property.contacts.find(function (c) {
	        return c.type == 'primary-owner';
	      });
	      if (primary) return primary.contact;else return null;
	    }
	  }, {
	    key: 'getPrimaryOwnerId',
	    value: function getPrimaryOwnerId(property) {
	      var primary = this.getPrimaryOwner(property);
	      if (primary) return primary._id;
	    }
	  }, {
	    key: 'roundCorrectly',
	    value: function roundCorrectly(number) {
	      return Math.round(number * 100) / 100;
	    }
	  }, {
	    key: 'filterData',
	    value: function filterData(code, cat) {
	
	      if (code) {
	        this.filteredData = this.data.filter(function (li) {
	          return li.code == code;
	        });
	      } else {
	        this.filteredData = this.data;
	      }
	
	      this.count.all = this.getCount('all');
	      this.count.paid = this.getCount('paid');
	      this.count.failed = this.getCount('failed');
	
	      this.chartData['dist'] = [this.count.paid, this.count.failed];
	
	      if (cat && cat !== 'all') {
	        switch (cat) {
	          case 'paid':
	            this.filteredData = this.filteredData.filter(function (li) {
	              return li.paid;
	            });
	            break;
	          case 'failed':
	            this.filteredData = this.filteredData.filter(function (li) {
	              return !li.paid;
	            });
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount(cat) {
	      if (!this.filteredData || !this.filteredData.length) return 0;
	
	      return this.filteredData.filter(function (li) {
	        switch (cat) {
	          case 'paid':
	            return li.paid;
	          case 'failed':
	            return !li.paid;
	          default:
	            return true;
	        }
	      }).length;
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter(cat) {
	      this.cat = cat;
	      this.filterData(this.selectedCommunityCode, this.cat);
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += " (" + contact.company + ")";
	      }
	
	      return composedName || "-";
	    }
	  }]);
	
	  return PaymentsOverviewComponent;
	}();
	
	exports.default = angular.module('conduu.paymentsOverview', [uiRouter]).config(_paymentsOverview2.default).component('paymentsOverview', {
	  template: __webpack_require__(803),
	  controller: PaymentsOverviewComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 802 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('payments-overview', {
	    url: '/payments',
	    template: '<payments-overview></payments-overview>',
	    authenticate: 'suite-admin'
	  });
	}];

/***/ }),
/* 803 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <ol class=\"breadcrumb\">\r\n            <h2>Payments Overview <small>{{ctrl.selectedCommunity}}</small></h2>\r\n            <span class=\"pull-right\"><i class=\"fa fa-fw fa-external-link\"></i> <a href=\"https://dashboard.stripe.com/\" target=\"_blank\">Open Stripe Payment Dashboard</a></span>\r\n            <li class=\"active\"><a href=\"#\">Payments Overview</a></li>\r\n        </ol>\r\n\r\n        <div class=\"col-xs-12\">\r\n\r\n            <!--<label><input type=\"checkbox\" ng-model=\"ctrl.openonly\" ng-click=\"ctrl.applyFilter()\" /> Only Open</label>-->\r\n\r\n            <uib-tabset active=\"ctrl.activeTabIndex\">\r\n                <uib-tab select=\"ctrl.setFilter('all')\">\r\n                    <uib-tab-heading><b>All</b> <span class=\"badge\">{{ctrl.count['all']}}</span></uib-tab-heading>\r\n                </uib-tab>\r\n                <uib-tab select=\"ctrl.setFilter('paid')\">\r\n                    <uib-tab-heading><b>Paid</b> <span class=\"badge\">{{ctrl.count['paid']}}</span></uib-tab-heading>\r\n                </uib-tab>\r\n                <uib-tab select=\"ctrl.setFilter('failed')\">\r\n                    <uib-tab-heading><b>Failed</b> <span class=\"badge\">{{ctrl.count['failed']}}</span></uib-tab-heading>\r\n                </uib-tab>\r\n\r\n                <uib-tab select=\"ctrl.setFilter('all')\" class=\"pull-right\">\r\n                    <uib-tab-heading><i class=\"fa fa-fw fa-pie-chart\"></i></uib-tab-heading>\r\n                    <br/>\r\n                    <div class=\"row\">\r\n\r\n                        <div class=\"col-xs-4\">\r\n                            <canvas id=\"doughnut\" class=\"chart chart-doughnut\"\r\n                                    chart-data=\"ctrl.chartData['dist']\" chart-labels=\"ctrl.chartLabels['dist']\" chart-options=\"ctrl.chartOptions['dist']\"\r\n                                    chart-colors=\"ctrl.chartColors['dist']\">\r\n                            </canvas>\r\n                        </div>\r\n\r\n                        <div class=\"col-xs-8\">\r\n                            <canvas id=\"bar\" class=\"chart chart-horizontal-bar\"\r\n                                    chart-data=\"ctrl.chartData['asn']\" chart-labels=\"ctrl.chartLabels['asn']\" chart-options=\"ctrl.chartOptions['asn']\"\r\n                                    chart-colors=\"ctrl.chartColors['asn']\" chart-series=\"ctrl.chartSeries['asn']\">\r\n                            </canvas>\r\n                        </div>\r\n\r\n                    </div>\r\n                    <hr>\r\n                </uib-tab>\r\n            </uib-tabset>\r\n\r\n            <br/>\r\n\r\n            <h5 ng-if=\"!ctrl.dataInitComplete\"><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> Retrieving Payments Data</h5>\r\n\r\n            <h5 ng-if=\"ctrl.dataInitComplete && !ctrl.filteredData.length\">No Payments Data Available</h5>\r\n\r\n            <div ng-if=\"ctrl.filteredData.length\" ng-hide=\"ctrl.activeTabIndex == 3\">\r\n\r\n                <table ng-if=\"ctrl.filteredData.length && ctrl.dataInitComplete\" datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table\">\r\n                    <thead>\r\n                    <tr>\r\n                        <th>Contact</th>\r\n                        <th>Amount</th>\r\n                        <th>Date</th>\r\n                        <th>Description</th>\r\n                        <th>Payment Method</th>\r\n                        <th>Status</th>\r\n                    </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                    <tr ng-repeat=\"payment in ctrl.filteredData\" ng-class=\"{'text-danger': !payment.paid}\">\r\n                        <td>\r\n                            <span ng-if=\"payment.metadata.webaccessId\">{{ctrl.mapContact[payment.metadata.webaccessId].contact.lastName}}, {{ctrl.mapContact[payment.metadata.webaccessId].contact.firstName}}</span>\r\n                        </td>\r\n                        <td>$ {{(payment.metadata.netAmount || payment.amount) / 100 | number:'2'}}</td>\r\n                        <td>{{payment.metadata.creationDate | date:'short'}}</td>\r\n                        <td>{{payment.description}}</td>\r\n                        <td>\r\n                            <span ng-if=\"payment.payment_method_details.type == 'card'\" class=\"text-uppercase\"><i class=\"fa fa-fw fa-credit-card\"></i> ***{{payment.payment_method_details.card.last4}} <nobr>({{payment.payment_method_details.card.network}})</nobr></span>\r\n                            <span ng-if=\"payment.payment_method_details.type == 'ach_debit'\"><i class=\"fa fa-fw fa-university\"></i> ***{{payment.payment_method_details.ach_debit.last4}} <nobr>({{payment.payment_method_details.ach_debit.bank_name}})</nobr></span>\r\n                        </td>\r\n                        <td>\r\n                            <span ng-if=\"payment.paid\"><i class=\"fa fa-fw fa-check\"></i> Paid</span>\r\n                            <span ng-if=\"!payment.paid && ctrl.activeTabIndex <= 1\"><i class=\"fa fa-fw fa-times\"></i> Failed</span>\r\n                            <span ng-if=\"!payment.paid && ctrl.activeTabIndex > 1\"><i class=\"fa fa-fw fa-times\"></i> {{payment.failure_message}}</span>\r\n                        </td>\r\n                    </tr>\r\n                    </tbody>\r\n                    <tfoot>\r\n                    <tr ng-show=\"ctrl.activeTabIndex > 0\">\r\n                        <th colspan=\"1\" style=\"text-align: right\"> TOTAL&nbsp;&nbsp;</th>\r\n                        <th></th>\r\n                    </tr>\r\n                    </tfoot>\r\n                </table>\r\n            </div>\r\n\r\n            <!--<button class=\"btn btn-warning\" ng-click=\"ctrl.back()\"><i class=\"fa fa-fw fa-arrow-left\"></i> Back</button>--->\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var photoCardComponent =
	/*@ngInject*/
	exports.photoCardComponent = function photoCardComponent() {
	  _classCallCheck(this, photoCardComponent);
	};
	
	exports.default = angular.module('conduuApp.photoCard', []).component('photoCard', {
	  template: __webpack_require__(805),
	  bindings: {
	    photo: '@'
	  },
	  controller: photoCardComponent
	}).name;

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	module.exports = "<!-- PostIt: Work Order for Community -->\r\n<div class=\"card card-container photo\" style=\"float:right;position:relative;top:-32px; padding:5px\">\r\n    <img class=\"paper-clip\" src=\"assets/images/paperclip.png\" />\r\n    <a href=\"{{$ctrl.photo}}\" target=\"_blank\">\r\n        <img src=\"{{$ctrl.photo}}\" style=\"width:100%\" />\r\n    </a>\r\n</div>\r\n"

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomEntityEditComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _customEntityEdit = __webpack_require__(807);
	
	var _customEntityEdit2 = _interopRequireDefault(_customEntityEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var CustomEntityEditComponent = exports.CustomEntityEditComponent = function () {
	  CustomEntityEditComponent.$inject = ['SettingsService', 'Auth', '$state', 'dialogs'];
	  function CustomEntityEditComponent(SettingsService, Auth, $state, dialogs) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, CustomEntityEditComponent);
	
	    this.SettingsService = SettingsService;
	    this.dialogs = dialogs;
	    this.$state = $state;
	    this.active = 0;
	
	    this.sortableOptions = {
	      handle: '.handle'
	    };
	
	    this.SettingsService.getByName({ name: 'custom-entities' }, function (customEntitiesSettings) {
	      _this.settings = customEntitiesSettings;
	      _this.model = customEntitiesSettings.data;
	    });
	  }
	
	  _createClass(CustomEntityEditComponent, [{
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess() {
	          var dlg = _this2.dialogs.notify("Success", "The custom entity settings have been changed successfully");
	          dlg.result.then(function () {
	            that.$state.go("home");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.SettingsService.update({ id: this.settings._id }, this.settings, onSuccess, onError);
	      }
	    }
	  }]);
	
	  return CustomEntityEditComponent;
	}();
	
	exports.default = angular.module('conduu.customEntityEdit', [uiRouter]).config(_customEntityEdit2.default).component('customEntityEdit', {
	  template: __webpack_require__(808),
	  controller: CustomEntityEditComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('custom-entity-edit', {
	    url: '/admin/custom-entity/edit',
	    template: '<custom-entity-edit></custom-entity-edit>',
	    authenticate: 'suite-admin'
	  });
	}];

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Custom Entities Editor</h2>\r\n      <li class=\"active\"><a href=\"#\">Custom Entities Editor</a></li>\r\n    </ol>\r\n\r\n\r\n      <div class=\"col-xs-8\">\r\n        <h1>{{ctrl.entity}} Editor</h1>\r\n      </div>\r\n      <div class=\"col-xs-4\" style=\"text-align: right; font-size:large\">\r\n        <form class=\"form-inline\" style=\"padding-top:18px\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label\" for=\"type\">Entity:&nbsp;</label>\r\n            <select type=\"text\" id=\"type\" name=\"entity\" class=\"form-control\" ng-model=\"ctrl.entity\"\r\n                    ng-options=\"o as o for o in ctrl.model.entities\"\r\n                    ng-change=\"ctrl.reload()\"></select>\r\n          </div>\r\n        </form>\r\n      </div>\r\n\r\n\r\n    <div class=\"col-xs-12\" ng-if=\"ctrl.entity\">\r\n\r\n      <form name=\"form\" ng-submit=\"ctrl.create(form)\">\r\n\r\n        <uib-tabset active=\"ctrl.active\">\r\n\r\n          <uib-tab index=\"0\" heading=\"Entity Data\" style=\"padding-top: 8px;\">\r\n            <uib-accordion close-others=\"oneAtATime\" ui-sortable=\"ctrl.sortableOptions\" ng-model=\"ctrl.model.enitySchema[ctrl.entity]\">\r\n              <div uib-accordion-group ng-repeat=\"field in ctrl.fields track by $index\" class=\"panel-default\">\r\n                <uib-accordion-heading>\r\n                  <span style=\"cursor: move\" class=\"handle\"><i class=\"fa fa-fw fa-arrows\" style=\"margin-right:8px\"></i></span>\r\n                  <span ng-class=\"{'text-muted': !field.title}\">{{field.title || 'No TITLE'}}</span>\r\n\r\n                  <a style=\"color: darkred\" ng-click=\"ctrl.deleteField($event, field, $index)\"><i class=\"fa fa-fw fa-trash\" style=\"float: right\"></i></a>\r\n                  <span style=\"float:right;padding-right: 24px;\" class=\"text-muted text-uppercase\">{{field.type}}</span>\r\n                  <span ng-if=\"field.required\" style=\"float:right\" class=\"text-muted\">*&nbsp;</span>\r\n                </uib-accordion-heading>\r\n\r\n                <div class=\"form-group\" ng-hide=\"field.type == 'help'\">\r\n                  <label>Title</label>\r\n                  <input type=\"text\" name=\"subject\" class=\"form-control\" ng-model=\"field.title\" />\r\n                </div>\r\n\r\n                <div class=\"form-group\" ng-hide=\"field.type == 'help'\">\r\n                  <label><input type=\"checkbox\" ng-model=\"field.required\" />&nbsp;&nbsp;Required</label>\r\n                  <label ng-show=\"field.type == 'text' || field.type == 'textbox'\"><input type=\"checkbox\" ng-model=\"field.prefill\" />&nbsp;&nbsp;Uses Prefilled Value</label>\r\n                </div>\r\n\r\n                <div class=\"form-group col-xs-6\" style=\"padding:0\">\r\n                  <label>Type</label>\r\n                  <select type=\"text\" name=\"fieldType\" class=\"form-control\" ng-model=\"field.type\"\r\n                          ng-options=\"o as o for o in ctrl.fieldTypes\"></select>\r\n                </div>\r\n\r\n                <div class=\"form-group col-xs-6\" style=\"padding-right:0\">\r\n                  <label>Key</label>\r\n                  <input type=\"text\" name=\"subject\" class=\"form-control\" ng-model=\"field.key\" />\r\n                </div>\r\n\r\n                <div class=\"form-group\" ng-show=\"(field.type == 'text' || field.type == 'textbox') && field.prefill == true\">\r\n                  <label>Prefilled</label>\r\n                  <select name=\"prefilled\" class=\"form-control\" ng-model=\"field.prefilled\"\r\n                          ng-options=\"o.type as o.name group by o.group for o in ctrl.prefillTypes\"></select>\r\n                </div>\r\n\r\n                <div class=\"form-group\" ng-hide=\"field.type == 'help'\">\r\n                  <label>Description</label>\r\n                  <input type=\"text\" name=\"description\" class=\"form-control\" ng-model=\"field.description\" />\r\n                </div>\r\n\r\n                <div ng-if=\"field.type == 'help'\" style=\"clear:both\"></div>\r\n                <text-angular ng-show=\"field.type == 'help'\" ng-model=\"field.helpvalue\" ta-toolbar=\"ctrl.toolbarDefinition\"></text-angular>\r\n\r\n                <div ng-if=\"field.type == 'select'\" class=\"form-group\" ng-if=\"question.type != 'text'\">\r\n                  <table ng-show=\"field.enum && field.enum.length > 0\" style=\"width:100%;\" class=\"table table-striped\">\r\n                    <thead>\r\n                    <tr>\r\n                      <th style=\"width:32px\"></th>\r\n                      <th>Option / Choice</th>\r\n                      <th></th>\r\n                    </tr>\r\n                    </thead>\r\n                    <tbody ui-sortable ng-model=\"field.enum\">\r\n                    <tr ng-repeat=\"choice in field.enum track by $index\" style=\"cursor: move;\">\r\n                      <td><i class=\"fa fa-fw fa-arrows\"></i></td>\r\n                      <td>\r\n                        <input type=\"text\" class=\"form-control\" ng-model=\"field.enum[$index]\" />\r\n                      </td>\r\n                      <td style=\"text-align: right; width:30px\">\r\n                        <a class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.removeChoice(field, $index)\"><i class=\"fa fa-fw fa-trash\"></i></a>\r\n                      </td>\r\n                    </tr>\r\n                    </tbody>\r\n                  </table>\r\n\r\n                  <a class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.addChoice(field)\"><i class=\"fa fa-fw fa-plus\"></i> Add Option / Choice</a>\r\n\r\n                </div>\r\n              </div>\r\n            </uib-accordion>\r\n\r\n            <a class=\"btn btn-primary\" ng-click=\"ctrl.addField()\"><i class=\"fa fa-fw fa-plus\"></i> Add Field</a>\r\n\r\n          </uib-tab>\r\n\r\n          <uib-tab index=\"1\" heading=\"Detail View\" style=\"padding-top: 8px;\">\r\n          </uib-tab>\r\n\r\n          <uib-tab index=\"2\" heading=\"List View\" style=\"padding-top: 8px;\">\r\n          </uib-tab>\r\n\r\n        </uib-tabset>\r\n\r\n        <br/>\r\n\r\n        <button class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\r\n        <button class=\"btn btn-warning\" ui-sref=\"home\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\r\n      </form>\r\n\r\n    </div>\r\n\r\n\r\n    <div class=\"col-xs-12\">\r\n      <pre>{{ctrl.model | json}}</pre>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(535);
	
	__webpack_require__(537);
	
	__webpack_require__(541);
	
	__webpack_require__(810);
	
	__webpack_require__(812);
	
	__webpack_require__(813);
	
	__webpack_require__(815);
	
	__webpack_require__(817);
	
	__webpack_require__(549);
	
	__webpack_require__(550);
	
	__webpack_require__(543);
	
	var _eFormList = __webpack_require__(819);
	
	var _eFormList2 = _interopRequireDefault(_eFormList);
	
	var _eFormEditor = __webpack_require__(822);
	
	var _eFormEditor2 = _interopRequireDefault(_eFormEditor);
	
	var _eForm = __webpack_require__(825);
	
	var _eForm2 = _interopRequireDefault(_eForm);
	
	var _eFormBrowser = __webpack_require__(828);
	
	var _eFormBrowser2 = _interopRequireDefault(_eFormBrowser);
	
	var _eforms = __webpack_require__(831);
	
	var _eforms2 = _interopRequireDefault(_eforms);
	
	var _eformResults = __webpack_require__(832);
	
	var _eformResults2 = _interopRequireDefault(_eformResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('conduu.eForms', ['schemaForm', 'ngSchemaFormFile', _eFormList2.default, _eForm2.default, _eFormBrowser2.default, _eFormEditor2.default, _eformResults2.default, _eforms2.default]).name;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('schemaForm').config(['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider', function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
	   var defaultPatternMsg = 'Wrong file type. Allowed types are ',
	       defaultMaxSizeMsg1 = 'This file is too large. Maximum size allowed is ',
	       defaultMaxSizeMsg2 = 'Current file size:',
	       defaultMinItemsMsg = 'You have to upload at least one file',
	       defaultMaxItemsMsg = 'You can\'t upload more than one file.';
	
	   var nwpSinglefileUpload = function nwpSinglefileUpload(name, schema, options) {
	      if (schema.type === 'array' && schema.format === 'singlefile') {
	         if (schema.pattern && schema.pattern.mimeType && !schema.pattern.validationMessage) {
	            schema.pattern.validationMessage = defaultPatternMsg;
	         }
	         if (schema.maxSize && schema.maxSize.maximum && !schema.maxSize.validationMessage) {
	            schema.maxSize.validationMessage = defaultMaxSizeMsg1;
	            schema.maxSize.validationMessage2 = defaultMaxSizeMsg2;
	         }
	         if (schema.minItems && schema.minItems.minimum && !schema.minItems.validationMessage) {
	            schema.minItems.validationMessage = defaultMinItemsMsg;
	         }
	         if (schema.maxItems && schema.maxItems.maximum && !schema.maxItems.validationMessage) {
	            schema.maxItems.validationMessage = defaultMaxItemsMsg;
	         }
	
	         var f = schemaFormProvider.stdFormObj(name, schema, options);
	         f.key = options.path;
	         f.type = 'nwpFileUpload';
	         options.lookup[sfPathProvider.stringify(options.path)] = f;
	         return f;
	      }
	   };
	
	   schemaFormProvider.defaults.array.unshift(nwpSinglefileUpload);
	
	   var nwpMultifileUpload = function nwpMultifileUpload(name, schema, options) {
	      if (schema.type === 'array' && schema.format === 'multifile') {
	         if (schema.pattern && schema.pattern.mimeType && !schema.pattern.validationMessage) {
	            schema.pattern.validationMessage = defaultPatternMsg;
	         }
	         if (schema.maxSize && schema.maxSize.maximum && !schema.maxSize.validationMessage) {
	            schema.maxSize.validationMessage = defaultMaxSizeMsg1;
	            schema.maxSize.validationMessage2 = defaultMaxSizeMsg2;
	         }
	         if (schema.minItems && schema.minItems.minimum && !schema.minItems.validationMessage) {
	            schema.minItems.validationMessage = defaultMinItemsMsg;
	         }
	         if (schema.maxItems && schema.maxItems.maximum && !schema.maxItems.validationMessage) {
	            schema.maxItems.validationMessage = defaultMaxItemsMsg;
	         }
	
	         var f = schemaFormProvider.stdFormObj(name, schema, options);
	         f.key = options.path;
	         f.type = 'nwpFileUpload';
	         options.lookup[sfPathProvider.stringify(options.path)] = f;
	         return f;
	      }
	   };
	
	   schemaFormProvider.defaults.array.unshift(nwpMultifileUpload);
	
	   schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'nwpFileUpload', 'directives/decorators/bootstrap/angular-schema-form-file-upload/schema-form-file.html');
	}]);
	
	angular.module('ngSchemaFormFile', ['ngFileUpload']).directive('ngSchemaFile', ['Upload', '$timeout', '$q', function (Upload, $timeout, $q) {
	   return {
	      restrict: 'A',
	      scope: true,
	      require: 'ngModel',
	      link: function link(scope, element, attrs, ngModel) {
	         scope.url = scope.form && scope.form.endpoint;
	         scope.isSinglefileUpload = scope.form && scope.form.schema && scope.form.schema.format === 'singlefile';
	
	         scope.selectFile = function (file) {
	            scope.picFile = file;
	            scope.uploadFile(file);
	         };
	         scope.selectFiles = function (files) {
	            scope.picFiles = files;
	            scope.uploadFile(files);
	         };
	
	         scope.uploadFile = function (file) {
	            file && doUpload(file);
	         };
	
	         scope.uploadFiles = function (files) {
	            files.length && angular.forEach(files, function (file) {
	               doUpload(file);
	            });
	         };
	
	         function doUpload(file) {
	            if (file && !file.$error && scope.url) {
	               var options = {
	                  url: scope.url,
	                  data: {
	                     file: file,
	                     name: scope.form.fileName || file.name,
	                     storageStrategy: 'local',
	                     isPublic: true,
	                     active: true
	                  }
	               };
	
	               file.upload = Upload.upload(options);
	
	               file.upload.then(function (response) {
	                  $timeout(function () {
	                     file.result = response.data;
	                  });
	                  var result = scope.form.post ? scope.form.post(response.data) : response.data;
	                  ngModel.$setViewValue(result);
	                  ngModel.$commitViewValue();
	               }, function (response) {
	                  if (response.status > 0) {
	                     scope.errorMsg = response.status + ': ' + response.data;
	                  }
	               });
	
	               file.upload.progress(function (evt) {
	                  file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	               });
	            }
	         }
	
	         scope.validateField = function () {
	            if (scope.uploadForm.file && scope.uploadForm.file.$valid && scope.picFile && !scope.picFile.$error) {
	               console.log('singlefile-form is invalid');
	            } else if (scope.uploadForm.files && scope.uploadForm.files.$valid && scope.picFiles && !scope.picFiles.$error) {
	               console.log('multifile-form is  invalid');
	            } else {
	               console.log('single- and multifile-form are valid');
	            }
	         };
	         scope.submit = function () {
	            if (scope.uploadForm.file && scope.uploadForm.file.$valid && scope.picFile && !scope.picFile.$error) {
	               scope.uploadFile(scope.picFile);
	            } else if (scope.uploadForm.files && scope.uploadForm.files.$valid && scope.picFiles && !scope.picFiles.$error) {
	               scope.uploadFiles(scope.picFiles);
	            }
	         };
	         scope.$on('schemaFormValidate', scope.validateField);
	         scope.$on('schemaFormFileUploadSubmit', scope.submit);
	      }
	   };
	}]);
	
	angular.module("schemaForm").run(["$templateCache", function ($templateCache) {
	   $templateCache.put("directives/decorators/bootstrap/angular-schema-form-file-upload/schema-form-file.html", __webpack_require__(811));
	}]);

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	module.exports = "<!-- Main -->\n<ng-form class=\"file-upload mb-lg\" ng-schema-file ng-model=\"$$value$$\" name=\"uploadForm\">\n    <label ng-show=\"form.title && form.notitle !== true\" class=\"control-label\" for=\"fileInputButton\"\n           ng-class=\"{'sr-only': !showTitle(), 'text-danger': uploadForm.$error.required && !uploadForm.$pristine}\">\n        {{ form.title }}<i ng-show=\"form.required\">&nbsp;*</i>\n    </label>\n    <div ng-show=\"picFile\">\n        <div ng-include=\"'uploadProcess.html'\" class=\"mb\"></div>\n    </div>\n    <ul ng-show=\"picFiles && picFiles.length\" class=\"list-group\">\n        <li class=\"list-group-item\" ng-repeat=\"picFile in picFiles\">\n            <div ng-include=\"'uploadProcess.html'\"></div>\n        </li>\n    </ul>\n    <div ng-hide=\"picFile\" class=\"well well-sm bg-white mb\"\n         ng-class=\"{'has-error border-danger': (uploadForm.$error.required && !uploadForm.$pristine) || (hasError() && errorMessage(schemaError()))}\">\n        <small class=\"text-muted\" ng-show=\"form.description\" ng-bind-html=\"form.description\"></small>\n        <div ng-if=\"isSinglefileUpload\" ng-include=\"'singleFileUpload.html'\"></div>\n        <div ng-if=\"!isSinglefileUpload\" ng-include=\"'multiFileUpload.html'\"></div>\n        <div class=\"help-block mb0\" ng-show=\"uploadForm.$error.required && !uploadForm.$pristine\">Required</div>\n        <div class=\"help-block mb0\" ng-show=\"(hasError() && errorMessage(schemaError()))\"\n             ng-bind-html=\"(hasError() && errorMessage(schemaError()))\"></div>\n    </div>\n</ng-form>\n\n<!-- Upload Progress -->\n<script type='text/ng-template' id=\"uploadProcess.html\">\n    <div class=\"row mb\">\n        <!--\n        <div class=\"col-sm-4 mb-sm\">\n            <label title=\"Preview\" class=\"text-info\">Preview</label>\n            <img ngf-src=\"picFile\" class=\"img-thumbnail img-responsive\">\n            <div class=\"img-placeholder\" ng-show=\"picFile.$invalid && !picFile.blobUrl\" ng-hide=\"!picFile || picFile.blobUrl\">\n                No preview available\n            </div>\n        </div>\n        -->\n        <div class=\"col-sm-6 mb-sm\">\n            <label title=\"Filename\" class=\"text-info\">Filename</label>\n            <div class=\"filename\" title=\"{{ picFile.name }}\">{{ picFile.name }}</div>\n        </div>\n        <div class=\"col-sm-6 mb-sm\">\n            <label title=\"Progress\" class=\"text-info\">Progress</label>\n            <div class=\"progress\">\n                <div class=\"progress-bar progress-bar-striped\" role=\"progressbar\"\n                     ng-class=\"{'progress-bar-success': picFile.progress == 100}\"\n                     ng-style=\"{width: picFile.progress + '%'}\">\n                    {{ picFile.progress }} %\n                </div>\n            </div>\n            <!--\n            <button class=\"btn btn-primary btn-sm\" type=\"button\" ng-click=\"uploadFile(picFile)\"\n                    ng-disabled=\"picFile\">Upload\n            </button>\n            -->\n        </div>\n    </div>\n    <div ng-if=\"uploadForm.$error\">\n        <div class=\"text-danger errorMsg\" ng-if=\"maxSize\">File size limit reached:\n            <strong>{{picFile.$errorParam}}</strong>. (Current file size:\n            <strong>{{picFile.size / 1000000|number:1}}MB</strong>)\n        </div>\n        <div class=\"text-danger errorMsg\" ng-if=\"pattern\">Worng file type:\n            <strong>{{picFile.$errorParam}}</strong></div>\n        <div class=\"text-danger errorMsg\" ng-if=\"maxItems\">You have uploaded more files than allowed\n            <strong>{{picFile.$errorParam}}</strong></div>\n        <div class=\"text-danger errorMsg\" ng-if=\"minItems\">You must upload at least one file\n            <strong>{{picFile.$errorParam}}</strong></div>\n        <div class=\"text-danger errorMsg\" ng-show=\"errorMsg\">{{errorMsg}}</div>\n    </div>\n</script>\n\n<!-- Single File Upload -->\n<script type='text/ng-template' id=\"singleFileUpload.html\">\n    <div ngf-drop=\"selectFile(picFile)\" ngf-select=\"selectFile(picFile)\" type=\"file\" ngf-multiple=\"false\"\n         ng-model=\"picFile\" name=\"file\"\n         ng-attr-ngf-pattern=\"{{form.schema.pattern && form.schema.pattern.mimeType ? form.schema.pattern.mimeType : undefined }}\"\n         ng-attr-ngf-max-size=\"{{form.schema.maxSize && form.schema.maxSize.maximum ? form.schema.maxSize.maximum : undefined }}\"\n         ng-required=\"form.required\" accept=\"{{form.schema.pattern && form.schema.pattern.mimeType}}\"\n         ng-model-options=\"form.ngModelOptions\" ngf-drag-over-class=\"dragover\" class=\"drop-box dragAndDropDescription\">\n        <p class=\"text-center\">Drop your file here</p>\n    </div>\n    <div ngf-no-file-drop>Drag n drop not surpported by your browser</div>\n    <button ngf-select=\"selectFile(picFile)\" type=\"file\" ngf-multiple=\"false\" ng-model=\"picFile\" name=\"file\"\n            ng-attr-ngf-pattern=\"{{form.schema.pattern && form.schema.pattern.mimeType ? form.schema.pattern.mimeType : undefined }}\"\n            ng-attr-ngf-max-size=\"{{form.schema.maxSize && form.schema.maxSize.maximum ? form.schema.maxSize.maximum : undefined }}\"\n            ng-required=\"form.required\" accept=\"{{form.schema.pattern && form.schema.pattern.mimeType}}\"\n            ng-model-options=\"form.ngModelOptions\" id=\"fileInputButton\"\n            class=\"btn btn-primary btn-block {{form.htmlClass}} mt-lg mb\">\n        <fa fw=\"fw\" name=\"upload\" class=\"mr-sm\"></fa>\n        Open file browser\n    </button>\n</script>\n\n<!-- Multi File Upload -->\n<script type='text/ng-template' id=\"multiFileUpload.html\">\n    <div ngf-drop=\"selectFiles(picFiles)\" ngf-select=\"selectFiles(picFiles)\" type=\"file\" ngf-multiple=\"true\"\n         ng-model=\"picFiles\" name=\"files\"\n         ng-attr-ngf-pattern=\"{{form.schema.pattern && form.schema.pattern.mimeType ? form.schema.pattern.mimeType : undefined }}\"\n         ng-attr-ngf-max-size=\"{{form.schema.maxSize && form.schema.maxSize.maximum ? form.schema.maxSize.maximum : undefined }}\"\n         ng-required=\"form.required\" accept=\"{{form.schema.pattern && form.schema.pattern.mimeType}}\"\n         ng-model-options=\"form.ngModelOptions\" ngf-drag-over-class=\"dragover\" class=\"drop-box dragAndDropDescription\">\n        <p class=\"text-center\">Drop your file(s) here</p>\n    </div>\n    <div ngf-no-file-drop>Drag n drop not surpported by your browser</div>\n    <button ngf-select=\"selectFiles(picFiles)\" type=\"file\" ngf-multiple=\"true\" multiple ng-model=\"picFiles\" name=\"files\"\n            accept=\"{{form.schema.pattern && form.schema.pattern.mimeType}}\"\n            ng-attr-ngf-pattern=\"{{form.schema.pattern && form.schema.pattern.mimeType ? form.schema.pattern.mimeType : undefined }}\"\n            ng-attr-ngf-max-size=\"{{form.schema.maxSize && form.schema.maxSize.maximum ? form.schema.maxSize.maximum : undefined }}\"\n            ng-required=\"form.required\" ng-model-options=\"form.ngModelOptions\" id=\"fileInputButton\"\n            class=\"btn btn-primary btn-block {{form.htmlClass}} mt-lg mb\">\n        <fa fw=\"fw\" name=\"upload\" class=\"mr-sm\"></fa>\n        Open file browser\n    </button>\n</script>\n"

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * pickadate.js v3.5.6, 2015/04/20
	 * By Amsul, http://amsul.ca
	 * Hosted on http://amsul.github.io/pickadate.js
	 * Licensed under MIT
	 */
	
	(function ( factory ) {
	
	    // AMD.
	    if ( true )
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	
	    // Node.js/browserify.
	    else if ( typeof exports == 'object' )
	        module.exports = factory( require('jquery') )
	
	    // Browser globals.
	    else this.Picker = factory( jQuery )
	
	}(function( $ ) {
	
	var $window = $( window )
	var $document = $( document )
	var $html = $( document.documentElement )
	var supportsTransitions = document.documentElement.style.transition != null
	
	
	/**
	 * The picker constructor that creates a blank picker.
	 */
	function PickerConstructor( ELEMENT, NAME, COMPONENT, OPTIONS ) {
	
	    // If there’s no element, return the picker constructor.
	    if ( !ELEMENT ) return PickerConstructor
	
	
	    var
	        IS_DEFAULT_THEME = false,
	
	
	        // The state of the picker.
	        STATE = {
	            id: ELEMENT.id || 'P' + Math.abs( ~~(Math.random() * new Date()) )
	        },
	
	
	        // Merge the defaults and options passed.
	        SETTINGS = COMPONENT ? $.extend( true, {}, COMPONENT.defaults, OPTIONS ) : OPTIONS || {},
	
	
	        // Merge the default classes with the settings classes.
	        CLASSES = $.extend( {}, PickerConstructor.klasses(), SETTINGS.klass ),
	
	
	        // The element node wrapper into a jQuery object.
	        $ELEMENT = $( ELEMENT ),
	
	
	        // Pseudo picker constructor.
	        PickerInstance = function() {
	            return this.start()
	        },
	
	
	        // The picker prototype.
	        P = PickerInstance.prototype = {
	
	            constructor: PickerInstance,
	
	            $node: $ELEMENT,
	
	
	            /**
	             * Initialize everything
	             */
	            start: function() {
	
	                // If it’s already started, do nothing.
	                if ( STATE && STATE.start ) return P
	
	
	                // Update the picker states.
	                STATE.methods = {}
	                STATE.start = true
	                STATE.open = false
	                STATE.type = ELEMENT.type
	
	
	                // Confirm focus state, convert into text input to remove UA stylings,
	                // and set as readonly to prevent keyboard popup.
	                ELEMENT.autofocus = ELEMENT == getActiveElement()
	                ELEMENT.readOnly = !SETTINGS.editable
	                ELEMENT.id = ELEMENT.id || STATE.id
	                if ( ELEMENT.type != 'text' ) {
	                    ELEMENT.type = 'text'
	                }
	
	
	                // Create a new picker component with the settings.
	                P.component = new COMPONENT(P, SETTINGS)
	
	
	                // Create the picker root and then prepare it.
	                P.$root = $( '<div class="' + CLASSES.picker + '" id="' + ELEMENT.id + '_root" />' )
	                prepareElementRoot()
	
	
	                // Create the picker holder and then prepare it.
	                P.$holder = $( createWrappedComponent() ).appendTo( P.$root )
	                prepareElementHolder()
	
	
	                // If there’s a format for the hidden input element, create the element.
	                if ( SETTINGS.formatSubmit ) {
	                    prepareElementHidden()
	                }
	
	
	                // Prepare the input element.
	                prepareElement()
	
	
	                // Insert the hidden input as specified in the settings.
	                if ( SETTINGS.containerHidden ) $( SETTINGS.containerHidden ).append( P._hidden )
	                else $ELEMENT.after( P._hidden )
	
	
	                // Insert the root as specified in the settings.
	                if ( SETTINGS.container ) $( SETTINGS.container ).append( P.$root )
	                else $ELEMENT.after( P.$root )
	
	
	                // Bind the default component and settings events.
	                P.on({
	                    start: P.component.onStart,
	                    render: P.component.onRender,
	                    stop: P.component.onStop,
	                    open: P.component.onOpen,
	                    close: P.component.onClose,
	                    set: P.component.onSet
	                }).on({
	                    start: SETTINGS.onStart,
	                    render: SETTINGS.onRender,
	                    stop: SETTINGS.onStop,
	                    open: SETTINGS.onOpen,
	                    close: SETTINGS.onClose,
	                    set: SETTINGS.onSet
	                })
	
	
	                // Once we’re all set, check the theme in use.
	                IS_DEFAULT_THEME = isUsingDefaultTheme( P.$holder[0] )
	
	
	                // If the element has autofocus, open the picker.
	                if ( ELEMENT.autofocus ) {
	                    P.open()
	                }
	
	
	                // Trigger queued the “start” and “render” events.
	                return P.trigger( 'start' ).trigger( 'render' )
	            }, //start
	
	
	            /**
	             * Render a new picker
	             */
	            render: function( entireComponent ) {
	
	                // Insert a new component holder in the root or box.
	                if ( entireComponent ) {
	                    P.$holder = $( createWrappedComponent() )
	                    prepareElementHolder()
	                    P.$root.html( P.$holder )
	                }
	                else P.$root.find( '.' + CLASSES.box ).html( P.component.nodes( STATE.open ) )
	
	                // Trigger the queued “render” events.
	                return P.trigger( 'render' )
	            }, //render
	
	
	            /**
	             * Destroy everything
	             */
	            stop: function() {
	
	                // If it’s already stopped, do nothing.
	                if ( !STATE.start ) return P
	
	                // Then close the picker.
	                P.close()
	
	                // Remove the hidden field.
	                if ( P._hidden ) {
	                    P._hidden.parentNode.removeChild( P._hidden )
	                }
	
	                // Remove the root.
	                P.$root.remove()
	
	                // Remove the input class, remove the stored data, and unbind
	                // the events (after a tick for IE - see `P.close`).
	                $ELEMENT.removeClass( CLASSES.input ).removeData( NAME )
	                setTimeout( function() {
	                    $ELEMENT.off( '.' + STATE.id )
	                }, 0)
	
	                // Restore the element state
	                ELEMENT.type = STATE.type
	                ELEMENT.readOnly = false
	
	                // Trigger the queued “stop” events.
	                P.trigger( 'stop' )
	
	                // Reset the picker states.
	                STATE.methods = {}
	                STATE.start = false
	
	                return P
	            }, //stop
	
	
	            /**
	             * Open up the picker
	             */
	            open: function( dontGiveFocus ) {
	
	                // If it’s already open, do nothing.
	                if ( STATE.open ) return P
	
	                // Add the “active” class.
	                $ELEMENT.addClass( CLASSES.active )
	                aria( ELEMENT, 'expanded', true )
	
	                // * A Firefox bug, when `html` has `overflow:hidden`, results in
	                //   killing transitions :(. So add the “opened” state on the next tick.
	                //   Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=625289
	                setTimeout( function() {
	
	                    // Add the “opened” class to the picker root.
	                    P.$root.addClass( CLASSES.opened )
	                    aria( P.$root[0], 'hidden', false )
	
	                }, 0 )
	
	                // If we have to give focus, bind the element and doc events.
	                if ( dontGiveFocus !== false ) {
	
	                    // Set it as open.
	                    STATE.open = true
	
	                    // Prevent the page from scrolling.
	                    if ( IS_DEFAULT_THEME ) {
	                        $html.
	                            css( 'overflow', 'hidden' ).
	                            css( 'padding-right', '+=' + getScrollbarWidth() )
	                    }
	
	                    // Pass focus to the root element’s jQuery object.
	                    focusPickerOnceOpened()
	
	                    // Bind the document events.
	                    $document.on( 'click.' + STATE.id + ' focusin.' + STATE.id, function( event ) {
	
	                        var target = event.target
	
	                        // If the target of the event is not the element, close the picker picker.
	                        // * Don’t worry about clicks or focusins on the root because those don’t bubble up.
	                        //   Also, for Firefox, a click on an `option` element bubbles up directly
	                        //   to the doc. So make sure the target wasn't the doc.
	                        // * In Firefox stopPropagation() doesn’t prevent right-click events from bubbling,
	                        //   which causes the picker to unexpectedly close when right-clicking it. So make
	                        //   sure the event wasn’t a right-click.
	                        if ( target != ELEMENT && target != document && event.which != 3 ) {
	
	                            // If the target was the holder that covers the screen,
	                            // keep the element focused to maintain tabindex.
	                            P.close( target === P.$holder[0] )
	                        }
	
	                    }).on( 'keydown.' + STATE.id, function( event ) {
	
	                        var
	                            // Get the keycode.
	                            keycode = event.keyCode,
	
	                            // Translate that to a selection change.
	                            keycodeToMove = P.component.key[ keycode ],
	
	                            // Grab the target.
	                            target = event.target
	
	
	                        // On escape, close the picker and give focus.
	                        if ( keycode == 27 ) {
	                            P.close( true )
	                        }
	
	
	                        // Check if there is a key movement or “enter” keypress on the element.
	                        else if ( target == P.$holder[0] && ( keycodeToMove || keycode == 13 ) ) {
	
	                            // Prevent the default action to stop page movement.
	                            event.preventDefault()
	
	                            // Trigger the key movement action.
	                            if ( keycodeToMove ) {
	                                PickerConstructor._.trigger( P.component.key.go, P, [ PickerConstructor._.trigger( keycodeToMove ) ] )
	                            }
	
	                            // On “enter”, if the highlighted item isn’t disabled, set the value and close.
	                            else if ( !P.$root.find( '.' + CLASSES.highlighted ).hasClass( CLASSES.disabled ) ) {
	                                P.set( 'select', P.component.item.highlight )
	                                if ( SETTINGS.closeOnSelect ) {
	                                    P.close( true )
	                                }
	                            }
	                        }
	
	
	                        // If the target is within the root and “enter” is pressed,
	                        // prevent the default action and trigger a click on the target instead.
	                        else if ( $.contains( P.$root[0], target ) && keycode == 13 ) {
	                            event.preventDefault()
	                            target.click()
	                        }
	                    })
	                }
	
	                // Trigger the queued “open” events.
	                return P.trigger( 'open' )
	            }, //open
	
	
	            /**
	             * Close the picker
	             */
	            close: function( giveFocus ) {
	
	                // If we need to give focus, do it before changing states.
	                if ( giveFocus ) {
	                    if ( SETTINGS.editable ) {
	                        ELEMENT.focus()
	                    }
	                    else {
	                        // ....ah yes! It would’ve been incomplete without a crazy workaround for IE :|
	                        // The focus is triggered *after* the close has completed - causing it
	                        // to open again. So unbind and rebind the event at the next tick.
	                        P.$holder.off( 'focus.toOpen' ).focus()
	                        setTimeout( function() {
	                            P.$holder.on( 'focus.toOpen', handleFocusToOpenEvent )
	                        }, 0 )
	                    }
	                }
	
	                // Remove the “active” class.
	                $ELEMENT.removeClass( CLASSES.active )
	                aria( ELEMENT, 'expanded', false )
	
	                // * A Firefox bug, when `html` has `overflow:hidden`, results in
	                //   killing transitions :(. So remove the “opened” state on the next tick.
	                //   Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=625289
	                setTimeout( function() {
	
	                    // Remove the “opened” and “focused” class from the picker root.
	                    P.$root.removeClass( CLASSES.opened + ' ' + CLASSES.focused )
	                    aria( P.$root[0], 'hidden', true )
	
	                }, 0 )
	
	                // If it’s already closed, do nothing more.
	                if ( !STATE.open ) return P
	
	                // Set it as closed.
	                STATE.open = false
	
	                // Allow the page to scroll.
	                if ( IS_DEFAULT_THEME ) {
	                    $html.
	                        css( 'overflow', '' ).
	                        css( 'padding-right', '-=' + getScrollbarWidth() )
	                }
	
	                // Unbind the document events.
	                $document.off( '.' + STATE.id )
	
	                // Trigger the queued “close” events.
	                return P.trigger( 'close' )
	            }, //close
	
	
	            /**
	             * Clear the values
	             */
	            clear: function( options ) {
	                return P.set( 'clear', null, options )
	            }, //clear
	
	
	            /**
	             * Set something
	             */
	            set: function( thing, value, options ) {
	
	                var thingItem, thingValue,
	                    thingIsObject = $.isPlainObject( thing ),
	                    thingObject = thingIsObject ? thing : {}
	
	                // Make sure we have usable options.
	                options = thingIsObject && $.isPlainObject( value ) ? value : options || {}
	
	                if ( thing ) {
	
	                    // If the thing isn’t an object, make it one.
	                    if ( !thingIsObject ) {
	                        thingObject[ thing ] = value
	                    }
	
	                    // Go through the things of items to set.
	                    for ( thingItem in thingObject ) {
	
	                        // Grab the value of the thing.
	                        thingValue = thingObject[ thingItem ]
	
	                        // First, if the item exists and there’s a value, set it.
	                        if ( thingItem in P.component.item ) {
	                            if ( thingValue === undefined ) thingValue = null
	                            P.component.set( thingItem, thingValue, options )
	                        }
	
	                        // Then, check to update the element value and broadcast a change.
	                        if ( thingItem == 'select' || thingItem == 'clear' ) {
	                            $ELEMENT.
	                                val( thingItem == 'clear' ? '' : P.get( thingItem, SETTINGS.format ) ).
	                                trigger( 'change' )
	                        }
	                    }
	
	                    // Render a new picker.
	                    P.render()
	                }
	
	                // When the method isn’t muted, trigger queued “set” events and pass the `thingObject`.
	                return options.muted ? P : P.trigger( 'set', thingObject )
	            }, //set
	
	
	            /**
	             * Get something
	             */
	            get: function( thing, format ) {
	
	                // Make sure there’s something to get.
	                thing = thing || 'value'
	
	                // If a picker state exists, return that.
	                if ( STATE[ thing ] != null ) {
	                    return STATE[ thing ]
	                }
	
	                // Return the submission value, if that.
	                if ( thing == 'valueSubmit' ) {
	                    if ( P._hidden ) {
	                        return P._hidden.value
	                    }
	                    thing = 'value'
	                }
	
	                // Return the value, if that.
	                if ( thing == 'value' ) {
	                    return ELEMENT.value
	                }
	
	                // Check if a component item exists, return that.
	                if ( thing in P.component.item ) {
	                    if ( typeof format == 'string' ) {
	                        var thingValue = P.component.get( thing )
	                        return thingValue ?
	                            PickerConstructor._.trigger(
	                                P.component.formats.toString,
	                                P.component,
	                                [ format, thingValue ]
	                            ) : ''
	                    }
	                    return P.component.get( thing )
	                }
	            }, //get
	
	
	
	            /**
	             * Bind events on the things.
	             */
	            on: function( thing, method, internal ) {
	
	                var thingName, thingMethod,
	                    thingIsObject = $.isPlainObject( thing ),
	                    thingObject = thingIsObject ? thing : {}
	
	                if ( thing ) {
	
	                    // If the thing isn’t an object, make it one.
	                    if ( !thingIsObject ) {
	                        thingObject[ thing ] = method
	                    }
	
	                    // Go through the things to bind to.
	                    for ( thingName in thingObject ) {
	
	                        // Grab the method of the thing.
	                        thingMethod = thingObject[ thingName ]
	
	                        // If it was an internal binding, prefix it.
	                        if ( internal ) {
	                            thingName = '_' + thingName
	                        }
	
	                        // Make sure the thing methods collection exists.
	                        STATE.methods[ thingName ] = STATE.methods[ thingName ] || []
	
	                        // Add the method to the relative method collection.
	                        STATE.methods[ thingName ].push( thingMethod )
	                    }
	                }
	
	                return P
	            }, //on
	
	
	
	            /**
	             * Unbind events on the things.
	             */
	            off: function() {
	                var i, thingName,
	                    names = arguments;
	                for ( i = 0, namesCount = names.length; i < namesCount; i += 1 ) {
	                    thingName = names[i]
	                    if ( thingName in STATE.methods ) {
	                        delete STATE.methods[thingName]
	                    }
	                }
	                return P
	            },
	
	
	            /**
	             * Fire off method events.
	             */
	            trigger: function( name, data ) {
	                var _trigger = function( name ) {
	                    var methodList = STATE.methods[ name ]
	                    if ( methodList ) {
	                        methodList.map( function( method ) {
	                            PickerConstructor._.trigger( method, P, [ data ] )
	                        })
	                    }
	                }
	                _trigger( '_' + name )
	                _trigger( name )
	                return P
	            } //trigger
	        } //PickerInstance.prototype
	
	
	    /**
	     * Wrap the picker holder components together.
	     */
	    function createWrappedComponent() {
	
	        // Create a picker wrapper holder
	        return PickerConstructor._.node( 'div',
	
	            // Create a picker wrapper node
	            PickerConstructor._.node( 'div',
	
	                // Create a picker frame
	                PickerConstructor._.node( 'div',
	
	                    // Create a picker box node
	                    PickerConstructor._.node( 'div',
	
	                        // Create the components nodes.
	                        P.component.nodes( STATE.open ),
	
	                        // The picker box class
	                        CLASSES.box
	                    ),
	
	                    // Picker wrap class
	                    CLASSES.wrap
	                ),
	
	                // Picker frame class
	                CLASSES.frame
	            ),
	
	            // Picker holder class
	            CLASSES.holder,
	
	            'tabindex="-1"'
	        ) //endreturn
	    } //createWrappedComponent
	
	
	
	    /**
	     * Prepare the input element with all bindings.
	     */
	    function prepareElement() {
	
	        $ELEMENT.
	
	            // Store the picker data by component name.
	            data(NAME, P).
	
	            // Add the “input” class name.
	            addClass(CLASSES.input).
	
	            // If there’s a `data-value`, update the value of the element.
	            val( $ELEMENT.data('value') ?
	                P.get('select', SETTINGS.format) :
	                ELEMENT.value
	            )
	
	
	        // Only bind keydown events if the element isn’t editable.
	        if ( !SETTINGS.editable ) {
	
	            $ELEMENT.
	
	                // On focus/click, open the picker.
	                on( 'focus.' + STATE.id + ' click.' + STATE.id, function(event) {
	                    event.preventDefault()
	                    P.open()
	                }).
	
	                // Handle keyboard event based on the picker being opened or not.
	                on( 'keydown.' + STATE.id, handleKeydownEvent )
	        }
	
	
	        // Update the aria attributes.
	        aria(ELEMENT, {
	            haspopup: true,
	            expanded: false,
	            readonly: false,
	            owns: ELEMENT.id + '_root'
	        })
	    }
	
	
	    /**
	     * Prepare the root picker element with all bindings.
	     */
	    function prepareElementRoot() {
	        aria( P.$root[0], 'hidden', true )
	    }
	
	
	     /**
	      * Prepare the holder picker element with all bindings.
	      */
	    function prepareElementHolder() {
	
	        P.$holder.
	
	            on({
	
	                // For iOS8.
	                keydown: handleKeydownEvent,
	
	                'focus.toOpen': handleFocusToOpenEvent,
	
	                blur: function() {
	                    // Remove the “target” class.
	                    $ELEMENT.removeClass( CLASSES.target )
	                },
	
	                // When something within the holder is focused, stop from bubbling
	                // to the doc and remove the “focused” state from the root.
	                focusin: function( event ) {
	                    P.$root.removeClass( CLASSES.focused )
	                    event.stopPropagation()
	                },
	
	                // When something within the holder is clicked, stop it
	                // from bubbling to the doc.
	                'mousedown click': function( event ) {
	
	                    var target = event.target
	
	                    // Make sure the target isn’t the root holder so it can bubble up.
	                    if ( target != P.$holder[0] ) {
	
	                        event.stopPropagation()
	
	                        // * For mousedown events, cancel the default action in order to
	                        //   prevent cases where focus is shifted onto external elements
	                        //   when using things like jQuery mobile or MagnificPopup (ref: #249 & #120).
	                        //   Also, for Firefox, don’t prevent action on the `option` element.
	                        if ( event.type == 'mousedown' && !$( target ).is( 'input, select, textarea, button, option' )) {
	
	                            event.preventDefault()
	
	                            // Re-focus onto the holder so that users can click away
	                            // from elements focused within the picker.
	                            P.$holder[0].focus()
	                        }
	                    }
	                }
	
	            }).
	
	            // If there’s a click on an actionable element, carry out the actions.
	            on( 'click', '[data-pick], [data-nav], [data-clear], [data-close]', function() {
	
	                var $target = $( this ),
	                    targetData = $target.data(),
	                    targetDisabled = $target.hasClass( CLASSES.navDisabled ) || $target.hasClass( CLASSES.disabled ),
	
	                    // * For IE, non-focusable elements can be active elements as well
	                    //   (http://stackoverflow.com/a/2684561).
	                    activeElement = getActiveElement()
	                    activeElement = activeElement && ( activeElement.type || activeElement.href )
	
	                // If it’s disabled or nothing inside is actively focused, re-focus the element.
	                if ( targetDisabled || activeElement && !$.contains( P.$root[0], activeElement ) ) {
	                    P.$holder[0].focus()
	                }
	
	                // If something is superficially changed, update the `highlight` based on the `nav`.
	                if ( !targetDisabled && targetData.nav ) {
	                    P.set( 'highlight', P.component.item.highlight, { nav: targetData.nav } )
	                }
	
	                // If something is picked, set `select` then close with focus.
	                else if ( !targetDisabled && 'pick' in targetData ) {
	                    P.set( 'select', targetData.pick )
	                    if ( SETTINGS.closeOnSelect ) {
	                        P.close( true )
	                    }
	                }
	
	                // If a “clear” button is pressed, empty the values and close with focus.
	                else if ( targetData.clear ) {
	                    P.clear()
	                    if ( SETTINGS.closeOnClear ) {
	                        P.close( true )
	                    }
	                }
	
	                else if ( targetData.close ) {
	                    P.close( true )
	                }
	
	            }) //P.$holder
	
	    }
	
	
	     /**
	      * Prepare the hidden input element along with all bindings.
	      */
	    function prepareElementHidden() {
	
	        var name
	
	        if ( SETTINGS.hiddenName === true ) {
	            name = ELEMENT.name
	            ELEMENT.name = ''
	        }
	        else {
	            name = [
	                typeof SETTINGS.hiddenPrefix == 'string' ? SETTINGS.hiddenPrefix : '',
	                typeof SETTINGS.hiddenSuffix == 'string' ? SETTINGS.hiddenSuffix : '_submit'
	            ]
	            name = name[0] + ELEMENT.name + name[1]
	        }
	
	        P._hidden = $(
	            '<input ' +
	            'type=hidden ' +
	
	            // Create the name using the original input’s with a prefix and suffix.
	            'name="' + name + '"' +
	
	            // If the element has a value, set the hidden value as well.
	            (
	                $ELEMENT.data('value') || ELEMENT.value ?
	                    ' value="' + P.get('select', SETTINGS.formatSubmit) + '"' :
	                    ''
	            ) +
	            '>'
	        )[0]
	
	        $ELEMENT.
	
	            // If the value changes, update the hidden input with the correct format.
	            on('change.' + STATE.id, function() {
	                P._hidden.value = ELEMENT.value ?
	                    P.get('select', SETTINGS.formatSubmit) :
	                    ''
	            })
	    }
	
	
	    // Wait for transitions to end before focusing the holder. Otherwise, while
	    // using the `container` option, the view jumps to the container.
	    function focusPickerOnceOpened() {
	
	        if (IS_DEFAULT_THEME && supportsTransitions) {
	            P.$holder.find('.' + CLASSES.frame).one('transitionend', function() {
	                P.$holder[0].focus()
	            })
	        }
	        else {
	            P.$holder[0].focus()
	        }
	    }
	
	
	    function handleFocusToOpenEvent(event) {
	
	        // Stop the event from propagating to the doc.
	        event.stopPropagation()
	
	        // Add the “target” class.
	        $ELEMENT.addClass( CLASSES.target )
	
	        // Add the “focused” class to the root.
	        P.$root.addClass( CLASSES.focused )
	
	        // And then finally open the picker.
	        P.open()
	    }
	
	
	    // For iOS8.
	    function handleKeydownEvent( event ) {
	
	        var keycode = event.keyCode,
	
	            // Check if one of the delete keys was pressed.
	            isKeycodeDelete = /^(8|46)$/.test(keycode)
	
	        // For some reason IE clears the input value on “escape”.
	        if ( keycode == 27 ) {
	            P.close( true )
	            return false
	        }
	
	        // Check if `space` or `delete` was pressed or the picker is closed with a key movement.
	        if ( keycode == 32 || isKeycodeDelete || !STATE.open && P.component.key[keycode] ) {
	
	            // Prevent it from moving the page and bubbling to doc.
	            event.preventDefault()
	            event.stopPropagation()
	
	            // If `delete` was pressed, clear the values and close the picker.
	            // Otherwise open the picker.
	            if ( isKeycodeDelete ) { P.clear().close() }
	            else { P.open() }
	        }
	    }
	
	
	    // Return a new picker instance.
	    return new PickerInstance()
	} //PickerConstructor
	
	
	
	/**
	 * The default classes and prefix to use for the HTML classes.
	 */
	PickerConstructor.klasses = function( prefix ) {
	    prefix = prefix || 'picker'
	    return {
	
	        picker: prefix,
	        opened: prefix + '--opened',
	        focused: prefix + '--focused',
	
	        input: prefix + '__input',
	        active: prefix + '__input--active',
	        target: prefix + '__input--target',
	
	        holder: prefix + '__holder',
	
	        frame: prefix + '__frame',
	        wrap: prefix + '__wrap',
	
	        box: prefix + '__box'
	    }
	} //PickerConstructor.klasses
	
	
	
	/**
	 * Check if the default theme is being used.
	 */
	function isUsingDefaultTheme( element ) {
	
	    var theme,
	        prop = 'position'
	
	    // For IE.
	    if ( element.currentStyle ) {
	        theme = element.currentStyle[prop]
	    }
	
	    // For normal browsers.
	    else if ( window.getComputedStyle ) {
	        theme = getComputedStyle( element )[prop]
	    }
	
	    return theme == 'fixed'
	}
	
	
	
	/**
	 * Get the width of the browser’s scrollbar.
	 * Taken from: https://github.com/VodkaBears/Remodal/blob/master/src/jquery.remodal.js
	 */
	function getScrollbarWidth() {
	
	    if ( $html.height() <= $window.height() ) {
	        return 0
	    }
	
	    var $outer = $( '<div style="visibility:hidden;width:100px" />' ).
	        appendTo( 'body' )
	
	    // Get the width without scrollbars.
	    var widthWithoutScroll = $outer[0].offsetWidth
	
	    // Force adding scrollbars.
	    $outer.css( 'overflow', 'scroll' )
	
	    // Add the inner div.
	    var $inner = $( '<div style="width:100%" />' ).appendTo( $outer )
	
	    // Get the width with scrollbars.
	    var widthWithScroll = $inner[0].offsetWidth
	
	    // Remove the divs.
	    $outer.remove()
	
	    // Return the difference between the widths.
	    return widthWithoutScroll - widthWithScroll
	}
	
	
	
	/**
	 * PickerConstructor helper methods.
	 */
	PickerConstructor._ = {
	
	    /**
	     * Create a group of nodes. Expects:
	     * `
	        {
	            min:    {Integer},
	            max:    {Integer},
	            i:      {Integer},
	            node:   {String},
	            item:   {Function}
	        }
	     * `
	     */
	    group: function( groupObject ) {
	
	        var
	            // Scope for the looped object
	            loopObjectScope,
	
	            // Create the nodes list
	            nodesList = '',
	
	            // The counter starts from the `min`
	            counter = PickerConstructor._.trigger( groupObject.min, groupObject )
	
	
	        // Loop from the `min` to `max`, incrementing by `i`
	        for ( ; counter <= PickerConstructor._.trigger( groupObject.max, groupObject, [ counter ] ); counter += groupObject.i ) {
	
	            // Trigger the `item` function within scope of the object
	            loopObjectScope = PickerConstructor._.trigger( groupObject.item, groupObject, [ counter ] )
	
	            // Splice the subgroup and create nodes out of the sub nodes
	            nodesList += PickerConstructor._.node(
	                groupObject.node,
	                loopObjectScope[ 0 ],   // the node
	                loopObjectScope[ 1 ],   // the classes
	                loopObjectScope[ 2 ]    // the attributes
	            )
	        }
	
	        // Return the list of nodes
	        return nodesList
	    }, //group
	
	
	    /**
	     * Create a dom node string
	     */
	    node: function( wrapper, item, klass, attribute ) {
	
	        // If the item is false-y, just return an empty string
	        if ( !item ) return ''
	
	        // If the item is an array, do a join
	        item = $.isArray( item ) ? item.join( '' ) : item
	
	        // Check for the class
	        klass = klass ? ' class="' + klass + '"' : ''
	
	        // Check for any attributes
	        attribute = attribute ? ' ' + attribute : ''
	
	        // Return the wrapped item
	        return '<' + wrapper + klass + attribute + '>' + item + '</' + wrapper + '>'
	    }, //node
	
	
	    /**
	     * Lead numbers below 10 with a zero.
	     */
	    lead: function( number ) {
	        return ( number < 10 ? '0': '' ) + number
	    },
	
	
	    /**
	     * Trigger a function otherwise return the value.
	     */
	    trigger: function( callback, scope, args ) {
	        return typeof callback == 'function' ? callback.apply( scope, args || [] ) : callback
	    },
	
	
	    /**
	     * If the second character is a digit, length is 2 otherwise 1.
	     */
	    digits: function( string ) {
	        return ( /\d/ ).test( string[ 1 ] ) ? 2 : 1
	    },
	
	
	    /**
	     * Tell if something is a date object.
	     */
	    isDate: function( value ) {
	        return {}.toString.call( value ).indexOf( 'Date' ) > -1 && this.isInteger( value.getDate() )
	    },
	
	
	    /**
	     * Tell if something is an integer.
	     */
	    isInteger: function( value ) {
	        return {}.toString.call( value ).indexOf( 'Number' ) > -1 && value % 1 === 0
	    },
	
	
	    /**
	     * Create ARIA attribute strings.
	     */
	    ariaAttr: ariaAttr
	} //PickerConstructor._
	
	
	
	/**
	 * Extend the picker with a component and defaults.
	 */
	PickerConstructor.extend = function( name, Component ) {
	
	    // Extend jQuery.
	    $.fn[ name ] = function( options, action ) {
	
	        // Grab the component data.
	        var componentData = this.data( name )
	
	        // If the picker is requested, return the data object.
	        if ( options == 'picker' ) {
	            return componentData
	        }
	
	        // If the component data exists and `options` is a string, carry out the action.
	        if ( componentData && typeof options == 'string' ) {
	            return PickerConstructor._.trigger( componentData[ options ], componentData, [ action ] )
	        }
	
	        // Otherwise go through each matched element and if the component
	        // doesn’t exist, create a new picker using `this` element
	        // and merging the defaults and options with a deep copy.
	        return this.each( function() {
	            var $this = $( this )
	            if ( !$this.data( name ) ) {
	                new PickerConstructor( this, name, Component, options )
	            }
	        })
	    }
	
	    // Set the defaults.
	    $.fn[ name ].defaults = Component.defaults
	} //PickerConstructor.extend
	
	
	
	function aria(element, attribute, value) {
	    if ( $.isPlainObject(attribute) ) {
	        for ( var key in attribute ) {
	            ariaSet(element, key, attribute[key])
	        }
	    }
	    else {
	        ariaSet(element, attribute, value)
	    }
	}
	function ariaSet(element, attribute, value) {
	    element.setAttribute(
	        (attribute == 'role' ? '' : 'aria-') + attribute,
	        value
	    )
	}
	function ariaAttr(attribute, data) {
	    if ( !$.isPlainObject(attribute) ) {
	        attribute = { attribute: data }
	    }
	    data = ''
	    for ( var key in attribute ) {
	        var attr = (key == 'role' ? '' : 'aria-') + key,
	            attrVal = attribute[key]
	        data += attrVal == null ? '' : attr + '="' + attribute[key] + '"'
	    }
	    return data
	}
	
	// IE8 bug throws an error for activeElements within iframes.
	function getActiveElement() {
	    try {
	        return document.activeElement
	    } catch ( err ) { }
	}
	
	
	
	// Expose the picker constructor.
	return PickerConstructor
	
	
	}));
	
	
	


/***/ }),
/* 813 */
5,
/* 814 */,
/* 815 */
5,
/* 816 */,
/* 817 */
5,
/* 818 */,
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EFormListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eFormList = __webpack_require__(820);
	
	var _eFormList2 = _interopRequireDefault(_eFormList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var EFormListComponent = exports.EFormListComponent = function () {
	  EFormListComponent.$inject = ['Auth', 'EFormsService', 'dialogs', '$uibModal', '$stateParams', 'prompt', '$location'];
	  function EFormListComponent(Auth, EFormsService, dialogs, $uibModal, $stateParams, prompt, $location) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, EFormListComponent);
	
	    this.EFormsService = EFormsService;
	    this.data = [];
	    this.isAdmin = Auth.isAdminSync;
	    this.prompt = prompt;
	
	    this.$location = $location;
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	
	    this.formName = $stateParams.name;
	
	    this.EFormsService.query(function (data) {
	      _this.data = data;
	    }, function (err) {
	      console.log("Could not retrieve e-forms.");
	    });
	  }
	
	  _createClass(EFormListComponent, [{
	    key: 'copyToClipboard',
	    value: function copyToClipboard(eform) {
	      var path = this.$location.protocol() + "://" + window.location.host + "/e-form/" + eform._id;
	      window.prompt("Link to E-Form:", path);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(eform) {
	      var that = this;
	
	      var eformText = "<br/><br/><p><b>" + eform.name + "</b></p>";
	
	      var callout = '<div class="bs-callout bs-callout-danger">\n      <h4>Warning!</h4>\n      When you delete this e-form, all user responses to this form won\'t be accessible anymore. <b>This cannot be undone!</b>\n    </div>';
	
	      var dlg = this.dialogs.confirm("Delete E-Form?", "Do you really want to delete the e-form?" + eformText + callout);
	      dlg.result.then(function () {
	
	        that.prompt({
	          title: 'Confirm deletion of E-Form',
	          message: 'To finally delete it, please enter the e-form name below:',
	          input: true,
	          label: '',
	          value: ''
	        }).then(function (name) {
	
	          if (eform.name == name) {
	            that.EFormsService.delete({ id: eform._id }, function () {
	              that.data = that.data.filter(function (obj) {
	                return obj._id !== eform._id;
	              });
	            }, function (err) {
	              alert("Could not delete e-form");
	            });
	          } else {
	            that.dialogs.notify("Name doesn't match", "The name doesn't match the e-form you are about to delete.");
	          }
	        }, function () {});
	      });
	    }
	  }]);
	
	  return EFormListComponent;
	}();
	
	exports.default = angular.module('conduu.eForms.eFormList', [uiRouter]).config(_eFormList2.default).component('eFormList', {
	  template: __webpack_require__(821),
	  controller: EFormListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 820 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('e-form-list', {
	    url: '/e-form/list',
	    template: '<e-form-list></e-form-list>',
	    authenticate: 'suite-admin'
	  });
	}];

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <a style=\"float:right; margin-top:16px\" class=\"btn btn-primary\" ng-href=\"/e-form/edit/\"><i class=\"fa fa-plus\"></i> Add E-Form</a>\n      <h2>E-Forms</h2>\n      <li class=\"active\"><a href=\"#\">E-Forms</a></li>\n    </ol>\n\n    <div class=\"col-xs-12\">\n      <table datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\n        <thead>\n        <tr>\n          <th>Name</th>\n          <th>Description</th>\n          <th></th>\n          <th></th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"eform in ctrl.data | orderBy: 'meta.creationDate':true\">\n          <td ng-class=\"{'text-bold': eform.system}\">{{eform.name}}</td>\n          <td>{{eform.description}}</td>\n          <td>\n            <a class=\"btn btn-sm btn-primary\" ng-href=\"/e-form/data-browser/{{eform._id}}\">\n              <i class=\"fa fa-eye fa-fw\"></i> Response Browser</a>\n            <a class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.copyToClipboard(eform)\"><i class=\"fa fa-clipboard fa-fw\"></i> </a>\n          </td>\n          <td>\n            <a ng-hide=\"eform.system\" ng-href=\"/e-form/edit/{{eform._id}}\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-fw fa-pencil\"></i></a>\n            <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(eform)\"><i class=\"fa fa-trash-o fa-fw\"></i></button>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EFormEditorComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eFormEditor = __webpack_require__(823);
	
	var _eFormEditor2 = _interopRequireDefault(_eFormEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var EFormEditorComponent = exports.EFormEditorComponent = function () {
	  EFormEditorComponent.$inject = ['$stateParams', '$scope', 'dialogs', 'EFormsService', '$state', 'CommunityService', 'PropertyService'];
	  function EFormEditorComponent($stateParams, $scope, dialogs, EFormsService, $state, CommunityService, PropertyService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, EFormEditorComponent);
	
	    this.eFormId = $stateParams.id;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.dialogs = dialogs;
	    this.EFormsService = EFormsService;
	    this.PropertyService = PropertyService;
	
	    CommunityService.query(function (data) {
	      _this.communities = data.map(function (community) {
	        return {
	          value: community._id,
	          name: community.code + ": " + community.name
	        };
	      });
	    });
	
	    this.fieldTypes = ["text", "textbox", "number", "yes/no", "select", "image", "help", "recipient", "unit"];
	    this.prefillTypes = [{
	      type: "name:first",
	      name: "First Name",
	      group: "Name"
	    }, {
	      type: "name:last",
	      name: "Last Name",
	      group: "Name"
	    }, {
	      type: "name:full",
	      name: "Full Name",
	      group: "Name"
	    }, {
	      type: "profile:email",
	      name: "Email",
	      group: "Profile"
	    }, {
	      type: "profile:phone",
	      name: "Phone",
	      group: "Profile"
	    }, {
	      type: "profile:address",
	      name: "Address",
	      group: "Profile"
	    }, {
	      type: "date:shortDate",
	      name: "Short Date (e.g. 9/6/18)",
	      group: "Date and Time"
	    }, {
	      type: "date:mediumDate",
	      name: "Medium Date (e.g. Sep 6, 2018)",
	      group: "Date and Time"
	    }, {
	      type: "date:longDate",
	      name: "Long Date (e.g. September 6, 2018)",
	      group: "Date and Time"
	    }, {
	      type: "date:fullDate",
	      name: "Full Date (e.g. Thursday, September 6, 2018)",
	      group: "Date and Time"
	    }, {
	      type: "date:short",
	      name: "Date and Time (e.g. 9/6/18 9:02 AM)",
	      group: "Date and Time"
	    }];
	
	    this.toolbarDefinition = [["bold", "italics", "underline"], ["h3", "h4", "h5"], ["p", "clear"], ["ul", "ol"], ["archiveImageLink", "insertImage", "insertLink"], ["html"]];
	
	    this.sortableOptions = {
	      handle: '.handle'
	    };
	
	    this.fields = [];
	    this.form = ['*'];
	    this.model = {};
	    this.recipients = "";
	
	    this.eForm = {
	      formSchema: {
	        "type": "object",
	        "properties": {}
	      }
	    };
	
	    if (this.eFormId) {
	      this.EFormsService.get({ id: this.eFormId }, function (eForm) {
	        _this.eForm = eForm;
	        _this.recipients = angular.isArray(eForm.recipients) ? eForm.recipients.join("\n") : '';
	        _this.createFields();
	      });
	    }
	  }
	
	  _createClass(EFormEditorComponent, [{
	    key: 'deleteField',
	    value: function deleteField($event, field, idx) {
	      var _this2 = this;
	
	      $event.stopPropagation();
	
	      var dlg = this.dialogs.confirm("Delete Field?", "Do you really want to delete the field '" + field.title + "'?");
	      dlg.result.then(function () {
	        _this2.fields.splice(idx, 1);
	      }, function () {});
	    }
	  }, {
	    key: 'setUnitsAsEnum',
	    value: function setUnitsAsEnum(field) {
	      this.PropertyService.getByCommunity({ communityId: field.communityId }, function (data) {
	        field.enum = data.filter(function (ppty) {
	          return ppty.lotNo;
	        }).map(function (ppty) {
	          return ppty.lotNo;
	        }).sort(function (a, b) {
	          return a.localeCompare(b);
	        });
	      });
	    }
	  }, {
	    key: 'createFields',
	    value: function createFields() {
	      var _this3 = this;
	
	      this.fields = [];
	
	      var keys = Object.keys(this.eForm.formSchema.properties);
	      var requiredFields = this.eForm.formSchema.required || [];
	
	      keys.forEach(function (key) {
	        var oSchemaField = _this3.eForm.formSchema.properties[key];
	
	        var fieldDef = {
	          key: key,
	          title: oSchemaField.title || '',
	          description: oSchemaField.description || '',
	          required: requiredFields.indexOf(key) !== -1
	        };
	
	        switch (oSchemaField.type) {
	          case 'string':
	            if (oSchemaField.enum) {
	              if (oSchemaField.recipient) {
	                fieldDef.type = 'recipient';
	              } else if (oSchemaField.communityId) {
	                fieldDef.type = 'unit';
	                fieldDef.communityId = oSchemaField.communityId;
	                fieldDef.copyToPrimaryOwner = oSchemaField.copyToPrimaryOwner;
	              } else {
	                fieldDef.type = 'select';
	              }
	              fieldDef.enum = oSchemaField.enum;
	            } else if (oSchemaField["x-schema-form"]) {
	
	              if (oSchemaField["x-schema-form"]["type"] == 'textarea') {
	                fieldDef.type = 'textbox';
	              } else if (oSchemaField["x-schema-form"]["type"] == 'help') {
	                fieldDef.type = 'help';
	                fieldDef.helpvalue = oSchemaField["x-schema-form"]["helpvalue"];
	              } else {
	                fieldDef.type = 'text';
	              }
	            } else {
	              fieldDef.type = 'text';
	            }
	            break;
	          case 'number':
	            fieldDef.type = 'number';
	            break;
	          case 'boolean':
	            fieldDef.type = 'yes/no';
	            break;
	          case 'array':
	            fieldDef.type = 'image';
	            break;
	        }
	
	        if (oSchemaField["x-prefilled"]) {
	          fieldDef.prefill = true;
	          fieldDef.prefilled = oSchemaField["x-prefilled"];
	        }
	
	        _this3.fields.push(fieldDef);
	      });
	    }
	  }, {
	    key: 'removeChoice',
	    value: function removeChoice(field, idx) {
	      field.enum.splice(idx, 1);
	    }
	  }, {
	    key: 'addChoice',
	    value: function addChoice(field) {
	      if (!field.hasOwnProperty("enum")) {
	        field.enum = [""];
	      } else {
	        field.enum.push("");
	      }
	    }
	  }, {
	    key: 'preview',
	    value: function preview() {
	      var _this4 = this;
	
	      this.eForm.formSchema.properties = {};
	      this.eForm.formSchema.required = [];
	
	      var recipientGroups = [];
	
	      this.recipients.split("\n").forEach(function (recipient) {
	        var splitted = recipient.split("|");
	        if (splitted.length == 2) {
	          var groupName = splitted[1].trim();
	          if (!recipientGroups.includes(groupName)) {
	            recipientGroups.push(groupName);
	          }
	        }
	      });
	
	      this.fields.forEach(function (field) {
	
	        var fieldDef = {
	          title: field.title,
	          key: field.key,
	          description: field.description
	        };
	
	        if (field.required && field.type != 'help') {
	          _this4.eForm.formSchema.required.push(field.key);
	        }
	
	        switch (field.type) {
	          case 'text':
	            fieldDef.type = 'string';
	            if (field.prefill && field.prefilled) {
	              fieldDef["x-prefilled"] = field.prefilled;
	            }
	            break;
	          case 'textbox':
	            fieldDef.type = 'string';
	            fieldDef["x-schema-form"] = {
	              "type": "textarea"
	            };
	            if (field.prefill && field.prefilled) {
	              fieldDef["x-prefilled"] = field.prefilled;
	            }
	            break;
	          case 'number':
	            fieldDef.type = 'number';
	            break;
	          case 'yes/no':
	            fieldDef.type = 'boolean';
	            break;
	          case 'select':
	            fieldDef.type = 'string';
	            fieldDef.enum = field.enum || [];
	            fieldDef["x-schema-form"] = {
	              "placeholder": "- Select -"
	            };
	            break;
	          case 'image':
	            fieldDef.type = 'array';
	            fieldDef.format = 'singlefile';
	            fieldDef.pattern = {
	              "mimeType": "image/*"
	            };
	            fieldDef["x-schema-form"] = {
	              "type": "nwpFileUpload",
	              "endpoint": "/api/storage"
	            };
	            break;
	          case 'help':
	            fieldDef.type = 'string';
	            fieldDef["x-schema-form"] = {
	              "type": "help",
	              "helpvalue": field.helpvalue
	            };
	            break;
	          case 'recipient':
	            fieldDef.type = 'string';
	            fieldDef.recipient = true;
	            fieldDef.enum = recipientGroups || [];
	            fieldDef["x-schema-form"] = {
	              "placeholder": "- Select -"
	            };
	            break;
	          case 'unit':
	            fieldDef.type = 'string';
	            fieldDef.communityId = field.communityId;
	            fieldDef.copyToPrimaryOwner = field.copyToPrimaryOwner;
	            fieldDef.enum = field.enum || [];
	            fieldDef["x-schema-form"] = {
	              "placeholder": "- Select -"
	            };
	            break;
	        }
	
	        _this4.eForm.formSchema.properties[field.key] = fieldDef;
	      });
	
	      this.$scope.$broadcast('schemaFormRedraw');
	    }
	  }, {
	    key: 'addField',
	    value: function addField() {
	      var idx = this.fields.length + 1;
	      this.fields.push({
	        key: 'field' + idx,
	        title: 'Field ' + idx,
	        type: 'text'
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      var _this5 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess(data) {
	          var actionString = _this5.eFormId ? "changed" : "created";
	          var dlg = _this5.dialogs.notify("Success", "Your eForm has been " + actionString + " successfully");
	          dlg.result.then(function () {
	            that.$state.go("e-form-list");
	          });
	        };
	
	        var onError = function onError(err) {
	          _this5.sendFailure = true;
	        };
	
	        this.preview();
	
	        var lines = this.recipients.split(/\n/);
	        this.eForm.recipients = [];
	        for (var i = 0; i < lines.length; i++) {
	          if (/\S/.test(lines[i])) {
	            this.eForm.recipients.push(lines[i].trim());
	          }
	        }
	
	        this.eForm.fields = this.fields;
	
	        if (this.eFormId) {
	          this.EFormsService.update({ id: this.eFormId }, this.eForm, onSuccess, onError);
	        } else {
	          this.EFormsService.save(this.eForm, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return EFormEditorComponent;
	}();
	
	exports.default = angular.module('conduu.eForms.editor', [uiRouter]).config(_eFormEditor2.default).component('eFormEdit', {
	  template: __webpack_require__(824),
	  controller: EFormEditorComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('e-form-editor', {
	    url: '/e-form/edit/:id',
	    template: '<e-form-edit></e-form-edit>',
	    authenticate: 'suite-admin'
	  });
	}];

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <h2>E-Form Editor</h2>\n      <li><a href=\"/e-form/list\">E-Forms</a></li>\n      <li class=\"active\"><a href=\"#\">Editor</a></li>\n    </ol>\n\n    <div class=\"col-xs-8\">\n            <form class=\"form\" name=\"form\" ng-submit=\"ctrl.create(form)\" novalidate>\n\n                <!-- Title -->\n                <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && ctrl.submitted,\n                                                    'has-error': form.name.$invalid && ctrl.submitted }\">\n                    <label>E-Form Name</label>\n                    <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"ctrl.eForm.name\" required/>\n                    <p class=\"help-block\" ng-show=\"form.name.$error.required && ctrl.submitted\">\n                        You must specify a name for the E-Form.\n                    </p>\n                </div>\n\n                <!-- Description -->\n                <div class=\"form-group\">\n                    <label>Description</label>\n                    <textarea name=\"description\" rows=\"2\" class=\"form-control\" ng-model=\"ctrl.eForm.description\"></textarea>\n                </div>\n\n                <!-- Recipients -->\n                <div class=\"form-group\" ng-class=\"{ 'has-success': form.recipients.$valid && ctrl.submitted,\n                                                    'has-error': form.recipients.$invalid && ctrl.submitted }\">\n                    <!--<label class=\"pull-right\" style=\"font-weight: normal\"><input type=\"checkbox\" ng-model=\"ctrl.eForm.copyToSender\" style=\"position: relative; top: 2px\" /> Send copy to sender</label>-->\n                    <label>E-Form Recipients</label> (One Email per Line)\n                    <textarea rows=\"2\" class=\"form-control\" style=\"font-family: monospace\" ng-model=\"ctrl.recipients\" name=\"recipients\" required></textarea>\n                    <p class=\"help-block\" ng-show=\"form.recipients.$error.required && ctrl.submitted\">\n                        You must specify at least one recipient for the E-Form.\n                    </p>\n                </div>\n\n                <!-- Fields -->\n                <uib-accordion close-others=\"oneAtATime\" ui-sortable=\"ctrl.sortableOptions\"  ng-model=\"ctrl.fields\">\n                    <div uib-accordion-group ng-repeat=\"field in ctrl.fields track by $index\" class=\"panel-default\">\n                        <uib-accordion-heading>\n                            <span style=\"cursor: move\" class=\"handle\"><i class=\"fa fa-fw fa-arrows\" style=\"margin-right:8px\"></i></span>\n                            <span ng-class=\"{'text-muted': !field.title}\">{{field.title || 'No TITLE'}}</span>\n\n                            <a style=\"color: darkred\" ng-click=\"ctrl.deleteField($event, field, $index)\"><i class=\"fa fa-fw fa-trash\" style=\"float: right\"></i></a>\n                            <span style=\"float:right;padding-right: 24px;\" class=\"text-muted text-uppercase\">{{field.type}}</span>\n                            <span ng-if=\"field.required\" style=\"float:right\" class=\"text-muted\">*&nbsp;</span>\n                        </uib-accordion-heading>\n\n                        <div class=\"form-group\" ng-hide=\"field.type == 'help'\">\n                            <label>Title</label>\n                            <input type=\"text\" name=\"subject\" class=\"form-control\" ng-model=\"field.title\" />\n                        </div>\n\n                        <div class=\"form-group\" ng-hide=\"field.type == 'help'\">\n                            <label><input type=\"checkbox\" ng-model=\"field.required\" />&nbsp;&nbsp;Required</label>\n                            <label ng-show=\"field.type == 'text' || field.type == 'textbox'\"><input type=\"checkbox\" ng-model=\"field.prefill\" />&nbsp;&nbsp;Uses Prefilled Value</label>\n                        </div>\n\n                        <div class=\"form-group col-xs-6\" style=\"padding:0\">\n                            <label>Type</label>\n                            <select type=\"text\" name=\"fieldType\" class=\"form-control\" ng-model=\"field.type\"\n                                    ng-options=\"o as o for o in ctrl.fieldTypes\"></select>\n                        </div>\n\n                        <div class=\"form-group col-xs-6\" style=\"padding-right:0\">\n                            <label>Key</label>\n                            <input type=\"text\" name=\"subject\" class=\"form-control\" ng-model=\"field.key\" />\n                        </div>\n\n                        <div class=\"form-group\" ng-show=\"(field.type == 'text' || field.type == 'textbox') && field.prefill == true\">\n                            <label>Prefilled</label>\n                            <select name=\"prefilled\" class=\"form-control\" ng-model=\"field.prefilled\"\n                                    ng-options=\"o.type as o.name group by o.group for o in ctrl.prefillTypes\"></select>\n                        </div>\n\n                      <div class=\"form-group\"  ng-if=\"field.type == 'unit'\">\n                        <label>Community <span style=\"font-weight: normal\">(to pick a unit/lot# from)</span></label>\n                        <select name=\"community\" class=\"form-control\" ng-model=\"field.communityId\"\n                                ng-options=\"o.value as o.name for o in ctrl.communities\"\n                                ng-change=\"ctrl.setUnitsAsEnum(field)\"></select>\n                      </div>\n\n                      <div class=\"form-group\" ng-show=\"field.type == 'unit'\">\n                        <label><input type=\"checkbox\" ng-model=\"field.copyToPrimaryOwner\" />&nbsp;&nbsp;Send Copy to Primary Owner of Unit</label>\n                      </div>\n\n                        <div class=\"form-group\" ng-hide=\"field.type == 'help'\">\n                            <label>Description</label>\n                            <input type=\"text\" name=\"description\" class=\"form-control\" ng-model=\"field.description\" />\n                        </div>\n\n                        <div ng-if=\"field.type == 'help'\" style=\"clear:both\"></div>\n                        <text-angular ng-show=\"field.type == 'help'\" ng-model=\"field.helpvalue\" ta-toolbar=\"ctrl.toolbarDefinition\"></text-angular>\n\n                        <div ng-if=\"field.type == 'select'\" class=\"form-group\" ng-if=\"question.type != 'text'\">\n                            <table ng-show=\"field.enum && field.enum.length > 0\" style=\"width:100%;\" class=\"table table-striped\">\n                                <thead>\n                                <tr>\n                                    <th style=\"width:32px\"></th>\n                                    <th>Option / Choice</th>\n                                    <th></th>\n                                </tr>\n                                </thead>\n                                <tbody ui-sortable ng-model=\"field.enum\">\n                                <tr ng-repeat=\"choice in field.enum track by $index\" style=\"cursor: move;\">\n                                    <td><i class=\"fa fa-fw fa-arrows\"></i></td>\n                                    <td>\n                                        <input type=\"text\" class=\"form-control\" ng-model=\"field.enum[$index]\" />\n                                    </td>\n                                    <td style=\"text-align: right; width:30px\">\n                                        <a class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.removeChoice(field, $index)\"><i class=\"fa fa-fw fa-trash\"></i></a>\n                                    </td>\n                                </tr>\n                                </tbody>\n                            </table>\n\n                            <a class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.addChoice(field)\"><i class=\"fa fa-fw fa-plus\"></i> Add Option / Choice</a>\n\n                        </div>\n                    </div>\n                </uib-accordion>\n\n                <a class=\"btn btn-primary\" ng-click=\"ctrl.addField()\"><i class=\"fa fa-fw fa-plus\"></i> Add Field</a>\n\n                <hr/>\n\n                <div class=\"form-group\">\n                    <label>Requires Signature</label>\n                    <input type=\"checkbox\" name=\"signatureRequired\" class=\"form-control\" ng-model=\"ctrl.eForm.signatureRequired\" />\n                </div>\n\n                <!--\n                <div class=\"form-group\">\n                    <label>Fields as Reply To</label>\n                    <select type=\"text\" name=\"fieldAsReplyTo\" class=\"form-control\" ng-model=\"ctrl.eForm.fieldAsReplyTo\"\n                            ng-options=\"o.value as o.name for o in ctrl.emailFields\"></select>\n                </div>-->\n\n                <div ng-show=\"ctrl.sendFailure\" class=\"alert alert-danger\">\n                    There has been an error. Your eForm could not be created.\n                </div>\n\n                <button ng-hide=\"ctrl.eFormId\" class=\"btn btn-primary\" type=\"submit\">Create Form</button>\n\n                <button ng-show=\"ctrl.eFormId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\n                <a class=\"btn btn-warning\" ui-sref=\"e-form-list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</a>\n            </form>\n\n        </div>\n\n        <div class=\"col-sm-4 preview\">\n            <a style=\"float:right;position: relative; top:24px\" href=\"#\" ng-click=\"ctrl.preview()\" class=\"btn btn-primary\"><i class=\"fa fa-fw fa-refresh\"></i> Refresh</a>\n            <h1>Preview</h1>\n            <div sf-schema=\"ctrl.eForm.formSchema\" sf-form=\"ctrl.form\" sf-model=\"ctrl.model\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EFormComponent = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eForm = __webpack_require__(826);
	
	var _eForm2 = _interopRequireDefault(_eForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var EFormComponent = exports.EFormComponent = function () {
	  EFormComponent.$inject = ['EFormsService', 'Auth', '$state', 'dialogs', '$filter', '$stateParams', '$uibModal', 'EFormResultsService', '$scope'];
	  function EFormComponent(EFormsService, Auth, $state, dialogs, $filter, $stateParams, $uibModal, EFormResultsService, $scope) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, EFormComponent);
	
	    this.EFormsService = EFormsService;
	    this.EFormResultsService = EFormResultsService;
	    this.dialogs = dialogs;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.eFormId = $stateParams.id;
	    this.model = {};
	    this.$filter = $filter;
	    this.$uibModal = $uibModal;
	
	    this.eFormResult = {
	      form: this.eFormId,
	      data: {},
	      suiteConnection: []
	    };
	
	    this.isLoggedIn = Auth.isLoggedInSync();
	    this.user = Auth.getCurrentUserSync();
	
	    if (this.eFormId) {
	      this.EFormsService.get({ id: this.eFormId }, function (form) {
	        _this.schema = form.formSchema;
	        _this.form = ["*"];
	        _this.title = form.name;
	        _this.description = form.description;
	        _this.recipients = form.recipients;
	        _this.signatureRequired = form.signatureRequired;
	
	        _this.fields = form.fields;
	
	        form.fields.forEach(function (field) {
	          if (field.type === 'recipient') {
	            _this.recipientField = field.key;
	          }
	
	          if (field.prefill && field.prefilled) {
	            var _field$prefilled$spli = field.prefilled.split(":"),
	                _field$prefilled$spli2 = _slicedToArray(_field$prefilled$spli, 2),
	                group = _field$prefilled$spli2[0],
	                value = _field$prefilled$spli2[1];
	
	            switch (group) {
	              case 'name':
	
	                if (_this.isLoggedIn && _this.user) {
	
	                  switch (value) {
	                    case 'first':
	                      _this.model[field.key] = _this.user.firstName;
	                      break;
	                    case 'last':
	                      _this.model[field.key] = _this.user.lastName;
	                      break;
	                    case 'full':
	
	                      var name = _this.user.firstName;
	                      if (_this.user.middleName) name += " " + _this.user.middleName;
	                      name += " " + _this.user.lastName;
	
	                      _this.model[field.key] = name;
	                      break;
	                  }
	                }
	
	                break;
	              case 'profile':
	
	                if (_this.isLoggedIn && _this.user) {
	
	                  switch (value) {
	                    case 'email':
	                      _this.model[field.key] = _this.user.email;
	                      break;
	                    case 'phone':
	                      if (_this.user.profile.phone && _this.user.profile.phone.length) {
	                        _this.model[field.key] = _this.user.profile.phone[0].number;
	                      }
	                      break;
	                    case 'address':
	                      if (_this.user.profile.address && _this.user.profile.address.length) {
	                        var oAdr = [];
	                        var adr = _this.user.profile.address[0];
	
	                        oAdr.push(adr.street);
	                        oAdr.push(", ");
	                        if (adr.street2) {
	                          oAdr.push(adr.street2);
	                          oAdr.push(", ");
	                        }
	                        oAdr.push(adr.city);
	                        oAdr.push(", ");
	                        oAdr.push(adr.state);
	                        oAdr.push(" ");
	                        oAdr.push(adr.zip);
	                        if (adr.country) {
	                          oAdr.push(", ");
	                          oAdr.push(adr.country);
	                        }
	
	                        _this.model[field.key] = oAdr.join("");
	                      }
	                      break;
	                  }
	                }
	
	                break;
	              case 'date':
	                _this.model[field.key] = _this.$filter('date')(new Date(), value);
	                break;
	            }
	          }
	        });
	      }, function (_) {
	        console.log("Could not load e-form schema from server");
	        _this.formNotFound = true;
	      });
	    }
	  }
	
	  _createClass(EFormComponent, [{
	    key: 'create',
	    value: function create(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var filterRecipients = function filterRecipients(recipient, group) {
	        var splitted = recipient.split("|");
	        if (splitted.length === 2) {
	          if (!group) {
	            return true;
	          } else {
	            return splitted[1].trim() === group.trim();
	          }
	        } else {
	          return true;
	        }
	      };
	
	      var mapRecipients = function mapRecipients(recipient) {
	        var splitted = recipient.split("|");
	
	        return splitted.length === 2 ? splitted[0].trim() : recipient.trim();
	      };
	
	      var that = this;
	
	      this.$scope.$broadcast('schemaFormValidate');
	
	      if (form.$valid) {
	        var onSuccess = function onSuccess() {
	          var dlg = _this2.dialogs.notify("Success", "The form has been sent successfully");
	          dlg.result.then(function () {
	            that.sendSuccess = true;
	          });
	        };
	
	        var onError = function onError(err) {
	          _this2.sendFailure = true;
	        };
	
	        this.eFormResult.data = this.model;
	
	        this.eFormResult.recipients = this.recipients.filter(function (recipient) {
	          return filterRecipients(recipient, _this2.model[_this2.recipientField]);
	        }).map(function (recipient) {
	          return mapRecipients(recipient);
	        });
	
	        this.fields.forEach(function (field) {
	          if (field.type == 'unit' && _this2.model[field.key]) {
	            _this2.eFormResult.suiteConnection.push({
	              key: field.key,
	              label: field.title,
	              type: 'unit',
	              communityId: field.communityId,
	              value: _this2.model[field.key],
	              copyToPrimaryOwner: field.copyToPrimaryOwner
	            });
	          }
	        });
	
	        if (this.signatureRequired) {
	
	          var that = this;
	
	          var modalInstance = this.$uibModal.open({
	            animation: true,
	            component: 'signatureModal',
	            resolve: {
	              config: function config() {
	                return {};
	              }
	            }
	          });
	
	          modalInstance.result.then(function (signatureImage) {
	            that.eFormResult.data.signature = signatureImage;
	
	            var FN_SAVE = that.isLoggedIn ? "save" : "savePublic";
	
	            that.EFormResultsService[FN_SAVE](that.eFormResult, onSuccess, onError);
	          }, function () {});
	        } else {
	          var FN_SAVE = that.isLoggedIn ? "save" : "savePublic";
	
	          this.EFormResultsService[FN_SAVE](this.eFormResult, onSuccess, onError);
	        }
	      }
	    }
	  }]);
	
	  return EFormComponent;
	}();
	
	exports.default = angular.module('conduu.eForms.eForm', [uiRouter]).config(_eForm2.default).component('eForm', {
	  template: __webpack_require__(827),
	  controller: EFormComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('e-form', {
	    url: '/e-form/:id',
	    template: '<e-form></e-form>'
	  });
	}];

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <h2>{{ctrl.title}}</h2>\n    </ol>\n\n    <div class=\"col-xs-12\">\n\n      <div ng-show=\"ctrl.sendSuccess\" class=\"alert alert-success\" role=\"alert\">\n        <strong>Success!</strong> <br/>\n        Your form was submitted successfully.\n      </div>\n\n      <div ng-hide=\"ctrl.sendSuccess\">\n        <p ng-if=\"ctrl.description\" ng-bind-html=\"ctrl.description\"></p>\n\n        <div ng-if=\"ctrl.formNotFound\" class=\"alert alert-dismissible alert-warning\">\n          <i class=\"fa fa-fw fa-4x fa-meh-o\" style=\"float:left\"></i>\n          <h4>Oops! Form Not Found</h4>\n          <p>The e-Form you are looking for is not (longer) available.</p>\n        </div>\n\n        <form ng-if=\"ctrl.schema\" name=\"form\" ng-submit=\"ctrl.create(form)\">\n\n          <div sf-schema=\"ctrl.schema\" sf-form=\"ctrl.form\" sf-model=\"ctrl.model\"\n               sf-options=\"{ formDefaults: { feedback: false }}\"></div>\n\n          <br/>\n\n          <button ng-show=\"ctrl.signatureRequired\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-pencil-square-o\"></i> Sign & Submit</button>\n          <button ng-hide=\"ctrl.signatureRequired\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-send-o\"></i> Submit</button>\n        </form>\n      </div>\n\n    </div>\n\n  </div>\n</div>\n\n"

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EFormBrowserComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eFormBrowser = __webpack_require__(829);
	
	var _eFormBrowser2 = _interopRequireDefault(_eFormBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var EFormBrowserComponent = exports.EFormBrowserComponent = function () {
	  EFormBrowserComponent.$inject = ['EFormsService', 'Auth', '$state', 'dialogs', '$stateParams', '$uibModal', 'EFormResultsService', '$scope', '$filter'];
	  function EFormBrowserComponent(EFormsService, Auth, $state, dialogs, $stateParams, $uibModal, EFormResultsService, $scope, $filter) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, EFormBrowserComponent);
	
	    this.EFormsService = EFormsService;
	    this.EFormResultsService = EFormResultsService;
	    this.dialogs = dialogs;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.eFormId = $stateParams.id;
	    this.model = {};
	    this.$filter = $filter;
	    this.$uibModal = $uibModal;
	
	    this.cursor = 0;
	    this.maxCursor = 0;
	
	    this.data = [];
	
	    this.systemFormSchemas = {
	      "contact": {
	        "required": [],
	        "properties": {
	          "firstName": {
	            "type": "string",
	            "key": "firstName",
	            "title": "First Name"
	          },
	          "lastName": {
	            "type": "string",
	            "key": "lastName",
	            "title": "Last Name"
	          },
	          "email": {
	            "type": "string",
	            "key": "email",
	            "title": "Email"
	          },
	          "phone": {
	            "type": "string",
	            "key": "phone",
	            "title": "Phone"
	          },
	          "message": {
	            "x-schema-form": {
	              "type": "textarea"
	            },
	            "type": "string",
	            "key": "message",
	            "title": "Your Message"
	          }
	        },
	        "type": "object"
	      },
	      "feedback": {
	        "required": [],
	        "properties": {
	          "name": {
	            "type": "string",
	            "key": "name",
	            "title": "Name"
	          },
	          "email": {
	            "type": "string",
	            "key": "email",
	            "title": "Email"
	          },
	          "feedback": {
	            "x-schema-form": {
	              "type": "textarea"
	            },
	            "type": "string",
	            "key": "feedback",
	            "title": "Feedback"
	          }
	        },
	        "type": "object"
	      }
	    };
	
	    this.systemFormFields = {
	      "contact": [{ "type": "text", "title": "First Name", "key": "firstName" }, { "type": "text", "title": "Last Name", "key": "lastName" }, { "type": "text", "title": "Email", "key": "email" }, { "type": "text", "title": "phone", "key": "phone" }, { "type": "textbox", "title": "Your Message", "key": "message" }],
	      "feedback": [{ "type": "text", "title": "Name", "key": "name" }, { "type": "text", "title": "Email", "key": "email" }, { "type": "textbox", "title": "Feedback", "key": "feedback" }]
	    };
	
	    if (this.eFormId) {
	      if (this.eFormId == 'contact' || this.eFormId == 'feedback') {
	
	        this.schema = this.systemFormSchemas[this.eFormId];
	        this.form = ["*"];
	        this.title = this.eFormId + " Form";
	        this.description = "Responses of the " + this.title;
	
	        this.csvHeader = this.systemFormFields[this.eFormId].map(function (field) {
	          return field.title;
	        });
	        this.csvOrder = this.systemFormFields[this.eFormId].map(function (field) {
	          return field.key;
	        });
	
	        this.imgFields = [];
	
	        this.EFormResultsService.getBySystemForm({ name: this.eFormId }, function (data) {
	          _this.data = data.reverse();
	          _this.maxCursor = _this.data.length ? _this.data.length - 1 : 0;
	          _this.move("first");
	        });
	      } else {
	        this.EFormsService.get({ id: this.eFormId }, function (form) {
	          _this.schema = form.formSchema;
	          _this.form = ["*"];
	          _this.title = form.name;
	          _this.description = form.description;
	          _this.signatureRequired = form.signatureRequired;
	
	          _this.csvHeader = form.fields.map(function (field) {
	            return field.title;
	          }).filter(function (title) {
	            return !title.startsWith("_");
	          });
	          _this.csvOrder = form.fields.map(function (field) {
	            return field.key;
	          }).filter(function (key) {
	            return !key.startsWith("_");
	          });
	
	          _this.imgFields = form.fields.filter(function (field) {
	            return field.type == 'image';
	          });
	          _this.imgFields.forEach(function (field) {
	            var key = field.key;
	            var ppty = _this.schema.properties[key];
	            ppty.type = 'string';
	            delete ppty.format;
	            ppty["x-schema-form"].type = 'help';
	            ppty["x-schema-form"].helpvalue = "";
	          });
	
	          _this.EFormResultsService.getByForm({ id: _this.eFormId }, function (data) {
	            _this.data = data.reverse();
	            _this.maxCursor = _this.data.length ? _this.data.length - 1 : 0;
	            _this.move("first");
	          });
	        }, function (_) {
	          console.log("Could not load e-form schema from server");
	          _this.formNotFound = true;
	        });
	      }
	    }
	  }
	
	  _createClass(EFormBrowserComponent, [{
	    key: 'openExportModal',
	    value: function openExportModal() {
	      var _this2 = this;
	
	      var data = this.data.map(function (response) {
	        return response.data;
	      });
	
	      var exportData = data.map(function (response) {
	        var row = [];
	        _this2.csvOrder.forEach(function (key) {
	          return row.push(response[key]);
	        });
	        return row;
	      });
	
	      this.$uibModal.open({
	        animation: true,
	        component: 'datatableViewer',
	        resolve: {
	          config: function config() {
	            return {
	              data: exportData,
	              settings: {
	                "columns": _this2.csvHeader
	              },
	              name: _this2.title
	            };
	          }
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var _this3 = this;
	
	      var that = this;
	
	      var eformText = "<b>" + this.$filter('date')(this.model.meta.creationDate, 'MMM d, y h:mm a') + "</b>";
	      var dlg = this.dialogs.confirm("Delete E-Form Response?", "Do you really want to delete the e-form response dated " + eformText + "?");
	      dlg.result.then(function () {
	
	        that.EFormResultsService.delete({ id: _this3.model._id }, function () {
	          that.data = that.data.filter(function (obj) {
	            return obj._id !== that.model._id;
	          });
	
	          that.maxCursor--;
	          _this3.move("first");
	        }, function (err) {
	          alert("Could not delete e-form response");
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'move',
	    value: function move(pos) {
	      var _this4 = this;
	
	      switch (pos) {
	        case 'first':
	          this.cursor = 0;
	          break;
	        case 'prev':
	          this.cursor--;
	          break;
	        case 'next':
	          this.cursor++;
	          break;
	        case 'last':
	          this.cursor = this.maxCursor;
	          break;
	      }
	
	      this.model = this.data[this.cursor];
	
	      if (this.imgFields.length) {
	        this.imgFields.forEach(function (field) {
	          var key = field.key;
	          var label = "<label class='control-label'>" + _this4.schema.properties[key].title + "</label><br/>";
	          var value = "-";
	
	          if (_this4.model.data[key]) {
	            var imgPath = "/api/storage/" + _this4.model.data[key];
	            value = "<a target='_blank' href='" + imgPath + "'><img src='" + imgPath + "/thumb' /></a><br/><span style='font-weight:normal;font-size:x-small'>(Preview - Click to enlarge)</span>";
	          }
	
	          _this4.schema.properties[key]["x-schema-form"].helpvalue = label + value;
	        });
	
	        this.$scope.$broadcast('schemaFormRedraw');
	      }
	    }
	  }]);
	
	  return EFormBrowserComponent;
	}();
	
	exports.default = angular.module('conduu.eForms.eFormBrowser', [uiRouter]).config(_eFormBrowser2.default).component('eFormBrowser', {
	  template: __webpack_require__(830),
	  controller: EFormBrowserComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('e-form-browser', {
	    url: '/e-form/data-browser/:id',
	    template: '<e-form-browser></e-form-browser>',
	    authenticate: 'suite-admin'
	  });
	}];

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <button type=\"button\" class=\"btn btn-primary\" style=\"float:right; margin-top:16px\" ng-click=\"ctrl.openExportModal()\"><i class=\"fa fa-download\"></i> Export</button>\n\n      <h2>{{ctrl.title}}</h2>\n      <li><a href=\"/e-form/list\">E-Forms</a></li>\n      <li class=\"active\"><a href=\"#\">{{ctrl.title}}</a></li>\n      <li class=\"active\"><a href=\"#\">Data Browser</a></li>\n    </ol>\n\n    <div class=\"col-xs-12\">\n\n      <div style=\"width:100%; text-align: center;\">\n        <button ng-disabled=\"ctrl.cursor == 0\" class=\"btn btn-sm btn-primary\" style=\"float:left\" ng-click=\"ctrl.move('first')\"><i class=\"fa fa-fw fa-fast-backward\"></i></button>\n        <button ng-disabled=\"!ctrl.data.length || ctrl.cursor == 0\" class=\"btn btn-sm btn-primary\" style=\"float:left\" ng-click=\"ctrl.move('prev')\"><i class=\"fa fa-fw fa-backward\"></i></button>\n\n        <span class=\"label label-primary\" style=\"font-size:larger\">{{ctrl.cursor+1}} of {{ctrl.maxCursor+1}}</span> | <span class=\"label label-primary\" style=\"font-size:larger\">{{ctrl.model.meta.creationDate | date:'MMM d, y h:mm a'}}</span> | <button class=\"btn btn-danger btn-sm\" title=\"Delete\" ng-click=\"ctrl.delete()\"><i class=\"fa fa-trash\"></i></button>\n\n        <button ng-disabled=\"!ctrl.data.length || ctrl.cursor == ctrl.maxCursor\" class=\"btn btn-sm btn-primary\" style=\"float:right\" ng-click=\"ctrl.move('last')\"><i class=\"fa fa-fw fa-fast-forward\"></i></button>\n        <button ng-disabled=\"ctrl.cursor == ctrl.maxCursor\" class=\"btn btn-sm btn-primary\" style=\"float:right\" ng-click=\"ctrl.move('next')\"><i class=\"fa fa-fw fa-forward\"></i></button>\n      </div>\n\n      <hr/>\n      <br/>\n\n      <div sf-schema=\"ctrl.schema\" sf-form=\"ctrl.form\" sf-model=\"ctrl.model.data\"\n           sf-options=\"{ formDefaults: { readonly: true, feedback: false }}\"></div>\n\n      <div ng-if=\"ctrl.signatureRequired && ctrl.model.data.signature\">\n        <label>Signature</label>\n        <br/>\n        <img ng-src=\"{{ctrl.model.data.signature}}\" />\n      </div>\n\n    </div>\n\n  </div>\n</div>\n\n"

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EFormsService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EFormsService = EFormsService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function EFormsService($resource) {
	  return $resource('/api/e-forms/:id', {
	    name: '@_id'
	  }, {
	    update: {
	      method: 'PUT'
	    }
	  });
	}
	
	exports.default = angular.module('conduu.EFormsService', []).factory('EFormsService', EFormsService).name;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EFormResultsService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EFormResultsService = EFormResultsService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function EFormResultsService($resource) {
	  return $resource('/api/e-form-results/:id', {
	    name: '@_id'
	  }, {
	    getByForm: {
	      method: 'GET',
	      url: "/api/e-form-results/form/:id",
	      isArray: true
	    },
	    getBySystemForm: {
	      method: 'GET',
	      url: "/api/e-form-results/system-form/:name",
	      isArray: true
	    },
	    queryBySuiteConnectionProperty: {
	      method: 'GET',
	      url: "/api/e-form-results/get-by-suite-connection/property/:propertyId",
	      isArray: true
	    },
	    savePublic: {
	      method: 'POST',
	      url: "/api/e-form-results/public"
	    }
	  });
	}
	
	exports.default = angular.module('conduu.EFormResultsService', []).factory('EFormResultsService', EFormResultsService).name;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var signatureModalComponent = exports.signatureModalComponent = function () {
	  /*@ngInject*/
	  function signatureModalComponent() {
	    _classCallCheck(this, signatureModalComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	      this.instructions = this.config.instructions;
	    };
	
	    this.disabled = false;
	  }
	
	  _createClass(signatureModalComponent, [{
	    key: 'ok',
	    value: function ok() {
	
	      this.close({ $value: this.signature.dataUrl });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return signatureModalComponent;
	}();
	
	exports.default = angular.module('conduApp.signatureModal', []).component('signatureModal', {
	  template: __webpack_require__(834),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: signatureModalComponent
	}).name;

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\"><i class=\"fa fa-fw fa-pencil-square-o\"></i> Sign</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <signature-pad accept=\"accept\" clear=\"clear\" height=\"220\" width=\"568\" disabled=\"$ctrl.disabled\"></signature-pad>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" style=\"float:left\" type=\"button\" ng-click=\"clear(); $ctrl.signature = undefined; $ctrl.disabled = false\"><i class=\"fa fa-fw fa-times\"></i>Clear</button>\r\n  <button class=\"btn btn-primary\" style=\"float:left\" type=\"button\" ng-disabled=\"$ctrl.signature.dataUrl\" ng-click=\"$ctrl.signature = accept(); $ctrl.disabled = true\"><i class=\"fa fa-fw fa-check\"></i>Accept</button>\r\n\r\n\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!$ctrl.signature.dataUrl || $ctrl.signature.isEmpty\" ng-click=\"$ctrl.ok()\"><i class=\"fa fa-fw fa-paper-plane-o\"></i>Submit</button>\r\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	/*
	 * https://github.com/legalthings/signature-pad-angular
	 * Copyright (c) 2015 ; Licensed MIT
	 */
	
	angular.module('signature', []);
	
	angular.module('signature').directive('signaturePad', ['$interval', '$timeout', '$window',
	  function ($interval, $timeout, $window) {
	    'use strict';
	
	    var signaturePad, element, EMPTY_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjgAAADcCAQAAADXNhPAAAACIklEQVR42u3UIQEAAAzDsM+/6UsYG0okFDQHMBIJAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHADDAQwHMBwAwwEMB8BwAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEwHMBwAMMBMBzAcAAMBzAcwHAADAcwHADDAQwHMBwAwwEMB8BwAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcCQADAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHMBwAAwHMBwAwwEMBzAcAMMBDAfAcADDAQwHwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHMBwAAwHMBwAwwEMB8BwAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDkQAwHMBwAAwHMBwAwwEMBzAcAMMBDAfAcADDAQwHwHAAwwEwHMBwAMMBMBzAcAAMBzAcwHAADAcwHADDAQwHMBwAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHMBwAAwHMBwAwwEMBzAcAMMBDAegeayZAN3dLgwnAAAAAElFTkSuQmCC';
	
	    return {
	      restrict: 'EA',
	      replace: true,
	      template: '<div class="signature" style="width: 100%; max-width:{{width}}px; height: 100%; max-height:{{height}}px;"><canvas style="display: block; margin: 0 auto;" ng-mouseup="onMouseup()" ng-mousedown="notifyDrawing({ drawing: true })"></canvas></div>',
	      scope: {
	        accept: '=?',
	        clear: '=?',
	        disabled: '=?',
	        dataurl: '=?',
	        height: '@',
	        width: '@',
	        notifyDrawing: '&onDrawing',
	      },
	      controller: [
	        '$scope',
	        function ($scope) {
	          $scope.accept = function () {
	
	            return {
	              isEmpty: $scope.dataurl === EMPTY_IMAGE,
	              dataUrl: $scope.dataurl
	            };
	          };
	
	          $scope.onMouseup = function () {
	            $scope.updateModel();
	
	            // notify that drawing has ended
	            $scope.notifyDrawing({ drawing: false });
	          };
	
	          $scope.updateModel = function () {
	            /*
	             defer handling mouseup event until $scope.signaturePad handles
	             first the same event
	             */
	            $timeout().then(function () {
	              $scope.dataurl = $scope.signaturePad.isEmpty() ? EMPTY_IMAGE : $scope.signaturePad.toDataURL();
	            });
	          };
	
	          $scope.clear = function () {
	            $scope.signaturePad.clear();
	            $scope.dataurl = EMPTY_IMAGE;
	          };
	
	          $scope.$watch("dataurl", function (dataUrl) {
	            if (!dataUrl || $scope.signaturePad.toDataURL() === dataUrl) {
	              return;
	            }
	
	            $scope.setDataUrl(dataUrl);
	          });
	        }
	      ],
	      link: function (scope, element, attrs) {
	        var canvas = element.find('canvas')[0];
	        var parent = canvas.parentElement;
	        var scale = 0;
	        var ctx = canvas.getContext('2d');
	
	        var width = parseInt(scope.width, 10);
	        var height = parseInt(scope.height, 10);
	
	        canvas.width = width;
	        canvas.height = height;
	
	        scope.signaturePad = new SignaturePad(canvas);
	
	        scope.setDataUrl = function(dataUrl) {
	          var ratio = Math.max(window.devicePixelRatio || 1, 1);
	
	          ctx.setTransform(1, 0, 0, 1, 0, 0);
	          ctx.scale(ratio, ratio);
	
	          scope.signaturePad.clear();
	          scope.signaturePad.fromDataURL(dataUrl);
	
	          $timeout().then(function() {
	            ctx.setTransform(1, 0, 0, 1, 0, 0);
	            ctx.scale(1 / scale, 1 / scale);
	          });
	        };
	
	        scope.$watch('disabled', function (val) {
	            val ? scope.signaturePad.off() : scope.signaturePad.on();
	        });
	        
	        var calculateScale = function() {
	          var scaleWidth = Math.min(parent.clientWidth / width, 1);
	          var scaleHeight = Math.min(parent.clientHeight / height, 1);
	
	          var newScale = Math.min(scaleWidth, scaleHeight);
	
	          if (newScale === scale) {
	            return;
	          }
	
	          var newWidth = width * newScale;
	          var newHeight = height * newScale;
	          canvas.style.height = Math.round(newHeight) + "px";
	          canvas.style.width = Math.round(newWidth) + "px";
	
	          scale = newScale;
	          ctx.setTransform(1, 0, 0, 1, 0, 0);
	          ctx.scale(1 / scale, 1 / scale);
	        };
	
	        var resizeIH = $interval(calculateScale, 200);
	        scope.$on('$destroy', function () {
	          $interval.cancel(resizeIH);
	          resizeIH = null;
	        });
	
	        angular.element($window).bind('resize', calculateScale);
	        scope.$on('$destroy', function () {
	          angular.element($window).unbind('resize', calculateScale);
	        });
	
	        calculateScale();
	
	        element.on('touchstart', onTouchstart);
	        element.on('touchend', onTouchend);
	
	        function onTouchstart(event) {
	          scope.$apply(function () {
	            // notify that drawing has started
	            scope.notifyDrawing({ drawing: true });
	          });
	          event.preventDefault();
	        }
	
	        function onTouchend(event) {
	          scope.$apply(function () {
	            // updateModel
	            scope.updateModel();
	
	            // notify that drawing has ended
	            scope.notifyDrawing({ drawing: false });
	          });
	          event.preventDefault();
	        }
	      }
	    };
	  }
	]);
	
	// Backward compatibility
	angular.module('ngSignaturePad', ['signature']);


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var eformResultModalComponent = exports.eformResultModalComponent = function () {
	  /*@ngInject*/
	  eformResultModalComponent.$inject = ['EFormsService', 'Auth', '$state', 'dialogs', '$filter', '$stateParams', '$uibModal', 'EFormResultsService', '$scope'];
	  function eformResultModalComponent(EFormsService, Auth, $state, dialogs, $filter, $stateParams, $uibModal, EFormResultsService, $scope) {
	    _classCallCheck(this, eformResultModalComponent);
	
	    this.EFormsService = EFormsService;
	    this.EFormResultsService = EFormResultsService;
	    this.dialogs = dialogs;
	    this.$state = $state;
	    this.$scope = $scope;
	
	    this.model = {};
	
	    this.eFormResult = {
	      data: {}
	    };
	
	    this.isLoggedIn = Auth.isLoggedInSync();
	    this.user = Auth.getCurrentUserSync();
	  }
	
	  _createClass(eformResultModalComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.config = this.resolve.config;
	
	      if (this.config.eFormId && this.config.eFormResultId) {
	        this.EFormsService.get({ id: this.config.eFormId }, function (form) {
	          _this.schema = form.formSchema;
	          _this.form = ["*"];
	          _this.title = form.name;
	          _this.description = form.description;
	          _this.signatureRequired = form.signatureRequired;
	
	          _this.imgFields = form.fields.filter(function (field) {
	            return field.type == 'image';
	          });
	          _this.imgFields.forEach(function (field) {
	            var key = field.key;
	            var ppty = _this.schema.properties[key];
	            ppty.type = 'string';
	            delete ppty.format;
	            ppty["x-schema-form"].type = 'help';
	            ppty["x-schema-form"].helpvalue = "";
	          });
	
	          _this.EFormResultsService.get({ id: _this.config.eFormResultId }, function (eformResult) {
	            _this.model = eformResult;
	
	            if (_this.imgFields.length) {
	              _this.imgFields.forEach(function (field) {
	                var key = field.key;
	                var label = "<label class='control-label'>" + _this.schema.properties[key].title + "</label><br/>";
	                var value = "-";
	
	                if (_this.model.data[key]) {
	                  var imgPath = "/api/storage/" + _this.model.data[key];
	                  value = "<a target='_blank' href='" + imgPath + "'><img src='" + imgPath + "/thumb' /></a><br/><span style='font-weight:normal;font-size:x-small'>(Preview - Click to enlarge)</span>";
	                }
	
	                _this.schema.properties[key]["x-schema-form"].helpvalue = label + value;
	              });
	
	              _this.$scope.$broadcast('schemaFormRedraw');
	            }
	          });
	        }, function (_) {
	          console.log("Could not load e-form schema from server");
	          _this.formNotFound = true;
	        });
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return eformResultModalComponent;
	}();
	
	exports.default = angular.module('conduu.eFormResultModal', []).component('eFormResultModal', {
	  template: __webpack_require__(837),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: eformResultModalComponent
	}).name;

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">{{$ctrl.title}}</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n\r\n  <div sf-schema=\"$ctrl.schema\" sf-form=\"$ctrl.form\" sf-model=\"$ctrl.model.data\"\r\n       sf-options=\"{ formDefaults: { readonly: true, feedback: false }}\"></div>\r\n\r\n  <div ng-if=\"$ctrl.signatureRequired && $ctrl.model.data.signature\">\r\n    <label>Signature</label>\r\n    <br/>\r\n    <img ng-src=\"{{$ctrl.model.data.signature}}\" />\r\n  </div>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <label class=\"pull-left text-left\" style=\"margin: 0; position: relative; top: -6px;\">\r\n    Created at<br/>\r\n    <span class=\"label label-primary\">{{$ctrl.model.meta.creationDate | date:'MMM d, y h:mm a'}}</span>\r\n  </label>\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.cancel()\"><i class=\"fa fa-fw fa-window-close\"></i> Close</button>\r\n</div>\r\n"

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MailComposerComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mailComposer = __webpack_require__(839);
	
	var _mailComposer2 = _interopRequireDefault(_mailComposer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var MailComposerComponent = exports.MailComposerComponent = function () {
	  MailComposerComponent.$inject = ['Auth', '$q', 'Upload', 'prompt', 'dialogs', 'StorageService', 'MailsService', '$uibModal', '$state', '$stateParams', '$location', 'SettingsService'];
	  function MailComposerComponent(Auth, $q, Upload, prompt, dialogs, StorageService, MailsService, $uibModal, $state, $stateParams, $location, SettingsService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, MailComposerComponent);
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.MailsService = MailsService;
	    this.$state = $state;
	    this.Auth = Auth;
	    this.$location = $location;
	    this.StorageService = StorageService;
	    this.SettingsService = SettingsService;
	    this.Upload = Upload;
	    this.prompt = prompt;
	    this.$q = $q;
	    this.assets = [];
	
	    this.hideViewOnline = false;
	
	    this.totalAttachmentSize = function (_) {
	      return _this.assets.reduce(function (totalSize, asset) {
	        return totalSize + asset.size;
	      }, 0);
	    };
	
	    this.SettingsService.getByName({ name: 'config.platform' }, function (setting) {
	      _this.baseUrl = setting.data.baseURL;
	    });
	
	    this.templates = [];
	
	    this.SettingsService.getByName({ name: 'default-mailblast-templates' }, function (setting) {
	      _this.templates = _this.templates.concat(setting.data.map(function (template) {
	        template.type = 'Default Templates';return template;
	      }));
	    });
	
	    this.sortableOptions = {
	      handle: '.handle'
	    };
	
	    var that = this;
	
	    this.dropHandler = function (file, insertAction) {
	
	      var isImage = that.isImageMime(file.type);
	      var isPdf = that.isPdfMime(file.type);
	
	      if (!isImage && !isPdf) {
	        return;
	      }
	
	      var defer = that.$q.defer();
	
	      that.Upload.upload({
	        url: '/api/storage',
	        data: {
	          name: file.name,
	          file: file,
	          storageStrategy: 'local',
	          isPublic: true,
	          creationUser: that.Auth.getCurrentUserSync()._id,
	          active: true
	        }
	      }).then(function (response) {
	
	        if (isImage) {
	          insertAction("insertImage", that.baseUrl + "/api/storage/" + response.data, true);
	          defer.resolve(true);
	        } else if (isPdf) {
	          that.StorageService.getMeta({ id: response.data }, function (data) {
	
	            that.prompt({
	              title: 'Define Link Text',
	              message: 'What would you like to name the link to the file?',
	              input: true,
	              value: data.filename
	            }).then(function (name) {
	
	              insertAction('insertHTML', '<a target="_blank" href="' + that.baseUrl + '/api/storage/' + data._id + '">' + name + '</a><br/>');
	
	              defer.resolve(true);
	            }, function () {
	              defer.reject();
	            });
	          }, function (err) {
	            console.log('could not retrieved storage from server');
	            defer.reject();
	          });
	        }
	      }, function (response) {
	        if (response.status > 0) {
	          alert(response.status + ': ' + response.data);
	          defer.reject();
	        }
	      });
	
	      return defer.promise;
	    };
	
	    this.optionsImagesPerRow = [1, 2, 3, 4];
	
	    this.mailId = $stateParams.id;
	
	    this.mail = {
	      subject: '',
	      sections: [],
	      body: "",
	      type: 'draft',
	      meta: {
	        creationUser: Auth.getCurrentUserSync()._id,
	        active: true
	      }
	    };
	
	    if (this.mailId) {
	      this.MailsService.get({ id: this.mailId }, function (data) {
	        _this.mail = data;
	        _this.assets = data.attachments;
	
	        _this.assets.forEach(function (asset) {
	          _this.StorageService.getFileSize({ id: asset._id }, function (data2) {
	            asset.size = 4 * (data2.size / 3);
	          });
	        });
	
	        _this.SettingsService.getByName({ name: 'default-mailblast-templates' }, function (setting) {
	
	          var idx = setting.data.findIndex(function (template) {
	            return template.name == _this.mail.template;
	          });
	          var template = setting.data[idx];
	
	          _this.generateDefaultMailTemplate(template);
	        });
	      }, function (err) {
	        console.log('Could not load mail from server');
	      });
	    }
	
	    this.toolbarDefinition = [["bold", "italics", "underline"], ["h3", "h4", "h5"], ["p", "quote", "clear"], ["ul", "ol"], ["insertLink"], ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"], ["indent", "outdent"], ["undo", "redo"], ["backgroundColor", "fontColor", "fontName", "fontSize"]];
	  }
	
	  _createClass(MailComposerComponent, [{
	    key: 'isImageMime',
	    value: function isImageMime(mime) {
	      return mime.startsWith('image/');
	    }
	  }, {
	    key: 'isPdfMime',
	    value: function isPdfMime(mime) {
	      return mime === 'application/pdf';
	    }
	  }, {
	    key: 'removeAttachment',
	    value: function removeAttachment(idx) {
	      this.assets.splice(idx, 1);
	    }
	  }, {
	    key: 'generateDefaultMailTemplate',
	    value: function generateDefaultMailTemplate(template) {
	      var html = ['<p style="font-size: 12pt;text-align: center;text-align: center;"><a href="{tmpl:mailurl}" style="font-size: 13px;">Click here</a><span style="font-size: 13px;float: none;"> to view this online</span><br></p>'];
	
	      if (this.hideViewOnline) html = [];
	
	      var imageUrl = "https://s3.amazonaws.com/conduu-cdn/mail/mailblast/" + template.filename;
	
	      switch (template.style) {
	        case 'full':
	          html.push('<p><img src="' + imageUrl + '" style="width: 100%;"></p>');
	          break;
	        case 'center':
	        default:
	          html.push('<h1 style="text-align: center;"><img src="' + imageUrl + '">​</h1>');
	          break;
	      }
	
	      html.push('<p style="text-align: left;font-size: 12pt;">{tmpl:section-start}</p><div><div class="WordSection1"><p style="font-size: 12pt;"><b><span style="font-size: 15pt;">{tmpl:section-heading}</span></b><b><span style="font-size: 15pt;"> </span></b><span style="font-size: 15pt;">&nbsp;{tmpl:section-content}</span></p></div></div> <p style="text-align: left;font-size: 12pt;">{tmpl:section-end}</p>');
	
	      this.mailtemplate = html.join('');
	    }
	  }, {
	    key: 'templateChanged',
	    value: function templateChanged() {
	      var _this2 = this;
	
	      var idx = this.templates.findIndex(function (template) {
	        return template.name == _this2.mail.template;
	      });
	      var template = this.templates[idx];
	
	      this.generateDefaultMailTemplate(template);
	      this.generateMailBody();
	    }
	  }, {
	    key: 'addSection',
	    value: function addSection() {
	
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'mailComposerSectionSelectorComponent',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'sm'
	      });
	
	      modalInstance.result.then(function (sectionType) {
	
	        if (sectionType == 'images') {
	          that.mail.sections.push({
	            type: sectionType,
	            imagesPerRow: 2,
	            images: [],
	            heading: '',
	            content: ''
	          });
	        } else {
	          that.mail.sections.push({
	            type: sectionType,
	            heading: '',
	            content: ''
	          });
	        }
	      }, function () {});
	    }
	  }, {
	    key: 'addTextBlock',
	    value: function addTextBlock() {
	      this.mail.sections.push({
	        type: 'html',
	        heading: '',
	        content: ''
	      });
	    }
	  }, {
	    key: 'addImageBlock',
	    value: function addImageBlock() {
	      this.mail.sections.push({
	        type: 'images',
	        imagesPerRow: 2,
	        images: [],
	        heading: '',
	        content: ''
	      });
	    }
	  }, {
	    key: 'isImageMime',
	    value: function isImageMime(mime) {
	      return mime.startsWith('image/');
	    }
	  }, {
	    key: 'removeAsset',
	    value: function removeAsset(section, idx) {
	      section.images.splice(idx, 1);
	    }
	  }, {
	    key: 'openAssetBrowserModal',
	    value: function openAssetBrowserModal(section) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetBrowser',
	        resolve: {
	          config: function config() {
	            return {
	              restrictToUserAssets: !that.Auth.isAdminSync(),
	              userId: that.Auth.getCurrentUserSync()._id,
	              restrictToFileTypes: ["image/jpeg", "image/png"],
	              restrictToPublicFiles: true
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (newlySelectedAssets) {
	        section.images = section.images.concat(newlySelectedAssets.map(function (asset) {
	          return {
	            title: '',
	            image: asset._id
	          };
	        }));
	      }, function () {});
	    }
	  }, {
	    key: 'openAssetUploadModal',
	    value: function openAssetUploadModal(section) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {
	              acceptedFileTypes: 'image/*',
	              forcePublic: true
	            };
	          }
	        }
	      });
	
	      modalInstance.result.then(function (result) {
	
	        result.forEach(function (storageId) {
	
	          section.images.push({
	            title: '',
	            image: storageId
	          });
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'deleteSection',
	    value: function deleteSection($event, section, idx) {
	      var _this3 = this;
	
	      $event.stopPropagation();
	
	      var dlg = this.dialogs.confirm("Delete Section?", "Do you really want to delete the section '" + section.heading + "'?");
	      dlg.result.then(function () {
	        _this3.mail.sections.splice(idx, 1);
	      }, function () {});
	    }
	  }, {
	    key: 'create',
	    value: function create(form, preview) {
	      var _this4 = this;
	
	      this.submitted = true;
	      this.sendFailure = false;
	
	      var that = this;
	
	      if (form.$valid) {
	
	        var onSuccess = function onSuccess(data) {
	          _this4.submitted = false;
	
	          if (preview) {
	            that.mailId = data._id;
	            that.openPreviewModal();
	          } else {
	            var actionString = _this4.mailId ? "changed" : "created";
	            var dlg = _this4.dialogs.notify("Success", "The page has been " + actionString + " successfully");
	            dlg.result.then(function () {
	              that.$location.path("/mail/" + that.mail.type + "/list");
	            });
	          }
	        };
	
	        var onError = function onError(err) {
	          _this4.sendFailure = true;
	        };
	
	        this.generateMailBody();
	
	        this.mail.attachments = this.assets.map(function (asset) {
	          return asset._id;
	        });
	
	        if (this.mailId) {
	          this.MailsService.update({ id: this.mailId }, this.mail, onSuccess, onError);
	        } else {
	          this.MailsService.save(this.mail, onSuccess, onError);
	        }
	      }
	    }
	  }, {
	    key: 'generateMailBody',
	    value: function generateMailBody() {
	      var TMPL_TAG_SUBJECT = "{tmpl:subject}";
	      var TMPL_TAG_CONTENT = "{tmpl:content}";
	      var TMPL_TAG_DATE = "{tmpl:date}";
	      var TMPL_TAG_MAIL_URL = "{tmpl:mailurl}";
	
	      var TMPL_TAG_OPEN_SECTION = "{tmpl:section-start}";
	      var TMPL_TAG_CLOSE_SECTION = "{tmpl:section-end}";
	
	      var TMPL_HTML_FRAME = '\n    <!doctype html>\n      <html lang="en">\n      <head>\n        <meta charset="utf-8">\n\n        <title>' + TMPL_TAG_SUBJECT + '</title>\n        <meta name="author" content="CONDUU">\n\n        <link rel="stylesheet" href="css/styles.css?v=1.0">\n\n        <!--[if lt IE 9]>\n          <script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.js"></script>\n        <![endif]-->\n      </head>\n\n      <body>\n        ' + TMPL_TAG_CONTENT + '\n      </body>\n      </html>';
	
	      var TMPL_HTML_FRAME2 = '\n  <!doctype html>\n<html>\n<head>\n    <meta name="viewport" content="width=device-width" />\n    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />\n    <title>{tmpl:subject}</title>\n    <style>\n        /* -------------------------------------\n            GLOBAL RESETS\n        ------------------------------------- */\n        img {\n            border: none;\n            -ms-interpolation-mode: bicubic;\n            max-width: 100%; }\n\n        body {\n            background-color: #f6f6f6;\n            font-family: sans-serif;\n            -webkit-font-smoothing: antialiased;\n            font-size: 14px;\n            line-height: 1.4;\n            margin: 0;\n            padding: 0;\n            -ms-text-size-adjust: 100%;\n            -webkit-text-size-adjust: 100%; }\n\n        table {\n            border-collapse: separate;\n            mso-table-lspace: 0pt;\n            mso-table-rspace: 0pt;\n            width: 100%; }\n        table td {\n            font-family: sans-serif;\n            font-size: 14px;\n            vertical-align: top; }\n\n        /* -------------------------------------\n            BODY & CONTAINER\n        ------------------------------------- */\n\n        .body {\n            background-color: #f6f6f6;\n            width: 100%; }\n\n        /* Set a max-width, and make it display as block so it will automatically stretch to that width, but will also shrink down on a phone or something */\n        .container {\n            display: block;\n            Margin: 0 auto !important;\n            /* makes it centered */\n            max-width: 580px;\n            padding: 10px;\n            width: 580px; }\n\n        /* This should also be a block element, so that it will fill 100% of the .container */\n        .content {\n            box-sizing: border-box;\n            display: block;\n            Margin: 0 auto;\n            max-width: 580px;\n            padding: 10px; }\n\n        /* -------------------------------------\n            HEADER, FOOTER, MAIN\n        ------------------------------------- */\n        .main {\n            background: #ffffff;\n            border-radius: 3px;\n            width: 100%; }\n\n        .wrapper {\n            box-sizing: border-box;\n            padding: 20px; }\n\n        .content-block {\n            padding-bottom: 10px;\n            padding-top: 10px;\n        }\n\n        .footer {\n            clear: both;\n            Margin-top: 10px;\n            text-align: center;\n            width: 100%; }\n        .footer td,\n        .footer p,\n        .footer span,\n        .footer a {\n            color: #999999;\n            font-size: 12px;\n            text-align: center; }\n\n        /* -------------------------------------\n            TYPOGRAPHY\n        ------------------------------------- */\n        h1,\n        h2,\n        h3,\n        h4 {\n            color: #000000;\n            font-family: sans-serif;\n            font-weight: 400;\n            line-height: 1.4;\n            margin: 0;\n            Margin-bottom: 30px; }\n\n        h1 {\n            font-size: 35px;\n            font-weight: 300;\n            text-align: center;\n            text-transform: capitalize; }\n\n        p,\n        ul,\n        ol {\n            font-family: sans-serif;\n            font-size: 14px;\n            font-weight: normal;\n            margin: 0;\n            Margin-bottom: 15px; }\n        p li,\n        ul li,\n        ol li {\n            list-style-position: inside;\n            margin-left: 5px; }\n\n        a {\n            color: #3498db;\n            text-decoration: underline; }\n\n        /* -------------------------------------\n            BUTTONS\n        ------------------------------------- */\n        .btn {\n            box-sizing: border-box;\n            width: 100%; }\n        .btn > tbody > tr > td {\n            padding-bottom: 15px; }\n        .btn table {\n            width: auto; }\n        .btn table td {\n            background-color: #ffffff;\n            border-radius: 5px;\n            text-align: center; }\n        .btn a {\n            background-color: #ffffff;\n            border: solid 1px #3498db;\n            border-radius: 5px;\n            box-sizing: border-box;\n            color: #3498db;\n            cursor: pointer;\n            display: inline-block;\n            font-size: 14px;\n            font-weight: bold;\n            margin: 0;\n            padding: 12px 25px;\n            text-decoration: none;\n            text-transform: capitalize; }\n\n        .btn-primary table td {\n            background-color: #3498db; }\n\n        .btn-primary a {\n            background-color: #3498db;\n            border-color: #3498db;\n            color: #ffffff; }\n\n        /* -------------------------------------\n            OTHER STYLES THAT MIGHT BE USEFUL\n        ------------------------------------- */\n        .last {\n            margin-bottom: 0; }\n\n        .first {\n            margin-top: 0; }\n\n        .align-center {\n            text-align: center; }\n\n        .align-right {\n            text-align: right; }\n\n        .align-left {\n            text-align: left; }\n\n        .clear {\n            clear: both; }\n\n        .mt0 {\n            margin-top: 0; }\n\n        .mb0 {\n            margin-bottom: 0; }\n\n        .preheader {\n            color: transparent;\n            display: none;\n            height: 0;\n            max-height: 0;\n            max-width: 0;\n            opacity: 0;\n            overflow: hidden;\n            mso-hide: all;\n            visibility: hidden;\n            width: 0; }\n\n        .powered-by a {\n            text-decoration: none; }\n\n        hr {\n            border: 0;\n            border-bottom: 1px solid #f6f6f6;\n            Margin: 20px 0; }\n\n        /* -------------------------------------\n            RESPONSIVE AND MOBILE FRIENDLY STYLES\n        ------------------------------------- */\n        @media only screen and (max-width: 620px) {\n            table[class=body] h1 {\n                font-size: 28px !important;\n                margin-bottom: 10px !important; }\n            table[class=body] p,\n            table[class=body] ul,\n            table[class=body] ol,\n            table[class=body] td,\n            table[class=body] span,\n            table[class=body] a {\n                font-size: 16px !important; }\n            table[class=body] .wrapper,\n            table[class=body] .article {\n                padding: 10px !important; }\n            table[class=body] .content {\n                padding: 0 !important; }\n            table[class=body] .container {\n                padding: 0 !important;\n                width: 100% !important; }\n            table[class=body] .main {\n                border-left-width: 0 !important;\n                border-radius: 0 !important;\n                border-right-width: 0 !important; }\n            table[class=body] .btn table {\n                width: 100% !important; }\n            table[class=body] .btn a {\n                width: 100% !important; }\n            table[class=body] .img-responsive {\n                height: auto !important;\n                max-width: 100% !important;\n                width: auto !important; }}\n\n        /* -------------------------------------\n            PRESERVE THESE STYLES IN THE HEAD\n        ------------------------------------- */\n        @media all {\n            .ExternalClass {\n                width: 100%; }\n            .ExternalClass,\n            .ExternalClass p,\n            .ExternalClass span,\n            .ExternalClass font,\n            .ExternalClass td,\n            .ExternalClass div {\n                line-height: 100%; }\n            .apple-link a {\n                color: inherit !important;\n                font-family: inherit !important;\n                font-size: inherit !important;\n                font-weight: inherit !important;\n                line-height: inherit !important;\n                text-decoration: none !important; }\n            .btn-primary table td:hover {\n                background-color: #34495e !important; }\n            .btn-primary a:hover {\n                background-color: #34495e !important;\n                border-color: #34495e !important; } }\n\n    </style>\n</head>\n<body class="">\n<table border="0" cellpadding="0" cellspacing="0" class="body">\n    <tr>\n        <td>&nbsp;</td>\n        <td class="container">\n            <div class="content">\n\n                <!-- START CENTERED WHITE CONTAINER -->\n                <span class="preheader"></span>\n\n                <table class="main">\n\n                    <!-- START MAIN CONTENT AREA -->\n                    <tr>\n                        <td class="wrapper">\n                            <table border="0" cellpadding="0" cellspacing="0">\n                                <tr>\n                                    <td>\n                                        {tmpl:content}\n                                    </td>\n                                </tr>\n                            </table>\n                        </td>\n                    </tr>\n                </table>\n\n                <!-- START FOOTER -->\n                <div class="footer">\n                    <table border="0" cellpadding="0" cellspacing="0">\n                        <tr>\n                            <td class="content-block">\n                                <span class="apple-link"><b>Made with <a target=\'_blank\' href="http://conduu.com">CONDUU</a></b><br/><span>IBA Technology Consultants LLC, 1200 Marine Way, North Palm Beach, FL 33408</span></span>\n                            </td>\n                        </tr>\n                    </table>\n\n\n                </div>\n                <!-- END FOOTER -->\n\n\n                <!-- END CENTERED WHITE CONTAINER -->\n            </div>\n        </td>\n        <td>&nbsp;</td>\n    </tr>\n</table>\n</body>\n</html>';
	
	      var dynContent = "";
	
	      var pageTemplate = TMPL_HTML_FRAME2.replace(TMPL_TAG_CONTENT, this.mailtemplate);
	      pageTemplate = pageTemplate.replace(TMPL_TAG_SUBJECT, this.mail.subject);
	      pageTemplate = pageTemplate.replace(TMPL_TAG_DATE, new Date().toLocaleString());
	      pageTemplate = pageTemplate.replace(TMPL_TAG_MAIL_URL, this.baseUrl + '/api/mails/html/' + (this.mailId || 'unavailable'));
	
	      var sectionTemplate = pageTemplate.substring(pageTemplate.lastIndexOf(TMPL_TAG_OPEN_SECTION) + TMPL_TAG_OPEN_SECTION.length, pageTemplate.lastIndexOf(TMPL_TAG_CLOSE_SECTION));
	
	      for (var i = 0; i < this.mail.sections.length; i++) {
	        var html = sectionTemplate;
	
	        var content = "";
	
	        switch (this.mail.sections[i].type) {
	          case 'html':
	            content = this.mail.sections[i].content;
	            break;
	          case 'text':
	            content = this.mail.sections[i].content.split(/\n/).join("<br/>");
	            break;
	          case 'images':
	
	            for (var k = 0; k < this.mail.sections[i].images.length; k++) {
	
	              var baseUrl = this.baseUrl;
	              var oImage = this.mail.sections[i].images[k];
	              var oTitle = oImage.title ? "<br/><em>" + oImage.title + "</em>" : "";
	
	              var imagesPerRow = this.mail.sections[i].imagesPerRow ? this.mail.sections[i].imagesPerRow : 2;
	              var percent = (100 / imagesPerRow).toFixed(2);
	
	              content += '<div style=\'width:' + percent + '%; float:left\'>\n                         <a target=\'_blank\' href=\'' + baseUrl + '/api/storage/' + oImage.image + '\'><img src=\'' + baseUrl + '/api/storage/' + oImage.image + '\' style="width:100%"/></a>' + oTitle + '\n                        </div>';
	            }
	
	            content += "<div style='clear: both'></div>";
	
	            break;
	          default:
	            content = this.mail.sections[i].content;
	        }
	
	        html = html.replace('{tmpl:section-heading}', this.mail.sections[i].heading);
	        html = html.replace('{tmpl:section-content}', content);
	
	        dynContent += html;
	      }
	
	      this.mail.body = pageTemplate.substring(0, pageTemplate.lastIndexOf(TMPL_TAG_OPEN_SECTION)) + dynContent + pageTemplate.substring(pageTemplate.lastIndexOf(TMPL_TAG_CLOSE_SECTION) + TMPL_TAG_CLOSE_SECTION.length, pageTemplate.length);
	    }
	  }, {
	    key: 'openPreviewModal',
	    value: function openPreviewModal() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'mailComposerPreviewComponent',
	        resolve: {
	          config: function config() {
	            return {
	              url: '/api/mails/html/' + that.mailId
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }, {
	    key: 'saveAndOpenPreviewModal',
	    value: function saveAndOpenPreviewModal(form) {
	      var _this5 = this;
	
	      if (!this.mailId) {
	        var dlg = this.dialogs.confirm("Save and Preview Mail?", "In order to to be able to preview, the mail must be saved first.<br/>Do you want to save the mail?");
	        dlg.result.then(function () {
	          _this5.create(form, true);
	        }, function () {});
	      } else {
	        this.create(form, true);
	      }
	    }
	  }, {
	    key: 'openAssetBrowserModalAttachment',
	    value: function openAssetBrowserModalAttachment() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetBrowser',
	        resolve: {
	          config: function config() {
	            return {};
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function (newlySelectedAssets) {
	        newlySelectedAssets.forEach(function (nsa) {
	
	          that.StorageService.getFileSize({ id: nsa._id }, function (data2) {
	            nsa.size = 4 * (data2.size / 3);
	            that.assets.push(nsa);
	          });
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'openAssetUploadModalAttachment',
	    value: function openAssetUploadModalAttachment() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'assetUpload',
	        resolve: {
	          config: function config() {
	            return {
	              acceptedFileTypes: 'application/pdf,image/*'
	            };
	          }
	        }
	      });
	
	      modalInstance.result.then(function (result) {
	
	        result.forEach(function (storageId) {
	          that.StorageService.getMeta({ id: storageId }, function (data) {
	            that.StorageService.getFileSize({ id: storageId }, function (data2) {
	              data.size = 4 * (data2.size / 3);
	              that.assets.push(data);
	            });
	          }, function (err) {
	            console.log('could not retrieved storage from server');
	          });
	        });
	      }, function () {});
	    }
	  }]);
	
	  return MailComposerComponent;
	}();
	
	exports.default = angular.module('conduu.mailComposer', [uiRouter]).config(_mailComposer2.default).component('mailComposer', {
	  template: __webpack_require__(840),
	  controller: MailComposerComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('mail-composer', {
	    url: '/mail/composer/:id',
	    template: '<mail-composer></mail-composer>',
	    authenticate: 'suite-user'
	  });
	}];

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <h2>Mail Composer</h2>\n      <li><a href=\"/mail/draft/list\">Mails</a></li>\n      <li class=\"active\"><a href=\"#\">Mail Composer</a></li>\n    </ol>\n\n        <div class=\"col-xs-12\">\n\n            <form class=\"form\" name=\"form\" ng-submit=\"ctrl.create(form)\" novalidate>\n\n                <!-- Subject -->\n                <div class=\"form-group\" ng-class=\"{ 'has-success': form.subject.$valid && ctrl.submitted,\n                                            'has-error': form.subject.$invalid && ctrl.submitted }\">\n                    <label>Mail Subject</label>\n                    <input type=\"text\" name=\"subject\" class=\"form-control\" ng-model=\"ctrl.mail.subject\" required/>\n                    <p class=\"help-block\" ng-show=\"form.subject.$error.required && ctrl.submitted\">\n                        You must specify a subject for the mail.\n                    </p>\n                </div>\n\n                <!-- Template -->\n                <div id=\"news-type-select\" class=\"form-group\" ng-class=\"{ 'has-success': form.type.$valid && ctrl.submitted,\n                                            'has-error': form.type.$invalid && ctrl.submitted }\">\n                    <label>Template</label>\n\n                    <select type=\"text\" name=\"type\" class=\"form-control\" ng-model=\"ctrl.mail.template\" required\n                            ng-options=\"o.name as o.name group by o.type for o in ctrl.templates\" ng-change=\"ctrl.templateChanged()\"></select>\n                    <p class=\"help-block\" ng-show=\"form.type.$error.required && ctrl.submitted\">\n                        Please specify the template you want to use\n                    </p>\n                </div>\n\n                <!-- Attachments -->\n                <div class=\"form-group\">\n                    <label>Attachments</label>\n\n                    <table ng-show=\"ctrl.assets.length > 0\" style=\"width:100%;\" class=\"table table-striped\">\n                        <thead>\n                        <tr>\n                            <th>#</th>\n                            <th></th>\n                            <th>Name</th>\n                            <th>Size</th>\n                            <th></th>\n                        </tr>\n                        </thead>\n                        <tbody ui-sortable ng-model=\"ctrl.assets\">\n                        <tr ng-repeat=\"asset in ctrl.assets\" style=\"cursor: move;\">\n                            <td>{{$index}}</td>\n                            <td>\n                                <p style=\"margin: 0px\">\n                                    <i ng-if=\"ctrl.isImageMime(asset.contentType)\" class=\"fa fa-fw fa-file-image-o\"></i>\n                                    <i ng-if=\"ctrl.isPdfMime(asset.contentType)\" class=\"fa fa-fw fa-file-pdf-o\"></i>\n                                    <i ng-if=\"!ctrl.isImageMime(asset.contentType) && !ctrl.isPdfMime(asset.contentType)\" class=\"fa fa-fw fa-file-o\"></i>\n                                </p>\n                            </td>\n                            <td>{{asset.filename}}</td>\n                            <td>{{asset.size / 1024 / 1024 | number:'2'}} MB</td>\n                            <td style=\"text-align: right\"><a class=\"text-danger\" href=\"#\" ng-click=\"ctrl.removeAttachment($index)\"><i class=\"fa fa fa-trash\"></i></a></td>\n                        </tr>\n                        </tbody>\n                        <tfoot>\n                            <td colspan=\"3\" style=\"text-align:right\">Total Attachment Size</td>\n                            <th colspan=\"2\">{{ctrl.totalAttachmentSize() / 1024 / 1024 | number:'2'}} MB</th>\n                        </tfoot>\n                    </table>\n\n                    <div ng-if=\"ctrl.totalAttachmentSize() > 10*1024*1024\" class=\"bs-callout bs-callout-danger\">\n                        <h4>Attachment Size Exceeds Limit</h4>\n                        The total attachment size must not exceed the limit of 10 MB, otherwise the whole mail blast will fail delivery\n                    </div>\n                </div>\n\n                <a class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.openAssetUploadModalAttachment()\"><i class=\"fa fa-fw fa-upload\"></i> Upload File(s)</a>\n\n                <hr/>\n\n                <uib-accordion close-others=\"oneAtATime\" ui-sortable=\"ctrl.sortableOptions\"  ng-model=\"ctrl.mail.sections\">\n                    <div uib-accordion-group ng-repeat=\"section in ctrl.mail.sections track by $index\" class=\"panel-default\">\n                        <uib-accordion-heading>\n                            <span style=\"cursor: move\" class=\"handle\"><i class=\"fa fa-fw fa-arrows\" style=\"margin-right:8px\"></i></span>\n                            <span ng-class=\"{'text-muted': !section.heading}\">{{section.heading || 'No Heading'}}</span>\n\n                            <a style=\"color: darkred\" ng-click=\"ctrl.deleteSection($event, section, $index)\"><i class=\"fa fa-fw fa-trash\" style=\"float: right\"></i></a>\n                            <span style=\"float:right;padding-right: 24px;\" class=\"text-muted text-uppercase\">{{section.type}}</span>\n                        </uib-accordion-heading>\n\n                        <div class=\"form-group\">\n                            <label>Heading</label>\n                            <input type=\"text\" name=\"heading\" class=\"form-control\" ng-model=\"section.heading\" />\n                        </div>\n\n                        <!-- Section: Text -->\n                        <div class=\"form-group\" ng-if=\"section.type == 'text'\">\n                            <label>Content</label>\n                            <textarea class=\"form-control\" rows=\"8\" ng-model=\"section.content\"></textarea>\n                        </div>\n\n                        <!-- Section: HTML -->\n                        <div class=\"form-group\" ng-if=\"section.type == 'html'\">\n                            <label>Content</label>\n                            <text-angular ng-model=\"section.content\" ta-toolbar=\"ctrl.toolbarDefinition\" ta-file-drop=\"ctrl.dropHandler\"></text-angular>\n                        </div>\n\n                        <!-- Section: Images -->\n                        <div class=\"form-group\" ng-if=\"section.type == 'images'\">\n                            <label>Number of Images per Row</label>\n                            <select name=\"imagesPerRow\" class=\"form-control\" ng-model=\"section.imagesPerRow\"\n                                    ng-options=\"o as o for o in ctrl.optionsImagesPerRow\"></select>\n                            <br/>\n\n                            <label>Images</label>\n                            <table ng-show=\"section.images.length > 0\" style=\"width:100%;\" class=\"table table-striped\">\n                                <thead>\n                                <tr>\n                                    <th>#</th>\n                                    <th></th>\n                                    <th>Image Title</th>\n                                    <th></th>\n                                </tr>\n                                </thead>\n                                <tbody ui-sortable ng-model=\"section.images\">\n                                <tr ng-repeat=\"asset in section.images\" style=\"cursor: move;\">\n                                    <td>{{$index}}</td>\n                                    <td>\n                                        <p style=\"margin: 0px\">\n                                            <img ng-src=\"/api/storage/{{asset.image}}/thumb\" style=\"height:40px\" />\n                                        </p>\n                                    </td>\n                                    <td>\n                                        <input type=\"text\" ng-model=\"asset.title\" style=\"width: 100%\" />\n                                    </td>\n                                    <td style=\"text-align: right\"><a class=\"btn btn-danger\" ng-click=\"ctrl.removeAsset(section, $index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\n                                </tr>\n                                </tbody>\n                            </table>\n                            <p ng-show=\"!section.images || section.images.length == 0\" >Select or Upload your Images</p>\n\n                            <a class=\"btn btn-primary\" ng-click=\"ctrl.openAssetUploadModal(section)\"><i class=\"fa fa-fw fa-upload\"></i> Upload Image(s)</a>\n                        </div>\n\n                    </div>\n                </uib-accordion>\n\n                <a class=\"btn btn-primary\" ng-click=\"ctrl.addTextBlock()\"><i class=\"fa fa-fw fa-plus\"></i> Add Text Section</a>\n                <a class=\"btn btn-primary\" ng-click=\"ctrl.addImageBlock()\"><i class=\"fa fa-fw fa-plus\"></i> Add Image Section</a>\n\n                <hr/>\n\n                <div ng-show=\"ctrl.sendFailure\" class=\"alert alert-danger\">\n                    There has been an error. Your mail could not be created.\n                </div>\n\n                <button ng-hide=\"ctrl.mailId\" class=\"btn btn-primary\" type=\"submit\">Create Mail</button>\n\n                <button ng-show=\"ctrl.mailId\" class=\"btn btn-primary\" type=\"submit\"><i class=\"fa fa-fw fa-floppy-o\"></i> Save</button>\n                <a class=\"btn btn-warning\" ng-href=\"/mail/{{ctrl.mail.type}}/list\"><i class=\"fa fa-fw fa-times\"></i> Cancel</a>\n\n                <a class=\"btn btn-primary\" style=\"float:right\" ng-click=\"ctrl.saveAndOpenPreviewModal(form)\"><i class=\"fa fa-fw fa-window-maximize\"></i> Save & Preview</a>\n            </form>\n\n        </div>\n\n    </div>\n</div>\n\n"

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MailListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mailList = __webpack_require__(842);
	
	var _mailList2 = _interopRequireDefault(_mailList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var MailListComponent = exports.MailListComponent = function () {
	  MailListComponent.$inject = ['Auth', 'dialogs', '$uibModal', 'MailsService', '$stateParams', '$location', 'Upload'];
	  function MailListComponent(Auth, dialogs, $uibModal, MailsService, $stateParams, $location, Upload) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, MailListComponent);
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.MailsService = MailsService;
	    this.Upload = Upload;
	    this.$stateParams = $stateParams;
	    this.Auth = Auth;
	    this.$location = $location;
	
	    this.type = $stateParams.type;
	
	    this.noData = false;
	    this.count = {};
	
	    this.MailsService.getByType({ type: this.type }, function (data) {
	      _this.mailLists = data;
	
	      if (_this.mailLists.length == 0) {
	        _this.noData = true;
	      }
	    }, function (err) {
	      console.log("Could not retrieve mail lists from server.");
	    });
	
	    this.MailsService.query(function (data) {
	      data.forEach(function (mail) {
	        if (mail.type) {
	          if (!_this.count[mail.type]) {
	            _this.count[mail.type] = 0;
	          }
	          _this.count[mail.type]++;
	        }
	      });
	    });
	  }
	
	  _createClass(MailListComponent, [{
	    key: 'openRecipientsModal',
	    value: function openRecipientsModal(mail) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'datatableViewer',
	        resolve: {
	          config: function config() {
	            return {
	              data: mail.recipients.map(function (mail) {
	                return [mail];
	              }) || [],
	              settings: {
	                "columns": ["Email"]
	              },
	              name: mail.subject + " Recipient List"
	            };
	          }
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'send',
	    value: function send(mail) {
	
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'mailComposerFilterSendComponent',
	        resolve: {
	          config: function config() {
	            return {
	              mail: mail
	            };
	          }
	        },
	        size: 'lg',
	        windowClass: 'xl-modal'
	      });
	
	      modalInstance.result.then(function (result) {
	
	        var id = result.mailId;
	
	        that.mailLists = that.mailLists.filter(function (obj) {
	          return obj._id !== id;
	        });
	
	        if (that.mailLists.length == 0) {
	          that.noData = true;
	        }
	
	        that.count["draft"]--;
	        that.count["sent"]++;
	
	        that.dialogs.notify("Mail has been sent", "The mail has been sent successfully");
	      }, function () {});
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(mail) {
	      var that = this;
	
	      var listText = "<br/><br/><b>" + mail.subject + "</b>";
	
	      var dlg = this.dialogs.confirm("Delete Mail?", "Do you really want to delete this mail?" + listText);
	      dlg.result.then(function () {
	        that.MailsService.delete({ id: mail._id }, function () {
	          that.mailLists = that.mailLists.filter(function (obj) {
	            return obj._id !== mail._id;
	          });
	
	          that.count[that.type]--;
	        }, function (err) {
	          alert("Could not delete mail");
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'clone',
	    value: function clone(mail) {
	      var that = this;
	
	      var listText = "<br/><br/><b>" + mail.subject + "</b>";
	
	      var dlg = this.dialogs.confirm("Clone Mail?", "Do you want to clone this mail?" + listText + "<br/><br/>The mail will be opened in the mail composer after it has been cloned");
	      dlg.result.then(function () {
	
	        var clonedMail = angular.copy(mail);
	
	        delete clonedMail._id;
	        delete clonedMail.sentDate;
	        delete clonedMail.recipients;
	        delete clonedMail.meta.creationDate;
	
	        clonedMail.type = 'draft';
	        clonedMail.subject += " (Cloned " + new Date().toLocaleString() + ")";
	
	        clonedMail.meta.creationUser = that.Auth.getCurrentUserSync()._id;
	        clonedMail.meta.active = true;
	
	        that.MailsService.save(clonedMail, function (newMail) {
	          that.$location.path("/mail/composer/" + newMail._id);
	        }, function (err) {
	          alert("Could create mail");
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'openPreviewModal',
	    value: function openPreviewModal(mail) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'mailComposerPreviewComponent',
	        resolve: {
	          config: function config() {
	            return {
	              url: '/api/mails/html/' + mail._id,
	              title: mail.subject
	            };
	          }
	        },
	        size: 'lg'
	      });
	
	      modalInstance.result.then(function () {}, function () {});
	    }
	  }]);
	
	  return MailListComponent;
	}();
	
	exports.default = angular.module('conduu.mailList', [uiRouter]).config(_mailList2.default).component('mailList', {
	  template: __webpack_require__(843),
	  controller: MailListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('mail-list', {
	    url: '/mail/:type/list',
	    params: { type: null },
	    template: '<mail-list></mail-list>',
	    authenticate: 'suite-user'
	  });
	}];

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <a style=\"float:right; margin-top:16px\" ng-href=\"/mail/composer/\" class=\"btn btn-primary\"><i class=\"fa fa-plus\"></i> Create New Mail</a>\n      <h2>Mails <small class=\"text-capitalize\">{{ctrl.type}}</small></h2>\n      <li><a href=\"/mail/draft/list\">Mails</a></li>\n      <li class=\"active\"><a class=\"text-capitalize\" href=\"#\">{{ctrl.type}}</a></li>\n    </ol>\n\n        <div class=\"col-md-2 col-xs-12\">\n            <br/>\n            <div class=\"list-group\">\n                <a href=\"/mail/draft/list\" class=\"list-group-item\" ng-class=\"{'active': ctrl.type == 'draft'}\">\n                    Draft\n                    <span class=\"badge\">{{ctrl.count.draft}}</span>\n                </a>\n                <a href=\"/mail/sent/list\" class=\"list-group-item\" ng-class=\"{'active': ctrl.type == 'sent'}\">\n                    Sent\n                    <span class=\"badge\">{{ctrl.count.sent}}</span>\n                </a>\n            </div>\n        </div>\n\n        <div class=\"col-md-10 col-xs-12\">\n\n            <table datatable=\"ng\" ng-if=\"!ctrl.noData\" class=\"table table-striped\" style=\"width:100%\">\n                <thead>\n                <tr>\n                    <th>Subject</th>\n                    <th>Date Created</th>\n                    <th ng-if=\"ctrl.type == 'sent'\">Date Sent</th>\n                    <th></th>\n                    <th ng-if=\"ctrl.type == 'sent'\"></th>\n                    <th></th>\n                    <th ng-if=\"ctrl.type == 'draft'\"></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat=\"mail in ctrl.mailLists | orderBy: 'meta.creationDate':true\">\n                    <td>{{mail.subject}}</td>\n                    <td>\n                        <nobr>{{mail.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\n                    </td>\n                    <td ng-if=\"ctrl.type == 'sent'\">\n                        <nobr>{{mail.sentDate | date:'yyyy-MM-dd'}}</nobr>\n                    </td>\n                    <td class=\"text-right\">\n                        <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.openPreviewModal(mail)\"><i\n                                class=\"fa fa-eye fa-fw\"></i> View</button>\n                    </td>\n                    <td ng-if=\"ctrl.type == 'sent'\" class=\"text-right\">\n                        <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.openRecipientsModal(mail)\"><i\n                                class=\"fa fa-users fa-fw\"></i> Recipients</button>\n                    </td>\n                    <td class=\"text-right\">\n                        <nobr>\n                            <a ng-if=\"ctrl.type == 'draft'\" class=\"btn btn-sm btn-primary\" ng-href=\"/mail/composer/{{mail._id}}\"><i class=\"fa fa-pencil fa-fw\"></i>\n                                Edit</a>\n                            <a class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.clone(mail)\"><i class=\"fa fa-clone fa-fw\"></i> Clone</a>\n                            <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(mail)\"><i class=\"fa fa-trash-o fa-fw\"></i> Delete</button>\n                        </nobr>\n                    </td>\n                    <td ng-if=\"ctrl.type == 'draft'\" class=\"text-right\">\n                        <nobr>\n                            <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.send(mail)\"><i class=\"fa fa-paper-plane-o fa-fw\"></i> Send</button>\n                        </nobr>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n\n            <p ng-if=\"ctrl.noData\"><br/><b>There are no mails in this list.</b><br/><em>Create your first mail now.</em></p>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var mailComposerPreviewComponent = exports.mailComposerPreviewComponent = function () {
	  /*@ngInject*/
	  function mailComposerPreviewComponent() {
	    _classCallCheck(this, mailComposerPreviewComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	    };
	  }
	
	  _createClass(mailComposerPreviewComponent, [{
	    key: 'ok',
	    value: function ok() {
	      this.cancel();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return mailComposerPreviewComponent;
	}();
	
	exports.default = angular.module('conduApp.mailComposerPreviewComponent', []).component('mailComposerPreviewComponent', {
	  template: __webpack_require__(845),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: mailComposerPreviewComponent
	}).name;

/***/ }),
/* 845 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <a class=\"btn btn-primary\" style=\"float:right\" target=\"_blank\" ng-href=\"{{$ctrl.config.url}}\"><i class=\"fa fa-fw fa-expand\"></i></a>\r\n  <h3 class=\"modal-title\" id=\"modal-title\">{{$ctrl.config.title || 'Mail'}}</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\" style=\"padding:0px !important\">\r\n\r\n  <iframe ng-src=\"{{$ctrl.config.url}}\" style=\"width:100%; height:480px; border: 0px;\"></iframe>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">Close</button>\r\n</div>\r\n"

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var mailComposerFilterSendComponent = exports.mailComposerFilterSendComponent = function () {
	  /*@ngInject*/
	  mailComposerFilterSendComponent.$inject = ['MailsService', 'SettingsService', 'CommunityService', 'PropertyService', 'DTOptionsBuilder'];
	  function mailComposerFilterSendComponent(MailsService, SettingsService, CommunityService, PropertyService, DTOptionsBuilder) {
	    var _this = this;
	
	    _classCallCheck(this, mailComposerFilterSendComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	    };
	
	    this.SettingsService = SettingsService;
	    this.MailsService = MailsService;
	    this.CommunityService = CommunityService;
	    this.PropertyService = PropertyService;
	
	    this.filteredAvailableEmails = [];
	
	    this.availableEmails = [];
	    this.selectedEmails = [];
	
	    this.filter = {
	      "primary-owner": true,
	      "owner": true,
	      "renter": false
	    };
	    this.contactTypes = ["primary-owner", "owner", "renter"];
	    this.contactTypesMap = {
	      "primary-owner": "Primary Owner",
	      "owner": "Owner",
	      "renter": "Tenant"
	    };
	    this.contactTypesShort = {
	      "primary-owner": "PO",
	      "owner": "O",
	      "renter": "T"
	    };
	
	    this.filterSecondOwner = false;
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('order', [0, 'asc']);
	
	    this.SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	
	      if (appSettings.data.eBlastContactTypesMap) {
	        _this.contactTypesMap = appSettings.data.eBlastContactTypesMap;
	        _this.contactTypes = Object.keys(_this.contactTypesMap);
	
	        _this.contactTypes.forEach(function (type) {
	          _this.filter[type] = type == 'renter' ? false : true;
	        });
	      }
	
	      if (appSettings.data.eBlastContactTypesShort) {
	        _this.contactTypesShort = appSettings.data.eBlastContactTypesShort;
	      }
	
	      _this.CommunityService.query(function (data) {
	        _this.communities = [{
	          value: undefined,
	          name: '- All -'
	        }].concat(data.map(function (cmty) {
	          return {
	            value: cmty._id,
	            name: cmty.code + ": " + cmty.name
	          };
	        }));
	      });
	
	      _this.PropertyService.queryWithContacts(function (data) {
	        data.forEach(function (ppty) {
	          ppty.contacts.filter(function (c) {
	            return c.contact && c.contact.email && c.contact.email.length;
	          }).filter(function (c) {
	            return _this.contactTypes.includes(c.type);
	          }).forEach(function (c) {
	            c.contact.email.forEach(function (e) {
	              var o = {
	                firstName: c.contact.firstName,
	                lastName: c.contact.lastName,
	                middleName: c.contact.middleName,
	                company: c.contact.company,
	                community: ppty.community,
	                lotNo: ppty.lotNo,
	                buildingNo: ppty.buildingNo
	              };
	
	              o.type = {
	                user: c.type,
	                email: e.isPrimary ? "primary-email" : "other-email"
	              };
	
	              o.address = ppty.address && ppty.address.street ? ppty.address.street : "-";
	              o.email = e.address;
	
	              _this.availableEmails.push(o);
	            });
	          });
	        });
	
	        _this.applyFilter();
	
	        _this.dataInitComplete = true;
	      });
	    });
	  }
	
	  _createClass(mailComposerFilterSendComponent, [{
	    key: 'resetCommunityFilter',
	    value: function resetCommunityFilter() {
	      this.community = undefined;
	      this.applyFilter();
	    }
	  }, {
	    key: 'applyFilter',
	    value: function applyFilter() {
	      var _this2 = this;
	
	      this.filteredAvailableEmails = this.availableEmails;
	
	      if (this.community) {
	        this.filteredAvailableEmails = this.filteredAvailableEmails.filter(function (o) {
	          return o.community == _this2.community;
	        });
	      }
	
	      Object.keys(this.filter).forEach(function (key) {
	        if (!_this2.filter[key]) {
	          _this2.filteredAvailableEmails = _this2.filteredAvailableEmails.filter(function (o) {
	            return o.type.user != key;
	          });
	        }
	      });
	
	      if (!this.filterSecondOwner) {
	        this.filteredAvailableEmails = this.filteredAvailableEmails.filter(function (o) {
	          return o.type.email != 'other-email';
	        });
	      }
	    }
	  }, {
	    key: 'selectEmail',
	    value: function selectEmail(email) {
	      this.selectedEmails.push(email);
	      this.availableEmails.forEach(function (o) {
	        if (o.email == email) o.selected = true;
	      });
	      this.filteredAvailableEmails.forEach(function (o) {
	        if (o.email == email) o.selected = true;
	      });
	    }
	  }, {
	    key: 'selectAllAvailable',
	    value: function selectAllAvailable() {
	      var _this3 = this;
	
	      this.filteredAvailableEmails.forEach(function (o) {
	        o.selected = true;
	        if (!_this3.selectedEmails.includes(o.email)) _this3.selectedEmails.push(o.email);
	      });
	    }
	  }, {
	    key: 'removeEmail',
	    value: function removeEmail(email) {
	      this.selectedEmails = this.selectedEmails.filter(function (e) {
	        return e != email;
	      });
	      this.availableEmails.forEach(function (o) {
	        if (o.email == email) o.selected = false;
	      });
	      this.filteredAvailableEmails.forEach(function (o) {
	        if (o.email == email) o.selected = false;
	      });
	    }
	  }, {
	    key: 'addIndividualEmail',
	    value: function addIndividualEmail() {
	      var email = window.prompt("Add another email:");
	      if (email && email.trim() !== '') {
	        if (!email.includes("@")) {
	          alert("Not a valid email address");
	          return;
	        }
	        this.selectedEmails.push(email);
	        this.availableEmails.forEach(function (o) {
	          if (o.email == email) o.selected = true;
	        });
	        this.filteredAvailableEmails.forEach(function (o) {
	          if (o.email == email) o.selected = true;
	        });
	      }
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += " (" + contact.company + ")";
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'getPrimaryEmail',
	    value: function getPrimaryEmail(contact) {
	      if (!contact || !contact.email || !contact.email.length) return "-";
	
	      var email = contact.email.find(function (email) {
	        return email.isPrimary;
	      }) || contact.email[0] || { address: '-' };
	
	      return email.address;
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this4 = this;
	
	      var mail = this.config.mail;
	
	      mail.recipients = this.selectedEmails;
	
	      this.MailsService.send({ id: mail._id }, mail, function (res) {
	        _this4.close({ $value: { mailId: mail._id } });
	      }, function (err) {
	        console.log("Could not send mail");
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return mailComposerFilterSendComponent;
	}();
	
	exports.default = angular.module('conduu.mailComposerFilterSendComponent', []).component('mailComposerFilterSendComponent', {
	  template: __webpack_require__(847),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: mailComposerFilterSendComponent
	}).name;

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">Send Email</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n\n  <div class=\"row\">\n    <div class=\"col-xs-4\">\n      <!-- Community -->\n      <div class=\"form-group\">\n        <label>Community</label>\n        <br/>\n        <div class=\"input-group\" style=\"display: inline-block\">\n          <select class=\"form-control\" ng-options=\"o.value as o.name for o in $ctrl.communities\" ng-model=\"$ctrl.community\"\n                  style=\"display: inline-block; width: auto\" ng-change=\"$ctrl.applyFilter()\"></select>\n          <span class=\"input-group-btn\">\n            <a class=\"btn btn-danger\" ng-disabled=\"!$ctrl.community\" ng-click=\"$ctrl.resetCommunityFilter()\"><i class=\"fa fa-fw fa-times\"></i></a>\n          </span>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-4\">\n      <div class=\"form-group\">\n        <label>Filter</label>\n        <div style=\"position:relative; top: 6px\">\n          <span ng-repeat=\"type in $ctrl.contactTypes\">\n            <label><input style=\"position: relative; top: 1px\" type=\"checkbox\" ng-click=\"$ctrl.applyFilter()\" ng-model=\"$ctrl.filter[type]\" /> {{$ctrl.contactTypesMap[type]}}</label>\n            <span ng-hide=\"$last\">|</span>\n          </span>\n          <br/>\n          <label style=\"font-weight: normal\"><input style=\"position: relative; top: 1px\" type=\"checkbox\" ng-click=\"$ctrl.applyFilter()\" ng-model=\"$ctrl.filterSecondOwner\" /> Also Include Secondary Emails</label>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-4\">\n      <!-- Future addition: Presets (load / store / delete) -->\n    </div>\n  </div>\n\n  <hr/>\n\n  <div class=\"row\">\n\n    <div class=\"col-xs-8\">\n      <h4 style=\"margin-top: 0\" class=\"separator\"><span>Available Emails</span><span style=\"float: right; padding-left: 8px\"><small><a href=\"#\" ng-click=\"$ctrl.selectAllAvailable()\">Select All <i class=\"fa fa-fw fa-angle-double-right\"></i></a></small></span></h4>\n      <table datatable=\"ng\" ng-if=\"$ctrl.dataInitComplete\" dt-options=\"$ctrl.dtOptions\" class=\"table table-hover table-condensed\" style=\"width:100%\">\n        <thead>\n          <tr>\n            <th>Name</th>\n            <th>Address</th>\n            <th>Unit</th>\n            <th>Type</th>\n            <th>Email</th>\n            <th></th>\n          </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"o in $ctrl.filteredAvailableEmails\" ng-class=\"{'text-muted':o.selected}\">\n          <td>{{$ctrl.getComposedName(o)}}</td>\n          <td>{{o.address}}</td>\n          <td>{{o.lotNo}}</td>\n          <td>\n            <nobr ng-repeat=\"type in $ctrl.contactTypes\">\n              <span ng-if=\"o.type.user == type && o.type.email == 'primary-email'\" title=\"{{$ctrl.contactTypesMap[type]}} (Primary Email)\" ng-class=\"{'label label-primary': type == 'primary-owner', 'label label-info': type != 'primary-owner' && type != 'renter', 'label label-warning': type == 'renter'}\">{{$ctrl.contactTypesShort[type]}} <i class=\"fa fa-fw fa-envelope\"></i></span>\n              <span ng-if=\"o.type.user == type && o.type.email == 'other-email'\" title=\"{{$ctrl.contactTypesMap[type]}} (Other Email)\" ng-class=\"{'label label-primary': type == 'primary-owner', 'label label-info': type != 'primary-owner' && type != 'renter', 'label label-warning': type == 'renter'}\">{{$ctrl.contactTypesShort[type]}} <i class=\"fa fa-fw fa-envelope-o\"></i></span>\n            </nobr>\n          </td>\n          <td>{{o.email}}</td>\n          <td><button class=\"btn btn-sm btn-primary\" ng-disabled=\"o.selected\" type=\"button\" ng-click=\"$ctrl.selectEmail(o.email)\"><i class=\"fa fa-fw fa-arrow-right\"></i></button></td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n    <div class=\"col-xs-4\">\n      <h4 style=\"margin-top: 0\" class=\"separator\"><span>Selected Emails</span><span style=\"float: right; padding-left: 8px\"><small><a href=\"#\" ng-click=\"$ctrl.addIndividualEmail()\">Add Email <i class=\"fa fa-fw fa-plus\"></i></a></small></span></h4>\n      <table datatable=\"ng\" ng-if=\"$ctrl.dataInitComplete\" dt-options=\"$ctrl.dtOptions\" class=\"table table-hover table-condensed\" style=\"width:100%\">\n        <thead>\n        <tr>\n          <th>Email</th>\n          <th></th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"email in $ctrl.selectedEmails\">\n          <td>{{email}}</td>\n          <td class=\"text-right\">\n            <button class=\"btn btn-sm btn-warning\" ng-click=\"$ctrl.removeEmail(email)\"><i class=\"fa fa-fw fa-trash\"></i></button>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n  </div>\n\n\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!$ctrl.selectedEmails || !$ctrl.selectedEmails.length\" ng-click=\"$ctrl.ok()\">Send</button>\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n</div>\n"

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	MailsService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MailsService = MailsService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function MailsService($resource) {
	  return $resource('/api/mails/:id', {
	    name: '@_id'
	  }, {
	    getByType: {
	      method: 'GET',
	      url: "/api/mails/type/:type",
	      isArray: true
	    },
	    update: {
	      method: 'PUT'
	    },
	    send: {
	      url: "/api/mails/send/:id",
	      method: 'PUT'
	    },
	    archive: {
	      url: "/api/mails/archive/:id/:cat",
	      method: 'PUT'
	    },
	    contact: {
	      url: "/api/mails/contact",
	      method: 'POST'
	    }
	  });
	}
	
	exports.default = angular.module('conduuApp.MailsService', []).factory('MailsService', MailsService).name;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var datatableViewerComponent = exports.datatableViewerComponent = function () {
	  datatableViewerComponent.$inject = ['DTOptionsBuilder', '$timeout'];
	  function datatableViewerComponent(DTOptionsBuilder, $timeout) {
	    'ngInject';
	
	    _classCallCheck(this, datatableViewerComponent);
	
	    this.DTOptionsBuilder = DTOptionsBuilder;
	    this.$timeout = $timeout;
	  }
	
	  _createClass(datatableViewerComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.data = this.resolve.config.data;
	      this.settings = this.resolve.config.settings;
	      this.name = this.resolve.config.name;
	
	      this.dtOptions = {
	        dom: 'lBfrtip',
	        responsive: true,
	        hasBootstrap: true,
	        buttons: [{
	          extend: 'excel',
	          title: this.name
	        }, {
	          extend: 'csv',
	          title: this.name
	        }, {
	          title: this.name,
	          extend: 'pdf',
	          orientation: 'portrait',
	          pageSize: 'LETTER'
	        }, 'print']
	      };
	    }
	  }]);
	
	  return datatableViewerComponent;
	}();
	
	exports.default = angular.module('conduu.datatableViewer', []).component('datatableViewer', {
	  template: __webpack_require__(850),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: datatableViewerComponent
	}).name;

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	module.exports = "\n\n<div class=\"modal-header\">\n    <button ng-if=\"modal.dismissable\" type=\"button\" ng-click=\"$dismiss()\" class=\"close\">&times;</button>\n    <h4 ng-bind=\"$ctrl.name\" class=\"modal-title\"></h4>\n</div>\n<div class=\"modal-body\">\n    <table dt-options=\"$ctrl.dtOptions\" datatable=\"ng\" class=\"table table-striped datatable-conduu\" style=\"width:100%\">\n        <thead>\n        <tr>\n            <th ng-repeat=\"column in $ctrl.settings.columns track by $index\">{{column}}</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"row in $ctrl.data\">\n            <td ng-repeat=\"cell in row track by $index\">{{cell}}</td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n"

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextListComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _textList = __webpack_require__(852);
	
	var _textList2 = _interopRequireDefault(_textList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var uiRouter = __webpack_require__(28);
	
	var TextListComponent = exports.TextListComponent = function () {
	  TextListComponent.$inject = ['Auth', 'dialogs', '$uibModal', 'MailsService', '$stateParams', '$location', 'Upload', 'TextMessagesService'];
	  function TextListComponent(Auth, dialogs, $uibModal, MailsService, $stateParams, $location, Upload, TextMessagesService) {
	    'ngInject';
	
	    _classCallCheck(this, TextListComponent);
	
	    this.dialogs = dialogs;
	    this.$uibModal = $uibModal;
	    this.TextMessagesService = TextMessagesService;
	    this.Upload = Upload;
	    this.$stateParams = $stateParams;
	    this.Auth = Auth;
	    this.$location = $location;
	
	    this.type = $stateParams.type;
	
	    this.noData = false;
	    this.count = {};
	
	    this.getData();
	  }
	
	  _createClass(TextListComponent, [{
	    key: 'getData',
	    value: function getData() {
	      var _this = this;
	
	      this.TextMessagesService.getByType({ type: this.type }, function (data) {
	        _this.textList = data;
	
	        if (_this.textList.length == 0) {
	          _this.noData = true;
	        }
	      }, function (err) {
	        console.log("Could not retrieve mail lists from server.");
	      });
	
	      this.count["draft"] = 0;
	      this.count["sent"] = 0;
	
	      this.TextMessagesService.query(function (data) {
	        data.forEach(function (text) {
	          if (text.type) {
	            if (!_this.count[text.type]) {
	              _this.count[text.type] = 0;
	            }
	            _this.count[text.type]++;
	          }
	        });
	      });
	    }
	  }, {
	    key: 'openRecipientsModal',
	    value: function openRecipientsModal(text) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'datatableViewer',
	        resolve: {
	          config: function config() {
	            return {
	              data: text.recipients.map(function (mail) {
	                return [mail];
	              }) || [],
	              settings: {
	                "columns": ["Cell Numbers"]
	              },
	              name: "Text Message Recipient List"
	            };
	          }
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'send',
	    value: function send(textMessage) {
	
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'textMessageFilterSendComponent',
	        resolve: {
	          config: function config() {
	            return {
	              textMessage: textMessage
	            };
	          }
	        },
	        size: 'lg',
	        windowClass: 'xl-modal'
	      });
	
	      modalInstance.result.then(function (result) {
	
	        that.getData();
	
	        that.dialogs.notify("Text message has been sent", "The text message has been sent successfully");
	      }, function () {});
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(text) {
	      var that = this;
	
	      var listText = "<br/><br/><b>" + text.body + "</b>";
	
	      var dlg = this.dialogs.confirm("Delete Text Message?", "Do you really want to delete this text message?" + listText);
	      dlg.result.then(function () {
	        that.TextMessagesService.delete({ id: text._id }, function () {
	          that.textList = that.textList.filter(function (obj) {
	            return obj._id !== text._id;
	          });
	
	          that.count[that.type]--;
	        }, function (err) {
	          alert("Could not delete text message");
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'addTextMessage',
	    value: function addTextMessage() {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'textMessageEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: ''
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (message) {
	
	        var textMessage = {
	          body: message,
	          type: 'draft',
	          meta: {
	            creationUser: that.Auth.getCurrentUserSync()._id
	          }
	        };
	
	        that.TextMessagesService.save(textMessage, function (newTextMessage) {
	          console.log(newTextMessage);
	          that.count['draft'] = that.count['draft'] ? that.count['draft'] + 1 : 1;
	          that.textList.push(newTextMessage);
	          console.log(that.textList);
	        }, function (err) {
	          console.log(err);
	          alert('There was an error trying to create the text message');
	        });
	      }, function () {});
	    }
	  }, {
	    key: 'editTextMessage',
	    value: function editTextMessage(text) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'textMessageEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: text.body
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (message) {
	
	        text.body = message;
	
	        that.TextMessagesService.update({ id: text._id }, text, function (_) {
	          that.getData();
	        }, function (err) {
	          console.log(err);
	          alert('There was an error trying to update the text message');
	        });
	      }, function () {});
	    }
	  }]);
	
	  return TextListComponent;
	}();
	
	exports.default = angular.module('conduu.textList', [uiRouter]).config(_textList2.default).component('textList', {
	  template: __webpack_require__(853),
	  controller: TextListComponent,
	  controllerAs: 'ctrl'
	}).name;

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('text-list', {
	    url: '/text/:type/list',
	    params: { type: null },
	    template: '<text-list></text-list>',
	    authenticate: 'suite-user'
	  });
	}];

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <ol class=\"breadcrumb\">\n      <a style=\"float:right; margin-top:16px\" ng-href=\"#\" class=\"btn btn-primary\" ng-click=\"ctrl.addTextMessage()\"><i class=\"fa fa-plus\"></i> Create New Text Message</a>\n      <h2>Text Messages <small class=\"text-capitalize\">{{ctrl.type}}</small></h2>\n      <li><a href=\"/text/draft/list\">Text Messages</a></li>\n      <li class=\"active\"><a class=\"text-capitalize\" href=\"#\">{{ctrl.type}}</a></li>\n    </ol>\n\n        <div class=\"col-md-2 col-xs-12\">\n            <br/>\n            <div class=\"list-group\">\n                <a href=\"/text/draft/list\" class=\"list-group-item\" ng-class=\"{'active': ctrl.type == 'draft'}\">\n                    Draft\n                    <span class=\"badge\">{{ctrl.count.draft}}</span>\n                </a>\n                <a href=\"/text/sent/list\" class=\"list-group-item\" ng-class=\"{'active': ctrl.type == 'sent'}\">\n                    Sent\n                    <span class=\"badge\">{{ctrl.count.sent}}</span>\n                </a>\n            </div>\n        </div>\n\n        <div class=\"col-md-10 col-xs-12\">\n\n            <table datatable=\"ng\" ng-if=\"!ctrl.noData\" class=\"table table-striped\" style=\"width:100%\">\n                <thead>\n                <tr>\n                    <th>Text Message</th>\n                    <th>Date Created</th>\n                    <th ng-if=\"ctrl.type == 'sent'\">Date Sent</th>\n                    <th ng-if=\"ctrl.type == 'sent'\"></th>\n                    <th></th>\n                    <th ng-if=\"ctrl.type == 'draft'\"></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat=\"text in ctrl.textList | orderBy: 'meta.creationDate':true\">\n                    <td>{{text.body}}</td>\n                    <td>\n                        <nobr>{{text.meta.creationDate | date:'yyyy-MM-dd'}}</nobr>\n                    </td>\n                    <td ng-if=\"ctrl.type == 'sent'\">\n                        <nobr>{{text.sentDate | date:'yyyy-MM-dd'}}</nobr>\n                    </td>\n                    <td ng-if=\"ctrl.type == 'sent'\" class=\"text-right\">\n                        <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.openRecipientsModal(text)\"><i\n                                class=\"fa fa-users fa-fw\"></i> Recipients</button>\n                    </td>\n                    <td class=\"text-right\">\n                        <nobr>\n                            <a ng-if=\"ctrl.type == 'draft'\" class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.editTextMessage(text)\"><i class=\"fa fa-pencil fa-fw\"></i>\n                                Edit</a>\n                            <button class=\"btn btn-sm btn-danger\" ng-click=\"ctrl.delete(text)\"><i class=\"fa fa-trash-o fa-fw\"></i> Delete</button>\n                        </nobr>\n                    </td>\n                    <td ng-if=\"ctrl.type == 'draft'\" class=\"text-right\">\n                        <nobr>\n                            <button class=\"btn btn-sm btn-primary\" ng-click=\"ctrl.send(text)\"><i class=\"fa fa-paper-plane-o fa-fw\"></i> Send</button>\n                        </nobr>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n\n            <p ng-if=\"ctrl.noData\"><br/><b>There are no text messages in this list.</b><br/><em>Create your first text message now.</em></p>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var TextMessageEditComponent = exports.TextMessageEditComponent = function () {
	
	  /*@ngInject*/
	  function TextMessageEditComponent() {
	    _classCallCheck(this, TextMessageEditComponent);
	
	    this.MAX_CHARS = 160;
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	
	      if (this.config.hasOwnProperty("data")) {
	        this.message = angular.copy(this.config.data);
	        this.updateChars();
	      }
	    };
	
	    this.charsLeft = this.MAX_CHARS;
	    this.message = '';
	  }
	
	  _createClass(TextMessageEditComponent, [{
	    key: 'updateChars',
	    value: function updateChars() {
	      if (this.message.length > this.MAX_CHARS) this.message = this.message.substring(0, this.MAX_CHARS);
	
	      this.charsLeft = this.MAX_CHARS - this.message.length;
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.message });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return TextMessageEditComponent;
	}();
	
	exports.default = angular.module('conduu.textMessageEdit', []).component('textMessageEdit', {
	  template: __webpack_require__(855),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: TextMessageEditComponent
	}).name;

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	module.exports = "\n  <div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">Text Message Editor</h3>\n  </div>\n  <div class=\"modal-body\" id=\"modal-body\">\n\n      <div class=\"form-group\" style=\"margin-bottom: 6px\">\n          <label>Text Message</label>\n\n          <textarea type=\"text\" name=\"message\" class=\"form-control\" ng-trim=\"false\" ng-model=\"$ctrl.message\" rows=\"3\"\n                    ng-change=\"$ctrl.updateChars()\"></textarea>\n      </div>\n\n    <small>{{$ctrl.charsLeft}} character(s) left</small>\n\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" type=\"submit\" type=\"button\" ng-click=\"$ctrl.ok()\" ng-disabled=\"!$ctrl.message.trim().length\">Save</button>\n    <a class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\">Cancel</a>\n  </div>\n"

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	TextMessagesService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextMessagesService = TextMessagesService;
	var angular = __webpack_require__(14);
	
	/*@ngInject*/
	function TextMessagesService($resource) {
	  return $resource('/api/text-messages/:id', {
	    name: '@_id'
	  }, {
	    getByType: {
	      method: 'GET',
	      url: "/api/text-messages/type/:type",
	      isArray: true
	    },
	    update: {
	      method: 'PUT'
	    },
	    send: {
	      url: "/api/text-messages/send/:id",
	      method: 'PUT'
	    },
	    contact: {
	      url: "/api/text-messages/contact",
	      method: 'POST'
	    }
	  });
	}
	
	exports.default = angular.module('conduuApp.TextMessagesService', []).factory('TextMessagesService', TextMessagesService).name;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var textMessageFilterSendComponent = exports.textMessageFilterSendComponent = function () {
	  /*@ngInject*/
	  textMessageFilterSendComponent.$inject = ['TextMessagesService', 'SettingsService', 'CommunityService', 'PropertyService', 'DTOptionsBuilder', '$uibModal'];
	  function textMessageFilterSendComponent(TextMessagesService, SettingsService, CommunityService, PropertyService, DTOptionsBuilder, $uibModal) {
	    var _this = this;
	
	    _classCallCheck(this, textMessageFilterSendComponent);
	
	    this.$onInit = function () {
	      this.config = this.resolve.config;
	    };
	
	    this.SettingsService = SettingsService;
	    this.TextMessagesService = TextMessagesService;
	    this.CommunityService = CommunityService;
	    this.PropertyService = PropertyService;
	    this.$uibModal = $uibModal;
	
	    this.filteredAvailableNumbers = [];
	
	    this.availableNumbers = [];
	    this.selectedNumbers = [];
	
	    this.filterPrimaryOwner = true;
	    this.filterOwner = true;
	    this.filterTenant = false;
	    this.filterSecondOwner = false;
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('order', [0, 'asc']);
	
	    this.CommunityService.query(function (data) {
	      _this.communities = [{
	        value: undefined,
	        name: '- All -'
	      }].concat(data.map(function (cmty) {
	        return {
	          value: cmty._id,
	          name: cmty.code + ": " + cmty.name
	        };
	      }));
	    });
	
	    this.PropertyService.queryWithContacts(function (data) {
	      data.forEach(function (ppty) {
	        ppty.contacts.filter(function (c) {
	          return c.contact && c.contact.phone && c.contact.phone.length;
	        }).filter(function (c) {
	          return c.type == 'primary-owner' || c.type == 'owner' || c.type == 'renter';
	        }).forEach(function (c) {
	          c.contact.phone.filter(function (phone) {
	            return ["mobile", "cell"].includes(phone.type.toLowerCase());
	          }).forEach(function (p) {
	            var o = {
	              firstName: c.contact.firstName,
	              lastName: c.contact.lastName,
	              middleName: c.contact.middleName,
	              company: c.contact.company,
	              community: ppty.community,
	              lotNo: ppty.lotNo,
	              buildingNo: ppty.buildingNo
	            };
	
	            o.type = {
	              user: c.type,
	              phone: p.isPrimary ? "primary-phone" : "other-phone"
	            };
	
	            o.address = ppty.address && ppty.address.street ? ppty.address.street : "-";
	            o.phone = p.number;
	
	            _this.availableNumbers.push(o);
	          });
	        });
	      });
	
	      _this.applyFilter();
	
	      _this.dataInitComplete = true;
	    });
	  }
	
	  _createClass(textMessageFilterSendComponent, [{
	    key: 'resetCommunityFilter',
	    value: function resetCommunityFilter() {
	      this.community = undefined;
	      this.applyFilter();
	    }
	  }, {
	    key: 'applyFilter',
	    value: function applyFilter() {
	      var _this2 = this;
	
	      this.filteredAvailableNumbers = this.availableNumbers;
	
	      if (this.community) {
	        this.filteredAvailableNumbers = this.filteredAvailableNumbers.filter(function (o) {
	          return o.community == _this2.community;
	        });
	      }
	
	      if (!this.filterPrimaryOwner) {
	        this.filteredAvailableNumbers = this.filteredAvailableNumbers.filter(function (o) {
	          return o.type.user != 'primary-owner';
	        });
	      }
	
	      if (!this.filterOwner) {
	        this.filteredAvailableNumbers = this.filteredAvailableNumbers.filter(function (o) {
	          return o.type.user != 'owner';
	        });
	      }
	
	      if (!this.filterTenant) {
	        this.filteredAvailableNumbers = this.filteredAvailableNumbers.filter(function (o) {
	          return o.type.user != 'renter';
	        });
	      }
	    }
	  }, {
	    key: 'selectNumber',
	    value: function selectNumber(number) {
	      this.selectedNumbers.push(number);
	      this.availableNumbers.forEach(function (o) {
	        if (o.phone == number) o.selected = true;
	      });
	      this.filteredAvailableNumbers.forEach(function (o) {
	        if (o.phone == number) o.selected = true;
	      });
	    }
	  }, {
	    key: 'selectAllAvailable',
	    value: function selectAllAvailable() {
	      var _this3 = this;
	
	      this.filteredAvailableNumbers.forEach(function (o) {
	        o.selected = true;
	        if (!_this3.selectedNumbers.includes(o.phone)) _this3.selectedNumbers.push(o.phone);
	      });
	    }
	  }, {
	    key: 'removeNumber',
	    value: function removeNumber(number) {
	      this.selectedNumbers = this.selectedNumbers.filter(function (p) {
	        return p != number;
	      });
	      this.availableNumbers.forEach(function (o) {
	        if (o.phone == number) o.selected = false;
	      });
	      this.filteredAvailableNumbers.forEach(function (o) {
	        if (o.phone == number) o.selected = false;
	      });
	    }
	  }, {
	    key: 'addIndividualNumber',
	    value: function addIndividualNumber() {
	
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'phoneNumberEditModal',
	        size: 'sm'
	      });
	
	      modalInstance.result.then(function (number) {
	        that.selectNumber(number);
	      }, function () {});
	    }
	  }, {
	    key: 'getComposedName',
	    value: function getComposedName(contact) {
	      var composedName = "";
	
	      if (contact.lastName && contact.firstName) {
	        composedName = contact.lastName + ", " + contact.firstName;
	        if (contact.middleName) composedName += " " + contact.middleName;
	      }
	
	      if (contact.company) {
	        if (composedName == "") composedName += contact.company;else composedName += " (" + contact.company + ")";
	      }
	
	      return composedName || "-";
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this4 = this;
	
	      var textMessage = this.config.textMessage;
	
	      textMessage.recipients = this.selectedNumbers.map(function (number) {
	        return "+1" + number;
	      });
	
	      this.TextMessagesService.send({ id: textMessage._id }, textMessage, function (res) {
	        _this4.close({ $value: { testMessageId: textMessage._id } });
	      }, function (err) {
	        console.log("Could not send text message");
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return textMessageFilterSendComponent;
	}();
	
	exports.default = angular.module('conduu.textMessageFilterSendComponent', []).component('textMessageFilterSendComponent', {
	  template: __webpack_require__(858),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: textMessageFilterSendComponent
	}).name;

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">Send Text Message</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n\n  <div class=\"row\">\n    <div class=\"col-xs-4\">\n      <!-- Community -->\n      <div class=\"form-group\">\n        <label>Community</label>\n        <br/>\n        <div class=\"input-group\" style=\"display: inline-block\">\n          <select class=\"form-control\" ng-options=\"o.value as o.name for o in $ctrl.communities\" ng-model=\"$ctrl.community\"\n                  style=\"display: inline-block; width: auto\" ng-change=\"$ctrl.applyFilter()\"></select>\n          <span class=\"input-group-btn\">\n            <a class=\"btn btn-danger\" ng-disabled=\"!$ctrl.community\" ng-click=\"$ctrl.resetCommunityFilter()\"><i class=\"fa fa-fw fa-times\"></i></a>\n          </span>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-4\">\n      <div class=\"form-group\">\n        <label>Filter</label>\n        <div style=\"position:relative; top: 6px\">\n          <label><input style=\"position: relative; top: 1px\" type=\"checkbox\" ng-click=\"$ctrl.applyFilter()\" ng-model=\"$ctrl.filterPrimaryOwner\" /> Primary Owner</label> &nbsp;|&nbsp;\n          <label><input style=\"position: relative; top: 1px\" type=\"checkbox\" ng-click=\"$ctrl.applyFilter()\" ng-model=\"$ctrl.filterOwner\" /> Owner</label> &nbsp;|&nbsp;\n          <label><input style=\"position: relative; top: 1px\" type=\"checkbox\" ng-click=\"$ctrl.applyFilter()\" ng-model=\"$ctrl.filterTenant\" /> Tenant</label>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-4\">\n      <!-- Future addition: Presets (load / store / delete) -->\n    </div>\n  </div>\n\n  <hr/>\n\n  <div class=\"row\">\n\n    <div class=\"col-xs-8\">\n      <h4 style=\"margin-top: 0\" class=\"separator\"><span>Available Cell Phones</span><span style=\"float: right; padding-left: 8px\"><small><a href=\"#\" ng-click=\"$ctrl.selectAllAvailable()\">Select All <i class=\"fa fa-fw fa-angle-double-right\"></i></a></small></span></h4>\n      <table datatable=\"ng\" ng-if=\"$ctrl.dataInitComplete\" dt-options=\"$ctrl.dtOptions\" class=\"table table-hover table-condensed\" style=\"width:100%\">\n        <thead>\n          <tr>\n            <th>Name</th>\n            <th>Address</th>\n            <th>Unit</th>\n            <th>Type</th>\n            <th>Cell Phone</th>\n            <th></th>\n          </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"o in $ctrl.filteredAvailableNumbers\" ng-class=\"{'text-muted':o.selected}\">\n          <td>{{$ctrl.getComposedName(o)}}</td>\n          <td>{{o.address}}</td>\n          <td>{{o.lotNo}}</td>\n          <td>\n            <nobr>\n              <span ng-if=\"o.type.user == 'primary-owner' && o.type.phone == 'primary-phone'\" title=\"Primary Owner (Primary Phone)\" class=\"label label-primary\">PO <i class=\"fa fa-fw fa-tablet\"></i></span>\n              <span ng-if=\"o.type.user == 'primary-owner' && o.type.phone == 'other-phone'\" title=\"Primary Owner (Other Phone)\" class=\"label label-primary\">PO <i class=\"fa fa-fw fa-mobile-phone\"></i></span>\n              <span ng-if=\"o.type.user == 'owner' && o.type.phone == 'primary-phone'\" title=\"Other Owner (Primary Phone)\" class=\"label label-info\">O <i class=\"fa fa-fw fa-tablet\"></i></span>\n              <span ng-if=\"o.type.user == 'owner' && o.type.phone == 'other-phone'\" title=\"Other Owner (Other Phone)\" class=\"label label-info\">O <i class=\"fa fa-fw fa-mobile-phone\"></i></span>\n              <span ng-if=\"o.type.user == 'renter' && o.type.phone == 'primary-phone'\" title=\"Tenant (Primary Phone)\" class=\"label label-warning\">T <i class=\"fa fa-fw fa-tablet\"></i></span>\n              <span ng-if=\"o.type.user == 'renter' && o.type.phone == 'other-phone'\" title=\"Tenant (Other Phone)\" class=\"label label-warning\">T <i class=\"fa fa-fw fa-mobile-phone\"></i></span>\n            </nobr>\n          </td>\n          <td>{{o.phone | usPhone}}</td>\n          <td><button class=\"btn btn-sm btn-primary\" ng-disabled=\"o.selected\" type=\"button\" ng-click=\"$ctrl.selectNumber(o.phone)\"><i class=\"fa fa-fw fa-arrow-right\"></i></button></td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n    <div class=\"col-xs-4\">\n      <h4 style=\"margin-top: 0\" class=\"separator\"><span>Selected Cell Phones</span><span style=\"float: right; padding-left: 8px\"><small><a href=\"#\" ng-click=\"$ctrl.addIndividualNumber()\">Add Phone Number <i class=\"fa fa-fw fa-plus\"></i></a></small></span></h4>\n      <table datatable=\"ng\" ng-if=\"$ctrl.dataInitComplete\" dt-options=\"$ctrl.dtOptions\" class=\"table table-hover table-condensed\" style=\"width:100%\">\n        <thead>\n        <tr>\n          <th>Cell Phone</th>\n          <th></th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"number in $ctrl.selectedNumbers\">\n          <td>{{number | usPhone}}</td>\n          <td class=\"text-right\">\n            <button class=\"btn btn-sm btn-warning\" ng-click=\"$ctrl.removeNumber(number)\"><i class=\"fa fa-fw fa-trash\"></i></button>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n  </div>\n\n\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!$ctrl.selectedNumbers || !$ctrl.selectedNumbers.length\" ng-click=\"$ctrl.ok()\">Send</button>\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n</div>\n"

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var phoneNumberEditModalComponent = exports.phoneNumberEditModalComponent = function () {
	  /*@ngInject*/
	  phoneNumberEditModalComponent.$inject = ['Auth', '$state', 'dialogs', '$filter', '$stateParams', '$uibModal', '$scope'];
	  function phoneNumberEditModalComponent(Auth, $state, dialogs, $filter, $stateParams, $uibModal, $scope) {
	    _classCallCheck(this, phoneNumberEditModalComponent);
	
	    this.dialogs = dialogs;
	    this.$state = $state;
	    this.$scope = $scope;
	
	    this.phone = "";
	  }
	
	  _createClass(phoneNumberEditModalComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.config = this.resolve.config;
	
	      if (this.config && this.config.phone) {
	        this.phone = angular.copy(this.config.phone);
	      }
	    }
	  }, {
	    key: 'ok',
	    value: function ok(model) {
	      this.close({ $value: this.phone });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return phoneNumberEditModalComponent;
	}();
	
	exports.default = angular.module('conduu.phoneNumberEditModal', []).component('phoneNumberEditModal', {
	  template: __webpack_require__(860),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: phoneNumberEditModalComponent
	}).name;

/***/ }),
/* 860 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">Phone Number</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n\n  <input class=\"form-control\" type=\"text\" ui-mask=\"(?9?9?9) ?9?9?9-?9?9?9?9\" ng-model=\"$ctrl.phone\" />\n\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\" ng-disabled=\"$ctrl.phone.length != 10\"><i class=\"fa fa-fw fa-check\"></i> OK</button>\n  <button class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\"><i class=\"fa fa-fw fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var EmailSectionEditComponent = exports.EmailSectionEditComponent = function () {
	  /*@ngInject*/
	  EmailSectionEditComponent.$inject = ['SettingsService'];
	  function EmailSectionEditComponent(SettingsService) {
	    _classCallCheck(this, EmailSectionEditComponent);
	
	    this.$onInit = function () {
	      var _this = this;
	
	      this.config = this.resolve.config;
	
	      if (this.config.hasOwnProperty("data")) {
	        this.emails = this.config.data ? angular.copy(this.config.data) : [];
	      }
	
	      this.SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	        _this.mailTypes = appSettings.data.mailTypes;
	
	        if (!_this.emails || !_this.emails.length) _this.addEmail();
	      });
	    };
	
	    this.emails = [];
	    this.SettingsService = SettingsService;
	  }
	
	  _createClass(EmailSectionEditComponent, [{
	    key: 'updatePrimaryEmail',
	    value: function updatePrimaryEmail(idx) {
	      angular.forEach(this.emails, function (email, index) {
	        email.isPrimary = idx == index;
	      });
	    }
	  }, {
	    key: 'addEmail',
	    value: function addEmail() {
	      this.emails.push({
	        type: this.mailTypes[0] || '-',
	        address: '',
	        isPrimary: !this.emails.length
	      });
	    }
	  }, {
	    key: 'removeEmail',
	    value: function removeEmail(idx) {
	      var primaryRemoved = this.emails[idx].isPrimary;
	
	      this.emails.splice(idx, 1);
	
	      if (primaryRemoved && this.emails.length > 0) {
	        this.emails[0].isPrimary = true;
	      }
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.emails });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return EmailSectionEditComponent;
	}();
	
	exports.default = angular.module('conduu.emailSectionEdit', []).component('emailSectionEdit', {
	  template: __webpack_require__(862),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: EmailSectionEditComponent
	}).name;

/***/ }),
/* 862 */
/***/ (function(module, exports) {

	module.exports = "\n  <div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">Emails</h3>\n  </div>\n  <div class=\"modal-body\" id=\"modal-body\">\n\n    <!-- Email -->\n    <div class=\"form-group\">\n      <table ng-show=\"$ctrl.emails.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\n        <thead>\n        <tr>\n          <th>Type</th>\n          <th>Email</th>\n          <th>Is Primary?</th>\n          <th>Is Private?</th>\n          <th></th>\n          <th></th>\n        </tr>\n        </thead>\n        <tbody ui-sortable ng-model=\"$ctrl.emails\">\n        <tr ng-repeat=\"email in $ctrl.emails\" style=\"cursor: move;\">\n          <td>\n            <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.mailTypes\" ng-model=\"email.type\"></select>\n          </td>\n          <td>\n            <input class=\"form-control\" type=\"text\" ng-model=\"email.address\" />\n          </td>\n          <td>\n            <input class=\"form-control\" type=\"checkbox\" ng-model=\"email.isPrimary\" ng-click=\"$ctrl.updatePrimaryEmail($index)\" />\n          </td>\n          <td>\n            <input class=\"form-control\" type=\"checkbox\" ng-model=\"email.isPrivate\" />\n          </td>\n          <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"$ctrl.removeEmail($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\n          <td style=\"cursor: move; width:16px\">\n            <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n\n      <button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.addEmail()\"><i class=\"fa fa fa-plus\"></i> Add Email</button>\n    </div>\n\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" type=\"submit\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\n    <a class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\">Cancel</a>\n  </div>\n"

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var PhoneSectionEditComponent = exports.PhoneSectionEditComponent = function () {
	  /*@ngInject*/
	  PhoneSectionEditComponent.$inject = ['SettingsService'];
	  function PhoneSectionEditComponent(SettingsService) {
	    _classCallCheck(this, PhoneSectionEditComponent);
	
	    this.$onInit = function () {
	      var _this = this;
	
	      this.config = this.resolve.config;
	
	      if (this.config.hasOwnProperty("data")) {
	        this.phones = this.config.data ? angular.copy(this.config.data) : [];
	      }
	
	      this.SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	        _this.phoneTypes = appSettings.data.phoneTypes;
	
	        if (!_this.phones || !_this.phones.length) _this.addPhone();
	      });
	    };
	
	    this.phones = [];
	    this.SettingsService = SettingsService;
	  }
	
	  _createClass(PhoneSectionEditComponent, [{
	    key: 'updatePrimaryPhone',
	    value: function updatePrimaryPhone(idx) {
	      angular.forEach(this.phones, function (phone, index) {
	        phone.isPrimary = idx == index;
	      });
	    }
	  }, {
	    key: 'addPhone',
	    value: function addPhone() {
	      this.phones.push({
	        type: this.phoneTypes[0],
	        number: '',
	        isPrimary: !this.phones.length
	      });
	    }
	  }, {
	    key: 'removePhone',
	    value: function removePhone(idx) {
	      var primaryRemoved = this.phones[idx].isPrimary;
	
	      this.phones.splice(idx, 1);
	
	      if (primaryRemoved && this.phones.length > 0) {
	        this.phones[0].isPrimary = true;
	      }
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.phones });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return PhoneSectionEditComponent;
	}();
	
	exports.default = angular.module('conduu.phoneSectionEdit', []).component('phoneSectionEdit', {
	  template: __webpack_require__(864),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: PhoneSectionEditComponent
	}).name;

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	module.exports = "\n  <div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">Phones</h3>\n  </div>\n  <div class=\"modal-body\" id=\"modal-body\">\n\n    <div class=\"form-group\">\n      <table ng-show=\"$ctrl.phones.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\n        <thead>\n        <tr>\n          <th>Type</th>\n          <th>Number</th>\n          <th>Is Primary?</th>\n          <th>Is Private?</th>\n          <th></th>\n          <th></th>\n        </tr>\n        </thead>\n        <tbody ui-sortable ng-model=\"$ctrl.phones\">\n        <tr ng-repeat=\"phone in $ctrl.phones\" style=\"cursor: move;\">\n          <td>\n            <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.phoneTypes\" ng-model=\"phone.type\"></select>\n          </td>\n          <td>\n            <input class=\"form-control\" type=\"text\" ui-mask=\"(?9?9?9) ?9?9?9-?9?9?9?9\" ng-model=\"phone.number\" />\n          </td>\n          <td>\n            <input class=\"form-control\" type=\"checkbox\" ng-model=\"phone.isPrimary\" ng-click=\"$ctrl.updatePrimaryPhone($index)\" />\n          </td>\n          <td>\n            <input class=\"form-control\" type=\"checkbox\" ng-model=\"phone.isPrivate\" />\n          </td>\n          <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"$ctrl.removePhone($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\n          <td style=\"cursor: move; width:16px\">\n            <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n\n      <button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.addPhone()\"><i class=\"fa fa fa-plus\"></i> Add Phone</button>\n    </div>\n\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" type=\"submit\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\n    <a class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\">Cancel</a>\n  </div>\n"

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var AddressSectionEditComponent = exports.AddressSectionEditComponent = function () {
	  /*@ngInject*/
	  AddressSectionEditComponent.$inject = ['SettingsService', '$uibModal'];
	  function AddressSectionEditComponent(SettingsService, $uibModal) {
	    _classCallCheck(this, AddressSectionEditComponent);
	
	    this.$onInit = function () {
	      var _this = this;
	
	      this.config = this.resolve.config;
	
	      if (this.config.hasOwnProperty("data")) {
	        this.addresses = this.config.data ? angular.copy(this.config.data) : [];
	      }
	
	      this.SettingsService.getByName({ name: 'config.app' }, function (appSettings) {
	        _this.addressTypes = appSettings.data.addressTypes;
	
	        if (!_this.addresses || !_this.addresses.length) _this.addAddress();
	      });
	    };
	
	    this.addresses = [];
	    this.SettingsService = SettingsService;
	    this.$uibModal = $uibModal;
	  }
	
	  _createClass(AddressSectionEditComponent, [{
	    key: 'addressEdit',
	    value: function addressEdit(idx, address) {
	      var that = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        component: 'addressEdit',
	        resolve: {
	          config: function config() {
	            return {
	              data: address
	            };
	          }
	        },
	        size: 'md'
	      });
	
	      modalInstance.result.then(function (address) {
	
	        that.addresses[idx] = address;
	      }, function () {});
	    }
	  }, {
	    key: 'updatePrimaryAddress',
	    value: function updatePrimaryAddress(idx) {
	      angular.forEach(this.addresses, function (address, index) {
	        address.isPrimary = idx == index;
	      });
	    }
	  }, {
	    key: 'updateMailingAddress',
	    value: function updateMailingAddress(idx) {
	      if (this.addresses[idx].isMailing) {
	        angular.forEach(this.addresses, function (address, index) {
	          address.isMailing = idx == index;
	        });
	      } else {
	        this.addresses[idx].isMailing = false;
	      }
	    }
	  }, {
	    key: 'addAddress',
	    value: function addAddress() {
	      var idx = this.addresses.length;
	      this.addressEdit(idx, {
	        type: this.addressTypes[0],
	        state: 'FL',
	        isPrimary: !idx
	      });
	    }
	  }, {
	    key: 'removeAddress',
	    value: function removeAddress(idx) {
	      var primaryRemoved = this.addresses[idx].isPrimary;
	
	      this.addresses.splice(idx, 1);
	
	      if (primaryRemoved && this.addresses.length > 0) {
	        this.addresses[0].isPrimary = true;
	      }
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.close({ $value: this.addresses });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return AddressSectionEditComponent;
	}();
	
	exports.default = angular.module('conduu.addressSectionEdit', []).component('addressSectionEdit', {
	  template: __webpack_require__(866),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: AddressSectionEditComponent
	}).name;

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	module.exports = "\n  <div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">Addresses</h3>\n  </div>\n  <div class=\"modal-body\" id=\"modal-body\">\n\n    <!-- Address -->\n    <div class=\"form-group\">\n      <table ng-show=\"$ctrl.addresses.length > 0\" style=\"width:100%;\" class=\"table table-condensed borderless\">\n        <thead>\n        <tr>\n          <th>Type</th>\n          <th>Address</th>\n          <th>Is Primary?</th>\n          <th>Is Mailing?</th>\n          <th>Is Private?</th>\n          <th></th>\n          <th></th>\n        </tr>\n        </thead>\n        <tbody ui-sortable ng-model=\"$ctrl.addresses\">\n        <tr ng-repeat=\"address in $ctrl.addresses\" style=\"cursor: move;\">\n          <td>\n            <select class=\"form-control\" ng-options=\"o as o for o in $ctrl.addressTypes\" ng-model=\"address.type\"></select>\n          </td>\n          <td>\n            <a href=\"#\" ng-click=\"$ctrl.addressEdit($index,address)\">\n              {{address.street}}<br/>{{address.city}}, {{address.state}} {{address.zip}}\n            </a>\n          </td>\n          <td>\n            <input class=\"form-control\" type=\"checkbox\" ng-model=\"address.isPrimary\" ng-click=\"$ctrl.updatePrimaryAddress($index)\" />\n          </td>\n          <td>\n            <input class=\"form-control\" type=\"checkbox\" ng-model=\"address.isMailing\" ng-click=\"$ctrl.updateMailingAddress($index)\" />\n          </td>\n          <td>\n            <input class=\"form-control\" type=\"checkbox\" ng-model=\"address.isPrivate\" />\n          </td>\n          <td style=\"text-align: right\"><a href=\"#\" class=\"text-danger\" ng-click=\"$ctrl.removeAddress($index)\"><i class=\"fa fa-2x fa-trash\"></i></a></td>\n          <td style=\"cursor: move; width:16px\">\n            <i style=\"color:#ddd\" class=\"fa fa-fw fa-2x fa-arrows\"></i>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n\n      <button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.addAddress()\"><i class=\"fa fa fa-plus\"></i> Add Address</button>\n    </div>\n\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" type=\"submit\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\n    <a class=\"btn btn-warning\" ng-click=\"$ctrl.cancel()\">Cancel</a>\n  </div>\n"

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(14);
	
	var AttachmentPickerComponent = exports.AttachmentPickerComponent = function () {
	  /*@ngInject*/
	  function AttachmentPickerComponent() {
	    _classCallCheck(this, AttachmentPickerComponent);
	
	    this.selected = {};
	  }
	
	  _createClass(AttachmentPickerComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.config = this.resolve.config;
	      this.attachments = this.config.attachments;
	      this.title = this.config.title || 'Attachment Select';
	
	      if (this.config.selectedIds && Array.isArray(this.config.selectedIds)) {
	        this.config.selectedIds.forEach(function (id) {
	          _this.selected[id] = true;
	        });
	      }
	    }
	  }, {
	    key: 'isImageMime',
	    value: function isImageMime(mime) {
	      return mime.startsWith('image/');
	    }
	  }, {
	    key: 'isPdfMime',
	    value: function isPdfMime(mime) {
	      return mime === 'application/pdf';
	    }
	  }, {
	    key: 'isWordMime',
	    value: function isWordMime(mime) {
	      return mime == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || mime == 'application/msword';
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this2 = this;
	
	      var selectedData = this.attachments.filter(function (att) {
	        return _this2.selected[att._id];
	      });
	      this.close({ $value: selectedData });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.dismiss({ $value: 'cancel' });
	    }
	  }]);
	
	  return AttachmentPickerComponent;
	}();
	
	exports.default = angular.module('conduu.attachmentPicker', []).component('attachmentPicker', {
	  template: __webpack_require__(868),
	  bindings: {
	    resolve: '<',
	    config: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  controller: AttachmentPickerComponent
	}).name;

/***/ }),
/* 868 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">{{$ctrl.title}}</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <table datatable=\"ng\" class=\"table table-striped\" style=\"width:100%\">\n    <thead>\n    <tr>\n      <th></th>\n      <th></th>\n      <th>Name</th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"attachment in $ctrl.attachments\">\n      <td><input type=\"checkbox\" ng-model=\"$ctrl.selected[attachment._id]\"></td>\n      <td>\n        <p style=\"margin: 0px\">\n          <i ng-if=\"$ctrl.isImageMime(attachment.contentType)\" class=\"fa fa-fw fa-file-image-o\"></i>\n          <i ng-if=\"$ctrl.isPdfMime(attachment.contentType)\" class=\"fa fa-fw fa-file-pdf-o\"></i>\n          <i ng-if=\"$ctrl.isWordMime(attachment.contentType)\" class=\"fa fa-fw fa-file-word-o\"></i>\n        </p>\n      </td>\n      <td>{{attachment.filename}}</td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n</div>\n"

/***/ }),
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    return exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (typeof process !== 'undefined' && 'env' in process) {
	    return ({"NODE_ENV":"production"}).DEBUG;
	  }
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(202)))

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug.debug = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting
	    args = exports.formatArgs.apply(self, args);
	
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ })
]);


// WEBPACK FOOTER //
// app.65b8a6b27b79bb533d3b.js